var slimeSplat;

var game;
var slimeSplat = (json) => {
    (function (letterBubble) {
        class App extends Phaser.Game {
            constructor(json) {
                App.json = json
                let config = {
                    type: Phaser.AUTO,
                    width: App.CANVAS_WIDTH,
                    height: App.CANVAS_HEIGHT,
                    parent: 'game-container',
                    dom: {
                        createContainer: false
                    },
                    scale: {
                        mode: FitScaleManager.detectBestScaleMode(),
                        autoCenter: Phaser.Scale.CENTER_BOTH
                    },
                    transparent: true,
                    scene: {
                        create: () => {
                            this.scene.add('Boot', letterBubble.scene.Boot, true);
                        }
                    }
                };
                super(config);
            }
        }

        App.CANVAS_WIDTH = 980;
        App.CANVAS_HEIGHT = 600;
        letterBubble.App = App;
    })(letterBubble || (letterBubble = {}));

    function pad(n, width, z) {
        z = z || '0';
        n = n + '';
        return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
    }

    var delayedCalls = [];

    function delayedCall(delay, callback, args, callbackScope) {
        let scene = game.scene.getAt(0);
        if (scene) {
            let dc = scene.time.delayedCall(delay, callback, args, callbackScope);
            delayedCalls.push(dc);
            return dc;
        }
        let t = setTimeout(callback, delay);
        delayedCalls.push(t);
        return t;
    }

    function pauseAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.paused = true;
            }
        }
    }

    function resumeAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.paused = false;
            }
        }
    }

    function destroyAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.remove(false);
            } else {
                clearTimeout(dc);
            }
        }
        delayedCalls = [];
    }

    function destroyDelayedCall(dc) {
        if (dc instanceof Phaser.Time.TimerEvent) {
            dc.remove(false);
        } else {
            clearTimeout(dc);
        }
        let ind = delayedCalls.indexOf(dc);
        if (ind >= 0)
            delayedCalls.splice(ind, 1);
    }

    function setPageBackground(bg) {
        document.querySelector("html").style.backgroundImage = "url(assets/games/slime-splat/imgs/" + bg + ".jpg)";
    }

    function setupButton(btn, frame) {
        btn.on('pointerdown', () => {
            btn.setFrame(frame + '_hover' + '0000');
        });
        btn.on('pointerover', () => {
            btn.setFrame(frame + '_hover' + '0000');
            game.scene.getAt(0).sound.add("button hover").play();
        });
        btn.on('pointerout', () => {
            btn.setFrame(frame + '0000');
        });
        btn.on('pointerup', () => {
            btn.setFrame(frame + '0000');
            game.scene.getAt(0).sound.add('activity selection - button selection').play();
        });
    }

    function setupButtonTextureBased(btn, texture, hoverTexture) {
        btn.on('pointerdown', () => {
            btn.setTexture(hoverTexture);
        });
        btn.on('pointerover', () => {
            btn.setTexture(hoverTexture);
            game.scene.getAt(0).sound.add("button hover").play();
        });
        btn.on('pointerout', () => {
            btn.setTexture(texture);
        });
        btn.on('pointerup', () => {
            btn.setTexture(texture);
            game.scene.getAt(0).sound.add('activity selection - button selection').play();
        });
    }

    function playBtnClickAnim(target) {
        let sc = target.hasOwnProperty("defScale") ? target["defScale"] : 1;
        target.scaleX = target.scaleY = sc;
        let scene = game.scene.getAt(0);
        scene.tweens.add({
            targets: target,
            "scaleX": 0.9 * sc,
            "scaleY": 0.9 * sc,
            duration: 100,
            yoyo: true
        });
    }

    /**
     * @author Roman Parada
     * This class is created to fix overlapping of bottom part of canvas by navigation bar in iOS.
     * It make a delayed resize of the canvas (like Phaser-3 FIT methods does) and it overrides Phaser-3 input window to Phaser-3 core transform methods
     *
     * How to use:
     * Just call the code line below in Boot scene's init() method of your project:
     * new FitScaleManager(this.game).setup();
     */
    class FitScaleManager {
        constructor(game) {
            this.doResize = () => {
                let scale = this.calculateScale();
                let newCanvasWidth = this.phaserScaleManager.width * scale;
                let newCanvasHeight = this.phaserScaleManager.height * scale;
                this.canvasStyle.width = newCanvasWidth + 'px';
                this.canvasStyle.height = newCanvasHeight + 'px';
                this.canvasStyle.marginLeft = (window.innerWidth - newCanvasWidth) / 2 + 'px';
                this.canvasStyle.marginTop = (window.innerHeight - newCanvasHeight) / 2 + 'px';
            };
            this.game = game;
            this.canvasStyle = this.game.canvas.style;
            this.phaserScaleManager = this.game.scale;
        }

        static detectBestScaleMode() {
            let iOS = /iPad|iPhone|iPod/.test(navigator.platform || "");
            let isAndroid = window.navigator.userAgent.toLowerCase().indexOf("android") > -1;
            return iOS || isAndroid ? Phaser.Scale.FIT : Phaser.Scale.NONE;
        }
        ;

        /**
         * Just call this method once in Boot scene's init() method
         */
        setup() {
            this.phaserScaleManager.addListener(Phaser.Scale.Events.RESIZE, this.onResize, this);
            this.overridePhaserTransformMethods();
            this.onResize();
        }

        calculateScale() {
            if (game.scale.scaleMode == Phaser.Scale.NONE)
                return 1;
            return Math.min(window.innerWidth / this.phaserScaleManager.width, window.innerHeight / this.phaserScaleManager.height);
        }

        overridePhaserTransformMethods() {
            this.game.scale.transformX = (pageX) => {
                return (pageX - parseInt(this.canvasStyle.marginLeft.split("px")[0])) / this.calculateScale();
            };
            this.game.scale.transformY = (pageY) => {
                return (pageY - parseInt(this.canvasStyle.marginTop.split("px")[0])) / this.calculateScale();
            };
        }

        onResize() {
            setTimeout(this.doResize, FitScaleManager.RESIZE_DELAY);
        }
    }

    FitScaleManager.RESIZE_DELAY = 500;

    (function (letterBubble) {
        var core;
        (function (core) {
            class Gameplay {
                constructor() {
                    this.allLettersNames = null;
                    this.currentRound = 0;
                    this.correctAnswersCount = 0;
                    this.wrongAnswersCount = 0;
                    this.correctAnswersCountThisRound = 0;
                    this.wrongAnswersCountThisRound = 0;
                    this.onNewRound = null;
                    this.nextLetterDelay = 0;
                    this.roundsVaryFrom = Number(game.cache.json.get('gameplay')["roundsVaryFrom"]);
                    this.roundsVaryTo = Number(game.cache.json.get('gameplay')["roundsVaryTo"]);
                    this.useImages = Boolean(game.cache.json.get('gameplay')["useImages"]);
                    this.wordsLetters = game.cache.json.get('gameplay')["wordsLetters"];
                    this.failsNumToLose = Number(game.cache.json.get('gameplay')["failsNumToLose"]) || 4;
                }
                getRoundWordCharAt(at) {
                    return this.wordsLetters[this.roundWord][at];
                }

                getRoundWordLettersNumber() {
                    return this.wordsLetters[this.roundWord].length;
                }

                setupCallbacks(onComplete, onLose, onNewRound) {
                    this.onComplete = onComplete;
                    this.onLose = onLose;
                    this.onNewRound = onNewRound;
                }

                calculateScore() {
                    return this.totalRoundsNum - this.wrongAnswersCount;//return this.totalRoundsNum; //3 * this.totalRoundsNum - this.wrongAnswersCount;
                }

                onLetterChosen() {
                    if (this.currentRound >= this.totalRoundsNum - 1) {
                        let score = this.calculateScore();
                        this.onComplete(score, score);
                        return true;
                    }
                    else {
                        if (this.isNewRound()) this.nextWord();
                    }
                    return false;

                    /* if (this.isNewRound()) {
                        this.nextWord();
                    }
                    console.log(this.currentRound , this.totalRoundsNum)
                    return this.currentRound >= this.totalRoundsNum; */
                }

                nextWord() {
                    let fn = () => {
                        this.currentRound++;
                        let round = this.rounds[this.currentRound];
                        this.roundWord = round["correctWord"];
                        this.roundWords = Phaser.Utils.Array.Shuffle([this.roundWord, round["wrongWord1"], round["wrongWord2"]]);
                        this.correctAnswersCountThisRound = 0;
                        this.wrongAnswersCountThisRound = 0;
                        if (this.onNewRound)
                            this.onNewRound();
                    };
                    if (this.nextLetterDelay == 0) {
                        fn();
                    } else {
                        delayedCall(this.nextLetterDelay, fn);
                    }
                }

                onCorrectAnswer() {
                    this.correctAnswersCount++;
                    this.correctAnswersCountThisRound++;
                    this.nextLetterDelay = 4250;
                    return this.onLetterChosen();
                }

                onWrongAnswer() {
                    this.wrongAnswersCount++;
                    this.wrongAnswersCountThisRound++;
                    this.nextLetterDelay = 1500;
                    if (this.wrongAnswersCount >= this.failsNumToLose) {
                        this.onLose(0, 0);
                        return true;
                    }
                    else {
                        // this.onLetterChosen();
                    }
                    return false;
                }

                getMaxTotalAnswersCount() {
                    return this.failsNumToLose + this.totalRoundsNum - 1;
                }

                getCurrentTotalAnswersCount() {
                    return this.correctAnswersCount + this.wrongAnswersCount;
                }

                getCurrentTotalAnswersCountThisRound() {
                    return this.correctAnswersCountThisRound + this.wrongAnswersCountThisRound;
                }

                isNewRound() {
                    return this.correctAnswersCountThisRound == 1;
                }

                isRoundsComplete() {
                    return this.currentRound >= this.totalRoundsNum;
                }

                getAudioKeyOfChar(letter) {
                    let json = game.cache.json.get('gameplay');
                    let letters = json["letters"];
                    for (let d of letters) {
                        if (letter == d['letterName']) {
                            return d['audioKey'];
                        }
                    }
                    return null;
                }

                reset() {
                    this.currentRound = -1;
                    this.totalRoundsNum = Math.round(Math.random() * (this.roundsVaryTo - this.roundsVaryFrom)) + this.roundsVaryFrom;
                    this.nextLetterDelay = 0;
                    this.setupCallbacks(null, null, null);
                    let json = game.cache.json.get('gameplay');
                    this.letters = json["letters"].slice();
                    this.allLettersNames = [];
                    for (let d of this.letters)
                        this.allLettersNames.push(d["letterName"]);
                    this.rounds = JSON.parse(JSON.stringify(json["rounds"]));
                    // this.totalRoundsNum = this.rounds.length;
                    this.nextWord();
                    this.correctAnswersCount = 0;
                    this.wrongAnswersCount = 0;
                    this.correctAnswersCountThisRound = 0;
                    this.wrongAnswersCountThisRound = 0;
                }
            }

            core.Gameplay = Gameplay;
        })(core = letterBubble.core || (letterBubble.core = {}));
    })(letterBubble || (letterBubble = {}));

    (function (letterBubble) {
        var scene;
        (function (scene) {
            class Boot extends Phaser.Scene {
                init() {
                    // new FitScaleManager(this.game).setup();
                    this.game.scale.transformX = (pageX) => {
                        let offsetLeft = 0;
                        let parentElement = game.canvas.parentElement;
                        while (parentElement) {
                            if (parentElement.offsetLeft) {
                                offsetLeft = parentElement.offsetLeft;
                                break;
                            }
                            parentElement = parentElement.parentElement;
                        }
                        return (pageX - offsetLeft) * this.game.scale.displayScale.x;
                    };
                    this.game.scale.transformY = (pageY) => {
                        let offsetTop = 0;
                        let parentElement = game.canvas.parentElement;
                        while (parentElement) {
                            if (parentElement.offsetTop) {
                                offsetTop = parentElement.offsetTop;
                                break;
                            }
                            parentElement = parentElement.parentElement;
                        }
                        return (pageY - offsetTop) * this.game.scale.displayScale.y;
                    };
                }

                create() {
                    game.scene.remove('Boot');
                    game.scene.add('Preloader', letterBubble.scene.Preloader, true);
                }
            }

            scene.Boot = Boot;
        })(scene = letterBubble.scene || (letterBubble.scene = {}));
    })(letterBubble || (letterBubble = {}));

    (function (letterBubble) {
        var scene;
        (function (scene) {
            var Gameplay = letterBubble.core.Gameplay;

            class MainScene extends Phaser.Scene {
                create() {
                    this.gameplay = new Gameplay();
                    this.gameplayScreen = new letterBubble.screen.GameplayScreen(this, this.gameplay);
                    this.children.add(this.gameplayScreen);
                    this.gameplayScreen.showInstructionPage();
                }
            }

            scene.MainScene = MainScene;
        })(scene = letterBubble.scene || (letterBubble.scene = {}));
    })(letterBubble || (letterBubble = {}));

    (function (letterBubble) {
        var scene;
        (function (scene) {
            class Preloader extends Phaser.Scene {
                preload() {
                    if (typeof letterBubble.App.json == "string") this.load.json('gameplay', letterBubble.App.json); else this.game.cache.json.add('gameplay', letterBubble.App.json);
                }

                create() {
                    let json = game.cache.json.get('gameplay');
                    let words = json["words"];
                    if (json["useImages"]) {
                        let rounds = JSON.parse(JSON.stringify(json["rounds"]));
                        for (let i = 0; i < rounds.length; i++) {
                            let w = rounds[i];
                            this.load.image(w.correctWord, "assets/games/slime-splat/imgs/letters/" + w.correctWord + ".png");
                            this.load.image(w.wrongWord1, "assets/games/slime-splat/imgs/letters/" + w.wrongWord1 + ".png");
                            this.load.image(w.wrongWord2, "assets/games/slime-splat/imgs/letters/" + w.wrongWord2 + ".png");
                        }
                        for (let l of json.letters) {
                            this.load.image(l.letterName, "assets/games/slime-splat/imgs/letters/" + l.letterName + ".png");
                        }
                    }
                    for (let l of json.letters) {
                        this.load.audio(l.audioKey, "assets/games/slime-splat/sound/mp3/letters/" + l.audioKey + ".mp3");
                    }
                    for (let w of words) {
                        this.load.audio(w, "assets/games/slime-splat/sound/mp3/words/" + w + ".mp3");
                    }
                    this.load.audio("englQuestion", "assets/games/slime-splat/sound/mp3/englQuestion.mp3");
                    let progressTxt = this.add.text(game.scale.width / 2, game.scale.height / 2 + 50, "", {
                        "fontFamily": "QuranErafont",
                        "fontSize": 25,
                        "color": "#000000",
                        "align": 'center'
                    });
                    progressTxt.setOrigin(0.5, 0.5);
                    this.load.pack('preloader', 'assets/games/slime-splat/pack.json');
                    this.load.on('progress', (value) => {
                        progressTxt.text = Math.ceil(value * 100) + "%";
                    }, this);
                    this.load.on('complete', () => {
                        this.nextScene();
                    });
                    this.load.start();
                }

                static playAnim(animKey, sprite, onComplete = null) {
                    let mainScene = game.scene.getScene('ScreenMain');
                    let data = Preloader.ANIMS_DATA[animKey];
                    if (!mainScene.anims.exists(animKey)) {
                        mainScene.anims.create({
                            key: animKey,
                            frames: mainScene.anims.generateFrameNames(data['atlas'], {
                                start: data['start'], end: data['end'], zeroPad: data['padNum'],
                                prefix: data['prefix'], suffix: ''
                            }),
                            frameRate: data['frameRate'],
                            repeat: data['repeat']
                        });
                    }
                    if (sprite.anims.currentAnim) {
                        sprite.anims.currentAnim.off('complete');
                    }
                    sprite.anims.stop();
                    sprite.play(animKey);
                    sprite.anims.currentAnim.once('complete', () => {
                        if (onComplete)
                            onComplete();
                    });
                    sprite.setOrigin(data['originX'], data['originY']);
                    return sprite;
                }

                nextScene() {
                    game.scene.remove('Preloader');
                    game.scene.add('ScreenMain', letterBubble.scene.MainScene, true);
                }
            }

            Preloader.ANIMS_DATA = {
                'marger': {
                    'start': 0,
                    'end': 44,
                    'padNum': 2,
                    'prefix': 'Marger_1',
                    'repeat': 0,
                    'frameRate': 45,
                    'atlas': 'marger',
                    'originX': 0.5,
                    'originY': 0
                },
                'being-splat': {
                    'start': 0,
                    'end': 74,
                    'padNum': 2,
                    'prefix': 'Splash_1',
                    'repeat': 0,
                    'frameRate': 25,
                    'atlas': 'being-splat',
                    'originX': 0.5,
                    'originY': 0.5
                },
                'fall': {
                    'start': 0,
                    'end': 53,
                    'padNum': 2,
                    'prefix': 'Drop Slime _1',
                    'repeat': 0,
                    'frameRate': 40,
                    'atlas': 'fall',
                    'originX': 0.5,
                    'originY': 0.5
                },
                'fallRight': {
                    'start': 0,
                    'end': 36,
                    'padNum': 2,
                    'prefix': 'Drop Slime 3_1',
                    'repeat': 0,
                    'frameRate': 40,
                    'atlas': 'fallRight',
                    'originX': 0.5,
                    'originY': 0.5
                },
                'fallLeft': {
                    'start': 0,
                    'end': 36,
                    'padNum': 2,
                    'prefix': 'Drop Slime 2_1',
                    'repeat': 0,
                    'frameRate': 40,
                    'atlas': 'fallLeft',
                    'originX': 0.5,
                    'originY': 0.5
                }
            };
            scene.Preloader = Preloader;
        })(scene = letterBubble.scene || (letterBubble.scene = {}));
    })(letterBubble || (letterBubble = {}));

    (function (letterBubble) {
        var screen;
        (function (screen) {
            class AreYouSureWindow extends Phaser.GameObjects.Container {
                constructor(scene, onYes, onNo) {
                    super(scene);
                    this._areYouSurePage = new Phaser.GameObjects.Image(this.scene, -105, 0 - 48, 'Exit warning');
                    this._areYouSurePage.setOrigin(0, 0);
                    this._areYouSurePage.setInteractive();
                    this._btnSureYes = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2 - 95, 485 - 50, 'btnYES1');
                    this._btnSureYes.setInteractive({ cursor: 'pointer' });
                    this._btnSureYes.once('pointerup', () => {
                        onYes;
                        window.angularComponentRef.backToMenu();
                    });
                    var modalTextStyle = {
                        backgroundColor: 'transparent',
                        stroke: '#ffffff',
                        strokeThickness: 2,
                        lineSpacing: 15,
                        fontFamily: 'Kids Rock DEMO',
                        fontSize: 27,
                        color: '#43425d',
                        wordWrap: true,
                        align: 'center'
                    };
                    var modalText = this.scene.add.text(game.scale.width / 2 + 12, game.scale.height / 2, "Your progress in this activity will not be saved. \n Are you sure you want to exit? ", modalTextStyle);
                    modalText.setOrigin(0.5, 0.5);

                    setupButtonTextureBased(this._btnSureYes, 'btnYES1', 'btnYES2');
                    this._btnSureNo = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2 + 95, 485 - 50, 'btnNO1');
                    this._btnSureNo.setInteractive({ cursor: 'pointer' });
                    this._btnSureNo.once('pointerup', onNo);
                    setupButtonTextureBased(this._btnSureNo, 'btnNO1', 'btnNO2');
                    this.add(this._areYouSurePage);
                    this.add(this._btnSureYes);
                    this.add(this._btnSureNo);
                    this.add(modalText);
                }
            }

            screen.AreYouSureWindow = AreYouSureWindow;
        })(screen = letterBubble.screen || (letterBubble.screen = {}));
    })(letterBubble || (letterBubble = {}));

    (function (letterBubble) {
        var screen;
        (function (screen) {
            class CompleteWindow extends Phaser.GameObjects.Container {
                constructor(scene, onBack, onReplay, onNext) {
                    super(scene);
                    this.music = null;
                    this.setPosition(-104.5, -48);
                    this._bgComplete = new Phaser.GameObjects.Image(this.scene, 0, 0, 'Completion page LATEST UPDATED');
                    this._bgComplete.setOrigin(0, 0);
                    this._bgComplete.setInteractive();
                    this._cup = new Phaser.GameObjects.Image(this.scene, 400, 410, 'Trophy');
                    this._btnBack = new Phaser.GameObjects.Image(this.scene, 570, 570, 'btnBACK1');
                    this._btnReplay = new Phaser.GameObjects.Image(this.scene, 720, 570, 'btnReplay1');
                    this._btnNext = new Phaser.GameObjects.Image(this.scene, 870, 570, 'btnNEXT1');
                    let _CollectedPoints = new Phaser.GameObjects.Image(this.scene, 620, 440, 'Collected Points');
                    this.totalScoreTxt = this.scene.add.text(845, 352, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 35,
                        "color": "#F49F1C",
                        "align": 'center',
                        'stroke': '#70451A',
                        'strokeThickness': 6
                    });
                    this.totalScoreTxt.setOrigin(0.5, 0.5);
                    let grd = this.totalScoreTxt.context.createLinearGradient(0, 0, 0, this.totalScoreTxt.height);
                    grd.addColorStop(0, '#FFFF00');
                    grd.addColorStop(1, '#C17316');
                    this.totalScoreTxt.setFill(grd);
                    this.starScoreTxt = this.scene.add.text(648, 433, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 24,
                        "color": "#FFFFFF",
                        "align": 'center'
                    });
                    this.starScoreTxt.setOrigin(0.5, 0.5);
                    this.add([
                        this._bgComplete,
                        _CollectedPoints,
                        this._cup,
                        this._btnBack,
                        this._btnReplay,
                        this._btnNext,
                        this.totalScoreTxt,
                        this.starScoreTxt
                    ]);
                    this._btnBack.setInteractive({ cursor: 'pointer' });
                    this._btnBack.on('pointerup', () => {
                        onBack(this._btnBack);
                        window.angularComponentRef.backToMenu();
                        // if (this.music) {
                        //     this.music.stop();
                        // }
                    });
                    setupButtonTextureBased(this._btnBack, 'btnBACK1', 'btnBACK2');
                    this._btnReplay.setInteractive({ cursor: 'pointer' });
                    this._btnReplay.once('pointerup', () => {
                        onReplay(this._btnReplay);
                        if (this.music) {
                            this.music.stop();
                        }
                    });
                    setupButtonTextureBased(this._btnReplay, 'btnReplay1', 'btnReplay2');
                    this._btnNext.setInteractive({ cursor: 'pointer' });
                    this._btnNext.on('pointerup', () => {
                        onNext(this._btnNext);
                        window.angularComponentRef.nextActivity();
                        // if (this.music) {
                        //     this.music.stop();
                        // }
                    });
                    setupButtonTextureBased(this._btnNext, 'btnNEXT1', 'btnNEXT2');
                }

                show(score, starScore) {
                    window.angularComponentRef.gameFinish({ score, starScore })
                    this._cup.scale = 1.25;
                    this.scene.tweens.add({
                        targets: this._cup,
                        "scale": 1,
                        duration: 500,
                        ease: Phaser.Math.Easing.Back.Out
                    });
                    this.totalScoreTxt.text = String(window.angularComponentRef.component.userInfo.totalScore);
                    this.starScoreTxt.text = String(starScore);
                    // let music = this.scene.sound.add("viktory");
                    this.music = this.scene.sound.add("Activity completion fantastic");
                    this.music.play();
                }
            }

            screen.CompleteWindow = CompleteWindow;
        })(screen = letterBubble.screen || (letterBubble.screen = {}));
    })(letterBubble || (letterBubble = {}));

    (function (letterBubble) {
        var screen;
        (function (screen) {
            var Preloader = letterBubble.scene.Preloader;

            class GameplayScreen extends Phaser.GameObjects.Container {
                constructor(scene, gameplay) {
                    super(scene);
                    this.bgMusic = null;
                    this.wfsnd = null;
                    this.showCompleteWindow = (score, starScore) => {
                        let completeWindow = new screen.CompleteWindow(this.scene, (target) => {
                            playBtnClickAnim(target);
                        }, (target) => {
                            playBtnClickAnim(target);
                            this.destroyGameplay();
                            this.remove(completeWindow);
                            this.showInstructionPage();
                        }, (target) => {
                            playBtnClickAnim(target);
                        });
                        this.setInputEnabled(false);
                        delayedCall(6000, () => {
                            setPageBackground("bg-blue");
                            this.add(completeWindow);
                            completeWindow.show(score, starScore);
                            this.bgMusic.stop();
                        });
                    };
                    this.showLoseWindow = (score, starScore) => {
                        let tryAgainWindow = new screen.TryAgainWindow(this.scene, (target) => {
                            playBtnClickAnim(target);
                        }, (target) => {
                            playBtnClickAnim(target);
                            this.destroyGameplay();
                            this.remove(tryAgainWindow);
                            this.showInstructionPage();
                        });
                        this.setInputEnabled(false);
                        delayedCall(1300, () => {
                            setPageBackground("bg-blue");
                            this.add(tryAgainWindow);
                            tryAgainWindow.show(score, starScore);
                            this.bgMusic.stop();
                        });
                    };
                    this.gameplay = gameplay;
                    window["gs"] = this;
                    this._gameStage = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2, game.scale.height / 2, 'bg');
                    this._gameStage.setOrigin(0.5, 0.5);
                    this._gameStage.setInteractive();
                    this.add(this._gameStage);
                    this._btnSound = new Phaser.GameObjects.Image(this.scene, 160 - 105, 100 - 50, 'Sound');
                    this._btnSound.setInteractive({ cursor: 'pointer' });
                    setupButtonTextureBased(this._btnSound, 'Sound', 'Sound HOVER EFFECT');
                    this.add(this._btnSound);
                    this._btnSound.on('pointerup', () => {
                        playBtnClickAnim(this._btnSound);
                        this.playCorrectAudio(true);
                    });
                    this._btnSound.visible = false;

                    /* this.character = this.scene.add.sprite(0, 0, null);
                    window["this.character"] = this.character;
                    this.character.visible = false;
                    this.add(this.character); */

                    this._btnClose = new Phaser.GameObjects.Image(this.scene, 1025 - 105, 100 - 50, 'x Button');
                    this._btnClose.setInteractive({ cursor: 'pointer' });
                    this._btnClose["defScale"] = this._btnClose.scale;
                    setupButtonTextureBased(this._btnClose, 'x Button', 'x Button HOVER EFFECT');
                    this.add(this._btnClose);
                    this._btnClose.on('pointerup', () => {
                        playBtnClickAnim(this._btnClose);
                        this.onCloseClick();
                    });
                }

                playCorrectAudio(onlyEngPart, onlyArabicPart) {
                    if (this.correctAudio) {
                        this.correctAudio.stop();
                    }
                    if (!onlyArabicPart) {
                        this.correctAudio = this.scene.sound.add("englQuestion");
                        this.correctAudio.play();
                    }
                    if (!onlyEngPart) {
                        if (onlyArabicPart) {
                            this.correctAudio = this.scene.sound.add(this.gameplay.roundWord);
                            this.correctAudio.play();
                        } else {
                            this.correctAudio.once('complete', () => {
                                this.correctAudio = this.scene.sound.add(this.gameplay.roundWord);
                                this.correctAudio.play();
                            });
                        }
                    }
                    if (this.areYouSureWindow && this.areYouSureWindow.parentContainer == this) {
                        this.correctAudio.pause();
                    }
                }

                showGameplay() {
                    setPageBackground("bg-australia");
                    this.gameplay.reset();
                    this.bgMusic = this.scene.sound.add("Bachground ambience");
                    // this.bgMusic.play();
                    // this.bgMusic.loop = true;
                    this.gameplayContainer = new Phaser.GameObjects.Container(this.scene);
                    this.addAt(this.gameplayContainer, 1);
                    this.prepareRound();
                    this.gameplay.setupCallbacks(this.showCompleteWindow, this.showLoseWindow, () => {
                        this.onNewRound(true);
                    });
                    this.createTallies();
                }

                createTallies() {
                    if (this.tally) {
                        for (let te of this.tallyEmptyArray) {
                            te.visible = false;
                            this.bringToTop(te);
                        }
                        for (let t of this.tally) {
                            t.visible = false;
                            this.bringToTop(t);
                        }
                        return;
                    }
                    let startX = 38;
                    let startY = 134;
                    let dy = 35;
                    let tallyEmptyArrayPositions = [];
                    for (let i = 0; i < this.gameplay.getMaxTotalAnswersCount(); i++) {
                        tallyEmptyArrayPositions.push({ x: startX, y: startY + i * dy });
                    }
                    this.tallyEmptyArray = [];
                    this.tally = [];
                    for (let p of tallyEmptyArrayPositions) {
                        let _BeehiveEmpty = new Phaser.GameObjects.Image(this.scene, p['x'], p['y'], 'tally Empty');
                        this.tallyEmptyArray.push(_BeehiveEmpty);
                        _BeehiveEmpty.visible = false;
                        let _Beehive = new Phaser.GameObjects.Image(this.scene, p['x'], p['y'], 'tally');
                        this.tally.push(_Beehive);
                    }
                    for (let bea of this.tallyEmptyArray) {
                        this.add(bea);
                    }
                    for (let bee of this.tally) {
                        this.add(bee);
                        bee.visible = false;
                    }
                }

                prepareRound() {
                    this._btnSound.visible = false;
                    this.gameplayContainer.removeAll();

                    this.marger = this.scene.add.sprite(0, 0, 'marger');
                    this.marger.setPosition(475, 0); window["this.marger"] = this.marger;//490, 300
                    this.gameplayContainer.add(this.marger);
                    this.marger.alpha = 0;
                    window['this.marger'] = this.marger;

                    this.clouds = [];
                    window['this.clouds'] = this.clouds;
                    let origins = {
                        0: { x: 0.47, y: 0.5 }, 1: { x: 0.55, y: 0.5 }, 2: { x: 0.43, y: 0.5 }
                    };
                    let _roundWordLettersNumber = json.wordsLetters == undefined ? 4 : this.gameplay.getRoundWordLettersNumber();
                    let positions = [{ x: 191/*170*/, y: 245 }, { x: 494, y: 244 }, { x: 756, y: 232 }];
                    let adjustTextX = [0, -12, 0];
                    let adjustTextY = [-4, -12, 3];
                    for (let i = 0; i < _roundWordLettersNumber; i++) {
                        let c = new Phaser.GameObjects.Container(this.scene, positions[i].x, positions[i].y);
                        this.gameplayContainer.add(c);
                        this.clouds.push(c);
                        // c.setScale(0.75);
                        c['defX'] = c.x;
                        c['defY'] = c.y;
                        c['defX-for-word'] = 200 + i * 290;
                        c['defY-for-word'] = 240 - 80;
                        let cSprite = new Phaser.GameObjects.Image(this.scene, 0, 0, 'cloud ' + (i == 3 ? 1 : (i + 1)));
                        cSprite.setOrigin(origins[i].x, origins[i].y);
                        c.add(cSprite);
                        c["-index-"] = i;
                        c["-image-"] = cSprite;
                        let charAt = {};
                        let roundWordLettersNumber = {};
                        if (json.wordsLetters == undefined) {
                            charAt = this.gameplay.roundWord.charAt(this.gameplay.roundWord.length - 1 - i);
                        }
                        else {
                            roundWordLettersNumber = this.gameplay.getRoundWordLettersNumber();
                            charAt = this.gameplay.getRoundWordCharAt(roundWordLettersNumber - 1 - i);
                        }
                        let txt;
                        if (this.gameplay.useImages) {
                            txt = new Phaser.GameObjects.Image(this.scene, 0, 0, charAt);
                            txt.setScale(1 / c.scaleX);
                        } else {
                            txt = this.scene.add.text(0, 0, charAt, {
                                "fontFamily": "QuranErafont",
                                "fontSize": 50,
                                "color": "#000000",
                                "align": 'center'
                            });
                            txt.setOrigin(0.5, 0.5);
                            txt.setPadding({ left: 0, right: 0, top: 65, bottom: 65 });

                            if (txt.width > 120) txt.setScale(120 / txt.width);
                        }
                        c.add(txt);
                        txt.x = adjustTextX[i];
                        txt.y = adjustTextY[i];
                        c["-txt-"] = txt;
                        if (json.wordsLetters == undefined) {
                            c["-txt-text"] = this.gameplay.roundWord.charAt(this.gameplay.roundWord.length - 1 - i);
                        }
                        else {
                            c["-txt-text"] = charAt;
                        }
                        c['handIcon'] = new Phaser.GameObjects.Image(this.scene, 0, -80, 'pointer arrow 1');
                        c.add(c['handIcon']);
                        c['handIcon'].setScale(0.65);
                        c['handIcon'].visible = false;
                        this.scene.tweens.add({
                            targets: c['handIcon'],
                            "y": c['handIcon'].y - 15,
                            duration: 750,
                            yoyo: true,
                            repeat: -1
                        });
                        c.alpha = 0;
                        this.scene.tweens.add({
                            targets: c,
                            "alpha": 1,
                            duration: 250,
                            delay: 1000 + 350
                        });

                        txt.alpha = 0;
                        this.scene.tweens.add({
                            targets: txt,
                            "alpha": 1,
                            duration: 250,
                            delay: 1000 + 350 + 1000
                        });
                    }

                    delayedCall(1000 + 250 + 1000, () => {
                        this.scene.sound.add('Letters appear').play();
                    });

                    this.preparePartA();
                    this.createInput();
                    this.setInputEnabled(false);
                    // delayedCall(1200, ()=>{
                    if (this.gameplay.isNewRound()) {
                        if (!this.gameplay.isRoundsComplete()) {
                            // delayedCall(2000, ()=>{
                            this.setInputEnabled(true);
                            // });
                        }
                    } else {
                        this.setInputEnabled(true);
                    }
                    // });
                }

                preparePartA() {
                    delayedCall(125, () => {
                        this.marger.alpha = 1;
                        this.marger.setPosition(490, 303);
                        Preloader.playAnim('being-splat', this.marger);
                    });
                    this.scene.sound.add('Three slimes being thrown to the wall').play();

                    delayedCall(1650 + 125, () => {
                        this.marger.setPosition(475, 0);
                        this.marger.alpha = 0;
                    });

                    for (let i = 0; i < this.clouds.length; i++) {
                        let c = this.clouds[i];
                        c["-image-"].setInteractive({ cursor: 'pointer', pixelPerfect: true });
                        c["-image-"].on('pointerdown', () => {
                            if (!c['handIcon'].visible)
                                return;
                            c["-image-"].off('pointerdown');
                            c['handIcon'].visible = false;
                            this.scene.sound.add("Bubble click").play();
                            delayedCall(500, () => {
                                try { this.scene.sound.add(this.gameplay.getAudioKeyOfChar(c["-txt-text"])).play(); } catch (e) { }
                            });
                            c["-image-"].setScale(1, 1);
                            /* this.scene.tweens.add({
                                targets: c["-image-"],
                                "scale": 1.02,
                                duration: 750,
                                ease: Phaser.Math.Easing.Cubic.Out
                            }); */
                            if (i == 0) {
                                delayedCall(1750, () => {
                                    this.preparePartB();
                                });
                            } else {
                                delayedCall(1000, () => {
                                    this.clouds[i - 1]['handIcon'].visible = true;
                                });
                            }
                        });
                    }
                    delayedCall(3000, () => {
                        this.clouds[this.clouds.length - 1]['handIcon'].visible = true;
                    });
                }

                preparePartB() {
                    this.marger.alpha = 1;
                    Preloader.playAnim('marger', this.marger);
                    window['this.clouds'] = this.clouds;
                    delayedCall(300, () => {
                        this.scene.sound.add('cloudsjoinsfx').play();
                    });
                    let pos = { x: game.scale.width / 2 - 10, y: this.clouds[1].y + 15 };
                    for (let i = 0; i < this.clouds.length; i++) {
                        let c = this.clouds[i];
                        this.clouds[i].visible = true;
                        this.scene.tweens.add({
                            targets: c,
                            duration: (i == 0 ? 95 : 102) / 125 * 1000,
                            x: pos.x,
                            scaleX: 0.75 * 0.75,
                            scaleY: 1.05 * 0.75,
                            delay: (i == 0 ? 7 : 3) / 90 * 1000,
                            alpha: 0,
                            ease: Phaser.Math.Easing.Quadratic.InOut,
                            onUpdate: () => {
                                /*if (i==0) {
                                    c.x = pos.x - this.marger.frame.width / 2 + 135;
                                } else if (i==2) {
                                    c.x = pos.x + this.marger.frame.width / 2 - 135;
                                }*/
                            }
                        });
                        /* this.scene.tweens.add({
                            targets: c,
                            duration: 30,
                            useFrames: true,
                            alpha: 0,
                            ease: Phaser.Math.Easing.Circular.In
                        });
 */
                        this.scene.tweens.add({
                            targets: c["-image-"],
                            duration: 200,
                            alpha: 0,
                            ease: Phaser.Math.Easing.Circular.Out
                        });
                        // c["-image-"].alpha = 0;
                    }

                    this.cloudsContainer = new Phaser.GameObjects.Container(this.scene, pos.x, pos.y);
                    let txt;
                    if (this.gameplay.useImages) {
                        txt = new Phaser.GameObjects.Image(this.scene, 0, -25, this.gameplay.roundWord);
                    } else {
                        txt = this.scene.add.text(0, -25, this.gameplay.roundWord, {
                            "fontFamily": "QuranErafont",
                            "fontSize": 65,
                            "color": "#000000",
                            "align": 'center'
                        });
                        txt.setOrigin(0.5, 0.5);
                        txt.setPadding({ left: 0, right: 0, top: 65, bottom: 65 });

                        if (txt.width > 120) txt.setScale(120 / txt.width);
                    }
                    txt['-txt-text'] = this.gameplay.roundWord;
                    txt.alpha = 0;
                    this.scene.tweens.add({
                        targets: txt,
                        delay: 400,
                        alpha: 1,
                        duration: 300
                    });

                    this.cloudsContainer.add(txt);
                    this.gameplayContainer.add(this.cloudsContainer);
                    delayedCall(4000, () => {
                        let positions = [{ x: 170, y: 522 }, { x: 488, y: 522 }, { x: 795, y: 522 }];

                        for (var i = 0; i < this.clouds.length; i++) {
                            this.clouds[i].y = positions[i].y + 200;//this.clouds[i]["defY"] - 250;
                            this.clouds[i].x = positions[i].x;//this.clouds[i]['defX'];
                            this.clouds[i].alpha = 1;
                            this.clouds[i]["-image-"].alpha = 1;
                            this.clouds[i].visible = i < this.gameplay.roundWords.length;
                        }
                        this.scene.sound.add("Three buckets appearing").play();
                        for (var i = 0; i < this.clouds.length; i++) {
                            this.clouds[i].y = positions[i].y + 250;
                            this.clouds[i].setScale(0.8);

                            this.scene.tweens.add({
                                targets: this.clouds[i],
                                "y": positions[i].y,
                                duration: 350,
                                delay: i == 2 ? 0 : (i == 0 ? 300 : 150),
                                scaleX: 1,
                                scaleY: 1
                            });
                        }
                    });
                    delayedCall(1800, () => {
                        this.scene.sound.add(this.gameplay.roundWord).play();
                    });
                    delayedCall(2000, () => {
                        delayedCall(1000, () => {
                            /* this.scene.tweens.add({
                                targets: this.marger,
                                alpha: 0,
                                duration: 500
                            }); */
                            /* this.scene.tweens.add({
                                targets: this.cloudsContainer,
                                alpha: 0,
                                duration: 500,
                                onComplete: () => {
                                    this.gameplayContainer.remove(this.cloudsContainer);
                                }
                            }); */
                            for (let i = 0; i < this.clouds.length; i++) {
                                let c = this.clouds[i];
                                c["-image-"].setTexture('bucket');
                                // c.setScale(0.75);
                                c["-image-"].setOrigin(0.54, 0.5);
                                if (txt instanceof Phaser.GameObjects.Text) {
                                    c['-txt-'].setFontSize(60);
                                    // txt.style.fixedHeight = 65;
                                    c['-txt-'].setText(this.gameplay.roundWords[i]);
                                } else {
                                    c['-txt-'].setTexture(this.gameplay.roundWords[i]);
                                    c['-txt-'].setScale(1)
                                }
                                c['-txt-'].x = 0;
                                c['-txt-text'] = this.gameplay.roundWords[i];
                                c['-txt-'].alpha = 0;
                                this.scene.tweens.add({
                                    targets: c['-txt-'],
                                    "alpha": 1,
                                    duration: 350,
                                    delay: 750
                                });
                            }
                            this.preparePartC();
                        });
                    });
                }

                preparePartC() {
                    delayedCall(750, () => {
                        this._btnSound.visible = true;
                        this.playCorrectAudio(true);
                    });
                    for (let c of this.clouds) {
                        c["-image-"].once('pointerdown', () => {
                            c.parentContainer.bringToTop(c);
                            this.setInputEnabled(false);
                            if (c['-txt-text'] == this.gameplay.roundWord) {
                                let completed = this.onCorrectAnswer();
                                delayedCall(2200, () => {
                                    this.marger.y = 295;
                                    Preloader.playAnim(c["-index-"] === 0 ? 'fallLeft' : (c["-index-"] === 2 ? 'fallRight' : 'fall'), this.marger);
                                    this.scene.sound.add("Falling to the bucket").play();

                                    if (c["-index-"] != 1) {
                                        let _dx = (c["-index-"] === 0 ? -1 : 1) * 300;
                                        this.scene.tweens.add({
                                            targets: this.cloudsContainer,
                                            x: this.cloudsContainer.x + _dx,
                                            duration: 500,
                                            delay: 150
                                        });
                                    }

                                    if (!completed) {
                                        for (let _c of this.clouds) {
                                            this.scene.tweens.add({
                                                targets: _c,
                                                // "alpha": 0,
                                                "y": _c.y + 175,
                                                duration: 300,
                                                delay: 850 + 750
                                            });
                                            delayedCall(750 + 750, () => {
                                                this.scene.sound.add("poppingout").play();
                                            });
                                        }
                                    }

                                    this.scene.tweens.add({
                                        targets: this.cloudsContainer,
                                        alpha: 0,
                                        delay: 150,
                                        duration: 200
                                    });

                                    this.scene.tweens.add({
                                        targets: this.cloudsContainer,
                                        y: this.cloudsContainer.y + 300,
                                        delay: 250,
                                        duration: 625
                                    });
                                });

                                let roundWord = this.gameplay.roundWord;

                                if (completed) delayedCall(3500, () => this.scene.sound.add('Final celebration').play());
                                delayedCall(350, () => {
                                    this.scene.sound.add(roundWord).play();// this.playCorrectAudio(false, true);
                                });
                                // c["-image-"].setScale(1.15);
                                // c["-image-"].setTexture("clouds_correct");
                            } else {
                                let lost = this.onWrongAnswer();
                                // c["-image-"].setTexture("clouds_incorrect");
                                /* c["-image-"].setScale(1.15);
                                delayedCall(1000, () => {
                                    c["-image-"].setTexture("bigSlime");
                                    c["-image-"].setScale(1);
                                }); */
                                this.scene.sound.add("Wrong click").play();

                                if (!lost) {
                                    this.scene.tweens.add({
                                        targets: c,
                                        "y": c.y + 175,
                                        duration: 300,
                                        delay: 800
                                    });
                                    delayedCall(700, () => {
                                        this.scene.sound.add("poppingout").play();
                                    });
                                }

                                delayedCall(600, () => {
                                    if (!lost) this.setInputEnabled(true);
                                    // c["-txt-"].visible = false;
                                    // c["-image-"].visible = false;
                                });
                            }
                        });
                    }
                }

                onNewRound(showOut) {
                    this.setInputEnabled(false);
                    if (showOut) {
                        this.prepareRound();
                    }
                }

                createInput() {
                    this._btnClose.setInteractive({ cursor: 'pointer', pixelPerfect: true });
                }

                onCorrectAnswer() {
                    let i = this.gameplay.getCurrentTotalAnswersCount();
                    this.tallyEmptyArray[i].visible = false;
                    this.tally[i].visible = true;

                    let completed = this.gameplay.onCorrectAnswer();
                    this.scene.sound.add("Correct").play();
                    delayedCall(600, () => {
                        // Preloader.playAnim('dolphinhappy', this.character);
                        // this.scene.sound.add(this.birdCorrectSndCounter++ % 2 == 0 ? "Bird - yes thats it" : "Bird fantastic").play();
                    });
                    return completed;
                }

                onWrongAnswer() {
                    let i = this.gameplay.getCurrentTotalAnswersCount();
                    this.tallyEmptyArray[i].visible = true;
                    this.tallyEmptyArray[i].visible = true;
                    this.tally[i].visible = false;

                    let lost = this.gameplay.onWrongAnswer();
                    // this.scene.sound.add("wrong click").play();
                    return lost;
                }

                onCloseClick() {
                    this.showAreYouSurePage();
                    this.scene.sound.add('warning page pop up sfx').play();
                }

                showInstructionPage() {
                    setPageBackground("bg-blue");
                    this.instructionPage = new screen.InstructionPage(this.scene, (target) => {
                        playBtnClickAnim(target);
                        this.remove(this.instructionPage);
                        this.showGameplay();
                        if (this.wfsnd) {
                            this.wfsnd.stop();
                        }
                    }, (target) => {
                        playBtnClickAnim(target);
                        if (this.wfsnd) {
                            this.wfsnd.stop();
                        }
                        if (!game.cache.json.get('gameplay')['welcomeAudioDisabled']) {
                            this.wfsnd = this.scene.sound.add("Introduction");
                            this.wfsnd.play();
                        }
                    });
                    this.add(this.instructionPage);
                    try {
                        if (!game.cache.json.get('gameplay')['welcomeAudioDisabled']) {
                            this.wfsnd = this.scene.sound.add("Introduction");
                            this.wfsnd.play();
                        }
                    }
                    catch (e) {
                        console.error(e);
                    }
                }

                showAreYouSurePage() {
                    pauseAllDelayedCalls();
                    setPageBackground("bg-blue");
                    this.pauseSounds();
                    this.areYouSureWindow = new screen.AreYouSureWindow(this.scene, () => {
                        this.remove(this.areYouSureWindow);
                        this.destroyGameplay();
                        this.showInstructionPage();
                    }, () => {
                        this.remove(this.areYouSureWindow);
                        this.unpauseSounds();
                        resumeAllDelayedCalls();
                        setPageBackground("bg-australia");
                    });
                    this.add(this.areYouSureWindow);
                }

                setInputEnabled(enabled) {
                    if (enabled) {
                        for (let c of this.clouds)
                            c["-image-"].setInteractive({ cursor: 'pointer', pixelPerfect: true });
                    } else {
                        for (let c of this.clouds)
                            c["-image-"].disableInteractive();
                    }
                }

                pauseSounds() {
                    this.scene.sound.pauseAll();
                    if (this.correctAudio) this.correctAudio.pause();
                }

                unpauseSounds() {
                    this.scene.sound.resumeAll();
                    if (this.correctAudio) this.correctAudio.resume();
                }

                destroyGameplay() {
                    this.setInputEnabled(false);
                    this.remove(this.gameplayContainer);
                    this.scene.sound.stopAll();
                    destroyAllDelayedCalls();
                }
            }

            screen.GameplayScreen = GameplayScreen;
        })(screen = letterBubble.screen || (letterBubble.screen = {}));
    })(letterBubble || (letterBubble = {}));

    (function (letterBubble) {
        var screen;
        (function (screen) {
            class InstructionPage extends Phaser.GameObjects.Container {
                constructor(scene, onPlayClick, onSndClick) {
                    super(scene);
                    this._instructionPage = new Phaser.GameObjects.Image(this.scene, 0 - 105, 0 - 48, 'Instructions page  ALL ACTIVITY  TITLEs');
                    this._instructionPage.setOrigin(0, 0);
                    this._instructionPage.setInteractive();

                    this._instructionPageTitle = this.scene.add.text(475, 110, letterBubble.App.json.instructionTitle ?? 'Slime Splat', {
                        "fontFamily": "Kids Rock DEMO",
                        "fontSize": 40,
                        "color": "#43425D",
                        "align": 'center'
                    });
                    this._instructionPageTitle.setOrigin(0.5, 0.5);
                    window['this._instructionPageTitle'] = this._instructionPageTitle;
                    this._instructionPageTitle.setStroke('#ffffff', 5);
                    //  Apply the gradient fill.
                    const gradient = this._instructionPageTitle.context.createLinearGradient(0, 0, 0, this._instructionPageTitle.height);
                    gradient.addColorStop(0, '#eeef67');
                    gradient.addColorStop(0.55, '#e98c2c');
                    gradient.addColorStop(1, '#91301a');
                    this._instructionPageTitle.setFill(gradient);

                    this._btnPlay = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2, 480 - 50, 'btnPLAY1');
                    this._btnPlay.setInteractive({ cursor: 'pointer' });
                    this._btnPlay.once('pointerup', onPlayClick);
                    setupButtonTextureBased(this._btnPlay, 'btnPLAY1', 'btnPLAY2');
                    this.instrTxt = this.scene.add.text(game.scale.width / 2, game.scale.height / 2, letterBubble.App.json.instructionDescription ?? "Tap on the slimes and make a word.\nThen put the slime into the right bucket.", {
                        "fontFamily": "Kids Rock DEMO",
                        "fontSize": 30,
                        "color": "#43425D",
                        "align": 'center'
                    });
                    this.instrTxt.setLineSpacing(15);
                    this.instrTxt.setOrigin(0.5, 0.5);
                    this._btnSoundInstruction = new Phaser.GameObjects.Image(this.scene, 800 - 105, 156 - 50, 'Sound');
                    this._btnSoundInstruction.setInteractive({ cursor: 'pointer' });
                    this._btnSoundInstruction.on('pointerup', onSndClick);
                    setupButtonTextureBased(this._btnSoundInstruction, 'Sound', 'Sound HOVER EFFECT');
                    this.add(this._instructionPage);
                    this.add(this._instructionPageTitle);
                    this.add(this.instrTxt);
                    this.add(this._btnPlay);
                    this.add(this._btnSoundInstruction);
                }
            }

            screen.InstructionPage = InstructionPage;
        })(screen = letterBubble.screen || (letterBubble.screen = {}));
    })(letterBubble || (letterBubble = {}));

    (function (letterBubble) {
        var screen;
        (function (screen) {
            class TryAgainWindow extends Phaser.GameObjects.Container {
                constructor(scene, onBack, onReplay) {
                    super(scene);
                    this.music = null;
                    this.setPosition(-106, -48);
                    this._bg = new Phaser.GameObjects.Image(this.scene, 0, 0, 'Try again page');
                    this._bg.setOrigin(0, 0);
                    this._bg.setInteractive();
                    this._star = new Phaser.GameObjects.Image(this.scene, 400, 415, 'Break Star');
                    this._btnBack = new Phaser.GameObjects.Image(this.scene, 600, 580, 'btnBACK1');
                    this._btnReplay = new Phaser.GameObjects.Image(this.scene, 765, 580, 'btnReplay1');
                    this.totalScoreTxt = this.scene.add.text(830, 355, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 35,
                        "color": "#F49F1C",
                        "align": 'center',
                        'stroke': '#70451A',
                        'strokeThickness': 6
                    });
                    this.totalScoreTxt.setOrigin(0.5, 0.5);
                    let grd = this.totalScoreTxt.context.createLinearGradient(0, 0, 0, this.totalScoreTxt.height);
                    grd.addColorStop(0, '#FFFF00');
                    grd.addColorStop(1, '#C17316');
                    this.totalScoreTxt.setFill(grd);
                    this.starScoreTxt = this.scene.add.text(635, 431, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 24,
                        "color": "#FFFFFF",
                        "align": 'center'
                    });
                    this.starScoreTxt.setOrigin(0.5, 0.5);
                    this.add([
                        this._bg,
                        this._star,
                        this._btnBack,
                        this._btnReplay,
                        this.totalScoreTxt,
                        this.starScoreTxt
                    ]);
                    this._btnBack.setInteractive({ cursor: 'pointer' });
                    this._btnBack.on('pointerup', () => {
                        onBack(this._btnBack);
                        // if (this.music) {
                        //     this.music.stop();
                        // }
                    });
                    setupButtonTextureBased(this._btnBack, 'btnBACK1', 'btnBACK2');
                    this._btnReplay.setInteractive({ cursor: 'pointer' });
                    this._btnReplay.once('pointerup', () => {
                        onReplay(this._btnReplay);
                        if (this.music) {
                            this.music.stop();
                        }
                    });
                    setupButtonTextureBased(this._btnReplay, 'btnReplay1', 'btnReplay2');
                }

                show(score, starScore) {
                    this._star.scale = 1.25;
                    this.scene.tweens.add({
                        targets: this._star,
                        "scale": 1,
                        duration: 500,
                        ease: Phaser.Math.Easing.Back.Out
                    });
                    if (window.angularComponentRef) this.totalScoreTxt.text = String(window.angularComponentRef.component.userInfo.totalScore);
                    this.starScoreTxt.text = String(0);
                    this.music = this.scene.sound.add("Fail - close one");
                    this.music.play();
                }
            }

            screen.TryAgainWindow = TryAgainWindow;
        })(screen = letterBubble.screen || (letterBubble.screen = {}));
    })(letterBubble || (letterBubble = {}));

    game = new letterBubble.App(json);
};

function destroySlimeSplat() {
    if (game) {
        game.destroy();
    }
}

var game;
var sh;
function findTheWay(json) {
    /**
     * @author Roman Parada
     * This class is created to fix overlapping of bottom part of canvas by navigation bar in iOS.
     * It make a delayed resize of the canvas (like Phaser-3 FIT methods does) and it overrides Phaser-3 input window to Phaser-3 core transform methods
     *
     * How to use:
     * Just call the code line below in Boot scene's init() method of your project:
     * new FitScaleManager(this.game).setup();
     */
    class FitScaleManager {
        constructor(game) {
            this.doResize = () => {
                let scale = this.calculateScale();
                let newCanvasWidth = this.phaserScaleManager.width * scale;
                let newCanvasHeight = this.phaserScaleManager.height * scale;
                this.canvasStyle.width = newCanvasWidth + 'px';
                this.canvasStyle.height = newCanvasHeight + 'px';
                this.canvasStyle.marginLeft = (window.innerWidth - newCanvasWidth) / 2 + 'px';
                this.canvasStyle.marginTop = (window.innerHeight - newCanvasHeight) / 2 + 'px';
            };
            this.game = game;
            this.canvasStyle = this.game.canvas.style;
            this.phaserScaleManager = this.game.scale;
        }
        static detectBestScaleMode() {
            let iOS = /iPad|iPhone|iPod/.test(navigator.platform || "");
            let isAndroid = window.navigator.userAgent.toLowerCase().indexOf("android") > -1;
            return iOS || isAndroid ? Phaser.Scale.FIT : Phaser.Scale.NONE;
        }
        ;
        /**
         * Just call this method once in Boot scene's init() method
         */
        setup() {
            this.phaserScaleManager.addListener(Phaser.Scale.Events.RESIZE, this.onResize, this);
            this.overridePhaserTransformMethods();
            this.onResize();
        }
        calculateScale() {
            if (game.scale.scaleMode === Phaser.Scale.NONE)
                return 1;
            return Math.min(window.innerWidth / this.phaserScaleManager.width, window.innerHeight / this.phaserScaleManager.height);
        }
        overridePhaserTransformMethods() {
            this.game.scale.transformX = (pageX) => {
                return (pageX - parseInt(this.canvasStyle.marginLeft.split("px")[0])) / this.calculateScale();
            };
            this.game.scale.transformY = (pageY) => {
                return (pageY - parseInt(this.canvasStyle.marginTop.split("px")[0])) / this.calculateScale();
            };
        }
        onResize() {
            setTimeout(this.doResize, FitScaleManager.RESIZE_DELAY);
        }
    }
    FitScaleManager.RESIZE_DELAY = 500;

    (function (sh) {
        class App extends Phaser.Game {
            constructor(json) {
                App.json = json;
                // console.log(App.json);

                let config = {
                    type: Phaser.AUTO,
                    width: App.CANVAS_WIDTH,
                    height: App.CANVAS_HEIGHT,
                    parent: 'game-container',
                    dom: {
                        createContainer: false
                    },
                    scale: {
                        mode: FitScaleManager.detectBestScaleMode(),
                        autoCenter: Phaser.Scale.CENTER_BOTH
                    },
                    transparent: true,
                    scene: {
                        create: () => {
                            this.scene.add('Boot', sh.scene.Boot, true);
                        }
                    }
                };
                super(config);
            }
        }
        App.CANVAS_WIDTH = 980;//490;
        App.CANVAS_HEIGHT = 600;//797;
        sh.App = App;
    })(sh || (sh = {}));

    game = new sh.App(json);

    var delayedCalls = [];
    function delayedCall(delay, callback, args, callbackScope) {
        let scene = game.scene.getAt(0);
        if (scene) {
            let dc = scene.time.delayedCall(delay, callback, args, callbackScope);
            delayedCalls.push(dc);
            return dc;
        }
        let t = setTimeout(callback, delay);
        delayedCalls.push(t);
        return t;
    }

    function pauseAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.paused = true;
            }
        }
    }

    function resumeAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.paused = false;
            }
        }
    }

    function destroyAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.remove(false);
            }
            else {
                clearTimeout(dc);
            }
        }
        delayedCalls = [];
    }

    function setPageBackground(bg) {
        // document.querySelector("html").style.backgroundImage = "url(assets/games/find-the-way/imgs/" + bg + ".jpg)";
    }

    function setupButton(btn, frame) {
        btn.on('pointerdown', () => { btn.setFrame(frame + '_hover' + '0000'); });
        btn.on('pointerover', () => { btn.setFrame(frame + '_hover' + '0000'); game.scene.getAt(0).sound.add("button hover").play(); });
        btn.on('pointerout', () => { btn.setFrame(frame + '0000'); });
        btn.on('pointerup', () => { btn.setFrame(frame + '0000'); game.scene.getAt(0).sound.add('activity selection - button selection').play(); });
    }

    function setupButtonTextureBased(btn, texture, hoverTexture) {
        btn.on('pointerdown', () => { btn.setTexture(hoverTexture); });
        btn.on('pointerover', () => { btn.setTexture(hoverTexture); game.scene.getAt(0).sound.add("button hover").play(); });
        btn.on('pointerout', () => { btn.setTexture(texture); });
        btn.on('pointerup', () => { btn.setTexture(texture); game.scene.getAt(0).sound.add('activity selection - button selection').play(); });
    }

    (function (sh) {
        var core;
        (function (core) {
            class Gameplay {
                constructor() {
                    this.currentRound = 0;
                    this.currentLetter = 0;
                    this.correctAnswersCount = 0;
                    this.wrongAnswersCount = 0;
                    this.correctAnswersCountThisRound = 0;
                    this.wrongAnswersCountThisRound = 0;
                    this.reset();
                    let json = game.cache.json.get('gameplay');
                    this.wrongAnswersToLose = json["wrongAnswersToLose"];
                    this.numberOfQuestionsPerRound = json["numberOfQuestionsPerRound"];
                    this.lettersConfig = JSON.parse(JSON.stringify(json["lettersConfig"]));
                    this.rounds = JSON.parse(JSON.stringify(json["rounds"]));
                    this.numberOfRounds = json["numberOfRounds"] ?? this.rounds.length;
                    this.useImages = Boolean(game.cache.json.get('gameplay')["useImages"]);
                }
                setupCallbacks(onComplete, onLose) {
                    this.onComplete = onComplete;
                    this.onLose = onLose;
                }
                onLetterChosen(forceNewRound) {
                    if (forceNewRound || this.isNewRound()) {
                        return this.nextRound();
                    }
                    return false;
                }
                nextRound() {
                    this.correctAnswersCountThisRound = 0;
                    this.wrongAnswersCountThisRound = 0;
                    this.currentRound++;
                    if (this.isRoundsComplete()) {
                        this.onComplete(this.correctAnswersCount, this.correctAnswersCount);
                        return true;
                    }

                    return false;
                }
                getCorrectLetterName() {
                    return this.rounds[this.currentRound]['correctLetterName'];
                }
                isCorrectLetterAudioQuestionEnable() {
                    return this.rounds[this.currentRound]['audioQuestionEnable'];
                }
                getCorrectAudioKey() {
                    return this.lettersConfig[this.getCorrectLetterName()]['correctAudioKey'];
                }
                getCorrectAndLetterSoundSfxAudioKey() {
                    return "Q-" + this.lettersConfig[this.getCorrectLetterName()]['Sounds of the letters'];
                }
                onCorrectAnswer() {
                    this.correctAnswersCountThisRound++;
                    this.correctAnswersCount++;
                    return this.onLetterChosen();
                }
                onWrongAnswer(forceNewRound) {
                    this.wrongAnswersCountThisRound++;
                    this.wrongAnswersCount++;
                    if (this.wrongAnswersCount >= this.wrongAnswersToLose) {
                        this.onLose(this.correctAnswersCount, this.correctAnswersCount);
                        return true;
                    }
                    else {
                        this.onLetterChosen(forceNewRound);
                    }
                    return false;
                }

                getMaxTotalAnswersCount() {
                    return this.wrongAnswersToLose + this.numberOfRounds - 1;
                }

                getCurrentTotalAnswersCount() {
                    return this.correctAnswersCount + this.wrongAnswersCount;
                }
                isNewRound() {
                    return this.correctAnswersCountThisRound >= 1 || (this.correctAnswersCountThisRound + this.wrongAnswersCountThisRound) === 0;
                }
                isRoundsComplete() {
                    return this.currentRound >= this.numberOfRounds && this.wrongAnswersCount < this.wrongAnswersToLose;
                }
                reset() {
                    this.currentRound = 0;
                    this.correctAnswersCount = 0;
                    this.wrongAnswersCount = 0;
                }
                getCurrentRoundLetters() {
                    return this.rounds[this.currentRound]["letters"];
                }
            }
            core.Gameplay = Gameplay;
        })(core = sh.core || (sh.core = {}));
    })(sh || (sh = {}));

    (function (sh) {
        var scene;
        (function (scene) {
            class Boot extends Phaser.Scene {
                init() {
                    this.game.scale.transformX = (pageX) => {
                        let offsetLeft = 0;
                        let parentElement = game.canvas.parentElement;
                        while (parentElement) {
                            if (parentElement.offsetLeft) {
                                offsetLeft = parentElement.offsetLeft;
                                break;
                            }
                            parentElement = parentElement.parentElement;
                        }
                        return (pageX - offsetLeft) * this.game.scale.displayScale.x;
                    };
                    this.game.scale.transformY = (pageY) => {
                        let offsetTop = 0;
                        let parentElement = game.canvas.parentElement;
                        while (parentElement) {
                            if (parentElement.offsetTop) {
                                offsetTop = parentElement.offsetTop;
                                break;
                            }
                            parentElement = parentElement.parentElement;
                        }
                        return (pageY - offsetTop) * this.game.scale.displayScale.y;
                    };
                }
                create() {
                    game.scene.remove('Boot');
                    game.scene.add('Preloader', sh.scene.Preloader, true);
                }
            }
            scene.Boot = Boot;
        })(scene = sh.scene || (sh.scene = {}));
    })(sh || (sh = {}));

    (function (sh) {
        var scene;
        (function (scene) {
            var Gameplay = sh.core.Gameplay;
            class MainScene extends Phaser.Scene {
                create() {
                    this.gameplay = new Gameplay();
                    this.gameplayScreen = new sh.screen.GameplayScreen(this, this.gameplay);
                    this.children.add(this.gameplayScreen);
                    this.gameplayScreen.showInstructionPage();
                }
            }
            scene.MainScene = MainScene;
        })(scene = sh.scene || (sh.scene = {}));
    })(sh || (sh = {}));

    (function (sh) {
        var scene;
        (function (scene) {
            class Preloader extends Phaser.Scene {
                preload() {
                    if (typeof sh.App.json == "string") this.load.json('gameplay', sh.App.json); else this.game.cache.json.add('gameplay', sh.App.json);
                }
                create() {
                    let json = game.cache.json.get('gameplay');
                    let lettersConfig = json["lettersConfig"];
                    this.load.audio("englQuestion", json["englQuestion"] ? "assets/games/find-the-way/sound/mp3/" + json["englQuestion"] : "assets/games/find-the-way/sound/mp3/englQuestion.mp3");

                    for (let letterName in lettersConfig) {
                        if (json["useImages"]) this.load.image(letterName, "assets/games/find-the-way/imgs/letters/" + letterName + ".png");
                    }

                    let progressTxt = this.add.text(game.scale.width / 2, game.scale.height / 2 + 50, "", {
                        "fontFamily": "QuranErafont",
                        "fontSize": 25,
                        "color": "#333333",
                        "align": 'center'
                    });
                    progressTxt.setOrigin(0.5, 0.5);
                    this.load.pack('preloader', 'assets/games/find-the-way/pack.json');
                    this.load.on('progress', (value) => {
                        progressTxt.text = Math.ceil(value * 100) + "%";
                    }, this);
                    this.load.on('complete', () => {
                        this.nextScene();
                    });
                    this.load.start();
                }
                static playAnim(animKey, sprite, onComplete = null) {
                    let mainScene = game.scene.getScene('ScreenMain');
                    if (!mainScene.anims.exists(animKey)) {
                        let data = Preloader.ANIMS_DATA[animKey];
                        mainScene.anims.create({
                            key: animKey,
                            frames: mainScene.anims.generateFrameNames(data['atlas'], {
                                start: data['start'], end: data['end'], zeroPad: data['padNum'],
                                prefix: data['prefix'], suffix: ''
                            }),
                            frameRate: data['frameRate'],
                            repeat: data['repeat']
                        });
                    }
                    if (sprite.anims.currentAnim) {
                        sprite.anims.currentAnim.off('complete');
                    }
                    sprite.anims.stop();
                    sprite.play(animKey);
                    sprite.anims.currentAnim.once('complete', () => {
                        if (onComplete)
                            onComplete();
                    });

                    if (animKey == 'fly') {
                        mainScene.sound.add('Bird flying').play();
                    }

                    return sprite;
                }
                nextScene() {
                    game.scene.remove('Preloader');
                    game.scene.add('ScreenMain', sh.scene.MainScene, true);
                }
            }
            Preloader.ANIMS_DATA = {
                'kangaroo-idle': {
                    'start': 0,
                    'end': 0,
                    'padNum': 2,
                    'prefix': 'jump',
                    'repeat': 0,
                    'frameRate': 22,
                    'atlas': 'kangaroo-atlas'
                },
                'kangaroo-jump': {
                    'start': 0,
                    'end': 39,
                    'padNum': 2,
                    'prefix': 'jump',
                    'repeat': 0,
                    'frameRate': 22,
                    'atlas': 'kangaroo-atlas'
                }
            };
            scene.Preloader = Preloader;
        })(scene = sh.scene || (sh.scene = {}));
    })(sh || (sh = {}));
    (function (sh) {
        var screen;
        (function (screen) {
            class AreYouSureWindow extends Phaser.GameObjects.Container {
                constructor(scene, onYes, onNo) {
                    super(scene);
                    this._areYouSurePage = new Phaser.GameObjects.Image(this.scene, -105, 0 - 48, 'Exit warning');
                    this._areYouSurePage.setOrigin(0, 0);
                    this._areYouSurePage.setInteractive();
                    this._btnSureYes = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2 - 95, 485 - 50, 'btnYES1');
                    this._btnSureYes.setInteractive({ cursor: 'pointer' });
                    this._btnSureYes.on('pointerup', () => {
                        onYes;
                        angularComponentRef.backToMenu();
                    });
                    var modalTextStyle = {
                        backgroundColor: 'transparent',
                        stroke: '#ffffff',
                        strokeThickness: 2,
                        lineSpacing: 15,
                        fontFamily: 'Kids Rock DEMO',
                        fontSize: 27,
                        color: '#43425d',
                        wordWrap: true,
                        align: 'center'
                    };
                    var modalText = this.scene.add.text(game.scale.width / 2 + 12, game.scale.height / 2, "Your progress in this activity will not be saved. \n Are you sure you want to exit? ", modalTextStyle);
                    modalText.setOrigin(0.5, 0.5);

                    setupButtonTextureBased(this._btnSureYes, 'btnYES1', 'btnYES2');
                    this._btnSureNo = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2 + 95, 485 - 50, 'btnNO1');
                    this._btnSureNo.setInteractive({ cursor: 'pointer' });
                    this._btnSureNo.on('pointerup', onNo);
                    setupButtonTextureBased(this._btnSureNo, 'btnNO1', 'btnNO2');
                    this.add(this._areYouSurePage);
                    this.add(this._btnSureYes);
                    this.add(this._btnSureNo);
                    this.add(modalText);
                }
            }
            screen.AreYouSureWindow = AreYouSureWindow;
        })(screen = sh.screen || (sh.screen = {}));
    })(sh || (sh = {}));

    (function (sh) {
        var screen;
        (function (screen) {
            class CompleteWindow extends Phaser.GameObjects.Container {
                constructor(scene, onBack, onReplay, onNext) {
                    super(scene);
                    this.music = null;
                    this.setPosition(-104.5, -48);
                    this._bgComplete = new Phaser.GameObjects.Image(this.scene, 0, 0, 'Completion page LATEST UPDATED');
                    this._bgComplete.setOrigin(0, 0);
                    this._bgComplete.setInteractive();
                    this._cup = new Phaser.GameObjects.Image(this.scene, 400, 410, 'Trophy');
                    this._btnBack = new Phaser.GameObjects.Image(this.scene, 570, 570, 'btnBACK1');
                    this._btnReplay = new Phaser.GameObjects.Image(this.scene, 720, 570, 'btnReplay1');
                    this._btnNext = new Phaser.GameObjects.Image(this.scene, 870, 570, 'btnNEXT1');
                    let _CollectedPoints = new Phaser.GameObjects.Image(this.scene, 620, 440, 'Collected Points');
                    this.totalScoreTxt = this.scene.add.text(845, 352, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 35,
                        "color": "#F49F1C",
                        "align": 'center',
                        'stroke': '#70451A',
                        'strokeThickness': 6
                    });
                    this.totalScoreTxt.setOrigin(0.5, 0.5);
                    let grd = this.totalScoreTxt.context.createLinearGradient(0, 0, 0, this.totalScoreTxt.height);
                    grd.addColorStop(0, '#FFFF00');
                    grd.addColorStop(1, '#C17316');
                    this.totalScoreTxt.setFill(grd);
                    this.starScoreTxt = this.scene.add.text(648, 433, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 24,
                        "color": "#FFFFFF",
                        "align": 'center'
                    });
                    this.starScoreTxt.setOrigin(0.5, 0.5);
                    this.add([
                        this._bgComplete,
                        _CollectedPoints,
                        this._cup,
                        this._btnBack,
                        this._btnReplay,
                        this._btnNext,
                        this.totalScoreTxt,
                        this.starScoreTxt
                    ]);
                    this._btnBack.setInteractive({ cursor: 'pointer' });
                    this._btnBack.on('pointerup', () => {
                        onBack(this._btnBack);
                        angularComponentRef.backToMenu();
                        // if (this.music) {
                        //     this.music.stop();
                        // }
                    });
                    setupButtonTextureBased(this._btnBack, 'btnBACK1', 'btnBACK2');
                    this._btnReplay.setInteractive({ cursor: 'pointer' });
                    this._btnReplay.once('pointerup', () => {
                        onReplay(this._btnReplay);
                        if (this.music) {
                            this.music.stop();
                        }
                    });
                    setupButtonTextureBased(this._btnReplay, 'btnReplay1', 'btnReplay2');
                    this._btnNext.setInteractive({ cursor: 'pointer' });
                    this._btnNext.on('pointerup', () => {
                        onNext(this._btnNext);
                        window.angularComponentRef.nextActivity()
                    });
                    setupButtonTextureBased(this._btnNext, 'btnNEXT1', 'btnNEXT2');
                }
                show(score, starScore) {
                    window.angularComponentRef.gameFinish({ score, starScore })
                    this._cup.scale = 1.25;
                    this.scene.tweens.add({
                        targets: this._cup,
                        "scale": 1,
                        duration: 500,
                        ease: Phaser.Math.Easing.Back.Out
                    });
                    this.totalScoreTxt.text = String(window.angularComponentRef.component.userInfo.totalScore);
                    this.starScoreTxt.text = String(starScore);
                    // let music = this.scene.sound.add("viktory");
                    this.music = this.scene.sound.add("Activity completion fantastic");
                    this.music.play();
                }
            }
            screen.CompleteWindow = CompleteWindow;
        })(screen = sh.screen || (sh.screen = {}));
    })(sh || (sh = {}));

    (function (sh) {
        var screen;
        (function (screen) {
            class GameplayScreen extends Phaser.GameObjects.Container {
                constructor(scene, gameplay) {
                    super(scene);
                    this.ROWS_DY = 372;
                    this.gridPositions = [];
                    let _dy = 0;
                    for (let k = 0; k < gameplay.numberOfRounds; k++) {
                        let _y = this.ROWS_DY * (gameplay.numberOfRounds - 1 - k) - _dy * k;
                        this.gridPositions.push([{ x: 218 - 22, y: 1190 - 95 - _y }, { x: 493 - 22, y: 1190 - 95 - _y }, { x: 771 - 22, y: 1190 - 95 - _y }]);
                    }
                    /* this.gridPositions = [
                        [{ x: 218, y: 807 }, { x: 493, y: 807 }, { x: 771, y: 807 }],
                        [{ x: 218, y: 995 }, { x: 493, y: 995 }, { x: 771, y: 995 }],
                        [{ x: 218, y: 1190 }, { x: 493, y: 1190 }, { x: 771, y: 1190 }]
                    ];   */
                    this.bgMusic = null;
                    this.correctAudio = null;
                    this.wfsnd = null;
                    this.showCompleteWindow = (score, starScore) => {
                        let completeWindow = new screen.CompleteWindow(this.scene, (target) => {
                            this.playBtnClickAnim(target);
                        }, (target) => {
                            this.playBtnClickAnim(target);
                            this.destroyGameplay();
                            this.remove(completeWindow);
                            this.showInstructionPage();
                        }, (target) => {
                            this.playBtnClickAnim(target);
                        });
                        this.setLettersInputEnabled(false);
                        delayedCall(5500, () => {
                            setPageBackground("bg-blue");
                            this.add(completeWindow);
                            completeWindow.show(score, starScore);
                            if (this.bgMusic) this.bgMusic.stop();
                        });
                    };
                    this.showLoseWindow = (score, starScore) => {
                        let tryAgainWindow = new screen.TryAgainWindow(this.scene, (target) => {
                            this.playBtnClickAnim(target);
                        }, (target) => {
                            this.playBtnClickAnim(target);
                            this.destroyGameplay();
                            this.remove(tryAgainWindow);
                            this.showInstructionPage();
                        });
                        this.setLettersInputEnabled(false);
                        delayedCall(1500, () => {
                            setPageBackground("bg-blue");
                            this.add(tryAgainWindow);
                            tryAgainWindow.show(score, starScore);
                            if (this.bgMusic) this.bgMusic.stop();
                        });
                    };
                    this.gameplay = gameplay;
                    window["t"] = this;
                }
                createHexagons() {
                    if (this.contentContainer && this.contentContainer.parentContainer) {
                        this.contentContainer.parentContainer.remove(this.contentContainer);
                    }
                    this.contentContainer = new Phaser.GameObjects.Container(this.scene, 0, this.contentContainer ? this.contentContainer.y : 0);
                    this.gameplayContentContainer.addAt(this.contentContainer, 1);
                    window['this.contentContainer'] = this.contentContainer;

                    if (this.gameplay.currentRound == 0) {
                        let bottom = new Phaser.GameObjects.Image(this.scene, 0, 1305, 'bottom');
                        bottom.setOrigin(0, 0);
                        window['-bottom-'] = bottom;
                        this.contentContainer.add(bottom);
                    }

                    if (this.gameplay.currentRound == this.gameplay.numberOfRounds - 1) {
                        let lastY = this.gridPositions[this.gridPositions.length - 1][0].y;
                        let _dy = (this.gameplay.currentRound > 2 ? this.gameplay.currentRound - 2 : 0) * this.ROWS_DY;

                        let palms = new Phaser.GameObjects.Image(this.scene, 0, -279 - _dy, 'palms');
                        palms.setOrigin(0, 0);
                        window['-palms-'] = palms;
                        this.contentContainer.add(palms);

                        let finishPlace = new Phaser.GameObjects.Image(this.scene, 545, -13 - _dy, 'finishPlace');
                        palms.setOrigin(0, 0);
                        window['-finishPlace-'] = finishPlace;
                        this.contentContainer.add(finishPlace);
                    }

                    /* delayedCall(250, () => {
                        this.scene.sound.add('New words appearing').play();
                    }); */

                    let offsetX = 10, offsetY = 15;

                    let _i = 0;
                    this.gridObjects = [];
                    var jarr = [1, 2, 3];
                    for (let k = 0; k < this.gridPositions.length; k++) {
                        let row = this.gridPositions[k];
                        for (let n = 0; n < row.length; n++) {
                            let hc = new Phaser.GameObjects.Container(this.scene, row[n]['x'], row[n]['y']);

                            let h = new Phaser.GameObjects.Image(this.scene, offsetX, offsetY, 'Normal Box-1');

                            if (k === this.gridPositions.length - this.gameplay.currentRound) {
                                if (n < 3 && n >= 0) {
                                    if (n < 3 && this.cars && this.cars[n] && this.cars[n]["Wrong Box"].visible) {
                                        h.setTexture('Wrong Box Answer-1');
                                    }
                                }
                            }

                            hc.add(h);
                            let p = row[n];
                            hc["defX"] = p['x'];
                            hc["defY"] = p['y'];
                            this.gridObjects.push(hc);
                            this.contentContainer.add(hc);
                            hc['index'] = _i;
                            _i++;
                        }
                    }
                    window['this.gridPositions'] = this.gridPositions;

                    this.carsPositions = this.gridPositions[this.gridPositions.length - (this.gameplay.correctAnswersCount + 1)];

                    this.cars = [];
                    _i = 0;
                    let origins = [{ x: 0.5, y: 0.5 }, { x: 0.5, y: 0.5 }, { x: 0.5, y: 0.5 }];
                    var jarr = [1, 2, 3];
                    for (let p of this.carsPositions) {
                        var j = Phaser.Utils.Array.RemoveRandomElement(jarr);
                        let hc = new Phaser.GameObjects.Container(this.scene, this.carsPositions[_i]['x'], this.carsPositions[_i]['y']);
                        let h = new Phaser.GameObjects.Image(this.scene, offsetX, offsetY, 'Normal Box-1');
                        h.setOrigin(origins[j - 1].x, origins[j - 1].y); h.alpha = 0.01;
                        hc.add(h);
                        hc["bg"] = h;
                        hc["Correct Box"] = new Phaser.GameObjects.Image(this.scene, offsetX, offsetY, 'Correct Box Answer-1');
                        hc["Correct Box"].alpha = 0;
                        hc["Correct Box"].setOrigin(0.5, 0.5);
                        hc.add(hc["Correct Box"]);
                        hc["Wrong Box"] = new Phaser.GameObjects.Image(this.scene, offsetX, offsetY, 'Wrong Box Answer-1');
                        hc["Wrong Box"].setOrigin(0.5, 0.5);
                        hc.add(hc["Wrong Box"]);
                        hc["Correct Box"].visible = hc["Wrong Box"].visible = false;

                        hc["defX"] = p['x'];
                        hc["defY"] = p['y'];
                        this.cars.push(hc);
                        this.contentContainer.add(hc);
                        hc['index'] = _i;
                        _i++;
                    }
                    window['this.cars'] = this.cars;

                    this.ship = this.scene.add.sprite(this.ship ? this.ship.x : 484 - 12, this.ship ? this.ship.y - 372 : 1100, "kangaroo-atlas");
                    sh.scene.Preloader.playAnim('kangaroo-idle', this.ship);
                    this.ship["defY"] = this.ship.y;
                    this.ship.setOrigin(0.5, 0.5);
                    this.contentContainer.add(this.ship);
                    window['this.ship'] = this.ship;
                }
                createLetters() {
                    /* if (this.letters) {
                        for (let l of this.letters) {
                            l.parentContainer["letter"] = null;
                            l["hexagon"] = null;
                            l.parentContainer.remove(l);
                        }
                    } */
                    this.letters = [];
                    let _letters = this.gameplay.getCurrentRoundLetters();
                    let firstLetter = true;
                    for (let n of _letters) {
                        let wordText;
                        if (this.gameplay.useImages) {
                            wordText = new Phaser.GameObjects.Image(this.scene, 0, 0, n);
                        } else {
                            wordText = this.scene.add.text(0, 0, n, {
                                "fontFamily": "QuranErafont",
                                "fontSize": 65,
                                "color": "#333333",
                                "align": 'center'
                            });
                            this.add(wordText);
                            wordText.setOrigin(0.5, 0.5);
                            wordText.setPadding({ left: 0, right: 0, top: 65, bottom: 65 });

                            if (wordText.width > 200) wordText.setScale(200 / wordText.width);
                        }
                        wordText["key"] = n;
                        wordText.setPosition(5, -32);
                        this.letters.push(wordText);
                        window['wordText'] = wordText;
                        window['this.letters'] = this.letters;

                        // wordText.alpha = 0;
                        delayedCall(400, () => {
                            /* this.scene.tweens.add({
                                targets: wordText,
                                "alpha": 1,
                                duration: 500
                            }); */

                            // if (this.gameplay.currentRound > 0 && firstLetter) this.scene.sound.add('New words appearing').play();
                            firstLetter = false;
                        });
                    }
                }
                showGameplay() {
                    this.isLost = false;
                    setPageBackground("bg-australia");
                    this.bgMusic = this.scene.sound.add("bg_sound");
                    this.bgMusic.play();
                    this.bgMusic.loop = true;
                    this.gameplay.reset();
                    this._gameStage = new Phaser.GameObjects.Container(this.scene);
                    this._bgContainer = new Phaser.GameObjects.Container(this.scene);
                    window['this._bgContainer'] = this._bgContainer;
                    this._bg = new Phaser.GameObjects.Image(this.scene, 0, -826, 'bg');
                    this._bg.setInteractive();
                    this._bg.setOrigin(0, 0);
                    this._bgContainer.add(this._bg);
                    this._bg1 = new Phaser.GameObjects.Image(this.scene, 0, -826 - this._bg.height, 'bg');
                    window['this._bg1'] = this._bg1;
                    this._bg1.setInteractive();
                    this._bg1.setOrigin(0, 0);
                    this._bgContainer.add(this._bg1);
                    this._gameStage.add(this._bgContainer);

                    this.overlayobjectLeft = new Phaser.GameObjects.Image(this.scene, 0, -810, 'overlayobjectLeft');
                    window['this.overlayobjectLeft'] = this.overlayobjectLeft;
                    this.overlayobjectLeft.setOrigin(0, 0.5);
                    this._bgContainer.add(this.overlayobjectLeft);

                    this.overlayobjectRight = new Phaser.GameObjects.Image(this.scene, 980, -840, 'overlayobjectRight');
                    window['this.overlayobjectRight'] = this.overlayobjectRight;
                    this.overlayobjectRight.setOrigin(1, 0.5);
                    this._bgContainer.add(this.overlayobjectRight);

                    window['this._bg'] = this._bg;
                    this._btnSound = new Phaser.GameObjects.Image(this.scene, 160 - 105, 100 - 50, 'Sound');
                    this._btnSound.setInteractive({ cursor: 'pointer' });
                    this._btnSound["defScale"] = this._btnSound.scale;
                    setupButtonTextureBased(this._btnSound, 'Sound', 'Sound HOVER EFFECT');
                    this._btnClose = new Phaser.GameObjects.Image(this.scene, 1025 - 105, 100 - 50, 'x Button');
                    this._btnClose.setInteractive({ cursor: 'pointer' });
                    this._btnClose["defScale"] = this._btnClose.scale;
                    setupButtonTextureBased(this._btnClose, 'x Button', 'x Button HOVER EFFECT');
                    this.gameplayContainer = new Phaser.GameObjects.Container(this.scene);
                    this.addAt(this.gameplayContainer, 0);
                    this.gameplayContentContainer = new Phaser.GameObjects.Container(this.scene);
                    this.gameplayContentContainer.add([
                        this._gameStage
                    ]);
                    this._btnSound.visible = false;
                    this.gameplayContainer.add([
                        this.gameplayContentContainer,
                        this._btnSound,
                        this._btnClose
                    ]);
                    this.gameplayContentContainer.y = -960;
                    window['this.gameplayContentContainer'] = this.gameplayContentContainer;
                    this.createBeehives();
                    this.shuffleOutHexagons();
                    this.gameplay.setupCallbacks(this.showCompleteWindow, this.showLoseWindow);
                }
                createBeehives() {
                    let startX = 943;
                    let startY = 515;
                    let dy = 34;
                    let _BeehiveEmptyArrayPositions = [];
                    for (let i = 0; i < this.gameplay.getMaxTotalAnswersCount(); i++) {
                        _BeehiveEmptyArrayPositions.push({ x: startX, y: startY - i * dy });
                    }
                    this._BeehiveEmptyArray = []; window["_BeehiveEmptyArray"] = this._BeehiveEmptyArray;
                    this._Beehive = [];
                    for (let p of _BeehiveEmptyArrayPositions) {
                        let _BeehiveEmpty = new Phaser.GameObjects.Image(this.scene, p['x'], p['y'], 'Beehive 1 Empty');
                        _BeehiveEmpty.setScale(0.5);
                        this._BeehiveEmptyArray.push(_BeehiveEmpty);
                        _BeehiveEmpty.visible = false;
                        let _Beehive = new Phaser.GameObjects.Image(this.scene, p['x'], p['y'], 'Beehive 1');
                        _Beehive.setScale(0.5);
                        this._Beehive.push(_Beehive);
                    }
                    for (let bea of this._BeehiveEmptyArray) {
                        this.gameplayContainer.add(bea);
                    }
                    for (let bee of this._Beehive) {
                        this.gameplayContainer.add(bee);
                        bee.visible = false;
                    }
                }
                randomizeLettersPosition() {
                    let hx = this.cars.slice();
                    for (let l of this.letters) {
                        if (hx.length == 0)
                            return;
                        let hc = Phaser.Utils.Array.RemoveRandomElement(hx);
                        hc.add(l);
                        hc["letter"] = l;
                        l["hexagon"] = hc;
                    }
                }
                updateHexagonsArrange() {
                    for (let hc of this.cars) {
                        if (!hc["letter"]) {
                            hc.parentContainer.bringToTop(hc);
                            break;
                        }
                    }
                }
                shuffleOutHexagons() {
                    this.createHexagons();

                    let setLettersInputEnabled = () => {
                        // if (this.correctAudio && this.correctAudio.isPlaying) {
                        // delayedCall(/* (this.correctAudio.duration * 0.75) *  */1000, () => {
                        this.setLettersInputEnabled(true);
                        // });
                        // }
                        // else {
                        // this.setLettersInputEnabled(true);
                        // }
                    };

                    if (this.gameplay.currentRound === 0 && this.gameplay.isCorrectLetterAudioQuestionEnable()) {
                        var snd = this.scene.sound.add("englQuestion");
                        snd.play();
                        snd.once('complete', setLettersInputEnabled);
                    } else {
                        setLettersInputEnabled();
                    }

                    if (this.sfxCarAccelerating) {
                        this.sfxCarAccelerating.stop();
                        this.sfxCarAccelerating = null;
                    }
                    if (this.sfxWrong) {
                        this.sfxWrong.stop();
                        this.sfxWrong = null;
                    }

                    if (!this.gameplay.isRoundsComplete()) {
                        this.createLetters();
                        this.randomizeLettersPosition();
                    }

                    // this.setLettersInputEnabled(false);
                    this.updateHexagonsArrange();
                    // Phaser.Utils.Array.Shuffle(this.carsPositions);
                    let cars = this.cars;
                    for (let i = 0; i < cars.length; i++) {
                        let hc = cars[i];
                        hc["defX"] = this.carsPositions[i]["x"];
                        hc["defY"] = this.carsPositions[i]["y"];

                        hc["Correct Box"].visible = hc["Wrong Box"].visible = false;
                        hc.x = hc["defX"];
                        hc.y = hc["defY"];

                        /* this.scene.tweens.add({
                            targets: this.ship,
                            "y": this.ship.y - 10,
                            scaleX: 0.95,
                            scaleY: 0.95,
                            duration: 1500,
                            onComplete: () => {},
                            yoyo: true
                        }); */
                    }
                    for (let c of cars) this.gameplayContentContainer.remove(c);
                    this.cars.sort((c1, c2) => c1.y - c2.y);
                    // for (let c of cars) this.gameplayContentContainer.add(c);

                    this.createInput();
                }
                shuffleInHexagons() {
                    this.updateHexagonsArrange();
                    let positions = this.carsPositions.slice();
                    this.setLettersInputEnabled(false);

                    // delayedCall(600, () => {
                    // this.scene.sound.add('move to centre').play();
                    this.shuffleOutHexagons();
                    // });
                }
                createInput() {
                    for (let hc of this.cars) {
                        let correctAnswer = hc["letter"] && hc["letter"]["key"] == this.gameplay.getCorrectLetterName();
                        //hc["letter"].alpha = correctAnswer ? 1 : 0.5;
                        hc["bg"].on('pointerup', () => {
                            if (hc["Wrong Box"].visible) return;
                            this.scene.sound.add('Click on the answer').play();

                            // this.playBtnClickAnim(hc);
                            let lost = false;
                            if (correctAnswer) {
                                let completed = this.onCorrectAnswer();

                                let angle = 0;
                                if (Math.abs(this.ship.x - hc.x) > 50) angle = hc['index'] == 0 ? -10 : (hc['index'] == 2 ? 10 : 0);
                                let __x = hc['index'] == 0 ? 200 : (hc['index'] == 2 ? 755 : 484 - 12);

                                let fn = () => {
                                    for (let l of this.letters) l.visible = false;

                                    let _fn = () => {
                                        sh.scene.Preloader.playAnim('kangaroo-idle', this.ship);
                                        this.ship.setOrigin(0.5, 0.5);
                                        if (!completed) {
                                            this.shuffleInHexagons();
                                        } else {
                                            /* this.scene.tweens.add({
                                                targets: this.gameplayContentContainer,
                                                y: 0,//-this.ROWS_DY,
                                                duration: 700,
                                                delay: completed ? 500 : 100
                                            }); */

                                            this.ship.y -= 372;
                                            sh.scene.Preloader.playAnim('kangaroo-jump', this.ship);
                                            delayedCall(775, () => {
                                                this.scene.sound.add('Kangaroo landing sfx').play();
                                            });
                                            // this.ship.setOrigin(0.5, 0.8);

                                            this.scene.tweens.add({
                                                targets: this.ship,
                                                duration: 500,
                                                x: 484 - 12,
                                                delay: 400
                                            });

                                            if (Math.abs(this.ship.x - (484 - 12)) > 50) this.scene.tweens.add({
                                                targets: this.ship,
                                                duration: 250,
                                                angle: this.ship.x > (484 - 12) ? -12 : 12,
                                                delay: 400,
                                                yoyo: true
                                            });

                                            this.scene.tweens.add({
                                                targets: this.contentContainer,
                                                y: this.contentContainer.y + this.ROWS_DY,
                                                duration: 650,
                                                delay: 450
                                            });

                                            this.scene.tweens.add({
                                                targets: this._bgContainer,
                                                y: this._bgContainer.y + this.ROWS_DY,
                                                duration: 650,
                                                delay: 450
                                            });

                                            delayedCall(1000, () => {
                                                this.scene.sound.add('Final celebration').play();
                                            });

                                            // this.ship.setOrigin(0.5, 0.8);
                                            /* this.scene.tweens.add({
                                                targets: this.ship,
                                                duration: 400,
                                                x: 484-12,
                                                delay: 300
                                            }); */
                                        }
                                    };

                                    sh.scene.Preloader.playAnim('kangaroo-jump', this.ship);

                                    delayedCall(1125, () => _fn(0));

                                    delayedCall(775, () => {
                                        this.scene.sound.add('Kangaroo landing sfx').play();
                                    });

                                    // this.ship.setOrigin(0.5, 0.8);
                                    this.scene.tweens.add({
                                        targets: this.ship,
                                        duration: 500,
                                        x: __x,
                                        delay: 400
                                    });

                                    this.scene.tweens.add({
                                        targets: this.ship,
                                        duration: 250,
                                        angle: angle,
                                        delay: 400,
                                        yoyo: true
                                    });

                                    // if (!completed) {
                                    this.scene.tweens.add({
                                        targets: this.contentContainer,
                                        y: this.contentContainer.y + this.ROWS_DY,
                                        duration: 650,
                                        delay: 450
                                    });

                                    this.scene.tweens.add({
                                        targets: this._bgContainer,
                                        y: this._bgContainer.y + this.ROWS_DY,
                                        duration: 650,
                                        delay: 450
                                    });

                                    /* let additionalDY = this.gameplay.correctAnswersCount === this.gameplay.numberOfRounds ? -70 : 0;
                                    if (this.gameplay.correctAnswersCount > (this.gameplay.numberOfRounds - 1)) this.scene.tweens.add({
                                        targets: this._gameStage,
                                        y: this._gameStage.y + this.ROWS_DY + additionalDY,
                                        duration: 650,
                                        delay: 250
                                    }); */
                                    // }
                                };
                                delayedCall(completed ? 250 : 500, fn);

                                /* }
                            }); */

                                this.setLettersInputEnabled(false);
                                hc["Wrong Box"].visible = false;
                                hc["Correct Box"].visible = true;
                                /* for (let hc of this.cars) {
                                    this.scene.tweens.add({
                                        targets: hc["raceTween"],
                                        "timeScale": hc["Correct Box"].visible ? 4 : 2.75,
                                        duration: 400
                                    });
                                } */

                                // delayedCall(500, () => {
                                //     if (!this.gameplay.isNewRound()) {
                                //         if (this.gameplay.isCorrectLetterAudioQuestionEnable()) {
                                //             this.playCorrectAudio();
                                //         }
                                //     }
                                // });
                            }
                            else {
                                hc["Wrong Box"].visible = true;
                                hc["Correct Box"].visible = false;
                                lost = this.onWrongAnswer();
                                if (!lost) {
                                    // this.shuffleInHexagons();
                                } else {
                                    this.isLost = true;
                                }
                            }
                        });
                    }
                    this._btnSound.on('pointerup', () => {
                        this.playBtnClickAnim(this._btnSound);
                        this.onSoundClick();
                    });
                    this._btnClose.on('pointerup', () => {
                        this.playBtnClickAnim(this._btnClose);
                        this.onCloseClick();
                    });
                }
                hideAllUnusedBeehives() {
                    let i = this.gameplay.getCurrentTotalAnswersCount();
                    for (let k = i + 1; k < this._BeehiveEmptyArray.length; k++) {
                        this._BeehiveEmptyArray[k].visible = false;
                        this._Beehive[k].visible = false;
                    }
                }
                onCorrectAnswer() {
                    let i = this.gameplay.getCurrentTotalAnswersCount();
                    if (i < this._BeehiveEmptyArray.length) {
                        this._BeehiveEmptyArray[i].visible = false;
                        this._Beehive[i].visible = true;
                    }
                    this.hideAllUnusedBeehives();
                    let completed = this.gameplay.onCorrectAnswer();

                    // delayedCall(150, () => {
                    this.scene.sound.add('Correct sfx').play();
                    // });

                    // this.sfxCarAccelerating = this.scene.sound.add('Car accelerating');
                    // this.sfxCarAccelerating.play();
                    // delayedCall(250, () => {
                    //     this.scene.sound.add(this.gameplay.getCorrectAndLetterSoundSfxAudioKey()).play();
                    // });
                    return completed;
                }
                onWrongAnswer(forceNewRound) {
                    let i = this.gameplay.getCurrentTotalAnswersCount();
                    if (i < this._BeehiveEmptyArray.length) {
                        this._BeehiveEmptyArray[i].visible = true;
                        this._Beehive[i].visible = false;
                    }
                    this.hideAllUnusedBeehives();
                    let lost = this.gameplay.onWrongAnswer(forceNewRound);

                    // delayedCall(150, () => {
                    this.sfxWrong = this.scene.sound.add("wrong sfx");
                    this.sfxWrong.play();
                    // });

                    return lost;
                }
                playCorrectAudio() {
                    if (this.correctAudio) {
                        this.correctAudio.stop();
                    }
                    this.correctAudio = this.scene.sound.add(this.gameplay.getCorrectAudioKey());
                    this.correctAudio.play();
                    if (this.areYouSureWindow && this.areYouSureWindow.parentContainer == this) {
                        this.correctAudio.pause();
                    }
                }
                onSoundClick() {
                    this.playCorrectAudio();
                }
                onCloseClick() {
                    this.showAreYouSurePage();
                    this.scene.sound.add('warning page pop up sfx').play();
                }
                playBtnClickAnim(target) {
                    let sc = target["defScale"] ? target["defScale"] : 1;
                    target.scaleX = target.scaleY = sc;
                    this.scene.tweens.add({
                        targets: target,
                        "scaleX": 0.9 * sc,
                        "scaleY": 0.9 * sc,
                        duration: 100,
                        yoyo: true
                    });
                }
                showInstructionPage() {
                    setPageBackground("bg-blue");
                    this.instructionPage = new screen.InstructionPage(this.scene, (target) => {
                        this.playBtnClickAnim(target);
                        this.remove(this.instructionPage);
                        this.showGameplay();
                        if (this.wfsnd) {
                            this.wfsnd.stop();
                        }
                    }, (target) => {
                        this.playBtnClickAnim(target);
                        if (this.wfsnd) {
                            this.wfsnd.stop();
                        }
                        if (!game.cache.json.get('gameplay')['welcomeAudioDisabled']) {
                            this.wfsnd = this.scene.sound.add("Welcome Find the sound");
                            this.wfsnd.play();
                        }
                    });
                    this.add(this.instructionPage);
                    try {
                        if (!game.cache.json.get('gameplay')['welcomeAudioDisabled']) {
                            this.wfsnd = this.scene.sound.add("Welcome Find the sound");
                            this.wfsnd.play();
                        }
                    }
                    catch (e) {
                        console.error(e);
                    }
                }
                showAreYouSurePage() {
                    /* for (let j = 0; j < this.cars.length; j++) {
                        if (this.cars[j]["raceTween"]) {
                            this.cars[j]["raceTween"].pause();
                        }
                    } */

                    pauseAllDelayedCalls();
                    setPageBackground("bg-blue");
                    this.pauseSounds();
                    if (!this.areYouSureWindow) this.areYouSureWindow = new screen.AreYouSureWindow(this.scene, () => {
                        this.remove(this.areYouSureWindow);
                        this.destroyGameplay();
                        this.showInstructionPage();
                    }, () => {
                        this.remove(this.areYouSureWindow);
                        this.unpauseSounds();
                        resumeAllDelayedCalls();

                        /* for (let j = 0; j < this.cars.length; j++) {
                            if (this.cars[j]["raceTween"]) {
                                this.cars[j]["raceTween"].resume();
                            }
                        } */

                        setPageBackground("bg-australia");
                    });
                    this.add(this.areYouSureWindow);
                }
                setLettersInputEnabled(enabled) {
                    if (enabled) {
                        for (let hc of this.cars) {
                            hc["bg"].setInteractive({ cursor: 'pointer' });
                        }
                    }
                    else {
                        for (let hc of this.cars) {
                            hc["bg"].disableInteractive();
                        }
                    }
                }
                pauseSounds() {
                    if (this.correctAudio)
                        this.correctAudio.pause();
                    if (this.bgMusic)
                        this.bgMusic.pause();
                }
                unpauseSounds() {
                    if (this.correctAudio)
                        this.correctAudio.resume();
                    if (this.bgMusic)
                        this.bgMusic.resume();
                }
                destroyGameplay() {
                    this.ship = null;
                    this.contentContainer = null;
                    this._gameStage.y = 0;
                    this.setLettersInputEnabled(false);
                    this.remove(this.gameplayContainer);
                    this.scene.sound.stopAll();
                    destroyAllDelayedCalls();
                }
            }
            screen.GameplayScreen = GameplayScreen;
        })(screen = sh.screen || (sh.screen = {}));
    })(sh || (sh = {}));
    (function (sh) {
        var screen;
        (function (screen) {
            class InstructionPage extends Phaser.GameObjects.Container {
                constructor(scene, onPlayClick, onSndClick) {
                    super(scene);
                    this._instructionPage = new Phaser.GameObjects.Image(this.scene, 0 - 105, 0 - 48, 'Instructions page  ALL ACTIVITY  TITLEs');
                    this._instructionPage.setOrigin(0, 0);
                    this._instructionPage.setInteractive();

                    this._instructionPageTitle = this.scene.add.text(475, 110, sh.App.json.instructionTitle ?? 'Find the way', {
                        "fontFamily": "Kids Rock DEMO",
                        "fontSize": 45,
                        "color": "#43425D",
                        "align": 'center'
                    });
                    this._instructionPageTitle.setOrigin(0.5, 0.5);
                    window['this._instructionPageTitle'] = this._instructionPageTitle;
                    this._instructionPageTitle.setStroke('#ffffff', 5);
                    //  Apply the gradient fill.
                    const gradient = this._instructionPageTitle.context.createLinearGradient(0, 0, 0, this._instructionPageTitle.height);
                    gradient.addColorStop(0, '#eeef67');
                    gradient.addColorStop(0.55, '#e98c2c');
                    gradient.addColorStop(1, '#91301a');
                    this._instructionPageTitle.setFill(gradient);

                    this._btnPlay = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2, 480 - 50, 'btnPLAY1');
                    this._btnPlay.setInteractive({ cursor: 'pointer' });
                    this._btnPlay.once('pointerup', onPlayClick);
                    setupButtonTextureBased(this._btnPlay, 'btnPLAY1', 'btnPLAY2');
                    this.instrTxt = this.scene.add.text(game.scale.width / 2 + 5, game.scale.height / 2, sh.App.json.instructionDescription ?? "Help Arab Kangaroo find his way out of the mud", {
                        "fontFamily": "Kids Rock DEMO",
                        "fontSize": 25,
                        "color": "#43425D",
                        "align": 'center'
                    });
                    this.instrTxt.setOrigin(0.5, 0.5);
                    this._btnSoundInstruction = new Phaser.GameObjects.Image(this.scene, 800 - 105, 156 - 50, 'Sound');
                    this._btnSoundInstruction.setInteractive({ cursor: 'pointer' });
                    this._btnSoundInstruction.on('pointerup', onSndClick);
                    this._btnSoundInstruction["defScale"] = this._btnSoundInstruction.scale;
                    setupButtonTextureBased(this._btnSoundInstruction, 'Sound', 'Sound HOVER EFFECT');
                    this.add(this._instructionPage);
                    this.add(this._instructionPageTitle);
                    this.add(this.instrTxt);
                    this.add(this._btnPlay);
                    this.add(this._btnSoundInstruction);
                }
            }
            screen.InstructionPage = InstructionPage;
        })(screen = sh.screen || (sh.screen = {}));
    })(sh || (sh = {}));
    (function (sh) {
        var screen;
        (function (screen) {
            class TryAgainWindow extends Phaser.GameObjects.Container {
                constructor(scene, onBack, onReplay) {
                    super(scene);
                    this.music = null;
                    this.setPosition(-106, -48);
                    this._bg = new Phaser.GameObjects.Image(this.scene, 0, 0, 'Try again page');
                    this._bg.setOrigin(0, 0);
                    this._bg.setInteractive();
                    this._star = new Phaser.GameObjects.Image(this.scene, 400, 415, 'Break Star');
                    this._btnBack = new Phaser.GameObjects.Image(this.scene, 600, 580, 'btnBACK1');
                    this._btnReplay = new Phaser.GameObjects.Image(this.scene, 765, 580, 'btnReplay1');
                    this.totalScoreTxt = this.scene.add.text(850, 355, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 35,
                        "color": "#F49F1C",
                        "align": 'center',
                        'stroke': '#70451A',
                        'strokeThickness': 6
                    });
                    this.totalScoreTxt.setOrigin(0.5, 0.5);
                    let grd = this.totalScoreTxt.context.createLinearGradient(0, 0, 0, this.totalScoreTxt.height);
                    grd.addColorStop(0, '#FFFF00');
                    grd.addColorStop(1, '#C17316');
                    this.totalScoreTxt.setFill(grd);
                    this.starScoreTxt = this.scene.add.text(635, 431, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 24,
                        "color": "#FFFFFF",
                        "align": 'center'
                    });
                    this.starScoreTxt.setOrigin(0.5, 0.5);
                    this.add([
                        this._bg,
                        this._star,
                        this._btnBack,
                        this._btnReplay,
                        this.totalScoreTxt,
                        this.starScoreTxt
                    ]);
                    this._btnBack.setInteractive({ cursor: 'pointer' });
                    this._btnBack.on('pointerup', () => {
                        onBack(this._btnBack);
                        angularComponentRef.backToMenu();
                        // if (this.music) {
                        //     this.music.stop();
                        // }
                    });
                    setupButtonTextureBased(this._btnBack, 'btnBACK1', 'btnBACK2');
                    this._btnReplay.setInteractive({ cursor: 'pointer' });
                    this._btnReplay.once('pointerup', () => {
                        onReplay(this._btnReplay);
                        if (this.music) {
                            this.music.stop();
                        }
                    });
                    setupButtonTextureBased(this._btnReplay, 'btnReplay1', 'btnReplay2');
                }
                show(score, starScore) {
                    this._star.scale = 1.25;
                    this.scene.tweens.add({
                        targets: this._star,
                        "scale": 1,
                        duration: 500,
                        ease: Phaser.Math.Easing.Back.Out
                    });
                    this.totalScoreTxt.text = '';//String(window.angularComponentRef.component.userInfo.totalScore);
                    this.starScoreTxt.text = String(0);
                    this.music = this.scene.sound.add("Fail - close one");
                    this.music.play();
                }
            }
            screen.TryAgainWindow = TryAgainWindow;
        })(screen = sh.screen || (sh.screen = {}));
    })(sh || (sh = {}));
}

function destroyFindTheWay() {
    if (game) {
        game.destroy();
    }
}

var game;
var sh;
function castleGame(json) {
    /**
     * @author Roman Parada
     * This class is created to fix overlapping of bottom part of canvas by navigation bar in iOS.
     * It make a delayed resize of the canvas (like Phaser-3 FIT methods does) and it overrides Phaser-3 input window to Phaser-3 core transform methods
     *
     * How to use:
     * Just call the code line below in Boot scene's init() method of your project:
     * new FitScaleManager(this.game).setup();
     */
    class FitScaleManager {
        constructor(game) {
            this.doResize = () => {
                let scale = this.calculateScale();
                let newCanvasWidth = this.phaserScaleManager.width * scale;
                let newCanvasHeight = this.phaserScaleManager.height * scale;
                this.canvasStyle.width = newCanvasWidth + 'px';
                this.canvasStyle.height = newCanvasHeight + 'px';
                this.canvasStyle.marginLeft = (window.innerWidth - newCanvasWidth) / 2 + 'px';
                this.canvasStyle.marginTop = (window.innerHeight - newCanvasHeight) / 2 + 'px';
            };
            this.game = game;
            this.canvasStyle = this.game.canvas.style;
            this.phaserScaleManager = this.game.scale;
        }
        static detectBestScaleMode() {
            let iOS = /iPad|iPhone|iPod/.test(navigator.platform || "");
            let isAndroid = window.navigator.userAgent.toLowerCase().indexOf("android") > -1;
            return iOS || isAndroid ? Phaser.Scale.FIT : Phaser.Scale.NONE;
        }
        ;
        /**
         * Just call this method once in Boot scene's init() method
         */
        setup() {
            this.phaserScaleManager.addListener(Phaser.Scale.Events.RESIZE, this.onResize, this);
            this.overridePhaserTransformMethods();
            this.onResize();
        }
        calculateScale() {
            if (game.scale.scaleMode === Phaser.Scale.NONE)
                return 1;
            return Math.min(window.innerWidth / this.phaserScaleManager.width, window.innerHeight / this.phaserScaleManager.height);
        }
        overridePhaserTransformMethods() {
            this.game.scale.transformX = (pageX) => {
                return (pageX - parseInt(this.canvasStyle.marginLeft.split("px")[0])) / this.calculateScale();
            };
            this.game.scale.transformY = (pageY) => {
                return (pageY - parseInt(this.canvasStyle.marginTop.split("px")[0])) / this.calculateScale();
            };
        }
        onResize() {
            setTimeout(this.doResize, FitScaleManager.RESIZE_DELAY);
        }
    }
    FitScaleManager.RESIZE_DELAY = 500;

    (function (sh) {
        class App extends Phaser.Game {
            constructor(json) {
                App.json = json;
                // console.log(App.json);

                let config = {
                    type: Phaser.AUTO,
                    width: App.CANVAS_WIDTH,
                    height: App.CANVAS_HEIGHT,
                    parent: 'game-container',
                    dom: {
                        createContainer: false
                    },
                    scale: {
                        mode: FitScaleManager.detectBestScaleMode(),
                        autoCenter: Phaser.Scale.CENTER_BOTH
                    },
                    transparent: true,
                    scene: {
                        create: () => {
                            this.scene.add('Boot', sh.scene.Boot, true);
                        }
                    }
                };
                super(config);
            }
        }
        App.CANVAS_WIDTH = 980;
        App.CANVAS_HEIGHT = 600;
        sh.App = App;
    })(sh || (sh = {}));

    game = new sh.App(json);

    var delayedCalls = [];
    function delayedCall(delay, callback, args, callbackScope) {
        let scene = game.scene.getAt(0);
        if (scene) {
            let dc = scene.time.delayedCall(delay, callback, args, callbackScope);
            delayedCalls.push(dc);
            return dc;
        }
        let t = setTimeout(callback, delay);
        delayedCalls.push(t);
        return t;
    }

    function pauseAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.paused = true;
            }
        }
    }

    function resumeAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.paused = false;
            }
        }
    }

    function destroyAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.remove(false);
            }
            else {
                clearTimeout(dc);
            }
        }
        delayedCalls = [];
    }

    function setPageBackground(bg) {
        // document.querySelector("html").style.backgroundImage = "url(assets/games/castle/imgs/" + bg + ".jpg)";
    }

    function setupButton(btn, frame) {
        btn.on('pointerdown', () => { btn.setFrame(frame + '_hover' + '0000'); });
        btn.on('pointerover', () => { btn.setFrame(frame + '_hover' + '0000'); game.scene.getAt(0).sound.add("button hover").play(); });
        btn.on('pointerout', () => { btn.setFrame(frame + '0000'); });
        btn.on('pointerup', () => { btn.setFrame(frame + '0000'); game.scene.getAt(0).sound.add('activity selection - button selection').play(); });
    }

    function setupButtonTextureBased(btn, texture, hoverTexture, downTexture) {
        btn.on('pointerdown', () => { btn.setTexture(downTexture ?? hoverTexture); });
        btn.on('pointerover', () => { btn.setTexture(hoverTexture); game.scene.getAt(0).sound.add("button hover").play(); });
        btn.on('pointerout', () => { btn.setTexture(texture); });
        btn.on('pointerup', () => { btn.setTexture(texture); game.scene.getAt(0).sound.add('activity selection - button selection').play(); });
    }

    (function (sh) {
        var core;
        (function (core) {
            class Gameplay {
                constructor() {
                    this.currentRound = 0;
                    this.currentLetter = 0;
                    this.correctAnswersCount = 0;
                    this.wrongAnswersCount = 0;
                    this.correctAnswersCountThisRound = 0;
                    this.wrongAnswersCountThisRound = 0;
                    this.reset();
                    let json = game.cache.json.get('gameplay');
                    this.wrongAnswersToLose = json["wrongAnswersToLose"];
                    this.numberOfQuestionsPerRound = json["numberOfQuestionsPerRound"];
                    this.lettersConfig = JSON.parse(JSON.stringify(json["lettersConfig"]));
                    this.rounds = JSON.parse(JSON.stringify(json["rounds"]));
                    this.numberOfRounds = json["numberOfRounds"] ?? this.rounds.length;
                    this.useImages = Boolean(game.cache.json.get('gameplay')["useImages"]);
                }
                setupCallbacks(onComplete, onLose) {
                    this.onComplete = onComplete;
                    this.onLose = onLose;
                }
                onLetterChosen(forceNewRound) {
                    if (forceNewRound || this.isNewRound()) {
                        return this.nextRound();
                    }
                    return false;
                }
                nextRound() {
                    this.correctAnswersCountThisRound = 0;
                    this.wrongAnswersCountThisRound = 0;
                    this.currentRound++;
                    if (this.isRoundsComplete()) {
                        this.onComplete(this.correctAnswersCount, this.correctAnswersCount);
                        return true;
                    }

                    return false;
                }
                getCorrectLetterName() {
                    return this.rounds[this.currentRound]['correctLetterName'];
                }
                isCorrectLetterAudioQuestionEnable() {
                    return this.rounds[this.currentRound]['audioQuestionEnable'];
                }
                getCorrectAudioKey() {
                    return this.lettersConfig[this.getCorrectLetterName()]['correctAudioKey'];
                }
                getLetterSoundSfxAudioKey(letter) {
                    return "Q-" + letter;
                }
                getCorrectAndLetterSoundSfxAudioKey() {
                    return "Q-" + this.getCorrectLetterName();
                }
                onCorrectAnswer() {
                    this.correctAnswersCountThisRound++;
                    this.correctAnswersCount++;
                    return this.onLetterChosen();
                }
                onWrongAnswer(forceNewRound) {
                    this.wrongAnswersCountThisRound++;
                    this.wrongAnswersCount++;
                    if (this.wrongAnswersCount >= this.wrongAnswersToLose) {
                        this.onLose(this.correctAnswersCount, this.correctAnswersCount);
                        return true;
                    }
                    else {
                        this.onLetterChosen(forceNewRound);
                    }
                    return false;
                }

                getMaxTotalAnswersCount() {
                    return this.wrongAnswersToLose + this.numberOfRounds - 1;
                }

                getCurrentTotalAnswersCount() {
                    return this.correctAnswersCount + this.wrongAnswersCount;
                }
                isNewRound() {
                    return this.correctAnswersCountThisRound >= 1 || (this.correctAnswersCountThisRound + this.wrongAnswersCountThisRound) === 3 || (this.correctAnswersCountThisRound + this.wrongAnswersCountThisRound) === 0;
                }
                isRoundsComplete() {
                    return this.currentRound >= this.numberOfRounds && this.wrongAnswersCount < this.wrongAnswersToLose;
                }
                reset() {
                    this.currentRound = 0;
                    this.correctAnswersCount = 0;
                    this.wrongAnswersCount = 0;
                }
                getCurrentRoundLetters() {
                    return this.rounds[this.currentRound]["letters"];
                }
            }
            core.Gameplay = Gameplay;
        })(core = sh.core || (sh.core = {}));
    })(sh || (sh = {}));

    (function (sh) {
        var scene;
        (function (scene) {
            class Boot extends Phaser.Scene {
                init() {
                    this.game.scale.transformX = (pageX) => {
                        let offsetLeft = 0;
                        let parentElement = game.canvas.parentElement;
                        while (parentElement) {
                            if (parentElement.offsetLeft) {
                                offsetLeft = parentElement.offsetLeft;
                                break;
                            }
                            parentElement = parentElement.parentElement;
                        }
                        return (pageX - offsetLeft) * this.game.scale.displayScale.x;
                    };
                    this.game.scale.transformY = (pageY) => {
                        let offsetTop = 0;
                        let parentElement = game.canvas.parentElement;
                        while (parentElement) {
                            if (parentElement.offsetTop) {
                                offsetTop = parentElement.offsetTop;
                                break;
                            }
                            parentElement = parentElement.parentElement;
                        }
                        return (pageY - offsetTop) * this.game.scale.displayScale.y;
                    };
                }
                create() {
                    game.scene.remove('Boot');
                    game.scene.add('Preloader', sh.scene.Preloader, true);
                }
            }
            scene.Boot = Boot;
        })(scene = sh.scene || (sh.scene = {}));
    })(sh || (sh = {}));

    (function (sh) {
        var scene;
        (function (scene) {
            var Gameplay = sh.core.Gameplay;
            class MainScene extends Phaser.Scene {
                create() {
                    this.gameplay = new Gameplay();
                    this.gameplayScreen = new sh.screen.GameplayScreen(this, this.gameplay);
                    this.children.add(this.gameplayScreen);
                    this.gameplayScreen.showInstructionPage();
                }
            }
            scene.MainScene = MainScene;
        })(scene = sh.scene || (sh.scene = {}));
    })(sh || (sh = {}));

    (function (sh) {
        var scene;
        (function (scene) {
            class Preloader extends Phaser.Scene {
                preload() {
                    if (typeof sh.App.json == "string") this.load.json('gameplay', sh.App.json); else this.game.cache.json.add('gameplay', sh.App.json);
                }
                create() {
                    let json = game.cache.json.get('gameplay');
                    let lettersConfig = json["lettersConfig"];

                    let rounds = json["rounds"];

                    for (let letterName in lettersConfig) {
                        if (json["useImages"]) this.load.image(letterName, "assets/games/castle/imgs/letters/" + letterName + ".png");
                    }

                    for (var i = 0; i < rounds.length; i++) {
                        var letters = rounds[i]['letters'];

                        for (var a = 0; a < letters.length; a++) {
                            var letter = letters[a];
                            this.load.audio(letter, "assets/games/castle/sound/mp3/letters/" + letter + ".mp3");
                            this.load.audio("Q-" + letter, "assets/games/castle/sound/mp3/letters/Sounds of the letters/" + letter + ".mp3");
                        }
                    }

                    let progressTxt = this.add.text(game.scale.width / 2, game.scale.height / 2 + 50, "", {
                        "fontFamily": "QuranErafont",
                        "fontSize": 25,
                        "color": "#333333",
                        "align": 'center'
                    });

                    progressTxt.setOrigin(0.5, 0.5);
                    this.load.pack('preloader', 'assets/games/castle/pack.json');
                    this.load.on('progress', (value) => {
                        progressTxt.text = Math.ceil(value * 100) + "%";
                    }, this);

                    this.load.on('complete', () => {
                        this.nextScene();
                    });

                    this.load.start();
                }
                static playAnim(animKey, sprite, onComplete = null) {
                    let mainScene = game.scene.getScene('ScreenMain');
                    let data = Preloader.ANIMS_DATA[animKey];
                    if (!mainScene.anims.exists(animKey)) {
                        mainScene.anims.create({
                            key: animKey,
                            frames: mainScene.anims.generateFrameNames(data['atlas'], {
                                start: data['start'], end: data['end'], zeroPad: data['padNum'],
                                prefix: data['prefix'], suffix: ''
                            }),
                            frameRate: data['frameRate'],
                            repeat: data['repeat']
                        });
                    }
                    if (sprite.anims.currentAnim) {
                        sprite.anims.currentAnim.off('complete');
                    }
                    sprite.anims.stop();
                    // sprite.setTexture(data['atlas']);
                    sprite.play(animKey);
                    sprite.anims.currentAnim.once('complete', () => {
                        if (onComplete)
                            onComplete();
                    });
                    return sprite;
                }
                nextScene() {
                    game.scene.remove('Preloader');
                    game.scene.add('ScreenMain', sh.scene.MainScene, true);
                }
            }
            Preloader.ANIMS_DATA = {
                'chestClosed': {
                    'start': 0,
                    'end': 0,
                    'padNum': 2,
                    'prefix': 'Treasure opened_1',
                    'repeat': 0,
                    'frameRate': 24,
                    'atlas': 'chestOpen-atlas'
                },
                'chestOpen': {
                    'start': 0,
                    'end': 74,
                    'padNum': 2,
                    'prefix': 'Treasure opened_1',
                    'repeat': 0,
                    'frameRate': 24,
                    'atlas': 'chestOpen-atlas'
                },
                'chestOpened': {
                    'start': 74,
                    'end': 74,
                    'padNum': 2,
                    'prefix': 'Treasure opened_1',
                    'repeat': 0,
                    'frameRate': 24,
                    'atlas': 'chestOpen-atlas'
                },
                'gamesOpened': {
                    'start': 74,
                    'end': 74,
                    'padNum': 2,
                    'prefix': 'Gates Open _1',
                    'repeat': 0,
                    'frameRate': 24,
                    'atlas': 'gamesOpen-atlas'
                },
                'gamesOpen': {
                    'start': 0,
                    'end': 74,
                    'padNum': 2,
                    'prefix': 'Gates Open _1',
                    'repeat': 0,
                    'frameRate': 24,
                    'atlas': 'gamesOpen-atlas'
                },
                'gamesClosed': {
                    'start': 0,
                    'end': 0,
                    'padNum': 2,
                    'prefix': 'Gates Open _1',
                    'repeat': 0,
                    'frameRate': 24,
                    'atlas': 'gamesOpen-atlas'
                },
                'flame': {
                    'start': 0,
                    'end': 74,
                    'padNum': 2,
                    'prefix': 'Flame _1',
                    'repeat': -1,
                    'frameRate': 24,
                    'atlas': 'flame-atlas'
                }
            };
            scene.Preloader = Preloader;
        })(scene = sh.scene || (sh.scene = {}));
    })(sh || (sh = {}));
    (function (sh) {
        var screen;
        (function (screen) {
            class AreYouSureWindow extends Phaser.GameObjects.Container {
                constructor(scene, onYes, onNo) {
                    super(scene);
                    this._areYouSurePage = new Phaser.GameObjects.Image(this.scene, -105, 0 - 48, 'Exit warning');
                    this._areYouSurePage.setOrigin(0, 0);
                    this._areYouSurePage.setInteractive();
                    this._btnSureYes = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2 - 95, 485 - 50, 'btnYES1');
                    this._btnSureYes.setInteractive({ cursor: 'pointer' });
                    this._btnSureYes.on('pointerup', () => {
                        onYes;
                        angularComponentRef.backToMenu();
                    });
                    var modalTextStyle = {
                        backgroundColor: 'transparent',
                        stroke: '#ffffff',
                        strokeThickness: 2,
                        lineSpacing: 15,
                        fontFamily: 'Kids Rock DEMO',
                        fontSize: 27,
                        color: '#43425d',
                        wordWrap: true,
                        align: 'center'
                    };
                    var modalText = this.scene.add.text(game.scale.width / 2 + 12, game.scale.height / 2, "Your progress in this activity will not be saved. \n Are you sure you want to exit? ", modalTextStyle);
                    modalText.setOrigin(0.5, 0.5);

                    setupButtonTextureBased(this._btnSureYes, 'btnYES1', 'btnYES2');
                    this._btnSureNo = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2 + 95, 485 - 50, 'btnNO1');
                    this._btnSureNo.setInteractive({ cursor: 'pointer' });
                    this._btnSureNo.on('pointerup', onNo);
                    setupButtonTextureBased(this._btnSureNo, 'btnNO1', 'btnNO2');
                    this.add(this._areYouSurePage);
                    this.add(this._btnSureYes);
                    this.add(this._btnSureNo);
                    this.add(modalText);
                }
            }
            screen.AreYouSureWindow = AreYouSureWindow;
        })(screen = sh.screen || (sh.screen = {}));
    })(sh || (sh = {}));

    (function (sh) {
        var screen;
        (function (screen) {
            class CompleteWindow extends Phaser.GameObjects.Container {
                constructor(scene, onBack, onReplay, onNext) {
                    super(scene);
                    this.music = null;
                    this.setPosition(-104.5, -48);
                    this._bgComplete = new Phaser.GameObjects.Image(this.scene, 0, 0, 'Completion page LATEST UPDATED');
                    this._bgComplete.setOrigin(0, 0);
                    this._bgComplete.setInteractive();
                    this._cup = new Phaser.GameObjects.Image(this.scene, 400, 410, 'Trophy');
                    this._btnBack = new Phaser.GameObjects.Image(this.scene, 570, 570, 'btnBACK1');
                    this._btnReplay = new Phaser.GameObjects.Image(this.scene, 720, 570, 'btnReplay1');
                    this._btnNext = new Phaser.GameObjects.Image(this.scene, 870, 570, 'btnNEXT1');
                    let _CollectedPoints = new Phaser.GameObjects.Image(this.scene, 620, 440, 'Collected Points');
                    this.totalScoreTxt = this.scene.add.text(845, 352, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 35,
                        "color": "#F49F1C",
                        "align": 'center',
                        'stroke': '#70451A',
                        'strokeThickness': 6
                    });
                    this.totalScoreTxt.setOrigin(0.5, 0.5);
                    let grd = this.totalScoreTxt.context.createLinearGradient(0, 0, 0, this.totalScoreTxt.height);
                    grd.addColorStop(0, '#FFFF00');
                    grd.addColorStop(1, '#C17316');
                    this.totalScoreTxt.setFill(grd);
                    this.starScoreTxt = this.scene.add.text(648, 433, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 24,
                        "color": "#FFFFFF",
                        "align": 'center'
                    });
                    this.starScoreTxt.setOrigin(0.5, 0.5);
                    this.add([
                        this._bgComplete,
                        _CollectedPoints,
                        this._cup,
                        this._btnBack,
                        this._btnReplay,
                        this._btnNext,
                        this.totalScoreTxt,
                        this.starScoreTxt
                    ]);
                    this._btnBack.setInteractive({ cursor: 'pointer' });
                    this._btnBack.on('pointerup', () => {
                        onBack(this._btnBack);
                        angularComponentRef.backToMenu();
                        // if (this.music) {
                        //     this.music.stop();
                        // }
                    });
                    setupButtonTextureBased(this._btnBack, 'btnBACK1', 'btnBACK2');
                    this._btnReplay.setInteractive({ cursor: 'pointer' });
                    this._btnReplay.once('pointerup', () => {
                        onReplay(this._btnReplay);
                        if (this.music) {
                            this.music.stop();
                        }
                    });
                    setupButtonTextureBased(this._btnReplay, 'btnReplay1', 'btnReplay2');
                    this._btnNext.setInteractive({ cursor: 'pointer' });
                    this._btnNext.on('pointerup', () => {
                        onNext(this._btnNext);
                        window.angularComponentRef.nextActivity()
                    });
                    setupButtonTextureBased(this._btnNext, 'btnNEXT1', 'btnNEXT2');
                }
                show(score, starScore) {
                    window.angularComponentRef.gameFinish({ score, starScore })
                    this._cup.scale = 1.25;
                    this.scene.tweens.add({
                        targets: this._cup,
                        "scale": 1,
                        duration: 500,
                        ease: Phaser.Math.Easing.Back.Out
                    });
                    this.totalScoreTxt.text = String(window.angularComponentRef.component.userInfo.totalScore);
                    this.starScoreTxt.text = String(starScore);
                    // let music = this.scene.sound.add("viktory");
                    this.music = this.scene.sound.add("Activity completion fantastic");
                    this.music.play();
                }
            }
            screen.CompleteWindow = CompleteWindow;
        })(screen = sh.screen || (sh.screen = {}));
    })(sh || (sh = {}));

    (function (sh) {
        var screen;
        (function (screen) {
            class GameplayScreen extends Phaser.GameObjects.Container {
                constructor(scene, gameplay) {
                    super(scene);
                    this.carsPositions = [{ x: 198, y: 595 }, { x: 490, y: 595 }, { x: 790, y: 595 }];
                    this.bgMusic = null;
                    this.correctAudio = null;
                    this.wfsnd = null;
                    this.showCompleteWindow = (score, starScore) => {
                        let completeWindow = new screen.CompleteWindow(this.scene, (target) => {
                            this.playBtnClickAnim(target);
                        }, (target) => {
                            this.playBtnClickAnim(target);
                            this.destroyGameplay();
                            this.remove(completeWindow);
                            this.showInstructionPage();
                        }, (target) => {
                            this.playBtnClickAnim(target);
                        });
                        this.setLettersInputEnabled(false);
                        delayedCall(8000, () => {
                            setPageBackground("bg-blue");
                            this.add(completeWindow);
                            completeWindow.show(score, starScore);
                            if (this.bgMusic) this.bgMusic.stop();
                        });
                    };
                    this.showLoseWindow = (score, starScore) => {
                        let tryAgainWindow = new screen.TryAgainWindow(this.scene, (target) => {
                            this.playBtnClickAnim(target);
                        }, (target) => {
                            this.playBtnClickAnim(target);
                            this.destroyGameplay();
                            this.remove(tryAgainWindow);
                            this.showInstructionPage();
                        });
                        this.setLettersInputEnabled(false);
                        delayedCall(2500, () => {
                            setPageBackground("bg-blue");
                            this.add(tryAgainWindow);
                            tryAgainWindow.show(score, starScore);
                            if (this.bgMusic) this.bgMusic.stop();
                        });
                    };
                    this.gameplay = gameplay;
                    window["t"] = this;
                }
                createHexagons() {
                    if (this.bgContainer) {
                        this.gameplayContainer.remove(this.bgContainer);
                    }
                    this.bgContainer = new Phaser.GameObjects.Container(this.scene);

                    let prev_gameStageBack = this._gameStageBack;

                    this._gameStageBack = new Phaser.GameObjects.Image(this.scene, 491, 350, this.gameplay.currentRound >= this.gameplay.numberOfRounds - 1/*2*/ ? '_gameStageBackBright' : '_gameStageBack');     //bg
                    this._gameStageBack.setScale(0.5, 0.5);
                    this._gameStageBack.setOrigin(0.5, 0.5);
                    this.bgContainer.add(this._gameStageBack);
                    window['this._gameStageBack'] = this._gameStageBack;
                    this._gameStageBack.alpha = 0;

                    if (prev_gameStageBack) {
                        prev_gameStageBack.setPosition(game.scale.width / 2, game.scale.height / 2);
                        prev_gameStageBack.setScale(1, 1);
                        this.bgContainer.add(prev_gameStageBack);
                        window['prev_gameStageBack'] = prev_gameStageBack;
                        this.scene.tweens.add({
                            targets: prev_gameStageBack,
                            alpha: 0,
                            duration: 250,
                            // delay: 200 + _k*250,
                            onComplete: () => {
                                this.bgContainer.remove(prev_gameStageBack);
                            }
                        });

                        this._gameStage = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2, game.scale.height / 2, this.gameplay.currentRound >= this.gameplay.numberOfRounds - 1 ? 'bgBright' : 'bgDark');
                        window['this._gameStage'] = this._gameStage;
                        this._gameStage.setOrigin(0.5, 0.5);
                        this._gameStage.setInteractive();
                        // this._gameStage.alpha = 0;
                        /* this.scene.tweens.add({
                            targets: this._gameStage,
                            alpha: 1,
                            duration: 250,
                            // delay: 200 + _k*250,
                            onComplete: ()=>{
                                // this.bgContainer.remove(prev_gameStageBack);
                            }
                        }); */
                        this.bgContainer.add(this._gameStage);
                    } else {
                        this._gameStage = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2, game.scale.height / 2, this.gameplay.currentRound >= this.gameplay.numberOfRounds - 1 ? 'bgBright' : 'bgDark');
                        window['this._gameStage'] = this._gameStage;
                        this._gameStage.setOrigin(0.5, 0.5);
                        this._gameStage.setInteractive();
                        this.bgContainer.add(this._gameStage);
                    }
                    this._gameStage.setScale(1.01, 1);
                    this.gameplayContainer.addAt([
                        this.bgContainer
                    ], 0);

                    if (this.contentContainer && this.contentContainer.parentContainer) {
                        this.contentContainer.parentContainer.remove(this.contentContainer);
                    }
                    this.contentContainer = new Phaser.GameObjects.Container(this.scene, 0, 0);
                    this.gameplayContainer.add(this.contentContainer);
                    window['this.contentContainer'] = this.contentContainer;

                    this.gate = this.scene.add.sprite(490, 300, 'gamesOpen-atlas');
                    sh.scene.Preloader.playAnim('gamesClosed', this.gate);
                    this.contentContainer.addAt(this.gate);

                    this.flame = this.scene.add.sprite(490, 300, 'flame-atlas');
                    this.flame.setScale(0.33 / 0.2);
                    sh.scene.Preloader.playAnim('flame', this.flame);
                    window['this.flame'] = this.flame;
                    this.contentContainer.addAt(this.flame);

                    let _k = 0;
                    var shadowPositions = [{ x: 208, y: 545 }, { x: 500, y: 545 }, { x: 800, y: 545 }];
                    for (let sp of shadowPositions) {
                        let shadow = new Phaser.GameObjects.Image(this.scene, sp.x, sp.y, 'shadow');

                        this.contentContainer.add(shadow);

                        // if (this.gameplay.currentRound > 0) {
                        shadow.alpha = 0;
                        shadow.setScale(0.5);
                        this.scene.tweens.add({
                            targets: shadow,
                            alpha: 1,
                            scaleY: 1,
                            scaleX: 1,
                            duration: 150,
                            delay: 250 + _k * 200
                        });
                        // }
                        _k++;
                    }

                    if (this.gameplay.currentRound > 0) {
                        this.contentContainer.alpha = 0;
                        this.scene.tweens.add({
                            targets: this.contentContainer,
                            alpha: 1,
                            duration: 250,
                            // delay: 200
                        });
                    }

                    this.speakers = [];
                    let _i = 0;
                    var jarr = [1, 2, 3];

                    // if (this.gameplay.currentRound > 0) {
                    delayedCall(350, () => this.scene.sound.add('Blocks appearing in each round').play())
                    // }

                    for (let p of this.carsPositions) {
                        let hc = new Phaser.GameObjects.Container(this.scene, this.carsPositions[_i]['x'], this.carsPositions[_i]['y']);
                        var j = Phaser.Utils.Array.RemoveRandomElement(jarr);

                        let h = this.scene.add.sprite(0, 0, 'chestOpen-atlas');
                        sh.scene.Preloader.playAnim('chestClosed', h);

                        h.setOrigin(0.5, 1);
                        hc.add(h);
                        hc["bg"] = h;

                        hc["selector"] = new Phaser.GameObjects.Image(this.scene, 20, -220, 'greenSelector');
                        hc.add(hc["selector"]);

                        hc["defX"] = p['x'];
                        hc["defY"] = p['y'];
                        this.speakers.push(hc);
                        this.contentContainer.add(hc);
                        hc['index'] = _i;

                        // if (this.gameplay.currentRound > 0) {
                        // hc.y -= 800;
                        hc.alpha = 0;
                        this.scene.tweens.add({
                            targets: hc,
                            alpha: 1,
                            duration: 150,
                            delay: 350 + _i * 150
                        });
                        // }

                        let playBtn = new Phaser.GameObjects.Image(this.scene, 40, -75, 'btnPlaySnd');
                        hc.add(playBtn);
                        hc["playBtn"] = playBtn;
                        setupButtonTextureBased(playBtn, 'btnPlaySnd', 'btnPlaySndHover', 'btnPlaySndDown');
                        playBtn.on('pointerdown', () => {
                            for (let _hc of this.speakers) {
                                if (_hc["playBtn"]["sound"]) _hc["playBtn"]["sound"].stop();
                            }

                            if (!playBtn["sound"]) {
                                playBtn["sound"] = this.scene.sound.add(this.gameplay.getLetterSoundSfxAudioKey(hc["letter"]));
                            }
                            playBtn["sound"].play();

                            if (this.gameplay.correctAnswersCount == 0) {
                                if (!hc["handIcon"] || !hc["handIcon"].visible) return;

                                hc['handIcon'].visible = false;

                                playBtn["sound"].once('complete', () => {
                                    if (hc['index'] > 0) {
                                        var nextSpeaker = this.speakers[hc['index'] - 1];
                                        nextSpeaker["handIcon"].visible = true;
                                        nextSpeaker["playBtn"].setInteractive({ cursor: 'pointer' });
                                    } else {
                                        if (this.gameplay.currentRound == 0) {
                                            for (let __hc of this.speakers) {
                                                let correctAnswer = __hc["letter"] && __hc["letter"] == this.gameplay.getCorrectLetterName();
                                                if (correctAnswer) {
                                                    delayedCall(350, () => {
                                                        __hc["handIcon"].visible = true;
                                                        __hc["handIcon"].setPosition(55, -200);
                                                    })
                                                }
                                            }
                                        }

                                        for (let _hc of this.speakers) {
                                            _hc["selector"].alpha = 0;
                                            this.scene.tweens.add({
                                                targets: _hc["selector"],
                                                alpha: 1,
                                                duration: 150,
                                                delay: 200
                                            });
                                            _hc["selector"].visible = true;
                                        }
                                        this.scene.sound.add('Movement fx').play();
                                    }
                                });
                            } else {
                                let __hc = this.speakers[hc['index']];
                                __hc["selector"].alpha = 0;
                                this.scene.tweens.add({
                                    targets: __hc["selector"],
                                    alpha: 1,
                                    duration: 150,
                                    delay: 200
                                });
                                __hc["selector"].visible = true;
                                this.scene.sound.add('Movement fx').play();
                            }
                        });

                        if (this.gameplay.correctAnswersCount == 0) {
                            hc["selector"].visible = false;

                            let handIcon = new Phaser.GameObjects.Image(this.scene, 75, -60, 'Hand Icon');
                            hc.add(handIcon);
                            hc["handIcon"] = handIcon;
                            this.scene.tweens.add({
                                targets: handIcon,
                                angle: -5,
                                scaleY: 0.95,
                                scaleX: 0.95,
                                duration: 500,
                                yoyo: true,
                                repeat: -1,
                            });

                            if (_i == 2) {
                                handIcon.visible = false;
                                delayedCall(5200, () => {
                                    handIcon.visible = true;
                                    playBtn.setInteractive({ cursor: 'pointer' });
                                });
                            } else {
                                handIcon.visible = false;
                            }
                        } else {
                            hc["selector"].visible = false;
                            playBtn.setInteractive({ cursor: 'pointer' });
                        }

                        _i++;
                    }
                    window['this.cars'] = this.speakers;

                    this.imgFrame = new Phaser.GameObjects.Image(this.scene, 980 / 2, 85, 'Frame');
                    window['this.imgFrame'] = this.imgFrame;
                    this.contentContainer.add(this.imgFrame);

                    this.questionContainer = new Phaser.GameObjects.Container(this.scene, 980 / 2, 85); window['this.questionContainer'] = this.questionContainer;

                    if (this.gameplay.useImages) {
                        this.questionWordText = new Phaser.GameObjects.Image(this.scene, -3, 0, this.gameplay.getCorrectLetterName());
                    } else {
                        this.questionWordText = this.scene.add.text(-3, 0, this.gameplay.getCorrectLetterName(), {
                            "fontFamily": "QuranErafont",
                            "fontSize": 65,
                            "color": "#333333",
                            "align": 'center'
                        });
                        this.questionWordText.setOrigin(0.5, 0.5);
                        this.questionWordText.setPadding({ left: 0, right: 0, top: 65, bottom: 65 });
                    }
                    if (this.questionWordText.width > 275) this.questionWordText.setScale(275 / this.questionWordText.width);
                    window['this.questionWordText'] = this.questionWordText;
                    this.questionContainer.add(this.questionWordText);
                    this.contentContainer.add(this.questionContainer);
                    this.questionContainer.alpha = 0;
                    this.scene.tweens.add({
                        targets: this.questionContainer,
                        alpha: 1,
                        duration: 400,
                        delay: 500
                    });
                }
                createLetters() {
                    this.letters = this.gameplay.getCurrentRoundLetters();
                }
                showGameplay() {
                    this.isLost = false;
                    setPageBackground("bg-australia");
                    this.bgMusic = this.scene.sound.add("bg_sound");
                    this.bgMusic.play();
                    this.bgMusic.loop = true;

                    this.gameplay.reset();

                    window['this.bgContainer'] = this.bgContainer;
                    this._btnClose = new Phaser.GameObjects.Image(this.scene, 1025 - 105, 100 - 50, 'x Button');
                    this._btnClose.setInteractive({ cursor: 'pointer' });
                    this._btnClose["defScale"] = this._btnClose.scale;
                    setupButtonTextureBased(this._btnClose, 'x Button', 'x Button HOVER EFFECT');
                    this.gameplayContainer = new Phaser.GameObjects.Container(this.scene);
                    if (this.___gameStageBack) this.remove(this.___gameStageBack);
                    else this.___gameStageBack = new Phaser.GameObjects.Image(this.scene, 490, 300, '_gameStageBack');
                    window['this.___gameStageBack'] = this.___gameStageBack;
                    if (!this.tallyContainer) this.tallyContainer = new Phaser.GameObjects.Container(this.scene);
                    this.tallyContainer.removeAll();
                    this.addAt(this.gameplayContainer, 0);
                    this.addAt(this.___gameStageBack, 0);
                    this.add([
                        this.tallyContainer,
                        this._btnClose
                    ]);
                    window['this._gameStage'] = this._gameStage;
                    window['this.gameplayContainer'] = this.gameplayContainer;

                    this.createBeehives();
                    this.shuffleOutHexagons();
                    this.gameplay.setupCallbacks(this.showCompleteWindow, this.showLoseWindow);
                }
                createBeehives() {
                    let startX = 940;
                    let startY = 110;
                    let dy = 35;
                    let _BeehiveEmptyArrayPositions = [];
                    for (let i = 0; i < this.gameplay.getMaxTotalAnswersCount(); i++) {
                        _BeehiveEmptyArrayPositions.push({ x: startX, y: startY + i * dy });
                    }
                    this._BeehiveEmptyArray = []; window["_BeehiveEmptyArray"] = this._BeehiveEmptyArray;
                    this._Beehive = [];
                    for (let p of _BeehiveEmptyArrayPositions) {
                        let _BeehiveEmpty = new Phaser.GameObjects.Image(this.scene, p['x'], p['y'], 'Beehive 1 Empty');
                        this._BeehiveEmptyArray.push(_BeehiveEmpty);
                        _BeehiveEmpty.visible = false;
                        let _Beehive = new Phaser.GameObjects.Image(this.scene, p['x'], p['y'], 'Beehive 1');
                        this._Beehive.push(_Beehive);
                    }
                    for (let bea of this._BeehiveEmptyArray) {
                        this.tallyContainer.add(bea);
                    }
                    for (let bee of this._Beehive) {
                        this.tallyContainer.add(bee);
                        bee.visible = false;
                    }
                }
                randomizeLettersPosition() {
                    let hx = this.speakers.slice();
                    for (let l of this.letters) {
                        if (hx.length == 0)
                            return;
                        let hc = Phaser.Utils.Array.RemoveRandomElement(hx);
                        hc["letter"] = l;
                    }
                }
                shuffleOutHexagons() {
                    this.createHexagons();

                    let setLettersInputEnabled = () => {
                        // if (this.correctAudio && this.correctAudio.isPlaying) {
                        delayedCall(/* (this.correctAudio.duration * 0.75) * */ 1000, () => {
                            this.setLettersInputEnabled(true);
                        });
                        // }
                        // else {
                        // this.setLettersInputEnabled(true);
                        // }
                    };

                    if (!this.gameplay.isRoundsComplete()) {
                        let c = this.gameplay.getCurrentTotalAnswersCount();
                        delayedCall(500, () => {
                            if (this.gameplay.isCorrectLetterAudioQuestionEnable() && c == 0) {
                                this.playCorrectAudio();
                            }
                            setLettersInputEnabled();
                        });
                    }

                    if (this.sfxCarAccelerating) {
                        this.sfxCarAccelerating.stop();
                        this.sfxCarAccelerating = null;
                    }
                    if (this.sfxWrong) {
                        this.sfxWrong.stop();
                        this.sfxWrong = null;
                    }

                    if (!this.gameplay.isRoundsComplete()) {
                        this.createLetters();
                        this.randomizeLettersPosition();
                    }

                    this.setLettersInputEnabled(false);
                    // Phaser.Utils.Array.Shuffle(this.carsPositions);
                    let cars = this.speakers;
                    for (let i = 0; i < cars.length; i++) {
                        let hc = cars[i];
                        hc["defX"] = this.carsPositions[i]["x"];
                        hc["defY"] = this.carsPositions[i]["y"];

                        this.scene.tweens.killTweensOf(hc);
                    }
                    for (let c of cars) this.gameplayContainer.remove(c);
                    this.speakers.sort((c1, c2) => c1.y - c2.y);
                    // for (let c of cars) this.gameplayContainer.add(c);

                    this.createInput();

                    if (this.gameplay.currentRound > 0) {
                        if (this.gameplay.currentRound == this.gameplay.numberOfRounds - 1) {
                            this.garden = new Phaser.GameObjects.Image(this.scene, 491, 350, 'garden');
                            this.garden.setOrigin(0.5, 0.5);
                            this.garden.setScale(0.5, 0.5);
                            this.garden.setInteractive();
                            this.bgContainer.add(this.garden);
                            window['this.garden'] = this.garden;
                            this.garden.alpha = 0;

                            this.bgBright = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2, game.scale.height / 2, 'bgBright');
                            this.bgBright.setOrigin(0.5, 0.5);
                            this.bgBright.setInteractive();
                            this.bgContainer.add(this.bgBright);
                            /* this.bgBright.alpha = 0;
                            this.scene.tweens.add({
                                targets: this.bgBright,
                                alpha: 1,
                                duration: 500
                            }); */

                            this.bgMusic.stop();
                            this.bgMusic = this.scene.sound.add("Garden ambience");
                            this.bgMusic.play();
                            this.bgMusic.loop = true;
                        }

                        this.gameplayContainer.setScale(1, 1);
                        this.gameplayContainer.setPosition(0, 0);

                        /* this.gameplayContainer.alpha = 0;
                            this.scene.tweens.add({
                                targets: this.gameplayContainer,
                                alpha: 1,
                                duration: 350
                            }); */

                        /* this.gameplayContainer.setPosition(-1720, -1110);
                        this.gameplayContainer.setScale(4.5,4.5);
                        this.scene.tweens.add({
                            targets: this.gameplayContainer,
                            x: 0,
                            y: 0,
                            scaleX: 1,
                            scaleY: 1,
                            duration: 1000,
                            ease: Phaser.Math.Easing.Quartic.Out
                        });
                        this.gate.alpha = 0;
                        this.scene.tweens.add({
                            targets: this.gate,
                            alpha: 1,
                            duration: 500
                        }); */
                    }
                }
                shuffleInHexagons() {
                    let positions = this.carsPositions.slice();
                    this.setLettersInputEnabled(false);

                    // delayedCall(600, () => {
                    // this.scene.sound.add('move to centre').play();
                    this.shuffleOutHexagons();
                    // });
                    window['t'] = this;
                }
                moveIntoGatesAnimation(moveInDuration, onComplete) {
                    this.scene.sound.add('Metal gate opens').play();
                    sh.scene.Preloader.playAnim('gamesOpen', this.gate);
                    let __gameStageBack = this._gameStageBack;
                    delayedCall(2000, () => {
                        this.scene.sound.add('Entering another room sound').play();
                        this.scene.tweens.add({
                            targets: this.gameplayContainer,
                            x: -1720,
                            y: -1120,
                            scaleX: 4.5,
                            scaleY: 4.5,
                            duration: moveInDuration,
                            onComplete: onComplete,
                            ease: Phaser.Math.Easing.Quartic.In
                        });
                        if (this.garden) {
                            this.scene.tweens.add({
                                targets: this.garden,
                                y: 315,
                                duration: moveInDuration - 125,
                                ease: Phaser.Math.Easing.Quartic.In
                            });
                            this.scene.tweens.add({
                                targets: this.garden,
                                scaleX: 1 / 4.5 * 1.005,
                                scaleY: 1 / 4.5 * 1.005,
                                duration: moveInDuration,
                                ease: Phaser.Math.Easing.Quartic.In
                            });
                        }
                        if (__gameStageBack) {
                            this.scene.tweens.add({
                                targets: __gameStageBack,
                                y: 315,
                                duration: moveInDuration - 125,
                                ease: Phaser.Math.Easing.Quartic.In
                            });
                            this.scene.tweens.add({
                                targets: __gameStageBack,
                                scaleX: 1 / 4.5,
                                scaleY: 1 / 4.5,
                                duration: moveInDuration,
                                ease: Phaser.Math.Easing.Quartic.In
                            });
                        }
                    });
                }
                createInput() {
                    for (let hc of this.speakers) {
                        let correctAnswer = hc["letter"] && hc["letter"] == this.gameplay.getCorrectLetterName();
                        hc["selector"].once('pointerup', () => {
                            if (hc["handIcon"]) hc["handIcon"].visible = false;

                            this.scene.tweens.add({
                                targets: hc["selector"],
                                scaleX: 0.9,
                                scaleY: 0.9,
                                duration: 100,
                                yoyo: true
                            });
                            // if (hc["Wrong Box"].visible) return;
                            // this.playBtnClickAnim(hc);
                            let lost = false;
                            if (correctAnswer) {
                                if (this.gameplay.currentRound >= this.gameplay.numberOfRounds - 1) {
                                    this.scene.tweens.add({
                                        targets: this.garden,
                                        alpha: 1,
                                        duration: 500
                                    });
                                } else {
                                    this.scene.tweens.add({
                                        targets: this._gameStageBack,
                                        alpha: 1,
                                        duration: 500
                                    });
                                }

                                hc.parentContainer.bringToTop(hc);
                                sh.scene.Preloader.playAnim('chestOpen', hc["bg"]);

                                this.scene.sound.add('Correct selection - chest opens').play();

                                this.setLettersInputEnabled(false);
                                hc["selector"].setTexture("greenSelectorCorrect");

                                let completed = this.onCorrectAnswer();

                                for (let _hc of this.speakers) {
                                    _hc["selector"].visible = false;
                                    _hc["playBtn"].disableInteractive();
                                }

                                delayedCall(1050, () => {
                                    /* this.scene.tweens.add({
                                        targets: this.questionContainer,
                                        alpha: 0,
                                        duration: 400,
                                        delay: 650
                                    }); */
                                    // this.scene.sound.add('Text from earth popping up').play();
                                });
                                delayedCall(1550, () => {
                                    /* for (let _sp of this.speakers) {
                                        this.scene.tweens.add({
                                            targets: _sp,
                                            duration: 250,
                                            delay: 250,
                                            alpha: 0
                                        });
                                    } */

                                    this.moveIntoGatesAnimation(completed ? 1000 : 1000, () => {
                                        delayedCall(completed ? 0 : 250, () => {
                                            if (!completed) {
                                                this.shuffleInHexagons();
                                            } else {
                                                delayedCall(700, () => this.scene.sound.add('Final celebration').play());

                                                /* this.garden = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2, game.scale.height / 2, 'garden');
                                                this.garden.setOrigin(0.5, 0.5);
                                                this.garden.setInteractive();
                                                this.gameplayContainer.add(this.garden);
                                                this.garden.alpha = 0;
                                                this.scene.tweens.add({
                                                    targets: this.garden,
                                                    alpha: 1,
                                                    duration: 350
                                                }); */

                                                /* this.gameplayContainer.setScale(1,1);
                                                this.gameplayContainer.setPosition(0, 0); */
                                            }
                                        });
                                    });
                                });
                            }
                            else {
                                hc["selector"].setTexture('redSelector');

                                this.scene.tweens.add({
                                    targets: hc["selector"],
                                    alpha: 0,
                                    duration: 500,
                                    delay: 200
                                });

                                lost = this.onWrongAnswer();
                                if (!lost) {
                                    // this.shuffleInHexagons();
                                } else {
                                    this.setLettersInputEnabled(false);
                                    for (let sp of this.speakers) {
                                        sp["playBtn"].disableInteractive();
                                    }
                                    this.isLost = true;
                                }
                            }
                        });
                    }
                    this._btnClose.on('pointerup', () => {
                        this.playBtnClickAnim(this._btnClose);
                        this.onCloseClick();
                    });
                }
                hideAllUnusedBeehives() {
                    let i = this.gameplay.getCurrentTotalAnswersCount();
                    for (let k = i + 1; k < this._BeehiveEmptyArray.length; k++) {
                        this._BeehiveEmptyArray[k].visible = false;
                        this._Beehive[k].visible = false;
                    }
                }
                onCorrectAnswer() {
                    let i = this.gameplay.getCurrentTotalAnswersCount();
                    if (i < this._BeehiveEmptyArray.length) {
                        this._BeehiveEmptyArray[i].visible = false;
                        this._Beehive[i].visible = true;
                    }
                    this.hideAllUnusedBeehives();
                    let completed = this.gameplay.onCorrectAnswer();
                    this.scene.sound.add('Correct sfx').play();
                    // this.sfxCarAccelerating = this.scene.sound.add('Car accelerating');
                    // this.sfxCarAccelerating.play();
                    // delayedCall(250, () => {
                    //     this.scene.sound.add(this.gameplay.getCorrectAndLetterSoundSfxAudioKey()).play();
                    // });
                    return completed;
                }
                onWrongAnswer(forceNewRound) {
                    let i = this.gameplay.getCurrentTotalAnswersCount();
                    if (i < this._BeehiveEmptyArray.length) {
                        this._BeehiveEmptyArray[i].visible = true;
                        this._Beehive[i].visible = false;
                    }
                    this.hideAllUnusedBeehives();
                    let lost = this.gameplay.onWrongAnswer(forceNewRound);
                    this.sfxWrong = this.scene.sound.add("wrong sfx");
                    this.sfxWrong.play();
                    return lost;
                }
                playCorrectAudio() {
                    if (this.correctAudio) {
                        this.correctAudio.stop();
                    }
                    this.correctAudio = this.scene.sound.add("questionAudio"/* this.gameplay.getCorrectAudioKey() */);
                    this.correctAudio.play();
                    if (this.areYouSureWindow && this.areYouSureWindow.parentContainer == this) {
                        this.correctAudio.pause();
                    }
                }
                onSoundClick() {
                    this.playCorrectAudio();
                }
                onCloseClick() {
                    this.showAreYouSurePage();
                    this.scene.sound.add('warning page pop up sfx').play();
                }
                playBtnClickAnim(target) {
                    let sc = target["defScale"] ? target["defScale"] : 1;
                    target.scaleX = target.scaleY = sc;
                    this.scene.tweens.add({
                        targets: target,
                        "scaleX": 0.9 * sc,
                        "scaleY": 0.9 * sc,
                        duration: 100,
                        yoyo: true
                    });
                }
                showInstructionPage() {
                    setPageBackground("bg-blue");
                    this.instructionPage = new screen.InstructionPage(this.scene, (target) => {
                        this.playBtnClickAnim(target);
                        this.remove(this.instructionPage);
                        this.showGameplay();
                        if (this.wfsnd) {
                            this.wfsnd.stop();
                        }
                    }, (target) => {
                        this.playBtnClickAnim(target);
                        if (this.wfsnd) {
                            this.wfsnd.stop();
                        }
                        if (!game.cache.json.get('gameplay')['welcomeAudioDisabled']) {
                            this.wfsnd = this.scene.sound.add("Welcome Find the sound");
                            this.wfsnd.play();
                        }
                    });
                    this.add(this.instructionPage);
                    try {
                        if (!game.cache.json.get('gameplay')['welcomeAudioDisabled']) {
                            this.wfsnd = this.scene.sound.add("Welcome Find the sound");
                            this.wfsnd.play();
                        }
                    }
                    catch (e) {
                        console.error(e);
                    }
                }
                showAreYouSurePage() {
                    /* for (let j = 0; j < this.cars.length; j++) {
                        if (this.cars[j]["raceTween"]) {
                            this.cars[j]["raceTween"].pause();
                        }
                    } */

                    pauseAllDelayedCalls();
                    setPageBackground("bg-blue");
                    this.pauseSounds();
                    if (!this.areYouSureWindow) this.areYouSureWindow = new screen.AreYouSureWindow(this.scene, () => {
                        this.remove(this.areYouSureWindow);
                        this.destroyGameplay();
                        this.showInstructionPage();
                    }, () => {
                        this.remove(this.areYouSureWindow);
                        this.unpauseSounds();
                        resumeAllDelayedCalls();

                        /* for (let j = 0; j < this.cars.length; j++) {
                            if (this.cars[j]["raceTween"]) {
                                this.cars[j]["raceTween"].resume();
                            }
                        } */

                        setPageBackground("bg-australia");
                    });
                    this.add(this.areYouSureWindow);
                }
                setLettersInputEnabled(enabled) {
                    if (enabled) {
                        for (let hc of this.speakers) {
                            hc["selector"].setInteractive({ cursor: 'pointer' });
                        }
                    }
                    else {
                        for (let hc of this.speakers) {
                            hc["selector"].disableInteractive();
                        }
                    }
                }
                pauseSounds() {
                    if (this.correctAudio)
                        this.correctAudio.pause();
                    if (this.bgMusic)
                        this.bgMusic.pause();
                }
                unpauseSounds() {
                    if (this.correctAudio)
                        this.correctAudio.resume();
                    if (this.bgMusic)
                        this.bgMusic.resume();
                }
                destroyGameplay() {
                    this.setLettersInputEnabled(false);
                    this.remove(this.gameplayContainer);
                    this.scene.sound.stopAll();
                    destroyAllDelayedCalls();
                }
            }
            screen.GameplayScreen = GameplayScreen;
        })(screen = sh.screen || (sh.screen = {}));
    })(sh || (sh = {}));
    (function (sh) {
        var screen;
        (function (screen) {
            class InstructionPage extends Phaser.GameObjects.Container {
                constructor(scene, onPlayClick, onSndClick) {
                    super(scene);
                    this._instructionPage = new Phaser.GameObjects.Image(this.scene, 0 - 105, 0 - 48, 'Instructions page  ALL ACTIVITY  TITLEs');
                    this._instructionPage.setOrigin(0, 0);
                    this._instructionPage.setInteractive();

                    this._instructionPageTitle = this.scene.add.text(475, 110, sh.App.json.instructionTitle ?? 'Castle', {
                        "fontFamily": "Kids Rock DEMO",
                        "fontSize": 35,
                        "color": "#43425D",
                        "align": 'center'
                    });
                    this._instructionPageTitle.setOrigin(0.5, 0.5);
                    window['this._instructionPageTitle'] = this._instructionPageTitle;
                    this._instructionPageTitle.setStroke('#ffffff', 5);
                    //  Apply the gradient fill.
                    const gradient = this._instructionPageTitle.context.createLinearGradient(0, 0, 0, this._instructionPageTitle.height);
                    gradient.addColorStop(0, '#eeef67');
                    gradient.addColorStop(0.55, '#e98c2c');
                    gradient.addColorStop(1, '#91301a');
                    this._instructionPageTitle.setFill(gradient);

                    this._btnPlay = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2, 480 - 50, 'btnPLAY1');
                    this._btnPlay.setInteractive({ cursor: 'pointer' });
                    this._btnPlay.once('pointerup', onPlayClick);
                    setupButtonTextureBased(this._btnPlay, 'btnPLAY1', 'btnPLAY2');
                    this.instrTxt = this.scene.add.text(game.scale.width / 2, game.scale.height / 2, "Listen to the code and match it to\n the word.", {
                        "fontFamily": "Kids Rock DEMO",
                        "fontSize": 30,
                        "lineSpacing": 15,
                        "color": "#43425D",
                        "align": 'center'
                    });
                    this.instrTxt.setOrigin(0.5, 0.5);
                    this._btnSoundInstruction = new Phaser.GameObjects.Image(this.scene, 800 - 105, 156 - 50, 'Sound');
                    this._btnSoundInstruction.setInteractive({ cursor: 'pointer' });
                    this._btnSoundInstruction.on('pointerup', onSndClick);
                    this._btnSoundInstruction["defScale"] = this._btnSoundInstruction.scale;
                    setupButtonTextureBased(this._btnSoundInstruction, 'Sound', 'Sound HOVER EFFECT');
                    this.add(this._instructionPage);
                    this.add(this._instructionPageTitle);
                    this.add(this.instrTxt);
                    this.add(this._btnPlay);
                    this.add(this._btnSoundInstruction);
                }
            }
            screen.InstructionPage = InstructionPage;
        })(screen = sh.screen || (sh.screen = {}));
    })(sh || (sh = {}));
    (function (sh) {
        var screen;
        (function (screen) {
            class TryAgainWindow extends Phaser.GameObjects.Container {
                constructor(scene, onBack, onReplay) {
                    super(scene);
                    this.music = null;
                    this.setPosition(-106, -48);
                    this._bg = new Phaser.GameObjects.Image(this.scene, 0, 0, 'Try again page');
                    this._bg.setOrigin(0, 0);
                    this._bg.setInteractive();
                    this._star = new Phaser.GameObjects.Image(this.scene, 400, 415, 'Break Star');
                    this._btnBack = new Phaser.GameObjects.Image(this.scene, 600, 580, 'btnBACK1');
                    this._btnReplay = new Phaser.GameObjects.Image(this.scene, 765, 580, 'btnReplay1');
                    this.totalScoreTxt = this.scene.add.text(850, 355, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 35,
                        "color": "#F49F1C",
                        "align": 'center',
                        'stroke': '#70451A',
                        'strokeThickness': 6
                    });
                    this.totalScoreTxt.setOrigin(0.5, 0.5);
                    let grd = this.totalScoreTxt.context.createLinearGradient(0, 0, 0, this.totalScoreTxt.height);
                    grd.addColorStop(0, '#FFFF00');
                    grd.addColorStop(1, '#C17316');
                    this.totalScoreTxt.setFill(grd);
                    this.starScoreTxt = this.scene.add.text(635, 431, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 24,
                        "color": "#FFFFFF",
                        "align": 'center'
                    });
                    this.starScoreTxt.setOrigin(0.5, 0.5);
                    this.add([
                        this._bg,
                        this._star,
                        this._btnBack,
                        this._btnReplay,
                        this.totalScoreTxt,
                        this.starScoreTxt
                    ]);
                    this._btnBack.setInteractive({ cursor: 'pointer' });
                    this._btnBack.on('pointerup', () => {
                        onBack(this._btnBack);
                        angularComponentRef.backToMenu();
                        // if (this.music) {
                        //     this.music.stop();
                        // }
                    });
                    setupButtonTextureBased(this._btnBack, 'btnBACK1', 'btnBACK2');
                    this._btnReplay.setInteractive({ cursor: 'pointer' });
                    this._btnReplay.once('pointerup', () => {
                        onReplay(this._btnReplay);
                        if (this.music) {
                            this.music.stop();
                        }
                    });
                    setupButtonTextureBased(this._btnReplay, 'btnReplay1', 'btnReplay2');
                }
                show(score, starScore) {
                    this._star.scale = 1.25;
                    this.scene.tweens.add({
                        targets: this._star,
                        "scale": 1,
                        duration: 500,
                        ease: Phaser.Math.Easing.Back.Out
                    });
                    this.totalScoreTxt.text = '';//String(window.angularComponentRef.component.userInfo.totalScore);
                    this.starScoreTxt.text = String(0);
                    this.music = this.scene.sound.add("Fail - close one");
                    this.music.play();
                }
            }
            screen.TryAgainWindow = TryAgainWindow;
        })(screen = sh.screen || (sh.screen = {}));
    })(sh || (sh = {}));
}

function destroyCastleGame() {
    if (game) {
        game.destroy();
    }
}

var game;
var sh;
function mosqueCompleteVerse(json) {
    /**
     * @author Roman Parada
     * This class is created to fix overlapping of bottom part of canvas by navigation bar in iOS.
     * It make a delayed resize of the canvas (like Phaser-3 FIT methods does) and it overrides Phaser-3 input window to Phaser-3 core transform methods
     *
     * How to use:
     * Just call the code line below in Boot scene's init() method of your project:
     * new FitScaleManager(this.game).setup();
     */
    class FitScaleManager {
        constructor(game) {
            this.doResize = () => {
                let scale = this.calculateScale();
                let newCanvasWidth = this.phaserScaleManager.width * scale;
                let newCanvasHeight = this.phaserScaleManager.height * scale;
                this.canvasStyle.width = newCanvasWidth + 'px';
                this.canvasStyle.height = newCanvasHeight + 'px';
                this.canvasStyle.marginLeft = (window.innerWidth - newCanvasWidth) / 2 + 'px';
                this.canvasStyle.marginTop = (window.innerHeight - newCanvasHeight) / 2 + 'px';
            };
            this.game = game;
            this.canvasStyle = this.game.canvas.style;
            this.phaserScaleManager = this.game.scale;
        }
        static detectBestScaleMode() {
            let iOS = /iPad|iPhone|iPod/.test(navigator.platform || "");
            let isAndroid = window.navigator.userAgent.toLowerCase().indexOf("android") > -1;
            return iOS || isAndroid ? Phaser.Scale.FIT : Phaser.Scale.NONE;
        }
        ;
        /**
         * Just call this method once in Boot scene's init() method
         */
        setup() {
            this.phaserScaleManager.addListener(Phaser.Scale.Events.RESIZE, this.onResize, this);
            this.overridePhaserTransformMethods();
            this.onResize();
        }
        calculateScale() {
            if (game.scale.scaleMode === Phaser.Scale.NONE)
                return 1;
            return Math.min(window.innerWidth / this.phaserScaleManager.width, window.innerHeight / this.phaserScaleManager.height);
        }
        overridePhaserTransformMethods() {
            this.game.scale.transformX = (pageX) => {
                return (pageX - parseInt(this.canvasStyle.marginLeft.split("px")[0])) / this.calculateScale();
            };
            this.game.scale.transformY = (pageY) => {
                return (pageY - parseInt(this.canvasStyle.marginTop.split("px")[0])) / this.calculateScale();
            };
        }
        onResize() {
            setTimeout(this.doResize, FitScaleManager.RESIZE_DELAY);
        }
    }
    FitScaleManager.RESIZE_DELAY = 500;

    (function (sh) {
        class App extends Phaser.Game {
            constructor(json) {
                App.json = json;
                // console.log(App.json);

                let config = {
                    type: Phaser.AUTO,
                    width: App.CANVAS_WIDTH,
                    height: App.CANVAS_HEIGHT,
                    parent: 'game-container',
                    dom: {
                        createContainer: false
                    },
                    scale: {
                        mode: FitScaleManager.detectBestScaleMode(),
                        autoCenter: Phaser.Scale.CENTER_BOTH
                    },
                    transparent: true,
                    scene: {
                        create: () => {
                            this.scene.add('Boot', sh.scene.Boot, true);
                        }
                    }
                };
                super(config);
            }
        }
        App.CANVAS_WIDTH = 980;
        App.CANVAS_HEIGHT = 600;
        sh.App = App;
    })(sh || (sh = {}));

    game = new sh.App(json);

    var delayedCalls = [];
    function delayedCall(delay, callback, args, callbackScope) {
        let scene = game.scene.getAt(0);
        if (scene) {
            let dc = scene.time.delayedCall(delay, callback, args, callbackScope);
            delayedCalls.push(dc);
            return dc;
        }
        let t = setTimeout(callback, delay);
        delayedCalls.push(t);
        return t;
    }

    function pauseAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.paused = true;
            }
        }
    }

    function resumeAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.paused = false;
            }
        }
    }

    function destroyAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.remove(false);
            }
            else {
                clearTimeout(dc);
            }
        }
        delayedCalls = [];
    }

    function setPageBackground(bg) {
        // document.querySelector("html").style.backgroundImage = "url(assets/games/mosque-complete-verse/imgs/" + bg + ".jpg)";
    }

    function setupButton(btn, frame) {
        btn.on('pointerdown', () => { btn.setFrame(frame + '_hover' + '0000'); });
        btn.on('pointerover', () => { btn.setFrame(frame + '_hover' + '0000'); game.scene.getAt(0).sound.add("button hover").play(); });
        btn.on('pointerout', () => { btn.setFrame(frame + '0000'); });
        btn.on('pointerup', () => { btn.setFrame(frame + '0000'); game.scene.getAt(0).sound.add('activity selection - button selection').play(); });
    }

    function setupButtonTextureBased(btn, texture, hoverTexture) {
        btn.on('pointerdown', () => { btn.setTexture(hoverTexture); });
        btn.on('pointerover', () => { btn.setTexture(hoverTexture); game.scene.getAt(0).sound.add("button hover").play(); });
        btn.on('pointerout', () => { btn.setTexture(texture); });
        btn.on('pointerup', () => { btn.setTexture(texture); game.scene.getAt(0).sound.add('activity selection - button selection').play(); });
    }

    (function (sh) {
        var core;
        (function (core) {
            class Gameplay {
                constructor() {
                    this.currentRound = 0;
                    this.currentLetter = 0;
                    this.correctAnswersCount = 0;
                    this.wrongAnswersCount = 0;
                    this.correctAnswersCountThisRound = 0;
                    this.wrongAnswersCountThisRound = 0;
                    this.reset();
                    let json = game.cache.json.get('gameplay');
                    this.wrongAnswersToLose = json["wrongAnswersToLose"];
                    this.numberOfQuestionsPerRound = json["numberOfQuestionsPerRound"];
                    this.lettersConfig = JSON.parse(JSON.stringify(json["lettersConfig"]));
                    this.rounds = JSON.parse(JSON.stringify(json["rounds"]));
                    this.numberOfRounds = json["numberOfRounds"] ?? this.rounds.length;
                    this.useImages = Boolean(game.cache.json.get('gameplay')["useImages"]);
                }
                setupCallbacks(onComplete, onLose) {
                    this.onComplete = onComplete;
                    this.onLose = onLose;
                }
                onLetterChosen(forceNewRound) {
                    if (forceNewRound || this.isNewRound()) {
                        return this.nextRound();
                    }
                    return false;
                }
                nextRound() {
                    this.correctAnswersCountThisRound = 0;
                    this.wrongAnswersCountThisRound = 0;
                    this.currentRound++;
                    if (this.isRoundsComplete()) {
                        this.onComplete(this.correctAnswersCount, this.correctAnswersCount);
                        return true;
                    }

                    return false;
                }
                getCorrectLetters() {
                    return this.rounds[this.currentRound]['correctLetters'];
                }
                isCorrectLetterAudioQuestionEnable() {
                    return this.rounds[this.currentRound]['audioQuestionEnable'];
                }
                getCorrectAndLetterSoundSfxAudioKey(firstOrSecond) {
                    return "Q-" + this.lettersConfig[this.getCorrectLetters()[firstOrSecond - 1]]['Sounds of the letters'];
                }
                onCorrectAnswer() {
                    this.correctAnswersCountThisRound++;
                    this.correctAnswersCount++;
                    return this.onLetterChosen();
                }
                onWrongAnswer(forceNewRound) {
                    this.wrongAnswersCountThisRound++;
                    this.wrongAnswersCount++;
                    if (this.wrongAnswersCount >= this.wrongAnswersToLose) {
                        this.onLose(this.correctAnswersCount, this.correctAnswersCount);
                        return true;
                    }
                    else {
                        this.onLetterChosen(forceNewRound);
                    }
                    return false;
                }

                getMaxTotalAnswersCount() {
                    return this.wrongAnswersToLose + this.numberOfRounds - 1;
                }

                getCurrentTotalAnswersCount() {
                    return this.correctAnswersCount + this.wrongAnswersCount;
                }
                isNewRound() {
                    return this.correctAnswersCountThisRound >= 1 || (this.correctAnswersCountThisRound + this.wrongAnswersCountThisRound) === 4 || (this.correctAnswersCountThisRound + this.wrongAnswersCountThisRound) === 0;
                }
                isRoundsComplete() {
                    return this.currentRound >= this.numberOfRounds && this.wrongAnswersCount < this.wrongAnswersToLose;
                }
                reset() {
                    this.currentRound = 0;
                    this.correctAnswersCount = 0;
                    this.wrongAnswersCount = 0;
                }
                getCurrentRoundLetters() {
                    return this.rounds[this.currentRound]["letters"];
                }
            }
            core.Gameplay = Gameplay;
        })(core = sh.core || (sh.core = {}));
    })(sh || (sh = {}));

    (function (sh) {
        var scene;
        (function (scene) {
            class Boot extends Phaser.Scene {
                init() {
                    this.game.scale.transformX = (pageX) => {
                        let offsetLeft = 0;
                        let parentElement = game.canvas.parentElement;
                        while (parentElement) {
                            if (parentElement.offsetLeft) {
                                offsetLeft = parentElement.offsetLeft;
                                break;
                            }
                            parentElement = parentElement.parentElement;
                        }
                        return (pageX - offsetLeft) * this.game.scale.displayScale.x;
                    };
                    this.game.scale.transformY = (pageY) => {
                        let offsetTop = 0;
                        let parentElement = game.canvas.parentElement;
                        while (parentElement) {
                            if (parentElement.offsetTop) {
                                offsetTop = parentElement.offsetTop;
                                break;
                            }
                            parentElement = parentElement.parentElement;
                        }
                        return (pageY - offsetTop) * this.game.scale.displayScale.y;
                    };
                }
                create() {
                    game.scene.remove('Boot');
                    game.scene.add('Preloader', sh.scene.Preloader, true);
                }
            }
            scene.Boot = Boot;
        })(scene = sh.scene || (sh.scene = {}));
    })(sh || (sh = {}));

    (function (sh) {
        var scene;
        (function (scene) {
            var Gameplay = sh.core.Gameplay;
            class MainScene extends Phaser.Scene {
                create() {
                    this.gameplay = new Gameplay();
                    this.gameplayScreen = new sh.screen.GameplayScreen(this, this.gameplay);
                    this.children.add(this.gameplayScreen);
                    this.gameplayScreen.showInstructionPage();
                }
            }
            scene.MainScene = MainScene;
        })(scene = sh.scene || (sh.scene = {}));
    })(sh || (sh = {}));

    (function (sh) {
        var scene;
        (function (scene) {
            class Preloader extends Phaser.Scene {
                preload() {
                    if (typeof sh.App.json == "string") this.load.json('gameplay', sh.App.json); else this.game.cache.json.add('gameplay', sh.App.json);
                }
                create() {
                    let json = game.cache.json.get('gameplay');
                    let lettersConfig = json["lettersConfig"];
                    this.load.audio("englQuestion", "assets/games/mosque-complete-verse/sound/mp3/letters/QuestionaudioCompletetheverse.mp3");
                    for (let letterName in lettersConfig) {
                        if (json["useImages"]) this.load.image(letterName, "assets/games/mosque-complete-verse/imgs/letters/" + letterName + ".png");
                        if (lettersConfig[letterName]) {
                            this.load.audio("Q-" + lettersConfig[letterName]["Sounds of the letters"], "assets/games/mosque-complete-verse/sound/mp3/letters/Sounds of the letters/" + lettersConfig[letterName]["Sounds of the letters"]);
                        }
                    }
                    let progressTxt = this.add.text(game.scale.width / 2, game.scale.height / 2 + 50, "", {
                        "fontFamily": "QuranEraV3",
                        "fontSize": 25,
                        "color": "#333333",
                        "align": 'center'
                    });
                    progressTxt.setOrigin(0.5, 0.5);
                    this.load.pack('preloader', 'assets/games/mosque-complete-verse/pack.json');
                    this.load.on('progress', (value) => {
                        progressTxt.text = Math.ceil(value * 100) + "%";
                    }, this);
                    this.load.on('complete', () => {
                        this.nextScene();
                    });
                    this.load.start();
                }
                static playAnim(animKey, sprite, onComplete = null) {
                    let mainScene = game.scene.getScene('ScreenMain');
                    let data = Preloader.ANIMS_DATA[animKey];
                    if (!mainScene.anims.exists(animKey)) {
                        mainScene.anims.create({
                            key: animKey,
                            frames: mainScene.anims.generateFrameNames(data['atlas'], {
                                start: data['start'], end: data['end'], zeroPad: data['padNum'],
                                prefix: data['prefix'], suffix: ''
                            }),
                            frameRate: data['frameRate'],
                            repeat: data['repeat']
                        });
                    }
                    if (sprite.anims.currentAnim) {
                        sprite.anims.currentAnim.off('complete');
                    }
                    sprite.anims.stop();
                    // sprite.setTexture(data['atlas']);
                    sprite.play(animKey);
                    sprite.anims.currentAnim.once('complete', () => {
                        if (onComplete)
                            onComplete();
                    });
                    return sprite;
                }
                nextScene() {
                    game.scene.remove('Preloader');
                    game.scene.add('ScreenMain', sh.scene.MainScene, true);
                }
            }
            Preloader.ANIMS_DATA = {
            };
            scene.Preloader = Preloader;
        })(scene = sh.scene || (sh.scene = {}));
    })(sh || (sh = {}));
    (function (sh) {
        var screen;
        (function (screen) {
            class AreYouSureWindow extends Phaser.GameObjects.Container {
                constructor(scene, onYes, onNo) {
                    super(scene);
                    this._areYouSurePage = new Phaser.GameObjects.Image(this.scene, -105, 0 - 48, 'Exit warning');
                    this._areYouSurePage.setOrigin(0, 0);
                    this._areYouSurePage.setInteractive();
                    this._btnSureYes = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2 - 95, 485 - 50, 'btnYES1');
                    this._btnSureYes.setInteractive({ cursor: 'pointer' });
                    this._btnSureYes.on('pointerup', () => {
                        onYes;
                        angularComponentRef.backToMenu();
                    });
                    var modalTextStyle = {
                        backgroundColor: 'transparent',
                        stroke: '#ffffff',
                        strokeThickness: 2,
                        lineSpacing: 15,
                        fontFamily: 'Kids Rock DEMO',
                        fontSize: 27,
                        color: '#43425d',
                        wordWrap: true,
                        align: 'center'
                    };
                    var modalText = this.scene.add.text(game.scale.width / 2 + 12, game.scale.height / 2, "Your progress in this activity will not be saved. \n Are you sure you want to exit? ", modalTextStyle);
                    modalText.setOrigin(0.5, 0.5);

                    setupButtonTextureBased(this._btnSureYes, 'btnYES1', 'btnYES2');
                    this._btnSureNo = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2 + 95, 485 - 50, 'btnNO1');
                    this._btnSureNo.setInteractive({ cursor: 'pointer' });
                    this._btnSureNo.on('pointerup', onNo);
                    setupButtonTextureBased(this._btnSureNo, 'btnNO1', 'btnNO2');
                    this.add(this._areYouSurePage);
                    this.add(this._btnSureYes);
                    this.add(this._btnSureNo);
                    this.add(modalText);
                }
            }
            screen.AreYouSureWindow = AreYouSureWindow;
        })(screen = sh.screen || (sh.screen = {}));
    })(sh || (sh = {}));

    (function (sh) {
        var screen;
        (function (screen) {
            class CompleteWindow extends Phaser.GameObjects.Container {
                constructor(scene, onBack, onReplay, onNext) {
                    super(scene);
                    this.music = null;
                    this.setPosition(-104.5, -48);
                    this._bgComplete = new Phaser.GameObjects.Image(this.scene, 0, 0, 'Completion page LATEST UPDATED');
                    this._bgComplete.setOrigin(0, 0);
                    this._bgComplete.setInteractive();
                    this._cup = new Phaser.GameObjects.Image(this.scene, 400, 410, 'Trophy');
                    this._btnBack = new Phaser.GameObjects.Image(this.scene, 570, 570, 'btnBACK1');
                    this._btnReplay = new Phaser.GameObjects.Image(this.scene, 720, 570, 'btnReplay1');
                    this._btnNext = new Phaser.GameObjects.Image(this.scene, 870, 570, 'btnNEXT1');
                    let _CollectedPoints = new Phaser.GameObjects.Image(this.scene, 620, 440, 'Collected Points');
                    this.totalScoreTxt = this.scene.add.text(845, 352, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 35,
                        "color": "#F49F1C",
                        "align": 'center',
                        'stroke': '#70451A',
                        'strokeThickness': 6
                    });
                    this.totalScoreTxt.setOrigin(0.5, 0.5);
                    let grd = this.totalScoreTxt.context.createLinearGradient(0, 0, 0, this.totalScoreTxt.height);
                    grd.addColorStop(0, '#FFFF00');
                    grd.addColorStop(1, '#C17316');
                    this.totalScoreTxt.setFill(grd);
                    this.starScoreTxt = this.scene.add.text(648, 433, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 24,
                        "color": "#FFFFFF",
                        "align": 'center'
                    });
                    this.starScoreTxt.setOrigin(0.5, 0.5);
                    this.add([
                        this._bgComplete,
                        _CollectedPoints,
                        this._cup,
                        this._btnBack,
                        this._btnReplay,
                        this._btnNext,
                        this.totalScoreTxt,
                        this.starScoreTxt
                    ]);
                    this._btnBack.setInteractive({ cursor: 'pointer' });
                    this._btnBack.on('pointerup', () => {
                        onBack(this._btnBack);
                        angularComponentRef.backToMenu();
                        // if (this.music) {
                        //     this.music.stop();
                        // }
                    });
                    setupButtonTextureBased(this._btnBack, 'btnBACK1', 'btnBACK2');
                    this._btnReplay.setInteractive({ cursor: 'pointer' });
                    this._btnReplay.once('pointerup', () => {
                        onReplay(this._btnReplay);
                        if (this.music) {
                            this.music.stop();
                        }
                    });
                    setupButtonTextureBased(this._btnReplay, 'btnReplay1', 'btnReplay2');
                    this._btnNext.setInteractive({ cursor: 'pointer' });
                    this._btnNext.on('pointerup', () => {
                        onNext(this._btnNext);
                        window.angularComponentRef.nextActivity()
                    });
                    setupButtonTextureBased(this._btnNext, 'btnNEXT1', 'btnNEXT2');
                }
                show(score, starScore) {
                    window.angularComponentRef.gameFinish({ score, starScore })
                    this._cup.scale = 1.25;
                    this.scene.tweens.add({
                        targets: this._cup,
                        "scale": 1,
                        duration: 500,
                        ease: Phaser.Math.Easing.Back.Out
                    });
                    this.totalScoreTxt.text = String(window.angularComponentRef.component.userInfo.totalScore);
                    this.starScoreTxt.text = String(starScore);
                    // let music = this.scene.sound.add("viktory");
                    this.music = this.scene.sound.add("Activity completion fantastic");
                    this.music.play();
                }
            }
            screen.CompleteWindow = CompleteWindow;
        })(screen = sh.screen || (sh.screen = {}));
    })(sh || (sh = {}));

    (function (sh) {
        var screen;
        (function (screen) {
            class GameplayScreen extends Phaser.GameObjects.Container {
                constructor(scene, gameplay) {
                    super(scene);
                    this.wordRectPositions = [{ x: 200, y: 463 }, { x: 500, y: 463 }, { x: 767, y: 463 }];
                    this.bgMusic = null;
                    this.correctAudio = null;
                    this.wfsnd = null;
                    this.showCompleteWindow = (score, starScore) => {
                        let completeWindow = new screen.CompleteWindow(this.scene, (target) => {
                            this.playBtnClickAnim(target);
                        }, (target) => {
                            this.playBtnClickAnim(target);
                            this.destroyGameplay();
                            this.remove(completeWindow);
                            this.showInstructionPage();
                        }, (target) => {
                            this.playBtnClickAnim(target);
                        });
                        this.setLettersInputEnabled(false);
                        delayedCall(7500, () => {
                            setPageBackground("bg-blue");
                            this.add(completeWindow);
                            completeWindow.show(score, starScore);
                            if (this.bgMusic) this.bgMusic.stop();
                        });
                    };
                    this.showLoseWindow = (score, starScore) => {
                        let tryAgainWindow = new screen.TryAgainWindow(this.scene, (target) => {
                            this.playBtnClickAnim(target);
                        }, (target) => {
                            this.playBtnClickAnim(target);
                            this.destroyGameplay();
                            this.remove(tryAgainWindow);
                            this.showInstructionPage();
                        });
                        this.setLettersInputEnabled(false);
                        delayedCall(2000, () => {
                            setPageBackground("bg-blue");
                            this.add(tryAgainWindow);
                            tryAgainWindow.show(score, starScore);
                            if (this.bgMusic) this.bgMusic.stop();
                        });
                    };
                    this.gameplay = gameplay;
                    window["t"] = this;
                }
                createHexagons() {
                    if (this.contentContainer && this.contentContainer.parentContainer) {
                        this.contentContainer.parentContainer.remove(this.contentContainer);
                    }

                    this.contentContainer = this.scene.add.container(0, 0);
                    this.gameplayContainer.addAt(this.contentContainer, this.gameplayContainer.getIndex(this._btnSound) + 1);
                    window['this.contentContainer'] = this.contentContainer;

                    this.light = new Phaser.GameObjects.Image(this.scene, 484, 321, 'light');
                    this.light.alpha = 0;
                    this.contentContainer.add(this.light);

                    window['this.gameplayContainer'] = this.gameplayContainer;

                    let firstWord = this.gameplay.getCorrectLetters()[1];
                    if (this.gameplay.useImages) {
                        this.firstWordText = new Phaser.GameObjects.Image(this.scene, 0, 0, firstWord);
                    } else {
                        this.firstWordText = this.scene.add.text(0, 0, firstWord, {
                            "fontFamily": "QuranEraV3",
                            "fontSize": 50,
                            "color": "#333333",
                            "align": 'center'
                        });
                        this.firstWordText.setOrigin(0.5, 0.5);
                        this.firstWordText.setPadding({ left: 0, right: 0, top: 65, bottom: 65 });
                    }
                    this.contentContainer.add(this.firstWordText);
                    this.firstWordText.setPosition(593, 85);
                    window['this.firstWordText'] = this.firstWordText;
                    if (this.firstWordText.width > 165) this.firstWordText.setScale(165 / this.firstWordText.width);
                    this.firstWordText.alpha = 0;
                    this.scene.tweens.add({
                        targets: this.firstWordText,
                        "alpha": 1,
                        duration: 10
                    });

                    if (this.gameplay.currentRound > 0) this.scene.sound.add('Movement').play();

                    for (let _i = 0; _i < this.wordRectPositions.length; _i++) {
                        let bookHolder = new Phaser.GameObjects.Image(this.scene, this.wordRectPositions[_i]['x'], this.wordRectPositions[_i]['y'] + 30, 'bookHolder' + _i);
                        this.contentContainer.addAt(bookHolder, 1);

                        let shadow = new Phaser.GameObjects.Image(this.scene, this.wordRectPositions[_i]['x'] + 5, this.wordRectPositions[_i]['y'] + 100, 'shadow' + _i);
                        this.contentContainer.addAt(shadow, 1);

                        if (this.gameplay.getCurrentTotalAnswersCount() === 0) {
                            bookHolder.y = -100;
                            this.scene.tweens.add({
                                targets: bookHolder,
                                "y": this.wordRectPositions[_i]['y'] + 30,
                                duration: 400,
                                ease: Phaser.Math.Easing.Quadratic.In,
                                delay: _i * 425 + 1000
                            });

                            shadow.setScale(0.5);
                            shadow.alpha = 0;
                            this.scene.tweens.add({
                                targets: shadow,
                                "alpha": 1,
                                "scaleX": 1,
                                "scaleY": 1,
                                delay: _i * 425 + 1000,
                                duration: 400,
                                ease: Phaser.Math.Easing.Quadratic.In
                            });
                        }
                    }
                    if (this.gameplay.getCurrentTotalAnswersCount() === 0) {
                        delayedCall(1250, () => this.scene.sound.add('Sound boxes falling').play());
                    }

                    this.wordsRects = [];
                    let _i = 0;
                    for (let p of this.wordRectPositions) {
                        let hc = this.scene.add.container(this.wordRectPositions[_i]['x'], this.wordRectPositions[_i]['y']);
                        let hcIdleMotionContainer = this.scene.add.container();
                        hc.add(hcIdleMotionContainer);
                        let h = this.scene.add.sprite(0, 0, 'selectRect');
                        hc["-image-"] = h;
                        hc['-draggable-'] = true;
                        hc.add(h);
                        hc["bg"] = h;
                        window['hc_' + _i] = hc;
                        window['h_' + _i] = h;
                        hcIdleMotionContainer.add(h);
                        hc['hcIdleMotionContainer'] = hcIdleMotionContainer;

                        let doIdleMove = () => {
                            if (!this.scene) return;
                            hcIdleMotionContainer['idleTween'] = this.scene.tweens.add({
                                targets: hcIdleMotionContainer,
                                "x": (0 + Math.random() * 6) * (Math.random() > 0.5 ? 1 : -1),
                                "y": (0 + Math.random() * 6) * (Math.random() > 0.5 ? 1 : -1),
                                yoyo: true,
                                delay: Math.random() > 0.5 ? 0 : Math.random() * 500,
                                duration: 1500,
                                ease: Phaser.Math.Easing.Quadratic.InOut,
                                onComplete: doIdleMove
                            });
                        };
                        // doIdleMove();

                        hc['startPosition'] = { x: hc.x, y: hc.y };

                        hc["defX"] = p['x'];
                        hc["defY"] = p['y'];
                        this.wordsRects.push(hc);
                        this.contentContainer.add(hc);
                        hc['index'] = _i;
                        _i++;
                    }
                    window['this.cars'] = this.wordsRects;

                    this.frameWhiteContainer = this.scene.add.container(0, 0);
                    this.contentContainer.addAt(this.frameWhiteContainer, 0);
                    this.frameWhiteContainer.alpha = 0;

                    this.frameWhiteLeft = new Phaser.GameObjects.Image(this.scene, 380, 84, 'frameWhite');
                    this.frameWhiteLeft.scaleX = -1.1;
                    this.frameWhiteLeft.setPosition(380, 84);
                    window['this.frameWhiteLeft'] = this.frameWhiteLeft;
                    this.frameWhiteContainer.add(this.frameWhiteLeft);

                    this.frameWhiteRight = new Phaser.GameObjects.Image(this.scene, 597, 84, 'frameWhite');
                    this.frameWhiteRight.scaleX = 1.05;
                    window['this.frameWhiteRight'] = this.frameWhiteRight;
                    this.frameWhiteContainer.add(this.frameWhiteRight);
                }
                createLetters() {
                    /* if (this.letters) {
                        for (let l of this.letters) {
                            l.parentContainer["letter"] = null;
                            l["hexagon"] = null;
                            l.parentContainer.remove(l);
                        }
                    } */

                    this.letters = [];
                    let _letters = this.gameplay.getCurrentRoundLetters();
                    for (let n of _letters) {
                        let wordText;
                        if (this.gameplay.useImages) {
                            wordText = new Phaser.GameObjects.Image(this.scene, 0, 0, n);
                        } else {
                            wordText = this.scene.add.text(0, 0, n, {
                                "fontFamily": "QuranEraV3",
                                "fontSize": 50,
                                "color": "#0d0c0c",
                                "align": 'center'
                            });
                            wordText.setOrigin(0.5, 0.5);
                            wordText.setPadding({ left: 0, right: 0, top: 65, bottom: 65 });
                        }
                        this.add(wordText);

                        if (wordText.width > 165) wordText.setScale(165 / wordText.width);
                        wordText["key"] = n;
                        this.letters.push(wordText);
                        window['wordText'] = wordText;

                        if (this.gameplay.getCurrentTotalAnswersCount() !== 0) {
                            wordText.alpha = 0;
                            this.scene.tweens.add({
                                targets: wordText,
                                "alpha": 1,
                                duration: 10
                            });
                        }
                    }
                }
                showGameplay() {
                    this.isLost = false;
                    setPageBackground("bg-australia");
                    this.bgMusic = this.scene.sound.add("bg_sound");
                    // this.bgMusic.play();
                    this.bgMusic.loop = true;
                    this.gameplay.reset();
                    this._gameStage = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2, game.scale.height / 2, 'bg');
                    this._gameStage.setOrigin(0.5, 0.5);
                    this._gameStage.setInteractive();
                    window['this._gameStage'] = this._gameStage;
                    // let selectRect = this.scene.add.sprite(598, 84, 'selectRect');
                    // window['selectRect']=selectRect;

                    this._btnSound = new Phaser.GameObjects.Image(this.scene, 160 - 105, 100 - 50, 'Sound');
                    this._btnSound.setInteractive({ cursor: 'pointer' });
                    this._btnSound["defScale"] = this._btnSound.scale;
                    setupButtonTextureBased(this._btnSound, 'Sound', 'Sound HOVER EFFECT');
                    this._btnClose = new Phaser.GameObjects.Image(this.scene, 1025 - 105, 100 - 50, 'x Button');
                    this._btnClose.setInteractive({ cursor: 'pointer' });
                    this._btnClose["defScale"] = this._btnClose.scale;
                    setupButtonTextureBased(this._btnClose, 'x Button', 'x Button HOVER EFFECT');
                    this.gameplayContainer = new Phaser.GameObjects.Container(this.scene);
                    this.addAt(this.gameplayContainer, 0);
                    this.gameplayContainer.add([
                        this._gameStage,
                        // selectRect,
                        this._btnSound,
                        this._btnClose
                    ]);

                    this.createBeehives();
                    this.shuffleOutHexagons();
                    this.gameplay.setupCallbacks(this.showCompleteWindow, this.showLoseWindow);
                }
                createBeehives() {
                    let startX = 45;
                    let startY = 125;
                    let dy = 35;
                    let _BeehiveEmptyArrayPositions = [];
                    for (let i = 0; i < this.gameplay.getMaxTotalAnswersCount(); i++) {
                        _BeehiveEmptyArrayPositions.push({ x: startX, y: startY + i * dy });
                    }
                    this._BeehiveEmptyArray = []; window["_BeehiveEmptyArray"] = this._BeehiveEmptyArray;
                    this._Beehive = [];
                    for (let p of _BeehiveEmptyArrayPositions) {
                        let _BeehiveEmpty = new Phaser.GameObjects.Image(this.scene, p['x'], p['y'], 'Beehive 1 Empty');
                        this._BeehiveEmptyArray.push(_BeehiveEmpty);
                        _BeehiveEmpty.setScale(0.9);
                        _BeehiveEmpty.visible = false;
                        let _Beehive = new Phaser.GameObjects.Image(this.scene, p['x'], p['y'], 'Beehive 1');
                        _Beehive.setScale(0.9);
                        this._Beehive.push(_Beehive);
                    }
                    for (let bea of this._BeehiveEmptyArray) {
                        this.gameplayContainer.add(bea);
                    }
                    for (let bee of this._Beehive) {
                        this.gameplayContainer.add(bee);
                        bee.visible = false;
                    }
                }
                randomizeLettersPosition() {
                    let hx = this.wordsRects.slice();
                    for (let l of this.letters) {
                        if (hx.length == 0)
                            return;
                        let hc = Phaser.Utils.Array.RemoveRandomElement(hx);
                        hc['hcIdleMotionContainer'].add(l);
                        hc["letter"] = l;
                        hc["-letter-text"] = l.key ?? l.text;
                        l["hexagon"] = hc;
                    }
                }
                updateHexagonsArrange() {
                    for (let hc of this.wordsRects) {
                        if (!hc["letter"]) {
                            hc.parentContainer.bringToTop(hc);
                            break;
                        }
                    }
                }
                shuffleOutHexagons() {
                    this.createHexagons();

                    let setLettersInputEnabled = () => {
                        // if (this.correctAudio && this.correctAudio.isPlaying) {
                        delayedCall((this.correctAudio.duration * 0.8) * 1000, () => {
                            this.setLettersInputEnabled(true);
                        });
                        // }
                        // else {
                        // this.setLettersInputEnabled(true);
                        // }
                    };

                    delayedCall(this.gameplay.getCurrentTotalAnswersCount() === 0 ? 2200 : 100, () => {
                        if (!this.gameplay.isRoundsComplete()) {
                            if (this.gameplay.isCorrectLetterAudioQuestionEnable()) {
                                this.playCorrectAudio();
                            }
                            setLettersInputEnabled();
                        }
                    });

                    if (this.sfxCarAccelerating) {
                        this.sfxCarAccelerating.stop();
                        this.sfxCarAccelerating = null;
                    }
                    if (this.sfxWrong) {
                        this.sfxWrong.stop();
                        this.sfxWrong = null;
                    }

                    if (!this.gameplay.isRoundsComplete()) {
                        this.createLetters();
                        this.randomizeLettersPosition();
                    }

                    this.setLettersInputEnabled(false);
                    this.updateHexagonsArrange();
                    // Phaser.Utils.Array.Shuffle(this.carsPositions);
                    let cars = this.wordsRects;
                    for (let i = 0; i < cars.length; i++) {
                        let hc = cars[i];
                        hc["defX"] = this.wordRectPositions[i]["x"];
                        hc["defY"] = this.wordRectPositions[i]["y"];
                        this.scene.tweens.killTweensOf(hc);

                        if (this.gameplay.getCurrentTotalAnswersCount() === 0) {
                            hc.y = -100;
                            this.scene.tweens.add({
                                targets: hc,
                                y: hc["defY"],
                                duration: 400,
                                ease: Phaser.Math.Easing.Quadratic.In,
                                delay: i * 425 + 1000,
                            });
                        }
                    }

                    for (let c of cars) this.gameplayContainer.remove(c);
                    this.wordsRects.sort((c1, c2) => c1.y - c2.y);
                    // for (let c of cars) this.gameplayContainer.add(c);

                    this.createInput();
                    this.setLettersInputEnabled(false);
                }
                shuffleInHexagons() {
                    this.updateHexagonsArrange();
                    let positions = this.wordRectPositions.slice();
                    this.setLettersInputEnabled(false);

                    // delayedCall(600, () => {
                    // this.scene.sound.add('move to centre').play();
                    this.shuffleOutHexagons();
                    // });
                }
                onCorrectDragsMade() {
                    let sfxKeyOnLeft = this.gameplay.getCorrectAndLetterSoundSfxAudioKey(1);
                    let sfxKeyOnRight = this.gameplay.getCorrectAndLetterSoundSfxAudioKey(2);

                    let completed = this.onCorrectAnswer();

                    // this.scene.sound.add('Snail giggling sound - correct selection').play();

                    this.scene.tweens.add({
                        targets: this.light,
                        "alpha": 1,
                        ease: Phaser.Math.Easing.Cubic.In,
                        duration: 500,
                        onComplete: () => {
                            this.scene.tweens.add({
                                targets: this.light,
                                "alpha": 0,
                                ease: Phaser.Math.Easing.Cubic.In,
                                duration: 500,
                                delay: 1250,
                            });
                        }
                    });

                    // delayedCall(1250, () => {
                    // let sndRight = this.scene.sound.add(sfxKeyOnRight);
                    // sndRight.once('complete', ()=>{
                    delayedCall(1250, () => {
                        let sndLeft = this.scene.sound.add(sfxKeyOnLeft);
                        sndLeft.play();
                        sndLeft.once('complete', () => {
                            delayedCall(completed ? 500 : 500/* 2250 */, () => {
                                if (!completed) {
                                    delayedCall(0, () => {
                                        for (let _hc of this.wordsRects) {
                                            this.scene.tweens.add({
                                                targets: _hc["letter"],
                                                "alpha": 0,
                                                ease: Phaser.Math.Easing.Cubic.In,
                                                duration: 10
                                            });
                                        }

                                        this.scene.tweens.add({
                                            targets: this.firstWordText,
                                            "alpha": 0,
                                            ease: Phaser.Math.Easing.Cubic.In,
                                            duration: 10
                                        });
                                        this.scene.sound.add('Movement').play();
                                    });

                                    delayedCall(750, () => {
                                        this.shuffleInHexagons();
                                    });
                                } else {
                                    this.scene.sound.add("Success 2").play();
                                }
                            });
                        });
                        // });
                        // });
                        // sndRight.play();
                    });

                    // delayedCall(650, () => this.scene.sound.add('Going up sound').play())
                    // if (completed) delayedCall(1750, () => this.scene.sound.add('Final celebration sound').play())

                    this.scene.tweens.add({
                        targets: this.frameWhiteContainer,
                        "alpha": 1,
                        duration: 300
                    });

                    let l = this.lastCorrectBlock["-block-"]["letter"];
                    let mid = (this.firstWordText.width + l.width) / 2;
                    let dx = mid - this.firstWordText.width;

                    this.scene.tweens.add({
                        targets: this.firstWordText,
                        "x": 493 + dx - 6,
                        "originX": 0,
                        delay: 300,
                        duration: 300,
                        onUpdate: () => {
                            this.firstWordText.setOrigin(this.firstWordText.originX, this.firstWordText.originY);
                        }
                    });
                    this.scene.tweens.add({
                        targets: this.lastCorrectBlock["-block-"]["bg"],
                        "alpha": 0,
                        duration: 300
                    });

                    this.scene.tweens.add({
                        targets: l,
                        "x": 101 + dx + 6,
                        "originX": 1,
                        delay: 300,
                        duration: 300,
                        onUpdate: () => {
                            l.setOrigin(l.originX, l.originY);
                        }
                    });
                }
                createInput() {
                    this.scene.input.on('drag', (pointer, block, dragX, dragY) => {
                        if (!block['-draggable-'])
                            return;
                        block.x = dragX;
                        block.y = dragY;
                        block.parentContainer.bringToTop(block);
                    });
                    console.log("CORRECT WORDS: ", this.gameplay.getCorrectLetters());
                    this.targetBlocks = [];
                    let bb = [{ x: 375, y: 84 }];
                    // for (let i = 0; i < bb.length; i++) {
                    let b = bb[0/* i */];
                    b['alreadyFilled'] = false;
                    this.targetBlocks.push(b);
                    b["-letter-text"] = this.gameplay.getCorrectLetters()[0/* i */];
                    b["-block-"] = null;
                    // }
                    window['this.targetBlocks'] = this.targetBlocks;

                    for (let a of this.wordsRects) {
                        // let correctAnswer = hc["letter"] && hc["letter"]["key"] == this.gameplay.getCorrectLetters(1);
                        //hc["letter"].alpha = correctAnswer ? 1 : 0.5;

                        a.setSize(a["-image-"].width, a["-image-"].height);
                        a.setInteractive({ cursor: 'pointer' });
                        this.scene.input.setDraggable(a, true);
                        a.on('pointerdown', () => {
                            if (a["-placedAtBlock-"]) {
                                a["-placedAtBlock-"]['alreadyFilled'] = false;
                                a["-placedAtBlock-"] = null;
                            }

                            a['-pointerdown-'] = true;
                            if (a['-draggable-']) this.scene.sound.add("Move the block from its spot").play();
                        });
                        a.on('pointerup', () => {
                            a['-pointerdown-'] = false;
                            if (!a['-draggable-'])
                                return;

                            let wasTargetBlockFound = false;
                            let targetBlock;
                            for (targetBlock of this.targetBlocks) {
                                if (targetBlock['alreadyFilled'])
                                    continue;
                                if (Phaser.Math.Distance.Between(a.x, a.y, targetBlock.x, targetBlock.y) < 50) {
                                    //as
                                    // a['-draggable-'] = false;
                                    targetBlock['alreadyFilled'] = true;
                                    this.scene.tweens.add({
                                        targets: a,
                                        x: targetBlock.x,
                                        y: targetBlock.y,
                                        duration: 200,
                                        ease: Phaser.Math.Easing.Back.Out
                                    });
                                    targetBlock["-block-"] = a;
                                    a["-placedAtBlock-"] = targetBlock;
                                    this.scene.sound.add("Dopping the block").play();

                                    wasTargetBlockFound = true;
                                    break;
                                }
                            }

                            let allTargetsFilled = true;
                            for (targetBlock of this.targetBlocks) {
                                if (!targetBlock['alreadyFilled']) {
                                    allTargetsFilled = false;
                                    break;
                                }
                            }
                            if (allTargetsFilled) this.checkTargetBlockLetters();

                            if (!wasTargetBlockFound) {
                                this.moveBridgeBackToStartPosition(a, null, true);
                            }
                        });
                        a.on('pointerout', () => {
                            if (!a['-draggable-'])
                                return;
                            if (!a['-pointerdown-'])
                                return;
                            this.moveBridgeBackToStartPosition(a, null, true);
                        });
                    }
                    this._btnSound.on('pointerup', () => {
                        this.playBtnClickAnim(this._btnSound);
                        this.onSoundClick();
                    });
                    this._btnClose.on('pointerup', () => {
                        this.playBtnClickAnim(this._btnClose);
                        this.onCloseClick();
                    });
                }
                hideAllUnusedBeehives() {
                    let i = this.gameplay.getCurrentTotalAnswersCount();
                    for (let k = i + 1; k < this._BeehiveEmptyArray.length; k++) {
                        this._BeehiveEmptyArray[k].visible = false;
                        this._Beehive[k].visible = false;
                    }
                }
                checkTargetBlockLetters() {
                    let sameLettersNum = 0;
                    for (let targetBlock of this.targetBlocks) {
                        if (!targetBlock['-block-']) {
                            // this.scene.sound.add("Placing block above").play();
                            return;
                        }
                        if (targetBlock["-letter-text"] == targetBlock['-block-']["-letter-text"]) {
                            sameLettersNum++;
                            this.lastCorrectBlock = targetBlock;
                        }
                    }

                    this.setLettersInputEnabled(false);
                    if (sameLettersNum == this.targetBlocks.length) {
                        // this.scene.sound.add("Blocks disappearing").play();

                        this.setLettersInputEnabled(false);
                        delayedCall(250, () => {
                            this.onCorrectDragsMade();
                        });
                    } else {
                        // for (let targetBlock of this.targetBlocks) targetBlock['-block-']["-image-"].setTexture('DoughWrong');

                        // delayedCall(500, () => { this.scene.sound.add("wrong drop").play(); });
                        delayedCall(900, () => {
                            for (let targetBlock of this.targetBlocks) {
                                // for (let targetBlock of this.targetBlocks) targetBlock['-block-']["-image-"].setTexture('DoughNormal');
                                this.moveBridgeBackToStartPosition(targetBlock['-block-'], null, false);
                            }
                            for (let targetBlock of this.targetBlocks) {
                                targetBlock['alreadyFilled'] = false;
                                targetBlock['-block-']['-draggable-'] = true;
                                targetBlock['-block-']["-placedAtBlock-"] = null;
                                targetBlock["-block-"] = null;
                            }
                            // delayedCall(100, ()=>this.scene.sound.add("all three blocks move back after wrong").play());
                        });
                        delayedCall(650, () => this.scene.sound.add("Two blocks move back after a wrong placement").play());
                        delayedCall(150, () => {
                            let lost = this.onWrongAnswer();

                            // delayedCall(650, () => {this.scene.sound.add('No snail animation sound').play();});

                            delayedCall(2000, () => {
                                if (!lost) this.setLettersInputEnabled(true);
                            });
                        });
                    }
                }
                moveBridgeBackToStartPosition(block, onComplete, playSound) {
                    this.scene.tweens.add({
                        targets: block,
                        x: block['startPosition'].x,
                        y: block['startPosition'].y,
                        duration: 200,
                        ease: Phaser.Math.Easing.Sine.Out,
                        onComplete: () => {
                            if (onComplete)
                                onComplete();
                        }
                    });
                    if (Phaser.Math.Distance.Between(block['startPosition'].x, block['startPosition'].y, block.x, block.y) > 20) {
                        delayedCall(100, () => {
                            if (playSound) {
                                this.scene.sound.add("Block goes back when released").play();
                            }
                        });
                    }
                }
                onCorrectAnswer() {
                    let i = this.gameplay.getCurrentTotalAnswersCount();
                    if (i < this._BeehiveEmptyArray.length) {
                        this._BeehiveEmptyArray[i].visible = false;
                        this._Beehive[i].visible = true;
                    }
                    this.hideAllUnusedBeehives();

                    let completed = this.gameplay.onCorrectAnswer();
                    this.scene.sound.add('Correct sfx').play();

                    // this.sfxCarAccelerating = this.scene.sound.add('Car accelerating');
                    // this.sfxCarAccelerating.play();
                    return completed;
                }
                onWrongAnswer(forceNewRound) {
                    let i = this.gameplay.getCurrentTotalAnswersCount();
                    if (i < this._BeehiveEmptyArray.length) {
                        this._BeehiveEmptyArray[i].visible = true;
                        this._Beehive[i].visible = false;
                    }
                    this.hideAllUnusedBeehives();
                    let lost = this.gameplay.onWrongAnswer(forceNewRound);
                    this.sfxWrong = this.scene.sound.add("wrong sfx");
                    this.sfxWrong.play();
                    return lost;
                }
                playCorrectAudio() {
                    if (this.correctAudio) {
                        this.correctAudio.stop();
                    }
                    this.correctAudio = this.scene.sound.add("englQuestion");
                    this.correctAudio.once('complete', () => {
                        this.correctAudio = this.scene.sound.add(this.gameplay.getCorrectAndLetterSoundSfxAudioKey(1));
                        this.correctAudio.play();
                    });
                    this.correctAudio.play();
                    if (this.areYouSureWindow && this.areYouSureWindow.parentContainer == this) {
                        this.correctAudio.pause();
                    }
                }
                onSoundClick() {
                    this.playCorrectAudio();
                }
                onCloseClick() {
                    this.showAreYouSurePage();
                    this.scene.sound.add('warning page pop up sfx').play();
                }
                playBtnClickAnim(target) {
                    let sc = target["defScale"] ? target["defScale"] : 1;
                    target.scaleX = target.scaleY = sc;
                    this.scene.tweens.add({
                        targets: target,
                        "scaleX": 0.9 * sc,
                        "scaleY": 0.9 * sc,
                        duration: 100,
                        yoyo: true
                    });
                }
                showInstructionPage() {
                    setPageBackground("bg-blue");
                    this.instructionPage = new screen.InstructionPage(this.scene, (target) => {
                        this.playBtnClickAnim(target);
                        this.remove(this.instructionPage);
                        this.showGameplay();
                        if (this.wfsnd) {
                            this.wfsnd.stop();
                        }
                    }, (target) => {
                        this.playBtnClickAnim(target);
                        if (this.wfsnd) {
                            this.wfsnd.stop();
                        }
                        if (!game.cache.json.get('gameplay')['welcomeAudioDisabled']) {
                            this.wfsnd = this.scene.sound.add("Welcome Find the sound");
                            this.wfsnd.play();
                        }
                    });
                    this.add(this.instructionPage);
                    try {
                        if (!game.cache.json.get('gameplay')['welcomeAudioDisabled']) {
                            this.wfsnd = this.scene.sound.add("Welcome Find the sound");
                            this.wfsnd.play();
                        }
                    }
                    catch (e) {
                        console.error(e);
                    }
                }
                showAreYouSurePage() {
                    /* for (let j = 0; j < this.cars.length; j++) {
                        if (this.cars[j]["raceTween"]) {
                            this.cars[j]["raceTween"].pause();
                        }
                    } */

                    pauseAllDelayedCalls();
                    setPageBackground("bg-blue");
                    this.pauseSounds();
                    if (!this.areYouSureWindow) this.areYouSureWindow = new screen.AreYouSureWindow(this.scene, () => {
                        this.remove(this.areYouSureWindow);
                        this.destroyGameplay();
                        this.showInstructionPage();
                    }, () => {
                        this.remove(this.areYouSureWindow);
                        this.unpauseSounds();
                        resumeAllDelayedCalls();

                        /* for (let j = 0; j < this.cars.length; j++) {
                            if (this.cars[j]["raceTween"]) {
                                this.cars[j]["raceTween"].resume();
                            }
                        } */

                        setPageBackground("bg-australia");
                    });
                    this.add(this.areYouSureWindow);
                }
                setLettersInputEnabled(enabled) {
                    if (enabled) {
                        for (let hc of this.wordsRects) {
                            hc.setInteractive({ cursor: 'pointer' });
                            this.scene.input.setDraggable(hc, true);
                            // hc["bg"].setInteractive(new Phaser.Geom.Rectangle(80, 100, 240, 200), Phaser.Geom.Rectangle.Contains);
                        }
                    }
                    else {
                        for (let hc of this.wordsRects) {
                            try { this.scene.input.setDraggable(hc, false); } catch (e) { }
                            hc.disableInteractive();
                        }
                    }
                }
                pauseSounds() {
                    if (this.correctAudio)
                        this.correctAudio.pause();
                    if (this.bgMusic)
                        this.bgMusic.pause();
                }
                unpauseSounds() {
                    if (this.correctAudio)
                        this.correctAudio.resume();
                    if (this.bgMusic)
                        this.bgMusic.resume();
                }
                destroyGameplay() {
                    this.setLettersInputEnabled(false);
                    this.remove(this.gameplayContainer);
                    this.scene.sound.stopAll();
                    destroyAllDelayedCalls();
                }
            }
            screen.GameplayScreen = GameplayScreen;
        })(screen = sh.screen || (sh.screen = {}));
    })(sh || (sh = {}));
    (function (sh) {
        var screen;
        (function (screen) {
            class InstructionPage extends Phaser.GameObjects.Container {
                constructor(scene, onPlayClick, onSndClick) {
                    super(scene);
                    this._instructionPage = new Phaser.GameObjects.Image(this.scene, 0 - 105, 0 - 48, 'Instructions page  ALL ACTIVITY  TITLEs');
                    this._instructionPage.setOrigin(0, 0);
                    this._instructionPage.setInteractive();

                    this._instructionPageTitle = this.scene.add.text(475, 110, sh.App.json.instructionTitle ?? 'Mosque', {
                        "fontFamily": "Kids Rock DEMO",
                        "fontSize": 45,
                        "color": "#43425D",
                        "align": 'center'
                    });
                    this._instructionPageTitle.setOrigin(0.5, 0.5);
                    window['this._instructionPageTitle'] = this._instructionPageTitle;
                    this._instructionPageTitle.setStroke('#ffffff', 5);
                    //  Apply the gradient fill.
                    const gradient = this._instructionPageTitle.context.createLinearGradient(0, 0, 0, this._instructionPageTitle.height);
                    gradient.addColorStop(0, '#eeef67');
                    gradient.addColorStop(0.55, '#e98c2c');
                    gradient.addColorStop(1, '#91301a');
                    this._instructionPageTitle.setFill(gradient);

                    this._btnPlay = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2, 480 - 50, 'btnPLAY1');
                    this._btnPlay.setInteractive({ cursor: 'pointer' });
                    this._btnPlay.once('pointerup', onPlayClick);
                    setupButtonTextureBased(this._btnPlay, 'btnPLAY1', 'btnPLAY2');
                    this.instrTxt = this.scene.add.text(game.scale.width / 2, game.scale.height / 2, "Complete the verse by dragging the \n right word to the board.", {
                        "fontFamily": "Kids Rock DEMO",
                        "fontSize": 30,
                        "lineSpacing": 15,
                        "color": "#43425D",
                        "align": 'center'
                    });
                    this.instrTxt.setOrigin(0.5, 0.5);
                    this._btnSoundInstruction = new Phaser.GameObjects.Image(this.scene, 800 - 105, 156 - 50, 'Sound');
                    this._btnSoundInstruction.setInteractive({ cursor: 'pointer' });
                    this._btnSoundInstruction.on('pointerup', onSndClick);
                    this._btnSoundInstruction["defScale"] = this._btnSoundInstruction.scale;
                    setupButtonTextureBased(this._btnSoundInstruction, 'Sound', 'Sound HOVER EFFECT');
                    this.add(this._instructionPage);
                    this.add(this._instructionPageTitle);
                    this.add(this.instrTxt);
                    this.add(this._btnPlay);
                    this.add(this._btnSoundInstruction);
                }
            }
            screen.InstructionPage = InstructionPage;
        })(screen = sh.screen || (sh.screen = {}));
    })(sh || (sh = {}));
    (function (sh) {
        var screen;
        (function (screen) {
            class TryAgainWindow extends Phaser.GameObjects.Container {
                constructor(scene, onBack, onReplay) {
                    super(scene);
                    this.music = null;
                    this.setPosition(-106, -48);
                    this._bg = new Phaser.GameObjects.Image(this.scene, 0, 0, 'Try again page');
                    this._bg.setOrigin(0, 0);
                    this._bg.setInteractive();
                    this._star = new Phaser.GameObjects.Image(this.scene, 400, 415, 'Break Star');
                    this._btnBack = new Phaser.GameObjects.Image(this.scene, 600, 580, 'btnBACK1');
                    this._btnReplay = new Phaser.GameObjects.Image(this.scene, 765, 580, 'btnReplay1');
                    this.totalScoreTxt = this.scene.add.text(850, 355, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 35,
                        "color": "#F49F1C",
                        "align": 'center',
                        'stroke': '#70451A',
                        'strokeThickness': 6
                    });
                    this.totalScoreTxt.setOrigin(0.5, 0.5);
                    let grd = this.totalScoreTxt.context.createLinearGradient(0, 0, 0, this.totalScoreTxt.height);
                    grd.addColorStop(0, '#FFFF00');
                    grd.addColorStop(1, '#C17316');
                    this.totalScoreTxt.setFill(grd);
                    this.starScoreTxt = this.scene.add.text(635, 431, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 24,
                        "color": "#FFFFFF",
                        "align": 'center'
                    });
                    this.starScoreTxt.setOrigin(0.5, 0.5);
                    this.add([
                        this._bg,
                        this._star,
                        this._btnBack,
                        this._btnReplay,
                        this.totalScoreTxt,
                        this.starScoreTxt
                    ]);
                    this._btnBack.setInteractive({ cursor: 'pointer' });
                    this._btnBack.on('pointerup', () => {
                        onBack(this._btnBack);
                        angularComponentRef.backToMenu();
                        // if (this.music) {
                        //     this.music.stop();
                        // }
                    });
                    setupButtonTextureBased(this._btnBack, 'btnBACK1', 'btnBACK2');
                    this._btnReplay.setInteractive({ cursor: 'pointer' });
                    this._btnReplay.once('pointerup', () => {
                        onReplay(this._btnReplay);
                        if (this.music) {
                            this.music.stop();
                        }
                    });
                    setupButtonTextureBased(this._btnReplay, 'btnReplay1', 'btnReplay2');
                }
                show(score, starScore) {
                    this._star.scale = 1.25;
                    this.scene.tweens.add({
                        targets: this._star,
                        "scale": 1,
                        duration: 500,
                        ease: Phaser.Math.Easing.Back.Out
                    });
                    this.totalScoreTxt.text = String(window.angularComponentRef.component.userInfo.totalScore);
                    this.starScoreTxt.text = String(0);
                    this.music = this.scene.sound.add("Fail - close one");
                    this.music.play();
                }
            }
            screen.TryAgainWindow = TryAgainWindow;
        })(screen = sh.screen || (sh.screen = {}));
    })(sh || (sh = {}));
}

function destroymosqueCV() {
    if (game) {
        game.destroy();
    }
    
}

var game;
var sh;
function iceBoard(json) {
    /**
     * @author Roman Parada
     * This class is created to fix overlapping of bottom part of canvas by navigation bar in iOS.
     * It make a delayed resize of the canvas (like Phaser-3 FIT methods does) and it overrides Phaser-3 input window to Phaser-3 core transform methods
     *
     * How to use:
     * Just call the code line below in Boot scene's init() method of your project:
     * new FitScaleManager(this.game).setup();
     */
    class FitScaleManager {
        constructor(game) {
            this.doResize = () => {
                let scale = this.calculateScale();
                let newCanvasWidth = this.phaserScaleManager.width * scale;
                let newCanvasHeight = this.phaserScaleManager.height * scale;
                this.canvasStyle.width = newCanvasWidth + 'px';
                this.canvasStyle.height = newCanvasHeight + 'px';
                this.canvasStyle.marginLeft = (window.innerWidth - newCanvasWidth) / 2 + 'px';
                this.canvasStyle.marginTop = (window.innerHeight - newCanvasHeight) / 2 + 'px';
            };
            this.game = game;
            this.canvasStyle = this.game.canvas.style;
            this.phaserScaleManager = this.game.scale;
        }
        static detectBestScaleMode() {
            let iOS = /iPad|iPhone|iPod/.test(navigator.platform || "");
            let isAndroid = window.navigator.userAgent.toLowerCase().indexOf("android") > -1;
            return iOS || isAndroid ? Phaser.Scale.FIT : Phaser.Scale.NONE;
        }
        ;
        /**
         * Just call this method once in Boot scene's init() method
         */
        setup() {
            this.phaserScaleManager.addListener(Phaser.Scale.Events.RESIZE, this.onResize, this);
            this.overridePhaserTransformMethods();
            this.onResize();
        }
        calculateScale() {
            if (game.scale.scaleMode === Phaser.Scale.NONE)
                return 1;
            return Math.min(window.innerWidth / this.phaserScaleManager.width, window.innerHeight / this.phaserScaleManager.height);
        }
        overridePhaserTransformMethods() {
            this.game.scale.transformX = (pageX) => {
                return (pageX - parseInt(this.canvasStyle.marginLeft.split("px")[0])) / this.calculateScale();
            };
            this.game.scale.transformY = (pageY) => {
                return (pageY - parseInt(this.canvasStyle.marginTop.split("px")[0])) / this.calculateScale();
            };
        }
        onResize() {
            setTimeout(this.doResize, FitScaleManager.RESIZE_DELAY);
        }
    }
    FitScaleManager.RESIZE_DELAY = 500;

    (function (sh) {
        class App extends Phaser.Game {
            constructor(json) {
                App.json = json;
                // console.log(App.json);

                let config = {
                    type: Phaser.AUTO,
                    width: App.CANVAS_WIDTH,
                    height: App.CANVAS_HEIGHT,
                    parent: 'game-container',
                    dom: {
                        createContainer: false
                    },
                    scale: {
                        mode: FitScaleManager.detectBestScaleMode(),
                        autoCenter: Phaser.Scale.CENTER_BOTH
                    },
                    transparent: true,
                    scene: {
                        create: () => {
                            this.scene.add('Boot', sh.scene.Boot, true);
                        }
                    }
                };
                super(config);
            }
        }
        App.CANVAS_WIDTH = 980;
        App.CANVAS_HEIGHT = 600;
        sh.App = App;
    })(sh || (sh = {}));

    game = new sh.App(json);

    var delayedCalls = [];
    function delayedCall(delay, callback, args, callbackScope) {
        let scene = game.scene.getAt(0);
        if (scene) {
            let dc = scene.time.delayedCall(delay, callback, args, callbackScope);
            delayedCalls.push(dc);
            return dc;
        }
        let t = setTimeout(callback, delay);
        delayedCalls.push(t);
        return t;
    }

    function pauseAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.paused = true;
            }
        }
    }

    function resumeAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.paused = false;
            }
        }
    }

    function destroyAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.remove(false);
            }
            else {
                clearTimeout(dc);
            }
        }
        delayedCalls = [];
    }

    function setPageBackground(bg) {
        // document.querySelector("html").style.backgroundImage = "url(assets/games/ice-board/imgs/" + bg + ".jpg)";
    }

    function setupButton(btn, frame) {
        btn.on('pointerdown', () => { btn.setFrame(frame + '_hover' + '0000'); });
        btn.on('pointerover', () => { btn.setFrame(frame + '_hover' + '0000'); game.scene.getAt(0).sound.add("button hover").play(); });
        btn.on('pointerout', () => { btn.setFrame(frame + '0000'); });
        btn.on('pointerup', () => { btn.setFrame(frame + '0000'); game.scene.getAt(0).sound.add('activity selection - button selection').play(); });
    }

    function setupButtonTextureBased(btn, texture, hoverTexture) {
        btn.on('pointerdown', () => { btn.setTexture(hoverTexture); });
        btn.on('pointerover', () => { btn.setTexture(hoverTexture); game.scene.getAt(0).sound.add("button hover").play(); });
        btn.on('pointerout', () => { btn.setTexture(texture); });
        btn.on('pointerup', () => { btn.setTexture(texture); game.scene.getAt(0).sound.add('activity selection - button selection').play(); });
    }

    (function (sh) {
        var core;
        (function (core) {
            class Gameplay {
                constructor() {
                    this.currentRound = 0;
                    this.currentLetter = 0;
                    this.correctAnswersCount = 0;
                    this.wrongAnswersCount = 0;
                    this.correctAnswersCountThisRound = 0;
                    this.wrongAnswersCountThisRound = 0;
                    this.reset();
                    let json = game.cache.json.get('gameplay');
                    this.wrongAnswersToLose = json["wrongAnswersToLose"];
                    this.numberOfQuestionsPerRound = json["numberOfQuestionsPerRound"];
                    this.lettersConfig = JSON.parse(JSON.stringify(json["lettersConfig"]));
                    this.rounds = JSON.parse(JSON.stringify(json["rounds"]));
                    this.numberOfRounds = json["numberOfRounds"] ?? this.rounds.length;
                    this.useImages = Boolean(game.cache.json.get('gameplay')["useImages"]);
                    this.lost = false;
                }
                setupCallbacks(onComplete, onLose) {
                    this.onComplete = onComplete;
                    this.onLose = onLose;
                }
                onLetterChosen(forceNewRound) {
                    if (forceNewRound || this.isNewRound()) {
                        return this.nextRound();
                    }
                    return false;
                }
                nextRound() {
                    this.correctAnswersCountThisRound = 0;
                    this.wrongAnswersCountThisRound = 0;
                    this.currentRound++;
                    if (this.isRoundsComplete()) {
                        this.onComplete(this.correctAnswersCount, this.correctAnswersCount);
                        return true;
                    }

                    return false;
                }
                getCorrectLetters() {
                    return this.rounds[this.currentRound]['letters'];
                }
                getCorrectLetterName() {
                    return this.rounds[this.currentRound]['correctLetterName'];
                }
                isCorrectLetterAudioQuestionEnable() {
                    return this.rounds[this.currentRound]['audioQuestionEnable'];
                }
                getCorrectAudioKey() {
                    return this.lettersConfig[this.getCorrectLetterName()]['correctAudioKey'];
                }
                getLetterSoundSfxAudioKey(letter) {
                    return "Q-" + this.lettersConfig[letter]['Sounds of the letters'];
                }
                getCorrectAndLetterSoundSfxAudioKey() {
                    return "Q-" + this.lettersConfig[this.getCorrectLetterName()]['Sounds of the letters'];
                }
                onCorrectAnswer() {
                    this.correctAnswersCountThisRound++;
                    this.correctAnswersCount++;
                    return this.onLetterChosen();
                }
                onWrongAnswer(forceNewRound) {
                    this.wrongAnswersCountThisRound++;
                    this.wrongAnswersCount++;
                    if (this.wrongAnswersCount >= this.wrongAnswersToLose) {
                        if (!this.lost) {
                            this.onLose(this.correctAnswersCount, this.correctAnswersCount);
                            this.lost = true;
                        }
                        return true;
                    }
                    /* else {
                        this.onLetterChosen(forceNewRound);
                    } */
                    return false;
                }

                getMaxTotalAnswersCount() {
                    return this.wrongAnswersToLose + this.numberOfRounds - 1;
                }

                getCurrentTotalAnswersCount() {
                    return this.correctAnswersCount + this.wrongAnswersCount;
                }
                isNewRound() {
                    return this.correctAnswersCountThisRound >= 1// || (this.correctAnswersCountThisRound + this.wrongAnswersCountThisRound) === 3 || (this.correctAnswersCountThisRound + this.wrongAnswersCountThisRound) === 0;
                }
                isRoundsComplete() {
                    return this.currentRound >= this.numberOfRounds && this.wrongAnswersCount < this.wrongAnswersToLose;
                }
                reset() {
                    this.currentRound = 0;
                    this.correctAnswersCount = 0;
                    this.wrongAnswersCount = 0;
                    this.lost = false;
                }
                getCurrentRoundLetters() {
                    return this.rounds[this.currentRound]["letters"];
                }
            }
            core.Gameplay = Gameplay;
        })(core = sh.core || (sh.core = {}));
    })(sh || (sh = {}));

    (function (sh) {
        var scene;
        (function (scene) {
            class Boot extends Phaser.Scene {
                init() {
                    this.game.scale.transformX = (pageX) => {
                        let offsetLeft = 0;
                        let parentElement = game.canvas.parentElement;
                        while (parentElement) {
                            if (parentElement.offsetLeft) {
                                offsetLeft = parentElement.offsetLeft;
                                break;
                            }
                            parentElement = parentElement.parentElement;
                        }
                        return (pageX - offsetLeft) * this.game.scale.displayScale.x;
                    };
                    this.game.scale.transformY = (pageY) => {
                        let offsetTop = 0;
                        let parentElement = game.canvas.parentElement;
                        while (parentElement) {
                            if (parentElement.offsetTop) {
                                offsetTop = parentElement.offsetTop;
                                break;
                            }
                            parentElement = parentElement.parentElement;
                        }
                        return (pageY - offsetTop) * this.game.scale.displayScale.y;
                    };
                }
                create() {
                    game.scene.remove('Boot');
                    game.scene.add('Preloader', sh.scene.Preloader, true);
                }
            }
            scene.Boot = Boot;
        })(scene = sh.scene || (sh.scene = {}));
    })(sh || (sh = {}));

    (function (sh) {
        var scene;
        (function (scene) {
            var Gameplay = sh.core.Gameplay;
            class MainScene extends Phaser.Scene {
                create() {
                    this.gameplay = new Gameplay();
                    this.gameplayScreen = new sh.screen.GameplayScreen(this, this.gameplay);
                    this.children.add(this.gameplayScreen);
                    this.gameplayScreen.showInstructionPage();
                }
            }
            scene.MainScene = MainScene;
        })(scene = sh.scene || (sh.scene = {}));
    })(sh || (sh = {}));

    (function (sh) {
        var scene;
        (function (scene) {
            class Preloader extends Phaser.Scene {
                preload() {
                    if (typeof sh.App.json == "string") this.load.json('gameplay', sh.App.json); else this.game.cache.json.add('gameplay', sh.App.json);
                }
                create() {
                    let json = game.cache.json.get('gameplay');
                    let lettersConfig = json["lettersConfig"];
                    for (let letterName in lettersConfig) {
                        if (json["useImages"]) this.load.image(letterName, "https://storage.googleapis.com/quran-era-web.appspot.com/assets/games/ice-board/imgs/letters/" + letterName + ".png");
                        if (lettersConfig[letterName]["correctAudioKey"] == null) continue;
                        let correctAudioKey = lettersConfig[letterName]["correctAudioKey"];
                        this.load.audio(correctAudioKey, "https://storage.googleapis.com/quran-era-web.appspot.com/assets/games/ice-board/sound/mp3/letters/" + correctAudioKey.replace(".wav", ".mp3"));
                        this.load.audio("Q-" + lettersConfig[letterName]["Sounds of the letters"], "https://storage.googleapis.com/quran-era-web.appspot.com/assets/games/ice-board/sound/mp3/letters/Sounds of the letters/" + lettersConfig[letterName]["Sounds of the letters"].replace(".wav", ".mp3"));
                    }
                    let progressTxt = this.add.text(game.scale.width / 2, game.scale.height / 2 + 50, "", {
                        "fontFamily": "QuranErafont",
                        "fontSize": 25,
                        "color": "#333333",
                        "align": 'center'
                    });
                    progressTxt.setOrigin(0.5, 0.5);
                    this.load.pack('preloader', 'https://storage.googleapis.com/quran-era-web.appspot.com/assets/games/ice-board/pack.json');
                    this.load.on('progress', (value) => {
                        progressTxt.text = Math.ceil(value * 100) + "%";
                    }, this);
                    this.load.on('complete', () => {
                        this.nextScene();
                    });
                    this.load.start();
                }
                static playAnim(animKey, sprite, onComplete = null) {
                    let mainScene = game.scene.getScene('ScreenMain');
                    let data = Preloader.ANIMS_DATA[animKey];
                    if (!mainScene.anims.exists(animKey)) {
                        mainScene.anims.create({
                            key: animKey,
                            frames: mainScene.anims.generateFrameNames(data['atlas'], {
                                start: data['start'], end: data['end'], zeroPad: data['padNum'],
                                prefix: data['prefix'], suffix: ''
                            }),
                            frameRate: data['frameRate'],
                            repeat: data['repeat']
                        });
                    }
                    if (sprite.anims.currentAnim) {
                        sprite.anims.currentAnim.off('complete');
                    }
                    sprite.anims.stop();
                    // sprite.setTexture(data['atlas']);
                    sprite.play(animKey);
                    sprite.anims.currentAnim.once('complete', () => {
                        if (onComplete)
                            onComplete();
                    });
                    return sprite;
                }
                nextScene() {
                    game.scene.remove('Preloader');
                    game.scene.add('ScreenMain', sh.scene.MainScene, true);
                }
            }
            Preloader.ANIMS_DATA = {
            };
            scene.Preloader = Preloader;
        })(scene = sh.scene || (sh.scene = {}));
    })(sh || (sh = {}));
    (function (sh) {
        var screen;
        (function (screen) {
            class AreYouSureWindow extends Phaser.GameObjects.Container {
                constructor(scene, onYes, onNo) {
                    super(scene);
                    this._areYouSurePage = new Phaser.GameObjects.Image(this.scene, -105, 0 - 48, 'Exit warning');
                    this._areYouSurePage.setOrigin(0, 0);
                    this._areYouSurePage.setInteractive();
                    this._btnSureYes = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2 - 95, 485 - 50, 'btnYES1');
                    this._btnSureYes.setInteractive({ cursor: 'pointer' });
                    this._btnSureYes.on('pointerup', () => {
                        onYes;
                        angularComponentRef.backToMenu();
                    });
                    var modalTextStyle = {
                        backgroundColor: 'transparent',
                        stroke: '#ffffff',
                        strokeThickness: 2,
                        lineSpacing: 15,
                        fontFamily: 'Kids Rock DEMO',
                        fontSize: 27,
                        color: '#43425d',
                        wordWrap: true,
                        align: 'center'
                    };
                    var modalText = this.scene.add.text(game.scale.width / 2 + 12, game.scale.height / 2, "Your progress in this activity will not be saved. \n Are you sure you want to exit? ", modalTextStyle);
                    modalText.setOrigin(0.5, 0.5);

                    setupButtonTextureBased(this._btnSureYes, 'btnYES1', 'btnYES2');
                    this._btnSureNo = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2 + 95, 485 - 50, 'btnNO1');
                    this._btnSureNo.setInteractive({ cursor: 'pointer' });
                    this._btnSureNo.on('pointerup', onNo);
                    setupButtonTextureBased(this._btnSureNo, 'btnNO1', 'btnNO2');
                    this.add(this._areYouSurePage);
                    this.add(this._btnSureYes);
                    this.add(this._btnSureNo);
                    this.add(modalText);
                }
            }
            screen.AreYouSureWindow = AreYouSureWindow;
        })(screen = sh.screen || (sh.screen = {}));
    })(sh || (sh = {}));

    (function (sh) {
        var screen;
        (function (screen) {
            class CompleteWindow extends Phaser.GameObjects.Container {
                constructor(scene, onBack, onReplay, onNext) {
                    super(scene);
                    this.music = null;
                    this.setPosition(-104.5, -48);
                    this._bgComplete = new Phaser.GameObjects.Image(this.scene, 0, 0, 'Completion page LATEST UPDATED');
                    this._bgComplete.setOrigin(0, 0);
                    this._bgComplete.setInteractive();
                    this._cup = new Phaser.GameObjects.Image(this.scene, 400, 410, 'Trophy');
                    this._btnBack = new Phaser.GameObjects.Image(this.scene, 570, 570, 'btnBACK1');
                    this._btnReplay = new Phaser.GameObjects.Image(this.scene, 720, 570, 'btnReplay1');
                    this._btnNext = new Phaser.GameObjects.Image(this.scene, 870, 570, 'btnNEXT1');
                    let _CollectedPoints = new Phaser.GameObjects.Image(this.scene, 620, 440, 'Collected Points');
                    this.totalScoreTxt = this.scene.add.text(845, 352, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 35,
                        "color": "#F49F1C",
                        "align": 'center',
                        'stroke': '#70451A',
                        'strokeThickness': 6
                    });
                    this.totalScoreTxt.setOrigin(0.5, 0.5);
                    let grd = this.totalScoreTxt.context.createLinearGradient(0, 0, 0, this.totalScoreTxt.height);
                    grd.addColorStop(0, '#FFFF00');
                    grd.addColorStop(1, '#C17316');
                    this.totalScoreTxt.setFill(grd);
                    this.starScoreTxt = this.scene.add.text(648, 433, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 24,
                        "color": "#FFFFFF",
                        "align": 'center'
                    });
                    this.starScoreTxt.setOrigin(0.5, 0.5);
                    this.add([
                        this._bgComplete,
                        _CollectedPoints,
                        this._cup,
                        this._btnBack,
                        this._btnReplay,
                        this._btnNext,
                        this.totalScoreTxt,
                        this.starScoreTxt
                    ]);
                    this._btnBack.setInteractive({ cursor: 'pointer' });
                    this._btnBack.on('pointerup', () => {
                        onBack(this._btnBack);
                        angularComponentRef.backToMenu();
                        // if (this.music) {
                        //     this.music.stop();
                        // }
                    });
                    setupButtonTextureBased(this._btnBack, 'btnBACK1', 'btnBACK2');
                    this._btnReplay.setInteractive({ cursor: 'pointer' });
                    this._btnReplay.once('pointerup', () => {
                        onReplay(this._btnReplay);
                        if (this.music) {
                            this.music.stop();
                        }
                    });
                    setupButtonTextureBased(this._btnReplay, 'btnReplay1', 'btnReplay2');
                    this._btnNext.setInteractive({ cursor: 'pointer' });
                    this._btnNext.on('pointerup', () => {
                        onNext(this._btnNext);
                        window.angularComponentRef.nextActivity()
                    });
                    setupButtonTextureBased(this._btnNext, 'btnNEXT1', 'btnNEXT2');
                }
                show(score, starScore) {
                    window.angularComponentRef.gameFinish({ score, starScore })
                    this._cup.scale = 1.25;
                    this.scene.tweens.add({
                        targets: this._cup,
                        "scale": 1,
                        duration: 500,
                        ease: Phaser.Math.Easing.Back.Out
                    });
                    this.totalScoreTxt.text = String(window.angularComponentRef.component.userInfo.totalScore);
                    this.starScoreTxt.text = String(starScore);
                    // let music = this.scene.sound.add("viktory");
                    this.music = this.scene.sound.add("Activity completion fantastic");
                    this.music.play();
                }
            }
            screen.CompleteWindow = CompleteWindow;
        })(screen = sh.screen || (sh.screen = {}));
    })(sh || (sh = {}));

    (function (sh) {
        var screen;
        (function (screen) {
            class GameplayScreen extends Phaser.GameObjects.Container {
                constructor(scene, gameplay) {
                    super(scene);
                    this.boxPositions = [
                        { x: 272, y: 148 },
                        { x: 272, y: 298 },
                        { x: 272, y: 464 },
                        { x: 798, y: 150 },
                        { x: 798, y: 310 },
                        { x: 798, y: 465 }
                    ];
                    this.bgMusic = null;
                    this.correctAudio = null;
                    this.wfsnd = null;
                    this.showCompleteWindow = (score, starScore) => {
                        let completeWindow = new screen.CompleteWindow(this.scene, (target) => {
                            this.playBtnClickAnim(target);
                        }, (target) => {
                            this.playBtnClickAnim(target);
                            this.destroyGameplay();
                            this.remove(completeWindow);
                            this.showInstructionPage();
                        }, (target) => {
                            this.playBtnClickAnim(target);
                        });
                        this.setLettersInputEnabled(false);
                        delayedCall(3200, () => {
                            setPageBackground("bg-blue");
                            this.add(completeWindow);
                            completeWindow.show(score, starScore);
                            if (this.bgMusic) this.bgMusic.stop();
                        });
                    };
                    this.showLoseWindow = (score, starScore) => {
                        let tryAgainWindow = new screen.TryAgainWindow(this.scene, (target) => {
                            this.playBtnClickAnim(target);
                        }, (target) => {
                            this.playBtnClickAnim(target);
                            this.destroyGameplay();
                            this.remove(tryAgainWindow);
                            this.showInstructionPage();
                        });
                        this.setLettersInputEnabled(false);
                        delayedCall(2500, () => {
                            setPageBackground("bg-blue");
                            this.add(tryAgainWindow);
                            tryAgainWindow.show(score, starScore);
                            if (this.bgMusic) this.bgMusic.stop();
                        });
                    };
                    this.gameplay = gameplay;
                    window["t"] = this;
                }
                createHexagons() {
                    if (this.contentContainer && this.contentContainer.parentContainer) {
                        this.contentContainer.parentContainer.remove(this.contentContainer);
                    }
                    this.contentContainer = new Phaser.GameObjects.Container(this.scene, 0, 0);
                    this.gameplayContainer.addAt(this.contentContainer, 1);
                    window['this.contentContainer'] = this.contentContainer;

                    this.scene.sound.add('Six frames appear').play();

                    this.speakers = [];
                    let _i = 0;
                    for (let p of this.boxPositions) {
                        let hc = new Phaser.GameObjects.Container(this.scene, this.boxPositions[_i]['x'], this.boxPositions[_i]['y']);
                        let h = new Phaser.GameObjects.Image(this.scene, 0, 0, 'boxBg');
                        hc.add(h);
                        hc["bg"] = h;

                        hc["defX"] = p['x'];
                        hc["defY"] = p['y'];
                        this.speakers.push(hc);
                        this.contentContainer.add(hc);
                        hc['index'] = _i;

                        let playBtn = new Phaser.GameObjects.Image(this.scene, -203, 6, 'btnPlaySnd');
                        hc.add(playBtn);
                        hc["playBtn"] = playBtn;
                        setupButtonTextureBased(playBtn, 'btnPlaySnd', 'btnPlaySndHover');
                        let _ind = _i;
                        // playBtn.visible = false;

                        playBtn.alpha = 0;
                        this.scene.tweens.add({
                            targets: playBtn,
                            alpha: 1,
                            duration: 200,
                            delay: 250 + _i * 160
                        });

                        playBtn.on('pointerup', () => {
                            for (let _hc of this.speakers) {
                                if (_hc["playBtn"]["sound"]) _hc["playBtn"]["sound"].stop();
                            }

                            if (!playBtn["sound"]) {
                                playBtn["sound"] = this.scene.sound.add(this.gameplay.getLetterSoundSfxAudioKey(this.targetBlocks[_ind]["-letter-text"]/* hc["letter"] */));
                            }
                            playBtn["sound"].play();

                            if (_ind == 0 && !this.wasTutorialCompleted) {
                                this.scene.tweens.killTweensOf(this.handIcon);
                                this.gameplayContainer.parentContainer.add(this.handIcon);
                                this.handIcon.setPosition(825, 485);
                                this.scene.tweens.add({
                                    targets: this.handIcon,
                                    duration: 750,
                                    delay: 500,
                                    x: 288,
                                    y: 175
                                });

                                this.boxes[this.boxes.length - 1].setInteractive({ cursor: 'pointer' });
                                this.scene.input.setDraggable(this.boxes[this.boxes.length - 1], true);
                            }

                            // if (!hc["handIcon"] || !hc["handIcon"].visible) return;

                            // hc['handIcon'].visible = false;

                            /* playBtn["sound"].once('complete', ()=>{
                                if (hc['index'] < this.speakers.length - 1) {
                                    var nextSpeaker = this.speakers[hc['index'] + 1];
                                    // nextSpeaker["handIcon"].visible = true;
                                    nextSpeaker["playBtn"].setInteractive({ cursor: 'pointer' });
                                }
                            }); */
                        });

                        if (!this.wasTutorialCompleted) {
                            if (_i == 0) {
                                this.handIcon = new Phaser.GameObjects.Image(this.scene, -180, 25, 'Hand Icon');
                                window['this.handIcon'] = this.handIcon;
                                hc.add(this.handIcon);
                                hc["handIcon"] = this.handIcon;
                                this.scene.tweens.add({
                                    targets: this.handIcon,
                                    angle: -5,
                                    scaleY: 0.95,
                                    scaleX: 0.95,
                                    duration: 500,
                                    yoyo: true,
                                    repeat: -1,
                                });

                                this.handIcon.alpha = 0;
                                delayedCall(3500, () => {
                                    this.scene.tweens.add({
                                        targets: this.handIcon,
                                        alpha: 1,
                                        duration: 500,
                                        delay: 0
                                    });
                                    playBtn.setInteractive({ cursor: 'pointer' });
                                });
                            }
                        } else {
                            playBtn.setInteractive({ cursor: 'pointer' });
                        }

                        _i++;
                    }

                    window['this.cars'] = this.speakers;

                    this.boxes = [];

                    let boxDefPos = { x: 0, y: 0 };
                    for (let _i = 0; _i < this.boxPositions.length; _i++) {
                        let hc = this.scene.add.container(boxDefPos.x, boxDefPos.y);
                        let h = this.scene.add.sprite(0, 0, 'box');
                        hc["-image-"] = h;
                        hc['-draggable-'] = true;
                        hc.add(h);
                        hc["bg"] = h;
                        window['hc_' + _i] = hc;
                        window['h_' + _i] = h;
                        hc.add(h);
                        // hc.visible = false;

                        hc["defX"] = boxDefPos.x;
                        hc["defY"] = boxDefPos.y;
                        this.boxes.push(hc);
                        this.contentContainer.add(hc);
                        hc['index'] = _i;

                        hc.alpha = 0;
                        this.scene.tweens.add({
                            targets: hc,
                            alpha: 1,
                            duration: 200,
                            delay: 250 + _i * 160
                        });
                    }
                    window['this.boxes'] = this.boxes;

                    this.setLettersInputEnabled(false);
                }
                createLetters() {
                    this.letters = [];
                    let _letters = this.gameplay.getCurrentRoundLetters();
                    for (let n of _letters) {
                        let wordText;
                        if (this.gameplay.useImages) {
                            wordText = new Phaser.GameObjects.Image(this.scene, 0, 0, n);
                        } else {
                            wordText = this.scene.add.text(0, 0, n, {
                                "fontFamily": "QuranErafont",
                                "fontSize": 40,
                                "color": "#333333",
                                "align": 'center'
                            });
                            this.add(wordText);
                            wordText.setOrigin(0.5, 0.5);
                            wordText.setPadding({ left: 0, right: 0, top: 65, bottom: 65 });

                            if (wordText.width > 135) wordText.setScale(140 / wordText.width);
                        }
                        wordText["key"] = n;
                        this.letters.push(wordText);
                        window['wordText'] = wordText;
                    }
                }
                showGameplay() {
                    this.isLost = false;
                    setPageBackground("bg-australia");
                    this.bgMusic = this.scene.sound.add("bg_sound");
                    this.bgMusic.setVolume(0.5);
                    this.bgMusic.play();
                    this.bgMusic.loop = true;
                    this.gameplay.reset();
                    this.bgContainer = new Phaser.GameObjects.Container(this.scene);
                    this._gameStage = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2, game.scale.height / 2, 'bg'); window['this._gameStage'] = this._gameStage;
                    this._gameStage.setOrigin(0.5, 0.5);
                    this._gameStage.setInteractive();
                    this.bgContainer.add(this._gameStage);
                    window['this.bgContainer'] = this.bgContainer;
                    this._btnSound = new Phaser.GameObjects.Image(this.scene, 160 - 105, 100 - 50, 'Sound');
                    this._btnSound.setInteractive({ cursor: 'pointer' });
                    this._btnSound["defScale"] = this._btnSound.scale;
                    setupButtonTextureBased(this._btnSound, 'Sound', 'Sound HOVER EFFECT');
                    this._btnClose = new Phaser.GameObjects.Image(this.scene, 1025 - 105, 100 - 50, 'x Button');
                    this._btnClose.setInteractive({ cursor: 'pointer' });
                    this._btnClose["defScale"] = this._btnClose.scale;
                    setupButtonTextureBased(this._btnClose, 'x Button', 'x Button HOVER EFFECT');
                    this.gameplayContainer = new Phaser.GameObjects.Container(this.scene);
                    this.addAt(this.gameplayContainer, 0);

                    this.btnDone = new Phaser.GameObjects.Image(this.scene, 530, 547, 'btnDONE1');
                    this.btnDone.setInteractive({ cursor: 'pointer' });
                    this.btnDone.on('pointerup', this.onDoneClicked, this);
                    setupButtonTextureBased(this.btnDone, 'btnDONE1', 'btnDONE2');
                    window['this.btnDone'] = this.btnDone;

                    this.gameplayContainer.add([
                        this.bgContainer,
                        this.btnDone,
                        this._btnSound,
                        this._btnClose
                    ]);
                    window['this._gameStage'] = this._gameStage;
                    window['this.gameplayContainer'] = this.gameplayContainer;
                    this.createBeehives();
                    this.shuffleOutHexagons();
                    this.gameplay.setupCallbacks(this.showCompleteWindow, this.showLoseWindow);
                }
                createBeehives() {
                    let startX = 460;
                    let startY = 44;
                    let dx = 45;
                    let _BeehiveEmptyArrayPositions = [];
                    for (let i = 0; i < this.gameplay.wrongAnswersToLose - 1 + this.boxPositions.length; i++) {
                        _BeehiveEmptyArrayPositions.push({ x: startX + i * dx, y: startY });
                    }
                    this._BeehiveEmptyArray = []; window["_BeehiveEmptyArray"] = this._BeehiveEmptyArray;
                    for (let p of _BeehiveEmptyArrayPositions) {
                        let _BeehiveEmpty = new Phaser.GameObjects.Image(this.scene, p['x'], p['y'], 'Beehive 1 Empty');
                        this._BeehiveEmptyArray.push(_BeehiveEmpty);
                        _BeehiveEmpty.visible = false;
                    }
                    for (let bea of this._BeehiveEmptyArray) {
                        this.gameplayContainer.add(bea);
                    }
                }
                onDoneClicked() {
                    let wrongBlocks = [];

                    for (let targetBlock of this.targetBlocks) {
                        if (targetBlock["-letter-text"] != targetBlock['-block-']["-letter-text"]) {
                            wrongBlocks.push(targetBlock);
                        }
                    }

                    if (wrongBlocks.length == 0) {
                        this.onCorrectDragsMade();
                    } else {
                        this.sfxWrong = this.scene.sound.add("wrong sfx");
                        this.sfxWrong.play();

                        let lost = false;
                        for (let k = 0; k < wrongBlocks.length; k++) {
                            if (this.onWrongAnswer()) {
                                lost = true;
                            }
                        }
                        if (!lost) {
                            this.setLettersInputEnabled(true);
                        }

                        for (let wb of wrongBlocks) {
                            this.speakers[wb['-index-']]['bg'].setTexture('bgWrong');
                        }
                    }
                }
                randomizeLettersPosition() {
                    let hx = this.boxes.slice();
                    if (!this.wasTutorialCompleted) {
                        let _hc = hx[0];
                        hx[0] = hx[hx.length - 1];
                        hx[hx.length - 1] = _hc;
                    }
                    let k = 0;
                    for (let l of this.letters) {
                        if (hx.length == 0)
                            return;
                        let hc;
                        if (!this.wasTutorialCompleted && k < 1) {
                            hc = hx.shift();
                        } else {
                            if (this.wasTutorialCompleted) {
                                hc = Phaser.Utils.Array.RemoveRandomElement(hx);
                            } else {
                                hc = Phaser.Utils.Array.RemoveRandomElement(hx, 0, hx.length - 1);
                            }
                        }
                        hc.add(l);
                        hc["letter"] = l;
                        hc["-letter-text"] = l.key ?? l.text;
                        l["hexagon"] = hc;
                        k++;
                    }
                }
                updateHexagonsArrange() {
                    for (let hc of this.boxes) {
                        if (!hc["letter"]) {
                            hc.parentContainer.bringToTop(hc);
                            break;
                        }
                    }
                }
                shuffleOutHexagons() {
                    this.createHexagons();

                    let setLettersInputEnabled = () => {
                        if (this.correctAudio && this.correctAudio.isPlaying) {
                            delayedCall(/* (this.correctAudio.duration * 0.75) * */ 1000, () => {
                                if (this.wasTutorialCompleted) this.setLettersInputEnabled(true);
                            });
                        }
                        else {
                            if (this.wasTutorialCompleted) this.setLettersInputEnabled(true);
                        }
                    };

                    if (!this.gameplay.isRoundsComplete()) {
                        if (this.gameplay.isCorrectLetterAudioQuestionEnable() && this.gameplay.getCurrentTotalAnswersCount() == 0) {
                            delayedCall(1350, () => this.playCorrectAudio());
                        }
                        delayedCall(1000, setLettersInputEnabled)
                    }

                    if (this.sfxCarAccelerating) {
                        this.sfxCarAccelerating.stop();
                        this.sfxCarAccelerating = null;
                    }
                    if (this.sfxWrong) {
                        this.sfxWrong.stop();
                        this.sfxWrong = null;
                    }

                    if (!this.gameplay.isRoundsComplete()) {
                        this.createLetters();
                        this.randomizeLettersPosition();
                    }

                    this.setLettersInputEnabled(false);
                    this.updateHexagonsArrange();
                    // Phaser.Utils.Array.Shuffle(this.boxPositions);
                    for (let c of this.speakers) this.gameplayContainer.remove(c);
                    // this.speakers.sort((c1, c2) => c1.y - c2.y);
                    // for (let c of cars) this.gameplayContainer.add(c);

                    this.createInput();
                }
                shuffleInHexagons() {
                    this.updateHexagonsArrange();
                    this.setLettersInputEnabled(false);

                    // delayedCall(600, () => {
                    // this.scene.sound.add('move to centre').play();
                    this.shuffleOutHexagons();
                    // });
                    window['t'] = this;
                }
                onCorrectDragsMade() {
                    let completed = this.onCorrectAnswer();

                    this.setLettersInputEnabled(false);

                    // this.scene.sound.add('Snail giggling sound - correct selection').play();

                    delayedCall(100, () => {
                        if (!completed) {
                            this.scene.sound.add('First round finishes').play();
                        } else {
                            this.scene.sound.add('Final celebration sound').play();
                        }
                    });

                    // if (!completed) delayedCall(1350, () => this.scene.sound.add('Next round starts').play());
                    // if (completed) delayedCall(1750, () => this.scene.sound.add('Final celebration sound').play())

                    delayedCall(completed ? 750 : 150, () => {
                        if (!completed) {
                            this.shuffleInHexagons();
                        }
                    });
                }
                createInput() {
                    this.scene.input.on('drag', (pointer, block, dragX, dragY) => {
                        if (!block['-draggable-'])
                            return;
                        block.x = dragX;
                        block.y = dragY;
                        block.parentContainer.bringToTop(block);
                    });
                    console.log("CORRECT WORDS: ", this.gameplay.getCorrectLetters());
                    this.targetBlocks = [];

                    for (let i = 0; i < this.boxPositions.length; i++) {
                        let b = this.boxPositions[i];
                        b['alreadyFilled'] = false;
                        b['-index-'] = i;
                        this.targetBlocks.push(b);
                        b["-letter-text"] = this.gameplay.getCorrectLetters()[i];
                        b["-block-"] = null;

                        // this.speakers[i]["letter"] = b["-letter-text"];
                    }
                    window['this.targetBlocks'] = this.targetBlocks;

                    var targetBlocks = this.targetBlocks.slice();
                    for (let a of this.boxes) {
                        // let correctAnswer = hc["letter"] && hc["letter"]["key"] == this.gameplay.getCorrectLetters(1);
                        //hc["letter"].alpha = correctAnswer ? 1 : 0.5;

                        //place at random target box
                        var tb = targetBlocks.shift();//Phaser.Utils.Array.RemoveRandomElement(targetBlocks);
                        tb['alreadyFilled'] = true;
                        tb["-block-"] = a;
                        a["-placedAtBlock-"] = tb;
                        a.setPosition(tb.x, tb.y);

                        a.setSize(a["-image-"].width, a["-image-"].height);
                        // a.setInteractive({ cursor: 'pointer' });
                        // this.scene.input.setDraggable(a, true);
                        a.on('pointerdown', () => {
                            for (let tb of this.targetBlocks) {
                                this.speakers[tb['-index-']]['bg'].setTexture('boxBg');
                            }
                            /* if (a["-placedAtBlock-"]) {
                                a["-placedAtBlock-"]['alreadyFilled'] = false;
                                a["-placedAtBlock-"] = null;
                            } */

                            a['-pointerdown-'] = true;
                            if (a['-draggable-']) this.scene.sound.add("Move the box from its spot").play();
                        });
                        a.on('pointerup', () => {
                            a['-pointerdown-'] = false;
                            if (!a['-draggable-'])
                                return;

                            let wasTargetBlockFound = false;
                            let targetBlock;
                            for (targetBlock of this.targetBlocks) {
                                if (Phaser.Math.Distance.Between(a.x, a.y, targetBlock.x, targetBlock.y) < 75) {
                                    let _a = targetBlock["-block-"];
                                    let _targetBlock = a["-placedAtBlock-"];

                                    let sameAsCurrent = _a["-placedAtBlock-"] === _targetBlock;

                                    _targetBlock["-block-"] = _a;
                                    _a["-placedAtBlock-"] = _targetBlock;

                                    this.scene.tweens.add({
                                        targets: _a,
                                        x: _targetBlock.x,
                                        y: _targetBlock.y,
                                        duration: 275,
                                        ease: Phaser.Math.Easing.Back.InOut
                                    });

                                    //as
                                    // a['-draggable-'] = false;
                                    targetBlock['alreadyFilled'] = true;
                                    this.scene.tweens.add({
                                        targets: a,
                                        x: targetBlock.x,
                                        y: targetBlock.y,
                                        duration: 350,
                                        ease: Phaser.Math.Easing.Back.InOut
                                    });
                                    targetBlock["-block-"] = a;
                                    a["-placedAtBlock-"] = targetBlock;
                                    if (!sameAsCurrent) this.scene.sound.add("Ice is dropped on a frame").play();

                                    wasTargetBlockFound = true;

                                    if (!this.wasTutorialCompleted && this.handIcon && !sameAsCurrent) {
                                        this.handIcon.parentContainer.remove(this.handIcon);
                                        this.handIcon = null;
                                        this.wasTutorialCompleted = true;

                                        this.setLettersInputEnabled(true);
                                        for (let sp of this.speakers) {
                                            sp["playBtn"].setInteractive({ cursor: 'pointer' });
                                        }
                                    }

                                    break;
                                }
                            }

                            if (!wasTargetBlockFound) {
                                this.moveBridgeBackToItsBlock(a, null, true);
                            }
                        });
                        a.on('pointerout', () => {
                            if (!a['-draggable-'])
                                return;
                            if (!a['-pointerdown-'])
                                return;
                            this.moveBridgeBackToItsBlock(a, null, true);
                        });
                    }

                    this._btnSound.on('pointerup', () => {
                        this.playBtnClickAnim(this._btnSound);
                        this.onSoundClick();
                    });
                    this._btnClose.on('pointerup', () => {
                        this.playBtnClickAnim(this._btnClose);
                        this.onCloseClick();
                    });
                }
                hideAllUnusedBeehives() {
                    let i = this.gameplay.getCurrentTotalAnswersCount();
                    for (let k = i + 1; k < this._BeehiveEmptyArray.length; k++) {
                        this._BeehiveEmptyArray[k].visible = false;
                    }
                }

                checkTargetBlockLetters(targetBlock) {
                    // try{this.scene.input.setDraggable(this.currentBox, false);}catch(e){}
                    // this.currentBox.disableInteractive();

                    this.boxes.shift();

                    this.scene.sound.add('Correct sfx').play();

                    this.setLettersInputEnabled(false);
                    if (this.boxes.length === 0) {
                        for (let _hc of this.boxes) {
                            if (_hc['-placedAtBlock-']) continue;
                            /* this.scene.tweens.add({
                                targets: _hc,
                                "alpha": 0,
                                ease: Phaser.Math.Easing.Cubic.In,
                                duration: 900,
                                delay: 0
                            }); */
                        }
                        // this.scene.sound.add("Blocks disappearing").play();
                        delayedCall(1000, () => {
                        });
                    }
                }
                moveBridgeBackToItsBlock(block, onComplete, playSound) {
                    this.scene.tweens.add({
                        targets: block,
                        x: block['-placedAtBlock-'].x,
                        y: block['-placedAtBlock-'].y,
                        duration: 175,
                        ease: Phaser.Math.Easing.Sine.Out,
                        onComplete: () => {
                            if (onComplete)
                                onComplete();
                        }
                    });
                    if (Phaser.Math.Distance.Between(block['-placedAtBlock-'].x, block['-placedAtBlock-'].y, block.x, block.y) > 20) {
                        delayedCall(100, () => {
                            if (playSound) {
                                this.scene.sound.add("Box goes back").play();
                            }
                        });
                    }
                }
                onCorrectAnswer() {
                    let i = this.gameplay.getCurrentTotalAnswersCount();
                    if (i < this._BeehiveEmptyArray.length) {
                        // this._BeehiveEmptyArray[i].visible = false;
                    }
                    this.hideAllUnusedBeehives();
                    let completed = this.gameplay.onCorrectAnswer();
                    // this.scene.sound.add('Correct sfx').play();
                    // this.sfxCarAccelerating = this.scene.sound.add('Car accelerating');
                    // this.sfxCarAccelerating.play();
                    // delayedCall(250, () => {
                    //     this.scene.sound.add(this.gameplay.getCorrectAndLetterSoundSfxAudioKey()).play();
                    // });
                    return completed;
                }
                onWrongAnswer(forceNewRound) {
                    let i = this.gameplay.wrongAnswersCount;
                    if (i < this._BeehiveEmptyArray.length) {
                        this._BeehiveEmptyArray[i].visible = true;
                    }
                    this.hideAllUnusedBeehives();
                    let lost = this.gameplay.onWrongAnswer(forceNewRound);
                    return lost;
                }
                playCorrectAudio() {
                    if (this.correctAudio) {
                        this.correctAudio.stop();
                    }
                    this.correctAudio = this.scene.sound.add("questionAudio"/* this.gameplay.getCorrectAudioKey() */);
                    this.correctAudio.play();
                    if (this.areYouSureWindow && this.areYouSureWindow.parentContainer == this) {
                        this.correctAudio.pause();
                    }
                }
                onSoundClick() {
                    this.playCorrectAudio();
                }
                onCloseClick() {
                    this.showAreYouSurePage();
                    this.scene.sound.add('warning page pop up sfx').play();
                }
                playBtnClickAnim(target) {
                    let sc = target["defScale"] ? target["defScale"] : 1;
                    target.scaleX = target.scaleY = sc;
                    this.scene.tweens.add({
                        targets: target,
                        "scaleX": 0.9 * sc,
                        "scaleY": 0.9 * sc,
                        duration: 100,
                        yoyo: true
                    });
                }
                showInstructionPage() {
                    setPageBackground("bg-blue");
                    this.instructionPage = new screen.InstructionPage(this.scene, (target) => {
                        this.playBtnClickAnim(target);
                        this.remove(this.instructionPage);
                        this.showGameplay();
                        if (this.wfsnd) {
                            this.wfsnd.stop();
                        }
                    }, (target) => {
                        this.playBtnClickAnim(target);
                        if (this.wfsnd) {
                            this.wfsnd.stop();
                        }
                        if (!game.cache.json.get('gameplay')['welcomeAudioDisabled']) {
                            this.wfsnd = this.scene.sound.add("Welcome Find the sound");
                            this.wfsnd.play();
                        }
                    });
                    this.add(this.instructionPage);
                    try {
                        if (!game.cache.json.get('gameplay')['welcomeAudioDisabled']) {
                            this.wfsnd = this.scene.sound.add("Welcome Find the sound");
                            this.wfsnd.play();
                        }
                    }
                    catch (e) {
                        console.error(e);
                    }
                }
                showAreYouSurePage() {
                    /* for (let j = 0; j < this.cars.length; j++) {
                        if (this.cars[j]["raceTween"]) {
                            this.cars[j]["raceTween"].pause();
                        }
                    } */

                    pauseAllDelayedCalls();
                    setPageBackground("bg-blue");
                    this.pauseSounds();
                    if (!this.areYouSureWindow) this.areYouSureWindow = new screen.AreYouSureWindow(this.scene, () => {
                        this.remove(this.areYouSureWindow);
                        this.destroyGameplay();
                        this.showInstructionPage();
                    }, () => {
                        this.remove(this.areYouSureWindow);
                        this.unpauseSounds();
                        resumeAllDelayedCalls();

                        /* for (let j = 0; j < this.cars.length; j++) {
                            if (this.cars[j]["raceTween"]) {
                                this.cars[j]["raceTween"].resume();
                            }
                        } */

                        setPageBackground("bg-australia");
                    });
                    this.add(this.areYouSureWindow);
                }
                setLettersInputEnabled(enabled) {
                    if (enabled) {
                        this.btnDone.setInteractive({ cursor: 'pointer' });
                        for (let hc of this.boxes) {
                            hc.setInteractive({ cursor: 'pointer' });
                            this.scene.input.setDraggable(hc, true);
                        }
                    }
                    else {
                        this.btnDone.disableInteractive();
                        for (let hc of this.boxes) {
                            try { this.scene.input.setDraggable(hc, false); } catch (e) { }
                            hc.disableInteractive();
                        }
                    }
                }
                pauseSounds() {
                    if (this.correctAudio)
                        this.correctAudio.pause();
                    if (this.bgMusic)
                        this.bgMusic.pause();
                }
                unpauseSounds() {
                    if (this.correctAudio)
                        this.correctAudio.resume();
                    if (this.bgMusic)
                        this.bgMusic.resume();
                }
                destroyGameplay() {
                    this.setLettersInputEnabled(false);
                    this.remove(this.gameplayContainer);
                    this.scene.sound.stopAll();
                    destroyAllDelayedCalls();
                }
            }
            screen.GameplayScreen = GameplayScreen;
        })(screen = sh.screen || (sh.screen = {}));
    })(sh || (sh = {}));
    (function (sh) {
        var screen;
        (function (screen) {
            class InstructionPage extends Phaser.GameObjects.Container {
                constructor(scene, onPlayClick, onSndClick) {
                    super(scene);
                    this._instructionPage = new Phaser.GameObjects.Image(this.scene, 0 - 105, 0 - 48, 'Instructions page  ALL ACTIVITY  TITLEs');
                    this._instructionPage.setOrigin(0, 0);
                    this._instructionPage.setInteractive();

                    this._instructionPageTitle = this.scene.add.text(475, 110, sh.App.json.instructionTitle ?? 'Ice Board', {
                        "fontFamily": "Kids Rock DEMO",
                        "fontSize": 35,
                        "color": "#43425D",
                        "align": 'center'
                    });
                    this._instructionPageTitle.setOrigin(0.5, 0.5);
                    window['this._instructionPageTitle'] = this._instructionPageTitle;
                    this._instructionPageTitle.setStroke('#ffffff', 5);
                    //  Apply the gradient fill.
                    const gradient = this._instructionPageTitle.context.createLinearGradient(0, 0, 0, this._instructionPageTitle.height);
                    gradient.addColorStop(0, '#eeef67');
                    gradient.addColorStop(0.55, '#e98c2c');
                    gradient.addColorStop(1, '#91301a');
                    this._instructionPageTitle.setFill(gradient);

                    this._btnPlay = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2, 480 - 50, 'btnPLAY1');
                    this._btnPlay.setInteractive({ cursor: 'pointer' });
                    this._btnPlay.once('pointerup', onPlayClick);
                    setupButtonTextureBased(this._btnPlay, 'btnPLAY1', 'btnPLAY2');
                    this.instrTxt = this.scene.add.text(game.scale.width / 2, game.scale.height / 2, "The verses have been mixed up. \n Play the sound and drag the \n verse to the right box.", {
                        "fontFamily": "Kids Rock DEMO",
                        "fontSize": 30,
                        "lineSpacing": 15,
                        "color": "#43425D",
                        "align": 'center'
                    });
                    this.instrTxt.setOrigin(0.5, 0.5);
                    this._btnSoundInstruction = new Phaser.GameObjects.Image(this.scene, 800 - 105, 156 - 50, 'Sound');
                    this._btnSoundInstruction.setInteractive({ cursor: 'pointer' });
                    this._btnSoundInstruction.on('pointerup', onSndClick);
                    this._btnSoundInstruction["defScale"] = this._btnSoundInstruction.scale;
                    setupButtonTextureBased(this._btnSoundInstruction, 'Sound', 'Sound HOVER EFFECT');
                    this.add(this._instructionPage);
                    this.add(this._instructionPageTitle);
                    this.add(this.instrTxt);
                    this.add(this._btnPlay);
                    this.add(this._btnSoundInstruction);
                }
            }
            screen.InstructionPage = InstructionPage;
        })(screen = sh.screen || (sh.screen = {}));
    })(sh || (sh = {}));
    (function (sh) {
        var screen;
        (function (screen) {
            class TryAgainWindow extends Phaser.GameObjects.Container {
                constructor(scene, onBack, onReplay) {
                    super(scene);
                    this.music = null;
                    this.setPosition(-106, -48);
                    this._bg = new Phaser.GameObjects.Image(this.scene, 0, 0, 'Try again page');
                    this._bg.setOrigin(0, 0);
                    this._bg.setInteractive();
                    this._star = new Phaser.GameObjects.Image(this.scene, 400, 415, 'Break Star');
                    this._btnBack = new Phaser.GameObjects.Image(this.scene, 600, 580, 'btnBACK1');
                    this._btnReplay = new Phaser.GameObjects.Image(this.scene, 765, 580, 'btnReplay1');
                    this.totalScoreTxt = this.scene.add.text(850, 355, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 35,
                        "color": "#F49F1C",
                        "align": 'center',
                        'stroke': '#70451A',
                        'strokeThickness': 6
                    });
                    this.totalScoreTxt.setOrigin(0.5, 0.5);
                    let grd = this.totalScoreTxt.context.createLinearGradient(0, 0, 0, this.totalScoreTxt.height);
                    grd.addColorStop(0, '#FFFF00');
                    grd.addColorStop(1, '#C17316');
                    this.totalScoreTxt.setFill(grd);
                    this.starScoreTxt = this.scene.add.text(635, 431, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 24,
                        "color": "#FFFFFF",
                        "align": 'center'
                    });
                    this.starScoreTxt.setOrigin(0.5, 0.5);
                    this.add([
                        this._bg,
                        this._star,
                        this._btnBack,
                        this._btnReplay,
                        this.totalScoreTxt,
                        this.starScoreTxt
                    ]);
                    this._btnBack.setInteractive({ cursor: 'pointer' });
                    this._btnBack.on('pointerup', () => {
                        onBack(this._btnBack);
                        angularComponentRef.backToMenu();
                        // if (this.music) {
                        //     this.music.stop();
                        // }
                    });
                    setupButtonTextureBased(this._btnBack, 'btnBACK1', 'btnBACK2');
                    this._btnReplay.setInteractive({ cursor: 'pointer' });
                    this._btnReplay.once('pointerup', () => {
                        onReplay(this._btnReplay);
                        if (this.music) {
                            this.music.stop();
                        }
                    });
                    setupButtonTextureBased(this._btnReplay, 'btnReplay1', 'btnReplay2');
                }
                show(score, starScore) {
                    this._star.scale = 1.25;
                    this.scene.tweens.add({
                        targets: this._star,
                        "scale": 1,
                        duration: 500,
                        ease: Phaser.Math.Easing.Back.Out
                    });
                    this.totalScoreTxt.text = '';//String(window.angularComponentRef.component.userInfo.totalScore);
                    this.starScoreTxt.text = String(0);
                    this.music = this.scene.sound.add("Fail - close one");
                    this.music.play();
                }
            }
            screen.TryAgainWindow = TryAgainWindow;
        })(screen = sh.screen || (sh.screen = {}));
    })(sh || (sh = {}));
}

function destroyIceBoard() {
    if (game) {
        game.destroy();
    }
}

var game;
var sh;
function stackWood(json) {
    /**
     * @author Roman Parada
     * This class is created to fix overlapping of bottom part of canvas by navigation bar in iOS.
     * It make a delayed resize of the canvas (like Phaser-3 FIT methods does) and it overrides Phaser-3 input window to Phaser-3 core transform methods
     *
     * How to use:
     * Just call the code line below in Boot scene's init() method of your project:
     * new FitScaleManager(this.game).setup();
     */
    class FitScaleManager {
        constructor(game) {
            this.doResize = () => {
                let scale = this.calculateScale();
                let newCanvasWidth = this.phaserScaleManager.width * scale;
                let newCanvasHeight = this.phaserScaleManager.height * scale;
                this.canvasStyle.width = newCanvasWidth + 'px';
                this.canvasStyle.height = newCanvasHeight + 'px';
                this.canvasStyle.marginLeft = (window.innerWidth - newCanvasWidth) / 2 + 'px';
                this.canvasStyle.marginTop = (window.innerHeight - newCanvasHeight) / 2 + 'px';
            };
            this.game = game;
            this.canvasStyle = this.game.canvas.style;
            this.phaserScaleManager = this.game.scale;
        }
        static detectBestScaleMode() {
            let iOS = /iPad|iPhone|iPod/.test(navigator.platform || "");
            let isAndroid = window.navigator.userAgent.toLowerCase().indexOf("android") > -1;
            return iOS || isAndroid ? Phaser.Scale.FIT : Phaser.Scale.NONE;
        }
        ;
        /**
         * Just call this method once in Boot scene's init() method
         */
        setup() {
            this.phaserScaleManager.addListener(Phaser.Scale.Events.RESIZE, this.onResize, this);
            this.overridePhaserTransformMethods();
            this.onResize();
        }
        calculateScale() {
            if (game.scale.scaleMode === Phaser.Scale.NONE)
                return 1;
            return Math.min(window.innerWidth / this.phaserScaleManager.width, window.innerHeight / this.phaserScaleManager.height);
        }
        overridePhaserTransformMethods() {
            this.game.scale.transformX = (pageX) => {
                return (pageX - parseInt(this.canvasStyle.marginLeft.split("px")[0])) / this.calculateScale();
            };
            this.game.scale.transformY = (pageY) => {
                return (pageY - parseInt(this.canvasStyle.marginTop.split("px")[0])) / this.calculateScale();
            };
        }
        onResize() {
            setTimeout(this.doResize, FitScaleManager.RESIZE_DELAY);
        }
    }
    FitScaleManager.RESIZE_DELAY = 500;

    (function (sh) {
        class App extends Phaser.Game {
            constructor(json) {
                App.json = json;
                // console.log(App.json);

                let config = {
                    type: Phaser.AUTO,
                    width: App.CANVAS_WIDTH,
                    height: App.CANVAS_HEIGHT,
                    parent: 'game-container',
                    dom: {
                        createContainer: false
                    },
                    scale: {
                        mode: FitScaleManager.detectBestScaleMode(),
                        autoCenter: Phaser.Scale.CENTER_BOTH
                    },
                    transparent: true,
                    scene: {
                        create: () => {
                            this.scene.add('Boot', sh.scene.Boot, true);
                        }
                    }
                };
                super(config);
            }
        }
        App.CANVAS_WIDTH = 980;
        App.CANVAS_HEIGHT = 600;
        sh.App = App;
    })(sh || (sh = {}));

    game = new sh.App(json);

    var delayedCalls = [];
    function delayedCall(delay, callback, args, callbackScope) {
        let scene = game.scene.getAt(0);
        if (scene) {
            let dc = scene.time.delayedCall(delay, callback, args, callbackScope);
            delayedCalls.push(dc);
            return dc;
        }
        let t = setTimeout(callback, delay);
        delayedCalls.push(t);
        return t;
    }

    function pauseAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.paused = true;
            }
        }
    }

    function resumeAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.paused = false;
            }
        }
    }

    function destroyAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.remove(false);
            }
            else {
                clearTimeout(dc);
            }
        }
        delayedCalls = [];
    }

    function setPageBackground(bg) {
        // document.querySelector("html").style.backgroundImage = "url(assets/games/stack-the-wood/imgs/" + bg + ".jpg)";
    }

    function setupButton(btn, frame) {
        btn.on('pointerdown', () => { btn.setFrame(frame + '_hover' + '0000'); });
        btn.on('pointerover', () => { btn.setFrame(frame + '_hover' + '0000'); game.scene.getAt(0).sound.add("button hover").play(); });
        btn.on('pointerout', () => { btn.setFrame(frame + '0000'); });
        btn.on('pointerup', () => { btn.setFrame(frame + '0000'); game.scene.getAt(0).sound.add('activity selection - button selection').play(); });
    }

    function setupButtonTextureBased(btn, texture, hoverTexture) {
        btn.on('pointerdown', () => { btn.setTexture(hoverTexture); });
        btn.on('pointerover', () => { btn.setTexture(hoverTexture); game.scene.getAt(0).sound.add("button hover").play(); });
        btn.on('pointerout', () => { btn.setTexture(texture); });
        btn.on('pointerup', () => { btn.setTexture(texture); game.scene.getAt(0).sound.add('activity selection - button selection').play(); });
    }

    (function (sh) {
        var core;
        (function (core) {
            class Gameplay {
                constructor() {
                    this.currentRound = 0;
                    this.currentLetter = 0;
                    this.correctAnswersCount = 0;
                    this.wrongAnswersCount = 0;
                    this.correctAnswersCountThisRound = 0;
                    this.wrongAnswersCountThisRound = 0;
                    this.reset();
                    let json = game.cache.json.get('gameplay');
                    this.wrongAnswersToLose = json["wrongAnswersToLose"];
                    this.numberOfQuestionsPerRound = json["numberOfQuestionsPerRound"];
                    this.lettersConfig = JSON.parse(JSON.stringify(json["lettersConfig"]));
                    this.rounds = JSON.parse(JSON.stringify(json["rounds"]));
                    this.numberOfRounds = json["numberOfRounds"] ?? this.rounds.length;
                    this.useImages = Boolean(game.cache.json.get('gameplay')["useImages"]);
                }
                setupCallbacks(onComplete, onLose) {
                    this.onComplete = onComplete;
                    this.onLose = onLose;
                }
                onLetterChosen(forceNewRound) {
                    if (forceNewRound || this.isNewRound()) {
                        return this.nextRound();
                    }
                    return false;
                }
                nextRound() {
                    this.correctAnswersCountThisRound = 0;
                    this.wrongAnswersCountThisRound = 0;
                    this.currentRound++;
                    if (this.isRoundsComplete()) {
                        this.onComplete(this.correctAnswersCount, this.correctAnswersCount);
                        return true;
                    }

                    return false;
                }
                getCorrectLetterName() {
                    return this.rounds[this.currentRound]['correctLetterName'];
                }
                isCorrectLetterAudioQuestionEnable() {
                    return this.rounds[this.currentRound]['audioQuestionEnable'];
                }
                getCorrectAndLetterSoundSfxAudioKey() {
                    return "Q-" + this.lettersConfig[this.getCorrectLetterName()]['Sounds of the letters'];
                }
                onCorrectAnswer() {
                    this.correctAnswersCountThisRound++;
                    this.correctAnswersCount++;
                    return this.onLetterChosen();
                }
                onWrongAnswer(forceNewRound) {
                    this.wrongAnswersCountThisRound++;
                    this.wrongAnswersCount++;
                    if (this.wrongAnswersCount >= this.wrongAnswersToLose) {
                        this.onLose(this.correctAnswersCount, this.correctAnswersCount);
                        return true;
                    }
                    else {
                        this.onLetterChosen(forceNewRound);
                    }
                    return false;
                }

                getMaxTotalAnswersCount() {
                    return this.wrongAnswersToLose + this.numberOfRounds - 1;
                }

                getCurrentTotalAnswersCount() {
                    return this.correctAnswersCount + this.wrongAnswersCount;
                }
                isNewRound() {
                    return this.correctAnswersCountThisRound >= 1 || (this.correctAnswersCountThisRound + this.wrongAnswersCountThisRound) === 4 || (this.correctAnswersCountThisRound + this.wrongAnswersCountThisRound) === 0;
                }
                isRoundsComplete() {
                    return this.currentRound >= this.numberOfRounds && this.wrongAnswersCount < this.wrongAnswersToLose;
                }
                reset() {
                    this.currentRound = 0;
                    this.correctAnswersCount = 0;
                    this.wrongAnswersCount = 0;
                }
                getCurrentRoundLetters() {
                    return this.rounds[this.currentRound]["letters"];
                }
            }
            core.Gameplay = Gameplay;
        })(core = sh.core || (sh.core = {}));
    })(sh || (sh = {}));

    (function (sh) {
        var scene;
        (function (scene) {
            class Boot extends Phaser.Scene {
                init() {
                    this.game.scale.transformX = (pageX) => {
                        let offsetLeft = 0;
                        let parentElement = game.canvas.parentElement;
                        while (parentElement) {
                            if (parentElement.offsetLeft) {
                                offsetLeft = parentElement.offsetLeft;
                                break;
                            }
                            parentElement = parentElement.parentElement;
                        }
                        return (pageX - offsetLeft) * this.game.scale.displayScale.x;
                    };
                    this.game.scale.transformY = (pageY) => {
                        let offsetTop = 0;
                        let parentElement = game.canvas.parentElement;
                        while (parentElement) {
                            if (parentElement.offsetTop) {
                                offsetTop = parentElement.offsetTop;
                                break;
                            }
                            parentElement = parentElement.parentElement;
                        }
                        return (pageY - offsetTop) * this.game.scale.displayScale.y;
                    };
                }
                create() {
                    game.scene.remove('Boot');
                    game.scene.add('Preloader', sh.scene.Preloader, true);
                }
            }
            scene.Boot = Boot;
        })(scene = sh.scene || (sh.scene = {}));
    })(sh || (sh = {}));

    (function (sh) {
        var scene;
        (function (scene) {
            var Gameplay = sh.core.Gameplay;
            class MainScene extends Phaser.Scene {
                create() {
                    this.gameplay = new Gameplay();
                    this.gameplayScreen = new sh.screen.GameplayScreen(this, this.gameplay);
                    this.children.add(this.gameplayScreen);
                    this.gameplayScreen.showInstructionPage();
                }
            }
            scene.MainScene = MainScene;
        })(scene = sh.scene || (sh.scene = {}));
    })(sh || (sh = {}));

    (function (sh) {
        var scene;
        (function (scene) {
            class Preloader extends Phaser.Scene {
                preload() {
                    if (typeof sh.App.json == "string") this.load.json('gameplay', sh.App.json); else this.game.cache.json.add('gameplay', sh.App.json);
                }
                create() {
                    let json = game.cache.json.get('gameplay');

                    let lettersConfig = json["lettersConfig"];
                    this.load.audio("englQuestion", "assets/games/stack-the-wood/sound/mp3/letters/englQuestion.mp3");
                    for (let letterName in lettersConfig) {
                        if (json["useImages"]) this.load.image(letterName, "assets/games/stack-the-wood/imgs/letters/" + letterName + ".png");
                        if (lettersConfig[letterName]) {
                            this.load.audio("Q-" + lettersConfig[letterName]["Sounds of the letters"], "assets/games/stack-the-wood/sound/mp3/letters/Sounds of the letters/" + lettersConfig[letterName]["Sounds of the letters"]);
                        }
                    }
                    let progressTxt = this.add.text(game.scale.width / 2, game.scale.height / 2 + 50, "", {
                        "fontFamily": "QuranErafont",
                        "fontSize": 25,
                        "color": "#333333",
                        "align": 'center'
                    });
                    progressTxt.setOrigin(0.5, 0.5);
                    this.load.pack('preloader', 'assets/games/stack-the-wood/pack.json');
                    this.load.on('progress', (value) => {
                        progressTxt.text = Math.ceil(value * 100) + "%";
                    }, this);
                    this.load.on('complete', () => {
                        this.nextScene();
                    });
                    this.load.start();
                }
                static playAnim(animKey, sprite, onComplete = null) {
                    let mainScene = game.scene.getScene('ScreenMain');
                    let data = Preloader.ANIMS_DATA[animKey];
                    if (!mainScene.anims.exists(animKey)) {
                        mainScene.anims.create({
                            key: animKey,
                            frames: mainScene.anims.generateFrameNames(data['atlas'], {
                                start: data['start'], end: data['end'], zeroPad: data['padNum'],
                                prefix: data['prefix'], suffix: ''
                            }),
                            frameRate: data['frameRate'],
                            repeat: data['repeat']
                        });
                    }
                    if (sprite.anims.currentAnim) {
                        sprite.anims.currentAnim.off('complete');
                    }
                    sprite.anims.stop();
                    // sprite.setTexture(data['atlas']);
                    sprite.play(animKey);
                    sprite.anims.currentAnim.once('complete', () => {
                        if (onComplete)
                            onComplete();
                    });
                    return sprite;
                }
                nextScene() {
                    game.scene.remove('Preloader');
                    game.scene.add('ScreenMain', sh.scene.MainScene, true);
                }
            }
            Preloader.ANIMS_DATA = {
                'idle': {
                    'start': 0,
                    'end': 99,
                    'padNum': 2,
                    'prefix': 'Iddle Snail 0',
                    'repeat': -1,
                    'frameRate': 30,
                    'atlas': 'idle-atlas'
                },
                'wrong': {
                    'start': 0,
                    'end': 99,
                    'padNum': 2,
                    'prefix': 'wrong Answer _20',
                    'repeat': 0,
                    'frameRate': 30,
                    'atlas': 'wrong-atlas'
                },
                'final': {
                    'start': 0,
                    'end': 79,
                    'padNum': 2,
                    'prefix': 'Final celebration Snail ',
                    'repeat': 0,
                    'frameRate': 30,
                    'atlas': 'final-atlas'
                },
                'idle_alone': {
                    'start': 98,
                    'end': 98,
                    'padNum': 2,
                    'prefix': 'Correct Answer _50',
                    'repeat': 0,
                    'frameRate': 30,
                    'atlas': 'correct1-atlas'
                },
                'correct1': {
                    'start': 0,
                    'end': 99,
                    'padNum': 2,
                    'prefix': 'Correct Answer _50',
                    'repeat': 0,
                    'frameRate': 30,
                    'atlas': 'correct1-atlas'
                },
                'correct2': {
                    'start': 0,
                    'end': 99,
                    'padNum': 2,
                    'prefix': 'Correct Answer _60',
                    'repeat': 0,
                    'frameRate': 30,
                    'atlas': 'correct2-atlas'
                },
                'correct3': {
                    'start': 0,
                    'end': 99,
                    'padNum': 2,
                    'prefix': 'Correct Answer _70',
                    'repeat': 0,
                    'frameRate': 30,
                    'atlas': 'correct3-atlas'
                },
            };
            scene.Preloader = Preloader;
        })(scene = sh.scene || (sh.scene = {}));
    })(sh || (sh = {}));
    (function (sh) {
        var screen;
        (function (screen) {
            class AreYouSureWindow extends Phaser.GameObjects.Container {
                constructor(scene, onYes, onNo) {
                    super(scene);
                    this._areYouSurePage = new Phaser.GameObjects.Image(this.scene, -105, 0 - 48, 'Exit warning');
                    this._areYouSurePage.setOrigin(0, 0);
                    this._areYouSurePage.setInteractive();
                    this._btnSureYes = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2 - 95, 485 - 50, 'btnYES1');
                    this._btnSureYes.setInteractive({ cursor: 'pointer' });
                    this._btnSureYes.on('pointerup', () => {
                        onYes;
                        angularComponentRef.backToMenu();
                    });
                    var modalTextStyle = {
                        backgroundColor: 'transparent',
                        stroke: '#ffffff',
                        strokeThickness: 2,
                        lineSpacing: 15,
                        fontFamily: 'Kids Rock DEMO',
                        fontSize: 27,
                        color: '#43425d',
                        wordWrap: true,
                        align: 'center'
                    };
                    var modalText = this.scene.add.text(game.scale.width / 2 + 12, game.scale.height / 2, "Your progress in this activity will not be saved. \n Are you sure you want to exit? ", modalTextStyle);
                    modalText.setOrigin(0.5, 0.5);

                    setupButtonTextureBased(this._btnSureYes, 'btnYES1', 'btnYES2');
                    this._btnSureNo = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2 + 95, 485 - 50, 'btnNO1');
                    this._btnSureNo.setInteractive({ cursor: 'pointer' });
                    this._btnSureNo.on('pointerup', onNo);
                    setupButtonTextureBased(this._btnSureNo, 'btnNO1', 'btnNO2');
                    this.add(this._areYouSurePage);
                    this.add(this._btnSureYes);
                    this.add(this._btnSureNo);
                    this.add(modalText);
                }
            }
            screen.AreYouSureWindow = AreYouSureWindow;
        })(screen = sh.screen || (sh.screen = {}));
    })(sh || (sh = {}));

    (function (sh) {
        var screen;
        (function (screen) {
            class CompleteWindow extends Phaser.GameObjects.Container {
                constructor(scene, onBack, onReplay, onNext) {
                    super(scene);
                    this.music = null;
                    this.setPosition(-104.5, -48);
                    this._bgComplete = new Phaser.GameObjects.Image(this.scene, 0, 0, 'Completion page LATEST UPDATED');
                    this._bgComplete.setOrigin(0, 0);
                    this._bgComplete.setInteractive();
                    this._cup = new Phaser.GameObjects.Image(this.scene, 400, 410, 'Trophy');
                    this._btnBack = new Phaser.GameObjects.Image(this.scene, 570, 570, 'btnBACK1');
                    this._btnReplay = new Phaser.GameObjects.Image(this.scene, 720, 570, 'btnReplay1');
                    this._btnNext = new Phaser.GameObjects.Image(this.scene, 870, 570, 'btnNEXT1');
                    let _CollectedPoints = new Phaser.GameObjects.Image(this.scene, 620, 440, 'Collected Points');
                    this.totalScoreTxt = this.scene.add.text(845, 352, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 35,
                        "color": "#F49F1C",
                        "align": 'center',
                        'stroke': '#70451A',
                        'strokeThickness': 6
                    });
                    this.totalScoreTxt.setOrigin(0.5, 0.5);
                    let grd = this.totalScoreTxt.context.createLinearGradient(0, 0, 0, this.totalScoreTxt.height);
                    grd.addColorStop(0, '#FFFF00');
                    grd.addColorStop(1, '#C17316');
                    this.totalScoreTxt.setFill(grd);
                    this.starScoreTxt = this.scene.add.text(648, 433, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 24,
                        "color": "#FFFFFF",
                        "align": 'center'
                    });
                    this.starScoreTxt.setOrigin(0.5, 0.5);
                    this.add([
                        this._bgComplete,
                        _CollectedPoints,
                        this._cup,
                        this._btnBack,
                        this._btnReplay,
                        this._btnNext,
                        this.totalScoreTxt,
                        this.starScoreTxt
                    ]);
                    this._btnBack.setInteractive({ cursor: 'pointer' });
                    this._btnBack.on('pointerup', () => {
                        onBack(this._btnBack);
                        angularComponentRef.backToMenu();
                        // if (this.music) {
                        //     this.music.stop();
                        // }
                    });
                    setupButtonTextureBased(this._btnBack, 'btnBACK1', 'btnBACK2');
                    this._btnReplay.setInteractive({ cursor: 'pointer' });
                    this._btnReplay.once('pointerup', () => {
                        onReplay(this._btnReplay);
                        if (this.music) {
                            this.music.stop();
                        }
                    });
                    setupButtonTextureBased(this._btnReplay, 'btnReplay1', 'btnReplay2');
                    this._btnNext.setInteractive({ cursor: 'pointer' });
                    this._btnNext.on('pointerup', () => {
                        onNext(this._btnNext);
                        window.angularComponentRef.nextActivity()
                    });
                    setupButtonTextureBased(this._btnNext, 'btnNEXT1', 'btnNEXT2');
                }
                show(score, starScore) {
                    window.angularComponentRef.gameFinish({ score, starScore })
                    this._cup.scale = 1.25;
                    this.scene.tweens.add({
                        targets: this._cup,
                        "scale": 1,
                        duration: 500,
                        ease: Phaser.Math.Easing.Back.Out
                    });
                    this.totalScoreTxt.text = String(window.angularComponentRef.component.userInfo.totalScore);
                    this.starScoreTxt.text = String(starScore);
                    // let music = this.scene.sound.add("viktory");
                    this.music = this.scene.sound.add("Activity completion fantastic");
                    this.music.play();
                }
            }
            screen.CompleteWindow = CompleteWindow;
        })(screen = sh.screen || (sh.screen = {}));
    })(sh || (sh = {}));

    (function (sh) {
        var screen;
        (function (screen) {
            class GameplayScreen extends Phaser.GameObjects.Container {
                constructor(scene, gameplay) {
                    super(scene);
                    let _dx = 0;
                    let _dy = 640;
                    this.carsPositionsOutScreen = [{ x: 245 - 50 - _dx, y: 514 - _dy }, { x: 485 - _dx, y: 514 - _dy }, { x: 723 + 55 - _dx, y: 514 - _dy }];
                    this.carsPositions = [{ x: 245 - 50, y: 514 }, { x: 485, y: 514 }, { x: 723 + 55, y: 514 }];
                    this.bgMusic = null;
                    this.correctAudio = null;
                    this.wfsnd = null;
                    this.showCompleteWindow = (score, starScore) => {
                        let completeWindow = new screen.CompleteWindow(this.scene, (target) => {
                            this.playBtnClickAnim(target);
                        }, (target) => {
                            this.playBtnClickAnim(target);
                            this.destroyGameplay();
                            this.remove(completeWindow);
                            this.showInstructionPage();
                        }, (target) => {
                            this.playBtnClickAnim(target);
                        });
                        this.setLettersInputEnabled(false);
                        delayedCall(9200, () => {
                            setPageBackground("bg-blue");
                            this.add(completeWindow);
                            completeWindow.show(score, starScore);
                            if (this.bgMusic) this.bgMusic.stop();
                        });
                    };
                    this.showLoseWindow = (score, starScore) => {
                        let tryAgainWindow = new screen.TryAgainWindow(this.scene, (target) => {
                            this.playBtnClickAnim(target);
                        }, (target) => {
                            this.playBtnClickAnim(target);
                            this.destroyGameplay();
                            this.remove(tryAgainWindow);
                            this.showInstructionPage();
                        });
                        this.setLettersInputEnabled(false);
                        delayedCall(2500, () => {
                            setPageBackground("bg-blue");
                            this.add(tryAgainWindow);
                            tryAgainWindow.show(score, starScore);
                            if (this.bgMusic) this.bgMusic.stop();
                        });
                    };
                    this.gameplay = gameplay;
                    window["t"] = this;
                }
                createHexagons() {
                    if (this.contentContainer && this.contentContainer.parentContainer) {
                        this.contentContainer.parentContainer.remove(this.contentContainer);
                    }

                    this.contentContainer = this.scene.add.container(0, 0);
                    this.gameplayContainer.addAt(this.contentContainer, 1);
                    window['this.contentContainer'] = this.contentContainer;

                    if (this.bgWoodsContainer && this.bgWoodsContainer.parentContainer) {
                        this.bgWoodsContainer.parentContainer.remove(this.bgWoodsContainer);
                    } else {
                        this.bgWoodsContainer = this.scene.add.container(330, 165);
                        this.bgWoodsContainer.setScale(0.6);
                        let positions = [
                            { x: 810, y: 416 }, { x: 844, y: 422 }, { x: 875, y: 425 }, { x: 906, y: 430 },
                            { x: 830, y: 364 - 40 }, { x: 857, y: 367 - 40 }, { x: 890, y: 369 - 40 },
                            { x: 847, y: 305 - 80 }, { x: 880, y: 307 - 80 },
                            { x: 867, y: 252 - 125 }
                        ];
                        for (let c = 0; c < 10; c++) {
                            let p = positions.shift();
                            let wood = this.scene.add.sprite(p.x, p.y, 'smalwood');
                            wood.alpha = 0;
                            window['wood'] = wood;
                            wood.setScale(1 / 0.6);
                            this.bgWoodsContainer.add(wood);
                            window['this.bgWoodsContainer'] = this.bgWoodsContainer;
                        }
                    }
                    this.gameplayContainer.addAt(this.bgWoodsContainer, 1);

                    let wasSnail = this.snail ? true : false;
                    let _ind = this.snail ? this.snail['index'] : this.carsPositions.length - 1;
                    this.snail = this.scene.add.sprite(this.snail ? this.snail.x : this.carsPositions[_ind].x + 305, this.snail ? this.snail.y : 604);
                    this.snail['index'] = _ind;
                    this.contentContainer.add(this.snail);
                    this.snail.setOrigin(0.5, 1);
                    window['this.snail'] = this.snail;
                    sh.scene.Preloader.playAnim('idle', this.snail);

                    /* let frontTree = this.scene.add.sprite(895, 185, 'frontTree');
                    window['frontTree'] = frontTree;
                    this.contentContainer.add(frontTree); */

                    let shadowContainer = this.scene.add.container();
                    this.contentContainer.add(shadowContainer);

                    this.cars = [];
                    let _i = 0;
                    for (let _k = 0; _k < this.carsPositions.length; _k++) {
                        let p = this.carsPositions[_k];
                        let hc = this.scene.add.container(p['x'], p['y']);
                        let hcIdleMotionContainer = this.scene.add.container();
                        hc.add(hcIdleMotionContainer);
                        let shadow = this.scene.add.sprite(this.carsPositions[_k]["x"], this.carsPositions[_k]["y"] + 50, 'shadow');
                        if (!wasSnail || _k === _ind) shadow.alpha = 0;
                        hc["shadow"] = shadow;
                        shadowContainer.add(shadow);

                        let h = this.scene.add.sprite(0, 0, 'cloud');
                        h.setOrigin(0.518, 0.5);
                        hc['isUsedAlready'] = false
                        hc.add(h);
                        hc["bg"] = h;
                        window['hc_' + _i] = hc;
                        window['h_' + _i] = h;
                        hcIdleMotionContainer.add(h);
                        hc['hcIdleMotionContainer'] = hcIdleMotionContainer;

                        hc["defX"] = p['x'];
                        hc["defY"] = p['y'];
                        this.cars.push(hc);
                        this.contentContainer.addAt(hc, 2);
                        hc['index'] = _i;
                        _i++;
                    }
                    window['this.cars'] = this.cars;
                }
                createLetters() {
                    /* if (this.letters) {
                        for (let l of this.letters) {
                            l.parentContainer["letter"] = null;
                            l["hexagon"] = null;
                            l.parentContainer.remove(l);
                        }
                    } */
                    this.letters = [];
                    let _letters = this.gameplay.getCurrentRoundLetters();
                    for (let n of _letters) {
                        let wordText;
                        if (this.gameplay.useImages) {
                            wordText = new Phaser.GameObjects.Image(this.scene, 0, 0, n);
                        } else {
                            wordText = this.scene.add.text(0, 0, n, {
                                "fontFamily": "QuranErafont",
                                "fontSize": 50,
                                "color": "#333333",
                                "align": 'center'
                            });
                            this.add(wordText);
                            wordText.setOrigin(0.5, 0.5);
                            wordText.setPadding({ left: 0, right: 0, top: 65, bottom: 65 });

                            if (wordText.width > 160) wordText.setScale(160 / wordText.width);
                        }
                        wordText.setPosition(0, -3);
                        wordText["key"] = n;
                        this.letters.push(wordText);
                        window['wordText'] = wordText;
                    }
                }
                showGameplay() {
                    this.isLost = false;
                    setPageBackground("bg-australia");
                    this.bgMusic = this.scene.sound.add("bg_sound");
                    this.bgMusic.play();
                    this.bgMusic.loop = true;
                    this.gameplay.reset();
                    this._gameStage = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2, game.scale.height / 2, 'bg');
                    this._gameStage.setOrigin(0.5, 0.5);
                    this._gameStage.setInteractive();
                    this._btnSound = new Phaser.GameObjects.Image(this.scene, 160 - 105, 100 - 50, 'Sound');
                    this._btnSound.setInteractive({ cursor: 'pointer' });
                    this._btnSound["defScale"] = this._btnSound.scale;
                    setupButtonTextureBased(this._btnSound, 'Sound', 'Sound HOVER EFFECT');
                    this._btnClose = new Phaser.GameObjects.Image(this.scene, 1025 - 105, 100 - 50, 'x Button');
                    this._btnClose.setInteractive({ cursor: 'pointer' });
                    this._btnClose["defScale"] = this._btnClose.scale;
                    setupButtonTextureBased(this._btnClose, 'x Button', 'x Button HOVER EFFECT');
                    this.gameplayContainer = new Phaser.GameObjects.Container(this.scene);
                    this.addAt(this.gameplayContainer, 0);
                    this.gameplayContainer.add([
                        this._gameStage,
                        this._btnSound,
                        this._btnClose
                    ]);
                    this.createBeehives();
                    this.shuffleOutHexagons();
                    this.gameplay.setupCallbacks(this.showCompleteWindow, this.showLoseWindow);
                }
                createBeehives() {
                    let startX = 140;
                    let startY = 43;
                    let dx = 36;
                    let _BeehiveEmptyArrayPositions = [];
                    for (let i = 0; i < this.gameplay.getMaxTotalAnswersCount(); i++) {
                        _BeehiveEmptyArrayPositions.push({ x: startX + i * dx, y: startY });
                    }
                    this._BeehiveEmptyArray = []; window["_BeehiveEmptyArray"] = this._BeehiveEmptyArray;
                    this._Beehive = [];
                    for (let p of _BeehiveEmptyArrayPositions) {
                        let _BeehiveEmpty = new Phaser.GameObjects.Image(this.scene, p['x'], p['y'], 'Beehive 1 Empty');
                        this._BeehiveEmptyArray.push(_BeehiveEmpty);
                        _BeehiveEmpty.visible = false;
                        let _Beehive = new Phaser.GameObjects.Image(this.scene, p['x'], p['y'], 'Beehive 1');
                        this._Beehive.push(_Beehive);
                    }
                    for (let bea of this._BeehiveEmptyArray) {
                        this.gameplayContainer.add(bea);
                    }
                    for (let bee of this._Beehive) {
                        this.gameplayContainer.add(bee);
                        bee.visible = false;
                    }
                }
                randomizeLettersPosition() {
                    let hx = this.cars.slice();
                    for (let l of this.letters) {
                        if (hx.length == 0)
                            return;
                        let hc = Phaser.Utils.Array.RemoveRandomElement(hx);
                        hc['hcIdleMotionContainer'].add(l);
                        hc["letter"] = l;
                        l["hexagon"] = hc;
                    }
                }
                updateHexagonsArrange() {
                    for (let hc of this.cars) {
                        if (!hc["letter"]) {
                            hc.parentContainer.bringToTop(hc);
                            break;
                        }
                    }
                }
                shuffleOutHexagons() {
                    this.createHexagons();

                    let setLettersInputEnabled = () => {
                        if (this.correctAudio && this.correctAudio.isPlaying) {
                            delayedCall((this.correctAudio.duration) * 1000, () => {
                                this.setLettersInputEnabled(true);
                            });
                        }
                        else {
                            this.setLettersInputEnabled(true);
                        }
                    };

                    if (!this.gameplay.isRoundsComplete()) {
                        if (this.gameplay.isCorrectLetterAudioQuestionEnable()) {
                            delayedCall(2000, () => {
                                this.playCorrectAudio();
                                setLettersInputEnabled();
                            });
                        }
                    }

                    if (this.sfxCarAccelerating) {
                        this.sfxCarAccelerating.stop();
                        this.sfxCarAccelerating = null;
                    }
                    if (this.sfxWrong) {
                        this.sfxWrong.stop();
                        this.sfxWrong = null;
                    }

                    if (!this.gameplay.isRoundsComplete()) {
                        this.createLetters();
                        this.randomizeLettersPosition();
                    }

                    this.setLettersInputEnabled(false);
                    this.updateHexagonsArrange();
                    // Phaser.Utils.Array.Shuffle(this.carsPositions);

                    delayedCall(1325, () => { this.scene.sound.add('All words appear').play(); });
                    if (!this.usedCarsIndexes) delayedCall(300, () => { this.scene.sound.add('Logs falling').play(); });

                    let cars = this.cars;
                    for (let i = 0; i < cars.length; i++) {
                        let hc = cars[i];

                        hc['letter'].alpha = 0;
                        this.scene.tweens.add({
                            targets: hc['letter'],
                            alpha: 1,
                            duration: 200,
                            delay: 1450
                        });

                        hc["defX"] = this.carsPositions[i]["x"];
                        hc["defY"] = this.carsPositions[i]["y"];

                        if (!this.usedCarsIndexes || this.usedCarsIndexes.indexOf(hc['index']) >= 0) {
                            this.scene.tweens.killTweensOf(hc);

                            hc.x = this.carsPositionsOutScreen[i].x;
                            hc.y = this.carsPositionsOutScreen[i].y;

                            // hc.alpha = 0;
                            this.scene.tweens.add({
                                targets: hc,
                                // alpha: 1,
                                "x": hc["defX"],
                                "y": hc["defY"],
                                duration: 300,
                                delay: (cars.length - 1 - i) * 325,
                                ease: Phaser.Math.Easing.Cubic.In,
                                onComplete: () => {
                                    // if (this.snail['index'] === i) sh.scene.Preloader.playAnim('idle', this.snail);
                                }
                            });

                            if (this.usedCarsIndexes) delayedCall((cars.length - 1 - hc['index']) * 450, () => {
                                this.scene.sound.add('new log falls').play();
                            });

                            this.scene.tweens.add({
                                targets: hc["shadow"],
                                alpha: 1,
                                duration: 325,
                                delay: (cars.length - 1 - i) * 375,
                                ease: Phaser.Math.Easing.Cubic.In
                            });
                        }
                    }

                    this.usedCarsIndexes = undefined;
                    this.correctIndex = undefined;

                    for (let c of cars) this.gameplayContainer.remove(c);
                    this.cars.sort((c1, c2) => c1.y - c2.y);
                    // for (let c of cars) this.gameplayContainer.add(c);

                    this.createInput();
                }
                shuffleInHexagons() {
                    this.updateHexagonsArrange();
                    let positions = this.carsPositions.slice();
                    this.setLettersInputEnabled(false);

                    // delayedCall(600, () => {
                    // this.scene.sound.add('move to centre').play();
                    this.shuffleOutHexagons();
                    // });
                }
                createInput() {
                    for (let hc of this.cars) {
                        let correctAnswer = hc["letter"] && hc["letter"]["key"] == this.gameplay.getCorrectLetterName();
                        //hc["letter"].alpha = correctAnswer ? 1 : 0.5;
                        hc["bg"].once('pointerup', () => {
                            if (hc["isUsedAlready"]) return;
                            hc['isUsedAlready'] = true;

                            // this.playBtnClickAnim(hc);
                            let lost = false;
                            let hcIndex = hc['index'] + 1;

                            var snaiPosX = this.carsPositions[hcIndex - 1].x + 305;
                            let d = Math.abs(snaiPosX - this.snail.x);
                            let duration = 650;//Math.min( d / 600 * 1000, 700);
                            // sh.scene.Preloader.playAnim('idle', this.snail);

                            if (correctAnswer) {
                                this.usedCarsIndexes = this.usedCarsIndexes || [];
                                this.usedCarsIndexes.push(hc['index']);
                                this.correctIndex = hc['index'];

                                let completed = this.onCorrectAnswer();

                                if (d > 100) delayedCall(1750, () => { this.scene.sound.add('Snail moving').play(); });

                                this.setLettersInputEnabled(false);
                                this.scene.tweens.add({
                                    targets: this.snail,
                                    x: snaiPosX,
                                    duration: duration,
                                    delay: 1750,
                                    onComplete: () => {
                                        let originX = [0.5, 0.808, 1.102];
                                        this.snail.originX = originX[hcIndex - 1];
                                        this.snail['index'] = hc['index'];

                                        this.scene.tweens.add({
                                            targets: hc["shadow"],
                                            alpha: 0,
                                            duration: 650,
                                            delay: 850
                                        });

                                        delayedCall(1700, () => { this.scene.sound.add('Throwing log bckwards').play(); });
                                        delayedCall(200, () => { this.scene.sound.add('Snail smile - correct animation').play(); });
                                        sh.scene.Preloader.playAnim('correct' + hcIndex, this.snail, () => {
                                            // this.setLettersInputEnabled(true);
                                            hc["bg"].disableInteractive();

                                            for (let c of this.cars) {
                                                this.scene.tweens.add({
                                                    targets: c["letter"],
                                                    alpha: 0,
                                                    duration: 500
                                                });
                                            }

                                            this.snail.originX = 0.5;
                                            if (completed) {
                                                sh.scene.Preloader.playAnim('final', this.snail);
                                                delayedCall(250, () => this.scene.sound.add('Snail laugh - final celebration animation').play());
                                                delayedCall(1800, () => { this.scene.sound.add('Final celebration').play(); });
                                            }
                                            // else sh.scene.Preloader.playAnim('idle', this.snail);
                                        });

                                        delayedCall(2450, () => {
                                            // completed = this.onCorrectAnswer();
                                            // this.scene.sound.add('First meteor explostion').play();
                                            // sh.scene.Preloader.playAnim('correct'+hcIndex, this.snail);
                                            delayedCall(completed ? 2000 : 1500, () => {
                                                if (!completed) {
                                                    this.shuffleInHexagons();
                                                } else {
                                                }
                                            })

                                            //wood
                                            let wood = this.bgWoodsContainer.getAll()[this.gameplay.correctAnswersCount - 1];
                                            this.scene.tweens.add({
                                                targets: wood,
                                                alpha: 1,
                                                duration: 500
                                            });
                                            wood.setScale(0.8 * 1 / 0.6);
                                            this.scene.tweens.add({
                                                targets: wood,
                                                scale: 1 / 0.6,
                                                duration: 200
                                            });
                                            let _y = wood.y;
                                            wood.y = _y - 100;
                                            this.scene.tweens.add({
                                                targets: wood,
                                                y: _y,
                                                duration: 450,
                                                ease: Phaser.Math.Easing.Bounce.Out
                                            });
                                            this.scene.tweens.add({
                                                targets: wood,
                                                angle: -3,
                                                yoyo: true,
                                                repeat: 2,
                                                duration: 100
                                            });
                                        });

                                        this.scene.tweens.add({
                                            targets: hc["bg"],
                                            alpha: 0,
                                            duration: 500,
                                            onComplete: () => {
                                                hc.visible = false;
                                            }
                                        });
                                        this.scene.tweens.add({
                                            targets: hc["letter"],
                                            alpha: 0,
                                            duration: 500
                                        });
                                    }
                                });
                            }
                            else {
                                this.scene.sound.add('Log selection').play();

                                if (d > 100) this.scene.sound.add('Snail moving').play();

                                // this.usedCarsIndexes = this.usedCarsIndexes || [];
                                // this.usedCarsIndexes.push(hc['index'])
                                this.snail['index'] = hc['index'];
                                this.setLettersInputEnabled(false);
                                this.scene.tweens.add({
                                    targets: this.snail,
                                    x: snaiPosX,
                                    duration: duration,
                                    onComplete: () => {
                                        delayedCall(1000, () => {
                                            this.scene.tweens.add({
                                                targets: hc["bg"],
                                                alpha: 1,
                                                duration: 500,
                                                onComplete: () => {
                                                    hc["bg"].disableInteractive();
                                                }
                                            });
                                        });

                                        delayedCall(950, () => this.scene.sound.add('Snail trying hard sound - wrong answer').play());
                                        sh.scene.Preloader.playAnim('wrong', this.snail, () => {
                                            this.snail.originX = 0.5;
                                            sh.scene.Preloader.playAnim('idle', this.snail);

                                            lost = this.onWrongAnswer();
                                            if (!lost) {
                                                // this.shuffleInHexagons();
                                                delayedCall(500, () => {
                                                    this.playCorrectAudio()

                                                    if (this.correctAudio && this.correctAudio.isPlaying) {
                                                        delayedCall((this.correctAudio.duration) * 1000, () => {
                                                            this.setLettersInputEnabled(true);
                                                        });
                                                    }
                                                    else {
                                                        this.setLettersInputEnabled(true);
                                                    }
                                                });
                                            } else {
                                                this.isLost = true;
                                            }
                                        });

                                        this.scene.tweens.add({
                                            targets: hc["bg"],
                                            alpha: 0,
                                            duration: 500
                                        });
                                        this.scene.tweens.add({
                                            targets: hc["letter"],
                                            alpha: 0,
                                            duration: 500
                                        });

                                        // delayedCall(700, ()=>{hc.visible=false;});
                                    }
                                });
                            }
                        });
                    }
                    this._btnSound.on('pointerup', () => {
                        this.playBtnClickAnim(this._btnSound);
                        this.onSoundClick();
                    });
                    this._btnClose.on('pointerup', () => {
                        this.playBtnClickAnim(this._btnClose);
                        this.onCloseClick();
                    });
                }
                hideAllUnusedBeehives() {
                    let i = this.gameplay.getCurrentTotalAnswersCount();
                    for (let k = i + 1; k < this._BeehiveEmptyArray.length; k++) {
                        this._BeehiveEmptyArray[k].visible = false;
                        this._Beehive[k].visible = false;
                    }
                }
                onCorrectAnswer() {
                    let correctAndLetterSoundSfxAudioKey = this.gameplay.getCorrectAndLetterSoundSfxAudioKey();
                    delayedCall(175, () => {
                        this.scene.sound.add(correctAndLetterSoundSfxAudioKey).play();
                    });

                    let i = this.gameplay.getCurrentTotalAnswersCount();
                    if (i < this._BeehiveEmptyArray.length) {
                        this._BeehiveEmptyArray[i].visible = false;
                        this._Beehive[i].visible = true;
                    }
                    this.hideAllUnusedBeehives();
                    let completed = this.gameplay.onCorrectAnswer();
                    delayedCall(0, () => this.scene.sound.add('Correct sfx').play());

                    // this.sfxCarAccelerating = this.scene.sound.add('Car accelerating');
                    // this.sfxCarAccelerating.play();
                    return completed;
                }
                onWrongAnswer(forceNewRound) {
                    let i = this.gameplay.getCurrentTotalAnswersCount();
                    if (i < this._BeehiveEmptyArray.length) {
                        this._BeehiveEmptyArray[i].visible = true;
                        this._Beehive[i].visible = false;
                    }
                    this.hideAllUnusedBeehives();
                    let lost = this.gameplay.onWrongAnswer(forceNewRound);
                    this.sfxWrong = this.scene.sound.add("wrong sfx");
                    this.sfxWrong.play();
                    return lost;
                }
                playCorrectAudio() {
                    if (this.correctAudio) {
                        this.correctAudio.stop();
                    }
                    this.correctAudio = this.scene.sound.add("englQuestion");
                    this.correctAudio.once('complete', () => {
                        this.correctAudio = this.scene.sound.add(this.gameplay.getCorrectAndLetterSoundSfxAudioKey());
                        this.correctAudio.play();
                    });
                    this.correctAudio.play();
                    if (this.areYouSureWindow && this.areYouSureWindow.parentContainer == this) {
                        this.correctAudio.pause();
                    }
                }
                onSoundClick() {
                    this.playCorrectAudio();
                }
                onCloseClick() {
                    this.showAreYouSurePage();
                    this.scene.sound.add('warning page pop up sfx').play();
                }
                playBtnClickAnim(target) {
                    let sc = target["defScale"] ? target["defScale"] : 1;
                    target.scaleX = target.scaleY = sc;
                    this.scene.tweens.add({
                        targets: target,
                        "scaleX": 0.9 * sc,
                        "scaleY": 0.9 * sc,
                        duration: 100,
                        yoyo: true
                    });
                }
                showInstructionPage() {
                    setPageBackground("bg-blue");
                    this.instructionPage = new screen.InstructionPage(this.scene, (target) => {
                        this.playBtnClickAnim(target);
                        this.remove(this.instructionPage);
                        this.showGameplay();
                        if (this.wfsnd) {
                            this.wfsnd.stop();
                        }
                    }, (target) => {
                        this.playBtnClickAnim(target);
                        if (this.wfsnd) {
                            this.wfsnd.stop();
                        }
                        if (!game.cache.json.get('gameplay')['welcomeAudioDisabled']) {
                            this.wfsnd = this.scene.sound.add("Welcome Find the sound");
                            this.wfsnd.play();
                        }
                    });
                    this.add(this.instructionPage);
                    try {
                        if (!game.cache.json.get('gameplay')['welcomeAudioDisabled']) {
                            this.wfsnd = this.scene.sound.add("Welcome Find the sound");
                            this.wfsnd.play();
                        }
                    }
                    catch (e) {
                        console.error(e);
                    }
                }
                showAreYouSurePage() {
                    /* for (let j = 0; j < this.cars.length; j++) {
                        if (this.cars[j]["raceTween"]) {
                            this.cars[j]["raceTween"].pause();
                        }
                    } */

                    pauseAllDelayedCalls();
                    setPageBackground("bg-blue");
                    this.pauseSounds();
                    if (!this.areYouSureWindow) this.areYouSureWindow = new screen.AreYouSureWindow(this.scene, () => {
                        this.remove(this.areYouSureWindow);
                        this.destroyGameplay();
                        this.showInstructionPage();
                    }, () => {
                        this.remove(this.areYouSureWindow);
                        this.unpauseSounds();
                        resumeAllDelayedCalls();

                        /* for (let j = 0; j < this.cars.length; j++) {
                            if (this.cars[j]["raceTween"]) {
                                this.cars[j]["raceTween"].resume();
                            }
                        } */

                        setPageBackground("bg-australia");
                    });
                    this.add(this.areYouSureWindow);
                }
                setLettersInputEnabled(enabled) {
                    if (enabled) {
                        for (let hc of this.cars) {
                            hc["bg"].setInteractive({ cursor: 'pointer' });
                            // hc["bg"].setInteractive(new Phaser.Geom.Rectangle(80, 100, 240, 200), Phaser.Geom.Rectangle.Contains);
                        }
                    }
                    else {
                        for (let hc of this.cars) {
                            hc["bg"].disableInteractive();
                        }
                    }
                }
                pauseSounds() {
                    if (this.correctAudio)
                        this.correctAudio.pause();
                    if (this.bgMusic)
                        this.bgMusic.pause();
                }
                unpauseSounds() {
                    if (this.correctAudio)
                        this.correctAudio.resume();
                    if (this.bgMusic)
                        this.bgMusic.resume();
                }
                destroyGameplay() {
                    this.setLettersInputEnabled(false);
                    this.cars = null;
                    this.snail = null;
                    this.usedCarsIndexes = false;
                    this.bgWoodsContainer.parentContainer.remove(this.bgWoodsContainer);
                    this.remove(this.gameplayContainer);
                    this.scene.sound.stopAll();
                    destroyAllDelayedCalls();
                }
            }
            screen.GameplayScreen = GameplayScreen;
        })(screen = sh.screen || (sh.screen = {}));
    })(sh || (sh = {}));
    (function (sh) {
        var screen;
        (function (screen) {
            class InstructionPage extends Phaser.GameObjects.Container {
                constructor(scene, onPlayClick, onSndClick) {
                    super(scene);
                    this._instructionPage = new Phaser.GameObjects.Image(this.scene, 0 - 105, 0 - 48, 'Instructions page  ALL ACTIVITY  TITLEs');
                    this._instructionPage.setOrigin(0, 0);
                    this._instructionPage.setInteractive();

                    this._instructionPageTitle = this.scene.add.text(475, 110, sh.App.json.instructionTitle ?? 'To the air', {
                        "fontFamily": "Kids Rock DEMO",
                        "fontSize": 40,
                        "color": "#43425D",
                        "align": 'center'
                    });
                    this._instructionPageTitle.setOrigin(0.5, 0.5);
                    window['this._instructionPageTitle'] = this._instructionPageTitle;
                    this._instructionPageTitle.setStroke('#ffffff', 5);
                    //  Apply the gradient fill.
                    const gradient = this._instructionPageTitle.context.createLinearGradient(0, 0, 0, this._instructionPageTitle.height);
                    gradient.addColorStop(0, '#eeef67');
                    gradient.addColorStop(0.55, '#e98c2c');
                    gradient.addColorStop(1, '#91301a');
                    this._instructionPageTitle.setFill(gradient);

                    this._btnPlay = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2, 480 - 50, 'btnPLAY1');
                    this._btnPlay.setInteractive({ cursor: 'pointer' });
                    this._btnPlay.once('pointerup', onPlayClick);
                    setupButtonTextureBased(this._btnPlay, 'btnPLAY1', 'btnPLAY2');
                    this.instrTxt = this.scene.add.text(game.scale.width / 2, game.scale.height / 2, "Help Qari snail collect firewood \nfor the winter.", {
                        "fontFamily": "Kids Rock DEMO",
                        "fontSize": 30,
                        "color": "#43425D",
                        "align": 'center'
                    });
                    this.instrTxt.setLineSpacing(15);
                    this.instrTxt.setOrigin(0.5, 0.5);
                    this._btnSoundInstruction = new Phaser.GameObjects.Image(this.scene, 800 - 105, 156 - 50, 'Sound');
                    this._btnSoundInstruction.setInteractive({ cursor: 'pointer' });
                    this._btnSoundInstruction.on('pointerup', onSndClick);
                    this._btnSoundInstruction["defScale"] = this._btnSoundInstruction.scale;
                    setupButtonTextureBased(this._btnSoundInstruction, 'Sound', 'Sound HOVER EFFECT');
                    this.add(this._instructionPage);
                    this.add(this._instructionPageTitle);
                    this.add(this.instrTxt);
                    this.add(this._btnPlay);
                    this.add(this._btnSoundInstruction);
                }
            }
            screen.InstructionPage = InstructionPage;
        })(screen = sh.screen || (sh.screen = {}));
    })(sh || (sh = {}));
    (function (sh) {
        var screen;
        (function (screen) {
            class TryAgainWindow extends Phaser.GameObjects.Container {
                constructor(scene, onBack, onReplay) {
                    super(scene);
                    this.music = null;
                    this.setPosition(-106, -48);
                    this._bg = new Phaser.GameObjects.Image(this.scene, 0, 0, 'Try again page');
                    this._bg.setOrigin(0, 0);
                    this._bg.setInteractive();
                    this._star = new Phaser.GameObjects.Image(this.scene, 400, 415, 'Break Star');
                    this._btnBack = new Phaser.GameObjects.Image(this.scene, 600, 580, 'btnBACK1');
                    this._btnReplay = new Phaser.GameObjects.Image(this.scene, 765, 580, 'btnReplay1');
                    this.totalScoreTxt = this.scene.add.text(850, 355, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 35,
                        "color": "#F49F1C",
                        "align": 'center',
                        'stroke': '#70451A',
                        'strokeThickness': 6
                    });
                    this.totalScoreTxt.setOrigin(0.5, 0.5);
                    let grd = this.totalScoreTxt.context.createLinearGradient(0, 0, 0, this.totalScoreTxt.height);
                    grd.addColorStop(0, '#FFFF00');
                    grd.addColorStop(1, '#C17316');
                    this.totalScoreTxt.setFill(grd);
                    this.starScoreTxt = this.scene.add.text(635, 431, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 24,
                        "color": "#FFFFFF",
                        "align": 'center'
                    });
                    this.starScoreTxt.setOrigin(0.5, 0.5);
                    this.add([
                        this._bg,
                        this._star,
                        this._btnBack,
                        this._btnReplay,
                        this.totalScoreTxt,
                        this.starScoreTxt
                    ]);
                    this._btnBack.setInteractive({ cursor: 'pointer' });
                    this._btnBack.on('pointerup', () => {
                        onBack(this._btnBack);
                        angularComponentRef.backToMenu();
                        // if (this.music) {
                        //     this.music.stop();
                        // }
                    });
                    setupButtonTextureBased(this._btnBack, 'btnBACK1', 'btnBACK2');
                    this._btnReplay.setInteractive({ cursor: 'pointer' });
                    this._btnReplay.once('pointerup', () => {
                        onReplay(this._btnReplay);
                        if (this.music) {
                            this.music.stop();
                        }
                    });
                    setupButtonTextureBased(this._btnReplay, 'btnReplay1', 'btnReplay2');
                }
                show(score, starScore) {
                    this._star.scale = 1.25;
                    this.scene.tweens.add({
                        targets: this._star,
                        "scale": 1,
                        duration: 500,
                        ease: Phaser.Math.Easing.Back.Out
                    });
                    this.totalScoreTxt.text = '';//String(window.angularComponentRef.component.userInfo.totalScore);
                    this.starScoreTxt.text = String(0);
                    this.music = this.scene.sound.add("Fail - close one");
                    this.music.play();
                }
            }
            screen.TryAgainWindow = TryAgainWindow;
        })(screen = sh.screen || (sh.screen = {}));
    })(sh || (sh = {}));
}

function destroyStackWood() {
    if (game) {
        game.destroy();
    }
}

var game;
var sh;
function submarineGame(json) {
    /**
     * @author Roman Parada
     * This class is created to fix overlapping of bottom part of canvas by navigation bar in iOS.
     * It make a delayed resize of the canvas (like Phaser-3 FIT methods does) and it overrides Phaser-3 input window to Phaser-3 core transform methods
     *
     * How to use:
     * Just call the code line below in Boot scene's init() method of your project:
     * new FitScaleManager(this.game).setup();
     */
    class FitScaleManager {
        constructor(game) {
            this.doResize = () => {
                let scale = this.calculateScale();
                let newCanvasWidth = this.phaserScaleManager.width * scale;
                let newCanvasHeight = this.phaserScaleManager.height * scale;
                this.canvasStyle.width = newCanvasWidth + 'px';
                this.canvasStyle.height = newCanvasHeight + 'px';
                this.canvasStyle.marginLeft = (window.innerWidth - newCanvasWidth) / 2 + 'px';
                this.canvasStyle.marginTop = (window.innerHeight - newCanvasHeight) / 2 + 'px';
            };
            this.game = game;
            this.canvasStyle = this.game.canvas.style;
            this.phaserScaleManager = this.game.scale;
        }
        static detectBestScaleMode() {
            let iOS = /iPad|iPhone|iPod/.test(navigator.platform || "");
            let isAndroid = window.navigator.userAgent.toLowerCase().indexOf("android") > -1;
            return iOS || isAndroid ? Phaser.Scale.FIT : Phaser.Scale.NONE;
        }
        ;
        /**
         * Just call this method once in Boot scene's init() method
         */
        setup() {
            this.phaserScaleManager.addListener(Phaser.Scale.Events.RESIZE, this.onResize, this);
            this.overridePhaserTransformMethods();
            this.onResize();
        }
        calculateScale() {
            if (game.scale.scaleMode === Phaser.Scale.NONE)
                return 1;
            return Math.min(window.innerWidth / this.phaserScaleManager.width, window.innerHeight / this.phaserScaleManager.height);
        }
        overridePhaserTransformMethods() {
            this.game.scale.transformX = (pageX) => {
                return (pageX - parseInt(this.canvasStyle.marginLeft.split("px")[0])) / this.calculateScale();
            };
            this.game.scale.transformY = (pageY) => {
                return (pageY - parseInt(this.canvasStyle.marginTop.split("px")[0])) / this.calculateScale();
            };
        }
        onResize() {
            setTimeout(this.doResize, FitScaleManager.RESIZE_DELAY);
        }
    }
    FitScaleManager.RESIZE_DELAY = 500;

    (function (sh) {
        class App extends Phaser.Game {
            constructor(json) {
                App.json = json;
                // console.log(App.json);

                let config = {
                    type: Phaser.AUTO,
                    width: App.CANVAS_WIDTH,
                    height: App.CANVAS_HEIGHT,
                    parent: 'game-container',
                    dom: {
                        createContainer: false
                    },
                    scale: {
                        mode: FitScaleManager.detectBestScaleMode(),
                        autoCenter: Phaser.Scale.CENTER_BOTH
                    },
                    transparent: true,
                    scene: {
                        create: () => {
                            this.scene.add('Boot', sh.scene.Boot, true);
                        }
                    }
                };
                super(config);
            }
        }
        App.CANVAS_WIDTH = 980;
        App.CANVAS_HEIGHT = 600;
        sh.App = App;
    })(sh || (sh = {}));

    game = new sh.App(json);

    var delayedCalls = [];
    function delayedCall(delay, callback, args, callbackScope) {
        let scene = game.scene.getAt(0);
        if (scene) {
            let dc = scene.time.delayedCall(delay, callback, args, callbackScope);
            delayedCalls.push(dc);
            return dc;
        }
        let t = setTimeout(callback, delay);
        delayedCalls.push(t);
        return t;
    }

    function pauseAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.paused = true;
            }
        }
    }

    function resumeAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.paused = false;
            }
        }
    }

    function destroyAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.remove(false);
            }
            else {
                clearTimeout(dc);
            }
        }
        delayedCalls = [];
    }

    function setPageBackground(bg) {
        // document.querySelector("html").style.backgroundImage = "url(assets/games/submarine/imgs/" + bg + ".jpg)";
    }

    function setupButton(btn, frame) {
        btn.on('pointerdown', () => { btn.setFrame(frame + '_hover' + '0000'); });
        btn.on('pointerover', () => { btn.setFrame(frame + '_hover' + '0000'); game.scene.getAt(0).sound.add("button hover").play(); });
        btn.on('pointerout', () => { btn.setFrame(frame + '0000'); });
        btn.on('pointerup', () => { btn.setFrame(frame + '0000'); game.scene.getAt(0).sound.add('activity selection - button selection').play(); });
    }

    function setupButtonTextureBased(btn, texture, hoverTexture, downTexture) {
        btn.on('pointerdown', () => { btn.setTexture(downTexture ?? hoverTexture); });
        btn.on('pointerover', () => { btn.setTexture(hoverTexture); game.scene.getAt(0).sound.add("button hover").play(); });
        btn.on('pointerout', () => { btn.setTexture(texture); });
        btn.on('pointerup', () => { btn.setTexture(texture); game.scene.getAt(0).sound.add('activity selection - button selection').play(); });
    }

    (function (sh) {
        var core;
        (function (core) {
            class Gameplay {
                constructor() {
                    this.currentRound = 0;
                    this.currentLetter = 0;
                    this.reset();
                    let json = game.cache.json.get('gameplay');
                    this.lettersConfig = JSON.parse(JSON.stringify(json["lettersConfig"]));
                    this.rounds = JSON.parse(JSON.stringify(json["rounds"]));
                    this.numberOfRounds = json["numberOfRounds"] ?? this.rounds.length;
                    this.useImages = Boolean(game.cache.json.get('gameplay')["useImages"]);
                }
                setupCallbacks(onComplete, onLose) {
                    this.onComplete = onComplete;
                    this.onLose = onLose;
                }
                nextRound() {
                    this.currentRound++;
                    if (this.isRoundsComplete()) {
                        this.onComplete(this.currentRound, this.currentRound);
                        return true;
                    }

                    return false;
                }
                getCorrectLetterName() {
                    return this.rounds[this.currentRound]['correctLetterName'];
                }
                isCorrectLetterAudioQuestionEnable() {
                    return this.rounds[this.currentRound]['audioQuestionEnable'];
                }
                getCorrectAudioKey() {
                    return this.lettersConfig[this.getCorrectLetterName()]['correctAudioKey'];
                }
                getCorrectAndLetterSoundSfxAudioKey() {
                    return "Q-" + this.lettersConfig[this.getCorrectLetterName()]['Sounds of the letters'];
                }
                isRoundsComplete() {
                    return this.currentRound >= this.numberOfRounds;
                }
                reset() {
                    this.currentRound = 0;
                }
                getCurrentRoundLetters() {
                    return this.rounds[this.currentRound]["letters"];
                }
            }
            core.Gameplay = Gameplay;
        })(core = sh.core || (sh.core = {}));
    })(sh || (sh = {}));

    (function (sh) {
        var scene;
        (function (scene) {
            class Boot extends Phaser.Scene {
                init() {
                    this.game.scale.transformX = (pageX) => {
                        let offsetLeft = 0;
                        let parentElement = game.canvas.parentElement;
                        while (parentElement) {
                            if (parentElement.offsetLeft) {
                                offsetLeft = parentElement.offsetLeft;
                                break;
                            }
                            parentElement = parentElement.parentElement;
                        }
                        return (pageX - offsetLeft) * this.game.scale.displayScale.x;
                    };
                    this.game.scale.transformY = (pageY) => {
                        let offsetTop = 0;
                        let parentElement = game.canvas.parentElement;
                        while (parentElement) {
                            if (parentElement.offsetTop) {
                                offsetTop = parentElement.offsetTop;
                                break;
                            }
                            parentElement = parentElement.parentElement;
                        }
                        return (pageY - offsetTop) * this.game.scale.displayScale.y;
                    };
                }
                create() {
                    game.scene.remove('Boot');
                    game.scene.add('Preloader', sh.scene.Preloader, true);
                }
            }
            scene.Boot = Boot;
        })(scene = sh.scene || (sh.scene = {}));
    })(sh || (sh = {}));

    (function (sh) {
        var scene;
        (function (scene) {
            var Gameplay = sh.core.Gameplay;
            class MainScene extends Phaser.Scene {
                create() {
                    this.gameplay = new Gameplay();
                    this.gameplayScreen = new sh.screen.GameplayScreen(this, this.gameplay);
                    this.children.add(this.gameplayScreen);
                    this.gameplayScreen.showInstructionPage();
                }
            }
            scene.MainScene = MainScene;
        })(scene = sh.scene || (sh.scene = {}));
    })(sh || (sh = {}));

    (function (sh) {
        var scene;
        (function (scene) {
            class Preloader extends Phaser.Scene {
                preload() {
                    if (typeof sh.App.json == "string") this.load.json('gameplay', sh.App.json); else this.game.cache.json.add('gameplay', sh.App.json);
                }
                create() {
                    let json = game.cache.json.get('gameplay');
                    let lettersConfig = json["lettersConfig"];
                    for (let letterName in lettersConfig) {
                        if (json["useImages"]) this.load.image(letterName, "assets/games/submarine/imgs/letters/" + (lettersConfig[letterName]["imageFileName"] ?? letterName) + ".png");
                        if (lettersConfig[letterName]["correctAudioKey"] == null) continue;
                        let correctAudioKey = lettersConfig[letterName]["correctAudioKey"];
                        this.load.audio(correctAudioKey, "assets/games/submarine/sound/mp3/letters/" + correctAudioKey.replace(".wav", ".mp3"));
                        if (lettersConfig[letterName]) {
                            this.load.audio("Q-" + lettersConfig[letterName]["Sounds of the letters"], "assets/games/submarine/sound/mp3/letters/Sounds of the letters/" + lettersConfig[letterName]["Sounds of the letters"]);
                        }
                    }
                    let progressTxt = this.add.text(game.scale.width / 2, game.scale.height / 2 + 50, "", {
                        "fontFamily": "QuranErafont",
                        "fontSize": 25,
                        "color": "#333333",
                        "align": 'center'
                    });
                    progressTxt.setOrigin(0.5, 0.5);
                    this.load.pack('preloader', 'assets/games/submarine/pack.json');
                    this.load.on('progress', (value) => {
                        progressTxt.text = Math.ceil(value * 100) + "%";
                    }, this);
                    this.load.on('complete', () => {
                        this.nextScene();
                    });
                    this.load.start();
                }
                static playAnim(animKey, sprite, onComplete = null) {
                    let mainScene = game.scene.getScene('ScreenMain');
                    let data = Preloader.ANIMS_DATA[animKey];
                    if (!mainScene.anims.exists(animKey)) {
                        mainScene.anims.create({
                            key: animKey,
                            frames: mainScene.anims.generateFrameNames(data['atlas'], {
                                start: data['start'], end: data['end'], zeroPad: data['padNum'],
                                prefix: data['prefix'], suffix: ''
                            }),
                            frameRate: data['frameRate'],
                            repeat: data['repeat']
                        });
                    }
                    if (sprite.anims.currentAnim) {
                        sprite.anims.currentAnim.off('complete');
                    }
                    sprite.anims.stop();
                    // sprite.setTexture(data['atlas']);
                    sprite.play(animKey);
                    sprite.anims.currentAnim.once('complete', () => {
                        if (onComplete)
                            onComplete();
                    });
                    return sprite;
                }
                nextScene() {
                    game.scene.remove('Preloader');
                    game.scene.add('ScreenMain', sh.scene.MainScene, true);
                }
            }
            Preloader.ANIMS_DATA = {
                'orca-idle': {
                    'start': 0,
                    'end': 74,
                    'padNum': 2,
                    'prefix': 'Whale Orca',
                    'repeat': -1,
                    'frameRate': 30,
                    'atlas': 'orca-atlas'
                },
                'shark-idle': {
                    'start': 0,
                    'end': 74,
                    'padNum': 2,
                    'prefix': 'Shark',
                    'repeat': -1,
                    'frameRate': 30,
                    'atlas': 'shark-atlas'
                },
                'squid-idle': {
                    'start': 0,
                    'end': 74,
                    'padNum': 2,
                    'prefix': 'octopus',
                    'repeat': -1,
                    'frameRate': 30,
                    'atlas': 'squid-atlas'
                },
                'starfish-idle': {
                    'start': 0,
                    'end': 74,
                    'padNum': 2,
                    'prefix': 'Starfish',
                    'repeat': -1,
                    'frameRate': 30,
                    'atlas': 'starfish-atlas'
                },
                'submarine-idle': {
                    'start': 0,
                    'end': 15,
                    'padNum': 2,
                    'prefix': 'submarine 2_1',
                    'repeat': -1,
                    'frameRate': 30,
                    'atlas': 'submarine-atlas'
                },
                'submarine-underwater': {
                    'start': 0,
                    'end': 15,
                    'padNum': 2,
                    'prefix': 'submarine 2_1',
                    'repeat': -1,
                    'frameRate': 13,
                    'atlas': 'submarine-atlas'
                },
                'submarine-stop': {
                    'start': 8,
                    'end': 8,
                    'padNum': 2,
                    'prefix': 'submarine 2_1',
                    'repeat': -1,
                    'frameRate': 13,
                    'atlas': 'submarine-atlas'
                },
                'whale-idle': {
                    'start': 0,
                    'end': 74,
                    'padNum': 2,
                    'prefix': 'Whale',
                    'repeat': -1,
                    'frameRate': 30,
                    'atlas': 'whale-atlas'
                }
            };
            scene.Preloader = Preloader;
        })(scene = sh.scene || (sh.scene = {}));
    })(sh || (sh = {}));
    (function (sh) {
        var screen;
        (function (screen) {
            class AreYouSureWindow extends Phaser.GameObjects.Container {
                constructor(scene, onYes, onNo) {
                    super(scene);
                    this._areYouSurePage = new Phaser.GameObjects.Image(this.scene, -105, 0 - 48, 'Exit warning');
                    this._areYouSurePage.setOrigin(0, 0);
                    this._areYouSurePage.setInteractive();
                    this._btnSureYes = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2 - 95, 485 - 50, 'btnYES1');
                    this._btnSureYes.setInteractive({ cursor: 'pointer' });
                    this._btnSureYes.on('pointerup', () => {
                        onYes;
                        angularComponentRef.backToMenu();
                    });
                    var modalTextStyle = {
                        backgroundColor: 'transparent',
                        stroke: '#ffffff',
                        strokeThickness: 2,
                        lineSpacing: 15,
                        fontFamily: 'Kids Rock DEMO',
                        fontSize: 27,
                        color: '#43425d',
                        wordWrap: true,
                        align: 'center'
                    };
                    var modalText = this.scene.add.text(game.scale.width / 2 + 12, game.scale.height / 2, "Your progress in this activity will not be saved. \n Are you sure you want to exit? ", modalTextStyle);
                    modalText.setOrigin(0.5, 0.5);

                    setupButtonTextureBased(this._btnSureYes, 'btnYES1', 'btnYES2');
                    this._btnSureNo = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2 + 95, 485 - 50, 'btnNO1');
                    this._btnSureNo.setInteractive({ cursor: 'pointer' });
                    this._btnSureNo.on('pointerup', onNo);
                    setupButtonTextureBased(this._btnSureNo, 'btnNO1', 'btnNO2');
                    this.add(this._areYouSurePage);
                    this.add(this._btnSureYes);
                    this.add(this._btnSureNo);
                    this.add(modalText);
                }
            }
            screen.AreYouSureWindow = AreYouSureWindow;
        })(screen = sh.screen || (sh.screen = {}));
    })(sh || (sh = {}));

    (function (sh) {
        var screen;
        (function (screen) {
            class CompleteWindow extends Phaser.GameObjects.Container {
                constructor(scene, onBack, onReplay, onNext) {
                    super(scene);
                    this.music = null;
                    this.setPosition(-104.5, -48);
                    this._bgComplete = new Phaser.GameObjects.Image(this.scene, 0, 0, 'Completion page LATEST UPDATED');
                    this._bgComplete.setOrigin(0, 0);
                    this._bgComplete.setInteractive();
                    this._cup = new Phaser.GameObjects.Image(this.scene, 400, 410, 'Trophy');
                    this._btnBack = new Phaser.GameObjects.Image(this.scene, 570, 570, 'btnBACK1');
                    this._btnReplay = new Phaser.GameObjects.Image(this.scene, 720, 570, 'btnReplay1');
                    this._btnNext = new Phaser.GameObjects.Image(this.scene, 870, 570, 'btnNEXT1');
                    let _CollectedPoints = new Phaser.GameObjects.Image(this.scene, 620, 440, 'Collected Points');
                    this.totalScoreTxt = this.scene.add.text(845, 352, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 35,
                        "color": "#F49F1C",
                        "align": 'center',
                        'stroke': '#70451A',
                        'strokeThickness': 6
                    });
                    this.totalScoreTxt.setOrigin(0.5, 0.5);
                    let grd = this.totalScoreTxt.context.createLinearGradient(0, 0, 0, this.totalScoreTxt.height);
                    grd.addColorStop(0, '#FFFF00');
                    grd.addColorStop(1, '#C17316');
                    this.totalScoreTxt.setFill(grd);
                    this.starScoreTxt = this.scene.add.text(648, 433, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 24,
                        "color": "#FFFFFF",
                        "align": 'center'
                    });
                    this.starScoreTxt.setOrigin(0.5, 0.5);
                    this.add([
                        this._bgComplete,
                        _CollectedPoints,
                        this._cup,
                        this._btnBack,
                        this._btnReplay,
                        this._btnNext,
                        this.totalScoreTxt,
                        this.starScoreTxt
                    ]);
                    this._btnBack.setInteractive({ cursor: 'pointer' });
                    this._btnBack.on('pointerup', () => {
                        onBack(this._btnBack);
                        angularComponentRef.backToMenu();
                        // if (this.music) {
                        //     this.music.stop();
                        // }
                    });
                    setupButtonTextureBased(this._btnBack, 'btnBACK1', 'btnBACK2');
                    this._btnReplay.setInteractive({ cursor: 'pointer' });
                    this._btnReplay.once('pointerup', () => {
                        onReplay(this._btnReplay);
                        if (this.music) {
                            this.music.stop();
                        }
                    });
                    setupButtonTextureBased(this._btnReplay, 'btnReplay1', 'btnReplay2');
                    this._btnNext.setInteractive({ cursor: 'pointer' });
                    this._btnNext.on('pointerup', () => {
                        onNext(this._btnNext);
                        window.angularComponentRef.nextActivity()
                    });
                    setupButtonTextureBased(this._btnNext, 'btnNEXT1', 'btnNEXT2');
                }
                show(score, starScore) {
                    window.angularComponentRef.gameFinish({ score, starScore })
                    this._cup.scale = 1.25;
                    this.scene.tweens.add({
                        targets: this._cup,
                        "scale": 1,
                        duration: 500,
                        ease: Phaser.Math.Easing.Back.Out
                    });
                    this.totalScoreTxt.text = String(window.angularComponentRef.component.userInfo.totalScore);
                    this.starScoreTxt.text = String(starScore);
                    // let music = this.scene.sound.add("viktory");
                    this.music = this.scene.sound.add("Activity completion fantastic");
                    this.music.play();
                }
            }
            screen.CompleteWindow = CompleteWindow;
        })(screen = sh.screen || (sh.screen = {}));
    })(sh || (sh = {}));

    (function (sh) {
        var screen;
        (function (screen) {
            class GameplayScreen extends Phaser.GameObjects.Container {
                constructor(scene, gameplay) {
                    super(scene);
                    this.carsPositions = [{ x: 360 - 23, y: 220 + 85 }];
                    this.bgMusic = null;
                    this.correctAudio = null;
                    this.wfsnd = null;
                    this.showCompleteWindow = (score, starScore) => {
                        let completeWindow = new screen.CompleteWindow(this.scene, (target) => {
                            this.playBtnClickAnim(target);
                        }, (target) => {
                            this.playBtnClickAnim(target);
                            this.destroyGameplay();
                            this.remove(completeWindow);
                            this.showInstructionPage();
                        }, (target) => {
                            this.playBtnClickAnim(target);
                        });
                        this.setLettersInputEnabled(false);
                        delayedCall(6500, () => {
                            setPageBackground("bg-blue");
                            this.add(completeWindow);
                            completeWindow.show(score, starScore);
                            if (this.bgMusic) this.bgMusic.stop();
                        });
                    };
                    this.showLoseWindow = (score, starScore) => {
                        let tryAgainWindow = new screen.TryAgainWindow(this.scene, (target) => {
                            this.playBtnClickAnim(target);
                        }, (target) => {
                            this.playBtnClickAnim(target);
                            this.destroyGameplay();
                            this.remove(tryAgainWindow);
                            this.showInstructionPage();
                        });
                        this.setLettersInputEnabled(false);
                        delayedCall(2500, () => {
                            setPageBackground("bg-blue");
                            this.add(tryAgainWindow);
                            tryAgainWindow.show(score, starScore);
                            if (this.bgMusic) this.bgMusic.stop();
                        });
                    };
                    this.gameplay = gameplay;
                    window["t"] = this;
                }
                createHexagons() {
                    if (this.contentContainer && this.contentContainer.parentContainer) {
                        this.contentContainer.parentContainer.remove(this.contentContainer);
                    }

                    this.contentContainer = this.scene.add.container(0, 0);
                    this.gameplayContainer.addAt(this.contentContainer, 1);
                    window['this.contentContainer'] = this.contentContainer;

                    if (this.bgCloudsContainer && this.bgCloudsContainer.parentContainer) {
                        this.bgCloudsContainer.parentContainer.remove(this.bgCloudsContainer);
                    }
                    this.bgCloudsContainer = this.scene.add.container(0, 0);
                    let positions = [{ x: 65, y: 30 }, { x: 450, y: 90 }, { x: 880, y: 330 }, { x: 590, y: 480 }, { x: 536, y: 500 }, { x: 428, y: 307 }, { x: 618, y: 327 }, { x: 450, y: 500 }];
                    for (let c = 0; c < 6; c++) {
                        let p = Phaser.Utils.Array.RemoveRandomElement(positions);
                        let cloud = this.scene.add.sprite(p.x, p.y, 'bgFish' + Math.ceil(Math.random() * 2));
                        cloud.setScale(0.35 + Math.random() * 0.45);
                        this.scene.tweens.add({
                            targets: cloud,
                            "x": cloud.x - 960,
                            duration: 40000 + Math.random() * 45000
                        });
                        this.scene.tweens.add({
                            targets: cloud,
                            "scaleX": cloud.scaleX * 0.85,
                            "scaleY": cloud.scaleY * 1.1,
                            yoyo: true,
                            // "y":p.y + (5 + Math.random()*10)*(Math.random() > 0.5 ? 1 : -1),
                            repeat: -1,
                            duration: 1500 + Math.random() * 1000
                        });
                        this.bgCloudsContainer.add(cloud);
                        window['this.bgCloudsContainer'] = this.bgCloudsContainer;
                    }

                    this.bubblesGroup = new Phaser.GameObjects.Container(this.scene);
                    this.bgCloudsContainer.add(this.bubblesGroup);

                    this.bubblesGroup1 = new Phaser.GameObjects.Image(this.scene, 120, -450 + 1200, 'bubblesGroup1');
                    window['this.bubblesGroup1'] = this.bubblesGroup1;
                    this.bubblesGroup.add(this.bubblesGroup1);

                    this.bubblesGroup2 = new Phaser.GameObjects.Image(this.scene, -50, -850 + 1200, 'bubblesGroup2');
                    window['this.bubblesGroup2'] = this.bubblesGroup2;
                    this.bubblesGroup.add(this.bubblesGroup2);

                    this.scene.tweens.add({
                        targets: this.bubblesGroup1,
                        "y": this.bubblesGroup1.y - 260,
                        duration: 30000
                    });
                    this.scene.tweens.add({
                        targets: this.bubblesGroup2,
                        "y": this.bubblesGroup2.y - 260,
                        duration: 25000
                    });

                    /* this.bubblesGroup3 = new Phaser.GameObjects.Image(this.scene, -200, -1300, 'bubblesGroup3');
                    window['this.bubblesGroup3']=this.bubblesGroup3;
                    this.bubblesGroup.add(this.bubblesGroup3);

                    this.bubblesGroup4 = new Phaser.GameObjects.Image(this.scene, -200, -1830, 'bubblesGroup4');
                    window['this.bubblesGroup4']=this.bubblesGroup4;
                    this.bubblesGroup.add(this.bubblesGroup4); */

                    this.gameplayContainer.addAt(this.bgCloudsContainer, 1);
                    window['this.gameplayContainer'] = this.gameplayContainer;

                    const animals = ['squid', 'whale', 'starfish', 'shark', 'orca'];

                    const period = 4;
                    let mod = this.gameplay.currentRound % period;
                    if (mod == period - 1 && this.gameplay.currentRound > 0) {
                        let animalName = animals[this.animalIndex];
                        let animal = this.scene.add.sprite(800, 440, animalName + '-atlas');
                        sh.scene.Preloader.playAnim(animalName + '-idle', animal);
                        window['animal'] = animal;
                        this.bgCloudsContainer.add(animal);
                        this.scene.tweens.add({
                            targets: animal,
                            "x": animal.x + 10,
                            yoyo: true,
                            repeat: -1,
                            duration: 1750
                        });
                    }

                    this.animalIndex++;
                    if (this.animalIndex > animals.length - 1) this.animalIndex = 0;

                    this.cars = [];
                    let _i = 0;
                    for (let p of this.carsPositions) {
                        let hc = this.scene.add.container(this.carsPositions[_i]['x'], this.carsPositions[_i]['y']);
                        let hcIdleMotionContainer = this.scene.add.container();
                        hc.add(hcIdleMotionContainer);
                        let h = this.scene.add.sprite(0, 0, 'dialogUI');
                        h.setOrigin(0.45, 0.95);
                        hc['isUsedAlready'] = false
                        hc.add(h);
                        hc["bg"] = h;
                        window['hc_' + _i] = hc;
                        window['h_' + _i] = h;
                        hcIdleMotionContainer.add(h);
                        hc['hcIdleMotionContainer'] = hcIdleMotionContainer;

                        let btnPlayVerse = this.scene.add.sprite(365, -105, 'btnPlayVerse');
                        btnPlayVerse.setInteractive({ cursor: 'pointer' });
                        btnPlayVerse["defScale"] = btnPlayVerse.scale;
                        window['btnPlayVerse'] = btnPlayVerse;
                        setupButtonTextureBased(btnPlayVerse, 'btnPlayVerse', 'btnPlayVerse', 'btnPlayVerseDown');
                        hc.add(btnPlayVerse);
                        btnPlayVerse.on('pointerup', () => {
                            this.playCorrectAudio();

                            if (this.handIcon && !this.handIcon['isAboveUpButton']) {
                                this.handIcon['isAboveUpButton'] = true;

                                this.scene.tweens.add({
                                    targets: this.handIcon,
                                    alpha: 0,
                                    duration: 250,
                                    onComplete: () => {
                                        this.handIcon.setPosition(315, 545);
                                        this.scene.tweens.add({
                                            targets: this.handIcon,
                                            alpha: 1,
                                            duration: 250,
                                            delay: 1500,
                                            onComplete: () => {
                                                this.btnUp.setInteractive({ cursor: 'pointer' });
                                            }
                                        });
                                        /* this.scene.tweens.add({
                                            targets: this.handIcon,
                                            x: 315,
                                            y: 545,
                                            duration: 500,
                                            ease: Phaser.Math.Easing.Quadratic.InOut,
                                            onComplete: ()=>{
                                                this.btnUp.setInteractive({ cursor: 'pointer' });
                                            }
                                        });         */
                                    }
                                });
                            }
                        });
                        if (this.gameplay.currentRound == 0) {
                            this.handIcon = new Phaser.GameObjects.Image(this.scene, 725, 215, 'Hand Icon');
                            hc["handIcon"] = this.handIcon;
                            window['this.handIcon'] = this.handIcon;
                            this.scene.tweens.add({
                                targets: this.handIcon,
                                angle: -5,
                                scaleY: 0.95,
                                scaleX: 0.95,
                                duration: 500,
                                yoyo: true,
                                repeat: -1,
                            });
                            this.gameplayContainer.add(this.handIcon);
                            this.handIcon.alpha = 0;
                            this.handIcon.y += 20;
                            this.scene.tweens.add({
                                targets: this.handIcon,
                                alpha: 1,
                                y: this.handIcon.y - 20,
                                delay: 500,
                                duration: 200
                            });
                        }

                        let doIdleMove = () => {
                            if (!this.scene) return;
                            this.scene.tweens.add({
                                targets: hcIdleMotionContainer,
                                "x": (0 + Math.random() * 10) * (Math.random() > 0.5 ? 1 : -1),
                                "y": (0 + Math.random() * 10) * (Math.random() > 0.5 ? 1 : -1),
                                yoyo: true,
                                delay: Math.random() > 0.5 ? 0 : Math.random() * 500,
                                duration: 1500,
                                ease: Phaser.Math.Easing.Quadratic.InOut,
                                onComplete: doIdleMove
                            });
                        };
                        doIdleMove();

                        hc["defX"] = p['x'];
                        hc["defY"] = p['y'];
                        this.cars.push(hc);
                        this.contentContainer.add(hc);
                        hc['index'] = _i;
                        _i++;
                    }
                    window['this.cars'] = this.cars;

                    this.ship = this.scene.add.container(480, 405);
                    this.ship['defY'] = this.ship.y;

                    this.submarine = this.scene.add.sprite(-200, 150, "submarine-atlas");
                    sh.scene.Preloader.playAnim('submarine-idle', this.submarine);
                    this.ship.add(this.submarine);
                    this.submarine.setOrigin(0.50242, 0.714);
                    window['this.submarine'] = this.submarine;

                    this.btnUp = this.scene.add.sprite(-190, 127, 'btnUp');
                    if (!this.handIcon) this.btnUp.setInteractive({ cursor: 'pointer' });
                    window['this.btnUp'] = this.btnUp;
                    this.btnUp.setScale(1.02)
                    this.btnUp["defScale"] = this.btnUp.scale;
                    window['btnUp'] = this.btnUp;
                    setupButtonTextureBased(this.btnUp, 'btnUp', 'btnUp', 'btnUpDown');
                    this.ship.add(this.btnUp);

                    this.submarineFront = this.scene.add.sprite(-200.5, 167.5, "submarine");
                    this.ship.add(this.submarineFront);
                    window['this.submarineFront'] = this.submarineFront;
                    this.submarineFront.setOrigin(0.5, 1);
                    this.submarineFront.alpha = 0;

                    this.ship["defY"] = this.ship.y;
                    this.contentContainer.add(this.ship);
                    window['this.ship'] = this.ship;
                }
                createLetters() {
                    /* if (this.letters) {
                        for (let l of this.letters) {
                            l.parentContainer["letter"] = null;
                            l["hexagon"] = null;
                            l.parentContainer.remove(l);
                        }
                    } */
                    this.letters = [];
                    let _letters = this.gameplay.getCurrentRoundLetters();
                    for (let n of _letters) {
                        let wordText;
                        if (this.gameplay.useImages) {
                            wordText = new Phaser.GameObjects.Image(this.scene, 0, 0, n);
                        } else {
                            wordText = this.scene.add.text(0, 0, n, {
                                "fontFamily": "QuranErafont",
                                "fontSize": 65,
                                "color": "#333333",
                                "align": 'center'
                            });
                            this.add(wordText);
                            wordText.setOrigin(0.5, 0.5);
                            wordText.setPadding({ left: 0, right: 0, top: 65, bottom: 65 });

                            if (wordText.width > 520) wordText.setScale(520 / wordText.width);
                            if (wordText.height > 320) wordText.setScale(Math.min(320 / wordText.width, wordText.scaleX));
                        }
                        wordText.setPosition(24, -103);
                        wordText["key"] = n;
                        this.letters.push(wordText);
                        window['wordText'] = wordText;
                    }
                }
                showGameplay() {
                    this.isLost = false;
                    setPageBackground("bg-australia");
                    this.bgMusic = this.scene.sound.add("bg_sound");
                    this.bgMusic.play();
                    this.bgMusic.loop = true;
                    this.gameplay.reset();

                    this._gameStage = new Phaser.GameObjects.Container(this.scene);
                    this._gameStage.setPosition(game.scale.width / 2, 600);
                    this._gameStageImg = new Phaser.GameObjects.Image(this.scene, 0, 0, 'bg');
                    this._gameStageImg.setOrigin(0.5, 1);
                    this._gameStageImg.setInteractive();
                    this._gameStage.add(this._gameStageImg);

                    this._gameStage['defY'] = this._gameStage.y;
                    window['this._gameStage'] = this._gameStage;
                    this._btnSound = new Phaser.GameObjects.Image(this.scene, 160 - 105, 100 - 50, 'Sound');
                    this._btnSound.setInteractive({ cursor: 'pointer' });
                    this._btnSound["defScale"] = this._btnSound.scale;
                    setupButtonTextureBased(this._btnSound, 'Sound', 'Sound HOVER EFFECT');
                    this._btnSound.visible = false;
                    this._btnClose = new Phaser.GameObjects.Image(this.scene, 1025 - 105, 100 - 50, 'x Button');
                    this._btnClose.setInteractive({ cursor: 'pointer' });
                    this._btnClose["defScale"] = this._btnClose.scale;
                    setupButtonTextureBased(this._btnClose, 'x Button', 'x Button HOVER EFFECT');
                    this.gameplayContainer = new Phaser.GameObjects.Container(this.scene);
                    this.addAt(this.gameplayContainer, 0);
                    this.gameplayContainer.add([
                        this._gameStage,
                        this._btnSound,
                        this._btnClose
                    ]);
                    this.shuffleOutHexagons();
                    this.gameplay.setupCallbacks(this.showCompleteWindow, this.showLoseWindow);

                    this.animalIndex = 0;
                }
                randomizeLettersPosition() {
                    let hx = this.cars.slice();
                    for (let l of this.letters) {
                        if (hx.length == 0)
                            return;
                        let hc = Phaser.Utils.Array.RemoveRandomElement(hx);
                        hc['hcIdleMotionContainer'].add(l);
                        hc["letter"] = l;
                        l["hexagon"] = hc;
                    }
                }
                updateHexagonsArrange() {
                    for (let hc of this.cars) {
                        if (!hc["letter"]) {
                            hc.parentContainer.bringToTop(hc);
                            break;
                        }
                    }
                }
                shuffleOutHexagons() {
                    this.createHexagons();

                    let setLettersInputEnabled = () => {
                        if (this.correctAudio && this.correctAudio.isPlaying) {
                            delayedCall((this.correctAudio.duration * 0.75) * 1000, () => {
                                this.setLettersInputEnabled(true);
                            });
                        }
                        else {
                            this.setLettersInputEnabled(true);
                        }
                    };

                    if (!this.gameplay.isRoundsComplete()) {
                        if (this.gameplay.isCorrectLetterAudioQuestionEnable()) {
                            // this.playCorrectAudio();
                        }
                        setLettersInputEnabled();
                    }

                    if (this.sfxCarAccelerating) {
                        this.sfxCarAccelerating.stop();
                        this.sfxCarAccelerating = null;
                    }
                    if (this.sfxWrong) {
                        this.sfxWrong.stop();
                        this.sfxWrong = null;
                    }

                    if (!this.gameplay.isRoundsComplete()) {
                        this.createLetters();
                        this.randomizeLettersPosition();
                    }

                    this.setLettersInputEnabled(false);
                    this.updateHexagonsArrange();
                    // Phaser.Utils.Array.Shuffle(this.carsPositions);
                    if (this.gameplay.currentRound == 0) delayedCall(500, () => {
                        // this.scene.sound.add('Blocks appearing in each round').play();
                    });
                    let cars = this.cars;
                    for (let i = 0; i < cars.length; i++) {
                        let hc = cars[i];
                        hc.x = this.carsPositions[i]["x"];
                        hc.y = this.carsPositions[i]["y"];
                        this.scene.tweens.killTweensOf(hc);

                        hc.setScale(0, 0);
                        this.scene.tweens.add({
                            targets: hc,
                            "scaleX": 1,
                            "scaleY": 1,
                            duration: 550,
                            delay: 600,
                            ease: Phaser.Math.Easing.Back.Out,
                            onComplete: () => { }
                        });
                    }
                    this.scene.sound.add('Text from earth popping up').play()

                    if (this.gameplay.currentRound != 0) {
                        let allBgClouds = this.bgCloudsContainer.getAll();
                        for (let c of allBgClouds) {
                            this.scene.tweens.killTweensOf(c);
                            let _y = c.y;
                            c.y -= 800;
                            this.scene.tweens.add({
                                targets: c,
                                y: _y,
                                duration: 1550 - 500,
                                ease: Phaser.Math.Easing.Quadratic.Out
                            });
                        }

                        this.scene.tweens.add({
                            targets: this.ship,
                            "y": this.ship.y - 15,
                            duration: 650,
                            ease: Phaser.Math.Easing.Quadratic.InOut,
                            yoyo: true,
                            onComplete: () => {
                                this.scene.tweens.add({
                                    targets: this.ship,
                                    "y": this.ship.y - 7,
                                    duration: 1500 - 500,
                                    repeat: -1,
                                    yoyo: true
                                });
                            }
                        });
                    } else {
                        this.scene.tweens.add({
                            targets: this.ship,
                            "y": this.ship.y - 7,
                            duration: 1500 - 500,
                            repeat: -1,
                            yoyo: true
                        });
                    }

                    for (let c of cars) this.gameplayContainer.remove(c);
                    this.cars.sort((c1, c2) => c1.y - c2.y);
                    // for (let c of cars) this.gameplayContainer.add(c);

                    this.createInput();
                }
                shuffleInHexagons() {
                    this.updateHexagonsArrange();
                    let positions = this.carsPositions.slice();
                    this.setLettersInputEnabled(false);

                    // delayedCall(600, () => {
                    // this.scene.sound.add('move to centre').play();
                    this.shuffleOutHexagons();
                    // });
                }
                createInput() {
                    this.btnUp.once('pointerup', () => {
                        if (this.handIcon) {
                            let handIcon = this.handIcon;
                            this.handIcon = null;
                            this.scene.tweens.add({
                                targets: handIcon,
                                alpha: 0,
                                y: handIcon.y + 15,
                                duration: 300,
                                onComplete: () => {
                                    if (handIcon.parentContainer) handIcon.parentContainer.remove(handIcon);
                                }
                            });
                        }

                        this.btnUp.disableInteractive();
                        // this.btnUp.visible = false;
                        if (this.correctAudio) {
                            this.correctAudio.stop();
                        }

                        this.scene.tweens.add({
                            targets: this.cars[0],
                            alpha: 0,
                            scaleX: 0,
                            scaleY: 0,
                            duration: 300
                        });

                        let completed = this.gameplay.nextRound();

                        // this.scene.sound.add('First meteor explostion').play();

                        this.setLettersInputEnabled(false);

                        // sh.scene.Preloader.playAnim('snail-giggling', this.snail);
                        // delayedCall(300, () => {this.scene.sound.add('Snail giggling sound - correct selection').play();});

                        for (let _hc of this.cars) {
                            this.scene.tweens.add({
                                targets: _hc,
                                y: _hc.y + 640,
                                duration: 1500 - 500,
                                delay: 0,
                                ease: Phaser.Math.Easing.Cubic.In,
                                onComplete: () => {
                                    if (_hc && _hc.parentContainer) _hc.parentContainer.remove(_hc);
                                }
                            });
                        }
                        this.scene.tweens.killTweensOf(this.ship);
                        if (!completed) {
                            this.scene.tweens.add({
                                targets: this.ship,
                                "y": this.ship.y - 250,
                                ease: Phaser.Math.Easing.Sine.InOut,
                                duration: 600,
                                delay: 0,
                                onComplete: () => {
                                    this.scene.tweens.add({
                                        targets: this.ship,
                                        "y": this.ship['defY'],
                                        duration: 500,
                                    });
                                }
                            });
                            this.scene.sound.add('Submarine going up').play()
                        }
                        if (completed) delayedCall(3400, () => this.scene.sound.add('Final celebration sound').play())

                        const firstDy = 450;
                        let dy = this.gameplay.currentRound == 1 ? firstDy : (1850 - firstDy - 600) / (this.gameplay.numberOfRounds) * (this.gameplay.currentRound) + firstDy;
                        this.scene.tweens.add({
                            targets: this._gameStage,
                            y: this._gameStage['defY'] + dy,
                            duration: this.gameplay.currentRound == 1 ? 1500 : 2800,
                            ease: Phaser.Math.Easing.Quadratic.InOut
                        });
                        ;

                        let allBgClouds = this.bgCloudsContainer.getAll();
                        for (let c of allBgClouds) {
                            this.scene.tweens.add({
                                targets: c,
                                y: c.y + 800,
                                duration: 1900 - 500,
                                delay: 0,
                                ease: Phaser.Math.Easing.Cubic.InOut,
                                onComplete: () => {
                                    if (c.parentContainer) c.parentContainer.remove(c);
                                }
                            });
                        }

                        delayedCall(completed ? 0 : 2500 - 1000, () => {
                            if (!completed) {
                                this.shuffleInHexagons();
                            } else {
                                this.scene.sound.add('Submarine going up').play()
                                delayedCall(2200, () => this.scene.sound.add('Going above water sound').play())
                                delayedCall(2000, () => sh.scene.Preloader.playAnim('submarine-underwater', this.submarine))
                                delayedCall(3200, () => {
                                    sh.scene.Preloader.playAnim('submarine-stop', this.submarine)
                                    this.scene.tweens.add({
                                        targets: this.submarineFront,
                                        duration: 250,
                                        alpha: 1
                                    });
                                    this.scene.tweens.add({
                                        targets: this.submarine,
                                        duration: 250,
                                        delay: 250,
                                        alpha: 0
                                    });
                                    /* this.scene.tweens.add({
                                        targets: this.ship,
                                        duration: 1300,
                                        y: 190,
                                        ease: Phaser.Math.Easing.Sine.Out,
                                    }); */
                                })
                                this.scene.tweens.add({
                                    targets: this.ship,
                                    duration: 1000,
                                    y: 180,
                                    // ease: Phaser.Math.Easing.Back.Out,
                                    // y: 220,
                                    ease: Phaser.Math.Easing.Sine.Out
                                });

                                this.flag = this.scene.add.sprite(-245, 0, "flag");
                                this.flag.setOrigin(0, 0);
                                this.ship.addAt(this.flag, 0);
                                window['this.flag'] = this.flag;
                                this.scene.tweens.add({
                                    targets: this.flag,
                                    duration: 1000,
                                    y: -130,
                                    ease: Phaser.Math.Easing.Sine.Out,
                                    delay: 2800
                                });

                                delayedCall(850, () => {
                                    this.overlayFilter = this.scene.add.sprite(0, 0, "OverlayFilter");
                                    this.overlayFilter.alpha = 0;
                                    this.ship.add(this.overlayFilter);
                                    this.overlayFilter.setOrigin(0, 0);
                                    this.gameplayContainer.add(this.overlayFilter);
                                    window['this.overlayFilter'] = this.overlayFilter;

                                    this.scene.tweens.add({
                                        targets: this._gameStage,
                                        duration: 1500,
                                        delay: 1000,
                                        y: 2100
                                    });
                                    this.scene.tweens.add({
                                        targets: this.overlayFilter,
                                        duration: 1000,
                                        delay: 2000,
                                        alpha: 0.4
                                    });
                                });
                            }
                        });
                    });

                    this._btnSound.on('pointerup', () => {
                        this.playBtnClickAnim(this._btnSound);
                        this.onSoundClick();
                    });
                    this._btnClose.on('pointerup', () => {
                        this.playBtnClickAnim(this._btnClose);
                        this.onCloseClick();
                    });
                }
                playCorrectAudio() {
                    if (this.correctAudio) {
                        this.correctAudio.stop();
                    }
                    this.correctAudio = this.scene.sound.add(this.gameplay.getCorrectAudioKey());
                    this.correctAudio.play();
                    if (this.areYouSureWindow && this.areYouSureWindow.parentContainer == this) {
                        this.correctAudio.pause();
                    }
                }
                onSoundClick() {
                    this.playCorrectAudio();
                }
                onCloseClick() {
                    this.showAreYouSurePage();
                    this.scene.sound.add('warning page pop up sfx').play();
                }
                playBtnClickAnim(target) {
                    let sc = target["defScale"] ? target["defScale"] : 1;
                    target.scaleX = target.scaleY = sc;
                    this.scene.tweens.add({
                        targets: target,
                        "scaleX": 0.9 * sc,
                        "scaleY": 0.9 * sc,
                        duration: 100,
                        yoyo: true
                    });
                }
                showInstructionPage() {
                    setPageBackground("bg-blue");
                    this.instructionPage = new screen.InstructionPage(this.scene, (target) => {
                        this.playBtnClickAnim(target);
                        this.remove(this.instructionPage);
                        this.showGameplay();
                        if (this.wfsnd) {
                            this.wfsnd.stop();
                        }
                    }, (target) => {
                        this.playBtnClickAnim(target);
                        if (this.wfsnd) {
                            this.wfsnd.stop();
                        }
                        if (!game.cache.json.get('gameplay')['welcomeAudioDisabled']) {
                            this.wfsnd = this.scene.sound.add("Welcome Find the sound");
                            this.wfsnd.play();
                        }
                    });
                    this.add(this.instructionPage);
                    try {
                        if (!game.cache.json.get('gameplay')['welcomeAudioDisabled']) {
                            this.wfsnd = this.scene.sound.add("Welcome Find the sound");
                            this.wfsnd.play();
                        }
                    }
                    catch (e) {
                        console.error(e);
                    }
                }
                showAreYouSurePage() {
                    /* for (let j = 0; j < this.cars.length; j++) {
                        if (this.cars[j]["raceTween"]) {
                            this.cars[j]["raceTween"].pause();
                        }
                    } */

                    pauseAllDelayedCalls();
                    setPageBackground("bg-blue");
                    this.pauseSounds();
                    if (!this.areYouSureWindow) this.areYouSureWindow = new screen.AreYouSureWindow(this.scene, () => {
                        this.remove(this.areYouSureWindow);
                        this.destroyGameplay();
                        this.showInstructionPage();
                    }, () => {
                        this.remove(this.areYouSureWindow);
                        this.unpauseSounds();
                        resumeAllDelayedCalls();

                        /* for (let j = 0; j < this.cars.length; j++) {
                            if (this.cars[j]["raceTween"]) {
                                this.cars[j]["raceTween"].resume();
                            }
                        } */

                        setPageBackground("bg-australia");
                    });
                    this.add(this.areYouSureWindow);
                }
                setLettersInputEnabled(enabled) {
                    if (enabled) {
                        for (let hc of this.cars) {
                            // hc["bg"].setInteractive({ cursor: 'pointer' });
                            hc["bg"].setInteractive(new Phaser.Geom.Rectangle(80, 100, 240, 200), Phaser.Geom.Rectangle.Contains);
                        }
                    }
                    else {
                        for (let hc of this.cars) {
                            hc["bg"].disableInteractive();
                        }
                    }
                }
                pauseSounds() {
                    if (this.correctAudio)
                        this.correctAudio.pause();
                    if (this.bgMusic)
                        this.bgMusic.pause();
                }
                unpauseSounds() {
                    if (this.correctAudio)
                        this.correctAudio.resume();
                    if (this.bgMusic)
                        this.bgMusic.resume();
                }
                destroyGameplay() {
                    this.setLettersInputEnabled(false);
                    this.remove(this.gameplayContainer);
                    this.scene.sound.stopAll();
                    destroyAllDelayedCalls();
                }
            }
            screen.GameplayScreen = GameplayScreen;
        })(screen = sh.screen || (sh.screen = {}));
    })(sh || (sh = {}));
    (function (sh) {
        var screen;
        (function (screen) {
            class InstructionPage extends Phaser.GameObjects.Container {
                constructor(scene, onPlayClick, onSndClick) {
                    super(scene);
                    this._instructionPage = new Phaser.GameObjects.Image(this.scene, 0 - 105, 0 - 48, 'Instructions page  ALL ACTIVITY  TITLEs');
                    this._instructionPage.setOrigin(0, 0);
                    this._instructionPage.setInteractive();

                    this._instructionPageTitle = this.scene.add.text(475, 110, sh.App.json.instructionTitle ?? 'Submarine', {
                        "fontFamily": "Kids Rock DEMO",
                        "fontSize": 45,
                        "color": "#43425D",
                        "align": 'center'
                    });
                    this._instructionPageTitle.setOrigin(0.5, 0.5);
                    window['this._instructionPageTitle'] = this._instructionPageTitle;
                    this._instructionPageTitle.setStroke('#ffffff', 5);
                    //  Apply the gradient fill.
                    const gradient = this._instructionPageTitle.context.createLinearGradient(0, 0, 0, this._instructionPageTitle.height);
                    gradient.addColorStop(0, '#eeef67');
                    gradient.addColorStop(0.55, '#e98c2c');
                    gradient.addColorStop(1, '#91301a');
                    this._instructionPageTitle.setFill(gradient);

                    this._btnPlay = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2, 480 - 50, 'btnPLAY1');
                    this._btnPlay.setInteractive({ cursor: 'pointer' });
                    this._btnPlay.once('pointerup', onPlayClick);
                    setupButtonTextureBased(this._btnPlay, 'btnPLAY1', 'btnPLAY2');
                    this.instrTxt = this.scene.add.text(game.scale.width / 2, game.scale.height / 2, "Recite the verse and get the submarine\n to the surface.", {
                        "fontFamily": "Kids Rock DEMO",
                        "fontSize": 30,
                        "color": "#43425D",
                        "align": 'center'
                    });
                    this.instrTxt.setLineSpacing(15);
                    this.instrTxt.setOrigin(0.5, 0.5);
                    this._btnSoundInstruction = new Phaser.GameObjects.Image(this.scene, 800 - 105, 156 - 50, 'Sound');
                    this._btnSoundInstruction.setInteractive({ cursor: 'pointer' });
                    this._btnSoundInstruction.on('pointerup', onSndClick);
                    this._btnSoundInstruction["defScale"] = this._btnSoundInstruction.scale;
                    setupButtonTextureBased(this._btnSoundInstruction, 'Sound', 'Sound HOVER EFFECT');
                    this.add(this._instructionPage);
                    this.add(this._instructionPageTitle);
                    this.add(this.instrTxt);
                    this.add(this._btnPlay);
                    this.add(this._btnSoundInstruction);
                }
            }
            screen.InstructionPage = InstructionPage;
        })(screen = sh.screen || (sh.screen = {}));
    })(sh || (sh = {}));
    (function (sh) {
        var screen;
        (function (screen) {
            class TryAgainWindow extends Phaser.GameObjects.Container {
                constructor(scene, onBack, onReplay) {
                    super(scene);
                    this.music = null;
                    this.setPosition(-106, -48);
                    this._bg = new Phaser.GameObjects.Image(this.scene, 0, 0, 'Try again page');
                    this._bg.setOrigin(0, 0);
                    this._bg.setInteractive();
                    this._star = new Phaser.GameObjects.Image(this.scene, 400, 415, 'Break Star');
                    this._btnBack = new Phaser.GameObjects.Image(this.scene, 600, 580, 'btnBACK1');
                    this._btnReplay = new Phaser.GameObjects.Image(this.scene, 765, 580, 'btnReplay1');
                    this.totalScoreTxt = this.scene.add.text(850, 355, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 35,
                        "color": "#F49F1C",
                        "align": 'center',
                        'stroke': '#70451A',
                        'strokeThickness': 6
                    });
                    this.totalScoreTxt.setOrigin(0.5, 0.5);
                    let grd = this.totalScoreTxt.context.createLinearGradient(0, 0, 0, this.totalScoreTxt.height);
                    grd.addColorStop(0, '#FFFF00');
                    grd.addColorStop(1, '#C17316');
                    this.totalScoreTxt.setFill(grd);
                    this.starScoreTxt = this.scene.add.text(635, 431, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 24,
                        "color": "#FFFFFF",
                        "align": 'center'
                    });
                    this.starScoreTxt.setOrigin(0.5, 0.5);
                    this.add([
                        this._bg,
                        this._star,
                        this._btnBack,
                        this._btnReplay,
                        this.totalScoreTxt,
                        this.starScoreTxt
                    ]);
                    this._btnBack.setInteractive({ cursor: 'pointer' });
                    this._btnBack.on('pointerup', () => {
                        onBack(this._btnBack);
                        angularComponentRef.backToMenu();
                        // if (this.music) {
                        //     this.music.stop();
                        // }
                    });
                    setupButtonTextureBased(this._btnBack, 'btnBACK1', 'btnBACK2');
                    this._btnReplay.setInteractive({ cursor: 'pointer' });
                    this._btnReplay.once('pointerup', () => {
                        onReplay(this._btnReplay);
                        if (this.music) {
                            this.music.stop();
                        }
                    });
                    setupButtonTextureBased(this._btnReplay, 'btnReplay1', 'btnReplay2');
                }
                show(score, starScore) {
                    this._star.scale = 1.25;
                    this.scene.tweens.add({
                        targets: this._star,
                        "scale": 1,
                        duration: 500,
                        ease: Phaser.Math.Easing.Back.Out
                    });
                    this.totalScoreTxt.text = String(window.angularComponentRef.component.userInfo.totalScore);
                    this.starScoreTxt.text = String(0);
                    this.music = this.scene.sound.add("Fail - close one");
                    this.music.play();
                }
            }
            screen.TryAgainWindow = TryAgainWindow;
        })(screen = sh.screen || (sh.screen = {}));
    })(sh || (sh = {}));
}

function destroySubmarineGame() {
    if (game) {
        game.destroy();
    }
}

var game;
var sh;
function factoryGame(json) {
    /**
     * @author Roman Parada
     * This class is created to fix overlapping of bottom part of canvas by navigation bar in iOS.
     * It make a delayed resize of the canvas (like Phaser-3 FIT methods does) and it overrides Phaser-3 input window to Phaser-3 core transform methods
     *
     * How to use:
     * Just call the code line below in Boot scene's init() method of your project:
     * new FitScaleManager(this.game).setup();
     */
    class FitScaleManager {
        constructor(game) {
            this.doResize = () => {
                let scale = this.calculateScale();
                let newCanvasWidth = this.phaserScaleManager.width * scale;
                let newCanvasHeight = this.phaserScaleManager.height * scale;
                this.canvasStyle.width = newCanvasWidth + 'px';
                this.canvasStyle.height = newCanvasHeight + 'px';
                this.canvasStyle.marginLeft = (window.innerWidth - newCanvasWidth) / 2 + 'px';
                this.canvasStyle.marginTop = (window.innerHeight - newCanvasHeight) / 2 + 'px';
            };
            this.game = game;
            this.canvasStyle = this.game.canvas.style;
            this.phaserScaleManager = this.game.scale;
        }
        static detectBestScaleMode() {
            let iOS = /iPad|iPhone|iPod/.test(navigator.platform || "");
            let isAndroid = window.navigator.userAgent.toLowerCase().indexOf("android") > -1;
            return iOS || isAndroid ? Phaser.Scale.FIT : Phaser.Scale.NONE;
        }
        ;
        /**
         * Just call this method once in Boot scene's init() method
         */
        setup() {
            this.phaserScaleManager.addListener(Phaser.Scale.Events.RESIZE, this.onResize, this);
            this.overridePhaserTransformMethods();
            this.onResize();
        }
        calculateScale() {
            if (game.scale.scaleMode === Phaser.Scale.NONE)
                return 1;
            return Math.min(window.innerWidth / this.phaserScaleManager.width, window.innerHeight / this.phaserScaleManager.height);
        }
        overridePhaserTransformMethods() {
            this.game.scale.transformX = (pageX) => {
                return (pageX - parseInt(this.canvasStyle.marginLeft.split("px")[0])) / this.calculateScale();
            };
            this.game.scale.transformY = (pageY) => {
                return (pageY - parseInt(this.canvasStyle.marginTop.split("px")[0])) / this.calculateScale();
            };
        }
        onResize() {
            setTimeout(this.doResize, FitScaleManager.RESIZE_DELAY);
        }
    }
    FitScaleManager.RESIZE_DELAY = 500;

    (function (sh) {
        class App extends Phaser.Game {
            constructor(json) {
                App.json = json;
                // console.log(App.json);

                let config = {
                    type: Phaser.AUTO,
                    width: App.CANVAS_WIDTH,
                    height: App.CANVAS_HEIGHT,
                    parent: 'game-container',
                    dom: {
                        createContainer: false
                    },
                    scale: {
                        mode: FitScaleManager.detectBestScaleMode(),
                        autoCenter: Phaser.Scale.CENTER_BOTH
                    },
                    transparent: true,
                    scene: {
                        create: () => {
                            this.scene.add('Boot', sh.scene.Boot, true);
                        }
                    }
                };
                super(config);
            }
        }
        App.CANVAS_WIDTH = 980;
        App.CANVAS_HEIGHT = 600;
        sh.App = App;
    })(sh || (sh = {}));

    game = new sh.App(json);

    var delayedCalls = [];
    function delayedCall(delay, callback, args, callbackScope) {
        let scene = game.scene.getAt(0);
        if (scene) {
            let dc = scene.time.delayedCall(delay, callback, args, callbackScope);
            delayedCalls.push(dc);
            return dc;
        }
        let t = setTimeout(callback, delay);
        delayedCalls.push(t);
        return t;
    }

    function pauseAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.paused = true;
            }
        }
    }

    function resumeAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.paused = false;
            }
        }
    }

    function destroyAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.remove(false);
            }
            else {
                clearTimeout(dc);
            }
        }
        delayedCalls = [];
    }

    function setPageBackground(bg) {
        // document.querySelector("html").style.backgroundImage = "url(assets/games/factory/imgs/" + bg + ".jpg)";
    }

    function setupButton(btn, frame) {
        btn.on('pointerdown', () => { btn.setFrame(frame + '_hover' + '0000'); });
        btn.on('pointerover', () => { btn.setFrame(frame + '_hover' + '0000'); game.scene.getAt(0).sound.add("button hover").play(); });
        btn.on('pointerout', () => { btn.setFrame(frame + '0000'); });
        btn.on('pointerup', () => { btn.setFrame(frame + '0000'); game.scene.getAt(0).sound.add('activity selection - button selection').play(); });
    }

    function setupButtonTextureBased(btn, texture, hoverTexture) {
        btn.on('pointerdown', () => { btn.setTexture(hoverTexture); });
        btn.on('pointerover', () => { btn.setTexture(hoverTexture); game.scene.getAt(0).sound.add("button hover").play(); });
        btn.on('pointerout', () => { btn.setTexture(texture); });
        btn.on('pointerup', () => { btn.setTexture(texture); game.scene.getAt(0).sound.add('activity selection - button selection').play(); });
    }

    (function (sh) {
        var core;
        (function (core) {
            class Gameplay {
                constructor() {
                    this.currentRound = 0;
                    this.currentLetter = 0;
                    this.correctAnswersCount = 0;
                    this.wrongAnswersCount = 0;
                    this.correctAnswersCountThisRound = 0;
                    this.wrongAnswersCountThisRound = 0;
                    this.reset();
                    let json = game.cache.json.get('gameplay');
                    this.wrongAnswersToLose = json["wrongAnswersToLose"];
                    this.numberOfQuestionsPerRound = json["numberOfQuestionsPerRound"];
                    this.lettersConfig = JSON.parse(JSON.stringify(json["lettersConfig"]));
                    this.rounds = JSON.parse(JSON.stringify(json["rounds"]));
                    this.numberOfRounds = json["numberOfRounds"] ?? this.rounds.length;
                    this.useImages = Boolean(game.cache.json.get('gameplay')["useImages"]);
                }
                setupCallbacks(onComplete, onLose) {
                    this.onComplete = onComplete;
                    this.onLose = onLose;
                }
                onLetterChosen(forceNewRound) {
                    if (forceNewRound || this.isNewRound()) {
                        return this.nextRound();
                    }
                    return false;
                }
                nextRound() {
                    this.correctAnswersCountThisRound = 0;
                    this.wrongAnswersCountThisRound = 0;
                    this.currentRound++;
                    if (this.isRoundsComplete()) {
                        this.onComplete(this.correctAnswersCount, this.correctAnswersCount);
                        return true;
                    }

                    return false;
                }
                getCorrectLetters() {
                    return this.rounds[this.currentRound]['letters'];
                }
                getCorrectLetterName() {
                    return this.rounds[this.currentRound]['correctLetterName'];
                }
                isCorrectLetterAudioQuestionEnable() {
                    return this.rounds[this.currentRound]['audioQuestionEnable'];
                }
                getCorrectAudioKey() {
                    return "correctAudioKey-" + this.rounds[this.currentRound]["correctAudioKey"];
                }
                getLetterSoundSfxAudioKey(letter) {
                    return "Q-" + this.lettersConfig[letter]['Sounds of the letters'];
                }
                getCorrectAndLetterSoundSfxAudioKey() {
                    return "Q-" + this.lettersConfig[this.getCorrectLetterName()]['Sounds of the letters'];
                }
                onCorrectAnswer() {
                    this.correctAnswersCountThisRound++;
                    this.correctAnswersCount++;
                    return this.onLetterChosen();
                }
                onWrongAnswer(forceNewRound) {
                    this.wrongAnswersCountThisRound++;
                    this.wrongAnswersCount++;
                    if (this.wrongAnswersCount >= this.wrongAnswersToLose) {
                        this.onLose(this.correctAnswersCount, this.correctAnswersCount);
                        return true;
                    }
                    /* else {
                        this.onLetterChosen(forceNewRound);
                    } */
                    return false;
                }

                getMaxTotalAnswersCount() {
                    return this.wrongAnswersToLose + this.numberOfRounds - 1;
                }

                getCurrentTotalAnswersCount() {
                    return this.correctAnswersCount + this.wrongAnswersCount;
                }
                isNewRound() {
                    return this.correctAnswersCountThisRound >= 1 || (this.correctAnswersCountThisRound + this.wrongAnswersCountThisRound) === 3 || (this.correctAnswersCountThisRound + this.wrongAnswersCountThisRound) === 0;
                }
                isRoundsComplete() {
                    return this.currentRound >= this.numberOfRounds && this.wrongAnswersCount < this.wrongAnswersToLose;
                }
                reset() {
                    this.currentRound = 0;
                    this.correctAnswersCount = 0;
                    this.wrongAnswersCount = 0;
                }
                getCurrentRoundLetters() {
                    return this.rounds[this.currentRound]["letters"];
                }
            }
            core.Gameplay = Gameplay;
        })(core = sh.core || (sh.core = {}));
    })(sh || (sh = {}));

    (function (sh) {
        var scene;
        (function (scene) {
            class Boot extends Phaser.Scene {
                init() {
                    this.game.scale.transformX = (pageX) => {
                        let offsetLeft = 0;
                        let parentElement = game.canvas.parentElement;
                        while (parentElement) {
                            if (parentElement.offsetLeft) {
                                offsetLeft = parentElement.offsetLeft;
                                break;
                            }
                            parentElement = parentElement.parentElement;
                        }
                        return (pageX - offsetLeft) * this.game.scale.displayScale.x;
                    };
                    this.game.scale.transformY = (pageY) => {
                        let offsetTop = 0;
                        let parentElement = game.canvas.parentElement;
                        while (parentElement) {
                            if (parentElement.offsetTop) {
                                offsetTop = parentElement.offsetTop;
                                break;
                            }
                            parentElement = parentElement.parentElement;
                        }
                        return (pageY - offsetTop) * this.game.scale.displayScale.y;
                    };
                }
                create() {
                    game.scene.remove('Boot');
                    game.scene.add('Preloader', sh.scene.Preloader, true);
                }
            }
            scene.Boot = Boot;
        })(scene = sh.scene || (sh.scene = {}));
    })(sh || (sh = {}));

    (function (sh) {
        var scene;
        (function (scene) {
            var Gameplay = sh.core.Gameplay;
            class MainScene extends Phaser.Scene {
                create() {
                    this.gameplay = new Gameplay();
                    this.gameplayScreen = new sh.screen.GameplayScreen(this, this.gameplay);
                    this.children.add(this.gameplayScreen);
                    this.gameplayScreen.showInstructionPage();
                }
            }
            scene.MainScene = MainScene;
        })(scene = sh.scene || (sh.scene = {}));
    })(sh || (sh = {}));

    (function (sh) {
        var scene;
        (function (scene) {
            class Preloader extends Phaser.Scene {
                preload() {
                    if (typeof sh.App.json == "string") this.load.json('gameplay', sh.App.json); else this.game.cache.json.add('gameplay', sh.App.json);
                }
                create() {
                    let json = game.cache.json.get('gameplay');
                    let lettersConfig = json["lettersConfig"];

                    // this.load.audio("englQuestion", "assets/games/factory/sound/mp3/letters/englQuestion.mp3");
                    for (let round of json["rounds"]) {
                        let correctAudioKey = round["correctAudioKey"];
                        this.load.audio("correctAudioKey-" + correctAudioKey, "assets/games/factory/sound/mp3/correctAudios/" + correctAudioKey.replace(".wav", ".mp3"));
                    }

                    for (let letterName in lettersConfig) {
                        if (json["useImages"]) this.load.image(letterName, "assets/games/factory/imgs/letters/" + letterName + ".png");
                        if (lettersConfig[letterName]) {
                            this.load.audio("Q-" + lettersConfig[letterName]["Sounds of the letters"], "assets/games/factory/sound/mp3/letters/Sounds of the letters/" + lettersConfig[letterName]["Sounds of the letters"]);
                        }
                    }
                    let progressTxt = this.add.text(game.scale.width / 2, game.scale.height / 2 + 50, "", {
                        "fontFamily": "QuranErafont",
                        "fontSize": 25,
                        "color": "#333333",
                        "align": 'center'
                    });
                    progressTxt.setOrigin(0.5, 0.5);
                    this.load.pack('preloader', 'assets/games/factory/pack.json');
                    this.load.on('progress', (value) => {
                        progressTxt.text = Math.ceil(value * 100) + "%";
                    }, this);
                    this.load.on('complete', () => {
                        this.nextScene();
                    });
                    this.load.start();
                }
                static playAnim(animKey, sprite, onComplete = null) {
                    let mainScene = game.scene.getScene('ScreenMain');
                    let data = Preloader.ANIMS_DATA[animKey];
                    if (!mainScene.anims.exists(animKey)) {
                        mainScene.anims.create({
                            key: animKey,
                            frames: mainScene.anims.generateFrameNames(data['atlas'], {
                                start: data['start'], end: data['end'], zeroPad: data['padNum'],
                                prefix: data['prefix'], suffix: ''
                            }),
                            frameRate: data['frameRate'],
                            repeat: data['repeat']
                        });
                    }
                    if (sprite.anims.currentAnim) {
                        sprite.anims.currentAnim.off('complete');
                    }
                    sprite.anims.stop();
                    // sprite.setTexture(data['atlas']);
                    sprite.play(animKey);
                    sprite.anims.currentAnim.once('complete', () => {
                        if (onComplete)
                            onComplete();
                    });
                    return sprite;
                }
                nextScene() {
                    game.scene.remove('Preloader');
                    game.scene.add('ScreenMain', sh.scene.MainScene, true);
                }
            }
            Preloader.ANIMS_DATA = {
                'conveyor-working': {
                    'start': 0,
                    'end': 9,
                    'padNum': 2,
                    'prefix': 'Factory_10',
                    'repeat': 0,
                    'frameRate': 24 * 1.2,
                    'atlas': 'conveyor-atlas'
                },
                'conveyor-idle': {
                    'start': 0,
                    'end': 0,
                    'padNum': 2,
                    'prefix': 'Factory_10',
                    'repeat': 0,
                    'frameRate': 24,
                    'atlas': 'conveyor-atlas'
                }
            };
            scene.Preloader = Preloader;
        })(scene = sh.scene || (sh.scene = {}));
    })(sh || (sh = {}));
    (function (sh) {
        var screen;
        (function (screen) {
            class AreYouSureWindow extends Phaser.GameObjects.Container {
                constructor(scene, onYes, onNo) {
                    super(scene);
                    this._areYouSurePage = new Phaser.GameObjects.Image(this.scene, -105, 0 - 48, 'Exit warning');
                    this._areYouSurePage.setOrigin(0, 0);
                    this._areYouSurePage.setInteractive();
                    this._btnSureYes = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2 - 95, 485 - 50, 'btnYES1');
                    this._btnSureYes.setInteractive({ cursor: 'pointer' });
                    this._btnSureYes.on('pointerup', () => {
                        onYes;
                        angularComponentRef.backToMenu();
                    });
                    var modalTextStyle = {
                        backgroundColor: 'transparent',
                        stroke: '#ffffff',
                        strokeThickness: 2,
                        lineSpacing: 15,
                        fontFamily: 'Kids Rock DEMO',
                        fontSize: 27,
                        color: '#43425d',
                        wordWrap: true,
                        align: 'center'
                    };
                    var modalText = this.scene.add.text(game.scale.width / 2 + 12, game.scale.height / 2, "Your progress in this activity will not be saved. \n Are you sure you want to exit? ", modalTextStyle);
                    modalText.setOrigin(0.5, 0.5);

                    setupButtonTextureBased(this._btnSureYes, 'btnYES1', 'btnYES2');
                    this._btnSureNo = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2 + 95, 485 - 50, 'btnNO1');
                    this._btnSureNo.setInteractive({ cursor: 'pointer' });
                    this._btnSureNo.on('pointerup', onNo);
                    setupButtonTextureBased(this._btnSureNo, 'btnNO1', 'btnNO2');
                    this.add(this._areYouSurePage);
                    this.add(this._btnSureYes);
                    this.add(this._btnSureNo);
                    this.add(modalText);
                }
            }
            screen.AreYouSureWindow = AreYouSureWindow;
        })(screen = sh.screen || (sh.screen = {}));
    })(sh || (sh = {}));

    (function (sh) {
        var screen;
        (function (screen) {
            class CompleteWindow extends Phaser.GameObjects.Container {
                constructor(scene, onBack, onReplay, onNext) {
                    super(scene);
                    this.music = null;
                    this.setPosition(-104.5, -48);
                    this._bgComplete = new Phaser.GameObjects.Image(this.scene, 0, 0, 'Completion page LATEST UPDATED');
                    this._bgComplete.setOrigin(0, 0);
                    this._bgComplete.setInteractive();
                    this._cup = new Phaser.GameObjects.Image(this.scene, 400, 410, 'Trophy');
                    this._btnBack = new Phaser.GameObjects.Image(this.scene, 570, 570, 'btnBACK1');
                    this._btnReplay = new Phaser.GameObjects.Image(this.scene, 720, 570, 'btnReplay1');
                    this._btnNext = new Phaser.GameObjects.Image(this.scene, 870, 570, 'btnNEXT1');
                    let _CollectedPoints = new Phaser.GameObjects.Image(this.scene, 620, 440, 'Collected Points');
                    this.totalScoreTxt = this.scene.add.text(845, 352, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 35,
                        "color": "#F49F1C",
                        "align": 'center',
                        'stroke': '#70451A',
                        'strokeThickness': 6
                    });
                    this.totalScoreTxt.setOrigin(0.5, 0.5);
                    let grd = this.totalScoreTxt.context.createLinearGradient(0, 0, 0, this.totalScoreTxt.height);
                    grd.addColorStop(0, '#FFFF00');
                    grd.addColorStop(1, '#C17316');
                    this.totalScoreTxt.setFill(grd);
                    this.starScoreTxt = this.scene.add.text(648, 433, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 24,
                        "color": "#FFFFFF",
                        "align": 'center'
                    });
                    this.starScoreTxt.setOrigin(0.5, 0.5);
                    this.add([
                        this._bgComplete,
                        _CollectedPoints,
                        this._cup,
                        this._btnBack,
                        this._btnReplay,
                        this._btnNext,
                        this.totalScoreTxt,
                        this.starScoreTxt
                    ]);
                    this._btnBack.setInteractive({ cursor: 'pointer' });
                    this._btnBack.on('pointerup', () => {
                        onBack(this._btnBack);
                        angularComponentRef.backToMenu();
                        // if (this.music) {
                        //     this.music.stop();
                        // }
                    });
                    setupButtonTextureBased(this._btnBack, 'btnBACK1', 'btnBACK2');
                    this._btnReplay.setInteractive({ cursor: 'pointer' });
                    this._btnReplay.once('pointerup', () => {
                        onReplay(this._btnReplay);
                        if (this.music) {
                            this.music.stop();
                        }
                    });
                    setupButtonTextureBased(this._btnReplay, 'btnReplay1', 'btnReplay2');
                    this._btnNext.setInteractive({ cursor: 'pointer' });
                    this._btnNext.on('pointerup', () => {
                        onNext(this._btnNext);
                        window.angularComponentRef.nextActivity()
                    });
                    setupButtonTextureBased(this._btnNext, 'btnNEXT1', 'btnNEXT2');
                }
                show(score, starScore) {
                    window.angularComponentRef.gameFinish({ score, starScore })
                    this._cup.scale = 1.25;
                    this.scene.tweens.add({
                        targets: this._cup,
                        "scale": 1,
                        duration: 500,
                        ease: Phaser.Math.Easing.Back.Out
                    });
                    this.totalScoreTxt.text = String(window.angularComponentRef.component.userInfo.totalScore);
                    this.starScoreTxt.text = String(starScore);
                    // let music = this.scene.sound.add("viktory");
                    this.music = this.scene.sound.add("Activity completion fantastic");
                    this.music.play();
                }
            }
            screen.CompleteWindow = CompleteWindow;
        })(screen = sh.screen || (sh.screen = {}));
    })(sh || (sh = {}));

    (function (sh) {
        var screen;
        (function (screen) {
            class GameplayScreen extends Phaser.GameObjects.Container {
                constructor(scene, gameplay) {
                    super(scene);
                    this.carsPositions = [{ x: 410, y: 79 }, { x: 665, y: -44 }, { x: 932, y: 79 }];
                    this.bgMusic = null;
                    this.correctAudio = null;
                    this.wfsnd = null;
                    this.showCompleteWindow = (score, starScore) => {
                        let completeWindow = new screen.CompleteWindow(this.scene, (target) => {
                            this.playBtnClickAnim(target);
                        }, (target) => {
                            this.playBtnClickAnim(target);
                            this.destroyGameplay();
                            this.remove(completeWindow);
                            this.showInstructionPage();
                        }, (target) => {
                            this.playBtnClickAnim(target);
                        });
                        this.setLettersInputEnabled(false);
                        delayedCall(4500, () => {
                            setPageBackground("bg-blue");
                            this.add(completeWindow);
                            completeWindow.show(score, starScore);
                            if (this.bgMusic) this.bgMusic.stop();
                        });
                    };
                    this.showLoseWindow = (score, starScore) => {
                        let tryAgainWindow = new screen.TryAgainWindow(this.scene, (target) => {
                            this.playBtnClickAnim(target);
                        }, (target) => {
                            this.playBtnClickAnim(target);
                            this.destroyGameplay();
                            this.remove(tryAgainWindow);
                            this.showInstructionPage();
                        });
                        this.setLettersInputEnabled(false);
                        delayedCall(2500, () => {
                            setPageBackground("bg-blue");
                            this.add(tryAgainWindow);
                            tryAgainWindow.show(score, starScore);
                            if (this.bgMusic) this.bgMusic.stop();
                        });
                    };
                    this.gameplay = gameplay;
                    window["t"] = this;
                }
                createHexagons() {
                    if (this.contentContainer && this.contentContainer.parentContainer) {
                        this.contentContainer.parentContainer.remove(this.contentContainer);
                    }
                    this.contentContainer = new Phaser.GameObjects.Container(this.scene, 0, 0);
                    this.gameplayContainer.addAt(this.contentContainer, 1);
                    window['this.contentContainer'] = this.contentContainer;

                    this.speakers = [];
                    window['this.speakers'] = this.speakers;
                    let _i = 0;
                    for (let p of this.carsPositions) {
                        let hc = new Phaser.GameObjects.Container(this.scene, this.carsPositions[_i]['x'], this.carsPositions[_i]['y']);
                        let h = new Phaser.GameObjects.Image(this.scene, -134, 155, 'speaker');
                        h.setOrigin(0.5, 1);
                        hc.add(h);
                        hc["bg"] = h;
                        let h1 = new Phaser.GameObjects.Image(this.scene, -286, 155, 'speaker');
                        h1.setOrigin(0.5, 1);
                        hc.add(h1);
                        hc["bg1"] = h1;

                        let bigCorrectRect = this.scene.add.sprite(-210, 152, 'bigCorrectRect');
                        bigCorrectRect.setOrigin(0.5, 1);
                        bigCorrectRect.setScale(1, 1.03);
                        hc.add(bigCorrectRect);
                        bigCorrectRect.alpha = 0;
                        hc["bigCorrectRect"] = bigCorrectRect;

                        hc["defX"] = p['x'];
                        hc["defY"] = p['y'];
                        this.speakers.push(hc);
                        this.contentContainer.add(hc);
                        hc['index'] = _i;

                        let playBtn = new Phaser.GameObjects.Image(this.scene, -16, 104, 'btnPlaySnd');
                        hc.add(playBtn);
                        hc["playBtn"] = playBtn;
                        setupButtonTextureBased(playBtn, 'btnPlaySnd', 'btnPlaySndHover');
                        let _ind = _i;
                        playBtn.visible = false;
                        playBtn.on('pointerup', () => {
                            for (let _hc of this.speakers) {
                                if (_hc["playBtn"]["sound"]) _hc["playBtn"]["sound"].stop();
                            }

                            if (!playBtn["sound"]) {
                                playBtn["sound"] = this.scene.sound.add(this.gameplay.getLetterSoundSfxAudioKey(this.targetBlocks[_ind * 2]["-letter-text"]/* hc["letter"] */));
                            }
                            playBtn["sound"].play();

                            if (_ind == 0 && !this.wasTutorialCompleted) {
                                this.gameplayContainer.parentContainer.add(this.handIcon);
                                this.handIcon.setPosition(585, 425);
                                this.scene.tweens.add({
                                    targets: this.handIcon,
                                    duration: 750,
                                    delay: 500,
                                    x: 140,
                                    y: 195
                                });
                                this.setLettersInputEnabled(true);
                            }

                            // if (!hc["handIcon"] || !hc["handIcon"].visible) return;

                            // hc['handIcon'].visible = false;
                        });

                        if (!this.wasTutorialCompleted) {
                            if (_i == 0) {
                                this.handIcon = new Phaser.GameObjects.Image(this.scene, 30, 130, 'Hand Icon');
                                hc.add(this.handIcon);
                                hc["handIcon"] = this.handIcon;
                                this.scene.tweens.add({
                                    targets: this.handIcon,
                                    angle: -5,
                                    scaleY: 0.95,
                                    scaleX: 0.95,
                                    duration: 500,
                                    yoyo: true,
                                    repeat: -1,
                                });

                                this.handIcon.alpha = 0;
                                delayedCall(2000, () => {
                                    this.scene.tweens.add({
                                        targets: this.handIcon,
                                        alpha: 1,
                                        duration: 500,
                                        delay: 1750
                                    });
                                    // playBtn.setInteractive({ cursor: 'pointer' });
                                });
                            }
                        }
                        playBtn.setInteractive({ cursor: 'pointer' });
                        _i++;
                    }
                    window['this.cars'] = this.speakers;

                    this.conveyor = this.scene.add.sprite(500, 600, "conveyor-atlas");
                    this.contentContainer.add(this.conveyor);
                    window['this.kangaroo'] = this.conveyor;
                    this.conveyor["defY"] = this.conveyor.y;
                    this.conveyor.setOrigin(0.5, 1);
                    window['this.conveyor'] = this.conveyor;

                    sh.scene.Preloader.playAnim('conveyor-idle', this.conveyor);

                    this.boxDefPos = { x: 470 + 100, y: 410 };
                    this.boxes = [];
                    for (let _i = 0; _i < 6; _i++) {
                        let hc = this.scene.add.container(this.boxDefPos.x, this.boxDefPos.y);
                        let h = this.scene.add.sprite(0, 0, 'box');
                        hc["-image-"] = h;
                        hc['-draggable-'] = true;
                        hc.add(h);
                        hc["bg"] = h;
                        window['hc_' + _i] = hc;
                        window['h_' + _i] = h;
                        hc.add(h);
                        hc.visible = false;

                        hc['startPosition'] = { x: hc.x, y: hc.y };

                        hc["defX"] = this.boxDefPos['x'];
                        hc["defY"] = this.boxDefPos['y'];
                        this.boxes.push(hc);
                        this.contentContainer.add(hc);
                        hc['index'] = _i;
                    }
                    window['this.boxes'] = this.boxes;

                    this.showUpNextBox();
                }
                showUpNextBox() {
                    this.setLettersInputEnabled(false);

                    this.playConveyorWorking();

                    this.currentBox = this.boxes[0/* this.gameplay.correctAnswersCountThisRound */];
                    this.currentBox.visible = true;
                    window['this.currentBox'] = this.currentBox;
                    this.currentBox.x = 865 + 150;
                    this.scene.tweens.add({
                        targets: this.currentBox,
                        x: this.boxDefPos.x,
                        duration: 4150 / 1.2,
                        onComplete: () => {
                            this.contentContainer.remove(shape);
                            this.currentBox.setMask(null);

                            if (this.wasTutorialCompleted) this.setLettersInputEnabled(true);

                            if (this.boxes.length === 6) delayedCall(250, () => {
                                let k = 0;
                                for (let hc of this.speakers) {
                                    hc["playBtn"].visible = true;
                                    hc["playBtn"].alpha = 0;
                                    this.scene.tweens.add({
                                        targets: hc["playBtn"],
                                        alpha: 1,
                                        duration: 250,
                                        delay: k++ * 250
                                    });
                                }
                            });
                        }
                    });

                    const shape = this.scene.make.graphics();
                    shape.setPosition(340, 310);
                    shape.fillStyle(0xffff0);
                    shape.alpha = 0
                    shape.beginPath();
                    shape.fillRect(0, 0, 450, 150);
                    this.contentContainer.add(shape);
                    window['shape'] = shape;
                    const mask = shape.createGeometryMask();
                    this.currentBox.setMask(mask);
                }
                playConveyorWorking() {
                    var snd = this.scene.sound.add("Conveyor Belt Sound Effect");
                    snd.play();
                    snd.setRate(1.2);
                    let i = 0;
                    let play = () => {
                        if (i++ >= 10) return;
                        sh.scene.Preloader.playAnim('conveyor-working', this.conveyor, play);
                    };
                    play();
                }
                createLetters() {
                    this.letters = [];
                    let _letters = this.gameplay.getCurrentRoundLetters();
                    for (let n of _letters) {
                        let wordText;
                        if (this.gameplay.useImages) {
                            wordText = new Phaser.GameObjects.Image(this.scene, 0, 0, n);
                        } else {
                            wordText = this.scene.add.text(0, 0, n, {
                                "fontFamily": "QuranErafont",
                                "fontSize": 40,
                                "color": "#333333",
                                "align": 'center'
                            });
                            this.add(wordText);
                            wordText.setOrigin(0.5, 0.5);
                            wordText.setPadding({ left: 0, right: 0, top: 65, bottom: 65 });

                            if (wordText.width > 135) wordText.setScale(140 / wordText.width);
                        }
                        wordText["key"] = n;
                        this.letters.push(wordText);
                        window['wordText'] = wordText;
                    }
                }
                showGameplay() {
                    this.isLost = false;
                    setPageBackground("bg-australia");
                    this.bgMusic = this.scene.sound.add("bg_sound");
                    this.bgMusic.play();
                    this.bgMusic.loop = true;
                    this.gameplay.reset();
                    this.bgContainer = new Phaser.GameObjects.Container(this.scene);
                    this._gameStage = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2, game.scale.height / 2, 'bg'); window['this._gameStage'] = this._gameStage;
                    this._gameStage.setOrigin(0.5, 0.5);
                    this._gameStage.setInteractive();
                    this.bgContainer.add(this._gameStage);
                    window['this.bgContainer'] = this.bgContainer;
                    this._btnSound = new Phaser.GameObjects.Image(this.scene, 160 - 105, 100 - 50, 'Sound');
                    this._btnSound.visible = false;
                    this._btnSound.setInteractive({ cursor: 'pointer' });
                    this._btnSound["defScale"] = this._btnSound.scale;
                    setupButtonTextureBased(this._btnSound, 'Sound', 'Sound HOVER EFFECT');
                    this._btnClose = new Phaser.GameObjects.Image(this.scene, 1025 - 105, 100 - 50, 'x Button');
                    this._btnClose.setInteractive({ cursor: 'pointer' });
                    this._btnClose["defScale"] = this._btnClose.scale;
                    setupButtonTextureBased(this._btnClose, 'x Button', 'x Button HOVER EFFECT');
                    this.gameplayContainer = new Phaser.GameObjects.Container(this.scene);
                    this.addAt(this.gameplayContainer, 0);
                    this.gameplayContainer.add([
                        this.bgContainer,
                        this._btnSound,
                        this._btnClose
                    ]);
                    window['this._gameStage'] = this._gameStage;
                    window['this.gameplayContainer'] = this.gameplayContainer;
                    this.createBeehives();
                    this.shuffleOutHexagons();
                    this.gameplay.setupCallbacks(this.showCompleteWindow, this.showLoseWindow);
                }
                createBeehives() {
                    let startX = 55;
                    let startY = 324;
                    let dy = 52;
                    let _BeehiveEmptyArrayPositions = [];
                    for (let i = 0; i < this.gameplay.wrongAnswersToLose; i++) {
                        _BeehiveEmptyArrayPositions.push({ x: startX, y: startY + i * dy });
                    }
                    this._BeehiveEmptyArray = []; window["_BeehiveEmptyArray"] = this._BeehiveEmptyArray;
                    for (let p of _BeehiveEmptyArrayPositions) {
                        let _BeehiveEmpty = new Phaser.GameObjects.Image(this.scene, p['x'], p['y'], 'Beehive 1 Empty');
                        this._BeehiveEmptyArray.push(_BeehiveEmpty);
                        _BeehiveEmpty.visible = false;
                    }
                    for (let bea of this._BeehiveEmptyArray) {
                        this.gameplayContainer.add(bea);
                    }
                }
                randomizeLettersPosition() {
                    let hx = this.boxes.slice();
                    let k = 0;
                    for (let l of this.letters) {
                        if (hx.length == 0)
                            return;
                        let hc;
                        if (!this.wasTutorialCompleted && k < 2) {
                            hc = hx.shift();
                        } else {
                            hc = Phaser.Utils.Array.RemoveRandomElement(hx);
                        }
                        hc.add(l);
                        hc["letter"] = l;
                        hc["-letter-text"] = l.key ?? l.text;
                        l["hexagon"] = hc;
                        k++;
                    }
                }
                updateHexagonsArrange() {
                    for (let hc of this.boxes) {
                        if (!hc["letter"]) {
                            hc.parentContainer.bringToTop(hc);
                            break;
                        }
                    }
                }
                shuffleOutHexagons() {
                    this.createHexagons();

                    let setLettersInputEnabled = () => {
                        // if (this.correctAudio && this.correctAudio.isPlaying) {
                        delayedCall(/* (this.correctAudio.duration * 0.75) * */ 1000, () => {
                            // this.setLettersInputEnabled(true);
                        });
                        // }
                        // else {
                        // this.setLettersInputEnabled(true);
                        // }
                    };

                    if (!this.gameplay.isRoundsComplete()) {
                        if (this.gameplay.isCorrectLetterAudioQuestionEnable() && this.gameplay.getCurrentTotalAnswersCount() == 0) {
                            // this.playCorrectAudio();
                        }
                        setLettersInputEnabled();
                    }

                    if (this.sfxCarAccelerating) {
                        this.sfxCarAccelerating.stop();
                        this.sfxCarAccelerating = null;
                    }
                    if (this.sfxWrong) {
                        this.sfxWrong.stop();
                        this.sfxWrong = null;
                    }

                    if (!this.gameplay.isRoundsComplete()) {
                        this.createLetters();
                        this.randomizeLettersPosition();
                    }

                    this.setLettersInputEnabled(false);
                    this.updateHexagonsArrange();
                    // Phaser.Utils.Array.Shuffle(this.carsPositions);
                    for (let c of this.speakers) this.gameplayContainer.remove(c);
                    // this.speakers.sort((c1, c2) => c1.y - c2.y);
                    // for (let c of cars) this.gameplayContainer.add(c);

                    this.createInput();
                }
                shuffleInHexagons() {
                    this.updateHexagonsArrange();
                    this.setLettersInputEnabled(false);

                    // delayedCall(600, () => {
                    // this.scene.sound.add('move to centre').play();
                    this.shuffleOutHexagons();
                    // });
                    window['t'] = this;
                }
                onCorrectDragsMade() {
                    let completed = this.onCorrectAnswer();

                    this.setLettersInputEnabled(false);

                    // this.scene.sound.add('Snail giggling sound - correct selection').play();

                    delayedCall(350 + 1500, () => {
                        if (!completed) {
                            // this.scene.sound.add('First round finishes').play();
                        } else {
                            this.scene.sound.add('Final celebration sound').play();
                        }
                    });

                    if (!completed) delayedCall(2700, () => this.scene.sound.add('First round finishes').play());
                    // if (completed) delayedCall(1750, () => this.scene.sound.add('Final celebration sound').play())

                    delayedCall(completed ? 750 + 1000 : 1100 + 2000/* +1000 */, () => {
                        if (!completed) {
                            this.shuffleInHexagons();
                        }
                    });
                }
                createInput() {
                    this.scene.input.on('drag', (pointer, block, dragX, dragY) => {
                        if (!block['-draggable-'])
                            return;
                        block.x = dragX;
                        block.y = dragY;
                        block.parentContainer.bringToTop(block);
                    });
                    console.log("CORRECT WORDS: ", this.gameplay.getCorrectLetters());
                    this.targetBlocks = [];
                    let bb = [{ x: 118 + 5.5, y: 183 }, { x: 279 - 3, y: 183 }, { x: 375 + 4, y: 60 }, { x: 534 - 3, y: 60 }, { x: 641 + 5.5, y: 183 }, { x: 802 - 4, y: 183 }];
                    for (let i = 0; i < bb.length; i++) {
                        let b = bb[i];
                        b['alreadyFilled'] = false;
                        this.targetBlocks.push(b);
                        b["-letter-text"] = this.gameplay.getCorrectLetters()[i];
                        b["-block-"] = null;
                        b["-index-"] = i;

                        // this.speakers[i]["letter"] = b["-letter-text"];
                    }
                    window['this.targetBlocks'] = this.targetBlocks;

                    for (let a of this.boxes) {
                        // let correctAnswer = hc["letter"] && hc["letter"]["key"] == this.gameplay.getCorrectLetters(1);
                        //hc["letter"].alpha = correctAnswer ? 1 : 0.5;

                        a.setSize(a["-image-"].width, a["-image-"].height);
                        // a.setInteractive({ cursor: 'pointer' });
                        // this.scene.input.setDraggable(a, true);
                        a.on('pointerdown', () => {
                            if (a["-placedAtBlock-"]) {
                                a["-placedAtBlock-"]['alreadyFilled'] = false;
                                a["-placedAtBlock-"] = null;
                            }

                            a['-pointerdown-'] = true;
                            if (a['-draggable-']) this.scene.sound.add("Move the box from its spot").play();
                        });
                        a.on('pointerup', () => {
                            a['-pointerdown-'] = false;
                            if (!a['-draggable-'])
                                return;

                            let wasTargetBlockFound = false;
                            let targetBlock;
                            for (targetBlock of this.targetBlocks) {
                                if (targetBlock['alreadyFilled'])
                                    continue;
                                if (Phaser.Math.Distance.Between(a.x, a.y, targetBlock.x, targetBlock.y) < 50) {
                                    //as
                                    // a['-draggable-'] = false;
                                    targetBlock['alreadyFilled'] = true;
                                    this.scene.tweens.add({
                                        targets: a,
                                        x: targetBlock.x,
                                        y: targetBlock.y,
                                        duration: 300,
                                        ease: Phaser.Math.Easing.Back.Out
                                    });
                                    targetBlock["-block-"] = a;
                                    a["-placedAtBlock-"] = targetBlock;
                                    this.scene.sound.add("Drop").play();

                                    wasTargetBlockFound = true;
                                    this.checkTargetBlockLetters(targetBlock);
                                    break;
                                }
                            }

                            if (!wasTargetBlockFound) {
                                this.moveBridgeBackToStartPosition(a, null, true);
                            }
                        });
                        a.on('pointerout', () => {
                            if (!a['-draggable-'])
                                return;
                            if (!a['-pointerdown-'])
                                return;
                            this.moveBridgeBackToStartPosition(a, null, true);
                        });
                    }

                    this._btnSound.on('pointerup', () => {
                        this.playBtnClickAnim(this._btnSound);
                        this.onSoundClick();
                    });
                    this._btnClose.on('pointerup', () => {
                        this.playBtnClickAnim(this._btnClose);
                        this.onCloseClick();
                    });
                }
                hideAllUnusedBeehives() {
                    let i = this.gameplay.getCurrentTotalAnswersCount();
                    for (let k = i + 1; k < this._BeehiveEmptyArray.length; k++) {
                        this._BeehiveEmptyArray[k].visible = false;
                    }
                }

                checkTargetBlockLetters(targetBlock) {
                    if (targetBlock["-letter-text"] != targetBlock['-block-']["-letter-text"]) {
                        delayedCall(350, () => {
                            this.moveBridgeBackToStartPosition(targetBlock['-block-'], null, false);
                            targetBlock['alreadyFilled'] = false;
                            targetBlock['-block-']['-draggable-'] = true;
                            targetBlock['-block-']["-placedAtBlock-"] = null;
                            targetBlock["-block-"] = null;
                            // delayedCall(100, ()=>this.scene.sound.add("all three blocks move back after wrong").play());
                        });
                        // delayedCall(1500, () => this.scene.sound.add("Two blocks move back after a wrong placement").play());
                        delayedCall(400, () => {
                            let lost = this.onWrongAnswer();

                            // delayedCall(500, () => {
                            if (!lost) this.setLettersInputEnabled(true);
                            // });
                        });

                        return;
                    }

                    let __ind = targetBlock['-block-']['-placedAtBlock-']['-index-'];
                    let _pairInd = __ind % 2 === 0 ? __ind + 1 : __ind - 1;

                    let aPairIsMade = this.targetBlocks[_pairInd].alreadyFilled;
                    if (aPairIsMade) {
                        let _blockA = this.targetBlocks[Math.min(_pairInd, __ind)]['-block-'];
                        let _blockB = this.targetBlocks[Math.max(_pairInd, __ind)]['-block-'];
                        this.scene.tweens.add({
                            targets: [_blockA['-image-'], _blockB['-image-']],
                            duration: 350,
                            delay: 0,
                            alpha: 0
                        });

                        delayedCall(400, () => {
                            this.scene.sound.add(this.gameplay.getLetterSoundSfxAudioKey(this.targetBlocks[Math.min(_pairInd, __ind)]["-letter-text"])).play();
                        });

                        let mid = (_blockB['letter'].width + _blockA['letter'].width) / 2;
                        let dx = mid - _blockB['letter'].width;

                        this.scene.tweens.add({
                            targets: _blockA['letter'],
                            "x": 79 + dx,
                            "originX": 1,
                            delay: 0,
                            duration: 300,
                            onUpdate: () => {
                                _blockA['letter'].setOrigin(_blockA['letter'].originX, _blockA['letter'].originY);
                            }
                        });

                        this.scene.tweens.add({
                            targets: _blockB['letter'],
                            "x": -79 + dx,
                            "originX": 0,
                            delay: 0,
                            duration: 300,
                            onUpdate: () => {
                                _blockB['letter'].setOrigin(_blockB['letter'].originX, _blockB['letter'].originY);
                            }
                        });

                        this.scene.tweens.add({
                            targets: this.speakers[Math.floor(Math.min(__ind, _pairInd) / 2)]["bigCorrectRect"],
                            duration: 350,
                            delay: 0,
                            alpha: 1
                        });
                    }

                    if (this.handIcon) {
                        if (targetBlock['-block-']['index'] == 0 && !this.wasTutorialCompleted) {
                            this.handIcon.visible = false;
                            delayedCall(4500, () => {
                                this.handIcon.visible = true;
                                this.handIcon.setPosition(585, 425);
                                this.scene.tweens.add({
                                    targets: this.handIcon,
                                    duration: 750,
                                    delay: 500,
                                    x: 290,
                                    y: 195
                                });
                                this.setLettersInputEnabled(true);
                            });
                        } else {
                            this.handIcon.parentContainer.remove(this.handIcon);
                            this.handIcon = null;
                            this.wasTutorialCompleted = true;
                        }
                    }

                    try { this.scene.input.setDraggable(this.currentBox, false); } catch (e) { }
                    this.currentBox.disableInteractive();

                    this.boxes.shift();

                    this.scene.sound.add('Correct sfx').play();

                    this.setLettersInputEnabled(false);
                    if (this.boxes.length === 0) {
                        for (let _hc of this.boxes) {
                            if (_hc['-placedAtBlock-']) continue;
                            /* this.scene.tweens.add({
                                targets: _hc,
                                "alpha": 0,
                                ease: Phaser.Math.Easing.Cubic.In,
                                duration: 900,
                                delay: 0
                            }); */
                        }
                        // this.scene.sound.add("Blocks disappearing").play();
                        delayedCall(1000, () => {
                            this.onCorrectDragsMade();
                        });
                    } else {
                        delayedCall(aPairIsMade ? 1750 : 750, () => {
                            this.showUpNextBox();
                        });
                    }
                }
                moveBridgeBackToStartPosition(block, onComplete, playSound) {
                    this.scene.tweens.add({
                        targets: block,
                        x: block['startPosition'].x,
                        y: block['startPosition'].y,
                        duration: 350,
                        ease: Phaser.Math.Easing.Cubic.Out,
                        onComplete: () => {
                            if (onComplete)
                                onComplete();
                        }
                    });
                    if (Phaser.Math.Distance.Between(block['startPosition'].x, block['startPosition'].y, block.x, block.y) > 20) {
                        delayedCall(100, () => {
                            if (playSound) {
                                this.scene.sound.add("Box goes back").play();
                            }
                        });
                    }
                }
                onCorrectAnswer() {
                    /* let correctAudioKey = this.gameplay.getCorrectAudioKey();
                    delayedCall(1000, () => {
                        this.scene.sound.add(correctAudioKey).play();
                    }); */

                    let i = this.gameplay.getCurrentTotalAnswersCount();
                    if (i < this._BeehiveEmptyArray.length) {
                        // this._BeehiveEmptyArray[i].visible = false;
                    }
                    this.hideAllUnusedBeehives();
                    let completed = this.gameplay.onCorrectAnswer();
                    // this.scene.sound.add('Correct sfx').play();
                    // this.sfxCarAccelerating = this.scene.sound.add('Car accelerating');
                    // this.sfxCarAccelerating.play();
                    return completed;
                }
                onWrongAnswer(forceNewRound) {
                    let i = this.gameplay.wrongAnswersCount;
                    if (i < this._BeehiveEmptyArray.length) {
                        this._BeehiveEmptyArray[i].visible = true;
                    }
                    this.hideAllUnusedBeehives();
                    let lost = this.gameplay.onWrongAnswer(forceNewRound);
                    this.sfxWrong = this.scene.sound.add("wrong sfx");
                    this.sfxWrong.play();
                    return lost;
                }
                playCorrectAudio() {
                    if (this.correctAudio) {
                        this.correctAudio.stop();
                    }
                    this.correctAudio = this.scene.sound.add("englQuestion");
                    this.correctAudio.once('complete', () => {
                        this.correctAudio = this.scene.sound.add(this.gameplay.getCorrectAudioKey());
                        this.correctAudio.play();
                    });
                    this.correctAudio.play();
                    if (this.areYouSureWindow && this.areYouSureWindow.parentContainer == this) {
                        this.correctAudio.pause();
                    }
                }
                onSoundClick() {
                    // this.playCorrectAudio();
                }
                onCloseClick() {
                    this.showAreYouSurePage();
                    this.scene.sound.add('warning page pop up sfx').play();
                }
                playBtnClickAnim(target) {
                    let sc = target["defScale"] ? target["defScale"] : 1;
                    target.scaleX = target.scaleY = sc;
                    this.scene.tweens.add({
                        targets: target,
                        "scaleX": 0.9 * sc,
                        "scaleY": 0.9 * sc,
                        duration: 100,
                        yoyo: true
                    });
                }
                showInstructionPage() {
                    setPageBackground("bg-blue");
                    this.instructionPage = new screen.InstructionPage(this.scene, (target) => {
                        this.playBtnClickAnim(target);
                        this.remove(this.instructionPage);
                        this.showGameplay();
                        if (this.wfsnd) {
                            this.wfsnd.stop();
                        }
                    }, (target) => {
                        this.playBtnClickAnim(target);
                        if (this.wfsnd) {
                            this.wfsnd.stop();
                        }
                        if (!game.cache.json.get('gameplay')['welcomeAudioDisabled']) {
                            this.wfsnd = this.scene.sound.add("Welcome Find the sound");
                            this.wfsnd.play();
                        }
                    });
                    this.add(this.instructionPage);
                    try {
                        if (!game.cache.json.get('gameplay')['welcomeAudioDisabled']) {
                            this.wfsnd = this.scene.sound.add("Welcome Find the sound");
                            this.wfsnd.play();
                        }
                    }
                    catch (e) {
                        console.error(e);
                    }
                }
                showAreYouSurePage() {
                    /* for (let j = 0; j < this.cars.length; j++) {
                        if (this.cars[j]["raceTween"]) {
                            this.cars[j]["raceTween"].pause();
                        }
                    } */

                    pauseAllDelayedCalls();
                    setPageBackground("bg-blue");
                    this.pauseSounds();
                    if (!this.areYouSureWindow) this.areYouSureWindow = new screen.AreYouSureWindow(this.scene, () => {
                        this.remove(this.areYouSureWindow);
                        this.destroyGameplay();
                        this.showInstructionPage();
                    }, () => {
                        this.remove(this.areYouSureWindow);
                        this.unpauseSounds();
                        resumeAllDelayedCalls();

                        /* for (let j = 0; j < this.cars.length; j++) {
                            if (this.cars[j]["raceTween"]) {
                                this.cars[j]["raceTween"].resume();
                            }
                        } */

                        setPageBackground("bg-australia");
                    });
                    this.add(this.areYouSureWindow);
                }
                setLettersInputEnabled(enabled) {
                    if (enabled) {
                        for (let hc of this.boxes) {
                            hc.setInteractive({ cursor: 'pointer' });
                            this.scene.input.setDraggable(hc, true);
                        }
                    }
                    else {
                        for (let hc of this.boxes) {
                            try { this.scene.input.setDraggable(hc, false); } catch (e) { }
                            hc.disableInteractive();
                        }
                    }
                }
                pauseSounds() {
                    if (this.correctAudio)
                        this.correctAudio.pause();
                    if (this.bgMusic)
                        this.bgMusic.pause();
                }
                unpauseSounds() {
                    if (this.correctAudio)
                        this.correctAudio.resume();
                    if (this.bgMusic)
                        this.bgMusic.resume();
                }
                destroyGameplay() {
                    this.setLettersInputEnabled(false);
                    this.remove(this.gameplayContainer);
                    this.scene.sound.stopAll();
                    destroyAllDelayedCalls();
                }
            }
            screen.GameplayScreen = GameplayScreen;
        })(screen = sh.screen || (sh.screen = {}));
    })(sh || (sh = {}));
    (function (sh) {
        var screen;
        (function (screen) {
            class InstructionPage extends Phaser.GameObjects.Container {
                constructor(scene, onPlayClick, onSndClick) {
                    super(scene);
                    this._instructionPage = new Phaser.GameObjects.Image(this.scene, 0 - 105, 0 - 48, 'Instructions page  ALL ACTIVITY  TITLEs');
                    this._instructionPage.setOrigin(0, 0);
                    this._instructionPage.setInteractive();

                    this._instructionPageTitle = this.scene.add.text(475, 110, sh.App.json.instructionTitle ?? 'Factory', {
                        "fontFamily": "Kids Rock DEMO",
                        "fontSize": 35,
                        "color": "#43425D",
                        "align": 'center'
                    });
                    this._instructionPageTitle.setOrigin(0.5, 0.5);
                    window['this._instructionPageTitle'] = this._instructionPageTitle;
                    this._instructionPageTitle.setStroke('#ffffff', 5);
                    //  Apply the gradient fill.
                    const gradient = this._instructionPageTitle.context.createLinearGradient(0, 0, 0, this._instructionPageTitle.height);
                    gradient.addColorStop(0, '#eeef67');
                    gradient.addColorStop(0.55, '#e98c2c');
                    gradient.addColorStop(1, '#91301a');
                    this._instructionPageTitle.setFill(gradient);

                    this._btnPlay = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2, 480 - 50, 'btnPLAY1');
                    this._btnPlay.setInteractive({ cursor: 'pointer' });
                    this._btnPlay.once('pointerup', onPlayClick);
                    setupButtonTextureBased(this._btnPlay, 'btnPLAY1', 'btnPLAY2');
                    this.instrTxt = this.scene.add.text(game.scale.width / 2, game.scale.height / 2,  "Listen to the verse and drag the box \n to the right shelf.", {
                        "fontFamily": "Kids Rock DEMO",
                        "fontSize": 30,
                        "color": "#43425D",
                        "align": 'center'
                    });
                    this.instrTxt.setLineSpacing(15);
                    this.instrTxt.setOrigin(0.5, 0.5);
                    this._btnSoundInstruction = new Phaser.GameObjects.Image(this.scene, 800 - 105, 156 - 50, 'Sound');
                    this._btnSoundInstruction.setInteractive({ cursor: 'pointer' });
                    this._btnSoundInstruction.on('pointerup', onSndClick);
                    this._btnSoundInstruction["defScale"] = this._btnSoundInstruction.scale;
                    setupButtonTextureBased(this._btnSoundInstruction, 'Sound', 'Sound HOVER EFFECT');
                    this.add(this._instructionPage);
                    this.add(this._instructionPageTitle);
                    this.add(this.instrTxt);
                    this.add(this._btnPlay);
                    this.add(this._btnSoundInstruction);
                }
            }
            screen.InstructionPage = InstructionPage;
        })(screen = sh.screen || (sh.screen = {}));
    })(sh || (sh = {}));
    (function (sh) {
        var screen;
        (function (screen) {
            class TryAgainWindow extends Phaser.GameObjects.Container {
                constructor(scene, onBack, onReplay) {
                    super(scene);
                    this.music = null;
                    this.setPosition(-106, -48);
                    this._bg = new Phaser.GameObjects.Image(this.scene, 0, 0, 'Try again page');
                    this._bg.setOrigin(0, 0);
                    this._bg.setInteractive();
                    this._star = new Phaser.GameObjects.Image(this.scene, 400, 415, 'Break Star');
                    this._btnBack = new Phaser.GameObjects.Image(this.scene, 600, 580, 'btnBACK1');
                    this._btnReplay = new Phaser.GameObjects.Image(this.scene, 765, 580, 'btnReplay1');
                    this.totalScoreTxt = this.scene.add.text(850, 355, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 35,
                        "color": "#F49F1C",
                        "align": 'center',
                        'stroke': '#70451A',
                        'strokeThickness': 6
                    });
                    this.totalScoreTxt.setOrigin(0.5, 0.5);
                    let grd = this.totalScoreTxt.context.createLinearGradient(0, 0, 0, this.totalScoreTxt.height);
                    grd.addColorStop(0, '#FFFF00');
                    grd.addColorStop(1, '#C17316');
                    this.totalScoreTxt.setFill(grd);
                    this.starScoreTxt = this.scene.add.text(635, 431, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 24,
                        "color": "#FFFFFF",
                        "align": 'center'
                    });
                    this.starScoreTxt.setOrigin(0.5, 0.5);
                    this.add([
                        this._bg,
                        this._star,
                        this._btnBack,
                        this._btnReplay,
                        this.totalScoreTxt,
                        this.starScoreTxt
                    ]);
                    this._btnBack.setInteractive({ cursor: 'pointer' });
                    this._btnBack.on('pointerup', () => {
                        onBack(this._btnBack);
                        angularComponentRef.backToMenu();
                        // if (this.music) {
                        //     this.music.stop();
                        // }
                    });
                    setupButtonTextureBased(this._btnBack, 'btnBACK1', 'btnBACK2');
                    this._btnReplay.setInteractive({ cursor: 'pointer' });
                    this._btnReplay.once('pointerup', () => {
                        onReplay(this._btnReplay);
                        if (this.music) {
                            this.music.stop();
                        }
                    });
                    setupButtonTextureBased(this._btnReplay, 'btnReplay1', 'btnReplay2');
                }
                show(score, starScore) {
                    this._star.scale = 1.25;
                    this.scene.tweens.add({
                        targets: this._star,
                        "scale": 1,
                        duration: 500,
                        ease: Phaser.Math.Easing.Back.Out
                    });
                    this.totalScoreTxt.text = '';//String(window.angularComponentRef.component.userInfo.totalScore);
                    this.starScoreTxt.text = String(0);
                    this.music = this.scene.sound.add("Fail - close one");
                    this.music.play();
                }
            }
            screen.TryAgainWindow = TryAgainWindow;
        })(screen = sh.screen || (sh.screen = {}));
    })(sh || (sh = {}));
}

function destroyFactoryGame() {
    if (game) {
        game.destroy();
    }
}

var game;
var sh;
function farmGame(json) {
    /**
     * @author Roman Parada
     * This class is created to fix overlapping of bottom part of canvas by navigation bar in iOS.
     * It make a delayed resize of the canvas (like Phaser-3 FIT methods does) and it overrides Phaser-3 input window to Phaser-3 core transform methods
     *
     * How to use:
     * Just call the code line below in Boot scene's init() method of your project:
     * new FitScaleManager(this.game).setup();
     */
    class FitScaleManager {
        constructor(game) {
            this.doResize = () => {
                let scale = this.calculateScale();
                let newCanvasWidth = this.phaserScaleManager.width * scale;
                let newCanvasHeight = this.phaserScaleManager.height * scale;
                this.canvasStyle.width = newCanvasWidth + 'px';
                this.canvasStyle.height = newCanvasHeight + 'px';
                this.canvasStyle.marginLeft = (window.innerWidth - newCanvasWidth) / 2 + 'px';
                this.canvasStyle.marginTop = (window.innerHeight - newCanvasHeight) / 2 + 'px';
            };
            this.game = game;
            this.canvasStyle = this.game.canvas.style;
            this.phaserScaleManager = this.game.scale;
        }
        static detectBestScaleMode() {
            let iOS = /iPad|iPhone|iPod/.test(navigator.platform || "");
            let isAndroid = window.navigator.userAgent.toLowerCase().indexOf("android") > -1;
            return iOS || isAndroid ? Phaser.Scale.FIT : Phaser.Scale.NONE;
        }
        ;
        /**
         * Just call this method once in Boot scene's init() method
         */
        setup() {
            this.phaserScaleManager.addListener(Phaser.Scale.Events.RESIZE, this.onResize, this);
            this.overridePhaserTransformMethods();
            this.onResize();
        }
        calculateScale() {
            if (game.scale.scaleMode === Phaser.Scale.NONE)
                return 1;
            return Math.min(window.innerWidth / this.phaserScaleManager.width, window.innerHeight / this.phaserScaleManager.height);
        }
        overridePhaserTransformMethods() {
            this.game.scale.transformX = (pageX) => {
                return (pageX - parseInt(this.canvasStyle.marginLeft.split("px")[0])) / this.calculateScale();
            };
            this.game.scale.transformY = (pageY) => {
                return (pageY - parseInt(this.canvasStyle.marginTop.split("px")[0])) / this.calculateScale();
            };
        }
        onResize() {
            setTimeout(this.doResize, FitScaleManager.RESIZE_DELAY);
        }
    }
    FitScaleManager.RESIZE_DELAY = 500;

    (function (sh) {
        class App extends Phaser.Game {
            constructor(json) {
                App.json = json;
                // console.log(App.json);

                let config = {
                    type: Phaser.AUTO,
                    width: App.CANVAS_WIDTH,
                    height: App.CANVAS_HEIGHT,
                    parent: 'game-container',
                    dom: {
                        createContainer: false
                    },
                    scale: {
                        mode: FitScaleManager.detectBestScaleMode(),
                        autoCenter: Phaser.Scale.CENTER_BOTH
                    },
                    transparent: true,
                    scene: {
                        create: () => {
                            this.scene.add('Boot', sh.scene.Boot, true);
                        }
                    }
                };
                super(config);
            }
        }
        App.CANVAS_WIDTH = 980;
        App.CANVAS_HEIGHT = 600;
        sh.App = App;
    })(sh || (sh = {}));

    game = new sh.App(json);

    var delayedCalls = [];
    function delayedCall(delay, callback, args, callbackScope) {
        let scene = game.scene.getAt(0);
        if (scene) {
            let dc = scene.time.delayedCall(delay, callback, args, callbackScope);
            delayedCalls.push(dc);
            return dc;
        }
        let t = setTimeout(callback, delay);
        delayedCalls.push(t);
        return t;
    }

    function pauseAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.paused = true;
            }
        }
    }

    function resumeAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.paused = false;
            }
        }
    }

    function destroyAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.remove(false);
            }
            else {
                clearTimeout(dc);
            }
        }
        delayedCalls = [];
    }

    function setPageBackground(bg) {
        // document.querySelector("html").style.backgroundImage = "url(assets/games/farm/imgs/" + bg + ".jpg)";
    }

    function setupButton(btn, frame) {
        btn.on('pointerdown', () => { btn.setFrame(frame + '_hover' + '0000'); });
        btn.on('pointerover', () => { btn.setFrame(frame + '_hover' + '0000'); game.scene.getAt(0).sound.add("button hover").play(); });
        btn.on('pointerout', () => { btn.setFrame(frame + '0000'); });
        btn.on('pointerup', () => { btn.setFrame(frame + '0000'); game.scene.getAt(0).sound.add('activity selection - button selection').play(); });
    }

    function setupButtonTextureBased(btn, texture, hoverTexture) {
        btn.on('pointerdown', () => { btn.setTexture(hoverTexture); });
        btn.on('pointerover', () => { btn.setTexture(hoverTexture); game.scene.getAt(0).sound.add("button hover").play(); });
        btn.on('pointerout', () => { btn.setTexture(texture); });
        btn.on('pointerup', () => { btn.setTexture(texture); game.scene.getAt(0).sound.add('activity selection - button selection').play(); });
    }

    (function (sh) {
        var core;
        (function (core) {
            class Gameplay {
                constructor() {
                    this.currentRound = 0;
                    this.currentLetter = 0;
                    this.correctAnswersCount = 0;
                    this.wrongAnswersCount = 0;
                    this.correctAnswersCountThisRound = 0;
                    this.wrongAnswersCountThisRound = 0;
                    this.reset();
                    let json = game.cache.json.get('gameplay');
                    this.wrongAnswersToLose = json["wrongAnswersToLose"];
                    this.numberOfQuestionsPerRound = json["numberOfQuestionsPerRound"];
                    this.lettersConfig = JSON.parse(JSON.stringify(json["lettersConfig"]));
                    this.rounds = JSON.parse(JSON.stringify(json["rounds"]));
                    this.numberOfRounds = json["numberOfRounds"] ?? this.rounds.length;
                    this.useImages = Boolean(game.cache.json.get('gameplay')["useImages"]);
                }
                setupCallbacks(onComplete, onLose) {
                    this.onComplete = onComplete;
                    this.onLose = onLose;
                }
                onLetterChosen(forceNewRound) {
                    if (forceNewRound || this.isNewRound()) {
                        return this.nextRound();
                    }
                    return false;
                }
                nextRound() {
                    this.correctAnswersCountThisRound = 0;
                    this.wrongAnswersCountThisRound = 0;
                    this.currentRound++;
                    if (this.isRoundsComplete()) {
                        this.onComplete(this.correctAnswersCount, this.correctAnswersCount);
                        return true;
                    }

                    return false;
                }
                getCorrectLetterName() {
                    return this.rounds[this.currentRound]['correctLetterName'];
                }
                isCorrectLetterAudioQuestionEnable() {
                    return this.rounds[this.currentRound]['audioQuestionEnable'];
                }
                getCorrectAndLetterSoundSfxAudioKey() {
                    return "Q-" + this.lettersConfig[this.getCorrectLetterName()]['Sounds of the letters'];
                }
                onCorrectAnswer() {
                    this.correctAnswersCountThisRound++;
                    this.correctAnswersCount++;
                    return this.onLetterChosen();
                }
                onWrongAnswer(forceNewRound) {
                    this.wrongAnswersCountThisRound++;
                    this.wrongAnswersCount++;
                    if (this.wrongAnswersCount >= this.wrongAnswersToLose) {
                        this.onLose(this.correctAnswersCount, this.correctAnswersCount);
                        return true;
                    }
                    else {
                        this.onLetterChosen(forceNewRound);
                    }
                    return false;
                }

                getMaxTotalAnswersCount() {
                    return this.wrongAnswersToLose + this.numberOfRounds - 1;
                }

                getCurrentTotalAnswersCount() {
                    return this.correctAnswersCount + this.wrongAnswersCount;
                }
                isNewRound() {
                    return this.correctAnswersCountThisRound >= 1 || (this.correctAnswersCountThisRound + this.wrongAnswersCountThisRound) === 4 || (this.correctAnswersCountThisRound + this.wrongAnswersCountThisRound) === 0;
                }
                isRoundsComplete() {
                    return this.currentRound >= this.numberOfRounds && this.wrongAnswersCount < this.wrongAnswersToLose;
                }
                reset() {
                    this.currentRound = 0;
                    this.correctAnswersCount = 0;
                    this.wrongAnswersCount = 0;
                }
                getCurrentRoundLetters() {
                    return this.rounds[this.currentRound]["letters"];
                }
            }
            core.Gameplay = Gameplay;
        })(core = sh.core || (sh.core = {}));
    })(sh || (sh = {}));

    (function (sh) {
        var scene;
        (function (scene) {
            class Boot extends Phaser.Scene {
                init() {
                    this.game.scale.transformX = (pageX) => {
                        let offsetLeft = 0;
                        let parentElement = game.canvas.parentElement;
                        while (parentElement) {
                            if (parentElement.offsetLeft) {
                                offsetLeft = parentElement.offsetLeft;
                                break;
                            }
                            parentElement = parentElement.parentElement;
                        }
                        return (pageX - offsetLeft) * this.game.scale.displayScale.x;
                    };
                    this.game.scale.transformY = (pageY) => {
                        let offsetTop = 0;
                        let parentElement = game.canvas.parentElement;
                        while (parentElement) {
                            if (parentElement.offsetTop) {
                                offsetTop = parentElement.offsetTop;
                                break;
                            }
                            parentElement = parentElement.parentElement;
                        }
                        return (pageY - offsetTop) * this.game.scale.displayScale.y;
                    };
                }
                create() {
                    game.scene.remove('Boot');
                    game.scene.add('Preloader', sh.scene.Preloader, true);
                }
            }
            scene.Boot = Boot;
        })(scene = sh.scene || (sh.scene = {}));
    })(sh || (sh = {}));

    (function (sh) {
        var scene;
        (function (scene) {
            var Gameplay = sh.core.Gameplay;
            class MainScene extends Phaser.Scene {
                create() {
                    this.gameplay = new Gameplay();
                    this.gameplayScreen = new sh.screen.GameplayScreen(this, this.gameplay);
                    this.children.add(this.gameplayScreen);
                    this.gameplayScreen.showInstructionPage();
                }
            }
            scene.MainScene = MainScene;
        })(scene = sh.scene || (sh.scene = {}));
    })(sh || (sh = {}));

    (function (sh) {
        var scene;
        (function (scene) {
            class Preloader extends Phaser.Scene {
                preload() {
                    if (typeof sh.App.json == "string") this.load.json('gameplay', sh.App.json); else this.game.cache.json.add('gameplay', sh.App.json);
                }
                create() {
                    let json = game.cache.json.get('gameplay');
                    let lettersConfig = json["lettersConfig"];

                    if (json.instructionAudio) {
                        this.load.audio("instructionAudio", json.instructionAudio);
                    }

                    this.load.audio("englQuestion", "assets/games/farm/sound/mp3/letters/englQuestion.mp3");

                    for (let letterName in lettersConfig) {
                        if (json["useImages"]) this.load.image(letterName, "assets/games/farm/imgs/letters/" + letterName + ".png");
                        if (lettersConfig[letterName]) {
                            this.load.audio("Q-" + lettersConfig[letterName]["Sounds of the letters"], "assets/games/farm/sound/mp3/letters/Sounds of the letters/" + lettersConfig[letterName]["Sounds of the letters"]);
                        }
                    }
                    let progressTxt = this.add.text(game.scale.width / 2, game.scale.height / 2 + 50, "", {
                        "fontFamily": "QuranErafont",
                        "fontSize": 25,
                        "color": "#333333",
                        "align": 'center'
                    });
                    progressTxt.setOrigin(0.5, 0.5);
                    this.load.pack('preloader', 'assets/games/farm/pack.json');
                    this.load.on('progress', (value) => {
                        progressTxt.text = Math.ceil(value * 100) + "%";
                    }, this);
                    this.load.on('complete', () => {
                        this.nextScene();
                    });
                    this.load.start();
                }
                static playAnim(animKey, sprite, onComplete = null) {
                    let mainScene = game.scene.getScene('ScreenMain');
                    let data = Preloader.ANIMS_DATA[animKey];
                    if (!mainScene.anims.exists(animKey)) {
                        mainScene.anims.create({
                            key: animKey,
                            frames: mainScene.anims.generateFrameNames(data['atlas'], {
                                start: data['start'], end: data['end'], zeroPad: data['padNum'],
                                prefix: data['prefix'], suffix: ''
                            }),
                            frameRate: data['frameRate'],
                            repeat: data['repeat']
                        });
                    }
                    if (sprite.anims.currentAnim) {
                        sprite.anims.currentAnim.off('complete');
                    }
                    sprite.anims.stop();
                    // sprite.setTexture(data['atlas']);
                    sprite.play(animKey);
                    sprite.anims.currentAnim.once('complete', () => {
                        if (onComplete)
                            onComplete();
                    });
                    return sprite;
                }
                nextScene() {
                    game.scene.remove('Preloader');
                    game.scene.add('ScreenMain', sh.scene.MainScene, true);
                }
            }
            Preloader.ANIMS_DATA = {
                'idle': {
                    'start': 1,
                    'end': 99,
                    'padNum': 2,
                    'prefix': 'Duck Finish the Melon v3 0',
                    'repeat': -1,
                    'frameRate': 30,
                    'atlas': 'idle-atlas'
                },
                'finalanimation': {
                    'start': 1,
                    'end': 109,
                    'padNum': 3,
                    'prefix': 'Duck Finish the Melon',
                    'repeat': 0,
                    'frameRate': 30,
                    'atlas': 'finalanimation-atlas'
                },
                'correct': {
                    'start': 1,
                    'end': 74,
                    'padNum': 2,
                    'prefix': 'Duck Take a Bite',
                    'repeat': 0,
                    'frameRate': 30,
                    'atlas': 'correct-atlas'
                },
                'wrong': {
                    'start': 1,
                    'end': 53,
                    'padNum': 2,
                    'prefix': 'Duck Take a Bite',
                    'repeat': 0,
                    'frameRate': 30,
                    'atlas': 'wrong-atlas'
                }
            };
            scene.Preloader = Preloader;
        })(scene = sh.scene || (sh.scene = {}));
    })(sh || (sh = {}));
    (function (sh) {
        var screen;
        (function (screen) {
            class AreYouSureWindow extends Phaser.GameObjects.Container {
                constructor(scene, onYes, onNo) {
                    super(scene);
                    this._areYouSurePage = new Phaser.GameObjects.Image(this.scene, -105, 0 - 48, 'Exit warning');
                    this._areYouSurePage.setOrigin(0, 0);
                    this._areYouSurePage.setInteractive();
                    this._btnSureYes = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2 - 95, 485 - 50, 'btnYES1');
                    this._btnSureYes.setInteractive({ cursor: 'pointer' });
                    this._btnSureYes.on('pointerup', () => {
                        onYes;
                        angularComponentRef.backToMenu();
                    });
                    var modalTextStyle = {
                        backgroundColor: 'transparent',
                        stroke: '#ffffff',
                        strokeThickness: 2,
                        lineSpacing: 15,
                        fontFamily: 'Kids Rock DEMO',
                        fontSize: 27,
                        color: '#43425d',
                        wordWrap: true,
                        align: 'center'
                    };
                    var modalText = this.scene.add.text(game.scale.width / 2 + 12, game.scale.height / 2, "Your progress in this activity will not be saved. \n Are you sure you want to exit? ", modalTextStyle);
                    modalText.setOrigin(0.5, 0.5);

                    setupButtonTextureBased(this._btnSureYes, 'btnYES1', 'btnYES2');
                    this._btnSureNo = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2 + 95, 485 - 50, 'btnNO1');
                    this._btnSureNo.setInteractive({ cursor: 'pointer' });
                    this._btnSureNo.on('pointerup', onNo);
                    setupButtonTextureBased(this._btnSureNo, 'btnNO1', 'btnNO2');
                    this.add(this._areYouSurePage);
                    this.add(this._btnSureYes);
                    this.add(this._btnSureNo);
                    this.add(modalText);
                }
            }
            screen.AreYouSureWindow = AreYouSureWindow;
        })(screen = sh.screen || (sh.screen = {}));
    })(sh || (sh = {}));

    (function (sh) {
        var screen;
        (function (screen) {
            class CompleteWindow extends Phaser.GameObjects.Container {
                constructor(scene, onBack, onReplay, onNext) {
                    super(scene);
                    this.music = null;
                    this.setPosition(-104.5, -48);
                    this._bgComplete = new Phaser.GameObjects.Image(this.scene, 0, 0, 'Completion page LATEST UPDATED');
                    this._bgComplete.setOrigin(0, 0);
                    this._bgComplete.setInteractive();
                    this._cup = new Phaser.GameObjects.Image(this.scene, 400, 410, 'Trophy');
                    this._btnBack = new Phaser.GameObjects.Image(this.scene, 570, 570, 'btnBACK1');
                    this._btnReplay = new Phaser.GameObjects.Image(this.scene, 720, 570, 'btnReplay1');
                    this._btnNext = new Phaser.GameObjects.Image(this.scene, 870, 570, 'btnNEXT1');
                    let _CollectedPoints = new Phaser.GameObjects.Image(this.scene, 620, 440, 'Collected Points');
                    this.totalScoreTxt = this.scene.add.text(845, 352, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 35,
                        "color": "#F49F1C",
                        "align": 'center',
                        'stroke': '#70451A',
                        'strokeThickness': 6
                    });
                    this.totalScoreTxt.setOrigin(0.5, 0.5);
                    let grd = this.totalScoreTxt.context.createLinearGradient(0, 0, 0, this.totalScoreTxt.height);
                    grd.addColorStop(0, '#FFFF00');
                    grd.addColorStop(1, '#C17316');
                    this.totalScoreTxt.setFill(grd);
                    this.starScoreTxt = this.scene.add.text(648, 433, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 24,
                        "color": "#FFFFFF",
                        "align": 'center'
                    });
                    this.starScoreTxt.setOrigin(0.5, 0.5);
                    this.add([
                        this._bgComplete,
                        _CollectedPoints,
                        this._cup,
                        this._btnBack,
                        this._btnReplay,
                        this._btnNext,
                        this.totalScoreTxt,
                        this.starScoreTxt
                    ]);
                    this._btnBack.setInteractive({ cursor: 'pointer' });
                    this._btnBack.on('pointerup', () => {
                        onBack(this._btnBack);
                        angularComponentRef.backToMenu();
                        // if (this.music) {
                        //     this.music.stop();
                        // }
                    });
                    setupButtonTextureBased(this._btnBack, 'btnBACK1', 'btnBACK2');
                    this._btnReplay.setInteractive({ cursor: 'pointer' });
                    this._btnReplay.once('pointerup', () => {
                        onReplay(this._btnReplay);
                        if (this.music) {
                            this.music.stop();
                        }
                    });
                    setupButtonTextureBased(this._btnReplay, 'btnReplay1', 'btnReplay2');
                    this._btnNext.setInteractive({ cursor: 'pointer' });
                    this._btnNext.on('pointerup', () => {
                        onNext(this._btnNext);
                        window.angularComponentRef.nextActivity()
                    });
                    setupButtonTextureBased(this._btnNext, 'btnNEXT1', 'btnNEXT2');
                }
                show(score, starScore) {
                    window.angularComponentRef.gameFinish({ score, starScore })
                    this._cup.scale = 1.25;
                    this.scene.tweens.add({
                        targets: this._cup,
                        "scale": 1,
                        duration: 500,
                        ease: Phaser.Math.Easing.Back.Out
                    });
                    this.totalScoreTxt.text = String(window.angularComponentRef.component.userInfo.totalScore);
                    this.starScoreTxt.text = String(starScore);
                    // let music = this.scene.sound.add("viktory");
                    this.music = this.scene.sound.add("Activity completion fantastic");
                    this.music.play();
                }
            }
            screen.CompleteWindow = CompleteWindow;
        })(screen = sh.screen || (sh.screen = {}));
    })(sh || (sh = {}));

    (function (sh) {
        var screen;
        (function (screen) {
            class GameplayScreen extends Phaser.GameObjects.Container {
                constructor(scene, gameplay) {
                    super(scene);
                    this.carsPositions = [{ x: -153 + 330, y: 277 + 242 }, { x: 53 + 330, y: 277 + 242 }, { x: 273 + 330, y: 277 + 242 }, { x: 501 + 330, y: 277 + 242 }];
                    this.bgMusic = null;
                    this.correctAudio = null;
                    this.wfsnd = null;
                    this.showCompleteWindow = (score, starScore) => {
                        let completeWindow = new screen.CompleteWindow(this.scene, (target) => {
                            this.playBtnClickAnim(target);
                        }, (target) => {
                            this.playBtnClickAnim(target);
                            this.destroyGameplay();
                            this.remove(completeWindow);
                            this.showInstructionPage();
                        }, (target) => {
                            this.playBtnClickAnim(target);
                        });
                        this.setLettersInputEnabled(false);
                        delayedCall(7750, () => {
                            setPageBackground("bg-blue");
                            this.add(completeWindow);
                            completeWindow.show(score, starScore);
                            if (this.bgMusic) this.bgMusic.stop();
                        });
                    };
                    this.showLoseWindow = (score, starScore) => {
                        let tryAgainWindow = new screen.TryAgainWindow(this.scene, (target) => {
                            this.playBtnClickAnim(target);
                        }, (target) => {
                            this.playBtnClickAnim(target);
                            this.destroyGameplay();
                            this.remove(tryAgainWindow);
                            this.showInstructionPage();
                        });
                        this.setLettersInputEnabled(false);
                        delayedCall(2500, () => {
                            setPageBackground("bg-blue");
                            this.add(tryAgainWindow);
                            tryAgainWindow.show(score, starScore);
                            if (this.bgMusic) this.bgMusic.stop();
                        });
                    };
                    this.gameplay = gameplay;
                    window["t"] = this;
                }
                createHexagons() {
                    if (this.contentContainer && this.contentContainer.parentContainer) {
                        this.contentContainer.parentContainer.remove(this.contentContainer);
                    }

                    this.contentContainer = this.scene.add.container(0, 0);
                    this.gameplayContainer.addAt(this.contentContainer, this.gameplayContainer.getAll().length);
                    window['this.contentContainer'] = this.contentContainer;

                    this.cars = [];
                    let _i = 0;
                    for (let p of this.carsPositions) {
                        let hc = this.scene.add.container(this.carsPositions[_i]['x'], this.carsPositions[_i]['y']); window['hc'] = hc;
                        let hcIdleMotionContainer = this.scene.add.container();
                        hc.add(hcIdleMotionContainer);
                        let h = this.scene.add.sprite(-70, -8, 'melon'); window['h'] = h;
                        h.setOrigin(20 / 185, 0.5);
                        hc['isUsedAlready'] = false
                        hc.add(h);
                        hc["bg"] = h;
                        window['hc_' + _i] = hc;
                        window['h_' + _i] = h;
                        hcIdleMotionContainer.add(h);
                        hc['hcIdleMotionContainer'] = hcIdleMotionContainer;

                        hc["defX"] = p['x'];
                        hc["defY"] = p['y'];
                        this.cars.push(hc);
                        this.contentContainer.add(hc);
                        hc['index'] = _i;
                        _i++;
                    }
                    window['this.cars'] = this.cars;
                }
                createLetters() {
                    /* if (this.letters) {
                        for (let l of this.letters) {
                            l.parentContainer["letter"] = null;
                            l["hexagon"] = null;
                            l.parentContainer.remove(l);
                        }
                    } */
                    this.letters = [];
                    let _letters = this.gameplay.getCurrentRoundLetters();
                    for (let n of _letters) {
                        let wordText;
                        if (this.gameplay.useImages) {
                            wordText = new Phaser.GameObjects.Image(this.scene, 0, 0, n);

                            if (wordText.width > 130) wordText.setScale(130 / wordText.width);
                            if (wordText.height > 70) wordText.setScale(wordText.scaleY * 70 / wordText.height);
                        } else {
                            wordText = this.scene.add.text(0, 0, n, {
                                "fontFamily": "QuranErafont",
                                "fontSize": 40,
                                "color": "#333333",
                                "align": 'center'
                            });
                            this.add(wordText);
                            wordText.setOrigin(0.5, 0.5);
                            wordText.setPadding({ left: 0, right: 0, top: 50, bottom: 50 });
                        }

                        wordText.setPosition(11, -5);
                        wordText["key"] = n;
                        this.letters.push(wordText);
                        window['wordText'] = wordText;
                    }
                }
                showGameplay() {
                    this.melonPositions = [
                        { x: 529 + 40 + 10, y: 342 + 25 },
                        { x: 556 + 40 + 15, y: 321 + 35 },
                        { x: 606 + 40 + 10 + 7, y: 315 + 35 },
                        { x: 661 + 40 + 10 + 10, y: 313 + 35 },

                        { x: 547 + 40 + 10, y: 300 + 30 }, { x: 571 + 40 + 10, y: 261 + 30 },
                        { x: 574 + 80 + 10, y: 273 + 30 }, { x: 637 + 40 + 45 + 10, y: 270 + 30 }, { x: 604 + 40 + 10, y: 234 + 30 },
                        { x: 690 + 10, y: 246 + 20 }
                    ];
                    this.isLost = false;
                    setPageBackground("bg-australia");
                    this.bgMusic = this.scene.sound.add("bg_sound");
                    this.bgMusic.play();
                    this.bgMusic.loop = true;
                    this.gameplay.reset();
                    this._gameStage = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2, game.scale.height / 2, 'bg');
                    this._gameStage.setOrigin(0.5, 0.5);
                    this._gameStage.setInteractive();
                    this._btnSound = new Phaser.GameObjects.Image(this.scene, 160 - 105, 100 - 50, 'Sound');
                    this._btnSound.setInteractive({ cursor: 'pointer' });
                    this._btnSound["defScale"] = this._btnSound.scale;
                    setupButtonTextureBased(this._btnSound, 'Sound', 'Sound HOVER EFFECT');
                    this._btnClose = new Phaser.GameObjects.Image(this.scene, 1025 - 105, 100 - 50, 'x Button');
                    this._btnClose.setInteractive({ cursor: 'pointer' });
                    this._btnClose["defScale"] = this._btnClose.scale;
                    setupButtonTextureBased(this._btnClose, 'x Button', 'x Button HOVER EFFECT');
                    this.gameplayContainer = new Phaser.GameObjects.Container(this.scene);
                    this.addAt(this.gameplayContainer, 0);
                    this.gameplayContainer.add([
                        this._gameStage,
                        this._btnSound,
                        this._btnClose
                    ]);

                    this.wagonBack = this.scene.add.sprite(650 + 80, 365 - 10, "wagonBack"); window['this.wagonBack'] = this.wagonBack;
                    this.gameplayContainer.add(this.wagonBack);

                    this.wagonFront = this.scene.add.sprite(650, 365, "wagonFront"); window['this.wagonFront'] = this.wagonFront;
                    this.gameplayContainer.add(this.wagonFront);

                    this.goose = this.scene.add.sprite(490, 600, "idle-atlas");
                    this.gameplayContainer.add(this.goose);
                    this.goose.setOrigin(0.5, 1);
                    window['this.goose'] = this.goose;
                    sh.scene.Preloader.playAnim('idle', this.goose);
                    // sh.scene.Preloader.playAnim('finalanimation', this.goose);

                    this.createBeehives();
                    this.shuffleOutHexagons();
                    this.gameplay.setupCallbacks(this.showCompleteWindow, this.showLoseWindow);

                    this.frontPlant = this.scene.add.sprite(425, 470, "frontPlant"); window['this.frontPlant'] = this.frontPlant;
                    this.gameplayContainer.add(this.frontPlant);
                }
                createBeehives() {
                    let startX = 120;
                    let startY = 40;
                    let dx = 37;
                    let _BeehiveEmptyArrayPositions = [];
                    for (let i = 0; i < this.gameplay.getMaxTotalAnswersCount(); i++) {
                        _BeehiveEmptyArrayPositions.push({ x: startX + i * dx, y: startY });
                    }
                    this._BeehiveEmptyArray = []; window["_BeehiveEmptyArray"] = this._BeehiveEmptyArray;
                    this._Beehive = [];
                    for (let p of _BeehiveEmptyArrayPositions) {
                        let _BeehiveEmpty = new Phaser.GameObjects.Image(this.scene, p['x'], p['y'], 'Beehive 1 Empty');
                        this._BeehiveEmptyArray.push(_BeehiveEmpty);
                        _BeehiveEmpty.visible = false;
                        let _Beehive = new Phaser.GameObjects.Image(this.scene, p['x'], p['y'], 'Beehive 1');
                        this._Beehive.push(_Beehive);
                    }
                    for (let bea of this._BeehiveEmptyArray) {
                        this.gameplayContainer.add(bea);
                    }
                    for (let bee of this._Beehive) {
                        this.gameplayContainer.add(bee);
                        bee.visible = false;
                    }
                }
                randomizeLettersPosition() {
                    let hx = this.cars.slice();
                    for (let l of this.letters) {
                        if (hx.length == 0)
                            return;
                        let hc = Phaser.Utils.Array.RemoveRandomElement(hx);
                        hc['hcIdleMotionContainer'].add(l);
                        hc["letter"] = l;
                        l["hexagon"] = hc;
                    }
                }
                updateHexagonsArrange() {
                    for (let hc of this.cars) {
                        if (!hc["letter"]) {
                            hc.parentContainer.bringToTop(hc);
                            break;
                        }
                    }
                }
                shuffleOutHexagons() {
                    this.createHexagons();

                    let setLettersInputEnabled = () => {
                        if (this.correctAudio && this.correctAudio.isPlaying) {
                            delayedCall((this.correctAudio.duration * 0.75) * 1000, () => {
                                this.setLettersInputEnabled(true);
                            });
                        }
                        else {
                            this.setLettersInputEnabled(true);
                        }
                    };

                    if (json.instructionAudio) {

                        if (this.gameplay.currentRound === 0) {
                            var snd = this.scene.sound.add("instructionAudio");
                            snd.play();
                            if (!this.gameplay.isRoundsComplete()) {
                                delayedCall(4650, () => {
                                    if (this.gameplay.isCorrectLetterAudioQuestionEnable()) {
                                        this.playCorrectAudio();
                                    }
                                    setLettersInputEnabled();
                                })
                            }

                        }else{
                            if (!this.gameplay.isRoundsComplete()) {
                                delayedCall(650, () => {
                                    if (this.gameplay.isCorrectLetterAudioQuestionEnable()) {
                                        this.playCorrectAudio();
                                    }
                                    setLettersInputEnabled();
                                })
                            }
                        }

                    } else {

                        if (!this.gameplay.isRoundsComplete()) {
                            delayedCall(650, () => {
                                if (this.gameplay.isCorrectLetterAudioQuestionEnable()) {
                                    this.playCorrectAudio();
                                }
                                setLettersInputEnabled();
                            })
                        }
                    }

                    if (this.sfxCarAccelerating) {
                        this.sfxCarAccelerating.stop();
                        this.sfxCarAccelerating = null;
                    }
                    if (this.sfxWrong) {
                        this.sfxWrong.stop();
                        this.sfxWrong = null;
                    }

                    if (!this.gameplay.isRoundsComplete()) {
                        this.createLetters();
                        this.randomizeLettersPosition();
                    }

                    this.setLettersInputEnabled(false);
                    this.updateHexagonsArrange();
                    // Phaser.Utils.Array.Shuffle(this.carsPositions);
                    let cars = this.cars;
                    for (let i = 0; i < cars.length; i++) {
                        let hc = cars[i];
                        hc["defX"] = this.carsPositions[i]["x"];
                        hc["defY"] = this.carsPositions[i]["y"];
                        this.scene.tweens.killTweensOf(hc);

                        if (this.gameplay.getCurrentTotalAnswersCount() === 0) {
                            hc["bg"].setScale(0);
                            this.scene.tweens.add({
                                targets: hc["bg"],
                                scaleX: 1,
                                scaleY: 1,
                                duration: 250,
                                delay: 350 + i * 150
                            });

                            delayedCall(350, () => this.scene.sound.add('Blocks appearing in each round').play())

                            hc['letter'].alpha = 0;
                            this.scene.tweens.add({
                                targets: hc['letter'],
                                alpha: 1,
                                duration: 350,
                                delay: 150 + 350 + i * 150
                            });
                        } else {
                            if (this.gameplay.getCurrentTotalAnswersCount() == 0 || i == this.lastCorrectAnswerIndex) {
                                hc["bg"].setScale(0);
                                this.scene.tweens.add({
                                    targets: hc["bg"],
                                    scaleX: 1,
                                    scaleY: 1,
                                    duration: 200,
                                    delay: 200,
                                    ease: Phaser.Math.Easing.Quadratic.Out,
                                    onComplete: () => { }
                                });

                                this.scene.sound.add('New melon appears sfx').play();
                            }

                            // delayedCall(450, ()=>this.scene.sound.add('Movement fx').play())

                            hc['letter'].alpha = 0;
                            this.scene.tweens.add({
                                targets: hc['letter'],
                                alpha: 1,
                                duration: 175,
                                delay: 550
                            });
                        }
                    }

                    this.scene.tweens.add({
                        targets: this.frontPlant,
                        scaleX: 1.013,
                        yoyo: true,
                        duration: 500
                    });

                    for (let c of cars) this.gameplayContainer.remove(c);
                    this.cars.sort((c1, c2) => c1.y - c2.y);
                    // for (let c of cars) this.gameplayContainer.add(c);

                    this.createInput();
                }
                shuffleInHexagons() {
                    this.updateHexagonsArrange();
                    let positions = this.carsPositions.slice();
                    this.setLettersInputEnabled(false);

                    // delayedCall(600, () => {
                    // this.scene.sound.add('move to centre').play();
                    this.shuffleOutHexagons();
                    // });
                }
                createInput() {
                    let j = 0;
                    for (let hc of this.cars) {
                        let correctAnswer = hc["letter"] && hc["letter"]["key"] == this.gameplay.getCorrectLetterName();
                        //hc["letter"].alpha = correctAnswer ? 1 : 0.5;
                        hc["bg"].once('pointerup', () => {
                            if (hc["isUsedAlready"]) return;
                            hc['isUsedAlready'] = true;

                            // this.playBtnClickAnim(hc);
                            let lost = false;
                            if (correctAnswer) {
                                this.setLettersInputEnabled(false);

                                this.lastCorrectAnswerIndex = this.cars.indexOf(hc);
                                this.scene.tweens.add({
                                    targets: hc["bg"],
                                    scaleX: 0.85,
                                    scaleY: 1.15,
                                    yoyo: true,
                                    duration: 100
                                });

                                let completed = this.onCorrectAnswer();

                                this.scene.tweens.add({
                                    targets: hc["letter"],
                                    alpha: 0,
                                    duration: 300,
                                    delay: 200
                                }); +

                                    delayedCall(600, () => {
                                        this.scene.sound.add('Melon being thrown and landing sfx').play()
                                        let p = this.melonPositions.shift();
                                        this.scene.tweens.add({
                                            targets: hc,
                                            x: p.x,
                                            y: p.y - 90,
                                            scaleX: 0.5,
                                            scaleY: 0.5,
                                            ease: Phaser.Math.Easing.Quadratic.Out,
                                            duration: 500,
                                            delay: 200,
                                            onComplete: () => {
                                                hc.parentContainer.remove(hc);
                                                if (this.gameplay.correctAnswersCount > 5) {
                                                    this.gameplayContainer.addAt(hc, 4);
                                                } else {
                                                    this.gameplayContainer.add(hc);
                                                    this.gameplayContainer.swap(hc, this.wagonFront);
                                                }

                                                this.scene.tweens.add({
                                                    targets: hc,
                                                    y: p.y,
                                                    duration: 100,
                                                    onComplete: () => {
                                                        for (let _hc of this.cars) {
                                                            this.scene.tweens.add({
                                                                targets: _hc["letter"],
                                                                alpha: 0,
                                                                duration: 400
                                                            });
                                                        }

                                                        if (completed) {
                                                            sh.scene.Preloader.playAnim('finalanimation', this.goose);
                                                            delayedCall(400, () => this.scene.sound.add('Eating up - final animation sfx').play())
                                                        } else {
                                                            sh.scene.Preloader.playAnim('correct', this.goose, () => sh.scene.Preloader.playAnim('idle', this.goose));
                                                            delayedCall(500, () => this.scene.sound.add('Biting - correct animation sfx').play())
                                                        }
                                                        // this.scene.sound.add('First meteor explostion').play();

                                                        // sh.scene.Preloader.playAnim('snail-giggling', this.goose);
                                                        // this.scene.sound.add('Snail giggling sound - correct selection').play();

                                                        if (completed) delayedCall(3750, () => this.scene.sound.add('Final celebration sound').play())

                                                        delayedCall(completed ? 4200 : 1600, () => {
                                                            if (!completed) {
                                                                this.shuffleInHexagons();
                                                            }
                                                        });
                                                    }
                                                });
                                            }
                                        });
                                    });
                            } else {
                                delayedCall(350, () => {
                                    sh.scene.Preloader.playAnim('wrong', this.goose, () => sh.scene.Preloader.playAnim('idle', this.goose));
                                    this.scene.sound.add('Goose No sfx').play();
                                });

                                this.scene.tweens.add({
                                    targets: hc,
                                    x: hc.x - 1,
                                    yoyo: true,
                                    repeat: 3,
                                    duration: 100
                                });
                                this.scene.tweens.add({
                                    targets: hc["letter"],
                                    alpha: 0,
                                    duration: 500
                                });

                                // delayedCall(700, ()=>{hc.visible=false;});
                                lost = this.onWrongAnswer();
                                if (!lost) {
                                    // this.shuffleInHexagons();
                                } else {
                                    this.isLost = true;
                                }
                            }
                        });
                    }
                    this._btnSound.on('pointerup', () => {
                        this.playBtnClickAnim(this._btnSound);
                        this.onSoundClick();
                    });
                    this._btnClose.on('pointerup', () => {
                        this.playBtnClickAnim(this._btnClose);
                        this.onCloseClick();
                    });
                }
                hideAllUnusedBeehives() {
                    let i = this.gameplay.getCurrentTotalAnswersCount();
                    for (let k = i + 1; k < this._BeehiveEmptyArray.length; k++) {
                        this._BeehiveEmptyArray[k].visible = false;
                        this._Beehive[k].visible = false;
                    }
                }
                onCorrectAnswer() {
                    let i = this.gameplay.getCurrentTotalAnswersCount();
                    if (i < this._BeehiveEmptyArray.length) {
                        this._BeehiveEmptyArray[i].visible = false;
                        this._Beehive[i].visible = true;
                    }
                    this.hideAllUnusedBeehives();
                    let completed = this.gameplay.onCorrectAnswer();
                    this.scene.sound.add('Correct sfx').play();

                    // this.sfxCarAccelerating = this.scene.sound.add('Car accelerating');
                    // this.sfxCarAccelerating.play();
                    // delayedCall(250, () => {
                    //     this.scene.sound.add(this.gameplay.getCorrectAndLetterSoundSfxAudioKey()).play();
                    // });
                    return completed;
                }
                onWrongAnswer(forceNewRound) {
                    let i = this.gameplay.getCurrentTotalAnswersCount();
                    if (i < this._BeehiveEmptyArray.length) {
                        this._BeehiveEmptyArray[i].visible = true;
                        this._Beehive[i].visible = false;
                    }
                    this.hideAllUnusedBeehives();
                    let lost = this.gameplay.onWrongAnswer(forceNewRound);
                    this.sfxWrong = this.scene.sound.add("wrong sfx");
                    this.sfxWrong.play();
                    return lost;
                }
                playCorrectAudio() {
                    if (this.correctAudio) {
                        this.correctAudio.stop();
                    }
                    this.correctAudio = this.scene.sound.add("englQuestion");
                    this.correctAudio.once('complete', () => {
                        this.correctAudio = this.scene.sound.add(this.gameplay.getCorrectAndLetterSoundSfxAudioKey());
                        this.correctAudio.play();
                    });
                    this.correctAudio.play();
                    if (this.areYouSureWindow && this.areYouSureWindow.parentContainer == this) {
                        this.correctAudio.pause();
                    }
                }
                onSoundClick() {
                    this.playCorrectAudio();
                }
                onCloseClick() {
                    this.showAreYouSurePage();
                    this.scene.sound.add('warning page pop up sfx').play();
                }
                playBtnClickAnim(target) {
                    let sc = target["defScale"] ? target["defScale"] : 1;
                    target.scaleX = target.scaleY = sc;
                    this.scene.tweens.add({
                        targets: target,
                        "scaleX": 0.9 * sc,
                        "scaleY": 0.9 * sc,
                        duration: 100,
                        yoyo: true
                    });
                }
                showInstructionPage() {
                    setPageBackground("bg-blue");
                    this.instructionPage = new screen.InstructionPage(this.scene, (target) => {
                        this.playBtnClickAnim(target);
                        this.remove(this.instructionPage);
                        this.showGameplay();
                        if (this.wfsnd) {
                            this.wfsnd.stop();
                        }
                    }, (target) => {
                        this.playBtnClickAnim(target);
                        if (this.wfsnd) {
                            this.wfsnd.stop();
                        }
                        if (!game.cache.json.get('gameplay')['welcomeAudioDisabled']) {
                            this.wfsnd = this.scene.sound.add("Welcome Find the sound");
                            this.wfsnd.play();
                        }
                    });
                    this.add(this.instructionPage);
                    try {
                        if (!game.cache.json.get('gameplay')['welcomeAudioDisabled']) {
                            this.wfsnd = this.scene.sound.add("Welcome Find the sound");
                            this.wfsnd.play();
                        }
                    }
                    catch (e) {
                        console.error(e);
                    }
                }
                showAreYouSurePage() {
                    /* for (let j = 0; j < this.cars.length; j++) {
                        if (this.cars[j]["raceTween"]) {
                            this.cars[j]["raceTween"].pause();
                        }
                    } */

                    pauseAllDelayedCalls();
                    setPageBackground("bg-blue");
                    this.pauseSounds();
                    if (!this.areYouSureWindow) this.areYouSureWindow = new screen.AreYouSureWindow(this.scene, () => {
                        this.remove(this.areYouSureWindow);
                        this.destroyGameplay();
                        this.showInstructionPage();
                    }, () => {
                        this.remove(this.areYouSureWindow);
                        this.unpauseSounds();
                        resumeAllDelayedCalls();

                        /* for (let j = 0; j < this.cars.length; j++) {
                            if (this.cars[j]["raceTween"]) {
                                this.cars[j]["raceTween"].resume();
                            }
                        } */

                        setPageBackground("bg-australia");
                    });
                    this.add(this.areYouSureWindow);
                }
                setLettersInputEnabled(enabled) {
                    if (enabled) {
                        for (let hc of this.cars) {
                            hc["bg"].setInteractive({ cursor: 'pointer' });
                        }
                    }
                    else {
                        for (let hc of this.cars) {
                            hc["bg"].disableInteractive();
                        }
                    }
                }
                pauseSounds() {
                    if (this.correctAudio)
                        this.correctAudio.pause();
                    if (this.bgMusic)
                        this.bgMusic.pause();
                }
                unpauseSounds() {
                    if (this.correctAudio)
                        this.correctAudio.resume();
                    if (this.bgMusic)
                        this.bgMusic.resume();
                }
                destroyGameplay() {
                    this.setLettersInputEnabled(false);
                    this.remove(this.gameplayContainer);
                    this.scene.sound.stopAll();
                    destroyAllDelayedCalls();
                }
            }
            screen.GameplayScreen = GameplayScreen;
        })(screen = sh.screen || (sh.screen = {}));
    })(sh || (sh = {}));
    (function (sh) {
        var screen;
        (function (screen) {
            class InstructionPage extends Phaser.GameObjects.Container {
                constructor(scene, onPlayClick, onSndClick) {
                    super(scene);
                    this._instructionPage = new Phaser.GameObjects.Image(this.scene, 0 - 105, 0 - 48, 'Instructions page  ALL ACTIVITY  TITLEs');
                    this._instructionPage.setOrigin(0, 0);
                    this._instructionPage.setInteractive();

                    this._instructionPageTitle = this.scene.add.text(475, 110, sh.App.json.instructionTitle ?? 'Farm', {
                        "fontFamily": "Kids Rock DEMO",
                        "fontSize": 45,
                        "color": "#43425D",
                        "align": 'center'
                    });
                    this._instructionPageTitle.setOrigin(0.5, 0.5);
                    window['this._instructionPageTitle'] = this._instructionPageTitle;
                    this._instructionPageTitle.setStroke('#ffffff', 5);
                    //  Apply the gradient fill.
                    const gradient = this._instructionPageTitle.context.createLinearGradient(0, 0, 0, this._instructionPageTitle.height);
                    gradient.addColorStop(0, '#eeef67');
                    gradient.addColorStop(0.55, '#e98c2c');
                    gradient.addColorStop(1, '#91301a');
                    this._instructionPageTitle.setFill(gradient);

                    this._btnPlay = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2, 480 - 50, 'btnPLAY1');
                    this._btnPlay.setInteractive({ cursor: 'pointer' });
                    this._btnPlay.once('pointerup', onPlayClick);
                    setupButtonTextureBased(this._btnPlay, 'btnPLAY1', 'btnPLAY2');
                    this.instrTxt = this.scene.add.text(game.scale.width / 2, game.scale.height / 2, "Lazy Goose is too lazy to harvest \n the melons. Help him pick the \n right melon.", {
                        "fontFamily": "Kids Rock DEMO",
                        "fontSize": 30,
                        "lineSpacing": 15,
                        "color": "#43425D",
                        "align": 'center'
                    });
                    this.instrTxt.setOrigin(0.5, 0.5);
                    this._btnSoundInstruction = new Phaser.GameObjects.Image(this.scene, 800 - 105, 156 - 50, 'Sound');
                    this._btnSoundInstruction.setInteractive({ cursor: 'pointer' });
                    this._btnSoundInstruction.on('pointerup', onSndClick);
                    this._btnSoundInstruction["defScale"] = this._btnSoundInstruction.scale;
                    setupButtonTextureBased(this._btnSoundInstruction, 'Sound', 'Sound HOVER EFFECT');
                    this.add(this._instructionPage);
                    this.add(this._instructionPageTitle);
                    this.add(this.instrTxt);
                    this.add(this._btnPlay);
                    this.add(this._btnSoundInstruction);
                }
            }
            screen.InstructionPage = InstructionPage;
        })(screen = sh.screen || (sh.screen = {}));
    })(sh || (sh = {}));
    (function (sh) {
        var screen;
        (function (screen) {
            class TryAgainWindow extends Phaser.GameObjects.Container {
                constructor(scene, onBack, onReplay) {
                    super(scene);
                    this.music = null;
                    this.setPosition(-106, -48);
                    this._bg = new Phaser.GameObjects.Image(this.scene, 0, 0, 'Try again page');
                    this._bg.setOrigin(0, 0);
                    this._bg.setInteractive();
                    this._star = new Phaser.GameObjects.Image(this.scene, 400, 415, 'Break Star');
                    this._btnBack = new Phaser.GameObjects.Image(this.scene, 600, 580, 'btnBACK1');
                    this._btnReplay = new Phaser.GameObjects.Image(this.scene, 765, 580, 'btnReplay1');
                    this.totalScoreTxt = this.scene.add.text(850, 355, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 35,
                        "color": "#F49F1C",
                        "align": 'center',
                        'stroke': '#70451A',
                        'strokeThickness': 6
                    });
                    this.totalScoreTxt.setOrigin(0.5, 0.5);
                    let grd = this.totalScoreTxt.context.createLinearGradient(0, 0, 0, this.totalScoreTxt.height);
                    grd.addColorStop(0, '#FFFF00');
                    grd.addColorStop(1, '#C17316');
                    this.totalScoreTxt.setFill(grd);
                    this.starScoreTxt = this.scene.add.text(635, 431, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 24,
                        "color": "#FFFFFF",
                        "align": 'center'
                    });
                    this.starScoreTxt.setOrigin(0.5, 0.5);
                    this.add([
                        this._bg,
                        this._star,
                        this._btnBack,
                        this._btnReplay,
                        this.totalScoreTxt,
                        this.starScoreTxt
                    ]);
                    this._btnBack.setInteractive({ cursor: 'pointer' });
                    this._btnBack.on('pointerup', () => {
                        onBack(this._btnBack);
                        angularComponentRef.backToMenu();
                        // if (this.music) {
                        //     this.music.stop();
                        // }
                    });
                    setupButtonTextureBased(this._btnBack, 'btnBACK1', 'btnBACK2');
                    this._btnReplay.setInteractive({ cursor: 'pointer' });
                    this._btnReplay.once('pointerup', () => {
                        onReplay(this._btnReplay);
                        if (this.music) {
                            this.music.stop();
                        }
                    });
                    setupButtonTextureBased(this._btnReplay, 'btnReplay1', 'btnReplay2');
                }
                show(score, starScore) {
                    this._star.scale = 1.25;
                    this.scene.tweens.add({
                        targets: this._star,
                        "scale": 1,
                        duration: 500,
                        ease: Phaser.Math.Easing.Back.Out
                    });
                    this.totalScoreTxt.text = '';//String(window.angularComponentRef.component.userInfo.totalScore);
                    this.starScoreTxt.text = String(0);
                    this.music = this.scene.sound.add("Fail - close one");
                    this.music.play();
                }
            }
            screen.TryAgainWindow = TryAgainWindow;
        })(screen = sh.screen || (sh.screen = {}));
    })(sh || (sh = {}));
}

function destroyFarmGame() {
    if (game) {
        game.destroy();
    }
}

var game;
var sh;
function jumpingKangaroo(json) {
    /**
     * @author Roman Parada
     * This class is created to fix overlapping of bottom part of canvas by navigation bar in iOS.
     * It make a delayed resize of the canvas (like Phaser-3 FIT methods does) and it overrides Phaser-3 input window to Phaser-3 core transform methods
     *
     * How to use:
     * Just call the code line below in Boot scene's init() method of your project:
     * new FitScaleManager(this.game).setup();
     */
    class FitScaleManager {
        constructor(game) {
            this.doResize = () => {
                let scale = this.calculateScale();
                let newCanvasWidth = this.phaserScaleManager.width * scale;
                let newCanvasHeight = this.phaserScaleManager.height * scale;
                this.canvasStyle.width = newCanvasWidth + 'px';
                this.canvasStyle.height = newCanvasHeight + 'px';
                this.canvasStyle.marginLeft = (window.innerWidth - newCanvasWidth) / 2 + 'px';
                this.canvasStyle.marginTop = (window.innerHeight - newCanvasHeight) / 2 + 'px';
            };
            this.game = game;
            this.canvasStyle = this.game.canvas.style;
            this.phaserScaleManager = this.game.scale;
        }
        static detectBestScaleMode() {
            let iOS = /iPad|iPhone|iPod/.test(navigator.platform || "");
            let isAndroid = window.navigator.userAgent.toLowerCase().indexOf("android") > -1;
            return iOS || isAndroid ? Phaser.Scale.FIT : Phaser.Scale.NONE;
        }
        ;
        /**
         * Just call this method once in Boot scene's init() method
         */
        setup() {
            this.phaserScaleManager.addListener(Phaser.Scale.Events.RESIZE, this.onResize, this);
            this.overridePhaserTransformMethods();
            this.onResize();
        }
        calculateScale() {
            if (game.scale.scaleMode === Phaser.Scale.NONE)
                return 1;
            return Math.min(window.innerWidth / this.phaserScaleManager.width, window.innerHeight / this.phaserScaleManager.height);
        }
        overridePhaserTransformMethods() {
            this.game.scale.transformX = (pageX) => {
                return (pageX - parseInt(this.canvasStyle.marginLeft.split("px")[0])) / this.calculateScale();
            };
            this.game.scale.transformY = (pageY) => {
                return (pageY - parseInt(this.canvasStyle.marginTop.split("px")[0])) / this.calculateScale();
            };
        }
        onResize() {
            setTimeout(this.doResize, FitScaleManager.RESIZE_DELAY);
        }
    }
    FitScaleManager.RESIZE_DELAY = 500;

    (function (sh) {
        class App extends Phaser.Game {
            constructor(json) {
                App.json = json;
                // console.log(App.json);

                let config = {
                    type: Phaser.AUTO,
                    width: App.CANVAS_WIDTH,
                    height: App.CANVAS_HEIGHT,
                    parent: 'game-container',
                    dom: {
                        createContainer: false
                    },
                    scale: {
                        mode: FitScaleManager.detectBestScaleMode(),
                        autoCenter: Phaser.Scale.CENTER_BOTH
                    },
                    transparent: true,
                    scene: {
                        create: () => {
                            this.scene.add('Boot', sh.scene.Boot, true);
                        }
                    }
                };
                super(config);
            }
        }
        App.CANVAS_WIDTH = 980;
        App.CANVAS_HEIGHT = 600;
        sh.App = App;
    })(sh || (sh = {}));

    game = new sh.App(json);

    var delayedCalls = [];
    function delayedCall(delay, callback, args, callbackScope) {
        let scene = game.scene.getAt(0);
        if (scene) {
            let dc = scene.time.delayedCall(delay, callback, args, callbackScope);
            delayedCalls.push(dc);
            return dc;
        }
        let t = setTimeout(callback, delay);
        delayedCalls.push(t);
        return t;
    }

    function pauseAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.paused = true;
            }
        }
    }

    function resumeAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.paused = false;
            }
        }
    }

    function destroyAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.remove(false);
            }
            else {
                clearTimeout(dc);
            }
        }
        delayedCalls = [];
    }

    function setPageBackground(bg) {
        // document.querySelector("html").style.backgroundImage = "url(assets/games/jumping-kangaroo/imgs/" + bg + ".jpg)";
    }

    function setupButton(btn, frame) {
        btn.on('pointerdown', () => { btn.setFrame(frame + '_hover' + '0000'); });
        btn.on('pointerover', () => { btn.setFrame(frame + '_hover' + '0000'); game.scene.getAt(0).sound.add("button hover").play(); });
        btn.on('pointerout', () => { btn.setFrame(frame + '0000'); });
        btn.on('pointerup', () => { btn.setFrame(frame + '0000'); game.scene.getAt(0).sound.add('activity selection - button selection').play(); });
    }

    function setupButtonTextureBased(btn, texture, hoverTexture, downTexture) {
        btn.on('pointerdown', () => { btn.setTexture(downTexture ?? hoverTexture); });
        btn.on('pointerover', () => { btn.setTexture(hoverTexture); game.scene.getAt(0).sound.add("button hover").play(); });
        btn.on('pointerout', () => { btn.setTexture(texture); });
        btn.on('pointerup', () => { btn.setTexture(texture); game.scene.getAt(0).sound.add('activity selection - button selection').play(); });
    }

    (function (sh) {
        var core;
        (function (core) {
            class Gameplay {
                constructor() {
                    this.currentRound = 0;
                    this.currentLetter = 0;
                    this.correctAnswersCount = 0;
                    this.wrongAnswersCount = 0;
                    this.correctAnswersCountThisRound = 0;
                    this.wrongAnswersCountThisRound = 0;
                    this.reset();
                    let json = game.cache.json.get('gameplay');
                    this.wrongAnswersToLose = json["wrongAnswersToLose"];
                    this.numberOfQuestionsPerRound = json["numberOfQuestionsPerRound"];
                    this.lettersConfig = JSON.parse(JSON.stringify(json["lettersConfig"]));
                    this.rounds = JSON.parse(JSON.stringify(json["rounds"]));
                    this.numberOfRounds = json["numberOfRounds"] ?? this.rounds.length;
                    this.useImages = Boolean(game.cache.json.get('gameplay')["useImages"]);
                }
                setupCallbacks(onComplete, onLose) {
                    this.onComplete = onComplete;
                    this.onLose = onLose;
                }
                onLetterChosen(forceNewRound) {
                    if (forceNewRound || this.isNewRound()) {
                        return this.nextRound();
                    }
                    return false;
                }
                nextRound() {
                    this.correctAnswersCountThisRound = 0;
                    this.wrongAnswersCountThisRound = 0;
                    this.currentRound++;
                    if (this.isRoundsComplete()) {
                        this.onComplete(this.correctAnswersCount, this.correctAnswersCount);
                        return true;
                    }

                    return false;
                }
                getCorrectLetterName() {
                    return this.rounds[this.currentRound]['correctLetterName'];
                }
                isCorrectLetterAudioQuestionEnable() {
                    return this.rounds[this.currentRound]['audioQuestionEnable'];
                }
                getCorrectAudioKey() {
                    return this.lettersConfig[this.getCorrectLetterName()]['correctAudioKey'];
                }
                getLetterSoundSfxAudioKey(letter) {
                    return "Q-" + letter;
                }
                getCorrectAndLetterSoundSfxAudioKey() {
                    return "Q-" + this.getCorrectLetterName();
                }
                onCorrectAnswer() {
                    this.correctAnswersCountThisRound++;
                    this.correctAnswersCount++;
                    return this.onLetterChosen();
                }
                onWrongAnswer(forceNewRound) {
                    this.wrongAnswersCountThisRound++;
                    this.wrongAnswersCount++;
                    if (this.wrongAnswersCount >= this.wrongAnswersToLose) {
                        this.onLose(this.correctAnswersCount, this.correctAnswersCount);
                        return true;
                    }
                    else {
                        this.onLetterChosen(forceNewRound);
                    }
                    return false;
                }

                getMaxTotalAnswersCount() {
                    return this.wrongAnswersToLose + this.numberOfRounds - 1;
                }

                getCurrentTotalAnswersCount() {
                    return this.correctAnswersCount + this.wrongAnswersCount;
                }
                isNewRound() {
                    return this.correctAnswersCountThisRound >= 1 || (this.correctAnswersCountThisRound + this.wrongAnswersCountThisRound) === 3 || (this.correctAnswersCountThisRound + this.wrongAnswersCountThisRound) === 0;
                }
                isRoundsComplete() {
                    return this.currentRound >= this.numberOfRounds && this.wrongAnswersCount < this.wrongAnswersToLose;
                }
                reset() {
                    this.currentRound = 0;
                    this.correctAnswersCount = 0;
                    this.wrongAnswersCount = 0;
                }
                getCurrentRoundLetters() {
                    return this.rounds[this.currentRound]["letters"];
                }
            }
            core.Gameplay = Gameplay;
        })(core = sh.core || (sh.core = {}));
    })(sh || (sh = {}));

    (function (sh) {
        var scene;
        (function (scene) {
            class Boot extends Phaser.Scene {
                init() {
                    this.game.scale.transformX = (pageX) => {
                        let offsetLeft = 0;
                        let parentElement = game.canvas.parentElement;
                        while (parentElement) {
                            if (parentElement.offsetLeft) {
                                offsetLeft = parentElement.offsetLeft;
                                break;
                            }
                            parentElement = parentElement.parentElement;
                        }
                        return (pageX - offsetLeft) * this.game.scale.displayScale.x;
                    };
                    this.game.scale.transformY = (pageY) => {
                        let offsetTop = 0;
                        let parentElement = game.canvas.parentElement;
                        while (parentElement) {
                            if (parentElement.offsetTop) {
                                offsetTop = parentElement.offsetTop;
                                break;
                            }
                            parentElement = parentElement.parentElement;
                        }
                        return (pageY - offsetTop) * this.game.scale.displayScale.y;
                    };
                }
                create() {
                    game.scene.remove('Boot');
                    game.scene.add('Preloader', sh.scene.Preloader, true);
                }
            }
            scene.Boot = Boot;
        })(scene = sh.scene || (sh.scene = {}));
    })(sh || (sh = {}));

    (function (sh) {
        var scene;
        (function (scene) {
            var Gameplay = sh.core.Gameplay;
            class MainScene extends Phaser.Scene {
                create() {
                    this.gameplay = new Gameplay();
                    this.gameplayScreen = new sh.screen.GameplayScreen(this, this.gameplay);
                    this.children.add(this.gameplayScreen);
                    this.gameplayScreen.showInstructionPage();
                }
            }
            scene.MainScene = MainScene;
        })(scene = sh.scene || (sh.scene = {}));
    })(sh || (sh = {}));

    (function (sh) {
        var scene;
        (function (scene) {
            class Preloader extends Phaser.Scene {
                preload() {
                    if (typeof sh.App.json == "string") this.load.json('gameplay', sh.App.json); else this.game.cache.json.add('gameplay', sh.App.json);
                }
                create() {
                    let json = game.cache.json.get('gameplay');
                    let lettersConfig = json["lettersConfig"];

                    let rounds = json["rounds"];

                    for (let letterName in lettersConfig) {
                        if (json["useImages"]) this.load.image(letterName, "assets/games/jumping-kangaroo/imgs/letters/" + letterName + ".png");
                    }

                    for (var i = 0; i < rounds.length; i++) {
                        var letters = rounds[i]['letters'];

                        for (var a = 0; a < letters.length; a++) {
                            var letter = letters[a];
                            this.load.audio(letter, "assets/games/jumping-kangaroo/sound/mp3/letters/" + letter + ".mp3");
                            this.load.audio("Q-" + letter, "assets/games/jumping-kangaroo/sound/mp3/letters/Sounds of the letters/" + letter + ".mp3");
                        }
                    }

                    let progressTxt = this.add.text(game.scale.width / 2, game.scale.height / 2 + 50, "", {
                        "fontFamily": "QuranErafont",
                        "fontSize": 25,
                        "color": "#333333",
                        "align": 'center'
                    });
                    progressTxt.setOrigin(0.5, 0.5);
                    this.load.pack('preloader', 'assets/games/jumping-kangaroo/pack.json');
                    this.load.on('progress', (value) => {
                        progressTxt.text = Math.ceil(value * 100) + "%";
                    }, this);
                    this.load.on('complete', () => {
                        this.nextScene();
                    });
                    this.load.start();
                }
                static playAnim(animKey, sprite, onComplete = null) {
                    let mainScene = game.scene.getScene('ScreenMain');
                    let data = Preloader.ANIMS_DATA[animKey];
                    if (!mainScene.anims.exists(animKey)) {
                        mainScene.anims.create({
                            key: animKey,
                            frames: mainScene.anims.generateFrameNames(data['atlas'], {
                                start: data['start'], end: data['end'], zeroPad: data['padNum'],
                                prefix: data['prefix'], suffix: ''
                            }),
                            frameRate: data['frameRate'],
                            repeat: data['repeat']
                        });
                    }
                    if (sprite.anims.currentAnim) {
                        sprite.anims.currentAnim.off('complete');
                    }
                    sprite.anims.stop();
                    // sprite.setTexture(data['atlas']);
                    sprite.play(animKey);
                    sprite.anims.currentAnim.once('complete', () => {
                        if (onComplete)
                            onComplete();
                    });
                    return sprite;
                }
                nextScene() {
                    game.scene.remove('Preloader');
                    game.scene.add('ScreenMain', sh.scene.MainScene, true);
                }
            }
            Preloader.ANIMS_DATA = {
                'idle': {
                    'start': 1,
                    'end': 32,
                    'padNum': 2,
                    'prefix': 'Kang_idle_2_000',
                    'repeat': -1,
                    'frameRate': 30,
                    'atlas': 'idle-atlas'
                },
                'no': {
                    'start': 1,
                    'end': 32,
                    'padNum': 2,
                    'prefix': 'Kang_No_2_000',
                    'repeat': 0,
                    'frameRate': 22,
                    'atlas': 'no-atlas'
                },
                'yes': {
                    'start': 1,
                    'end': 90,
                    'padNum': 2,
                    'prefix': 'Kangoro New00',
                    'repeat': 0,
                    'frameRate': 30,
                    'atlas': 'yes-atlas'
                },
                'jump': {
                    'start': 0,
                    'end': 51,//61,
                    'padNum': 2,
                    'prefix': 'Kangoro Jump_4',
                    'repeat': 0,
                    'frameRate': 24,
                    'atlas': 'jumping-atlas'
                }
            };
            scene.Preloader = Preloader;
        })(scene = sh.scene || (sh.scene = {}));
    })(sh || (sh = {}));
    (function (sh) {
        var screen;
        (function (screen) {
            class AreYouSureWindow extends Phaser.GameObjects.Container {
                constructor(scene, onYes, onNo) {
                    super(scene);
                    this._areYouSurePage = new Phaser.GameObjects.Image(this.scene, -105, 0 - 48, 'Exit warning');
                    this._areYouSurePage.setOrigin(0, 0);
                    this._areYouSurePage.setInteractive();
                    this._btnSureYes = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2 - 95, 485 - 50, 'btnYES1');
                    this._btnSureYes.setInteractive({ cursor: 'pointer' });
                    this._btnSureYes.on('pointerup', () => {
                        onYes;
                        angularComponentRef.backToMenu();
                    });
                    var modalTextStyle = {
                        backgroundColor: 'transparent',
                        stroke: '#ffffff',
                        strokeThickness: 2,
                        lineSpacing: 15,
                        fontFamily: 'Kids Rock DEMO',
                        fontSize: 27,
                        color: '#43425d',
                        wordWrap: true,
                        align: 'center'
                    };
                    var modalText = this.scene.add.text(game.scale.width / 2 + 12, game.scale.height / 2, "Your progress in this activity will not be saved. \n Are you sure you want to exit? ", modalTextStyle);
                    modalText.setOrigin(0.5, 0.5);

                    setupButtonTextureBased(this._btnSureYes, 'btnYES1', 'btnYES2');
                    this._btnSureNo = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2 + 95, 485 - 50, 'btnNO1');
                    this._btnSureNo.setInteractive({ cursor: 'pointer' });
                    this._btnSureNo.on('pointerup', onNo);
                    setupButtonTextureBased(this._btnSureNo, 'btnNO1', 'btnNO2');
                    this.add(this._areYouSurePage);
                    this.add(this._btnSureYes);
                    this.add(this._btnSureNo);
                    this.add(modalText);
                }
            }
            screen.AreYouSureWindow = AreYouSureWindow;
        })(screen = sh.screen || (sh.screen = {}));
    })(sh || (sh = {}));

    (function (sh) {
        var screen;
        (function (screen) {
            class CompleteWindow extends Phaser.GameObjects.Container {
                constructor(scene, onBack, onReplay, onNext) {
                    super(scene);
                    this.music = null;
                    this.setPosition(-104.5, -48);
                    this._bgComplete = new Phaser.GameObjects.Image(this.scene, 0, 0, 'Completion page LATEST UPDATED');
                    this._bgComplete.setOrigin(0, 0);
                    this._bgComplete.setInteractive();
                    this._cup = new Phaser.GameObjects.Image(this.scene, 400, 410, 'Trophy');
                    this._btnBack = new Phaser.GameObjects.Image(this.scene, 570, 570, 'btnBACK1');
                    this._btnReplay = new Phaser.GameObjects.Image(this.scene, 720, 570, 'btnReplay1');
                    this._btnNext = new Phaser.GameObjects.Image(this.scene, 870, 570, 'btnNEXT1');
                    let _CollectedPoints = new Phaser.GameObjects.Image(this.scene, 620, 440, 'Collected Points');
                    this.totalScoreTxt = this.scene.add.text(845, 352, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 35,
                        "color": "#F49F1C",
                        "align": 'center',
                        'stroke': '#70451A',
                        'strokeThickness': 6
                    });
                    this.totalScoreTxt.setOrigin(0.5, 0.5);
                    let grd = this.totalScoreTxt.context.createLinearGradient(0, 0, 0, this.totalScoreTxt.height);
                    grd.addColorStop(0, '#FFFF00');
                    grd.addColorStop(1, '#C17316');
                    this.totalScoreTxt.setFill(grd);
                    this.starScoreTxt = this.scene.add.text(648, 433, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 24,
                        "color": "#FFFFFF",
                        "align": 'center'
                    });
                    this.starScoreTxt.setOrigin(0.5, 0.5);
                    this.add([
                        this._bgComplete,
                        _CollectedPoints,
                        this._cup,
                        this._btnBack,
                        this._btnReplay,
                        this._btnNext,
                        this.totalScoreTxt,
                        this.starScoreTxt
                    ]);
                    this._btnBack.setInteractive({ cursor: 'pointer' });
                    this._btnBack.on('pointerup', () => {
                        onBack(this._btnBack);
                        angularComponentRef.backToMenu();
                        // if (this.music) {
                        //     this.music.stop();
                        // }
                    });
                    setupButtonTextureBased(this._btnBack, 'btnBACK1', 'btnBACK2');
                    this._btnReplay.setInteractive({ cursor: 'pointer' });
                    this._btnReplay.once('pointerup', () => {
                        onReplay(this._btnReplay);
                        if (this.music) {
                            this.music.stop();
                        }
                    });
                    setupButtonTextureBased(this._btnReplay, 'btnReplay1', 'btnReplay2');
                    this._btnNext.setInteractive({ cursor: 'pointer' });
                    this._btnNext.on('pointerup', () => {
                        onNext(this._btnNext);
                        window.angularComponentRef.nextActivity()
                    });
                    setupButtonTextureBased(this._btnNext, 'btnNEXT1', 'btnNEXT2');
                }
                show(score, starScore) {
                    window.angularComponentRef.gameFinish({ score, starScore })
                    this._cup.scale = 1.25;
                    this.scene.tweens.add({
                        targets: this._cup,
                        "scale": 1,
                        duration: 500,
                        ease: Phaser.Math.Easing.Back.Out
                    });
                    this.totalScoreTxt.text = String(window.angularComponentRef.component.userInfo.totalScore);
                    this.starScoreTxt.text = String(starScore);
                    // let music = this.scene.sound.add("viktory");
                    this.music = this.scene.sound.add("Activity completion fantastic");
                    this.music.play();
                }
            }
            screen.CompleteWindow = CompleteWindow;
        })(screen = sh.screen || (sh.screen = {}));
    })(sh || (sh = {}));

    (function (sh) {
        var screen;
        (function (screen) {
            class GameplayScreen extends Phaser.GameObjects.Container {
                constructor(scene, gameplay) {
                    super(scene);
                    this.carsPositionsOutScreen = [{ x: 500 - 95 + 180, y: -300 }, { x: 500 - 95, y: -300 }, { x: 500 - 95 - 180, y: -300 }];
                    this.carsPositions = [{ x: 500 - 95 + 25 + 180, y: 400 }, { x: 500 - 95, y: 400 }, { x: 500 - 95 - 25 - 180, y: 400 }];
                    this.bgMusic = null;
                    this.correctAudio = null;
                    this.wfsnd = null;
                    this.showCompleteWindow = (score, starScore) => {
                        let completeWindow = new screen.CompleteWindow(this.scene, (target) => {
                            this.playBtnClickAnim(target);
                        }, (target) => {
                            this.playBtnClickAnim(target);
                            this.destroyGameplay();
                            this.remove(completeWindow);
                            this.showInstructionPage();
                        }, (target) => {
                            this.playBtnClickAnim(target);
                        });
                        this.setLettersInputEnabled(false);
                        delayedCall(4500, () => {
                            setPageBackground("bg-blue");
                            this.add(completeWindow);
                            completeWindow.show(score, starScore);
                            if (this.bgMusic) this.bgMusic.stop();
                        });
                    };
                    this.showLoseWindow = (score, starScore) => {
                        let tryAgainWindow = new screen.TryAgainWindow(this.scene, (target) => {
                            this.playBtnClickAnim(target);
                        }, (target) => {
                            this.playBtnClickAnim(target);
                            this.destroyGameplay();
                            this.remove(tryAgainWindow);
                            this.showInstructionPage();
                        });
                        this.setLettersInputEnabled(false);
                        delayedCall(2500, () => {
                            setPageBackground("bg-blue");
                            this.add(tryAgainWindow);
                            tryAgainWindow.show(score, starScore);
                            if (this.bgMusic) this.bgMusic.stop();
                        });
                    };
                    this.gameplay = gameplay;
                    window["t"] = this;
                }
                createHexagons() {
                    if (this.contentContainer && this.contentContainer.parentContainer) {
                        this.contentContainer.parentContainer.remove(this.contentContainer);
                    }
                    this.contentContainer = new Phaser.GameObjects.Container(this.scene, 0, 0);
                    this.gameplayContainer.addAt(this.contentContainer, 1);
                    window['this.contentContainer'] = this.contentContainer;

                    this.scene.sound.add('Text from earth popping up').play();

                    this.speakers = [];
                    let _i = 0;
                    var jarr = [1, 2, 3];
                    for (let p of this.carsPositions) {
                        let hc = new Phaser.GameObjects.Container(this.scene, this.carsPositions[_i]['x'], this.carsPositions[_i]['y']);
                        var j = Phaser.Utils.Array.RemoveRandomElement(jarr);
                        let h = new Phaser.GameObjects.Image(this.scene, 0, 150, 'speaker');
                        h.setOrigin(0.5, 1);
                        hc.add(h);
                        hc["bg"] = h;

                        hc["selector"] = new Phaser.GameObjects.Image(this.scene, 70, -20, 'greenSelector');
                        hc.add(hc["selector"]);

                        hc["defX"] = p['x'];
                        hc["defY"] = p['y'];
                        this.speakers.push(hc);
                        this.contentContainer.add(hc);
                        hc['index'] = _i;

                        let playBtn = new Phaser.GameObjects.Image(this.scene, -16, 104, 'btnPlaySnd');
                        hc.add(playBtn);
                        hc["playBtn"] = playBtn;
                        setupButtonTextureBased(playBtn, 'btnPlaySnd', 'btnPlaySndHover');
                        playBtn.on('pointerup', () => {
                            for (let _hc of this.speakers) {
                                if (_hc["playBtn"]["sound"]) _hc["playBtn"]["sound"].stop();
                            }

                            if (!playBtn["sound"]) {
                                playBtn["sound"] = this.scene.sound.add(this.gameplay.getLetterSoundSfxAudioKey(hc["letter"]));
                            }
                            playBtn["sound"].play();

                            if (this.gameplay.correctAnswersCount == 0) {
                                if (!hc["handIcon"] || !hc["handIcon"].visible) return;

                                hc['handIcon'].visible = false;

                                playBtn["sound"].once('complete', () => {
                                    if (hc['index'] < this.speakers.length - 1) {
                                        var nextSpeaker = this.speakers[hc['index'] + 1];
                                        nextSpeaker["handIcon"].visible = true;
                                        nextSpeaker["playBtn"].setInteractive({ cursor: 'pointer' });
                                    } else {
                                        for (let _hc of this.speakers) {
                                            _hc["selector"].visible = true;
                                        }
                                        this.scene.sound.add('Movement fx').play();
                                    }
                                });
                            } else {
                                this.speakers[hc['index']]["selector"].visible = true;
                                this.scene.sound.add('Movement fx').play();
                            }
                        });

                        if (this.gameplay.correctAnswersCount == 0) {
                            hc["selector"].visible = false;

                            let handIcon = new Phaser.GameObjects.Image(this.scene, 30, 130, 'Hand Icon');
                            hc.add(handIcon);
                            hc["handIcon"] = handIcon;
                            this.scene.tweens.add({
                                targets: handIcon,
                                angle: -5,
                                scaleY: 0.95,
                                scaleX: 0.95,
                                duration: 500,
                                yoyo: true,
                                repeat: -1,
                            });

                            if (_i == 0) {
                                handIcon.visible = false;
                                delayedCall(5200, () => {
                                    handIcon.visible = true;
                                    playBtn.setInteractive({ cursor: 'pointer' });
                                });
                            } else {
                                handIcon.visible = false;
                            }
                        } else {
                            hc["selector"].visible = false;
                            playBtn.setInteractive({ cursor: 'pointer' });
                        }

                        _i++;
                    }
                    window['this.cars'] = this.speakers;

                    this.questionContainer = new Phaser.GameObjects.Container(this.scene, 490 - 95, -200); window['this.questionContainer'] = this.questionContainer;
                    let question_box = new Phaser.GameObjects.Image(this.scene, 0, 0, 'question-box');
                    question_box.setOrigin(0.5, 1);
                    this.questionContainer.add(question_box);

                    if (this.gameplay.useImages) {
                        this.questionWordText = new Phaser.GameObjects.Image(this.scene, -8, -100, this.gameplay.getCorrectLetterName());
                    } else {
                        this.questionWordText = this.scene.add.text(-8, -100, this.gameplay.getCorrectLetterName(), {
                            "fontFamily": "QuranErafont",
                            "fontSize": 65,
                            "color": "#333333",
                            "align": 'center'
                        });
                        this.questionWordText.setOrigin(0.5, 0.5);
                        this.questionWordText.setPadding({ left: 0, right: 0, top: 65, bottom: 65 });
                    }
                    if (this.questionWordText.width > 375) this.questionWordText.setScale(375 / this.questionWordText.width);
                    window['this.questionWordText'] = this.questionWordText;
                    this.questionContainer.add(this.questionWordText);
                    this.contentContainer.add(this.questionContainer);
                    this.scene.tweens.add({
                        targets: this.questionContainer,
                        y: 200,
                        duration: 400,
                        delay: 500
                    });

                    this.kangarooContainer = new Phaser.GameObjects.Container(this.scene, 840, 560);
                    this.contentContainer.add(this.kangarooContainer);

                    this.shadow = new Phaser.GameObjects.Image(this.scene, -20, -15, 'shadow');
                    this.kangarooContainer.add(this.shadow); window['this.shadow'] = this.shadow;

                    this.kangaroo = this.scene.add.sprite(0, 0, "idle-atlas");
                    window['this.kangaroo'] = this.kangaroo;
                    // this.kangaroo.setPosition(0, 0);
                    this.kangaroo["defY"] = this.kangaroo.y;
                    this.kangaroo.setOrigin(0.5, 1);
                    this.kangarooContainer.add(this.kangaroo);
                    window['this.ship'] = this.kangaroo;

                    //initial jump in
                    // this.kangarooContainer.x += 275;
                    sh.scene.Preloader.playAnim('idle', this.kangaroo);
                    this.kangaroo.setOrigin(0.5, 1);
                    this.kangaroo.setPosition(0, 0);
                    /* this.scene.tweens.add({
                        targets: this.kangarooContainer,
                        duration: 500,
                        delay: 700,
                        x: this.kangarooContainer.x - 275
                    }); */
                    /* let _y = this.kangaroo.y;
                    this.scene.tweens.add({
                        targets: this.kangaroo,
                        duration: 400,
                        angle: -7,
                        scaleX: 1.05,
                        scaleY: 0.95,
                        delay: 700,
                        y: _y - 100,
                        ease: Phaser.Math.Easing.Cubic.Out,
                        onComplete: () => {
                            this.scene.tweens.add({
                                targets: this.kangaroo,
                                angle: 0,
                                duration: 200,
                                y: _y,
                                ease: Phaser.Math.Easing.Cubic.Out,
                                onComplete: () => {
                                    sh.scene.Preloader.playAnim('idle', this.kangaroo);
                                    this.kangaroo.setOrigin(0.5, 1);
                                    this.kangaroo.setPosition(0, 0);
                                }
                            });
                        }
                    }); */
                }
                createLetters() {
                    this.letters = this.gameplay.getCurrentRoundLetters();
                }
                showGameplay() {
                    this.isLost = false;
                    setPageBackground("bg-australia");
                    this.bgMusic = this.scene.sound.add("bg_sound");
                    this.bgMusic.play();
                    this.bgMusic.loop = true;
                    this.gameplay.reset();
                    this.bgContainer = new Phaser.GameObjects.Container(this.scene);
                    this._gameStage = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2 - 130, game.scale.height / 2, 'bg'); window['this._gameStage'] = this._gameStage;
                    this._gameStage.setOrigin(0.5, 0.5);
                    this._gameStage.setInteractive();
                    this._gameStage1 = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2 - 130 - this._gameStage.width, game.scale.height / 2, 'bg'); window['this._gameStage'] = this._gameStage;
                    this._gameStage1.setOrigin(0.5, 0.5);
                    this._gameStage1.setInteractive();
                    this.bgContainer.add(this._gameStage);
                    this.bgContainer.add(this._gameStage1);
                    window['this.bgContainer'] = this.bgContainer;
                    this._btnClose = new Phaser.GameObjects.Image(this.scene, 1025 - 105, 100 - 50, 'x Button');
                    this._btnClose.setInteractive({ cursor: 'pointer' });
                    this._btnClose["defScale"] = this._btnClose.scale;
                    setupButtonTextureBased(this._btnClose, 'x Button', 'x Button HOVER EFFECT');
                    this.gameplayContainer = new Phaser.GameObjects.Container(this.scene);
                    this.addAt(this.gameplayContainer, 0);
                    this.gameplayContainer.add([
                        this.bgContainer,
                        this._btnClose
                    ]);
                    window['this._gameStage'] = this._gameStage;
                    window['this.gameplayContainer'] = this.gameplayContainer;
                    this.createBeehives();
                    this.shuffleOutHexagons();
                    this.gameplay.setupCallbacks(this.showCompleteWindow, this.showLoseWindow);
                }
                createBeehives() {
                    let startX = 55;
                    let startY = 110;
                    let dy = 35;
                    let _BeehiveEmptyArrayPositions = [];
                    for (let i = 0; i < this.gameplay.getMaxTotalAnswersCount(); i++) {
                        _BeehiveEmptyArrayPositions.push({ x: startX, y: startY + i * dy });
                    }
                    this._BeehiveEmptyArray = []; window["_BeehiveEmptyArray"] = this._BeehiveEmptyArray;
                    this._Beehive = [];
                    for (let p of _BeehiveEmptyArrayPositions) {
                        let _BeehiveEmpty = new Phaser.GameObjects.Image(this.scene, p['x'], p['y'], 'Beehive 1 Empty');
                        this._BeehiveEmptyArray.push(_BeehiveEmpty);
                        _BeehiveEmpty.visible = false;
                        let _Beehive = new Phaser.GameObjects.Image(this.scene, p['x'], p['y'], 'Beehive 1');
                        this._Beehive.push(_Beehive);
                    }
                    for (let bea of this._BeehiveEmptyArray) {
                        this.gameplayContainer.add(bea);
                    }
                    for (let bee of this._Beehive) {
                        this.gameplayContainer.add(bee);
                        bee.visible = false;
                    }
                }
                randomizeLettersPosition() {
                    let hx = this.speakers.slice();
                    for (let l of this.letters) {
                        if (hx.length == 0)
                            return;
                        let hc = Phaser.Utils.Array.RemoveRandomElement(hx);
                        hc["letter"] = l;
                    }
                }
                shuffleOutHexagons() {
                    this.bgContainer.x = 260;
                    this.createHexagons();

                    let setLettersInputEnabled = () => {
                        // if (this.correctAudio && this.correctAudio.isPlaying) {
                        delayedCall(/* (this.correctAudio.duration * 0.75) * */ 1000, () => {
                            this.setLettersInputEnabled(true);
                        });
                        // }
                        // else {
                        // this.setLettersInputEnabled(true);
                        // }
                    };

                    if (!this.gameplay.isRoundsComplete()) {
                        let c = this.gameplay.getCurrentTotalAnswersCount();
                        delayedCall(2500, () => {
                            if (this.gameplay.isCorrectLetterAudioQuestionEnable() && c == 0) {
                                this.playCorrectAudio();
                            }
                            setLettersInputEnabled();
                        });
                    }
                    if (this.sfxCarAccelerating) {
                        this.sfxCarAccelerating.stop();
                        this.sfxCarAccelerating = null;
                    }
                    if (this.sfxWrong) {
                        this.sfxWrong.stop();
                        this.sfxWrong = null;
                    }

                    if (!this.gameplay.isRoundsComplete()) {
                        this.createLetters();
                        this.randomizeLettersPosition();
                    }

                    this.setLettersInputEnabled(false);
                    // Phaser.Utils.Array.Shuffle(this.carsPositions);
                    let cars = this.speakers;
                    for (let i = 0; i < cars.length; i++) {
                        let hc = cars[i];
                        hc["defX"] = this.carsPositions[i]["x"];
                        hc["defY"] = this.carsPositions[i]["y"];

                        hc.x = this.carsPositionsOutScreen[i].x;
                        hc.y = this.carsPositionsOutScreen[i].y;
                        this.scene.tweens.killTweensOf(hc);

                        delayedCall(1250, () => this.scene.sound.add('Sound boxes falling').play());

                        this.scene.tweens.add({
                            targets: hc,
                            "x": hc["defX"],
                            delay: i * 425 + 1000,
                            "y": hc["defY"],
                            duration: 400/*  - Math.ceil(Math.random() * 5) * 100 */,
                            ease: Phaser.Math.Easing.Quadratic.In,
                            onComplete: () => { }
                        });
                        this.scene.tweens.add({
                            targets: hc["bg"],
                            scaleY: 0.97,
                            scaleX: 1.03,
                            duration: 400,
                            delay: 1200,
                            yoyo: true,
                            ease: Phaser.Math.Easing.Quadratic.In
                        });
                    }
                    for (let c of cars) this.gameplayContainer.remove(c);
                    this.speakers.sort((c1, c2) => c1.y - c2.y);
                    // for (let c of cars) this.gameplayContainer.add(c);

                    this.createInput();
                }
                shuffleInHexagons() {
                    let positions = this.carsPositions.slice();
                    this.setLettersInputEnabled(false);

                    // delayedCall(600, () => {
                    // this.scene.sound.add('move to centre').play();
                    this.shuffleOutHexagons();
                    // });
                    window['t'] = this;
                }
                playKangorooJumpingOutTheScreen(onComplete) {
                    var s = this.scene.sound.add('Kangaroo jumping forward three times');
                    s.setRate(0.77);
                    delayedCall(700, () => s.play());
                    sh.scene.Preloader.playAnim('jump', this.kangaroo, onComplete);
                    this.kangaroo.setOrigin(0.86, 0.94);
                    this.kangaroo.setPosition(0, 0);
                    this.scene.tweens.add({
                        targets: this.contentContainer,
                        x: 1000,
                        duration: 500,
                        delay: 400 + 1300 + 100
                    });

                    this.scene.tweens.add({
                        targets: this.bgContainer,
                        x: 1505,
                        duration: 500,
                        delay: 400 + 1300 + 100
                    });
                }
                createInput() {
                    for (let hc of this.speakers) {
                        let correctAnswer = hc["letter"] && hc["letter"] == this.gameplay.getCorrectLetterName();
                        hc["selector"].once('pointerup', () => {
                            this.scene.tweens.add({
                                targets: hc["selector"],
                                scaleX: 0.9,
                                scaleY: 0.9,
                                duration: 100,
                                yoyo: true
                            });
                            // if (hc["Wrong Box"].visible) return;
                            // this.playBtnClickAnim(hc);
                            let lost = false;
                            if (correctAnswer) {
                                this.setLettersInputEnabled(false);
                                hc["selector"].setTexture("greenSelectorCorrect");

                                let completed = this.onCorrectAnswer();

                                // sh.scene.Preloader.playAnim('yes', this.kangaroo);
                                // this.kangaroo.setPosition(-3, 40);
                                this.kangaroo.setPosition(-3, 40);
                                delayedCall(450, () => {
                                    if (this.kangarooVoiceYesNo) this.kangarooVoiceYesNo.stop();
                                    this.kangarooVoiceYesNo = this.scene.sound.add('Kangaroo Yes');
                                    this.kangarooVoiceYesNo.play();
                                });
                                delayedCall(1000, () => { this.scene.sound.add('Kangaroo landing sfx').play(); });
                                sh.scene.Preloader.playAnim('yes', this.kangaroo);
                                delayedCall(1050, () => {
                                    this.scene.tweens.add({
                                        targets: this.questionContainer,
                                        y: -200,
                                        duration: 400,
                                        delay: 650
                                    });
                                    this.scene.sound.add('Text from earth popping up').play();
                                });
                                delayedCall(1550, () => {
                                    for (let _sp of this.speakers) {
                                        this.scene.tweens.add({
                                            targets: _sp,
                                            duration: 500,
                                            delay: 250,
                                            alpha: 0
                                        });
                                    }

                                    if (completed) {
                                        if (completed) this.scene.sound.add('Final celebration').play();
                                    } else {
                                        this.playKangorooJumpingOutTheScreen(() => {
                                            this.scene.tweens.add({
                                                targets: this.kangaroo,
                                                angle: 0,
                                                duration: 350,
                                                delay: 1500,
                                                ease: Phaser.Math.Easing.Cubic.Out,
                                                onComplete: () => {
                                                    if (completed) this.scene.sound.add('Final celebration').play();
                                                }
                                            });

                                            delayedCall(completed ? 500 : 250, () => {
                                                if (!completed) {
                                                    this.shuffleInHexagons();
                                                }
                                            });
                                        });
                                    }
                                });
                            }
                            else {
                                hc["selector"].setTexture('redSelector');

                                this.scene.tweens.add({
                                    targets: hc["selector"],
                                    alpha: 0,
                                    duration: 500,
                                    delay: 200
                                });

                                if (this.kangarooVoiceYesNo) this.kangarooVoiceYesNo.stop();
                                this.kangarooVoiceYesNo = this.scene.sound.add('Kangaroo No');
                                this.kangarooVoiceYesNo.play();

                                delayedCall(250, () => {
                                    sh.scene.Preloader.playAnim('no', this.kangaroo);
                                    this.kangaroo.setOrigin(0.5, 1);
                                    this.kangaroo.setPosition(0, 0);
                                });

                                lost = this.onWrongAnswer();
                                if (!lost) {
                                    // this.shuffleInHexagons();
                                } else {
                                    this.isLost = true;
                                }
                            }
                        });
                    }

                    this._btnClose.on('pointerup', () => {
                        this.playBtnClickAnim(this._btnClose);
                        this.onCloseClick();
                    });
                }
                hideAllUnusedBeehives() {
                    let i = this.gameplay.getCurrentTotalAnswersCount();
                    for (let k = i + 1; k < this._BeehiveEmptyArray.length; k++) {
                        this._BeehiveEmptyArray[k].visible = false;
                        this._Beehive[k].visible = false;
                    }
                }
                onCorrectAnswer() {
                    let i = this.gameplay.getCurrentTotalAnswersCount();
                    if (i < this._BeehiveEmptyArray.length) {
                        this._BeehiveEmptyArray[i].visible = false;
                        this._Beehive[i].visible = true;
                    }
                    this.hideAllUnusedBeehives();
                    let completed = this.gameplay.onCorrectAnswer();
                    this.scene.sound.add('Correct sfx').play();
                    // this.sfxCarAccelerating = this.scene.sound.add('Car accelerating');
                    // this.sfxCarAccelerating.play();
                    // delayedCall(250, () => {
                    //     this.scene.sound.add(this.gameplay.getCorrectAndLetterSoundSfxAudioKey()).play();
                    // });
                    return completed;
                }
                onWrongAnswer(forceNewRound) {
                    let i = this.gameplay.getCurrentTotalAnswersCount();
                    if (i < this._BeehiveEmptyArray.length) {
                        this._BeehiveEmptyArray[i].visible = true;
                        this._Beehive[i].visible = false;
                    }
                    this.hideAllUnusedBeehives();
                    let lost = this.gameplay.onWrongAnswer(forceNewRound);
                    this.sfxWrong = this.scene.sound.add("wrong sfx");
                    this.sfxWrong.play();
                    return lost;
                }
                playCorrectAudio() {
                    if (this.correctAudio) {
                        this.correctAudio.stop();
                    }
                    this.correctAudio = this.scene.sound.add("questionAudio"/* this.gameplay.getCorrectAudioKey() */);
                    this.correctAudio.play();
                    if (this.areYouSureWindow && this.areYouSureWindow.parentContainer == this) {
                        this.correctAudio.pause();
                    }
                }
                onSoundClick() {
                    this.playCorrectAudio();
                }
                onCloseClick() {
                    this.showAreYouSurePage();
                    this.scene.sound.add('warning page pop up sfx').play();
                }
                playBtnClickAnim(target) {
                    let sc = target["defScale"] ? target["defScale"] : 1;
                    target.scaleX = target.scaleY = sc;
                    this.scene.tweens.add({
                        targets: target,
                        "scaleX": 0.9 * sc,
                        "scaleY": 0.9 * sc,
                        duration: 100,
                        yoyo: true
                    });
                }
                showInstructionPage() {
                    setPageBackground("bg-blue");
                    this.instructionPage = new screen.InstructionPage(this.scene, (target) => {
                        this.playBtnClickAnim(target);
                        this.remove(this.instructionPage);
                        this.showGameplay();
                        if (this.wfsnd) {
                            this.wfsnd.stop();
                        }
                    }, (target) => {
                        this.playBtnClickAnim(target);
                        if (this.wfsnd) {
                            this.wfsnd.stop();
                        }
                        if (!game.cache.json.get('gameplay')['welcomeAudioDisabled']) {
                            this.wfsnd = this.scene.sound.add("Welcome Find the sound");
                            this.wfsnd.play();
                        }
                    });
                    this.add(this.instructionPage);
                    try {
                        if (!game.cache.json.get('gameplay')['welcomeAudioDisabled']) {
                            this.wfsnd = this.scene.sound.add("Welcome Find the sound");
                            this.wfsnd.play();
                        }
                    }
                    catch (e) {
                        console.error(e);
                    }
                }
                showAreYouSurePage() {
                    /* for (let j = 0; j < this.cars.length; j++) {
                        if (this.cars[j]["raceTween"]) {
                            this.cars[j]["raceTween"].pause();
                        }
                    } */

                    pauseAllDelayedCalls();
                    setPageBackground("bg-blue");
                    this.pauseSounds();
                    if (!this.areYouSureWindow) this.areYouSureWindow = new screen.AreYouSureWindow(this.scene, () => {
                        this.remove(this.areYouSureWindow);
                        this.destroyGameplay();
                        this.showInstructionPage();
                    }, () => {
                        this.remove(this.areYouSureWindow);
                        this.unpauseSounds();
                        resumeAllDelayedCalls();

                        /* for (let j = 0; j < this.cars.length; j++) {
                            if (this.cars[j]["raceTween"]) {
                                this.cars[j]["raceTween"].resume();
                            }
                        } */

                        setPageBackground("bg-australia");
                    });
                    this.add(this.areYouSureWindow);
                }
                setLettersInputEnabled(enabled) {
                    if (enabled) {
                        for (let hc of this.speakers) {
                            hc["selector"].setInteractive({ cursor: 'pointer' });
                        }
                    }
                    else {
                        for (let hc of this.speakers) {
                            hc["selector"].disableInteractive();
                        }
                    }
                }
                pauseSounds() {
                    if (this.correctAudio)
                        this.correctAudio.pause();
                    if (this.bgMusic)
                        this.bgMusic.pause();
                }
                unpauseSounds() {
                    if (this.correctAudio)
                        this.correctAudio.resume();
                    if (this.bgMusic)
                        this.bgMusic.resume();
                }
                destroyGameplay() {
                    this.setLettersInputEnabled(false);
                    this.remove(this.gameplayContainer);
                    this.scene.sound.stopAll();
                    destroyAllDelayedCalls();
                }
            }
            screen.GameplayScreen = GameplayScreen;
        })(screen = sh.screen || (sh.screen = {}));
    })(sh || (sh = {}));
    (function (sh) {
        var screen;
        (function (screen) {
            class InstructionPage extends Phaser.GameObjects.Container {
                constructor(scene, onPlayClick, onSndClick) {
                    super(scene);
                    this._instructionPage = new Phaser.GameObjects.Image(this.scene, 0 - 105, 0 - 48, 'Instructions page  ALL ACTIVITY  TITLEs');
                    this._instructionPage.setOrigin(0, 0);
                    this._instructionPage.setInteractive();

                    this._instructionPageTitle = this.scene.add.text(475, 110, sh.App.json.instructionTitle ?? 'Jumping Kangaroo', {
                        "fontFamily": "Kids Rock DEMO",
                        "fontSize": 35,
                        "color": "#43425D",
                        "align": 'center'
                    });
                    this._instructionPageTitle.setOrigin(0.5, 0.5);
                    window['this._instructionPageTitle'] = this._instructionPageTitle;
                    this._instructionPageTitle.setStroke('#ffffff', 5);
                    //  Apply the gradient fill.
                    const gradient = this._instructionPageTitle.context.createLinearGradient(0, 0, 0, this._instructionPageTitle.height);
                    gradient.addColorStop(0, '#eeef67');
                    gradient.addColorStop(0.55, '#e98c2c');
                    gradient.addColorStop(1, '#91301a');
                    this._instructionPageTitle.setFill(gradient);

                    this._btnPlay = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2, 480 - 50, 'btnPLAY1');
                    this._btnPlay.setInteractive({ cursor: 'pointer' });
                    this._btnPlay.once('pointerup', onPlayClick);
                    setupButtonTextureBased(this._btnPlay, 'btnPLAY1', 'btnPLAY2');
                    this.instrTxt = this.scene.add.text(game.scale.width / 2, game.scale.height / 2, "Play the speakers and match it\n to the word.", {
                        "fontFamily": "Kids Rock DEMO",
                        "fontSize": 30,
                        "color": "#43425D",
                        "align": 'center'
                    });
                    this.instrTxt.setLineSpacing(15);
                    this.instrTxt.setOrigin(0.5, 0.5);
                    this._btnSoundInstruction = new Phaser.GameObjects.Image(this.scene, 800 - 105, 156 - 50, 'Sound');
                    this._btnSoundInstruction.setInteractive({ cursor: 'pointer' });
                    this._btnSoundInstruction.on('pointerup', onSndClick);
                    this._btnSoundInstruction["defScale"] = this._btnSoundInstruction.scale;
                    setupButtonTextureBased(this._btnSoundInstruction, 'Sound', 'Sound HOVER EFFECT');
                    this.add(this._instructionPage);
                    this.add(this._instructionPageTitle);
                    this.add(this.instrTxt);
                    this.add(this._btnPlay);
                    this.add(this._btnSoundInstruction);
                }
            }
            screen.InstructionPage = InstructionPage;
        })(screen = sh.screen || (sh.screen = {}));
    })(sh || (sh = {}));
    (function (sh) {
        var screen;
        (function (screen) {
            class TryAgainWindow extends Phaser.GameObjects.Container {
                constructor(scene, onBack, onReplay) {
                    super(scene);
                    this.music = null;
                    this.setPosition(-106, -48);
                    this._bg = new Phaser.GameObjects.Image(this.scene, 0, 0, 'Try again page');
                    this._bg.setOrigin(0, 0);
                    this._bg.setInteractive();
                    this._star = new Phaser.GameObjects.Image(this.scene, 400, 415, 'Break Star');
                    this._btnBack = new Phaser.GameObjects.Image(this.scene, 600, 580, 'btnBACK1');
                    this._btnReplay = new Phaser.GameObjects.Image(this.scene, 765, 580, 'btnReplay1');
                    this.totalScoreTxt = this.scene.add.text(850, 355, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 35,
                        "color": "#F49F1C",
                        "align": 'center',
                        'stroke': '#70451A',
                        'strokeThickness': 6
                    });
                    this.totalScoreTxt.setOrigin(0.5, 0.5);
                    let grd = this.totalScoreTxt.context.createLinearGradient(0, 0, 0, this.totalScoreTxt.height);
                    grd.addColorStop(0, '#FFFF00');
                    grd.addColorStop(1, '#C17316');
                    this.totalScoreTxt.setFill(grd);
                    this.starScoreTxt = this.scene.add.text(635, 431, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 24,
                        "color": "#FFFFFF",
                        "align": 'center'
                    });
                    this.starScoreTxt.setOrigin(0.5, 0.5);
                    this.add([
                        this._bg,
                        this._star,
                        this._btnBack,
                        this._btnReplay,
                        this.totalScoreTxt,
                        this.starScoreTxt
                    ]);
                    this._btnBack.setInteractive({ cursor: 'pointer' });
                    this._btnBack.on('pointerup', () => {
                        onBack(this._btnBack);
                        angularComponentRef.backToMenu();
                        // if (this.music) {
                        //     this.music.stop();
                        // }
                    });
                    setupButtonTextureBased(this._btnBack, 'btnBACK1', 'btnBACK2');
                    this._btnReplay.setInteractive({ cursor: 'pointer' });
                    this._btnReplay.once('pointerup', () => {
                        onReplay(this._btnReplay);
                        if (this.music) {
                            this.music.stop();
                        }
                    });
                    setupButtonTextureBased(this._btnReplay, 'btnReplay1', 'btnReplay2');
                }
                show(score, starScore) {
                    this._star.scale = 1.25;
                    this.scene.tweens.add({
                        targets: this._star,
                        "scale": 1,
                        duration: 500,
                        ease: Phaser.Math.Easing.Back.Out
                    });
                    this.totalScoreTxt.text = '';//String(window.angularComponentRef.component.userInfo.totalScore);
                    this.starScoreTxt.text = String(0);
                    this.music = this.scene.sound.add("Fail - close one");
                    this.music.play();
                }
            }
            screen.TryAgainWindow = TryAgainWindow;
        })(screen = sh.screen || (sh.screen = {}));
    })(sh || (sh = {}));
}

function destroyJumpingKangaroo() {
    if (game) {
        game.destroy();
    }
}

var game;
var sh;
function meteorsGame(json) {
    /**
     * @author Roman Parada
     * This class is created to fix overlapping of bottom part of canvas by navigation bar in iOS.
     * It make a delayed resize of the canvas (like Phaser-3 FIT methods does) and it overrides Phaser-3 input window to Phaser-3 core transform methods
     *
     * How to use:
     * Just call the code line below in Boot scene's init() method of your project:
     * new FitScaleManager(this.game).setup();
     */
    class FitScaleManager {
        constructor(game) {
            this.doResize = () => {
                let scale = this.calculateScale();
                let newCanvasWidth = this.phaserScaleManager.width * scale;
                let newCanvasHeight = this.phaserScaleManager.height * scale;
                this.canvasStyle.width = newCanvasWidth + 'px';
                this.canvasStyle.height = newCanvasHeight + 'px';
                this.canvasStyle.marginLeft = (window.innerWidth - newCanvasWidth) / 2 + 'px';
                this.canvasStyle.marginTop = (window.innerHeight - newCanvasHeight) / 2 + 'px';
            };
            this.game = game;
            this.canvasStyle = this.game.canvas.style;
            this.phaserScaleManager = this.game.scale;
        }
        static detectBestScaleMode() {
            let iOS = /iPad|iPhone|iPod/.test(navigator.platform || "");
            let isAndroid = window.navigator.userAgent.toLowerCase().indexOf("android") > -1;
            return iOS || isAndroid ? Phaser.Scale.FIT : Phaser.Scale.NONE;
        }
        ;
        /**
         * Just call this method once in Boot scene's init() method
         */
        setup() {
            this.phaserScaleManager.addListener(Phaser.Scale.Events.RESIZE, this.onResize, this);
            this.overridePhaserTransformMethods();
            this.onResize();
        }
        calculateScale() {
            if (game.scale.scaleMode === Phaser.Scale.NONE)
                return 1;
            return Math.min(window.innerWidth / this.phaserScaleManager.width, window.innerHeight / this.phaserScaleManager.height);
        }
        overridePhaserTransformMethods() {
            this.game.scale.transformX = (pageX) => {
                return (pageX - parseInt(this.canvasStyle.marginLeft.split("px")[0])) / this.calculateScale();
            };
            this.game.scale.transformY = (pageY) => {
                return (pageY - parseInt(this.canvasStyle.marginTop.split("px")[0])) / this.calculateScale();
            };
        }
        onResize() {
            setTimeout(this.doResize, FitScaleManager.RESIZE_DELAY);
        }
    }
    FitScaleManager.RESIZE_DELAY = 500;

    (function (sh) {
        class App extends Phaser.Game {
            constructor(json) {
                App.json = json;
                // console.log(App.json);

                let config = {
                    type: Phaser.AUTO,
                    width: App.CANVAS_WIDTH,
                    height: App.CANVAS_HEIGHT,
                    parent: 'game-container',
                    dom: {
                        createContainer: false
                    },
                    scale: {
                        mode: FitScaleManager.detectBestScaleMode(),
                        autoCenter: Phaser.Scale.CENTER_BOTH
                    },
                    transparent: true,
                    scene: {
                        create: () => {
                            this.scene.add('Boot', sh.scene.Boot, true);
                        }
                    }
                };
                super(config);
            }
        }
        App.CANVAS_WIDTH = 980;
        App.CANVAS_HEIGHT = 600;
        sh.App = App;
    })(sh || (sh = {}));

    game = new sh.App(json);

    var delayedCalls = [];
    function delayedCall(delay, callback, args, callbackScope) {
        let scene = game.scene.getAt(0);
        if (scene) {
            let dc = scene.time.delayedCall(delay, callback, args, callbackScope);
            delayedCalls.push(dc);
            return dc;
        }
        let t = setTimeout(callback, delay);
        delayedCalls.push(t);
        return t;
    }

    function pauseAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.paused = true;
            }
        }
    }

    function resumeAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.paused = false;
            }
        }
    }

    function destroyAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.remove(false);
            }
            else {
                clearTimeout(dc);
            }
        }
        delayedCalls = [];
    }

    function setPageBackground(bg) {
        // document.querySelector("html").style.backgroundImage = "url(assets/games/meteors/imgs/" + bg + ".jpg)";
    }

    function setupButton(btn, frame) {
        btn.on('pointerdown', () => { btn.setFrame(frame + '_hover' + '0000'); });
        btn.on('pointerover', () => { btn.setFrame(frame + '_hover' + '0000'); game.scene.getAt(0).sound.add("button hover").play(); });
        btn.on('pointerout', () => { btn.setFrame(frame + '0000'); });
        btn.on('pointerup', () => { btn.setFrame(frame + '0000'); game.scene.getAt(0).sound.add('activity selection - button selection').play(); });
    }

    function setupButtonTextureBased(btn, texture, hoverTexture) {
        btn.on('pointerdown', () => { btn.setTexture(hoverTexture); });
        btn.on('pointerover', () => { btn.setTexture(hoverTexture); game.scene.getAt(0).sound.add("button hover").play(); });
        btn.on('pointerout', () => { btn.setTexture(texture); });
        btn.on('pointerup', () => { btn.setTexture(texture); game.scene.getAt(0).sound.add('activity selection - button selection').play(); });
    }

    (function (sh) {
        var core;
        (function (core) {
            class Gameplay {
                constructor() {
                    this.currentRound = 0;
                    this.currentLetter = 0;
                    this.correctAnswersCount = 0;
                    this.wrongAnswersCount = 0;
                    this.correctAnswersCountThisRound = 0;
                    this.wrongAnswersCountThisRound = 0;
                    this.reset();
                    let json = game.cache.json.get('gameplay');
                    this.wrongAnswersToLose = json["wrongAnswersToLose"];
                    this.numberOfQuestionsPerRound = json["numberOfQuestionsPerRound"];
                    this.lettersConfig = JSON.parse(JSON.stringify(json["lettersConfig"]));
                    this.rounds = JSON.parse(JSON.stringify(json["rounds"]));
                    this.numberOfRounds = json["numberOfRounds"] ?? this.rounds.length;
                    this.useImages = Boolean(game.cache.json.get('gameplay')["useImages"]);
                }
                setupCallbacks(onComplete, onLose) {
                    this.onComplete = onComplete;
                    this.onLose = onLose;
                }
                onLetterChosen(forceNewRound) {
                    if (forceNewRound || this.isNewRound()) {
                        return this.nextRound();
                    }
                    return false;
                }
                nextRound() {
                    this.correctAnswersCountThisRound = 0;
                    this.wrongAnswersCountThisRound = 0;
                    this.currentRound++;
                    if (this.isRoundsComplete()) {
                        this.onComplete(this.correctAnswersCount, this.correctAnswersCount);
                        return true;
                    }

                    return false;
                }
                getCorrectLetterName() {
                    return this.rounds[this.currentRound]['correctLetterName'];
                }
                isCorrectLetterAudioQuestionEnable() {
                    return this.rounds[this.currentRound]['audioQuestionEnable'];
                }
                getCorrectAudioKey() {
                    return this.lettersConfig[this.getCorrectLetterName()]['correctAudioKey'];
                }
                getCorrectAndLetterSoundSfxAudioKey() {
                    return "Q-" + this.lettersConfig[this.getCorrectLetterName()]['Sounds of the letters'];
                }
                onCorrectAnswer() {
                    this.correctAnswersCountThisRound++;
                    this.correctAnswersCount++;
                    return this.onLetterChosen();
                }
                onWrongAnswer(forceNewRound) {
                    this.wrongAnswersCountThisRound++;
                    this.wrongAnswersCount++;
                    if (this.wrongAnswersCount >= this.wrongAnswersToLose) {
                        this.onLose(this.correctAnswersCount, this.correctAnswersCount);
                        return true;
                    }
                    else {
                        this.onLetterChosen(forceNewRound);
                    }
                    return false;
                }

                getMaxTotalAnswersCount() {
                    return this.wrongAnswersToLose + this.numberOfRounds - 1;
                }

                getCurrentTotalAnswersCount() {
                    return this.correctAnswersCount + this.wrongAnswersCount;
                }
                isNewRound() {
                    return this.correctAnswersCountThisRound >= 1 || (this.correctAnswersCountThisRound + this.wrongAnswersCountThisRound) === 3 || (this.correctAnswersCountThisRound + this.wrongAnswersCountThisRound) === 0;
                }
                isRoundsComplete() {
                    return this.currentRound >= this.numberOfRounds && this.wrongAnswersCount < this.wrongAnswersToLose;
                }
                reset() {
                    this.currentRound = 0;
                    this.correctAnswersCount = 0;
                    this.wrongAnswersCount = 0;
                }
                getCurrentRoundLetters() {
                    return this.rounds[this.currentRound]["letters"];
                }
            }
            core.Gameplay = Gameplay;
        })(core = sh.core || (sh.core = {}));
    })(sh || (sh = {}));

    (function (sh) {
        var scene;
        (function (scene) {
            class Boot extends Phaser.Scene {
                init() {
                    this.game.scale.transformX = (pageX) => {
                        let offsetLeft = 0;
                        let parentElement = game.canvas.parentElement;
                        while (parentElement) {
                            if (parentElement.offsetLeft) {
                                offsetLeft = parentElement.offsetLeft;
                                break;
                            }
                            parentElement = parentElement.parentElement;
                        }
                        return (pageX - offsetLeft) * this.game.scale.displayScale.x;
                    };
                    this.game.scale.transformY = (pageY) => {
                        let offsetTop = 0;
                        let parentElement = game.canvas.parentElement;
                        while (parentElement) {
                            if (parentElement.offsetTop) {
                                offsetTop = parentElement.offsetTop;
                                break;
                            }
                            parentElement = parentElement.parentElement;
                        }
                        return (pageY - offsetTop) * this.game.scale.displayScale.y;
                    };
                }
                create() {
                    game.scene.remove('Boot');
                    game.scene.add('Preloader', sh.scene.Preloader, true);
                }
            }
            scene.Boot = Boot;
        })(scene = sh.scene || (sh.scene = {}));
    })(sh || (sh = {}));

    (function (sh) {
        var scene;
        (function (scene) {
            var Gameplay = sh.core.Gameplay;
            class MainScene extends Phaser.Scene {
                create() {
                    this.gameplay = new Gameplay();
                    this.gameplayScreen = new sh.screen.GameplayScreen(this, this.gameplay);
                    this.children.add(this.gameplayScreen);
                    this.gameplayScreen.showInstructionPage();
                }
            }
            scene.MainScene = MainScene;
        })(scene = sh.scene || (sh.scene = {}));
    })(sh || (sh = {}));

    (function (sh) {
        var scene;
        (function (scene) {
            class Preloader extends Phaser.Scene {
                preload() {
                    if (typeof sh.App.json == "string") this.load.json('gameplay', sh.App.json); else this.game.cache.json.add('gameplay', sh.App.json);
                }
                create() {
                    let json = game.cache.json.get('gameplay');
                    let lettersConfig = json["lettersConfig"];
                    for (let letterName in lettersConfig) {
                        if (json["useImages"]) this.load.image(letterName, "assets/games/meteors/imgs/letters/" + letterName + ".png");
                        if (lettersConfig[letterName]["correctAudioKey"] == null) continue;
                        let correctAudioKey = lettersConfig[letterName]["correctAudioKey"];
                        // this.load.audio(correctAudioKey, "assets/games/meteors/sound/mp3/letters/" + correctAudioKey.replace(".wav", ".mp3"));
                        // this.load.audio("Q-" + lettersConfig[letterName]["Sounds of the letters"], "assets/games/meteors/sound/mp3/letters/Sounds of the letters/" + lettersConfig[letterName]["Sounds of the letters"].replace(".wav", ".mp3"));
                    }
                    let progressTxt = this.add.text(game.scale.width / 2, game.scale.height / 2 + 50, "", {
                        "fontFamily": "QuranErafont",
                        "fontSize": 25,
                        "color": "#333333",
                        "align": 'center'
                    });
                    progressTxt.setOrigin(0.5, 0.5);
                    this.load.pack('preloader', 'assets/games/meteors/pack.json');
                    this.load.on('progress', (value) => {
                        progressTxt.text = Math.ceil(value * 100) + "%";
                    }, this);
                    this.load.on('complete', () => {
                        this.nextScene();
                    });
                    this.load.start();
                }
                static playAnim(animKey, sprite, onComplete = null) {
                    let mainScene = game.scene.getScene('ScreenMain');
                    let data = Preloader.ANIMS_DATA[animKey];
                    if (!mainScene.anims.exists(animKey)) {
                        mainScene.anims.create({
                            key: animKey,
                            frames: mainScene.anims.generateFrameNames(data['atlas'], {
                                start: data['start'], end: data['end'], zeroPad: data['padNum'],
                                prefix: data['prefix'], suffix: ''
                            }),
                            frameRate: data['frameRate'],
                            repeat: data['repeat']
                        });
                    }
                    if (sprite.anims.currentAnim) {
                        sprite.anims.currentAnim.off('complete');
                    }
                    sprite.anims.stop();
                    // sprite.setTexture(data['atlas']);
                    sprite.play(animKey);
                    sprite.anims.currentAnim.once('complete', () => {
                        if (onComplete)
                            onComplete();
                    });
                    return sprite;
                }
                nextScene() {
                    game.scene.remove('Preloader');
                    game.scene.add('ScreenMain', sh.scene.MainScene, true);
                }
            }
            Preloader.ANIMS_DATA = {
                'meteor-explosion': {
                    'start': 0,
                    'end': 27,
                    'padNum': 2,
                    'prefix': 'Meteor_2',
                    'repeat': 0,
                    'frameRate': 30,
                    'atlas': 'meteor-explosion-atlas'
                },
                'ship-idle': {
                    'start': 0,
                    'end': 48,
                    'padNum': 2,
                    'prefix': 'iddle space craft_3',
                    'repeat': -1,
                    'frameRate': 30,
                    'atlas': 'idle-atlas'
                },
                'shoot': {
                    'start': 0,
                    'end': 36,
                    'padNum': 2,
                    'prefix': 'SpaceCraft ',
                    'repeat': 0,
                    'frameRate': 30,
                    'atlas': 'shoot-atlas'
                }
            };
            scene.Preloader = Preloader;
        })(scene = sh.scene || (sh.scene = {}));
    })(sh || (sh = {}));
    (function (sh) {
        var screen;
        (function (screen) {
            class AreYouSureWindow extends Phaser.GameObjects.Container {
                constructor(scene, onYes, onNo) {
                    super(scene);
                    this._areYouSurePage = new Phaser.GameObjects.Image(this.scene, -105, 0 - 48, 'Exit warning');
                    this._areYouSurePage.setOrigin(0, 0);
                    this._areYouSurePage.setInteractive();
                    this._btnSureYes = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2 - 95, 485 - 50, 'btnYES1');
                    this._btnSureYes.setInteractive({ cursor: 'pointer' });
                    this._btnSureYes.on('pointerup', () => {
                        onYes;
                        angularComponentRef.backToMenu();
                    });
                    var modalTextStyle = {
                        backgroundColor: 'transparent',
                        stroke: '#ffffff',
                        strokeThickness: 2,
                        lineSpacing: 15,
                        fontFamily: 'Kids Rock DEMO',
                        fontSize: 27,
                        color: '#43425d',
                        wordWrap: true,
                        align: 'center'
                    };
                    var modalText = this.scene.add.text(game.scale.width / 2 + 12, game.scale.height / 2, "Your progress in this activity will not be saved. \n Are you sure you want to exit? ", modalTextStyle);
                    modalText.setOrigin(0.5, 0.5);

                    setupButtonTextureBased(this._btnSureYes, 'btnYES1', 'btnYES2');
                    this._btnSureNo = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2 + 95, 485 - 50, 'btnNO1');
                    this._btnSureNo.setInteractive({ cursor: 'pointer' });
                    this._btnSureNo.on('pointerup', onNo);
                    setupButtonTextureBased(this._btnSureNo, 'btnNO1', 'btnNO2');
                    this.add(this._areYouSurePage);
                    this.add(this._btnSureYes);
                    this.add(this._btnSureNo);
                    this.add(modalText);
                }
            }
            screen.AreYouSureWindow = AreYouSureWindow;
        })(screen = sh.screen || (sh.screen = {}));
    })(sh || (sh = {}));

    (function (sh) {
        var screen;
        (function (screen) {
            class CompleteWindow extends Phaser.GameObjects.Container {
                constructor(scene, onBack, onReplay, onNext) {
                    super(scene);
                    this.music = null;
                    this.setPosition(-104.5, -48);
                    this._bgComplete = new Phaser.GameObjects.Image(this.scene, 0, 0, 'Completion page LATEST UPDATED');
                    this._bgComplete.setOrigin(0, 0);
                    this._bgComplete.setInteractive();
                    this._cup = new Phaser.GameObjects.Image(this.scene, 400, 410, 'Trophy');
                    this._btnBack = new Phaser.GameObjects.Image(this.scene, 570, 570, 'btnBACK1');
                    this._btnReplay = new Phaser.GameObjects.Image(this.scene, 720, 570, 'btnReplay1');
                    this._btnNext = new Phaser.GameObjects.Image(this.scene, 870, 570, 'btnNEXT1');
                    let _CollectedPoints = new Phaser.GameObjects.Image(this.scene, 620, 440, 'Collected Points');
                    this.totalScoreTxt = this.scene.add.text(845, 352, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 35,
                        "color": "#F49F1C",
                        "align": 'center',
                        'stroke': '#70451A',
                        'strokeThickness': 6
                    });
                    this.totalScoreTxt.setOrigin(0.5, 0.5);
                    let grd = this.totalScoreTxt.context.createLinearGradient(0, 0, 0, this.totalScoreTxt.height);
                    grd.addColorStop(0, '#FFFF00');
                    grd.addColorStop(1, '#C17316');
                    this.totalScoreTxt.setFill(grd);
                    this.starScoreTxt = this.scene.add.text(648, 433, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 24,
                        "color": "#FFFFFF",
                        "align": 'center'
                    });
                    this.starScoreTxt.setOrigin(0.5, 0.5);
                    this.add([
                        this._bgComplete,
                        _CollectedPoints,
                        this._cup,
                        this._btnBack,
                        this._btnReplay,
                        this._btnNext,
                        this.totalScoreTxt,
                        this.starScoreTxt
                    ]);
                    this._btnBack.setInteractive({ cursor: 'pointer' });
                    this._btnBack.on('pointerup', () => {
                        onBack(this._btnBack);
                        angularComponentRef.backToMenu();
                        // if (this.music) {
                        //     this.music.stop();
                        // }
                    });
                    setupButtonTextureBased(this._btnBack, 'btnBACK1', 'btnBACK2');
                    this._btnReplay.setInteractive({ cursor: 'pointer' });
                    this._btnReplay.once('pointerup', () => {
                        onReplay(this._btnReplay);
                        if (this.music) {
                            this.music.stop();
                        }
                    });
                    setupButtonTextureBased(this._btnReplay, 'btnReplay1', 'btnReplay2');
                    this._btnNext.setInteractive({ cursor: 'pointer' });
                    this._btnNext.on('pointerup', () => {
                        onNext(this._btnNext);
                        window.angularComponentRef.nextActivity()
                    });
                    setupButtonTextureBased(this._btnNext, 'btnNEXT1', 'btnNEXT2');
                }
                show(score, starScore) {
                    window.angularComponentRef.gameFinish({ score, starScore })
                    this._cup.scale = 1.25;
                    this.scene.tweens.add({
                        targets: this._cup,
                        "scale": 1,
                        duration: 500,
                        ease: Phaser.Math.Easing.Back.Out
                    });
                    this.totalScoreTxt.text = String(window.angularComponentRef.component.userInfo.totalScore);
                    this.starScoreTxt.text = String(starScore);
                    // let music = this.scene.sound.add("viktory");
                    this.music = this.scene.sound.add("Activity completion fantastic");
                    this.music.play();
                }
            }
            screen.CompleteWindow = CompleteWindow;
        })(screen = sh.screen || (sh.screen = {}));
    })(sh || (sh = {}));

    (function (sh) {
        var screen;
        (function (screen) {
            class GameplayScreen extends Phaser.GameObjects.Container {
                constructor(scene, gameplay) {
                    super(scene);
                    this.carsPositionsOutScreen = [{ x: -195 - 20, y: 220 - 350 }, { x: 507 - 40, y: 155 - 350 }, { x: 960 + 195 - 40, y: 220 - 350 }];
                    this.carsPositions = [{ x: 195 - 20, y: 220 }, { x: 507 - 40, y: 155 }, { x: 812 - 40 - 15, y: 220 }];
                    this.bgMusic = null;
                    this.correctAudio = null;
                    this.wfsnd = null;
                    this.showCompleteWindow = (score, starScore) => {
                        let completeWindow = new screen.CompleteWindow(this.scene, (target) => {
                            this.playBtnClickAnim(target);
                        }, (target) => {
                            this.playBtnClickAnim(target);
                            this.destroyGameplay();
                            this.remove(completeWindow);
                            this.showInstructionPage();
                        }, (target) => {
                            this.playBtnClickAnim(target);
                        });
                        this.setLettersInputEnabled(false);
                        delayedCall(6500, () => {
                            setPageBackground("bg-blue");
                            this.add(completeWindow);
                            completeWindow.show(score, starScore);
                            if (this.bgMusic) this.bgMusic.stop();
                        });
                    };
                    this.showLoseWindow = (score, starScore) => {
                        let tryAgainWindow = new screen.TryAgainWindow(this.scene, (target) => {
                            this.playBtnClickAnim(target);
                        }, (target) => {
                            this.playBtnClickAnim(target);
                            this.destroyGameplay();
                            this.remove(tryAgainWindow);
                            this.showInstructionPage();
                        });
                        this.setLettersInputEnabled(false);
                        delayedCall(2500, () => {
                            setPageBackground("bg-blue");
                            this.add(tryAgainWindow);
                            tryAgainWindow.show(score, starScore);
                            if (this.bgMusic) this.bgMusic.stop();
                        });
                    };
                    this.gameplay = gameplay;
                    window["t"] = this;
                }
                createHexagons() {
                    if (this.contentContainer && this.contentContainer.parentContainer) {
                        this.contentContainer.parentContainer.remove(this.contentContainer);
                    }
                    this.contentContainer = new Phaser.GameObjects.Container(this.scene, 0, 0);
                    this.gameplayContainer.addAt(this.contentContainer, 1);
                    window['this.contentContainer'] = this.contentContainer;

                    this.questionContainer = new Phaser.GameObjects.Container(this.scene, 867, 543);
                    let question_box = new Phaser.GameObjects.Image(this.scene, 0, 0, 'question-box');
                    question_box.setOrigin(173 / 265, 1);
                    this.questionContainer.add(question_box);

                    if (this.gameplay.useImages) {
                        this.questionWordText = new Phaser.GameObjects.Image(this.scene, -43, -132, this.gameplay.getCorrectLetterName());
                    } else {
                        this.questionWordText = this.scene.add.text(-43, -132, this.gameplay.getCorrectLetterName(), {
                            "fontFamily": "QuranErafont",
                            "fontSize": 65,
                            "color": "#333333",
                            "align": 'center'
                        });
                        this.questionWordText.setOrigin(0.5, 0.5);
                        this.questionWordText.setPadding({ left: 0, right: 0, top: 65, bottom: 65 });

                        if (this.questionWordText.width > 235) this.questionWordText.setScale(235 / this.questionWordText.width);

                        window['this.questionWordText'] = this.questionWordText;
                    }
                    this.questionContainer.add(this.questionWordText);
                    this.contentContainer.add(this.questionContainer);
                    this.questionContainer.setScale(0, 0);
                    this.scene.tweens.add({
                        targets: this.questionContainer,
                        "scaleX": 1,
                        "scaleY": 1,
                        duration: 400,
                        delay: 600,
                        ease: Phaser.Math.Easing.Back.Out
                    });

                    this.scene.sound.add('Text from earth popping up').play();

                    this.cars = [];
                    let _i = 0;
                    let origins = [{ x: 0.5, y: 0.5 }, { x: 0.5, y: 0.5 }, { x: 0.5, y: 0.5 }];
                    var jarr = [1, 2, 3];
                    for (let p of this.carsPositions) {
                        let hc = new Phaser.GameObjects.Container(this.scene, this.carsPositions[_i]['x'], this.carsPositions[_i]['y']);
                        var j = Phaser.Utils.Array.RemoveRandomElement(jarr);
                        let h = new Phaser.GameObjects.Image(this.scene, 0, 0, 'Normal Box-' + (_i + 1));
                        h.setOrigin(origins[j - 1].x, origins[j - 1].y);
                        hc.add(h);
                        hc["bg"] = h;
                        hc["Correct Box"] = new Phaser.GameObjects.Image(this.scene, 0, 0, 'Correct Box Answer-' + (_i + 1));
                        hc.add(hc["Correct Box"]);
                        hc["Wrong Box"] = new Phaser.GameObjects.Image(this.scene, 0, 0, 'Wrong Box Answer-' + (_i + 1));
                        // hc["Wrong Box"].setTinit(0xff0000);
                        hc.add(hc["Wrong Box"]);
                        hc["Correct Box"].visible = hc["Wrong Box"].visible = false;

                        hc["defX"] = p['x'];
                        hc["defY"] = p['y'];
                        this.cars.push(hc);
                        this.contentContainer.add(hc);
                        hc['index'] = _i;
                        _i++;
                    }
                    window['this.cars'] = this.cars;

                    this.ship = this.scene.add.sprite(480, 590, "idle-atlas");
                    sh.scene.Preloader.playAnim('ship-idle', this.ship);
                    this.ship["defY"] = this.ship.y;
                    this.ship.setOrigin(0.5, 1);
                    this.contentContainer.add(this.ship);
                    window['this.ship'] = this.ship;
                }
                createLetters() {
                    /* if (this.letters) {
                        for (let l of this.letters) {
                            l.parentContainer["letter"] = null;
                            l["hexagon"] = null;
                            l.parentContainer.remove(l);
                        }
                    } */
                    this.letters = [];
                    let _letters = this.gameplay.getCurrentRoundLetters();
                    for (let n of _letters) {
                        let wordText;
                        if (this.gameplay.useImages) {
                            wordText = new Phaser.GameObjects.Image(this.scene, 0, -2, n);
                        } else {
                            wordText = this.scene.add.text(0, -2, n, {
                                "fontFamily": "QuranErafont",
                                "fontSize": 65,
                                "color": "#333333",
                                "align": 'center'
                            });
                            this.add(wordText);
                            wordText.setOrigin(0.5, 0.5);
                            wordText.setPadding({ left: 0, right: 0, top: 65, bottom: 65 });

                            if (wordText.width > 200) wordText.setScale(200 / wordText.width);
                        }
                        wordText["key"] = n;
                        this.letters.push(wordText);
                        window['wordText'] = wordText;
                    }
                }
                showGameplay() {
                    this.isLost = false;
                    setPageBackground("bg-australia");
                    this.bgMusic = this.scene.sound.add("bg_sound");
                    this.bgMusic.play();
                    this.bgMusic.loop = true;
                    this.gameplay.reset();
                    this._gameStage = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2, game.scale.height / 2, 'bg');
                    this._gameStage.setOrigin(0.5, 0.5);
                    this._gameStage.setInteractive();
                    this._btnSound = new Phaser.GameObjects.Image(this.scene, 160 - 105, 100 - 50, 'Sound');
                    this._btnSound.visible = false;
                    this._btnSound.setInteractive({ cursor: 'pointer' });
                    this._btnSound["defScale"] = this._btnSound.scale;
                    setupButtonTextureBased(this._btnSound, 'Sound', 'Sound HOVER EFFECT');
                    this._btnClose = new Phaser.GameObjects.Image(this.scene, 1025 - 105, 100 - 50, 'x Button');
                    this._btnClose.setInteractive({ cursor: 'pointer' });
                    this._btnClose["defScale"] = this._btnClose.scale;
                    setupButtonTextureBased(this._btnClose, 'x Button', 'x Button HOVER EFFECT');
                    this.gameplayContainer = new Phaser.GameObjects.Container(this.scene);
                    this.addAt(this.gameplayContainer, 0);
                    this.gameplayContainer.add([
                        this._gameStage,
                        this._btnSound,
                        this._btnClose
                    ]);
                    this.createBeehives();
                    this.shuffleOutHexagons();
                    this.gameplay.setupCallbacks(this.showCompleteWindow, this.showLoseWindow);
                }
                createBeehives() {
                    let startX = 150;
                    let startY = 50;
                    let dx = 45;
                    let _BeehiveEmptyArrayPositions = [];
                    for (let i = 0; i < this.gameplay.getMaxTotalAnswersCount(); i++) {
                        _BeehiveEmptyArrayPositions.push({ x: startX + i * dx, y: startY });
                    }
                    this._BeehiveEmptyArray = []; window["_BeehiveEmptyArray"] = this._BeehiveEmptyArray;
                    this._Beehive = [];
                    for (let p of _BeehiveEmptyArrayPositions) {
                        let _BeehiveEmpty = new Phaser.GameObjects.Image(this.scene, p['x'], p['y'], 'Beehive 1 Empty');
                        this._BeehiveEmptyArray.push(_BeehiveEmpty);
                        _BeehiveEmpty.visible = false;
                        let _Beehive = new Phaser.GameObjects.Image(this.scene, p['x'], p['y'], 'Beehive 1');
                        this._Beehive.push(_Beehive);
                    }
                    for (let bea of this._BeehiveEmptyArray) {
                        this.gameplayContainer.add(bea);
                    }
                    for (let bee of this._Beehive) {
                        this.gameplayContainer.add(bee);
                        bee.visible = false;
                    }
                }
                randomizeLettersPosition() {
                    let hx = this.cars.slice();
                    for (let l of this.letters) {
                        if (hx.length == 0)
                            return;
                        let hc = Phaser.Utils.Array.RemoveRandomElement(hx);
                        hc.add(l);
                        hc["letter"] = l;
                        l["hexagon"] = hc;
                    }
                }
                updateHexagonsArrange() {
                    for (let hc of this.cars) {
                        if (!hc["letter"]) {
                            hc.parentContainer.bringToTop(hc);
                            break;
                        }
                    }
                }
                shuffleOutHexagons() {
                    this.createHexagons();

                    let setLettersInputEnabled = () => {
                        // if (this.correctAudio && this.correctAudio.isPlaying) {
                        delayedCall(/* (this.correctAudio.duration * 0.75) * */ 1000, () => {
                            this.setLettersInputEnabled(true);
                        });
                        // }
                        // else {
                        // this.setLettersInputEnabled(true);
                        // }
                    };

                    if (!this.gameplay.isRoundsComplete()) {
                        if (this.gameplay.isCorrectLetterAudioQuestionEnable() && this.gameplay.getCurrentTotalAnswersCount() == 0) {
                            // this.playCorrectAudio();
                        }
                        setLettersInputEnabled();
                    }

                    if (this.sfxCarAccelerating) {
                        this.sfxCarAccelerating.stop();
                        this.sfxCarAccelerating = null;
                    }
                    if (this.sfxWrong) {
                        this.sfxWrong.stop();
                        this.sfxWrong = null;
                    }

                    if (!this.gameplay.isRoundsComplete()) {
                        this.createLetters();
                        this.randomizeLettersPosition();
                    }

                    this.scene.sound.add('move to centre').play();

                    this.setLettersInputEnabled(false);
                    this.updateHexagonsArrange();
                    // Phaser.Utils.Array.Shuffle(this.carsPositions);
                    let cars = this.cars;
                    for (let i = 0; i < cars.length; i++) {
                        let hc = cars[i];
                        hc["defX"] = this.carsPositions[i]["x"];
                        hc["defY"] = this.carsPositions[i]["y"];

                        hc["Correct Box"].visible = hc["Wrong Box"].visible = false;
                        hc.x = this.carsPositionsOutScreen[i].x;
                        hc.y = this.carsPositionsOutScreen[i].y;
                        this.scene.tweens.killTweensOf(hc);

                        this.scene.tweens.add({
                            targets: hc,
                            "x": hc["defX"],
                            "y": hc["defY"],
                            duration: 400/*  - Math.ceil(Math.random() * 5) * 100 */,
                            // ease: Phaser.Math.Easing.Quadratic.Out,
                            onComplete: () => { }
                        });

                        this.scene.tweens.add({
                            targets: this.ship,
                            "y": this.ship.y - 10,
                            scaleX: 0.985,
                            scaleY: 0.985,
                            duration: 150/*  - Math.ceil(Math.random() * 5) * 100 */,
                            onComplete: () => { },
                            yoyo: true
                        });
                    }
                    for (let c of cars) this.gameplayContainer.remove(c);
                    this.cars.sort((c1, c2) => c1.y - c2.y);
                    // for (let c of cars) this.gameplayContainer.add(c);

                    this.createInput();
                }
                shuffleInHexagons() {
                    this.updateHexagonsArrange();
                    let positions = this.carsPositions.slice();
                    this.setLettersInputEnabled(false);

                    // delayedCall(600, () => {
                    // this.scene.sound.add('move to centre').play();
                    this.shuffleOutHexagons();
                    // });
                }
                createInput() {
                    for (let hc of this.cars) {
                        let correctAnswer = hc["letter"] && hc["letter"]["key"] == this.gameplay.getCorrectLetterName();
                        //hc["letter"].alpha = correctAnswer ? 1 : 0.5;
                        hc["bg"].on('pointerup', () => {
                            if (hc["Wrong Box"].visible) return;
                            // this.playBtnClickAnim(hc);
                            let lost = false;
                            if (correctAnswer) {
                                let completed = this.onCorrectAnswer();
                                this.scene.sound.add('Shooting sfx').play();

                                let angle = hc['index'] == 0 ? -40 : (hc['index'] == 2 ? 37 : 0);
                                this.scene.tweens.add({
                                    targets: this.ship,
                                    angle: angle,
                                    ease: Phaser.Math.Easing.Cubic.Out,
                                    duration: angle == 0 ? 100 : 350,
                                    onComplete: () => {
                                        sh.scene.Preloader.playAnim('shoot', this.ship, () => { sh.scene.Preloader.playAnim('ship-idle', this.ship); });
                                        // this.ship.setOrigin(0.507, 0.86);

                                        let __d = 1150;
                                        let _diff = 200;
                                        let _otherSndFirtTime = true;
                                        for (let _hc of this.cars) {
                                            let mainMeteor = _hc == hc;
                                            let _d = mainMeteor ? 450 : (__d += _diff);
                                            delayedCall(_d, () => {
                                                _hc.visible = false;
                                                let hExpl = this.scene.add.sprite(_hc.x, _hc.y, "meteor-explosion-atlas");
                                                _hc.parentContainer.add(hExpl);
                                                sh.scene.Preloader.playAnim('meteor-explosion', hExpl);
                                            });

                                            if (mainMeteor) {
                                                this.scene.sound.add('First meteor explostion').play();
                                            } else {
                                                if (_otherSndFirtTime) {
                                                    _otherSndFirtTime = false;
                                                    delayedCall(800, () => {
                                                        this.scene.sound.add('Other two meteors explosion').play();
                                                    });
                                                }
                                            }
                                        }

                                        this.scene.tweens.add({
                                            targets: this.ship,
                                            angle: 0,
                                            duration: 350,
                                            delay: 1500,
                                            ease: Phaser.Math.Easing.Cubic.Out,
                                            onComplete: () => {
                                                if (completed) this.scene.sound.add('Final action - spacecraft going up').play();
                                            }
                                        });

                                        delayedCall(completed ? 2500 : 2750, () => {
                                            if (!completed) {
                                                this.shuffleInHexagons();
                                            } else {
                                                this.scene.tweens.add({
                                                    targets: this.ship,
                                                    duration: 2200,
                                                    y: -300,
                                                    ease: Phaser.Math.Easing.Cubic.In
                                                });
                                            }
                                        })
                                    }
                                });

                                this.scene.tweens.add({
                                    targets: this.questionContainer,
                                    "scaleX": 0,
                                    "scaleY": 0,
                                    duration: 500,
                                    ease: Phaser.Math.Easing.Back.In
                                });

                                this.setLettersInputEnabled(false);
                                hc["Wrong Box"].visible = false;
                                hc["Correct Box"].visible = true;
                                /* for (let hc of this.cars) {
                                    this.scene.tweens.add({
                                        targets: hc["raceTween"],
                                        "timeScale": hc["Correct Box"].visible ? 4 : 2.75,
                                        duration: 400
                                    });
                                } */

                                // delayedCall(500, () => {
                                //     if (!this.gameplay.isNewRound()) {
                                //         if (this.gameplay.isCorrectLetterAudioQuestionEnable()) {
                                //             this.playCorrectAudio();
                                //         }
                                //     }
                                // });
                            }
                            else {
                                hc["Wrong Box"].visible = true;
                                hc["Correct Box"].visible = false;
                                lost = this.onWrongAnswer();
                                if (!lost) {
                                    // this.shuffleInHexagons();
                                } else {
                                    this.isLost = true;
                                }
                            }
                        });
                    }
                    this._btnSound.on('pointerup', () => {
                        this.playBtnClickAnim(this._btnSound);
                        this.onSoundClick();
                    });
                    this._btnClose.on('pointerup', () => {
                        this.playBtnClickAnim(this._btnClose);
                        this.onCloseClick();
                    });
                }
                hideAllUnusedBeehives() {
                    let i = this.gameplay.getCurrentTotalAnswersCount();
                    for (let k = i + 1; k < this._BeehiveEmptyArray.length; k++) {
                        this._BeehiveEmptyArray[k].visible = false;
                        this._Beehive[k].visible = false;
                    }
                }
                onCorrectAnswer() {
                    let i = this.gameplay.getCurrentTotalAnswersCount();
                    if (i < this._BeehiveEmptyArray.length) {
                        this._BeehiveEmptyArray[i].visible = false;
                        this._Beehive[i].visible = true;
                    }
                    this.hideAllUnusedBeehives();
                    let completed = this.gameplay.onCorrectAnswer();
                    this.scene.sound.add('Correct sfx').play();
                    // this.sfxCarAccelerating = this.scene.sound.add('Car accelerating');
                    // this.sfxCarAccelerating.play();
                    // delayedCall(250, () => {
                    //     this.scene.sound.add(this.gameplay.getCorrectAndLetterSoundSfxAudioKey()).play();
                    // });
                    return completed;
                }
                onWrongAnswer(forceNewRound) {
                    let i = this.gameplay.getCurrentTotalAnswersCount();
                    if (i < this._BeehiveEmptyArray.length) {
                        this._BeehiveEmptyArray[i].visible = true;
                        this._Beehive[i].visible = false;
                    }
                    this.hideAllUnusedBeehives();
                    let lost = this.gameplay.onWrongAnswer(forceNewRound);
                    this.sfxWrong = this.scene.sound.add("wrong sfx");
                    this.sfxWrong.play();
                    return lost;
                }
                playCorrectAudio() {
                    if (this.correctAudio) {
                        this.correctAudio.stop();
                    }
                    this.correctAudio = this.scene.sound.add("questionAudio"/* this.gameplay.getCorrectAudioKey() */);
                    this.correctAudio.play();
                    if (this.areYouSureWindow && this.areYouSureWindow.parentContainer == this) {
                        this.correctAudio.pause();
                    }
                }
                onSoundClick() {
                    this.playCorrectAudio();
                }
                onCloseClick() {
                    this.showAreYouSurePage();
                    this.scene.sound.add('warning page pop up sfx').play();
                }
                playBtnClickAnim(target) {
                    let sc = target["defScale"] ? target["defScale"] : 1;
                    target.scaleX = target.scaleY = sc;
                    this.scene.tweens.add({
                        targets: target,
                        "scaleX": 0.9 * sc,
                        "scaleY": 0.9 * sc,
                        duration: 100,
                        yoyo: true
                    });
                }
                showInstructionPage() {
                    setPageBackground("bg-blue");
                    this.instructionPage = new screen.InstructionPage(this.scene, (target) => {
                        this.playBtnClickAnim(target);
                        this.remove(this.instructionPage);
                        this.showGameplay();
                        if (this.wfsnd) {
                            this.wfsnd.stop();
                        }
                    }, (target) => {
                        this.playBtnClickAnim(target);
                        if (this.wfsnd) {
                            this.wfsnd.stop();
                        }
                        if (!game.cache.json.get('gameplay')['welcomeAudioDisabled']) {
                            this.wfsnd = this.scene.sound.add("Welcome Find the sound");
                            this.wfsnd.play();
                        }
                    });
                    this.add(this.instructionPage);
                    try {
                        if (!game.cache.json.get('gameplay')['welcomeAudioDisabled']) {
                            this.wfsnd = this.scene.sound.add("Welcome Find the sound");
                            this.wfsnd.play();
                        }
                    }
                    catch (e) {
                        console.error(e);
                    }
                }
                showAreYouSurePage() {
                    /* for (let j = 0; j < this.cars.length; j++) {
                        if (this.cars[j]["raceTween"]) {
                            this.cars[j]["raceTween"].pause();
                        }
                    } */

                    pauseAllDelayedCalls();
                    setPageBackground("bg-blue");
                    this.pauseSounds();
                    if (!this.areYouSureWindow) this.areYouSureWindow = new screen.AreYouSureWindow(this.scene, () => {
                        this.remove(this.areYouSureWindow);
                        this.destroyGameplay();
                        this.showInstructionPage();
                    }, () => {
                        this.remove(this.areYouSureWindow);
                        this.unpauseSounds();
                        resumeAllDelayedCalls();

                        /* for (let j = 0; j < this.cars.length; j++) {
                            if (this.cars[j]["raceTween"]) {
                                this.cars[j]["raceTween"].resume();
                            }
                        } */

                        setPageBackground("bg-australia");
                    });
                    this.add(this.areYouSureWindow);
                }
                setLettersInputEnabled(enabled) {
                    if (enabled) {
                        for (let hc of this.cars) {
                            hc["bg"].setInteractive({ cursor: 'pointer' });
                        }
                    }
                    else {
                        for (let hc of this.cars) {
                            hc["bg"].disableInteractive();
                        }
                    }
                }
                pauseSounds() {
                    if (this.correctAudio)
                        this.correctAudio.pause();
                    if (this.bgMusic)
                        this.bgMusic.pause();
                }
                unpauseSounds() {
                    if (this.correctAudio)
                        this.correctAudio.resume();
                    if (this.bgMusic)
                        this.bgMusic.resume();
                }
                destroyGameplay() {
                    this.setLettersInputEnabled(false);
                    this.remove(this.gameplayContainer);
                    this.scene.sound.stopAll();
                    destroyAllDelayedCalls();
                }
            }
            screen.GameplayScreen = GameplayScreen;
        })(screen = sh.screen || (sh.screen = {}));
    })(sh || (sh = {}));
    (function (sh) {
        var screen;
        (function (screen) {
            class InstructionPage extends Phaser.GameObjects.Container {
                constructor(scene, onPlayClick, onSndClick) {
                    super(scene);
                    this._instructionPage = new Phaser.GameObjects.Image(this.scene, 0 - 105, 0 - 48, 'Instructions page  ALL ACTIVITY  TITLEs');
                    this._instructionPage.setOrigin(0, 0);
                    this._instructionPage.setInteractive();

                    this._instructionPageTitle = this.scene.add.text(475, 110, sh.App.json.instructionTitle ?? 'Meteors', {
                        "fontFamily": "Kids Rock DEMO",
                        "fontSize": 45,
                        "color": "#43425D",
                        "align": 'center'
                    });
                    this._instructionPageTitle.setOrigin(0.5, 0.5);
                    window['this._instructionPageTitle'] = this._instructionPageTitle;
                    this._instructionPageTitle.setStroke('#ffffff', 5);
                    //  Apply the gradient fill.
                    const gradient = this._instructionPageTitle.context.createLinearGradient(0, 0, 0, this._instructionPageTitle.height);
                    gradient.addColorStop(0, '#eeef67');
                    gradient.addColorStop(0.55, '#e98c2c');
                    gradient.addColorStop(1, '#91301a');
                    this._instructionPageTitle.setFill(gradient);

                    this._btnPlay = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2, 480 - 50, 'btnPLAY1');
                    this._btnPlay.setInteractive({ cursor: 'pointer' });
                    this._btnPlay.once('pointerup', onPlayClick);
                    setupButtonTextureBased(this._btnPlay, 'btnPLAY1', 'btnPLAY2');
                    this.instrTxt = this.scene.add.text(game.scale.width / 2, game.scale.height / 2, "Meteors are about to crash into Earth. \nExplode the meteors by matching\n the codes.", {
                        "fontFamily": "Kids Rock DEMO",
                        "fontSize": 30,
                        "lineSpacing": 15,
                        "color": "#43425D",
                        "align": 'center'
                    });
                    this.instrTxt.setOrigin(0.5, 0.5);
                    this._btnSoundInstruction = new Phaser.GameObjects.Image(this.scene, 800 - 105, 156 - 50, 'Sound');
                    this._btnSoundInstruction.setInteractive({ cursor: 'pointer' });
                    this._btnSoundInstruction.on('pointerup', onSndClick);
                    this._btnSoundInstruction["defScale"] = this._btnSoundInstruction.scale;
                    setupButtonTextureBased(this._btnSoundInstruction, 'Sound', 'Sound HOVER EFFECT');
                    this.add(this._instructionPage);
                    this.add(this._instructionPageTitle);
                    this.add(this.instrTxt);
                    this.add(this._btnPlay);
                    this.add(this._btnSoundInstruction);
                }
            }
            screen.InstructionPage = InstructionPage;
        })(screen = sh.screen || (sh.screen = {}));
    })(sh || (sh = {}));
    (function (sh) {
        var screen;
        (function (screen) {
            class TryAgainWindow extends Phaser.GameObjects.Container {
                constructor(scene, onBack, onReplay) {
                    super(scene);
                    this.music = null;
                    this.setPosition(-106, -48);
                    this._bg = new Phaser.GameObjects.Image(this.scene, 0, 0, 'Try again page');
                    this._bg.setOrigin(0, 0);
                    this._bg.setInteractive();
                    this._star = new Phaser.GameObjects.Image(this.scene, 400, 415, 'Break Star');
                    this._btnBack = new Phaser.GameObjects.Image(this.scene, 600, 580, 'btnBACK1');
                    this._btnReplay = new Phaser.GameObjects.Image(this.scene, 765, 580, 'btnReplay1');
                    this.totalScoreTxt = this.scene.add.text(850, 355, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 35,
                        "color": "#F49F1C",
                        "align": 'center',
                        'stroke': '#70451A',
                        'strokeThickness': 6
                    });
                    this.totalScoreTxt.setOrigin(0.5, 0.5);
                    let grd = this.totalScoreTxt.context.createLinearGradient(0, 0, 0, this.totalScoreTxt.height);
                    grd.addColorStop(0, '#FFFF00');
                    grd.addColorStop(1, '#C17316');
                    this.totalScoreTxt.setFill(grd);
                    this.starScoreTxt = this.scene.add.text(635, 431, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 24,
                        "color": "#FFFFFF",
                        "align": 'center'
                    });
                    this.starScoreTxt.setOrigin(0.5, 0.5);
                    this.add([
                        this._bg,
                        this._star,
                        this._btnBack,
                        this._btnReplay,
                        this.totalScoreTxt,
                        this.starScoreTxt
                    ]);
                    this._btnBack.setInteractive({ cursor: 'pointer' });
                    this._btnBack.on('pointerup', () => {
                        onBack(this._btnBack);
                        angularComponentRef.backToMenu();
                        // if (this.music) {
                        //     this.music.stop();
                        // }
                    });
                    setupButtonTextureBased(this._btnBack, 'btnBACK1', 'btnBACK2');
                    this._btnReplay.setInteractive({ cursor: 'pointer' });
                    this._btnReplay.once('pointerup', () => {
                        onReplay(this._btnReplay);
                        if (this.music) {
                            this.music.stop();
                        }
                    });
                    setupButtonTextureBased(this._btnReplay, 'btnReplay1', 'btnReplay2');
                }
                show(score, starScore) {
                    this._star.scale = 1.25;
                    this.scene.tweens.add({
                        targets: this._star,
                        "scale": 1,
                        duration: 500,
                        ease: Phaser.Math.Easing.Back.Out
                    });
                    this.totalScoreTxt.text = String(window.angularComponentRef.component.userInfo.totalScore);
                    this.starScoreTxt.text = String(0);
                    this.music = this.scene.sound.add("Fail - close one");
                    this.music.play();
                }
            }
            screen.TryAgainWindow = TryAgainWindow;
        })(screen = sh.screen || (sh.screen = {}));
    })(sh || (sh = {}));
}

function destroyMeteorsGame() {
    if (game) {
        game.destroy();
    }
}

var game;
var sh;
function toTheAir(json) {
    /**
     * @author Roman Parada
     * This class is created to fix overlapping of bottom part of canvas by navigation bar in iOS.
     * It make a delayed resize of the canvas (like Phaser-3 FIT methods does) and it overrides Phaser-3 input window to Phaser-3 core transform methods
     *
     * How to use:
     * Just call the code line below in Boot scene's init() method of your project:
     * new FitScaleManager(this.game).setup();
     */
    class FitScaleManager {
        constructor(game) {
            this.doResize = () => {
                let scale = this.calculateScale();
                let newCanvasWidth = this.phaserScaleManager.width * scale;
                let newCanvasHeight = this.phaserScaleManager.height * scale;
                this.canvasStyle.width = newCanvasWidth + 'px';
                this.canvasStyle.height = newCanvasHeight + 'px';
                this.canvasStyle.marginLeft = (window.innerWidth - newCanvasWidth) / 2 + 'px';
                this.canvasStyle.marginTop = (window.innerHeight - newCanvasHeight) / 2 + 'px';
            };
            this.game = game;
            this.canvasStyle = this.game.canvas.style;
            this.phaserScaleManager = this.game.scale;
        }
        static detectBestScaleMode() {
            let iOS = /iPad|iPhone|iPod/.test(navigator.platform || "");
            let isAndroid = window.navigator.userAgent.toLowerCase().indexOf("android") > -1;
            return iOS || isAndroid ? Phaser.Scale.FIT : Phaser.Scale.NONE;
        }
        ;
        /**
         * Just call this method once in Boot scene's init() method
         */
        setup() {
            this.phaserScaleManager.addListener(Phaser.Scale.Events.RESIZE, this.onResize, this);
            this.overridePhaserTransformMethods();
            this.onResize();
        }
        calculateScale() {
            if (game.scale.scaleMode === Phaser.Scale.NONE)
                return 1;
            return Math.min(window.innerWidth / this.phaserScaleManager.width, window.innerHeight / this.phaserScaleManager.height);
        }
        overridePhaserTransformMethods() {
            this.game.scale.transformX = (pageX) => {
                return (pageX - parseInt(this.canvasStyle.marginLeft.split("px")[0])) / this.calculateScale();
            };
            this.game.scale.transformY = (pageY) => {
                return (pageY - parseInt(this.canvasStyle.marginTop.split("px")[0])) / this.calculateScale();
            };
        }
        onResize() {
            setTimeout(this.doResize, FitScaleManager.RESIZE_DELAY);
        }
    }
    FitScaleManager.RESIZE_DELAY = 500;

    (function (sh) {
        class App extends Phaser.Game {
            constructor(json) {
                App.json = json;
                // console.log(App.json);

                let config = {
                    type: Phaser.AUTO,
                    width: App.CANVAS_WIDTH,
                    height: App.CANVAS_HEIGHT,
                    parent: 'game-container',
                    dom: {
                        createContainer: false
                    },
                    scale: {
                        mode: FitScaleManager.detectBestScaleMode(),
                        autoCenter: Phaser.Scale.CENTER_BOTH
                    },
                    transparent: true,
                    scene: {
                        create: () => {
                            this.scene.add('Boot', sh.scene.Boot, true);
                        }
                    }
                };
                super(config);
            }
        }
        App.CANVAS_WIDTH = 980;
        App.CANVAS_HEIGHT = 600;
        sh.App = App;
    })(sh || (sh = {}));

    game = new sh.App(json);

    var delayedCalls = [];
    function delayedCall(delay, callback, args, callbackScope) {
        let scene = game.scene.getAt(0);
        if (scene) {
            let dc = scene.time.delayedCall(delay, callback, args, callbackScope);
            delayedCalls.push(dc);
            return dc;
        }
        let t = setTimeout(callback, delay);
        delayedCalls.push(t);
        return t;
    }

    function pauseAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.paused = true;
            }
        }
    }

    function resumeAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.paused = false;
            }
        }
    }

    function destroyAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.remove(false);
            }
            else {
                clearTimeout(dc);
            }
        }
        delayedCalls = [];
    }

    function setPageBackground(bg) {
        // document.querySelector("html").style.backgroundImage = "url(assets/games/to-the-air/imgs/" + bg + ".jpg)";
    }

    function setupButton(btn, frame) {
        btn.on('pointerdown', () => { btn.setFrame(frame + '_hover' + '0000'); });
        btn.on('pointerover', () => { btn.setFrame(frame + '_hover' + '0000'); game.scene.getAt(0).sound.add("button hover").play(); });
        btn.on('pointerout', () => { btn.setFrame(frame + '0000'); });
        btn.on('pointerup', () => { btn.setFrame(frame + '0000'); game.scene.getAt(0).sound.add('activity selection - button selection').play(); });
    }

    function setupButtonTextureBased(btn, texture, hoverTexture) {
        btn.on('pointerdown', () => { btn.setTexture(hoverTexture); });
        btn.on('pointerover', () => { btn.setTexture(hoverTexture); game.scene.getAt(0).sound.add("button hover").play(); });
        btn.on('pointerout', () => { btn.setTexture(texture); });
        btn.on('pointerup', () => { btn.setTexture(texture); game.scene.getAt(0).sound.add('activity selection - button selection').play(); });
    }

    (function (sh) {
        var core;
        (function (core) {
            class Gameplay {
                constructor() {
                    this.currentRound = 0;
                    this.currentLetter = 0;
                    this.correctAnswersCount = 0;
                    this.wrongAnswersCount = 0;
                    this.correctAnswersCountThisRound = 0;
                    this.wrongAnswersCountThisRound = 0;
                    this.reset();
                    let json = game.cache.json.get('gameplay');
                    this.wrongAnswersToLose = json["wrongAnswersToLose"];
                    this.numberOfQuestionsPerRound = json["numberOfQuestionsPerRound"];
                    this.lettersConfig = JSON.parse(JSON.stringify(json["lettersConfig"]));
                    this.rounds = JSON.parse(JSON.stringify(json["rounds"]));
                    this.numberOfRounds = json["numberOfRounds"] ?? this.rounds.length;
                    this.useImages = Boolean(game.cache.json.get('gameplay')["useImages"]);
                }
                setupCallbacks(onComplete, onLose) {
                    this.onComplete = onComplete;
                    this.onLose = onLose;
                }
                onLetterChosen(forceNewRound) {
                    if (forceNewRound || this.isNewRound()) {
                        return this.nextRound();
                    }
                    return false;
                }
                nextRound() {
                    this.correctAnswersCountThisRound = 0;
                    this.wrongAnswersCountThisRound = 0;
                    this.currentRound++;
                    if (this.isRoundsComplete()) {
                        this.onComplete(this.correctAnswersCount, this.correctAnswersCount);
                        return true;
                    }

                    return false;
                }
                getCorrectLetterName() {
                    return this.rounds[this.currentRound]['correctLetterName'];
                }
                isCorrectLetterAudioQuestionEnable() {
                    return this.rounds[this.currentRound]['audioQuestionEnable'];
                }
                getCorrectAndLetterSoundSfxAudioKey() {
                    return "Q-" + this.lettersConfig[this.getCorrectLetterName()]['Sounds of the letters'];
                }
                onCorrectAnswer() {
                    this.correctAnswersCountThisRound++;
                    this.correctAnswersCount++;
                    return this.onLetterChosen();
                }
                onWrongAnswer(forceNewRound) {
                    this.wrongAnswersCountThisRound++;
                    this.wrongAnswersCount++;
                    if (this.wrongAnswersCount >= this.wrongAnswersToLose) {
                        this.onLose(this.correctAnswersCount, this.correctAnswersCount);
                        return true;
                    }
                    else {
                        this.onLetterChosen(forceNewRound);
                    }
                    return false;
                }

                getMaxTotalAnswersCount() {
                    return this.wrongAnswersToLose + this.numberOfRounds - 1;
                }

                getCurrentTotalAnswersCount() {
                    return this.correctAnswersCount + this.wrongAnswersCount;
                }
                isNewRound() {
                    return this.correctAnswersCountThisRound >= 1 || (this.correctAnswersCountThisRound + this.wrongAnswersCountThisRound) === 4 || (this.correctAnswersCountThisRound + this.wrongAnswersCountThisRound) === 0;
                }
                isRoundsComplete() {
                    return this.currentRound >= this.numberOfRounds && this.wrongAnswersCount < this.wrongAnswersToLose;
                }
                reset() {
                    this.currentRound = 0;
                    this.correctAnswersCount = 0;
                    this.wrongAnswersCount = 0;
                }
                getCurrentRoundLetters() {
                    return this.rounds[this.currentRound]["letters"];
                }
            }
            core.Gameplay = Gameplay;
        })(core = sh.core || (sh.core = {}));
    })(sh || (sh = {}));

    (function (sh) {
        var scene;
        (function (scene) {
            class Boot extends Phaser.Scene {
                init() {
                    this.game.scale.transformX = (pageX) => {
                        let offsetLeft = 0;
                        let parentElement = game.canvas.parentElement;
                        while (parentElement) {
                            if (parentElement.offsetLeft) {
                                offsetLeft = parentElement.offsetLeft;
                                break;
                            }
                            parentElement = parentElement.parentElement;
                        }
                        return (pageX - offsetLeft) * this.game.scale.displayScale.x;
                    };
                    this.game.scale.transformY = (pageY) => {
                        let offsetTop = 0;
                        let parentElement = game.canvas.parentElement;
                        while (parentElement) {
                            if (parentElement.offsetTop) {
                                offsetTop = parentElement.offsetTop;
                                break;
                            }
                            parentElement = parentElement.parentElement;
                        }
                        return (pageY - offsetTop) * this.game.scale.displayScale.y;
                    };
                }
                create() {
                    game.scene.remove('Boot');
                    game.scene.add('Preloader', sh.scene.Preloader, true);
                }
            }
            scene.Boot = Boot;
        })(scene = sh.scene || (sh.scene = {}));
    })(sh || (sh = {}));

    (function (sh) {
        var scene;
        (function (scene) {
            var Gameplay = sh.core.Gameplay;
            class MainScene extends Phaser.Scene {
                create() {
                    this.gameplay = new Gameplay();
                    this.gameplayScreen = new sh.screen.GameplayScreen(this, this.gameplay);
                    this.children.add(this.gameplayScreen);
                    this.gameplayScreen.showInstructionPage();
                }
            }
            scene.MainScene = MainScene;
        })(scene = sh.scene || (sh.scene = {}));
    })(sh || (sh = {}));

    (function (sh) {
        var scene;
        (function (scene) {
            class Preloader extends Phaser.Scene {
                preload() {
                    if (typeof sh.App.json == "string") this.load.json('gameplay', sh.App.json); else this.game.cache.json.add('gameplay', sh.App.json);
                }
                create() {
                    let json = game.cache.json.get('gameplay');
                    let lettersConfig = json["lettersConfig"];
                    this.load.audio("englQuestion", "assets/games/to-the-air/sound/mp3/letters/englQuestion.mp3");
                    for (let letterName in lettersConfig) {
                        if (json["useImages"]) this.load.image(letterName, "assets/games/to-the-air/imgs/letters/" + letterName + ".png");
                        if (lettersConfig[letterName]) {
                            this.load.audio("Q-" + lettersConfig[letterName]["Sounds of the letters"], "assets/games/to-the-air/sound/mp3/letters/Sounds of the letters/" + lettersConfig[letterName]["Sounds of the letters"]);
                        }
                    }
                    let progressTxt = this.add.text(game.scale.width / 2, game.scale.height / 2 + 50, "", {
                        "fontFamily": "QuranErafont",
                        "fontSize": 25,
                        "color": "#333333",
                        "align": 'center'
                    });
                    progressTxt.setOrigin(0.5, 0.5);
                    this.load.pack('preloader', 'assets/games/to-the-air/pack.json');
                    this.load.on('progress', (value) => {
                        progressTxt.text = Math.ceil(value * 100) + "%";
                    }, this);
                    this.load.on('complete', () => {
                        this.nextScene();
                    });
                    this.load.start();
                }
                static playAnim(animKey, sprite, onComplete = null) {
                    let mainScene = game.scene.getScene('ScreenMain');
                    let data = Preloader.ANIMS_DATA[animKey];
                    if (!mainScene.anims.exists(animKey)) {
                        mainScene.anims.create({
                            key: animKey,
                            frames: mainScene.anims.generateFrameNames(data['atlas'], {
                                start: data['start'], end: data['end'], zeroPad: data['padNum'],
                                prefix: data['prefix'], suffix: ''
                            }),
                            frameRate: data['frameRate'],
                            repeat: data['repeat']
                        });
                    }
                    if (sprite.anims.currentAnim) {
                        sprite.anims.currentAnim.off('complete');
                    }
                    sprite.anims.stop();
                    // sprite.setTexture(data['atlas']);
                    sprite.play(animKey);
                    sprite.anims.currentAnim.once('complete', () => {
                        if (onComplete)
                            onComplete();
                    });
                    return sprite;
                }
                nextScene() {
                    game.scene.remove('Preloader');
                    game.scene.add('ScreenMain', sh.scene.MainScene, true);
                }
            }
            Preloader.ANIMS_DATA = {
                'snail-giggling': {
                    'start': 0,
                    'end': 60,
                    'padNum': 2,
                    'prefix': 'Giggling_4',
                    'repeat': 0,
                    'frameRate': 30,
                    'atlas': 'snail-atlas'
                },
                'snail-idle': {
                    'start': 0,
                    'end': 119,
                    'padNum': 3,
                    'prefix': 'iddle_1',
                    'repeat': -1,
                    'frameRate': 30,
                    'atlas': 'snail-atlas'
                },
                'cloud-idle': {
                    'start': 0,
                    'end': 1,
                    'padNum': 3,
                    'prefix': 'Pre-comp 2',
                    'repeat': -1,
                    'frameRate': 30,
                    'atlas': 'cloud-atlas'
                },
                'cloud-pop': {
                    'start': 10,
                    'end': 31,
                    'padNum': 2,
                    'prefix': 'clouds_20',
                    'repeat': 0,
                    'frameRate': 30,
                    'atlas': 'cloud-atlas'
                }
            };
            scene.Preloader = Preloader;
        })(scene = sh.scene || (sh.scene = {}));
    })(sh || (sh = {}));
    (function (sh) {
        var screen;
        (function (screen) {
            class AreYouSureWindow extends Phaser.GameObjects.Container {
                constructor(scene, onYes, onNo) {
                    super(scene);
                    this._areYouSurePage = new Phaser.GameObjects.Image(this.scene, -105, 0 - 48, 'Exit warning');
                    this._areYouSurePage.setOrigin(0, 0);
                    this._areYouSurePage.setInteractive();
                    this._btnSureYes = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2 - 95, 485 - 50, 'btnYES1');
                    this._btnSureYes.setInteractive({ cursor: 'pointer' });
                    this._btnSureYes.on('pointerup', () => {
                        onYes;
                        angularComponentRef.backToMenu();
                    });
                    var modalTextStyle = {
                        backgroundColor: 'transparent',
                        stroke: '#ffffff',
                        strokeThickness: 2,
                        lineSpacing: 15,
                        fontFamily: 'Kids Rock DEMO',
                        fontSize: 27,
                        color: '#43425d',
                        wordWrap: true,
                        align: 'center'
                    };
                    var modalText = this.scene.add.text(game.scale.width / 2 + 12, game.scale.height / 2, "Your progress in this activity will not be saved. \n Are you sure you want to exit? ", modalTextStyle);
                    modalText.setOrigin(0.5, 0.5);

                    setupButtonTextureBased(this._btnSureYes, 'btnYES1', 'btnYES2');
                    this._btnSureNo = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2 + 95, 485 - 50, 'btnNO1');
                    this._btnSureNo.setInteractive({ cursor: 'pointer' });
                    this._btnSureNo.on('pointerup', onNo);
                    setupButtonTextureBased(this._btnSureNo, 'btnNO1', 'btnNO2');
                    this.add(this._areYouSurePage);
                    this.add(this._btnSureYes);
                    this.add(this._btnSureNo);
                    this.add(modalText);
                }
            }
            screen.AreYouSureWindow = AreYouSureWindow;
        })(screen = sh.screen || (sh.screen = {}));
    })(sh || (sh = {}));

    (function (sh) {
        var screen;
        (function (screen) {
            class CompleteWindow extends Phaser.GameObjects.Container {
                constructor(scene, onBack, onReplay, onNext) {
                    super(scene);
                    this.music = null;
                    this.setPosition(-104.5, -48);
                    this._bgComplete = new Phaser.GameObjects.Image(this.scene, 0, 0, 'Completion page LATEST UPDATED');
                    this._bgComplete.setOrigin(0, 0);
                    this._bgComplete.setInteractive();
                    this._cup = new Phaser.GameObjects.Image(this.scene, 400, 410, 'Trophy');
                    this._btnBack = new Phaser.GameObjects.Image(this.scene, 570, 570, 'btnBACK1');
                    this._btnReplay = new Phaser.GameObjects.Image(this.scene, 720, 570, 'btnReplay1');
                    this._btnNext = new Phaser.GameObjects.Image(this.scene, 870, 570, 'btnNEXT1');
                    let _CollectedPoints = new Phaser.GameObjects.Image(this.scene, 620, 440, 'Collected Points');
                    this.totalScoreTxt = this.scene.add.text(845, 352, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 35,
                        "color": "#F49F1C",
                        "align": 'center',
                        'stroke': '#70451A',
                        'strokeThickness': 6
                    });
                    this.totalScoreTxt.setOrigin(0.5, 0.5);
                    let grd = this.totalScoreTxt.context.createLinearGradient(0, 0, 0, this.totalScoreTxt.height);
                    grd.addColorStop(0, '#FFFF00');
                    grd.addColorStop(1, '#C17316');
                    this.totalScoreTxt.setFill(grd);
                    this.starScoreTxt = this.scene.add.text(648, 433, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 24,
                        "color": "#FFFFFF",
                        "align": 'center'
                    });
                    this.starScoreTxt.setOrigin(0.5, 0.5);
                    this.add([
                        this._bgComplete,
                        _CollectedPoints,
                        this._cup,
                        this._btnBack,
                        this._btnReplay,
                        this._btnNext,
                        this.totalScoreTxt,
                        this.starScoreTxt
                    ]);
                    this._btnBack.setInteractive({ cursor: 'pointer' });
                    this._btnBack.on('pointerup', () => {
                        onBack(this._btnBack);
                        angularComponentRef.backToMenu();
                        // if (this.music) {
                        //     this.music.stop();
                        // }
                    });
                    setupButtonTextureBased(this._btnBack, 'btnBACK1', 'btnBACK2');
                    this._btnReplay.setInteractive({ cursor: 'pointer' });
                    this._btnReplay.once('pointerup', () => {
                        onReplay(this._btnReplay);
                        if (this.music) {
                            this.music.stop();
                        }
                    });
                    setupButtonTextureBased(this._btnReplay, 'btnReplay1', 'btnReplay2');
                    this._btnNext.setInteractive({ cursor: 'pointer' });
                    this._btnNext.on('pointerup', () => {
                        onNext(this._btnNext);
                        window.angularComponentRef.nextActivity()
                    });
                    setupButtonTextureBased(this._btnNext, 'btnNEXT1', 'btnNEXT2');
                }
                show(score, starScore) {
                    window.angularComponentRef.gameFinish({ score, starScore })
                    this._cup.scale = 1.25;
                    this.scene.tweens.add({
                        targets: this._cup,
                        "scale": 1,
                        duration: 500,
                        ease: Phaser.Math.Easing.Back.Out
                    });
                    this.totalScoreTxt.text = String(window.angularComponentRef.component.userInfo.totalScore);
                    this.starScoreTxt.text = String(starScore);
                    // let music = this.scene.sound.add("viktory");
                    this.music = this.scene.sound.add("Activity completion fantastic");
                    this.music.play();
                }
            }
            screen.CompleteWindow = CompleteWindow;
        })(screen = sh.screen || (sh.screen = {}));
    })(sh || (sh = {}));

    (function (sh) {
        var screen;
        (function (screen) {
            class GameplayScreen extends Phaser.GameObjects.Container {
                constructor(scene, gameplay) {
                    super(scene);
                    let _dy = 640;
                    this.carsPositionsOutScreen = [{ x: 490, y: 305 - _dy }, { x: 1085, y: 275 - _dy }, { x: 575, y: 580 - _dy }, { x: 1000, y: 565 - _dy }];
                    this.carsPositions = [{ x: 490, y: 305 }, { x: 1085, y: 275 }, { x: 575, y: 580 }, { x: 1000, y: 565 }];
                    this.bgMusic = null;
                    this.correctAudio = null;
                    this.wfsnd = null;
                    this.showCompleteWindow = (score, starScore) => {
                        let completeWindow = new screen.CompleteWindow(this.scene, (target) => {
                            this.playBtnClickAnim(target);
                        }, (target) => {
                            this.playBtnClickAnim(target);
                            this.destroyGameplay();
                            this.remove(completeWindow);
                            this.showInstructionPage();
                        }, (target) => {
                            this.playBtnClickAnim(target);
                        });
                        this.setLettersInputEnabled(false);
                        delayedCall(5200, () => {
                            setPageBackground("bg-blue");
                            this.add(completeWindow);
                            completeWindow.show(score, starScore);
                            if (this.bgMusic) this.bgMusic.stop();
                        });
                    };
                    this.showLoseWindow = (score, starScore) => {
                        let tryAgainWindow = new screen.TryAgainWindow(this.scene, (target) => {
                            this.playBtnClickAnim(target);
                        }, (target) => {
                            this.playBtnClickAnim(target);
                            this.destroyGameplay();
                            this.remove(tryAgainWindow);
                            this.showInstructionPage();
                        });
                        this.setLettersInputEnabled(false);
                        delayedCall(2500, () => {
                            setPageBackground("bg-blue");
                            this.add(tryAgainWindow);
                            tryAgainWindow.show(score, starScore);
                            if (this.bgMusic) this.bgMusic.stop();
                        });
                    };
                    this.gameplay = gameplay;
                    window["t"] = this;
                }
                createHexagons() {
                    if (this.contentContainer && this.contentContainer.parentContainer) {
                        this.contentContainer.parentContainer.remove(this.contentContainer);
                    }

                    this.contentContainer = this.scene.add.container(0, 0);
                    this.gameplayContainer.addAt(this.contentContainer, 1);
                    window['this.contentContainer'] = this.contentContainer;

                    if (this.bgCloudsContainer && this.bgCloudsContainer.parentContainer) {
                        this.bgCloudsContainer.parentContainer.remove(this.bgCloudsContainer);
                    }
                    this.bgCloudsContainer = this.scene.add.container(0, 0);
                    let positions = [{ x: 65, y: 30 }, { x: 850, y: 30 }, { x: 880, y: 330 }, { x: 910, y: 480 }, { x: 536, y: 571 }, { x: 428, y: 307 }, { x: 618, y: 327 }, { x: 450, y: 500 }];
                    for (let c = 0; c < 3; c++) {
                        let p = Phaser.Utils.Array.RemoveRandomElement(positions);
                        let cloud = this.scene.add.sprite(p.x, p.y, 'cloud');
                        cloud.alpha = 0.75;
                        cloud.setScale(0.15 + Math.random() * 0.2);
                        this.bgCloudsContainer.add(cloud);
                        window['this.bgCloudsContainer'] = this.bgCloudsContainer;
                    }
                    this.gameplayContainer.addAt(this.bgCloudsContainer, 1);
                    window['this.gameplayContainer'] = this.gameplayContainer;

                    this.scene.sound.add('Text from earth popping up').play();

                    this.cars = [];
                    let _i = 0;
                    for (let p of this.carsPositions) {
                        let hc = this.scene.add.container(this.carsPositions[_i]['x'], this.carsPositions[_i]['y']);
                        let hcIdleMotionContainer = this.scene.add.container();
                        hc.add(hcIdleMotionContainer);
                        let h = this.scene.add.sprite(0, 0, 'cloud-atlas', 'clouds_2000');
                        delayedCall(_i * 250, () => sh.scene.Preloader.playAnim('cloud-idle', h));
                        hc['isUsedAlready'] = false
                        hc.add(h);
                        hc["bg"] = h;
                        window['hc_' + _i] = hc;
                        window['h_' + _i] = h;
                        hcIdleMotionContainer.add(h);
                        hc['hcIdleMotionContainer'] = hcIdleMotionContainer;

                        let doIdleMove = () => {
                            if (!this.scene) return;
                            this.scene.tweens.add({
                                targets: hcIdleMotionContainer,
                                "x": (0 + Math.random() * 10) * (Math.random() > 0.5 ? 1 : -1),
                                "y": (0 + Math.random() * 10) * (Math.random() > 0.5 ? 1 : -1),
                                yoyo: true,
                                delay: Math.random() > 0.5 ? 0 : Math.random() * 500,
                                duration: 1500,
                                ease: Phaser.Math.Easing.Quadratic.InOut,
                                onComplete: doIdleMove
                            });
                        };
                        doIdleMove();

                        hc["defX"] = p['x'];
                        hc["defY"] = p['y'];
                        this.cars.push(hc);
                        this.contentContainer.add(hc);
                        hc['index'] = _i;
                        _i++;
                    }
                    window['this.cars'] = this.cars;

                    this.ship = this.scene.add.container(480, 405);
                    this.ship['defY'] = this.ship.y;

                    this.airBaloon = this.scene.add.sprite(0, 0, "airBaloon");
                    window['this.airBaloon'] = this.airBaloon;
                    this.airBaloon.setOrigin(0.5, 1);
                    this.ship.add(this.airBaloon);

                    this.snail = this.scene.add.sprite(0, 190, "snail-atlas");
                    this.ship.add(this.snail);
                    this.snail.setOrigin(0.5, 1);
                    window['this.snail'] = this.snail;
                    sh.scene.Preloader.playAnim('snail-idle', this.snail);

                    this.ship["defY"] = this.ship.y;
                    this.contentContainer.add(this.ship);
                    window['this.ship'] = this.ship;
                }
                createLetters() {
                    /* if (this.letters) {
                        for (let l of this.letters) {
                            l.parentContainer["letter"] = null;
                            l["hexagon"] = null;
                            l.parentContainer.remove(l);
                        }
                    } */
                    this.letters = [];
                    let _letters = this.gameplay.getCurrentRoundLetters();
                    for (let n of _letters) {
                        let wordText;
                        if (this.gameplay.useImages) {
                            wordText = new Phaser.GameObjects.Image(this.scene, 0, 0, n);
                        } else {
                            wordText = this.scene.add.text(0, 0, n, {
                                "fontFamily": "QuranErafont",
                                "fontSize": 65,
                                "color": "#333333",
                                "align": 'center'
                            });
                            this.add(wordText);
                            wordText.setOrigin(0.5, 0.5);
                            wordText.setPadding({ left: 0, right: 0, top: 65, bottom: 65 });

                            if (wordText.width > 185) wordText.setScale(185 / wordText.width);
                        }
                        wordText.setPosition(-295, -95);
                        wordText["key"] = n;
                        this.letters.push(wordText);
                        window['wordText'] = wordText;
                    }
                }
                showGameplay() {
                    this.isLost = false;
                    setPageBackground("bg-australia");
                    this.bgMusic = this.scene.sound.add("bg_sound");
                    this.bgMusic.play();
                    this.bgMusic.loop = true;
                    this.gameplay.reset();
                    this._gameStage = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2, game.scale.height / 2, 'bg');
                    this._gameStage.setOrigin(0.5, 0.5);
                    this._gameStage.setInteractive();
                    this._btnSound = new Phaser.GameObjects.Image(this.scene, 160 - 105, 100 - 50, 'Sound');
                    this._btnSound.setInteractive({ cursor: 'pointer' });
                    this._btnSound["defScale"] = this._btnSound.scale;
                    setupButtonTextureBased(this._btnSound, 'Sound', 'Sound HOVER EFFECT');
                    this._btnClose = new Phaser.GameObjects.Image(this.scene, 1025 - 105, 100 - 50, 'x Button');
                    this._btnClose.setInteractive({ cursor: 'pointer' });
                    this._btnClose["defScale"] = this._btnClose.scale;
                    setupButtonTextureBased(this._btnClose, 'x Button', 'x Button HOVER EFFECT');
                    this.gameplayContainer = new Phaser.GameObjects.Container(this.scene);
                    this.addAt(this.gameplayContainer, 0);
                    this.gameplayContainer.add([
                        this._gameStage,
                        this._btnSound,
                        this._btnClose
                    ]);
                    this.createBeehives();
                    this.shuffleOutHexagons();
                    this.gameplay.setupCallbacks(this.showCompleteWindow, this.showLoseWindow);
                }
                createBeehives() {
                    let startX = 39;
                    let startY = 152;
                    let dy = 28;
                    let _BeehiveEmptyArrayPositions = [];
                    for (let i = 0; i < this.gameplay.getMaxTotalAnswersCount(); i++) {
                        _BeehiveEmptyArrayPositions.push({ x: startX, y: startY + i * dy });
                    }
                    this._BeehiveEmptyArray = []; window["_BeehiveEmptyArray"] = this._BeehiveEmptyArray;
                    this._Beehive = [];
                    for (let p of _BeehiveEmptyArrayPositions) {
                        let _BeehiveEmpty = new Phaser.GameObjects.Image(this.scene, p['x'], p['y'], 'Beehive 1 Empty');
                        this._BeehiveEmptyArray.push(_BeehiveEmpty);
                        _BeehiveEmpty.visible = false;
                        let _Beehive = new Phaser.GameObjects.Image(this.scene, p['x'], p['y'], 'Beehive 1');
                        this._Beehive.push(_Beehive);
                    }
                    for (let bea of this._BeehiveEmptyArray) {
                        this.gameplayContainer.add(bea);
                    }
                    for (let bee of this._Beehive) {
                        this.gameplayContainer.add(bee);
                        bee.visible = false;
                    }
                }
                randomizeLettersPosition() {
                    let hx = this.cars.slice();
                    for (let l of this.letters) {
                        if (hx.length == 0)
                            return;
                        let hc = Phaser.Utils.Array.RemoveRandomElement(hx);
                        hc['hcIdleMotionContainer'].add(l);
                        hc["letter"] = l;
                        l["hexagon"] = hc;
                    }
                }
                updateHexagonsArrange() {
                    for (let hc of this.cars) {
                        if (!hc["letter"]) {
                            hc.parentContainer.bringToTop(hc);
                            break;
                        }
                    }
                }
                shuffleOutHexagons() {
                    this.createHexagons();

                    let setLettersInputEnabled = () => {
                        if (this.correctAudio && this.correctAudio.isPlaying) {
                            delayedCall((this.correctAudio.duration * 0.75) * 1000, () => {
                                this.setLettersInputEnabled(true);
                            });
                        }
                        else {
                            this.setLettersInputEnabled(true);
                        }
                    };

                    if (!this.gameplay.isRoundsComplete()) {
                        delayedCall(1000, () => {
                            if (this.gameplay.isCorrectLetterAudioQuestionEnable()) {
                                this.playCorrectAudio();
                            }
                            setLettersInputEnabled();
                        });
                    }

                    if (this.sfxCarAccelerating) {
                        this.sfxCarAccelerating.stop();
                        this.sfxCarAccelerating = null;
                    }
                    if (this.sfxWrong) {
                        this.sfxWrong.stop();
                        this.sfxWrong = null;
                    }

                    if (!this.gameplay.isRoundsComplete()) {
                        this.createLetters();
                        this.randomizeLettersPosition();
                    }

                    this.setLettersInputEnabled(false);
                    this.updateHexagonsArrange();
                    // Phaser.Utils.Array.Shuffle(this.carsPositions);
                    if (this.gameplay.getCurrentTotalAnswersCount() == 0) delayedCall(500, () => {
                        this.scene.sound.add('Blocks appearing in each round').play();
                    });
                    let cars = this.cars;
                    for (let i = 0; i < cars.length; i++) {
                        let hc = cars[i];
                        hc["defX"] = this.carsPositions[i]["x"];
                        hc["defY"] = this.carsPositions[i]["y"];
                        this.scene.tweens.killTweensOf(hc);

                        // hc['letter'].alpha = 0;

                        if (this.gameplay.getCurrentTotalAnswersCount() == 0) {
                            hc.alpha = 0;
                            this.scene.tweens.add({
                                targets: hc,
                                alpha: 1,
                                duration: 350,
                                delay: 750 + i * 140
                            });
                        } else {
                            hc.x = this.carsPositionsOutScreen[i].x;
                            hc.y = this.carsPositionsOutScreen[i].y;

                            this.scene.tweens.add({
                                targets: hc,
                                "x": hc["defX"],
                                "y": hc["defY"],
                                duration: 1500 - 500,
                                ease: Phaser.Math.Easing.Quadratic.Out,
                                onComplete: () => { }
                            });
                        }
                    }

                    if (this.gameplay.getCurrentTotalAnswersCount() != 0) {
                        let allBgClouds = this.bgCloudsContainer.getAll();
                        for (let c of allBgClouds) {
                            this.scene.tweens.killTweensOf(c);
                            let _y = c.y;
                            c.y -= 700;
                            this.scene.tweens.add({
                                targets: c,
                                y: _y,
                                duration: 1550 - 500,
                                ease: Phaser.Math.Easing.Quadratic.Out
                            });
                        }

                        this.scene.tweens.add({
                            targets: this.ship,
                            "y": this.ship.y - 15,
                            duration: 650,
                            ease: Phaser.Math.Easing.Quadratic.InOut,
                            yoyo: true,
                            onComplete: () => {
                                this.scene.tweens.add({
                                    targets: this.ship,
                                    "y": this.ship.y - 7,
                                    duration: 1500 - 500,
                                    repeat: -1,
                                    yoyo: true
                                });
                            }
                        });
                    } else {
                        this.scene.tweens.add({
                            targets: this.ship,
                            "y": this.ship.y - 7,
                            duration: 1500 - 500,
                            repeat: -1,
                            yoyo: true
                        });
                    }

                    for (let c of cars) this.gameplayContainer.remove(c);
                    this.cars.sort((c1, c2) => c1.y - c2.y);
                    // for (let c of cars) this.gameplayContainer.add(c);

                    this.createInput();
                }
                shuffleInHexagons() {
                    this.updateHexagonsArrange();
                    let positions = this.carsPositions.slice();
                    this.setLettersInputEnabled(false);

                    // delayedCall(600, () => {
                    // this.scene.sound.add('move to centre').play();
                    this.shuffleOutHexagons();
                    // });
                }
                createInput() {
                    for (let hc of this.cars) {
                        let correctAnswer = hc["letter"] && hc["letter"]["key"] == this.gameplay.getCorrectLetterName();
                        //hc["letter"].alpha = correctAnswer ? 1 : 0.5;
                        hc["bg"].once('pointerup', () => {
                            if (hc["isUsedAlready"]) return;
                            hc['isUsedAlready'] = true;

                            // this.playBtnClickAnim(hc);
                            let lost = false;
                            if (correctAnswer) {
                                this.scene.tweens.add({
                                    targets: hc,
                                    alpha: 0.75,
                                    yoyo: true,
                                    duration: 250
                                });

                                let completed = this.onCorrectAnswer();

                                // this.scene.sound.add('First meteor explostion').play();

                                this.setLettersInputEnabled(false);

                                sh.scene.Preloader.playAnim('snail-giggling', this.snail);
                                delayedCall(300, () => { this.scene.sound.add('Snail giggling sound - correct selection').play(); });

                                for (let _hc of this.cars) {
                                    this.scene.tweens.add({
                                        targets: _hc,
                                        y: _hc.y + 640,
                                        duration: 1500 - 500,
                                        delay: 0,
                                        ease: Phaser.Math.Easing.Cubic.In,
                                        onComplete: () => {
                                            if (_hc && _hc.parentContainer) _hc.parentContainer.remove(_hc);
                                        }
                                    });
                                }
                                this.scene.tweens.killTweensOf(this.ship);
                                if (!completed) {
                                    this.scene.tweens.add({
                                        targets: this.ship,
                                        "y": this.ship.y - 50,
                                        duration: 500,
                                        delay: 0,
                                        onComplete: () => {
                                            this.scene.tweens.add({
                                                targets: this.ship,
                                                "y": this.ship['defY'],
                                                duration: 500,
                                            });
                                        }
                                    });
                                }
                                delayedCall(650, () => this.scene.sound.add('Going up sound').play())
                                if (completed) delayedCall(2300, () => this.scene.sound.add('Final celebration sound').play())

                                let allBgClouds = this.bgCloudsContainer.getAll();
                                let k = 0;
                                for (let c of allBgClouds) {
                                    this.scene.tweens.add({
                                        targets: c,
                                        y: c.y + 700,
                                        duration: 1900 - 500,
                                        delay: 0,
                                        ease: Phaser.Math.Easing.Cubic.In,
                                        onComplete: () => {
                                            if (c.parentContainer) c.parentContainer.remove(c);
                                        }
                                    });
                                }

                                delayedCall(completed ? 850 : 2500 - 1000, () => {
                                    if (!completed) {
                                        this.shuffleInHexagons();
                                    } else {
                                        this.scene.tweens.add({
                                            targets: this.ship,
                                            duration: 2200,
                                            y: -450,
                                            ease: Phaser.Math.Easing.Cubic.In
                                        });
                                    }
                                });

                                // delayedCall(500, () => {
                                //     if (!this.gameplay.isNewRound()) {
                                //         if (this.gameplay.isCorrectLetterAudioQuestionEnable()) {
                                //             this.playCorrectAudio();
                                //         }
                                //     }
                                // });
                            }
                            else {
                                this.scene.tweens.add({
                                    targets: hc["letter"],
                                    alpha: 0,
                                    duration: 500
                                });

                                sh.scene.Preloader.playAnim('cloud-pop', hc["bg"]/* , ()=>{hc.visible=false;} */);
                                delayedCall(700, () => { hc.visible = false; });
                                lost = this.onWrongAnswer();
                                if (!lost) {
                                    // this.shuffleInHexagons();
                                } else {
                                    this.isLost = true;
                                }
                            }
                        });
                    }
                    this._btnSound.on('pointerup', () => {
                        this.playBtnClickAnim(this._btnSound);
                        this.onSoundClick();
                    });
                    this._btnClose.on('pointerup', () => {
                        this.playBtnClickAnim(this._btnClose);
                        this.onCloseClick();
                    });
                }
                hideAllUnusedBeehives() {
                    let i = this.gameplay.getCurrentTotalAnswersCount();
                    for (let k = i + 1; k < this._BeehiveEmptyArray.length; k++) {
                        this._BeehiveEmptyArray[k].visible = false;
                        this._Beehive[k].visible = false;
                    }
                }
                onCorrectAnswer() {
                    let i = this.gameplay.getCurrentTotalAnswersCount();
                    if (i < this._BeehiveEmptyArray.length) {
                        this._BeehiveEmptyArray[i].visible = false;
                        this._Beehive[i].visible = true;
                    }
                    this.hideAllUnusedBeehives();
                    let completed = this.gameplay.onCorrectAnswer();
                    this.scene.sound.add('Correct sfx').play();

                    // this.sfxCarAccelerating = this.scene.sound.add('Car accelerating');
                    // this.sfxCarAccelerating.play();
                    // delayedCall(250, () => {
                    //     this.scene.sound.add(this.gameplay.getCorrectAndLetterSoundSfxAudioKey()).play();
                    // });
                    return completed;
                }
                onWrongAnswer(forceNewRound) {
                    let i = this.gameplay.getCurrentTotalAnswersCount();
                    if (i < this._BeehiveEmptyArray.length) {
                        this._BeehiveEmptyArray[i].visible = true;
                        this._Beehive[i].visible = false;
                    }
                    this.hideAllUnusedBeehives();
                    let lost = this.gameplay.onWrongAnswer(forceNewRound);
                    this.sfxWrong = this.scene.sound.add("wrong sfx");
                    this.sfxWrong.play();
                    return lost;
                }
                playCorrectAudio() {
                    if (this.correctAudio) {
                        this.correctAudio.stop();
                    }
                    this.correctAudio = this.scene.sound.add("englQuestion");
                    this.correctAudio.once('complete', () => {
                        this.correctAudio = this.scene.sound.add(this.gameplay.getCorrectAndLetterSoundSfxAudioKey());
                        this.correctAudio.play();
                    });
                    this.correctAudio.play();
                    if (this.areYouSureWindow && this.areYouSureWindow.parentContainer == this) {
                        this.correctAudio.pause();
                    }
                }
                onSoundClick() {
                    this.playCorrectAudio();
                }
                onCloseClick() {
                    this.showAreYouSurePage();
                    this.scene.sound.add('warning page pop up sfx').play();
                }
                playBtnClickAnim(target) {
                    let sc = target["defScale"] ? target["defScale"] : 1;
                    target.scaleX = target.scaleY = sc;
                    this.scene.tweens.add({
                        targets: target,
                        "scaleX": 0.9 * sc,
                        "scaleY": 0.9 * sc,
                        duration: 100,
                        yoyo: true
                    });
                }
                showInstructionPage() {
                    setPageBackground("bg-blue");
                    this.instructionPage = new screen.InstructionPage(this.scene, (target) => {
                        this.playBtnClickAnim(target);
                        this.remove(this.instructionPage);
                        this.showGameplay();
                        if (this.wfsnd) {
                            this.wfsnd.stop();
                        }
                    }, (target) => {
                        this.playBtnClickAnim(target);
                        if (this.wfsnd) {
                            this.wfsnd.stop();
                        }
                        if (!game.cache.json.get('gameplay')['welcomeAudioDisabled']) {
                            this.wfsnd = this.scene.sound.add("Welcome Find the sound");
                            this.wfsnd.play();
                        }
                    });
                    this.add(this.instructionPage);
                    try {
                        if (!game.cache.json.get('gameplay')['welcomeAudioDisabled']) {
                            this.wfsnd = this.scene.sound.add("Welcome Find the sound");
                            this.wfsnd.play();
                        }
                    }
                    catch (e) {
                        console.error(e);
                    }
                }
                showAreYouSurePage() {
                    /* for (let j = 0; j < this.cars.length; j++) {
                        if (this.cars[j]["raceTween"]) {
                            this.cars[j]["raceTween"].pause();
                        }
                    } */

                    pauseAllDelayedCalls();
                    setPageBackground("bg-blue");
                    this.pauseSounds();
                    if (!this.areYouSureWindow) this.areYouSureWindow = new screen.AreYouSureWindow(this.scene, () => {
                        this.remove(this.areYouSureWindow);
                        this.destroyGameplay();
                        this.showInstructionPage();
                    }, () => {
                        this.remove(this.areYouSureWindow);
                        this.unpauseSounds();
                        resumeAllDelayedCalls();

                        /* for (let j = 0; j < this.cars.length; j++) {
                            if (this.cars[j]["raceTween"]) {
                                this.cars[j]["raceTween"].resume();
                            }
                        } */

                        setPageBackground("bg-australia");
                    });
                    this.add(this.areYouSureWindow);
                }
                setLettersInputEnabled(enabled) {
                    if (enabled) {
                        for (let hc of this.cars) {
                            // hc["bg"].setInteractive({ cursor: 'pointer' });
                            hc["bg"].setInteractive(new Phaser.Geom.Rectangle(80, 100, 240, 200), Phaser.Geom.Rectangle.Contains);
                        }
                    }
                    else {
                        for (let hc of this.cars) {
                            hc["bg"].disableInteractive();
                        }
                    }
                }
                pauseSounds() {
                    if (this.correctAudio)
                        this.correctAudio.pause();
                    if (this.bgMusic)
                        this.bgMusic.pause();
                }
                unpauseSounds() {
                    if (this.correctAudio)
                        this.correctAudio.resume();
                    if (this.bgMusic)
                        this.bgMusic.resume();
                }
                destroyGameplay() {
                    this.setLettersInputEnabled(false);
                    this.remove(this.gameplayContainer);
                    this.scene.sound.stopAll();
                    destroyAllDelayedCalls();
                }
            }
            screen.GameplayScreen = GameplayScreen;
        })(screen = sh.screen || (sh.screen = {}));
    })(sh || (sh = {}));
    (function (sh) {
        var screen;
        (function (screen) {
            class InstructionPage extends Phaser.GameObjects.Container {
                constructor(scene, onPlayClick, onSndClick) {
                    super(scene);
                    this._instructionPage = new Phaser.GameObjects.Image(this.scene, 0 - 105, 0 - 48, 'Instructions page  ALL ACTIVITY  TITLEs');
                    this._instructionPage.setOrigin(0, 0);
                    this._instructionPage.setInteractive();

                    this._instructionPageTitle = this.scene.add.text(475, 110, sh.App.json.instructionTitle ?? 'To the air', {
                        "fontFamily": "Kids Rock DEMO",
                        "fontSize": 45,
                        "color": "#43425D",
                        "align": 'center'
                    });
                    this._instructionPageTitle.setOrigin(0.5, 0.5);
                    window['this._instructionPageTitle'] = this._instructionPageTitle;
                    this._instructionPageTitle.setStroke('#ffffff', 5);
                    //  Apply the gradient fill.
                    const gradient = this._instructionPageTitle.context.createLinearGradient(0, 0, 0, this._instructionPageTitle.height);
                    gradient.addColorStop(0, '#eeef67');
                    gradient.addColorStop(0.55, '#e98c2c');
                    gradient.addColorStop(1, '#91301a');
                    this._instructionPageTitle.setFill(gradient);

                    this._btnPlay = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2, 480 - 50, 'btnPLAY1');
                    this._btnPlay.setInteractive({ cursor: 'pointer' });
                    this._btnPlay.once('pointerup', onPlayClick);
                    setupButtonTextureBased(this._btnPlay, 'btnPLAY1', 'btnPLAY2');
                    this.instrTxt = this.scene.add.text(game.scale.width / 2, game.scale.height / 2, "Help Qari Snail go higher on his\n air balloon.", {
                        "fontFamily": "Kids Rock DEMO",
                        "fontSize": 30,
                        "color": "#43425D",
                        "align": 'center'
                    });
                    this.instrTxt.setLineSpacing(15);
                    this.instrTxt.setOrigin(0.5, 0.5);
                    this._btnSoundInstruction = new Phaser.GameObjects.Image(this.scene, 800 - 105, 156 - 50, 'Sound');
                    this._btnSoundInstruction.setInteractive({ cursor: 'pointer' });
                    this._btnSoundInstruction.on('pointerup', onSndClick);
                    this._btnSoundInstruction["defScale"] = this._btnSoundInstruction.scale;
                    setupButtonTextureBased(this._btnSoundInstruction, 'Sound', 'Sound HOVER EFFECT');
                    this.add(this._instructionPage);
                    this.add(this._instructionPageTitle);
                    this.add(this.instrTxt);
                    this.add(this._btnPlay);
                    this.add(this._btnSoundInstruction);
                }
            }
            screen.InstructionPage = InstructionPage;
        })(screen = sh.screen || (sh.screen = {}));
    })(sh || (sh = {}));
    (function (sh) {
        var screen;
        (function (screen) {
            class TryAgainWindow extends Phaser.GameObjects.Container {
                constructor(scene, onBack, onReplay) {
                    super(scene);
                    this.music = null;
                    this.setPosition(-106, -48);
                    this._bg = new Phaser.GameObjects.Image(this.scene, 0, 0, 'Try again page');
                    this._bg.setOrigin(0, 0);
                    this._bg.setInteractive();
                    this._star = new Phaser.GameObjects.Image(this.scene, 400, 415, 'Break Star');
                    this._btnBack = new Phaser.GameObjects.Image(this.scene, 600, 580, 'btnBACK1');
                    this._btnReplay = new Phaser.GameObjects.Image(this.scene, 765, 580, 'btnReplay1');
                    this.totalScoreTxt = this.scene.add.text(850, 355, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 35,
                        "color": "#F49F1C",
                        "align": 'center',
                        'stroke': '#70451A',
                        'strokeThickness': 6
                    });
                    this.totalScoreTxt.setOrigin(0.5, 0.5);
                    let grd = this.totalScoreTxt.context.createLinearGradient(0, 0, 0, this.totalScoreTxt.height);
                    grd.addColorStop(0, '#FFFF00');
                    grd.addColorStop(1, '#C17316');
                    this.totalScoreTxt.setFill(grd);
                    this.starScoreTxt = this.scene.add.text(635, 431, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 24,
                        "color": "#FFFFFF",
                        "align": 'center'
                    });
                    this.starScoreTxt.setOrigin(0.5, 0.5);
                    this.add([
                        this._bg,
                        this._star,
                        this._btnBack,
                        this._btnReplay,
                        this.totalScoreTxt,
                        this.starScoreTxt
                    ]);
                    this._btnBack.setInteractive({ cursor: 'pointer' });
                    this._btnBack.on('pointerup', () => {
                        onBack(this._btnBack);
                        angularComponentRef.backToMenu();
                        // if (this.music) {
                        //     this.music.stop();
                        // }
                    });
                    setupButtonTextureBased(this._btnBack, 'btnBACK1', 'btnBACK2');
                    this._btnReplay.setInteractive({ cursor: 'pointer' });
                    this._btnReplay.once('pointerup', () => {
                        onReplay(this._btnReplay);
                        if (this.music) {
                            this.music.stop();
                        }
                    });
                    setupButtonTextureBased(this._btnReplay, 'btnReplay1', 'btnReplay2');
                }
                show(score, starScore) {
                    this._star.scale = 1.25;
                    this.scene.tweens.add({
                        targets: this._star,
                        "scale": 1,
                        duration: 500,
                        ease: Phaser.Math.Easing.Back.Out
                    });
                    this.totalScoreTxt.text = String(window.angularComponentRef.component.userInfo.totalScore);
                    this.starScoreTxt.text = String(0);
                    this.music = this.scene.sound.add("Fail - close one");
                    this.music.play();
                }
            }
            screen.TryAgainWindow = TryAgainWindow;
        })(screen = sh.screen || (sh.screen = {}));
    })(sh || (sh = {}));
}

function destroyToTheAir() {
    if (game) {
        game.destroy();
    }
}

var game;
var sh;
function truckGame(json) {
    /**
     * @author Roman Parada
     * This class is created to fix overlapping of bottom part of canvas by navigation bar in iOS.
     * It make a delayed resize of the canvas (like Phaser-3 FIT methods does) and it overrides Phaser-3 input window to Phaser-3 core transform methods
     *
     * How to use:
     * Just call the code line below in Boot scene's init() method of your project:
     * new FitScaleManager(this.game).setup();
     */
    class FitScaleManager {
        constructor(game) {
            this.doResize = () => {
                let scale = this.calculateScale();
                let newCanvasWidth = this.phaserScaleManager.width * scale;
                let newCanvasHeight = this.phaserScaleManager.height * scale;
                this.canvasStyle.width = newCanvasWidth + 'px';
                this.canvasStyle.height = newCanvasHeight + 'px';
                this.canvasStyle.marginLeft = (window.innerWidth - newCanvasWidth) / 2 + 'px';
                this.canvasStyle.marginTop = (window.innerHeight - newCanvasHeight) / 2 + 'px';
            };
            this.game = game;
            this.canvasStyle = this.game.canvas.style;
            this.phaserScaleManager = this.game.scale;
        }
        static detectBestScaleMode() {
            let iOS = /iPad|iPhone|iPod/.test(navigator.platform || "");
            let isAndroid = window.navigator.userAgent.toLowerCase().indexOf("android") > -1;
            return iOS || isAndroid ? Phaser.Scale.FIT : Phaser.Scale.NONE;
        }
        ;
        /**
         * Just call this method once in Boot scene's init() method
         */
        setup() {
            this.phaserScaleManager.addListener(Phaser.Scale.Events.RESIZE, this.onResize, this);
            this.overridePhaserTransformMethods();
            this.onResize();
        }
        calculateScale() {
            if (game.scale.scaleMode === Phaser.Scale.NONE)
                return 1;
            return Math.min(window.innerWidth / this.phaserScaleManager.width, window.innerHeight / this.phaserScaleManager.height);
        }
        overridePhaserTransformMethods() {
            this.game.scale.transformX = (pageX) => {
                return (pageX - parseInt(this.canvasStyle.marginLeft.split("px")[0])) / this.calculateScale();
            };
            this.game.scale.transformY = (pageY) => {
                return (pageY - parseInt(this.canvasStyle.marginTop.split("px")[0])) / this.calculateScale();
            };
        }
        onResize() {
            setTimeout(this.doResize, FitScaleManager.RESIZE_DELAY);
        }
    }
    FitScaleManager.RESIZE_DELAY = 500;

    (function (sh) {
        class App extends Phaser.Game {
            constructor(json) {
                App.json = json;
                // console.log(App.json);

                let config = {
                    type: Phaser.AUTO,
                    width: App.CANVAS_WIDTH,
                    height: App.CANVAS_HEIGHT,
                    parent: 'game-container',
                    dom: {
                        createContainer: false
                    },
                    scale: {
                        mode: FitScaleManager.detectBestScaleMode(),
                        autoCenter: Phaser.Scale.CENTER_BOTH
                    },
                    transparent: true,
                    scene: {
                        create: () => {
                            this.scene.add('Boot', sh.scene.Boot, true);
                        }
                    }
                };
                super(config);
            }
        }
        App.CANVAS_WIDTH = 980;
        App.CANVAS_HEIGHT = 600;
        sh.App = App;
    })(sh || (sh = {}));

    game = new sh.App(json);

    var delayedCalls = [];
    function delayedCall(delay, callback, args, callbackScope) {
        let scene = game.scene.getAt(0);
        if (scene) {
            let dc = scene.time.delayedCall(delay, callback, args, callbackScope);
            delayedCalls.push(dc);
            return dc;
        }
        let t = setTimeout(callback, delay);
        delayedCalls.push(t);
        return t;
    }

    function pauseAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.paused = true;
            }
        }
    }

    function resumeAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.paused = false;
            }
        }
    }

    function destroyAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.remove(false);
            }
            else {
                clearTimeout(dc);
            }
        }
        delayedCalls = [];
    }

    function setPageBackground(bg) {
        // document.querySelector("html").style.backgroundImage = "url(assets/games/truck/imgs/" + bg + ".jpg)";
    }

    function setupButton(btn, frame) {
        btn.on('pointerdown', () => { btn.setFrame(frame + '_hover' + '0000'); });
        btn.on('pointerover', () => { btn.setFrame(frame + '_hover' + '0000'); game.scene.getAt(0).sound.add("button hover").play(); });
        btn.on('pointerout', () => { btn.setFrame(frame + '0000'); });
        btn.on('pointerup', () => { btn.setFrame(frame + '0000'); game.scene.getAt(0).sound.add('activity selection - button selection').play(); });
    }

    function setupButtonTextureBased(btn, texture, hoverTexture) {
        btn.on('pointerdown', () => { btn.setTexture(hoverTexture); });
        btn.on('pointerover', () => { btn.setTexture(hoverTexture); game.scene.getAt(0).sound.add("button hover").play(); });
        btn.on('pointerout', () => { btn.setTexture(texture); });
        btn.on('pointerup', () => { btn.setTexture(texture); game.scene.getAt(0).sound.add('activity selection - button selection').play(); });
    }

    (function (sh) {
        var core;
        (function (core) {
            class Gameplay {
                constructor() {
                    this.currentRound = 0;
                    this.currentLetter = 0;
                    this.correctAnswersCount = 0;
                    this.wrongAnswersCount = 0;
                    this.correctAnswersCountThisRound = 0;
                    this.wrongAnswersCountThisRound = 0;
                    this.reset();
                    let json = game.cache.json.get('gameplay');
                    this.wrongAnswersToLose = json["wrongAnswersToLose"];
                    this.numberOfQuestionsPerRound = json["numberOfQuestionsPerRound"];
                    this.lettersConfig = JSON.parse(JSON.stringify(json["lettersConfig"]));
                    this.rounds = JSON.parse(JSON.stringify(json["rounds"]));
                    this.numberOfRounds = json["numberOfRounds"] ?? this.rounds.length;
                    this.useImages = Boolean(game.cache.json.get('gameplay')["useImages"]);
                }
                setupCallbacks(onComplete, onLose) {
                    this.onComplete = onComplete;
                    this.onLose = onLose;
                }
                onLetterChosen(forceNewRound) {
                    if (forceNewRound || this.isNewRound()) {
                        return this.nextRound();
                    }
                    return false;
                }
                nextRound() {
                    this.correctAnswersCountThisRound = 0;
                    this.wrongAnswersCountThisRound = 0;
                    this.currentRound++;
                    if (this.isRoundsComplete()) {
                        this.onComplete(this.correctAnswersCount, this.correctAnswersCount);
                        return true;
                    }

                    return false;
                }
                getCorrectLetterName() {
                    return this.rounds[this.currentRound]['correctLetterName'];
                }
                isCorrectLetterAudioQuestionEnable() {
                    return this.rounds[this.currentRound]['audioQuestionEnable'];
                }
                getCorrectAudioKey() {
                    return this.lettersConfig[this.getCorrectLetterName()]['correctAudioKey'];
                }
                getCorrectAndLetterSoundSfxAudioKey() {
                    return "Q-" + this.getCorrectLetterName();
                }
                onCorrectAnswer() {
                    this.correctAnswersCountThisRound++;
                    this.correctAnswersCount++;
                    return this.onLetterChosen();
                }
                onWrongAnswer(forceNewRound) {
                    this.wrongAnswersCountThisRound++;
                    this.wrongAnswersCount++;
                    if (this.wrongAnswersCount >= this.wrongAnswersToLose) {
                        this.onLose(this.correctAnswersCount, this.correctAnswersCount);
                        return true;
                    }
                    else {
                        this.onLetterChosen(forceNewRound);
                    }
                    return false;
                }

                getMaxTotalAnswersCount() {
                    return this.numberOfRounds;
                }

                getCurrentTotalAnswersCount() {
                    return this.correctAnswersCount + this.wrongAnswersCount;
                }
                isNewRound() {
                    return this.correctAnswersCountThisRound >= 1 || (this.correctAnswersCountThisRound + this.wrongAnswersCountThisRound) === 3 || (this.correctAnswersCountThisRound + this.wrongAnswersCountThisRound) === 0;
                }
                isRoundsComplete() {
                    return this.currentRound >= this.numberOfRounds && this.wrongAnswersCount < this.wrongAnswersToLose;
                }
                reset() {
                    this.currentRound = 0;
                    this.correctAnswersCount = 0;
                    this.wrongAnswersCount = 0;
                }
                getCurrentRoundLetters() {
                    return this.rounds[this.currentRound]["words"];
                }
                isExpectedCurrentRoundAnswerCorrect() {
                    return this.rounds[this.currentRound]["correct"];
                }
            }
            core.Gameplay = Gameplay;
        })(core = sh.core || (sh.core = {}));
    })(sh || (sh = {}));

    (function (sh) {
        var scene;
        (function (scene) {
            class Boot extends Phaser.Scene {
                init() {
                    this.game.scale.transformX = (pageX) => {
                        let offsetLeft = 0;
                        let parentElement = game.canvas.parentElement;
                        while (parentElement) {
                            if (parentElement.offsetLeft) {
                                offsetLeft = parentElement.offsetLeft;
                                break;
                            }
                            parentElement = parentElement.parentElement;
                        }
                        return (pageX - offsetLeft) * this.game.scale.displayScale.x;
                    };
                    this.game.scale.transformY = (pageY) => {
                        let offsetTop = 0;
                        let parentElement = game.canvas.parentElement;
                        while (parentElement) {
                            if (parentElement.offsetTop) {
                                offsetTop = parentElement.offsetTop;
                                break;
                            }
                            parentElement = parentElement.parentElement;
                        }
                        return (pageY - offsetTop) * this.game.scale.displayScale.y;
                    };
                }
                create() {
                    game.scene.remove('Boot');
                    game.scene.add('Preloader', sh.scene.Preloader, true);
                }
            }
            scene.Boot = Boot;
        })(scene = sh.scene || (sh.scene = {}));
    })(sh || (sh = {}));

    (function (sh) {
        var scene;
        (function (scene) {
            var Gameplay = sh.core.Gameplay;
            class MainScene extends Phaser.Scene {
                create() {
                    this.gameplay = new Gameplay();
                    this.gameplayScreen = new sh.screen.GameplayScreen(this, this.gameplay);
                    this.children.add(this.gameplayScreen);
                    this.gameplayScreen.showInstructionPage();
                }
            }
            scene.MainScene = MainScene;
        })(scene = sh.scene || (sh.scene = {}));
    })(sh || (sh = {}));

    (function (sh) {
        var scene;
        (function (scene) {
            class Preloader extends Phaser.Scene {
                preload() {
                    if (typeof sh.App.json == "string") this.load.json('gameplay', sh.App.json); else this.game.cache.json.add('gameplay', sh.App.json);
                }
                create() {
                    let json = game.cache.json.get('gameplay');
                    let lettersConfig = json["lettersConfig"];
                    for (let letterName in lettersConfig) {
                        if (json["useImages"]) this.load.image(letterName, "assets/games/truck/imgs/letters/" + letterName + ".png");
                    }

                    this.load.audio("innerInstruction", json["innerInstruction"] ? "assets/games/truck/sound/mp3/" + json["innerInstruction"] : "assets/games/truck/sound/mp3/Truck checkpoint - Inner instr L2.mp3");

                    let rounds = json['rounds'];

                    for (var i = 0; i < rounds.length; i++) {
                        var round = rounds[i];

                        if (round.correct) this.load.audio("Q-" + round['words'][0], "assets/games/truck/sound/mp3/letters/Sounds of the letters/" + round['words'][0] + ".mp3");
                    }

                    let progressTxt = this.add.text(game.scale.width / 2, game.scale.height / 2 + 50, "", {
                        "fontFamily": "QuranErafont",
                        "fontSize": 25,
                        "color": "#333333",
                        "align": 'center'
                    });
                    progressTxt.setOrigin(0.5, 0.5);
                    this.load.pack('preloader', 'assets/games/truck/pack.json');
                    this.load.on('progress', (value) => {
                        progressTxt.text = Math.ceil(value * 100) + "%";
                    }, this);
                    this.load.on('complete', () => {
                        this.nextScene();
                    });
                    this.load.start();
                }
                static playAnim(animKey, sprite, onComplete = null) {
                    let mainScene = game.scene.getScene('ScreenMain');
                    let data = Preloader.ANIMS_DATA[animKey];
                    if (!mainScene.anims.exists(animKey)) {
                        mainScene.anims.create({
                            key: animKey,
                            frames: mainScene.anims.generateFrameNames(data['atlas'], {
                                start: data['start'], end: data['end'], zeroPad: data['padNum'],
                                prefix: data['prefix'], suffix: ''
                            }),
                            frameRate: data['frameRate'],
                            repeat: data['repeat']
                        });
                    }
                    if (sprite.anims.currentAnim) {
                        sprite.anims.currentAnim.off('complete');
                    }
                    sprite.anims.stop();
                    // sprite.setTexture(data['atlas']);
                    sprite.play(animKey);
                    sprite.anims.currentAnim.once('complete', () => {
                        if (onComplete)
                            onComplete();
                    });
                    return sprite;
                }
                nextScene() {
                    game.scene.remove('Preloader');
                    game.scene.add('ScreenMain', sh.scene.MainScene, true);
                }
            }
            Preloader.ANIMS_DATA = {
            };
            scene.Preloader = Preloader;
        })(scene = sh.scene || (sh.scene = {}));
    })(sh || (sh = {}));
    (function (sh) {
        var screen;
        (function (screen) {
            class AreYouSureWindow extends Phaser.GameObjects.Container {
                constructor(scene, onYes, onNo) {
                    super(scene);
                    this._areYouSurePage = new Phaser.GameObjects.Image(this.scene, -105, 0 - 48, 'Exit warning');
                    this._areYouSurePage.setOrigin(0, 0);
                    this._areYouSurePage.setInteractive();
                    this._btnSureYes = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2 - 95, 485 - 50, 'btnYES1');
                    this._btnSureYes.setInteractive({ cursor: 'pointer' });
                    this._btnSureYes.on('pointerup', () => {
                        onYes;
                        angularComponentRef.backToMenu();
                    });
                    var modalTextStyle = {
                        backgroundColor: 'transparent',
                        stroke: '#ffffff',
                        strokeThickness: 2,
                        lineSpacing: 15,
                        fontFamily: 'Kids Rock DEMO',
                        fontSize: 27,
                        color: '#43425d',
                        wordWrap: true,
                        align: 'center'
                    };
                    var modalText = this.scene.add.text(game.scale.width / 2 + 12, game.scale.height / 2, "Your progress in this activity will not be saved. \n Are you sure you want to exit? ", modalTextStyle);
                    modalText.setOrigin(0.5, 0.5);

                    setupButtonTextureBased(this._btnSureYes, 'btnYES1', 'btnYES2');
                    this._btnSureNo = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2 + 95, 485 - 50, 'btnNO1');
                    this._btnSureNo.setInteractive({ cursor: 'pointer' });
                    this._btnSureNo.on('pointerup', onNo);
                    setupButtonTextureBased(this._btnSureNo, 'btnNO1', 'btnNO2');
                    this.add(this._areYouSurePage);
                    this.add(this._btnSureYes);
                    this.add(this._btnSureNo);
                    this.add(modalText);
                }
            }
            screen.AreYouSureWindow = AreYouSureWindow;
        })(screen = sh.screen || (sh.screen = {}));
    })(sh || (sh = {}));

    (function (sh) {
        var screen;
        (function (screen) {
            class CompleteWindow extends Phaser.GameObjects.Container {
                constructor(scene, onBack, onReplay, onNext) {
                    super(scene);
                    this.music = null;
                    this.setPosition(-104.5, -48);
                    this._bgComplete = new Phaser.GameObjects.Image(this.scene, 0, 0, 'Completion page LATEST UPDATED');
                    this._bgComplete.setOrigin(0, 0);
                    this._bgComplete.setInteractive();
                    this._cup = new Phaser.GameObjects.Image(this.scene, 400, 410, 'Trophy');
                    this._btnBack = new Phaser.GameObjects.Image(this.scene, 570, 570, 'btnBACK1');
                    this._btnReplay = new Phaser.GameObjects.Image(this.scene, 720, 570, 'btnReplay1');
                    this._btnNext = new Phaser.GameObjects.Image(this.scene, 870, 570, 'btnNEXT1');
                    let _CollectedPoints = new Phaser.GameObjects.Image(this.scene, 620, 440, 'Collected Points');
                    this.totalScoreTxt = this.scene.add.text(845, 352, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 35,
                        "color": "#F49F1C",
                        "align": 'center',
                        'stroke': '#70451A',
                        'strokeThickness': 6
                    });
                    this.totalScoreTxt.setOrigin(0.5, 0.5);
                    let grd = this.totalScoreTxt.context.createLinearGradient(0, 0, 0, this.totalScoreTxt.height);
                    grd.addColorStop(0, '#FFFF00');
                    grd.addColorStop(1, '#C17316');
                    this.totalScoreTxt.setFill(grd);
                    this.starScoreTxt = this.scene.add.text(648, 433, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 24,
                        "color": "#FFFFFF",
                        "align": 'center'
                    });
                    this.starScoreTxt.setOrigin(0.5, 0.5);
                    this.add([
                        this._bgComplete,
                        _CollectedPoints,
                        this._cup,
                        this._btnBack,
                        this._btnReplay,
                        this._btnNext,
                        this.totalScoreTxt,
                        this.starScoreTxt
                    ]);
                    this._btnBack.setInteractive({ cursor: 'pointer' });
                    this._btnBack.on('pointerup', () => {
                        onBack(this._btnBack);
                        angularComponentRef.backToMenu();
                        // if (this.music) {
                        //     this.music.stop();
                        // }
                    });
                    setupButtonTextureBased(this._btnBack, 'btnBACK1', 'btnBACK2');
                    this._btnReplay.setInteractive({ cursor: 'pointer' });
                    this._btnReplay.once('pointerup', () => {
                        onReplay(this._btnReplay);
                        if (this.music) {
                            this.music.stop();
                        }
                    });
                    setupButtonTextureBased(this._btnReplay, 'btnReplay1', 'btnReplay2');
                    this._btnNext.setInteractive({ cursor: 'pointer' });
                    this._btnNext.on('pointerup', () => {
                        onNext(this._btnNext);
                        window.angularComponentRef.nextActivity()
                    });
                    setupButtonTextureBased(this._btnNext, 'btnNEXT1', 'btnNEXT2');
                }
                show(score, starScore) {
                    window.angularComponentRef.gameFinish({ score, starScore })
                    this._cup.scale = 1.25;
                    this.scene.tweens.add({
                        targets: this._cup,
                        "scale": 1,
                        duration: 500,
                        ease: Phaser.Math.Easing.Back.Out
                    });
                    this.totalScoreTxt.text = String(window.angularComponentRef.component.userInfo.totalScore);
                    this.starScoreTxt.text = String(starScore);
                    // let music = this.scene.sound.add("viktory");
                    this.music = this.scene.sound.add("Activity completion fantastic");
                    this.music.play();
                }
            }
            screen.CompleteWindow = CompleteWindow;
        })(screen = sh.screen || (sh.screen = {}));
    })(sh || (sh = {}));

    (function (sh) {
        var screen;
        (function (screen) {
            class GameplayScreen extends Phaser.GameObjects.Container {
                constructor(scene, gameplay) {
                    super(scene);
                    this.carsPositionsOutScreen = [{ x: -195 - 20, y: 220 - 350 }, { x: 507 - 40, y: 155 - 350 }, { x: 960 + 195 - 40, y: 220 - 350 }];
                    this.carsPositions = [{ x: 50, y: -100 }, { x: 50, y: -100 }];
                    this.bgMusic = null;
                    this.correctAudio = null;
                    this.wfsnd = null;
                    this.showCompleteWindow = (score, starScore) => {
                        let completeWindow = new screen.CompleteWindow(this.scene, (target) => {
                            this.playBtnClickAnim(target);
                        }, (target) => {
                            this.playBtnClickAnim(target);
                            this.destroyGameplay();
                            this.remove(completeWindow);
                            this.showInstructionPage();
                        }, (target) => {
                            this.playBtnClickAnim(target);
                        });
                        this.setLettersInputEnabled(false);
                        delayedCall(7300, () => {
                            setPageBackground("bg-blue");
                            this.add(completeWindow);
                            completeWindow.show(score, starScore);
                            if (this.bgMusic) this.bgMusic.stop();
                        });
                    };
                    this.showLoseWindow = (score, starScore) => {
                        let tryAgainWindow = new screen.TryAgainWindow(this.scene, (target) => {
                            this.playBtnClickAnim(target);
                        }, (target) => {
                            this.playBtnClickAnim(target);
                            this.destroyGameplay();
                            this.remove(tryAgainWindow);
                            this.showInstructionPage();
                        });
                        this.setLettersInputEnabled(false);
                        delayedCall(5000, () => {
                            setPageBackground("bg-blue");
                            this.add(tryAgainWindow);
                            tryAgainWindow.show(score, starScore);
                            if (this.bgMusic) this.bgMusic.stop();
                        });
                    };
                    this.gameplay = gameplay;
                    window["t"] = this;
                }
                createHexagons() {
                    if (this.contentContainer && this.contentContainer.parentContainer) {
                        this.contentContainer.parentContainer.remove(this.contentContainer);
                    }
                    this.contentContainer = new Phaser.GameObjects.Container(this.scene, 0, 0);
                    this.gameplayContainer.addAt(this.contentContainer, 1);
                    window['this.contentContainer'] = this.contentContainer;

                    // this.scene.sound.add('Text from earth popping up').play();

                    this.truckContainer = new Phaser.GameObjects.Container(this.scene, 0, 0);
                    this.contentContainer.add(this.truckContainer);
                    this.selectors = [];
                    let correctselector = new Phaser.GameObjects.Image(this.scene, 50 - 30, 150, 'correctSelector');
                    correctselector.visible = false;
                    correctselector.alpha = 0;
                    correctselector['correct'] = true;
                    this.truckContainer.add(correctselector);
                    this.selectors.push(correctselector);//correct
                    let wrongSelector = new Phaser.GameObjects.Image(this.scene, -50 - 30, 150, 'wrongSelector');
                    wrongSelector.visible = false;
                    wrongSelector.alpha = 0;
                    wrongSelector['correct'] = false;
                    this.truckContainer.add(wrongSelector);
                    this.selectors.push(wrongSelector);//wrong

                    window['this.cars'] = this.selectors;

                    this.truck = new Phaser.GameObjects.Image(this.scene, 50, 400, 'Truck');
                    this.truck.setOrigin(0.5, 0.5);
                    this.truckContainer.add(this.truck);
                    window['this.ship'] = this.truck;

                    this.frameTruck = new Phaser.GameObjects.Image(this.scene, -67, 338, 'White Frame truck');
                    this.truckContainer.add(this.frameTruck);
                    window['this.frameTruck'] = this.frameTruck;
                }
                createLetters() {
                    let _letters = this.gameplay.getCurrentRoundLetters();
                    let _i = 0;
                    this.wordsContainerOnTruck = new Phaser.GameObjects.Container(this.scene, 0, 340);
                    this.truckContainer.add(this.wordsContainerOnTruck);
                    for (let n of _letters) {
                        let wordText;
                        let w = 250;
                        if (this.gameplay.useImages) {
                            wordText = new Phaser.GameObjects.Image(this.scene, 0, 0, n);
                        } else {
                            wordText = this.scene.add.text(0, 0, n, {
                                "fontFamily": "QuranErafont",
                                "fontSize": 65,
                                "color": "#333333",
                                "align": 'center'
                            });
                            this.add(wordText);
                            wordText.setOrigin(0.5, 0.5);
                            wordText.setPadding({ left: 0, right: 0, top: 65, bottom: 65 });

                            if (wordText.width > w) wordText.setScale(w / wordText.width);
                        }
                        wordText["key"] = n;
                        wordText.x = _letters.length == 1 ? -0.25 * w : (_i / _letters.length - 0.5) * w;
                        this.wordsContainerOnTruck.add(wordText);
                        window['this.wordsContainerOnTruck'] = this.wordsContainerOnTruck;
                        _i++;
                        // window['wordText'] = wordText;
                    }
                }
                showGameplay() {
                    this.isLost = false;
                    setPageBackground("bg-australia");
                    this.bgMusic = this.scene.sound.add("bg_sound");
                    this.bgMusic.play();
                    this.bgMusic.loop = true;
                    this.gameplay.reset();
                    this._gameStage = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2, game.scale.height / 2, 'bg');
                    this._gameStage.setOrigin(0.5, 0.5);
                    this._gameStage.setInteractive();
                    this._btnSound = new Phaser.GameObjects.Image(this.scene, 160 - 105, 100 - 50, 'Sound');
                    this._btnSound.setInteractive({ cursor: 'pointer' });
                    this._btnSound["defScale"] = this._btnSound.scale;
                    setupButtonTextureBased(this._btnSound, 'Sound', 'Sound HOVER EFFECT');
                    this._btnClose = new Phaser.GameObjects.Image(this.scene, 1025 - 105, 100 - 50, 'x Button');
                    this._btnClose.setInteractive({ cursor: 'pointer' });
                    this._btnClose["defScale"] = this._btnClose.scale;
                    setupButtonTextureBased(this._btnClose, 'x Button', 'x Button HOVER EFFECT');
                    this.gameplayContainer = new Phaser.GameObjects.Container(this.scene);
                    this.addAt(this.gameplayContainer, 0);
                    this.gameplayContainer.add([
                        this._gameStage,
                        this._btnSound,
                        this._btnClose
                    ]);
                    this.createBeehives();
                    this.shuffleOutHexagons();
                    this.gameplay.setupCallbacks(this.showCompleteWindow, this.showLoseWindow);
                }
                createBeehives() {
                    let startX = 50;
                    let startY = 150;
                    let dy = 40;
                    let _BeehiveEmptyArrayPositions = [];
                    for (let i = 0; i < this.gameplay.getMaxTotalAnswersCount(); i++) {
                        _BeehiveEmptyArrayPositions.push({ x: startX, y: startY + i * dy });
                    }
                    this._BeehiveEmptyArray = []; window["_BeehiveEmptyArray"] = this._BeehiveEmptyArray;
                    this._Beehive = [];
                    for (let p of _BeehiveEmptyArrayPositions) {
                        let _BeehiveEmpty = new Phaser.GameObjects.Image(this.scene, p['x'], p['y'], 'Beehive 1 Empty');
                        this._BeehiveEmptyArray.push(_BeehiveEmpty);
                        _BeehiveEmpty.visible = false;
                        let _Beehive = new Phaser.GameObjects.Image(this.scene, p['x'], p['y'], 'Beehive 1');
                        this._Beehive.push(_Beehive);
                    }
                    for (let bea of this._BeehiveEmptyArray) {
                        this.gameplayContainer.add(bea);
                    }
                    for (let bee of this._Beehive) {
                        this.gameplayContainer.add(bee);
                        bee.visible = false;
                    }
                }
                randomizeLettersPosition() {
                }
                updateHexagonsArrange() {
                }
                shuffleOutHexagons() {
                    this.createHexagons();

                    let setLettersInputEnabled = () => {
                        // if (this.correctAudio && this.correctAudio.isPlaying) {
                        delayedCall(/* (this.correctAudio.duration * 0.75) * */ 1000, () => {
                            this.setLettersInputEnabled(true);
                        });
                        // }
                        // else {
                        // this.setLettersInputEnabled(true);
                        // }
                    };

                    if (!this.gameplay.isRoundsComplete()) {
                        if (this.gameplay.isCorrectLetterAudioQuestionEnable() && this.gameplay.getCurrentTotalAnswersCount() == 0) {
                            this.playCorrectAudio();
                        }
                        setLettersInputEnabled();
                    }

                    if (this.sfxCarAccelerating) {
                        this.sfxCarAccelerating.stop();
                        this.sfxCarAccelerating = null;
                    }
                    if (this.sfxWrong) {
                        this.sfxWrong.stop();
                        this.sfxWrong = null;
                    }

                    if (!this.gameplay.isRoundsComplete()) {
                        this.createLetters();
                        this.randomizeLettersPosition();
                    }

                    this.setLettersInputEnabled(false);
                    this.updateHexagonsArrange();

                    this.scene.sound.add('Truck stops sound').play();
                    this.truckContainer.x = -960 / 2 - 275;
                    this.scene.tweens.add({
                        targets: this.truckContainer,
                        x: 960 / 2 - 30,
                        // ease: Phaser.Math.Easing.Quadratic.Out,
                        duration: 1800,
                        onComplete: () => {
                            for (let s of this.selectors) {
                                s.visible = true;
                                this.scene.tweens.add({
                                    targets: s,
                                    alpha: 1,
                                    duration: 500
                                });
                            }
                        }
                    });

                    this.createInput();
                }
                shuffleInHexagons() {
                    this.updateHexagonsArrange();
                    let positions = this.carsPositions.slice();
                    this.setLettersInputEnabled(false);

                    // delayedCall(600, () => {
                    // this.scene.sound.add('move to centre').play();
                    this.shuffleOutHexagons();
                    // });
                }
                createInput() {
                    for (let selector of this.selectors) {
                        selector.once('pointerup', () => {
                            let isExpectedCurrentRoundAnswerCorrect = this.gameplay.isExpectedCurrentRoundAnswerCorrect();
                            let correctAnswer = selector["correct"] === isExpectedCurrentRoundAnswerCorrect;
                            for (let _selector of this.selectors) {
                                _selector.disableInteractive();
                                this.scene.tweens.add({
                                    targets: _selector,
                                    scaleX: 0.5,
                                    scaleY: 0.5,
                                    alpha: 0,
                                    duration: 150
                                });
                            }

                            let correctAndLetterSoundSfxAudioKey = this.gameplay.getCorrectAndLetterSoundSfxAudioKey();
                            let lost;
                            if (correctAnswer) {
                                this.onCorrectAnswer();
                            } else {
                                this.frameTruck.setTexture("Red Frame truck");
                                lost = this.onWrongAnswer(true);
                            }
                            let completed = this.gameplay.isRoundsComplete();

                            let _delay = 0;
                            if (isExpectedCurrentRoundAnswerCorrect) {
                                var wordSfx = this.scene.sound.add(correctAndLetterSoundSfxAudioKey);
                                if (wordSfx.duration) {
                                    _delay += wordSfx.duration * 1000;
                                    delayedCall(250, () => {
                                        wordSfx.play();
                                    });
                                } else {
                                    console.error('No SFX loaded for the current word: ' + correctAndLetterSoundSfxAudioKey);
                                }
                            }

                            delayedCall(250 + _delay, () => {
                                this.scene.sound.add(isExpectedCurrentRoundAnswerCorrect ? 'Truck Driving Off sfx' : 'truck-reverse-sound').play();

                                this.scene.tweens.add({
                                    targets: this.truckContainer,
                                    duration: isExpectedCurrentRoundAnswerCorrect ? 2300 : 4500,
                                    x: isExpectedCurrentRoundAnswerCorrect ? 960 / 2 + 960 : -960 / 2,
                                    ease: Phaser.Math.Easing.Cubic.In,
                                    onComplete: () => {
                                        if (!completed) {
                                            delayedCall(isExpectedCurrentRoundAnswerCorrect ? 500 : 1250, () => {
                                                if (correctAnswer) {
                                                    this.shuffleInHexagons();
                                                } else {
                                                    if (!lost) {
                                                        this.shuffleInHexagons();
                                                    } else {
                                                        this.isLost = true;
                                                    }
                                                }
                                            });
                                        }
                                    }
                                });
                            });

                            if (completed) {
                                delayedCall(5400, () => { this.scene.sound.add("Final celebration sound").play(); });
                            }
                        });
                    }
                    this._btnSound.on('pointerup', () => {
                        this.playBtnClickAnim(this._btnSound);
                        this.onSoundClick();
                    });
                    this._btnClose.on('pointerup', () => {
                        this.playBtnClickAnim(this._btnClose);
                        this.onCloseClick();
                    });
                }
                hideAllUnusedBeehives() {
                    let i = this.gameplay.getCurrentTotalAnswersCount();
                    for (let k = i + 1; k < this._BeehiveEmptyArray.length; k++) {
                        this._BeehiveEmptyArray[k].visible = false;
                        this._Beehive[k].visible = false;
                    }
                }
                onCorrectAnswer() {
                    let i = this.gameplay.getCurrentTotalAnswersCount();
                    if (i < this._BeehiveEmptyArray.length) {
                        this._BeehiveEmptyArray[i].visible = false;
                        this._Beehive[i].visible = true;
                    }
                    this.hideAllUnusedBeehives();
                    let completed = this.gameplay.onCorrectAnswer();
                    this.scene.sound.add('Correct sfx').play();
                    // this.sfxCarAccelerating = this.scene.sound.add('Car accelerating');
                    // this.sfxCarAccelerating.play();
                    // delayedCall(250, () => {
                    //     this.scene.sound.add(this.gameplay.getCorrectAndLetterSoundSfxAudioKey()).play();
                    // });
                    return completed;
                }
                onWrongAnswer(forceNewRound) {
                    let i = this.gameplay.getCurrentTotalAnswersCount();
                    if (i < this._BeehiveEmptyArray.length) {
                        this._BeehiveEmptyArray[i].visible = true;
                        this._Beehive[i].visible = false;
                    }
                    this.hideAllUnusedBeehives();
                    let lost = this.gameplay.onWrongAnswer(forceNewRound);
                    this.sfxWrong = this.scene.sound.add("wrong sfx");
                    this.sfxWrong.play();
                    return lost;
                }
                playCorrectAudio() {
                    if (this.correctAudio) {
                        this.correctAudio.stop();
                    }
                    this.correctAudio = this.scene.sound.add("innerInstruction");
                    this.correctAudio.play();
                    if (this.areYouSureWindow && this.areYouSureWindow.parentContainer == this) {
                        this.correctAudio.pause();
                    }
                }
                onSoundClick() {
                    this.playCorrectAudio();
                }
                onCloseClick() {
                    this.showAreYouSurePage();
                    this.scene.sound.add('warning page pop up sfx').play();
                }
                playBtnClickAnim(target) {
                    let sc = target["defScale"] ? target["defScale"] : 1;
                    target.scaleX = target.scaleY = sc;
                    this.scene.tweens.add({
                        targets: target,
                        "scaleX": 0.9 * sc,
                        "scaleY": 0.9 * sc,
                        duration: 100,
                        yoyo: true
                    });
                }
                showInstructionPage() {
                    setPageBackground("bg-blue");
                    this.instructionPage = new screen.InstructionPage(this.scene, (target) => {
                        this.playBtnClickAnim(target);
                        this.remove(this.instructionPage);
                        this.showGameplay();
                        if (this.wfsnd) {
                            this.wfsnd.stop();
                        }
                    }, (target) => {
                        this.playBtnClickAnim(target);
                        if (this.wfsnd) {
                            this.wfsnd.stop();
                        }
                        if (!game.cache.json.get('gameplay')['welcomeAudioDisabled']) {
                            this.wfsnd = this.scene.sound.add("Welcome Find the sound");
                            this.wfsnd.play();
                        }
                    });
                    this.add(this.instructionPage);
                    try {
                        if (!game.cache.json.get('gameplay')['welcomeAudioDisabled']) {
                            this.wfsnd = this.scene.sound.add("Welcome Find the sound");
                            this.wfsnd.play();
                        }
                    }
                    catch (e) {
                        console.error(e);
                    }
                }
                showAreYouSurePage() {
                    /* for (let j = 0; j < this.cars.length; j++) {
                        if (this.cars[j]["raceTween"]) {
                            this.cars[j]["raceTween"].pause();
                        }
                    } */

                    pauseAllDelayedCalls();
                    setPageBackground("bg-blue");
                    this.pauseSounds();
                    if (!this.areYouSureWindow) this.areYouSureWindow = new screen.AreYouSureWindow(this.scene, () => {
                        this.remove(this.areYouSureWindow);
                        this.destroyGameplay();
                        this.showInstructionPage();
                    }, () => {
                        this.remove(this.areYouSureWindow);
                        this.unpauseSounds();
                        resumeAllDelayedCalls();

                        /* for (let j = 0; j < this.cars.length; j++) {
                            if (this.cars[j]["raceTween"]) {
                                this.cars[j]["raceTween"].resume();
                            }
                        } */

                        setPageBackground("bg-australia");
                    });
                    this.add(this.areYouSureWindow);
                }
                setLettersInputEnabled(enabled) {
                    if (enabled) {
                        for (let hc of this.selectors) {
                            hc.setInteractive({ cursor: 'pointer' });
                        }
                    }
                    else {
                        for (let hc of this.selectors) {
                            hc.disableInteractive();
                        }
                    }
                }
                pauseSounds() {
                    if (this.correctAudio)
                        this.correctAudio.pause();
                    if (this.bgMusic)
                        this.bgMusic.pause();
                }
                unpauseSounds() {
                    if (this.correctAudio)
                        this.correctAudio.resume();
                    if (this.bgMusic)
                        this.bgMusic.resume();
                }
                destroyGameplay() {
                    this.setLettersInputEnabled(false);
                    this.remove(this.gameplayContainer);
                    this.scene.sound.stopAll();
                    destroyAllDelayedCalls();
                }
            }
            screen.GameplayScreen = GameplayScreen;
        })(screen = sh.screen || (sh.screen = {}));
    })(sh || (sh = {}));
    (function (sh) {
        var screen;
        (function (screen) {
            class InstructionPage extends Phaser.GameObjects.Container {
                constructor(scene, onPlayClick, onSndClick) {
                    super(scene);
                    this._instructionPage = new Phaser.GameObjects.Image(this.scene, 0 - 105, 0 - 48, 'Instructions page  ALL ACTIVITY  TITLEs');
                    this._instructionPage.setOrigin(0, 0);
                    this._instructionPage.setInteractive();

                    this._instructionPageTitle = this.scene.add.text(475, 110, sh.App.json.instructionTitle ?? 'Truck', {
                        "fontFamily": "Kids Rock DEMO",
                        "fontSize": 35,
                        "color": "#43425D",
                        "align": 'center'
                    });
                    this._instructionPageTitle.setOrigin(0.5, 0.5);
                    window['this._instructionPageTitle'] = this._instructionPageTitle;
                    this._instructionPageTitle.setStroke('#ffffff', 5);
                    //  Apply the gradient fill.
                    const gradient = this._instructionPageTitle.context.createLinearGradient(0, 0, 0, this._instructionPageTitle.height);
                    gradient.addColorStop(0, '#eeef67');
                    gradient.addColorStop(0.55, '#e98c2c');
                    gradient.addColorStop(1, '#91301a');
                    this._instructionPageTitle.setFill(gradient);

                    this._btnPlay = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2, 480 - 50, 'btnPLAY1');
                    this._btnPlay.setInteractive({ cursor: 'pointer' });
                    this._btnPlay.once('pointerup', onPlayClick);
                    setupButtonTextureBased(this._btnPlay, 'btnPLAY1', 'btnPLAY2');
                    this.instrTxt = this.scene.add.text(game.scale.width / 2, game.scale.height / 2, "Check the trucks for the right code \n and let them drive in.", {
                        "fontFamily": "Kids Rock DEMO",
                        "fontSize": 30,
                        "color": "#43425D",
                        "align": 'center'
                    });
                    this.instrTxt.setLineSpacing(15);
                    this.instrTxt.setOrigin(0.5, 0.5);
                    this._btnSoundInstruction = new Phaser.GameObjects.Image(this.scene, 800 - 105, 156 - 50, 'Sound');
                    this._btnSoundInstruction.setInteractive({ cursor: 'pointer' });
                    this._btnSoundInstruction.on('pointerup', onSndClick);
                    this._btnSoundInstruction["defScale"] = this._btnSoundInstruction.scale;
                    setupButtonTextureBased(this._btnSoundInstruction, 'Sound', 'Sound HOVER EFFECT');
                    this.add(this._instructionPage);
                    this.add(this._instructionPageTitle);
                    this.add(this.instrTxt);
                    this.add(this._btnPlay);
                    this.add(this._btnSoundInstruction);
                }
            }
            screen.InstructionPage = InstructionPage;
        })(screen = sh.screen || (sh.screen = {}));
    })(sh || (sh = {}));
    (function (sh) {
        var screen;
        (function (screen) {
            class TryAgainWindow extends Phaser.GameObjects.Container {
                constructor(scene, onBack, onReplay) {
                    super(scene);
                    this.music = null;
                    this.setPosition(-106, -48);
                    this._bg = new Phaser.GameObjects.Image(this.scene, 0, 0, 'Try again page');
                    this._bg.setOrigin(0, 0);
                    this._bg.setInteractive();
                    this._star = new Phaser.GameObjects.Image(this.scene, 400, 415, 'Break Star');
                    this._btnBack = new Phaser.GameObjects.Image(this.scene, 600, 580, 'btnBACK1');
                    this._btnReplay = new Phaser.GameObjects.Image(this.scene, 765, 580, 'btnReplay1');
                    this.totalScoreTxt = this.scene.add.text(850, 355, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 35,
                        "color": "#F49F1C",
                        "align": 'center',
                        'stroke': '#70451A',
                        'strokeThickness': 6
                    });
                    this.totalScoreTxt.setOrigin(0.5, 0.5);
                    let grd = this.totalScoreTxt.context.createLinearGradient(0, 0, 0, this.totalScoreTxt.height);
                    grd.addColorStop(0, '#FFFF00');
                    grd.addColorStop(1, '#C17316');
                    this.totalScoreTxt.setFill(grd);
                    this.starScoreTxt = this.scene.add.text(635, 431, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 24,
                        "color": "#FFFFFF",
                        "align": 'center'
                    });
                    this.starScoreTxt.setOrigin(0.5, 0.5);
                    this.add([
                        this._bg,
                        this._star,
                        this._btnBack,
                        this._btnReplay,
                        this.totalScoreTxt,
                        this.starScoreTxt
                    ]);
                    this._btnBack.setInteractive({ cursor: 'pointer' });
                    this._btnBack.on('pointerup', () => {
                        onBack(this._btnBack);
                        angularComponentRef.backToMenu();
                        // if (this.music) {
                        //     this.music.stop();
                        // }
                    });
                    setupButtonTextureBased(this._btnBack, 'btnBACK1', 'btnBACK2');
                    this._btnReplay.setInteractive({ cursor: 'pointer' });
                    this._btnReplay.once('pointerup', () => {
                        onReplay(this._btnReplay);
                        if (this.music) {
                            this.music.stop();
                        }
                    });
                    setupButtonTextureBased(this._btnReplay, 'btnReplay1', 'btnReplay2');
                }
                show(score, starScore) {
                    this._star.scale = 1.25;
                    this.scene.tweens.add({
                        targets: this._star,
                        "scale": 1,
                        duration: 500,
                        ease: Phaser.Math.Easing.Back.Out
                    });
                    this.totalScoreTxt.text = String(window.angularComponentRef.component.userInfo.totalScore);
                    this.starScoreTxt.text = String(0);
                    this.music = this.scene.sound.add("Fail - close one");
                    this.music.play();
                }
            }
            screen.TryAgainWindow = TryAgainWindow;
        })(screen = sh.screen || (sh.screen = {}));
    })(sh || (sh = {}));
}

function destroyTruckGame() {
    if (game) {
        game.destroy();
    }
}

var game;
var sh;
function aeroPlane(json) {
    /**
     * @author Roman Parada
     * This class is created to fix overlapping of bottom part of canvas by navigation bar in iOS.
     * It make a delayed resize of the canvas (like Phaser-3 FIT methods does) and it overrides Phaser-3 input window to Phaser-3 core transform methods
     *
     * How to use:
     * Just call the code line below in Boot scene's init() method of your project:
     * new FitScaleManager(this.game).setup();
     */
    class FitScaleManager {
        constructor(game) {
            this.doResize = () => {
                let scale = this.calculateScale();
                let newCanvasWidth = this.phaserScaleManager.width * scale;
                let newCanvasHeight = this.phaserScaleManager.height * scale;
                this.canvasStyle.width = newCanvasWidth + 'px';
                this.canvasStyle.height = newCanvasHeight + 'px';
                this.canvasStyle.marginLeft = (window.innerWidth - newCanvasWidth) / 2 + 'px';
                this.canvasStyle.marginTop = (window.innerHeight - newCanvasHeight) / 2 + 'px';
            };
            this.game = game;
            this.canvasStyle = this.game.canvas.style;
            this.phaserScaleManager = this.game.scale;
        }
        static detectBestScaleMode() {
            let iOS = /iPad|iPhone|iPod/.test(navigator.platform || "");
            let isAndroid = window.navigator.userAgent.toLowerCase().indexOf("android") > -1;
            return iOS || isAndroid ? Phaser.Scale.FIT : Phaser.Scale.NONE;
        }
        ;
        /**
         * Just call this method once in Boot scene's init() method
         */
        setup() {
            this.phaserScaleManager.addListener(Phaser.Scale.Events.RESIZE, this.onResize, this);
            this.overridePhaserTransformMethods();
            this.onResize();
        }
        calculateScale() {
            if (game.scale.scaleMode === Phaser.Scale.NONE)
                return 1;
            return Math.min(window.innerWidth / this.phaserScaleManager.width, window.innerHeight / this.phaserScaleManager.height);
        }
        overridePhaserTransformMethods() {
            this.game.scale.transformX = (pageX) => {
                return (pageX - parseInt(this.canvasStyle.marginLeft.split("px")[0])) / this.calculateScale();
            };
            this.game.scale.transformY = (pageY) => {
                return (pageY - parseInt(this.canvasStyle.marginTop.split("px")[0])) / this.calculateScale();
            };
        }
        onResize() {
            setTimeout(this.doResize, FitScaleManager.RESIZE_DELAY);
        }
    }
    FitScaleManager.RESIZE_DELAY = 500;

    (function (sh) {
        class App extends Phaser.Game {
            constructor(json) {
                App.json = json;
                // console.log(App.json);

                let config = {
                    type: Phaser.AUTO,
                    width: App.CANVAS_WIDTH,
                    height: App.CANVAS_HEIGHT,
                    parent: 'game-container',
                    dom: {
                        createContainer: false
                    },
                    scale: {
                        mode: FitScaleManager.detectBestScaleMode(),
                        autoCenter: Phaser.Scale.CENTER_BOTH
                    },
                    transparent: true,
                    scene: {
                        create: () => {
                            this.scene.add('Boot', sh.scene.Boot, true);
                        }
                    }
                };
                super(config);
            }
        }
        App.CANVAS_WIDTH = 980;
        App.CANVAS_HEIGHT = 600;
        sh.App = App;
    })(sh || (sh = {}));

    game = new sh.App(json);

    var delayedCalls = [];
    function delayedCall(delay, callback, args, callbackScope) {
        let scene = game.scene.getAt(0);
        if (scene) {
            let dc = scene.time.delayedCall(delay, callback, args, callbackScope);
            delayedCalls.push(dc);
            return dc;
        }
        let t = setTimeout(callback, delay);
        delayedCalls.push(t);
        return t;
    }

    function pauseAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.paused = true;
            }
        }
    }

    function resumeAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.paused = false;
            }
        }
    }

    function destroyAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.remove(false);
            }
            else {
                clearTimeout(dc);
            }
        }
        delayedCalls = [];
    }

    function setPageBackground(bg) {
        // document.querySelector("html").style.backgroundImage = "url(assets/games/aeroplane/imgs/" + bg + ".jpg)";
    }

    function setupButton(btn, frame) {
        btn.on('pointerdown', () => { btn.setFrame(frame + '_hover' + '0000'); });
        btn.on('pointerover', () => { btn.setFrame(frame + '_hover' + '0000'); game.scene.getAt(0).sound.add("button hover").play(); });
        btn.on('pointerout', () => { btn.setFrame(frame + '0000'); });
        btn.on('pointerup', () => { btn.setFrame(frame + '0000'); game.scene.getAt(0).sound.add('activity selection - button selection').play(); });
    }

    function setupButtonTextureBased(btn, texture, hoverTexture) {
        btn.on('pointerdown', () => { btn.setTexture(hoverTexture); });
        btn.on('pointerover', () => { btn.setTexture(hoverTexture); game.scene.getAt(0).sound.add("button hover").play(); });
        btn.on('pointerout', () => { btn.setTexture(texture); });
        btn.on('pointerup', () => { btn.setTexture(texture); game.scene.getAt(0).sound.add('activity selection - button selection').play(); });
    }

    (function (sh) {
        var core;
        (function (core) {
            class Gameplay {
                constructor() {
                    this.currentRound = 0;
                    this.currentLetter = 0;
                    this.correctAnswersCount = 0;
                    this.wrongAnswersCount = 0;
                    this.correctAnswersCountThisRound = 0;
                    this.wrongAnswersCountThisRound = 0;
                    this.reset();
                    let json = game.cache.json.get('gameplay');
                    this.wrongAnswersToLose = json["wrongAnswersToLose"];
                    this.numberOfQuestionsPerRound = json["numberOfQuestionsPerRound"];
                    this.lettersConfig = JSON.parse(JSON.stringify(json["lettersConfig"]));
                    this.rounds = JSON.parse(JSON.stringify(json["rounds"]));
                    this.numberOfRounds = json["numberOfRounds"] ?? this.rounds.length;
                    this.useImages = Boolean(game.cache.json.get('gameplay')["useImages"]);
                }
                setupCallbacks(onComplete, onLose) {
                    this.onComplete = onComplete;
                    this.onLose = onLose;
                }
                onLetterChosen(forceNewRound) {
                    if (forceNewRound || this.isNewRound()) {
                        return this.nextRound();
                    }
                    return false;
                }
                nextRound() {
                    this.correctAnswersCountThisRound = 0;
                    this.wrongAnswersCountThisRound = 0;
                    this.currentRound++;
                    if (this.isRoundsComplete()) {
                        this.onComplete(this.correctAnswersCount, this.correctAnswersCount);
                        return true;
                    }

                    return false;
                }
                getCorrectLetters() {
                    return this.rounds[this.currentRound]['correctLetters'];
                }
                isCorrectLetterAudioQuestionEnable() {
                    return this.rounds[this.currentRound]['audioQuestionEnable'];
                }
                getCorrectAudioKey() {
                    return this.rounds[this.currentRound]["correctAudioKey"];
                }
                onCorrectAnswer() {
                    this.correctAnswersCountThisRound++;
                    this.correctAnswersCount++;
                    return this.onLetterChosen();
                }
                onWrongAnswer(forceNewRound) {
                    this.wrongAnswersCountThisRound++;
                    this.wrongAnswersCount++;
                    if (this.wrongAnswersCount >= this.wrongAnswersToLose) {
                        this.onLose(this.correctAnswersCount, this.correctAnswersCount);
                        return true;
                    }
                    else {
                        this.onLetterChosen(forceNewRound);
                    }
                    return false;
                }

                getMaxTotalAnswersCount() {
                    return this.wrongAnswersToLose + this.numberOfRounds - 1;
                }

                getCurrentTotalAnswersCount() {
                    return this.correctAnswersCount + this.wrongAnswersCount;
                }
                isNewRound() {
                    return this.correctAnswersCountThisRound >= 1 || (this.correctAnswersCountThisRound + this.wrongAnswersCountThisRound) === 4 || (this.correctAnswersCountThisRound + this.wrongAnswersCountThisRound) === 0;
                }
                isRoundsComplete() {
                    return this.currentRound >= this.numberOfRounds && this.wrongAnswersCount < this.wrongAnswersToLose;
                }
                reset() {
                    this.currentRound = 0;
                    this.correctAnswersCount = 0;
                    this.wrongAnswersCount = 0;
                }
                getCurrentRoundLetters() {
                    return this.rounds[this.currentRound]["letters"];
                }
            }
            core.Gameplay = Gameplay;
        })(core = sh.core || (sh.core = {}));
    })(sh || (sh = {}));

    (function (sh) {
        var scene;
        (function (scene) {
            class Boot extends Phaser.Scene {
                init() {
                    this.game.scale.transformX = (pageX) => {
                        let offsetLeft = 0;
                        let parentElement = game.canvas.parentElement;
                        while (parentElement) {
                            if (parentElement.offsetLeft) {
                                offsetLeft = parentElement.offsetLeft;
                                break;
                            }
                            parentElement = parentElement.parentElement;
                        }
                        return (pageX - offsetLeft) * this.game.scale.displayScale.x;
                    };
                    this.game.scale.transformY = (pageY) => {
                        let offsetTop = 0;
                        let parentElement = game.canvas.parentElement;
                        while (parentElement) {
                            if (parentElement.offsetTop) {
                                offsetTop = parentElement.offsetTop;
                                break;
                            }
                            parentElement = parentElement.parentElement;
                        }
                        return (pageY - offsetTop) * this.game.scale.displayScale.y;
                    };
                }
                create() {
                    game.scene.remove('Boot');
                    game.scene.add('Preloader', sh.scene.Preloader, true);
                }
            }
            scene.Boot = Boot;
        })(scene = sh.scene || (sh.scene = {}));
    })(sh || (sh = {}));

    (function (sh) {
        var scene;
        (function (scene) {
            var Gameplay = sh.core.Gameplay;
            class MainScene extends Phaser.Scene {
                create() {
                    this.gameplay = new Gameplay();
                    this.gameplayScreen = new sh.screen.GameplayScreen(this, this.gameplay);
                    this.children.add(this.gameplayScreen);
                    this.gameplayScreen.showInstructionPage();
                }
            }
            scene.MainScene = MainScene;
        })(scene = sh.scene || (sh.scene = {}));
    })(sh || (sh = {}));

    (function (sh) {
        var scene;
        (function (scene) {
            class Preloader extends Phaser.Scene {
                preload() {
                    if (typeof sh.App.json == "string") this.load.json('gameplay', sh.App.json); else this.game.cache.json.add('gameplay', sh.App.json);
                }
                create() {
                    let json = game.cache.json.get('gameplay');
                    let lettersConfig = json["lettersConfig"];
                    this.load.audio("englQuestion", "assets/games/aeroplane/sound/mp3/letters/englQuestion.mp3");
                    for (let round of json["rounds"]) {
                        let correctAudioKey = round["correctAudioKey"];
                        this.load.audio(correctAudioKey, "assets/games/aeroplane/sound/mp3/letters/Sounds of the letters/" + correctAudioKey.replace(".wav", ".mp3"));
                    }
                    for (let letterName in lettersConfig) {
                        if (json["useImages"]) this.load.image(letterName, "assets/games/aeroplane/imgs/letters/" + letterName + ".png");
                    }
                    let progressTxt = this.add.text(game.scale.width / 2, game.scale.height / 2 + 50, "", {
                        "fontFamily": "QuranEraV3",
                        "fontSize": 25,
                        "color": "#333333",
                        "align": 'center'
                    });
                    progressTxt.setOrigin(0.5, 0.5);
                    this.load.pack('preloader', 'assets/games/aeroplane/pack.json');
                    this.load.on('progress', (value) => {
                        progressTxt.text = Math.ceil(value * 100) + "%";
                    }, this);
                    this.load.on('complete', () => {
                        this.nextScene();
                    });
                    this.load.start();
                }
                static playAnim(animKey, sprite, onComplete = null) {
                    let mainScene = game.scene.getScene('ScreenMain');
                    let data = Preloader.ANIMS_DATA[animKey];
                    if (!mainScene.anims.exists(animKey)) {
                        mainScene.anims.create({
                            key: animKey,
                            frames: mainScene.anims.generateFrameNames(data['atlas'], {
                                start: data['start'], end: data['end'], zeroPad: data['padNum'],
                                prefix: data['prefix'], suffix: ''
                            }),
                            frameRate: data['frameRate'],
                            repeat: data['repeat']
                        });
                    }
                    if (sprite.anims.currentAnim) {
                        sprite.anims.currentAnim.off('complete');
                    }
                    sprite.anims.stop();
                    // sprite.setTexture(data['atlas']);
                    sprite.play(animKey);
                    sprite.anims.currentAnim.once('complete', () => {
                        if (onComplete)
                            onComplete();
                    });
                    return sprite;
                }
                nextScene() {
                    game.scene.remove('Preloader');
                    game.scene.add('ScreenMain', sh.scene.MainScene, true);
                }
            }
            Preloader.ANIMS_DATA = {
                'wrong': {
                    'start': 0,
                    'end': 24,
                    'padNum': 2,
                    'prefix': 'Nah Animation_3',
                    'repeat': 0,
                    'frameRate': 30,
                    'atlas': 'wrong-atlas'
                },
                'idle': {
                    'start': 0,
                    'end': 124,
                    'padNum': 3,
                    'prefix': 'Plane iddle_3',
                    'repeat': -1,
                    'frameRate': 30,
                    'atlas': 'idle-atlas'
                }
            };
            scene.Preloader = Preloader;
        })(scene = sh.scene || (sh.scene = {}));
    })(sh || (sh = {}));
    (function (sh) {
        var screen;
        (function (screen) {
            class AreYouSureWindow extends Phaser.GameObjects.Container {
                constructor(scene, onYes, onNo) {
                    super(scene);
                    this._areYouSurePage = new Phaser.GameObjects.Image(this.scene, -105, 0 - 48, 'Exit warning');
                    this._areYouSurePage.setOrigin(0, 0);
                    this._areYouSurePage.setInteractive();
                    this._btnSureYes = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2 - 95, 485 - 50, 'btnYES1');
                    this._btnSureYes.setInteractive({ cursor: 'pointer' });
                    this._btnSureYes.on('pointerup', () => {
                        onYes;
                        angularComponentRef.backToMenu();
                    });
                    var modalTextStyle = {
                        backgroundColor: 'transparent',
                        stroke: '#ffffff',
                        strokeThickness: 2,
                        lineSpacing: 15,
                        fontFamily: 'Kids Rock DEMO',
                        fontSize: 27,
                        color: '#43425d',
                        wordWrap: true,
                        align: 'center'
                    };
                    var modalText = this.scene.add.text(game.scale.width / 2 + 12, game.scale.height / 2, "Your progress in this activity will not be saved. \n Are you sure you want to exit? ", modalTextStyle);
                    modalText.setOrigin(0.5, 0.5);

                    setupButtonTextureBased(this._btnSureYes, 'btnYES1', 'btnYES2');
                    this._btnSureNo = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2 + 95, 485 - 50, 'btnNO1');
                    this._btnSureNo.setInteractive({ cursor: 'pointer' });
                    this._btnSureNo.on('pointerup', onNo);
                    setupButtonTextureBased(this._btnSureNo, 'btnNO1', 'btnNO2');
                    this.add(this._areYouSurePage);
                    this.add(this._btnSureYes);
                    this.add(this._btnSureNo);
                    this.add(modalText);
                }
            }
            screen.AreYouSureWindow = AreYouSureWindow;
        })(screen = sh.screen || (sh.screen = {}));
    })(sh || (sh = {}));

    (function (sh) {
        var screen;
        (function (screen) {
            class CompleteWindow extends Phaser.GameObjects.Container {
                constructor(scene, onBack, onReplay, onNext) {
                    super(scene);
                    this.music = null;
                    this.setPosition(-104.5, -48);
                    this._bgComplete = new Phaser.GameObjects.Image(this.scene, 0, 0, 'Completion page LATEST UPDATED');
                    this._bgComplete.setOrigin(0, 0);
                    this._bgComplete.setInteractive();
                    this._cup = new Phaser.GameObjects.Image(this.scene, 400, 410, 'Trophy');
                    this._btnBack = new Phaser.GameObjects.Image(this.scene, 570, 570, 'btnBACK1');
                    this._btnReplay = new Phaser.GameObjects.Image(this.scene, 720, 570, 'btnReplay1');
                    this._btnNext = new Phaser.GameObjects.Image(this.scene, 870, 570, 'btnNEXT1');
                    let _CollectedPoints = new Phaser.GameObjects.Image(this.scene, 620, 440, 'Collected Points');
                    this.totalScoreTxt = this.scene.add.text(845, 352, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 35,
                        "color": "#F49F1C",
                        "align": 'center',
                        'stroke': '#70451A',
                        'strokeThickness': 6
                    });
                    this.totalScoreTxt.setOrigin(0.5, 0.5);
                    let grd = this.totalScoreTxt.context.createLinearGradient(0, 0, 0, this.totalScoreTxt.height);
                    grd.addColorStop(0, '#FFFF00');
                    grd.addColorStop(1, '#C17316');
                    this.totalScoreTxt.setFill(grd);
                    this.starScoreTxt = this.scene.add.text(648, 433, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 24,
                        "color": "#FFFFFF",
                        "align": 'center'
                    });
                    this.starScoreTxt.setOrigin(0.5, 0.5);
                    this.add([
                        this._bgComplete,
                        _CollectedPoints,
                        this._cup,
                        this._btnBack,
                        this._btnReplay,
                        this._btnNext,
                        this.totalScoreTxt,
                        this.starScoreTxt
                    ]);
                    this._btnBack.setInteractive({ cursor: 'pointer' });
                    this._btnBack.on('pointerup', () => {
                        onBack(this._btnBack);
                        angularComponentRef.backToMenu();
                        // if (this.music) {
                        //     this.music.stop();
                        // }
                    });
                    setupButtonTextureBased(this._btnBack, 'btnBACK1', 'btnBACK2');
                    this._btnReplay.setInteractive({ cursor: 'pointer' });
                    this._btnReplay.once('pointerup', () => {
                        onReplay(this._btnReplay);
                        if (this.music) {
                            this.music.stop();
                        }
                    });
                    setupButtonTextureBased(this._btnReplay, 'btnReplay1', 'btnReplay2');
                    this._btnNext.setInteractive({ cursor: 'pointer' });
                    this._btnNext.on('pointerup', () => {
                        onNext(this._btnNext);
                        window.angularComponentRef.nextActivity()
                    });
                    setupButtonTextureBased(this._btnNext, 'btnNEXT1', 'btnNEXT2');
                }
                show(score, starScore) {
                    window.angularComponentRef.gameFinish({ score, starScore })
                    this._cup.scale = 1.25;
                    this.scene.tweens.add({
                        targets: this._cup,
                        "scale": 1,
                        duration: 500,
                        ease: Phaser.Math.Easing.Back.Out
                    });
                    this.totalScoreTxt.text = String(window.angularComponentRef.component.userInfo.totalScore);
                    this.starScoreTxt.text = String(starScore);
                    // let music = this.scene.sound.add("viktory");
                    this.music = this.scene.sound.add("Activity completion fantastic");
                    this.music.play();
                }
            }
            screen.CompleteWindow = CompleteWindow;
        })(screen = sh.screen || (sh.screen = {}));
    })(sh || (sh = {}));

    (function (sh) {
        var screen;
        (function (screen) {
            class GameplayScreen extends Phaser.GameObjects.Container {
                constructor(scene, gameplay) {
                    super(scene);
                    let _dy = 640;
                    this.wordRectPositions = [{ x: 81 + 85, y: 393 + 45 }, { x: 303 + 85, y: 393 + 45 }, { x: 511 + 85, y: 393 + 45 }, { x: 725 + 85, y: 393 + 45 }];
                    this.bgMusic = null;
                    this.correctAudio = null;
                    this.wfsnd = null;
                    this.showCompleteWindow = (score, starScore) => {
                        let completeWindow = new screen.CompleteWindow(this.scene, (target) => {
                            this.playBtnClickAnim(target);
                        }, (target) => {
                            this.playBtnClickAnim(target);
                            this.destroyGameplay();
                            this.remove(completeWindow);
                            this.showInstructionPage();
                        }, (target) => {
                            this.playBtnClickAnim(target);
                        });
                        this.setLettersInputEnabled(false);
                        delayedCall(6000, () => {
                            setPageBackground("bg-blue");
                            this.add(completeWindow);
                            completeWindow.show(score, starScore);
                            if (this.bgMusic) this.bgMusic.stop();
                        });
                    };
                    this.showLoseWindow = (score, starScore) => {
                        let tryAgainWindow = new screen.TryAgainWindow(this.scene, (target) => {
                            this.playBtnClickAnim(target);
                        }, (target) => {
                            this.playBtnClickAnim(target);
                            this.destroyGameplay();
                            this.remove(tryAgainWindow);
                            this.showInstructionPage();
                        });
                        this.setLettersInputEnabled(false);
                        delayedCall(2500, () => {
                            setPageBackground("bg-blue");
                            this.add(tryAgainWindow);
                            tryAgainWindow.show(score, starScore);
                            if (this.bgMusic) this.bgMusic.stop();
                        });
                    };
                    this.gameplay = gameplay;
                    window["t"] = this;
                }
                createHexagons() {
                    if (this.contentContainer && this.contentContainer.parentContainer) {
                        this.contentContainer.parentContainer.remove(this.contentContainer);
                    }

                    this.contentContainer = this.scene.add.container(0, 0);
                    this.gameplayContainer.addAt(this.contentContainer, 1);
                    window['this.contentContainer'] = this.contentContainer;

                    window['this.gameplayContainer'] = this.gameplayContainer;

                    this.shipContainer = this.scene.add.container(480 - 1150, 405);
                    this.shipContainer['defY'] = this.shipContainer.y;

                    this.airCraft = this.scene.add.sprite(25, 150, "airBaloon");
                    window['this.airCraft'] = this.airCraft;
                    this.airCraft.setOrigin(0.5, 1);
                    this.shipContainer.add(this.airCraft);
                    sh.scene.Preloader.playAnim('idle', this.airCraft);
                    this.airCraft.setScale(0.9/0.8);

                    this.targetRect1 = this.scene.add.sprite(-180, -199, "targetRect");
                    this.targetRect1.scaleX = 0.98;
                    window['this.targetRect1'] = this.targetRect1;
                    this.shipContainer.add(this.targetRect1);
                    this.targetRect2 = this.scene.add.sprite(1, -199, "targetRect");
                    this.targetRect2.scaleX = 0.98;
                    window['this.targetRect2'] = this.targetRect2;
                    this.shipContainer.add(this.targetRect2);

                    this.bigCorrectRect = this.scene.add.sprite(-90, -199, "bigCorrectRect");
                    window['this.bigCorrectRect'] = this.bigCorrectRect;
                    this.shipContainer.add(this.bigCorrectRect);
                    this.bigCorrectRect.alpha = 0;

                    this.targetRect1.alpha = 0;
                    this.targetRect2.alpha = 0;

                    /* this.scene.tweens.add({
                        targets: this.targetRect1,
                        "y": -199,
                        yoyo: true,
                        duration: 600,
                        delay:600,
                        ease: Phaser.Math.Easing.Quadratic.InOut,
                        repeat: -1
                    });
                    this.scene.tweens.add({
                        targets: this.targetRect2,
                        "y": -199,
                        yoyo: true,
                        duration: 600,
                        ease: Phaser.Math.Easing.Quadratic.InOut,
                        repeat: -1
                    }); */

                    this.shipContainer["defY"] = this.shipContainer.y;
                    this.contentContainer.add(this.shipContainer);
                    window['this.ship'] = this.shipContainer;

                    this.wordsRects = [];
                    let _i = 0;
                    for (let p of this.wordRectPositions) {
                        let hc = this.scene.add.container(this.wordRectPositions[_i]['x'], this.wordRectPositions[_i]['y']);
                        let hcIdleMotionContainer = this.scene.add.container();
                        hc.add(hcIdleMotionContainer);
                        let h = this.scene.add.sprite(0, 0, 'selectRect');
                        h.scaleX = 1.02;
                        hc["-image-"] = h;
                        hc['-draggable-'] = true;
                        hc.add(h);
                        hc["bg"] = h;
                        window['hc_' + _i] = hc;
                        window['h_' + _i] = h;
                        hcIdleMotionContainer.add(h);
                        hc['hcIdleMotionContainer'] = hcIdleMotionContainer;

                        let doIdleMove = () => {
                            if (!this.scene) return;
                            hcIdleMotionContainer['idleTween'] = this.scene.tweens.add({
                                targets: hcIdleMotionContainer,
                                "x": (0 + Math.random() * 6) * (Math.random() > 0.5 ? 1 : -1),
                                "y": (0 + Math.random() * 6) * (Math.random() > 0.5 ? 1 : -1),
                                yoyo: true,
                                delay: Math.random() > 0.5 ? 0 : Math.random() * 500,
                                duration: 1500,
                                ease: Phaser.Math.Easing.Quadratic.InOut,
                                onComplete: doIdleMove,
                                onUpdate: () => {
                                    /* for (let i = 0; i < this.targetBlocks.length; i++) {
                                        let targetBlock = this.targetBlocks[i];
                                        if (!targetBlock['alreadyFilled']) continue;
                                        if  (targetBlock["-block-"] != hc) continue;
                                        hcIdleMotionContainer['idleTween'].paused = true;
                                        hcIdleMotionContainer.x = 0;
                                        hcIdleMotionContainer.y = 0;

                                        let targetRect = i == 0 ? this.targetRect1 : this.targetRect2;
                                        hc.x = targetRect.x;
                                        if (targetBlock.parentContainer) hc.x += targetBlock.parentContainer.x;
                                        hc.x -= 75;
                                        hc.x *= -1;
                                        hc.y = targetRect.y;
                                        if (targetBlock.parentContainer) hc.y += targetBlock.parentContainer.y;
                                        hc.y *= -1;
                                    } */
                                }
                            });
                        };
                        // doIdleMove();

                        hc['startPosition'] = { x: hc.x, y: hc.y };

                        hc["defX"] = p['x'];
                        hc["defY"] = p['y'];
                        this.wordsRects.push(hc);
                        this.contentContainer.add(hc);
                        hc['index'] = _i;
                        _i++;
                    }
                    window['this.cars'] = this.wordsRects;
                }
                createLetters() {
                    /* if (this.letters) {
                        for (let l of this.letters) {
                            l.parentContainer["letter"] = null;
                            l["hexagon"] = null;
                            l.parentContainer.remove(l);
                        }
                    } */
                    this.letters = [];
                    let _letters = this.gameplay.getCurrentRoundLetters();
                    for (let n of _letters) {
                        let wordText;
                        if (this.gameplay.useImages) {
                            wordText = new Phaser.GameObjects.Image(this.scene, 0, 0, n);
                        } else {
                            wordText = this.scene.add.text(0, 0, n, {
                                "fontFamily": "QuranEraV3",
                                "fontSize": 40,
                                "color": "#333333",
                                "align": 'center'
                            });
                            this.add(wordText);
                            wordText.setOrigin(0.5, 0.5);
                            wordText.setPadding({ left: 0, right: 0, top: 65, bottom: 65 });

                            if (wordText.width > 140) wordText.setScale(140 / wordText.width);
                        }
                        wordText["key"] = n;
                        this.letters.push(wordText);
                        window['wordText'] = wordText;
                    }
                }
                showGameplay() {
                    this.isLost = false;
                    setPageBackground("bg-australia");
                    this.bgMusic = this.scene.sound.add("bg_sound");
                    this.bgMusic.play();
                    this.bgMusic.loop = true;
                    this.gameplay.reset();
                    this._gameStage = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2, game.scale.height / 2, 'bg');
                    this._gameStage.setOrigin(0.5, 0.5);
                    this._gameStage.setInteractive();
                    this._btnSound = new Phaser.GameObjects.Image(this.scene, 160 - 105, 100 - 50, 'Sound');
                    this._btnSound.setInteractive({ cursor: 'pointer' });
                    this._btnSound["defScale"] = this._btnSound.scale;
                    setupButtonTextureBased(this._btnSound, 'Sound', 'Sound HOVER EFFECT');
                    this._btnClose = new Phaser.GameObjects.Image(this.scene, 1025 - 105, 100 - 50, 'x Button');
                    this._btnClose.setInteractive({ cursor: 'pointer' });
                    this._btnClose["defScale"] = this._btnClose.scale;
                    setupButtonTextureBased(this._btnClose, 'x Button', 'x Button HOVER EFFECT');
                    this.gameplayContainer = new Phaser.GameObjects.Container(this.scene);
                    this.addAt(this.gameplayContainer, 0);
                    this.gameplayContainer.add([
                        this._gameStage,
                        this._btnSound,
                        this._btnClose
                    ]);

                    this.fgContainer = this.scene.add.container(0, 600);
                    this.fg1 = this.scene.add.sprite(0, 0, "fg");
                    this.fg1.setOrigin(0, 1);
                    this.fgContainer.add(this.fg1);
                    this.fg2 = this.scene.add.sprite(this.fg1.width, 0, "fg");
                    this.fg2.scaleX = -1;
                    this.fg2.setOrigin(1, 1);
                    this.fgContainer.add(this.fg2);
                    this.gameplayContainer.add(this.fgContainer);
                    window['this.fgContainer'] = this.fgContainer;

                    this.createBeehives();
                    this.shuffleOutHexagons();
                    this.gameplay.setupCallbacks(this.showCompleteWindow, this.showLoseWindow);
                }
                createBeehives() {
                    let startX = 142;
                    let startY = 48;
                    let dx = 44;
                    let _BeehiveEmptyArrayPositions = [];
                    for (let i = 0; i < this.gameplay.getMaxTotalAnswersCount(); i++) {
                        _BeehiveEmptyArrayPositions.push({ x: startX + i * dx, y: startY });
                    }
                    this._BeehiveEmptyArray = []; window["_BeehiveEmptyArray"] = this._BeehiveEmptyArray;
                    this._Beehive = [];
                    for (let p of _BeehiveEmptyArrayPositions) {
                        let _BeehiveEmpty = new Phaser.GameObjects.Image(this.scene, p['x'], p['y'], 'Beehive 1 Empty');
                        this._BeehiveEmptyArray.push(_BeehiveEmpty);
                        _BeehiveEmpty.visible = false;
                        let _Beehive = new Phaser.GameObjects.Image(this.scene, p['x'], p['y'], 'Beehive 1');
                        this._Beehive.push(_Beehive);
                    }
                    for (let bea of this._BeehiveEmptyArray) {
                        this.gameplayContainer.add(bea);
                    }
                    for (let bee of this._Beehive) {
                        this.gameplayContainer.add(bee);
                        bee.visible = false;
                    }
                }
                randomizeLettersPosition() {
                    let hx = this.wordsRects.slice();
                    for (let l of this.letters) {
                        if (hx.length == 0)
                            return;
                        let hc = Phaser.Utils.Array.RemoveRandomElement(hx);
                        hc['hcIdleMotionContainer'].add(l);
                        hc["letter"] = l;
                        hc["-letter-text"] = l.key ?? l.text;
                        l["hexagon"] = hc;
                    }
                }
                updateHexagonsArrange() {
                    for (let hc of this.wordsRects) {
                        if (!hc["letter"]) {
                            hc.parentContainer.bringToTop(hc);
                            break;
                        }
                    }
                }
                shuffleOutHexagons() {
                    this.createHexagons();

                    let setLettersInputEnabled = () => {
                        if (this.correctAudio && this.correctAudio.isPlaying) {
                            delayedCall((this.correctAudio.duration * 0.75) * 1000, () => {
                                this.setLettersInputEnabled(true);
                            });
                        }
                        else {
                            this.setLettersInputEnabled(true);
                        }
                    };

                    if (!this.gameplay.isRoundsComplete()) {
                        delayedCall(2900, () => {
                            if (this.gameplay.isCorrectLetterAudioQuestionEnable()) {
                                this.playCorrectAudio();
                            }
                            setLettersInputEnabled();
                        });
                    }

                    if (this.sfxCarAccelerating) {
                        this.sfxCarAccelerating.stop();
                        this.sfxCarAccelerating = null;
                    }
                    if (this.sfxWrong) {
                        this.sfxWrong.stop();
                        this.sfxWrong = null;
                    }

                    if (!this.gameplay.isRoundsComplete()) {
                        this.createLetters();
                        this.randomizeLettersPosition();
                    }

                    this.setLettersInputEnabled(false);
                    this.updateHexagonsArrange();
                    // Phaser.Utils.Array.Shuffle(this.carsPositions);
                    let cars = this.wordsRects;
                    for (let i = 0; i < cars.length; i++) {
                        let hc = cars[i];
                        hc["defX"] = this.wordRectPositions[i]["x"];
                        hc["defY"] = this.wordRectPositions[i]["y"];
                        this.scene.tweens.killTweensOf(hc);

                        hc.alpha = 0;
                        delayedCall(2400, () => {
                            this.scene.tweens.add({
                                targets: hc,
                                alpha: 1,
                                duration: 300,
                                ease: Phaser.Math.Easing.Cubic.Out,
                                delay: 200 + i * 125
                            });
                            this.scene.sound.add('Blocks appearing in each round').play();
                        });
                    }

                    this.scene.tweens.add({
                        targets: this.targetRect1,
                        "alpha": 1,
                        duration: 900,
                        delay: 1700
                    });
                    this.scene.tweens.add({
                        targets: this.targetRect2,
                        "alpha": 1,
                        duration: 900,
                        delay: 2100
                    });

                    var snd = this.scene.sound.add('Plane coming in');
                    snd.setRate(1.15);
                    snd.play();
                    this.scene.tweens.add({
                        targets: this.shipContainer,
                        "x": 480,
                        duration: 2250,
                        // ease: Phaser.Math.Easing.Cubic.Out,
                        onComplete: () => {
                            //ship idle movement

                            /* this.scene.tweens.add({
                                targets: this.shipContainer,
                                "y": this.shipContainer.y - 7,
                                duration: 1500-500,
                                repeat: -1,
                                yoyo: true
                            }); */
                        }
                    });

                    for (let c of cars) this.gameplayContainer.remove(c);
                    this.wordsRects.sort((c1, c2) => c1.y - c2.y);
                    // for (let c of cars) this.gameplayContainer.add(c);

                    this.createInput();
                }
                shuffleInHexagons() {
                    this.updateHexagonsArrange();
                    let positions = this.wordRectPositions.slice();
                    this.setLettersInputEnabled(false);

                    // delayedCall(600, () => {
                    // this.scene.sound.add('move to centre').play();
                    this.shuffleOutHexagons();
                    // });
                }
                onCorrectDragsMade() {
                    let completed = this.onCorrectAnswer();

                    // this.scene.sound.add('First meteor explostion').play();

                    this.setLettersInputEnabled(false);

                    // this.scene.sound.add('Snail giggling sound - correct selection').play();

                    delayedCall(1700 + 1500, () => {
                        for (let _hc of this.wordsRects) {
                            this.scene.tweens.add({
                                targets: _hc,
                                "x": _hc.x + 900,
                                ease: Phaser.Math.Easing.Cubic.In,
                                duration: 1750,
                                delay: 0
                            });
                        }
                        this.scene.tweens.killTweensOf(this.shipContainer);

                        this.scene.sound.add('Plane leaving sound').play();
                        this.scene.tweens.add({
                            targets: this.shipContainer,
                            "x": this.shipContainer.x + 900,
                            ease: Phaser.Math.Easing.Cubic.In,
                            duration: 1750,
                            delay: 0
                        });
                    });

                    // delayedCall(650, () => this.scene.sound.add('Going up sound').play())
                    // if (completed) delayedCall(1750, () => this.scene.sound.add('Final celebration sound').play())

                    delayedCall(completed ? 3700 : 3950 + 1500, () => {
                        if (!completed) {
                            this.shuffleInHexagons();
                        } else {
                            this.scene.sound.add("Success 2").play();
                        }
                    });

                    // this.playBtnClickAnim(hc);
                    /* let lost = false;
                    if (correctAnswer) {
                    } else {
                        sh.scene.Preloader.playAnim('wrong', this.airCraft, () => {
                            sh.scene.Preloader.playAnim('idle', this.airCraft);
                            this.airCraft.setScale(1 / 0.9);
                        });
                        this.airCraft.setScale(1);

                        this.scene.tweens.add({
                            targets: hc,
                            alpha: 0,
                            duration: 500
                        });

                        delayedCall(700, () => { hc.visible = false; });
                        lost = this.onWrongAnswer();
                        if (!lost) {
                            // this.shuffleInHexagons();
                        } else {
                            this.isLost = true;
                        }
                    } */
                }
                createInput() {
                    this.scene.input.on('drag', (pointer, block, dragX, dragY) => {
                        if (!block['-draggable-'])
                            return;
                        block.x = dragX;
                        block.y = dragY;
                        block.parentContainer.bringToTop(block);
                    });
                    console.log("CORRECT WORDS: ", this.gameplay.getCorrectLetters());
                    this.targetBlocks = [];
                    let bb = [{ x: 300, y: 206 }, { x: 481, y: 206 }];
                    for (let i = 0; i < 2; i++) {
                        let b = bb[i];
                        b['alreadyFilled'] = false;
                        this.targetBlocks.push(b);
                        b["-letter-text"] = this.gameplay.getCorrectLetters()[i];
                        b["-index-"] = i;
                        b["-block-"] = null;
                    }
                    window['this.targetBlocks'] = this.targetBlocks;

                    for (let a of this.wordsRects) {
                        // let correctAnswer = hc["letter"] && hc["letter"]["key"] == this.gameplay.getCorrectLetters(1);
                        //hc["letter"].alpha = correctAnswer ? 1 : 0.5;

                        a.setSize(a["-image-"].width, a["-image-"].height);
                        a.setInteractive({ cursor: 'pointer' });
                        this.scene.input.setDraggable(a, true);
                        a.on('pointerdown', () => {
                            if (a["-placedAtBlock-"]) {
                                a["-placedAtBlock-"]['alreadyFilled'] = false;
                                a["-placedAtBlock-"] = null;
                            }

                            a['-pointerdown-'] = true;
                            if (a['-draggable-']) this.scene.sound.add("Move the block from its spot").play();
                        });
                        a.on('pointerup', () => {
                            a['-pointerdown-'] = false;
                            if (!a['-draggable-'])
                                return;

                            let wasTargetBlockFound = false;
                            let targetBlock;
                            for (targetBlock of this.targetBlocks) {
                                if (targetBlock['alreadyFilled'])
                                    continue;
                                if (Phaser.Math.Distance.Between(a.x, a.y, targetBlock.x, targetBlock.y) < 50) {
                                    //as
                                    // a['-draggable-'] = false;
                                    targetBlock['alreadyFilled'] = true;
                                    this.scene.tweens.add({
                                        targets: a,
                                        x: targetBlock.x,
                                        y: targetBlock.y,
                                        duration: 300,
                                        ease: Phaser.Math.Easing.Back.Out
                                    });
                                    targetBlock["-block-"] = a;
                                    a["-placedAtBlock-"] = targetBlock;
                                    this.scene.sound.add("Dopping the block").play();

                                    wasTargetBlockFound = true;
                                    break;
                                }
                            }

                            let allTargetsFilled = true;
                            for (targetBlock of this.targetBlocks) {
                                if (!targetBlock['alreadyFilled']) {
                                    allTargetsFilled = false;
                                    break;
                                }
                            }
                            if (allTargetsFilled) this.checkTargetBlockLetters();

                            if (!wasTargetBlockFound) {
                                this.moveBridgeBackToStartPosition(a, null, true);
                            }
                        });
                        a.on('pointerout', () => {
                            if (!a['-draggable-'])
                                return;
                            if (!a['-pointerdown-'])
                                return;
                            this.moveBridgeBackToStartPosition(a, null, true);
                        });
                    }
                    this._btnSound.on('pointerup', () => {
                        this.playBtnClickAnim(this._btnSound);
                        this.onSoundClick();
                    });
                    this._btnClose.on('pointerup', () => {
                        this.playBtnClickAnim(this._btnClose);
                        this.onCloseClick();
                    });
                }
                hideAllUnusedBeehives() {
                    let i = this.gameplay.getCurrentTotalAnswersCount();
                    for (let k = i + 1; k < this._BeehiveEmptyArray.length; k++) {
                        this._BeehiveEmptyArray[k].visible = false;
                        this._Beehive[k].visible = false;
                    }
                }
                checkTargetBlockLetters() {
                    let sameLettersNum = 0;
                    for (let targetBlock of this.targetBlocks) {
                        if (!targetBlock['-block-']) {
                            // this.scene.sound.add("Placing block above").play();
                            return;
                        }
                        if (targetBlock["-letter-text"] == targetBlock['-block-']["-letter-text"]) {
                            sameLettersNum++;
                        }
                    }
                    this.setLettersInputEnabled(false);
                    if (sameLettersNum == this.targetBlocks.length) {
                        delayedCall(3000, () => {
                            for (let _hc of this.wordsRects) {
                                if (_hc['-placedAtBlock-']) continue;
                                this.scene.tweens.add({
                                    targets: _hc,
                                    "alpha": 0,
                                    ease: Phaser.Math.Easing.Cubic.In,
                                    duration: 900,
                                    delay: 0
                                });
                            }
                            this.scene.sound.add("Blocks disappearing").play();
                        });

                        delayedCall(1000, () => {
                            let _letter1, _letter2;
                            for (let _hc of this.wordsRects) {
                                if (!_hc['-placedAtBlock-']) continue;

                                if (_hc['-placedAtBlock-']["-index-"] === 0) {
                                    _letter1 = _hc['letter'];
                                } else {
                                    _letter2 = _hc['letter'];
                                }
                            }
                            let mid = (_letter1.width + _letter2.width) / 2;
                            let _dx = mid - _letter1.width;

                            for (let _hc of this.wordsRects) {
                                if (!_hc['-placedAtBlock-']) continue;
                                let dx = this.gameplay.useImages ? 90 : 75;
                                if (_hc['-placedAtBlock-']["-index-"] === 0) {
                                    this.scene.tweens.add({
                                        targets: _hc['letter'],
                                        "x": _hc['letter'].x + dx - _dx,
                                        "originX": 1,
                                        delay: 0,
                                        duration: 300,
                                        onUpdate: () => {
                                            _hc['letter'].setOrigin(_hc['letter'].originX, _hc['letter'].originY);
                                        }
                                    });
                                } else {
                                    this.scene.tweens.add({
                                        targets: _hc['letter'],
                                        "x": _hc['letter'].x - dx - _dx,
                                        "originX": 0,
                                        delay: 0,
                                        duration: 300,
                                        onUpdate: () => {
                                            _hc['letter'].setOrigin(_hc['letter'].originX, _hc['letter'].originY);
                                        }
                                    });
                                }

                                this.scene.tweens.add({
                                    targets: _hc["bg"],
                                    "alpha": 0,
                                    duration: 300
                                });
                            }
                            this.scene.tweens.add({
                                targets: this.bigCorrectRect,
                                "alpha": 1,
                                duration: 300
                            });

                            this.onCorrectDragsMade();
                        });
                    } else {
                        // for (let targetBlock of this.targetBlocks) targetBlock['-block-']["-image-"].setTexture('DoughWrong');

                        // delayedCall(500, () => { this.scene.sound.add("wrong drop").play(); });
                        delayedCall(1800, () => {
                            for (let targetBlock of this.targetBlocks) {
                                // for (let targetBlock of this.targetBlocks) targetBlock['-block-']["-image-"].setTexture('DoughNormal');
                                this.moveBridgeBackToStartPosition(targetBlock['-block-'], null, false);
                            }
                            for (let targetBlock of this.targetBlocks) {
                                targetBlock['alreadyFilled'] = false;
                                targetBlock['-block-']['-draggable-'] = true;
                                targetBlock['-block-']["-placedAtBlock-"] = null;
                                targetBlock["-block-"] = null;
                            }
                            // delayedCall(100, ()=>this.scene.sound.add("all three blocks move back after wrong").play());
                        });
                        delayedCall(1500, () => this.scene.sound.add("Two blocks move back after a wrong placement").play());
                        delayedCall(150, () => {
                            let lost = this.onWrongAnswer();

                            delayedCall(650, () => { this.scene.sound.add('No snail animation sound').play(); });
                            delayedCall(750, () => {
                                sh.scene.Preloader.playAnim('wrong', this.airCraft, () => {
                                    sh.scene.Preloader.playAnim('idle', this.airCraft);                                    
                                    this.airCraft.setScale(0.9/0.8);
                                });
                                this.airCraft.setScale(1);
                            });

                            // delayedCall(500, () => {
                            if (!lost) this.setLettersInputEnabled(true);
                            // });
                        });
                    }
                }
                moveBridgeBackToStartPosition(block, onComplete, playSound) {
                    this.scene.tweens.add({
                        targets: block,
                        x: block['startPosition'].x,
                        y: block['startPosition'].y,
                        duration: 350,
                        ease: Phaser.Math.Easing.Sine.Out,
                        onComplete: () => {
                            if (onComplete)
                                onComplete();
                        }
                    });
                    if (Phaser.Math.Distance.Between(block['startPosition'].x, block['startPosition'].y, block.x, block.y) > 20) {
                        delayedCall(100, () => {
                            if (playSound) {
                                this.scene.sound.add("Block goes back when released").play();
                            }
                        });
                    }
                }
                onCorrectAnswer() {
                    let correctAudioKey = this.gameplay.getCorrectAudioKey();
                    delayedCall(600, () => {
                        this.scene.sound.add(correctAudioKey).play();
                    });

                    let i = this.gameplay.getCurrentTotalAnswersCount();
                    if (i < this._BeehiveEmptyArray.length) {
                        this._BeehiveEmptyArray[i].visible = false;
                        this._Beehive[i].visible = true;
                    }
                    this.hideAllUnusedBeehives();
                    let completed = this.gameplay.onCorrectAnswer();
                    this.scene.sound.add('Correct sfx').play();

                    // this.sfxCarAccelerating = this.scene.sound.add('Car accelerating');
                    // this.sfxCarAccelerating.play();

                    return completed;
                }
                onWrongAnswer(forceNewRound) {
                    let i = this.gameplay.getCurrentTotalAnswersCount();
                    if (i < this._BeehiveEmptyArray.length) {
                        this._BeehiveEmptyArray[i].visible = true;
                        this._Beehive[i].visible = false;
                    }
                    this.hideAllUnusedBeehives();
                    let lost = this.gameplay.onWrongAnswer(forceNewRound);
                    this.sfxWrong = this.scene.sound.add("wrong sfx");
                    this.sfxWrong.play();
                    return lost;
                }
                playCorrectAudio() {
                    if (this.correctAudio) {
                        this.correctAudio.stop();
                    }
                    this.correctAudio = this.scene.sound.add("englQuestion");
                    this.correctAudio.once('complete', () => {
                        this.correctAudio = this.scene.sound.add(this.gameplay.getCorrectAudioKey());
                        this.correctAudio.play();
                    });
                    this.correctAudio.play();
                    if (this.areYouSureWindow && this.areYouSureWindow.parentContainer == this) {
                        this.correctAudio.pause();
                    }
                }
                onSoundClick() {
                    this.playCorrectAudio();
                }
                onCloseClick() {
                    this.showAreYouSurePage();
                    this.scene.sound.add('warning page pop up sfx').play();
                }
                playBtnClickAnim(target) {
                    let sc = target["defScale"] ? target["defScale"] : 1;
                    target.scaleX = target.scaleY = sc;
                    this.scene.tweens.add({
                        targets: target,
                        "scaleX": 0.9 * sc,
                        "scaleY": 0.9 * sc,
                        duration: 100,
                        yoyo: true
                    });
                }
                showInstructionPage() {
                    setPageBackground("bg-blue");
                    this.instructionPage = new screen.InstructionPage(this.scene, (target) => {
                        this.playBtnClickAnim(target);
                        this.remove(this.instructionPage);
                        this.showGameplay();
                        if (this.wfsnd) {
                            this.wfsnd.stop();
                        }
                    }, (target) => {
                        this.playBtnClickAnim(target);
                        if (this.wfsnd) {
                            this.wfsnd.stop();
                        }
                        if (!game.cache.json.get('gameplay')['welcomeAudioDisabled']) {
                            this.wfsnd = this.scene.sound.add("Welcome Find the sound");
                            this.wfsnd.play();
                        }
                    });
                    this.add(this.instructionPage);
                    try {
                        if (!game.cache.json.get('gameplay')['welcomeAudioDisabled']) {
                            this.wfsnd = this.scene.sound.add("Welcome Find the sound");
                            this.wfsnd.play();
                        }
                    }
                    catch (e) {
                        console.error(e);
                    }
                }
                showAreYouSurePage() {
                    /* for (let j = 0; j < this.cars.length; j++) {
                        if (this.cars[j]["raceTween"]) {
                            this.cars[j]["raceTween"].pause();
                        }
                    } */

                    pauseAllDelayedCalls();
                    setPageBackground("bg-blue");
                    this.pauseSounds();
                    if (!this.areYouSureWindow) this.areYouSureWindow = new screen.AreYouSureWindow(this.scene, () => {
                        this.remove(this.areYouSureWindow);
                        this.destroyGameplay();
                        this.showInstructionPage();
                    }, () => {
                        this.remove(this.areYouSureWindow);
                        this.unpauseSounds();
                        resumeAllDelayedCalls();

                        /* for (let j = 0; j < this.cars.length; j++) {
                            if (this.cars[j]["raceTween"]) {
                                this.cars[j]["raceTween"].resume();
                            }
                        } */

                        setPageBackground("bg-australia");
                    });
                    this.add(this.areYouSureWindow);
                }
                setLettersInputEnabled(enabled) {
                    if (enabled) {
                        for (let hc of this.wordsRects) {
                            hc.setInteractive({ cursor: 'pointer' });
                            this.scene.input.setDraggable(hc, true);
                            // hc["bg"].setInteractive(new Phaser.Geom.Rectangle(80, 100, 240, 200), Phaser.Geom.Rectangle.Contains);
                        }
                    }
                    else {
                        for (let hc of this.wordsRects) {
                            try { this.scene.input.setDraggable(hc, false); } catch (e) { }
                            hc.disableInteractive();
                        }
                    }
                }
                pauseSounds() {
                    if (this.correctAudio)
                        this.correctAudio.pause();
                    if (this.bgMusic)
                        this.bgMusic.pause();
                }
                unpauseSounds() {
                    if (this.correctAudio)
                        this.correctAudio.resume();
                    if (this.bgMusic)
                        this.bgMusic.resume();
                }
                destroyGameplay() {
                    this.setLettersInputEnabled(false);
                    this.remove(this.gameplayContainer);
                    this.scene.sound.stopAll();
                    destroyAllDelayedCalls();
                }
            }
            screen.GameplayScreen = GameplayScreen;
        })(screen = sh.screen || (sh.screen = {}));
    })(sh || (sh = {}));
    (function (sh) {
        var screen;
        (function (screen) {
            class InstructionPage extends Phaser.GameObjects.Container {
                constructor(scene, onPlayClick, onSndClick) {
                    super(scene);
                    this._instructionPage = new Phaser.GameObjects.Image(this.scene, 0 - 105, 0 - 48, 'Instructions page  ALL ACTIVITY  TITLEs');
                    this._instructionPage.setOrigin(0, 0);
                    this._instructionPage.setInteractive();

                    this._instructionPageTitle = this.scene.add.text(475, 110, sh.App.json.instructionTitle ?? 'Aeroplane', {
                        "fontFamily": "Kids Rock DEMO",
                        "fontSize": 45,
                        "color": "#43425D",
                        "align": 'center'
                    });
                    this._instructionPageTitle.setOrigin(0.5, 0.5);
                    window['this._instructionPageTitle'] = this._instructionPageTitle;
                    this._instructionPageTitle.setStroke('#ffffff', 5);
                    //  Apply the gradient fill.
                    const gradient = this._instructionPageTitle.context.createLinearGradient(0, 0, 0, this._instructionPageTitle.height);
                    gradient.addColorStop(0, '#eeef67');
                    gradient.addColorStop(0.55, '#e98c2c');
                    gradient.addColorStop(1, '#91301a');
                    this._instructionPageTitle.setFill(gradient);

                    this._btnPlay = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2, 480 - 50, 'btnPLAY1');
                    this._btnPlay.setInteractive({ cursor: 'pointer' });
                    this._btnPlay.once('pointerup', onPlayClick);
                    setupButtonTextureBased(this._btnPlay, 'btnPLAY1', 'btnPLAY2');
                    this.instrTxt = this.scene.add.text(game.scale.width / 2, game.scale.height / 2, "Use the words to make the verse on\n the flag.", {
                        "fontFamily": "Kids Rock DEMO",
                        "fontSize": 30,
                        "lineSpacing": 15,
                        "color": "#43425D",
                        "align": 'center'
                    });
                    this.instrTxt.setOrigin(0.5, 0.5);
                    this._btnSoundInstruction = new Phaser.GameObjects.Image(this.scene, 800 - 105, 156 - 50, 'Sound');
                    this._btnSoundInstruction.setInteractive({ cursor: 'pointer' });
                    this._btnSoundInstruction.on('pointerup', onSndClick);
                    this._btnSoundInstruction["defScale"] = this._btnSoundInstruction.scale;
                    setupButtonTextureBased(this._btnSoundInstruction, 'Sound', 'Sound HOVER EFFECT');
                    this.add(this._instructionPage);
                    this.add(this._instructionPageTitle);
                    this.add(this.instrTxt);
                    this.add(this._btnPlay);
                    this.add(this._btnSoundInstruction);
                }
            }
            screen.InstructionPage = InstructionPage;
        })(screen = sh.screen || (sh.screen = {}));
    })(sh || (sh = {}));
    (function (sh) {
        var screen;
        (function (screen) {
            class TryAgainWindow extends Phaser.GameObjects.Container {
                constructor(scene, onBack, onReplay) {
                    super(scene);
                    this.music = null;
                    this.setPosition(-106, -48);
                    this._bg = new Phaser.GameObjects.Image(this.scene, 0, 0, 'Try again page');
                    this._bg.setOrigin(0, 0);
                    this._bg.setInteractive();
                    this._star = new Phaser.GameObjects.Image(this.scene, 400, 415, 'Break Star');
                    this._btnBack = new Phaser.GameObjects.Image(this.scene, 600, 580, 'btnBACK1');
                    this._btnReplay = new Phaser.GameObjects.Image(this.scene, 765, 580, 'btnReplay1');
                    this.totalScoreTxt = this.scene.add.text(850, 355, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 35,
                        "color": "#F49F1C",
                        "align": 'center',
                        'stroke': '#70451A',
                        'strokeThickness': 6
                    });
                    this.totalScoreTxt.setOrigin(0.5, 0.5);
                    let grd = this.totalScoreTxt.context.createLinearGradient(0, 0, 0, this.totalScoreTxt.height);
                    grd.addColorStop(0, '#FFFF00');
                    grd.addColorStop(1, '#C17316');
                    this.totalScoreTxt.setFill(grd);
                    this.starScoreTxt = this.scene.add.text(635, 431, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 24,
                        "color": "#FFFFFF",
                        "align": 'center'
                    });
                    this.starScoreTxt.setOrigin(0.5, 0.5);
                    this.add([
                        this._bg,
                        this._star,
                        this._btnBack,
                        this._btnReplay,
                        this.totalScoreTxt,
                        this.starScoreTxt
                    ]);
                    this._btnBack.setInteractive({ cursor: 'pointer' });
                    this._btnBack.on('pointerup', () => {
                        onBack(this._btnBack);
                        angularComponentRef.backToMenu();
                        // if (this.music) {
                        //     this.music.stop();
                        // }
                    });
                    setupButtonTextureBased(this._btnBack, 'btnBACK1', 'btnBACK2');
                    this._btnReplay.setInteractive({ cursor: 'pointer' });
                    this._btnReplay.once('pointerup', () => {
                        onReplay(this._btnReplay);
                        if (this.music) {
                            this.music.stop();
                        }
                    });
                    setupButtonTextureBased(this._btnReplay, 'btnReplay1', 'btnReplay2');
                }
                show(score, starScore) {
                    this._star.scale = 1.25;
                    this.scene.tweens.add({
                        targets: this._star,
                        "scale": 1,
                        duration: 500,
                        ease: Phaser.Math.Easing.Back.Out
                    });
                    this.totalScoreTxt.text = String(window.angularComponentRef.component.userInfo.totalScore);
                    this.starScoreTxt.text = String(0);
                    this.music = this.scene.sound.add("Fail - close one");
                    this.music.play();
                }
            }
            screen.TryAgainWindow = TryAgainWindow;
        })(screen = sh.screen || (sh.screen = {}));
    })(sh || (sh = {}));
}

function destroyAeroPlane() {
    if (game) {
        game.destroy();
    }
}

var game;
var sh;
function birdGame(json) {
    /**
     * @author Roman Parada
     * This class is created to fix overlapping of bottom part of canvas by navigation bar in iOS.
     * It make a delayed resize of the canvas (like Phaser-3 FIT methods does) and it overrides Phaser-3 input window to Phaser-3 core transform methods
     *
     * How to use:
     * Just call the code line below in Boot scene's init() method of your project:
     * new FitScaleManager(this.game).setup();
     */
    class FitScaleManager {
        constructor(game) {
            this.doResize = () => {
                let scale = this.calculateScale();
                let newCanvasWidth = this.phaserScaleManager.width * scale;
                let newCanvasHeight = this.phaserScaleManager.height * scale;
                this.canvasStyle.width = newCanvasWidth + 'px';
                this.canvasStyle.height = newCanvasHeight + 'px';
                this.canvasStyle.marginLeft = (window.innerWidth - newCanvasWidth) / 2 + 'px';
                this.canvasStyle.marginTop = (window.innerHeight - newCanvasHeight) / 2 + 'px';
            };
            this.game = game;
            this.canvasStyle = this.game.canvas.style;
            this.phaserScaleManager = this.game.scale;
        }
        static detectBestScaleMode() {
            let iOS = /iPad|iPhone|iPod/.test(navigator.platform || "");
            let isAndroid = window.navigator.userAgent.toLowerCase().indexOf("android") > -1;
            return iOS || isAndroid ? Phaser.Scale.FIT : Phaser.Scale.NONE;
        }
        ;
        /**
         * Just call this method once in Boot scene's init() method
         */
        setup() {
            this.phaserScaleManager.addListener(Phaser.Scale.Events.RESIZE, this.onResize, this);
            this.overridePhaserTransformMethods();
            this.onResize();
        }
        calculateScale() {
            if (game.scale.scaleMode === Phaser.Scale.NONE)
                return 1;
            return Math.min(window.innerWidth / this.phaserScaleManager.width, window.innerHeight / this.phaserScaleManager.height);
        }
        overridePhaserTransformMethods() {
            this.game.scale.transformX = (pageX) => {
                return (pageX - parseInt(this.canvasStyle.marginLeft.split("px")[0])) / this.calculateScale();
            };
            this.game.scale.transformY = (pageY) => {
                return (pageY - parseInt(this.canvasStyle.marginTop.split("px")[0])) / this.calculateScale();
            };
        }
        onResize() {
            setTimeout(this.doResize, FitScaleManager.RESIZE_DELAY);
        }
    }
    FitScaleManager.RESIZE_DELAY = 500;

    (function (sh) {
        class App extends Phaser.Game {
            constructor(json) {
                App.json = json;
                // console.log(App.json);

                let config = {
                    type: Phaser.AUTO,
                    width: App.CANVAS_WIDTH,
                    height: App.CANVAS_HEIGHT,
                    parent: 'game-container',
                    dom: {
                        createContainer: false
                    },
                    scale: {
                        mode: FitScaleManager.detectBestScaleMode(),
                        autoCenter: Phaser.Scale.CENTER_BOTH
                    },
                    transparent: true,
                    scene: {
                        create: () => {
                            this.scene.add('Boot', sh.scene.Boot, true);
                        }
                    }
                };
                super(config);
            }
        }
        App.CANVAS_WIDTH = 980;//490;
        App.CANVAS_HEIGHT = 600;//797;
        sh.App = App;
    })(sh || (sh = {}));

    game = new sh.App(json);

    var delayedCalls = [];
    function delayedCall(delay, callback, args, callbackScope) {
        let scene = game.scene.getAt(0);
        if (scene) {
            let dc = scene.time.delayedCall(delay, callback, args, callbackScope);
            delayedCalls.push(dc);
            return dc;
        }
        let t = setTimeout(callback, delay);
        delayedCalls.push(t);
        return t;
    }

    function pauseAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.paused = true;
            }
        }
    }

    function resumeAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.paused = false;
            }
        }
    }

    function destroyAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.remove(false);
            }
            else {
                clearTimeout(dc);
            }
        }
        delayedCalls = [];
    }

    function setPageBackground(bg) {
        // document.querySelector("html").style.backgroundImage = "url(assets/games/bird-game/imgs/" + bg + ".jpg)";
    }

    function setupButton(btn, frame) {
        btn.on('pointerdown', () => { btn.setFrame(frame + '_hover' + '0000'); });
        btn.on('pointerover', () => { btn.setFrame(frame + '_hover' + '0000'); game.scene.getAt(0).sound.add("button hover").play(); });
        btn.on('pointerout', () => { btn.setFrame(frame + '0000'); });
        btn.on('pointerup', () => { btn.setFrame(frame + '0000'); game.scene.getAt(0).sound.add('activity selection - button selection').play(); });
    }

    function setupButtonTextureBased(btn, texture, hoverTexture) {
        btn.on('pointerdown', () => { btn.setTexture(hoverTexture); });
        btn.on('pointerover', () => { btn.setTexture(hoverTexture); game.scene.getAt(0).sound.add("button hover").play(); });
        btn.on('pointerout', () => { btn.setTexture(texture); });
        btn.on('pointerup', () => { btn.setTexture(texture); game.scene.getAt(0).sound.add('activity selection - button selection').play(); });
    }

    (function (sh) {
        var core;
        (function (core) {
            class Gameplay {
                constructor() {
                    this.currentRound = 0;
                    this.currentLetter = 0;
                    this.correctAnswersCount = 0;
                    this.wrongAnswersCount = 0;
                    this.correctAnswersCountThisRound = 0;
                    this.wrongAnswersCountThisRound = 0;
                    this.reset();
                    let json = game.cache.json.get('gameplay');
                    this.wrongAnswersToLose = json["wrongAnswersToLose"];
                    this.numberOfQuestionsPerRound = json["numberOfQuestionsPerRound"];
                    this.lettersConfig = JSON.parse(JSON.stringify(json["lettersConfig"]));
                    this.rounds = JSON.parse(JSON.stringify(json["rounds"]));
                    this.numberOfRounds = json["numberOfRounds"] ?? this.rounds.length;
                    this.useImages = Boolean(game.cache.json.get('gameplay')["useImages"]);
                }
                setupCallbacks(onComplete, onLose) {
                    this.onComplete = onComplete;
                    this.onLose = onLose;
                }
                onLetterChosen(forceNewRound) {
                    if (forceNewRound || this.isNewRound()) {
                        return this.nextRound();
                    }
                    return false;
                }
                nextRound() {
                    this.correctAnswersCountThisRound = 0;
                    this.wrongAnswersCountThisRound = 0;
                    this.currentRound++;
                    if (this.isRoundsComplete()) {
                        this.onComplete(this.correctAnswersCount, this.correctAnswersCount);
                        return true;
                    }

                    return false;
                }
                getCorrectLetterName() {
                    return this.rounds[this.currentRound]['correctLetterName'];
                }
                isCorrectLetterAudioQuestionEnable() {
                    return this.rounds[this.currentRound]['audioQuestionEnable'];
                }
                getCorrectAudioKey() {
                    return this.lettersConfig[this.getCorrectLetterName()]['correctAudioKey'];
                }
                getCorrectAndLetterSoundSfxAudioKey() {
                    return "Q-" + this.lettersConfig[this.getCorrectLetterName()]['Sounds of the letters'];
                }
                onCorrectAnswer() {
                    this.correctAnswersCountThisRound++;
                    this.correctAnswersCount++;
                    return this.onLetterChosen();
                }
                onWrongAnswer(forceNewRound) {
                    this.wrongAnswersCountThisRound++;
                    this.wrongAnswersCount++;
                    if (this.wrongAnswersCount >= this.wrongAnswersToLose) {
                        this.onLose(this.correctAnswersCount, this.correctAnswersCount);
                        return true;
                    }
                    else {
                        this.onLetterChosen(forceNewRound);
                    }
                    return false;
                }

                getMaxTotalAnswersCount() {
                    return this.wrongAnswersToLose + this.numberOfRounds - 1;
                }

                getCurrentTotalAnswersCount() {
                    return this.correctAnswersCount + this.wrongAnswersCount;
                }
                isNewRound() {
                    return this.correctAnswersCountThisRound >= 1 || (this.correctAnswersCountThisRound + this.wrongAnswersCountThisRound) === 3 || (this.correctAnswersCountThisRound + this.wrongAnswersCountThisRound) === 0;
                }
                isRoundsComplete() {
                    return this.currentRound >= this.numberOfRounds && this.wrongAnswersCount < this.wrongAnswersToLose;
                }
                reset() {
                    this.currentRound = 0;
                    this.correctAnswersCount = 0;
                    this.wrongAnswersCount = 0;
                }
                getCurrentRoundLetters() {
                    return this.rounds[this.currentRound]["letters"];
                }
            }
            core.Gameplay = Gameplay;
        })(core = sh.core || (sh.core = {}));
    })(sh || (sh = {}));

    (function (sh) {
        var scene;
        (function (scene) {
            class Boot extends Phaser.Scene {
                init() {
                    this.game.scale.transformX = (pageX) => {
                        let offsetLeft = 0;
                        let parentElement = game.canvas.parentElement;
                        while (parentElement) {
                            if (parentElement.offsetLeft) {
                                offsetLeft = parentElement.offsetLeft;
                                break;
                            }
                            parentElement = parentElement.parentElement;
                        }
                        return (pageX - offsetLeft) * this.game.scale.displayScale.x;
                    };
                    this.game.scale.transformY = (pageY) => {
                        let offsetTop = 0;
                        let parentElement = game.canvas.parentElement;
                        while (parentElement) {
                            if (parentElement.offsetTop) {
                                offsetTop = parentElement.offsetTop;
                                break;
                            }
                            parentElement = parentElement.parentElement;
                        }
                        return (pageY - offsetTop) * this.game.scale.displayScale.y;
                    };
                }
                create() {
                    game.scene.remove('Boot');
                    game.scene.add('Preloader', sh.scene.Preloader, true);
                }
            }
            scene.Boot = Boot;
        })(scene = sh.scene || (sh.scene = {}));
    })(sh || (sh = {}));

    (function (sh) {
        var scene;
        (function (scene) {
            var Gameplay = sh.core.Gameplay;
            class MainScene extends Phaser.Scene {
                create() {
                    this.gameplay = new Gameplay();
                    this.gameplayScreen = new sh.screen.GameplayScreen(this, this.gameplay);
                    this.children.add(this.gameplayScreen);
                    this.gameplayScreen.showInstructionPage();
                }
            }
            scene.MainScene = MainScene;
        })(scene = sh.scene || (sh.scene = {}));
    })(sh || (sh = {}));

    (function (sh) {
        var scene;
        (function (scene) {
            class Preloader extends Phaser.Scene {
                preload() {
                    if (typeof sh.App.json == "string") this.load.json('gameplay', sh.App.json); else this.game.cache.json.add('gameplay', sh.App.json);
                }
                create() {
                    let json = game.cache.json.get('gameplay');
                    let lettersConfig = json["lettersConfig"];
                    for (let letterName in lettersConfig) {
                        if (json["useImages"]) this.load.image(letterName, "assets/games/bird-game/imgs/letters/" + letterName + ".png");
                        if (lettersConfig[letterName]["correctAudioKey"] == null) continue;
                        // let correctAudioKey = lettersConfig[letterName]["correctAudioKey"];
                        // this.load.audio(correctAudioKey, "assets/games/bird-game/sound/mp3/letters/" + correctAudioKey.replace(".wav", ".mp3"));
                        // this.load.audio("Q-" + lettersConfig[letterName]["Sounds of the letters"], "assets/games/bird-game/sound/mp3/letters/Sounds of the letters/" + lettersConfig[letterName]["Sounds of the letters"].replace(".wav", ".mp3"));
                    }
                    let progressTxt = this.add.text(game.scale.width / 2, game.scale.height / 2 + 50, "", {
                        "fontFamily": "QuranErafont",
                        "fontSize": 25,
                        "color": "#333333",
                        "align": 'center'
                    });
                    progressTxt.setOrigin(0.5, 0.5);
                    this.load.pack('preloader', 'assets/games/bird-game/pack.json');
                    this.load.on('progress', (value) => {
                        progressTxt.text = Math.ceil(value * 100) + "%";
                    }, this);
                    this.load.on('complete', () => {
                        this.nextScene();
                    });
                    this.load.start();
                }
                static playAnim(animKey, sprite, onComplete = null) {
                    let mainScene = game.scene.getScene('ScreenMain');
                    if (!mainScene.anims.exists(animKey)) {
                        let data = Preloader.ANIMS_DATA[animKey];
                        mainScene.anims.create({
                            key: animKey,
                            frames: mainScene.anims.generateFrameNames(data['atlas'], {
                                start: data['start'], end: data['end'], zeroPad: data['padNum'],
                                prefix: data['prefix'], suffix: ''
                            }),
                            frameRate: data['frameRate'],
                            repeat: data['repeat']
                        });
                    }
                    if (sprite.anims.currentAnim) {
                        sprite.anims.currentAnim.off('complete');
                    }
                    sprite.anims.stop();
                    sprite.play(animKey);
                    sprite.anims.currentAnim.once('complete', () => {
                        if (onComplete)
                            onComplete();
                    });

                    if (animKey == 'fly') {
                        mainScene.sound.add('Bird flying').play();
                    }

                    return sprite;
                }
                nextScene() {
                    game.scene.remove('Preloader');
                    game.scene.add('ScreenMain', sh.scene.MainScene, true);
                }
            }
            Preloader.ANIMS_DATA = {
                'fly': {
                    'start': 0,
                    'end': 72,
                    'padNum': 2,
                    'prefix': 'Bird Half Fly_1',
                    'repeat': 0,
                    'frameRate': 30,
                    'atlas': 'fly-atlas'
                },
                'jump': {
                    'start': 0,
                    'end': 37,
                    'padNum': 2,
                    'prefix': 'Bird Jump_1',
                    'repeat': 0,
                    'frameRate': 30,
                    'atlas': 'fly-atlas'
                },
                'idle': {
                    'start': 30,
                    'end': 31,
                    'padNum': 2,
                    'prefix': 'Bird Jump_1',
                    'repeat': 0,
                    'frameRate': 30,
                    'atlas': 'fly-atlas'
                }
            };
            scene.Preloader = Preloader;
        })(scene = sh.scene || (sh.scene = {}));
    })(sh || (sh = {}));
    (function (sh) {
        var screen;
        (function (screen) {
            class AreYouSureWindow extends Phaser.GameObjects.Container {
                constructor(scene, onYes, onNo) {
                    super(scene);
                    this._areYouSurePage = new Phaser.GameObjects.Image(this.scene, -105, 0 - 48, 'Exit warning');
                    this._areYouSurePage.setOrigin(0, 0);
                    this._areYouSurePage.setInteractive();
                    this._btnSureYes = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2 - 95, 485 - 50, 'btnYES1');
                    this._btnSureYes.setInteractive({ cursor: 'pointer' });
                    this._btnSureYes.on('pointerup', () => {
                        onYes;
                        angularComponentRef.backToMenu();
                    });
                    var modalTextStyle = {
                        backgroundColor: 'transparent',
                        stroke: '#ffffff',
                        strokeThickness: 2,
                        lineSpacing: 15,
                        fontFamily: 'Kids Rock DEMO',
                        fontSize: 27,
                        color: '#43425d',
                        wordWrap: true,
                        align: 'center'
                    };
                    var modalText = this.scene.add.text(game.scale.width / 2 + 12, game.scale.height / 2, "Your progress in this activity will not be saved. \n Are you sure you want to exit? ", modalTextStyle);
                    modalText.setOrigin(0.5, 0.5);

                    setupButtonTextureBased(this._btnSureYes, 'btnYES1', 'btnYES2');
                    this._btnSureNo = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2 + 95, 485 - 50, 'btnNO1');
                    this._btnSureNo.setInteractive({ cursor: 'pointer' });
                    this._btnSureNo.on('pointerup', onNo);
                    setupButtonTextureBased(this._btnSureNo, 'btnNO1', 'btnNO2');
                    this.add(this._areYouSurePage);
                    this.add(this._btnSureYes);
                    this.add(this._btnSureNo);
                    this.add(modalText);
                }
            }
            screen.AreYouSureWindow = AreYouSureWindow;
        })(screen = sh.screen || (sh.screen = {}));
    })(sh || (sh = {}));

    (function (sh) {
        var screen;
        (function (screen) {
            class CompleteWindow extends Phaser.GameObjects.Container {
                constructor(scene, onBack, onReplay, onNext) {
                    super(scene);
                    this.music = null;
                    this.setPosition(-104.5, -48);
                    this._bgComplete = new Phaser.GameObjects.Image(this.scene, 0, 0, 'Completion page LATEST UPDATED');
                    this._bgComplete.setOrigin(0, 0);
                    this._bgComplete.setInteractive();
                    this._cup = new Phaser.GameObjects.Image(this.scene, 400, 410, 'Trophy');
                    this._btnBack = new Phaser.GameObjects.Image(this.scene, 570, 570, 'btnBACK1');
                    this._btnReplay = new Phaser.GameObjects.Image(this.scene, 720, 570, 'btnReplay1');
                    this._btnNext = new Phaser.GameObjects.Image(this.scene, 870, 570, 'btnNEXT1');
                    let _CollectedPoints = new Phaser.GameObjects.Image(this.scene, 620, 440, 'Collected Points');
                    this.totalScoreTxt = this.scene.add.text(845, 352, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 35,
                        "color": "#F49F1C",
                        "align": 'center',
                        'stroke': '#70451A',
                        'strokeThickness': 6
                    });
                    this.totalScoreTxt.setOrigin(0.5, 0.5);
                    let grd = this.totalScoreTxt.context.createLinearGradient(0, 0, 0, this.totalScoreTxt.height);
                    grd.addColorStop(0, '#FFFF00');
                    grd.addColorStop(1, '#C17316');
                    this.totalScoreTxt.setFill(grd);
                    this.starScoreTxt = this.scene.add.text(648, 433, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 24,
                        "color": "#FFFFFF",
                        "align": 'center'
                    });
                    this.starScoreTxt.setOrigin(0.5, 0.5);
                    this.add([
                        this._bgComplete,
                        _CollectedPoints,
                        this._cup,
                        this._btnBack,
                        this._btnReplay,
                        this._btnNext,
                        this.totalScoreTxt,
                        this.starScoreTxt
                    ]);
                    this._btnBack.setInteractive({ cursor: 'pointer' });
                    this._btnBack.on('pointerup', () => {
                        onBack(this._btnBack);
                        angularComponentRef.backToMenu();
                        // if (this.music) {
                        //     this.music.stop();
                        // }
                    });
                    setupButtonTextureBased(this._btnBack, 'btnBACK1', 'btnBACK2');
                    this._btnReplay.setInteractive({ cursor: 'pointer' });
                    this._btnReplay.once('pointerup', () => {
                        onReplay(this._btnReplay);
                        if (this.music) {
                            this.music.stop();
                        }
                    });
                    setupButtonTextureBased(this._btnReplay, 'btnReplay1', 'btnReplay2');
                    this._btnNext.setInteractive({ cursor: 'pointer' });
                    this._btnNext.on('pointerup', () => {
                        onNext(this._btnNext);
                        window.angularComponentRef.nextActivity()
                    });
                    setupButtonTextureBased(this._btnNext, 'btnNEXT1', 'btnNEXT2');
                }
                show(score, starScore) {
                    window.angularComponentRef.gameFinish({ score, starScore })
                    this._cup.scale = 1.25;
                    this.scene.tweens.add({
                        targets: this._cup,
                        "scale": 1,
                        duration: 500,
                        ease: Phaser.Math.Easing.Back.Out
                    });
                    this.totalScoreTxt.text = String(window.angularComponentRef.component.userInfo.totalScore);
                    this.starScoreTxt.text = String(starScore);
                    // let music = this.scene.sound.add("viktory");
                    this.music = this.scene.sound.add("Activity completion fantastic");
                    this.music.play();
                }
            }
            screen.CompleteWindow = CompleteWindow;
        })(screen = sh.screen || (sh.screen = {}));
    })(sh || (sh = {}));

    (function (sh) {
        var screen;
        (function (screen) {
            class GameplayScreen extends Phaser.GameObjects.Container {
                constructor(scene, gameplay) {
                    super(scene);
                    this.ROWS_DY = 285;
                    this.gridPositions = [];
                    for (let k = 0; k < gameplay.numberOfRounds; k++) {
                        let _y = this.ROWS_DY * (gameplay.numberOfRounds - 1 - k);
                        this.gridPositions.push([{ x: 218, y: 1190 - _y }, { x: 493, y: 1190 - _y }, { x: 771, y: 1190 - _y }]);
                    }
                    /* this.gridPositions = [
                        [{ x: 218, y: 807 }, { x: 493, y: 807 }, { x: 771, y: 807 }],
                        [{ x: 218, y: 995 }, { x: 493, y: 995 }, { x: 771, y: 995 }],
                        [{ x: 218, y: 1190 }, { x: 493, y: 1190 }, { x: 771, y: 1190 }]
                    ];   */
                    this.bgMusic = null;
                    this.correctAudio = null;
                    this.wfsnd = null;
                    this.showCompleteWindow = (score, starScore) => {
                        let completeWindow = new screen.CompleteWindow(this.scene, (target) => {
                            this.playBtnClickAnim(target);
                        }, (target) => {
                            this.playBtnClickAnim(target);
                            this.destroyGameplay();
                            this.remove(completeWindow);
                            this.showInstructionPage();
                        }, (target) => {
                            this.playBtnClickAnim(target);
                        });
                        this.setLettersInputEnabled(false);
                        delayedCall(5500, () => {
                            setPageBackground("bg-blue");
                            this.add(completeWindow);
                            completeWindow.show(score, starScore);
                            if (this.bgMusic) this.bgMusic.stop();
                        });
                    };
                    this.showLoseWindow = (score, starScore) => {
                        let tryAgainWindow = new screen.TryAgainWindow(this.scene, (target) => {
                            this.playBtnClickAnim(target);
                        }, (target) => {
                            this.playBtnClickAnim(target);
                            this.destroyGameplay();
                            this.remove(tryAgainWindow);
                            this.showInstructionPage();
                        });
                        this.setLettersInputEnabled(false);
                        delayedCall(2500, () => {
                            setPageBackground("bg-blue");
                            this.add(tryAgainWindow);
                            tryAgainWindow.show(score, starScore);
                            if (this.bgMusic) this.bgMusic.stop();
                        });
                    };
                    this.gameplay = gameplay;
                    window["t"] = this;
                }
                createHexagons() {
                    if (this.contentContainer && this.contentContainer.parentContainer) {
                        this.contentContainer.parentContainer.remove(this.contentContainer);
                    }
                    this.contentContainer = new Phaser.GameObjects.Container(this.scene, 0, this.contentContainer ? this.contentContainer.y : 0);
                    this.gameplayContentContainer.addAt(this.contentContainer, 1);
                    window['this.contentContainer'] = this.contentContainer;

                    this._water = new Phaser.GameObjects.Image(this.scene, -1, -1680, 'water');
                    this._water.setOrigin(0, 0);
                    this._water.setInteractive();
                    this.contentContainer.add(this._water);
                    window['this_water'] = this._water;

                    this.questionContainer = new Phaser.GameObjects.Container(this.scene, 497, 55);
                    let question_box = new Phaser.GameObjects.Image(this.scene, 0, 0, 'question-box');
                    question_box.setOrigin(0.5, 0.5);
                    question_box.setScale(1, 0.82);
                    this.questionContainer.add(question_box);

                    if (this.gameplay.useImages) {
                        this.questionWordText = new Phaser.GameObjects.Image(this.scene, 0, 0, this.gameplay.getCorrectLetterName());
                        this.questionWordText.setScale(0.8);
                    } else {
                        this.questionWordText = this.scene.add.text(0, 0, this.gameplay.getCorrectLetterName(), {
                            "fontFamily": "QuranErafont",
                            "fontSize": 50,
                            "color": "#333333",
                            "align": 'center'
                        });
                        this.questionWordText.setOrigin(0.5, 0.5);
                        this.questionWordText.setPadding({ left: 0, right: 0, top: 65, bottom: 65 });
                        this.questionWordText.setScale(0.8);

                        if (this.questionWordText.width > 215) this.questionWordText.setScale(215 / this.questionWordText.width);

                        window['this.questionWordText'] = this.questionWordText;
                    }
                    this.questionContainer.add(this.questionWordText);
                    window['this.questionContainer'] = this.questionContainer;
                    this.gameplayContainer.add(this.questionContainer);
                    this.questionContainer.y = -100;
                    this.scene.tweens.add({
                        targets: this.questionContainer,
                        y: 55,
                        duration: 400
                    });
                    this.scene.sound.add('Frame hanging down each round').play();
                    /* delayedCall(250, () => {
                        this.scene.sound.add('New words appearing').play();
                    }); */

                    let offsetX = 10, offsetY = 15;

                    let _i = 0;
                    this.gridObjects = [];
                    var jarr = [1, 2, 3];
                    for (let k = 0; k < this.gridPositions.length; k++) {
                        let row = this.gridPositions[k];
                        for (let n = 0; n < row.length; n++) {
                            let hc = new Phaser.GameObjects.Container(this.scene, row[n]['x'], row[n]['y']);
                            let h = new Phaser.GameObjects.Image(this.scene, offsetX, offsetY, 'Normal Box-1');
                            hc.add(h);
                            let p = row[n];
                            hc["defX"] = p['x'];
                            hc["defY"] = p['y'];
                            this.gridObjects.push(hc);
                            this.contentContainer.add(hc);
                            hc['index'] = _i;
                            _i++;
                        }
                    }
                    window['this.gridPositions'] = this.gridPositions;

                    this.carsPositions = this.gridPositions[this.gridPositions.length - (this.gameplay.correctAnswersCount + 1)];

                    this.cars = [];
                    _i = 0;
                    let origins = [{ x: 0.5, y: 0.5 }, { x: 0.5, y: 0.5 }, { x: 0.5, y: 0.5 }];
                    var jarr = [1, 2, 3];
                    for (let p of this.carsPositions) {
                        var j = Phaser.Utils.Array.RemoveRandomElement(jarr);
                        let hc = new Phaser.GameObjects.Container(this.scene, this.carsPositions[_i]['x'], this.carsPositions[_i]['y']);
                        let h = new Phaser.GameObjects.Image(this.scene, offsetX, offsetY, 'Normal Box-1');
                        h.setOrigin(origins[j - 1].x, origins[j - 1].y);
                        hc.add(h);
                        hc["bg"] = h;
                        hc["Correct Box"] = new Phaser.GameObjects.Image(this.scene, offsetX, offsetY, 'Correct Box Answer-1');
                        hc["Correct Box"].setOrigin(0.52, 0.49);
                        hc.add(hc["Correct Box"]);
                        hc["Wrong Box"] = new Phaser.GameObjects.Image(this.scene, offsetX, offsetY, 'Wrong Box Answer-1');
                        hc["Wrong Box"].setOrigin(0.52, 0.5);
                        hc.add(hc["Wrong Box"]);
                        hc["Correct Box"].visible = hc["Wrong Box"].visible = false;

                        hc["defX"] = p['x'];
                        hc["defY"] = p['y'];
                        this.cars.push(hc);
                        this.contentContainer.add(hc);
                        hc['index'] = _i;
                        _i++;
                    }
                    window['this.cars'] = this.cars;

                    this.ship = this.scene.add.sprite(this.ship ? this.ship.x : 484, this.ship ? this.ship.y : 1270, "jump-atlas");
                    sh.scene.Preloader.playAnim('idle', this.ship);
                    this.ship["defY"] = this.ship.y;
                    this.ship.setOrigin(0.5, 0.5);
                    this.contentContainer.add(this.ship);
                    window['this.ship'] = this.ship;
                }
                createLetters() {
                    /* if (this.letters) {
                        for (let l of this.letters) {
                            l.parentContainer["letter"] = null;
                            l["hexagon"] = null;
                            l.parentContainer.remove(l);
                        }
                    } */
                    this.letters = [];
                    let _letters = this.gameplay.getCurrentRoundLetters();
                    let firstLetter = true;
                    for (let n of _letters) {
                        let wordText;
                        if (this.gameplay.useImages) {
                            wordText = new Phaser.GameObjects.Image(this.scene, 0, 0, n);
                        } else {
                            wordText = this.scene.add.text(0, 0, n, {
                                "fontFamily": "QuranErafont",
                                "fontSize": 65,
                                "color": "#333333",
                                "align": 'center'
                            });
                            this.add(wordText);
                            wordText.setOrigin(0.5, 0.5);
                            wordText.setPadding({ left: 0, right: 0, top: 65, bottom: 65 });

                            if (wordText.width > 200) wordText.setScale(200 / wordText.width);
                        }
                        wordText["key"] = n;
                        this.letters.push(wordText);
                        window['wordText'] = wordText;

                        wordText.visible = false;
                        delayedCall(400, () => {
                            wordText.visible = true;

                            if (firstLetter) this.scene.sound.add('New words appearing').play();
                            firstLetter = false;
                        });
                    }
                }
                showGameplay() {
                    this.isLost = false;
                    setPageBackground("bg-australia");
                    this.bgMusic = this.scene.sound.add("bg_sound");
                    this.bgMusic.play();
                    this.bgMusic.loop = true;
                    this.gameplay.reset();
                    this._gameStage = new Phaser.GameObjects.Container(this.scene);
                    this._bg = new Phaser.GameObjects.Image(this.scene, 0, 2, 'bg');
                    this._bg.setInteractive();
                    this._bg.setOrigin(0, 0);
                    this._gameStage.add(this._bg);
                    this._btnClose = new Phaser.GameObjects.Image(this.scene, 1025 - 105, 100 - 50, 'x Button');
                    this._btnClose.setInteractive({ cursor: 'pointer' });
                    this._btnClose["defScale"] = this._btnClose.scale;
                    setupButtonTextureBased(this._btnClose, 'x Button', 'x Button HOVER EFFECT');
                    this.gameplayContainer = new Phaser.GameObjects.Container(this.scene);
                    this.addAt(this.gameplayContainer, 0);
                    this.gameplayContentContainer = new Phaser.GameObjects.Container(this.scene);
                    this.gameplayContentContainer.add([
                        this._gameStage
                    ]);
                    this.gameplayContainer.add([
                        this.gameplayContentContainer,
                        this._btnClose
                    ]);
                    this.gameplayContentContainer.y = -996;
                    window['this.gameplayContentContainer'] = this.gameplayContentContainer;
                    this.createBeehives();
                    this.shuffleOutHexagons();
                    this.gameplay.setupCallbacks(this.showCompleteWindow, this.showLoseWindow);
                }
                createBeehives() {
                    let startX = 943;
                    let startY = 515;
                    let dy = 34;
                    let _BeehiveEmptyArrayPositions = [];
                    for (let i = 0; i < this.gameplay.getMaxTotalAnswersCount(); i++) {
                        _BeehiveEmptyArrayPositions.push({ x: startX, y: startY - i * dy });
                    }
                    this._BeehiveEmptyArray = []; window["_BeehiveEmptyArray"] = this._BeehiveEmptyArray;
                    this._Beehive = [];
                    for (let p of _BeehiveEmptyArrayPositions) {
                        let _BeehiveEmpty = new Phaser.GameObjects.Image(this.scene, p['x'], p['y'], 'Beehive 1 Empty');
                        _BeehiveEmpty.setScale(0.5);
                        this._BeehiveEmptyArray.push(_BeehiveEmpty);
                        _BeehiveEmpty.visible = false;
                        let _Beehive = new Phaser.GameObjects.Image(this.scene, p['x'], p['y'], 'Beehive 1');
                        _Beehive.setScale(0.5);
                        this._Beehive.push(_Beehive);
                    }
                    for (let bea of this._BeehiveEmptyArray) {
                        this.gameplayContainer.add(bea);
                    }
                    for (let bee of this._Beehive) {
                        this.gameplayContainer.add(bee);
                        bee.visible = false;
                    }
                }
                randomizeLettersPosition() {
                    let hx = this.cars.slice();
                    for (let l of this.letters) {
                        if (hx.length == 0)
                            return;
                        let hc = Phaser.Utils.Array.RemoveRandomElement(hx);
                        hc.add(l);
                        hc["letter"] = l;
                        l["hexagon"] = hc;
                    }
                }
                updateHexagonsArrange() {
                    for (let hc of this.cars) {
                        if (!hc["letter"]) {
                            hc.parentContainer.bringToTop(hc);
                            break;
                        }
                    }
                }
                shuffleOutHexagons() {
                    this.createHexagons();

                    let setLettersInputEnabled = () => {
                        // if (this.correctAudio && this.correctAudio.isPlaying) {
                        delayedCall(/* (this.correctAudio.duration * 0.75) *  */1000, () => {
                            this.setLettersInputEnabled(true);
                        });
                        // }
                        // else {
                        // this.setLettersInputEnabled(true);
                        // }
                    };

                    if (!this.gameplay.isRoundsComplete()) {
                        if (this.gameplay.isCorrectLetterAudioQuestionEnable() && this.gameplay.getCurrentTotalAnswersCount() == 0) {
                            this.playCorrectAudio();
                        }
                        setLettersInputEnabled();
                    }

                    if (this.sfxCarAccelerating) {
                        this.sfxCarAccelerating.stop();
                        this.sfxCarAccelerating = null;
                    }
                    if (this.sfxWrong) {
                        this.sfxWrong.stop();
                        this.sfxWrong = null;
                    }

                    if (!this.gameplay.isRoundsComplete()) {
                        this.createLetters();
                        this.randomizeLettersPosition();
                    }

                    this.setLettersInputEnabled(false);
                    this.updateHexagonsArrange();
                    // Phaser.Utils.Array.Shuffle(this.carsPositions);
                    let cars = this.cars;
                    for (let i = 0; i < cars.length; i++) {
                        let hc = cars[i];
                        hc["defX"] = this.carsPositions[i]["x"];
                        hc["defY"] = this.carsPositions[i]["y"];

                        hc["Correct Box"].visible = hc["Wrong Box"].visible = false;
                        hc.x = hc["defX"];
                        hc.y = hc["defY"];

                        /* this.scene.tweens.add({
                            targets: this.ship,
                            "y": this.ship.y - 10,
                            scaleX: 0.95,
                            scaleY: 0.95,
                            duration: 1500,
                            onComplete: () => {},
                            yoyo: true
                        }); */
                    }
                    for (let c of cars) this.gameplayContentContainer.remove(c);
                    this.cars.sort((c1, c2) => c1.y - c2.y);
                    // for (let c of cars) this.gameplayContentContainer.add(c);

                    this.createInput();
                }
                shuffleInHexagons() {
                    this.updateHexagonsArrange();
                    let positions = this.carsPositions.slice();
                    this.setLettersInputEnabled(false);

                    // delayedCall(600, () => {
                    // this.scene.sound.add('move to centre').play();
                    this.shuffleOutHexagons();
                    // });
                }
                createInput() {
                    for (let hc of this.cars) {
                        let correctAnswer = hc["letter"] && hc["letter"]["key"] == this.gameplay.getCorrectLetterName();
                        //hc["letter"].alpha = correctAnswer ? 1 : 0.5;
                        hc["bg"].on('pointerup', () => {
                            if (hc["Wrong Box"].visible) return;
                            this.scene.sound.add('Click on the answer').play();

                            // this.playBtnClickAnim(hc);
                            let lost = false;
                            if (correctAnswer) {
                                let completed = this.onCorrectAnswer();

                                let angle = hc['index'] == 0 ? -45 : (hc['index'] == 2 ? 45 : 0);

                                let fn = () => {
                                    for (let l of this.letters) l.visible = false;

                                    let _fn = (_dy) => {
                                        let __dy = (this.ROWS_DY - 15);
                                        this.ship.y -= _dy;
                                        if (completed) {
                                            __dy = _dy;
                                        }
                                        sh.scene.Preloader.playAnim('idle', this.ship);
                                        this.ship.setOrigin(0.5, 0.5);
                                        if (!completed) {
                                            this.shuffleInHexagons();
                                        } else {
                                            this.scene.tweens.add({
                                                targets: this.gameplayContentContainer,
                                                y: 0,//-this.ROWS_DY,
                                                duration: 700,
                                                delay: completed ? 500 : 300
                                            });
                                            sh.scene.Preloader.playAnim('fly', this.ship);
                                            this.ship.setOrigin(0.5, 0.8);
                                            this.scene.tweens.add({
                                                targets: this.ship,
                                                duration: 900,
                                                x: 500,
                                                y: this.ship.y - __dy,
                                                delay: 500,
                                                onComplete: () => {
                                                    delayedCall(350, () => {
                                                        this.scene.sound.add('Final celebration').play();
                                                    });
                                                }
                                            });
                                        }
                                        /*     }
                                        }); */
                                        this.scene.tweens.add({
                                            targets: this.ship,
                                            angle: 0,
                                            // x: hc.x,
                                            duration: 750
                                        });
                                    };

                                    if (this.gameplay.correctAnswersCount == 1) {
                                        let shipY = this.ship.y;
                                        sh.scene.Preloader.playAnim('fly', this.ship, () => _fn(280));
                                        this.ship.setOrigin(0.5, 0.8);

                                        this.scene.tweens.add({
                                            targets: this.ship,
                                            duration: 900,
                                            y: shipY + 25,
                                            delay: 500,
                                        });
                                    } else {
                                        // if (!completed) {
                                        let shipY = this.ship.y;
                                        sh.scene.Preloader.playAnim('fly', this.ship, () => {
                                        });
                                        delayedCall(completed ? 1700 : 2100, () => {
                                            this.ship.y = shipY - 9;
                                            _fn(196 + (this.ROWS_DY - 205));
                                        });
                                        this.ship.setOrigin(0.5, 0.8);

                                        /* this.scene.tweens.add({
                                            targets: this.ship,
                                            duration: 900,
                                            y: shipY - 100,
                                            delay: 500,
                                        }); */
                                        // } else {
                                        // sh.scene.Preloader.playAnim('fly', this.ship);
                                        // let shipY = this.ship.y;
                                        // this.ship.y = shipY - 9;
                                        // _fn(196+(this.ROWS_DY-205));
                                        // } else {
                                        /* sh.scene.Preloader.playAnim('fly', this.ship);
                                            // let shipY = this.ship.y;
                                            // this.ship.y = shipY - 9;
                                        _fn(196+(this.ROWS_DY-205)); */
                                        // }
                                    }

                                    if (this.gameplay.correctAnswersCount == 1) {
                                        this.scene.tweens.add({
                                            targets: this.gameplayContentContainer,
                                            y: -690,
                                            duration: 800,
                                            delay: 650
                                        });

                                        this.scene.tweens.add({
                                            targets: this.ship,
                                            // angle:0,
                                            x: hc.x,
                                            duration: (650) * (Math.abs(hc.x - this.ship.x) / (493 - 218)),
                                            delay: 550
                                        });
                                    } else {
                                        if (!completed) {
                                            this.scene.tweens.add({
                                                targets: this.contentContainer,
                                                y: this.contentContainer.y + this.ROWS_DY,
                                                duration: 650,
                                                delay: 750
                                            });

                                            let additionalDY = this.gameplay.correctAnswersCount === this.gameplay.numberOfRounds ? -70 : 0;
                                            if (this.gameplay.correctAnswersCount > (this.gameplay.numberOfRounds - 1)) this.scene.tweens.add({
                                                targets: this._gameStage,
                                                y: this._gameStage.y + this.ROWS_DY + additionalDY,
                                                duration: 650,
                                                delay: 250
                                            });
                                        }

                                        this.scene.tweens.add({
                                            targets: this.ship,
                                            // angle:0,
                                            x: hc.x,
                                            duration: 800,
                                            delay: 250
                                        });
                                    }
                                };
                                delayedCall(completed ? 250 : 500, fn);

                                /* }
                            }); */

                                this.scene.tweens.add({
                                    targets: this.questionContainer,
                                    y: -100,
                                    duration: 300
                                });

                                this.setLettersInputEnabled(false);
                                hc["Wrong Box"].visible = false;
                                hc["Correct Box"].visible = true;
                                /* for (let hc of this.cars) {
                                    this.scene.tweens.add({
                                        targets: hc["raceTween"],
                                        "timeScale": hc["Correct Box"].visible ? 4 : 2.75,
                                        duration: 400
                                    });
                                } */

                                // delayedCall(500, () => {
                                //     if (!this.gameplay.isNewRound()) {
                                //         if (this.gameplay.isCorrectLetterAudioQuestionEnable()) {
                                //             this.playCorrectAudio();
                                //         }
                                //     }
                                // });
                            }
                            else {
                                hc["Wrong Box"].visible = true;
                                hc["Correct Box"].visible = false;
                                lost = this.onWrongAnswer();
                                if (!lost) {
                                    // this.shuffleInHexagons();
                                } else {
                                    this.isLost = true;
                                }
                            }
                        });
                    }

                    this._btnClose.on('pointerup', () => {
                        this.playBtnClickAnim(this._btnClose);
                        this.onCloseClick();
                    });
                }
                hideAllUnusedBeehives() {
                    let i = this.gameplay.getCurrentTotalAnswersCount();
                    for (let k = i + 1; k < this._BeehiveEmptyArray.length; k++) {
                        this._BeehiveEmptyArray[k].visible = false;
                        this._Beehive[k].visible = false;
                    }
                }
                onCorrectAnswer() {
                    let i = this.gameplay.getCurrentTotalAnswersCount();
                    if (i < this._BeehiveEmptyArray.length) {
                        this._BeehiveEmptyArray[i].visible = false;
                        this._Beehive[i].visible = true;
                    }
                    this.hideAllUnusedBeehives();
                    let completed = this.gameplay.onCorrectAnswer();

                    delayedCall(150, () => {
                        this.scene.sound.add('Correct sfx').play();
                    });

                    // this.sfxCarAccelerating = this.scene.sound.add('Car accelerating');
                    // this.sfxCarAccelerating.play();
                    // delayedCall(250, () => {
                    //     this.scene.sound.add(this.gameplay.getCorrectAndLetterSoundSfxAudioKey()).play();
                    // });
                    return completed;
                }
                onWrongAnswer(forceNewRound) {
                    let i = this.gameplay.getCurrentTotalAnswersCount();
                    if (i < this._BeehiveEmptyArray.length) {
                        this._BeehiveEmptyArray[i].visible = true;
                        this._Beehive[i].visible = false;
                    }
                    this.hideAllUnusedBeehives();
                    let lost = this.gameplay.onWrongAnswer(forceNewRound);

                    delayedCall(150, () => {
                        this.sfxWrong = this.scene.sound.add("wrong sfx");
                        this.sfxWrong.play();
                    });

                    return lost;
                }
                playCorrectAudio() {
                    if (this.correctAudio) {
                        this.correctAudio.stop();
                    }
                    this.correctAudio = this.scene.sound.add("questionAudio"/* this.gameplay.getCorrectAudioKey() */);
                    this.correctAudio.play();
                    if (this.areYouSureWindow && this.areYouSureWindow.parentContainer == this) {
                        this.correctAudio.pause();
                    }
                }
                onSoundClick() {
                    this.playCorrectAudio();
                }
                onCloseClick() {
                    this.showAreYouSurePage();
                    this.scene.sound.add('warning page pop up sfx').play();
                }
                playBtnClickAnim(target) {
                    let sc = target["defScale"] ? target["defScale"] : 1;
                    target.scaleX = target.scaleY = sc;
                    this.scene.tweens.add({
                        targets: target,
                        "scaleX": 0.9 * sc,
                        "scaleY": 0.9 * sc,
                        duration: 100,
                        yoyo: true
                    });
                }
                showInstructionPage() {
                    setPageBackground("bg-blue");
                    this.instructionPage = new screen.InstructionPage(this.scene, (target) => {
                        this.playBtnClickAnim(target);
                        this.remove(this.instructionPage);
                        this.showGameplay();
                        if (this.wfsnd) {
                            this.wfsnd.stop();
                        }
                    }, (target) => {
                        this.playBtnClickAnim(target);
                        if (this.wfsnd) {
                            this.wfsnd.stop();
                        }
                        if (!game.cache.json.get('gameplay')['welcomeAudioDisabled']) {
                            this.wfsnd = this.scene.sound.add("Welcome Find the sound");
                            this.wfsnd.play();
                        }
                    });
                    this.add(this.instructionPage);
                    try {
                        if (!game.cache.json.get('gameplay')['welcomeAudioDisabled']) {
                            this.wfsnd = this.scene.sound.add("Welcome Find the sound");
                            this.wfsnd.play();
                        }
                    }
                    catch (e) {
                        console.error(e);
                    }
                }
                showAreYouSurePage() {
                    /* for (let j = 0; j < this.cars.length; j++) {
                        if (this.cars[j]["raceTween"]) {
                            this.cars[j]["raceTween"].pause();
                        }
                    } */

                    pauseAllDelayedCalls();
                    setPageBackground("bg-blue");
                    this.pauseSounds();
                    if (!this.areYouSureWindow) this.areYouSureWindow = new screen.AreYouSureWindow(this.scene, () => {
                        this.remove(this.areYouSureWindow);
                        this.destroyGameplay();
                        this.showInstructionPage();
                    }, () => {
                        this.remove(this.areYouSureWindow);
                        this.unpauseSounds();
                        resumeAllDelayedCalls();

                        /* for (let j = 0; j < this.cars.length; j++) {
                            if (this.cars[j]["raceTween"]) {
                                this.cars[j]["raceTween"].resume();
                            }
                        } */

                        setPageBackground("bg-australia");
                    });
                    this.add(this.areYouSureWindow);
                }
                setLettersInputEnabled(enabled) {
                    if (enabled) {
                        for (let hc of this.cars) {
                            hc["bg"].setInteractive({ cursor: 'pointer' });
                        }
                    }
                    else {
                        for (let hc of this.cars) {
                            hc["bg"].disableInteractive();
                        }
                    }
                }
                pauseSounds() {
                    if (this.correctAudio)
                        this.correctAudio.pause();
                    if (this.bgMusic)
                        this.bgMusic.pause();
                }
                unpauseSounds() {
                    if (this.correctAudio)
                        this.correctAudio.resume();
                    if (this.bgMusic)
                        this.bgMusic.resume();
                }
                destroyGameplay() {
                    this.ship = null;
                    this.contentContainer = null;
                    this._gameStage.y = 0;
                    this.setLettersInputEnabled(false);
                    this.remove(this.gameplayContainer);
                    this.scene.sound.stopAll();
                    destroyAllDelayedCalls();
                }
            }
            screen.GameplayScreen = GameplayScreen;
        })(screen = sh.screen || (sh.screen = {}));
    })(sh || (sh = {}));
    (function (sh) {
        var screen;
        (function (screen) {
            class InstructionPage extends Phaser.GameObjects.Container {
                constructor(scene, onPlayClick, onSndClick) {
                    super(scene);
                    this._instructionPage = new Phaser.GameObjects.Image(this.scene, 0 - 105, 0 - 48, 'Instructions page  ALL ACTIVITY  TITLEs');
                    this._instructionPage.setOrigin(0, 0);
                    this._instructionPage.setInteractive();

                    this._instructionPageTitle = this.scene.add.text(475, 110, sh.App.json.instructionTitle ?? 'Bird', {
                        "fontFamily": "Kids Rock DEMO",
                        "fontSize": 45,
                        "color": "#43425D",
                        "align": 'center'
                    });
                    this._instructionPageTitle.setOrigin(0.5, 0.5);
                    window['this._instructionPageTitle'] = this._instructionPageTitle;
                    this._instructionPageTitle.setStroke('#ffffff', 5);
                    //  Apply the gradient fill.
                    const gradient = this._instructionPageTitle.context.createLinearGradient(0, 0, 0, this._instructionPageTitle.height);
                    gradient.addColorStop(0, '#eeef67');
                    gradient.addColorStop(0.55, '#e98c2c');
                    gradient.addColorStop(1, '#91301a');
                    this._instructionPageTitle.setFill(gradient);

                    this._btnPlay = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2, 480 - 50, 'btnPLAY1');
                    this._btnPlay.setInteractive({ cursor: 'pointer' });
                    this._btnPlay.once('pointerup', onPlayClick);
                    setupButtonTextureBased(this._btnPlay, 'btnPLAY1', 'btnPLAY2');
                    this.instrTxt = this.scene.add.text(game.scale.width / 2, game.scale.height / 2, sh.App.json.instructionDescription ?? "Choose the correct word!", {
                        "fontFamily": "Kids Rock DEMO",
                        "fontSize": 30,
                        "color": "#43425D",
                        "align": 'center'
                    });
                    this.instrTxt.setOrigin(0.5, 0.5);
                    this._btnSoundInstruction = new Phaser.GameObjects.Image(this.scene, 800 - 105, 156 - 50, 'Sound');
                    this._btnSoundInstruction.setInteractive({ cursor: 'pointer' });
                    this._btnSoundInstruction.on('pointerup', onSndClick);
                    this._btnSoundInstruction["defScale"] = this._btnSoundInstruction.scale;
                    setupButtonTextureBased(this._btnSoundInstruction, 'Sound', 'Sound HOVER EFFECT');
                    this.add(this._instructionPage);
                    this.add(this._instructionPageTitle);
                    this.add(this.instrTxt);
                    this.add(this._btnPlay);
                    this.add(this._btnSoundInstruction);
                }
            }
            screen.InstructionPage = InstructionPage;
        })(screen = sh.screen || (sh.screen = {}));
    })(sh || (sh = {}));
    (function (sh) {
        var screen;
        (function (screen) {
            class TryAgainWindow extends Phaser.GameObjects.Container {
                constructor(scene, onBack, onReplay) {
                    super(scene);
                    this.music = null;
                    this.setPosition(-106, -48);
                    this._bg = new Phaser.GameObjects.Image(this.scene, 0, 0, 'Try again page');
                    this._bg.setOrigin(0, 0);
                    this._bg.setInteractive();
                    this._star = new Phaser.GameObjects.Image(this.scene, 400, 415, 'Break Star');
                    this._btnBack = new Phaser.GameObjects.Image(this.scene, 600, 580, 'btnBACK1');
                    this._btnReplay = new Phaser.GameObjects.Image(this.scene, 765, 580, 'btnReplay1');
                    this.totalScoreTxt = this.scene.add.text(850, 355, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 35,
                        "color": "#F49F1C",
                        "align": 'center',
                        'stroke': '#70451A',
                        'strokeThickness': 6
                    });
                    this.totalScoreTxt.setOrigin(0.5, 0.5);
                    let grd = this.totalScoreTxt.context.createLinearGradient(0, 0, 0, this.totalScoreTxt.height);
                    grd.addColorStop(0, '#FFFF00');
                    grd.addColorStop(1, '#C17316');
                    this.totalScoreTxt.setFill(grd);
                    this.starScoreTxt = this.scene.add.text(635, 431, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 24,
                        "color": "#FFFFFF",
                        "align": 'center'
                    });
                    this.starScoreTxt.setOrigin(0.5, 0.5);
                    this.add([
                        this._bg,
                        this._star,
                        this._btnBack,
                        this._btnReplay,
                        this.totalScoreTxt,
                        this.starScoreTxt
                    ]);
                    this._btnBack.setInteractive({ cursor: 'pointer' });
                    this._btnBack.on('pointerup', () => {
                        onBack(this._btnBack);
                        angularComponentRef.backToMenu();
                        // if (this.music) {
                        //     this.music.stop();
                        // }
                    });
                    setupButtonTextureBased(this._btnBack, 'btnBACK1', 'btnBACK2');
                    this._btnReplay.setInteractive({ cursor: 'pointer' });
                    this._btnReplay.once('pointerup', () => {
                        onReplay(this._btnReplay);
                        if (this.music) {
                            this.music.stop();
                        }
                    });
                    setupButtonTextureBased(this._btnReplay, 'btnReplay1', 'btnReplay2');
                }
                show(score, starScore) {
                    this._star.scale = 1.25;
                    this.scene.tweens.add({
                        targets: this._star,
                        "scale": 1,
                        duration: 500,
                        ease: Phaser.Math.Easing.Back.Out
                    });
                    this.totalScoreTxt.text = String(window.angularComponentRef.component.userInfo.totalScore);
                    this.starScoreTxt.text = String(0);
                    this.music = this.scene.sound.add("Fail - close one");
                    this.music.play();
                }
            }
            screen.TryAgainWindow = TryAgainWindow;
        })(screen = sh.screen || (sh.screen = {}));
    })(sh || (sh = {}));
}

function destroyBirdGame() {
    if (game) {
        game.destroy();
    }
}

/* Phaser v2.12.0 - http://phaser.io - @photonstorm - (c) 2016 Photon Storm Ltd. */

!function(t){if("object"==typeof exports)module.exports=t();else{var e;"undefined"!=typeof window?e=window:"undefined"!=typeof global?e=global:"undefined"!=typeof self&&(e=self),e.p2=t()}}(function(){return function t(e,i,s){function n(o,a){if(!i[o]){if(!e[o]){var h="function"==typeof require&&require;if(!a&&h)return h(o,!0);if(r)return r(o,!0);throw new Error("Cannot find module '"+o+"'")}var l=i[o]={exports:{}};e[o][0].call(l.exports,function(t){var i=e[o][1][t];return n(i||t)},l,l.exports,t,e,i,s)}return i[o].exports}for(var r="function"==typeof require&&require,o=0;o<s.length;o++)n(s[o]);return n}({1:[function(t,e,i){function s(){}var n=t("./Scalar");e.exports=s,s.lineInt=function(t,e,i){i=i||0;var s,r,o,a,h,l,c,u=[0,0];return s=t[1][1]-t[0][1],r=t[0][0]-t[1][0],o=s*t[0][0]+r*t[0][1],a=e[1][1]-e[0][1],h=e[0][0]-e[1][0],l=a*e[0][0]+h*e[0][1],c=s*h-a*r,n.eq(c,0,i)||(u[0]=(h*o-r*l)/c,u[1]=(s*l-a*o)/c),u},s.segmentsIntersect=function(t,e,i,s){var n=e[0]-t[0],r=e[1]-t[1],o=s[0]-i[0],a=s[1]-i[1];if(o*r-a*n==0)return!1;var h=(n*(i[1]-t[1])+r*(t[0]-i[0]))/(o*r-a*n),l=(o*(t[1]-i[1])+a*(i[0]-t[0]))/(a*n-o*r);return h>=0&&h<=1&&l>=0&&l<=1}},{"./Scalar":4}],2:[function(t,e,i){function s(){}e.exports=s,s.area=function(t,e,i){return(e[0]-t[0])*(i[1]-t[1])-(i[0]-t[0])*(e[1]-t[1])},s.left=function(t,e,i){return s.area(t,e,i)>0},s.leftOn=function(t,e,i){return s.area(t,e,i)>=0},s.right=function(t,e,i){return s.area(t,e,i)<0},s.rightOn=function(t,e,i){return s.area(t,e,i)<=0};var n=[],r=[];s.collinear=function(t,e,i,o){if(o){var a=n,h=r;a[0]=e[0]-t[0],a[1]=e[1]-t[1],h[0]=i[0]-e[0],h[1]=i[1]-e[1];var l=a[0]*h[0]+a[1]*h[1],c=Math.sqrt(a[0]*a[0]+a[1]*a[1]),u=Math.sqrt(h[0]*h[0]+h[1]*h[1]);return Math.acos(l/(c*u))<o}return 0==s.area(t,e,i)},s.sqdist=function(t,e){var i=e[0]-t[0],s=e[1]-t[1];return i*i+s*s}},{}],3:[function(t,e,i){function s(){this.vertices=[]}function n(t,e,i,s,n){n=n||0;var r=e[1]-t[1],o=t[0]-e[0],h=r*t[0]+o*t[1],l=s[1]-i[1],c=i[0]-s[0],u=l*i[0]+c*i[1],d=r*c-l*o;return a.eq(d,0,n)?[0,0]:[(c*h-o*u)/d,(r*u-l*h)/d]}var r=t("./Line"),o=t("./Point"),a=t("./Scalar");e.exports=s,s.prototype.at=function(t){var e=this.vertices,i=e.length;return e[t<0?t%i+i:t%i]},s.prototype.first=function(){return this.vertices[0]},s.prototype.last=function(){return this.vertices[this.vertices.length-1]},s.prototype.clear=function(){this.vertices.length=0},s.prototype.append=function(t,e,i){if(void 0===e)throw new Error("From is not given!");if(void 0===i)throw new Error("To is not given!");if(i-1<e)throw new Error("lol1");if(i>t.vertices.length)throw new Error("lol2");if(e<0)throw new Error("lol3");for(var s=e;s<i;s++)this.vertices.push(t.vertices[s])},s.prototype.makeCCW=function(){for(var t=0,e=this.vertices,i=1;i<this.vertices.length;++i)(e[i][1]<e[t][1]||e[i][1]==e[t][1]&&e[i][0]>e[t][0])&&(t=i);o.left(this.at(t-1),this.at(t),this.at(t+1))||this.reverse()},s.prototype.reverse=function(){for(var t=[],e=0,i=this.vertices.length;e!==i;e++)t.push(this.vertices.pop());this.vertices=t},s.prototype.isReflex=function(t){return o.right(this.at(t-1),this.at(t),this.at(t+1))};var h=[],l=[];s.prototype.canSee=function(t,e){var i,s,n=h,a=l;if(o.leftOn(this.at(t+1),this.at(t),this.at(e))&&o.rightOn(this.at(t-1),this.at(t),this.at(e)))return!1;s=o.sqdist(this.at(t),this.at(e));for(var c=0;c!==this.vertices.length;++c)if((c+1)%this.vertices.length!==t&&c!==t&&o.leftOn(this.at(t),this.at(e),this.at(c+1))&&o.rightOn(this.at(t),this.at(e),this.at(c))&&(n[0]=this.at(t),n[1]=this.at(e),a[0]=this.at(c),a[1]=this.at(c+1),i=r.lineInt(n,a),o.sqdist(this.at(t),i)<s))return!1;return!0},s.prototype.copy=function(t,e,i){var n=i||new s;if(n.clear(),t<e)for(r=t;r<=e;r++)n.vertices.push(this.vertices[r]);else{for(r=0;r<=e;r++)n.vertices.push(this.vertices[r]);for(var r=t;r<this.vertices.length;r++)n.vertices.push(this.vertices[r])}return n},s.prototype.getCutEdges=function(){for(var t=[],e=[],i=[],n=new s,r=Number.MAX_VALUE,o=0;o<this.vertices.length;++o)if(this.isReflex(o))for(var a=0;a<this.vertices.length;++a)if(this.canSee(o,a)){e=this.copy(o,a,n).getCutEdges(),i=this.copy(a,o,n).getCutEdges();for(var h=0;h<i.length;h++)e.push(i[h]);e.length<r&&(t=e,r=e.length,t.push([this.at(o),this.at(a)]))}return t},s.prototype.decomp=function(){var t=this.getCutEdges();return t.length>0?this.slice(t):[this]},s.prototype.slice=function(t){if(0==t.length)return[this];if(t instanceof Array&&t.length&&t[0]instanceof Array&&2==t[0].length&&t[0][0]instanceof Array){for(var e=[this],i=0;i<t.length;i++)for(var s=t[i],n=0;n<e.length;n++){var r=e[n].slice(s);if(r){e.splice(n,1),e.push(r[0],r[1]);break}}return e}var s=t,i=this.vertices.indexOf(s[0]),n=this.vertices.indexOf(s[1]);return-1!=i&&-1!=n&&[this.copy(i,n),this.copy(n,i)]},s.prototype.isSimple=function(){for(var t=this.vertices,e=0;e<t.length-1;e++)for(var i=0;i<e-1;i++)if(r.segmentsIntersect(t[e],t[e+1],t[i],t[i+1]))return!1;for(e=1;e<t.length-2;e++)if(r.segmentsIntersect(t[0],t[t.length-1],t[e],t[e+1]))return!1;return!0},s.prototype.quickDecomp=function(t,e,i,r,a,h){a=a||100,h=h||0,r=r||25,t=void 0!==t?t:[],e=e||[],i=i||[];var l=[0,0],c=[0,0],u=[0,0],d=0,p=0,f=0,g=0,m=0,y=0,v=0,x=new s,b=new s,_=this,w=this.vertices;if(w.length<3)return t;if(++h>a)return console.warn("quickDecomp: max level ("+a+") reached."),t;for(var T=0;T<this.vertices.length;++T)if(_.isReflex(T)){e.push(_.vertices[T]),d=p=Number.MAX_VALUE;for(P=0;P<this.vertices.length;++P)o.left(_.at(T-1),_.at(T),_.at(P))&&o.rightOn(_.at(T-1),_.at(T),_.at(P-1))&&(u=n(_.at(T-1),_.at(T),_.at(P),_.at(P-1)),o.right(_.at(T+1),_.at(T),u)&&(f=o.sqdist(_.vertices[T],u))<p&&(p=f,c=u,y=P)),o.left(_.at(T+1),_.at(T),_.at(P+1))&&o.rightOn(_.at(T+1),_.at(T),_.at(P))&&(u=n(_.at(T+1),_.at(T),_.at(P),_.at(P+1)),o.left(_.at(T-1),_.at(T),u)&&(f=o.sqdist(_.vertices[T],u))<d&&(d=f,l=u,m=P));if(y==(m+1)%this.vertices.length)u[0]=(c[0]+l[0])/2,u[1]=(c[1]+l[1])/2,i.push(u),T<m?(x.append(_,T,m+1),x.vertices.push(u),b.vertices.push(u),0!=y&&b.append(_,y,_.vertices.length),b.append(_,0,T+1)):(0!=T&&x.append(_,T,_.vertices.length),x.append(_,0,m+1),x.vertices.push(u),b.vertices.push(u),b.append(_,y,T+1));else{if(y>m&&(m+=this.vertices.length),g=Number.MAX_VALUE,m<y)return t;for(var P=y;P<=m;++P)o.leftOn(_.at(T-1),_.at(T),_.at(P))&&o.rightOn(_.at(T+1),_.at(T),_.at(P))&&(f=o.sqdist(_.at(T),_.at(P)))<g&&(g=f,v=P%this.vertices.length);T<v?(x.append(_,T,v+1),0!=v&&b.append(_,v,w.length),b.append(_,0,T+1)):(0!=T&&x.append(_,T,w.length),x.append(_,0,v+1),b.append(_,v,T+1))}return x.vertices.length<b.vertices.length?(x.quickDecomp(t,e,i,r,a,h),b.quickDecomp(t,e,i,r,a,h)):(b.quickDecomp(t,e,i,r,a,h),x.quickDecomp(t,e,i,r,a,h)),t}return t.push(this),t},s.prototype.removeCollinearPoints=function(t){for(var e=0,i=this.vertices.length-1;this.vertices.length>3&&i>=0;--i)o.collinear(this.at(i-1),this.at(i),this.at(i+1),t)&&(this.vertices.splice(i%this.vertices.length,1),i--,e++);return e}},{"./Line":1,"./Point":2,"./Scalar":4}],4:[function(t,e,i){function s(){}e.exports=s,s.eq=function(t,e,i){return i=i||0,Math.abs(t-e)<i}},{}],5:[function(t,e,i){e.exports={Polygon:t("./Polygon"),Point:t("./Point")}},{"./Point":2,"./Polygon":3}],6:[function(t,e,i){e.exports={name:"p2",version:"0.7.1",description:"A JavaScript 2D physics engine.",author:"Stefan Hedman <schteppe@gmail.com> (http://steffe.se)",keywords:["p2.js","p2","physics","engine","2d"],main:"./src/p2.js",engines:{node:"*"},repository:{type:"git",url:"https://github.com/schteppe/p2.js.git"},bugs:{url:"https://github.com/schteppe/p2.js/issues"},licenses:[{type:"MIT"}],devDependencies:{grunt:"^0.4.5","grunt-contrib-jshint":"^0.11.2","grunt-contrib-nodeunit":"^0.4.1","grunt-contrib-uglify":"~0.4.0","grunt-contrib-watch":"~0.5.0","grunt-browserify":"~2.0.1","grunt-contrib-concat":"^0.4.0"},dependencies:{"poly-decomp":"0.1.1"}}},{}],7:[function(t,e,i){function s(t){this.lowerBound=n.create(),t&&t.lowerBound&&n.copy(this.lowerBound,t.lowerBound),this.upperBound=n.create(),t&&t.upperBound&&n.copy(this.upperBound,t.upperBound)}var n=t("../math/vec2");t("../utils/Utils");e.exports=s;var r=n.create();s.prototype.setFromPoints=function(t,e,i,s){var o=this.lowerBound,a=this.upperBound;"number"!=typeof i&&(i=0),0!==i?n.rotate(o,t[0],i):n.copy(o,t[0]),n.copy(a,o);for(var h=Math.cos(i),l=Math.sin(i),c=1;c<t.length;c++){var u=t[c];if(0!==i){var d=u[0],p=u[1];r[0]=h*d-l*p,r[1]=l*d+h*p,u=r}for(var f=0;f<2;f++)u[f]>a[f]&&(a[f]=u[f]),u[f]<o[f]&&(o[f]=u[f])}e&&(n.add(this.lowerBound,this.lowerBound,e),n.add(this.upperBound,this.upperBound,e)),s&&(this.lowerBound[0]-=s,this.lowerBound[1]-=s,this.upperBound[0]+=s,this.upperBound[1]+=s)},s.prototype.copy=function(t){n.copy(this.lowerBound,t.lowerBound),n.copy(this.upperBound,t.upperBound)},s.prototype.extend=function(t){for(var e=2;e--;){var i=t.lowerBound[e];this.lowerBound[e]>i&&(this.lowerBound[e]=i);var s=t.upperBound[e];this.upperBound[e]<s&&(this.upperBound[e]=s)}},s.prototype.overlaps=function(t){var e=this.lowerBound,i=this.upperBound,s=t.lowerBound,n=t.upperBound;return(s[0]<=i[0]&&i[0]<=n[0]||e[0]<=n[0]&&n[0]<=i[0])&&(s[1]<=i[1]&&i[1]<=n[1]||e[1]<=n[1]&&n[1]<=i[1])},s.prototype.containsPoint=function(t){var e=this.lowerBound,i=this.upperBound;return e[0]<=t[0]&&t[0]<=i[0]&&e[1]<=t[1]&&t[1]<=i[1]},s.prototype.overlapsRay=function(t){var e=1/t.direction[0],i=1/t.direction[1],s=(this.lowerBound[0]-t.from[0])*e,n=(this.upperBound[0]-t.from[0])*e,r=(this.lowerBound[1]-t.from[1])*i,o=(this.upperBound[1]-t.from[1])*i,a=Math.max(Math.max(Math.min(s,n),Math.min(r,o))),h=Math.min(Math.min(Math.max(s,n),Math.max(r,o)));return h<0?-1:a>h?-1:a}},{"../math/vec2":30,"../utils/Utils":57}],8:[function(t,e,i){function s(t){this.type=t,this.result=[],this.world=null,this.boundingVolumeType=s.AABB}var n=t("../math/vec2"),r=t("../objects/Body");e.exports=s,s.AABB=1,s.BOUNDING_CIRCLE=2,s.prototype.setWorld=function(t){this.world=t},s.prototype.getCollisionPairs=function(t){};var o=n.create();s.boundingRadiusCheck=function(t,e){n.sub(o,t.position,e.position);var i=n.squaredLength(o),s=t.boundingRadius+e.boundingRadius;return i<=s*s},s.aabbCheck=function(t,e){return t.getAABB().overlaps(e.getAABB())},s.prototype.boundingVolumeCheck=function(t,e){var i;switch(this.boundingVolumeType){case s.BOUNDING_CIRCLE:i=s.boundingRadiusCheck(t,e);break;case s.AABB:i=s.aabbCheck(t,e);break;default:throw new Error("Bounding volume type not recognized: "+this.boundingVolumeType)}return i},s.canCollide=function(t,e){var i=r.KINEMATIC,s=r.STATIC;return(t.type!==s||e.type!==s)&&(!(t.type===i&&e.type===s||t.type===s&&e.type===i)&&((t.type!==i||e.type!==i)&&((t.sleepState!==r.SLEEPING||e.sleepState!==r.SLEEPING)&&!(t.sleepState===r.SLEEPING&&e.type===s||e.sleepState===r.SLEEPING&&t.type===s))))},s.NAIVE=1,s.SAP=2},{"../math/vec2":30,"../objects/Body":31}],9:[function(t,e,i){function s(){n.call(this,n.NAIVE)}t("../shapes/Circle"),t("../shapes/Plane"),t("../shapes/Shape"),t("../shapes/Particle");var n=t("../collision/Broadphase");t("../math/vec2");e.exports=s,(s.prototype=new n).constructor=s,s.prototype.getCollisionPairs=function(t){var e=t.bodies,i=this.result;i.length=0;for(var s=0,r=e.length;s!==r;s++)for(var o=e[s],a=0;a<s;a++){var h=e[a];n.canCollide(o,h)&&this.boundingVolumeCheck(o,h)&&i.push(o,h)}return i},s.prototype.aabbQuery=function(t,e,i){i=i||[];for(var s=t.bodies,n=0;n<s.length;n++){var r=s[n];r.aabbNeedsUpdate&&r.updateAABB(),r.aabb.overlaps(e)&&i.push(r)}return i}},{"../collision/Broadphase":8,"../math/vec2":30,"../shapes/Circle":39,"../shapes/Particle":43,"../shapes/Plane":44,"../shapes/Shape":45}],10:[function(t,e,i){function s(){this.contactEquations=[],this.frictionEquations=[],this.enableFriction=!0,this.enabledEquations=!0,this.slipForce=10,this.frictionCoefficient=.3,this.surfaceVelocity=0,this.contactEquationPool=new c({size:32}),this.frictionEquationPool=new u({size:64}),this.restitution=0,this.stiffness=p.DEFAULT_STIFFNESS,this.relaxation=p.DEFAULT_RELAXATION,this.frictionStiffness=p.DEFAULT_STIFFNESS,this.frictionRelaxation=p.DEFAULT_RELAXATION,this.enableFrictionReduction=!0,this.collidingBodiesLastStep=new d,this.contactSkinSize=.01}function n(t,e){o.set(t.vertices[0],.5*-e.length,-e.radius),o.set(t.vertices[1],.5*e.length,-e.radius),o.set(t.vertices[2],.5*e.length,e.radius),o.set(t.vertices[3],.5*-e.length,e.radius)}function r(t,e,i,s){for(var n=H,r=q,l=Y,c=z,u=t,d=e.vertices,p=null,f=0;f!==d.length+1;f++){var g=d[f%d.length],m=d[(f+1)%d.length];o.rotate(n,g,s),o.rotate(r,m,s),h(n,n,i),h(r,r,i),a(l,n,u),a(c,r,u);var y=o.crossLength(l,c);if(null===p&&(p=y),y*p<=0)return!1;p=y}return!0}var o=t("../math/vec2"),a=o.sub,h=o.add,l=o.dot,c=(t("../utils/Utils"),t("../utils/ContactEquationPool")),u=t("../utils/FrictionEquationPool"),d=t("../utils/TupleDictionary"),p=t("../equations/Equation"),f=(t("../equations/ContactEquation"),t("../equations/FrictionEquation"),t("../shapes/Circle")),g=t("../shapes/Convex"),m=t("../shapes/Shape"),y=(t("../objects/Body"),t("../shapes/Box"));e.exports=s;var v=o.fromValues(0,1),x=o.fromValues(0,0),b=o.fromValues(0,0),_=o.fromValues(0,0),w=o.fromValues(0,0),T=o.fromValues(0,0),P=o.fromValues(0,0),C=o.fromValues(0,0),S=o.fromValues(0,0),A=o.fromValues(0,0),E=o.fromValues(0,0),M=o.fromValues(0,0),R=o.fromValues(0,0),L=o.fromValues(0,0),B=o.fromValues(0,0),I=o.fromValues(0,0),O=o.fromValues(0,0),k=o.fromValues(0,0),F=o.fromValues(0,0),D=[],U=o.create(),G=o.create();s.prototype.bodiesOverlap=function(t,e){for(var i=U,s=G,n=0,r=t.shapes.length;n!==r;n++){var o=t.shapes[n];t.toWorldFrame(i,o.position);for(var a=0,h=e.shapes.length;a!==h;a++){var l=e.shapes[a];if(e.toWorldFrame(s,l.position),this[o.type|l.type](t,o,i,o.angle+t.angle,e,l,s,l.angle+e.angle,!0))return!0}}return!1},s.prototype.collidedLastStep=function(t,e){var i=0|t.id,s=0|e.id;return!!this.collidingBodiesLastStep.get(i,s)},s.prototype.reset=function(){this.collidingBodiesLastStep.reset();for(var t=this.contactEquations,e=t.length;e--;){var i=t[e],s=i.bodyA.id,n=i.bodyB.id;this.collidingBodiesLastStep.set(s,n,!0)}for(var r=this.contactEquations,o=this.frictionEquations,a=0;a<r.length;a++)this.contactEquationPool.release(r[a]);for(a=0;a<o.length;a++)this.frictionEquationPool.release(o[a]);this.contactEquations.length=this.frictionEquations.length=0},s.prototype.createContactEquation=function(t,e,i,s){var n=this.contactEquationPool.get();return n.bodyA=t,n.bodyB=e,n.shapeA=i,n.shapeB=s,n.restitution=this.restitution,n.firstImpact=!this.collidedLastStep(t,e),n.stiffness=this.stiffness,n.relaxation=this.relaxation,n.needsUpdate=!0,n.enabled=this.enabledEquations,n.offset=this.contactSkinSize,n},s.prototype.createFrictionEquation=function(t,e,i,s){var n=this.frictionEquationPool.get();return n.bodyA=t,n.bodyB=e,n.shapeA=i,n.shapeB=s,n.setSlipForce(this.slipForce),n.frictionCoefficient=this.frictionCoefficient,n.relativeVelocity=this.surfaceVelocity,n.enabled=this.enabledEquations,n.needsUpdate=!0,n.stiffness=this.frictionStiffness,n.relaxation=this.frictionRelaxation,n.contactEquations.length=0,n},s.prototype.createFrictionFromContact=function(t){var e=this.createFrictionEquation(t.bodyA,t.bodyB,t.shapeA,t.shapeB);return o.copy(e.contactPointA,t.contactPointA),o.copy(e.contactPointB,t.contactPointB),o.rotate90cw(e.t,t.normalA),e.contactEquations.push(t),e},s.prototype.createFrictionFromAverage=function(t){var e=this.contactEquations[this.contactEquations.length-1],i=this.createFrictionEquation(e.bodyA,e.bodyB,e.shapeA,e.shapeB),s=e.bodyA;e.bodyB;o.set(i.contactPointA,0,0),o.set(i.contactPointB,0,0),o.set(i.t,0,0);for(var n=0;n!==t;n++)(e=this.contactEquations[this.contactEquations.length-1-n]).bodyA===s?(o.add(i.t,i.t,e.normalA),o.add(i.contactPointA,i.contactPointA,e.contactPointA),o.add(i.contactPointB,i.contactPointB,e.contactPointB)):(o.sub(i.t,i.t,e.normalA),o.add(i.contactPointA,i.contactPointA,e.contactPointB),o.add(i.contactPointB,i.contactPointB,e.contactPointA)),i.contactEquations.push(e);var r=1/t;return o.scale(i.contactPointA,i.contactPointA,r),o.scale(i.contactPointB,i.contactPointB,r),o.normalize(i.t,i.t),o.rotate90cw(i.t,i.t),i},s.prototype[m.LINE|m.CONVEX]=s.prototype.convexLine=function(t,e,i,s,n,r,o,a,h){return!h&&0},s.prototype[m.LINE|m.BOX]=s.prototype.lineBox=function(t,e,i,s,n,r,o,a,h){return!h&&0};var N=new y({width:1,height:1}),X=o.create();s.prototype[m.CAPSULE|m.CONVEX]=s.prototype[m.CAPSULE|m.BOX]=s.prototype.convexCapsule=function(t,e,i,s,r,a,h,l,c){var u=X;o.set(u,a.length/2,0),o.rotate(u,u,l),o.add(u,u,h);var d=this.circleConvex(r,a,u,l,t,e,i,s,c,a.radius);o.set(u,-a.length/2,0),o.rotate(u,u,l),o.add(u,u,h);var p=this.circleConvex(r,a,u,l,t,e,i,s,c,a.radius);if(c&&(d||p))return!0;var f=N;return n(f,a),this.convexConvex(t,e,i,s,r,f,h,l,c)+d+p},s.prototype[m.CAPSULE|m.LINE]=s.prototype.lineCapsule=function(t,e,i,s,n,r,o,a,h){return!h&&0};var W=o.create(),j=o.create(),V=new y({width:1,height:1});s.prototype[m.CAPSULE|m.CAPSULE]=s.prototype.capsuleCapsule=function(t,e,i,s,r,a,h,l,c){for(var u=W,d=j,p=0,f=0;f<2;f++){o.set(u,(0===f?-1:1)*e.length/2,0),o.rotate(u,u,s),o.add(u,u,i);for(var g=0;g<2;g++){o.set(d,(0===g?-1:1)*a.length/2,0),o.rotate(d,d,l),o.add(d,d,h),this.enableFrictionReduction&&(x=this.enableFriction,this.enableFriction=!1);var m=this.circleCircle(t,e,u,s,r,a,d,l,c,e.radius,a.radius);if(this.enableFrictionReduction&&(this.enableFriction=x),c&&m)return!0;p+=m}}this.enableFrictionReduction&&(x=this.enableFriction,this.enableFriction=!1);var y=V;n(y,e);var v=this.convexCapsule(t,y,i,s,r,a,h,l,c);if(this.enableFrictionReduction&&(this.enableFriction=x),c&&v)return!0;if(p+=v,this.enableFrictionReduction){var x=this.enableFriction;this.enableFriction=!1}n(y,a);var b=this.convexCapsule(r,y,h,l,t,e,i,s,c);return this.enableFrictionReduction&&(this.enableFriction=x),!(!c||!b)||(p+=b,this.enableFrictionReduction&&p&&this.enableFriction&&this.frictionEquations.push(this.createFrictionFromAverage(p)),p)},s.prototype[m.LINE|m.LINE]=s.prototype.lineLine=function(t,e,i,s,n,r,o,a,h){return!h&&0},s.prototype[m.PLANE|m.LINE]=s.prototype.planeLine=function(t,e,i,s,n,r,c,u,d){var p=x,f=b,g=_,m=w,y=T,E=P,M=C,R=S,L=A,B=D,I=0;o.set(p,-r.length/2,0),o.set(f,r.length/2,0),o.rotate(g,p,u),o.rotate(m,f,u),h(g,g,c),h(m,m,c),o.copy(p,g),o.copy(f,m),a(y,f,p),o.normalize(E,y),o.rotate90cw(L,E),o.rotate(R,v,s),B[0]=p,B[1]=f;for(var O=0;O<B.length;O++){var k=B[O];a(M,k,i);var F=l(M,R);if(F<0){if(d)return!0;var U=this.createContactEquation(t,n,e,r);I++,o.copy(U.normalA,R),o.normalize(U.normalA,U.normalA),o.scale(M,R,F),a(U.contactPointA,k,M),a(U.contactPointA,U.contactPointA,t.position),a(U.contactPointB,k,c),h(U.contactPointB,U.contactPointB,c),a(U.contactPointB,U.contactPointB,n.position),this.contactEquations.push(U),this.enableFrictionReduction||this.enableFriction&&this.frictionEquations.push(this.createFrictionFromContact(U))}}return!d&&(this.enableFrictionReduction||I&&this.enableFriction&&this.frictionEquations.push(this.createFrictionFromAverage(I)),I)},s.prototype[m.PARTICLE|m.CAPSULE]=s.prototype.particleCapsule=function(t,e,i,s,n,r,o,a,h){return this.circleLine(t,e,i,s,n,r,o,a,h,r.radius,0)},s.prototype[m.CIRCLE|m.LINE]=s.prototype.circleLine=function(t,e,i,s,n,r,c,u,d,p,f){var p=p||0,f=void 0!==f?f:e.radius,g=x,m=b,y=_,v=w,I=T,O=P,k=C,F=S,U=A,G=E,N=M,X=R,W=L,j=B,V=D;o.set(F,-r.length/2,0),o.set(U,r.length/2,0),o.rotate(G,F,u),o.rotate(N,U,u),h(G,G,c),h(N,N,c),o.copy(F,G),o.copy(U,N),a(O,U,F),o.normalize(k,O),o.rotate90cw(I,k),a(X,i,F);var H=l(X,I);a(v,F,c),a(W,i,c);var q=f+p;if(Math.abs(H)<q){o.scale(g,I,H),a(y,i,g),o.scale(m,I,l(I,W)),o.normalize(m,m),o.scale(m,m,p),h(y,y,m);var Y=l(k,y),z=l(k,F),K=l(k,U);if(Y>z&&Y<K){if(d)return!0;Z=this.createContactEquation(t,n,e,r);return o.scale(Z.normalA,g,-1),o.normalize(Z.normalA,Z.normalA),o.scale(Z.contactPointA,Z.normalA,f),h(Z.contactPointA,Z.contactPointA,i),a(Z.contactPointA,Z.contactPointA,t.position),a(Z.contactPointB,y,c),h(Z.contactPointB,Z.contactPointB,c),a(Z.contactPointB,Z.contactPointB,n.position),this.contactEquations.push(Z),this.enableFriction&&this.frictionEquations.push(this.createFrictionFromContact(Z)),1}}V[0]=F,V[1]=U;for(var J=0;J<V.length;J++){var Q=V[J];if(a(X,Q,i),o.squaredLength(X)<Math.pow(q,2)){if(d)return!0;var Z=this.createContactEquation(t,n,e,r);return o.copy(Z.normalA,X),o.normalize(Z.normalA,Z.normalA),o.scale(Z.contactPointA,Z.normalA,f),h(Z.contactPointA,Z.contactPointA,i),a(Z.contactPointA,Z.contactPointA,t.position),a(Z.contactPointB,Q,c),o.scale(j,Z.normalA,-p),h(Z.contactPointB,Z.contactPointB,j),h(Z.contactPointB,Z.contactPointB,c),a(Z.contactPointB,Z.contactPointB,n.position),this.contactEquations.push(Z),this.enableFriction&&this.frictionEquations.push(this.createFrictionFromContact(Z)),1}}return 0},s.prototype[m.CIRCLE|m.CAPSULE]=s.prototype.circleCapsule=function(t,e,i,s,n,r,o,a,h){return this.circleLine(t,e,i,s,n,r,o,a,h,r.radius)},s.prototype[m.CIRCLE|m.CONVEX]=s.prototype[m.CIRCLE|m.BOX]=s.prototype.circleConvex=function(t,e,i,s,n,l,c,u,d,p){for(var p="number"==typeof p?p:e.radius,f=x,g=b,m=_,y=w,v=T,P=E,C=M,S=L,A=B,R=I,k=O,F=!1,D=Number.MAX_VALUE,U=l.vertices,G=0;G!==U.length+1;G++){var N=U[G%U.length],X=U[(G+1)%U.length];if(o.rotate(f,N,u),o.rotate(g,X,u),h(f,f,c),h(g,g,c),a(m,g,f),o.normalize(y,m),o.rotate90cw(v,y),o.scale(A,v,-e.radius),h(A,A,i),r(A,l,c,u)){o.sub(R,f,A);var W=Math.abs(o.dot(R,v));W<D&&(o.copy(k,A),D=W,o.scale(S,v,W),o.add(S,S,A),F=!0)}}if(F){if(d)return!0;V=this.createContactEquation(t,n,e,l);return o.sub(V.normalA,k,i),o.normalize(V.normalA,V.normalA),o.scale(V.contactPointA,V.normalA,p),h(V.contactPointA,V.contactPointA,i),a(V.contactPointA,V.contactPointA,t.position),a(V.contactPointB,S,c),h(V.contactPointB,V.contactPointB,c),a(V.contactPointB,V.contactPointB,n.position),this.contactEquations.push(V),this.enableFriction&&this.frictionEquations.push(this.createFrictionFromContact(V)),1}if(p>0)for(G=0;G<U.length;G++){var j=U[G];if(o.rotate(C,j,u),h(C,C,c),a(P,C,i),o.squaredLength(P)<Math.pow(p,2)){if(d)return!0;var V=this.createContactEquation(t,n,e,l);return o.copy(V.normalA,P),o.normalize(V.normalA,V.normalA),o.scale(V.contactPointA,V.normalA,p),h(V.contactPointA,V.contactPointA,i),a(V.contactPointA,V.contactPointA,t.position),a(V.contactPointB,C,c),h(V.contactPointB,V.contactPointB,c),a(V.contactPointB,V.contactPointB,n.position),this.contactEquations.push(V),this.enableFriction&&this.frictionEquations.push(this.createFrictionFromContact(V)),1}}return 0};var H=o.create(),q=o.create(),Y=o.create(),z=o.create();s.prototype[m.PARTICLE|m.CONVEX]=s.prototype[m.PARTICLE|m.BOX]=s.prototype.particleConvex=function(t,e,i,s,n,c,u,d,p){var f=x,g=b,m=_,y=w,v=T,S=P,A=C,M=E,R=L,B=k,I=F,O=Number.MAX_VALUE,D=!1,U=c.vertices;if(!r(i,c,u,d))return 0;if(p)return!0;for(var G=0;G!==U.length+1;G++){var N=U[G%U.length],X=U[(G+1)%U.length];o.rotate(f,N,d),o.rotate(g,X,d),h(f,f,u),h(g,g,u),a(m,g,f),o.normalize(y,m),o.rotate90cw(v,y),a(M,i,f);l(M,v);a(S,f,u),a(A,i,u),o.sub(B,f,i);var W=Math.abs(o.dot(B,v));W<O&&(O=W,o.scale(R,v,W),o.add(R,R,i),o.copy(I,v),D=!0)}if(D){var j=this.createContactEquation(t,n,e,c);return o.scale(j.normalA,I,-1),o.normalize(j.normalA,j.normalA),o.set(j.contactPointA,0,0),h(j.contactPointA,j.contactPointA,i),a(j.contactPointA,j.contactPointA,t.position),a(j.contactPointB,R,u),h(j.contactPointB,j.contactPointB,u),a(j.contactPointB,j.contactPointB,n.position),this.contactEquations.push(j),this.enableFriction&&this.frictionEquations.push(this.createFrictionFromContact(j)),1}return 0},s.prototype[m.CIRCLE]=s.prototype.circleCircle=function(t,e,i,s,n,r,l,c,u,d,p){var f=x,d=d||e.radius,p=p||r.radius;a(f,i,l);var g=d+p;if(o.squaredLength(f)>Math.pow(g,2))return 0;if(u)return!0;var m=this.createContactEquation(t,n,e,r);return a(m.normalA,l,i),o.normalize(m.normalA,m.normalA),o.scale(m.contactPointA,m.normalA,d),o.scale(m.contactPointB,m.normalA,-p),h(m.contactPointA,m.contactPointA,i),a(m.contactPointA,m.contactPointA,t.position),h(m.contactPointB,m.contactPointB,l),a(m.contactPointB,m.contactPointB,n.position),this.contactEquations.push(m),this.enableFriction&&this.frictionEquations.push(this.createFrictionFromContact(m)),1},s.prototype[m.PLANE|m.CONVEX]=s.prototype[m.PLANE|m.BOX]=s.prototype.planeConvex=function(t,e,i,s,n,r,c,u,d){var p=x,f=b,g=_,m=0;o.rotate(f,v,s);for(var y=0;y!==r.vertices.length;y++){var w=r.vertices[y];if(o.rotate(p,w,u),h(p,p,c),a(g,p,i),l(g,f)<=0){if(d)return!0;m++;var T=this.createContactEquation(t,n,e,r);a(g,p,i),o.copy(T.normalA,f);var P=l(g,T.normalA);o.scale(g,T.normalA,P),a(T.contactPointB,p,n.position),a(T.contactPointA,p,g),a(T.contactPointA,T.contactPointA,t.position),this.contactEquations.push(T),this.enableFrictionReduction||this.enableFriction&&this.frictionEquations.push(this.createFrictionFromContact(T))}}return this.enableFrictionReduction&&this.enableFriction&&m&&this.frictionEquations.push(this.createFrictionFromAverage(m)),m},s.prototype[m.PARTICLE|m.PLANE]=s.prototype.particlePlane=function(t,e,i,s,n,r,h,c,u){var d=x,p=b;c=c||0,a(d,i,h),o.rotate(p,v,c);var f=l(d,p);if(f>0)return 0;if(u)return!0;var g=this.createContactEquation(n,t,r,e);return o.copy(g.normalA,p),o.scale(d,g.normalA,f),a(g.contactPointA,i,d),a(g.contactPointA,g.contactPointA,n.position),a(g.contactPointB,i,t.position),this.contactEquations.push(g),this.enableFriction&&this.frictionEquations.push(this.createFrictionFromContact(g)),1},s.prototype[m.CIRCLE|m.PARTICLE]=s.prototype.circleParticle=function(t,e,i,s,n,r,l,c,u){var d=x;if(a(d,l,i),o.squaredLength(d)>Math.pow(e.radius,2))return 0;if(u)return!0;var p=this.createContactEquation(t,n,e,r);return o.copy(p.normalA,d),o.normalize(p.normalA,p.normalA),o.scale(p.contactPointA,p.normalA,e.radius),h(p.contactPointA,p.contactPointA,i),a(p.contactPointA,p.contactPointA,t.position),a(p.contactPointB,l,n.position),this.contactEquations.push(p),this.enableFriction&&this.frictionEquations.push(this.createFrictionFromContact(p)),1};var K=new f({radius:1}),J=o.create(),Q=o.create();o.create();s.prototype[m.PLANE|m.CAPSULE]=s.prototype.planeCapsule=function(t,e,i,s,n,r,a,l,c){var u=J,d=Q,p=K;o.set(u,-r.length/2,0),o.rotate(u,u,l),h(u,u,a),o.set(d,r.length/2,0),o.rotate(d,d,l),h(d,d,a),p.radius=r.radius;var f;this.enableFrictionReduction&&(f=this.enableFriction,this.enableFriction=!1);var g=this.circlePlane(n,p,u,0,t,e,i,s,c),m=this.circlePlane(n,p,d,0,t,e,i,s,c);if(this.enableFrictionReduction&&(this.enableFriction=f),c)return g||m;var y=g+m;return this.enableFrictionReduction&&y&&this.frictionEquations.push(this.createFrictionFromAverage(y)),y},s.prototype[m.CIRCLE|m.PLANE]=s.prototype.circlePlane=function(t,e,i,s,n,r,c,u,d){var p=t,f=e,g=i,m=n,y=c,w=u;w=w||0;var T=x,P=b,C=_;a(T,g,y),o.rotate(P,v,w);var S=l(P,T);if(S>f.radius)return 0;if(d)return!0;var A=this.createContactEquation(m,p,r,e);return o.copy(A.normalA,P),o.scale(A.contactPointB,A.normalA,-f.radius),h(A.contactPointB,A.contactPointB,g),a(A.contactPointB,A.contactPointB,p.position),o.scale(C,A.normalA,S),a(A.contactPointA,T,C),h(A.contactPointA,A.contactPointA,y),a(A.contactPointA,A.contactPointA,m.position),this.contactEquations.push(A),this.enableFriction&&this.frictionEquations.push(this.createFrictionFromContact(A)),1},s.prototype[m.CONVEX]=s.prototype[m.CONVEX|m.BOX]=s.prototype[m.BOX]=s.prototype.convexConvex=function(t,e,i,n,r,c,u,d,p,f){var g=x,m=b,y=_,v=w,P=T,E=C,M=S,R=A,L=0,f="number"==typeof f?f:0;if(!s.findSeparatingAxis(e,i,n,c,u,d,g))return 0;a(M,u,i),l(g,M)>0&&o.scale(g,g,-1);var B=s.getClosestEdge(e,n,g,!0),I=s.getClosestEdge(c,d,g);if(-1===B||-1===I)return 0;for(var O=0;O<2;O++){var k=B,F=I,D=e,U=c,G=i,N=u,X=n,W=d,j=t,V=r;if(0===O){var H;H=k,k=F,F=H,H=D,D=U,U=H,H=G,G=N,N=H,H=X,X=W,W=H,H=j,j=V,V=H}for(var q=F;q<F+2;q++){var Y=U.vertices[(q+U.vertices.length)%U.vertices.length];o.rotate(m,Y,W),h(m,m,N);for(var z=0,K=k-1;K<k+2;K++){var J=D.vertices[(K+D.vertices.length)%D.vertices.length],Q=D.vertices[(K+1+D.vertices.length)%D.vertices.length];o.rotate(y,J,X),o.rotate(v,Q,X),h(y,y,G),h(v,v,G),a(P,v,y),o.rotate90cw(R,P),o.normalize(R,R),a(M,m,y);$=l(R,M);(K===k&&$<=f||K!==k&&$<=0)&&z++}if(z>=3){if(p)return!0;var Z=this.createContactEquation(j,V,D,U);L++;var J=D.vertices[k%D.vertices.length],Q=D.vertices[(k+1)%D.vertices.length];o.rotate(y,J,X),o.rotate(v,Q,X),h(y,y,G),h(v,v,G),a(P,v,y),o.rotate90cw(Z.normalA,P),o.normalize(Z.normalA,Z.normalA),a(M,m,y);var $=l(Z.normalA,M);o.scale(E,Z.normalA,$),a(Z.contactPointA,m,G),a(Z.contactPointA,Z.contactPointA,E),h(Z.contactPointA,Z.contactPointA,G),a(Z.contactPointA,Z.contactPointA,j.position),a(Z.contactPointB,m,N),h(Z.contactPointB,Z.contactPointB,N),a(Z.contactPointB,Z.contactPointB,V.position),this.contactEquations.push(Z),this.enableFrictionReduction||this.enableFriction&&this.frictionEquations.push(this.createFrictionFromContact(Z))}}}return this.enableFrictionReduction&&this.enableFriction&&L&&this.frictionEquations.push(this.createFrictionFromAverage(L)),L};var Z=o.fromValues(0,0);s.projectConvexOntoAxis=function(t,e,i,s,n){var r,a,h=null,c=null,u=Z;o.rotate(u,s,-i);for(var d=0;d<t.vertices.length;d++)r=t.vertices[d],a=l(r,u),(null===h||a>h)&&(h=a),(null===c||a<c)&&(c=a);if(c>h){var p=c;c=h,h=p}var f=l(e,s);o.set(n,c+f,h+f)};var $=o.fromValues(0,0),tt=o.fromValues(0,0),et=o.fromValues(0,0),it=o.fromValues(0,0),st=o.fromValues(0,0),nt=o.fromValues(0,0);s.findSeparatingAxis=function(t,e,i,n,r,h,l){var c=null,u=!1,d=!1,p=$,f=tt,g=et,m=it,v=st,x=nt;if(t instanceof y&&n instanceof y)for(P=0;2!==P;P++){var b=t,_=i;1===P&&(b=n,_=h);for(C=0;2!==C;C++){0===C?o.set(m,0,1):1===C&&o.set(m,1,0),0!==_&&o.rotate(m,m,_),s.projectConvexOntoAxis(t,e,i,m,v),s.projectConvexOntoAxis(n,r,h,m,x);var w=v,T=x;v[0]>x[0]&&(T=v,w=x,!0),u=(S=T[0]-w[1])<=0,(null===c||S>c)&&(o.copy(l,m),c=S,d=u)}}else for(var P=0;2!==P;P++){var b=t,_=i;1===P&&(b=n,_=h);for(var C=0;C!==b.vertices.length;C++){o.rotate(f,b.vertices[C],_),o.rotate(g,b.vertices[(C+1)%b.vertices.length],_),a(p,g,f),o.rotate90cw(m,p),o.normalize(m,m),s.projectConvexOntoAxis(t,e,i,m,v),s.projectConvexOntoAxis(n,r,h,m,x);var w=v,T=x;v[0]>x[0]&&(T=v,w=x,!0);var S=T[0]-w[1];u=S<=0,(null===c||S>c)&&(o.copy(l,m),c=S,d=u)}}return d};var rt=o.fromValues(0,0),ot=o.fromValues(0,0),at=o.fromValues(0,0);s.getClosestEdge=function(t,e,i,s){var n=rt,r=ot,h=at;o.rotate(n,i,-e),s&&o.scale(n,n,-1);for(var c=-1,u=t.vertices.length,d=-1,p=0;p!==u;p++){a(r,t.vertices[(p+1)%u],t.vertices[p%u]),o.rotate90cw(h,r),o.normalize(h,h);var f=l(h,n);(-1===c||f>d)&&(c=p%u,d=f)}return c};var ht=o.create(),lt=o.create(),ct=o.create(),ut=o.create(),dt=o.create(),pt=o.create(),ft=o.create();s.prototype[m.CIRCLE|m.HEIGHTFIELD]=s.prototype.circleHeightfield=function(t,e,i,s,n,r,l,c,u,d){var p=r.heights,d=d||e.radius,f=r.elementWidth,g=lt,m=ht,y=dt,v=ft,x=pt,b=ct,_=ut,w=Math.floor((i[0]-d-l[0])/f),T=Math.ceil((i[0]+d-l[0])/f);w<0&&(w=0),T>=p.length&&(T=p.length-1);for(var P=p[w],C=p[T],S=w;S<T;S++)p[S]<C&&(C=p[S]),p[S]>P&&(P=p[S]);if(i[1]-d>P)return!u&&0;for(var A=!1,S=w;S<T;S++){o.set(b,S*f,p[S]),o.set(_,(S+1)*f,p[S+1]),o.add(b,b,l),o.add(_,_,l),o.sub(x,_,b),o.rotate(x,x,Math.PI/2),o.normalize(x,x),o.scale(m,x,-d),o.add(m,m,i),o.sub(g,m,b);var E=o.dot(g,x);if(m[0]>=b[0]&&m[0]<_[0]&&E<=0){if(u)return!0;A=!0,o.scale(g,x,-E),o.add(y,m,g),o.copy(v,x);M=this.createContactEquation(n,t,r,e);o.copy(M.normalA,v),o.scale(M.contactPointB,M.normalA,-d),h(M.contactPointB,M.contactPointB,i),a(M.contactPointB,M.contactPointB,t.position),o.copy(M.contactPointA,y),o.sub(M.contactPointA,M.contactPointA,n.position),this.contactEquations.push(M),this.enableFriction&&this.frictionEquations.push(this.createFrictionFromContact(M))}}if(A=!1,d>0)for(S=w;S<=T;S++)if(o.set(b,S*f,p[S]),o.add(b,b,l),o.sub(g,i,b),o.squaredLength(g)<Math.pow(d,2)){if(u)return!0;A=!0;var M=this.createContactEquation(n,t,r,e);o.copy(M.normalA,g),o.normalize(M.normalA,M.normalA),o.scale(M.contactPointB,M.normalA,-d),h(M.contactPointB,M.contactPointB,i),a(M.contactPointB,M.contactPointB,t.position),a(M.contactPointA,b,l),h(M.contactPointA,M.contactPointA,l),a(M.contactPointA,M.contactPointA,n.position),this.contactEquations.push(M),this.enableFriction&&this.frictionEquations.push(this.createFrictionFromContact(M))}return A?1:0};var gt=o.create(),mt=o.create(),yt=o.create(),vt=new g({vertices:[o.create(),o.create(),o.create(),o.create()]});s.prototype[m.BOX|m.HEIGHTFIELD]=s.prototype[m.CONVEX|m.HEIGHTFIELD]=s.prototype.convexHeightfield=function(t,e,i,s,n,r,a,h,l){var c=r.heights,u=r.elementWidth,d=gt,p=mt,f=yt,g=vt,m=Math.floor((t.aabb.lowerBound[0]-a[0])/u),y=Math.ceil((t.aabb.upperBound[0]-a[0])/u);m<0&&(m=0),y>=c.length&&(y=c.length-1);for(var v=c[m],x=c[y],b=m;b<y;b++)c[b]<x&&(x=c[b]),c[b]>v&&(v=c[b]);if(t.aabb.lowerBound[1]>v)return!l&&0;for(var _=0,b=m;b<y;b++){o.set(d,b*u,c[b]),o.set(p,(b+1)*u,c[b+1]),o.add(d,d,a),o.add(p,p,a);o.set(f,.5*(p[0]+d[0]),.5*(p[1]+d[1]-100)),o.sub(g.vertices[0],p,f),o.sub(g.vertices[1],d,f),o.copy(g.vertices[2],g.vertices[1]),o.copy(g.vertices[3],g.vertices[0]),g.vertices[2][1]-=100,g.vertices[3][1]-=100,_+=this.convexConvex(t,e,i,s,n,g,f,0,l)}return _}},{"../equations/ContactEquation":21,"../equations/Equation":22,"../equations/FrictionEquation":23,"../math/vec2":30,"../objects/Body":31,"../shapes/Box":37,"../shapes/Circle":39,"../shapes/Convex":40,"../shapes/Shape":45,"../utils/ContactEquationPool":48,"../utils/FrictionEquationPool":49,"../utils/TupleDictionary":56,"../utils/Utils":57}],11:[function(t,e,i){function s(t){t=t||{},this.from=t.from?r.fromValues(t.from[0],t.from[1]):r.create(),this.to=t.to?r.fromValues(t.to[0],t.to[1]):r.create(),this.checkCollisionResponse=void 0===t.checkCollisionResponse||t.checkCollisionResponse,this.skipBackfaces=!!t.skipBackfaces,this.collisionMask=void 0!==t.collisionMask?t.collisionMask:-1,this.collisionGroup=void 0!==t.collisionGroup?t.collisionGroup:-1,this.mode=void 0!==t.mode?t.mode:s.ANY,this.callback=t.callback||function(t){},this.direction=r.create(),this.length=1,this.update()}function n(t,e,i){r.sub(a,i,t);var s=r.dot(a,e);return r.scale(h,e,s),r.add(h,h,t),r.squaredDistance(i,h)}e.exports=s;var r=t("../math/vec2");t("../collision/RaycastResult"),t("../shapes/Shape"),t("../collision/AABB");s.prototype.constructor=s,s.CLOSEST=1,s.ANY=2,s.ALL=4,s.prototype.update=function(){var t=this.direction;r.sub(t,this.to,this.from),this.length=r.length(t),r.normalize(t,t)},s.prototype.intersectBodies=function(t,e){for(var i=0,s=e.length;!t.shouldStop(this)&&i<s;i++){var n=e[i],r=n.getAABB();(r.overlapsRay(this)>=0||r.containsPoint(this.from))&&this.intersectBody(t,n)}};var o=r.create();s.prototype.intersectBody=function(t,e){var i=this.checkCollisionResponse;if(!i||e.collisionResponse)for(var s=o,n=0,a=e.shapes.length;n<a;n++){var h=e.shapes[n];if((!i||h.collisionResponse)&&(0!=(this.collisionGroup&h.collisionMask)&&0!=(h.collisionGroup&this.collisionMask))){r.rotate(s,h.position,e.angle),r.add(s,s,e.position);var l=h.angle+e.angle;if(this.intersectShape(t,h,l,s,e),t.shouldStop(this))break}}},s.prototype.intersectShape=function(t,e,i,s,r){n(this.from,this.direction,s)>e.boundingRadius*e.boundingRadius||(this._currentBody=r,this._currentShape=e,e.raycast(t,this,s,i),this._currentBody=this._currentShape=null)},s.prototype.getAABB=function(t){var e=this.to,i=this.from;r.set(t.lowerBound,Math.min(e[0],i[0]),Math.min(e[1],i[1])),r.set(t.upperBound,Math.max(e[0],i[0]),Math.max(e[1],i[1]))};r.create();s.prototype.reportIntersection=function(t,e,i,n){this.from,this.to;var o=this._currentShape,a=this._currentBody;if(!(this.skipBackfaces&&r.dot(i,this.direction)>0))switch(this.mode){case s.ALL:t.set(i,o,a,e,n),this.callback(t);break;case s.CLOSEST:(e<t.fraction||!t.hasHit())&&t.set(i,o,a,e,n);break;case s.ANY:t.set(i,o,a,e,n)}};var a=r.create(),h=r.create()},{"../collision/AABB":7,"../collision/RaycastResult":12,"../math/vec2":30,"../shapes/Shape":45}],12:[function(t,e,i){function s(){this.normal=n.create(),this.shape=null,this.body=null,this.faceIndex=-1,this.fraction=-1,this.isStopped=!1}var n=t("../math/vec2"),r=t("../collision/Ray");e.exports=s,s.prototype.reset=function(){n.set(this.normal,0,0),this.shape=null,this.body=null,this.faceIndex=-1,this.fraction=-1,this.isStopped=!1},s.prototype.getHitDistance=function(t){return n.distance(t.from,t.to)*this.fraction},s.prototype.hasHit=function(){return-1!==this.fraction},s.prototype.getHitPoint=function(t,e){n.lerp(t,e.from,e.to,this.fraction)},s.prototype.stop=function(){this.isStopped=!0},s.prototype.shouldStop=function(t){return this.isStopped||-1!==this.fraction&&t.mode===r.ANY},s.prototype.set=function(t,e,i,s,r){n.copy(this.normal,t),this.shape=e,this.body=i,this.fraction=s,this.faceIndex=r}},{"../collision/Ray":11,"../math/vec2":30}],13:[function(t,e,i){function s(){r.call(this,r.SAP),this.axisList=[],this.axisIndex=0;var t=this;this._addBodyHandler=function(e){t.axisList.push(e.body)},this._removeBodyHandler=function(e){var i=t.axisList.indexOf(e.body);-1!==i&&t.axisList.splice(i,1)}}var n=t("../utils/Utils"),r=t("../collision/Broadphase");e.exports=s,(s.prototype=new r).constructor=s,s.prototype.setWorld=function(t){this.axisList.length=0,n.appendArray(this.axisList,t.bodies),t.off("addBody",this._addBodyHandler).off("removeBody",this._removeBodyHandler),t.on("addBody",this._addBodyHandler).on("removeBody",this._removeBodyHandler),this.world=t},s.sortAxisList=function(t,e){e|=0;for(var i=1,s=t.length;i<s;i++){for(var n=t[i],r=i-1;r>=0&&!(t[r].aabb.lowerBound[e]<=n.aabb.lowerBound[e]);r--)t[r+1]=t[r];t[r+1]=n}return t},s.prototype.sortList=function(){var t=this.axisList,e=this.axisIndex;s.sortAxisList(t,e)},s.prototype.getCollisionPairs=function(t){var e=this.axisList,i=this.result,s=this.axisIndex;i.length=0;for(var n=e.length;n--;){var o=e[n];o.aabbNeedsUpdate&&o.updateAABB()}this.sortList();for(var a=0,h=0|e.length;a!==h;a++)for(var l=e[a],c=a+1;c<h;c++){var u=e[c];if(!(u.aabb.lowerBound[s]<=l.aabb.upperBound[s]))break;r.canCollide(l,u)&&this.boundingVolumeCheck(l,u)&&i.push(l,u)}return i},s.prototype.aabbQuery=function(t,e,i){i=i||[],this.sortList();var s=this.axisIndex,n="x";1===s&&(n="y"),2===s&&(n="z");for(var r=this.axisList,o=(e.lowerBound[n],e.upperBound[n],0);o<r.length;o++){var a=r[o];a.aabbNeedsUpdate&&a.updateAABB(),a.aabb.overlaps(e)&&i.push(a)}return i}},{"../collision/Broadphase":8,"../utils/Utils":57}],14:[function(t,e,i){function s(t,e,i,s){this.type=i,s=n.defaults(s,{collideConnected:!0,wakeUpBodies:!0}),this.equations=[],this.bodyA=t,this.bodyB=e,this.collideConnected=s.collideConnected,s.wakeUpBodies&&(t&&t.wakeUp(),e&&e.wakeUp())}e.exports=s;var n=t("../utils/Utils");s.prototype.update=function(){throw new Error("method update() not implmemented in this Constraint subclass!")},s.DISTANCE=1,s.GEAR=2,s.LOCK=3,s.PRISMATIC=4,s.REVOLUTE=5,s.prototype.setStiffness=function(t){for(var e=this.equations,i=0;i!==e.length;i++){var s=e[i];s.stiffness=t,s.needsUpdate=!0}},s.prototype.setRelaxation=function(t){for(var e=this.equations,i=0;i!==e.length;i++){var s=e[i];s.relaxation=t,s.needsUpdate=!0}}},{"../utils/Utils":57}],15:[function(t,e,i){function s(t,e,i){i=a.defaults(i,{localAnchorA:[0,0],localAnchorB:[0,0]}),n.call(this,t,e,n.DISTANCE,i),this.localAnchorA=o.fromValues(i.localAnchorA[0],i.localAnchorA[1]),this.localAnchorB=o.fromValues(i.localAnchorB[0],i.localAnchorB[1]);var s=this.localAnchorA,h=this.localAnchorB;if(this.distance=0,"number"==typeof i.distance)this.distance=i.distance;else{var l=o.create(),c=o.create(),u=o.create();o.rotate(l,s,t.angle),o.rotate(c,h,e.angle),o.add(u,e.position,c),o.sub(u,u,l),o.sub(u,u,t.position),this.distance=o.length(u)}var d;d=void 0===i.maxForce?Number.MAX_VALUE:i.maxForce;var p=new r(t,e,-d,d);this.equations=[p],this.maxForce=d;var u=o.create(),f=o.create(),g=o.create(),m=this;p.computeGq=function(){var t=this.bodyA,e=this.bodyB,i=t.position,n=e.position;return o.rotate(f,s,t.angle),o.rotate(g,h,e.angle),o.add(u,n,g),o.sub(u,u,f),o.sub(u,u,i),o.length(u)-m.distance},this.setMaxForce(d),this.upperLimitEnabled=!1,this.upperLimit=1,this.lowerLimitEnabled=!1,this.lowerLimit=0,this.position=0}var n=t("./Constraint"),r=t("../equations/Equation"),o=t("../math/vec2"),a=t("../utils/Utils");e.exports=s,(s.prototype=new n).constructor=s;var h=o.create(),l=o.create(),c=o.create();s.prototype.update=function(){var t=this.equations[0],e=this.bodyA,i=this.bodyB,s=(this.distance,e.position),n=i.position,r=this.equations[0],a=t.G;o.rotate(l,this.localAnchorA,e.angle),o.rotate(c,this.localAnchorB,i.angle),o.add(h,n,c),o.sub(h,h,l),o.sub(h,h,s),this.position=o.length(h);var u=!1;if(this.upperLimitEnabled&&this.position>this.upperLimit&&(r.maxForce=0,r.minForce=-this.maxForce,this.distance=this.upperLimit,u=!0),this.lowerLimitEnabled&&this.position<this.lowerLimit&&(r.maxForce=this.maxForce,r.minForce=0,this.distance=this.lowerLimit,u=!0),!this.lowerLimitEnabled&&!this.upperLimitEnabled||u){r.enabled=!0,o.normalize(h,h);var d=o.crossLength(l,h),p=o.crossLength(c,h);a[0]=-h[0],a[1]=-h[1],a[2]=-d,a[3]=h[0],a[4]=h[1],a[5]=p}else r.enabled=!1},s.prototype.setMaxForce=function(t){var e=this.equations[0];e.minForce=-t,e.maxForce=t},s.prototype.getMaxForce=function(){return this.equations[0].maxForce}},{"../equations/Equation":22,"../math/vec2":30,"../utils/Utils":57,"./Constraint":14}],16:[function(t,e,i){function s(t,e,i){i=i||{},n.call(this,t,e,n.GEAR,i),this.ratio=void 0!==i.ratio?i.ratio:1,this.angle=void 0!==i.angle?i.angle:e.angle-this.ratio*t.angle,i.angle=this.angle,i.ratio=this.ratio,this.equations=[new r(t,e,i)],void 0!==i.maxTorque&&this.setMaxTorque(i.maxTorque)}var n=t("./Constraint"),r=(t("../equations/Equation"),t("../equations/AngleLockEquation"));t("../math/vec2");e.exports=s,(s.prototype=new n).constructor=s,s.prototype.update=function(){var t=this.equations[0];t.ratio!==this.ratio&&t.setRatio(this.ratio),t.angle=this.angle},s.prototype.setMaxTorque=function(t){this.equations[0].setMaxTorque(t)},s.prototype.getMaxTorque=function(t){return this.equations[0].maxForce}},{"../equations/AngleLockEquation":20,"../equations/Equation":22,"../math/vec2":30,"./Constraint":14}],17:[function(t,e,i){function s(t,e,i){i=i||{},n.call(this,t,e,n.LOCK,i);var s=void 0===i.maxForce?Number.MAX_VALUE:i.maxForce,a=(i.localAngleB,new o(t,e,-s,s)),h=new o(t,e,-s,s),l=new o(t,e,-s,s),c=r.create(),u=r.create(),d=this;a.computeGq=function(){return r.rotate(c,d.localOffsetB,t.angle),r.sub(u,e.position,t.position),r.sub(u,u,c),u[0]},h.computeGq=function(){return r.rotate(c,d.localOffsetB,t.angle),r.sub(u,e.position,t.position),r.sub(u,u,c),u[1]};var p=r.create(),f=r.create();l.computeGq=function(){return r.rotate(p,d.localOffsetB,e.angle-d.localAngleB),r.scale(p,p,-1),r.sub(u,t.position,e.position),r.add(u,u,p),r.rotate(f,p,-Math.PI/2),r.normalize(f,f),r.dot(u,f)},this.localOffsetB=r.create(),i.localOffsetB?r.copy(this.localOffsetB,i.localOffsetB):(r.sub(this.localOffsetB,e.position,t.position),r.rotate(this.localOffsetB,this.localOffsetB,-t.angle)),this.localAngleB=0,"number"==typeof i.localAngleB?this.localAngleB=i.localAngleB:this.localAngleB=e.angle-t.angle,this.equations.push(a,h,l),this.setMaxForce(s)}var n=t("./Constraint"),r=t("../math/vec2"),o=t("../equations/Equation");e.exports=s,(s.prototype=new n).constructor=s,s.prototype.setMaxForce=function(t){for(var e=this.equations,i=0;i<this.equations.length;i++)e[i].maxForce=t,e[i].minForce=-t},s.prototype.getMaxForce=function(){return this.equations[0].maxForce};var a=r.create(),h=r.create(),l=r.create(),c=r.fromValues(1,0),u=r.fromValues(0,1);s.prototype.update=function(){var t=this.equations[0],e=this.equations[1],i=this.equations[2],s=this.bodyA,n=this.bodyB;r.rotate(a,this.localOffsetB,s.angle),r.rotate(h,this.localOffsetB,n.angle-this.localAngleB),r.scale(h,h,-1),r.rotate(l,h,Math.PI/2),r.normalize(l,l),t.G[0]=-1,t.G[1]=0,t.G[2]=-r.crossLength(a,c),t.G[3]=1,e.G[0]=0,e.G[1]=-1,e.G[2]=-r.crossLength(a,u),e.G[4]=1,i.G[0]=-l[0],i.G[1]=-l[1],i.G[3]=l[0],i.G[4]=l[1],i.G[5]=r.crossLength(h,l)}},{"../equations/Equation":22,"../math/vec2":30,"./Constraint":14}],18:[function(t,e,i){function s(t,e,i){i=i||{},n.call(this,t,e,n.PRISMATIC,i);var s=a.fromValues(0,0),l=a.fromValues(1,0),c=a.fromValues(0,0);i.localAnchorA&&a.copy(s,i.localAnchorA),i.localAxisA&&a.copy(l,i.localAxisA),i.localAnchorB&&a.copy(c,i.localAnchorB),this.localAnchorA=s,this.localAnchorB=c,this.localAxisA=l;var u=this.maxForce=void 0!==i.maxForce?i.maxForce:Number.MAX_VALUE,d=new o(t,e,-u,u),p=new a.create,f=new a.create,g=new a.create,m=new a.create;if(d.computeGq=function(){return a.dot(g,m)},d.updateJacobian=function(){var i=this.G,n=t.position,r=e.position;a.rotate(p,s,t.angle),a.rotate(f,c,e.angle),a.add(g,r,f),a.sub(g,g,n),a.sub(g,g,p),a.rotate(m,l,t.angle+Math.PI/2),i[0]=-m[0],i[1]=-m[1],i[2]=-a.crossLength(p,m)+a.crossLength(m,g),i[3]=m[0],i[4]=m[1],i[5]=a.crossLength(f,m)},this.equations.push(d),!i.disableRotationalLock){var y=new h(t,e,-u,u);this.equations.push(y)}this.position=0,this.velocity=0,this.lowerLimitEnabled=void 0!==i.lowerLimit,this.upperLimitEnabled=void 0!==i.upperLimit,this.lowerLimit=void 0!==i.lowerLimit?i.lowerLimit:0,this.upperLimit=void 0!==i.upperLimit?i.upperLimit:1,this.upperLimitEquation=new r(t,e),this.lowerLimitEquation=new r(t,e),this.upperLimitEquation.minForce=this.lowerLimitEquation.minForce=0,this.upperLimitEquation.maxForce=this.lowerLimitEquation.maxForce=u,this.motorEquation=new o(t,e),this.motorEnabled=!1,this.motorSpeed=0;var v=this,x=this.motorEquation;x.computeGW;x.computeGq=function(){return 0},x.computeGW=function(){var t=this.G,e=this.bodyA,i=this.bodyB,s=e.velocity,n=i.velocity,r=e.angularVelocity,o=i.angularVelocity;return this.gmult(t,s,r,n,o)+v.motorSpeed}}var n=t("./Constraint"),r=t("../equations/ContactEquation"),o=t("../equations/Equation"),a=t("../math/vec2"),h=t("../equations/RotationalLockEquation");e.exports=s,(s.prototype=new n).constructor=s;var l=a.create(),c=a.create(),u=a.create(),d=a.create(),p=a.create(),f=a.create();s.prototype.update=function(){var t=this.equations,e=t[0],i=this.upperLimit,s=this.lowerLimit,n=this.upperLimitEquation,r=this.lowerLimitEquation,o=this.bodyA,h=this.bodyB,g=this.localAxisA,m=this.localAnchorA,y=this.localAnchorB;e.updateJacobian(),a.rotate(l,g,o.angle),a.rotate(d,m,o.angle),a.add(c,d,o.position),a.rotate(p,y,h.angle),a.add(u,p,h.position);var v=this.position=a.dot(u,l)-a.dot(c,l);if(this.motorEnabled){var x=this.motorEquation.G;x[0]=l[0],x[1]=l[1],x[2]=a.crossLength(l,p),x[3]=-l[0],x[4]=-l[1],x[5]=-a.crossLength(l,d)}if(this.upperLimitEnabled&&v>i?(a.scale(n.normalA,l,-1),a.sub(n.contactPointA,c,o.position),a.sub(n.contactPointB,u,h.position),a.scale(f,l,i),a.add(n.contactPointA,n.contactPointA,f),-1===t.indexOf(n)&&t.push(n)):-1!==(b=t.indexOf(n))&&t.splice(b,1),this.lowerLimitEnabled&&v<s)a.scale(r.normalA,l,1),a.sub(r.contactPointA,c,o.position),a.sub(r.contactPointB,u,h.position),a.scale(f,l,s),a.sub(r.contactPointB,r.contactPointB,f),-1===t.indexOf(r)&&t.push(r);else{var b=t.indexOf(r);-1!==b&&t.splice(b,1)}},s.prototype.enableMotor=function(){this.motorEnabled||(this.equations.push(this.motorEquation),this.motorEnabled=!0)},s.prototype.disableMotor=function(){if(this.motorEnabled){var t=this.equations.indexOf(this.motorEquation);this.equations.splice(t,1),this.motorEnabled=!1}},s.prototype.setLimits=function(t,e){"number"==typeof t?(this.lowerLimit=t,this.lowerLimitEnabled=!0):(this.lowerLimit=t,this.lowerLimitEnabled=!1),"number"==typeof e?(this.upperLimit=e,this.upperLimitEnabled=!0):(this.upperLimit=e,this.upperLimitEnabled=!1)}},{"../equations/ContactEquation":21,"../equations/Equation":22,"../equations/RotationalLockEquation":24,"../math/vec2":30,"./Constraint":14}],19:[function(t,e,i){function s(t,e,i){i=i||{},n.call(this,t,e,n.REVOLUTE,i);var s=this.maxForce=void 0!==i.maxForce?i.maxForce:Number.MAX_VALUE;this.pivotA=h.create(),this.pivotB=h.create(),i.worldPivot?(h.sub(this.pivotA,i.worldPivot,t.position),h.sub(this.pivotB,i.worldPivot,e.position),h.rotate(this.pivotA,this.pivotA,-t.angle),h.rotate(this.pivotB,this.pivotB,-e.angle)):(h.copy(this.pivotA,i.localPivotA),h.copy(this.pivotB,i.localPivotB));var f=this.equations=[new r(t,e,-s,s),new r(t,e,-s,s)],g=f[0],m=f[1],y=this;g.computeGq=function(){return h.rotate(l,y.pivotA,t.angle),h.rotate(c,y.pivotB,e.angle),h.add(p,e.position,c),h.sub(p,p,t.position),h.sub(p,p,l),h.dot(p,u)},m.computeGq=function(){return h.rotate(l,y.pivotA,t.angle),h.rotate(c,y.pivotB,e.angle),h.add(p,e.position,c),h.sub(p,p,t.position),h.sub(p,p,l),h.dot(p,d)},m.minForce=g.minForce=-s,m.maxForce=g.maxForce=s,this.motorEquation=new o(t,e),this.motorEnabled=!1,this.angle=0,this.lowerLimitEnabled=!1,this.upperLimitEnabled=!1,this.lowerLimit=0,this.upperLimit=0,this.upperLimitEquation=new a(t,e),this.lowerLimitEquation=new a(t,e),this.upperLimitEquation.minForce=0,this.lowerLimitEquation.maxForce=0}var n=t("./Constraint"),r=t("../equations/Equation"),o=t("../equations/RotationalVelocityEquation"),a=t("../equations/RotationalLockEquation"),h=t("../math/vec2");e.exports=s;var l=h.create(),c=h.create(),u=h.fromValues(1,0),d=h.fromValues(0,1),p=h.create();(s.prototype=new n).constructor=s,s.prototype.setLimits=function(t,e){"number"==typeof t?(this.lowerLimit=t,this.lowerLimitEnabled=!0):(this.lowerLimit=t,this.lowerLimitEnabled=!1),"number"==typeof e?(this.upperLimit=e,this.upperLimitEnabled=!0):(this.upperLimit=e,this.upperLimitEnabled=!1)},s.prototype.update=function(){var t=this.bodyA,e=this.bodyB,i=this.pivotA,s=this.pivotB,n=this.equations,r=(n[0],n[1],n[0]),o=n[1],a=this.upperLimit,p=this.lowerLimit,f=this.upperLimitEquation,g=this.lowerLimitEquation,m=this.angle=e.angle-t.angle;if(this.upperLimitEnabled&&m>a?(f.angle=a,-1===n.indexOf(f)&&n.push(f)):-1!==(y=n.indexOf(f))&&n.splice(y,1),this.lowerLimitEnabled&&m<p)g.angle=p,-1===n.indexOf(g)&&n.push(g);else{var y=n.indexOf(g);-1!==y&&n.splice(y,1)}h.rotate(l,i,t.angle),h.rotate(c,s,e.angle),r.G[0]=-1,r.G[1]=0,r.G[2]=-h.crossLength(l,u),r.G[3]=1,r.G[4]=0,r.G[5]=h.crossLength(c,u),o.G[0]=0,o.G[1]=-1,o.G[2]=-h.crossLength(l,d),o.G[3]=0,o.G[4]=1,o.G[5]=h.crossLength(c,d)},s.prototype.enableMotor=function(){this.motorEnabled||(this.equations.push(this.motorEquation),this.motorEnabled=!0)},s.prototype.disableMotor=function(){if(this.motorEnabled){var t=this.equations.indexOf(this.motorEquation);this.equations.splice(t,1),this.motorEnabled=!1}},s.prototype.setMotorSpeed=function(t){if(this.motorEnabled){var e=this.equations.indexOf(this.motorEquation);this.equations[e].relativeVelocity=t}},s.prototype.getMotorSpeed=function(){return!!this.motorEnabled&&this.motorEquation.relativeVelocity}},{"../equations/Equation":22,"../equations/RotationalLockEquation":24,"../equations/RotationalVelocityEquation":25,"../math/vec2":30,"./Constraint":14}],20:[function(t,e,i){function s(t,e,i){i=i||{},n.call(this,t,e,-Number.MAX_VALUE,Number.MAX_VALUE),this.angle=i.angle||0,this.ratio="number"==typeof i.ratio?i.ratio:1,this.setRatio(this.ratio)}var n=t("./Equation");t("../math/vec2");e.exports=s,(s.prototype=new n).constructor=s,s.prototype.computeGq=function(){return this.ratio*this.bodyA.angle-this.bodyB.angle+this.angle},s.prototype.setRatio=function(t){var e=this.G;e[2]=t,e[5]=-1,this.ratio=t},s.prototype.setMaxTorque=function(t){this.maxForce=t,this.minForce=-t}},{"../math/vec2":30,"./Equation":22}],21:[function(t,e,i){function s(t,e){n.call(this,t,e,0,Number.MAX_VALUE),this.contactPointA=r.create(),this.penetrationVec=r.create(),this.contactPointB=r.create(),this.normalA=r.create(),this.restitution=0,this.firstImpact=!1,this.shapeA=null,this.shapeB=null}var n=t("./Equation"),r=t("../math/vec2");e.exports=s,(s.prototype=new n).constructor=s,s.prototype.computeB=function(t,e,i){var s=this.bodyA,n=this.bodyB,o=this.contactPointA,a=this.contactPointB,h=s.position,l=n.position,c=this.penetrationVec,u=this.normalA,d=this.G,p=r.crossLength(o,u),f=r.crossLength(a,u);d[0]=-u[0],d[1]=-u[1],d[2]=-p,d[3]=u[0],d[4]=u[1],d[5]=f,r.add(c,l,a),r.sub(c,c,h),r.sub(c,c,o);var g,m;return this.firstImpact&&0!==this.restitution?(m=0,g=1/e*(1+this.restitution)*this.computeGW()):(m=r.dot(u,c)+this.offset,g=this.computeGW()),-m*t-g*e-i*this.computeGiMf()};var o=r.create(),a=r.create(),h=r.create();s.prototype.getVelocityAlongNormal=function(){return this.bodyA.getVelocityAtPoint(o,this.contactPointA),this.bodyB.getVelocityAtPoint(a,this.contactPointB),r.subtract(h,o,a),r.dot(this.normalA,h)}},{"../math/vec2":30,"./Equation":22}],22:[function(t,e,i){function s(t,e,i,n){this.minForce=void 0===i?-Number.MAX_VALUE:i,this.maxForce=void 0===n?Number.MAX_VALUE:n,this.bodyA=t,this.bodyB=e,this.stiffness=s.DEFAULT_STIFFNESS,this.relaxation=s.DEFAULT_RELAXATION,this.G=new r.ARRAY_TYPE(6);for(var o=0;o<6;o++)this.G[o]=0;this.offset=0,this.a=0,this.b=0,this.epsilon=0,this.timeStep=1/60,this.needsUpdate=!0,this.multiplier=0,this.relativeVelocity=0,this.enabled=!0}e.exports=s;var n=t("../math/vec2"),r=t("../utils/Utils");t("../objects/Body");s.prototype.constructor=s,s.DEFAULT_STIFFNESS=1e6,s.DEFAULT_RELAXATION=4,s.prototype.update=function(){var t=this.stiffness,e=this.relaxation,i=this.timeStep;this.a=4/(i*(1+4*e)),this.b=4*e/(1+4*e),this.epsilon=4/(i*i*t*(1+4*e)),this.needsUpdate=!1},s.prototype.gmult=function(t,e,i,s,n){return t[0]*e[0]+t[1]*e[1]+t[2]*i+t[3]*s[0]+t[4]*s[1]+t[5]*n},s.prototype.computeB=function(t,e,i){var s=this.computeGW();return-this.computeGq()*t-s*e-this.computeGiMf()*i};var o=n.create(),a=n.create();s.prototype.computeGq=function(){var t=this.G,e=this.bodyA,i=this.bodyB,s=(e.position,i.position,e.angle),n=i.angle;return this.gmult(t,o,s,a,n)+this.offset},s.prototype.computeGW=function(){var t=this.G,e=this.bodyA,i=this.bodyB,s=e.velocity,n=i.velocity,r=e.angularVelocity,o=i.angularVelocity;return this.gmult(t,s,r,n,o)+this.relativeVelocity},s.prototype.computeGWlambda=function(){var t=this.G,e=this.bodyA,i=this.bodyB,s=e.vlambda,n=i.vlambda,r=e.wlambda,o=i.wlambda;return this.gmult(t,s,r,n,o)};var h=n.create(),l=n.create();s.prototype.computeGiMf=function(){var t=this.bodyA,e=this.bodyB,i=t.force,s=t.angularForce,r=e.force,o=e.angularForce,a=t.invMassSolve,c=e.invMassSolve,u=t.invInertiaSolve,d=e.invInertiaSolve,p=this.G;return n.scale(h,i,a),n.multiply(h,t.massMultiplier,h),n.scale(l,r,c),n.multiply(l,e.massMultiplier,l),this.gmult(p,h,s*u,l,o*d)},s.prototype.computeGiMGt=function(){var t=this.bodyA,e=this.bodyB,i=t.invMassSolve,s=e.invMassSolve,n=t.invInertiaSolve,r=e.invInertiaSolve,o=this.G;return o[0]*o[0]*i*t.massMultiplier[0]+o[1]*o[1]*i*t.massMultiplier[1]+o[2]*o[2]*n+o[3]*o[3]*s*e.massMultiplier[0]+o[4]*o[4]*s*e.massMultiplier[1]+o[5]*o[5]*r};var c=n.create(),u=n.create(),d=n.create();n.create(),n.create(),n.create();s.prototype.addToWlambda=function(t){var e=this.bodyA,i=this.bodyB,s=c,r=u,o=d,a=e.invMassSolve,h=i.invMassSolve,l=e.invInertiaSolve,p=i.invInertiaSolve,f=this.G;r[0]=f[0],r[1]=f[1],o[0]=f[3],o[1]=f[4],n.scale(s,r,a*t),n.multiply(s,s,e.massMultiplier),n.add(e.vlambda,e.vlambda,s),e.wlambda+=l*f[2]*t,n.scale(s,o,h*t),n.multiply(s,s,i.massMultiplier),n.add(i.vlambda,i.vlambda,s),i.wlambda+=p*f[5]*t},s.prototype.computeInvC=function(t){return 1/(this.computeGiMGt()+t)}},{"../math/vec2":30,"../objects/Body":31,"../utils/Utils":57}],23:[function(t,e,i){function s(t,e,i){r.call(this,t,e,-i,i),this.contactPointA=n.create(),this.contactPointB=n.create(),this.t=n.create(),this.contactEquations=[],this.shapeA=null,this.shapeB=null,this.frictionCoefficient=.3}var n=t("../math/vec2"),r=t("./Equation");t("../utils/Utils");e.exports=s,(s.prototype=new r).constructor=s,s.prototype.setSlipForce=function(t){this.maxForce=t,this.minForce=-t},s.prototype.getSlipForce=function(){return this.maxForce},s.prototype.computeB=function(t,e,i){this.bodyA,this.bodyB;var s=this.contactPointA,r=this.contactPointB,o=this.t,a=this.G;return a[0]=-o[0],a[1]=-o[1],a[2]=-n.crossLength(s,o),a[3]=o[0],a[4]=o[1],a[5]=n.crossLength(r,o),-this.computeGW()*e-i*this.computeGiMf()}},{"../math/vec2":30,"../utils/Utils":57,"./Equation":22}],24:[function(t,e,i){function s(t,e,i){i=i||{},n.call(this,t,e,-Number.MAX_VALUE,Number.MAX_VALUE),this.angle=i.angle||0;var s=this.G;s[2]=1,s[5]=-1}var n=t("./Equation"),r=t("../math/vec2");e.exports=s,(s.prototype=new n).constructor=s;var o=r.create(),a=r.create(),h=r.fromValues(1,0),l=r.fromValues(0,1);s.prototype.computeGq=function(){return r.rotate(o,h,this.bodyA.angle+this.angle),r.rotate(a,l,this.bodyB.angle),r.dot(o,a)}},{"../math/vec2":30,"./Equation":22}],25:[function(t,e,i){function s(t,e){n.call(this,t,e,-Number.MAX_VALUE,Number.MAX_VALUE),this.relativeVelocity=1,this.ratio=1}var n=t("./Equation");t("../math/vec2");e.exports=s,(s.prototype=new n).constructor=s,s.prototype.computeB=function(t,e,i){var s=this.G;s[2]=-1,s[5]=this.ratio;var n=this.computeGiMf();return-this.computeGW()*e-i*n}},{"../math/vec2":30,"./Equation":22}],26:[function(t,e,i){var s=function(){};e.exports=s,s.prototype={constructor:s,on:function(t,e,i){e.context=i||this,void 0===this._listeners&&(this._listeners={});var s=this._listeners;return void 0===s[t]&&(s[t]=[]),-1===s[t].indexOf(e)&&s[t].push(e),this},has:function(t,e){if(void 0===this._listeners)return!1;var i=this._listeners;if(e){if(void 0!==i[t]&&-1!==i[t].indexOf(e))return!0}else if(void 0!==i[t])return!0;return!1},off:function(t,e){if(void 0===this._listeners)return this;var i=this._listeners,s=i[t].indexOf(e);return-1!==s&&i[t].splice(s,1),this},emit:function(t){if(void 0===this._listeners)return this;var e=this._listeners[t.type];if(void 0!==e){t.target=this;for(var i=0,s=e.length;i<s;i++){var n=e[i];n.call(n.context,t)}}return this}}},{}],27:[function(t,e,i){function s(t,e,i){if(i=i||{},!(t instanceof n&&e instanceof n))throw new Error("First two arguments must be Material instances.");this.id=s.idCounter++,this.materialA=t,this.materialB=e,this.friction=void 0!==i.friction?Number(i.friction):.3,this.restitution=void 0!==i.restitution?Number(i.restitution):0,this.stiffness=void 0!==i.stiffness?Number(i.stiffness):r.DEFAULT_STIFFNESS,this.relaxation=void 0!==i.relaxation?Number(i.relaxation):r.DEFAULT_RELAXATION,this.frictionStiffness=void 0!==i.frictionStiffness?Number(i.frictionStiffness):r.DEFAULT_STIFFNESS,this.frictionRelaxation=void 0!==i.frictionRelaxation?Number(i.frictionRelaxation):r.DEFAULT_RELAXATION,this.surfaceVelocity=void 0!==i.surfaceVelocity?Number(i.surfaceVelocity):0,this.contactSkinSize=.005}var n=t("./Material"),r=t("../equations/Equation");e.exports=s,s.idCounter=0},{"../equations/Equation":22,"./Material":28}],28:[function(t,e,i){function s(t){this.id=t||s.idCounter++}e.exports=s,s.idCounter=0},{}],29:[function(t,e,i){var s={};s.GetArea=function(t){if(t.length<6)return 0;for(var e=t.length-2,i=0,s=0;s<e;s+=2)i+=(t[s+2]-t[s])*(t[s+1]+t[s+3]);return.5*-(i+=(t[0]-t[e])*(t[e+1]+t[1]))},s.Triangulate=function(t){var e=t.length>>1;if(e<3)return[];for(var i=[],n=[],r=0;r<e;r++)n.push(r);for(var r=0,o=e;o>3;){var a=n[(r+0)%o],h=n[(r+1)%o],l=n[(r+2)%o],c=t[2*a],u=t[2*a+1],d=t[2*h],p=t[2*h+1],f=t[2*l],g=t[2*l+1],m=!1;if(s._convex(c,u,d,p,f,g)){m=!0;for(var y=0;y<o;y++){var v=n[y];if(v!=a&&v!=h&&v!=l&&s._PointInTriangle(t[2*v],t[2*v+1],c,u,d,p,f,g)){m=!1;break}}}if(m)i.push(a,h,l),n.splice((r+1)%o,1),o--,r=0;else if(r++>3*o)break}return i.push(n[0],n[1],n[2]),i},s._PointInTriangle=function(t,e,i,s,n,r,o,a){var h=o-i,l=a-s,c=n-i,u=r-s,d=t-i,p=e-s,f=h*h+l*l,g=h*c+l*u,m=h*d+l*p,y=c*c+u*u,v=c*d+u*p,x=1/(f*y-g*g),b=(y*m-g*v)*x,_=(f*v-g*m)*x;return b>=0&&_>=0&&b+_<1},s._convex=function(t,e,i,s,n,r){return(e-s)*(n-i)+(i-t)*(r-s)>=0},e.exports=s},{}],30:[function(t,e,i){var s=e.exports={},n=t("../utils/Utils");s.crossLength=function(t,e){return t[0]*e[1]-t[1]*e[0]},s.crossVZ=function(t,e,i){return s.rotate(t,e,-Math.PI/2),s.scale(t,t,i),t},s.crossZV=function(t,e,i){return s.rotate(t,i,Math.PI/2),s.scale(t,t,e),t},s.rotate=function(t,e,i){if(0!==i){var s=Math.cos(i),n=Math.sin(i),r=e[0],o=e[1];t[0]=s*r-n*o,t[1]=n*r+s*o}else t[0]=e[0],t[1]=e[1]},s.rotate90cw=function(t,e){var i=e[0],s=e[1];t[0]=s,t[1]=-i},s.toLocalFrame=function(t,e,i,n){s.copy(t,e),s.sub(t,t,i),s.rotate(t,t,-n)},s.toGlobalFrame=function(t,e,i,n){s.copy(t,e),s.rotate(t,t,n),s.add(t,t,i)},s.vectorToLocalFrame=function(t,e,i){s.rotate(t,e,-i)},s.vectorToGlobalFrame=function(t,e,i){s.rotate(t,e,i)},s.centroid=function(t,e,i,n){return s.add(t,e,i),s.add(t,t,n),s.scale(t,t,1/3),t},s.create=function(){var t=new n.ARRAY_TYPE(2);return t[0]=0,t[1]=0,t},s.clone=function(t){var e=new n.ARRAY_TYPE(2);return e[0]=t[0],e[1]=t[1],e},s.fromValues=function(t,e){var i=new n.ARRAY_TYPE(2);return i[0]=t,i[1]=e,i},s.copy=function(t,e){return t[0]=e[0],t[1]=e[1],t},s.set=function(t,e,i){return t[0]=e,t[1]=i,t},s.add=function(t,e,i){return t[0]=e[0]+i[0],t[1]=e[1]+i[1],t},s.subtract=function(t,e,i){return t[0]=e[0]-i[0],t[1]=e[1]-i[1],t},s.sub=s.subtract,s.multiply=function(t,e,i){return t[0]=e[0]*i[0],t[1]=e[1]*i[1],t},s.mul=s.multiply,s.divide=function(t,e,i){return t[0]=e[0]/i[0],t[1]=e[1]/i[1],t},s.div=s.divide,s.scale=function(t,e,i){return t[0]=e[0]*i,t[1]=e[1]*i,t},s.distance=function(t,e){var i=e[0]-t[0],s=e[1]-t[1];return Math.sqrt(i*i+s*s)},s.dist=s.distance,s.squaredDistance=function(t,e){var i=e[0]-t[0],s=e[1]-t[1];return i*i+s*s},s.sqrDist=s.squaredDistance,s.length=function(t){var e=t[0],i=t[1];return Math.sqrt(e*e+i*i)},s.len=s.length,s.squaredLength=function(t){var e=t[0],i=t[1];return e*e+i*i},s.sqrLen=s.squaredLength,s.negate=function(t,e){return t[0]=-e[0],t[1]=-e[1],t},s.normalize=function(t,e){var i=e[0],s=e[1],n=i*i+s*s;return n>0&&(n=1/Math.sqrt(n),t[0]=e[0]*n,t[1]=e[1]*n),t},s.dot=function(t,e){return t[0]*e[0]+t[1]*e[1]},s.str=function(t){return"vec2("+t[0]+", "+t[1]+")"},s.lerp=function(t,e,i,s){var n=e[0],r=e[1];return t[0]=n+s*(i[0]-n),t[1]=r+s*(i[1]-r),t},s.reflect=function(t,e,i){var s=e[0]*i[0]+e[1]*i[1];t[0]=e[0]-2*i[0]*s,t[1]=e[1]-2*i[1]*s},s.getLineSegmentsIntersection=function(t,e,i,n,r){var o=s.getLineSegmentsIntersectionFraction(e,i,n,r);return!(o<0)&&(t[0]=e[0]+o*(i[0]-e[0]),t[1]=e[1]+o*(i[1]-e[1]),!0)},s.getLineSegmentsIntersectionFraction=function(t,e,i,s){var n,r,o=e[0]-t[0],a=e[1]-t[1],h=s[0]-i[0],l=s[1]-i[1];return n=(-a*(t[0]-i[0])+o*(t[1]-i[1]))/(-h*a+o*l),r=(h*(t[1]-i[1])-l*(t[0]-i[0]))/(-h*a+o*l),n>=0&&n<=1&&r>=0&&r<=1?r:-1}},{"../utils/Utils":57}],31:[function(t,e,i){function s(t){t=t||{},c.call(this),this.id=t.id||++s._idCounter,this.world=null,this.shapes=[],this.mass=t.mass||0,this.invMass=0,this.inertia=0,this.invInertia=0,this.invMassSolve=0,this.invInertiaSolve=0,this.fixedRotation=!!t.fixedRotation,this.fixedX=!!t.fixedX,this.fixedY=!!t.fixedY,this.massMultiplier=n.create(),this.position=n.fromValues(0,0),t.position&&n.copy(this.position,t.position),this.interpolatedPosition=n.fromValues(0,0),this.interpolatedAngle=0,this.previousPosition=n.fromValues(0,0),this.previousAngle=0,this.velocity=n.fromValues(0,0),t.velocity&&n.copy(this.velocity,t.velocity),this.vlambda=n.fromValues(0,0),this.wlambda=0,this.angle=t.angle||0,this.angularVelocity=t.angularVelocity||0,this.force=n.create(),t.force&&n.copy(this.force,t.force),this.angularForce=t.angularForce||0,this.damping="number"==typeof t.damping?t.damping:.1,this.angularDamping="number"==typeof t.angularDamping?t.angularDamping:.1,this.type=s.STATIC,void 0!==t.type?this.type=t.type:t.mass?this.type=s.DYNAMIC:this.type=s.STATIC,this.boundingRadius=0,this.aabb=new l,this.aabbNeedsUpdate=!0,this.allowSleep=void 0===t.allowSleep||t.allowSleep,this.wantsToSleep=!1,this.sleepState=s.AWAKE,this.sleepSpeedLimit=void 0!==t.sleepSpeedLimit?t.sleepSpeedLimit:.2,this.sleepTimeLimit=void 0!==t.sleepTimeLimit?t.sleepTimeLimit:1,this.gravityScale=void 0!==t.gravityScale?t.gravityScale:1,this.collisionResponse=void 0===t.collisionResponse||t.collisionResponse,this.idleTime=0,this.timeLastSleepy=0,this.ccdSpeedThreshold=void 0!==t.ccdSpeedThreshold?t.ccdSpeedThreshold:-1,this.ccdIterations=void 0!==t.ccdIterations?t.ccdIterations:10,this.concavePath=null,this._wakeUpAfterNarrowphase=!1,this.updateMassProperties()}var n=t("../math/vec2"),r=t("poly-decomp"),o=t("../shapes/Convex"),a=t("../collision/RaycastResult"),h=t("../collision/Ray"),l=t("../collision/AABB"),c=t("../events/EventEmitter");e.exports=s,s.prototype=new c,s.prototype.constructor=s,s._idCounter=0,s.prototype.updateSolveMassProperties=function(){this.sleepState===s.SLEEPING||this.type===s.KINEMATIC?(this.invMassSolve=0,this.invInertiaSolve=0):(this.invMassSolve=this.invMass,this.invInertiaSolve=this.invInertia)},s.prototype.setDensity=function(t){var e=this.getArea();this.mass=e*t,this.updateMassProperties()},s.prototype.getArea=function(){for(var t=0,e=0;e<this.shapes.length;e++)t+=this.shapes[e].area;return t},s.prototype.getAABB=function(){return this.aabbNeedsUpdate&&this.updateAABB(),this.aabb};var u=new l,d=n.create();s.prototype.updateAABB=function(){for(var t=this.shapes,e=t.length,i=d,s=this.angle,r=0;r!==e;r++){var o=t[r],a=o.angle+s;n.rotate(i,o.position,s),n.add(i,i,this.position),o.computeAABB(u,i,a),0===r?this.aabb.copy(u):this.aabb.extend(u)}this.aabbNeedsUpdate=!1},s.prototype.updateBoundingRadius=function(){for(var t=this.shapes,e=t.length,i=0,s=0;s!==e;s++){var r=t[s],o=n.length(r.position),a=r.boundingRadius;o+a>i&&(i=o+a)}this.boundingRadius=i},s.prototype.addShape=function(t,e,i){if(t.body)throw new Error("A shape can only be added to one body.");t.body=this,e?n.copy(t.position,e):n.set(t.position,0,0),t.angle=i||0,this.shapes.push(t),this.updateMassProperties(),this.updateBoundingRadius(),this.aabbNeedsUpdate=!0},s.prototype.removeShape=function(t){var e=this.shapes.indexOf(t);return-1!==e&&(this.shapes.splice(e,1),this.aabbNeedsUpdate=!0,t.body=null,!0)},s.prototype.updateMassProperties=function(){if(this.type===s.STATIC||this.type===s.KINEMATIC)this.mass=Number.MAX_VALUE,this.invMass=0,this.inertia=Number.MAX_VALUE,this.invInertia=0;else{var t=this.shapes,e=t.length,i=this.mass/e,r=0;if(this.fixedRotation)this.inertia=Number.MAX_VALUE,this.invInertia=0;else{for(var o=0;o<e;o++){var a=t[o],h=n.squaredLength(a.position);r+=a.computeMomentOfInertia(i)+i*h}this.inertia=r,this.invInertia=r>0?1/r:0}this.invMass=1/this.mass,n.set(this.massMultiplier,this.fixedX?0:1,this.fixedY?0:1)}};n.create();s.prototype.applyForce=function(t,e){if(n.add(this.force,this.force,t),e){var i=n.crossLength(e,t);this.angularForce+=i}};var p=n.create(),f=n.create(),g=n.create();s.prototype.applyForceLocal=function(t,e){e=e||g;var i=p,s=f;this.vectorToWorldFrame(i,t),this.vectorToWorldFrame(s,e),this.applyForce(i,s)};var m=n.create();s.prototype.applyImpulse=function(t,e){if(this.type===s.DYNAMIC){var i=m;if(n.scale(i,t,this.invMass),n.multiply(i,this.massMultiplier,i),n.add(this.velocity,i,this.velocity),e){var r=n.crossLength(e,t);r*=this.invInertia,this.angularVelocity+=r}}};var y=n.create(),v=n.create(),x=n.create();s.prototype.applyImpulseLocal=function(t,e){e=e||x;var i=y,s=v;this.vectorToWorldFrame(i,t),this.vectorToWorldFrame(s,e),this.applyImpulse(i,s)},s.prototype.toLocalFrame=function(t,e){n.toLocalFrame(t,e,this.position,this.angle)},s.prototype.toWorldFrame=function(t,e){n.toGlobalFrame(t,e,this.position,this.angle)},s.prototype.vectorToLocalFrame=function(t,e){n.vectorToLocalFrame(t,e,this.angle)},s.prototype.vectorToWorldFrame=function(t,e){n.vectorToGlobalFrame(t,e,this.angle)},s.prototype.fromPolygon=function(t,e){e=e||{};for(h=this.shapes.length;h>=0;--h)this.removeShape(this.shapes[h]);var i=new r.Polygon;if(i.vertices=t,i.makeCCW(),"number"==typeof e.removeCollinearPoints&&i.removeCollinearPoints(e.removeCollinearPoints),void 0===e.skipSimpleCheck&&!i.isSimple())return!1;this.concavePath=i.vertices.slice(0);for(h=0;h<this.concavePath.length;h++){u=[0,0];n.copy(u,this.concavePath[h]),this.concavePath[h]=u}var s;s=e.optimalDecomp?i.decomp():i.quickDecomp();for(var a=n.create(),h=0;h!==s.length;h++){for(var l=new o({vertices:s[h].vertices}),c=0;c!==l.vertices.length;c++){var u=l.vertices[c];n.sub(u,u,l.centerOfMass)}n.scale(a,l.centerOfMass,1),l.updateTriangles(),l.updateCenterOfMass(),l.updateBoundingRadius(),this.addShape(l,a)}return this.adjustCenterOfMass(),this.aabbNeedsUpdate=!0,!0};n.fromValues(0,0);var b=n.fromValues(0,0),_=n.fromValues(0,0),w=n.fromValues(0,0);s.prototype.adjustCenterOfMass=function(){var t=b,e=_,i=w,s=0;n.set(e,0,0);for(o=0;o!==this.shapes.length;o++){r=this.shapes[o];n.scale(t,r.position,r.area),n.add(e,e,t),s+=r.area}n.scale(i,e,1/s);for(o=0;o!==this.shapes.length;o++){var r=this.shapes[o];n.sub(r.position,r.position,i)}n.add(this.position,this.position,i);for(var o=0;this.concavePath&&o<this.concavePath.length;o++)n.sub(this.concavePath[o],this.concavePath[o],i);this.updateMassProperties(),this.updateBoundingRadius()},s.prototype.setZeroForce=function(){n.set(this.force,0,0),this.angularForce=0},s.prototype.resetConstraintVelocity=function(){var t=this,e=t.vlambda;n.set(e,0,0),t.wlambda=0},s.prototype.addConstraintVelocity=function(){var t=this,e=t.velocity;n.add(e,e,t.vlambda),t.angularVelocity+=t.wlambda},s.prototype.applyDamping=function(t){if(this.type===s.DYNAMIC){var e=this.velocity;n.scale(e,e,Math.pow(1-this.damping,t)),this.angularVelocity*=Math.pow(1-this.angularDamping,t)}},s.prototype.wakeUp=function(){var t=this.sleepState;this.sleepState=s.AWAKE,this.idleTime=0,t!==s.AWAKE&&this.emit(s.wakeUpEvent)},s.prototype.sleep=function(){this.sleepState=s.SLEEPING,this.angularVelocity=0,this.angularForce=0,n.set(this.velocity,0,0),n.set(this.force,0,0),this.emit(s.sleepEvent)},s.prototype.sleepTick=function(t,e,i){if(this.allowSleep&&this.type!==s.SLEEPING){this.wantsToSleep=!1;this.sleepState;n.squaredLength(this.velocity)+Math.pow(this.angularVelocity,2)>=Math.pow(this.sleepSpeedLimit,2)?(this.idleTime=0,this.sleepState=s.AWAKE):(this.idleTime+=i,this.sleepState=s.SLEEPY),this.idleTime>this.sleepTimeLimit&&(e?this.wantsToSleep=!0:this.sleep())}},s.prototype.overlaps=function(t){return this.world.overlapKeeper.bodiesAreOverlapping(this,t)};var T=n.create(),P=n.create();s.prototype.integrate=function(t){var e=this.invMass,i=this.force,s=this.position,r=this.velocity;n.copy(this.previousPosition,this.position),this.previousAngle=this.angle,this.fixedRotation||(this.angularVelocity+=this.angularForce*this.invInertia*t),n.scale(T,i,t*e),n.multiply(T,this.massMultiplier,T),n.add(r,T,r),this.integrateToTimeOfImpact(t)||(n.scale(P,r,t),n.add(s,s,P),this.fixedRotation||(this.angle+=this.angularVelocity*t)),this.aabbNeedsUpdate=!0};var C=new a,S=new h({mode:h.ALL}),A=n.create(),E=n.create(),M=n.create(),R=n.create();s.prototype.integrateToTimeOfImpact=function(t){if(this.ccdSpeedThreshold<0||n.squaredLength(this.velocity)<Math.pow(this.ccdSpeedThreshold,2))return!1;n.normalize(A,this.velocity),n.scale(E,this.velocity,t),n.add(E,E,this.position),n.sub(M,E,this.position);var e,i=this.angularVelocity*t,s=n.length(M),r=1,o=this;if(C.reset(),S.callback=function(t){t.body!==o&&(e=t.body,t.getHitPoint(E,S),n.sub(M,E,o.position),r=n.length(M)/s,t.stop())},n.copy(S.from,this.position),n.copy(S.to,E),S.update(),this.world.raycast(C,S),!e)return!1;var a=this.angle;n.copy(R,this.position);for(var h=0,l=0,c=0,u=r;u>=l&&h<this.ccdIterations;)h++,c=(u-l)/2,n.scale(P,M,r),n.add(this.position,R,P),this.angle=a+i*r,this.updateAABB(),this.aabb.overlaps(e.aabb)&&this.world.narrowphase.bodiesOverlap(this,e)?l=c:u=c;return r=c,n.copy(this.position,R),this.angle=a,n.scale(P,M,r),n.add(this.position,this.position,P),this.fixedRotation||(this.angle+=i*r),!0},s.prototype.getVelocityAtPoint=function(t,e){return n.crossVZ(t,e,this.angularVelocity),n.subtract(t,this.velocity,t),t},s.sleepyEvent={type:"sleepy"},s.sleepEvent={type:"sleep"},s.wakeUpEvent={type:"wakeup"},s.DYNAMIC=1,s.STATIC=2,s.KINEMATIC=4,s.AWAKE=0,s.SLEEPY=1,s.SLEEPING=2},{"../collision/AABB":7,"../collision/Ray":11,"../collision/RaycastResult":12,"../events/EventEmitter":26,"../math/vec2":30,"../shapes/Convex":40,"poly-decomp":5}],32:[function(t,e,i){function s(t,e,i){i=i||{},r.call(this,t,e,i),this.localAnchorA=n.fromValues(0,0),this.localAnchorB=n.fromValues(0,0),i.localAnchorA&&n.copy(this.localAnchorA,i.localAnchorA),i.localAnchorB&&n.copy(this.localAnchorB,i.localAnchorB),i.worldAnchorA&&this.setWorldAnchorA(i.worldAnchorA),i.worldAnchorB&&this.setWorldAnchorB(i.worldAnchorB);var s=n.create(),o=n.create();this.getWorldAnchorA(s),this.getWorldAnchorB(o);var a=n.distance(s,o);this.restLength="number"==typeof i.restLength?i.restLength:a}var n=t("../math/vec2"),r=t("./Spring");t("../utils/Utils");e.exports=s,(s.prototype=new r).constructor=s,s.prototype.setWorldAnchorA=function(t){this.bodyA.toLocalFrame(this.localAnchorA,t)},s.prototype.setWorldAnchorB=function(t){this.bodyB.toLocalFrame(this.localAnchorB,t)},s.prototype.getWorldAnchorA=function(t){this.bodyA.toWorldFrame(t,this.localAnchorA)},s.prototype.getWorldAnchorB=function(t){this.bodyB.toWorldFrame(t,this.localAnchorB)};var o=n.create(),a=n.create(),h=n.create(),l=n.create(),c=n.create(),u=n.create(),d=n.create(),p=n.create(),f=n.create();s.prototype.applyForce=function(){var t=this.stiffness,e=this.damping,i=this.restLength,s=this.bodyA,r=this.bodyB,g=o,m=a,y=h,v=l,x=f,b=c,_=u,w=d,T=p;this.getWorldAnchorA(b),this.getWorldAnchorB(_),n.sub(w,b,s.position),n.sub(T,_,r.position),n.sub(g,_,b);var P=n.len(g);n.normalize(m,g),n.sub(y,r.velocity,s.velocity),n.crossZV(x,r.angularVelocity,T),n.add(y,y,x),n.crossZV(x,s.angularVelocity,w),n.sub(y,y,x),n.scale(v,m,-t*(P-i)-e*n.dot(y,m)),n.sub(s.force,s.force,v),n.add(r.force,r.force,v);var C=n.crossLength(w,v),S=n.crossLength(T,v);s.angularForce-=C,r.angularForce+=S}},{"../math/vec2":30,"../utils/Utils":57,"./Spring":34}],33:[function(t,e,i){function s(t,e,i){i=i||{},n.call(this,t,e,i),this.restAngle="number"==typeof i.restAngle?i.restAngle:e.angle-t.angle}t("../math/vec2");var n=t("./Spring");e.exports=s,(s.prototype=new n).constructor=s,s.prototype.applyForce=function(){var t=this.stiffness,e=this.damping,i=this.restAngle,s=this.bodyA,n=this.bodyB,r=-t*(n.angle-s.angle-i)-e*(n.angularVelocity-s.angularVelocity)*0;s.angularForce-=r,n.angularForce+=r}},{"../math/vec2":30,"./Spring":34}],34:[function(t,e,i){function s(t,e,i){i=n.defaults(i,{stiffness:100,damping:1}),this.stiffness=i.stiffness,this.damping=i.damping,this.bodyA=t,this.bodyB=e}t("../math/vec2");var n=t("../utils/Utils");e.exports=s,s.prototype.applyForce=function(){}},{"../math/vec2":30,"../utils/Utils":57}],35:[function(t,e,i){function s(t,e){e=e||{},this.chassisBody=t,this.wheels=[],this.groundBody=new h({mass:0}),this.world=null;var i=this;this.preStepCallback=function(){i.update()}}function n(t,e){e=e||{},this.vehicle=t,this.forwardEquation=new a(t.chassisBody,t.groundBody),this.sideEquation=new a(t.chassisBody,t.groundBody),this.steerValue=0,this.engineForce=0,this.setSideFriction(void 0!==e.sideFriction?e.sideFriction:5),this.localForwardVector=r.fromValues(0,1),e.localForwardVector&&r.copy(this.localForwardVector,e.localForwardVector),this.localPosition=r.fromValues(0,0),e.localPosition&&r.copy(this.localPosition,e.localPosition),o.apply(this,t.chassisBody,t.groundBody),this.equations.push(this.forwardEquation,this.sideEquation),this.setBrakeForce(0)}var r=t("../math/vec2"),o=(t("../utils/Utils"),t("../constraints/Constraint")),a=t("../equations/FrictionEquation"),h=t("../objects/Body");e.exports=s,s.prototype.addToWorld=function(t){this.world=t,t.addBody(this.groundBody),t.on("preStep",this.preStepCallback);for(var e=0;e<this.wheels.length;e++){var i=this.wheels[e];t.addConstraint(i)}},s.prototype.removeFromWorld=function(){var t=this.world;t.removeBody(this.groundBody),t.off("preStep",this.preStepCallback);for(var e=0;e<this.wheels.length;e++){var i=this.wheels[e];t.removeConstraint(i)}this.world=null},s.prototype.addWheel=function(t){var e=new n(this,t);return this.wheels.push(e),e},s.prototype.update=function(){for(var t=0;t<this.wheels.length;t++)this.wheels[t].update()},(n.prototype=new o).setBrakeForce=function(t){this.forwardEquation.setSlipForce(t)},n.prototype.setSideFriction=function(t){this.sideEquation.setSlipForce(t)};var l=r.create(),c=r.create();n.prototype.getSpeed=function(){return this.vehicle.chassisBody.vectorToWorldFrame(c,this.localForwardVector),this.vehicle.chassisBody.getVelocityAtPoint(l,c),r.dot(l,c)};var u=r.create();n.prototype.update=function(){this.vehicle.chassisBody.vectorToWorldFrame(this.forwardEquation.t,this.localForwardVector),r.rotate(this.sideEquation.t,this.localForwardVector,Math.PI/2),this.vehicle.chassisBody.vectorToWorldFrame(this.sideEquation.t,this.sideEquation.t),r.rotate(this.forwardEquation.t,this.forwardEquation.t,this.steerValue),r.rotate(this.sideEquation.t,this.sideEquation.t,this.steerValue),this.vehicle.chassisBody.toWorldFrame(this.forwardEquation.contactPointB,this.localPosition),r.copy(this.sideEquation.contactPointB,this.forwardEquation.contactPointB),this.vehicle.chassisBody.vectorToWorldFrame(this.forwardEquation.contactPointA,this.localPosition),r.copy(this.sideEquation.contactPointA,this.forwardEquation.contactPointA),r.normalize(u,this.forwardEquation.t),r.scale(u,u,this.engineForce),this.vehicle.chassisBody.applyForce(u,this.forwardEquation.contactPointA)}},{"../constraints/Constraint":14,"../equations/FrictionEquation":23,"../math/vec2":30,"../objects/Body":31,"../utils/Utils":57}],36:[function(t,e,i){var s=e.exports={AABB:t("./collision/AABB"),AngleLockEquation:t("./equations/AngleLockEquation"),Body:t("./objects/Body"),Broadphase:t("./collision/Broadphase"),Capsule:t("./shapes/Capsule"),Circle:t("./shapes/Circle"),Constraint:t("./constraints/Constraint"),ContactEquation:t("./equations/ContactEquation"),ContactEquationPool:t("./utils/ContactEquationPool"),ContactMaterial:t("./material/ContactMaterial"),Convex:t("./shapes/Convex"),DistanceConstraint:t("./constraints/DistanceConstraint"),Equation:t("./equations/Equation"),EventEmitter:t("./events/EventEmitter"),FrictionEquation:t("./equations/FrictionEquation"),FrictionEquationPool:t("./utils/FrictionEquationPool"),GearConstraint:t("./constraints/GearConstraint"),GSSolver:t("./solver/GSSolver"),Heightfield:t("./shapes/Heightfield"),Line:t("./shapes/Line"),LockConstraint:t("./constraints/LockConstraint"),Material:t("./material/Material"),Narrowphase:t("./collision/Narrowphase"),NaiveBroadphase:t("./collision/NaiveBroadphase"),Particle:t("./shapes/Particle"),Plane:t("./shapes/Plane"),Pool:t("./utils/Pool"),RevoluteConstraint:t("./constraints/RevoluteConstraint"),PrismaticConstraint:t("./constraints/PrismaticConstraint"),Ray:t("./collision/Ray"),RaycastResult:t("./collision/RaycastResult"),Box:t("./shapes/Box"),RotationalVelocityEquation:t("./equations/RotationalVelocityEquation"),SAPBroadphase:t("./collision/SAPBroadphase"),Shape:t("./shapes/Shape"),Solver:t("./solver/Solver"),Spring:t("./objects/Spring"),TopDownVehicle:t("./objects/TopDownVehicle"),LinearSpring:t("./objects/LinearSpring"),RotationalSpring:t("./objects/RotationalSpring"),Utils:t("./utils/Utils"),World:t("./world/World"),vec2:t("./math/vec2"),version:t("../package.json").version};Object.defineProperty(s,"Rectangle",{get:function(){return console.warn("The Rectangle class has been renamed to Box."),this.Box}})},{"../package.json":6,"./collision/AABB":7,"./collision/Broadphase":8,"./collision/NaiveBroadphase":9,"./collision/Narrowphase":10,"./collision/Ray":11,"./collision/RaycastResult":12,"./collision/SAPBroadphase":13,"./constraints/Constraint":14,"./constraints/DistanceConstraint":15,"./constraints/GearConstraint":16,"./constraints/LockConstraint":17,"./constraints/PrismaticConstraint":18,"./constraints/RevoluteConstraint":19,"./equations/AngleLockEquation":20,"./equations/ContactEquation":21,"./equations/Equation":22,"./equations/FrictionEquation":23,"./equations/RotationalVelocityEquation":25,"./events/EventEmitter":26,"./material/ContactMaterial":27,"./material/Material":28,"./math/vec2":30,"./objects/Body":31,"./objects/LinearSpring":32,"./objects/RotationalSpring":33,"./objects/Spring":34,"./objects/TopDownVehicle":35,"./shapes/Box":37,"./shapes/Capsule":38,"./shapes/Circle":39,"./shapes/Convex":40,"./shapes/Heightfield":41,"./shapes/Line":42,"./shapes/Particle":43,"./shapes/Plane":44,"./shapes/Shape":45,"./solver/GSSolver":46,"./solver/Solver":47,"./utils/ContactEquationPool":48,"./utils/FrictionEquationPool":49,"./utils/Pool":55,"./utils/Utils":57,"./world/World":61}],37:[function(t,e,i){function s(t){"number"==typeof arguments[0]&&"number"==typeof arguments[1]&&(t={width:arguments[0],height:arguments[1]},console.warn("The Rectangle has been renamed to Box and its constructor signature has changed. Please use the following format: new Box({ width: 1, height: 1, ... })")),t=t||{};var e=this.width=t.width||1,i=this.height=t.height||1,s=[n.fromValues(-e/2,-i/2),n.fromValues(e/2,-i/2),n.fromValues(e/2,i/2),n.fromValues(-e/2,i/2)],a=[n.fromValues(1,0),n.fromValues(0,1)];t.vertices=s,t.axes=a,t.type=r.BOX,o.call(this,t)}var n=t("../math/vec2"),r=t("./Shape"),o=t("./Convex");e.exports=s,(s.prototype=new o).constructor=s,s.prototype.computeMomentOfInertia=function(t){var e=this.width,i=this.height;return t*(i*i+e*e)/12},s.prototype.updateBoundingRadius=function(){var t=this.width,e=this.height;this.boundingRadius=Math.sqrt(t*t+e*e)/2};n.create(),n.create(),n.create(),n.create();s.prototype.computeAABB=function(t,e,i){t.setFromPoints(this.vertices,e,i,0)},s.prototype.updateArea=function(){this.area=this.width*this.height}},{"../math/vec2":30,"./Convex":40,"./Shape":45}],38:[function(t,e,i){function s(t){"number"==typeof arguments[0]&&"number"==typeof arguments[1]&&(t={length:arguments[0],radius:arguments[1]},console.warn("The Capsule constructor signature has changed. Please use the following format: new Capsule({ radius: 1, length: 1 })")),t=t||{},this.length=t.length||1,this.radius=t.radius||1,t.type=n.CAPSULE,n.call(this,t)}var n=t("./Shape"),r=t("../math/vec2");e.exports=s,(s.prototype=new n).constructor=s,s.prototype.computeMomentOfInertia=function(t){var e=this.radius,i=this.length+e,s=2*e;return t*(s*s+i*i)/12},s.prototype.updateBoundingRadius=function(){this.boundingRadius=this.radius+this.length/2},s.prototype.updateArea=function(){this.area=Math.PI*this.radius*this.radius+2*this.radius*this.length};var o=r.create();s.prototype.computeAABB=function(t,e,i){var s=this.radius;r.set(o,this.length/2,0),0!==i&&r.rotate(o,o,i),r.set(t.upperBound,Math.max(o[0]+s,-o[0]+s),Math.max(o[1]+s,-o[1]+s)),r.set(t.lowerBound,Math.min(o[0]-s,-o[0]-s),Math.min(o[1]-s,-o[1]-s)),r.add(t.lowerBound,t.lowerBound,e),r.add(t.upperBound,t.upperBound,e)};var a=r.create(),h=r.create(),l=r.create(),c=r.create(),u=r.fromValues(0,1);s.prototype.raycast=function(t,e,i,s){for(var n=e.from,o=e.to,d=(e.direction,a),p=h,f=l,g=c,m=this.length/2,y=0;y<2;y++){var v=this.radius*(2*y-1);if(r.set(f,-m,v),r.set(g,m,v),r.toGlobalFrame(f,f,i,s),r.toGlobalFrame(g,g,i,s),(T=r.getLineSegmentsIntersectionFraction(n,o,f,g))>=0&&(r.rotate(p,u,s),r.scale(p,p,2*y-1),e.reportIntersection(t,T,p,-1),t.shouldStop(e)))return}for(var x=Math.pow(this.radius,2)+Math.pow(m,2),y=0;y<2;y++){r.set(f,m*(2*y-1),0),r.toGlobalFrame(f,f,i,s);var b=Math.pow(o[0]-n[0],2)+Math.pow(o[1]-n[1],2),_=2*((o[0]-n[0])*(n[0]-f[0])+(o[1]-n[1])*(n[1]-f[1])),w=Math.pow(n[0]-f[0],2)+Math.pow(n[1]-f[1],2)-Math.pow(this.radius,2),T=Math.pow(_,2)-4*b*w;if(!(T<0))if(0===T){if(r.lerp(d,n,o,T),r.squaredDistance(d,i)>x&&(r.sub(p,d,f),r.normalize(p,p),e.reportIntersection(t,T,p,-1),t.shouldStop(e)))return}else{var P=Math.sqrt(T),C=1/(2*b),S=(-_-P)*C,A=(-_+P)*C;if(S>=0&&S<=1&&(r.lerp(d,n,o,S),r.squaredDistance(d,i)>x&&(r.sub(p,d,f),r.normalize(p,p),e.reportIntersection(t,S,p,-1),t.shouldStop(e))))return;if(A>=0&&A<=1&&(r.lerp(d,n,o,A),r.squaredDistance(d,i)>x&&(r.sub(p,d,f),r.normalize(p,p),e.reportIntersection(t,A,p,-1),t.shouldStop(e))))return}}}},{"../math/vec2":30,"./Shape":45}],39:[function(t,e,i){function s(t){"number"==typeof arguments[0]&&(t={radius:arguments[0]},console.warn("The Circle constructor signature has changed. Please use the following format: new Circle({ radius: 1 })")),t=t||{},this.radius=t.radius||1,t.type=n.CIRCLE,n.call(this,t)}var n=t("./Shape"),r=t("../math/vec2");e.exports=s,(s.prototype=new n).constructor=s,s.prototype.computeMomentOfInertia=function(t){var e=this.radius;return t*e*e/2},s.prototype.updateBoundingRadius=function(){this.boundingRadius=this.radius},s.prototype.updateArea=function(){this.area=Math.PI*this.radius*this.radius},s.prototype.computeAABB=function(t,e,i){var s=this.radius;r.set(t.upperBound,s,s),r.set(t.lowerBound,-s,-s),e&&(r.add(t.lowerBound,t.lowerBound,e),r.add(t.upperBound,t.upperBound,e))};var o=r.create(),a=r.create();s.prototype.raycast=function(t,e,i,s){var n=e.from,h=e.to,l=this.radius,c=Math.pow(h[0]-n[0],2)+Math.pow(h[1]-n[1],2),u=2*((h[0]-n[0])*(n[0]-i[0])+(h[1]-n[1])*(n[1]-i[1])),d=Math.pow(n[0]-i[0],2)+Math.pow(n[1]-i[1],2)-Math.pow(l,2),p=Math.pow(u,2)-4*c*d,f=o,g=a;if(!(p<0))if(0===p)r.lerp(f,n,h,p),r.sub(g,f,i),r.normalize(g,g),e.reportIntersection(t,p,g,-1);else{var m=Math.sqrt(p),y=1/(2*c),v=(-u-m)*y,x=(-u+m)*y;if(v>=0&&v<=1&&(r.lerp(f,n,h,v),r.sub(g,f,i),r.normalize(g,g),e.reportIntersection(t,v,g,-1),t.shouldStop(e)))return;x>=0&&x<=1&&(r.lerp(f,n,h,x),r.sub(g,f,i),r.normalize(g,g),e.reportIntersection(t,x,g,-1))}}},{"../math/vec2":30,"./Shape":45}],40:[function(t,e,i){function s(t){Array.isArray(arguments[0])&&(t={vertices:arguments[0],axes:arguments[1]},console.warn("The Convex constructor signature has changed. Please use the following format: new Convex({ vertices: [...], ... })")),t=t||{},this.vertices=[];for(var e=void 0!==t.vertices?t.vertices:[],i=0;i<e.length;i++){var s=r.create();r.copy(s,e[i]),this.vertices.push(s)}if(this.axes=[],t.axes)for(i=0;i<t.axes.length;i++){var o=r.create();r.copy(o,t.axes[i]),this.axes.push(o)}else for(i=0;i<this.vertices.length;i++){var a=this.vertices[i],h=this.vertices[(i+1)%this.vertices.length],l=r.create();r.sub(l,h,a),r.rotate90cw(l,l),r.normalize(l,l),this.axes.push(l)}if(this.centerOfMass=r.fromValues(0,0),this.triangles=[],this.vertices.length&&(this.updateTriangles(),this.updateCenterOfMass()),this.boundingRadius=0,t.type=n.CONVEX,n.call(this,t),this.updateBoundingRadius(),this.updateArea(),this.area<0)throw new Error("Convex vertices must be given in conter-clockwise winding.")}var n=t("./Shape"),r=t("../math/vec2"),o=t("../math/polyk");t("poly-decomp");e.exports=s,(s.prototype=new n).constructor=s;var a=r.create(),h=r.create();s.prototype.projectOntoLocalAxis=function(t,e){for(var i,s,n=null,o=null,t=a,h=0;h<this.vertices.length;h++)i=this.vertices[h],s=r.dot(i,t),(null===n||s>n)&&(n=s),(null===o||s<o)&&(o=s);if(o>n){var l=o;o=n,n=l}r.set(e,o,n)},s.prototype.projectOntoWorldAxis=function(t,e,i,s){var n=h;this.projectOntoLocalAxis(t,s),0!==i?r.rotate(n,t,i):n=t;var o=r.dot(e,n);r.set(s,s[0]+o,s[1]+o)},s.prototype.updateTriangles=function(){this.triangles.length=0;for(var t=[],e=0;e<this.vertices.length;e++){var i=this.vertices[e];t.push(i[0],i[1])}for(var s=o.Triangulate(t),e=0;e<s.length;e+=3){var n=s[e],r=s[e+1],a=s[e+2];this.triangles.push([n,r,a])}};var l=r.create(),c=r.create(),u=r.create(),d=r.create(),p=r.create();r.create(),r.create(),r.create(),r.create();s.prototype.updateCenterOfMass=function(){var t=this.triangles,e=this.vertices,i=this.centerOfMass,n=l,o=u,a=d,h=p,f=c;r.set(i,0,0);for(var g=0,m=0;m!==t.length;m++){var y=t[m],o=e[y[0]],a=e[y[1]],h=e[y[2]];r.centroid(n,o,a,h);var v=s.triangleArea(o,a,h);g+=v,r.scale(f,n,v),r.add(i,i,f)}r.scale(i,i,1/g)},s.prototype.computeMomentOfInertia=function(t){for(var e=0,i=0,s=this.vertices.length,n=s-1,o=0;o<s;n=o,o++){var a=this.vertices[n],h=this.vertices[o],l=Math.abs(r.crossLength(a,h));e+=l*(r.dot(h,h)+r.dot(h,a)+r.dot(a,a)),i+=l}return t/6*(e/i)},s.prototype.updateBoundingRadius=function(){for(var t=this.vertices,e=0,i=0;i!==t.length;i++){var s=r.squaredLength(t[i]);s>e&&(e=s)}this.boundingRadius=Math.sqrt(e)},s.triangleArea=function(t,e,i){return.5*((e[0]-t[0])*(i[1]-t[1])-(i[0]-t[0])*(e[1]-t[1]))},s.prototype.updateArea=function(){this.updateTriangles(),this.area=0;for(var t=this.triangles,e=this.vertices,i=0;i!==t.length;i++){var n=t[i],r=e[n[0]],o=e[n[1]],a=e[n[2]],h=s.triangleArea(r,o,a);this.area+=h}},s.prototype.computeAABB=function(t,e,i){t.setFromPoints(this.vertices,e,i,0)};var f=r.create(),g=r.create(),m=r.create();s.prototype.raycast=function(t,e,i,s){var n=f,o=g,a=m,h=this.vertices;r.toLocalFrame(n,e.from,i,s),r.toLocalFrame(o,e.to,i,s);for(var l=h.length,c=0;c<l&&!t.shouldStop(e);c++){var u=h[c],d=h[(c+1)%l],p=r.getLineSegmentsIntersectionFraction(n,o,u,d);p>=0&&(r.sub(a,d,u),r.rotate(a,a,-Math.PI/2+s),r.normalize(a,a),e.reportIntersection(t,p,a,c))}}},{"../math/polyk":29,"../math/vec2":30,"./Shape":45,"poly-decomp":5}],41:[function(t,e,i){function s(t){if(Array.isArray(arguments[0])){if(t={heights:arguments[0]},"object"==typeof arguments[1])for(var e in arguments[1])t[e]=arguments[1][e];console.warn("The Heightfield constructor signature has changed. Please use the following format: new Heightfield({ heights: [...], ... })")}t=t||{},this.heights=t.heights?t.heights.slice(0):[],this.maxValue=t.maxValue||null,this.minValue=t.minValue||null,this.elementWidth=t.elementWidth||.1,void 0!==t.maxValue&&void 0!==t.minValue||this.updateMaxMinValues(),t.type=n.HEIGHTFIELD,n.call(this,t)}var n=t("./Shape"),r=t("../math/vec2");t("../utils/Utils");e.exports=s,(s.prototype=new n).constructor=s,s.prototype.updateMaxMinValues=function(){for(var t=this.heights,e=t[0],i=t[0],s=0;s!==t.length;s++){var n=t[s];n>e&&(e=n),n<i&&(i=n)}this.maxValue=e,this.minValue=i},s.prototype.computeMomentOfInertia=function(t){return Number.MAX_VALUE},s.prototype.updateBoundingRadius=function(){this.boundingRadius=Number.MAX_VALUE},s.prototype.updateArea=function(){for(var t=this.heights,e=0,i=0;i<t.length-1;i++)e+=(t[i]+t[i+1])/2*this.elementWidth;this.area=e};var o=[r.create(),r.create(),r.create(),r.create()];s.prototype.computeAABB=function(t,e,i){r.set(o[0],0,this.maxValue),r.set(o[1],this.elementWidth*this.heights.length,this.maxValue),r.set(o[2],this.elementWidth*this.heights.length,this.minValue),r.set(o[3],0,this.minValue),t.setFromPoints(o,e,i)},s.prototype.getLineSegment=function(t,e,i){var s=this.heights,n=this.elementWidth;r.set(t,i*n,s[i]),r.set(e,(i+1)*n,s[i+1])},s.prototype.getSegmentIndex=function(t){return Math.floor(t[0]/this.elementWidth)},s.prototype.getClampedSegmentIndex=function(t){var e=this.getSegmentIndex(t);return e=Math.min(this.heights.length,Math.max(e,0))};r.create();var a=r.create(),h=r.create(),l=r.create(),c=r.create(),u=r.create();r.fromValues(0,1);s.prototype.raycast=function(t,e,i,s){var n=e.from,o=e.to,d=(e.direction,a),p=h,f=l,g=c,m=u;r.toLocalFrame(g,n,i,s),r.toLocalFrame(m,o,i,s);var y=this.getClampedSegmentIndex(g),v=this.getClampedSegmentIndex(m);if(y>v){var x=y;y=v,v=x}for(var b=0;b<this.heights.length-1;b++){this.getLineSegment(p,f,b);var _=r.getLineSegmentsIntersectionFraction(g,m,p,f);if(_>=0&&(r.sub(d,f,p),r.rotate(d,d,s+Math.PI/2),r.normalize(d,d),e.reportIntersection(t,_,d,-1),t.shouldStop(e)))return}}},{"../math/vec2":30,"../utils/Utils":57,"./Shape":45}],42:[function(t,e,i){function s(t){"number"==typeof arguments[0]&&(t={length:arguments[0]},console.warn("The Line constructor signature has changed. Please use the following format: new Line({ length: 1, ... })")),t=t||{},this.length=t.length||1,t.type=n.LINE,n.call(this,t)}var n=t("./Shape"),r=t("../math/vec2");e.exports=s,(s.prototype=new n).constructor=s,s.prototype.computeMomentOfInertia=function(t){return t*Math.pow(this.length,2)/12},s.prototype.updateBoundingRadius=function(){this.boundingRadius=this.length/2};var o=[r.create(),r.create()];s.prototype.computeAABB=function(t,e,i){var s=this.length/2;r.set(o[0],-s,0),r.set(o[1],s,0),t.setFromPoints(o,e,i,0)};r.create();var a=r.create(),h=r.create(),l=r.create(),c=r.fromValues(0,1);s.prototype.raycast=function(t,e,i,s){var n=e.from,o=e.to,u=h,d=l,p=this.length/2;r.set(u,-p,0),r.set(d,p,0),r.toGlobalFrame(u,u,i,s),r.toGlobalFrame(d,d,i,s);var f=r.getLineSegmentsIntersectionFraction(u,d,n,o);if(f>=0){var g=a;r.rotate(g,c,s),e.reportIntersection(t,f,g,-1)}}},{"../math/vec2":30,"./Shape":45}],43:[function(t,e,i){function s(t){(t=t||{}).type=n.PARTICLE,n.call(this,t)}var n=t("./Shape"),r=t("../math/vec2");e.exports=s,(s.prototype=new n).constructor=s,s.prototype.computeMomentOfInertia=function(t){return 0},s.prototype.updateBoundingRadius=function(){this.boundingRadius=0},s.prototype.computeAABB=function(t,e,i){r.copy(t.lowerBound,e),r.copy(t.upperBound,e)}},{"../math/vec2":30,"./Shape":45}],44:[function(t,e,i){function s(t){(t=t||{}).type=n.PLANE,n.call(this,t)}var n=t("./Shape"),r=t("../math/vec2");t("../utils/Utils");e.exports=s,(s.prototype=new n).constructor=s,s.prototype.computeMomentOfInertia=function(t){return 0},s.prototype.updateBoundingRadius=function(){this.boundingRadius=Number.MAX_VALUE},s.prototype.computeAABB=function(t,e,i){var s=i%(2*Math.PI),n=r.set,o=t.lowerBound,a=t.upperBound;n(o,-1e7,-1e7),n(a,1e7,1e7),0===s?a[1]=0:s===Math.PI/2?o[0]=0:s===Math.PI?o[1]=0:s===3*Math.PI/2&&(a[0]=0)},s.prototype.updateArea=function(){this.area=Number.MAX_VALUE};var o=r.create(),a=(r.create(),r.create(),r.create()),h=r.create();s.prototype.raycast=function(t,e,i,s){var n=e.from,l=e.to,c=e.direction,u=o,d=a,p=h;r.set(d,0,1),r.rotate(d,d,s),r.sub(p,n,i);var f=r.dot(p,d);if(r.sub(p,l,i),!(f*r.dot(p,d)>0||r.squaredDistance(n,l)<f*f)){var g=r.dot(d,c);r.sub(u,n,i);var m=-r.dot(d,u)/g/e.length;e.reportIntersection(t,m,d,-1)}}},{"../math/vec2":30,"../utils/Utils":57,"./Shape":45}],45:[function(t,e,i){function s(t){t=t||{},this.body=null,this.position=n.fromValues(0,0),t.position&&n.copy(this.position,t.position),this.angle=t.angle||0,this.type=t.type||0,this.id=s.idCounter++,this.boundingRadius=0,this.collisionGroup=void 0!==t.collisionGroup?t.collisionGroup:1,this.collisionResponse=void 0===t.collisionResponse||t.collisionResponse,this.collisionMask=void 0!==t.collisionMask?t.collisionMask:1,this.material=t.material||null,this.area=0,this.sensor=void 0!==t.sensor&&t.sensor,this.type&&this.updateBoundingRadius(),this.updateArea()}e.exports=s;var n=t("../math/vec2");s.idCounter=0,s.CIRCLE=1,s.PARTICLE=2,s.PLANE=4,s.CONVEX=8,s.LINE=16,s.BOX=32,s.CAPSULE=64,s.HEIGHTFIELD=128,s.prototype.computeMomentOfInertia=function(t){},s.prototype.updateBoundingRadius=function(){},s.prototype.updateArea=function(){},s.prototype.computeAABB=function(t,e,i){},s.prototype.raycast=function(t,e,i,s){}},{"../math/vec2":30}],46:[function(t,e,i){function s(t){o.call(this,t,o.GS),t=t||{},this.iterations=t.iterations||10,this.tolerance=t.tolerance||1e-7,this.arrayStep=30,this.lambda=new a.ARRAY_TYPE(this.arrayStep),this.Bs=new a.ARRAY_TYPE(this.arrayStep),this.invCs=new a.ARRAY_TYPE(this.arrayStep),this.useZeroRHS=!1,this.frictionIterations=void 0!==t.frictionIterations?0:t.frictionIterations,this.usedIterations=0}function n(t){for(var e=t.length;e--;)t[e]=0}var r=t("../math/vec2"),o=t("./Solver"),a=t("../utils/Utils"),h=t("../equations/FrictionEquation");e.exports=s,(s.prototype=new o).constructor=s,s.prototype.solve=function(t,e){this.sortEquations();var i=0,o=this.iterations,l=this.frictionIterations,c=this.equations,u=c.length,d=Math.pow(this.tolerance*u,2),p=e.bodies,f=e.bodies.length,g=(r.add,r.set,this.useZeroRHS),m=this.lambda;if(this.usedIterations=0,u)for(x=0;x!==f;x++)(T=p[x]).updateSolveMassProperties();m.length<u&&(m=this.lambda=new a.ARRAY_TYPE(u+this.arrayStep),this.Bs=new a.ARRAY_TYPE(u+this.arrayStep),this.invCs=new a.ARRAY_TYPE(u+this.arrayStep)),n(m);for(var y=this.invCs,v=this.Bs,m=this.lambda,x=0;x!==c.length;x++)((b=c[x]).timeStep!==t||b.needsUpdate)&&(b.timeStep=t,b.update()),v[x]=b.computeB(b.a,b.b,t),y[x]=b.computeInvC(b.epsilon);var b,_,w;if(0!==u){for(x=0;x!==f;x++){var T=p[x];T.resetConstraintVelocity()}if(l){for(i=0;i!==l;i++){for(_=0,w=0;w!==u;w++){b=c[w];A=s.iterateEquation(w,b,b.epsilon,v,y,m,g,t,i);_+=Math.abs(A)}if(this.usedIterations++,_*_<=d)break}for(s.updateMultipliers(c,m,1/t),w=0;w!==u;w++){var P=c[w];if(P instanceof h){for(var C=0,S=0;S!==P.contactEquations.length;S++)C+=P.contactEquations[S].multiplier;C*=P.frictionCoefficient/P.contactEquations.length,P.maxForce=C,P.minForce=-C}}}for(i=0;i!==o;i++){for(_=0,w=0;w!==u;w++){b=c[w];var A=s.iterateEquation(w,b,b.epsilon,v,y,m,g,t,i);_+=Math.abs(A)}if(this.usedIterations++,_*_<=d)break}for(x=0;x!==f;x++)p[x].addConstraintVelocity();s.updateMultipliers(c,m,1/t)}},s.updateMultipliers=function(t,e,i){for(var s=t.length;s--;)t[s].multiplier=e[s]*i},s.iterateEquation=function(t,e,i,s,n,r,o,a,h){var l=s[t],c=n[t],u=r[t],d=e.computeGWlambda(),p=e.maxForce,f=e.minForce;o&&(l=0);var g=c*(l-d-i*u),m=u+g;return m<f*a?g=f*a-u:m>p*a&&(g=p*a-u),r[t]+=g,e.addToWlambda(g),g}},{"../equations/FrictionEquation":23,"../math/vec2":30,"../utils/Utils":57,"./Solver":47}],47:[function(t,e,i){function s(t,e){t=t||{},n.call(this),this.type=e,this.equations=[],this.equationSortFunction=t.equationSortFunction||!1}t("../utils/Utils");var n=t("../events/EventEmitter");e.exports=s,(s.prototype=new n).constructor=s,s.prototype.solve=function(t,e){throw new Error("Solver.solve should be implemented by subclasses!")};var r={bodies:[]};s.prototype.solveIsland=function(t,e){this.removeAllEquations(),e.equations.length&&(this.addEquations(e.equations),r.bodies.length=0,e.getBodies(r.bodies),r.bodies.length&&this.solve(t,r))},s.prototype.sortEquations=function(){this.equationSortFunction&&this.equations.sort(this.equationSortFunction)},s.prototype.addEquation=function(t){t.enabled&&this.equations.push(t)},s.prototype.addEquations=function(t){for(var e=0,i=t.length;e!==i;e++){var s=t[e];s.enabled&&this.equations.push(s)}},s.prototype.removeEquation=function(t){var e=this.equations.indexOf(t);-1!==e&&this.equations.splice(e,1)},s.prototype.removeAllEquations=function(){this.equations.length=0},s.GS=1,s.ISLAND=2},{"../events/EventEmitter":26,"../utils/Utils":57}],48:[function(t,e,i){function s(){r.apply(this,arguments)}var n=t("../equations/ContactEquation"),r=t("./Pool");e.exports=s,(s.prototype=new r).constructor=s,s.prototype.create=function(){return new n},s.prototype.destroy=function(t){return t.bodyA=t.bodyB=null,this}},{"../equations/ContactEquation":21,"./Pool":55}],49:[function(t,e,i){function s(){r.apply(this,arguments)}var n=t("../equations/FrictionEquation"),r=t("./Pool");e.exports=s,(s.prototype=new r).constructor=s,s.prototype.create=function(){return new n},s.prototype.destroy=function(t){return t.bodyA=t.bodyB=null,this}},{"../equations/FrictionEquation":23,"./Pool":55}],50:[function(t,e,i){function s(){r.apply(this,arguments)}var n=t("../world/IslandNode"),r=t("./Pool");e.exports=s,(s.prototype=new r).constructor=s,s.prototype.create=function(){return new n},s.prototype.destroy=function(t){return t.reset(),this}},{"../world/IslandNode":60,"./Pool":55}],51:[function(t,e,i){function s(){r.apply(this,arguments)}var n=t("../world/Island"),r=t("./Pool");e.exports=s,(s.prototype=new r).constructor=s,s.prototype.create=function(){return new n},s.prototype.destroy=function(t){return t.reset(),this}},{"../world/Island":58,"./Pool":55}],52:[function(t,e,i){function s(){this.overlappingShapesLastState=new n,this.overlappingShapesCurrentState=new n,this.recordPool=new r({size:16}),this.tmpDict=new n,this.tmpArray1=[]}var n=t("./TupleDictionary"),r=(t("./OverlapKeeperRecord"),t("./OverlapKeeperRecordPool"));t("./Utils");e.exports=s,s.prototype.tick=function(){for(var t=this.overlappingShapesLastState,e=this.overlappingShapesCurrentState,i=t.keys.length;i--;){var s=t.keys[i],n=t.getByKey(s);e.getByKey(s);n&&this.recordPool.release(n)}t.reset(),t.copy(e),e.reset()},s.prototype.setOverlapping=function(t,e,i,s){this.overlappingShapesLastState;var n=this.overlappingShapesCurrentState;if(!n.get(e.id,s.id)){var r=this.recordPool.get();r.set(t,e,i,s),n.set(e.id,s.id,r)}},s.prototype.getNewOverlaps=function(t){return this.getDiff(this.overlappingShapesLastState,this.overlappingShapesCurrentState,t)},s.prototype.getEndOverlaps=function(t){return this.getDiff(this.overlappingShapesCurrentState,this.overlappingShapesLastState,t)},s.prototype.bodiesAreOverlapping=function(t,e){for(var i=this.overlappingShapesCurrentState,s=i.keys.length;s--;){var n=i.keys[s],r=i.data[n];if(r.bodyA===t&&r.bodyB===e||r.bodyA===e&&r.bodyB===t)return!0}return!1},s.prototype.getDiff=function(t,e,i){var s=t,n=e;(i=i||[]).length=0;for(var r=n.keys.length;r--;){var o=n.keys[r],a=n.data[o];if(!a)throw new Error("Key "+o+" had no data!");s.data[o]||i.push(a)}return i},s.prototype.isNewOverlap=function(t,e){var i=0|t.id,s=0|e.id,n=this.overlappingShapesLastState,r=this.overlappingShapesCurrentState;return!n.get(i,s)&&!!r.get(i,s)},s.prototype.getNewBodyOverlaps=function(t){this.tmpArray1.length=0;var e=this.getNewOverlaps(this.tmpArray1);return this.getBodyDiff(e,t)},s.prototype.getEndBodyOverlaps=function(t){this.tmpArray1.length=0;var e=this.getEndOverlaps(this.tmpArray1);return this.getBodyDiff(e,t)},s.prototype.getBodyDiff=function(t,e){e=e||[];for(var i=this.tmpDict,s=t.length;s--;){var n=t[s];i.set(0|n.bodyA.id,0|n.bodyB.id,n)}for(s=i.keys.length;s--;)(n=i.getByKey(i.keys[s]))&&e.push(n.bodyA,n.bodyB);return i.reset(),e}},{"./OverlapKeeperRecord":53,"./OverlapKeeperRecordPool":54,"./TupleDictionary":56,"./Utils":57}],53:[function(t,e,i){function s(t,e,i,s){this.shapeA=e,this.shapeB=s,this.bodyA=t,this.bodyB=i}e.exports=s,s.prototype.set=function(t,e,i,n){s.call(this,t,e,i,n)}},{}],54:[function(t,e,i){function s(){r.apply(this,arguments)}var n=t("./OverlapKeeperRecord"),r=t("./Pool");e.exports=s,(s.prototype=new r).constructor=s,s.prototype.create=function(){return new n},s.prototype.destroy=function(t){return t.bodyA=t.bodyB=t.shapeA=t.shapeB=null,this}},{"./OverlapKeeperRecord":53,"./Pool":55}],55:[function(t,e,i){function s(t){t=t||{},this.objects=[],void 0!==t.size&&this.resize(t.size)}e.exports=s,s.prototype.resize=function(t){for(var e=this.objects;e.length>t;)e.pop();for(;e.length<t;)e.push(this.create());return this},s.prototype.get=function(){var t=this.objects;return t.length?t.pop():this.create()},s.prototype.release=function(t){return this.destroy(t),this.objects.push(t),this}},{}],56:[function(t,e,i){function s(){this.data={},this.keys=[]}var n=t("./Utils");e.exports=s,s.prototype.getKey=function(t,e){return t|=0,e|=0,(0|t)==(0|e)?-1:0|((0|t)>(0|e)?t<<16|65535&e:e<<16|65535&t)},s.prototype.getByKey=function(t){return t|=0,this.data[t]},s.prototype.get=function(t,e){return this.data[this.getKey(t,e)]},s.prototype.set=function(t,e,i){if(!i)throw new Error("No data!");var s=this.getKey(t,e);return this.data[s]||this.keys.push(s),this.data[s]=i,s},s.prototype.reset=function(){for(var t=this.data,e=this.keys,i=e.length;i--;)delete t[e[i]];e.length=0},s.prototype.copy=function(t){this.reset(),n.appendArray(this.keys,t.keys);for(var e=t.keys.length;e--;){var i=t.keys[e];this.data[i]=t.data[i]}}},{"./Utils":57}],57:[function(t,e,i){function s(){}e.exports=s,s.appendArray=function(t,e){if(e.length<15e4)t.push.apply(t,e);else for(var i=0,s=e.length;i!==s;++i)t.push(e[i])},s.splice=function(t,e,i){i=i||1;for(var s=e,n=t.length-i;s<n;s++)t[s]=t[s+i];t.length=n},s.ARRAY_TYPE="undefined"!=typeof P2_ARRAY_TYPE?P2_ARRAY_TYPE:"undefined"!=typeof Float32Array?Float32Array:Array,s.extend=function(t,e){for(var i in e)t[i]=e[i]},s.defaults=function(t,e){t=t||{};for(var i in e)i in t||(t[i]=e[i]);return t}},{}],58:[function(t,e,i){function s(){this.equations=[],this.bodies=[]}var n=t("../objects/Body");e.exports=s,s.prototype.reset=function(){this.equations.length=this.bodies.length=0};var r=[];s.prototype.getBodies=function(t){var e=t||[],i=this.equations;r.length=0;for(var s=0;s!==i.length;s++){var n=i[s];-1===r.indexOf(n.bodyA.id)&&(e.push(n.bodyA),r.push(n.bodyA.id)),-1===r.indexOf(n.bodyB.id)&&(e.push(n.bodyB),r.push(n.bodyB.id))}return e},s.prototype.wantsToSleep=function(){for(var t=0;t<this.bodies.length;t++){var e=this.bodies[t];if(e.type===n.DYNAMIC&&!e.wantsToSleep)return!1}return!0},s.prototype.sleep=function(){for(var t=0;t<this.bodies.length;t++)this.bodies[t].sleep();return!0}},{"../objects/Body":31}],59:[function(t,e,i){function s(t){this.nodePool=new n({size:16}),this.islandPool=new r({size:8}),this.equations=[],this.islands=[],this.nodes=[],this.queue=[]}t("../math/vec2"),t("./Island"),t("./IslandNode");var n=t("./../utils/IslandNodePool"),r=t("./../utils/IslandPool"),o=t("../objects/Body");e.exports=s,s.getUnvisitedNode=function(t){for(var e=t.length,i=0;i!==e;i++){var s=t[i];if(!s.visited&&s.body.type===o.DYNAMIC)return s}return!1},s.prototype.visit=function(t,e,i){e.push(t.body);for(var s=t.equations.length,n=0;n!==s;n++){var r=t.equations[n];-1===i.indexOf(r)&&i.push(r)}},s.prototype.bfs=function(t,e,i){var n=this.queue;for(n.length=0,n.push(t),t.visited=!0,this.visit(t,e,i);n.length;)for(var r,a=n.pop();r=s.getUnvisitedNode(a.neighbors);)r.visited=!0,this.visit(r,e,i),r.body.type===o.DYNAMIC&&n.push(r)},s.prototype.split=function(t){for(var e=t.bodies,i=this.nodes,n=this.equations;i.length;)this.nodePool.release(i.pop());for(h=0;h!==e.length;h++){var r=this.nodePool.get();r.body=e[h],i.push(r)}for(var o=0;o!==n.length;o++){var a=n[o],h=e.indexOf(a.bodyA),l=e.indexOf(a.bodyB),c=i[h],u=i[l];c.neighbors.push(u),u.neighbors.push(c),c.equations.push(a),u.equations.push(a)}for(var d=this.islands,h=0;h<d.length;h++)this.islandPool.release(d[h]);d.length=0;for(var p;p=s.getUnvisitedNode(i);){var f=this.islandPool.get();this.bfs(p,f.bodies,f.equations),d.push(f)}return d}},{"../math/vec2":30,"../objects/Body":31,"./../utils/IslandNodePool":50,"./../utils/IslandPool":51,"./Island":58,"./IslandNode":60}],60:[function(t,e,i){function s(t){this.body=t,this.neighbors=[],this.equations=[],this.visited=!1}e.exports=s,s.prototype.reset=function(){this.equations.length=0,this.neighbors.length=0,this.visited=!1,this.body=null}},{}],61:[function(t,e,i){function s(t){u.apply(this),t=t||{},this.springs=[],this.bodies=[],this.disabledBodyCollisionPairs=[],this.solver=t.solver||new n,this.narrowphase=new y(this),this.islandManager=new b,this.gravity=r.fromValues(0,-9.78),t.gravity&&r.copy(this.gravity,t.gravity),this.frictionGravity=r.length(this.gravity)||10,this.useWorldGravityAsFrictionGravity=!0,this.useFrictionGravityOnZeroGravity=!0,this.broadphase=t.broadphase||new m,this.broadphase.setWorld(this),this.constraints=[],this.defaultMaterial=new p,this.defaultContactMaterial=new f(this.defaultMaterial,this.defaultMaterial),this.lastTimeStep=1/60,this.applySpringForces=!0,this.applyDamping=!0,this.applyGravity=!0,this.solveConstraints=!0,this.contactMaterials=[],this.time=0,this.accumulator=0,this.stepping=!1,this.bodiesToBeRemoved=[],this.islandSplit=void 0===t.islandSplit||!!t.islandSplit,this.emitImpactEvent=!0,this._constraintIdCounter=0,this._bodyIdCounter=0,this.postStepEvent={type:"postStep"},this.addBodyEvent={type:"addBody",body:null},this.removeBodyEvent={type:"removeBody",body:null},this.addSpringEvent={type:"addSpring",spring:null},this.impactEvent={type:"impact",bodyA:null,bodyB:null,shapeA:null,shapeB:null,contactEquation:null},this.postBroadphaseEvent={type:"postBroadphase",pairs:null},this.sleepMode=s.NO_SLEEPING,this.beginContactEvent={type:"beginContact",shapeA:null,shapeB:null,bodyA:null,bodyB:null,contactEquations:[]},this.endContactEvent={type:"endContact",shapeA:null,shapeB:null,bodyA:null,bodyB:null},this.preSolveEvent={type:"preSolve",contactEquations:null,frictionEquations:null},this.overlappingShapesLastState={keys:[]},this.overlappingShapesCurrentState={keys:[]},this.overlapKeeper=new x}var n=t("../solver/GSSolver"),r=(t("../solver/Solver"),t("../collision/Ray"),t("../math/vec2")),o=t("../shapes/Circle"),a=t("../shapes/Convex"),h=(t("../shapes/Line"),t("../shapes/Plane")),l=t("../shapes/Capsule"),c=t("../shapes/Particle"),u=t("../events/EventEmitter"),d=t("../objects/Body"),p=(t("../shapes/Shape"),t("../objects/LinearSpring"),t("../material/Material")),f=t("../material/ContactMaterial"),g=(t("../constraints/DistanceConstraint"),t("../constraints/Constraint"),t("../constraints/LockConstraint"),t("../constraints/RevoluteConstraint"),t("../constraints/PrismaticConstraint"),t("../constraints/GearConstraint"),t("../../package.json"),t("../collision/Broadphase"),t("../collision/AABB")),m=t("../collision/SAPBroadphase"),y=t("../collision/Narrowphase"),v=t("../utils/Utils"),x=t("../utils/OverlapKeeper"),b=t("./IslandManager");t("../objects/RotationalSpring");e.exports=s,s.prototype=new Object(u.prototype),s.prototype.constructor=s,s.NO_SLEEPING=1,s.BODY_SLEEPING=2,s.ISLAND_SLEEPING=4,s.prototype.addConstraint=function(t){this.constraints.push(t)},s.prototype.addContactMaterial=function(t){this.contactMaterials.push(t)},s.prototype.removeContactMaterial=function(t){var e=this.contactMaterials.indexOf(t);-1!==e&&v.splice(this.contactMaterials,e,1)},s.prototype.getContactMaterial=function(t,e){for(var i=this.contactMaterials,s=0,n=i.length;s!==n;s++){var r=i[s];if(r.materialA.id===t.id&&r.materialB.id===e.id||r.materialA.id===e.id&&r.materialB.id===t.id)return r}return!1},s.prototype.removeConstraint=function(t){var e=this.constraints.indexOf(t);-1!==e&&v.splice(this.constraints,e,1)};r.create(),r.create(),r.create(),r.create(),r.create(),r.create();var _=r.create(),w=r.fromValues(0,0),T=r.fromValues(0,0);r.fromValues(0,0),r.fromValues(0,0);s.prototype.step=function(t,e,i){if(i=i||10,0===(e=e||0))this.internalStep(t),this.time+=t;else{this.accumulator+=e;for(var s=0;this.accumulator>=t&&s<i;)this.internalStep(t),this.time+=t,this.accumulator-=t,s++;for(var n=this.accumulator%t/t,o=0;o!==this.bodies.length;o++){var a=this.bodies[o];r.lerp(a.interpolatedPosition,a.previousPosition,a.position,n),a.interpolatedAngle=a.previousAngle+n*(a.angle-a.previousAngle)}}};var P=[];s.prototype.internalStep=function(t){this.stepping=!0;var e=this.springs.length,i=this.springs,n=this.bodies,o=this.gravity,a=this.solver,h=this.bodies.length,l=this.broadphase,c=this.narrowphase,u=this.constraints,p=_,f=(r.scale,r.add),g=(r.rotate,this.islandManager);if(this.overlapKeeper.tick(),this.lastTimeStep=t,this.useWorldGravityAsFrictionGravity){var m=r.length(this.gravity);0===m&&this.useFrictionGravityOnZeroGravity||(this.frictionGravity=m)}if(this.applyGravity)for(T=0;T!==h;T++){var y=(x=n[T]).force;x.type===d.DYNAMIC&&x.sleepState!==d.SLEEPING&&(r.scale(p,o,x.mass*x.gravityScale),f(y,y,p))}if(this.applySpringForces)for(T=0;T!==e;T++)i[T].applyForce();if(this.applyDamping)for(T=0;T!==h;T++){var x=n[T];x.type===d.DYNAMIC&&x.applyDamping(t)}for(var b=l.getCollisionPairs(this),w=this.disabledBodyCollisionPairs,T=w.length-2;T>=0;T-=2)for(S=b.length-2;S>=0;S-=2)(w[T]===b[S]&&w[T+1]===b[S+1]||w[T+1]===b[S]&&w[T]===b[S+1])&&b.splice(S,2);H=u.length;for(T=0;T!==H;T++){var C=u[T];if(!C.collideConnected)for(var S=b.length-2;S>=0;S-=2)(C.bodyA===b[S]&&C.bodyB===b[S+1]||C.bodyB===b[S]&&C.bodyA===b[S+1])&&b.splice(S,2)}this.postBroadphaseEvent.pairs=b,this.emit(this.postBroadphaseEvent),this.postBroadphaseEvent.pairs=null,c.reset(this);for(var T=0,A=b.length;T!==A;T+=2)for(var E=b[T],M=b[T+1],R=0,L=E.shapes.length;R!==L;R++)for(var B=E.shapes[R],I=B.position,O=B.angle,k=0,F=M.shapes.length;k!==F;k++){var D=M.shapes[k],U=D.position,G=D.angle,N=this.defaultContactMaterial;if(B.material&&D.material){var X=this.getContactMaterial(B.material,D.material);X&&(N=X)}this.runNarrowphase(c,E,B,I,O,M,D,U,G,N,this.frictionGravity)}for(T=0;T!==h;T++)(q=n[T])._wakeUpAfterNarrowphase&&(q.wakeUp(),q._wakeUpAfterNarrowphase=!1);if(this.has("endContact")){this.overlapKeeper.getEndOverlaps(P);for(var W=this.endContactEvent,k=P.length;k--;){var j=P[k];W.shapeA=j.shapeA,W.shapeB=j.shapeB,W.bodyA=j.bodyA,W.bodyB=j.bodyB,this.emit(W)}P.length=0}var V=this.preSolveEvent;V.contactEquations=c.contactEquations,V.frictionEquations=c.frictionEquations,this.emit(V),V.contactEquations=V.frictionEquations=null;var H=u.length;for(T=0;T!==H;T++)u[T].update();if(c.contactEquations.length||c.frictionEquations.length||H)if(this.islandSplit){for(g.equations.length=0,v.appendArray(g.equations,c.contactEquations),v.appendArray(g.equations,c.frictionEquations),T=0;T!==H;T++)v.appendArray(g.equations,u[T].equations);g.split(this);for(T=0;T!==g.islands.length;T++)(K=g.islands[T]).equations.length&&a.solveIsland(t,K)}else{for(a.addEquations(c.contactEquations),a.addEquations(c.frictionEquations),T=0;T!==H;T++)a.addEquations(u[T].equations);this.solveConstraints&&a.solve(t,this),a.removeAllEquations()}for(T=0;T!==h;T++){var q=n[T];q.integrate(t)}for(T=0;T!==h;T++)n[T].setZeroForce();if(this.emitImpactEvent&&this.has("impact"))for(var Y=this.impactEvent,T=0;T!==c.contactEquations.length;T++){var z=c.contactEquations[T];z.firstImpact&&(Y.bodyA=z.bodyA,Y.bodyB=z.bodyB,Y.shapeA=z.shapeA,Y.shapeB=z.shapeB,Y.contactEquation=z,this.emit(Y))}if(this.sleepMode===s.BODY_SLEEPING)for(T=0;T!==h;T++)n[T].sleepTick(this.time,!1,t);else if(this.sleepMode===s.ISLAND_SLEEPING&&this.islandSplit){for(T=0;T!==h;T++)n[T].sleepTick(this.time,!0,t);for(T=0;T<this.islandManager.islands.length;T++){var K=this.islandManager.islands[T];K.wantsToSleep()&&K.sleep()}}this.stepping=!1;for(var J=this.bodiesToBeRemoved,T=0;T!==J.length;T++)this.removeBody(J[T]);J.length=0,this.emit(this.postStepEvent)},s.prototype.runNarrowphase=function(t,e,i,s,n,o,a,h,l,c,u){if(0!=(i.collisionGroup&a.collisionMask)&&0!=(a.collisionGroup&i.collisionMask)){r.rotate(w,s,e.angle),r.rotate(T,h,o.angle),r.add(w,w,e.position),r.add(T,T,o.position);var p=n+e.angle,f=l+o.angle;t.enableFriction=c.friction>0,t.frictionCoefficient=c.friction;var g;g=e.type===d.STATIC||e.type===d.KINEMATIC?o.mass:o.type===d.STATIC||o.type===d.KINEMATIC?e.mass:e.mass*o.mass/(e.mass+o.mass),t.slipForce=c.friction*u*g,t.restitution=c.restitution,t.surfaceVelocity=c.surfaceVelocity,t.frictionStiffness=c.frictionStiffness,t.frictionRelaxation=c.frictionRelaxation,t.stiffness=c.stiffness,t.relaxation=c.relaxation,t.contactSkinSize=c.contactSkinSize,t.enabledEquations=e.collisionResponse&&o.collisionResponse&&i.collisionResponse&&a.collisionResponse;var m=t[i.type|a.type],y=0;if(m){var v=i.sensor||a.sensor,x=t.frictionEquations.length;y=i.type<a.type?m.call(t,e,i,w,p,o,a,T,f,v):m.call(t,o,a,T,f,e,i,w,p,v);var b=t.frictionEquations.length-x;if(y){if(e.allowSleep&&e.type===d.DYNAMIC&&e.sleepState===d.SLEEPING&&o.sleepState===d.AWAKE&&o.type!==d.STATIC&&r.squaredLength(o.velocity)+Math.pow(o.angularVelocity,2)>=2*Math.pow(o.sleepSpeedLimit,2)&&(e._wakeUpAfterNarrowphase=!0),o.allowSleep&&o.type===d.DYNAMIC&&o.sleepState===d.SLEEPING&&e.sleepState===d.AWAKE&&e.type!==d.STATIC&&r.squaredLength(e.velocity)+Math.pow(e.angularVelocity,2)>=2*Math.pow(e.sleepSpeedLimit,2)&&(o._wakeUpAfterNarrowphase=!0),this.overlapKeeper.setOverlapping(e,i,o,a),this.has("beginContact")&&this.overlapKeeper.isNewOverlap(i,a)){var _=this.beginContactEvent;if(_.shapeA=i,_.shapeB=a,_.bodyA=e,_.bodyB=o,_.contactEquations.length=0,"number"==typeof y)for(P=t.contactEquations.length-y;P<t.contactEquations.length;P++)_.contactEquations.push(t.contactEquations[P]);this.emit(_)}if("number"==typeof y&&b>1)for(var P=t.frictionEquations.length-b;P<t.frictionEquations.length;P++){var C=t.frictionEquations[P];C.setSlipForce(C.getSlipForce()/b)}}}}},s.prototype.addSpring=function(t){this.springs.push(t);var e=this.addSpringEvent;e.spring=t,this.emit(e),e.spring=null},s.prototype.removeSpring=function(t){var e=this.springs.indexOf(t);-1!==e&&v.splice(this.springs,e,1)},s.prototype.addBody=function(t){if(-1===this.bodies.indexOf(t)){this.bodies.push(t),t.world=this;var e=this.addBodyEvent;e.body=t,this.emit(e),e.body=null}},s.prototype.removeBody=function(t){if(this.stepping)this.bodiesToBeRemoved.push(t);else{t.world=null;var e=this.bodies.indexOf(t);-1!==e&&(v.splice(this.bodies,e,1),this.removeBodyEvent.body=t,t.resetConstraintVelocity(),this.emit(this.removeBodyEvent),this.removeBodyEvent.body=null)}},s.prototype.getBodyById=function(t){for(var e=this.bodies,i=0;i<e.length;i++){var s=e[i];if(s.id===t)return s}return!1},s.prototype.disableBodyCollision=function(t,e){this.disabledBodyCollisionPairs.push(t,e)},s.prototype.enableBodyCollision=function(t,e){for(var i=this.disabledBodyCollisionPairs,s=0;s<i.length;s+=2)if(i[s]===t&&i[s+1]===e||i[s+1]===t&&i[s]===e)return void i.splice(s,2)},s.prototype.clear=function(){this.time=0,this.solver&&this.solver.equations.length&&this.solver.removeAllEquations();for(var t=this.constraints,e=t.length-1;e>=0;e--)this.removeConstraint(t[e]);for(var i=this.bodies,e=i.length-1;e>=0;e--)this.removeBody(i[e]);for(var n=this.springs,e=n.length-1;e>=0;e--)this.removeSpring(n[e]);for(var r=this.contactMaterials,e=r.length-1;e>=0;e--)this.removeContactMaterial(r[e]);s.apply(this)};var C=r.create(),S=(r.fromValues(0,0),r.fromValues(0,0));s.prototype.hitTest=function(t,e,i){i=i||0;var s=new d({position:t}),n=new c,u=t,p=C,f=S;s.addShape(n);for(var g=this.narrowphase,m=[],y=0,v=e.length;y!==v;y++)for(var x=e[y],b=0,_=x.shapes.length;b!==_;b++){var w=x.shapes[b];r.rotate(p,w.position,x.angle),r.add(p,p,x.position);var T=w.angle+x.angle;(w instanceof o&&g.circleParticle(x,w,p,T,s,n,u,0,!0)||w instanceof a&&g.particleConvex(s,n,u,0,x,w,p,T,!0)||w instanceof h&&g.particlePlane(s,n,u,0,x,w,p,T,!0)||w instanceof l&&g.particleCapsule(s,n,u,0,x,w,p,T,!0)||w instanceof c&&r.squaredLength(r.sub(f,p,t))<i*i)&&m.push(x)}return m},s.prototype.setGlobalStiffness=function(t){for(var e=this.constraints,i=0;i!==e.length;i++)for(var s=e[i],n=0;n!==s.equations.length;n++){var r=s.equations[n];r.stiffness=t,r.needsUpdate=!0}for(var o=this.contactMaterials,i=0;i!==o.length;i++)(s=o[i]).stiffness=s.frictionStiffness=t;(s=this.defaultContactMaterial).stiffness=s.frictionStiffness=t},s.prototype.setGlobalRelaxation=function(t){for(n=0;n!==this.constraints.length;n++)for(var e=this.constraints[n],i=0;i!==e.equations.length;i++){var s=e.equations[i];s.relaxation=t,s.needsUpdate=!0}for(var n=0;n!==this.contactMaterials.length;n++)(e=this.contactMaterials[n]).relaxation=e.frictionRelaxation=t;(e=this.defaultContactMaterial).relaxation=e.frictionRelaxation=t};var A=new g,E=[];s.prototype.raycast=function(t,e){return e.getAABB(A),this.broadphase.aabbQuery(this,A,E),e.intersectBodies(t,E),E.length=0,t.hasHit()}},{"../../package.json":6,"../collision/AABB":7,"../collision/Broadphase":8,"../collision/Narrowphase":10,"../collision/Ray":11,"../collision/SAPBroadphase":13,"../constraints/Constraint":14,"../constraints/DistanceConstraint":15,"../constraints/GearConstraint":16,"../constraints/LockConstraint":17,"../constraints/PrismaticConstraint":18,"../constraints/RevoluteConstraint":19,"../events/EventEmitter":26,"../material/ContactMaterial":27,"../material/Material":28,"../math/vec2":30,"../objects/Body":31,"../objects/LinearSpring":32,"../objects/RotationalSpring":33,"../shapes/Capsule":38,"../shapes/Circle":39,"../shapes/Convex":40,"../shapes/Line":42,"../shapes/Particle":43,"../shapes/Plane":44,"../shapes/Shape":45,"../solver/GSSolver":46,"../solver/Solver":47,"../utils/OverlapKeeper":52,"../utils/Utils":57,"./IslandManager":59}]},{},[36])(36)}),function(){function t(t,e,i,n){var r=t.createTexture();return t.bindTexture(t.TEXTURE_2D,r),t.texParameteri(t.TEXTURE_2D,t.TEXTURE_WRAP_S,t.CLAMP_TO_EDGE),t.texParameteri(t.TEXTURE_2D,t.TEXTURE_WRAP_T,t.CLAMP_TO_EDGE),t.texParameteri(t.TEXTURE_2D,t.TEXTURE_MAG_FILTER,n===s.scaleModes.LINEAR?t.LINEAR:t.NEAREST),t.texParameteri(t.TEXTURE_2D,t.TEXTURE_MIN_FILTER,n===s.scaleModes.LINEAR?t.LINEAR:t.NEAREST),t.texImage2D(t.TEXTURE_2D,0,t.RGBA,e,i,0,t.RGBA,t.UNSIGNED_BYTE,null),r}function e(e,i,s,r,o){var a=e.createFramebuffer(),h=e.createRenderbuffer(),l=null,c=0;return e.activeTexture(e.TEXTURE0+o),e.bindFramebuffer(e.FRAMEBUFFER,a),e.bindRenderbuffer(e.RENDERBUFFER,h),e.framebufferRenderbuffer(e.FRAMEBUFFER,e.DEPTH_STENCIL_ATTACHMENT,e.RENDERBUFFER,this.renderBuffer),l=t(e,i,s,r),e.framebufferTexture2D(e.FRAMEBUFFER,e.COLOR_ATTACHMENT0,e.TEXTURE_2D,l,0),(c=e.checkFramebufferStatus(e.FRAMEBUFFER))!==e.FRAMEBUFFER_COMPLETE&&console.error("Incomplete GL framebuffer. ",n[c]),a.width=i,a.height=s,a.targetTexture=l,a.renderBuffer=h,a}var i=this,s=s||{};s.DisplayObject=function(){this.position=new s.Point(0,0),this.scale=new s.Point(1,1),this.pivot=new s.Point(0,0),this.rotation=0,this.alpha=1,this.visible=!0,this.hitArea=null,this.renderable=!1,this.parent=null,this.worldAlpha=1,this.worldTransform=new Phaser.Matrix,this.worldPosition=new s.Point(0,0),this.worldScale=new s.Point(1,1),this.worldRotation=0,this.filterArea=null,this._sr=0,this._cr=1,this._bounds=new s.Rectangle(0,0,0,0),this._currentBounds=null,this._mask=null,this._cacheAsBitmap=!1,this._cacheIsDirty=!1},s.DisplayObject.prototype={constructor:s.DisplayObject,destroy:function(){if(this.children){for(var t=this.children.length;t--;)this.children[t].destroy();this.children=[]}this.hitArea=null,this.parent=null,this.worldTransform=null,this.filterArea=null,this.renderable=!1,this._bounds=null,this._currentBounds=null,this._mask=null,this._destroyCachedSprite()},updateTransform:function(t){if(!t&&!this.parent&&!this.game)return this;var e=this.parent;t?e=t:this.parent||(e=this.game.world);var i,s,n,r,o,a,h=e.worldTransform,l=this.worldTransform;this.rotation%Phaser.Math.PI2?(this.rotation!==this.rotationCache&&(this.rotationCache=this.rotation,this._sr=Math.sin(this.rotation),this._cr=Math.cos(this.rotation)),i=this._cr*this.scale.x,s=this._sr*this.scale.x,n=-this._sr*this.scale.y,r=this._cr*this.scale.y,o=this.position.x,a=this.position.y,(this.pivot.x||this.pivot.y)&&(o-=this.pivot.x*i+this.pivot.y*n,a-=this.pivot.x*s+this.pivot.y*r),l.a=i*h.a+s*h.c,l.b=i*h.b+s*h.d,l.c=n*h.a+r*h.c,l.d=n*h.b+r*h.d,l.tx=o*h.a+a*h.c+h.tx,l.ty=o*h.b+a*h.d+h.ty):(i=this.scale.x,s=0,n=0,r=this.scale.y,o=this.position.x-this.pivot.x*i,a=this.position.y-this.pivot.y*r,l.a=i*h.a,l.b=i*h.b,l.c=r*h.c,l.d=r*h.d,l.tx=o*h.a+a*h.c+h.tx,l.ty=o*h.b+a*h.d+h.ty),i=l.a,s=l.b,n=l.c;var c=i*(r=l.d)-s*n;if(i||s){var u=Math.sqrt(i*i+s*s);this.worldRotation=s>0?Math.acos(i/u):-Math.acos(i/u),this.worldScale.x=u,this.worldScale.y=c/u}else if(n||r){var d=Math.sqrt(n*n+r*r);this.worldRotation=Phaser.Math.HALF_PI-(r>0?Math.acos(-n/d):-Math.acos(n/d)),this.worldScale.x=c/d,this.worldScale.y=d}else this.worldScale.x=0,this.worldScale.y=0;return this.worldAlpha=this.alpha*e.worldAlpha,this.worldPosition.x=l.tx,this.worldPosition.y=l.ty,this._currentBounds=null,this.transformCallback&&this.transformCallback.call(this.transformCallbackContext,l,h),this},preUpdate:function(){},generateTexture:function(t,e,i){var n=this.getLocalBounds(),r=new Phaser.RenderTexture(this.game,0|n.width,0|n.height,i,e,t);return s.DisplayObject._tempMatrix.tx=-n.x,s.DisplayObject._tempMatrix.ty=-n.y,r.render(this,s.DisplayObject._tempMatrix),r},updateCache:function(){return this._generateCachedSprite(),this},toGlobal:function(t){return this.updateTransform(),this.worldTransform.apply(t)},toLocal:function(t,e){return e&&(t=e.toGlobal(t)),this.updateTransform(),this.worldTransform.applyInverse(t)},_renderCachedSprite:function(t){this._cachedSprite.worldAlpha=this.worldAlpha,t.gl?s.Sprite.prototype._renderWebGL.call(this._cachedSprite,t):s.Sprite.prototype._renderCanvas.call(this._cachedSprite,t)},_generateCachedSprite:function(){this._cacheAsBitmap=!1;var t=this.getLocalBounds();if(t.width=Math.max(1,Math.ceil(t.width)),t.height=Math.max(1,Math.ceil(t.height)),this.updateTransform(),this._cachedSprite)this._cachedSprite.texture.resize(t.width,t.height);else{var e=0;this.texture&&this.texture.baseTexture&&s._enableMultiTextureToggle&&(e=this.texture.baseTexture.textureIndex);var i=new Phaser.RenderTexture(this.game,t.width,t.height,void 0,void 0,void 0,void 0,e);this._cachedSprite=new s.Sprite(i),this._cachedSprite.worldTransform=this.worldTransform}var n=this._filters;this._filters=null,this._cachedSprite.filters=n,s.DisplayObject._tempMatrix.tx=-t.x,s.DisplayObject._tempMatrix.ty=-t.y,this._cachedSprite.texture.render(this,s.DisplayObject._tempMatrix,!0),this._cachedSprite.anchor.x=-t.x/t.width,this._cachedSprite.anchor.y=-t.y/t.height,this._filters=n,this._cacheAsBitmap=!0},_destroyCachedSprite:function(){this._cachedSprite&&(this._cachedSprite.texture.destroy(!0),this._cachedSprite=null)}},s.DisplayObject.prototype.displayObjectUpdateTransform=s.DisplayObject.prototype.updateTransform,Object.defineProperties(s.DisplayObject.prototype,{x:{get:function(){return this.position.x},set:function(t){this.position.x=t}},y:{get:function(){return this.position.y},set:function(t){this.position.y=t}},worldVisible:{get:function(){if(this.visible){var t=this.parent;if(!t)return this.visible;do{if(!t.visible)return!1;t=t.parent}while(t);return!0}return!1}},mask:{get:function(){return this._mask},set:function(t){this._mask&&(this._mask.isMask=!1),this._mask=t,t&&(this._mask.isMask=!0)}},filters:{get:function(){return this._filters},set:function(t){if(Array.isArray(t)){for(var e=[],i=0;i<t.length;i++)for(var n=t[i].passes,r=0;r<n.length;r++)e.push(n[r]);this._filterBlock={target:this,filterPasses:e}}this._filters=t,this.blendMode&&this.blendMode===s.blendModes.MULTIPLY&&(this.blendMode=s.blendModes.NORMAL)}},cacheAsBitmap:{get:function(){return this._cacheAsBitmap},set:function(t){this._cacheAsBitmap!==t&&(t?this._generateCachedSprite():this._destroyCachedSprite(),this._cacheAsBitmap=t)}}}),s.DisplayObjectContainer=function(){s.DisplayObject.call(this),this.children=[],this.ignoreChildInput=!1},s.DisplayObjectContainer.prototype=Object.create(s.DisplayObject.prototype),s.DisplayObjectContainer.prototype.constructor=s.DisplayObjectContainer,s.DisplayObjectContainer.prototype.addChild=function(t){return this.addChildAt(t,this.children.length)},s.DisplayObjectContainer.prototype.addChildAt=function(t,e){if(e>=0&&e<=this.children.length)return t.parent&&t.parent.removeChild(t),t.parent=this,this.children.splice(e,0,t),t;throw new Error(t+"addChildAt: The index "+e+" supplied is out of bounds "+this.children.length)},s.DisplayObjectContainer.prototype.swapChildren=function(t,e){if(t!==e){var i=this.getChildIndex(t),s=this.getChildIndex(e);if(i<0||s<0)throw new Error("swapChildren: Both the supplied DisplayObjects must be a child of the caller.");this.children[i]=e,this.children[s]=t}},s.DisplayObjectContainer.prototype.getChildIndex=function(t){var e=this.children.indexOf(t);if(-1===e)throw new Error("The supplied DisplayObject must be a child of the caller");return e},s.DisplayObjectContainer.prototype.setChildIndex=function(t,e){if(e<0||e>=this.children.length)throw new Error("The supplied index is out of bounds");var i=this.getChildIndex(t);this.children.splice(i,1),this.children.splice(e,0,t)},s.DisplayObjectContainer.prototype.getChildAt=function(t){if(t<0||t>=this.children.length)throw new Error("getChildAt: Supplied index "+t+" does not exist in the child list, or the supplied DisplayObject must be a child of the caller");return this.children[t]},s.DisplayObjectContainer.prototype.removeChild=function(t){var e=this.children.indexOf(t);if(-1!==e)return this.removeChildAt(e)},s.DisplayObjectContainer.prototype.removeChildAt=function(t){var e=this.getChildAt(t);return e&&(e.parent=void 0,this.children.splice(t,1)),e},s.DisplayObjectContainer.prototype.bringChildToTop=function(t){if(t.parent===this)return this.setChildIndex(t,this.children.length-1)},s.DisplayObjectContainer.prototype.sendChildToBack=function(t){if(t.parent===this)return this.setChildIndex(t,0)},s.DisplayObjectContainer.prototype.removeChildren=function(t,e){void 0===t&&(t=0),void 0===e&&(e=this.children.length);var i=e-t;if(i>0&&i<=e){for(var s=this.children.splice(t,i),n=0;n<s.length;n++)s[n].parent=void 0;return s}if(0===i&&0===this.children.length)return[];throw new Error("removeChildren: Range Error, numeric values are outside the acceptable range")},s.DisplayObjectContainer.prototype.updateTransform=function(){if(this.visible&&(this.displayObjectUpdateTransform(),!this._cacheAsBitmap))for(var t=0;t<this.children.length;t++)this.children[t].updateTransform()},s.DisplayObjectContainer.prototype.displayObjectContainerUpdateTransform=s.DisplayObjectContainer.prototype.updateTransform,s.DisplayObjectContainer.prototype.getBounds=function(t){var e=t&&t instanceof s.DisplayObject,i=!0;e?i=t instanceof s.DisplayObjectContainer&&t.contains(this):t=this;var n;if(e){var r=t.worldTransform;for(t.worldTransform=Phaser.identityMatrix,n=0;n<t.children.length;n++)t.children[n].updateTransform()}var o,a,h,l=1/0,c=1/0,u=-1/0,d=-1/0,p=!1;for(n=0;n<this.children.length;n++)this.children[n].visible&&(p=!0,l=l<(o=this.children[n].getBounds()).x?l:o.x,c=c<o.y?c:o.y,a=o.width+o.x,h=o.height+o.y,u=u>a?u:a,d=d>h?d:h);var f=this._bounds;if(!p){var g=(f=new s.Rectangle).x,m=f.width+f.x,y=f.y,v=f.height+f.y,x=this.worldTransform,b=x.a,_=x.b,w=x.c,T=x.d,P=x.tx,C=x.ty,S=b*m+w*v+P,A=T*v+_*m+C,E=b*g+w*v+P,M=T*v+_*g+C,R=b*g+w*y+P,L=T*y+_*g+C,B=b*m+w*y+P,I=T*y+_*m+C;u=S,d=A,c=A,l=B<(l=R<(l=E<(l=S)?E:l)?R:l)?B:l,c=I<(c=L<(c=M<c?M:c)?L:c)?I:c,u=B>(u=R>(u=E>u?E:u)?R:u)?B:u,d=I>(d=L>(d=M>d?M:d)?L:d)?I:d}if(f.x=l,f.y=c,f.width=u-l,f.height=d-c,e)for(t.worldTransform=r,n=0;n<t.children.length;n++)t.children[n].updateTransform();if(!i){var O=t.getBounds();f.x-=O.x,f.y-=O.y}return f},s.DisplayObjectContainer.prototype.getLocalBounds=function(){return this.getBounds(this)},s.DisplayObjectContainer.prototype.contains=function(t){return!!t&&(t===this||this.contains(t.parent))},s.DisplayObjectContainer.prototype._renderWebGL=function(t){if(this.visible&&!(this.alpha<=0))if(this._cacheAsBitmap)this._renderCachedSprite(t);else{var e;if(this._mask||this._filters){for(this._filters&&(t.spriteBatch.flush(),t.filterManager.pushFilter(this._filterBlock)),this._mask&&(t.spriteBatch.stop(),t.maskManager.pushMask(this.mask,t),t.spriteBatch.start()),e=0;e<this.children.length;e++)this.children[e]._renderWebGL(t);t.spriteBatch.stop(),this._mask&&t.maskManager.popMask(this._mask,t),this._filters&&t.filterManager.popFilter(),t.spriteBatch.start()}else for(e=0;e<this.children.length;e++)this.children[e]._renderWebGL(t)}},s.DisplayObjectContainer.prototype._renderCanvas=function(t){if(!1!==this.visible&&0!==this.alpha)if(this._cacheAsBitmap)this._renderCachedSprite(t);else{this._mask&&t.maskManager.pushMask(this._mask,t);for(var e=0;e<this.children.length;e++)this.children[e]._renderCanvas(t);this._mask&&t.maskManager.popMask(t)}},Object.defineProperty(s.DisplayObjectContainer.prototype,"width",{get:function(){return this.getLocalBounds().width*this.scale.x},set:function(t){var e=this.getLocalBounds().width;this.scale.x=0!==e?t/e:1,this._width=t}}),Object.defineProperty(s.DisplayObjectContainer.prototype,"height",{get:function(){return this.getLocalBounds().height*this.scale.y},set:function(t){var e=this.getLocalBounds().height;this.scale.y=0!==e?t/e:1,this._height=t}}),s.Sprite=function(t){s.DisplayObjectContainer.call(this),this.anchor=new s.Point(s.Sprite.defaultAnchor.x,s.Sprite.defaultAnchor.y),this.texture=t||s.Texture.emptyTexture,this._width=0,this._height=0,this.tint=16777215,this.cachedTint=-1,this.tintedTexture=null,this.blendMode=s.blendModes.NORMAL,this.shader=null,this.exists=!0,this.texture.baseTexture.hasLoaded&&this.onTextureUpdate(),this.renderable=!0},s.Sprite.defaultAnchor={x:0,y:0},s.Sprite.prototype=Object.create(s.DisplayObjectContainer.prototype),s.Sprite.prototype.constructor=s.Sprite,Object.defineProperty(s.Sprite.prototype,"width",{get:function(){return this.scale.x*this.texture.frame.width},set:function(t){this.scale.x=t/this.texture.frame.width,this._width=t}}),Object.defineProperty(s.Sprite.prototype,"height",{get:function(){return this.scale.y*this.texture.frame.height},set:function(t){this.scale.y=t/this.texture.frame.height,this._height=t}}),s.Sprite.prototype.setTexture=function(t,e){e&&this.texture.baseTexture.destroy(),this.texture.baseTexture.skipRender=!1,this.texture=t,this.texture.valid=!0,this.cachedTint=-1},s.Sprite.prototype.onTextureUpdate=function(){this._width&&(this.scale.x=this._width/this.texture.frame.width),this._height&&(this.scale.y=this._height/this.texture.frame.height)},s.Sprite.prototype.getBounds=function(t){var e=this.texture.frame.width,i=this.texture.frame.height,s=e*(1-this.anchor.x),n=e*-this.anchor.x,r=i*(1-this.anchor.y),o=i*-this.anchor.y,a=t||this.worldTransform,h=a.a,l=a.b,c=a.c,u=a.d,d=a.tx,p=a.ty,f=-1/0,g=-1/0,m=1/0,y=1/0;if(0===l&&0===c){if(h<0){h*=-1;v=s;s=-n,n=-v}if(u<0){u*=-1;var v=r;r=-o,o=-v}m=h*n+d,f=h*s+d,y=u*o+p,g=u*r+p}else{var x=h*n+c*o+d,b=u*o+l*n+p,_=h*s+c*o+d,w=u*o+l*s+p,T=h*s+c*r+d,P=u*r+l*s+p,C=h*n+c*r+d,S=u*r+l*n+p;m=C<(m=T<(m=_<(m=x<m?x:m)?_:m)?T:m)?C:m,y=S<(y=P<(y=w<(y=b<y?b:y)?w:y)?P:y)?S:y,f=C>(f=T>(f=_>(f=x>f?x:f)?_:f)?T:f)?C:f,g=S>(g=P>(g=w>(g=b>g?b:g)?w:g)?P:g)?S:g}var A=this._bounds;return A.x=m,A.width=f-m,A.y=y,A.height=g-y,this._currentBounds=A,A},s.Sprite.prototype.getLocalBounds=function(){var t=this.worldTransform;this.worldTransform=Phaser.identityMatrix;for(var e=0;e<this.children.length;e++)this.children[e].updateTransform();var i=this.getBounds();for(this.worldTransform=t,e=0;e<this.children.length;e++)this.children[e].updateTransform();return i},s.Sprite.prototype._renderWebGL=function(t,e){if(this.visible&&!(this.alpha<=0)&&this.renderable){var i=this.worldTransform;if(e&&(i=e),this._mask||this._filters){var s=t.spriteBatch;this._filters&&(s.flush(),t.filterManager.pushFilter(this._filterBlock)),this._mask&&(s.stop(),t.maskManager.pushMask(this.mask,t),s.start()),s.render(this);for(n=0;n<this.children.length;n++)this.children[n]._renderWebGL(t);s.stop(),this._mask&&t.maskManager.popMask(this._mask,t),this._filters&&t.filterManager.popFilter(),s.start()}else{t.spriteBatch.render(this);for(var n=0;n<this.children.length;n++)this.children[n]._renderWebGL(t,i)}}},s.Sprite.prototype._renderCanvas=function(t,e){if(!(!this.visible||0===this.alpha||!this.renderable||this.texture.crop.width<1||this.texture.crop.height<1)){var i=this.worldTransform;if(e&&(i=e),this.blendMode!==t.currentBlendMode&&(t.currentBlendMode=this.blendMode,t.context.globalCompositeOperation=s.blendModesCanvas[t.currentBlendMode]),this._mask&&t.maskManager.pushMask(this._mask,t),this.texture.valid){var n=this.texture.baseTexture.resolution/t.resolution;t.context.globalAlpha=this.worldAlpha,t.smoothProperty&&t.scaleMode!==this.texture.baseTexture.scaleMode&&(t.scaleMode=this.texture.baseTexture.scaleMode,t.context[t.smoothProperty]=t.scaleMode===s.scaleModes.LINEAR);var r=this.texture.trim?this.texture.trim.x-this.anchor.x*this.texture.trim.width:this.anchor.x*-this.texture.frame.width,o=this.texture.trim?this.texture.trim.y-this.anchor.y*this.texture.trim.height:this.anchor.y*-this.texture.frame.height,a=i.tx*t.resolution+t.shakeX,h=i.ty*t.resolution+t.shakeY,l=this.texture.crop.width,c=this.texture.crop.height;if(this.texture.rotated){var u=i.a,d=i.b,p=i.c,f=i.d,g=l;a=i.c*c+a,h=i.d*c+h,i.a=6.123233995736766e-17*u-p,i.b=6.123233995736766e-17*d-f,i.c=u+6.123233995736766e-17*p,i.d=d+6.123233995736766e-17*f,l=c,c=g}if(t.roundPixels?(t.context.setTransform(i.a,i.b,i.c,i.d,0|a,0|h),r|=0,o|=0):t.context.setTransform(i.a,i.b,i.c,i.d,a,h),r/=n,o/=n,l|=0,c|=0,l&&c){if(16777215!==this.tint)(this.texture.requiresReTint||this.cachedTint!==this.tint)&&(this.tintedTexture=s.CanvasTinter.getTintedTexture(this,this.tint),this.cachedTint=this.tint,this.texture.requiresReTint=!1),t.context.drawImage(this.tintedTexture,0,0,l,c,r,o,l/n,c/n);else{var m=this.texture.crop.x,y=this.texture.crop.y;t.context.drawImage(this.texture.baseTexture.source,m,y,l,c,r,o,l/n,c/n)}for(v=0;v<this.children.length;v++)this.children[v]._renderCanvas(t);this._mask&&t.maskManager.popMask(t)}}else{for(var v=0;v<this.children.length;v++)this.children[v]._renderCanvas(t);this._mask&&t.maskManager.popMask(t)}}},s.initDefaultShaders=function(){},s.CompileVertexShader=function(t,e){return s._CompileShader(t,e,t.VERTEX_SHADER)},s.CompileFragmentShader=function(t,e){return s._CompileShader(t,e,t.FRAGMENT_SHADER)},s._CompileShader=function(t,e,i){var s=e;Array.isArray(e)&&(s=e.join("\n"));var n=t.createShader(i);return t.shaderSource(n,s),t.compileShader(n),t.getShaderParameter(n,t.COMPILE_STATUS)?n:(window.console.log(t.getShaderInfoLog(n)),null)},s.compileProgram=function(t,e,i){var n=s.CompileFragmentShader(t,i),r=s.CompileVertexShader(t,e),o=t.createProgram();return t.attachShader(o,r),t.attachShader(o,n),t.linkProgram(o),t.getProgramParameter(o,t.LINK_STATUS)||(window.console.log(t.getProgramInfoLog(o)),window.console.log("Could not initialise shaders")),o},s.PixiShader=function(t){this._UID=Phaser._UID++,this.gl=t,this.program=null,this.fragmentSrc=null,this.textureCount=0,this.firstRun=!0,this.dirty=!0,this.attributes=[],this.init()},s.PixiShader.prototype.constructor=s.PixiShader,s.PixiShader.prototype.initMultitexShader=function(){var t=this.gl;this.MAX_TEXTURES=t.getParameter(t.MAX_TEXTURE_IMAGE_UNITS);for(var e="\tif (vTextureIndex == 0.0) { gl_FragColor = texture2D(uSamplerArray[0], vTextureCoord) * vColor;return;}\n",i=1;i<this.MAX_TEXTURES;++i)e+="\tif (vTextureIndex == "+i+".0) {gl_FragColor = texture2D(uSamplerArray["+i+"], vTextureCoord) * vColor;return;}\n";this.fragmentSrc=["// PixiShader Fragment Shader.","precision lowp float;","bool isnan( float val ) {  return ( val < 0.0 || 0.0 < val || val == 0.0 ) ? false : true; }","varying vec2 vTextureCoord;","varying vec4 vColor;","varying float vTextureIndex;","uniform sampler2D uSamplerArray["+this.MAX_TEXTURES+"];","const vec4 BLUE = vec4(1.0, 0.0, 1.0, 1.0);","const vec4 RED = vec4(1.0, 0.0, 0.0, 1.0);","void main(void) {",e,"   if(vTextureIndex >= "+this.MAX_TEXTURES+".0) { gl_FragColor = BLUE;return;}","   if(isnan(vTextureIndex)) { gl_FragColor = RED;return;}","}"];var n=s.compileProgram(t,this.vertexSrc||s.PixiShader.defaultVertexSrc,this.fragmentSrc);t.useProgram(n),this.uSamplerArray=t.getUniformLocation(n,"uSamplerArray[0]"),this.projectionVector=t.getUniformLocation(n,"projectionVector"),this.offsetVector=t.getUniformLocation(n,"offsetVector"),this.dimensions=t.getUniformLocation(n,"dimensions"),this.aVertexPosition=t.getAttribLocation(n,"aVertexPosition"),this.aTextureCoord=t.getAttribLocation(n,"aTextureCoord"),this.colorAttribute=t.getAttribLocation(n,"aColor"),this.aTextureIndex=t.getAttribLocation(n,"aTextureIndex");var r=[],o=t.createTexture();t.activeTexture(t.TEXTURE0),t.bindTexture(t.TEXTURE_2D,o),t.texImage2D(t.TEXTURE_2D,0,t.RGB,1,1,0,t.RGB,t.UNSIGNED_BYTE,null);for(var a=0;a<this.MAX_TEXTURES;++a)t.activeTexture(t.TEXTURE0+a),t.bindTexture(t.TEXTURE_2D,o),r.push(a);t.activeTexture(t.TEXTURE0),t.uniform1iv(this.uSamplerArray,r),-1===this.colorAttribute&&(this.colorAttribute=2),this.attributes=[this.aVertexPosition,this.aTextureCoord,this.colorAttribute,this.aTextureIndex];for(var h in this.uniforms)this.uniforms[h].uniformLocation=t.getUniformLocation(n,h);this.initUniforms(),this.program=n},s.PixiShader.prototype.initDefaultShader=function(){null===this.fragmentSrc&&(this.fragmentSrc=["precision lowp float;","varying vec2 vTextureCoord;","varying vec4 vColor;","varying float vTextureIndex;","uniform sampler2D uSampler;","void main(void) {","   gl_FragColor = texture2D(uSampler, vTextureCoord) * vColor ;","}"]);var t=this.gl,e=s.compileProgram(t,this.vertexSrc||s.PixiShader.defaultVertexSrc,this.fragmentSrc);t.useProgram(e),this.uSampler=t.getUniformLocation(e,"uSampler"),this.projectionVector=t.getUniformLocation(e,"projectionVector"),this.offsetVector=t.getUniformLocation(e,"offsetVector"),this.dimensions=t.getUniformLocation(e,"dimensions"),this.aVertexPosition=t.getAttribLocation(e,"aVertexPosition"),this.aTextureCoord=t.getAttribLocation(e,"aTextureCoord"),this.colorAttribute=t.getAttribLocation(e,"aColor"),this.aTextureIndex=t.getAttribLocation(e,"aTextureIndex"),-1===this.colorAttribute&&(this.colorAttribute=2),this.attributes=[this.aVertexPosition,this.aTextureCoord,this.colorAttribute,this.aTextureIndex];for(var i in this.uniforms)this.uniforms[i].uniformLocation=t.getUniformLocation(e,i);this.initUniforms(),this.program=e},s.PixiShader.prototype.init=function(t){s._enableMultiTextureToggle&&!t?this.initMultitexShader():this.initDefaultShader()},s.PixiShader.prototype.initUniforms=function(){this.textureCount=1;var t,e=this.gl;for(var i in this.uniforms){var s=(t=this.uniforms[i]).type;"sampler2D"===s?(t._init=!1,null!==t.value&&this.initSampler2D(t)):"mat2"===s||"mat3"===s||"mat4"===s?(t.glMatrix=!0,t.glValueLength=1,"mat2"===s?t.glFunc=e.uniformMatrix2fv:"mat3"===s?t.glFunc=e.uniformMatrix3fv:"mat4"===s&&(t.glFunc=e.uniformMatrix4fv)):(t.glFunc=e["uniform"+s],t.glValueLength="2f"===s||"2i"===s?2:"3f"===s||"3i"===s?3:"4f"===s||"4i"===s?4:1)}},s.PixiShader.prototype.initSampler2D=function(t){if(t.value&&t.value.baseTexture&&t.value.baseTexture.hasLoaded){var e=this.gl;if(e.activeTexture(e.TEXTURE0+this.textureCount),e.bindTexture(e.TEXTURE_2D,t.value.baseTexture._glTextures[e.id]),t.textureData){var i=t.textureData,s=i.magFilter?i.magFilter:e.LINEAR,n=i.minFilter?i.minFilter:e.LINEAR,r=i.wrapS?i.wrapS:e.CLAMP_TO_EDGE,o=i.wrapT?i.wrapT:e.CLAMP_TO_EDGE,a=i.luminance?e.LUMINANCE:e.RGBA;if(i.repeat&&(r=e.REPEAT,o=e.REPEAT),e.pixelStorei(e.UNPACK_FLIP_Y_WEBGL,!!i.flipY),i.width){var h=i.width?i.width:512,l=i.height?i.height:2,c=i.border?i.border:0;e.texImage2D(e.TEXTURE_2D,0,a,h,l,c,a,e.UNSIGNED_BYTE,null)}else e.texImage2D(e.TEXTURE_2D,0,a,e.RGBA,e.UNSIGNED_BYTE,t.value.baseTexture.source);e.texParameteri(e.TEXTURE_2D,e.TEXTURE_MAG_FILTER,s),e.texParameteri(e.TEXTURE_2D,e.TEXTURE_MIN_FILTER,n),e.texParameteri(e.TEXTURE_2D,e.TEXTURE_WRAP_S,r),e.texParameteri(e.TEXTURE_2D,e.TEXTURE_WRAP_T,o)}e.uniform1i(t.uniformLocation,this.textureCount),t._init=!0,this.textureCount++}},s.PixiShader.prototype.syncUniforms=function(){this.textureCount=1;var t,e=this.gl;for(var i in this.uniforms)1===(t=this.uniforms[i]).glValueLength?!0===t.glMatrix?t.glFunc.call(e,t.uniformLocation,t.transpose,t.value):t.glFunc.call(e,t.uniformLocation,t.value):2===t.glValueLength?t.glFunc.call(e,t.uniformLocation,t.value.x,t.value.y):3===t.glValueLength?t.glFunc.call(e,t.uniformLocation,t.value.x,t.value.y,t.value.z):4===t.glValueLength?t.glFunc.call(e,t.uniformLocation,t.value.x,t.value.y,t.value.z,t.value.w):"sampler2D"===t.type&&(t._init?(e.activeTexture(e["TEXTURE"+this.textureCount]),t.value.baseTexture._dirty[e.id]?s.instances[e.id].updateTexture(t.value.baseTexture):e.bindTexture(e.TEXTURE_2D,t.value.baseTexture._glTextures[e.id]),e.uniform1i(t.uniformLocation,this.textureCount),this.textureCount++):this.initSampler2D(t))},s.PixiShader.prototype.destroy=function(){this.gl.deleteProgram(this.program),this.uniforms=null,this.gl=null,this.attributes=null},s.PixiShader.defaultVertexSrc=["// PixiShader Vertex Shader","// With multi-texture rendering","attribute vec2 aVertexPosition;","attribute vec2 aTextureCoord;","attribute vec4 aColor;","attribute float aTextureIndex;","uniform vec2 projectionVector;","uniform vec2 offsetVector;","varying vec2 vTextureCoord;","varying vec4 vColor;","varying float vTextureIndex;","const vec2 center = vec2(-1.0, 1.0);","void main(void) {","   if (aTextureIndex > 0.0) gl_Position = vec4(0.0);","   gl_Position = vec4( ((aVertexPosition + offsetVector) / projectionVector) + center , 0.0, 1.0);","   vTextureCoord = aTextureCoord;","   vColor = vec4(aColor.rgb * aColor.a, aColor.a);","   vTextureIndex = aTextureIndex;","}"],s.PixiFastShader=function(t){if(this._UID=Phaser._UID++,this.gl=t,this.program=null,s._enableMultiTextureToggle){var t=this.gl;this.MAX_TEXTURES=t.getParameter(t.MAX_TEXTURE_IMAGE_UNITS);for(var e="\tif (vTextureIndex == 0.0) { gl_FragColor = texture2D(uSamplerArray[0], vTextureCoord) * vColor;return;}\n",i=1;i<this.MAX_TEXTURES;++i)e+="\tif (vTextureIndex == "+i+".0) { gl_FragColor = texture2D(uSamplerArray["+i+"], vTextureCoord) * vColor;return;}\n";this.fragmentSrc=["// PixiFastShader Fragment Shader.","precision lowp float;","bool isnan( float val ) {  return ( val < 0.0 || 0.0 < val || val == 0.0 ) ? false : true; }","varying vec2 vTextureCoord;","varying float vColor;","varying float vTextureIndex;","uniform sampler2D uSamplerArray["+this.MAX_TEXTURES+"];","const vec4 BLUE = vec4(1.0, 0.0, 1.0, 1.0);","const vec4 RED = vec4(1.0, 0.0, 0.0, 1.0);","void main(void) {",e,"   if(vTextureIndex >= "+this.MAX_TEXTURES+".0) { gl_FragColor = BLUE;return;}","   if(isnan(vTextureIndex)) {gl_FragColor = RED;return;}","}"]}else this.fragmentSrc=["// PixiFastShader Fragment Shader.","precision lowp float;","varying vec2 vTextureCoord;","varying float vColor;","varying float vTextureIndex;","uniform sampler2D uSampler;","void main(void) {","   gl_FragColor = texture2D(uSampler, vTextureCoord) * vColor;","}"];this.vertexSrc=["// PixiFastShader Vertex Shader.","attribute vec2 aVertexPosition;","attribute vec2 aPositionCoord;","attribute vec2 aScale;","attribute float aRotation;","attribute vec2 aTextureCoord;","attribute float aColor;","attribute float aTextureIndex;","uniform vec2 projectionVector;","uniform vec2 offsetVector;","uniform mat3 uMatrix;","varying vec2 vTextureCoord;","varying float vColor;","varying float vTextureIndex;","const vec2 center = vec2(-1.0, 1.0);","void main(void) {","   vec2 v;","   vec2 sv = aVertexPosition * aScale;","   v.x = (sv.x) * cos(aRotation) - (sv.y) * sin(aRotation);","   v.y = (sv.x) * sin(aRotation) + (sv.y) * cos(aRotation);","   v = ( uMatrix * vec3(v + aPositionCoord , 1.0) ).xy ;","   gl_Position = vec4( ( v / projectionVector) + center , 0.0, 1.0);","   vTextureCoord = aTextureCoord;","   vTextureIndex = aTextureIndex;","   vColor = aColor;","}"],this.textureCount=0,this.init()},s.PixiFastShader.prototype.constructor=s.PixiFastShader,s.PixiFastShader.prototype.init=function(){var t=this.gl,e=s.compileProgram(t,this.vertexSrc,this.fragmentSrc);if(t.useProgram(e),this.uSampler=s._enableMultiTextureToggle?t.getUniformLocation(e,"uSamplerArray[0]"):t.getUniformLocation(e,"uSampler"),s._enableMultiTextureToggle){var i=[],n=t.createTexture();t.activeTexture(t.TEXTURE0),t.bindTexture(t.TEXTURE_2D,n),t.texImage2D(t.TEXTURE_2D,0,t.RGB,1,1,0,t.RGB,t.UNSIGNED_BYTE,null);for(var r=0;r<this.MAX_TEXTURES;++r)t.activeTexture(t.TEXTURE0+r),t.bindTexture(t.TEXTURE_2D,n),i.push(r);t.activeTexture(t.TEXTURE0),t.uniform1iv(this.uSampler,i)}this.projectionVector=t.getUniformLocation(e,"projectionVector"),this.offsetVector=t.getUniformLocation(e,"offsetVector"),this.dimensions=t.getUniformLocation(e,"dimensions"),this.uMatrix=t.getUniformLocation(e,"uMatrix"),this.aVertexPosition=t.getAttribLocation(e,"aVertexPosition"),this.aPositionCoord=t.getAttribLocation(e,"aPositionCoord"),this.aScale=t.getAttribLocation(e,"aScale"),this.aRotation=t.getAttribLocation(e,"aRotation"),this.aTextureCoord=t.getAttribLocation(e,"aTextureCoord"),this.colorAttribute=t.getAttribLocation(e,"aColor"),this.aTextureIndex=t.getAttribLocation(e,"aTextureIndex"),-1===this.colorAttribute&&(this.colorAttribute=2),this.attributes=[this.aVertexPosition,this.aPositionCoord,this.aScale,this.aRotation,this.aTextureCoord,this.colorAttribute,this.aTextureIndex],this.program=e},s.PixiFastShader.prototype.destroy=function(){this.gl.deleteProgram(this.program),this.uniforms=null,this.gl=null,this.attributes=null},s.StripShader=function(t){if(this._UID=Phaser._UID++,this.gl=t,this.program=null,s._enableMultiTextureToggle){var t=this.gl;this.MAX_TEXTURES=t.getParameter(t.MAX_TEXTURE_IMAGE_UNITS);for(var e="\tif (vTextureIndex == 0.0) { gl_FragColor = texture2D(uSamplerArray[0], vTextureCoord);return;}\n",i=1;i<this.MAX_TEXTURES;++i)e+="\tif (vTextureIndex == "+i+".0) { gl_FragColor = texture2D(uSamplerArray["+i+"], vTextureCoord) ;return;}\n";this.fragmentSrc=["//StripShader Fragment Shader.","precision mediump float;","bool isnan( float val ) {  return ( val < 0.0 || 0.0 < val || val == 0.0 ) ? false : true; }","varying vec2 vTextureCoord;","varying float vTextureIndex;","uniform float alpha;","uniform sampler2D uSamplerArray["+this.MAX_TEXTURES+"];","const vec4 BLUE = vec4(1.0, 0.0, 1.0, 1.0);","const vec4 RED = vec4(1.0, 0.0, 0.0, 1.0);","void main(void) {",e,"   if(vTextureIndex >= "+this.MAX_TEXTURES+".0) { gl_FragColor = BLUE;return;}","   if(isnan(vTextureIndex)) {gl_FragColor = RED;return;}","}"]}else this.fragmentSrc=["//StripShader Fragment Shader.","precision mediump float;","varying vec2 vTextureCoord;","varying float vTextureIndex;","uniform float alpha;","uniform sampler2D uSampler;","void main(void) {","   gl_FragColor = texture2D(uSampler, vTextureCoord);","}"];this.vertexSrc=["//StripShader Vertex Shader.","attribute vec2 aVertexPosition;","attribute vec2 aTextureCoord;","attribute float aTextureIndex;","uniform mat3 translationMatrix;","uniform vec2 projectionVector;","uniform vec2 offsetVector;","varying vec2 vTextureCoord;","varying float vTextureIndex;","void main(void) {","   vec3 v = translationMatrix * vec3(aVertexPosition , 1.0);","   v -= offsetVector.xyx;","   gl_Position = vec4( v.x / projectionVector.x -1.0, v.y / -projectionVector.y + 1.0 , 0.0, 1.0);","   vTextureCoord = aTextureCoord;","   vTextureIndex = aTextureIndex;","}"],this.init()},s.StripShader.prototype.constructor=s.StripShader,s.StripShader.prototype.init=function(){var t=this.gl,e=s.compileProgram(t,this.vertexSrc,this.fragmentSrc);if(t.useProgram(e),this.uSampler=s._enableMultiTextureToggle?t.getUniformLocation(e,"uSamplerArray[0]"):t.getUniformLocation(e,"uSampler"),s._enableMultiTextureToggle){var i=[],n=t.createTexture();t.activeTexture(t.TEXTURE0),t.bindTexture(t.TEXTURE_2D,n),t.texImage2D(t.TEXTURE_2D,0,t.RGB,1,1,0,t.RGB,t.UNSIGNED_BYTE,null);for(var r=0;r<this.MAX_TEXTURES;++r)t.activeTexture(t.TEXTURE0+r),t.bindTexture(t.TEXTURE_2D,n),i.push(r);t.activeTexture(t.TEXTURE0),t.uniform1iv(this.uSampler,i)}this.projectionVector=t.getUniformLocation(e,"projectionVector"),this.offsetVector=t.getUniformLocation(e,"offsetVector"),this.colorAttribute=t.getAttribLocation(e,"aColor"),this.aTextureIndex=t.getAttribLocation(e,"aTextureIndex"),this.aVertexPosition=t.getAttribLocation(e,"aVertexPosition"),this.aTextureCoord=t.getAttribLocation(e,"aTextureCoord"),this.attributes=[this.aVertexPosition,this.aTextureCoord,this.aTextureIndex],this.translationMatrix=t.getUniformLocation(e,"translationMatrix"),this.alpha=t.getUniformLocation(e,"alpha"),this.program=e},s.StripShader.prototype.destroy=function(){this.gl.deleteProgram(this.program),this.uniforms=null,this.gl=null,this.attribute=null},s.PrimitiveShader=function(t){this._UID=Phaser._UID++,this.gl=t,this.program=null,this.fragmentSrc=["precision mediump float;","varying vec4 vColor;","void main(void) {","   gl_FragColor = vColor;","}"],this.vertexSrc=["attribute vec2 aVertexPosition;","attribute vec4 aColor;","uniform mat3 translationMatrix;","uniform vec2 projectionVector;","uniform vec2 offsetVector;","uniform float alpha;","uniform float flipY;","uniform vec3 tint;","varying vec4 vColor;","void main(void) {","   vec3 v = translationMatrix * vec3(aVertexPosition , 1.0);","   v -= offsetVector.xyx;","   gl_Position = vec4( v.x / projectionVector.x -1.0, (v.y / projectionVector.y * -flipY) + flipY , 0.0, 1.0);","   vColor = aColor * vec4(tint * alpha, alpha);","}"],this.init()},s.PrimitiveShader.prototype.constructor=s.PrimitiveShader,s.PrimitiveShader.prototype.init=function(){var t=this.gl,e=s.compileProgram(t,this.vertexSrc,this.fragmentSrc);t.useProgram(e),this.projectionVector=t.getUniformLocation(e,"projectionVector"),this.offsetVector=t.getUniformLocation(e,"offsetVector"),this.tintColor=t.getUniformLocation(e,"tint"),this.flipY=t.getUniformLocation(e,"flipY"),this.aVertexPosition=t.getAttribLocation(e,"aVertexPosition"),this.colorAttribute=t.getAttribLocation(e,"aColor"),this.attributes=[this.aVertexPosition,this.colorAttribute],this.translationMatrix=t.getUniformLocation(e,"translationMatrix"),this.alpha=t.getUniformLocation(e,"alpha"),this.program=e},s.PrimitiveShader.prototype.destroy=function(){this.gl.deleteProgram(this.program),this.uniforms=null,this.gl=null,this.attributes=null},s.ComplexPrimitiveShader=function(t){this._UID=Phaser._UID++,this.gl=t,this.program=null,this.fragmentSrc=["precision mediump float;","varying vec4 vColor;","void main(void) {","   gl_FragColor = vColor;","}"],this.vertexSrc=["attribute vec2 aVertexPosition;","uniform mat3 translationMatrix;","uniform vec2 projectionVector;","uniform vec2 offsetVector;","uniform vec3 tint;","uniform float alpha;","uniform vec3 color;","uniform float flipY;","varying vec4 vColor;","void main(void) {","   vec3 v = translationMatrix * vec3(aVertexPosition , 1.0);","   v -= offsetVector.xyx;","   gl_Position = vec4( v.x / projectionVector.x -1.0, (v.y / projectionVector.y * -flipY) + flipY , 0.0, 1.0);","   vColor = vec4(color * alpha * tint, alpha);","}"],this.init()},s.ComplexPrimitiveShader.prototype.constructor=s.ComplexPrimitiveShader,s.ComplexPrimitiveShader.prototype.init=function(){var t=this.gl,e=s.compileProgram(t,this.vertexSrc,this.fragmentSrc);t.useProgram(e),this.projectionVector=t.getUniformLocation(e,"projectionVector"),this.offsetVector=t.getUniformLocation(e,"offsetVector"),this.tintColor=t.getUniformLocation(e,"tint"),this.color=t.getUniformLocation(e,"color"),this.flipY=t.getUniformLocation(e,"flipY"),this.aVertexPosition=t.getAttribLocation(e,"aVertexPosition"),this.attributes=[this.aVertexPosition,this.colorAttribute],this.translationMatrix=t.getUniformLocation(e,"translationMatrix"),this.alpha=t.getUniformLocation(e,"alpha"),this.program=e},s.ComplexPrimitiveShader.prototype.destroy=function(){this.gl.deleteProgram(this.program),this.uniforms=null,this.gl=null,this.attribute=null},s.glContexts=[],s.instances=[],s._enableMultiTextureToggle=!1,s.WebGLRenderer=function(t,e){this.game=t,s.defaultRenderer||(s.defaultRenderer=this),this.extensions={},this.type=Phaser.WEBGL,this.resolution=t.resolution,this.transparent=t.transparent,this.autoResize=!1,this.preserveDrawingBuffer=t.preserveDrawingBuffer,this.clearBeforeRender=t.clearBeforeRender,this.width=t.width,this.height=t.height,this.view=t.canvas,this._contextOptions={alpha:this.transparent,antialias:t.antialias,failIfMajorPerformanceCaveat:e.failIfMajorPerformanceCaveat,premultipliedAlpha:this.transparent&&"notMultiplied"!==this.transparent,stencil:!0,preserveDrawingBuffer:this.preserveDrawingBuffer},this.projection=new s.Point,this.offset=new s.Point,this.shaderManager=new s.WebGLShaderManager,this.spriteBatch=new s.WebGLSpriteBatch(t),this.maskManager=new s.WebGLMaskManager,this.filterManager=new s.WebGLFilterManager,this.stencilManager=new s.WebGLStencilManager,this.blendModeManager=new s.WebGLBlendModeManager,this.renderSession={},this.currentBatchedTextures=[],this.renderSession.game=this.game,this.renderSession.gl=this.gl,this.renderSession.drawCount=0,this.renderSession.shaderManager=this.shaderManager,this.renderSession.maskManager=this.maskManager,this.renderSession.filterManager=this.filterManager,this.renderSession.blendModeManager=this.blendModeManager,this.renderSession.spriteBatch=this.spriteBatch,this.renderSession.stencilManager=this.stencilManager,this.renderSession.renderer=this,this.renderSession.resolution=this.resolution,this.renderSession.roundPixels=e.roundPixels||!1,this.renderSession.maxTextureAvailableSpace=null,this.initContext(),this.mapBlendModes()},s.WebGLRenderer.prototype.constructor=s.WebGLRenderer,s.WebGLRenderer.prototype.initContext=function(){var t=this.view.getContext("webgl",this._contextOptions)||this.view.getContext("experimental-webgl",this._contextOptions);if(this.gl=t,!t)throw new Error("This browser does not support webGL. Try using the canvas renderer");this.maxTextures=t.getParameter(t.MAX_TEXTURE_IMAGE_UNITS),this.maxTextureSize=this.gl.getParameter(t.MAX_TEXTURE_SIZE),this.glContextId=t.id=s.WebGLRenderer.glContextId++,s.glContexts[this.glContextId]=t,s.instances[this.glContextId]=this,t.disable(t.DEPTH_TEST),t.disable(t.CULL_FACE),t.enable(t.BLEND),this.shaderManager.setContext(t),this.spriteBatch.setContext(t),this.maskManager.setContext(t),this.filterManager.setContext(t),this.blendModeManager.setContext(t),this.stencilManager.setContext(t),this.renderSession.gl=this.gl,this.resize(this.width,this.height),this.extensions.compression={};var e=t.getExtension("WEBGL_compressed_texture_etc1")||t.getExtension("WEBKIT_WEBGL_compressed_texture_etc1"),i=t.getExtension("WEBGL_compressed_texture_pvrtc")||t.getExtension("WEBKIT_WEBGL_compressed_texture_pvrtc"),n=t.getExtension("WEBGL_compressed_texture_s3tc")||t.getExtension("WEBKIT_WEBGL_compressed_texture_s3tc");e&&(this.extensions.compression.ETC1=e),i&&(this.extensions.compression.PVRTC=i),n&&(this.extensions.compression.S3TC=n)},s.WebGLRenderer.prototype.setTexturePriority=function(t){if(s._enableMultiTextureToggle){for(var e=function(t){return--t,t|=t>>1,t|=t>>2,t|=t>>4,t|=t>>8,t|=t>>16,++t},i=this.gl,n=i.getParameter(i.MAX_TEXTURE_IMAGE_UNITS),r=i.getParameter(i.MAX_TEXTURE_SIZE),o=this.game.cache._cache.image,a=null,h=0;h<this.currentBatchedTextures.length;h++)(a=this.currentBatchedTextures[h])in o?o[a].base.textureIndex=0:console.warn('setTexturePriority: There is no image "%s" in the image cache.',a);var l=r-e(Math.max(this.width,this.height));this.currentBatchedTextures.length=0;for(var c=0;c<t.length;++c)if((a=t[c])in o){var u=o[a].base;(l-=e(Math.max(u.width,u.height)))<=0?(u.textureIndex=0,console.warn('setTexturePriority: Image "%s" was given textureIndex=0 because there is no available texture space (%s).',a,l)):u.textureIndex=1+c%(n-1),this.currentBatchedTextures.push(a)}else console.warn('setTexturePriority: There is no image "%s" in the image cache.',a);return this.renderSession.maxTextureAvailableSpace=l,this.currentBatchedTextures}console.warn("setTexturePriority error: Multi Texture support hasn't been enabled in the Phaser Game Config.")},s.WebGLRenderer.prototype.render=function(t){if(!this.contextLost){var e=this.gl;e.viewport(0,0,this.width,this.height),e.bindFramebuffer(e.FRAMEBUFFER,null),this.game.clearBeforeRender&&(e.clearColor(t._bgColor.r,t._bgColor.g,t._bgColor.b,t._bgColor.a),e.clear(e.COLOR_BUFFER_BIT)),this.offset.x=this.game.camera._shake.x,this.offset.y=this.game.camera._shake.y,this.renderDisplayObject(t,this.projection)}},s.WebGLRenderer.prototype.renderDisplayObject=function(t,e,i,n){this.renderSession.blendModeManager.setBlendMode(s.blendModes.NORMAL),this.renderSession.drawCount=0,this.renderSession.flipY=i?-1:1,this.renderSession.projection=e,this.renderSession.offset=this.offset,this.spriteBatch.begin(this.renderSession),this.filterManager.begin(this.renderSession,i),t._renderWebGL(this.renderSession,n),this.spriteBatch.end()},s.WebGLRenderer.prototype.resize=function(t,e){this.width=t*this.resolution,this.height=e*this.resolution,this.view.width=this.width,this.view.height=this.height,this.autoResize&&(this.view.style.width=this.width/this.resolution+"px",this.view.style.height=this.height/this.resolution+"px"),this.gl.viewport(0,0,this.width,this.height),this.projection.x=this.width/2/this.resolution,this.projection.y=-this.height/2/this.resolution},s.WebGLRenderer.prototype.updateCompressedTexture=function(t){if(!t.hasLoaded)return!1;var e=this.gl,i=t.source;return t._glTextures[e.id]||(t._glTextures[e.id]=e.createTexture()),e.activeTexture(e.TEXTURE0+t.textureIndex),e.bindTexture(e.TEXTURE_2D,t._glTextures[e.id]),e.compressedTexImage2D(e.TEXTURE_2D,0,i.glExtensionFormat,i.width,i.height,0,i.textureData),e.texParameteri(e.TEXTURE_2D,e.TEXTURE_MAG_FILTER,t.scaleMode===s.scaleModes.LINEAR?e.LINEAR:e.NEAREST),t.mipmap&&Phaser.Math.isPowerOfTwo(t.width,t.height)?(e.texParameteri(e.TEXTURE_2D,e.TEXTURE_MIN_FILTER,t.scaleMode===s.scaleModes.LINEAR?e.LINEAR_MIPMAP_LINEAR:e.NEAREST_MIPMAP_NEAREST),e.generateMipmap(e.TEXTURE_2D)):e.texParameteri(e.TEXTURE_2D,e.TEXTURE_MIN_FILTER,t.scaleMode===s.scaleModes.LINEAR?e.LINEAR:e.NEAREST),t._powerOf2?(e.texParameteri(e.TEXTURE_2D,e.TEXTURE_WRAP_S,e.REPEAT),e.texParameteri(e.TEXTURE_2D,e.TEXTURE_WRAP_T,e.REPEAT)):(e.texParameteri(e.TEXTURE_2D,e.TEXTURE_WRAP_S,e.CLAMP_TO_EDGE),e.texParameteri(e.TEXTURE_2D,e.TEXTURE_WRAP_T,e.CLAMP_TO_EDGE)),t._dirty[e.id]=!1,!0},s.WebGLRenderer.prototype.updateTexture=function(t){if(!t.hasLoaded)return!1;if(t.source.compressionAlgorithm)return this.updateCompressedTexture(t);var e=this.gl;return t._glTextures[e.id]||(t._glTextures[e.id]=e.createTexture()),e.activeTexture(e.TEXTURE0+t.textureIndex),e.bindTexture(e.TEXTURE_2D,t._glTextures[e.id]),e.pixelStorei(e.UNPACK_PREMULTIPLY_ALPHA_WEBGL,t.premultipliedAlpha),e.texImage2D(e.TEXTURE_2D,0,e.RGBA,e.RGBA,e.UNSIGNED_BYTE,t.source),e.texParameteri(e.TEXTURE_2D,e.TEXTURE_MAG_FILTER,t.scaleMode===s.scaleModes.LINEAR?e.LINEAR:e.NEAREST),t.mipmap&&Phaser.Math.isPowerOfTwo(t.width,t.height)?(e.texParameteri(e.TEXTURE_2D,e.TEXTURE_MIN_FILTER,t.scaleMode===s.scaleModes.LINEAR?e.LINEAR_MIPMAP_LINEAR:e.NEAREST_MIPMAP_NEAREST),e.generateMipmap(e.TEXTURE_2D)):e.texParameteri(e.TEXTURE_2D,e.TEXTURE_MIN_FILTER,t.scaleMode===s.scaleModes.LINEAR?e.LINEAR:e.NEAREST),t._powerOf2?(e.texParameteri(e.TEXTURE_2D,e.TEXTURE_WRAP_S,e.REPEAT),e.texParameteri(e.TEXTURE_2D,e.TEXTURE_WRAP_T,e.REPEAT)):(e.texParameteri(e.TEXTURE_2D,e.TEXTURE_WRAP_S,e.CLAMP_TO_EDGE),e.texParameteri(e.TEXTURE_2D,e.TEXTURE_WRAP_T,e.CLAMP_TO_EDGE)),t._dirty[e.id]=!1,!0},s.WebGLRenderer.prototype.destroy=function(){s.glContexts[this.glContextId]=null,this.projection=null,this.offset=null,this.shaderManager.destroy(),this.spriteBatch.destroy(),this.maskManager.destroy(),this.filterManager.destroy(),this.shaderManager=null,this.spriteBatch=null,this.maskManager=null,this.filterManager=null,this.gl=null,this.renderSession=null,Phaser.CanvasPool.remove(this),s.instances[this.glContextId]=null,s.WebGLRenderer.glContextId--},s.WebGLRenderer.prototype.mapBlendModes=function(){var t=this.gl;if(!s.blendModesWebGL){var e=[],i=s.blendModes;e[i.NORMAL]=[t.ONE,t.ONE_MINUS_SRC_ALPHA],e[i.ADD]=[t.SRC_ALPHA,t.DST_ALPHA],e[i.MULTIPLY]=[t.DST_COLOR,t.ONE_MINUS_SRC_ALPHA],e[i.SCREEN]=[t.SRC_ALPHA,t.ONE],e[i.OVERLAY]=[t.ONE,t.ONE_MINUS_SRC_ALPHA],e[i.DARKEN]=[t.ONE,t.ONE_MINUS_SRC_ALPHA],e[i.LIGHTEN]=[t.ONE,t.ONE_MINUS_SRC_ALPHA],e[i.COLOR_DODGE]=[t.ONE,t.ONE_MINUS_SRC_ALPHA],e[i.COLOR_BURN]=[t.ONE,t.ONE_MINUS_SRC_ALPHA],e[i.HARD_LIGHT]=[t.ONE,t.ONE_MINUS_SRC_ALPHA],e[i.SOFT_LIGHT]=[t.ONE,t.ONE_MINUS_SRC_ALPHA],e[i.DIFFERENCE]=[t.ONE,t.ONE_MINUS_SRC_ALPHA],e[i.EXCLUSION]=[t.ONE,t.ONE_MINUS_SRC_ALPHA],e[i.HUE]=[t.ONE,t.ONE_MINUS_SRC_ALPHA],e[i.SATURATION]=[t.ONE,t.ONE_MINUS_SRC_ALPHA],e[i.COLOR]=[t.ONE,t.ONE_MINUS_SRC_ALPHA],e[i.LUMINOSITY]=[t.ONE,t.ONE_MINUS_SRC_ALPHA],s.blendModesWebGL=e}},s.WebGLRenderer.prototype.getMaxTextureUnit=function(){var t=this.gl;return t.getParameter(t.MAX_TEXTURE_IMAGE_UNITS)},s.enableMultiTexture=function(){s._enableMultiTextureToggle=!0},s.WebGLRenderer.glContextId=0,s.WebGLRenderer.textureArray=[],s.WebGLBlendModeManager=function(){this.currentBlendMode=99999},s.WebGLBlendModeManager.prototype.constructor=s.WebGLBlendModeManager,s.WebGLBlendModeManager.prototype.setContext=function(t){this.gl=t},s.WebGLBlendModeManager.prototype.setBlendMode=function(t){if(this.currentBlendMode===t)return!1;this.currentBlendMode=t;var e=s.blendModesWebGL[this.currentBlendMode];return e&&this.gl.blendFunc(e[0],e[1]),!0},s.WebGLBlendModeManager.prototype.destroy=function(){this.gl=null},s.WebGLMaskManager=function(){},s.WebGLMaskManager.prototype.constructor=s.WebGLMaskManager,s.WebGLMaskManager.prototype.setContext=function(t){this.gl=t},s.WebGLMaskManager.prototype.pushMask=function(t,e){var i=e.gl;t.dirty&&s.WebGLGraphics.updateGraphics(t,i),void 0!==t._webGL[i.id]&&void 0!==t._webGL[i.id].data&&0!==t._webGL[i.id].data.length&&e.stencilManager.pushStencil(t,t._webGL[i.id].data[0],e)},s.WebGLMaskManager.prototype.popMask=function(t,e){var i=this.gl;void 0!==t._webGL[i.id]&&void 0!==t._webGL[i.id].data&&0!==t._webGL[i.id].data.length&&e.stencilManager.popStencil(t,t._webGL[i.id].data[0],e)},s.WebGLMaskManager.prototype.destroy=function(){this.gl=null},s.WebGLStencilManager=function(){this.stencilStack=[],this.reverse=!0,this.count=0},s.WebGLStencilManager.prototype.setContext=function(t){this.gl=t},s.WebGLStencilManager.prototype.pushStencil=function(t,e,i){var s=this.gl;this.bindGraphics(t,e,i),0===this.stencilStack.length&&(s.enable(s.STENCIL_TEST),s.clear(s.STENCIL_BUFFER_BIT),this.reverse=!0,this.count=0),this.stencilStack.push(e);var n=this.count;s.colorMask(!1,!1,!1,!1),s.stencilFunc(s.ALWAYS,0,255),s.stencilOp(s.KEEP,s.KEEP,s.INVERT),1===e.mode?(s.drawElements(s.TRIANGLE_FAN,e.indices.length-4,s.UNSIGNED_SHORT,0),this.reverse?(s.stencilFunc(s.EQUAL,255-n,255),s.stencilOp(s.KEEP,s.KEEP,s.DECR)):(s.stencilFunc(s.EQUAL,n,255),s.stencilOp(s.KEEP,s.KEEP,s.INCR)),s.drawElements(s.TRIANGLE_FAN,4,s.UNSIGNED_SHORT,2*(e.indices.length-4)),this.reverse?s.stencilFunc(s.EQUAL,255-(n+1),255):s.stencilFunc(s.EQUAL,n+1,255),this.reverse=!this.reverse):(this.reverse?(s.stencilFunc(s.EQUAL,n,255),s.stencilOp(s.KEEP,s.KEEP,s.INCR)):(s.stencilFunc(s.EQUAL,255-n,255),s.stencilOp(s.KEEP,s.KEEP,s.DECR)),s.drawElements(s.TRIANGLE_STRIP,e.indices.length,s.UNSIGNED_SHORT,0),this.reverse?s.stencilFunc(s.EQUAL,n+1,255):s.stencilFunc(s.EQUAL,255-(n+1),255)),s.colorMask(!0,!0,!0,!0),s.stencilOp(s.KEEP,s.KEEP,s.KEEP),this.count++},s.WebGLStencilManager.prototype.bindGraphics=function(t,e,i){this._currentGraphics=t;var s,n=this.gl,r=i.projection,o=i.offset;1===e.mode?(s=i.shaderManager.complexPrimitiveShader,i.shaderManager.setShader(s),n.uniform1f(s.flipY,i.flipY),n.uniformMatrix3fv(s.translationMatrix,!1,t.worldTransform.toArray(!0)),n.uniform2f(s.projectionVector,r.x,-r.y),n.uniform2f(s.offsetVector,-o.x,-o.y),n.uniform3fv(s.tintColor,Phaser.Color.hexToRGBArray(t.tint)),n.uniform3fv(s.color,e.color),n.uniform1f(s.alpha,t.worldAlpha*e.alpha),n.bindBuffer(n.ARRAY_BUFFER,e.buffer),n.vertexAttribPointer(s.aVertexPosition,2,n.FLOAT,!1,8,0),n.bindBuffer(n.ELEMENT_ARRAY_BUFFER,e.indexBuffer)):(s=i.shaderManager.primitiveShader,i.shaderManager.setShader(s),n.uniformMatrix3fv(s.translationMatrix,!1,t.worldTransform.toArray(!0)),n.uniform1f(s.flipY,i.flipY),n.uniform2f(s.projectionVector,r.x,-r.y),n.uniform2f(s.offsetVector,-o.x,-o.y),n.uniform3fv(s.tintColor,Phaser.Color.hexToRGBArray(t.tint)),n.uniform1f(s.alpha,t.worldAlpha),n.bindBuffer(n.ARRAY_BUFFER,e.buffer),n.vertexAttribPointer(s.aVertexPosition,2,n.FLOAT,!1,24,0),n.vertexAttribPointer(s.colorAttribute,4,n.FLOAT,!1,24,8),n.bindBuffer(n.ELEMENT_ARRAY_BUFFER,e.indexBuffer))},s.WebGLStencilManager.prototype.popStencil=function(t,e,i){var s=this.gl;if(this.stencilStack.pop(),this.count--,0===this.stencilStack.length)s.disable(s.STENCIL_TEST);else{var n=this.count;this.bindGraphics(t,e,i),s.colorMask(!1,!1,!1,!1),1===e.mode?(this.reverse=!this.reverse,this.reverse?(s.stencilFunc(s.EQUAL,255-(n+1),255),s.stencilOp(s.KEEP,s.KEEP,s.INCR)):(s.stencilFunc(s.EQUAL,n+1,255),s.stencilOp(s.KEEP,s.KEEP,s.DECR)),s.drawElements(s.TRIANGLE_FAN,4,s.UNSIGNED_SHORT,2*(e.indices.length-4)),s.stencilFunc(s.ALWAYS,0,255),s.stencilOp(s.KEEP,s.KEEP,s.INVERT),s.drawElements(s.TRIANGLE_FAN,e.indices.length-4,s.UNSIGNED_SHORT,0),this.reverse?s.stencilFunc(s.EQUAL,n,255):s.stencilFunc(s.EQUAL,255-n,255)):(this.reverse?(s.stencilFunc(s.EQUAL,n+1,255),s.stencilOp(s.KEEP,s.KEEP,s.DECR)):(s.stencilFunc(s.EQUAL,255-(n+1),255),s.stencilOp(s.KEEP,s.KEEP,s.INCR)),s.drawElements(s.TRIANGLE_STRIP,e.indices.length,s.UNSIGNED_SHORT,0),this.reverse?s.stencilFunc(s.EQUAL,n,255):s.stencilFunc(s.EQUAL,255-n,255)),s.colorMask(!0,!0,!0,!0),s.stencilOp(s.KEEP,s.KEEP,s.KEEP)}},s.WebGLStencilManager.prototype.destroy=function(){this.stencilStack=null,this.gl=null},s.WebGLShaderManager=function(){this.maxAttibs=10,this.attribState=[],this.tempAttribState=[];for(var t=0;t<this.maxAttibs;t++)this.attribState[t]=!1;this.stack=[]},s.WebGLShaderManager.prototype.constructor=s.WebGLShaderManager,s.WebGLShaderManager.prototype.setContext=function(t){this.gl=t,this.primitiveShader=new s.PrimitiveShader(t),this.complexPrimitiveShader=new s.ComplexPrimitiveShader(t),this.defaultShader=new s.PixiShader(t),this.fastShader=new s.PixiFastShader(t),this.stripShader=new s.StripShader(t),this.creatureShader=s.CreatureShader?new s.CreatureShader(t):null,this.setShader(this.defaultShader)},s.WebGLShaderManager.prototype.setAttribs=function(t){var e;for(e=0;e<this.tempAttribState.length;e++)this.tempAttribState[e]=!1;for(e=0;e<t.length;e++){var i=t[e];this.tempAttribState[i]=!0}var s=this.gl;for(e=0;e<this.attribState.length;e++)this.attribState[e]!==this.tempAttribState[e]&&(this.attribState[e]=this.tempAttribState[e],this.tempAttribState[e]?s.enableVertexAttribArray(e):s.disableVertexAttribArray(e))},s.WebGLShaderManager.prototype.setShader=function(t){return this._currentId!==t._UID&&(this._currentId=t._UID,this.currentShader=t,this.gl.useProgram(t.program),this.setAttribs(t.attributes),!0)},s.WebGLShaderManager.prototype.destroy=function(){this.attribState=null,this.tempAttribState=null,this.primitiveShader.destroy(),this.complexPrimitiveShader.destroy(),this.defaultShader.destroy(),this.fastShader.destroy(),this.stripShader.destroy(),this.creatureShader&&this.creatureShader.destroy(),this.gl=null},s.WebGLSpriteBatch=function(t){this.game=t,this.vertSize=5,this.size=2e3,this.vertexSize=24;var e=this.vertexSize*this.size*4,i=6*this.size;this.vertices=new ArrayBuffer(e),this.positions=new Float32Array(this.vertices),this.colors=new Uint32Array(this.vertices),this.indices=new Uint16Array(i),this.lastIndexCount=0;for(var s=0,n=0;s<i;s+=6,n+=4)this.indices[s+0]=n+0,this.indices[s+1]=n+1,this.indices[s+2]=n+2,this.indices[s+3]=n+0,this.indices[s+4]=n+2,this.indices[s+5]=n+3;this.drawing=!1,this.currentBatchSize=0,this.currentBaseTexture=null,this.dirty=!0,this.textures=[],this.blendModes=[],this.shaders=[],this.sprites=[],this.defaultShader=null},s.WebGLSpriteBatch.prototype.setContext=function(t){if(this.MAX_TEXTURES=t.getParameter(t.MAX_TEXTURE_IMAGE_UNITS),this.gl=t,s._enableMultiTextureToggle){for(var e="\tif (vTextureIndex == 0.0) {gl_FragColor = texture2D(uSamplerArray[0], vTextureCoord) * vColor;return;}\n",i=1;i<this.MAX_TEXTURES;++i)e+="\tif (vTextureIndex == "+i+".0) {gl_FragColor = texture2D(uSamplerArray["+i+"], vTextureCoord) * vColor;return;}\n";this.defaultShader=new Phaser.Filter(this.game,void 0,["//WebGLSpriteBatch Fragment Shader.","precision lowp float;","varying vec2 vTextureCoord;","varying vec4 vColor;","varying float vTextureIndex;","uniform sampler2D uSamplerArray["+this.MAX_TEXTURES+"];","void main(void) {",e,"\tgl_FragColor = texture2D(uSamplerArray[0], vTextureCoord) * vColor;","}"])}else this.defaultShader=new Phaser.Filter(this.game,void 0,["//WebGLSpriteBatch Fragment Shader.","precision lowp float;","varying vec2 vTextureCoord;","varying vec4 vColor;","varying float vTextureIndex;","uniform sampler2D uSampler;","void main(void) {","   gl_FragColor = texture2D(uSampler, vTextureCoord) * vColor;","}"]);this.vertexBuffer=t.createBuffer(),this.indexBuffer=t.createBuffer(),t.bindBuffer(t.ELEMENT_ARRAY_BUFFER,this.indexBuffer),t.bufferData(t.ELEMENT_ARRAY_BUFFER,this.indices,t.STATIC_DRAW),t.bindBuffer(t.ARRAY_BUFFER,this.vertexBuffer),t.bufferData(t.ARRAY_BUFFER,this.vertices,t.DYNAMIC_DRAW),this.currentBlendMode=99999;var n=new s.PixiShader(t);n.fragmentSrc=this.defaultShader.fragmentSrc,n.uniforms={},n.init(),this.defaultShader.shaders[t.id]=n},s.WebGLSpriteBatch.prototype.begin=function(t){this.renderSession=t,this.shader=this.renderSession.shaderManager.defaultShader,this.start()},s.WebGLSpriteBatch.prototype.end=function(){this.flush()},s.WebGLSpriteBatch.prototype.render=function(t,e){var i=t.texture,n=i.baseTexture,r=this.gl;s.WebGLRenderer.textureArray[n.textureIndex]!=n&&(this.flush(),r.activeTexture(r.TEXTURE0+n.textureIndex),r.bindTexture(r.TEXTURE_2D,n._glTextures[r.id]),s.WebGLRenderer.textureArray[n.textureIndex]=n);var o=t.worldTransform;e&&(o=e),this.currentBatchSize>=this.size&&(this.flush(),this.currentBaseTexture=i.baseTexture);var a=i._uvs;if(a){var h,l,c,u,d=t.anchor.x,p=t.anchor.y;if(i.trim){var f=i.trim;h=(l=f.x-d*f.width)+i.crop.width,c=(u=f.y-p*f.height)+i.crop.height}else h=i.frame.width*(1-d),l=i.frame.width*-d,c=i.frame.height*(1-p),u=i.frame.height*-p;var g=this.currentBatchSize*this.vertexSize,m=i.baseTexture.resolution,y=i.baseTexture.textureIndex,v=o.a/m,x=o.b/m,b=o.c/m,_=o.d/m,w=o.tx,T=o.ty,P=i.crop.height;if(i.rotated){var C=o.a,S=o.b,A=o.c,E=o.d,M=l,R=h;w=o.c*P+w,T=o.d*P+T,v=6.123233995736766e-17*C-A,x=6.123233995736766e-17*S-E,b=C+6.123233995736766e-17*A,_=S+6.123233995736766e-17*E,i._updateUvsInverted(),h=c,l=u,c=R,u=M}var L=this.colors,B=this.positions,I=t.tint,O=(I>>16)+(65280&I)+((255&I)<<16)+(255*t.worldAlpha<<24);this.renderSession.roundPixels?(B[g++]=v*l+b*u+w|0,B[g++]=_*u+x*l+T|0,B[g++]=a.x0,B[g++]=a.y0,L[g++]=O,B[g++]=y,B[g++]=v*h+b*u+w|0,B[g++]=_*u+x*h+T|0,B[g++]=a.x1,B[g++]=a.y1,L[g++]=O,B[g++]=y,B[g++]=v*h+b*c+w|0,B[g++]=_*c+x*h+T|0,B[g++]=a.x2,B[g++]=a.y2,L[g++]=O,B[g++]=y,B[g++]=v*l+b*c+w|0,B[g++]=_*c+x*l+T|0,B[g++]=a.x3,B[g++]=a.y3,L[g++]=O,B[g++]=y):(B[g++]=v*l+b*u+w,B[g++]=_*u+x*l+T,B[g++]=a.x0,B[g++]=a.y0,L[g++]=O,B[g++]=y,B[g++]=v*h+b*u+w,B[g++]=_*u+x*h+T,B[g++]=a.x1,B[g++]=a.y1,L[g++]=O,B[g++]=y,B[g++]=v*h+b*c+w,B[g++]=_*c+x*h+T,B[g++]=a.x2,B[g++]=a.y2,L[g++]=O,B[g++]=y,B[g++]=v*l+b*c+w,B[g++]=_*c+x*l+T,B[g++]=a.x3,B[g++]=a.y3,L[g++]=O,B[g++]=y),this.sprites[this.currentBatchSize++]=t}},s.WebGLSpriteBatch.prototype.renderTilingSprite=function(t){var e=t.tilingTexture,i=e.baseTexture,n=this.gl,r=t.texture.baseTexture.textureIndex;s.WebGLRenderer.textureArray[r]!=i&&(this.flush(),n.activeTexture(n.TEXTURE0+r),n.bindTexture(n.TEXTURE_2D,i._glTextures[n.id]),s.WebGLRenderer.textureArray[r]=i),this.currentBatchSize>=this.size&&(this.flush(),this.currentBaseTexture=e.baseTexture),t._uvs||(t._uvs=new s.TextureUvs);var o=t._uvs,a=e.baseTexture.width,h=e.baseTexture.height;t.tilePosition.x%=a*t.tileScaleOffset.x,t.tilePosition.y%=h*t.tileScaleOffset.y;var l=t.tilePosition.x/(a*t.tileScaleOffset.x),c=t.tilePosition.y/(h*t.tileScaleOffset.y),u=t.width/a/(t.tileScale.x*t.tileScaleOffset.x),d=t.height/h/(t.tileScale.y*t.tileScaleOffset.y);o.x0=0-l,o.y0=0-c,o.x1=1*u-l,o.y1=0-c,o.x2=1*u-l,o.y2=1*d-c,o.x3=0-l,o.y3=1*d-c;var p=t.tint,f=(p>>16)+(65280&p)+((255&p)<<16)+(255*t.worldAlpha<<24),g=this.positions,m=this.colors,y=t.width,v=t.height,x=t.anchor.x,b=t.anchor.y,_=y*(1-x),w=y*-x,T=v*(1-b),P=v*-b,C=this.currentBatchSize*this.vertexSize,S=e.baseTexture.resolution,A=t.worldTransform,E=A.a/S,M=A.b/S,R=A.c/S,L=A.d/S,B=A.tx,I=A.ty;g[C++]=E*w+R*P+B,g[C++]=L*P+M*w+I,g[C++]=o.x0,g[C++]=o.y0,m[C++]=f,g[C++]=r,g[C++]=E*_+R*P+B,g[C++]=L*P+M*_+I,g[C++]=o.x1,g[C++]=o.y1,m[C++]=f,g[C++]=r,g[C++]=E*_+R*T+B,g[C++]=L*T+M*_+I,g[C++]=o.x2,g[C++]=o.y2,m[C++]=f,g[C++]=r,g[C++]=E*w+R*T+B,g[C++]=L*T+M*w+I,g[C++]=o.x3,g[C++]=o.y3,m[C++]=f,g[C++]=r,this.sprites[this.currentBatchSize++]=t},s.WebGLSpriteBatch.prototype.flush=function(){if(0!==this.currentBatchSize){var t,e=this.gl;if(this.dirty){this.dirty=!1,t=this.defaultShader.shaders[e.id],e.activeTexture(e.TEXTURE0),e.bindBuffer(e.ARRAY_BUFFER,this.vertexBuffer),e.bindBuffer(e.ELEMENT_ARRAY_BUFFER,this.indexBuffer);var i=this.vertexSize;e.vertexAttribPointer(t.aVertexPosition,2,e.FLOAT,!1,i,0),e.vertexAttribPointer(t.aTextureCoord,2,e.FLOAT,!1,i,8),e.vertexAttribPointer(t.colorAttribute,4,e.UNSIGNED_BYTE,!0,i,16),e.vertexAttribPointer(t.aTextureIndex,1,e.FLOAT,!1,i,20)}if(this.currentBatchSize>.5*this.size)e.bufferSubData(e.ARRAY_BUFFER,0,this.vertices);else{e.bindBuffer(e.ARRAY_BUFFER,this.vertexBuffer);var n=this.positions.subarray(0,this.currentBatchSize*this.vertexSize);e.bufferSubData(e.ARRAY_BUFFER,0,n)}for(var r,o,a,h,l=0,c=0,u=null,d=this.renderSession.blendModeManager.currentBlendMode,p=null,f=!1,g=!1,m=0,y=this.currentBatchSize;m<y;m++){r=(h=this.sprites[m]).tilingTexture?h.tilingTexture.baseTexture:h.texture.baseTexture,f=d!==(o=h.blendMode),g=p!==(a=h.shader||this.defaultShader);var v=r.skipRender;if(v&&h.children.length>0&&(v=!1),(f||g)&&(this.renderBatch(u,l,c),c=m,l=0,u=r,f&&(d=o,this.renderSession.blendModeManager.setBlendMode(d)),g)){(t=(p=a).shaders[e.id])||((t=new s.PixiShader(e)).fragmentSrc=p.fragmentSrc,t.uniforms=p.uniforms,t.init(),p.shaders[e.id]=t),this.renderSession.shaderManager.setShader(t),t.dirty&&t.syncUniforms();var x=this.renderSession.projection;e.uniform2f(t.projectionVector,x.x,x.y);var b=this.renderSession.offset;e.uniform2f(t.offsetVector,b.x,b.y)}l++}this.renderBatch(u,l,c),this.currentBatchSize=0}},s.WebGLSpriteBatch.prototype.renderBatch=function(t,e,i){if(0!==e){var s=this.gl;if(t._dirty[s.id]){if(!this.renderSession.renderer.updateTexture(t))return}else s.bindTexture(s.TEXTURE_2D,t._glTextures[s.id]);s.drawElements(s.TRIANGLES,6*e,s.UNSIGNED_SHORT,6*i*2),this.renderSession.drawCount++}},s.WebGLSpriteBatch.prototype.stop=function(){this.flush(),this.dirty=!0},s.WebGLSpriteBatch.prototype.start=function(){this.dirty=!0},s.WebGLSpriteBatch.prototype.destroy=function(){this.vertices=null,this.indices=null,this.gl.deleteBuffer(this.vertexBuffer),this.gl.deleteBuffer(this.indexBuffer),this.currentBaseTexture=null,this.gl=null},s.WebGLFastSpriteBatch=function(t){this.vertSize=11,this.maxSize=6e3,this.size=this.maxSize;var e=4*this.size*this.vertSize,i=6*this.maxSize;this.vertices=new Float32Array(e),this.indices=new Uint16Array(i),this.vertexBuffer=null,this.indexBuffer=null,this.lastIndexCount=0;for(var s=0,n=0;s<i;s+=6,n+=4)this.indices[s+0]=n+0,this.indices[s+1]=n+1,this.indices[s+2]=n+2,this.indices[s+3]=n+0,this.indices[s+4]=n+2,this.indices[s+5]=n+3;this.drawing=!1,this.currentBatchSize=0,this.currentBaseTexture=null,this.currentBlendMode=0,this.renderSession=null,this.shader=null,this.matrix=null,this.setContext(t)},s.WebGLFastSpriteBatch.prototype.constructor=s.WebGLFastSpriteBatch,s.WebGLFastSpriteBatch.prototype.setContext=function(t){this.gl=t,this.vertexBuffer=t.createBuffer(),this.indexBuffer=t.createBuffer(),t.bindBuffer(t.ELEMENT_ARRAY_BUFFER,this.indexBuffer),t.bufferData(t.ELEMENT_ARRAY_BUFFER,this.indices,t.STATIC_DRAW),t.bindBuffer(t.ARRAY_BUFFER,this.vertexBuffer),t.bufferData(t.ARRAY_BUFFER,this.vertices,t.DYNAMIC_DRAW)},s.WebGLFastSpriteBatch.prototype.begin=function(t,e){this.renderSession=e,this.shader=this.renderSession.shaderManager.fastShader,this.matrix=t.worldTransform.toArray(!0),this.start()},s.WebGLFastSpriteBatch.prototype.end=function(){this.flush()},s.WebGLFastSpriteBatch.prototype.render=function(t){var e=t.children,i=e[0];if(i.texture._uvs){this.currentBaseTexture=i.texture.baseTexture,i.blendMode!==this.renderSession.blendModeManager.currentBlendMode&&(this.flush(),this.renderSession.blendModeManager.setBlendMode(i.blendMode));for(var s=0,n=e.length;s<n;s++)this.renderSprite(e[s]);this.flush()}},s.WebGLFastSpriteBatch.prototype.renderSprite=function(t){var e=t.texture.baseTexture,i=this.gl,n=t.texture.baseTexture.textureIndex;if((s.WebGLRenderer.textureArray[n]==e||!e._glTextures[i.id]||t.texture.baseTexture.skipRender||(this.flush(),i.activeTexture(i.TEXTURE0+n),i.bindTexture(i.TEXTURE_2D,e._glTextures[i.id]),s.WebGLRenderer.textureArray[n]=e,t.texture._uvs))&&t.visible){var r,o,a,h,l,c,u,d,p=this.vertices;if(r=t.texture._uvs,o=t.texture.frame.width,a=t.texture.frame.height,t.texture.trim){var f=t.texture.trim;h=(l=f.x-t.anchor.x*f.width)+t.texture.crop.width,c=(u=f.y-t.anchor.y*f.height)+t.texture.crop.height}else h=o*(1-t.anchor.x),l=o*-t.anchor.x,c=a*(1-t.anchor.y),u=a*-t.anchor.y;d=4*this.currentBatchSize*this.vertSize,p[d++]=l,p[d++]=u,p[d++]=t.position.x,p[d++]=t.position.y,p[d++]=t.scale.x,p[d++]=t.scale.y,p[d++]=t.rotation,p[d++]=r.x0,p[d++]=r.y1,p[d++]=t.alpha,p[d++]=n,p[d++]=h,p[d++]=u,p[d++]=t.position.x,p[d++]=t.position.y,p[d++]=t.scale.x,p[d++]=t.scale.y,p[d++]=t.rotation,p[d++]=r.x1,p[d++]=r.y1,p[d++]=t.alpha,p[d++]=n,p[d++]=h,p[d++]=c,p[d++]=t.position.x,p[d++]=t.position.y,p[d++]=t.scale.x,p[d++]=t.scale.y,p[d++]=t.rotation,p[d++]=r.x2,p[d++]=r.y2,p[d++]=t.alpha,p[d++]=n,p[d++]=l,p[d++]=c,p[d++]=t.position.x,p[d++]=t.position.y,p[d++]=t.scale.x,p[d++]=t.scale.y,p[d++]=t.rotation,p[d++]=r.x3,p[d++]=r.y3,p[d++]=t.alpha,p[d++]=n,++this.currentBatchSize>=this.size&&this.flush()}},s.WebGLFastSpriteBatch.prototype.flush=function(){if(0!==this.currentBatchSize){var t=this.gl;if(this.currentBaseTexture._glTextures[t.id]){if(this.currentBatchSize>.5*this.size)t.bufferSubData(t.ARRAY_BUFFER,0,this.vertices);else{var e=this.vertices.subarray(0,4*this.currentBatchSize*this.vertSize);t.bufferSubData(t.ARRAY_BUFFER,0,e)}t.drawElements(t.TRIANGLES,6*this.currentBatchSize,t.UNSIGNED_SHORT,0),this.currentBatchSize=0,this.renderSession.drawCount++}else this.renderSession.renderer.updateTexture(this.currentBaseTexture,t)}},s.WebGLFastSpriteBatch.prototype.stop=function(){this.flush()},s.WebGLFastSpriteBatch.prototype.start=function(){var t=this.gl;t.activeTexture(t.TEXTURE0),t.bindBuffer(t.ARRAY_BUFFER,this.vertexBuffer),t.bindBuffer(t.ELEMENT_ARRAY_BUFFER,this.indexBuffer);var e=this.renderSession.projection;t.uniform2f(this.shader.projectionVector,e.x,e.y),t.uniformMatrix3fv(this.shader.uMatrix,!1,this.matrix);var i=4*this.vertSize;t.vertexAttribPointer(this.shader.aVertexPosition,2,t.FLOAT,!1,i,0),t.vertexAttribPointer(this.shader.aPositionCoord,2,t.FLOAT,!1,i,8),t.vertexAttribPointer(this.shader.aScale,2,t.FLOAT,!1,i,16),t.vertexAttribPointer(this.shader.aRotation,1,t.FLOAT,!1,i,24),t.vertexAttribPointer(this.shader.aTextureCoord,2,t.FLOAT,!1,i,28),t.vertexAttribPointer(this.shader.colorAttribute,1,t.FLOAT,!1,i,36),t.vertexAttribPointer(this.shader.aTextureIndex,1,t.FLOAT,!1,i,40)},s.WebGLFilterManager=function(){this.filterStack=[],this.offsetX=0,this.offsetY=0},s.WebGLFilterManager.prototype.constructor=s.WebGLFilterManager,s.WebGLFilterManager.prototype.setContext=function(t){this.gl=t,this.texturePool=[],this.initShaderBuffers()},s.WebGLFilterManager.prototype.begin=function(t,e){this.renderSession=t,this.defaultShader=t.shaderManager.defaultShader;var i=this.renderSession.projection;this.width=2*i.x,this.height=2*-i.y,this.buffer=e},s.WebGLFilterManager.prototype.pushFilter=function(t){var e=this.gl,i=this.renderSession.projection,n=this.renderSession.offset;t._filterArea=t.target.filterArea||t.target.getBounds(),t._previous_stencil_mgr=this.renderSession.stencilManager,this.renderSession.stencilManager=new s.WebGLStencilManager,this.renderSession.stencilManager.setContext(e),e.disable(e.STENCIL_TEST),this.filterStack.push(t);var r=t.filterPasses[0];this.offsetX+=t._filterArea.x,this.offsetY+=t._filterArea.y;var o=this.texturePool.pop();o?o.resize(this.width*this.renderSession.resolution,this.height*this.renderSession.resolution):o=new s.FilterTexture(this.gl,this.width*this.renderSession.resolution,this.height*this.renderSession.resolution),e.bindTexture(e.TEXTURE_2D,o.texture);var a=t._filterArea,h=r.padding;a.x-=h,a.y-=h,a.width+=2*h,a.height+=2*h,a.x<0&&(a.x=0),a.width>this.width&&(a.width=this.width),a.y<0&&(a.y=0),a.height>this.height&&(a.height=this.height),e.bindFramebuffer(e.FRAMEBUFFER,o.frameBuffer),e.viewport(0,0,a.width*this.renderSession.resolution,a.height*this.renderSession.resolution),i.x=a.width/2,i.y=-a.height/2,n.x=-a.x,n.y=-a.y,e.colorMask(!0,!0,!0,!0),e.clearColor(0,0,0,0),e.clear(e.COLOR_BUFFER_BIT),t._glFilterTexture=o},s.WebGLFilterManager.prototype.popFilter=function(){var t=this.gl,e=this.filterStack.pop(),i=e._filterArea,n=e._glFilterTexture,r=this.renderSession.projection,o=this.renderSession.offset;if(e.filterPasses.length>1){t.viewport(0,0,i.width*this.renderSession.resolution,i.height*this.renderSession.resolution),t.bindBuffer(t.ARRAY_BUFFER,this.vertexBuffer),this.vertexArray[0]=0,this.vertexArray[1]=i.height,this.vertexArray[2]=i.width,this.vertexArray[3]=i.height,this.vertexArray[4]=0,this.vertexArray[5]=0,this.vertexArray[6]=i.width,this.vertexArray[7]=0,t.bufferSubData(t.ARRAY_BUFFER,0,this.vertexArray),t.bindBuffer(t.ARRAY_BUFFER,this.uvBuffer),this.uvArray[2]=i.width/this.width,this.uvArray[5]=i.height/this.height,this.uvArray[6]=i.width/this.width,this.uvArray[7]=i.height/this.height,t.bufferSubData(t.ARRAY_BUFFER,0,this.uvArray);var a=n,h=this.texturePool.pop();h||(h=new s.FilterTexture(this.gl,this.width*this.renderSession.resolution,this.height*this.renderSession.resolution)),h.resize(this.width*this.renderSession.resolution,this.height*this.renderSession.resolution),t.bindFramebuffer(t.FRAMEBUFFER,h.frameBuffer),t.clear(t.COLOR_BUFFER_BIT),t.disable(t.BLEND);for(var l=0;l<e.filterPasses.length-1;l++){var c=e.filterPasses[l];t.bindFramebuffer(t.FRAMEBUFFER,h.frameBuffer),t.activeTexture(t.TEXTURE0),t.bindTexture(t.TEXTURE_2D,a.texture),this.applyFilterPass(c,i,i.width,i.height);var u=a;a=h,h=u}t.enable(t.BLEND),n=a,this.texturePool.push(h)}var d=e.filterPasses[e.filterPasses.length-1];this.offsetX-=i.x,this.offsetY-=i.y;var p=this.width,f=this.height,g=0,m=0,y=this.buffer;if(0===this.filterStack.length)t.colorMask(!0,!0,!0,!0);else{var v=this.filterStack[this.filterStack.length-1];p=(i=v._filterArea).width,f=i.height,g=i.x,m=i.y,y=v._glFilterTexture.frameBuffer}r.x=p/2,r.y=-f/2,o.x=g,o.y=m;var x=(i=e._filterArea).x-g,b=i.y-m;t.bindBuffer(t.ARRAY_BUFFER,this.vertexBuffer),this.vertexArray[0]=x,this.vertexArray[1]=b+i.height,this.vertexArray[2]=x+i.width,this.vertexArray[3]=b+i.height,this.vertexArray[4]=x,this.vertexArray[5]=b,this.vertexArray[6]=x+i.width,this.vertexArray[7]=b,t.bufferSubData(t.ARRAY_BUFFER,0,this.vertexArray),t.bindBuffer(t.ARRAY_BUFFER,this.uvBuffer),this.uvArray[2]=i.width/this.width,this.uvArray[5]=i.height/this.height,this.uvArray[6]=i.width/this.width,this.uvArray[7]=i.height/this.height,t.bufferSubData(t.ARRAY_BUFFER,0,this.uvArray),t.viewport(0,0,p*this.renderSession.resolution,f*this.renderSession.resolution),t.bindFramebuffer(t.FRAMEBUFFER,y),t.activeTexture(t.TEXTURE0),t.bindTexture(t.TEXTURE_2D,n.texture),this.renderSession.stencilManager&&this.renderSession.stencilManager.destroy(),this.renderSession.stencilManager=e._previous_stencil_mgr,e._previous_stencil_mgr=null,this.renderSession.stencilManager.count>0?t.enable(t.STENCIL_TEST):t.disable(t.STENCIL_TEST),this.applyFilterPass(d,i,p,f),this.texturePool.push(n),e._glFilterTexture=null},s.WebGLFilterManager.prototype.applyFilterPass=function(t,e,i,n){var r=this.gl,o=t.shaders[r.id];o||((o=new s.PixiShader(r)).fragmentSrc=t.fragmentSrc,o.uniforms=t.uniforms,o.init(!0),t.shaders[r.id]=o),this.renderSession.shaderManager.setShader(o),r.uniform2f(o.projectionVector,i/2,-n/2),r.uniform2f(o.offsetVector,0,0),t.uniforms.dimensions&&(t.uniforms.dimensions.value[0]=this.width,t.uniforms.dimensions.value[1]=this.height,t.uniforms.dimensions.value[2]=this.vertexArray[0],t.uniforms.dimensions.value[3]=this.vertexArray[5]),o.syncUniforms(),r.bindBuffer(r.ARRAY_BUFFER,this.vertexBuffer),r.vertexAttribPointer(o.aVertexPosition,2,r.FLOAT,!1,0,0),r.bindBuffer(r.ARRAY_BUFFER,this.uvBuffer),r.vertexAttribPointer(o.aTextureCoord,2,r.FLOAT,!1,0,0),r.bindBuffer(r.ARRAY_BUFFER,this.colorBuffer),r.vertexAttribPointer(o.colorAttribute,2,r.FLOAT,!1,0,0),r.bindBuffer(r.ELEMENT_ARRAY_BUFFER,this.indexBuffer),r.drawElements(r.TRIANGLES,6,r.UNSIGNED_SHORT,0),this.renderSession.drawCount++},s.WebGLFilterManager.prototype.initShaderBuffers=function(){var t=this.gl;this.vertexBuffer=t.createBuffer(),this.uvBuffer=t.createBuffer(),this.colorBuffer=t.createBuffer(),this.indexBuffer=t.createBuffer(),this.vertexArray=new Float32Array([0,0,1,0,0,1,1,1]),t.bindBuffer(t.ARRAY_BUFFER,this.vertexBuffer),t.bufferData(t.ARRAY_BUFFER,this.vertexArray,t.STATIC_DRAW),this.uvArray=new Float32Array([0,0,1,0,0,1,1,1]),t.bindBuffer(t.ARRAY_BUFFER,this.uvBuffer),t.bufferData(t.ARRAY_BUFFER,this.uvArray,t.STATIC_DRAW),this.colorArray=new Float32Array([1,16777215,1,16777215,1,16777215,1,16777215]),t.bindBuffer(t.ARRAY_BUFFER,this.colorBuffer),t.bufferData(t.ARRAY_BUFFER,this.colorArray,t.STATIC_DRAW),t.bindBuffer(t.ELEMENT_ARRAY_BUFFER,this.indexBuffer),t.bufferData(t.ELEMENT_ARRAY_BUFFER,new Uint16Array([0,1,2,1,3,2]),t.STATIC_DRAW)},s.WebGLFilterManager.prototype.destroy=function(){var t=this.gl;this.filterStack=null,this.offsetX=0,this.offsetY=0;for(var e=0;e<this.texturePool.length;e++)this.texturePool[e].destroy();this.texturePool=null,t.deleteBuffer(this.vertexBuffer),t.deleteBuffer(this.uvBuffer),t.deleteBuffer(this.colorBuffer),t.deleteBuffer(this.indexBuffer)};var n={36054:"Incomplete attachment",36055:"Missing attachment",36057:"Incomplete dimensions",36061:"Framebuffer unsupported"};return s.FilterTexture=function(t,i,n,r,o){o="number"==typeof o?o:0,this.gl=t,this.frameBuffer=e(t,i,n,r||s.scaleModes.DEFAULT,o),this.texture=this.frameBuffer.targetTexture,this.width=i,this.height=n,this.renderBuffer=this.frameBuffer.renderBuffer},s.FilterTexture.prototype.constructor=s.FilterTexture,s.FilterTexture.prototype.clear=function(){var t=this.gl;t.clearColor(0,0,0,0),t.clear(t.COLOR_BUFFER_BIT)},s.FilterTexture.prototype.resize=function(t,e){if(this.width!==t||this.height!==e){this.width=t,this.height=e;var i=this.gl;i.bindTexture(i.TEXTURE_2D,this.texture),i.texImage2D(i.TEXTURE_2D,0,i.RGBA,t,e,0,i.RGBA,i.UNSIGNED_BYTE,null),i.bindRenderbuffer(i.RENDERBUFFER,this.renderBuffer),i.renderbufferStorage(i.RENDERBUFFER,i.DEPTH_STENCIL,t,e)}},s.FilterTexture.prototype.destroy=function(){var t=this.gl;t.deleteFramebuffer(this.frameBuffer),t.deleteTexture(this.texture),this.frameBuffer=null,this.texture=null},s.CanvasBuffer=function(t,e){this.width=t,this.height=e,this.canvas=Phaser.CanvasPool.create(this,this.width,this.height),this.context=this.canvas.getContext("2d"),this.canvas.width=t,this.canvas.height=e},s.CanvasBuffer.prototype.constructor=s.CanvasBuffer,s.CanvasBuffer.prototype.clear=function(){this.context.setTransform(1,0,0,1,0,0),this.context.clearRect(0,0,this.width,this.height)},s.CanvasBuffer.prototype.resize=function(t,e){this.width=this.canvas.width=t,this.height=this.canvas.height=e},s.CanvasBuffer.prototype.destroy=function(){Phaser.CanvasPool.remove(this)},s.CanvasMaskManager=function(){},s.CanvasMaskManager.prototype.constructor=s.CanvasMaskManager,s.CanvasMaskManager.prototype.pushMask=function(t,e){var i=e.context;i.save();var n=t.alpha,r=t.worldTransform,o=e.resolution;i.setTransform(r.a*o,r.b*o,r.c*o,r.d*o,r.tx*o,r.ty*o),s.CanvasGraphics.renderGraphicsMask(t,i),i.clip(),t.worldAlpha=n},s.CanvasMaskManager.prototype.popMask=function(t){t.context.restore()},s.CanvasTinter=function(){},s.CanvasTinter.getTintedTexture=function(t,e){var i=t.tintedTexture||Phaser.CanvasPool.create(this);return s.CanvasTinter.tintMethod(t.texture,e,i),i},s.CanvasTinter.tintWithMultiply=function(t,e,i){var s=i.getContext("2d"),n=t.crop,r=n.width,o=n.height;t.rotated&&(r=o,o=n.width),i.width===r&&i.height===o||(i.width=r,i.height=o),s.clearRect(0,0,r,o),s.fillStyle="#"+("00000"+(0|e).toString(16)).substr(-6),s.fillRect(0,0,r,o),s.globalCompositeOperation="multiply",s.drawImage(t.baseTexture.source,n.x,n.y,r,o,0,0,r,o),s.globalCompositeOperation="destination-atop",s.drawImage(t.baseTexture.source,n.x,n.y,r,o,0,0,r,o)},s.CanvasTinter.tintWithPerPixel=function(t,e,i){var n=i.getContext("2d"),r=t.crop,o=r.width,a=r.height;t.rotated&&(o=a,a=r.width),i.width===o&&i.height===a||(i.width=o,i.height=a),n.globalCompositeOperation="copy",n.drawImage(t.baseTexture.source,r.x,r.y,o,a,0,0,o,a);for(var h=Phaser.Color.hexToRGBArray(e),l=h[0],c=h[1],u=h[2],d=n.getImageData(0,0,o,a),p=d.data,f=0;f<p.length;f+=4)if(p[f+0]*=l,p[f+1]*=c,p[f+2]*=u,!s.CanvasTinter.canHandleAlpha){var g=p[f+3];p[f+0]/=255/g,p[f+1]/=255/g,p[f+2]/=255/g}n.putImageData(d,0,0)},s.CanvasRenderer=function(t,e){if(this.game=t,s.defaultRenderer||(s.defaultRenderer=this),this.type=Phaser.CANVAS,this.resolution=t.resolution,this.clearBeforeRender=t.clearBeforeRender,this.transparent=t.transparent,this.autoResize=!1,this.width=t.width*this.resolution,this.height=t.height*this.resolution,this.view=t.canvas,this.context=this.view.getContext("2d",{alpha:this.transparent}),!this.context)throw new Error("Failed to create a Canvas 2d context.");this.refresh=!0,this.count=0,this.maskManager=new s.CanvasMaskManager,this.renderSession={context:this.context,maskManager:this.maskManager,scaleMode:null,smoothProperty:Phaser.Canvas.getSmoothingPrefix(this.context),roundPixels:e.roundPixels||!1},this.mapBlendModes(),this.resize(this.width,this.height)},s.CanvasRenderer.prototype.constructor=s.CanvasRenderer,s.CanvasRenderer.prototype.render=function(t){this.context.setTransform(1,0,0,1,0,0),this.context.globalAlpha=1,this.renderSession.currentBlendMode=0,this.renderSession.shakeX=this.game.camera._shake.x,this.renderSession.shakeY=this.game.camera._shake.y,this.context.globalCompositeOperation="source-over",navigator.isCocoonJS&&this.view.screencanvas&&(this.context.fillStyle="black",this.context.clear()),this.clearBeforeRender&&(this.transparent?this.context.clearRect(0,0,this.width,this.height):t._bgColor&&(this.context.fillStyle=t._bgColor.rgba,this.context.fillRect(0,0,this.width,this.height))),this.renderDisplayObject(t)},s.CanvasRenderer.prototype.setTexturePriority=function(){},s.CanvasRenderer.prototype.destroy=function(t){void 0===t&&(t=!0),t&&this.view.parent&&this.view.parent.removeChild(this.view),this.view=null,this.context=null,this.maskManager=null,this.renderSession=null},s.CanvasRenderer.prototype.resize=function(t,e){this.width=t*this.resolution,this.height=e*this.resolution,this.view.width=this.width,this.view.height=this.height,this.autoResize&&(this.view.style.width=this.width/this.resolution+"px",this.view.style.height=this.height/this.resolution+"px"),this.renderSession.smoothProperty&&(this.context[this.renderSession.smoothProperty]=this.renderSession.scaleMode===s.scaleModes.LINEAR)},s.CanvasRenderer.prototype.renderDisplayObject=function(t,e,i){this.renderSession.context=e||this.context,this.renderSession.resolution=this.resolution,t._renderCanvas(this.renderSession,i)},s.CanvasRenderer.prototype.mapBlendModes=function(){if(!s.blendModesCanvas){var t=[],e=s.blendModes,i=this.game.device.canUseMultiply;t[e.NORMAL]="source-over",t[e.ADD]="lighter",t[e.MULTIPLY]=i?"multiply":"source-over",t[e.SCREEN]=i?"screen":"source-over",t[e.OVERLAY]=i?"overlay":"source-over",t[e.DARKEN]=i?"darken":"source-over",t[e.LIGHTEN]=i?"lighten":"source-over",t[e.COLOR_DODGE]=i?"color-dodge":"source-over",t[e.COLOR_BURN]=i?"color-burn":"source-over",t[e.HARD_LIGHT]=i?"hard-light":"source-over",t[e.SOFT_LIGHT]=i?"soft-light":"source-over",t[e.DIFFERENCE]=i?"difference":"source-over",t[e.EXCLUSION]=i?"exclusion":"source-over",t[e.HUE]=i?"hue":"source-over",t[e.SATURATION]=i?"saturation":"source-over",t[e.COLOR]=i?"color":"source-over",t[e.LUMINOSITY]=i?"luminosity":"source-over",s.blendModesCanvas=t}},s.BaseTexture=function(t,e,i){this.resolution=i||1,this.width=100,this.height=100,this.scaleMode=e||s.scaleModes.DEFAULT,this.hasLoaded=!1,this.source=t,this.premultipliedAlpha=!0,this._glTextures=[],this.mipmap=!1,this.textureIndex=0,this._dirty=[!0,!0,!0,!0],t&&((this.source.complete||this.source.getContext)&&this.source.width&&this.source.height&&(this.hasLoaded=!0,this.width=this.source.naturalWidth||this.source.width,this.height=this.source.naturalHeight||this.source.height,this.dirty()),this.skipRender=!1,this._powerOf2=!1)},s.BaseTexture.prototype.constructor=s.BaseTexture,s.BaseTexture.prototype.forceLoaded=function(t,e){this.hasLoaded=!0,this.width=t,this.height=e,this.dirty()},s.BaseTexture.prototype.destroy=function(){this.source&&Phaser.CanvasPool.removeByCanvas(this.source),this.source=null,this.unloadFromGPU()},s.BaseTexture.prototype.dirty=function(){for(var t=0;t<this._glTextures.length;t++)this._dirty[t]=!0},s.BaseTexture.prototype.unloadFromGPU=function(){this.dirty();for(var t=this._glTextures.length-1;t>=0;t--){var e=this._glTextures[t],i=s.glContexts[t];i&&e&&i.deleteTexture(e)}this._glTextures.length=0,this.dirty()},s.BaseTexture.fromCanvas=function(t,e,i){return 0===t.width&&(t.width=1),0===t.height&&(t.height=1),i=i||1,new s.BaseTexture(t,e,i)},s.TextureSilentFail=!1,s.Texture=function(t,e,i,n){this.noFrame=!1,e||(this.noFrame=!0,e=new s.Rectangle(0,0,1,1)),t instanceof s.Texture&&(t=t.baseTexture),this.baseTexture=t,this.frame=e,this.trim=n,this.valid=!1,this.isTiling=!1,this.requiresUpdate=!1,this.requiresReTint=!1,this._uvs=null,this.width=0,this.height=0,this.crop=i||new s.Rectangle(0,0,1,1),this.rotated=!1,t.hasLoaded&&(this.noFrame&&(e=new s.Rectangle(0,0,t.width,t.height)),this.setFrame(e))},s.Texture.prototype.constructor=s.Texture,s.Texture.prototype.onBaseTextureLoaded=function(){var t=this.baseTexture;this.noFrame&&(this.frame=new s.Rectangle(0,0,t.width,t.height)),this.setFrame(this.frame)},s.Texture.prototype.destroy=function(t){t&&this.baseTexture.destroy(),this.valid=!1},s.Texture.prototype.setFrame=function(t){if(this.noFrame=!1,this.frame=t,this.width=t.width,this.height=t.height,this.crop.x=t.x,this.crop.y=t.y,this.crop.width=t.width,this.crop.height=t.height,this.trim||!(t.x+t.width>this.baseTexture.width||t.y+t.height>this.baseTexture.height))this.valid=t&&t.width&&t.height&&this.baseTexture.source&&this.baseTexture.hasLoaded,this.trim&&(this.width=this.trim.width,this.height=this.trim.height,this.frame.width=this.trim.width,this.frame.height=this.trim.height),this.valid&&this._updateUvs();else{if(!s.TextureSilentFail)throw new Error("Texture Error: frame does not fit inside the base Texture dimensions "+this);this.valid=!1}},s.Texture.prototype._updateUvs=function(){this._uvs||(this._uvs=new s.TextureUvs);var t=this.crop,e=this.baseTexture.width,i=this.baseTexture.height;this._uvs.x0=t.x/e,this._uvs.y0=t.y/i,this._uvs.x1=(t.x+t.width)/e,this._uvs.y1=t.y/i,this._uvs.x2=(t.x+t.width)/e,this._uvs.y2=(t.y+t.height)/i,this._uvs.x3=t.x/e,this._uvs.y3=(t.y+t.height)/i},s.Texture.prototype._updateUvsInverted=function(){this._uvs||(this._uvs=new s.TextureUvs);var t=this.crop,e=this.baseTexture.width,i=this.baseTexture.height;this._uvs.x0=t.x/e,this._uvs.y0=t.y/i,this._uvs.x1=(t.x+t.height)/e,this._uvs.y1=t.y/i,this._uvs.x2=(t.x+t.height)/e,this._uvs.y2=(t.y+t.width)/i,this._uvs.x3=t.x/e,this._uvs.y3=(t.y+t.width)/i},s.Texture.fromCanvas=function(t,e){var i=s.BaseTexture.fromCanvas(t,e);return new s.Texture(i)},s.TextureUvs=function(){this.x0=0,this.y0=0,this.x1=0,this.y1=0,this.x2=0,this.y2=0,this.x3=0,this.y3=0},"undefined"!=typeof exports?("undefined"!=typeof module&&module.exports&&(exports=module.exports=s),exports.PIXI=s):"undefined"!=typeof define&&define.amd?define("PIXI",i.PIXI=s):i.PIXI=s,s}.call(this),function(){var t=this,e=e||{VERSION:"2.12.0",GAMES:[],AUTO:0,CANVAS:1,WEBGL:2,HEADLESS:3,WEBGL_MULTI:4,NONE:0,LEFT:1,RIGHT:2,UP:3,DOWN:4,SPRITE:0,BUTTON:1,IMAGE:2,GRAPHICS:3,TEXT:4,TILESPRITE:5,BITMAPTEXT:6,GROUP:7,RENDERTEXTURE:8,TILEMAP:9,TILEMAPLAYER:10,EMITTER:11,POLYGON:12,BITMAPDATA:13,CANVAS_FILTER:14,WEBGL_FILTER:15,ELLIPSE:16,SPRITEBATCH:17,RETROFONT:18,POINTER:19,ROPE:20,CIRCLE:21,RECTANGLE:22,LINE:23,MATRIX:24,POINT:25,ROUNDEDRECTANGLE:26,CREATURE:27,VIDEO:28,PENDING_ATLAS:-1,HORIZONTAL:0,VERTICAL:1,LANDSCAPE:0,PORTRAIT:1,ANGLE_UP:270,ANGLE_DOWN:90,ANGLE_LEFT:180,ANGLE_RIGHT:0,ANGLE_NORTH_EAST:315,ANGLE_NORTH_WEST:225,ANGLE_SOUTH_EAST:45,ANGLE_SOUTH_WEST:135,TOP_LEFT:0,TOP_CENTER:1,TOP_RIGHT:2,LEFT_TOP:3,LEFT_CENTER:4,LEFT_BOTTOM:5,CENTER:6,RIGHT_TOP:7,RIGHT_CENTER:8,RIGHT_BOTTOM:9,BOTTOM_LEFT:10,BOTTOM_CENTER:11,BOTTOM_RIGHT:12,blendModes:{NORMAL:0,ADD:1,MULTIPLY:2,SCREEN:3,OVERLAY:4,DARKEN:5,LIGHTEN:6,COLOR_DODGE:7,COLOR_BURN:8,HARD_LIGHT:9,SOFT_LIGHT:10,DIFFERENCE:11,EXCLUSION:12,HUE:13,SATURATION:14,COLOR:15,LUMINOSITY:16},scaleModes:{DEFAULT:0,LINEAR:0,NEAREST:1},PIXI:PIXI||{},_UID:0};if("undefined"!=typeof AudioBufferSourceNode&&(AudioBufferSourceNode.prototype.start||(AudioBufferSourceNode.prototype.start=AudioBufferSourceNode.prototype.noteGrainOn),AudioBufferSourceNode.prototype.stop||(AudioBufferSourceNode.prototype.stop=AudioBufferSourceNode.prototype.noteOff)),Math.trunc||(Math.trunc=function(t){return t<0?Math.ceil(t):Math.floor(t)}),Function.prototype.bind||(Function.prototype.bind=function(){var t=Array.prototype.slice;return function(e){function i(){var r=n.concat(t.call(arguments));s.apply(this instanceof i?this:e,r)}var s=this,n=t.call(arguments,1);if("function"!=typeof s)throw new TypeError;return i.prototype=function t(e){if(e&&(t.prototype=e),!(this instanceof t))return new t}(s.prototype),i}}()),Array.isArray||(Array.isArray=function(t){return"[object Array]"===Object.prototype.toString.call(t)}),Array.prototype.forEach||(Array.prototype.forEach=function(t){"use strict";if(void 0===this||null===this)throw new TypeError;var e=Object(this),i=e.length>>>0;if("function"!=typeof t)throw new TypeError;for(var s=arguments.length>=2?arguments[1]:void 0,n=0;n<i;n++)n in e&&t.call(s,e[n],n,e)}),"function"!=typeof window.Uint32Array&&"object"!=typeof window.Uint32Array){var i=function(t){var e=new Array;window[t]=function(t){if("number"==typeof t){Array.call(this,t),this.length=t;for(e=0;e<this.length;e++)this[e]=0}else{Array.call(this,t.length),this.length=t.length;for(var e=0;e<this.length;e++)this[e]=t[e]}},window[t].prototype=e,window[t].constructor=window[t]};i("Float32Array"),i("Uint32Array"),i("Uint16Array"),i("Int16Array"),i("ArrayBuffer")}window.console||(window.console={},window.console.log=window.console.assert=function(){},window.console.warn=window.console.assert=function(){}),Object.assign||(Object.assign=function(t,e){"use strict";if(null==t)throw new TypeError("Cannot convert undefined or null to object");for(var i=Object(t),s=Object.prototype.hasOwnProperty,n=1;n<arguments.length;n++){var r=arguments[n];if(null!=r)for(var o in r)s.call(r,o)&&(i[o]=r[o])}return i}),e.Utils={defaults:function(t,e){for(var i=Object.keys(e),s=0,n=i.length;s<n;s++){var r=i[s];void 0===t[r]&&(t[r]=e[r])}return t},reverseString:function(t){return t.split("").reverse().join("")},getProperty:function(t,e){var i=e.split(".");switch(i.length){case 1:return t[e];case 2:return t[i[0]][i[1]];case 3:return t[i[0]][i[1]][i[2]];case 4:return t[i[0]][i[1]][i[2]][i[3]];default:return this._getProperty(t,e)}},setProperties:function(t,e){for(var i in e)this.setProperty(t,i,e[i]);return t},setProperty:function(t,e,i){var s=e.split(".");switch(s.length){case 1:t[e]=i;break;case 2:t[s[0]][s[1]]=i;break;case 3:t[s[0]][s[1]][s[2]]=i;break;case 4:t[s[0]][s[1]][s[2]][s[3]]=i;break;default:this._setProperty(t,e,i)}},_getProperty:function(t,e){for(var i=e.split("."),s=i.length,n=0,r=t;n<s;){var o=i[n];if(null==r)return;r=r[o],n++}return r},_setProperty:function(t,e,i){var s=e.split("."),n=s.length,r=0,o=t,a=s[0];if(1===n)t[e]=i;else{for(;r<n-1;)o=o[a],a=s[++r];o[a]=i}return t},chanceRoll:function(t){return void 0===t&&(t=50),t>0&&100*Math.random()<=t},randomChoice:function(t,e){return Math.random()<.5?t:e},parseDimension:function(t,e){var i=0,s=0;return"string"==typeof t?"%"===t.substr(-1)?(i=parseInt(t,10)/100,s=0===e?window.innerWidth*i:window.innerHeight*i):s=parseInt(t,10):s=t,s},pad:function(t,e,i,s){if(void 0===e)var e=0;if(void 0===i)var i=" ";if(void 0===s)var s=3;var n=0;if(e+1>=(t=t.toString()).length)switch(s){case 1:t=new Array(e+1-t.length).join(i)+t;break;case 3:var r=Math.ceil((n=e-t.length)/2),o=n-r;t=new Array(o+1).join(i)+t+new Array(r+1).join(i);break;default:t+=new Array(e+1-t.length).join(i)}return t},isPlainObject:function(t){if("object"!=typeof t||t.nodeType||t===t.window)return!1;try{if(t.constructor&&!{}.hasOwnProperty.call(t.constructor.prototype,"isPrototypeOf"))return!1}catch(t){return!1}return!0},extend:function(){var t,i,s,n,r,o,a=arguments[0]||{},h=1,l=arguments.length,c=!1;for("boolean"==typeof a&&(c=a,a=arguments[1]||{},h=2),l===h&&(a=this,--h);h<l;h++)if(null!=(t=arguments[h]))for(i in t)s=a[i],a!==(n=t[i])&&(c&&n&&(e.Utils.isPlainObject(n)||(r=Array.isArray(n)))?(r?(r=!1,o=s&&Array.isArray(s)?s:[]):o=s&&e.Utils.isPlainObject(s)?s:{},a[i]=e.Utils.extend(c,o,n)):void 0!==n&&(a[i]=n));return a},mixinPrototype:function(t,e,i){void 0===i&&(i=!1);for(var s=Object.keys(e),n=0;n<s.length;n++){var r=s[n],o=e[r];!i&&r in t||(!o||"function"!=typeof o.get&&"function"!=typeof o.set?t[r]=o:"function"==typeof o.clone?t[r]=o.clone():Object.defineProperty(t,r,o))}},mixin:function(t,i){if(!t||"object"!=typeof t)return i;for(var s in t){var n=t[s];if(!n.childNodes&&!n.cloneNode){var r=typeof t[s];t[s]&&"object"===r?typeof i[s]===r?i[s]=e.Utils.mixin(t[s],i[s]):i[s]=e.Utils.mixin(t[s],new n.constructor):i[s]=t[s]}}return i}},e.Circle=function(t,i,s){t=t||0,i=i||0,s=s||0,this.x=t,this.y=i,this._diameter=s,this._radius=0,s>0&&(this._radius=.5*s),this.type=e.CIRCLE},e.Circle.prototype={circumference:function(){return Math.PI*this._radius*2},random:function(t){void 0===t&&(t=new e.Point);var i=2*Math.PI*Math.random(),s=Math.random()+Math.random(),n=s>1?2-s:s,r=n*Math.cos(i),o=n*Math.sin(i);return t.x=this.x+r*this.radius,t.y=this.y+o*this.radius,t},getBounds:function(){return new e.Rectangle(this.x-this.radius,this.y-this.radius,this.diameter,this.diameter)},setTo:function(t,e,i){return this.x=t,this.y=e,this._diameter=i,this._radius=.5*i,this},copyFrom:function(t){return this.setTo(t.x,t.y,t.diameter)},copyTo:function(t){return t.x=this.x,t.y=this.y,t.diameter=this._diameter,t},distance:function(t,i){var s=e.Math.distance(this.x,this.y,t.x,t.y);return i?Math.round(s):s},clone:function(t){return void 0===t||null===t?t=new e.Circle(this.x,this.y,this.diameter):t.setTo(this.x,this.y,this.diameter),t},contains:function(t,i){return e.Circle.contains(this,t,i)},circumferencePoint:function(t,i,s){return e.Circle.circumferencePoint(this,t,i,s)},sample:function(t,i,s,n,r){t||(t=60),null==i&&(i=0),null==s&&(s=e.Math.PI2),r||(r=[]);for(var o=0;o<t;)this.circumferencePoint(e.Math.linear(i,s,o/t),n,r[o]||(r[o]=new e.Point)),o+=1;return r},offset:function(t,e){return this.x+=t,this.y+=e,this},offsetPoint:function(t){return this.offset(t.x,t.y)},toString:function(){return"[{Phaser.Circle (x="+this.x+" y="+this.y+" diameter="+this.diameter+" radius="+this.radius+")}]"}},e.Circle.prototype.constructor=e.Circle,Object.defineProperty(e.Circle.prototype,"diameter",{get:function(){return this._diameter},set:function(t){t>0&&(this._diameter=t,this._radius=.5*t)}}),Object.defineProperty(e.Circle.prototype,"radius",{get:function(){return this._radius},set:function(t){t>0&&(this._radius=t,this._diameter=2*t)}}),Object.defineProperty(e.Circle.prototype,"left",{get:function(){return this.x-this._radius},set:function(t){t>this.x?(this._radius=0,this._diameter=0):this.radius=this.x-t}}),Object.defineProperty(e.Circle.prototype,"right",{get:function(){return this.x+this._radius},set:function(t){t<this.x?(this._radius=0,this._diameter=0):this.radius=t-this.x}}),Object.defineProperty(e.Circle.prototype,"top",{get:function(){return this.y-this._radius},set:function(t){t>this.y?(this._radius=0,this._diameter=0):this.radius=this.y-t}}),Object.defineProperty(e.Circle.prototype,"bottom",{get:function(){return this.y+this._radius},set:function(t){t<this.y?(this._radius=0,this._diameter=0):this.radius=t-this.y}}),Object.defineProperty(e.Circle.prototype,"area",{get:function(){return this._radius>0?Math.PI*this._radius*this._radius:0}}),Object.defineProperty(e.Circle.prototype,"empty",{get:function(){return 0===this._diameter},set:function(t){!0===t&&this.setTo(0,0,0)}}),e.Circle.contains=function(t,e,i){return t.radius>0&&e>=t.left&&e<=t.right&&i>=t.top&&i<=t.bottom&&(t.x-e)*(t.x-e)+(t.y-i)*(t.y-i)<=t.radius*t.radius},e.Circle.equals=function(t,e){return t.x===e.x&&t.y===e.y&&t.diameter===e.diameter},e.Circle.intersects=function(t,i){return e.Math.distance(t.x,t.y,i.x,i.y)<=t.radius+i.radius},e.Circle.circumferencePoint=function(t,i,s,n){return void 0===s&&(s=!1),void 0===n&&(n=new e.Point),!0===s&&(i=e.Math.degToRad(i)),n.x=t.x+t.radius*Math.cos(i),n.y=t.y+t.radius*Math.sin(i),n},e.Circle.intersectsRectangle=function(t,e){var i=Math.abs(t.x-e.x-e.halfWidth);if(i>e.halfWidth+t.radius)return!1;var s=Math.abs(t.y-e.y-e.halfHeight);if(s>e.halfHeight+t.radius)return!1;if(i<=e.halfWidth||s<=e.halfHeight)return!0;var n=i-e.halfWidth,r=s-e.halfHeight;return n*n+r*r<=t.radius*t.radius},e.Circle.intersectsLine=function(t,i,s){var n=t.x,r=t.y,o=(i.end.y-i.start.y)/(i.end.x-i.start.x),a=i.end.y-o*i.end.x,h=t.radius,l=t.radius,c=a+o*n,u=(n*(l*l)-o*(h*h)*(a-r)+h*l*Math.sqrt(h*h*(o*o)+l*l-c*c-r*r+2*c*r))/(h*h*(o*o)+l*l),d=(n*(l*l)-o*(h*h)*(a-r)-h*l*Math.sqrt(h*h*(o*o)+l*l-c*c-r*r+2*c*r))/(h*h*(o*o)+l*l),p=o*u+a,f=o*d+a,g=new e.Point(u,p),m=new e.Point(d,f),y=i.pointOnSegment(g.x,g.y,.01),v=i.pointOnSegment(m.x,m.y,.01);return y&&v?!s||[g,m]:y?!s||[g]:v?!s||[m]:!!s&&[]},PIXI.Circle=e.Circle,e.Ellipse=function(t,i,s,n){t=t||0,i=i||0,s=s||0,n=n||0,this.x=t,this.y=i,this.width=s,this.height=n,this.type=e.ELLIPSE},e.Ellipse.prototype={setTo:function(t,e,i,s){return this.x=t,this.y=e,this.width=i,this.height=s,this},getBounds:function(){return new e.Rectangle(this.x-this.width,this.y-this.height,this.width,this.height)},copyFrom:function(t){return this.setTo(t.x,t.y,t.width,t.height)},copyTo:function(t){return t.x=this.x,t.y=this.y,t.width=this.width,t.height=this.height,t},clone:function(t){return void 0===t||null===t?t=new e.Ellipse(this.x,this.y,this.width,this.height):t.setTo(this.x,this.y,this.width,this.height),t},contains:function(t,i){return e.Ellipse.contains(this,t,i)},random:function(t){void 0===t&&(t=new e.Point);var i=Math.random()*Math.PI*2,s=Math.sqrt(Math.random());return t.x=this.centerX+.5*s*Math.cos(i)*this.width,t.y=this.centerY+.5*s*Math.sin(i)*this.height,t},toString:function(){return"[{Phaser.Ellipse (x="+this.x+" y="+this.y+" width="+this.width+" height="+this.height+")}]"}},e.Ellipse.prototype.constructor=e.Ellipse,Object.defineProperty(e.Ellipse.prototype,"left",{get:function(){return this.x},set:function(t){this.x=t}}),Object.defineProperty(e.Ellipse.prototype,"right",{get:function(){return this.x+this.width},set:function(t){t<this.x?this.width=0:this.width=t-this.x}}),Object.defineProperty(e.Ellipse.prototype,"top",{get:function(){return this.y},set:function(t){this.y=t}}),Object.defineProperty(e.Ellipse.prototype,"bottom",{get:function(){return this.y+this.height},set:function(t){t<this.y?this.height=0:this.height=t-this.y}}),Object.defineProperty(e.Ellipse.prototype,"centerX",{get:function(){return this.x+.5*this.width}}),Object.defineProperty(e.Ellipse.prototype,"centerY",{get:function(){return this.y+.5*this.height}}),Object.defineProperty(e.Ellipse.prototype,"empty",{get:function(){return 0===this.width||0===this.height},set:function(t){!0===t&&this.setTo(0,0,0,0)}}),e.Ellipse.contains=function(t,e,i){if(t.width<=0||t.height<=0)return!1;var s=(e-t.x)/t.width-.5,n=(i-t.y)/t.height-.5;return s*=s,n*=n,s+n<.25},e.Ellipse.intersectsLine=function(t,i,s){var n=t.x,r=t.y,o=(i.end.y-i.start.y)/(i.end.x-i.start.x),a=i.end.y-o*i.end.x,h=t.width/2,l=t.height/2,c=a+o*n,u=(n*(l*l)-o*(h*h)*(a-r)+h*l*Math.sqrt(h*h*(o*o)+l*l-c*c-r*r+2*c*r))/(h*h*(o*o)+l*l),d=(n*(l*l)-o*(h*h)*(a-r)-h*l*Math.sqrt(h*h*(o*o)+l*l-c*c-r*r+2*c*r))/(h*h*(o*o)+l*l),p=o*u+a,f=o*d+a,g=new e.Point(u,p),m=new e.Point(d,f),y=i.pointOnSegment(g.x,g.y,.01),v=i.pointOnSegment(m.x,m.y,.01);return y&&v?!s||[g,m]:y?!s||[g]:v?!s||[m]:!!s&&[]},PIXI.Ellipse=e.Ellipse,e.Line=function(t,i,s,n){t=t||0,i=i||0,s=s||0,n=n||0,this.start=new e.Point(t,i),this.end=new e.Point(s,n),this.type=e.LINE},e.Line.prototype={setTo:function(t,e,i,s){return this.start.setTo(t,e),this.end.setTo(i,s),this},fromPoints:function(t,e){return this.setTo(t.x,t.y,e.x,e.y),this},fromSprite:function(t,e,i){return void 0===i&&(i=!1),i?this.setTo(t.centerX,t.centerY,e.centerX,e.centerY):this.fromPoints(t,e)},fromAngle:function(t,e,i,s){return this.start.setTo(t,e),this.end.setTo(t+Math.cos(i)*s,e+Math.sin(i)*s),this},rotate:function(t,e){var i=(this.start.x+this.end.x)/2,s=(this.start.y+this.end.y)/2;return this.start.rotate(i,s,t,e),this.end.rotate(i,s,t,e),this},rotateAround:function(t,e,i,s){return this.start.rotate(t,e,i,s),this.end.rotate(t,e,i,s),this},intersects:function(t,i,s){return e.Line.intersectsPoints(this.start,this.end,t.start,t.end,i,s)},reflect:function(t){return e.Line.reflect(this,t)},midPoint:function(t){return void 0===t&&(t=new e.Point),t.x=(this.start.x+this.end.x)/2,t.y=(this.start.y+this.end.y)/2,t},centerOn:function(t,e){var i=t-(this.start.x+this.end.x)/2,s=e-(this.start.y+this.end.y)/2;this.start.add(i,s),this.end.add(i,s)},pointOnLine:function(t,i,s){return e.Math.fuzzyEqual((t-this.start.x)*(this.end.y-this.start.y),(this.end.x-this.start.x)*(i-this.start.y),s||0)},pointOnSegment:function(t,e,i){var s=Math.min(this.start.x,this.end.x),n=Math.max(this.start.x,this.end.x),r=Math.min(this.start.y,this.end.y),o=Math.max(this.start.y,this.end.y);return this.pointOnLine(t,e,i)&&t>=s&&t<=n&&e>=r&&e<=o},random:function(t){void 0===t&&(t=new e.Point);var i=Math.random();return t.x=this.start.x+i*(this.end.x-this.start.x),t.y=this.start.y+i*(this.end.y-this.start.y),t},coordinatesOnLine:function(t,e){void 0===t&&(t=1),void 0===e&&(e=[]);var i=Math.round(this.start.x),s=Math.round(this.start.y),n=Math.round(this.end.x),r=Math.round(this.end.y),o=Math.abs(n-i),a=Math.abs(r-s),h=i<n?1:-1,l=s<r?1:-1,c=o-a;e.push([i,s]);for(var u=1;i!==n||s!==r;){var d=c<<1;d>-a&&(c-=a,i+=h),d<o&&(c+=o,s+=l),u%t==0&&e.push([i,s]),u++}return e},clone:function(t){return void 0===t||null===t?t=new e.Line(this.start.x,this.start.y,this.end.x,this.end.y):t.setTo(this.start.x,this.start.y,this.end.x,this.end.y),t}},Object.defineProperty(e.Line.prototype,"length",{get:function(){return Math.sqrt((this.end.x-this.start.x)*(this.end.x-this.start.x)+(this.end.y-this.start.y)*(this.end.y-this.start.y))}}),Object.defineProperty(e.Line.prototype,"angle",{get:function(){return e.Point.angle(this.end,this.start)}}),Object.defineProperty(e.Line.prototype,"slope",{get:function(){return(this.end.y-this.start.y)/(this.end.x-this.start.x)}}),Object.defineProperty(e.Line.prototype,"perpSlope",{get:function(){return-(this.end.x-this.start.x)/(this.end.y-this.start.y)}}),Object.defineProperty(e.Line.prototype,"x",{get:function(){return Math.min(this.start.x,this.end.x)}}),Object.defineProperty(e.Line.prototype,"y",{get:function(){return Math.min(this.start.y,this.end.y)}}),Object.defineProperty(e.Line.prototype,"left",{get:function(){return Math.min(this.start.x,this.end.x)}}),Object.defineProperty(e.Line.prototype,"right",{get:function(){return Math.max(this.start.x,this.end.x)}}),Object.defineProperty(e.Line.prototype,"top",{get:function(){return Math.min(this.start.y,this.end.y)}}),Object.defineProperty(e.Line.prototype,"bottom",{get:function(){return Math.max(this.start.y,this.end.y)}}),Object.defineProperty(e.Line.prototype,"width",{get:function(){return Math.abs(this.start.x-this.end.x)}}),Object.defineProperty(e.Line.prototype,"height",{get:function(){return Math.abs(this.start.y-this.end.y)}}),Object.defineProperty(e.Line.prototype,"normalX",{get:function(){return Math.cos(this.angle-1.5707963267948966)}}),Object.defineProperty(e.Line.prototype,"normalY",{get:function(){return Math.sin(this.angle-1.5707963267948966)}}),Object.defineProperty(e.Line.prototype,"normalAngle",{get:function(){return e.Math.wrap(this.angle-1.5707963267948966,-Math.PI,Math.PI)}}),e.Line.intersectsPoints=function(t,i,s,n,r,o){void 0===r&&(r=!0),void 0===o&&(o=new e.Point);var a=i.y-t.y,h=n.y-s.y,l=t.x-i.x,c=s.x-n.x,u=i.x*t.y-t.x*i.y,d=n.x*s.y-s.x*n.y,p=a*c-h*l;if(0===p)return null;if(o.x=(l*d-c*u)/p,o.y=(h*u-a*d)/p,r){var f=(n.y-s.y)*(i.x-t.x)-(n.x-s.x)*(i.y-t.y),g=((n.x-s.x)*(t.y-s.y)-(n.y-s.y)*(t.x-s.x))/f,m=((i.x-t.x)*(t.y-s.y)-(i.y-t.y)*(t.x-s.x))/f;return g>=0&&g<=1&&m>=0&&m<=1?o:null}return o},e.Line.intersects=function(t,i,s,n){return e.Line.intersectsPoints(t.start,t.end,i.start,i.end,s,n)},e.Line.intersectsRectangle=function(t,e){if(0===t.length||e.empty)return!1;var i=t.start.x,s=t.start.y,n=t.end.x,r=t.end.y,o=e.x,a=e.y,h=e.right,l=e.bottom,c=0;if(i>=o&&i<=h&&s>=a&&s<=l||n>=o&&n<=h&&r>=a&&r<=l)return!0;if(i<o&&n>=o){if((c=s+(r-s)*(o-i)/(n-i))>a&&c<=l)return!0}else if(i>h&&n<=h&&(c=s+(r-s)*(h-i)/(n-i))>=a&&c<=l)return!0;if(s<a&&r>=a){if((c=i+(n-i)*(a-s)/(r-s))>=o&&c<=h)return!0}else if(s>l&&r<=l&&(c=i+(n-i)*(l-s)/(r-s))>=o&&c<=h)return!0;return!1},e.Line.intersectionWithRectangle=function(t,i,s){var n=e.Line.intersectionWithRectangle;s||(s=new e.Point),n.edges||(n.edges=[new e.Line,new e.Line,new e.Line,new e.Line]),n.edgeIntersection||(n.edgeIntersection=new e.Point);var r=n.edges,o=n.edgeIntersection.set(0),a=i.x,h=i.y,l=i.right,c=i.bottom,u=1/0;r[0].setTo(a,h,l,h),r[1].setTo(a,c,l,c),r[2].setTo(a,h,a,c),r[3].setTo(l,h,l,c);for(var d,p=0;d=r[p];p++)if(t.intersects(d,!0,o)){var f=t.start.distance(o);f<u&&(u=f,s.copyFrom(o))}return null!=f?s:null},e.Line.reflect=function(t,e){return 2*e.normalAngle-3.141592653589793-t.angle},e.Matrix=function(t,i,s,n,r,o){void 0!==t&&null!==t||(t=1),void 0!==i&&null!==i||(i=0),void 0!==s&&null!==s||(s=0),void 0!==n&&null!==n||(n=1),void 0!==r&&null!==r||(r=0),void 0!==o&&null!==o||(o=0),this.a=t,this.b=i,this.c=s,this.d=n,this.tx=r,this.ty=o,this.type=e.MATRIX},e.Matrix.prototype={fromArray:function(t){return this.setTo(t[0],t[1],t[3],t[4],t[2],t[5])},setTo:function(t,e,i,s,n,r){return this.a=t,this.b=e,this.c=i,this.d=s,this.tx=n,this.ty=r,this},clone:function(t){return void 0===t||null===t?t=new e.Matrix(this.a,this.b,this.c,this.d,this.tx,this.ty):(t.a=this.a,t.b=this.b,t.c=this.c,t.d=this.d,t.tx=this.tx,t.ty=this.ty),t},copyTo:function(t){return t.copyFrom(this),t},copyFrom:function(t){return this.a=t.a,this.b=t.b,this.c=t.c,this.d=t.d,this.tx=t.tx,this.ty=t.ty,this},toArray:function(t,e){return void 0===e&&(e=new Float32Array(9)),t?(e[0]=this.a,e[1]=this.b,e[2]=0,e[3]=this.c,e[4]=this.d,e[5]=0,e[6]=this.tx,e[7]=this.ty,e[8]=1):(e[0]=this.a,e[1]=this.c,e[2]=this.tx,e[3]=this.b,e[4]=this.d,e[5]=this.ty,e[6]=0,e[7]=0,e[8]=1),e},apply:function(t,i){return void 0===i&&(i=new e.Point),i.x=this.a*t.x+this.c*t.y+this.tx,i.y=this.b*t.x+this.d*t.y+this.ty,i},applyInverse:function(t,i){void 0===i&&(i=new e.Point);var s=1/(this.a*this.d+this.c*-this.b),n=t.x,r=t.y;return i.x=this.d*s*n+-this.c*s*r+(this.ty*this.c-this.tx*this.d)*s,i.y=this.a*s*r+-this.b*s*n+(-this.ty*this.a+this.tx*this.b)*s,i},translate:function(t,e){return this.tx+=t,this.ty+=e,this},scale:function(t,e){return this.a*=t,this.d*=e,this.c*=t,this.b*=e,this.tx*=t,this.ty*=e,this},rotate:function(t){var e=Math.cos(t),i=Math.sin(t),s=this.a,n=this.c,r=this.tx;return this.a=s*e-this.b*i,this.b=s*i+this.b*e,this.c=n*e-this.d*i,this.d=n*i+this.d*e,this.tx=r*e-this.ty*i,this.ty=r*i+this.ty*e,this},append:function(t){var e=this.a,i=this.b,s=this.c,n=this.d;return this.a=t.a*e+t.b*s,this.b=t.a*i+t.b*n,this.c=t.c*e+t.d*s,this.d=t.c*i+t.d*n,this.tx=t.tx*e+t.ty*s+this.tx,this.ty=t.tx*i+t.ty*n+this.ty,this},identity:function(){return this.setTo(1,0,0,1,0,0)}},e.identityMatrix=new e.Matrix,e.Point=function(t,i){t=t||0,i=i||0,this.x=t,this.y=i,this.type=e.POINT},e.Point.prototype={copyFrom:function(t){return this.setTo(t.x,t.y)},invert:function(){return this.setTo(this.y,this.x)},setTo:function(t,i){return e.Point.set(this,t,i)},set:function(t,i){return e.Point.set(this,t,i)},setToPolar:function(t,i,s){return null==i&&(i=1),s&&(t=e.Math.degToRad(t)),this.setTo(Math.cos(t)*i,Math.sin(t)*i)},add:function(t,e){return this.x+=t,this.y+=e,this},subtract:function(t,e){return this.x-=t,this.y-=e,this},multiply:function(t,e){return this.x*=t,this.y*=e,this},divide:function(t,e){return this.x/=t,this.y/=e,this},clampX:function(t,i){return this.x=e.Math.clamp(this.x,t,i),this},clampY:function(t,i){return this.y=e.Math.clamp(this.y,t,i),this},clamp:function(t,i){return this.x=e.Math.clamp(this.x,t,i),this.y=e.Math.clamp(this.y,t,i),this},clip:function(t){var e=t.left,i=t.top,s=t.right,n=t.bottom;return this.x<e?this.x=e:this.x>s&&(this.x=s),this.y<i?this.y=i:this.y>n&&(this.y=n),this},clone:function(t){return void 0===t||null===t?t=new e.Point(this.x,this.y):t.setTo(this.x,this.y),t},copyTo:function(t){return t.x=this.x,t.y=this.y,t},distance:function(t,i){return e.Point.distance(this,t,i)},equals:function(t){return t.x===this.x&&t.y===this.y},equalsXY:function(t,e){return this.x===t&&this.y===e},fuzzyEquals:function(t,i){return e.Point.fuzzyEquals(this,t,i)},fuzzyEqualsXY:function(t,i,s){return e.Point.fuzzyEqualsXY(this,t,i,s)},angle:function(t,e){return this.angleXY(t.x,t.y,e)},angleXY:function(t,i,s){var n=Math.atan2(i-this.y,t-this.x);return s?e.Math.radToDeg(n):n},atan:function(t){var i=Math.atan2(this.y,this.x);return t?e.Math.radToDeg(i):i},rotate:function(t,i,s,n,r){return e.Point.rotate(this,t,i,s,n,r)},getMagnitude:function(){return Math.sqrt(this.x*this.x+this.y*this.y)},getMagnitudeSq:function(){return this.x*this.x+this.y*this.y},setMagnitude:function(t){return this.normalize().multiply(t,t)},normalize:function(){if(!this.isZero()){var t=this.getMagnitude();this.x/=t,this.y/=t}return this},limit:function(t){return this.getMagnitudeSq()>t*t&&this.setMagnitude(t),this},expand:function(t){return this.getMagnitudeSq()<t*t&&this.setMagnitude(t),this},isZero:function(){return 0===this.x&&0===this.y},dot:function(t){return this.x*t.x+this.y*t.y},cross:function(t){return this.x*t.y-this.y*t.x},perp:function(){return this.setTo(-this.y,this.x)},rperp:function(){return this.setTo(this.y,-this.x)},normalRightHand:function(){return this.setTo(-1*this.y,this.x)},floor:function(){return this.setTo(Math.floor(this.x),Math.floor(this.y))},ceil:function(){return this.setTo(Math.ceil(this.x),Math.ceil(this.y))},round:function(){return this.setTo(Math.round(this.x),Math.round(this.y))},toString:function(){return"[{Point (x="+this.x+" y="+this.y+")}]"}},e.Point.prototype.constructor=e.Point,e.Point.add=function(t,i,s){return void 0===s&&(s=new e.Point),s.x=t.x+i.x,s.y=t.y+i.y,s},e.Point.subtract=function(t,i,s){return void 0===s&&(s=new e.Point),s.x=t.x-i.x,s.y=t.y-i.y,s},e.Point.multiply=function(t,i,s){return void 0===s&&(s=new e.Point),s.x=t.x*i.x,s.y=t.y*i.y,s},e.Point.divide=function(t,i,s){return void 0===s&&(s=new e.Point),s.x=t.x/i.x,s.y=t.y/i.y,s},e.Point.equals=function(t,e){return t.x===e.x&&t.y===e.y},e.Point.equalsXY=function(t,e,i){return t.x===e&&t.y===i},e.Point.fuzzyEquals=function(t,i,s){return e.Math.fuzzyEquals(t.x,i.x,s)&&e.Math.fuzzyEquals(t.y,i.y,s)},e.Point.fuzzyEqualsXY=function(t,i,s,n){return e.Math.fuzzyEquals(t.x,i,n)&&e.Math.fuzzyEquals(t.y,s,n)},e.Point.angle=function(t,e){return Math.atan2(t.y-e.y,t.x-e.x)},e.Point.negative=function(t,i){return void 0===i&&(i=new e.Point),i.setTo(-t.x,-t.y)},e.Point.multiplyAdd=function(t,i,s,n){return void 0===n&&(n=new e.Point),n.setTo(t.x+i.x*s,t.y+i.y*s)},e.Point.interpolate=function(t,i,s,n){return void 0===n&&(n=new e.Point),n.setTo(t.x+(i.x-t.x)*s,t.y+(i.y-t.y)*s)},e.Point.perp=function(t,i){return void 0===i&&(i=new e.Point),i.setTo(-t.y,t.x)},e.Point.rperp=function(t,i){return void 0===i&&(i=new e.Point),i.setTo(t.y,-t.x)},e.Point.distance=function(t,i,s){var n=e.Math.distance(t.x,t.y,i.x,i.y);return s?Math.round(n):n},e.Point.project=function(t,i,s){void 0===s&&(s=new e.Point);var n=t.dot(i)/i.getMagnitudeSq();return 0!==n&&s.setTo(n*i.x,n*i.y),s},e.Point.projectUnit=function(t,i,s){void 0===s&&(s=new e.Point);var n=t.dot(i);return 0!==n&&s.setTo(n*i.x,n*i.y),s},e.Point.normalRightHand=function(t,i){return void 0===i&&(i=new e.Point),i.setTo(-1*t.y,t.x)},e.Point.normalize=function(t,i){void 0===i&&(i=new e.Point);var s=t.getMagnitude();return 0!==s&&i.setTo(t.x/s,t.y/s),i},e.Point.rotate=function(t,i,s,n,r,o){if(r&&(n=e.Math.degToRad(n)),void 0===o){t.subtract(i,s);var a=Math.sin(n),h=Math.cos(n),l=h*t.x-a*t.y,c=a*t.x+h*t.y;t.x=l+i,t.y=c+s}else{var u=n+Math.atan2(t.y-s,t.x-i);t.x=i+o*Math.cos(u),t.y=s+o*Math.sin(u)}return t},e.Point.centroid=function(t,i){if(void 0===i&&(i=new e.Point),"[object Array]"!==Object.prototype.toString.call(t))throw new Error("Phaser.Point. Parameter 'points' must be an array");var s=t.length;if(s<1)throw new Error("Phaser.Point. Parameter 'points' array must not be empty");if(1===s)return i.copyFrom(t[0]),i;for(var n=0;n<s;n++)e.Point.add(i,t[n],i);return i.divide(s,s),i},e.Point.parse=function(t,i,s){i=i||"x",s=s||"y";var n=new e.Point;return t[i]&&(n.x=parseFloat(t[i],10)),t[s]&&(n.y=parseFloat(t[s],10)),n},e.Point.trunc=function(t){return t.x=e.Math.trunc(t.x),t.y=e.Math.trunc(t.y),t},e.Point.isPoint=function(t){return null!=t&&"number"==typeof t.x&&"number"==typeof t.y},e.Point.set=function(t,e,i){return t.x=e||0,t.y=i||(0!==i?t.x:0),t},e.Point.sortClockwise=function(t,e){e||(e=this.centroid(t));var i=e.x,s=e.y;return t.sort(function(t,e){if(t.x-i>=0&&e.x-i<0)return-1;if(t.x-i<0&&e.x-i>=0)return 1;if(t.x-i==0&&e.x-i==0)return t.y-s>=0||e.y-s>=0?t.y>e.y?1:-1:e.y>t.y?1:-1;var n=(t.x-i)*-(e.y-s)-(e.x-i)*-(t.y-s);return n<0?-1:n>0?1:(t.x-i)*(t.x-i)+(t.y-s)*(t.y-s)>(e.x-i)*(e.x-i)+(e.y-s)*(e.y-s)?-1:1})},PIXI.Point=e.Point,e.Polygon=function(){this.area=0,this._points=[],arguments.length>0&&this.setTo.apply(this,arguments),this.closed=!0,this.flattened=!1,this.type=e.POLYGON},e.Polygon.prototype={toNumberArray:function(t){void 0===t&&(t=[]);for(var e=0;e<this._points.length;e++)"number"==typeof this._points[e]?(t.push(this._points[e]),t.push(this._points[e+1]),e++):(t.push(this._points[e].x),t.push(this._points[e].y));return t},flatten:function(){return this._points=this.toNumberArray(),this.flattened=!0,this},clone:function(t){var i=this._points.slice();return void 0===t||null===t?t=new e.Polygon(i):t.setTo(i),t},contains:function(t,e){var i=!1;if(this.flattened)for(var s=-2,n=this._points.length-2;(s+=2)<this._points.length;n=s){var r=this._points[s],o=this._points[s+1],a=this._points[n],h=this._points[n+1];(o<=e&&e<h||h<=e&&e<o)&&t<(a-r)*(e-o)/(h-o)+r&&(i=!i)}else for(var s=-1,n=this._points.length-1;++s<this._points.length;n=s){var r=this._points[s].x,o=this._points[s].y,a=this._points[n].x,h=this._points[n].y;(o<=e&&e<h||h<=e&&e<o)&&t<(a-r)*(e-o)/(h-o)+r&&(i=!i)}return i},setTo:function(t){if(this.area=0,this._points=[],arguments.length>0){Array.isArray(t)||(t=Array.prototype.slice.call(arguments));for(var e=Number.MAX_VALUE,i=0,s=t.length;i<s;i++){if("number"==typeof t[i]){n=new PIXI.Point(t[i],t[i+1]);i++}else if(Array.isArray(t[i]))n=new PIXI.Point(t[i][0],t[i][1]);else var n=new PIXI.Point(t[i].x,t[i].y);this._points.push(n),n.y<e&&(e=n.y)}this.calculateArea(e)}return this},calculateArea:function(t){for(var e,i,s,n,r=0,o=this._points.length;r<o;r++)e=this._points[r],i=r===o-1?this._points[0]:this._points[r+1],s=(e.y-t+(i.y-t))/2,n=e.x-i.x,this.area+=s*n;return this.area}},e.Polygon.prototype.constructor=e.Polygon,Object.defineProperty(e.Polygon.prototype,"points",{get:function(){return this._points}}),PIXI.Polygon=e.Polygon,e.Rectangle=function(t,i,s,n){t=t||0,i=i||0,s=s||0,n=n||0,this.x=t,this.y=i,this.width=s,this.height=n,this.type=e.RECTANGLE},e.Rectangle.prototype={offset:function(t,e){return this.x+=t,this.y+=e,this},offsetPoint:function(t){return this.offset(t.x,t.y)},setTo:function(t,e,i,s){return this.x=t,this.y=e,this.width=i,this.height=s,this},scale:function(t,e){return void 0===e&&(e=t),this.width*=t,this.height*=e,this},centerOn:function(t,e){return this.centerX=t,this.centerY=e,this},floor:function(){this.x=Math.floor(this.x),this.y=Math.floor(this.y)},floorAll:function(){this.x=Math.floor(this.x),this.y=Math.floor(this.y),this.width=Math.floor(this.width),this.height=Math.floor(this.height)},ceil:function(){this.x=Math.ceil(this.x),this.y=Math.ceil(this.y)},ceilAll:function(){this.x=Math.ceil(this.x),this.y=Math.ceil(this.y),this.width=Math.ceil(this.width),this.height=Math.ceil(this.height)},copyFrom:function(t){return this.setTo(t.x,t.y,t.width,t.height)},copyFromBounds:function(t){return this.setTo(t.left,t.top,t.width,t.height)},copyTo:function(t){return t.x=this.x,t.y=this.y,t.width=this.width,t.height=this.height,t},inflate:function(t,i){return e.Rectangle.inflate(this,t,i)},size:function(t){return e.Rectangle.size(this,t)},resize:function(t,e){return this.width=t,this.height=e,this},clone:function(t){return e.Rectangle.clone(this,t)},contains:function(t,i){return e.Rectangle.contains(this,t,i)},containsRect:function(t){return e.Rectangle.containsRect(t,this)},equals:function(t){return e.Rectangle.equals(this,t)},intersection:function(t,i){return e.Rectangle.intersection(this,t,i)},intersects:function(t){return e.Rectangle.intersects(this,t)},intersectsRaw:function(t,i,s,n,r){return e.Rectangle.intersectsRaw(this,t,i,s,n,r)},union:function(t,i){return e.Rectangle.union(this,t,i)},random:function(t){return void 0===t&&(t=new e.Point),t.x=this.randomX,t.y=this.randomY,t},getPoint:function(t,i){switch(void 0===i&&(i=new e.Point),t){default:case e.TOP_LEFT:return i.set(this.x,this.y);case e.TOP_CENTER:return i.set(this.centerX,this.y);case e.TOP_RIGHT:return i.set(this.right,this.y);case e.LEFT_CENTER:return i.set(this.x,this.centerY);case e.CENTER:return i.set(this.centerX,this.centerY);case e.RIGHT_CENTER:return i.set(this.right,this.centerY);case e.BOTTOM_LEFT:return i.set(this.x,this.bottom);case e.BOTTOM_CENTER:return i.set(this.centerX,this.bottom);case e.BOTTOM_RIGHT:return i.set(this.right,this.bottom)}},sides:function(t,i,s,n){arguments.length||(t=new e.Line,i=new e.Line,s=new e.Line,n=new e.Line);var r=this.x,o=this.y,a=this.right,h=this.bottom;return t.setTo(r,o,a,o),i.setTo(a,o,a,h),s.setTo(r,h,a,h),n.setTo(r,o,r,h),arguments.length?null:[t,i,s,n]},toString:function(){return"[{Rectangle (x="+this.x+" y="+this.y+" width="+this.width+" height="+this.height+" empty="+this.empty+")}]"}},Object.defineProperty(e.Rectangle.prototype,"halfWidth",{get:function(){return Math.round(this.width/2)}}),Object.defineProperty(e.Rectangle.prototype,"halfHeight",{get:function(){return Math.round(this.height/2)}}),Object.defineProperty(e.Rectangle.prototype,"bottom",{get:function(){return this.y+this.height},set:function(t){t<=this.y?this.height=0:this.height=t-this.y}}),Object.defineProperty(e.Rectangle.prototype,"bottomLeft",{get:function(){return new e.Point(this.x,this.bottom)},set:function(t){this.x=t.x,this.bottom=t.y}}),Object.defineProperty(e.Rectangle.prototype,"bottomRight",{get:function(){return new e.Point(this.right,this.bottom)},set:function(t){this.right=t.x,this.bottom=t.y}}),Object.defineProperty(e.Rectangle.prototype,"left",{get:function(){return this.x},set:function(t){t>=this.right?this.width=0:this.width=this.right-t,this.x=t}}),Object.defineProperty(e.Rectangle.prototype,"right",{get:function(){return this.x+this.width},set:function(t){t<=this.x?this.width=0:this.width=t-this.x}}),Object.defineProperty(e.Rectangle.prototype,"volume",{get:function(){return this.width*this.height}}),Object.defineProperty(e.Rectangle.prototype,"perimeter",{get:function(){return 2*this.width+2*this.height}}),Object.defineProperty(e.Rectangle.prototype,"centerX",{get:function(){return this.x+this.halfWidth},set:function(t){this.x=t-this.halfWidth}}),Object.defineProperty(e.Rectangle.prototype,"centerY",{get:function(){return this.y+this.halfHeight},set:function(t){this.y=t-this.halfHeight}}),Object.defineProperty(e.Rectangle.prototype,"randomX",{get:function(){return this.x+Math.random()*this.width}}),Object.defineProperty(e.Rectangle.prototype,"randomY",{get:function(){return this.y+Math.random()*this.height}}),Object.defineProperty(e.Rectangle.prototype,"top",{get:function(){return this.y},set:function(t){t>=this.bottom?(this.height=0,this.y=t):this.height=this.bottom-t}}),Object.defineProperty(e.Rectangle.prototype,"topLeft",{get:function(){return new e.Point(this.x,this.y)},set:function(t){this.x=t.x,this.y=t.y}}),Object.defineProperty(e.Rectangle.prototype,"topRight",{get:function(){return new e.Point(this.x+this.width,this.y)},set:function(t){this.right=t.x,this.y=t.y}}),Object.defineProperty(e.Rectangle.prototype,"empty",{get:function(){return!this.width||!this.height},set:function(t){!0===t&&this.setTo(0,0,0,0)}}),e.Rectangle.prototype.constructor=e.Rectangle,e.Rectangle.inflate=function(t,e,i){return t.x-=e,t.width+=2*e,t.y-=i,t.height+=2*i,t},e.Rectangle.inflatePoint=function(t,i){return e.Rectangle.inflate(t,i.x,i.y)},e.Rectangle.size=function(t,i){return void 0===i||null===i?i=new e.Point(t.width,t.height):i.setTo(t.width,t.height),i},e.Rectangle.clone=function(t,i){return void 0===i||null===i?i=new e.Rectangle(t.x,t.y,t.width,t.height):i.setTo(t.x,t.y,t.width,t.height),i},e.Rectangle.createFromBounds=function(t,i){return void 0!==i&&null!==i||(i=new e.Rectangle(t.x,t.y,t.width,t.height)),i.copyFromBounds(t)},e.Rectangle.contains=function(t,e,i){return!(t.width<=0||t.height<=0)&&(e>=t.x&&e<t.right&&i>=t.y&&i<t.bottom)},e.Rectangle.containsRaw=function(t,e,i,s,n,r){return n>=t&&n<t+i&&r>=e&&r<e+s},e.Rectangle.containsPoint=function(t,i){return e.Rectangle.contains(t,i.x,i.y)},e.Rectangle.containsRect=function(t,e){return!(t.volume>e.volume)&&(t.x>=e.x&&t.y>=e.y&&t.right<e.right&&t.bottom<e.bottom)},e.Rectangle.equals=function(t,e){return t.x===e.x&&t.y===e.y&&t.width===e.width&&t.height===e.height},e.Rectangle.sameDimensions=function(t,e){return t.width===e.width&&t.height===e.height},e.Rectangle.intersection=function(t,i,s){return void 0===s&&(s=new e.Rectangle),e.Rectangle.intersects(t,i)&&(s.x=Math.max(t.x,i.x),s.y=Math.max(t.y,i.y),s.width=Math.min(t.right,i.right)-s.x,s.height=Math.min(t.bottom,i.bottom)-s.y),s},e.Rectangle.intersects=function(t,e){return!(t.width<=0||t.height<=0||e.width<=0||e.height<=0)&&!(t.right<e.x||t.bottom<e.y||t.x>e.right||t.y>e.bottom)},e.Rectangle.intersectsRaw=function(t,e,i,s,n,r){return void 0===r&&(r=0),!(e>t.right+r||i<t.left-r||s>t.bottom+r||n<t.top-r)},e.Rectangle.union=function(t,i,s){return void 0===s&&(s=new e.Rectangle),s.setTo(Math.min(t.x,i.x),Math.min(t.y,i.y),Math.max(t.right,i.right)-Math.min(t.left,i.left),Math.max(t.bottom,i.bottom)-Math.min(t.top,i.top))},e.Rectangle.aabb=function(t,i){void 0===i&&(i=new e.Rectangle);var s=Number.NEGATIVE_INFINITY,n=Number.POSITIVE_INFINITY,r=Number.NEGATIVE_INFINITY,o=Number.POSITIVE_INFINITY;return t.forEach(function(t){t.x>s&&(s=t.x),t.x<n&&(n=t.x),t.y>r&&(r=t.y),t.y<o&&(o=t.y)}),i.setTo(n,o,s-n,r-o),i},PIXI.Rectangle=e.Rectangle,e.EmptyRectangle=new e.Rectangle(0,0,0,0),e.RoundedRectangle=function(t,i,s,n,r){void 0===t&&(t=0),void 0===i&&(i=0),void 0===s&&(s=0),void 0===n&&(n=0),void 0===r&&(r=20),this.x=t,this.y=i,this.width=s,this.height=n,this.radius=r||20,this.type=e.ROUNDEDRECTANGLE},e.RoundedRectangle.prototype={clone:function(){return new e.RoundedRectangle(this.x,this.y,this.width,this.height,this.radius)},contains:function(t,e){if(this.width<=0||this.height<=0)return!1;var i=this.x;if(t>=i&&t<=i+this.width){var s=this.y;if(e>=s&&e<=s+this.height)return!0}return!1}},e.RoundedRectangle.prototype.constructor=e.RoundedRectangle,PIXI.RoundedRectangle=e.RoundedRectangle,e.Camera=function(t,i,s,n,r,o){this.game=t,this.world=t.world,this.id=0,this.view=new e.Rectangle(s,n,r,o),this.bounds=new e.Rectangle(s,n,r,o),this.deadzone=null,this.visible=!0,this.roundPx=!0,this.atLimit={x:!1,y:!1},this.target=null,this.displayObject=null,this.scale=null,this.totalInView=0,this.lerp=new e.Point(1,1),this.onShakeComplete=new e.Signal,this.onFlashComplete=new e.Signal,this.onFadeComplete=new e.Signal,this.fx=null,this._targetPosition=new e.Point,this._edge=0,this._position=new e.Point,this._shake={intensity:0,duration:0,horizontal:!1,vertical:!1,shakeBounds:!0,x:0,y:0},this._fxDuration=0,this._fxType=0,this._fixedView=new e.Rectangle},e.Camera.FOLLOW_LOCKON=0,e.Camera.FOLLOW_PLATFORMER=1,e.Camera.FOLLOW_TOPDOWN=2,e.Camera.FOLLOW_TOPDOWN_TIGHT=3,e.Camera.SHAKE_BOTH=4,e.Camera.SHAKE_HORIZONTAL=5,e.Camera.SHAKE_VERTICAL=6,e.Camera.ENABLE_FX=!0,e.Camera.prototype={boot:function(){this.displayObject=this.game.world,this.scale=this.game.world.scale,this.game.camera=this,e.Graphics&&e.Camera.ENABLE_FX&&(this.fx=new e.Graphics(this.game),this.game.stage.addChild(this.fx))},preUpdate:function(){this.totalInView=0},follow:function(t,i,s,n){void 0===i&&(i=e.Camera.FOLLOW_LOCKON),void 0===s&&(s=1),void 0===n&&(n=1),this.target=t,this.lerp.set(s,n);var r;switch(i){case e.Camera.FOLLOW_PLATFORMER:var o=this.width/8,a=this.height/3;this.deadzone=new e.Rectangle((this.width-o)/2,(this.height-a)/2-.25*a,o,a);break;case e.Camera.FOLLOW_TOPDOWN:r=Math.max(this.width,this.height)/4,this.deadzone=new e.Rectangle((this.width-r)/2,(this.height-r)/2,r,r);break;case e.Camera.FOLLOW_TOPDOWN_TIGHT:r=Math.max(this.width,this.height)/8,this.deadzone=new e.Rectangle((this.width-r)/2,(this.height-r)/2,r,r);break;case e.Camera.FOLLOW_LOCKON:default:this.deadzone=null}},unfollow:function(){this.target=null},focusOn:function(t){this.setPosition(Math.round(t.x-this.view.halfWidth),Math.round(t.y-this.view.halfHeight))},focusOnXY:function(t,e){this.setPosition(Math.round(t-this.view.halfWidth),Math.round(e-this.view.halfHeight))},shake:function(t,i,s,n,r){return void 0===t&&(t=.05),void 0===i&&(i=500),void 0===s&&(s=!0),void 0===n&&(n=e.Camera.SHAKE_BOTH),void 0===r&&(r=!0),!(!s&&this._shake.duration>0)&&(this._shake.intensity=t,this._shake.duration=i,this._shake.shakeBounds=r,this._shake.x=0,this._shake.y=0,this._shake.horizontal=n===e.Camera.SHAKE_BOTH||n===e.Camera.SHAKE_HORIZONTAL,this._shake.vertical=n===e.Camera.SHAKE_BOTH||n===e.Camera.SHAKE_VERTICAL,!0)},flash:function(t,e,i,s){return void 0===t&&(t=16777215),void 0===e&&(e=500),void 0===i&&(i=!1),void 0===s&&(s=1),!(!this.fx||!i&&this._fxDuration>0)&&(this.fx.clear(),this.fx.beginFill(t,s),this.fx.drawRect(0,0,this.width,this.height),this.fx.endFill(),this.fx.alpha=1,this._fxDuration=e,this._fxType=0,!0)},fade:function(t,e,i,s){return void 0===t&&(t=0),void 0===e&&(e=500),void 0===i&&(i=!1),void 0===s&&(s=1),!(!this.fx||!i&&this._fxDuration>0)&&(this.fx.clear(),this.fx.beginFill(t,s),this.fx.drawRect(0,0,this.width,this.height),this.fx.endFill(),this.fx.alpha=0,this._fxDuration=e,this._fxType=1,!0)},update:function(){this._fxDuration>0&&this.updateFX(),this._shake.duration>0&&this.updateShake(),this.bounds&&this.checkBounds(),this.roundPx&&(this.view.floor(),this._shake.x=Math.floor(this._shake.x),this._shake.y=Math.floor(this._shake.y)),this.displayObject.position.x=-this.view.x,this.displayObject.position.y=-this.view.y},updateFX:function(){0===this._fxType?(this.fx.alpha-=this.game.time.elapsedMS/this._fxDuration,this.fx.alpha<=0&&(this._fxDuration=0,this.fx.alpha=0,this.onFlashComplete.dispatch())):(this.fx.alpha+=this.game.time.elapsedMS/this._fxDuration,this.fx.alpha>=1&&(this._fxDuration=0,this.fx.alpha=1,this.onFadeComplete.dispatch()))},updateShake:function(){this._shake.duration-=this.game.time.elapsedMS,this._shake.duration<=0?(this.onShakeComplete.dispatch(),this._shake.x=0,this._shake.y=0):(this._shake.horizontal&&(this._shake.x=this.game.rnd.frac()*this._shake.intensity*this.view.width*2-this._shake.intensity*this.view.width),this._shake.vertical&&(this._shake.y=this.game.rnd.frac()*this._shake.intensity*this.view.height*2-this._shake.intensity*this.view.height))},updateTarget:function(){this._targetPosition.x=this.view.x+this.target.worldPosition.x,this._targetPosition.y=this.view.y+this.target.worldPosition.y,this.deadzone?(this._edge=this._targetPosition.x-this.view.x,this._edge<this.deadzone.left?this.view.x=this.game.math.linear(this.view.x,this._targetPosition.x-this.deadzone.left,this.lerp.x):this._edge>this.deadzone.right&&(this.view.x=this.game.math.linear(this.view.x,this._targetPosition.x-this.deadzone.right,this.lerp.x)),this._edge=this._targetPosition.y-this.view.y,this._edge<this.deadzone.top?this.view.y=this.game.math.linear(this.view.y,this._targetPosition.y-this.deadzone.top,this.lerp.y):this._edge>this.deadzone.bottom&&(this.view.y=this.game.math.linear(this.view.y,this._targetPosition.y-this.deadzone.bottom,this.lerp.y))):(this.view.x=this.game.math.linear(this.view.x,this._targetPosition.x-this.view.halfWidth,this.lerp.x),this.view.y=this.game.math.linear(this.view.y,this._targetPosition.y-this.view.halfHeight,this.lerp.y)),this.bounds&&this.checkBounds(),this.roundPx&&this.view.floor(),this.displayObject.position.x=-this.view.x,this.displayObject.position.y=-this.view.y},setBoundsToWorld:function(){this.bounds&&this.bounds.copyFrom(this.game.world.bounds)},checkBounds:function(){this.atLimit.x=!1,this.atLimit.y=!1;var t=this.view.x+this._shake.x,e=this.view.right+this._shake.x,i=this.view.y+this._shake.y,s=this.view.bottom+this._shake.y;t<=this.bounds.x*this.scale.x?(this.atLimit.x=!0,this.view.x=this.bounds.x*this.scale.x,this._shake.shakeBounds||(this._shake.x=0)):e>=this.bounds.right*this.scale.x&&(this.atLimit.x=!0,this.view.x=this.bounds.right*this.scale.x-this.width,this._shake.shakeBounds||(this._shake.x=0)),i<=this.bounds.top*this.scale.y?(this.atLimit.y=!0,this.view.y=this.bounds.top*this.scale.y,this._shake.shakeBounds||(this._shake.y=0)):s>=this.bounds.bottom*this.scale.y&&(this.atLimit.y=!0,this.view.y=this.bounds.bottom*this.scale.y-this.height,this._shake.shakeBounds||(this._shake.y=0))},setPosition:function(t,e){this.view.x=t,this.view.y=e,this.bounds&&this.checkBounds()},setSize:function(t,e){this.view.width=t,this.view.height=e},reset:function(){this.target=null,this.view.x=0,this.view.y=0,this._shake.duration=0,this._shake.x=0,this._shake.y=0,this.resetFX()},resetFX:function(){this.fx&&(this.fx.clear(),this.fx.alpha=0),this._fxDuration=0}},e.Camera.prototype.constructor=e.Camera,Object.defineProperty(e.Camera.prototype,"x",{get:function(){return this.view.x},set:function(t){this.view.x=t,this.bounds&&this.checkBounds()}}),Object.defineProperty(e.Camera.prototype,"y",{get:function(){return this.view.y},set:function(t){this.view.y=t,this.bounds&&this.checkBounds()}}),Object.defineProperty(e.Camera.prototype,"position",{get:function(){return this._position.set(this.view.x,this.view.y),this._position},set:function(t){void 0!==t.x&&(this.view.x=t.x),void 0!==t.y&&(this.view.y=t.y),this.bounds&&this.checkBounds()}}),Object.defineProperty(e.Camera.prototype,"width",{get:function(){return this.view.width},set:function(t){this.view.width=t}}),Object.defineProperty(e.Camera.prototype,"height",{get:function(){return this.view.height},set:function(t){this.view.height=t}}),Object.defineProperty(e.Camera.prototype,"shakeIntensity",{get:function(){return this._shake.intensity},set:function(t){this._shake.intensity=t}}),Object.defineProperty(e.Camera.prototype,"fixedView",{get:function(){return this._fixedView.setTo(0,0,this.view.width,this.view.height),this._fixedView}}),Object.defineProperty(e.Camera.prototype,"centerX",{get:function(){return this.x+.5*this.width}}),Object.defineProperty(e.Camera.prototype,"centerY",{get:function(){return this.y+.5*this.height}}),e.State=function(){this.game=null,this.key="",this.add=null,this.make=null,this.camera=null,this.cache=null,this.input=null,this.load=null,this.math=null,this.sound=null,this.scale=null,this.stage=null,this.state=null,this.time=null,this.tweens=null,this.world=null,this.particles=null,this.physics=null,this.rnd=null},e.State.prototype={init:function(){},preload:function(){},loadUpdate:function(){},loadRender:function(){},create:function(){},update:function(){},postUpdate:function(){},preRender:function(){},render:function(){},resize:function(){},paused:function(){},resumed:function(){},pauseUpdate:function(){},shutdown:function(){}},e.State.prototype.constructor=e.State,e.StateManager=function(t,i){this.game=t,this.states={},this._pendingState=null,void 0!==i&&null!==i&&(this._pendingState=i),this._clearWorld=!1,this._clearCache=!1,this._created=!1,this._args=[],this.current="",this.onStateChange=new e.Signal,this.onInitCallback=null,this.onPreloadCallback=null,this.onCreateCallback=null,this.onUpdateCallback=null,this.onRenderCallback=null,this.onResizeCallback=null,this.onPreRenderCallback=null,this.onLoadUpdateCallback=null,this.onLoadRenderCallback=null,this.onPausedCallback=null,this.onResumedCallback=null,this.onPauseUpdateCallback=null,this.onShutDownCallback=null},e.StateManager.prototype={boot:function(){this.game.onPause.add(this.pause,this),this.game.onResume.add(this.resume,this),null!==this._pendingState&&"string"!=typeof this._pendingState&&this.add("default",this._pendingState,!0)},add:function(t,i,s){void 0===s&&(s=!1);var n;return i instanceof e.State?n=i:"object"==typeof i?(n=i).game=this.game:"function"==typeof i&&(n=new i(this.game)),this.states[t]=n,s&&(this.game.isBooted?this.start(t):this._pendingState=t),n},remove:function(t){this.current===t&&(this.callbackContext=null,this.onInitCallback=null,this.onShutDownCallback=null,this.onPreloadCallback=null,this.onLoadRenderCallback=null,this.onLoadUpdateCallback=null,this.onCreateCallback=null,this.onUpdateCallback=null,this.onPreRenderCallback=null,this.onRenderCallback=null,this.onResizeCallback=null,this.onPausedCallback=null,this.onResumedCallback=null,this.onPauseUpdateCallback=null),delete this.states[t]},start:function(t,e,i){void 0===e&&(e=!0),void 0===i&&(i=!1),this.checkState(t)&&(this._pendingState=t,this._clearWorld=e,this._clearCache=i,arguments.length>3&&(this._args=Array.prototype.splice.call(arguments,3)))},restart:function(t,e){void 0===t&&(t=!0),void 0===e&&(e=!1),this._pendingState=this.current,this._clearWorld=t,this._clearCache=e,arguments.length>2&&(this._args=Array.prototype.slice.call(arguments,2))},dummy:function(){},preUpdate:function(){if(this._pendingState&&this.game.isBooted){var t=this.current;if(this.clearCurrentState(),this.setCurrentState(this._pendingState),this.onStateChange.dispatch(this.current,t),this.current!==this._pendingState)return;this._pendingState=null,this.onPreloadCallback?(this.game.load.reset(!0),this.onPreloadCallback.call(this.callbackContext,this.game),0===this.game.load.totalQueuedFiles()&&0===this.game.load.totalQueuedPacks()?this.loadComplete():this.game.load.start()):this.loadComplete()}},clearCurrentState:function(){this.current&&(this.onShutDownCallback&&this.onShutDownCallback.call(this.callbackContext,this.game),this.game.tweens.removeAll(),this.game.camera.reset(),this.game.input.reset(!0),this.game.physics.clear(),this.game.time.removeAll(),this.game.scale.reset(this._clearWorld),this.game.debug&&this.game.debug.reset(),this._clearWorld&&(this.game.world.shutdown(),this._clearCache&&this.game.cache.destroy()))},checkState:function(t){var e=this.states[t];return e?!!(e.preload||e.create||e.update||e.render)||(console.warn("Invalid Phaser State object given. Must contain at least one of the required functions: preload, create, update or render"),!1):(console.warn("Phaser.StateManager - No state found with the key: "+t),!1)},link:function(t){var e=this.states[t];e.game=this.game,e.add=this.game.add,e.make=this.game.make,e.camera=this.game.camera,e.cache=this.game.cache,e.input=this.game.input,e.load=this.game.load,e.math=this.game.math,e.sound=this.game.sound,e.scale=this.game.scale,e.state=this,e.stage=this.game.stage,e.time=this.game.time,e.tweens=this.game.tweens,e.world=this.game.world,e.particles=this.game.particles,e.rnd=this.game.rnd,e.physics=this.game.physics,e.key=t},unlink:function(t){var e=this.states[t];e&&(e.game=null,e.add=null,e.make=null,e.camera=null,e.cache=null,e.input=null,e.load=null,e.math=null,e.sound=null,e.scale=null,e.state=null,e.stage=null,e.time=null,e.tweens=null,e.world=null,e.particles=null,e.rnd=null,e.physics=null)},setCurrentState:function(t){var e=this.states[t];this.callbackContext=e,this.link(t),this.onInitCallback=e.init||this.dummy,this.onPreloadCallback=e.preload||null,this.onLoadRenderCallback=e.loadRender||null,this.onLoadUpdateCallback=e.loadUpdate||null,this.onCreateCallback=e.create||null,this.onUpdateCallback=e.update||null,this.onPostUpdateCallback=e.postUpdate||null,this.onPreRenderCallback=e.preRender||null,this.onRenderCallback=e.render||null,this.onResizeCallback=e.resize||null,this.onPausedCallback=e.paused||null,this.onResumedCallback=e.resumed||null,this.onPauseUpdateCallback=e.pauseUpdate||null,this.onShutDownCallback=e.shutdown||this.dummy,""!==this.current&&this.game.physics.reset(),this.current=t,this._created=!1,this.onInitCallback.apply(this.callbackContext,this._args),t===this._pendingState&&(this._args=[]),this.game._kickstart=!0},getCurrentState:function(){return this.states[this.current]},loadComplete:function(){!1===this._created&&this.onCreateCallback?(this._created=!0,this.onCreateCallback.call(this.callbackContext,this.game)):this._created=!0},loadUpdate:function(){!1===this._created&&this.onLoadUpdateCallback&&this.onLoadUpdateCallback.call(this.callbackContext,this.game)},pause:function(){this._created&&this.onPausedCallback&&this.onPausedCallback.call(this.callbackContext,this.game)},resume:function(){this._created&&this.onResumedCallback&&this.onResumedCallback.call(this.callbackContext,this.game)},update:function(){this._created?this.onUpdateCallback&&this.onUpdateCallback.call(this.callbackContext,this.game):this.onLoadUpdateCallback&&this.onLoadUpdateCallback.call(this.callbackContext,this.game)},postUpdate:function(){this._created&&this.onPostUpdateCallback&&this.onPostUpdateCallback.call(this.callbackContext,this.game)},pauseUpdate:function(){this._created?this.onPauseUpdateCallback&&this.onPauseUpdateCallback.call(this.callbackContext,this.game):this.onLoadUpdateCallback&&this.onLoadUpdateCallback.call(this.callbackContext,this.game)},preRender:function(t){this._created&&this.onPreRenderCallback&&this.onPreRenderCallback.call(this.callbackContext,this.game,t)},resize:function(t,e){this.onResizeCallback&&this.onResizeCallback.call(this.callbackContext,t,e)},render:function(){this._created?this.onRenderCallback&&(this.game.renderType===e.CANVAS?(this.game.context.save(),this.game.context.setTransform(1,0,0,1,0,0),this.onRenderCallback.call(this.callbackContext,this.game),this.game.context.restore()):this.onRenderCallback.call(this.callbackContext,this.game)):this.onLoadRenderCallback&&this.onLoadRenderCallback.call(this.callbackContext,this.game)},destroy:function(){this._clearWorld=!0,this._clearCache=!0,this.clearCurrentState(),this.callbackContext=null,this.onInitCallback=null,this.onShutDownCallback=null,this.onPreloadCallback=null,this.onLoadRenderCallback=null,this.onLoadUpdateCallback=null,this.onCreateCallback=null,this.onUpdateCallback=null,this.onPostUpdateCallback=null,this.onRenderCallback=null,this.onPausedCallback=null,this.onResumedCallback=null,this.onPauseUpdateCallback=null,this.game=null,this.states={},this._pendingState=null,this.current=""}},e.StateManager.prototype.constructor=e.StateManager,Object.defineProperty(e.StateManager.prototype,"created",{get:function(){return this._created}}),e.Signal=function(){},e.Signal.prototype={_bindings:null,_prevParams:null,memorize:!1,_shouldPropagate:!0,active:!0,_boundDispatch:!1,validateListener:function(t,e){if("function"!=typeof t)throw new Error("Phaser.Signal: listener is a required param of {fn}() and should be a Function.".replace("{fn}",e))},_registerListener:function(t,i,s,n,r){var o,a=this._indexOfListener(t,s);if(-1!==a){if((o=this._bindings[a]).isOnce()!==i)throw new Error("You cannot add"+(i?"":"Once")+"() then add"+(i?"Once":"")+"() the same listener without removing the relationship first.")}else o=new e.SignalBinding(this,t,i,s,n,r),this._addBinding(o);return this.memorize&&this._prevParams&&o.execute(this._prevParams),o},_addBinding:function(t){this._bindings||(this._bindings=[]);var e=this._bindings.length;do{e--}while(this._bindings[e]&&t._priority<=this._bindings[e]._priority);this._bindings.splice(e+1,0,t)},_indexOfListener:function(t,e){if(!this._bindings)return-1;void 0===e&&(e=null);for(var i,s=this._bindings.length;s--;)if((i=this._bindings[s])._listener===t&&i.context===e)return s;return-1},has:function(t,e){return-1!==this._indexOfListener(t,e)},add:function(t,e,i){this.validateListener(t,"add");var s=[];if(arguments.length>3)for(var n=3;n<arguments.length;n++)s.push(arguments[n]);return this._registerListener(t,!1,e,i,s)},addOnce:function(t,e,i){this.validateListener(t,"addOnce");var s=[];if(arguments.length>3)for(var n=3;n<arguments.length;n++)s.push(arguments[n]);return this._registerListener(t,!0,e,i,s)},remove:function(t,e){this.validateListener(t,"remove");var i=this._indexOfListener(t,e);return-1!==i&&(this._bindings[i]._destroy(),this._bindings.splice(i,1)),t},removeAll:function(t){if(void 0===t&&(t=null),this._bindings){for(var e=this._bindings.length;e--;)t?this._bindings[e].context===t&&(this._bindings[e]._destroy(),this._bindings.splice(e,1)):this._bindings[e]._destroy();t||(this._bindings.length=0)}},getNumListeners:function(){return this._bindings?this._bindings.length:0},halt:function(){this._shouldPropagate=!1},dispatch:function(){if(this.active&&(this._bindings||this.memorize)){var t=Array.prototype.slice.call(arguments);this.memorize&&(this._prevParams=t);var e=this._bindings?this._bindings.length:0;if(e){var i=this._bindings.slice();this._shouldPropagate=!0;do{e--}while(i[e]&&this._shouldPropagate&&!1!==i[e].execute(t))}}},forget:function(){this._prevParams&&(this._prevParams=null)},dispose:function(){this.removeAll(),this._bindings=null,this._prevParams&&(this._prevParams=null)},toString:function(){return"[Phaser.Signal active:"+this.active+" numListeners:"+this.getNumListeners()+"]"}},Object.defineProperty(e.Signal.prototype,"boundDispatch",{get:function(){var t=this;return this._boundDispatch||(this._boundDispatch=function(){return t.dispatch.apply(t,arguments)})}}),e.Signal.prototype.constructor=e.Signal,e.SignalBinding=function(t,e,i,s,n,r){this._listener=e,i&&(this._isOnce=!0),null!=s&&(this.context=s),this._signal=t,n&&(this._priority=n),r&&r.length&&(this._args=r)},e.SignalBinding.prototype={context:null,_isOnce:!1,_priority:0,_args:null,callCount:0,active:!0,params:null,execute:function(t){var e,i;return this.active&&this._listener&&(i=this.params?this.params.concat(t):t,this._args&&(i=i.concat(this._args)),e=this._listener.apply(this.context,i),this.callCount++,this._isOnce&&this.detach()),e},detach:function(){return this.isBound()?this._signal.remove(this._listener,this.context):null},isBound:function(){return!!this._signal&&!!this._listener},isOnce:function(){return this._isOnce},getListener:function(){return this._listener},getSignal:function(){return this._signal},_destroy:function(){delete this._signal,delete this._listener,delete this.context},toString:function(){return"[Phaser.SignalBinding isOnce:"+this._isOnce+", isBound:"+this.isBound()+", active:"+this.active+"]"}},e.SignalBinding.prototype.constructor=e.SignalBinding,e.Filter=function(t,i,s){this.game=t,this.type=e.WEBGL_FILTER,this.passes=[this],this.shaders=[],this.dirty=!0,this.padding=0,this.prevPoint=new e.Point;var n=new Date;if(this.uniforms={resolution:{type:"2f",value:{x:256,y:256}},time:{type:"1f",value:0},mouse:{type:"2f",value:{x:0,y:0}},date:{type:"4fv",value:[n.getFullYear(),n.getMonth(),n.getDate(),60*n.getHours()*60+60*n.getMinutes()+n.getSeconds()]},sampleRate:{type:"1f",value:44100},iChannel0:{type:"sampler2D",value:null,textureData:{repeat:!0}},iChannel1:{type:"sampler2D",value:null,textureData:{repeat:!0}},iChannel2:{type:"sampler2D",value:null,textureData:{repeat:!0}},iChannel3:{type:"sampler2D",value:null,textureData:{repeat:!0}}},i)for(var r in i)this.uniforms[r]=i[r];"string"==typeof s&&(s=s.split("\n")),this.fragmentSrc=s||[]},e.Filter.prototype={init:function(){},setResolution:function(t,e){this.uniforms.resolution.value.x=t,this.uniforms.resolution.value.y=e},update:function(t){if(t){var e=t.x/this.game.width,i=1-t.y/this.game.height;e===this.prevPoint.x&&i===this.prevPoint.y||(this.uniforms.mouse.value.x=e.toFixed(2),this.uniforms.mouse.value.y=i.toFixed(2),this.prevPoint.set(e,i))}this.uniforms.time.value=this.game.time.totalElapsedSeconds()},addToWorld:function(t,i,s,n,r,o){void 0===r&&(r=0),void 0===o&&(o=0),void 0!==s&&null!==s?this.width=s:s=this.width,void 0!==n&&null!==n?this.height=n:n=this.height;var a=this.game.add.image(t,i,e.Cache.DEFAULT);return a.width=s,a.height=n,a.anchor.set(r,o),a.filters=[this],a},syncUniforms:function(){for(var t=0;t<this.shaders.length;t++)this.shaders[t].dirty=!0},destroy:function(){this.passes.length=0,this.shaders.length=0,this.fragmentSrc.length=0,this.game=null,this.uniforms=null,this.prevPoint=null}},e.Filter.prototype.constructor=e.Filter,Object.defineProperty(e.Filter.prototype,"width",{get:function(){return this.uniforms.resolution.value.x},set:function(t){this.uniforms.resolution.value.x=t}}),Object.defineProperty(e.Filter.prototype,"height",{get:function(){return this.uniforms.resolution.value.y},set:function(t){this.uniforms.resolution.value.y=t}}),e.Plugin=function(t,e){void 0===e&&(e=null),this.game=t,this.parent=e,this.active=!1,this.visible=!1,this.hasPreUpdate=!1,this.hasUpdate=!1,this.hasPostUpdate=!1,this.hasRender=!1,this.hasPostRender=!1},e.Plugin.prototype={preUpdate:function(){},update:function(){},render:function(){},postRender:function(){},destroy:function(){this.game=null,this.parent=null,this.active=!1,this.visible=!1}},e.Plugin.prototype.constructor=e.Plugin,e.PluginManager=function(t){this.game=t,this.plugins=[],this._len=0,this._i=0},e.PluginManager.prototype={add:function(t){var e=Array.prototype.slice.call(arguments,1),i=!1;return"function"==typeof t?t=new t(this.game,this):(t.game=this.game,t.parent=this),"function"==typeof t.preUpdate&&(t.hasPreUpdate=!0,i=!0),"function"==typeof t.update&&(t.hasUpdate=!0,i=!0),"function"==typeof t.postUpdate&&(t.hasPostUpdate=!0,i=!0),"function"==typeof t.render&&(t.hasRender=!0,i=!0),"function"==typeof t.postRender&&(t.hasPostRender=!0,i=!0),i?((t.hasPreUpdate||t.hasUpdate||t.hasPostUpdate)&&(t.active=!0),(t.hasRender||t.hasPostRender)&&(t.visible=!0),this._len=this.plugins.push(t),"function"==typeof t.init&&t.init.apply(t,e),t):null},remove:function(t,e){for(void 0===e&&(e=!0),this._i=this._len;this._i--;)if(this.plugins[this._i]===t)return e&&t.destroy(),this.plugins.splice(this._i,1),void this._len--},removeAll:function(){for(this._i=this._len;this._i--;)this.plugins[this._i].destroy();this.plugins.length=0,this._len=0},preUpdate:function(){for(this._i=this._len;this._i--;)this.plugins[this._i].active&&this.plugins[this._i].hasPreUpdate&&this.plugins[this._i].preUpdate()},update:function(){for(this._i=this._len;this._i--;)this.plugins[this._i].active&&this.plugins[this._i].hasUpdate&&this.plugins[this._i].update()},postUpdate:function(){for(this._i=this._len;this._i--;)this.plugins[this._i].active&&this.plugins[this._i].hasPostUpdate&&this.plugins[this._i].postUpdate()},render:function(){for(this._i=this._len;this._i--;)this.plugins[this._i].visible&&this.plugins[this._i].hasRender&&this.plugins[this._i].render()},postRender:function(){for(this._i=this._len;this._i--;)this.plugins[this._i].visible&&this.plugins[this._i].hasPostRender&&this.plugins[this._i].postRender()},destroy:function(){this.removeAll(),this.game=null}},e.PluginManager.prototype.constructor=e.PluginManager,e.Stage=function(t){this.game=t,PIXI.DisplayObjectContainer.call(this),this.name="_stage_root",this.disableVisibilityChange=!1,this.exists=!0,this.worldTransform=new e.Matrix,this.stage=this,this.currentRenderOrderID=0,this._hiddenVar="hidden",this._onChange=null,this._bgColor={r:0,g:0,b:0,a:0,color:0,rgba:"#000000"},this.game.transparent||(this._bgColor.a=1),t.config&&this.parseConfig(t.config)},e.Stage.prototype=Object.create(PIXI.DisplayObjectContainer.prototype),e.Stage.prototype.constructor=e.Stage,e.Stage.prototype.parseConfig=function(t){t.disableVisibilityChange&&(this.disableVisibilityChange=t.disableVisibilityChange),t.backgroundColor&&this.setBackgroundColor(t.backgroundColor)},e.Stage.prototype.boot=function(){e.DOM.getOffset(this.game.canvas,this.offset),e.Canvas.setUserSelect(this.game.canvas,"none"),e.Canvas.setTouchAction(this.game.canvas,"none"),this.checkVisibility()},e.Stage.prototype.preUpdate=function(){this.currentRenderOrderID=0;for(var t=0;t<this.children.length;){var e=this.children[t];e.preUpdate(),this===e.parent&&t++}},e.Stage.prototype.update=function(){for(var t=this.children.length;t--;)this.children[t].update()},e.Stage.prototype.postUpdate=function(){this.game.camera.update(),this.game.camera.target&&(this.game.camera.target.postUpdate(),this.updateTransform(),this.game.camera.updateTarget());for(var t=0;t<this.children.length;t++)this.children[t].postUpdate();this.updateTransform()},e.Stage.prototype.updateTransform=function(){this.worldAlpha=1;for(var t=0;t<this.children.length;t++)this.children[t].updateTransform()},e.Stage.prototype.checkVisibility=function(){void 0!==document.hidden?this._hiddenVar="visibilitychange":void 0!==document.webkitHidden?this._hiddenVar="webkitvisibilitychange":void 0!==document.mozHidden?this._hiddenVar="mozvisibilitychange":void 0!==document.msHidden?this._hiddenVar="msvisibilitychange":this._hiddenVar=null;var t=this;this._onChange=function(e){return t.visibilityChange(e)},this._onChangePause=function(){return t._onChange({type:"pause"})},this._onChangeResume=function(){return t._onChange({type:"resume"})},this._onClick=function(e){void 0===document.hasFocus||document.hasFocus()||t.visibilityChange(e)},this._hiddenVar&&document.addEventListener(this._hiddenVar,this._onChange,!1),window.onblur=this._onChange,window.onfocus=this._onChange,window.onpagehide=this._onChange,window.onpageshow=this._onChange,window.addEventListener("click",this._onClick),this.game.device.cocoonJSApp&&CocoonJS.App&&(CocoonJS.App.onSuspended&&CocoonJS.App.onSuspended.addEventListener(this._onChangePause),CocoonJS.App.onActivated&&CocoonJS.App.onActivated.addEventListener(this._onChangeResume),CocoonJS.App.on&&(CocoonJS.App.on("activated",this._onChangeResume),CocoonJS.App.on("suspended",this._onChangePause)))},e.Stage.prototype.visibilityChange=function(t){switch(t.type){case"blur":case"pagehide":return void this.game.focusLoss(t);case"click":case"focus":case"pageshow":return void this.game.focusGain(t)}this.disableVisibilityChange||(document.hidden||document.mozHidden||document.msHidden||document.webkitHidden||"pause"===t.type?this.game.gamePaused(t):this.game.gameResumed(t))},e.Stage.prototype.setBackgroundColor=function(t){this.game.transparent||(e.Color.valueToColor(t,this._bgColor),e.Color.updateColor(this._bgColor),this._bgColor.r/=255,this._bgColor.g/=255,this._bgColor.b/=255,this._bgColor.a=1)},e.Stage.prototype.destroy=function(){this._hiddenVar&&document.removeEventListener(this._hiddenVar,this._onChange,!1),window.onpagehide=null,window.onpageshow=null,window.onblur=null,window.onfocus=null,window.removeEventListener("click",this._onClick)},e.Stage.prototype.add=function(t,e,i){return t.parent===this?t:(t.body&&t.parent&&t.parent.hash&&t.parent.removeFromHash(t),void 0===i?this.addChild(t):this.addChildAt(t,i),t)},Object.defineProperty(e.Stage.prototype,"backgroundColor",{get:function(){return this._bgColor.color},set:function(t){this.setBackgroundColor(t)}}),Object.defineProperty(e.Stage.prototype,"smoothed",{get:function(){return PIXI.scaleModes.DEFAULT===PIXI.scaleModes.LINEAR},set:function(t){PIXI.scaleModes.DEFAULT=t?PIXI.scaleModes.LINEAR:PIXI.scaleModes.NEAREST}}),e.Group=function(t,i,s,n,r,o){void 0===n&&(n=!1),void 0===r&&(r=!1),void 0===o&&(o=e.Physics.ARCADE),this.game=t,void 0===i&&(i=t.world),this.name=s||"group",this.z=0,PIXI.DisplayObjectContainer.call(this),n?(this.game.stage.addChild(this),this.z=this.game.stage.children.length):i&&(i.addChild(this),this.z=i.children.length),this.type=e.GROUP,this.physicsType=e.GROUP,this.alive=!0,this.exists=!0,this.ignoreDestroy=!1,this.pendingDestroy=!1,this.classType=e.Sprite,this.cursor=null,this.inputEnableChildren=!1,this.updateOnlyExistingChildren=!1,this.onChildInputDown=new e.Signal,this.onChildInputUp=new e.Signal,this.onChildInputOver=new e.Signal,this.onChildInputOut=new e.Signal,this.enableBody=r,this.enableBodyDebug=!1,this.physicsBodyType=o,this.physicsSortDirection=null,this.onDestroy=new e.Signal,this.cursorIndex=0,this.fixedToCamera=!1,this.cameraOffset=new e.Point,this.hash=[],this._sortProperty="z"},e.Group.prototype=Object.create(PIXI.DisplayObjectContainer.prototype),e.Group.prototype.constructor=e.Group,e.Group.RETURN_NONE=0,e.Group.RETURN_TOTAL=1,e.Group.RETURN_CHILD=2,e.Group.RETURN_ALL=3,e.Group.SORT_ASCENDING=-1,e.Group.SORT_DESCENDING=1,e.Group.prototype.add=function(t,e,i){return void 0===e&&(e=!1),t.parent===this?t:(t.body&&t.parent&&t.parent.hash&&t.parent.removeFromHash(t),void 0===i?(t.z=this.children.length,this.addChild(t)):(this.addChildAt(t,i),this.updateZ()),this.enableBody&&t.hasOwnProperty("body")&&null===t.body?this.game.physics.enable(t,this.physicsBodyType):t.body&&this.addToHash(t),!this.inputEnableChildren||t.input&&!t.inputEnabled||(t.inputEnabled=!0),!e&&t.events&&t.events.onAddedToGroup$dispatch(t,this),null===this.cursor&&(this.cursor=t),t)},e.Group.prototype.addAt=function(t,e,i){return this.add(t,i,e)},e.Group.prototype.addToHash=function(t){return t.parent===this&&-1===this.hash.indexOf(t)&&(this.hash.push(t),!0)},e.Group.prototype.removeFromHash=function(t){if(t){var e=this.hash.indexOf(t);if(-1!==e)return this.hash.splice(e,1),!0}return!1},e.Group.prototype.addMultiple=function(t,i){if(t instanceof e.Group)t.moveAll(this,i);else if(Array.isArray(t))for(var s=0;s<t.length;s++)this.add(t[s],i);return t},e.Group.prototype.getAt=function(t){return t<0||t>=this.children.length?-1:this.getChildAt(t)},e.Group.prototype.create=function(t,e,i,s,n,r){void 0===n&&(n=!0);var o=new this.classType(this.game,t,e,i,s);return o.exists=n,o.visible=n,o.alive=n,this.add(o,!1,r)},e.Group.prototype.createMultiple=function(t,e,i,s,n,r){void 0===i&&(i=0),void 0===s&&(s=!1),Array.isArray(e)||(e=[e]),Array.isArray(i)||(i=[i]);var o=this,a=[];return e.forEach(function(e){i.forEach(function(i){for(var h=0;h<t;h++){var l=o.create(0,0,e,i,s);n&&n.call(r||l,l,h),a.push(l)}})}),a},e.Group.prototype.updateZ=function(){for(var t=this.children.length;t--;)this.children[t].z=t},e.Group.prototype.align=function(t,i,s,n,r,o){if(void 0===r&&(r=e.TOP_LEFT),void 0===o&&(o=0),0===this.children.length||o>this.children.length||-1===t&&-1===i)return!1;for(var a=new e.Rectangle(0,0,s,n),h=t*s,l=i*n,c=o;c<this.children.length;c++){var u=this.children[c];if(u.alignIn)if(u.alignIn(a,r),-1===t)a.y+=n,a.y===l&&(a.x+=s,a.y=0);else if(-1===i)a.x+=s,a.x===h&&(a.x=0,a.y+=n);else if(a.x+=s,a.x===h&&(a.x=0,a.y+=n,a.y===l))return!0}return!0},e.Group.prototype.resetCursor=function(t){if(void 0===t&&(t=0),t>this.children.length-1&&(t=0),this.cursor)return this.cursorIndex=t,this.cursor=this.children[this.cursorIndex],this.cursor},e.Group.prototype.next=function(){if(this.cursor)return this.cursorIndex>=this.children.length-1?this.cursorIndex=0:this.cursorIndex++,this.cursor=this.children[this.cursorIndex],this.cursor},e.Group.prototype.previous=function(){if(this.cursor)return 0===this.cursorIndex?this.cursorIndex=this.children.length-1:this.cursorIndex--,this.cursor=this.children[this.cursorIndex],this.cursor},e.Group.prototype.swap=function(t,e){this.swapChildren(t,e),this.updateZ()},e.Group.prototype.bringToTop=function(t){return t.parent===this&&this.getIndex(t)<this.children.length&&(this.remove(t,!1,!0),this.add(t,!0)),t},e.Group.prototype.bringChildToTop=e.Group.prototype.bringToTop,e.Group.prototype.sendToBack=function(t){return t.parent===this&&this.getIndex(t)>0&&(this.remove(t,!1,!0),this.addAt(t,0,!0)),t},e.Group.prototype.sendChildToBack=e.Group.prototype.sendToBack,e.Group.prototype.moveUp=function(t){if(t.parent===this&&this.getIndex(t)<this.children.length-1){var e=this.getIndex(t),i=this.getAt(e+1);i&&this.swap(t,i)}return t},e.Group.prototype.moveDown=function(t){if(t.parent===this&&this.getIndex(t)>0){var e=this.getIndex(t),i=this.getAt(e-1);i&&this.swap(t,i)}return t},e.Group.prototype.xy=function(t,e,i){if(t<0||t>this.children.length)return-1;this.getChildAt(t).x=e,this.getChildAt(t).y=i},e.Group.prototype.reverse=function(){this.children.reverse(),this.updateZ()},e.Group.prototype.getIndex=function(t){return this.children.indexOf(t)},e.Group.prototype.getByName=function(t){for(var e=0;e<this.children.length;e++)if(this.children[e].name===t)return this.children[e];return null},e.Group.prototype.replace=function(t,i){var s=this.getIndex(t);if(-1!==s)return i.parent&&(i.parent instanceof e.Group?i.parent.remove(i):i.parent.removeChild(i)),this.remove(t),this.addAt(i,s),t},e.Group.prototype.hasProperty=function(t,e){var i=e.length;return 1===i&&e[0]in t||(2===i&&e[0]in t&&e[1]in t[e[0]]||(3===i&&e[0]in t&&e[1]in t[e[0]]&&e[2]in t[e[0]][e[1]]||4===i&&e[0]in t&&e[1]in t[e[0]]&&e[2]in t[e[0]][e[1]]&&e[3]in t[e[0]][e[1]][e[2]]))},e.Group.prototype.setProperty=function(t,e,i,s,n){if(void 0===n&&(n=!1),s=s||0,!this.hasProperty(t,e)&&(!n||s>0))return!1;var r=e.length;return 1===r?0===s?t[e[0]]=i:1===s?t[e[0]]+=i:2===s?t[e[0]]-=i:3===s?t[e[0]]*=i:4===s&&(t[e[0]]/=i):2===r?0===s?t[e[0]][e[1]]=i:1===s?t[e[0]][e[1]]+=i:2===s?t[e[0]][e[1]]-=i:3===s?t[e[0]][e[1]]*=i:4===s&&(t[e[0]][e[1]]/=i):3===r?0===s?t[e[0]][e[1]][e[2]]=i:1===s?t[e[0]][e[1]][e[2]]+=i:2===s?t[e[0]][e[1]][e[2]]-=i:3===s?t[e[0]][e[1]][e[2]]*=i:4===s&&(t[e[0]][e[1]][e[2]]/=i):4===r&&(0===s?t[e[0]][e[1]][e[2]][e[3]]=i:1===s?t[e[0]][e[1]][e[2]][e[3]]+=i:2===s?t[e[0]][e[1]][e[2]][e[3]]-=i:3===s?t[e[0]][e[1]][e[2]][e[3]]*=i:4===s&&(t[e[0]][e[1]][e[2]][e[3]]/=i)),!0},e.Group.prototype.checkProperty=function(t,i,s,n){if(void 0===n&&(n=!1),this!==t.parent)return!1;var r=e.Utils.getProperty(t,i);return!(void 0===r&&n||r!==s)},e.Group.prototype.set=function(t,e,i,s,n,r,o){if(void 0===o&&(o=!1),e=e.split("."),void 0===s&&(s=!1),void 0===n&&(n=!1),(!1===s||s&&t.alive)&&(!1===n||n&&t.visible))return this.setProperty(t,e,i,r,o)},e.Group.prototype.setAll=function(t,e,i,s,n,r){void 0===i&&(i=!1),void 0===s&&(s=!1),void 0===r&&(r=!1),t=t.split("."),n=n||0;for(var o=0;o<this.children.length;o++)(!i||i&&this.children[o].alive)&&(!s||s&&this.children[o].visible)&&this.setProperty(this.children[o],t,e,n,r)},e.Group.prototype.setAllChildren=function(t,i,s,n,r,o){void 0===s&&(s=!1),void 0===n&&(n=!1),void 0===o&&(o=!1),r=r||0;for(var a=0;a<this.children.length;a++)(!s||s&&this.children[a].alive)&&(!n||n&&this.children[a].visible)&&(this.children[a]instanceof e.Group?this.children[a].setAllChildren(t,i,s,n,r,o):this.setProperty(this.children[a],t.split("."),i,r,o))},e.Group.prototype.checkAll=function(t,e,i,s,n){void 0===i&&(i=!1),void 0===s&&(s=!1),void 0===n&&(n=!1);for(var r=0;r<this.children.length;r++){var o=this.children[r];if((!i||i&&o.alive)&&(!s||s&&o.visible)&&!this.checkProperty(o,t,e,n))return!1}return!0},e.Group.prototype.checkAny=function(t,e,i,s){void 0===i&&(i=!1),void 0===s&&(s=!1);for(var n=0;n<this.children.length;n++){var r=this.children[n];if((!i||i&&r.alive)&&(!s||s&&r.visible)&&this.checkProperty(r,t,e))return!0}return!1},e.Group.prototype.addAll=function(t,e,i,s){this.setAll(t,e,i,s,1)},e.Group.prototype.subAll=function(t,e,i,s){this.setAll(t,e,i,s,2)},e.Group.prototype.multiplyAll=function(t,e,i,s){this.setAll(t,e,i,s,3)},e.Group.prototype.divideAll=function(t,e,i,s){this.setAll(t,e,i,s,4)},e.Group.prototype.kill=function(){this.alive=!1,this.exists=!1,this.visible=!1},e.Group.prototype.killAll=function(){this.callAllExists("kill",!0)},e.Group.prototype.revive=function(){this.alive=!0,this.exists=!0,this.visible=!0},e.Group.prototype.reviveAll=function(){this.callAllExists("revive",!1)},e.Group.prototype.resetAll=function(t,e,i,s,n){this.forEach(this.resetChild,this,n,t,e,i,s)},e.Group.prototype.callAllExists=function(t,e){var i;if(arguments.length>2){i=[];for(s=2;s<arguments.length;s++)i.push(arguments[s])}for(var s=0;s<this.children.length;s++)this.children[s].exists===e&&this.children[s][t]&&this.children[s][t].apply(this.children[s],i)},e.Group.prototype.callbackFromArray=function(t,e,i){if(1===i){if(t[e[0]])return t[e[0]]}else if(2===i){if(t[e[0]][e[1]])return t[e[0]][e[1]]}else if(3===i){if(t[e[0]][e[1]][e[2]])return t[e[0]][e[1]][e[2]]}else if(4===i){if(t[e[0]][e[1]][e[2]][e[3]])return t[e[0]][e[1]][e[2]][e[3]]}else if(t[e])return t[e];return!1},e.Group.prototype.callAll=function(t,e){if(void 0!==t){var i=(t=t.split(".")).length;if(void 0===e||null===e||""===e)e=null;else if("string"==typeof e)var s=(e=e.split(".")).length;var n;if(arguments.length>2){n=[];for(a=2;a<arguments.length;a++)n.push(arguments[a])}for(var r=null,o=null,a=0;a<this.children.length;a++)r=this.callbackFromArray(this.children[a],t,i),e&&r?(o=this.callbackFromArray(this.children[a],e,s),r&&r.apply(o,n)):r&&r.apply(this.children[a],n)}},e.Group.prototype.preUpdate=function(){if(this.pendingDestroy)return this.destroy(),!1;if(!this.exists||!this.parent.exists)return this.renderOrderID=-1,!1;for(var t=0;t<this.children.length;){var e=this.children[t];e.preUpdate(),this===e.parent&&t++}return!0},e.Group.prototype.update=function(){for(var t=this.children.length;t--;){var e=this.children.length;t>=e&&(t=e-1);var i=this.children[t];this.updateOnlyExistingChildren&&!i.exists||i.update()}},e.Group.prototype.postUpdate=function(){this.fixedToCamera&&(this.x=(this.game.camera.view.x+this.cameraOffset.x)/this.game.camera.scale.x,this.y=(this.game.camera.view.y+this.cameraOffset.y)/this.game.camera.scale.y);for(var t=0;t<this.children.length;t++)this.children[t].postUpdate()},e.Group.prototype.filter=function(t,i){for(var s=-1,n=this.children.length,r=[];++s<n;){var o=this.children[s];(!i||i&&o.exists)&&t(o,s,this.children)&&r.push(o)}return new e.ArraySet(r)},e.Group.prototype.forEach=function(t,e,i){if(void 0===i&&(i=!1),arguments.length<=3)for(n=0;n<this.children.length;n++)(!i||i&&this.children[n].exists)&&t.call(e,this.children[n]);else{for(var s=[null],n=3;n<arguments.length;n++)s.push(arguments[n]);for(n=0;n<this.children.length;n++)(!i||i&&this.children[n].exists)&&(s[0]=this.children[n],t.apply(e,s))}},e.Group.prototype.forEachExists=function(t,i){var s;if(arguments.length>2){s=[null];for(var n=2;n<arguments.length;n++)s.push(arguments[n])}this.iterate("exists",!0,e.Group.RETURN_TOTAL,t,i,s)},e.Group.prototype.forEachAlive=function(t,i){var s;if(arguments.length>2){s=[null];for(var n=2;n<arguments.length;n++)s.push(arguments[n])}this.iterate("alive",!0,e.Group.RETURN_TOTAL,t,i,s)},e.Group.prototype.forEachDead=function(t,i){var s;if(arguments.length>2){s=[null];for(var n=2;n<arguments.length;n++)s.push(arguments[n])}this.iterate("alive",!1,e.Group.RETURN_TOTAL,t,i,s)},e.Group.prototype.sort=function(t,i){this.children.length<2||(void 0===t&&(t="z"),void 0===i&&(i=e.Group.SORT_ASCENDING),this._sortProperty=t,i===e.Group.SORT_ASCENDING?this.children.sort(this.ascendingSortHandler.bind(this)):this.children.sort(this.descendingSortHandler.bind(this)),this.updateZ())},e.Group.prototype.customSort=function(t,e){this.children.length<2||(this.children.sort(t.bind(e)),this.updateZ())},e.Group.prototype.ascendingSortHandler=function(t,e){return t[this._sortProperty]<e[this._sortProperty]?-1:t[this._sortProperty]>e[this._sortProperty]?1:t.z<e.z?-1:1},e.Group.prototype.descendingSortHandler=function(t,e){return t[this._sortProperty]<e[this._sortProperty]?1:t[this._sortProperty]>e[this._sortProperty]?-1:0},e.Group.prototype.iterate=function(t,i,s,n,r,o){if(0===this.children.length){if(s===e.Group.RETURN_TOTAL)return 0;if(s===e.Group.RETURN_ALL)return[]}var a=0;if(s===e.Group.RETURN_ALL)var h=[];for(var l=0;l<this.children.length;l++)if(this.children[l][t]===i){if(a++,n&&(o?(o[0]=this.children[l],n.apply(r,o)):n.call(r,this.children[l])),s===e.Group.RETURN_CHILD)return this.children[l];s===e.Group.RETURN_ALL&&h.push(this.children[l])}return s===e.Group.RETURN_TOTAL?a:s===e.Group.RETURN_ALL?h:null},e.Group.prototype.getFirst=function(t,i){return this.iterate(t,i,e.Group.RETURN_CHILD)},e.Group.prototype.getFirstExists=function(t,e,i,s,n,r){void 0===e&&(e=!1),"boolean"!=typeof t&&(t=!0);var o=this.getFirst("exists",t);return null===o&&e?this.create(i,s,n,r):this.resetChild(o,i,s,n,r)},e.Group.prototype.getFirstAlive=function(t,e,i,s,n){void 0===t&&(t=!1);var r=this.getFirst("alive",!0);return null===r&&t?this.create(e,i,s,n):this.resetChild(r,e,i,s,n)},e.Group.prototype.getFirstDead=function(t,e,i,s,n){void 0===t&&(t=!1);var r=this.getFirst("alive",!1);return null===r&&t?this.create(e,i,s,n):this.resetChild(r,e,i,s,n)},e.Group.prototype.resetChild=function(t,e,i,s,n){return null===t?null:(void 0===e&&(e=null),void 0===i&&(i=null),null!==e&&null!==i&&t.reset(e,i),void 0!==s&&t.loadTexture(s,n),t)},e.Group.prototype.getTop=function(){if(this.children.length>0)return this.children[this.children.length-1]},e.Group.prototype.getBottom=function(){if(this.children.length>0)return this.children[0]},e.Group.prototype.getClosestTo=function(t,i,s){for(var n=Number.MAX_VALUE,r=0,o=null,a=0;a<this.children.length;a++){var h=this.children[a];h.exists&&(r=Math.abs(e.Point.distance(t,h)))<n&&(!i||i.call(s,h,r))&&(n=r,o=h)}return o},e.Group.prototype.getFurthestFrom=function(t,i,s){for(var n=0,r=0,o=null,a=0;a<this.children.length;a++){var h=this.children[a];h.exists&&(r=Math.abs(e.Point.distance(t,h)))>n&&(!i||i.call(s,h,r))&&(n=r,o=h)}return o},e.Group.prototype.count=function(t,i){return this.iterate(t,i,e.Group.RETURN_TOTAL)},e.Group.prototype.countLiving=function(){return this.count("alive",!0)},e.Group.prototype.countDead=function(){return this.count("alive",!1)},e.Group.prototype.getRandom=function(t,i){return void 0===t&&(t=0),void 0===i&&(i=this.children.length),0===i?null:e.ArrayUtils.getRandomItem(this.children,t,i)},e.Group.prototype.getRandomExists=function(t,e){var i=this.getAll("exists",!0,t,e);return this.game.rnd.pick(i)},e.Group.prototype.getAll=function(t,e,i,s){void 0===i&&(i=0),void 0===s&&(s=this.children.length);for(var n=[],r=i;r<s;r++){var o=this.children[r];t?o[t]===e&&n.push(o):n.push(o)}return n},e.Group.prototype.remove=function(t,e,i){if(void 0===e&&(e=!1),void 0===i&&(i=!1),0===this.children.length||-1===this.children.indexOf(t))return!1;i||!t.events||t.destroyPhase||t.events.onRemovedFromGroup$dispatch(t,this);var s=this.removeChild(t);return this.removeFromHash(t),this.updateZ(),this.cursor===t&&this.next(),e&&s&&s.destroy(!0),!0},e.Group.prototype.moveAll=function(t,i){if(void 0===i&&(i=!1),this.children.length>0&&t instanceof e.Group){do{t.add(this.children[0],i)}while(this.children.length>0);this.hash=[],this.cursor=null}return t},e.Group.prototype.removeAll=function(t,e,i){if(void 0===t&&(t=!1),void 0===e&&(e=!1),void 0===i&&(i=!1),0!==this.children.length){do{!e&&this.children[0].events&&this.children[0].events.onRemovedFromGroup$dispatch(this.children[0],this);var s=this.removeChild(this.children[0]);this.removeFromHash(s),t&&s&&s.destroy(!0,i)}while(this.children.length>0);this.hash=[],this.cursor=null}},e.Group.prototype.removeBetween=function(t,e,i,s){if(void 0===e&&(e=this.children.length-1),void 0===i&&(i=!1),void 0===s&&(s=!1),0!==this.children.length){if(t>e||t<0||e>this.children.length)return!1;for(var n=e;n>=t;){!s&&this.children[n].events&&this.children[n].events.onRemovedFromGroup$dispatch(this.children[n],this);var r=this.removeChild(this.children[n]);this.removeFromHash(r),i&&r&&r.destroy(!0),this.cursor===this.children[n]&&(this.cursor=null),n--}this.updateZ()}},e.Group.prototype.scatter=function(t,e){null==t&&(t=this.game.world.bounds),this.forEach(function(e){e.position.set(t.randomX,t.randomY)},null,e)},e.Group.prototype.shuffle=function(){e.ArrayUtils.shuffle(this.children),this.updateZ()},e.Group.prototype.destroy=function(t,e){null===this.game||this.ignoreDestroy||(void 0===t&&(t=!0),void 0===e&&(e=!1),this.onDestroy.dispatch(this,t,e),this.removeAll(t),this.cursor=null,this.filters=null,this.pendingDestroy=!1,e||(this.parent&&this.parent.removeChild(this),this.game=null,this.exists=!1))},Object.defineProperty(e.Group.prototype,"total",{get:function(){return this.iterate("exists",!0,e.Group.RETURN_TOTAL)}}),Object.defineProperty(e.Group.prototype,"length",{get:function(){return this.children.length}}),Object.defineProperty(e.Group.prototype,"angle",{get:function(){return e.Math.radToDeg(this.rotation)},set:function(t){this.rotation=e.Math.degToRad(t)}}),Object.defineProperty(e.Group.prototype,"centerX",{get:function(){return this.getBounds(this.parent).centerX},set:function(t){var e=this.getBounds(this.parent),i=this.x-e.x;this.x=t+i-e.halfWidth}}),Object.defineProperty(e.Group.prototype,"centerY",{get:function(){return this.getBounds(this.parent).centerY},set:function(t){var e=this.getBounds(this.parent),i=this.y-e.y;this.y=t+i-e.halfHeight}}),Object.defineProperty(e.Group.prototype,"left",{get:function(){return this.getBounds(this.parent).left},set:function(t){var e=this.getBounds(this.parent),i=this.x-e.x;this.x=t+i}}),Object.defineProperty(e.Group.prototype,"right",{get:function(){return this.getBounds(this.parent).right},set:function(t){var e=this.getBounds(this.parent),i=this.x-e.x;this.x=t+i-e.width}}),Object.defineProperty(e.Group.prototype,"top",{get:function(){return this.getBounds(this.parent).top},set:function(t){var e=this.getBounds(this.parent),i=this.y-e.y;this.y=t+i}}),Object.defineProperty(e.Group.prototype,"bottom",{get:function(){return this.getBounds(this.parent).bottom},set:function(t){var e=this.getBounds(this.parent),i=this.y-e.y;this.y=t+i-e.height}}),e.World=function(t){e.Group.call(this,t,null,"__world",!1),this.bounds=new e.Rectangle(0,0,t.width,t.height),this.camera=null,this._definedSize=!1,this._width=t.width,this._height=t.height,this.game.state.onStateChange.add(this.stateChange,this)},e.World.prototype=Object.create(e.Group.prototype),e.World.prototype.constructor=e.World,e.World.prototype.boot=function(){this.camera=new e.Camera(this.game,0,0,0,this.game.width,this.game.height),this.game.stage.addChild(this),this.camera.boot()},e.World.prototype.stateChange=function(){this.x=0,this.y=0,this.camera.reset()},e.World.prototype.setBounds=function(t,e,i,s){this._definedSize=!0,this._width=i,this._height=s,this.bounds.setTo(t,e,i,s),this.x=t,this.y=e,this.camera.bounds&&this.camera.bounds.setTo(t,e,Math.max(i,this.game.width),Math.max(s,this.game.height)),this.game.physics.setBoundsToWorld()},e.World.prototype.resize=function(t,e){this._definedSize&&(t<this._width&&(t=this._width),e<this._height&&(e=this._height)),this.bounds.width=t,this.bounds.height=e,this.game.camera.setBoundsToWorld(),this.game.physics.setBoundsToWorld()},e.World.prototype.shutdown=function(){this.destroy(!0,!0)},e.World.prototype.wrap=function(t,e,i,s,n){void 0===e&&(e=0),void 0===i&&(i=!1),void 0===s&&(s=!0),void 0===n&&(n=!0),i?(t.getBounds(),s&&(t.x+t._currentBounds.width<this.bounds.x?t.x=this.bounds.right:t.x>this.bounds.right&&(t.x=this.bounds.left)),n&&(t.y+t._currentBounds.height<this.bounds.top?t.y=this.bounds.bottom:t.y>this.bounds.bottom&&(t.y=this.bounds.top))):(s&&t.x+e<this.bounds.x?t.x=this.bounds.right+e:s&&t.x-e>this.bounds.right&&(t.x=this.bounds.left-e),n&&t.y+e<this.bounds.top?t.y=this.bounds.bottom+e:n&&t.y-e>this.bounds.bottom&&(t.y=this.bounds.top-e))},e.World.prototype.wrapAll=function(t,e,i,s,n,r){t.forEach(this.wrap,this,e,i,s,n,r)},Object.defineProperty(e.World.prototype,"width",{get:function(){return this.bounds.width},set:function(t){t<this.game.width&&(t=this.game.width),this.bounds.width=t,this._width=t,this._definedSize=!0}}),Object.defineProperty(e.World.prototype,"height",{get:function(){return this.bounds.height},set:function(t){t<this.game.height&&(t=this.game.height),this.bounds.height=t,this._height=t,this._definedSize=!0}}),Object.defineProperty(e.World.prototype,"centerX",{get:function(){return this.bounds.halfWidth+this.bounds.x}}),Object.defineProperty(e.World.prototype,"centerY",{get:function(){return this.bounds.halfHeight+this.bounds.y}}),Object.defineProperty(e.World.prototype,"randomX",{get:function(){return this.bounds.x<0?this.game.rnd.between(this.bounds.x,this.bounds.width-Math.abs(this.bounds.x)):this.game.rnd.between(this.bounds.x,this.bounds.width)}}),Object.defineProperty(e.World.prototype,"randomY",{get:function(){return this.bounds.y<0?this.game.rnd.between(this.bounds.y,this.bounds.height-Math.abs(this.bounds.y)):this.game.rnd.between(this.bounds.y,this.bounds.height)}}),e.Game=function(t,i,s,n,r,o,a,h){return this.id=e.GAMES.push(this)-1,this.config=null,this.physicsConfig=h,this.parent="",this.width=800,this.height=600,this.resolution=1,this._width=800,this._height=600,this.transparent=!1,this.antialias=!0,this.multiTexture=!1,this.preserveDrawingBuffer=!1,this.clearBeforeRender=!0,this.renderer=null,this.renderType=e.AUTO,this.state=null,this.isBooted=!1,this.isRunning=!1,this.raf=null,this.add=null,this.make=null,this.cache=null,this.input=null,this.load=null,this.math=null,this.net=null,this.scale=null,this.sound=null,this.stage=null,this.time=null,this.tweens=null,this.world=null,this.physics=null,this.plugins=null,this.rnd=null,this.device=e.Device,this.camera=null,this.canvas=null,this.context=null,this.debug=null,this.particles=null,this.create=null,this.lockRender=!1,this.pendingDestroy=!1,this.stepping=!1,this.pendingStep=!1,this.stepCount=0,this.onPause=null,this.onResume=null,this.onBlur=null,this.onFocus=null,this._paused=!1,this._codePaused=!1,this.currentUpdateID=0,this.updatesThisFrame=1,this.rendersThisFrame=1,this._deltaTime=0,this._lastCount=0,this._spiraling=0,this._kickstart=!0,this.fpsProblemNotifier=new e.Signal,this.forceSingleUpdate=!0,this.forceSingleRender=!0,this.dropFrames=!1,this._nextFpsNotification=0,1===arguments.length&&"object"==typeof arguments[0]?this.parseConfig(arguments[0]):(this.config={enableDebug:!0},void 0!==t&&(this._width=t),void 0!==i&&(this._height=i),void 0!==s&&(this.renderType=s),void 0!==n&&(this.parent=n),void 0!==o&&(this.transparent=o),void 0!==a&&(this.antialias=a),this.rnd=new e.RandomDataGenerator([(Date.now()*Math.random()).toString()]),this.state=new e.StateManager(this,r)),this.device.whenReady(this.boot,this),this},e.Game.prototype={parseConfig:function(t){this.config=t,void 0===t.enableDebug&&(this.config.enableDebug=!0),t.width&&(this._width=t.width),t.height&&(this._height=t.height),t.renderer&&(this.renderType=t.renderer),t.parent&&(this.parent=t.parent),void 0!==t.transparent&&(this.transparent=t.transparent),void 0!==t.antialias&&(this.antialias=t.antialias),void 0!==t.clearBeforeRender&&(this.clearBeforeRender=t.clearBeforeRender),void 0!==t.multiTexture&&(this.multiTexture=t.multiTexture),t.resolution&&(this.resolution=t.resolution),void 0!==t.preserveDrawingBuffer&&(this.preserveDrawingBuffer=t.preserveDrawingBuffer),t.physicsConfig&&(this.physicsConfig=t.physicsConfig);var i=[(Date.now()*Math.random()).toString()];t.seed&&(i=t.seed),this.rnd=new e.RandomDataGenerator(i);var s=null;t.state&&(s=t.state),this.state=new e.StateManager(this,s)},boot:function(){if(!this.isBooted){if(this.onPause=new e.Signal,this.onResume=new e.Signal,this.onBlur=new e.Signal,this.onFocus=new e.Signal,this.isBooted=!0,PIXI.game=this,this.math=e.Math,this.scale=new e.ScaleManager(this,this._width,this._height),this.stage=new e.Stage(this),this.setUpRenderer(),this.world=new e.World(this),this.add=new e.GameObjectFactory(this),this.make=new e.GameObjectCreator(this),this.cache=new e.Cache(this),this.load=new e.Loader(this),this.time=new e.Time(this),this.tweens=new e.TweenManager(this),this.input=new e.Input(this),this.sound=new e.SoundManager(this),this.physics=new e.Physics(this,this.physicsConfig),this.particles=new e.Particles(this),this.create=new e.Create(this),this.plugins=new e.PluginManager(this),this.net=new e.Net(this),this.time.boot(),this.stage.boot(),this.world.boot(),this.scale.boot(),this.input.boot(this.config),this.sound.boot(),this.state.boot(),this.config.enableDebug)this.debug=new e.Utils.Debug(this),this.debug.boot();else{var t=function(){};this.debug={preUpdate:t,update:t,reset:t,destroy:t,isDisabled:!0}}this.showDebugHeader(),this.isRunning=!0,this.config&&this.config.forceSetTimeOut?this.raf=new e.RequestAnimationFrame(this,this.config.forceSetTimeOut):this.raf=new e.RequestAnimationFrame(this,!1),this._kickstart=!0,this.focusWindow(),this.config.disableStart||(this.cache.isReady?this.raf.start():this.cache.onReady.addOnce(function(){this.raf.start()},this))}},showDebugHeader:function(){if(!window.PhaserGlobal||!window.PhaserGlobal.hideBanner){var t=e.VERSION,i="Canvas",s="HTML Audio",n=1;if(this.renderType===e.WEBGL?(i="WebGL",n++):this.renderType===e.HEADLESS&&(i="Headless"),this.device.webAudio&&(s="WebAudio",n++),this.device.ie)window.console&&console.log("Phaser v"+t+" | Pixi.js | "+i+" | "+s+" | http://phaser.io");else{for(var r=["%c %c %c Phaser CE v"+t+" | Pixi.js | "+i+" | "+s+"  %c %c %c http://phaser.io %c♥%c♥%c♥","background: #fb8cb3","background: #d44a52","color: #ffffff; background: #871905;","background: #d44a52","background: #fb8cb3","background: #ffffff"],o=0;o<3;o++)o<n?r.push("color: #ff2424; background: #fff"):r.push("color: #959595; background: #fff");console.log.apply(console,r)}}},setUpRenderer:function(){if(!this.device.canvas)throw new Error("Phaser.Game - Cannot create Canvas 2d context, aborting.");if(this.config.canvas?this.canvas=this.config.canvas:this.canvas=e.Canvas.create(this,this.width,this.height,this.config.canvasID,!0),this.config.canvasStyle?this.canvas.style=this.config.canvasStyle:this.canvas.style["-webkit-full-screen"]="width: 100%; height: 100%",this.config.crisp&&e.Canvas.setImageRenderingCrisp(this.canvas),this.renderType===e.WEBGL||this.renderType===e.WEBGL_MULTI||this.renderType===e.AUTO&&this.device.webGL){(this.multiTexture||this.renderType===e.WEBGL_MULTI)&&(PIXI.enableMultiTexture(),this.multiTexture=!0);try{this.renderer=new PIXI.WebGLRenderer(this,this.config),this.renderType=e.WEBGL,this.context=null,this.canvas.addEventListener("webglcontextlost",this.contextLost.bind(this),!1),this.canvas.addEventListener("webglcontextrestored",this.contextRestored.bind(this),!1)}catch(t){if(PIXI.defaultRenderer=null,this.renderer=null,this.multiTexture=!1,PIXI._enableMultiTextureToggle=!1,this.renderType===e.WEBGL)throw t}}this.renderer||(this.renderer=new PIXI.CanvasRenderer(this,this.config),this.context=this.renderer.context,this.renderType===e.AUTO&&(this.renderType=e.CANVAS)),this.device.cocoonJS&&(this.canvas.screencanvas=this.renderType===e.CANVAS),this.renderType!==e.HEADLESS&&(this.stage.smoothed=this.antialias,e.Canvas.addToDOM(this.canvas,this.parent,!1),e.Canvas.setTouchAction(this.canvas))},contextLost:function(t){t.preventDefault(),this.renderer.contextLost=!0},contextRestored:function(){this.renderer.initContext(),this.cache.clearGLTextures(),this.renderer.contextLost=!1},update:function(t){if(this.pendingDestroy)this.destroy();else{if(this.time.update(t),this._kickstart)return this.updateLogic(this.time.desiredFpsMult),this.updateRender(this.time.slowMotion*this.time.desiredFps),void(this._kickstart=!1);if(this._spiraling>1&&!this.forceSingleUpdate)this.time.time>this._nextFpsNotification&&(this._nextFpsNotification=this.time.time+1e4,this.fpsProblemNotifier.dispatch()),this._deltaTime=0,this._spiraling=0,this.dropFrames?this.rendersThisFrame=0:(this.updateRender(this.time.slowMotion*this.time.desiredFps),this.rendersThisFrame=1);else{var e=1e3*this.time.slowMotion/this.time.desiredFps;this._deltaTime+=Math.max(Math.min(3*e,this.time.elapsed),0);var i=0;for(this.updatesThisFrame=Math.floor(this._deltaTime/e),this.forceSingleUpdate&&(this.updatesThisFrame=Math.min(1,this.updatesThisFrame)),this.forceSingleRender?this.rendersThisFrame=1:this.rendersThisFrame=Math.min(1,this.updatesThisFrame);this._deltaTime>=e&&(this._deltaTime-=e,this.currentUpdateID=i,this.updateLogic(this.time.desiredFpsMult),i++,!this.forceSingleUpdate||1!==i);)this.time.refresh();i>this._lastCount?this._spiraling++:i<this._lastCount&&(this._spiraling=0),this._lastCount=i,this.rendersThisFrame>0&&this.updateRender(this._deltaTime/e)}}},updateLogic:function(t){this._paused||this.pendingStep?(this.scale.pauseUpdate(),this.state.pauseUpdate(t),this.debug.preUpdate(),this.input.pauseUpdate()):(this.stepping&&(this.pendingStep=!0),this.time.countUpdate(),this.scale.preUpdate(),this.debug.preUpdate(),this.camera.preUpdate(),this.physics.preUpdate(),this.state.preUpdate(t),this.plugins.preUpdate(t),this.stage.preUpdate(),this.state.update(),this.stage.update(),this.tweens.update(),this.sound.update(),this.input.update(),this.physics.update(),this.plugins.update(),this.stage.postUpdate(),this.state.postUpdate(),this.plugins.postUpdate()),this.stage.updateTransform()},updateRender:function(t){this.lockRender||this.renderType===e.HEADLESS||(this.time.countRender(),this.state.preRender(t),this.renderer.render(this.stage),this.plugins.render(t),this.state.render(t),this.plugins.postRender(t))},enableStep:function(){this.stepping=!0,this.pendingStep=!1,this.stepCount=0},disableStep:function(){this.stepping=!1,this.pendingStep=!1},step:function(){this.pendingStep=!1,this.stepCount++},destroy:function(){this.raf.stop(),this.debug.destroy(),this.state.destroy(),this.sound.destroy(),this.scale.destroy(),this.stage.destroy(),this.input.destroy(),this.physics.destroy(),this.plugins.destroy(),this.tweens.destroy(),this.debug=null,this.state=null,this.sound=null,this.scale=null,this.stage=null,this.input=null,this.physics=null,this.plugins=null,this.tweens=null,this.cache=null,this.load=null,this.time=null,this.world=null,this.isBooted=!1,this.renderer.destroy(!1),e.Canvas.removeFromDOM(this.canvas),PIXI.game===this&&(PIXI.game=null),PIXI.defaultRenderer=null,e.GAMES[this.id]=null},gamePaused:function(t){this._paused||(this._paused=!0,this.time.gamePaused(),this.sound.muteOnPause&&this.sound.setMute(),this.onPause.dispatch(t),this.device.cordova&&this.device.iOS&&(this.lockRender=!0))},gameResumed:function(t){this._paused&&!this._codePaused&&(this._paused=!1,this.time.gameResumed(),this.input.reset(),this.sound.muteOnPause&&this.sound.unsetMute(),this.onResume.dispatch(t),this.device.cordova&&this.device.iOS&&(this.lockRender=!1))},focusLoss:function(t){this.onBlur.dispatch(t),this.stage.disableVisibilityChange||this.gamePaused(t)},focusGain:function(t){this.focusWindow(),this.onFocus.dispatch(t),this.stage.disableVisibilityChange||this.gameResumed(t)},focusWindow:function(){window.focus&&(!window.PhaserGlobal||window.PhaserGlobal&&!window.PhaserGlobal.stopFocus)&&window.focus()}},e.Game.prototype.constructor=e.Game,Object.defineProperty(e.Game.prototype,"paused",{get:function(){return this._paused},set:function(t){!0===t?(!1===this._paused&&(this._paused=!0,this.sound.muteOnPause&&this.sound.setMute(),this.time.gamePaused(),this.onPause.dispatch(this)),this._codePaused=!0):(this._paused&&(this._paused=!1,this.input.reset(),this.sound.unsetMute(),this.time.gameResumed(),this.onResume.dispatch(this)),this._codePaused=!1)}}),e.Input=function(t){this.game=t,this.hitCanvas=null,this.hitContext=null,this.moveCallbacks=[],this.customCandidateHandler=null,this.customCandidateHandlerContext=null,this.pollRate=0,this.enabled=!0,this.multiInputOverride=e.Input.MOUSE_TOUCH_COMBINE,this.position=null,this.speed=null,this.circle=null,this.scale=null,this.maxPointers=-1,this.tapRate=200,this.doubleTapRate=300,this.holdRate=2e3,this.justPressedRate=200,this.justReleasedRate=200,this.recordPointerHistory=!1,this.recordRate=100,this.recordLimit=100,this.touchLockCallbacks=[],this.pointer1=null,this.pointer2=null,this.pointer3=null,this.pointer4=null,this.pointer5=null,this.pointer6=null,this.pointer7=null,this.pointer8=null,this.pointer9=null,this.pointer10=null,this.pointers=[],this.activePointer=null,this.mousePointer=null,this.mouse=null,this.keyboard=null,this.touch=null,this.mspointer=null,this.gamepad=null,this.resetLocked=!1,this.onDown=null,this.onUp=null,this.onTap=null,this.onHold=null,this.minPriorityID=0,this.interactiveItems=new e.ArraySet,this._localPoint=new e.Point,this._pollCounter=0,this._oldPosition=null,this._x=0,this._y=0},e.Input.MOUSE_OVERRIDES_TOUCH=0,e.Input.TOUCH_OVERRIDES_MOUSE=1,e.Input.MOUSE_TOUCH_COMBINE=2,e.Input.MAX_POINTERS=10,e.Input.prototype={boot:function(t){"maxPointers"in t&&(this.maxPointers=t.maxPointers),this.mousePointer=new e.Pointer(this.game,0,e.PointerMode.CURSOR),this.addPointer(),this.addPointer(),this.mouse=new e.Mouse(this.game),this.touch=new e.Touch(this.game),this.mspointer=new e.MSPointer(this.game),this.mouseWheel=new e.MouseWheel(this.game),this.pointerLock=new e.PointerLock(this.game),e.Keyboard&&(this.keyboard=new e.Keyboard(this.game)),e.Gamepad&&(this.gamepad=new e.Gamepad(this.game)),this.onDown=new e.Signal,this.onUp=new e.Signal,this.onTap=new e.Signal,this.onHold=new e.Signal,this.scale=new e.Point(1,1),this.speed=new e.Point,this.position=new e.Point,this._oldPosition=new e.Point,this.circle=new e.Circle(0,0,45),this.activePointer=this.mousePointer,this.hitCanvas=e.CanvasPool.create(this,1,1),this.hitContext=this.hitCanvas.getContext("2d"),this.game.device.mspointer&&!1!==t.mspointer?this.mspointer.start():this.game.device.touch&&!1!==t.touch&&this.touch.start(),this.mspointer.active||!1===t.mouse||this.mouse.start(),this.mousePointer.active=!0,!1!==t.mouseWheel&&this.mouseWheel.start(),!1!==t.pointerLock&&this.pointerLock.start(),this.keyboard&&!1!==t.keyboard&&this.keyboard.start();var i=this;this._onClickTrampoline=function(t){i.onClickTrampoline(t)},this.game.canvas.addEventListener("click",this._onClickTrampoline,!1)},destroy:function(){this.mouse.stop(),this.mouseWheel.stop(),this.touch.stop(),this.mspointer.stop(),this.pointerLock.stop(),this.keyboard&&this.keyboard.stop(),this.gamepad&&this.gamepad.stop(),this.moveCallbacks=[],e.CanvasPool.remove(this),this.game.canvas.removeEventListener("click",this._onClickTrampoline)},setInteractiveCandidateHandler:function(t,e){this.customCandidateHandler=t,this.customCandidateHandlerContext=e},addMoveCallback:function(t,e){this.moveCallbacks.push({callback:t,context:e})},addTouchLockCallback:function(t,e,i){void 0===i&&(i=!1),this.touchLockCallbacks.push({callback:t,context:e,onEnd:i})},removeTouchLockCallback:function(t,e){for(var i=this.touchLockCallbacks.length;i--;)if(this.touchLockCallbacks[i].callback===t&&this.touchLockCallbacks[i].context===e)return this.touchLockCallbacks.splice(i,1),!0;return!1},executeTouchLockCallbacks:function(t,e){for(var i=this.touchLockCallbacks.length;i--;){var s=this.touchLockCallbacks[i];s.onEnd===t&&s.callback.call(s.context,this,e)&&this.touchLockCallbacks.splice(i,1)}},deleteMoveCallback:function(t,e){for(var i=this.moveCallbacks.length;i--;)if(this.moveCallbacks[i].callback===t&&this.moveCallbacks[i].context===e)return void this.moveCallbacks.splice(i,1)},addPointer:function(){if(this.pointers.length>=e.Input.MAX_POINTERS)return console.warn("Phaser.Input.addPointer: Maximum limit of "+e.Input.MAX_POINTERS+" pointers reached."),null;var t=this.pointers.length+1,i=new e.Pointer(this.game,t,e.PointerMode.CONTACT);return this.pointers.push(i),this["pointer"+t]=i,i},update:function(){if(this.keyboard&&this.keyboard.update(),this.pollRate>0&&this._pollCounter<this.pollRate)this._pollCounter++;else{this.speed.x=this.position.x-this._oldPosition.x,this.speed.y=this.position.y-this._oldPosition.y,this._oldPosition.copyFrom(this.position),this.mousePointer.update(),this.gamepad&&this.gamepad.active&&this.gamepad.update();for(var t=0;t<this.pointers.length;t++)this.pointers[t].update();this._pollCounter=0}},pauseUpdate:function(){this.gamepad&&this.gamepad.active&&this.gamepad.update()},reset:function(t){if(this.game.isBooted&&!this.resetLocked){void 0===t&&(t=!1),this.mousePointer.reset(),this.keyboard&&this.keyboard.reset(t);for(var i=0;i<this.pointers.length;i++)this.pointers[i].reset();"none"!==this.game.canvas.style.cursor&&(this.game.canvas.style.cursor=""),t&&(this.onDown.dispose(),this.onUp.dispose(),this.onTap.dispose(),this.onHold.dispose(),this.onDown=new e.Signal,this.onUp=new e.Signal,this.onTap=new e.Signal,this.onHold=new e.Signal,this.moveCallbacks=[]),this._pollCounter=0}},resetSpeed:function(t,e){this._oldPosition.setTo(t,e),this.speed.setTo(0,0)},startPointer:function(t){if(this.maxPointers>=0&&this.countActivePointers(this.maxPointers)>=this.maxPointers)return null;if(!this.pointer1.active)return this.pointer1.start(t);if(!this.pointer2.active)return this.pointer2.start(t);for(var e=2;e<this.pointers.length;e++){var i=this.pointers[e];if(!i.active)return i.start(t)}return null},updatePointer:function(t){if(this.pointer1.active&&this.pointer1.identifier===t.identifier)return this.pointer1.move(t);if(this.pointer2.active&&this.pointer2.identifier===t.identifier)return this.pointer2.move(t);for(var e=2;e<this.pointers.length;e++){var i=this.pointers[e];if(i.active&&i.identifier===t.identifier)return i.move(t)}return null},stopPointer:function(t){if(this.pointer1.active&&this.pointer1.identifier===t.identifier)return this.pointer1.stop(t);if(this.pointer2.active&&this.pointer2.identifier===t.identifier)return this.pointer2.stop(t);for(var e=2;e<this.pointers.length;e++){var i=this.pointers[e];if(i.active&&i.identifier===t.identifier)return i.stop(t)}return null},countActivePointers:function(t){void 0===t&&(t=this.pointers.length);for(var e=t,i=0;i<this.pointers.length&&e>0;i++)this.pointers[i].active&&e--;return t-e},getPointer:function(t){void 0===t&&(t=!1);for(var e=0;e<this.pointers.length;e++){var i=this.pointers[e];if(i.active===t)return i}return null},getPointerFromIdentifier:function(t){for(var e=0;e<this.pointers.length;e++){var i=this.pointers[e];if(i.identifier===t)return i}return null},getPointerFromId:function(t){for(var e=0;e<this.pointers.length;e++){var i=this.pointers[e];if(i.pointerId===t)return i}return null},getLocalPosition:function(t,i,s){void 0===s&&(s=new e.Point);var n=t.worldTransform,r=1/(n.a*n.d+n.c*-n.b);return s.setTo(n.d*r*i.x+-n.c*r*i.y+(n.ty*n.c-n.tx*n.d)*r,n.a*r*i.y+-n.b*r*i.x+(-n.ty*n.a+n.tx*n.b)*r)},hitTest:function(t,i,s){if(!t.worldVisible)return!1;if(this.getLocalPosition(t,i,this._localPoint),s.copyFrom(this._localPoint),t.hitArea&&t.hitArea.contains)return t.hitArea.contains(this._localPoint.x,this._localPoint.y);if(e.Creature&&t instanceof e.Creature){var n=Math.abs(t.width),r=Math.abs(t.height),o=t.x-n*t.anchorX;if(this.game.camera.x+i.x>=o&&this.game.camera.x+i.x<o+n){a=t.y-r*t.anchorY;if(this.game.camera.y+i.y>=a&&this.game.camera.y+i.y<a+r)return!0}}else if(t instanceof e.TileSprite){var n=t.width,r=t.height,o=-n*t.anchor.x;if(this._localPoint.x>=o&&this._localPoint.x<o+n){a=-r*t.anchor.y;if(this._localPoint.y>=a&&this._localPoint.y<a+r)return!0}}else if(t instanceof PIXI.Sprite){var n=t.texture.frame.width/t.texture.baseTexture.resolution,r=t.texture.frame.height/t.texture.baseTexture.resolution,o=-n*t.anchor.x;if(this._localPoint.x>=o&&this._localPoint.x<o+n){var a=-r*t.anchor.y;if(this._localPoint.y>=a&&this._localPoint.y<a+r)return!0}}else if(t instanceof e.Graphics)for(l=0;l<t.graphicsData.length;l++){var h=t.graphicsData[l];if(h.fill&&(h.shape&&h.shape.contains(this._localPoint.x,this._localPoint.y)))return!0}for(var l=0;l<t.children.length;l++)if(this.hitTest(t.children[l],i,s))return!0;return!1},onClickTrampoline:function(){this.activePointer.processClickTrampolines()}},e.Input.prototype.constructor=e.Input,Object.defineProperty(e.Input.prototype,"x",{get:function(){return this._x},set:function(t){this._x=Math.floor(t)}}),Object.defineProperty(e.Input.prototype,"y",{get:function(){return this._y},set:function(t){this._y=Math.floor(t)}}),Object.defineProperty(e.Input.prototype,"pollLocked",{get:function(){return this.pollRate>0&&this._pollCounter<this.pollRate}}),Object.defineProperty(e.Input.prototype,"totalInactivePointers",{get:function(){return this.pointers.length-this.countActivePointers()}}),Object.defineProperty(e.Input.prototype,"totalActivePointers",{get:function(){return this.countActivePointers()}}),Object.defineProperty(e.Input.prototype,"worldX",{get:function(){return this.game.camera.view.x+this.x}}),Object.defineProperty(e.Input.prototype,"worldY",{get:function(){return this.game.camera.view.y+this.y}}),e.Mouse=function(t){this.game=t,this.input=t.input,this.callbackContext=this.game,this.mouseDownCallback=null,this.mouseUpCallback=null,this.mouseOutCallback=null,this.mouseOverCallback=null,this.capture=!1,this.active=!1,this.enabled=!0,this.stopOnGameOut=!1,this.event=null,this._onMouseDown=null,this._onMouseMove=null,this._onMouseUp=null,this._onMouseOut=null,this._onMouseOver=null},e.Mouse.NO_BUTTON=-1,e.Mouse.LEFT_BUTTON=0,e.Mouse.MIDDLE_BUTTON=1,e.Mouse.RIGHT_BUTTON=2,e.Mouse.BACK_BUTTON=3,e.Mouse.FORWARD_BUTTON=4,e.Mouse.WHEEL_UP=1,e.Mouse.WHEEL_DOWN=-1,e.Mouse.prototype={start:function(){var t=this.game.device;if(t.isAndroidStockBrowser()&&this.input.touch.active)return!1;if(null!==this._onMouseDown)return!1;var e=this;this._onMouseDown=function(t){return e.onMouseDown(t)},this._onMouseMove=function(t){return e.onMouseMove(t)},this._onMouseUp=function(t){return e.onMouseUp(t)},this._onMouseUpGlobal=function(t){return e.onMouseUpGlobal(t)},this._onMouseOutGlobal=function(t){return e.onMouseOutGlobal(t)},this._onMouseOut=function(t){return e.onMouseOut(t)},this._onMouseOver=function(t){return e.onMouseOver(t)};var i=this.game.canvas;return i.addEventListener("mousedown",this._onMouseDown,!0),i.addEventListener("mousemove",this._onMouseMove,!0),i.addEventListener("mouseup",this._onMouseUp,!0),t.cocoonJS||(window.addEventListener("mouseup",this._onMouseUpGlobal,!0),window.addEventListener("mouseout",this._onMouseOutGlobal,!0),i.addEventListener("mouseover",this._onMouseOver,!0),i.addEventListener("mouseout",this._onMouseOut,!0)),this.active=!0,!0},onMouseDown:function(t){this.event=t,this.capture&&t.preventDefault(),this.mouseDownCallback&&this.mouseDownCallback.call(this.callbackContext,t),this.input.enabled&&this.enabled&&(t.identifier=0,this.input.mousePointer.start(t))},onMouseMove:function(t){this.event=t,this.capture&&t.preventDefault(),this.mouseMoveCallback&&this.mouseMoveCallback.call(this.callbackContext,t),this.input.enabled&&this.enabled&&(t.identifier=0,this.input.mousePointer.move(t))},onMouseUp:function(t){this.event=t,this.capture&&t.preventDefault(),this.mouseUpCallback&&this.mouseUpCallback.call(this.callbackContext,t),this.input.enabled&&this.enabled&&(t.identifier=0,this.input.mousePointer.stop(t))},onMouseUpGlobal:function(t){this.input.mousePointer.withinGame||(this.mouseUpCallback&&this.mouseUpCallback.call(this.callbackContext,t),t.identifier=0,this.input.mousePointer.stop(t))},onMouseOutGlobal:function(t){this.event=t,this.capture&&t.preventDefault(),this.input.mousePointer.withinGame=!1,this.input.enabled&&this.enabled&&(this.input.mousePointer.stop(t),this.input.mousePointer.resetButtons())},onMouseOut:function(t){if(this.event=t,this.capture&&t.preventDefault(),this.input.mousePointer.withinGame=!1,this.mouseOutCallback&&this.mouseOutCallback.call(this.callbackContext,t),this.input.enabled&&this.enabled){this.stopOnGameOut&&(t.identifier=0,this.input.mousePointer.stop(t));for(var e=this.input.interactiveItems.list,i=e.length;i--;){var s=e[i];s.enabled&&s._pointerOutHandler(this.input.mousePointer)}}},onMouseOver:function(t){this.event=t,this.capture&&t.preventDefault(),this.input.mousePointer.withinGame=!0,this.mouseOverCallback&&this.mouseOverCallback.call(this.callbackContext,t)},releasePointerLock:function(){return console.warn("Deprecated. Please use `input.pointerLock.exit()` instead."),this.input.pointerLock.exit()},requestPointerLock:function(){return console.warn("Deprecated. Please use `input.pointerLock.request()` instead."),this.input.pointerLock.request()},stop:function(){var t=this.game.canvas;t.removeEventListener("mousedown",this._onMouseDown,!0),t.removeEventListener("mousemove",this._onMouseMove,!0),t.removeEventListener("mouseup",this._onMouseUp,!0),t.removeEventListener("mouseover",this._onMouseOver,!0),t.removeEventListener("mouseout",this._onMouseOut,!0),window.removeEventListener("mouseup",this._onMouseUpGlobal,!0),window.removeEventListener("mouseout",this._onMouseOutGlobal,!0),this.active=!1}},e.Mouse.prototype.constructor=e.Mouse,Object.defineProperty(e.Mouse.prototype,"locked",{get:function(){return this.input.pointerLock.locked}}),Object.defineProperty(e.Mouse.prototype,"pointerLock",{get:function(){return this.input.pointerLock.onChange}}),Object.defineProperty(e.Mouse.prototype,"mouseWheelCallback",{get:function(){return this.input.mouseWheel.callback},set:function(t){this.input.mouseWheel.callback=t}}),Object.defineProperty(e.Mouse.prototype,"wheelDelta",{get:function(){return this.input.mouseWheel.delta}}),e.MouseWheel=function(t){this.game=t,this.input=t.input,this.element=t.canvas,this.preventDefault=!0,this.active=!1,this.callback=null,this.callbackContext=t,this.delta=0,this.wheelEventName=t.device.wheelEvent,this.boundOnWheelHandler=this.onWheelHandler.bind(this),this.eventProxy=null},e.MouseWheel.UP=1,e.MouseWheel.DOWN=-1,e.MouseWheel.prototype.start=function(){return!(!this.wheelEventName||this.active)&&(this.element.addEventListener(this.wheelEventName,this.boundOnWheelHandler,!0),"mousewheel"===this.wheelEventName?this.eventProxy=new e.WheelEventProxy(-.025,1):"DOMMouseScroll"===this.wheelEventName&&(this.eventProxy=new e.WheelEventProxy(1,1)),this.active=!0,!0)},e.MouseWheel.prototype.stop=function(){this.active&&(this.element.removeEventListener(this.wheelEventName,this.boundOnWheelHandler,!0),this.active=!1)},e.MouseWheel.prototype.onWheelHandler=function(t){this.eventProxy&&(t=this.eventProxy.bindEvent(t)),this.preventDefault&&t.preventDefault(),this.delta=e.Math.clamp(-t.deltaY,-1,1),this.callback&&this.callback.call(this.callbackContext,t)},e.MSPointer=function(t){this.game=t,this.input=t.input,this.callbackContext=this.game,this.pointerDownCallback=null,this.pointerMoveCallback=null,this.pointerUpCallback=null,this.capture=!1,this.event=null,this.active=!1,this.enabled=!0,this._onMSPointerDown=null,this._onMSPointerMove=null,this._onMSPointerUp=null,this._onMSPointerUpGlobal=null,this._onMSPointerOut=null,this._onMSPointerOver=null},e.MSPointer.prototype={start:function(){if(!this.game.device.mspointer)return!1;if(null!==this._onMSPointerDown)return!1;var t=this;this._onMSPointerDown=function(e){return t.onPointerDown(e)},this._onMSPointerMove=function(e){return t.onPointerMove(e)},this._onMSPointerUp=function(e){return t.onPointerUp(e)},this._onMSPointerUpGlobal=function(e){return t.onPointerUpGlobal(e)},this._onMSPointerOut=function(e){return t.onPointerOut(e)},this._onMSPointerOver=function(e){return t.onPointerOver(e)};var e=this.game.canvas;return e.addEventListener("MSPointerDown",this._onMSPointerDown,!1),e.addEventListener("MSPointerMove",this._onMSPointerMove,!1),e.addEventListener("MSPointerUp",this._onMSPointerUp,!1),e.addEventListener("pointerdown",this._onMSPointerDown,!1),e.addEventListener("pointermove",this._onMSPointerMove,!1),e.addEventListener("pointerup",this._onMSPointerUp,!1),e.style["-ms-content-zooming"]="none",e.style["-ms-touch-action"]="none",this.game.device.cocoonJS||(window.addEventListener("MSPointerUp",this._onMSPointerUpGlobal,!0),e.addEventListener("MSPointerOver",this._onMSPointerOver,!0),e.addEventListener("MSPointerOut",this._onMSPointerOut,!0),window.addEventListener("pointerup",this._onMSPointerUpGlobal,!0),e.addEventListener("pointerover",this._onMSPointerOver,!0),e.addEventListener("pointerout",this._onMSPointerOut,!0)),this.active=!0,!0},onPointerDown:function(t){this.game.input.executeTouchLockCallbacks(!1,t),this.event=t,this.capture&&t.preventDefault(),this.pointerDownCallback&&this.pointerDownCallback.call(this.callbackContext,t),this.input.enabled&&this.enabled&&(t.identifier=t.pointerId,"mouse"===t.pointerType||4===t.pointerType?this.input.mousePointer.start(t):this.input.startPointer(t))},onPointerMove:function(t){this.event=t,this.capture&&t.preventDefault(),this.pointerMoveCallback&&this.pointerMoveCallback.call(this.callbackContext,t),this.input.enabled&&this.enabled&&(t.identifier=t.pointerId,"mouse"===t.pointerType||4===t.pointerType?this.input.mousePointer.move(t):this.input.updatePointer(t))},onPointerUp:function(t){this.game.input.executeTouchLockCallbacks(!0,t),this.event=t,this.capture&&t.preventDefault(),this.pointerUpCallback&&this.pointerUpCallback.call(this.callbackContext,t),this.input.enabled&&this.enabled&&(t.identifier=t.pointerId,"mouse"===t.pointerType||4===t.pointerType?this.input.mousePointer.stop(t):this.input.stopPointer(t))},onPointerUpGlobal:function(t){if("mouse"!==t.pointerType&&4!==t.pointerType||this.input.mousePointer.withinGame){var e=this.input.getPointerFromIdentifier(t.identifier);e&&e.withinGame&&this.onPointerUp(t)}else this.onPointerUp(t)},onPointerOut:function(t){if(this.event=t,this.capture&&t.preventDefault(),"mouse"===t.pointerType||4===t.pointerType)this.input.mousePointer.withinGame=!1;else{var e=this.input.getPointerFromIdentifier(t.identifier);e&&(e.withinGame=!1)}this.input.mouse.mouseOutCallback&&this.input.mouse.mouseOutCallback.call(this.input.mouse.callbackContext,t),this.input.enabled&&this.enabled&&this.input.mouse.stopOnGameOut&&(t.identifier=0,e?e.stop(t):this.input.mousePointer.stop(t))},onPointerOver:function(t){if(this.event=t,this.capture&&t.preventDefault(),"mouse"===t.pointerType||4===t.pointerType)this.input.mousePointer.withinGame=!0;else{var e=this.input.getPointerFromIdentifier(t.identifier);e&&(e.withinGame=!0)}this.input.mouse.mouseOverCallback&&this.input.mouse.mouseOverCallback.call(this.input.mouse.callbackContext,t)},stop:function(){var t=this.game.canvas;t.removeEventListener("MSPointerDown",this._onMSPointerDown,!1),t.removeEventListener("MSPointerMove",this._onMSPointerMove,!1),t.removeEventListener("MSPointerUp",this._onMSPointerUp,!1),t.removeEventListener("pointerdown",this._onMSPointerDown,!1),t.removeEventListener("pointermove",this._onMSPointerMove,!1),t.removeEventListener("pointerup",this._onMSPointerUp,!1),window.removeEventListener("MSPointerUp",this._onMSPointerUpGlobal,!0),t.removeEventListener("MSPointerOver",this._onMSPointerOver,!0),t.removeEventListener("MSPointerOut",this._onMSPointerOut,!0),window.removeEventListener("pointerup",this._onMSPointerUpGlobal,!0),t.removeEventListener("pointerover",this._onMSPointerOver,!0),t.removeEventListener("pointerout",this._onMSPointerOut,!0),this.active=!1}},e.MSPointer.prototype.constructor=e.MSPointer,e.DeviceButton=function(t,i){this.parent=t,this.game=t.game,this.event=null,this.isDown=!1,this.isUp=!0,this.timeDown=0,this.timeUp=0,this.repeats=0,this.altKey=!1,this.shiftKey=!1,this.ctrlKey=!1,this.value=0,this.buttonCode=i,this.onDown=new e.Signal,this.onUp=new e.Signal,this.onFloat=new e.Signal},e.DeviceButton.prototype={start:function(t,e){this.isDown||(this.isDown=!0,this.isUp=!1,this.timeDown=this.game.time.time,this.repeats=0,this.event=t,this.value=e,t&&(this.altKey=t.altKey,this.shiftKey=t.shiftKey,this.ctrlKey=t.ctrlKey),this.onDown.dispatch(this,e))},stop:function(t,e){this.isUp||(this.isDown=!1,this.isUp=!0,this.timeUp=this.game.time.time,this.event=t,this.value=e,t&&(this.altKey=t.altKey,this.shiftKey=t.shiftKey,this.ctrlKey=t.ctrlKey),this.onUp.dispatch(this,e))},startStop:function(t,e,i){t?this.start(e,i):this.stop(e,i)},padFloat:function(t){this.isDown=!1,this.isUp=!1,this.value=t,this.onFloat.dispatch(this,t)},justPressed:function(t){return t=t||250,this.isDown&&this.timeDown+t>this.game.time.time},justReleased:function(t){return t=t||250,this.isUp&&this.timeUp+t>this.game.time.time},reset:function(){this.isDown=!1,this.isUp=!0,this.timeDown=this.game.time.time,this.repeats=0,this.altKey=!1,this.shiftKey=!1,this.ctrlKey=!1},destroy:function(){this.onDown.dispose(),this.onUp.dispose(),this.onFloat.dispose(),this.parent=null,this.game=null}},e.DeviceButton.prototype.constructor=e.DeviceButton,Object.defineProperty(e.DeviceButton.prototype,"duration",{get:function(){return this.isUp?-1:this.game.time.time-this.timeDown}}),e.Pointer=function(t,i,s){this.game=t,this.id=i,this.type=e.POINTER,this.exists=!0,this.identifier=0,this.pointerId=null,this.pointerMode=s||e.PointerMode.CURSOR|e.PointerMode.CONTACT,this.target=null,this.button=null,this.leftButton=new e.DeviceButton(this,e.Pointer.LEFT_BUTTON),this.middleButton=new e.DeviceButton(this,e.Pointer.MIDDLE_BUTTON),this.rightButton=new e.DeviceButton(this,e.Pointer.RIGHT_BUTTON),this.backButton=new e.DeviceButton(this,e.Pointer.BACK_BUTTON),this.forwardButton=new e.DeviceButton(this,e.Pointer.FORWARD_BUTTON),this.eraserButton=new e.DeviceButton(this,e.Pointer.ERASER_BUTTON),this._holdSent=!1,this._history=[],this._nextDrop=0,this._stateReset=!1,this.withinGame=!1,this.clientX=-1,this.clientY=-1,this.pageX=-1,this.pageY=-1,this.screenX=-1,this.screenY=-1,this.rawMovementX=0,this.rawMovementY=0,this.movementX=0,this.movementY=0,this.x=-1,this.y=-1,this.isMouse=0===i,this.isDown=!1,this.isUp=!0,this.timeDown=0,this.timeUp=0,this.previousTapTime=0,this.totalTouches=0,this.msSinceLastClick=Number.MAX_VALUE,this.targetObject=null,this.interactiveCandidates=[],this.active=!1,this.dirty=!1,this.position=new e.Point,this.positionDown=new e.Point,this.positionUp=new e.Point,this.circle=new e.Circle(0,0,44),this._clickTrampolines=null,this._trampolineTargetObject=null},e.Pointer.NO_BUTTON=0,e.Pointer.LEFT_BUTTON=1,e.Pointer.RIGHT_BUTTON=2,e.Pointer.MIDDLE_BUTTON=4,e.Pointer.BACK_BUTTON=8,e.Pointer.FORWARD_BUTTON=16,e.Pointer.ERASER_BUTTON=32,e.Pointer.prototype={resetButtons:function(){this.isDown=!1,this.isUp=!0,this.isMouse&&(this.leftButton.reset(),this.middleButton.reset(),this.rightButton.reset(),this.backButton.reset(),this.forwardButton.reset(),this.eraserButton.reset())},processButtonsDown:function(t,i){switch(t){case e.Mouse.LEFT_BUTTON:this.leftButton.start(i);break;case e.Mouse.RIGHT_BUTTON:this.rightButton.start(i);break;case e.Mouse.MIDDLE_BUTTON:this.middleButton.start(i);break;case e.Mouse.BACK_BUTTON:this.backButton.start(i);break;case e.Mouse.FORWARD_BUTTON:this.forwardButton.start(i)}},processButtonsUp:function(t,i){switch(t){case e.Mouse.LEFT_BUTTON:this.leftButton.stop(i);break;case e.Mouse.RIGHT_BUTTON:this.rightButton.stop(i);break;case e.Mouse.MIDDLE_BUTTON:this.middleButton.stop(i);break;case e.Mouse.BACK_BUTTON:this.backButton.stop(i);break;case e.Mouse.FORWARD_BUTTON:this.forwardButton.stop(i)}},processButtonsUpDown:function(t,i){var s=i.type.toLowerCase().substr(-4),n="down"===s,r="move"===s;void 0!==t?(n&&1===t&&i.ctrlKey&&(t=2),this.leftButton.startStop(e.Pointer.LEFT_BUTTON&t,i),this.rightButton.startStop(e.Pointer.RIGHT_BUTTON&t,i),this.middleButton.startStop(e.Pointer.MIDDLE_BUTTON&t,i),this.backButton.startStop(e.Pointer.BACK_BUTTON&t,i),this.forwardButton.startStop(e.Pointer.FORWARD_BUTTON&t,i),this.eraserButton.startStop(e.Pointer.ERASER_BUTTON&t,i)):void 0!==i.button?n&&i.ctrlKey&&0===i.button?this.rightButton.start(i):n?this.processButtonsDown(i.button,i):r||this.processButtonsUp(i.button,i):n?i.ctrlKey?this.rightButton.start(i):this.leftButton.start(i):(this.leftButton.stop(i),this.rightButton.stop(i))},updateButtons:function(t){this.button=t.button,this.processButtonsUpDown(t.buttons,t),this.isUp=!0,this.isDown=!1,(this.leftButton.isDown||this.rightButton.isDown||this.middleButton.isDown||this.backButton.isDown||this.forwardButton.isDown||this.eraserButton.isDown)&&(this.isUp=!1,this.isDown=!0)},start:function(t){var i=this.game.input;return t.pointerId&&(this.pointerId=t.pointerId),this.identifier=t.identifier,this.target=t.target,this.isMouse?this.updateButtons(t):(this.isDown=!0,this.isUp=!1),this.active=!0,this.withinGame=!0,this.dirty=!1,this._history=[],this._clickTrampolines=null,this._trampolineTargetObject=null,this.msSinceLastClick=this.game.time.time-this.timeDown,this.timeDown=this.game.time.time,this._holdSent=!1,this.move(t,!0),this.positionDown.setTo(this.x,this.y),(i.multiInputOverride===e.Input.MOUSE_OVERRIDES_TOUCH||i.multiInputOverride===e.Input.MOUSE_TOUCH_COMBINE||i.multiInputOverride===e.Input.TOUCH_OVERRIDES_MOUSE&&0===i.totalActivePointers)&&(i.x=this.x,i.y=this.y,i.position.setTo(this.x,this.y),i.onDown.dispatch(this,t),i.resetSpeed(this.x,this.y)),this._stateReset=!1,this.totalTouches++,null!==this.targetObject&&this.targetObject._touchedHandler(this),this},update:function(){var t=this.game.input;this.active&&(this.dirty&&(t.interactiveItems.total>0&&this.processInteractiveObjects(!1),this.dirty=!1),!1===this._holdSent&&this.duration>=t.holdRate&&((t.multiInputOverride===e.Input.MOUSE_OVERRIDES_TOUCH||t.multiInputOverride===e.Input.MOUSE_TOUCH_COMBINE||t.multiInputOverride===e.Input.TOUCH_OVERRIDES_MOUSE&&0===t.totalActivePointers)&&t.onHold.dispatch(this),this._holdSent=!0),t.recordPointerHistory&&this.game.time.time>=this._nextDrop&&(this._nextDrop=this.game.time.time+t.recordRate,this._history.push({x:this.position.x,y:this.position.y}),this._history.length>t.recordLimit&&this._history.shift()))},move:function(t,i){var s=this.game.input;if(!s.pollLocked){void 0===i&&(i=!1),void 0!==t.button&&(this.button=t.button),this.isMouse&&this.updateButtons(t),this.clientX=t.clientX,this.clientY=t.clientY,this.pageX=t.pageX,this.pageY=t.pageY,this.screenX=t.screenX,this.screenY=t.screenY,this.isMouse&&s.mouse.locked&&!i&&(this.rawMovementX=t.movementX||t.mozMovementX||t.webkitMovementX||0,this.rawMovementY=t.movementY||t.mozMovementY||t.webkitMovementY||0,this.movementX+=this.rawMovementX,this.movementY+=this.rawMovementY),this.x=(this.pageX-this.game.scale.offset.x)*s.scale.x,this.y=(this.pageY-this.game.scale.offset.y)*s.scale.y,this.position.setTo(this.x,this.y),this.circle.x=this.x,this.circle.y=this.y,(s.multiInputOverride===e.Input.MOUSE_OVERRIDES_TOUCH||s.multiInputOverride===e.Input.MOUSE_TOUCH_COMBINE||s.multiInputOverride===e.Input.TOUCH_OVERRIDES_MOUSE&&0===s.totalActivePointers)&&(s.activePointer=this,s.x=this.x,s.y=this.y,s.position.setTo(s.x,s.y),s.circle.x=s.x,s.circle.y=s.y),this.withinGame=this.game.scale.bounds.contains(this.pageX,this.pageY);for(var n=s.moveCallbacks.length;n--;)s.moveCallbacks[n].callback.call(s.moveCallbacks[n].context,this,this.x,this.y,i,t);return null===this.targetObject||this.game.paused&&!this.targetObject.noPause||!0!==this.targetObject.isDragged?s.interactiveItems.total>0&&this.processInteractiveObjects(i):!1===this.targetObject.update(this)&&(this.targetObject=null),this}},processInteractiveObjects:function(t){var e=0,i=-1,s=null,n=this.game.input.interactiveItems.first;for(this.interactiveCandidates=[];n;)n.checked=!1,!n.validForInput(i,e,!1)||this.game.paused&&!n.sprite.noPause||(n.checked=!0,(t&&n.checkPointerDown(this,!0)||!t&&n.checkPointerOver(this,!0))&&(e=n.sprite.renderOrderID,i=n.priorityID,s=n,this.interactiveCandidates.push(n))),n=this.game.input.interactiveItems.next;for(n=this.game.input.interactiveItems.first;n;)!n.checked&&n.validForInput(i,e,!0)&&(t&&n.checkPointerDown(this,!1)||!t&&n.checkPointerOver(this,!1))&&(e=n.sprite.renderOrderID,i=n.priorityID,s=n,this.interactiveCandidates.push(n)),n=this.game.input.interactiveItems.next;return this.game.input.customCandidateHandler&&(s=this.game.input.customCandidateHandler.call(this.game.input.customCandidateHandlerContext,this,this.interactiveCandidates,s)),this.swapTarget(s,!1),null!==this.targetObject},swapTarget:function(t,e){void 0===e&&(e=!1),null===t?this.targetObject&&(this.targetObject._pointerOutHandler(this,e),this.targetObject=null):null===this.targetObject?(this.targetObject=t,t._pointerOverHandler(this,e)):this.targetObject===t?!1===t.update(this)&&(this.targetObject=null):(this.targetObject._pointerOutHandler(this,e),this.targetObject=t,this.targetObject._pointerOverHandler(this,e))},leave:function(t){this.withinGame=!1,this.move(t,!1)},stop:function(t){var i=this.game.input;{if(!this._stateReset||!this.withinGame){if(this.timeUp=this.game.time.time,(i.multiInputOverride===e.Input.MOUSE_OVERRIDES_TOUCH||i.multiInputOverride===e.Input.MOUSE_TOUCH_COMBINE||i.multiInputOverride===e.Input.TOUCH_OVERRIDES_MOUSE&&0===i.totalActivePointers)&&(i.onUp.dispatch(this,t),this.duration>=0&&this.duration<=i.tapRate)){var s=this.timeUp-this.previousTapTime<i.doubleTapRate;i.onTap.dispatch(this,s,t),this.previousTapTime=this.timeUp}return this.isMouse?this.updateButtons(t):(this.isDown=!1,this.isUp=!0),this.id>0&&(this.active=!1),this.withinGame=this.game.scale.bounds.contains(t.pageX,t.pageY),this.pointerId=null,this.identifier=null,this.positionUp.setTo(this.x,this.y),!1===this.isMouse&&i.currentPointers--,i.interactiveItems.callAll("_releasedHandler",this),this._clickTrampolines&&(this._trampolineTargetObject=this.targetObject),this.targetObject=null,this}t.preventDefault()}},justPressed:function(t){return t=t||this.game.input.justPressedRate,!0===this.isDown&&this.timeDown+t>this.game.time.time},justReleased:function(t){return t=t||this.game.input.justReleasedRate,this.isUp&&this.timeUp+t>this.game.time.time},addClickTrampoline:function(t,e,i,s){if(this.isDown){for(var n=this._clickTrampolines=this._clickTrampolines||[],r=0;r<n.length;r++)if(n[r].name===t){n.splice(r,1);break}n.push({name:t,targetObject:this.targetObject,callback:e,callbackContext:i,callbackArgs:s})}},processClickTrampolines:function(){var t=this._clickTrampolines;if(t){for(var e=0;e<t.length;e++){var i=t[e];i.targetObject===this._trampolineTargetObject&&i.callback.apply(i.callbackContext,i.callbackArgs)}this._clickTrampolines=null,this._trampolineTargetObject=null}},reset:function(){!1===this.isMouse&&(this.active=!1),this.pointerId=null,this.identifier=null,this.dirty=!1,this.totalTouches=0,this._holdSent=!1,this._history.length=0,this._stateReset=!0,this.resetButtons(),this.targetObject&&this.targetObject._releasedHandler(this),this.targetObject=null},resetMovement:function(){this.movementX=0,this.movementY=0}},e.Pointer.prototype.constructor=e.Pointer,Object.defineProperty(e.Pointer.prototype,"duration",{get:function(){return this.isUp?-1:this.game.time.time-this.timeDown}}),Object.defineProperty(e.Pointer.prototype,"worldX",{get:function(){return this.game.world.camera.x+this.x}}),Object.defineProperty(e.Pointer.prototype,"worldY",{get:function(){return this.game.world.camera.y+this.y}}),e.PointerMode={CURSOR:1,CONTACT:2},e.PointerModes={},e.PointerModes[e.PointerMode.CURSOR]="CURSOR",e.PointerModes[e.PointerMode.CONTACT]="CONTACT",e.Touch=function(t){this.game=t,this.active=!1,this.enabled=!0,this.callbackContext=this.game,this.touchStartCallback=null,this.touchMoveCallback=null,this.touchEndCallback=null,this.touchEnterCallback=null,this.touchLeaveCallback=null,this.touchCancelCallback=null,this.preventDefault=!0,this.event=null,this._onTouchStart=null,this._onTouchMove=null,this._onTouchEnd=null,this._onTouchEnter=null,this._onTouchLeave=null,this._onTouchCancel=null,this._onTouchMove=null},e.Touch.prototype={start:function(){if(!this.game.device.touch)return!1;if(null!==this._onTouchStart)return!1;var t=this;return this._onTouchStart=function(e){return t.onTouchStart(e)},this._onTouchMove=function(e){return t.onTouchMove(e)},this._onTouchEnd=function(e){return t.onTouchEnd(e)},this._onTouchEnter=function(e){return t.onTouchEnter(e)},this._onTouchLeave=function(e){return t.onTouchLeave(e)},this._onTouchCancel=function(e){return t.onTouchCancel(e)},this.game.canvas.addEventListener("touchstart",this._onTouchStart,!1),this.game.canvas.addEventListener("touchmove",this._onTouchMove,!1),this.game.canvas.addEventListener("touchend",this._onTouchEnd,!1),this.game.canvas.addEventListener("touchcancel",this._onTouchCancel,!1),this.game.device.cocoonJS||(this.game.canvas.addEventListener("touchenter",this._onTouchEnter,!1),this.game.canvas.addEventListener("touchleave",this._onTouchLeave,!1)),this.active=!0,!0},consumeDocumentTouches:function(){this._documentTouchMove=function(t){t.preventDefault()},document.addEventListener("touchmove",this._documentTouchMove,!1)},onTouchStart:function(t){if(this.game.input.executeTouchLockCallbacks(!1,t),this.event=t,this.game.input.enabled&&this.enabled){this.touchStartCallback&&this.touchStartCallback.call(this.callbackContext,t),this.preventDefault&&t.preventDefault();for(var e=0;e<t.changedTouches.length;e++)this.game.input.startPointer(t.changedTouches[e])}},onTouchCancel:function(t){if(this.event=t,this.touchCancelCallback&&this.touchCancelCallback.call(this.callbackContext,t),this.game.input.enabled&&this.enabled){this.preventDefault&&t.preventDefault();for(var e=0;e<t.changedTouches.length;e++)this.game.input.stopPointer(t.changedTouches[e])}},onTouchEnter:function(t){this.event=t,this.touchEnterCallback&&this.touchEnterCallback.call(this.callbackContext,t),this.game.input.enabled&&this.enabled&&this.preventDefault&&t.preventDefault()},onTouchLeave:function(t){this.event=t,this.touchLeaveCallback&&this.touchLeaveCallback.call(this.callbackContext,t),this.preventDefault&&t.preventDefault()},onTouchMove:function(t){this.event=t,this.touchMoveCallback&&this.touchMoveCallback.call(this.callbackContext,t),this.preventDefault&&t.preventDefault();for(var e=0;e<t.changedTouches.length;e++)this.game.input.updatePointer(t.changedTouches[e])},onTouchEnd:function(t){this.game.input.executeTouchLockCallbacks(!0,t),this.event=t,this.touchEndCallback&&this.touchEndCallback.call(this.callbackContext,t),this.preventDefault&&t.preventDefault();for(var e=0;e<t.changedTouches.length;e++)this.game.input.stopPointer(t.changedTouches[e])},stop:function(){this.game.device.touch&&(this.game.canvas.removeEventListener("touchstart",this._onTouchStart),this.game.canvas.removeEventListener("touchmove",this._onTouchMove),this.game.canvas.removeEventListener("touchend",this._onTouchEnd),this.game.canvas.removeEventListener("touchenter",this._onTouchEnter),this.game.canvas.removeEventListener("touchleave",this._onTouchLeave),this.game.canvas.removeEventListener("touchcancel",this._onTouchCancel),this.active=!1)}},e.Touch.prototype.constructor=e.Touch,e.InputHandler=function(t){this.sprite=t,this.game=t.game,this.enabled=!1,this.checked=!1,this.priorityID=0,this.useHandCursor=!1,this._setHandCursor=!1,this.isDragged=!1,this.allowHorizontalDrag=!0,this.allowVerticalDrag=!0,this.bringToTop=!1,this.snapOffset=null,this.snapOnDrag=!1,this.snapOnRelease=!1,this.snapX=0,this.snapY=0,this.snapOffsetX=0,this.snapOffsetY=0,this.pixelPerfectOver=!1,this.pixelPerfectClick=!1,this.pixelPerfectAlpha=255,this.draggable=!1,this.boundsRect=null,this.boundsSprite=null,this.scaleLayer=!1,this.dragOffset=new e.Point,this.dragFromCenter=!1,this.dragStopBlocksInputUp=!1,this.dragStartPoint=new e.Point,this.dragDistanceThreshold=0,this.dragTimeThreshold=0,this.downPoint=new e.Point,this.snapPoint=new e.Point,this._dragPoint=new e.Point,this._dragPhase=!1,this._pendingDrag=!1,this._dragTimePass=!1,this._dragDistancePass=!1,this._wasEnabled=!1,this._tempPoint=new e.Point,this._pointerData=[],this._pointerData.push({id:0,x:0,y:0,camX:0,camY:0,isDown:!1,isUp:!1,isOver:!1,isOut:!1,timeOver:0,timeOut:0,timeDown:0,timeUp:0,downDuration:0,isDragged:!1})},e.InputHandler.prototype={start:function(t,i){if(t=t||0,void 0===i&&(i=!1),!1===this.enabled){this.game.input.interactiveItems.add(this),this.useHandCursor=i,this.priorityID=t;for(var s=0;s<10;s++)this._pointerData[s]={id:s,x:0,y:0,isDown:!1,isUp:!1,isOver:!1,isOut:!1,timeOver:0,timeOut:0,timeDown:0,timeUp:0,downDuration:0,isDragged:!1};this.snapOffset=new e.Point,this.enabled=!0,this._wasEnabled=!0}return this.sprite.events.onAddedToGroup.add(this.addedToGroup,this),this.sprite.events.onRemovedFromGroup.add(this.removedFromGroup,this),this.sprite},addedToGroup:function(){this._dragPhase||this._wasEnabled&&!this.enabled&&this.start()},removedFromGroup:function(){this._dragPhase||(this.enabled?(this._wasEnabled=!0,this.stop()):this._wasEnabled=!1)},reset:function(){this.enabled=!1;for(var t=0;t<10;t++)this._pointerData[t]={id:t,x:0,y:0,isDown:!1,isUp:!1,isOver:!1,isOut:!1,timeOver:0,timeOut:0,timeDown:0,timeUp:0,downDuration:0,isDragged:!1}},stop:function(){!1!==this.enabled&&(this.enabled=!1,this.game.input.interactiveItems.remove(this))},destroy:function(){this.sprite&&(this._setHandCursor&&(this.game.canvas.style.cursor="",this._setHandCursor=!1),this.enabled=!1,this.game.input.interactiveItems.remove(this),this._pointerData.length=0,this.boundsRect=null,this.boundsSprite=null,this.sprite=null)},validForInput:function(t,e,i){return void 0===i&&(i=!0),!(!this.enabled||0===this.sprite.scale.x||0===this.sprite.scale.y||this.priorityID<this.game.input.minPriorityID||this.sprite.parent&&this.sprite.parent.ignoreChildInput)&&(!(!i&&(this.pixelPerfectClick||this.pixelPerfectOver))&&(this.priorityID>t||this.priorityID===t&&this.sprite.renderOrderID>e))},isPixelPerfect:function(){return this.pixelPerfectClick||this.pixelPerfectOver},pointerX:function(t){return t=t||0,this._pointerData[t].x},pointerY:function(t){return t=t||0,this._pointerData[t].y},pointerDown:function(t){return t=t||0,this._pointerData[t].isDown},pointerUp:function(t){return t=t||0,this._pointerData[t].isUp},pointerTimeDown:function(t){return t=t||0,this._pointerData[t].timeDown},pointerTimeUp:function(t){return t=t||0,this._pointerData[t].timeUp},pointerOver:function(t){if(!this.enabled)return!1;if(void 0===t){for(var e=0;e<10;e++)if(this._pointerData[e].isOver)return!0;return!1}return this._pointerData[t].isOver},pointerOut:function(t){if(!this.enabled)return!1;if(void 0!==t)return this._pointerData[t].isOut;for(var e=0;e<10;e++)if(this._pointerData[e].isOut)return!0},pointerTimeOver:function(t){return t=t||0,this._pointerData[t].timeOver},pointerTimeOut:function(t){return t=t||0,this._pointerData[t].timeOut},pointerDragged:function(t){return t=t||0,this._pointerData[t].isDragged},checkPointerDown:function(t,e){return!!(t.isDown&&this.enabled&&this.sprite&&this.sprite.parent&&this.sprite.visible&&this.sprite.parent.visible&&0!==this.sprite.worldScale.x&&0!==this.sprite.worldScale.y)&&(!!this.game.input.hitTest(this.sprite,t,this._tempPoint)&&(void 0===e&&(e=!1),!(!e&&this.pixelPerfectClick)||this.checkPixel(this._tempPoint.x,this._tempPoint.y)))},checkPointerOver:function(t,e){return!!(this.enabled&&this.sprite&&this.sprite.parent&&this.sprite.visible&&this.sprite.parent.visible&&0!==this.sprite.worldScale.x&&0!==this.sprite.worldScale.y)&&(!!this.game.input.hitTest(this.sprite,t,this._tempPoint)&&(void 0===e&&(e=!1),!(!e&&this.pixelPerfectOver)||this.checkPixel(this._tempPoint.x,this._tempPoint.y)))},checkPixel:function(t,e,i){if(this.sprite.texture.baseTexture.source){if(null===t&&null===e){this.game.input.getLocalPosition(this.sprite,i,this._tempPoint);var t=this._tempPoint.x,e=this._tempPoint.y}if(0!==this.sprite.anchor.x&&(t-=-this.sprite.texture.frame.width*this.sprite.anchor.x),0!==this.sprite.anchor.y&&(e-=-this.sprite.texture.frame.height*this.sprite.anchor.y),t+=this.sprite.texture.frame.x,e+=this.sprite.texture.frame.y,this.sprite.texture.trim&&(t-=this.sprite.texture.trim.x,e-=this.sprite.texture.trim.y,t<this.sprite.texture.crop.x||t>this.sprite.texture.crop.right||e<this.sprite.texture.crop.y||e>this.sprite.texture.crop.bottom))return this._dx=t,this._dy=e,!1;if(this._dx=t,this._dy=e,this.game.input.hitContext.clearRect(0,0,1,1),this.game.input.hitContext.drawImage(this.sprite.texture.baseTexture.source,t,e,1,1,0,0,1,1),this.game.input.hitContext.getImageData(0,0,1,1).data[3]>=this.pixelPerfectAlpha)return!0}return!1},update:function(t){if(null!==this.sprite&&void 0!==this.sprite.parent)return this.enabled&&this.sprite.visible&&this.sprite.parent.visible?this._pendingDrag?(this._dragDistancePass||(this._dragDistancePass=e.Math.distance(t.x,t.y,this.downPoint.x,this.downPoint.y)>=this.dragDistanceThreshold),this._dragDistancePass&&this._dragTimePass&&this.startDrag(t),!0):this.draggable&&this._draggedPointerID===t.id?this.updateDrag(t,!1):this._pointerData[t.id].isOver?this.checkPointerOver(t)?(this._pointerData[t.id].x=t.x-this.sprite.x,this._pointerData[t.id].y=t.y-this.sprite.y,!0):(this._pointerOutHandler(t),!1):void 0:(this._pointerOutHandler(t),!1)},_pointerOverHandler:function(t,e){if(null!==this.sprite){var i=this._pointerData[t.id];if(!1===i.isOver||t.dirty){var s=!1===i.isOver;i.isOver=!0,i.isOut=!1,i.timeOver=this.game.time.time,i.x=t.x-this.sprite.x,i.y=t.y-this.sprite.y,this.useHandCursor&&!1===i.isDragged&&(this.game.canvas.style.cursor="pointer",this._setHandCursor=!0),!e&&s&&this.sprite&&this.sprite.events&&this.sprite.events.onInputOver$dispatch(this.sprite,t),this.sprite.parent&&this.sprite.parent.onChildInputOver&&this.sprite.parent.onChildInputOver.dispatch(this.sprite,t)}}},_pointerOutHandler:function(t,e){if(null!==this.sprite){var i=this._pointerData[t.id];i.isOver=!1,i.isOut=!0,i.timeOut=this.game.time.time,this.useHandCursor&&!1===i.isDragged&&(this.game.canvas.style.cursor="",this._setHandCursor=!1),!e&&this.sprite&&this.sprite.events&&(this.sprite.events.onInputOut$dispatch(this.sprite,t),this.sprite&&this.sprite.parent&&this.sprite.parent.onChildInputOut&&this.sprite.parent.onChildInputOut.dispatch(this.sprite,t))}},_touchedHandler:function(t){if(null!==this.sprite){var e=this._pointerData[t.id];if(!e.isDown&&e.isOver){if(this.pixelPerfectClick&&!this.checkPixel(null,null,t))return;if(e.isDown=!0,e.isUp=!1,e.timeDown=this.game.time.time,this.downPoint.set(t.x,t.y),t.dirty=!0,this.sprite&&this.sprite.events&&(this.sprite.events.onInputDown$dispatch(this.sprite,t),this.sprite&&this.sprite.parent&&this.sprite.parent.onChildInputDown&&this.sprite.parent.onChildInputDown.dispatch(this.sprite,t),null===this.sprite))return;this.draggable&&!1===this.isDragged&&(0===this.dragTimeThreshold&&0===this.dragDistanceThreshold?this.startDrag(t):(this._pendingDrag=!0,this._dragDistancePass=0===this.dragDistanceThreshold,this.dragTimeThreshold>0?(this._dragTimePass=!1,this.game.time.events.add(this.dragTimeThreshold,this.dragTimeElapsed,this,t)):this._dragTimePass=!0)),this.bringToTop&&this.sprite.bringToTop()}}},dragTimeElapsed:function(t){this._dragTimePass=!0,this._pendingDrag&&this.sprite&&this._dragDistancePass&&this.startDrag(t)},_releasedHandler:function(t){if(null!==this.sprite){var e=this._pointerData[t.id];if(e.isDown&&t.isUp){e.isDown=!1,e.isUp=!0,e.timeUp=this.game.time.time,e.downDuration=e.timeUp-e.timeDown;var i=this.checkPointerOver(t);this.sprite&&this.sprite.events&&(this.dragStopBlocksInputUp&&(!this.dragStopBlocksInputUp||this.draggable&&this.isDragged&&this._draggedPointerID===t.id)||this.sprite.events.onInputUp$dispatch(this.sprite,t,i),this.sprite&&this.sprite.parent&&this.sprite.parent.onChildInputUp&&this.sprite.parent.onChildInputUp.dispatch(this.sprite,t,i),i&&(i=this.checkPointerOver(t))),e.isOver=i,!i&&this.useHandCursor&&(this.game.canvas.style.cursor="default",this._setHandCursor=!1),t.dirty=!0,this._pendingDrag=!1,this.draggable&&this.isDragged&&this._draggedPointerID===t.id&&this.stopDrag(t)}}},updateDrag:function(t,e){var i=this.game.camera,s=this.dragOffset,n=this._dragPoint,r=this._pointerData[t.id],o=this.snapPoint,a=this.sprite;if(void 0===e&&(e=!1),t.isUp)return this.stopDrag(t),!1;var h=this.globalToLocal(t);if(a.fixedToCamera)var l=i.scale.x*h.x+n.x+s.x,c=i.scale.y*h.y+n.y+s.y;else var l=h.x+n.x+s.x,c=h.y+n.y+s.y;if(a.fixedToCamera){var u=a.cameraOffset,d=u.x,p=u.y;this.allowHorizontalDrag&&(u.x=l-i.x),this.allowVerticalDrag&&(u.y=c-i.y),this.boundsRect&&this.checkBoundsRect(),this.boundsSprite&&this.checkBoundsSprite(),this.snapOnDrag&&(u.x=Math.round((u.x-this.snapOffsetX%this.snapX)/this.snapX)*this.snapX+this.snapOffsetX%this.snapX,u.y=Math.round((u.y-this.snapOffsetY%this.snapY)/this.snapY)*this.snapY+this.snapOffsetY%this.snapY,o.set(u.x,u.y));var f=u.x-d,g=u.y-p}else{var m=i.x-r.camX,y=i.y-r.camY,d=a.x,p=a.y;this.allowHorizontalDrag&&(a.x=l+m),this.allowVerticalDrag&&(a.y=c+y),this.boundsRect&&this.checkBoundsRect(),this.boundsSprite&&this.checkBoundsSprite(),this.snapOnDrag&&(a.x=Math.round((a.x-this.snapOffsetX%this.snapX)/this.snapX)*this.snapX+this.snapOffsetX%this.snapX,a.y=Math.round((a.y-this.snapOffsetY%this.snapY)/this.snapY)*this.snapY+this.snapOffsetY%this.snapY,o.set(a.x,a.y));var f=a.x-d,g=a.y-p}return this.sprite.events.onDragUpdate.dispatch(a,t,l,c,o,e,f,g),!0},justOver:function(t,e){return t=t||0,e=e||500,this._pointerData[t].isOver&&this.overDuration(t)<e},justOut:function(t,e){return t=t||0,e=e||500,this._pointerData[t].isOut&&this.game.time.time-this._pointerData[t].timeOut<e},justPressed:function(t,e){return t=t||0,e=e||500,this._pointerData[t].isDown&&this.downDuration(t)<e},justReleased:function(t,e){return t=t||0,e=e||500,this._pointerData[t].isUp&&this.game.time.time-this._pointerData[t].timeUp<e},overDuration:function(t){return t=t||0,this._pointerData[t].isOver?this.game.time.time-this._pointerData[t].timeOver:-1},downDuration:function(t){return t=t||0,this._pointerData[t].isDown?this.game.time.time-this._pointerData[t].timeDown:-1},enableDrag:function(t,i,s,n,r,o){void 0===t&&(t=!1),void 0===i&&(i=!1),void 0===s&&(s=!1),void 0===n&&(n=255),void 0===r&&(r=null),void 0===o&&(o=null),this._dragPoint=new e.Point,this.draggable=!0,this.bringToTop=i,this.dragOffset=new e.Point,this.dragFromCenter=t,this.pixelPerfectClick=s,this.pixelPerfectAlpha=n,r&&(this.boundsRect=r),o&&(this.boundsSprite=o)},disableDrag:function(){if(this._pointerData)for(var t=0;t<10;t++)this._pointerData[t].isDragged=!1;this.draggable=!1,this.isDragged=!1,this._draggedPointerID=-1,this._pendingDrag=!1},startDrag:function(t){var i=this.sprite.x,s=this.sprite.y,n=this.globalToLocal(t);if(this.isDragged=!0,this._draggedPointerID=t.id,this._pointerData[t.id].camX=this.game.camera.x,this._pointerData[t.id].camY=this.game.camera.y,this._pointerData[t.id].isDragged=!0,this.sprite.fixedToCamera){if(this.dragFromCenter){var r=this.sprite.getBounds(),o=this.globalToLocal(new e.Point(r.centerX,r.centerY));this.sprite.cameraOffset.x=n.x+(this.sprite.cameraOffset.x-o.x),this.sprite.cameraOffset.y=n.y+(this.sprite.cameraOffset.y-o.y)}this._dragPoint.setTo(this.sprite.cameraOffset.x-t.x,this.sprite.cameraOffset.y-t.y)}else{if(this.dragFromCenter){var r=this.sprite.getBounds(),o=this.globalToLocal(new e.Point(r.centerX,r.centerY));this.sprite.x=n.x+(this.sprite.x-o.x),this.sprite.y=n.y+(this.sprite.y-o.y)}this._dragPoint.setTo(this.sprite.x-n.x,this.sprite.y-n.y)}this.updateDrag(t,!0),this.bringToTop&&(this._dragPhase=!0,this.sprite.bringToTop()),this.dragStartPoint.set(i,s),this.sprite.events.onDragStart$dispatch(this.sprite,t,i,s),this._pendingDrag=!1},globalToLocalX:function(t){return this.scaleLayer&&(t-=this.game.scale.grid.boundsFluid.x,t*=this.game.scale.grid.scaleFluidInversed.x),t},globalToLocalY:function(t){return this.scaleLayer&&(t-=this.game.scale.grid.boundsFluid.y,t*=this.game.scale.grid.scaleFluidInversed.y),t},globalToLocal:function(t){return this.sprite.parent?this.game.input.getLocalPosition(this.sprite.parent,{x:t.x,y:t.y}):t},stopDrag:function(t){this.isDragged=!1,this._draggedPointerID=-1,this._pointerData[t.id].isDragged=!1,this._dragPhase=!1,this._pendingDrag=!1,this.snapOnRelease&&(this.sprite.fixedToCamera?(this.sprite.cameraOffset.x=Math.round((this.sprite.cameraOffset.x-this.snapOffsetX%this.snapX)/this.snapX)*this.snapX+this.snapOffsetX%this.snapX,this.sprite.cameraOffset.y=Math.round((this.sprite.cameraOffset.y-this.snapOffsetY%this.snapY)/this.snapY)*this.snapY+this.snapOffsetY%this.snapY):(this.sprite.x=Math.round((this.sprite.x-this.snapOffsetX%this.snapX)/this.snapX)*this.snapX+this.snapOffsetX%this.snapX,this.sprite.y=Math.round((this.sprite.y-this.snapOffsetY%this.snapY)/this.snapY)*this.snapY+this.snapOffsetY%this.snapY)),this.sprite.events.onDragStop$dispatch(this.sprite,t),!1===this.checkPointerOver(t)&&this._pointerOutHandler(t)},setDragLock:function(t,e){void 0===t&&(t=!0),void 0===e&&(e=!0),this.allowHorizontalDrag=t,this.allowVerticalDrag=e},enableSnap:function(t,e,i,s,n,r){void 0===i&&(i=!0),void 0===s&&(s=!1),void 0===n&&(n=0),void 0===r&&(r=0),this.snapX=t,this.snapY=e,this.snapOffsetX=n,this.snapOffsetY=r,this.snapOnDrag=i,this.snapOnRelease=s},disableSnap:function(){this.snapOnDrag=!1,this.snapOnRelease=!1},checkBoundsRect:function(){this.sprite.fixedToCamera?(this.sprite.cameraOffset.x<this.boundsRect.left?this.sprite.cameraOffset.x=this.boundsRect.left:this.sprite.cameraOffset.x+this.sprite.width>this.boundsRect.right&&(this.sprite.cameraOffset.x=this.boundsRect.right-this.sprite.width),this.sprite.cameraOffset.y<this.boundsRect.top?this.sprite.cameraOffset.y=this.boundsRect.top:this.sprite.cameraOffset.y+this.sprite.height>this.boundsRect.bottom&&(this.sprite.cameraOffset.y=this.boundsRect.bottom-this.sprite.height)):(this.sprite.left<this.boundsRect.left?this.sprite.x=this.boundsRect.x+this.sprite.offsetX:this.sprite.right>this.boundsRect.right&&(this.sprite.x=this.boundsRect.right-(this.sprite.width-this.sprite.offsetX)),this.sprite.top<this.boundsRect.top?this.sprite.y=this.boundsRect.top+this.sprite.offsetY:this.sprite.bottom>this.boundsRect.bottom&&(this.sprite.y=this.boundsRect.bottom-(this.sprite.height-this.sprite.offsetY)))},checkBoundsSprite:function(){this.sprite.fixedToCamera&&this.boundsSprite.fixedToCamera?(this.sprite.cameraOffset.x<this.boundsSprite.cameraOffset.x?this.sprite.cameraOffset.x=this.boundsSprite.cameraOffset.x:this.sprite.cameraOffset.x+this.sprite.width>this.boundsSprite.cameraOffset.x+this.boundsSprite.width&&(this.sprite.cameraOffset.x=this.boundsSprite.cameraOffset.x+this.boundsSprite.width-this.sprite.width),this.sprite.cameraOffset.y<this.boundsSprite.cameraOffset.y?this.sprite.cameraOffset.y=this.boundsSprite.cameraOffset.y:this.sprite.cameraOffset.y+this.sprite.height>this.boundsSprite.cameraOffset.y+this.boundsSprite.height&&(this.sprite.cameraOffset.y=this.boundsSprite.cameraOffset.y+this.boundsSprite.height-this.sprite.height)):(this.sprite.left<this.boundsSprite.left?this.sprite.x=this.boundsSprite.left+this.sprite.offsetX:this.sprite.right>this.boundsSprite.right&&(this.sprite.x=this.boundsSprite.right-(this.sprite.width-this.sprite.offsetX)),this.sprite.top<this.boundsSprite.top?this.sprite.y=this.boundsSprite.top+this.sprite.offsetY:this.sprite.bottom>this.boundsSprite.bottom&&(this.sprite.y=this.boundsSprite.bottom-(this.sprite.height-this.sprite.offsetY)))}},e.InputHandler.prototype.constructor=e.InputHandler,e.PointerLock=function(t){this.game=t,this.input=t.input,this.element=t.canvas,this.active=!1,this.locked=!1,this.onChange=new e.Signal,this.onError=new e.Signal,this.boundOnChangeHandler=this.onChangeHandler.bind(this),this.boundOnErrorHandler=this.onErrorHandler.bind(this);var i=t.device;this.pointerLockElement=i.pointerLockElement,this.pointerlockchange=i.pointerlockchange,this.pointerlockerror=i.pointerlockerror},e.PointerLock.prototype.start=function(){return!(!this.game.device.pointerLock||this.active)&&(this.element.requestPointerLock||(this.element.requestPointerLock=this.element.mozRequestPointerLock||this.element.webkitRequestPointerLock),document.exitPointerLock||(document.exitPointerLock=document.mozExitPointerLock||document.webkitExitPointerLock),document.addEventListener(this.pointerlockchange,this.boundOnChangeHandler,!0),document.addEventListener(this.pointerlockerror,this.boundOnErrorHandler,!0),this.active=!0,!0)},e.PointerLock.prototype.stop=function(){this.active&&(document.removeEventListener(this.pointerlockchange,this.boundOnChangeHandler,!0),document.removeEventListener(this.pointerlockerror,this.boundOnErrorHandler,!0),this.active=!1)},e.PointerLock.prototype.request=function(){this.active&&!this.locked&&this.element.requestPointerLock()},e.PointerLock.prototype.exit=function(){document.exitPointerLock()},e.PointerLock.prototype.onChangeHandler=function(t){this.locked=document[this.pointerLockElement]===this.element,this.onChange.dispatch(this.locked,t)},e.PointerLock.prototype.onErrorHandler=function(t){this.onError.dispatch(t)},e.Gamepad=function(t){this.game=t,this._gamepadIndexMap={},this._rawPads=[],this._active=!1,this.enabled=!0,this._gamepadSupportAvailable=!!navigator.webkitGetGamepads||!!navigator.webkitGamepads||-1!==navigator.userAgent.indexOf("Firefox/")||!!navigator.getGamepads,this._prevRawGamepadTypes=[],this._prevTimestamps=[],this.callbackContext=this,this.onConnectCallback=null,this.onDisconnectCallback=null,this.onDownCallback=null,this.onUpCallback=null,this.onAxisCallback=null,this.onFloatCallback=null,this._ongamepadconnected=null,this._gamepaddisconnected=null,this._gamepads=[new e.SinglePad(t,this),new e.SinglePad(t,this),new e.SinglePad(t,this),new e.SinglePad(t,this)]},e.Gamepad.prototype={addCallbacks:function(t,e){void 0!==e&&(this.onConnectCallback="function"==typeof e.onConnect?e.onConnect:this.onConnectCallback,this.onDisconnectCallback="function"==typeof e.onDisconnect?e.onDisconnect:this.onDisconnectCallback,this.onDownCallback="function"==typeof e.onDown?e.onDown:this.onDownCallback,this.onUpCallback="function"==typeof e.onUp?e.onUp:this.onUpCallback,this.onAxisCallback="function"==typeof e.onAxis?e.onAxis:this.onAxisCallback,this.onFloatCallback="function"==typeof e.onFloat?e.onFloat:this.onFloatCallback,this.callbackContext=t)},start:function(){if(!this._active){this._active=!0;var t=this;this._onGamepadConnected=function(e){return t.onGamepadConnected(e)},this._onGamepadDisconnected=function(e){return t.onGamepadDisconnected(e)},window.addEventListener("gamepadconnected",this._onGamepadConnected,!1),window.addEventListener("gamepaddisconnected",this._onGamepadDisconnected,!1)}},onGamepadConnected:function(t){var e=t.gamepad;this._rawPads.push(e),this._gamepads[e.index].connect(e)},onGamepadDisconnected:function(t){var e=t.gamepad;for(var i in this._rawPads)this._rawPads[i].index===e.index&&this._rawPads.splice(i,1);this._gamepads[e.index].disconnect()},update:function(){this._pollGamepads(),this.pad1.pollStatus(),this.pad2.pollStatus(),this.pad3.pollStatus(),this.pad4.pollStatus()},_pollGamepads:function(){if(this._active){if(navigator.getGamepads)t=navigator.getGamepads();else if(navigator.webkitGetGamepads)t=navigator.webkitGetGamepads();else if(navigator.webkitGamepads)var t=navigator.webkitGamepads();if(t){this._rawPads=[];for(var e=!1,i=0;i<t.length&&(typeof t[i]!==this._prevRawGamepadTypes[i]&&(e=!0,this._prevRawGamepadTypes[i]=typeof t[i]),t[i]&&this._rawPads.push(t[i]),3!==i);i++);for(var s=0;s<this._gamepads.length;s++)this._gamepads[s]._rawPad=this._rawPads[s];if(e){for(var n,r={rawIndices:{},padIndices:{}},o=0;o<this._gamepads.length;o++)if((n=this._gamepads[o]).connected)for(var a=0;a<this._rawPads.length;a++)this._rawPads[a].index===n.index&&(r.rawIndices[n.index]=!0,r.padIndices[o]=!0);for(var h=0;h<this._gamepads.length;h++)if(n=this._gamepads[h],!r.padIndices[h]){this._rawPads.length<1&&n.disconnect();for(var l=0;l<this._rawPads.length&&!r.padIndices[h];l++){var c=this._rawPads[l];if(c){if(r.rawIndices[c.index]){n.disconnect();continue}n.connect(c),r.rawIndices[c.index]=!0,r.padIndices[h]=!0}else n.disconnect()}}}}}},setDeadZones:function(t){for(var e=0;e<this._gamepads.length;e++)this._gamepads[e].deadZone=t},stop:function(){this._active=!1,window.removeEventListener("gamepadconnected",this._onGamepadConnected),window.removeEventListener("gamepaddisconnected",this._onGamepadDisconnected)},reset:function(){this.update();for(var t=0;t<this._gamepads.length;t++)this._gamepads[t].reset()},justPressed:function(t,e){for(var i=0;i<this._gamepads.length;i++)if(!0===this._gamepads[i].justPressed(t,e))return!0;return!1},justReleased:function(t,e){for(var i=0;i<this._gamepads.length;i++)if(!0===this._gamepads[i].justReleased(t,e))return!0;return!1},isDown:function(t){for(var e=0;e<this._gamepads.length;e++)if(!0===this._gamepads[e].isDown(t))return!0;return!1},destroy:function(){this.stop();for(var t=0;t<this._gamepads.length;t++)this._gamepads[t].destroy()}},e.Gamepad.prototype.constructor=e.Gamepad,Object.defineProperty(e.Gamepad.prototype,"active",{get:function(){return this._active}}),Object.defineProperty(e.Gamepad.prototype,"supported",{get:function(){return this._gamepadSupportAvailable}}),Object.defineProperty(e.Gamepad.prototype,"padsConnected",{get:function(){return this._rawPads.length}}),Object.defineProperty(e.Gamepad.prototype,"pad1",{get:function(){return this._gamepads[0]}}),Object.defineProperty(e.Gamepad.prototype,"pad2",{get:function(){return this._gamepads[1]}}),Object.defineProperty(e.Gamepad.prototype,"pad3",{get:function(){return this._gamepads[2]}}),Object.defineProperty(e.Gamepad.prototype,"pad4",{get:function(){return this._gamepads[3]}}),e.Gamepad.BUTTON_0=0,e.Gamepad.BUTTON_1=1,e.Gamepad.BUTTON_2=2,e.Gamepad.BUTTON_3=3,e.Gamepad.BUTTON_4=4,e.Gamepad.BUTTON_5=5,e.Gamepad.BUTTON_6=6,e.Gamepad.BUTTON_7=7,e.Gamepad.BUTTON_8=8,e.Gamepad.BUTTON_9=9,e.Gamepad.BUTTON_10=10,e.Gamepad.BUTTON_11=11,e.Gamepad.BUTTON_12=12,e.Gamepad.BUTTON_13=13,e.Gamepad.BUTTON_14=14,e.Gamepad.BUTTON_15=15,e.Gamepad.AXIS_0=0,e.Gamepad.AXIS_1=1,e.Gamepad.AXIS_2=2,e.Gamepad.AXIS_3=3,e.Gamepad.AXIS_4=4,e.Gamepad.AXIS_5=5,e.Gamepad.AXIS_6=6,e.Gamepad.AXIS_7=7,e.Gamepad.AXIS_8=8,e.Gamepad.AXIS_9=9,e.Gamepad.XBOX360_A=0,e.Gamepad.XBOX360_B=1,e.Gamepad.XBOX360_X=2,e.Gamepad.XBOX360_Y=3,e.Gamepad.XBOX360_LEFT_BUMPER=4,e.Gamepad.XBOX360_RIGHT_BUMPER=5,e.Gamepad.XBOX360_LEFT_TRIGGER=6,e.Gamepad.XBOX360_RIGHT_TRIGGER=7,e.Gamepad.XBOX360_BACK=8,e.Gamepad.XBOX360_START=9,e.Gamepad.XBOX360_STICK_LEFT_BUTTON=10,e.Gamepad.XBOX360_STICK_RIGHT_BUTTON=11,e.Gamepad.XBOX360_DPAD_LEFT=14,e.Gamepad.XBOX360_DPAD_RIGHT=15,e.Gamepad.XBOX360_DPAD_UP=12,e.Gamepad.XBOX360_DPAD_DOWN=13,e.Gamepad.XBOX360_STICK_LEFT_X=0,e.Gamepad.XBOX360_STICK_LEFT_Y=1,e.Gamepad.XBOX360_STICK_RIGHT_X=2,e.Gamepad.XBOX360_STICK_RIGHT_Y=3,e.Gamepad.PS3XC_X=0,e.Gamepad.PS3XC_CIRCLE=1,e.Gamepad.PS3XC_SQUARE=2,e.Gamepad.PS3XC_TRIANGLE=3,e.Gamepad.PS3XC_L1=4,e.Gamepad.PS3XC_R1=5,e.Gamepad.PS3XC_L2=6,e.Gamepad.PS3XC_R2=7,e.Gamepad.PS3XC_SELECT=8,e.Gamepad.PS3XC_START=9,e.Gamepad.PS3XC_STICK_LEFT_BUTTON=10,e.Gamepad.PS3XC_STICK_RIGHT_BUTTON=11,e.Gamepad.PS3XC_DPAD_UP=12,e.Gamepad.PS3XC_DPAD_DOWN=13,e.Gamepad.PS3XC_DPAD_LEFT=14,e.Gamepad.PS3XC_DPAD_RIGHT=15,e.Gamepad.PS3XC_STICK_LEFT_X=0,e.Gamepad.PS3XC_STICK_LEFT_Y=1,e.Gamepad.PS3XC_STICK_RIGHT_X=2,e.Gamepad.PS3XC_STICK_RIGHT_Y=3,e.SinglePad=function(t,e){this.game=t,this.index=null,this.connected=!1,this.callbackContext=this,this.onConnectCallback=null,this.onDisconnectCallback=null,this.onDownCallback=null,this.onUpCallback=null,this.onAxisCallback=null,this.onFloatCallback=null,this.deadZone=.26,this._padParent=e,this._rawPad=null,this._prevTimestamp=null,this._buttons=[],this._buttonsLen=0,this._axes=[],this._axesLen=0},e.SinglePad.prototype={addCallbacks:function(t,e){void 0!==e&&(this.onConnectCallback="function"==typeof e.onConnect?e.onConnect:this.onConnectCallback,this.onDisconnectCallback="function"==typeof e.onDisconnect?e.onDisconnect:this.onDisconnectCallback,this.onDownCallback="function"==typeof e.onDown?e.onDown:this.onDownCallback,this.onUpCallback="function"==typeof e.onUp?e.onUp:this.onUpCallback,this.onAxisCallback="function"==typeof e.onAxis?e.onAxis:this.onAxisCallback,this.onFloatCallback="function"==typeof e.onFloat?e.onFloat:this.onFloatCallback,this.callbackContext=t)},getButton:function(t){return this._buttons[t]?this._buttons[t]:null},pollStatus:function(){if(this.connected&&this.game.input.enabled&&this.game.input.gamepad.enabled&&(!this._rawPad||!this._rawPad.timestamp||this._rawPad.timestamp!==this._prevTimestamp)){for(var t=0;t<this._buttonsLen;t++){var e=isNaN(this._rawPad.buttons[t])?this._rawPad.buttons[t].value:this._rawPad.buttons[t];e!==this._buttons[t].value&&(1===e?this.processButtonDown(t,e):0===e?this.processButtonUp(t,e):this.processButtonFloat(t,e))}for(var i=0;i<this._axesLen;i++){var s=this._rawPad.axes[i];s>0&&s>this.deadZone||s<0&&s<-this.deadZone?this.processAxisChange(i,s):this.processAxisChange(i,0)}this._prevTimestamp=this._rawPad.timestamp}},connect:function(t){var i=!this.connected;this.connected=!0,this.index=t.index,this._rawPad=t,this._buttons=[],this._buttonsLen=t.buttons.length,this._axes=[],this._axesLen=t.axes.length;for(var s=0;s<this._axesLen;s++)this._axes[s]=t.axes[s];for(var n in t.buttons)n=parseInt(n,10),this._buttons[n]=new e.DeviceButton(this,n);i&&this._padParent.onConnectCallback&&this._padParent.onConnectCallback.call(this._padParent.callbackContext,this.index),i&&this.onConnectCallback&&this.onConnectCallback.call(this.callbackContext)},disconnect:function(){var t=this.connected,e=this.index;this.connected=!1,this.index=null,this._rawPad=void 0;for(var i=0;i<this._buttonsLen;i++)this._buttons[i].destroy();this._buttons=[],this._buttonsLen=0,this._axes=[],this._axesLen=0,t&&this._padParent.onDisconnectCallback&&this._padParent.onDisconnectCallback.call(this._padParent.callbackContext,e),t&&this.onDisconnectCallback&&this.onDisconnectCallback.call(this.callbackContext)},destroy:function(){this._rawPad=void 0;for(var t=0;t<this._buttonsLen;t++)this._buttons[t].destroy();this._buttons=[],this._buttonsLen=0,this._axes=[],this._axesLen=0,this.onConnectCallback=null,this.onDisconnectCallback=null,this.onDownCallback=null,this.onUpCallback=null,this.onAxisCallback=null,this.onFloatCallback=null},processAxisChange:function(t,e){this._axes[t]!==e&&(this._axes[t]=e,this._padParent.onAxisCallback&&this._padParent.onAxisCallback.call(this._padParent.callbackContext,this,t,e),this.onAxisCallback&&this.onAxisCallback.call(this.callbackContext,this,t,e))},processButtonDown:function(t,e){this._buttons[t]&&this._buttons[t].start(null,e),this._padParent.onDownCallback&&this._padParent.onDownCallback.call(this._padParent.callbackContext,t,e,this.index),this.onDownCallback&&this.onDownCallback.call(this.callbackContext,t,e)},processButtonUp:function(t,e){this._padParent.onUpCallback&&this._padParent.onUpCallback.call(this._padParent.callbackContext,t,e,this.index),this.onUpCallback&&this.onUpCallback.call(this.callbackContext,t,e),this._buttons[t]&&this._buttons[t].stop(null,e)},processButtonFloat:function(t,e){this._padParent.onFloatCallback&&this._padParent.onFloatCallback.call(this._padParent.callbackContext,t,e,this.index),this.onFloatCallback&&this.onFloatCallback.call(this.callbackContext,t,e),this._buttons[t]&&this._buttons[t].padFloat(e)},axis:function(t){return!!this._axes[t]&&this._axes[t]},isDown:function(t){return!!this._buttons[t]&&this._buttons[t].isDown},isUp:function(t){return!!this._buttons[t]&&this._buttons[t].isUp},justReleased:function(t,e){if(this._buttons[t])return this._buttons[t].justReleased(e)},justPressed:function(t,e){if(this._buttons[t])return this._buttons[t].justPressed(e)},buttonValue:function(t){return this._buttons[t]?this._buttons[t].value:null},reset:function(){for(var t=0;t<this._axes.length;t++)this._axes[t]=0}},e.SinglePad.prototype.constructor=e.SinglePad,e.Key=function(t,i){this.game=t,this._enabled=!0,this.event=null,this.isDown=!1,this.isUp=!0,this.altKey=!1,this.ctrlKey=!1,this.shiftKey=!1,this.timeDown=0,this.duration=0,this.timeUp=-2500,this.durationUp=-2500,this.repeats=0,this.keyCode=i,this.onDown=new e.Signal,this.onHoldCallback=null,this.onHoldContext=null,this.onUp=new e.Signal,this._justDown=!1,this._justUp=!1},e.Key.prototype={update:function(){this._enabled&&(this.isDown?(this.duration=this.game.time.time-this.timeDown,this.repeats++,this.onHoldCallback&&this.onHoldCallback.call(this.onHoldContext,this)):this.durationUp=this.game.time.time-this.timeUp)},processKeyDown:function(t){this._enabled&&(this.event=t,this.isDown||(this.altKey=t.altKey,this.ctrlKey=t.ctrlKey,this.shiftKey=t.shiftKey,this.isDown=!0,this.isUp=!1,this.timeDown=this.game.time.time,this.duration=0,this.durationUp=this.game.time.time-this.timeUp,this.repeats=0,this._justDown=!0,this.onDown.dispatch(this)))},processKeyUp:function(t){this._enabled&&(this.event=t,this.isUp||(this.isDown=!1,this.isUp=!0,this.timeUp=this.game.time.time,this.duration=this.game.time.time-this.timeDown,this.durationUp=0,this._justUp=!0,this.onUp.dispatch(this)))},reset:function(t){void 0===t&&(t=!0),this.isDown=!1,this.isUp=!0,this.timeUp=this.game.time.time,this.duration=0,this.durationUp=-2500,this._enabled=!0,this._justDown=!1,this._justUp=!1,t&&(this.onDown.removeAll(),this.onUp.removeAll(),this.onHoldCallback=null,this.onHoldContext=null)},downDuration:function(t){return void 0===t&&(t=50),this.isDown&&this.duration<t},upDuration:function(t){return void 0===t&&(t=50),!this.isDown&&this.game.time.time-this.timeUp<t},justPressed:function(){return this.isDown&&0===this.duration},justReleased:function(){return!this.isDown&&0===this.durationUp}},Object.defineProperty(e.Key.prototype,"justDown",{get:function(){var t=this._justDown;return this._justDown=!1,t}}),Object.defineProperty(e.Key.prototype,"justUp",{get:function(){var t=this._justUp;return this._justUp=!1,t}}),Object.defineProperty(e.Key.prototype,"enabled",{get:function(){return this._enabled},set:function(t){(t=!!t)!==this._enabled&&(t||this.reset(!1),this._enabled=t)}}),e.Key.prototype.constructor=e.Key,e.Keyboard=function(t){this.game=t,this.active=!1,this.enabled=!0,this.event=null,this.pressEvent=null,this.callbackContext=this,this.onDownCallback=null,this.onPressCallback=null,this.onUpCallback=null,this._keys=[],this._capture=[],this._onKeyDown=null,this._onKeyPress=null,this._onKeyUp=null,this._i=0,this._k=0},e.Keyboard.prototype={addCallbacks:function(t,e,i,s){this.callbackContext=t,void 0!==e&&null!==e&&(this.onDownCallback=e),void 0!==i&&null!==i&&(this.onUpCallback=i),void 0!==s&&null!==s&&(this.onPressCallback=s)},removeCallbacks:function(){this.callbackContext=this,this.onDownCallback=null,this.onUpCallback=null,this.onPressCallback=null},addKey:function(t){return this._keys[t]||(this._keys[t]=new e.Key(this.game,t),this.addKeyCapture(t)),this._keys[t]},addKeys:function(t){var e={};for(var i in t)e[i]=this.addKey(t[i]);return e},removeKey:function(t){this._keys[t]&&(this._keys[t]=null,this.removeKeyCapture(t))},createCursorKeys:function(){return this.addKeys({up:e.KeyCode.UP,down:e.KeyCode.DOWN,left:e.KeyCode.LEFT,right:e.KeyCode.RIGHT})},start:function(){if(this.game.device.cocoonJS)return!1;if(this.active)return!1;var t=this;return this._onKeyDown=function(e){return t.processKeyDown(e)},this._onKeyUp=function(e){return t.processKeyUp(e)},this._onKeyPress=function(e){return t.processKeyPress(e)},window.addEventListener("keydown",this._onKeyDown,!1),window.addEventListener("keyup",this._onKeyUp,!1),window.addEventListener("keypress",this._onKeyPress,!1),this.active=!0,!0},stop:function(){window.removeEventListener("keydown",this._onKeyDown),window.removeEventListener("keyup",this._onKeyUp),window.removeEventListener("keypress",this._onKeyPress),this._onKeyDown=null,this._onKeyUp=null,this._onKeyPress=null,this.active=!1},destroy:function(){this.stop(),this.clearCaptures(),this._keys.length=0,this._i=0},addKeyCapture:function(t){if("object"==typeof t)for(var e in t)this._capture[t[e]]=!0;else this._capture[t]=!0},removeKeyCapture:function(t){delete this._capture[t]},clearCaptures:function(){this._capture={}},update:function(){for(this._i=this._keys.length;this._i--;)this._keys[this._i]&&this._keys[this._i].update()},processKeyDown:function(t){if(this.event=t,this.game.input.enabled&&this.enabled){var i=t.keyCode;this._capture[i]&&t.preventDefault(),this._keys[i]||(this._keys[i]=new e.Key(this.game,i)),this._keys[i].processKeyDown(t),this._k=i,this.onDownCallback&&this.onDownCallback.call(this.callbackContext,t)}},processKeyPress:function(t){this.pressEvent=t,this.game.input.enabled&&this.enabled&&this.onPressCallback&&this.onPressCallback.call(this.callbackContext,String.fromCharCode(t.charCode),t)},processKeyUp:function(t){if(this.event=t,this.game.input.enabled&&this.enabled){var i=t.keyCode;this._capture[i]&&t.preventDefault(),this._keys[i]||(this._keys[i]=new e.Key(this.game,i)),this._keys[i].processKeyUp(t),this.onUpCallback&&this.onUpCallback.call(this.callbackContext,t)}},reset:function(t){void 0===t&&(t=!0),this.event=null;for(var e=this._keys.length;e--;)this._keys[e]&&this._keys[e].reset(t)},downDuration:function(t,e){return this._keys[t]?this._keys[t].downDuration(e):null},upDuration:function(t,e){return this._keys[t]?this._keys[t].upDuration(e):null},justPressed:function(t){return this._keys[t]?this._keys[t].justPressed():null},justReleased:function(t){return this._keys[t]?this._keys[t].justReleased():null},isDown:function(t){return this._keys[t]?this._keys[t].isDown:null}},Object.defineProperty(e.Keyboard.prototype,"lastChar",{get:function(){return this.event&&32===this.event.charCode?"":this.pressEvent?String.fromCharCode(this.pressEvent.charCode):null}}),Object.defineProperty(e.Keyboard.prototype,"lastKey",{get:function(){return this._keys[this._k]}}),e.Keyboard.prototype.constructor=e.Keyboard,e.KeyCode={A:"A".charCodeAt(0),B:"B".charCodeAt(0),C:"C".charCodeAt(0),D:"D".charCodeAt(0),E:"E".charCodeAt(0),F:"F".charCodeAt(0),G:"G".charCodeAt(0),H:"H".charCodeAt(0),I:"I".charCodeAt(0),J:"J".charCodeAt(0),K:"K".charCodeAt(0),L:"L".charCodeAt(0),M:"M".charCodeAt(0),N:"N".charCodeAt(0),O:"O".charCodeAt(0),P:"P".charCodeAt(0),Q:"Q".charCodeAt(0),R:"R".charCodeAt(0),S:"S".charCodeAt(0),T:"T".charCodeAt(0),U:"U".charCodeAt(0),V:"V".charCodeAt(0),W:"W".charCodeAt(0),X:"X".charCodeAt(0),Y:"Y".charCodeAt(0),Z:"Z".charCodeAt(0),ZERO:"0".charCodeAt(0),ONE:"1".charCodeAt(0),TWO:"2".charCodeAt(0),THREE:"3".charCodeAt(0),FOUR:"4".charCodeAt(0),FIVE:"5".charCodeAt(0),SIX:"6".charCodeAt(0),SEVEN:"7".charCodeAt(0),EIGHT:"8".charCodeAt(0),NINE:"9".charCodeAt(0),NUMPAD_0:96,NUMPAD_1:97,NUMPAD_2:98,NUMPAD_3:99,NUMPAD_4:100,NUMPAD_5:101,NUMPAD_6:102,NUMPAD_7:103,NUMPAD_8:104,NUMPAD_9:105,NUMPAD_MULTIPLY:106,NUMPAD_ADD:107,NUMPAD_ENTER:108,NUMPAD_SUBTRACT:109,NUMPAD_DECIMAL:110,NUMPAD_DIVIDE:111,F1:112,F2:113,F3:114,F4:115,F5:116,F6:117,F7:118,F8:119,F9:120,F10:121,F11:122,F12:123,F13:124,F14:125,F15:126,COLON:186,EQUALS:187,COMMA:188,UNDERSCORE:189,PERIOD:190,QUESTION_MARK:191,TILDE:192,OPEN_BRACKET:219,BACKWARD_SLASH:220,CLOSED_BRACKET:221,QUOTES:222,BACKSPACE:8,TAB:9,CLEAR:12,ENTER:13,SHIFT:16,CONTROL:17,ALT:18,CAPS_LOCK:20,ESC:27,SPACEBAR:32,PAGE_UP:33,PAGE_DOWN:34,END:35,HOME:36,LEFT:37,UP:38,RIGHT:39,DOWN:40,PLUS:43,MINUS:44,INSERT:45,DELETE:46,HELP:47,NUM_LOCK:144};for(var s in e.KeyCode)e.KeyCode.hasOwnProperty(s)&&!s.match(/[a-z]/)&&(e.Keyboard[s]=e.KeyCode[s]);e.Component=function(){},e.Component.Angle=function(){},e.Component.Angle.prototype={angle:{get:function(){return e.Math.wrapAngle(e.Math.radToDeg(this.rotation))},set:function(t){this.rotation=e.Math.degToRad(e.Math.wrapAngle(t))}}},e.Component.Animation=function(){},e.Component.Animation.prototype={play:function(t,e,i,s){if(this.animations)return this.animations.play(t,e,i,s)}},e.Component.AutoCull=function(){},e.Component.AutoCull.prototype={autoCull:!1,inCamera:{get:function(){return this.autoCull||this.checkWorldBounds||(this._bounds.copyFrom(this.getBounds()),this._bounds.x+=this.game.camera.view.x,this._bounds.y+=this.game.camera.view.y),this.game.world.camera.view.intersects(this._bounds)}}},e.Component.Bounds=function(){},e.Component.Bounds.prototype={offsetX:{get:function(){return this.anchor.x*this.width}},offsetY:{get:function(){return this.anchor.y*this.height}},centerX:{get:function(){return this.x-this.offsetX+.5*this.width},set:function(t){this.x=t+this.offsetX-.5*this.width}},centerY:{get:function(){return this.y-this.offsetY+.5*this.height},set:function(t){this.y=t+this.offsetY-.5*this.height}},left:{get:function(){return this.x-this.offsetX},set:function(t){this.x=t+this.offsetX}},right:{get:function(){return this.x+this.width-this.offsetX},set:function(t){this.x=t-this.width+this.offsetX}},top:{get:function(){return this.y-this.offsetY},set:function(t){this.y=t+this.offsetY}},bottom:{get:function(){return this.y+this.height-this.offsetY},set:function(t){this.y=t-this.height+this.offsetY}},alignIn:function(t,i,s,n){switch(void 0===s&&(s=0),void 0===n&&(n=0),i){default:case e.TOP_LEFT:this.left=t.left-s,this.top=t.top-n;break;case e.TOP_CENTER:this.centerX=t.centerX+s,this.top=t.top-n;break;case e.TOP_RIGHT:this.right=t.right+s,this.top=t.top-n;break;case e.LEFT_CENTER:this.left=t.left-s,this.centerY=t.centerY+n;break;case e.CENTER:this.centerX=t.centerX+s,this.centerY=t.centerY+n;break;case e.RIGHT_CENTER:this.right=t.right+s,this.centerY=t.centerY+n;break;case e.BOTTOM_LEFT:this.left=t.left-s,this.bottom=t.bottom+n;break;case e.BOTTOM_CENTER:this.centerX=t.centerX+s,this.bottom=t.bottom+n;break;case e.BOTTOM_RIGHT:this.right=t.right+s,this.bottom=t.bottom+n}return this},alignTo:function(t,i,s,n){switch(void 0===s&&(s=0),void 0===n&&(n=0),i){default:case e.TOP_LEFT:this.left=t.left-s,this.bottom=t.top-n;break;case e.TOP_CENTER:this.centerX=t.centerX+s,this.bottom=t.top-n;break;case e.TOP_RIGHT:this.right=t.right+s,this.bottom=t.top-n;break;case e.LEFT_TOP:this.right=t.left-s,this.top=t.top-n;break;case e.LEFT_CENTER:this.right=t.left-s,this.centerY=t.centerY+n;break;case e.LEFT_BOTTOM:this.right=t.left-s,this.bottom=t.bottom+n;break;case e.RIGHT_TOP:this.left=t.right+s,this.top=t.top-n;break;case e.RIGHT_CENTER:this.left=t.right+s,this.centerY=t.centerY+n;break;case e.RIGHT_BOTTOM:this.left=t.right+s,this.bottom=t.bottom+n;break;case e.BOTTOM_LEFT:this.left=t.left-s,this.top=t.bottom+n;break;case e.BOTTOM_CENTER:this.centerX=t.centerX+s,this.top=t.bottom+n;break;case e.BOTTOM_RIGHT:this.right=t.right+s,this.top=t.bottom+n}return this}},e.Group.prototype.alignIn=e.Component.Bounds.prototype.alignIn,e.Group.prototype.alignTo=e.Component.Bounds.prototype.alignTo,e.Component.BringToTop=function(){},e.Component.BringToTop.prototype.bringToTop=function(){return this.parent&&this.parent.bringChildToTop&&this.parent.bringChildToTop(this),this},e.Component.BringToTop.prototype.sendToBack=function(){return this.parent&&this.parent.sendChildToBack&&this.parent.sendChildToBack(this),this},e.Component.BringToTop.prototype.moveUp=function(){return this.parent&&this.parent.moveUp(this),this},e.Component.BringToTop.prototype.moveDown=function(){return this.parent&&this.parent.moveDown(this),this},e.Component.Core=function(){},e.Component.Core.skipTypeChecks=!1,e.Component.Core.install=function(t){e.Utils.mixinPrototype(this,e.Component.Core.prototype),this.components={};for(var i=0;i<t.length;i++){var s=t[i],n=!1;"Destroy"===s&&(n=!0),e.Utils.mixinPrototype(this,e.Component[s].prototype,n),this.components[s]=!0}},e.Component.Core.init=function(t,i,s,n,r){if(!e.Component.Core.skipTypeChecks){if(!(t instanceof e.Game))throw new Error("The value passed as the `game` argument ("+t+") is not an instance of Phaser.Game.");"number"!=typeof i&&(console.warn("The `x` argument value (%s) should be a number.",i),i=0),"number"!=typeof s&&(console.warn("The `y` argument value (%s) should be a number.",s),s=0)}this.game=t,this.key=n,this.data={},this.position.set(i,s),this.world=new e.Point(i,s),this.previousPosition=new e.Point(i,s),this.events=new e.Events(this),this._bounds=new e.Rectangle,this.components.PhysicsBody&&(this.body=this.body),this.components.Animation&&(this.animations=new e.AnimationManager(this)),this.components.LoadTexture&&null!==n&&this.loadTexture(n,r),this.components.FixedToCamera&&(this.cameraOffset=new e.Point(i,s))},e.Component.Core.preUpdate=function(){return this.pendingDestroy?(this.destroy(),!1):(this.previousPosition.set(this.world.x,this.world.y),this.previousRotation=this.rotation,this.exists&&this.parent.exists?(this.world.setTo(this.game.camera.x+this.worldTransform.tx,this.game.camera.y+this.worldTransform.ty),this.visible&&(this.renderOrderID=this.game.stage.currentRenderOrderID++),this.animations&&this.animations.update(),this.body&&this.body.preUpdate(),this.preUpdateChildren(),!0):(this.renderOrderID=-1,!1))},e.Component.Core.prototype={game:null,name:"",data:{},components:{},z:0,events:void 0,animations:void 0,key:"",world:null,debug:!1,previousPosition:null,previousRotation:0,renderOrderID:0,fresh:!0,pendingDestroy:!1,_bounds:null,_exists:!0,exists:{get:function(){return this._exists},set:function(t){t?(this._exists=!0,this.body&&this.body.type===e.Physics.P2JS&&this.body.addToWorld(),this.visible=!0):(this._exists=!1,this.body&&this.body.type===e.Physics.P2JS&&this.body.removeFromWorld(),this.visible=!1)}},preUpdateChildren:function(){for(var t=0;t<this.children.length;){var e=this.children[t];e.preUpdate(),this===e.parent&&t++}},update:function(){},postUpdate:function(){this.customRender&&this.key.render(),this.components.PhysicsBody&&e.Component.PhysicsBody.postUpdate.call(this),this.components.FixedToCamera&&e.Component.FixedToCamera.postUpdate.call(this);for(var t=0;t<this.children.length;t++)this.children[t].postUpdate()}},e.Component.Crop=function(){},e.Component.Crop.prototype={cropRect:null,_crop:null,crop:function(t,i){void 0===i&&(i=!1),t?(i&&null!==this.cropRect?this.cropRect.setTo(t.x,t.y,t.width,t.height):i&&null===this.cropRect?this.cropRect=new e.Rectangle(t.x,t.y,t.width,t.height):this.cropRect=t,this.updateCrop()):(this._crop=null,this.cropRect=null,this.resetFrame())},updateCrop:function(){if(this.cropRect){var t=this.texture.crop.x,i=this.texture.crop.y,s=this.texture.crop.width,n=this.texture.crop.height;this._crop=e.Rectangle.clone(this.cropRect,this._crop),this._crop.x+=this._frame.x,this._crop.y+=this._frame.y;var r=Math.max(this._frame.x,this._crop.x),o=Math.max(this._frame.y,this._crop.y),a=Math.min(this._frame.right,this._crop.right)-r,h=Math.min(this._frame.bottom,this._crop.bottom)-o;this.texture.crop.x=r,this.texture.crop.y=o,this.texture.crop.width=a,this.texture.crop.height=h,this.texture.frame.width=Math.min(a,this.cropRect.width),this.texture.frame.height=Math.min(h,this.cropRect.height),this.texture.width=this.texture.frame.width,this.texture.height=this.texture.frame.height,this.texture._updateUvs(),16777215===this.tint||t===r&&i===o&&s===a&&n===h||(this.texture.requiresReTint=!0)}}},e.Component.Delta=function(){},e.Component.Delta.prototype={deltaX:{get:function(){return this.world.x-this.previousPosition.x}},deltaY:{get:function(){return this.world.y-this.previousPosition.y}},deltaZ:{get:function(){return this.rotation-this.previousRotation}}},e.Component.Destroy=function(){},e.Component.Destroy.prototype={destroyPhase:!1,destroy:function(t,i){if(null!==this.game&&!this.destroyPhase){void 0===t&&(t=!0),void 0===i&&(i=!1),this.destroyPhase=!0,this.events&&this.events.onDestroy$dispatch(this),this.parent&&(this.parent instanceof e.Group?this.parent.remove(this):this.parent.removeChild(this)),this.input&&this.input.destroy(),this.animations&&this.animations.destroy(),this.body&&this.body.destroy(),this.events&&this.events.destroy(),this.game.tweens.removeFrom(this);var s=this.children.length;if(t)for(;s--;)this.children[s].destroy(t);else for(;s--;)this.removeChild(this.children[s]);this._crop&&(this._crop=null,this.cropRect=null),this._frame&&(this._frame=null),e.Video&&this.key instanceof e.Video&&this.key.onChangeSource.remove(this.resizeFrame,this),e.BitmapText&&this._glyphs&&(this._glyphs=[]),this.alive=!1,this.exists=!1,this.visible=!1,this.filters=null,this.mask=null,this.game=null,this.data={},this.renderable=!1,this.transformCallback&&(this.transformCallback=null,this.transformCallbackContext=null),this.hitArea=null,this.parent=null,this.stage=null,this.worldTransform=null,this.filterArea=null,this._bounds=null,this._currentBounds=null,this._mask=null,this._destroyCachedSprite(),i&&this.texture.destroy(!0),this.destroyPhase=!1,this.pendingDestroy=!1}}},e.Events=function(t){this.parent=t},e.Events.prototype={destroy:function(){this._parent=null,this._onDestroy&&this._onDestroy.dispose(),this._onAddedToGroup&&this._onAddedToGroup.dispose(),this._onRemovedFromGroup&&this._onRemovedFromGroup.dispose(),this._onKilled&&this._onKilled.dispose(),this._onRevived&&this._onRevived.dispose(),this._onEnterBounds&&this._onEnterBounds.dispose(),this._onOutOfBounds&&this._onOutOfBounds.dispose(),this._onInputOver&&this._onInputOver.dispose(),this._onInputOut&&this._onInputOut.dispose(),this._onInputDown&&this._onInputDown.dispose(),this._onInputUp&&this._onInputUp.dispose(),this._onDragStart&&this._onDragStart.dispose(),this._onDragUpdate&&this._onDragUpdate.dispose(),this._onDragStop&&this._onDragStop.dispose(),this._onAnimationStart&&this._onAnimationStart.dispose(),this._onAnimationComplete&&this._onAnimationComplete.dispose(),this._onAnimationLoop&&this._onAnimationLoop.dispose()},onAddedToGroup:null,onRemovedFromGroup:null,onDestroy:null,onKilled:null,onRevived:null,onOutOfBounds:null,onEnterBounds:null,onInputOver:null,onInputOut:null,onInputDown:null,onInputUp:null,onDragStart:null,onDragUpdate:null,onDragStop:null,onAnimationStart:null,onAnimationComplete:null,onAnimationLoop:null},e.Events.prototype.constructor=e.Events;for(var n in e.Events.prototype)e.Events.prototype.hasOwnProperty(n)&&0===n.indexOf("on")&&null===e.Events.prototype[n]&&function(t,i){"use strict";Object.defineProperty(e.Events.prototype,t,{get:function(){return this[i]||(this[i]=new e.Signal)}}),e.Events.prototype[t+"$dispatch"]=function(){return this[i]?this[i].dispatch.apply(this[i],arguments):null}}(n,"_"+n);e.Component.FixedToCamera=function(){},e.Component.FixedToCamera.postUpdate=function(){this.fixedToCamera&&(this.position.x=(this.game.camera.view.x+this.cameraOffset.x)/this.game.camera.scale.x,this.position.y=(this.game.camera.view.y+this.cameraOffset.y)/this.game.camera.scale.y)},e.Component.FixedToCamera.prototype={_fixedToCamera:!1,fixedToCamera:{get:function(){return this._fixedToCamera},set:function(t){t?(this._fixedToCamera=!0,this.cameraOffset.set(this.x,this.y)):this._fixedToCamera=!1}},cameraOffset:new e.Point},e.Component.Health=function(){},e.Component.Health.prototype={health:1,maxHealth:100,damage:function(t){return this.alive&&(this.health-=t,this.health<=0&&this.kill()),this},setHealth:function(t){return this.health=t,this.health>this.maxHealth&&(this.health=this.maxHealth),this},heal:function(t){return this.alive&&(this.health+=t,this.health>this.maxHealth&&(this.health=this.maxHealth)),this}},e.Component.InCamera=function(){},e.Component.InCamera.prototype={inCamera:{get:function(){return this.game.world.camera.view.intersects(this._bounds)}}},e.Component.InputEnabled=function(){},e.Component.InputEnabled.prototype={input:null,inputEnabled:{get:function(){return this.input&&this.input.enabled},set:function(t){t?null===this.input?(this.input=new e.InputHandler(this),this.input.start()):this.input&&!this.input.enabled&&this.input.start():this.input&&this.input.enabled&&this.input.stop()}}},e.Component.InWorld=function(){},e.Component.InWorld.preUpdate=function(){if(this.pendingDestroy)return this.destroy(),!1;if(this.autoCull||this.checkWorldBounds){if(this._bounds.copyFrom(this.getBounds()),this._bounds.x+=this.game.camera.view.x,this._bounds.y+=this.game.camera.view.y,this.autoCull)if(this.game.world.camera.view.intersects(this._bounds))this.renderable=!0,this.game.world.camera.totalInView++;else if(this.renderable=!1,this.outOfCameraBoundsKill)return this.kill(),!1;if(this.checkWorldBounds)if(this._outOfBoundsFired&&this.game.world.bounds.intersects(this._bounds))this._outOfBoundsFired=!1,this.events.onEnterBounds$dispatch(this);else if(!this._outOfBoundsFired&&!this.game.world.bounds.intersects(this._bounds)&&(this._outOfBoundsFired=!0,this.events.onOutOfBounds$dispatch(this),this.outOfBoundsKill))return this.kill(),!1}return!0},e.Component.InWorld.prototype={checkWorldBounds:!1,outOfBoundsKill:!1,outOfCameraBoundsKill:!1,_outOfBoundsFired:!1,inWorld:{get:function(){return this.game.world.bounds.intersects(this.getBounds())}}},e.Component.LifeSpan=function(){},e.Component.LifeSpan.preUpdate=function(){return this.pendingDestroy?(this.destroy(),!1):!(this.lifespan>0&&(this.lifespan-=this.game.time.physicsElapsedMS,this.lifespan<=0))||(this.kill(),!1)},e.Component.LifeSpan.prototype={alive:!0,lifespan:0,revive:function(t){return void 0===t&&(t=100),this.alive=!0,this.exists=!0,this.visible=!0,"function"==typeof this.setHealth&&this.setHealth(t),this.events&&this.events.onRevived$dispatch(this),this},kill:function(){return this.alive=!1,this.exists=!1,this.visible=!1,this.events&&this.events.onKilled$dispatch(this),this}},e.Component.LoadTexture=function(){},e.Component.LoadTexture.prototype={customRender:!1,_frame:null,loadTexture:function(t,i,s){t===e.PENDING_ATLAS?(t=i,i=0):i=i||0,(s||void 0===s)&&this.animations&&this.animations.stop(),this.key=t,this.customRender=!1;var n=this.game.cache,r=!0,o=!this.texture.baseTexture.scaleMode;if(e.RenderTexture&&t instanceof e.RenderTexture)this.key=t.key,this.setTexture(t);else if(e.BitmapData&&t instanceof e.BitmapData)this.customRender=!0,this.setTexture(t.texture),r=n.hasFrameData(t.key,e.Cache.BITMAPDATA)?!this.animations.loadFrameData(n.getFrameData(t.key,e.Cache.BITMAPDATA),i):!this.animations.loadFrameData(t.frameData,0);else if(e.Video&&t instanceof e.Video){this.customRender=!0;var a=t.texture.valid;this.setTexture(t.texture),this.setFrame(t.texture.frame.clone()),t.onChangeSource.add(this.resizeFrame,this),this.texture.valid=a}else if(e.Tilemap&&t instanceof e.TilemapLayer)this.setTexture(PIXI.Texture.fromCanvas(t.canvas));else if(t instanceof PIXI.Texture)this.setTexture(t);else{var h=n.getImage(t,!0);this.key=h.key,this.setTexture(new PIXI.Texture(h.base)),this.texture.baseTexture.skipRender="__default"===t,r=!this.animations.loadFrameData(h.frameData,i)}r&&(this._frame=e.Rectangle.clone(this.texture.frame)),o||(this.texture.baseTexture.scaleMode=1)},setFrame:function(t){this._frame=t,this.texture.frame.x=t.x,this.texture.frame.y=t.y,this.texture.frame.width=t.width,this.texture.frame.height=t.height,this.texture.crop.x=t.x,this.texture.crop.y=t.y,this.texture.crop.width=t.width,this.texture.crop.height=t.height,t.trimmed?(this.texture.trim?(this.texture.trim.x=t.spriteSourceSizeX,this.texture.trim.y=t.spriteSourceSizeY,this.texture.trim.width=t.sourceSizeW,this.texture.trim.height=t.sourceSizeH):this.texture.trim={x:t.spriteSourceSizeX,y:t.spriteSourceSizeY,width:t.sourceSizeW,height:t.sourceSizeH},this.texture.width=t.sourceSizeW,this.texture.height=t.sourceSizeH,this.texture.frame.width=t.sourceSizeW,this.texture.frame.height=t.sourceSizeH):!t.trimmed&&this.texture.trim&&(this.texture.trim=null),t.rotated&&(this.texture.rotated=!0),this.cropRect&&this.updateCrop(),this.texture.requiresReTint=!0,this.texture._updateUvs(),this.tilingTexture&&(this.refreshTexture=!0)},resizeFrame:function(t,e,i){this.texture.frame.resize(e,i),this.texture.setFrame(this.texture.frame)},resetFrame:function(){this._frame&&this.setFrame(this._frame)},frame:{get:function(){return this.animations.frame},set:function(t){this.animations.frame=t}},frameName:{get:function(){return this.animations.frameName},set:function(t){this.animations.frameName=t}}},e.Component.Overlap=function(){},e.Component.Overlap.prototype={overlap:function(t){return e.Rectangle.intersects(this.getBounds(),t.getBounds())}},e.Component.PhysicsBody=function(){},e.Component.PhysicsBody.preUpdate=function(){return this.pendingDestroy?(this.destroy(),!1):this.fresh&&this.exists?(this.world.setTo(this.parent.position.x+this.position.x,this.parent.position.y+this.position.y),this.worldTransform.tx=this.world.x,this.worldTransform.ty=this.world.y,this.previousPosition.set(this.world.x,this.world.y),this.previousRotation=this.rotation,this.body&&this.body.preUpdate(),this.fresh=!1,this.preUpdateChildren(),!1):(this.previousPosition.set(this.world.x,this.world.y),this.previousRotation=this.rotation,!(!this._exists||!this.parent.exists)||(this.renderOrderID=-1,!1))},e.Component.PhysicsBody.postUpdate=function(){this.exists&&this.body&&this.body.postUpdate()},e.Component.PhysicsBody.prototype={body:null,x:{get:function(){return this.position.x},set:function(t){this.position.x=t,this.body&&!this.body.dirty&&(this.body._reset=!0)}},y:{get:function(){return this.position.y},set:function(t){this.position.y=t,this.body&&!this.body.dirty&&(this.body._reset=!0)}}},e.Component.Reset=function(){},e.Component.Reset.prototype.reset=function(t,e,i){return void 0===i&&(i=1),this.world.set(t,e),this.position.set(t,e),this.fresh=!0,this.exists=!0,this.visible=!0,this.renderable=!0,this.components.InWorld&&(this._outOfBoundsFired=!1),this.components.LifeSpan&&(this.alive=!0,this.health=i),this.components.PhysicsBody&&this.body&&this.body.reset(t,e,!1,!1),this},e.Component.ScaleMinMax=function(){},e.Component.ScaleMinMax.prototype={transformCallback:null,transformCallbackContext:this,scaleMin:null,scaleMax:null,checkTransform:function(t){this.scaleMin&&(t.a<this.scaleMin.x&&(t.a=this.scaleMin.x),t.d<this.scaleMin.y&&(t.d=this.scaleMin.y)),this.scaleMax&&(t.a>this.scaleMax.x&&(t.a=this.scaleMax.x),t.d>this.scaleMax.y&&(t.d=this.scaleMax.y))},setScaleMinMax:function(t,i,s,n){void 0===i?i=s=n=t:void 0===s&&(s=n=i,i=t),null===t?this.scaleMin=null:this.scaleMin?this.scaleMin.set(t,i):this.scaleMin=new e.Point(t,i),null===s?this.scaleMax=null:this.scaleMax?this.scaleMax.set(s,n):this.scaleMax=new e.Point(s,n),null===this.scaleMin?this.transformCallback=null:(this.transformCallback=this.checkTransform,this.transformCallbackContext=this)}},e.Component.Smoothed=function(){},e.Component.Smoothed.prototype={smoothed:{get:function(){return!this.texture.baseTexture.scaleMode},set:function(t){t?this.texture&&(this.texture.baseTexture.scaleMode=0,this.texture.baseTexture.dirty()):this.texture&&(this.texture.baseTexture.scaleMode=1,this.texture.baseTexture.dirty())}}},e.GameObjectFactory=function(t){this.game=t,this.world=this.game.world},e.GameObjectFactory.prototype={existing:function(t){return this.world.add(t)},weapon:function(t,i,s,n,r){var o=this.game.plugins.add(e.Weapon);return r&&(o.bulletClass=r),o.createBullets(t,i,s,n),o},image:function(t,i,s,n,r){return void 0===r&&(r=this.world),r.add(new e.Image(this.game,t,i,s,n))},sprite:function(t,i,s,n,r){return void 0===r&&(r=this.world),r.add(new e.Sprite(this.game,t,i,s,n))},creature:function(t,i,s,n,r,o,a){void 0===r&&(r=this.world);var h=new e.Creature(this.game,t,i,s,n,o,a);return r.add(h),h},tween:function(t){return this.game.tweens.create(t)},group:function(t,i,s,n,r){return new e.Group(this.game,t,i,s,n,r)},physicsGroup:function(t,i,s,n){return new e.Group(this.game,i,s,n,!0,t)},spriteBatch:function(t,i,s){return void 0===t&&(t=null),void 0===i&&(i="group"),void 0===s&&(s=!1),new e.SpriteBatch(this.game,t,i,s)},audio:function(t,e,i,s){return this.game.sound.add(t,e,i,s)},sound:function(t,e,i,s){return this.game.sound.add(t,e,i,s)},audioSprite:function(t){return this.game.sound.addSprite(t)},tileSprite:function(t,i,s,n,r,o,a){return void 0===a&&(a=this.world),a.add(new e.TileSprite(this.game,t,i,s,n,r,o))},rope:function(t,i,s,n,r,o){return void 0===o&&(o=this.world),o.add(new e.Rope(this.game,t,i,s,n,r))},text:function(t,i,s,n,r){return void 0===r&&(r=this.world),r.add(new e.Text(this.game,t,i,s,n))},button:function(t,i,s,n,r,o,a,h,l,c){return void 0===c&&(c=this.world),c.add(new e.Button(this.game,t,i,s,n,r,o,a,h,l))},graphics:function(t,i,s){return void 0===s&&(s=this.world),s.add(new e.Graphics(this.game,t,i))},emitter:function(t,i,s){return this.game.particles.add(new e.Particles.Arcade.Emitter(this.game,t,i,s))},retroFont:function(t,i,s,n,r,o,a,h,l){return new e.RetroFont(this.game,t,i,s,n,r,o,a,h,l)},bitmapText:function(t,i,s,n,r,o){return void 0===o&&(o=this.world),o.add(new e.BitmapText(this.game,t,i,s,n,r))},tilemap:function(t,i,s,n,r){return new e.Tilemap(this.game,t,i,s,n,r)},renderTexture:function(t,i,s,n){void 0!==s&&""!==s||(s=this.game.rnd.uuid()),void 0===n&&(n=!1);var r=new e.RenderTexture(this.game,t,i,s);return n&&this.game.cache.addRenderTexture(s,r),r},video:function(t,i){return new e.Video(this.game,t,i)},bitmapData:function(t,i,s,n){void 0===n&&(n=!1),void 0!==s&&""!==s||(s=this.game.rnd.uuid());var r=new e.BitmapData(this.game,s,t,i);return n&&this.game.cache.addBitmapData(s,r),r},filter:function(t){var i=Array.prototype.slice.call(arguments,1);return(t=new e.Filter[t](this.game)).init.apply(t,i),t},plugin:function(){return this.game.plugins.add.apply(this.game.plugins,arguments)}},e.GameObjectFactory.prototype.constructor=e.GameObjectFactory,e.GameObjectCreator=function(t){this.game=t,this.world=this.game.world},e.GameObjectCreator.prototype={image:function(t,i,s,n){return new e.Image(this.game,t,i,s,n)},sprite:function(t,i,s,n){return new e.Sprite(this.game,t,i,s,n)},tween:function(t){return new e.Tween(t,this.game,this.game.tweens)},group:function(t,i,s,n,r){return new e.Group(this.game,t||null,i,s,n,r)},spriteBatch:function(t,i,s){return void 0===i&&(i="group"),void 0===s&&(s=!1),new e.SpriteBatch(this.game,t,i,s)},audio:function(t,e,i,s){return this.game.sound.add(t,e,i,s)},audioSprite:function(t){return this.game.sound.addSprite(t)},sound:function(t,e,i,s){return this.game.sound.add(t,e,i,s)},tileSprite:function(t,i,s,n,r,o){return new e.TileSprite(this.game,t,i,s,n,r,o)},rope:function(t,i,s,n,r){return new e.Rope(this.game,t,i,s,n,r)},text:function(t,i,s,n){return new e.Text(this.game,t,i,s,n)},button:function(t,i,s,n,r,o,a,h,l){return new e.Button(this.game,t,i,s,n,r,o,a,h,l)},graphics:function(t,i){return new e.Graphics(this.game,t,i)},emitter:function(t,i,s){return new e.Particles.Arcade.Emitter(this.game,t,i,s)},retroFont:function(t,i,s,n,r,o,a,h,l){return new e.RetroFont(this.game,t,i,s,n,r,o,a,h,l)},bitmapText:function(t,i,s,n,r,o){return new e.BitmapText(this.game,t,i,s,n,r,o)},tilemap:function(t,i,s,n,r){return new e.Tilemap(this.game,t,i,s,n,r)},renderTexture:function(t,i,s,n){void 0!==s&&""!==s||(s=this.game.rnd.uuid()),void 0===n&&(n=!1);var r=new e.RenderTexture(this.game,t,i,s);return n&&this.game.cache.addRenderTexture(s,r),r},bitmapData:function(t,i,s,n){void 0===n&&(n=!1),void 0!==s&&""!==s||(s=this.game.rnd.uuid());var r=new e.BitmapData(this.game,s,t,i);return n&&this.game.cache.addBitmapData(s,r),r},filter:function(t){var i=Array.prototype.slice.call(arguments,1);return(t=new e.Filter[t](this.game)).init.apply(t,i),t}},e.GameObjectCreator.prototype.constructor=e.GameObjectCreator,e.Sprite=function(t,i,s,n,r){i=i||0,s=s||0,n=n||null,r=r||null,this.type=e.SPRITE,this.physicsType=e.SPRITE,PIXI.Sprite.call(this,e.Cache.DEFAULT),e.Component.Core.init.call(this,t,i,s,n,r)},e.Sprite.prototype=Object.create(PIXI.Sprite.prototype),e.Sprite.prototype.constructor=e.Sprite,e.Component.Core.install.call(e.Sprite.prototype,["Angle","Animation","AutoCull","Bounds","BringToTop","Crop","Delta","Destroy","FixedToCamera","Health","InCamera","InputEnabled","InWorld","LifeSpan","LoadTexture","Overlap","PhysicsBody","Reset","ScaleMinMax","Smoothed"]),e.Sprite.prototype.preUpdatePhysics=e.Component.PhysicsBody.preUpdate,e.Sprite.prototype.preUpdateLifeSpan=e.Component.LifeSpan.preUpdate,e.Sprite.prototype.preUpdateInWorld=e.Component.InWorld.preUpdate,e.Sprite.prototype.preUpdateCore=e.Component.Core.preUpdate,e.Sprite.prototype.preUpdate=function(){return!!(this.preUpdatePhysics()&&this.preUpdateLifeSpan()&&this.preUpdateInWorld())&&this.preUpdateCore()},e.Image=function(t,i,s,n,r){i=i||0,s=s||0,n=n||null,r=r||null,this.type=e.IMAGE,PIXI.Sprite.call(this,e.Cache.DEFAULT),e.Component.Core.init.call(this,t,i,s,n,r)},e.Image.prototype=Object.create(PIXI.Sprite.prototype),e.Image.prototype.constructor=e.Image,e.Component.Core.install.call(e.Image.prototype,["Angle","Animation","AutoCull","Bounds","BringToTop","Crop","Destroy","FixedToCamera","InputEnabled","LifeSpan","LoadTexture","Overlap","Reset","ScaleMinMax","Smoothed"]),e.Image.prototype.preUpdateLifeSpan=e.Component.LifeSpan.preUpdate,e.Image.prototype.preUpdateInWorld=e.Component.InWorld.preUpdate,e.Image.prototype.preUpdateCore=e.Component.Core.preUpdate,e.Image.prototype.preUpdate=function(){return!(!this.preUpdateInWorld()||!this.preUpdateLifeSpan())&&this.preUpdateCore()},e.Button=function(t,i,s,n,r,o,a,h,l,c){i=i||0,s=s||0,n=n||null,r=r||null,o=o||this,e.Image.call(this,t,i,s,n,h),this.type=e.BUTTON,this.physicsType=e.SPRITE,this._onOverFrame=null,this._onOutFrame=null,this._onDownFrame=null,this._onUpFrame=null,this.onOverSound=null,this.onOutSound=null,this.onDownSound=null,this.onUpSound=null,this.onOverSoundMarker="",this.onOutSoundMarker="",this.onDownSoundMarker="",this.onUpSoundMarker="",this.onInputOver=new e.Signal,this.onInputOut=new e.Signal,this.onInputDown=new e.Signal,this.onInputUp=new e.Signal,this.onOverMouseOnly=!0,this.justReleasedPreventsOver=e.PointerMode.CONTACT,this.freezeFrames=!1,this.forceOut=!1,this.inputEnabled=!0,this.input.start(0,!0),this.input.useHandCursor=!0,this.setFrames(a,h,l,c),null!==r&&this.onInputUp.add(r,o),this.events.onInputOver.add(this.onInputOverHandler,this),this.events.onInputOut.add(this.onInputOutHandler,this),this.events.onInputDown.add(this.onInputDownHandler,this),this.events.onInputUp.add(this.onInputUpHandler,this)},e.Button.prototype=Object.create(e.Image.prototype),e.Button.prototype.constructor=e.Button;return e.Button.prototype.clearFrames=function(){this.setFrames(null,null,null,null)},e.Button.prototype.setStateFrame=function(t,e,i){var s="_on"+t+"Frame";null!==e?(this[s]=e,i&&this.changeStateFrame(t)):this[s]=null},e.Button.prototype.changeStateFrame=function(t){if(this.freezeFrames)return!1;var e=this["_on"+t+"Frame"];return"string"==typeof e?(this.frameName=e,!0):"number"==typeof e&&(this.frame=e,!0)},e.Button.prototype.setFrames=function(t,e,i,s){this.setStateFrame("Over",t,this.input.pointerOver()),this.setStateFrame("Out",e,!this.input.pointerOver()),this.setStateFrame("Down",i,this.input.pointerDown()),this.setStateFrame("Up",s,this.input.pointerUp())},e.Button.prototype.setStateSound=function(t,i,s){var n="on"+t+"Sound",r="on"+t+"SoundMarker";i instanceof e.Sound||i instanceof e.AudioSprite?(this[n]=i,this[r]="string"==typeof s?s:""):(this[n]=null,this[r]="")},e.Button.prototype.playStateSound=function(t){var e=this["on"+t+"Sound"];if(e){var i=this["on"+t+"SoundMarker"];return e.play(i),!0}return!1},e.Button.prototype.setSounds=function(t,e,i,s,n,r,o,a){this.setStateSound("Over",t,e),this.setStateSound("Out",n,r),this.setStateSound("Down",i,s),this.setStateSound("Up",o,a)},e.Button.prototype.setOverSound=function(t,e){this.setStateSound("Over",t,e)},e.Button.prototype.setOutSound=function(t,e){this.setStateSound("Out",t,e)},e.Button.prototype.setDownSound=function(t,e){this.setStateSound("Down",t,e)},e.Button.prototype.setUpSound=function(t,e){this.setStateSound("Up",t,e)},e.Button.prototype.onInputOverHandler=function(t,e){e.justReleased()&&(this.justReleasedPreventsOver&e.pointerMode)===e.pointerMode||(this.changeStateFrame("Over"),this.onOverMouseOnly&&!e.isMouse||(this.playStateSound("Over"),this.onInputOver&&this.onInputOver.dispatch(this,e)))},e.Button.prototype.onInputOutHandler=function(t,e){this.changeStateFrame("Out"),this.playStateSound("Out"),this.onInputOut&&this.onInputOut.dispatch(this,e)},e.Button.prototype.onInputDownHandler=function(t,e){this.changeStateFrame("Down"),this.playStateSound("Down"),this.onInputDown&&this.onInputDown.dispatch(this,e)},e.Button.prototype.onInputUpHandler=function(t,e,i){this.playStateSound("Up"),this.onInputUp&&this.onInputUp.dispatch(this,e,i),this.freezeFrames||(!0===this.forceOut||(this.forceOut&e.pointerMode)===e.pointerMode?this.changeStateFrame("Out"):this.changeStateFrame("Up")||(i?this.changeStateFrame("Over"):this.changeStateFrame("Out")))},e.SpriteBatch=function(t,i,s,n){void 0!==i&&null!==i||(i=t.world),e.Group.call(this,t,i,s,n),this.type=e.SPRITEBATCH,this.fastSpriteBatch=null,this.ready=!1},e.SpriteBatch.prototype=Object.create(e.Group.prototype),e.SpriteBatch.prototype.constructor=e.SpriteBatch,e.SpriteBatch.prototype._renderWebGL=function(t){!this.visible||this.alpha<=0||!this.children.length||(this.ready||(this.fastSpriteBatch=new PIXI.WebGLFastSpriteBatch(t.gl),this.ready=!0),this.fastSpriteBatch.gl!==t.gl&&this.fastSpriteBatch.setContext(t.gl),t.spriteBatch.stop(),t.shaderManager.setShader(t.shaderManager.fastShader),this.fastSpriteBatch.begin(this,t),this.fastSpriteBatch.render(this),t.spriteBatch.start())},e.SpriteBatch.prototype._renderCanvas=function(t){if(this.visible&&!(this.alpha<=0)&&this.children.length){var e=t.context;e.globalAlpha=this.worldAlpha,this.displayObjectUpdateTransform();for(var i=this.worldTransform,s=!0,n=0;n<this.children.length;n++){var r=this.children[n];if(r.visible){var o=r.texture,a=o.frame;if(e.globalAlpha=this.worldAlpha*r.alpha,r.rotation%(2*Math.PI)==0)s&&(e.setTransform(i.a,i.b,i.c,i.d,i.tx,i.ty),s=!1),e.drawImage(o.baseTexture.source,a.x,a.y,a.width,a.height,r.anchor.x*(-a.width*r.scale.x)+r.position.x+.5+t.shakeX|0,r.anchor.y*(-a.height*r.scale.y)+r.position.y+.5+t.shakeY|0,a.width*r.scale.x,a.height*r.scale.y);else{s||(s=!0),r.displayObjectUpdateTransform();var h=r.worldTransform,l=h.tx*t.resolution+t.shakeX,c=h.ty*t.resolution+t.shakeY;t.roundPixels?e.setTransform(h.a,h.b,h.c,h.d,0|l,0|c):e.setTransform(h.a,h.b,h.c,h.d,l,c),e.drawImage(o.baseTexture.source,a.x,a.y,a.width,a.height,r.anchor.x*-a.width+.5|0,r.anchor.y*-a.height+.5|0,a.width,a.height)}}}}},e.BitmapData=function(t,i,s,n,r){void 0!==s&&0!==s||(s=256),void 0!==n&&0!==n||(n=256),void 0===r&&(r=!1),this.game=t,this.key=i,this.width=s,this.height=n,this.canvas=e.Canvas.create(this,s,n,null,r),this.context=this.canvas.getContext("2d",{alpha:!0}),this.ctx=this.context,this.smoothProperty=t.renderType===e.CANVAS?t.renderer.renderSession.smoothProperty:e.Canvas.getSmoothingPrefix(this.context),this.imageData=this.context.getImageData(0,0,s,n),this.data=null,this.imageData&&(this.data=this.imageData.data),this.pixels=null,this.data&&(this.imageData.data.buffer?(this.buffer=this.imageData.data.buffer,this.pixels=new Uint32Array(this.buffer)):window.ArrayBuffer?(this.buffer=new ArrayBuffer(this.imageData.data.length),this.pixels=new Uint32Array(this.buffer)):this.pixels=this.imageData.data),this.baseTexture=new PIXI.BaseTexture(this.canvas,null,this.game.resolution),this.texture=new PIXI.Texture(this.baseTexture),this.frameData=new e.FrameData,this.textureFrame=this.frameData.addFrame(new e.Frame(0,0,0,s,n,"bitmapData")),this.texture.frame=this.textureFrame,this.type=e.BITMAPDATA,this.disableTextureUpload=!1,this.dirty=!1,this.cls=this.clear,this._image=null,this._pos=new e.Point,this._size=new e.Point,this._scale=new e.Point,this._rotate=0,this._alpha={prev:1,current:1},this._anchor=new e.Point,this._tempR=0,this._tempG=0,this._tempB=0,this._circle=new e.Circle,this._swapCanvas=void 0},e.BitmapData.prototype={move:function(t,e,i){return 0!==t&&this.moveH(t,i),0!==e&&this.moveV(e,i),this},moveH:function(t,i){void 0===i&&(i=!0),void 0===this._swapCanvas&&(this._swapCanvas=e.CanvasPool.create(this,this.width,this.height));var s=this._swapCanvas.getContext("2d"),n=this.height,r=this.canvas;if(s.clearRect(0,0,this.width,this.height),t<0){t=Math.abs(t);o=this.width-t;i&&s.drawImage(r,0,0,t,n,o,0,t,n),s.drawImage(r,t,0,o,n,0,0,o,n)}else{var o=this.width-t;i&&s.drawImage(r,o,0,t,n,0,0,t,n),s.drawImage(r,0,0,o,n,t,0,o,n)}return this.clear(),this.copy(this._swapCanvas)},moveV:function(t,i){void 0===i&&(i=!0),void 0===this._swapCanvas&&(this._swapCanvas=e.CanvasPool.create(this,this.width,this.height));var s=this._swapCanvas.getContext("2d"),n=this.width,r=this.canvas;if(s.clearRect(0,0,this.width,this.height),t<0){t=Math.abs(t);o=this.height-t;i&&s.drawImage(r,0,0,n,t,0,o,n,t),s.drawImage(r,0,t,n,o,0,0,n,o)}else{var o=this.height-t;i&&s.drawImage(r,0,o,n,t,0,0,n,t),s.drawImage(r,0,0,n,o,0,t,n,o)}return this.clear(),this.copy(this._swapCanvas)},add:function(t){if(Array.isArray(t))for(var e=0;e<t.length;e++)t[e].loadTexture&&t[e].loadTexture(this);else t.loadTexture(this);return this},load:function(t){if("string"==typeof t&&(t=this.game.cache.getImage(t)),t)return this.resize(t.width,t.height),this.cls(),this.draw(t),this.update(),this},clear:function(t,e,i,s){return void 0===t&&(t=0),void 0===e&&(e=0),void 0===i&&(i=this.width),void 0===s&&(s=this.height),this.context.clearRect(t,e,i,s),this.dirty=!0,this},fill:function(t,e,i,s){return void 0===s&&(s=1),this.context.fillStyle="rgba("+t+","+e+","+i+","+s+")",this.context.fillRect(0,0,this.width,this.height),this.dirty=!0,this},generateTexture:function(t,e,i){var s=this.game.cache,n=new Image;if(e&&(n.onload=function(){var r=s.addImage(t,"",n),o=new PIXI.Texture(r.base);e.call(i||null,o),n.onload=null}),n.src=this.canvas.toDataURL("image/png"),!e){var r=s.addImage(t,"",n);return new PIXI.Texture(r.base)}return null},resize:function(t,e){return t===this.width&&e===this.height||(this.width=t,this.height=e,this.canvas.width=t,this.canvas.height=e,void 0!==this._swapCanvas&&(this._swapCanvas.width=t,this._swapCanvas.height=e),this.baseTexture.width=t,this.baseTexture.height=e,this.textureFrame.width=t,this.textureFrame.height=e,this.texture.width=t,this.texture.height=e,this.texture.crop.width=t,this.texture.crop.height=e,this.update(),this.dirty=!0),this},update:function(t,e,i,s){return void 0===t&&(t=0),void 0===e&&(e=0),void 0===i&&(i=Math.max(1,this.width)),void 0===s&&(s=Math.max(1,this.height)),this.imageData=this.context.getImageData(t,e,i,s),this.data=this.imageData.data,this.imageData.data.buffer?(this.buffer=this.imageData.data.buffer,this.pixels=new Uint32Array(this.buffer)):window.ArrayBuffer?(this.buffer=new ArrayBuffer(this.imageData.data.length),this.pixels=new Uint32Array(this.buffer)):this.pixels=this.imageData.data,this},processPixelRGB:function(t,i,s,n,r,o){void 0===s&&(s=0),void 0===n&&(n=0),void 0===r&&(r=this.width),void 0===o&&(o=this.height);for(var a=s+r,h=n+o,l=e.Color.createColor(),c={r:0,g:0,b:0,a:0},u=!1,d=n;d<h;d++)for(var p=s;p<a;p++)e.Color.unpackPixel(this.getPixel32(p,d),l),!1!==(c=t.call(i,l,p,d))&&null!==c&&void 0!==c&&(this.setPixel32(p,d,c.r,c.g,c.b,c.a,!1),u=!0);return u&&(this.context.putImageData(this.imageData,0,0),this.dirty=!0),this},processPixel:function(t,e,i,s,n,r){void 0===i&&(i=0),void 0===s&&(s=0),void 0===n&&(n=this.width),void 0===r&&(r=this.height);for(var o=i+n,a=s+r,h=0,l=0,c=!1,u=s;u<a;u++)for(var d=i;d<o;d++)h=this.getPixel32(d,u),(l=t.call(e,h,d,u))!==h&&(this.pixels[u*this.width+d]=l,c=!0);return c&&(this.context.putImageData(this.imageData,0,0),this.dirty=!0),this},replaceRGB:function(t,i,s,n,r,o,a,h,l){var c=0,u=0,d=this.width,p=this.height,f=e.Color.packPixel(t,i,s,n);void 0!==l&&l instanceof e.Rectangle&&(c=l.x,u=l.y,d=l.width,p=l.height);for(var g=0;g<p;g++)for(var m=0;m<d;m++)this.getPixel32(c+m,u+g)===f&&this.setPixel32(c+m,u+g,r,o,a,h,!1);return this.context.putImageData(this.imageData,0,0),this.dirty=!0,this},setHSL:function(t,i,s,n){var r=t||0===t,o=i||0===i,a=s||0===s;if(r||o||a){void 0===n&&(n=new e.Rectangle(0,0,this.width,this.height));for(var h=e.Color.createColor(),l=n.y;l<n.bottom;l++)for(var c=n.x;c<n.right;c++)e.Color.unpackPixel(this.getPixel32(c,l),h,!0),r&&(h.h=t),o&&(h.s=i),a&&(h.l=s),e.Color.HSLtoRGB(h.h,h.s,h.l,h),this.setPixel32(c,l,h.r,h.g,h.b,h.a,!1);return this.context.putImageData(this.imageData,0,0),this.dirty=!0,this}},shiftHSL:function(t,i,s,n){if(void 0!==t&&null!==t||(t=!1),void 0!==i&&null!==i||(i=!1),void 0!==s&&null!==s||(s=!1),t||i||s){void 0===n&&(n=new e.Rectangle(0,0,this.width,this.height));for(var r=e.Color.createColor(),o=n.y;o<n.bottom;o++)for(var a=n.x;a<n.right;a++)e.Color.unpackPixel(this.getPixel32(a,o),r,!0),t&&(r.h=this.game.math.wrap(r.h+t,0,1)),i&&(r.s=this.game.math.clamp(r.s+i,0,1)),s&&(r.l=this.game.math.clamp(r.l+s,0,1)),e.Color.HSLtoRGB(r.h,r.s,r.l,r),this.setPixel32(a,o,r.r,r.g,r.b,r.a,!1);return this.context.putImageData(this.imageData,0,0),this.dirty=!0,this}},setPixel32:function(t,i,s,n,r,o,a){return void 0===a&&(a=!0),t>=0&&t<=this.width&&i>=0&&i<=this.height&&(e.Device.LITTLE_ENDIAN?this.pixels[i*this.width+t]=o<<24|r<<16|n<<8|s:this.pixels[i*this.width+t]=s<<24|n<<16|r<<8|o,a&&(this.context.putImageData(this.imageData,0,0),this.dirty=!0)),this},setPixel:function(t,e,i,s,n,r){return this.setPixel32(t,e,i,s,n,255,r)},getPixel:function(t,i,s){s||(s=e.Color.createColor());var n=~~(t+i*this.width);return n*=4,s.r=this.data[n],s.g=this.data[++n],s.b=this.data[++n],s.a=this.data[++n],s},getPixel32:function(t,e){if(t>=0&&t<=this.width&&e>=0&&e<=this.height)return this.pixels[e*this.width+t]},getPixelRGB:function(t,i,s,n,r){return e.Color.unpackPixel(this.getPixel32(t,i),s,n,r)},getPixels:function(t){return this.context.getImageData(t.x,t.y,t.width,t.height)},getFirstPixel:function(t){void 0===t&&(t=0);var i=e.Color.createColor(),s=0,n=0,r=1,o=!1;1===t?(r=-1,n=this.height):3===t&&(r=-1,s=this.width);do{e.Color.unpackPixel(this.getPixel32(s,n),i),0===t||1===t?++s===this.width&&(s=0,((n+=r)>=this.height||n<=0)&&(o=!0)):2!==t&&3!==t||++n===this.height&&(n=0,((s+=r)>=this.width||s<=0)&&(o=!0))}while(0===i.a&&!o);return i.x=s,i.y=n,i},getBounds:function(t){return void 0===t&&(t=new e.Rectangle),t.x=this.getFirstPixel(2).x,t.x===this.width?t.setTo(0,0,0,0):(t.y=this.getFirstPixel(0).y,t.width=this.getFirstPixel(3).x-t.x+1,t.height=this.getFirstPixel(1).y-t.y+1,t)},addToWorld:function(t,e,i,s,n,r){n=n||1,r=r||1;var o=this.game.add.image(t,e,this);return o.anchor.set(i,s),o.scale.set(n,r),o},copy:function(t,i,s,n,r,o,a,h,l,c,u,d,p,f,g,m,y){if(void 0!==t&&null!==t||(t=this),t instanceof e.RenderTexture&&(t=t.getCanvas()),this._image=t,t instanceof e.Sprite||t instanceof e.Image||t instanceof e.Text||t instanceof PIXI.Sprite)this._pos.set(t.texture.crop.x,t.texture.crop.y),this._size.set(t.texture.crop.width,t.texture.crop.height),this._scale.set(t.scale.x,t.scale.y),this._anchor.set(t.anchor.x,t.anchor.y),this._rotate=t.rotation,this._alpha.current=t.alpha,t.texture instanceof e.RenderTexture?this._image=t.texture.getCanvas():this._image=t.texture.baseTexture.source,void 0!==o&&null!==o||(o=t.x),void 0!==a&&null!==a||(a=t.y),t.texture.trim&&(o+=t.texture.trim.x-t.anchor.x*t.texture.trim.width,a+=t.texture.trim.y-t.anchor.y*t.texture.trim.height),16777215!==t.tint&&(t.cachedTint!==t.tint&&(t.cachedTint=t.tint,t.tintedTexture=PIXI.CanvasTinter.getTintedTexture(t,t.tint)),this._image=t.tintedTexture,this._pos.set(0));else{if(this._pos.set(0),this._scale.set(1),this._anchor.set(0),this._rotate=0,this._alpha.current=1,t instanceof e.BitmapData)this._image=t.canvas;else if("string"==typeof t){if(null===(t=this.game.cache.getImage(t)))return this;this._image=t}this._size.set(this._image.width,this._image.height)}if(void 0!==i&&null!==i||(i=0),void 0!==s&&null!==s||(s=0),n&&(this._size.x=n),r&&(this._size.y=r),void 0!==o&&null!==o||(o=i),void 0!==a&&null!==a||(a=s),void 0!==h&&null!==h||(h=this._size.x),void 0!==l&&null!==l||(l=this._size.y),"number"==typeof c&&(this._rotate=c),"number"==typeof u&&(this._anchor.x=u),"number"==typeof d&&(this._anchor.y=d),"number"==typeof p&&(this._scale.x=p),"number"==typeof f&&(this._scale.y=f),"number"==typeof g&&(this._alpha.current=g),void 0===m&&(m=null),void 0===y&&(y=!1),this._alpha.current<=0||0===this._scale.x||0===this._scale.y||0===this._size.x||0===this._size.y)return this;var v=this.context;return this._alpha.prev=v.globalAlpha,v.save(),v.globalAlpha=this._alpha.current,m&&(this.op=m),y&&(o|=0,a|=0),v.translate(o,a),v.scale(this._scale.x,this._scale.y),v.rotate(this._rotate),v.drawImage(this._image,this._pos.x+i,this._pos.y+s,this._size.x,this._size.y,-h*this._anchor.x,-l*this._anchor.y,h,l),v.restore(),v.globalAlpha=this._alpha.prev,this.dirty=!0,this},copyTransform:function(t,i,s){if(void 0===i&&(i=null),void 0===s&&(s=!1),!t.hasOwnProperty("worldTransform")||!t.worldVisible||0===t.worldAlpha)return this;var n=t.worldTransform;if(this._pos.set(t.texture.crop.x,t.texture.crop.y),this._size.set(t.texture.crop.width,t.texture.crop.height),0===n.a||0===n.d||0===this._size.x||0===this._size.y)return this;t.texture instanceof e.RenderTexture?this._image=t.texture.getCanvas():this._image=t.texture.baseTexture.source;var r=n.tx,o=n.ty;t.texture.trim&&(r+=t.texture.trim.x-t.anchor.x*t.texture.trim.width,o+=t.texture.trim.y-t.anchor.y*t.texture.trim.height),16777215!==t.tint&&(t.cachedTint!==t.tint&&(t.cachedTint=t.tint,t.tintedTexture=PIXI.CanvasTinter.getTintedTexture(t,t.tint)),this._image=t.tintedTexture,this._pos.set(0)),s&&(r|=0,o|=0);var a=this.context;return this._alpha.prev=a.globalAlpha,a.save(),a.globalAlpha=this._alpha.current,i&&(this.op=i),a[this.smoothProperty]=t.texture.baseTexture.scaleMode===PIXI.scaleModes.LINEAR,a.setTransform(n.a,n.b,n.c,n.d,r,o),a.drawImage(this._image,this._pos.x,this._pos.y,this._size.x,this._size.y,-this._size.x*t.anchor.x,-this._size.y*t.anchor.y,this._size.x,this._size.y),a.restore(),a.globalAlpha=this._alpha.prev,this.dirty=!0,this},copyRect:function(t,e,i,s,n,r,o){return this.copy(t,e.x,e.y,e.width,e.height,i,s,e.width,e.height,0,0,0,1,1,n,r,o)},draw:function(t,e,i,s,n,r,o){return this.copy(t,null,null,null,null,e,i,s,n,null,null,null,null,null,null,r,o)},drawGroup:function(t,e,i){return t.total>0&&t.forEachExists(this.drawGroupProxy,this,e,i),this},drawGroupProxy:function(t,i,s){if(t.hasOwnProperty("texture")&&this.copyTransform(t,i,s),t.type===e.GROUP&&t.exists)this.drawGroup(t,i,s);else if(t.hasOwnProperty("children")&&t.children.length>0)for(var n=0;n<t.children.length;n++)t.children[n].exists&&this.copyTransform(t.children[n],i,s)},drawFull:function(t,i,s){if(!1===t.worldVisible||0===t.worldAlpha||t.hasOwnProperty("exists")&&!1===t.exists)return this;if(t.type!==e.GROUP&&t.type!==e.EMITTER&&t.type!==e.BITMAPTEXT)if(t.type===e.GRAPHICS){var n=t.getBounds();this.ctx.save(),this.ctx.translate(n.x,n.y),PIXI.CanvasGraphics.renderGraphics(t,this.ctx),this.ctx.restore()}else this.copy(t,null,null,null,null,t.worldPosition.x,t.worldPosition.y,null,null,t.worldRotation,null,null,t.worldScale.x,t.worldScale.y,t.worldAlpha,i,s);if(t.children)for(var r=0;r<t.children.length;r++)this.drawFull(t.children[r],i,s);return this},shadow:function(t,e,i,s){var n=this.context;return void 0===t||null===t?n.shadowColor="rgba(0,0,0,0)":(n.shadowColor=t,n.shadowBlur=0===e?0:e||5,n.shadowOffsetX=0===i?0:i||10,n.shadowOffsetY=0===s?0:s||10),this},alphaMask:function(t,e,i,s){return void 0===s||null===s?this.draw(e).blendSourceAtop():this.draw(e,s.x,s.y,s.width,s.height).blendSourceAtop(),void 0===i||null===i?this.draw(t).blendReset():this.draw(t,i.x,i.y,i.width,i.height).blendReset(),this},extract:function(t,e,i,s,n,r,o,a,h){return void 0===n&&(n=255),void 0===r&&(r=!1),void 0===o&&(o=e),void 0===a&&(a=i),void 0===h&&(h=s),r&&t.resize(this.width,this.height),this.processPixelRGB(function(r,l,c){return r.r===e&&r.g===i&&r.b===s&&t.setPixel32(l,c,o,a,h,n,!1),!1},this),t.context.putImageData(t.imageData,0,0),t.dirty=!0,t},rect:function(t,e,i,s,n){return void 0!==n&&(this.context.fillStyle=n),this.context.fillRect(t,e,i,s),this},text:function(t,e,i,s,n,r){void 0===e&&(e=0),void 0===i&&(i=0),void 0===s&&(s="14px Courier"),void 0===n&&(n="rgb(255,255,255)"),void 0===r&&(r=!0);var o=this.context,a=o.font;return o.font=s,r&&(o.fillStyle="rgb(0,0,0)",o.fillText(t,e+1,i+1)),o.fillStyle=n,o.fillText(t,e,i),o.font=a,this},circle:function(t,e,i,s){var n=this.context;return void 0!==s&&(n.fillStyle=s),n.beginPath(),n.arc(t,e,i,0,2*Math.PI,!1),n.closePath(),n.fill(),this},line:function(t,e,i,s,n,r){void 0===n&&(n="#fff"),void 0===r&&(r=1);var o=this.context;return o.beginPath(),o.moveTo(t,e),o.lineTo(i,s),o.lineWidth=r,o.strokeStyle=n,o.stroke(),o.closePath(),this},polygon:function(t,e,i,s){void 0===s&&(s="#fff"),void 0===i&&(i=0);var n=this.context;e&&(n.fillStyle=e),i&&(n.lineWidth=i,n.strokeStyle=s),n.beginPath(),n.moveTo(t[0].x,t[0].y);for(var r=1,o=t.length;r<o;r++){var a=t[r];n.lineTo(a.x,a.y)}return n.closePath(),e&&n.fill(),i&&n.stroke(),this},textureLine:function(t,i,s){if(void 0===s&&(s="repeat-x"),"string"!=typeof i||(i=this.game.cache.getImage(i))){var n=t.length;"no-repeat"===s&&n>i.width&&(n=i.width);var r=this.context;return r.fillStyle=r.createPattern(i,s),this._circle=new e.Circle(t.start.x,t.start.y,i.height),this._circle.circumferencePoint(t.angle-1.5707963267948966,!1,this._pos),r.save(),r.translate(this._pos.x,this._pos.y),r.rotate(t.angle),r.fillRect(0,0,n,i.height),r.restore(),this.dirty=!0,this}},render:function(){return!this.disableTextureUpload&&this.dirty&&(this.baseTexture.dirty(),this.dirty=!1),this},destroy:function(){this.frameData.destroy(),this.texture.destroy(!0),e.CanvasPool.remove(this)},blendReset:function(){return this.op="source-over",this},blendSourceOver:function(){return this.op="source-over",this},blendSourceIn:function(){return this.op="source-in",this},blendSourceOut:function(){return this.op="source-out",this},blendSourceAtop:function(){return this.op="source-atop",this},blendDestinationOver:function(){return this.op="destination-over",this},blendDestinationIn:function(){return this.op="destination-in",this},blendDestinationOut:function(){return this.op="destination-out",this},blendDestinationAtop:function(){return this.op="destination-atop",this},blendXor:function(){return this.op="xor",this},blendAdd:function(){return this.op="lighter",this},blendMultiply:function(){return this.op="multiply",this},blendScreen:function(){return this.op="screen",this},blendOverlay:function(){return this.op="overlay",this},blendDarken:function(){return this.op="darken",this},blendLighten:function(){return this.op="lighten",this},blendColorDodge:function(){return this.op="color-dodge",this},blendColorBurn:function(){return this.op="color-burn",this},blendHardLight:function(){return this.op="hard-light",this},blendSoftLight:function(){return this.op="soft-light",this},blendDifference:function(){return this.op="difference",this},blendExclusion:function(){return this.op="exclusion",this},blendHue:function(){return this.op="hue",this},blendSaturation:function(){return this.op="saturation",this},blendColor:function(){return this.op="color",this},blendLuminosity:function(){return this.op="luminosity",this},copyBitmapData:function(t,e,i){t.update();for(var s,n=0;n<t.height;n++){s=(i+n)*this.width+e;for(var r=0;r<t.width;r++)this.pixels[s+r]=t.pixels[n*t.width+r]}return this}},Object.defineProperty(e.BitmapData.prototype,"smoothed",{get:function(){e.Canvas.getSmoothingEnabled(this.context)},set:function(t){e.Canvas.setSmoothingEnabled(this.context,t)}}),Object.defineProperty(e.BitmapData.prototype,"op",{get:function(){return this.context.globalCompositeOperation},set:function(t){this.context.globalCompositeOperation=t}}),e.BitmapData.getTransform=function(t,e,i,s,n,r){return"number"!=typeof t&&(t=0),"number"!=typeof e&&(e=0),"number"!=typeof i&&(i=1),"number"!=typeof s&&(s=1),"number"!=typeof n&&(n=0),"number"!=typeof r&&(r=0),{sx:i,sy:s,scaleX:i,scaleY:s,skewX:n,skewY:r,translateX:t,translateY:e,tx:t,ty:e}},e.BitmapData.prototype.constructor=e.BitmapData,e.EarCut={},e.EarCut.Triangulate=function(t,i,s){s=s||2;var n=i&&i.length,r=n?i[0]*s:t.length,o=e.EarCut.linkedList(t,0,r,s,!0),a=[];if(!o)return a;var h,l,c,u,d,p,f;if(n&&(o=e.EarCut.eliminateHoles(t,i,o,s)),t.length>80*s){h=c=t[0],l=u=t[1];for(var g=s;g<r;g+=s)d=t[g],p=t[g+1],d<h&&(h=d),p<l&&(l=p),d>c&&(c=d),p>u&&(u=p);f=Math.max(c-h,u-l)}return e.EarCut.earcutLinked(o,a,s,h,l,f),a},e.EarCut.linkedList=function(t,i,s,n,r){var o,a,h,l=0;for(o=i,a=s-n;o<s;o+=n)l+=(t[a]-t[o])*(t[o+1]+t[a+1]),a=o;if(r===l>0)for(o=i;o<s;o+=n)h=e.EarCut.insertNode(o,t[o],t[o+1],h);else for(o=s-n;o>=i;o-=n)h=e.EarCut.insertNode(o,t[o],t[o+1],h);return h},e.EarCut.filterPoints=function(t,i){if(!t)return t;i||(i=t);var s,n=t;do{if(s=!1,n.steiner||!e.EarCut.equals(n,n.next)&&0!==e.EarCut.area(n.prev,n,n.next))n=n.next;else{if(e.EarCut.removeNode(n),(n=i=n.prev)===n.next)return null;s=!0}}while(s||n!==i);return i},e.EarCut.earcutLinked=function(t,i,s,n,r,o,a){if(t){!a&&o&&e.EarCut.indexCurve(t,n,r,o);for(var h,l,c=t;t.prev!==t.next;)if(h=t.prev,l=t.next,o?e.EarCut.isEarHashed(t,n,r,o):e.EarCut.isEar(t))i.push(h.i/s),i.push(t.i/s),i.push(l.i/s),e.EarCut.removeNode(t),t=l.next,c=l.next;else if((t=l)===c){a?1===a?(t=e.EarCut.cureLocalIntersections(t,i,s),e.EarCut.earcutLinked(t,i,s,n,r,o,2)):2===a&&e.EarCut.splitEarcut(t,i,s,n,r,o):e.EarCut.earcutLinked(e.EarCut.filterPoints(t),i,s,n,r,o,1);break}}},e.EarCut.isEar=function(t){var i=t.prev,s=t,n=t.next;if(e.EarCut.area(i,s,n)>=0)return!1;for(var r=t.next.next;r!==t.prev;){if(e.EarCut.pointInTriangle(i.x,i.y,s.x,s.y,n.x,n.y,r.x,r.y)&&e.EarCut.area(r.prev,r,r.next)>=0)return!1;r=r.next}return!0},e.EarCut.isEarHashed=function(t,i,s,n){var r=t.prev,o=t,a=t.next;if(e.EarCut.area(r,o,a)>=0)return!1;for(var h=r.x<o.x?r.x<a.x?r.x:a.x:o.x<a.x?o.x:a.x,l=r.y<o.y?r.y<a.y?r.y:a.y:o.y<a.y?o.y:a.y,c=r.x>o.x?r.x>a.x?r.x:a.x:o.x>a.x?o.x:a.x,u=r.y>o.y?r.y>a.y?r.y:a.y:o.y>a.y?o.y:a.y,d=e.EarCut.zOrder(h,l,i,s,n),p=e.EarCut.zOrder(c,u,i,s,n),f=t.nextZ;f&&f.z<=p;){if(f!==t.prev&&f!==t.next&&e.EarCut.pointInTriangle(r.x,r.y,o.x,o.y,a.x,a.y,f.x,f.y)&&e.EarCut.area(f.prev,f,f.next)>=0)return!1;f=f.nextZ}for(f=t.prevZ;f&&f.z>=d;){if(f!==t.prev&&f!==t.next&&e.EarCut.pointInTriangle(r.x,r.y,o.x,o.y,a.x,a.y,f.x,f.y)&&e.EarCut.area(f.prev,f,f.next)>=0)return!1;f=f.prevZ}return!0},e.EarCut.cureLocalIntersections=function(t,i,s){var n=t;do{var r=n.prev,o=n.next.next;e.EarCut.intersects(r,n,n.next,o)&&e.EarCut.locallyInside(r,o)&&e.EarCut.locallyInside(o,r)&&(i.push(r.i/s),i.push(n.i/s),i.push(o.i/s),e.EarCut.removeNode(n),e.EarCut.removeNode(n.next),n=t=o),n=n.next}while(n!==t);return n},e.EarCut.splitEarcut=function(t,i,s,n,r,o){var a=t;do{for(var h=a.next.next;h!==a.prev;){if(a.i!==h.i&&e.EarCut.isValidDiagonal(a,h)){var l=e.EarCut.splitPolygon(a,h);return a=e.EarCut.filterPoints(a,a.next),l=e.EarCut.filterPoints(l,l.next),e.EarCut.earcutLinked(a,i,s,n,r,o),void e.EarCut.earcutLinked(l,i,s,n,r,o)}h=h.next}a=a.next}while(a!==t)},e.EarCut.eliminateHoles=function(t,i,s,n){var r,o,a,h,l,c=[];for(r=0,o=i.length;r<o;r++)a=i[r]*n,h=r<o-1?i[r+1]*n:t.length,(l=e.EarCut.linkedList(t,a,h,n,!1))===l.next&&(l.steiner=!0),c.push(e.EarCut.getLeftmost(l));for(c.sort(e.EarCut.compareX),r=0;r<c.length;r++)e.EarCut.eliminateHole(c[r],s),s=e.EarCut.filterPoints(s,s.next);return s},e.EarCut.compareX=function(t,e){return t.x-e.x},e.EarCut.eliminateHole=function(t,i){if(i=e.EarCut.findHoleBridge(t,i)){var s=e.EarCut.splitPolygon(i,t);e.EarCut.filterPoints(s,s.next)}},e.EarCut.findHoleBridge=function(t,i){var s,n=i,r=t.x,o=t.y,a=-1/0;do{if(o<=n.y&&o>=n.next.y){var h=n.x+(o-n.y)*(n.next.x-n.x)/(n.next.y-n.y);h<=r&&h>a&&(a=h,s=n.x<n.next.x?n:n.next)}n=n.next}while(n!==i);if(!s)return null;if(t.x===s.x)return s.prev;var l,c=s,u=1/0;for(n=s.next;n!==c;)r>=n.x&&n.x>=s.x&&e.EarCut.pointInTriangle(o<s.y?r:a,o,s.x,s.y,o<s.y?a:r,o,n.x,n.y)&&((l=Math.abs(o-n.y)/(r-n.x))<u||l===u&&n.x>s.x)&&e.EarCut.locallyInside(n,t)&&(s=n,u=l),n=n.next;return s},e.EarCut.indexCurve=function(t,i,s,n){var r=t;do{null===r.z&&(r.z=e.EarCut.zOrder(r.x,r.y,i,s,n)),r.prevZ=r.prev,r.nextZ=r.next,r=r.next}while(r!==t);r.prevZ.nextZ=null,r.prevZ=null,e.EarCut.sortLinked(r)},e.EarCut.sortLinked=function(t){var e,i,s,n,r,o,a,h,l=1;do{for(i=t,t=null,r=null,o=0;i;){for(o++,s=i,a=0,e=0;e<l&&(a++,s=s.nextZ);e++);for(h=l;a>0||h>0&&s;)0===a?(n=s,s=s.nextZ,h--):0!==h&&s?i.z<=s.z?(n=i,i=i.nextZ,a--):(n=s,s=s.nextZ,h--):(n=i,i=i.nextZ,a--),r?r.nextZ=n:t=n,n.prevZ=r,r=n;i=s}r.nextZ=null,l*=2}while(o>1);return t},e.EarCut.zOrder=function(t,e,i,s,n){return t=32767*(t-i)/n,e=32767*(e-s)/n,t=16711935&(t|t<<8),t=252645135&(t|t<<4),t=858993459&(t|t<<2),t=1431655765&(t|t<<1),e=16711935&(e|e<<8),e=252645135&(e|e<<4),e=858993459&(e|e<<2),e=1431655765&(e|e<<1),t|e<<1},e.EarCut.getLeftmost=function(t){var e=t,i=t;do{e.x<i.x&&(i=e),e=e.next}while(e!==t);return i},e.EarCut.pointInTriangle=function(t,e,i,s,n,r,o,a){return(n-o)*(e-a)-(t-o)*(r-a)>=0&&(t-o)*(s-a)-(i-o)*(e-a)>=0&&(i-o)*(r-a)-(n-o)*(s-a)>=0},e.EarCut.isValidDiagonal=function(t,i){return e.EarCut.equals(t,i)||t.next.i!==i.i&&t.prev.i!==i.i&&!e.EarCut.intersectsPolygon(t,i)&&e.EarCut.locallyInside(t,i)&&e.EarCut.locallyInside(i,t)&&e.EarCut.middleInside(t,i)},e.EarCut.area=function(t,e,i){return(e.y-t.y)*(i.x-e.x)-(e.x-t.x)*(i.y-e.y)},e.EarCut.equals=function(t,e){return t.x===e.x&&t.y===e.y},e.EarCut.intersects=function(t,i,s,n){return e.EarCut.area(t,i,s)>0!=e.EarCut.area(t,i,n)>0&&e.EarCut.area(s,n,t)>0!=e.EarCut.area(s,n,i)>0},e.EarCut.intersectsPolygon=function(t,i){var s=t;do{if(s.i!==t.i&&s.next.i!==t.i&&s.i!==i.i&&s.next.i!==i.i&&e.EarCut.intersects(s,s.next,t,i))return!0;s=s.next}while(s!==t);return!1},e.EarCut.locallyInside=function(t,i){return e.EarCut.area(t.prev,t,t.next)<0?e.EarCut.area(t,i,t.next)>=0&&e.EarCut.area(t,t.prev,i)>=0:e.EarCut.area(t,i,t.prev)<0||e.EarCut.area(t,t.next,i)<0},e.EarCut.middleInside=function(t,e){var i=t,s=!1,n=(t.x+e.x)/2,r=(t.y+e.y)/2;do{i.y>r!=i.next.y>r&&n<(i.next.x-i.x)*(r-i.y)/(i.next.y-i.y)+i.x&&(s=!s),i=i.next}while(i!==t);return s},e.EarCut.splitPolygon=function(t,i){var s=new e.EarCut.Node(t.i,t.x,t.y),n=new e.EarCut.Node(i.i,i.x,i.y),r=t.next,o=i.prev;return t.next=i,i.prev=t,s.next=r,r.prev=s,n.next=s,s.prev=n,o.next=n,n.prev=o,n},e.EarCut.insertNode=function(t,i,s,n){var r=new e.EarCut.Node(t,i,s);return n?(r.next=n.next,r.prev=n,n.next.prev=r,n.next=r):(r.prev=r,r.next=r),r},e.EarCut.removeNode=function(t){t.next.prev=t.prev,t.prev.next=t.next,t.prevZ&&(t.prevZ.nextZ=t.nextZ),t.nextZ&&(t.nextZ.prevZ=t.prevZ)},e.EarCut.Node=function(t,e,i){this.i=t,this.x=e,this.y=i,this.prev=null,this.next=null,this.z=null,this.prevZ=null,this.nextZ=null,this.steiner=!1},PIXI.WebGLGraphics=function(){},PIXI.WebGLGraphics.stencilBufferLimit=6,PIXI.WebGLGraphics.renderGraphics=function(t,i){var s,n=i.gl,r=i.projection,o=i.offset,a=i.shaderManager.primitiveShader;t.dirty&&PIXI.WebGLGraphics.updateGraphics(t,n);var h=t._webGL[n.id];if(h)for(var l=0;l<h.data.length;l++)1===h.data[l].mode?(s=h.data[l],i.stencilManager.pushStencil(t,s,i),n.drawElements(n.TRIANGLE_FAN,4,n.UNSIGNED_SHORT,2*(s.indices.length-4)),i.stencilManager.popStencil(t,s,i)):(s=h.data[l],i.shaderManager.setShader(a),a=i.shaderManager.primitiveShader,n.uniformMatrix3fv(a.translationMatrix,!1,t.worldTransform.toArray(!0)),n.uniform1f(a.flipY,1),n.uniform2f(a.projectionVector,r.x,-r.y),n.uniform2f(a.offsetVector,-o.x,-o.y),n.uniform3fv(a.tintColor,e.Color.hexToRGBArray(t.tint)),n.uniform1f(a.alpha,t.worldAlpha),n.bindBuffer(n.ARRAY_BUFFER,s.buffer),n.vertexAttribPointer(a.aVertexPosition,2,n.FLOAT,!1,24,0),n.vertexAttribPointer(a.colorAttribute,4,n.FLOAT,!1,24,8),n.bindBuffer(n.ELEMENT_ARRAY_BUFFER,s.indexBuffer),n.drawElements(n.TRIANGLE_STRIP,s.indices.length,n.UNSIGNED_SHORT,0))},PIXI.WebGLGraphics.updateGraphics=function(t,i){var s=t._webGL[i.id];s||(s=t._webGL[i.id]={lastIndex:0,data:[],gl:i}),t.dirty=!1;var n;if(t.clearDirty){for(t.clearDirty=!1,n=0;n<s.data.length;n++){var r=s.data[n];r.reset(),PIXI.WebGLGraphics.graphicsDataPool.push(r)}s.data=[],s.lastIndex=0}var o;for(n=s.lastIndex;n<t.graphicsData.length;n++){var a=t.graphicsData[n];a.type===e.POLYGON?(a.points=a.shape.points.slice(),a.shape.closed&&(a.points[0]===a.points[a.points.length-2]&&a.points[1]===a.points[a.points.length-1]||a.points.push(a.points[0],a.points[1])),a.fill&&a.points.length>=PIXI.WebGLGraphics.stencilBufferLimit&&(a.points.length<2*PIXI.WebGLGraphics.stencilBufferLimit?(o=PIXI.WebGLGraphics.switchMode(s,0),PIXI.WebGLGraphics.buildPoly(a,o)||(o=PIXI.WebGLGraphics.switchMode(s,1),PIXI.WebGLGraphics.buildComplexPoly(a,o))):(o=PIXI.WebGLGraphics.switchMode(s,1),PIXI.WebGLGraphics.buildComplexPoly(a,o))),a.lineWidth>0&&(o=PIXI.WebGLGraphics.switchMode(s,0),PIXI.WebGLGraphics.buildLine(a,o))):(o=PIXI.WebGLGraphics.switchMode(s,0),a.type===e.RECTANGLE?PIXI.WebGLGraphics.buildRectangle(a,o):a.type===e.CIRCLE||a.type===e.ELLIPSE?PIXI.WebGLGraphics.buildCircle(a,o):a.type===e.ROUNDEDRECTANGLE&&PIXI.WebGLGraphics.buildRoundedRectangle(a,o)),s.lastIndex++}for(n=0;n<s.data.length;n++)(o=s.data[n]).dirty&&o.upload()},PIXI.WebGLGraphics.switchMode=function(t,e){var i;return t.data.length?(i=t.data[t.data.length-1]).mode===e&&1!==e||((i=PIXI.WebGLGraphics.graphicsDataPool.pop()||new PIXI.WebGLGraphicsData(t.gl)).mode=e,t.data.push(i)):((i=PIXI.WebGLGraphics.graphicsDataPool.pop()||new PIXI.WebGLGraphicsData(t.gl)).mode=e,t.data.push(i)),i.dirty=!0,i},PIXI.WebGLGraphics.buildRectangle=function(t,i){var s=t.shape,n=s.x,r=s.y,o=s.width,a=s.height;if(t.fill){var h=e.Color.hexToRGBArray(t.fillColor),l=t.fillAlpha,c=h[0]*l,u=h[1]*l,d=h[2]*l,p=i.points,f=i.indices,g=p.length/6;p.push(n,r),p.push(c,u,d,l),p.push(n+o,r),p.push(c,u,d,l),p.push(n,r+a),p.push(c,u,d,l),p.push(n+o,r+a),p.push(c,u,d,l),f.push(g,g,g+1,g+2,g+3,g+3)}if(t.lineWidth){var m=t.points;t.points=[n,r,n+o,r,n+o,r+a,n,r+a,n,r],PIXI.WebGLGraphics.buildLine(t,i),t.points=m}},PIXI.WebGLGraphics.buildRoundedRectangle=function(t,i){var s=t.shape,n=s.x,r=s.y,o=s.width,a=s.height,h=s.radius,l=[];if(l.push(n,r+h),l=l.concat(PIXI.WebGLGraphics.quadraticBezierCurve(n,r+a-h,n,r+a,n+h,r+a)),l=l.concat(PIXI.WebGLGraphics.quadraticBezierCurve(n+o-h,r+a,n+o,r+a,n+o,r+a-h)),l=l.concat(PIXI.WebGLGraphics.quadraticBezierCurve(n+o,r+h,n+o,r,n+o-h,r)),l=l.concat(PIXI.WebGLGraphics.quadraticBezierCurve(n+h,r,n,r,n,r+h)),t.fill){var c=e.Color.hexToRGBArray(t.fillColor),u=t.fillAlpha,d=c[0]*u,p=c[1]*u,f=c[2]*u,g=i.points,m=i.indices,y=g.length/6,v=e.EarCut.Triangulate(l,null,2),x=0;for(x=0;x<v.length;x+=3)m.push(v[x]+y),m.push(v[x]+y),m.push(v[x+1]+y),m.push(v[x+2]+y),m.push(v[x+2]+y);for(x=0;x<l.length;x++)g.push(l[x],l[++x],d,p,f,u)}if(t.lineWidth){var b=t.points;t.points=l,PIXI.WebGLGraphics.buildLine(t,i),t.points=b}},PIXI.WebGLGraphics.quadraticBezierCurve=function(t,e,i,s,n,r){function o(t,e,i){return t+(e-t)*i}for(var a,h,l,c,u,d,p=[],f=0,g=0;g<=20;g++)a=o(t,i,f=g/20),h=o(e,s,f),l=o(i,n,f),c=o(s,r,f),u=o(a,l,f),d=o(h,c,f),p.push(u,d);return p},PIXI.WebGLGraphics.buildCircle=function(t,i){var s,n,r=t.shape,o=r.x,a=r.y;t.type===e.CIRCLE?(s=r.radius,n=r.radius):(s=r.width,n=r.height);var h=2*Math.PI/40,l=0;if(t.fill){var c=e.Color.hexToRGBArray(t.fillColor),u=t.fillAlpha,d=c[0]*u,p=c[1]*u,f=c[2]*u,g=i.points,m=i.indices,y=g.length/6;for(m.push(y),l=0;l<41;l++)g.push(o,a,d,p,f,u),g.push(o+Math.sin(h*l)*s,a+Math.cos(h*l)*n,d,p,f,u),m.push(y++,y++);m.push(y-1)}if(t.lineWidth){var v=t.points;for(t.points=[],l=0;l<41;l++)t.points.push(o+Math.sin(h*l)*s,a+Math.cos(h*l)*n);PIXI.WebGLGraphics.buildLine(t,i),t.points=v}},PIXI.WebGLGraphics.buildLine=function(t,i){var s=0,n=t.points;if(0!==n.length){if(t.lineWidth%2)for(s=0;s<n.length;s++)n[s]+=.5;var r=new PIXI.Point(n[0],n[1]),o=new PIXI.Point(n[n.length-2],n[n.length-1]);if(r.x===o.x&&r.y===o.y){(n=n.slice()).pop(),n.pop();var a=(o=new PIXI.Point(n[n.length-2],n[n.length-1])).x+.5*(r.x-o.x),h=o.y+.5*(r.y-o.y);n.unshift(a,h),n.push(a,h)}var l,c,u,d,p,f,g,m,y,v,x,b,_,w,T,P,C,S,A,E,M,R,L=i.points,B=i.indices,I=n.length/2,O=n.length,k=L.length/6,F=t.lineWidth/2,D=e.Color.hexToRGBArray(t.lineColor),U=t.lineAlpha,G=D[0]*U,N=D[1]*U,X=D[2]*U;for(u=n[0],d=n[1],p=n[2],y=-(d-(f=n[3])),v=u-p,y/=R=Math.sqrt(y*y+v*v),v/=R,y*=F,v*=F,L.push(u-y,d-v,G,N,X,U),L.push(u+y,d+v,G,N,X,U),s=1;s<I-1;s++)u=n[2*(s-1)],d=n[2*(s-1)+1],p=n[2*s],f=n[2*s+1],g=n[2*(s+1)],m=n[2*(s+1)+1],y=-(d-f),v=u-p,y/=R=Math.sqrt(y*y+v*v),v/=R,y*=F,v*=F,x=-(f-m),b=p-g,x/=R=Math.sqrt(x*x+b*b),b/=R,C=(-y+u)*(-v+f)-(-y+p)*(-v+d),E=(-(x*=F)+g)*(-(b*=F)+f)-(-x+p)*(-b+m),M=(T=-v+d-(-v+f))*(A=-x+p-(-x+g))-(S=-b+m-(-b+f))*(P=-y+p-(-y+u)),Math.abs(M)<.1?(M+=10.1,L.push(p-y,f-v,G,N,X,U),L.push(p+y,f+v,G,N,X,U)):((l=(P*E-A*C)/M)-p)*(l-p)+((c=(S*C-T*E)/M)-f)+(c-f)>19600?(_=y-x,w=v-b,_/=R=Math.sqrt(_*_+w*w),w/=R,_*=F,w*=F,L.push(p-_,f-w),L.push(G,N,X,U),L.push(p+_,f+w),L.push(G,N,X,U),L.push(p-_,f-w),L.push(G,N,X,U),O++):(L.push(l,c),L.push(G,N,X,U),L.push(p-(l-p),f-(c-f)),L.push(G,N,X,U));for(u=n[2*(I-2)],d=n[2*(I-2)+1],p=n[2*(I-1)],y=-(d-(f=n[2*(I-1)+1])),v=u-p,y/=R=Math.sqrt(y*y+v*v),v/=R,y*=F,v*=F,L.push(p-y,f-v),L.push(G,N,X,U),L.push(p+y,f+v),L.push(G,N,X,U),B.push(k),s=0;s<O;s++)B.push(k++);B.push(k-1)}},PIXI.WebGLGraphics.buildComplexPoly=function(t,i){var s=t.points.slice();if(!(s.length<6)){var n=i.indices;i.points=s,i.alpha=t.fillAlpha,i.color=e.Color.hexToRGBArray(t.fillColor);for(var r,o,a=1/0,h=-1/0,l=1/0,c=-1/0,u=0;u<s.length;u+=2)r=s[u],o=s[u+1],a=r<a?r:a,h=r>h?r:h,l=o<l?o:l,c=o>c?o:c;s.push(a,l,h,l,h,c,a,c);var d=s.length/2;for(u=0;u<d;u++)n.push(u)}},PIXI.WebGLGraphics.buildPoly=function(t,i){var s=t.points;if(!(s.length<6)){var n=i.points,r=i.indices,o=s.length/2,a=e.Color.hexToRGBArray(t.fillColor),h=t.fillAlpha,l=a[0]*h,c=a[1]*h,u=a[2]*h,d=e.EarCut.Triangulate(s,null,2);if(!d)return!1;var p=n.length/6,f=0;for(f=0;f<d.length;f+=3)r.push(d[f]+p),r.push(d[f]+p),r.push(d[f+1]+p),r.push(d[f+2]+p),r.push(d[f+2]+p);for(f=0;f<o;f++)n.push(s[2*f],s[2*f+1],l,c,u,h);return!0}},PIXI.WebGLGraphics.graphicsDataPool=[],PIXI.WebGLGraphicsData=function(t){this.gl=t,this.color=[0,0,0],this.points=[],this.indices=[],this.buffer=t.createBuffer(),this.indexBuffer=t.createBuffer(),this.mode=1,this.alpha=1,this.dirty=!0},PIXI.WebGLGraphicsData.prototype.reset=function(){this.points=[],this.indices=[]},PIXI.WebGLGraphicsData.prototype.upload=function(){var t=this.gl;this.glPoints=new Float32Array(this.points),t.bindBuffer(t.ARRAY_BUFFER,this.buffer),t.bufferData(t.ARRAY_BUFFER,this.glPoints,t.STATIC_DRAW),this.glIndicies=new Uint16Array(this.indices),t.bindBuffer(t.ELEMENT_ARRAY_BUFFER,this.indexBuffer),t.bufferData(t.ELEMENT_ARRAY_BUFFER,this.glIndicies,t.STATIC_DRAW),this.dirty=!1},PIXI.CanvasGraphics=function(){},PIXI.CanvasGraphics.renderGraphics=function(t,i){var s=t.worldAlpha;t.dirty&&(this.updateGraphicsTint(t),t.dirty=!1);for(var n=0;n<t.graphicsData.length;n++){var r=t.graphicsData[n],o=r.shape,a=r._fillTint,h=r._lineTint;if(i.lineWidth=r.lineWidth,r.type===e.POLYGON){i.beginPath();var l=o.points;i.moveTo(l[0],l[1]);for(var c=1;c<l.length/2;c++)i.lineTo(l[2*c],l[2*c+1]);o.closed&&i.lineTo(l[0],l[1]),l[0]===l[l.length-2]&&l[1]===l[l.length-1]&&i.closePath(),r.fill&&(i.globalAlpha=r.fillAlpha*s,i.fillStyle="#"+("00000"+(0|a).toString(16)).substr(-6),i.fill()),r.lineWidth&&(i.globalAlpha=r.lineAlpha*s,i.strokeStyle="#"+("00000"+(0|h).toString(16)).substr(-6),i.stroke())}else if(r.type===e.RECTANGLE)(r.fillColor||0===r.fillColor)&&(i.globalAlpha=r.fillAlpha*s,i.fillStyle="#"+("00000"+(0|a).toString(16)).substr(-6),i.fillRect(o.x,o.y,o.width,o.height)),r.lineWidth&&(i.globalAlpha=r.lineAlpha*s,i.strokeStyle="#"+("00000"+(0|h).toString(16)).substr(-6),i.strokeRect(o.x,o.y,o.width,o.height));else if(r.type===e.CIRCLE)i.beginPath(),i.arc(o.x,o.y,o.radius,0,2*Math.PI),i.closePath(),r.fill&&(i.globalAlpha=r.fillAlpha*s,i.fillStyle="#"+("00000"+(0|a).toString(16)).substr(-6),i.fill()),r.lineWidth&&(i.globalAlpha=r.lineAlpha*s,i.strokeStyle="#"+("00000"+(0|h).toString(16)).substr(-6),i.stroke());else if(r.type===e.ELLIPSE){var u=2*o.width,d=2*o.height,p=o.x-u/2,f=o.y-d/2;i.beginPath();var g=u/2*.5522848,m=d/2*.5522848,y=p+u,v=f+d,x=p+u/2,b=f+d/2;i.moveTo(p,b),i.bezierCurveTo(p,b-m,x-g,f,x,f),i.bezierCurveTo(x+g,f,y,b-m,y,b),i.bezierCurveTo(y,b+m,x+g,v,x,v),i.bezierCurveTo(x-g,v,p,b+m,p,b),i.closePath(),r.fill&&(i.globalAlpha=r.fillAlpha*s,i.fillStyle="#"+("00000"+(0|a).toString(16)).substr(-6),i.fill()),r.lineWidth&&(i.globalAlpha=r.lineAlpha*s,i.strokeStyle="#"+("00000"+(0|h).toString(16)).substr(-6),i.stroke())}else if(r.type===e.ROUNDEDRECTANGLE){var _=o.x,w=o.y,T=o.width,P=o.height,C=o.radius,S=Math.min(T,P)/2|0;C=C>S?S:C,i.beginPath(),i.moveTo(_,w+C),i.lineTo(_,w+P-C),i.quadraticCurveTo(_,w+P,_+C,w+P),i.lineTo(_+T-C,w+P),i.quadraticCurveTo(_+T,w+P,_+T,w+P-C),i.lineTo(_+T,w+C),i.quadraticCurveTo(_+T,w,_+T-C,w),i.lineTo(_+C,w),i.quadraticCurveTo(_,w,_,w+C),i.closePath(),(r.fillColor||0===r.fillColor)&&(i.globalAlpha=r.fillAlpha*s,i.fillStyle="#"+("00000"+(0|a).toString(16)).substr(-6),i.fill()),r.lineWidth&&(i.globalAlpha=r.lineAlpha*s,i.strokeStyle="#"+("00000"+(0|h).toString(16)).substr(-6),i.stroke())}}},PIXI.CanvasGraphics.renderGraphicsMask=function(t,i){var s=t.graphicsData.length;if(0!==s){i.beginPath();for(var n=0;n<s;n++){var r=t.graphicsData[n],o=r.shape;if(r.type===e.POLYGON){var a=o.points;i.moveTo(a[0],a[1]);for(var h=1;h<a.length/2;h++)i.lineTo(a[2*h],a[2*h+1]);a[0]===a[a.length-2]&&a[1]===a[a.length-1]&&i.closePath()}else if(r.type===e.RECTANGLE)i.rect(o.x,o.y,o.width,o.height),i.closePath();else if(r.type===e.CIRCLE)i.arc(o.x,o.y,o.radius,0,2*Math.PI),i.closePath();else if(r.type===e.ELLIPSE){var l=2*o.width,c=2*o.height,u=o.x-l/2,d=o.y-c/2,p=l/2*.5522848,f=c/2*.5522848,g=u+l,m=d+c,y=u+l/2,v=d+c/2;i.moveTo(u,v),i.bezierCurveTo(u,v-f,y-p,d,y,d),i.bezierCurveTo(y+p,d,g,v-f,g,v),i.bezierCurveTo(g,v+f,y+p,m,y,m),i.bezierCurveTo(y-p,m,u,v+f,u,v),i.closePath()}else if(r.type===e.ROUNDEDRECTANGLE){var x=o.x,b=o.y,_=o.width,w=o.height,T=o.radius,P=Math.min(_,w)/2|0;T=T>P?P:T,i.moveTo(x,b+T),i.lineTo(x,b+w-T),i.quadraticCurveTo(x,b+w,x+T,b+w),i.lineTo(x+_-T,b+w),i.quadraticCurveTo(x+_,b+w,x+_,b+w-T),i.lineTo(x+_,b+T),i.quadraticCurveTo(x+_,b,x+_-T,b),i.lineTo(x+T,b),i.quadraticCurveTo(x,b,x,b+T),i.closePath()}}}},PIXI.CanvasGraphics.updateGraphicsTint=function(t){if(16777215!==t.tint)for(var e=(t.tint>>16&255)/255,i=(t.tint>>8&255)/255,s=(255&t.tint)/255,n=0;n<t.graphicsData.length;n++){var r=t.graphicsData[n],o=0|r.fillColor,a=0|r.lineColor;r._fillTint=((o>>16&255)/255*e*255<<16)+((o>>8&255)/255*i*255<<8)+(255&o)/255*s*255,r._lineTint=((a>>16&255)/255*e*255<<16)+((a>>8&255)/255*i*255<<8)+(255&a)/255*s*255}},e.GraphicsData=function(t,e,i,s,n,r,o){this.lineWidth=t,this.lineColor=e,this.lineAlpha=i,this._lineTint=e,this.fillColor=s,this.fillAlpha=n,this._fillTint=s,this.fill=r,this.shape=o,this.type=o.type},e.GraphicsData.prototype.constructor=e.GraphicsData,e.GraphicsData.prototype.clone=function(){return new e.GraphicsData(this.lineWidth,this.lineColor,this.lineAlpha,this.fillColor,this.fillAlpha,this.fill,this.shape)},e.Graphics=function(t,i,s){void 0===i&&(i=0),void 0===s&&(s=0),this.type=e.GRAPHICS,this.physicsType=e.SPRITE,this.anchor=new e.Point,PIXI.DisplayObjectContainer.call(this),this.renderable=!0,this.fillAlpha=1,this.lineWidth=0,this.lineColor=0,this.graphicsData=[],this.tint=16777215,this.blendMode=PIXI.blendModes.NORMAL,this.currentPath=null,this._webGL=[],this.isMask=!1,this.boundsPadding=0,this._localBounds=new e.Rectangle(0,0,1,1),this.dirty=!0,this._boundsDirty=!1,this.webGLDirty=!1,this.cachedSpriteDirty=!1,e.Component.Core.init.call(this,t,i,s,"",null)},e.Graphics.prototype=Object.create(PIXI.DisplayObjectContainer.prototype),e.Graphics.prototype.constructor=e.Graphics,e.Component.Core.install.call(e.Graphics.prototype,["Angle","AutoCull","Bounds","Destroy","FixedToCamera","InputEnabled","InWorld","LifeSpan","PhysicsBody","Reset"]),e.Graphics.prototype.preUpdatePhysics=e.Component.PhysicsBody.preUpdate,e.Graphics.prototype.preUpdateLifeSpan=e.Component.LifeSpan.preUpdate,e.Graphics.prototype.preUpdateInWorld=e.Component.InWorld.preUpdate,e.Graphics.prototype.preUpdateCore=e.Component.Core.preUpdate,e.Graphics.prototype.preUpdate=function(){return!!(this.preUpdatePhysics()&&this.preUpdateLifeSpan()&&this.preUpdateInWorld())&&this.preUpdateCore()},e.Graphics.prototype.postUpdate=function(){e.Component.PhysicsBody.postUpdate.call(this),e.Component.FixedToCamera.postUpdate.call(this),this._boundsDirty&&(this.updateLocalBounds(),this._boundsDirty=!1);for(var t=0;t<this.children.length;t++)this.children[t].postUpdate()},e.Graphics.prototype.destroy=function(t){this.clear(),e.Component.Destroy.prototype.destroy.call(this,t)},e.Graphics.prototype.drawTriangle=function(t,i){void 0===i&&(i=!1);var s=new e.Polygon(t);if(i){var n=new e.Point(this.game.camera.x-t[0].x,this.game.camera.y-t[0].y),r=new e.Point(t[1].x-t[0].x,t[1].y-t[0].y),o=new e.Point(t[1].x-t[2].x,t[1].y-t[2].y).cross(r);n.dot(o)>0&&this.drawPolygon(s)}else this.drawPolygon(s)},e.Graphics.prototype.drawTriangles=function(t,i,s){void 0===s&&(s=!1);var n,r=new e.Point,o=new e.Point,a=new e.Point,h=[];if(i)if(t[0]instanceof e.Point)for(n=0;n<i.length/3;n++)h.push(t[i[3*n]]),h.push(t[i[3*n+1]]),h.push(t[i[3*n+2]]),3===h.length&&(this.drawTriangle(h,s),h=[]);else for(n=0;n<i.length;n++)r.x=t[2*i[n]],r.y=t[2*i[n]+1],h.push(r.copyTo({})),3===h.length&&(this.drawTriangle(h,s),h=[]);else if(t[0]instanceof e.Point)for(n=0;n<t.length/3;n++)this.drawTriangle([t[3*n],t[3*n+1],t[3*n+2]],s);else for(n=0;n<t.length/6;n++)r.x=t[6*n+0],r.y=t[6*n+1],o.x=t[6*n+2],o.y=t[6*n+3],a.x=t[6*n+4],a.y=t[6*n+5],this.drawTriangle([r,o,a],s)},e.Graphics.prototype.lineStyle=function(t,i,s){return this.lineWidth=t||0,this.lineColor=i||0,this.lineAlpha=void 0===s?1:s,this.currentPath&&(this.currentPath.shape.points.length?this.drawShape(new e.Polygon(this.currentPath.shape.points.slice(-2))):(this.currentPath.lineWidth=this.lineWidth,this.currentPath.lineColor=this.lineColor,this.currentPath.lineAlpha=this.lineAlpha)),this},e.Graphics.prototype.moveTo=function(t,i){return this.drawShape(new e.Polygon([t,i])),this},e.Graphics.prototype.lineTo=function(t,e){return this.currentPath||this.moveTo(0,0),this.currentPath.shape.points.push(t,e),this.dirty=!0,this._boundsDirty=!0,this},e.Graphics.prototype.quadraticCurveTo=function(t,e,i,s){this.currentPath?0===this.currentPath.shape.points.length&&(this.currentPath.shape.points=[0,0]):this.moveTo(0,0);var n,r,o=this.currentPath.shape.points;0===o.length&&this.moveTo(0,0);for(var a=o[o.length-2],h=o[o.length-1],l=0,c=1;c<=20;++c)n=a+(t-a)*(l=c/20),r=h+(e-h)*l,o.push(n+(t+(i-t)*l-n)*l,r+(e+(s-e)*l-r)*l);return this.dirty=!0,this._boundsDirty=!0,this},e.Graphics.prototype.bezierCurveTo=function(t,e,i,s,n,r){this.currentPath?0===this.currentPath.shape.points.length&&(this.currentPath.shape.points=[0,0]):this.moveTo(0,0);for(var o,a,h,l,c,u=this.currentPath.shape.points,d=u[u.length-2],p=u[u.length-1],f=0,g=1;g<=20;++g)h=(a=(o=1-(f=g/20))*o)*o,c=(l=f*f)*f,u.push(h*d+3*a*f*t+3*o*l*i+c*n,h*p+3*a*f*e+3*o*l*s+c*r);return this.dirty=!0,this._boundsDirty=!0,this},e.Graphics.prototype.arcTo=function(t,e,i,s,n){this.currentPath?0===this.currentPath.shape.points.length&&this.currentPath.shape.points.push(t,e):this.moveTo(t,e);var r=this.currentPath.shape.points,o=r[r.length-2],a=r[r.length-1]-e,h=o-t,l=s-e,c=i-t,u=Math.abs(a*c-h*l);if(u<1e-8||0===n)r[r.length-2]===t&&r[r.length-1]===e||r.push(t,e);else{var d=a*a+h*h,p=l*l+c*c,f=a*l+h*c,g=n*Math.sqrt(d)/u,m=n*Math.sqrt(p)/u,y=g*f/d,v=m*f/p,x=g*c+m*h,b=g*l+m*a,_=h*(m+y),w=a*(m+y),T=c*(g+v),P=l*(g+v),C=Math.atan2(w-b,_-x),S=Math.atan2(P-b,T-x);this.arc(x+t,b+e,n,C,S,h*l>c*a)}return this.dirty=!0,this._boundsDirty=!0,this},e.Graphics.prototype.arc=function(t,e,i,s,n,r,o){if(s===n)return this;void 0===r&&(r=!1),void 0===o&&(o=40),!r&&n<=s?n+=2*Math.PI:r&&s<=n&&(s+=2*Math.PI);var a=r?-1*(s-n):n-s,h=Math.ceil(Math.abs(a)/(2*Math.PI))*o;if(0===a)return this;var l=t+Math.cos(s)*i,c=e+Math.sin(s)*i;r&&this.filling?this.moveTo(t,e):this.moveTo(l,c);for(var u=this.currentPath.shape.points,d=a/(2*h),p=2*d,f=Math.cos(d),g=Math.sin(d),m=h-1,y=m%1/m,v=0;v<=m;v++){var x=d+s+p*(v+y*v),b=Math.cos(x),_=-Math.sin(x);u.push((f*b+g*_)*i+t,(f*-_+g*b)*i+e)}return this.dirty=!0,this._boundsDirty=!0,this},e.Graphics.prototype.beginFill=function(t,e){return this.filling=!0,this.fillColor=t||0,this.fillAlpha=void 0===e?1:e,this.currentPath&&this.currentPath.shape.points.length<=2&&(this.currentPath.fill=this.filling,this.currentPath.fillColor=this.fillColor,this.currentPath.fillAlpha=this.fillAlpha),this},e.Graphics.prototype.endFill=function(){return this.filling=!1,this.fillColor=null,this.fillAlpha=1,this},e.Graphics.prototype.drawRect=function(t,i,s,n){return this.drawShape(new e.Rectangle(t,i,s,n)),this},e.Graphics.prototype.drawRoundedRect=function(t,i,s,n,r){return this.drawShape(new e.RoundedRectangle(t,i,s,n,r)),this},e.Graphics.prototype.drawCircle=function(t,i,s){return this.drawShape(new e.Circle(t,i,s)),this},e.Graphics.prototype.drawEllipse=function(t,i,s,n){return this.drawShape({x:t,y:i,width:s,height:n,type:e.ELLIPSE}),this},e.Graphics.prototype.drawPolygon=function(t){t instanceof e.Polygon&&(t=t.points);var i=t;if(!Array.isArray(i)){i=new Array(arguments.length);for(var s=0;s<i.length;++s)i[s]=arguments[s]}return this.drawShape(new e.Polygon(i)),this},e.Graphics.prototype.clear=function(){return this.lineWidth=0,this.filling=!1,this.dirty=!0,this._boundsDirty=!0,this.clearDirty=!0,this.graphicsData=[],this.updateLocalBounds(),this},e.Graphics.prototype.generateTexture=function(t,e,i){void 0===t&&(t=1),void 0===e&&(e=PIXI.scaleModes.DEFAULT),void 0===i&&(i=0);var s=this.getBounds();s.width+=i,s.height+=i;var n=new PIXI.CanvasBuffer(s.width*t,s.height*t),r=PIXI.Texture.fromCanvas(n.canvas,e);return r.baseTexture.resolution=t,n.context.scale(t,t),n.context.translate(-s.x,-s.y),PIXI.CanvasGraphics.renderGraphics(this,n.context),r},e.Graphics.prototype._renderWebGL=function(t){if(!1!==this.visible&&0!==this.alpha&&!0!==this.isMask){if(this._cacheAsBitmap)return(this.dirty||this.cachedSpriteDirty)&&(this._generateCachedSprite(),this.updateCachedSpriteTexture(),this.cachedSpriteDirty=!1,this.dirty=!1),this._cachedSprite.worldAlpha=this.worldAlpha,void PIXI.Sprite.prototype._renderWebGL.call(this._cachedSprite,t);if(t.spriteBatch.stop(),t.blendModeManager.setBlendMode(this.blendMode),this._mask&&t.maskManager.pushMask(this._mask,t),this._filters&&t.filterManager.pushFilter(this._filterBlock),this.blendMode!==t.spriteBatch.currentBlendMode){t.spriteBatch.currentBlendMode=this.blendMode;var e=PIXI.blendModesWebGL[t.spriteBatch.currentBlendMode];t.spriteBatch.gl.blendFunc(e[0],e[1])}if(this.webGLDirty&&(this.dirty=!0,this.webGLDirty=!1),PIXI.WebGLGraphics.renderGraphics(this,t),this.children.length){t.spriteBatch.start();for(var i=0;i<this.children.length;i++)this.children[i]._renderWebGL(t);t.spriteBatch.stop()}this._filters&&t.filterManager.popFilter(),this._mask&&t.maskManager.popMask(this.mask,t),t.drawCount++,t.spriteBatch.start()}},e.Graphics.prototype._renderCanvas=function(t){if(!1!==this.visible&&0!==this.alpha&&!0!==this.isMask){if(this._prevTint!==this.tint&&(this.dirty=!0,this._prevTint=this.tint),this._cacheAsBitmap)return(this.dirty||this.cachedSpriteDirty)&&(this._generateCachedSprite(),this.updateCachedSpriteTexture(),this.cachedSpriteDirty=!1,this.dirty=!1),this._cachedSprite.alpha=this.alpha,void PIXI.Sprite.prototype._renderCanvas.call(this._cachedSprite,t);var e=t.context,i=this.worldTransform;this.blendMode!==t.currentBlendMode&&(t.currentBlendMode=this.blendMode,e.globalCompositeOperation=PIXI.blendModesCanvas[t.currentBlendMode]),this._mask&&t.maskManager.pushMask(this._mask,t);var s=t.resolution,n=i.tx*t.resolution+t.shakeX,r=i.ty*t.resolution+t.shakeY;e.setTransform(i.a*s,i.b*s,i.c*s,i.d*s,n,r),PIXI.CanvasGraphics.renderGraphics(this,e);for(var o=0;o<this.children.length;o++)this.children[o]._renderCanvas(t);this._mask&&t.maskManager.popMask(t)}},e.Graphics.prototype.getBounds=function(t){if(this._currentBounds)return this._currentBounds;if(this.isMask)return e.EmptyRectangle;this.dirty&&(this.updateLocalBounds(),this.webGLDirty=!0,this.cachedSpriteDirty=!0,this.dirty=!1);var i=this._localBounds,s=i.x,n=i.width+i.x,r=i.y,o=i.height+i.y,a=t||this.worldTransform,h=a.a,l=a.b,c=a.c,u=a.d,d=a.tx,p=a.ty,f=h*n+c*o+d,g=u*o+l*n+p,m=h*s+c*o+d,y=u*o+l*s+p,v=h*s+c*r+d,x=u*r+l*s+p,b=h*n+c*r+d,_=u*r+l*n+p,w=f,T=g,P=f,C=g;return P=m<P?m:P,P=v<P?v:P,P=b<P?b:P,C=y<C?y:C,C=x<C?x:C,C=_<C?_:C,w=m>w?m:w,w=v>w?v:w,w=b>w?b:w,T=y>T?y:T,T=x>T?x:T,T=_>T?_:T,this._bounds.x=P,this._bounds.width=w-P,this._bounds.y=C,this._bounds.height=T-C,this._currentBounds=this._bounds,this._currentBounds},e.Graphics.prototype.getLocalBounds=function(){var t=this.worldTransform;this.worldTransform=e.identityMatrix;for(var i=0;i<this.children.length;i++)this.children[i].updateTransform();var s=this.getBounds();for(this.worldTransform=t,i=0;i<this.children.length;i++)this.children[i].updateTransform();return s},e.Graphics.prototype.containsPoint=function(t,i){void 0===i&&(i=new e.Point),this.worldTransform.applyInverse(t,i);for(var s=this.graphicsData,n=0;n<s.length;n++){var r=s[n];if(r.fill&&(r.shape&&r.shape.contains(i.x,i.y)))return!0}return!1},e.Graphics.prototype.getVisualBounds=function(t){return this._boundsDirty&&(this.updateLocalBounds(),this._boundsDirty=!1),this._localBounds.clone(t)},e.Graphics.prototype.updateLocalBounds=function(){var t=1/0,i=-1/0,s=1/0,n=-1/0;if(this.graphicsData.length)for(var r,o,a,h,l,c,u=0;u<this.graphicsData.length;u++){var d=this.graphicsData[u],p=d.type,f=d.lineWidth;if(r=d.shape,p===e.RECTANGLE||p===e.ROUNDEDRECTANGLE)a=r.x-f/2,h=r.y-f/2,l=r.width+f,c=r.height+f,t=a<t?a:t,i=a+l>i?a+l:i,s=h<s?h:s,n=h+c>n?h+c:n;else if(p===e.CIRCLE)a=r.x,h=r.y,l=r.radius+f/2,c=r.radius+f/2,t=a-l<t?a-l:t,i=a+l>i?a+l:i,s=h-c<s?h-c:s,n=h+c>n?h+c:n;else if(p===e.ELLIPSE)a=r.x,h=r.y,l=r.width+f/2,c=r.height+f/2,t=a-l<t?a-l:t,i=a+l>i?a+l:i,s=h-c<s?h-c:s,n=h+c>n?h+c:n;else{o=r.points;for(var g=0;g<o.length;g++)o[g]instanceof e.Point?(a=o[g].x,h=o[g].y):(a=o[g],h=o[g+1],g<o.length-1&&g++),t=a-f<t?a-f:t,i=a+f>i?a+f:i,s=h-f<s?h-f:s,n=h+f>n?h+f:n}}else t=0,i=0,s=0,n=0;var m=this.boundsPadding;this._localBounds.x=t-m,this._localBounds.width=i-t+2*m,this._localBounds.y=s-m,this._localBounds.height=n-s+2*m},e.Graphics.prototype._generateCachedSprite=function(){var t=this.getLocalBounds();if(this._cachedSprite)this._cachedSprite.buffer.resize(t.width,t.height);else{var e=new PIXI.CanvasBuffer(t.width,t.height),i=PIXI.Texture.fromCanvas(e.canvas);this._cachedSprite=new PIXI.Sprite(i),this._cachedSprite.buffer=e,this._cachedSprite.worldTransform=this.worldTransform}this._cachedSprite.anchor.x=-t.x/t.width,this._cachedSprite.anchor.y=-t.y/t.height,this._cachedSprite.buffer.context.translate(-t.x,-t.y),this.worldAlpha=1,PIXI.CanvasGraphics.renderGraphics(this,this._cachedSprite.buffer.context),this._cachedSprite.alpha=this.alpha},e.Graphics.prototype.updateCachedSpriteTexture=function(){var t=this._cachedSprite,e=t.texture,i=t.buffer.canvas;e.baseTexture.width=i.width,e.baseTexture.height=i.height,e.crop.width=e.frame.width=i.width,e.crop.height=e.frame.height=i.height,t._width=i.width,t._height=i.height,e.baseTexture.dirty()},e.Graphics.prototype.destroyCachedSprite=function(){this._cachedSprite.texture.destroy(!0),this._cachedSprite=null},e.Graphics.prototype.drawShape=function(t){this.currentPath&&this.currentPath.shape.points.length<=2&&this.graphicsData.pop(),this.currentPath=null,t instanceof e.Polygon&&(t=t.clone()).flatten();var i=new e.GraphicsData(this.lineWidth,this.lineColor,this.lineAlpha,this.fillColor,this.fillAlpha,this.filling,t);return this.graphicsData.push(i),i.type===e.POLYGON&&(i.shape.closed=this.filling,this.currentPath=i),this.dirty=!0,this._boundsDirty=!0,i},Object.defineProperty(e.Graphics.prototype,"cacheAsBitmap",{get:function(){return this._cacheAsBitmap},set:function(t){this._cacheAsBitmap=t,this._cacheAsBitmap?this._generateCachedSprite():this.destroyCachedSprite(),this.dirty=!0,this.webGLDirty=!0}}),e.RenderTexture=function(t,i,s,n,r,o,a,h){if(void 0===i&&(i=100),void 0===s&&(s=100),void 0===n&&(n=""),void 0===r&&(r=e.scaleModes.DEFAULT),void 0===o&&(o=1),void 0===a&&(a=PIXI.defaultRenderer),void 0===h&&(h=0),this.game=t,this.key=n,this.type=e.RENDERTEXTURE,this._tempMatrix=new e.Matrix,this.width=i,this.height=s,this.resolution=o,this.frame=new e.Rectangle(0,0,this.width*this.resolution,this.height*this.resolution),this.crop=this.frame.clone(),this.baseTexture=new PIXI.BaseTexture,this.baseTexture.width=this.width*this.resolution,this.baseTexture.height=this.height*this.resolution,this.baseTexture._glTextures=[],this.baseTexture.resolution=this.resolution,this.baseTexture.scaleMode=r,this.baseTexture.hasLoaded=!0,PIXI.Texture.call(this,this.baseTexture,this.frame.clone()),this.renderer=a,this.renderer.type===e.WEBGL){var l=this.renderer.gl;this.baseTexture.textureIndex=h,this.baseTexture._dirty[l.id]=!1,this.textureBuffer=new PIXI.FilterTexture(l,this.width,this.height,this.baseTexture.scaleMode,h),this.baseTexture._glTextures[l.id]=this.textureBuffer.texture,this.projection=new e.Point(.5*this.width,.5*-this.height)}else this.textureBuffer=new PIXI.CanvasBuffer(this.width*this.resolution,this.height*this.resolution),this.baseTexture.source=this.textureBuffer.canvas;this.valid=!0,this.tempMatrix=new e.Matrix,this._updateUvs()},e.RenderTexture.prototype=Object.create(PIXI.Texture.prototype),e.RenderTexture.prototype.constructor=e.RenderTexture,e.RenderTexture.prototype.renderXY=function(t,i,s,n){t.updateTransform(),this._tempMatrix.copyFrom(t.worldTransform),this._tempMatrix.tx=i,this._tempMatrix.ty=s,this.renderer.type===e.WEBGL?this._renderWebGL(t,this._tempMatrix,n):this._renderCanvas(t,this._tempMatrix,n)},e.RenderTexture.prototype.renderRawXY=function(t,i,s,n){this._tempMatrix.identity().translate(i,s),this.renderer.type===e.WEBGL?this._renderWebGL(t,this._tempMatrix,n):this._renderCanvas(t,this._tempMatrix,n)},e.RenderTexture.prototype.render=function(t,i,s){void 0===i||null===i?this._tempMatrix.copyFrom(t.worldTransform):this._tempMatrix.copyFrom(i),this.renderer.type===e.WEBGL?this._renderWebGL(t,this._tempMatrix,s):this._renderCanvas(t,this._tempMatrix,s)},e.RenderTexture.prototype.resize=function(t,i,s){t===this.width&&i===this.height||(this.valid=t>0&&i>0,this.width=t,this.height=i,this.frame.width=this.crop.width=t*this.resolution,this.frame.height=this.crop.height=i*this.resolution,s&&(this.baseTexture.width=this.width*this.resolution,this.baseTexture.height=this.height*this.resolution),this.renderer.type===e.WEBGL&&(this.projection.x=this.width/2,this.projection.y=-this.height/2),this.valid&&this.textureBuffer.resize(this.width,this.height))},e.RenderTexture.prototype.clear=function(){this.valid&&(this.renderer.type===e.WEBGL&&this.renderer.gl.bindFramebuffer(this.renderer.gl.FRAMEBUFFER,this.textureBuffer.frameBuffer),this.textureBuffer.clear())},e.RenderTexture.prototype._renderWebGL=function(t,e,i){if(this.valid&&0!==t.alpha){var s=t.worldTransform;s.identity(),s.translate(0,2*this.projection.y),e&&s.append(e),s.scale(1,-1);for(var n=0;n<t.children.length;n++)t.children[n].updateTransform();var r=this.renderer.gl;r.viewport(0,0,this.width*this.resolution,this.height*this.resolution),r.bindFramebuffer(r.FRAMEBUFFER,this.textureBuffer.frameBuffer),i&&this.textureBuffer.clear(),this.renderer.spriteBatch.dirty=!0,this.renderer.renderDisplayObject(t,this.projection,this.textureBuffer.frameBuffer,e),this.renderer.spriteBatch.dirty=!0,r.bindFramebuffer(r.FRAMEBUFFER,null)}},e.RenderTexture.prototype._renderCanvas=function(t,e,i){if(this.valid&&0!==t.alpha){var s=t.worldTransform;s.identity(),e&&s.append(e);for(var n=0;n<t.children.length;n++)t.children[n].updateTransform();i&&this.textureBuffer.clear();var r=this.renderer.resolution;this.renderer.resolution=this.resolution,this.renderer.renderDisplayObject(t,this.textureBuffer.context,e),this.renderer.resolution=r}},e.RenderTexture.prototype.getImage=function(){var t=new Image;return t.src=this.getBase64(),t},e.RenderTexture.prototype.getBase64=function(){return this.getCanvas().toDataURL()},e.RenderTexture.prototype.getCanvas=function(){if(this.renderer.type===e.WEBGL){var t=this.renderer.gl,i=this.textureBuffer.width,s=this.textureBuffer.height,n=new Uint8Array(4*i*s);t.bindFramebuffer(t.FRAMEBUFFER,this.textureBuffer.frameBuffer),t.readPixels(0,0,i,s,t.RGBA,t.UNSIGNED_BYTE,n),t.bindFramebuffer(t.FRAMEBUFFER,null);var r=new PIXI.CanvasBuffer(i,s),o=r.context.getImageData(0,0,i,s);return o.data.set(n),r.context.putImageData(o,0,0),r.canvas}return this.textureBuffer.canvas},e.Text=function(t,i,s,n,r){i=i||0,s=s||0,n=void 0===n||null===n?"":n.toString(),this.canvas=e.CanvasPool.create(this),e.Sprite.call(this,t,i,s,PIXI.Texture.fromCanvas(this.canvas)),this.type=e.TEXT,this.physicsType=e.SPRITE,this.padding=new e.Point,this.textBounds=null,this.context=this.canvas.getContext("2d"),this.colors=[],this.strokeColors=[],this.fontStyles=[],this.fontWeights=[],this.autoRound=!1,this.useAdvancedWrap=!1,this.splitRegExp=/(?:\r\n|\r|\n)/,this.characterLimitSize=-1,this.characterLimitSuffix="",this._testString="|MÉq",this._res=t.renderer.resolution,this._text=n,this._fontComponents=null,this._lineSpacing=0,this._charCount=0,this._width=0,this._height=0,this.style={},this.setStyle(r||{}),""!==n&&this.updateText()},e.Text.prototype=Object.create(e.Sprite.prototype),e.Text.prototype.constructor=e.Text,e.Text.prototype.preUpdate=function(){return!!(this.preUpdatePhysics()&&this.preUpdateLifeSpan()&&this.preUpdateInWorld())&&this.preUpdateCore()},e.Text.prototype.update=function(){},e.Text.prototype.destroy=function(t){this.texture.destroy(!0),e.Component.Destroy.prototype.destroy.call(this,t)},e.Text.prototype.setShadow=function(t,e,i,s,n,r){return void 0===t&&(t=0),void 0===e&&(e=0),void 0===i&&(i="rgba(0, 0, 0, 1)"),void 0===s&&(s=0),void 0===n&&(n=!0),void 0===r&&(r=!0),this.style.shadowOffsetX=t,this.style.shadowOffsetY=e,this.style.shadowColor=i,this.style.shadowBlur=s,this.style.shadowStroke=n,this.style.shadowFill=r,this.dirty=!0,this},e.Text.prototype.setStyle=function(t,e){void 0===e&&(e=!1);var i=Object.assign({},t);i.font=t.font||"bold 20pt Arial",i.backgroundColor=t.backgroundColor||null,i.fill=t.fill||"black",i.align=(t.align||"left").toLowerCase(),i.boundsAlignH=(t.boundsAlignH||"left").toLowerCase(),i.boundsAlignV=(t.boundsAlignV||"top").toLowerCase(),i.stroke=t.stroke||"black",i.strokeThickness=Number(t.strokeThickness)||0,i.wordWrap=t.wordWrap||!1,i.wordWrapWidth=t.wordWrapWidth||100,i.maxLines=t.maxLines||0,i.shadowOffsetX=t.shadowOffsetX||0,i.shadowOffsetY=t.shadowOffsetY||0,i.shadowColor=t.shadowColor||"rgba(0,0,0,0)",i.shadowBlur=t.shadowBlur||0,i.tabs=t.tabs||0;var s=this.fontToComponents(i.font);return i.fontStyle&&(s.fontStyle=i.fontStyle),i.fontVariant&&(s.fontVariant=i.fontVariant),i.fontWeight&&(s.fontWeight=i.fontWeight),i.fontSize&&("number"==typeof i.fontSize&&(i.fontSize=i.fontSize+"px"),s.fontSize=i.fontSize),this._fontComponents=s,i.font=this.componentsToFont(this._fontComponents),this.style=i,this.dirty=!0,e&&this.updateText(),this},e.Text.prototype.updateText=function(){this.texture.baseTexture.resolution=this._res,this.context.font=this.style.font;var t=this.text;this.characterLimitSize>-1&&this.characterLimitSize<t.length&&(t=this.text.substring(0,this.characterLimitSize)+this.characterLimitSuffix),this.style.wordWrap&&(t=this.runWordWrap(this.text));var e=t.split(this.splitRegExp),i=this.style.tabs,s=[],n=0,r=this.determineFontProperties(this.style.font),o=e.length;this.style.maxLines>0&&this.style.maxLines<e.length&&(o=this.style.maxLines),this._charCount=0;for(var a=0;a<o;a++){if(0===i){l=this.style.strokeThickness+this.padding.x;this.colors.length>0||this.strokeColors.length>0||this.fontWeights.length>0||this.fontStyles.length>0?l+=this.measureLine(e[a]):l+=this.context.measureText(e[a]).width,this.style.wordWrap&&(l-=this.context.measureText(" ").width)}else{var h=e[a].split(/(?:\t)/),l=this.padding.x+this.style.strokeThickness;if(Array.isArray(i))for(var c=0,u=0;u<h.length;u++){var d=0;d=this.colors.length>0||this.strokeColors.length>0||this.fontWeights.length>0||this.fontStyles.length>0?this.measureLine(h[u]):Math.ceil(this.context.measureText(h[u]).width),u>0&&(c+=i[u-1]),l=c+d}else for(u=0;u<h.length;u++)this.colors.length>0||this.strokeColors.length>0||this.fontWeights.length>0||this.fontStyles.length>0?l+=this.measureLine(h[u]):l+=Math.ceil(this.context.measureText(h[u]).width),l+=this.game.math.snapToCeil(l,i)-l}s[a]=Math.ceil(l),n=Math.max(n,s[a])}this.canvas.width=n*this._res;var p=r.fontSize+this.style.strokeThickness+this.padding.y,f=p*o,g=this._lineSpacing;g<0&&Math.abs(g)>p&&(g=-p),0!==g&&(f+=g>0?g*e.length:g*(e.length-1)),this.canvas.height=f*this._res,this.context.scale(this._res,this._res),navigator.isCocoonJS&&this.context.clearRect(0,0,this.canvas.width,this.canvas.height),this.style.backgroundColor&&(this.context.fillStyle=this.style.backgroundColor,this.context.fillRect(0,0,this.canvas.width,this.canvas.height)),this.context.fillStyle=this.style.fill,this.context.font=this.style.font,this.context.strokeStyle=this.style.stroke,this.context.textBaseline="alphabetic",this.context.lineWidth=this.style.strokeThickness,this.context.lineCap="round",this.context.lineJoin="round";var m,y;for(this._charCount=0,a=0;a<o;a++)m=this.style.strokeThickness/2,y=this.style.strokeThickness/2+a*p+r.ascent,a>0&&(y+=g*a),"right"===this.style.align?m+=n-s[a]:"center"===this.style.align&&(m+=(n-s[a])/2),this.autoRound&&(m=Math.round(m),y=Math.round(y)),this.colors.length>0||this.strokeColors.length>0||this.fontWeights.length>0||this.fontStyles.length>0?this.updateLine(e[a],m,y):(this.style.stroke&&this.style.strokeThickness&&(this.updateShadow(this.style.shadowStroke),0===i?this.context.strokeText(e[a],m,y):this.renderTabLine(e[a],m,y,!1)),this.style.fill&&(this.updateShadow(this.style.shadowFill),0===i?this.context.fillText(e[a],m,y):this.renderTabLine(e[a],m,y,!0)));this.updateTexture(),this.dirty=!1},e.Text.prototype.renderTabLine=function(t,e,i,s){var n=t.split(/(?:\t)/),r=this.style.tabs,o=0;if(Array.isArray(r))for(var a=0,h=0;h<n.length;h++)h>0&&(a+=r[h-1]),o=e+a,s?this.context.fillText(n[h],o,i):this.context.strokeText(n[h],o,i);else for(h=0;h<n.length;h++){var l=Math.ceil(this.context.measureText(n[h]).width);o=this.game.math.snapToCeil(e,r),s?this.context.fillText(n[h],o,i):this.context.strokeText(n[h],o,i),e=o+l}},e.Text.prototype.updateShadow=function(t){t?(this.context.shadowOffsetX=this.style.shadowOffsetX,this.context.shadowOffsetY=this.style.shadowOffsetY,this.context.shadowColor=this.style.shadowColor,this.context.shadowBlur=this.style.shadowBlur):(this.context.shadowOffsetX=0,this.context.shadowOffsetY=0,this.context.shadowColor=0,this.context.shadowBlur=0)},e.Text.prototype.measureLine=function(t){for(var e=0,i=0;i<t.length;i++){var s=t[i];if(this.fontWeights.length>0||this.fontStyles.length>0){var n=this.fontToComponents(this.context.font);this.fontStyles[this._charCount]&&(n.fontStyle=this.fontStyles[this._charCount]),this.fontWeights[this._charCount]&&(n.fontWeight=this.fontWeights[this._charCount]),this.context.font=this.componentsToFont(n)}this.style.stroke&&this.style.strokeThickness&&(this.strokeColors[this._charCount]&&(this.context.strokeStyle=this.strokeColors[this._charCount]),this.updateShadow(this.style.shadowStroke)),this.style.fill&&(this.colors[this._charCount]&&(this.context.fillStyle=this.colors[this._charCount]),this.updateShadow(this.style.shadowFill)),e+=this.context.measureText(s).width,this._charCount++}return Math.ceil(e)},e.Text.prototype.updateLine=function(t,e,i){for(var s=0;s<t.length;s++){var n=t[s];if(this.fontWeights.length>0||this.fontStyles.length>0){var r=this.fontToComponents(this.context.font);this.fontStyles[this._charCount]&&(r.fontStyle=this.fontStyles[this._charCount]),this.fontWeights[this._charCount]&&(r.fontWeight=this.fontWeights[this._charCount]),this.context.font=this.componentsToFont(r)}this.style.stroke&&this.style.strokeThickness&&(this.strokeColors[this._charCount]&&(this.context.strokeStyle=this.strokeColors[this._charCount]),this.updateShadow(this.style.shadowStroke),this.context.strokeText(n,e,i)),this.style.fill&&(this.colors[this._charCount]&&(this.context.fillStyle=this.colors[this._charCount]),this.updateShadow(this.style.shadowFill),this.context.fillText(n,e,i)),e+=this.context.measureText(n).width,this._charCount++}},e.Text.prototype.clearColors=function(){return this.colors=[],this.strokeColors=[],this.dirty=!0,this},e.Text.prototype.clearFontValues=function(){return this.fontStyles=[],this.fontWeights=[],this.dirty=!0,this},e.Text.prototype.addColor=function(t,e){return this.colors[e]=t,this.dirty=!0,this},e.Text.prototype.addStrokeColor=function(t,e){return this.strokeColors[e]=t,this.dirty=!0,this},e.Text.prototype.addFontStyle=function(t,e){return this.fontStyles[e]=t,this.dirty=!0,this},e.Text.prototype.addFontWeight=function(t,e){return this.fontWeights[e]=t,this.dirty=!0,this},e.Text.prototype.precalculateWordWrap=function(t){return this.texture.baseTexture.resolution=this._res,this.context.font=this.style.font,this.runWordWrap(t).split(/(?:\r\n|\r|\n)/)},e.Text.prototype.runWordWrap=function(t){return this.useAdvancedWrap?this.advancedWordWrap(t):this.basicWordWrap(t)},e.Text.prototype.advancedWordWrap=function(t){for(var e=this.context,i=this.style.wordWrapWidth,s="",n=t.replace(/ +/gi," ").split(/\r?\n/gi),r=n.length,o=0;o<r;o++){var a=n[o],h="";if(a=a.replace(/^ *|\s*$/gi,""),e.measureText(a).width<i)s+=a+"\n";else{for(var l=i,c=a.split(" "),u=0;u<c.length;u++){var d=c[u],p=d+" ",f=e.measureText(p).width;if(f>l){if(0===u){for(var g=p;g.length&&(g=g.slice(0,-1),!((f=e.measureText(g).width)<=l)););if(!g.length)throw new Error("This text's wordWrapWidth setting is less than a single character!");var m=d.substr(g.length);c[u]=m,h+=g}var y=c[u].length?u:u+1,v=c.slice(y).join(" ").replace(/[ \n]*$/gi,"");n[o+1]=v+" "+(n[o+1]||""),r=n.length;break}h+=p,l-=f}s+=h.replace(/[ \n]*$/gi,"")+"\n"}}return s=s.replace(/[\s|\n]*$/gi,"")},e.Text.prototype.basicWordWrap=function(t){for(var e="",i=t.split("\n"),s=0;s<i.length;s++){for(var n=this.style.wordWrapWidth,r=i[s].split(" "),o=0;o<r.length;o++){var a=this.context.measureText(r[o]).width,h=a+this.context.measureText(" ").width;h>n?(o>0&&(e+="\n"),e+=r[o]+" ",n=this.style.wordWrapWidth-a):(n-=h,e+=r[o]+" ")}s<i.length-1&&(e+="\n")}return e},e.Text.prototype.updateFont=function(t){var e=this.componentsToFont(t);this.style.font!==e&&(this.style.font=e,this.dirty=!0,this.parent&&this.updateTransform())},e.Text.prototype.fontToComponents=function(t){var e=t.match(/^\s*(?:\b(normal|italic|oblique|inherit)?\b)\s*(?:\b(normal|small-caps|inherit)?\b)\s*(?:\b(normal|bold|bolder|lighter|100|200|300|400|500|600|700|800|900|inherit)?\b)\s*(?:\b(xx-small|x-small|small|medium|large|x-large|xx-large|larger|smaller|0|\d*(?:[.]\d*)?(?:%|[a-z]{2,5}))?\b)\s*(.*)\s*$/);if(e){var i=e[5].trim();return/^(?:inherit|serif|sans-serif|cursive|fantasy|monospace)$/.exec(i)||/['",]/.exec(i)||(i="'"+i+"'"),{font:t,fontStyle:e[1]||"normal",fontVariant:e[2]||"normal",fontWeight:e[3]||"normal",fontSize:e[4]||"medium",fontFamily:i}}return console.warn("Phaser.Text - unparsable CSS font: "+t),{font:t}},e.Text.prototype.componentsToFont=function(t){var e,i=[];return(e=t.fontStyle)&&"normal"!==e&&i.push(e),(e=t.fontVariant)&&"normal"!==e&&i.push(e),(e=t.fontWeight)&&"normal"!==e&&i.push(e),(e=t.fontSize)&&"medium"!==e&&i.push(e),(e=t.fontFamily)&&i.push(e),i.length||i.push(t.font),i.join(" ")},e.Text.prototype.setText=function(t,e){return void 0===e&&(e=!1),(t=t.toString()||"")===this._text?this:(this.text=t,e?this.updateText():this.dirty=!0,this)},e.Text.prototype.parseList=function(t){if(!Array.isArray(t))return this;for(var e="",i=0;i<t.length;i++)Array.isArray(t[i])?(e+=t[i].join("\t"),i<t.length-1&&(e+="\n")):(e+=t[i],i<t.length-1&&(e+="\t"));return this.text=e,this.dirty=!0,this},e.Text.prototype.setTextBounds=function(t,i,s,n){return void 0===t?this.textBounds=null:(this.textBounds?this.textBounds.setTo(t,i,s,n):this.textBounds=new e.Rectangle(t,i,s,n),this.style.wordWrapWidth>s&&(this.style.wordWrapWidth=s)),this.updateTexture(),this},e.Text.prototype.updateTexture=function(){var t=this.texture.baseTexture,e=this.texture.crop,i=this.texture.frame,s=this.canvas.width,n=this.canvas.height;if(t.width=s,t.height=n,e.width=s,e.height=n,i.width=s,i.height=n,this.texture.width=s,this.texture.height=n,this._width=s,this._height=n,this.textBounds){var r=this.textBounds.x,o=this.textBounds.y;"right"===this.style.boundsAlignH?r+=this.textBounds.width-this.canvas.width/this.resolution:"center"===this.style.boundsAlignH&&(r+=this.textBounds.halfWidth-this.canvas.width/this.resolution/2),"bottom"===this.style.boundsAlignV?o+=this.textBounds.height-this.canvas.height/this.resolution:"middle"===this.style.boundsAlignV&&(o+=this.textBounds.halfHeight-this.canvas.height/this.resolution/2),this.pivot.x=-r,this.pivot.y=-o}this.renderable=0!==s&&0!==n,this.texture.requiresReTint=!0,this.texture.baseTexture.dirty()},e.Text.prototype._renderWebGL=function(t){this.dirty&&(this.updateText(),this.dirty=!1),PIXI.Sprite.prototype._renderWebGL.call(this,t)},e.Text.prototype._renderCanvas=function(t){this.dirty&&(this.updateText(),this.dirty=!1),PIXI.Sprite.prototype._renderCanvas.call(this,t)},e.Text.prototype.determineFontProperties=function(t){var i=e.Text.fontPropertiesCache[t],s=this.testString||"|MÉq";if(!i){i={};var n=e.Text.fontPropertiesCanvas,r=e.Text.fontPropertiesContext;r.font=t;var o=Math.ceil(r.measureText(s).width),a=Math.ceil(r.measureText(s).width),h=2*a;if(a=1.4*a|0,n.width=o,n.height=h,r.fillStyle="#f00",r.fillRect(0,0,o,h),r.font=t,r.textBaseline="alphabetic",r.fillStyle="#000",r.fillText(s,0,a),!r.getImageData(0,0,o,h))return i.ascent=a,i.descent=a+6,i.fontSize=i.ascent+i.descent,e.Text.fontPropertiesCache[t]=i,i;var l,c,u=r.getImageData(0,0,o,h).data,d=u.length,p=4*o,f=0,g=!1;for(l=0;l<a;l++){for(c=0;c<p;c+=4)if(255!==u[f+c]){g=!0;break}if(g)break;f+=p}for(i.ascent=a-l,f=d-p,g=!1,l=h;l>a;l--){for(c=0;c<p;c+=4)if(255!==u[f+c]){g=!0;break}if(g)break;f-=p}i.descent=l-a,i.descent+=6,i.fontSize=i.ascent+i.descent,e.Text.fontPropertiesCache[t]=i}return i},e.Text.prototype.getBounds=function(t){return this.dirty&&(this.updateText(),this.dirty=!1),PIXI.Sprite.prototype.getBounds.call(this,t)},e.Text.prototype.setCharacterLimit=function(t,e){this.characterLimitSuffix=void 0===e?"":e,this.characterLimitSize=t,this.updateText()},Object.defineProperty(e.Text.prototype,"text",{get:function(){return this._text},set:function(t){t!==this._text&&(this._text=t.toString()||"",this.dirty=!0,this.parent&&this.updateTransform())}}),Object.defineProperty(e.Text.prototype,"cssFont",{get:function(){return this.componentsToFont(this._fontComponents)},set:function(t){t=t||"bold 20pt Arial",this._fontComponents=this.fontToComponents(t),this.updateFont(this._fontComponents)}}),Object.defineProperty(e.Text.prototype,"font",{get:function(){return this._fontComponents.fontFamily},set:function(t){t=(t=t||"Arial").trim(),/^(?:inherit|serif|sans-serif|cursive|fantasy|monospace)$/.exec(t)||/['",]/.exec(t)||(t="'"+t+"'"),this._fontComponents.fontFamily=t,this.updateFont(this._fontComponents)}}),Object.defineProperty(e.Text.prototype,"fontSize",{get:function(){var t=this._fontComponents.fontSize;return t&&/(?:^0$|px$)/.exec(t)?parseInt(t,10):t},set:function(t){"number"==typeof(t=t||"0")&&(t+="px"),this._fontComponents.fontSize=t,this.updateFont(this._fontComponents)}}),Object.defineProperty(e.Text.prototype,"fontWeight",{get:function(){return this._fontComponents.fontWeight||"normal"},set:function(t){t=t||"normal",this._fontComponents.fontWeight=t,this.updateFont(this._fontComponents)}}),Object.defineProperty(e.Text.prototype,"fontStyle",{get:function(){return this._fontComponents.fontStyle||"normal"},set:function(t){t=t||"normal",this._fontComponents.fontStyle=t,this.updateFont(this._fontComponents)}}),Object.defineProperty(e.Text.prototype,"fontVariant",{get:function(){return this._fontComponents.fontVariant||"normal"},set:function(t){t=t||"normal",this._fontComponents.fontVariant=t,this.updateFont(this._fontComponents)}}),Object.defineProperty(e.Text.prototype,"fill",{get:function(){return this.style.fill},set:function(t){t!==this.style.fill&&(this.style.fill=t,this.dirty=!0)}}),Object.defineProperty(e.Text.prototype,"align",{get:function(){return this.style.align},set:function(t){(t=t.toLowerCase())!==this.style.align&&(this.style.align=t,this.dirty=!0)}}),Object.defineProperty(e.Text.prototype,"resolution",{get:function(){return this._res},set:function(t){t!==this._res&&(this._res=t,this.dirty=!0)}}),Object.defineProperty(e.Text.prototype,"tabs",{get:function(){return this.style.tabs},set:function(t){t!==this.style.tabs&&(this.style.tabs=t,this.dirty=!0)}}),Object.defineProperty(e.Text.prototype,"boundsAlignH",{get:function(){return this.style.boundsAlignH},set:function(t){(t=t.toLowerCase())!==this.style.boundsAlignH&&(this.style.boundsAlignH=t,this.dirty=!0)}}),Object.defineProperty(e.Text.prototype,"boundsAlignV",{get:function(){return this.style.boundsAlignV},set:function(t){(t=t.toLowerCase())!==this.style.boundsAlignV&&(this.style.boundsAlignV=t,this.dirty=!0)}}),Object.defineProperty(e.Text.prototype,"stroke",{get:function(){return this.style.stroke},set:function(t){t!==this.style.stroke&&(this.style.stroke=t,this.dirty=!0)}}),Object.defineProperty(e.Text.prototype,"strokeThickness",{get:function(){return this.style.strokeThickness},set:function(t){t!==this.style.strokeThickness&&(this.style.strokeThickness=Number(t),this.dirty=!0)}}),Object.defineProperty(e.Text.prototype,"wordWrap",{get:function(){return this.style.wordWrap},set:function(t){t!==this.style.wordWrap&&(this.style.wordWrap=t,this.dirty=!0)}}),Object.defineProperty(e.Text.prototype,"wordWrapWidth",{get:function(){return this.style.wordWrapWidth},set:function(t){t!==this.style.wordWrapWidth&&(this.style.wordWrapWidth=t,this.dirty=!0)}}),Object.defineProperty(e.Text.prototype,"lineSpacing",{get:function(){return this._lineSpacing},set:function(t){t!==this._lineSpacing&&(this._lineSpacing=parseFloat(t),this.dirty=!0,this.parent&&this.updateTransform())}}),Object.defineProperty(e.Text.prototype,"shadowOffsetX",{get:function(){return this.style.shadowOffsetX},set:function(t){t!==this.style.shadowOffsetX&&(this.style.shadowOffsetX=t,this.dirty=!0)}}),Object.defineProperty(e.Text.prototype,"shadowOffsetY",{get:function(){return this.style.shadowOffsetY},set:function(t){t!==this.style.shadowOffsetY&&(this.style.shadowOffsetY=t,this.dirty=!0)}}),Object.defineProperty(e.Text.prototype,"shadowColor",{get:function(){return this.style.shadowColor},set:function(t){t!==this.style.shadowColor&&(this.style.shadowColor=t,this.dirty=!0)}}),Object.defineProperty(e.Text.prototype,"shadowBlur",{get:function(){return this.style.shadowBlur},set:function(t){t!==this.style.shadowBlur&&(this.style.shadowBlur=t,this.dirty=!0)}}),Object.defineProperty(e.Text.prototype,"shadowStroke",{get:function(){return this.style.shadowStroke},set:function(t){t!==this.style.shadowStroke&&(this.style.shadowStroke=t,this.dirty=!0)}}),Object.defineProperty(e.Text.prototype,"shadowFill",{get:function(){return this.style.shadowFill},set:function(t){t!==this.style.shadowFill&&(this.style.shadowFill=t,this.dirty=!0)}}),Object.defineProperty(e.Text.prototype,"width",{get:function(){return this.dirty&&(this.updateText(),this.dirty=!1),this.scale.x*(this.texture.frame.width/this.resolution)},set:function(t){this.scale.x=t/this.texture.frame.width,this._width=t}}),Object.defineProperty(e.Text.prototype,"height",{get:function(){return this.dirty&&(this.updateText(),this.dirty=!1),this.scale.y*(this.texture.frame.height/this.resolution)},set:function(t){this.scale.y=t/this.texture.frame.height,this._height=t}}),Object.defineProperty(e.Text.prototype,"testString",{get:function(){return this._testString},set:function(t){this._testString=t,this.updateText()}}),e.Text.fontPropertiesCache={},e.Text.fontPropertiesCanvas=document.createElement("canvas"),e.Text.fontPropertiesContext=e.Text.fontPropertiesCanvas.getContext("2d"),e.BitmapText=function(t,i,s,n,r,o,a){i=i||0,s=s||0,n=n||"",r=r||"",o=o||32,a=a||"left",PIXI.DisplayObjectContainer.call(this),this.type=e.BITMAPTEXT,this.physicsType=e.SPRITE,this.textWidth=0,this.textHeight=0,this.anchor=new e.Point,this._prevAnchor=new e.Point,this._glyphs=[],this._maxWidth=0,this._text=r.toString()||"",this._data=t.cache.getBitmapFont(n),this._font=n,this._fontSize=o,this._align=a,this._letterSpacing=0,this._tint=16777215,this.updateText(),this.dirty=!1,e.Component.Core.init.call(this,t,i,s,"",null)},e.BitmapText.prototype=Object.create(PIXI.DisplayObjectContainer.prototype),e.BitmapText.prototype.constructor=e.BitmapText,e.Component.Core.install.call(e.BitmapText.prototype,["Angle","AutoCull","Bounds","Destroy","FixedToCamera","InputEnabled","InWorld","LifeSpan","PhysicsBody","Reset"]),e.BitmapText.prototype.preUpdatePhysics=e.Component.PhysicsBody.preUpdate,e.BitmapText.prototype.preUpdateLifeSpan=e.Component.LifeSpan.preUpdate,e.BitmapText.prototype.preUpdateInWorld=e.Component.InWorld.preUpdate,e.BitmapText.prototype.preUpdateCore=e.Component.Core.preUpdate,e.BitmapText.prototype.preUpdate=function(){return!!(this.preUpdatePhysics()&&this.preUpdateLifeSpan()&&this.preUpdateInWorld())&&this.preUpdateCore()},e.BitmapText.prototype.postUpdate=function(){e.Component.PhysicsBody.postUpdate.call(this),e.Component.FixedToCamera.postUpdate.call(this),this.body&&this.body.type===e.Physics.ARCADE&&(this.textWidth===this.body.sourceWidth&&this.textHeight===this.body.sourceHeight||this.body.setSize(this.textWidth,this.textHeight))},e.BitmapText.prototype.setText=function(t){this.text=t},e.BitmapText.prototype.scanLine=function(t,e,i){for(var s=0,n=0,r=-1,o=0,a=null,h=this._maxWidth>0?this._maxWidth:null,l=[],c=0;c<i.length;c++){var u=c===i.length-1;if(/(?:\r\n|\r|\n)/.test(i.charAt(c)))return{width:n,text:i.substr(0,c),end:u,chars:l};var d=i.charCodeAt(c),p=t.chars[d],f=0;void 0===p&&(d=32,p=t.chars[d]);var g=a&&p.kerning[a]?p.kerning[a]:0;if(/(\s)/.test(i.charAt(c))&&(r=c,o=n),f=(g+p.texture.width+p.xOffset)*e,h&&n+f>=h&&r>-1)return{width:o||n,text:i.substr(0,c-(c-r)),end:!1,chars:l};n+=(p.xAdvance+g+this.letterSpacing)*e,l.push(s+(p.xOffset+g+this.letterSpacing)*e),s+=(p.xAdvance+g+this.letterSpacing)*e,a=d}return{width:n,text:i,end:u,chars:l}},e.BitmapText.prototype.cleanText=function(t,e){void 0===e&&(e="");var i=this._data.font;if(!i)return"";for(var s=/\r\n|\n\r|\n|\r/g,n=t.replace(s,"\n").split("\n"),r=0;r<n.length;r++){for(var o="",a=n[r],h=0;h<a.length;h++)o=i.chars[a.charCodeAt(h)]?o.concat(a[h]):o.concat(e);n[r]=o}return n.join("\n")},e.BitmapText.prototype.updateText=function(){var t=this._data.font;if(t){var e=this.text,i=this._fontSize/t.size,s=[],n=0;this.textWidth=0;do{(c=this.scanLine(t,i,e)).y=n,s.push(c),c.width>this.textWidth&&(this.textWidth=c.width),n+=t.lineHeight*i,e=e.substr(c.text.length+1)}while(!1===c.end);this.textHeight=n;for(var r=0,o=0,a=this.textWidth*this.anchor.x,h=this.textHeight*this.anchor.y,l=0;l<s.length;l++){var c=s[l];"right"===this._align?o=this.textWidth-c.width:"center"===this._align&&(o=(this.textWidth-c.width)/2);for(var u=0;u<c.text.length;u++){var d=c.text.charCodeAt(u),p=t.chars[d];void 0===p&&(d=32,p=t.chars[d]);var f=this._glyphs[r];f?f.texture=p.texture:((f=new PIXI.Sprite(p.texture)).name=c.text[u],this._glyphs.push(f)),f.position.x=c.chars[u]+o-a,f.position.y=c.y+p.yOffset*i-h,f.scale.set(i),f.tint=this.tint,f.texture.requiresReTint=!0,f.cachedTint=16777215,f.parent||this.addChild(f),r++}}for(l=r;l<this._glyphs.length;l++)this.removeChild(this._glyphs[l])}},e.BitmapText.prototype.purgeGlyphs=function(){for(var t=this._glyphs.length,e=[],i=0;i<this._glyphs.length;i++)this._glyphs[i].parent!==this?this._glyphs[i].destroy():e.push(this._glyphs[i]);return this._glyphs=[],this._glyphs=e,this.updateText(),t-e.length},e.BitmapText.prototype.updateTransform=function(){!this.dirty&&this.anchor.equals(this._prevAnchor)||(this.updateText(),this.dirty=!1,this._prevAnchor.copyFrom(this.anchor)),PIXI.DisplayObjectContainer.prototype.updateTransform.call(this)},Object.defineProperty(e.BitmapText.prototype,"letterSpacing",{get:function(){return this._letterSpacing},set:function(t){"number"==typeof t&&(this._letterSpacing=t,this.updateText())}}),Object.defineProperty(e.BitmapText.prototype,"align",{get:function(){return this._align},set:function(t){t===this._align||"left"!==t&&"center"!==t&&"right"!==t||(this._align=t,this.updateText())}}),Object.defineProperty(e.BitmapText.prototype,"tint",{get:function(){return this._tint},set:function(t){t!==this._tint&&(this._tint=t,this.updateText())}}),Object.defineProperty(e.BitmapText.prototype,"font",{get:function(){return this._font},set:function(t){t!==this._font&&(this._font=t.trim(),this._data=this.game.cache.getBitmapFont(this._font),this.updateText())}}),Object.defineProperty(e.BitmapText.prototype,"fontSize",{get:function(){return this._fontSize},set:function(t){(t=parseInt(t,10))!==this._fontSize&&t>0&&(this._fontSize=t,this.updateText())}}),Object.defineProperty(e.BitmapText.prototype,"text",{get:function(){return this._text},set:function(t){t!==this._text&&(this._text=t.toString()||"",this.updateText())}}),Object.defineProperty(e.BitmapText.prototype,"maxWidth",{get:function(){return this._maxWidth},set:function(t){t!==this._maxWidth&&(this._maxWidth=t,this.updateText())}}),Object.defineProperty(e.BitmapText.prototype,"smoothed",{get:function(){return!this._data.base.scaleMode},set:function(t){this._data.base.scaleMode=t?0:1,this._data.base.dirty()}}),e.RetroFont=function(t,i,s,n,r,o,a,h,l,c){if(!t.cache.checkImageKey(i))return!1;void 0!==o&&null!==o||(o=t.cache.getImage(i).width/s),this.characterWidth=s,this.characterHeight=n,this.characterSpacingX=a||0,this.characterSpacingY=h||0,this.characterPerRow=o,this.offsetX=l||0,this.offsetY=c||0,this.align="left",this.multiLine=!1,this.autoUpperCase=!0,this.customSpacingX=0,this.customSpacingY=0,this.fixedWidth=0,this.fontSet=t.cache.getImage(i),this._text="",this.grabData=[],this.frameData=new e.FrameData;for(var u=this.offsetX,d=this.offsetY,p=0,f=0;f<r.length;f++){var g=this.frameData.addFrame(new e.Frame(f,u,d,this.characterWidth,this.characterHeight));this.grabData[r.charCodeAt(f)]=g.index,++p===this.characterPerRow?(p=0,u=this.offsetX,d+=this.characterHeight+this.characterSpacingY):u+=this.characterWidth+this.characterSpacingX}t.cache.updateFrameData(i,this.frameData),this.stamp=new e.Image(t,0,0,i,0),e.RenderTexture.call(this,t,100,100,"",e.scaleModes.NEAREST),this.type=e.RETROFONT},e.RetroFont.prototype=Object.create(e.RenderTexture.prototype),e.RetroFont.prototype.constructor=e.RetroFont,e.RetroFont.ALIGN_LEFT="left",e.RetroFont.ALIGN_RIGHT="right",e.RetroFont.ALIGN_CENTER="center",e.RetroFont.TEXT_SET1=" !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~",e.RetroFont.TEXT_SET2=" !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ",e.RetroFont.TEXT_SET3="ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789 ",e.RetroFont.TEXT_SET4="ABCDEFGHIJKLMNOPQRSTUVWXYZ 0123456789",e.RetroFont.TEXT_SET5="ABCDEFGHIJKLMNOPQRSTUVWXYZ.,/() '!?-*:0123456789",e.RetroFont.TEXT_SET6="ABCDEFGHIJKLMNOPQRSTUVWXYZ!?:;0123456789\"(),-.' ",e.RetroFont.TEXT_SET7="AGMSY+:4BHNTZ!;5CIOU.?06DJPV,(17EKQW\")28FLRX-'39",e.RetroFont.TEXT_SET8="0123456789 .ABCDEFGHIJKLMNOPQRSTUVWXYZ",e.RetroFont.TEXT_SET9="ABCDEFGHIJKLMNOPQRSTUVWXYZ()-0123456789.:,'\"?!",e.RetroFont.TEXT_SET10="ABCDEFGHIJKLMNOPQRSTUVWXYZ",e.RetroFont.TEXT_SET11="ABCDEFGHIJKLMNOPQRSTUVWXYZ.,\"-+!?()':;0123456789",e.RetroFont.prototype.setFixedWidth=function(t,e){void 0===e&&(e="left"),this.fixedWidth=t,this.align=e},e.RetroFont.prototype.setText=function(t,e,i,s,n,r){this.multiLine=e||!1,this.customSpacingX=i||0,this.customSpacingY=s||0,this.align=n||"left",this.autoUpperCase=!r,t.length>0&&(this.text=t)},e.RetroFont.prototype.buildRetroFontText=function(){var t=0,i=0;if(this.clear(),this.multiLine){var s=this._text.split("\n");this.fixedWidth>0?this.resize(this.fixedWidth,s.length*(this.characterHeight+this.customSpacingY)-this.customSpacingY,!0):this.resize(this.getLongestLine()*(this.characterWidth+this.customSpacingX),s.length*(this.characterHeight+this.customSpacingY)-this.customSpacingY,!0);for(var n=0;n<s.length;n++)t=0,this.align===e.RetroFont.ALIGN_RIGHT?t=this.width-s[n].length*(this.characterWidth+this.customSpacingX):this.align===e.RetroFont.ALIGN_CENTER&&(t=this.width/2-s[n].length*(this.characterWidth+this.customSpacingX)/2,t+=this.customSpacingX/2),t<0&&(t=0),this.pasteLine(s[n],t,i,this.customSpacingX),i+=this.characterHeight+this.customSpacingY}else this.fixedWidth>0?this.resize(this.fixedWidth,this.characterHeight,!0):this.resize(this._text.length*(this.characterWidth+this.customSpacingX),this.characterHeight,!0),t=0,this.align===e.RetroFont.ALIGN_RIGHT?t=this.width-this._text.length*(this.characterWidth+this.customSpacingX):this.align===e.RetroFont.ALIGN_CENTER&&(t=this.width/2-this._text.length*(this.characterWidth+this.customSpacingX)/2,t+=this.customSpacingX/2),t<0&&(t=0),this.pasteLine(this._text,t,0,this.customSpacingX);this.requiresReTint=!0},e.RetroFont.prototype.pasteLine=function(t,e,i,s){for(var n=0;n<t.length;n++)if(" "===t.charAt(n))e+=this.characterWidth+s;else if(this.grabData[t.charCodeAt(n)]>=0&&(this.stamp.frame=this.grabData[t.charCodeAt(n)],this.renderXY(this.stamp,e,i,!1),(e+=this.characterWidth+s)>this.width))break},e.RetroFont.prototype.getLongestLine=function(){var t=0;if(this._text.length>0)for(var e=this._text.split("\n"),i=0;i<e.length;i++)e[i].length>t&&(t=e[i].length);return t},e.RetroFont.prototype.removeUnsupportedCharacters=function(t){for(var e="",i=0;i<this._text.length;i++){var s=this._text[i],n=s.charCodeAt(0);(this.grabData[n]>=0||!t&&"\n"===s)&&(e=e.concat(s))}return e},e.RetroFont.prototype.updateOffset=function(t,e){if(this.offsetX!==t||this.offsetY!==e){for(var i=t-this.offsetX,s=e-this.offsetY,n=this.game.cache.getFrameData(this.stamp.key).getFrames(),r=n.length;r--;)n[r].x+=i,n[r].y+=s;this.buildRetroFontText()}},Object.defineProperty(e.RetroFont.prototype,"text",{get:function(){return this._text},set:function(t){var e;(e=this.autoUpperCase?t.toUpperCase():t)!==this._text&&(this._text=e,this.removeUnsupportedCharacters(this.multiLine),this.buildRetroFontText())}}),Object.defineProperty(e.RetroFont.prototype,"smoothed",{get:function(){return this.stamp.smoothed},set:function(t){this.stamp.smoothed=t,this.buildRetroFontText()}}),e.Rope=function(t,i,s,n,r,o){this.points=o||[],this._hasUpdateAnimation=!1,this._updateAnimationCallback=null,i=i||0,s=s||0,n=n||null,r=r||null,this.type=e.ROPE,PIXI.DisplayObjectContainer.call(this),this.texture=e.Cache.DEFAULT,this.uvs=new Float32Array([0,1,1,1,1,0,0,1]),this.vertices=new Float32Array([0,0,100,0,100,100,0,100]),this.colors=new Float32Array([1,1,1,1]),this.indices=new Uint16Array([0,1,2,3]),o&&(this.vertices=new Float32Array(4*o.length),this.uvs=new Float32Array(4*o.length),this.colors=new Float32Array(2*o.length),this.indices=new Uint16Array(2*o.length)),this.dirty=!0,this.canvasPadding=0,this.drawMode=e.Rope.TRIANGLE_STRIP,e.Component.Core.init.call(this,t,i,s,n,r),this.refresh()},e.Rope.prototype=Object.create(PIXI.DisplayObjectContainer.prototype),e.Rope.prototype.constructor=e.Rope,e.Component.Core.install.call(e.Rope.prototype,["Angle","Animation","AutoCull","Bounds","BringToTop","Crop","Delta","Destroy","FixedToCamera","InWorld","LifeSpan","LoadTexture","Overlap","PhysicsBody","Reset","ScaleMinMax","Smoothed"]),e.Rope.prototype.preUpdatePhysics=e.Component.PhysicsBody.preUpdate,e.Rope.prototype.preUpdateLifeSpan=e.Component.LifeSpan.preUpdate,e.Rope.prototype.preUpdateInWorld=e.Component.InWorld.preUpdate,e.Rope.prototype.preUpdateCore=e.Component.Core.preUpdate,e.Rope.TRIANGLE_STRIP=0,e.Rope.TRIANGLES=1,e.Rope.prototype.preUpdate=function(){return!!(this.preUpdatePhysics()&&this.preUpdateLifeSpan()&&this.preUpdateInWorld())&&this.preUpdateCore()},e.Rope.prototype.update=function(){this._hasUpdateAnimation&&this.updateAnimation.call(this)},e.Rope.prototype.reset=function(t,i){return e.Component.Reset.prototype.reset.call(this,t,i),this},e.Rope.prototype.refresh=function(){var t=this.points;if(!(t.length<1)){var e=this.uvs,i=this.indices,s=this.colors;this.count-=.2,e[0]=0,e[1]=0,e[2]=0,e[3]=1,s[0]=1,s[1]=1,i[0]=0,i[1]=1;for(var n,r,o=t.length,a=1;a<o;a++)r=a/(o-1),e[n=4*a]=r,e[n+1]=0,e[n+2]=r,e[n+3]=1,s[n=2*a]=1,s[n+1]=1,i[n=2*a]=n,i[n+1]=n+1}},e.Rope.prototype.updateTransform=function(){var t=this.points;if(!(t.length<1)){var e,i=t[0],s={x:0,y:0};this.count-=.2;for(var n,r,o,a,h=this.vertices,l=t.length,c=0;c<l;c++)n=t[c],r=4*c,e=c<t.length-1?t[c+1]:n,s.y=-(e.x-i.x),s.x=e.y-i.y,10*(1-c/(l-1))>1&&1,o=Math.sqrt(s.x*s.x+s.y*s.y),a=this.texture.height/2,s.x/=o,s.y/=o,s.x*=a,s.y*=a,h[r]=n.x+s.x,h[r+1]=n.y+s.y,h[r+2]=n.x-s.x,h[r+3]=n.y-s.y,i=n;PIXI.DisplayObjectContainer.prototype.updateTransform.call(this)}},e.Rope.prototype.setTexture=function(t){this.texture=t},e.Rope.prototype._renderWebGL=function(t){!this.visible||this.alpha<=0||(t.spriteBatch.stop(),this._vertexBuffer||this._initWebGL(t),t.shaderManager.setShader(t.shaderManager.stripShader),this._renderStrip(t),t.spriteBatch.start())},e.Rope.prototype._initWebGL=function(t){var e=t.gl;this._vertexBuffer=e.createBuffer(),this._indexBuffer=e.createBuffer(),this._uvBuffer=e.createBuffer(),this._colorBuffer=e.createBuffer(),e.bindBuffer(e.ARRAY_BUFFER,this._vertexBuffer),e.bufferData(e.ARRAY_BUFFER,this.vertices,e.DYNAMIC_DRAW),e.bindBuffer(e.ARRAY_BUFFER,this._uvBuffer),e.bufferData(e.ARRAY_BUFFER,this.uvs,e.STATIC_DRAW),e.bindBuffer(e.ARRAY_BUFFER,this._colorBuffer),e.bufferData(e.ARRAY_BUFFER,this.colors,e.STATIC_DRAW),e.bindBuffer(e.ELEMENT_ARRAY_BUFFER,this._indexBuffer),e.bufferData(e.ELEMENT_ARRAY_BUFFER,this.indices,e.STATIC_DRAW)},e.Rope.prototype._renderStrip=function(t){var i=t.gl,s=t.projection,n=t.offset,r=t.shaderManager.stripShader,o=this.drawMode===e.Rope.TRIANGLE_STRIP?i.TRIANGLE_STRIP:i.TRIANGLES;t.blendModeManager.setBlendMode(this.blendMode),i.uniformMatrix3fv(r.translationMatrix,!1,this.worldTransform.toArray(!0)),i.uniform2f(r.projectionVector,s.x,-s.y),i.uniform2f(r.offsetVector,-n.x,-n.y),i.uniform1f(r.alpha,this.worldAlpha),this.dirty?(this.dirty=!1,i.bindBuffer(i.ARRAY_BUFFER,this._vertexBuffer),i.bufferData(i.ARRAY_BUFFER,this.vertices,i.STATIC_DRAW),i.vertexAttribPointer(r.aVertexPosition,2,i.FLOAT,!1,0,0),i.bindBuffer(i.ARRAY_BUFFER,this._uvBuffer),i.bufferData(i.ARRAY_BUFFER,this.uvs,i.STATIC_DRAW),i.vertexAttribPointer(r.aTextureCoord,2,i.FLOAT,!1,0,0),i.activeTexture(i.TEXTURE0),this.texture.baseTexture._dirty[i.id]?t.renderer.updateTexture(this.texture.baseTexture):i.bindTexture(i.TEXTURE_2D,this.texture.baseTexture._glTextures[i.id]),i.bindBuffer(i.ELEMENT_ARRAY_BUFFER,this._indexBuffer),i.bufferData(i.ELEMENT_ARRAY_BUFFER,this.indices,i.STATIC_DRAW)):(i.bindBuffer(i.ARRAY_BUFFER,this._vertexBuffer),i.bufferSubData(i.ARRAY_BUFFER,0,this.vertices),i.vertexAttribPointer(r.aVertexPosition,2,i.FLOAT,!1,0,0),i.bindBuffer(i.ARRAY_BUFFER,this._uvBuffer),i.vertexAttribPointer(r.aTextureCoord,2,i.FLOAT,!1,0,0),i.activeTexture(i.TEXTURE0),this.texture.baseTexture._dirty[i.id]?t.renderer.updateTexture(this.texture.baseTexture):i.bindTexture(i.TEXTURE_2D,this.texture.baseTexture._glTextures[i.id]),i.bindBuffer(i.ELEMENT_ARRAY_BUFFER,this._indexBuffer)),i.drawElements(o,this.indices.length,i.UNSIGNED_SHORT,0)},e.Rope.prototype._renderCanvas=function(t){var i=t.context,s=this.worldTransform,n=s.tx*t.resolution+t.shakeX,r=s.ty*t.resolution+t.shakeY;t.roundPixels?i.setTransform(s.a,s.b,s.c,s.d,0|n,0|r):i.setTransform(s.a,s.b,s.c,s.d,n,r),this.drawMode===e.Rope.TRIANGLE_STRIP?this._renderCanvasTriangleStrip(i):this._renderCanvasTriangles(i)},e.Rope.prototype._renderCanvasTriangleStrip=function(t){var e=this.vertices,i=this.uvs,s=e.length/2;this.count++;for(var n=0;n<s-2;n++){var r=2*n;this._renderCanvasDrawTriangle(t,e,i,r,r+2,r+4)}},e.Rope.prototype._renderCanvasTriangles=function(t){var e=this.vertices,i=this.uvs,s=this.indices,n=s.length;this.count++;for(var r=0;r<n;r+=3){var o=2*s[r],a=2*s[r+1],h=2*s[r+2];this._renderCanvasDrawTriangle(t,e,i,o,a,h)}},e.Rope.prototype._renderCanvasDrawTriangle=function(t,e,i,s,n,r){var o=this.texture.baseTexture.source,a=this.texture.width,h=this.texture.height,l=e[s],c=e[n],u=e[r],d=e[s+1],p=e[n+1],f=e[r+1],g=i[s]*a,m=i[n]*a,y=i[r]*a,v=i[s+1]*h,x=i[n+1]*h,b=i[r+1]*h;if(this.canvasPadding>0){var _=this.canvasPadding/this.worldTransform.a,w=this.canvasPadding/this.worldTransform.d,T=(l+c+u)/3,P=(d+p+f)/3,C=l-T,S=d-P,A=Math.sqrt(C*C+S*S);l=T+C/A*(A+_),d=P+S/A*(A+w),S=p-P,c=T+(C=c-T)/(A=Math.sqrt(C*C+S*S))*(A+_),p=P+S/A*(A+w),S=f-P,u=T+(C=u-T)/(A=Math.sqrt(C*C+S*S))*(A+_),f=P+S/A*(A+w)}t.save(),t.beginPath(),t.moveTo(l,d),t.lineTo(c,p),t.lineTo(u,f),t.closePath(),t.clip();var E=g*x+v*y+m*b-x*y-v*m-g*b,M=l*x+v*u+c*b-x*u-v*c-l*b,R=g*c+l*y+m*u-c*y-l*m-g*u,L=g*x*u+v*c*y+l*m*b-l*x*y-v*m*u-g*c*b,B=d*x+v*f+p*b-x*f-v*p-d*b,I=g*p+d*y+m*f-p*y-d*m-g*f,O=g*x*f+v*p*y+d*m*b-d*x*y-v*m*f-g*p*b;t.transform(M/E,B/E,R/E,I/E,L/E,O/E),t.drawImage(o,0,0),t.restore()},e.Rope.prototype.renderStripFlat=function(t){var e=this.context,i=t.vertices,s=i.length/2;this.count++,e.beginPath();for(var n=1;n<s-2;n++){var r=2*n,o=i[r],a=i[r+2],h=i[r+4],l=i[r+1],c=i[r+3],u=i[r+5];e.moveTo(o,l),e.lineTo(a,c),e.lineTo(h,u)}e.fillStyle="#FF0000",e.fill(),e.closePath()},e.Rope.prototype.getBounds=function(t){for(var i=t||this.worldTransform,s=i.a,n=i.b,r=i.c,o=i.d,a=i.tx,h=i.ty,l=-1/0,c=-1/0,u=1/0,d=1/0,p=this.vertices,f=0;f<p.length;f+=2){var g=p[f],m=p[f+1],y=s*g+r*m+a,v=o*m+n*g+h;u=y<u?y:u,d=v<d?v:d,l=y>l?y:l,c=v>c?v:c}if(u===-1/0||c===1/0)return e.EmptyRectangle;var x=this._bounds;return x.x=u,x.width=l-u,x.y=d,x.height=c-d,this._currentBounds=x,x},Object.defineProperty(e.Rope.prototype,"updateAnimation",{get:function(){return this._updateAnimation},set:function(t){t&&"function"==typeof t?(this._hasUpdateAnimation=!0,this._updateAnimation=t):(this._hasUpdateAnimation=!1,this._updateAnimation=null)}}),Object.defineProperty(e.Rope.prototype,"segments",{get:function(){for(var t,i,s,n,r,o,a,h,l=[],c=0;c<this.points.length;c++)t=4*c,i=this.vertices[t]*this.scale.x,s=this.vertices[t+1]*this.scale.y,n=this.vertices[t+4]*this.scale.x,r=this.vertices[t+3]*this.scale.y,o=e.Math.difference(i,n),a=e.Math.difference(s,r),i+=this.world.x,s+=this.world.y,h=new e.Rectangle(i,s,o,a),l.push(h);return l}}),e.TileSprite=function(t,i,s,n,r,o,a){i=i||0,s=s||0,n=n||256,r=r||256,o=o||null,a=a||null,PIXI.Sprite.call(this,new PIXI.Texture(e.Cache.DEFAULT.baseTexture),n,r),this.type=e.TILESPRITE,this.physicsType=e.SPRITE,this._scroll=new e.Point,this.tileScale=new e.Point(1,1),this.tileScaleOffset=new e.Point(1,1),this.tilePosition=new e.Point,this.textureDebug=!1,this.canvasBuffer=null,this.tilingTexture=null,this.tilePattern=null,this.refreshTexture=!0,this.frameWidth=0,this.frameHeight=0,this._width=n,this._height=r,e.Component.Core.init.call(this,t,i,s,o,a)},e.TileSprite.prototype=Object.create(PIXI.Sprite.prototype),e.TileSprite.prototype.constructor=e.TileSprite,e.Component.Core.install.call(e.TileSprite.prototype,["Angle","Animation","AutoCull","Bounds","BringToTop","Destroy","FixedToCamera","Health","InCamera","InputEnabled","InWorld","LifeSpan","LoadTexture","Overlap","PhysicsBody","Reset","Smoothed"]),e.TileSprite.prototype.preUpdatePhysics=e.Component.PhysicsBody.preUpdate,e.TileSprite.prototype.preUpdateLifeSpan=e.Component.LifeSpan.preUpdate,e.TileSprite.prototype.preUpdateInWorld=e.Component.InWorld.preUpdate,e.TileSprite.prototype.preUpdateCore=e.Component.Core.preUpdate,e.TileSprite.prototype.preUpdate=function(){return 0!==this._scroll.x&&(this.tilePosition.x+=this._scroll.x*this.game.time.physicsElapsed),0!==this._scroll.y&&(this.tilePosition.y+=this._scroll.y*this.game.time.physicsElapsed),!!(this.preUpdatePhysics()&&this.preUpdateLifeSpan()&&this.preUpdateInWorld())&&this.preUpdateCore()},e.TileSprite.prototype.autoScroll=function(t,e){return this._scroll.set(t,e),this},e.TileSprite.prototype.stopScroll=function(){return this._scroll.set(0,0),this},e.TileSprite.prototype.destroy=function(t){e.Component.Destroy.prototype.destroy.call(this,t),PIXI.Sprite.prototype.destroy.call(this),this.canvasBuffer&&(this.canvasBuffer.destroy(),this.canvasBuffer=null),this.tileScale=null,this.tileScaleOffset=null,this.tilePosition=null,this.tilingTexture&&(this.tilingTexture.destroy(!0),this.tilingTexture=null)},e.TileSprite.prototype.reset=function(t,i){return e.Component.Reset.prototype.reset.call(this,t,i),this.tilePosition.x=0,this.tilePosition.y=0,this},e.TileSprite.prototype.setTexture=function(t){return this.texture!==t&&(this.texture=t,this.refreshTexture=!0,this.cachedTint=16777215),this},e.TileSprite.prototype._renderWebGL=function(t){if(this.visible&&this.renderable&&0!==this.alpha){if(this._mask&&(t.spriteBatch.stop(),t.maskManager.pushMask(this.mask,t),t.spriteBatch.start()),this._filters&&(t.spriteBatch.flush(),t.filterManager.pushFilter(this._filterBlock)),this.refreshTexture){if(this.generateTilingTexture(!0,t),!this.tilingTexture)return;this.tilingTexture.needsUpdate&&(this.tilingTexture.baseTexture.textureIndex=this.texture.baseTexture.textureIndex,t.renderer.updateTexture(this.tilingTexture.baseTexture),this.tilingTexture.needsUpdate=!1)}t.spriteBatch.renderTilingSprite(this);for(var e=0;e<this.children.length;e++)this.children[e]._renderWebGL(t);var i=!1;this._filters&&(i=!0,t.spriteBatch.stop(),t.filterManager.popFilter()),this._mask&&(i||t.spriteBatch.stop(),t.maskManager.popMask(this._mask,t)),i&&t.spriteBatch.start()}},e.TileSprite.prototype._renderCanvas=function(t){if(this.visible&&this.renderable&&0!==this.alpha){var e=t.context;this._mask&&t.maskManager.pushMask(this._mask,t),e.globalAlpha=this.worldAlpha;var i=this.worldTransform,s=t.resolution,n=i.tx*s+t.shakeX,r=i.ty*s+t.shakeY;if(e.setTransform(i.a*s,i.b*s,i.c*s,i.d*s,n,r),16777215===this.tint||!this.texture.requiresReTint&&this.cachedTint===this.tint||(this.tintedTexture=PIXI.CanvasTinter.getTintedTexture(this,this.tint),this.cachedTint=this.tint,this.texture.requiresReTint=!1,this.refreshTexture=!0),this.refreshTexture){if(this.generateTilingTexture(!1,t),!this.tilingTexture)return;this.tilePattern=e.createPattern(this.tilingTexture.baseTexture.source,"repeat")}var o=t.currentBlendMode;this.blendMode!==t.currentBlendMode&&(t.currentBlendMode=this.blendMode,e.globalCompositeOperation=PIXI.blendModesCanvas[t.currentBlendMode]);var a=this.tilePosition,h=this.tileScale;a.x%=this.tilingTexture.baseTexture.width,a.y%=this.tilingTexture.baseTexture.height,e.scale(h.x,h.y),e.translate(a.x+this.anchor.x*-this._width,a.y+this.anchor.y*-this._height),e.fillStyle=this.tilePattern,n=-a.x,r=-a.y;var l=this._width/h.x,c=this._height/h.y;t.roundPixels&&(n|=0,r|=0,l|=0,c|=0),e.fillRect(n,r,l,c),e.scale(1/h.x,1/h.y),e.translate(-a.x+this.anchor.x*this._width,-a.y+this.anchor.y*this._height),this._mask&&t.maskManager.popMask(t);for(var u=0;u<this.children.length;u++)this.children[u]._renderCanvas(t);o!==this.blendMode&&(t.currentBlendMode=o,e.globalCompositeOperation=PIXI.blendModesCanvas[o])}},e.TileSprite.prototype.onTextureUpdate=function(){},e.TileSprite.prototype.generateTilingTexture=function(t){if(this.texture.baseTexture.hasLoaded){var i=this.texture,s=i.frame,n=this._frame.sourceSizeW||this._frame.width,r=this._frame.sourceSizeH||this._frame.height,o=0,a=0;this._frame.trimmed&&(o=this._frame.spriteSourceSizeX,a=this._frame.spriteSourceSizeY),t&&(n=e.Math.getNextPowerOfTwo(n),r=e.Math.getNextPowerOfTwo(r)),this.canvasBuffer?(this.canvasBuffer.resize(n,r),this.tilingTexture.baseTexture.width=n,this.tilingTexture.baseTexture.height=r,this.tilingTexture.needsUpdate=!0):(this.canvasBuffer=new PIXI.CanvasBuffer(n,r),this.tilingTexture=PIXI.Texture.fromCanvas(this.canvasBuffer.canvas),this.tilingTexture.isTiling=!0,this.tilingTexture.needsUpdate=!0),this.textureDebug&&(this.canvasBuffer.context.strokeStyle="#00ff00",this.canvasBuffer.context.strokeRect(0,0,n,r));var h=i.crop.width,l=i.crop.height;h===n&&l===r||(h=n,l=r);var c=this.tintedTexture?this.tintedTexture:i.baseTexture.source;this.canvasBuffer.context.drawImage(c,i.crop.x,i.crop.y,i.crop.width,i.crop.height,o,a,h,l),this.tileScaleOffset.x=s.width/n,this.tileScaleOffset.y=s.height/r,this.refreshTexture=!1,this.tilingTexture.baseTexture._powerOf2=!0}},e.TileSprite.prototype.getBounds=function(){var t=this._width,e=this._height,i=t*(1-this.anchor.x),s=t*-this.anchor.x,n=e*(1-this.anchor.y),r=e*-this.anchor.y,o=this.worldTransform,a=o.a,h=o.b,l=o.c,c=o.d,u=o.tx,d=o.ty,p=a*s+l*r+u,f=c*r+h*s+d,g=a*i+l*r+u,m=c*r+h*i+d,y=a*i+l*n+u,v=c*n+h*i+d,x=a*s+l*n+u,b=c*n+h*s+d,_=-1/0,w=-1/0,T=1/0,P=1/0;T=x<(T=y<(T=g<(T=p<T?p:T)?g:T)?y:T)?x:T,P=b<(P=v<(P=m<(P=f<P?f:P)?m:P)?v:P)?b:P,_=x>(_=y>(_=g>(_=p>_?p:_)?g:_)?y:_)?x:_,w=b>(w=v>(w=m>(w=f>w?f:w)?m:w)?v:w)?b:w;var C=this._bounds;return C.x=T,C.width=_-T,C.y=P,C.height=w-P,this._currentBounds=C,C},Object.defineProperty(e.TileSprite.prototype,"width",{get:function(){return this._width},set:function(t){this._width=t}}),Object.defineProperty(e.TileSprite.prototype,"height",{get:function(){return this._height},set:function(t){this._height=t}}),e.CanvasPool={create:function(t,i,s){var n,r=e.CanvasPool.getFirst();if(-1===r){var o={parent:t,canvas:document.createElement("canvas")};e.CanvasPool.pool.push(o),n=o.canvas}else e.CanvasPool.pool[r].parent=t,n=e.CanvasPool.pool[r].canvas;return void 0!==i&&(n.width=i,n.height=s),n},getFirst:function(){for(var t=e.CanvasPool.pool,i=0;i<t.length;i++)if(!t[i].parent)return i;return-1},remove:function(t){for(var i=e.CanvasPool.pool,s=0;s<i.length;s++)i[s].parent===t&&(i[s].parent=null,i[s].canvas.width=1,i[s].canvas.height=1)},removeByCanvas:function(t){for(var i=e.CanvasPool.pool,s=0;s<i.length;s++)i[s].canvas===t&&(i[s].parent=null,i[s].canvas.width=1,i[s].canvas.height=1)},getTotal:function(){for(var t=e.CanvasPool.pool,i=0,s=0;s<t.length;s++)t[s].parent&&i++;return i},getFree:function(){for(var t=e.CanvasPool.pool,i=0,s=0;s<t.length;s++)t[s].parent||i++;return i},log:function(){console.log("CanvasPool: %s used, %s free, %s total",this.getTotal(),this.getFree(),this.pool.length)}},e.CanvasPool.pool=[],Object.defineProperty(e.CanvasPool,"length",{get:function(){return this.pool.length}}),e.Device=function(){this.deviceReadyAt=0,this.initialized=!1,this.desktop=!1,this.iOS=!1,this.iOSVersion=0,this.cocoonJS=!1,this.cocoonJSApp=!1,this.cordova=!1,this.node=!1,this.nodeWebkit=!1,this.electron=!1,this.ejecta=!1,this.crosswalk=!1,this.android=!1,this.chromeOS=!1,this.linux=!1,this.macOS=!1,this.windows=!1,this.windowsPhone=!1,this.canvas=!1,this.canvasBitBltShift=null,this.canHandleAlpha=!1,this.canUseMultiply=!1,this.webGL=!1,this.file=!1,this.fileSystem=!1,this.localStorage=!1,this.worker=!1,this.css3D=!1,this.pointerLock=!1,this.typedArray=!1,this.vibration=!1,this.getUserMedia=!0,this.quirksMode=!1,this.touch=!1,this.mspointer=!1,this.wheelEvent=null,this.arora=!1,this.chrome=!1,this.chromeVersion=0,this.epiphany=!1,this.firefox=!1,this.firefoxVersion=0,this.ie=!1,this.ieVersion=0,this.trident=!1,this.tridentVersion=0,this.edge=!1,this.mobileSafari=!1,this.midori=!1,this.opera=!1,this.safari=!1,this.safariVersion=0,this.webApp=!1,this.silk=!1,this.audioData=!1,this.webAudio=!1,this.ogg=!1,this.opus=!1,this.mp3=!1,this.wav=!1,this.m4a=!1,this.webm=!1,this.dolby=!1,this.oggVideo=!1,this.h264Video=!1,this.mp4Video=!1,this.webmVideo=!1,this.vp9Video=!1,this.hlsVideo=!1,this.iPhone=!1,this.iPhone4=!1,this.iPad=!1,this.pixelRatio=0,this.littleEndian=!1,this.LITTLE_ENDIAN=!1,this.support32bit=!1,this.fullscreen=!1,this.requestFullscreen="",this.cancelFullscreen="",this.fullscreenKeyboard=!1},e.Device=new e.Device,e.Device.onInitialized=new e.Signal,e.Device.whenReady=function(t,e,i){var s=this._readyCheck;if(this.deviceReadyAt||!s)t.call(e,this);else if(s._monitor||i)s._queue=s._queue||[],s._queue.push([t,e]);else{s._monitor=s.bind(this),s._queue=s._queue||[],s._queue.push([t,e]);var n=void 0!==window.cordova,r=navigator.isCocoonJS;"complete"===document.readyState||"interactive"===document.readyState?window.setTimeout(s._monitor,0):n&&!r?document.addEventListener("deviceready",s._monitor,!1):(document.addEventListener("DOMContentLoaded",s._monitor,!1),window.addEventListener("load",s._monitor,!1))}},e.Device._readyCheck=function(){var t=this._readyCheck;if(document.body){if(!this.deviceReadyAt){this.deviceReadyAt=Date.now(),document.removeEventListener("deviceready",t._monitor),document.removeEventListener("DOMContentLoaded",t._monitor),window.removeEventListener("load",t._monitor),this._initialize(),this.initialized=!0,this.onInitialized.dispatch(this);for(var e;e=t._queue.shift();){var i=e[0],s=e[1];i.call(s,this)}this._readyCheck=null,this._initialize=null,this.onInitialized=null}}else window.setTimeout(t._monitor,20)},e.Device._initialize=function(){function t(){var t=new ArrayBuffer(4),e=new Uint8Array(t),i=new Uint32Array(t);return e[0]=161,e[1]=178,e[2]=195,e[3]=212,3569595041===i[0]||2712847316!==i[0]&&null}function i(){if(void 0===Uint8ClampedArray)return!1;var t=e.CanvasPool.create(this,1,1).getContext("2d");if(!t)return!1;var i=t.createImageData(1,1);return e.CanvasPool.remove(this),i.data instanceof Uint8ClampedArray}var s=this;!function(){var t=navigator.userAgent;/Playstation Vita/.test(t)?s.vita=!0:/Kindle/.test(t)||/\bKF[A-Z][A-Z]+/.test(t)||/Silk.*Mobile Safari/.test(t)?s.kindle=!0:/Android/.test(t)?s.android=!0:/CrOS/.test(t)?s.chromeOS=!0:/iP[ao]d|iPhone/i.test(t)?(s.iOS=!0,navigator.appVersion.match(/OS (\d+)/),s.iOSVersion=parseInt(RegExp.$1,10)):/Linux/.test(t)?s.linux=!0:/Mac OS/.test(t)?s.macOS=!0:/Windows/.test(t)&&(s.windows=!0),(/Windows Phone/i.test(t)||/IEMobile/i.test(t))&&(s.android=!1,s.iOS=!1,s.macOS=!1,s.windows=!0,s.windowsPhone=!0);var e=/Silk/.test(t);(s.windows||s.macOS||s.linux&&!e||s.chromeOS)&&(s.desktop=!0),(s.windowsPhone||/Windows NT/i.test(t)&&/Touch/i.test(t))&&(s.desktop=!1)}(),function(){var t=navigator.userAgent;if(/Arora/.test(t)?s.arora=!0:/Edge\/\d+/.test(t)?s.edge=!0:/Chrome\/(\d+)/.test(t)&&!s.windowsPhone?(s.chrome=!0,s.chromeVersion=parseInt(RegExp.$1,10)):/Epiphany/.test(t)?s.epiphany=!0:/Firefox\D+(\d+)/.test(t)?(s.firefox=!0,s.firefoxVersion=parseInt(RegExp.$1,10)):/AppleWebKit/.test(t)&&s.iOS?s.mobileSafari=!0:/MSIE (\d+\.\d+);/.test(t)?(s.ie=!0,s.ieVersion=parseInt(RegExp.$1,10)):/Midori/.test(t)?s.midori=!0:/Opera/.test(t)?s.opera=!0:/Safari\/(\d+)/.test(t)&&!s.windowsPhone?(s.safari=!0,/Version\/(\d+)\./.test(t)&&(s.safariVersion=parseInt(RegExp.$1,10))):/Trident\/(\d+\.\d+)(.*)rv:(\d+\.\d+)/.test(t)&&(s.ie=!0,s.trident=!0,s.tridentVersion=parseInt(RegExp.$1,10),s.ieVersion=parseInt(RegExp.$3,10)),/Silk/.test(t)&&(s.silk=!0),navigator.standalone&&(s.webApp=!0),void 0!==window.cordova&&(s.cordova=!0),"undefined"!=typeof process&&"undefined"!=typeof require&&(s.node=!0),s.node&&"object"==typeof process.versions&&(s.nodeWebkit=!!process.versions["node-webkit"],s.electron=!!process.versions.electron),navigator.isCocoonJS&&(s.cocoonJS=!0),s.cocoonJS)try{s.cocoonJSApp="undefined"!=typeof CocoonJS}catch(t){s.cocoonJSApp=!1}void 0!==window.ejecta&&(s.ejecta=!0),/Crosswalk/.test(t)&&(s.crosswalk=!0)}(),function(){s.audioData=!!window.Audio,s.webAudio=!(!window.AudioContext&&!window.webkitAudioContext);var t=document.createElement("audio");try{if(t.canPlayType&&(t.canPlayType('audio/ogg; codecs="vorbis"').replace(/^no$/,"")&&(s.ogg=!0),(t.canPlayType('audio/ogg; codecs="opus"').replace(/^no$/,"")||t.canPlayType("audio/opus;").replace(/^no$/,""))&&(s.opus=!0),t.canPlayType("audio/mpeg;").replace(/^no$/,"")&&(s.mp3=!0),t.canPlayType('audio/wav; codecs="1"').replace(/^no$/,"")&&(s.wav=!0),(t.canPlayType("audio/x-m4a;")||t.canPlayType("audio/aac;").replace(/^no$/,""))&&(s.m4a=!0),t.canPlayType('audio/webm; codecs="vorbis"').replace(/^no$/,"")&&(s.webm=!0),""!==t.canPlayType('audio/mp4;codecs="ec-3"')))if(s.edge)s.dolby=!0;else if(s.safari&&s.safariVersion>=9&&/Mac OS X (\d+)_(\d+)/.test(navigator.userAgent)){var e=parseInt(RegExp.$1,10),i=parseInt(RegExp.$2,10);(10===e&&i>=11||e>10)&&(s.dolby=!0)}}catch(t){}}(),function(){var t=document.createElement("video");try{t.canPlayType&&(t.canPlayType('video/ogg; codecs="theora"').replace(/^no$/,"")&&(s.oggVideo=!0),t.canPlayType('video/mp4; codecs="avc1.42E01E"').replace(/^no$/,"")&&(s.h264Video=!0,s.mp4Video=!0),t.canPlayType('video/webm; codecs="vp8, vorbis"').replace(/^no$/,"")&&(s.webmVideo=!0),t.canPlayType('video/webm; codecs="vp9"').replace(/^no$/,"")&&(s.vp9Video=!0),t.canPlayType('application/x-mpegURL; codecs="avc1.42E01E"').replace(/^no$/,"")&&(s.hlsVideo=!0))}catch(t){}}(),function(){var t,e=document.createElement("p"),i={webkitTransform:"-webkit-transform",OTransform:"-o-transform",msTransform:"-ms-transform",MozTransform:"-moz-transform",transform:"transform"};document.body.insertBefore(e,null);for(var n in i)void 0!==e.style[n]&&(e.style[n]="translate3d(1px,1px,1px)",t=window.getComputedStyle(e).getPropertyValue(i[n]));document.body.removeChild(e),s.css3D=void 0!==t&&t.length>0&&"none"!==t}(),s.pixelRatio=window.devicePixelRatio||1,s.iPhone=-1!==navigator.userAgent.toLowerCase().indexOf("iphone"),s.iPhone4=2===s.pixelRatio&&s.iPhone,s.iPad=-1!==navigator.userAgent.toLowerCase().indexOf("ipad"),"undefined"!=typeof Int8Array?s.typedArray=!0:s.typedArray=!1,"undefined"!=typeof ArrayBuffer&&"undefined"!=typeof Uint8Array&&"undefined"!=typeof Uint32Array&&(s.littleEndian=t(),s.LITTLE_ENDIAN=s.littleEndian),s.support32bit="undefined"!=typeof ArrayBuffer&&"undefined"!=typeof Uint8ClampedArray&&"undefined"!=typeof Int32Array&&null!==s.littleEndian&&i(),navigator.vibrate=navigator.vibrate||navigator.webkitVibrate||navigator.mozVibrate||navigator.msVibrate,navigator.vibrate&&(s.vibration=!0),function(){s.canvas=!!window.CanvasRenderingContext2D||s.cocoonJS;try{s.localStorage=!!localStorage.getItem}catch(t){s.localStorage=!1}s.file=!!(window.File&&window.FileReader&&window.FileList&&window.Blob),s.fileSystem=!!window.requestFileSystem,s.webGL=!!window.WebGLRenderingContext,s.worker=!!window.Worker,s.pointerLockElement="pointerLockElement"in document&&"pointerLockElement"||"mozPointerLockElement"in document&&"mozPointerLockElement"||"webkitPointerLockElement"in document&&"webkitPointerLockElement",s.pointerlockchange="onpointerlockchange"in document&&"pointerlockchange"||"onmozpointerlockchange"in document&&"mozpointerlockchange"||"onwebkitpointerlockchange"in document&&"webkitpointerlockchange",s.pointerlockerror="onpointerlockerror"in document&&"pointerlockerror"||"onmozpointerlockerror"in document&&"mozpointerlockerror"||"onwebkitpointerlockerror"in document&&"webkitpointerlockerror",s.pointerLock=!!s.pointerLockElement,s.quirksMode="CSS1Compat"!==document.compatMode,navigator.getUserMedia=navigator.getUserMedia||navigator.webkitGetUserMedia||navigator.mozGetUserMedia||navigator.msGetUserMedia||navigator.oGetUserMedia,window.URL=window.URL||window.webkitURL||window.mozURL||window.msURL,s.getUserMedia=s.getUserMedia&&!!navigator.getUserMedia&&!!window.URL,s.firefox&&s.firefoxVersion<21&&(s.getUserMedia=!1),!s.iOS&&(s.ie||s.firefox||s.chrome)&&(s.canvasBitBltShift=!0),(s.safari||s.mobileSafari)&&(s.canvasBitBltShift=!1)}(),function(){var t=e.CanvasPool.create(this,6,1),i=t.getContext("2d");i.fillStyle="rgba(10, 20, 30, 0.5)",i.fillRect(0,0,1,1);var n=i.getImageData(0,0,1,1);if(n){i.putImageData(n,1,0);var r=i.getImageData(1,0,1,1);s.canHandleAlpha=r.data[0]===n.data[0]&&r.data[1]===n.data[1]&&r.data[2]===n.data[2]&&r.data[3]===n.data[3]}i.globalCompositeOperation="multiply",s.canUseMultiply="multiply"===i.globalCompositeOperation,e.CanvasPool.removeByCanvas(t),PIXI.CanvasTinter.tintMethod=s.canUseMultiply?PIXI.CanvasTinter.tintWithMultiply:PIXI.CanvasTinter.tintWithPerPixel}(),function(){for(var t=["requestFullscreen","requestFullScreen","webkitRequestFullscreen","webkitRequestFullScreen","msRequestFullscreen","msRequestFullScreen","mozRequestFullScreen","mozRequestFullscreen"],e=document.createElement("div"),i=0;i<t.length;i++)if(e[t[i]]){s.fullscreen=!0,s.requestFullscreen=t[i];break}var n=["cancelFullScreen","exitFullscreen","webkitCancelFullScreen","webkitExitFullscreen","msCancelFullScreen","msExitFullscreen","mozCancelFullScreen","mozExitFullscreen"];if(s.fullscreen)for(i=0;i<n.length;i++)if(document[n[i]]){s.cancelFullscreen=n[i];break}window.Element&&Element.ALLOW_KEYBOARD_INPUT&&(s.fullscreenKeyboard=!0)}(),("ontouchstart"in document.documentElement||window.navigator.maxTouchPoints&&window.navigator.maxTouchPoints>=1)&&(s.touch=!0),(window.PointerEvent||window.MSPointerEvent||window.navigator.msPointerEnabled||window.navigator.pointerEnabled)&&(s.mspointer=!0),s.cocoonJS||("onwheel"in window||s.ie&&"WheelEvent"in window?s.wheelEvent="wheel":"onmousewheel"in window?s.wheelEvent="mousewheel":s.firefox&&"MouseScrollEvent"in window&&(s.wheelEvent="DOMMouseScroll"))},e.Device.canPlayAudio=function(t){return!("mp3"!==t||!this.mp3)||(!("ogg"!==t||!this.ogg&&!this.opus)||(!("m4a"!==t||!this.m4a)||(!("opus"!==t||!this.opus)||(!("wav"!==t||!this.wav)||(!("webm"!==t||!this.webm)||!("mp4"!==t||!this.dolby))))))},e.Device.canPlayVideo=function(t){return!("webm"!==t||!this.webmVideo&&!this.vp9Video)||(!("mp4"!==t||!this.mp4Video&&!this.h264Video)||(!("ogg"!==t&&"ogv"!==t||!this.oggVideo)||!("mpeg"!==t||!this.hlsVideo)))},e.Device.needsTouchUnlock=function(){return!!(!this.cocoonJS&&(this.iOS||this.android)||window.PhaserGlobal&&window.PhaserGlobal.fakeiOSTouchLock)},e.Device.isAndroidStockBrowser=function(){var t=window.navigator.userAgent.match(/Android.*AppleWebKit\/([\d.]+)/);return t&&t[1]<537},e.Canvas={create:function(t,i,s,n,r){i=i||256,s=s||256;var o=r?document.createElement("canvas"):e.CanvasPool.create(t,i,s);return"string"==typeof n&&""!==n&&(o.id=n),o.width=i,o.height=s,o.style.display="block",o},setBackgroundColor:function(t,e){return e=e||"rgb(0,0,0)",t.style.backgroundColor=e,t},setTouchAction:function(t,e){return e=e||"none",t.style.msTouchAction=e,t.style["ms-touch-action"]=e,t.style["touch-action"]=e,t},setUserSelect:function(t,e){return e=e||"none",t.style["-webkit-touch-callout"]=e,t.style["-webkit-user-select"]=e,t.style["-khtml-user-select"]=e,t.style["-moz-user-select"]=e,t.style["-ms-user-select"]=e,t.style["user-select"]=e,t.style["-webkit-tap-highlight-color"]="rgba(0, 0, 0, 0)",t},addToDOM:function(t,e,i){var s;return void 0===i&&(i=!0),e&&("string"==typeof e?s=document.getElementById(e):"object"==typeof e&&1===e.nodeType&&(s=e)),s||(s=document.body),i&&s.style&&(s.style.overflow="hidden"),s.appendChild(t),t},removeFromDOM:function(t){t.parentNode&&t.parentNode.removeChild(t)},setTransform:function(t,e,i,s,n,r,o){return t.setTransform(s,r,o,n,e,i),t},setSmoothingEnabled:function(t,i){var s=e.Canvas.getSmoothingPrefix(t);return s&&(t[s]=i),t},getSmoothingPrefix:function(t){var e=["i","webkitI","msI","mozI","oI"];for(var i in e){var s=e[i]+"mageSmoothingEnabled";if(s in t)return s}return null},getSmoothingEnabled:function(t){var i=e.Canvas.getSmoothingPrefix(t);if(i)return t[i]},setImageRenderingCrisp:function(t){for(var e=["-webkit-optimize-contrast","-moz-crisp-edges","crisp-edges","pixelated"],i=0;i<e.length;i++)t.style["image-rendering"]=e[i];return t.style.msInterpolationMode="nearest-neighbor",t},setImageRenderingBicubic:function(t){return t.style["image-rendering"]="auto",t.style.msInterpolationMode="bicubic",t}},e.RequestAnimationFrame=function(t,e){void 0===e&&(e=!1),this.game=t,this.isRunning=!1,this.forceSetTimeOut=e;for(var i=["ms","moz","webkit","o"],s=0;s<i.length&&!window.requestAnimationFrame;s++)window.requestAnimationFrame=window[i[s]+"RequestAnimationFrame"],window.cancelAnimationFrame=window[i[s]+"CancelAnimationFrame"]||window[i[s]+"CancelRequestAnimationFrame"];this._isSetTimeOut=!1,this._onLoop=null,this._timeOutID=null},e.RequestAnimationFrame.prototype={start:function(){this.isRunning=!0;var t=this;!window.requestAnimationFrame||this.forceSetTimeOut?(this._isSetTimeOut=!0,this._onLoop=function(){return t.updateSetTimeout()},this._timeOutID=window.setTimeout(this._onLoop,0)):(this._isSetTimeOut=!1,this._onLoop=function(e){return t.updateRAF(e)},this._timeOutID=window.requestAnimationFrame(this._onLoop))},updateRAF:function(t){this.isRunning&&(this.game.update(Math.floor(t)),this._timeOutID=window.requestAnimationFrame(this._onLoop))},updateSetTimeout:function(){this.isRunning&&(this.game.update(Date.now()),this._timeOutID=window.setTimeout(this._onLoop,this.game.time.timeToCall))},stop:function(){this._isSetTimeOut?clearTimeout(this._timeOutID):window.cancelAnimationFrame(this._timeOutID),this.isRunning=!1},isSetTimeOut:function(){return this._isSetTimeOut},isRAF:function(){return!1===this._isSetTimeOut}},e.RequestAnimationFrame.prototype.constructor=e.RequestAnimationFrame,e.Math={PI2:2*Math.PI,HALF_PI:.5*Math.PI,DEG_TO_RAD:Math.PI/180,RAD_TO_DEG:180/Math.PI,degToRad:function(t){return t*e.Math.DEG_TO_RAD},radToDeg:function(t){return t*e.Math.RAD_TO_DEG},getNextPowerOfTwo:function(t){if(t>0&&0==(t&t-1))return t;for(var e=1;e<t;)e<<=1;return e},isPowerOfTwo:function(t,e){return t>0&&0==(t&t-1)&&e>0&&0==(e&e-1)},random:function(t,e){if(void 0===t&&(t=0),void 0===e&&(e=1),t===e)return t;if(t>e){var i=t;t=e,e=i}return Math.random()*(e-t)+t},between:function(t,e){if(void 0===t&&(t=0),void 0===e&&(e=1),t===e)return t;if(t>e){var i=t;t=e,e=i}return t=Math.ceil(t),e=Math.floor(e),Math.floor(Math.random()*(e-t+1))+t},fuzzyEqual:function(t,e,i){return void 0===i&&(i=1e-4),Math.abs(t-e)<i},fuzzyLessThan:function(t,e,i){return void 0===i&&(i=1e-4),t<e+i},fuzzyGreaterThan:function(t,e,i){return void 0===i&&(i=1e-4),t>e-i},fuzzyCeil:function(t,e){return void 0===e&&(e=1e-4),Math.ceil(t-e)},fuzzyFloor:function(t,e){return void 0===e&&(e=1e-4),Math.floor(t+e)},average:function(){for(var t=0,e=arguments.length,i=0;i<e;i++)t+=+arguments[i];return t/e},shear:function(t){return t%1},snapTo:function(t,e,i){return void 0===i&&(i=0),0===e?t:(t-=i,t=e*Math.round(t/e),i+t)},snapToFloor:function(t,e,i){return void 0===i&&(i=0),0===e?t:(t-=i,t=e*Math.floor(t/e),i+t)},snapToCeil:function(t,e,i){return void 0===i&&(i=0),0===e?t:(t-=i,t=e*Math.ceil(t/e),i+t)},roundTo:function(t,e,i){void 0===e&&(e=0),void 0===i&&(i=10);var s=Math.pow(i,-e);return Math.round(t*s)/s},floorTo:function(t,e,i){void 0===e&&(e=0),void 0===i&&(i=10);var s=Math.pow(i,-e);return Math.floor(t*s)/s},ceilTo:function(t,e,i){void 0===e&&(e=0),void 0===i&&(i=10);var s=Math.pow(i,-e);return Math.ceil(t*s)/s},trunc:function(t){return isFinite(t)?t-t%1||(t<0?-0:0===t?t:0):t},rotateToAngle:function(t,i,s){return void 0===s&&(s=.05),t===i?t:(Math.abs(i-t)<=s||Math.abs(i-t)>=e.Math.PI2-s?t=i:(Math.abs(i-t)>Math.PI&&(i<t?i+=e.Math.PI2:i-=e.Math.PI2),i>t?t+=s:i<t&&(t-=s)),t)},getShortestAngle:function(t,e){var i=e-t;return 0===i?0:i-360*Math.floor((i- -180)/360)},angleBetween:function(t,e,i,s){return Math.atan2(s-e,i-t)},angleBetweenY:function(t,e,i,s){return Math.atan2(i-t,s-e)},angleBetweenPoints:function(t,e){return Math.atan2(e.y-t.y,e.x-t.x)},angleBetweenPointsY:function(t,e){return Math.atan2(e.x-t.x,e.y-t.y)},reverseAngle:function(t){return this.normalizeAngle(t+Math.PI,!0)},normalizeAngle:function(t){return(t%=2*Math.PI)>=0?t:t+2*Math.PI},maxAdd:function(t,e,i){return Math.min(t+e,i)},minSub:function(t,e,i){return Math.max(t-e,i)},wrap:function(t,e,i){var s=i-e;if(s<=0)return 0;var n=(t-e)%s;return n<0&&(n+=s),n+e},wrapValue:function(t,e,i){return t=Math.abs(t),e=Math.abs(e),i=Math.abs(i),(t+e)%i},isOdd:function(t){return!!(1&t)},isEven:function(t){return!(1&t)},min:function(){if(1===arguments.length&&"object"==typeof arguments[0])t=arguments[0];else var t=arguments;for(var e=1,i=0,s=t.length;e<s;e++)t[e]<t[i]&&(i=e);return t[i]},max:function(){if(1===arguments.length&&"object"==typeof arguments[0])t=arguments[0];else var t=arguments;for(var e=1,i=0,s=t.length;e<s;e++)t[e]>t[i]&&(i=e);return t[i]},minProperty:function(t){if(2===arguments.length&&"object"==typeof arguments[1])e=arguments[1];else var e=arguments.slice(1);for(var i=1,s=0,n=e.length;i<n;i++)e[i][t]<e[s][t]&&(s=i);return e[s][t]},maxProperty:function(t){if(2===arguments.length&&"object"==typeof arguments[1])e=arguments[1];else var e=arguments.slice(1);for(var i=1,s=0,n=e.length;i<n;i++)e[i][t]>e[s][t]&&(s=i);return e[s][t]},wrapAngle:function(t,e){return e?this.wrap(t,-Math.PI,Math.PI):this.wrap(t,-180,180)},linearInterpolation:function(t,e){var i=t.length-1,s=i*e,n=Math.floor(s);return e<0?this.linear(t[0],t[1],s):e>1?this.linear(t[i],t[i-1],i-s):this.linear(t[n],t[n+1>i?i:n+1],s-n)},bezierInterpolation:function(t,e){for(var i=0,s=t.length-1,n=0;n<=s;n++)i+=Math.pow(1-e,s-n)*Math.pow(e,n)*t[n]*this.bernstein(s,n);return i},catmullRomInterpolation:function(t,e){var i=t.length-1,s=i*e,n=Math.floor(s);return t[0]===t[i]?(e<0&&(n=Math.floor(s=i*(1+e))),this.catmullRom(t[(n-1+i)%i],t[n],t[(n+1)%i],t[(n+2)%i],s-n)):e<0?t[0]-(this.catmullRom(t[0],t[0],t[1],t[1],-s)-t[0]):e>1?t[i]-(this.catmullRom(t[i],t[i],t[i-1],t[i-1],s-i)-t[i]):this.catmullRom(t[n?n-1:0],t[n],t[i<n+1?i:n+1],t[i<n+2?i:n+2],s-n)},linear:function(t,e,i){return(e-t)*i+t},bernstein:function(t,e){return this.factorial(t)/this.factorial(e)/this.factorial(t-e)},factorial:function(t){if(0===t)return 1;for(var e=t;--t;)e*=t;return e},catmullRom:function(t,e,i,s,n){var r=.5*(i-t),o=.5*(s-e),a=n*n;return(2*e-2*i+r+o)*(n*a)+(-3*e+3*i-2*r-o)*a+r*n+e},difference:function(t,e){return Math.abs(t-e)},roundAwayFromZero:function(t){return t>0?Math.ceil(t):Math.floor(t)},sinCosGenerator:function(t,e,i,s){void 0===e&&(e=1),void 0===i&&(i=1),void 0===s&&(s=1);for(var n=e,r=i,o=s*Math.PI/t,a=[],h=[],l=0;l<t;l++)n+=(r-=n*o)*o,a[l]=r,h[l]=n;return{sin:h,cos:a,length:t}},hypot:function(t,e){return Math.sqrt(t*t+e*e)},distance:function(t,e,i,s){var n=t-i,r=e-s;return Math.sqrt(n*n+r*r)},distanceSq:function(t,e,i,s){var n=t-i,r=e-s;return n*n+r*r},distancePow:function(t,e,i,s,n){return void 0===n&&(n=2),Math.sqrt(Math.pow(i-t,n)+Math.pow(s-e,n))},clamp:function(t,e,i){return t<e?e:i<t?i:t},clampBottom:function(t,e){return t<e?e:t},within:function(t,e,i){return Math.abs(t-e)<=i},mapLinear:function(t,e,i,s,n){return s+(t-e)*(n-s)/(i-e)},smoothstep:function(t,e,i){return(t=Math.max(0,Math.min(1,(t-e)/(i-e))))*t*(3-2*t)},smootherstep:function(t,e,i){return(t=Math.max(0,Math.min(1,(t-e)/(i-e))))*t*t*(t*(6*t-15)+10)},sign:function(t){return t<0?-1:t>0?1:0},percent:function(t,e,i){return void 0===i&&(i=0),t>e||i>e?1:t<i||i>t?0:(t-i)/e}},e.RandomDataGenerator=function(t){void 0===t&&(t=[]),this.c=1,this.s0=0,this.s1=0,this.s2=0,"string"==typeof t?this.state(t):this.sow(t)},e.RandomDataGenerator.prototype={rnd:function(){var t=2091639*this.s0+2.3283064365386963e-10*this.c;return this.c=0|t,this.s0=this.s1,this.s1=this.s2,this.s2=t-this.c,this.s2},sow:function(t){if(this.s0=this.hash(" "),this.s1=this.hash(this.s0),this.s2=this.hash(this.s1),this.c=1,t)for(var e=0;e<t.length&&null!=t[e];e++){var i=t[e];this.s0-=this.hash(i),this.s0+=~~(this.s0<0),this.s1-=this.hash(i),this.s1+=~~(this.s1<0),this.s2-=this.hash(i),this.s2+=~~(this.s2<0)}},hash:function(t){var e,i,s;for(s=4022871197,t=t.toString(),i=0;i<t.length;i++)e=.02519603282416938*(s+=t.charCodeAt(i)),e-=s=e>>>0,s=(e*=s)>>>0,s+=4294967296*(e-=s);return 2.3283064365386963e-10*(s>>>0)},integer:function(){return 4294967296*this.rnd.apply(this)},frac:function(){return this.rnd.apply(this)+1.1102230246251565e-16*(2097152*this.rnd.apply(this)|0)},real:function(){return this.integer()+this.frac()},integerInRange:function(t,e){return Math.floor(this.realInRange(0,e-t+1)+t)},between:function(t,e){return this.integerInRange(t,e)},realInRange:function(t,e){return this.frac()*(e-t)+t},normal:function(){return 1-2*this.frac()},uuid:function(){var t="",e="";for(e=t="";t++<36;e+=~t%5|3*t&4?(15^t?8^this.frac()*(20^t?16:4):4).toString(16):"-");return e},pick:function(t){return t[this.integerInRange(0,t.length-1)]},sign:function(){return this.pick([-1,1])},weightedPick:function(t){return t[~~(Math.pow(this.frac(),2)*(t.length-1)+.5)]},timestamp:function(t,e){return this.realInRange(t||9466848e5,e||1577862e6)},angle:function(){return this.integerInRange(-180,180)},state:function(t){return"string"==typeof t&&t.match(/^!rnd/)&&(t=t.split(","),this.c=parseFloat(t[1]),this.s0=parseFloat(t[2]),this.s1=parseFloat(t[3]),this.s2=parseFloat(t[4])),["!rnd",this.c,this.s0,this.s1,this.s2].join(",")}},e.RandomDataGenerator.prototype.constructor=e.RandomDataGenerator,e.QuadTree=function(t,e,i,s,n,r,o){this.maxObjects=10,this.maxLevels=4,this.level=0,this.bounds={},this.objects=[],this.nodes=[],this._empty=[],this.reset(t,e,i,s,n,r,o)},e.QuadTree.prototype={reset:function(t,e,i,s,n,r,o){this.maxObjects=n||10,this.maxLevels=r||4,this.level=o||0,this.bounds={x:Math.round(t),y:Math.round(e),width:i,height:s,subWidth:Math.floor(i/2),subHeight:Math.floor(s/2),right:Math.round(t)+Math.floor(i/2),bottom:Math.round(e)+Math.floor(s/2)},this.objects.length=0,this.nodes.length=0},populate:function(t){t.forEach(this.populateHandler,this,!0)},populateHandler:function(t){t.body&&t.exists&&this.insert(t.body)},split:function(){this.nodes[0]=new e.QuadTree(this.bounds.right,this.bounds.y,this.bounds.subWidth,this.bounds.subHeight,this.maxObjects,this.maxLevels,this.level+1),this.nodes[1]=new e.QuadTree(this.bounds.x,this.bounds.y,this.bounds.subWidth,this.bounds.subHeight,this.maxObjects,this.maxLevels,this.level+1),this.nodes[2]=new e.QuadTree(this.bounds.x,this.bounds.bottom,this.bounds.subWidth,this.bounds.subHeight,this.maxObjects,this.maxLevels,this.level+1),this.nodes[3]=new e.QuadTree(this.bounds.right,this.bounds.bottom,this.bounds.subWidth,this.bounds.subHeight,this.maxObjects,this.maxLevels,this.level+1)},insert:function(t){var e,i=0;if(null==this.nodes[0]||-1===(e=this.getIndex(t))){if(this.objects.push(t),this.objects.length>this.maxObjects&&this.level<this.maxLevels)for(null==this.nodes[0]&&this.split();i<this.objects.length;)-1!==(e=this.getIndex(this.objects[i]))?this.nodes[e].insert(this.objects.splice(i,1)[0]):i++}else this.nodes[e].insert(t)},getIndex:function(t){var e=-1;return t.x<this.bounds.right&&t.right<this.bounds.right?t.y<this.bounds.bottom&&t.bottom<this.bounds.bottom?e=1:t.y>this.bounds.bottom&&(e=2):t.x>this.bounds.right&&(t.y<this.bounds.bottom&&t.bottom<this.bounds.bottom?e=0:t.y>this.bounds.bottom&&(e=3)),e},retrieve:function(t){if(t instanceof e.Rectangle)var i=this.objects,s=this.getIndex(t);else{if(!t.body)return this._empty;var i=this.objects,s=this.getIndex(t.body)}return this.nodes[0]&&(i=-1!==s?i.concat(this.nodes[s].retrieve(t)):(i=(i=(i=i.concat(this.nodes[0].retrieve(t))).concat(this.nodes[1].retrieve(t))).concat(this.nodes[2].retrieve(t))).concat(this.nodes[3].retrieve(t))),i},clear:function(){this.objects.length=0;for(var t=this.nodes.length;t--;)this.nodes[t].clear(),this.nodes.splice(t,1);this.nodes.length=0}},e.QuadTree.prototype.constructor=e.QuadTree,e.Net=function(t){this.game=t},e.Net.prototype={getHostName:function(){return window.location&&window.location.hostname?window.location.hostname:null},checkDomainName:function(t){return-1!==window.location.hostname.indexOf(t)},updateQueryString:function(t,e,i,s){void 0===i&&(i=!1),void 0!==s&&""!==s||(s=window.location.href);var n="",r=new RegExp("([?|&])"+t+"=.*?(&|#|$)(.*)","gi");if(r.test(s))n=void 0!==e&&null!==e?s.replace(r,"$1"+t+"="+e+"$2$3"):s.replace(r,"$1$3").replace(/(&|\?)$/,"");else if(void 0!==e&&null!==e){var o=-1!==s.indexOf("?")?"&":"?",a=s.split("#");s=a[0]+o+t+"="+e,a[1]&&(s+="#"+a[1]),n=s}else n=s;if(!i)return n;window.location.href=n},getQueryString:function(t){void 0===t&&(t="");var e={},i=location.search.substring(1).split("&");for(var s in i){var n=i[s].split("=");if(n.length>1){if(t&&t===this.decodeURI(n[0]))return this.decodeURI(n[1]);e[this.decodeURI(n[0])]=this.decodeURI(n[1])}}return e},decodeURI:function(t){return decodeURIComponent(t.replace(/\+/g," "))}},e.Net.prototype.constructor=e.Net,e.TweenManager=function(t){this.game=t,this.frameBased=!1,this._tweens=[],this._add=[],this.easeMap={Power0:e.Easing.Power0,Power1:e.Easing.Power1,Power2:e.Easing.Power2,Power3:e.Easing.Power3,Power4:e.Easing.Power4,Linear:e.Easing.Linear.None,Quad:e.Easing.Quadratic.Out,Cubic:e.Easing.Cubic.Out,Quart:e.Easing.Quartic.Out,Quint:e.Easing.Quintic.Out,Sine:e.Easing.Sinusoidal.Out,Expo:e.Easing.Exponential.Out,Circ:e.Easing.Circular.Out,Elastic:e.Easing.Elastic.Out,Back:e.Easing.Back.Out,Bounce:e.Easing.Bounce.Out,"Quad.easeIn":e.Easing.Quadratic.In,"Cubic.easeIn":e.Easing.Cubic.In,"Quart.easeIn":e.Easing.Quartic.In,"Quint.easeIn":e.Easing.Quintic.In,"Sine.easeIn":e.Easing.Sinusoidal.In,"Expo.easeIn":e.Easing.Exponential.In,"Circ.easeIn":e.Easing.Circular.In,"Elastic.easeIn":e.Easing.Elastic.In,"Back.easeIn":e.Easing.Back.In,"Bounce.easeIn":e.Easing.Bounce.In,"Quad.easeOut":e.Easing.Quadratic.Out,"Cubic.easeOut":e.Easing.Cubic.Out,"Quart.easeOut":e.Easing.Quartic.Out,"Quint.easeOut":e.Easing.Quintic.Out,"Sine.easeOut":e.Easing.Sinusoidal.Out,"Expo.easeOut":e.Easing.Exponential.Out,"Circ.easeOut":e.Easing.Circular.Out,"Elastic.easeOut":e.Easing.Elastic.Out,"Back.easeOut":e.Easing.Back.Out,"Bounce.easeOut":e.Easing.Bounce.Out,"Quad.easeInOut":e.Easing.Quadratic.InOut,"Cubic.easeInOut":e.Easing.Cubic.InOut,"Quart.easeInOut":e.Easing.Quartic.InOut,"Quint.easeInOut":e.Easing.Quintic.InOut,"Sine.easeInOut":e.Easing.Sinusoidal.InOut,"Expo.easeInOut":e.Easing.Exponential.InOut,"Circ.easeInOut":e.Easing.Circular.InOut,"Elastic.easeInOut":e.Easing.Elastic.InOut,"Back.easeInOut":e.Easing.Back.InOut,"Bounce.easeInOut":e.Easing.Bounce.InOut},this.game.onPause.add(this._pauseAll,this),this.game.onResume.add(this._resumeAll,this)},e.TweenManager.prototype={getAll:function(){return this._tweens},removeAll:function(){for(var t=0;t<this._tweens.length;t++)this._tweens[t].pendingDelete=!0;this._add=[]},removeFrom:function(t,i){void 0===i&&(i=!0);if(Array.isArray(t))for(s=0,n=t.length;s<n;s++)this.removeFrom(t[s]);else if(t.type===e.GROUP&&i)for(var s=0,n=t.children.length;s<n;s++)this.removeFrom(t.children[s]);else{for(s=0,n=this._tweens.length;s<n;s++)t===this._tweens[s].target&&this.remove(this._tweens[s]);for(s=0,n=this._add.length;s<n;s++)t===this._add[s].target&&this.remove(this._add[s])}},add:function(t){t._manager=this,this._add.push(t)},create:function(t){return new e.Tween(t,this.game,this)},remove:function(t){var e=this._tweens.indexOf(t);-1!==e?this._tweens[e].pendingDelete=!0:-1!==(e=this._add.indexOf(t))&&(this._add[e].pendingDelete=!0)},update:function(){var t=this._add.length,e=this._tweens.length;if(0===e&&0===t)return!1;for(var i=0;i<e;)this._tweens[i].update(this.game.time.time)?i++:(this._tweens.splice(i,1),e--);return t>0&&(this._tweens=this._tweens.concat(this._add),this._add.length=0),!0},isTweening:function(t,e){return e||(e=!1),this._tweens.some(function(i){return i.target===t&&(!e||i.isRunning&&!i.pendingDelete)})},_pauseAll:function(){for(var t=this._tweens.length-1;t>=0;t--)this._tweens[t]._pause()},_resumeAll:function(){for(var t=this._tweens.length-1;t>=0;t--)this._tweens[t]._resume()},pauseAll:function(){for(var t=this._tweens.length-1;t>=0;t--)this._tweens[t].pause()},resumeAll:function(){for(var t=this._tweens.length-1;t>=0;t--)this._tweens[t].resume(!0)},destroy:function(){this.game.onPause.remove(this._pauseAll,this),this.game.onResume.remove(this._resumeAll,this),this.game=null,this._add=null,this._tweens=null}},e.TweenManager.prototype.constructor=e.TweenManager,e.Tween=function(t,i,s){this.game=i,this.target=t,this.manager=s,this.timeline=[],this.reverse=!1,this.timeScale=1,this.repeatCounter=0,this.pendingDelete=!1,this.onStart=new e.Signal,this.onLoop=new e.Signal,this.onRepeat=new e.Signal,this.onChildComplete=new e.Signal,this.onComplete=new e.Signal,this.isRunning=!1,this.current=0,this.properties={},this.chainedTween=null,this.isPaused=!1,this.frameBased=s.frameBased,this._onUpdateCallback=null,this._onUpdateCallbackContext=null,this._pausedTime=0,this._codePaused=!1,this._hasStarted=!1},e.Tween.updateColor=function(t){e.Color.updateColor(t.target)},e.Tween.prototype={to:function(t,i,s,n,r,o,a){return(void 0===i||i<=0)&&(i=1e3),void 0!==s&&null!==s||(s=e.Easing.Default),void 0===n&&(n=!1),void 0===r&&(r=0),void 0===o&&(o=0),void 0===a&&(a=!1),"string"==typeof s&&this.manager.easeMap[s]&&(s=this.manager.easeMap[s]),this.isRunning?(console.warn("Phaser.Tween.to cannot be called after Tween.start"),this):(this.timeline.push(new e.TweenData(this).to(t,i,s,r,o,a)),n&&this.start(),this)},from:function(t,i,s,n,r,o,a){return void 0===i&&(i=1e3),void 0!==s&&null!==s||(s=e.Easing.Default),void 0===n&&(n=!1),void 0===r&&(r=0),void 0===o&&(o=0),void 0===a&&(a=!1),"string"==typeof s&&this.manager.easeMap[s]&&(s=this.manager.easeMap[s]),this.isRunning?(console.warn("Phaser.Tween.from cannot be called after Tween.start"),this):(this.timeline.push(new e.TweenData(this).from(t,i,s,r,o,a)),n&&this.start(),this)},start:function(t){if(void 0===t&&(t=0),this.pendingDelete)return console.warn("Phaser.Tween.start cannot be called after Tween.stop"),this;if(null===this.game||null===this.target||0===this.timeline.length||this.isRunning)return this;for(i=0;i<this.timeline.length;i++)for(var e in this.timeline[i].vEnd)this.properties[e]=this.target[e]||0,Array.isArray(this.properties[e])||(this.properties[e]*=1);for(var i=0;i<this.timeline.length;i++)this.timeline[i].loadValues();return this.manager.add(this),this.isRunning=!0,(t<0||t>this.timeline.length-1)&&(t=0),this.current=t,this.timeline[this.current].start(),this},stop:function(t){return void 0===t&&(t=!1),this.isRunning=!1,this._onUpdateCallback=null,this._onUpdateCallbackContext=null,t&&(this.onComplete.dispatch(this.target,this),this._hasStarted=!1,this.chainedTween&&this.chainedTween.start()),this.manager.remove(this),this},updateTweenData:function(t,e,i){if(0===this.timeline.length)return this;if(void 0===i&&(i=0),-1===i)for(var s=0;s<this.timeline.length;s++)this.timeline[s][t]=e;else this.timeline[i][t]=e;return this},delay:function(t,e){return this.updateTweenData("delay",t,e)},repeat:function(t,e,i){return void 0===e&&(e=0),this.updateTweenData("repeatCounter",t,i),this.updateTweenData("repeatTotal",t,i),this.updateTweenData("repeatDelay",e,i)},repeatDelay:function(t,e){return this.updateTweenData("repeatDelay",t,e)},yoyo:function(t,e,i){return void 0===e&&(e=0),this.updateTweenData("yoyo",t,i),this.updateTweenData("yoyoDelay",e,i)},yoyoDelay:function(t,e){return this.updateTweenData("yoyoDelay",t,e)},easing:function(t,e){return"string"==typeof t&&this.manager.easeMap[t]&&(t=this.manager.easeMap[t]),this.updateTweenData("easingFunction",t,e)},interpolation:function(t,i,s){return void 0===i&&(i=e.Math),this.updateTweenData("interpolationFunction",t,s),this.updateTweenData("interpolationContext",i,s)},repeatAll:function(t){return void 0===t&&(t=0),this.repeatCounter=t,this},chain:function(){for(var t=arguments.length;t--;)t>0?arguments[t-1].chainedTween=arguments[t]:this.chainedTween=arguments[t];return this},loop:function(t){return void 0===t&&(t=!0),this.repeatCounter=t?-1:0,this},onUpdateCallback:function(t,e){return this._onUpdateCallback=t,this._onUpdateCallbackContext=e,this},pause:function(){this.isPaused=!0,this._codePaused=!0,this._pausedTime=this.game.time.time},_pause:function(){this._codePaused||(this.isPaused=!0,this._pausedTime=this.game.time.time)},resume:function(){if(this.isPaused){this.isPaused=!1,this._codePaused=!1;for(var t=0;t<this.timeline.length;t++)this.timeline[t].isRunning||(this.timeline[t].startTime+=this.game.time.time-this._pausedTime)}},_resume:function(){this._codePaused||this.resume()},update:function(t){if(this.pendingDelete||!this.target)return!1;if(this.isPaused)return!0;var i=this.timeline[this.current].update(t);if(i===e.TweenData.PENDING)return!0;if(i===e.TweenData.RUNNING)return this._hasStarted||(this.onStart.dispatch(this.target,this),this._hasStarted=!0),null!==this._onUpdateCallback&&this._onUpdateCallback.call(this._onUpdateCallbackContext,this,this.timeline[this.current].value,this.timeline[this.current]),this.isRunning;if(i===e.TweenData.LOOPED)return-1===this.timeline[this.current].repeatCounter?this.onLoop.dispatch(this.target,this):this.onRepeat.dispatch(this.target,this),!0;if(i===e.TweenData.COMPLETE){var s=!1;return this.reverse?--this.current<0&&(this.current=this.timeline.length-1,s=!0):++this.current===this.timeline.length&&(this.current=0,s=!0),s?-1===this.repeatCounter?(this.timeline[this.current].start(),this.onLoop.dispatch(this.target,this),!0):this.repeatCounter>0?(this.repeatCounter--,this.timeline[this.current].start(),this.onRepeat.dispatch(this.target,this),!0):(this.isRunning=!1,this.onComplete.dispatch(this.target,this),this._hasStarted=!1,this.chainedTween&&this.chainedTween.start(),!1):(this.onChildComplete.dispatch(this.target,this),this.timeline[this.current].start(),!0)}},generateData:function(t,e){if(null===this.game||null===this.target)return null;void 0===t&&(t=60),void 0===e&&(e=[]);for(s=0;s<this.timeline.length;s++)for(var i in this.timeline[s].vEnd)this.properties[i]=this.target[i]||0,Array.isArray(this.properties[i])||(this.properties[i]*=1);for(s=0;s<this.timeline.length;s++)this.timeline[s].loadValues();for(var s=0;s<this.timeline.length;s++)e=e.concat(this.timeline[s].generateData(t));return e}},Object.defineProperty(e.Tween.prototype,"totalDuration",{get:function(){for(var t=0,e=0;e<this.timeline.length;e++)t+=this.timeline[e].duration;return t}}),e.Tween.prototype.constructor=e.Tween,e.TweenData=function(t){this.parent=t,this.game=t.game,this.vStart={},this.vStartCache={},this.vEnd={},this.vEndCache={},this.duration=1e3,this.percent=0,this.value=0,this.repeatCounter=0,this.repeatDelay=0,this.repeatTotal=0,this.interpolate=!1,this.yoyo=!1,this.yoyoDelay=0,this.inReverse=!1,this.delay=0,this.dt=0,this.startTime=null,this.easingFunction=e.Easing.Default,this.interpolationFunction=e.Math.linearInterpolation,this.interpolationContext=e.Math,this.isRunning=!1,this.isFrom=!1},e.TweenData.PENDING=0,e.TweenData.RUNNING=1,e.TweenData.LOOPED=2,e.TweenData.COMPLETE=3,e.TweenData.prototype={to:function(t,e,i,s,n,r){return this.vEnd=t,this.duration=e,this.easingFunction=i,this.delay=s,this.repeatTotal=n,this.yoyo=r,this.isFrom=!1,this},from:function(t,e,i,s,n,r){return this.vEnd=t,this.duration=e,this.easingFunction=i,this.delay=s,this.repeatTotal=n,this.yoyo=r,this.isFrom=!0,this},start:function(){if(this.startTime=this.game.time.time+this.delay,this.parent.reverse?this.dt=this.duration:this.dt=0,this.delay>0?this.isRunning=!1:this.isRunning=!0,this.isFrom)for(var t in this.vStartCache)this.vStart[t]=this.vEndCache[t],this.vEnd[t]=this.vStartCache[t],this.parent.target[t]=this.vStart[t];return this.value=0,this.repeatCounter=this.repeatTotal,this},loadValues:function(){for(var t in this.parent.properties){if(this.vStart[t]=this.parent.properties[t],Array.isArray(this.vEnd[t])){if(0===this.vEnd[t].length)continue;0===this.percent&&(this.vEnd[t]=[this.vStart[t]].concat(this.vEnd[t]))}void 0!==this.vEnd[t]?("string"==typeof this.vEnd[t]&&(this.vEnd[t]=this.vStart[t]+parseFloat(this.vEnd[t],10)),this.parent.properties[t]=this.vEnd[t]):this.vEnd[t]=this.vStart[t],this.vStartCache[t]=this.vStart[t],this.vEndCache[t]=this.vEnd[t]}return this},update:function(t){if(this.isRunning){if(t<this.startTime)return e.TweenData.RUNNING}else{if(!(t>=this.startTime))return e.TweenData.PENDING;this.isRunning=!0}var i=this.parent.frameBased?this.game.time.physicsElapsedMS:this.game.time.elapsedMS;this.parent.reverse?(this.dt-=i*this.parent.timeScale,this.dt=Math.max(this.dt,0)):(this.dt+=i*this.parent.timeScale,this.dt=Math.min(this.dt,this.duration)),this.percent=this.dt/this.duration,this.value=this.easingFunction(this.percent);for(var s in this.vEnd){var n=this.vStart[s],r=this.vEnd[s];Array.isArray(r)?this.parent.target[s]=this.interpolationFunction.call(this.interpolationContext,r,this.value):this.parent.target[s]=n+(r-n)*this.value}return!this.parent.reverse&&1===this.percent||this.parent.reverse&&0===this.percent?this.repeat():e.TweenData.RUNNING},generateData:function(t){this.parent.reverse?this.dt=this.duration:this.dt=0;var e=[],i=!1,s=1/t*1e3;do{this.parent.reverse?(this.dt-=s,this.dt=Math.max(this.dt,0)):(this.dt+=s,this.dt=Math.min(this.dt,this.duration)),this.percent=this.dt/this.duration,this.value=this.easingFunction(this.percent);var n={};for(var r in this.vEnd){var o=this.vStart[r],a=this.vEnd[r];Array.isArray(a)?n[r]=this.interpolationFunction.call(this.interpolationContext,a,this.value):n[r]=o+(a-o)*this.value}e.push(n),(!this.parent.reverse&&1===this.percent||this.parent.reverse&&0===this.percent)&&(i=!0)}while(!i);if(this.yoyo){var h=e.slice();h.reverse(),e=e.concat(h)}return e},repeat:function(){if(this.yoyo){if(this.inReverse&&0===this.repeatCounter){for(var t in this.vStartCache)this.vStart[t]=this.vStartCache[t],this.vEnd[t]=this.vEndCache[t];return this.inReverse=!1,e.TweenData.COMPLETE}this.inReverse=!this.inReverse}else if(0===this.repeatCounter)return e.TweenData.COMPLETE;if(this.inReverse)for(var t in this.vStartCache)this.vStart[t]=this.vEndCache[t],this.vEnd[t]=this.vStartCache[t];else{for(var t in this.vStartCache)this.vStart[t]=this.vStartCache[t],this.vEnd[t]=this.vEndCache[t];this.repeatCounter>0&&this.repeatCounter--}return this.startTime=this.game.time.time,this.yoyo&&this.inReverse?this.startTime+=this.yoyoDelay:this.inReverse||(this.startTime+=this.repeatDelay),this.parent.reverse?this.dt=this.duration:this.dt=0,e.TweenData.LOOPED}},e.TweenData.prototype.constructor=e.TweenData,e.Easing={Linear:{None:function(t){return t}},Quadratic:{In:function(t){return t*t},Out:function(t){return t*(2-t)},InOut:function(t){return(t*=2)<1?.5*t*t:-.5*(--t*(t-2)-1)}},Cubic:{In:function(t){return t*t*t},Out:function(t){return--t*t*t+1},InOut:function(t){return(t*=2)<1?.5*t*t*t:.5*((t-=2)*t*t+2)}},Quartic:{In:function(t){return t*t*t*t},Out:function(t){return 1- --t*t*t*t},InOut:function(t){return(t*=2)<1?.5*t*t*t*t:-.5*((t-=2)*t*t*t-2)}},Quintic:{In:function(t){return t*t*t*t*t},Out:function(t){return--t*t*t*t*t+1},InOut:function(t){return(t*=2)<1?.5*t*t*t*t*t:.5*((t-=2)*t*t*t*t+2)}},Sinusoidal:{In:function(t){return 0===t?0:1===t?1:1-Math.cos(t*Math.PI/2)},Out:function(t){return 0===t?0:1===t?1:Math.sin(t*Math.PI/2)},InOut:function(t){return 0===t?0:1===t?1:.5*(1-Math.cos(Math.PI*t))}},Exponential:{In:function(t){return 0===t?0:Math.pow(1024,t-1)},Out:function(t){return 1===t?1:1-Math.pow(2,-10*t)},InOut:function(t){return 0===t?0:1===t?1:(t*=2)<1?.5*Math.pow(1024,t-1):.5*(2-Math.pow(2,-10*(t-1)))}},Circular:{In:function(t){return 1-Math.sqrt(1-t*t)},Out:function(t){return Math.sqrt(1- --t*t)},InOut:function(t){return(t*=2)<1?-.5*(Math.sqrt(1-t*t)-1):.5*(Math.sqrt(1-(t-=2)*t)+1)}},Elastic:{In:function(t){var e,i=.1;return 0===t?0:1===t?1:(!i||i<1?(i=1,e=.1):e=.4*Math.asin(1/i)/(2*Math.PI),-i*Math.pow(2,10*(t-=1))*Math.sin((t-e)*(2*Math.PI)/.4))},Out:function(t){var e,i=.1;return 0===t?0:1===t?1:(!i||i<1?(i=1,e=.1):e=.4*Math.asin(1/i)/(2*Math.PI),i*Math.pow(2,-10*t)*Math.sin((t-e)*(2*Math.PI)/.4)+1)},InOut:function(t){var e,i=.1;return 0===t?0:1===t?1:(!i||i<1?(i=1,e=.1):e=.4*Math.asin(1/i)/(2*Math.PI),(t*=2)<1?i*Math.pow(2,10*(t-=1))*Math.sin((t-e)*(2*Math.PI)/.4)*-.5:i*Math.pow(2,-10*(t-=1))*Math.sin((t-e)*(2*Math.PI)/.4)*.5+1)}},Back:{In:function(t){var e=1.70158;return t*t*((e+1)*t-e)},Out:function(t){var e=1.70158;return--t*t*((e+1)*t+e)+1},InOut:function(t){var e=2.5949095;return(t*=2)<1?t*t*((e+1)*t-e)*.5:.5*((t-=2)*t*((e+1)*t+e)+2)}},Bounce:{In:function(t){return 1-e.Easing.Bounce.Out(1-t)},Out:function(t){return t<1/2.75?7.5625*t*t:t<2/2.75?7.5625*(t-=1.5/2.75)*t+.75:t<2.5/2.75?7.5625*(t-=2.25/2.75)*t+.9375:7.5625*(t-=2.625/2.75)*t+.984375},InOut:function(t){return t<.5?.5*e.Easing.Bounce.In(2*t):.5*e.Easing.Bounce.Out(2*t-1)+.5}}},e.Easing.Default=e.Easing.Linear.None,e.Easing.Power0=e.Easing.Linear.None,e.Easing.Power1=e.Easing.Quadratic.Out,e.Easing.Power2=e.Easing.Cubic.Out,e.Easing.Power3=e.Easing.Quartic.Out,e.Easing.Power4=e.Easing.Quintic.Out,e.Time=function(t){this.game=t,this.time=0,this.prevTime=0,this.now=0,this.elapsed=0,this.elapsedMS=0,this.physicsElapsed=1/60,this.physicsElapsedMS=1/60*1e3,this.desiredFpsMult=1/60,this._desiredFps=60,this.suggestedFps=this.desiredFps,this.slowMotion=1,this.advancedTiming=!1,this.frames=0,this.updates=0,this.renders=0,this.fps=0,this.ups=0,this.rps=0,this.fpsMin=1e3,this.fpsMax=0,this.msMin=1e3,this.msMax=0,this.pauseDuration=0,this.timeToCall=0,this.timeExpected=0,this.events=new e.Timer(this.game,!1),this._frameCount=0,this._elapsedAccumulator=0,this._started=0,this._timeLastSecond=0,this._pauseStarted=0,this._justResumed=!1,this._timers=[]},e.Time.prototype={boot:function(){this._started=Date.now(),this.time=Date.now(),this.events.start(),this.timeExpected=this.time},add:function(t){return this._timers.push(t),t},create:function(t){void 0===t&&(t=!0);var i=new e.Timer(this.game,t);return this._timers.push(i),i},removeAll:function(){for(var t=0;t<this._timers.length;t++)this._timers[t].destroy();this._timers=[],this.events.removeAll()},refresh:function(){var t=this.time;this.time=Date.now(),this.elapsedMS=this.time-t},update:function(t){var e=this.time;this.time=Date.now(),this.elapsedMS=this.time-e,this.prevTime=this.now,this.now=t,this.elapsed=this.now-this.prevTime,this.game.raf._isSetTimeOut&&(this.timeToCall=Math.floor(Math.max(0,1e3/this._desiredFps-(this.timeExpected-t))),this.timeExpected=t+this.timeToCall),this.advancedTiming&&this.updateAdvancedTiming(),this.game.paused||(this.events.update(this.time),this._timers.length&&this.updateTimers())},updateTimers:function(){for(var t=0,e=this._timers.length;t<e;)this._timers[t].update(this.time)?t++:(this._timers.splice(t,1),e--)},updateAdvancedTiming:function(){if(this._frameCount++,this._elapsedAccumulator+=this.elapsed,this._frameCount>=2*this._desiredFps&&(this.suggestedFps=5*Math.floor(200/(this._elapsedAccumulator/this._frameCount)),this._frameCount=0,this._elapsedAccumulator=0),this.msMin=Math.min(this.msMin,this.elapsed),this.msMax=Math.max(this.msMax,this.elapsed),this.frames++,this.now>this._timeLastSecond+1e3){var t=this.now-this._timeLastSecond;this.fps=Math.round(1e3*this.frames/t),this.ups=Math.round(1e3*this.updates/t),this.rps=Math.round(1e3*this.renders/t),this.fpsMin=Math.min(this.fpsMin,this.fps),this.fpsMax=Math.max(this.fpsMax,this.fps),this._timeLastSecond=this.now,this.frames=0,this.updates=0,this.renders=0}},countUpdate:function(){this.advancedTiming&&this.updates++},countRender:function(){this.advancedTiming&&this.renders++},gamePaused:function(){this._pauseStarted=Date.now(),this.events.pause();for(var t=this._timers.length;t--;)this._timers[t]._pause()},gameResumed:function(){this.time=Date.now(),this.pauseDuration=this.time-this._pauseStarted,this.events.resume();for(var t=this._timers.length;t--;)this._timers[t]._resume()},totalElapsedSeconds:function(){return.001*(this.time-this._started)},elapsedSince:function(t){return this.time-t},elapsedSecondsSince:function(t){return.001*(this.time-t)},reset:function(){this._started=this.time,this.removeAll()}},Object.defineProperty(e.Time.prototype,"desiredFps",{get:function(){return this._desiredFps},set:function(t){this._desiredFps=t,this.physicsElapsed=1/t,this.physicsElapsedMS=1e3*this.physicsElapsed,this.desiredFpsMult=1/t}}),e.Time.prototype.constructor=e.Time,e.Timer=function(t,i){void 0===i&&(i=!0),this.game=t,this.running=!1,this.autoDestroy=i,this.expired=!1,this.elapsed=0,this.events=[],this.onComplete=new e.Signal,this.nextTick=0,this.timeCap=1e3,this.paused=!1,this._codePaused=!1,this._started=0,this._pauseStarted=0,this._pauseTotal=0,this._now=Date.now(),this._len=0,this._marked=0,this._i=0,this._diff=0,this._newTick=0},e.Timer.MINUTE=6e4,e.Timer.SECOND=1e3,e.Timer.HALF=500,e.Timer.QUARTER=250,e.Timer.prototype={create:function(t,i,s,n,r,o){var a=t=Math.round(t);0===this._now?a+=this.game.time.time:a+=this._now;var h=new e.TimerEvent(this,t,a,s,i,n,r,o);return this.events.push(h),this.order(),this.expired=!1,h},add:function(t,e,i){return this.create(t,!1,0,e,i,Array.prototype.slice.call(arguments,3))},repeat:function(t,e,i,s){return this.create(t,!1,e,i,s,Array.prototype.slice.call(arguments,4))},loop:function(t,e,i){return this.create(t,!0,0,e,i,Array.prototype.slice.call(arguments,3))},start:function(t){if(!this.running){this._started=this.game.time.time+(t||0),this.running=!0;for(var e=0;e<this.events.length;e++)this.events[e].tick=this.events[e].delay+this._started}},stop:function(t){this.running=!1,void 0===t&&(t=!0),t&&(this.events.length=0)},remove:function(t){for(var e=0;e<this.events.length;e++)if(this.events[e]===t)return this.events[e].pendingDelete=!0,!0;return!1},order:function(){this.events.length>0&&(this.events.sort(this.sortHandler),this.nextTick=this.events[0].tick)},sortHandler:function(t,e){return t.tick<e.tick?-1:t.tick>e.tick?1:0},clearPendingEvents:function(){for(this._i=this.events.length;this._i--;)this.events[this._i].pendingDelete&&this.events.splice(this._i,1);this._len=this.events.length,this._i=0},update:function(t){if(this.paused)return!0;if(this.elapsed=t-this._now,this._now=t,this.elapsed>this.timeCap&&this.adjustEvents(t-this.elapsed),this._marked=0,this.clearPendingEvents(),this.running&&this._now>=this.nextTick&&this._len>0){for(;this._i<this._len&&this.running;){var e=this.events[this._i];if(!(this._now>=e.tick)||e.pendingDelete)break;this._newTick=this._now+e.delay-(this._now-e.tick),this._newTick<0&&(this._newTick=this._now+e.delay),!0===e.loop?(e.tick=this._newTick,e.callback.apply(e.callbackContext,e.args)):e.repeatCount>0?(e.repeatCount--,e.tick=this._newTick,e.callback.apply(e.callbackContext,e.args)):(this._marked++,e.pendingDelete=!0,e.callback.apply(e.callbackContext,e.args)),this._i++}this.events.length>this._marked?this.order():(this.expired=!0,this.onComplete.dispatch(this))}return!this.expired||!this.autoDestroy},pause:function(){this.running&&(this._codePaused=!0,this.paused||(this._pauseStarted=this.game.time.time,this.paused=!0))},_pause:function(){!this.paused&&this.running&&(this._pauseStarted=this.game.time.time,this.paused=!0)},adjustEvents:function(t){for(var e=0;e<this.events.length;e++)if(!this.events[e].pendingDelete){var i=this.events[e].tick-t;i<0&&(i=0),this.events[e].tick=this._now+i}var s=this.nextTick-t;this.nextTick=s<0?this._now:this._now+s},resume:function(){if(this.paused){var t=this.game.time.time;this._pauseTotal+=t-this._now,this._now=t,this.adjustEvents(this._pauseStarted),this.paused=!1,this._codePaused=!1}},_resume:function(){this._codePaused||this.resume()},removeAll:function(){this.onComplete.removeAll(),this.events.length=0,this._len=0,this._i=0},destroy:function(){this.onComplete.removeAll(),this.running=!1,this.expired=!0,this.events=[],this._len=0,this._i=0}},Object.defineProperty(e.Timer.prototype,"next",{get:function(){return this.nextTick}}),Object.defineProperty(e.Timer.prototype,"duration",{get:function(){return this.running&&this.nextTick>this._now?this.nextTick-this._now:0}}),Object.defineProperty(e.Timer.prototype,"length",{get:function(){return this.events.length}}),Object.defineProperty(e.Timer.prototype,"ms",{get:function(){return this.running?this._now-this._started-this._pauseTotal:0}}),Object.defineProperty(e.Timer.prototype,"seconds",{get:function(){return this.running?.001*this.ms:0}}),e.Timer.prototype.constructor=e.Timer,e.TimerEvent=function(t,e,i,s,n,r,o,a){this.timer=t,this.delay=e,this.tick=i,this.repeatCount=s-1,this.loop=n,this.callback=r,this.callbackContext=o,this.args=a,this.pendingDelete=!1},e.TimerEvent.prototype.constructor=e.TimerEvent,e.AnimationManager=function(t){this.sprite=t,this.game=t.game,this.currentFrame=null,this.currentAnim=null,this.updateIfVisible=!0,this.isLoaded=!1,this._frameData=null,this._anims={},this._outputFrames=[]},e.AnimationManager.prototype={loadFrameData:function(t,e){if(void 0===t)return!1;if(this.isLoaded)for(var i in this._anims)this._anims[i].updateFrameData(t);return this._frameData=t,void 0===e||null===e?this.frame=0:"string"==typeof e?this.frameName=e:this.frame=e,this.isLoaded=!0,!0},copyFrameData:function(t,e){if(this._frameData=t.clone(),this.isLoaded)for(var i in this._anims)this._anims[i].updateFrameData(this._frameData);return void 0===e||null===e?this.frame=0:"string"==typeof e?this.frameName=e:this.frame=e,this.isLoaded=!0,!0},add:function(t,i,s,n,r){return i=i||[],s=s||60,void 0===n&&(n=!1),void 0===r&&(r=!(!i||"number"!=typeof i[0])),this._outputFrames=[],this._frameData.getFrameIndexes(i,r,this._outputFrames),this._anims[t]=new e.Animation(this.game,this.sprite,t,this._frameData,this._outputFrames,s,n),this.currentAnim=this._anims[t],this.sprite.tilingTexture&&(this.sprite.refreshTexture=!0),this._anims[t]},validateFrames:function(t,e){void 0===e&&(e=!0);for(var i=0;i<t.length;i++)if(!0===e){if(t[i]>this._frameData.total)return!1}else if(!1===this._frameData.checkFrameName(t[i]))return!1;return!0},play:function(t,e,i,s){if(this._anims[t])return this.currentAnim===this._anims[t]?!1===this.currentAnim.isPlaying?(this.currentAnim.paused=!1,this.currentAnim.play(e,i,s)):this.currentAnim:(this.currentAnim&&this.currentAnim.isPlaying&&this.currentAnim.stop(),this.currentAnim=this._anims[t],this.currentAnim.paused=!1,this.currentFrame=this.currentAnim.currentFrame,this.currentAnim.play(e,i,s))},stop:function(t,e){void 0===e&&(e=!1),!this.currentAnim||"string"==typeof t&&t!==this.currentAnim.name||this.currentAnim.stop(e)},update:function(){return!(this.updateIfVisible&&!this.sprite.visible)&&(!(!this.currentAnim||!this.currentAnim.update())&&(this.currentFrame=this.currentAnim.currentFrame,!0))},next:function(t){this.currentAnim&&(this.currentAnim.next(t),this.currentFrame=this.currentAnim.currentFrame)},previous:function(t){this.currentAnim&&(this.currentAnim.previous(t),this.currentFrame=this.currentAnim.currentFrame)},getAnimation:function(t){return"string"==typeof t&&this._anims[t]?this._anims[t]:null},refreshFrame:function(){},destroy:function(){t=null;for(var t in this._anims)this._anims.hasOwnProperty(t)&&this._anims[t].destroy();this._anims={},this._outputFrames=[],this._frameData=null,this.currentAnim=null,this.currentFrame=null,this.sprite=null,this.game=null}},e.AnimationManager.prototype.constructor=e.AnimationManager,Object.defineProperty(e.AnimationManager.prototype,"frameData",{get:function(){return this._frameData}}),Object.defineProperty(e.AnimationManager.prototype,"frameTotal",{get:function(){return this._frameData.total}}),Object.defineProperty(e.AnimationManager.prototype,"paused",{get:function(){return this.currentAnim.isPaused},set:function(t){this.currentAnim.paused=t}}),Object.defineProperty(e.AnimationManager.prototype,"name",{get:function(){if(this.currentAnim)return this.currentAnim.name}}),Object.defineProperty(e.AnimationManager.prototype,"frame",{get:function(){if(this.currentFrame)return this.currentFrame.index},set:function(t){var e;"number"==typeof t&&this._frameData&&(e=this._frameData.getFrame(t))&&(this.currentFrame=e,this.sprite.setFrame(this.currentFrame))}}),Object.defineProperty(e.AnimationManager.prototype,"frameName",{get:function(){if(this.currentFrame)return this.currentFrame.name},set:function(t){var e;"string"==typeof t&&this._frameData&&(e=this._frameData.getFrameByName(t))?(this.currentFrame=e,this._frameIndex=this.currentFrame.index,this.sprite.setFrame(this.currentFrame)):console.warn("Cannot set frameName: "+t)}}),e.Animation=function(t,i,s,n,r,o,a){void 0===a&&(a=!1),this.game=t,this._parent=i,this._frameData=n,this.name=s,this._frames=[],this._frames=this._frames.concat(r),this.delay=1e3/o,this.loop=a,this.loopCount=0,this.killOnComplete=!1,this.isFinished=!1,this.isPlaying=!1,this.isPaused=!1,this._pauseStartTime=0,this._frameIndex=0,this._frameDiff=0,this._frameSkip=1,this.currentFrame=this._frameData.getFrame(this._frames[this._frameIndex]),this.onStart=new e.Signal,this.onUpdate=null,this.onComplete=new e.Signal,this.onLoop=new e.Signal,this.isReversed=!1,this.game.onPause.add(this.onPause,this),this.game.onResume.add(this.onResume,this)},e.Animation.prototype={play:function(t,e,i){return"number"==typeof t&&(this.delay=1e3/t),"boolean"==typeof e&&(this.loop=e),void 0!==i&&(this.killOnComplete=i),this.isPlaying=!0,this.isFinished=!1,this.paused=!1,this.loopCount=0,this._timeLastFrame=this.game.time.time,this._timeNextFrame=this.game.time.time+this.delay,this._frameIndex=this.isReversed?this._frames.length-1:0,this.updateCurrentFrame(!1,!0),this._parent.events.onAnimationStart$dispatch(this._parent,this),this.onStart.dispatch(this._parent,this),this._parent.animations.currentAnim=this,this._parent.animations.currentFrame=this.currentFrame,this},restart:function(){this.isPlaying=!0,this.isFinished=!1,this.paused=!1,this.loopCount=0,this._timeLastFrame=this.game.time.time,this._timeNextFrame=this.game.time.time+this.delay,this._frameIndex=0,this.currentFrame=this._frameData.getFrame(this._frames[this._frameIndex]),this._parent.setFrame(this.currentFrame),this._parent.animations.currentAnim=this,this._parent.animations.currentFrame=this.currentFrame,this.onStart.dispatch(this._parent,this)},reverse:function(){return this.reversed=!this.reversed,this},reverseOnce:function(){return this.onComplete.addOnce(this.reverse,this),this.reverse()},setFrame:function(t,e){var i;if(void 0===e&&(e=!1),"string"==typeof t)for(s=0;s<this._frames.length;s++)this._frameData.getFrame(this._frames[s]).name===t&&(i=s);else if("number"==typeof t)if(e)i=t;else for(var s=0;s<this._frames.length;s++)this._frames[s]===t&&(i=s);if(i){var n=this.isReversed?-1:1;this._frameIndex=i-n,this._timeNextFrame=this.game.time.time,this.update()}},stop:function(t,e){void 0===t&&(t=!1),void 0===e&&(e=!1),this.isPlaying=!1,this.isFinished=!0,this.paused=!1,t&&(this.currentFrame=this._frameData.getFrame(this._frames[0]),this._parent.setFrame(this.currentFrame)),e&&(this._parent.events.onAnimationComplete$dispatch(this._parent,this),this.onComplete.dispatch(this._parent,this))},onPause:function(){this.isPlaying&&(this._frameDiff=this._timeNextFrame-this.game.time.time)},onResume:function(){this.isPlaying&&(this._timeNextFrame=this.game.time.time+this._frameDiff)},update:function(){return!this.isPaused&&(!!(this.isPlaying&&this.game.time.time>=this._timeNextFrame)&&(this._frameSkip=1,this._frameDiff=this.game.time.time-this._timeNextFrame,this._timeLastFrame=this.game.time.time,this._frameDiff>this.delay?(this._frameSkip=Math.floor(this._frameDiff/this.delay),this._frameDiff-=this._frameSkip*this.delay):this._frameDiff=0,this._timeNextFrame=this.game.time.time+(this.delay-this._frameDiff),this.isReversed?this._frameIndex-=this._frameSkip:this._frameIndex+=this._frameSkip,!this.isReversed&&this._frameIndex>=this._frames.length||this.isReversed&&this._frameIndex<=-1?this.loop?(this._frameIndex=Math.abs(this._frameIndex)%this._frames.length,this.isReversed&&(this._frameIndex=this._frames.length-1-this._frameIndex),this.currentFrame=this._frameData.getFrame(this._frames[this._frameIndex]),this.currentFrame&&this._parent.setFrame(this.currentFrame),this.loopCount++,this._parent.events.onAnimationLoop$dispatch(this._parent,this),this.onLoop.dispatch(this._parent,this),!this.onUpdate||(this.onUpdate.dispatch(this,this.currentFrame),!!this._frameData)):(this.complete(),!1):this.updateCurrentFrame(!0)))},updateCurrentFrame:function(t,e){if(void 0===e&&(e=!1),!this._frameData)return!1;var i=this.currentFrame.index;return this.currentFrame=this._frameData.getFrame(this._frames[this._frameIndex]),this.currentFrame&&(e||!e&&i!==this.currentFrame.index)&&this._parent.setFrame(this.currentFrame),!this.onUpdate||!t||(this.onUpdate.dispatch(this,this.currentFrame),!!this._frameData)},next:function(t){void 0===t&&(t=1);var e=this._frameIndex+t;e>=this._frames.length&&(this.loop?e%=this._frames.length:e=this._frames.length-1),e!==this._frameIndex&&(this._frameIndex=e,this.updateCurrentFrame(!0))},previous:function(t){void 0===t&&(t=1);var e=this._frameIndex-t;e<0&&(this.loop?e=this._frames.length+e:e++),e!==this._frameIndex&&(this._frameIndex=e,this.updateCurrentFrame(!0))},updateFrameData:function(t){this._frameData=t,this.currentFrame=this._frameData?this._frameData.getFrame(this._frames[this._frameIndex%this._frames.length]):null},destroy:function(){this._frameData&&(this.game.onPause.remove(this.onPause,this),this.game.onResume.remove(this.onResume,this),this.game=null,this._parent=null,this._frames=null,this._frameData=null,this.currentFrame=null,this.isPlaying=!1,this.onStart.dispose(),this.onLoop.dispose(),this.onComplete.dispose(),this.onUpdate&&this.onUpdate.dispose())},complete:function(){this._frameIndex=this._frames.length-1,this.currentFrame=this._frameData.getFrame(this._frames[this._frameIndex]),this.updateCurrentFrame(!1),this.isPlaying=!1,this.isFinished=!0,this.paused=!1,this._parent.events.onAnimationComplete$dispatch(this._parent,this),this.onComplete.dispatch(this._parent,this),this.killOnComplete&&this._parent.kill()}},e.Animation.prototype.constructor=e.Animation,Object.defineProperty(e.Animation.prototype,"paused",{get:function(){return this.isPaused},set:function(t){this.isPaused=t,t?this._pauseStartTime=this.game.time.time:this.isPlaying&&(this._timeNextFrame=this.game.time.time+this.delay)}}),Object.defineProperty(e.Animation.prototype,"reversed",{get:function(){return this.isReversed},set:function(t){this.isReversed=t}}),Object.defineProperty(e.Animation.prototype,"frameTotal",{get:function(){return this._frames.length}}),Object.defineProperty(e.Animation.prototype,"frame",{get:function(){return null!==this.currentFrame?this.currentFrame.index:this._frameIndex},set:function(t){this.currentFrame=this._frameData.getFrame(this._frames[t]),null!==this.currentFrame&&(this._frameIndex=t,this._parent.setFrame(this.currentFrame),this.onUpdate&&this.onUpdate.dispatch(this,this.currentFrame))}}),Object.defineProperty(e.Animation.prototype,"speed",{get:function(){return 1e3/this.delay},set:function(t){t>0&&(this.delay=1e3/t)}}),Object.defineProperty(e.Animation.prototype,"enableUpdate",{get:function(){return null!==this.onUpdate},set:function(t){t&&null===this.onUpdate?this.onUpdate=new e.Signal:t||null===this.onUpdate||(this.onUpdate.dispose(),this.onUpdate=null)}}),e.Animation.generateFrameNames=function(t,i,s,n,r){void 0===n&&(n="");var o=[],a="";if(i<s)for(h=i;h<=s;h++)a=t+(a="number"==typeof r?e.Utils.pad(h.toString(),r,"0",1):h.toString())+n,o.push(a);else for(var h=i;h>=s;h--)a=t+(a="number"==typeof r?e.Utils.pad(h.toString(),r,"0",1):h.toString())+n,o.push(a);return o},e.Frame=function(t,i,s,n,r,o){this.index=t,this.x=i,this.y=s,this.width=n,this.height=r,0!==this.width&&0!==this.height||console.warn('Phaser.Frame: Frame "'+this.name+'" has a width or height of zero'),this.name=o,this.centerX=Math.floor(n/2),this.centerY=Math.floor(r/2),this.distance=e.Math.distance(0,0,n,r),this.rotated=!1,this.trimmed=!1,this.sourceSizeW=n,this.sourceSizeH=r,this.spriteSourceSizeX=0,this.spriteSourceSizeY=0,this.spriteSourceSizeW=0,this.spriteSourceSizeH=0,this.right=this.x+this.width,this.bottom=this.y+this.height},e.Frame.prototype={resize:function(t,i){this.width=t,this.height=i,this.centerX=Math.floor(t/2),this.centerY=Math.floor(i/2),this.distance=e.Math.distance(0,0,t,i),this.sourceSizeW=t,this.sourceSizeH=i,this.right=this.x+t,this.bottom=this.y+i},setTrim:function(t,e,i,s,n,r,o){this.trimmed=t,t&&(this.sourceSizeW=e,this.sourceSizeH=i,this.centerX=Math.floor(e/2),this.centerY=Math.floor(i/2),this.spriteSourceSizeX=s,this.spriteSourceSizeY=n,this.spriteSourceSizeW=r,this.spriteSourceSizeH=o)},clone:function(){var t=new e.Frame(this.index,this.x,this.y,this.width,this.height,this.name);for(var i in this)this.hasOwnProperty(i)&&(t[i]=this[i]);return t},getRect:function(t){return void 0===t?t=new e.Rectangle(this.x,this.y,this.width,this.height):t.setTo(this.x,this.y,this.width,this.height),t}},e.Frame.prototype.constructor=e.Frame,e.FrameData=function(){this._frames=[],this._frameNames=[]},e.FrameData.prototype={addFrame:function(t){return t.index=this._frames.length,this._frames.push(t),""!==t.name&&(this._frameNames[t.name]=t.index),t},getFrame:function(t){return t>=this._frames.length&&(t=0),this._frames[t]},getFrameByName:function(t){return"number"==typeof this._frameNames[t]?this._frames[this._frameNames[t]]:null},checkFrameName:function(t){return null!=this._frameNames[t]},clone:function(){for(var t=new e.FrameData,i=0;i<this._frames.length;i++)t._frames.push(this._frames[i].clone());for(var s in this._frameNames)this._frameNames.hasOwnProperty(s)&&t._frameNames.push(this._frameNames[s]);return t},getFrameRange:function(t,e,i){void 0===i&&(i=[]);for(var s=t;s<=e;s++)i.push(this._frames[s]);return i},getFrames:function(t,e,i){if(void 0===e&&(e=!0),void 0===i&&(i=[]),void 0===t||0===t.length)for(s=0;s<this._frames.length;s++)i.push(this._frames[s]);else for(var s=0;s<t.length;s++)e?i.push(this.getFrame(t[s])):i.push(this.getFrameByName(t[s]));return i},getFrameIndexes:function(t,e,i){if(void 0===e&&(e=!0),void 0===i&&(i=[]),void 0===t||0===t.length)for(s=0;s<this._frames.length;s++)i.push(this._frames[s].index);else for(var s=0;s<t.length;s++)e&&this._frames[t[s]]?i.push(this._frames[t[s]].index):this.getFrameByName(t[s])&&i.push(this.getFrameByName(t[s]).index);return i},destroy:function(){this._frames=null,this._frameNames=null}},e.FrameData.prototype.constructor=e.FrameData,Object.defineProperty(e.FrameData.prototype,"total",{get:function(){return this._frames.length}}),e.AnimationParser={spriteSheet:function(t,i,s,n,r,o,a,h){void 0===r&&(r=-1),void 0===o&&(o=0),void 0===a&&(a=0),void 0===h&&(h=0);var l=i;if("string"==typeof i?l=t.cache.getImage(i):i=l.name,null===l)return null;if(s<=0||n<=0)return console.warn("Phaser.AnimationParser.spriteSheet: '%s' frameWidth (%s) or frameHeight (%s) must be positive",i,s,n),null;var c=l.width,u=l.height;if(0===c||0===u)return console.warn("Phaser.AnimationParser.spriteSheet: '%s' width (%s) or height (%s) is zero",i,c,u),null;if(c<s||u<n)return console.warn("Phaser.AnimationParser.spriteSheet: '%s' width (%s) or height (%s) is less than the given frameWidth (%s) or frameHeight (%s)",i,c,u,s,n),null;var d=Math.floor((c-o)/(s+a)),p=Math.floor((u-o)/(n+a)),f=d*p,g=f,m=f-1,y=0,v=m;if(h>f||h<-f)return console.warn("Phaser.AnimationParser.spriteSheet: '%s' skipFrames = %s is larger than the frame total %s",i,h,f),null;if(r>-1&&(v=(f=r)-1),d<1&&console.warn("Phaser.AnimationParser.spriteSheet: image '%s' has width %d, but it should be at least %d (frameWidth=%s, margin=%s, spacing=%s)",i,c,s+o+a,s,o,a),p<1&&console.warn("Phaser.AnimationParser.spriteSheet: image '%s' has height %d, but it should be at least %d (frameHeight=%s, margin=%s, spacing=%s)",i,u,n+o+a,n,o,a),0===g)return console.warn("Phaser.AnimationParser.spriteSheet: '%s' zero frames were produced",i),null;if(h>0?v=(y=h)+(f=Math.min(f,g-h))-1:h<0&&(y=(v=m+h)-(f=Math.min(f,g+h))+1),y<0)return console.warn("First frame index %s is outside of range [0, %d]",y,m),null;if(v>m)return console.warn("Last frame index %s is outside of range [0, %d]",v,m),null;for(var x=new e.FrameData,b=o,_=o,w=0,T=0;T<g&&!(T>v);T++)T>=y&&x.addFrame(new e.Frame(w++,b,_,s,n,"")),(b+=s+a)+s>c&&(b=o,_+=n+a);return x},JSONData:function(t,i){if(!i.frames)return console.warn("Phaser.AnimationParser.JSONData: Invalid Texture Atlas JSON given, missing 'frames' array"),void console.log(i);for(var s,n=new e.FrameData,r=i.frames,o=0;o<r.length;o++)s=n.addFrame(new e.Frame(o,r[o].frame.x,r[o].frame.y,r[o].frame.w,r[o].frame.h,r[o].filename)),r[o].trimmed&&s.setTrim(r[o].trimmed,r[o].sourceSize.w,r[o].sourceSize.h,r[o].spriteSourceSize.x,r[o].spriteSourceSize.y,r[o].spriteSourceSize.w,r[o].spriteSourceSize.h),r[o].rotated&&(s.rotated=!0);return n},JSONDataPyxel:function(t,i){if(["layers","tilewidth","tileheight","tileswide","tileshigh"].forEach(function(t){if(!i[t])return console.warn('Phaser.AnimationParser.JSONDataPyxel: Invalid Pyxel Tilemap JSON given, missing "'+t+'" key.'),void console.log(i)}),1!==i.layers.length)return console.warn("Phaser.AnimationParser.JSONDataPyxel: Too many layers, this parser only supports flat Tilemaps."),void console.log(i);for(var s=new e.FrameData,n=i.tileheight,r=i.tilewidth,o=i.layers[0].tiles,a=0;a<o.length;a++)s.addFrame(new e.Frame(a,o[a].x,o[a].y,r,n,"frame_"+a)).setTrim(!1);return s},JSONDataHash:function(t,i){if(!i.frames)return console.warn("Phaser.AnimationParser.JSONDataHash: Invalid Texture Atlas JSON given, missing 'frames' object"),void console.log(i);var s,n=new e.FrameData,r=i.frames,o=0;for(var a in r)s=n.addFrame(new e.Frame(o,r[a].frame.x,r[a].frame.y,r[a].frame.w,r[a].frame.h,a)),r[a].trimmed&&s.setTrim(r[a].trimmed,r[a].sourceSize.w,r[a].sourceSize.h,r[a].spriteSourceSize.x,r[a].spriteSourceSize.y,r[a].spriteSourceSize.w,r[a].spriteSourceSize.h),r[a].rotated&&(s.rotated=!0),o++;return n},XMLData:function(t,i){if(i.getElementsByTagName("TextureAtlas")){for(var s,n,r,o,a,h,l,c,u,d,p,f=new e.FrameData,g=i.getElementsByTagName("SubTexture"),m=0;m<g.length;m++)n=(r=g[m].attributes).name.value,o=parseInt(r.x.value,10),a=parseInt(r.y.value,10),h=parseInt(r.width.value,10),l=parseInt(r.height.value,10),c=null,u=null,r.frameX&&(c=Math.abs(parseInt(r.frameX.value,10)),u=Math.abs(parseInt(r.frameY.value,10)),d=parseInt(r.frameWidth.value,10),p=parseInt(r.frameHeight.value,10)),s=f.addFrame(new e.Frame(m,o,a,h,l,n)),null===c&&null===u||s.setTrim(!0,h,l,c,u,d,p);return f}console.warn("Phaser.AnimationParser.XMLData: Invalid Texture Atlas XML given, missing <TextureAtlas> tag")}},e.Cache=function(t){this.game=t,this.autoResolveURL=!1,this._cache={canvas:{},image:{},texture:{},sound:{},video:{},text:{},json:{},xml:{},physics:{},tilemap:{},binary:{},bitmapData:{},bitmapFont:{},shader:{},renderTexture:{},compressedTexture:{}},this._urlMap={},this._urlResolver=new Image,this._urlTemp=null,this.onSoundUnlock=new e.Signal,this._cacheMap=[],this._cacheMap[e.Cache.CANVAS]=this._cache.canvas,this._cacheMap[e.Cache.IMAGE]=this._cache.image,this._cacheMap[e.Cache.TEXTURE]=this._cache.texture,this._cacheMap[e.Cache.SOUND]=this._cache.sound,this._cacheMap[e.Cache.TEXT]=this._cache.text,this._cacheMap[e.Cache.PHYSICS]=this._cache.physics,this._cacheMap[e.Cache.TILEMAP]=this._cache.tilemap,this._cacheMap[e.Cache.BINARY]=this._cache.binary,this._cacheMap[e.Cache.BITMAPDATA]=this._cache.bitmapData,this._cacheMap[e.Cache.BITMAPFONT]=this._cache.bitmapFont,this._cacheMap[e.Cache.JSON]=this._cache.json,this._cacheMap[e.Cache.XML]=this._cache.xml,this._cacheMap[e.Cache.VIDEO]=this._cache.video,this._cacheMap[e.Cache.SHADER]=this._cache.shader,this._cacheMap[e.Cache.RENDER_TEXTURE]=this._cache.renderTexture,this._pendingCount=0,this.onReady=new e.Signal,this._addImages()},e.Cache.CANVAS=1,e.Cache.IMAGE=2,e.Cache.TEXTURE=3,e.Cache.SOUND=4,e.Cache.TEXT=5,e.Cache.PHYSICS=6,e.Cache.TILEMAP=7,e.Cache.BINARY=8,e.Cache.BITMAPDATA=9,e.Cache.BITMAPFONT=10,e.Cache.JSON=11,e.Cache.XML=12,e.Cache.VIDEO=13,e.Cache.SHADER=14,e.Cache.RENDER_TEXTURE=15,e.Cache.DEFAULT=null,e.Cache.DEFAULT_KEY="__default",e.Cache.DEFAULT_SRC="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgAQMAAABJtOi3AAAAA1BMVEX///+nxBvIAAAAAXRSTlMAQObYZgAAABVJREFUeF7NwIEAAAAAgKD9qdeocAMAoAABm3DkcAAAAABJRU5ErkJggg==",e.Cache.MISSING=null,e.Cache.MISSING_KEY="__missing",e.Cache.MISSING_SRC="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAIAAAD8GO2jAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAJ9JREFUeNq01ssOwyAMRFG46v//Mt1ESmgh+DFmE2GPOBARKb2NVjo+17PXLD8a1+pl5+A+wSgFygymWYHBb0FtsKhJDdZlncG2IzJ4ayoMDv20wTmSMzClEgbWYNTAkQ0Z+OJ+A/eWnAaR9+oxCF4Os0H8htsMUp+pwcgBBiMNnAwF8GqIgL2hAzaGFFgZauDPKABmowZ4GL369/0rwACp2yA/ttmvsQAAAABJRU5ErkJggg==",e.Cache.READY_TIMEOUT=1e3,e.Cache.prototype={addCompressedTextureMetaData:function(t,i,s,n){this.checkImageKey(t)&&this.removeImage(t);var r=s in e.LoaderParser?e.LoaderParser[s](n):n,o={key:t,url:i,data:r,base:new PIXI.BaseTexture(r,null,this.game.resolution),frame:new e.Frame(0,0,0,r.width,r.height,t),frameData:new e.FrameData,fileFormat:s};return o.frameData.addFrame(new e.Frame(0,0,0,r.width,r.height,i)),this._cache.image[t]=o,this._resolveURL(i,o),o},addCanvas:function(t,e,i){void 0===i&&(i=e.getContext("2d")),this._cache.canvas[t]={canvas:e,context:i}},addImage:function(t,i,s){this.checkImageKey(t)&&this.removeImage(t),!1===s.complete&&console.warn('Phaser.Cache.addImage: Image "%s" is not complete',t);var n={key:t,url:i,data:s,base:new PIXI.BaseTexture(s,null,this.game.resolution),frame:new e.Frame(0,0,0,s.width,s.height,t),frameData:new e.FrameData};return n.frameData.addFrame(new e.Frame(0,0,0,s.width,s.height,i)),this._cache.image[t]=n,this._resolveURL(i,n),"__default"===t?e.Cache.DEFAULT=new PIXI.Texture(n.base):"__missing"===t&&(e.Cache.MISSING=new PIXI.Texture(n.base)),n},addImageAsync:function(t,e,i){var s=this,n=new Image;n.onload=function(){i.call(this,s.addImage(t,null,n)),s._removePending(),n.onload=null},this._addPending(),n.src=e},addDefaultImage:function(){this.addImageAsync(e.Cache.DEFAULT_KEY,e.Cache.DEFAULT_SRC,function(t){t.base.skipRender=!0,e.Cache.DEFAULT=new PIXI.Texture(t.base)})},addMissingImage:function(){this.addImageAsync(e.Cache.MISSING_KEY,e.Cache.MISSING_SRC,function(t){e.Cache.MISSING=new PIXI.Texture(t.base)})},addSound:function(t,e,i,s,n){void 0===s&&(s=!0,n=!1),void 0===n&&(s=!1,n=!0);var r=!1;n&&(r=!0),this._cache.sound[t]={url:e,data:i,isDecoding:!1,decoded:r,webAudio:s,audioTag:n,locked:this.game.sound.touchLocked},this._resolveURL(e,this._cache.sound[t])},addText:function(t,e,i){this._cache.text[t]={url:e,data:i},this._resolveURL(e,this._cache.text[t])},addPhysicsData:function(t,e,i,s){this._cache.physics[t]={url:e,data:i,format:s},this._resolveURL(e,this._cache.physics[t])},addTilemap:function(t,e,i,s){this._cache.tilemap[t]={url:e,data:i,format:s},this._resolveURL(e,this._cache.tilemap[t])},addBinary:function(t,e){this._cache.binary[t]=e},addBitmapData:function(t,i,s){return i.key=t,void 0===s&&(s=new e.FrameData).addFrame(i.textureFrame),this._cache.bitmapData[t]={data:i,frameData:s},i},addBitmapFont:function(t,i,s,n,r,o,a){var h={url:i,data:s,font:null,base:new PIXI.BaseTexture(s,null,this.game.resolution)};void 0===o&&(o=0),void 0===a&&(a=0),h.font="json"===r?e.LoaderParser.jsonBitmapFont(n,h.base,o,a,!1,this.game.resolution):e.LoaderParser.xmlBitmapFont(n,h.base,o,a,!1,this.game.resolution),this._cache.bitmapFont[t]=h,this._resolveURL(i,h)},addBitmapFontFromAtlas:function(t,i,s,n,r,o,a){var h=this.getFrameByName(i,s);if(h){var l={font:null,base:this.getBaseTexture(i),frame:h};void 0===o&&(o=0),void 0===a&&(a=0);var c;"json"===r?(c=this.getJSON(n),l.font=e.LoaderParser.jsonBitmapFont(c,l.base,o,a,h,this.game.resolution)):(c=this.getXML(n),l.font=e.LoaderParser.xmlBitmapFont(c,l.base,o,a,h,this.game.resolution)),this._cache.bitmapFont[t]=l}},addJSON:function(t,e,i){this._cache.json[t]={url:e,data:i},this._resolveURL(e,this._cache.json[t])},addXML:function(t,e,i){this._cache.xml[t]={url:e,data:i},this._resolveURL(e,this._cache.xml[t])},addVideo:function(t,e,i,s){this._cache.video[t]={url:e,data:i,isBlob:s,locked:!0},this._resolveURL(e,this._cache.video[t])},addShader:function(t,e,i){this._cache.shader[t]={url:e,data:i},this._resolveURL(e,this._cache.shader[t])},addRenderTexture:function(t,i){this._cache.renderTexture[t]={texture:i,frame:new e.Frame(0,0,0,i.width,i.height,"","")}},addSpriteSheet:function(t,i,s,n,r,o,a,h,l){void 0===o&&(o=-1),void 0===a&&(a=0),void 0===h&&(h=0);var c={key:t,url:i,data:s,frameWidth:n,frameHeight:r,margin:a,spacing:h,base:new PIXI.BaseTexture(s,null,this.game.resolution),frameData:e.AnimationParser.spriteSheet(this.game,s,n,r,o,a,h,l)};this._cache.image[t]=c,this._resolveURL(i,c)},addTextureAtlas:function(t,i,s,n,r){var o={key:t,url:i,data:s,base:new PIXI.BaseTexture(s,null,this.game.resolution)};r===e.Loader.TEXTURE_ATLAS_XML_STARLING?o.frameData=e.AnimationParser.XMLData(this.game,n,t):r===e.Loader.TEXTURE_ATLAS_JSON_PYXEL?o.frameData=e.AnimationParser.JSONDataPyxel(this.game,n,t):Array.isArray(n.frames)?o.frameData=e.AnimationParser.JSONData(this.game,n,t):o.frameData=e.AnimationParser.JSONDataHash(this.game,n,t),this._cache.image[t]=o,this._resolveURL(i,o)},reloadSound:function(t){var e=this,i=this.getSound(t);i&&(i.data.src=i.url,i.data.addEventListener("canplaythrough",function(){return e.reloadSoundComplete(t)},!1),i.data.load())},reloadSoundComplete:function(t){var e=this.getSound(t);e&&(e.locked=!1,this.onSoundUnlock.dispatch(t))},updateSound:function(t,e,i){var s=this.getSound(t);s&&(s[e]=i)},decodedSound:function(t,e){var i=this.getSound(t);i.data=e,i.decoded=!0,i.isDecoding=!1},isSoundDecoded:function(t){var i=this.getItem(t,e.Cache.SOUND,"isSoundDecoded");if(i)return i.decoded},isSoundReady:function(t){var i=this.getItem(t,e.Cache.SOUND,"isSoundDecoded");if(i)return i.decoded&&!this.game.sound.touchLocked},checkKey:function(t,e){return!!this._cacheMap[t][e]},checkURL:function(t){return!!this._urlMap[this._resolveURL(t)]},checkCanvasKey:function(t){return this.checkKey(e.Cache.CANVAS,t)},checkImageKey:function(t){return this.checkKey(e.Cache.IMAGE,t)},checkTextureKey:function(t){return this.checkKey(e.Cache.TEXTURE,t)},checkSoundKey:function(t){return this.checkKey(e.Cache.SOUND,t)},checkTextKey:function(t){return this.checkKey(e.Cache.TEXT,t)},checkPhysicsKey:function(t){return this.checkKey(e.Cache.PHYSICS,t)},checkTilemapKey:function(t){return this.checkKey(e.Cache.TILEMAP,t)},checkBinaryKey:function(t){return this.checkKey(e.Cache.BINARY,t)},checkBitmapDataKey:function(t){return this.checkKey(e.Cache.BITMAPDATA,t)},checkBitmapFontKey:function(t){return this.checkKey(e.Cache.BITMAPFONT,t)},checkJSONKey:function(t){return this.checkKey(e.Cache.JSON,t)},checkXMLKey:function(t){return this.checkKey(e.Cache.XML,t)},checkVideoKey:function(t){return this.checkKey(e.Cache.VIDEO,t)},checkShaderKey:function(t){return this.checkKey(e.Cache.SHADER,t)},checkRenderTextureKey:function(t){return this.checkKey(e.Cache.RENDER_TEXTURE,t)},getItem:function(t,e,i,s){return this.checkKey(e,t)?void 0===s?this._cacheMap[e][t]:this._cacheMap[e][t][s]:(i&&console.warn("Phaser.Cache."+i+': Key "'+t+'" not found in Cache.'),null)},getCanvas:function(t){return this.getItem(t,e.Cache.CANVAS,"getCanvas","canvas")},getImage:function(t,i){void 0!==t&&null!==t||(t="__default"),void 0===i&&(i=!1);var s=this.getItem(t,e.Cache.IMAGE,"getImage");return null===s&&(s=this.getItem("__missing",e.Cache.IMAGE,"getImage")),i?s:s.data},getTextureFrame:function(t){return this.getItem(t,e.Cache.TEXTURE,"getTextureFrame","frame")},getSound:function(t){return this.getItem(t,e.Cache.SOUND,"getSound")},getSoundData:function(t){return this.getItem(t,e.Cache.SOUND,"getSoundData","data")},getText:function(t){return this.getItem(t,e.Cache.TEXT,"getText","data")},getPhysicsData:function(t,i,s){var n=this.getItem(t,e.Cache.PHYSICS,"getPhysicsData","data");if(null===n||void 0===i||null===i)return n;if(n[i]){var r=n[i];if(!r||!s)return r;for(var o in r)if((o=r[o]).fixtureKey===s)return o;console.warn('Phaser.Cache.getPhysicsData: Could not find given fixtureKey: "'+s+" in "+t+'"')}else console.warn('Phaser.Cache.getPhysicsData: Invalid key/object: "'+t+" / "+i+'"');return null},getTilemapData:function(t){return this.getItem(t,e.Cache.TILEMAP,"getTilemapData")},getBinary:function(t){return this.getItem(t,e.Cache.BINARY,"getBinary")},getBitmapData:function(t){return this.getItem(t,e.Cache.BITMAPDATA,"getBitmapData","data")},getBitmapFont:function(t){return this.getItem(t,e.Cache.BITMAPFONT,"getBitmapFont")},getJSON:function(t,i){var s=this.getItem(t,e.Cache.JSON,"getJSON","data");return s?i?e.Utils.extend(!0,Array.isArray(s)?[]:{},s):s:null},getXML:function(t){return this.getItem(t,e.Cache.XML,"getXML","data")},getVideo:function(t){return this.getItem(t,e.Cache.VIDEO,"getVideo")},getShader:function(t){return this.getItem(t,e.Cache.SHADER,"getShader","data")},getRenderTexture:function(t){return this.getItem(t,e.Cache.RENDER_TEXTURE,"getRenderTexture")},getBaseTexture:function(t,i){return void 0===i&&(i=e.Cache.IMAGE),this.getItem(t,i,"getBaseTexture","base")},getFrame:function(t,i){return void 0===i&&(i=e.Cache.IMAGE),this.getItem(t,i,"getFrame","frame")},getFrameCount:function(t,e){var i=this.getFrameData(t,e);return i?i.total:0},getFrameData:function(t,i){return void 0===i&&(i=e.Cache.IMAGE),this.getItem(t,i,"getFrameData","frameData")},hasFrameData:function(t,i){return void 0===i&&(i=e.Cache.IMAGE),null!==this.getItem(t,i,"","frameData")},updateFrameData:function(t,i,s){void 0===s&&(s=e.Cache.IMAGE),this._cacheMap[s][t]&&(this._cacheMap[s][t].frameData=i)},getFrameByIndex:function(t,e,i){var s=this.getFrameData(t,i);return s?s.getFrame(e):null},getFrameByName:function(t,e,i){var s=this.getFrameData(t,i);return s?s.getFrameByName(e):null},getURL:function(t){return(t=this._resolveURL(t))?this._urlMap[t]:(console.warn('Phaser.Cache.getUrl: Invalid url: "'+t+'" or Cache.autoResolveURL was false'),null)},getKeys:function(t){void 0===t&&(t=e.Cache.IMAGE);var i=[];if(this._cacheMap[t])for(var s in this._cacheMap[t])"__default"!==s&&"__missing"!==s&&i.push(s);return i},removeCanvas:function(t){delete this._cache.canvas[t]},removeImage:function(t,e){void 0===e&&(e=!0);var i=this.getImage(t,!0);e&&i.base&&i.base.destroy(),delete this._cache.image[t]},removeSound:function(t){delete this._cache.sound[t]},removeText:function(t){delete this._cache.text[t]},removePhysics:function(t){delete this._cache.physics[t]},removeTilemap:function(t){delete this._cache.tilemap[t]},removeBinary:function(t){delete this._cache.binary[t]},removeBitmapData:function(t){delete this._cache.bitmapData[t]},removeBitmapFont:function(t){delete this._cache.bitmapFont[t]},removeJSON:function(t){delete this._cache.json[t]},removeXML:function(t){delete this._cache.xml[t]},removeVideo:function(t){delete this._cache.video[t]},removeShader:function(t){delete this._cache.shader[t]},removeRenderTexture:function(t){delete this._cache.renderTexture[t]},removeSpriteSheet:function(t){delete this._cache.spriteSheet[t]},removeTextureAtlas:function(t){delete this._cache.image[t]},clearGLTextures:function(){for(var t in this._cache.image)this._cache.image[t].base._glTextures=[]},_resolveURL:function(t,e){return this.autoResolveURL?(this._urlResolver.src=this.game.load.baseURL+t,this._urlTemp=this._urlResolver.src,this._urlResolver.src="",e&&(this._urlMap[this._urlTemp]=e),this._urlTemp):null},destroy:function(){for(var t=0;t<this._cacheMap.length;t++){var e=this._cacheMap[t];for(var i in e)"__default"!==i&&"__missing"!==i&&(this.destroyItem(e[i]),delete e[i])}this._urlMap=null,this._urlResolver=null,this._urlTemp=null},destroyItem:function(t){t.destroy?t.destroy():(t.base&&t.base.destroy&&t.base.destroy(),t.data&&t.data.destroy&&t.data.destroy(),t.frameData&&t.frameData.destroy&&t.frameData.destroy(),t.texture&&t.texture.destroy&&t.texture.destroy(!0))},_addImages:function(){this._pendingCount=0,this.addDefaultImage(),this.addMissingImage();var t=this,i=e.Cache.READY_TIMEOUT;e.Cache.READY_TIMEOUT>0?setTimeout(function(){t.isReady||(console.warn("Phaser.Cache: Still waiting for images after %s ms.",i),t._ready())},e.Cache.READY_TIMEOUT):this._ready()},_addPending:function(){this._pendingCount+=1},_removePending:function(){this._pendingCount-=1,this._checkReady()},_checkReady:function(){this.isReady&&this._ready()},_ready:function(){this._pendingCount=0,this.onReady.dispatch(this)}},e.Cache.prototype.constructor=e.Cache,Object.defineProperty(e.Cache.prototype,"isReady",{get:function(){return this._pendingCount<=0}}),e.Loader=function(t){this.game=t,this.cache=t.cache,this.resetLocked=!1,this.isLoading=!1,this.hasLoaded=!1,this.preloadSprite=null,this.crossOrigin=!1,this.baseURL="",this.path="",this.headers={requestedWith:!1,json:"application/json",xml:"application/xml"},this.onLoadStart=new e.Signal,this.onBeforeLoadComplete=new e.Signal,this.onLoadComplete=new e.Signal,this.onPackComplete=new e.Signal,this.onFileStart=new e.Signal,this.onFileComplete=new e.Signal,this.onFileError=new e.Signal,this.enableParallel=!0,this.maxParallelDownloads=4,this._withSyncPointDepth=0,this._fileList=[],this._flightQueue=[],this._processingHead=0,this._fileLoadStarted=!1,this._totalPackCount=0,this._totalFileCount=0,this._loadedPackCount=0,this._loadedFileCount=0},e.Loader.TEXTURE_ATLAS_JSON_ARRAY=0,e.Loader.TEXTURE_ATLAS_JSON_HASH=1,e.Loader.TEXTURE_ATLAS_XML_STARLING=2,e.Loader.PHYSICS_LIME_CORONA_JSON=3,e.Loader.PHYSICS_PHASER_JSON=4,e.Loader.TEXTURE_ATLAS_JSON_PYXEL=5,e.Loader.prototype={setPreloadSprite:function(t,i){i=i||0,this.preloadSprite={sprite:t,direction:i,width:t.width,height:t.height,rect:null},this.preloadSprite.rect=0===i?new e.Rectangle(0,0,1,t.height):new e.Rectangle(0,0,t.width,1),t.crop(this.preloadSprite.rect),t.visible=!0},resize:function(){this.preloadSprite&&this.preloadSprite.height!==this.preloadSprite.sprite.height&&(this.preloadSprite.rect.height=this.preloadSprite.sprite.height)},checkKeyExists:function(t,e){return this.getAssetIndex(t,e)>-1},getAssetIndex:function(t,e){for(var i=-1,s=0;s<this._fileList.length;s++){var n=this._fileList[s];if(n.type===t&&n.key===e&&(i=s,!n.loaded&&!n.loading))break}return i},getAsset:function(t,e){var i=this.getAssetIndex(t,e);return i>-1&&{index:i,file:this._fileList[i]}},reset:function(t,e){void 0===e&&(e=!1),this.resetLocked||(t&&(this.preloadSprite=null),this.isLoading=!1,this._processingHead=0,this._fileList.length=0,this._flightQueue.length=0,this._fileLoadStarted=!1,this._totalFileCount=0,this._totalPackCount=0,this._loadedPackCount=0,this._loadedFileCount=0,e&&(this.onLoadStart.removeAll(),this.onLoadComplete.removeAll(),this.onPackComplete.removeAll(),this.onFileStart.removeAll(),this.onFileComplete.removeAll(),this.onFileError.removeAll()))},addToFileList:function(t,e,i,s,n,r){if(void 0===n&&(n=!1),void 0===e||""===e)return console.warn("Phaser.Loader: Invalid or no key given of type "+t),this;if(void 0===i||null===i){if(!r)return console.warn("Phaser.Loader: No URL given for file type: "+t+" key: "+e),this;i=e+r}var o={type:t,key:e,path:this.path,url:i,syncPoint:this._withSyncPointDepth>0,data:null,loading:!1,loaded:!1,error:!1};if(s)for(var a in s)o[a]=s[a];var h=this.getAssetIndex(t,e);if(n&&h>-1){var l=this._fileList[h];l.loading||l.loaded?(this._fileList.push(o),this._totalFileCount++):this._fileList[h]=o}else-1===h&&(this._fileList.push(o),this._totalFileCount++);return this},replaceInFileList:function(t,e,i,s){return this.addToFileList(t,e,i,s,!0)},pack:function(t,e,i,s){if(void 0===e&&(e=null),void 0===i&&(i=null),void 0===s&&(s=null),!e&&!i)return console.warn("Phaser.Loader.pack - Both url and data are null. One must be set."),this;var n={type:"packfile",key:t,url:e,path:this.path,syncPoint:!0,data:null,loading:!1,loaded:!1,error:!1,callbackContext:s};i&&("string"==typeof i&&(i=JSON.parse(i)),n.data=i||{},n.loaded=!0);for(var r=0;r<this._fileList.length+1;r++){var o=this._fileList[r];if(!o||!o.loaded&&!o.loading&&"packfile"!==o.type){this._fileList.splice(r,0,n),this._totalPackCount++;break}}return this},image:function(t,e,i){return"object"==typeof e?this.texture(t,e,i):this.addToFileList("image",t,e,void 0,i,".png")},imageFromBitmapData:function(t,e,i){return this.image(t,e.canvas.toDataURL("image/png"),i)},imageFromGrid:function(t,e,i,s,n,r){return this.imageFromBitmapData(t,this.game.create.grid(t,e,i,s,n,r,!1))},imageFromTexture:function(t,e,i,s,n){return this.imageFromBitmapData(t,this.game.create.texture(t,e,i,s,n,!1))},texture:function(t,i,s){if(this.game.renderType===e.WEBGL){var n,r=this.game.renderer.extensions.compression;for(n in i)if(n.toUpperCase()in r)return this.addToFileList("texture",t,i[n],void 0,s,".pvr")}return i.truecolor&&this.addToFileList("image",t,i.truecolor,void 0,s,".png"),this},images:function(t,e){if(Array.isArray(e))for(i=0;i<t.length;i++)this.image(t[i],e[i]);else for(var i=0;i<t.length;i++)this.image(t[i]);return this},text:function(t,e,i){return this.addToFileList("text",t,e,void 0,i,".txt")},json:function(t,e,i){return this.addToFileList("json",t,e,void 0,i,".json")},shader:function(t,e,i){return this.addToFileList("shader",t,e,void 0,i,".frag")},xml:function(t,e,i){return this.addToFileList("xml",t,e,void 0,i,".xml")},script:function(t,e,i,s){return void 0===i&&(i=!1),!1!==i&&void 0===s&&(s=this),this.addToFileList("script",t,e,{syncPoint:!0,callback:i,callbackContext:s},!1,".js")},binary:function(t,e,i,s){return void 0===i&&(i=!1),!1!==i&&void 0===s&&(s=i),this.addToFileList("binary",t,e,{callback:i,callbackContext:s},!1,".bin")},spritesheet:function(t,e,i,s,n,r,o,a){return void 0===n&&(n=-1),void 0===r&&(r=0),void 0===o&&(o=0),void 0===a&&(a=0),this.addToFileList("spritesheet",t,e,{frameWidth:i,frameHeight:s,frameMax:n,margin:r,spacing:o,skipFrames:a},!1,".png")},audio:function(t,e,i){return this.game.sound.noAudio?this:(void 0===i&&(i=!0),"string"==typeof e&&(e=[e]),this.addToFileList("audio",t,e,{buffer:null,autoDecode:i}))},audioSprite:function(t,e,i,s,n){return this.game.sound.noAudio?this:(void 0===i&&(i=null),void 0===s&&(s=null),void 0===n&&(n=!0),this.audio(t,e,n),i?this.json(t+"-audioatlas",i):s?("string"==typeof s&&(s=JSON.parse(s)),this.cache.addJSON(t+"-audioatlas","",s)):console.warn("Phaser.Loader.audiosprite - You must specify either a jsonURL or provide a jsonData object"),this)},audiosprite:function(t,e,i,s,n){return this.audioSprite(t,e,i,s,n)},video:function(t,e,i,s){return void 0===i&&(i=this.game.device.firefox?"loadeddata":"canplaythrough"),void 0===s&&(s=!1),"string"==typeof e&&(e=[e]),this.addToFileList("video",t,e,{buffer:null,asBlob:s,loadEvent:i})},tilemap:function(t,i,s,n){if(void 0===i&&(i=null),void 0===s&&(s=null),void 0===n&&(n=e.Tilemap.CSV),i||s||(i=n===e.Tilemap.CSV?t+".csv":t+".json"),s){switch(n){case e.Tilemap.CSV:break;case e.Tilemap.TILED_JSON:"string"==typeof s&&(s=JSON.parse(s))}this.cache.addTilemap(t,null,s,n)}else this.addToFileList("tilemap",t,i,{format:n});return this},physics:function(t,i,s,n){return void 0===i&&(i=null),void 0===s&&(s=null),void 0===n&&(n=e.Physics.LIME_CORONA_JSON),i||s||(i=t+".json"),s?("string"==typeof s&&(s=JSON.parse(s)),this.cache.addPhysicsData(t,null,s,n)):this.addToFileList("physics",t,i,{format:n}),this},bitmapFont:function(t,e,i,s,n,r){if(void 0!==e&&null!==e||(e=t+".png"),void 0===i&&(i=null),void 0===s&&(s=null),null===i&&null===s&&(i=t+".xml"),void 0===n&&(n=0),void 0===r&&(r=0),i)this.addToFileList("bitmapfont",t,e,{atlasURL:i,xSpacing:n,ySpacing:r});else if("string"==typeof s){var o,a;try{o=JSON.parse(s)}catch(t){a=this.parseXml(s)}if(!a&&!o)throw new Error("Phaser.Loader. Invalid Bitmap Font atlas given");this.addToFileList("bitmapfont",t,e,{atlasURL:null,atlasData:o||a,atlasType:o?"json":"xml",xSpacing:n,ySpacing:r})}return this},atlasJSONArray:function(t,i,s,n){return this.atlas(t,i,s,n,e.Loader.TEXTURE_ATLAS_JSON_ARRAY)},atlasJSONHash:function(t,i,s,n){return this.atlas(t,i,s,n,e.Loader.TEXTURE_ATLAS_JSON_HASH)},atlasXML:function(t,i,s,n){return void 0===s&&(s=null),void 0===n&&(n=null),s||n||(s=t+".xml"),this.atlas(t,i,s,n,e.Loader.TEXTURE_ATLAS_XML_STARLING)},atlas:function(t,i,s,n,r){if(void 0!==i&&null!==i||(i=t+".png"),void 0===s&&(s=null),void 0===n&&(n=null),void 0===r&&(r=e.Loader.TEXTURE_ATLAS_JSON_ARRAY),s||n||(s=r===e.Loader.TEXTURE_ATLAS_XML_STARLING?t+".xml":t+".json"),s)this.addToFileList("textureatlas",t,i,{atlasURL:s,format:r});else{switch(r){case e.Loader.TEXTURE_ATLAS_JSON_ARRAY:"string"==typeof n&&(n=JSON.parse(n));break;case e.Loader.TEXTURE_ATLAS_XML_STARLING:if("string"==typeof n){var o=this.parseXml(n);if(!o)throw new Error("Phaser.Loader. Invalid Texture Atlas XML given");n=o}}this.addToFileList("textureatlas",t,i,{atlasURL:null,atlasData:n,format:r})}return this},withSyncPoint:function(t,e){this._withSyncPointDepth++;try{t.call(e||this,this)}finally{this._withSyncPointDepth--}return this},addSyncPoint:function(t,e){var i=this.getAsset(t,e);return i&&(i.file.syncPoint=!0),this},removeFile:function(t,e){var i=this.getAsset(t,e);i&&(i.loaded||i.loading||this._fileList.splice(i.index,1))},removeAll:function(){this._fileList.length=0,this._flightQueue.length=0},start:function(){this.isLoading||(this.hasLoaded=!1,this.isLoading=!0,this.updateProgress(),this.processLoadQueue())},processLoadQueue:function(){if(!this.isLoading)return console.warn("Phaser.Loader - active loading canceled / reset"),void this.finishedLoading(!0);for(i=0;i<this._flightQueue.length;i++)((s=this._flightQueue[i]).loaded||s.error)&&(this._flightQueue.splice(i,1),i--,s.loading=!1,s.requestUrl=null,s.requestObject=null,s.error&&this.onFileError.dispatch(s.key,s),"packfile"!==s.type?(this._loadedFileCount++,this.onFileComplete.dispatch(this.progress,s.key,!s.error,this._loadedFileCount,this._totalFileCount)):"packfile"===s.type&&s.error&&(this._loadedPackCount++,this.onPackComplete.dispatch(s.key,!s.error,this._loadedPackCount,this._totalPackCount)));for(var t=!1,e=this.enableParallel?Math.max(1,this.maxParallelDownloads):1,i=this._processingHead;i<this._fileList.length;i++){var s=this._fileList[i];if("packfile"===s.type&&!s.error&&s.loaded&&i===this._processingHead&&(this.processPack(s),this._loadedPackCount++,this.onPackComplete.dispatch(s.key,!s.error,this._loadedPackCount,this._totalPackCount)),s.loaded||s.error?i===this._processingHead&&(this._processingHead=i+1):!s.loading&&this._flightQueue.length<e&&("packfile"!==s.type||s.data?t||(this._fileLoadStarted||(this._fileLoadStarted=!0,this.onLoadStart.dispatch()),this._flightQueue.push(s),s.loading=!0,this.onFileStart.dispatch(this.progress,s.key,s.url),this.loadFile(s)):(this._flightQueue.push(s),s.loading=!0,this.loadFile(s))),!s.loaded&&s.syncPoint&&(t=!0),this._flightQueue.length>=e||t&&this._loadedPackCount===this._totalPackCount)break}if(this.updateProgress(),this._processingHead>=this._fileList.length)this.finishedLoading();else if(!this._flightQueue.length){console.warn("Phaser.Loader - aborting: processing queue empty, loading may have stalled");var n=this;setTimeout(function(){n.finishedLoading(!0)},2e3)}},finishedLoading:function(t){this.hasLoaded||(this.hasLoaded=!0,this.isLoading=!1,t||this._fileLoadStarted||(this._fileLoadStarted=!0,this.onLoadStart.dispatch()),this.game.state.loadUpdate(),this.onBeforeLoadComplete.dispatch(),this.reset(),this.onLoadComplete.dispatch(),this.game.state&&this.game.state.loadComplete())},asyncComplete:function(t,e){void 0===e&&(e=""),t.loaded=!0,t.error=!!e,e&&(t.errorMessage=e,console.warn("Phaser.Loader - "+t.type+"["+t.key+"]: "+e)),this.processLoadQueue()},processPack:function(t){var i=t.data[t.key];if(i)for(var s=0;s<i.length;s++){var n=i[s];switch(n.type){case"image":this.image(n.key,n.url,n.overwrite);break;case"text":this.text(n.key,n.url,n.overwrite);break;case"json":this.json(n.key,n.url,n.overwrite);break;case"xml":this.xml(n.key,n.url,n.overwrite);break;case"script":this.script(n.key,n.url,n.callback,t.callbackContext||this);break;case"binary":this.binary(n.key,n.url,n.callback,t.callbackContext||this);break;case"spritesheet":this.spritesheet(n.key,n.url,n.frameWidth,n.frameHeight,n.frameMax,n.margin,n.spacing,n.skipFrames);break;case"video":this.video(n.key,n.urls);break;case"audio":this.audio(n.key,n.urls,n.autoDecode);break;case"audiosprite":this.audiosprite(n.key,n.urls,n.jsonURL,n.jsonData,n.autoDecode);break;case"tilemap":this.tilemap(n.key,n.url,n.data,e.Tilemap[n.format]);break;case"physics":this.physics(n.key,n.url,n.data,e.Loader[n.format]);break;case"bitmapFont":this.bitmapFont(n.key,n.textureURL,n.atlasURL,n.atlasData,n.xSpacing,n.ySpacing);break;case"atlasJSONArray":this.atlasJSONArray(n.key,n.textureURL,n.atlasURL,n.atlasData);break;case"atlasJSONHash":this.atlasJSONHash(n.key,n.textureURL,n.atlasURL,n.atlasData);break;case"atlasXML":this.atlasXML(n.key,n.textureURL,n.atlasURL,n.atlasData);break;case"atlas":this.atlas(n.key,n.textureURL,n.atlasURL,n.atlasData,e.Loader[n.format]);break;case"shader":this.shader(n.key,n.url,n.overwrite)}}else console.warn("Phaser.Loader - "+t.key+": pack has data, but not for pack key")},transformUrl:function(t,e){return!!t&&(t.match(/^(?:blob:|data:|http:\/\/|https:\/\/|\/\/)/)?t:this.baseURL+e.path+t)},loadFile:function(t){switch(t.type){case"packfile":this.xhrLoad(t,this.transformUrl(t.url,t),"text",this.fileComplete);break;case"image":case"spritesheet":case"textureatlas":case"bitmapfont":this.loadImageTag(t);break;case"audio":t.url=this.getAudioURL(t.url),t.url?this.game.sound.usingWebAudio?this.xhrLoad(t,this.transformUrl(t.url,t),"arraybuffer",this.fileComplete):this.game.sound.usingAudioTag&&this.loadAudioTag(t):this.fileError(t,null,"No supported audio URL specified or device does not have audio playback support");break;case"video":t.url=this.getVideoURL(t.url),t.url?t.asBlob?this.xhrLoad(t,this.transformUrl(t.url,t),"blob",this.fileComplete):this.loadVideoTag(t):this.fileError(t,null,"No supported video URL specified or device does not have video playback support");break;case"json":this.xhrLoad(t,this.transformUrl(t.url,t),"text",this.jsonLoadComplete);break;case"xml":this.xhrLoad(t,this.transformUrl(t.url,t),"text",this.xmlLoadComplete);break;case"tilemap":t.format===e.Tilemap.TILED_JSON?this.xhrLoad(t,this.transformUrl(t.url,t),"text",this.jsonLoadComplete):t.format===e.Tilemap.CSV?this.xhrLoad(t,this.transformUrl(t.url,t),"text",this.csvLoadComplete):this.asyncComplete(t,"invalid Tilemap format: "+t.format);break;case"text":case"script":case"shader":case"physics":this.xhrLoad(t,this.transformUrl(t.url,t),"text",this.fileComplete);break;case"texture":"truecolor"===t.key.split("_").pop()?this.loadImageTag(t):this.xhrLoad(t,this.transformUrl(t.url,t),"arraybuffer",this.fileComplete);break;case"binary":this.xhrLoad(t,this.transformUrl(t.url,t),"arraybuffer",this.fileComplete)}},loadImageTag:function(t){var e=this;t.data=new Image,t.data.name=t.key,this.crossOrigin&&(t.data.crossOrigin=this.crossOrigin),t.data.onload=function(){t.data.onload&&(t.data.onload=null,t.data.onerror=null,e.fileComplete(t))},t.data.onerror=function(){t.data.onload&&(t.data.onload=null,t.data.onerror=null,e.fileError(t))},t.data.src=this.transformUrl(t.url,t),!this.game.device.firefox&&t.data.complete&&t.data.width&&t.data.height&&(t.data.onload=null,t.data.onerror=null,this.fileComplete(t))},loadVideoTag:function(t){var i=this;t.data=document.createElement("video"),t.data.name=t.key,t.data.controls=!1,t.data.autoplay=!1;var s=function(){t.data.removeEventListener(t.loadEvent,s,!1),t.data.onerror=null,t.data.canplay=!0,e.GAMES[i.game.id].load.fileComplete(t)};t.data.onerror=function(){t.data.removeEventListener(t.loadEvent,s,!1),t.data.onerror=null,t.data.canplay=!1,i.fileError(t)},t.data.addEventListener(t.loadEvent,s,!1),t.data.src=this.transformUrl(t.url,t),t.data.load()},loadAudioTag:function(t){var e=this;if(this.game.sound.touchLocked)t.data=new Audio,t.data.name=t.key,t.data.preload="auto",t.data.src=this.transformUrl(t.url,t),this.fileComplete(t);else{t.data=new Audio,t.data.name=t.key;var i=function(){t.data.removeEventListener("canplaythrough",i,!1),t.data.onerror=null,e.fileComplete(t)};t.data.onerror=function(){t.data.removeEventListener("canplaythrough",i,!1),t.data.onerror=null,e.fileError(t)},t.data.preload="auto",t.data.src=this.transformUrl(t.url,t),t.data.addEventListener("canplaythrough",i,!1),t.data.load()}},xhrLoad:function(t,e,i,s,n){var r=new XMLHttpRequest;r.open("GET",e,!0),r.responseType=i,!1!==this.headers.requestedWith&&r.setRequestHeader("X-Requested-With",this.headers.requestedWith),this.headers[t.type]&&r.setRequestHeader("Accept",this.headers[t.type]),n=n||this.fileError;var o=this;r.onload=function(){try{return 4===r.readyState&&r.status>=400&&r.status<=599?n.call(o,t,r):s.call(o,t,r)}catch(e){o.hasLoaded?window.console&&console.error(e):o.asyncComplete(t,e.message||"Exception")}},r.onerror=function(){try{return n.call(o,t,r)}catch(e){o.hasLoaded?window.console&&console.error(e):o.asyncComplete(t,e.message||"Exception")}},t.requestObject=r,t.requestUrl=e,r.send()},getVideoURL:function(t){for(var e=0;e<t.length;e++){var i,s=t[e];if(s.uri){if(i=s.type,s=s.uri,this.game.device.canPlayVideo(i))return s}else{if(0===s.indexOf("blob:")||0===s.indexOf("data:"))return s;if(s.indexOf("?")>=0&&(s=s.substr(0,s.indexOf("?"))),i=s.substr((Math.max(0,s.lastIndexOf("."))||1/0)+1).toLowerCase(),this.game.device.canPlayVideo(i))return t[e]}}return null},getAudioURL:function(t){if(this.game.sound.noAudio)return null;for(var e=0;e<t.length;e++){var i,s=t[e];if(s.uri){if(i=s.type,s=s.uri,this.game.device.canPlayAudio(i))return s}else{if(0===s.indexOf("blob:")||0===s.indexOf("data:"))return s;if(s.indexOf("?")>=0&&(s=s.substr(0,s.indexOf("?"))),i=s.substr((Math.max(0,s.lastIndexOf("."))||1/0)+1).toLowerCase(),this.game.device.canPlayAudio(i))return t[e]}}return null},fileError:function(t,e,i){var s="error loading asset from URL "+(t.requestUrl||this.transformUrl(t.url,t));!i&&e&&(i=e.status),i&&(s=s+" ("+i+")"),this.asyncComplete(t,s)},fileComplete:function(t,i){var s=!0;switch(t.type){case"packfile":r=JSON.parse(i.responseText);t.data=r||{};break;case"texture":var n=/\.([^.]+)$/.exec(t.url.split("?",1)[0])[1].toLowerCase();null!==t.data?this.cache.addCompressedTextureMetaData(t.key,t.url,n,t.data):this.cache.addCompressedTextureMetaData(t.key,t.url,n,i.response);break;case"image":this.cache.addImage(t.key,t.url,t.data);break;case"spritesheet":this.cache.addSpriteSheet(t.key,t.url,t.data,t.frameWidth,t.frameHeight,t.frameMax,t.margin,t.spacing,t.skipFrames);break;case"textureatlas":if(null==t.atlasURL)this.cache.addTextureAtlas(t.key,t.url,t.data,t.atlasData,t.format);else if(s=!1,t.format===e.Loader.TEXTURE_ATLAS_JSON_ARRAY||t.format===e.Loader.TEXTURE_ATLAS_JSON_HASH||t.format===e.Loader.TEXTURE_ATLAS_JSON_PYXEL)this.xhrLoad(t,this.transformUrl(t.atlasURL,t),"text",this.jsonLoadComplete);else{if(t.format!==e.Loader.TEXTURE_ATLAS_XML_STARLING)throw new Error("Phaser.Loader. Invalid Texture Atlas format: "+t.format);this.xhrLoad(t,this.transformUrl(t.atlasURL,t),"text",this.xmlLoadComplete)}break;case"bitmapfont":t.atlasURL?(s=!1,this.xhrLoad(t,this.transformUrl(t.atlasURL,t),"text",function(t,e){var i;try{i=JSON.parse(e.responseText)}catch(t){}i?(t.atlasType="json",this.jsonLoadComplete(t,e)):(t.atlasType="xml",this.xmlLoadComplete(t,e))})):this.cache.addBitmapFont(t.key,t.url,t.data,t.atlasData,t.atlasType,t.xSpacing,t.ySpacing);break;case"video":if(t.asBlob)try{t.data=i.response}catch(e){throw new Error("Phaser.Loader. Unable to parse video file as Blob: "+t.key)}this.cache.addVideo(t.key,t.url,t.data,t.asBlob);break;case"audio":this.game.sound.usingWebAudio?(t.data=i.response,this.cache.addSound(t.key,t.url,t.data,!0,!1),t.autoDecode&&this.game.sound.decode(t.key)):this.cache.addSound(t.key,t.url,t.data,!1,!0);break;case"text":t.data=i.responseText,this.cache.addText(t.key,t.url,t.data);break;case"shader":t.data=i.responseText,this.cache.addShader(t.key,t.url,t.data);break;case"physics":var r=JSON.parse(i.responseText);this.cache.addPhysicsData(t.key,t.url,r,t.format);break;case"script":t.data=document.createElement("script"),t.data.language="javascript",t.data.type="text/javascript",t.data.defer=!1,t.data.text=i.responseText,document.head.appendChild(t.data),t.callback&&(t.data=t.callback.call(t.callbackContext,t.key,i.responseText));break;case"binary":t.callback?t.data=t.callback.call(t.callbackContext,t.key,i.response):t.data=i.response,this.cache.addBinary(t.key,t.data)}s&&this.asyncComplete(t)},jsonLoadComplete:function(t,e){var i=JSON.parse(e.responseText);"tilemap"===t.type?this.cache.addTilemap(t.key,t.url,i,t.format):"bitmapfont"===t.type?this.cache.addBitmapFont(t.key,t.url,t.data,i,t.atlasType,t.xSpacing,t.ySpacing):"json"===t.type?this.cache.addJSON(t.key,t.url,i):this.cache.addTextureAtlas(t.key,t.url,t.data,i,t.format),this.asyncComplete(t)},csvLoadComplete:function(t,e){var i=e.responseText;this.cache.addTilemap(t.key,t.url,i,t.format),this.asyncComplete(t)},xmlLoadComplete:function(t,e){var i=e.responseText,s=this.parseXml(i);if(!s){var n=e.responseType||e.contentType;return console.warn("Phaser.Loader - "+t.key+": invalid XML ("+n+")"),void this.asyncComplete(t,"invalid XML")}"bitmapfont"===t.type?this.cache.addBitmapFont(t.key,t.url,t.data,s,t.atlasType,t.xSpacing,t.ySpacing):"textureatlas"===t.type?this.cache.addTextureAtlas(t.key,t.url,t.data,s,t.format):"xml"===t.type&&this.cache.addXML(t.key,t.url,s),this.asyncComplete(t)},parseXml:function(t){var e;try{if(window.DOMParser){var i=new DOMParser;e=i.parseFromString(t,"text/xml")}else(e=new ActiveXObject("Microsoft.XMLDOM")).async="false",e.loadXML(t)}catch(t){e=null}return e&&e.documentElement&&!e.getElementsByTagName("parsererror").length?e:null},updateProgress:function(){this.preloadSprite&&(0===this.preloadSprite.direction?this.preloadSprite.rect.width=Math.floor(this.preloadSprite.width/100*this.progress):this.preloadSprite.rect.height=Math.floor(this.preloadSprite.height/100*this.progress),this.preloadSprite.sprite?this.preloadSprite.sprite.updateCrop():this.preloadSprite=null)},totalLoadedFiles:function(){return this._loadedFileCount},totalQueuedFiles:function(){return this._totalFileCount-this._loadedFileCount},totalLoadedPacks:function(){return this._totalPackCount},totalQueuedPacks:function(){return this._totalPackCount-this._loadedPackCount}},Object.defineProperty(e.Loader.prototype,"progressFloat",{get:function(){var t=this._loadedFileCount/this._totalFileCount*100;return e.Math.clamp(t||0,0,100)}}),Object.defineProperty(e.Loader.prototype,"progress",{get:function(){return Math.round(this.progressFloat)}}),e.Loader.prototype.constructor=e.Loader,e.LoaderParser={bitmapFont:function(t,e,i,s,n,r){return this.xmlBitmapFont(t,e,i,s,n,r)},xmlBitmapFont:function(t,e,i,s,n,r){null==r&&(r=1);var o={},a=t.getElementsByTagName("info")[0],h=t.getElementsByTagName("common")[0];o.font=a.getAttribute("face"),o.size=parseInt(a.getAttribute("size"),10),o.lineHeight=parseInt(h.getAttribute("lineHeight"),10)+s,o.chars={};for(var l=t.getElementsByTagName("char"),c=n?n.x:0,u=n?n.y:0,d=0;d<l.length;d++){var p=parseInt(l[d].getAttribute("id"),10),f=o.chars[p]={x:parseInt(l[d].getAttribute("x"),10),y:parseInt(l[d].getAttribute("y"),10),width:parseInt(l[d].getAttribute("width"),10),height:parseInt(l[d].getAttribute("height"),10),xOffset:parseInt(l[d].getAttribute("xoffset"),10)/r,yOffset:parseInt(l[d].getAttribute("yoffset"),10)/r,xAdvance:(parseInt(l[d].getAttribute("xadvance"),10)+i)/r,kerning:{}};if(n&&n.trimmed){if(f.x+f.width>n.spriteSourceSizeX+n.spriteSourceSizeW&&(f.width-=f.x+f.width-n.spriteSourceSizeX-n.spriteSourceSizeW),f.y+f.height>n.spriteSourceSizeY+n.spriteSourceSizeH&&(f.height-=f.y+f.height-n.spriteSourceSizeY-n.spriteSourceSizeH),f.x<n.spriteSourceSizeX){g=n.spriteSourceSizeX-f.x;f.x=0,f.width-=g,f.xOffset+=g}if(f.y<n.spriteSourceSizeY){var g=n.spriteSourceSizeY-f.y;f.y=0,f.height-=g,f.yOffset+=g}}f.x+=c,f.y+=u}var m=t.getElementsByTagName("kerning");for(d=0;d<m.length;d++){var y=parseInt(m[d].getAttribute("first"),10),v=parseInt(m[d].getAttribute("second"),10),x=parseInt(m[d].getAttribute("amount"),10)/r;o.chars[v]&&(o.chars[v].kerning[y]=x)}return this.finalizeBitmapFont(e,o)},jsonBitmapFont:function(t,e,i,s,n,r){null==r&&(r=1);var o={font:t.font.info._face,size:parseInt(t.font.info._size,10),lineHeight:parseInt(t.font.common._lineHeight,10)+s,chars:{}},a=n?n.x:0,h=n?n.y:0;return t.font.chars.char.forEach(function(t){var e=parseInt(t._id,10),s=o.chars[e]={x:parseInt(t._x,10),y:parseInt(t._y,10),width:parseInt(t._width,10),height:parseInt(t._height,10),xOffset:parseInt(t._xoffset,10)/r,yOffset:parseInt(t._yoffset,10)/r,xAdvance:(parseInt(t._xadvance,10)+i)/r,kerning:{}};if(n&&n.trimmed){if(s.x+s.width>n.spriteSourceSizeX+n.spriteSourceSizeW&&(s.width-=s.x+s.width-n.spriteSourceSizeX-n.spriteSourceSizeW),s.y+s.height>n.spriteSourceSizeY+n.spriteSourceSizeH&&(s.height-=s.y+s.height-n.spriteSourceSizeY-n.spriteSourceSizeH),s.x<n.spriteSourceSizeX){l=n.spriteSourceSizeX-s.x;s.x=0,s.width-=l,s.xOffset+=l}if(s.y<n.spriteSourceSizeY){var l=n.spriteSourceSizeY-s.y;s.y=0,s.height-=l,s.yOffset+=l}}s.x+=a,s.y+=h}),t.font.kernings&&t.font.kernings.kerning&&t.font.kernings.kerning.forEach(function(t){o.chars[t._second]&&(o.chars[t._second].kerning[t._first]=parseInt(t._amount,10)/r)}),this.finalizeBitmapFont(e,o)},finalizeBitmapFont:function(t,i){return Object.keys(i.chars).forEach(function(s){var n=i.chars[s];n.texture=new PIXI.Texture(t,new e.Rectangle(n.x,n.y,n.width,n.height))}),i},pvr:function(t){var e,i=new Uint32Array(t.slice(0,52)),s=new Uint8Array(t),n=null,r=i[3]<<32|i[2],o=0;if(55727696===i[0]&&[0,1,2,3,6,7,9,11].indexOf(r)>=0){switch(r>=0&&r<=3?e="PVRTC":r>=7&&r<=11?e="S3TC":6===r&&(e="ETC1"),r){case 0:o=35841;break;case 1:o=35843;break;case 2:o=35840;break;case 3:o=35842;break;case 6:o=36196;break;case 7:o=33777;break;case 9:o=33778;break;case 11:o=33779;break;default:o=-1}n={complete:!0,fileFormat:"PVR",compressionAlgorithm:e,flags:i[1],pixelFormat:r,colorSpace:i[4],channelType:i[5],height:i[6],width:i[7],depth:i[8],numberOfSurfaces:i[9],numberOfFaces:i[10],numberOfMipmaps:i[11],metaDataSize:i[12],textureData:s.subarray(52+i[12],s.byteLength),glExtensionFormat:o}}return n},dds:function(t){var e=new Uint8Array(t),i=new Uint32Array(t),s=null;return 68===e[0]&&68===e[1]&&83===e[2]&&32===e[3]&&("DX10"===(s={complete:!0,fileFormat:"DDS",compressionAlgorithm:"S3TC",size:i[1],flags:i[2],height:i[3],width:i[4],pitch:i[5],depth:i[6],mipmapCount:i[7],formatSize:i[19],formatFlag:i[19],formatFourCC:[String.fromCharCode(e[84]),String.fromCharCode(e[85]),String.fromCharCode(e[86]),String.fromCharCode(e[87])].join(""),formatBitCount:i[21],formatRBitMask:i[22],formatGBitMask:i[23],formatBBitMask:i[24],formatABitMask:i[25],caps1:i[26],caps2:i[27],caps3:i[28],caps4:i[29],reserved2:i[30],DXGIFormat:null,resourceDimension:null,miscFlag:null,arraySize:null,textureData:e.subarray(i[1]+4,e.byteLength)}).formatFourCC?(s.DXGIFormat=i[31],s.resourceDimension=i[32],s.miscFlag=i[33],s.arraySize=i[34],s.miscFlag=i[35]):"DXT5"===s.formatFourCC?s.glExtensionFormat=33779:"DXT3"===s.formatFourCC&&(s.glExtensionFormat=33778)),s},ktx:function(t){var e=new Uint8Array(t),i=new Uint32Array(t),s=null,n=16+i[15]/4|0,r=i[n],o=i[7],a=0;if(171===e[0]&&75===e[1]&&84===e[2]&&88===e[3]&&32===e[4]&&49===e[5]&&49===e[6]&&187===e[7]&&13===e[8]&&10===e[9]&&26===e[10]&&10===e[11]&&[36196,35840,35841,35842,35843,33776,33777,33778,33779].indexOf(o)>=0){switch(o){case 36196:a="ETC1";break;case 35840:case 35841:case 35842:case 35843:a="PVRTC";break;case 33776:case 33777:case 33778:case 33779:a="S3TC"}s={complete:!0,fileFormat:"KTX",compressionAlgorithm:a,endianness:i[3],glType:i[4],glTypeSize:i[5],glFormat:i[6],glInternalFormat:i[7],glBaseInternalFormat:i[8],width:i[9],height:i[10],pixelDepth:i[11],numberOfArrayElements:i[12],numberOfFaces:i[13],numberOfMipmapLevels:i[14],bytesOfKeyValueData:i[15],keyAndValueByteSize:i[16],imageSize:r,textureData:e.subarray(4*(n+1),r+100)}}return s},pkm:function(t){var e=new Uint8Array(t),i=null;return 80===e[0]&&75===e[1]&&77===e[2]&&32===e[3]&&(i={complete:!0,fileFormat:"PKM",compressionAlgorithm:"ETC1",format:65535&(e[6]<<8|e[7]),width:65535&(e[8]<<8|e[9]),height:65535&(e[10]<<8|e[11]),originalWidth:65535&(e[12]<<8|e[13]),originalHeight:65535&(e[14]<<8|e[15]),textureData:e.subarray(16,e.length)}),i}},e.AudioSprite=function(t,e){this.game=t,this.key=e,this.config=this.game.cache.getJSON(e+"-audioatlas"),this.autoplayKey=null,this.autoplay=!1,this.sounds={};for(var i in this.config.spritemap){var s=this.config.spritemap[i],n=this.game.add.sound(this.key);n.addMarker(i,s.start,s.end-s.start,null,s.loop),this.sounds[i]=n}this.config.autoplay&&(this.autoplayKey=this.config.autoplay,this.play(this.autoplayKey),this.autoplay=this.sounds[this.autoplayKey])},e.AudioSprite.prototype={play:function(t,e){return void 0===e&&(e=1),this.sounds[t].play(t,null,e)},stop:function(t){if(t)this.sounds[t].stop();else for(var e in this.sounds)this.sounds[e].stop()},get:function(t){return this.sounds[t]}},e.AudioSprite.prototype.constructor=e.AudioSprite,e.Sound=function(t,i,s,n,r){void 0===s&&(s=1),void 0===n&&(n=!1),void 0===r&&(r=t.sound.connectToMaster),this.game=t,this.name=i,this.key=i,this.loop=n,this.markers={},this.context=null,this.autoplay=!1,this.totalDuration=0,this.startTime=0,this.currentTime=0,this.duration=0,this.durationMS=0,this.position=0,this.stopTime=0,this.paused=!1,this.pausedPosition=0,this.pausedTime=0,this.isPlaying=!1,this.currentMarker="",this.fadeTween=null,this.pendingPlayback=!1,this.override=!1,this.allowMultiple=!1,this.playOnce=!1,this.usingWebAudio=this.game.sound.usingWebAudio,this.usingAudioTag=this.game.sound.usingAudioTag,this.externalNode=null,this.masterGainNode=null,this.gainNode=null,this._sound=null,this._globalVolume=1,this._markedToDelete=!1,this._removeFromSoundManager=!1,this._sourceId=0,this.usingWebAudio?(this.context=this.game.sound.context,this.masterGainNode=this.game.sound.masterGain,void 0===this.context.createGain?this.gainNode=this.context.createGainNode():this.gainNode=this.context.createGain(),this.gainNode.gain.value=s,r&&this.gainNode.connect(this.masterGainNode)):this.usingAudioTag&&(this.game.cache.getSound(i)&&this.game.cache.isSoundReady(i)?(this._sound=this.game.cache.getSoundData(i),this.totalDuration=0,this._sound.duration&&(this.totalDuration=this._sound.duration)):this.game.cache.onSoundUnlock.add(this.soundHasUnlocked,this)),this.onDecoded=new e.Signal,this.onPlay=new e.Signal,this.onPause=new e.Signal,this.onResume=new e.Signal,this.onLoop=new e.Signal,this.onStop=new e.Signal,this.onMute=new e.Signal,this.onMarkerComplete=new e.Signal,this.onFadeComplete=new e.Signal,this._volume=s,this._buffer=null,this._muted=!1,this._tempMarker=0,this._tempPosition=0,this._tempVolume=0,this._tempPause=0,this._muteVolume=0,this._tempLoop=0,this._paused=!1,this._onDecodedEventDispatched=!1},e.Sound.prototype={soundHasUnlocked:function(t){t===this.key&&(this._sound=this.game.cache.getSoundData(this.key),this.totalDuration=this._sound.duration)},addMarker:function(t,e,i,s,n){void 0!==i&&null!==i||(i=1),void 0!==s&&null!==s||(s=1),void 0===n&&(n=!1),this.markers[t]={name:t,start:e,stop:e+i,volume:s,duration:i,durationMS:1e3*i,loop:n}},removeMarker:function(t){delete this.markers[t]},onEndedHandler:function(){this._removeOnEndedHandler(),this.isPlaying=!1,this.currentTime=this.durationMS,this.stop(),this.playOnce&&(this._markedToDelete=!0,this._removeFromSoundManager=!0),this._markedToDelete&&(this._disconnectSource(),this._removeFromSoundManager?this.game.sound.remove(this):(this.markers={},this.context=null,this._buffer=null,this.externalNode=null,this.onDecoded.dispose(),this.onPlay.dispose(),this.onPause.dispose(),this.onResume.dispose(),this.onLoop.dispose(),this.onStop.dispose(),this.onMute.dispose(),this.onMarkerComplete.dispose()))},update:function(){this.game.cache.checkSoundKey(this.key)?(this.isDecoded&&!this._onDecodedEventDispatched&&(this.onDecoded.dispatch(this),this._onDecodedEventDispatched=!0),this.pendingPlayback&&this.game.cache.isSoundReady(this.key)&&(this.pendingPlayback=!1,this.play(this._tempMarker,this._tempPosition,this._tempVolume,this._tempLoop)),this.isPlaying&&(this.currentTime=this.game.time.time-this.startTime,this.currentTime>=this.durationMS&&(this.usingWebAudio?this.loop?(this.onLoop.dispatch(this),this.isPlaying=!1,""===this.currentMarker?(this.currentTime=0,this.startTime=this.game.time.time,this.isPlaying=!0):(this.onMarkerComplete.dispatch(this.currentMarker,this),this.play(this.currentMarker,0,this.volume,!0,!0))):""!==this.currentMarker&&this.stop():this.loop?(this.onLoop.dispatch(this),""===this.currentMarker&&(this.currentTime=0,this.startTime=this.game.time.time),this.isPlaying=!1,this.play(this.currentMarker,0,this.volume,!0,!0)):this.stop()))):this.destroy()},loopFull:function(t){return this.play(null,0,t,!0)},play:function(t,e,i,s,n){if(void 0!==t&&!1!==t&&null!==t||(t=""),void 0===n&&(n=!0),this.isPlaying&&!this.allowMultiple&&!n&&!this.override)return this;if(this._sound&&this.isPlaying&&!this.allowMultiple&&(this.override||n)&&(this.usingWebAudio?this._stopSourceAndDisconnect():this.usingAudioTag&&(this._sound.pause(),this._sound.currentTime=0),this.isPlaying=!1),""===t&&Object.keys(this.markers).length>0)return this;if(""!==t){if(!this.markers[t])return console.warn("Phaser.Sound.play: audio marker "+t+" doesn't exist"),this;this.currentMarker=t,this.position=this.markers[t].start,this.volume=this.markers[t].volume,this.loop=this.markers[t].loop,this.duration=this.markers[t].duration,this.durationMS=this.markers[t].durationMS,void 0!==i&&(this.volume=i),void 0!==s&&(this.loop=s),this._tempMarker=t,this._tempPosition=this.position,this._tempVolume=this.volume,this._tempLoop=this.loop}else e=e||0,void 0===i&&(i=this._volume),void 0===s&&(s=this.loop),this.position=Math.max(0,e),this.volume=i,this.loop=s,this.duration=0,this.durationMS=0,this._tempMarker=t,this._tempPosition=e,this._tempVolume=i,this._tempLoop=s;return this.usingWebAudio?this.game.cache.isSoundDecoded(this.key)?(this._createSourceAndConnect(),this.loop&&""===t&&(this._sound.loop=!0),this.loop||""!==t||this._addOnEndedHandler(),this.totalDuration=this._sound.buffer.duration,0===this.duration&&(this.duration=this.totalDuration,this.durationMS=Math.ceil(1e3*this.totalDuration)),this.loop&&""===t?this._startSource(0,0):this._startSource(0,this.position,this.duration),this.isPlaying=!0,this.paused=!1,this.startTime=this.game.time.time,this.currentTime=0,this.stopTime=this.startTime+this.durationMS,this.onPlay.dispatch(this)):(this.pendingPlayback=!0,this.game.cache.getSound(this.key)&&!1===this.game.cache.getSound(this.key).isDecoding&&this.game.sound.decode(this.key,this)):this.game.cache.getSound(this.key)&&this.game.cache.getSound(this.key).locked?(this.game.cache.reloadSound(this.key),this.pendingPlayback=!0):this._sound&&(this.game.device.cocoonJS||4===this._sound.readyState)?(this._sound.play(),this._sound.loop=this.loop,this.totalDuration=this._sound.duration,0===this.duration&&(this.duration=this.totalDuration,this.durationMS=1e3*this.totalDuration),this._globalVolume=this.game.sound.volume,this._sound.currentTime=this.position,this._sound.muted=this._muted,this._muted||this.game.sound.mute?this._sound.volume=0:this._sound.volume=this._volume*this._globalVolume,this.isPlaying=!0,this.paused=!1,this.startTime=this.game.time.time,this.currentTime=0,this.stopTime=this.startTime+this.durationMS,this.onPlay.dispatch(this)):this.pendingPlayback=!0,this.playOnce&&(this.loop&&console.warn("Phaser.Sound.play: audio clip "+this.name+" cannot be deleted while looping."),this._markedToDelete=!0,this._removeFromSoundManager=!0),this},restart:function(t,e,i,s){t=t||"",e=e||0,i=i||1,void 0===s&&(s=!1),this.play(t,e,i,s,!0)},pause:function(){this.isPlaying&&(this.paused=!0,this.pausedPosition=this.currentTime,this.pausedTime=this.game.time.time,this._tempPause=this._sound.currentTime,this.onPause.dispatch(this),this.stop())},resume:function(){if(this.paused){if(this.usingWebAudio){var t=Math.max(0,this.position+this.pausedPosition/1e3);this._createSourceAndConnect(),""===this.currentMarker&&(this.loop?this._sound.loop=!0:this._addOnEndedHandler());var e=this.duration-this.pausedPosition/1e3;this.loop&&""===this.currentMarker?this._startSource(0,t):this._startSource(0,t,e)}else this._sound.currentTime=this._tempPause,this._sound.play();this.isPlaying=!0,this.paused=!1,this.startTime+=this.game.time.time-this.pausedTime,this.onResume.dispatch(this)}},stop:function(){if(this.isPlaying&&this._sound&&(this.usingWebAudio?this._stopSourceAndDisconnect():this.usingAudioTag&&(this._sound.pause(),this._sound.currentTime=0)),this.pendingPlayback=!1,this.isPlaying=!1,!this.paused){var t=this.currentMarker;""!==this.currentMarker&&this.onMarkerComplete.dispatch(this.currentMarker,this),this.currentMarker="",null!==this.fadeTween&&this.fadeTween.stop(),this.onStop.dispatch(this,t)}},fadeIn:function(t,e,i){void 0===e&&(e=!1),void 0===i&&(i=this.currentMarker),this.paused||(this.play(i,0,0,e),this.fadeTo(t,1))},fadeOut:function(t){this.fadeTo(t,0)},fadeTo:function(t,i){this.isPlaying&&!this.paused&&i!==this.volume&&(void 0===t&&(t=1e3),void 0!==i?(this.fadeTween=this.game.add.tween(this).to({volume:i},t,e.Easing.Linear.None,!0),this.fadeTween.onComplete.add(this.fadeComplete,this)):console.warn("Phaser.Sound.fadeTo: No Volume Specified."))},fadeComplete:function(){this.onFadeComplete.dispatch(this,this.volume),0===this.volume&&this.stop()},updateGlobalVolume:function(t){this.usingAudioTag&&this._sound&&(this._globalVolume=t,this._sound.volume=this._globalVolume*this._volume)},destroy:function(t){void 0===t&&(t=!0),this._markedToDelete=!0,this._removeFromSoundManager=t,this.stop(),t?this.game.sound.remove(this):(this.markers={},this.context=null,this._buffer=null,this.externalNode=null,this.onDecoded.dispose(),this.onPlay.dispose(),this.onPause.dispose(),this.onResume.dispose(),this.onLoop.dispose(),this.onStop.dispose(),this.onMute.dispose(),this.onMarkerComplete.dispose())},_createSourceAndConnect:function(){this._sound=this.context.createBufferSource(),this._sound.connect(this.externalNode||this.gainNode),this._buffer=this.game.cache.getSoundData(this.key),this._sound.buffer=this._buffer,this._sourceId++},_disconnectSource:function(){this._sound.disconnect(this.externalNode||this.gainNode)},_startSource:function(t,e,i){this._sound.start(t||0,e||0,i)},_stopSourceAndDisconnect:function(){this._removeOnEndedHandler();try{this._sound.stop(0)}catch(t){}this._disconnectSource(),this._sound=null},_addOnEndedHandler:function(){this._sound.onended=this.onEndedHandler.bind(this)},_removeOnEndedHandler:function(){this._sound.onended=null}},e.Sound.prototype.constructor=e.Sound,Object.defineProperty(e.Sound.prototype,"isDecoding",{get:function(){return this.game.cache.getSound(this.key).isDecoding}}),Object.defineProperty(e.Sound.prototype,"isDecoded",{get:function(){return this.game.cache.isSoundDecoded(this.key)}}),Object.defineProperty(e.Sound.prototype,"mute",{get:function(){return this._muted||this.game.sound.mute},set:function(t){(t=t||!1)!==this._muted&&(t?(this._muted=!0,this._muteVolume=this._tempVolume,this.usingWebAudio?this.gainNode.gain.value=0:this.usingAudioTag&&this._sound&&(this._sound.volume=0)):(this._muted=!1,this.usingWebAudio?this.gainNode.gain.value=this._muteVolume:this.usingAudioTag&&this._sound&&(this._sound.volume=this._muteVolume)),this.onMute.dispatch(this))}}),Object.defineProperty(e.Sound.prototype,"volume",{get:function(){return this._volume},set:function(t){this.usingAudioTag&&(t=this.game.math.clamp(t,0,1)),this._muted?this._muteVolume=t:(this._tempVolume=t,this._volume=t,this.usingWebAudio?this.gainNode.gain.value=t:this.usingAudioTag&&this._sound&&(this._sound.volume=this._globalVolume*t))}}),Object.defineProperty(e.Sound.prototype,"sourceId",{get:function(){return this._sound?this._sourceId:null}}),e.SoundManager=function(t){this.game=t,this.onSoundDecode=new e.Signal,this.onVolumeChange=new e.Signal,this.onMute=new e.Signal,this.onUnMute=new e.Signal,this.onTouchUnlock=new e.Signal,this.context=null,this.baseLatency=null,this.usingWebAudio=!1,this.usingAudioTag=!1,this.noAudio=!1,this.connectToMaster=!0,this.touchLocked=!1,this.channels=32,this.muteOnPause=!0,this._codeMuted=!1,this._muted=!1,this._unlockSource=null,this._volume=1,this._sounds=[],this._watchList=new e.ArraySet,this._watching=!1,this._watchCallback=null,this._watchContext=null,this._resumeWebAudioOnClick=this._resumeWebAudioOnClick.bind(this)},e.SoundManager.prototype={boot:function(){var t=this.game.device,e=window.PhaserGlobal;if(t.iOS&&!1===t.webAudio&&(this.channels=1),e){if(!0===e.disableAudio)return this.noAudio=!0,void(this.touchLocked=!1);if(!0===e.disableWebAudio)return this.usingAudioTag=!0,void(this.touchLocked=!1)}if(e&&e.audioContext)this.context=e.audioContext;else{var i=window.AudioContext||window.webkitAudioContext;if(i)try{this.context=new i}catch(t){this.context=null,this.usingWebAudio=!1,this.touchLocked=!1,console.warn(t)}}if(null===this.context){if(void 0===window.Audio)return void(this.noAudio=!0);this.usingAudioTag=!0}else this.usingWebAudio=!0,this.baseLatency=this.context.baseLatency||256/(this.context.sampleRate||44100),void 0===this.context.createGain?this.masterGain=this.context.createGainNode():this.masterGain=this.context.createGain(),this.masterGain.gain.value=1,this.masterGain.connect(this.context.destination),"suspended"===this.context.state&&this.game.canvas.addEventListener("click",this._resumeWebAudioOnClick);this.noAudio||t.needsTouchUnlock()&&this.setTouchLock(),this.usingWebAudio&&t.chrome&&t.chromeVersion<=65&&console.log('A "GainNode.gain.value setter smoothing is deprecated" notice in Chrome is normal. <https://github.com/photonstorm/phaser-ce/issues/385>')},setTouchLock:function(){this.noAudio||window.PhaserGlobal&&!0===window.PhaserGlobal.disableAudio||(this.game.input.addTouchLockCallback(this.unlock,this,!0),this.touchLocked=!0)},setTouchUnlock:function(){this.touchLocked=!1,this._unlockSource=null,this.onTouchUnlock.dispatch()},resumeWebAudio:function(){if(this.usingWebAudio&&"suspended"===this.context.state)return this.context.resume()},unlock:function(){if(this.noAudio||!this.touchLocked||null!==this._unlockSource)return!0;if(this.usingAudioTag)this.setTouchUnlock();else if(this.usingWebAudio){var t=this.context.createBuffer(1,1,22050);this._unlockSource=this.context.createBufferSource(),this._unlockSource.buffer=t,this._unlockSource.connect(this.context.destination);var e=this;this._unlockSource.onended=function(){e.setTouchUnlock(),e.resumeWebAudio()},void 0===this._unlockSource.start?this._unlockSource.noteOn(0):this._unlockSource.start(0),this.resumeWebAudio()}return!0},stopAll:function(){if(!this.noAudio)for(var t=0;t<this._sounds.length;t++)this._sounds[t]&&this._sounds[t].stop()},pauseAll:function(){if(!this.noAudio)for(var t=0;t<this._sounds.length;t++)this._sounds[t]&&this._sounds[t].pause()},resumeAll:function(){if(!this.noAudio)for(var t=0;t<this._sounds.length;t++)this._sounds[t]&&this._sounds[t].resume()},decode:function(t,e){e=e||null;var i=this.game.cache.getSoundData(t);if(i&&!1===this.game.cache.isSoundDecoded(t)){this.game.cache.updateSound(t,"isDecoding",!0);var s=this;try{this.context.decodeAudioData(i,function(i){i&&(s.game.cache.decodedSound(t,i),s.onSoundDecode.dispatch(t,e))})}catch(t){}}},setDecodedCallback:function(t,i,s){"string"==typeof t&&(t=[t]),this._watchList.reset();for(var n=0;n<t.length;n++)t[n]instanceof e.Sound?this.game.cache.isSoundDecoded(t[n].key)||this._watchList.add(t[n].key):this.game.cache.isSoundDecoded(t[n])||this._watchList.add(t[n]);0===this._watchList.total?(this._watching=!1,i.call(s)):(this._watching=!0,this._watchCallback=i,this._watchContext=s)},update:function(){if(!this.noAudio){for(var t=0;t<this._sounds.length;t++)this._sounds[t].update();if(this._watching){for(var e=this._watchList.first;e;)this.game.cache.isSoundDecoded(e)&&this._watchList.remove(e),e=this._watchList.next;0===this._watchList.total&&(this._watching=!1,this._watchCallback.call(this._watchContext))}}},add:function(t,i,s,n){void 0===i&&(i=1),void 0===s&&(s=!1),void 0===n&&(n=this.connectToMaster);var r=new e.Sound(this.game,t,i,s,n);return this._sounds.push(r),r},addSprite:function(t){return new e.AudioSprite(this.game,t)},remove:function(t){for(var e=this._sounds.length;e--;)if(this._sounds[e]===t)return this._sounds[e].destroy(!1),this._sounds.splice(e,1),!0;return!1},removeAll:function(){this.stopAll();for(var t=0;t<this._sounds.length;t++)this._sounds[t]&&this._sounds[t].destroy();this._sounds.length=0},removeByKey:function(t){for(var e=this._sounds.length,i=0;e--;)this._sounds[e].key===t&&(this._sounds[e].destroy(!1),this._sounds.splice(e,1),i++);return i},play:function(t,e,i){if(!this.noAudio){var s=this.add(t,e,i);return s.play(),s}},setMute:function(){if(!this._muted){this._muted=!0,this.usingWebAudio&&(this._muteVolume=this.masterGain.gain.value,this.masterGain.gain.value=0);for(var t=0;t<this._sounds.length;t++)this._sounds[t].usingAudioTag&&(this._sounds[t].mute=!0);this.onMute.dispatch()}},unsetMute:function(){if(this._muted&&!this._codeMuted){this._muted=!1,this.usingWebAudio&&(this.masterGain.gain.value=this._muteVolume);for(var t=0;t<this._sounds.length;t++)this._sounds[t].usingAudioTag&&(this._sounds[t].mute=!1);this.onUnMute.dispatch()}},destroy:function(){this.removeAll(),this.onSoundDecode.dispose(),this.game.canvas.removeEventListener("click",this._resumeWebAudioOnClick),this.context&&(window.PhaserGlobal?window.PhaserGlobal.audioContext=this.context:this.context.close&&this.context.close())},_resumeWebAudioOnClick:function(){this.resumeWebAudio(),this.game.canvas.removeEventListener("click",this._resumeWebAudioOnClick)}},e.SoundManager.prototype.constructor=e.SoundManager,Object.defineProperty(e.SoundManager.prototype,"mute",{get:function(){return this._muted},set:function(t){if(t=t||!1){if(this._muted)return;this._codeMuted=!0,this.setMute()}else{if(!this._muted)return;this._codeMuted=!1,this.unsetMute()}}}),Object.defineProperty(e.SoundManager.prototype,"volume",{get:function(){return this._volume},set:function(t){if(t<0?t=0:t>1&&(t=1),this._volume!==t){if(this._volume=t,this.usingWebAudio)this.masterGain.gain.value=t;else for(var e=0;e<this._sounds.length;e++)this._sounds[e].usingAudioTag&&this._sounds[e].updateGlobalVolume(t);this.onVolumeChange.dispatch(t)}}}),e.ScaleManager=function(t,i,s){this.game=t,this.dom=e.DOM,this.grid=null,this.width=0,this.height=0,this.minWidth=null,this.maxWidth=null,this.minHeight=null,this.maxHeight=null,this.offset=new e.Point,this.forceLandscape=!1,this.forcePortrait=!1,this.incorrectOrientation=!1,this._pageAlignHorizontally=!1,this._pageAlignVertically=!1,this.onOrientationChange=new e.Signal,this.enterIncorrectOrientation=new e.Signal,this.leaveIncorrectOrientation=new e.Signal,this.hasPhaserSetFullScreen=!1,this.fullScreenTarget=null,this._createdFullScreenTarget=null,this.onFullScreenInit=new e.Signal,this.onFullScreenChange=new e.Signal,this.onFullScreenError=new e.Signal,this.screenOrientation=this.dom.getScreenOrientation(),this.scaleFactor=new e.Point(1,1),this.scaleFactorInversed=new e.Point(1,1),this.margin={left:0,top:0,right:0,bottom:0,x:0,y:0},this.bounds=new e.Rectangle,this.aspectRatio=0,this.sourceAspectRatio=0,this.event=null,this.windowConstraints={right:"layout",bottom:""},this.compatibility={supportsFullScreen:!1,orientationFallback:null,noMargins:!1,scrollTo:null,forceMinimumDocumentHeight:!1,canExpandParent:!0,clickTrampoline:""},this._scaleMode=e.ScaleManager.NO_SCALE,this._fullScreenScaleMode=e.ScaleManager.NO_SCALE,this.parentIsWindow=!1,this.parentNode=null,this.parentScaleFactor=new e.Point(1,1),this.trackParentInterval=2e3,this.onSizeChange=new e.Signal,this.onResize=null,this.onResizeContext=null,this._pendingScaleMode=null,this._fullScreenRestore=null,this._gameSize=new e.Rectangle,this._userScaleFactor=new e.Point(1,1),this._userScaleTrim=new e.Point(0,0),this._lastUpdate=0,this._updateThrottle=0,this._updateThrottleReset=100,this._parentBounds=new e.Rectangle,this._tempBounds=new e.Rectangle,this._lastReportedCanvasSize=new e.Rectangle,this._lastReportedGameSize=new e.Rectangle,this._booted=!1,t.config&&this.parseConfig(t.config),this.setupScale(i,s)},e.ScaleManager.EXACT_FIT=0,e.ScaleManager.NO_SCALE=1,e.ScaleManager.SHOW_ALL=2,e.ScaleManager.RESIZE=3,e.ScaleManager.USER_SCALE=4,e.ScaleManager.MODES=["EXACT_FIT","NO_SCALE","SHOW_ALL","RESIZE","USER_SCALE"],e.ScaleManager.prototype={boot:function(){var t=this.compatibility;t.supportsFullScreen=this.game.device.fullscreen&&!this.game.device.cocoonJS,this.game.device.iPad||this.game.device.webApp||this.game.device.desktop||(this.game.device.android&&!this.game.device.chrome?t.scrollTo=new e.Point(0,1):t.scrollTo=new e.Point(0,0)),this.game.device.desktop?(t.orientationFallback="screen",t.clickTrampoline="when-not-mouse"):(t.orientationFallback="",t.clickTrampoline="");var i=this;this._orientationChange=function(t){return i.orientationChange(t)},this._windowResize=function(t){return i.windowResize(t)},window.addEventListener("orientationchange",this._orientationChange,!1),window.addEventListener("resize",this._windowResize,!1),this.compatibility.supportsFullScreen&&(this._fullScreenChange=function(t){return i.fullScreenChange(t)},this._fullScreenError=function(t){return i.fullScreenError(t)},document.addEventListener("webkitfullscreenchange",this._fullScreenChange,!1),document.addEventListener("mozfullscreenchange",this._fullScreenChange,!1),document.addEventListener("MSFullscreenChange",this._fullScreenChange,!1),document.addEventListener("fullscreenchange",this._fullScreenChange,!1),document.addEventListener("webkitfullscreenerror",this._fullScreenError,!1),document.addEventListener("mozfullscreenerror",this._fullScreenError,!1),document.addEventListener("MSFullscreenError",this._fullScreenError,!1),document.addEventListener("fullscreenerror",this._fullScreenError,!1)),this.game.onResume.add(this._gameResumed,this),this.dom.getOffset(this.game.canvas,this.offset),this.bounds.setTo(this.offset.x,this.offset.y,this.width,this.height),this.setGameSize(this.game.width,this.game.height),this.screenOrientation=this.dom.getScreenOrientation(this.compatibility.orientationFallback),e.FlexGrid&&(this.grid=new e.FlexGrid(this,this.width,this.height)),this._booted=!0,null!==this._pendingScaleMode&&(this.scaleMode=this._pendingScaleMode,this._pendingScaleMode=null)},parseConfig:function(t){void 0!==t.scaleMode&&(this._booted?this.scaleMode=t.scaleMode:this._pendingScaleMode=t.scaleMode),void 0!==t.fullScreenScaleMode&&(this.fullScreenScaleMode=t.fullScreenScaleMode),t.fullScreenTarget&&(this.fullScreenTarget=t.fullScreenTarget),this.pageAlignHorizontally=t.alignH||!1,this.pageAlignVertically=t.alignV||!1,t.scaleH&&t.scaleV&&this.setUserScale(t.scaleH,t.scaleV,t.trimH,t.trimV)},setupScale:function(t,i){var s,n=new e.Rectangle;""!==this.game.parent&&("string"==typeof this.game.parent?s=document.getElementById(this.game.parent):this.game.parent&&1===this.game.parent.nodeType&&(s=this.game.parent)),s?(this.parentNode=s,this.parentIsWindow=!1,this.getParentBounds(this._parentBounds,this.parentNode),n.width=this._parentBounds.width,n.height=this._parentBounds.height,this.offset.set(this._parentBounds.x,this._parentBounds.y)):(this.parentNode=null,this.parentIsWindow=!0,n.width=this.dom.visualBounds.width,n.height=this.dom.visualBounds.height,this.offset.set(0,0));var r=0,o=0;"number"==typeof t?r=t:(this.parentScaleFactor.x=parseInt(t,10)/100,r=n.width*this.parentScaleFactor.x),"number"==typeof i?o=i:(this.parentScaleFactor.y=parseInt(i,10)/100,o=n.height*this.parentScaleFactor.y),r=Math.floor(r),o=Math.floor(o),this._gameSize.setTo(0,0,r,o),this.updateDimensions(r,o,!1)},_gameResumed:function(){this.queueUpdate(!0)},setGameSize:function(t,i){this._gameSize.setTo(0,0,t,i),this.currentScaleMode!==e.ScaleManager.RESIZE&&this.updateDimensions(t,i,!0),this.queueUpdate(!0)},setUserScale:function(t,e,i,s,n,r){this._userScaleFactor.setTo(t,e),this._userScaleTrim.setTo(0|i,0|s),void 0===n&&(n=!0),void 0===r&&(r=!0),n&&this.queueUpdate(r)},setResizeCallback:function(t,e){this.onResize=t,this.onResizeContext=e},signalSizeChange:function(){if(!e.Rectangle.sameDimensions(this,this._lastReportedCanvasSize)||!e.Rectangle.sameDimensions(this.game,this._lastReportedGameSize)){var t=this.width,i=this.height;this._lastReportedCanvasSize.setTo(0,0,t,i),this._lastReportedGameSize.setTo(0,0,this.game.width,this.game.height),this.grid&&this.grid.onResize(t,i),this.onSizeChange.dispatch(this,t,i),this.currentScaleMode===e.ScaleManager.RESIZE&&(this.game.state.resize(t,i),this.game.load.resize(t,i))}},setMinMax:function(t,e,i,s){this.minWidth=t,this.minHeight=e,void 0!==i&&(this.maxWidth=i),void 0!==s&&(this.maxHeight=s)},preUpdate:function(){if(!(this.game.time.time<this._lastUpdate+this._updateThrottle)){var t=this._updateThrottle;this._updateThrottleReset=t>=400?0:100,this.dom.getOffset(this.game.canvas,this.offset);var i=this._parentBounds.width,s=this._parentBounds.height,n=this.getParentBounds(this._parentBounds),r=n.width!==i||n.height!==s,o=this.updateOrientationState();(r||o)&&(this.onResize&&this.onResize.call(this.onResizeContext,this,n),this.updateLayout(),this.signalSizeChange());var a=2*this._updateThrottle;this._updateThrottle<t&&(a=Math.min(t,this._updateThrottleReset)),this._updateThrottle=e.Math.clamp(a,25,this.trackParentInterval),this._lastUpdate=this.game.time.time}},pauseUpdate:function(){this.preUpdate(),this._updateThrottle=this.trackParentInterval},updateDimensions:function(t,e,i){this.width=t*this.parentScaleFactor.x,this.height=e*this.parentScaleFactor.y,this.game.width=this.width,this.game.height=this.height,this.sourceAspectRatio=this.width/this.height,this.updateScalingAndBounds(),i&&(this.game.renderer.resize(this.width,this.height),this.game.camera.setSize(this.width,this.height),this.game.world.resize(this.width,this.height))},updateScalingAndBounds:function(){this.scaleFactor.x=this.game.width/this.width,this.scaleFactor.y=this.game.height/this.height,this.scaleFactorInversed.x=this.width/this.game.width,this.scaleFactorInversed.y=this.height/this.game.height,this.aspectRatio=this.width/this.height,this.game.canvas&&this.dom.getOffset(this.game.canvas,this.offset),this.bounds.setTo(this.offset.x,this.offset.y,this.width,this.height),this.game.input&&this.game.input.scale&&this.game.input.scale.setTo(this.scaleFactor.x,this.scaleFactor.y)},forceOrientation:function(t,e){void 0===e&&(e=!1),!0!==t||!0!==e?(this.forceLandscape=t,this.forcePortrait=e,this.queueUpdate(!0)):console.warn("Phaser.ScaleManager: forceLandscape and forcePortrait cannot both be true.")},classifyOrientation:function(t){return"portrait-primary"===t||"portrait-secondary"===t?"portrait":"landscape-primary"===t||"landscape-secondary"===t?"landscape":null},updateOrientationState:function(){var t=this.screenOrientation,e=this.incorrectOrientation;this.screenOrientation=this.dom.getScreenOrientation(this.compatibility.orientationFallback),this.incorrectOrientation=this.forceLandscape&&!this.isLandscape||this.forcePortrait&&!this.isPortrait;var i=t!==this.screenOrientation,s=e!==this.incorrectOrientation;return s&&(this.incorrectOrientation?this.enterIncorrectOrientation.dispatch():this.leaveIncorrectOrientation.dispatch()),(i||s)&&this.onOrientationChange.dispatch(this,t,e),i||s},orientationChange:function(t){this.event=t,this.queueUpdate(!0)},windowResize:function(t){this.event=t,this.queueUpdate(!0)},scrollTop:function(){var t=this.compatibility.scrollTo;t&&window.scrollTo(t.x,t.y)},refresh:function(){this.scrollTop(),this.queueUpdate(!0)},updateLayout:function(){var t=this.currentScaleMode;if(t!==e.ScaleManager.RESIZE){if(this.scrollTop(),this.compatibility.forceMinimumDocumentHeight&&(document.documentElement.style.minHeight=window.innerHeight+"px"),this.incorrectOrientation?this.setMaximum():t===e.ScaleManager.EXACT_FIT?this.setExactFit():t===e.ScaleManager.SHOW_ALL?!this.isFullScreen&&this.boundingParent&&this.compatibility.canExpandParent?(this.setShowAll(!0),this.resetCanvas(),this.setShowAll()):this.setShowAll():t===e.ScaleManager.NO_SCALE?(this.width=this.game.width,this.height=this.game.height):t===e.ScaleManager.USER_SCALE&&(this.width=this.game.width*this._userScaleFactor.x-this._userScaleTrim.x,this.height=this.game.height*this._userScaleFactor.y-this._userScaleTrim.y),!this.compatibility.canExpandParent&&(t===e.ScaleManager.SHOW_ALL||t===e.ScaleManager.USER_SCALE)){var i=this.getParentBounds(this._tempBounds);this.width=Math.min(this.width,i.width),this.height=Math.min(this.height,i.height)}this.width=0|this.width,this.height=0|this.height,this.reflowCanvas()}else this.reflowGame()},getParentBounds:function(t,i){var s=t||new e.Rectangle,n=i||this.boundingParent,r=this.dom.visualBounds,o=this.dom.layoutBounds;if(n){var a=n.getBoundingClientRect(),h=n.offsetParent?n.offsetParent.getBoundingClientRect():n.getBoundingClientRect();s.setTo(a.left-h.left,a.top-h.top,a.width,a.height);var l=this.windowConstraints;if(l.right){c="layout"===l.right?o:r;s.right=Math.min(s.right,c.width)}if(l.bottom){var c="layout"===l.bottom?o:r;s.bottom=Math.min(s.bottom,c.height)}}else s.setTo(0,0,r.width,r.height);return s.setTo(Math.round(s.x),Math.round(s.y),Math.round(s.width),Math.round(s.height)),s},align:function(t,e){null!=t&&(this.pageAlignHorizontally=t),null!=e&&(this.pageAlignVertically=e)},alignCanvas:function(t,e){var i=this.getParentBounds(this._tempBounds),s=this.game.canvas,n=this.margin;if(t){n.left=n.right=0;h=s.getBoundingClientRect();if(this.width<i.width&&!this.incorrectOrientation){var r=h.left-i.x,o=i.width/2-this.width/2,a=(o=Math.max(o,0))-r;n.left=Math.round(a)}s.style.marginLeft=n.left+"px",0!==n.left&&(n.right=-(i.width-h.width-n.left),s.style.marginRight=n.right+"px")}if(e){n.top=n.bottom=0;var h=s.getBoundingClientRect();if(this.height<i.height&&!this.incorrectOrientation){var r=h.top-i.y,o=i.height/2-this.height/2,a=(o=Math.max(o,0))-r;n.top=Math.round(a)}s.style.marginTop=n.top+"px",0!==n.top&&(n.bottom=-(i.height-h.height-n.top),s.style.marginBottom=n.bottom+"px")}n.x=n.left,n.y=n.top},reflowGame:function(){this.resetCanvas("","");var t=this.getParentBounds(this._tempBounds);this.updateDimensions(t.width,t.height,!0)},reflowCanvas:function(){this.incorrectOrientation||(this.width=e.Math.clamp(this.width,this.minWidth||0,this.maxWidth||this.width),this.height=e.Math.clamp(this.height,this.minHeight||0,this.maxHeight||this.height)),this.resetCanvas(),this.compatibility.noMargins||(this.isFullScreen&&this._createdFullScreenTarget?this.alignCanvas(!0,!0):this.alignCanvas(this.pageAlignHorizontally,this.pageAlignVertically)),this.updateScalingAndBounds()},resetCanvas:function(t,e){void 0===t&&(t=this.width+"px"),void 0===e&&(e=this.height+"px");var i=this.game.canvas;this.compatibility.noMargins||(i.style.marginLeft="",i.style.marginTop="",i.style.marginRight="",i.style.marginBottom=""),i.style.width=t,i.style.height=e},queueUpdate:function(t){t&&(this._parentBounds.width=0,this._parentBounds.height=0),this._updateThrottle=this._updateThrottleReset},reset:function(t){t&&this.grid&&this.grid.reset()},setMaximum:function(){this.width=this.dom.visualBounds.width,this.height=this.dom.visualBounds.height},setShowAll:function(t){var e,i=this.getParentBounds(this._tempBounds),s=i.width,n=i.height;e=t?Math.max(n/this.game.height,s/this.game.width):Math.min(n/this.game.height,s/this.game.width),this.width=Math.round(this.game.width*e),this.height=Math.round(this.game.height*e)},setExactFit:function(){var t=this.getParentBounds(this._tempBounds);this.width=t.width,this.height=t.height,this.isFullScreen||(this.maxWidth&&(this.width=Math.min(this.width,this.maxWidth)),this.maxHeight&&(this.height=Math.min(this.height,this.maxHeight)))},createFullScreenTarget:function(){var t=document.createElement("div");return t.style.margin="0",t.style.padding="0",t.style.background="#000",t},startFullScreen:function(t,i){if(this.isFullScreen)return!1;{if(this.compatibility.supportsFullScreen){if("when-not-mouse"===this.compatibility.clickTrampoline){var s=this.game.input;if(s.activePointer&&s.activePointer!==s.mousePointer&&(i||!1!==i))return void s.activePointer.addClickTrampoline("startFullScreen",this.startFullScreen,this,[t,!1])}void 0!==t&&this.game.renderType===e.CANVAS&&(this.game.stage.smoothed=t);var n=this.fullScreenTarget;n||(this.cleanupCreatedTarget(),this._createdFullScreenTarget=this.createFullScreenTarget(),n=this._createdFullScreenTarget);var r={targetElement:n};if(this.hasPhaserSetFullScreen=!0,this.onFullScreenInit.dispatch(this,r),this._createdFullScreenTarget){var o=this.game.canvas;o.parentNode.insertBefore(n,o),n.appendChild(o)}return this.game.device.fullscreenKeyboard?n[this.game.device.requestFullscreen](Element.ALLOW_KEYBOARD_INPUT):n[this.game.device.requestFullscreen](),!0}var a=this;setTimeout(function(){a.fullScreenError()},10)}},stopFullScreen:function(){return!(!this.isFullScreen||!this.compatibility.supportsFullScreen)&&(this.hasPhaserSetFullScreen=!1,document[this.game.device.cancelFullscreen](),!0)},cleanupCreatedTarget:function(){var t=this._createdFullScreenTarget;if(t&&t.parentNode){var e=t.parentNode;e.insertBefore(this.game.canvas,t),e.removeChild(t)}this._createdFullScreenTarget=null},prepScreenMode:function(t){var i=!!this._createdFullScreenTarget,s=this._createdFullScreenTarget||this.fullScreenTarget;t?(i||this.fullScreenScaleMode===e.ScaleManager.EXACT_FIT)&&s!==this.game.canvas&&(this._fullScreenRestore={targetWidth:s.style.width,targetHeight:s.style.height},s.style.width="100%",s.style.height="100%"):(this._fullScreenRestore&&(s.style.width=this._fullScreenRestore.targetWidth,s.style.height=this._fullScreenRestore.targetHeight,this._fullScreenRestore=null),this.updateDimensions(this._gameSize.width,this._gameSize.height,!0),this.resetCanvas())},fullScreenChange:function(t){this.event=t,this.isFullScreen?(this.prepScreenMode(!0),this.updateLayout(),this.queueUpdate(!0)):(this.prepScreenMode(!1),this.cleanupCreatedTarget(),this.updateLayout(),this.queueUpdate(!0)),this.onFullScreenChange.dispatch(this,this.width,this.height)},fullScreenError:function(t){this.event=t,this.cleanupCreatedTarget(),console.warn("Phaser.ScaleManager: requestFullscreen failed or device does not support the Fullscreen API"),this.onFullScreenError.dispatch(this)},scaleSprite:function(t,e,i,s){if(void 0===e&&(e=this.width),void 0===i&&(i=this.height),void 0===s&&(s=!1),!t||!t.scale)return t;if(t.scale.x=1,t.scale.y=1,t.width<=0||t.height<=0||e<=0||i<=0)return t;var n=e,r=t.height*e/t.width,o=t.width*i/t.height,a=i,h=o>e;return(h=h?s:!s)?(t.width=Math.floor(n),t.height=Math.floor(r)):(t.width=Math.floor(o),t.height=Math.floor(a)),t},destroy:function(){this.game.onResume.remove(this._gameResumed,this),window.removeEventListener("orientationchange",this._orientationChange,!1),window.removeEventListener("resize",this._windowResize,!1),this.compatibility.supportsFullScreen&&(document.removeEventListener("webkitfullscreenchange",this._fullScreenChange,!1),document.removeEventListener("mozfullscreenchange",this._fullScreenChange,!1),document.removeEventListener("MSFullscreenChange",this._fullScreenChange,!1),document.removeEventListener("fullscreenchange",this._fullScreenChange,!1),document.removeEventListener("webkitfullscreenerror",this._fullScreenError,!1),document.removeEventListener("mozfullscreenerror",this._fullScreenError,!1),document.removeEventListener("MSFullscreenError",this._fullScreenError,!1),document.removeEventListener("fullscreenerror",this._fullScreenError,!1))}},e.ScaleManager.prototype.constructor=e.ScaleManager,Object.defineProperty(e.ScaleManager.prototype,"boundingParent",{get:function(){return this.parentIsWindow||this.isFullScreen&&this.hasPhaserSetFullScreen&&!this._createdFullScreenTarget?null:this.game.canvas&&this.game.canvas.parentNode||null}}),Object.defineProperty(e.ScaleManager.prototype,"scaleMode",{get:function(){return this._scaleMode},set:function(t){return t!==this._scaleMode&&(this.isFullScreen||(this.updateDimensions(this._gameSize.width,this._gameSize.height,!0),this.queueUpdate(!0)),this._scaleMode=t),this._scaleMode}}),Object.defineProperty(e.ScaleManager.prototype,"fullScreenScaleMode",{get:function(){return this._fullScreenScaleMode},set:function(t){return t!==this._fullScreenScaleMode&&(this.isFullScreen?(this.prepScreenMode(!1),this._fullScreenScaleMode=t,this.prepScreenMode(!0),this.queueUpdate(!0)):this._fullScreenScaleMode=t),this._fullScreenScaleMode}}),Object.defineProperty(e.ScaleManager.prototype,"currentScaleMode",{get:function(){return this.isFullScreen?this._fullScreenScaleMode:this._scaleMode}}),Object.defineProperty(e.ScaleManager.prototype,"pageAlignHorizontally",{get:function(){return this._pageAlignHorizontally},set:function(t){t!==this._pageAlignHorizontally&&(this._pageAlignHorizontally=t,this.queueUpdate(!0))}}),Object.defineProperty(e.ScaleManager.prototype,"pageAlignVertically",{get:function(){return this._pageAlignVertically},set:function(t){t!==this._pageAlignVertically&&(this._pageAlignVertically=t,this.queueUpdate(!0))}}),Object.defineProperty(e.ScaleManager.prototype,"isFullScreen",{get:function(){return!!(document.fullscreenElement||document.webkitFullscreenElement||document.mozFullScreenElement||document.msFullscreenElement)}}),Object.defineProperty(e.ScaleManager.prototype,"isPortrait",{get:function(){return"portrait"===this.classifyOrientation(this.screenOrientation)}}),Object.defineProperty(e.ScaleManager.prototype,"isLandscape",{get:function(){return"landscape"===this.classifyOrientation(this.screenOrientation)}}),Object.defineProperty(e.ScaleManager.prototype,"isGamePortrait",{get:function(){return this.height>this.width}}),Object.defineProperty(e.ScaleManager.prototype,"isGameLandscape",{get:function(){return this.width>this.height}}),e.Utils.Debug=function(t){this.game=t,this.sprite=null,this.bmd=null,this.canvas=null,this.context=null,this.font="14px monospace",this.columnWidth=100,this.lineHeight=16,this.lineWidth=1,this.renderShadow=!0,this.currentColor=null,this.currentX=0,this.currentY=0,this.currentAlpha=1,this.dirty=!1,this.isDisabled=!1,this._line=null,this._rect=null},e.Utils.Debug.GEOM_AUTO=0,e.Utils.Debug.GEOM_RECTANGLE=1,e.Utils.Debug.GEOM_CIRCLE=2,e.Utils.Debug.GEOM_POINT=3,e.Utils.Debug.GEOM_LINE=4,e.Utils.Debug.GEOM_ELLIPSE=5,e.Utils.Debug.prototype={boot:function(){this.game.renderType===e.CANVAS?this.context=this.game.context:(this.bmd=new e.BitmapData(this.game,"__DEBUG",this.game.width,this.game.height,!0),this.sprite=this.game.make.image(0,0,this.bmd),this.game.stage.addChild(this.sprite),this.game.scale.onSizeChange.add(this.resize,this),this.canvas=e.CanvasPool.create(this,this.game.width,this.game.height),this.context=this.canvas.getContext("2d")),this._line=new e.Line,this._rect=new e.Rectangle},resize:function(){this.bmd.resize(this.game.width,this.game.height),this.canvas.width=this.game.width,this.canvas.height=this.game.height},preUpdate:function(){this.dirty&&this.sprite&&(this.bmd.clear(),this.bmd.draw(this.canvas,0,0),this.context.clearRect(0,0,this.game.width,this.game.height),this.dirty=!1)},reset:function(){this.context&&this.context.clearRect(0,0,this.game.width,this.game.height),this.sprite&&this.bmd.clear()},start:function(t,e,i,s){"number"!=typeof t&&(t=0),"number"!=typeof e&&(e=0),i=i||"rgb(255,255,255)",void 0===s&&(s=0),this.currentX=t,this.currentY=e,this.currentColor=i,this.columnWidth=s,this.dirty=!0,this.context.save(),this.context.setTransform(1,0,0,1,0,0),this.context.strokeStyle=i,this.context.fillStyle=i,this.context.font=this.font,this.context.globalAlpha=this.currentAlpha},stop:function(){this.context.restore()},line:function(){for(var t=this.currentX,e=0;e<arguments.length;e++)this.renderShadow&&(this.context.fillStyle="rgb(0,0,0)",this.context.fillText(arguments[e],t+1,this.currentY+1),this.context.fillStyle=this.currentColor),this.context.fillText(arguments[e],t,this.currentY),t+=this.columnWidth;this.currentY+=this.lineHeight},sound:function(t,e,i){var s=this.game.sound;this.start(t,e,i),s.noAudio?this.line("Audio is disabled"):(this.line("Volume: "+s.volume.toFixed(2)+(s.mute?" (Mute)":"")),this.line("Mute on pause: "+s.muteOnPause),this.line("Using: "+(s.usingWebAudio?"Web Audio - "+s.context.state:"Audio Tag")),this.line("Touch locked: "+s.touchLocked),this.line("Sounds: "+s._sounds.length)),this.stop()},soundInfo:function(t,e,i,s){this.start(e,i,s),this.line("Sound: "+t.key+"  Touch locked: "+t.game.sound.touchLocked),this.line("Is Ready?: "+this.game.cache.isSoundReady(t.key)+"  Pending Playback: "+t.pendingPlayback),this.line("Decoded: "+t.isDecoded+"  Decoding: "+t.isDecoding),this.line("Playing: "+t.isPlaying+"  Loop: "+t.loop),this.line("Time: "+(t.currentTime/1e3).toFixed(3)+"s  Total: "+t.totalDuration.toFixed(3)+"s"),this.line("Volume: "+t.volume.toFixed(2)+(t.mute?" (Mute)":"")),this.line("Using: "+(t.usingWebAudio?"Web Audio":"Audio Tag")+"  "+(t.usingWebAudio?"Source: "+(t.sourceId||"none"):"")),""!==t.currentMarker&&(this.line("Marker: "+t.currentMarker+"  Duration: "+t.duration.toFixed(3)+"s ("+t.durationMS+"ms)"),this.line("Start: "+t.markers[t.currentMarker].start+"  Stop: "+t.markers[t.currentMarker].stop),this.line("Position: "+t.position)),this.stop()},camera:function(t,e,i){var s=t.deadzone,n=t.target,r=t.view;s&&(this._rect.setTo(r.x+s.x,r.y+s.y,s.width,s.height),this.rectangle(this._rect,e,i)),n&&(this._line.setTo(r.centerX,r.centerY,n.x,n.y),this.geom(this._line,e,i),this.geom(n,e,!1,3))},cameraInfo:function(t,e,i,s){var n=t.bounds,r=t.deadzone,o=t.target,a=t.view;this.start(e,i,s),this.line("Camera ("+t.width+" x "+t.height+")"),this.line("x: "+t.x+" y: "+t.y),this.line("Bounds: "+(n?"x: "+n.x+" y: "+n.y+" w: "+n.width+" h: "+n.height:"none")),this.line("View: x: "+a.x+" y: "+a.y+" w: "+a.width+" h: "+a.height),this.line("Center: x: "+t.centerX+" y: "+t.centerY),this.line("Deadzone: "+(r?"x: "+r.x+" y: "+r.y+" w: "+r.width+" h: "+r.height:r)),this.line("Total in view: "+t.totalInView),this.line("At limit: x: "+t.atLimit.x+" y: "+t.atLimit.y),this.line("Target: "+(o?o.name||o:"none")),this.stop()},timer:function(t,e,i,s){this.start(e,i,s),this.line("Timer (running: "+t.running+" expired: "+t.expired+")"),this.line("Next Tick: "+t.next+" Duration: "+t.duration),this.line("Paused: "+t.paused+" Length: "+t.length),this.stop()},pointer:function(t,e,i,s,n,r){if(null!=t&&(void 0===e&&(e=!1),i=i||"rgba(0,255,0,0.5)",s=s||"rgba(255,255,0,0.5)",r=r||"rgba(255,0,0,0.5)",!0!==e||!0!==t.isUp)){this.start(t.x,t.y-150,n),this.context.beginPath(),this.context.arc(t.x,t.y,t.circle.radius,0,2*Math.PI),t.active?this.context.fillStyle=t.isDown?i:s:this.context.fillStyle=r,this.context.fill(),this.context.closePath(),this.context.beginPath(),this.context.moveTo(t.positionDown.x,t.positionDown.y),this.context.lineTo(t.position.x,t.position.y),this.context.lineWidth=2,this.context.stroke(),this.context.closePath();var o=t.movementX,a=t.movementY;(o||a)&&(this.context.beginPath(),this.context.moveTo(o+t.position.x,a+t.position.y),this.context.lineTo(t.position.x,t.position.y),this.context.lineWidth=2,this.context.stroke(),this.context.closePath()),this.line("ID: "+t.id+" Active: "+t.active),this.line("World X: "+t.worldX.toFixed(1)+" World Y: "+t.worldY.toFixed(1)),this.line("Screen X: "+t.x.toFixed(1)+" Screen Y: "+t.y.toFixed(1)+" In: "+t.withinGame),this.line("Movement: X: "+o+" Y: "+a),this.line("Duration: "+t.duration+" ms"),this.line("is Down: "+t.isDown+" is Up: "+t.isUp),t.isMouse&&this.line("Buttons: "+this._pointerButtonIcon(t.leftButton)+" "+this._pointerButtonIcon(t.middleButton)+" "+this._pointerButtonIcon(t.rightButton)),this.stop()}},_pointerButtonIcon:function(t){return t.isDown?"x":t.isUp?"o":"-"},spriteInputInfo:function(t,e,i,s){this.start(e,i,s),this.line("Sprite Input: ("+t.width+" x "+t.height+")"),this.line("x: "+t.input.pointerX().toFixed(1)+" y: "+t.input.pointerY().toFixed(1)),this.line("over: "+t.input.pointerOver()+" duration: "+t.input.overDuration().toFixed(0)),this.line("down: "+t.input.pointerDown()+" duration: "+t.input.downDuration().toFixed(0)),this.line("just over: "+t.input.justOver()+" just out: "+t.input.justOut()),this.stop()},key:function(t,e,i,s){this.start(e,i,s,150),this.line("Key:",t.keyCode,"isDown:",t.isDown),this.line("justDown:",t.justDown,"justUp:",t.justUp),this.line("Time Down:",t.timeDown.toFixed(0),"duration:",t.duration.toFixed(0)),this.stop()},inputInfo:function(t,i,s,n){var r=this.game.input;if(void 0===n&&(n=!0),this.start(t,i,s),this.line("Input"),this.line("X: "+r.x+" Y: "+r.y),this.line("World X: "+r.worldX+" World Y: "+r.worldY),this.line("Scale X: "+r.scale.x.toFixed(2)+" Scale Y: "+r.scale.x.toFixed(2)),this.line("Screen X: "+r.activePointer.screenX.toFixed(1)+" Screen Y: "+r.activePointer.screenY.toFixed(1)),n){this.line("Sources:"),this.line("  "+this._inputHandler(r.mouse,"mouse")),this.line("  "+this._inputHandler(r.mspointer,"mspointer")),this.line("  "+this._inputHandler(r.touch,"touch"));var o=r.pointers,a=r.mousePointer,h=e.PointerModes;this.line("Pointers: (Max: "+r.maxPointers+")"),this.line("  "+(a.isDown?"x":"o")+" "+h[a.pointerMode]);for(var l=0;l<o.length;l++){var c=o[l];this.line("  "+(c.active?"+":"-")+" "+h[c.pointerMode])}this.stop()}else this.stop()},_inputHandler:function(t,e){return this._inputHandlerStatusIcon(t)+" "+e+" "+this._inputHandlerCaptureIcon(t)},_inputHandlerStatusIcon:function(t){return t.active?t.enabled?"+":"-":" "},_inputHandlerCaptureIcon:function(t){return t.active&&(t.capture||t.preventDefault)?"*":" "},spriteBounds:function(t,e,i){var s=t.getBounds();s.x+=this.game.camera.x,s.y+=this.game.camera.y,this.rectangle(s,e,i)},ropeSegments:function(t,e,i){var s=this;t.segments.forEach(function(t){s.rectangle(t,e,i)},this)},spriteInfo:function(t,e,i,s){this.start(e,i,s),this.line("Sprite: "+(t.name||"")+" ("+t.width+" x "+t.height+") anchor: "+t.anchor.x+" x "+t.anchor.y),this.line("x: "+t.x.toFixed(1)+" y: "+t.y.toFixed(1)),this.line("angle: "+t.angle.toFixed(1)+" rotation: "+t.rotation.toFixed(1)),this.line("visible: "+t.visible+" in camera: "+t.inCamera),this.line("bounds x: "+t._bounds.x.toFixed(1)+" y: "+t._bounds.y.toFixed(1)+" w: "+t._bounds.width.toFixed(1)+" h: "+t._bounds.height.toFixed(1)),this.line("parent: "+(t.parent?t.parent.name||"(DisplayObject)":"(none)")),this.stop()},spriteCoords:function(t,e,i,s){this.start(e,i,s,100),t.name&&this.line(t.name),this.line("x:",t.x.toFixed(2),"y:",t.y.toFixed(2)),this.line("pos x:",t.position.x.toFixed(2),"pos y:",t.position.y.toFixed(2)),this.line("world x:",t.world.x.toFixed(2),"world y:",t.world.y.toFixed(2)),this.stop()},lineInfo:function(t,e,i,s){this.start(e,i,s,80),this.line("start.x:",t.start.x.toFixed(2),"start.y:",t.start.y.toFixed(2)),this.line("end.x:",t.end.x.toFixed(2),"end.y:",t.end.y.toFixed(2)),this.line("length:",t.length.toFixed(2),"angle:",t.angle),this.stop()},pixel:function(t,e,i,s){s=s||2,this.start(),this.context.fillStyle=i,this.context.fillRect(t,e,s,s),this.stop()},geom:function(t,i,s,n){void 0===s&&(s=!0),void 0===n&&(n=0),i=i||"rgba(0,255,0,0.4)",this.start(),this.context.fillStyle=i,this.context.strokeStyle=i,this.context.lineWidth=this.lineWidth;var r=e.Utils.Debug;n===r.GEOM_RECTANGLE||t instanceof e.Rectangle?s?this.context.fillRect(t.x-this.game.camera.x,t.y-this.game.camera.y,t.width,t.height):this.context.strokeRect(t.x-this.game.camera.x,t.y-this.game.camera.y,t.width,t.height):n===r.GEOM_CIRCLE||t instanceof e.Circle?(this.context.beginPath(),this.context.arc(t.x-this.game.camera.x,t.y-this.game.camera.y,t.radius,0,2*Math.PI,!1),this.context.closePath(),s?this.context.fill():this.context.stroke()):n===r.GEOM_POINT||t instanceof e.Point?this.context.fillRect(t.x-this.game.camera.x,t.y-this.game.camera.y,4,4):n===r.GEOM_LINE||t instanceof e.Line?(this.context.beginPath(),this.context.moveTo(t.start.x+.5-this.game.camera.x,t.start.y+.5-this.game.camera.y),this.context.lineTo(t.end.x+.5-this.game.camera.x,t.end.y+.5-this.game.camera.y),this.context.closePath(),this.context.stroke()):(n===r.GEOM_ELLIPSE||t instanceof e.Ellipse)&&(this.context.beginPath(),this.context.ellipse(t.centerX-this.game.camera.x,t.centerY-this.game.camera.y,t.width/2,t.height/2,0,2*Math.PI,!1),this.context.closePath(),s?this.context.fill():this.context.stroke()),this.stop()},rectangle:function(t,e,i){void 0===i&&(i=!0),e=e||"rgba(0, 255, 0, 0.4)",this.start(),i?(this.context.fillStyle=e,this.context.fillRect(t.x-this.game.camera.x,t.y-this.game.camera.y,t.width,t.height)):(this.context.lineWidth=this.lineWidth,this.context.strokeStyle=e,this.context.strokeRect(t.x-this.game.camera.x,t.y-this.game.camera.y,t.width,t.height)),this.stop()},text:function(t,e,i,s,n){s=s||"rgb(255,255,255)",n=n||this.font,this.start(),this.context.font=n,this.renderShadow&&(this.context.fillStyle="rgb(0,0,0)",this.context.fillText(t,e+1,i+1)),this.context.fillStyle=s,this.context.fillText(t,e,i),this.stop()},quadTree:function(t,e){e=e||"rgba(255,0,0,0.3)",this.start();var i=t.bounds;if(0===t.nodes.length){this.context.strokeStyle=e,this.context.strokeRect(i.x,i.y,i.width,i.height),this.text("size: "+t.objects.length,i.x+4,i.y+16,"rgb(0,200,0)","12px Courier"),this.context.strokeStyle="rgb(0,255,0)";for(s=0;s<t.objects.length;s++)this.context.strokeRect(t.objects[s].x,t.objects[s].y,t.objects[s].width,t.objects[s].height)}else for(var s=0;s<t.nodes.length;s++)this.quadTree(t.nodes[s]);this.stop()},body:function(t,i,s){t.body&&(this.start(),t.body.type===e.Physics.ARCADE?e.Physics.Arcade.Body.render(this.context,t.body,i,s,this.lineWidth):t.body.type===e.Physics.NINJA?e.Physics.Ninja.Body.render(this.context,t.body,i,s):t.body.type===e.Physics.BOX2D&&e.Physics.Box2D.renderBody(this.context,t.body,i),this.stop())},bodyInfo:function(t,i,s,n){t.body&&(this.start(i,s,n,210),t.body.type===e.Physics.ARCADE?e.Physics.Arcade.Body.renderBodyInfo(this,t.body):t.body.type===e.Physics.BOX2D&&this.game.physics.box2d.renderBodyInfo(this,t.body),this.stop())},box2dWorld:function(){this.start(),this.context.translate(-this.game.camera.view.x,-this.game.camera.view.y,0),this.game.physics.box2d.renderDebugDraw(this.context),this.stop()},box2dBody:function(t,i){this.start(),e.Physics.Box2D.renderBody(this.context,t,i),this.stop()},displayList:function(t){if(void 0===t&&(t=this.game.world),t.hasOwnProperty("renderOrderID")?console.log("["+t.renderOrderID+"]",t):console.log("[]",t),t.children&&t.children.length>0)for(var e=0;e<t.children.length;e++)this.game.debug.displayList(t.children[e])},renderer:function(t,e,i){var s=this.game.renderer,n=s.renderSession;if(this.start(t,e,i),this.line((s.gl?"WebGL":"Canvas")+" Renderer ("+s.width+" x "+s.height+")"),this.line("autoResize: "+s.autoResize),this.line("clearBeforeRender: "+s.clearBeforeRender),this.line("resolution: "+s.resolution),this.line("transparent: "+s.transparent),this.line("renderSession:"),s.gl){this.line("  currentBatchedTextures: ("+s.currentBatchedTextures.length+")");for(var r=0;r<s.currentBatchedTextures.length;r++)this.line("    "+s.currentBatchedTextures[r]);this.line("  drawCount: "+n.drawCount),this.line("  maxTextures: "+s.maxTextures),this.line("  maxTextureSize: "+s.maxTextureSize),this.line("  maxTextureAvailableSpace: "+n.maxTextureAvailableSpace),this.line("  roundPixels: "+n.roundPixels)}else this.line("  roundPixels: "+n.roundPixels),this.line("  scaleMode: "+(0===n.scaleMode?"LINEAR":1===n.scaleMode?"NEAREST":n.scaleMode));this.stop()},canvasPool:function(t,i,s,n){var r=e.CanvasPool;this.start(t,i,s,n||100),this.line("Canvas Pool"),this.line("Used:",r.getTotal()),this.line("Free:",r.getFree()),this.line("Total:",r.length),this.stop()},physicsGroup:function(t,e,i,s){t.forEach(this.body,this,s,e,i)},phaser:function(t,i,s){this.text("Phaser v"+e.VERSION+" "+(this.game.renderType===e.WEBGL?"WebGL":"Canvas")+" "+(this.game.device.webAudio?"WebAudio":"HTML Audio"),t,i,s,this.font)},scale:function(t,i,s){this.start(t,i,s);var n=this.game.scale,r=n.scaleFactorInversed,o=n._parentBounds,t=" x ";this.line("Game: "+this.game.width+t+this.game.height),this.line("Canvas: "+n.width+t+n.height+" ("+r.x.toFixed(2)+t+r.y.toFixed(2)+") ["+n.aspectRatio.toFixed(2)+"]"),this.line("Mode: "+e.ScaleManager.MODES[n.currentScaleMode]+(n.currentScaleMode===e.ScaleManager.USER_SCALE?" ("+n._userScaleFactor.x+t+n._userScaleFactor.y+")":"")),this.line("Parent: "+(n.parentIsWindow?"window":n.parentNode)+(o.empty?"":" ("+o.width+t+o.height+")")),this.line("Screen: "+n.classifyOrientation(n.screenOrientation)+(n.incorrectOrientation?" (incorrect)":"")),this.stop()},loader:function(t,i,s,n){var r=e.Utils.pad;this.start(i,s,n),t.hasLoaded?this.line("Complete"+(t.resetLocked?" [locked]":"")):t.isLoading?this.line("Loading"):this.line("Not started"),t.hasLoaded&&!t.resetLocked||(this.line("Progress: "+r(t.progress,3)+"%"),this.line("Files: "+t._loadedFileCount+" of "+t._totalFileCount),this.line("Packs: "+t._loadedPackCount+" of "+t._loadedPackCount)),this.stop()},device:function(t,e,i){var s=this.game.device;this.start(t,e,i),this.line("Device"),this.line("Pointer Events: "+s.mspointer),this.line("Touch: "+s.touch),this.line("Web Audio: "+s.webAudio),this.line("WebGL: "+s.webGL),this.stop()},destroy:function(){e.CanvasPool.remove(this)}},e.Utils.Debug.prototype.constructor=e.Utils.Debug,e.DOM={getOffset:function(t,i){i=i||new e.Point;var s=t.getBoundingClientRect(),n=e.DOM.scrollY,r=e.DOM.scrollX,o=document.documentElement.clientTop,a=document.documentElement.clientLeft;return i.x=s.left+r-a,i.y=s.top+n-o,i},getBounds:function(t,e){return void 0===e&&(e=0),!(!(t=t&&!t.nodeType?t[0]:t)||1!==t.nodeType)&&this.calibrate(t.getBoundingClientRect(),e)},calibrate:function(t,e){e=+e||0;var i={width:0,height:0,left:0,right:0,top:0,bottom:0};return i.width=(i.right=t.right+e)-(i.left=t.left-e),i.height=(i.bottom=t.bottom+e)-(i.top=t.top-e),i},getAspectRatio:function(t){var e=(t=null==t?this.visualBounds:1===t.nodeType?this.getBounds(t):t).width,i=t.height;return"function"==typeof e&&(e=e.call(t)),"function"==typeof i&&(i=i.call(t)),e/i},inLayoutViewport:function(t,e){var i=this.getBounds(t,e);return!!i&&i.bottom>=0&&i.right>=0&&i.top<=this.layoutBounds.width&&i.left<=this.layoutBounds.height},getScreenOrientation:function(t){var e=window.screen,i=e.orientation||e.mozOrientation||e.msOrientation;if(i&&"string"==typeof i.type)return i.type;if("string"==typeof i)return i;var s="portrait-primary",n="landscape-primary";if("screen"===t)return e.height>e.width?s:n;if("viewport"===t)return this.visualBounds.height>this.visualBounds.width?s:n;if("window.orientation"===t&&"number"==typeof window.orientation)return 0===window.orientation||180===window.orientation?s:n;if(window.matchMedia){if(window.matchMedia("(orientation: portrait)").matches)return s;if(window.matchMedia("(orientation: landscape)").matches)return n}return this.visualBounds.height>this.visualBounds.width?s:n},visualBounds:new e.Rectangle,layoutBounds:new e.Rectangle,documentBounds:new e.Rectangle},e.Device.whenReady(function(t){var i=window&&"pageXOffset"in window?function(){return window.pageXOffset}:function(){return document.documentElement.scrollLeft},s=window&&"pageYOffset"in window?function(){return window.pageYOffset}:function(){return document.documentElement.scrollTop};if(Object.defineProperty(e.DOM,"scrollX",{get:i}),Object.defineProperty(e.DOM,"scrollY",{get:s}),Object.defineProperty(e.DOM.visualBounds,"x",{get:i}),Object.defineProperty(e.DOM.visualBounds,"y",{get:s}),Object.defineProperty(e.DOM.layoutBounds,"x",{value:0}),Object.defineProperty(e.DOM.layoutBounds,"y",{value:0}),t.desktop&&document.documentElement.clientWidth<=window.innerWidth&&document.documentElement.clientHeight<=window.innerHeight){var n=function(){return Math.max(window.innerWidth,document.documentElement.clientWidth)},r=function(){return Math.max(window.innerHeight,document.documentElement.clientHeight)};Object.defineProperty(e.DOM.visualBounds,"width",{get:n}),Object.defineProperty(e.DOM.visualBounds,"height",{get:r}),Object.defineProperty(e.DOM.layoutBounds,"width",{get:n}),Object.defineProperty(e.DOM.layoutBounds,"height",{get:r})}else Object.defineProperty(e.DOM.visualBounds,"width",{get:function(){return window.innerWidth}}),Object.defineProperty(e.DOM.visualBounds,"height",{get:function(){return window.innerHeight}}),Object.defineProperty(e.DOM.layoutBounds,"width",{get:function(){var t=document.documentElement.clientWidth,e=window.innerWidth;return t<e?e:t}}),Object.defineProperty(e.DOM.layoutBounds,"height",{get:function(){var t=document.documentElement.clientHeight,e=window.innerHeight;return t<e?e:t}});Object.defineProperty(e.DOM.documentBounds,"x",{value:0}),Object.defineProperty(e.DOM.documentBounds,"y",{value:0}),Object.defineProperty(e.DOM.documentBounds,"width",{get:function(){var t=document.documentElement;return Math.max(t.clientWidth,t.offsetWidth,t.scrollWidth)}}),Object.defineProperty(e.DOM.documentBounds,"height",{get:function(){var t=document.documentElement;return Math.max(t.clientHeight,t.offsetHeight,t.scrollHeight)}})},null,!0),e.ArraySet=function(t){this.position=0,this.list=t||[]},e.ArraySet.prototype={add:function(t){return this.exists(t)||this.list.push(t),t},getIndex:function(t){return this.list.indexOf(t)},getByKey:function(t,e){for(var i=this.list.length;i--;)if(this.list[i][t]===e)return this.list[i];return null},exists:function(t){return this.list.indexOf(t)>-1},reset:function(){this.list.length=0},remove:function(t){var e=this.list.indexOf(t);if(e>-1)return this.list.splice(e,1),t},setAll:function(t,e){for(var i=this.list.length;i--;)this.list[i]&&(this.list[i][t]=e)},callAll:function(t){for(var e=Array.prototype.slice.call(arguments,1),i=this.list.length;i--;)this.list[i]&&this.list[i][t]&&this.list[i][t].apply(this.list[i],e)},removeAll:function(t){void 0===t&&(t=!1);for(var e=this.list.length;e--;)if(this.list[e]){var i=this.remove(this.list[e]);t&&i.destroy()}this.position=0,this.list=[]}},Object.defineProperty(e.ArraySet.prototype,"total",{get:function(){return this.list.length}}),Object.defineProperty(e.ArraySet.prototype,"first",{get:function(){return this.position=0,this.list.length>0?this.list[0]:null}}),Object.defineProperty(e.ArraySet.prototype,"next",{get:function(){return this.position<this.list.length?(this.position++,this.list[this.position]):null}}),e.ArraySet.prototype.constructor=e.ArraySet,e.ArrayUtils={getRandomItem:function(t,e,i){if(null===t)return null;void 0===e&&(e=0),void 0===i&&(i=t.length);var s=e+Math.floor(Math.random()*i);return void 0===t[s]?null:t[s]},removeRandomItem:function(t,e,i){if(null==t)return null;void 0===e&&(e=0),void 0===i&&(i=t.length);var s=e+Math.floor(Math.random()*i);if(s<t.length){var n=t.splice(s,1);return void 0===n[0]?null:n[0]}return null},remove:function(t,e,i){var s=t.length;if(!(e>=s||0===i)){null==i&&(i=1);for(var n=s-i,r=e;r<n;++r)t[r]=t[r+i];t.length=n}},shuffle:function(t){for(var e=t.length-1;e>0;e--){var i=Math.floor(Math.random()*(e+1)),s=t[e];t[e]=t[i],t[i]=s}return t},transposeMatrix:function(t){for(var e=t.length,i=t[0].length,s=new Array(i),n=0;n<i;n++){s[n]=new Array(e);for(var r=e-1;r>-1;r--)s[n][r]=t[r][n]}return s},rotateMatrix:function(t,i){if("string"!=typeof i&&(i=(i%360+360)%360),90===i||-270===i||"rotateLeft"===i)t=(t=e.ArrayUtils.transposeMatrix(t)).reverse();else if(-90===i||270===i||"rotateRight"===i)t=t.reverse(),t=e.ArrayUtils.transposeMatrix(t);else if(180===Math.abs(i)||"rotate180"===i){for(var s=0;s<t.length;s++)t[s].reverse();t=t.reverse()}return t},findClosest:function(t,e){if(!e.length)return NaN;if(1===e.length||t<e[0])return e[0];for(var i=1;e[i]<t;)i++;var s=e[i-1],n=i<e.length?e[i]:Number.POSITIVE_INFINITY;return n-t<=t-s?n:s},rotateRight:function(t){var e=t.pop();return t.unshift(e),e},rotateLeft:function(t){var e=t.shift();return t.push(e),e},numberArray:function(t,e){void 0!==e&&null!==e||(e=t,t=0);for(var i=[],s=t;s<=e;s++)i.push(s);return i},numberArrayStep:function(t,i,s){void 0!==t&&null!==t||(t=0),void 0!==i&&null!==i||(i=t,t=0),void 0===s&&(s=1);for(var n=[],r=Math.max(e.Math.roundAwayFromZero((i-t)/(s||1)),0),o=0;o<r;o++)n.push(t),t+=s;return n}},e.LinkedList=function(){this.next=null,this.prev=null,this.first=null,this.last=null,this.total=0},e.LinkedList.prototype={add:function(t){return 0===this.total&&null===this.first&&null===this.last?(this.first=t,this.last=t,this.next=t,t.prev=this,this.total++,t):(this.last.next=t,t.prev=this.last,this.last=t,this.total++,t)},reset:function(){this.first=null,this.last=null,this.next=null,this.prev=null,this.total=0},remove:function(t){if(1===this.total)return this.reset(),void(t.next=t.prev=null);t===this.first?this.first=this.first.next:t===this.last&&(this.last=this.last.prev),t.prev&&(t.prev.next=t.next),t.next&&(t.next.prev=t.prev),t.next=t.prev=null,null===this.first&&(this.last=null),this.total--},callAll:function(t){if(this.first&&this.last){var e=this.first;do{e&&e[t]&&e[t].call(e),e=e.next}while(e!==this.last.next)}}},e.LinkedList.prototype.constructor=e.LinkedList,e.Create=function(t){this.game=t,this.bmd=null,this.canvas=null,this.ctx=null,this.palettes=[{0:"#000",1:"#9D9D9D",2:"#FFF",3:"#BE2633",4:"#E06F8B",5:"#493C2B",6:"#A46422",7:"#EB8931",8:"#F7E26B",9:"#2F484E",A:"#44891A",B:"#A3CE27",C:"#1B2632",D:"#005784",E:"#31A2F2",F:"#B2DCEF"},{0:"#000",1:"#191028",2:"#46af45",3:"#a1d685",4:"#453e78",5:"#7664fe",6:"#833129",7:"#9ec2e8",8:"#dc534b",9:"#e18d79",A:"#d6b97b",B:"#e9d8a1",C:"#216c4b",D:"#d365c8",E:"#afaab9",F:"#f5f4eb"},{0:"#000",1:"#2234d1",2:"#0c7e45",3:"#44aacc",4:"#8a3622",5:"#5c2e78",6:"#aa5c3d",7:"#b5b5b5",8:"#5e606e",9:"#4c81fb",A:"#6cd947",B:"#7be2f9",C:"#eb8a60",D:"#e23d69",E:"#ffd93f",F:"#fff"},{0:"#000",1:"#fff",2:"#8b4131",3:"#7bbdc5",4:"#8b41ac",5:"#6aac41",6:"#3931a4",7:"#d5de73",8:"#945a20",9:"#5a4100",A:"#bd736a",B:"#525252",C:"#838383",D:"#acee8b",E:"#7b73de",F:"#acacac"},{0:"#000",1:"#191028",2:"#46af45",3:"#a1d685",4:"#453e78",5:"#7664fe",6:"#833129",7:"#9ec2e8",8:"#dc534b",9:"#e18d79",A:"#d6b97b",B:"#e9d8a1",C:"#216c4b",D:"#d365c8",E:"#afaab9",F:"#fff"}]},e.Create.PALETTE_ARNE=0,e.Create.PALETTE_JMP=1,e.Create.PALETTE_CGA=2,e.Create.PALETTE_C64=3,e.Create.PALETTE_JAPANESE_MACHINE=4,e.Create.prototype={texture:function(t,e,i,s,n,r,o,a){void 0===i&&(i=8),void 0===s&&(s=i),void 0===n&&(n=0),void 0===r&&(r=!0);var h=e[0].length*i,l=e.length*s;null===this.bmd&&(this.bmd=this.game.make.bitmapData(),this.canvas=this.bmd.canvas,this.ctx=this.bmd.context),this.bmd.resize(h,l),this.bmd.clear();for(var c=0;c<e.length;c++)for(var u=e[c],d=0;d<u.length;d++){var p=u[d];"."!==p&&" "!==p&&(this.ctx.fillStyle=this.palettes[n][p],this.ctx.fillRect(d*i,c*s,i,s))}return r?this.bmd.generateTexture(t,o,a):this.copy()},grid:function(t,e,i,s,n,r,o,a,h){void 0===o&&(o=!0),null===this.bmd&&(this.bmd=this.game.make.bitmapData(),this.canvas=this.bmd.canvas,this.ctx=this.bmd.context),this.bmd.resize(e,i),this.ctx.fillStyle=r;for(var l=0;l<i;l+=n)this.ctx.fillRect(0,l,e,1);for(var c=0;c<e;c+=s)this.ctx.fillRect(c,0,1,i);return o?this.bmd.generateTexture(t,a,h):this.copy()},copy:function(t,e,i,s,n,r,o){return null==t&&(t=this.game.make.bitmapData()),t.resize(this.bmd.width,this.bmd.height),t.draw(this.bmd,e,i,s,n,r,o)}},e.Create.prototype.constructor=e.Create,e.FlexGrid=function(t,i,s){this.game=t.game,this.manager=t,this.width=i,this.height=s,this.boundsCustom=new e.Rectangle(0,0,i,s),this.boundsFluid=new e.Rectangle(0,0,i,s),this.boundsFull=new e.Rectangle(0,0,i,s),this.boundsNone=new e.Rectangle(0,0,i,s),this.positionCustom=new e.Point(0,0),this.positionFluid=new e.Point(0,0),this.positionFull=new e.Point(0,0),this.positionNone=new e.Point(0,0),this.scaleCustom=new e.Point(1,1),this.scaleFluid=new e.Point(1,1),this.scaleFluidInversed=new e.Point(1,1),this.scaleFull=new e.Point(1,1),this.scaleNone=new e.Point(1,1),this.customWidth=0,this.customHeight=0,this.customOffsetX=0,this.customOffsetY=0,this.ratioH=i/s,this.ratioV=s/i,this.multiplier=0,this.layers=[]},e.FlexGrid.prototype={setSize:function(t,i){this.width=t,this.height=i,this.ratioH=t/i,this.ratioV=i/t,this.scaleNone=new e.Point(1,1),this.boundsNone.width=this.width,this.boundsNone.height=this.height,this.refresh()},createCustomLayer:function(t,i,s,n){void 0===n&&(n=!0),this.customWidth=t,this.customHeight=i,this.boundsCustom.width=t,this.boundsCustom.height=i;var r=new e.FlexLayer(this,this.positionCustom,this.boundsCustom,this.scaleCustom);return n&&this.game.world.add(r),this.layers.push(r),s&&r.addMultiple(s),r},createFluidLayer:function(t,i){void 0===i&&(i=!0);var s=new e.FlexLayer(this,this.positionFluid,this.boundsFluid,this.scaleFluid);return i&&this.game.world.add(s),this.layers.push(s),t&&s.addMultiple(t),s},createFullLayer:function(t){var i=new e.FlexLayer(this,this.positionFull,this.boundsFull,this.scaleFluid);return this.game.world.add(i),this.layers.push(i),void 0!==t&&i.addMultiple(t),i},createFixedLayer:function(t){var i=new e.FlexLayer(this,this.positionNone,this.boundsNone,this.scaleNone);return this.game.world.add(i),this.layers.push(i),void 0!==t&&i.addMultiple(t),i},reset:function(){for(var t=this.layers.length;t--;)this.layers[t].persist||(this.layers[t].position=null,this.layers[t].scale=null,this.layers.slice(t,1))},onResize:function(t,e){this.ratioH=t/e,this.ratioV=e/t,this.refresh(t,e)},refresh:function(){this.multiplier=Math.min(this.manager.height/this.height,this.manager.width/this.width),this.boundsFluid.width=Math.round(this.width*this.multiplier),this.boundsFluid.height=Math.round(this.height*this.multiplier),this.scaleFluid.set(this.boundsFluid.width/this.width,this.boundsFluid.height/this.height),this.scaleFluidInversed.set(this.width/this.boundsFluid.width,this.height/this.boundsFluid.height),this.scaleFull.set(this.boundsFull.width/this.width,this.boundsFull.height/this.height),this.boundsFull.width=Math.round(this.manager.width*this.scaleFluidInversed.x),this.boundsFull.height=Math.round(this.manager.height*this.scaleFluidInversed.y),this.boundsFluid.centerOn(this.manager.bounds.centerX,this.manager.bounds.centerY),this.boundsNone.centerOn(this.manager.bounds.centerX,this.manager.bounds.centerY),this.positionFluid.set(this.boundsFluid.x,this.boundsFluid.y),this.positionNone.set(this.boundsNone.x,this.boundsNone.y)},fitSprite:function(t){this.manager.scaleSprite(t),t.x=this.manager.bounds.centerX,t.y=this.manager.bounds.centerY},debug:function(){this.game.debug.text(this.boundsFluid.width+" x "+this.boundsFluid.height,this.boundsFluid.x+4,this.boundsFluid.y+16),this.game.debug.geom(this.boundsFluid,"rgba(255,0,0,0.9",!1)}},e.FlexGrid.prototype.constructor=e.FlexGrid,e.FlexLayer=function(t,i,s,n){e.Group.call(this,t.game,null,"__flexLayer"+t.game.rnd.uuid(),!1),this.manager=t.manager,this.grid=t,this.persist=!1,this.position=i,this.bounds=s,this.scale=n,this.topLeft=s.topLeft,this.topMiddle=new e.Point(s.halfWidth,0),this.topRight=s.topRight,this.bottomLeft=s.bottomLeft,this.bottomMiddle=new e.Point(s.halfWidth,s.bottom),this.bottomRight=s.bottomRight},e.FlexLayer.prototype=Object.create(e.Group.prototype),e.FlexLayer.prototype.constructor=e.FlexLayer,e.FlexLayer.prototype.resize=function(){},e.FlexLayer.prototype.debug=function(){this.game.debug.text(this.bounds.width+" x "+this.bounds.height,this.bounds.x+4,this.bounds.y+16),this.game.debug.geom(this.bounds,"rgba(0,0,255,0.9",!1),this.game.debug.geom(this.topLeft,"rgba(255,255,255,0.9"),this.game.debug.geom(this.topMiddle,"rgba(255,255,255,0.9"),this.game.debug.geom(this.topRight,"rgba(255,255,255,0.9")},e.Color={RED:16711680,ORANGE:16750848,YELLOW:16776960,GREEN:65280,AQUA:65535,BLUE:255,VIOLET:16711935,WHITE:16777215,BLACK:0,GRAY:6710886,packPixel:function(t,i,s,n){return e.Device.LITTLE_ENDIAN?(n<<24|s<<16|i<<8|t)>>>0:(t<<24|i<<16|s<<8|n)>>>0},unpackPixel:function(t,i,s,n){return void 0!==i&&null!==i||(i=e.Color.createColor()),void 0!==s&&null!==s||(s=!1),void 0!==n&&null!==n||(n=!1),e.Device.LITTLE_ENDIAN?(i.a=(4278190080&t)>>>24,i.b=(16711680&t)>>>16,i.g=(65280&t)>>>8,i.r=255&t):(i.r=(4278190080&t)>>>24,i.g=(16711680&t)>>>16,i.b=(65280&t)>>>8,i.a=255&t),i.color=t,i.rgba="rgba("+i.r+","+i.g+","+i.b+","+i.a/255+")",s&&e.Color.RGBtoHSL(i.r,i.g,i.b,i),n&&e.Color.RGBtoHSV(i.r,i.g,i.b,i),i},fromRGBA:function(t,i){return i||(i=e.Color.createColor()),i.r=(4278190080&t)>>>24,i.g=(16711680&t)>>>16,i.b=(65280&t)>>>8,i.a=255&t,i.rgba="rgba("+i.r+","+i.g+","+i.b+","+i.a+")",i},toRGBA:function(t,e,i,s){return t<<24|e<<16|i<<8|s},toABGR:function(t,e,i,s){return(s<<24|i<<16|e<<8|t)>>>0},hexToRGBArray:function(t){return[(t>>16&255)/255,(t>>8&255)/255,(255&t)/255]},RGBArrayToHex:function(t){return(255*t[0]<<16)+(255*t[1]<<8)+255*t[2]},RGBtoHSL:function(t,i,s,n){n||(n=e.Color.createColor(t,i,s,1)),t/=255,i/=255,s/=255;var r=Math.min(t,i,s),o=Math.max(t,i,s);if(n.h=0,n.s=0,n.l=(o+r)/2,o!==r){var a=o-r;n.s=n.l>.5?a/(2-o-r):a/(o+r),o===t?n.h=(i-s)/a+(i<s?6:0):o===i?n.h=(s-t)/a+2:o===s&&(n.h=(t-i)/a+4),n.h/=6}return n},HSLtoRGB:function(t,i,s,n){if(n?(n.r=s,n.g=s,n.b=s):n=e.Color.createColor(s,s,s),0!==i){var r=s<.5?s*(1+i):s+i-s*i,o=2*s-r;n.r=e.Color.hueToColor(o,r,t+1/3),n.g=e.Color.hueToColor(o,r,t),n.b=e.Color.hueToColor(o,r,t-1/3)}return n.r=Math.floor(255*n.r|0),n.g=Math.floor(255*n.g|0),n.b=Math.floor(255*n.b|0),e.Color.updateColor(n),n},RGBtoHSV:function(t,i,s,n){n||(n=e.Color.createColor(t,i,s,255)),t/=255,i/=255,s/=255;var r=Math.min(t,i,s),o=Math.max(t,i,s),a=o-r;return n.h=0,n.s=0===o?0:a/o,n.v=o,o!==r&&(o===t?n.h=(i-s)/a+(i<s?6:0):o===i?n.h=(s-t)/a+2:o===s&&(n.h=(t-i)/a+4),n.h/=6),n},HSVtoRGB:function(t,i,s,n){void 0===n&&(n=e.Color.createColor(0,0,0,1,t,i,0,s));var r,o,a,h=Math.floor(6*t),l=6*t-h,c=s*(1-i),u=s*(1-l*i),d=s*(1-(1-l)*i);switch(h%6){case 0:r=s,o=d,a=c;break;case 1:r=u,o=s,a=c;break;case 2:r=c,o=s,a=d;break;case 3:r=c,o=u,a=s;break;case 4:r=d,o=c,a=s;break;case 5:r=s,o=c,a=u}return n.r=Math.floor(255*r),n.g=Math.floor(255*o),n.b=Math.floor(255*a),e.Color.updateColor(n),n},hueToColor:function(t,e,i){return i<0&&(i+=1),i>1&&(i-=1),i<1/6?t+6*(e-t)*i:i<.5?e:i<2/3?t+(e-t)*(2/3-i)*6:t},createColor:function(t,i,s,n,r,o,a,h){var l={r:t||0,g:i||0,b:s||0,a:n||1,h:r||0,s:o||0,l:a||0,v:h||0,color:0,color32:0,rgba:""};return e.Color.updateColor(l)},updateColor:function(t){return t.rgba="rgba("+t.r.toFixed()+","+t.g.toFixed()+","+t.b.toFixed()+","+t.a.toString()+")",t.color=e.Color.getColor(t.r,t.g,t.b),t.color32=e.Color.getColor32(255*t.a,t.r,t.g,t.b),t},getColor32:function(t,e,i,s){return t<<24|e<<16|i<<8|s},getColor:function(t,e,i){return t<<16|e<<8|i},RGBtoString:function(t,i,s,n,r){return void 0===n&&(n=255),void 0===r&&(r="#"),"#"===r?"#"+((1<<24)+(t<<16)+(i<<8)+s).toString(16).slice(1):"0x"+e.Color.componentToHex(n)+e.Color.componentToHex(t)+e.Color.componentToHex(i)+e.Color.componentToHex(s)},hexToRGB:function(t){var i=e.Color.hexToColor(t);if(i)return e.Color.getColor32(i.a,i.r,i.g,i.b)},hexToColor:function(t,i){t=t.replace(/^(?:#|0x)?([a-f\d])([a-f\d])([a-f\d])$/i,function(t,e,i,s){return e+e+i+i+s+s});var s=/^(?:#|0x)?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(t);if(s){var n=parseInt(s[1],16),r=parseInt(s[2],16),o=parseInt(s[3],16);i?(i.r=n,i.g=r,i.b=o):i=e.Color.createColor(n,r,o)}return i},webToColor:function(t,i){i||(i=e.Color.createColor());var s=/^rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d+(?:\.\d+)?))?\s*\)$/.exec(t);return s&&(i.r=~~Number(s[1]),i.g=~~Number(s[2]),i.b=~~Number(s[3]),i.a=void 0!==s[4]?Number(s[4]):1,e.Color.updateColor(i)),i},valueToColor:function(t,i){if(i||(i=e.Color.createColor()),"string"==typeof t)return 0===t.indexOf("rgb")?e.Color.webToColor(t,i):(i.a=1,e.Color.hexToColor(t,i));if("number"==typeof t){var s=e.Color.getRGB(t);return i.r=s.r,i.g=s.g,i.b=s.b,i.a=s.a/255,i}return i},componentToHex:function(t){var e=t.toString(16);return 1===e.length?"0"+e:e},HSVColorWheel:function(t,i){void 0===t&&(t=1),void 0===i&&(i=1);for(var s=[],n=0;n<=359;n++)s.push(e.Color.HSVtoRGB(n/359,t,i));return s},HSLColorWheel:function(t,i){void 0===t&&(t=.5),void 0===i&&(i=.5);for(var s=[],n=0;n<=359;n++)s.push(e.Color.HSLtoRGB(n/359,t,i));return s},interpolateColor:function(t,i,s,n,r,o){void 0===r&&(r=255),void 0===o&&(o=0);var a=e.Color.getRGB(t),h=e.Color.getRGB(i);if(0===o)var l=(h.red-a.red)*n/s+a.red,c=(h.green-a.green)*n/s+a.green,u=(h.blue-a.blue)*n/s+a.blue;if(1===o){var d,p=e.Color.RGBtoHSV(a.r,a.g,a.b),f=e.Color.RGBtoHSV(h.r,h.g,h.b),g=f.h-p.h;if(p.h>f.h){var m=f.h;f.h=p.h,p.h=m,g=-g,n=s-n}g>.5&&(p.h=p.h+1,d=((f.h-p.h)*n/s+p.h)%1),g<=.5&&(d=(f.h-p.h)*n/s+p.h);var y=(f.s-p.s)*n/s+p.s,v=(f.v-p.v)*n/s+p.v,x=e.Color.HSVtoRGB(d,y,v,x),l=x.r,c=x.g,u=x.b}return e.Color.getColor32(r,l,c,u)},interpolateColorWithRGB:function(t,i,s,n,r,o){var a=e.Color.getRGB(t),h=(i-a.red)*o/r+a.red,l=(s-a.green)*o/r+a.green,c=(n-a.blue)*o/r+a.blue;return e.Color.getColor(h,l,c)},interpolateRGB:function(t,i,s,n,r,o,a,h){var l=(n-t)*h/a+t,c=(r-i)*h/a+i,u=(o-s)*h/a+s;return e.Color.getColor(l,c,u)},linear:function(t,e,i){return this.interpolateColor(t,e,1,i)},linearInterpolation:function(t,i){var s=e.Math.linear(0,t.length-1,i),n=t[Math.floor(s)],r=t[Math.ceil(s)];return this.linear(n,r,s%1)},getRandomColor:function(t,i,s){if(void 0===t&&(t=0),void 0===i&&(i=255),void 0===s&&(s=255),i>255||t>i)return e.Color.getColor(255,255,255);var n=t+Math.round(Math.random()*(i-t)),r=t+Math.round(Math.random()*(i-t)),o=t+Math.round(Math.random()*(i-t));return e.Color.getColor32(s,n,r,o)},getRGB:function(t){return t>16777215?{alpha:t>>>24,red:t>>16&255,green:t>>8&255,blue:255&t,a:t>>>24,r:t>>16&255,g:t>>8&255,b:255&t}:{alpha:255,red:t>>16&255,green:t>>8&255,blue:255&t,a:255,r:t>>16&255,g:t>>8&255,b:255&t}},getWebRGB:function(t){if("object"==typeof t)return"rgba("+t.r.toString()+","+t.g.toString()+","+t.b.toString()+","+(t.a/255).toString()+")";var i=e.Color.getRGB(t);return"rgba("+i.r.toString()+","+i.g.toString()+","+i.b.toString()+","+(i.a/255).toString()+")"},getAlpha:function(t){return t>>>24},getAlphaFloat:function(t){return(t>>>24)/255},getRed:function(t){return t>>16&255},getGreen:function(t){return t>>8&255},getBlue:function(t){return 255&t},blendNormal:function(t){return t},blendLighten:function(t,e){return e>t?e:t},blendDarken:function(t,e){return e>t?t:e},blendMultiply:function(t,e){return t*e/255},blendAverage:function(t,e){return(t+e)/2},blendAdd:function(t,e){return Math.min(255,t+e)},blendSubtract:function(t,e){return Math.max(0,t+e-255)},blendDifference:function(t,e){return Math.abs(t-e)},blendNegation:function(t,e){return 255-Math.abs(255-t-e)},blendScreen:function(t,e){return 255-((255-t)*(255-e)>>8)},blendExclusion:function(t,e){return t+e-2*t*e/255},blendOverlay:function(t,e){return e<128?2*t*e/255:255-2*(255-t)*(255-e)/255},blendSoftLight:function(t,e){return e<128?2*(64+(t>>1))*(e/255):255-2*(255-(64+(t>>1)))*(255-e)/255},blendHardLight:function(t,i){return e.Color.blendOverlay(i,t)},blendColorDodge:function(t,e){return 255===e?e:Math.min(255,(t<<8)/(255-e))},blendColorBurn:function(t,e){return 0===e?e:Math.max(0,255-(255-t<<8)/e)},blendLinearDodge:function(t,i){return e.Color.blendAdd(t,i)},blendLinearBurn:function(t,i){return e.Color.blendSubtract(t,i)},blendLinearLight:function(t,i){return i<128?e.Color.blendLinearBurn(t,2*i):e.Color.blendLinearDodge(t,2*(i-128))},blendVividLight:function(t,i){return i<128?e.Color.blendColorBurn(t,2*i):e.Color.blendColorDodge(t,2*(i-128))},blendPinLight:function(t,i){return i<128?e.Color.blendDarken(t,2*i):e.Color.blendLighten(t,2*(i-128))},blendHardMix:function(t,i){return e.Color.blendVividLight(t,i)<128?0:255},blendReflect:function(t,e){return 255===e?e:Math.min(255,t*t/(255-e))},blendGlow:function(t,i){return e.Color.blendReflect(i,t)},blendPhoenix:function(t,e){return Math.min(t,e)-Math.max(t,e)+255}},e.Physics=function(t,e){e=e||{},this.game=t,this.config=e,this.arcade=null,this.p2=null,this.ninja=null,this.box2d=null,this.chipmunk=null,this.matter=null,this.parseConfig()},e.Physics.ARCADE=0,e.Physics.P2JS=1,e.Physics.NINJA=2,e.Physics.BOX2D=3,e.Physics.CHIPMUNK=4,e.Physics.MATTERJS=5,e.Physics.prototype={parseConfig:function(){this.config.hasOwnProperty("arcade")&&!0!==this.config.arcade||!e.Physics.hasOwnProperty("Arcade")||(this.arcade=new e.Physics.Arcade(this.game)),this.config.hasOwnProperty("ninja")&&!0===this.config.ninja&&e.Physics.hasOwnProperty("Ninja")&&(this.ninja=new e.Physics.Ninja(this.game)),this.config.hasOwnProperty("p2")&&!0===this.config.p2&&e.Physics.hasOwnProperty("P2")&&(this.p2=new e.Physics.P2(this.game,this.config)),this.config.hasOwnProperty("box2d")&&!0===this.config.box2d&&e.Physics.hasOwnProperty("BOX2D")&&(this.box2d=new e.Physics.Box2D(this.game,this.config)),this.config.hasOwnProperty("matter")&&!0===this.config.matter&&e.Physics.hasOwnProperty("Matter")&&(this.matter=new e.Physics.Matter(this.game,this.config))},startSystem:function(t){t===e.Physics.ARCADE?this.arcade=new e.Physics.Arcade(this.game):t===e.Physics.P2JS?null===this.p2?this.p2=new e.Physics.P2(this.game,this.config):this.p2.reset():t===e.Physics.NINJA?this.ninja=new e.Physics.Ninja(this.game):t===e.Physics.BOX2D?null===this.box2d?this.box2d=new e.Physics.Box2D(this.game,this.config):this.box2d.reset():t===e.Physics.MATTERJS&&(null===this.matter?this.matter=new e.Physics.Matter(this.game,this.config):this.matter.reset())},enable:function(t,i,s){void 0===i&&(i=e.Physics.ARCADE),void 0===s&&(s=!1),i===e.Physics.ARCADE?this.arcade.enable(t):i===e.Physics.P2JS&&this.p2?this.p2.enable(t,s):i===e.Physics.NINJA&&this.ninja?this.ninja.enableAABB(t):i===e.Physics.BOX2D&&this.box2d?this.box2d.enable(t):i===e.Physics.MATTERJS&&this.matter?this.matter.enable(t):console.warn(t.key+" is attempting to enable a physics body using an unknown physics system.")},preUpdate:function(){this.p2&&this.p2.preUpdate(),this.box2d&&this.box2d.preUpdate(),this.matter&&this.matter.preUpdate()},update:function(){this.p2&&this.p2.update(),this.box2d&&this.box2d.update(),this.matter&&this.matter.update()},setBoundsToWorld:function(){this.arcade&&this.arcade.setBoundsToWorld(),this.ninja&&this.ninja.setBoundsToWorld(),this.p2&&this.p2.setBoundsToWorld(),this.box2d&&this.box2d.setBoundsToWorld(),this.matter&&this.matter.setBoundsToWorld()},clear:function(){this.p2&&this.p2.clear(),this.box2d&&this.box2d.clear(),this.matter&&this.matter.clear()},reset:function(){this.p2&&this.p2.reset(),this.box2d&&this.box2d.reset(),this.matter&&this.matter.reset()},destroy:function(){this.p2&&this.p2.destroy(),this.box2d&&this.box2d.destroy(),this.matter&&this.matter.destroy(),this.arcade=null,this.ninja=null,this.p2=null,this.box2d=null,this.matter=null}},e.Physics.prototype.constructor=e.Physics,e.Physics.Arcade=function(t){this.game=t,this.gravity=new e.Point,this.bounds=new e.Rectangle(0,0,t.world.width,t.world.height),this.checkCollision={up:!0,down:!0,left:!0,right:!0},this.maxObjects=10,this.maxLevels=4,this.OVERLAP_BIAS=4,this.forceX=!1,this.sortDirection=e.Physics.Arcade.LEFT_RIGHT,this.skipQuadTree=!0,this.isPaused=!1,this.quadTree=new e.QuadTree(this.game.world.bounds.x,this.game.world.bounds.y,this.game.world.bounds.width,this.game.world.bounds.height,this.maxObjects,this.maxLevels),this._total=0,this.setBoundsToWorld()},e.Physics.Arcade.prototype.constructor=e.Physics.Arcade,e.Physics.Arcade.SORT_NONE=0,e.Physics.Arcade.LEFT_RIGHT=1,e.Physics.Arcade.RIGHT_LEFT=2,e.Physics.Arcade.TOP_BOTTOM=3,e.Physics.Arcade.BOTTOM_TOP=4,e.Physics.Arcade.prototype={setBounds:function(t,e,i,s){this.bounds.setTo(t,e,i,s)},setBoundsToWorld:function(){this.bounds.copyFrom(this.game.world.bounds)},enable:function(t,i){void 0===i&&(i=!0);var s=1;if(Array.isArray(t))for(s=t.length;s--;)t[s]instanceof e.Group?this.enable(t[s].children,i):(this.enableBody(t[s]),i&&t[s].hasOwnProperty("children")&&t[s].children.length>0&&this.enable(t[s],!0));else t instanceof e.Group?this.enable(t.children,i):(this.enableBody(t),i&&t.hasOwnProperty("children")&&t.children.length>0&&this.enable(t.children,!0))},enableBody:function(t){t.hasOwnProperty("body")&&null===t.body&&(t.body=new e.Physics.Arcade.Body(t),t.parent&&t.parent instanceof e.Group&&t.parent.addToHash(t))},updateMotion:function(t){if(t.allowRotation){var e=this.computeVelocity(0,t,t.angularVelocity,t.angularAcceleration,t.angularDrag,t.maxAngular)-t.angularVelocity;t.angularVelocity+=e,t.rotation+=t.angularVelocity*this.game.time.physicsElapsed}t.velocity.x=this.computeVelocity(1,t,t.velocity.x,t.acceleration.x,t.drag.x,t.maxVelocity.x),t.velocity.y=this.computeVelocity(2,t,t.velocity.y,t.acceleration.y,t.drag.y,t.maxVelocity.y)},computeVelocity:function(t,e,i,s,n,r){return void 0===r&&(r=1e4),1===t&&e.allowGravity?i+=(this.gravity.x+e.gravity.x)*this.game.time.physicsElapsed:2===t&&e.allowGravity&&(i+=(this.gravity.y+e.gravity.y)*this.game.time.physicsElapsed),s?i+=s*this.game.time.physicsElapsed:n&&e.allowDrag&&(i-(n*=this.game.time.physicsElapsed)>0?i-=n:i+n<0?i+=n:i=0),i>r?i=r:i<-r&&(i=-r),i},overlap:function(t,e,i,s,n){return i=i||null,s=s||null,n=n||i,this._total=0,this.collideObjects(t,e,i,s,n,!0),this._total>0},collide:function(t,e,i,s,n){return i=i||null,s=s||null,n=n||i,this._total=0,this.collideObjects(t,e,i,s,n,!1),this._total>0},sortLeftRight:function(t,e){return t.body&&e.body?t.body.x-e.body.x:0},sortRightLeft:function(t,e){return t.body&&e.body?e.body.x-t.body.x:0},sortTopBottom:function(t,e){return t.body&&e.body?t.body.y-e.body.y:0},sortBottomTop:function(t,e){return t.body&&e.body?e.body.y-t.body.y:0},sort:function(t,i){null!==t.physicsSortDirection?i=t.physicsSortDirection:void 0===i&&(i=this.sortDirection),i===e.Physics.Arcade.LEFT_RIGHT?t.hash.sort(this.sortLeftRight):i===e.Physics.Arcade.RIGHT_LEFT?t.hash.sort(this.sortRightLeft):i===e.Physics.Arcade.TOP_BOTTOM?t.hash.sort(this.sortTopBottom):i===e.Physics.Arcade.BOTTOM_TOP&&t.hash.sort(this.sortBottomTop)},collideObjects:function(t,e,i,s,n,r){if(!Array.isArray(t)&&Array.isArray(e))for(o=0;o<e.length;o++)e[o]&&this.collideHandler(t,e[o],i,s,n,r);else if(Array.isArray(t)&&!Array.isArray(e))for(o=0;o<t.length;o++)t[o]&&this.collideHandler(t[o],e,i,s,n,r);else if(Array.isArray(t)&&Array.isArray(e)){for(var o=0;o<t.length;o++)if(t[o])for(var a=0;a<e.length;a++)e[a]&&this.collideHandler(t[o],e[a],i,s,n,r)}else this.collideHandler(t,e,i,s,n,r)},collideHandler:function(t,i,s,n,r,o){if(void 0===i&&t.physicsType===e.GROUP)return this.sort(t),void this.collideGroupVsSelf(t,s,n,r,o);t&&i&&t.exists&&i.exists&&(this.sortDirection!==e.Physics.Arcade.SORT_NONE&&(t.physicsType===e.GROUP&&this.sort(t),i.physicsType===e.GROUP&&this.sort(i)),t.physicsType===e.SPRITE?i.physicsType===e.SPRITE?this.collideSpriteVsSprite(t,i,s,n,r,o):i.physicsType===e.GROUP?this.collideSpriteVsGroup(t,i,s,n,r,o):i.physicsType===e.TILEMAPLAYER&&this.collideSpriteVsTilemapLayer(t,i,s,n,r,o):t.physicsType===e.GROUP?i.physicsType===e.SPRITE?this.collideSpriteVsGroup(i,t,s,n,r,o):i.physicsType===e.GROUP?this.collideGroupVsGroup(t,i,s,n,r,o):i.physicsType===e.TILEMAPLAYER&&this.collideGroupVsTilemapLayer(t,i,s,n,r,o):t.physicsType===e.TILEMAPLAYER&&(i.physicsType===e.SPRITE?this.collideSpriteVsTilemapLayer(i,t,s,n,r,o):i.physicsType===e.GROUP&&this.collideGroupVsTilemapLayer(i,t,s,n,r,o)))},collideSpriteVsSprite:function(t,e,i,s,n,r){return!(!t.body||!e.body)&&(this.separate(t.body,e.body,s,n,r)&&(i&&i.call(n,t,e),this._total++),!0)},collideSpriteVsGroup:function(t,i,s,n,r,o){if(0!==i.length&&t.body)if(this.skipQuadTree||t.body.skipQuadTree)for(var a={},h=0;h<i.hash.length;h++){var l=i.hash[h];if(l&&l.exists&&l.body){if(a=l.body.getBounds(a),this.sortDirection===e.Physics.Arcade.LEFT_RIGHT){if(t.body.right<a.x)break;if(a.right<t.body.x)continue}else if(this.sortDirection===e.Physics.Arcade.RIGHT_LEFT){if(t.body.x>a.right)break;if(a.x>t.body.right)continue}else if(this.sortDirection===e.Physics.Arcade.TOP_BOTTOM){if(t.body.bottom<a.y)break;if(a.bottom<t.body.y)continue}else if(this.sortDirection===e.Physics.Arcade.BOTTOM_TOP){if(t.body.y>a.bottom)break;if(a.y>t.body.bottom)continue}this.collideSpriteVsSprite(t,l,s,n,r,o)}}else{this.quadTree.clear(),this.quadTree.reset(this.game.world.bounds.x,this.game.world.bounds.y,this.game.world.bounds.width,this.game.world.bounds.height,this.maxObjects,this.maxLevels),this.quadTree.populate(i);for(var c=this.quadTree.retrieve(t),h=0;h<c.length;h++)this.separate(t.body,c[h],n,r,o)&&(s&&s.call(r,t,c[h].sprite),this._total++)}},collideGroupVsSelf:function(t,i,s,n,r){if(0!==t.length)for(var o=0;o<t.hash.length;o++){var a={},h=t.hash[o];if(h&&h.exists&&h.body){a=h.body.getBounds(a);for(var l=o+1;l<t.hash.length;l++){var c={},u=t.hash[l];if(u&&u.exists&&u.body){if(c=u.body.getBounds(c),this.sortDirection===e.Physics.Arcade.LEFT_RIGHT){if(a.right<c.x)break;if(c.right<a.x)continue}else if(this.sortDirection===e.Physics.Arcade.RIGHT_LEFT){if(a.x>c.right)continue;if(c.x>a.right)break}else if(this.sortDirection===e.Physics.Arcade.TOP_BOTTOM){if(a.bottom<c.y)continue;if(c.bottom<a.y)break}else if(this.sortDirection===e.Physics.Arcade.BOTTOM_TOP){if(a.y>c.bottom)continue;if(c.y>h.body.bottom)break}this.collideSpriteVsSprite(h,u,i,s,n,r)}}}}},collideGroupVsGroup:function(t,i,s,n,r,o){if(0!==t.length&&0!==i.length)for(var a=0;a<t.children.length;a++)t.children[a].exists&&(t.children[a].physicsType===e.GROUP?this.collideGroupVsGroup(t.children[a],i,s,n,r,o):this.collideSpriteVsGroup(t.children[a],i,s,n,r,o))},separate:function(t,e,i,s,n){if(!t.enable||!e.enable||t.checkCollision.none||e.checkCollision.none||!this.intersects(t,e))return!1;if(i&&!1===i.call(s,t.sprite,e.sprite))return!1;if(t.isCircle&&e.isCircle)return this.separateCircle(t,e,n);if(t.isCircle!==e.isCircle){var r=t.isCircle?e:t,o=t.isCircle?t:e,a={x:r.x,y:r.y,right:r.right,bottom:r.bottom},h=o.center;if((h.y<a.y||h.y>a.bottom)&&(h.x<a.x||h.x>a.right))return this.separateCircle(t,e,n)}var l=!1,c=!1;this.forceX||Math.abs(this.gravity.y+t.gravity.y)<Math.abs(this.gravity.x+t.gravity.x)?(l=this.separateX(t,e,n),this.intersects(t,e)&&(c=this.separateY(t,e,n))):(c=this.separateY(t,e,n),this.intersects(t,e)&&(l=this.separateX(t,e,n)));var u=l||c;return u&&(n?(t.onOverlap&&t.onOverlap.dispatch(t.sprite,e.sprite),e.onOverlap&&e.onOverlap.dispatch(e.sprite,t.sprite)):(t.onCollide&&t.onCollide.dispatch(t.sprite,e.sprite),e.onCollide&&e.onCollide.dispatch(e.sprite,t.sprite))),u},intersects:function(t,i){return t!==i&&(t.isCircle?i.isCircle?e.Math.distance(t.center.x,t.center.y,i.center.x,i.center.y)<=t.halfWidth+i.halfWidth:this.circleBodyIntersects(t,i):i.isCircle?this.circleBodyIntersects(i,t):!(t.right<=i.position.x)&&(!(t.bottom<=i.position.y)&&(!(t.position.x>=i.right)&&!(t.position.y>=i.bottom))))},circleBodyIntersects:function(t,i){var s=e.Math.clamp(t.center.x,i.left,i.right),n=e.Math.clamp(t.center.y,i.top,i.bottom);return(t.center.x-s)*(t.center.x-s)+(t.center.y-n)*(t.center.y-n)<=t.halfWidth*t.halfWidth},separateCircle:function(t,i,s){this.getOverlapX(t,i),this.getOverlapY(t,i);var n=i.center.x-t.center.x,r=i.center.y-t.center.y,o=Math.atan2(r,n),a=0;if(t.isCircle!==i.isCircle){var h={x:i.isCircle?t.position.x:i.position.x,y:i.isCircle?t.position.y:i.position.y,right:i.isCircle?t.right:i.right,bottom:i.isCircle?t.bottom:i.bottom},l={x:t.isCircle?t.center.x:i.center.x,y:t.isCircle?t.center.y:i.center.y,radius:t.isCircle?t.halfWidth:i.halfWidth};l.y<h.y?l.x<h.x?a=e.Math.distance(l.x,l.y,h.x,h.y)-l.radius:l.x>h.right&&(a=e.Math.distance(l.x,l.y,h.right,h.y)-l.radius):l.y>h.bottom&&(l.x<h.x?a=e.Math.distance(l.x,l.y,h.x,h.bottom)-l.radius:l.x>h.right&&(a=e.Math.distance(l.x,l.y,h.right,h.bottom)-l.radius)),a*=-1}else a=t.halfWidth+i.halfWidth-e.Math.distance(t.center.x,t.center.y,i.center.x,i.center.y);if(s||0===a||t.immovable&&i.immovable||t.customSeparateX||i.customSeparateX)return 0!==a&&(t.onOverlap&&t.onOverlap.dispatch(t.sprite,i.sprite),i.onOverlap&&i.onOverlap.dispatch(i.sprite,t.sprite)),0!==a;var c={x:t.velocity.x*Math.cos(o)+t.velocity.y*Math.sin(o),y:-t.velocity.x*Math.sin(o)+t.velocity.y*Math.cos(o)},u={x:i.velocity.x*Math.cos(o)+i.velocity.y*Math.sin(o),y:-i.velocity.x*Math.sin(o)+i.velocity.y*Math.cos(o)},d=((t.mass-i.mass)*c.x+2*i.mass*u.x)/(t.mass+i.mass),p=(2*t.mass*c.x+(i.mass-t.mass)*u.x)/(t.mass+i.mass);return t.immovable||(t.velocity.x=(d*Math.cos(o)-c.y*Math.sin(o))*t.bounce.x,t.velocity.y=(c.y*Math.cos(o)+d*Math.sin(o))*t.bounce.y),i.immovable||(i.velocity.x=(p*Math.cos(o)-u.y*Math.sin(o))*i.bounce.x,i.velocity.y=(u.y*Math.cos(o)+p*Math.sin(o))*i.bounce.y),Math.abs(o)<Math.PI/2?t.velocity.x>0&&!t.immovable&&i.velocity.x>t.velocity.x?t.velocity.x*=-1:i.velocity.x<0&&!i.immovable&&t.velocity.x<i.velocity.x?i.velocity.x*=-1:t.velocity.y>0&&!t.immovable&&i.velocity.y>t.velocity.y?t.velocity.y*=-1:i.velocity.y<0&&!i.immovable&&t.velocity.y<i.velocity.y&&(i.velocity.y*=-1):Math.abs(o)>Math.PI/2&&(t.velocity.x<0&&!t.immovable&&i.velocity.x<t.velocity.x?t.velocity.x*=-1:i.velocity.x>0&&!i.immovable&&t.velocity.x>i.velocity.x?i.velocity.x*=-1:t.velocity.y<0&&!t.immovable&&i.velocity.y<t.velocity.y?t.velocity.y*=-1:i.velocity.y>0&&!i.immovable&&t.velocity.x>i.velocity.y&&(i.velocity.y*=-1)),t.immovable||(t.x+=t.velocity.x*this.game.time.physicsElapsed-a*Math.cos(o),t.y+=t.velocity.y*this.game.time.physicsElapsed-a*Math.sin(o)),i.immovable||(i.x+=i.velocity.x*this.game.time.physicsElapsed+a*Math.cos(o),i.y+=i.velocity.y*this.game.time.physicsElapsed+a*Math.sin(o)),t.onCollide&&t.onCollide.dispatch(t.sprite,i.sprite),i.onCollide&&i.onCollide.dispatch(i.sprite,t.sprite),!0},getOverlapX:function(t,e,i){var s=0,n=t.deltaAbsX()+e.deltaAbsX()+this.OVERLAP_BIAS;return 0===t.deltaX()&&0===e.deltaX()?(t.embedded=!0,e.embedded=!0):t.deltaX()>e.deltaX()?(s=t.right-e.x)>n&&!i||!1===t.checkCollision.right||!1===e.checkCollision.left?s=0:(t.touching.none=!1,t.touching.right=!0,e.touching.none=!1,e.touching.left=!0):t.deltaX()<e.deltaX()&&(-(s=t.x-e.width-e.x)>n&&!i||!1===t.checkCollision.left||!1===e.checkCollision.right?s=0:(t.touching.none=!1,t.touching.left=!0,e.touching.none=!1,e.touching.right=!0)),t.overlapX=s,e.overlapX=s,s},getOverlapY:function(t,e,i){var s=0,n=t.deltaAbsY()+e.deltaAbsY()+this.OVERLAP_BIAS;return 0===t.deltaY()&&0===e.deltaY()?(t.embedded=!0,e.embedded=!0):t.deltaY()>e.deltaY()?(s=t.bottom-e.y)>n&&!i||!1===t.checkCollision.down||!1===e.checkCollision.up?s=0:(t.touching.none=!1,t.touching.down=!0,e.touching.none=!1,e.touching.up=!0):t.deltaY()<e.deltaY()&&(-(s=t.y-e.bottom)>n&&!i||!1===t.checkCollision.up||!1===e.checkCollision.down?s=0:(t.touching.none=!1,t.touching.up=!0,e.touching.none=!1,e.touching.down=!0)),t.overlapY=s,e.overlapY=s,s},separateX:function(t,e,i){var s=this.getOverlapX(t,e,i);if(i||0===s||t.immovable&&e.immovable||t.customSeparateX||e.customSeparateX)return 0!==s||t.embedded&&e.embedded;var n=t.velocity.x,r=e.velocity.x;if(t.immovable||e.immovable)t.immovable?(e.x+=s,e.velocity.x=n-r*e.bounce.x,t.moves&&(e.y+=(t.y-t.prev.y)*t.friction.y)):(t.x-=s,t.velocity.x=r-n*t.bounce.x,e.moves&&(t.y+=(e.y-e.prev.y)*e.friction.y));else{s*=.5,t.x-=s,e.x+=s;var o=Math.sqrt(r*r*e.mass/t.mass)*(r>0?1:-1),a=Math.sqrt(n*n*t.mass/e.mass)*(n>0?1:-1),h=.5*(o+a);o-=h,a-=h,t.velocity.x=h+o*t.bounce.x,e.velocity.x=h+a*e.bounce.x}return!0},separateY:function(t,e,i){var s=this.getOverlapY(t,e,i);if(i||0===s||t.immovable&&e.immovable||t.customSeparateY||e.customSeparateY)return 0!==s||t.embedded&&e.embedded;var n=t.velocity.y,r=e.velocity.y;if(t.immovable||e.immovable)t.immovable?(e.y+=s,e.velocity.y=n-r*e.bounce.y,t.moves&&(e.x+=(t.x-t.prev.x)*t.friction.x)):(t.y-=s,t.velocity.y=r-n*t.bounce.y,e.moves&&(t.x+=(e.x-e.prev.x)*e.friction.x));else{s*=.5,t.y-=s,e.y+=s;var o=Math.sqrt(r*r*e.mass/t.mass)*(r>0?1:-1),a=Math.sqrt(n*n*t.mass/e.mass)*(n>0?1:-1),h=.5*(o+a);o-=h,a-=h,t.velocity.y=h+o*t.bounce.y,e.velocity.y=h+a*e.bounce.y}return!0},getObjectsUnderPointer:function(t,e,i,s){if(0!==e.length&&t.exists)return this.getObjectsAtLocation(t.x,t.y,e,i,s,t)},getObjectsAtLocation:function(t,i,s,n,r,o){this.quadTree.clear(),this.quadTree.reset(this.game.world.bounds.x,this.game.world.bounds.y,this.game.world.bounds.width,this.game.world.bounds.height,this.maxObjects,this.maxLevels),this.quadTree.populate(s);for(var a=new e.Rectangle(t,i,1,1),h=[],l=this.quadTree.retrieve(a),c=0;c<l.length;c++)l[c].hitTest(t,i)&&(n&&n.call(r,o,l[c].sprite),h.push(l[c].sprite));return h},moveToObject:function(t,i,s,n){void 0===s&&(s=60),void 0===n&&(n=0);var r=e.Point.angle(i,t);return n>0&&(s=this.distanceBetween(t,i)/(n/1e3)),t.body.velocity.setToPolar(r,s),r},moveToPointer:function(t,e,i,s){void 0===e&&(e=60),i=i||this.game.input.activePointer,void 0===s&&(s=0);var n=this.angleToPointer(t,i);return s>0&&(e=this.distanceToPointer(t,i)/(s/1e3)),t.body.velocity.setToPolar(n,e),n},moveToXY:function(t,e,i,s,n){void 0===s&&(s=60),void 0===n&&(n=0);var r=Math.atan2(i-t.y,e-t.x);return n>0&&(s=this.distanceToXY(t,e,i)/(n/1e3)),t.body.velocity.setToPolar(r,s),r},velocityFromAngle:function(t,i,s){return void 0===i&&(i=60),(s=s||new e.Point).setToPolar(t,i,!0)},velocityFromRotation:function(t,i,s){return void 0===i&&(i=60),(s=s||new e.Point).setToPolar(t,i)},accelerationFromRotation:function(t,i,s){return void 0===i&&(i=60),(s=s||new e.Point).setToPolar(t,i)},accelerateToObject:function(t,e,i,s,n){void 0===i&&(i=60),void 0===s&&(s=1e3),void 0===n&&(n=1e3);var r=this.angleBetween(t,e);return t.body.acceleration.setToPolar(r,i),t.body.maxVelocity.setTo(s,n),r},accelerateToPointer:function(t,e,i,s,n){void 0===i&&(i=60),void 0===e&&(e=this.game.input.activePointer),void 0===s&&(s=1e3),void 0===n&&(n=1e3);var r=this.angleToPointer(t,e);return t.body.acceleration.setToPolar(r,i),t.body.maxVelocity.setTo(s,n),r},accelerateToXY:function(t,e,i,s,n,r){void 0===s&&(s=60),void 0===n&&(n=1e3),void 0===r&&(r=1e3);var o=this.angleToXY(t,e,i);return t.body.acceleration.setTo(o,s),t.body.maxVelocity.setTo(n,r),o},distanceBetween:function(t,e,i,s){void 0===i&&(i=!1);var n,r;return s?(n=t.centerX-e.centerX,r=t.centerY-e.centerY):i?(n=t.world.x-e.world.x,r=t.world.y-e.world.y):(n=t.x-e.x,r=t.y-e.y),Math.sqrt(n*n+r*r)},distanceToXY:function(t,e,i,s){void 0===s&&(s=!1);var n=s?t.world.x-e:t.x-e,r=s?t.world.y-i:t.y-i;return Math.sqrt(n*n+r*r)},distanceToPointer:function(t,e,i){void 0===e&&(e=this.game.input.activePointer),void 0===i&&(i=!1);var s=i?t.world.x-e.worldX:t.x-e.worldX,n=i?t.world.y-e.worldY:t.y-e.worldY;return Math.sqrt(s*s+n*n)},closest:function(t,e,i,s){for(var n=1/0,r=null,o=0,a=e.length;o<a;o++){var h=e[o],l=this.distanceBetween(t,h,i,s);l<n&&(r=h,n=l)}return r},farthest:function(t,e,i,s){for(var n=-1,r=null,o=0,a=e.length;o<a;o++){var h=e[o],l=this.distanceBetween(t,h,i,s);l>n&&(r=h,n=l)}return r},angleBetween:function(t,i,s){return void 0===s&&(s=!1),s?e.Point.angle(i.world,t.world):e.Point.angle(i,t)},angleBetweenCenters:function(t,e){var i=e.centerX-t.centerX,s=e.centerY-t.centerY;return Math.atan2(s,i)},angleToXY:function(t,e,i,s){return void 0===s&&(s=!1),s?Math.atan2(i-t.world.y,e-t.world.x):Math.atan2(i-t.y,e-t.x)},angleToPointer:function(t,e,i){return void 0===e&&(e=this.game.input.activePointer),void 0===i&&(i=!1),i?Math.atan2(e.worldY-t.world.y,e.worldX-t.world.x):Math.atan2(e.worldY-t.y,e.worldX-t.x)},worldAngleToPointer:function(t,e){return this.angleToPointer(t,e,!0)}},e.Physics.Arcade.Body=function(t){this.sprite=t,this.game=t.game,this.type=e.Physics.ARCADE,this.enable=!0,this.isCircle=!1,this.radius=0,this.offset=new e.Point,this.position=new e.Point(t.x,t.y),this.prev=new e.Point(this.position.x,this.position.y),this.allowRotation=!0,this.rotation=t.angle,this.preRotation=t.angle,this.width=t.width,this.height=t.height,this.sourceWidth=t.width,this.sourceHeight=t.height,t.texture&&(this.sourceWidth=t.texture.frame.width,this.sourceHeight=t.texture.frame.height),this.halfWidth=Math.abs(t.width/2),this.halfHeight=Math.abs(t.height/2),this.center=new e.Point(t.x+this.halfWidth,t.y+this.halfHeight),this.velocity=new e.Point,this.newVelocity=new e.Point,this.deltaMax=new e.Point,this.acceleration=new e.Point,this.allowDrag=!0,this.drag=new e.Point,this.allowGravity=!0,this.gravity=new e.Point,this.bounce=new e.Point,this.worldBounce=null,this.onWorldBounds=null,this.onCollide=null,this.onOverlap=null,this.maxVelocity=new e.Point(1e4,1e4),this.friction=new e.Point(1,0),this.angularVelocity=0,this.angularAcceleration=0,this.angularDrag=0,this.maxAngular=1e3,this.mass=1,this.angle=0,this.speed=0,this.facing=e.NONE,this.immovable=!1,this.moves=!0,this.customSeparateX=!1,this.customSeparateY=!1,this.overlapX=0,this.overlapY=0,this.overlapR=0,this.embedded=!1,this.collideWorldBounds=!1,this.checkCollision={none:!1,up:!0,down:!0,left:!0,right:!0},this.touching={none:!0,up:!1,down:!1,left:!1,right:!1},this.wasTouching={none:!0,up:!1,down:!1,left:!1,right:!1},this.blocked={none:!0,up:!1,down:!1,left:!1,right:!1},this.tilePadding=new e.Point,this.dirty=!1,this.skipQuadTree=!1,this.syncBounds=!1,this.isMoving=!1,this.stopVelocityOnCollide=!0,this.moveTimer=0,this.moveDistance=0,this.moveDuration=0,this.moveTarget=null,this.moveEnd=null,this.onMoveComplete=new e.Signal,this.movementCallback=null,this.movementCallbackContext=null,this._reset=!0,this._sx=t.scale.x,this._sy=t.scale.y,this._dx=0,this._dy=0},e.Physics.Arcade.Body.prototype={updateBounds:function(){if(this.syncBounds){var t=this.sprite.getBounds();t.ceilAll(),t.width===this.width&&t.height===this.height||(this.width=t.width,this.height=t.height,this._reset=!0)}else{var e=Math.abs(this.sprite.scale.x),i=Math.abs(this.sprite.scale.y);e===this._sx&&i===this._sy||(this.width=this.sourceWidth*e,this.height=this.sourceHeight*i,this._sx=e,this._sy=i,this._reset=!0)}this._reset&&(this.halfWidth=Math.floor(this.width/2),this.halfHeight=Math.floor(this.height/2),this.updateCenter())},updateCenter:function(){this.center.setTo(this.position.x+this.halfWidth,this.position.y+this.halfHeight)},preUpdate:function(){this.enable&&!this.game.physics.arcade.isPaused&&(this.dirty=!0,this.wasTouching.none=this.touching.none,this.wasTouching.up=this.touching.up,this.wasTouching.down=this.touching.down,this.wasTouching.left=this.touching.left,this.wasTouching.right=this.touching.right,this.touching.none=!0,this.touching.up=!1,this.touching.down=!1,this.touching.left=!1,this.touching.right=!1,this.blocked.none=!0,this.blocked.up=!1,this.blocked.down=!1,this.blocked.left=!1,this.blocked.right=!1,this.overlapR=0,this.overlapX=0,this.overlapY=0,this.embedded=!1,this.updateBounds(),this.position.x=this.sprite.world.x-this.sprite.anchor.x*this.sprite.width+this.sprite.scale.x*this.offset.x,this.position.x-=this.sprite.scale.x<0?this.width:0,this.position.y=this.sprite.world.y-this.sprite.anchor.y*this.sprite.height+this.sprite.scale.y*this.offset.y,this.position.y-=this.sprite.scale.y<0?this.height:0,this.updateCenter(),this.rotation=this.sprite.angle,this.preRotation=this.rotation,(this._reset||this.sprite.fresh)&&(this.prev.x=this.position.x,this.prev.y=this.position.y),this.moves&&(this.game.physics.arcade.updateMotion(this),this.newVelocity.set(this.velocity.x*this.game.time.physicsElapsed,this.velocity.y*this.game.time.physicsElapsed),this.position.x+=this.newVelocity.x,this.position.y+=this.newVelocity.y,this.updateCenter(),this.position.x===this.prev.x&&this.position.y===this.prev.y||(this.angle=this.velocity.atan()),this.speed=Math.sqrt(this.velocity.x*this.velocity.x+this.velocity.y*this.velocity.y),this.collideWorldBounds&&this.checkWorldBounds()&&this.onWorldBounds&&this.onWorldBounds.dispatch(this.sprite,this.blocked.up,this.blocked.down,this.blocked.left,this.blocked.right)),this._dx=this.deltaX(),this._dy=this.deltaY(),this._reset=!1)},updateMovement:function(){var t=0,e=0!==this.overlapX||0!==this.overlapY;if(this.moveDuration>0?(this.moveTimer+=this.game.time.elapsedMS,t=this.moveTimer/this.moveDuration):(this.moveTarget.end.set(this.position.x,this.position.y),t=this.moveTarget.length/this.moveDistance),this.movementCallback)var i=this.movementCallback.call(this.movementCallbackContext,this,this.velocity,t);return!(e||t>=1||void 0!==i&&!0!==i)||(this.stopMovement(t>=1||this.stopVelocityOnCollide&&e),!1)},stopMovement:function(t){this.isMoving&&(this.isMoving=!1,t&&this.velocity.set(0),this.onMoveComplete.dispatch(this.sprite,0!==this.overlapX||0!==this.overlapY))},postUpdate:function(){this.enable&&this.dirty&&(this.isMoving&&this.updateMovement(),this.dirty=!1,this.deltaX()<0?this.facing=e.LEFT:this.deltaX()>0&&(this.facing=e.RIGHT),this.deltaY()<0?this.facing=e.UP:this.deltaY()>0&&(this.facing=e.DOWN),this.moves&&(this._dx=this.deltaX(),this._dy=this.deltaY(),0!==this.deltaMax.x&&0!==this._dx&&(this._dx<0&&this._dx<-this.deltaMax.x?this._dx=-this.deltaMax.x:this._dx>0&&this._dx>this.deltaMax.x&&(this._dx=this.deltaMax.x)),0!==this.deltaMax.y&&0!==this._dy&&(this._dy<0&&this._dy<-this.deltaMax.y?this._dy=-this.deltaMax.y:this._dy>0&&this._dy>this.deltaMax.y&&(this._dy=this.deltaMax.y)),this.sprite.position.x+=this._dx,this.sprite.position.y+=this._dy,this._reset=!0),this.updateCenter(),this.allowRotation&&(this.sprite.angle+=this.deltaZ()),this.prev.x=this.position.x,this.prev.y=this.position.y)},checkWorldBounds:function(){var t=this.position,e=this.game.physics.arcade.bounds,i=this.game.physics.arcade.checkCollision,s=this.worldBounce?-this.worldBounce.x:-this.bounce.x,n=this.worldBounce?-this.worldBounce.y:-this.bounce.y;return t.x<e.x&&i.left?(t.x=e.x,this.velocity.x*=s,this.blocked.left=!0,this.blocked.none=!1):this.right>e.right&&i.right&&(t.x=e.right-this.width,this.velocity.x*=s,this.blocked.right=!0,this.blocked.none=!1),t.y<e.y&&i.up?(t.y=e.y,this.velocity.y*=n,this.blocked.up=!0,this.blocked.none=!1):this.bottom>e.bottom&&i.down&&(t.y=e.bottom-this.height,this.velocity.y*=n,this.blocked.down=!0,this.blocked.none=!1),!this.blocked.none},moveFrom:function(t,e,i){if(void 0===e&&(e=this.speed),0===e)return!1;var s;return void 0===i?(s=this.angle,i=this.game.math.radToDeg(s)):s=this.game.math.degToRad(i),this.moveTimer=0,this.moveDuration=t,0===i||180===i?this.velocity.set(Math.cos(s)*e,0):90===i||270===i?this.velocity.set(0,Math.sin(s)*e):this.velocity.setToPolar(s,e),this.isMoving=!0,!0},moveTo:function(t,i,s){var n=i/(t/1e3);if(0===n)return!1;var r;return void 0===s?(r=this.angle,s=this.game.math.radToDeg(r)):r=this.game.math.degToRad(s),i=Math.abs(i),this.moveDuration=0,this.moveDistance=i,null===this.moveTarget&&(this.moveTarget=new e.Line,this.moveEnd=new e.Point),this.moveTarget.fromAngle(this.x,this.y,r,i),this.moveEnd.set(this.moveTarget.end.x,this.moveTarget.end.y),this.moveTarget.setTo(this.x,this.y,this.x,this.y),0===s||180===s?this.velocity.set(Math.cos(r)*n,0):90===s||270===s?this.velocity.set(0,Math.sin(r)*n):this.velocity.setToPolar(r,n),this.isMoving=!0,!0},setSize:function(t,e,i,s){void 0===i&&(i=this.offset.x),void 0===s&&(s=this.offset.y),this.sourceWidth=t,this.sourceHeight=e,this.width=this.sourceWidth*this._sx,this.height=this.sourceHeight*this._sy,this.halfWidth=Math.floor(this.width/2),this.halfHeight=Math.floor(this.height/2),this.offset.setTo(i,s),this.updateCenter(),this.isCircle=!1,this.radius=0},setCircle:function(t,e,i){void 0===e&&(e=this.offset.x),void 0===i&&(i=this.offset.y),t>0?(this.isCircle=!0,this.radius=t,this.sourceWidth=2*t,this.sourceHeight=2*t,this.width=this.sourceWidth*this._sx,this.height=this.sourceHeight*this._sy,this.halfWidth=Math.floor(this.width/2),this.halfHeight=Math.floor(this.height/2),this.offset.setTo(e,i),this.updateCenter()):this.isCircle=!1},reset:function(t,e){this.stop(),this.position.x=t-this.sprite.anchor.x*this.sprite.width+this.sprite.scale.x*this.offset.x,this.position.x-=this.sprite.scale.x<0?this.width:0,this.position.y=e-this.sprite.anchor.y*this.sprite.height+this.sprite.scale.y*this.offset.y,this.position.y-=this.sprite.scale.y<0?this.height:0,this.prev.x=this.position.x,this.prev.y=this.position.y,this.rotation=this.sprite.angle,this.preRotation=this.rotation,this.updateBounds(),this.updateCenter()},stop:function(){this.velocity.set(0),this.acceleration.set(0),this.speed=0,this.angularVelocity=0,this.angularAcceleration=0},getBounds:function(t){return t.x=this.x,t.y=this.y,t.right=this.right,t.bottom=this.bottom,t},hitTest:function(t,i){return this.isCircle?e.Circle.contains(this,t,i):e.Rectangle.contains(this,t,i)},onFloor:function(){return this.blocked.down},onCeiling:function(){return this.blocked.up},onWall:function(){return this.blocked.left||this.blocked.right},deltaAbsX:function(){return this.deltaX()>0?this.deltaX():-this.deltaX()},deltaAbsY:function(){return this.deltaY()>0?this.deltaY():-this.deltaY()},deltaX:function(){return this.position.x-this.prev.x},deltaY:function(){return this.position.y-this.prev.y},deltaZ:function(){return this.rotation-this.preRotation},destroy:function(){this.sprite.parent&&this.sprite.parent instanceof e.Group&&this.sprite.parent.removeFromHash(this.sprite),this.sprite.body=null,this.sprite=null}},Object.defineProperty(e.Physics.Arcade.Body.prototype,"left",{get:function(){return this.position.x}}),Object.defineProperty(e.Physics.Arcade.Body.prototype,"right",{get:function(){return this.position.x+this.width}}),Object.defineProperty(e.Physics.Arcade.Body.prototype,"top",{get:function(){return this.position.y}}),Object.defineProperty(e.Physics.Arcade.Body.prototype,"bottom",{get:function(){return this.position.y+this.height}}),Object.defineProperty(e.Physics.Arcade.Body.prototype,"x",{get:function(){return this.position.x},set:function(t){this.position.x=t}}),Object.defineProperty(e.Physics.Arcade.Body.prototype,"y",{get:function(){return this.position.y},set:function(t){this.position.y=t}}),e.Physics.Arcade.Body.render=function(t,e,i,s,n){void 0===s&&(s=!0),i=i||"rgba(0,255,0,0.4)",t.fillStyle=i,t.strokeStyle=i,t.lineWidth=n||1,e.isCircle?(t.beginPath(),t.arc(e.center.x-e.game.camera.x,e.center.y-e.game.camera.y,e.halfWidth,0,2*Math.PI),s?t.fill():t.stroke()):s?t.fillRect(e.position.x-e.game.camera.x,e.position.y-e.game.camera.y,e.width,e.height):t.strokeRect(e.position.x-e.game.camera.x,e.position.y-e.game.camera.y,e.width,e.height)},e.Physics.Arcade.Body.renderBodyInfo=function(t,e){t.line("x: "+e.x.toFixed(2),"y: "+e.y.toFixed(2),"width: "+e.width,"height: "+e.height),t.line("velocity x: "+e.velocity.x.toFixed(2),"y: "+e.velocity.y.toFixed(2),"deltaX: "+e._dx.toFixed(2),"deltaY: "+e._dy.toFixed(2)),t.line("acceleration x: "+e.acceleration.x.toFixed(2),"y: "+e.acceleration.y.toFixed(2),"speed: "+e.speed.toFixed(2),"angle: "+e.angle.toFixed(2)),t.line("gravity x: "+e.gravity.x,"y: "+e.gravity.y,"bounce x: "+e.bounce.x.toFixed(2),"y: "+e.bounce.y.toFixed(2)),t.line("touching left: "+e.touching.left,"right: "+e.touching.right,"up: "+e.touching.up,"down: "+e.touching.down),t.line("blocked left: "+e.blocked.left,"right: "+e.blocked.right,"up: "+e.blocked.up,"down: "+e.blocked.down)},e.Physics.Arcade.Body.prototype.constructor=e.Physics.Arcade.Body,e.Physics.Arcade.TilemapCollision=function(){},e.Physics.Arcade.TilemapCollision.prototype={TILE_BIAS:16,collideSpriteVsTilemapLayer:function(t,e,i,s,n,r){if(t.body){var o=e.getTiles(t.body.position.x-t.body.tilePadding.x-e.getTileOffsetX(),t.body.position.y-t.body.tilePadding.y-e.getTileOffsetY(),t.body.width+t.body.tilePadding.x,t.body.height+t.body.tilePadding.y,!1,!1);if(0!==o.length)for(var a=0;a<o.length;a++)s?s.call(n,t,o[a])&&this.separateTile(a,t.body,o[a],e,r)&&(this._total++,i&&i.call(n,t,o[a])):this.separateTile(a,t.body,o[a],e,r)&&(this._total++,i&&i.call(n,t,o[a]))}},collideGroupVsTilemapLayer:function(t,e,i,s,n,r){if(0!==t.length)for(var o=0;o<t.children.length;o++)t.children[o].exists&&this.collideSpriteVsTilemapLayer(t.children[o],e,i,s,n,r)},separateTile:function(t,e,i,s,n){if(!e.enable)return!1;var r=s.getTileOffsetX(),o=s.getTileOffsetY();if(!i.intersects(e.position.x-r,e.position.y-o,e.right-r,e.bottom-o))return!1;if(n)return!0;if(i.collisionCallback&&!i.collisionCallback.call(i.collisionCallbackContext,e.sprite,i))return!1;if(void 0!==i.layer.callbacks&&i.layer.callbacks[i.index]&&!i.layer.callbacks[i.index].callback.call(i.layer.callbacks[i.index].callbackContext,e.sprite,i))return!1;if(!(i.faceLeft||i.faceRight||i.faceTop||i.faceBottom))return!1;var a=0,h=0,l=0,c=1;if(e.deltaAbsX()>e.deltaAbsY()?l=-1:e.deltaAbsX()<e.deltaAbsY()&&(c=-1),0!==e.deltaX()&&0!==e.deltaY()&&(i.faceLeft||i.faceRight)&&(i.faceTop||i.faceBottom)&&(l=Math.min(Math.abs(e.position.x-r-i.right),Math.abs(e.right-r-i.left)),c=Math.min(Math.abs(e.position.y-o-i.bottom),Math.abs(e.bottom-o-i.top))),l<c){if((i.faceLeft||i.faceRight)&&0!==(a=this.tileCheckX(e,i,s))&&!i.intersects(e.position.x-r,e.position.y-o,e.right-r,e.bottom-o))return!0;(i.faceTop||i.faceBottom)&&(h=this.tileCheckY(e,i,s))}else{if((i.faceTop||i.faceBottom)&&0!==(h=this.tileCheckY(e,i,s))&&!i.intersects(e.position.x-r,e.position.y-o,e.right-r,e.bottom-o))return!0;(i.faceLeft||i.faceRight)&&(a=this.tileCheckX(e,i,s))}return 0!==a||0!==h},tileCheckX:function(t,e,i){var s=0,n=i.getTileOffsetX();return t.deltaX()<0&&!t.blocked.left&&e.collideRight&&t.checkCollision.left?e.faceRight&&t.x-n<e.right&&(s=t.x-n-e.right)<-this.TILE_BIAS&&(s=0):t.deltaX()>0&&!t.blocked.right&&e.collideLeft&&t.checkCollision.right&&e.faceLeft&&t.right-n>e.left&&(s=t.right-n-e.left)>this.TILE_BIAS&&(s=0),0!==s&&(t.customSeparateX?t.overlapX=s:this.processTileSeparationX(t,s)),s},tileCheckY:function(t,e,i){var s=0,n=i.getTileOffsetY();return t.deltaY()<0&&!t.blocked.up&&e.collideDown&&t.checkCollision.up?e.faceBottom&&t.y-n<e.bottom&&(s=t.y-n-e.bottom)<-this.TILE_BIAS&&(s=0):t.deltaY()>0&&!t.blocked.down&&e.collideUp&&t.checkCollision.down&&e.faceTop&&t.bottom-n>e.top&&(s=t.bottom-n-e.top)>this.TILE_BIAS&&(s=0),0!==s&&(t.customSeparateY?t.overlapY=s:this.processTileSeparationY(t,s)),s},processTileSeparationX:function(t,e){e<0?(t.blocked.left=!0,t.blocked.none=!1):e>0&&(t.blocked.right=!0,t.blocked.none=!1),t.position.x-=e,0===t.bounce.x?t.velocity.x=0:t.velocity.x=-t.velocity.x*t.bounce.x},processTileSeparationY:function(t,e){e<0?(t.blocked.up=!0,t.blocked.none=!1):e>0&&(t.blocked.down=!0,t.blocked.none=!1),t.position.y-=e,0===t.bounce.y?t.velocity.y=0:t.velocity.y=-t.velocity.y*t.bounce.y}},e.Utils.mixinPrototype(e.Physics.Arcade.prototype,e.Physics.Arcade.TilemapCollision.prototype),p2.Body.prototype.parent=null,p2.Spring.prototype.parent=null,e.Physics.P2=function(t,i){this.game=t,void 0===i?i={gravity:[0,0],broadphase:new p2.SAPBroadphase}:(i.hasOwnProperty("gravity")||(i.gravity=[0,0]),i.hasOwnProperty("broadphase")||(i.broadphase=new p2.SAPBroadphase)),this.config=i,this.world=new p2.World(this.config),this.frameRate=1/60,this.useElapsedTime=!1,this.paused=!1,this.materials=[],this.gravity=new e.Physics.P2.InversePointProxy(this,this.world.gravity),this.walls={left:null,right:null,top:null,bottom:null},this.onBodyAdded=new e.Signal,this.onBodyRemoved=new e.Signal,this.onSpringAdded=new e.Signal,this.onSpringRemoved=new e.Signal,this.onConstraintAdded=new e.Signal,this.onConstraintRemoved=new e.Signal,this.onContactMaterialAdded=new e.Signal,this.onContactMaterialRemoved=new e.Signal,this.postBroadphaseCallback=null,this.callbackContext=null,this.onBeginContact=new e.Signal,this.onEndContact=new e.Signal,i.hasOwnProperty("mpx")&&i.hasOwnProperty("pxm")&&i.hasOwnProperty("mpxi")&&i.hasOwnProperty("pxmi")&&(this.mpx=i.mpx,this.mpxi=i.mpxi,this.pxm=i.pxm,this.pxmi=i.pxmi),this.world.on("beginContact",this.beginContactHandler,this),this.world.on("endContact",this.endContactHandler,this),this.collisionGroups=[],this.nothingCollisionGroup=new e.Physics.P2.CollisionGroup(1),this.boundsCollisionGroup=new e.Physics.P2.CollisionGroup(2),this.everythingCollisionGroup=new e.Physics.P2.CollisionGroup(2147483648),this.boundsCollidesWith=[],this._toRemove=[],this._collisionGroupID=2,this._boundsLeft=!0,this._boundsRight=!0,this._boundsTop=!0,this._boundsBottom=!0,this._boundsOwnGroup=!1,this.setBoundsToWorld(!0,!0,!0,!0,!1)},e.Physics.P2.prototype={removeBodyNextStep:function(t){this._toRemove.push(t)},preUpdate:function(){for(var t=this._toRemove.length;t--;)this.removeBody(this._toRemove[t]);this._toRemove.length=0},enable:function(t,i,s){void 0===i&&(i=!1),void 0===s&&(s=!0);var n=1;if(Array.isArray(t))for(n=t.length;n--;)t[n]instanceof e.Group?this.enable(t[n].children,i,s):(this.enableBody(t[n],i),s&&t[n].hasOwnProperty("children")&&t[n].children.length>0&&this.enable(t[n],i,!0));else t instanceof e.Group?this.enable(t.children,i,s):(this.enableBody(t,i),s&&t.hasOwnProperty("children")&&t.children.length>0&&this.enable(t.children,i,!0))},enableBody:function(t,i){t.hasOwnProperty("body")&&null===t.body&&(t.body=new e.Physics.P2.Body(this.game,t,t.x,t.y,1),t.body.debug=i,void 0!==t.anchor&&t.anchor.set(.5))},setImpactEvents:function(t){t?this.world.on("impact",this.impactHandler,this):this.world.off("impact",this.impactHandler,this)},setPostBroadphaseCallback:function(t,e){this.postBroadphaseCallback=t,this.callbackContext=e,null!==t?this.world.on("postBroadphase",this.postBroadphaseHandler,this):this.world.off("postBroadphase",this.postBroadphaseHandler,this)},postBroadphaseHandler:function(t){if(this.postBroadphaseCallback&&0!==t.pairs.length)for(var e=t.pairs.length-2;e>=0;e-=2)t.pairs[e].parent&&t.pairs[e+1].parent&&!this.postBroadphaseCallback.call(this.callbackContext,t.pairs[e].parent,t.pairs[e+1].parent)&&t.pairs.splice(e,2)},impactHandler:function(t){if(t.bodyA.parent&&t.bodyB.parent){var e=t.bodyA.parent,i=t.bodyB.parent;e._bodyCallbacks[t.bodyB.id]&&e._bodyCallbacks[t.bodyB.id].call(e._bodyCallbackContext[t.bodyB.id],e,i,t.shapeA,t.shapeB),i._bodyCallbacks[t.bodyA.id]&&i._bodyCallbacks[t.bodyA.id].call(i._bodyCallbackContext[t.bodyA.id],i,e,t.shapeB,t.shapeA),e._groupCallbacks[t.shapeB.collisionGroup]&&e._groupCallbacks[t.shapeB.collisionGroup].call(e._groupCallbackContext[t.shapeB.collisionGroup],e,i,t.shapeA,t.shapeB),i._groupCallbacks[t.shapeA.collisionGroup]&&i._groupCallbacks[t.shapeA.collisionGroup].call(i._groupCallbackContext[t.shapeA.collisionGroup],i,e,t.shapeB,t.shapeA)}},beginContactHandler:function(t){t.bodyA&&t.bodyB&&(this.onBeginContact.dispatch(t.bodyA,t.bodyB,t.shapeA,t.shapeB,t.contactEquations),t.bodyA.parent&&t.bodyA.parent.onBeginContact.dispatch(t.bodyB.parent,t.bodyB,t.shapeA,t.shapeB,t.contactEquations),t.bodyB.parent&&t.bodyB.parent.onBeginContact.dispatch(t.bodyA.parent,t.bodyA,t.shapeB,t.shapeA,t.contactEquations))},endContactHandler:function(t){t.bodyA&&t.bodyB&&(this.onEndContact.dispatch(t.bodyA,t.bodyB,t.shapeA,t.shapeB),t.bodyA.parent&&t.bodyA.parent.onEndContact.dispatch(t.bodyB.parent,t.bodyB,t.shapeA,t.shapeB),t.bodyB.parent&&t.bodyB.parent.onEndContact.dispatch(t.bodyA.parent,t.bodyA,t.shapeB,t.shapeA))},setBoundsToWorld:function(t,e,i,s,n){this.setBounds(this.game.world.bounds.x,this.game.world.bounds.y,this.game.world.bounds.width,this.game.world.bounds.height,t,e,i,s,n)},setWorldMaterial:function(t,e,i,s,n){void 0===e&&(e=!0),void 0===i&&(i=!0),void 0===s&&(s=!0),void 0===n&&(n=!0),e&&this.walls.left&&(this.walls.left.shapes[0].material=t),i&&this.walls.right&&(this.walls.right.shapes[0].material=t),s&&this.walls.top&&(this.walls.top.shapes[0].material=t),n&&this.walls.bottom&&(this.walls.bottom.shapes[0].material=t)},updateBoundsCollisionGroup:function(t){void 0===t&&(t=!0);var e=t?this.boundsCollisionGroup.mask:this.everythingCollisionGroup.mask;this.walls.left&&(this.walls.left.shapes[0].collisionGroup=e),this.walls.right&&(this.walls.right.shapes[0].collisionGroup=e),this.walls.top&&(this.walls.top.shapes[0].collisionGroup=e),this.walls.bottom&&(this.walls.bottom.shapes[0].collisionGroup=e),this._boundsOwnGroup=t},setBounds:function(t,e,i,s,n,r,o,a,h){void 0===n&&(n=this._boundsLeft),void 0===r&&(r=this._boundsRight),void 0===o&&(o=this._boundsTop),void 0===a&&(a=this._boundsBottom),void 0===h&&(h=this._boundsOwnGroup),this.setupWall(n,"left",t,e,1.5707963267948966,h),this.setupWall(r,"right",t+i,e,-1.5707963267948966,h),this.setupWall(o,"top",t,e,-3.141592653589793,h),this.setupWall(a,"bottom",t,e+s,0,h),this._boundsLeft=n,this._boundsRight=r,this._boundsTop=o,this._boundsBottom=a,this._boundsOwnGroup=h},setupWall:function(t,e,i,s,n,r){t?(this.walls[e]?this.walls[e].position=[this.pxmi(i),this.pxmi(s)]:(this.walls[e]=new p2.Body({mass:0,position:[this.pxmi(i),this.pxmi(s)],angle:n}),this.walls[e].addShape(new p2.Plane),this.world.addBody(this.walls[e])),r&&(this.walls[e].shapes[0].collisionGroup=this.boundsCollisionGroup.mask)):this.walls[e]&&(this.world.removeBody(this.walls[e]),this.walls[e]=null)},pause:function(){this.paused=!0},resume:function(){this.paused=!1},update:function(){this.paused||(this.useElapsedTime?this.world.step(this.game.time.physicsElapsed):this.world.step(this.frameRate))},reset:function(){this.world.on("beginContact",this.beginContactHandler,this),this.world.on("endContact",this.endContactHandler,this),this.nothingCollisionGroup=new e.Physics.P2.CollisionGroup(1),this.boundsCollisionGroup=new e.Physics.P2.CollisionGroup(2),this.everythingCollisionGroup=new e.Physics.P2.CollisionGroup(2147483648),this._collisionGroupID=2,this.setBoundsToWorld(!0,!0,!0,!0,!1)},clear:function(){this.world.time=0,this.world.fixedStepTime=0,this.world.solver&&this.world.solver.equations.length&&this.world.solver.removeAllEquations();for(var t=this.world.constraints,e=t.length-1;e>=0;e--)this.world.removeConstraint(t[e]);for(var i=this.world.bodies,e=i.length-1;e>=0;e--)this.world.removeBody(i[e]);for(var s=this.world.springs,e=s.length-1;e>=0;e--)this.world.removeSpring(s[e]);for(var n=this.world.contactMaterials,e=n.length-1;e>=0;e--)this.world.removeContactMaterial(n[e]);this.world.off("beginContact",this.beginContactHandler,this),this.world.off("endContact",this.endContactHandler,this),this.postBroadphaseCallback=null,this.callbackContext=null,this.impactCallback=null,this.collisionGroups=[],this._toRemove=[],this.boundsCollidesWith=[],this.walls={left:null,right:null,top:null,bottom:null}},destroy:function(){this.clear(),this.game=null},addBody:function(t){return!t.data.world&&(this.world.addBody(t.data),this.onBodyAdded.dispatch(t),!0)},removeBody:function(t){return t.data.world===this.world&&(this.world.removeBody(t.data),this.onBodyRemoved.dispatch(t)),t},addSpring:function(t){return t instanceof e.Physics.P2.Spring||t instanceof e.Physics.P2.RotationalSpring?this.world.addSpring(t.data):this.world.addSpring(t),this.onSpringAdded.dispatch(t),t},removeSpring:function(t){return t instanceof e.Physics.P2.Spring||t instanceof e.Physics.P2.RotationalSpring?this.world.removeSpring(t.data):this.world.removeSpring(t),this.onSpringRemoved.dispatch(t),t},createDistanceConstraint:function(t,i,s,n,r,o){if(t=this.getBody(t),i=this.getBody(i),t&&i)return this.addConstraint(new e.Physics.P2.DistanceConstraint(this,t,i,s,n,r,o));console.warn("Cannot create Constraint, invalid body objects given")},createGearConstraint:function(t,i,s,n){if(t=this.getBody(t),i=this.getBody(i),t&&i)return this.addConstraint(new e.Physics.P2.GearConstraint(this,t,i,s,n));console.warn("Cannot create Constraint, invalid body objects given")},createRevoluteConstraint:function(t,i,s,n,r,o){if(t=this.getBody(t),s=this.getBody(s),t&&s)return this.addConstraint(new e.Physics.P2.RevoluteConstraint(this,t,i,s,n,r,o));console.warn("Cannot create Constraint, invalid body objects given")},createLockConstraint:function(t,i,s,n,r){if(t=this.getBody(t),i=this.getBody(i),t&&i)return this.addConstraint(new e.Physics.P2.LockConstraint(this,t,i,s,n,r));console.warn("Cannot create Constraint, invalid body objects given")},createPrismaticConstraint:function(t,i,s,n,r,o,a){if(t=this.getBody(t),i=this.getBody(i),t&&i)return this.addConstraint(new e.Physics.P2.PrismaticConstraint(this,t,i,s,n,r,o,a));console.warn("Cannot create Constraint, invalid body objects given")},addConstraint:function(t){return this.world.addConstraint(t),this.onConstraintAdded.dispatch(t),t},removeConstraint:function(t){return this.world.removeConstraint(t),this.onConstraintRemoved.dispatch(t),t},addContactMaterial:function(t){return this.world.addContactMaterial(t),this.onContactMaterialAdded.dispatch(t),t},removeContactMaterial:function(t){return this.world.removeContactMaterial(t),this.onContactMaterialRemoved.dispatch(t),t},getContactMaterial:function(t,e){return this.world.getContactMaterial(t,e)},setMaterial:function(t,e){for(var i=e.length;i--;)e[i].setMaterial(t)},createMaterial:function(t,i){t=t||"";var s=new e.Physics.P2.Material(t);return this.materials.push(s),void 0!==i&&i.setMaterial(s),s},createContactMaterial:function(t,i,s){void 0===t&&(t=this.createMaterial()),void 0===i&&(i=this.createMaterial());var n=new e.Physics.P2.ContactMaterial(t,i,s);return this.addContactMaterial(n)},getBodies:function(){for(var t=[],e=this.world.bodies.length;e--;)t.push(this.world.bodies[e].parent);return t},getBody:function(t){return t instanceof p2.Body?t:t instanceof e.Physics.P2.Body?t.data:t.body&&t.body.type===e.Physics.P2JS?t.body.data:null},getSprings:function(){for(var t=[],e=this.world.springs.length;e--;)t.push(this.world.springs[e].parent);return t},getConstraints:function(){for(var t=[],e=this.world.constraints.length;e--;)t.push(this.world.constraints[e]);return t},hitTest:function(t,i,s,n){void 0===i&&(i=this.world.bodies),void 0===s&&(s=5),void 0===n&&(n=!1);for(var r=[this.pxmi(t.x),this.pxmi(t.y)],o=[],a=i.length;a--;)i[a]instanceof e.Physics.P2.Body&&(!n||i[a].data.type!==p2.Body.STATIC)?o.push(i[a].data):i[a]instanceof p2.Body&&i[a].parent&&(!n||i[a].type!==p2.Body.STATIC)?o.push(i[a]):i[a]instanceof e.Sprite&&i[a].hasOwnProperty("body")&&(!n||i[a].body.data.type!==p2.Body.STATIC)&&o.push(i[a].body.data);return this.world.hitTest(r,o,s)},toJSON:function(){return this.world.toJSON()},createCollisionGroup:function(t){var i=Math.pow(2,this._collisionGroupID);this.walls.left&&(this.walls.left.shapes[0].collisionMask=this.walls.left.shapes[0].collisionMask|i),this.walls.right&&(this.walls.right.shapes[0].collisionMask=this.walls.right.shapes[0].collisionMask|i),this.walls.top&&(this.walls.top.shapes[0].collisionMask=this.walls.top.shapes[0].collisionMask|i),this.walls.bottom&&(this.walls.bottom.shapes[0].collisionMask=this.walls.bottom.shapes[0].collisionMask|i),this._collisionGroupID++;var s=new e.Physics.P2.CollisionGroup(i);return this.collisionGroups.push(s),t&&this.setCollisionGroup(t,s),s},setCollisionGroup:function(t,i){if(t instanceof e.Group)for(var s=0;s<t.total;s++)t.children[s].body&&t.children[s].body.type===e.Physics.P2JS&&t.children[s].body.setCollisionGroup(i);else t.body.setCollisionGroup(i)},createSpring:function(t,i,s,n,r,o,a,h,l){if(t=this.getBody(t),i=this.getBody(i),t&&i)return this.addSpring(new e.Physics.P2.Spring(this,t,i,s,n,r,o,a,h,l));console.warn("Cannot create Spring, invalid body objects given")},createRotationalSpring:function(t,i,s,n,r){if(t=this.getBody(t),i=this.getBody(i),t&&i)return this.addSpring(new e.Physics.P2.RotationalSpring(this,t,i,s,n,r));console.warn("Cannot create Rotational Spring, invalid body objects given")},createBody:function(t,i,s,n,r,o){void 0===n&&(n=!1);var a=new e.Physics.P2.Body(this.game,null,t,i,s);return!(o&&!a.addPolygon(r,o))&&(n&&this.world.addBody(a.data),a)},createParticle:function(t,i,s,n,r,o){void 0===n&&(n=!1);var a=new e.Physics.P2.Body(this.game,null,t,i,s);return!(o&&!a.addPolygon(r,o))&&(n&&this.world.addBody(a.data),a)},convertCollisionObjects:function(t,e,i){void 0===i&&(i=!0);for(var s=[],n=0,r=t.collision[e].length;n<r;n++){var o=t.collision[e][n],a=o.polyline||o.polygon;if(a)var h=this.createBody(o.x,o.y,0,i,{},a);else o.rectangle&&(h=this.createBody(o.x,o.y,0,i)).addRectangle(o.width,o.height,o.width/2,o.height/2);h&&s.push(h)}return s},clearTilemapLayerBodies:function(t,e){e=t.getLayer(e);for(var i=t.layers[e].bodies.length;i--;)t.layers[e].bodies[i].destroy();t.layers[e].bodies.length=0},convertTilemap:function(t,e,i,s){e=t.getLayer(e),void 0===i&&(i=!0),void 0===s&&(s=!0),this.clearTilemapLayerBodies(t,e);for(var n=0,r=0,o=0,a=0,h=t.layers[e].height;a<h;a++){n=0;for(var l=0,c=t.layers[e].width;l<c;l++){var u=t.layers[e].data[a][l];if(u&&u.index>-1&&u.collides)if(s){var d=t.getTileRight(e,l,a);0===n&&(r=u.x*u.width,o=u.y*u.height,n=u.width),d&&d.collides?n+=u.width:((p=this.createBody(r,o,0,!1)).addRectangle(n,u.height,n/2,u.height/2,0),i&&this.addBody(p),t.layers[e].bodies.push(p),n=0)}else{var p=this.createBody(u.x*u.width,u.y*u.height,0,!1);p.addRectangle(u.width,u.height,u.width/2,u.height/2,0),i&&this.addBody(p),t.layers[e].bodies.push(p)}}}return t.layers[e].bodies},mpx:function(t){return t*=20},pxm:function(t){return.05*t},mpxi:function(t){return t*=-20},pxmi:function(t){return-.05*t}},Object.defineProperty(e.Physics.P2.prototype,"friction",{get:function(){return this.world.defaultContactMaterial.friction},set:function(t){this.world.defaultContactMaterial.friction=t}}),Object.defineProperty(e.Physics.P2.prototype,"restitution",{get:function(){return this.world.defaultContactMaterial.restitution},set:function(t){this.world.defaultContactMaterial.restitution=t}}),Object.defineProperty(e.Physics.P2.prototype,"contactMaterial",{get:function(){return this.world.defaultContactMaterial},set:function(t){this.world.defaultContactMaterial=t}}),Object.defineProperty(e.Physics.P2.prototype,"applySpringForces",{get:function(){return this.world.applySpringForces},set:function(t){this.world.applySpringForces=t}}),Object.defineProperty(e.Physics.P2.prototype,"applyDamping",{get:function(){return this.world.applyDamping},set:function(t){this.world.applyDamping=t}}),Object.defineProperty(e.Physics.P2.prototype,"applyGravity",{get:function(){return this.world.applyGravity},set:function(t){this.world.applyGravity=t}}),Object.defineProperty(e.Physics.P2.prototype,"solveConstraints",{get:function(){return this.world.solveConstraints},set:function(t){this.world.solveConstraints=t}}),Object.defineProperty(e.Physics.P2.prototype,"time",{get:function(){return this.world.time}}),Object.defineProperty(e.Physics.P2.prototype,"emitImpactEvent",{get:function(){return this.world.emitImpactEvent},set:function(t){this.world.emitImpactEvent=t}}),Object.defineProperty(e.Physics.P2.prototype,"sleepMode",{get:function(){return this.world.sleepMode},set:function(t){this.world.sleepMode=t}}),Object.defineProperty(e.Physics.P2.prototype,"total",{get:function(){return this.world.bodies.length}}),e.Physics.P2.FixtureList=function(t){Array.isArray(t)||(t=[t]),this.rawList=t,this.init(),this.parse(this.rawList)},e.Physics.P2.FixtureList.prototype={init:function(){this.namedFixtures={},this.groupedFixtures=[],this.allFixtures=[]},setCategory:function(t,e){this.getFixtures(e).forEach(function(e){e.collisionGroup=t})},setMask:function(t,e){this.getFixtures(e).forEach(function(e){e.collisionMask=t})},setSensor:function(t,e){this.getFixtures(e).forEach(function(e){e.sensor=t})},setMaterial:function(t,e){this.getFixtures(e).forEach(function(e){e.material=t})},getFixtures:function(t){var e=[];if(t){t instanceof Array||(t=[t]);var i=this;return t.forEach(function(t){i.namedFixtures[t]&&e.push(i.namedFixtures[t])}),this.flatten(e)}return this.allFixtures},getFixtureByKey:function(t){return this.namedFixtures[t]},getGroup:function(t){return this.groupedFixtures[t]},parse:function(){var t,e,i,s;i=this.rawList,s=[];for(t in i)e=i[t],isNaN(t-0)?this.namedFixtures[t]=this.flatten(e):(this.groupedFixtures[t]=this.groupedFixtures[t]||[],this.groupedFixtures[t]=this.groupedFixtures[t].concat(e)),s.push(this.allFixtures=this.flatten(this.groupedFixtures))},flatten:function(t){var e,i;return e=[],i=arguments.callee,t.forEach(function(t){return Array.prototype.push.apply(e,Array.isArray(t)?i(t):[t])}),e}},e.Physics.P2.PointProxy=function(t,e){this.world=t,this.destination=e},e.Physics.P2.PointProxy.prototype.constructor=e.Physics.P2.PointProxy,Object.defineProperty(e.Physics.P2.PointProxy.prototype,"x",{get:function(){return this.world.mpx(this.destination[0])},set:function(t){this.destination[0]=this.world.pxm(t)}}),Object.defineProperty(e.Physics.P2.PointProxy.prototype,"y",{get:function(){return this.world.mpx(this.destination[1])},set:function(t){this.destination[1]=this.world.pxm(t)}}),Object.defineProperty(e.Physics.P2.PointProxy.prototype,"mx",{get:function(){return this.destination[0]},set:function(t){this.destination[0]=t}}),Object.defineProperty(e.Physics.P2.PointProxy.prototype,"my",{get:function(){return this.destination[1]},set:function(t){this.destination[1]=t}}),e.Physics.P2.InversePointProxy=function(t,e){this.world=t,this.destination=e},e.Physics.P2.InversePointProxy.prototype.constructor=e.Physics.P2.InversePointProxy,Object.defineProperty(e.Physics.P2.InversePointProxy.prototype,"x",{get:function(){return this.world.mpxi(this.destination[0])},set:function(t){this.destination[0]=this.world.pxmi(t)}}),Object.defineProperty(e.Physics.P2.InversePointProxy.prototype,"y",{get:function(){return this.world.mpxi(this.destination[1])},set:function(t){this.destination[1]=this.world.pxmi(t)}}),Object.defineProperty(e.Physics.P2.InversePointProxy.prototype,"mx",{get:function(){return this.destination[0]},set:function(t){this.destination[0]=-t}}),Object.defineProperty(e.Physics.P2.InversePointProxy.prototype,"my",{get:function(){return this.destination[1]},set:function(t){this.destination[1]=-t}}),e.Physics.P2.Body=function(t,i,s,n,r){i=i||null,s=s||0,n=n||0,void 0===r&&(r=1),this.game=t,this.world=t.physics.p2,this.sprite=i,this.type=e.Physics.P2JS,this.offset=new e.Point,this.data=new p2.Body({position:[this.world.pxmi(s),this.world.pxmi(n)],mass:r}),this.data.parent=this,this.velocity=new e.Physics.P2.InversePointProxy(this.world,this.data.velocity),this.force=new e.Physics.P2.InversePointProxy(this.world,this.data.force),this.gravity=new e.Point,this.onBeginContact=new e.Signal,this.onEndContact=new e.Signal,this.collidesWith=[],this.removeNextStep=!1,this.debugBody=null,this.dirty=!1,this._collideWorldBounds=!0,this._bodyCallbacks={},this._bodyCallbackContext={},this._groupCallbacks={},this._groupCallbackContext={},this._reset=!1,i&&(this.setRectangleFromSprite(i),i.exists&&this.game.physics.p2.addBody(this))},e.Physics.P2.Body.prototype={createBodyCallback:function(t,e,i){var s=-1;t.id?s=t.id:t.body&&(s=t.body.id),s>-1&&(null===e?(delete this._bodyCallbacks[s],delete this._bodyCallbackContext[s]):(this._bodyCallbacks[s]=e,this._bodyCallbackContext[s]=i))},createGroupCallback:function(t,e,i){null===e?(delete this._groupCallbacks[t.mask],delete this._groupCallbackContext[t.mask]):(this._groupCallbacks[t.mask]=e,this._groupCallbackContext[t.mask]=i)},getCollisionMask:function(){var t=0;this._collideWorldBounds&&(t=this.game.physics.p2.boundsCollisionGroup.mask);for(var e=0;e<this.collidesWith.length;e++)t|=this.collidesWith[e].mask;return t},updateCollisionMask:function(t){var e=this.getCollisionMask();if(void 0===t)for(var i=this.data.shapes.length-1;i>=0;i--)this.data.shapes[i].collisionMask=e;else t.collisionMask=e},setCollisionGroup:function(t,e){var i=this.getCollisionMask();if(void 0===e)for(var s=this.data.shapes.length-1;s>=0;s--)this.data.shapes[s].collisionGroup=t.mask,this.data.shapes[s].collisionMask=i;else e.collisionGroup=t.mask,e.collisionMask=i},clearCollision:function(t,e,i){if(void 0===t&&(t=!0),void 0===e&&(e=!0),void 0===i)for(var s=this.data.shapes.length-1;s>=0;s--)t&&(this.data.shapes[s].collisionGroup=null),e&&(this.data.shapes[s].collisionMask=null);else t&&(i.collisionGroup=null),e&&(i.collisionMask=null);t&&(this.collidesWith.length=0)},removeCollisionGroup:function(t,e,i){void 0===e&&(e=!0);var s;if(Array.isArray(t))for(r=0;r<t.length;r++)(s=this.collidesWith.indexOf(t[r]))>-1&&(this.collidesWith.splice(s,1),e&&(delete this._groupCallbacks[t.mask],delete this._groupCallbackContext[t.mask]));else(s=this.collidesWith.indexOf(t))>-1&&(this.collidesWith.splice(s,1),e&&(delete this._groupCallbacks[t.mask],delete this._groupCallbackContext[t.mask]));var n=this.getCollisionMask();if(void 0===i)for(var r=this.data.shapes.length-1;r>=0;r--)this.data.shapes[r].collisionMask=n;else i.collisionMask=n},collides:function(t,e,i,s){if(Array.isArray(t))for(r=0;r<t.length;r++)-1===this.collidesWith.indexOf(t[r])&&(this.collidesWith.push(t[r]),e&&this.createGroupCallback(t[r],e,i));else-1===this.collidesWith.indexOf(t)&&(this.collidesWith.push(t),e&&this.createGroupCallback(t,e,i));var n=this.getCollisionMask();if(void 0===s)for(var r=this.data.shapes.length-1;r>=0;r--)this.data.shapes[r].collisionMask=n;else s.collisionMask=n},adjustCenterOfMass:function(){this.data.adjustCenterOfMass(),this.shapeChanged()},getVelocityAtPoint:function(t,e){return this.data.getVelocityAtPoint(t,e)},applyDamping:function(t){this.data.applyDamping(t)},applyImpulse:function(t,e,i){this.data.applyImpulse(t,[this.world.pxmi(e),this.world.pxmi(i)])},applyImpulseLocal:function(t,e,i){this.data.applyImpulseLocal(t,[this.world.pxmi(e),this.world.pxmi(i)])},applyForce:function(t,e,i){this.data.applyForce(t,[this.world.pxmi(e),this.world.pxmi(i)])},setZeroForce:function(){this.data.setZeroForce()},setZeroRotation:function(){this.data.angularVelocity=0},setZeroVelocity:function(){this.data.velocity[0]=0,this.data.velocity[1]=0},setZeroDamping:function(){this.data.damping=0,this.data.angularDamping=0},toLocalFrame:function(t,e){return this.data.toLocalFrame(t,e)},toWorldFrame:function(t,e){return this.data.toWorldFrame(t,e)},rotateLeft:function(t){this.data.angularVelocity=this.world.pxm(-t)},rotateRight:function(t){this.data.angularVelocity=this.world.pxm(t)},moveForward:function(t){var e=this.world.pxmi(-t),i=this.data.angle+Math.PI/2;this.data.velocity[0]=e*Math.cos(i),this.data.velocity[1]=e*Math.sin(i)},moveBackward:function(t){var e=this.world.pxmi(-t),i=this.data.angle+Math.PI/2;this.data.velocity[0]=-e*Math.cos(i),this.data.velocity[1]=-e*Math.sin(i)},thrust:function(t){var e=this.world.pxmi(-t),i=this.data.angle+Math.PI/2;this.data.force[0]+=e*Math.cos(i),this.data.force[1]+=e*Math.sin(i)},thrustLeft:function(t){var e=this.world.pxmi(-t),i=this.data.angle;this.data.force[0]+=e*Math.cos(i),this.data.force[1]+=e*Math.sin(i)},thrustRight:function(t){var e=this.world.pxmi(-t),i=this.data.angle;this.data.force[0]-=e*Math.cos(i),this.data.force[1]-=e*Math.sin(i)},reverse:function(t){var e=this.world.pxmi(-t),i=this.data.angle+Math.PI/2;this.data.force[0]-=e*Math.cos(i),this.data.force[1]-=e*Math.sin(i)},moveLeft:function(t){this.data.velocity[0]=this.world.pxmi(-t)},moveRight:function(t){this.data.velocity[0]=this.world.pxmi(t)},moveUp:function(t){this.data.velocity[1]=this.world.pxmi(-t)},moveDown:function(t){this.data.velocity[1]=this.world.pxmi(t)},preUpdate:function(){this.dirty=!0,this.removeNextStep&&(this.removeFromWorld(),this.removeNextStep=!1)},postUpdate:function(){this.sprite.x=this.world.mpxi(this.data.position[0])+this.offset.x,this.sprite.y=this.world.mpxi(this.data.position[1])+this.offset.y,this.fixedRotation||(this.sprite.rotation=this.data.angle),this.debugBody&&this.debugBody.updateSpriteTransform(),this.dirty=!1},reset:function(t,e,i,s){void 0===i&&(i=!1),void 0===s&&(s=!1),this.setZeroForce(),this.setZeroVelocity(),this.setZeroRotation(),i&&this.setZeroDamping(),s&&(this.mass=1),this.x=t,this.y=e},addToWorld:function(){if(this.game.physics.p2._toRemove)for(var t=0;t<this.game.physics.p2._toRemove.length;t++)this.game.physics.p2._toRemove[t]===this&&this.game.physics.p2._toRemove.splice(t,1);this.data.world!==this.game.physics.p2.world&&this.game.physics.p2.addBody(this)},removeFromWorld:function(){this.data.world===this.game.physics.p2.world&&this.game.physics.p2.removeBodyNextStep(this)},destroy:function(){this.removeFromWorld(),this.clearShapes(),this._bodyCallbacks={},this._bodyCallbackContext={},this._groupCallbacks={},this._groupCallbackContext={},this.debugBody&&this.debugBody.destroy(!0,!0),this.debugBody=null,this.sprite&&(this.sprite.body=null,this.sprite=null)},clearShapes:function(){for(var t=this.data.shapes.length;t--;)this.data.removeShape(this.data.shapes[t]);this.shapeChanged()},addShape:function(t,e,i,s){return void 0===e&&(e=0),void 0===i&&(i=0),void 0===s&&(s=0),this.data.addShape(t,[this.world.pxmi(e),this.world.pxmi(i)],s),this.shapeChanged(),t},addCircle:function(t,e,i,s){var n=new p2.Circle({radius:this.world.pxm(t)});return this.addShape(n,e,i,s)},addRectangle:function(t,e,i,s,n){var r=new p2.Box({width:this.world.pxm(t),height:this.world.pxm(e)});return this.addShape(r,i,s,n)},addPlane:function(t,e,i){var s=new p2.Plane;return this.addShape(s,t,e,i)},addParticle:function(t,e,i){var s=new p2.Particle;return this.addShape(s,t,e,i)},addLine:function(t,e,i,s){var n=new p2.Line({length:this.world.pxm(t)});return this.addShape(n,e,i,s)},addCapsule:function(t,e,i,s,n){var r=new p2.Capsule({length:this.world.pxm(t),radius:this.world.pxm(e)});return this.addShape(r,i,s,n)},addPolygon:function(t,e){t=t||{},Array.isArray(e)||(e=Array.prototype.slice.call(arguments,1));var i=[];if(1===e.length&&Array.isArray(e[0]))i=e[0].slice(0);else if(Array.isArray(e[0]))i=e.slice();else if("number"==typeof e[0])for(var s=0,n=e.length;s<n;s+=2)i.push([e[s],e[s+1]]);var r=i.length-1;i[r][0]===i[0][0]&&i[r][1]===i[0][1]&&i.pop();for(var o=0;o<i.length;o++)i[o][0]=this.world.pxmi(i[o][0]),i[o][1]=this.world.pxmi(i[o][1]);var a=this.data.fromPolygon(i,t);return this.shapeChanged(),a},removeShape:function(t){var e=this.data.removeShape(t);return this.shapeChanged(),e},setCircle:function(t,e,i,s){return this.clearShapes(),this.addCircle(t,e,i,s)},setRectangle:function(t,e,i,s,n){return void 0===t&&(t=16),void 0===e&&(e=16),this.clearShapes(),this.addRectangle(t,e,i,s,n)},setRectangleFromSprite:function(t){return void 0===t&&(t=this.sprite),this.clearShapes(),this.addRectangle(t.width,t.height,0,0,t.rotation)},setMaterial:function(t,e){if(void 0===e)for(var i=this.data.shapes.length-1;i>=0;i--)this.data.shapes[i].material=t;else e.material=t},shapeChanged:function(){this.debugBody&&this.debugBody.draw()},addPhaserPolygon:function(t,e){for(var i=this.game.cache.getPhysicsData(t,e),s=[],n=0;n<i.length;n++){var r=i[n],o=this.addFixture(r);s[r.filter.group]=s[r.filter.group]||[],s[r.filter.group]=s[r.filter.group].concat(o),r.fixtureKey&&(s[r.fixtureKey]=o)}return this.data.aabbNeedsUpdate=!0,this.shapeChanged(),s},addFixture:function(t){var e=[];if(t.circle){(l=new p2.Circle({radius:this.world.pxm(t.circle.radius)})).collisionGroup=t.filter.categoryBits,l.collisionMask=t.filter.maskBits,l.sensor=t.isSensor;var i=p2.vec2.create();i[0]=this.world.pxmi(t.circle.position[0]-this.sprite.width/2),i[1]=this.world.pxmi(t.circle.position[1]-this.sprite.height/2),this.data.addShape(l,i),e.push(l)}else for(var s=t.polygons,n=p2.vec2.create(),r=0;r<s.length;r++){for(var o=s[r],a=[],h=0;h<o.length;h+=2)a.push([this.world.pxmi(o[h]),this.world.pxmi(o[h+1])]);for(var l=new p2.Convex({vertices:a}),c=0;c!==l.vertices.length;c++){var u=l.vertices[c];p2.vec2.sub(u,u,l.centerOfMass)}p2.vec2.scale(n,l.centerOfMass,1),n[0]-=this.world.pxmi(this.sprite.width/2),n[1]-=this.world.pxmi(this.sprite.height/2),l.updateTriangles(),l.updateCenterOfMass(),l.updateBoundingRadius(),l.collisionGroup=t.filter.categoryBits,l.collisionMask=t.filter.maskBits,l.sensor=t.isSensor,this.data.addShape(l,n),e.push(l)}return e},loadPolygon:function(t,e,i){if(null===t)s=e;else var s=this.game.cache.getPhysicsData(t,e);"number"!=typeof i&&(i=1);for(var n=p2.vec2.create(),r=0;r<s.length;r++){for(var o=[],a=0;a<s[r].shape.length;a+=2)o.push([this.world.pxmi(s[r].shape[a]*i),this.world.pxmi(s[r].shape[a+1]*i)]);for(var h=new p2.Convex({vertices:o}),l=0;l!==h.vertices.length;l++){var c=h.vertices[l];p2.vec2.sub(c,c,h.centerOfMass)}p2.vec2.scale(n,h.centerOfMass,1),n[0]-=this.world.pxmi(this.sprite.width/2),n[1]-=this.world.pxmi(this.sprite.height/2),h.updateTriangles(),h.updateCenterOfMass(),h.updateBoundingRadius(),this.data.addShape(h,n)}return this.data.aabbNeedsUpdate=!0,this.shapeChanged(),!0}},e.Physics.P2.Body.prototype.constructor=e.Physics.P2.Body,e.Physics.P2.Body.DYNAMIC=1,e.Physics.P2.Body.STATIC=2,e.Physics.P2.Body.KINEMATIC=4,Object.defineProperty(e.Physics.P2.Body.prototype,"static",{get:function(){return this.data.type===e.Physics.P2.Body.STATIC},set:function(t){t&&this.data.type!==e.Physics.P2.Body.STATIC?(this.data.type=e.Physics.P2.Body.STATIC,this.mass=0):t||this.data.type!==e.Physics.P2.Body.STATIC||(this.data.type=e.Physics.P2.Body.DYNAMIC,this.mass=1)}}),Object.defineProperty(e.Physics.P2.Body.prototype,"dynamic",{get:function(){return this.data.type===e.Physics.P2.Body.DYNAMIC},set:function(t){t&&this.data.type!==e.Physics.P2.Body.DYNAMIC?(this.data.type=e.Physics.P2.Body.DYNAMIC,this.mass=1):t||this.data.type!==e.Physics.P2.Body.DYNAMIC||(this.data.type=e.Physics.P2.Body.STATIC,this.mass=0)}}),Object.defineProperty(e.Physics.P2.Body.prototype,"kinematic",{get:function(){return this.data.type===e.Physics.P2.Body.KINEMATIC},set:function(t){t&&this.data.type!==e.Physics.P2.Body.KINEMATIC?(this.data.type=e.Physics.P2.Body.KINEMATIC,this.mass=4):t||this.data.type!==e.Physics.P2.Body.KINEMATIC||(this.data.type=e.Physics.P2.Body.STATIC,this.mass=0)}}),Object.defineProperty(e.Physics.P2.Body.prototype,"allowSleep",{get:function(){return this.data.allowSleep},set:function(t){t!==this.data.allowSleep&&(this.data.allowSleep=t)}}),Object.defineProperty(e.Physics.P2.Body.prototype,"angle",{get:function(){return e.Math.wrapAngle(e.Math.radToDeg(this.data.angle))},set:function(t){this.data.angle=e.Math.degToRad(e.Math.wrapAngle(t))}}),Object.defineProperty(e.Physics.P2.Body.prototype,"angularDamping",{get:function(){return this.data.angularDamping},set:function(t){this.data.angularDamping=t}}),Object.defineProperty(e.Physics.P2.Body.prototype,"angularForce",{get:function(){return this.data.angularForce},set:function(t){this.data.angularForce=t}}),Object.defineProperty(e.Physics.P2.Body.prototype,"angularVelocity",{get:function(){return this.data.angularVelocity},set:function(t){this.data.angularVelocity=t}}),Object.defineProperty(e.Physics.P2.Body.prototype,"damping",{get:function(){return this.data.damping},set:function(t){this.data.damping=t}}),Object.defineProperty(e.Physics.P2.Body.prototype,"fixedRotation",{get:function(){return this.data.fixedRotation},set:function(t){t!==this.data.fixedRotation&&(this.data.fixedRotation=t)}}),Object.defineProperty(e.Physics.P2.Body.prototype,"inertia",{get:function(){return this.data.inertia},set:function(t){this.data.inertia=t}}),Object.defineProperty(e.Physics.P2.Body.prototype,"mass",{get:function(){return this.data.mass},set:function(t){t!==this.data.mass&&(this.data.mass=t,this.data.updateMassProperties())}}),Object.defineProperty(e.Physics.P2.Body.prototype,"motionState",{get:function(){return this.data.type},set:function(t){t!==this.data.type&&(this.data.type=t)}}),Object.defineProperty(e.Physics.P2.Body.prototype,"rotation",{get:function(){return this.data.angle},set:function(t){this.data.angle=t}}),Object.defineProperty(e.Physics.P2.Body.prototype,"sleepSpeedLimit",{get:function(){return this.data.sleepSpeedLimit},set:function(t){this.data.sleepSpeedLimit=t}}),Object.defineProperty(e.Physics.P2.Body.prototype,"x",{get:function(){return this.world.mpxi(this.data.position[0])},set:function(t){this.data.position[0]=this.world.pxmi(t)}}),Object.defineProperty(e.Physics.P2.Body.prototype,"y",{get:function(){return this.world.mpxi(this.data.position[1])},set:function(t){this.data.position[1]=this.world.pxmi(t)}}),Object.defineProperty(e.Physics.P2.Body.prototype,"id",{get:function(){return this.data.id}}),Object.defineProperty(e.Physics.P2.Body.prototype,"debug",{get:function(){return null!==this.debugBody},set:function(t){t&&!this.debugBody?this.debugBody=new e.Physics.P2.BodyDebug(this.game,this.data):!t&&this.debugBody&&(this.debugBody.destroy(),this.debugBody=null)}}),Object.defineProperty(e.Physics.P2.Body.prototype,"collideWorldBounds",{get:function(){return this._collideWorldBounds},set:function(t){t&&!this._collideWorldBounds?(this._collideWorldBounds=!0,this.updateCollisionMask()):!t&&this._collideWorldBounds&&(this._collideWorldBounds=!1,this.updateCollisionMask())}}),e.Physics.P2.BodyDebug=function(t,i,s){e.Group.call(this,t);var n={pixelsPerLengthUnit:t.physics.p2.mpx(1),debugPolygons:!1,lineWidth:1,alpha:.5};this.settings=Object.assign(n,s),this.ppu=this.settings.pixelsPerLengthUnit,this.ppu=-1*this.ppu,this.body=i,this.canvas=new e.Graphics(t),this.canvas.alpha=this.settings.alpha,this.add(this.canvas),this.draw(),this.updateSpriteTransform()},e.Physics.P2.BodyDebug.prototype=Object.create(e.Group.prototype),e.Physics.P2.BodyDebug.prototype.constructor=e.Physics.P2.BodyDebug,Object.assign(e.Physics.P2.BodyDebug.prototype,{updateSpriteTransform:function(){this.position.x=this.body.position[0]*this.ppu,this.position.y=this.body.position[1]*this.ppu,this.rotation=this.body.angle},draw:function(){var t,e,i,s,n,r,o,a,h,l,c,u,d,p;if(o=this.body,(h=this.canvas).clear(),i=parseInt(this.randomPastelHex(),16),16711680,r=this.lineWidth,o instanceof p2.Body&&o.shapes.length){var f=o.shapes.length;for(s=0;s!==f;){if(e=o.shapes[s],a=e.position||0,t=e.angle||0,e instanceof p2.Circle)this.drawCircle(h,a[0]*this.ppu,a[1]*this.ppu,t,e.radius*this.ppu,i,r);else if(e instanceof p2.Capsule)this.drawCapsule(h,a[0]*this.ppu,a[1]*this.ppu,t,e.length*this.ppu,e.radius*this.ppu,16711680,i,r);else if(e instanceof p2.Plane)this.drawPlane(h,a[0]*this.ppu,-a[1]*this.ppu,i,16711680,5*r,10*r,10*r,100*this.ppu,t);else if(e instanceof p2.Line)this.drawLine(h,e.length*this.ppu,16711680,r);else if(e instanceof p2.Box)this.drawRectangle(h,a[0]*this.ppu,a[1]*this.ppu,t,e.width*this.ppu,e.height*this.ppu,16711680,i,r);else if(e instanceof p2.Convex){for(c=[],u=p2.vec2.create(),n=d=0,p=e.vertices.length;p>=0?d<p:d>p;n=p>=0?++d:--d)l=e.vertices[n],p2.vec2.rotate(u,l,t),c.push([(u[0]+a[0])*this.ppu,-(u[1]+a[1])*this.ppu]);this.drawConvex(h,c,e.triangles,16711680,i,r,this.settings.debugPolygons,[a[0]*this.ppu,-a[1]*this.ppu])}s++}}},drawRectangle:function(t,e,i,s,n,r,o,a,h){void 0===h&&(h=1),void 0===o&&(o=0),t.lineStyle(h,o,1),t.beginFill(a),t.drawRect(e-n/2,i-r/2,n,r)},drawCircle:function(t,e,i,s,n,r,o){void 0===o&&(o=1),void 0===r&&(r=16777215),t.lineStyle(o,0,1),t.beginFill(r,1),t.drawCircle(e,i,2*-n),t.endFill(),t.moveTo(e,i),t.lineTo(e+n*Math.cos(-s),i+n*Math.sin(-s))},drawLine:function(t,e,i,s){void 0===s&&(s=1),void 0===i&&(i=0),t.lineStyle(5*s,i,1),t.moveTo(-e/2,0),t.lineTo(e/2,0)},drawConvex:function(t,e,i,s,n,r,o,a){var h,l,c,u,d,p,f,g,m,y,v;if(void 0===r&&(r=1),void 0===s&&(s=0),o){for(h=[16711680,65280,255],l=0;l!==e.length+1;)u=e[l%e.length],d=e[(l+1)%e.length],f=u[0],y=u[1],g=d[0],v=d[1],t.lineStyle(r,h[l%h.length],1),t.moveTo(f,-y),t.lineTo(g,-v),t.drawCircle(f,-y,2*r),l++;return t.lineStyle(r,0,1),t.drawCircle(a[0],a[1],2*r)}for(t.lineStyle(r,s,1),t.beginFill(n),l=0;l!==e.length;)p=(c=e[l])[0],m=c[1],0===l?t.moveTo(p,-m):t.lineTo(p,-m),l++;if(t.endFill(),e.length>2)return t.moveTo(e[e.length-1][0],-e[e.length-1][1]),t.lineTo(e[0][0],-e[0][1])},drawPath:function(t,e,i,s,n){var r,o,a,h,l,c,u,d,p,f,g;for(void 0===n&&(n=1),void 0===i&&(i=0),t.lineStyle(n,i,1),"number"==typeof s&&t.beginFill(s),o=null,a=null,r=0;r<e.length;)f=(p=e[r])[0],g=p[1],f===o&&g===a||(0===r?t.moveTo(f,g):(h=o,l=a,c=f,u=g,d=e[(r+1)%e.length][0],0!==(c-h)*(e[(r+1)%e.length][1]-l)-(d-h)*(u-l)&&t.lineTo(f,g)),o=f,a=g),r++;"number"==typeof s&&t.endFill(),e.length>2&&"number"==typeof s&&(t.moveTo(e[e.length-1][0],e[e.length-1][1]),t.lineTo(e[0][0],e[0][1]))},drawPlane:function(t,e,i,s,n,r,o,a,h,l){var c,u;void 0===r&&(r=1),void 0===s&&(s=16777215),t.lineStyle(r,n,11),t.beginFill(s),t.moveTo(e,-i),c=e+Math.cos(l)*this.game.width,u=i+Math.sin(l)*this.game.height,t.lineTo(c,-u),t.moveTo(e,-i),c=e+Math.cos(l)*-this.game.width,u=i+Math.sin(l)*-this.game.height,t.lineTo(c,-u)},drawCapsule:function(t,e,i,s,n,r,o,a,h){void 0===h&&(h=1),void 0===o&&(o=0),t.lineStyle(h,o,1);var l=Math.cos(s),c=Math.sin(s);t.beginFill(a,1),t.drawCircle(-n/2*l+e,-n/2*c+i,2*-r),t.drawCircle(n/2*l+e,n/2*c+i,2*-r),t.endFill(),t.lineStyle(h,o,0),t.beginFill(a,1),t.moveTo(-n/2*l+r*c+e,-n/2*c+r*l+i),t.lineTo(n/2*l+r*c+e,n/2*c+r*l+i),t.lineTo(n/2*l-r*c+e,n/2*c-r*l+i),t.lineTo(-n/2*l-r*c+e,-n/2*c-r*l+i),t.endFill(),t.lineStyle(h,o,1),t.moveTo(-n/2*l+r*c+e,-n/2*c+r*l+i),t.lineTo(n/2*l+r*c+e,n/2*c+r*l+i),t.moveTo(-n/2*l-r*c+e,-n/2*c-r*l+i),t.lineTo(n/2*l-r*c+e,n/2*c-r*l+i)},randomPastelHex:function(){var t,e,i,s;return i=[255,255,255],s=Math.floor(256*Math.random()),e=Math.floor(256*Math.random()),t=Math.floor(256*Math.random()),s=Math.floor((s+3*i[0])/4),e=Math.floor((e+3*i[1])/4),t=Math.floor((t+3*i[2])/4),this.rgbToHex(s,e,t)},rgbToHex:function(t,e,i){return this.componentToHex(t)+this.componentToHex(e)+this.componentToHex(i)},componentToHex:function(t){var e;return 2===(e=t.toString(16)).length?e:e+"0"}}),e.Physics.P2.Spring=function(t,e,i,s,n,r,o,a,h,l){this.game=t.game,this.world=t,void 0===s&&(s=1),void 0===n&&(n=100),void 0===r&&(r=1);var c={restLength:s=t.pxm(s),stiffness:n,damping:r};void 0!==o&&null!==o&&(c.worldAnchorA=[t.pxm(o[0]),t.pxm(o[1])]),void 0!==a&&null!==a&&(c.worldAnchorB=[t.pxm(a[0]),t.pxm(a[1])]),void 0!==h&&null!==h&&(c.localAnchorA=[t.pxm(h[0]),t.pxm(h[1])]),void 0!==l&&null!==l&&(c.localAnchorB=[t.pxm(l[0]),t.pxm(l[1])]),this.data=new p2.LinearSpring(e,i,c),this.data.parent=this},e.Physics.P2.Spring.prototype.constructor=e.Physics.P2.Spring,e.Physics.P2.RotationalSpring=function(t,e,i,s,n,r){this.game=t.game,this.world=t,void 0===s&&(s=null),void 0===n&&(n=100),void 0===r&&(r=1),s&&(s=t.pxm(s));var o={restAngle:s,stiffness:n,damping:r};this.data=new p2.RotationalSpring(e,i,o),this.data.parent=this},e.Physics.P2.Spring.prototype.constructor=e.Physics.P2.Spring,e.Physics.P2.Material=function(t){this.name=t,p2.Material.call(this)},e.Physics.P2.Material.prototype=Object.create(p2.Material.prototype),e.Physics.P2.Material.prototype.constructor=e.Physics.P2.Material,e.Physics.P2.ContactMaterial=function(t,e,i){p2.ContactMaterial.call(this,t,e,i)},e.Physics.P2.ContactMaterial.prototype=Object.create(p2.ContactMaterial.prototype),e.Physics.P2.ContactMaterial.prototype.constructor=e.Physics.P2.ContactMaterial,e.Physics.P2.CollisionGroup=function(t){this.mask=t},e.Physics.P2.DistanceConstraint=function(t,e,i,s,n,r,o){void 0===s&&(s=100),void 0===n&&(n=[0,0]),void 0===r&&(r=[0,0]),void 0===o&&(o=Number.MAX_VALUE),this.game=t.game,this.world=t;var a={distance:s=t.pxm(s),localAnchorA:n=[t.pxmi(n[0]),t.pxmi(n[1])],localAnchorB:r=[t.pxmi(r[0]),t.pxmi(r[1])],maxForce:o};p2.DistanceConstraint.call(this,e,i,a)},e.Physics.P2.DistanceConstraint.prototype=Object.create(p2.DistanceConstraint.prototype),e.Physics.P2.DistanceConstraint.prototype.constructor=e.Physics.P2.DistanceConstraint,e.Physics.P2.GearConstraint=function(t,e,i,s,n){void 0===s&&(s=0),void 0===n&&(n=1),this.game=t.game,this.world=t;var r={angle:s,ratio:n};p2.GearConstraint.call(this,e,i,r)},e.Physics.P2.GearConstraint.prototype=Object.create(p2.GearConstraint.prototype),e.Physics.P2.GearConstraint.prototype.constructor=e.Physics.P2.GearConstraint,e.Physics.P2.LockConstraint=function(t,e,i,s,n,r){void 0===s&&(s=[0,0]),void 0===n&&(n=0),void 0===r&&(r=Number.MAX_VALUE),this.game=t.game,this.world=t;var o={localOffsetB:s=[t.pxm(s[0]),t.pxm(s[1])],localAngleB:n,maxForce:r};p2.LockConstraint.call(this,e,i,o)},e.Physics.P2.LockConstraint.prototype=Object.create(p2.LockConstraint.prototype),e.Physics.P2.LockConstraint.prototype.constructor=e.Physics.P2.LockConstraint,e.Physics.P2.PrismaticConstraint=function(t,e,i,s,n,r,o,a){void 0===s&&(s=!0),void 0===n&&(n=[0,0]),void 0===r&&(r=[0,0]),void 0===o&&(o=[0,0]),void 0===a&&(a=Number.MAX_VALUE),this.game=t.game,this.world=t;var h={localAnchorA:n=[t.pxmi(n[0]),t.pxmi(n[1])],localAnchorB:r=[t.pxmi(r[0]),t.pxmi(r[1])],localAxisA:o,maxForce:a,disableRotationalLock:!s};p2.PrismaticConstraint.call(this,e,i,h)},e.Physics.P2.PrismaticConstraint.prototype=Object.create(p2.PrismaticConstraint.prototype),e.Physics.P2.PrismaticConstraint.prototype.constructor=e.Physics.P2.PrismaticConstraint,e.Physics.P2.RevoluteConstraint=function(t,e,i,s,n,r,o){void 0===r&&(r=Number.MAX_VALUE),void 0===o&&(o=null),this.game=t.game,this.world=t,i=[t.pxmi(i[0]),t.pxmi(i[1])],n=[t.pxmi(n[0]),t.pxmi(n[1])],o&&(o=[t.pxmi(o[0]),t.pxmi(o[1])]);var a={worldPivot:o,localPivotA:i,localPivotB:n,maxForce:r};p2.RevoluteConstraint.call(this,e,s,a)},e.Physics.P2.RevoluteConstraint.prototype=Object.create(p2.RevoluteConstraint.prototype),e.Physics.P2.RevoluteConstraint.prototype.constructor=e.Physics.P2.RevoluteConstraint,e.ImageCollection=function(t,e,i,s,n,r,o){(void 0===i||i<=0)&&(i=32),(void 0===s||s<=0)&&(s=32),void 0===n&&(n=0),void 0===r&&(r=0),this.name=t,this.firstgid=0|e,this.imageWidth=0|i,this.imageHeight=0|s,this.imageMargin=0|n,this.imageSpacing=0|r,this.properties=o||{},this.images=[],this.total=0},e.ImageCollection.prototype={containsImageIndex:function(t){return t>=this.firstgid&&t<this.firstgid+this.total},addImage:function(t,e){this.images.push({gid:t,image:e}),this.total++}},e.ImageCollection.prototype.constructor=e.ImageCollection,e.Tile=function(t,e,i,s,n,r){this.layer=t,this.index=e,this.x=i,this.y=s,this.rotation=0,this.flipped=!1,this.worldX=i*n,this.worldY=s*r,this.width=n,this.height=r,this.centerX=Math.abs(n/2),this.centerY=Math.abs(r/2),this.alpha=1,this.properties={},this.scanned=!1,this.faceTop=!1,this.faceBottom=!1,this.faceLeft=!1,this.faceRight=!1,this.collideLeft=!1,this.collideRight=!1,this.collideUp=!1,this.collideDown=!1,this.collisionCallback=null,this.collisionCallbackContext=this,this.debug=!1},e.Tile.prototype={containsPoint:function(t,e){return!(t<this.worldX||e<this.worldY||t>this.right||e>this.bottom)},intersects:function(t,e,i,s){return!(i<=this.worldX)&&(!(s<=this.worldY)&&(!(t>=this.worldX+this.width)&&!(e>=this.worldY+this.height)))},setCollisionCallback:function(t,e){this.collisionCallback=t,this.collisionCallbackContext=e},destroy:function(){this.collisionCallback=null,this.collisionCallbackContext=null,this.properties=null},setCollision:function(t,e,i,s){this.collideLeft=t,this.collideRight=e,this.collideUp=i,this.collideDown=s,this.faceLeft=t,this.faceRight=e,this.faceTop=i,this.faceBottom=s},resetCollision:function(){this.collideLeft=!1,this.collideRight=!1,this.collideUp=!1,this.collideDown=!1,this.faceTop=!1,this.faceBottom=!1,this.faceLeft=!1,this.faceRight=!1},isInteresting:function(t,e){return t&&e?this.collideLeft||this.collideRight||this.collideUp||this.collideDown||this.faceTop||this.faceBottom||this.faceLeft||this.faceRight||this.collisionCallback:t?this.collideLeft||this.collideRight||this.collideUp||this.collideDown:!!e&&(this.faceTop||this.faceBottom||this.faceLeft||this.faceRight)},copy:function(t){this.index=t.index,this.alpha=t.alpha,this.properties=t.properties,this.collideUp=t.collideUp,this.collideDown=t.collideDown,this.collideLeft=t.collideLeft,this.collideRight=t.collideRight,this.collisionCallback=t.collisionCallback,this.collisionCallbackContext=t.collisionCallbackContext}},e.Tile.prototype.constructor=e.Tile,Object.defineProperty(e.Tile.prototype,"collides",{get:function(){return this.collideLeft||this.collideRight||this.collideUp||this.collideDown}}),Object.defineProperty(e.Tile.prototype,"canCollide",{get:function(){return this.collideLeft||this.collideRight||this.collideUp||this.collideDown||this.collisionCallback}}),Object.defineProperty(e.Tile.prototype,"left",{get:function(){return this.worldX}}),Object.defineProperty(e.Tile.prototype,"right",{get:function(){return this.worldX+this.width}}),Object.defineProperty(e.Tile.prototype,"top",{get:function(){return this.worldY}}),Object.defineProperty(e.Tile.prototype,"bottom",{get:function(){return this.worldY+this.height}}),e.Tilemap=function(t,i,s,n,r,o){this.game=t,this.key=i;var a=e.TilemapParser.parse(this.game,i,s,n,r,o);null!==a&&(this.width=a.width,this.height=a.height,this.tileWidth=a.tileWidth,this.tileHeight=a.tileHeight,this.orientation=a.orientation,this.format=a.format,this.version=a.version,this.properties=a.properties,this.widthInPixels=a.widthInPixels,this.heightInPixels=a.heightInPixels,this.layers=a.layers,this.tilesets=a.tilesets,this.imagecollections=a.imagecollections,this.tiles=a.tiles,this.objects=a.objects,this.collideIndexes=[],this.collision=a.collision,this.images=a.images,this.enableDebug=!1,this.currentLayer=0,this.debugMap=[],this._results=[],this._tempA=0,this._tempB=0)},e.Tilemap.CSV=0,e.Tilemap.TILED_JSON=1,e.Tilemap.NORTH=0,e.Tilemap.EAST=1,e.Tilemap.SOUTH=2,e.Tilemap.WEST=3,e.Tilemap.prototype={create:function(t,e,i,s,n,r){return void 0===r&&(r=this.game.world),this.width=e,this.height=i,this.setTileSize(s,n),this.layers.length=0,this.createBlankLayer(t,e,i,s,n,r)},setTileSize:function(t,e){this.tileWidth=t,this.tileHeight=e,this.widthInPixels=this.width*t,this.heightInPixels=this.height*e},addTilesetImage:function(t,i,s,n,r,o,a){if(void 0===t)return null;void 0===s&&(s=this.tileWidth),void 0===n&&(n=this.tileHeight),void 0===r&&(r=0),void 0===o&&(o=0),void 0===a&&(a=0),0===s&&(s=32),0===n&&(n=32);var h=null;if(void 0!==i&&null!==i||(i=t),i instanceof e.BitmapData)h=i.canvas;else{if(!this.game.cache.checkImageKey(i))return console.warn('Phaser.Tilemap.addTilesetImage: Invalid image key given: "'+i+'"'),null;h=this.game.cache.getImage(i)}var l=this.getTilesetIndex(t);if(null===l&&this.format===e.Tilemap.TILED_JSON)return console.warn('Phaser.Tilemap.addTilesetImage: No data found in the JSON matching the tileset name: "'+t+'"'),console.log("Tilesets: ",this.tilesets),null;if(this.tilesets[l])return this.tilesets[l].setImage(h),this.tilesets[l];var c=new e.Tileset(t,a,s,n,r,o,{});c.setImage(h),this.tilesets.push(c);for(var u=this.tilesets.length-1,d=r,p=r,f=0,g=0,m=0,y=a;y<a+c.total&&(this.tiles[y]=[d,p,u],d+=s+o,++f!==c.total)&&(++g!==c.columns||(d=r,p+=n+o,g=0,++m!==c.rows));y++);return c},createFromObjects:function(t,i,s,n,r,o,a,h,l,c){if(void 0===r&&(r=!0),void 0===o&&(o=!1),void 0===a&&(a=this.game.world),void 0===h&&(h=e.Sprite),void 0===l&&(l=!0),void 0===c&&(c=!0),!this.objects[t])return console.warn("Tilemap.createFromObjects: Invalid objectgroup name given: "+t),void console.log("Objects: ",this.objects);for(var u=0;u<this.objects[t].length;u++){var d=!1,p=this.objects[t][u];if(void 0!==p.gid&&"number"==typeof i&&p.gid===i?d=!0:void 0!==p.id&&"number"==typeof i&&p.id===i?d=!0:void 0!==p.name&&"string"==typeof i&&p.name===i&&(d=!0),d){var f=new h(this.game,parseFloat(p.x,10),parseFloat(p.y,10),s,n);f.name=p.name,f.autoCull=o,f.exists=r,f.visible=p.visible,c&&(p.width&&(f.width=p.width),p.height&&(f.height=p.height)),p.rotation&&(f.angle=p.rotation),l&&(f.y-=f.height),a.add(f);for(var g in p.properties)a.set(f,g,p.properties[g],!1,!1,0,!0)}}},createFromTiles:function(t,i,s,n,r,o){"number"==typeof t&&(t=[t]),void 0===i||null===i?i=[]:"number"==typeof i&&(i=[i]),n=this.getLayer(n),void 0===r&&(r=this.game.world),void 0===o&&(o={}),void 0===o.customClass&&(o.customClass=e.Sprite),void 0===o.adjustY&&(o.adjustY=!0);var a=this.layers[n].width,h=this.layers[n].height;if(this.copy(0,0,a,h,n),this._results.length<2)return 0;for(var l,c=0,u=1,d=this._results.length;u<d;u++)if(-1!==t.indexOf(this._results[u].index)){l=new o.customClass(this.game,this._results[u].worldX,this._results[u].worldY,s);for(var p in o)l[p]=o[p];r.add(l),c++}if(1===i.length)for(u=0;u<t.length;u++)this.replace(t[u],i[0],0,0,a,h,n);else if(i.length>1)for(u=0;u<t.length;u++)this.replace(t[u],i[u],0,0,a,h,n);return c},createLayer:function(t,i,s,n){void 0===i&&(i=this.game.width),void 0===s&&(s=this.game.height),void 0===n&&(n=this.game.world);var r=t;if("string"==typeof t&&(r=this.getLayerIndex(t)),null===r||r>this.layers.length)return console.warn('Tilemap.createLayer: Invalid layer ID given: "'+t+'"'),void console.log("Layers: ",this.layers);void 0===i||i<=0?i=Math.min(this.game.width,this.layers[r].widthInPixels):i>this.game.width&&(i=this.game.width),void 0===s||s<=0?s=Math.min(this.game.height,this.layers[r].heightInPixels):s>this.game.height&&(s=this.game.height),this.enableDebug&&(console.group("Tilemap.createLayer"),console.log("Name:",this.layers[r].name),console.log("Size:",i,"x",s),console.log("Tileset:",this.tilesets[0].name,"index:",r));var o=n.add(new e.TilemapLayer(this.game,this,r,i,s));return this.enableDebug&&console.groupEnd(),o},createBlankLayer:function(t,i,s,n,r,o){void 0===o&&(o=this.game.world);{if(null===this.getLayerIndex(t)){for(var a,h={name:t,x:0,y:0,width:i,height:s,widthInPixels:i*n,heightInPixels:s*r,alpha:1,visible:!0,properties:{},indexes:[],callbacks:[],bodies:[],data:null},l=[],c=0;c<s;c++){a=[];for(var u=0;u<i;u++)a.push(new e.Tile(h,-1,u,c,n,r));l.push(a)}h.data=l,this.layers.push(h),this.currentLayer=this.layers.length-1;var d=h.widthInPixels,p=h.heightInPixels;return d>this.game.width&&(d=this.game.width),p>this.game.height&&(p=this.game.height),(l=new e.TilemapLayer(this.game,this,this.layers.length-1,d,p)).name=t,o.add(l)}console.warn("Tilemap.createBlankLayer: Layer with matching name already exists: "+t)}},getIndex:function(t,e){for(var i=0;i<t.length;i++)if(t[i].name===e)return i;return null},getLayerIndex:function(t){return this.getIndex(this.layers,t)},getTilesetIndex:function(t){return this.getIndex(this.tilesets,t)},getImageIndex:function(t){return this.getIndex(this.images,t)},setTileIndexCallback:function(t,e,i,s){if(s=this.getLayer(s),"number"==typeof t)null===e?delete this.layers[s].callbacks[t]:this.layers[s].callbacks[t]={callback:e,callbackContext:i};else for(var n=0,r=t.length;n<r;n++)null===e?delete this.layers[s].callbacks[t[n]]:this.layers[s].callbacks[t[n]]={callback:e,callbackContext:i}},setTileLocationCallback:function(t,e,i,s,n,r,o){if(o=this.getLayer(o),this.copy(t,e,i,s,o),!(this._results.length<2))for(var a=1;a<this._results.length;a++)this._results[a].setCollisionCallback(n,r)},setCollision:function(t,e,i,s){if(void 0===e&&(e=!0),void 0===s&&(s=!0),i=this.getLayer(i),"number"==typeof t)return this.setCollisionByIndex(t,e,i,!0);if(Array.isArray(t)){for(var n=0;n<t.length;n++)this.setCollisionByIndex(t[n],e,i,!1);s&&this.calculateFaces(i)}},setCollisionBetween:function(t,e,i,s,n){if(void 0===i&&(i=!0),void 0===n&&(n=!0),s=this.getLayer(s),!(t>e)){for(var r=t;r<=e;r++)this.setCollisionByIndex(r,i,s,!1);n&&this.calculateFaces(s)}},setCollisionByExclusion:function(t,e,i,s){void 0===e&&(e=!0),void 0===s&&(s=!0),i=this.getLayer(i);for(var n=0,r=this.tiles.length;n<r;n++)-1===t.indexOf(n)&&this.setCollisionByIndex(n,e,i,!1);s&&this.calculateFaces(i)},setCollisionByIndex:function(t,e,i,s){if(void 0===e&&(e=!0),void 0===i&&(i=this.currentLayer),void 0===s&&(s=!0),e)this.collideIndexes.push(t);else{var n=this.collideIndexes.indexOf(t);n>-1&&this.collideIndexes.splice(n,1)}for(var r=0;r<this.layers[i].height;r++)for(var o=0;o<this.layers[i].width;o++){var a=this.layers[i].data[r][o];a&&a.index===t&&(e?a.setCollision(!0,!0,!0,!0):a.resetCollision(),a.faceTop=e,a.faceBottom=e,a.faceLeft=e,a.faceRight=e)}return s&&this.calculateFaces(i),i},getLayer:function(t){if(void 0===t)t=this.currentLayer;else if("string"==typeof t){var i=t;null===(t=this.getLayerIndex(t))&&console.warn("No such layer name: "+i)}else t instanceof e.TilemapLayer&&(t=t.index);return t},setPreventRecalculate:function(t){if(!0===t&&!0!==this.preventingRecalculate&&(this.preventingRecalculate=!0,this.needToRecalculate={}),!1===t&&!0===this.preventingRecalculate){this.preventingRecalculate=!1;for(var e in this.needToRecalculate)this.calculateFaces(e);this.needToRecalculate=!1}},calculateFaces:function(t){if(this.preventingRecalculate)this.needToRecalculate[t]=!0;else for(var e=null,i=null,s=null,n=null,r=0,o=this.layers[t].height;r<o;r++)for(var a=0,h=this.layers[t].width;a<h;a++){var l=this.layers[t].data[r][a];l&&(e=this.getTileAbove(t,a,r),i=this.getTileBelow(t,a,r),s=this.getTileLeft(t,a,r),n=this.getTileRight(t,a,r),l.collides&&(l.faceTop=!0,l.faceBottom=!0,l.faceLeft=!0,l.faceRight=!0),e&&e.collides&&(l.faceTop=!1),i&&i.collides&&(l.faceBottom=!1),s&&s.collides&&(l.faceLeft=!1),n&&n.collides&&(l.faceRight=!1))}},getTileAbove:function(t,e,i){return i>0?this.layers[t].data[i-1][e]:null},getTileBelow:function(t,e,i){return i<this.layers[t].height-1?this.layers[t].data[i+1][e]:null},getTileLeft:function(t,e,i){return e>0?this.layers[t].data[i][e-1]:null},getTileRight:function(t,e,i){return e<this.layers[t].width-1?this.layers[t].data[i][e+1]:null},setLayer:function(t){t=this.getLayer(t),this.layers[t]&&(this.currentLayer=t)},hasTile:function(t,e,i){return i=this.getLayer(i),void 0!==this.layers[i].data[e]&&void 0!==this.layers[i].data[e][t]&&this.layers[i].data[e][t].index>-1},removeTile:function(t,i,s){if(s=this.getLayer(s),t>=0&&t<this.layers[s].width&&i>=0&&i<this.layers[s].height&&this.hasTile(t,i,s)){var n=this.layers[s].data[i][t];return this.layers[s].data[i][t]=new e.Tile(this.layers[s],-1,t,i,this.tileWidth,this.tileHeight),this.layers[s].dirty=!0,this.calculateFaces(s),n}},removeTileWorldXY:function(t,e,i,s,n){return n=this.getLayer(n),t=this.game.math.snapToFloor(t,i)/i,e=this.game.math.snapToFloor(e,s)/s,this.removeTile(t,e,n)},putTile:function(t,i,s,n){if(null===t)return this.removeTile(i,s,n);if(n=this.getLayer(n),i>=0&&i<this.layers[n].width&&s>=0&&s<this.layers[n].height){var r;return t instanceof e.Tile?(r=t.index,this.hasTile(i,s,n)?this.layers[n].data[s][i].copy(t):this.layers[n].data[s][i]=new e.Tile(n,r,i,s,t.width,t.height)):(r=t,this.hasTile(i,s,n)?this.layers[n].data[s][i].index=r:this.layers[n].data[s][i]=new e.Tile(this.layers[n],r,i,s,this.tileWidth,this.tileHeight)),this.collideIndexes.indexOf(r)>-1?this.layers[n].data[s][i].setCollision(!0,!0,!0,!0):this.layers[n].data[s][i].resetCollision(),this.layers[n].dirty=!0,this.calculateFaces(n),this.layers[n].data[s][i]}return null},putTileWorldXY:function(t,e,i,s,n,r){return r=this.getLayer(r),e=this.game.math.snapToFloor(e,s)/s,i=this.game.math.snapToFloor(i,n)/n,this.putTile(t,e,i,r)},searchTileIndex:function(t,e,i,s){void 0===e&&(e=0),void 0===i&&(i=!1),s=this.getLayer(s);var n=0;if(i){for(r=this.layers[s].height-1;r>=0;r--)for(o=this.layers[s].width-1;o>=0;o--)if(this.layers[s].data[r][o].index===t){if(n===e)return this.layers[s].data[r][o];n++}}else for(var r=0;r<this.layers[s].height;r++)for(var o=0;o<this.layers[s].width;o++)if(this.layers[s].data[r][o].index===t){if(n===e)return this.layers[s].data[r][o];n++}return null},getTile:function(t,e,i,s){return void 0===s&&(s=!1),i=this.getLayer(i),t>=0&&t<this.layers[i].width&&e>=0&&e<this.layers[i].height?-1===this.layers[i].data[e][t].index?s?this.layers[i].data[e][t]:null:this.layers[i].data[e][t]:null},getTileWorldXY:function(t,e,i,s,n,r){return void 0===i&&(i=this.tileWidth),void 0===s&&(s=this.tileHeight),n=this.getLayer(n),t=this.game.math.snapToFloor(t,i)/i,e=this.game.math.snapToFloor(e,s)/s,this.getTile(t,e,n,r)},copy:function(t,e,i,s,n){n=this.getLayer(n);{if(this.layers[n]){void 0===t&&(t=0),void 0===e&&(e=0),void 0===i&&(i=this.layers[n].width),void 0===s&&(s=this.layers[n].height),t<0&&(t=0),e<0&&(e=0),i>this.layers[n].width&&(i=this.layers[n].width),s>this.layers[n].height&&(s=this.layers[n].height),this._results.length=0,this._results.push({x:t,y:e,width:i,height:s,layer:n});for(var r=e;r<e+s;r++)for(var o=t;o<t+i;o++)this._results.push(this.layers[n].data[r][o]);return this._results}this._results.length=0}},paste:function(t,e,i,s){if(void 0===t&&(t=0),void 0===e&&(e=0),s=this.getLayer(s),i&&!(i.length<2)){for(var n=t-i[1].x,r=e-i[1].y,o=1;o<i.length;o++)this.layers[s].data[r+i[o].y][n+i[o].x].copy(i[o]);this.layers[s].dirty=!0,this.calculateFaces(s)}},swap:function(t,e,i,s,n,r,o){o=this.getLayer(o),this.copy(i,s,n,r,o),this._results.length<2||(this._tempA=t,this._tempB=e,this._results.forEach(this.swapHandler,this),this.paste(i,s,this._results,o))},swapHandler:function(t){t.index===this._tempA?t.index=this._tempB:t.index===this._tempB&&(t.index=this._tempA)},forEach:function(t,e,i,s,n,r,o){o=this.getLayer(o),this.copy(i,s,n,r,o),this._results.length<2||(this._results.forEach(t,e),this.paste(i,s,this._results,o))},replace:function(t,e,i,s,n,r,o){if(o=this.getLayer(o),this.copy(i,s,n,r,o),!(this._results.length<2)){for(var a=1;a<this._results.length;a++)this._results[a].index===t&&(this._results[a].index=e);this.paste(i,s,this._results,o)}},random:function(t,e,i,s,n){if(n=this.getLayer(n),this.copy(t,e,i,s,n),!(this._results.length<2)){for(var r=[],o=1;o<this._results.length;o++)if(this._results[o].index){var a=this._results[o].index;-1===r.indexOf(a)&&r.push(a)}for(var h=1;h<this._results.length;h++)this._results[h].index=this.game.rnd.pick(r);this.paste(t,e,this._results,n)}},shuffle:function(t,i,s,n,r){if(r=this.getLayer(r),this.copy(t,i,s,n,r),!(this._results.length<2)){for(var o=[],a=1;a<this._results.length;a++)this._results[a].index&&o.push(this._results[a].index);e.ArrayUtils.shuffle(o);for(var h=1;h<this._results.length;h++)this._results[h].index=o[h-1];this.paste(t,i,this._results,r)}},fill:function(t,e,i,s,n,r){if(r=this.getLayer(r),this.copy(e,i,s,n,r),!(this._results.length<2)){for(var o=1;o<this._results.length;o++)this._results[o].index=t;this.paste(e,i,this._results,r)}},removeAllLayers:function(){this.layers.length=0,this.currentLayer=0},dump:function(){for(var t="",e=[""],i=0;i<this.layers[this.currentLayer].height;i++){for(var s=0;s<this.layers[this.currentLayer].width;s++)t+="%c  ",this.layers[this.currentLayer].data[i][s]>1?this.debugMap[this.layers[this.currentLayer].data[i][s]]?e.push("background: "+this.debugMap[this.layers[this.currentLayer].data[i][s]]):e.push("background: #ffffff"):e.push("background: rgb(0, 0, 0)");t+="\n"}e[0]=t,console.log.apply(console,e)},destroy:function(){this.removeAllLayers(),this.data=[],this.game=null}},e.Tilemap.prototype.constructor=e.Tilemap,Object.defineProperty(e.Tilemap.prototype,"layer",{get:function(){return this.layers[this.currentLayer]},set:function(t){t!==this.currentLayer&&this.setLayer(t)}}),e.TilemapLayer=function(t,i,s,n,r){n|=0,r|=0,e.Sprite.call(this,t,0,0),this.map=i,this.index=s,this.layer=i.layers[s],this.canvas=e.CanvasPool.create(this,n,r),this.context=this.canvas.getContext("2d"),this.setTexture(new PIXI.Texture(new PIXI.BaseTexture(this.canvas,null,this.game.resolution))),this.type=e.TILEMAPLAYER,this.physicsType=e.TILEMAPLAYER,this.renderSettings={enableScrollDelta:!0,overdrawRatio:.2,copyCanvas:null},this.debug=!1,this.exists=!0,this.debugSettings={missingImageFill:"rgb(255,255,255)",debuggedTileOverfill:"rgba(0,255,0,0.4)",forceFullRedraw:!0,debugAlpha:.5,facingEdgeStroke:"rgba(0,255,0,1)",collidingTileOverfill:"rgba(0,255,0,0.2)"},this.scrollFactorX=1,this.scrollFactorY=1,this.dirty=!0,this.rayStepRate=4,this._wrap=!1,this._mc={scrollX:0,scrollY:0,renderWidth:0,renderHeight:0,tileWidth:i.tileWidth,tileHeight:i.tileHeight,cw:i.tileWidth,ch:i.tileHeight,tilesets:[]},this._scrollX=0,this._scrollY=0,this.tileOffset=new e.Point(this.layer.offsetX||0,this.layer.offsetY||0),this._results=[],t.device.canvasBitBltShift||(this.renderSettings.copyCanvas=e.TilemapLayer.ensureSharedCopyCanvas()),this.fixedToCamera=!0},e.TilemapLayer.prototype=Object.create(e.Sprite.prototype),e.TilemapLayer.prototype.constructor=e.TilemapLayer,e.TilemapLayer.prototype.preUpdateCore=e.Component.Core.preUpdate,e.TilemapLayer.sharedCopyCanvas=null,e.TilemapLayer.ensureSharedCopyCanvas=function(){return this.sharedCopyCanvas||(this.sharedCopyCanvas=e.CanvasPool.create(this,2,2)),this.sharedCopyCanvas},e.TilemapLayer.prototype.preUpdate=function(){return this.preUpdateCore()},e.TilemapLayer.prototype.postUpdate=function(){this.fixedToCamera&&(this.position.x=(this.game.camera.view.x+this.cameraOffset.x)/this.game.camera.scale.x,this.position.y=(this.game.camera.view.y+this.cameraOffset.y)/this.game.camera.scale.y),this._scrollX=(this.game.camera.view.x-this.tileOffset.x)*this.scrollFactorX/this.scale.x,this._scrollY=(this.game.camera.view.y-this.tileOffset.y)*this.scrollFactorY/this.scale.y},e.TilemapLayer.prototype._renderCanvas=function(t){this.fixedToCamera&&(this.position.x=(this.game.camera.view.x+this.cameraOffset.x)/this.game.camera.scale.x,this.position.y=(this.game.camera.view.y+this.cameraOffset.y)/this.game.camera.scale.y),this._scrollX=(this.game.camera.view.x-this.tileOffset.x)*this.scrollFactorX/this.scale.x,this._scrollY=(this.game.camera.view.y-this.tileOffset.y)*this.scrollFactorY/this.scale.y,this.render(),PIXI.Sprite.prototype._renderCanvas.call(this,t)},e.TilemapLayer.prototype._renderWebGL=function(t){this.fixedToCamera&&(this.position.x=(this.game.camera.view.x+this.cameraOffset.x)/this.game.camera.scale.x,this.position.y=(this.game.camera.view.y+this.cameraOffset.y)/this.game.camera.scale.y),this._scrollX=(this.game.camera.view.x-this.tileOffset.x)*this.scrollFactorX/this.scale.x,this._scrollY=(this.game.camera.view.y-this.tileOffset.y)*this.scrollFactorY/this.scale.y,this.render(),PIXI.Sprite.prototype._renderWebGL.call(this,t)},e.TilemapLayer.prototype.destroy=function(){e.CanvasPool.remove(this),e.Component.Destroy.prototype.destroy.call(this)},e.TilemapLayer.prototype.resize=function(t,e){this.canvas.width=t,this.canvas.height=e,this.texture.frame.resize(t,e),this.texture.width=t,this.texture.height=e,this.texture.crop.width=t,this.texture.crop.height=e,this.texture.baseTexture.width=t,this.texture.baseTexture.height=e,this.texture.baseTexture.dirty(),this.texture.requiresUpdate=!0,this.texture._updateUvs(),this.dirty=!0},e.TilemapLayer.prototype.resizeWorld=function(){this.game.world.setBounds(0,0,this.layer.widthInPixels*this.scale.x,this.layer.heightInPixels*this.scale.y)},e.TilemapLayer.prototype.getTileOffsetX=function(){return this.tileOffset.x||(this.fixedToCamera?0:this.position.x)},e.TilemapLayer.prototype.getTileOffsetY=function(){return this.tileOffset.y||(this.fixedToCamera?0:this.position.y)},e.TilemapLayer.prototype._fixX=function(t){return 1===this.scrollFactorX||0===this.scrollFactorX&&0===this.position.x?t:0===this.scrollFactorX&&0!==this.position.x?t-this.position.x:this._scrollX+(t-this._scrollX/this.scrollFactorX)},e.TilemapLayer.prototype._unfixX=function(t){return 1===this.scrollFactorX?t:this._scrollX/this.scrollFactorX+(t-this._scrollX)},e.TilemapLayer.prototype._fixY=function(t){return 1===this.scrollFactorY||0===this.scrollFactorY&&0===this.position.y?t:0===this.scrollFactorY&&0!==this.position.y?t-this.position.y:this._scrollY+(t-this._scrollY/this.scrollFactorY)},e.TilemapLayer.prototype._unfixY=function(t){return 1===this.scrollFactorY?t:this._scrollY/this.scrollFactorY+(t-this._scrollY)},e.TilemapLayer.prototype.getTileX=function(t){return Math.floor(this._fixX(t)/this._mc.tileWidth)},e.TilemapLayer.prototype.getTileY=function(t){return Math.floor(this._fixY(t)/this._mc.tileHeight)},e.TilemapLayer.prototype.getTileXY=function(t,e,i){return i.x=this.getTileX(t),i.y=this.getTileY(e),i},e.TilemapLayer.prototype.getRayCastTiles=function(t,e,i,s){e||(e=this.rayStepRate),void 0===i&&(i=!1),void 0===s&&(s=!1);var n=this.getTiles(t.x,t.y,t.width,t.height,i,s);if(0===n.length)return[];for(var r=t.coordinatesOnLine(e),o=[],a=0;a<n.length;a++)for(var h=0;h<r.length;h++){var l=n[a],c=r[h];if(l.containsPoint(c[0],c[1])){o.push(l);break}}return o},e.TilemapLayer.prototype.getTiles=function(t,e,i,s,n,r){void 0===n&&(n=!1),void 0===r&&(r=!1);var o=!(n||r);t=this._fixX(t),e=this._fixY(e);for(var a=Math.floor(t/(this._mc.cw*this.scale.x)),h=Math.floor(e/(this._mc.ch*this.scale.y)),l=Math.ceil((t+i)/(this._mc.cw*this.scale.x))-a,c=Math.ceil((e+s)/(this._mc.ch*this.scale.y))-h;this._results.length;)this._results.pop();for(var u=h;u<h+c;u++)for(var d=a;d<a+l;d++){var p=this.layer.data[u];p&&p[d]&&(o||p[d].isInteresting(n,r))&&this._results.push(p[d])}return this._results.slice()},e.TilemapLayer.prototype.resolveTileset=function(t){var e=this._mc.tilesets;if(t<2e3)for(;e.length<t;)e.push(void 0);var i=this.map.tiles[t]&&this.map.tiles[t][2];if(null!==i){var s=this.map.tilesets[i];if(s&&s.containsTileIndex(t))return e[t]=s}return e[t]=null},e.TilemapLayer.prototype.resetTilesetCache=function(){for(var t=this._mc.tilesets;t.length;)t.pop()},e.TilemapLayer.prototype.setScale=function(t,e){t=t||1,e=e||t;for(var i=0;i<this.layer.data.length;i++)for(var s=this.layer.data[i],n=0;n<s.length;n++){var r=s[n];r.width=this.map.tileWidth*t,r.height=this.map.tileHeight*e,r.worldX=r.x*r.width,r.worldY=r.y*r.height}this.scale.setTo(t,e)},e.TilemapLayer.prototype.shiftCanvas=function(t,e,i){var s=t.canvas,n=s.width-Math.abs(e),r=s.height-Math.abs(i),o=0,a=0,h=e,l=i;e<0&&(o=-e,h=0),i<0&&(a=-i,l=0);var c=this.renderSettings.copyCanvas;if(c){(c.width<n||c.height<r)&&(c.width=n,c.height=r);var u=c.getContext("2d");u.clearRect(0,0,n,r),u.drawImage(s,o,a,n,r,0,0,n,r),t.clearRect(h,l,n,r),t.drawImage(c,0,0,n,r,h,l,n,r)}else t.save(),t.globalCompositeOperation="copy",t.drawImage(s,o,a,n,r,h,l,n,r),t.restore()},e.TilemapLayer.prototype.renderRegion=function(t,e,i,s,n,r){var o=this.context,a=this.layer.width,h=this.layer.height,l=this._mc.tileWidth,c=this._mc.tileHeight,u=this._mc.tilesets,d=NaN;this._wrap||(i<=n&&(i=Math.max(0,i),n=Math.min(a-1,n)),s<=r&&(s=Math.max(0,s),r=Math.min(h-1,r)));var p,f,g,m,y,v,x=i*l-t,b=(i+(1<<20)*a)%a;for(m=(s+(1<<20)*h)%h,v=r-s,f=s*c-e;v>=0;m++,v--,f+=c){m>=h&&(m-=h);var _=this.layer.data[m];for(g=b,y=n-i,p=x;y>=0;g++,y--,p+=l){g>=a&&(g-=a);var w=_[g];if(w&&!(w.index<0)){var T=w.index,P=u[T];void 0===P&&(P=this.resolveTileset(T)),w.alpha===d||this.debug||(o.globalAlpha=w.alpha,d=w.alpha),P?w.rotation||w.flipped?(o.save(),o.translate(p+w.centerX,f+w.centerY),o.rotate(w.rotation),w.flipped&&o.scale(-1,1),P.draw(o,-w.centerX,-w.centerY,T),o.restore()):P.draw(o,p,f,T):this.debugSettings.missingImageFill&&(o.fillStyle=this.debugSettings.missingImageFill,o.fillRect(p,f,l,c)),w.debug&&this.debugSettings.debuggedTileOverfill&&(o.fillStyle=this.debugSettings.debuggedTileOverfill,o.fillRect(p,f,l,c))}}}},e.TilemapLayer.prototype.renderDeltaScroll=function(t,e){var i=this._mc.scrollX,s=this._mc.scrollY,n=this.canvas.width,r=this.canvas.height,o=this._mc.tileWidth,a=this._mc.tileHeight,h=0,l=-o,c=0,u=-a;if(t<0?(h=n+t,l=n-1):t>0&&(l=t),e<0?(c=r+e,u=r-1):e>0&&(u=e),this.shiftCanvas(this.context,t,e),h=Math.floor((h+i)/o),l=Math.floor((l+i)/o),c=Math.floor((c+s)/a),u=Math.floor((u+s)/a),h<=l){this.context.clearRect(h*o-i,0,(l-h+1)*o,r);var d=Math.floor((0+s)/a),p=Math.floor((r-1+s)/a);this.renderRegion(i,s,h,d,l,p)}if(c<=u){this.context.clearRect(0,c*a-s,n,(u-c+1)*a);var f=Math.floor((0+i)/o),g=Math.floor((n-1+i)/o);this.renderRegion(i,s,f,c,g,u)}},e.TilemapLayer.prototype.renderFull=function(){var t=this._mc.scrollX,e=this._mc.scrollY,i=this.canvas.width,s=this.canvas.height,n=this._mc.tileWidth,r=this._mc.tileHeight,o=Math.floor(t/n),a=Math.floor((i-1+t)/n),h=Math.floor(e/r),l=Math.floor((s-1+e)/r);this.context.clearRect(0,0,i,s),this.renderRegion(t,e,o,h,a,l)},e.TilemapLayer.prototype.render=function(){var t=!1;if(this.visible){(this.dirty||this.layer.dirty)&&(this.layer.dirty=!1,t=!0);var e=this.canvas.width,i=this.canvas.height,s=0|this._scrollX,n=0|this._scrollY,r=this._mc,o=r.scrollX-s,a=r.scrollY-n;if(t||0!==o||0!==a||r.renderWidth!==e||r.renderHeight!==i)return this.context.save(),r.scrollX=s,r.scrollY=n,r.renderWidth===e&&r.renderHeight===i||(r.renderWidth=e,r.renderHeight=i),this.debug&&(this.context.globalAlpha=this.debugSettings.debugAlpha,this.debugSettings.forceFullRedraw&&(t=!0)),!t&&this.renderSettings.enableScrollDelta&&Math.abs(o)+Math.abs(a)<Math.min(e,i)?this.renderDeltaScroll(o,a):this.renderFull(),this.debug&&(this.context.globalAlpha=1,this.renderDebug()),this.texture.baseTexture.dirty(),this.dirty=!1,this.context.restore(),!0}},e.TilemapLayer.prototype.renderDebug=function(){var t,e,i,s,n,r,o=this._mc.scrollX,a=this._mc.scrollY,h=this.context,l=this.canvas.width,c=this.canvas.height,u=this.layer.width,d=this.layer.height,p=this._mc.tileWidth,f=this._mc.tileHeight,g=Math.floor(o/p),m=Math.floor((l-1+o)/p),y=Math.floor(a/f),v=Math.floor((c-1+a)/f),x=g*p-o,b=y*f-a,_=(g+(1<<20)*u)%u,w=(y+(1<<20)*d)%d;for(h.strokeStyle=this.debugSettings.facingEdgeStroke,s=w,r=v-y,e=b;r>=0;s++,r--,e+=f){s>=d&&(s-=d);var T=this.layer.data[s];for(i=_,n=m-g,t=x;n>=0;i++,n--,t+=p){i>=u&&(i-=u);var P=T[i];!P||P.index<0||!P.collides||(this.debugSettings.collidingTileOverfill&&(h.fillStyle=this.debugSettings.collidingTileOverfill,h.fillRect(t,e,this._mc.cw,this._mc.ch)),this.debugSettings.facingEdgeStroke&&(h.beginPath(),P.faceTop&&(h.moveTo(t,e),h.lineTo(t+this._mc.cw,e)),P.faceBottom&&(h.moveTo(t,e+this._mc.ch),h.lineTo(t+this._mc.cw,e+this._mc.ch)),P.faceLeft&&(h.moveTo(t,e),h.lineTo(t,e+this._mc.ch)),P.faceRight&&(h.moveTo(t+this._mc.cw,e),h.lineTo(t+this._mc.cw,e+this._mc.ch)),h.closePath(),h.stroke()))}}},Object.defineProperty(e.TilemapLayer.prototype,"wrap",{get:function(){return this._wrap},set:function(t){this._wrap=t,this.dirty=!0}}),Object.defineProperty(e.TilemapLayer.prototype,"scrollX",{get:function(){return this._scrollX},set:function(t){this._scrollX=t}}),Object.defineProperty(e.TilemapLayer.prototype,"scrollY",{get:function(){return this._scrollY},set:function(t){this._scrollY=t}}),Object.defineProperty(e.TilemapLayer.prototype,"collisionWidth",{get:function(){return this._mc.cw},set:function(t){this._mc.cw=0|t,this.dirty=!0}}),Object.defineProperty(e.TilemapLayer.prototype,"collisionHeight",{get:function(){return this._mc.ch},set:function(t){this._mc.ch=0|t,this.dirty=!0}}),e.TilemapParser={INSERT_NULL:!1,parse:function(t,i,s,n,r,o){if(void 0===s&&(s=32),void 0===n&&(n=32),void 0===r&&(r=10),void 0===o&&(o=10),void 0===i)return this.getEmptyData();if(null===i)return this.getEmptyData(s,n,r,o);var a=t.cache.getTilemapData(i);if(a){if(a.format===e.Tilemap.CSV)return this.parseCSV(i,a.data,s,n);if(!a.format||a.format===e.Tilemap.TILED_JSON)return this.parseTiledJSON(a.data)}else console.warn("Phaser.TilemapParser.parse - No map data found for key "+i)},parseCSV:function(t,i,s,n){for(var r=this.getEmptyData(),o=[],a=(i=i.trim()).split("\n"),h=a.length,l=0,c=0;c<a.length;c++){o[c]=[];for(var u=a[c].split(","),d=0;d<u.length;d++)o[c][d]=new e.Tile(r.layers[0],parseInt(u[d],10),d,c,s,n);0===l&&(l=u.length)}return r.format=e.Tilemap.CSV,r.name=t,r.width=l,r.height=h,r.tileWidth=s,r.tileHeight=n,r.widthInPixels=l*s,r.heightInPixels=h*n,r.layers[0].width=l,r.layers[0].height=h,r.layers[0].widthInPixels=r.widthInPixels,r.layers[0].heightInPixels=r.heightInPixels,r.layers[0].data=o,r},getEmptyData:function(t,e,i,s){return{width:void 0!==i&&null!==i?i:0,height:void 0!==s&&null!==s?s:0,tileWidth:void 0!==t&&null!==t?t:0,tileHeight:void 0!==e&&null!==e?e:0,orientation:"orthogonal",version:"1",properties:{},widthInPixels:0,heightInPixels:0,layers:[{name:"layer",x:0,y:0,width:0,height:0,widthInPixels:0,heightInPixels:0,alpha:1,visible:!0,properties:{},indexes:[],callbacks:[],bodies:[],data:[]}],images:[],objects:{},collision:{},tilesets:[],tiles:[]}},_slice:function(t,e){var i={};for(var s in e){var n=e[s];void 0!==t[n]&&(i[n]=t[n])}return i},parseObjectGroup:function(t,e,i,s,n){var s=s||t.name,n=n||{x:0,y:0},r=this._slice;s||console.warn("No name found for objectGroup",t),void 0!==n.x&&void 0!==n.y||console.warn("Malformed xy properties in relativePosition",n),e[s]=e[s]||[],i[s]=i[s]||[];for(var o=0,a=t.objects.length;o<a;o++){var h=t.objects[o];if(h.gid){l={gid:h.gid,name:h.name,type:h.type||"",x:h.x+n.x,y:h.y+n.y,width:h.width,height:h.height,visible:h.visible,properties:h.properties};h.rotation&&(l.rotation=h.rotation),e[s].push(l)}else if(h.polyline){var l={name:h.name,type:h.type,x:h.x+n.x,y:h.y+n.y,width:h.width,height:h.height,visible:h.visible,properties:h.properties};h.rotation&&(l.rotation=h.rotation),l.polyline=[];for(c=0;c<h.polyline.length;c++)l.polyline.push([h.polyline[c].x,h.polyline[c].y]);i[s].push(l),e[s].push(l)}else if(h.polygon){(l=r(h,["name","type","x","y","visible","rotation","properties"])).x+=n.x,l.y+=n.y,l.polygon=[];for(var c=0;c<h.polygon.length;c++)l.polygon.push([h.polygon[c].x,h.polygon[c].y]);i[s].push(l),e[s].push(l)}else h.ellipse?((l=r(h,["name","type","ellipse","x","y","width","height","visible","rotation","properties"])).x+=n.x,l.y+=n.y,i[s].push(l),e[s].push(l)):((l=r(h,["name","type","x","y","width","height","visible","rotation","properties"])).x+=n.x,l.y+=n.y,l.rectangle=!0,i[s].push(l),e[s].push(l))}return{objectsCollection:e,collisionCollection:i}},parseTiledJSON:function(t){if("orthogonal"!==t.orientation)return console.warn("TilemapParser.parseTiledJSON - Only orthogonal map types are supported in this version of Phaser"),null;for(var i={width:t.width,height:t.height,tileWidth:t.tilewidth,tileHeight:t.tileheight,orientation:t.orientation,format:e.Tilemap.TILED_JSON,version:t.version,properties:t.properties,widthInPixels:t.width*t.tilewidth,heightInPixels:t.height*t.tileheight},s=[],n=0;n<t.layers.length;n++)if("tilelayer"===t.layers[n].type){var r=t.layers[n];if(!r.compression&&r.encoding&&"base64"===r.encoding){for(var o=window.atob(r.data),a=o.length,h=new Array(a),l=0;l<a;l+=4)h[l/4]=(o.charCodeAt(l)|o.charCodeAt(l+1)<<8|o.charCodeAt(l+2)<<16|o.charCodeAt(l+3)<<24)>>>0;r.data=h,delete r.encoding}else if(r.compression){console.warn("TilemapParser.parseTiledJSON - Layer compression is unsupported, skipping layer '"+r.name+"'");continue}k={name:r.name,x:r.x,y:r.y,width:r.width,height:r.height,widthInPixels:r.width*t.tilewidth,heightInPixels:r.height*t.tileheight,alpha:r.opacity,offsetX:r.offsetx,offsetY:r.offsety,visible:r.visible,properties:{},indexes:[],callbacks:[],bodies:[]};r.properties&&(k.properties=r.properties);for(var c,u,d,p=0,f=[],g=[],m=0,a=r.data.length;m<a;m++){if(c=0,u=!1,A=r.data[m],d=0,A>536870912)switch(A>2147483648&&(A-=2147483648,d+=4),A>1073741824&&(A-=1073741824,d+=2),A>536870912&&(A-=536870912,d+=1),d){case 5:c=Math.PI/2;break;case 6:c=Math.PI;break;case 3:c=3*Math.PI/2;break;case 4:c=0,u=!0;break;case 7:c=Math.PI/2,u=!0;break;case 2:c=Math.PI,u=!0;break;case 1:c=3*Math.PI/2,u=!0}A>0?((F=new e.Tile(k,A,p,g.length,t.tilewidth,t.tileheight)).rotation=c,F.flipped=u,0!==d&&(F.flippedVal=d),f.push(F)):e.TilemapParser.INSERT_NULL?f.push(null):f.push(new e.Tile(k,-1,p,g.length,t.tilewidth,t.tileheight)),++p===r.width&&(g.push(f),p=0,f=[])}k.data=g,s.push(k)}i.layers=s;for(var y=[],n=0;n<t.layers.length;n++)if("imagelayer"===t.layers[n].type){var v=t.layers[n],x={name:v.name,image:v.image,x:v.x,y:v.y,alpha:v.opacity,visible:v.visible,properties:{}};v.properties&&(x.properties=v.properties),y.push(x)}i.images=y;for(var b=[],_={},w=[],T=null,n=0;n<t.tilesets.length;n++){if((U=t.tilesets[n]).source)console.warn("Phaser.TilemapParser - Phaser can't load external tilesets (%s). Use the Embed Tileset button and then export the map again.",U.source);else if(U.image){var P=new e.Tileset(U.name,U.firstgid,U.tilewidth,U.tileheight,U.margin,U.spacing,U.properties);U.tileproperties&&(P.tileProperties=U.tileproperties),P.updateTileData(U.imagewidth,U.imageheight),b.push(P)}else{if(!U.tiles)throw new Error("Tileset "+U.name+" has no `image` or `tiles` property.");var C=new e.ImageCollection(U.name,U.firstgid,U.tilewidth,U.tileheight,U.margin,U.spacing,U.properties);for(var S in U.tiles){var x=U.tiles[S].image,A=U.firstgid+parseInt(S,10);C.addImage(A,x)}w.push(C)}for(var S in U.tiles)(R=U.tiles[S].objectgroup)&&(_[parseInt(S,10)+U.firstgid]=R);T&&(T.lastgid=U.firstgid-1),T=U}if(0===b.length&&0===w.length)throw new Error("This tilemap has no tilesets.");i.tilesets=b,i.imagecollections=w;for(var E={},M={},n=0;n<t.layers.length;n++)if("objectgroup"===t.layers[n].type){var R=t.layers[n];this.parseObjectGroup(R,E,M)}i.objects=E,i.collision=M,i.tiles=[];for(n=0;n<i.tilesets.length;n++)for(var p=(U=i.tilesets[n]).tileMargin,L=U.tileMargin,B=0,I=0,O=0,m=U.firstgid;m<U.firstgid+U.total&&(i.tiles[m]=[p,L,n],p+=U.tileWidth+U.tileSpacing,++B!==U.total)&&(++I!==U.columns||(p=U.tileMargin,L+=U.tileHeight+U.tileSpacing,I=0,++O!==U.rows));m++);for(var k,F,D,U,n=0;n<i.layers.length;n++){M[(k=i.layers[n]).name]=[],U=null;for(l=0;l<k.data.length;l++){f=k.data[l];for(var G=0;G<f.length;G++)null===(F=f[G])||F.index<0||(D=i.tiles[F.index][2],(U=i.tilesets[D]).tileProperties&&U.tileProperties[F.index-U.firstgid]&&(F.properties=e.Utils.mixin(U.tileProperties[F.index-U.firstgid],F.properties)),(R=_[F.index])&&this.parseObjectGroup(R,i.objects,i.collision,F.layer.name,{x:F.worldX+R.x,y:F.worldY+R.y}))}}return i}},e.Tileset=function(t,e,i,s,n,r,o){(void 0===i||i<=0)&&(i=32),(void 0===s||s<=0)&&(s=32),void 0===n&&(n=0),void 0===r&&(r=0),this.name=t,this.firstgid=0|e,this.tileWidth=0|i,this.tileHeight=0|s,this.tileMargin=0|n,this.tileSpacing=0|r,this.properties=o||{},this.image=null,this.rows=0,this.columns=0,this.total=0,this.drawCoords=[]},e.Tileset.prototype={draw:function(t,e,i,s){var n=s-this.firstgid<<1;n>=0&&n+1<this.drawCoords.length&&t.drawImage(this.image,this.drawCoords[n],this.drawCoords[n+1],this.tileWidth,this.tileHeight,e,i,this.tileWidth,this.tileHeight)},containsTileIndex:function(t){return t>=this.firstgid&&t<this.firstgid+this.total},setImage:function(t){this.image=t,this.updateTileData(t.width,t.height)},setSpacing:function(t,e){this.tileMargin=0|t,this.tileSpacing=0|e,this.image&&this.updateTileData(this.image.width,this.image.height)},updateTileData:function(t,e){var i=(e-2*this.tileMargin+this.tileSpacing)/(this.tileHeight+this.tileSpacing),s=(t-2*this.tileMargin+this.tileSpacing)/(this.tileWidth+this.tileSpacing);i%1==0&&s%1==0||console.warn("Phaser.Tileset - '%s' image tile area (%s x %s) is not a whole multiple of tile size (%s x %s + %s + %s)",this.name,t,e,this.tileWidth,this.tileHeight,this.tileMargin,this.tileSpacing),i=Math.floor(i),s=Math.floor(s),(this.rows&&this.rows!==i||this.columns&&this.columns!==s)&&console.warn("Phaser.Tileset - Tile layout from image '%s' (%s rows by %s columns) differs from tileset '%s' (%s rows by %s columns)",this.image.name,s,i,this.name,this.columns,this.rows),this.rows=i,this.columns=s,this.total=i*s,this.drawCoords.length=0;for(var n=this.tileMargin,r=this.tileMargin,o=0;o<this.rows;o++){for(var a=0;a<this.columns;a++)this.drawCoords.push(n),this.drawCoords.push(r),n+=this.tileWidth+this.tileSpacing;n=this.tileMargin,r+=this.tileHeight+this.tileSpacing}}},e.Tileset.prototype.constructor=e.Tileset,e.Particle=function(t,i,s,n,r){e.Sprite.call(this,t,i,s,n,r),this.autoScale=!1,this.scaleData=null,this._s=0,this.autoAlpha=!1,this.alphaData=null,this._a=0},e.Particle.prototype=Object.create(e.Sprite.prototype),e.Particle.prototype.constructor=e.Particle,e.Particle.prototype.update=function(){this.autoScale&&(--this._s?this.scale.set(this.scaleData[this._s].x,this.scaleData[this._s].y):this.autoScale=!1),this.autoAlpha&&(--this._a?this.alpha=this.alphaData[this._a].v:this.autoAlpha=!1)},e.Particle.prototype.onEmit=function(){},e.Particle.prototype.setAlphaData=function(t){this.alphaData=t,this._a=t.length-1,this.alpha=this.alphaData[this._a].v,this.autoAlpha=!0},e.Particle.prototype.setScaleData=function(t){this.scaleData=t,this._s=t.length-1,this.scale.set(this.scaleData[this._s].x,this.scaleData[this._s].y),this.autoScale=!0},e.Particle.prototype.reset=function(t,i,s){return e.Component.Reset.prototype.reset.call(this,t,i,s),this.alpha=1,this.scale.set(1),this.autoScale=!1,this.autoAlpha=!1,this},e.Particles=function(t){this.game=t,this.emitters={},this.ID=0},e.Particles.prototype={add:function(t){return this.emitters[t.id]=t,t},remove:function(t){delete this.emitters[t.id]}},e.Particles.prototype.constructor=e.Particles,e.Particles.Arcade={},e.Particles.Arcade.Emitter=function(t,i,s,n){this.maxParticles=n||50,e.Group.call(this,t),this._id=this.game.particles.ID++,this.name="emitter"+this.id,this.type=e.EMITTER,this.physicsType=e.GROUP,this.area=new e.Rectangle(i,s,1,1),this.minAngle=null,this.maxAngle=null,this.minSpeed=0,this.maxSpeed=100,this.minParticleSpeed=new e.Point(-100,-100),this.maxParticleSpeed=new e.Point(100,100),this.minParticleScale=1,this.maxParticleScale=1,this.scaleData=null,this.minRotation=-360,this.maxRotation=360,this.minParticleAlpha=1,this.maxParticleAlpha=1,this.alphaData=null,this.particleClass=e.Particle,this.particleDrag=new e.Point,this.angularDrag=0,this.frequency=100,this.lifespan=2e3,this.bounce=new e.Point,this.on=!1,this.particleAnchor=new e.Point(.5,.5),this.blendMode=e.blendModes.NORMAL,this.emitX=i,this.emitY=s,this.autoScale=!1,this.autoAlpha=!1,this.particleBringToTop=!1,this.particleSendToBack=!1,this.counts={emitted:0,failed:0,totalEmitted:0,totalFailed:0},this._gravity=new e.Point(0,100),this._minParticleScale=new e.Point(1,1),this._maxParticleScale=new e.Point(1,1),this._total=0,this._timer=0,this._counter=0,this._flowQuantity=0,this._flowTotal=0,this._explode=!0,this._frames=null},e.Particles.Arcade.Emitter.prototype=Object.create(e.Group.prototype),e.Particles.Arcade.Emitter.prototype.constructor=e.Particles.Arcade.Emitter,e.Particles.Arcade.Emitter.prototype.update=function(){if(this.counts.emitted=0,this.counts.failed=0,this.on&&this.game.time.time>=this._timer)if(this._timer=this.game.time.time+this.frequency*this.game.time.slowMotion,0!==this._flowTotal)if(this._flowQuantity>0){for(t=0;t<this._flowQuantity;t++)if(this.emitParticle()&&(this._counter++,-1!==this._flowTotal&&this._counter>=this._flowTotal)){this.on=!1;break}}else this.emitParticle()&&(this._counter++,-1!==this._flowTotal&&this._counter>=this._flowTotal&&(this.on=!1));else this.emitParticle()&&(this._counter++,this._total>0&&this._counter>=this._total&&(this.on=!1));for(var t=this.children.length;t--;)this.children[t].exists&&this.children[t].update()},e.Particles.Arcade.Emitter.prototype.makeParticles=function(t,e,i,s,n,r){void 0===e&&(e=0),void 0===i&&(i=this.maxParticles),void 0===s&&(s=!1),void 0===n&&(n=!1),void 0===r&&(r=null);var o,a=0,h=t,l=e;for(this._frames=e,i>this.maxParticles&&(this.maxParticles=i);a<i;)Array.isArray(t)&&(h=this.game.rnd.pick(t)),Array.isArray(e)&&(l=this.game.rnd.pick(e)),o=new this.particleClass(this.game,0,0,h,l,r),this.game.physics.arcade.enable(o,!1),o.body.checkCollision.none=!s,o.body.collideWorldBounds=n,o.body.skipQuadTree=!0,o.exists=!1,o.visible=!1,o.anchor.copyFrom(this.particleAnchor),this.add(o),a++;return this},e.Particles.Arcade.Emitter.prototype.kill=function(){return this.on=!1,this.alive=!1,this.exists=!1,this},e.Particles.Arcade.Emitter.prototype.revive=function(){return this.alive=!0,this.exists=!0,this},e.Particles.Arcade.Emitter.prototype.explode=function(t,e){return void 0===e&&(e=this.maxParticles),this._flowTotal=0,this.start(!0,t,0,e,!1),this},e.Particles.Arcade.Emitter.prototype.flow=function(t,e,i,s,n){return void 0!==e&&null!==e||(e=250),void 0!==i&&0!==i||(i=1),void 0===s&&(s=-1),void 0===n&&(n=!0),i>this.maxParticles&&(i=this.maxParticles),this._counter=0,this._flowQuantity=i,this._flowTotal=s,n?(this.start(!0,t,e,i),this._counter+=i,this.on=!0,this._timer=this.game.time.time+e*this.game.time.slowMotion):this.start(!1,t,e,i),this},e.Particles.Arcade.Emitter.prototype.start=function(t,e,i,s,n){if(void 0===t&&(t=!0),void 0===e&&(e=0),void 0!==i&&null!==i||(i=250),void 0===s&&(s=0),void 0===n&&(n=!1),s>this.maxParticles&&(s=this.maxParticles),this.revive(),this.visible=!0,this.lifespan=e,this.frequency=i,t||n)for(var r=0;r<s;r++)this.emitParticle();else this.on=!0,this._total=s,this._counter=0,this._timer=this.game.time.time+i*this.game.time.slowMotion;return this},e.Particles.Arcade.Emitter.prototype.emitParticle=function(t,e,i,s){void 0===t&&(t=null),void 0===e&&(e=null);var n=this.getNextParticle();if(null===n)return this.counts.failed++,this.counts.totalFailed++,!1;this.counts.emitted++,this.counts.totalEmitted++;var r=this.game.rnd;void 0!==i&&void 0!==s?n.loadTexture(i,s):void 0!==i&&(n.loadTexture(i),n.frame=Array.isArray(this._frames)?r.pick(this._frames):this._frames);var o=this.emitX,a=this.emitY;return null!==t?o=t:this.width>1&&(o=r.between(this.left,this.right)),null!==e?a=e:this.height>1&&(a=r.between(this.top,this.bottom)),this.resetParticle(n,o,a),!0},e.Particles.Arcade.Emitter.prototype.getNextParticle=function(){for(var t=this.length;t--;){var e=this.next();if(!e.exists)return e}return null},e.Particles.Arcade.Emitter.prototype.resetParticle=function(t,e,i){var s=this.game.rnd;t.reset(e,i),t.angle=0,t.lifespan=this.lifespan,this.particleBringToTop?this.bringToTop(t):this.particleSendToBack&&this.sendToBack(t),this.autoScale?t.setScaleData(this.scaleData):1!==this.minParticleScale||1!==this.maxParticleScale?t.scale.set(s.realInRange(this.minParticleScale,this.maxParticleScale)):this._minParticleScale.x!==this._maxParticleScale.x||this._minParticleScale.y!==this._maxParticleScale.y?t.scale.set(s.realInRange(this._minParticleScale.x,this._maxParticleScale.x),s.realInRange(this._minParticleScale.y,this._maxParticleScale.y)):t.scale.set(this._minParticleScale.x,this._minParticleScale.y),this.autoAlpha?t.setAlphaData(this.alphaData):t.alpha=s.realInRange(this.minParticleAlpha,this.maxParticleAlpha),t.blendMode=this.blendMode;var n=t.body;n.updateBounds(),n.bounce.copyFrom(this.bounce),n.drag.copyFrom(this.particleDrag),null!=this.minAngle&&null!=this.maxAngle?this.game.physics.arcade.velocityFromAngle(this.minAngle===this.maxAngle?this.minAngle:s.between(this.minAngle,this.maxAngle),this.minSpeed===this.maxSpeed?this.minSpeed:s.between(this.minSpeed,this.maxSpeed),n.velocity):(n.velocity.x=s.between(this.minParticleSpeed.x,this.maxParticleSpeed.x),n.velocity.y=s.between(this.minParticleSpeed.y,this.maxParticleSpeed.y)),n.angularVelocity=s.between(this.minRotation,this.maxRotation),n.gravity.copyFrom(this.gravity),n.angularDrag=this.angularDrag,t.onEmit()},e.Particles.Arcade.Emitter.prototype.destroy=function(){this.game.particles.remove(this),e.Group.prototype.destroy.call(this,!0,!1)},e.Particles.Arcade.Emitter.prototype.setSize=function(t,e){return this.area.width=t,this.area.height=e,this},e.Particles.Arcade.Emitter.prototype.setXSpeed=function(t,e){return t=t||0,e=e||0,this.minParticleSpeed.x=t,this.maxParticleSpeed.x=e,this},e.Particles.Arcade.Emitter.prototype.setYSpeed=function(t,e){return t=t||0,e=e||0,this.minParticleSpeed.y=t,this.maxParticleSpeed.y=e,this},e.Particles.Arcade.Emitter.prototype.setRotation=function(t,e){return t=t||0,e=e||0,this.minRotation=t,this.maxRotation=e,this},e.Particles.Arcade.Emitter.prototype.setAlpha=function(t,i,s,n,r){if(void 0===t&&(t=1),void 0===i&&(i=1),void 0===s&&(s=0),void 0===n&&(n=e.Easing.Linear.None),void 0===r&&(r=!1),this.minParticleAlpha=t,this.maxParticleAlpha=i,this.autoAlpha=!1,s>0&&t!==i){var o={v:t},a=this.game.make.tween(o).to({v:i},s,n);a.yoyo(r),this.alphaData=a.generateData(60),this.alphaData.reverse(),this.autoAlpha=!0}return this},e.Particles.Arcade.Emitter.prototype.setScale=function(t,i,s,n,r,o,a){if(void 0===t&&(t=1),void 0===i&&(i=1),void 0===s&&(s=1),void 0===n&&(n=1),void 0===r&&(r=0),void 0===o&&(o=e.Easing.Linear.None),void 0===a&&(a=!1),this.minParticleScale=1,this.maxParticleScale=1,this._minParticleScale.set(t,s),this._maxParticleScale.set(i,n),this.autoScale=!1,r>0&&(t!==i||s!==n)){var h={x:t,y:s},l=this.game.make.tween(h).to({x:i,y:n},r,o);l.yoyo(a),this.scaleData=l.generateData(60),this.scaleData.reverse(),this.autoScale=!0}return this},e.Particles.Arcade.Emitter.prototype.setAngle=function(t,e,i,s){return this.minAngle=t,this.maxAngle=e,null!=i&&(this.minSpeed=i),null!=s&&(this.maxSpeed=s),this},e.Particles.Arcade.Emitter.prototype.at=function(t){return t.center?(this.emitX=t.center.x,this.emitY=t.center.y):(this.emitX=t.world.x+t.anchor.x*t.width,this.emitY=t.world.y+t.anchor.y*t.height),this},Object.defineProperty(e.Particles.Arcade.Emitter.prototype,"gravity",{get:function(){return this._gravity},set:function(t){"number"==typeof t?this._gravity.y=t:this._gravity=t}}),Object.defineProperty(e.Particles.Arcade.Emitter.prototype,"id",{get:function(){return this._id}}),Object.defineProperty(e.Particles.Arcade.Emitter.prototype,"width",{get:function(){return this.area.width},set:function(t){this.area.width=t}}),Object.defineProperty(e.Particles.Arcade.Emitter.prototype,"height",{get:function(){return this.area.height},set:function(t){this.area.height=t}}),Object.defineProperty(e.Particles.Arcade.Emitter.prototype,"x",{get:function(){return this.emitX},set:function(t){this.emitX=t}}),Object.defineProperty(e.Particles.Arcade.Emitter.prototype,"y",{get:function(){return this.emitY},set:function(t){this.emitY=t}}),Object.defineProperty(e.Particles.Arcade.Emitter.prototype,"left",{get:function(){return Math.floor(this.x-this.area.width/2)}}),Object.defineProperty(e.Particles.Arcade.Emitter.prototype,"right",{get:function(){return Math.floor(this.x+this.area.width/2)}}),Object.defineProperty(e.Particles.Arcade.Emitter.prototype,"top",{get:function(){return Math.floor(this.y-this.area.height/2)}}),Object.defineProperty(e.Particles.Arcade.Emitter.prototype,"bottom",{get:function(){return Math.floor(this.y+this.area.height/2)}}),Object.defineProperty(e.Particles.Arcade.Emitter.prototype,"output",{get:function(){return 1e3*this._flowQuantity/this.frequency}}),Object.defineProperty(e.Particles.Arcade.Emitter.prototype,"lifespanOutput",{get:function(){return(0===this.lifespan?1/0:this.lifespan)*this._flowQuantity/this.frequency}}),Object.defineProperty(e.Particles.Arcade.Emitter.prototype,"remainder",{get:function(){return this.maxParticles-this.lifespanOutput}}),e.Weapon=function(t,i){e.Plugin.call(this,t,i),this.bullets=null,this.autoExpandBulletsGroup=!1,this.autofire=!1,this.shots=0,this.fireLimit=0,this.fireRate=100,this.fireRateVariance=0,this.fireFrom=new e.Rectangle(0,0,1,1),this.fireAngle=e.ANGLE_UP,this.bulletInheritSpriteSpeed=!1,this.bulletAnimation="",this.bulletFrameRandom=!1,this.bulletFrameCycle=!1,this.bulletWorldWrap=!1,this.bulletWorldWrapPadding=0,this.bulletAngleOffset=0,this.bulletAngleVariance=0,this.bulletSpeed=200,this.bulletSpeedVariance=0,this.bulletLifespan=0,this.bulletKillDistance=0,this.bulletGravity=new e.Point(0,0),this.bulletRotateToVelocity=!1,this.bulletKey="",this.bulletFrame="",this._bulletClass=e.Bullet,this._bulletCollideWorldBounds=!1,this._bulletKillType=e.Weapon.KILL_WORLD_BOUNDS,this._data={customBody:!1,width:0,height:0,offsetX:0,offsetY:0},this.bounds=new e.Rectangle,this.bulletBounds=t.world.bounds,this.bulletFrames=[],this.bulletFrameIndex=0,this.anims={},this.onFire=new e.Signal,this.onKill=new e.Signal,this.onFireLimit=new e.Signal,this.trackedSprite=null,this.trackedPointer=null,this.multiFire=!1,this._hasFired=!1,this.trackRotation=!1,this.trackOffset=new e.Point,this._nextFire=0,this._tempNextFire=0,this._rotatedPoint=new e.Point},e.Weapon.prototype=Object.create(e.Plugin.prototype),e.Weapon.prototype.constructor=e.Weapon,e.Weapon.KILL_NEVER=0,e.Weapon.KILL_LIFESPAN=1,e.Weapon.KILL_DISTANCE=2,e.Weapon.KILL_WEAPON_BOUNDS=3,e.Weapon.KILL_CAMERA_BOUNDS=4,e.Weapon.KILL_WORLD_BOUNDS=5,e.Weapon.KILL_STATIC_BOUNDS=6,e.Weapon.prototype.createBullets=function(t,i,s,n){return void 0===t&&(t=1),void 0===n&&(n=this.game.world),this.bullets&&!this.bullets.game&&(this.bullets=null),this.bullets||(this.bullets=this.game.add.physicsGroup(e.Physics.ARCADE,n),this.bullets.classType=this._bulletClass),0!==t&&(-1===t&&(this.autoExpandBulletsGroup=!0,t=1),this.bullets.createMultiple(t,i,s),this.bullets.setAll("data.bulletManager",this),this.bulletKey=i,this.bulletFrame=s),this},e.Weapon.prototype.forEach=function(t,e){return this.bullets.forEachExists(t,e,arguments),this},e.Weapon.prototype.pauseAll=function(){return this.bullets.setAll("body.enable",!1),this},e.Weapon.prototype.resumeAll=function(){return this.bullets.setAll("body.enable",!0),this},e.Weapon.prototype.killAll=function(){return this.bullets.callAllExists("kill",!0),this.bullets.setAll("body.enable",!0),this},e.Weapon.prototype.resetShots=function(t){return this.shots=0,void 0!==t&&(this.fireLimit=t),this},e.Weapon.prototype.destroy=function(){this.parent.remove(this,!1),this.bullets.destroy(),this.game=null,this.parent=null,this.active=!1,this.visible=!1},e.Weapon.prototype.update=function(){this._bulletKillType===e.Weapon.KILL_WEAPON_BOUNDS&&(this.trackedSprite?(this.trackedSprite.updateTransform(),this.bounds.centerOn(this.trackedSprite.worldPosition.x,this.trackedSprite.worldPosition.y)):this.trackedPointer&&this.bounds.centerOn(this.trackedPointer.worldX,this.trackedPointer.worldY)),this.autofire&&this.fire()},e.Weapon.prototype.postRender=function(){this.multiFire&&this._hasFired&&(this._hasFired=!1,this._nextFire=this._tempNextFire)},e.Weapon.prototype.trackSprite=function(t,e,i,s){return void 0===e&&(e=0),void 0===i&&(i=0),void 0===s&&(s=!1),this.trackedPointer=null,this.trackedSprite=t,this.trackRotation=s,this.trackOffset.set(e,i),this},e.Weapon.prototype.trackPointer=function(t,e,i){return void 0===t&&(t=this.game.input.activePointer),void 0===e&&(e=0),void 0===i&&(i=0),this.trackedPointer=t,this.trackedSprite=null,this.trackRotation=!1,this.trackOffset.set(e,i),this},e.Weapon.prototype.fireMany=function(t,e){this.multiFire=!0;var i=[],s=this;return e||this.trackedSprite||this.trackedPointer?t.forEach(function(t){i.push(s.fire(e,null,null,t.x,t.y))}):t.forEach(function(t){i.push(s.fire(t))}),i},e.Weapon.prototype.fireOffset=function(t,e){return void 0===t&&(t=0),void 0===e&&(e=0),this.fire(null,null,null,t,e)},e.Weapon.prototype.fire=function(t,i,s,n,r){if(void 0===i&&(i=null),void 0===s&&(s=null),this.game.time.now<this._nextFire||this.fireLimit>0&&this.shots===this.fireLimit)return null;var o=this.bulletSpeed;0!==this.bulletSpeedVariance&&(o+=e.Math.between(-this.bulletSpeedVariance,this.bulletSpeedVariance)),t?this.fireFrom.width>1?this.fireFrom.centerOn(t.x,t.y):(this.fireFrom.x=t.x,this.fireFrom.y=t.y):this.trackedSprite?(this.trackRotation?(this._rotatedPoint.set(this.trackedSprite.world.x+this.trackOffset.x,this.trackedSprite.world.y+this.trackOffset.y),this._rotatedPoint.rotate(this.trackedSprite.world.x,this.trackedSprite.world.y,this.trackedSprite.worldRotation),this.fireFrom.width>1?this.fireFrom.centerOn(this._rotatedPoint.x,this._rotatedPoint.y):(this.fireFrom.x=this._rotatedPoint.x,this.fireFrom.y=this._rotatedPoint.y)):this.fireFrom.width>1?this.fireFrom.centerOn(this.trackedSprite.world.x+this.trackOffset.x,this.trackedSprite.world.y+this.trackOffset.y):(this.fireFrom.x=this.trackedSprite.world.x+this.trackOffset.x,this.fireFrom.y=this.trackedSprite.world.y+this.trackOffset.y),this.bulletInheritSpriteSpeed&&(o+=this.trackedSprite.body.speed)):this.trackedPointer&&(this.fireFrom.width>1?this.fireFrom.centerOn(this.trackedPointer.world.x+this.trackOffset.x,this.trackedPointer.world.y+this.trackOffset.y):(this.fireFrom.x=this.trackedPointer.world.x+this.trackOffset.x,this.fireFrom.y=this.trackedPointer.world.y+this.trackOffset.y)),void 0!==n&&(this.fireFrom.x+=n),void 0!==r&&(this.fireFrom.y+=r);var a=this.fireFrom.width>1?this.fireFrom.randomX:this.fireFrom.x,h=this.fireFrom.height>1?this.fireFrom.randomY:this.fireFrom.y,l=this.trackRotation?this.trackedSprite.angle:this.fireAngle;null!==i&&null!==s&&(l=this.game.math.radToDeg(Math.atan2(s-h,i-a))),0!==this.bulletAngleVariance&&(l+=e.Math.between(-this.bulletAngleVariance,this.bulletAngleVariance));var c=0,u=0;0===l||180===l?c=Math.cos(this.game.math.degToRad(l))*o:90===l||270===l?u=Math.sin(this.game.math.degToRad(l))*o:(c=Math.cos(this.game.math.degToRad(l))*o,u=Math.sin(this.game.math.degToRad(l))*o);var d=null;if(this.autoExpandBulletsGroup?(d=this.bullets.getFirstExists(!1,!0,a,h,this.bulletKey,this.bulletFrame)).data.bulletManager=this:d=this.bullets.getFirstExists(!1),d){if(d.reset(a,h),d.data.fromX=a,d.data.fromY=h,d.data.killType=this.bulletKillType,d.data.killDistance=this.bulletKillDistance,d.data.rotateToVelocity=this.bulletRotateToVelocity,this.bulletKillType===e.Weapon.KILL_LIFESPAN&&(d.lifespan=this.bulletLifespan),d.angle=l+this.bulletAngleOffset,""!==this.bulletAnimation){if(null===d.animations.getAnimation(this.bulletAnimation)){var p=this.anims[this.bulletAnimation];d.animations.add(p.name,p.frames,p.frameRate,p.loop,p.useNumericIndex)}d.animations.play(this.bulletAnimation)}else this.bulletFrameCycle?(d.frame=this.bulletFrames[this.bulletFrameIndex],++this.bulletFrameIndex>=this.bulletFrames.length&&(this.bulletFrameIndex=0)):this.bulletFrameRandom&&(d.frame=this.bulletFrames[Math.floor(Math.random()*this.bulletFrames.length)]);d.data.bodyDirty&&(this._data.customBody&&d.body.setSize(this._data.width,this._data.height,this._data.offsetX,this._data.offsetY),d.body.collideWorldBounds=this.bulletCollideWorldBounds,d.data.bodyDirty=!1),d.body.velocity.set(c,u),d.body.gravity.set(this.bulletGravity.x,this.bulletGravity.y);var f=0;if(0!==this.bulletSpeedVariance){var g=this.fireRate;(g+=e.Math.between(-this.fireRateVariance,this.fireRateVariance))<0&&(g=0),f=this.game.time.now+g}else f=this.game.time.now+this.fireRate;this.multiFire?this._hasFired||(this._hasFired=!0,this._tempNextFire=f,this.shots++):(this._nextFire=f,this.shots++),this.onFire.dispatch(d,this,o),this.fireLimit>0&&this.shots===this.fireLimit&&this.onFireLimit.dispatch(this,this.fireLimit)}return d},e.Weapon.prototype.fireAtPointer=function(t){return void 0===t&&(t=this.game.input.activePointer),this.fire(null,t.worldX,t.worldY)},e.Weapon.prototype.fireAtSprite=function(t){return this.fire(null,t.world.x,t.world.y)},e.Weapon.prototype.fireAtXY=function(t,e){return this.fire(null,t,e)},e.Weapon.prototype.setBulletBodyOffset=function(t,e,i,s){return void 0===i&&(i=0),void 0===s&&(s=0),this._data.customBody=!0,this._data.width=t,this._data.height=e,this._data.offsetX=i,this._data.offsetY=s,this.bullets.callAll("body.setSize","body",t,e,i,s),this.bullets.setAll("data.bodyDirty",!1),this},e.Weapon.prototype.setBulletFrames=function(t,i,s,n){return void 0===s&&(s=!0),void 0===n&&(n=!1),this.bulletFrames=e.ArrayUtils.numberArray(t,i),this.bulletFrameIndex=0,this.bulletFrameCycle=s,this.bulletFrameRandom=n,this},e.Weapon.prototype.addBulletAnimation=function(t,e,i,s,n){return this.anims[t]={name:t,frames:e,frameRate:i,loop:s,useNumericIndex:n},this.bullets.callAll("animations.add","animations",t,e,i,s,n),this.bulletAnimation=t,this},e.Weapon.prototype.debug=function(t,e,i){void 0===t&&(t=16),void 0===e&&(e=32),void 0===i&&(i=!1),this.game.debug.text("Weapon Plugin",t,e),this.game.debug.text("Bullets Alive: "+this.bullets.total+" - Total: "+this.bullets.length,t,e+24),i&&this.bullets.forEachExists(this.game.debug.body,this.game.debug,"rgba(255, 0, 255, 0.8)")},Object.defineProperty(e.Weapon.prototype,"bulletClass",{get:function(){return this._bulletClass},set:function(t){this._bulletClass=t,this.bullets&&(this.bullets.classType=this._bulletClass)}}),Object.defineProperty(e.Weapon.prototype,"bulletKillType",{get:function(){return this._bulletKillType},set:function(t){switch(t){case e.Weapon.KILL_STATIC_BOUNDS:case e.Weapon.KILL_WEAPON_BOUNDS:this.bulletBounds=this.bounds;break;case e.Weapon.KILL_CAMERA_BOUNDS:this.bulletBounds=this.game.camera.view;break;case e.Weapon.KILL_WORLD_BOUNDS:this.bulletBounds=this.game.world.bounds}this._bulletKillType=t}}),Object.defineProperty(e.Weapon.prototype,"bulletCollideWorldBounds",{get:function(){return this._bulletCollideWorldBounds},set:function(t){this._bulletCollideWorldBounds=t,this.bullets.setAll("body.collideWorldBounds",t),this.bullets.setAll("data.bodyDirty",!1)}}),Object.defineProperty(e.Weapon.prototype,"x",{get:function(){return this.fireFrom.x},set:function(t){this.fireFrom.x=t}}),Object.defineProperty(e.Weapon.prototype,"y",{get:function(){return this.fireFrom.y},set:function(t){this.fireFrom.y=t}}),e.Bullet=function(t,i,s,n,r){e.Sprite.call(this,t,i,s,n,r),this.anchor.set(.5),this.data={bulletManager:null,fromX:0,fromY:0,bodyDirty:!0,rotateToVelocity:!1,killType:0,killDistance:0}},e.Bullet.prototype=Object.create(e.Sprite.prototype),e.Bullet.prototype.constructor=e.Bullet,e.Bullet.prototype.kill=function(){return this.alive=!1,this.exists=!1,this.visible=!1,this.data.bulletManager.onKill.dispatch(this),this},e.Bullet.prototype.update=function(){this.exists&&(this.data.killType>e.Weapon.KILL_LIFESPAN&&(this.data.killType===e.Weapon.KILL_DISTANCE?this.game.physics.arcade.distanceToXY(this,this.data.fromX,this.data.fromY,!0)>this.data.killDistance&&this.kill():this.data.bulletManager.bulletBounds.intersects(this)||this.kill()),this.data.rotateToVelocity&&(this.rotation=this.body.velocity.atan()),this.data.bulletManager.bulletWorldWrap&&this.game.world.wrap(this,this.data.bulletManager.bulletWorldWrapPadding))},e.Video=function(t,i,s){if(void 0===i&&(i=null),void 0===s&&(s=null),this.game=t,this.key=i,this.width=0,this.height=0,this.type=e.VIDEO,this.disableTextureUpload=!1,this.touchLocked=!1,this.onPlay=new e.Signal,this.onChangeSource=new e.Signal,this.onComplete=new e.Signal,this.onAccess=new e.Signal,this.onError=new e.Signal,this.onTimeout=new e.Signal,this.onTouchUnlock=new e.Signal,this.playWhenUnlocked=!0,this.timeout=15e3,this._timeOutID=null,this.video=null,this.videoStream=null,this.isStreaming=!1,this.retryLimit=20,this.retry=0,this.retryInterval=500,this._retryID=null,this._codeMuted=!1,this._muted=!1,this._codePaused=!1,this._paused=!1,this._pending=!1,this._pendingChangeSource=!1,this._autoplay=!1,this._endCallback=null,this._playCallback=null,i&&this.game.cache.checkVideoKey(i)){var n=this.game.cache.getVideo(i);n.isBlob?this.createVideoFromBlob(n.data):this.video=n.data,this.width=this.video.videoWidth,this.height=this.video.videoHeight}else s&&this.createVideoFromURL(s,!1);this.video&&!s?(this.baseTexture=new PIXI.BaseTexture(this.video,null,this.game.resolution),this.baseTexture.forceLoaded(this.width,this.height)):(this.baseTexture=new PIXI.BaseTexture(e.Cache.DEFAULT.baseTexture.source,null,this.game.resolution),this.baseTexture.forceLoaded(this.width,this.height)),this.texture=new PIXI.Texture(this.baseTexture),this.textureFrame=new e.Frame(0,0,0,this.width,this.height,"video"),this.texture.setFrame(this.textureFrame),this.texture.valid=!1,null!==i&&this.video&&(this.texture.valid=this.video.canplay),this.snapshot=null,e.BitmapData&&(this.snapshot=new e.BitmapData(this.game,"",this.width,this.height)),this.game.device.needsTouchUnlock()?this.setTouchLock():n&&(n.locked=!1)},e.Video.prototype={connectToMediaStream:function(t,e){return t&&e&&(this.video=t,this.videoStream=e,this.isStreaming=!0,this.baseTexture.source=this.video,this.updateTexture(null,this.video.videoWidth,this.video.videoHeight),this.onAccess.dispatch(this)),this},startMediaStream:function(t,e,i){if(void 0===t&&(t=!1),void 0===e&&(e=null),void 0===i&&(i=null),!this.game.device.getUserMedia)return this.onError.dispatch(this,"No getUserMedia"),!1;null!==this.videoStream&&(this.videoStream.active?this.videoStream.active=!1:this.videoStream.stop()),this.removeVideoElement(),this.video=document.createElement("video"),this.video.setAttribute("autoplay","autoplay"),null!==e&&(this.video.width=e),null!==i&&(this.video.height=i),this._timeOutID=window.setTimeout(this.getUserMediaTimeout.bind(this),this.timeout);try{navigator.getUserMedia({audio:t,video:!0},this.getUserMediaSuccess.bind(this),this.getUserMediaError.bind(this))}catch(t){this.getUserMediaError(t)}return this},getUserMediaTimeout:function(){clearTimeout(this._timeOutID),this.onTimeout.dispatch(this)},getUserMediaError:function(t){clearTimeout(this._timeOutID),this.onError.dispatch(this,t)},getUserMediaSuccess:function(t){clearTimeout(this._timeOutID),this.videoStream=t,void 0!==this.video.mozSrcObject?this.video.mozSrcObject=t:void 0!==this.video.srcObject?this.video.srcObject=t:this.video.src=window.URL&&window.URL.createObjectURL(t)||t;var e=this;this.video.onloadeddata=function(){function t(){if(i>0)if(e.video.videoWidth>0){var s=e.video.videoWidth,n=e.video.videoHeight;isNaN(e.video.videoHeight)&&(n=s/(4/3)),e.video.play(),e.isStreaming=!0,e.baseTexture.source=e.video,e.updateTexture(null,s,n),e.onAccess.dispatch(e)}else window.setTimeout(t,500);else console.warn("Unable to connect to video stream. Webcam error?");i--}var i=10;t()}},createVideoFromBlob:function(t){var e=this;return this.video=document.createElement("video"),this.video.controls=!1,this.video.setAttribute("autoplay","autoplay"),this.video.addEventListener("loadeddata",function(t){e.updateTexture(t)},!0),this.video.src=window.URL.createObjectURL(t),this.video.canplay=!0,this},createVideoFromURL:function(t,e){return void 0===e&&(e=!1),this.texture&&(this.texture.valid=!1),this.video=document.createElement("video"),this.video.controls=!1,e&&this.video.setAttribute("autoplay","autoplay"),this.video.src=t,this.video.canplay=!0,this.video.load(),this.retry=this.retryLimit,this._retryID=window.setTimeout(this.checkVideoProgress.bind(this),this.retryInterval),this.key=t,this},updateTexture:function(t,e,i){var s=!1;void 0!==e&&null!==e||(e=this.video.videoWidth,s=!0),void 0!==i&&null!==i||(i=this.video.videoHeight),this.width=e,this.height=i,this.baseTexture.source!==this.video&&(this.baseTexture.source=this.video),this.baseTexture.forceLoaded(e,i),this.texture.frame.resize(e,i),this.texture.width=e,this.texture.height=i,this.texture.valid=!0,this.snapshot&&this.snapshot.resize(e,i),s&&null!==this.key&&(this.onChangeSource.dispatch(this,e,i),this._autoplay&&(this.video.play(),this.onPlay.dispatch(this,this.loop,this.playbackRate)))},complete:function(){this.onComplete.dispatch(this)},play:function(t,e){return this._pendingChangeSource?this:(void 0===t&&(t=!1),void 0===e&&(e=1),this.game.sound.onMute&&(this.game.sound.onMute.add(this.setMute,this),this.game.sound.onUnMute.add(this.unsetMute,this),this.game.sound.mute&&this.setMute()),this.game.onPause.add(this.setPause,this),this.game.onResume.add(this.setResume,this),this._endCallback=this.complete.bind(this),this.video.addEventListener("ended",this._endCallback,!0),this.video.addEventListener("webkitendfullscreen",this._endCallback,!0),this.video.loop=t?"loop":"",this.video.playbackRate=e,this.touchLocked?this._pending=!0:(this._pending=!1,null!==this.key&&(4!==this.video.readyState?(this.retry=this.retryLimit,this._retryID=window.setTimeout(this.checkVideoProgress.bind(this),this.retryInterval)):(this._playCallback=this.playHandler.bind(this),this.video.addEventListener("playing",this._playCallback,!0))),this.video.play(),this.onPlay.dispatch(this,t,e)),this)},playHandler:function(){this.video.removeEventListener("playing",this._playCallback,!0),this.updateTexture()},stop:function(){return this.game.sound.onMute&&(this.game.sound.onMute.remove(this.setMute,this),this.game.sound.onUnMute.remove(this.unsetMute,this)),this.game.onPause.remove(this.setPause,this),this.game.onResume.remove(this.setResume,this),this.isStreaming?(this.video.mozSrcObject?(this.video.mozSrcObject.stop(),this.video.src=null):this.video.srcObject?(this.video.srcObject.stop(),this.video.src=null):(this.video.src="",this.videoStream.active?this.videoStream.active=!1:this.videoStream.getTracks?this.videoStream.getTracks().forEach(function(t){t.stop()}):this.videoStream.stop()),this.videoStream=null,this.isStreaming=!1):(this.video.removeEventListener("ended",this._endCallback,!0),this.video.removeEventListener("webkitendfullscreen",this._endCallback,!0),this.video.removeEventListener("playing",this._playCallback,!0),this.touchLocked?this._pending=!1:this.video.pause()),this},add:function(t){if(Array.isArray(t))for(var e=0;e<t.length;e++)t[e].loadTexture&&t[e].loadTexture(this);else t.loadTexture(this);return this},addToWorld:function(t,e,i,s,n,r){n=n||1,r=r||1;var o=this.game.add.image(t,e,this);return o.anchor.set(i,s),o.scale.set(n,r),o},render:function(){!this.disableTextureUpload&&this.playing&&this.baseTexture.dirty()},setMute:function(){this._muted||(this._muted=!0,this.video.muted=!0)},unsetMute:function(){this._muted&&!this._codeMuted&&(this._muted=!1,this.video.muted=!1)},setPause:function(){this._paused||this.touchLocked||(this._paused=!0,this.video.pause())},setResume:function(){!this._paused||this._codePaused||this.touchLocked||(this._paused=!1,this.video.ended||this.video.play())},changeSource:function(t,e){return void 0===e&&(e=!0),this.texture.valid=!1,this.video.pause(),this._pendingChangeSource=!0,this.retry=this.retryLimit,this._retryID=window.setTimeout(this.checkVideoProgress.bind(this),this.retryInterval),this.video.src=t,this.video.load(),this._autoplay=e,e||(this.paused=!0),this},checkVideoProgress:function(){4===this.video.readyState?(this._pendingChangeSource=!1,this.updateTexture()):--this.retry>0?this._retryID=window.setTimeout(this.checkVideoProgress.bind(this),this.retryInterval):console.warn("Phaser.Video: Unable to start downloading video in time",this.isStreaming)},setTouchLock:function(){this.game.input.addTouchLockCallback(this.unlock,this,!0),this.touchLocked=!0},unlock:function(){if(this.touchLocked=!1,this.playWhenUnlocked&&(this.video.play(),this.onPlay.dispatch(this,this.loop,this.playbackRate)),this.key){var t=this.game.cache.getVideo(this.key);t&&!t.isBlob&&(t.locked=!1)}return this.onTouchUnlock.dispatch(this),!0},grab:function(t,e,i){if(void 0===t&&(t=!1),void 0===e&&(e=1),void 0===i&&(i=null),null!==this.snapshot)return t&&this.snapshot.cls(),this.snapshot.copy(this.video,0,0,this.width,this.height,0,0,this.width,this.height,0,0,0,1,1,e,i),this.snapshot;console.warn("Video.grab cannot run because Phaser.BitmapData is unavailable")},removeVideoElement:function(){if(this.video){for(this.video.parentNode&&this.video.parentNode.removeChild(this.video);this.video.hasChildNodes();)this.video.removeChild(this.video.firstChild);this.video.removeAttribute("autoplay"),this.video.removeAttribute("src"),this.video=null}},destroy:function(){this.stop(),this.removeVideoElement(),this.touchLocked&&this.game.input.removeTouchLockCallback(this.unlock,this),this._retryID&&window.clearTimeout(this._retryID)}},Object.defineProperty(e.Video.prototype,"currentTime",{get:function(){return this.video?this.video.currentTime:0},set:function(t){this.video.currentTime=t}}),Object.defineProperty(e.Video.prototype,"duration",{get:function(){return this.video?this.video.duration:0}}),Object.defineProperty(e.Video.prototype,"progress",{get:function(){return this.video?this.video.currentTime/this.video.duration:0}}),Object.defineProperty(e.Video.prototype,"mute",{get:function(){return this._muted},set:function(t){if(t=t||null){if(this._muted)return;this._codeMuted=!0,this.setMute()}else{if(!this._muted)return;this._codeMuted=!1,this.unsetMute()}}}),Object.defineProperty(e.Video.prototype,"paused",{get:function(){return this._paused},set:function(t){if(t=t||null,!this.touchLocked)if(t){if(this._paused)return;this._codePaused=!0,this.setPause()}else{if(!this._paused)return;this._codePaused=!1,this.setResume()}}}),Object.defineProperty(e.Video.prototype,"volume",{get:function(){return this.video?this.video.volume:1},set:function(t){t<0?t=0:t>1&&(t=1),this.video&&(this.video.volume=t)}}),Object.defineProperty(e.Video.prototype,"playbackRate",{get:function(){return this.video?this.video.playbackRate:1},set:function(t){this.video&&(this.video.playbackRate=t)}}),Object.defineProperty(e.Video.prototype,"loop",{get:function(){return!!this.video&&this.video.loop},set:function(t){t&&this.video?this.video.loop="loop":this.video&&(this.video.loop="")}}),Object.defineProperty(e.Video.prototype,"playing",{get:function(){return!!this.video&&!(this.video.paused&&this.video.ended)}}),e.Video.prototype.constructor=e.Video,void 0===PIXI.blendModes&&(PIXI.blendModes=e.blendModes),void 0===PIXI.scaleModes&&(PIXI.scaleModes=e.scaleModes),void 0===PIXI.Texture.emptyTexture&&(PIXI.Texture.emptyTexture=new PIXI.Texture(new PIXI.BaseTexture)),void 0===PIXI.DisplayObject._tempMatrix&&(PIXI.DisplayObject._tempMatrix=new e.Matrix),PIXI.TextureSilentFail=!0,PIXI.canUseNewCanvasBlendModes=function(){return e.Device.canUseMultiply},"undefined"!=typeof exports?("undefined"!=typeof module&&module.exports&&(exports=module.exports=e),exports.Phaser=e):"undefined"!=typeof define&&define.amd?define("Phaser",t.Phaser=e):t.Phaser=e,e}.call(this);
//# sourceMappingURL=phaser.map
var game = null;

var quiz = (json) => {
    var gameData = {
        score: 0,
        winSound: null,
        correctQ: 0,
        wrongQ: 0,
        totalQ: 0,
        progress: 0,

        reset: function () {
            this.correctQ = 0;
            this.wrongQ = 0;
            this.totalQ = 0;
            this.progress = 0;
            this.score = 0;
            this.winSound = null;
        }
    };

    class Option extends Phaser.GameObjects.Sprite {
        constructor(config) {
            super(config.scene, config.x, config.y, config.key);

            this.origX = config.x;
            this.origY = config.y;
            this.id = config.id;
            this.string = config.string;
            this.imageKey = config.imageKey;
            this.setOrigin(0.5, 0.5);
            this.setInteractive();
            this.correct = false;
            config.scene.add.existing(this);

            var textStyle = {
                fontSize: "65px", fontFamily: "QuranEraV3", align: "center",
                fill: "#000"
            };

            this.stringText = this.scene.add.text(config.x + 12, config.y, "", textStyle);
            this.stringText.setOrigin(0.5, 0.5);
            //this.stringText.setDisplaySize(100, 100);
            this.stringText.setVisible(false);
            this.stringText.setPadding(0, 40, 0, 0)
            this.stringText.setFixedSize(345, 154);
            this.img = this.scene.add.sprite(config.x + 12, config.y, "");
            this.img.setOrigin(0.5, 0.5);
            this.img.setVisible(false);

            this.on('pointerdown', function () {
            });
        }

        update() {
        }

        setString(text, correct) {
            this.stringText.setText(text);
            this.stringText.setVisible(true);
            this.img.setVisible(false);
            this.correct = correct;
        }

        setImg(img, correct) {
            this.img.setTexture(img);
            this.img.setVisible(true);
            this.stringText.setVisible(false);
            this.correct = correct;
        }
    }

    class DropZone extends Phaser.GameObjects.Sprite {
        constructor(config) {
            super(config.scene, config.x, config.y, config.key);

            this.id = config.id;
            this.setOrigin(0.5, 0.5);

            config.scene.add.existing(this);

            this.dropRect = config.scene.add.image(this.x, this.y + 110, 'dropRect');
            this.dropRect.setOrigin(0.5, 0.5);
        }

        setPos(x, y) {
            this.x = x;
            this.y = y;
            this.dropRect.x = x;
            this.dropRect.y = y + 110;
        }
    }

    class Boot extends Phaser.Scene {
        constructor() {
            super({ key: "Boot" });
        }

        preload() {
            var instance = this;
            var progress = this.add.graphics();
            this.load.on('progress', function (value) {
            });

            this.load.on('complete', function () {
                progress.destroy();
                this.scene.scene.start('Welcome');
            });

            //this.load.start();

            //load all assets here

            /*WELCOME SCENE ASSETS*/
            //this.load.image("frame", "assets/games/quiz/assets/Frame.png");
            this.load.image("greyRect", "assets/games/quiz/assets/welcome/greyRect.png");
            this.load.image("instRect", "assets/games/quiz/assets/welcome/instRect.png");
            this.load.image("title", "assets/games/quiz/assets/welcome/welcomeText.png");
            this.load.image("playBtn", "assets/games/quiz/assets/welcome/playBtn.png");
            this.load.image("playBtnselected", "assets/games/quiz/assets/welcome/playBtnselected.png");
            this.load.image("soundBtn", "assets/games/quiz/assets/welcome/soundBtn.png");
            this.load.image("soundBtnHover", "assets/games/quiz/assets/welcome/soundBtnHover.png");
            this.load.image("snail", "assets/games/quiz/assets/welcome/snail.png");

            /*GAME SCENE ASSETS*/
            this.load.image("gamebg", "assets/games/quiz/assets/game/boardbg.png");
            this.load.image("playBoard", "assets/games/quiz/assets/game/playBoard.png");
            this.load.image("titleRect", "assets/games/quiz/assets/game/titleRect.png");
            this.load.image("optionBg", "assets/games/quiz/assets/game/optionBg.png");
            this.load.image("optionBgHover", "assets/games/quiz/assets/game/optionBgHover.png");
            this.load.image("optionBgCorrect", "assets/games/quiz/assets/game/optionCorrect.png");
            this.load.image("optionBgWrong", "assets/games/quiz/assets/game/optionWrong.png");
            this.load.image("gamesoundBtn", "assets/games/quiz/assets/game/sound.png");
            this.load.image("gamesoundBtnHover", "assets/games/quiz/assets/game/soundhover.png");
            this.load.image("qBg", "assets/games/quiz/assets/game/qBg.png");
            this.load.image("closeBtn", "assets/games/quiz/assets/game/closeBtn.png");
            this.load.image("closeBtnHover", "assets/games/quiz/assets/game/closeBtnHover.png");
            this.load.image("woodbar", "assets/games/quiz/assets/game/Wood.png");
            this.load.image("woodbrown", "assets/games/quiz/assets/game/woodbrown.png");
            this.load.image("bluebar", "assets/games/quiz/assets/game/bluebar.png");

            /*TRY AGAIN SCENE ASSETS*/
            this.load.image("looseBg", "assets/games/quiz/assets/loose/looseBg.png");
            //this.load.image("playagainBtn", "assets/games/quiz/assets/loose/playagainBtn.png");
            //this.load.image("playagainBtnHover", "assets/games/quiz/assets/loose/playagainBtnHover.png");
            this.load.image("backtoMenu", "assets/games/quiz/assets/loose/backtomenu.png");
            this.load.image("backtoMenuHover", "assets/games/quiz/assets/loose/backtomenuHover.png");
            this.load.image("badge", "assets/games/quiz/assets/loose/badge.png");
            this.load.image("bigStar", "assets/games/quiz/assets/loose/bigstar.png");
            this.load.image("ribbon", "assets/games/quiz/assets/loose/ribbon.png");
            this.load.image("totalScoreText", "assets/games/quiz/assets/loose/totalScoreText.png");
            this.load.image("tryagainBoard", "assets/games/quiz/assets/loose/tryagainBoard.png");
            this.load.image("tryagain", "assets/games/quiz/assets/loose/tryagain.png");

            /*WIN SCREEN ASSETS */
            this.load.image("certificate", "assets/images/awards/cert-200.jpg");
            this.load.image("congratsTitle", "assets/games/quiz/assets/win/congratsTitle.png");
            this.load.image("playagainBtn", "assets/games/quiz/assets/win/playagain.png");
            this.load.image("playagainBtnHover", "assets/games/quiz/assets/win/playagainHover.png");
            this.load.image("nextBtn", "assets/games/quiz/assets/win/nextBtn.png");
            this.load.image("nextBtnHover", "assets/games/quiz/assets/win/nextBtnHover.png");

            /* WARNING SCREEN ASSETS*/
            this.load.image("noBtn", "assets/games/quiz/assets/warning/noBtn.png");
            this.load.image("noBtnHover", "assets/games/quiz/assets/warning/noBtnHover.png");
            this.load.image("yesBtn", "assets/games/quiz/assets/warning/yesBtn.png");
            this.load.image("yesBtnHover", "assets/games/quiz/assets/warning/yesBtnHover.png");
            this.load.image("sign", "assets/games/quiz/assets/warning/sign.png");
            this.load.image("warningBg", "assets/games/quiz/assets/warning/warningbg.png");
            this.load.image("warningBoard", "assets/games/quiz/assets/warning/warningboard.png");
            this.load.image("leaf", "assets/games/quiz/assets/warning/leaf.png");

            /*LOAD SOUNDS*/
            this.load.audio('quiz1Intro', [json.introduction.audio]);
            this.load.audio('wrongDrop', 'assets/games/quiz/assets/audio/wrongdrop.mp3');
            this.load.audio('correctDrop', 'assets/games/quiz/assets/audio/correctdrop.mp3');
            this.load.audio('fail', ['assets/games/quiz/assets/audio/fail.mp3', 'assets/games/quiz/assets/audio/fail.mp3']);

            this.load.audio('buttonclick', 'assets/games/quiz/assets/audio/buttonclick.mp3');
            this.load.audio('buttonhover', 'assets/games/quiz/assets/audio/buttonhover.mp3');
            this.load.audio('win', [json.completeAudio]);
            this.load.audio('correctAnswer', ['assets/games/quiz/assets/audio/Correctanswer.mp3', 'assets/games/quiz/assets/audio/Correctanswer.mp3']);
            this.load.audio('wrongAnswer', ['assets/games/quiz/assets/audio/Wronganswer.mp3', 'assets/games/quiz/assets/audio/Wronganswer.mp3']);
            this.load.audio('warning', ['assets/games/quiz/assets/audio/warning.mp3', 'assets/games/quiz/assets/audio/warning.mp3']);
            this.load.json('data', json);
        }

        create() {
        }

        update() {
        }

        init() {
        }
    }

    var welcomeInstance = null;

    var instructionSound = null;

    class Welcome extends Phaser.Scene {
        constructor() {
            super({ key: "Welcome" });

            welcomeInstance = this;
        }

        preload() {
            let catalog = this.cache.json.get('data');

            catalog.data.map((question, i) => {
                if (question.audio.includes('http')) {
                    this.load.audio("Q" + i + "Audio", [question.audio])
                } else {
                    this.load.audio("Q" + i + "Audio", ["assets/games/quiz/assets/audios/" + question.audio + ".mp3"]);
                }

                question.answers.map((answer, j) => {
                    if (answer.text.includes('http')) {
                        this.load.image("Q" + (i + 1) + "_op" + (j + 1), answer.text);
                    } else {
                        if (answer.image) {
                            this.load.image("Q" + (i + 1) + "_op" + (j + 1), "assets/games/quiz/assets/imgs/" + answer.text + ".png");
                        }
                    }
                })
            });
        }

        create() {
            this.buttonClick = this.sound.add('buttonclick');
            this.buttonHover = this.sound.add('buttonhover');

            instructionSound = this.sound.add("quiz1Intro");// document.getElementById("instAudio");
            instructionSound.play();

            //var board = this.add.sprite(this.game.config.width/2, this.game.config.height/2, 'board');
            //board.setOrigin(0.5, 0.5);

            var greyRect = this.add.sprite(this.game.config.width / 2 + 6.5, this.game.config.height / 2 - 25.5, 'greyRect');
            greyRect.setOrigin(0.5, 0.475);

            var board = this.add.sprite(this.game.config.width / 2, this.game.config.height / 2, 'frame');
            board.setOrigin(0.5, 0.5);

            var instRect = this.add.sprite(this.game.config.width / 2, this.game.config.height / 2 - 30, 'instRect');
            instRect.setOrigin(0.5, 0.53);

            var snail = this.add.sprite(this.game.config.width / 2 - 220, this.game.config.height / 2, 'snail');
            snail.setOrigin(0.5, 0.5);
            var title = this.add.text(this.game.config.width / 2, this.game.config.height / 2 - 200, `${json.continent} - ${json.title}`, { fontFamily: 'Kids Rock DEMO', fontSize: 32, color: '#3280db', align: 'center', strokeThickness: 3 });
            title.setOrigin(0.5, 0.9);

            // var title = this.add.sprite(this.game.config.width / 2, this.game.config.height / 2 - 205, 'title');
            // title.setOrigin(0.5, 0.9);
            //title.setScale(0.8);

            var playBtn = this.add.sprite(this.game.config.width / 2, this.game.config.height / 2 + 160, 'playBtn').setInteractive();
            playBtn.setOrigin(0.5, 0.5);

            var tween = this.tweens.add({
                targets: playBtn,
                scale: 0.8,
                duration: 100,
                ease: 'Power2',
                yoyo: true,
                paused: true
            });

            var tween1 = this.tweens.add({
                targets: playBtn,
                scale: 1.1,
                duration: 100,
                ease: 'Power2',
                paused: true,
            });

            playBtn.on('pointerdown', function () {
                this.scene.scene.start("Game");
                this.scene.buttonClick.play();
            });

            playBtn.on('pointerover', function () {
                playBtn.setTexture("playBtnselected");
                this.scene.buttonHover.play();
            });

            playBtn.on('pointerout', function () {
                playBtn.setTexture("playBtn");
            });

            var quizId = window.location.pathname.split('/').pop();
            var textWelcome = [
                (
                    quizId === '1-4' || quizId === '2-3' || quizId === '3-3'
                        ? "This quiz has 15 questions.\n\nYou need to pass this quiz to \n\nget through to the next continent.\n\nGood Luck!"
                        : "This quiz has 15 questions.\n\nYou need to pass this quiz to \n\nget through to the next zone.\n\nGood Luck!"
                )
            ];

            var paragraph = this.add.text(this.game.config.width / 2 + 130, this.game.config.height / 2, textWelcome,
                {
                    fontFamily: "Kids Rock DEMO",
                    fontSize: 23,
                    color: '#312f2f',
                    align: 'left',
                    strokeThickness: 1
                });

            paragraph.setOrigin(0.5, 0.5);

            var soundBtn = this.add.sprite(this.game.config.width / 2 + 310, this.game.config.height / 2 - 210, 'gamesoundBtn').setInteractive();
            soundBtn.setOrigin(0.5, 0.65);
            soundBtn.setScale(0.8)

            soundBtn.on("pointerover", function () {
                soundBtn.setTexture('gamesoundBtnHover');
                this.scene.buttonHover.play();
            })

            soundBtn.on("pointerout", function () {
                soundBtn.setTexture('gamesoundBtn');
            })

            soundBtn.on('pointerdown', function () {
                this.scene.buttonClick.play();

                instructionSound.play();
            })
        }

        update(time, delta) {
        }
    }

    var gameInstance = null;

    const clampNumber = (num, a, b) => Math.max(Math.min(num, Math.max(a, b)), Math.min(a, b));

    class Game extends Phaser.Scene {
        constructor() {
            super({ key: "Game" });
            gameInstance = this;
        }

        preload() {
        }

        create() {
            gameData.reset();

            this.questionCompleted = false;

            this.questionIndex = 1;

            this.currentQuestion = null;

            this.progressX = 0;

            this.questions = [];

            if (instructionSound != null) {
                instructionSound.stop();
            }

            this.correctAnsSound = this.sound.add("correctAnswer");
            this.wrongAnsSound = this.sound.add("wrongAnswer");

            this.incorrect = 0;
            this.correct = 0;

            var btnclickSound = this.sound.add('buttonclick');
            var btnhoverSound = this.sound.add('buttonhover');

            this.wrongSound = this.sound.add('wrongDrop');
            this.correctSound = this.sound.add('correctDrop');

            var gameBg = this.add.sprite(this.game.config.width / 2 + 6.5, this.game.config.height / 2 - 25, 'gamebg');
            gameBg.setOrigin(0.5, 0.475);

            var playBoard = this.add.sprite(this.game.config.width / 2, this.game.config.height / 2 - 20, 'playBoard');
            playBoard.setOrigin(0.5, 0.5);

            //var board = this.add.sprite(this.game.config.width/2, this.game.config.height/2, 'board');
            //board.setOrigin(0.5, 0.5);

            var titleRect = this.add.sprite(this.game.config.width / 2, -25, 'titleRect');
            titleRect.setOrigin(0.5, 0);

            var title = this.add.text(this.game.config.width / 2, 35, json.title, {
                fontFamily: 'Kids Rock DEMO',
                fontSize: 28,
                color: '#ffffff',
                stroke: '#ffffff',
                align: 'center',
                strokeThickness: 1
            });
            title.setOrigin(0.5, 0.2);

            var qBg = this.add.sprite(this.game.config.width / 2, this.game.config.height / 2 - 140, 'qBg');
            qBg.setOrigin(0.5, 0.5);

            this.question = this.add.text(this.game.config.width / 2 - 280, this.game.config.height / 2 - 135, "Question 1.", {
                fontFamily: "Kids Rock DEMO",
                fontSize: 22,
                color: '#000',
                stroke: '#000',
                align: 'left'
            });
            this.question.fixedHeight = 50;
            this.question.setOrigin(0.5, 0.5);

            this.option1 = new Option({
                scene: this,
                x: game.config.width / 2 - 180,
                y: game.config.height / 2 - 20,
                string: "A",
                imageKey: "",
                id: 1,
                key: "optionBg"
            });

            this.option2 = new Option({
                scene: this,
                x: game.config.width / 2 + 160,
                y: game.config.height / 2 - 20,
                string: "A",
                imageKey: "",
                id: 1,
                key: "optionBg"
            });

            this.option3 = new Option({
                scene: this,
                x: game.config.width / 2 - 180,
                y: game.config.height / 2 + 120,
                string: "A",
                imageKey: "",
                id: 1,
                key: "optionBg"
            });

            this.option4 = new Option({
                scene: this,
                x: game.config.width / 2 + 160,
                y: game.config.height / 2 + 120,
                string: "A",
                imageKey: "",
                id: 1,
                key: "optionBg"
            });

            this.option1.on("pointerdown", this.onOptionSelect);
            this.option2.on("pointerdown", this.onOptionSelect);
            this.option3.on("pointerdown", this.onOptionSelect);
            this.option4.on("pointerdown", this.onOptionSelect);

            this.option1.on("pointerover", function () {
                if (!this.scene.questionCompleted) {
                    this.setTexture('optionBgHover');
                }
            });

            this.option2.on("pointerover", function () {
                if (!this.scene.questionCompleted) {
                    this.setTexture('optionBgHover');
                }
            });
            this.option3.on("pointerover", function () {
                if (!this.scene.questionCompleted) {
                    this.setTexture('optionBgHover');
                }
            });
            this.option4.on("pointerover", function () {
                if (!this.scene.questionCompleted) {
                    this.setTexture('optionBgHover');
                }
            });

            this.option1.on("pointerout", function () {
                if (!this.scene.questionCompleted) {
                    this.setTexture('optionBg');
                }
            });

            this.option2.on("pointerout", function () {
                if (!this.scene.questionCompleted) {
                    this.setTexture('optionBg');
                }
            });
            this.option3.on("pointerout", function () {
                if (!this.scene.questionCompleted) {
                    this.setTexture('optionBg');
                }
            });
            this.option4.on("pointerout", function () {
                if (!this.scene.questionCompleted) {
                    this.setTexture('optionBg');
                }
            });

            var closeBtn = this.add.sprite(this.game.config.width - 60, 40, 'closeBtn').setInteractive();
            closeBtn.setOrigin(0.5, 0.5);

            closeBtn.on("pointerdown", function () {
                btnclickSound.play();
                this.scene.questions[this.scene.questionIndex - 1].sound.stop();
                this.scene.scene.launch('Warning');

                this.scene.scene.pause('Game');
            })

            closeBtn.on("pointerover", function () {
                btnhoverSound.play();
                closeBtn.setTexture('closeBtnHover');
            })

            closeBtn.on("pointerout", function () {
                closeBtn.setTexture('closeBtn');
            })

            var soundBtn = this.add.sprite(this.game.config.width / 2 + 360, this.game.config.height / 2 - 120, 'gamesoundBtn').setInteractive();
            soundBtn.setOrigin(0.5, 0.5);

            soundBtn.on("pointerdown", function () {
                btnclickSound.play();
                this.scene.questions[this.scene.questionIndex - 1].sound.play();
                //document.getElementById("Q"+this.scene.questionIndex+"Audio").play();
            })

            soundBtn.on("pointerover", function () {
                btnhoverSound.play();
                soundBtn.setTexture('gamesoundBtnHover');
            })

            soundBtn.on("pointerout", function () {
                soundBtn.setTexture('gamesoundBtn');
            })

            var woodbase = this.add.sprite(this.game.config.width / 2, this.game.config.height / 2 + 260, 'woodbar');
            woodbase.setOrigin(0.5, 0.5);

            var woodbrown = this.add.sprite(this.game.config.width / 2, this.game.config.height / 2 + 260, 'woodbrown');
            woodbrown.setOrigin(0.5, 0.5);

            this.bluebar = this.add.sprite(this.game.config.width / 2 - 749, this.game.config.height / 2 + 260, 'bluebar');
            this.bluebar.setOrigin(0.5, 0.5);

            var shape = this.make.graphics();

            //  Create a hash shape Graphics object
            shape.fillStyle(0x000000);

            //  You have to begin a path for a Geometry mask to work
            shape.beginPath();

            shape.fillRect(120, this.game.config.height / 2 + 245, 741, 31);

            var mask = shape.createGeometryMask();

            this.bluebar.setMask(mask);

            this.createQuestions();
            this.SetQuestionOnBoard(this.questionIndex);
        }

        update(time, delta) {
        }

        shuffle(arra1) {
            var ctr = arra1.length, temp, index;

            // While there are elements in the array
            while (ctr > 0) {
                // Pick a random index
                index = Math.floor(Math.random() * ctr);
                // Decrease ctr by 1
                ctr--;
                // And swap the last element with it
                temp = arra1[ctr];
                arra1[ctr] = arra1[index];
                arra1[index] = temp;
            }
            return arra1;
        }

        createQuestions() {
            var option = {
                id: 0,
                string: "",
                img: "",
                correct: false
            }

            var question = {
                id: 0,
                string: "",
                options: [],
            }

            var catalog = this.cache.json.get('data');

            catalog.data.map((question, i) => {
                var q = { id: 0, string: "", options: [], sound: null };

                q.id = i;
                q.string = question.question;
                q.sound = this.sound.add(`Q${i}Audio`);

                question.answers.map((answer, j) => {
                    let op = { id: 0, string: "", img: "", correct: false };
                    op.id = j;
                    op.img = (answer.text.includes('http') || answer.image) ? `Q${i + 1}_op${j + 1}` : '';
                    op.string = !answer.text.includes('http') ? answer.text : ''
                    op.correct = answer.correct

                    q.options.push(op);
                })
                this.questions.push(q);
            });

            gameData.totalQ = this.questions.length;

            gameData.progress = 738 / gameData.totalQ;
        }

        SetQuestionOnBoard(index) {
            if (this.prevQuestionSound) {
                this.prevQuestionSound.stop();
            }

            if (index > this.questions.length) {
                if (gameData.wrongQ > 4)
                    this.scene.start("Loose");
                else {
                    this.scene.start("Win");
                }

                return;
            }

            this.option1.setTexture("optionBg");
            this.option2.setTexture("optionBg");
            this.option3.setTexture("optionBg");
            this.option4.setTexture("optionBg");

            this.questionCompleted = false;
            var question = this.questions[index - 1];

            question.options = this.shuffle(question.options);

            if (question.options[0].img != "") {
                this.option1.setImg(question.options[0].img, question.options[0].correct);
            } else {
                this.option1.setString(question.options[0].string, question.options[0].correct);
            }

            if (question.options[1].img != "") {
                this.option2.setImg(question.options[1].img, question.options[1].correct);
            } else {
                this.option2.setString(question.options[1].string, question.options[1].correct);
            }

            if (question.options[2].img != "") {
                this.option3.setImg(question.options[2].img, question.options[2].correct);
            } else {
                this.option3.setString(question.options[2].string, question.options[2].correct);
            }

            if (question.options[3].img != "") {
                this.option4.setImg(question.options[3].img, question.options[3].correct);
            } else {
                this.option4.setString(question.options[3].string, question.options[3].correct);
            }

            for (var i = 0; i < question.options.length; i++) {
                if (question.options[i].correct) {
                    switch (i) {
                        case 0:
                            this.option1.correct = true;
                            break;
                        case 1:
                            this.option2.correct = true;
                            break;
                        case 2:
                            this.option3.correct = true;
                            break;
                        case 3:
                            this.option4.correct = true;
                            break;
                    }
                }
            }

            this.question.setText("Question " + (question.id + 1) + ".");
            question.sound.play();

            this.prevQuestionSound = question.sound;
        }

        onOptionSelect() {
            if (!this.scene.questionCompleted) {
                this.scene.questionCompleted = true;

                if (this.correct) {
                    this.setTexture('optionBgCorrect');
                    this.scene.correctAnsSound.play();
                    gameData.correctQ += 1;
                    window['angularComponentRef'].changeCorrectAnswer(gameData.correctQ);
                } else {
                    this.setTexture('optionBgWrong');
                    this.scene.wrongAnsSound.play();
                    gameData.wrongQ += 1;
                }

                this.scene.time.addEvent({
                    delay: 2000,
                    callback: () => {
                        this.scene.questionIndex += 1;
                        this.scene.SetQuestionOnBoard(this.scene.questionIndex);
                        var barx = this.scene.bluebar.x + gameData.progress;
                        //this.scene.bluebar.setX(barx);
                        this.scene.bartween = this.scene.tweens.add({
                            targets: this.scene.bluebar,
                            x: barx,
                            duration: 500,
                            ease: 'Power2',
                        });
                    },
                    loop: false
                });
            }
        }
    }

    class Loose extends Phaser.Scene {
        constructor() {
            super({ key: "Loose" });
        }

        preload() {
        }

        create() {
            window.angularComponentRef.gameFinishWithLoose();

            this.buttonClick = this.sound.add('buttonclick');
            this.buttonHover = this.sound.add('buttonhover');

            var failSound = this.sound.add("fail");// document.getElementById("instAudio");
            failSound.play();

            //var board = this.add.sprite(this.game.config.width/2, this.game.config.height/2, 'board');
            //board.setOrigin(0.5, 0.5);

            var greyRect = this.add.sprite(this.game.config.width / 2 + 6.5, this.game.config.height / 2 - 25.5, 'greyRect');
            greyRect.setOrigin(0.5, 0.475); var greyRect = this.add.sprite(this.game.config.width / 2 + 6.5, this.game.config.height / 2 - 25.5, 'greyRect');
            greyRect.setOrigin(0.5, 0.475);

            var board = this.add.sprite(this.game.config.width / 2, this.game.config.height / 2, 'frame');
            board.setOrigin(0.5, 0.5)

            var instRect = this.add.sprite(this.game.config.width / 2, this.game.config.height / 2 - 30, 'instRect');
            instRect.setOrigin(0.5, 0.53);

            var bigStar = this.add.sprite(this.game.config.width / 2 - 180, this.game.config.height / 2 + 30, 'bigStar');
            bigStar.setOrigin(0.5, 0.5);
            bigStar.setScale(0);

            var tween = this.tweens.add({
                targets: bigStar,
                scale: 1,
                ease: 'Power1',
                duration: 500,
            });
            var title = this.add.text(this.game.config.width / 2, this.game.config.height / 2 - 200, `${json.continent} - ${json.title}`, { fontFamily: 'Kids Rock DEMO', fontSize: 32, color: '#3280db', align: 'center', strokeThickness: 3 });
            title.setOrigin(0.5, 0.9);

            var playBtn = this.add.sprite(this.game.config.width / 2 + 190, this.game.config.height / 2 + 225, 'playagainBtn').setInteractive();
            playBtn.setOrigin(0.5, 0.5);

            var backbtn = this.add.sprite(this.game.config.width / 2 + 40, this.game.config.height / 2 + 225, 'backtoMenu').setInteractive();
            backbtn.setOrigin(0.5, 0.5);

            var tween = this.tweens.add({
                targets: playBtn,
                scale: 0.8,
                duration: 100,
                ease: 'Power2',
                yoyo: true,
                paused: true
            });

            var tween1 = this.tweens.add({
                targets: playBtn,
                scale: 1.1,
                duration: 100,
                ease: 'Power2',
                paused: true,
            });

            playBtn.on('pointerdown', function () {
                failSound.stop();

                this.scene.scene.start("Welcome");
                this.scene.buttonClick.play();
            });

            playBtn.on('pointerover', function () {
                playBtn.setTexture("playagainBtnHover");
                this.scene.buttonHover.play();
            });

            playBtn.on('pointerout', function () {
                playBtn.setTexture("playagainBtn");
            });

            backbtn.on('pointerdown', function () {
                failSound.stop();

                window.angularComponentRef.backToMenu();
            });

            backbtn.on('pointerover', function () {
                backbtn.setTexture("backtoMenuHover");
                this.scene.buttonHover.play();
            });

            backbtn.on('pointerout', function () {
                backbtn.setTexture("backtoMenu");
            });

            var congratsTitle = this.add.sprite(this.game.config.width / 2 + 60, this.game.config.height / 2 - 80, 'tryagain');
            congratsTitle.setOrigin(0.5, 0.5);

            var content = [
                "This time you didn't pass",
                "the quiz."

            ];

            var paragraph = this.add.text(this.game.config.width / 2 + 130, this.game.config.height / 2, content, {
                fontFamily: "Kids Rock DEMO",
                fontSize: 23,
                color: '#312f2f',
                align: 'left'
            });
            paragraph.setOrigin(0.5, 0.5);
            paragraph.setLineSpacing(10);

            var paragraph1 = this.add.text(this.game.config.width / 2 + 130, this.game.config.height / 2 + 100, "You have answered " + gameData.correctQ + " out \nof " + gameData.totalQ + " questions correctly.", {
                fontFamily: "Kids Rock DEMO",
                fontSize: 23,
                color: '#312f2f',
                align: 'left'
            });
            paragraph1.setOrigin(0.5, 0.5);
            paragraph1.setLineSpacing(10);
        }

        update(time, delta) {
        }
    }

    class Warning extends Phaser.Scene {
        constructor() {
            super({ key: "Warning" });
        }

        preload() {
        }

        create() {
            var btnclickSound = this.sound.add('buttonclick');
            var btnhoverSound = this.sound.add('buttonhover');

            var warningsound = this.sound.add("warning");
            warningsound.play();

            var bg = this.add.sprite(this.game.config.width / 2, this.game.config.height / 2, 'warningBg');
            bg.setOrigin(0.494, 0.516);

            var leaf = this.add.sprite(this.game.config.width / 2 - 380, this.game.config.height / 2 + 130, 'leaf');
            leaf.setOrigin(0.5, 0.5);

            var leaf1 = this.add.sprite(this.game.config.width / 2 + 380, this.game.config.height / 2 - 130, 'leaf');
            leaf1.setOrigin(0.5, 0.5);
            leaf1.setFlipX(-1);

            var board = this.add.sprite(this.game.config.width / 2, this.game.config.height / 2, 'warningBoard');
            board.setOrigin(0.5);

            var sign = this.add.sprite(this.game.config.width / 2, this.game.config.height / 2 - 130, 'sign');
            sign.setOrigin(0.5);

            var yesBtn = this.add.sprite(this.game.config.width / 2 - 100, this.game.config.height / 2 + 150, 'yesBtn').setInteractive();
            yesBtn.setOrigin(0.5);

            yesBtn.on("pointerdown", function () {
                btnclickSound.play();
                this.scene.scene.stop('Warning');
                this.scene.scene.stop('Game');
                window.angularComponentRef.backToMenu();
            });

            yesBtn.on("pointerover", function () {
                btnhoverSound.play();
                yesBtn.setTexture('yesBtnHover');
            });

            yesBtn.on("pointerout", function () {
                yesBtn.setTexture('yesBtn');
            });

            var noBtn = this.add.sprite(this.game.config.width / 2 + 100, this.game.config.height / 2 + 150, 'noBtn').setInteractive();
            noBtn.setOrigin(0.5);

            noBtn.on("pointerdown", function () {
                btnclickSound.play();
                this.scene.scene.stop('Warning');
                this.scene.scene.resume('Game');
            });

            noBtn.on("pointerover", function () {
                btnhoverSound.play();
                noBtn.setTexture('noBtnHover');
            });

            noBtn.on("pointerout", function () {
                noBtn.setTexture('noBtn');
            });

            var paragraph = this.add.text(this.game.config.width / 2, this.game.config.height / 2, "Your progress in this activity will not be saved.\n\nAre you sure you want to exit?", {
                fontFamily: "Kids Rock DEMO",
                fontSize: 26,
                color: '#1f1c19',
                stroke: '#ffffff',
                align: 'center',
                strokeThickness: 2
            });
            paragraph.setOrigin(0.5, 0.5);
        }
    }

    class Win extends Phaser.Scene {
        constructor() {
            super({ key: "Win" });
        }

        preload() {
        }

        create() {
            window.angularComponentRef.gameFinish();
            this.buttonClick = this.sound.add('buttonclick');
            this.buttonHover = this.sound.add('buttonhover');

            var winSound = this.sound.add("win");// document.getElementById("instAudio");
            winSound.play();

            //var board = this.add.sprite(this.game.config.width/2, this.game.config.height/2, 'board');
            //board.setOrigin(0.5, 0.5);

            var greyRect = this.add.sprite(this.game.config.width / 2 + 6.5, this.game.config.height / 2 + 3.5, 'greyRect');
            greyRect.setOrigin(0.5, 0.523);

            var board = this.add.sprite(this.game.config.width / 2, this.game.config.height / 2, 'frame');
            board.setOrigin(0.5, 0.5)

            var instRect = this.add.sprite(this.game.config.width / 2, this.game.config.height / 2 - 30, 'instRect');
            instRect.setOrigin(0.5, 0.53);

            var certificate = this.add.sprite(this.game.config.width / 2 - 180, this.game.config.height / 2 + 30, 'certificate');
            certificate.setOrigin(0.5, 0.5);

            var userName = this.add.text(this.game.config.width / 2 - 180, this.game.config.height / 2 + 17, json.displayName, {
                fontFamily: "PointSoft",
                fontSize: 16,
                color: '#000000',
                align: 'center',
            });
            userName.setOrigin(0.5, 0.5);

            var continents = ["Asia and Oceania", "Europe", "Africa", "South America"];

            var desc = this.add.text(this.game.config.width / 2 - 180, this.game.config.height / 2 + 44, "for completing " + json.title + " in \n the continent of " + continents[json.continentId.split('-')[0] - 1], {
                fontFamily: "PointSoft",
                fontSize: 9,
                color: '#E51B00',
                align: 'center',
            });
            desc.setOrigin(0.5, 0.5);

            var today = new Date();

            var date = this.add.text(this.game.config.width / 2 - 144, this.game.config.height / 2 + 82, today.getDate() + '.' + (today.getMonth() + 1) + '.' + today.getFullYear(), {
                fontFamily: "PointSoft",
                fontSize: 6,
                color: '#0090d9',
                align: 'center',
            });
            date.setOrigin(0.5, 0.5);

            var title = this.add.text(this.game.config.width / 2, this.game.config.height / 2 - 200, `${json.continent} - ${json.title}`, { fontFamily: 'Kids Rock DEMO', fontSize: 32, color: '#3280db', align: 'center', strokeThickness: 3 });
            title.setOrigin(0.5, 0.9);

            var playBtn = this.add.sprite(this.game.config.width / 2 + 40, this.game.config.height / 2 + 225, 'playagainBtn').setInteractive();
            playBtn.setOrigin(0.5, 0.5);

            var nextBtn = this.add.sprite(this.game.config.width / 2 + 190, this.game.config.height / 2 + 225, 'nextBtn').setInteractive();
            nextBtn.setOrigin(0.5, 0.5);

            var tween = this.tweens.add({
                targets: playBtn,
                scale: 0.8,
                duration: 100,
                ease: 'Power2',
                yoyo: true,
                paused: true
            });

            var tween1 = this.tweens.add({
                targets: playBtn,
                scale: 1.1,
                duration: 100,
                ease: 'Power2',
                paused: true,
            });

            playBtn.on('pointerdown', function () {
                winSound.stop();

                this.scene.scene.start("Welcome");
                this.scene.buttonClick.play();
            });

            playBtn.on('pointerover', function () {
                playBtn.setTexture("playagainBtnHover");
                this.scene.buttonHover.play();
            });

            playBtn.on('pointerout', function () {
                playBtn.setTexture("playagainBtn");
            });

            var canClick = true;

            nextBtn.on('pointerdown', function () {
                winSound.stop();
                if (canClick) {
                    canClick = false;
                    window.angularComponentRef.nextActivity();
                }
            });

            nextBtn.on('pointerover', function () {
                nextBtn.setTexture("nextBtnHover");
                this.scene.buttonHover.play();
            });

            nextBtn.on('pointerout', function () {
                nextBtn.setTexture("nextBtn");
            });

            var congratsTitle = this.add.sprite(this.game.config.width / 2 + 110, this.game.config.height / 2 - 80, 'congratsTitle');
            congratsTitle.setOrigin(0.5, 0.5);

            var content = [
                "You have earned the " + json.title,
                "certificate."

            ];

            var paragraph = this.add.text(this.game.config.width / 2 + 130, this.game.config.height / 2, content, {
                fontFamily: "Kids Rock DEMO",
                fontSize: 23,
                color: '#312f2f',
                stroke: '#312f2f',
                align: 'left'
            });
            paragraph.setOrigin(0.5, 0.5);
            paragraph.setLineSpacing(10);

            var paragraph1 = this.add.text(this.game.config.width / 2 + 130, this.game.config.height / 2 + 110, "You have answered " + gameData.correctQ + " out \nof " + gameData.totalQ + " questions correctly.", {
                fontFamily: "Kids Rock DEMO",
                fontSize: 23,
                color: '#312f2f',
                stroke: '#312f2f',
                align: 'left'
            });
            paragraph1.setOrigin(0.5, 0.5);
            paragraph1.setLineSpacing(10);
        }

        update(time, delta) {
        }
    }

    var config = {
        type: Phaser.CANVAS,
        transparent: true,
        scale: {
            mode: Phaser.Scale.NONE,
            parent: 'game-holder',
            resolution: 1,
        },
        autoCenter: Phaser.Scale.CENTER_BOTH,

        physics: {
            default: 'arcade',
            arcade: {
                gravity: { y: 200 }
            }
        },
        dom: {
            createContainer: false
        },
        render: {
            imageSmoothingEnabled: false,
            transparent: true,
        },
        scene: [Boot, Welcome, Game, Loose, Win, Warning]
    };

    config.json = json
    if (typeof window.orientation !== 'undefined') {
        config.scale.width = 1000;
        config.scale.height = 620;
        config.autoCenter = Phaser.Scale.CENTER_BOTH;
        config.scale.resolution = 1;
    } else {
        config.scale.mode = Phaser.Scale.NONE;
        config.scale.width = 1000;
        config.scale.height = 620;
        config.autoCenter = Phaser.Scale.CENTER_BOTH;
        config.scale.resolution = 1;
    }

    game = new Phaser.Game(config);

    // console.log(game);
    // resize();
    // window.addEventListener("resize", resize, false);

    // console.log(game);

    function resize() {
        var canvas = document.querySelector("canvas");
        var windowWidth = window.innerWidth;
        var windowHeight = window.innerHeight;
        var windowRatio = windowWidth / windowHeight;
        var gameRatio = 1000 / 620;

        console.log("window ratio", windowRatio);
        console.log("game ratio", gameRatio);

        if (windowRatio < gameRatio) {
            canvas.style.width = windowWidth + "px";
            canvas.style.height = (windowWidth / gameRatio) + "px";
        }
        else {
            canvas.style.width = 1000;//(windowHeight * gameRatio) + "px";
            canvas.style.height = 620;//windowHeight + "px";
        }
    }
};

function destoryQuiz() {
    if (game) {
        game.destroy();
    }
}

var game;
function soundSearch(json) {
    var currentQuestionIndex = 0;

    function setupButton(btn, frame_pointerdown, frame_pointerover, frame_pointerout, frame_pointerup, textureBased) {
        if (typeof frame_pointerout === "undefined") frame_pointerout = frame_pointerdown;
        if (typeof frame_pointerup === "undefined") frame_pointerup = frame_pointerdown;

        btn['frame_pointerdown'] = frame_pointerdown;
        btn['frame_pointerover'] = frame_pointerover;
        btn['frame_pointerout'] = frame_pointerout;
        btn['frame_pointerup'] = frame_pointerup;

        if (!btn["alreadySetupEvents"]) {
            btn["alreadySetupEvents"] = true;
            let fn = textureBased ? "setTexture" : "setFrame";
            btn.on('pointerdown', () => { btn[fn](btn['frame_pointerdown']); });
            btn.on('pointerover', () => { btn[fn](btn['frame_pointerover']); });
            btn.on('pointerout', () => { btn[fn](btn['frame_pointerout']); });
            btn.on('pointerup', () => { btn[fn](btn['frame_pointerup']); });
        }
    };

    //boot
    var boot = function (game) {
        console.log('%cBoot', 'color:white; background:red');
    };

    boot.prototype = {
        init: function () {
            this.apiData = json;

            //fix input
            this.game.scale.transformX = (pageX) => {
                let offsetLeft = 0;
                let parentElement = this.game.canvas.parentElement;
                while (parentElement) {
                    if (parentElement.offsetLeft) {
                        offsetLeft = parentElement.offsetLeft;
                        break;
                    }
                    parentElement = parentElement.parentElement;
                }
                return (pageX - offsetLeft) * this.game.scale.displayScale.x;
            };
            this.game.scale.transformY = (pageY) => {
                let offsetTop = 0;
                let parentElement = this.game.canvas.parentElement;
                while (parentElement) {
                    if (parentElement.offsetTop) {
                        offsetTop = parentElement.offsetTop;
                        break;
                    }
                    parentElement = parentElement.parentElement;
                }
                return (pageY - offsetTop) * this.game.scale.displayScale.y;
            };
        },
        preload: function () {
            this.load.atlas('assets', 'assets/games/sound-search/assets.png', 'assets/games/sound-search/assets.json');
            this.load.atlas('soundBtn', 'assets/qa/sound-icon/sound-btn-spritesheet.png', 'assets/qa/sound-icon/sound-btn-spritesheet.json');
            if (this.apiData.bgImage) {
                this.load.image('bg-image', this.apiData.bgImage);
            }
            else {
                this.load.image('bg-image', 'assets/games/sound-search/img/background.jpg');
            }

            this.load.image('Normal Sound Button', 'assets/games/sound-search/img/Normal Sound Button.png');
            this.load.image('Hover Sound Button', 'assets/games/sound-search/img/Hover Sound Button.png');

            this.load.image('red-arrow-image', 'assets/images/red-arrow.png');
            this.load.spritesheet('idle_default', 'assets/games/sound-search/spritesheets/Idle_sheet.png', { frameWidth: 2160 / 8, frameHeight: 1440 / 4, endFrame: 32 });
            this.load.spritesheet('idle_no', 'assets/games/sound-search/spritesheets/No_sheet.png', { frameWidth: 2160 / 8, frameHeight: 1440 / 4, endFrame: 32 });
            // this.load.spritesheet('idle_yes', 'assets/games/sound-search/spritesheets/Yes_sheet.png', { frameWidth: 400, frameHeight: 400, endFrame: 90 });
            this.load.atlas('idle_yes_atlas', 'assets/games/sound-search/spritesheets/Yes_atlas.png', 'assets/games/sound-search/spritesheets/Yes_atlas.json');


            this.cache.binary.add('questions', this.apiData.questions);
            this.cache.binary.add('instruction', this.apiData.instruction);
            // this.load.json('complete', location.origin + '/data/complete.json');
            this.cache.binary.add('totalPoints', '0');
            this.cache.binary.add('qAnsPoints', {
                correctAnsPoint: 2,
                secTimeCorrectAnsPoint: 0,
                wrongAnsPoint: 0
            });

            this.load.image('instruction-bg', 'assets/games/sound-search/img/modal-bg-1.png');
            this.load.image('completion-bg', 'assets/games/sound-search/img/complete-page-bg.jpg');
            this.load.image('try-again-bg', 'assets/games/sound-search/img/Try-again-bg.jpg');
            this.load.image('try-again-trophy', 'assets/games/sound-search/img/Try-again-trophy-w-bg.png');
            this.load.image('complete-trophy', 'assets/games/sound-search/img/complete-trophy.png');

            this.load.image('modal-overlay', 'assets/games/sound-search/img/modal-overlay.png');

            // this.load.audio('yes', 'assets/games/sound-search/sounds/yes.wav');
            this.load.audio('yes', 'assets/games/sound-search/sounds/yes_2.mp3');
            this.load.audio('noCorrectAnswerThis', 'assets/games/sound-search/sounds/no.mp3');
            this.load.audio('Next round starts', 'assets/games/sound-search/sounds/Next round starts.mp3');

            if (this.apiData.complete && this.apiData.complete.audios && this.apiData.complete.audios.length > 0) {
                var index = Math.floor(Math.random() * Math.floor(this.apiData.complete.audios.length));
                this.load.audio('completionSound', this.apiData.complete.audios[index]);
            }
            else {
                this.load.audio('completionSound', 'assets/games/sound-search/sounds/viktory.wav');
            }

            this.load.audio('tryAgainSound', 'assets/games/sound-search/sounds/fail.mp3');

            if (this.apiData.bgAudio) {
                this.load.audio('bg-music', this.apiData.bgAudio);
            }

            this.load.audio('selectionSound', 'assets/sounds/selection.mp3');
            this.load.audio('hoverSound', 'assets/sounds/hover.mp3');
            this.load.audio('exitSound', 'assets/sounds/warning-pop-up.mp3'); console.log('musics loaded');
        },
        create: function () {
            this.isMobile = !this.game.device.desktop;
            // this.scale.scaleMode = Phaser.ScaleManager.USER_SCALE;
            // if (this.isMobile) {
            //     this.scaleGame();
            //     this.scale.setResizeCallback(this.scaleGame);
            // }
            //Local storing
            if (window.localStorage.getItem('currentState')) {
                // this.game.state.start('ResumeGame', true, false, window.localStorage.getItem('currentState'));
                window.localStorage.removeItem('currentState');
            }
            this.scene.start("StartGame");//this.game.state.start('StartGame', true, false);
        },

        scaleGame: function () {
            const padding = this.isMobile ? 0 : 0; // include padding around the canvas frame for desktop
            const parentWidth = document.getElementById('game-container').offsetWidth;
            const xScale = (parentWidth - padding) / this.game.width;
            const scalePoint = Math.min(xScale, 1);
            // if (this.scale) {
            //     this.scale.setUserScale(scalePoint, scalePoint);
            // }
        }
    };

    //startGame
    var startgame = function (game) {
        console.log('startgame');
        console.log('%cStartGame', 'color:white; background:blue');
    };

    startgame.prototype = {
        init: function () {
            this.goUp = false;
            var storage = {
                questions: [],
                currentPoints: 0
            };
            window.localStorage.setItem('payload', JSON.stringify(storage));
        },
        preload: function () {
            this.fData = this.cache.binary.get('instruction');
            if (this.fData && this.fData.audio) {
                this.load.audio('startSound', this.fData.audio);
            }

            //sounds
            var self = this;
            this.questionData = { questions: this.cache.binary.get('questions') };
            for (var i = 0; i < this.questionData.questions.length; i++) {
                this.questionData.questions[i].answers.forEach(function (answer, _i) {
                    self.load.image('answerImage_' + i + '_' + _i, "assets/games/sound-search/img/answers/" + answer.imageName + ".png");
                    self.load.audio('answerSound_' + i + '_' + _i, "assets/games/sound-search/sounds/answers/" + answer.sound + ".mp3");
                });
                var soundName = this.questionData.questions[i].questionAudioName;
                if (soundName) {
                    this.load.audio('questionSound_' + i, "assets/games/sound-search/sounds/questions/" + soundName + ".mp3");
                }
            }
        },
        update: function () {
            if (this.redArrowImage) {
                if (this.goUp) {
                    this.redArrowImage.y -= 1;
                    if (this.redArrowImage.y <= -4) {
                        this.goUp = false
                    }
                } else {
                    this.redArrowImage.y += 1;
                    if (this.redArrowImage.y >= 18) {
                        this.goUp = true;
                    }
                }
            }
        },
        create: function () {
            window.angularComponentRef.loadingFinished();
            this.setupState();

            this.addSounds();
            this.playQuestionSound();

            var modalTextStyle = {
                backgroundColor: 'transparent',
                stroke: '#ffffff',
                strokeThickness: 2,
                fontFamily: 'Kids Rock DEMO',
                fontSize: 35,
                color: '#43425d',
                wordWrap: true,
                align: 'center'
            };

            var modalHeaderStyle = {
                backgroundColor: 'transparent',
                stroke: '#ffffff',
                strokeThickness: 16,
                fontFamily: 'Kids Rock DEMO',
                fontSize: 50,
                wordWrap: false,
                align: 'center'
            };

            this.add.sprite(0, 0, 'instruction-bg').setOrigin(0, 0);

            this.modal = this.add.container();

            var modalBox = this.add.sprite(this.game.scale.width / 2, this.game.scale.height / 2, 'assets', 'activity-Instruction-board.png');
            modalBox.setOrigin(0.5, 0.5);

            this.modalHeaderGroup = this.add.container();
            var modalBoxHeader = this.add.sprite(0, 0, 'assets', 'activity-Instruction-board-header.png');
            modalBoxHeader.setOrigin(0, 0);

            var modalHeaderText = this.add.text(0, 0, this.fData.title, modalHeaderStyle);
            if (!(this.game.device.mobileSafari || this.game.device.safari)) {
                modalHeaderText.setShadow(3, 3, '#43425d', 0, false, true);
            }

            var grd = modalHeaderText.context.createLinearGradient(0, 0, 0, modalHeaderText.height);
            grd.addColorStop(0, '#edee62');
            grd.addColorStop(0.2, '#edee62');
            grd.addColorStop(0.7, '#dd7b33');
            modalHeaderText.setFill(grd);

            var bgSoundButton = this.add.sprite(0, 0, 'soundBtn', 'introduction-sound_02.png');
            bgSoundButton.setOrigin(0, 0);
            bgSoundButton.on('pointerup', function () {
                if (this.redArrowImage) {
                    this.redArrowImage.alpha = 0;
                }
                this.playQuestionSound();
            }, this);

            setupButton(bgSoundButton, 'introduction-sound_02.png', 'introduction-sound_01.png');
            bgSoundButton.setInteractive({ cursor: 'pointer' });

            bgSoundButton.on('pointerover', this.playHoverSound, this);
            bgSoundButton.on('pointerdown', this.playSelectionSound, this);

            this.modalHeaderGroup.add(modalBoxHeader);
            this.modalHeaderGroup.add(modalHeaderText);
            this.modalHeaderGroup.add(bgSoundButton);
            this.modalHeaderGroup.setPosition((modalBox.width - modalBoxHeader.width) / 2 + modalBox.getBounds().left, modalBox.getBounds().top - 21);

            if (this.game.device.os.iOS) {
                this.redArrowImage = this.add.sprite(0, 0, 'red-arrow-image');
                this.redArrowImage.setOrigin(0, 0)
                this.modalHeaderGroup.add(this.redArrowImage);
            }

            modalHeaderText.setPosition(modalBoxHeader.getCenter().x, modalBoxHeader.getCenter().y);
            modalHeaderText.setOrigin(0.5, 0.5);
            modalBoxHeader.setPosition(this.modalHeaderGroup.getBounds().left, this.modalHeaderGroup.getBounds().top);
            bgSoundButton.setPosition(modalBoxHeader.getCenter().x + 30, modalBoxHeader.getCenter().y - 40);

            if (this.game.device.os.iOS) {
                this.redArrowImage.setPosition(modalBoxHeader.getCenter().x + 34, modalBoxHeader.getCenter().y - 110);
            }

            var modalText = this.add.text(this.game.scale.width / 2, this.game.scale.height / 2, this.fData.content.replaceAll('{br}', "\n"), modalTextStyle);
            modalText.setWordWrapWidth(modalBox.width - 110);//modalText.wordWrapWidth = modalBox.width - 110;
            modalText.setOrigin(0.5, 0.5);

            console.log('startButton');
            var startButton = this.add.sprite(this.game.scale.width / 2, modalBox.getBounds().bottom - 103, 'assets', 'activity-Instruction-play-button.png');
            startButton.setOrigin(0, 0)
            startButton.on('pointerup', function () {
                console.log('startButton clicked');
                // if (!this.game.device.desktop) {
                //     this.game.scale.startFullScreen(false);
                // }
                this.fsound.stop();
                currentQuestionIndex = 0;
                this.scene.start("Questions");//this.game.state.start('Questions', true, false, 0);
                console.log('startButton clicked22');
            }, this);

            setupButton(startButton, 'activity-Instruction-play-button.png', 'activity-Instruction-play-button-hover.png');
            startButton.setInteractive({ cursor: 'pointer' });

            startButton.on('pointerover', this.playHoverSound, this);
            startButton.on('pointerdown', this.playSelectionSound, this);

            startButton.input.pixelPerfectOver = true;
            startButton.input.pixelPerfectClick = true;
            startButton.setOrigin(0.5, 0.5);

            var leavesRightSprite = this.add.sprite(0, 0, 'assets', 'leaves.png');
            leavesRightSprite.setOrigin(0, 0)
            leavesRightSprite.setPosition(modalBox.getBounds().right - 145, modalBox.getBounds().top + 15);

            var leavesLeftSprite = this.add.sprite(0, 0, 'assets', 'leaves.png');
            leavesLeftSprite.setOrigin(0.5, 0.5);
            leavesLeftSprite.scaleX *= -1;
            leavesLeftSprite.setPosition(modalBox.getBounds().left + 34, modalBox.getBounds().bottom - 140);

            this.modal.add(leavesLeftSprite);
            this.modal.add(leavesRightSprite);
            this.modal.add(modalBox);
            this.modal.add(modalBoxHeader);
            this.modal.add(modalText);
            this.modal.add(startButton);
        },

        setupState: function () {
            // this.game.scale.fullScreenScaleMode = Phaser.ScaleManager.SHOW_ALL;

            // this.game.stage.disableVisibilityChange = true; // keep animation run on focus out
            // this.scale.pageAlignHorizontally = true;

            // this.scale.pageAlignVertically = true;
        },

        addSounds: function () {
            // console.warn("sound!");
            this.fsound = this.sound.add('startSound');
            this.hoverSound = this.sound.add('hoverSound');
            this.selectionSound = this.sound.add('selectionSound');

            // this.time.addEvent({ delay: 0, callback: this.playQuestionSound, callbackScope: this, loop: false });//this.game.time.events.add(0, this.playQuestionSound, this);
        },

        playHoverSound: function () {
            console.log('playHoverSound');
            this.hoverSound.play();
        },
        playSelectionSound: function () {
            this.selectionSound.play();
        },
        playQuestionSound: function () {
            this.fsound.play();
        }
    };

    //endGame
    var endgame = function (game) {
        console.log("%cEndGame", "color:white; background:blue");
    };

    endgame.prototype = {
        init: function () {
            this.saveActivityAns();
        },
        preload: function () {
            this.totalPoints = window.angularComponentRef.getTotalScore();
            // this.fData = this.cache.binary.get('complete')
        },
        create: function () {
            if (!this.completionSound) {
                this.completionSound = this.sound.add('completionSound');
            }
            this.completionSound.play();
            this.hoverSound = this.sound.add('hoverSound');
            this.selectionSound = this.sound.add('selectionSound');

            window.localStorage.removeItem('currentState');
            window.localStorage.removeItem('wrongButtonKey');

            var storageJson = window.localStorage.getItem('payload');
            var storage = JSON.parse(storageJson);
            var currentPoints = 0;
            if (storage) {
                currentPoints = storage.currentPoints || 0;
            }
            // this.scale.pageAlignHorizontally = true;
            // this.scale.pageAlignVertically = true;

            this.add.sprite(0, 0, 'completion-bg').setOrigin(0, 0);

            // this.game.stage.disableVisibilityChange = true; // keep animation run on focus out

            var totalScoreTextStyle = {
                backgroundColor: 'transparent',
                stroke: '#91301a',
                strokeThickness: 6,
                fontFamily: 'Kids Rock DEMO',
                fontSize: 39,
                wordWrap: false,
                align: 'left'
            };
            var totalScoreTextStyleOutline = {
                backgroundColor: 'transparent',
                stroke: '#fff',
                strokeThickness: 12,
                fontFamily: 'Kids Rock DEMO',
                fontSize: 39,
                wordWrap: false,
                align: 'left'
            };
            var collectedPointsTextStyle = {
                backgroundColor: 'transparent',
                stroke: '#91301a',
                strokeThickness: 2,
                fontFamily: 'Kids Rock DEMO',
                fontSize: 25,
                wordWrap: false,
                align: 'left',
                color: '#ffffff'
            };

            var modalBox = this.add.sprite(this.game.scale.width / 2, this.game.scale.height / 2, 'assets', 'activity-Instruction-board.png');
            modalBox.setOrigin(0.5, 0.5);
            var completeRibbon = this.add.sprite(modalBox.getCenter().x, modalBox.getBounds().top + 222, 'assets', 'complete-ribbon-full.png');
            completeRibbon.setOrigin(0.5, 0.5);

            var totalScoreOutline = this.add.text(modalBox.getBounds().left + 340, modalBox.getBounds().bottom - 302, "Total Score: " + " " + this.totalPoints, totalScoreTextStyleOutline);
            var totalScore = this.add.text(modalBox.getBounds().left + 342, modalBox.getBounds().bottom - 300, "Total Score: " + " " + this.totalPoints, totalScoreTextStyle);

            var grd = totalScore.context.createLinearGradient(0, 0, 0, totalScore.height);
            grd.addColorStop(0, '#f4fa38');
            grd.addColorStop(0.3, '#edee62');
            grd.addColorStop(0.7, '#dd7b33');
            totalScore.setFill(grd);

            var collectedPointsMedal = this.add.sprite(modalBox.getBounds().left + 324, modalBox.getBounds().bottom - 244, 'assets', 'collected-poins-medal.png');
            collectedPointsMedal.setOrigin(0, 0)
            var collectedPoints = this.add.text(modalBox.getBounds().left + 422, modalBox.getBounds().bottom - 204, "+" + currentPoints, collectedPointsTextStyle);

            // var trophy = this.game.add.sprite(modalBox.getBounds().left+66, modalBox.bottom-355, 'trophy');
            var trophy = this.add.sprite(modalBox.getBounds().left + 210, modalBox.getBounds().bottom - 215, 'complete-trophy');
            trophy.setScale(0.5, 0.5);
            trophy.setOrigin(0.5, 0.5);
            trophy.alpha = 0;
            this.tweens.add({
                targets: trophy,
                scaleX: 1,
                scaleY: 1,
                duration: 400,
                ease: Phaser.Math.Easing.Linear
            });
            this.tweens.add({
                targets: trophy,
                alpha: 1,
                duration: 400,
                ease: Phaser.Math.Easing.Linear
            });
            // game.add.tween(trophy.scale).to({ x: 1, y: 1 }, 400, Phaser.Easing.Linear.None, true);
            // game.add.tween(trophy).to({ alpha: 1 }, 400, Phaser.Easing.Linear.None, true);

            var backToMenuButton = this.add.sprite(modalBox.getBounds().left + 332, modalBox.getBounds().bottom - 89, 'assets', 'back-to-menu-button.png');
            backToMenuButton.setOrigin(0, 0)
            setupButton(backToMenuButton, 'back-to-menu-button.png', 'back-to-menu-button-hover.png');
            backToMenuButton.setInteractive({ cursor: 'pointer' });
            backToMenuButton.on('pointerup', this.backToMenu, this);

            var playAgainButton = this.add.sprite(modalBox.getBounds().left + 479, modalBox.getBounds().bottom - 89, 'assets', 'play-again-button.png');
            playAgainButton.setOrigin(0, 0)
            setupButton(playAgainButton, 'play-again-button.png', 'play-again-button-hover.png');
            playAgainButton.setInteractive({ cursor: 'pointer' });
            playAgainButton.on('pointerup', this.playAgain, this);

            var nextActivityButton = this.add.sprite(modalBox.getBounds().left + 626, modalBox.getBounds().bottom - 89, 'assets', 'next-activity-button.png');
            nextActivityButton.setOrigin(0, 0)
            setupButton(nextActivityButton, 'next-activity-button.png', 'next-activity-button-hover.png');
            nextActivityButton.setInteractive({ cursor: 'pointer' });
            nextActivityButton.on('pointerup', this.nextActivity, this);

            backToMenuButton.on('pointerover', this.playHoverSound, this);
            backToMenuButton.on('pointerdown', this.playSelectionSound, this);

            playAgainButton.on('pointerover', this.playHoverSound, this);
            playAgainButton.on('pointerdown', this.playSelectionSound, this);

            nextActivityButton.on('pointerover', this.playHoverSound, this);
            nextActivityButton.on('pointerdown', this.playSelectionSound, this);
        },

        backToMenu: function () {
            window.angularComponentRef.backToMenu();
            this.completionSound.stop()
        },
        playAgain: function () {
            console.log('play again button clicked');
            this.completionSound.stop()
            this.scene.start("StartGame");//this.game.state.start('StartGame', true, false);
        },
        nextActivity: function () {
            window.angularComponentRef.nextActivity();
            // this.game.state.start('StartGame', true, false);
        },

        formatTime: function (s) {
            var minutes = "0" + Math.floor(s / 60);
            var seconds = "0" + (s - minutes * 60);
            return minutes.substr(-2) + ":" + seconds.substr(-2);
        },

        playHoverSound: function () {
            this.hoverSound.play();
        },
        playSelectionSound: function () {
            this.selectionSound.play();
        },

        saveActivityAns: function () {
            var storageJson = window.localStorage.getItem('payload');
            var storage = JSON.parse(storageJson);
            var _obj = {
                activity_id: 1,
                country_id: 1,
                zone_id: 1,
                continent_id: 1,
                totalScore: 0,
                questions: []
            }
            if (storage) {
                for (var i = 0; i < storage.questions.length; i++) {
                    var questionKey = storage.questions[i].questionKey;
                    var answerKey = storage.questions[i].answerKey;
                    var attempts = storage.questions[i].attempts;
                    var points = storage.questions[i].points;
                    var question = {
                        [questionKey]: {
                            [answerKey]: {
                                try_count: attempts,
                                score: points
                            }
                        }
                    }
                    _obj.questions.push(question);
                    _obj.totalScore += points
                }
                window.angularComponentRef.gameFinish(_obj);
            }
        }
    };

    //startGame
    var resumegame = function (game) {
        console.log("%cStartGame", "color:white; background:blue");
    };

    resumegame.prototype = {
        init: function (/*currentQuestionIndex*/) {
            // this.currentQuestionIndex = currentQuestionIndex;
            this.fData = { questions: this.cache.binary.get('questions') };
        },
        create: function () {
            // this.scale.pageAlignHorizontally = true;
            // this.scale.pageAlignVertically = true;

            this.hoverSound = this.sound.add('hoverSound');
            this.selectionSound = this.sound.add('selectionSound');

            this.add.sprite(0, 0, 'bg-image').setOrigin(0, 0);

            // this.game.stage.disableVisibilityChange = true; // keep animation run on focus out

            var startButton = this.add.sprite(this.game.scale.width / 2, this.game.scale.height / 2, 'assets', 'next-button.png');
            startButton.setOrigin(0, 0)
            setupButton(startButton, 'next-button.png', 'next-button-hover.png');
            startButton.setInteractive({ cursor: 'pointer' });

            startButton.on('pointerup', function () {
                if (currentQuestionIndex < this.fData.questions.length) {
                    this.scene.start("Questions");//this.game.state.start("Questions", true, false, this.currentQuestionIndex);
                } else {
                    this.scene.start("EndGame");//this.game.state.start("EndGame", true, false);
                }
            }, this);

            startButton.on('pointerover', this.playHoverSound, this);
            startButton.on('pointerdown', this.playSelectionSound, this);
            startButton.setOrigin(0.5, 0.5);

            var style = {
                backgroundColor: 'transparent',
                stroke: '#074a83',
                strokeThickness: 6,
                fontFamily: "Kids Rock DEMO",
                fontSize: 40,
                color: "#ffffff",
                wordWrap: false,
                align: "left"
            };
            var startButtonText = this.add.text(this.game.scale.width / 2, this.game.scale.height / 2 - 100, 'Resume quiz', style);
            startButtonText.setOrigin(0.5, 0.5);
        },
        playHoverSound: function () {
            this.hoverSound.play();
        },
        playSelectionSound: function () {
            this.selectionSound.play();
        }
    };
    //questions
    var questions = function (game) {
        console.log("%cQuestions", "color:white; background:blue");
    };

    questions.prototype = {
        init: function (/*currentQuestionIndex*/) {
            // this.currentQuestionIndex = currentQuestionIndex || 0;
            this.wrongAnswersCount = 0;
            this.maxWrongAnswers = 1;
            window.localStorage.setItem('currentState', currentQuestionIndex);
        },
        preload: function () {
            this.fData = { questions: this.cache.binary.get('questions').filter(question => question.key != 5 && question.key != 10) };
            this.qAnsPoints = this.cache.binary.get('qAnsPoints');
        },
        create: function () {
            if (!this.bgMusic) {
                this.bgMusic = this.sound.add('bg-music', { volume: 1, loop: true });
                this.bgMusic.play();
            }
            else {
                if (!this.bgMusic.isPlaying) {
                    this.bgMusic.play();
                }
            }

            this.questionItem = this.fData.questions[currentQuestionIndex];

            this.drawBg();

            this.drawPuppet();

            this.drawStaticScene(this.questionItem.answers, this.questionItem.answer);

            this.drawStarPoints();

            this.addSounds();

            this.addEvents();

            this.addPlayQuestionButton();

            this.exitButton();

            this.exitModal();
        },
        drawStaticScene: function (answers, rightAnswerIndex) {
            console.log('drawStaticScene');
            let optionBoardMarginTop = 160;
            this.optionBoardA = this.add.sprite(50, optionBoardMarginTop, 'assets', 'option-board.png');
            this.optionBoardA.setOrigin(0, 0)
            this.optionBoardB = this.add.sprite(this.game.scale.width - 343, 160, 'assets', 'option-board.png');
            this.optionBoardB.setOrigin(0, 0)

            var isRightAnswer = (0 === rightAnswerIndex);
            this.optionPaperBtnA = this.add.sprite(this.optionBoardA.getBounds().left + 24, optionBoardMarginTop + 12, 'assets', 'option-paper.png');
            this.optionPaperBtnA.setOrigin(0, 0)
            setupButton(this.optionPaperBtnA, 'option-paper-click.png', 'option-paper-hover.png', 'option-paper.png');
            // this.optionPaperBtnA.setInteractive({ cursor: 'pointer' });
            this.optionPaperBtnA.fData = { isRight: isRightAnswer };
            this.optionPaperBtnA["context"] = this;
            this.optionPaperBtnA["isRightAnswer"] = isRightAnswer;
            this.optionPaperBtnA.on('pointerup', this.onClickAnswerButton, this.optionPaperBtnA);
            this.optionPaperBtnA.on('pointerover', this.playHoverSound, this);
            this.optionPaperBtnA.on('pointerdown', this.playSelectionSound, this);
            // var isClicked = false;
            // if (item.key === window.localStorage.getItem('wrongButtonKey')) {
            //     isClicked = true;
            // }
            isRightAnswer = (1 === rightAnswerIndex);
            this.optionPaperBtnB = this.add.sprite(this.optionBoardB.getBounds().left + 24, optionBoardMarginTop + 12, 'assets', 'option-paper.png');
            this.optionPaperBtnB.setOrigin(0, 0)
            setupButton(this.optionPaperBtnB, 'option-paper-click.png', 'option-paper-hover.png', 'option-paper.png');
            // this.optionPaperBtnB.setInteractive({ cursor: 'pointer' });
            this.optionPaperBtnB.fData = { isRight: isRightAnswer };
            this.optionPaperBtnB["context"] = this;
            this.optionPaperBtnB["isRightAnswer"] = isRightAnswer;
            this.optionPaperBtnB.on('pointerup', this.onClickAnswerButton, this.optionPaperBtnB);
            this.optionPaperBtnB.on('pointerover', this.playHoverSound, this);
            this.optionPaperBtnB.on('pointerdown', this.playSelectionSound, this);

            this.answerCorrectImage = 'option-paper-correct.png';
            this.answerWrongImage = 'option-paper-wrong.png'; // wrong button image need to change

            this.firstAnswerImage = this.add.sprite(this.optionPaperBtnA.getBounds().left, this.optionPaperBtnA.getBounds().top, 'answerImage_' + currentQuestionIndex + '_0');
            this.firstAnswerImage.setOrigin(0, 0)
            this.secondAnswerImage = this.add.sprite(this.optionPaperBtnB.getBounds().left, this.optionPaperBtnA.getBounds().top, 'answerImage_' + currentQuestionIndex + '_1');
            this.secondAnswerImage.setOrigin(0, 0)

            // let bush_1 = this.add.sprite(0, this.game.world.bottom - 183, 'assets', 'bush-1.png');
            // let bush_2 = this.add.sprite(this.game.world.width - 527, this.game.world.bottom - 157, 'assets', 'bush-2.png');

            this.optionBoardA_soundBtn = this.add.sprite(this.optionBoardA.getBounds().left + 118 + 30, optionBoardMarginTop + 224 + 40, 'Normal Sound Button');
            this.optionBoardA_soundBtn.setScale(0.5);
            this.optionBoardA_soundBtn.setOrigin(0.5, 0.5)
            setupButton(this.optionBoardA_soundBtn, 'Normal Sound Button', 'Hover Sound Button', undefined, undefined, true);
            this.optionBoardA_soundBtn.setInteractive({ cursor: 'pointer' });
            this.optionBoardA_soundBtn["context"] = this;
            this.optionBoardA_soundBtn["answerIndex"] = 0;
            this.optionBoardA_soundBtn.on('pointerup', this.playAnswerSound, this.optionBoardA_soundBtn);

            this.optionBoardB_soundBtn = this.add.sprite(this.optionBoardB.getBounds().left + 118 + 30, optionBoardMarginTop + 224 + 40, 'Normal Sound Button');
            this.optionBoardB_soundBtn.setScale(0.5);
            this.optionBoardB_soundBtn.setOrigin(0.5, 0.5)
            setupButton(this.optionBoardB_soundBtn, 'Normal Sound Button', 'Hover Sound Button', undefined, undefined, true);
            this.optionBoardB_soundBtn.setInteractive({ cursor: 'pointer' });
            this.optionBoardB_soundBtn["context"] = this;
            this.optionBoardB_soundBtn["answerIndex"] = 1;
            this.optionBoardB_soundBtn.on('pointerup', this.playAnswerSound, this.optionBoardB_soundBtn);

            if (this.optionPaperBtnA.game) {
                this.optionPaperBtnA.disableInteractive();
                this.optionPaperBtnB.disableInteractive();
            }
        },
        drawBg: function () {
            this.bg = this.add.sprite(0, 0, 'bg-image')
            this.bg.setOrigin(0, 0)
        },
        drawStarPoints: function () {
            var starMargin = 12
            var starWidth = 33

            var bgHead = this.add.sprite(56, 525, 'assets', 'stars-bg-head.png');
            bgHead.setOrigin(0, 0)
            //background body reapeat
            var bgBodyGroup = this.add.container();
            var k = bgHead.getBounds().right;
            var allStarWidth = (this.fData.questions.length * (starWidth + starMargin)) / 3 // 3 - the width of a chunk for background repeat
            for (var i = 0; i < allStarWidth; i++) {
                var bgBodyChunk = this.add.sprite(k, bgHead.getBounds().top, 'assets', 'stars-bg-body.png')
                bgBodyChunk.setOrigin(0, 0)
                bgBodyGroup.add(bgBodyChunk)
                k += 3;
            }

            var bgTail = this.add.sprite(bgBodyGroup.getBounds().right + bgHead.getBounds().width / 2, bgHead.getBounds().top, 'assets', 'stars-bg-head.png');
            // flip head to get the tail part
            bgTail.setOrigin(.5, 0);
            bgTail.scaleX *= -1;

            this.starDefaultGroup = this.add.container()
            this.starActiveGroup = this.add.container()
            this.starWrongGroup = this.add.container()
            var starPosX = bgHead.getBounds().right

            var storageJson = window.localStorage.getItem('payload');
            var storage = JSON.parse(storageJson);

            for (var i = 0; i < this.fData.questions.length; i++) {
                var star = this.add.sprite(starPosX, bgHead.getBounds().top + 6, 'assets', 'star.png')
                star.setOrigin(0, 0)
                var starActive = this.add.sprite(starPosX, bgHead.getBounds().top + 6, 'assets', 'star-active.png')
                starActive.setOrigin(0, 0)
                starActive.alpha = 0;
                var starWrong = this.add.sprite(starPosX, bgHead.getBounds().top + 6, 'assets', 'star-wrong.png')
                starWrong.setOrigin(0, 0)
                starWrong.alpha = 0;
                starPosX += starWidth + starMargin
                this.starDefaultGroup.add(star)
                this.starActiveGroup.add(starActive)
                this.starWrongGroup.add(starWrong)
                if (storage.questions[i] && storage.questions[i].correctAnswer) {
                    this.setStar(i, 1)
                } else if (storage.questions[i] && !storage.questions[i].correctAnswer) {
                    this.setStarWrong(i)
                }
            }
        },
        setStar: function (index, alpha) {
            this.starActiveGroup.getAt(index).alpha = alpha
        },
        setStarWrong: function (index) {
            this.starWrongGroup.getAt(index).alpha = 1;
            this.starDefaultGroup.getAt(index).alpha = 0;
        },
        playAnswerSound: function () {
            this.context.answerSounds['answerSound_' + currentQuestionIndex + '_' + this.answerIndex].play();
        },
        onClickAnswerButton: function () {
            var button = this;
            var context = this.context;
            // console.warn("context.puppetIdle.animations.stop(null, true);")
            context.puppetIdle.anims.stop();
            // context.questionSoundEvent.remove(false);//context.game.time.events.remove(context.questionSoundEvent);

            if (context.sound && context.sound.isPlaying) {
                context.sound.stop();
            }
            var storage = window.localStorage.getItem('payload');
            storage = JSON.parse(storage);

            var questionIdx;
            if (storage) {
                var question;
                for (var i = 0; i < storage.questions.length; i++) {
                    var item = storage.questions[i];
                    if (context.questionItem.key === item.questionKey) {
                        question = item;
                        questionIdx = i;
                        break;
                    }
                }
                if (question) {
                    question.attempts = question.attempts + 1;
                    question.correctAnswer = this.isRightAnswer;
                    storage.questions[questionIdx] = question;
                } else {
                    question = {
                        questionKey: context.questionItem.key,
                        correctAnswer: this.isRightAnswer,
                        attempts: 1
                    };
                    storage.questions.push(question)
                }
            }
            var points = 0;

            context.optionPaperBtnA.disableInteractive();
            context.optionPaperBtnB.disableInteractive();

            var isEndGame = false;
            if (this.isRightAnswer) {
                if (context.wrongAnswersCount === 0) {
                    points = +context.qAnsPoints.correctAnsPoint;
                } else {
                    points = +context.qAnsPoints.secTimeCorrectAnsPoint;
                }
                isEndGame = true;

                // this.text.fill = '#6afaff';
                // this.text.stroke = '#1a472b';
                button.setFrame(context.answerCorrectImage);
                setupButton(button, context.answerCorrectImage, context.answerCorrectImage);//button.setFrames(context.answerCorrectImage, context.answerCorrectImage);

                context.puppetNo.alpha = 0;
                context.puppetIdle.alpha = 0;
                context.puppetYes.alpha = 1;

                context.puppetNo.anims.stop();
                context.anims.create({
                    key: 'yesAnimate',
                    frames: context.anims.generateFrameNames('idle_yes_atlas', {
                        prefix: 'Kangoro New',
                        suffix: '.png',
                        start: 6,
                        end: 90,
                        zeroPad: 4
                    }),
                    frameRate: 45,
                    repeat: 0
                });
                context.puppetYes.play('yesAnimate');
                setTimeout(function () {
                    context.yesSound.play();
                }, 250);

                context.addNewDefaultLoop();
                window.localStorage.setItem('currentState', +(currentQuestionIndex) + 1);
                context.setStar(currentQuestionIndex, 1)
            } else {
                points = +context.qAnsPoints.secTimeCorrectAnsPoint;

                button.disableInteractive();

                context.puppetIdle.alpha = 0;
                context.puppetYes.alpha = 0;

                if (!this.clicked) {
                    this.clicked = true;
                    context.wrongAnswersCount++;
                }
                isEndGame = context.wrongAnswersCount === context.maxWrongAnswers;

                points = +context.qAnsPoints.wrongAnsPoint;

                context.puppetNo.alpha = 1;

                context.anims.create({
                    key: 'noAnimate',
                    frames: context.anims.generateFrameNumbers('idle_no', { start: 0, end: 31, first: 0 }),
                    frameRate: 20,
                    repeat: 0
                });
                context.puppetNo.play('noAnimate');

                context.noCorrectAnswerThis.play();
                if (isEndGame) {
                    // if (context.optionPaperBtnA.data.isRight) {
                    //     context.optionPaperBtnA.setFrames(context.answerCorrectImage, context.answerCorrectImage, context.answerCorrectImage);
                    // } else {
                    //     context.optionPaperBtnB.setFrames(context.answerCorrectImage, context.answerCorrectImage, context.answerCorrectImage);
                    // }

                    window.localStorage.setItem('currentState', +(currentQuestionIndex) + 1);
                    // window.localStorage.removeItem('wrongButtonKey');
                } else {
                    // window.localStorage.setItem('wrongButtonKey', this.key);
                }
                button.setFrame(context.answerWrongImage);
                setupButton(button, context.answerWrongImage, context.answerWrongImage);//button.setFrames(context.answerWrongImage, context.answerWrongImage);
                context.setStarWrong(currentQuestionIndex);
            }
            if (storage) {
                if (isEndGame) {
                    storage.currentPoints = storage.currentPoints + points;
                    if (questionIdx) {
                        storage.questions[questionIdx].points = points;
                        storage.questions[questionIdx].answerKey = this.key;
                    } else {
                        storage.questions[currentQuestionIndex].points = points;
                        storage.questions[currentQuestionIndex].answerKey = this.key;
                    }
                }
                window.localStorage.setItem('payload', JSON.stringify(storage));
            }
        },
        drawPuppet: function () {
            var frameWidth = 361;
            var frameHeight = 448;
            var framePosX = 500;
            var framePosY = 350;

            this.puppetIdle = this.add.sprite(framePosX, framePosY, 'idle_default');
            this.puppetIdle.setOrigin(0.5, 0.5)
            this.puppetIdle.height = frameHeight;
            this.puppetIdle.width = frameWidth;

            // puppet no
            this.puppetNo = this.add.sprite(framePosX, framePosY, 'idle_no');
            this.puppetNo.setOrigin(0.5, 0.5)
            this.puppetNo.height = frameHeight;
            this.puppetNo.width = frameWidth;
            this.puppetNo.alpha = 0;

            // puppet yes
            this.puppetYes = this.add.sprite(framePosX - 2, framePosY + 7, 'idle_yes_atlas');
            this.puppetYes.setOrigin(0.5, 0.5)
            this.puppetYes.height = frameHeight;
            this.puppetYes.width = frameWidth;
            this.puppetYes.alpha = 0;

            var self = this;

            this.anims.create({
                key: 'idleAnimate',
                frames: this.anims.generateFrameNumbers('idle_default', { start: 0, end: 31, first: 0 }),
                frameRate: 20,
                repeat: 0
            });
            var a = this.puppetIdle.play('idleAnimate');
            this.puppetIdle.on('animationcomplete', function () {
                // self.puppetIdle.frame = 0;
            });


            this.anims.create({
                key: 'noAnimate',
                frames: this.anims.generateFrameNumbers('idle_no', { start: 0, end: 31, first: 0 }),
                frameRate: 20,
                repeat: 0
            });
            // this.puppetNoAnim = this.puppetNo.play('noAnimate');
            this.puppetNo.on('animationcomplete', function () {
                // self.puppetNo.frame = 0;
                setTimeout(function () {
                    self.onClickNextButton()
                }, 1000)
            });

            /*this.puppetNoAnim = this.puppetNo.anims.add('noAnimate');
            this.puppetNo.on('animationcomplete', function () {
                self.puppetNo.frame = 0;
                setTimeout(function () {
                    self.onClickNextButton()
                }, 1000)
            });*/


            this.anims.create({
                key: 'yesAnimate',
                frames: this.anims.generateFrameNames('idle_yes_atlas', {
                    prefix: 'Kangoro New',
                    suffix: '.png',
                    start: 6,
                    end: 90,
                    zeroPad: 4
                }),
                frameRate: 45,
                repeat: 0
            });

            // this.puppetYesAnim = this.puppetYes.play('yesAnimate');
            this.puppetYes.on('animationcomplete', function () {
                // self.puppetYes.frame = 0;
                setTimeout(function () {
                    self.onClickNextButton()
                }, 1000)
            });

            /*this.puppetYesAnim = this.puppetYes.anims.add('yesAnimate');
            this.puppetYes.on('animationcomplete', function () {
                self.puppetYes.frame = 0;
                this.setTimeout(function () {
                    self.onClickNextButton()
                }, 1000)
            });*/
        },
        addNewDefaultLoop: function () {
            if (this.defaultLoop) {
                this.time.clearPendingEvents();//this.game.time.events.clearPendingEvents();
                this.defaultLoop = this.time.addEvent({ delay: 1000 * 5, callback: this.payPuppet, callbackScope: this, loop: true });//this.defaultLoop = self.game.time.events.loop(Phaser.Timer.SECOND * 5, this.payPuppet, this);
            } else if (!this.defaultLoop) {
                this.defaultLoop = this.time.addEvent({ delay: 1000 * 5, callback: this.payPuppet, callbackScope: this, loop: true });//this.defaultLoop = self.game.time.events.loop(Phaser.Timer.SECOND * 5, this.payPuppet, this);
            }
        },
        playQuestionSound: function () {
            if (!this.fsound) {
                return
            }
            this.fsound.play();
            var self = this;
            this.fsound.on('complete', function () {
                // if (self.optionPaperBtnA.game) {
                self.optionPaperBtnA.setInteractive({ cursor: 'pointer' });
                self.optionPaperBtnB.setInteractive({ cursor: 'pointer' });
                // self.questionSoundEvent.remove(false);// self.game.time.events.remove(self.questionSoundEvent);
                // self.questionSoundEvent = self.time.addEvent({ delay: 1000 * 7, callback: function () {
                //         this.fsound.play();
                //     }, callbackScope: this, loop: true });
                /*self.questionSoundEvent = self.game.time.events.loop(Phaser.Timer.SECOND * 7, function () {
                    this.sound.play()
                }, self);*/
                // }
            });
        },
        payPuppet: function () {
            console.warn('this.puppetNoAnim.isPlaying');
            // if (this.puppetNoAnim.isPlaying
            //     || this.puppetYesAnim.isPlaying) {
            //     return
            // }
            if (this.puppetNo.anims.isPlaying
                || this.puppetYes.anims.isPlaying) {
                return
            }
            this.puppetNo.alpha = 0;
            this.puppetYes.alpha = 0;
            this.puppetIdle.alpha = 1;

            this.puppetIdle.anims.play('idleAnimate');
        },
        addSounds: function () {
            this.answerSounds = {};
            var self = this;
            this.fData.questions[currentQuestionIndex].answers.forEach(function (answer, i) {
                self.answerSounds['answerSound_' + currentQuestionIndex + '_' + i] = self.sound.add('answerSound_' + currentQuestionIndex + '_' + i);
            });

            this.fsound = null;
            if (this.fData.questions[currentQuestionIndex].questionAudioName) {
                this.fsound = this.sound.add('questionSound_' + currentQuestionIndex);
            }
            this.yesSound = this.sound.add("yes");
            this.noCorrectAnswerThis = this.sound.add("noCorrectAnswerThis");

            this.hoverSound = this.sound.add('hoverSound');
            this.selectionSound = this.sound.add('selectionSound');
            this.exitSound = this.sound.add('exitSound');
            var self = this;
            /*this.game.onPause.add(function () {
                self.game.sound.unsetMute();
                self.sound.stop();
                self.bgMusic.pause();
            })*/
        },
        addEvents: function () {
            if (currentQuestionIndex % 4 == 0) {
                this.playQuestionSound();
            } else {
                this.optionPaperBtnA.setInteractive({ cursor: 'pointer' });
                this.optionPaperBtnB.setInteractive({ cursor: 'pointer' });
            }
            // this.questionSoundEvent = this.time.addEvent({ delay: 1000, callback: this.playQuestionSound, callbackScope: this, loop: false });//this.questionSoundEvent = this.game.time.events.add(Phaser.Timer.SECOND, this.playQuestionSound, this);
            this.addNewDefaultLoop();
        },
        addPlayQuestionButton: function () {
            this.playQuestionBtn = this.add.sprite(100, 16, 'assets', 'audio-icon.png');
            this.playQuestionBtn.setOrigin(1, 0)
            setupButton(this.playQuestionBtn, 'audio-icon.png', 'audio-icon-hover.png');

            this.playQuestionBtn.setInteractive({ cursor: 'pointer' });
            this.playQuestionBtn.on('pointerup', this.playQuestionSound, this);
            this.playQuestionBtn.on('pointerover', this.playHoverSound, this);
            this.playQuestionBtn.on('pointerdown', this.playSelectionSound, this);
        },
        exitButton: function () {
            this.extiBtn = this.add.sprite(this.game.scale.width - 100, 0 + 16, 'assets', 'exit-button.png');
            this.extiBtn.setOrigin(0, 0)
            setupButton(this.extiBtn, 'exit-button.png', 'exit-button-hover.png');
            this.extiBtn.setInteractive({ cursor: 'pointer' });
            this.extiBtn.on('pointerup', this.showExitModal, this);
            this.extiBtn.on('pointerover', this.playHoverSound, this);
            this.extiBtn.on('pointerdown', this.playSelectionSound, this);
        },

        exitModal: function () {
            var modalBg = this.add.sprite(0, 0, 'modal-overlay');
            modalBg.setInteractive();
            modalBg.setOrigin(0, 0)
            this.modal = this.add.container();
            var modalBox = this.add.sprite(this.game.scale.width / 2, this.game.scale.height / 2, 'assets', 'activity-Instruction-board.png');
            modalBox.setOrigin(0.5, 0.5);

            var leavesRightSprite = this.add.sprite(0, 0, 'assets', 'leaves.png');
            leavesRightSprite.setOrigin(0, 0)
            leavesRightSprite.setPosition(modalBox.getBounds().right - 145, modalBox.getBounds().top + 15);

            var leavesLeftSprite = this.add.sprite(0, 0, 'assets', 'leaves.png');
            leavesLeftSprite.setOrigin(0.5, 0.5);
            leavesLeftSprite.scaleX *= -1;
            leavesLeftSprite.setPosition(modalBox.getBounds().left + 34, modalBox.getBounds().bottom - 140);

            var warningIcon = this.add.sprite(modalBox.getCenter().x, modalBox.getBounds().top + 74, 'assets', 'warning-icon.png');
            warningIcon.setOrigin(0.5, 0);


            var modalTextStyle = {
                backgroundColor: 'transparent',
                stroke: '#ffffff',
                strokeThickness: 2,
                fontFamily: 'Kids Rock DEMO',
                fontSize: 27,
                color: '#43425d',
                wordWrap: true,
                align: 'center'
            };
            var modalText = this.add.text(this.game.scale.width / 2, this.game.scale.height / 2 + 10, "Your progress in this activity will not be saved. \n Are you sure you want to exit? ", modalTextStyle);
            modalText.setWordWrapWidth(modalBox.width - 110);//modalText.wordWrapWidth = modalBox.width - 110;
            modalText.setOrigin(0.5, 0.5);

            var modalYesBtn = this.add.sprite(modalBox.getBounds().left + 217, modalBox.getBounds().bottom - 179, 'assets', 'button-yes.png');
            modalYesBtn.setOrigin(0, 0)
            setupButton(modalYesBtn, 'button-yes.png', 'button-yes-hover.png');
            modalYesBtn.setInteractive({ cursor: 'pointer' });
            modalYesBtn.on('pointerup', this.exitGame, this);
            var modalNoBtn = this.add.sprite(modalYesBtn.getBounds().right - 43, modalBox.getBounds().bottom - 179, 'assets', 'button-no.png');
            modalNoBtn.setOrigin(0, 0)
            setupButton(modalNoBtn, 'button-no.png', 'button-no-hover.png');
            modalNoBtn.setInteractive({ cursor: 'pointer' });
            modalNoBtn.on('pointerup', this.exitGameCancel, this);

            modalYesBtn.on('pointerover', this.playHoverSound, this);
            modalYesBtn.on('pointerdown', this.playSelectionSound, this);

            modalNoBtn.on('pointerover', this.playHoverSound, this);
            modalNoBtn.on('pointerdown', this.playSelectionSound, this);

            this.modal.add(modalBg);
            this.modal.add(leavesLeftSprite);
            this.modal.add(leavesRightSprite);
            this.modal.add(modalBox);
            this.modal.add(warningIcon);
            this.modal.add(modalText);
            this.modal.add(modalYesBtn);
            this.modal.add(modalNoBtn);

            this.modal.visible = false;
            this.modal.alpha = 0;
        },

        showExitModal: function () {
            this.extiBtn.visible = false;
            this.modal.visible = true;
            // game.add.tween(this.modal).to( { alpha: 1 }, 200, Phaser.Easing.Linear.None, true);
            this.modal.alpha = 1;
            this.time.paused = true;
            this.sound.pauseAll();// this.scene.pause();//this.game.paused = true;
            this.exitSound.play();
        },

        exitGame: function () {
            this.time.paused = false;
            this.sound.resumeAll();// this.scene.resume();//this.game.paused = false;
            window.localStorage.removeItem('currentState');

            if (this.bgMusic) {
                this.bgMusic.stop();
            }
            // window.localStorage.removeItem('wrongButtonKey');
            // this.game.state.start('StartGame', true, false);
            window.angularComponentRef.backToMenu();
        },
        exitGameCancel: function () {
            this.extiBtn.visible = true;
            this.modal.alpha = 0;
            this.modal.visible = false;
            this.time.paused = false;
            this.sound.resumeAll();// this.scene.resume();//this.game.paused = false;
            this.bgMusic.resume();
        },
        onClickNextButton: function () {
            // this.game.sound.stopAll();
            if (this.fsound) {
                this.fsound.stop();
            }
            Object.values(this.answerSounds).forEach(function (item) {
                item.stop();
            });
            if (this.yesSound) {
                this.yesSound.stop();
            }
            if (this.noCorrectAnswerThis) {
                this.noCorrectAnswerThis.stop();
            }
            currentQuestionIndex++;
            var storage = window.localStorage.getItem('payload');
            storage = JSON.parse(storage);
            if (storage && storage.questions) {
                var incorrectArr = [];
                for (var i = 0; i < storage.questions.length; i++) {
                    if (!storage.questions[i].correctAnswer) {
                        incorrectArr[incorrectArr.length] = storage.questions[i]
                    }
                }
                if (incorrectArr.length >= 3) {
                    if (this.bgMusic) {
                        this.bgMusic.stop();
                    }
                    this.scene.start("TryGame");//this.game.state.start("TryGame", true, false);
                } else if (currentQuestionIndex < this.fData.questions.length) {
                    // this.scene.switch("Questions")
                    this.scene.start("Questions");//this.game.state.start("Questions", true, false, this.currentQuestionIndex);

                    this.sound.add("Next round starts").play();
                } else {
                    if (this.bgMusic) {
                        this.bgMusic.stop();
                    }
                    this.scene.start("EndGame");//this.game.state.start("EndGame", true, false);
                }
            } else {
                if (this.bgMusic) {
                    this.bgMusic.stop();
                }
                this.scene.start("EndGame");//this.game.state.start("EndGame", true, false);
            }
        },
        playHoverSound: function () {
            console.log('playHoverSound');
            this.hoverSound.play();
        },
        playSelectionSound: function () {
            this.selectionSound.play();
        }
    };

    //endGame
    var trygame = function (game) {
        console.log("%cTryGame", "color:white; background:blue");
    };

    trygame.prototype = {
        preload: function () {
            this.totalPoints = window.angularComponentRef.getTotalScore();
            // this.fData = this.cache.binary.get('complete')
        },
        create: function () {
            console.log('trygame create');
            if (!this.tryAgainSound) {
                this.tryAgainSound = this.sound.add('tryAgainSound');
            }
            this.tryAgainSound.play();

            this.hoverSound = this.sound.add('hoverSound');
            this.selectionSound = this.sound.add('selectionSound');

            window.localStorage.removeItem('currentState');
            window.localStorage.removeItem('wrongButtonKey');

            var storageJson = window.localStorage.getItem('payload');
            var storage = JSON.parse(storageJson);
            var currentPoints = 0;
            if (storage) {
                // currentPoints = storage.currentPoints || 0;
            }
            // this.scale.pageAlignHorizontally = true;
            // this.scale.pageAlignVertically = true;

            this.add.sprite(0, 0, 'try-again-bg').setOrigin(0, 0);

            // this.game.stage.disableVisibilityChange = true; // keep animation run on focus out

            var totalScoreTextStyle = {
                backgroundColor: 'transparent',
                stroke: '#91301a',
                strokeThickness: 6,
                fontFamily: 'Kids Rock DEMO',
                fontSize: 39,
                wordWrap: false,
                align: 'left'
            };
            var totalScoreTextStyleOutline = {
                backgroundColor: 'transparent',
                stroke: '#fff',
                strokeThickness: 12,
                fontFamily: 'Kids Rock DEMO',
                fontSize: 39,
                wordWrap: false,
                align: 'left'
            };
            var collectedPointsTextStyle = {
                backgroundColor: 'transparent',
                stroke: '#91301a',
                strokeThickness: 2,
                fontFamily: 'Kids Rock DEMO',
                fontSize: 25,
                wordWrap: false,
                align: 'left',
                color: '#ffffff'
            };

            var modalBox = this.add.sprite(this.game.scale.width / 2, this.game.scale.height / 2, 'assets', 'activity-Instruction-board.png');
            modalBox.setOrigin(0.5, 0.5);
            var completeRibbon = this.add.sprite(modalBox.getCenter().x, modalBox.getBounds().top + 222, 'assets', 'try-again-ribbon.png');
            completeRibbon.setOrigin(0.5, 0.5);

            var totalScoreOutline = this.add.text(modalBox.getBounds().left + 340, modalBox.getBounds().bottom - 302, "Total Score: " + " " + this.totalPoints, totalScoreTextStyleOutline);
            var totalScore = this.add.text(modalBox.getBounds().left + 342, modalBox.getBounds().bottom - 300, "Total Score: " + " " + this.totalPoints, totalScoreTextStyle);

            var grd = totalScore.context.createLinearGradient(0, 0, 0, totalScore.height);
            grd.addColorStop(0, '#edee62');
            grd.addColorStop(0.2, '#edee62');
            grd.addColorStop(0.7, '#dd7b33');
            totalScore.setFill(grd);

            var collectedPointsMedal = this.add.sprite(modalBox.getBounds().left + 324, modalBox.getBounds().bottom - 244, 'assets', 'collected-poins-medal.png');
            collectedPointsMedal.setOrigin(0, 0)

            var collectedPoints = this.add.text(modalBox.getBounds().left + 422, modalBox.getBounds().bottom - 204, currentPoints, collectedPointsTextStyle);

            // var trophy = this.game.add.sprite(modalBox.getBounds().left+66, modalBox.bottom-355, 'trophy');
            var trophy = this.add.sprite(modalBox.getBounds().left + 210, modalBox.getBounds().bottom - 215, 'try-again-trophy');
            trophy.setScale(0.5, 0.5);
            trophy.setOrigin(0.5, 0.5);
            trophy.alpha = 0;
            this.tweens.add({
                targets: trophy,
                scaleX: 1,
                scaleY: 1,
                duration: 400,
                ease: Phaser.Math.Easing.Linear
            });
            this.tweens.add({
                targets: trophy,
                alpha: 1,
                duration: 400,
                ease: Phaser.Math.Easing.Linear
            });
            // game.add.tween(trophy.scale).to({ x: 1, y: 1 }, 400, Phaser.Easing.Linear.None, true);
            // game.add.tween(trophy).to({ alpha: 1 }, 400, Phaser.Easing.Linear.None, true);

            var backToMenuButton = this.add.sprite(modalBox.getBounds().left + 332, modalBox.getBounds().bottom - 89, 'assets', 'back-to-menu-button.png');
            backToMenuButton.setOrigin(0, 0)
            setupButton(backToMenuButton, 'back-to-menu-button.png', 'back-to-menu-button-hover.png');
            backToMenuButton.setInteractive({ cursor: 'pointer' });
            backToMenuButton.on('pointerup', this.backToMenu, this);
            var playAgainButton = this.add.sprite(modalBox.getBounds().left + 479, modalBox.getBounds().bottom - 89, 'assets', 'play-again-button.png');
            playAgainButton.setOrigin(0, 0)
            setupButton(playAgainButton, 'play-again-button.png', 'play-again-button-hover.png');
            playAgainButton.setInteractive({ cursor: 'pointer' });
            playAgainButton.on('pointerup', this.playAgain, this);

            backToMenuButton.on('pointerover', this.playHoverSound, this);
            backToMenuButton.on('pointerdown', this.playSelectionSound, this);

            playAgainButton.on('pointerover', this.playHoverSound, this);
            playAgainButton.on('pointerdown', this.playSelectionSound, this);
        },

        backToMenu: function () {
            console.log('back to menu button clicked');
            this.tryAgainSound.stop();
            window.angularComponentRef.backToMenu();
        },
        playAgain: function () {
            console.log('play again button clicked');
            this.tryAgainSound.stop()
            this.scene.start("StartGame");//this.game.state.start('StartGame', true, false);
        },
        playHoverSound: function () {
            this.hoverSound.play();
        },
        playSelectionSound: function () {
            this.selectionSound.play();
        }
    };

    //main
    game = new Phaser.Game({
        type: Phaser.AUTO,
        width: 980,
        height: 600,
        parent: 'game-container',
        dom: {
            createContainer: false
        },
        scale: {
            mode: Phaser.Scale.NONE,
            // autoCenter: Phaser.Scale.CENTER_BOTH
        },
        transparent: true,
        scene: {
            create: () => {
                game.scene.add("Boot", boot, false);//game.state.add("Boot", boot);
                game.scene.add("StartGame", startgame);//game.state.add("StartGame", startgame);
                game.scene.add("ResumeGame", resumegame);//game.state.add("ResumeGame", resumegame);
                game.scene.add("Questions", questions);//game.state.add("Questions", questions);
                game.scene.add("EndGame", endgame);//game.state.add("EndGame", endgame);
                game.scene.add("TryGame", trygame);//game.state.add("TryGame", trygame);

                game.scene.start("Boot");//game.state.start("Boot");
            }
        }
    });
}
function destroySoundSearch() {
    if (game)
        game.destroy();
}

var game;
function findTheLetter(json) {
    var currentQuestionIndex = 0;

    function setupButton(btn, frame_pointerdown, frame_pointerover, frame_pointerout, frame_pointerup, textureBased) {
        if (typeof frame_pointerout === "undefined") frame_pointerout = frame_pointerdown;
        if (typeof frame_pointerup === "undefined") frame_pointerup = frame_pointerdown;

        btn['frame_pointerdown'] = frame_pointerdown;
        btn['frame_pointerover'] = frame_pointerover;
        btn['frame_pointerout'] = frame_pointerout;
        btn['frame_pointerup'] = frame_pointerup;

        if (!btn["alreadySetupEvents"]) {
            btn["alreadySetupEvents"] = true;
            let fn = textureBased ? "setTexture" : "setFrame";
            btn.on('pointerdown', () => { btn[fn](btn['frame_pointerdown']); });
            btn.on('pointerover', () => { btn[fn](btn['frame_pointerover']); });
            btn.on('pointerout', () => { btn[fn](btn['frame_pointerout']); });
            btn.on('pointerup', () => { btn[fn](btn['frame_pointerup']); });
        }
    };

    //boot
    var boot = function (game) {
        console.log('%cBoot', 'color:white; background:red');
    };

    boot.prototype = {
        init: function () {
            this.apiData = json;

            //fix input
            this.game.scale.transformX = (pageX) => {
                let offsetLeft = 0;
                let parentElement = this.game.canvas.parentElement;
                while (parentElement) {
                    if (parentElement.offsetLeft) {
                        offsetLeft = parentElement.offsetLeft;
                        break;
                    }
                    parentElement = parentElement.parentElement;
                }
                return (pageX - offsetLeft) * this.game.scale.displayScale.x;
            };
            this.game.scale.transformY = (pageY) => {
                let offsetTop = 0;
                let parentElement = this.game.canvas.parentElement;
                while (parentElement) {
                    if (parentElement.offsetTop) {
                        offsetTop = parentElement.offsetTop;
                        break;
                    }
                    parentElement = parentElement.parentElement;
                }
                return (pageY - offsetTop) * this.game.scale.displayScale.y;
            };
        },
        preload: function () {
            this.load.atlas('assets', 'assets/games/find-the-letter/assets.png', 'assets/games/find-the-letter/assets.json');
            this.load.atlas('soundBtn', 'assets/qa/sound-icon/sound-btn-spritesheet.png', 'assets/qa/sound-icon/sound-btn-spritesheet.json');

            // if (this.apiData.bgImage) {
            //     this.load.image('bg-image', this.apiData.bgImage);
            // } else {
            this.load.image('bg-image', 'assets/games/find-the-letter/img/Background.png');
            // }

            this.load.image('Board R', 'assets/games/find-the-letter/img/Board R.png');
            this.load.image('PaperCorrect', 'assets/games/find-the-letter/img/PaperCorrect.png');
            this.load.image('PaperNormal', 'assets/games/find-the-letter/img/PaperNormal.png');
            this.load.image('PaperWrong', 'assets/games/find-the-letter/img/PaperWrong.png');
            this.load.image('Normal Sound Button', 'assets/games/find-the-letter/img/Normal Sound Button.png');
            this.load.image('Hover Sound Button', 'assets/games/find-the-letter/img/Hover Sound Button.png');

            this.load.image('red-arrow-image', 'assets/images/red-arrow.png');
            this.load.spritesheet('idle_default', 'assets/games/find-the-letter/spritesheets/new/Idle_sheet.png', { frameWidth: 320, frameHeight: 411, endFrame: 32 });
            this.load.spritesheet('idle_no', 'assets/games/find-the-letter/spritesheets/No_sheet.png', { frameWidth: 320, frameHeight: 411, endFrame: 32 });
            this.load.spritesheet('idle_yes', 'assets/games/find-the-letter/spritesheets/Yes_sheet.png', { frameWidth: 320, frameHeight: 411, endFrame: 32 });

            this.cache.binary.add('questions', this.apiData.questions);
            this.cache.binary.add('instruction', this.apiData.instruction);
            // this.load.json('complete', location.origin + '/data/complete.json');
            this.cache.binary.add('totalPoints', '0');
            this.cache.binary.add('qAnsPoints', {
                correctAnsPoint: 2,
                secTimeCorrectAnsPoint: 0,
                wrongAnsPoint: 0
            });
            //67x172 = 38.9%
            // if (this.apiData.instruction && this.apiData.instruction.b_image) {
            //     this.load.image('instruction-bg', location.origin + '/uploads/images/activity/instruction/' + this.apiData.instruction.b_image);
            // } else {
            //     this.load.image('instruction-bg', '/images/modal-bg-1.png');
            // }
            this.load.image('instruction-bg', 'assets/games/find-the-letter/img/modal-bg-1.png');
            this.load.image('completion-bg', 'assets/games/find-the-letter/img/complete-page-bg.jpg');
            this.load.image('try-again-bg', 'assets/games/find-the-letter/img/Try-again-bg.jpg');
            this.load.image('try-again-trophy', 'assets/games/find-the-letter/img/Try-again-trophy-w-bg.png');
            this.load.image('complete-trophy', 'assets/games/find-the-letter/img/complete-trophy.png');

            this.load.image('modal-overlay', 'assets/games/find-the-letter/img/modal-overlay.png');

            this.load.audio('yes', 'assets/games/find-the-letter/sounds/Yes.mp3');
            this.load.audio('noCorrectAnswerThis', 'assets/games/find-the-letter/sounds/no.mp3');
            this.load.audio('chooseAnswerSound', 'assets/games/find-the-letter/sounds/chooseAnswerSound.wav');

            if (this.apiData.complete && this.apiData.complete.audios && this.apiData.complete.audios.length > 0) {
                var index = Math.floor(Math.random() * Math.floor(this.apiData.complete.audios.length));
                this.load.audio('completionSound', this.apiData.complete.audios[index]);
            }
            else {
                this.load.audio('completionSound', 'assets/games/find-the-letter/sounds/viktory.wav');
            }



            this.load.audio('tryAgainSound', 'assets/games/find-the-letter/sounds/fail.mp3');
            this.load.audio('bg-music', this.apiData.bgAudio);

            this.load.audio('selectionSound', 'assets/sounds/selection.mp3');
            this.load.audio('hoverSound', 'assets/sounds/button_hover.mp3');
            this.load.audio('exitSound', 'assets/sounds/warning-pop-up.mp3');
        },
        create: function () {

            this.isMobile = !this.game.device.desktop;
            // this.scale.scaleMode = Phaser.ScaleManager.USER_SCALE;
            // if (this.isMobile) {
            //     this.scaleGame();
            //     this.scale.setResizeCallback(this.scaleGame);
            // }
            //Local storing
            if (window.localStorage.getItem('currentState')) {
                window.localStorage.removeItem('currentState');
                // this.game.state.start('ResumeGame', true, false, window.localStorage.getItem('currentState'));
            }
            this.scene.start("StartGame");//this.game.state.start('StartGame', true, false);
        },

        scaleGame: function () {
            const padding = this.isMobile ? 0 : 0; // include padding around the canvas frame for desktop
            const parentWidth = document.getElementById('game-container').offsetWidth;
            const xScale = (parentWidth - padding) / this.game.width;
            const scalePoint = Math.min(xScale, 1);
            // if (this.scale) {
            //     this.scale.setUserScale(scalePoint, scalePoint);
            // }
        }
    };

    //startGame
    var startgame = function (game) {
        console.log('%cStartGame', 'color:white; background:blue');
    };

    startgame.prototype = {
        init: function () {
            this.goUp = false;
            var storage = {
                questions: [],
                currentPoints: 0
            };
            window.localStorage.setItem('payload', JSON.stringify(storage));
        },
        preload: function () {
            this.fData = this.cache.binary.get('instruction')
            this.load.audio('startSound', 'assets/games/find-the-letter/sounds/instruction.mp3');

            //answer images and sounds
            var self = this;
            this.questionData = { questions: this.cache.binary.get('questions') };
            console.log('this.questionData.questions', this.questionData.questions);
            for (var i = 0; i < this.questionData.questions.length; i++) {
                this.questionData.questions[i].answers.forEach(function (answer, _i) {
                    self.load.image('letter_img_default_' + i + '_' + _i, "assets/games/find-the-letter/img/answers/" + answer.letter_img_default + ".png");
                    self.load.image('letter_img_hover_' + i + '_' + _i, "assets/games/find-the-letter/img/answers/" + answer.letter_img_default + ".png");
                });
                var soundName = this.questionData.questions[i].questionAudioName;
                if (soundName) {
                    this.load.audio('questionSound_' + i, "assets/games/find-the-letter/sounds/questions/" + soundName + ".mp3");
                }
            }
        },
        update: function () {
            if (this.redArrowImage) {
                if (this.goUp) {
                    this.redArrowImage.y -= 1;
                    if (this.redArrowImage.y <= -4) {
                        this.goUp = false
                    }
                } else {
                    this.redArrowImage.y += 1;
                    if (this.redArrowImage.y >= 18) {
                        this.goUp = true;
                    }
                }
            }
        },
        create: function () {
            window.angularComponentRef.loadingFinished();
            this.setupState();

            this.addSounds();

            this.playQuestionSound();

            var modalTextStyle = {
                backgroundColor: 'transparent',
                stroke: '#ffffff',
                strokeThickness: 2,
                fontFamily: 'Kids Rock DEMO',
                fontSize: 30,
                color: '#43425d',
                wordWrap: true,
                align: 'center'
            };

            var modalHeaderStyle = {
                backgroundColor: 'transparent',
                stroke: '#ffffff',
                strokeThickness: 16,
                fontFamily: 'Kids Rock DEMO',
                fontSize: 50,
                wordWrap: false,
                align: 'center'
            };

            this.add.sprite(0, 0, 'instruction-bg').setOrigin(0, 0);

            this.modal = this.add.container();

            var modalBox = this.add.sprite(this.game.scale.width / 2, this.game.scale.height / 2, 'assets', 'activity-Instruction-board.png');
            modalBox.setOrigin(0.5, 0.5);

            this.modalHeaderGroup = this.add.container();
            var modalBoxHeader = this.add.sprite(0, 0, 'assets', 'activity-Instruction-board-header.png');
            modalBoxHeader.setOrigin(0, 0);

            var modalHeaderText = this.add.text(0, 0, "Word Hunt", modalHeaderStyle);
            if (!(this.game.device.mobileSafari || this.game.device.safari)) {
                modalHeaderText.setShadow(3, 3, '#43425d', 0, false, true);
            }
            var grd = modalHeaderText.context.createLinearGradient(0, 0, 0, modalHeaderText.height);
            grd.addColorStop(0, '#edee62');
            grd.addColorStop(0.2, '#edee62');
            grd.addColorStop(0.7, '#dd7b33');
            modalHeaderText.setFill(grd);

            modalHeaderText.setOrigin(0, 0);

            var bgSoundButton = this.add.sprite(0, 0, 'soundBtn', 'introduction-sound_02.png');
            bgSoundButton.setOrigin(0, 0);
            bgSoundButton.on('pointerup', function () {
                if (this.redArrowImage) {
                    this.redArrowImage.alpha = 0;
                }
                this.playQuestionSound()
            }, this);

            setupButton(bgSoundButton, 'introduction-sound_02.png', 'introduction-sound_01.png');
            bgSoundButton.setInteractive({ cursor: 'pointer' });

            bgSoundButton.on('pointerover', this.playHoverSound, this);
            bgSoundButton.on('pointerdown', this.playSelectionSound, this);

            this.modalHeaderGroup.add(modalBoxHeader);
            this.modalHeaderGroup.add(modalHeaderText);
            this.modalHeaderGroup.add(bgSoundButton);
            this.modalHeaderGroup.setPosition((modalBox.width - modalBoxHeader.width) / 2 + modalBox.getBounds().left, modalBox.getBounds().top - 21);

            if (this.game.device.os.iOS) {
                this.redArrowImage = this.add.sprite(0, 0, 'red-arrow-image');
                this.modalHeaderGroup.add(this.redArrowImage);
            }

            modalHeaderText.setPosition(modalBoxHeader.getCenter().x, modalBoxHeader.getCenter().y);
            modalHeaderText.setOrigin(0.5, 0.5);
            modalBoxHeader.setPosition(this.modalHeaderGroup.getBounds().left, this.modalHeaderGroup.getBounds().top);
            bgSoundButton.setPosition(modalBoxHeader.getCenter().x + 30, modalBoxHeader.getCenter().y - 40);

            if (this.game.device.os.iOS) {
                this.redArrowImage.setPosition(modalBoxHeader.getCenter().x + 34, modalBoxHeader.getCenter().y - 110);
            }

            var modalText = this.add.text(this.game.scale.width / 2, this.game.scale.height / 2, "Tap on the right word", modalTextStyle);
            modalText.setWordWrapWidth(modalBox.width - 110);
            modalText.setOrigin(0.5, 0.5);

            var startButton = this.add.sprite(this.game.scale.width / 2, modalBox.getBounds().bottom - 103, 'assets', 'activity-Instruction-play-button.png');
            startButton.setOrigin(0, 0)
            startButton.on('pointerup', function () {
                console.log('startButton clicked');
                // if (!this.game.device.desktop) {
                //     this.game.scale.startFullScreen(false);
                // }
                this.fsound.stop();
                currentQuestionIndex = 0;
                this.scene.start("Questions");//this.game.state.start('Questions', true, false, 0);
                console.log('startButton clicked22');
            }, this);

            setupButton(startButton, 'activity-Instruction-play-button.png', 'activity-Instruction-play-button-hover.png');
            startButton.setInteractive({ cursor: 'pointer' });

            startButton.on('pointerover', this.playHoverSound, this);
            startButton.on('pointerdown', this.playSelectionSound, this);
            startButton.setOrigin(0.5, 0.5);

            var leavesRightSprite = this.add.sprite(0, 0, 'assets', 'leaves.png');
            leavesRightSprite.setPosition(modalBox.right - 145, modalBox.getBounds().top + 15);

            var leavesLeftSprite = this.add.sprite(0, 0, 'assets', 'leaves.png');
            leavesLeftSprite.setOrigin(0.5, 0.5);
            leavesLeftSprite.scaleX *= -1;
            leavesLeftSprite.setPosition(modalBox.getBounds().left + 34, modalBox.getBounds().bottom - 140);


            this.modal.add(leavesLeftSprite);
            this.modal.add(leavesRightSprite);
            this.modal.add(modalBox);
            this.modal.add(modalBoxHeader);
            this.modal.add(modalText);
            this.modal.add(startButton);
        },

        setupState: function () {
            // this.game.scale.fullScreenScaleMode = Phaser.ScaleManager.SHOW_ALL;

            // this.game.stage.disableVisibilityChange = true; // keep animation run on focus out
            // this.scale.pageAlignHorizontally = true;

            // this.scale.pageAlignVertically = true;
        },

        addSounds: function () {
            this.fsound = this.sound.add('startSound');
            this.hoverSound = this.sound.add('hoverSound');
            this.selectionSound = this.sound.add('selectionSound');
            // this.game.time.events.add(Phaser.Timer.SECOND * 2, this.playQuestionSound, this);
        },
        playHoverSound: function () {
            this.hoverSound.play();
        },
        playSelectionSound: function () {
            this.selectionSound.play();
        },

        playQuestionSound: function () {
            this.fsound.play();
        }
    };

    //endGame
    var endgame = function (game) {
        console.log("%cEndGame", "color:white; background:blue");
    };

    endgame.prototype = {
        init: function () {
            this.saveActivityAns();
        },
        preload: function () {
            this.totalPoints = window.angularComponentRef.getTotalScore();
            // this.fData = this.cache.binary.get('complete')
        },
        create: function () {
            if (!this.completionSound) {
                this.completionSound = this.sound.add('completionSound');
            }
            this.completionSound.play();
            this.hoverSound = this.sound.add('hoverSound');
            this.selectionSound = this.sound.add('selectionSound');

            window.localStorage.removeItem('currentState');
            window.localStorage.removeItem('wrongButtonKey');

            var storageJson = window.localStorage.getItem('payload');
            var storage = JSON.parse(storageJson);
            var currentPoints = 0;
            if (storage) {
                currentPoints = storage.currentPoints || 0;
            }
            // this.scale.pageAlignHorizontally = true;
            // this.scale.pageAlignVertically = true;

            this.add.sprite(0, 0, 'completion-bg').setOrigin(0, 0);

            // this.game.stage.disableVisibilityChange = true; // keep animation run on focus out

            var totalScoreTextStyle = {
                backgroundColor: 'transparent',
                stroke: '#91301a',
                strokeThickness: 6,
                fontFamily: 'Kids Rock DEMO',
                fontSize: 39,
                wordWrap: false,
                align: 'left'
            };
            var totalScoreTextStyleOutline = {
                backgroundColor: 'transparent',
                stroke: '#fff',
                strokeThickness: 12,
                fontFamily: 'Kids Rock DEMO',
                fontSize: 39,
                wordWrap: false,
                align: 'left'
            };
            var collectedPointsTextStyle = {
                backgroundColor: 'transparent',
                stroke: '#91301a',
                strokeThickness: 2,
                fontFamily: 'Kids Rock DEMO',
                fontSize: 25,
                wordWrap: false,
                align: 'left',
                color: '#ffffff'
            };

            var modalBox = this.add.sprite(this.game.scale.width / 2, this.game.scale.height / 2, 'assets', 'activity-Instruction-board.png');
            modalBox.setOrigin(0.5, 0.5);
            var completeRibbon = this.add.sprite(modalBox.getCenter().x, modalBox.getBounds().top + 222, 'assets', 'complete-ribbon-full.png');
            completeRibbon.setOrigin(0.5, 0.5);

            var totalScoreOutline = this.add.text(modalBox.getBounds().left + 340, modalBox.getBounds().bottom - 302, "Total Score: " + " " + this.totalPoints, totalScoreTextStyleOutline);
            var totalScore = this.add.text(modalBox.getBounds().left + 342, modalBox.getBounds().bottom - 300, "Total Score: " + " " + this.totalPoints, totalScoreTextStyle);

            var grd = totalScore.context.createLinearGradient(0, 0, 0, totalScore.height);
            grd.addColorStop(0, '#f4fa38');
            grd.addColorStop(0.3, '#edee62');
            grd.addColorStop(0.7, '#dd7b33');
            totalScore.setFill(grd);

            var collectedPointsMedal = this.add.sprite(modalBox.getBounds().left + 324, modalBox.getBounds().bottom - 244, 'assets', 'collected-poins-medal.png');
            collectedPointsMedal.setOrigin(0, 0)
            var collectedPoints = this.add.text(modalBox.getBounds().left + 422, modalBox.getBounds().bottom - 204, "+" + currentPoints, collectedPointsTextStyle);

            var trophy = this.add.sprite(modalBox.getBounds().left + 210, modalBox.getBounds().bottom - 215, 'complete-trophy');
            trophy.setScale(0.5, 0.5);
            trophy.setOrigin(0.5, 0.5);
            trophy.alpha = 0;
            this.tweens.add({
                targets: trophy,
                scaleX: 1,
                scaleY: 1,
                duration: 400,
                ease: Phaser.Math.Easing.Linear
            });
            this.tweens.add({
                targets: trophy,
                alpha: 1,
                duration: 400,
                ease: Phaser.Math.Easing.Linear
            });

            var backToMenuButton = this.add.sprite(modalBox.getBounds().left + 332, modalBox.getBounds().bottom - 89, 'assets', 'back-to-menu-button.png');
            backToMenuButton.setOrigin(0, 0)
            setupButton(backToMenuButton, 'back-to-menu-button.png', 'back-to-menu-button-hover.png');
            backToMenuButton.setInteractive({ cursor: 'pointer' });
            backToMenuButton.on('pointerup', this.backToMenu, this);

            var playAgainButton = this.add.sprite(modalBox.getBounds().left + 479, modalBox.getBounds().bottom - 89, 'assets', 'play-again-button.png');
            playAgainButton.setOrigin(0, 0)
            setupButton(playAgainButton, 'play-again-button.png', 'play-again-button-hover.png');
            playAgainButton.setInteractive({ cursor: 'pointer' });
            playAgainButton.on('pointerup', this.playAgain, this);

            var nextActivityButton = this.add.sprite(modalBox.getBounds().left + 626, modalBox.getBounds().bottom - 89, 'assets', 'next-activity-button.png');
            nextActivityButton.setOrigin(0, 0)
            setupButton(nextActivityButton, 'next-activity-button.png', 'next-activity-button-hover.png');
            nextActivityButton.setInteractive({ cursor: 'pointer' });
            nextActivityButton.on('pointerup', this.nextActivity, this);

            backToMenuButton.on('pointerover', this.playHoverSound, this);
            backToMenuButton.on('pointerdown', this.playSelectionSound, this);

            playAgainButton.on('pointerover', this.playHoverSound, this);
            playAgainButton.on('pointerdown', this.playSelectionSound, this);

            nextActivityButton.on('pointerover', this.playHoverSound, this);
            nextActivityButton.on('pointerdown', this.playSelectionSound, this);
        },

        backToMenu: function () {
            console.log('back to menu button clicked');
            this.completionSound.stop();
            window.angularComponentRef.backToMenu();
        },
        playAgain: function () {
            console.log('play again button clicked');
            this.completionSound.stop()
            this.scene.start('StartGame');
        },
        nextActivity: function () {
            console.log('next activity button clicked');
            window.angularComponentRef.nextActivity();
            // this.game.state.start('StartGame', true, false);
        },

        formatTime: function (s) {
            var minutes = "0" + Math.floor(s / 60);
            var seconds = "0" + (s - minutes * 60);
            return minutes.substr(-2) + ":" + seconds.substr(-2);
        },

        playHoverSound: function () {
            this.hoverSound.play();
        },
        playSelectionSound: function () {
            this.selectionSound.play();
        },

        saveActivityAns: function () {
            var storageJson = window.localStorage.getItem('payload');
            var storage = JSON.parse(storageJson);
            var _obj = {
                activity_id: 1,
                country_id: 1,
                zone_id: 1,
                continent_id: 1,
                totalScore: 0,
                questions: []
            }
            if (storage) {
                for (var i = 0; i < storage.questions.length; i++) {
                    var questionKey = storage.questions[i].questionKey;
                    var answerKey = storage.questions[i].answerKey;
                    var attempts = storage.questions[i].attempts;
                    var points = storage.questions[i].points;
                    var question = {
                        [questionKey]: {
                            [answerKey]: {
                                try_count: attempts,
                                score: points
                            }
                        }
                    }
                    _obj.questions.push(question);
                    _obj.totalScore += points
                }
                window.angularComponentRef.gameFinish(_obj);
            }
        }
    };


    //startGame
    var resumegame = function (game) {
        console.log("%cStartGame", "color:white; background:blue");
    };

    resumegame.prototype = {
        init: function (/*currentQuestionIndex*/) {
            // this.currentQuestionIndex = currentQuestionIndex;
            this.fData = { questions: this.cache.binary.get('questions') };
        },
        create: function () {
            // this.scale.pageAlignHorizontally = true;
            // this.scale.pageAlignVertically = true;

            this.hoverSound = this.fsound.add('hoverSound');
            this.selectionSound = this.sound.add('selectionSound');

            this.add.sprite(0, 0, 'bg-image').setOrigin(0, 0);

            // this.game.stage.disableVisibilityChange = true; // keep animation run on focus out

            var startButton = this.add.sprite(this.game.scale.width / 2, this.game.scale.height / 2, 'assets', 'next-button.png');
            startButton.setOrigin(0, 0)
            setupButton(startButton, 'next-button.png', 'next-button-hover.png');
            startButton.setInteractive({ cursor: 'pointer' });

            startButton.on('pointerup', function () {
                if (currentQuestionIndex < this.fData.questions.length) {
                    this.scene.start("Questions");//this.game.state.start("Questions", true, false, this.currentQuestionIndex);
                } else {
                    this.scene.start("EndGame");//this.game.state.start("EndGame", true, false);
                }
            }, this);

            startButton.on('pointerover', this.playHoverSound, this);
            startButton.on('pointerdown', this.playSelectionSound, this);
            startButton.setOrigin(0.5, 0.5);

            var style = {
                backgroundColor: 'transparent',
                stroke: '#074a83',
                strokeThickness: 6,
                fontFamily: "Kids Rock DEMO",
                fontSize: 40,
                color: "#ffffff",
                wordWrap: false,
                align: "left"
            };
            var startButtonText = this.add.text(this.game.scale.width / 2, this.game.scale.height / 2 - 100, 'Resume quiz', style);
            startButtonText.setOrigin(0.5, 0.5);
        },
        playHoverSound: function () {
            this.hoverSound.play();
        },
        playSelectionSound: function () {
            this.selectionSound.play();
        }
    };


    //questions
    var questions = function (game) {
        console.log("%cQuestions", "color:white; background:blue");
    };

    questions.prototype = {
        init: function (/*currentQuestionIndex*/) {
            // this.currentQuestionIndex = currentQuestionIndex || 0;
            this.wrongAnswersCount = 0;
            this.maxWrongAnswers = 1;
            window.localStorage.setItem('currentState', currentQuestionIndex);
        },
        preload: function () {
            this.fData = { questions: this.cache.binary.get('questions') };
            this.qAnsPoints = this.cache.binary.get('qAnsPoints');

        },
        create: function () {
            if (!this.bgMusic) {
                this.bgMusic = this.sound.add('bg-music', 1, true);
                this.bgMusic.play();
            }
            else {
                if (!this.bgMusic.isPlaying) {
                    this.bgMusic.play();
                }
            }

            this.questionItem = this.fData.questions[currentQuestionIndex];

            this.drawBg();

            this.drawPuppet();

            this.drawStaticScene(this.questionItem.answers, this.questionItem.answer);

            this.drawStarPoints();

            this.addSounds();

            this.addEvents();

            this.addPlayQuestionButton();

            this.exitButton();

            this.exitModal();
        },
        drawStaticScene: function (answers, rightAnswerIndex) {
            this.add.sprite(395, 330, 'Board R');

            var optionBoardMarginTop = 235;
            var optionLetterMarginLeft = 0;


            var positionsPaper = [{ x: 200, y: 367 }, { x: 343, y: 138 }, { x: 522, y: 365 }];

            var positions = [{ x: 134, y: 367 }, { x: 340, y: 138 }, { x: 520, y: 365 }];

            var p1 = positions[0];

            var paper = this.add.sprite(positionsPaper[0].x, positionsPaper[0].y, 'PaperNormal');

            var isRightAnswer = (0 === rightAnswerIndex)
            this.optionPaperBtnA = this.add.sprite(p1.x, p1.y/*0, optionBoardMarginTop*/, 'letter_img_default_' + currentQuestionIndex + '_' + '0')
            this.optionPaperBtnA.setOrigin(0.5, 0.5)
            setupButton(this.optionPaperBtnA, 'letter_img_default_' + currentQuestionIndex + '_' + '0', 'letter_img_hover_' + currentQuestionIndex + '_' + '0', 'letter_img_default_' + currentQuestionIndex + '_' + '0', undefined, true);
            this.optionPaperBtnA.setInteractive({ cursor: 'pointer' });
            this.optionPaperBtnA["context"] = this;
            this.optionPaperBtnA["btnIndex"] = 0;
            this.optionPaperBtnA["isRightAnswer"] = isRightAnswer;
            this.optionPaperBtnA.on('pointerup', this.onClickAnswerButton, this.optionPaperBtnA);
            this.optionPaperBtnA.on('pointerover', this.playHoverSound, this);
            this.optionPaperBtnA.on('pointerdown', this.playSelectionSound, this);
            // this.optionPaperBtnA.setScale(0.75)
            this.optionPaperBtnA["paperBack"] = paper;
            // this.optionPaperBtnA.height = 200*0.7
            // this.optionPaperBtnA.width = 113*0.7

            window["this.optionPaperBtnA"] = this.optionPaperBtnA;

            var p2 = positions[1];
            var paper = this.add.sprite(positionsPaper[1].x, positionsPaper[1].y, 'PaperNormal');
            paper.setOrigin(0.25, 0.5);

            isRightAnswer = (1 === rightAnswerIndex)
            this.optionPaperBtnB = this.add.sprite(p2.x, p2.y/*this.optionPaperBtnA.getBounds().right + optionLetterMarginLeft, optionBoardMarginTop*/, 'letter_img_default_' + currentQuestionIndex + '_' + '1')
            this.optionPaperBtnB.setOrigin(0.5, 0.5)
            setupButton(this.optionPaperBtnB, 'letter_img_default_' + currentQuestionIndex + '_' + '1', 'letter_img_hover_' + currentQuestionIndex + '_' + '1', 'letter_img_default_' + currentQuestionIndex + '_' + '1', undefined, true);
            this.optionPaperBtnB.setInteractive({ cursor: 'pointer' });
            this.optionPaperBtnB["context"] = this;
            this.optionPaperBtnB["btnIndex"] = 1;
            this.optionPaperBtnB["isRightAnswer"] = isRightAnswer;
            this.optionPaperBtnB.on('pointerup', this.onClickAnswerButton, this.optionPaperBtnB);
            this.optionPaperBtnB.on('pointerover', this.playHoverSound, this);
            this.optionPaperBtnB.on('pointerdown', this.playSelectionSound, this);
            // this.optionPaperBtnB.setScale(0.75)
            this.optionPaperBtnB["paperBack"] = paper;
            // this.optionPaperBtnB.height = 200*0.7
            // this.optionPaperBtnB.width = 113*0.7

            window["this.optionPaperBtnB"] = this.optionPaperBtnB;

            var p3 = positions[2];
            var paper = this.add.sprite(positionsPaper[2].x, positionsPaper[2].y, 'PaperNormal');
            paper.setOrigin(0.25, 0.5);

            isRightAnswer = (2 === rightAnswerIndex)
            this.optionPaperBtnC = this.add.sprite(p3.x, p3.y/*this.optionPaperBtnB.getBounds().right + optionLetterMarginLeft, optionBoardMarginTop*/, 'letter_img_default_' + currentQuestionIndex + '_' + '2')
            this.optionPaperBtnC.setOrigin(0.5, 0.5)
            setupButton(this.optionPaperBtnC, 'letter_img_default_' + currentQuestionIndex + '_' + '2', 'letter_img_hover_' + currentQuestionIndex + '_' + '2', 'letter_img_default_' + currentQuestionIndex + '_' + '2', undefined, true);
            this.optionPaperBtnC.setInteractive({ cursor: 'pointer' });
            this.optionPaperBtnC["context"] = this;
            this.optionPaperBtnC["btnIndex"] = 2;
            this.optionPaperBtnC["isRightAnswer"] = isRightAnswer;
            this.optionPaperBtnC.on('pointerup', this.onClickAnswerButton, this.optionPaperBtnC);
            this.optionPaperBtnC.on('pointerover', this.playHoverSound, this);
            this.optionPaperBtnC.on('pointerdown', this.playSelectionSound, this);
            // this.optionPaperBtnC.setScale(0.75)
            this.optionPaperBtnC["paperBack"] = paper;
            // this.optionPaperBtnC.height = 200*0.7
            // this.optionPaperBtnC.width = 113*0.7
            window["this.optionPaperBtnC"] = this.optionPaperBtnC;
            var letterGroup = this.add.container()
            letterGroup.add(this.optionPaperBtnA)
            letterGroup.add(this.optionPaperBtnB)
            letterGroup.add(this.optionPaperBtnC)

            var letterBoxWidth = letterGroup.getBounds().width + optionLetterMarginLeft * 2
            var letterBoardLeftPositionStart = 305;
            var letterBoxPositionX = 325 - letterBoxWidth / 2
            letterGroup.setPosition(letterBoxPositionX, 0);

            this.disableButtons();
        },
        disableButtons: function () {
            console.log("disableButtons")
            // if (this.optionPaperBtnA.game) {
            this.optionPaperBtnA.disableInteractive();
            this.optionPaperBtnB.disableInteractive();
            this.optionPaperBtnC.disableInteractive();
            // }

        },
        enableButtons: function () {
            console.log("enableButtons")
            // if (this.optionPaperBtnA.game) {
            this.optionPaperBtnA.setInteractive({ cursor: 'pointer' });
            this.optionPaperBtnB.setInteractive({ cursor: 'pointer' });
            this.optionPaperBtnC.setInteractive({ cursor: 'pointer' });
            // }
        },
        drawBg: function () {
            this.bg = this.add.sprite(0, 0, 'bg-image')
            this.bg.setOrigin(0, 0)
        },
        drawStarPoints: function () {
            var starMargin = 12
            var starWidth = 33

            var starGroup = this.add.container()
            this.starWrongGroup = this.add.container()
            this.starActiveGroup = this.add.container()
            var starPosX = 85
            var starPosY = 526

            var storageJson = window.localStorage.getItem('payload');
            var storage = JSON.parse(storageJson);

            for (var i = 0; i < this.fData.questions.length; i++) {
                var star = this.add.sprite(starPosX, starPosY, 'assets', 'point-default.png')
                star.setOrigin(0, 0)
                var starActive = this.add.sprite(starPosX, starPosY, 'assets', 'point-right.png')
                starActive.setOrigin(0, 0)
                var starWrong = this.add.sprite(starPosX, starPosY, 'assets', 'point-wrong.png')
                starWrong.setOrigin(0, 0)
                starActive.alpha = 0;
                starWrong.alpha = 0;
                starPosX += starWidth + starMargin
                starGroup.add(star)
                this.starActiveGroup.add(starActive)
                this.starWrongGroup.add(starWrong);
                if (storage.questions[i] && storage.questions[i].correctAnswer) {
                    this.setStar(i, 1)
                } else if (storage.questions[i] && !storage.questions[i].correctAnswer) {
                    this.setStarWrong(i)
                }
            }
        },
        setStar: function (index, alpha) {
            this.starActiveGroup.getAt(index).alpha = alpha
        },
        setStarWrong: function (index) {
            this.starActiveGroup.getAt(index).alpha = 0;
            this.starWrongGroup.getAt(index).alpha = 1;
        },
        onClickAnswerButton: function (button, event) {
            var button = this;
            var context = this.context;
            context.puppetIdle.anims.stop();
            // context.questionSoundEvent.remove(false);//context.game.time.events.remove(context.questionSoundEvent);
            // if (context.chooseAnswerEvent) {
            // context.chooseAnswerEvent.remove(false);//context.game.time.events.remove(context.chooseAnswerEvent);
            // }
            if (context.sound && context.sound.isPlaying) {
                context.sound.stop();
            }
            if (context.chooseAnswerSound && context.chooseAnswerSound.isPlaying) {
                context.chooseAnswerSound.stop();
            }
            var storage = window.localStorage.getItem('payload');
            storage = JSON.parse(storage);

            var questionIdx;
            if (storage) {
                var question;
                for (var i = 0; i < storage.questions.length; i++) {
                    var item = storage.questions[i];
                    if (context.questionItem.key === item.questionKey) {
                        question = item;
                        questionIdx = i;
                        break;
                    }
                }
                if (question) {
                    question.attempts = question.attempts + 1;
                    question.correctAnswer = this.isRightAnswer;
                    storage.questions[questionIdx] = question;
                } else {
                    question = {
                        questionKey: context.questionItem.key,
                        correctAnswer: this.isRightAnswer,
                        attempts: 1
                    };
                    storage.questions.push(question)
                }
            }
            var points = 0;

            context.optionPaperBtnA.disableInteractive();
            context.optionPaperBtnB.disableInteractive();
            context.optionPaperBtnC.disableInteractive();

            var isEndGame = false;
            if (this.isRightAnswer) {
                if (context.wrongAnswersCount === 0) {
                    points = +context.qAnsPoints.correctAnsPoint;

                } else {
                    points = +context.qAnsPoints.secTimeCorrectAnsPoint;
                }
                isEndGame = true;

                // var correctAnsFrame = 'letter_img_right_' + currentQuestionIndex + '_' + this.btnIndex
                // setupButton(button, correctAnsFrame, correctAnsFrame);//button.loadTexture(correctAnsFrame)

                context.puppetNo.alpha = 0;
                context.puppetIdle.alpha = 0;
                context.puppetYes.alpha = 1;

                context.puppetNo.anims.stop();

                context.anims.create({
                    key: 'yesAnimate',
                    frames: context.anims.generateFrameNumbers('idle_yes', { start: 0, end: 31, first: 0 }),
                    frameRate: 20,
                    repeat: 0
                });
                context.puppetYes.play('yesAnimate');
                context.yesSound.play();

                context.addNewDefaultLoop();
                window.localStorage.setItem('currentState', +(currentQuestionIndex) + 1);
                // window.localStorage.removeItem('wrongButtonKey');
                context.setStar(currentQuestionIndex, 1)

                this["paperBack"].setTexture("PaperCorrect");
            } else {
                points = +context.qAnsPoints.secTimeCorrectAnsPoint;

                button.disableInteractive();

                context.puppetIdle.alpha = 0;
                context.puppetYes.alpha = 0;

                if (!this.clicked) {
                    this.clicked = true;
                    context.wrongAnswersCount++;
                }
                isEndGame = context.wrongAnswersCount === context.maxWrongAnswers;

                points = +context.qAnsPoints.wrongAnsPoint;

                context.puppetNo.alpha = 1;

                context.anims.create({
                    key: 'noAnimate',
                    frames: context.anims.generateFrameNumbers('idle_no', { start: 0, end: 31, first: 0 }),
                    frameRate: 20,
                    repeat: 0
                });
                context.puppetNo.play('noAnimate');

                context.noCorrectAnswerThis.play();
                if (isEndGame) {

                    window.localStorage.setItem('currentState', +(currentQuestionIndex) + 1);
                    // window.localStorage.removeItem('wrongButtonKey');
                } else {
                    // window.localStorage.setItem('wrongButtonKey', this.key);
                }
                // var wrongAnsFrame = 'letter_img_wrong_' + currentQuestionIndex + '_' + this.btnIndex
                // button.setFrames(wrongAnsFrame, wrongAnsFrame);
                // button.setTexture(wrongAnsFrame)
                // button.tint = 0xff00ff;
                context.setStarWrong(currentQuestionIndex);
                this["paperBack"].setTexture("PaperWrong");
            }
            context.disableButtons();
            if (storage) {
                if (isEndGame) {
                    storage.currentPoints = storage.currentPoints + points;
                    if (questionIdx) {
                        storage.questions[questionIdx].points = points;
                        storage.questions[questionIdx].answerKey = this.key;
                    } else {
                        storage.questions[currentQuestionIndex].points = points;
                        storage.questions[currentQuestionIndex].answerKey = this.key;
                    }
                }
                window.localStorage.setItem('payload', JSON.stringify(storage));
            }
        },
        drawPuppet: function () {
            var frameWidth = 320;
            var frameHeight = 411;
            var framePosX = 825;
            var framePosY = 350;

            this.puppetIdle = this.add.sprite(framePosX, framePosY, 'idle_default');
            this.puppetIdle.height = frameHeight;
            this.puppetIdle.width = frameWidth;
            window["this.puppetIdle"] = this.puppetIdle;
            // puppet no
            this.puppetNo = this.add.sprite(framePosX, framePosY, 'idle_no');
            this.puppetNo.height = frameHeight;
            this.puppetNo.width = frameWidth;
            this.puppetNo.alpha = 0;

            // puppet yes
            this.puppetYes = this.add.sprite(framePosX, framePosY, 'idle_yes');
            this.puppetYes.height = frameHeight;
            this.puppetYes.width = frameWidth;
            this.puppetYes.alpha = 0;

            var self = this;

            this.anims.create({
                key: 'idleAnimate',
                frames: this.anims.generateFrameNumbers('idle_default', { start: 0, end: 31, first: 0 }),
                frameRate: 20,
                repeat: -1
            });
            var a = this.puppetIdle.play('idleAnimate');
            this.puppetIdle.on('animationcomplete', function () {
                // self.puppetIdle.frame = 0;
            });

            this.anims.create({
                key: 'noAnimate',
                frames: this.anims.generateFrameNumbers('idle_no', { start: 0, end: 31, first: 0 }),
                frameRate: 20,
                repeat: 0
            });
            // this.puppetNoAnim = this.puppetNo.play('noAnimate');
            this.puppetNo.on('animationcomplete', function () {
                // self.puppetNo.frame = 0;
                setTimeout(function () {
                    self.onClickNextButton()
                }, 1000)
            });

            this.anims.create({
                key: 'yesAnimate',
                frames: this.anims.generateFrameNumbers('idle_yes', { start: 0, end: 31, first: 0 }),
                frameRate: 20,
                repeat: 0
            });
            // this.puppetYesAnim = this.puppetYes.play('yesAnimate');
            this.puppetYes.on('animationcomplete', function () {
                // self.puppetYes.frame = 0;
                setTimeout(function () {
                    self.onClickNextButton()
                }, 1000)
            });
        },
        addNewDefaultLoop: function () {
            if (this.defaultLoop) {
                this.time.clearPendingEvents();//this.game.time.events.clearPendingEvents();
                this.defaultLoop = this.time.addEvent({ delay: 1000 * 3, callback: this.payPuppet, callbackScope: this, loop: true });//this.defaultLoop = this.game.time.events.loop(Phaser.Timer.SECOND * 3, this.payPuppet, this);
            } else if (!this.defaultLoop) {
                this.defaultLoop = this.time.addEvent({ delay: 1000 * 3, callback: this.payPuppet, callbackScope: this, loop: true });//this.defaultLoop = this.game.time.events.loop(Phaser.Timer.SECOND * 3, this.payPuppet, this);
            }
        },
        playQuestionSound: function () {
            if (!this.fsound) {
                this.enableButtons();
                return;
            }
            this.fsound.play();
            var self = this;
            this.fsound.on('complete', function () {
                self.enableButtons()
                // self.questionSoundEvent.remove(false);//self.game.time.events.remove(self.questionSoundEvent);
                // self.chooseAnswerEvent.remove(false);//self.game.time.events.remove(self.chooseAnswerEvent);

                // self.questionSoundEvent = self.time.addEvent({ delay: 1000 * 10, callback: function () {
                //         this.playQuestionSound()
                //     }, callbackScope: this, loop: true });
            });
        },
        payPuppet: function () {
            if (this.puppetNo.anims.isPlaying
                || this.puppetYes.anims.isPlaying) {
                return
            }
            this.puppetNo.alpha = 0;
            this.puppetYes.alpha = 0;
            this.puppetIdle.alpha = 1;

            this.puppetIdle.anims.play('idleAnimate');
        },
        addSounds: function () {
            this.fsound = null;
            if (this.fData.questions[currentQuestionIndex].questionAudioName) {
                this.fsound = this.sound.add('questionSound_' + currentQuestionIndex);
            }
            this.yesSound = this.sound.add('yes');
            this.noCorrectAnswerThis = this.sound.add('noCorrectAnswerThis');
            // this.chooseAnswerSound = this.sound.add('chooseAnswerSound');
            this.hoverSound = this.sound.add('hoverSound');
            this.selectionSound = this.sound.add('selectionSound');
            this.exitSound = this.sound.add('exitSound');
            var self = this;
            /*this.game.onPause.add(function () {
                self.game.sound.unsetMute();
                self.sound.stop();
                self.bgMusic.pause();
            })*/
        },
        addEvents: function () {
            this.playQuestionSound();
            // this.questionSoundEvent = this.time.addEvent({ delay: 1000, callback: this.playQuestionSound, callbackScope: this, loop: false });//this.questionSoundEvent = this.game.time.events.add(Phaser.Timer.SECOND, this.playQuestionSound, this);
            // this.chooseAnswerEvent = this.time.addEvent({ delay: 1000 * 10, callback: function () {
            // this.chooseAnswerSound.play()
            // this.playQuestionSound()
            // }, callbackScope: this, loop: true });
            /*this.chooseAnswerEvent = this.game.time.events.loop(Phaser.Timer.SECOND * 10, function () {
                // this.chooseAnswerSound.play()
                this.playQuestionSound()
            }, this);*/
            this.addNewDefaultLoop();
        },
        addPlayQuestionButton: function () {
            this.playQuestionBtn = this.add.sprite(70, 44, 'Normal Sound Button');
            this.playQuestionBtn.setOrigin(0.5, 0.5)
            // this.playQuestionBtn.setScale(0.5);
            setupButton(this.playQuestionBtn, 'Normal Sound Button', 'Hover Sound Button', undefined, undefined, true);

            this.playQuestionBtn.setInteractive({ cursor: 'pointer' });
            this.playQuestionBtn.on('pointerup', this.playQuestionSound, this);
            this.playQuestionBtn.on('pointerover', this.playHoverSound, this);
            this.playQuestionBtn.on('pointerdown', this.playSelectionSound, this);
        },
        exitButton: function () {
            this.extiBtn = this.add.sprite(this.game.scale.width - 100, 0 + 16, 'assets', 'exit-button.png');
            this.extiBtn.setOrigin(0, 0)
            setupButton(this.extiBtn, 'exit-button.png', 'exit-button-hover.png');
            this.extiBtn.setInteractive({ cursor: 'pointer' });
            this.extiBtn.on('pointerup', this.showExitModal, this);
            this.extiBtn.on('pointerover', this.playHoverSound, this);
            this.extiBtn.on('pointerdown', this.playSelectionSound, this);
        },

        exitModal: function () {
            var modalBg = this.add.sprite(0, 0, 'modal-overlay');
            modalBg.setInteractive();
            modalBg.setOrigin(0, 0)
            this.modal = this.add.container();
            var modalBox = this.add.sprite(this.game.scale.width / 2, this.game.scale.height / 2, 'assets', 'activity-Instruction-board.png');
            modalBox.setOrigin(0.5, 0.5);

            var leavesRightSprite = this.add.sprite(0, 0, 'assets', 'leaves.png');
            leavesRightSprite.setOrigin(0, 0)
            leavesRightSprite.setPosition(modalBox.getBounds().right - 145, modalBox.getBounds().top + 15);

            var leavesLeftSprite = this.add.sprite(0, 0, 'assets', 'leaves.png');
            leavesLeftSprite.setOrigin(0.5, 0.5);
            leavesLeftSprite.scaleX *= -1;
            leavesLeftSprite.setPosition(modalBox.getBounds().left + 34, modalBox.getBounds().bottom - 140);

            var warningIcon = this.add.sprite(modalBox.getCenter().x, modalBox.getBounds().top + 74, 'assets', 'warning-icon.png');
            warningIcon.setOrigin(0.5, 0);

            var modalTextStyle = {
                backgroundColor: 'transparent',
                stroke: '#ffffff',
                strokeThickness: 2,
                lineSpacing: 15,
                fontFamily: 'Kids Rock DEMO',
                fontSize: 27,
                color: '#43425d',
                wordWrap: true,
                align: 'center'
            };
            var modalText = this.add.text(this.game.scale.width / 2, this.game.scale.height / 2 + 10, "Your progress in this activity will not be saved.  Are you sure you want to exit? ", modalTextStyle);
            modalText.setWordWrapWidth(modalBox.width - 110);//modalText.wordWrapWidth = modalBox.width - 110;
            modalText.setOrigin(0.5, 0.5);

            var modalYesBtn = this.add.sprite(modalBox.getBounds().left + 217, modalBox.getBounds().bottom - 179, 'assets', 'button-yes.png');
            modalYesBtn.setOrigin(0, 0)
            setupButton(modalYesBtn, 'button-yes.png', 'button-yes-hover.png');
            modalYesBtn.setInteractive({ cursor: 'pointer' });
            modalYesBtn.on('pointerup', this.exitGame, this);
            var modalNoBtn = this.add.sprite(modalYesBtn.getBounds().right - 43, modalBox.getBounds().bottom - 179, 'assets', 'button-no.png');
            modalNoBtn.setOrigin(0, 0)
            setupButton(modalNoBtn, 'button-no.png', 'button-no-hover.png');
            modalNoBtn.setInteractive({ cursor: 'pointer' });
            modalNoBtn.on('pointerup', this.exitGameCancel, this);

            modalYesBtn.on('pointerover', this.playHoverSound, this);
            modalYesBtn.on('pointerdown', this.playSelectionSound, this);

            modalNoBtn.on('pointerover', this.playHoverSound, this);
            modalNoBtn.on('pointerdown', this.playSelectionSound, this);

            this.modal.add(modalBg);
            this.modal.add(leavesLeftSprite);
            this.modal.add(leavesRightSprite);
            this.modal.add(modalBox);
            this.modal.add(warningIcon);
            this.modal.add(modalText);
            this.modal.add(modalYesBtn);
            this.modal.add(modalNoBtn);

            this.modal.visible = false;
            this.modal.alpha = 0;
        },

        showExitModal: function () {
            this.extiBtn.visible = false;
            this.modal.visible = true;
            // game.add.tween(this.modal).to( { alpha: 1 }, 200, Phaser.Easing.Linear.None, true);
            this.modal.alpha = 1;
            this.sound.pauseAll();// this.scene.pause();//this.game.paused = true;
            this.exitSound.play();
        },

        exitGame: function () {
            this.sound.resumeAll();// this.scene.resume();//this.game.paused = false;
            window.localStorage.removeItem('currentState');

            if (this.bgMusic) {
                this.bgMusic.stop();
            }
            // window.localStorage.removeItem('wrongButtonKey');
            // this.game.state.start('StartGame', true, false);
            window.angularComponentRef.backToMenu();
        },
        exitGameCancel: function () {
            this.extiBtn.visible = true;
            this.modal.alpha = 0;
            this.modal.visible = false;
            this.sound.resumeAll();// this.scene.resume();//this.game.paused = false;
            this.bgMusic.resume();
        },
        onClickNextButton: function () {
            // this.game.sound.stopAll();
            if (this.fsound) {
                this.fsound.stop();
            }
            if (this.yesSound) {
                this.yesSound.stop();
            }
            if (this.chooseAnswerSound) {
                this.chooseAnswerSound.stop();
            }
            if (this.noCorrectAnswerThis) {
                this.noCorrectAnswerThis.stop();
            }
            currentQuestionIndex++;
            var storage = window.localStorage.getItem('payload');
            storage = JSON.parse(storage);
            if (storage && storage.questions) {
                var incorrectArr = [];
                for (var i = 0; i < storage.questions.length; i++) {
                    if (!storage.questions[i].correctAnswer) {
                        incorrectArr[incorrectArr.length] = storage.questions[i]
                    }
                }
                if (incorrectArr.length >= 4) {
                    if (this.bgMusic) {
                        this.bgMusic.stop();
                    }
                    this.scene.start("TryGame");
                } else if (currentQuestionIndex < this.fData.questions.length) {
                    this.scene.start("Questions");//this.game.state.start("Questions", true, false, this.currentQuestionIndex);
                } else {
                    if (this.bgMusic) {
                        this.bgMusic.stop();
                    }
                    this.scene.start("EndGame");
                }
            } else {
                if (this.bgMusic) {
                    this.bgMusic.stop();
                }
                this.scene.start("EndGame");
            }
        },
        playHoverSound: function () {
            this.hoverSound.play();
        },
        playSelectionSound: function () {
            this.selectionSound.play();
        }
    };


    //endGame
    var trygame = function (game) {
        console.log("%cTryGame", "color:white; background:blue");
    };

    trygame.prototype = {
        preload: function () {
            this.totalPoints = window.angularComponentRef.getTotalScore();
            // this.fData = this.cache.binary.get('complete')
        },
        create: function () {
            if (!this.tryAgainSound) {
                this.tryAgainSound = this.sound.add('tryAgainSound');
            }
            this.tryAgainSound.play();

            this.hoverSound = this.sound.add('hoverSound');
            this.selectionSound = this.sound.add('selectionSound');

            window.localStorage.removeItem('currentState');
            window.localStorage.removeItem('wrongButtonKey');

            var storageJson = window.localStorage.getItem('payload');
            var storage = JSON.parse(storageJson);
            var currentPoints = 0;
            if (storage) {
                // currentPoints = storage.currentPoints || 0;
            }
            // this.scale.pageAlignHorizontally = true;
            // this.scale.pageAlignVertically = true;

            this.add.sprite(0, 0, 'try-again-bg').setOrigin(0, 0);

            // this.game.stage.disableVisibilityChange = true; // keep animation run on focus out

            var totalScoreTextStyle = {
                backgroundColor: 'transparent',
                stroke: '#91301a',
                strokeThickness: 6,
                fontFamily: 'Kids Rock DEMO',
                fontSize: 39,
                wordWrap: false,
                align: 'left'
            };
            var totalScoreTextStyleOutline = {
                backgroundColor: 'transparent',
                stroke: '#fff',
                strokeThickness: 12,
                fontFamily: 'Kids Rock DEMO',
                fontSize: 39,
                wordWrap: false,
                align: 'left'
            };
            var collectedPointsTextStyle = {
                backgroundColor: 'transparent',
                stroke: '#91301a',
                strokeThickness: 2,
                fontFamily: 'Kids Rock DEMO',
                fontSize: 25,
                wordWrap: false,
                align: 'left',
                color: '#ffffff'
            };

            var modalBox = this.add.sprite(this.game.scale.width / 2, this.game.scale.height / 2, 'assets', 'activity-Instruction-board.png');
            modalBox.setOrigin(0.5, 0.5);
            var completeRibbon = this.add.sprite(modalBox.getCenter().x, modalBox.getBounds().top + 222, 'assets', 'try-again-ribbon.png');
            completeRibbon.setOrigin(0.5, 0.5);

            var totalScoreOutline = this.add.text(modalBox.getBounds().left + 340, modalBox.getBounds().bottom - 302, "Total Score: " + " " + this.totalPoints, totalScoreTextStyleOutline);
            var totalScore = this.add.text(modalBox.getBounds().left + 342, modalBox.getBounds().bottom - 300, "Total Score: " + " " + this.totalPoints, totalScoreTextStyle);

            var grd = totalScore.context.createLinearGradient(0, 0, 0, totalScore.height);
            grd.addColorStop(0, '#edee62');
            grd.addColorStop(0.2, '#edee62');
            grd.addColorStop(0.7, '#dd7b33');
            totalScore.setFill(grd);

            var collectedPointsMedal = this.add.sprite(modalBox.getBounds().left + 324, modalBox.getBounds().bottom - 244, 'assets', 'collected-poins-medal.png');
            collectedPointsMedal.setOrigin(0, 0)

            var collectedPoints = this.add.text(modalBox.getBounds().left + 422, modalBox.getBounds().bottom - 204, currentPoints, collectedPointsTextStyle);

            var trophy = this.add.sprite(modalBox.getBounds().left + 210, modalBox.getBounds().bottom - 215, 'complete-trophy');
            trophy.setScale(0.5, 0.5);
            trophy.setOrigin(0.5, 0.5);
            trophy.alpha = 0;
            this.tweens.add({
                targets: trophy,
                scaleX: 1,
                scaleY: 1,
                duration: 400,
                ease: Phaser.Math.Easing.Linear
            });
            this.tweens.add({
                targets: trophy,
                alpha: 1,
                duration: 400,
                ease: Phaser.Math.Easing.Linear
            });

            var backToMenuButton = this.add.sprite(modalBox.getBounds().left + 332, modalBox.getBounds().bottom - 89, 'assets', 'back-to-menu-button.png');
            backToMenuButton.setOrigin(0, 0)
            setupButton(backToMenuButton, 'back-to-menu-button.png', 'back-to-menu-button-hover.png');
            backToMenuButton.setInteractive({ cursor: 'pointer' });
            backToMenuButton.on('pointerup', this.backToMenu, this);
            var playAgainButton = this.add.sprite(modalBox.getBounds().left + 479, modalBox.getBounds().bottom - 89, 'assets', 'play-again-button.png');
            playAgainButton.setOrigin(0, 0)
            setupButton(playAgainButton, 'play-again-button.png', 'play-again-button-hover.png');
            playAgainButton.setInteractive({ cursor: 'pointer' });
            playAgainButton.on('pointerup', this.playAgain, this);

            backToMenuButton.on('pointerover', this.playHoverSound, this);
            backToMenuButton.on('pointerdown', this.playSelectionSound, this);

            playAgainButton.on('pointerover', this.playHoverSound, this);
            playAgainButton.on('pointerdown', this.playSelectionSound, this);
        },

        backToMenu: function () {
            console.log('back to menu button clicked');
            this.tryAgainSound.stop();
            window.angularComponentRef.backToMenu();
        },
        playAgain: function () {
            console.log('play again button clicked');
            this.tryAgainSound.stop()
            this.scene.start('StartGame');
        },
        playHoverSound: function () {
            this.hoverSound.play();
        },
        playSelectionSound: function () {
            this.selectionSound.play();
        }
    };

    //main
    game = new Phaser.Game({
        type: Phaser.AUTO,
        width: 980,
        height: 600,
        parent: 'game-container',
        dom: {
            createContainer: false
        },
        scale: {
            mode: Phaser.Scale.NONE,
            // autoCenter: Phaser.Scale.CENTER_BOTH
        },
        transparent: true,
        scene: {
            create: () => {
                game.scene.add("Boot", boot, false);//game.state.add("Boot", boot);
                game.scene.add("StartGame", startgame);//game.state.add("StartGame", startgame);
                game.scene.add("ResumeGame", resumegame);//game.state.add("ResumeGame", resumegame);
                game.scene.add("Questions", questions);//game.state.add("Questions", questions);
                game.scene.add("EndGame", endgame);//game.state.add("EndGame", endgame);
                game.scene.add("TryGame", trygame);//game.state.add("TryGame", trygame);

                game.scene.start("Boot");//game.state.start("Boot");
            }
        }
    });
}

function destroyFindTheLetter() {
    if (game) {
        game.destroy();
    }

}

var game;
function getFrameRate( defFrameRate ) {
    return game.loop.actualFps / 60 * defFrameRate;
}
function getTimeSyncForFrameRate( defTime ) {
    return defTime / (game.loop.actualFps / 60);
}
function matchTheWord(json) {
    var currentQuestionIndex = 0;
    var isCloseDoor = false;
    var quizTimer = 0;

    function setupButton(btn, frame_pointerdown, frame_pointerover, frame_pointerout, frame_pointerup, textureBased) {
        if ( typeof frame_pointerout === "undefined" ) frame_pointerout = frame_pointerdown;
        if ( typeof frame_pointerup === "undefined" ) frame_pointerup = frame_pointerdown;

        btn['frame_pointerdown'] = frame_pointerdown;
        btn['frame_pointerover'] = frame_pointerover;
        btn['frame_pointerout'] = frame_pointerout;
        btn['frame_pointerup'] = frame_pointerup;

        if (!btn["alreadySetupEvents"]) {
            btn["alreadySetupEvents"] = true;
            let fn = textureBased ? "setTexture" : "setFrame";
            btn.on('pointerdown', () => { btn[fn](btn['frame_pointerdown']); });
            btn.on('pointerover', () => { btn[fn](btn['frame_pointerover']); });
            btn.on('pointerout', () => { btn[fn](btn['frame_pointerout']); });
            btn.on('pointerup', () => { btn[fn](btn['frame_pointerup']); });
        }
    };

    //boot
    var boot = function (game) {
        console.log('%cBoot', 'color:white; background:red');
    };

    boot.prototype = {
        init: function () {
            this.apiData = json;

            //fix input
            this.game.scale.transformX = (pageX) => {
                let offsetLeft = 0;
                let parentElement = this.game.canvas.parentElement;
                while (parentElement) {
                    if (parentElement.offsetLeft) {
                        offsetLeft = parentElement.offsetLeft;
                        break;
                    }
                    parentElement = parentElement.parentElement;
                }
                return (pageX - offsetLeft) * this.game.scale.displayScale.x;
            };
            this.game.scale.transformY = (pageY) => {
                let offsetTop = 0;
                let parentElement = this.game.canvas.parentElement;
                while (parentElement) {
                    if (parentElement.offsetTop) {
                        offsetTop = parentElement.offsetTop;
                        break;
                    }
                    parentElement = parentElement.parentElement;
                }
                return (pageY - offsetTop) * this.game.scale.displayScale.y;
            };
        },
        preload: function () {
            this.load.atlas('assets', 'assets/match-the-word/assets.png', 'assets/match-the-word/assets.json');
            this.load.atlas('soundBtn', 'assets/qa/sound-icon/sound-btn-spritesheet.png', 'assets/qa/sound-icon/sound-btn-spritesheet.json');

            this.load.image('Ellipse.png', 'assets/match-the-word/img/Ellipse.png');

            // if (this.apiData.bgImage) {
            //     this.load.image('bg-image', this.apiData.bgImage);
            // } else {
                this.load.image('bg-image', 'assets/match-the-word/img/BG 1 Wood Pattern.png');
            // }

            this.load.image('red-arrow-image', 'assets/images/red-arrow.png');
            // this.load.spritesheet('idle_default', 'assets/match-the-word/spritesheets/Idle_sheet.png', { frameWidth: 420, frameHeight: 370, endFrame: 32 });
            this.load.spritesheet('idle_no', 'assets/match-the-word/spritesheets/Laugh.png', { frameWidth: 420, frameHeight: 370, endFrame: 32 });
            this.load.spritesheet('idle_yes', 'assets/match-the-word/spritesheets/Yes_sheet.png', { frameWidth: 420, frameHeight: 370, endFrame: 32 });
            // this.load.spritesheet('idle_yes', 'assets/match-the-word/spritesheets/Go_inside.png', 420, 370, 32);
            this.load.spritesheet('go_out', 'assets/match-the-word/spritesheets/Go out_v3.png', { frameWidth: 420, frameeight: 370, endFrame: 32 });
            this.load.spritesheet('Enter_scene', 'assets/match-the-word/spritesheets/Enter_scene.png', { frameWidth: 3360/8, frameHeight: 1480/4, endFrame: 32 });
            this.load.spritesheet('door_open', 'assets/match-the-word/spritesheets/Door_anim_open.png', { frameWidth: 217, frameHeight: 187, endFrame: 6 });

            this.cache.binary.add('questions', this.apiData.questions);
            this.cache.binary.add('instruction', this.apiData.instruction);
            this.cache.binary.add('totalPoints', '0');
            this.cache.binary.add('qAnsPoints', {
                correctAnsPoint: 2,
                secTimeCorrectAnsPoint: 2,
                wrongAnsPoint: 0
            });

            this.load.image('instruction-bg', 'assets/match-the-word/img/modal-bg-1.png');
            this.load.image('completion-bg', 'assets/match-the-word/img/complete-page-bg.jpg');
            this.load.image('try-again-bg', 'assets/match-the-word/img/Try-again-bg.jpg');
            this.load.image('try-again-trophy', 'assets/match-the-word/img/Try-again-trophy-w-bg.png');
            this.load.image('complete-trophy', 'assets/match-the-word/img/complete-trophy.png');

            this.load.image('modal-overlay', 'assets/match-the-word/img/modal-overlay.png');
            this.load.image('door-frame', 'assets/match-the-word/img/doorframe.png');
            this.load.image('door-half-frame-overlay', 'assets/match-the-word/img/door-half-frame-overlay.png');
            this.load.image('door-dark-bg', 'assets/match-the-word/img/door-dark-bg.jpg');
            this.load.image('door-half-frame-fadeout', 'assets/match-the-word/img/door-half-frame-fadeout.png');

            this.load.audio('answerCorrectGoingIn', 'assets/sounds/match-the-word/Correct answer - dolphin swims inside.mp3');
            this.load.audio('answerCorrectGoingOut', 'assets/sounds/match-the-word/Correct answer - dolphin simming back.mp3');
            this.load.audio('answerWrongSwimmingOut', 'assets/sounds/match-the-word/wrong answer and dolphin swims back.mp3');
            this.load.audio('answerWrongSwimmingOutAndSwimIn', 'assets/sounds/match-the-word/Evil laugh and dolphin swims in.mp3');
            this.load.audio('answerCorrectGoingInBgSound', 'assets/sounds/match-the-word/enters.mp3');

            this.load.audio('door-open', 'assets/match-the-word/sounds/door-open.mp3');
            this.load.audio('door-close', 'assets/match-the-word/sounds/door-close.mp3');
            this.load.audio('bg-music', this.apiData.bgAudio);

            if (this.apiData.complete && this.apiData.complete.audios && this.apiData.complete.audios.length > 0) {
                var index = Math.floor(Math.random() * Math.floor(this.apiData.complete.audios.length));
                this.load.audio('completionSound', this.apiData.complete.audios[index]);
            }
            else {
                this.load.audio('completionSound', 'assets/match-the-word/sounds/viktory.mp3');
            }

            this.load.audio('tryAgainSound', 'assets/match-the-word/sounds/fail.mp3');

            this.load.audio('selectionSound', 'assets/sounds/selection.mp3');
            this.load.audio('hoverSound', 'assets/sounds/hover.mp3');

            this.load.audio('openButtonHover', 'assets/match-the-word/sounds/open-button-hover.mp3');
            this.load.audio('exitSound', 'assets/sounds/warning-pop-up.mp3');

            this.load.audio('openBtnSelectionSound', 'assets/sounds/match-the-word/selection.mp3');
            this.load.audio('openBtnHoverSound', 'assets/sounds/match-the-word/dolphin open button hover.mp3');
        },
        create: function () {
            this.isMobile = !this.game.device.desktop;
            // this.scale.scaleMode = Phaser.ScaleManager.USER_SCALE;
            // if (this.isMobile) {
            //     this.scaleGame();
            //     this.scale.setResizeCallback(this.scaleGame);
            // }
            //Local storing
            if (window.localStorage.getItem('currentState')) {
                window.localStorage.removeItem('currentState');
            }
            this.scene.start('StartGame');
        },

        scaleGame: function () {
            const padding = this.isMobile ? 0 : 0; // include padding around the canvas frame for desktop
            const parentWidth = document.getElementById('game-container').offsetWidth;
            const xScale = (parentWidth - padding) / this.game.width;
            const scalePoint = Math.min(xScale, 1);
            // if (this.scale) {
            //     this.scale.setUserScale(scalePoint, scalePoint);
            // }
        }
    };

    //startGame
    var startgame = function (game) {
        console.log('%cStartGame', 'color:white; background:blue');
    };

    startgame.prototype = {
        init: function () {
            this.goUp = false;
            var storage = {
                questions: [],
                currentPoints: 0
            };
            window.localStorage.setItem('payload', JSON.stringify(storage));
        },
        preload: function () {
            this.fdata = this.cache.binary.get('instruction');

            if (this.fdata && this.fdata.audio) {
                this.load.audio('startSound', this.fdata.audio);
            }

            this.questionData = { questions: this.cache.binary.get('questions') };
            for (var i = 0; i < this.questionData.questions.length; i++) {
                this.load.image('doorCode_' + i, this.questionData.questions[i].doorCode);
                this.load.image('code_' + i, this.questionData.questions[i].code);
            }
        },
        update: function () {
            if (this.redArrowImage) {
                if (this.goUp) {
                    this.redArrowImage.y -= 1;
                    if (this.redArrowImage.y <= -4) {
                        this.goUp = false
                    }
                } else {
                    this.redArrowImage.y += 1;
                    if (this.redArrowImage.y >= 18) {
                        this.goUp = true;
                    }
                }
            }
        },
        create: function () {
            window.angularComponentRef.loadingFinished();
            // if(this.bgMusic){
            //     this.bgMusic.stop();
            // }

            this.setupState();

            this.addSounds();

            this.playQuestionSound();

            var modalTextStyle = {
                backgroundColor: 'transparent',
                stroke: '#ffffff',
                strokeThickness: 2,
                fontFamily: 'Kids Rock DEMO',
                fontSize: 25,
                color: '#43425d',
                wordWrap: true,
                align: 'center'
            };

            var modalHeaderStyle = {
                backgroundColor: 'transparent',
                stroke: '#ffffff',
                strokeThickness: 16,
                fontFamily: 'Kids Rock DEMO',
                fontSize: 38,
                wordWrap: false,
                align: 'center'
            };

            this.add.sprite(0, 0, 'instruction-bg').setOrigin(0, 0);

            this.modal = this.add.container();

            var modalBox = this.add.sprite(this.game.scale.width/2, this.game.scale.height/2, 'assets', 'activity-Instruction-board.png');
            modalBox.setOrigin(0.5, 0.5);

            this.modalHeaderGroup = this.add.container();
            var modalBoxHeader = this.add.sprite(0, 0, 'assets', 'activity-Instruction-board-header.png');
            modalBoxHeader.setOrigin(0, 0);

            var modalHeaderText = this.add.text(0, 0, this.fdata.title, modalHeaderStyle);
            if (!(this.game.device.mobileSafari || this.game.device.safari)) {
                modalHeaderText.setShadow(3, 3, '#43425d', 0, false, true);
            }

            var grd = modalHeaderText.context.createLinearGradient(0, 0, 0, modalHeaderText.height);
            grd.addColorStop(0, '#edee62');
            grd.addColorStop(0.2, '#edee62');
            grd.addColorStop(0.7, '#dd7b33');
            modalHeaderText.setFill(grd);

            var bgSoundButton = this.add.sprite(0, 0, 'soundBtn', 'introduction-sound_02.png');
            bgSoundButton.setOrigin(0, 0);
            bgSoundButton.on('pointerup', function () {
                if (this.redArrowImage) {
                    this.redArrowImage.alpha = 0;
                }
                this.playQuestionSound()
            }, this);

            setupButton(bgSoundButton, 'introduction-sound_02.png', 'introduction-sound_01.png');
            bgSoundButton.setInteractive({ cursor: 'pointer' });

            bgSoundButton.on('pointerover', this.playHoverSound, this);
            bgSoundButton.on('pointerdown', this.playSelectionSound, this );

            this.modalHeaderGroup.add(modalBoxHeader);
            this.modalHeaderGroup.add(modalHeaderText);
            this.modalHeaderGroup.add(bgSoundButton);
            this.modalHeaderGroup.setPosition((modalBox.width - modalBoxHeader.width) / 2 + modalBox.getBounds().left, modalBox.getBounds().top - 21);

            if (this.game.device.os.iOS) {
                this.redArrowImage = this.add.sprite(0, 0, 'red-arrow-image');
                this.redArrowImage.setOrigin(0, 0)
                this.modalHeaderGroup.add(this.redArrowImage);
            }

            modalHeaderText.setPosition(modalBoxHeader.getCenter().x, modalBoxHeader.getCenter().y);
            modalHeaderText.setOrigin(0.5, 0.5);
            modalBoxHeader.setPosition(this.modalHeaderGroup.getBounds().left, this.modalHeaderGroup.getBounds().top);
            bgSoundButton.setPosition(modalBoxHeader.getCenter().x + 30, modalBoxHeader.getCenter().y - 40);

            if (this.game.device.os.iOS) {
                this.redArrowImage.setPosition(modalBoxHeader.getCenter().x + 34, modalBoxHeader.getCenter().y - 110);
            }

            var modalText = this.add.text(this.game.scale.width/2, this.game.scale.height/2, this.fdata.content, modalTextStyle);
            modalText.setWordWrapWidth(modalBox.width - 180);//modalText.wordWrapWidth = modalBox.width - 110;
            modalText.setOrigin(0.5, 0.5);

            console.log('startButton');
            var startButton = this.add.sprite(this.game.scale.width/2, modalBox.getBounds().bottom - 103, 'assets', 'activity-Instruction-play-button.png');
            startButton.setOrigin(0, 0)
            startButton.on('pointerup', function () {
                console.log('startButton clicked');
                // if (!this.game.device.desktop) {
                //     this.game.scale.startFullScreen(false);
                // }
                this.fsound.stop();
                currentQuestionIndex = 0;
                this.scene.start("Questions");//this.game.state.start('Questions', true, false, 0);
                console.log('startButton clicked22');
            }, this);

            setupButton(startButton, 'activity-Instruction-play-button.png', 'activity-Instruction-play-button-hover.png');
            startButton.setInteractive({ cursor: 'pointer' });

            startButton.on('pointerover', this.playHoverSound, this);
            startButton.on('pointerdown', this.playSelectionSound, this);

            startButton.input.pixelPerfectOver = true;
            startButton.input.pixelPerfectClick = true;
            startButton.setOrigin(0.5, 0.5);

            var leavesRightSprite = this.add.sprite(0, 0, 'assets', 'leaves.png');
            leavesRightSprite.setOrigin(0, 0)
            leavesRightSprite.setPosition(modalBox.getBounds().right - 145, modalBox.getBounds().top + 15);

            var leavesLeftSprite = this.add.sprite(0, 0, 'assets', 'leaves.png');
            leavesLeftSprite.setOrigin(0.5, 0.5);
            leavesLeftSprite.scaleX *= -1;
            leavesLeftSprite.setPosition(modalBox.getBounds().left + 34, modalBox.getBounds().bottom - 140);

            this.modal.add(leavesLeftSprite);
            this.modal.add(leavesRightSprite);
            this.modal.add(modalBox);
            this.modal.add(modalBoxHeader);
            this.modal.add(modalText);
            this.modal.add(startButton);
        },

        setupState: function () {
            // this.game.scale.fullScreenScaleMode = Phaser.ScaleManager.SHOW_ALL;

            // this.game.stage.disableVisibilityChange = true; // keep animation run on focus out
            // this.scale.pageAlignHorizontally = true;

            // this.scale.pageAlignVertically = true;
        },

        addSounds: function () {
            this.fsound = this.sound.add('startSound');
            this.hoverSound = this.sound.add('hoverSound');
            this.selectionSound = this.sound.add('selectionSound');
            // this.game.time.events.add(Phaser.Timer.SECOND * 2, this.playQuestionSound, this);
        },

        playHoverSound: function () {
            this.hoverSound.play();
        },
        playSelectionSound: function () {
            this.selectionSound.play();
        },

        playQuestionSound: function () {
            this.fsound.play();
        }
    };

    //endGame
    var endgame = function (game) {
        console.log("%cEndGame", "color:white; background:blue");
    };

    endgame.prototype = {
        init: function (/*quizTimer*/) {
            this.saveActivityAns();
            // this.quizTimer = quizTimer || 0;
        },
        preload: function () {
            this.totalPoints = window.angularComponentRef.getTotalScore();
            // this.fdata = this.cache.binary.get('complete')
        },
        create: function () {
            if (!this.completionSound) {
                this.completionSound = this.sound.add('completionSound');
            }
            this.completionSound.play();

            this.hoverSound = this.sound.add('hoverSound');
            this.selectionSound = this.sound.add('selectionSound');

            window.localStorage.removeItem('currentState');
            window.localStorage.removeItem('wrongButtonKey');

            var storageJson = window.localStorage.getItem('payload');
            var storage = JSON.parse(storageJson);
            var currentPoints = 0;
            if (storage) {
                currentPoints = storage.currentPoints || 0;
            }
            // this.scale.pageAlignHorizontally = true;
            // this.scale.pageAlignVertically = true;

            this.add.sprite(0, 0, 'completion-bg').setOrigin(0, 0);

            // this.game.stage.disableVisibilityChange = true; // keep animation run on focus out

            var totalScoreTextStyle = {
                backgroundColor: 'transparent',
                stroke: '#91301a',
                strokeThickness: 6,
                fontFamily: 'Kids Rock DEMO',
                fontSize: 39,
                wordWrap: false,
                align: 'left'
            };
            var totalScoreTextStyleOutline = {
                backgroundColor: 'transparent',
                stroke: '#fff',
                strokeThickness: 12,
                fontFamily: 'Kids Rock DEMO',
                fontSize: 39,
                wordWrap: false,
                align: 'left'
            };
            var collectedPointsTextStyle = {
                backgroundColor: 'transparent',
                stroke: '#91301a',
                strokeThickness: 2,
                fontFamily: 'Kids Rock DEMO',
                fontSize: 25,
                wordWrap: false,
                align: 'left',
                color: '#ffffff'
            };

            var modalBox = this.add.sprite(this.game.scale.width/2, this.game.scale.height/2, 'assets', 'activity-Instruction-board.png');
            modalBox.setOrigin(0.5, 0.5);
            var completeRibbon = this.add.sprite(modalBox.getCenter().x, modalBox.getBounds().top + 222, 'assets', 'complete-ribbon-full.png');
            completeRibbon.setOrigin(0.5, 0.5);

            var totalScoreOutline = this.add.text(modalBox.getBounds().left + 340, modalBox.getBounds().bottom - 302, "Total Score: " + " " + this.totalPoints, totalScoreTextStyleOutline);
            var totalScore = this.add.text(modalBox.getBounds().left + 342, modalBox.getBounds().bottom - 300, "Total Score: " + " " + this.totalPoints, totalScoreTextStyle);

            var grd = totalScore.context.createLinearGradient(0, 0, 0, totalScore.height);
            grd.addColorStop(0, '#f4fa38');
            grd.addColorStop(0.3, '#edee62');
            grd.addColorStop(0.7, '#dd7b33');
            totalScore.setFill(grd);

            var timerTotalRibbon = this.add.sprite(modalBox.getBounds().left + 342, modalBox.getBounds().bottom - 232, 'assets', 'timer-total.png');
            timerTotalRibbon.setOrigin(0, 0)
            var timerTotalText = this.add.text(modalBox.getBounds().left + 403, modalBox.getBounds().bottom - 203, this.formatTime(quizTimer), collectedPointsTextStyle);
            timerTotalText.setOrigin(0, 0)

            var collectedPointsMedal = this.add.sprite(modalBox.getBounds().left + 516, modalBox.getBounds().bottom - 244, 'assets', 'collected-poins-medal.png');
            collectedPointsMedal.setOrigin(0, 0)
            var collectedPoints = this.add.text(modalBox.getBounds().left + 605, modalBox.getBounds().bottom - 204, "+" + currentPoints, collectedPointsTextStyle);
            collectedPoints.setOrigin(0, 0)

            // var trophy = this.add.sprite(modalBox.getBounds().left+66, modalBox.bottom-355, 'trophy');
            var trophy = this.add.sprite(modalBox.getBounds().left + 210, modalBox.getBounds().bottom - 215, 'complete-trophy');
            trophy.setScale(0.5, 0.5);
            trophy.setOrigin(0.5, 0.5);
            trophy.alpha = 0;
            this.tweens.add({
                targets: trophy,
                scaleX: 1,
                scaleY: 1,
                duration: 400,
                ease: Phaser.Math.Easing.Linear
            });
            this.tweens.add({
                targets: trophy,
                alpha: 1,
                duration: 400,
                ease: Phaser.Math.Easing.Linear
            });

            var backToMenuButton = this.add.sprite(modalBox.getBounds().left + 332, modalBox.getBounds().bottom - 89, 'assets', 'back-to-menu-button.png');
            backToMenuButton.setOrigin(0, 0)
            setupButton(backToMenuButton, 'back-to-menu-button.png', 'back-to-menu-button-hover.png');
            backToMenuButton.setInteractive({ cursor: 'pointer' });
            backToMenuButton.on('pointerup', this.backToMenu, this );

            var playAgainButton = this.add.sprite(modalBox.getBounds().left + 479, modalBox.getBounds().bottom - 89, 'assets', 'play-again-button.png');
            playAgainButton.setOrigin(0, 0)
            setupButton(playAgainButton, 'play-again-button.png', 'play-again-button-hover.png');
            playAgainButton.setInteractive({ cursor: 'pointer' });
            playAgainButton.on('pointerup', this.playAgain, this );

            var nextActivityButton = this.add.sprite(modalBox.getBounds().left + 626, modalBox.getBounds().bottom - 89, 'assets', 'next-activity-button.png');
            nextActivityButton.setOrigin(0, 0)
            setupButton(nextActivityButton, 'next-activity-button.png', 'next-activity-button-hover.png');
            nextActivityButton.setInteractive({ cursor: 'pointer' });
            nextActivityButton.on('pointerup', this.nextActivity, this );

            backToMenuButton.on('pointerover', this.playHoverSound, this);
            backToMenuButton.on('pointerdown', this.playSelectionSound, this );

            playAgainButton.on('pointerover', this.playHoverSound, this);
            playAgainButton.on('pointerdown', this.playSelectionSound, this );

            nextActivityButton.on('pointerover', this.playHoverSound, this);
            nextActivityButton.on('pointerdown', this.playSelectionSound, this );
        },

        backToMenu: function () {
            console.log('back to menu button clicked');
            this.completionSound.stop();
            window.angularComponentRef.backToMenu();
        },
        playAgain: function () {
            console.log('play again button clicked');
            this.completionSound.stop()
            this.scene.start('StartGame');
        },
        nextActivity: function () {
            console.log('next activity button clicked');
            window.angularComponentRef.nextActivity();
            // this.scene.start('StartGame', true, false);
        },

        formatTime: function (s) {
            var minutes = "0" + Math.floor(s / 60);
            var seconds = "0" + (s - minutes * 60);
            return minutes.substr(-2) + ":" + seconds.substr(-2);
        },

        playHoverSound: function () {
            this.hoverSound.play();
        },
        playSelectionSound: function () {
            this.selectionSound.play();
        },
        saveActivityAns: function () {
            var storageJson = window.localStorage.getItem('payload');
            var storage = JSON.parse(storageJson);
            var _obj = {
                activity_id: 1,
                country_id: 1,
                zone_id: 1,
                continent_id: 1,
                totalScore: 0,
                questions: []
            }
            if (storage) {
                for (var i = 0; i < storage.questions.length; i++) {
                    var questionKey = storage.questions[i].questionKey;
                    var answerKey = storage.questions[i].answerKey;
                    var attempts = storage.questions[i].attempts;
                    var points = storage.questions[i].points;
                    var question = {
                        [questionKey]: {
                            [answerKey]: {
                                try_count: attempts,
                                score: points
                            }
                        }
                    }
                    _obj.questions.push(question);
                    _obj.totalScore += points
                }
                window.angularComponentRef.gameFinish(_obj);
            }
        }
    };

    //startGame
    var resumegame = function (game) {
        console.log("%cStartGame", "color:white; background:blue");
    };

    resumegame.prototype = {
        init: function (/*currentQuestionIndex*/) {
            // this.currentQuestionIndex = currentQuestionIndex;
            this.fdata = { questions: this.cache.binary.get('questions') };
        },
        create: function () {
            // this.scale.pageAlignHorizontally = true;
            // this.scale.pageAlignVertically = true;

            this.add.sprite(0, 0, 'bg-image').setOrigin(0, 0);

            // this.game.stage.disableVisibilityChange = true; // keep animation run on focus out

            this.hoverSound = this.sound.add('hoverSound');
            this.selectionSound = this.sound.add('selectionSound');

            var startButton = this.add.sprite(this.game.scale.width/2, this.game.scale.height/2, 'assets', 'next-button.png');
            startButton.setOrigin(0, 0)
            setupButton(startButton, 'next-button.png', 'next-button-hover.png');
            startButton.setInteractive({ cursor: 'pointer' });

            startButton.on('pointerup', function () {
                if (currentQuestionIndex < this.fdata.questions.length) {
                    this.scene.start("Questions");//this.game.state.start("Questions", true, false, this.currentQuestionIndex);
                } else {
                    this.scene.start("EndGame");//this.game.state.start("EndGame", true, false);
                }
            }, this);

            startButton.on('pointerover', this.playHoverSound, this);
            startButton.on('pointerdown', this.playSelectionSound, this );
            startButton.setOrigin(0.5, 0.5);

            var style = {
                backgroundColor: 'transparent',
                stroke: '#074a83',
                strokeThickness: 6,
                fontFamily: "Kids Rock DEMO",
                fontSize: 40,
                color: "#ffffff",
                wordWrap: false,
                align: "left"
            };
            var startButtonText = this.add.text(this.game.scale.width/2, this.game.scale.height/2 - 100, 'Resume quiz', style);
            startButtonText.setOrigin(0.5, 0.5);
        },
        playHoverSound: function () {
            this.hoverSound.play();
        },
        playSelectionSound: function () {
            this.selectionSound.play();
        }
    };

    //questions
    var questions = function (game) {
        console.log("%cQuestions", "color:white; background:blue");
    };

    questions.prototype = {
        init: function (/*currentQuestionIndex, isCloseDoor*/) {
            // this.currentQuestionIndex = currentQuestionIndex || 0;
            // this.isCloseDoor = isCloseDoor || false;
            this.wrongAnswersCount = 0;
            this.maxWrongAnswers = 1;
            this.openBtnInputEnabled = false;
            window.localStorage.setItem('currentState', currentQuestionIndex);
        },
        preload: function () {
            this.fdata = { questions: this.cache.binary.get('questions') };
            this.qAnsPoints = this.cache.binary.get('qAnsPoints');
            //images
            // this.load.image('doorCode', this.fdata.questions[this.currentQuestionIndex].doorCode);
            // this.load.image('code', this.fdata.questions[this.currentQuestionIndex].code);
        },
        create: function () {
            if (!this.bgMusic) {
                this.bgMusic = this.sound.add('bg-music', {volume: 1, loop: true});
                this.bgMusic.play();
            }
            else {
                if (!this.bgMusic.isPlaying) {
                    this.bgMusic.play();
                }
            }

            this.questionItem = this.fdata.questions[currentQuestionIndex];

            this.hoverSound = this.sound.add('hoverSound');
            this.selectionSound = this.sound.add('selectionSound');
            this.hoverOpenButton = this.sound.add('openButtonHover');

            this.drawBg();
            this.drawDoor();
            this.drawPuppet();
            this.doorHalfFrameFadeOut = this.add.sprite(0, 272, 'door-half-frame-fadeout');
            this.doorHalfFrameFadeOut.setOrigin(0, 0);
            this.doorHalfFrameFadeOut.alpha = 0;
            this.doorHalfFrame = this.add.sprite(0, 272, 'door-half-frame-overlay');
            this.doorHalfFrame.setOrigin(0, 0);
            this.drawStaticScene();
            this.setProgressBar(currentQuestionIndex);
            this.addAnswerSounds();
            this.drawOpenBtn(this.questionItem.match);
            this.progressPanel();
            this.addEvents();
            this.exitButton();
            this.exitModal();
        },
        update: function () {
            if (this.puppetIdle.x > 573) {
                this.puppetIdle.x -= 8;
            }
            if (this.puppetYes.anims && this.puppetYes.anims.isPlaying) {
                this.puppetYes.x -= 7.5;
                this.puppetYes.y += 2.25;
                this.puppetYes.scaleY -= 0.005;
                this.puppetYes.scaleX -= 0.005;
            }
            if (this.puppetGoOut.anims && this.puppetGoOut.anims.isPlaying) {
                this.puppetGoOut.x += 4;
                this.puppetGoOut.y += 3;
            }
        },
        drawStaticScene: function () {
            this.add.sprite(263, 198, 'doorCode_' + currentQuestionIndex).setOrigin(0.5, 0.5);
            this.answerTab = this.add.sprite(485, 285, 'Ellipse.png').setOrigin(0, 0.2);
            this.answerCode = this.add.sprite(this.answerTab.x+100, this.answerTab.y+45, 'code_' + currentQuestionIndex).setOrigin(0.5, 0.5);
            this.answerTabGroup = this.add.container();
            this.answerTabGroup.add(this.answerTab)
            this.answerTabGroup.add(this.answerCode)
            this.answerTabGroup.alpha = 0;
            this.add.sprite(832, 160, 'assets', 'bubble.png').setOrigin(0, 0);
        },
        drawDoor: function () {
            this.doorDarkBg = this.add.sprite(142, 273, 'door-dark-bg').setOrigin(0, 0);
            this.door = this.add.sprite(148, 300, 'door_open').setOrigin(0, 0);
            this.doorFrame = this.add.sprite(142, 273, 'door-frame').setOrigin(0, 0);
            this.anims.create({
                key: 'doorOpen',
                frames: this.anims.generateFrameNumbers('door_open', { start: 0, end: 5, first: 0 }),
                frameRate: getFrameRate(10),
                repeat: 0
            });
            this.anims.create({
                key: 'doorClose',
                frames: this.anims.generateFrameNumbers('door_open', { start: 0, end: 5, first: 0 }).reverse(),
                frameRate: getFrameRate(12),
                repeat: 0
            });

            if (isCloseDoor && currentQuestionIndex !== 0) {
                this.door.play('doorClose');
                this.doorCloseAudio.play();

                this.doorHalfFrameFadeOut.alpha = 0;//fix for this.door.on("animationstart", function (animation, frame) {
            }
            var self = this;
            this.door.on("animationcomplete", function (animation, frame) {
                if (animation.key == 'doorOpen') {
                    self.doorHalfFrameFadeOut.alpha = 1;
                }
            });
        },
        drawOpenBtn: function (isMatch) {
            this.openBtn = this.add.sprite(120, 464, 'assets', 'open-btn.png');
            this.openBtn.setOrigin(0, 0);
            this.openBtn["context"] = this;
            this.openBtn["isMatch"] = isMatch;
            setupButton(this.openBtn, 'open-btn.png', 'open-btn-hover.png');
            this.openBtn.setInteractive({ cursor: 'pointer' });
            this.openBtn.on('pointerup', this.openBtnAction, this.openBtn );
            this.openBtn.on('pointerover', this.playHoverSound, this);
            this.openBtn.on('pointerdown', this.playSelectionSound, this );
            // this.openBtn.inputEnabled = false;
        },
        openBtnAction: function () {
            var context = this.context;

            if (context.openBtnInputEnabled) {
                context.door.play('doorOpen');
                context.doorOpenAudio.play();

                context.questionTimerLoop.remove(false);//context.game.time.events.remove(context.questionTimerLoop);

                context.puppetIdle.alpha = 0;
                context.puppetGoOut.alpha = 0;

                if (this.isMatch) {
                    context.puppetYes.alpha = 1;
                    context.puppetYes.play('yesAnimate', 30);
                    context.answerTabGroup.alpha = 0;
                    context.answerCorrectGoingIn.play();
                } else {
                    context.puppetNo.alpha = 1;
                    context.puppetNo.play('noAnimate');
                    context.answerTabGroup.alpha = 0;
                    context.answerWrongSwimmingOutAndSwimIn.play();
                }
                // context.game.time.events.remove(context.puppetOutOnNoAnswerEvent);
                // context.openBtn.inputEnabled = false;
                context.openBtnInputEnabled = false;

                var points = 0;
                if (this.isMatch) {
                    points = +context.qAnsPoints.correctAnsPoint;
                } else {
                    points = +context.qAnsPoints.wrongAnsPoint;
                }
                context.calculatePoints.call(context, this.isMatch, points);
            }
        },
        progressPanel: function () {
            var modalTextStyle = {
                backgroundColor: 'transparent',
                fontFamily: 'Kids Rock DEMO',
                fontSize: 16,
                color: '#ffffff',
                wordWrap: false,
                align: 'center'
            };
            //questions current/total
            var totalQuestionsCount = this.fdata.questions.length;
            var questionsTotalProgress = this.add.text(625, 8, "Questions " + (+currentQuestionIndex + 1) + "/" + totalQuestionsCount, modalTextStyle);
            questionsTotalProgress.setOrigin(0, 0);
            questionsTotalProgress.setShadow(0, 2, '#243f5d', 0);
            questionsTotalProgress.alpha = 0;
            var storageJson = window.localStorage.getItem('payload');
            var storage = JSON.parse(storageJson);

            var answeredCount = storage.questions.length;
            var correctAnswersCount = 0;
            for (var i = 0; i < storage.questions.length; i++) {
                if (storage.questions[i].correctAnswer) {
                    correctAnswersCount++;
                }
            }
            // correct/wrong answers
            var correctAnswerCountText = this.add.text(444, 34, correctAnswersCount, modalTextStyle);
            correctAnswerCountText.setOrigin(0,0);
            var wrongAnswerCountText = this.add.text(523, 34, answeredCount - correctAnswersCount, modalTextStyle);
            wrongAnswerCountText.setOrigin(0,0);

            //timer
            this.questionTimeOut = 4;
            quizTimer = 0;
            if (storage.quizTimer !== undefined) {
                quizTimer = storage.quizTimer;
            } else {
                storage.quizTimer = quizTimer;
                window.localStorage.setItem('payload', JSON.stringify(storage));
            }
            this.questionTimerText = this.add.text(779, 34, this.formatTime(quizTimer), modalTextStyle);
            this.questionTimerText.setOrigin(0,0);
            this.time.addEvent({ delay: 1000, callback: this.updateTimer, callbackScope: this, loop: true });//this.game.time.events.loop(Phaser.Timer.SECOND, this.updateTimer, this);
        },
        updateTimer: function () {
            quizTimer++;
            this.questionTimerText.setText(this.formatTime(quizTimer));
        },
        drawBg: function () {
            this.bg = this.add.sprite(0, 0, 'bg-image').setOrigin(0,0)
        },
        setProgressBar: function (step) {
            var totalQuestionsCount = this.fdata.questions.length;
            var progressBarMaxWidth = 117;
            var progressBarWidth = (progressBarMaxWidth / totalQuestionsCount) * step;
            // rect for full bar
            var rrectBg = this.add.graphics();
            rrectBg.setPosition(587, 31);
            rrectBg.fillStyle(0x233e5b);
            rrectBg.fillRoundedRect(0, 0, 117, 22, 15);

            // rect for progress bar itself
            var rrect = this.add.graphics();
            rrect.setPosition(587, 31);
            rrect.fillStyle(0xFFA500, 1);
            rrect.fillRoundedRect(0, 0, progressBarWidth, 22, progressBarWidth >= 15 ? 10 : progressBarWidth > 0 ? 5 : 0);
        },
        drawPuppet: function () {
            var frameWidth = 320;
            var frameHeight = 411;
            var framePosX = 650;
            var framePosY = 122;

            this.puppetIdle = this.add.sprite(framePosX + 960, framePosY, 'Enter_scene');
            this.puppetIdle.setOrigin(0, 0)
            this.puppetIdle.height = frameHeight;
            this.puppetIdle.width = frameWidth;

            var self = this;
            this.anims.create({
                key: 'idleAnimate',
                frames: this.anims.generateFrameNumbers('Enter_scene', { start: 0, end: 31, first: 0 }),//this.getExtendedStartFrames('idle_default', 23, 31),
                frameRate: getFrameRate(40),
                repeat: 0
            });

            this.puppetIdle.on('animationcomplete', function () {
                self.answerTabGroup.alpha = 1;
                // self.openBtn.inputEnabled = true;
                self.openBtnInputEnabled = true;
                self.questionTimerLoop = this.time.addEvent({ delay: 1000, callback: self.updateCounter, callbackScope: self, loop: true });//self.questionTimerLoop = self.game.time.events.loop(Phaser.Timer.SECOND, self.updateCounter, self);
            }, this);


            // puppet no
            this.puppetNo = this.add.sprite(framePosX, framePosY, 'idle_no');
            this.puppetNo.setOrigin(0, 0)
            this.puppetNo.height = frameHeight;
            this.puppetNo.width = frameWidth;
            this.puppetNo.alpha = 0;

            this.anims.create({
                key: 'noAnimate',
                frames: this.anims.generateFrameNumbers('idle_no', { start: 0, end: 31, first: 0 }),
                frameRate: getFrameRate(45),
                repeat: 0
            });
            this.puppetNo.on('animationcomplete', function () {
                self.answerTabGroup.alpha = 0;
                self.puppetNo.alpha = 0;
                self.puppetYes.alpha = 1;
                self.puppetYes.play('yesAnimate');
            }, this);

            // puppet yes
            this.puppetYes = this.add.sprite(framePosX, framePosY, 'idle_yes');
            this.puppetYes.setOrigin(0, 0)
            this.puppetYes.height = frameHeight;
            this.puppetYes.width = frameWidth;
            this.puppetYes.alpha = 0;

            this.anims.create({
                key: 'yesAnimate',
                frames: this.getExtendedEndFrames('idle_yes', 8, 31, false, 3),
                frameRate: getFrameRate(40),
                repeat: 0
            });
            this.puppetYes.on('animationcomplete', function () {
                self.onClickNextButton(true)
            }, this);

            // puppet go out
            this.puppetGoOut = this.add.sprite(framePosX - 50, framePosY, 'go_out');
            this.puppetGoOut.setOrigin(0, 0)
            this.puppetGoOut.height = frameHeight;
            this.puppetGoOut.width = frameWidth;
            this.puppetGoOut.alpha = 0;

            this.anims.create({
                key: 'goOutAnimate',
                frames: this.anims.generateFrameNumbers('go_out', { start: 0, end: 31, first: 0 }),//this.getExtendedEndFrames('go_out', 8, 31),
                frameRate: getFrameRate(20),
                repeat: 0
            });
            this.puppetGoOut.on('animationcomplete', function () {
                self.onClickNextButton(false)
            }, this);
        },
        updateCounter: function () {
            this.questionTimeOut--;

            if (this.questionTimeOut === 0) {
                this.questionTimerLoop.remove(false);//this.game.time.events.remove(this.questionTimerLoop);
                this.puppetOut();
            }
        },
        getExtendedStartFrames: function (spritesheetKey, repeatTil, endFrame, reverse) {
            var dolphinFrames = [];
            for (var i = 1; i <= 3; i++) {
                for (var j = 1; j <= repeatTil; j++) {
                    dolphinFrames.push(j);
                }
            }
            for (var i = repeatTil + 1; i <= endFrame; i++) {
                dolphinFrames.push(i);
            }
            if (reverse) {
                return dolphinFrames.map(function(frame) {return {key: spritesheetKey, frame: frame}}).reverse()
            }
            return dolphinFrames.map(function(frame) {return {key: spritesheetKey, frame: frame}});
        },
        getExtendedEndFrames: function (spritesheetKey, repeatfrom, endFrame, reverse, times) {
            var dolphinFrames = [];
            times = times || 3;
            for (var i = 1; i <= repeatfrom - 1; i++) {
                dolphinFrames.push(i);
            }
            for (var i = 1; i <= times; i++) {
                for (var j = repeatfrom; j <= endFrame; j++) {
                    dolphinFrames.push(j);
                }
            }
            if (reverse) {
                return dolphinFrames.map(function(frame) {return {key: spritesheetKey, frame: frame}}).reverse()
            }
            return dolphinFrames.map(function(frame) {return {key: spritesheetKey, frame: frame}});
        },
        puppetEnter: function () {
            this.puppetNo.alpha = 0;
            this.puppetYes.alpha = 0;
            this.puppetGoOut.alpha = 0;
            this.puppetIdle.alpha = 1;
            self = this;

            this.time.addEvent({ delay: getTimeSyncForFrameRate(1500), callback: function () {
                    self.puppetIdle.play('idleAnimate');
                }, callbackScope: this, loop: false });
            this.time.addEvent({ delay: getTimeSyncForFrameRate(600), callback: function () {
                    this.answerCorrectGoingInBgSound.play();
                }, callbackScope: this, loop: false });
        },
        puppetOut: function () {
            this.puppetNo.alpha = 0;
            this.puppetYes.alpha = 0;
            this.puppetIdle.alpha = 0;
            this.puppetGoOut.alpha = 1;
            this.answerTabGroup.alpha = 0;
            // this.openBtn.inputEnabled = false;
            this.openBtnInputEnabled = false;
            this.puppetGoOut.play('goOutAnimate');

            if (this.questionItem.match) {
                this.answerWrongSwimmingOut.play();
                this.calculatePoints.call(this, false, this.qAnsPoints.wrongAnsPoint)
            }
            else {
                this.answerCorrectGoingOut.play();
                this.calculatePoints.call(this, true, this.qAnsPoints.correctAnsPoint);
            }
        },
        addEvents: function () {
            this.puppetEnter();
        },
        exitButton: function () {
            this.extiBtn = this.add.sprite(900, 0 + 11, 'assets', 'exit-button.png');
            this.extiBtn.setOrigin(0, 0)
            setupButton(this.extiBtn, 'exit-button.png', 'exit-button-hover.png');
            this.extiBtn.setInteractive({ cursor: 'pointer' });
            this.extiBtn.on('pointerup', this.showExitModal, this);
            this.extiBtn.on('pointerover', this.playHoverSound, this);
            this.extiBtn.on('pointerdown', this.playSelectionSound, this );
        },

        exitModal: function () {
            var modalBg = this.add.sprite(0, 0, 'modal-overlay').setOrigin(0, 0);
            modalBg.setInteractive();

            this.modal = this.add.container();
            var modalBox = this.add.sprite(this.game.scale.width/2, this.game.scale.height/2, 'assets', 'activity-Instruction-board.png');
            modalBox.setOrigin(0.5, 0.5);

            var leavesRightSprite = this.add.sprite(0, 0, 'assets', 'leaves.png');
            leavesRightSprite.setOrigin(0, 0)
            leavesRightSprite.setPosition(modalBox.right - 145, modalBox.getBounds().top + 15);

            var leavesLeftSprite = this.add.sprite(0, 0, 'assets', 'leaves.png');
            leavesLeftSprite.setOrigin(0.5, 0.5);
            leavesLeftSprite.scaleX *= -1;
            leavesLeftSprite.setPosition(modalBox.getBounds().left + 34, modalBox.getBounds().bottom - 140);

            var warningIcon = this.add.sprite(modalBox.getCenter().x, modalBox.getBounds().top + 74, 'assets', 'warning-icon.png');
            warningIcon.setOrigin(0.5, 0);

            var modalTextStyle = {
                backgroundColor: 'transparent',
                stroke: '#ffffff',
                strokeThickness: 2,
                lineSpacing: 15,
                fontFamily: 'Kids Rock DEMO',
                fontSize: 30,
                color: '#43425d',
                wordWrap: true,
                align: 'center'
            };
            var modalText = this.add.text(this.game.scale.width/2, this.game.scale.height/2 + 10, "Your progress in this activity will not be saved. Are you sure you want to exit? ", modalTextStyle);
            modalText.setWordWrapWidth(modalBox.width - 110);//modalText.wordWrapWidth = modalBox.width - 110;
            modalText.setOrigin(0.5, 0.5);

            var modalYesBtn = this.add.sprite(modalBox.getBounds().left + 217, modalBox.getBounds().bottom - 179, 'assets', 'button-yes.png');
            modalYesBtn.setOrigin(0, 0)
            setupButton(modalYesBtn,  'button-yes.png', 'button-yes-hover.png');
            modalYesBtn.setInteractive({ cursor: 'pointer' });
            modalYesBtn.on('pointerup', this.exitGame, this);
            var modalNoBtn = this.add.sprite(modalYesBtn.getBounds().right - 43, modalBox.getBounds().bottom - 179, 'assets', 'button-no.png');
            modalNoBtn.setOrigin(0, 0)
            setupButton(modalNoBtn,  'button-no.png','button-no-hover.png');
            modalNoBtn.setInteractive({ cursor: 'pointer' });
            modalNoBtn.on('pointerup', this.exitGameCancel, this);

            modalYesBtn.on('pointerover', this.playHoverSound, this);
            modalYesBtn.on('pointerdown', this.playSelectionSound, this );

            modalNoBtn.on('pointerover', this.playHoverSound, this);
            modalNoBtn.on('pointerdown', this.playSelectionSound, this );

            this.modal.add(modalBg);
            this.modal.add(leavesLeftSprite);
            this.modal.add(leavesRightSprite);
            this.modal.add(modalBox);
            this.modal.add(warningIcon);
            this.modal.add(modalText);
            this.modal.add(modalYesBtn);
            this.modal.add(modalNoBtn);

            this.modal.visible = false;
            this.modal.alpha = 0;
        },

        showExitModal: function () {
            this.extiBtn.visible = false;
            this.modal.visible = true;
            this.modal.alpha = 1;
            this.time.paused = true;
            this.anims.pauseAll();
            this.tweens.pauseAll();
            this.sound.pauseAll();
            this.exitSound.play();
        },

        exitGame: function () {
            this.time.paused = false;
            this.anims.resumeAll();
            this.tweens.resumeAll();
            this.sound.resumeAll();
            window.localStorage.removeItem('currentState');

            if (this.bgMusic) {
                this.bgMusic.stop();
            }
            // window.localStorage.removeItem('wrongButtonKey');
            // this.game.state.start('StartGame', true, false);
            window.angularComponentRef.backToMenu();
        },
        exitGameCancel: function () {
            this.extiBtn.visible = true;
            this.modal.alpha = 0;
            this.modal.visible = false;
            this.time.paused = false;
            this.anims.resumeAll();
            this.tweens.resumeAll();
            this.sound.resumeAll();// this.scene.resume();//this.game.paused = false;
            this.bgMusic.resume();
        },
        onClickNextButton: function (p_isCloseDoor) {
            // this.game.sound.stopAll();
            currentQuestionIndex++;
            var storage = window.localStorage.getItem('payload');
            storage = JSON.parse(storage);
            storage.quizTimer = quizTimer;
            window.localStorage.setItem('payload', JSON.stringify(storage));
            if (storage && storage.questions) {
                var incorrectArr = [];
                for (var i = 0; i < storage.questions.length; i++) {
                    if (!storage.questions[i].correctAnswer) {
                        incorrectArr[incorrectArr.length] = storage.questions[i]
                    }
                }
                if (incorrectArr.length >= 4) {
                    if (this.bgMusic) {
                        this.bgMusic.stop();
                    }
                    this.scene.start("TryGame"/*, true, false*/);
                } else if (currentQuestionIndex < this.fdata.questions.length) {
                    isCloseDoor = p_isCloseDoor;
                    this.scene.start("Questions"/*, true, false, currentQuestionIndex, isCloseDoor*/);
                } else {
                    if (this.bgMusic) {
                        this.bgMusic.stop();
                    }
                    this.scene.start("EndGame"/*, true, false, this.quizTimer*/);
                }
            } else {
                if (this.bgMusic) {
                    this.bgMusic.stop();
                }
                this.scene.start("EndGame");
            }
        },
        calculatePoints: function (isMatch, points) {
            var storage = window.localStorage.getItem('payload');
            storage = JSON.parse(storage);

            if (storage) {
                var question = {
                    questionKey: this.questionItem.key,
                    correctAnswer: isMatch || false,
                    attempts: 1
                };
                storage.questions.push(question)
                storage.currentPoints = storage.currentPoints + points;
                storage.questions[currentQuestionIndex].points = points;

                window.localStorage.setItem('payload', JSON.stringify(storage));
            }
        },
        formatTime: function (s) {
            var minutes = "0" + Math.floor(s / 60);
            var seconds = "0" + (s - minutes * 60);
            return minutes.substr(-2) + ":" + seconds.substr(-2);
        },
        addAnswerSounds: function () {
            this.answerCorrectGoingIn = this.sound.add('answerCorrectGoingIn');
            this.answerCorrectGoingOut = this.sound.add('answerCorrectGoingOut');

            this.answerCorrectGoingInBgSound = this.sound.add('answerCorrectGoingInBgSound');

            this.answerWrongSwimmingOut = this.sound.add('answerWrongSwimmingOut');
            this.answerWrongSwimmingOutAndSwimIn = this.sound.add('answerWrongSwimmingOutAndSwimIn');

            this.doorOpenAudio = this.sound.add('door-open');
            this.doorCloseAudio = this.sound.add('door-close');
            this.exitSound = this.sound.add('exitSound');
            var self = this;
            /*this.game.onPause.add(function () {
                self.game.sound.unsetMute();
                // self.sound.stop();
                self.bgMusic.pause();
            })*/

            this.openBtnHoverSound = this.sound.add('openBtnHoverSound');
            this.openBtnSelectionSound = this.sound.add('openBtnSelectionSound');
        },
        playOpenHoverSound: function () {
            this.openBtnHoverSound.play();
        },
        playOpenSelectionSound: function () {
            this.openBtnSelectionSound.play();
        },
        playHoverSound: function () {
            this.hoverSound.play();
        },
        playSelectionSound: function () {
            this.selectionSound.play();
        },
        playOpenButtonHoverSound: function () {
            this.hoverOpenButton.play();
        }
    };

    //endGame
    var trygame = function (game) {
        console.log("%cTryGame", "color:white; background:blue");
    };

    trygame.prototype = {
        preload: function () {
            this.totalPoints = window.angularComponentRef.getTotalScore();
            // this.fdata = this.cache.binary.get('complete')
        },
        create: function () {
            console.log('trygame create');
            if (!this.tryAgainSound) {
                this.tryAgainSound = this.sound.add('tryAgainSound');
            }
            this.tryAgainSound.play();

            this.hoverSound = this.sound.add('hoverSound');
            this.selectionSound = this.sound.add('selectionSound');

            window.localStorage.removeItem('currentState');
            window.localStorage.removeItem('wrongButtonKey');

            var storageJson = window.localStorage.getItem('payload');
            var storage = JSON.parse(storageJson);
            var currentPoints = 0;
            if (storage) {
                // currentPoints = storage.currentPoints || 0;
            }
            // this.scale.pageAlignHorizontally = true;
            // this.scale.pageAlignVertically = true;

            this.add.sprite(0, 0, 'try-again-bg').setOrigin(0, 0);

            // this.game.stage.disableVisibilityChange = true; // keep animation run on focus out

            var totalScoreTextStyle = {
                backgroundColor: 'transparent',
                stroke: '#91301a',
                strokeThickness: 6,
                fontFamily: 'Kids Rock DEMO',
                fontSize: 39,
                wordWrap: false,
                align: 'left'
            };
            var totalScoreTextStyleOutline = {
                backgroundColor: 'transparent',
                stroke: '#fff',
                strokeThickness: 12,
                fontFamily: 'Kids Rock DEMO',
                fontSize: 39,
                wordWrap: false,
                align: 'left'
            };
            var collectedPointsTextStyle = {
                backgroundColor: 'transparent',
                stroke: '#91301a',
                strokeThickness: 2,
                fontFamily: 'Kids Rock DEMO',
                fontSize: 25,
                wordWrap: false,
                align: 'left',
                color: '#ffffff'
            };

            var modalBox = this.add.sprite(this.game.scale.width/2, this.game.scale.height/2, 'assets', 'activity-Instruction-board.png');
            modalBox.setOrigin(0.5, 0.5);
            var completeRibbon = this.add.sprite(modalBox.getCenter().x, modalBox.getBounds().top + 222, 'assets', 'try-again-ribbon.png');
            completeRibbon.setOrigin(0.5, 0.5);

            var totalScoreOutline = this.add.text(modalBox.getBounds().left + 340, modalBox.getBounds().bottom - 302, "Total Score: " + " " + this.totalPoints, totalScoreTextStyleOutline);
            var totalScore = this.add.text(modalBox.getBounds().left + 342, modalBox.getBounds().bottom - 300, "Total Score: " + " " + this.totalPoints, totalScoreTextStyle);

            var grd = totalScore.context.createLinearGradient(0, 0, 0, totalScore.height);
            grd.addColorStop(0, '#edee62');
            grd.addColorStop(0.2, '#edee62');
            grd.addColorStop(0.7, '#dd7b33');
            totalScore.setFill(grd);

            var collectedPointsMedal = this.add.sprite(modalBox.getBounds().left + 324, modalBox.getBounds().bottom - 244, 'assets', 'collected-poins-medal.png');
            collectedPointsMedal.setOrigin(0, 0)

            var collectedPoints = this.add.text(modalBox.getBounds().left + 422, modalBox.getBounds().bottom - 204, currentPoints, collectedPointsTextStyle);
            collectedPointsMedal.setOrigin(0, 0);

            // var trophy = this.add.sprite(modalBox.left+66, modalBox.bottom-355, 'trophy');
            var trophy = this.add.sprite(modalBox.getBounds().left + 210, modalBox.getBounds().bottom - 215, 'try-again-trophy');
            trophy.setScale(0.5, 0.5);
            trophy.setOrigin(0.5, 0.5);
            trophy.alpha = 0;
            this.tweens.add({
                targets: trophy,
                scaleX: 1,
                scaleY: 1,
                duration: 400,
                ease: Phaser.Math.Easing.Linear
            });
            this.tweens.add({
                targets: trophy,
                alpha: 1,
                duration: 400,
                ease: Phaser.Math.Easing.Linear
            });

            var backToMenuButton = this.add.sprite(modalBox.getBounds().left + 332, modalBox.getBounds().bottom - 89, 'assets', 'back-to-menu-button-hover.png');
            backToMenuButton.setOrigin(0, 0)
            setupButton(backToMenuButton,  'back-to-menu-button-hover.png','back-to-menu-button.png');
            backToMenuButton.setInteractive({ cursor: 'pointer' });
            backToMenuButton.on('pointerup', this.backToMenu, this);
            var playAgainButton = this.add.sprite(modalBox.getBounds().left + 479, modalBox.getBounds().bottom - 89, 'assets', 'play-again-button-hover.png');
            playAgainButton.setOrigin(0, 0)
            setupButton(playAgainButton,  'play-again-button-hover.png','play-again-button.png');
            playAgainButton.setInteractive({ cursor: 'pointer' });
            playAgainButton.on('pointerup', this.playAgain, this);

            backToMenuButton.on('pointerover', this.playHoverSound, this);
            backToMenuButton.on('pointerdown', this.playSelectionSound, this );

            playAgainButton.on('pointerover', this.playHoverSound, this);
            playAgainButton.on('pointerdown', this.playSelectionSound, this );
        },

        backToMenu: function () {
            console.log('back to menu button clicked');
            this.tryAgainSound.stop();
            window.angularComponentRef.backToMenu();
        },
        playAgain: function () {
            console.log('play again button clicked');
            this.tryAgainSound.stop()
            this.scene.start('StartGame');
        },
        playHoverSound: function () {
            this.hoverSound.play();
        },
        playSelectionSound: function () {
            this.selectionSound.play();
        }
    };

    //main
    game = new Phaser.Game({
        type: Phaser.AUTO,
        width: 980,
        height: 600,
        parent: 'game-container',
        dom: {
            createContainer: false
        },
        scale: {
            mode: Phaser.Scale.NONE,
            // autoCenter: Phaser.Scale.CENTER_BOTH
        },
        fps: {
            target: 60,
            forceSetTimeOut: true
        },
        transparent: true,
        scene: {
            create: () => {
                game.scene.add("Boot", boot, false);//game.state.add("Boot", boot);
                game.scene.add("StartGame", startgame);//game.state.add("StartGame", startgame);
                game.scene.add("ResumeGame", resumegame);//game.state.add("ResumeGame", resumegame);
                game.scene.add("Questions", questions);//game.state.add("Questions", questions);
                game.scene.add("EndGame", endgame);//game.state.add("EndGame", endgame);
                game.scene.add("TryGame", trygame);//game.state.add("TryGame", trygame);

                game.scene.start("Boot");//game.state.start("Boot");
            }
        }
    });
}
function destroyMatchTheWord() {
    if (game)
        game.destroy();
}

var game;
var sh;
function soundhive(json) {
    /**
     * @author Roman Parada
     * This class is created to fix overlapping of bottom part of canvas by navigation bar in iOS.
     * It make a delayed resize of the canvas (like Phaser-3 FIT methods does) and it overrides Phaser-3 input window to Phaser-3 core transform methods
     *
     * How to use:
     * Just call the code line below in Boot scene's init() method of your project:
     * new FitScaleManager(this.game).setup();
     */
    class FitScaleManager {
        constructor(game) {
            this.doResize = () => {
                let scale = this.calculateScale();
                let newCanvasWidth = this.phaserScaleManager.width * scale;
                let newCanvasHeight = this.phaserScaleManager.height * scale;
                this.canvasStyle.width = newCanvasWidth + 'px';
                this.canvasStyle.height = newCanvasHeight + 'px';
                this.canvasStyle.marginLeft = (window.innerWidth - newCanvasWidth) / 2 + 'px';
                this.canvasStyle.marginTop = (window.innerHeight - newCanvasHeight) / 2 + 'px';
            };
            this.game = game;
            this.canvasStyle = this.game.canvas.style;
            this.phaserScaleManager = this.game.scale;
        }
        static detectBestScaleMode() {
            let iOS = /iPad|iPhone|iPod/.test(navigator.platform || "");
            let isAndroid = window.navigator.userAgent.toLowerCase().indexOf("android") > -1;
            return iOS || isAndroid ? Phaser.Scale.FIT : Phaser.Scale.NONE;
        }
        ;
        /**
         * Just call this method once in Boot scene's init() method
         */
        setup() {
            this.phaserScaleManager.addListener(Phaser.Scale.Events.RESIZE, this.onResize, this);
            this.overridePhaserTransformMethods();
            this.onResize();
        }
        calculateScale() {
            if (game.scale.scaleMode === Phaser.Scale.NONE)
                return 1;
            return Math.min(window.innerWidth / this.phaserScaleManager.width, window.innerHeight / this.phaserScaleManager.height);
        }
        overridePhaserTransformMethods() {
            this.game.scale.transformX = (pageX) => {
                return (pageX - parseInt(this.canvasStyle.marginLeft.split("px")[0])) / this.calculateScale();
            };
            this.game.scale.transformY = (pageY) => {
                return (pageY - parseInt(this.canvasStyle.marginTop.split("px")[0])) / this.calculateScale();
            };
        }
        onResize() {
            setTimeout(this.doResize, FitScaleManager.RESIZE_DELAY);
        }
    }
    FitScaleManager.RESIZE_DELAY = 500;

    (function (sh) {
        class App extends Phaser.Game {
            constructor(json) {
                App.json = json;

                let config = {
                    type: Phaser.AUTO,
                    width: App.CANVAS_WIDTH,
                    height: App.CANVAS_HEIGHT,
                    parent: 'game-container',
                    dom: {
                        createContainer: false
                    },
                    scale: {
                        mode: FitScaleManager.detectBestScaleMode(),
                        autoCenter: Phaser.Scale.CENTER_BOTH
                    },
                    transparent: true,
                    scene: {
                        create: () => {
                            this.scene.add('Boot', sh.scene.Boot, true);
                        }
                    }
                };
                super(config);
            }
        }
        App.CANVAS_WIDTH = 980;
        App.CANVAS_HEIGHT = 600;
        sh.App = App;
    })(sh || (sh = {}));

    game = new sh.App(json);

    var delayedCalls = [];
    function delayedCall(delay, callback, args, callbackScope) {
        let scene = game.scene.getAt(0);
        if (scene) {
            let dc = scene.time.delayedCall(delay, callback, args, callbackScope);
            delayedCalls.push(dc);
            return dc;
        }
        let t = setTimeout(callback, delay);
        delayedCalls.push(t);
        return t;
    }

    function pauseAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.paused = true;
            }
        }
    }

    function resumeAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.paused = false;
            }
        }
    }

    function destroyAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.remove(false);
            }
            else {
                clearTimeout(dc);
            }
        }
        delayedCalls = [];
    }

    function setPageBackground(bg) {
        // document.querySelector("html").style.backgroundImage = "url(assets/games/soundhive/imgs/" + bg + ".jpg)";
    }

    function setupButton(btn, frame) {
        btn.on('pointerdown', () => { btn.setFrame(frame + '_hover' + '0000'); });
        btn.on('pointerover', () => { btn.setFrame(frame + '_hover' + '0000'); game.scene.getAt(0).sound.add("button hover").play(); });
        btn.on('pointerout', () => { btn.setFrame(frame + '0000'); });
        btn.on('pointerup', () => { btn.setFrame(frame + '0000'); game.scene.getAt(0).sound.add('activity selection - button selection').play(); });
    }

    function setupButtonTextureBased(btn, texture, hoverTexture) {
        btn.on('pointerdown', () => { btn.setTexture(hoverTexture); });
        btn.on('pointerover', () => { btn.setTexture(hoverTexture); game.scene.getAt(0).sound.add("button hover").play(); });
        btn.on('pointerout', () => { btn.setTexture(texture); });
        btn.on('pointerup', () => { btn.setTexture(texture); game.scene.getAt(0).sound.add('activity selection - button selection').play(); });
    }

    (function (sh) {
        var core;
        (function (core) {
            class Gameplay {
                constructor() {
                    this.currentRound = 0;
                    this.currentLetter = 0;
                    this.correctAnswersCount = 0;
                    this.wrongAnswersCount = 0;
                    this.nextLetterDelay = 0;
                    this.reset();
                    let json = game.cache.json.get('gameplay');
                    this.wrongAnswersToLose = json["wrongAnswersToLose"];
                    this.numberOfQuestionsPerRound = json["numberOfQuestionsPerRound"];
                    this.lettersConfig = JSON.parse(JSON.stringify(json["lettersConfig"]));
                    this.rounds = JSON.parse(JSON.stringify(json["rounds"]));
                    this.numberOfRounds = this.rounds.length;
                }
                setupCallbacks(onComplete, onLose) {
                    this.onComplete = onComplete;
                    this.onLose = onLose;
                }
                onLetterChosen() {
                    if (this.isNewRound()) {
                        if (this.currentRound >= this.numberOfRounds - 1) {
                            this.onComplete(this.correctAnswersCount, this.correctAnswersCount);
                            return true;
                        }
                        else {
                            this.nextRound();
                        }
                    }
                    return false;
                }
                nextRound() {
                    let fn = () => {
                        if (this.currentRound == this.rounds.length) {
                            this.currentRound = 0;
                        }
                        else {
                            this.currentRound++;
                        }
                    };
                    if (this.nextLetterDelay == 0) {
                        fn();
                    }
                    else {
                        delayedCall(this.nextLetterDelay, fn);
                    }
                }
                getCorrectLetterName() {
                    return this.rounds[this.currentRound]['correctLetterName'];
                }
                isCorrectLetterAudioQuestionEnable() {
                    return this.rounds[this.currentRound]['audioQuestionEnable'];
                }
                getCorrectAudioKey() {
                    return this.lettersConfig[this.getCorrectLetterName()]['correctAudioKey'];
                }
                getCorrectAndLetterSoundSfxAudioKey() {
                    return this.lettersConfig[this.getCorrectLetterName()]['Sounds of the letters'];
                }
                onCorrectAnswer() {
                    this.correctAnswersCount++;
                    this.nextLetterDelay = 1500;
                    return this.onLetterChosen();
                }
                onWrongAnswer() {
                    this.wrongAnswersCount++;
                    this.nextLetterDelay = 1500;
                    if (this.wrongAnswersCount >= this.wrongAnswersToLose) {
                        this.onLose(this.correctAnswersCount, this.correctAnswersCount);
                        return true;
                    }
                    else {
                        this.onLetterChosen();
                    }
                    return false;
                }
                getCurrentTotalAnswersCount() {
                    return this.correctAnswersCount + this.wrongAnswersCount;
                }
                isNewRound() {
                    return this.getCurrentTotalAnswersCount() % this.numberOfQuestionsPerRound == 0;
                }
                isRoundsComplete() {
                    return this.getCurrentTotalAnswersCount() / this.numberOfQuestionsPerRound >= this.numberOfRounds;
                }
                reset() {
                    this.nextLetterDelay = 0;
                    this.currentRound = 0;
                    this.correctAnswersCount = 0;
                    this.wrongAnswersCount = 0;
                }
                getCurrentRoundLetters() {
                    return this.rounds[this.currentRound]["letters"];
                }
            }
            core.Gameplay = Gameplay;
        })(core = sh.core || (sh.core = {}));
    })(sh || (sh = {}));

    (function (sh) {
        var scene;
        (function (scene) {
            class Boot extends Phaser.Scene {
                init() {
                    this.game.scale.transformX = (pageX) => {
                        let offsetLeft = 0;
                        let parentElement = game.canvas.parentElement;
                        while (parentElement) {
                            if (parentElement.offsetLeft) {
                                offsetLeft = parentElement.offsetLeft;
                                break;
                            }
                            parentElement = parentElement.parentElement;
                        }
                        return (pageX - offsetLeft) * this.game.scale.displayScale.x;
                    };
                    this.game.scale.transformY = (pageY) => {
                        let offsetTop = 0;
                        let parentElement = game.canvas.parentElement;
                        while (parentElement) {
                            if (parentElement.offsetTop) {
                                offsetTop = parentElement.offsetTop;
                                break;
                            }
                            parentElement = parentElement.parentElement;
                        }
                        return (pageY - offsetTop) * this.game.scale.displayScale.y;
                    };
                }
                create() {
                    game.scene.remove('Boot');
                    game.scene.add('Preloader', sh.scene.Preloader, true);
                }
            }
            scene.Boot = Boot;
        })(scene = sh.scene || (sh.scene = {}));
    })(sh || (sh = {}));

    (function (sh) {
        var scene;
        (function (scene) {
            var Gameplay = sh.core.Gameplay;
            class MainScene extends Phaser.Scene {
                create() {
                    this.gameplay = new Gameplay();
                    this.gameplayScreen = new sh.screen.GameplayScreen(this, this.gameplay);
                    this.children.add(this.gameplayScreen);
                    this.gameplayScreen.showInstructionPage();
                }
            }
            scene.MainScene = MainScene;
        })(scene = sh.scene || (sh.scene = {}));
    })(sh || (sh = {}));

    (function (sh) {
        var scene;
        (function (scene) {
            class Preloader extends Phaser.Scene {
                preload() {
                    if (typeof sh.App.json == "string") this.load.json('gameplay', sh.App.json); else this.game.cache.json.add('gameplay', sh.App.json);
                }
                create() {
                    let json = game.cache.json.get('gameplay');
                    let lettersConfig = json["lettersConfig"];

                    for (var i = 0; i < json['secondaryImages'].length; i++) {
                        this.load.image(json['secondaryImages'][i], "assets/games/soundhive/imgs/letters/" + json['secondaryImages'][i] + ".png");
                    }

                    for (let letterName in lettersConfig) {
                        let correctAudioKey = lettersConfig[letterName]["correctAudioKey"];
                        this.load.audio(correctAudioKey, "assets/games/soundhive/sound/mp3/letters/" + correctAudioKey.replace(".wav", ".mp3"));
                        this.load.audio("CS-" + lettersConfig[letterName]["Sounds of the letters"], "assets/games/soundhive/sound/mp3/letters/Sounds of the letters/" + lettersConfig[letterName]["Sounds of the letters"].replace(".wav", ".mp3"));
                    }
                    this.load.pack('preloader', 'assets/games/soundhive/pack.json');
                    this.load.on('progress', (value) => {
                    }, this);
                    this.load.on('complete', () => {
                        this.nextScene();
                    });
                    this.load.start();
                }
                nextScene() {
                    game.scene.remove('Preloader');
                    game.scene.add('ScreenMain', sh.scene.MainScene, true);
                }
            }
            scene.Preloader = Preloader;
        })(scene = sh.scene || (sh.scene = {}));
    })(sh || (sh = {}));
    (function (sh) {
        var screen;
        (function (screen) {
            class AreYouSureWindow extends Phaser.GameObjects.Container {
                constructor(scene, onYes, onNo) {
                    super(scene);
                    this._areYouSurePage = new Phaser.GameObjects.Image(this.scene, -105, 0 - 48, 'Exit warning');
                    this._areYouSurePage.setOrigin(0, 0);
                    this._areYouSurePage.setInteractive();
                    var modalTextStyle = {
                        backgroundColor: 'transparent',
                        stroke: '#ffffff',
                        strokeThickness: 2,
                        lineSpacing: 15,
                        fontFamily: 'Kids Rock DEMO',
                        fontSize: 27,
                        color: '#43425d',
                        wordWrap: true,
                        align: 'center'
                    };
                    var modalText = this.scene.add.text(game.scale.width / 2 + 12, game.scale.height / 2, "Your progress in this activity will not be saved. \n Are you sure you want to exit? ", modalTextStyle);
                    modalText.setOrigin(0.5, 0.5);

                    this._btnSureYes = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2 - 95, 485 - 50, 'btnYES1');
                    this._btnSureYes.setInteractive({ cursor: 'pointer' });
                    this._btnSureYes.once('pointerup', () => {
                        onYes;
                        angularComponentRef.backToMenu();
                    });


                    setupButtonTextureBased(this._btnSureYes, 'btnYES1', 'btnYES2');
                    this._btnSureNo = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2 + 95, 485 - 50, 'btnNO1');
                    this._btnSureNo.setInteractive({ cursor: 'pointer' });
                    this._btnSureNo.once('pointerup', onNo);
                    setupButtonTextureBased(this._btnSureNo, 'btnNO1', 'btnNO2');
                    this.add(this._areYouSurePage);
                    this.add(this._btnSureYes);
                    this.add(this._btnSureNo);
                    this.add(modalText);

                }
            }
            screen.AreYouSureWindow = AreYouSureWindow;
        })(screen = sh.screen || (sh.screen = {}));
    })(sh || (sh = {}));

    (function (sh) {
        var screen;
        (function (screen) {
            class CompleteWindow extends Phaser.GameObjects.Container {
                constructor(scene, onBack, onReplay, onNext) {
                    super(scene);
                    this.music = null;
                    this.setPosition(-104.5, -48);
                    this._bgComplete = new Phaser.GameObjects.Image(this.scene, 0, 0, 'Completion page LATEST UPDATED');
                    this._bgComplete.setOrigin(0, 0);
                    this._bgComplete.setInteractive();
                    this._cup = new Phaser.GameObjects.Image(this.scene, 400, 410, 'Trophy');
                    this._btnBack = new Phaser.GameObjects.Image(this.scene, 570, 570, 'btnBACK1');
                    this._btnReplay = new Phaser.GameObjects.Image(this.scene, 720, 570, 'btnReplay1');
                    this._btnNext = new Phaser.GameObjects.Image(this.scene, 870, 570, 'btnNEXT1');
                    let _CollectedPoints = new Phaser.GameObjects.Image(this.scene, 620, 440, 'Collected Points');
                    this.totalScoreTxt = this.scene.add.text(845, 352, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 35,
                        "color": "#F49F1C",
                        "align": 'center',
                        'stroke': '#70451A',
                        'strokeThickness': 6
                    });
                    this.totalScoreTxt.setOrigin(0.5, 0.5);
                    let grd = this.totalScoreTxt.context.createLinearGradient(0, 0, 0, this.totalScoreTxt.height);
                    grd.addColorStop(0, '#FFFF00');
                    grd.addColorStop(1, '#C17316');
                    this.totalScoreTxt.setFill(grd);
                    this.starScoreTxt = this.scene.add.text(648, 433, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 24,
                        "color": "#FFFFFF",
                        "align": 'center'
                    });
                    this.starScoreTxt.setOrigin(0.5, 0.5);
                    this.add([
                        this._bgComplete,
                        _CollectedPoints,
                        this._cup,
                        this._btnBack,
                        this._btnReplay,
                        this._btnNext,
                        this.totalScoreTxt,
                        this.starScoreTxt
                    ]);
                    this._btnBack.setInteractive({ cursor: 'pointer' });
                    this._btnBack.on('pointerup', () => {
                        onBack(this._btnBack);
                        angularComponentRef.backToMenu();
                        // if (this.music) {
                        //     this.music.stop();
                        // }
                    });
                    setupButtonTextureBased(this._btnBack, 'btnBACK1', 'btnBACK2');
                    this._btnReplay.setInteractive({ cursor: 'pointer' });
                    this._btnReplay.once('pointerup', () => {
                        onReplay(this._btnReplay);
                        if (this.music) {
                            this.music.stop();
                        }
                    });
                    setupButtonTextureBased(this._btnReplay, 'btnReplay1', 'btnReplay2');
                    this._btnNext.setInteractive({ cursor: 'pointer' });
                    this._btnNext.on('pointerup', () => {
                        onNext(this._btnNext);
                        window.angularComponentRef.nextActivity()
                    });
                    setupButtonTextureBased(this._btnNext, 'btnNEXT1', 'btnNEXT2');
                }
                show(score, starScore) {
                    window.angularComponentRef.gameFinish({ score, starScore })
                    this._cup.scale = 1.25;
                    this.scene.tweens.add({
                        targets: this._cup,
                        "scale": 1,
                        duration: 500,
                        ease: Phaser.Math.Easing.Back.Out
                    });
                    this.totalScoreTxt.text = String(window.angularComponentRef.component.userInfo.totalScore);
                    this.starScoreTxt.text = String(starScore);
                    // let music = this.scene.sound.add("viktory");
                    this.music = this.scene.sound.add("Activity completion fantastic");
                    this.music.play();
                }
            }
            screen.CompleteWindow = CompleteWindow;
        })(screen = sh.screen || (sh.screen = {}));
    })(sh || (sh = {}));

    (function (sh) {
        var screen;
        (function (screen) {
            class GameplayScreen extends Phaser.GameObjects.Container {
                constructor(scene, gameplay) {
                    super(scene);
                    this.hexagonPositions = [{ x: 595 - 105, y: 152 - 50 }, { x: 595 - 105, y: 500 - 50 }, { x: 422 - 105, y: 240 - 50 }, { x: 595 - 105, y: 326 - 50 }, { x: 768 - 105, y: 240 - 50 }, { x: 422 - 105, y: 414 - 50 }, { x: 770 - 105, y: 414 - 50 }];
                    this.bgMusic = null;
                    this.correctAudio = null;
                    this.wfsnd = null;
                    this.showCompleteWindow = (score, starScore) => {
                        let completeWindow = new screen.CompleteWindow(this.scene, (target) => {
                            this.playBtnClickAnim(target);
                        }, (target) => {
                            this.playBtnClickAnim(target);
                            this.destroyGameplay();
                            this.remove(completeWindow);
                            this.showInstructionPage();
                        }, (target) => {
                            this.playBtnClickAnim(target);
                        });
                        this.setLettersInputEnabled(false);
                        delayedCall(1750, () => {
                            setPageBackground("bg-blue");
                            this.add(completeWindow);
                            completeWindow.show(score, starScore);
                            this.bgMusic.stop();
                        });
                    };
                    this.showLoseWindow = (score, starScore) => {
                        let tryAgainWindow = new screen.TryAgainWindow(this.scene, (target) => {
                            this.playBtnClickAnim(target);
                        }, (target) => {
                            this.playBtnClickAnim(target);
                            this.destroyGameplay();
                            this.remove(tryAgainWindow);
                            this.showInstructionPage();
                        });
                        this.setLettersInputEnabled(false);
                        delayedCall(1750, () => {
                            setPageBackground("bg-blue");
                            this.add(tryAgainWindow);
                            tryAgainWindow.show(score, starScore);
                            this.bgMusic.stop();
                        });
                    };
                    this.gameplay = gameplay;
                    window["t"] = this;
                }
                createHexagons() {
                    this.hexagons = [];
                    for (let p of this.hexagonPositions) {
                        let hc = new Phaser.GameObjects.Container(this.scene, this.hexagonPositions[3]['x'], this.hexagonPositions[3]['y']);
                        let h = new Phaser.GameObjects.Image(this.scene, 0, 0, 'hexagon');
                        hc.add(h);
                        hc["bg"] = h;
                        hc["_hexagon_correct"] = new Phaser.GameObjects.Image(this.scene, 0, 0, '1 Correct Hover Effects');
                        hc.add(hc["_hexagon_correct"]);
                        hc["_hexagon_wrong"] = new Phaser.GameObjects.Image(this.scene, 0, 0, '1 wrong Hover Effects');
                        hc.add(hc["_hexagon_wrong"]);
                        hc["_hexagon_correct"].visible = hc["_hexagon_wrong"].visible = false;
                        hc["defX"] = p['x'];
                        hc["defY"] = p['y'];
                        this.hexagons.push(hc);
                    }
                    this.gameplayContainer.add(this.hexagons);
                }
                createLetters() {
                    if (this.letters) {
                        for (let l of this.letters) {
                            l.parentContainer["letter"] = null;
                            l["hexagon"] = null;
                            l.parentContainer.remove(l);
                        }
                    }
                    this.letters = [];
                    let _letters = this.gameplay.getCurrentRoundLetters();
                    for (let n of _letters) {
                        let l = new Phaser.GameObjects.Image(this.scene, 0, 0, n);
                        this.letters.push(l);
                    }
                }
                showGameplay() {
                    setPageBackground("bg-australia");
                    this.bgMusic = this.scene.sound.add("bg_sound");
                    this.bgMusic.play();
                    this.bgMusic.loop = true;
                    this.gameplay.reset();
                    this._gameStage = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2, game.scale.height / 2, 'Sound Hive Final');
                    this._gameStage.setOrigin(0.488, 0.476);
                    this._gameStage.setInteractive();
                    let rr = new Phaser.GameObjects.Image(this.scene, 958 - 105, 570 - 50, 'Rounded Rectangle 602');
                    rr.setScale(0.75, 1.4);
                    this._btnSound = new Phaser.GameObjects.Image(this.scene, 160 - 105, 100 - 50, 'Sound');
                    this._btnSound.setInteractive({ cursor: 'pointer' });
                    this._btnSound["defScale"] = this._btnSound.scale;
                    setupButtonTextureBased(this._btnSound, 'Sound', 'Sound HOVER EFFECT');
                    this._btnClose = new Phaser.GameObjects.Image(this.scene, 1025 - 105, 100 - 50, 'x Button');
                    this._btnClose.setInteractive({ cursor: 'pointer' });
                    this._btnClose["defScale"] = this._btnClose.scale;
                    setupButtonTextureBased(this._btnClose, 'x Button', 'x Button HOVER EFFECT');
                    this.gameplayContainer = new Phaser.GameObjects.Container(this.scene);
                    this.addAt(this.gameplayContainer, 0);
                    this.gameplayContainer.add([
                        this._gameStage,
                        rr,
                        this._btnSound,
                        this._btnClose
                    ]);
                    this.createBeehives();
                    this.createHexagons();
                    this.shuffleOutHexagons();
                    this.createInput();
                    this.gameplay.setupCallbacks(this.showCompleteWindow, this.showLoseWindow);
                }
                createBeehives() {
                    let startX = 878 - 105;
                    let startY = 532 - 50;
                    let dx = 39;
                    let dy = 39;
                    let _BeehiveEmptyArrayPositions = [];
                    for (let i = 0; i < 3; i++) {
                        for (let j = 0; j < 5; j++) {
                            _BeehiveEmptyArrayPositions.push({ x: startX + j * dx, y: startY + i * dy });
                        }
                    }
                    this._BeehiveEmptyArray = [];
                    this._Beehive = [];
                    for (let p of _BeehiveEmptyArrayPositions) {
                        let _BeehiveEmpty = new Phaser.GameObjects.Image(this.scene, p['x'], p['y'], 'Beehive 1 Empty');
                        this._BeehiveEmptyArray.push(_BeehiveEmpty);
                        _BeehiveEmpty.visible = false;
                        let _Beehive = new Phaser.GameObjects.Image(this.scene, p['x'], p['y'], 'Beehive 1');
                        this._Beehive.push(_Beehive);
                    }
                    for (let bea of this._BeehiveEmptyArray) {
                        this.gameplayContainer.add(bea);
                    }
                    for (let bee of this._Beehive) {
                        this.gameplayContainer.add(bee);
                        bee.visible = false;
                    }
                }
                randomizeLettersPosition() {
                    let hx = this.hexagons.slice();
                    for (let l of this.letters) {
                        if (hx.length == 0)
                            return;
                        let hc = Phaser.Utils.Array.RemoveRandomElement(hx);
                        hc.add(l);
                        hc["letter"] = l;
                        l["hexagon"] = hc;
                    }
                }
                updateHexagonsArrange() {
                    for (let hc of this.hexagons) {
                        if (!hc["letter"]) {
                            hc.parentContainer.bringToTop(hc);
                            break;
                        }
                    }
                }
                shuffleOutHexagons() {
                    if (this.gameplay.isNewRound()) {
                        if (!this.gameplay.isRoundsComplete()) {
                            this.createLetters();
                            this.randomizeLettersPosition();
                        }
                    }

                    this.setLettersInputEnabled(false);
                    this.updateHexagonsArrange();
                    let positions = this.hexagonPositions.slice();
                    for (let hc of this.hexagons) {
                        let rndP = Phaser.Utils.Array.RemoveRandomElement(positions);
                        this.scene.tweens.add({
                            targets: hc,
                            "x": rndP['x'],
                            "y": rndP['y'],
                            duration: 300,
                            delay: 500
                        });
                    }
                    delayedCall(450, () => {
                        this.scene.sound.add('spread from centre').play();
                    });
                    delayedCall(1200, () => {
                        let setLettersInputEnabled = () => {
                            if (this.correctAudio && this.correctAudio.isPlaying) {
                                delayedCall((this.correctAudio.duration * 0.75) * 1000, () => {
                                    this.setLettersInputEnabled(true);
                                });
                            }
                            else {
                                this.setLettersInputEnabled(true);
                            }
                        };
                        if (this.gameplay.isNewRound()) {
                            if (!this.gameplay.isRoundsComplete()) {
                                if (this.gameplay.isCorrectLetterAudioQuestionEnable()) {
                                    this.playCorrectAudio();
                                }
                                setLettersInputEnabled();
                            }
                        }
                        else {
                            setLettersInputEnabled();
                        }
                    });
                }
                shuffleInHexagons() {
                    this.updateHexagonsArrange();
                    let positions = this.hexagonPositions.slice();
                    this.setLettersInputEnabled(false);
                    for (let hc of this.hexagons) {
                        let posX = hc.x;
                        let posY = hc.y;
                        this.scene.tweens.add({
                            targets: hc,
                            "x": this.hexagonPositions[3]['x'],
                            "y": this.hexagonPositions[3]['y'],
                            duration: 300,
                            delay: 700,
                            onComplete: () => {
                                hc["_hexagon_correct"].visible = hc["_hexagon_wrong"].visible = false;
                            }
                        });
                    }
                    delayedCall(600, () => {
                        this.scene.sound.add('move to centre').play();
                    });
                    delayedCall(1000, () => {
                        this.shuffleOutHexagons();
                    });
                }
                createInput() {
                    for (let hc of this.hexagons) {
                        hc["bg"].on('pointerup', () => {
                            let l = hc["letter"];
                            this.setLettersInputEnabled(false);
                            this.playBtnClickAnim(hc);
                            let lost = false;
                            let correctAnswer = l && l.texture.key == this.gameplay.getCorrectLetterName();
                            if (correctAnswer) {
                                hc["_hexagon_wrong"].visible = false;
                                hc["_hexagon_correct"].visible = true;
                                let completed = this.onCorrectAnswer();
                                if (!completed) {
                                    delayedCall(1000, () => this.shuffleInHexagons());
                                }
                            }
                            else {
                                hc["_hexagon_wrong"].visible = true;
                                hc["_hexagon_correct"].visible = false;
                                lost = this.onWrongAnswer();
                                if (!lost) {
                                    delayedCall(1000, () => this.shuffleInHexagons());
                                }
                            }
                            if (!lost) {
                                delayedCall(2500, () => {
                                    if (!this.gameplay.isNewRound()) {
                                        if (this.gameplay.isCorrectLetterAudioQuestionEnable()) {
                                            this.playCorrectAudio();
                                        }
                                    }
                                });
                            }
                        });
                    }
                    this._btnSound.on('pointerup', () => {
                        this.playBtnClickAnim(this._btnSound);
                        this.onSoundClick();
                    });
                    this._btnClose.on('pointerup', () => {
                        this.playBtnClickAnim(this._btnClose);
                        this.onCloseClick();
                    });
                }
                hideAllUnusedBeehives() {
                    let i = this.gameplay.getCurrentTotalAnswersCount();
                    for (let k = i + 1; k < this._BeehiveEmptyArray.length; k++) {
                        this._BeehiveEmptyArray[k].visible = false;
                        this._Beehive[k].visible = false;
                    }
                }
                onCorrectAnswer() {
                    let i = this.gameplay.getCurrentTotalAnswersCount();
                    if (i < this._BeehiveEmptyArray.length) {
                        this._BeehiveEmptyArray[i].visible = false;
                        this._Beehive[i].visible = true;
                    }
                    this.hideAllUnusedBeehives();
                    let completed = this.gameplay.onCorrectAnswer();
                    this.scene.sound.add('correct and letter sound sfx').play();
                    delayedCall(750, () => {
                        this.scene.sound.add("CS-" + this.gameplay.getCorrectAndLetterSoundSfxAudioKey()).play();
                    });
                    return completed;
                }
                onWrongAnswer() {
                    let i = this.gameplay.getCurrentTotalAnswersCount();
                    if (i < this._BeehiveEmptyArray.length) {
                        this._BeehiveEmptyArray[i].visible = true;
                        this._Beehive[i].visible = false;
                    }
                    this.hideAllUnusedBeehives();
                    let lost = this.gameplay.onWrongAnswer();
                    this.scene.sound.add("wrong sfx").play();
                    return lost;
                }
                playCorrectAudio() {
                    if (this.correctAudio) {
                        this.correctAudio.stop();
                    }
                    this.correctAudio = this.scene.sound.add(this.gameplay.getCorrectAudioKey());
                    this.correctAudio.play();
                    if (this.areYouSureWindow && this.areYouSureWindow.parentContainer == this) {
                        this.correctAudio.pause();
                    }
                }
                onSoundClick() {
                    this.playCorrectAudio();
                }
                onCloseClick() {
                    this.showAreYouSurePage();
                    this.scene.sound.add('warning page pop up sfx').play();
                }
                playBtnClickAnim(target) {
                    let sc = target["defScale"] ? target["defScale"] : 1;
                    target.scaleX = target.scaleY = sc;
                    this.scene.tweens.add({
                        targets: target,
                        "scaleX": 0.9 * sc,
                        "scaleY": 0.9 * sc,
                        duration: 100,
                        yoyo: true
                    });
                }
                showInstructionPage() {
                    setPageBackground("bg-blue");
                    this.instructionPage = new screen.InstructionPage(this.scene, (target) => {
                        this.playBtnClickAnim(target);
                        this.remove(this.instructionPage);
                        this.showGameplay();
                        if (this.wfsnd) {
                            this.wfsnd.stop();
                        }
                    }, (target) => {
                        this.playBtnClickAnim(target);
                        if (this.wfsnd) {
                            this.wfsnd.stop();
                        }
                        this.wfsnd = this.scene.sound.add("Welcome Find the sound");
                        this.wfsnd.play();
                    });
                    this.add(this.instructionPage);
                    try {
                        this.wfsnd = this.scene.sound.add("Welcome Find the sound");
                        this.wfsnd.play();
                    }
                    catch (e) {
                        console.error(e);
                    }
                }
                showAreYouSurePage() {
                    pauseAllDelayedCalls();
                    setPageBackground("bg-blue");
                    this.pauseSounds();
                    this.areYouSureWindow = new screen.AreYouSureWindow(this.scene, () => {
                        this.remove(this.areYouSureWindow);
                        this.destroyGameplay();
                        this.showInstructionPage();
                    }, () => {
                        this.remove(this.areYouSureWindow);
                        this.unpauseSounds();
                        resumeAllDelayedCalls();
                        setPageBackground("bg-australia");
                    });
                    this.add(this.areYouSureWindow);
                }
                setLettersInputEnabled(enabled) {
                    if (enabled) {
                        for (let hc of this.hexagons) {
                            hc["bg"].setInteractive({ cursor: 'pointer' });
                        }
                    }
                    else {
                        for (let hc of this.hexagons) {
                            hc["bg"].disableInteractive();
                        }
                    }
                }
                pauseSounds() {
                    if (this.correctAudio)
                        this.correctAudio.pause();
                    if (this.bgMusic)
                        this.bgMusic.pause();
                }
                unpauseSounds() {
                    if (this.correctAudio)
                        this.correctAudio.resume();
                    if (this.bgMusic)
                        this.bgMusic.resume();
                }
                destroyGameplay() {
                    this.setLettersInputEnabled(false);
                    this.remove(this.gameplayContainer);
                    destroyAllDelayedCalls();
                }
            }
            screen.GameplayScreen = GameplayScreen;
        })(screen = sh.screen || (sh.screen = {}));
    })(sh || (sh = {}));
    (function (sh) {
        var screen;
        (function (screen) {
            class InstructionPage extends Phaser.GameObjects.Container {
                constructor(scene, onPlayClick, onSndClick) {
                    super(scene);
                    this._instructionPage = new Phaser.GameObjects.Image(this.scene, 0 - 105, 0 - 48, 'Instructions page  ALL ACTIVITY  TITLEs');
                    this._instructionPage.setOrigin(0, 0);
                    this._instructionPage.setInteractive();
                    this._instructionPageTitle = new Phaser.GameObjects.Image(this.scene, 495, 105, 'welcome');
                    this._instructionPageTitle.setScale(0.8);
                    this._btnPlay = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2, 480 - 50, 'btnPLAY1');
                    this._btnPlay.setInteractive({ cursor: 'pointer' });
                    this._btnPlay.once('pointerup', onPlayClick);
                    setupButtonTextureBased(this._btnPlay, 'btnPLAY1', 'btnPLAY2');
                    this.instrTxt = this.scene.add.text(game.scale.width / 2, game.scale.height / 2, "Help the bee find the sound.", {
                        "fontFamily": "Kids Rock DEMO",
                        "fontSize": 30,
                        "color": "#43425D",
                        "align": 'center'
                    });
                    this.instrTxt.setOrigin(0.5, 0.5);
                    this._btnSoundInstruction = new Phaser.GameObjects.Image(this.scene, 800 - 105, 156 - 50, 'Sound');
                    this._btnSoundInstruction.setInteractive({ cursor: 'pointer' });
                    this._btnSoundInstruction.on('pointerup', onSndClick);
                    this._btnSoundInstruction["defScale"] = this._btnSoundInstruction.scale;
                    setupButtonTextureBased(this._btnSoundInstruction, 'Sound', 'Sound HOVER EFFECT');
                    this.add(this._instructionPage);
                    this.add(this._instructionPageTitle);
                    this.add(this.instrTxt);
                    this.add(this._btnPlay);
                    this.add(this._btnSoundInstruction);
                }
            }
            screen.InstructionPage = InstructionPage;
        })(screen = sh.screen || (sh.screen = {}));
    })(sh || (sh = {}));
    (function (sh) {
        var screen;
        (function (screen) {
            class TryAgainWindow extends Phaser.GameObjects.Container {
                constructor(scene, onBack, onReplay) {
                    super(scene);
                    this.music = null;
                    this.setPosition(-106, -48);
                    this._bg = new Phaser.GameObjects.Image(this.scene, 0, 0, 'Try again page');
                    this._bg.setOrigin(0, 0);
                    this._bg.setInteractive();
                    this._star = new Phaser.GameObjects.Image(this.scene, 400, 415, 'Break Star');
                    this._btnBack = new Phaser.GameObjects.Image(this.scene, 600, 580, 'btnBACK1');
                    this._btnReplay = new Phaser.GameObjects.Image(this.scene, 765, 580, 'btnReplay1');
                    this.totalScoreTxt = this.scene.add.text(830, 355, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 35,
                        "color": "#F49F1C",
                        "align": 'center',
                        'stroke': '#70451A',
                        'strokeThickness': 6
                    });
                    this.totalScoreTxt.setOrigin(0.5, 0.5);
                    let grd = this.totalScoreTxt.context.createLinearGradient(0, 0, 0, this.totalScoreTxt.height);
                    grd.addColorStop(0, '#FFFF00');
                    grd.addColorStop(1, '#C17316');
                    this.totalScoreTxt.setFill(grd);
                    this.starScoreTxt = this.scene.add.text(635, 431, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 24,
                        "color": "#FFFFFF",
                        "align": 'center'
                    });
                    this.starScoreTxt.setOrigin(0.5, 0.5);
                    this.add([
                        this._bg,
                        this._star,
                        this._btnBack,
                        this._btnReplay,
                        this.totalScoreTxt,
                        this.starScoreTxt
                    ]);
                    this._btnBack.setInteractive({ cursor: 'pointer' });
                    this._btnBack.on('pointerup', () => {
                        onBack(this._btnBack);
                        angularComponentRef.backToMenu();
                        // if (this.music) {
                        //     this.music.stop();
                        // }
                    });
                    setupButtonTextureBased(this._btnBack, 'btnBACK1', 'btnBACK2');
                    this._btnReplay.setInteractive({ cursor: 'pointer' });
                    this._btnReplay.once('pointerup', () => {
                        onReplay(this._btnReplay);
                        if (this.music) {
                            this.music.stop();
                        }
                    });
                    setupButtonTextureBased(this._btnReplay, 'btnReplay1', 'btnReplay2');
                }
                show(score, starScore) {
                    this._star.scale = 1.25;
                    this.scene.tweens.add({
                        targets: this._star,
                        "scale": 1,
                        duration: 500,
                        ease: Phaser.Math.Easing.Back.Out
                    });
                    this.totalScoreTxt.text = String(window.angularComponentRef.component.userInfo.totalScore);
                    this.starScoreTxt.text = String(0);
                    this.music = this.scene.sound.add("Fail - close one");
                    this.music.play();
                }
            }
            screen.TryAgainWindow = TryAgainWindow;
        })(screen = sh.screen || (sh.screen = {}));
    })(sh || (sh = {}));
}

function destroySoundHive() {
    if (game) {
        game.destroy();
    }
}

var game;
var sh;
function truckRace(json) {
    /**
     * @author Roman Parada
     * This class is created to fix overlapping of bottom part of canvas by navigation bar in iOS.
     * It make a delayed resize of the canvas (like Phaser-3 FIT methods does) and it overrides Phaser-3 input window to Phaser-3 core transform methods
     *
     * How to use:
     * Just call the code line below in Boot scene's init() method of your project:
     * new FitScaleManager(this.game).setup();
     */
    class FitScaleManager {
        constructor(game) {
            this.doResize = () => {
                let scale = this.calculateScale();
                let newCanvasWidth = this.phaserScaleManager.width * scale;
                let newCanvasHeight = this.phaserScaleManager.height * scale;
                this.canvasStyle.width = newCanvasWidth + 'px';
                this.canvasStyle.height = newCanvasHeight + 'px';
                this.canvasStyle.marginLeft = (window.innerWidth - newCanvasWidth) / 2 + 'px';
                this.canvasStyle.marginTop = (window.innerHeight - newCanvasHeight) / 2 + 'px';
            };
            this.game = game;
            this.canvasStyle = this.game.canvas.style;
            this.phaserScaleManager = this.game.scale;
        }
        static detectBestScaleMode() {
            let iOS = /iPad|iPhone|iPod/.test(navigator.platform || "");
            let isAndroid = window.navigator.userAgent.toLowerCase().indexOf("android") > -1;
            return iOS || isAndroid ? Phaser.Scale.FIT : Phaser.Scale.NONE;
        }
        ;
        /**
         * Just call this method once in Boot scene's init() method
         */
        setup() {
            this.phaserScaleManager.addListener(Phaser.Scale.Events.RESIZE, this.onResize, this);
            this.overridePhaserTransformMethods();
            this.onResize();
        }
        calculateScale() {
            if (game.scale.scaleMode === Phaser.Scale.NONE)
                return 1;
            return Math.min(window.innerWidth / this.phaserScaleManager.width, window.innerHeight / this.phaserScaleManager.height);
        }
        overridePhaserTransformMethods() {
            this.game.scale.transformX = (pageX) => {
                return (pageX - parseInt(this.canvasStyle.marginLeft.split("px")[0])) / this.calculateScale();
            };
            this.game.scale.transformY = (pageY) => {
                return (pageY - parseInt(this.canvasStyle.marginTop.split("px")[0])) / this.calculateScale();
            };
        }
        onResize() {
            setTimeout(this.doResize, FitScaleManager.RESIZE_DELAY);
        }
    }
    FitScaleManager.RESIZE_DELAY = 500;

    (function (sh) {
        class App extends Phaser.Game {
            constructor(json) {
                App.json = json;

                let config = {
                    type: Phaser.AUTO,
                    width: App.CANVAS_WIDTH,
                    height: App.CANVAS_HEIGHT,
                    parent: 'game-container',
                    dom: {
                        createContainer: false
                    },
                    scale: {
                        mode: FitScaleManager.detectBestScaleMode(),
                        autoCenter: Phaser.Scale.CENTER_BOTH
                    },
                    transparent: true,
                    scene: {
                        create: () => {
                            this.scene.add('Boot', sh.scene.Boot, true);
                        }
                    }
                };
                super(config);
            }
        }
        App.CANVAS_WIDTH = 980;
        App.CANVAS_HEIGHT = 600;
        sh.App = App;
    })(sh || (sh = {}));

    game = new sh.App(json);

    var delayedCalls = [];
    function delayedCall(delay, callback, args, callbackScope) {
        let scene = game.scene.getAt(0);
        if (scene) {
            let dc = scene.time.delayedCall(delay, callback, args, callbackScope);
            delayedCalls.push(dc);
            return dc;
        }
        let t = setTimeout(callback, delay);
        delayedCalls.push(t);
        return t;
    }

    function pauseAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.paused = true;
            }
        }
    }

    function resumeAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.paused = false;
            }
        }
    }

    function destroyAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.remove(false);
            }
            else {
                clearTimeout(dc);
            }
        }
        delayedCalls = [];
    }

    function setPageBackground(bg) {
        // document.querySelector("html").style.backgroundImage = "url(assets/games/truck-race/imgs/" + bg + ".jpg)";
    }

    function setupButton(btn, frame) {
        btn.on('pointerdown', () => { btn.setFrame(frame + '_hover' + '0000'); });
        btn.on('pointerover', () => { btn.setFrame(frame + '_hover' + '0000'); game.scene.getAt(0).sound.add("button hover").play(); });
        btn.on('pointerout', () => { btn.setFrame(frame + '0000'); });
        btn.on('pointerup', () => { btn.setFrame(frame + '0000'); game.scene.getAt(0).sound.add('activity selection - button selection').play(); });
    }

    function setupButtonTextureBased(btn, texture, hoverTexture) {
        btn.on('pointerdown', () => { btn.setTexture(hoverTexture); });
        btn.on('pointerover', () => { btn.setTexture(hoverTexture); game.scene.getAt(0).sound.add("button hover").play(); });
        btn.on('pointerout', () => { btn.setTexture(texture); });
        btn.on('pointerup', () => { btn.setTexture(texture); game.scene.getAt(0).sound.add('activity selection - button selection').play(); });
    }

    (function (sh) {
        var core;
        (function (core) {
            class Gameplay {
                constructor() {
                    this.currentRound = 0;
                    this.currentLetter = 0;
                    this.correctAnswersCount = 0;
                    this.wrongAnswersCount = 0;
                    this.correctAnswersCountThisRound = 0;
                    this.wrongAnswersCountThisRound = 0;
                    this.reset();
                    let json = game.cache.json.get('gameplay');
                    this.wrongAnswersToLose = json["wrongAnswersToLose"];
                    this.numberOfQuestionsPerRound = json["numberOfQuestionsPerRound"];
                    this.lettersConfig = JSON.parse(JSON.stringify(json["lettersConfig"]));
                    this.rounds = JSON.parse(JSON.stringify(json["rounds"]));
                    this.numberOfRounds = this.rounds.length;
                }
                setupCallbacks(onComplete, onLose) {
                    this.onComplete = onComplete;
                    this.onLose = onLose;
                }
                onLetterChosen(forceNewRound) {
                    if (forceNewRound || this.isNewRound()) {
                        return this.nextRound();
                    }
                    return false;
                }
                nextRound() {

                    this.correctAnswersCountThisRound = 0;
                    this.wrongAnswersCountThisRound = 0;
                    this.currentRound++;
                    if (this.isRoundsComplete()) {
                        this.onComplete(this.correctAnswersCount, this.correctAnswersCount);
                        return true;
                    }

                    return false;
                }
                getCorrectLetterName() {
                    return this.rounds[this.currentRound]['correctLetterName'];
                }
                isCorrectLetterAudioQuestionEnable() {
                    return this.rounds[this.currentRound]['audioQuestionEnable'];
                }
                getCorrectAudioKey() {
                    return this.lettersConfig[this.getCorrectLetterName()]['correctAudioKey'];
                }
                getCorrectAndLetterSoundSfxAudioKey() {
                    return "Q-" + this.lettersConfig[this.getCorrectLetterName()]['Sounds of the letters'];
                }
                onCorrectAnswer() {
                    this.correctAnswersCountThisRound++;
                    this.correctAnswersCount++;
                    return this.onLetterChosen();
                }
                onWrongAnswer(forceNewRound) {
                    this.wrongAnswersCountThisRound++;
                    this.wrongAnswersCount++;
                    if (this.wrongAnswersCount >= this.wrongAnswersToLose) {
                        this.onLose(this.correctAnswersCount, this.correctAnswersCount);
                        return true;
                    }
                    else {
                        this.onLetterChosen(forceNewRound);
                    }
                    return false;
                }

                getMaxTotalAnswersCount() {
                    return this.wrongAnswersToLose + this.numberOfRounds - 1;
                }

                getCurrentTotalAnswersCount() {
                    return this.correctAnswersCount + this.wrongAnswersCount;
                }
                isNewRound() {
                    return this.correctAnswersCountThisRound >= 1 || (this.correctAnswersCountThisRound + this.wrongAnswersCountThisRound) === 3 || (this.correctAnswersCountThisRound + this.wrongAnswersCountThisRound) === 0;
                }
                isRoundsComplete() {
                    return this.currentRound >= this.numberOfRounds && this.wrongAnswersCount < this.wrongAnswersToLose;
                }
                reset() {
                    this.currentRound = 0;
                    this.correctAnswersCount = 0;
                    this.wrongAnswersCount = 0;
                }
                getCurrentRoundLetters() {
                    return this.rounds[this.currentRound]["letters"];
                }
            }
            core.Gameplay = Gameplay;
        })(core = sh.core || (sh.core = {}));
    })(sh || (sh = {}));

    (function (sh) {
        var scene;
        (function (scene) {
            class Boot extends Phaser.Scene {
                init() {
                    this.game.scale.transformX = (pageX) => {
                        let offsetLeft = 0;
                        let parentElement = game.canvas.parentElement;
                        while (parentElement) {
                            if (parentElement.offsetLeft) {
                                offsetLeft = parentElement.offsetLeft;
                                break;
                            }
                            parentElement = parentElement.parentElement;
                        }
                        return (pageX - offsetLeft) * this.game.scale.displayScale.x;
                    };
                    this.game.scale.transformY = (pageY) => {
                        let offsetTop = 0;
                        let parentElement = game.canvas.parentElement;
                        while (parentElement) {
                            if (parentElement.offsetTop) {
                                offsetTop = parentElement.offsetTop;
                                break;
                            }
                            parentElement = parentElement.parentElement;
                        }
                        return (pageY - offsetTop) * this.game.scale.displayScale.y;
                    };
                }
                create() {
                    game.scene.remove('Boot');
                    game.scene.add('Preloader', sh.scene.Preloader, true);
                }
            }
            scene.Boot = Boot;
        })(scene = sh.scene || (sh.scene = {}));
    })(sh || (sh = {}));

    (function (sh) {
        var scene;
        (function (scene) {
            var Gameplay = sh.core.Gameplay;
            class MainScene extends Phaser.Scene {
                create() {
                    this.gameplay = new Gameplay();
                    this.gameplayScreen = new sh.screen.GameplayScreen(this, this.gameplay);
                    this.children.add(this.gameplayScreen);
                    this.gameplayScreen.showInstructionPage();
                }
            }
            scene.MainScene = MainScene;
        })(scene = sh.scene || (sh.scene = {}));
    })(sh || (sh = {}));

    (function (sh) {
        var scene;
        (function (scene) {
            class Preloader extends Phaser.Scene {
                preload() {
                    if (typeof sh.App.json == "string") this.load.json('gameplay', sh.App.json); else this.game.cache.json.add('gameplay', sh.App.json);
                }
                create() {
                    let json = game.cache.json.get('gameplay');
                    let lettersConfig = json["lettersConfig"];
                    for (let letterName in lettersConfig) {
                        this.load.image(letterName, "assets/games/truck-race/imgs/letters/" + letterName + ".png");
                        if (lettersConfig[letterName]["correctAudioKey"] == null) continue;
                        let correctAudioKey = lettersConfig[letterName]["correctAudioKey"];
                        this.load.audio(correctAudioKey, "assets/games/truck-race/sound/mp3/letters/" + correctAudioKey.replace(".wav", ".mp3"));
                        this.load.audio("Q-" + lettersConfig[letterName]["Sounds of the letters"], "assets/games/truck-race/sound/mp3/letters/Sounds of the letters/" + lettersConfig[letterName]["Sounds of the letters"].replace(".wav", ".mp3"));
                    }
                    let progressTxt = this.add.text(game.scale.width / 2, game.scale.height / 2 + 50, "", {
                        "fontFamily": "QuranErafont",
                        "fontSize": 25,
                        "color": "#000000",
                        "align": 'center'
                    });
                    progressTxt.setOrigin(0.5, 0.5);
                    this.load.pack('preloader', 'assets/games/truck-race/pack.json');
                    this.load.on('progress', (value) => {
                        progressTxt.text = Math.ceil(value * 100) + "%";
                    }, this);
                    this.load.on('complete', () => {
                        this.nextScene();
                    });
                    this.load.start();
                }
                nextScene() {
                    game.scene.remove('Preloader');
                    game.scene.add('ScreenMain', sh.scene.MainScene, true);
                }
            }
            scene.Preloader = Preloader;
        })(scene = sh.scene || (sh.scene = {}));
    })(sh || (sh = {}));
    (function (sh) {
        var screen;
        (function (screen) {
            class AreYouSureWindow extends Phaser.GameObjects.Container {
                constructor(scene, onYes, onNo) {
                    super(scene);
                    this._areYouSurePage = new Phaser.GameObjects.Image(this.scene, -105, 0 - 48, 'Exit warning');
                    this._areYouSurePage.setOrigin(0, 0);
                    this._areYouSurePage.setInteractive();
                    this._btnSureYes = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2 - 95, 485 - 50, 'btnYES1');
                    this._btnSureYes.setInteractive({ cursor: 'pointer' });
                    this._btnSureYes.once('pointerup', () => {
                        onYes;
                        angularComponentRef.backToMenu();
                    });
                    var modalTextStyle = {
                        backgroundColor: 'transparent',
                        stroke: '#ffffff',
                        strokeThickness: 2,
                        lineSpacing: 15,
                        fontFamily: 'Kids Rock DEMO',
                        fontSize: 27,
                        color: '#43425d',
                        wordWrap: true,
                        align: 'center'
                    };
                    var modalText = this.scene.add.text(game.scale.width / 2 + 12, game.scale.height / 2, "Your progress in this activity will not be saved. \n Are you sure you want to exit? ", modalTextStyle);
                    modalText.setOrigin(0.5, 0.5);


                    setupButtonTextureBased(this._btnSureYes, 'btnYES1', 'btnYES2');
                    this._btnSureNo = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2 + 95, 485 - 50, 'btnNO1');
                    this._btnSureNo.setInteractive({ cursor: 'pointer' });
                    this._btnSureNo.once('pointerup', onNo);
                    setupButtonTextureBased(this._btnSureNo, 'btnNO1', 'btnNO2');
                    this.add(this._areYouSurePage);
                    this.add(this._btnSureYes);
                    this.add(this._btnSureNo);
                    this.add(modalText);
                }
            }
            screen.AreYouSureWindow = AreYouSureWindow;
        })(screen = sh.screen || (sh.screen = {}));
    })(sh || (sh = {}));

    (function (sh) {
        var screen;
        (function (screen) {
            class CompleteWindow extends Phaser.GameObjects.Container {
                constructor(scene, onBack, onReplay, onNext) {
                    super(scene);
                    this.music = null;
                    this.setPosition(-104.5, -48);
                    this._bgComplete = new Phaser.GameObjects.Image(this.scene, 0, 0, 'Completion page LATEST UPDATED');
                    this._bgComplete.setOrigin(0, 0);
                    this._bgComplete.setInteractive();
                    this._cup = new Phaser.GameObjects.Image(this.scene, 400, 410, 'Trophy');
                    this._btnBack = new Phaser.GameObjects.Image(this.scene, 570, 570, 'btnBACK1');
                    this._btnReplay = new Phaser.GameObjects.Image(this.scene, 720, 570, 'btnReplay1');
                    this._btnNext = new Phaser.GameObjects.Image(this.scene, 870, 570, 'btnNEXT1');
                    let _CollectedPoints = new Phaser.GameObjects.Image(this.scene, 620, 440, 'Collected Points');
                    this.totalScoreTxt = this.scene.add.text(845, 352, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 35,
                        "color": "#F49F1C",
                        "align": 'center',
                        'stroke': '#70451A',
                        'strokeThickness': 6
                    });
                    this.totalScoreTxt.setOrigin(0.5, 0.5);
                    let grd = this.totalScoreTxt.context.createLinearGradient(0, 0, 0, this.totalScoreTxt.height);
                    grd.addColorStop(0, '#FFFF00');
                    grd.addColorStop(1, '#C17316');
                    this.totalScoreTxt.setFill(grd);
                    this.starScoreTxt = this.scene.add.text(648, 433, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 24,
                        "color": "#FFFFFF",
                        "align": 'center'
                    });
                    this.starScoreTxt.setOrigin(0.5, 0.5);
                    this.add([
                        this._bgComplete,
                        _CollectedPoints,
                        this._cup,
                        this._btnBack,
                        this._btnReplay,
                        this._btnNext,
                        this.totalScoreTxt,
                        this.starScoreTxt
                    ]);
                    this._btnBack.setInteractive({ cursor: 'pointer' });
                    this._btnBack.on('pointerup', () => {
                        onBack(this._btnBack);
                        angularComponentRef.backToMenu();
                        // if (this.music) {
                        //     this.music.stop();
                        // }
                    });
                    setupButtonTextureBased(this._btnBack, 'btnBACK1', 'btnBACK2');
                    this._btnReplay.setInteractive({ cursor: 'pointer' });
                    this._btnReplay.once('pointerup', () => {
                        onReplay(this._btnReplay);
                        if (this.music) {
                            this.music.stop();
                        }
                    });
                    setupButtonTextureBased(this._btnReplay, 'btnReplay1', 'btnReplay2');
                    this._btnNext.setInteractive({ cursor: 'pointer' });
                    this._btnNext.on('pointerup', () => {
                        onNext(this._btnNext);
                        window.angularComponentRef.nextActivity()
                    });
                    setupButtonTextureBased(this._btnNext, 'btnNEXT1', 'btnNEXT2');
                }
                show(score, starScore) {
                    window.angularComponentRef.gameFinish({ score, starScore })
                    this._cup.scale = 1.25;
                    this.scene.tweens.add({
                        targets: this._cup,
                        "scale": 1,
                        duration: 500,
                        ease: Phaser.Math.Easing.Back.Out
                    });
                    this.totalScoreTxt.text = String(window.angularComponentRef.component.userInfo.totalScore);
                    this.starScoreTxt.text = String(starScore);
                    // let music = this.scene.sound.add("viktory");
                    this.music = this.scene.sound.add("Activity completion fantastic");
                    this.music.play();
                }
            }
            screen.CompleteWindow = CompleteWindow;
        })(screen = sh.screen || (sh.screen = {}));
    })(sh || (sh = {}));

    (function (sh) {
        var screen;
        (function (screen) {
            class GameplayScreen extends Phaser.GameObjects.Container {
                constructor(scene, gameplay) {
                    super(scene);
                    this.carsPositions = [{ x: 100 - 600, y: 130 }, { x: 225 - 600, y: 275 }, { x: 150 - 600, y: 400 }];
                    this.bgMusic = null;
                    this.correctAudio = null;
                    this.wfsnd = null;
                    this.showCompleteWindow = (score, starScore) => {
                        let completeWindow = new screen.CompleteWindow(this.scene, (target) => {
                            this.playBtnClickAnim(target);
                        }, (target) => {
                            this.playBtnClickAnim(target);
                            this.destroyGameplay();
                            this.remove(completeWindow);
                            this.showInstructionPage();
                        }, (target) => {
                            this.playBtnClickAnim(target);
                        });
                        this.setLettersInputEnabled(false);
                        delayedCall(4000, () => {
                            setPageBackground("bg-blue");
                            this.add(completeWindow);
                            completeWindow.show(score, starScore);
                            this.bgMusic.stop();
                        });
                    };
                    this.showLoseWindow = (score, starScore) => {
                        let tryAgainWindow = new screen.TryAgainWindow(this.scene, (target) => {
                            this.playBtnClickAnim(target);
                        }, (target) => {
                            this.playBtnClickAnim(target);
                            this.destroyGameplay();
                            this.remove(tryAgainWindow);
                            this.showInstructionPage();
                        });
                        this.setLettersInputEnabled(false);
                        delayedCall(2500, () => {
                            setPageBackground("bg-blue");
                            this.add(tryAgainWindow);
                            tryAgainWindow.show(score, starScore);
                            this.bgMusic.stop();
                        });
                    };
                    this.gameplay = gameplay;
                    window["t"] = this;
                }
                createHexagons() {
                    this.cars = [];
                    let _i = 0;
                    let origins = [{ x: 0.08, y: 0 }, { x: 0.06, y: -0.18 }, { x: 0.14, y: -0.14 }];
                    var jarr = [1, 2, 3];
                    for (let p of this.carsPositions) {
                        let hc = new Phaser.GameObjects.Container(this.scene, this.carsPositions[_i]['x'], this.carsPositions[_i]['y']);
                        var j = Phaser.Utils.Array.RemoveRandomElement(jarr);
                        let h = new Phaser.GameObjects.Image(this.scene, 0, 0, 'Car ' + j);
                        h.setOrigin(origins[j - 1].x, origins[j - 1].y);
                        hc.add(h);
                        hc["bg"] = h;
                        hc["Normal Box"] = new Phaser.GameObjects.Image(this.scene, 0, 0, 'Normal Box');
                        hc["Normal Box"].setOrigin(0, 0);
                        hc.add(hc["Normal Box"]);
                        hc["Correct Box"] = new Phaser.GameObjects.Image(this.scene, 0, 0, 'Correct Box Answer');
                        hc["Correct Box"].setOrigin(0, 0);
                        hc.add(hc["Correct Box"]);
                        hc["Wrong Box"] = new Phaser.GameObjects.Image(this.scene, 0, 0, 'Wrong Box Answer');
                        hc["Wrong Box"].setOrigin(0, 0);
                        hc.add(hc["Wrong Box"]);
                        hc["Correct Box"].visible = hc["Wrong Box"].visible = false;
                        hc["defX"] = p['x'];
                        hc["defY"] = p['y'];
                        this.cars.push(hc);
                        _i++;
                    }
                    window['this.cars'] = this.cars;
                    this.gameplayContainer.add(this.cars);
                }
                createLetters() {
                    /* if (this.letters) {
                        for (let l of this.letters) {
                            l.parentContainer["letter"] = null;
                            l["hexagon"] = null;
                            l.parentContainer.remove(l);
                        }
                    } */
                    this.letters = [];
                    let _letters = this.gameplay.getCurrentRoundLetters();
                    for (let n of _letters) {
                        let l = new Phaser.GameObjects.Image(this.scene, 130, 70, n);
                        this.letters.push(l); window['l'] = l;
                    }
                }
                showGameplay() {
                    this.isLost = false;
                    setPageBackground("bg-australia");
                    this.bgMusic = this.scene.sound.add("bg_sound");
                    this.bgMusic.play();
                    this.bgMusic.loop = true;
                    this.gameplay.reset();
                    this._gameStage = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2, game.scale.height / 2, 'Sound Hive Final');
                    this._gameStage.setOrigin(0.5, 0.5);
                    this._gameStage.setInteractive();
                    let rr = new Phaser.GameObjects.Image(this.scene, 123, 50, 'Rounded Rectangle 602'); window["rr"] = rr;
                    rr.setOrigin(0, 0.5);
                    this.rr = rr;
                    this._btnSound = new Phaser.GameObjects.Image(this.scene, 160 - 105, 100 - 50, 'Sound');
                    this._btnSound.setInteractive({ cursor: 'pointer' });
                    this._btnSound["defScale"] = this._btnSound.scale;
                    setupButtonTextureBased(this._btnSound, 'Sound', 'Sound HOVER EFFECT');
                    this._btnClose = new Phaser.GameObjects.Image(this.scene, 1025 - 105, 100 - 50, 'x Button');
                    this._btnClose.setInteractive({ cursor: 'pointer' });
                    this._btnClose["defScale"] = this._btnClose.scale;
                    setupButtonTextureBased(this._btnClose, 'x Button', 'x Button HOVER EFFECT');
                    this.gameplayContainer = new Phaser.GameObjects.Container(this.scene);
                    this.addAt(this.gameplayContainer, 0);
                    this.gameplayContainer.add([
                        this._gameStage,
                        rr,
                        this._btnSound,
                        this._btnClose
                    ]);
                    this.createBeehives();
                    this.shuffleOutHexagons();
                    this.gameplay.setupCallbacks(this.showCompleteWindow, this.showLoseWindow);
                }
                createBeehives() {
                    let startX = 150;
                    let startY = 50;
                    let dx = 40;
                    let _BeehiveEmptyArrayPositions = [];
                    for (let i = 0; i < this.gameplay.getMaxTotalAnswersCount(); i++) {
                        _BeehiveEmptyArrayPositions.push({ x: startX + i * dx, y: startY });
                    }
                    this.rr.setScale(this.gameplay.getMaxTotalAnswersCount() / 8, 1);
                    this._BeehiveEmptyArray = []; window["_BeehiveEmptyArray"] = this._BeehiveEmptyArray;
                    this._Beehive = [];
                    for (let p of _BeehiveEmptyArrayPositions) {
                        let _BeehiveEmpty = new Phaser.GameObjects.Image(this.scene, p['x'], p['y'], 'Beehive 1 Empty');
                        this._BeehiveEmptyArray.push(_BeehiveEmpty);
                        _BeehiveEmpty.visible = false;
                        let _Beehive = new Phaser.GameObjects.Image(this.scene, p['x'], p['y'], 'Beehive 1');
                        this._Beehive.push(_Beehive);
                    }
                    for (let bea of this._BeehiveEmptyArray) {
                        this.gameplayContainer.add(bea);
                    }
                    for (let bee of this._Beehive) {
                        this.gameplayContainer.add(bee);
                        bee.visible = false;
                    }
                }
                randomizeLettersPosition() {
                    let hx = this.cars.slice();
                    for (let l of this.letters) {
                        if (hx.length == 0)
                            return;
                        let hc = Phaser.Utils.Array.RemoveRandomElement(hx);
                        hc.add(l);
                        hc["letter"] = l;
                        l["hexagon"] = hc;
                    }
                }
                updateHexagonsArrange() {
                    for (let hc of this.cars) {
                        if (!hc["letter"]) {
                            hc.parentContainer.bringToTop(hc);
                            break;
                        }
                    }
                }
                shuffleOutHexagons() {
                    this.createHexagons();

                    let setLettersInputEnabled = () => {
                        if (this.correctAudio && this.correctAudio.isPlaying) {
                            delayedCall((this.correctAudio.duration * 0.75) * 1000, () => {
                                this.setLettersInputEnabled(true);
                            });
                        }
                        else {
                            this.setLettersInputEnabled(true);
                        }
                    };

                    if (!this.gameplay.isRoundsComplete()) {
                        if (this.gameplay.isCorrectLetterAudioQuestionEnable()) {
                            this.playCorrectAudio();
                        }
                        setLettersInputEnabled();
                    }

                    if (this.sfxCarAccelerating) {
                        this.sfxCarAccelerating.stop();
                        this.sfxCarAccelerating = null;
                    }
                    if (this.sfxWrong) {
                        this.sfxWrong.stop();
                        this.sfxWrong = null;
                    }

                    if (!this.gameplay.isRoundsComplete()) {
                        this.createLetters();
                        this.randomizeLettersPosition();
                    }

                    this.setLettersInputEnabled(false);
                    this.updateHexagonsArrange();
                    Phaser.Utils.Array.Shuffle(this.carsPositions);
                    let cars = this.cars;
                    for (let i = 0; i < cars.length; i++) {
                        let hc = cars[i];
                        hc["defX"] = this.carsPositions[i]["x"];
                        hc["defY"] = this.carsPositions[i]["y"];

                        hc["Correct Box"].visible = hc["Wrong Box"].visible = false;
                        hc.x = hc["defX"] - Math.round(Math.random() * 3) * 15;
                        hc.y = hc["defY"];
                        hc["targetX"] = 1030;
                        this.scene.tweens.killTweensOf(hc);
                        hc["raceTween"] = this.scene.tweens.add({
                            targets: hc,
                            "x": hc["targetX"],
                            duration: 15000 - Math.ceil(Math.random() * 5) * 100,
                            // ease: Phaser.Math.Easing.Linear.NONE,
                            onComplete: () => {
                                if (this.isLost) return;
                                if (this.cars !== cars) return;
                                if (this.gameplay.isRoundsComplete()) return;
                                if (hc["Correct Box"].visible) {
                                    this.shuffleOutHexagons();
                                    return;
                                }

                                var wasACarChosen = false;

                                hc["raceTween"] = null;
                                for (let j = 0; j < cars.length; j++) {
                                    if (cars[j]["raceTween"]) return;

                                    wasACarChosen = wasACarChosen || cars[j]["Correct Box"].visible || cars[j]["Wrong Box"].visible;
                                }

                                //all cars got end point    

                                if (!wasACarChosen) {
                                    this.isLost = this.onWrongAnswer(true);
                                    if (!this.isLost && !this.gameplay.isRoundsComplete()) {
                                        this.shuffleOutHexagons()
                                    }
                                } else {
                                    if (!this.isLost) this.shuffleOutHexagons();
                                }
                            }
                        });
                    }
                    for (let c of cars) this.gameplayContainer.remove(c);
                    this.cars.sort((c1, c2) => c1.y - c2.y);
                    for (let c of cars) this.gameplayContainer.add(c);

                    this.createInput();
                }
                shuffleInHexagons() {
                    this.updateHexagonsArrange();
                    let positions = this.carsPositions.slice();
                    this.setLettersInputEnabled(false);

                    delayedCall(600, () => {
                        // this.scene.sound.add('move to centre').play();
                    });
                }
                createInput() {
                    for (let hc of this.cars) {
                        let correctAnswer = hc["letter"] && hc["letter"].texture.key == this.gameplay.getCorrectLetterName();
                        //hc["letter"].alpha = correctAnswer ? 1 : 0.5;
                        hc["bg"].on('pointerup', () => {
                            if (hc["Wrong Box"].visible) return;
                            // this.playBtnClickAnim(hc);
                            let lost = false;
                            if (correctAnswer) {
                                this.setLettersInputEnabled(false);
                                hc["Wrong Box"].visible = false;
                                hc["Correct Box"].visible = true;
                                for (let hc of this.cars) {
                                    this.scene.tweens.add({
                                        targets: hc["raceTween"],
                                        "timeScale": hc["Correct Box"].visible ? 4 : 2.75,
                                        duration: 400
                                    });
                                }

                                let completed = this.onCorrectAnswer();
                                if (!completed) {
                                    this.shuffleInHexagons();
                                }
                                // delayedCall(500, () => {
                                //     if (!this.gameplay.isNewRound()) {
                                //         if (this.gameplay.isCorrectLetterAudioQuestionEnable()) {
                                //             this.playCorrectAudio();
                                //         }
                                //     }
                                // });
                            }
                            else {
                                hc["Wrong Box"].visible = true;
                                hc["Correct Box"].visible = false;
                                lost = this.onWrongAnswer();
                                if (!lost) {
                                    // this.shuffleInHexagons();
                                } else {
                                    this.isLost = true;
                                }
                            }
                        });
                    }
                    this._btnSound.on('pointerup', () => {
                        this.playBtnClickAnim(this._btnSound);
                        this.onSoundClick();
                    });
                    this._btnClose.on('pointerup', () => {
                        this.playBtnClickAnim(this._btnClose);
                        this.onCloseClick();
                    });
                }
                hideAllUnusedBeehives() {
                    let i = this.gameplay.getCurrentTotalAnswersCount();
                    for (let k = i + 1; k < this._BeehiveEmptyArray.length; k++) {
                        this._BeehiveEmptyArray[k].visible = false;
                        this._Beehive[k].visible = false;
                    }
                }
                onCorrectAnswer() {
                    let i = this.gameplay.getCurrentTotalAnswersCount();
                    if (i < this._BeehiveEmptyArray.length) {
                        this._BeehiveEmptyArray[i].visible = false;
                        this._Beehive[i].visible = true;
                    }
                    this.hideAllUnusedBeehives();
                    let completed = this.gameplay.onCorrectAnswer();
                    this.scene.sound.add('Correct sfx').play();
                    this.sfxCarAccelerating = this.scene.sound.add('Car accelerating');
                    this.sfxCarAccelerating.play();
                    // delayedCall(250, () => {
                    //     this.scene.sound.add(this.gameplay.getCorrectAndLetterSoundSfxAudioKey()).play();
                    // });
                    return completed;
                }
                onWrongAnswer(forceNewRound) {
                    let i = this.gameplay.getCurrentTotalAnswersCount();
                    if (i < this._BeehiveEmptyArray.length) {
                        this._BeehiveEmptyArray[i].visible = true;
                        this._Beehive[i].visible = false;
                    }
                    this.hideAllUnusedBeehives();
                    let lost = this.gameplay.onWrongAnswer(forceNewRound);
                    this.sfxWrong = this.scene.sound.add("wrong sfx");
                    this.sfxWrong.play();
                    return lost;
                }
                playCorrectAudio() {
                    if (this.correctAudio) {
                        this.correctAudio.stop();
                    }
                    this.correctAudio = this.scene.sound.add(this.gameplay.getCorrectAudioKey());
                    this.correctAudio.play();
                    if (this.areYouSureWindow && this.areYouSureWindow.parentContainer == this) {
                        this.correctAudio.pause();
                    }
                }
                onSoundClick() {
                    this.playCorrectAudio();
                }
                onCloseClick() {
                    this.showAreYouSurePage();
                    this.scene.sound.add('warning page pop up sfx').play();
                }
                playBtnClickAnim(target) {
                    let sc = target["defScale"] ? target["defScale"] : 1;
                    target.scaleX = target.scaleY = sc;
                    this.scene.tweens.add({
                        targets: target,
                        "scaleX": 0.9 * sc,
                        "scaleY": 0.9 * sc,
                        duration: 100,
                        yoyo: true
                    });
                }
                showInstructionPage() {
                    setPageBackground("bg-blue");
                    this.instructionPage = new screen.InstructionPage(this.scene, (target) => {
                        this.playBtnClickAnim(target);
                        this.remove(this.instructionPage);
                        this.showGameplay();
                        if (this.wfsnd) {
                            this.wfsnd.stop();
                        }
                    }, (target) => {
                        this.playBtnClickAnim(target);
                        if (this.wfsnd) {
                            this.wfsnd.stop();
                        }
                        this.wfsnd = this.scene.sound.add("Welcome Find the sound");
                        this.wfsnd.play();
                    });
                    this.add(this.instructionPage);
                    try {
                        this.wfsnd = this.scene.sound.add("Welcome Find the sound");
                        this.wfsnd.play();
                    }
                    catch (e) {
                        console.error(e);
                    }
                }
                showAreYouSurePage() {
                    for (let j = 0; j < this.cars.length; j++) {
                        if (this.cars[j]["raceTween"]) {
                            this.cars[j]["raceTween"].pause();
                        }
                    }

                    pauseAllDelayedCalls();
                    setPageBackground("bg-blue");
                    this.pauseSounds();
                    this.areYouSureWindow = new screen.AreYouSureWindow(this.scene, () => {
                        this.remove(this.areYouSureWindow);
                        this.destroyGameplay();
                        this.showInstructionPage();
                    }, () => {
                        this.remove(this.areYouSureWindow);
                        this.unpauseSounds();
                        resumeAllDelayedCalls();

                        for (let j = 0; j < this.cars.length; j++) {
                            if (this.cars[j]["raceTween"]) {
                                this.cars[j]["raceTween"].resume();
                            }
                        }

                        setPageBackground("bg-australia");
                    });
                    this.add(this.areYouSureWindow);
                }
                setLettersInputEnabled(enabled) {
                    if (enabled) {
                        for (let hc of this.cars) {
                            hc["bg"].setInteractive({ cursor: 'pointer' });
                        }
                    }
                    else {
                        for (let hc of this.cars) {
                            hc["bg"].disableInteractive();
                        }
                    }
                }
                pauseSounds() {
                    if (this.correctAudio)
                        this.correctAudio.pause();
                    if (this.bgMusic)
                        this.bgMusic.pause();
                }
                unpauseSounds() {
                    if (this.correctAudio)
                        this.correctAudio.resume();
                    if (this.bgMusic)
                        this.bgMusic.resume();
                }
                destroyGameplay() {
                    this.setLettersInputEnabled(false);
                    this.remove(this.gameplayContainer);
                    this.scene.sound.stopAll();
                    destroyAllDelayedCalls();
                }
            }
            screen.GameplayScreen = GameplayScreen;
        })(screen = sh.screen || (sh.screen = {}));
    })(sh || (sh = {}));
    (function (sh) {
        var screen;
        (function (screen) {
            class InstructionPage extends Phaser.GameObjects.Container {
                constructor(scene, onPlayClick, onSndClick) {
                    super(scene);
                    this._instructionPage = new Phaser.GameObjects.Image(this.scene, 0 - 105, 0 - 48, 'Instructions page  ALL ACTIVITY  TITLEs');
                    this._instructionPage.setOrigin(0, 0);
                    this._instructionPage.setInteractive();

                    this._instructionPageTitle = new Phaser.GameObjects.Image(this.scene, 475, 110, 'Truck Race Title');
                    this._instructionPageTitle.setScale(0.8);

                    this._btnPlay = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2, 480 - 50, 'btnPLAY1');
                    this._btnPlay.setInteractive({ cursor: 'pointer' });
                    this._btnPlay.once('pointerup', onPlayClick);
                    setupButtonTextureBased(this._btnPlay, 'btnPLAY1', 'btnPLAY2');
                    this.instrTxt = this.scene.add.text(game.scale.width / 2, game.scale.height / 2, "Listen to the word and tap on\n the right truck.", {
                        "fontFamily": "Kids Rock DEMO",
                        "fontSize": 30,
                        "color": "#43425D",
                        "align": 'center'
                    });
                    this.instrTxt.setOrigin(0.5, 0.5);
                    this._btnSoundInstruction = new Phaser.GameObjects.Image(this.scene, 800 - 105, 156 - 50, 'Sound');
                    this._btnSoundInstruction.setInteractive({ cursor: 'pointer' });
                    this._btnSoundInstruction.on('pointerup', onSndClick);
                    this._btnSoundInstruction["defScale"] = this._btnSoundInstruction.scale;
                    setupButtonTextureBased(this._btnSoundInstruction, 'Sound', 'Sound HOVER EFFECT');
                    this.add(this._instructionPage);
                    this.add(this._instructionPageTitle);
                    this.add(this.instrTxt);
                    this.add(this._btnPlay);
                    this.add(this._btnSoundInstruction);
                }
            }
            screen.InstructionPage = InstructionPage;
        })(screen = sh.screen || (sh.screen = {}));
    })(sh || (sh = {}));
    (function (sh) {
        var screen;
        (function (screen) {
            class TryAgainWindow extends Phaser.GameObjects.Container {
                constructor(scene, onBack, onReplay) {
                    super(scene);
                    this.music = null;
                    this.setPosition(-106, -48);
                    this._bg = new Phaser.GameObjects.Image(this.scene, 0, 0, 'Try again page');
                    this._bg.setOrigin(0, 0);
                    this._bg.setInteractive();
                    this._star = new Phaser.GameObjects.Image(this.scene, 400, 415, 'Break Star');
                    this._btnBack = new Phaser.GameObjects.Image(this.scene, 600, 580, 'btnBACK1');
                    this._btnReplay = new Phaser.GameObjects.Image(this.scene, 765, 580, 'btnReplay1');
                    this.totalScoreTxt = this.scene.add.text(850, 355, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 35,
                        "color": "#F49F1C",
                        "align": 'center',
                        'stroke': '#70451A',
                        'strokeThickness': 6
                    });
                    this.totalScoreTxt.setOrigin(0.5, 0.5);
                    let grd = this.totalScoreTxt.context.createLinearGradient(0, 0, 0, this.totalScoreTxt.height);
                    grd.addColorStop(0, '#FFFF00');
                    grd.addColorStop(1, '#C17316');
                    this.totalScoreTxt.setFill(grd);
                    this.starScoreTxt = this.scene.add.text(635, 431, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 24,
                        "color": "#FFFFFF",
                        "align": 'center'
                    });
                    this.starScoreTxt.setOrigin(0.5, 0.5);
                    this.add([
                        this._bg,
                        this._star,
                        this._btnBack,
                        this._btnReplay,
                        this.totalScoreTxt,
                        this.starScoreTxt
                    ]);
                    this._btnBack.setInteractive({ cursor: 'pointer' });
                    this._btnBack.on('pointerup', () => {
                        onBack(this._btnBack);
                        angularComponentRef.backToMenu();
                        // if (this.music) {
                        //     this.music.stop();
                        // }
                    });
                    setupButtonTextureBased(this._btnBack, 'btnBACK1', 'btnBACK2');
                    this._btnReplay.setInteractive({ cursor: 'pointer' });
                    this._btnReplay.once('pointerup', () => {
                        onReplay(this._btnReplay);
                        if (this.music) {
                            this.music.stop();
                        }
                    });
                    setupButtonTextureBased(this._btnReplay, 'btnReplay1', 'btnReplay2');
                }
                show(score, starScore) {
                    this._star.scale = 1.25;
                    this.scene.tweens.add({
                        targets: this._star,
                        "scale": 1,
                        duration: 500,
                        ease: Phaser.Math.Easing.Back.Out
                    });
                    this.totalScoreTxt.text = String(window.angularComponentRef.component.userInfo.totalScore);
                    this.starScoreTxt.text = String(0);
                    this.music = this.scene.sound.add("Fail - close one");
                    this.music.play();
                }
            }
            screen.TryAgainWindow = TryAgainWindow;
        })(screen = sh.screen || (sh.screen = {}));
    })(sh || (sh = {}));
}

function destroyTruckRace() {
    if (game) {
        game.destroy();
    }
}

var sh;
var game;

var letterGrid = (json) => {
    class FitScaleManager {
        constructor(game) {
            this.doResize = () => {
                let scale = this.calculateScale();
                let newCanvasWidth = this.phaserScaleManager.width * scale;
                let newCanvasHeight = this.phaserScaleManager.height * scale;
                this.canvasStyle.width = newCanvasWidth + 'px';
                this.canvasStyle.height = newCanvasHeight + 'px';
                this.canvasStyle.marginLeft = (window.innerWidth - newCanvasWidth) / 2 + 'px';
                this.canvasStyle.marginTop = (window.innerHeight - newCanvasHeight) / 2 + 'px';
            };
            this.game = game;
            this.canvasStyle = this.game.canvas.style;
            this.phaserScaleManager = this.game.scale;
        }

        static detectBestScaleMode() {
            let iOS = /iPad|iPhone|iPod/.test(navigator.platform || "");
            let isAndroid = window.navigator.userAgent.toLowerCase().indexOf("android") > -1;
            return iOS || isAndroid ? Phaser.Scale.FIT : Phaser.Scale.NONE;
        }
        ;

        /**
         * Just call this method once in Boot scene's init() method
         */
        setup() {
            this.phaserScaleManager.addListener(Phaser.Scale.Events.RESIZE, this.onResize, this);
            this.overridePhaserTransformMethods();
            this.onResize();
        }

        calculateScale() {
            if (game.scale.scaleMode == Phaser.Scale.NONE)
                return 1;
            return Math.min(window.innerWidth / this.phaserScaleManager.width, window.innerHeight / this.phaserScaleManager.height);
        }

        overridePhaserTransformMethods() {
            this.game.scale.transformX = (pageX) => {
                return (pageX - parseInt(this.canvasStyle.marginLeft.split("px")[0])) / this.calculateScale();
            };
            this.game.scale.transformY = (pageY) => {
                return (pageY - parseInt(this.canvasStyle.marginTop.split("px")[0])) / this.calculateScale();
            };
        }

        onResize() {
            setTimeout(this.doResize, FitScaleManager.RESIZE_DELAY);
        }
    }

    (function (sh) {
        class App extends Phaser.Game {
            constructor(json) {
                App.json = json;
                let config = {
                    type: Phaser.WEBGL,
                    width: App.CANVAS_WIDTH,
                    height: App.CANVAS_HEIGHT,
                    parent: 'game-container',
                    dom: {
                        createContainer: false
                    },
                    scale: {
                        mode: FitScaleManager.detectBestScaleMode(),
                        autoCenter: Phaser.Scale.CENTER_BOTH
                    },
                    transparent: true,
                    scene: {
                        create: () => {
                            this.scene.add('Boot', sh.scene.Boot, true);
                        }
                    }
                };
                super(config);
            }
        }

        App.CANVAS_WIDTH = 980;
        App.CANVAS_HEIGHT = 600;
        sh.App = App;
    })(sh || (sh = {}));

    FitScaleManager.RESIZE_DELAY = 500;

    var delayedCalls = [];

    function delayedCall(delay, callback, args, callbackScope) {
        let scene = game.scene.getAt(0);
        if (scene) {
            let dc = scene.time.delayedCall(delay, callback, args, callbackScope);
            delayedCalls.push(dc);
            return dc;
        }
        let t = setTimeout(callback, delay);
        delayedCalls.push(t);
        return t;
    }

    function pauseAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.paused = true;
            }
        }
    }

    function resumeAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.paused = false;
            }
        }
    }

    function destroyAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.remove(false);
            } else {
                clearTimeout(dc);
            }
        }
        delayedCalls = [];
    }

    function setPageBackground(bg) {
        document.querySelector("html").style.backgroundImage = "url(assets/games/letter-grid/imgs/" + bg + ".jpg)";
    }

    function setupButton(btn, frame) {
        btn.on('pointerdown', () => {
            btn.setFrame(frame + '_hover' + '0000');
        });
        btn.on('pointerover', () => {
            btn.setFrame(frame + '_hover' + '0000');
            game.scene.getAt(0).sound.add("button hover").play();
        });
        btn.on('pointerout', () => {
            btn.setFrame(frame + '0000');
        });
        btn.on('pointerup', () => {
            btn.setFrame(frame + '0000');
            game.scene.getAt(0).sound.add('activity selection - button selection').play();
        });
    }

    function setupButtonTextureBased(btn, texture, hoverTexture) {
        btn.on('pointerdown', () => {
            btn.setTexture(hoverTexture);
        });
        btn.on('pointerover', () => {
            btn.setTexture(hoverTexture);
            game.scene.getAt(0).sound.add("button hover").play();
        });
        btn.on('pointerout', () => {
            btn.setTexture(texture);
        });
        btn.on('pointerup', () => {
            btn.setTexture(texture);
            game.scene.getAt(0).sound.add('activity selection - button selection').play();
        });
    }

    (function (sh) {
        var core;
        (function (core) {
            class Gameplay {
                constructor() {
                    this.totalLettersCount = 25;
                    this.totalRoundsNum = 2;
                    this.failsNumToLose = 3;
                    this.choicesNumPerRound = 5;
                    this.currentRound = 0;
                    this.currentLetter = null;
                    this.correctAnswersCount = 0;
                    this.wrongAnswersCount = 0;
                    this.correctAnswersCountThisRound = 0;
                    this.wrongAnswersCountThisRound = 0;
                }

                setupCallbacks(onComplete, onLose) {
                    this.onComplete = onComplete;
                    this.onLose = onLose;
                }

                calculateScore() {
                    return this.choicesNumPerRound * this.totalRoundsNum - this.wrongAnswersCount;
                }

                onLetterChosen() {
                    if (this.correctAnswersCountThisRound == this.choicesNumPerRound) {
                        this.currentRound++;
                        if (this.currentRound >= this.totalRoundsNum) {
                            let score = this.calculateScore();
                            this.onComplete(score, score);
                            return true;
                        } else {
                            this.nextLetter();
                        }
                    }
                    return false;
                }

                nextLetter() {
                    if (this.roundsLetter.length == 0) {
                        this.currentLetter = null;
                    } else {
                        this.currentLetter = this.roundsLetter.shift();
                        this.gridLettersNames = [];
                        let correctLetterName = this.getCorrectLetterName();
                        for (let i = 0; i < this.choicesNumPerRound; i++) {
                            this.gridLettersNames.push(correctLetterName);
                        }
                        let rwl = this.roundsWrongLetters.shift();
                        for (let wl of rwl) {
                            for (let i = 0; i < 2; i++) {
                                this.gridLettersNames.push(wl);
                            }
                        }
                    }
                    this.correctAnswersCountThisRound = 0;
                    this.wrongAnswersCountThisRound = 0;
                }

                getCorrectLetterName() {
                    return this.currentLetter['correctLetterName'];
                }

                getCorrectAudioKey() {
                    return this.currentLetter['correctAudioKey'];
                }

                onCorrectAnswer() {
                    this.correctAnswersCount++;
                    this.correctAnswersCountThisRound++;
                    return this.onLetterChosen();
                }

                onWrongAnswer() {
                    this.wrongAnswersCount++;
                    this.wrongAnswersCountThisRound++;
                    if (this.wrongAnswersCountThisRound >= this.failsNumToLose) {
                        this.onLose(0, 0);
                        return true;
                    } else {
                        this.onLetterChosen();
                    }
                    return false;
                }

                getCurrentTotalAnswersCount() {
                    return this.correctAnswersCount + this.wrongAnswersCount;
                }

                getCurrentTotalAnswersCountThisRound() {
                    return this.correctAnswersCountThisRound + this.wrongAnswersCountThisRound;
                }

                isNewRound() {
                    return this.getCurrentTotalAnswersCountThisRound() == 0;
                }

                isRoundsComplete() {
                    return this.getCurrentTotalAnswersCount() / this.choicesNumPerRound >= this.totalRoundsNum;
                }

                reset() {
                    let json = game.cache.json.get('gameplay');
                    this.letters = json["letters"].slice();
                    let rounds = json["rounds"];
                    this.roundsLetter = [];
                    this.roundsWrongLetters = [];
                    for (let r of rounds) {
                        let l = r["correctLetter"];
                        for (let i = this.letters.length - 1; i >= 0; i--) {
                            if (this.letters[i]['correctLetterName'] == l) {
                                this.roundsLetter.push(this.letters[i]);
                                break;
                            }
                        }
                        this.roundsWrongLetters.push(r["wrongLetters"]);
                    }
                    this.totalRoundsNum = this.roundsLetter.length;
                    this.nextLetter();
                    this.currentRound = 0;
                    this.correctAnswersCount = 0;
                    this.wrongAnswersCount = 0;
                    this.correctAnswersCountThisRound = 0;
                    this.wrongAnswersCountThisRound = 0;
                }
            }

            core.Gameplay = Gameplay;
        })(core = sh.core || (sh.core = {}));
    })(sh || (sh = {}));

    (function (sh) {
        var scene;
        (function (scene) {
            class Boot extends Phaser.Scene {
                init() {
                    // new FitScaleManager(this.game).setup();
                    this.game.scale.transformX = (pageX) => {
                        let offsetLeft = 0;
                        let parentElement = game.canvas.parentElement;
                        while (parentElement) {
                            if (parentElement.offsetLeft) {
                                offsetLeft = parentElement.offsetLeft;
                                break;
                            }
                            parentElement = parentElement.parentElement;
                        }
                        return (pageX - offsetLeft) * this.game.scale.displayScale.x;
                    };
                    this.game.scale.transformY = (pageY) => {
                        let offsetTop = 0;
                        let parentElement = game.canvas.parentElement;
                        while (parentElement) {
                            if (parentElement.offsetTop) {
                                offsetTop = parentElement.offsetTop;
                                break;
                            }
                            parentElement = parentElement.parentElement;
                        }
                        return (pageY - offsetTop) * this.game.scale.displayScale.y;
                    };
                }

                create() {
                    game.scene.remove('Boot');
                    game.scene.add('Preloader', sh.scene.Preloader, true);
                }
            }

            scene.Boot = Boot;
        })(scene = sh.scene || (sh.scene = {}));
    })(sh || (sh = {}));

    (function (sh) {
        var scene;
        (function (scene) {
            var Gameplay = sh.core.Gameplay;

            class MainScene extends Phaser.Scene {
                create() {
                    this.gameplay = new Gameplay();
                    this.gameplayScreen = new sh.screen.GameplayScreen(this, this.gameplay);
                    this.children.add(this.gameplayScreen);
                    this.gameplayScreen.showInstructionPage();
                }
            }

            scene.MainScene = MainScene;
        })(scene = sh.scene || (sh.scene = {}));
    })(sh || (sh = {}));

    (function (sh) {
        var scene;
        (function (scene) {
            class Preloader extends Phaser.Scene {
                preload() {
                    if (typeof sh.App.json == "string") this.load.json('gameplay', sh.App.json); else this.game.cache.json.add('gameplay', sh.App.json);
                }

                create() {
                    this.load.pack('preloader', 'assets/games/letter-grid/pack.json');

                    let json = game.cache.json.get('gameplay');
                    for (let l of json["letters"]) {
                        this.load.image(l["correctLetterName"], "assets/games/letter-grid/imgs/letters/" + l["correctLetterName"] + ".png");
                    }

                    this.load.on('progress', (value) => {
                    }, this);
                    this.load.on('complete', () => {
                        this.nextScene();
                    });
                    this.load.start();
                }

                nextScene() {
                    game.scene.remove('Preloader');
                    game.scene.add('ScreenMain', sh.scene.MainScene, true);
                }
            }

            scene.Preloader = Preloader;
        })(scene = sh.scene || (sh.scene = {}));
    })(sh || (sh = {}));

    (function (sh) {
        var screen;
        (function (screen) {
            class AreYouSureWindow extends Phaser.GameObjects.Container {
                constructor(scene, onYes, onNo) {
                    super(scene);
                    this._areYouSurePage = new Phaser.GameObjects.Image(this.scene, -105, 0 - 48, 'Exit warning');
                    this._areYouSurePage.setOrigin(0, 0);
                    this._areYouSurePage.setInteractive();
                    var modalTextStyle = {
                        backgroundColor: 'transparent',
                        stroke: '#ffffff',
                        strokeThickness: 2,
                        lineSpacing: 15,
                        fontFamily: 'Kids Rock DEMO',
                        fontSize: 27,
                        color: '#43425d',
                        wordWrap: true,
                        align: 'center'
                    };
                    var modalText = this.scene.add.text(game.scale.width / 2 + 12, game.scale.height / 2, "Your progress in this activity will not be saved. \n Are you sure you want to exit? ", modalTextStyle);
                    modalText.setOrigin(0.5, 0.5);
                    this._btnSureYes = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2 - 95, 485 - 50, 'btnYES1');
                    this._btnSureYes.setInteractive({ cursor: 'pointer' });
                    this._btnSureYes.once('pointerup', () => {
                        onYes;
                        window.angularComponentRef.backToMenu()
                    });
                    setupButtonTextureBased(this._btnSureYes, 'btnYES1', 'btnYES2');
                    this._btnSureNo = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2 + 95, 485 - 50, 'btnNO1');
                    this._btnSureNo.setInteractive({ cursor: 'pointer' });
                    this._btnSureNo.once('pointerup', onNo);
                    setupButtonTextureBased(this._btnSureNo, 'btnNO1', 'btnNO2');
                    this.add(this._areYouSurePage);
                    this.add(this._btnSureYes);
                    this.add(this._btnSureNo);
                    this.add(modalText);
                }
            }

            screen.AreYouSureWindow = AreYouSureWindow;
        })(screen = sh.screen || (sh.screen = {}));
    })(sh || (sh = {}));

    (function (sh) {
        var screen;
        (function (screen) {
            class CompleteWindow extends Phaser.GameObjects.Container {
                constructor(scene, onBack, onReplay, onNext) {
                    super(scene);
                    this.music = null;
                    this.setPosition(-104.5, -48);
                    this._bgComplete = new Phaser.GameObjects.Image(this.scene, 0, 0, 'Completion page LATEST UPDATED');
                    this._bgComplete.setOrigin(0, 0);
                    this._bgComplete.setInteractive();
                    this._cup = new Phaser.GameObjects.Image(this.scene, 400, 410, 'Trophy');
                    this._btnBack = new Phaser.GameObjects.Image(this.scene, 570, 570, 'btnBACK1');
                    this._btnReplay = new Phaser.GameObjects.Image(this.scene, 720, 570, 'btnReplay1');
                    this._btnNext = new Phaser.GameObjects.Image(this.scene, 870, 570, 'btnNEXT1');
                    let _CollectedPoints = new Phaser.GameObjects.Image(this.scene, 620, 440, 'Collected Points');
                    this.totalScoreTxt = this.scene.add.text(845, 352, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 35,
                        "color": "#F49F1C",
                        "align": 'center',
                        'stroke': '#70451A',
                        'strokeThickness': 6
                    });
                    this.totalScoreTxt.setOrigin(0.5, 0.5);
                    let grd = this.totalScoreTxt.context.createLinearGradient(0, 0, 0, this.totalScoreTxt.height);
                    grd.addColorStop(0, '#FFFF00');
                    grd.addColorStop(1, '#C17316');
                    this.totalScoreTxt.setFill(grd);
                    this.starScoreTxt = this.scene.add.text(648, 433, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 24,
                        "color": "#FFFFFF",
                        "align": 'center'
                    });
                    this.starScoreTxt.setOrigin(0.5, 0.5);
                    this.add([
                        this._bgComplete,
                        _CollectedPoints,
                        this._cup,
                        this._btnBack,
                        this._btnReplay,
                        this._btnNext,
                        this.totalScoreTxt,
                        this.starScoreTxt
                    ]);
                    this._btnBack.setInteractive({ cursor: 'pointer' });
                    this._btnBack.on('pointerup', () => {
                        onBack(this._btnBack);
                        window.angularComponentRef.backToMenu();
                        // if (this.music) {
                        //     this.music.stop();
                        // }
                    });
                    setupButtonTextureBased(this._btnBack, 'btnBACK1', 'btnBACK2');
                    this._btnReplay.setInteractive({ cursor: 'pointer' });
                    this._btnReplay.once('pointerup', () => {
                        onReplay(this._btnReplay);
                        if (this.music) {
                            this.music.stop();
                        }
                    });
                    setupButtonTextureBased(this._btnReplay, 'btnReplay1', 'btnReplay2');
                    this._btnNext.setInteractive({ cursor: 'pointer' });
                    this._btnNext.on('pointerup', () => {
                        onNext(this._btnNext);
                        window.angularComponentRef.nextActivity();
                        // if (this.music) {
                        //     this.music.stop();
                        // }
                    });
                    setupButtonTextureBased(this._btnNext, 'btnNEXT1', 'btnNEXT2');
                }

                show(score, starScore) {
                    window.angularComponentRef.gameFinish({ score, starScore })
                    this._cup.scale = 1.25;
                    this.scene.tweens.add({
                        targets: this._cup,
                        "scale": 1,
                        duration: 500,
                        ease: Phaser.Math.Easing.Back.Out
                    });
                    this.totalScoreTxt.text = String(window.angularComponentRef.component.userInfo.totalScore);
                    this.starScoreTxt.text = String(starScore);
                    // let music = this.scene.sound.add("viktory");
                    this.music = this.scene.sound.add("Activity completion fantastic");
                    this.music.play();
                }
            }

            screen.CompleteWindow = CompleteWindow;
        })(screen = sh.screen || (sh.screen = {}));
    })(sh || (sh = {}));

    (function (sh) {
        var screen;
        (function (screen) {
            class DoorsWindow extends Phaser.GameObjects.Container {
                constructor(scene) {
                    super(scene);
                    this._DoorR = new Phaser.GameObjects.Image(this.scene, 504.5, 158, 'Door R');
                    this._DoorR.setOrigin(0, 0);
                    this._DoorL = new Phaser.GameObjects.Image(this.scene, 313.5, 158, 'Door L');
                    this._DoorL.setOrigin(0, 0);
                    this._DoorInside = new Phaser.GameObjects.Image(this.scene, 313, 158, 'Door Inside');
                    this._DoorInside.setOrigin(0, 0);
                    this.add(this._DoorInside);
                    this.add(this._DoorR);
                    this.add(this._DoorL);
                }

                openDoor(door, duration, def_vertices_no_offset, vertXIndexes, vertYIndexes, vertYSign, tweenDoorValueY) {
                    door.visible = false;
                    let dx = 100, dy = 198;
                    let def_vertices = def_vertices_no_offset.slice();
                    for (let i = 0; i < def_vertices_no_offset.length; i += 2) {
                        def_vertices[i] += dx;
                    }
                    for (let i = 1; i < def_vertices_no_offset.length; i += 2) {
                        def_vertices[i] += dy;
                    }
                    let mesh = this.scene.make.mesh({
                        key: door.texture.key,
                        x: door.x,
                        y: door.y,
                        vertices: def_vertices.slice(),
                        uv: [
                            /*  U   |   V  */
                            /* ----------- */
                            0, 0,
                            0, 1,
                            1, 1,
                            0, 0,
                            1, 1,
                            1, 0
                        ]
                    });
                    mesh["def_vertices"] = def_vertices;
                    door["tweenDoorValueX"] = mesh["def_vertices"][vertXIndexes[0]];
                    door["tweenDoorValueY"] = 0;
                    this.scene.tweens.add({
                        targets: door,
                        tweenDoorValueX: -def_vertices_no_offset[vertXIndexes[0]] * 0.6 + dx,
                        tweenDoorValueY: tweenDoorValueY,
                        duration: duration,
                        ease: Phaser.Math.Easing.Linear,
                        onUpdate: () => {
                            for (let k = 0; k < vertYIndexes.length; k++) {
                                mesh.vertices[vertYIndexes[k]] = mesh["def_vertices"][vertYIndexes[k]] + vertYSign[k] * door["tweenDoorValueY"];
                            }
                            for (let i of vertXIndexes) {
                                mesh.vertices[i] = door["tweenDoorValueX"];
                            }
                        }
                    });
                    this.add(mesh);
                    this.scene.sound.add('Door opening').play();
                }

                open(onComplete) {
                    let duration = 2000;
                    let tweenDoorValueY = 50;
                    this.openDoor(this._DoorR, duration, [
                        /*  X   |   Y  */
                        /* ----------- */
                        -this._DoorR.width / 2, -this._DoorR.height / 2,
                        -this._DoorR.width / 2, this._DoorR.height / 2,
                        this._DoorR.width / 2, this._DoorR.height / 2,
                        -this._DoorR.width / 2, -this._DoorR.height / 2,
                        this._DoorR.width / 2, this._DoorR.height / 2,
                        this._DoorR.width / 2, -this._DoorR.height / 2
                    ], [0, 2, 6], [1, 3, 7], [-1, 1, -1], tweenDoorValueY);
                    this.openDoor(this._DoorL, duration, [
                        /*  X   |   Y  */
                        /* ----------- */
                        -this._DoorL.width / 2, -this._DoorL.height / 2,
                        -this._DoorL.width / 2, this._DoorL.height / 2,
                        this._DoorL.width / 2, this._DoorL.height / 2,
                        -this._DoorL.width / 2, -this._DoorL.height / 2,
                        this._DoorL.width / 2, this._DoorL.height / 2,
                        this._DoorL.width / 2, -this._DoorL.height / 2
                    ], [4, 8, 10], [5, 9, 11], [-1, -1, 1], -tweenDoorValueY);
                    delayedCall(duration, onComplete);
                }
            }

            screen.DoorsWindow = DoorsWindow;
        })(screen = sh.screen || (sh.screen = {}));
    })(sh || (sh = {}));

    (function (sh) {
        var screen;
        (function (screen) {
            class GameplayScreen extends Phaser.GameObjects.Container {
                constructor(scene, gameplay) {
                    super(scene);
                    this.rows = 5;
                    this.cols = 5;
                    this.bgMusic = null;
                    this.sfxOpen = null;
                    this.sfxClose = null;
                    this.soundGooseYes = null;
                    this.soundGooseNo = null;
                    this.correctAudio = null;
                    this.wfsnd = null;
                    this.sfxCallToPrayer = null;
                    this.showCompleteWindow = (score, starScore) => {
                        let completeWindow = new screen.CompleteWindow(this.scene, (target) => {
                            this.playBtnClickAnim(target);
                        }, (target) => {
                            this.playBtnClickAnim(target);
                            this.destroyGameplay();
                            this.remove(completeWindow);
                            this.showInstructionPage();
                        }, (target) => {
                            this.playBtnClickAnim(target);
                        });
                        this.setInputEnabled(false);
                        delayedCall(1500, () => {
                            this.bgMusic.stop();
                            this.doorsWindow.open(() => {
                                this.sfxCallToPrayer = this.scene.sound.add("Call to prayer");
                                this.sfxCallToPrayer.play();
                                delayedCall(6000, () => {
                                    setPageBackground("bg-blue");
                                    this.add(completeWindow);
                                    completeWindow.show(score, starScore);
                                });
                            });
                        });
                    };
                    this.showLoseWindow = (score, starScore) => {
                        let tryAgainWindow = new screen.TryAgainWindow(this.scene, (target) => {
                            this.playBtnClickAnim(target);
                        }, (target) => {
                            this.playBtnClickAnim(target);
                            this.destroyGameplay();
                            this.remove(tryAgainWindow);
                            this.showInstructionPage();
                        });
                        this.setInputEnabled(false);
                        delayedCall(750, () => {
                            setPageBackground("bg-blue");
                            this.add(tryAgainWindow);
                            tryAgainWindow.show(score, starScore);
                            this.bgMusic.stop();
                        });
                    };
                    this.gameplay = gameplay;
                    window["t"] = this;
                }

                showGameplay() {
                    setPageBackground("bg-australia");
                    this.bgMusic = this.scene.sound.add("B-g ambience");
                    this.bgMusic.play();
                    this.bgMusic.loop = true;
                    this._gameStage = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2, game.scale.height / 2, '3 Letter Grid');
                    this._gameStage.setOrigin(0.485, 0.48);
                    this._gameStage.setInteractive();
                    this._btnSound = new Phaser.GameObjects.Image(this.scene, 160 - 105, 100 - 50, 'Sound');
                    this._btnSound.setInteractive({ cursor: 'pointer' });
                    setupButtonTextureBased(this._btnSound, 'Sound', 'Sound HOVER EFFECT');
                    this._btnClose = new Phaser.GameObjects.Image(this.scene, 1025 - 105, 100 - 50, 'x Button');
                    this._btnClose.setInteractive({ cursor: 'pointer' });
                    setupButtonTextureBased(this._btnClose, 'x Button', 'x Button HOVER EFFECT');
                    this.gameplayContainer = new Phaser.GameObjects.Container(this.scene);
                    this.addAt(this.gameplayContainer, 0);
                    this.targetLetterLabel = new Phaser.GameObjects.Image(this.scene, 590, 90, null);
                    this.targetLetterLabel.tint = Math.round(0x000000 * 0.9);
                    this.doorsWindow = new screen.DoorsWindow(this.scene);
                    this.gameplayContainer.add([
                        this._gameStage,
                        this.doorsWindow,
                        this._btnSound,
                        this._btnClose,
                        this.targetLetterLabel
                    ]);
                    this.gameplay.reset();
                    this.createGrid();
                    this.createCrescentMoons();
                    this.createInput();
                    this.showOutGrid();
                    this.gameplay.setupCallbacks(this.showCompleteWindow, this.showLoseWindow);
                }

                showOutGrid() {
                    this.setInputEnabled(false);
                    let delay = 700;
                    for (let i = 0; i < this.rows; i++) {
                        for (let j = 0; j < this.cols; j++) {
                            let c = this.grid[i][j];
                            c.setScale(0);
                            this.scene.tweens.add({
                                targets: c,
                                "scale": 1,
                                duration: 300,
                                delay: delay
                            });
                        }
                    }
                    delayedCall(delay, () => {
                        this.sfxOpen = this.scene.sound.add("open");
                        this.sfxOpen.play();
                    });
                    this.targetLetterLabel.visible = false;
                    this.resetCrescentMoons();
                    this.randomizeGrid();
                    delayedCall(1200, () => {
                        this.targetLetterLabel.visible = true;
                        this.updateClickLetterTargetLabel();
                        if (this.gameplay.isNewRound()) {
                            if (!this.gameplay.isRoundsComplete()) {
                                this.playCorrectAudio();
                                delayedCall(2000, () => {
                                    this.setInputEnabled(true);
                                });
                            }
                        } else {
                            this.setInputEnabled(true);
                        }
                    });
                }

                showInGrid(showOut) {
                    this.setInputEnabled(false);
                    let delay = 700;
                    for (let i = 0; i < this.rows; i++) {
                        for (let j = 0; j < this.cols; j++) {
                            let c = this.grid[i][j];
                            this.scene.tweens.add({
                                targets: c,
                                "scale": 0,
                                duration: 300,
                                delay: delay,
                                onComplete: () => {
                                    c["bg"].setTexture('rr_def');
                                }
                            });
                        }
                    }
                    delayedCall(delay, () => {
                        this.sfxClose = this.scene.sound.add("close");
                        this.sfxClose.play();
                    });
                    if (showOut) {
                        delayedCall(1000, () => {
                            this.showOutGrid();
                        });
                    }
                }

                createInput() {
                    for (let i = 0; i < this.rows; i++) {
                        for (let j = 0; j < this.cols; j++) {
                            let c = this.grid[i][j];
                            c["bg"].on('pointerup', () => {
                                this.playBtnClickAnim(c);
                                c["bg"].disableInteractive();
                                let l = c["letter"];
                                if (l && l.texture.key == this.gameplay.getCorrectLetterName()) {
                                    c["bg"].setTexture('rr_active');
                                    let completed = this.onCorrectAnswer();
                                    if (!completed) {
                                        if (this.gameplay.isNewRound()) {
                                            this.showInGrid(true);
                                        }
                                    } else {
                                        this.showInGrid(false);
                                    }
                                } else {
                                    c["bg"].setTexture('rr_wrong');
                                    let lost = this.onWrongAnswer();
                                    if (!lost) {
                                        if (this.gameplay.isNewRound()) {
                                            this.showInGrid(true);
                                        }
                                    } else {
                                        this.showInGrid(false);
                                    }
                                }
                            });
                        }
                    }
                    this._btnSound.on('pointerup', () => {
                        this.playBtnClickAnim(this._btnSound);
                        this.onSoundClick();
                    });
                    this._btnClose.on('pointerup', () => {
                        this.playBtnClickAnim(this._btnClose);
                        this.onCloseClick();
                    });
                }

                createGrid() {
                    let startX = 355;
                    let startY = 215;
                    let dx = 76;
                    let dy = 71;
                    this.grid = [];
                    for (let i = 0; i < this.rows; i++) {
                        let arr = [];
                        for (let j = 0; j < this.cols; j++) {
                            let c = new Phaser.GameObjects.Container(this.scene, startX + i * dx, startY + j * dy);
                            this.gameplayContainer.add(c);
                            c["bg"] = new Phaser.GameObjects.Image(this.scene, 0, 0, 'rr_def');
                            c.add(c["bg"]);
                            c["letter"] = new Phaser.GameObjects.Image(this.scene, 0, 0, null);
                            c["letter"]["rectContainer"] = c;
                            c.add(c["letter"]);
                            c["letter"].tint = Math.round(0x000000 * 0.9);
                            arr.push(c);
                        }
                        this.grid.push(arr);
                    }
                }

                randomizeGrid() {
                    let gridLettersNames = null;
                    let minTriesGrid = null;
                    let minTries = Number.MAX_VALUE;
                    let triesNum = 0;
                    let sim = Number.MAX_VALUE;
                    do {
                        triesNum++;
                        gridLettersNames = Phaser.Utils.Array.Shuffle(this.gameplay.gridLettersNames.slice());
                        sim = this.checkRandomizationSimilarity(gridLettersNames);
                        if (sim < minTries) {
                            minTries = sim;
                            minTriesGrid = gridLettersNames;
                        }
                    } while (sim > 0 && triesNum < 100);
                    for (let i = 0; i < this.rows; i++) {
                        for (let j = 0; j < this.cols; j++) {
                            let l = this.grid[i][j]["letter"];
                            let rnd = minTriesGrid.shift();
                            l.setTexture(rnd);
                        }
                    }
                }

                checkRandomizationSimilarity(gridLettersNames) {
                    let similarity = 0;
                    for (let i = 0; i < gridLettersNames.length - 1; i++) {
                        if (gridLettersNames[i] == gridLettersNames[i + 1]) {
                            similarity++;
                        }
                    }
                    for (let i = 0; i < gridLettersNames.length - this.rows; i++) {
                        if (i + this.rows < gridLettersNames.length && gridLettersNames[i] == gridLettersNames[i + this.rows]) {
                            similarity++;
                        }
                    }
                    // console.log("sim: ",similarity);
                    return similarity;
                }

                updateClickLetterTargetLabel() {
                    this.targetLetterLabel.setTexture(this.gameplay.getCorrectLetterName());
                }

                createCrescentMoons() {
                    this.crescentMoons = [];
                    let dy = 61;
                    for (let i = 0; i < this.gameplay.choicesNumPerRound; i++) {
                        let cm = new Phaser.GameObjects.Image(this.scene, 179, 261 + i * dy, 'crescent_moon_def');
                        this.crescentMoons.push(cm);
                        this.gameplayContainer.add(cm);
                    }
                }

                resetCrescentMoons() {
                    for (let i = 0; i < this.crescentMoons.length; i++) {
                        this.setMoonsActive(i, false);
                    }
                }

                setMoonsActive(index, active) {
                    this.crescentMoons[index].setTexture(active ? 'crescent_moon_active' : 'crescent_moon_def');
                }

                onCorrectAnswer() {
                    this.setMoonsActive(this.gameplay.correctAnswersCountThisRound, true);
                    let completed = this.gameplay.onCorrectAnswer();
                    this.soundGooseYes = this.scene.sound.add("Correct click");
                    this.soundGooseYes.play();
                    return completed;
                }

                onWrongAnswer() {
                    let lost = this.gameplay.onWrongAnswer();
                    this.soundGooseNo = this.scene.sound.add("Incorrect click");
                    this.soundGooseNo.play();
                    return lost;
                }

                playCorrectAudio() {
                    if (this.correctAudio) {
                        this.correctAudio.stop();
                    }
                    try {
                        if (this.areYouSureWindow && this.areYouSureWindow.parentContainer == this) {
                            this.correctAudio.pause();
                        }
                        delayedCall(750, () => {
                            this.correctAudio = this.scene.sound.add(this.gameplay.getCorrectAudioKey());
                            this.correctAudio.play();
                            if (this.areYouSureWindow && this.areYouSureWindow.parentContainer == this) {
                                this.correctAudio.pause();
                            }
                        });
                    } catch (e) {
                        console.log(e);
                    }
                }

                onSoundClick() {
                    this.playCorrectAudio();
                }

                onCloseClick() {
                    this.showAreYouSurePage();
                    this.scene.sound.add('warning page pop up sfx').play();
                }

                playBtnClickAnim(target) {
                    target.scaleX = target.scaleY = 1;
                    this.scene.tweens.add({
                        targets: target,
                        "scaleX": 0.9,
                        "scaleY": 0.9,
                        duration: 100,
                        yoyo: true
                    });
                }

                showInstructionPage() {
                    setPageBackground("bg-blue");
                    let playInstructionSound = () => {
                        if (this.wfsnd) {
                            this.wfsnd.stop();
                        }
                        this.wfsnd = this.scene.sound.add("Unlock the Gate Open the mosque gate by entering the passcode.");
                        this.wfsnd.play();
                    };
                    this.instructionPage = new screen.InstructionPage(this.scene, (target) => {
                        this.playBtnClickAnim(target);
                        this.remove(this.instructionPage);
                        this.showGameplay();
                        if (this.wfsnd) {
                            this.wfsnd.stop();
                        }
                    }, (target) => {
                        this.playBtnClickAnim(target);
                        playInstructionSound();
                    });
                    this.add(this.instructionPage);
                    try {
                        playInstructionSound();
                    }
                    catch (e) {
                        console.error(e);
                    }
                }

                showAreYouSurePage() {
                    pauseAllDelayedCalls();
                    setPageBackground("bg-blue");
                    this.pauseSounds();
                    this.areYouSureWindow = new screen.AreYouSureWindow(this.scene, () => {
                        this.remove(this.areYouSureWindow);
                        this.destroyGameplay();
                        this.showInstructionPage();
                    }, () => {
                        this.remove(this.areYouSureWindow);
                        this.unpauseSounds();
                        resumeAllDelayedCalls();
                        setPageBackground("bg-australia");
                    });
                    this.add(this.areYouSureWindow);
                }

                setInputEnabled(enabled) {
                    if (enabled) {
                        for (let i = 0; i < this.rows; i++) {
                            for (let j = 0; j < this.cols; j++) {
                                this.grid[i][j]["bg"].setInteractive({ cursor: 'pointer' });
                            }
                        }
                    } else {
                        for (let i = 0; i < this.rows; i++) {
                            for (let j = 0; j < this.cols; j++) {
                                this.grid[i][j]["bg"].disableInteractive();
                            }
                        }
                    }
                }

                pauseSounds() {
                    this.scene.sound.pauseAll();
                }

                unpauseSounds() {
                    this.scene.sound.resumeAll();
                }

                destroyGameplay() {
                    this.setInputEnabled(false);
                    this.remove(this.gameplayContainer);
                    destroyAllDelayedCalls();
                }
            }

            screen.GameplayScreen = GameplayScreen;
        })(screen = sh.screen || (sh.screen = {}));
    })(sh || (sh = {}));

    (function (sh) {
        var screen;
        (function (screen) {
            class InstructionPage extends Phaser.GameObjects.Container {
                constructor(scene, onPlayClick, onSndClick) {
                    super(scene);
                    this._instructionPage = new Phaser.GameObjects.Image(this.scene, 0 - 105, 0 - 48, 'Instructions page  ALL ACTIVITY  TITLEs');
                    this._instructionPage.setOrigin(0, 0);
                    this._instructionPage.setInteractive();
                    this._instructionPageTitle = new Phaser.GameObjects.Image(this.scene, 495, 105, 'welcome');
                    this._instructionPageTitle.setScale(0.75);
                    this._btnPlay = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2, 480 - 50, 'btnPLAY1');
                    this._btnPlay.setInteractive({ cursor: 'pointer' });
                    this._btnPlay.once('pointerup', onPlayClick);
                    setupButtonTextureBased(this._btnPlay, 'btnPLAY1', 'btnPLAY2');
                    this.instrTxt = this.scene.add.text(game.scale.width / 2, game.scale.height / 2, "Open the mosque gate by entering\nthe passcode.", {
                        "fontFamily": "Kids Rock DEMO",
                        "fontSize": 30,
                        "color": "#43425D",
                        "align": 'center'
                    });
                    this.instrTxt.setLineSpacing(20);
                    this.instrTxt.setOrigin(0.5, 0.5);
                    this._btnSoundInstruction = new Phaser.GameObjects.Image(this.scene, 800 - 105, 156 - 50, 'Sound');
                    this._btnSoundInstruction.setInteractive({ cursor: 'pointer' });
                    this._btnSoundInstruction.on('pointerup', onSndClick);
                    setupButtonTextureBased(this._btnSoundInstruction, 'Sound', 'Sound HOVER EFFECT');
                    this.add(this._instructionPage);
                    this.add(this._instructionPageTitle);
                    this.add(this.instrTxt);
                    this.add(this._btnPlay);
                    this.add(this._btnSoundInstruction);
                }
            }

            screen.InstructionPage = InstructionPage;
        })(screen = sh.screen || (sh.screen = {}));
    })(sh || (sh = {}));

    (function (sh) {
        var screen;
        (function (screen) {
            class TryAgainWindow extends Phaser.GameObjects.Container {
                constructor(scene, onBack, onReplay) {
                    super(scene);
                    this.music = null;
                    this.setPosition(-106, -48);
                    this._bg = new Phaser.GameObjects.Image(this.scene, 0, 0, 'Try again page');
                    this._bg.setOrigin(0, 0);
                    this._bg.setInteractive();
                    this._star = new Phaser.GameObjects.Image(this.scene, 400, 415, 'Break Star');
                    this._btnBack = new Phaser.GameObjects.Image(this.scene, 600, 580, 'btnBACK1');
                    this._btnReplay = new Phaser.GameObjects.Image(this.scene, 765, 580, 'btnReplay1');
                    this.totalScoreTxt = this.scene.add.text(830, 355, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 35,
                        "color": "#F49F1C",
                        "align": 'center',
                        'stroke': '#70451A',
                        'strokeThickness': 6
                    });
                    this.totalScoreTxt.setOrigin(0.5, 0.5);
                    let grd = this.totalScoreTxt.context.createLinearGradient(0, 0, 0, this.totalScoreTxt.height);
                    grd.addColorStop(0, '#FFFF00');
                    grd.addColorStop(1, '#C17316');
                    this.totalScoreTxt.setFill(grd);
                    this.starScoreTxt = this.scene.add.text(635, 431, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 24,
                        "color": "#FFFFFF",
                        "align": 'center'
                    });
                    this.starScoreTxt.setOrigin(0.5, 0.5);
                    this.add([
                        this._bg,
                        this._star,
                        this._btnBack,
                        this._btnReplay,
                        this.totalScoreTxt,
                        this.starScoreTxt
                    ]);
                    this._btnBack.setInteractive({ cursor: 'pointer' });
                    this._btnBack.on('pointerup', () => {
                        onBack(this._btnBack);
                        window.angularComponentRef.backToMenu()
                        // if (this.music) {
                        //     this.music.stop();
                        // }
                    });
                    setupButtonTextureBased(this._btnBack, 'btnBACK1', 'btnBACK2');
                    this._btnReplay.setInteractive({ cursor: 'pointer' });
                    this._btnReplay.once('pointerup', () => {
                        onReplay(this._btnReplay);
                        if (this.music) {
                            this.music.stop();
                        }
                    });
                    setupButtonTextureBased(this._btnReplay, 'btnReplay1', 'btnReplay2');
                }

                show(score, starScore) {
                    this._star.scale = 1.25;
                    this.scene.tweens.add({
                        targets: this._star,
                        "scale": 1,
                        duration: 500,
                        ease: Phaser.Math.Easing.Back.Out
                    });
                    this.totalScoreTxt.text = String(window.angularComponentRef.component.userInfo.totalScore);
                    this.starScoreTxt.text = String(starScore);
                    this.music = this.scene.sound.add("Fail - close one");
                    this.music.play();
                }
            }

            screen.TryAgainWindow = TryAgainWindow;
        })(screen = sh.screen || (sh.screen = {}));
    })(sh || (sh = {}));

    game = new sh.App(json);
};

function destroyLetterGrid() {
    if (game) {
        game.destroy();
    }
}

var garage;var garage;

var game;
var letterCloud = (json) => {
    (function (garage) {
        class App extends Phaser.Game {
            constructor(json) {
                App.json = json
                let config = {
                    type: Phaser.AUTO,
                    width: App.CANVAS_WIDTH,
                    height: App.CANVAS_HEIGHT,
                    parent: 'game-container',
                    dom: {
                        createContainer: false
                    },
                    scale: {
                        mode: FitScaleManager.detectBestScaleMode(),
                        autoCenter: Phaser.Scale.CENTER_BOTH
                    },
                    transparent: true,
                    scene: {
                        create: () => {
                            this.scene.add('Boot', garage.scene.Boot, true);
                        }
                    }
                };
                super(config);
            }
        }

        App.CANVAS_WIDTH = 980;
        App.CANVAS_HEIGHT = 600;
        garage.App = App;
    })(garage || (garage = {}));

    function pad(n, width, z) {
        z = z || '0';
        n = n + '';
        return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
    }

    var delayedCalls = [];

    function delayedCall(delay, callback, args, callbackScope) {
        let scene = game.scene.getAt(0);
        if (scene) {
            let dc = scene.time.delayedCall(delay, callback, args, callbackScope);
            delayedCalls.push(dc);
            return dc;
        }
        let t = setTimeout(callback, delay);
        delayedCalls.push(t);
        return t;
    }

    function pauseAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.paused = true;
            }
        }
    }

    function resumeAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.paused = false;
            }
        }
    }

    function destroyAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.remove(false);
            } else {
                clearTimeout(dc);
            }
        }
        delayedCalls = [];
    }

    function destroyDelayedCall(dc) {
        if (dc instanceof Phaser.Time.TimerEvent) {
            dc.remove(false);
        } else {
            clearTimeout(dc);
        }
        let ind = delayedCalls.indexOf(dc);
        if (ind >= 0)
            delayedCalls.splice(ind, 1);
    }

    function setPageBackground(bg) {
        document.querySelector("html").style.backgroundImage = "url(assets/games/letter-cloud/imgs/" + bg + ".jpg)";
    }

    function setupButton(btn, frame) {
        btn.on('pointerdown', () => {
            btn.setFrame(frame + '_hover' + '0000');
        });
        btn.on('pointerover', () => {
            btn.setFrame(frame + '_hover' + '0000');
            game.scene.getAt(0).sound.add("button hover").play();
        });
        btn.on('pointerout', () => {
            btn.setFrame(frame + '0000');
        });
        btn.on('pointerup', () => {
            btn.setFrame(frame + '0000');
            game.scene.getAt(0).sound.add('activity selection - button selection').play();
        });
    }

    function setupButtonTextureBased(btn, texture, hoverTexture) {
        btn.on('pointerdown', () => {
            btn.setTexture(hoverTexture);
        });
        btn.on('pointerover', () => {
            btn.setTexture(hoverTexture);
            game.scene.getAt(0).sound.add("button hover").play();
        });
        btn.on('pointerout', () => {
            btn.setTexture(texture);
        });
        btn.on('pointerup', () => {
            btn.setTexture(texture);
            game.scene.getAt(0).sound.add('activity selection - button selection').play();
        });
    }

    function playBtnClickAnim(target) {
        let sc = target.hasOwnProperty("defScale") ? target["defScale"] : 1;
        target.scaleX = target.scaleY = sc;
        let scene = game.scene.getAt(0);
        scene.tweens.add({
            targets: target,
            "scaleX": 0.9 * sc,
            "scaleY": 0.9 * sc,
            duration: 100,
            yoyo: true
        });
    }

    /**
     * @author Roman Parada
     * This class is created to fix overlapping of bottom part of canvas by navigation bar in iOS.
     * It make a delayed resize of the canvas (like Phaser-3 FIT methods does) and it overrides Phaser-3 input window to Phaser-3 core transform methods
     *
     * How to use:
     * Just call the code line below in Boot scene's init() method of your project:
     * new FitScaleManager(this.game).setup();
     */
    class FitScaleManager {
        constructor(game) {
            this.doResize = () => {
                let scale = this.calculateScale();
                let newCanvasWidth = this.phaserScaleManager.width * scale;
                let newCanvasHeight = this.phaserScaleManager.height * scale;
                this.canvasStyle.width = newCanvasWidth + 'px';
                this.canvasStyle.height = newCanvasHeight + 'px';
                this.canvasStyle.marginLeft = (window.innerWidth - newCanvasWidth) / 2 + 'px';
                this.canvasStyle.marginTop = (window.innerHeight - newCanvasHeight) / 2 + 'px';
            };
            this.game = game;
            this.canvasStyle = this.game.canvas.style;
            this.phaserScaleManager = this.game.scale;
        }

        static detectBestScaleMode() {
            let iOS = /iPad|iPhone|iPod/.test(navigator.platform || "");
            let isAndroid = window.navigator.userAgent.toLowerCase().indexOf("android") > -1;
            return iOS || isAndroid ? Phaser.Scale.FIT : Phaser.Scale.NONE;
        }
        ;

        /**
         * Just call this method once in Boot scene's init() method
         */
        setup() {
            this.phaserScaleManager.addListener(Phaser.Scale.Events.RESIZE, this.onResize, this);
            this.overridePhaserTransformMethods();
            this.onResize();
        }

        calculateScale() {
            if (game.scale.scaleMode == Phaser.Scale.NONE)
                return 1;
            return Math.min(window.innerWidth / this.phaserScaleManager.width, window.innerHeight / this.phaserScaleManager.height);
        }

        overridePhaserTransformMethods() {
            this.game.scale.transformX = (pageX) => {
                return (pageX - parseInt(this.canvasStyle.marginLeft.split("px")[0])) / this.calculateScale();
            };
            this.game.scale.transformY = (pageY) => {
                return (pageY - parseInt(this.canvasStyle.marginTop.split("px")[0])) / this.calculateScale();
            };
        }

        onResize() {
            setTimeout(this.doResize, FitScaleManager.RESIZE_DELAY);
        }
    }

    FitScaleManager.RESIZE_DELAY = 500;

    (function (garage) {
        var core;
        (function (core) {
            class Gameplay {
                constructor() {
                    this.allLettersNames = null;
                    this.currentRound = 0;
                    this.correctAnswersCount = 0;
                    this.wrongAnswersCount = 0;
                    this.correctAnswersCountThisRound = 0;
                    this.wrongAnswersCountThisRound = 0;
                    this.onNewRound = null;
                    this.nextLetterDelay = 0;
                    this.roundsVaryFrom = Number(game.cache.json.get('gameplay')["roundsVaryFrom"]);
                    this.roundsVaryTo = Number(game.cache.json.get('gameplay')["roundsVaryTo"]);
                    this.useImages = Boolean(game.cache.json.get('gameplay')["useImages"]);
                    this.wordsLetters = game.cache.json.get('gameplay')["wordsLetters"];
                }
                getRoundWordCharAt(at) {
                    return this.wordsLetters[this.roundWord][at];
                }

                getRoundWordLettersNumber() {
                    return this.wordsLetters[this.roundWord].length;
                }

                setupCallbacks(onComplete, onLose, onNewRound) {
                    this.onComplete = onComplete;
                    this.onNewRound = onNewRound;
                }

                calculateScore() {
                    return this.totalRoundsNum; //3 * this.totalRoundsNum - this.wrongAnswersCount;
                }

                onLetterChosen() {
                    if (this.correctAnswersCountThisRound == 1) {
                        this.currentRound++;
                        if (this.currentRound >= this.totalRoundsNum) {
                            let score = this.calculateScore();
                            this.onComplete(score, score);
                            return true;
                        } else {
                            this.nextWord();
                        }
                    }
                    return false;
                }

                nextWord() {
                    let fn = () => {
                        let round = this.rounds[this.currentRound];
                        this.roundWord = round["correctWord"];
                        this.roundWords = Phaser.Utils.Array.Shuffle([this.roundWord, round["wrongWord1"], round["wrongWord2"]]);
                        this.correctAnswersCountThisRound = 0;
                        this.wrongAnswersCountThisRound = 0;
                        if (this.onNewRound)
                            this.onNewRound();
                    };
                    if (this.nextLetterDelay == 0) {
                        fn();
                    } else {
                        delayedCall(this.nextLetterDelay, fn);
                    }
                }

                onCorrectAnswer() {
                    this.correctAnswersCount++;
                    this.correctAnswersCountThisRound++;
                    this.nextLetterDelay = 2500;
                    return this.onLetterChosen();
                }

                onWrongAnswer() {
                    this.wrongAnswersCount++;
                    this.wrongAnswersCountThisRound++;
                    this.nextLetterDelay = 0;
                    this.onLetterChosen();
                    return false;
                }

                getCurrentTotalAnswersCount() {
                    return this.correctAnswersCount + this.wrongAnswersCount;
                }

                getCurrentTotalAnswersCountThisRound() {
                    return this.correctAnswersCountThisRound + this.wrongAnswersCountThisRound;
                }

                isNewRound() {
                    return this.getCurrentTotalAnswersCountThisRound() == 0;
                }

                isRoundsComplete() {
                    return this.currentRound >= this.totalRoundsNum;
                }

                getAudioKeyOfChar(letter) {
                    let json = game.cache.json.get('gameplay');
                    let letters = json["letters"];
                    for (let d of letters) {
                        if (letter == d['letterName']) {
                            return d['audioKey'];
                        }
                    }
                    return null;
                }

                reset() {
                    this.currentRound = 0;
                    this.totalRoundsNum = Math.round(Math.random() * (this.roundsVaryTo - this.roundsVaryFrom)) + this.roundsVaryFrom;
                    this.nextLetterDelay = 0;
                    this.setupCallbacks(null, null, null);
                    let json = game.cache.json.get('gameplay');
                    this.letters = json["letters"].slice();
                    this.allLettersNames = [];
                    for (let d of this.letters)
                        this.allLettersNames.push(d["letterName"]);
                    this.rounds = JSON.parse(JSON.stringify(json["rounds"]));
                    this.totalRoundsNum = this.rounds.length;
                    this.nextWord();
                    this.correctAnswersCount = 0;
                    this.wrongAnswersCount = 0;
                    this.correctAnswersCountThisRound = 0;
                    this.wrongAnswersCountThisRound = 0;
                }
            }

            core.Gameplay = Gameplay;
        })(core = garage.core || (garage.core = {}));
    })(garage || (garage = {}));

    (function (garage) {
        var scene;
        (function (scene) {
            class Boot extends Phaser.Scene {
                init() {
                    // new FitScaleManager(this.game).setup();
                    this.game.scale.transformX = (pageX) => {
                        let offsetLeft = 0;
                        let parentElement = game.canvas.parentElement;
                        while (parentElement) {
                            if (parentElement.offsetLeft) {
                                offsetLeft = parentElement.offsetLeft;
                                break;
                            }
                            parentElement = parentElement.parentElement;
                        }
                        return (pageX - offsetLeft) * this.game.scale.displayScale.x;
                    };
                    this.game.scale.transformY = (pageY) => {
                        let offsetTop = 0;
                        let parentElement = game.canvas.parentElement;
                        while (parentElement) {
                            if (parentElement.offsetTop) {
                                offsetTop = parentElement.offsetTop;
                                break;
                            }
                            parentElement = parentElement.parentElement;
                        }
                        return (pageY - offsetTop) * this.game.scale.displayScale.y;
                    };
                }

                create() {
                    game.scene.remove('Boot');
                    game.scene.add('Preloader', garage.scene.Preloader, true);
                }
            }

            scene.Boot = Boot;
        })(scene = garage.scene || (garage.scene = {}));
    })(garage || (garage = {}));

    (function (garage) {
        var scene;
        (function (scene) {
            var Gameplay = garage.core.Gameplay;

            class MainScene extends Phaser.Scene {
                create() {
                    this.gameplay = new Gameplay();
                    this.gameplayScreen = new garage.screen.GameplayScreen(this, this.gameplay);
                    this.children.add(this.gameplayScreen);
                    this.gameplayScreen.showInstructionPage();
                }
            }

            scene.MainScene = MainScene;
        })(scene = garage.scene || (garage.scene = {}));
    })(garage || (garage = {}));

    (function (garage) {
        var scene;
        (function (scene) {
            class Preloader extends Phaser.Scene {
                preload() {
                    if (typeof garage.App.json == "string") this.load.json('gameplay', garage.App.json); else this.game.cache.json.add('gameplay', garage.App.json);
                }

                create() {
                    let json = game.cache.json.get('gameplay');
                    let words = json["words"];
                    if (json["useImages"]) {
                        let rounds = JSON.parse(JSON.stringify(json["rounds"]));
                        for (let i = 0; i < rounds.length; i++) {
                            let w = rounds[i];
                            this.load.image(w.correctWord, "assets/games/letter-cloud/imgs/letters/" + w.correctWord + ".png");
                            this.load.image(w.wrongWord1, "assets/games/letter-cloud/imgs/letters/" + w.wrongWord1 + ".png");
                            this.load.image(w.wrongWord2, "assets/games/letter-cloud/imgs/letters/" + w.wrongWord2 + ".png");
                        }
                        for (let l of json["letters"]) {
                            this.load.image(l["letterName"], "assets/games/letter-cloud/imgs/letters/" + l["letterName"] + ".png");
                        }
                    }
                    for (let l of json["letters"]) {
                        this.load.audio(l["audioKey"], "assets/games/letter-cloud/sound/mp3/letters/" + l["audioKey"] + ".mp3");
                    }
                    for (let w of words) {
                        this.load.audio(w, "assets/games/letter-cloud/sound/mp3/words/" + w + ".mp3");
                        this.load.audio('tapon_' + w, "assets/games/letter-cloud/sound/mp3/words/tapon/" + w + ".mp3");
                    }
                    let progressTxt = this.add.text(game.scale.width / 2, game.scale.height / 2, "", {
                        "fontFamily": "QuranErafont",
                        "fontSize": 25,
                        "color": "#000000",
                        "align": 'center'
                    });
                    progressTxt.setOrigin(0.5, 0.5);
                    this.load.pack('preloader', 'assets/games/letter-cloud/pack.json');
                    this.load.on('progress', (value) => {
                        progressTxt.text = Math.ceil(value * 100) + "%";
                    }, this);
                    this.load.on('complete', () => {
                        this.nextScene();
                    });
                    this.load.start();
                }

                static playAnim(animKey, sprite, onComplete = null) {
                    let mainScene = game.scene.getScene('ScreenMain');
                    let data = Preloader.ANIMS_DATA[animKey];
                    if (!mainScene.anims.exists(animKey)) {
                        mainScene.anims.create({
                            key: animKey,
                            frames: mainScene.anims.generateFrameNames(data['atlas'], {
                                start: data['start'], end: data['end'], zeroPad: data['padNum'],
                                prefix: data['prefix'], suffix: ''
                            }),
                            frameRate: data['frameRate'],
                            repeat: data['repeat']
                        });
                    }
                    if (sprite.anims.currentAnim) {
                        sprite.anims.currentAnim.off('complete');
                    }
                    sprite.anims.stop();
                    sprite.play(animKey);
                    sprite.anims.currentAnim.once('complete', () => {
                        if (onComplete)
                            onComplete();
                    });
                    sprite.setOrigin(data['originX'], data['originY']);
                    return sprite;
                }

                nextScene() {
                    game.scene.remove('Preloader');
                    game.scene.add('ScreenMain', garage.scene.MainScene, true);
                }
            }

            Preloader.ANIMS_DATA = {
                'Birds_Iddle': {
                    'start': 0,
                    'end': 85,
                    'padNum': 4,
                    'prefix': 'Birds_Iddle',
                    'repeat': 0,
                    'frameRate': 24,
                    'atlas': 'Birds Iddle v2',
                    'originX': 0.5,
                    'originY': 0.5
                },
                'Birds_Great': {
                    'start': 0,
                    'end': 47,
                    'padNum': 4,
                    'prefix': 'Birds_Great',
                    'repeat': 0,
                    'frameRate': 24,
                    'atlas': 'Birds Great v2',
                    'originX': 0.44,
                    'originY': 0.58
                }
            };
            scene.Preloader = Preloader;
        })(scene = garage.scene || (garage.scene = {}));
    })(garage || (garage = {}));

    (function (garage) {
        var screen;
        (function (screen) {
            class AreYouSureWindow extends Phaser.GameObjects.Container {
                constructor(scene, onYes, onNo) {
                    super(scene);
                    this._areYouSurePage = new Phaser.GameObjects.Image(this.scene, -105, 0 - 48, 'Exit warning');
                    this._areYouSurePage.setOrigin(0, 0);
                    this._areYouSurePage.setInteractive();
                    var modalTextStyle = {
                        backgroundColor: 'transparent',
                        stroke: '#ffffff',
                        strokeThickness: 2,
                        lineSpacing: 15,
                        fontFamily: 'Kids Rock DEMO',
                        fontSize: 27,
                        color: '#43425d',
                        wordWrap: true,
                        align: 'center'
                    };
                    var modalText = this.scene.add.text(game.scale.width / 2 + 12, game.scale.height / 2, "Your progress in this activity will not be saved. \n Are you sure you want to exit? ", modalTextStyle);
                    modalText.setOrigin(0.5, 0.5);
                    this._btnSureYes = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2 - 95, 485 - 50, 'btnYES1');
                    this._btnSureYes.setInteractive({ cursor: 'pointer' });
                    this._btnSureYes.once('pointerup', () => {
                        onYes;
                        window.angularComponentRef.backToMenu();
                    });
                    setupButtonTextureBased(this._btnSureYes, 'btnYES1', 'btnYES2');
                    this._btnSureNo = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2 + 95, 485 - 50, 'btnNO1');
                    this._btnSureNo.setInteractive({ cursor: 'pointer' });
                    this._btnSureNo.once('pointerup', onNo);
                    setupButtonTextureBased(this._btnSureNo, 'btnNO1', 'btnNO2');
                    this.add(this._areYouSurePage);
                    this.add(this._btnSureYes);
                    this.add(this._btnSureNo);
                    this.add(modalText);
                }
            }

            screen.AreYouSureWindow = AreYouSureWindow;
        })(screen = garage.screen || (garage.screen = {}));
    })(garage || (garage = {}));

    (function (garage) {
        var screen;
        (function (screen) {
            class CompleteWindow extends Phaser.GameObjects.Container {
                constructor(scene, onBack, onReplay, onNext) {
                    super(scene);
                    this.music = null;
                    this.setPosition(-104.5, -48);
                    this._bgComplete = new Phaser.GameObjects.Image(this.scene, 0, 0, 'Completion page LATEST UPDATED');
                    this._bgComplete.setOrigin(0, 0);
                    this._bgComplete.setInteractive();
                    this._cup = new Phaser.GameObjects.Image(this.scene, 400, 410, 'Trophy');
                    this._btnBack = new Phaser.GameObjects.Image(this.scene, 570, 570, 'btnBACK1');
                    this._btnReplay = new Phaser.GameObjects.Image(this.scene, 720, 570, 'btnReplay1');
                    this._btnNext = new Phaser.GameObjects.Image(this.scene, 870, 570, 'btnNEXT1');
                    let _CollectedPoints = new Phaser.GameObjects.Image(this.scene, 620, 440, 'Collected Points');
                    this.totalScoreTxt = this.scene.add.text(845, 352, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 35,
                        "color": "#F49F1C",
                        "align": 'center',
                        'stroke': '#70451A',
                        'strokeThickness': 6
                    });
                    this.totalScoreTxt.setOrigin(0.5, 0.5);
                    let grd = this.totalScoreTxt.context.createLinearGradient(0, 0, 0, this.totalScoreTxt.height);
                    grd.addColorStop(0, '#FFFF00');
                    grd.addColorStop(1, '#C17316');
                    this.totalScoreTxt.setFill(grd);
                    this.starScoreTxt = this.scene.add.text(648, 433, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 24,
                        "color": "#FFFFFF",
                        "align": 'center'
                    });
                    this.starScoreTxt.setOrigin(0.5, 0.5);
                    this.add([
                        this._bgComplete,
                        _CollectedPoints,
                        this._cup,
                        this._btnBack,
                        this._btnReplay,
                        this._btnNext,
                        this.totalScoreTxt,
                        this.starScoreTxt
                    ]);
                    this._btnBack.setInteractive({ cursor: 'pointer' });
                    this._btnBack.on('pointerup', () => {
                        onBack(this._btnBack);
                        window.angularComponentRef.backToMenu();
                        // if (this.music) {
                        //     this.music.stop();
                        // }
                    });
                    setupButtonTextureBased(this._btnBack, 'btnBACK1', 'btnBACK2');
                    this._btnReplay.setInteractive({ cursor: 'pointer' });
                    this._btnReplay.once('pointerup', () => {
                        onReplay(this._btnReplay);
                        if (this.music) {
                            this.music.stop();
                        }
                    });
                    setupButtonTextureBased(this._btnReplay, 'btnReplay1', 'btnReplay2');
                    this._btnNext.setInteractive({ cursor: 'pointer' });
                    this._btnNext.on('pointerup', () => {
                        onNext(this._btnNext);
                        window.angularComponentRef.nextActivity();
                        // if (this.music) {
                        //     this.music.stop();
                        // }
                    });
                    setupButtonTextureBased(this._btnNext, 'btnNEXT1', 'btnNEXT2');
                }

                show(score, starScore) {
                    window.angularComponentRef.gameFinish({ score, starScore })
                    this._cup.scale = 1.25;
                    this.scene.tweens.add({
                        targets: this._cup,
                        "scale": 1,
                        duration: 500,
                        ease: Phaser.Math.Easing.Back.Out
                    });
                    this.totalScoreTxt.text = String(window.angularComponentRef.component.userInfo.totalScore);
                    this.starScoreTxt.text = String(starScore);
                    // let music = this.scene.sound.add("viktory");
                    this.music = this.scene.sound.add("Activity completion fantastic");
                    this.music.play();
                }
            }

            screen.CompleteWindow = CompleteWindow;
        })(screen = garage.screen || (garage.screen = {}));
    })(garage || (garage = {}));

    (function (garage) {
        var screen;
        (function (screen) {
            var Preloader = garage.scene.Preloader;

            class GameplayScreen extends Phaser.GameObjects.Container {
                constructor(scene, gameplay) {
                    super(scene);
                    this.bgMusic = null;
                    this.playIdle = () => {
                        Preloader.playAnim('Birds_Iddle', this.character, this.playIdle);
                    };
                    this.wfsnd = null;
                    this.showCompleteWindow = (score, starScore) => {
                        let completeWindow = new screen.CompleteWindow(this.scene, (target) => {
                            playBtnClickAnim(target);
                        }, (target) => {
                            playBtnClickAnim(target);
                            this.destroyGameplay();
                            this.remove(completeWindow);
                            this.showInstructionPage();
                        }, (target) => {
                            playBtnClickAnim(target);
                        });
                        this.setInputEnabled(false);
                        delayedCall(2000, () => {
                            setPageBackground("bg-blue");
                            this.add(completeWindow);
                            completeWindow.show(score, starScore);
                            this.bgMusic.stop();
                        });
                    };
                    this.showLoseWindow = (score, starScore) => {
                        let tryAgainWindow = new screen.TryAgainWindow(this.scene, (target) => {
                            playBtnClickAnim(target);
                        }, (target) => {
                            playBtnClickAnim(target);
                            this.destroyGameplay();
                            this.remove(tryAgainWindow);
                            this.showInstructionPage();
                        });
                        this.setInputEnabled(false);
                        delayedCall(2500, () => {
                            setPageBackground("bg-blue");
                            this.add(tryAgainWindow);
                            tryAgainWindow.show(score, starScore);
                            this.bgMusic.stop();
                        });
                    };
                    this.gameplay = gameplay;
                    window["gs"] = this;
                    this._gameStage = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2, game.scale.height / 2, 'Page 1');
                    this._gameStage.setOrigin(0.5, 0.52);
                    this._gameStage.setInteractive();
                    this.add(this._gameStage);
                    this._btnSound = new Phaser.GameObjects.Image(this.scene, 160 - 105, 100 - 50, 'Sound');
                    this._btnSound.setInteractive({ cursor: 'pointer' });
                    setupButtonTextureBased(this._btnSound, 'Sound', 'Sound HOVER EFFECT');
                    this.add(this._btnSound);
                    this._btnSound.on('pointerup', () => {
                        playBtnClickAnim(this._btnSound);
                        this.scene.sound.add("tapon_" + this.gameplay.roundWord).play();
                    });
                    this._btnSound.visible = false;
                    this.character = this.scene.add.sprite(0, 0, null);
                    this.character.setPosition(170, 490);
                    this.add(this.character);
                    this.playIdle();
                    this._btnClose = new Phaser.GameObjects.Image(this.scene, 1025 - 105, 100 - 50, 'x Button');
                    this._btnClose.setInteractive({ cursor: 'pointer' });
                    this._btnClose["defScale"] = this._btnClose.scale;
                    setupButtonTextureBased(this._btnClose, 'x Button', 'x Button HOVER EFFECT');
                    this.add(this._btnClose);
                    this._btnClose.on('pointerup', () => {
                        playBtnClickAnim(this._btnClose);
                        this.onCloseClick();
                    });
                }

                showGameplay() {
                    setPageBackground("bg-australia");
                    this.gameplay.reset();
                    this.bgMusic = this.scene.sound.add("Bachground ambience");
                    this.bgMusic.play();
                    this.bgMusic.loop = true;
                    this.gameplayContainer = new Phaser.GameObjects.Container(this.scene);
                    this.addAt(this.gameplayContainer, this.getIndex(this.character));
                    this.prepareRound();
                    this.gameplay.setupCallbacks(this.showCompleteWindow, this.showLoseWindow, () => {
                        this.onNewRound(true);
                    });
                }

                prepareRound() {
                    this._btnSound.visible = false;
                    this.gameplayContainer.removeAll();
                    this.clouds = [];
                    for (let i = 0; i < 3; i++) {
                        let c = new Phaser.GameObjects.Container(this.scene, 200 + i * 290, 240);
                        this.gameplayContainer.add(c);
                        this.clouds.push(c);
                        c['defX'] = c.x;
                        c['defY'] = c.y;
                        let cSprite = new Phaser.GameObjects.Image(this.scene, 0, 0, 'cloud ' + (i + 1));
                        c.add(cSprite);
                        c["-image-"] = cSprite;
                        let charAt = {};
                        let roundWordLettersNumber = {};
                        if (json.wordsLetters == undefined) {
                            charAt = this.gameplay.roundWord.charAt(this.gameplay.roundWord.length - 1 - i);
                        }
                        else {
                            roundWordLettersNumber = this.gameplay.getRoundWordLettersNumber();
                            charAt = this.gameplay.getRoundWordCharAt(roundWordLettersNumber - 1 - i);
                        }
                        let txt;
                        if (this.gameplay.useImages) {
                            txt = new Phaser.GameObjects.Image(this.scene, 0, 0, charAt);
                        } else {
                            txt = this.scene.add.text(0, 0, "", {
                                "fontFamily": "QuranErafont",
                                "fontSize": 85,
                                "color": "#000000",
                                "align": 'center'
                            });
                            txt.setOrigin(0.5, 0.5);
                            txt.style.fixedHeight = 120;
                            txt.setText(charAt);
                        }
                        c.add(txt);
                        c["-txt-"] = txt;
                        if (json.wordsLetters == undefined) {
                            c["-txt-text"] = this.gameplay.roundWord.charAt(this.gameplay.roundWord.length - 1 - i);
                        }
                        else {
                            c["-txt-text"] = charAt;
                        }
                        c['handIcon'] = new Phaser.GameObjects.Image(this.scene, 0, -140, 'pointer arrow 1');
                        c.add(c['handIcon']);
                        c['handIcon'].visible = false;
                        this.scene.tweens.add({
                            targets: c['handIcon'],
                            "y": c['handIcon'].y - 25,
                            duration: 750,
                            yoyo: true,
                            repeat: -1
                        });
                        c.alpha = 0;
                        this.scene.tweens.add({
                            targets: c,
                            "alpha": 1,
                            duration: 250,
                            delay: 1000 + (2 - i) * 150
                        });
                    }
                    delayedCall(750, () => {
                        this.scene.sound.add("Letter clouds appear in each round-question").play();
                    });
                    this.preparePartA();
                    this.createInput();
                    this.setInputEnabled(false);
                    // delayedCall(1200, ()=>{
                    if (this.gameplay.isNewRound()) {
                        if (!this.gameplay.isRoundsComplete()) {
                            // delayedCall(2000, ()=>{
                            this.setInputEnabled(true);
                            // });
                        }
                    } else {
                        this.setInputEnabled(true);
                    }
                    // });
                }

                preparePartA() {
                    for (let i = 0; i < this.clouds.length; i++) {
                        let c = this.clouds[i];
                        c["-image-"].setInteractive({ cursor: 'pointer', pixelPerfect: true });
                        c["-image-"].on('pointerdown', () => {
                            if (!c['handIcon'].visible)
                                return;
                            c["-image-"].off('pointerdown');
                            c['handIcon'].visible = false;
                            this.scene.sound.add(this.gameplay.getAudioKeyOfChar(c["-txt-text"])).play();
                            this.scene.tweens.add({
                                targets: c,
                                "scale": 0.9,
                                duration: 250,
                                yoyo: true
                            });
                            if (i == 0) {
                                delayedCall(1000, () => {
                                    this.preparePartB();
                                });
                            } else {
                                delayedCall(1000, () => {
                                    this.clouds[i - 1]['handIcon'].visible = true;
                                });
                            }
                        });
                    }
                    this.clouds[this.clouds.length - 1]['handIcon'].visible = true;
                }

                preparePartB() {
                    this.scene.sound.add('cloudsjoinsfx').play();
                    let pos = { x: game.scale.width / 2, y: this.clouds[1].y };
                    for (let c of this.clouds) {
                        this.scene.tweens.add({
                            targets: c,
                            x: pos.x,
                            y: pos.y,
                            alpha: 0,
                            duration: 250
                        });
                    }
                    let cloudsContainer = new Phaser.GameObjects.Container(this.scene, pos.x, pos.y);
                    let clouds = new Phaser.GameObjects.Image(this.scene, 0, 0, 'clouds');
                    cloudsContainer.add(clouds);
                    let txt;
                    if (this.gameplay.useImages) {
                        txt = new Phaser.GameObjects.Image(this.scene, 0, 0, this.gameplay.roundWord);
                    } else {
                        txt = this.scene.add.text(0, 0, "", {
                            "fontFamily": "QuranErafont",
                            "fontSize": 85,
                            "color": "#000000",
                            "align": 'center'
                        });
                        txt.setOrigin(0.5, 0.5);
                        txt.style.fixedHeight = 120;
                        txt.setText(this.gameplay.roundWord);
                    }
                    txt['-txt-text'] = this.gameplay.roundWord;
                    cloudsContainer.add(txt);
                    this.gameplayContainer.add(cloudsContainer);
                    clouds.alpha = 0;
                    this.scene.tweens.add({
                        targets: clouds,
                        alpha: 1,
                        duration: 750
                    });
                    delayedCall(1500, () => {
                        this.scene.sound.add(this.gameplay.roundWord).play();
                    });
                    delayedCall(3000, () => {
                        delayedCall(1000, () => {
                            this.scene.tweens.add({
                                targets: cloudsContainer,
                                alpha: 0,
                                duration: 500,
                                onComplete: () => {
                                    this.gameplayContainer.remove(cloudsContainer);
                                }
                            });
                            for (let i = 0; i < this.clouds.length; i++) {
                                let c = this.clouds[i];
                                c["-image-"].setTexture('clouds');
                                c["-image-"].setScale(0.75);
                                c["-image-"].setOrigin(0.5, 0.5);
                                this.scene.tweens.add({
                                    targets: c,
                                    x: c['defX'],
                                    y: c['defY'],
                                    alpha: 1,
                                    duration: 500
                                });
                                this.scene.sound.add("cloud words appear").play();
                                if (txt instanceof Phaser.GameObjects.Text) {
                                    c['-txt-'].setFontSize(65);
                                    txt.style.fixedHeight = 65;
                                    c['-txt-'].setText(this.gameplay.roundWords[i]);
                                } else {
                                    c['-txt-'].setTexture(this.gameplay.roundWords[i]);
                                    c['-txt-'].setScale(0.75)
                                }
                                c['-txt-text'] = this.gameplay.roundWords[i];
                            }
                            this.preparePartC();
                        });
                    });
                }

                preparePartC() {
                    this._btnSound.visible = true;
                    delayedCall(750, () => this.scene.sound.add('tapon_' + this.gameplay.roundWord).play());
                    for (let c of this.clouds) {
                        c["-image-"].on('pointerdown', () => {
                            if (c['-txt-text'] == this.gameplay.roundWord) {
                                this.setInputEnabled(false);
                                for (let _c of this.clouds) {
                                    this.scene.tweens.add({
                                        targets: _c,
                                        "alpha": 0,
                                        duration: 1000,
                                        delay: 1000
                                    });
                                }
                                this.onCorrectAnswer();
                                c["-image-"].setScale(1);
                                c["-image-"].setTexture("clouds_correct");
                            } else {
                                this.onWrongAnswer();
                                c["-image-"].setTexture("clouds_incorrect");
                                c["-image-"].setScale(1);
                                delayedCall(1000, () => {
                                    c["-image-"].setTexture("clouds");
                                    c["-image-"].setScale(0.75);
                                });
                            }
                            this.scene.tweens.add({
                                targets: c,
                                "scale": 0.9,
                                duration: 250,
                                yoyo: true
                            });
                        });
                    }
                }

                onNewRound(showOut) {
                    this.setInputEnabled(false);
                    if (showOut) {
                        this.prepareRound();
                    }
                }

                createInput() {
                    this._btnClose.setInteractive({ cursor: 'pointer', pixelPerfect: true });
                }

                onCorrectAnswer() {
                    let completed = this.gameplay.onCorrectAnswer();
                    this.scene.sound.add("correct").play();
                    delayedCall(600, () => {
                        Preloader.playAnim('Birds_Great', this.character, this.playIdle);
                        this.scene.sound.add(this.birdCorrectSndCounter++ % 2 == 0 ? "Bird - yes thats it" : "Bird fantastic").play();
                    });
                    return completed;
                }

                onWrongAnswer() {
                    let lost = this.gameplay.onWrongAnswer();
                    this.scene.sound.add("wrong click").play();
                    return lost;
                }

                onCloseClick() {
                    this.showAreYouSurePage();
                    this.scene.sound.add('warning page pop up sfx').play();
                }

                showInstructionPage() {
                    setPageBackground("bg-blue");
                    let playInstructionSound = () => {
                        if (this.wfsnd) {
                            this.wfsnd.stop();
                        }
                        this.wfsnd = this.scene.sound.add("Letter cloud instruction");
                        this.wfsnd.play();
                    };
                    this.instructionPage = new screen.InstructionPage(this.scene, (target) => {
                        playBtnClickAnim(target);
                        this.remove(this.instructionPage);
                        this.showGameplay();
                        if (this.wfsnd) {
                            this.wfsnd.stop();
                        }
                    }, (target) => {
                        playBtnClickAnim(target);
                        playInstructionSound();
                    });
                    this.add(this.instructionPage);
                    try {
                        playInstructionSound();
                    }
                    catch (e) {
                        console.error(e);
                    }
                }

                showAreYouSurePage() {
                    pauseAllDelayedCalls();
                    setPageBackground("bg-blue");
                    this.pauseSounds();
                    this.areYouSureWindow = new screen.AreYouSureWindow(this.scene, () => {
                        this.remove(this.areYouSureWindow);
                        this.destroyGameplay();
                        this.showInstructionPage();
                    }, () => {
                        this.remove(this.areYouSureWindow);
                        this.unpauseSounds();
                        resumeAllDelayedCalls();
                        setPageBackground("bg-australia");
                    });
                    this.add(this.areYouSureWindow);
                }

                setInputEnabled(enabled) {
                    if (enabled) {
                        for (let c of this.clouds)
                            c["-image-"].setInteractive({ cursor: 'pointer', pixelPerfect: true });
                    } else {
                        for (let c of this.clouds)
                            c["-image-"].disableInteractive();
                    }
                }

                pauseSounds() {
                    this.scene.sound.pauseAll();
                }

                unpauseSounds() {
                    this.scene.sound.resumeAll();
                }

                destroyGameplay() {
                    this.setInputEnabled(false);
                    this.remove(this.gameplayContainer);
                    this.scene.sound.stopAll();
                    destroyAllDelayedCalls();
                }
            }

            screen.GameplayScreen = GameplayScreen;
        })(screen = garage.screen || (garage.screen = {}));
    })(garage || (garage = {}));

    (function (garage) {
        var screen;
        (function (screen) {
            class InstructionPage extends Phaser.GameObjects.Container {
                constructor(scene, onPlayClick, onSndClick) {
                    super(scene);
                    this._instructionPage = new Phaser.GameObjects.Image(this.scene, 0 - 105, 0 - 48, 'Instructions page  ALL ACTIVITY  TITLEs');
                    this._instructionPage.setOrigin(0, 0);
                    this._instructionPage.setInteractive();
                    this._instructionPageTitle = new Phaser.GameObjects.Image(this.scene, 495, 105, 'welcome');
                    this._instructionPageTitle.setScale(0.7);
                    this._btnPlay = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2, 480 - 50, 'btnPLAY1');
                    this._btnPlay.setInteractive({ cursor: 'pointer' });
                    this._btnPlay.once('pointerup', onPlayClick);
                    setupButtonTextureBased(this._btnPlay, 'btnPLAY1', 'btnPLAY2');
                    this.instrTxt = this.scene.add.text(game.scale.width / 2, game.scale.height / 2, "See how letters join to make a word.\nThen tap the cloud with the right word.", {
                        "fontFamily": "Kids Rock DEMO",
                        "fontSize": 30,
                        "color": "#43425D",
                        "align": 'center'
                    });
                    this.instrTxt.setLineSpacing(15);
                    this.instrTxt.setOrigin(0.5, 0.5);
                    this._btnSoundInstruction = new Phaser.GameObjects.Image(this.scene, 800 - 105, 156 - 50, 'Sound');
                    this._btnSoundInstruction.setInteractive({ cursor: 'pointer' });
                    this._btnSoundInstruction.on('pointerup', onSndClick);
                    setupButtonTextureBased(this._btnSoundInstruction, 'Sound', 'Sound HOVER EFFECT');
                    this.add(this._instructionPage);
                    this.add(this._instructionPageTitle);
                    this.add(this.instrTxt);
                    this.add(this._btnPlay);
                    this.add(this._btnSoundInstruction);
                }
            }

            screen.InstructionPage = InstructionPage;
        })(screen = garage.screen || (garage.screen = {}));
    })(garage || (garage = {}));

    (function (garage) {
        var screen;
        (function (screen) {
            class TryAgainWindow extends Phaser.GameObjects.Container {
                constructor(scene, onBack, onReplay) {
                    super(scene);
                    this.music = null;
                    this.setPosition(-106, -48);
                    this._bg = new Phaser.GameObjects.Image(this.scene, 0, 0, 'Try again page');
                    this._bg.setOrigin(0, 0);
                    this._bg.setInteractive();
                    this._star = new Phaser.GameObjects.Image(this.scene, 400, 415, 'Break Star');
                    this._btnBack = new Phaser.GameObjects.Image(this.scene, 600, 580, 'btnBACK1');
                    this._btnReplay = new Phaser.GameObjects.Image(this.scene, 765, 580, 'btnReplay1');
                    this.totalScoreTxt = this.scene.add.text(830, 355, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 35,
                        "color": "#F49F1C",
                        "align": 'center',
                        'stroke': '#70451A',
                        'strokeThickness': 6
                    });
                    this.totalScoreTxt.setOrigin(0.5, 0.5);
                    let grd = this.totalScoreTxt.context.createLinearGradient(0, 0, 0, this.totalScoreTxt.height);
                    grd.addColorStop(0, '#FFFF00');
                    grd.addColorStop(1, '#C17316');
                    this.totalScoreTxt.setFill(grd);
                    this.starScoreTxt = this.scene.add.text(635, 431, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 24,
                        "color": "#FFFFFF",
                        "align": 'center'
                    });
                    this.starScoreTxt.setOrigin(0.5, 0.5);
                    this.add([
                        this._bg,
                        this._star,
                        this._btnBack,
                        this._btnReplay,
                        this.totalScoreTxt,
                        this.starScoreTxt
                    ]);
                    this._btnBack.setInteractive({ cursor: 'pointer' });
                    this._btnBack.on('pointerup', () => {
                        onBack(this._btnBack);
                        // if (this.music) {
                        //     this.music.stop();
                        // }
                    });
                    setupButtonTextureBased(this._btnBack, 'btnBACK1', 'btnBACK2');
                    this._btnReplay.setInteractive({ cursor: 'pointer' });
                    this._btnReplay.once('pointerup', () => {
                        onReplay(this._btnReplay);
                        if (this.music) {
                            this.music.stop();
                        }
                    });
                    setupButtonTextureBased(this._btnReplay, 'btnReplay1', 'btnReplay2');
                }

                show(score, starScore) {
                    this._star.scale = 1.25;
                    this.scene.tweens.add({
                        targets: this._star,
                        "scale": 1,
                        duration: 500,
                        ease: Phaser.Math.Easing.Back.Out
                    });
                    this.totalScoreTxt.text = String(window.angularComponentRef.component.userInfo.totalScore);
                    this.starScoreTxt.text = String(0);
                    this.music = this.scene.sound.add("Fail - close one");
                    this.music.play();
                }
            }

            screen.TryAgainWindow = TryAgainWindow;
        })(screen = garage.screen || (garage.screen = {}));
    })(garage || (garage = {}));

    game = new garage.App(json);
};

function destroyLetterCloud() {
    if (game) {
        game.destroy();
    }
}

var letterBubble;

var game;
var letterBubble = (json) => {
    (function (letterBubble) {
        class App extends Phaser.Game {
            constructor(json) {
                App.json = json
                let config = {
                    type: Phaser.AUTO,
                    width: App.CANVAS_WIDTH,
                    height: App.CANVAS_HEIGHT,
                    parent: 'game-container',
                    dom: {
                        createContainer: false
                    },
                    scale: {
                        mode: FitScaleManager.detectBestScaleMode(),
                        autoCenter: Phaser.Scale.CENTER_BOTH
                    },
                    transparent: true,
                    scene: {
                        create: () => {
                            this.scene.add('Boot', letterBubble.scene.Boot, true);
                        }
                    }
                };
                super(config);
            }
        }

        App.CANVAS_WIDTH = 980;
        App.CANVAS_HEIGHT = 600;
        letterBubble.App = App;
    })(letterBubble || (letterBubble = {}));

    function pad(n, width, z) {
        z = z || '0';
        n = n + '';
        return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
    }

    var delayedCalls = [];

    function delayedCall(delay, callback, args, callbackScope) {
        let scene = game.scene.getAt(0);
        if (scene) {
            let dc = scene.time.delayedCall(delay, callback, args, callbackScope);
            delayedCalls.push(dc);
            return dc;
        }
        let t = setTimeout(callback, delay);
        delayedCalls.push(t);
        return t;
    }

    function pauseAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.paused = true;
            }
        }
    }

    function resumeAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.paused = false;
            }
        }
    }

    function destroyAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.remove(false);
            } else {
                clearTimeout(dc);
            }
        }
        delayedCalls = [];
    }

    function destroyDelayedCall(dc) {
        if (dc instanceof Phaser.Time.TimerEvent) {
            dc.remove(false);
        } else {
            clearTimeout(dc);
        }
        let ind = delayedCalls.indexOf(dc);
        if (ind >= 0)
            delayedCalls.splice(ind, 1);
    }

    function setPageBackground(bg) {
        document.querySelector("html").style.backgroundImage = "url(assets/games/letter-bubble/imgs/" + bg + ".jpg)";
    }

    function setupButton(btn, frame) {
        btn.on('pointerdown', () => {
            btn.setFrame(frame + '_hover' + '0000');
        });
        btn.on('pointerover', () => {
            btn.setFrame(frame + '_hover' + '0000');
            game.scene.getAt(0).sound.add("button hover").play();
        });
        btn.on('pointerout', () => {
            btn.setFrame(frame + '0000');
        });
        btn.on('pointerup', () => {
            btn.setFrame(frame + '0000');
            game.scene.getAt(0).sound.add('activity selection - button selection').play();
        });
    }

    function setupButtonTextureBased(btn, texture, hoverTexture) {
        btn.on('pointerdown', () => {
            btn.setTexture(hoverTexture);
        });
        btn.on('pointerover', () => {
            btn.setTexture(hoverTexture);
            game.scene.getAt(0).sound.add("button hover").play();
        });
        btn.on('pointerout', () => {
            btn.setTexture(texture);
        });
        btn.on('pointerup', () => {
            btn.setTexture(texture);
            game.scene.getAt(0).sound.add('activity selection - button selection').play();
        });
    }

    function playBtnClickAnim(target) {
        let sc = target.hasOwnProperty("defScale") ? target["defScale"] : 1;
        target.scaleX = target.scaleY = sc;
        let scene = game.scene.getAt(0);
        scene.tweens.add({
            targets: target,
            "scaleX": 0.9 * sc,
            "scaleY": 0.9 * sc,
            duration: 100,
            yoyo: true
        });
    }

    /**
     * @author Roman Parada
     * This class is created to fix overlapping of bottom part of canvas by navigation bar in iOS.
     * It make a delayed resize of the canvas (like Phaser-3 FIT methods does) and it overrides Phaser-3 input window to Phaser-3 core transform methods
     *
     * How to use:
     * Just call the code line below in Boot scene's init() method of your project:
     * new FitScaleManager(this.game).setup();
     */
    class FitScaleManager {
        constructor(game) {
            this.doResize = () => {
                let scale = this.calculateScale();
                let newCanvasWidth = this.phaserScaleManager.width * scale;
                let newCanvasHeight = this.phaserScaleManager.height * scale;
                this.canvasStyle.width = newCanvasWidth + 'px';
                this.canvasStyle.height = newCanvasHeight + 'px';
                this.canvasStyle.marginLeft = (window.innerWidth - newCanvasWidth) / 2 + 'px';
                this.canvasStyle.marginTop = (window.innerHeight - newCanvasHeight) / 2 + 'px';
            };
            this.game = game;
            this.canvasStyle = this.game.canvas.style;
            this.phaserScaleManager = this.game.scale;
        }

        static detectBestScaleMode() {
            let iOS = /iPad|iPhone|iPod/.test(navigator.platform || "");
            let isAndroid = window.navigator.userAgent.toLowerCase().indexOf("android") > -1;
            return iOS || isAndroid ? Phaser.Scale.FIT : Phaser.Scale.NONE;
        }
        ;

        /**
         * Just call this method once in Boot scene's init() method
         */
        setup() {
            this.phaserScaleManager.addListener(Phaser.Scale.Events.RESIZE, this.onResize, this);
            this.overridePhaserTransformMethods();
            this.onResize();
        }

        calculateScale() {
            if (game.scale.scaleMode == Phaser.Scale.NONE)
                return 1;
            return Math.min(window.innerWidth / this.phaserScaleManager.width, window.innerHeight / this.phaserScaleManager.height);
        }

        overridePhaserTransformMethods() {
            this.game.scale.transformX = (pageX) => {
                return (pageX - parseInt(this.canvasStyle.marginLeft.split("px")[0])) / this.calculateScale();
            };
            this.game.scale.transformY = (pageY) => {
                return (pageY - parseInt(this.canvasStyle.marginTop.split("px")[0])) / this.calculateScale();
            };
        }

        onResize() {
            setTimeout(this.doResize, FitScaleManager.RESIZE_DELAY);
        }
    }

    FitScaleManager.RESIZE_DELAY = 500;

    (function (letterBubble) {
        var core;
        (function (core) {
            class Gameplay {
                constructor() {
                    this.allLettersNames = null;
                    this.currentRound = 0;
                    this.correctAnswersCount = 0;
                    this.wrongAnswersCount = 0;
                    this.correctAnswersCountThisRound = 0;
                    this.wrongAnswersCountThisRound = 0;
                    this.onNewRound = null;
                    this.nextLetterDelay = 0;
                    this.roundsVaryFrom = Number(game.cache.json.get('gameplay')["roundsVaryFrom"]);
                    this.roundsVaryTo = Number(game.cache.json.get('gameplay')["roundsVaryTo"]);
                    this.useImages = Boolean(game.cache.json.get('gameplay')["useImages"]);
                    this.wordsLetters = game.cache.json.get('gameplay')["wordsLetters"];
                    this.failsNumToLose = Number(game.cache.json.get('gameplay')["failsNumToLose"]) || 4;
                }
                getRoundWordCharAt(at) {
                    return this.wordsLetters[this.roundWord][at];
                }

                getRoundWordLettersNumber() {
                    return this.wordsLetters[this.roundWord].length;
                }

                setupCallbacks(onComplete, onLose, onNewRound) {
                    this.onComplete = onComplete;
                    this.onLose = onLose;
                    this.onNewRound = onNewRound;
                }

                calculateScore() {
                    return this.totalRoundsNum - this.wrongAnswersCount;//return this.totalRoundsNum; //3 * this.totalRoundsNum - this.wrongAnswersCount;
                }

                onLetterChosen() {
                    this.currentRound++;
                    if (this.currentRound >= this.totalRoundsNum) {
                        let score = this.calculateScore();
                        this.onComplete(score, score);
                        return true;
                    }
                    else {
                        this.nextWord();
                    }
                    return false;
                }

                nextWord() {
                    let fn = () => {
                        let round = this.rounds[this.currentRound];
                        this.roundWord = round["correctWord"];
                        this.roundWords = Phaser.Utils.Array.Shuffle([this.roundWord, round["wrongWord1"], round["wrongWord2"]]);
                        this.correctAnswersCountThisRound = 0;
                        this.wrongAnswersCountThisRound = 0;
                        if (this.onNewRound)
                            this.onNewRound();
                    };
                    if (this.nextLetterDelay == 0) {
                        fn();
                    } else {
                        delayedCall(this.nextLetterDelay, fn);
                    }
                }

                onCorrectAnswer() {
                    this.correctAnswersCount++;
                    this.correctAnswersCountThisRound++;
                    this.nextLetterDelay = 2500;
                    return this.onLetterChosen();
                }

                onWrongAnswer() {
                    this.wrongAnswersCount++;
                    this.wrongAnswersCountThisRound++;
                    this.nextLetterDelay = 1500;
                    if (this.wrongAnswersCount >= this.failsNumToLose) {
                        this.onLose(0, 0);
                        return true;
                    }
                    else {
                        this.onLetterChosen();
                    }
                    return false;
                }

                getCurrentTotalAnswersCount() {
                    return this.correctAnswersCount + this.wrongAnswersCount;
                }

                getCurrentTotalAnswersCountThisRound() {
                    return this.correctAnswersCountThisRound + this.wrongAnswersCountThisRound;
                }

                isNewRound() {
                    return this.getCurrentTotalAnswersCountThisRound() == 0;
                }

                isRoundsComplete() {
                    return this.currentRound >= this.totalRoundsNum;
                }

                getAudioKeyOfChar(letter) {
                    let json = game.cache.json.get('gameplay');
                    let letters = json["letters"];
                    for (let d of letters) {
                        if (letter == d['letterName']) {
                            return d['audioKey'];
                        }
                    }
                    return null;
                }

                reset() {
                    this.currentRound = 0;
                    this.totalRoundsNum = Math.round(Math.random() * (this.roundsVaryTo - this.roundsVaryFrom)) + this.roundsVaryFrom;
                    this.nextLetterDelay = 0;
                    this.setupCallbacks(null, null, null);
                    let json = game.cache.json.get('gameplay');
                    this.letters = json["letters"].slice();
                    this.allLettersNames = [];
                    for (let d of this.letters)
                        this.allLettersNames.push(d["letterName"]);
                    this.rounds = JSON.parse(JSON.stringify(json["rounds"]));
                    this.totalRoundsNum = this.rounds.length;
                    this.nextWord();
                    this.correctAnswersCount = 0;
                    this.wrongAnswersCount = 0;
                    this.correctAnswersCountThisRound = 0;
                    this.wrongAnswersCountThisRound = 0;
                }
            }

            core.Gameplay = Gameplay;
        })(core = letterBubble.core || (letterBubble.core = {}));
    })(letterBubble || (letterBubble = {}));

    (function (letterBubble) {
        var scene;
        (function (scene) {
            class Boot extends Phaser.Scene {
                init() {
                    // new FitScaleManager(this.game).setup();
                    this.game.scale.transformX = (pageX) => {
                        let offsetLeft = 0;
                        let parentElement = game.canvas.parentElement;
                        while (parentElement) {
                            if (parentElement.offsetLeft) {
                                offsetLeft = parentElement.offsetLeft;
                                break;
                            }
                            parentElement = parentElement.parentElement;
                        }
                        return (pageX - offsetLeft) * this.game.scale.displayScale.x;
                    };
                    this.game.scale.transformY = (pageY) => {
                        let offsetTop = 0;
                        let parentElement = game.canvas.parentElement;
                        while (parentElement) {
                            if (parentElement.offsetTop) {
                                offsetTop = parentElement.offsetTop;
                                break;
                            }
                            parentElement = parentElement.parentElement;
                        }
                        return (pageY - offsetTop) * this.game.scale.displayScale.y;
                    };
                }

                create() {
                    game.scene.remove('Boot');
                    game.scene.add('Preloader', letterBubble.scene.Preloader, true);
                }
            }

            scene.Boot = Boot;
        })(scene = letterBubble.scene || (letterBubble.scene = {}));
    })(letterBubble || (letterBubble = {}));

    (function (letterBubble) {
        var scene;
        (function (scene) {
            var Gameplay = letterBubble.core.Gameplay;

            class MainScene extends Phaser.Scene {
                create() {
                    this.gameplay = new Gameplay();
                    this.gameplayScreen = new letterBubble.screen.GameplayScreen(this, this.gameplay);
                    this.children.add(this.gameplayScreen);
                    this.gameplayScreen.showInstructionPage();
                }
            }

            scene.MainScene = MainScene;
        })(scene = letterBubble.scene || (letterBubble.scene = {}));
    })(letterBubble || (letterBubble = {}));

    (function (letterBubble) {
        var scene;
        (function (scene) {
            class Preloader extends Phaser.Scene {
                preload() {
                    if (typeof letterBubble.App.json == "string") this.load.json('gameplay', letterBubble.App.json); else this.game.cache.json.add('gameplay', letterBubble.App.json);
                }

                create() {
                    let json = game.cache.json.get('gameplay');
                    let words = json["words"];
                    if (json["useImages"]) {
                        let rounds = JSON.parse(JSON.stringify(json["rounds"]));
                        for (let i = 0; i < rounds.length; i++) {
                            let w = rounds[i];
                            this.load.image(w.correctWord, "assets/games/letter-bubble/imgs/letters/" + w.correctWord + ".png");
                            this.load.image(w.wrongWord1, "assets/games/letter-bubble/imgs/letters/" + w.wrongWord1 + ".png");
                            this.load.image(w.wrongWord2, "assets/games/letter-bubble/imgs/letters/" + w.wrongWord2 + ".png");
                        }
                        for (let l of json.letters) {
                            this.load.image(l.letterName, "assets/games/letter-bubble/imgs/letters/" + l.letterName + ".png");
                        }
                    }
                    for (let l of json.letters) {
                        this.load.audio(l.audioKey, "assets/games/letter-bubble/sound/mp3/letters/" + l.audioKey + ".mp3");
                    }
                    for (let w of words) {
                        this.load.audio(w, "assets/games/letter-bubble/sound/mp3/words/" + w + ".mp3");
                        this.load.audio('tapon_' + w, "assets/games/letter-bubble/sound/mp3/words/tapon/" + w + ".mp3");
                    }
                    let progressTxt = this.add.text(game.scale.width / 2, game.scale.height / 2 + 50, "", {
                        "fontFamily": "QuranErafont",
                        "fontSize": 25,
                        "color": "#000000",
                        "align": 'center'
                    });
                    progressTxt.setOrigin(0.5, 0.5);
                    this.load.pack('preloader', 'assets/games/letter-bubble/pack.json');
                    this.load.on('progress', (value) => {
                        progressTxt.text = Math.ceil(value * 100) + "%";
                    }, this);
                    this.load.on('complete', () => {
                        this.nextScene();
                    });
                    this.load.start();
                }

                static playAnim(animKey, sprite, onComplete = null) {
                    let mainScene = game.scene.getScene('ScreenMain');
                    let data = Preloader.ANIMS_DATA[animKey];
                    if (!mainScene.anims.exists(animKey)) {
                        mainScene.anims.create({
                            key: animKey,
                            frames: mainScene.anims.generateFrameNames(data['atlas'], {
                                start: data['start'], end: data['end'], zeroPad: data['padNum'],
                                prefix: data['prefix'], suffix: ''
                            }),
                            frameRate: data['frameRate'],
                            repeat: data['repeat']
                        });
                    }
                    if (sprite.anims.currentAnim) {
                        sprite.anims.currentAnim.off('complete');
                    }
                    sprite.anims.stop();
                    sprite.play(animKey);
                    sprite.anims.currentAnim.once('complete', () => {
                        if (onComplete)
                            onComplete();
                    });
                    sprite.setOrigin(data['originX'], data['originY']);
                    return sprite;
                }

                nextScene() {
                    game.scene.remove('Preloader');
                    game.scene.add('ScreenMain', letterBubble.scene.MainScene, true);
                }
            }

            Preloader.ANIMS_DATA = {
                'dolphiniddle': {
                    'start': 1,
                    'end': 72,
                    'padNum': 4,
                    'prefix': 'iddle',
                    'repeat': 0,
                    'frameRate': 24,
                    'atlas': 'dolphiniddle',
                    'originX': 0.5,
                    'originY': 0.5
                },
                'dolphinhappy': {
                    'start': 1,
                    'end': 63,
                    'padNum': 4,
                    'prefix': 'happy v2 dolphine',
                    'repeat': 0,
                    'frameRate': 24,
                    'atlas': 'dolphinhappy',
                    'originX': 0.54,
                    'originY': 0.63
                },
                'poping': {
                    'start': 1,
                    'end': 33,
                    'padNum': 4,
                    'prefix': 'Poping',
                    'repeat': 0,
                    'frameRate': 24,
                    'atlas': 'poping',
                    'originX': 0.495,
                    'originY': 0.345
                },
                'marger': {
                    'start': 33,
                    'end': 33,
                    'padNum': 4,
                    'prefix': 'marger',
                    'repeat': 0,
                    'frameRate': 45,
                    'atlas': 'marger',
                    'originX': 0.5,
                    'originY': 0
                }
            };
            scene.Preloader = Preloader;
        })(scene = letterBubble.scene || (letterBubble.scene = {}));
    })(letterBubble || (letterBubble = {}));

    (function (letterBubble) {
        var screen;
        (function (screen) {
            class AreYouSureWindow extends Phaser.GameObjects.Container {
                constructor(scene, onYes, onNo) {
                    super(scene);
                    this._areYouSurePage = new Phaser.GameObjects.Image(this.scene, -105, 0 - 48, 'Exit warning');
                    this._areYouSurePage.setOrigin(0, 0);
                    this._areYouSurePage.setInteractive();
                    this._btnSureYes = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2 - 95, 485 - 50, 'btnYES1');
                    this._btnSureYes.setInteractive({ cursor: 'pointer' });
                    this._btnSureYes.once('pointerup', () => {
                        onYes;
                        window.angularComponentRef.backToMenu();
                    });
                    var modalTextStyle = {
                        backgroundColor: 'transparent',
                        stroke: '#ffffff',
                        strokeThickness: 2,
                        lineSpacing: 15,
                        fontFamily: 'Kids Rock DEMO',
                        fontSize: 27,
                        color: '#43425d',
                        wordWrap: true,
                        align: 'center'
                    };
                    var modalText = this.scene.add.text(game.scale.width / 2 + 12, game.scale.height / 2, "Your progress in this activity will not be saved. \n Are you sure you want to exit? ", modalTextStyle);
                    modalText.setOrigin(0.5, 0.5);

                    setupButtonTextureBased(this._btnSureYes, 'btnYES1', 'btnYES2');
                    this._btnSureNo = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2 + 95, 485 - 50, 'btnNO1');
                    this._btnSureNo.setInteractive({ cursor: 'pointer' });
                    this._btnSureNo.once('pointerup', onNo);
                    setupButtonTextureBased(this._btnSureNo, 'btnNO1', 'btnNO2');
                    this.add(this._areYouSurePage);
                    this.add(this._btnSureYes);
                    this.add(this._btnSureNo);
                    this.add(modalText);
                }
            }

            screen.AreYouSureWindow = AreYouSureWindow;
        })(screen = letterBubble.screen || (letterBubble.screen = {}));
    })(letterBubble || (letterBubble = {}));

    (function (letterBubble) {
        var screen;
        (function (screen) {
            class CompleteWindow extends Phaser.GameObjects.Container {
                constructor(scene, onBack, onReplay, onNext) {
                    super(scene);
                    this.music = null;
                    this.setPosition(-104.5, -48);
                    this._bgComplete = new Phaser.GameObjects.Image(this.scene, 0, 0, 'Completion page LATEST UPDATED');
                    this._bgComplete.setOrigin(0, 0);
                    this._bgComplete.setInteractive();
                    this._cup = new Phaser.GameObjects.Image(this.scene, 400, 410, 'Trophy');
                    this._btnBack = new Phaser.GameObjects.Image(this.scene, 570, 570, 'btnBACK1');
                    this._btnReplay = new Phaser.GameObjects.Image(this.scene, 720, 570, 'btnReplay1');
                    this._btnNext = new Phaser.GameObjects.Image(this.scene, 870, 570, 'btnNEXT1');
                    let _CollectedPoints = new Phaser.GameObjects.Image(this.scene, 620, 440, 'Collected Points');
                    this.totalScoreTxt = this.scene.add.text(845, 352, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 35,
                        "color": "#F49F1C",
                        "align": 'center',
                        'stroke': '#70451A',
                        'strokeThickness': 6
                    });
                    this.totalScoreTxt.setOrigin(0.5, 0.5);
                    let grd = this.totalScoreTxt.context.createLinearGradient(0, 0, 0, this.totalScoreTxt.height);
                    grd.addColorStop(0, '#FFFF00');
                    grd.addColorStop(1, '#C17316');
                    this.totalScoreTxt.setFill(grd);
                    this.starScoreTxt = this.scene.add.text(648, 433, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 24,
                        "color": "#FFFFFF",
                        "align": 'center'
                    });
                    this.starScoreTxt.setOrigin(0.5, 0.5);
                    this.add([
                        this._bgComplete,
                        _CollectedPoints,
                        this._cup,
                        this._btnBack,
                        this._btnReplay,
                        this._btnNext,
                        this.totalScoreTxt,
                        this.starScoreTxt
                    ]);
                    this._btnBack.setInteractive({ cursor: 'pointer' });
                    this._btnBack.on('pointerup', () => {
                        onBack(this._btnBack);
                        window.angularComponentRef.backToMenu();
                        // if (this.music) {
                        //     this.music.stop();
                        // }
                    });
                    setupButtonTextureBased(this._btnBack, 'btnBACK1', 'btnBACK2');
                    this._btnReplay.setInteractive({ cursor: 'pointer' });
                    this._btnReplay.once('pointerup', () => {
                        onReplay(this._btnReplay);
                        if (this.music) {
                            this.music.stop();
                        }
                    });
                    setupButtonTextureBased(this._btnReplay, 'btnReplay1', 'btnReplay2');
                    this._btnNext.setInteractive({ cursor: 'pointer' });
                    this._btnNext.on('pointerup', () => {
                        onNext(this._btnNext);
                        window.angularComponentRef.nextActivity();
                        // if (this.music) {
                        //     this.music.stop();
                        // }
                    });
                    setupButtonTextureBased(this._btnNext, 'btnNEXT1', 'btnNEXT2');
                }

                show(score, starScore) {
                    window.angularComponentRef.gameFinish({ score, starScore })
                    this._cup.scale = 1.25;
                    this.scene.tweens.add({
                        targets: this._cup,
                        "scale": 1,
                        duration: 500,
                        ease: Phaser.Math.Easing.Back.Out
                    });
                    this.totalScoreTxt.text = String(window.angularComponentRef.component.userInfo.totalScore);
                    this.starScoreTxt.text = String(starScore);
                    // let music = this.scene.sound.add("viktory");
                    this.music = this.scene.sound.add("Activity completion fantastic");
                    this.music.play();
                }
            }

            screen.CompleteWindow = CompleteWindow;
        })(screen = letterBubble.screen || (letterBubble.screen = {}));
    })(letterBubble || (letterBubble = {}));

    (function (letterBubble) {
        var screen;
        (function (screen) {
            var Preloader = letterBubble.scene.Preloader;

            class GameplayScreen extends Phaser.GameObjects.Container {
                constructor(scene, gameplay) {
                    super(scene);
                    this.bgMusic = null;
                    this.playIdle = () => {
                        Preloader.playAnim('dolphiniddle', this.character, this.playIdle);
                    };
                    this.wfsnd = null;
                    this.showCompleteWindow = (score, starScore) => {
                        let completeWindow = new screen.CompleteWindow(this.scene, (target) => {
                            playBtnClickAnim(target);
                        }, (target) => {
                            playBtnClickAnim(target);
                            this.destroyGameplay();
                            this.remove(completeWindow);
                            this.showInstructionPage();
                        }, (target) => {
                            playBtnClickAnim(target);
                        });
                        this.setInputEnabled(false);
                        delayedCall(2000, () => {
                            setPageBackground("bg-blue");
                            this.add(completeWindow);
                            completeWindow.show(score, starScore);
                            this.bgMusic.stop();
                        });
                    };
                    this.showLoseWindow = (score, starScore) => {
                        let tryAgainWindow = new screen.TryAgainWindow(this.scene, (target) => {
                            playBtnClickAnim(target);
                        }, (target) => {
                            playBtnClickAnim(target);
                            this.destroyGameplay();
                            this.remove(tryAgainWindow);
                            this.showInstructionPage();
                        });
                        this.setInputEnabled(false);
                        delayedCall(2500, () => {
                            setPageBackground("bg-blue");
                            this.add(tryAgainWindow);
                            tryAgainWindow.show(score, starScore);
                            this.bgMusic.stop();
                        });
                    };
                    this.gameplay = gameplay;
                    window["gs"] = this;
                    this._gameStage = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2, game.scale.height / 2, 'Page 1');
                    this._gameStage.setOrigin(0.5, 0.5);
                    this._gameStage.setInteractive();
                    this.add(this._gameStage);
                    this._btnSound = new Phaser.GameObjects.Image(this.scene, 160 - 105, 100 - 50, 'Sound');
                    this._btnSound.setInteractive({ cursor: 'pointer' });
                    setupButtonTextureBased(this._btnSound, 'Sound', 'Sound HOVER EFFECT');
                    this.add(this._btnSound);
                    this._btnSound.on('pointerup', () => {
                        playBtnClickAnim(this._btnSound);
                        this.scene.sound.add("tapon_" + this.gameplay.roundWord).play();
                    });
                    this._btnSound.visible = false;

                    this.marger = this.scene.add.sprite(0, 0, null);
                    this.marger.setPosition(505, -215); window["this.marger"] = this.marger;
                    this.add(this.marger);

                    this.character = this.scene.add.sprite(0, 0, null);
                    this.character.setPosition(560, 390); window["this.character"] = this.character;
                    this.add(this.character);
                    this.playIdle();
                    this._btnClose = new Phaser.GameObjects.Image(this.scene, 1025 - 105, 100 - 50, 'x Button');
                    this._btnClose.setInteractive({ cursor: 'pointer' });
                    this._btnClose["defScale"] = this._btnClose.scale;
                    setupButtonTextureBased(this._btnClose, 'x Button', 'x Button HOVER EFFECT');
                    this.add(this._btnClose);
                    this._btnClose.on('pointerup', () => {
                        playBtnClickAnim(this._btnClose);
                        this.onCloseClick();
                    });
                }

                showGameplay() {
                    setPageBackground("bg-australia");
                    this.gameplay.reset();
                    this.bgMusic = this.scene.sound.add("Bachground ambience");
                    this.bgMusic.play();
                    this.bgMusic.loop = true;
                    this.gameplayContainer = new Phaser.GameObjects.Container(this.scene);
                    this.addAt(this.gameplayContainer, this.getIndex(this.character));
                    this.prepareRound();
                    this.gameplay.setupCallbacks(this.showCompleteWindow, this.showLoseWindow, () => {
                        this.onNewRound(true);
                    });
                    this.createTallies();
                }

                createTallies() {
                    if (this.tally) {
                        for (let te of this.tallyEmptyArray) {
                            te.visible = false;
                            this.bringToTop(te);
                        }
                        for (let t of this.tally) {
                            t.visible = false;
                            this.bringToTop(t);
                        }
                        return;
                    }
                    let startX = 90;
                    let startY = 530;
                    let dx = 48;
                    let tallyEmptyArrayPositions = [];
                    for (let i = 0; i < 8; i++) {
                        tallyEmptyArrayPositions.push({ x: startX + i * dx, y: startY });
                    }
                    this.tallyEmptyArray = [];
                    this.tally = [];
                    for (let p of tallyEmptyArrayPositions) {
                        let _BeehiveEmpty = new Phaser.GameObjects.Image(this.scene, p['x'], p['y'], 'tally Empty');
                        this.tallyEmptyArray.push(_BeehiveEmpty);
                        _BeehiveEmpty.visible = false;
                        let _Beehive = new Phaser.GameObjects.Image(this.scene, p['x'], p['y'], 'tally');
                        this.tally.push(_Beehive);
                    }
                    for (let bea of this.tallyEmptyArray) {
                        this.add(bea);
                    }
                    for (let bee of this.tally) {
                        this.add(bee);
                        bee.visible = false;
                    }
                }

                prepareRound() {
                    this._btnSound.visible = false;
                    this.gameplayContainer.removeAll();
                    this.clouds = [];
                    let _roundWordLettersNumber = json.wordsLetters == undefined ? 4 : this.gameplay.getRoundWordLettersNumber();
                    for (let i = 0; i < _roundWordLettersNumber; i++) {
                        let c = new Phaser.GameObjects.Container(this.scene, 150 + (_roundWordLettersNumber == 4 ? i : (i + 0.5)) * 212, 240 - 80);
                        this.gameplayContainer.add(c);
                        this.clouds.push(c);
                        c.setScale(0.75);
                        c['defX'] = c.x;
                        c['defY'] = c.y;
                        c['defX-for-word'] = 200 + i * 290;
                        c['defY-for-word'] = 240 - 80;
                        let cSprite = new Phaser.GameObjects.Image(this.scene, 0, 0, 'cloud ' + (i == 3 ? 1 : (i + 1)));
                        c.add(cSprite);
                        c["-image-"] = cSprite;
                        let charAt = {};
                        let roundWordLettersNumber = {};
                        if (json.wordsLetters == undefined) {
                            charAt = this.gameplay.roundWord.charAt(this.gameplay.roundWord.length - 1 - i);
                        }
                        else {
                            roundWordLettersNumber = this.gameplay.getRoundWordLettersNumber();
                            charAt = this.gameplay.getRoundWordCharAt(roundWordLettersNumber - 1 - i);
                        }
                        let txt;
                        if (this.gameplay.useImages) {
                            txt = new Phaser.GameObjects.Image(this.scene, 0, 0, charAt);
                            txt.setScale(1/c.scaleX);
                        } else {
                            txt = this.scene.add.text(0, 0, "", {
                                "fontFamily": "QuranErafont",
                                "fontSize": 85,
                                "color": "#000000",
                                "align": 'center'
                            });
                            txt.setOrigin(0.5, 0.5);
                            txt.style.fixedHeight = 120;
                            txt.setText(charAt);
                        }
                        c.add(txt);
                        c["-txt-"] = txt;
                        if (json.wordsLetters == undefined) {
                            c["-txt-text"] = this.gameplay.roundWord.charAt(this.gameplay.roundWord.length - 1 - i);
                        }
                        else {
                            c["-txt-text"] = charAt;
                        }
                        c['handIcon'] = new Phaser.GameObjects.Image(this.scene, 0, -120, 'pointer arrow 1');
                        c.add(c['handIcon']);
                        c['handIcon'].setScale(0.65);
                        c['handIcon'].visible = false;
                        this.scene.tweens.add({
                            targets: c['handIcon'],
                            "y": c['handIcon'].y - 15,
                            duration: 750,
                            yoyo: true,
                            repeat: -1
                        });
                        c.alpha = 0;
                        this.scene.tweens.add({
                            targets: c,
                            "alpha": 1,
                            duration: 250,
                            delay: 1000 + (2 - i) * 150
                        });
                    }
                    delayedCall(750, () => {
                        this.scene.sound.add("Letter clouds appear in each round-question").play();
                    });
                    this.preparePartA();
                    this.createInput();
                    this.setInputEnabled(false);
                    // delayedCall(1200, ()=>{
                    if (this.gameplay.isNewRound()) {
                        if (!this.gameplay.isRoundsComplete()) {
                            // delayedCall(2000, ()=>{
                            this.setInputEnabled(true);
                            // });
                        }
                    } else {
                        this.setInputEnabled(true);
                    }
                    // });
                }

                preparePartA() {
                    for (let i = 0; i < this.clouds.length; i++) {
                        let c = this.clouds[i];
                        c["-image-"].setInteractive({ cursor: 'pointer', pixelPerfect: true });
                        c["-image-"].on('pointerdown', () => {
                            if (!c['handIcon'].visible)
                                return;
                            c["-image-"].off('pointerdown');
                            c['handIcon'].visible = false;
                            this.scene.sound.add("Bubble click").play();
                            try { this.scene.sound.add(this.gameplay.getAudioKeyOfChar(c["-txt-text"])).play(); } catch (e) { }
                            this.scene.tweens.add({
                                targets: c,
                                "scale": 0.9 * 0.75,
                                duration: 250,
                                yoyo: true
                            });
                            if (i == 0) {
                                delayedCall(1000, () => {
                                    this.preparePartB();
                                });
                            } else {
                                delayedCall(1000, () => {
                                    this.clouds[i - 1]['handIcon'].visible = true;
                                });
                            }
                        });
                    }
                    this.clouds[this.clouds.length - 1]['handIcon'].visible = true;
                }

                preparePartB() {
                    this.marger.alpha = 1;
                    Preloader.playAnim('marger', this.marger);

                    this.scene.sound.add('cloudsjoinsfx').play();
                    let pos = { x: game.scale.width / 2, y: this.clouds[1].y };
                    for (let i = 0; i < this.clouds.length; i++) {
                        let c = this.clouds[i];
                        this.clouds[i].visible = true;
                        this.scene.tweens.add({
                            targets: c,
                            duration: 30,
                            useFrames: true,
                            x: pos.x,
                            scaleX: 0.75 * 0.75,
                            scaleY: 1.05 * 0.75,
                            alpha: 0,
                            ease: Phaser.Math.Easing.Circular.Out,
                            onUpdate: () => {
                                /*if (i==0) {
                                    c.x = pos.x - this.marger.frame.width / 2 + 135;
                                } else if (i==2) {
                                    c.x = pos.x + this.marger.frame.width / 2 - 135;
                                }*/
                            }
                        });
                        // c["-image-"].alpha = 0;
                    }
                    this.scene.sound.add("Words are popping in").play();

                    let cloudsContainer = new Phaser.GameObjects.Container(this.scene, pos.x, pos.y);
                    let txt;
                    if (this.gameplay.useImages) {
                        txt = new Phaser.GameObjects.Image(this.scene, 0, 0, this.gameplay.roundWord);
                    } else {
                        txt = this.scene.add.text(0, 0, "", {
                            "fontFamily": "QuranErafont",
                            "fontSize": 85,
                            "color": "#000000",
                            "align": 'center'
                        });
                        txt.setOrigin(0.5, 0.5);
                        txt.style.fixedHeight = 120;
                        txt.setText(this.gameplay.roundWord);
                    }
                    txt['-txt-text'] = this.gameplay.roundWord;
                    txt.alpha = 0;
                    this.scene.tweens.add({
                        targets: txt,
                        delay: 400,
                        alpha: 1,
                        duration: 300
                    });
                    cloudsContainer.add(txt);
                    this.gameplayContainer.add(cloudsContainer);
                    delayedCall(4000, () => {
                        for (var i = 0; i < this.clouds.length; i++) {
                            this.clouds[i].y = this.clouds[i]["defY"] - 250;
                            this.clouds[i].x = this.clouds[i]['defX-for-word'];//this.clouds[i]['defX'];
                            this.clouds[i].alpha = 1;
                            this.clouds[i]["-image-"].alpha = 1;
                            this.clouds[i].visible = i < this.gameplay.roundWords.length;
                        }
                        for (var i = 0; i < this.clouds.length; i++) {
                            this.scene.tweens.add({
                                targets: this.clouds[i],
                                "y": this.clouds[i]["defY"],
                                duration: 350,
                                delay: i == 2 ? 0 : (i == 0 ? 100 : 150),
                                scaleX: 1,
                                scaleY: 1
                            });
                        }
                    });
                    delayedCall(1500, () => {
                        this.scene.sound.add(this.gameplay.roundWord).play();
                    });
                    delayedCall(3000, () => {
                        delayedCall(1000, () => {
                            this.scene.tweens.add({
                                targets: this.marger,
                                alpha: 0,
                                duration: 500
                            });
                            this.scene.tweens.add({
                                targets: cloudsContainer,
                                alpha: 0,
                                duration: 500,
                                onComplete: () => {
                                    this.gameplayContainer.remove(cloudsContainer);
                                }
                            });
                            for (let i = 0; i < this.clouds.length; i++) {
                                let c = this.clouds[i];
                                c["-image-"].setTexture('clouds');
                                c.setScale(0.75);
                                c["-image-"].setOrigin(0.5, 0.5);
                                this.scene.sound.add("cloud words appear").play();
                                if (txt instanceof Phaser.GameObjects.Text) {
                                    c['-txt-'].setFontSize(65);
                                    txt.style.fixedHeight = 65;
                                    c['-txt-'].setText(this.gameplay.roundWords[i]);
                                } else {
                                    c['-txt-'].setTexture(this.gameplay.roundWords[i]);
                                    c['-txt-'].setScale(1)
                                }
                                c['-txt-text'] = this.gameplay.roundWords[i];
                            }
                            this.preparePartC();
                        });
                    });
                }

                preparePartC() {
                    this._btnSound.visible = true;
                    delayedCall(750, () => this.scene.sound.add('tapon_' + this.gameplay.roundWord).play());
                    for (let c of this.clouds) {
                        c["-image-"].on('pointerdown', () => {
                            this.setInputEnabled(false);
                            if (c['-txt-text'] == this.gameplay.roundWord) {
                                for (let _c of this.clouds) {
                                    this.scene.tweens.add({
                                        targets: _c,
                                        "alpha": 0,
                                        duration: 1000,
                                        delay: 1000
                                    });
                                }
                                this.onCorrectAnswer();
                                c["-image-"].setScale(1.25);
                                c["-image-"].setTexture("clouds_correct");
                            } else {
                                this.onWrongAnswer();
                                c["-image-"].setTexture("clouds_incorrect");
                                c["-image-"].setScale(1.25);
                                delayedCall(1000, () => {
                                    c["-image-"].setTexture("clouds");
                                    c["-image-"].setScale(1);
                                });
                                this.scene.sound.add("Wrong click").play();

                                delayedCall(600, () => {
                                    c["-txt-"].visible = false;
                                    c["-image-"].visible = false;
                                    let poping = this.scene.add.sprite(c["-image-"].x, c["-image-"].y, null);
                                    c.add(poping);
                                    this.scene.sound.add("Bubble popping").play();
                                    Preloader.playAnim('poping', poping, () => {
                                        if (poping.parent) c.remove(poping);
                                        c["-txt-"].visible = true;
                                        c["-image-"].visible = true;
                                    });
                                });
                            }
                            this.scene.tweens.add({
                                targets: c,
                                "scale": 0.9,
                                duration: 250,
                                yoyo: true
                            });
                        });
                    }
                }

                onNewRound(showOut) {
                    this.setInputEnabled(false);
                    if (showOut) {
                        this.prepareRound();
                    }
                }

                createInput() {
                    this._btnClose.setInteractive({ cursor: 'pointer', pixelPerfect: true });
                }

                onCorrectAnswer() {
                    let i = this.gameplay.getCurrentTotalAnswersCount();
                    this.tallyEmptyArray[i].visible = false;
                    this.tally[i].visible = true;

                    let completed = this.gameplay.onCorrectAnswer();
                    this.scene.sound.add("correct").play();
                    delayedCall(600, () => {
                        Preloader.playAnim('dolphinhappy', this.character, this.playIdle);
                        this.scene.sound.add(this.birdCorrectSndCounter++ % 2 == 0 ? "Bird - yes thats it" : "Bird fantastic").play();
                        this.scene.sound.add("Dolphin flipping").play();
                    });
                    return completed;
                }

                onWrongAnswer() {
                    let i = this.gameplay.getCurrentTotalAnswersCount();
                    this.tallyEmptyArray[i].visible = true;
                    this.tallyEmptyArray[i].visible = true;
                    this.tally[i].visible = false;

                    let lost = this.gameplay.onWrongAnswer();
                    // this.scene.sound.add("wrong click").play();
                    return lost;
                }

                onCloseClick() {
                    this.showAreYouSurePage();
                    this.scene.sound.add('warning page pop up sfx').play();
                }

                showInstructionPage() {
                    setPageBackground("bg-blue");
                    let playInstructionSound = () => {
                        if (this.wfsnd) {
                            this.wfsnd.stop();
                        }
                        this.wfsnd = this.scene.sound.add("Introduction");
                        this.wfsnd.play();
                    };
                    this.instructionPage = new screen.InstructionPage(this.scene, (target) => {
                        playBtnClickAnim(target);
                        this.remove(this.instructionPage);
                        this.showGameplay();
                        if (this.wfsnd) {
                            this.wfsnd.stop();
                        }
                    }, (target) => {
                        playBtnClickAnim(target);
                        playInstructionSound();
                    });
                    this.add(this.instructionPage);
                    try {
                        playInstructionSound();
                    }
                    catch (e) {
                        console.error(e);
                    }
                }

                showAreYouSurePage() {
                    pauseAllDelayedCalls();
                    setPageBackground("bg-blue");
                    this.pauseSounds();
                    this.areYouSureWindow = new screen.AreYouSureWindow(this.scene, () => {
                        this.remove(this.areYouSureWindow);
                        this.destroyGameplay();
                        this.showInstructionPage();
                    }, () => {
                        this.remove(this.areYouSureWindow);
                        this.unpauseSounds();
                        resumeAllDelayedCalls();
                        setPageBackground("bg-australia");
                    });
                    this.add(this.areYouSureWindow);
                }

                setInputEnabled(enabled) {
                    if (enabled) {
                        for (let c of this.clouds)
                            c["-image-"].setInteractive({ cursor: 'pointer', pixelPerfect: true });
                    } else {
                        for (let c of this.clouds)
                            c["-image-"].disableInteractive();
                    }
                }

                pauseSounds() {
                    this.scene.sound.pauseAll();
                }

                unpauseSounds() {
                    this.scene.sound.resumeAll();
                }

                destroyGameplay() {
                    this.setInputEnabled(false);
                    this.remove(this.gameplayContainer);
                    this.scene.sound.stopAll();
                    destroyAllDelayedCalls();
                }
            }

            screen.GameplayScreen = GameplayScreen;
        })(screen = letterBubble.screen || (letterBubble.screen = {}));
    })(letterBubble || (letterBubble = {}));

    (function (letterBubble) {
        var screen;
        (function (screen) {
            class InstructionPage extends Phaser.GameObjects.Container {
                constructor(scene, onPlayClick, onSndClick) {
                    super(scene);
                    this._instructionPage = new Phaser.GameObjects.Image(this.scene, 0 - 105, 0 - 48, 'Instructions page  ALL ACTIVITY  TITLEs');
                    this._instructionPage.setOrigin(0, 0);
                    this._instructionPage.setInteractive();

                    this._instructionPageTitle = new Phaser.GameObjects.Image(this.scene, 495, 110, 'Letter Bubble Title');
                    this._instructionPageTitle.setScale(0.8);

                    this._btnPlay = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2, 480 - 50, 'btnPLAY1');
                    this._btnPlay.setInteractive({ cursor: 'pointer' });
                    this._btnPlay.once('pointerup', onPlayClick);
                    setupButtonTextureBased(this._btnPlay, 'btnPLAY1', 'btnPLAY2');
                    this.instrTxt = this.scene.add.text(game.scale.width / 2, game.scale.height / 2, "Tap on the bubbles and make a word.\n Then choose the word that matches.", {
                        "fontFamily": "Kids Rock DEMO",
                        "fontSize": 30,
                        "color": "#43425D",
                        "align": 'center'
                    });
                    this.instrTxt.setLineSpacing(15);
                    this.instrTxt.setOrigin(0.5, 0.5);
                    this._btnSoundInstruction = new Phaser.GameObjects.Image(this.scene, 800 - 105, 156 - 50, 'Sound');
                    this._btnSoundInstruction.setInteractive({ cursor: 'pointer' });
                    this._btnSoundInstruction.on('pointerup', onSndClick);
                    setupButtonTextureBased(this._btnSoundInstruction, 'Sound', 'Sound HOVER EFFECT');
                    this.add(this._instructionPage);
                    this.add(this._instructionPageTitle);
                    this.add(this.instrTxt);
                    this.add(this._btnPlay);
                    this.add(this._btnSoundInstruction);
                }
            }

            screen.InstructionPage = InstructionPage;
        })(screen = letterBubble.screen || (letterBubble.screen = {}));
    })(letterBubble || (letterBubble = {}));

    (function (letterBubble) {
        var screen;
        (function (screen) {
            class TryAgainWindow extends Phaser.GameObjects.Container {
                constructor(scene, onBack, onReplay) {
                    super(scene);
                    this.music = null;
                    this.setPosition(-106, -48);
                    this._bg = new Phaser.GameObjects.Image(this.scene, 0, 0, 'Try again page');
                    this._bg.setOrigin(0, 0);
                    this._bg.setInteractive();
                    this._star = new Phaser.GameObjects.Image(this.scene, 400, 415, 'Break Star');
                    this._btnBack = new Phaser.GameObjects.Image(this.scene, 600, 580, 'btnBACK1');
                    this._btnReplay = new Phaser.GameObjects.Image(this.scene, 765, 580, 'btnReplay1');
                    this.totalScoreTxt = this.scene.add.text(830, 355, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 35,
                        "color": "#F49F1C",
                        "align": 'center',
                        'stroke': '#70451A',
                        'strokeThickness': 6
                    });
                    this.totalScoreTxt.setOrigin(0.5, 0.5);
                    let grd = this.totalScoreTxt.context.createLinearGradient(0, 0, 0, this.totalScoreTxt.height);
                    grd.addColorStop(0, '#FFFF00');
                    grd.addColorStop(1, '#C17316');
                    this.totalScoreTxt.setFill(grd);
                    this.starScoreTxt = this.scene.add.text(635, 431, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 24,
                        "color": "#FFFFFF",
                        "align": 'center'
                    });
                    this.starScoreTxt.setOrigin(0.5, 0.5);
                    this.add([
                        this._bg,
                        this._star,
                        this._btnBack,
                        this._btnReplay,
                        this.totalScoreTxt,
                        this.starScoreTxt
                    ]);
                    this._btnBack.setInteractive({ cursor: 'pointer' });
                    this._btnBack.on('pointerup', () => {
                        onBack(this._btnBack);
                        // if (this.music) {
                        //     this.music.stop();
                        // }
                    });
                    setupButtonTextureBased(this._btnBack, 'btnBACK1', 'btnBACK2');
                    this._btnReplay.setInteractive({ cursor: 'pointer' });
                    this._btnReplay.once('pointerup', () => {
                        onReplay(this._btnReplay);
                        if (this.music) {
                            this.music.stop();
                        }
                    });
                    setupButtonTextureBased(this._btnReplay, 'btnReplay1', 'btnReplay2');
                }

                show(score, starScore) {
                    this._star.scale = 1.25;
                    this.scene.tweens.add({
                        targets: this._star,
                        "scale": 1,
                        duration: 500,
                        ease: Phaser.Math.Easing.Back.Out
                    });
                    this.totalScoreTxt.text = String(window.angularComponentRef.component.userInfo.totalScore);
                    this.starScoreTxt.text = String(0);
                    this.music = this.scene.sound.add("Fail - close one");
                    this.music.play();
                }
            }

            screen.TryAgainWindow = TryAgainWindow;
        })(screen = letterBubble.screen || (letterBubble.screen = {}));
    })(letterBubble || (letterBubble = {}));

    game = new letterBubble.App(json);
};

function destroyLetterBubble() {
    if (game) {
        game.destroy();
    }
}

var garage;
var game;

var carRepair = (json) => {
    (function (garage) {
        class App extends Phaser.Game {
            constructor(json) {
                App.json = json;
                let config = {
                    type: Phaser.AUTO,
                    width: App.CANVAS_WIDTH,
                    height: App.CANVAS_HEIGHT,
                    parent: 'game-container',
                    dom: {
                        createContainer: false
                    },
                    scale: {
                        mode: FitScaleManager.detectBestScaleMode(),
                        autoCenter: Phaser.Scale.CENTER_BOTH
                    },
                    transparent: true,
                    scene: {
                        create: () => {
                            this.scene.add('Boot', garage.scene.Boot, true);
                        }
                    }
                };
                super(config);
            }
        }

        App.CANVAS_WIDTH = 980;
        App.CANVAS_HEIGHT = 600;
        garage.App = App;
    })(garage || (garage = {}));

    var delayedCalls = [];

    function delayedCall(delay, callback, args, callbackScope) {
        let scene = game.scene.getAt(0);
        if (scene) {
            let dc = scene.time.delayedCall(delay, callback, args, callbackScope);
            delayedCalls.push(dc);
            return dc;
        }
        let t = setTimeout(callback, delay);
        delayedCalls.push(t);
        return t;
    }

    function pauseAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.paused = true;
            }
        }
    }

    function resumeAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.paused = false;
            }
        }
    }

    function destroyAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.remove(false);
            } else {
                clearTimeout(dc);
            }
        }
        delayedCalls = [];
    }

    function setPageBackground(bg) {
        document.querySelector("html").style.backgroundImage = "url(assets/games/car-repair/imgs/" + bg + ".jpg)";
    }

    function setupButton(btn, frame) {
        btn.on('pointerdown', () => {
            btn.setFrame(frame + '_hover' + '0000');
        });
        btn.on('pointerover', () => {
            btn.setFrame(frame + '_hover' + '0000');
            game.scene.getAt(0).sound.add("button hover").play();
        });
        btn.on('pointerout', () => {
            btn.setFrame(frame + '0000');
        });
        btn.on('pointerup', () => {
            btn.setFrame(frame + '0000');
            game.scene.getAt(0).sound.add('activity selection - button selection').play();
        });
    }

    function setupButtonTextureBased(btn, texture, hoverTexture) {
        btn.on('pointerdown', () => {
            btn.setTexture(hoverTexture);
        });
        btn.on('pointerover', () => {
            btn.setTexture(hoverTexture);
            game.scene.getAt(0).sound.add("button hover").play();
        });
        btn.on('pointerout', () => {
            btn.setTexture(texture);
        });
        btn.on('pointerup', () => {
            btn.setTexture(texture);
            game.scene.getAt(0).sound.add('activity selection - button selection').play();
        });
    }

    function playBtnClickAnim(target) {
        let sc = target.hasOwnProperty("defScale") ? target["defScale"] : 1;
        target.scaleX = target.scaleY = sc;
        let scene = game.scene.getAt(0);
        scene.tweens.add({
            targets: target,
            "scaleX": 0.9 * sc,
            "scaleY": 0.9 * sc,
            duration: 100,
            yoyo: true
        });
    }

    /**
     * @author Roman Parada
     * This class is created to fix overlapping of bottom part of canvas by navigation bar in iOS.
     * It make a delayed resize of the canvas (like Phaser-3 FIT methods does) and it overrides Phaser-3 input window to Phaser-3 core transform methods
     *
     * How to use:
     * Just call the code line below in Boot scene's init() method of your project:
     * new FitScaleManager(this.game).setup();
     */
    class FitScaleManager {
        constructor(game) {
            this.doResize = () => {
                let scale = this.calculateScale();
                let newCanvasWidth = this.phaserScaleManager.width * scale;
                let newCanvasHeight = this.phaserScaleManager.height * scale;
                this.canvasStyle.width = newCanvasWidth + 'px';
                this.canvasStyle.height = newCanvasHeight + 'px';
                this.canvasStyle.marginLeft = (window.innerWidth - newCanvasWidth) / 2 + 'px';
                this.canvasStyle.marginTop = (window.innerHeight - newCanvasHeight) / 2 + 'px';
            };
            this.game = game;
            this.canvasStyle = this.game.canvas.style;
            this.phaserScaleManager = this.game.scale;
        }

        static detectBestScaleMode() {
            let iOS = /iPad|iPhone|iPod/.test(navigator.platform || "");
            let isAndroid = window.navigator.userAgent.toLowerCase().indexOf("android") > -1;
            return iOS || isAndroid ? Phaser.Scale.FIT : Phaser.Scale.NONE;
        }
        ;

        /**
         * Just call this method once in Boot scene's init() method
         */
        setup() {
            this.phaserScaleManager.addListener(Phaser.Scale.Events.RESIZE, this.onResize, this);
            this.overridePhaserTransformMethods();
            this.onResize();
        }

        calculateScale() {
            if (game.scale.scaleMode == Phaser.Scale.NONE)
                return 1;
            return Math.min(window.innerWidth / this.phaserScaleManager.width, window.innerHeight / this.phaserScaleManager.height);
        }

        overridePhaserTransformMethods() {
            this.game.scale.transformX = (pageX) => {
                return (pageX - parseInt(this.canvasStyle.marginLeft.split("px")[0])) / this.calculateScale();
            };
            this.game.scale.transformY = (pageY) => {
                return (pageY - parseInt(this.canvasStyle.marginTop.split("px")[0])) / this.calculateScale();
            };
        }

        onResize() {
            setTimeout(this.doResize, FitScaleManager.RESIZE_DELAY);
        }
    }

    FitScaleManager.RESIZE_DELAY = 500;

    (function (garage) {
        var core;
        (function (core) {
            class Gameplay {
                constructor() {
                    this.allLettersNames = null;
                    this.garagesNum = 3;
                    this.failsNumToLose = 3;
                    this.currentRound = 0;
                    this.correctAnswersCount = 0;
                    this.wrongAnswersCount = 0;
                    this.correctAnswersCountThisRound = 0;
                    this.wrongAnswersCountThisRound = 0;
                    this.onNewRound = null;
                    this.nextLetterDelay = 0;
                    this.failsNumToLose = Number(game.cache.json.get('gameplay')["failsNumToLose"]);
                    this.useImages = Boolean(game.cache.json.get('gameplay')["useImages"]);
                }

                setupCallbacks(onComplete, onLose, onNewRound) {
                    this.onComplete = onComplete;
                    this.onLose = onLose;
                    this.onNewRound = onNewRound;
                }

                onLetterChosen() {
                    this.currentRound++;
                    if (this.currentRound >= this.totalRoundsNum) {
                        this.onComplete(this.correctAnswersCount, this.correctAnswersCount);
                        return true;
                    } else {
                        this.nextLetter();
                    }
                    return false;
                }

                nextLetter() {
                    let fn = () => {
                        this.randomize();
                        this.correctAnswersCountThisRound = 0;
                        this.wrongAnswersCountThisRound = 0;
                        if (this.onNewRound)
                            this.onNewRound();
                    };
                    if (this.nextLetterDelay == 0) {
                        fn();
                    } else {
                        delayedCall(this.nextLetterDelay, fn);
                    }
                }

                readWord(word) {
                    let d = 2000;
                    delayedCall(d, () => {
                        game.scene.getScene('ScreenMain').sound.add(word).play();
                    });
                    return d + 750;
                }

                getCorrectLetterName(index) {
                    return this.garageLettersNames[index];
                }

                getCorrectAudioKey(index) {
                    return this.garageLettersAudioKey[index];
                }

                onCorrectAnswer() {
                    this.correctAnswersCount++;
                    this.correctAnswersCountThisRound++;
                    this.nextLetterDelay = this.readWord(this.correctWord);
                    return this.onLetterChosen();
                }

                onWrongAnswer() {
                    this.wrongAnswersCount++;
                    this.wrongAnswersCountThisRound++;
                    this.nextLetterDelay = 1000;
                    if (this.wrongAnswersCount >= this.failsNumToLose) {
                        this.onLose(0, 0);
                        return true;
                    } else {
                        this.onLetterChosen();
                    }
                    return false;
                }

                getCurrentTotalAnswersCount() {
                    return this.correctAnswersCount + this.wrongAnswersCount;
                }

                getCurrentTotalAnswersCountThisRound() {
                    return this.correctAnswersCountThisRound + this.wrongAnswersCountThisRound;
                }

                isNewRound() {
                    return this.getCurrentTotalAnswersCountThisRound() == 0;
                }

                isRoundsComplete() {
                    return this.currentRound >= this.totalRoundsNum;
                }

                randomize() {
                    let round = this.rounds[this.currentRound];
                    this.correctWord = round["correctWord"];
                    if (this.wordsLetters === undefined) {

                        this.garageLettersNames = this.correctWord.split("");
                    }
                    else {
                        this.garageLettersNames = this.wordsLetters[this.correctWord];
                    }
                    this.garageLettersNames = this.garageLettersNames.reverse();
                    this.garageLettersAudioKey = [];
                    for (let i = 0; i < this.garageLettersNames.length; i++) {
                        this.garageLettersAudioKey.push(this.getAudioKeyOfChar(this.garageLettersNames[i]));
                    }
                    this.carWords = Phaser.Utils.Array.Shuffle([this.correctWord, round["wrongWord1"], round["wrongWord2"]]);
                }

                getAudioKeyOfChar(letter) {
                    let json = game.cache.json.get('gameplay');
                    let letters = json["letters"];
                    for (let d of letters) {
                        if (letter == d['letterName']) {
                            return d['audioKey'];
                        }
                    }
                    return null;
                }

                reset() {
                    this.setupCallbacks(null, null, null);
                    this.correctWord = null;
                    let json = JSON.parse(JSON.stringify(game.cache.json.get('gameplay')));

                    this.wordsLetters = json["wordsLetters"];

                    this.letters = json["letters"].slice();
                    this.allLettersNames = [];
                    for (let d of this.letters)
                        this.allLettersNames.push(d["letterName"]);
                    this.rounds = JSON.parse(JSON.stringify(json["rounds"]));
                    this.totalRoundsNum = this.rounds.length;
                    this.currentRound = 0;
                    this.correctAnswersCount = 0;
                    this.wrongAnswersCount = 0;
                    this.correctAnswersCountThisRound = 0;
                    this.wrongAnswersCountThisRound = 0;
                    this.nextLetterDelay = 0;
                    this.nextLetter();
                }
            }

            core.Gameplay = Gameplay;
        })(core = garage.core || (garage.core = {}));
    })(garage || (garage = {}));

    (function (garage) {
        var scene;
        (function (scene) {
            class Boot extends Phaser.Scene {
                init() {
                    this.game.scale.transformX = (pageX) => {
                        let offsetLeft = 0;
                        let parentElement = game.canvas.parentElement;
                        while (parentElement) {
                            if (parentElement.offsetLeft) {
                                offsetLeft = parentElement.offsetLeft;
                                break;
                            }
                            parentElement = parentElement.parentElement;
                        }
                        return (pageX - offsetLeft) * this.game.scale.displayScale.x;
                    };
                    this.game.scale.transformY = (pageY) => {
                        let offsetTop = 0;
                        let parentElement = game.canvas.parentElement;
                        while (parentElement) {
                            if (parentElement.offsetTop) {
                                offsetTop = parentElement.offsetTop;
                                break;
                            }
                            parentElement = parentElement.parentElement;
                        }
                        return (pageY - offsetTop) * this.game.scale.displayScale.y;
                    };
                }

                create() {
                    game.scene.remove('Boot');
                    game.scene.add('Preloader', garage.scene.Preloader, true);
                }
            }

            scene.Boot = Boot;
        })(scene = garage.scene || (garage.scene = {}));
    })(garage || (garage = {}));

    (function (garage) {
        var scene;
        (function (scene) {
            var Gameplay = garage.core.Gameplay;

            class MainScene extends Phaser.Scene {
                create() {
                    this.gameplay = new Gameplay();
                    this.gameplayScreen = new garage.screen.GameplayScreen(this, this.gameplay);
                    this.children.add(this.gameplayScreen);
                    this.gameplayScreen.showInstructionPage();
                }
            }

            scene.MainScene = MainScene;
        })(scene = garage.scene || (garage.scene = {}));
    })(garage || (garage = {}));

    (function (garage) {
        var scene;
        (function (scene) {
            class Preloader extends Phaser.Scene {
                preload() {
                    if (typeof garage.App.json == "string") this.load.json('gameplay', garage.App.json); else this.game.cache.json.add('gameplay', garage.App.json);
                }

                create() {
                    let json = game.cache.json.get('gameplay');
                    let words = json["words"];
                    if (json["useImages"]) {
                        let rounds = JSON.parse(JSON.stringify(json["rounds"]));
                        for (let i = 0; i < rounds.length; i++) {
                            let w = rounds[i];
                            this.load.image(w.correctWord, "assets/games/car-repair/imgs/letters/" + w.correctWord + ".png");
                            this.load.image(w.wrongWord1, "assets/games/car-repair/imgs/letters/" + w.wrongWord1 + ".png");
                            this.load.image(w.wrongWord2, "assets/games/car-repair/imgs/letters/" + w.wrongWord2 + ".png");
                        }
                        for (let l of json["letters"]) {
                            this.load.image(l["letterName"], "assets/games/car-repair/imgs/letters/" + l["letterName"] + ".png");
                        }
                    }
                    for (let l of json["letters"]) {
                        this.load.audio(l["audioKey"], "assets/games/car-repair/sound/mp3/letters/" + l["audioKey"] + ".mp3");
                    }
                    for (let w of words) {
                        this.load.audio(w, "assets/games/car-repair/sound/mp3/words/" + w + ".mp3");
                    }
                    this.load.pack('preloader', 'assets/games/car-repair/pack.json');
                    this.load.on('progress', (value) => {
                    }, this);
                    this.load.on('complete', () => {
                        this.nextScene();
                    });
                    this.load.start();
                }

                nextScene() {
                    game.scene.remove('Preloader');
                    game.scene.add('ScreenMain', garage.scene.MainScene, true);
                }
            }

            scene.Preloader = Preloader;
        })(scene = garage.scene || (garage.scene = {}));
    })(garage || (garage = {}));

    (function (garage) {
        var screen;
        (function (screen) {
            class AreYouSureWindow extends Phaser.GameObjects.Container {
                constructor(scene, onYes, onNo) {
                    super(scene);
                    this._areYouSurePage = new Phaser.GameObjects.Image(this.scene, -105, 0 - 48, 'Exit warning');
                    this._areYouSurePage.setOrigin(0, 0);
                    this._areYouSurePage.setInteractive();
                    var modalTextStyle = {
                        backgroundColor: 'transparent',
                        stroke: '#ffffff',
                        strokeThickness: 2,
                        lineSpacing: 15,
                        fontFamily: 'Kids Rock DEMO',
                        fontSize: 27,
                        color: '#43425d',
                        wordWrap: true,
                        align: 'center'
                    };
                    var modalText = this.scene.add.text(game.scale.width / 2 + 12, game.scale.height / 2, "Your progress in this activity will not be saved. \n Are you sure you want to exit? ", modalTextStyle);
                    modalText.setOrigin(0.5, 0.5);
                    this._btnSureYes = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2 - 95, 485 - 50, 'btnYES1');
                    this._btnSureYes.setInteractive({ cursor: 'pointer' });
                    this._btnSureYes.once('pointerup', () => {
                        onYes;
                        window.angularComponentRef.backToMenu();
                    });
                    setupButtonTextureBased(this._btnSureYes, 'btnYES1', 'btnYES2');
                    this._btnSureNo = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2 + 95, 485 - 50, 'btnNO1');
                    this._btnSureNo.setInteractive({ cursor: 'pointer' });
                    this._btnSureNo.once('pointerup', onNo);
                    setupButtonTextureBased(this._btnSureNo, 'btnNO1', 'btnNO2');
                    this.add(this._areYouSurePage);
                    this.add(this._btnSureYes);
                    this.add(this._btnSureNo);
                    this.add(modalText);
                }
            }

            screen.AreYouSureWindow = AreYouSureWindow;
        })(screen = garage.screen || (garage.screen = {}));
    })(garage || (garage = {}));

    (function (garage_1) {
        var screen;
        (function (screen) {
            class Car extends Phaser.GameObjects.Container {
                constructor(scene, gameplayScreen, carBG) {
                    super(scene);
                    this.gameplayScreen = gameplayScreen;
                    this._carBG = new Phaser.GameObjects.Image(this.scene, 0, 0, carBG);
                    this.add(this._carBG);
                    this._WIDE_SCREEN = new Phaser.GameObjects.Image(this.scene, 0, -86, 'WIDE SCREEN');
                    this.add(this._WIDE_SCREEN);
                    this.ligthR = new Phaser.GameObjects.Image(this.scene, 160, 65, 'ligth');
                    this.add(this.ligthR);
                    this.ligthL = new Phaser.GameObjects.Image(this.scene, -160, 65, 'ligth');
                    this.add(this.ligthL);
                    this.setLigthVisible(false);
                    if (this.gameplayScreen.gameplay.useImages) {
                        this.wordText = new Phaser.GameObjects.Image(this.scene, 0, -80, null);
                        this.add(this.wordText);
                    } else {
                        this.wordText = this.scene.add.text(0, -90, "", {
                            "fontFamily": "QuranErafont",
                            "fontSize": 100,
                            "color": "#000000",
                            "align": 'center',
                            'stroke': '#FFFFFF',
                            'strokeThickness': 7
                        });
                        this.wordText.setOrigin(0.5, 0.5);
                        this.wordText.style.fixedHeight = 150;
                        this.add(this.wordText);
                    }
                }

                setGarage(garage) {
                    this.garage = garage;
                }

                setup(word, isCorrect) {
                    this.word = word;
                    this.isCorrect = isCorrect;
                    if (this.gameplayScreen.gameplay.useImages) {
                        this.wordText.setTexture(word);
                        this.wordText.setScale(1.5);
                    } else {
                        this.wordText.setText(this.word);
                    }
                }

                createInput() {
                    this._carBG.on('pointerup', () => {
                        // playBtnClickAnim(letterImage);
                        if (this.isCorrect) {
                            this._WIDE_SCREEN.setTexture('WIDE SCREEN CORRECT');
                            this.setLigthVisible(true);
                            for (let c of this.gameplayScreen.cars) {
                                if (c != this) {
                                    c.wordText.visible = false;
                                }
                            }
                            this.gameplayScreen.onCorrectAnswer();
                        } else {
                            this._WIDE_SCREEN.setTexture('WIDE SCREEN Wrong');
                            this.gameplayScreen.onWrongAnswer();
                        }
                    });
                }

                _setInteractive() {
                    this._carBG.setInteractive({ cursor: 'pointer' });
                }

                _disableInteractive() {
                    this._carBG.disableInteractive();
                }

                setLigthVisible(visible) {
                    this.ligthL.visible = this.ligthR.visible = visible;
                }

                reset() {
                    this.setLigthVisible(false);
                    this.wordText.visible = false;
                    this._WIDE_SCREEN.setTexture('WIDE SCREEN');
                }
            }

            screen.Car = Car;
        })(screen = garage_1.screen || (garage_1.screen = {}));
    })(garage || (garage = {}));

    (function (garage) {
        var screen;
        (function (screen) {
            class CompleteWindow extends Phaser.GameObjects.Container {
                constructor(scene, onBack, onReplay, onNext) {
                    super(scene);
                    this.music = null;
                    this.setPosition(-104.5, -48);
                    this._bgComplete = new Phaser.GameObjects.Image(this.scene, 0, 0, 'Completion page LATEST UPDATED');
                    this._bgComplete.setOrigin(0, 0);
                    this._bgComplete.setInteractive();
                    this._cup = new Phaser.GameObjects.Image(this.scene, 400, 410, 'Trophy');
                    this._btnBack = new Phaser.GameObjects.Image(this.scene, 570, 570, 'btnBACK1');
                    this._btnReplay = new Phaser.GameObjects.Image(this.scene, 720, 570, 'btnReplay1');
                    this._btnNext = new Phaser.GameObjects.Image(this.scene, 870, 570, 'btnNEXT1');
                    let _CollectedPoints = new Phaser.GameObjects.Image(this.scene, 620, 440, 'Collected Points');
                    this.totalScoreTxt = this.scene.add.text(845, 352, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 35,
                        "color": "#F49F1C",
                        "align": 'center',
                        'stroke': '#70451A',
                        'strokeThickness': 6
                    });
                    this.totalScoreTxt.setOrigin(0.5, 0.5);
                    let grd = this.totalScoreTxt.context.createLinearGradient(0, 0, 0, this.totalScoreTxt.height);
                    grd.addColorStop(0, '#FFFF00');
                    grd.addColorStop(1, '#C17316');
                    this.totalScoreTxt.setFill(grd);
                    this.starScoreTxt = this.scene.add.text(648, 433, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 24,
                        "color": "#FFFFFF",
                        "align": 'center'
                    });
                    this.starScoreTxt.setOrigin(0.5, 0.5);
                    this.add([
                        this._bgComplete,
                        _CollectedPoints,
                        this._cup,
                        this._btnBack,
                        this._btnReplay,
                        this._btnNext,
                        this.totalScoreTxt,
                        this.starScoreTxt
                    ]);
                    this._btnBack.setInteractive({ cursor: 'pointer' });
                    this._btnBack.on('pointerup', () => {
                        onBack(this._btnBack);
                        window.angularComponentRef.backToMenu();
                        // if (this.music) {
                        //     this.music.stop();
                        // }
                    });
                    setupButtonTextureBased(this._btnBack, 'btnBACK1', 'btnBACK2');
                    this._btnReplay.setInteractive({ cursor: 'pointer' });
                    this._btnReplay.once('pointerup', () => {
                        onReplay(this._btnReplay);
                        if (this.music) {
                            this.music.stop();
                        }
                    });
                    setupButtonTextureBased(this._btnReplay, 'btnReplay1', 'btnReplay2');
                    this._btnNext.setInteractive({ cursor: 'pointer' });
                    this._btnNext.on('pointerup', () => {
                        onNext(this._btnNext);
                        window.angularComponentRef.nextActivity();
                        // if (this.music) {
                        //     this.music.stop();
                        // }
                    });
                    setupButtonTextureBased(this._btnNext, 'btnNEXT1', 'btnNEXT2');
                }

                show(score, starScore) {
                    window.angularComponentRef.gameFinish({ score, starScore });
                    this._cup.scale = 1.25;
                    this.scene.tweens.add({
                        targets: this._cup,
                        "scale": 1,
                        duration: 500,
                        ease: Phaser.Math.Easing.Back.Out
                    });
                    this.totalScoreTxt.text = String(window.angularComponentRef.component.userInfo.totalScore);
                    this.starScoreTxt.text = String(starScore);
                    // let music = this.scene.sound.add("viktory");
                    this.music = this.scene.sound.add("Activity completion fantastic");
                    this.music.play();
                }
            }

            screen.CompleteWindow = CompleteWindow;
        })(screen = garage.screen || (garage.screen = {}));
    })(garage || (garage = {}));

    (function (garage) {
        var screen;
        (function (screen) {
            class GameplayScreen extends Phaser.GameObjects.Container {
                constructor(scene, gameplay) {
                    super(scene);
                    this.bgMusic = null;
                    this.firstHeartDefPos = { x: 60, y: 100 };
                    this.soundGooseYes = null;
                    this.soundGooseNo = null;
                    this.correctAudio = null;
                    this.wfsnd = null;
                    this.showCompleteWindow = (score, starScore) => {
                        let completeWindow = new screen.CompleteWindow(this.scene, (target) => {
                            playBtnClickAnim(target);
                        }, (target) => {
                            playBtnClickAnim(target);
                            this.destroyGameplay();
                            this.remove(completeWindow);
                            this.showInstructionPage();
                        }, (target) => {
                            playBtnClickAnim(target);
                        });
                        this.setInputEnabled(false);
                        delayedCall(3000, () => {
                            setPageBackground("bg-blue");
                            this.add(completeWindow);
                            completeWindow.show(score, starScore);
                            this.bgMusic.stop();
                        });
                    };
                    this.showLoseWindow = (score, starScore) => {
                        let tryAgainWindow = new screen.TryAgainWindow(this.scene, (target) => {
                            playBtnClickAnim(target);
                        }, (target) => {
                            playBtnClickAnim(target);
                            this.destroyGameplay();
                            this.remove(tryAgainWindow);
                            this.showInstructionPage();
                        });
                        this.setInputEnabled(false);
                        delayedCall(750, () => {
                            setPageBackground("bg-blue");
                            this.add(tryAgainWindow);
                            tryAgainWindow.show(score, starScore);
                            this.bgMusic.stop();
                        });
                    };
                    this.gameplay = gameplay;
                    window["gs"] = this;
                }

                showGameplay() {
                    setPageBackground("bg-australia");
                    this.bgMusic = this.scene.sound.add("Bachground ambience");
                    this.bgMusic.play();
                    this.bgMusic.loop = true;
                    this.gameplayContainer = new Phaser.GameObjects.Container(this.scene);
                    this.add(this.gameplayContainer);
                    this.gameplayContainer.setScale(0.5);
                    this._gameStage = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2 * 2, game.scale.height / 2 * 2, 'Garage');
                    this._gameStage.setOrigin(0.5, 0.5);
                    this._gameStage.setInteractive();
                    this.gameplayContainer.add(this._gameStage);
                    this._btnClose = new Phaser.GameObjects.Image(this.scene, /*1025-105*/ 1865, /*100-50*/ 95, 'x Button');
                    this._btnClose.setInteractive({ cursor: 'pointer' });
                    this._btnClose.setScale(2);
                    this._btnClose["defScale"] = this._btnClose.scale;
                    setupButtonTextureBased(this._btnClose, 'x Button', 'x Button HOVER EFFECT');
                    this.gameplayContainer.add(this._btnClose);
                    this.gameplay.reset();
                    this.garages = [];
                    this.cars = [];
                    let l = this.gameplay.garageLettersNames.length;
                    for (let i = 0; i < l; i++) {
                        let g = new screen.Garage(this.scene, this, i);
                        g.setPosition(970 + (l % 2 == 0 ? i / 2 - 0.5 : (i - 1) / 2) * 1050, 380);
                        this.gameplayContainer.add(g);
                        this.garages.push(g);
                    }
                    let carBGs = ['Car Purple', 'Car Red', 'Car Green'];
                    for (let i = 0; i < l; i++) {
                        let c = new screen.Car(this.scene, this, carBGs[i % carBGs.length]);
                        // c.setScale(1.3)
                        this.cars.push(c);
                        this.garages[i].addCar(c);
                    }
                    this.createInput();
                    this.prepareGarages();
                    this.gameplay.setupCallbacks(this.showCompleteWindow, this.showLoseWindow, () => {
                        this.onNewRound(true);
                    });
                    this.hearts = [];
                }

                showHeart(active) {
                    let h = new Phaser.GameObjects.Image(this.scene, this.firstHeartDefPos['x'] + this.hearts.length * 68, this.firstHeartDefPos['y'], active ? 'GreyHeartActive' : 'GreyHeartDef');
                    this.gameplayContainer.add(h);
                    this.hearts.push(h);
                }

                prepareGarages() {
                    this.setInputEnabled(false);
                    for (let g of this.garages)
                        g.reset();
                    this.garages[this.garages.length - 1].showHandIconAnim();
                    delayedCall(1200, () => {
                        if (this.gameplay.isNewRound()) {
                            if (!this.gameplay.isRoundsComplete()) {
                                delayedCall(2000, () => {
                                    this.setInputEnabled(true);
                                });
                            }
                        } else {
                            this.setInputEnabled(true);
                        }
                    });
                }

                onNewRound(showOut) {
                    this.setInputEnabled(false);
                    if (showOut) {
                        for (let g of this.garages) {
                            g.closeDoor(true);
                        }
                        delayedCall(screen.Garage.DOOR_OPEN_CLOSE_DURATION, () => {
                            this.prepareGarages();
                            for (let c of this.cars) {
                                c.visible = false;
                            }
                        });
                    }
                }

                createInput() {
                    for (let g of this.garages)
                        g.createInput();
                    for (let c of this.cars)
                        c.createInput();
                    this._btnClose.on('pointerup', () => {
                        playBtnClickAnim(this._btnClose);
                        this.onCloseClick();
                    });
                }

                onCorrectAnswer() {
                    let completed = this.gameplay.onCorrectAnswer();
                    this.soundGooseYes = this.scene.sound.add("correct click ignition");
                    this.soundGooseYes.play();
                    this.showHeart(true);
                    this.setInputEnabled(false);
                    return completed;
                }

                onWrongAnswer() {
                    let lost = this.gameplay.onWrongAnswer();
                    this.soundGooseNo = this.scene.sound.add("Warning sound - horn");
                    this.soundGooseNo.play();
                    this.showHeart(false);
                    this.setInputEnabled(false);
                    return lost;
                }

                playCorrectAudio(index) {
                    if (this.correctAudio) {
                        this.correctAudio.stop();
                    }
                    this.correctAudio = this.scene.sound.add(this.gameplay.getCorrectAudioKey(index));
                    this.correctAudio.play();
                    if (this.areYouSureWindow && this.areYouSureWindow.parentContainer == this) {
                        this.correctAudio.pause();
                    }
                }

                onCloseClick() {
                    this.showAreYouSurePage();
                    this.scene.sound.add('warning page pop up sfx').play();
                }

                showInstructionPage() {
                    setPageBackground("bg-blue");
                    let playInstructionSound = () => {
                        if (this.wfsnd) {
                            this.wfsnd.stop();
                        }
                        this.wfsnd = this.scene.sound.add("Car Repairs Choose the word that matches");
                        this.wfsnd.play();
                    };
                    this.instructionPage = new screen.InstructionPage(this.scene, (target) => {
                        playBtnClickAnim(target);
                        this.remove(this.instructionPage);
                        this.showGameplay();
                        if (this.wfsnd) {
                            this.wfsnd.stop();
                        }
                    }, (target) => {
                        playBtnClickAnim(target);
                        playInstructionSound();
                    });
                    this.add(this.instructionPage);
                    try {
                        playInstructionSound();
                    }
                    catch (e) {
                        console.error(e);
                    }
                }

                showAreYouSurePage() {
                    pauseAllDelayedCalls();
                    setPageBackground("bg-blue");
                    this.pauseSounds();
                    this.areYouSureWindow = new screen.AreYouSureWindow(this.scene, () => {
                        this.remove(this.areYouSureWindow);
                        this.destroyGameplay();
                        this.showInstructionPage();
                    }, () => {
                        this.remove(this.areYouSureWindow);
                        this.unpauseSounds();
                        resumeAllDelayedCalls();
                        setPageBackground("bg-australia");
                    });
                    this.add(this.areYouSureWindow);
                }

                setInputEnabled(enabled) {
                    if (enabled) {
                        for (let g of this.garages)
                            g._setInteractive();
                        for (let c of this.cars)
                            c._setInteractive();
                    } else {
                        for (let g of this.garages)
                            g._disableInteractive();
                        for (let c of this.cars)
                            c._disableInteractive();
                    }
                }

                pauseSounds() {
                    this.scene.sound.pauseAll();
                }

                unpauseSounds() {
                    this.scene.sound.resumeAll();
                }

                destroyGameplay() {
                    this.scene.tweens.killAll();
                    this.setInputEnabled(false);

                    for (let g of this.garages) {
                        g.destroy(true);
                    }
                    this.remove(this.gameplayContainer, true);
                    this.scene.sound.stopAll();
                    destroyAllDelayedCalls();
                }
            }

            screen.GameplayScreen = GameplayScreen;
        })(screen = garage.screen || (garage.screen = {}));
    })(garage || (garage = {}));

    (function (garage) {
        var screen;
        (function (screen) {
            class Garage extends Phaser.GameObjects.Container {
                constructor(scene, gameplayScreen, index) {
                    super(scene);
                    this.garageDoorDY = 15;
                    this.isDoorOpened = true;
                    this.gameplayScreen = gameplayScreen;
                    this.index = index;
                    this._btnSound = new Phaser.GameObjects.Image(this.scene, 0, 0, 'SoundButtonNormal');
                    setupButtonTextureBased(this._btnSound, 'SoundButtonNormal', 'SoundButtonHover');
                    this.add(this._btnSound);
                    this._btnSound.visible = false;
                    this._btnOpen = new Phaser.GameObjects.Image(this.scene, 0, 0, 'OpenButttonNormal');
                    setupButtonTextureBased(this._btnOpen, 'OpenButttonNormal', 'OpenButttonHover');
                    this.add(this._btnOpen);
                    if (this.gameplayScreen.gameplay.useImages) {
                        this.letterImage = new Phaser.GameObjects.Image(this.scene, 0, 210, null);
                        this.add(this.letterImage);
                    } else {
                        this.letterImage = this.scene.add.text(0, 210, "", {
                            "fontFamily": "QuranErafont",
                            "fontSize": 130,
                            "color": "#000000",
                            "align": 'center'
                        });
                        this.letterImage.setOrigin(0.5, 0.5);
                        this.letterImage.style.fixedHeight = 170;
                        this.add(this.letterImage);
                    }
                    this.garageDoorContainer = new Phaser.GameObjects.Container(this.scene);
                    this.garageDoorContainer.y = 70;
                    this.add(this.garageDoorContainer);
                    this.garageDoor = [];
                    for (let i = 0; i < 19; i++) {
                        let garageDoor = new Phaser.GameObjects.Image(this.scene, 0, 0, 'garageDoor');
                        garageDoor.scaleY = i % 2 == 0 ? 1 : 1;
                        garageDoor.setOrigin(0.5, 0);
                        this.garageDoor.push(garageDoor);
                        this.garageDoorContainer.addAt(garageDoor, 0);
                    }
                    this.closeDoor(false);
                    this._HandIcon = new Phaser.GameObjects.Image(this.scene, 80, 65, 'Hand Icon');
                    this._HandIcon.setOrigin(0, 1);
                    this._HandIcon.visible = false;
                    this.add(this._HandIcon);
                }

                showHandIconAnim() {
                    this._btnOpen.setInteractive({ cursor: 'pointer', pixelPerfect: true });
                    this._HandIcon.visible = true;
                    this._HandIcon.angle = 0;
                    this._t = this.scene.tweens.add({
                        targets: this._HandIcon,
                        "angle": 10,
                        yoyo: true,
                        repeat: -1,
                        duration: 500
                    });
                }

                hideHandIcon() {
                    this._HandIcon.visible = false;
                    this.scene.tweens.remove(this._t);
                }

                opedDoor(animate) {
                    if (animate) {
                        this.scene.sound.add('Garage door opening sound').play();
                        for (let i = 0; i < this.garageDoor.length; i++) {
                            this.scene.tweens.add({
                                targets: this.garageDoor[i],
                                "y": 0,
                                "scaleX": 1,
                                duration: Garage.DOOR_OPEN_CLOSE_DURATION,
                                onComplete: () => {
                                    this.gameplayScreen.playCorrectAudio(this.index);
                                    this.isDoorOpened = true;
                                }
                            });
                        }
                    } else {
                        for (let i = 0; i < this.garageDoor.length; i++) {
                            this.garageDoor[i].y = 0;
                            this.garageDoor[i].scaleX = 1;
                        }
                        this.isDoorOpened = true;
                    }
                }

                closeDoor(animate) {
                    if (animate) {
                        this.scene.sound.add('Garage door opening sound').play();
                        for (let i = 0; i < this.garageDoor.length; i++) {
                            this.scene.tweens.add({
                                targets: this.garageDoor[i],
                                "y": 0 + i * this.garageDoorDY,
                                "scaleX": 1 + i * 0.004,
                                duration: Garage.DOOR_OPEN_CLOSE_DURATION,
                                onComplete: () => {
                                    this.isDoorOpened = false;
                                }
                            });
                        }
                    } else {
                        for (let i = 0; i < this.garageDoor.length; i++) {
                            this.garageDoor[i].y = 0 + i * this.garageDoorDY;
                            this.garageDoor[i].scaleX = 1 + i * 0.004;
                        }
                        this.isDoorOpened = false;
                    }
                }

                createInput() {
                    this._btnSound.on('pointerup', () => {
                        playBtnClickAnim(this._btnSound);
                        this.onSoundClick();
                    });
                    this._btnOpen.on('pointerup', () => {
                        playBtnClickAnim(this._btnOpen);
                        this._btnOpen.visible = false;
                        this.opedDoor(true);
                        this.hideHandIcon();
                        delayedCall(Garage.DOOR_OPEN_CLOSE_DURATION + 1000, () => {
                            for (let i = this.gameplayScreen.garages.length - 1; i >= 0; i--) {
                                let g = this.gameplayScreen.garages[i];
                                if (!g.isDoorOpened) {
                                    g._btnOpen.setInteractive({ cursor: 'pointer', pixelPerfect: true });
                                    g.showHandIconAnim();
                                    this._btnSound.visible = true;
                                    return;
                                }
                            }
                            if (!this._btnSound.visible) {
                                let wasAllCarsInvisible = true;
                                for (let c of this.gameplayScreen.cars) {
                                    if (c.visible)
                                        wasAllCarsInvisible = false;
                                    c.wordText.visible = true;
                                    c.visible = true;
                                }
                                if (wasAllCarsInvisible)
                                    this.scene.sound.add("car appear sfx").play();
                                this.scene.sound.add("Choose the word that matches").play();
                            }
                            this._btnSound.visible = true;
                        });
                    });
                }

                onSoundClick() {
                    this.gameplayScreen.playCorrectAudio(this.index);
                }

                _setInteractive() {
                    this._btnSound.setInteractive({ cursor: 'pointer', pixelPerfect: true });
                    // this._btnOpen.setInteractive({cursor: 'pointer', pixelPerfect:true});
                }

                _disableInteractive() {
                    this._btnSound.disableInteractive();
                    this._btnOpen.disableInteractive();
                }

                addCar(car) {
                    this.car = car;
                    this.car.setPosition((this.gameplayScreen.gameplay.garageLettersNames.length % 2 == 0 ? this.index / 2 - 0.5 : (this.index - 1) / 2) * 200, 600);
                    this.addAt(this.car, this.getIndex(this.garageDoorContainer));
                    this.car.setGarage(this);
                    this.car.visible = false;
                }

                reset() {
                    this._btnOpen.visible = true;
                    this._btnSound.visible = false;
                    this.car.reset();
                    let gameplay = this.gameplayScreen.gameplay;
                    if (gameplay.useImages) {
                        this.letterImage.setTexture(gameplay.garageLettersNames[this.index]);
                        this.letterImage.setScale(1.5);
                    } else {
                        this.letterImage.setText(gameplay.garageLettersNames[this.index]);
                    }
                    this.car.setup(gameplay.carWords[this.index], gameplay.carWords[this.index] == gameplay.correctWord);
                    this._btnOpen.disableInteractive();
                }
            }

            Garage.DOOR_OPEN_CLOSE_DURATION = 1000;
            screen.Garage = Garage;
        })(screen = garage.screen || (garage.screen = {}));
    })(garage || (garage = {}));

    (function (garage) {
        var screen;
        (function (screen) {
            class InstructionPage extends Phaser.GameObjects.Container {
                constructor(scene, onPlayClick, onSndClick) {
                    super(scene);
                    this._instructionPage = new Phaser.GameObjects.Image(this.scene, 0 - 105, 0 - 48, 'Instructions page  ALL ACTIVITY  TITLEs');
                    this._instructionPage.setOrigin(0, 0);
                    this._instructionPage.setInteractive();
                    this._instructionPageTitle = new Phaser.GameObjects.Image(this.scene, 495, 105, 'welcome');
                    this._instructionPageTitle.setScale(0.8);
                    this._btnPlay = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2, 480 - 50, 'btnPLAY1');
                    this._btnPlay.setInteractive({ cursor: 'pointer' });
                    this._btnPlay.once('pointerup', onPlayClick);
                    setupButtonTextureBased(this._btnPlay, 'btnPLAY1', 'btnPLAY2');
                    this.instrTxt = this.scene.add.text(game.scale.width / 2, game.scale.height / 2, "A Word is hidden in the garage.\nTap the buttons to uncover the letters.\nThen choose the word that matches.", {
                        "fontFamily": "Kids Rock DEMO",
                        "fontSize": 30,
                        "color": "#43425D",
                        "align": 'center'
                    });
                    this.instrTxt.setOrigin(0.5, 0.5);
                    this._btnSoundInstruction = new Phaser.GameObjects.Image(this.scene, 800 - 105, 156 - 50, 'Sound');
                    this._btnSoundInstruction.setInteractive({ cursor: 'pointer' });
                    this._btnSoundInstruction.on('pointerup', onSndClick);
                    setupButtonTextureBased(this._btnSoundInstruction, 'Sound', 'Sound HOVER EFFECT');
                    this.add(this._instructionPage);
                    this.add(this._instructionPageTitle);
                    this.add(this.instrTxt);
                    this.add(this._btnPlay);
                    this.add(this._btnSoundInstruction);
                }
            }

            screen.InstructionPage = InstructionPage;
        })(screen = garage.screen || (garage.screen = {}));
    })(garage || (garage = {}));

    (function (garage) {
        var screen;
        (function (screen) {
            class TryAgainWindow extends Phaser.GameObjects.Container {
                constructor(scene, onBack, onReplay) {
                    super(scene);
                    this.music = null;
                    this.setPosition(-106, -48);
                    this._bg = new Phaser.GameObjects.Image(this.scene, 0, 0, 'Try again page');
                    this._bg.setOrigin(0, 0);
                    this._bg.setInteractive();
                    this._star = new Phaser.GameObjects.Image(this.scene, 400, 415, 'Break Star');
                    this._btnBack = new Phaser.GameObjects.Image(this.scene, 600, 580, 'btnBACK1');
                    this._btnReplay = new Phaser.GameObjects.Image(this.scene, 765, 580, 'btnReplay1');
                    this.totalScoreTxt = this.scene.add.text(830, 355, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 35,
                        "color": "#F49F1C",
                        "align": 'center',
                        'stroke': '#70451A',
                        'strokeThickness': 6
                    });
                    this.totalScoreTxt.setOrigin(0.5, 0.5);
                    let grd = this.totalScoreTxt.context.createLinearGradient(0, 0, 0, this.totalScoreTxt.height);
                    grd.addColorStop(0, '#FFFF00');
                    grd.addColorStop(1, '#C17316');
                    this.totalScoreTxt.setFill(grd);
                    this.starScoreTxt = this.scene.add.text(635, 431, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 24,
                        "color": "#FFFFFF",
                        "align": 'center'
                    });
                    this.starScoreTxt.setOrigin(0.5, 0.5);
                    this.add([
                        this._bg,
                        this._star,
                        this._btnBack,
                        this._btnReplay,
                        this.totalScoreTxt,
                        this.starScoreTxt
                    ]);
                    this._btnBack.setInteractive({ cursor: 'pointer' });
                    this._btnBack.on('pointerup', () => {
                        onBack(this._btnBack);
                        window.angularComponentRef.backToMenu();
                        // if (this.music) {
                        //     this.music.stop();
                        // }
                    });
                    setupButtonTextureBased(this._btnBack, 'btnBACK1', 'btnBACK2');
                    this._btnReplay.setInteractive({ cursor: 'pointer' });
                    this._btnReplay.once('pointerup', () => {
                        onReplay(this._btnReplay);
                        if (this.music) {
                            this.music.stop();
                        }
                    });
                    setupButtonTextureBased(this._btnReplay, 'btnReplay1', 'btnReplay2');
                }

                show(score, starScore) {
                    this._star.scale = 1.25;
                    this.scene.tweens.add({
                        targets: this._star,
                        "scale": 1,
                        duration: 500,
                        ease: Phaser.Math.Easing.Back.Out
                    });
                    this.totalScoreTxt.text = String(window.angularComponentRef.component.userInfo.totalScore);
                    this.starScoreTxt.text = String(0);
                    this.music = this.scene.sound.add("Fail - close one");
                    this.music.play();
                }
            }

            screen.TryAgainWindow = TryAgainWindow;
        })(screen = garage.screen || (garage.screen = {}));
    })(garage || (garage = {}));

    game = new garage.App(json);
};

function destroyCarRepair() {
    if (game) {
        game.destroy();
        game = null;
    }
}

var trainGame;
var game;

var loadTrain = (json) => {
    (function (trainGame) {
        class App extends Phaser.Game {
            constructor(json) {
                App.json = json;
                let config = {
                    type: Phaser.AUTO,
                    width: App.CANVAS_WIDTH,
                    height: App.CANVAS_HEIGHT,
                    parent: 'game-container',
                    dom: {
                        createContainer: false
                    },
                    scale: {
                        mode: FitScaleManager.detectBestScaleMode(),
                        autoCenter: Phaser.Scale.CENTER_BOTH
                    },
                    transparent: true,
                    scene: {
                        create: () => {
                            this.scene.add('Boot', trainGame.scene.Boot, true);
                        }
                    }
                };
                super(config);
            }
        }

        App.CANVAS_WIDTH = 980;
        App.CANVAS_HEIGHT = 600;
        trainGame.App = App;
    })(trainGame || (trainGame = {}));

    var delayedCalls = [];

    function delayedCall(delay, callback, args, callbackScope) {
        let scene = game.scene.getAt(0);
        if (scene) {
            let dc = scene.time.delayedCall(delay, callback, args, callbackScope);
            delayedCalls.push(dc);
            return dc;
        }
        let t = setTimeout(callback, delay);
        delayedCalls.push(t);
        return t;
    }

    function pauseAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.paused = true;
            }
        }
    }

    function resumeAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.paused = false;
            }
        }
    }

    function destroyAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.remove(false);
            } else {
                clearTimeout(dc);
            }
        }
        delayedCalls = [];
    }

    function setPageBackground(bg) {
        document.querySelector("html").style.backgroundImage = "url(assets/games/load-train/imgs/" + bg + ".jpg)";
    }

    function setupButton(btn, frame) {
        btn.on('pointerdown', () => {
            btn.setFrame(frame + '_hover' + '0000');
        });
        btn.on('pointerover', () => {
            btn.setFrame(frame + '_hover' + '0000');
            game.scene.getAt(0).sound.add("button hover").play();
        });
        btn.on('pointerout', () => {
            btn.setFrame(frame + '0000');
        });
        btn.on('pointerup', () => {
            btn.setFrame(frame + '0000');
            game.scene.getAt(0).sound.add('activity selection - button selection').play();
        });
    }

    function setupButtonTextureBased(btn, texture, hoverTexture) {
        btn.on('pointerdown', () => {
            btn.setTexture(hoverTexture);
        });
        btn.on('pointerover', () => {
            btn.setTexture(hoverTexture);
            game.scene.getAt(0).sound.add("button hover").play();
        });
        btn.on('pointerout', () => {
            btn.setTexture(texture);
        });
        btn.on('pointerup', () => {
            btn.setTexture(texture);
            game.scene.getAt(0).sound.add('activity selection - button selection').play();
        });
    }

    function playBtnClickAnim(target) {
        let sc = target.hasOwnProperty("defScale") ? target["defScale"] : 1;
        target.scaleX = target.scaleY = sc;
        let scene = game.scene.getAt(0);
        scene.tweens.add({
            targets: target,
            "scaleX": 0.9 * sc,
            "scaleY": 0.9 * sc,
            duration: 100,
            yoyo: true
        });
    }

    /**
     * @author Roman Parada
     * This class is created to fix overlapping of bottom part of canvas by navigation bar in iOS.
     * It make a delayed resize of the canvas (like Phaser-3 FIT methods does) and it overrides Phaser-3 input window to Phaser-3 core transform methods
     *
     * How to use:
     * Just call the code line below in Boot scene's init() method of your project:
     * new FitScaleManager(this.game).setup();
     */
    class FitScaleManager {
        constructor(game) {
            this.doResize = () => {
                let scale = this.calculateScale();
                let newCanvasWidth = this.phaserScaleManager.width * scale;
                let newCanvasHeight = this.phaserScaleManager.height * scale;
                this.canvasStyle.width = newCanvasWidth + 'px';
                this.canvasStyle.height = newCanvasHeight + 'px';
                this.canvasStyle.marginLeft = (window.innerWidth - newCanvasWidth) / 2 + 'px';
                this.canvasStyle.marginTop = (window.innerHeight - newCanvasHeight) / 2 + 'px';
            };
            this.game = game;
            this.canvasStyle = this.game.canvas.style;
            this.phaserScaleManager = this.game.scale;
        }

        static detectBestScaleMode() {
            let iOS = /iPad|iPhone|iPod/.test(navigator.platform || "");
            let isAndroid = window.navigator.userAgent.toLowerCase().indexOf("android") > -1;
            return iOS || isAndroid ? Phaser.Scale.FIT : Phaser.Scale.NONE;
        }
        ;

        /**
         * Just call this method once in Boot scene's init() method
         */
        setup() {
            this.phaserScaleManager.addListener(Phaser.Scale.Events.RESIZE, this.onResize, this);
            this.overridePhaserTransformMethods();
            this.onResize();
        }

        calculateScale() {
            if (game.scale.scaleMode == Phaser.Scale.NONE)
                return 1;
            return Math.min(window.innerWidth / this.phaserScaleManager.width, window.innerHeight / this.phaserScaleManager.height);
        }

        overridePhaserTransformMethods() {
            this.game.scale.transformX = (pageX) => {
                return (pageX - parseInt(this.canvasStyle.marginLeft.split("px")[0])) / this.calculateScale();
            };
            this.game.scale.transformY = (pageY) => {
                return (pageY - parseInt(this.canvasStyle.marginTop.split("px")[0])) / this.calculateScale();
            };
        }

        onResize() {
            setTimeout(this.doResize, FitScaleManager.RESIZE_DELAY);
        }
    }

    FitScaleManager.RESIZE_DELAY = 500;

    /* Gameplay */
    (function (trainGame) {
        var core;
        (function (core) {
            class Gameplay {
                constructor() {
                    this.allLettersNames = null;
                    this.failsNumToLose = 3;
                    this.currentRound = 0;
                    this.correctAnswersCount = 0;
                    this.wrongAnswersCount = 0;
                    this.correctAnswersCountThisRound = 0;
                    this.wrongAnswersCountThisRound = 0;
                    this.onNewRound = null;
                    this.nextLetterDelay = 0;
                    this.failsNumToLose = Number(game.cache.json.get('gameplay')["failsNumToLose"]);
                    this.useImages = Boolean(game.cache.json.get('gameplay')["useImages"]);
                }

                setupCallbacks(onComplete, onLose, onNewRound) {
                    this.onComplete = onComplete;
                    this.onLose = onLose;
                    this.onNewRound = onNewRound;
                }

                onLetterChosen() {
                    this.currentRound++;
                    if (this.correctAnswersCount >= this.totalRoundsNum) {
                        this.onComplete(this.correctAnswersCount, this.correctAnswersCount);
                        return true;
                    } else {
                        this.nextLetter();
                    }
                    return false;
                }

                nextLetter() {
                    let fn = () => {
                        this.randomize();
                        this.correctAnswersCountThisRound = 0;
                        this.wrongAnswersCountThisRound = 0;
                        if (this.onNewRound)
                            this.onNewRound();
                    };
                    if (this.nextLetterDelay == 0) {
                        fn();
                    } else {
                        delayedCall(this.nextLetterDelay, fn);
                    }
                }

                readWord(word) {
                    let d = 1400;
                    delayedCall(d, () => {
                        game.scene.getScene('ScreenMain').sound.add(word).play();
                    });
                    return 6500;
                }

                getCorrectLetterName(index) {
                    return this.roundLetterNames[index];
                }

                getCorrectAudioKey(index) {
                    return this.lettersAudioKeys[index];
                }

                onCorrectAnswer() {
                    this.correctAnswersCount++;
                    this.correctAnswersCountThisRound++;
                    this.nextLetterDelay = this.readWord(this.correctWord);
                    return this.onLetterChosen();
                }

                onWrongAnswer() {
                    this.wrongAnswersCount++;
                    this.wrongAnswersCountThisRound++;
                    this.nextLetterDelay = 1000;
                    if (this.wrongAnswersCount >= this.failsNumToLose) {
                        this.onLose(0, 0);
                        return true;
                    } else {
                        console.log('Wrong letter chosen');
                        // this.onLetterChosen();
                    }
                    return false;
                }

                getCurrentTotalAnswersCount() {
                    return this.correctAnswersCount + this.wrongAnswersCount;
                }

                getCurrentTotalAnswersCountThisRound() {
                    return this.correctAnswersCountThisRound + this.wrongAnswersCountThisRound;
                }

                isNewRound() {
                    return this.getCurrentTotalAnswersCountThisRound() == 0;
                }

                isRoundsComplete() {
                    return this.currentRound >= this.totalRoundsNum;
                }

                randomize() {
                    let round = this.rounds[this.currentRound];
                    this.correctWord = round["correctWord"];
                    if (this.wordsLetters === undefined) {
                        this.roundLetterNames = this.correctWord.split("");
                    } else {
                        this.roundLetterNames = this.wordsLetters[this.correctWord];
                    }
                    this.roundLetterNames = this.roundLetterNames.reverse();
                    this.lettersAudioKeys = [];
                    for (let i = 0; i < this.roundLetterNames.length; i++) {
                        this.lettersAudioKeys.push(this.getAudioKeyOfChar(this.roundLetterNames[i]));
                    }
                    this.roundWords = Phaser.Utils.Array.Shuffle([this.correctWord, round["wrongWord1"], round["wrongWord2"]]);
                }

                getAudioKeyOfChar(letter) {
                    let json = game.cache.json.get('gameplay');
                    let letters = json["letters"];
                    for (let d of letters) {
                        if (letter == d['letterName']) {
                            return d['audioKey'];
                        }
                    }
                    return null;
                }

                reset() {
                    this.setupCallbacks(null, null, null);
                    this.correctWord = null;
                    let json = JSON.parse(JSON.stringify(game.cache.json.get('gameplay')));

                    this.wordsLetters = json["wordsLetters"];

                    this.letters = json["letters"].slice();
                    this.allLettersNames = [];
                    for (let d of this.letters)
                        this.allLettersNames.push(d["letterName"]);
                    this.rounds = JSON.parse(JSON.stringify(json["rounds"]));
                    this.totalRoundsNum = this.rounds.length;
                    this.currentRound = 0;
                    this.correctAnswersCount = 0;
                    this.wrongAnswersCount = 0;
                    this.correctAnswersCountThisRound = 0;
                    this.wrongAnswersCountThisRound = 0;
                    this.nextLetterDelay = 0;
                    this.nextLetter();
                }
            }

            core.Gameplay = Gameplay;
        })(core = trainGame.core || (trainGame.core = {}));
    })(trainGame || (trainGame = {}));

    /* Boot */
    (function (trainGame) {
        var scene;
        (function (scene) {
            class Boot extends Phaser.Scene {
                init() {
                    this.game.scale.transformX = (pageX) => {
                        let offsetLeft = 0;
                        let parentElement = game.canvas.parentElement;
                        while (parentElement) {
                            if (parentElement.offsetLeft) {
                                offsetLeft = parentElement.offsetLeft;
                                break;
                            }
                            parentElement = parentElement.parentElement;
                        }
                        return (pageX - offsetLeft) * this.game.scale.displayScale.x;
                    };
                    this.game.scale.transformY = (pageY) => {
                        let offsetTop = 0;
                        let parentElement = game.canvas.parentElement;
                        while (parentElement) {
                            if (parentElement.offsetTop) {
                                offsetTop = parentElement.offsetTop;
                                break;
                            }
                            parentElement = parentElement.parentElement;
                        }
                        return (pageY - offsetTop) * this.game.scale.displayScale.y;
                    };
                }

                create() {
                    game.scene.remove('Boot');
                    game.scene.add('Preloader', trainGame.scene.Preloader, true);
                }
            }

            scene.Boot = Boot;
        })(scene = trainGame.scene || (trainGame.scene = {}));
    })(trainGame || (trainGame = {}));

    /* Preloader */
    (function (trainGame) {
        var scene;
        (function (scene) {
            class Preloader extends Phaser.Scene {
                preload() {
                    if (typeof trainGame.App.json == "string") this.load.json('gameplay', trainGame.App.json); else this.game.cache.json.add('gameplay', trainGame.App.json);
                }

                create() {
                    let json = game.cache.json.get('gameplay');
                    let words = json["words"];
                    if (json["useImages"]) {
                        let rounds = JSON.parse(JSON.stringify(json["rounds"]));
                        for (let i = 0; i < rounds.length; i++) {
                            let w = rounds[i];
                            this.load.image(w.correctWord, "assets/games/load-train/imgs/words/" + w.correctWord + ".png");
                            this.load.image(w.wrongWord1, "assets/games/load-train/imgs/words/" + w.wrongWord1 + ".png");
                            this.load.image(w.wrongWord2, "assets/games/load-train/imgs/words/" + w.wrongWord2 + ".png");
                        }
                        for (let l of json["letters"]) {
                            this.load.image(l["letterName"], "assets/games/load-train/imgs/letters/" + l["letterName"] + ".png");
                        }
                    }
                    for (let l of json["letters"]) {
                        this.load.audio(l["audioKey"], "assets/games/load-train/sound/mp3/letters/" + l["audioKey"] + ".mp3");
                    }
                    for (let w of words) {
                        this.load.audio(w, "assets/games/load-train/sound/mp3/words/" + w + ".mp3");
                    }
                    this.load.pack('preloader', 'assets/games/load-train/pack.json');
                    let progressTxt = this.add.text(game.scale.width / 2, game.scale.height / 2 + 50, "", {
                        "fontFamily": "QuranErafont",
                        "fontSize": 25,
                        "color": "#000000",
                        "align": 'center'
                    });
                    this.load.on('progress', (value) => {
                        progressTxt.text = Math.ceil(value * 100) + "%";
                    }, this);
                    this.load.on('complete', () => {
                        this.nextScene();
                    });
                    this.load.start();
                }

                static playAnim(animKey, sprite, onComplete = null) {
                    let mainScene = game.scene.getScene('ScreenMain');
                    if (!mainScene.anims.exists(animKey)) {
                        let data = Preloader.ANIMS_DATA[animKey];
                        mainScene.anims.create({
                            key: animKey,
                            frames: mainScene.anims.generateFrameNames(data['atlas'], {
                                start: data['start'], end: data['end'], zeroPad: data['padNum'],
                                prefix: data['prefix'], suffix: data['suffix'] || ''
                            }),
                            frameRate: data['frameRate'],
                            repeat: data['repeat']
                        });
                    }
                    if (sprite.anims.currentAnim) {
                        sprite.anims.currentAnim.off('complete');
                    }
                    sprite.anims.stop();
                    sprite.play(animKey);
                    sprite.anims.currentAnim.once('complete', () => {
                        if (onComplete)
                            onComplete();
                    });
                    return sprite;
                }

                nextScene() {
                    game.scene.remove('Preloader');
                    game.scene.add('ScreenMain', trainGame.scene.MainScene, true);
                }
            }

            Preloader.ANIMS_DATA = {
                'horse-iddle': {
                    'start': 1,
                    'end': 48,
                    'padNum': 4,
                    'prefix': 'iddle',
                    'suffix': '.png',
                    'repeat': -1,
                    'frameRate': 24,
                    'atlas': 'horse-iddle-atlas'
                },
                'horse-yes': {
                    'start': 1,
                    'end': 72,
                    'padNum': 4,
                    'prefix': 'Yes v4 ',
                    'suffix': '.png',
                    'repeat': 0,
                    'frameRate': 24,
                    'atlas': 'horse-yes-atlas'
                },

                'train-stop': {
                    'start': 1,
                    'end': 1,
                    'padNum': 4,
                    'prefix': 'Train looping ',
                    'suffix': '.png',
                    'repeat': -1,
                    'frameRate': 24,
                    'atlas': 'train-atlas'
                },

                'train-moving': {
                    'start': 1,
                    'end': 16,
                    'padNum': 4,
                    'prefix': 'Train looping ',
                    'suffix': '.png',
                    'repeat': -1,
                    'frameRate': 24,
                    'atlas': 'train-atlas'
                },

                'smoke-off': {
                    'start': 1,
                    'end': 16,
                    'padNum': 4,
                    'prefix': 'Smoke off ',
                    'suffix': '.png',
                    'repeat': 0,
                    'frameRate': 24,
                    'atlas': 'smoke-off-atlas'
                },

                'smoke': {
                    'start': 1,
                    'end': 36,
                    'padNum': 4,
                    'prefix': 'Smoke looping on the way ',
                    'suffix': '.png',
                    'repeat': -1,
                    'frameRate': 24,
                    'atlas': 'smoke-atlas'
                },
            };
            scene.Preloader = Preloader;
        })(scene = trainGame.scene || (trainGame.scene = {}));
    })(trainGame || (trainGame = {}));

    /* MainScene */
    (function (trainGame) {
        var scene;
        (function (scene) {
            var Gameplay = trainGame.core.Gameplay;

            class MainScene extends Phaser.Scene {
                create() {
                    this.gameplay = new Gameplay();
                    this.gameplayScreen = new trainGame.screen.GameplayScreen(this, this.gameplay);
                    this.children.add(this.gameplayScreen);
                    this.gameplayScreen.showInstructionPage();
                }
            }

            scene.MainScene = MainScene;
        })(scene = trainGame.scene || (trainGame.scene = {}));
    })(trainGame || (trainGame = {}));

    /* Small Claw */
    (function (trainGame) {
        var screen;
        (function (screen) {
            class SmallClaw extends Phaser.GameObjects.Container {
                constructor(scene, gameplayScreen, buttonIndex) {
                    super(scene);
                    this.buttonIndex = buttonIndex;
                    this.gameplayScreen = gameplayScreen;
                    this.boxDropped = false;

                    this.clawClosed = new Phaser.GameObjects.Image(this.scene, 0, 0, 'claw-closed');
                    this.add(this.clawClosed);

                    this.clawOpen = new Phaser.GameObjects.Image(this.scene, 0, 5, 'claw-open');
                    this.add(this.clawOpen);

                    this.smallBox = new screen.SmallBox(scene, gameplayScreen, buttonIndex);
                    this.smallBox.setPosition(0, 110);
                    this.add(this.smallBox);

                    this.dropButton = new Phaser.GameObjects.Image(this.scene, -1.5, 23, 'drop-button');
                    this.dropButton.disableInteractive();
                    this.dropButton["defScale"] = this.dropButton.scale;
                    setupButtonTextureBased(this.dropButton, 'drop-button', 'drop-button-hover');
                    this.dropButton.on('pointerup', () => {
                        this.dropBox();
                    });
                    this.add(this.dropButton);

                    this._HandIcon = this.scene.add.image(10, 67, 'Hand Icon');
                    this._HandIcon.setOrigin(0, 1);
                    this._HandIcon.scale = 0.5;
                    this._HandIcon.visible = true;
                    this.add(this._HandIcon);
                }

                dropBox() {
                    this.reset();

                    delayedCall(500, () => this.smallBox.playAudio());
                    let _dy = (this.smallBox.box.scaleY-1)/2*this.smallBox.box.height;
                    this.scene.tweens.add({
                        targets: this.smallBox,
                        y: 349 - _dy,
                        duration: 900,
                        ease: Phaser.Math.Easing.Bounce.Out,
                        onComplete: () => {
                            this.boxDropped = true;
                            this.gameplayScreen.trainContainer.add(this.smallBox);
                            this.smallBox.setPosition(this.x, this.y + 349 - _dy);
                            this.gameplayScreen.onSmallBoxDropped(this.smallBox.boxIndex);
                            this.smallBox._setInteractive();
                        }
                    });

                    delayedCall(300, () => {
                        this.clawClosed.visible = true;
                        this.clawOpen.visible = false;
                        this.scene.sound.add("Box falling").play();
                    });
                }

                reset() {
                    this.boxDropped = false;
                    this.add(this.smallBox);
                    let _dy = (this.smallBox.box.scaleY-1)/2*this.smallBox.box.height;
                    this.smallBox.setPosition(0, 110 + _dy);
                    this.clawClosed.visible = false;
                    this.clawOpen.visible = true;
                    this.smallBox.reset();
                    this.hideHandIcon();
                }

                showHandIconAnim() {
                    this.dropButton.setInteractive({ cursor: 'pointer', pixelPerfect: true });
                    this._HandIcon.visible = true;
                    this._HandIcon.angle = 0;
                    this._t = this.scene.tweens.add({
                        targets: this._HandIcon,
                        "angle": 10,
                        yoyo: true,
                        repeat: -1,
                        duration: 500
                    });
                }

                hideHandIcon() {
                    this.dropButton.disableInteractive();
                    this._HandIcon.visible = false;
                    if (this._t) this.scene.tweens.remove(this._t);
                    this._t = null;
                }
            }

            screen.SmallClaw = SmallClaw;
        })(screen = trainGame.screen || (trainGame.screen = {}));
    })(trainGame || (trainGame = {}));

    /* Small Box */
    (function (trainGame) {
        var screen;
        (function (screen) {
            class SmallBox extends Phaser.GameObjects.Container {
                constructor(scene, gameplayScreen, boxIndex) {
                    super(scene);
                    this.gameplayScreen = gameplayScreen;
                    this.boxIndex = boxIndex;

                    this.box = new Phaser.GameObjects.Image(this.scene, 0, 0, 'small-box');
                    this.box.setInteractive({ cursor: 'pointer' });
                    this.box.scaleY =  game.cache.json.get('gameplay')["smallBoxScaleY"] ?? 1.25;
                    this.box["defScale"] = this.box.scale;
                    setupButtonTextureBased(this.box, 'small-box', 'small-box-hover');
                    this.box.on('pointerup', () => {
                        this.playAudio();
                    });
                    this.add(this.box);

                    if (this.gameplayScreen.gameplay.useImages) {
                        this.wordText = new Phaser.GameObjects.Image(this.scene, 0, 0, null);
                        this.add(this.wordText);
                    } else {
                        this.wordText = this.scene.add.text(0, 0, "", {
                            "fontFamily": "QuranErafont",
                            "fontSize": 100,
                            "color": "#000000",
                            "align": 'center',
                            'stroke': '#FFFFFF',
                            'strokeThickness': 7
                        });
                        this.wordText.setOrigin(0.5, 0.5);
                        this.wordText.style.fixedHeight = 150;
                        this.add(this.wordText);
                    }
                }

                playAudio() {
                    this.gameplayScreen.playCorrectAudio(this.boxIndex);
                }

                setup(letter) {
                    this.letter = letter;
                    if (this.gameplayScreen.gameplay.useImages) {
                        this.wordText.setTexture(this.letter);
                        this.wordText.setScale(0.8);
                    } else {
                        this.wordText.setText(this.letter);
                    }
                    this._disableInteractive();
                }

                _setInteractive() {
                    this.box.setInteractive({ cursor: 'pointer' });
                }

                _disableInteractive() {
                    this.box.disableInteractive();
                }

                reset() {
                }
            }

            screen.SmallBox = SmallBox;
        })(screen = trainGame.screen || (trainGame.screen = {}));
    })(trainGame || (trainGame = {}));

    /* Big Claw */
    (function (trainGame) {
        var screen;
        (function (screen) {
            class BigClaw extends Phaser.GameObjects.Container {
                constructor(scene, gameplayScreen, clawIndex) {
                    super(scene);
                    this.clawIndex = clawIndex;
                    this.gameplayScreen = gameplayScreen;

                    this.claw = new Phaser.GameObjects.Image(this.scene, 0, 0, 'big-claw');
                    this.add(this.claw);

                    this.bigBox = new screen.BigBox(scene, gameplayScreen, clawIndex);
                    this.bigBox.setPosition(0, 80);
                    this.add(this.bigBox);
                }

                setInitialPosition(x, y) {
                    this.initialPosition = { x: x, y: y };
                    this.setPosition(x, y);
                }

                dropBox(onCompleteCallback) {
                    this.add(this.bigBox);
                    this.bigBox.setPosition(0, 80);

                    this.scene.tweens.add({
                        targets: this.bigBox,
                        y: 298,
                        duration: 950,
                        ease: Phaser.Math.Easing.Bounce.Out,
                        onComplete: () => {
                            this.gameplayScreen.trainContainer.add(this.bigBox);
                            this.bigBox.setPosition(125, 382);
                            if (onCompleteCallback) onCompleteCallback();
                        }
                    });
                    delayedCall(400, () => {
                        this.scene.sound.add("Box falling").play();
                    });
                }

                reset() {
                    this.setPosition(this.initialPosition.x, this.initialPosition.y);
                    this.add(this.bigBox);
                    this.bigBox.setPosition(0, 80);
                    this.bigBox.reset();
                }
            }

            screen.BigClaw = BigClaw;
        })(screen = trainGame.screen || (trainGame.screen = {}));
    })(trainGame || (trainGame = {}));

    /* Big Box */
    (function (trainGame) {
        var screen;
        (function (screen) {
            class BigBox extends Phaser.GameObjects.Container {
                constructor(scene, gameplayScreen, boxIndex) {
                    super(scene);
                    this.gameplayScreen = gameplayScreen;
                    this.boxIndex = boxIndex;

                    this.box = new Phaser.GameObjects.Image(this.scene, 0, 0, 'big-box');
                    this.box.setInteractive({ cursor: 'pointer' });
                    this.box["defScale"] = this.box.scale;
                    setupButtonTextureBased(this.box, 'big-box', 'big-box');
                    this.box.on('pointerup', () => {
                        this.gameplayScreen.onBigBoxClicked(this.boxIndex);
                    });
                    this.add(this.box);

                    this.boxOverlayGreen = new Phaser.GameObjects.Image(this.scene, 0, 0, 'big-box-green');
                    this.boxOverlayGreen.visible = false;
                    this.add(this.boxOverlayGreen);

                    this.boxOverlayRed = new Phaser.GameObjects.Image(this.scene, 0, 0, 'big-box-red');
                    this.boxOverlayRed.visible = false;
                    this.add(this.boxOverlayRed);

                    if (this.gameplayScreen.gameplay.useImages) {
                        this.wordText = new Phaser.GameObjects.Image(this.scene, 0, 0, null);
                        this.add(this.wordText);
                    } else {
                        this.wordText = this.scene.add.text(0, 0, "", {
                            "fontFamily": "QuranErafont",
                            "fontSize": 100,
                            "color": "#000000",
                            "align": 'center',
                            'stroke': '#FFFFFF',
                            'strokeThickness': 7
                        });
                        this.wordText.setOrigin(0.5, 0.5);
                        this.wordText.style.fixedHeight = 150;
                        this.add(this.wordText);
                    }
                }

                setup(word, isCorrect) {
                    this.word = word;
                    this.isCorrect = isCorrect;
                    if (this.gameplayScreen.gameplay.useImages) {
                        this.wordText.setTexture(word);
                        this.wordText.setScale(1.0);
                    } else {
                        this.wordText.setText(this.word);
                    }

                    this.reset();
                }

                turnGreen() {
                    this.boxOverlayGreen.visible = true;
                    this.boxOverlayRed.visible = false;
                    this._disableInteractive();
                }

                turnRed() {
                    this.boxOverlayGreen.visible = false;
                    this.boxOverlayRed.visible = true;
                    this._disableInteractive();
                }

                _setInteractive() {
                    this.box.setInteractive({ cursor: 'pointer' });
                }

                _disableInteractive() {
                    this.box.disableInteractive();
                }

                reset() {
                    this.boxOverlayGreen.visible = false;
                    this.boxOverlayRed.visible = false;
                    this._setInteractive();
                }
            }

            screen.BigBox = BigBox;
        })(screen = trainGame.screen || (trainGame.screen = {}));
    })(trainGame || (trainGame = {}));

    /* Gameplay Screen */
    (function (trainGame) {
        var screen;
        var Preloader = trainGame.scene.Preloader;
        (function (screen) {
            class GameplayScreen extends Phaser.GameObjects.Container {
                constructor(scene, gameplay) {
                    super(scene);
                    this.bgMusic = null;
                    this.firstTallyDefPos = { x: 60, y: 565 };
                    this.soundGooseYes = null;
                    this.soundGooseNo = null;
                    this.correctAudio = null;
                    this.wfsnd = null;
                    this.showCompleteWindow = (score, starScore) => {
                        let completeWindow = new screen.CompleteWindow(this.scene, (target) => {
                            playBtnClickAnim(target);
                        }, (target) => {
                            playBtnClickAnim(target);
                            this.destroyGameplay();
                            this.remove(completeWindow);
                            this.showInstructionPage();
                        }, (target) => {
                            playBtnClickAnim(target);
                        });
                        delayedCall(10000, () => {
                            setPageBackground("bg-blue");
                            this.add(completeWindow);
                            completeWindow.show(score, starScore);
                            this.bgMusic.stop();
                        });
                    };
                    this.showLoseWindow = (score, starScore) => {
                        let tryAgainWindow = new screen.TryAgainWindow(this.scene, (target) => {
                            playBtnClickAnim(target);
                        }, (target) => {
                            playBtnClickAnim(target);
                            this.destroyGameplay();
                            this.remove(tryAgainWindow);
                            this.showInstructionPage();
                        });
                        delayedCall(750, () => {
                            setPageBackground("bg-blue");
                            this.add(tryAgainWindow);
                            tryAgainWindow.show(score, starScore);
                            this.bgMusic.stop();
                        });
                    };
                    this.gameplay = gameplay;
                    window["gs"] = this;
                }

                showGameplay() {
                    setPageBackground("bg-australia");
                    this.bgMusic = this.scene.sound.add("Bachground ambience");
                    this.bgMusic.play();
                    this.bgMusic.loop = true;

                    this.gameplayContainer = new Phaser.GameObjects.Container(this.scene);
                    this.add(this.gameplayContainer);

                    this._gameStage = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2, game.scale.height / 2, 'BG');
                    this._gameStage.setOrigin(0.5, 0.5);
                    this._gameStage.setInteractive();
                    this.gameplayContainer.add(this._gameStage);

                    /* init gameplay */
                    this.gameplay.reset();

                    /* train and horse */
                    this.trainContainer = new Phaser.GameObjects.Container(this.scene);
                    this.gameplayContainer.add(this.trainContainer);

                    this.smoke = this.scene.add.sprite(0, 0, 'smoke');
                    this.smoke.setOrigin(0, 0);
                    this.trainContainer.add(this.smoke);
                    Preloader.playAnim('smoke', this.smoke);

                    this.train = this.scene.add.sprite(0, 0, 'train-atlas', 'Train looping 0001.png');
                    this.train.setOrigin(0, 0);
                    this.trainContainer.add(this.train);
                    Preloader.playAnim('train-stop', this.train);

                    this.horse = this.scene.add.sprite(0, 0, 'horse-iddle-atlas', 'iddle0001.png');
                    this.horse.setOrigin(0, 0);
                    this.trainContainer.add(this.horse);
                    Preloader.playAnim('horse-iddle', this.horse);

                    /* small claws */
                    this.smallClawsContainer = new Phaser.GameObjects.Container(this.scene);
                    this.gameplayContainer.add(this.smallClawsContainer);

                    this.smallClaws = [];
                    for (let i = 0; i < 3; i++) {
                        const claw = new screen.SmallClaw(this.scene, this, i);
                        claw.setPosition(313 + i * 137, 80);
                        this.smallClawsContainer.add(claw);
                        this.smallClaws.push(claw);
                        claw.reset();
                    }

                    /* Big Claws */

                    this.bigClawsContainer = new Phaser.GameObjects.Container(this.scene);
                    this.gameplayContainer.add(this.bigClawsContainer);

                    this.bigClaws = [];
                    for (let i = 0; i < 3; i++) {
                        const claw = new screen.BigClaw(this.scene, this, i);
                        claw.setInitialPosition(200 + i * 250, 85);
                        this.bigClawsContainer.add(claw);
                        this.bigClaws.push(claw);
                        claw.reset();
                    }

                    /* UI buttons */
                    this._btnClose = new Phaser.GameObjects.Image(this.scene, 932, 47, 'x Button');
                    this._btnClose.setInteractive({ cursor: 'pointer' });
                    this._btnClose["defScale"] = this._btnClose.scale;
                    setupButtonTextureBased(this._btnClose, 'x Button', 'x Button HOVER EFFECT');
                    this.gameplayContainer.add(this._btnClose);

                    this._btnSound = new Phaser.GameObjects.Image(this.scene, 52, 47, 'Sound');
                    this._btnSound.setInteractive({ cursor: 'pointer' });
                    this._btnSound["defScale"] = this._btnSound.scale;
                    setupButtonTextureBased(this._btnSound, 'Sound', 'Sound HOVER EFFECT');
                    this.gameplayContainer.add(this._btnSound);

                    this._btnClose.on('pointerup', () => {
                        playBtnClickAnim(this._btnClose);
                        this.onCloseClick();
                    });
                    this._btnSound.on('pointerup', () => {
                        playBtnClickAnim(this._btnSound);
                        this.scene.sound.play("Load the Train - Question Audio");
                    });

                    this.gameplay.setupCallbacks(this.showCompleteWindow, this.showLoseWindow, () => {
                        this.onNewRound(true);
                    });

                    this.tallies = [];
                    this.talliesContainer = new Phaser.GameObjects.Container(this.scene);
                    this.talliesContainer.setPosition(30, 565);
                    this.add(this.talliesContainer);

                    this.tallyBar = this.scene.add.image(0, 0, 'tally-bar');
                    this.tallyBar.setOrigin(0, 0.5);
                    this.tallyBar.scaleX = 1.36;
                    this.talliesContainer.add(this.tallyBar);

                    for(let i = 0; i < this.gameplay.totalRoundsNum+this.gameplay.failsNumToLose; i++) {
                        const tally = this.scene.add.image(25 + i * 40, 0, 'tally-correct');
                        this.tallies.push(tally);
                        this.talliesContainer.add(tally);
                    }

                    /* launch round */
                    this.startRound();
                }

                updateTalliesVisibility() {
                    this.tallies.forEach(tally => tally.visible = false);
                    for (let i = 0; i < this.gameplay.getCurrentTotalAnswersCount(); i++) {
                        this.tallies[i].visible = true;
                    }
                }

                startRound() {
                    if (this.gameplay.isRoundsComplete()) {
                        return;
                    }
                    this.resetAll();
                    this.smallClaws.forEach(claw => claw.smallBox.setup(this.gameplay.roundLetterNames[claw.smallBox.boxIndex]));
                    this.bigClaws.forEach(claw => claw.bigBox.setup(this.gameplay.roundWords[claw.bigBox.boxIndex], this.gameplay.roundWords[claw.bigBox.boxIndex] == this.gameplay.correctWord));

                    this.updateTalliesVisibility();

                    this.playTrainArrivingAnim(() => {
                        this.playSmallClawsAppearingAnim(() => {
                            this.smallClaws[2].showHandIconAnim();
                        });
                    });
                }

                resetAll() {
                    this.smallClawsContainer.visible = false;
                    this.bigClawsContainer.visible = false;
                    this.trainContainer.x = -1000;
                    this.smallClaws.forEach(claw => claw.reset());
                    this.bigClaws.forEach(claw => claw.reset());
                }

                onBigBoxClicked(boxIndex) {
                    const clickedBox = this.bigClaws[boxIndex].bigBox;
                    if (clickedBox.isCorrect) {
                        clickedBox.turnGreen();
                        this.onCorrectAnswer();
                        this.bigClaws.forEach(claw => claw.bigBox._disableInteractive());
                        this.playBigClawsCorrectSelectionAnim(boxIndex, () => {
                            delayedCall(1000, () => {
                                this.playHorseYesAnim();
                                delayedCall(3000, () => {
                                    this.playTrainDepartureAnim(() => {
                                    });
                                });
                            });
                        });

                    } else {
                        clickedBox.turnRed();
                        this.onWrongAnswer();
                    }
                }

                onSmallBoxDropped(boxIndex) {
                    const firstDroppedClawIndex = this.smallClaws.findIndex(claw => claw.boxDropped);
                    if (firstDroppedClawIndex > 0) {
                        const nextClawToDrop = this.smallClaws[firstDroppedClawIndex - 1];
                        nextClawToDrop.showHandIconAnim();
                    }
                    if (this.smallClaws.every(claw => claw.boxDropped)) {
                        this.playSmallClawsDisappearingAnim(() => {
                            this.playBigClawsAppearingAnim(() => {
                                this.scene.sound.play("Load the Train - Question Audio");
                            })
                        })
                    }
                }

                playHorseYesAnim() {
                    Preloader.playAnim('horse-yes', this.horse, () => {
                        Preloader.playAnim('horse-iddle', this.horse);
                    });
                    this.soundGooseYes = this.scene.sound.add("Horse neigh and Yeah");//this.soundGooseYes = this.scene.sound.add("yes");
                    this.soundGooseYes.play();
                }

                playTrainArrivingAnim(onCompleteCallback) {
                    Preloader.playAnim('train-moving', this.train);
                    this.smoke.alpha = 1;
                    Preloader.playAnim('smoke', this.smoke);
                    this.trainContainer.x = -1000;
                    this.trainArrivingTween = this.scene.tweens.add({
                        targets: this.trainContainer,
                        x: 0,
                        duration: 4000,
                        ease: Phaser.Math.Easing.Sine.Out,
                        onComplete: () => {
                            Preloader.playAnim('train-stop', this.train);
                            this.scene.tweens.add({
                                targets: this.smoke,
                                alpha: 0,
                                duration: 200,
                                ease: Phaser.Math.Easing.Linear
                            });
                            if (onCompleteCallback) onCompleteCallback();
                        }
                    });
                    this.scene.sound.add("Train coming").play();
                }

                playTrainDepartureAnim(onCompleteCallback) {
                    /* tween smoke appearing */
                    this.smoke.alpha = 0;
                    Preloader.playAnim('smoke', this.smoke);
                    Preloader.playAnim('train-moving', this.train);

                    this.scene.tweens.add({
                        targets: this.smoke,
                        alpha: 1,
                        duration: 250,
                        ease: Phaser.Math.Easing.Linear
                    });
                    /* departure tween */
                    this.trainDepartureTween = this.scene.tweens.add({
                        targets: this.trainContainer,
                        x: 1000,
                        duration: 4000,
                        ease: Phaser.Math.Easing.Sine.In,
                        onComplete: () => {
                            if (onCompleteCallback) onCompleteCallback();
                        }
                    });

                    this.scene.sound.add("Train moving and leaving").play();
                }

                playSmallClawsAppearingAnim(onCompleteCallback) {
                    this.smallClawsContainer.visible = true;
                    this.bigClawsContainer.visible = false;
                    this.smallClaws.forEach((claw, index) => {
                        claw.y = -180;
                        this.scene.tweens.add({
                            targets: claw,
                            y: 80,
                            duration: 400,
                            delay: (2 - index) * 200,
                            ease: Phaser.Math.Easing.Cubic.Out,
                            onComplete: () => {
                                if (onCompleteCallback) onCompleteCallback();
                            }
                        });
                        // delayedCall((2 - index) * 200, () => {
                        this.scene.sound.add("Claws hanging").play();
                        // });
                    });
                }

                playSmallClawsDisappearingAnim(onCompleteCallback) {
                    this.smallClaws.forEach((claw, index) => {
                        this.scene.tweens.add({
                            targets: claw,
                            y: -180,
                            duration: 300,
                            delay: (2 - index) * 150,
                            ease: Phaser.Math.Easing.Cubic.In,
                            onComplete: () => {
                                if (index === 0 && onCompleteCallback) onCompleteCallback();
                            }
                        });
                    });
                }

                playBigClawsAppearingAnim(onCompleteCallback) {
                    this.smallClawsContainer.visible = false;
                    this.bigClawsContainer.visible = true;
                    this.bigClaws.forEach((claw, index) => {
                        claw.reset();
                        claw.y = -250;
                        this.scene.tweens.add({
                            targets: claw,
                            y: 85,
                            duration: 400,
                            delay: (2 - index) * 175,
                            ease: Phaser.Math.Easing.Sine.Out,
                            onComplete: () => {
                                if (index === 0 && onCompleteCallback) onCompleteCallback();
                            }
                        });
                        // delayedCall((2 - index) * 150, () => {
                        this.scene.sound.add("Claws going up").play();
                        // });
                    });
                }

                playBigClawsCorrectSelectionAnim(selectedClawIndex, onCompleteCallback) {
                    const targetClaw = this.bigClaws[selectedClawIndex];
                    const otherClaws = this.bigClaws.filter(claw => claw != targetClaw);
                    this.bigClawsContainer.visible = true;
                    otherClaws.forEach((claw, index) => {
                        this.scene.tweens.add({
                            targets: claw,
                            y: -250,
                            duration: 450,
                            delay: index * 150,
                            ease: Phaser.Math.Easing.Sine.In,
                            onComplete: () => { }
                        });
                    });

                    this.scene.tweens.add({
                        targets: targetClaw,
                        x: 125,
                        duration: 400 + Math.abs(targetClaw.x - 175) * 1.5,
                        delay: 300,
                        ease: Phaser.Math.Easing.Sine.InOut,
                        onComplete: () => {
                            targetClaw.dropBox(() => {
                                this.scene.tweens.add({
                                    targets: targetClaw,
                                    y: -250,
                                    duration: 450,
                                    delay: 0,
                                    ease: Phaser.Math.Easing.Sine.In,
                                    onComplete: () => { }
                                });
                                if (onCompleteCallback) onCompleteCallback();
                            });
                            this.scene.sound.add("Claws going up").play();
                        }
                    });
                    this.scene.sound.add("Claw moving").play();
                }

                onNewRound(showOut) {
                    if (showOut) {
                        delayedCall(4500, () => {
                            console.log("Starting new round...");
                            this.startRound();
                        });
                    }
                }

                onCorrectAnswer() {
                    let completed = this.gameplay.onCorrectAnswer();
                    this.scene.sound.add("Correct").play();
                    this.tallies[this.gameplay.getCurrentTotalAnswersCount() - 1].setTexture('tally-correct');
                    this.updateTalliesVisibility();
                    return completed;
                }

                onWrongAnswer() {
                    let lost = this.gameplay.onWrongAnswer();
                    this.soundGooseNo = this.scene.sound.add("Wrong attempt");
                    this.soundGooseNo.play();
                    this.tallies[this.gameplay.getCurrentTotalAnswersCount() - 1].setTexture('tally-wrong');
                    this.updateTalliesVisibility();
                    return lost;
                }

                playCorrectAudio(index) {
                    if (this.correctAudio) {
                        this.correctAudio.stop();
                    }
                    this.correctAudio = this.scene.sound.add(this.gameplay.getCorrectAudioKey(index));
                    this.correctAudio.play();
                    if (this.areYouSureWindow && this.areYouSureWindow.parentContainer == this) {
                        this.correctAudio.pause();
                    }
                }

                onCloseClick() {
                    this.showAreYouSurePage();
                    this.scene.sound.add('warning page pop up sfx').play();
                }

                showInstructionPage() {
                    setPageBackground("bg-blue");
                    let playInstructionSound = () => {
                        if (this.wfsnd) {
                            this.wfsnd.stop();
                        }
                        this.wfsnd = this.scene.sound.add("Introduction");
                        this.wfsnd.play();
                    };
                    this.instructionPage = new screen.InstructionPage(this.scene, (target) => {
                        playBtnClickAnim(target);
                        this.remove(this.instructionPage);
                        this.showGameplay();
                        if (this.wfsnd) {
                            this.wfsnd.stop();
                        }
                    }, (target) => {
                        playBtnClickAnim(target);
                        playInstructionSound();
                    });
                    this.add(this.instructionPage);
                    try {
                        playInstructionSound();
                    } catch (e) {
                        console.error(e);
                    }
                }

                showAreYouSurePage() {
                    pauseAllDelayedCalls();
                    setPageBackground("bg-blue");
                    this.pauseSounds();
                    this.areYouSureWindow = new screen.AreYouSureWindow(this.scene, () => {
                        this.remove(this.areYouSureWindow);
                        this.destroyGameplay();
                        this.showInstructionPage();
                    }, () => {
                        this.remove(this.areYouSureWindow);
                        this.unpauseSounds();
                        resumeAllDelayedCalls();
                        setPageBackground("bg-australia");
                    });
                    this.add(this.areYouSureWindow);
                }

                pauseSounds() {
                    this.scene.sound.pauseAll();
                }

                unpauseSounds() {
                    this.scene.sound.resumeAll();
                }

                destroyGameplay() {
                    this.scene.tweens.killAll();
                    this.remove(this.gameplayContainer, true);
                    this.scene.sound.stopAll();
                    destroyAllDelayedCalls();
                }
            }

            screen.GameplayScreen = GameplayScreen;
        })(screen = trainGame.screen || (trainGame.screen = {}));
    })(trainGame || (trainGame = {}));

    /* InstructionPage */
    (function (trainGame) {
        var screen;
        (function (screen) {
            class InstructionPage extends Phaser.GameObjects.Container {
                constructor(scene, onPlayClick, onSndClick) {
                    super(scene);
                    this._instructionPage = new Phaser.GameObjects.Image(this.scene, 0 - 105, 0 - 48, 'Instructions page  ALL ACTIVITY  TITLEs');
                    this._instructionPage.setOrigin(0, 0);
                    this._instructionPage.setInteractive();

                    this._instructionPageTitle = new Phaser.GameObjects.Image(this.scene, 475, 110, 'Load the Train Title');
                    this._instructionPageTitle.setScale(0.8);

                    this._btnPlay = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2, 480 - 50, 'btnPLAY1');
                    this._btnPlay.setInteractive({ cursor: 'pointer' });
                    this._btnPlay.once('pointerup', onPlayClick);
                    setupButtonTextureBased(this._btnPlay, 'btnPLAY1', 'btnPLAY2');
                    this.instrTxt = this.scene.add.text(game.scale.width / 2, game.scale.height / 2, "The boxes make up a word.\n Load the train and read the word.\n Then choose the word that matches.", {
                        "fontFamily": "Kids Rock DEMO",
                        "fontSize": 30,
                        "lineSpacing":15,
                        "color": "#43425D",
                        "align": 'center'
                    });
                    this.instrTxt.setOrigin(0.5, 0.5);
                    this._btnSoundInstruction = new Phaser.GameObjects.Image(this.scene, 800 - 105, 156 - 50, 'Sound');
                    this._btnSoundInstruction.setInteractive({ cursor: 'pointer' });
                    this._btnSoundInstruction.on('pointerup', onSndClick);
                    setupButtonTextureBased(this._btnSoundInstruction, 'Sound', 'Sound HOVER EFFECT');
                    this.add(this._instructionPage);
                    this.add(this._instructionPageTitle);
                    this.add(this.instrTxt);
                    this.add(this._btnPlay);
                    this.add(this._btnSoundInstruction);
                }
            }

            screen.InstructionPage = InstructionPage;
        })(screen = trainGame.screen || (trainGame.screen = {}));
    })(trainGame || (trainGame = {}));

    /* Complete Window */
    (function (trainGame) {
        var screen;
        (function (screen) {
            class CompleteWindow extends Phaser.GameObjects.Container {
                constructor(scene, onBack, onReplay, onNext) {
                    super(scene);
                    this.music = null;
                    this.setPosition(-104.5, -48);
                    this._bgComplete = new Phaser.GameObjects.Image(this.scene, 0, 0, 'Completion page LATEST UPDATED');
                    this._bgComplete.setOrigin(0, 0);
                    this._bgComplete.setInteractive();
                    this._cup = new Phaser.GameObjects.Image(this.scene, 400, 410, 'Trophy');
                    this._btnBack = new Phaser.GameObjects.Image(this.scene, 570, 570, 'btnBACK1');
                    this._btnReplay = new Phaser.GameObjects.Image(this.scene, 720, 570, 'btnReplay1');
                    this._btnNext = new Phaser.GameObjects.Image(this.scene, 870, 570, 'btnNEXT1');
                    let _CollectedPoints = new Phaser.GameObjects.Image(this.scene, 620, 440, 'Collected Points');
                    this.totalScoreTxt = this.scene.add.text(845, 352, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 35,
                        "color": "#F49F1C",
                        "align": 'center',
                        'stroke': '#70451A',
                        'strokeThickness': 6
                    });
                    this.totalScoreTxt.setOrigin(0.5, 0.5);
                    let grd = this.totalScoreTxt.context.createLinearGradient(0, 0, 0, this.totalScoreTxt.height);
                    grd.addColorStop(0, '#FFFF00');
                    grd.addColorStop(1, '#C17316');
                    this.totalScoreTxt.setFill(grd);
                    this.starScoreTxt = this.scene.add.text(648, 433, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 24,
                        "color": "#FFFFFF",
                        "align": 'center'
                    });
                    this.starScoreTxt.setOrigin(0.5, 0.5);
                    this.add([
                        this._bgComplete,
                        _CollectedPoints,
                        this._cup,
                        this._btnBack,
                        this._btnReplay,
                        this._btnNext,
                        this.totalScoreTxt,
                        this.starScoreTxt
                    ]);
                    this._btnBack.setInteractive({ cursor: 'pointer' });
                    this._btnBack.on('pointerup', () => {
                        onBack(this._btnBack);
                        window.angularComponentRef.backToMenu();
                        // if (this.music) {
                        //     this.music.stop();
                        // }
                    });
                    setupButtonTextureBased(this._btnBack, 'btnBACK1', 'btnBACK2');
                    this._btnReplay.setInteractive({ cursor: 'pointer' });
                    this._btnReplay.once('pointerup', () => {
                        onReplay(this._btnReplay);
                        if (this.music) {
                            this.music.stop();
                        }
                    });
                    setupButtonTextureBased(this._btnReplay, 'btnReplay1', 'btnReplay2');
                    this._btnNext.setInteractive({ cursor: 'pointer' });
                    this._btnNext.on('pointerup', () => {
                        onNext(this._btnNext);
                        window.angularComponentRef.nextActivity();
                        // if (this.music) {
                        //     this.music.stop();
                        // }
                    });
                    setupButtonTextureBased(this._btnNext, 'btnNEXT1', 'btnNEXT2');
                }

                show(score, starScore) {
                    window.angularComponentRef.gameFinish({ score, starScore });
                    this._cup.scale = 1.25;
                    this.scene.tweens.add({
                        targets: this._cup,
                        "scale": 1,
                        duration: 500,
                        ease: Phaser.Math.Easing.Back.Out
                    });
                    this.totalScoreTxt.text = String(window.angularComponentRef.component.userInfo.totalScore);
                    this.starScoreTxt.text = String(starScore);
                    // let music = this.scene.sound.add("viktory");
                    this.music = this.scene.sound.add("Activity completion fantastic");
                    this.music.play();
                }
            }

            screen.CompleteWindow = CompleteWindow;
        })(screen = trainGame.screen || (trainGame.screen = {}));
    })(trainGame || (trainGame = {}));

    /* AreYouSureWindow */
    (function (trainGame) {
        var screen;
        (function (screen) {
            class AreYouSureWindow extends Phaser.GameObjects.Container {
                constructor(scene, onYes, onNo) {
                    super(scene);
                    this._areYouSurePage = new Phaser.GameObjects.Image(this.scene, -105, 0 - 48, 'Exit warning');
                    this._areYouSurePage.setOrigin(0, 0);
                    this._areYouSurePage.setInteractive();
                    this._btnSureYes = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2 - 95, 485 - 50, 'btnYES1');
                    this._btnSureYes.setInteractive({ cursor: 'pointer' });
                    this._btnSureYes.once('pointerup', () => {
                        onYes;
                        window.angularComponentRef.backToMenu();
                    });
                    var modalTextStyle = {
                        backgroundColor: 'transparent',
                        stroke: '#ffffff',
                        strokeThickness: 2,
                        lineSpacing: 15,
                        fontFamily: 'Kids Rock DEMO',
                        fontSize: 27,
                        color: '#43425d',
                        wordWrap: true,
                        align: 'center'
                    };
                    var modalText = this.scene.add.text(game.scale.width / 2 + 12, game.scale.height / 2, "Your progress in this activity will not be saved. \n Are you sure you want to exit? ", modalTextStyle);
                    modalText.setOrigin(0.5, 0.5);

                    setupButtonTextureBased(this._btnSureYes, 'btnYES1', 'btnYES2');
                    this._btnSureNo = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2 + 95, 485 - 50, 'btnNO1');
                    this._btnSureNo.setInteractive({ cursor: 'pointer' });
                    this._btnSureNo.once('pointerup', onNo);
                    setupButtonTextureBased(this._btnSureNo, 'btnNO1', 'btnNO2');
                    this.add(this._areYouSurePage);
                    this.add(this._btnSureYes);
                    this.add(this._btnSureNo);
                    this.add(modalText);
                }
            }

            screen.AreYouSureWindow = AreYouSureWindow;
        })(screen = trainGame.screen || (trainGame.screen = {}));
    })(trainGame || (trainGame = {}));

    /* Try Again Window */
    (function (trainGame) {
        var screen;
        (function (screen) {
            class TryAgainWindow extends Phaser.GameObjects.Container {
                constructor(scene, onBack, onReplay) {
                    super(scene);
                    this.music = null;
                    this.setPosition(-106, -48);
                    this._bg = new Phaser.GameObjects.Image(this.scene, 0, 0, 'Try again page');
                    this._bg.setOrigin(0, 0);
                    this._bg.setInteractive();
                    this._star = new Phaser.GameObjects.Image(this.scene, 400, 415, 'Break Star');
                    this._btnBack = new Phaser.GameObjects.Image(this.scene, 600, 580, 'btnBACK1');
                    this._btnReplay = new Phaser.GameObjects.Image(this.scene, 765, 580, 'btnReplay1');
                    this.totalScoreTxt = this.scene.add.text(830, 355, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 35,
                        "color": "#F49F1C",
                        "align": 'center',
                        'stroke': '#70451A',
                        'strokeThickness': 6
                    });
                    this.totalScoreTxt.setOrigin(0.5, 0.5);
                    let grd = this.totalScoreTxt.context.createLinearGradient(0, 0, 0, this.totalScoreTxt.height);
                    grd.addColorStop(0, '#FFFF00');
                    grd.addColorStop(1, '#C17316');
                    this.totalScoreTxt.setFill(grd);
                    this.starScoreTxt = this.scene.add.text(635, 431, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 24,
                        "color": "#FFFFFF",
                        "align": 'center'
                    });
                    this.starScoreTxt.setOrigin(0.5, 0.5);
                    this.add([
                        this._bg,
                        this._star,
                        this._btnBack,
                        this._btnReplay,
                        this.totalScoreTxt,
                        this.starScoreTxt
                    ]);
                    this._btnBack.setInteractive({ cursor: 'pointer' });
                    this._btnBack.on('pointerup', () => {
                        onBack(this._btnBack);
                        window.angularComponentRef.backToMenu();
                        // if (this.music) {
                        //     this.music.stop();
                        // }
                    });
                    setupButtonTextureBased(this._btnBack, 'btnBACK1', 'btnBACK2');
                    this._btnReplay.setInteractive({ cursor: 'pointer' });
                    this._btnReplay.once('pointerup', () => {
                        onReplay(this._btnReplay);
                        if (this.music) {
                            this.music.stop();
                        }
                    });
                    setupButtonTextureBased(this._btnReplay, 'btnReplay1', 'btnReplay2');
                }

                show(score, starScore) {
                    this._star.scale = 1.25;
                    this.scene.tweens.add({
                        targets: this._star,
                        "scale": 1,
                        duration: 500,
                        ease: Phaser.Math.Easing.Back.Out
                    });
                    this.totalScoreTxt.text = String(window.angularComponentRef.component.userInfo.totalScore);
                    this.starScoreTxt.text = String(0);
                    this.music = this.scene.sound.add("Fail - close one");
                    this.music.play();
                }
            }

            screen.TryAgainWindow = TryAgainWindow;
        })(screen = trainGame.screen || (trainGame.screen = {}));
    })(trainGame || (trainGame = {}));

    game = new trainGame.App(json);
};

function destroyLoadTrain() {
    if (game) {
        game.destroy();
        game = null;
    }
}

var ctb;
var game;

var catchTheCrab = (json) => {
    (function (ctb) {
        class App extends Phaser.Game {
            constructor(json) {
                App.json = json;
                let config = {
                    type: Phaser.AUTO,
                    width: App.CANVAS_WIDTH,
                    height: App.CANVAS_HEIGHT,
                    parent: 'game-container',
                    dom: {
                        createContainer: false
                    },
                    scale: {
                        mode: FitScaleManager.detectBestScaleMode(),
                        autoCenter: Phaser.Scale.CENTER_BOTH
                    },
                    transparent: true,
                    scene: {
                        create: () => {
                            this.scene.add('Boot', ctb.scene.Boot, true);
                        }
                    }
                };
                super(config);
            }
        }
        App.CANVAS_WIDTH = 980;
        App.CANVAS_HEIGHT = 600;
        ctb.App = App;
    })(ctb || (ctb = {}));

    var delayedCalls = [];
    function delayedCall(delay, callback, args, callbackScope) {
        let scene = game.scene.getAt(0);
        if (scene) {
            let dc = scene.time.delayedCall(delay, callback, args, callbackScope);
            delayedCalls.push(dc);
            return dc;
        }
        let t = setTimeout(callback, delay);
        delayedCalls.push(t);
        return t;
    }
    function pauseAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.paused = true;
            }
        }
    }
    function resumeAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.paused = false;
            }
        }
    }
    function destroyAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.remove(false);
            }
            else {
                clearTimeout(dc);
            }
        }
        delayedCalls = [];
    }
    function destroyDelayedCall(dc) {
        if (dc instanceof Phaser.Time.TimerEvent) {
            dc.remove(false);
        }
        else {
            clearTimeout(dc);
        }
        let ind = delayedCalls.indexOf(dc);
        if (ind >= 0)
            delayedCalls.splice(ind, 1);
    }
    function setPageBackground(bg) {
        // document.querySelector("html").style.backgroundImage = "url(assets/imgs/" + bg + ".jpg)";
    }
    function setupButton(btn, frame) {
        btn.on('pointerdown', () => { btn.setFrame(frame + '_hover' + '0000'); });
        btn.on('pointerover', () => { btn.setFrame(frame + '_hover' + '0000'); game.scene.getAt(0).sound.add("button hover").play(); });
        btn.on('pointerout', () => { btn.setFrame(frame + '0000'); });
        btn.on('pointerup', () => { btn.setFrame(frame + '0000'); game.scene.getAt(0).sound.add('activity selection - button selection').play(); });
    }
    function setupButtonTextureBased(btn, texture, hoverTexture) {
        btn.on('pointerdown', () => { btn.setTexture(hoverTexture); });
        btn.on('pointerover', () => { btn.setTexture(hoverTexture); game.scene.getAt(0).sound.add("button hover").play(); });
        btn.on('pointerout', () => { btn.setTexture(texture); });
        btn.on('pointerup', () => { btn.setTexture(texture); game.scene.getAt(0).sound.add('activity selection - button selection').play(); });
    }
    function playBtnClickAnim(target) {
        let sc = target.hasOwnProperty("defScale") ? target["defScale"] : 1;
        target.scaleX = target.scaleY = sc;
        let scene = game.scene.getAt(0);
        scene.tweens.add({
            targets: target,
            "scaleX": 0.9 * sc,
            "scaleY": 0.9 * sc,
            duration: 100,
            yoyo: true
        });
    }
    /**
     * @author Roman Parada
     * This class is created to fix overlapping of bottom part of canvas by navigation bar in iOS.
     * It make a delayed resize of the canvas (like Phaser-3 FIT methods does) and it overrides Phaser-3 input window to Phaser-3 core transform methods
     *
     * How to use:
     * Just call the code line below in Boot scene's init() method of your project:
     * new FitScaleManager(this.game).setup();
     */
    class FitScaleManager {
        constructor(game) {
            this.doResize = () => {
                let scale = this.calculateScale();
                let newCanvasWidth = this.phaserScaleManager.width * scale;
                let newCanvasHeight = this.phaserScaleManager.height * scale;
                this.canvasStyle.width = newCanvasWidth + 'px';
                this.canvasStyle.height = newCanvasHeight + 'px';
                this.canvasStyle.marginLeft = (window.innerWidth - newCanvasWidth) / 2 + 'px';
                this.canvasStyle.marginTop = (window.innerHeight - newCanvasHeight) / 2 + 'px';
            };
            this.game = game;
            this.canvasStyle = this.game.canvas.style;
            this.phaserScaleManager = this.game.scale;
        }
        static detectBestScaleMode() {
            let iOS = /iPad|iPhone|iPod/.test(navigator.platform || "");
            let isAndroid = window.navigator.userAgent.toLowerCase().indexOf("android") > -1;
            return iOS || isAndroid ? Phaser.Scale.FIT : Phaser.Scale.NONE;
        }
        ;
        /**
         * Just call this method once in Boot scene's init() method
         */
        setup() {
            this.phaserScaleManager.addListener(Phaser.Scale.Events.RESIZE, this.onResize, this);
            this.overridePhaserTransformMethods();
            this.onResize();
        }
        calculateScale() {
            if (game.scale.scaleMode == Phaser.Scale.NONE)
                return 1;
            return Math.min(window.innerWidth / this.phaserScaleManager.width, window.innerHeight / this.phaserScaleManager.height);
        }
        overridePhaserTransformMethods() {
            this.game.scale.transformX = (pageX) => {
                return (pageX - parseInt(this.canvasStyle.marginLeft.split("px")[0])) / this.calculateScale();
            };
            this.game.scale.transformY = (pageY) => {
                return (pageY - parseInt(this.canvasStyle.marginTop.split("px")[0])) / this.calculateScale();
            };
        }
        onResize() {
            setTimeout(this.doResize, FitScaleManager.RESIZE_DELAY);
        }
    }
    FitScaleManager.RESIZE_DELAY = 500;

    (function (ctb) {
        var core;
        (function (core) {
            class Gameplay {
                constructor() {
                    this.currentRound = 0;
                    this.correctAnswersCount = 0;
                    this.wrongAnswersCount = 0;
                    this.correctAnswersCountThisRound = 0;
                    this.wrongAnswersCountThisRound = 0;
                    this.onNewRound = null;
                    this.nextLetterDelay = 0;
                    this.words = game.cache.json.get('gameplay')['words'];
                    this.failsNumToLose = Number(game.cache.json.get('gameplay')["failsNumToLose"]);
                    this.useImages = Boolean(game.cache.json.get('gameplay')["useImages"]);
                }
                setupCallbacks(onComplete, onLose, onNewRound) {
                    this.onComplete = onComplete;
                    this.onLose = onLose;
                    this.onNewRound = onNewRound;
                }
                calculateScore() {
                    return this.totalRoundsNum - this.wrongAnswersCount;
                }
                onLetterChosen() {
                    this.currentRound++;
                    if (this.currentRound >= this.totalRoundsNum) {
                        let score = this.calculateScore();
                        this.onComplete(score, score);
                        return true;
                    }
                    else {
                        this.nextLetter();
                    }
                    return false;
                }
                nextLetter() {
                    let fn = () => {
                        let thisRound = this.rounds.shift();
                        this.wantedWord = thisRound["wantedWord"];
                        this.selectableWords = thisRound["selectableWords"];
                        this.selectableImages = [];
                        this.correctAnswersCountThisRound = 0;
                        this.wrongAnswersCountThisRound = 0;
                        this.words.map(word => {
                            if (this.selectableWords.includes(word.word)) {
                                this.selectableImages[this.selectableWords.indexOf(word.word)] = word.image
                            }
                            if (word.word === this.wantedWord[0]) {
                                this.wantedImage = word.image;
                            }
                        });
                        if (this.onNewRound)
                            this.onNewRound();
                    };
                    if (this.nextLetterDelay == 0) {
                        fn();
                    }
                    else {
                        delayedCall(this.nextLetterDelay, fn);
                    }
                }
                onCorrectAnswer() {
                    this.correctAnswersCount++;
                    this.correctAnswersCountThisRound++;
                    this.nextLetterDelay = 3500;
                    return this.onLetterChosen();
                }
                onWrongAnswer() {
                    this.wrongAnswersCount++;
                    this.wrongAnswersCountThisRound++;
                    this.nextLetterDelay = 1500;
                    if (this.wrongAnswersCount >= this.failsNumToLose) {
                        this.onLose(0, 0);
                        return true;
                    }
                    else {
                        this.onLetterChosen();
                    }
                    return false;
                }
                getCurrentTotalAnswersCount() {
                    return this.correctAnswersCount + this.wrongAnswersCount;
                }
                getCurrentTotalAnswersCountThisRound() {
                    return this.correctAnswersCountThisRound + this.wrongAnswersCountThisRound;
                }
                isNewRound() {
                    return this.getCurrentTotalAnswersCountThisRound() == 0;
                }
                isRoundsComplete() {
                    return this.currentRound >= this.totalRoundsNum;
                }
                getAudioKeyOfChar(letter) {
                    let json = game.cache.json.get('gameplay');
                    let letters = json["letters"];
                    for (let d of letters) {
                        if (letter == d['letterName']) {
                            return d['audioKey'];
                        }
                    }
                    return null;
                }
                reset() {
                    this.nextLetterDelay = 0;
                    this.setupCallbacks(null, null, null);
                    let json = game.cache.json.get('gameplay');
                    this.rounds = json["rounds"].slice();
                    this.totalRoundsNum = this.rounds.length;
                    this.nextLetter();
                    this.currentRound = 0;
                    this.correctAnswersCount = 0;
                    this.wrongAnswersCount = 0;
                    this.correctAnswersCountThisRound = 0;
                    this.wrongAnswersCountThisRound = 0;
                }
            }
            core.Gameplay = Gameplay;
        })(core = ctb.core || (ctb.core = {}));
    })(ctb || (ctb = {}));

    (function (ctb) {
        var scene;
        (function (scene) {
            class Boot extends Phaser.Scene {
                init() {
                    this.game.scale.transformX = (pageX) => {
                        let offsetLeft = 0;
                        let parentElement = game.canvas.parentElement;
                        while (parentElement) {
                            if (parentElement.offsetLeft) {
                                offsetLeft = parentElement.offsetLeft;
                                break;
                            }
                            parentElement = parentElement.parentElement;
                        }
                        return (pageX - offsetLeft) * this.game.scale.displayScale.x;
                    };
                    this.game.scale.transformY = (pageY) => {
                        let offsetTop = 0;
                        let parentElement = game.canvas.parentElement;
                        while (parentElement) {
                            if (parentElement.offsetTop) {
                                offsetTop = parentElement.offsetTop;
                                break;
                            }
                            parentElement = parentElement.parentElement;
                        }
                        return (pageY - offsetTop) * this.game.scale.displayScale.y;
                    };
                }
                create() {
                    game.scene.remove('Boot');
                    game.scene.add('Preloader', ctb.scene.Preloader, true);
                }
            }
            scene.Boot = Boot;
        })(scene = ctb.scene || (ctb.scene = {}));
    })(ctb || (ctb = {}));

    (function (ctb) {
        var scene;
        (function (scene) {
            var Gameplay = ctb.core.Gameplay;
            class MainScene extends Phaser.Scene {
                create() {
                    this.gameplay = new Gameplay();
                    this.gameplayScreen = new ctb.screen.GameplayScreen(this, this.gameplay);
                    this.children.add(this.gameplayScreen);
                    this.gameplayScreen.showInstructionPage();
                }
                update() {
                    this.gameplayScreen._update();
                }
            }
            scene.MainScene = MainScene;
        })(scene = ctb.scene || (ctb.scene = {}));
    })(ctb || (ctb = {}));

    (function (ctb) {
        var scene;
        (function (scene) {
            class Preloader extends Phaser.Scene {
                preload() {
                    if (typeof ctb.App.json == "string") this.load.json('gameplay', ctb.App.json); else this.game.cache.json.add('gameplay', ctb.App.json);
                }
                create() {
                    let json = game.cache.json.get('gameplay');
                    if (json["useImages"]) {
                        for (let w of json["words"]) {
                            if (w["image"] && !w["image"].includes('http')) {
                                this.load.image(w["word"], "assets/games/cat-the-crab/imgs/words/" + w["image"] + ".png");
                            } else {
                                this.load.image(w["word"], w["image"]);
                            }
                            if (w["audioKey"]) {
                                this.load.audio(w["audioKey"], "assets/games/cat-the-crab/sound/mp3/words/" + w["audioKey"] + ".mp3");
                            }
                        }
                    }
                    let progressTxt = this.add.text(game.scale.width / 2, game.scale.height / 2, "", {
                        "fontFamily": "QuranErafont",
                        "fontSize": 25,
                        "color": "#000000",
                        "align": 'center'
                    });
                    progressTxt.setOrigin(0.5, 0.5);
                    this.load.pack('preloader', 'assets/games/cat-the-crab/pack.json');
                    this.load.on('progress', (value) => {
                        progressTxt.text = Math.ceil(value * 100) + "%";
                    }, this);
                    this.load.on('complete', () => {
                        this.nextScene();
                    });
                    this.load.start();
                }
                static playAnim(animKey, sprite, onComplete = null) {
                    let mainScene = game.scene.getScene('ScreenMain');
                    if (!mainScene.anims.exists(animKey)) {
                        let data = Preloader.ANIMS_DATA[animKey];
                        mainScene.anims.create({
                            key: animKey,
                            frames: mainScene.anims.generateFrameNames(data['atlas'], {
                                start: data['start'], end: data['end'], zeroPad: data['padNum'],
                                prefix: data['prefix'], suffix: ''
                            }),
                            frameRate: data['frameRate'],
                            repeat: data['repeat']
                        });
                    }
                    if (sprite.anims.currentAnim) {
                        sprite.anims.currentAnim.off('complete');
                    }
                    sprite.anims.stop();
                    sprite.play(animKey);
                    sprite.anims.currentAnim.once('complete', () => {
                        if (onComplete)
                            onComplete();
                    });
                    return sprite;
                }
                nextScene() {
                    game.scene.remove('Preloader');
                    game.scene.add('ScreenMain', ctb.scene.MainScene, true);
                }
            }
            Preloader.ANIMS_DATA = {
                'bird': {
                    'start': 0,
                    'end': 54,
                    'padNum': 4,
                    'prefix': 'bird',
                    'repeat': -1,
                    'frameRate': 35,
                    'atlas': 'bird-atlas'
                },
                'crab': {
                    'start': 0,
                    'end': 46,
                    'padNum': 4,
                    'prefix': 'crab',
                    'repeat': 0,
                    'frameRate': 24,
                    'atlas': 'crab-iddle-atlas'
                },
                'crabCaught': {
                    'start': 7,
                    'end': 7,
                    'padNum': 4,
                    'prefix': 'crab',
                    'repeat': 0,
                    'frameRate': 34,
                    'atlas': 'crab-iddle-atlas'
                }
            };
            scene.Preloader = Preloader;
        })(scene = ctb.scene || (ctb.scene = {}));
    })(ctb || (ctb = {}));

    (function (ctb) {
        var screen;
        (function (screen) {
            class AreYouSureWindow extends Phaser.GameObjects.Container {
                constructor(scene, onYes, onNo) {
                    super(scene);
                    this._areYouSurePage = new Phaser.GameObjects.Image(this.scene, -105, 0 - 48, 'Exit warning');
                    this._areYouSurePage.setOrigin(0, 0);
                    this._areYouSurePage.setInteractive();
                    this._btnSureYes = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2 - 95, 485 - 50, 'btnYES1');
                    this._btnSureYes.setInteractive({ cursor: 'pointer' });
                    this._btnSureYes.once('pointerup', () => {
                        onYes;
                        window.angularComponentRef.backToMenu();
                    });


                    var modalTextStyle = {
                        backgroundColor: 'transparent',
                        stroke: '#ffffff',
                        strokeThickness: 2,
                        lineSpacing: 15,
                        fontFamily: 'Kids Rock DEMO',
                        fontSize: 27,
                        color: '#43425d',
                        wordWrap: true,
                        align: 'center'
                    };
                    var modalText = this.scene.add.text(game.scale.width / 2 + 12, game.scale.height / 2, "Your progress in this activity will not be saved. \n Are you sure you want to exit? ", modalTextStyle);
                    modalText.setOrigin(0.5, 0.5);

                    setupButtonTextureBased(this._btnSureYes, 'btnYES1', 'btnYES2');
                    this._btnSureNo = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2 + 95, 485 - 50, 'btnNO1');
                    this._btnSureNo.setInteractive({ cursor: 'pointer' });
                    this._btnSureNo.once('pointerup', onNo);
                    setupButtonTextureBased(this._btnSureNo, 'btnNO1', 'btnNO2');
                    this.add(this._areYouSurePage);
                    this.add(this._btnSureYes);
                    this.add(this._btnSureNo);
                    this.add(modalText);
                }
            }
            screen.AreYouSureWindow = AreYouSureWindow;
        })(screen = ctb.screen || (ctb.screen = {}));
    })(ctb || (ctb = {}));

    (function (ctb) {
        var screen;
        (function (screen) {
            class CompleteWindow extends Phaser.GameObjects.Container {
                constructor(scene, onBack, onReplay, onNext) {
                    super(scene);
                    this.music = null;
                    this.setPosition(-104.5, -48);
                    this._bgComplete = new Phaser.GameObjects.Image(this.scene, 0, 0, 'Completion page LATEST UPDATED');
                    this._bgComplete.setOrigin(0, 0);
                    this._bgComplete.setInteractive();
                    this._cup = new Phaser.GameObjects.Image(this.scene, 400, 410, 'Trophy');
                    this._btnBack = new Phaser.GameObjects.Image(this.scene, 570, 570, 'btnBACK1');
                    this._btnReplay = new Phaser.GameObjects.Image(this.scene, 720, 570, 'btnReplay1');
                    this._btnNext = new Phaser.GameObjects.Image(this.scene, 870, 570, 'btnNEXT1');
                    let _CollectedPoints = new Phaser.GameObjects.Image(this.scene, 620, 440, 'Collected Points');
                    this.totalScoreTxt = this.scene.add.text(845, 352, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 35,
                        "color": "#F49F1C",
                        "align": 'center',
                        'stroke': '#70451A',
                        'strokeThickness': 6
                    });
                    this.totalScoreTxt.setOrigin(0.5, 0.5);
                    let grd = this.totalScoreTxt.context.createLinearGradient(0, 0, 0, this.totalScoreTxt.height);
                    grd.addColorStop(0, '#FFFF00');
                    grd.addColorStop(1, '#C17316');
                    this.totalScoreTxt.setFill(grd);
                    this.starScoreTxt = this.scene.add.text(648, 433, "", {
                        "fontFamily": "Kids Rock DEMO",
                        "fontSize": 24,
                        "color": "#FFFFFF",
                        "align": 'center'
                    });
                    this.starScoreTxt.setOrigin(0.5, 0.5);
                    this.add([
                        this._bgComplete,
                        _CollectedPoints,
                        this._cup,
                        this._btnBack,
                        this._btnReplay,
                        this._btnNext,
                        this.totalScoreTxt,
                        this.starScoreTxt
                    ]);
                    this._btnBack.setInteractive({ cursor: 'pointer' });
                    this._btnBack.on('pointerup', () => {
                        onBack(this._btnBack);
                        window.angularComponentRef.backToMenu();
                        // if (this.music) {
                        //     this.music.stop();
                        // }
                    });
                    setupButtonTextureBased(this._btnBack, 'btnBACK1', 'btnBACK2');
                    this._btnReplay.setInteractive({ cursor: 'pointer' });
                    this._btnReplay.once('pointerup', () => {
                        onReplay(this._btnReplay);
                        if (this.music) {
                            this.music.stop();
                        }
                    });
                    setupButtonTextureBased(this._btnReplay, 'btnReplay1', 'btnReplay2');
                    this._btnNext.setInteractive({ cursor: 'pointer' });
                    this._btnNext.on('pointerup', () => {
                        onNext(this._btnNext);
                        window.angularComponentRef.nextActivity();
                        // if (this.music) {
                        //     this.music.stop();
                        // }
                    });
                    setupButtonTextureBased(this._btnNext, 'btnNEXT1', 'btnNEXT2');
                }
                show(score, starScore) {
                    window.angularComponentRef.gameFinish({ score, starScore });
                    this._cup.scale = 1.25;
                    this.scene.tweens.add({
                        targets: this._cup,
                        "scale": 1,
                        duration: 500,
                        ease: Phaser.Math.Easing.Back.Out
                    });
                    this.totalScoreTxt.text = String(window.angularComponentRef.component.userInfo.totalScore);
                    this.starScoreTxt.text = String(starScore);
                    // let music = this.scene.sound.add("viktory");
                    this.music = this.scene.sound.add("Activity completion fantastic");
                    this.music.play();
                }
            }
            screen.CompleteWindow = CompleteWindow;
        })(screen = ctb.screen || (ctb.screen = {}));
    })(ctb || (ctb = {}));

    (function (ctb) {
        var screen;
        (function (screen) {
            var Preloader = ctb.scene.Preloader;
            class GameplayScreen extends Phaser.GameObjects.Container {
                constructor(scene, gameplay) {
                    super(scene);
                    this.bgMusic = null;
                    this.delayedCallCrabsAnim = null;
                    this.wantedCrab = null;
                    this.wfsnd = null;
                    this.showCompleteWindow = (score, starScore) => {
                        let completeWindow = new screen.CompleteWindow(this.scene, (target) => {
                            playBtnClickAnim(target);
                        }, (target) => {
                            playBtnClickAnim(target);
                            this.destroyGameplay();
                            this.remove(completeWindow);
                            this.showInstructionPage();
                        }, (target) => {
                            playBtnClickAnim(target);
                        });
                        this.setInputEnabled(false);
                        delayedCall(2000, () => {
                            setPageBackground("bg-blue");
                            this.add(completeWindow);
                            completeWindow.show(score, starScore);
                            this.bgMusic.stop();
                        });
                    };
                    this.showLoseWindow = (score, starScore) => {
                        let tryAgainWindow = new screen.TryAgainWindow(this.scene, (target) => {
                            playBtnClickAnim(target);
                        }, (target) => {
                            playBtnClickAnim(target);
                            this.destroyGameplay();
                            this.remove(tryAgainWindow);
                            this.showInstructionPage();
                        });
                        this.setInputEnabled(false);
                        delayedCall(1500, () => {
                            setPageBackground("bg-blue");
                            this.add(tryAgainWindow);
                            tryAgainWindow.show(score, starScore);
                            this.bgMusic.stop();
                        });
                    };
                    this.gameplay = gameplay;
                    window["gs"] = this;
                    this._gameStage = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2, game.scale.height / 2, 'BG');
                    this._gameStage.setOrigin(0.5, 0.5);
                    this._gameStage.setScale(1.02);
                    this._gameStage.setInteractive();
                    this.add(this._gameStage);
                    this._btnClose = new Phaser.GameObjects.Image(this.scene, 1025 - 105, 100 - 50, 'x Button');
                    this._btnClose.setInteractive({ cursor: 'pointer' });
                    this._btnClose["defScale"] = this._btnClose.scale;
                    setupButtonTextureBased(this._btnClose, 'x Button', 'x Button HOVER EFFECT');
                    this.add(this._btnClose);
                    this._btnClose.on('pointerup', () => {
                        playBtnClickAnim(this._btnClose);
                        this.onCloseClick();
                    });
                }
                showGameplay() {
                    setPageBackground("bg-australia");
                    this.bgMusic = this.scene.sound.add("BG Sea sound");
                    this.bgMusic.play();
                    this.bgMusic.loop = true;
                    this.gameplayContainer = new Phaser.GameObjects.Container(this.scene);
                    this.add(this.gameplayContainer);
                    this.gameplay.reset();
                    this.prepareRound();
                    this.gameplay.setupCallbacks(this.showCompleteWindow, this.showLoseWindow, () => {
                        this.onNewRound(true);
                    });
                    this.createTallies();
                }
                _update() {
                    if (!this.selectableLetters)
                        return;
                    let plankPositions = [
                        { x: -6, y: -625 },
                        { x: -6, y: -624 },
                        { x: -6, y: -622 },
                        { x: -6, y: -618 },
                        { x: -6, y: -612 },
                        { x: -6, y: -603 },
                        { x: -6, y: -592 },
                        { x: -6, y: -582 },
                        { x: -6, y: -573 },
                        { x: -6, y: -567 },
                        { x: -6, y: -562 },
                        { x: -6, y: -559 },
                        { x: -6, y: -557 },
                        { x: -6, y: -558 },
                        { x: -6, y: -560 },
                        { x: -6, y: -573 },
                        { x: -6, y: -583 },
                        { x: -6, y: -593 },
                        { x: -6, y: -602 },
                        { x: -6, y: -609 },
                        { x: -6, y: -615 },
                        { x: -6, y: -619 },
                        { x: -6, y: -622 },
                        { x: -6, y: -624 },
                        { x: -6, y: -625 },
                        { x: -6, y: -625 },
                        { x: -6, y: -625 },
                        { x: -6, y: -625 },
                        { x: -6, y: -625 },
                        { x: -6, y: -625 },
                        { x: -6, y: -625 },
                        { x: -6, y: -623 },
                        { x: -6, y: -621 },
                        { x: -6, y: -620 },
                        { x: -6, y: -619 },
                        { x: -6, y: -618 },
                        { x: -6, y: -618 },
                        { x: -6, y: -619 },
                        { x: -6, y: -621 },
                        { x: -6, y: -623 },
                        { x: -6, y: -624 },
                        { x: -6, y: -625 },
                        { x: -6, y: -625 },
                        { x: -6, y: -625 },
                        { x: -6, y: -625 },
                        { x: -6, y: -625 },
                        { x: -6, y: -625 },
                        { x: -6, y: -625 },
                        { x: -6, y: -625 },
                        { x: -6, y: -625 }
                    ];
                    for (let sl of this.selectableLetters) {
                        if (!sl['-crab-'].anims.isPlaying)
                            continue;
                        let p = plankPositions[(sl['-crab-'].anims.currentFrame.index-1) % plankPositions.length];
                        sl["-plankContainer-"].setPosition(p['x'], (p['y'] + 625) * 0.45);
                    }
                }
                prepareRound() {
                    this.gameplayContainer.removeAll();
                    this.wantedCrab = null;
                    this.characterBird = this.scene.add.sprite(0, 0, null);
                    this.characterBird.setPosition(1175, 220);
                    if (this.gameplay.useImages) {
                        this.gameplayContainer.add(new Phaser.GameObjects.Image(this.scene, 650, 170, this.gameplay.wantedWord));
                    }
                    else {
                        let wantedWordTxt = this.scene.add.text(650, 165, "", {
                            "fontFamily": "QuranErafont",
                            "fontSize": 80,
                            "color": "#000000",
                            "align": 'center'
                        });
                        wantedWordTxt.setOrigin(0.5, 0.4);
                        wantedWordTxt.style.fixedHeight = 115;
                        wantedWordTxt.setText(this.gameplay.wantedWord);
                        this.gameplayContainer.add(wantedWordTxt);
                    }
                    let randomizedWords = Phaser.Utils.Array.Shuffle(this.gameplay.selectableWords.slice());
                    this.selectableLetters = [];
                    for (let i = 0; i < randomizedWords.length; i++) {
                        let a = new Phaser.GameObjects.Container(this.scene, 210 + i * 292, 405);
                        a.add(a["-plankContainer-"] = new Phaser.GameObjects.Container(this.scene, 0, 0));
                        a["-plankContainer-"].add(a["-image-"] = new Phaser.GameObjects.Image(this.scene, 0, 0, 'plankNormal'));
                        a["-image-"].setOrigin(0.45, 0.555);
                        a['-crab-'] = this.scene.add.sprite(5, 95, null);
                        a.add(a['-crab-']);
                        this.selectableLetters.push(a);
                        let txt;
                        if (this.gameplay.useImages) {
                            txt = new Phaser.GameObjects.Image(this.scene, 9, -10, randomizedWords[i]);
                            a["-plankContainer-"].add(txt);
                        }
                        else {
                            txt = this.scene.add.text(9, -15, "", {
                                "fontFamily": "QuranErafont",
                                "fontSize": 65,
                                "color": "#000000",
                                "align": 'center'
                            });
                            txt.setOrigin(0.5, 0.45);
                            txt.style.fixedHeight = 90;
                            txt.setText(randomizedWords[i]);
                            a["-plankContainer-"].add(txt);
                        }
                        a['startPosition'] = { x: a.x, y: a.y };
                        a["-word-"] = txt;
                        a["-word-text-"] = randomizedWords[i];
                        this.gameplayContainer.add(a);
                        a['-draggable-'] = true;
                    }
                    let fn = () => {
                        if (this.wantedCrab) {
                            return;
                        }
                        let d = 0;
                        for (let sl of this.selectableLetters) {
                            if (this.wantedCrab != sl) {
                                if (sl['-crab-']['-isAnimStarted-']) {
                                    let _d = 1 + Math.round(Math.random() * 3) * 1000;
                                    delayedCall(_d, () => {
                                        Preloader.playAnim('crab', sl['-crab-']);
                                    });
                                    d = Math.max(d, _d);
                                }
                                else {
                                    sl['-crab-']['-isAnimStarted-'] = true;
                                    Preloader.playAnim('crab', sl['-crab-']);
                                }
                            }
                        }
                        this.delayedCallCrabsAnim = delayedCall(d + 2500, fn);
                    };
                    fn();
                    for (let a of this.selectableLetters) {
                        a.setSize(a["-image-"].width, a["-image-"].height);
                        a.setInteractive({ cursor: 'pointer' });
                        a.on('pointerdown', () => {
                            this.setInputEnabled(false);
                            if (this.delayedCallCrabsAnim) {
                                destroyDelayedCall(this.delayedCallCrabsAnim);
                                this.delayedCallCrabsAnim = null;
                            }
                            if (a["-word-text-"] == this.gameplay.wantedWord) {
                                this.wantedCrab = a;
                                this.onCorrectAnswer();
                            }
                            else {
                                a['-crab-'].anims.stop();
                                a["-image-"].setTexture("plankIncorrect");
                                this.onWrongAnswer();
                                this.shakeCrab(a);
                                this.scene.sound.add("Wrong click").play();
                            }
                        });
                    }
                    this.setInputEnabled(false);
                    if (this.gameplay.isNewRound()) {
                        if (!this.gameplay.isRoundsComplete()) {
                            this.setInputEnabled(true);
                        }
                    }
                    else {
                        this.setInputEnabled(true);
                    }
                    this.gameplayContainer.add(this.characterBird);
                    this._btnClose.setInteractive({ cursor: 'pointer', pixelPerfect: true });
                }
                shakeCrab(crab) {
                    let startX = crab.x;
                    let startY = crab.y;
                    let g = (counter) => {
                        if (counter > 5)
                            return;
                        this.scene.tweens.add({
                            targets: crab,
                            x: startX + (Math.random() - 0.5) * 8,
                            y: startY + (Math.random() - 0.5) * 8,
                            duration: 50,
                            onComplete: () => { g(counter + 1); }
                        });
                    };
                    g(0);
                }
                onNewRound(showOut) {
                    this.scene.sound.add("next_round").play();
                    this.setInputEnabled(false);
                    if (showOut) {
                        this.prepareRound();
                    }
                }
                onCorrectAnswer() {
                    let i = this.gameplay.getCurrentTotalAnswersCount();
                    this.tallyEmptyArray[i].visible = false;
                    this.tally[i].visible = true;
                    let completed = this.gameplay.onCorrectAnswer();
                    this.scene.sound.add("Bird sfx").play();
                    let spd = 1000 / 1000;
                    Preloader.playAnim('bird', this.characterBird);
                    this.scene.tweens.add({
                        targets: this.characterBird,
                        x: this.wantedCrab.x - 100,
                        y: this.wantedCrab.y - 135,
                        duration: (this.characterBird.x - (this.wantedCrab.x - 100)) * spd,
                        ease: Phaser.Math.Easing.Linear,
                        onComplete: () => {
                            Preloader.playAnim('crabCaught', this.wantedCrab['-crab-']);
                            this.scene.tweens.add({
                                targets: this.characterBird,
                                x: -300,
                                y: 0,
                                duration: (this.characterBird.x - (-300)) * spd,
                                ease: Phaser.Math.Easing.Linear,
                                onUpdate: () => {
                                    this.wantedCrab.x = this.characterBird.x + 100;
                                    this.wantedCrab.y = this.characterBird.y + 135;
                                    this.wantedCrab.rotation += (Math.atan2(this.wantedCrab.y - 0, this.wantedCrab.x - (-250)) - Math.PI / 2 - this.wantedCrab.rotation) / 5;
                                }
                            });
                        }
                    });
                    this.characterBird.play('bird');
                    this.scene.sound.add("Correct click").play();
                    return completed;
                }
                onWrongAnswer() {
                    let i = this.gameplay.getCurrentTotalAnswersCount();
                    this.tallyEmptyArray[i].visible = true;
                    this.tallyEmptyArray[i].visible = true;
                    this.tally[i].visible = false;
                    for (let sl of this.selectableLetters) {
                        sl['-crab-'].anims.stop();
                    }
                    let lost = this.gameplay.onWrongAnswer();
                    this.scene.sound.add("Goose no").play();
                    return lost;
                }
                onCloseClick() {
                    this.showAreYouSurePage();
                    this.scene.sound.add('warning page pop up sfx').play();
                }
                createTallies() {
                    if (this.tally) {
                        for (let te of this.tallyEmptyArray) {
                            te.visible = false;
                            this.bringToTop(te);
                        }
                        for (let t of this.tally) {
                            t.visible = false;
                            this.bringToTop(t);
                        }
                        return;
                    }
                    let startX = 38;
                    let startY = 40;
                    let dx = 43;
                    let tallyEmptyArrayPositions = [];
                    for (let i = 0; i < 12; i++) {
                        tallyEmptyArrayPositions.push({ x: startX + i * dx, y: startY });
                    }
                    this.tallyEmptyArray = [];
                    this.tally = [];
                    for (let p of tallyEmptyArrayPositions) {
                        let _BeehiveEmpty = new Phaser.GameObjects.Image(this.scene, p['x'], p['y'], 'tally Empty');
                        this.tallyEmptyArray.push(_BeehiveEmpty);
                        _BeehiveEmpty.visible = false;
                        let _Beehive = new Phaser.GameObjects.Image(this.scene, p['x'], p['y'], 'tally');
                        this.tally.push(_Beehive);
                    }
                    for (let bea of this.tallyEmptyArray) {
                        this.add(bea);
                    }
                    for (let bee of this.tally) {
                        this.add(bee);
                        bee.visible = false;
                    }
                }
                hideAllUnusedTallies() {
                    let i = this.gameplay.getCurrentTotalAnswersCount();
                    for (let k = i + 1; k < this.tallyEmptyArray.length; k++) {
                        this.tallyEmptyArray[k].visible = false;
                        this.tally[k].visible = false;
                    }
                }
                showInstructionPage() {
                    setPageBackground("bg-blue");
                    let playInstructionSound = () => {
                        if (this.wfsnd) {
                            this.wfsnd.stop();
                        }
                        this.wfsnd = this.scene.sound.add("Match the words and catch the crab");
                        this.wfsnd.play();
                    };
                    this.instructionPage = new screen.InstructionPage(this.scene, (target) => {
                        playBtnClickAnim(target);
                        this.remove(this.instructionPage);
                        this.showGameplay();
                        if (this.wfsnd) {
                            this.wfsnd.stop();
                        }
                    }, (target) => {
                        playBtnClickAnim(target);
                        playInstructionSound();
                    });
                    this.add(this.instructionPage);
                    try {
                        playInstructionSound();
                    }
                    catch (e) {
                        console.error(e);
                    }
                }
                showAreYouSurePage() {
                    pauseAllDelayedCalls();
                    setPageBackground("bg-blue");
                    this.scene.tweens.pauseAll();
                    this.pauseSounds();
                    this.areYouSureWindow = new screen.AreYouSureWindow(this.scene, () => {
                        this.scene.tweens.resumeAll();
                        this.remove(this.areYouSureWindow);
                        this.destroyGameplay();
                        this.showInstructionPage();
                    }, () => {
                        this.scene.tweens.resumeAll();
                        this.remove(this.areYouSureWindow);
                        this.unpauseSounds();
                        resumeAllDelayedCalls();
                        setPageBackground("bg-australia");
                    });
                    this.add(this.areYouSureWindow);
                }
                setInputEnabled(enabled) {
                    if (enabled) {
                        for (let a of this.selectableLetters)
                            a.setInteractive( /*{cursor: 'pointer', pixelPerfect:true}*/);
                    }
                    else {
                        for (let a of this.selectableLetters)
                            a.disableInteractive();
                    }
                }
                pauseSounds() {
                    this.scene.sound.pauseAll();
                }
                unpauseSounds() {
                    this.scene.sound.resumeAll();
                }
                destroyGameplay() {
                    this.setInputEnabled(false);
                    this.remove(this.gameplayContainer);
                    this.scene.sound.stopAll();
                    destroyAllDelayedCalls();
                }
            }
            screen.GameplayScreen = GameplayScreen;
        })(screen = ctb.screen || (ctb.screen = {}));
    })(ctb || (ctb = {}));

    (function (ctb) {
        var screen;
        (function (screen) {
            class InstructionPage extends Phaser.GameObjects.Container {
                constructor(scene, onPlayClick, onSndClick) {
                    super(scene);
                    this._instructionPage = new Phaser.GameObjects.Image(this.scene, 0 - 105, 0 - 48, 'Instructions page  ALL ACTIVITY  TITLEs');
                    this._instructionPage.setOrigin(0, 0);
                    this._instructionPage.setInteractive();
                    this._instructionPageTitle = new Phaser.GameObjects.Image(this.scene, 495, 105, 'welcome');
                    this._instructionPageTitle.setScale(0.65);
                    this._btnPlay = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2, 480 - 50, 'btnPLAY1');
                    this._btnPlay.setInteractive({ cursor: 'pointer' });
                    this._btnPlay.once('pointerup', onPlayClick);
                    setupButtonTextureBased(this._btnPlay, 'btnPLAY1', 'btnPLAY2');
                    this.instrTxt = this.scene.add.text(game.scale.width / 2, game.scale.height / 2, "Match the words and catch the crab.", {
                        "fontFamily": "Kids Rock DEMO",
                        "fontSize": 30,
                        "color": "#43425D",
                        "align": 'center'
                    });
                    this.instrTxt.setOrigin(0.5, 0.5);
                    this.instrTxt.setWordWrapWidth(600);
                    this.instrTxt.setLineSpacing(5);
                    this._btnSoundInstruction = new Phaser.GameObjects.Image(this.scene, 800 - 105, 156 - 50, 'Sound');
                    this._btnSoundInstruction.setInteractive({ cursor: 'pointer' });
                    this._btnSoundInstruction.on('pointerup', onSndClick);
                    this._btnSoundInstruction["defScale"] = this._btnSoundInstruction.scale;
                    setupButtonTextureBased(this._btnSoundInstruction, 'Sound', 'Sound HOVER EFFECT');
                    this.add(this._instructionPage);
                    this.add(this._instructionPageTitle);
                    this.add(this.instrTxt);
                    this.add(this._btnPlay);
                    this.add(this._btnSoundInstruction);
                }
            }
            screen.InstructionPage = InstructionPage;
        })(screen = ctb.screen || (ctb.screen = {}));
    })(ctb || (ctb = {}));

    (function (ctb) {
        var screen;
        (function (screen) {
            class TryAgainWindow extends Phaser.GameObjects.Container {
                constructor(scene, onBack, onReplay) {
                    super(scene);
                    this.music = null;
                    this.setPosition(-106, -48);
                    this._bg = new Phaser.GameObjects.Image(this.scene, 0, 0, 'Try again page');
                    this._bg.setOrigin(0, 0);
                    this._bg.setInteractive();
                    this._star = new Phaser.GameObjects.Image(this.scene, 400, 415, 'Break Star');
                    this._btnBack = new Phaser.GameObjects.Image(this.scene, 600, 580, 'btnBACK1');
                    this._btnReplay = new Phaser.GameObjects.Image(this.scene, 765, 580, 'btnReplay1');
                    this.totalScoreTxt = this.scene.add.text(830, 355, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 35,
                        "color": "#F49F1C",
                        "align": 'center',
                        'stroke': '#70451A',
                        'strokeThickness': 6
                    });
                    this.totalScoreTxt.setOrigin(0.5, 0.5);
                    let grd = this.totalScoreTxt.context.createLinearGradient(0, 0, 0, this.totalScoreTxt.height);
                    grd.addColorStop(0, '#FFFF00');
                    grd.addColorStop(1, '#C17316');
                    this.totalScoreTxt.setFill(grd);
                    this.starScoreTxt = this.scene.add.text(635, 431, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 24,
                        "color": "#FFFFFF",
                        "align": 'center'
                    });
                    this.starScoreTxt.setOrigin(0.5, 0.5);
                    this.add([
                        this._bg,
                        this._star,
                        this._btnBack,
                        this._btnReplay,
                        this.totalScoreTxt,
                        this.starScoreTxt
                    ]);
                    this._btnBack.setInteractive({ cursor: 'pointer' });
                    this._btnBack.on('pointerup', () => {
                        onBack(this._btnBack);
                        window.angularComponentRef.backToMenu();
                        // if (this.music) {
                        //     this.music.stop();
                        // }
                    });
                    setupButtonTextureBased(this._btnBack, 'btnBACK1', 'btnBACK2');
                    this._btnReplay.setInteractive({ cursor: 'pointer' });
                    this._btnReplay.once('pointerup', () => {
                        onReplay(this._btnReplay);
                        if (this.music) {
                            this.music.stop();
                        }
                    });
                    setupButtonTextureBased(this._btnReplay, 'btnReplay1', 'btnReplay2');
                }
                show(score, starScore) {
                    this._star.scale = 1.25;
                    this.scene.tweens.add({
                        targets: this._star,
                        "scale": 1,
                        duration: 500,
                        ease: Phaser.Math.Easing.Back.Out
                    });
                    this.totalScoreTxt.text = String(window.angularComponentRef.component.userInfo.totalScore);
                    this.starScoreTxt.text = String(starScore);
                    this.music = this.scene.sound.add("Fail - close one");
                    this.music.play();
                }
            }
            screen.TryAgainWindow = TryAgainWindow;
        })(screen = ctb.screen || (ctb.screen = {}));
    })(ctb || (ctb = {}));

    game = new ctb.App(json);
};

function destroyCatchTheCrab() {
    if (game) {
        game.destroy();
    }
}

var ctb;
var game;

var rocketLaunch = (json) => {
    (function (ctb) {
        class App extends Phaser.Game {
            constructor(json) {
                App.json = json;
                let config = {
                    type: Phaser.AUTO,
                    width: App.CANVAS_WIDTH,
                    height: App.CANVAS_HEIGHT,
                    parent: 'game-container',
                    dom: {
                        createContainer: false
                    },
                    scale: {
                        mode: FitScaleManager.detectBestScaleMode(),
                        autoCenter: Phaser.Scale.CENTER_BOTH
                    },
                    transparent: true,
                    scene: {
                        create: () => {
                            this.scene.add('Boot', ctb.scene.Boot, true);
                        }
                    }
                };
                super(config);
            }
        }
        App.CANVAS_WIDTH = 980;
        App.CANVAS_HEIGHT = 600;
        ctb.App = App;
    })(ctb || (ctb = {}));

    var delayedCalls = [];
    function delayedCall(delay, callback, args, callbackScope) {
        let scene = game.scene.getAt(0);
        if (scene) {
            let dc = scene.time.delayedCall(delay, callback, args, callbackScope);
            delayedCalls.push(dc);
            return dc;
        }
        let t = setTimeout(callback, delay);
        delayedCalls.push(t);
        return t;
    }
    function pauseAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.paused = true;
            }
        }
    }
    function resumeAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.paused = false;
            }
        }
    }
    function destroyAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.remove(false);
            }
            else {
                clearTimeout(dc);
            }
        }
        delayedCalls = [];
    }
    function destroyDelayedCall(dc) {
        if (dc instanceof Phaser.Time.TimerEvent) {
            dc.remove(false);
        }
        else {
            clearTimeout(dc);
        }
        let ind = delayedCalls.indexOf(dc);
        if (ind >= 0)
            delayedCalls.splice(ind, 1);
    }
    function setPageBackground(bg) {
        // document.querySelector("html").style.backgroundImage = "url(assets/imgs/" + bg + ".jpg)";
    }
    function setupButton(btn, frame) {
        btn.on('pointerdown', () => { btn.setFrame(frame + '_hover' + '0000'); });
        btn.on('pointerover', () => { btn.setFrame(frame + '_hover' + '0000'); game.scene.getAt(0).sound.add("button hover").play(); });
        btn.on('pointerout', () => { btn.setFrame(frame + '0000'); });
        btn.on('pointerup', () => { btn.setFrame(frame + '0000'); game.scene.getAt(0).sound.add('activity selection - button selection').play(); });
    }
    function setupButtonTextureBased(btn, texture, hoverTexture) {
        btn.on('pointerdown', () => { btn.setTexture(hoverTexture); });
        btn.on('pointerover', () => { btn.setTexture(hoverTexture); game.scene.getAt(0).sound.add("button hover").play(); });
        btn.on('pointerout', () => { btn.setTexture(texture); });
        btn.on('pointerup', () => { btn.setTexture(texture); game.scene.getAt(0).sound.add('activity selection - button selection').play(); });
    }
    function playBtnClickAnim(target) {
        let sc = target.hasOwnProperty("defScale") ? target["defScale"] : 1;
        target.scaleX = target.scaleY = sc;
        let scene = game.scene.getAt(0);
        scene.tweens.add({
            targets: target,
            "scaleX": 0.9 * sc,
            "scaleY": 0.9 * sc,
            duration: 100,
            yoyo: true
        });
    }
    /**
     * @author Roman Parada
     * This class is created to fix overlapping of bottom part of canvas by navigation bar in iOS.
     * It make a delayed resize of the canvas (like Phaser-3 FIT methods does) and it overrides Phaser-3 input window to Phaser-3 core transform methods
     *
     * How to use:
     * Just call the code line below in Boot scene's init() method of your project:
     * new FitScaleManager(this.game).setup();
     */
    class FitScaleManager {
        constructor(game) {
            this.doResize = () => {
                let scale = this.calculateScale();
                let newCanvasWidth = this.phaserScaleManager.width * scale;
                let newCanvasHeight = this.phaserScaleManager.height * scale;
                this.canvasStyle.width = newCanvasWidth + 'px';
                this.canvasStyle.height = newCanvasHeight + 'px';
                this.canvasStyle.marginLeft = (window.innerWidth - newCanvasWidth) / 2 + 'px';
                this.canvasStyle.marginTop = (window.innerHeight - newCanvasHeight) / 2 + 'px';
            };
            this.game = game;
            this.canvasStyle = this.game.canvas.style;
            this.phaserScaleManager = this.game.scale;
        }
        static detectBestScaleMode() {
            let iOS = /iPad|iPhone|iPod/.test(navigator.platform || "");
            let isAndroid = window.navigator.userAgent.toLowerCase().indexOf("android") > -1;
            return iOS || isAndroid ? Phaser.Scale.FIT : Phaser.Scale.NONE;
        }
        ;
        /**
         * Just call this method once in Boot scene's init() method
         */
        setup() {
            this.phaserScaleManager.addListener(Phaser.Scale.Events.RESIZE, this.onResize, this);
            this.overridePhaserTransformMethods();
            this.onResize();
        }
        calculateScale() {
            if (game.scale.scaleMode == Phaser.Scale.NONE)
                return 1;
            return Math.min(window.innerWidth / this.phaserScaleManager.width, window.innerHeight / this.phaserScaleManager.height);
        }
        overridePhaserTransformMethods() {
            this.game.scale.transformX = (pageX) => {
                return (pageX - parseInt(this.canvasStyle.marginLeft.split("px")[0])) / this.calculateScale();
            };
            this.game.scale.transformY = (pageY) => {
                return (pageY - parseInt(this.canvasStyle.marginTop.split("px")[0])) / this.calculateScale();
            };
        }
        onResize() {
            setTimeout(this.doResize, FitScaleManager.RESIZE_DELAY);
        }
    }
    FitScaleManager.RESIZE_DELAY = 500;

    (function (ctb) {
        var core;
        (function (core) {
            class Gameplay {
                constructor() {
                    this.currentRound = 0;
                    this.correctAnswersCount = 0;
                    this.wrongAnswersCount = 0;
                    this.correctAnswersCountThisRound = 0;
                    this.wrongAnswersCountThisRound = 0;
                    this.onNewRound = null;
                    this.nextLetterDelay = 0;
                    this.words = game.cache.json.get('gameplay')['words'];
                    this.failsNumToLose = 4;
                    this.useImages = Boolean(game.cache.json.get('gameplay')["useImages"]);
                }
                setupCallbacks(onComplete, onLose, onNewRound) {
                    this.onComplete = onComplete;
                    this.onLose = onLose;
                    this.onNewRound = onNewRound;
                }
                calculateScore() {
                    return this.totalRoundsNum - this.wrongAnswersCount;
                }
                onLetterChosen() {
                    this.currentRound++;
                    if (this.currentRound >= this.totalRoundsNum) {
                        let score = this.calculateScore();
                        this.onComplete(score, score);
                        return true;
                    }
                    else {
                        this.nextLetter();
                    }
                    return false;
                }
                nextLetter() {
                    let fn = () => {
                        let thisRound = this.rounds.shift();
                        this.wantedWord = thisRound["wantedWord"];
                        this.selectableWords = thisRound["selectableWords"];
                        this.selectableImages = [];
                        this.correctAnswersCountThisRound = 0;
                        this.wrongAnswersCountThisRound = 0;
                        this.words.map(word => {
                            if (this.selectableWords.includes(word.word)) {
                                this.selectableImages[this.selectableWords.indexOf(word.word)] = word.image
                            }
                            if (word.word === this.wantedWord[0]) {
                                this.wantedImage = word.image;
                            }
                        });
                        if (this.onNewRound)
                            this.onNewRound();
                    };
                    if (this.nextLetterDelay == 0) {
                        fn();
                    }
                    else {
                        delayedCall(this.nextLetterDelay, fn);
                    }
                }
                onCorrectAnswer() {
                    this.correctAnswersCount++;
                    this.correctAnswersCountThisRound++;
                    this.nextLetterDelay = 3500;
                    return this.onLetterChosen();
                }
                onWrongAnswer() {
                    this.wrongAnswersCount++;
                    this.wrongAnswersCountThisRound++;
                    this.nextLetterDelay = 1500;
                    if (this.wrongAnswersCount >= this.failsNumToLose) {
                        this.onLose(0, 0);
                        return true;
                    }
                    else {
                        this.onLetterChosen();
                    }
                    return false;
                }
                getCurrentTotalAnswersCount() {
                    return this.correctAnswersCount + this.wrongAnswersCount;
                }
                getCurrentTotalAnswersCountThisRound() {
                    return this.correctAnswersCountThisRound + this.wrongAnswersCountThisRound;
                }
                isNewRound() {
                    return this.getCurrentTotalAnswersCountThisRound() == 0;
                }
                isRoundsComplete() {
                    return this.currentRound >= this.totalRoundsNum;
                }
                getAudioKeyOfChar(letter) {
                    let json = game.cache.json.get('gameplay');
                    let letters = json["letters"];
                    for (let d of letters) {
                        if (letter == d['letterName']) {
                            return d['audioKey'];
                        }
                    }
                    return null;
                }
                reset() {
                    this.nextLetterDelay = 0;
                    this.setupCallbacks(null, null, null);
                    let json = game.cache.json.get('gameplay');
                    this.rounds = json["rounds"].slice();
                    this.totalRoundsNum = this.rounds.length;
                    this.nextLetter();
                    this.currentRound = 0;
                    this.correctAnswersCount = 0;
                    this.wrongAnswersCount = 0;
                    this.correctAnswersCountThisRound = 0;
                    this.wrongAnswersCountThisRound = 0;
                }
            }
            core.Gameplay = Gameplay;
        })(core = ctb.core || (ctb.core = {}));
    })(ctb || (ctb = {}));

    (function (ctb) {
        var scene;
        (function (scene) {
            class Boot extends Phaser.Scene {
                init() {
                    this.game.scale.transformX = (pageX) => {
                        let offsetLeft = 0;
                        let parentElement = game.canvas.parentElement;
                        while (parentElement) {
                            if (parentElement.offsetLeft) {
                                offsetLeft = parentElement.offsetLeft;
                                break;
                            }
                            parentElement = parentElement.parentElement;
                        }
                        return (pageX - offsetLeft) * this.game.scale.displayScale.x;
                    };
                    this.game.scale.transformY = (pageY) => {
                        let offsetTop = 0;
                        let parentElement = game.canvas.parentElement;
                        while (parentElement) {
                            if (parentElement.offsetTop) {
                                offsetTop = parentElement.offsetTop;
                                break;
                            }
                            parentElement = parentElement.parentElement;
                        }
                        return (pageY - offsetTop) * this.game.scale.displayScale.y;
                    };
                }
                create() {
                    game.scene.remove('Boot');
                    game.scene.add('Preloader', ctb.scene.Preloader, true);
                }
            }
            scene.Boot = Boot;
        })(scene = ctb.scene || (ctb.scene = {}));
    })(ctb || (ctb = {}));

    (function (ctb) {
        var scene;
        (function (scene) {
            var Gameplay = ctb.core.Gameplay;
            class MainScene extends Phaser.Scene {
                create() {
                    this.gameplay = new Gameplay();
                    this.gameplayScreen = new ctb.screen.GameplayScreen(this, this.gameplay);
                    this.children.add(this.gameplayScreen);
                    this.gameplayScreen.showInstructionPage();
                }
                update() {
                    this.gameplayScreen._update();
                }
            }
            scene.MainScene = MainScene;
        })(scene = ctb.scene || (ctb.scene = {}));
    })(ctb || (ctb = {}));

    (function (ctb) {
        var scene;
        (function (scene) {
            class Preloader extends Phaser.Scene {
                preload() {
                    if (typeof ctb.App.json == "string") this.load.json('gameplay', ctb.App.json); else this.game.cache.json.add('gameplay', ctb.App.json);
                }
                create() {
                    let json = game.cache.json.get('gameplay');
                    if (json["useImages"]) {
                        for (let w of json["words"]) {
                            if (w["word"] && !w["word"].includes('http')) {
                                this.load.image(w["word"], "assets/games/rocket-launch/imgs/words/" + w["word"] + ".png");
                            } else {
                                this.load.image(w["word"], w["word"]);
                            }
                            if (w["audioKey"]) {
                                this.load.audio(w["audioKey"], "assets/games/rocket-launch/sound/mp3/words/" + w["audioKey"] + ".mp3");
                            }
                        }
                    }
                    let progressTxt = this.add.text(game.scale.width / 2, game.scale.height / 2 + 50, "", {
                        "fontFamily": "QuranErafont",
                        "fontSize": 25,
                        "color": "#000000",
                        "align": 'center'
                    });
                    progressTxt.setOrigin(0.5, 0.5);
                    this.load.pack('preloader', 'assets/games/rocket-launch/pack.json');
                    this.load.on('progress', (value) => {
                        progressTxt.text = Math.ceil(value * 100) + "%";
                    }, this);
                    this.load.on('complete', () => {
                        this.nextScene();
                    });
                    this.load.start();
                }
                static playAnim(animKey, sprite, onComplete = null) {
                    let mainScene = game.scene.getScene('ScreenMain');
                    if (!mainScene.anims.exists(animKey)) {
                        let data = Preloader.ANIMS_DATA[animKey];
                        mainScene.anims.create({
                            key: animKey,
                            frames: mainScene.anims.generateFrameNames(data['atlas'], {
                                start: data['start'], end: data['end'], zeroPad: data['padNum'],
                                prefix: data['prefix'], suffix: ''
                            }),
                            frameRate: data['frameRate'],
                            repeat: data['repeat']
                        });
                    }
                    if (sprite.anims.currentAnim) {
                        sprite.anims.currentAnim.off('complete');
                    }
                    sprite.anims.stop();
                    sprite.play(animKey);
                    sprite.anims.currentAnim.once('complete', () => {
                        if (onComplete)
                            onComplete();
                    });
                    return sprite;
                }
                nextScene() {
                    game.scene.remove('Preloader');
                    game.scene.add('ScreenMain', ctb.scene.MainScene, true);
                }
            }
            Preloader.ANIMS_DATA = {
                'rocket-start': {
                    'start': 1,
                    'end': 61,
                    'padNum': 4,
                    'prefix': 'Rocket v2',
                    'repeat': 0,
                    'frameRate': 24,
                    'atlas': 'rocket-atlas'
                }
            };
            scene.Preloader = Preloader;
        })(scene = ctb.scene || (ctb.scene = {}));
    })(ctb || (ctb = {}));

    (function (ctb) {
        var screen;
        (function (screen) {
            class AreYouSureWindow extends Phaser.GameObjects.Container {
                constructor(scene, onYes, onNo) {
                    super(scene);
                    this._areYouSurePage = new Phaser.GameObjects.Image(this.scene, -105, 0 - 48, 'Exit warning');
                    this._areYouSurePage.setOrigin(0, 0);
                    this._areYouSurePage.setInteractive();
                    this._btnSureYes = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2 - 95, 485 - 50, 'btnYES1');
                    this._btnSureYes.setInteractive({ cursor: 'pointer' });
                    this._btnSureYes.once('pointerup', () => {
                        onYes;
                        window.angularComponentRef.backToMenu();
                    });

                    var modalTextStyle = {
                        backgroundColor: 'transparent',
                        stroke: '#ffffff',
                        strokeThickness: 2,
                        lineSpacing: 15,
                        fontFamily: 'Kids Rock DEMO',
                        fontSize: 27,
                        color: '#43425d',
                        wordWrap: true,
                        align: 'center'
                    };
                    var modalText = this.scene.add.text(game.scale.width / 2 + 12, game.scale.height / 2, "Your progress in this activity will not be saved. \n Are you sure you want to exit? ", modalTextStyle);
                    modalText.setOrigin(0.5, 0.5);

                    setupButtonTextureBased(this._btnSureYes, 'btnYES1', 'btnYES2');
                    this._btnSureNo = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2 + 95, 485 - 50, 'btnNO1');
                    this._btnSureNo.setInteractive({ cursor: 'pointer' });
                    this._btnSureNo.once('pointerup', onNo);
                    setupButtonTextureBased(this._btnSureNo, 'btnNO1', 'btnNO2');
                    this.add(this._areYouSurePage);
                    this.add(this._btnSureYes);
                    this.add(this._btnSureNo);
                    this.add(modalText);
                }
            }
            screen.AreYouSureWindow = AreYouSureWindow;
        })(screen = ctb.screen || (ctb.screen = {}));
    })(ctb || (ctb = {}));

    (function (ctb) {
        var screen;
        (function (screen) {
            class CompleteWindow extends Phaser.GameObjects.Container {
                constructor(scene, onBack, onReplay, onNext) {
                    super(scene);
                    this.music = null;
                    this.setPosition(-104.5, -48);
                    this._bgComplete = new Phaser.GameObjects.Image(this.scene, 0, 0, 'Completion page LATEST UPDATED');
                    this._bgComplete.setOrigin(0, 0);
                    this._bgComplete.setInteractive();
                    this._cup = new Phaser.GameObjects.Image(this.scene, 400, 410, 'Trophy');
                    this._btnBack = new Phaser.GameObjects.Image(this.scene, 570, 570, 'btnBACK1');
                    this._btnReplay = new Phaser.GameObjects.Image(this.scene, 720, 570, 'btnReplay1');
                    this._btnNext = new Phaser.GameObjects.Image(this.scene, 870, 570, 'btnNEXT1');
                    let _CollectedPoints = new Phaser.GameObjects.Image(this.scene, 620, 440, 'Collected Points');
                    this.totalScoreTxt = this.scene.add.text(845, 352, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 35,
                        "color": "#F49F1C",
                        "align": 'center',
                        'stroke': '#70451A',
                        'strokeThickness': 6
                    });
                    this.totalScoreTxt.setOrigin(0.5, 0.5);
                    let grd = this.totalScoreTxt.context.createLinearGradient(0, 0, 0, this.totalScoreTxt.height);
                    grd.addColorStop(0, '#FFFF00');
                    grd.addColorStop(1, '#C17316');
                    this.totalScoreTxt.setFill(grd);
                    this.starScoreTxt = this.scene.add.text(648, 433, "", {
                        "fontFamily": "Kids Rock DEMO",
                        "fontSize": 24,
                        "color": "#FFFFFF",
                        "align": 'center'
                    });
                    this.starScoreTxt.setOrigin(0.5, 0.5);
                    this.add([
                        this._bgComplete,
                        _CollectedPoints,
                        this._cup,
                        this._btnBack,
                        this._btnReplay,
                        this._btnNext,
                        this.totalScoreTxt,
                        this.starScoreTxt
                    ]);
                    this._btnBack.setInteractive({ cursor: 'pointer' });
                    this._btnBack.on('pointerup', () => {
                        onBack(this._btnBack);
                        window.angularComponentRef.backToMenu();
                        // if (this.music) {
                        //     this.music.stop();
                        // }
                    });
                    setupButtonTextureBased(this._btnBack, 'btnBACK1', 'btnBACK2');
                    this._btnReplay.setInteractive({ cursor: 'pointer' });
                    this._btnReplay.once('pointerup', () => {
                        onReplay(this._btnReplay);
                        if (this.music) {
                            this.music.stop();
                        }
                    });
                    setupButtonTextureBased(this._btnReplay, 'btnReplay1', 'btnReplay2');
                    this._btnNext.setInteractive({ cursor: 'pointer' });
                    this._btnNext.on('pointerup', () => {
                        onNext(this._btnNext);
                        window.angularComponentRef.nextActivity();
                        // if (this.music) {
                        //     this.music.stop();
                        // }
                    });
                    setupButtonTextureBased(this._btnNext, 'btnNEXT1', 'btnNEXT2');
                }
                show(score, starScore) {
                    window.angularComponentRef.gameFinish({ score, starScore });
                    this._cup.scale = 1.25;
                    this.scene.tweens.add({
                        targets: this._cup,
                        "scale": 1,
                        duration: 500,
                        ease: Phaser.Math.Easing.Back.Out
                    });
                    this.totalScoreTxt.text = String(window.angularComponentRef.component.userInfo.totalScore);
                    this.starScoreTxt.text = String(starScore);
                    // let music = this.scene.sound.add("viktory");
                    this.music = this.scene.sound.add("Activity completion fantastic");
                    this.music.play();
                }
            }
            screen.CompleteWindow = CompleteWindow;
        })(screen = ctb.screen || (ctb.screen = {}));
    })(ctb || (ctb = {}));

    (function (ctb) {
        var screen;
        (function (screen) {
            var Preloader = ctb.scene.Preloader;
            class GameplayScreen extends Phaser.GameObjects.Container {
                constructor(scene, gameplay) {
                    super(scene);
                    this.bgMusic = null;
                    this.delayedCallCrabsAnim = null;
                    this.wfsnd = null;
                    this.showCompleteWindow = (score, starScore) => {
                        let completeWindow = new screen.CompleteWindow(this.scene, (target) => {
                            playBtnClickAnim(target);
                        }, (target) => {
                            playBtnClickAnim(target);
                            this.destroyGameplay();
                            this.remove(completeWindow);
                            this.showInstructionPage();
                        }, (target) => {
                            playBtnClickAnim(target);
                        });
                        this.setInputEnabled(false);
                        delayedCall(4000, () => {
                            setPageBackground("bg-blue");
                            this.add(completeWindow);
                            completeWindow.show(score, starScore);
                            this.bgMusic.stop();
                        });
                    };
                    this.showLoseWindow = (score, starScore) => {
                        let tryAgainWindow = new screen.TryAgainWindow(this.scene, (target) => {
                            playBtnClickAnim(target);
                        }, (target) => {
                            playBtnClickAnim(target);
                            this.destroyGameplay();
                            this.remove(tryAgainWindow);
                            this.showInstructionPage();
                        });
                        this.setInputEnabled(false);
                        delayedCall(1500, () => {
                            setPageBackground("bg-blue");
                            this.add(tryAgainWindow);
                            tryAgainWindow.show(score, starScore);
                            this.bgMusic.stop();
                        });
                    };
                    this.gameplay = gameplay;
                    window["gs"] = this;
                    this._gameStage = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2, game.scale.height / 2, 'BG');
                    this._gameStage.setOrigin(0.5, 0.5);
                    this._gameStage.setScale(1.02);
                    this._gameStage.setInteractive();
                    this.add(this._gameStage);
                    this._btnClose = new Phaser.GameObjects.Image(this.scene, 1025 - 105, 100 - 50, 'x Button');
                    this._btnClose.setInteractive({ cursor: 'pointer' });
                    this._btnClose["defScale"] = this._btnClose.scale;
                    setupButtonTextureBased(this._btnClose, 'x Button', 'x Button HOVER EFFECT');
                    this.add(this._btnClose);
                    this._btnClose.on('pointerup', () => {
                        playBtnClickAnim(this._btnClose);
                        this.onCloseClick();
                    });
                }
                showGameplay() {
                    setPageBackground("bg-australia");
                    this.bgMusic = this.scene.sound.add("Bachground ambience");
                    this.bgMusic.play();
                    this.bgMusic.loop = true;
                    this.gameplayContainer = new Phaser.GameObjects.Container(this.scene);
                    this.addAt(this.gameplayContainer, this.getIndex(this._btnClose));
                    this.gameplay.reset();
                    this.prepareRound();
                    this.gameplay.setupCallbacks(this.showCompleteWindow, this.showLoseWindow, () => {
                        this.onNewRound(true);
                    });
                    this.createTallies();
                }
                _update() {
                    if (!this.selectableLetters)
                        return;
                }
                prepareRound() {
                    this.gameplayContainer.removeAll();
                    this.characterBirdContainer = new Phaser.GameObjects.Container(this.scene);
                    this.gameplayContainer.addAt(this.characterBirdContainer, 0);
                    this.characterBirdContainer.setPosition(0, 0);
                    this.characterBird = this.scene.add.sprite(510, 305, "rocket-atlas", "Rocket v20001");
                    this.characterBirdContainer.add(this.characterBird);
                    if (this.gameplay.useImages) {
                        this.wantedWord = new Phaser.GameObjects.Image(this.scene, 805, 230, this.gameplay.wantedWord);
                        this.characterBirdContainer.add(this.wantedWord);
                    }
                    else {
                        this.wantedWord = this.scene.add.text(805, 230, "", {
                            "fontFamily": "QuranErafont",
                            "fontSize": 80,
                            "color": "#000000",
                            "align": 'center'
                        });
                        this.wantedWord.setOrigin(0.5, 0.4);
                        this.wantedWord.style.fixedHeight = 115;
                        this.wantedWord.setText(this.gameplay.wantedWord);
                        this.characterBirdContainer.add(this.wantedWord);
                    }
                    this.wantedWord["-defY-"] = this.wantedWord.y;
                    this.wantedWord.alpha = 1;

                    let randomizedWords = Phaser.Utils.Array.Shuffle(this.gameplay.selectableWords.slice());
                    this.selectableLetters = [];
                    var _positions = [{ x: 183, y: 226 }, { x: 363, y: 324 }, { x: 545, y: 228 }];
                    for (let i = 0; i < randomizedWords.length; i++) {
                        let a = new Phaser.GameObjects.Container(this.scene, _positions[i].x, _positions[i].y);
                        a.add(a["-plankContainer-"] = new Phaser.GameObjects.Container(this.scene, 0, 0));
                        a["-plankContainer-"].add(a["-image-"] = new Phaser.GameObjects.Image(this.scene, 0, 0, 'plankNormal'));
                        a["-image-"].setOrigin(0.45, 0.555);
                        this.selectableLetters.push(a);
                        let txt;
                        if (this.gameplay.useImages) {
                            txt = new Phaser.GameObjects.Image(this.scene, 9, -10, randomizedWords[i]);
                            a["-plankContainer-"].add(txt);
                        }
                        else {
                            txt = this.scene.add.text(9, -15, "", {
                                "fontFamily": "QuranErafont",
                                "fontSize": 65,
                                "color": "#000000",
                                "align": 'center'
                            });
                            txt.setOrigin(0.5, 0.45);
                            txt.style.fixedHeight = 90;
                            txt.setText(randomizedWords[i]);
                            a["-plankContainer-"].add(txt);
                        }
                        a['startPosition'] = { x: a.x, y: a.y };
                        a["-word-"] = txt;
                        a["-word-text-"] = randomizedWords[i];
                        this.gameplayContainer.add(a);
                        a['-draggable-'] = true;
                    }
                    for (let a of this.selectableLetters) {
                        a.setSize(a["-image-"].width, a["-image-"].height);
                        a.setInteractive({ cursor: 'pointer', pixelPerfect: true, alphaTolerance: 120 });
                        a.on('pointerdown', () => {
                            this.setInputEnabled(false);
                            if (this.delayedCallCrabsAnim) {
                                destroyDelayedCall(this.delayedCallCrabsAnim);
                                this.delayedCallCrabsAnim = null;
                            }
                            if (a["-word-text-"] == this.gameplay.wantedWord) {
                                a["-image-"].setTexture("plankCorrect");
                                this.onCorrectAnswer();
                            }
                            else {
                                a["-image-"].setTexture("plankIncorrect");
                                this.onWrongAnswer();
                                this.scene.sound.add("Wrong click").play();
                            }
                        });
                    }
                    this.setInputEnabled(false);
                    if (this.gameplay.isNewRound()) {
                        if (!this.gameplay.isRoundsComplete()) {
                            this.setInputEnabled(true);
                        }
                    }
                    else {
                        this.setInputEnabled(true);
                    }
                    this._btnClose.setInteractive({ cursor: 'pointer', pixelPerfect: true });
                }
                onNewRound(showOut) {
                    this.scene.sound.add("next_round").play();
                    this.setInputEnabled(false);
                    if (showOut) {
                        this.prepareRound();
                    }
                }
                onCorrectAnswer() {
                    let i = this.gameplay.getCurrentTotalAnswersCount();
                    this.tallyEmptyArray[i].visible = false;
                    this.tally[i].visible = true;
                    let completed = this.gameplay.onCorrectAnswer();
                    Preloader.playAnim('rocket-start', this.characterBird);
                    this.scene.tweens.add({
                        targets: this.characterBirdContainer,
                        y: -700,
                        duration: 9500,
                        ease: Phaser.Math.Easing.Circular.In
                    });
                    this.scene.tweens.add({
                        targets: this.wantedWord,
                        alpha: 0,
                        duration: 1000,
                        ease: Phaser.Math.Easing.Circular.In
                    });
                    this.characterBird.play('rocket-start');
                    this.scene.sound.add("Rocket Launch").play();
                    this.scene.sound.add("Correct click").play();
                    return completed;
                }
                onWrongAnswer() {
                    let i = this.gameplay.getCurrentTotalAnswersCount();
                    this.tallyEmptyArray[i].visible = true;
                    this.tallyEmptyArray[i].visible = true;
                    this.tally[i].visible = false;
                    let lost = this.gameplay.onWrongAnswer();
                    // this.scene.sound.add("Goose no").play();
                    return lost;
                }
                onCloseClick() {
                    this.showAreYouSurePage();
                    this.scene.sound.add('warning page pop up sfx').play();
                }
                createTallies() {
                    if (this.tally) {
                        for (let te of this.tallyEmptyArray) {
                            te.visible = false;
                            this.bringToTop(te);
                        }
                        for (let t of this.tally) {
                            t.visible = false;
                            this.bringToTop(t);
                        }
                        return;
                    }
                    let startX = 66;
                    let startY = 45;
                    let dx = 46;
                    let tallyEmptyArrayPositions = [];
                    for (let i = 0; i < 12; i++) {
                        tallyEmptyArrayPositions.push({ x: startX + i * dx, y: startY });
                    }
                    this.tallyEmptyArray = [];
                    this.tally = [];
                    for (let p of tallyEmptyArrayPositions) {
                        let _BeehiveEmpty = new Phaser.GameObjects.Image(this.scene, p['x'], p['y'], 'tally Empty');
                        this.tallyEmptyArray.push(_BeehiveEmpty);
                        _BeehiveEmpty.visible = false;
                        let _Beehive = new Phaser.GameObjects.Image(this.scene, p['x'], p['y'], 'tally');
                        this.tally.push(_Beehive);
                    }
                    for (let bea of this.tallyEmptyArray) {
                        this.add(bea);
                    }
                    for (let bee of this.tally) {
                        this.add(bee);
                        bee.visible = false;
                    }
                }
                hideAllUnusedTallies() {
                    let i = this.gameplay.getCurrentTotalAnswersCount();
                    for (let k = i + 1; k < this.tallyEmptyArray.length; k++) {
                        this.tallyEmptyArray[k].visible = false;
                        this.tally[k].visible = false;
                    }
                }
                showInstructionPage() {
                    setPageBackground("bg-blue");
                    let playInstructionSound = () => {
                        if (this.wfsnd) {
                            this.wfsnd.stop();
                        }
                        this.wfsnd = this.scene.sound.add("Introduction");
                        this.wfsnd.play();
                    };
                    this.instructionPage = new screen.InstructionPage(this.scene, (target) => {
                        playBtnClickAnim(target);
                        this.remove(this.instructionPage);
                        this.showGameplay();
                        if (this.wfsnd) {
                            this.wfsnd.stop();
                        }
                    }, (target) => {
                        playBtnClickAnim(target);
                        playInstructionSound();
                    });
                    this.add(this.instructionPage);
                    try {
                        playInstructionSound();
                    }
                    catch (e) {
                        console.error(e);
                    }
                }
                showAreYouSurePage() {
                    pauseAllDelayedCalls();
                    setPageBackground("bg-blue");
                    this.scene.tweens.pauseAll();
                    this.pauseSounds();
                    this.areYouSureWindow = new screen.AreYouSureWindow(this.scene, () => {
                        this.scene.tweens.resumeAll();
                        this.remove(this.areYouSureWindow);
                        this.destroyGameplay();
                        this.showInstructionPage();
                    }, () => {
                        this.scene.tweens.resumeAll();
                        this.remove(this.areYouSureWindow);
                        this.unpauseSounds();
                        resumeAllDelayedCalls();
                        setPageBackground("bg-australia");
                    });
                    this.add(this.areYouSureWindow);
                }
                setInputEnabled(enabled) {
                    if (enabled) {
                        for (let a of this.selectableLetters)
                            a.setInteractive( /*{cursor: 'pointer', pixelPerfect:true}*/);
                    }
                    else {
                        for (let a of this.selectableLetters)
                            a.disableInteractive();
                    }
                }
                pauseSounds() {
                    this.scene.sound.pauseAll();
                }
                unpauseSounds() {
                    this.scene.sound.resumeAll();
                }
                destroyGameplay() {
                    this.setInputEnabled(false);
                    this.remove(this.gameplayContainer);
                    this.scene.sound.stopAll();
                    destroyAllDelayedCalls();
                }
            }
            screen.GameplayScreen = GameplayScreen;
        })(screen = ctb.screen || (ctb.screen = {}));
    })(ctb || (ctb = {}));

    (function (ctb) {
        var screen;
        (function (screen) {
            class InstructionPage extends Phaser.GameObjects.Container {
                constructor(scene, onPlayClick, onSndClick) {
                    super(scene);
                    this._instructionPage = new Phaser.GameObjects.Image(this.scene, 0 - 105, 0 - 48, 'Instructions page  ALL ACTIVITY  TITLEs');
                    this._instructionPage.setOrigin(0, 0);
                    this._instructionPage.setInteractive();

                    this._instructionPageTitle = new Phaser.GameObjects.Image(this.scene, 475, 110, 'Rocket Launch Title');
                    this._instructionPageTitle.setScale(0.8);
                    this._btnPlay = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2, 480 - 50, 'btnPLAY1');
                    this._btnPlay.setInteractive({ cursor: 'pointer' });
                    this._btnPlay.once('pointerup', onPlayClick);
                    setupButtonTextureBased(this._btnPlay, 'btnPLAY1', 'btnPLAY2');
                    this.instrTxt = this.scene.add.text(game.scale.width / 2, game.scale.height / 2, "Find the right code and launch the rocket.", {
                        "fontFamily": "Kids Rock DEMO",
                        "fontSize": 30,
                        "color": "#43425D",
                        "align": 'center'
                    });
                    this.instrTxt.setOrigin(0.5, 0.5);
                    this.instrTxt.setWordWrapWidth(700);
                    this.instrTxt.setLineSpacing(5);
                    this._btnSoundInstruction = new Phaser.GameObjects.Image(this.scene, 800 - 105, 156 - 50, 'Sound');
                    this._btnSoundInstruction.setInteractive({ cursor: 'pointer' });
                    this._btnSoundInstruction.on('pointerup', onSndClick);
                    this._btnSoundInstruction["defScale"] = this._btnSoundInstruction.scale;
                    setupButtonTextureBased(this._btnSoundInstruction, 'Sound', 'Sound HOVER EFFECT');
                    this.add(this._instructionPage);
                    this.add(this._instructionPageTitle);
                    this.add(this.instrTxt);
                    this.add(this._btnPlay);
                    this.add(this._btnSoundInstruction);
                }
            }
            screen.InstructionPage = InstructionPage;
        })(screen = ctb.screen || (ctb.screen = {}));
    })(ctb || (ctb = {}));

    (function (ctb) {
        var screen;
        (function (screen) {
            class TryAgainWindow extends Phaser.GameObjects.Container {
                constructor(scene, onBack, onReplay) {
                    super(scene);
                    this.music = null;
                    this.setPosition(-106, -48);
                    this._bg = new Phaser.GameObjects.Image(this.scene, 0, 0, 'Try again page');
                    this._bg.setOrigin(0, 0);
                    this._bg.setInteractive();
                    this._star = new Phaser.GameObjects.Image(this.scene, 400, 415, 'Break Star');
                    this._btnBack = new Phaser.GameObjects.Image(this.scene, 600, 580, 'btnBACK1');
                    this._btnReplay = new Phaser.GameObjects.Image(this.scene, 765, 580, 'btnReplay1');
                    this.totalScoreTxt = this.scene.add.text(830, 355, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 35,
                        "color": "#F49F1C",
                        "align": 'center',
                        'stroke': '#70451A',
                        'strokeThickness': 6
                    });
                    this.totalScoreTxt.setOrigin(0.5, 0.5);
                    let grd = this.totalScoreTxt.context.createLinearGradient(0, 0, 0, this.totalScoreTxt.height);
                    grd.addColorStop(0, '#FFFF00');
                    grd.addColorStop(1, '#C17316');
                    this.totalScoreTxt.setFill(grd);
                    this.starScoreTxt = this.scene.add.text(635, 431, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 24,
                        "color": "#FFFFFF",
                        "align": 'center'
                    });
                    this.starScoreTxt.setOrigin(0.5, 0.5);
                    this.add([
                        this._bg,
                        this._star,
                        this._btnBack,
                        this._btnReplay,
                        this.totalScoreTxt,
                        this.starScoreTxt
                    ]);
                    this._btnBack.setInteractive({ cursor: 'pointer' });
                    this._btnBack.on('pointerup', () => {
                        onBack(this._btnBack);
                        window.angularComponentRef.backToMenu();
                        // if (this.music) {
                        //     this.music.stop();
                        // }
                    });
                    setupButtonTextureBased(this._btnBack, 'btnBACK1', 'btnBACK2');
                    this._btnReplay.setInteractive({ cursor: 'pointer' });
                    this._btnReplay.once('pointerup', () => {
                        onReplay(this._btnReplay);
                        if (this.music) {
                            this.music.stop();
                        }
                    });
                    setupButtonTextureBased(this._btnReplay, 'btnReplay1', 'btnReplay2');
                }
                show(score, starScore) {
                    this._star.scale = 1.25;
                    this.scene.tweens.add({
                        targets: this._star,
                        "scale": 1,
                        duration: 500,
                        ease: Phaser.Math.Easing.Back.Out
                    });
                    this.totalScoreTxt.text = String(window.angularComponentRef.component.userInfo.totalScore);
                    this.starScoreTxt.text = String(starScore);
                    this.music = this.scene.sound.add("Fail - close one");
                    this.music.play();
                }
            }
            screen.TryAgainWindow = TryAgainWindow;
        })(screen = ctb.screen || (ctb.screen = {}));
    })(ctb || (ctb = {}));

    game = new ctb.App(json);
};

function destroyRocketLaunch() {
    if (game) {
        game.destroy();
    }
}

var climbGame;
var game;

var climbWall = (json) => {
    (function (climbGame) {
        class App extends Phaser.Game {
            constructor(json) {
                App.json = json;
                let config = {
                    type: Phaser.AUTO,
                    width: App.CANVAS_WIDTH,
                    height: App.CANVAS_HEIGHT,
                    parent: 'game-container',
                    dom: {
                        createContainer: false
                    },
                    scale: {
                        mode: FitScaleManager.detectBestScaleMode(),
                        autoCenter: Phaser.Scale.CENTER_BOTH
                    },
                    transparent: true,
                    scene: {
                        create: () => {
                            this.scene.add('Boot', climbGame.scene.Boot, true);
                        }
                    }
                };
                super(config);
            }
        }
        App.CANVAS_WIDTH = 980;
        App.CANVAS_HEIGHT = 600;
        climbGame.App = App;
    })(climbGame || (climbGame = {}));

    var delayedCalls = [];
    function delayedCall(delay, callback, args, callbackScope) {
        let scene = game.scene.getAt(0);
        if (scene) {
            let dc = scene.time.delayedCall(delay, callback, args, callbackScope);
            delayedCalls.push(dc);
            return dc;
        }
        let t = setTimeout(callback, delay);
        delayedCalls.push(t);
        return t;
    }
    function pauseAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.paused = true;
            }
        }
    }
    function resumeAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.paused = false;
            }
        }
    }
    function destroyAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.remove(false);
            }
            else {
                clearTimeout(dc);
            }
        }
        delayedCalls = [];
    }
    function destroyDelayedCall(dc) {
        if (dc instanceof Phaser.Time.TimerEvent) {
            dc.remove(false);
        }
        else {
            clearTimeout(dc);
        }
        let ind = delayedCalls.indexOf(dc);
        if (ind >= 0) delayedCalls.splice(ind, 1);
    }
    function setPageBackground(bg) {
        // document.querySelector("html").style.backgroundImage = "url(assets/imgs/" + bg + ".jpg)";
    }
    function setupButton(btn, frame) {
        btn.on('pointerdown', () => { btn.setFrame(frame + '_hover' + '0000'); });
        btn.on('pointerover', () => { btn.setFrame(frame + '_hover' + '0000'); game.scene.getAt(0).sound.add("button hover").play(); });
        btn.on('pointerout', () => { btn.setFrame(frame + '0000'); });
        btn.on('pointerup', () => { btn.setFrame(frame + '0000'); game.scene.getAt(0).sound.add('activity selection - button selection').play(); });
    }
    function setupButtonTextureBased(btn, texture, hoverTexture) {
        btn.on('pointerdown', () => { btn.setTexture(hoverTexture); });
        btn.on('pointerover', () => { btn.setTexture(hoverTexture); game.scene.getAt(0).sound.add("button hover").play(); });
        btn.on('pointerout', () => { btn.setTexture(texture); });
        btn.on('pointerup', () => { btn.setTexture(texture); game.scene.getAt(0).sound.add('activity selection - button selection').play(); });
    }
    function playBtnClickAnim(target) {
        let sc = target.hasOwnProperty("defScale") ? target["defScale"] : 1;
        target.scaleX = target.scaleY = sc;
        let scene = game.scene.getAt(0);
        scene.tweens.add({
            targets: target,
            "scaleX": 0.9 * sc,
            "scaleY": 0.9 * sc,
            duration: 100,
            yoyo: true
        });
    }

    class FitScaleManager {
        constructor(game) {
            this.doResize = () => {
                let scale = this.calculateScale();
                let newCanvasWidth = this.phaserScaleManager.width * scale;
                let newCanvasHeight = this.phaserScaleManager.height * scale;
                this.canvasStyle.width = newCanvasWidth + 'px';
                this.canvasStyle.height = newCanvasHeight + 'px';
                this.canvasStyle.marginLeft = (window.innerWidth - newCanvasWidth) / 2 + 'px';
                this.canvasStyle.marginTop = (window.innerHeight - newCanvasHeight) / 2 + 'px';
            };
            this.game = game;
            this.canvasStyle = this.game.canvas.style;
            this.phaserScaleManager = this.game.scale;
        }
        static detectBestScaleMode() {
            let iOS = /iPad|iPhone|iPod/.test(navigator.platform || "");
            let isAndroid = window.navigator.userAgent.toLowerCase().indexOf("android") > -1;
            return iOS || isAndroid ? Phaser.Scale.FIT : Phaser.Scale.NONE;
        }
        ;

        setup() {
            this.phaserScaleManager.addListener(Phaser.Scale.Events.RESIZE, this.onResize, this);
            this.overridePhaserTransformMethods();
            this.onResize();
        }
        calculateScale() {
            if (game.scale.scaleMode == Phaser.Scale.NONE) return 1;
            return Math.min(window.innerWidth / this.phaserScaleManager.width, window.innerHeight / this.phaserScaleManager.height);
        }
        overridePhaserTransformMethods() {
            this.game.scale.transformX = (pageX) => {
                return (pageX - parseInt(this.canvasStyle.marginLeft.split("px")[0])) / this.calculateScale();
            };
            this.game.scale.transformY = (pageY) => {
                return (pageY - parseInt(this.canvasStyle.marginTop.split("px")[0])) / this.calculateScale();
            };
        }
        onResize() {
            setTimeout(this.doResize, FitScaleManager.RESIZE_DELAY);
        }
    }
    FitScaleManager.RESIZE_DELAY = 500;

    (function (climbGame) {
        var core;
        (function (core) {
            class Gameplay {
                constructor() {
                    const json = game.cache.json.get('gameplay');

                    this.rounds = json["rounds"].slice();
                    this.totalRoundsNum = this.rounds.length;
                    this.currentRound = 0;
                    this.correctAnswersCount = 0;
                    this.wrongAnswersCount = 0;
                    this.correctAnswersCountThisRound = 0;
                    this.wrongAnswersCountThisRound = 0;
                    this.onNewRound = null;
                    this.nextLetterDelay = 0;
                    this.words = json['words'];
                    this.failsNumToLose = Number(json["failsNumToLose"]);
                    this.useImages = Boolean(json["useImages"]);
                }

                setupCallbacks(onComplete, onLose, onNewRound, onRepeatRound) {
                    this.onComplete = onComplete;
                    this.onLose = onLose;
                    this.onNewRound = onNewRound;
                    this.onRepeatRound = onRepeatRound;
                }
                calculateScore() {
                    return this.totalRoundsNum - this.wrongAnswersCount;
                }
                onLetterChosen(correct) {
                    this.currentRound++;
                    if (this.currentRound >= this.totalRoundsNum) {
                        let score = this.calculateScore();
                        if (correct) {
                            setTimeout(() => this.onComplete(score, score), 13000);
                        } else {
                            this.onComplete(score, score);
                        }
                        return true;
                    } else {
                        const repeatSameLetters = !correct;
                        this.nextLetter(repeatSameLetters);
                    }
                    return false;
                }
                nextLetter(repeatSameRound) {

                    let fn = () => {
                        if (repeatSameRound) {
                            if (this.onRepeatRound) this.onRepeatRound();
                            return;
                        }
                        let thisRound = repeatSameRound ? this.rounds[0] : this.rounds.shift();
                        this.wantedWord = thisRound["wantedWord"];
                        this.selectableWords = thisRound["selectableWords"];
                        this.selectableImages = [];
                        this.correctAnswersCountThisRound = 0;
                        this.wrongAnswersCountThisRound = 0;
                        this.words.map(word => {
                            if (this.selectableWords.includes(word.word)) {
                                this.selectableImages[this.selectableWords.indexOf(word.word)] = word.image
                            }
                            if (word.word === this.wantedWord[0]) {
                                this.wantedImage = word.image;
                            }
                        });
                        if (this.onNewRound)
                            this.onNewRound();
                    };
                    if (this.nextLetterDelay == 0) {
                        fn();
                    }
                    else {
                        delayedCall(this.nextLetterDelay, fn);
                    }
                }
                onCorrectAnswer() {
                    this.correctAnswersCount++;
                    this.correctAnswersCountThisRound++;
                    this.nextLetterDelay = 1800;
                    const result = this.onLetterChosen(true);
                    return result;
                }
                onWrongAnswer() {
                    this.wrongAnswersCount++;
                    this.wrongAnswersCountThisRound++;
                    this.nextLetterDelay = 1500;
                    if (this.wrongAnswersCount >= this.failsNumToLose) {
                        this.onLose(0, 0);
                        return true;
                    }
                    else {
                        this.onLetterChosen(false);
                    }
                    return false;
                }
                getCurrentTotalAnswersCount() {
                    return this.correctAnswersCount + this.wrongAnswersCount;
                }
                getCurrentTotalAnswersCountThisRound() {
                    return this.correctAnswersCountThisRound + this.wrongAnswersCountThisRound;
                }
                isNewRound() {
                    return this.getCurrentTotalAnswersCountThisRound() === 0;
                }
                isRoundsComplete() {
                    return this.currentRound >= this.totalRoundsNum;
                }
                getAudioKeyOfChar(letter) {
                    let json = game.cache.json.get('gameplay');
                    let letters = json["letters"];
                    for (let d of letters) {
                        if (letter == d['letterName']) {
                            return d['audioKey'];
                        }
                    }
                    return null;
                }
                reset() {
                    this.nextLetterDelay = 0;
                    this.setupCallbacks(null, null, null, null);
                    let json = game.cache.json.get('gameplay');
                    this.rounds = json["rounds"].slice();
                    this.totalRoundsNum = this.rounds.length;
                    this.nextLetter();
                    this.currentRound = 0;
                    this.correctAnswersCount = 0;
                    this.wrongAnswersCount = 0;
                    this.correctAnswersCountThisRound = 0;
                    this.wrongAnswersCountThisRound = 0;
                }
            }
            core.Gameplay = Gameplay;
        })(core = climbGame.core || (climbGame.core = {}));
    })(climbGame || (climbGame = {}));

    (function (climbGame) {
        var scene;
        (function (scene) {
            class Boot extends Phaser.Scene {
                init() {
                    this.game.scale.transformX = (pageX) => {
                        let offsetLeft = 0;
                        let parentElement = game.canvas.parentElement;
                        while (parentElement) {
                            if (parentElement.offsetLeft) {
                                offsetLeft = parentElement.offsetLeft;
                                break;
                            }
                            parentElement = parentElement.parentElement;
                        }
                        return (pageX - offsetLeft) * this.game.scale.displayScale.x;
                    };
                    this.game.scale.transformY = (pageY) => {
                        let offsetTop = 0;
                        let parentElement = game.canvas.parentElement;
                        while (parentElement) {
                            if (parentElement.offsetTop) {
                                offsetTop = parentElement.offsetTop;
                                break;
                            }
                            parentElement = parentElement.parentElement;
                        }
                        return (pageY - offsetTop) * this.game.scale.displayScale.y;
                    };
                }
                create() {
                    game.scene.remove('Boot');
                    game.scene.add('Preloader', climbGame.scene.Preloader, true);
                }
            }
            scene.Boot = Boot;
        })(scene = climbGame.scene || (climbGame.scene = {}));
    })(climbGame || (climbGame = {}));

    (function (climbGame) {
        var scene;
        (function (scene) {
            var Gameplay = climbGame.core.Gameplay;
            class MainScene extends Phaser.Scene {
                create() {
                    this.gameplay = new Gameplay();
                    this.gameplayScreen = new climbGame.screen.GameplayScreen(this, this.gameplay);
                    this.children.add(this.gameplayScreen);
                    this.gameplayScreen.showInstructionPage();
                }
                update() {
                    this.gameplayScreen._update();
                }
            }
            scene.MainScene = MainScene;
        })(scene = climbGame.scene || (climbGame.scene = {}));
    })(climbGame || (climbGame = {}));

    (function (climbGame) {
        var scene;
        (function (scene) {
            class Preloader extends Phaser.Scene {
                preload() {
                    if (typeof climbGame.App.json == "string") this.load.json('gameplay', climbGame.App.json); else this.game.cache.json.add('gameplay', climbGame.App.json);
                }
                create() {
                    let json = game.cache.json.get('gameplay');
                    if (json["useImages"]) {
                        for (let w of json["words"]) {
                            if (w["image"] && !w["image"].includes('http')) {
                                this.load.image(w["word"], "assets/games/climb-wall/imgs/words/" + w["image"] + ".png");
                            } else {
                                this.load.image(w["word"], w["image"]);
                            }
                            if (w["audioKey"]) {
                                this.load.audio(w["audioKey"], "assets/games/climb-wall/sound/mp3/words/" + w["audioKey"] + ".mp3");
                            }
                        }
                    }
                    let progressTxt = this.add.text(game.scale.width / 2, game.scale.height / 2 + 50, "", {
                        "fontFamily": "QuranErafont",
                        "fontSize": 25,
                        "color": "#000000",
                        "align": 'center'
                    });
                    progressTxt.setOrigin(0.5, 0.5);
                    this.load.pack('preloader', 'assets/games/climb-wall/pack.json');
                    this.load.on('progress', (value) => {
                        progressTxt.text = Math.ceil(value * 100) + "%";
                    }, this);
                    this.load.on('complete', () => {
                        this.nextScene();
                    });
                    this.load.start();
                }
                static playAnim(animKey, sprite, onComplete = null) {
                    let mainScene = game.scene.getScene('ScreenMain');
                    if (!mainScene.anims.exists(animKey)) {
                        let data = Preloader.ANIMS_DATA[animKey];
                        mainScene.anims.create({
                            key: animKey,
                            frames: mainScene.anims.generateFrameNames(data['atlas'], {
                                start: data['start'], end: data['end'], zeroPad: data['padNum'],
                                prefix: data['prefix'], suffix: data['suffix'] || ''
                            }),
                            frameRate: data['frameRate'],
                            repeat: data['repeat']
                        });
                    }
                    if (sprite.anims.currentAnim) {
                        sprite.anims.currentAnim.off('complete');
                    }
                    sprite.anims.stop();
                    sprite.play(animKey);
                    sprite.anims.currentAnim.once('complete', () => {
                        if (onComplete)
                            onComplete();
                    });
                    return sprite;
                }
                nextScene() {
                    game.scene.remove('Preloader');
                    game.scene.add('ScreenMain', climbGame.scene.MainScene, true);
                }
            }
            Preloader.ANIMS_DATA = {
                'climb-long': {
                    'start': 1,
                    'end': 72,
                    'padNum': 4,
                    'prefix': 'Climb v2',
                    'suffix': '.png',
                    'repeat': 0,
                    'frameRate': 36,
                    'atlas': 'climb'
                },
                'climb-short': {
                    'start': 1,
                    'end': 60,
                    'padNum': 4,
                    'prefix': 'Climb v2',
                    'suffix': '.png',
                    'repeat': 0,
                    'frameRate': 36,
                    'atlas': 'climb'
                },
                'adhan': {
                    'start': 1,
                    'end': 80,
                    'padNum': 4,
                    'prefix': 'adhan',
                    'suffix': '.png',
                    'repeat': 0,
                    'frameRate': 24,
                    'atlas': 'athan-v2-atlas'
                },
                'foot-slip': {
                    'start': 1,
                    'end': 53,
                    'padNum': 4,
                    'prefix': 'foot slip',
                    'suffix': '.png',
                    'repeat': 0,
                    'frameRate': 30,
                    'atlas': 'foot-slip-atlas'
                },
            };
            scene.Preloader = Preloader;
        })(scene = climbGame.scene || (climbGame.scene = {}));
    })(climbGame || (climbGame = {}));

    (function (climbGame) {
        var screen;
        (function (screen) {
            class AreYouSureWindow extends Phaser.GameObjects.Container {
                constructor(scene, onYes, onNo) {
                    super(scene);
                    this._areYouSurePage = new Phaser.GameObjects.Image(this.scene, -105, 0 - 48, 'Exit warning');
                    this._areYouSurePage.setOrigin(0, 0);
                    this._areYouSurePage.setInteractive();
                    this._btnSureYes = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2 - 95, 485 - 50, 'btnYES1');
                    this._btnSureYes.setInteractive({ cursor: 'pointer' });
                    this._btnSureYes.once('pointerup', () => {
                        onYes;
                        window.angularComponentRef.backToMenu();
                    });


                    var modalTextStyle = {
                        backgroundColor: 'transparent',
                        stroke: '#ffffff',
                        strokeThickness: 2,
                        lineSpacing: 15,
                        fontFamily: 'Kids Rock DEMO',
                        fontSize: 27,
                        color: '#43425d',
                        wordWrap: true,
                        align: 'center'
                    };
                    var modalText = this.scene.add.text(game.scale.width / 2 + 12, game.scale.height / 2, "Your progress in this activity will not be saved. \n Are you sure you want to exit? ", modalTextStyle);
                    modalText.setOrigin(0.5, 0.5);

                    setupButtonTextureBased(this._btnSureYes, 'btnYES1', 'btnYES2');
                    this._btnSureNo = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2 + 95, 485 - 50, 'btnNO1');
                    this._btnSureNo.setInteractive({ cursor: 'pointer' });
                    this._btnSureNo.once('pointerup', onNo);
                    setupButtonTextureBased(this._btnSureNo, 'btnNO1', 'btnNO2');
                    this.add(this._areYouSurePage);
                    this.add(this._btnSureYes);
                    this.add(this._btnSureNo);
                    this.add(modalText);
                }
            }
            screen.AreYouSureWindow = AreYouSureWindow;
        })(screen = climbGame.screen || (climbGame.screen = {}));
    })(climbGame || (climbGame = {}));

    (function (climbGame) {
        var screen;
        (function (screen) {
            class CompleteWindow extends Phaser.GameObjects.Container {
                constructor(scene, onBack, onReplay, onNext) {
                    super(scene);
                    this.music = null;
                    this.setPosition(-104.5, -48);
                    this._bgComplete = new Phaser.GameObjects.Image(this.scene, 0, 0, 'Completion page LATEST UPDATED');
                    this._bgComplete.setOrigin(0, 0);
                    this._bgComplete.setInteractive();
                    this._cup = new Phaser.GameObjects.Image(this.scene, 400, 410, 'Trophy');
                    this._btnBack = new Phaser.GameObjects.Image(this.scene, 570, 570, 'btnBACK1');
                    this._btnReplay = new Phaser.GameObjects.Image(this.scene, 720, 570, 'btnReplay1');
                    this._btnNext = new Phaser.GameObjects.Image(this.scene, 870, 570, 'btnNEXT1');
                    let _CollectedPoints = new Phaser.GameObjects.Image(this.scene, 620, 440, 'Collected Points');
                    this.totalScoreTxt = this.scene.add.text(845, 352, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 35,
                        "color": "#F49F1C",
                        "align": 'center',
                        'stroke': '#70451A',
                        'strokeThickness': 6
                    });
                    this.totalScoreTxt.setOrigin(0.5, 0.5);
                    let grd = this.totalScoreTxt.context.createLinearGradient(0, 0, 0, this.totalScoreTxt.height);
                    grd.addColorStop(0, '#FFFF00');
                    grd.addColorStop(1, '#C17316');
                    this.totalScoreTxt.setFill(grd);
                    this.starScoreTxt = this.scene.add.text(648, 433, "", {
                        "fontFamily": "Kids Rock DEMO",
                        "fontSize": 24,
                        "color": "#FFFFFF",
                        "align": 'center'
                    });
                    this.starScoreTxt.setOrigin(0.5, 0.5);
                    this.add([
                        this._bgComplete,
                        _CollectedPoints,
                        this._cup,
                        this._btnBack,
                        this._btnReplay,
                        this._btnNext,
                        this.totalScoreTxt,
                        this.starScoreTxt
                    ]);
                    this._btnBack.setInteractive({ cursor: 'pointer' });
                    this._btnBack.on('pointerup', () => {
                        onBack(this._btnBack);
                        window.angularComponentRef.backToMenu();
                        // if (this.music) {
                        //     this.music.stop();
                        // }
                    });
                    setupButtonTextureBased(this._btnBack, 'btnBACK1', 'btnBACK2');
                    this._btnReplay.setInteractive({ cursor: 'pointer' });
                    this._btnReplay.once('pointerup', () => {
                        onReplay(this._btnReplay);
                        if (this.music) {
                            this.music.stop();
                        }
                    });
                    setupButtonTextureBased(this._btnReplay, 'btnReplay1', 'btnReplay2');
                    this._btnNext.setInteractive({ cursor: 'pointer' });
                    this._btnNext.on('pointerup', () => {
                        onNext(this._btnNext);
                        window.angularComponentRef.nextActivity();
                        // if (this.music) {
                        //     this.music.stop();
                        // }
                    });
                    setupButtonTextureBased(this._btnNext, 'btnNEXT1', 'btnNEXT2');
                }
                show(score, starScore) {
                    window.angularComponentRef.gameFinish({ score, starScore });
                    this._cup.scale = 1.25;
                    this.scene.tweens.add({
                        targets: this._cup,
                        "scale": 1,
                        duration: 500,
                        ease: Phaser.Math.Easing.Back.Out
                    });
                    this.totalScoreTxt.text = String(window.angularComponentRef.component.userInfo.totalScore);
                    this.starScoreTxt.text = String(starScore);
                    // let music = this.scene.sound.add("viktory");
                    this.music = this.scene.sound.add("Activity completion fantastic");
                    this.music.play();
                }
            }
            screen.CompleteWindow = CompleteWindow;
        })(screen = climbGame.screen || (climbGame.screen = {}));
    })(climbGame || (climbGame = {}));

    (function (climbGame) {
        var screen;
        (function (screen) {
            var Preloader = climbGame.scene.Preloader;
            class GameplayScreen extends Phaser.GameObjects.Container {
                constructor(scene, gameplay) {
                    super(scene);
                    this.scrollableContainer = new Phaser.GameObjects.Container(this.scene);
                    this.add(this.scrollableContainer);
                    this.wordsContainer = new Phaser.GameObjects.Container(this.scene);
                    this.add(this.wordsContainer);
                    this.passedWordsContainer = new Phaser.GameObjects.Container(this.scene);
                    this.add(this.passedWordsContainer);
                    this.bgMusic = null;
                    this.wantedWindow = null;
                    this.wfsnd = null;
                    this.showCompleteWindow = (score, starScore) => {
                        let completeWindow = new screen.CompleteWindow(this.scene, (target) => {
                            playBtnClickAnim(target);
                        }, (target) => {
                            playBtnClickAnim(target);
                            this.destroyGameplay();
                            this.remove(completeWindow);
                            this.showInstructionPage();
                        }, (target) => {
                            playBtnClickAnim(target);
                        });
                        this.setInputEnabled(false);
                        delayedCall(2000, () => {
                            setPageBackground("bg-blue");
                            this.add(completeWindow);
                            completeWindow.show(score, starScore);
                            if (this.bgMusic) this.bgMusic.stop();

                            this.wordsContainer.removeAll();
                            this.passedWordsContainer.removeAll();
                        });
                    };
                    this.showLoseWindow = (score, starScore) => {
                        let tryAgainWindow = new screen.TryAgainWindow(this.scene, (target) => {
                            playBtnClickAnim(target);
                        }, (target) => {
                            playBtnClickAnim(target);
                            this.destroyGameplay();
                            this.remove(tryAgainWindow);
                            this.showInstructionPage();
                        });
                        this.setInputEnabled(false);
                        delayedCall(1500, () => {
                            setPageBackground("bg-blue");
                            this.add(tryAgainWindow);
                            tryAgainWindow.show(score, starScore);
                            if (this.bgMusic) this.bgMusic.stop();

                            this.wordsContainer.removeAll();
                            this.passedWordsContainer.removeAll();
                        });
                    };
                    this.gameplay = gameplay;
                    window["gs"] = this;


                    this.wallBottom = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2, game.scale.height / 2, 'BG1A');
                    this.wallBottom.setOrigin(0.5, 0.5);
                    this.wallBottom.setScale(1.004, 1);
                    this.wallBottom.setInteractive();
                    this.scrollableContainer.add(this.wallBottom);

                    this.wallTop = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2, -game.scale.height / 2, 'BG1B');
                    this.wallTop.setOrigin(0.5, 0.5);
                    this.wallTop.setScale(1.004, 1);
                    this.wallTop.setInteractive();
                    this.scrollableContainer.add(this.wallTop);

                    this.mosqueRoof = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2, -1.5 * game.scale.height, 'BG2');
                    this.mosqueRoof.setOrigin(0.5, 0.5);
                    this.mosqueRoof.setScale(1.004, 1);
                    this.mosqueRoof.setInteractive();
                    this.scrollableContainer.add(this.mosqueRoof);

                    this.charactersContainer = new Phaser.GameObjects.Container(this.scene);
                    this.charactersContainer.scale = 0.999;

                    this.charactersContainer.setPosition(495, 0);
                    this.scrollableContainer.add(this.charactersContainer);

                    this.characterClimb = this.scene.add.sprite(0, 0, 'climb', 'Climb v20001.png');
                    this.charactersContainer.add(this.characterClimb);

                    this.characterFootSlip = this.scene.add.sprite(0, 326, 'foot-slip-atlas', 'foot slip0001.png');
                    this.charactersContainer.add(this.characterFootSlip);
                    this.characterFootSlip.visible = false;

                    this.characterAdhan = this.scene.add.sprite(0, 0, 'adhan-atlas', 'adhan0001.png');
                    this.charactersContainer.add(this.characterAdhan);
                    this.characterAdhan.visible = false;

                    this._btnClose = new Phaser.GameObjects.Image(this.scene, 1025 - 105, 100 - 50, 'x Button');
                    this._btnClose.setInteractive({ cursor: 'pointer' });
                    this._btnClose["defScale"] = this._btnClose.scale;
                    setupButtonTextureBased(this._btnClose, 'x Button', 'x Button HOVER EFFECT');
                    this.add(this._btnClose);
                    this._btnClose.on('pointerup', () => {
                        playBtnClickAnim(this._btnClose);
                        this.onCloseClick();
                    });
                }
                showGameplay() {
                    setPageBackground("bg-australia");
                    this.bgMusic = this.scene.sound.add("Night ambience");
                    this.bgMusic.play();
                    this.bgMusic.loop = true;
                    this.gameplayContainer = new Phaser.GameObjects.Container(this.scene);
                    this.add(this.gameplayContainer);
                    this.gameplay.reset();
                    this.prepareRound();
                    this.scrollToBottomScreen();
                    this.charactersContainer.y = 0;
                    this.characterClimb.visible = true;
                    this.characterFootSlip.visible = false;
                    this.characterAdhan.visible = false;
                    this.characterClimb.setFrame('Climb v20001.png');
                    this.gameplay.setupCallbacks(this.showCompleteWindow, this.showLoseWindow, () => {
                        this.onNewRound(true);
                    }, () => {
                        this.setInputEnabled(true);
                    });
                    this.createTallies();
                }
                _update() {

                }
                playClimbAnim() {
                    this._climbAnimCompleted = false;
                    this.climbAnimIndex = (this.climbAnimIndex || 0) + 1;
                    this.characterClimb.visible = true;
                    this.characterFootSlip.visible = false;
                    this.characterAdhan.visible = false;
                    this.scene.sound.add("Climbing").play();
                    Preloader.playAnim((this.climbAnimIndex % 2 === 0) ? 'climb-short' : 'climb-long', this.characterClimb, () => {
                        this._climbAnimCompleted = true;

                        if (this._scrollTweenFinished) {
                            this.finishClimbRoutine();
                        }

                        if (this._mosqueTweenFinished) {
                            this.finishMosqueClimbRoutine();
                        }

                    })
                }
                playFootSlipAnim() {
                    this.characterClimb.visible = false;
                    this.characterFootSlip.visible = true;
                    this.characterAdhan.visible = false;
                    Preloader.playAnim('foot-slip', this.characterFootSlip, () => {

                    });
                }
                playAdhanAnim() {
                    this.characterClimb.visible = false;
                    this.characterFootSlip.visible = false;
                    this.characterAdhan.visible = true;
                    Preloader.playAnim('adhan', this.characterAdhan, () => {

                    });
                    delayedCall(1900, () => {
                        this.scene.sound.add("Boy calling Athan").play();
                    })
                }


                prepareRound() {
                    this.gameplayContainer.removeAll();

                    this.passedWordsContainer.removeAll();
                    this.wordsContainer.getAll().forEach(word => this.passedWordsContainer.add(word));
                    this.wordsContainer.removeAll();
                    this.wordsContainer.y = -game.scale.height;

                    this.wantedWindow = null;
                    if (this.gameplay.useImages) {
                        this.wordsContainer.add(new Phaser.GameObjects.Image(this.scene, 370, 460, this.gameplay.wantedWord));
                    } else {
                        let wantedWordTxt = this.scene.add.text(370, 460, "", {
                            "fontFamily": "QuranErafont",
                            "fontSize": 80,
                            "color": "#000000",
                            "align": 'center'
                        });
                        wantedWordTxt.setOrigin(0.5, 0.4);
                        wantedWordTxt.style.fixedHeight = 115;
                        wantedWordTxt.setText(this.gameplay.wantedWord);
                        this.wordsContainer.add(wantedWordTxt);
                    }
                    this.scrollableContainer.add(this.passedWordsContainer);
                    this.scrollableContainer.add(this.wordsContainer);
                    let randomizedWords = Phaser.Utils.Array.Shuffle(this.gameplay.selectableWords.slice());
                    let xPositions = [130, 376.5, 606];
                    this.selectableLetters = [];
                    for (let i = 0; i < randomizedWords.length; i++) {
                        let a = new Phaser.GameObjects.Container(this.scene, xPositions[i], 265);
                        a.add(a["-plankContainer-"] = new Phaser.GameObjects.Container(this.scene, 0, 0));
                        this.selectableLetters.push(a);

                        a['glowRed'] = new Phaser.GameObjects.Image(this.scene, 16, -42, 'red-frame');
                        a["-plankContainer-"].add(a['glowRed']);
                        a['glowRed'].visible = false;

                        a['glowGreen'] = new Phaser.GameObjects.Image(this.scene, 16, -42, 'green-frame');
                        a["-plankContainer-"].add(a['glowGreen']);
                        a['glowGreen'].visible = false;

                        let txt;
                        if (this.gameplay.useImages) {
                            txt = new Phaser.GameObjects.Image(this.scene, 18, -10, randomizedWords[i]);
                            a["-plankContainer-"].add(txt);
                        }
                        else {
                            txt = this.scene.add.text(9, -15, "", {
                                "fontFamily": "QuranErafont",
                                "fontSize": 65,
                                "color": "#000000",
                                "align": 'center'
                            });
                            txt.setOrigin(0.5, 0.45);
                            txt.style.fixedHeight = 90;
                            txt.setText(randomizedWords[i]);
                            a["-plankContainer-"].add(txt);
                        }

                        a['startPosition'] = { x: a.x, y: a.y };
                        a["-word-"] = txt;
                        a["-word-text-"] = randomizedWords[i];
                        this.wordsContainer.add(a);
                        a['-draggable-'] = true;
                    }
                    for (let a of this.selectableLetters) {
                        a.setSize(190, 170);
                        a.setInteractive({ cursor: 'pointer' });
                        a.on('pointerdown', () => {
                            this.setInputEnabled(false);
                            if (a["-word-text-"] == this.gameplay.wantedWord) {
                                a['glowGreen'].visible = true;
                                delayedCall(1500, () => {
                                    a['glowGreen'].visible = false;
                                })
                                this.wantedWindow = a;
                                this.onCorrectAnswer();
                            }
                            else {
                                a['glowRed'].visible = true;
                                delayedCall(1500, () => {
                                    a['glowRed'].visible = false;
                                })
                                this.onWrongAnswer();
                                this.scene.sound.add("Wrong").play();
                            }
                        });
                    }
                    this.wordsContainer.visible = true;
                    this.setInputEnabled(false);
                    if (this.gameplay.isNewRound()) {
                        if (!this.gameplay.isRoundsComplete()) {
                            this.setInputEnabled(true);
                        }
                    }
                    else {
                        this.setInputEnabled(true);
                    }
                    this._btnClose.setInteractive({ cursor: 'pointer', pixelPerfect: true });
                }
                onNewRound(showOut) {
                    this.setInputEnabled(false);
                    if (showOut) {
                        this.prepareRound();
                    }
                }
                onCorrectAnswer() {
                    let i = this.gameplay.getCurrentTotalAnswersCount();
                    this.tallyEmptyArray[i].visible = false;
                    this.tally[i].visible = true;
                    let completed = this.gameplay.onCorrectAnswer();
                    this.scene.sound.add("Correct").play();
                    if (completed) {
                        delayedCall(1500, () => {
                            this.playClimbAnim();
                            this.scrollToMosqueRoofScreen();
                        });
                    } else {
                        delayedCall(1500, () => {
                            this.playClimbAnim();
                            this.scrollToTopScreen();
                        });
                    }
                    return completed;
                }

                onWrongAnswer() {
                    let i = this.gameplay.getCurrentTotalAnswersCount();
                    this.tallyEmptyArray[i].visible = true;
                    this.tallyEmptyArray[i].visible = true;
                    this.tally[i].visible = false;
                    let lost = this.gameplay.onWrongAnswer();
                    this.playFootSlipAnim();
                    delayedCall(350, () => {
                        this.scene.sound.add("Boy slips and hangs").play();
                    });
                    return lost;
                }

                scrollToBottomScreen() {
                    this.scrollableContainer.y = 0;
                    this.wordsContainer.y = 0;
                }

                swapWallBackgrounds() {
                    const topY = this.wallTop.y;
                    this.wallTop.y = this.wallBottom.y;
                    this.wallBottom.y = topY;
                }

                finishClimbRoutine() {
                    if (this._scrollTweenFinished && this._climbAnimCompleted) {
                        this.scrollToBottomScreen();
                        this.swapWallBackgrounds();
                        if (this.climbAnimIndex % 2 === 0) {
                            this.charactersContainer.y += 52;
                        } else {
                            this.charactersContainer.y -= 52;
                        }
                        this.characterClimb.setFrame('Climb v20001.png');
                    }
                }

                finishMosqueClimbRoutine() {
                    if (this._mosqueTweenFinished && this._climbAnimCompleted) {
                        this.scrollableContainer.y = 2 * game.scale.height;
                        this.mosqueRoof.y = -game.scale.height * 1.5;
                        if (this.climbAnimIndex % 2 === 0) {
                            this.charactersContainer.y += 52;
                        } else {
                            this.charactersContainer.y -= 52;
                        }
                        this.charactersContainer.y = -601;
                        this.playAdhanAnim();
                    }
                }

                scrollToTopScreen() {
                    this._scrollTweenFinished = false;
                    this._mosqueTweenFinished = false;
                    const totalDuration = (this.climbAnimIndex % 2 === 0) ? 1550 : 1850;
                    const delayDuration = 400;
                    this.scene.tweens.add({
                        targets: this.scrollableContainer,
                        y: game.scale.height,
                        duration: (totalDuration - delayDuration),
                        delay: delayDuration,
                        ease: Phaser.Math.Easing.Linear,
                        onComplete: () => {
                            this._scrollTweenFinished = true;
                            this.finishClimbRoutine();
                        }
                    });

                    delayedCall(totalDuration * 0.75, () => {
                        this.passedWordsContainer.removeAll();
                    });
                }

                scrollToMosqueRoofScreen() {
                    const totalDuration = (this.climbAnimIndex % 2 === 0) ? 1667 : 2000;
                    const delayDuration = 400;

                    this._scrollTweenFinished = false;
                    this._mosqueTweenFinished = false;
                    this.mosqueRoof.y = -game.scale.height / 2;

                    this.scene.tweens.add({
                        targets: this.scrollableContainer,
                        y: game.scale.height,
                        duration: (totalDuration - delayDuration),
                        delay: delayDuration,
                        ease: Phaser.Math.Easing.Linear,
                        onComplete: () => {
                            this._mosqueTweenFinished = true;
                            this.finishMosqueClimbRoutine();
                        }
                    })
                }
                onCloseClick() {
                    this.showAreYouSurePage();
                    this.scene.sound.add('warning page pop up sfx').play();
                }
                createTallies() {
                    if (this.tally) {
                        for (let te of this.tallyEmptyArray) {
                            te.visible = false;
                            this.bringToTop(te);
                        }
                        for (let t of this.tally) {
                            t.visible = false;
                            this.bringToTop(t);
                        }
                        return;
                    }
                    let startX = 46;
                    let startY = 42;
                    let dx = 55;
                    let dy = 55;
                    let tallyEmptyArrayPositions = [];
                    for (let i = 0; i < 10; i++) {
                        tallyEmptyArrayPositions.push({ x: startX + (i % 5) * dx, y: startY + Math.floor(i / 5) * dy });
                    }

                    this.tallyBar = this.add(new Phaser.GameObjects.Image(this.scene, 160, 70, 'tally bar'));

                    this.tallyEmptyArray = [];
                    this.tally = [];
                    for (let p of tallyEmptyArrayPositions) {
                        let _BeehiveEmpty = new Phaser.GameObjects.Image(this.scene, p['x'], p['y'], 'tally Empty');
                        this.tallyEmptyArray.push(_BeehiveEmpty);
                        _BeehiveEmpty.visible = false;
                        let _Beehive = new Phaser.GameObjects.Image(this.scene, p['x'], p['y'], 'tally');
                        this.tally.push(_Beehive);
                    }
                    for (let bea of this.tallyEmptyArray) {
                        this.add(bea);
                    }
                    for (let bee of this.tally) {
                        this.add(bee);
                        bee.visible = false;
                    }
                }
                hideAllUnusedTallies() {
                    let i = this.gameplay.getCurrentTotalAnswersCount();
                    for (let k = i + 1; k < this.tallyEmptyArray.length; k++) {
                        this.tallyEmptyArray[k].visible = false;
                        this.tally[k].visible = false;
                    }
                }
                showInstructionPage() {
                    setPageBackground("bg-blue");
                    let playInstructionSound = () => {
                        if (this.wfsnd) {
                            this.wfsnd.stop();
                        }
                        this.wfsnd = this.scene.sound.add("Introduction");
                        this.wfsnd.play();
                    };
                    this.instructionPage = new screen.InstructionPage(this.scene, (target) => {
                        playBtnClickAnim(target);
                        this.remove(this.instructionPage);
                        this.showGameplay();
                        if (this.wfsnd) {
                            this.wfsnd.stop();
                        }
                    }, (target) => {
                        playBtnClickAnim(target);
                        playInstructionSound();
                    });
                    this.add(this.instructionPage);
                    try {
                        playInstructionSound();
                    }
                    catch (e) {
                        console.error(e);
                    }
                }
                showAreYouSurePage() {
                    pauseAllDelayedCalls();
                    setPageBackground("bg-blue");
                    this.scene.tweens.pauseAll();
                    this.pauseSounds();
                    this.areYouSureWindow = new screen.AreYouSureWindow(this.scene, () => {
                        this.scene.tweens.resumeAll();
                        this.remove(this.areYouSureWindow);
                        this.destroyGameplay();
                        this.showInstructionPage();
                    }, () => {
                        this.scene.tweens.resumeAll();
                        this.remove(this.areYouSureWindow);
                        this.unpauseSounds();
                        resumeAllDelayedCalls();
                        setPageBackground("bg-australia");
                    });
                    this.add(this.areYouSureWindow);
                }
                setInputEnabled(enabled) {
                    if (enabled) {
                        for (let a of this.selectableLetters)
                            a.setInteractive( /*{cursor: 'pointer', pixelPerfect:true}*/);
                    }
                    else {
                        for (let a of this.selectableLetters)
                            a.disableInteractive();
                    }
                }
                pauseSounds() {
                    this.scene.sound.pauseAll();
                }
                unpauseSounds() {
                    this.scene.sound.resumeAll();
                }
                destroyGameplay() {
                    this.setInputEnabled(false);
                    this.remove(this.gameplayContainer);
                    this.scene.sound.stopAll();
                    destroyAllDelayedCalls();
                }
            }
            screen.GameplayScreen = GameplayScreen;
        })(screen = climbGame.screen || (climbGame.screen = {}));
    })(climbGame || (climbGame = {}));

    (function (climbGame) {
        var screen;
        (function (screen) {
            class InstructionPage extends Phaser.GameObjects.Container {
                constructor(scene, onPlayClick, onSndClick) {
                    super(scene);
                    this._instructionPage = new Phaser.GameObjects.Image(this.scene, 0 - 105, 0 - 48, 'Instructions page  ALL ACTIVITY  TITLEs');
                    this._instructionPage.setOrigin(0, 0);
                    this._instructionPage.setInteractive();

                    this._instructionPageTitle = new Phaser.GameObjects.Image(this.scene, 460, 110, 'Climb the Mosque Title');
                    this._instructionPageTitle.setScale(0.8);


                    this._btnPlay = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2, 480 - 50, 'btnPLAY1');
                    this._btnPlay.setInteractive({ cursor: 'pointer' });
                    this._btnPlay.once('pointerup', onPlayClick);
                    setupButtonTextureBased(this._btnPlay, 'btnPLAY1', 'btnPLAY2');
                    this.instrTxt = this.scene.add.text(game.scale.width / 2, game.scale.height / 2, "Help the boy climb up the mosque and\n\n call the Athaan.", {
                        "fontFamily": "Kids Rock DEMO",
                        "fontSize": 30,
                        "lineSpacing":15,
                        "color": "#43425D",
                        "align": 'center'
                    });
                    this.instrTxt.setOrigin(0.5, 0.5);
                    this.instrTxt.setWordWrapWidth(600);
                    this.instrTxt.setLineSpacing(5);
                    this._btnSoundInstruction = new Phaser.GameObjects.Image(this.scene, 800 - 105, 156 - 50, 'Sound');
                    this._btnSoundInstruction.setInteractive({ cursor: 'pointer' });
                    this._btnSoundInstruction.on('pointerup', onSndClick);
                    this._btnSoundInstruction["defScale"] = this._btnSoundInstruction.scale;
                    setupButtonTextureBased(this._btnSoundInstruction, 'Sound', 'Sound HOVER EFFECT');
                    this.add(this._instructionPage);
                    this.add(this._instructionPageTitle);
                    this.add(this.instrTxt);
                    this.add(this._btnPlay);
                    this.add(this._btnSoundInstruction);
                }
            }
            screen.InstructionPage = InstructionPage;
        })(screen = climbGame.screen || (climbGame.screen = {}));
    })(climbGame || (climbGame = {}));

    (function (climbGame) {
        var screen;
        (function (screen) {
            class TryAgainWindow extends Phaser.GameObjects.Container {
                constructor(scene, onBack, onReplay) {
                    super(scene);
                    this.music = null;
                    this.setPosition(-106, -48);
                    this._bg = new Phaser.GameObjects.Image(this.scene, 0, 0, 'Try again page');
                    this._bg.setOrigin(0, 0);
                    this._bg.setInteractive();
                    this._star = new Phaser.GameObjects.Image(this.scene, 400, 415, 'Break Star');
                    this._btnBack = new Phaser.GameObjects.Image(this.scene, 600, 580, 'btnBACK1');
                    this._btnReplay = new Phaser.GameObjects.Image(this.scene, 765, 580, 'btnReplay1');
                    this.totalScoreTxt = this.scene.add.text(830, 355, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 35,
                        "color": "#F49F1C",
                        "align": 'center',
                        'stroke': '#70451A',
                        'strokeThickness': 6
                    });
                    this.totalScoreTxt.setOrigin(0.5, 0.5);
                    let grd = this.totalScoreTxt.context.createLinearGradient(0, 0, 0, this.totalScoreTxt.height);
                    grd.addColorStop(0, '#FFFF00');
                    grd.addColorStop(1, '#C17316');
                    this.totalScoreTxt.setFill(grd);
                    this.starScoreTxt = this.scene.add.text(635, 431, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 24,
                        "color": "#FFFFFF",
                        "align": 'center'
                    });
                    this.starScoreTxt.setOrigin(0.5, 0.5);
                    this.add([
                        this._bg,
                        this._star,
                        this._btnBack,
                        this._btnReplay,
                        this.totalScoreTxt,
                        this.starScoreTxt
                    ]);
                    this._btnBack.setInteractive({ cursor: 'pointer' });
                    this._btnBack.on('pointerup', () => {
                        onBack(this._btnBack);
                        window.angularComponentRef.backToMenu();
                        // if (this.music) {
                        //     this.music.stop();
                        // }
                    });
                    setupButtonTextureBased(this._btnBack, 'btnBACK1', 'btnBACK2');
                    this._btnReplay.setInteractive({ cursor: 'pointer' });
                    this._btnReplay.once('pointerup', () => {
                        onReplay(this._btnReplay);
                        if (this.music) {
                            this.music.stop();
                        }
                    });
                    setupButtonTextureBased(this._btnReplay, 'btnReplay1', 'btnReplay2');
                }
                show(score, starScore) {
                    this._star.scale = 1.25;
                    this.scene.tweens.add({
                        targets: this._star,
                        "scale": 1,
                        duration: 500,
                        ease: Phaser.Math.Easing.Back.Out
                    });
                    this.totalScoreTxt.text = String(window.angularComponentRef.component.userInfo.totalScore);
                    this.starScoreTxt.text = String(starScore);
                    this.music = this.scene.sound.add("Fail - close one");
                    this.music.play();
                }
            }
            screen.TryAgainWindow = TryAgainWindow;
        })(screen = climbGame.screen || (climbGame.screen = {}));
    })(climbGame || (climbGame = {}));

    game = new climbGame.App(json);
};

function destroyClimbWall() {
    if (game) {
        game.destroy();
    }
}

var ctb;
var game;

var crossTheBridge = (json) => {
    (function (ctb) {
        class App extends Phaser.Game {
            constructor(json) {
                App.json = json

                let config = {
                    type: Phaser.AUTO,
                    width: App.CANVAS_WIDTH,
                    height: App.CANVAS_HEIGHT,
                    parent: 'game-container',
                    dom: {
                        createContainer: false
                    },
                    scale: {
                        mode: FitScaleManager.detectBestScaleMode(),
                        autoCenter: Phaser.Scale.CENTER_BOTH
                    },
                    transparent: true,
                    scene: {
                        create: () => {
                            this.scene.add('Boot', ctb.scene.Boot, true);
                        }
                    }
                };
                super(config);
            }
        }
        App.CANVAS_WIDTH = 980;
        App.CANVAS_HEIGHT = 600;
        ctb.App = App;
    })(ctb || (ctb = {}));

    var delayedCalls = [];
    function delayedCall(delay, callback, args, callbackScope) {
        let scene = game.scene.getAt(0);
        if (scene) {
            let dc = scene.time.delayedCall(delay, callback, args, callbackScope);
            delayedCalls.push(dc);
            return dc;
        }
        let t = setTimeout(callback, delay);
        delayedCalls.push(t);
        return t;
    }
    function pauseAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.paused = true;
            }
        }
    }
    function resumeAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.paused = false;
            }
        }
    }
    function destroyAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.remove(false);
            }
            else {
                clearTimeout(dc);
            }
        }
        delayedCalls = [];
    }
    function destroyDelayedCall(dc) {
        if (dc instanceof Phaser.Time.TimerEvent) {
            dc.remove(false);
        }
        else {
            clearTimeout(dc);
        }
        let ind = delayedCalls.indexOf(dc);
        if (ind >= 0)
            delayedCalls.splice(ind, 1);
    }
    function setPageBackground(bg) {
        document.querySelector("html").style.backgroundImage = "url(assets/imgs/" + bg + ".jpg)";
    }
    function setupButton(btn, frame) {
        btn.on('pointerdown', () => { btn.setFrame(frame + '_hover' + '0000'); });
        btn.on('pointerover', () => { btn.setFrame(frame + '_hover' + '0000'); game.scene.getAt(0).sound.add("button hover").play(); });
        btn.on('pointerout', () => { btn.setFrame(frame + '0000'); });
        btn.on('pointerup', () => { btn.setFrame(frame + '0000'); game.scene.getAt(0).sound.add('activity selection - button selection').play(); });
    }
    function setupButtonTextureBased(btn, texture, hoverTexture) {
        btn.on('pointerdown', () => { btn.setTexture(hoverTexture); });
        btn.on('pointerover', () => { btn.setTexture(hoverTexture); game.scene.getAt(0).sound.add("button hover").play(); });
        btn.on('pointerout', () => { btn.setTexture(texture); });
        btn.on('pointerup', () => { btn.setTexture(texture); game.scene.getAt(0).sound.add('activity selection - button selection').play(); });
    }
    function playBtnClickAnim(target) {
        let sc = target.hasOwnProperty("defScale") ? target["defScale"] : 1;
        target.scaleX = target.scaleY = sc;
        let scene = game.scene.getAt(0);
        scene.tweens.add({
            targets: target,
            "scaleX": 0.9 * sc,
            "scaleY": 0.9 * sc,
            duration: 100,
            yoyo: true
        });
    }
    /**
     * @author Roman Parada
     * This class is created to fix overlapping of bottom part of canvas by navigation bar in iOS.
     * It make a delayed resize of the canvas (like Phaser-3 FIT methods does) and it overrides Phaser-3 input window to Phaser-3 core transform methods
     *
     * How to use:
     * Just call the code line below in Boot scene's init() method of your project:
     * new FitScaleManager(this.game).setup();
     */
    class FitScaleManager {
        constructor(game) {
            this.doResize = () => {
                let scale = this.calculateScale();
                let newCanvasWidth = this.phaserScaleManager.width * scale;
                let newCanvasHeight = this.phaserScaleManager.height * scale;
                this.canvasStyle.width = newCanvasWidth + 'px';
                this.canvasStyle.height = newCanvasHeight + 'px';
                this.canvasStyle.marginLeft = (window.innerWidth - newCanvasWidth) / 2 + 'px';
                this.canvasStyle.marginTop = (window.innerHeight - newCanvasHeight) / 2 + 'px';
            };
            this.game = game;
            this.canvasStyle = this.game.canvas.style;
            this.phaserScaleManager = this.game.scale;
        }
        static detectBestScaleMode() {
            let iOS = /iPad|iPhone|iPod/.test(navigator.platform || "");
            let isAndroid = window.navigator.userAgent.toLowerCase().indexOf("android") > -1;
            return iOS || isAndroid ? Phaser.Scale.FIT : Phaser.Scale.NONE;
        }
        ;
        /**
         * Just call this method once in Boot scene's init() method
         */
        setup() {
            this.phaserScaleManager.addListener(Phaser.Scale.Events.RESIZE, this.onResize, this);
            this.overridePhaserTransformMethods();
            this.onResize();
        }
        calculateScale() {
            if (game.scale.scaleMode == Phaser.Scale.NONE)
                return 1;
            return Math.min(window.innerWidth / this.phaserScaleManager.width, window.innerHeight / this.phaserScaleManager.height);
        }
        overridePhaserTransformMethods() {
            this.game.scale.transformX = (pageX) => {
                return (pageX - parseInt(this.canvasStyle.marginLeft.split("px")[0])) / this.calculateScale();
            };
            this.game.scale.transformY = (pageY) => {
                return (pageY - parseInt(this.canvasStyle.marginTop.split("px")[0])) / this.calculateScale();
            };
        }
        onResize() {
            setTimeout(this.doResize, FitScaleManager.RESIZE_DELAY);
        }
    }
    FitScaleManager.RESIZE_DELAY = 500;
    var ctb;
    (function (ctb) {
        var core;
        (function (core) {
            class Gameplay {
                constructor() {
                    this.allLettersNames = null;
                    this.currentRound = 0;
                    this.correctAnswersCount = 0;
                    this.wrongAnswersCount = 0;
                    this.correctAnswersCountThisRound = 0;
                    this.wrongAnswersCountThisRound = 0;
                    this.onNewRound = null;
                    this.nextLetterDelay = 0;
                    this.failsNumToLose = Number(game.cache.json.get('gameplay')["failsNumToLose"]);
                    this.useImages = Boolean(game.cache.json.get('gameplay')["useImages"]);
                }
                setupCallbacks(onComplete, onLose, onNewRound) {
                    this.onComplete = onComplete;
                    this.onLose = onLose;
                    this.onNewRound = onNewRound;
                }
                calculateScore() {
                    return this.totalRoundsNum - this.wrongAnswersCount;
                }
                onLetterChosen() {
                    if (this.correctAnswersCountThisRound == 1) {
                        this.currentRound++;
                        if (this.currentRound >= this.totalRoundsNum) {
                            let score = this.calculateScore();
                            this.onComplete(score, score);
                            return true;
                        }
                        else {
                            this.nextLetter();
                        }
                    }
                    return false;
                }
                nextLetter() {
                    let fn = () => {
                        let thisRound = this.rounds.shift();
                        this.bridgeLetters = thisRound["bridgeLetters"];
                        this.selectableLetters = thisRound["selectableLetters"];
                        this.wordAudioKey = thisRound["wordAudioKey"];
                        this.correctAnswersCountThisRound = 0;
                        this.wrongAnswersCountThisRound = 0;
                        if (this.onNewRound)
                            this.onNewRound();
                    };
                    if (this.nextLetterDelay == 0) {
                        fn();
                    }
                    else {
                        delayedCall(this.nextLetterDelay, fn);
                    }
                }
                onCorrectAnswer() {
                    this.correctAnswersCount++;
                    this.correctAnswersCountThisRound++;
                    this.nextLetterDelay = 4500;
                    return this.onLetterChosen();
                }
                onWrongAnswer() {
                    this.wrongAnswersCount++;
                    this.wrongAnswersCountThisRound++;
                    this.nextLetterDelay = 0;
                    if (this.wrongAnswersCount >= this.failsNumToLose) {
                        this.onLose(0, 0);
                        return true;
                    }
                    else {
                        this.onLetterChosen();
                    }
                    return false;
                }
                getCurrentTotalAnswersCount() {
                    return this.correctAnswersCount + this.wrongAnswersCount;
                }
                getCurrentTotalAnswersCountThisRound() {
                    return this.correctAnswersCountThisRound + this.wrongAnswersCountThisRound;
                }
                isNewRound() {
                    return this.getCurrentTotalAnswersCountThisRound() == 0;
                }
                isRoundsComplete() {
                    return this.currentRound >= this.totalRoundsNum;
                }
                getWordAudioKey() {
                    return this.wordAudioKey;
                }
                reset() {
                    this.nextLetterDelay = 0;
                    this.setupCallbacks(null, null, null);
                    let json = game.cache.json.get('gameplay');
                    this.rounds = json["rounds"].slice();
                    this.totalRoundsNum = this.rounds.length;
                    this.letters = json["letters"].slice();
                    this.allLettersNames = [];
                    for (let d of this.letters)
                        this.allLettersNames.push(d["letterName"]);
                    this.nextLetter();
                    this.currentRound = 0;
                    this.correctAnswersCount = 0;
                    this.wrongAnswersCount = 0;
                    this.correctAnswersCountThisRound = 0;
                    this.wrongAnswersCountThisRound = 0;
                }
            }
            core.Gameplay = Gameplay;
        })(core = ctb.core || (ctb.core = {}));
    })(ctb || (ctb = {}));
    var ctb;
    (function (ctb) {
        var scene;
        (function (scene) {
            class Boot extends Phaser.Scene {
                init() {
                    this.game.scale.transformX = (pageX) => {
                        let offsetLeft = 0;
                        let parentElement = game.canvas.parentElement;
                        while (parentElement) {
                            if (parentElement.offsetLeft) {
                                offsetLeft = parentElement.offsetLeft;
                                break;
                            }
                            parentElement = parentElement.parentElement;
                        }
                        return (pageX - offsetLeft) * this.game.scale.displayScale.x;
                    };
                    this.game.scale.transformY = (pageY) => {
                        let offsetTop = 0;
                        let parentElement = game.canvas.parentElement;
                        while (parentElement) {
                            if (parentElement.offsetTop) {
                                offsetTop = parentElement.offsetTop;
                                break;
                            }
                            parentElement = parentElement.parentElement;
                        }
                        return (pageY - offsetTop) * this.game.scale.displayScale.y;
                    };
                }
                create() {
                    game.scene.remove('Boot');
                    game.scene.add('Preloader', ctb.scene.Preloader, true);
                }
            }
            scene.Boot = Boot;
        })(scene = ctb.scene || (ctb.scene = {}));
    })(ctb || (ctb = {}));
    var ctb;
    (function (ctb) {
        var scene;
        (function (scene) {
            var Gameplay = ctb.core.Gameplay;
            class MainScene extends Phaser.Scene {
                create() {
                    this.gameplay = new Gameplay();
                    this.gameplayScreen = new ctb.screen.GameplayScreen(this, this.gameplay);
                    this.children.add(this.gameplayScreen);
                    this.gameplayScreen.showInstructionPage();
                }
                update() {
                    this.gameplayScreen._update();
                }
            }
            scene.MainScene = MainScene;
        })(scene = ctb.scene || (ctb.scene = {}));
    })(ctb || (ctb = {}));
    var ctb;
    (function (ctb) {
        var scene;
        (function (scene) {
            class Preloader extends Phaser.Scene {
                preload() {
                    if (typeof ctb.App.json == "string") this.load.json('gameplay', ctb.App.json); else this.game.cache.json.add('gameplay', ctb.App.json);
                }
                create() {
                    let json = game.cache.json.get('gameplay');
                    if (json["useImages"]) {
                        for (let l of json["letters"]) {
                            this.load.image(l["letterName"], "assets/games/cross-the-bridge/imgs/letters/" + l["letterImageKey"] + ".png");
                        }

                        for (let round of json['rounds']) {
                            let word = '';
                            for (let l of round.bridgeLetters) {
                                word += l;
                            }
                            this.load.image(word, "assets/games/cross-the-bridge/imgs/words/" + word + ".png");
                        }
                    }

                    for (let l of json["rounds"]) {
                        this.load.audio(l["wordAudioKey"], "assets/games/cross-the-bridge/sound/mp3/words/" + l["wordAudioKey"].replace(".wav", ".mp3"));
                        this.load.audio('q' + l["wordAudioKey"], "assets/games/cross-the-bridge/sound/mp3/questions/" + l["wordAudioKey"].replace(".wav", ".mp3"));
                    }
                    let progressTxt = this.add.text(game.scale.width / 2, game.scale.height / 2, "", {
                        "fontFamily": "QuranErafont",
                        "fontSize": 25,
                        "color": "#000000",
                        "align": 'center'
                    });
                    progressTxt.setOrigin(0.5, 0.5);
                    this.load.pack('preloader', 'assets/games/cross-the-bridge/pack.json');
                    this.load.on('progress', (value) => {
                        progressTxt.text = Math.ceil(value * 100) + "%";
                    }, this);
                    this.load.on('complete', () => {
                        this.nextScene();
                    });
                    this.load.start();
                }
                static playAnim(animKey, sprite, onComplete = null) {
                    let mainScene = game.scene.getScene('ScreenMain');
                    if (!mainScene.anims.exists(animKey)) {
                        let data = Preloader.ANIMS_DATA[animKey];
                        mainScene.anims.create({
                            key: animKey,
                            frames: mainScene.anims.generateFrameNames(data['atlas'], {
                                start: data['start'], end: data['end'], zeroPad: data['padNum'],
                                prefix: data['prefix'], suffix: ''
                            }),
                            frameRate: data['frameRate'],
                            repeat: data['repeat']
                        });
                    }
                    sprite.off('animationcomplete');
                    sprite.anims.stop();
                    sprite.play(animKey);
                    sprite.on('animationcomplete', () => {
                        if (onComplete)
                            onComplete();
                    });
                    return sprite;
                }
                nextScene() {
                    game.scene.remove('Preloader');
                    game.scene.add('ScreenMain', ctb.scene.MainScene, true);
                }
            }
            Preloader.ANIMS_DATA = {
                'Sprite Files_Happy': {
                    'start': 0,
                    'end': 56,
                    'padNum': 4,
                    'prefix': 'happy',
                    'repeat': 0,
                    'frameRate': 12,
                    'atlas': 'duck-atlass-Sprite Files_Happy'
                },
                'Sprite Files_Iddle': {
                    'start': 0,
                    'end': 73,
                    'padNum': 4,
                    'prefix': 'iddle',
                    'repeat': 0,
                    'frameRate': 12,
                    'atlas': 'duck-Sprite Files_Iddle'
                }
            };
            scene.Preloader = Preloader;
        })(scene = ctb.scene || (ctb.scene = {}));
    })(ctb || (ctb = {}));
    var ctb;
    (function (ctb) {
        var screen;
        (function (screen) {
            class AreYouSureWindow extends Phaser.GameObjects.Container {
                constructor(scene, onYes, onNo) {
                    super(scene);
                    this._areYouSurePage = new Phaser.GameObjects.Image(this.scene, -105, 0 - 48, 'Exit warning');
                    this._areYouSurePage.setOrigin(0, 0);
                    this._areYouSurePage.setInteractive();
                    var modalTextStyle = {
                        backgroundColor: 'transparent',
                        stroke: '#ffffff',
                        strokeThickness: 2,
                        lineSpacing: 15,
                        fontFamily: 'Kids Rock DEMO',
                        fontSize: 27,
                        color: '#43425d',
                        wordWrap: true,
                        align: 'center'
                    };
                    var modalText = this.scene.add.text(game.scale.width / 2 + 12, game.scale.height / 2, "Your progress in this activity will not be saved. \n Are you sure you want to exit? ", modalTextStyle);
                    modalText.setOrigin(0.5, 0.5);
                    this._btnSureYes = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2 - 95, 485 - 50, 'btnYES1');
                    this._btnSureYes.setInteractive({ cursor: 'pointer' });
                    this._btnSureYes.once('pointerup', () => {
                        onYes;
                        window.angularComponentRef.backToMenu();
                    });
                    setupButtonTextureBased(this._btnSureYes, 'btnYES1', 'btnYES2');
                    this._btnSureNo = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2 + 95, 485 - 50, 'btnNO1');
                    this._btnSureNo.setInteractive({ cursor: 'pointer' });
                    this._btnSureNo.once('pointerup', onNo);
                    setupButtonTextureBased(this._btnSureNo, 'btnNO1', 'btnNO2');
                    this.add(this._areYouSurePage);
                    this.add(this._btnSureYes);
                    this.add(this._btnSureNo);
                    this.add(modalText);
                }
            }
            screen.AreYouSureWindow = AreYouSureWindow;
        })(screen = ctb.screen || (ctb.screen = {}));
    })(ctb || (ctb = {}));
    var ctb;
    (function (ctb) {
        var screen;
        (function (screen) {
            class CompleteWindow extends Phaser.GameObjects.Container {
                constructor(scene, onBack, onReplay, onNext) {
                    super(scene);
                    this.music = null;
                    this.setPosition(-104.5, -48);
                    this._bgComplete = new Phaser.GameObjects.Image(this.scene, 0, 0, 'Completion page LATEST UPDATED');
                    this._bgComplete.setOrigin(0, 0);
                    this._bgComplete.setInteractive();
                    this._cup = new Phaser.GameObjects.Image(this.scene, 400, 410, 'Trophy');
                    this._btnBack = new Phaser.GameObjects.Image(this.scene, 570, 570, 'btnBACK1');
                    this._btnReplay = new Phaser.GameObjects.Image(this.scene, 720, 570, 'btnReplay1');
                    this._btnNext = new Phaser.GameObjects.Image(this.scene, 870, 570, 'btnNEXT1');
                    let _CollectedPoints = new Phaser.GameObjects.Image(this.scene, 620, 440, 'Collected Points');
                    this.totalScoreTxt = this.scene.add.text(845, 352, "", {
                        "fontFamily": "Kids Rock DEMO",
                        "fontSize": 35,
                        "color": "#F49F1C",
                        "align": 'center',
                        'stroke': '#70451A',
                        'strokeThickness': 6
                    });
                    this.totalScoreTxt.setOrigin(0.5, 0.5);
                    let grd = this.totalScoreTxt.context.createLinearGradient(0, 0, 0, this.totalScoreTxt.height);
                    grd.addColorStop(0, '#FFFF00');
                    grd.addColorStop(1, '#C17316');
                    this.totalScoreTxt.setFill(grd);
                    this.starScoreTxt = this.scene.add.text(648, 433, "", {
                        "fontFamily": "Kids Rock DEMO",
                        "fontSize": 24,
                        "color": "#FFFFFF",
                        "align": 'center'
                    });
                    this.starScoreTxt.setOrigin(0.5, 0.5);
                    this.add([
                        this._bgComplete,
                        _CollectedPoints,
                        this._cup,
                        this._btnBack,
                        this._btnReplay,
                        this._btnNext,
                        this.totalScoreTxt,
                        this.starScoreTxt
                    ]);
                    this._btnBack.setInteractive({ cursor: 'pointer' });
                    this._btnBack.on('pointerup', () => {
                        onBack(this._btnBack);
                        window.angularComponentRef.backToMenu();
                        // if (this.music) {
                        //     this.music.stop();
                        // }
                    });
                    setupButtonTextureBased(this._btnBack, 'btnBACK1', 'btnBACK2');
                    this._btnReplay.setInteractive({ cursor: 'pointer' });
                    this._btnReplay.once('pointerup', () => {
                        onReplay(this._btnReplay);
                        if (this.music) {
                            this.music.stop();
                        }
                    });
                    setupButtonTextureBased(this._btnReplay, 'btnReplay1', 'btnReplay2');
                    this._btnNext.setInteractive({ cursor: 'pointer' });
                    this._btnNext.on('pointerup', () => {
                        onNext(this._btnNext);
                        window.angularComponentRef.nextActivity();
                        // if (this.music) {
                        //     this.music.stop();
                        // }
                    });
                    setupButtonTextureBased(this._btnNext, 'btnNEXT1', 'btnNEXT2');
                }
                show(score, starScore) {
                    window.angularComponentRef.gameFinish({ score, starScore })
                    this._cup.scale = 1.25;
                    this.scene.tweens.add({
                        targets: this._cup,
                        "scale": 1,
                        duration: 500,
                        ease: Phaser.Math.Easing.Back.Out
                    });
                    this.totalScoreTxt.text = String(window.angularComponentRef.component.userInfo.totalScore);
                    this.starScoreTxt.text = String(starScore);
                    // let music = this.scene.sound.add("viktory");
                    this.music = this.scene.sound.add("Activity completion fantastic");
                    this.music.play();
                }
            }
            screen.CompleteWindow = CompleteWindow;
        })(screen = ctb.screen || (ctb.screen = {}));
    })(ctb || (ctb = {}));
    var ctb;
    (function (ctb) {
        var screen;
        (function (screen) {
            var Preloader = ctb.scene.Preloader;
            class GameplayScreen extends Phaser.GameObjects.Container {
                constructor(scene, gameplay) {
                    super(scene);
                    this.bgMusic = null;
                    this.correctAudio = null;
                    this.playIdle = () => {
                        this.character.setScale(200 / 250 * 1.05);
                        Preloader.playAnim('Sprite Files_Iddle', this.character, this.playIdle);
                    };
                    this.onDuckEnterMosqueSndIndex = 0;
                    this.wfsnd = null;
                    this.showCompleteWindow = (score, starScore) => {
                        delayedCall(1750, () => {
                            this.scene.sound.add("Call to prayer").play();
                        });
                        this.setInputEnabled(false);
                        delayedCall(10500, () => {
                            let completeWindow = new screen.CompleteWindow(this.scene, (target) => {
                                playBtnClickAnim(target);
                            }, (target) => {
                                playBtnClickAnim(target);
                                this.destroyGameplay();
                                this.remove(completeWindow);
                                this.showInstructionPage();
                            }, (target) => {
                                playBtnClickAnim(target);
                            });
                            delayedCall(2000, () => {
                                setPageBackground("bg-blue");
                                this.add(completeWindow);
                                completeWindow.show(score, starScore);
                                this.bgMusic.stop();
                            });
                        });
                    };
                    this.showLoseWindow = (score, starScore) => {
                        let tryAgainWindow = new screen.TryAgainWindow(this.scene, (target) => {
                            playBtnClickAnim(target);
                        }, (target) => {
                            playBtnClickAnim(target);
                            this.destroyGameplay();
                            this.remove(tryAgainWindow);
                            this.showInstructionPage();
                        });
                        this.setInputEnabled(false);
                        delayedCall(2500, () => {
                            setPageBackground("bg-blue");
                            this.add(tryAgainWindow);
                            tryAgainWindow.show(score, starScore);
                            this.bgMusic.stop();
                        });
                    };
                    this.gameplay = gameplay;
                    window["gs"] = this;
                    this._gameStage = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2, game.scale.height / 2, 'BG');
                    this._gameStage.setOrigin(0.5, 0.5);
                    this._gameStage.setScale(1.02);
                    this._gameStage.setInteractive();
                    this.add(this._gameStage);
                    this._btnClose = new Phaser.GameObjects.Image(this.scene, 1025 - 105, 100 - 50, 'x Button');
                    this._btnClose.setInteractive({ cursor: 'pointer' });
                    this._btnClose["defScale"] = this._btnClose.scale;
                    setupButtonTextureBased(this._btnClose, 'x Button', 'x Button HOVER EFFECT');
                    this.add(this._btnClose);
                    this._btnClose.on('pointerup', () => {
                        playBtnClickAnim(this._btnClose);
                        this.onCloseClick();
                    });
                    this._btnSound = new Phaser.GameObjects.Image(this.scene, 160 - 105, 100 - 50, 'Sound');
                    this._btnSound.setInteractive({ cursor: 'pointer' });
                    this._btnSound["defScale"] = this._btnSound.scale;
                    setupButtonTextureBased(this._btnSound, 'Sound', 'Sound HOVER EFFECT');
                    this.add(this._btnSound);
                    this._btnSound.on('pointerup', () => {
                        playBtnClickAnim(this._btnSound);
                        this.onSoundClick();
                    });
                }
                playCorrectAudio() {
                    if (this.correctAudio) {
                        this.correctAudio.stop();
                    }
                    this.correctAudio = this.scene.sound.add('q' + this.gameplay.wordAudioKey);
                    this.correctAudio.play();
                    if (this.areYouSureWindow && this.areYouSureWindow.parentContainer == this) {
                        this.correctAudio.pause();
                    }
                }
                onSoundClick() {
                    this.playCorrectAudio();
                }
                showGameplay() {
                    this.onDuckEnterMosqueSndIndex = 0;
                    setPageBackground("bg-australia");
                    this.bgMusic = this.scene.sound.add("Bachground ambience");
                    this.bgMusic.play();
                    this.bgMusic.loop = true;
                    this.gameplayContainer = new Phaser.GameObjects.Container(this.scene);
                    this.addAt(this.gameplayContainer, this.getIndex(this._btnClose));
                    this.gameplay.reset();
                    this.prepareRound();
                    this.gameplay.setupCallbacks(this.showCompleteWindow, this.showLoseWindow, () => {
                        this.onNewRound(true);
                    });
                    this.createTallies();
                }
                prepareRound() {
                    this.gameplayContainer.removeAll();
                    this.character = this.scene.add.sprite(0, 0, null);
                    this.character.setPosition(190 - 250, 234);
                    delayedCall(250, () => this.scene.sound.add('duck entering the frame').play());
                    this.scene.tweens.add({
                        targets: this.character,
                        x: 190,
                        duration: 1600,
                        ease: Phaser.Math.Easing.Sine.Out,
                        onComplete: () => {
                            this.playCorrectAudio();
                        }
                    });
                    this.character.setScale(1.05);
                    Preloader.playAnim('Sprite Files_Happy', this.character, this.playIdle);
                    this.mosqueLand = new Phaser.GameObjects.Image(this.scene, 750, 275, 'mosque Land');
                    this.gameplayContainer.add(this.mosqueLand);
                    this.gameplayContainer.add(this.mosqueBack = new Phaser.GameObjects.Image(this.scene, 805, 155, 'Mosque'));
                    this.gameplayContainer.add(this.mosqueFront = new Phaser.GameObjects.Image(this.scene, 805, 155, 'MosqueFront'));
                    this.gameplayContainer.add(new Phaser.GameObjects.Image(this.scene, 913, 365, 'tree'));
                    let bridgeLetter = this.gameplay.bridgeLetters.slice();
                    let randomizedLetter = Phaser.Utils.Array.Shuffle(this.gameplay.selectableLetters.slice());
                    this.selectableLetters = [];
                    this.bridgeLetters = [];
                    for (let i = 0; i < bridgeLetter.length; i++) {
                        let b = new Phaser.GameObjects.Container(this.scene, 310 + i * 100, 350);
                        b.add(b['-whileRect-'] = new Phaser.GameObjects.Image(this.scene, ((bridgeLetter.length - 1) / 2 - i) * 6, 0, 'whileRect').setScale(1.04, 0.95));
                        b['-whileRect-'].alpha = 0;
                        this.bridgeLetters.push(b);
                        let l = bridgeLetter[bridgeLetter.length - 1 - i];
                        let txt;
                        if (this.gameplay.useImages) {
                            txt = new Phaser.GameObjects.Image(this.scene, 0, 0, l);

                            b.add(txt);
                        }
                        else {
                            txt = this.scene.add.text(0, -5, "", {
                                "fontFamily": "QuranErafont",
                                "fontSize": 45,
                                "color": "#000000",
                                "align": 'center'
                            });
                            txt.setOrigin(0.5, 0.5);
                            txt.style.fixedHeight = 65;
                            txt.setText(l);
                            b.add(txt);
                        }
                        b["-letter-"] = txt;
                        b["-letter-text"] = l;
                        this.gameplayContainer.add(b);
                    }
                    for (let i = 0; i < randomizedLetter.length; i++) {
                        let a = new Phaser.GameObjects.Container(this.scene, 200 + i * 136, 520);
                        a.add(a["-image-"] = new Phaser.GameObjects.Image(this.scene, 0, 0, 'block'));
                        a["-image-"].setOrigin(0.42, 0.55);
                        a.add(a['-whileRect-'] = new Phaser.GameObjects.Image(this.scene, -6, 0, 'whileRect').setScale(1.04, 0.95));
                        a['-whileRect-'].alpha = 0;
                        this.selectableLetters.push(a);
                        let txt;
                        if (this.gameplay.useImages) {
                            txt = new Phaser.GameObjects.Image(this.scene, 0, 0, randomizedLetter[i]);
                            a.add(txt);
                        }
                        else {
                            txt = this.scene.add.text(0, -5, "", {
                                "fontFamily": "QuranErafont",
                                "fontSize": 45,
                                "color": "#000000",
                                "align": 'center'
                            });
                            txt.setOrigin(0.5, 0.5);
                            txt.style.fixedHeight = 65;
                            txt.setText(randomizedLetter[i]);
                            a.add(txt);
                        }
                        a['startPosition'] = { x: a.x, y: a.y };
                        a["-letter-"] = txt;
                        a["-letter-text"] = randomizedLetter[i];
                        this.gameplayContainer.add(a);
                    }
                    for (let block of this.selectableLetters) {
                        block.setSize(block["-image-"].width, block["-image-"].height);
                        block.setInteractive({ cursor: 'pointer' });
                        block.on('pointerdown', () => {
                            this.setInputEnabled(false);
                            let emptyBlock = this.bridgeLetters[this.bridgeLetters.length - 1];
                            block.disableInteractive();
                            this.placeBlockOnEmptyPlace(block);
                            this.scene.tweens.add({
                                targets: block,
                                x: emptyBlock.x,
                                y: emptyBlock.y,
                                duration: 300,
                                ease: Phaser.Math.Easing.Back.Out
                            });
                            if (block["-letter-text"] == emptyBlock["-letter-text"]) {
                                this.scene.sound.add("Correct click").play();
                                for (let _block of this.selectableLetters) {
                                    if (_block != block) {
                                        this.scene.tweens.add({
                                            targets: _block,
                                            alpha: 0,
                                            duration: 300
                                        });
                                    }
                                }
                                delayedCall(300, () => {
                                    let blocks = this.bridgeLetters.slice();
                                    blocks.splice(blocks.length - 1, 1, block)
                                    let wr = [];
                                    for (let b of blocks) {
                                        wr.push(b['-whileRect-']);
                                    }
                                    this.scene.tweens.add({
                                        targets: wr,
                                        alpha: 1,
                                        duration: 300
                                    });
                                    delayedCall(300, () => {
                                        this.scene.sound.add("Letters joining sound").play();
                                    });
                                    let word = "";
                                    for (let k = blocks.length - 1; k >= 0; k--) {
                                        word += blocks[k]["-letter-text"];
                                        this.scene.tweens.add({
                                            targets: blocks[k]['-letter-'],
                                            x: blocks[k]['-letter-'].x + ((blocks.length - 1) / 2 - k) * 100,
                                            duration: 200,
                                            delay: 200
                                        });
                                    }
                                    let letters = [];
                                    for (let b of blocks) {
                                        letters.push(b['-letter-']);
                                    }
                                    delayedCall(300, () => {
                                        if (this.gameplay.useImages) {
                                            blocks[1]['-letter-'].setTexture(word);
                                        } else {
                                            blocks[1]['-letter-'].setText(word);
                                        }
                                        this.scene.sound.add(this.gameplay.getWordAudioKey()).play();
                                    });
                                });
                                delayedCall(1750, () => {
                                    this.onCorrectAnswer();
                                });
                            }
                            else {
                                let lost = this.onWrongAnswer();
                                this.scene.sound.add("Wrong Answer").play();
                                if (!lost) {
                                    delayedCall(2500, () => {
                                        this.playCorrectAudio();
                                    });
                                }
                                delayedCall(1200, () => {
                                    this.moveBridgeBackToStartPosition(block, () => {
                                        if (!lost) {
                                            delayedCall(2000, () => {
                                                this.setInputEnabled(true);
                                            });
                                        }
                                    });
                                });
                            }
                        });
                    }
                    this._btnClose.setInteractive({ cursor: 'pointer', pixelPerfect: true });
                    this.setInputEnabled(false);
                    if (this.gameplay.isNewRound()) {
                        if (!this.gameplay.isRoundsComplete()) {
                            delayedCall(2000, () => {
                                this.setInputEnabled(true);
                            });
                        }
                    }
                    else {
                        this.setInputEnabled(true);
                    }
                    this.bridgeLetters[2].visible = false;
                    this.gameplayContainer.addAt(this.character, this.gameplayContainer.getIndex(this.mosqueFront));
                }
                _update() {
                    if (this.selectableLetters) {
                        for (let a of this.selectableLetters) {
                            if (a.x < 0 + a["-image-"].width / 2) {
                                a.x = 0 + a["-image-"].width / 2;
                            }
                            else if (a.x > game.scale.width - a["-image-"].width / 2) {
                                a.x = game.scale.width - a["-image-"].width / 2;
                            }
                            if (a.y < 0 + a["-image-"].height / 2) {
                                a.y = a["-image-"].height / 2;
                            }
                            else if (a.y > game.scale.height - a["-image-"].height / 2) {
                                a.y = game.scale.height - a["-image-"].height / 2;
                            }
                        }
                    }
                }
                placeAppleOverBuckets(a) {
                    if (!a.parentContainer)
                        return;
                    this.gameplayContainer.remove(a);
                    this.gameplayContainer.addAt(a, this.gameplayContainer.length);
                }
                placeBlockOnEmptyPlace(b) {
                    this.gameplayContainer.remove(b);
                    this.gameplayContainer.addAt(b, this.gameplayContainer.getIndex(this.mosqueLand));
                }
                onNewRound(showOut) {
                    this.scene.sound.add("next_round").play();
                    this.setInputEnabled(false);
                    if (showOut) {
                        this.prepareRound();
                    }
                }
                moveBridgeBackToStartPosition(block, onComplete) {
                    this.scene.tweens.add({
                        targets: block,
                        x: block['startPosition'].x,
                        y: block['startPosition'].y,
                        duration: 250,
                        ease: Phaser.Math.Easing.Sine.Out,
                        onComplete: () => {
                            if (onComplete)
                                onComplete();
                        }
                    });
                    this.placeAppleOverBuckets(block);
                }
                onCorrectAnswer() {
                    let i = this.gameplay.getCurrentTotalAnswersCount();
                    this.tallyEmptyArray[i].visible = false;
                    this.tally[i].visible = true;
                    let completed = this.gameplay.onCorrectAnswer();
                    this.scene.sound.add("duck and spin sound").play();
                    this.scene.tweens.add({
                        targets: this.character,
                        x: 850,
                        duration: 3300,
                        ease: Phaser.Math.Easing.Sine.Out
                    });
                    delayedCall(2500, () => {
                        if (!this.gameplay.isRoundsComplete()) {
                            this.scene.sound.add(++this.onDuckEnterMosqueSndIndex % 2 == 0 ? "Arabic success word" : "Children Happy Yay").play();
                        }
                    });
                    this.character.setScale(1.05);
                    Preloader.playAnim('Sprite Files_Happy', this.character);
                    return completed;
                }
                onWrongAnswer() {
                    let i = this.gameplay.getCurrentTotalAnswersCount();
                    this.tallyEmptyArray[i].visible = true;
                    this.tallyEmptyArray[i].visible = true;
                    this.tally[i].visible = false;
                    let lost = this.gameplay.onWrongAnswer();
                    return lost;
                }
                onCloseClick() {
                    this.showAreYouSurePage();
                    this.scene.sound.add('warning page pop up sfx').play();
                }
                createTallies() {
                    if (this.tally) {
                        for (let te of this.tallyEmptyArray) {
                            te.visible = false;
                            this.bringToTop(te);
                        }
                        for (let t of this.tally) {
                            t.visible = false;
                            this.bringToTop(t);
                        }
                        return;
                    }
                    let startX = 878 - 105;
                    let startY = 532 - 50;
                    let dx = 53;
                    let dy = 44;
                    let tallyEmptyArrayPositions = [];
                    for (let i = 0; i < 3; i++) {
                        for (let j = 0; j < 4; j++) {
                            tallyEmptyArrayPositions.push({ x: startX + j * dx, y: startY + i * dy });
                        }
                    }
                    this.tallyEmptyArray = [];
                    this.tally = [];
                    for (let p of tallyEmptyArrayPositions) {
                        let _BeehiveEmpty = new Phaser.GameObjects.Image(this.scene, p['x'], p['y'], 'tally Empty');
                        this.tallyEmptyArray.push(_BeehiveEmpty);
                        _BeehiveEmpty.visible = false;
                        let _Beehive = new Phaser.GameObjects.Image(this.scene, p['x'], p['y'], 'tally');
                        this.tally.push(_Beehive);
                    }
                    for (let bea of this.tallyEmptyArray) {
                        this.add(bea);
                    }
                    for (let bee of this.tally) {
                        this.add(bee);
                        bee.visible = false;
                    }
                }
                hideAllUnusedTallies() {
                    let i = this.gameplay.getCurrentTotalAnswersCount();
                    for (let k = i + 1; k < this.tallyEmptyArray.length; k++) {
                        this.tallyEmptyArray[k].visible = false;
                        this.tally[k].visible = false;
                    }
                }
                showInstructionPage() {
                    setPageBackground("bg-blue");
                    let playInstructionSound = () => {
                        if (this.wfsnd) {
                            this.wfsnd.stop();
                        }
                        this.wfsnd = this.scene.sound.add("Help the Yellow Duck");
                        this.wfsnd.play();
                    };
                    this.instructionPage = new screen.InstructionPage(this.scene, (target) => {
                        playBtnClickAnim(target);
                        this.remove(this.instructionPage);
                        this.showGameplay();
                        if (this.wfsnd) {
                            this.wfsnd.stop();
                        }
                    }, (target) => {
                        playBtnClickAnim(target);
                        playInstructionSound();
                    });
                    this.add(this.instructionPage);
                    try {
                        playInstructionSound();
                    }
                    catch (e) {
                        console.error(e);
                    }
                }
                showAreYouSurePage() {
                    pauseAllDelayedCalls();
                    setPageBackground("bg-blue");
                    this.scene.tweens.pauseAll();
                    this.pauseSounds();
                    this.areYouSureWindow = new screen.AreYouSureWindow(this.scene, () => {
                        this.scene.tweens.resumeAll();
                        this.remove(this.areYouSureWindow);
                        this.destroyGameplay();
                        this.showInstructionPage();
                    }, () => {
                        this.scene.tweens.resumeAll();
                        this.remove(this.areYouSureWindow);
                        this.unpauseSounds();
                        resumeAllDelayedCalls();
                        setPageBackground("bg-australia");
                    });
                    this.add(this.areYouSureWindow);
                }
                setInputEnabled(enabled) {
                    if (enabled) {
                        for (let a of this.selectableLetters)
                            a.setInteractive( /*{cursor: 'pointer', pixelPerfect:true}*/);
                    }
                    else {
                        for (let a of this.selectableLetters)
                            a.disableInteractive();
                    }
                }
                pauseSounds() {
                    this.scene.sound.pauseAll();
                }
                unpauseSounds() {
                    this.scene.sound.resumeAll();
                }
                destroyGameplay() {
                    this.setInputEnabled(false);
                    this.remove(this.gameplayContainer);
                    this.scene.sound.stopAll();
                    destroyAllDelayedCalls();
                }
            }
            screen.GameplayScreen = GameplayScreen;
        })(screen = ctb.screen || (ctb.screen = {}));
    })(ctb || (ctb = {}));
    var ctb;
    (function (ctb) {
        var screen;
        (function (screen) {
            class InstructionPage extends Phaser.GameObjects.Container {
                constructor(scene, onPlayClick, onSndClick) {
                    super(scene);
                    this._instructionPage = new Phaser.GameObjects.Image(this.scene, 0 - 105, 0 - 48, 'Instructions page  ALL ACTIVITY  TITLEs');
                    this._instructionPage.setOrigin(0, 0);
                    this._instructionPage.setInteractive();
                    this._instructionPageTitle = new Phaser.GameObjects.Image(this.scene, 495, 105, 'NEWS LETTERS');
                    this._instructionPageTitle.setScale(0.65);
                    this._btnPlay = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2, 480 - 50, 'btnPLAY1');
                    this._btnPlay.setInteractive({ cursor: 'pointer' });
                    this._btnPlay.once('pointerup', onPlayClick);
                    setupButtonTextureBased(this._btnPlay, 'btnPLAY1', 'btnPLAY2');
                    this.instrTxt = this.scene.add.text(game.scale.width / 2, game.scale.height / 2, "Help the Yellow Duck to cross the bridge by completing the word.", {
                        "fontFamily": "Kids Rock DEMO",
                        "fontSize": 30,
                        "color": "#43425D",
                        "align": 'center'
                    });
                    this.instrTxt.setOrigin(0.5, 0.5);
                    this.instrTxt.setWordWrapWidth(650);
                    this.instrTxt.setLineSpacing(11);
                    this._btnSoundInstruction = new Phaser.GameObjects.Image(this.scene, 800 - 105, 156 - 50, 'Sound');
                    this._btnSoundInstruction.setInteractive({ cursor: 'pointer' });
                    this._btnSoundInstruction.on('pointerup', onSndClick);
                    this._btnSoundInstruction["defScale"] = this._btnSoundInstruction.scale;
                    setupButtonTextureBased(this._btnSoundInstruction, 'Sound', 'Sound HOVER EFFECT');
                    this.add(this._instructionPage);
                    this.add(this._instructionPageTitle);
                    this.add(this.instrTxt);
                    this.add(this._btnPlay);
                    this.add(this._btnSoundInstruction);
                }
            }
            screen.InstructionPage = InstructionPage;
        })(screen = ctb.screen || (ctb.screen = {}));
    })(ctb || (ctb = {}));
    var ctb;
    (function (ctb) {
        var screen;
        (function (screen) {
            class TryAgainWindow extends Phaser.GameObjects.Container {
                constructor(scene, onBack, onReplay) {
                    super(scene);
                    this.music = null;
                    this.setPosition(-106, -48);
                    this._bg = new Phaser.GameObjects.Image(this.scene, 0, 0, 'Try again page');
                    this._bg.setOrigin(0, 0);
                    this._bg.setInteractive();
                    this._star = new Phaser.GameObjects.Image(this.scene, 400, 415, 'Break Star');
                    this._btnBack = new Phaser.GameObjects.Image(this.scene, 600, 580, 'btnBACK1');
                    this._btnReplay = new Phaser.GameObjects.Image(this.scene, 765, 580, 'btnReplay1');
                    this.totalScoreTxt = this.scene.add.text(830, 355, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 35,
                        "color": "#F49F1C",
                        "align": 'center',
                        'stroke': '#70451A',
                        'strokeThickness': 6
                    });
                    this.totalScoreTxt.setOrigin(0.5, 0.5);
                    let grd = this.totalScoreTxt.context.createLinearGradient(0, 0, 0, this.totalScoreTxt.height);
                    grd.addColorStop(0, '#FFFF00');
                    grd.addColorStop(1, '#C17316');
                    this.totalScoreTxt.setFill(grd);
                    this.starScoreTxt = this.scene.add.text(635, 431, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 24,
                        "color": "#FFFFFF",
                        "align": 'center'
                    });
                    this.starScoreTxt.setOrigin(0.5, 0.5);
                    this.add([
                        this._bg,
                        this._star,
                        this._btnBack,
                        this._btnReplay,
                        this.totalScoreTxt,
                        this.starScoreTxt
                    ]);
                    this._btnBack.setInteractive({ cursor: 'pointer' });
                    this._btnBack.on('pointerup', () => {
                        onBack(this._btnBack);
                        window.angularComponentRef.backToMenu()
                        // if (this.music) {
                        //     this.music.stop();
                        // }
                    });
                    setupButtonTextureBased(this._btnBack, 'btnBACK1', 'btnBACK2');
                    this._btnReplay.setInteractive({ cursor: 'pointer' });
                    this._btnReplay.once('pointerup', () => {
                        onReplay(this._btnReplay);
                        if (this.music) {
                            this.music.stop();
                        }
                    });
                    setupButtonTextureBased(this._btnReplay, 'btnReplay1', 'btnReplay2');
                }
                show(score, starScore) {
                    this._star.scale = 1.25;
                    this.scene.tweens.add({
                        targets: this._star,
                        "scale": 1,
                        duration: 500,
                        ease: Phaser.Math.Easing.Back.Out
                    });
                    this.totalScoreTxt.text = String(window.angularComponentRef.component.userInfo.totalScore);
                    this.starScoreTxt.text = String(starScore);
                    this.music = this.scene.sound.add("Fail - close one");
                    this.music.play();
                }
            }
            screen.TryAgainWindow = TryAgainWindow;
        })(screen = ctb.screen || (ctb.screen = {}));
    })(ctb || (ctb = {}));

    game = new ctb.App(json);
};

function destroyCrossTheBridge() {
    if (game) {
        game.destroy();
    }
}

var garage;
var game;

var letterBasket = (json) => {
    (function (garage) {
        class App extends Phaser.Game {
            constructor(json) {
                App.json = json
                let config = {
                    type: Phaser.AUTO,
                    width: App.CANVAS_WIDTH,
                    height: App.CANVAS_HEIGHT,
                    parent: 'game-container',
                    dom: {
                        createContainer: false
                    },
                    scale: {
                        mode: FitScaleManager.detectBestScaleMode(),
                        autoCenter: Phaser.Scale.CENTER_BOTH
                    },
                    transparent: true,
                    scene: {
                        create: () => {
                            this.scene.add('Boot', garage.scene.Boot, true);
                        }
                    }
                };
                super(config);
            }
        }

        App.CANVAS_WIDTH = 980;
        App.CANVAS_HEIGHT = 600;
        garage.App = App;
    })(garage || (garage = {}));

    function pad(n, width, z) {
        z = z || '0';
        n = n + '';
        return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
    }

    var delayedCalls = [];

    function delayedCall(delay, callback, args, callbackScope) {
        let scene = game.scene.getAt(0);
        if (scene) {
            let dc = scene.time.delayedCall(delay, callback, args, callbackScope);
            delayedCalls.push(dc);
            return dc;
        }
        let t = setTimeout(callback, delay);
        delayedCalls.push(t);
        return t;
    }

    function pauseAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.paused = true;
            }
        }
    }

    function resumeAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.paused = false;
            }
        }
    }

    function destroyAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.remove(false);
            } else {
                clearTimeout(dc);
            }
        }
        delayedCalls = [];
    }

    function destroyDelayedCall(dc) {
        if (dc instanceof Phaser.Time.TimerEvent) {
            dc.remove(false);
        } else {
            clearTimeout(dc);
        }
        let ind = delayedCalls.indexOf(dc);
        if (ind >= 0)
            delayedCalls.splice(ind, 1);
    }

    function setPageBackground(bg) {
        document.querySelector("html").style.backgroundImage = "url(assets/games/letter-basket/imgs/" + bg + ".jpg)";
    }

    function setupButton(btn, frame) {
        btn.on('pointerdown', () => {
            btn.setFrame(frame + '_hover' + '0000');
        });
        btn.on('pointerover', () => {
            btn.setFrame(frame + '_hover' + '0000');
            game.scene.getAt(0).sound.add("button hover").play();
        });
        btn.on('pointerout', () => {
            btn.setFrame(frame + '0000');
        });
        btn.on('pointerup', () => {
            btn.setFrame(frame + '0000');
            game.scene.getAt(0).sound.add('activity selection - button selection').play();
        });
    }

    function setupButtonTextureBased(btn, texture, hoverTexture) {
        btn.on('pointerdown', () => {
            btn.setTexture(hoverTexture);
        });
        btn.on('pointerover', () => {
            btn.setTexture(hoverTexture);
            game.scene.getAt(0).sound.add("button hover").play();
        });
        btn.on('pointerout', () => {
            btn.setTexture(texture);
        });
        btn.on('pointerup', () => {
            if (btn.parentContainer)
                btn.setTexture(texture); game.scene.getAt(0).sound.add('activity selection - button selection').play();
        });
    }

    function playBtnClickAnim(target) {
        let sc = target.hasOwnProperty("defScale") ? target["defScale"] : 1;
        target.scaleX = target.scaleY = sc;
        let scene = game.scene.getAt(0);
        scene.tweens.add({
            targets: target,
            "scaleX": 0.9 * sc,
            "scaleY": 0.9 * sc,
            duration: 100,
            yoyo: true
        });
    }

    /**
     * @author Roman Parada
     * This class is created to fix overlapping of bottom part of canvas by navigation bar in iOS.
     * It make a delayed resize of the canvas (like Phaser-3 FIT methods does) and it overrides Phaser-3 input window to Phaser-3 core transform methods
     *
     * How to use:
     * Just call the code line below in Boot scene's init() method of your project:
     * new FitScaleManager(this.game).setup();
     */
    class FitScaleManager {
        constructor(game) {
            this.doResize = () => {
                let scale = this.calculateScale();
                let newCanvasWidth = this.phaserScaleManager.width * scale;
                let newCanvasHeight = this.phaserScaleManager.height * scale;
                this.canvasStyle.width = newCanvasWidth + 'px';
                this.canvasStyle.height = newCanvasHeight + 'px';
                this.canvasStyle.marginLeft = (window.innerWidth - newCanvasWidth) / 2 + 'px';
                this.canvasStyle.marginTop = (window.innerHeight - newCanvasHeight) / 2 + 'px';
            };
            this.game = game;
            this.canvasStyle = this.game.canvas.style;
            this.phaserScaleManager = this.game.scale;
        }

        static detectBestScaleMode() {
            let iOS = /iPad|iPhone|iPod/.test(navigator.platform || "");
            let isAndroid = window.navigator.userAgent.toLowerCase().indexOf("android") > -1;
            return iOS || isAndroid ? Phaser.Scale.FIT : Phaser.Scale.NONE;
        }
        ;

        /**
         * Just call this method once in Boot scene's init() method
         */
        setup() {
            this.phaserScaleManager.addListener(Phaser.Scale.Events.RESIZE, this.onResize, this);
            this.overridePhaserTransformMethods();
            this.onResize();
        }

        calculateScale() {
            if (game.scale.scaleMode == Phaser.Scale.NONE)
                return 1;
            return Math.min(window.innerWidth / this.phaserScaleManager.width, window.innerHeight / this.phaserScaleManager.height);
        }

        overridePhaserTransformMethods() {
            this.game.scale.transformX = (pageX) => {
                return (pageX - parseInt(this.canvasStyle.marginLeft.split("px")[0])) / this.calculateScale();
            };
            this.game.scale.transformY = (pageY) => {
                return (pageY - parseInt(this.canvasStyle.marginTop.split("px")[0])) / this.calculateScale();
            };
        }

        onResize() {
            setTimeout(this.doResize, FitScaleManager.RESIZE_DELAY);
        }
    }

    FitScaleManager.RESIZE_DELAY = 500;

    (function (garage) {
        var core;
        (function (core) {
            class Gameplay {
                constructor() {
                    this.allLettersNames = null;
                    this.currentRound = 0;
                    this.correctAnswersCount = 0;
                    this.wrongAnswersCount = 0;
                    this.correctAnswersCountThisRound = 0;
                    this.wrongAnswersCountThisRound = 0;
                    this.onNewRound = null;
                    this.nextLetterDelay = 0;
                    this.failsNumToLose = Number(game.cache.json.get('gameplay')["failsNumToLose"]);
                    this.useImages = Boolean(game.cache.json.get('gameplay')["useImages"]);
                }

                setupCallbacks(onComplete, onLose, onNewRound) {
                    this.onComplete = onComplete;
                    this.onLose = onLose;
                    this.onNewRound = onNewRound;
                }

                calculateScore() {
                    return this.roundLetters.length * this.totalRoundsNum - this.wrongAnswersCount;
                }

                onLetterChosen() {
                    if (this.correctAnswersCountThisRound == this.roundLetters.length) {
                        this.currentRound++;
                        if (this.currentRound >= this.totalRoundsNum) {
                            let score = this.calculateScore();
                            this.onComplete(score, score);
                            return true;
                        } else {
                            this.nextLetter();
                        }
                    }
                    return false;
                }

                nextLetter() {
                    let fn = () => {
                        let thisRound = this.rounds.shift();
                        this.roundLetters = thisRound["letters"];
                        this.correctAnswersCountThisRound = 0;
                        this.wrongAnswersCountThisRound = 0;
                        if (this.onNewRound)
                            this.onNewRound();
                    };
                    if (this.nextLetterDelay == 0) {
                        fn();
                    } else {
                        delayedCall(this.nextLetterDelay, fn);
                    }
                }

                onCorrectAnswer() {
                    this.correctAnswersCount++;
                    this.correctAnswersCountThisRound++;
                    this.nextLetterDelay = 1000;
                    return this.onLetterChosen();
                }

                onWrongAnswer() {
                    this.wrongAnswersCount++;
                    this.wrongAnswersCountThisRound++;
                    this.nextLetterDelay = 0;
                    if (this.wrongAnswersCountThisRound >= this.failsNumToLose) {
                        this.onLose(0, 0);
                        return true;
                    } else {
                        this.onLetterChosen();
                    }
                    return false;
                }

                getCurrentTotalAnswersCount() {
                    return this.correctAnswersCount + this.wrongAnswersCount;
                }

                getCurrentTotalAnswersCountThisRound() {
                    return this.correctAnswersCountThisRound + this.wrongAnswersCountThisRound;
                }

                isNewRound() {
                    return this.getCurrentTotalAnswersCountThisRound() == 0;
                }

                isRoundsComplete() {
                    return this.currentRound >= this.totalRoundsNum;
                }

                getAudioKeyOfChar(letter) {
                    let json = game.cache.json.get('gameplay');
                    let letters = json["letters"];
                    for (let d of letters) {
                        if (letter == d['letterName']) {
                            return d['audioKey'];
                        }
                    }
                    return null;
                }

                reset() {
                    this.nextLetterDelay = 0;
                    this.setupCallbacks(null, null, null);
                    let json = game.cache.json.get('gameplay');
                    this.rounds = json["rounds"].slice();
                    this.totalRoundsNum = this.rounds.length;
                    this.letters = json["letters"].slice();
                    this.allLettersNames = [];
                    for (let d of this.letters)
                        this.allLettersNames.push(d["letterName"]);
                    this.nextLetter();
                    this.currentRound = 0;
                    this.correctAnswersCount = 0;
                    this.wrongAnswersCount = 0;
                    this.correctAnswersCountThisRound = 0;
                    this.wrongAnswersCountThisRound = 0;
                }
            }

            core.Gameplay = Gameplay;
        })(core = garage.core || (garage.core = {}));
    })(garage || (garage = {}));

    (function (garage) {
        var scene;
        (function (scene) {
            class Boot extends Phaser.Scene {
                init() {
                    this.game.scale.transformX = (pageX) => {
                        let offsetLeft = 0;
                        let parentElement = game.canvas.parentElement;
                        while (parentElement) {
                            if (parentElement.offsetLeft) {
                                offsetLeft = parentElement.offsetLeft;
                                break;
                            }
                            parentElement = parentElement.parentElement;
                        }
                        return (pageX - offsetLeft) * this.game.scale.displayScale.x;
                    };
                    this.game.scale.transformY = (pageY) => {
                        let offsetTop = 0;
                        let parentElement = game.canvas.parentElement;
                        while (parentElement) {
                            if (parentElement.offsetTop) {
                                offsetTop = parentElement.offsetTop;
                                break;
                            }
                            parentElement = parentElement.parentElement;
                        }
                        return (pageY - offsetTop) * this.game.scale.displayScale.y;
                    };
                }

                create() {
                    game.scene.remove('Boot');
                    game.scene.add('Preloader', garage.scene.Preloader, true);
                }
            }

            scene.Boot = Boot;
        })(scene = garage.scene || (garage.scene = {}));
    })(garage || (garage = {}));

    (function (garage) {
        var scene;
        (function (scene) {
            var Gameplay = garage.core.Gameplay;

            class MainScene extends Phaser.Scene {
                create() {
                    this.gameplay = new Gameplay();
                    this.gameplayScreen = new garage.screen.GameplayScreen(this, this.gameplay);
                    this.children.add(this.gameplayScreen);
                    this.gameplayScreen.showInstructionPage();
                }

                update() {
                    this.gameplayScreen._update();
                }
            }

            scene.MainScene = MainScene;
        })(scene = garage.scene || (garage.scene = {}));
    })(garage || (garage = {}));

    (function (garage) {
        var scene;
        (function (scene) {
            class Preloader extends Phaser.Scene {
                preload() {
                    if (typeof garage.App.json == "string") this.load.json('gameplay', garage.App.json); else this.game.cache.json.add('gameplay', garage.App.json);
                }

                create() {
                    let json = game.cache.json.get('gameplay');
                    if (json["useImages"]) {
                        for (let l of json["letters"]) {
                            this.load.image('sh' + l["letterName"], "assets/games/letter-basket/imgs/letters/short/" + l["letterName"] + ".png");
                            this.load.image('a' + l["letterName"], "assets/games/letter-basket/imgs/letters/actual/" + l["letterName"] + ".png");
                        }
                    }
                    for (let l of json["letters"]) {
                        this.load.audio(l["audioKey"], "assets/games/letter-basket/sound/mp3/letters/" + l["audioKey"].replace(".wav", ".mp3"));
                    }
                    let progressTxt = this.add.text(game.scale.width / 2, game.scale.height / 2, "", {
                        "fontFamily": "QuranErafont",
                        "fontSize": 25,
                        "color": "#000000",
                        "align": 'center'
                    });
                    progressTxt.setOrigin(0.5, 0.5);
                    this.load.pack('preloader', 'assets/games/letter-basket/pack.json');
                    this.load.on('progress', (value) => {
                        progressTxt.text = Math.ceil(value * 100) + "%";
                    }, this);
                    this.load.on('complete', () => {
                        this.nextScene();
                    });
                    this.load.start();
                }

                static playAnim(animKey, sprite, onComplete = null) {
                    let mainScene = game.scene.getScene('ScreenMain');
                    if (!mainScene.anims.exists(animKey)) {
                        let data = Preloader.ANIMS_DATA[animKey];
                        mainScene.anims.create({
                            key: animKey,
                            frames: mainScene.anims.generateFrameNames(data['atlas'], {
                                start: data['start'], end: data['end'], zeroPad: data['padNum'],
                                prefix: data['prefix'], suffix: ''
                            }),
                            frameRate: data['frameRate'],
                            repeat: data['repeat']
                        });
                    }
                    if (sprite.anims.currentAnim) {
                        sprite.off('animationcomplete');
                    }
                    sprite.anims.stop();
                    sprite.play(animKey);
                    sprite.on('animationcomplete', () => {
                        if (onComplete)
                            onComplete();
                    });
                    return sprite;
                }

                nextScene() {
                    game.scene.remove('Preloader');
                    game.scene.add('ScreenMain', garage.scene.MainScene, true);
                }
            }

            Preloader.ANIMS_DATA = {
                'Sprite Files_OH NO': {
                    'start': 0,
                    'end': 29,
                    'padNum': 4,
                    'prefix': 'OH_NO',
                    'repeat': 0,
                    'frameRate': 12,
                    'atlas': 'chameleon-atlass-Sprite Files_OH NO'
                },
                'Sprite Files_Iddle': {
                    'start': 0,
                    'end': 64,
                    'padNum': 4,
                    'prefix': 'iddle',
                    'repeat': 0,
                    'frameRate': 12,
                    'atlas': 'Sprite Files_Iddle'
                },
                'Sprite Files_Iddle-reversed': {
                    'start': 64,
                    'end': 0,
                    'padNum': 4,
                    'prefix': 'iddle',
                    'repeat': 0,
                    'frameRate': 12,
                    'atlas': 'Sprite Files_Iddle'
                }
            };
            scene.Preloader = Preloader;
        })(scene = garage.scene || (garage.scene = {}));
    })(garage || (garage = {}));

    (function (garage) {
        var screen;
        (function (screen) {
            class AreYouSureWindow extends Phaser.GameObjects.Container {
                constructor(scene, onYes, onNo) {
                    super(scene);
                    this._areYouSurePage = new Phaser.GameObjects.Image(this.scene, -105, 0 - 48, 'Exit warning');
                    this._areYouSurePage.setOrigin(0, 0);
                    //this._areYouSurePage.setInteractive();
                    var modalTextStyle = {
                        backgroundColor: 'transparent',
                        stroke: '#ffffff',
                        strokeThickness: 2,
                        lineSpacing: 15,
                        fontFamily: 'Kids Rock DEMO',
                        fontSize: 27,
                        color: '#43425d',
                        wordWrap: true,
                        align: 'center'
                    };
                    var modalText = this.scene.add.text(game.scale.width / 2 + 12, game.scale.height / 2, "Your progress in this activity will not be saved. \n Are you sure you want to exit? ", modalTextStyle);
                    modalText.setOrigin(0.5, 0.5);
                    this._btnSureYes = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2 - 95, 485 - 50, 'btnYES1');
                    this._btnSureYes.setInteractive({ cursor: 'pointer' });
                    this._btnSureYes.once('pointerup', () => {
                        onYes;
                        window.angularComponentRef.backToMenu();
                    });
                    setupButtonTextureBased(this._btnSureYes, 'btnYES1', 'btnYES2');
                    this._btnSureNo = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2 + 95, 485 - 50, 'btnNO1');
                    this._btnSureNo.setInteractive({ cursor: 'pointer' });
                    this._btnSureNo.once('pointerup', onNo);
                    setupButtonTextureBased(this._btnSureNo, 'btnNO1', 'btnNO2');
                    this.add(this._areYouSurePage);
                    this.add(this._btnSureYes);
                    this.add(this._btnSureNo);
                    this.add(modalText);

                }
            }

            screen.AreYouSureWindow = AreYouSureWindow;
        })(screen = garage.screen || (garage.screen = {}));
    })(garage || (garage = {}));

    (function (garage) {
        var screen;
        (function (screen) {
            class CompleteWindow extends Phaser.GameObjects.Container {
                constructor(scene, onBack, onReplay, onNext) {
                    super(scene);
                    this.music = null;
                    this.setPosition(-104.5, -48);
                    this._bgComplete = new Phaser.GameObjects.Image(this.scene, 0, 0, 'Completion page LATEST UPDATED');
                    this._bgComplete.setOrigin(0, 0);
                    //this._bgComplete.setInteractive();
                    this._cup = new Phaser.GameObjects.Image(this.scene, 400, 410, 'Trophy');
                    this._btnBack = new Phaser.GameObjects.Image(this.scene, 570, 570, 'btnBACK1');
                    this._btnReplay = new Phaser.GameObjects.Image(this.scene, 720, 570, 'btnReplay1');
                    this._btnNext = new Phaser.GameObjects.Image(this.scene, 870, 570, 'btnNEXT1');
                    let _CollectedPoints = new Phaser.GameObjects.Image(this.scene, 620, 440, 'Collected Points');
                    this.totalScoreTxt = this.scene.add.text(845, 352, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 35,
                        "color": "#F49F1C",
                        "align": 'center',
                        'stroke': '#70451A',
                        'strokeThickness': 6
                    });
                    this.totalScoreTxt.setOrigin(0.5, 0.5);
                    let grd = this.totalScoreTxt.context.createLinearGradient(0, 0, 0, this.totalScoreTxt.height);
                    grd.addColorStop(0, '#FFFF00');
                    grd.addColorStop(1, '#C17316');
                    this.totalScoreTxt.setFill(grd);
                    this.starScoreTxt = this.scene.add.text(648, 433, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 24,
                        "color": "#FFFFFF",
                        "align": 'center'
                    });
                    this.starScoreTxt.setOrigin(0.5, 0.5);
                    this.add([
                        this._bgComplete,
                        _CollectedPoints,
                        this._cup,
                        this._btnBack,
                        this._btnReplay,
                        this._btnNext,
                        this.totalScoreTxt,
                        this.starScoreTxt
                    ]);
                    this._btnBack.setInteractive({ cursor: 'pointer' });
                    this._btnBack.on('pointerup', () => {
                        onBack(this._btnBack);
                        window.angularComponentRef.backToMenu();
                        // if (this.music) {
                        //     this.music.stop();
                        // }
                    });
                    setupButtonTextureBased(this._btnBack, 'btnBACK1', 'btnBACK2');
                    this._btnReplay.setInteractive({ cursor: 'pointer' });
                    this._btnReplay.once('pointerup', () => {
                        onReplay(this._btnReplay);
                        if (this.music) {
                            this.music.stop();
                        }
                    });
                    setupButtonTextureBased(this._btnReplay, 'btnReplay1', 'btnReplay2');
                    this._btnNext.setInteractive({ cursor: 'pointer' });
                    this._btnNext.on('pointerup', () => {
                        onNext(this._btnNext);
                        window.angularComponentRef.nextActivity();
                        // if (this.music) {
                        //     this.music.stop();
                        // }
                    });
                    setupButtonTextureBased(this._btnNext, 'btnNEXT1', 'btnNEXT2');
                }

                show(score, starScore) {
                    window.angularComponentRef.gameFinish({ score, starScore });
                    this._cup.scale = 1.25;
                    this.scene.tweens.add({
                        targets: this._cup,
                        "scale": 1,
                        duration: 500,
                        ease: Phaser.Math.Easing.Back.Out
                    });
                    this.totalScoreTxt.text = String(window.angularComponentRef.component.userInfo.totalScore);
                    this.starScoreTxt.text = String(starScore);
                    // let music = this.scene.sound.add("viktory");
                    this.music = this.scene.sound.add("Activity completion fantastic");
                    this.music.play();
                }
            }

            screen.CompleteWindow = CompleteWindow;
        })(screen = garage.screen || (garage.screen = {}));
    })(garage || (garage = {}));

    (function (garage) {
        var screen;
        (function (screen) {
            var Preloader = garage.scene.Preloader;

            class GameplayScreen extends Phaser.GameObjects.Container {
                constructor(scene, gameplay) {
                    super(scene);
                    this.bgMusic = null;
                    this.idleDelayedCall = null;
                    this.playIdle = (anim) => {
                        Preloader.playAnim(anim, this.character, () => {
                            this.idleDelayedCall = delayedCall(5000, () => {
                                this.playIdle(anim == 'Sprite Files_Iddle' ? 'Sprite Files_Iddle-reversed' : 'Sprite Files_Iddle');
                            });
                        });
                    };
                    this.soundGooseYes = null;
                    this.soundGooseNo = null;
                    this.wfsnd = null;
                    this.showCompleteWindow = (score, starScore) => {
                        let completeWindow = new screen.CompleteWindow(this.scene, (target) => {
                            playBtnClickAnim(target);
                        }, (target) => {
                            playBtnClickAnim(target);
                            this.destroyGameplay();
                            completeWindow.destroy(true);
                            this.showInstructionPage();
                        }, (target) => {
                            playBtnClickAnim(target);
                        });
                        this.setInputEnabled(false);
                        delayedCall(2000, () => {
                            setPageBackground("bg-blue");
                            this.add(completeWindow);
                            completeWindow.show(score, starScore);
                            this.bgMusic.stop();
                        });
                    };
                    this.showLoseWindow = (score, starScore) => {
                        let tryAgainWindow = new screen.TryAgainWindow(this.scene, (target) => {
                            playBtnClickAnim(target);
                        }, (target) => {
                            playBtnClickAnim(target);
                            this.destroyGameplay();
                            tryAgainWindow.destroy(true);
                            this.showInstructionPage();
                        });
                        this.setInputEnabled(false);
                        delayedCall(1500, () => {
                            setPageBackground("bg-blue");
                            this.add(tryAgainWindow);
                            tryAgainWindow.show(score, starScore);
                            this.bgMusic.stop();
                        });
                    };
                    this.gameplay = gameplay;
                    window["gs"] = this;
                    this._gameStage = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2, game.scale.height / 2, 'Page 1');
                    this._gameStage.setOrigin(0.5, 0.52);
                    //this._gameStage.setInteractive();
                    this.add(this._gameStage);
                    this.character = this.scene.add.sprite(0, 0, null);
                    this.character.setPosition(140, 365);
                    this.add(this.character);
                    this.add(this._branch = new Phaser.GameObjects.Image(this.scene, 590, 35, 'branch'));
                    this.add(new Phaser.GameObjects.Image(this.scene, 700, 35, 'Shape 2365'));
                    this._btnClose = new Phaser.GameObjects.Image(this.scene, 1025 - 105, 100 - 50, 'x Button');
                    this._btnClose.setInteractive({ cursor: 'pointer' });
                    this._btnClose["defScale"] = this._btnClose.scale;
                    setupButtonTextureBased(this._btnClose, 'x Button', 'x Button HOVER EFFECT');
                    this.add(this._btnClose);
                    this._btnClose.on('pointerup', () => {
                        playBtnClickAnim(this._btnClose);
                        this.onCloseClick();
                    });
                }

                showGameplay() {
                    setPageBackground("bg-australia");
                    this.playIdle('Sprite Files_Iddle');
                    this.bgMusic = this.scene.sound.add("Bachground ambience");
                    this.bgMusic.play();
                    this.bgMusic.loop = true;
                    this.gameplayContainer = new Phaser.GameObjects.Container(this.scene);
                    this.addAt(this.gameplayContainer, this.getIndex(this._branch));
                    this.gameplay.reset();
                    this.prepareRound();
                    this.gameplay.setupCallbacks(this.showCompleteWindow, this.showLoseWindow, () => {
                        this.onNewRound(true);
                    });
                }

                showXLabel(index) {
                    this.icons[index].visible = true;
                }

                prepareRound() {
                    this.gameplayContainer.removeAll();
                    this.icons = [];
                    for (let i = 0; i < this.gameplay.failsNumToLose; i++) {
                        let h = new Phaser.GameObjects.Image(this.scene, 63 + i * 63, 40, 'x');
                        this.gameplayContainer.add(h);
                        this.icons.push(h);
                        h.visible = false;
                    }
                    let randomizedBucketsLetter = Phaser.Utils.Array.Shuffle(this.gameplay.roundLetters.slice());
                    let randomizedApplesLetter = Phaser.Utils.Array.Shuffle(this.gameplay.roundLetters.slice());
                    this.apples = [];
                    this.buckets = [];
                    let bucketX = 341;
                    let bucketDX = 172;
                    for (let i = 0; i < randomizedBucketsLetter.length; i++) {
                        let b = new Phaser.GameObjects.Image(this.scene, bucketX + i * bucketDX, 408, 'bucket-back');
                        b.setOrigin(0.5, 0);
                        this.gameplayContainer.add(b);
                    }
                    for (let i = 0; i < randomizedBucketsLetter.length; i++) {
                        let b = new Phaser.GameObjects.Container(this.scene, bucketX + i * bucketDX, 408);
                        b.add(new Phaser.GameObjects.Image(this.scene, 0, 0, 'bucket-front').setOrigin(0.5, 0));
                        b.add(new Phaser.GameObjects.Image(this.scene, 0, 75, 'bucket').setOrigin(0.5, 0).setScale(1, 1.25));
                        b['alreadyFilled'] = false;
                        this.buckets.push(b);
                        let txt;
                        if (this.gameplay.useImages) {
                            txt = new Phaser.GameObjects.Image(this.scene, 0, 115, 'a' + randomizedBucketsLetter[i]);
                            b.add(txt);
                        } else {
                            txt = this.scene.add.text(0, 115, "", {
                                "fontFamily": "QuranErafont",
                                "fontSize": 55,
                                "color": "#000000",
                                "align": 'center'
                            });
                            txt.setOrigin(0.5, 0.5);
                            txt.style.fixedHeight = 75;
                            txt.setText(randomizedBucketsLetter[i]);
                            b.add(txt);
                        }
                        b["-letter-"] = txt;
                        b["-letter-text"] = randomizedBucketsLetter[i];
                        this.gameplayContainer.add(b);
                    }
                    let applesY = [30 + 75, 67 + 75, 75 + 75, 62 + 75];
                    for (let i = 0; i < randomizedApplesLetter.length; i++) {
                        let a = new Phaser.GameObjects.Container(this.scene, bucketX + i * bucketDX, applesY[i]);
                        a.add(a["-image-"] = new Phaser.GameObjects.Image(this.scene, 0, 0, 'apple-' + (i + 1)));
                        a["-image-"].setOrigin(0.5, 0.5);
                        this.apples.push(a);
                        let txt;
                        if (this.gameplay.useImages) {
                            txt = new Phaser.GameObjects.Image(this.scene, 0, 0, 'sh' + randomizedApplesLetter[i]);
                            a.add(txt);
                        } else {
                            txt = this.scene.add.text(0, 0, "", {
                                "fontFamily": "QuranErafont",
                                "fontSize": 70,
                                "color": "#000000",
                                "align": 'center'
                            });
                            txt.setOrigin(0.5, 0.5);
                            txt.style.fixedHeight = 95;
                            txt.setText(randomizedApplesLetter[i]);
                            a.add(txt);
                        }
                        a['startPosition'] = { x: a.x, y: a.y };
                        a["-letter-"] = txt;
                        a["-letter-text"] = randomizedApplesLetter[i];
                        this.gameplayContainer.add(a);
                        a['-draggable-'] = true;
                    }
                    for (let a of this.apples) {
                        a.setSize(a["-image-"].width, a["-image-"].height);
                        a.setInteractive( /*{cursor: 'pointer', pixelPerfect:true}*/);
                        this.scene.input.setDraggable(a);
                        a.on('pointerdown', () => {
                            a['-pointerdown-'] = true;
                        });
                        a.on('pointerup', () => {
                            a['-pointerdown-'] = false;
                            if (!a['-draggable-'])
                                return;
                            this.moveAppleBackToStartPosition(a, null);
                        });
                        a.on('pointerout', () => {
                            if (!a['-draggable-'])
                                return;
                            if (!a['-pointerdown-'])
                                return;
                            this.moveAppleBackToStartPosition(a, null);
                        });
                    }
                    this.createInput();
                    this.setInputEnabled(false);
                    // delayedCall(1200, ()=>{
                    if (this.gameplay.isNewRound()) {
                        if (!this.gameplay.isRoundsComplete()) {
                            // delayedCall(2000, ()=>{
                            this.setInputEnabled(true);
                            // });
                        }
                    } else {
                        this.setInputEnabled(true);
                    }
                    // });
                }

                _update() {
                    if (this.apples) {
                        for (let a of this.apples) {
                            if (a.x < 0 + a["-image-"].width / 2) {
                                a.x = 0 + a["-image-"].width / 2;
                            } else if (a.x > game.scale.width - a["-image-"].width / 2) {
                                a.x = game.scale.width - a["-image-"].width / 2;
                            }
                            if (a.y < 0 + a["-image-"].height / 2) {
                                a.y = a["-image-"].height / 2;
                            } else if (a.y > game.scale.height - a["-image-"].height / 2) {
                                a.y = game.scale.height - a["-image-"].height / 2;
                            }
                        }
                    }
                }

                placeAppleOverBuckets(a) {
                    this.gameplayContainer.remove(a);
                    this.gameplayContainer.addAt(a, this.gameplayContainer.length);
                }

                placeAppleInBuckets(a) {
                    this.gameplayContainer.remove(a);
                    this.gameplayContainer.addAt(a, this.gameplayContainer.getIndex(this.buckets[0]));
                }

                onNewRound(showOut) {
                    this.scene.sound.add("next_round").play();
                    this.setInputEnabled(false);
                    if (showOut) {
                        this.prepareRound();
                    }
                }

                createInput() {
                    this.scene.input.on('drag', (pointer, apple, dragX, dragY) => {
                        if (!apple['-draggable-'])
                            return;
                        apple.x = dragX;
                        apple.y = dragY;
                        for (let b of this.buckets) {
                            if (b['alreadyFilled'])
                                continue;
                            if (Math.abs(apple.x - b.x) < 25 && Math.abs(apple.y - b.y) < 60 && (apple.y > b.y - 7)) {
                                apple['-draggable-'] = false;
                                apple.disableInteractive();
                                this.placeAppleInBuckets(apple);
                                this.scene.tweens.add({
                                    targets: apple,
                                    x: b.x,
                                    y: b.y + 50,
                                    duration: 300,
                                    ease: Phaser.Math.Easing.Back.Out
                                });
                                if (apple["-letter-text"] == b["-letter-text"]) {
                                    this.onCorrectAnswer();
                                    this.scene.sound.add(this.gameplay.getAudioKeyOfChar(apple["-letter-text"])).play();
                                    b['alreadyFilled'] = true;
                                } else {
                                    this.onWrongAnswer();
                                    delayedCall(300 + 250, () => {
                                        this.moveAppleBackToStartPosition(apple, () => {
                                            apple.setInteractive();
                                            apple['-draggable-'] = true;
                                        });
                                    });
                                }
                                break;
                            }
                        }
                    });
                    this._btnClose.setInteractive({ cursor: 'pointer', pixelPerfect: true });
                }

                moveAppleBackToStartPosition(apple, onComplete) {
                    this.scene.tweens.add({
                        targets: apple,
                        x: apple['startPosition'].x,
                        y: apple['startPosition'].y,
                        duration: 350,
                        ease: Phaser.Math.Easing.Back.Out,
                        onComplete: () => {
                            if (onComplete)
                                onComplete();
                        }
                    });
                    if (Phaser.Math.Distance.Between(apple['startPosition'].x, apple['startPosition'].y, apple.x, apple.y) > 20) {
                        delayedCall(100, () => {
                            this.scene.sound.add("drag from its spot").play();
                        });
                        this.scene.tweens.add({
                            targets: apple,
                            angle: (Math.random() - 0.5) * 8,
                            yoyo: true,
                            duration: 300,
                            delay: 250
                        });
                    }
                    this.placeAppleOverBuckets(apple);
                }

                onCorrectAnswer() {
                    let completed = this.gameplay.onCorrectAnswer();
                    this.soundGooseYes = this.scene.sound.add("correct drop");
                    this.soundGooseYes.play();
                    return completed;
                }

                onWrongAnswer() {
                    let lost = this.gameplay.onWrongAnswer();
                    this.soundGooseNo = this.scene.sound.add("wrong drop");
                    this.soundGooseNo.play();
                    this.scene.sound.add("Goose no").play();
                    this.showXLabel(this.gameplay.wrongAnswersCountThisRound - 1);
                    if (this.idleDelayedCall != null) {
                        destroyDelayedCall(this.idleDelayedCall);
                        this.idleDelayedCall = null;
                    }
                    Preloader.playAnim('Sprite Files_OH NO', this.character, () => {
                        this.playIdle('Sprite Files_Iddle');
                    });
                    return lost;
                }

                onCloseClick() {
                    this.showAreYouSurePage();
                    this.scene.sound.add('warning page pop up sfx').play();
                }

                showInstructionPage() {
                    setPageBackground("bg-blue");
                    let playInstructionSound = () => {
                        if (this.wfsnd) {
                            this.wfsnd.stop();
                        }
                        this.wfsnd = this.scene.sound.add("Place the apple into the right basket by matching the letters");
                        this.wfsnd.play();
                    };
                    this.instructionPage = new screen.InstructionPage(this.scene, (target) => {
                        playBtnClickAnim(target);
                        this.instructionPage.destroy(true);
                        this.showGameplay();
                        if (this.wfsnd) {
                            this.wfsnd.stop();
                        }
                    }, (target) => {
                        playBtnClickAnim(target);
                        playInstructionSound();
                    });
                    this.add(this.instructionPage);
                    try {
                        playInstructionSound();
                    }
                    catch (e) {
                        console.error(e);
                    }
                }

                showAreYouSurePage() {
                    pauseAllDelayedCalls();
                    setPageBackground("bg-blue");
                    this.pauseSounds();
                    this.areYouSureWindow = new screen.AreYouSureWindow(this.scene, () => {
                        this.areYouSureWindow.destroy(true);
                        this.destroyGameplay();
                        this.showInstructionPage();
                    }, () => {
                        this.areYouSureWindow.destroy(true);
                        this.unpauseSounds();
                        resumeAllDelayedCalls();
                        setPageBackground("bg-australia");
                    });
                    this.add(this.areYouSureWindow);
                }

                setInputEnabled(enabled) {
                    if (enabled) {
                        for (let a of this.apples)
                            a.setInteractive( /*{cursor: 'pointer', pixelPerfect:true}*/);
                    } else {
                        for (let a of this.apples)
                            a.disableInteractive();
                    }
                }

                pauseSounds() {
                    this.scene.sound.pauseAll();
                }

                unpauseSounds() {
                    this.scene.sound.resumeAll();
                }

                destroyGameplay() {
                    this.setInputEnabled(false);
                    this.remove(this.gameplayContainer);
                    this.scene.sound.stopAll();
                    destroyAllDelayedCalls();
                }
            }

            screen.GameplayScreen = GameplayScreen;
        })(screen = garage.screen || (garage.screen = {}));
    })(garage || (garage = {}));

    (function (garage) {
        var screen;
        (function (screen) {
            class InstructionPage extends Phaser.GameObjects.Container {
                constructor(scene, onPlayClick, onSndClick) {
                    super(scene);
                    this._instructionPage = new Phaser.GameObjects.Image(this.scene, 0 - 105, 0 - 48, 'Instructions page  ALL ACTIVITY  TITLEs');
                    this._instructionPage.setOrigin(0, 0);
                    // this._instructionPage.setInteractive();
                    this._instructionPageTitle = new Phaser.GameObjects.Image(this.scene, 495, 105, 'welcome');
                    this._instructionPageTitle.setScale(0.8);
                    this._btnPlay = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2, 480 - 50, 'btnPLAY1');
                    this._btnPlay.setInteractive({ cursor: 'pointer' });
                    this._btnPlay.once('pointerup', onPlayClick);
                    setupButtonTextureBased(this._btnPlay, 'btnPLAY1', 'btnPLAY2');
                    this.instrTxt = this.scene.add.text(game.scale.width / 2, game.scale.height / 2, "Place the apple into the right basket\nby matching the letters.", {
                        "fontFamily": "Kids Rock DEMO",
                        "fontSize": 30,
                        "color": "#43425D",
                        "align": 'center'
                    });
                    this.instrTxt.setLineSpacing(15);
                    this.instrTxt.setOrigin(0.5, 0.5);
                    this._btnSoundInstruction = new Phaser.GameObjects.Image(this.scene, 800 - 105, 156 - 50, 'Sound');
                    this._btnSoundInstruction.setInteractive({ cursor: 'pointer' });
                    this._btnSoundInstruction.on('pointerup', onSndClick);
                    setupButtonTextureBased(this._btnSoundInstruction, 'Sound', 'Sound HOVER EFFECT');
                    this.add(this._instructionPage);
                    this.add(this._instructionPageTitle);
                    this.add(this.instrTxt);
                    this.add(this._btnPlay);
                    this.add(this._btnSoundInstruction);
                }
            }

            screen.InstructionPage = InstructionPage;
        })(screen = garage.screen || (garage.screen = {}));
    })(garage || (garage = {}));

    (function (garage) {
        var screen;
        (function (screen) {
            class TryAgainWindow extends Phaser.GameObjects.Container {
                constructor(scene, onBack, onReplay) {
                    super(scene);
                    this.music = null;
                    this.setPosition(-106, -48);
                    this._bg = new Phaser.GameObjects.Image(this.scene, 0, 0, 'Try again page');
                    this._bg.setOrigin(0, 0);
                    // this._bg.setInteractive();
                    this._star = new Phaser.GameObjects.Image(this.scene, 400, 415, 'Break Star');
                    this._btnBack = new Phaser.GameObjects.Image(this.scene, 600, 580, 'btnBACK1');
                    this._btnReplay = new Phaser.GameObjects.Image(this.scene, 765, 580, 'btnReplay1');
                    this.totalScoreTxt = this.scene.add.text(830, 355, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 35,
                        "color": "#F49F1C",
                        "align": 'center',
                        'stroke': '#70451A',
                        'strokeThickness': 6
                    });
                    this.totalScoreTxt.setOrigin(0.5, 0.5);
                    let grd = this.totalScoreTxt.context.createLinearGradient(0, 0, 0, this.totalScoreTxt.height);
                    grd.addColorStop(0, '#FFFF00');
                    grd.addColorStop(1, '#C17316');
                    this.totalScoreTxt.setFill(grd);
                    this.starScoreTxt = this.scene.add.text(635, 431, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 24,
                        "color": "#FFFFFF",
                        "align": 'center'
                    });
                    this.starScoreTxt.setOrigin(0.5, 0.5);
                    this.add([
                        this._bg,
                        this._star,
                        this._btnBack,
                        this._btnReplay,
                        this.totalScoreTxt,
                        this.starScoreTxt
                    ]);
                    this._btnBack.setInteractive({ cursor: 'pointer' });
                    this._btnBack.on('pointerup', () => {
                        onBack(this._btnBack);
                        window.angularComponentRef.backToMenu();
                        // if (this.music) {
                        //     this.music.stop();
                        // }
                    });
                    setupButtonTextureBased(this._btnBack, 'btnBACK1', 'btnBACK2');
                    this._btnReplay.setInteractive({ cursor: 'pointer' });
                    this._btnReplay.once('pointerup', () => {
                        onReplay(this._btnReplay);
                        if (this.music) {
                            this.music.stop();
                        }
                    });
                    setupButtonTextureBased(this._btnReplay, 'btnReplay1', 'btnReplay2');
                }

                show(score, starScore) {
                    this._star.scale = 1.25;
                    this.scene.tweens.add({
                        targets: this._star,
                        "scale": 1,
                        duration: 500,
                        ease: Phaser.Math.Easing.Back.Out
                    });
                    this.totalScoreTxt.text = String(window.angularComponentRef.component.userInfo.totalScore);
                    this.starScoreTxt.text = String(starScore);
                    this.music = this.scene.sound.add("Fail - close one");
                    this.music.play();
                }
            }

            screen.TryAgainWindow = TryAgainWindow;
        })(screen = garage.screen || (garage.screen = {}));
    })(garage || (garage = {}));

    game = new garage.App(json);
};

function destroyLetterBasket() {
    if (game) {
        game.destroy();
    }
}

var ctb;
var game;
var iceBlocks = (json) => {
    (function (ctb) {
        class App extends Phaser.Game {
            constructor(json) {
                App.json = json;
                let config = {
                    type: Phaser.AUTO,
                    width: App.CANVAS_WIDTH,
                    height: App.CANVAS_HEIGHT,
                    parent: 'game-container',
                    dom: {
                        createContainer: false
                    },
                    scale: {
                        mode: FitScaleManager.detectBestScaleMode(),
                        autoCenter: Phaser.Scale.CENTER_BOTH
                    },
                    transparent: true,
                    scene: {
                        create: () => {
                            this.scene.add('Boot', ctb.scene.Boot, true);
                        }
                    }
                };
                super(config);
            }
        }
        App.CANVAS_WIDTH = 980;
        App.CANVAS_HEIGHT = 600;
        ctb.App = App;
    })(ctb || (ctb = {}));
    var delayedCalls = [];
    function delayedCall(delay, callback, args, callbackScope) {
        let scene = game.scene.getAt(0);
        if (scene) {
            let dc = scene.time.delayedCall(delay, callback, args, callbackScope);
            delayedCalls.push(dc);
            return dc;
        }
        let t = setTimeout(callback, delay);
        delayedCalls.push(t);
        return t;
    }
    function pauseAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.paused = true;
            }
        }
    }
    function resumeAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.paused = false;
            }
        }
    }
    function destroyAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.remove(false);
            }
            else {
                clearTimeout(dc);
            }
        }
        delayedCalls = [];
    }
    function destroyDelayedCall(dc) {
        if (dc instanceof Phaser.Time.TimerEvent) {
            dc.remove(false);
        }
        else {
            clearTimeout(dc);
        }
        let ind = delayedCalls.indexOf(dc);
        if (ind >= 0)
            delayedCalls.splice(ind, 1);
    }
    function setPageBackground(bg) {
        document.querySelector("html").style.backgroundImage = "url(assets/games/ice-blocks/imgs/" + bg + ".jpg)";
    }
    function setupButton(btn, frame) {
        btn.on('pointerdown', () => { btn.setFrame(frame + '_hover' + '0000'); });
        btn.on('pointerover', () => { btn.setFrame(frame + '_hover' + '0000'); game.scene.getAt(0).sound.add("button hover").play(); });
        btn.on('pointerout', () => { btn.setFrame(frame + '0000'); });
        btn.on('pointerup', () => { btn.setFrame(frame + '0000'); game.scene.getAt(0).sound.add('activity selection - button selection').play(); });
    }
    function setupButtonTextureBased(btn, texture, hoverTexture) {
        btn.on('pointerdown', () => { btn.setTexture(hoverTexture); });
        btn.on('pointerover', () => { btn.setTexture(hoverTexture); game.scene.getAt(0).sound.add("button hover").play(); });
        btn.on('pointerout', () => { btn.setTexture(texture); });
        btn.on('pointerup', () => {
            if (btn.parentContainer)
                btn.setTexture(texture); game.scene.getAt(0).sound.add('activity selection - button selection').play();
        });
    }
    function playBtnClickAnim(target) {
        let sc = target.hasOwnProperty("defScale") ? target["defScale"] : 1;
        target.scaleX = target.scaleY = sc;
        let scene = game.scene.getAt(0);
        scene.tweens.add({
            targets: target,
            "scaleX": 0.9 * sc,
            "scaleY": 0.9 * sc,
            duration: 100,
            yoyo: true
        });
    }
    /**
     * @author Roman Parada
     * This class is created to fix overlapping of bottom part of canvas by navigation bar in iOS.
     * It make a delayed resize of the canvas (like Phaser-3 FIT methods does) and it overrides Phaser-3 input window to Phaser-3 core transform methods
     *
     * How to use:
     * Just call the code line below in Boot scene's init() method of your project:
     * new FitScaleManager(this.game).setup();
     */
    class FitScaleManager {
        constructor(game) {
            this.doResize = () => {
                let scale = this.calculateScale();
                let newCanvasWidth = this.phaserScaleManager.width * scale;
                let newCanvasHeight = this.phaserScaleManager.height * scale;
                this.canvasStyle.width = newCanvasWidth + 'px';
                this.canvasStyle.height = newCanvasHeight + 'px';
                this.canvasStyle.marginLeft = (window.innerWidth - newCanvasWidth) / 2 + 'px';
                this.canvasStyle.marginTop = (window.innerHeight - newCanvasHeight) / 2 + 'px';
            };
            this.game = game;
            this.canvasStyle = this.game.canvas.style;
            this.phaserScaleManager = this.game.scale;
        }
        static detectBestScaleMode() {
            let iOS = /iPad|iPhone|iPod/.test(navigator.platform || "");
            let isAndroid = window.navigator.userAgent.toLowerCase().indexOf("android") > -1;
            return iOS || isAndroid ? Phaser.Scale.FIT : Phaser.Scale.NONE;
        }
        ;
        /**
         * Just call this method once in Boot scene's init() method
         */
        setup() {
            this.phaserScaleManager.addListener(Phaser.Scale.Events.RESIZE, this.onResize, this);
            this.overridePhaserTransformMethods();
            this.onResize();
        }
        calculateScale() {
            if (game.scale.scaleMode == Phaser.Scale.NONE)
                return 1;
            return Math.min(window.innerWidth / this.phaserScaleManager.width, window.innerHeight / this.phaserScaleManager.height);
        }
        overridePhaserTransformMethods() {
            this.game.scale.transformX = (pageX) => {
                return (pageX - parseInt(this.canvasStyle.marginLeft.split("px")[0])) / this.calculateScale();
            };
            this.game.scale.transformY = (pageY) => {
                return (pageY - parseInt(this.canvasStyle.marginTop.split("px")[0])) / this.calculateScale();
            };
        }
        onResize() {
            setTimeout(this.doResize, FitScaleManager.RESIZE_DELAY);
        }
    }
    FitScaleManager.RESIZE_DELAY = 500;

    (function (ctb) {
        var core;
        (function (core) {
            class Gameplay {
                constructor() {
                    this.allLettersNames = null;
                    this.currentRound = 0;
                    this.correctAnswersCount = 0;
                    this.wrongAnswersCount = 0;
                    this.correctAnswersCountThisRound = 0;
                    this.wrongAnswersCountThisRound = 0;
                    this.onNewRound = null;
                    this.nextLetterDelay = 0;
                    this.failsNumToLose = Number(game.cache.json.get('gameplay')["failsNumToLose"]);
                    this.useImages = Boolean(game.cache.json.get('gameplay')["useImages"]);
                }
                setupCallbacks(onComplete, onLose, onNewRound) {
                    this.onComplete = onComplete;
                    this.onLose = onLose;
                    this.onNewRound = onNewRound;
                }
                calculateScore() {
                    return this.totalRoundsNum - this.wrongAnswersCount;
                }
                onLettersPlaced() {
                    if (this.correctAnswersCountThisRound == 1) {
                        this.currentRound++;
                        if (this.currentRound >= this.totalRoundsNum) {
                            let score = this.calculateScore();
                            this.onComplete(score, score);
                            return true;
                        }
                        else {
                            this.nextLetter();
                        }
                    }
                    return false;
                }
                nextLetter() {
                    let fn = () => {
                        let thisRound = this.rounds.shift();
                        this.blockLetters = thisRound["blockLetters"];
                        this.correctWord = thisRound["correctWord"];
                        this.correctAnswersCountThisRound = 0;
                        this.wrongAnswersCountThisRound = 0;
                        if (this.onNewRound)
                            this.onNewRound();
                    };
                    if (this.nextLetterDelay == 0) {
                        fn();
                    }
                    else {
                        delayedCall(this.nextLetterDelay, fn);
                    }
                }
                onCorrectAnswer() {
                    this.correctAnswersCount++;
                    this.correctAnswersCountThisRound++;
                    this.nextLetterDelay = 3500;
                    return this.onLettersPlaced();
                }
                onWrongAnswer() {
                    this.wrongAnswersCount++;
                    this.wrongAnswersCountThisRound++;
                    this.nextLetterDelay = 2000;
                    if (this.wrongAnswersCount >= this.failsNumToLose) {
                        this.onLose(0, 0);
                        return true;
                    }
                    else {
                        this.onLettersPlaced();
                    }
                    return false;
                }
                getCorrectWordCharAt(at) {
                    return this.wordsLetters[this.correctWord][at];
                }
                getCorrectWordLettersNumber() {
                    return this.wordsLetters[this.correctWord].length;
                }
                getCurrentTotalAnswersCount() {
                    return this.correctAnswersCount + this.wrongAnswersCount;
                }
                getCurrentTotalAnswersCountThisRound() {
                    return this.correctAnswersCountThisRound + this.wrongAnswersCountThisRound;
                }
                isNewRound() {
                    return this.getCurrentTotalAnswersCountThisRound() == 0;
                }
                isRoundsComplete() {
                    return this.currentRound >= this.totalRoundsNum;
                }
                getAudioKeyOfChar(letter) {
                    let json = game.cache.json.get('gameplay');
                    let letters = json["letters"];
                    for (let d of letters) {
                        if (letter == d['letterName']) {
                            return d['audioKey'];
                        }
                    }
                    return null;
                }
                reset() {
                    this.nextLetterDelay = 0;
                    this.setupCallbacks(null, null, null);
                    let json = game.cache.json.get('gameplay');
                    this.wordsLetters = json["wordsLetters"];
                    this.rounds = json["rounds"].slice();
                    this.totalRoundsNum = this.rounds.length;
                    this.letters = json["letters"].slice();
                    this.allLettersNames = [];
                    for (let d of this.letters)
                        this.allLettersNames.push(d["letterName"]);
                    this.nextLetter();
                    this.currentRound = 0;
                    this.correctAnswersCount = 0;
                    this.wrongAnswersCount = 0;
                    this.correctAnswersCountThisRound = 0;
                    this.wrongAnswersCountThisRound = 0;
                }
            }
            core.Gameplay = Gameplay;
        })(core = ctb.core || (ctb.core = {}));
    })(ctb || (ctb = {}));

    (function (ctb) {
        var scene;
        (function (scene) {
            class Boot extends Phaser.Scene {
                init() {
                    // new FitScaleManager(this.game).setup();
                    this.game.scale.transformX = (pageX) => {
                        let offsetLeft = 0;
                        let parentElement = game.canvas.parentElement;
                        while (parentElement) {
                            if (parentElement.offsetLeft) {
                                offsetLeft = parentElement.offsetLeft;
                                break;
                            }
                            parentElement = parentElement.parentElement;
                        }
                        return (pageX - offsetLeft) * this.game.scale.displayScale.x;
                    };
                    this.game.scale.transformY = (pageY) => {
                        let offsetTop = 0;
                        let parentElement = game.canvas.parentElement;
                        while (parentElement) {
                            if (parentElement.offsetTop) {
                                offsetTop = parentElement.offsetTop;
                                break;
                            }
                            parentElement = parentElement.parentElement;
                        }
                        return (pageY - offsetTop) * this.game.scale.displayScale.y;
                    };
                }
                create() {
                    game.scene.remove('Boot');
                    game.scene.add('Preloader', ctb.scene.Preloader, true);
                }
            }
            scene.Boot = Boot;
        })(scene = ctb.scene || (ctb.scene = {}));
    })(ctb || (ctb = {}));

    (function (ctb) {
        var scene;
        (function (scene) {
            var Gameplay = ctb.core.Gameplay;
            class MainScene extends Phaser.Scene {
                create() {
                    this.gameplay = new Gameplay();
                    this.gameplayScreen = new ctb.screen.GameplayScreen(this, this.gameplay);
                    this.children.add(this.gameplayScreen);
                    this.gameplayScreen.showInstructionPage();
                }
                update() {
                    this.gameplayScreen._update();
                }
            }
            scene.MainScene = MainScene;
        })(scene = ctb.scene || (ctb.scene = {}));
    })(ctb || (ctb = {}));

    (function (ctb) {
        var scene;
        (function (scene) {
            class Preloader extends Phaser.Scene {
                preload() {
                    if (typeof ctb.App.json == "string") this.load.json('gameplay', ctb.App.json); else this.game.cache.json.add('gameplay', ctb.App.json);this.load.json('gameplay', ctb.App.json);
                }
                create() {
                    let json = game.cache.json.get('gameplay');
                    if (json["useImages"]) {
                        for (let l of json["letters"]) {
                            this.load.image(l["letterName"], "assets/games/ice-blocks/imgs/letters/" + l["letterName"] + ".png");
                        }
                        for (let r of json["rounds"]) {
                            this.load.image(r["correctWord"], "assets/games/ice-blocks/imgs/words/" + r["correctWord"] + ".png");
                        }
                    }
                    for (let l of json["letters"]) {
                        this.load.audio(l["audioKey"], "assets/games/ice-blocks/sound/mp3/letters/" + l["audioKey"]);
                    }
                    for (let r of json["rounds"]) {
                        this.load.audio(r["correctWord"], "assets/games/ice-blocks/sound/mp3/words/" + r["correctWord"] + '.mp3');
                    }
                    let progressTxt = this.add.text(game.scale.width / 2, game.scale.height / 2, "", {
                        "fontFamily": "QuranErafont",
                        "fontSize": 25,
                        "color": "#000000",
                        "align": 'center'
                    });
                    progressTxt.setOrigin(0.5, 0.5);
                    this.load.pack('preloader', 'assets/games/ice-blocks/pack.json');
                    this.load.on('progress', (value) => {
                        progressTxt.text = Math.ceil(value * 100) + "%";
                    }, this);
                    this.load.on('complete', () => {
                        this.nextScene();
                    });
                    this.load.start();
                }
                static playAnim(animKey, sprite, onComplete = null) {
                    let mainScene = game.scene.getScene('ScreenMain');
                    if (!mainScene.anims.exists(animKey)) {
                        let data = Preloader.ANIMS_DATA[animKey];
                        mainScene.anims.create({
                            key: animKey,
                            frames: mainScene.anims.generateFrameNames(data['atlas'], {
                                start: data['start'], end: data['end'], zeroPad: data['padNum'],
                                prefix: data['prefix'], suffix: ''
                            }),
                            frameRate: data['frameRate'],
                            repeat: data['repeat']
                        });
                    }
                    if (sprite.anims.currentAnim) {
                        sprite.off('animationcomplete');
                    }
                    sprite.anims.stop();
                    sprite.play(animKey);
                    sprite.on('animationcomplete', () => {
                        if (onComplete)
                            onComplete();
                    });
                    return sprite;
                }
                nextScene() {
                    game.scene.remove('Preloader');
                    game.scene.add('ScreenMain', ctb.scene.MainScene, true);
                }
            }
            Preloader.ANIMS_DATA = {
                'idle': {
                    'start': 0,
                    'end': 51,
                    'padNum': 4,
                    'prefix': 'idle',
                    'repeat': 0,
                    'frameRate': 24,
                    'atlas': 'atlas-shake'
                },
                'yelling_wrong': {
                    'start': 0,
                    'end': 46,
                    'padNum': 4,
                    'prefix': 'yelling_wrong',
                    'repeat': 0,
                    'frameRate': 24,
                    'atlas': 'atlas-shake'
                }
            };
            scene.Preloader = Preloader;
        })(scene = ctb.scene || (ctb.scene = {}));
    })(ctb || (ctb = {}));

    (function (ctb) {
        var screen;
        (function (screen) {
            class AreYouSureWindow extends Phaser.GameObjects.Container {
                constructor(scene, onYes, onNo) {
                    super(scene);
                    this._areYouSurePage = new Phaser.GameObjects.Image(this.scene, -105, 0 - 48, 'Exit warning');
                    this._areYouSurePage.setOrigin(0, 0);
                    this._areYouSurePage.setInteractive();
                    this._btnSureYes = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2 - 95, 485 - 50, 'btnYES1');
                    this._btnSureYes.setInteractive({ cursor: 'pointer' });
                    this._btnSureYes.once('pointerup', () => {
                        onYes();
                        window.angularComponentRef.backToMenu();
                    });
                    var modalTextStyle = {
                        backgroundColor: 'transparent',
                        stroke: '#ffffff',
                        strokeThickness: 2,
                        lineSpacing: 15,
                        fontFamily: 'Kids Rock DEMO',
                        fontSize: 27,
                        color: '#43425d',
                        wordWrap: true,
                        align: 'center'
                    };
                    var modalText = this.scene.add.text(game.scale.width / 2 + 12, game.scale.height / 2, "Your progress in this activity will not be saved. \n Are you sure you want to exit? ", modalTextStyle);
                    modalText.setOrigin(0.5, 0.5);


                    setupButtonTextureBased(this._btnSureYes, 'btnYES1', 'btnYES2');
                    this._btnSureNo = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2 + 95, 485 - 50, 'btnNO1');
                    this._btnSureNo.setInteractive({ cursor: 'pointer' });
                    this._btnSureNo.once('pointerup', onNo);
                    setupButtonTextureBased(this._btnSureNo, 'btnNO1', 'btnNO2');
                    this.add(this._areYouSurePage);
                    this.add(this._btnSureYes);
                    this.add(this._btnSureNo);
                    this.add(modalText);
                }
            }
            screen.AreYouSureWindow = AreYouSureWindow;
        })(screen = ctb.screen || (ctb.screen = {}));
    })(ctb || (ctb = {}));

    (function (ctb) {
        var screen;
        (function (screen) {
            class CompleteWindow extends Phaser.GameObjects.Container {
                constructor(scene, onBack, onReplay, onNext) {
                    super(scene);
                    this.music = null;
                    this.setPosition(-104.5, -48);
                    this._bgComplete = new Phaser.GameObjects.Image(this.scene, 0, 0, 'Completion page LATEST UPDATED');
                    this._bgComplete.setOrigin(0, 0);
                    //this._bgComplete.setInteractive();
                    this._cup = new Phaser.GameObjects.Image(this.scene, 400, 410, 'Trophy');
                    this._btnBack = new Phaser.GameObjects.Image(this.scene, 570, 570, 'btnBACK1');
                    this._btnReplay = new Phaser.GameObjects.Image(this.scene, 720, 570, 'btnReplay1');
                    this._btnNext = new Phaser.GameObjects.Image(this.scene, 870, 570, 'btnNEXT1');
                    let _CollectedPoints = new Phaser.GameObjects.Image(this.scene, 620, 440, 'Collected Points');
                    this.totalScoreTxt = this.scene.add.text(845, 352, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 35,
                        "color": "#F49F1C",
                        "align": 'center',
                        'stroke': '#70451A',
                        'strokeThickness': 6
                    });
                    this.totalScoreTxt.setOrigin(0.5, 0.5);
                    let grd = this.totalScoreTxt.context.createLinearGradient(0, 0, 0, this.totalScoreTxt.height);
                    grd.addColorStop(0, '#FFFF00');
                    grd.addColorStop(1, '#C17316');
                    this.totalScoreTxt.setFill(grd);
                    this.starScoreTxt = this.scene.add.text(648, 433, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 24,
                        "color": "#FFFFFF",
                        "align": 'center'
                    });
                    this.starScoreTxt.setOrigin(0.5, 0.5);
                    this.add([
                        this._bgComplete,
                        _CollectedPoints,
                        this._cup,
                        this._btnBack,
                        this._btnReplay,
                        this._btnNext,
                        this.totalScoreTxt,
                        this.starScoreTxt
                    ]);
                    this._btnBack.setInteractive({ cursor: 'pointer' });
                    this._btnBack.on('pointerup', () => {
                        onBack(this._btnBack);
                        window.angularComponentRef.backToMenu();
                        // if (this.music) {
                        //     this.music.stop();
                        // }
                    });
                    setupButtonTextureBased(this._btnBack, 'btnBACK1', 'btnBACK2');
                    this._btnReplay.setInteractive({ cursor: 'pointer' });
                    this._btnReplay.once('pointerup', () => {
                        onReplay(this._btnReplay);
                        if (this.music) {
                            this.music.stop();
                        }
                    });
                    setupButtonTextureBased(this._btnReplay, 'btnReplay1', 'btnReplay2');
                    this._btnNext.setInteractive({ cursor: 'pointer' });
                    this._btnNext.on('pointerup', () => {
                        onNext(this._btnNext);
                        window.angularComponentRef.nextActivity();
                        // if (this.music) {
                        //     this.music.stop();
                        // }
                    });
                    setupButtonTextureBased(this._btnNext, 'btnNEXT1', 'btnNEXT2');
                }
                show(score, starScore) {
                    window.angularComponentRef.gameFinish({ score, starScore });
                    this._cup.scale = 1.25;
                    this.scene.tweens.add({
                        targets: this._cup,
                        "scale": 1,
                        duration: 500,
                        ease: Phaser.Math.Easing.Back.Out
                    });
                    this.totalScoreTxt.text = String(window.angularComponentRef.component.userInfo.totalScore);
                    this.starScoreTxt.text = String(starScore);
                    // let music = this.scene.sound.add("viktory");
                    this.music = this.scene.sound.add("Activity completion fantastic");
                    this.music.play();
                }
            }
            screen.CompleteWindow = CompleteWindow;
        })(screen = ctb.screen || (ctb.screen = {}));
    })(ctb || (ctb = {}));

    (function (ctb) {
        var screen;
        (function (screen) {
            var Preloader = ctb.scene.Preloader;
            class GameplayScreen extends Phaser.GameObjects.Container {
                constructor(scene, gameplay) {
                    super(scene);
                    this.bgMusic = null;
                    this.correctAudio = null;
                    this.correctAudioWord = null;
                    this.idleDelayedCall = null;
                    this.playIdle = () => {
                        this.character.setOrigin(0.5, 0.5);
                        Preloader.playAnim('idle', this.character, () => {
                            this.idleDelayedCall = delayedCall(5000, () => {
                                this.playIdle();
                            });
                        });
                    };
                    this.soundWrongDrop = null;
                    this.wfsnd = null;
                    this.showCompleteWindow = (score, starScore) => {
                        let completeWindow = new screen.CompleteWindow(this.scene, (target) => {
                            playBtnClickAnim(target);
                        }, (target) => {
                            playBtnClickAnim(target);
                            this.destroyGameplay();
                            completeWindow.destroy(true);
                            this.showInstructionPage();
                        }, (target) => {
                            playBtnClickAnim(target);
                        });
                        this.setInputEnabled(false);
                        delayedCall(2000, () => {
                            setPageBackground("bg-blue");
                            this.add(completeWindow);
                            completeWindow.show(score, starScore);
                            this.bgMusic.stop();
                        });
                    };
                    this.showLoseWindow = (score, starScore) => {
                        let tryAgainWindow = new screen.TryAgainWindow(this.scene, (target) => {
                            playBtnClickAnim(target);
                        }, (target) => {
                            playBtnClickAnim(target);
                            this.destroyGameplay();
                            tryAgainWindow.destroy(true);
                            this.showInstructionPage();
                        });
                        this.setInputEnabled(false);
                        delayedCall(1500, () => {
                            setPageBackground("bg-blue");
                            this.add(tryAgainWindow);
                            tryAgainWindow.show(score, starScore);
                            this.bgMusic.stop();
                        });
                    };
                    this.gameplay = gameplay;
                    window["gs"] = this;
                    this._gameStage = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2, game.scale.height / 2, 'BG');
                    this._gameStage.setOrigin(0.5, 0.5);
                    this._gameStage.setScale(1.02);
                    //this._gameStage.setInteractive();
                    this.add(this._gameStage);
                    this._btnClose = new Phaser.GameObjects.Image(this.scene, 1025 - 105, 100 - 50, 'x Button');
                    this._btnClose.setInteractive({ cursor: 'pointer' });
                    this._btnClose["defScale"] = this._btnClose.scale;
                    setupButtonTextureBased(this._btnClose, 'x Button', 'x Button HOVER EFFECT');
                    this.add(this._btnClose);
                    this._btnClose.on('pointerup', () => {
                        playBtnClickAnim(this._btnClose);
                        this.onCloseClick();
                    });
                    this._btnSound = new Phaser.GameObjects.Image(this.scene, 160 - 105, 100 - 50, 'Sound');
                    this._btnSound.setInteractive({ cursor: 'pointer' });
                    this._btnSound["defScale"] = this._btnSound.scale;
                    setupButtonTextureBased(this._btnSound, 'Sound', 'Sound HOVER EFFECT');
                    this.add(this._btnSound);
                    this._btnSound.on('pointerup', () => {
                        playBtnClickAnim(this._btnSound);
                        this.onSoundClick();
                    });
                }
                playCorrectAudio() {
                    if (this.correctAudio) {
                        this.correctAudio.stop();
                    }
                    this.correctAudio = this.scene.sound.add(this.gameplay.correctWord);
                    this.correctAudio.play();
                    if (this.areYouSureWindow && this.areYouSureWindow.parentContainer == this) {
                        this.correctAudio.pause();
                    }
                    if (this.correctAudioWord)
                        this.correctAudioWord.stop();
                }
                onSoundClick() {
                    this.playCorrectAudio();
                }
                showGameplay() {
                    setPageBackground("bg-australia");
                    this.bgMusic = this.scene.sound.add("Winter bg sound");
                    this.bgMusic.play();
                    this.bgMusic.loop = true;
                    this.gameplayContainer = new Phaser.GameObjects.Container(this.scene);
                    this.add(this.gameplayContainer);
                    this.gameplay.reset();
                    this.prepareRound();
                    this.gameplay.setupCallbacks(this.showCompleteWindow, this.showLoseWindow, () => {
                        this.onNewRound(true);
                    });
                    this.createTallies();
                }
                prepareRound() {
                    delayedCall(500, () => this.playCorrectAudio());
                    this.gameplayContainer.removeAll();
                    this.character = this.scene.add.sprite(0, 0, null);
                    this.character.setPosition(750, 310);
                    this.playIdle();
                    this.longIce = new Phaser.GameObjects.Image(this.scene, 110, 147, 'Long Ice');
                    this.longIce.setOrigin(0, 0);
                    this.longIce.alpha = 0;
                    this.gameplayContainer.add(this.longIce);
                    let randomizedLetter = Phaser.Utils.Array.Shuffle(this.gameplay.blockLetters.slice());
                    if (this.gameplay.useImages) {
                        let correctWord = new Phaser.GameObjects.Image(this.scene, 750, 180, this.gameplay.correctWord);
                        this.gameplayContainer.add(correctWord);
                    }
                    else {
                        let correctWord = this.scene.add.text(750, 180, "", {
                            "fontFamily": "QuranErafont",
                            "fontSize": 90,
                            "color": "#000000",
                            "align": 'center'
                        });
                        correctWord.setOrigin(0.5, 0.5);
                        correctWord.style.fixedHeight = 140;
                        correctWord.setText(this.gameplay.correctWord);
                        this.gameplayContainer.add(correctWord);
                    }
                    this.selectableLetters = [];
                    this.targetBlocks = [];
                    let correctWordLettersNumber = this.gameplay.wordsLetters ? this.gameplay.getCorrectWordLettersNumber() : this.gameplay.correctWord.length;
                    for (let i = 0; i < correctWordLettersNumber; i++) {
                        let b = {
                            x: 174 + i * 133, y: 215
                        };
                        b['alreadyFilled'] = false;
                        this.targetBlocks.push(b);
                        if (this.gameplay.wordsLetters) {
                            b["-letter-text"] = this.gameplay.getCorrectWordCharAt(correctWordLettersNumber - 1 - i);
                        } else {
                            b["-letter-text"] = this.gameplay.correctWord.charAt(this.gameplay.correctWord.length - 1 - i);
                        }
                        b["-block-"] = null;
                    }
                    for (let i = 0; i < randomizedLetter.length; i++) {
                        let a = new Phaser.GameObjects.Container(this.scene, 100 + i * 150, 525);
                        a.add(a["-image-"] = new Phaser.GameObjects.Image(this.scene, 0, 0, 'IceBlock'));
                        a["-image-"].setOrigin(0.5, 0.5);
                        this.selectableLetters.push(a);
                        let txt;
                        if (this.gameplay.useImages) {
                            txt = new Phaser.GameObjects.Image(this.scene, 0, 0, randomizedLetter[i]);
                            a.add(txt);
                        }
                        else {
                            txt = this.scene.add.text(0, 0, "", {
                                "fontFamily": "QuranErafont",
                                "fontSize": 55,
                                "color": "#000000",
                                "align": 'center'
                            });
                            txt.setOrigin(0.5, 0.5);
                            txt.style.fixedHeight = 75;
                            txt.setText(randomizedLetter[i]);
                            a.add(txt);
                        }
                        a['startPosition'] = { x: a.x, y: a.y };
                        a["-letter-"] = txt;
                        a["-letter-text"] = randomizedLetter[i];
                        this.gameplayContainer.add(a);
                        a['-draggable-'] = true;
                    }
                    for (let a of this.selectableLetters) {
                        a.setSize(a["-image-"].width, a["-image-"].height);
                        a.setInteractive({ cursor: 'pointer' });
                        this.scene.input.setDraggable(a);
                        a.on('pointerdown', () => {
                            a['-pointerdown-'] = true;
                            if (a['-draggable-'])
                                this.scene.sound.add("drag from its spot").play();
                        });
                        a.on('pointerup', () => {
                            a['-pointerdown-'] = false;
                            if (!a['-draggable-'])
                                return;
                            this.moveBridgeBackToStartPosition(a, null, true);
                        });
                        a.on('pointerout', () => {
                            if (!a['-draggable-'])
                                return;
                            if (!a['-pointerdown-'])
                                return;
                            this.moveBridgeBackToStartPosition(a, null, true);
                        });
                    }
                    this.createInput();
                    this.setInputEnabled(false);
                    // delayedCall(1200, ()=>{
                    if (this.gameplay.isNewRound()) {
                        if (!this.gameplay.isRoundsComplete()) {
                            // delayedCall(2000, ()=>{
                            this.setInputEnabled(true);
                            // });
                        }
                    }
                    else {
                        this.setInputEnabled(true);
                    }
                    // });
                    this.gameplayContainer.add(this.character);
                }
                _update() {
                    if (this.selectableLetters) {
                        for (let a of this.selectableLetters) {
                            if (a.x < 0 + a["-image-"].width / 2) {
                                a.x = 0 + a["-image-"].width / 2;
                            }
                            else if (a.x > game.scale.width - a["-image-"].width / 2) {
                                a.x = game.scale.width - a["-image-"].width / 2;
                            }
                            if (a.y < 0 + a["-image-"].height / 2) {
                                a.y = a["-image-"].height / 2;
                            }
                            else if (a.y > game.scale.height - a["-image-"].height / 2) {
                                a.y = game.scale.height - a["-image-"].height / 2;
                            }
                        }
                    }
                }
                placeAppleOverBuckets(a) {
                    if (!a.parentContainer)
                        return;
                    this.gameplayContainer.remove(a);
                    this.gameplayContainer.addAt(a, this.gameplayContainer.length);
                }
                onNewRound(showOut) {
                    this.scene.sound.add("next_round").play();
                    this.setInputEnabled(false);
                    if (showOut) {
                        this.prepareRound();
                    }
                }
                createInput() {
                    this.scene.input.on('drag', (pointer, block, dragX, dragY) => {
                        if (!block['-draggable-'])
                            return;
                        block.x = dragX;
                        block.y = dragY;
                        this.gameplayContainer.bringToTop(block);
                        let targetBlock;
                        for (targetBlock of this.targetBlocks) {
                            if (targetBlock['alreadyFilled'])
                                continue;
                            if (Math.abs(block.x - targetBlock.x) < 25 && Math.abs(block.y - targetBlock.y) < 60 && (block.y > targetBlock.y - 7)) {
                                block['-draggable-'] = false;
                                targetBlock['alreadyFilled'] = true;
                                this.scene.tweens.add({
                                    targets: block,
                                    x: targetBlock.x,
                                    y: targetBlock.y,
                                    duration: 300,
                                    ease: Phaser.Math.Easing.Back.Out
                                });
                                targetBlock["-block-"] = block;
                                this.checkTargetBlockLetters();
                            }
                        }
                    });
                    this._btnClose.setInteractive({ cursor: 'pointer', pixelPerfect: true });
                }
                checkTargetBlockLetters() {
                    let sameLettersNum = 0;
                    for (let targetBlock of this.targetBlocks) {
                        if (!targetBlock['-block-']) {
                            this.scene.sound.add("Placing block above").play();
                            return;
                        }
                        if (targetBlock["-letter-text"] == targetBlock['-block-']["-letter-text"]) {
                            sameLettersNum++;
                        }
                    }
                    this.setInputEnabled(false);
                    if (sameLettersNum == this.targetBlocks.length) {
                        this.scene.sound.add("Placing block above").play();
                        this.scene.tweens.add({
                            targets: this.longIce,
                            alpha: 1,
                            duration: 250,
                            ease: Phaser.Math.Easing.Linear,
                        });
                        for (let targetBlock of this.targetBlocks) {
                            this.scene.tweens.add({
                                targets: targetBlock['-block-']["-image-"],
                                alpha: 0,
                                duration: 250,
                                ease: Phaser.Math.Easing.Linear
                            });
                            if (targetBlock == this.targetBlocks[1])
                                continue;
                            this.scene.tweens.add({
                                targets: targetBlock['-block-'],
                                x: this.targetBlocks[1]['x'],
                                duration: 250,
                                alpha: 0,
                                ease: Phaser.Math.Easing.Sine.Out,
                                delay: 250
                            });
                            delayedCall(500, () => {
                                if (this.gameplay.useImages) {
                                    this.targetBlocks[1]['-block-']["-letter-"].setTexture(this.gameplay.correctWord);
                                }
                                else {
                                    this.targetBlocks[1]['-block-']["-letter-"].setText(this.gameplay.correctWord);
                                }
                            });
                        }
                        this.scene.sound.add("Letters joining sound").play();
                        delayedCall(250, () => this.scene.sound.add("Correct click").play());
                        delayedCall(1000, () => this.scene.sound.add("success for corect word").play());
                        this.onCorrectAnswer();
                    }
                    else {
                        this.scene.sound.add("placed- wrong- snake - blocks go back").play();
                        // this.scene.sound.add("Wrong attempt").play();
                        delayedCall(2400, () => {
                            for (let targetBlock of this.targetBlocks) {
                                this.moveBridgeBackToStartPosition(targetBlock['-block-'], null, false);
                            }
                            // delayedCall(100, ()=>this.scene.sound.add("all three blocks move back after wrong").play());
                        });
                        delayedCall(1500, () => {
                            this.character.setOrigin(0.49, 0.515);
                            Preloader.playAnim('yelling_wrong', this.character, () => {
                                this.playIdle();
                            });
                            // this.scene.sound.add("Snake animation sfx").play();
                        });
                        delayedCall(2500, () => {
                            this.onWrongAnswer();
                            for (let targetBlock of this.targetBlocks) {
                                targetBlock['alreadyFilled'] = false;
                                targetBlock['-block-']['-draggable-'] = true;
                                targetBlock["-block-"] = null;
                            }
                        });
                        delayedCall(2750, () => {
                            this.setInputEnabled(true);
                        });
                    }
                }
                moveBridgeBackToStartPosition(block, onComplete, playSound) {
                    this.scene.tweens.add({
                        targets: block,
                        x: block['startPosition'].x,
                        y: block['startPosition'].y,
                        duration: 350,
                        ease: Phaser.Math.Easing.Sine.Out,
                        onComplete: () => {
                            if (onComplete)
                                onComplete();
                        }
                    });
                    if (Phaser.Math.Distance.Between(block['startPosition'].x, block['startPosition'].y, block.x, block.y) > 20) {
                        delayedCall(100, () => {
                            if (playSound) {
                                this.scene.sound.add("block goes back when released").play();
                            }
                        });
                    }
                    this.placeAppleOverBuckets(block);
                }
                onCorrectAnswer() {
                    let i = this.gameplay.getCurrentTotalAnswersCount();
                    this.tallyEmptyArray[i].visible = false;
                    this.tally[i].visible = true;
                    let completed = this.gameplay.onCorrectAnswer();
                    return completed;
                }
                onWrongAnswer() {
                    let i = this.gameplay.getCurrentTotalAnswersCount();
                    this.tallyEmptyArray[i].visible = true;
                    this.tallyEmptyArray[i].visible = true;
                    this.tally[i].visible = false;
                    let lost = this.gameplay.onWrongAnswer();
                    // this.soundWrongDrop = this.scene.sound.add("wrong drop");
                    // this.soundWrongDrop.play();
                    // this.scene.sound.add("Goose no").play();
                    if (this.idleDelayedCall != null) {
                        destroyDelayedCall(this.idleDelayedCall);
                        this.idleDelayedCall = null;
                    }
                    if (!lost) {
                        delayedCall(650, () => this.playCorrectAudio());
                    }
                    return lost;
                }
                onCloseClick() {
                    this.showAreYouSurePage();
                    this.scene.sound.add('warning page pop up sfx').play();
                }
                createTallies() {
                    if (this.tally) {
                        for (let te of this.tallyEmptyArray) {
                            te.visible = false;
                            this.bringToTop(te);
                        }
                        for (let t of this.tally) {
                            t.visible = false;
                            this.bringToTop(t);
                        }
                        return;
                    }
                    let startX = 26;
                    let startY = 148;
                    let dy = 34;
                    let tallyEmptyArrayPositions = [];
                    for (let i = 0; i < 12; i++) {
                        tallyEmptyArrayPositions.push({ x: startX, y: startY + i * dy });
                    }
                    this.tallyEmptyArray = [];
                    this.tally = [];
                    for (let p of tallyEmptyArrayPositions) {
                        let _BeehiveEmpty = new Phaser.GameObjects.Image(this.scene, p['x'], p['y'], 'tally Empty');
                        this.tallyEmptyArray.push(_BeehiveEmpty);
                        _BeehiveEmpty.visible = false;
                        let _Beehive = new Phaser.GameObjects.Image(this.scene, p['x'], p['y'], 'tally');
                        this.tally.push(_Beehive);
                    }
                    for (let bea of this.tallyEmptyArray) {
                        this.add(bea);
                    }
                    for (let bee of this.tally) {
                        this.add(bee);
                        bee.visible = false;
                    }
                }
                hideAllUnusedTallies() {
                    let i = this.gameplay.getCurrentTotalAnswersCount();
                    for (let k = i + 1; k < this.tallyEmptyArray.length; k++) {
                        this.tallyEmptyArray[k].visible = false;
                        this.tally[k].visible = false;
                    }
                }
                showInstructionPage() {
                    setPageBackground("bg-blue");
                    let playInstructionSound = () => {
                        if (this.wfsnd) {
                            this.wfsnd.stop();
                        }
                        this.wfsnd = this.scene.sound.add("Drag the ice blocks to make the word");
                        this.wfsnd.play();
                    };
                    this.instructionPage = new screen.InstructionPage(this.scene, (target) => {
                        playBtnClickAnim(target);
                        this.instructionPage.destroy(true);
                        this.showGameplay();
                        if (this.wfsnd) {
                            this.wfsnd.stop();
                        }
                    }, (target) => {
                        playBtnClickAnim(target);
                        playInstructionSound();
                    });
                    this.add(this.instructionPage);
                    try {
                        playInstructionSound();
                    }
                    catch (e) {
                        console.error(e);
                    }
                }
                showAreYouSurePage() {
                    pauseAllDelayedCalls();
                    setPageBackground("bg-blue");
                    this.scene.tweens.pauseAll();
                    this.pauseSounds();
                    this.areYouSureWindow = new screen.AreYouSureWindow(this.scene, () => {
                        this.scene.tweens.resumeAll();
                        this.areYouSureWindow.destroy(true);
                        this.destroyGameplay();
                        this.showInstructionPage();
                    }, () => {
                        this.scene.tweens.resumeAll();
                        this.areYouSureWindow.destroy(true);
                        this.unpauseSounds();
                        resumeAllDelayedCalls();
                        setPageBackground("bg-australia");
                    });
                    this.add(this.areYouSureWindow);
                }
                setInputEnabled(enabled) {
                    if (enabled) {
                        for (let a of this.selectableLetters)
                            a.setInteractive({ cursor: 'pointer' });
                    }
                    else {
                        for (let a of this.selectableLetters)
                            a.disableInteractive();
                    }
                }
                pauseSounds() {
                    this.scene.sound.pauseAll();
                }
                unpauseSounds() {
                    this.scene.sound.resumeAll();
                }
                destroyGameplay() {
                    this.setInputEnabled(false);
                    this.remove(this.gameplayContainer);
                    this.scene.sound.stopAll();
                    destroyAllDelayedCalls();
                }
            }
            screen.GameplayScreen = GameplayScreen;
        })(screen = ctb.screen || (ctb.screen = {}));
    })(ctb || (ctb = {}));

    (function (ctb) {
        var screen;
        (function (screen) {
            class InstructionPage extends Phaser.GameObjects.Container {
                constructor(scene, onPlayClick, onSndClick) {
                    super(scene);
                    this._instructionPage = new Phaser.GameObjects.Image(this.scene, 0 - 105, 0 - 48, 'Instructions page  ALL ACTIVITY  TITLEs');
                    this._instructionPage.setOrigin(0, 0);
                    //this._instructionPage.setInteractive();
                    this._instructionPageTitle = new Phaser.GameObjects.Image(this.scene, 495, 105, 'Ice Blocks');
                    this._instructionPageTitle.setScale(0.75);
                    this._btnPlay = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2, 480 - 50, 'btnPLAY1');
                    this._btnPlay.setInteractive({ cursor: 'pointer' });
                    this._btnPlay.once('pointerup', onPlayClick);
                    setupButtonTextureBased(this._btnPlay, 'btnPLAY1', 'btnPLAY2');
                    this.instrTxt = this.scene.add.text(game.scale.width / 2, game.scale.height / 2, "Drag the ice blocks to make the word.", {
                        "fontFamily": "Kids Rock DEMO",
                        "fontSize": 30,
                        "color": "#43425D",
                        "align": 'center'
                    });
                    this.instrTxt.setOrigin(0.5, 0.5);
                    this.instrTxt.setWordWrapWidth(600);
                    this.instrTxt.setLineSpacing(5);
                    this._btnSoundInstruction = new Phaser.GameObjects.Image(this.scene, 800 - 105, 156 - 50, 'Sound');
                    this._btnSoundInstruction.setInteractive({ cursor: 'pointer' });
                    this._btnSoundInstruction.on('pointerup', onSndClick);
                    this._btnSoundInstruction["defScale"] = this._btnSoundInstruction.scale;
                    setupButtonTextureBased(this._btnSoundInstruction, 'Sound', 'Sound HOVER EFFECT');
                    this.add(this._instructionPage);
                    this.add(this._instructionPageTitle);
                    this.add(this.instrTxt);
                    this.add(this._btnPlay);
                    this.add(this._btnSoundInstruction);
                }
            }
            screen.InstructionPage = InstructionPage;
        })(screen = ctb.screen || (ctb.screen = {}));
    })(ctb || (ctb = {}));

    (function (ctb) {
        var screen;
        (function (screen) {
            class TryAgainWindow extends Phaser.GameObjects.Container {
                constructor(scene, onBack, onReplay) {
                    super(scene);
                    this.music = null;
                    this.setPosition(-106, -48);
                    this._bg = new Phaser.GameObjects.Image(this.scene, 0, 0, 'Try again page');
                    this._bg.setOrigin(0, 0);
                    // this._bg.setInteractive();
                    this._star = new Phaser.GameObjects.Image(this.scene, 400, 415, 'Break Star');
                    this._btnBack = new Phaser.GameObjects.Image(this.scene, 600, 580, 'btnBACK1');
                    this._btnReplay = new Phaser.GameObjects.Image(this.scene, 765, 580, 'btnReplay1');
                    this.totalScoreTxt = this.scene.add.text(830, 355, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 35,
                        "color": "#F49F1C",
                        "align": 'center',
                        'stroke': '#70451A',
                        'strokeThickness': 6
                    });
                    this.totalScoreTxt.setOrigin(0.5, 0.5);
                    let grd = this.totalScoreTxt.context.createLinearGradient(0, 0, 0, this.totalScoreTxt.height);
                    grd.addColorStop(0, '#FFFF00');
                    grd.addColorStop(1, '#C17316');
                    this.totalScoreTxt.setFill(grd);
                    this.starScoreTxt = this.scene.add.text(635, 431, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 24,
                        "color": "#FFFFFF",
                        "align": 'center'
                    });
                    this.starScoreTxt.setOrigin(0.5, 0.5);
                    this.add([
                        this._bg,
                        this._star,
                        this._btnBack,
                        this._btnReplay,
                        this.totalScoreTxt,
                        this.starScoreTxt
                    ]);
                    this._btnBack.setInteractive({ cursor: 'pointer' });
                    this._btnBack.on('pointerup', () => {
                        onBack(this._btnBack);
                        // if (this.music) {
                        //     this.music.stop();
                        // }
                    });
                    setupButtonTextureBased(this._btnBack, 'btnBACK1', 'btnBACK2');
                    this._btnReplay.setInteractive({ cursor: 'pointer' });
                    this._btnReplay.once('pointerup', () => {
                        onReplay(this._btnReplay);
                        if (this.music) {
                            this.music.stop();
                        }
                    });
                    setupButtonTextureBased(this._btnReplay, 'btnReplay1', 'btnReplay2');
                }
                show(score, starScore) {
                    this._star.scale = 1.25;
                    this.scene.tweens.add({
                        targets: this._star,
                        "scale": 1,
                        duration: 500,
                        ease: Phaser.Math.Easing.Back.Out
                    });
                    this.totalScoreTxt.text = String(window.angularComponentRef.component.userInfo.totalScore);
                    this.starScoreTxt.text = String(starScore);
                    this.music = this.scene.sound.add("Fail - close one");
                    this.music.play();
                }
            }
            screen.TryAgainWindow = TryAgainWindow;
        })(screen = ctb.screen || (ctb.screen = {}));
    })(ctb || (ctb = {}));

    game = new ctb.App(json);
};

function destroyIceBlocks() {
    if (game) {
        game.destroy();
    }
}

var ctb;
var game;
var doughPress = (json) => {
    (function (ctb) {
        class App extends Phaser.Game {
            constructor(json) {
                App.json = json;
                let config = {
                    type: Phaser.AUTO,
                    width: App.CANVAS_WIDTH,
                    height: App.CANVAS_HEIGHT,
                    parent: 'game-container',
                    dom: {
                        createContainer: false
                    },
                    scale: {
                        mode: FitScaleManager.detectBestScaleMode(),
                        autoCenter: Phaser.Scale.CENTER_BOTH
                    },
                    transparent: true,
                    scene: {
                        create: () => {
                            this.scene.add('Boot', ctb.scene.Boot, true);
                        }
                    }
                };
                super(config);
            }
        }
        App.CANVAS_WIDTH = 980;
        App.CANVAS_HEIGHT = 600;
        ctb.App = App;
    })(ctb || (ctb = {}));
    var delayedCalls = [];
    function delayedCall(delay, callback, args, callbackScope) {
        let scene = game.scene.getAt(0);
        if (scene) {
            let dc = scene.time.delayedCall(delay, callback, args, callbackScope);
            delayedCalls.push(dc);
            return dc;
        }
        let t = setTimeout(callback, delay);
        delayedCalls.push(t);
        return t;
    }
    function pauseAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.paused = true;
            }
        }
    }
    function resumeAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.paused = false;
            }
        }
    }
    function destroyAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.remove(false);
            }
            else {
                clearTimeout(dc);
            }
        }
        delayedCalls = [];
    }
    function destroyDelayedCall(dc) {
        if (dc instanceof Phaser.Time.TimerEvent) {
            dc.remove(false);
        }
        else {
            clearTimeout(dc);
        }
        let ind = delayedCalls.indexOf(dc);
        if (ind >= 0)
            delayedCalls.splice(ind, 1);
    }
    function setPageBackground(bg) {
        document.querySelector("html").style.backgroundImage = "url(assets/games/dough-press/imgs/" + bg + ".jpg)";
    }
    function setupButton(btn, frame) {
        btn.on('pointerdown', () => { btn.setFrame(frame + '_hover' + '0000'); });
        btn.on('pointerover', () => { btn.setFrame(frame + '_hover' + '0000'); game.scene.getAt(0).sound.add("button hover").play(); });
        btn.on('pointerout', () => { btn.setFrame(frame + '0000'); });
        btn.on('pointerup', () => { btn.setFrame(frame + '0000'); game.scene.getAt(0).sound.add('activity selection - button selection').play(); });
    }
    function setupButtonTextureBased(btn, texture, hoverTexture) {
        btn.on('pointerdown', () => { btn.setTexture(hoverTexture); });
        btn.on('pointerover', () => { btn.setTexture(hoverTexture); game.scene.getAt(0).sound.add("button hover").play(); });
        btn.on('pointerout', () => { btn.setTexture(texture); });
        btn.on('pointerup', () => {
            if (btn.parentContainer)
                btn.setTexture(texture); game.scene.getAt(0).sound.add('activity selection - button selection').play();
        });
    }
    function playBtnClickAnim(target) {
        let sc = target.hasOwnProperty("defScale") ? target["defScale"] : 1;
        target.scaleX = target.scaleY = sc;
        let scene = game.scene.getAt(0);
        scene.tweens.add({
            targets: target,
            "scaleX": 0.9 * sc,
            "scaleY": 0.9 * sc,
            duration: 100,
            yoyo: true
        });
    }
    /**
     * @author Roman Parada
     * This class is created to fix overlapping of bottom part of canvas by navigation bar in iOS.
     * It make a delayed resize of the canvas (like Phaser-3 FIT methods does) and it overrides Phaser-3 input window to Phaser-3 core transform methods
     *
     * How to use:
     * Just call the code line below in Boot scene's init() method of your project:
     * new FitScaleManager(this.game).setup();
     */
    class FitScaleManager {
        constructor(game) {
            this.doResize = () => {
                let scale = this.calculateScale();
                let newCanvasWidth = this.phaserScaleManager.width * scale;
                let newCanvasHeight = this.phaserScaleManager.height * scale;
                this.canvasStyle.width = newCanvasWidth + 'px';
                this.canvasStyle.height = newCanvasHeight + 'px';
                this.canvasStyle.marginLeft = (window.innerWidth - newCanvasWidth) / 2 + 'px';
                this.canvasStyle.marginTop = (window.innerHeight - newCanvasHeight) / 2 + 'px';
            };
            this.game = game;
            this.canvasStyle = this.game.canvas.style;
            this.phaserScaleManager = this.game.scale;
        }
        static detectBestScaleMode() {
            let iOS = /iPad|iPhone|iPod/.test(navigator.platform || "");
            let isAndroid = window.navigator.userAgent.toLowerCase().indexOf("android") > -1;
            return iOS || isAndroid ? Phaser.Scale.FIT : Phaser.Scale.NONE;
        }
        ;
        /**
         * Just call this method once in Boot scene's init() method
         */
        setup() {
            this.phaserScaleManager.addListener(Phaser.Scale.Events.RESIZE, this.onResize, this);
            this.overridePhaserTransformMethods();
            this.onResize();
        }
        calculateScale() {
            if (game.scale.scaleMode == Phaser.Scale.NONE)
                return 1;
            return Math.min(window.innerWidth / this.phaserScaleManager.width, window.innerHeight / this.phaserScaleManager.height);
        }
        overridePhaserTransformMethods() {
            this.game.scale.transformX = (pageX) => {
                return (pageX - parseInt(this.canvasStyle.marginLeft.split("px")[0])) / this.calculateScale();
            };
            this.game.scale.transformY = (pageY) => {
                return (pageY - parseInt(this.canvasStyle.marginTop.split("px")[0])) / this.calculateScale();
            };
        }
        onResize() {
            setTimeout(this.doResize, FitScaleManager.RESIZE_DELAY);
        }
    }
    FitScaleManager.RESIZE_DELAY = 500;

    (function (ctb) {
        var core;
        (function (core) {
            class Gameplay {
                constructor() {
                    this.allLettersNames = null;
                    this.currentRound = 0;
                    this.correctAnswersCount = 0;
                    this.wrongAnswersCount = 0;
                    this.correctAnswersCountThisRound = 0;
                    this.wrongAnswersCountThisRound = 0;
                    this.onNewRound = null;
                    this.nextLetterDelay = 0;
                    this.failsNumToLose = Number(game.cache.json.get('gameplay')["failsNumToLose"]);
                    this.useImages = Boolean(game.cache.json.get('gameplay')["useImages"]);
                }
                setupCallbacks(onComplete, onLose, onNewRound) {
                    this.onComplete = onComplete;
                    this.onLose = onLose;
                    this.onNewRound = onNewRound;
                }
                calculateScore() {
                    return this.totalRoundsNum - this.wrongAnswersCount;
                }
                onLettersPlaced() {
                    if (this.correctAnswersCountThisRound == 1) {
                        this.currentRound++;
                        if (this.correctAnswersCount >= this.totalRoundsNum) {
                            let score = this.calculateScore();
                            this.onComplete(score, score);
                            return true;
                        }
                        else {
                            this.nextLetter();
                        }
                    }
                    return false;
                }
                nextLetter() {
                    let fn = () => {
                        let thisRound = this.rounds.shift();
                        this.blockLetters = thisRound["blockLetters"];
                        this.correctWord = thisRound["correctWord"];
                        this.correctAnswersCountThisRound = 0;
                        this.wrongAnswersCountThisRound = 0;
                        if (this.onNewRound)
                            this.onNewRound();
                    };
                    if (this.nextLetterDelay == 0) {
                        fn();
                    }
                    else {
                        delayedCall(this.nextLetterDelay, fn);
                    }
                }
                onCorrectAnswer() {
                    this.correctAnswersCount++;
                    this.correctAnswersCountThisRound++;
                    this.nextLetterDelay = 3100;
                    return this.onLettersPlaced();
                }
                onWrongAnswer() {
                    this.wrongAnswersCount++;
                    this.wrongAnswersCountThisRound++;
                    this.nextLetterDelay = 2000;
                    if (this.wrongAnswersCount >= this.failsNumToLose) {
                        this.onLose(0, 0);
                        return true;
                    }
                    else {
                        this.onLettersPlaced();
                    }
                    return false;
                }
                getCorrectWordCharAt(at) {
                    return this.wordsLetters[this.correctWord][at];
                }
                getCorrectWordLettersNumber() {
                    return this.wordsLetters[this.correctWord].length;
                }
                getCurrentTotalAnswersCount() {
                    return this.correctAnswersCount + this.wrongAnswersCount;
                }
                getCurrentTotalAnswersCountThisRound() {
                    return this.correctAnswersCountThisRound + this.wrongAnswersCountThisRound;
                }
                isNewRound() {
                    return this.getCurrentTotalAnswersCountThisRound() == 0;
                }
                isRoundsComplete() {
                    return this.currentRound >= this.totalRoundsNum;
                }
                getAudioKeyOfChar(letter) {
                    let json = game.cache.json.get('gameplay');
                    let letters = json["letters"];
                    for (let d of letters) {
                        if (letter == d['letterName']) {
                            return d['audioKey'];
                        }
                    }
                    return null;
                }
                reset() {
                    this.nextLetterDelay = 0;
                    this.setupCallbacks(null, null, null);
                    let json = game.cache.json.get('gameplay');
                    this.wordsLetters = json["wordsLetters"];
                    this.rounds = json["rounds"].slice();
                    this.totalRoundsNum = this.rounds.length;
                    this.letters = json["letters"].slice();
                    this.allLettersNames = [];
                    for (let d of this.letters)
                        this.allLettersNames.push(d["letterName"]);
                    this.nextLetter();
                    this.currentRound = 0;
                    this.correctAnswersCount = 0;
                    this.wrongAnswersCount = 0;
                    this.correctAnswersCountThisRound = 0;
                    this.wrongAnswersCountThisRound = 0;
                }
            }
            core.Gameplay = Gameplay;
        })(core = ctb.core || (ctb.core = {}));
    })(ctb || (ctb = {}));

    (function (ctb) {
        var scene;
        (function (scene) {
            class Boot extends Phaser.Scene {
                init() {
                    // new FitScaleManager(this.game).setup();
                    this.game.scale.transformX = (pageX) => {
                        let offsetLeft = 0;
                        let parentElement = game.canvas.parentElement;
                        while (parentElement) {
                            if (parentElement.offsetLeft) {
                                offsetLeft = parentElement.offsetLeft;
                                break;
                            }
                            parentElement = parentElement.parentElement;
                        }
                        return (pageX - offsetLeft) * this.game.scale.displayScale.x;
                    };
                    this.game.scale.transformY = (pageY) => {
                        let offsetTop = 0;
                        let parentElement = game.canvas.parentElement;
                        while (parentElement) {
                            if (parentElement.offsetTop) {
                                offsetTop = parentElement.offsetTop;
                                break;
                            }
                            parentElement = parentElement.parentElement;
                        }
                        return (pageY - offsetTop) * this.game.scale.displayScale.y;
                    };
                }
                create() {
                    game.scene.remove('Boot');
                    game.scene.add('Preloader', ctb.scene.Preloader, true);
                }
            }
            scene.Boot = Boot;
        })(scene = ctb.scene || (ctb.scene = {}));
    })(ctb || (ctb = {}));

    (function (ctb) {
        var scene;
        (function (scene) {
            var Gameplay = ctb.core.Gameplay;
            class MainScene extends Phaser.Scene {
                create() {
                    this.gameplay = new Gameplay();
                    this.gameplayScreen = new ctb.screen.GameplayScreen(this, this.gameplay);
                    this.children.add(this.gameplayScreen);
                    this.gameplayScreen.showInstructionPage();
                }
                update() {
                    this.gameplayScreen._update();
                }
            }
            scene.MainScene = MainScene;
        })(scene = ctb.scene || (ctb.scene = {}));
    })(ctb || (ctb = {}));

    (function (ctb) {
        var scene;
        (function (scene) {
            class Preloader extends Phaser.Scene {
                preload() {
                    if (typeof ctb.App.json == "string") this.load.json('gameplay', ctb.App.json); else this.game.cache.json.add('gameplay', ctb.App.json);
                }
                create() {
                    let json = game.cache.json.get('gameplay');
                    if (json["useImages"]) {
                        for (let l of json["letters"]) {
                            this.load.image(l["letterName"], "assets/games/dough-press/imgs/letters/" + l["letterName"] + ".png");
                        }
                        for (let r of json["rounds"]) {
                            this.load.image(r["correctWord"], "assets/games/dough-press/imgs/words/" + r["correctWord"] + ".png");
                        }
                    }

                    for (let r of json["rounds"]) {
                        this.load.audio(r["correctWord"], "assets/games/dough-press/sound/mp3/words/" + r["correctWord"] + '.mp3');
                    }
                    let progressTxt = this.add.text(game.scale.width / 2, game.scale.height / 2 + 50, "", {
                        "fontFamily": "QuranErafont",
                        "fontSize": 25,
                        "color": "#000000",
                        "align": 'center'
                    });
                    progressTxt.setOrigin(0.5, 0.5);
                    this.load.pack('preloader', 'assets/games/dough-press/pack.json');
                    this.load.on('progress', (value) => {
                        progressTxt.text = Math.ceil(value * 100) + "%";
                    }, this);
                    this.load.on('complete', () => {
                        this.nextScene();
                    });
                    this.load.start();
                }
                static playAnim(animKey, sprite, onComplete = null) {
                    let mainScene = game.scene.getScene('ScreenMain');
                    if (!mainScene.anims.exists(animKey)) {
                        let data = Preloader.ANIMS_DATA[animKey];
                        mainScene.anims.create({
                            key: animKey,
                            frames: mainScene.anims.generateFrameNames(data['atlas'], {
                                start: data['start'], end: data['end'], zeroPad: data['padNum'],
                                prefix: data['prefix'], suffix: ''
                            }),
                            frameRate: data['frameRate'],
                            repeat: data['repeat']
                        });
                    }
                    if (sprite.anims.currentAnim) {
                        sprite.off('animationcomplete');
                    }
                    sprite.anims.stop();
                    sprite.play(animKey);
                    sprite.on('animationcomplete', () => {
                        if (onComplete)
                            onComplete();
                    });
                    return sprite;
                }
                nextScene() {
                    game.scene.remove('Preloader');
                    game.scene.add('ScreenMain', ctb.scene.MainScene, true);
                }
            }
            Preloader.ANIMS_DATA = {};
            scene.Preloader = Preloader;
        })(scene = ctb.scene || (ctb.scene = {}));
    })(ctb || (ctb = {}));

    (function (ctb) {
        var screen;
        (function (screen) {
            class AreYouSureWindow extends Phaser.GameObjects.Container {
                constructor(scene, onYes, onNo) {
                    super(scene);
                    this._areYouSurePage = new Phaser.GameObjects.Image(this.scene, -105, 0 - 48, 'Exit warning');
                    this._areYouSurePage.setOrigin(0, 0);
                    //this._areYouSurePage.setInteractive();
                    this._btnSureYes = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2 - 95, 485 - 50, 'btnYES1');
                    this._btnSureYes.setInteractive({ cursor: 'pointer' });
                    this._btnSureYes.once('pointerup', () => {
                        onYes();
                        window.angularComponentRef.backToMenu();
                    });
                    var modalTextStyle = {
                        backgroundColor: 'transparent',
                        stroke: '#ffffff',
                        strokeThickness: 2,
                        lineSpacing: 20,
                        fontFamily: 'Kids Rock DEMO',
                        fontSize: 27,
                        color: '#43425d',
                        wordWrap: true,
                        align: 'center'
                    };
                    var modalText = this.scene.add.text(game.scale.width / 2 + 12, game.scale.height / 2, "Your progress in this activity will not be saved. \n Are you sure you want to exit? ", modalTextStyle);
                    modalText.setOrigin(0.5, 0.5);

                    setupButtonTextureBased(this._btnSureYes, 'btnYES1', 'btnYES2');
                    this._btnSureNo = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2 + 95, 485 - 50, 'btnNO1');
                    this._btnSureNo.setInteractive({ cursor: 'pointer' });
                    this._btnSureNo.once('pointerup', onNo);
                    setupButtonTextureBased(this._btnSureNo, 'btnNO1', 'btnNO2');
                    this.add(this._areYouSurePage);
                    this.add(this._btnSureYes);
                    this.add(this._btnSureNo);
                    this.add(modalText);

                }
            }
            screen.AreYouSureWindow = AreYouSureWindow;
        })(screen = ctb.screen || (ctb.screen = {}));
    })(ctb || (ctb = {}));

    (function (ctb) {
        var screen;
        (function (screen) {
            class CompleteWindow extends Phaser.GameObjects.Container {
                constructor(scene, onBack, onReplay, onNext) {
                    super(scene);
                    this.music = null;
                    this.setPosition(-104.5, -48);
                    this._bgComplete = new Phaser.GameObjects.Image(this.scene, 0, 0, 'Completion page LATEST UPDATED');
                    this._bgComplete.setOrigin(0, 0);
                    //this._bgComplete.setInteractive();
                    this._cup = new Phaser.GameObjects.Image(this.scene, 400, 410, 'Trophy');
                    this._btnBack = new Phaser.GameObjects.Image(this.scene, 570, 570, 'btnBACK1');
                    this._btnReplay = new Phaser.GameObjects.Image(this.scene, 720, 570, 'btnReplay1');
                    this._btnNext = new Phaser.GameObjects.Image(this.scene, 870, 570, 'btnNEXT1');
                    let _CollectedPoints = new Phaser.GameObjects.Image(this.scene, 620, 440, 'Collected Points');
                    this.totalScoreTxt = this.scene.add.text(845, 352, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 35,
                        "color": "#F49F1C",
                        "align": 'center',
                        'stroke': '#70451A',
                        'strokeThickness': 6
                    });
                    this.totalScoreTxt.setOrigin(0.5, 0.5);
                    let grd = this.totalScoreTxt.context.createLinearGradient(0, 0, 0, this.totalScoreTxt.height);
                    grd.addColorStop(0, '#FFFF00');
                    grd.addColorStop(1, '#C17316');
                    this.totalScoreTxt.setFill(grd);
                    this.starScoreTxt = this.scene.add.text(648, 433, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 24,
                        "color": "#FFFFFF",
                        "align": 'center'
                    });
                    this.starScoreTxt.setOrigin(0.5, 0.5);
                    this.add([
                        this._bgComplete,
                        _CollectedPoints,
                        this._cup,
                        this._btnBack,
                        this._btnReplay,
                        this._btnNext,
                        this.totalScoreTxt,
                        this.starScoreTxt
                    ]);
                    this._btnBack.setInteractive({ cursor: 'pointer' });
                    this._btnBack.on('pointerup', () => {
                        onBack(this._btnBack);
                        window.angularComponentRef.backToMenu();
                        // if (this.music) {
                        //     this.music.stop();
                        // }
                    });
                    setupButtonTextureBased(this._btnBack, 'btnBACK1', 'btnBACK2');
                    this._btnReplay.setInteractive({ cursor: 'pointer' });
                    this._btnReplay.once('pointerup', () => {
                        onReplay(this._btnReplay);
                        if (this.music) {
                            this.music.stop();
                        }
                    });
                    setupButtonTextureBased(this._btnReplay, 'btnReplay1', 'btnReplay2');
                    this._btnNext.setInteractive({ cursor: 'pointer' });
                    this._btnNext.on('pointerup', () => {
                        onNext(this._btnNext);
                        window.angularComponentRef.nextActivity();
                        // if (this.music) {
                        //     this.music.stop();
                        // }
                    });
                    setupButtonTextureBased(this._btnNext, 'btnNEXT1', 'btnNEXT2');
                }
                show(score, starScore) {
                    window.angularComponentRef.gameFinish({ score, starScore });
                    this._cup.scale = 1.25;
                    this.scene.tweens.add({
                        targets: this._cup,
                        "scale": 1,
                        duration: 500,
                        ease: Phaser.Math.Easing.Back.Out
                    });
                    this.totalScoreTxt.text = String(window.angularComponentRef.component.userInfo.totalScore);
                    this.starScoreTxt.text = String(starScore);
                    // let music = this.scene.sound.add("viktory");
                    this.music = this.scene.sound.add("Activity completion fantastic");
                    this.music.play();
                }
            }
            screen.CompleteWindow = CompleteWindow;
        })(screen = ctb.screen || (ctb.screen = {}));
    })(ctb || (ctb = {}));

    (function (ctb) {
        var screen;
        (function (screen) {
            var Preloader = ctb.scene.Preloader;
            class GameplayScreen extends Phaser.GameObjects.Container {
                constructor(scene, gameplay) {
                    super(scene);
                    this.bgMusic = null;
                    this.correctAudio = null;
                    this.correctAudioWord = null;
                    this.idleDelayedCall = null;
                    this.soundWrongDrop = null;
                    this.wfsnd = null;
                    this.showCompleteWindow = (score, starScore) => {
                        let completeWindow = new screen.CompleteWindow(this.scene, (target) => {
                            playBtnClickAnim(target);
                        }, (target) => {
                            playBtnClickAnim(target);
                            this.destroyGameplay();
                            completeWindow.destroy(true);
                            this.showInstructionPage();
                        }, (target) => {
                            playBtnClickAnim(target);
                        });
                        this.setInputEnabled(false);
                        delayedCall(2000, () => {
                            setPageBackground("bg-blue");
                            this.add(completeWindow);
                            completeWindow.show(score, starScore);
                            // this.bgMusic.stop();
                        });
                    };
                    this.showLoseWindow = (score, starScore) => {
                        let tryAgainWindow = new screen.TryAgainWindow(this.scene, (target) => {
                            playBtnClickAnim(target);
                        }, (target) => {
                            playBtnClickAnim(target);
                            this.destroyGameplay();
                            tryAgainWindow.destroy(true);
                            this.showInstructionPage();
                        });
                        this.setInputEnabled(false);
                        delayedCall(1500, () => {
                            setPageBackground("bg-blue");
                            this.add(tryAgainWindow);
                            tryAgainWindow.show(score, starScore);
                            // this.bgMusic.stop();
                        });
                    };
                    this.gameplay = gameplay;
                    window["gs"] = this;
                    this._gameStage = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2, game.scale.height / 2, 'BG');
                    this._gameStage.setOrigin(0.5, 0.5);
                    this._gameStage.setScale(1.02);
                    //this._gameStage.setInteractive();
                    this.add(this._gameStage);
                    this._btnClose = new Phaser.GameObjects.Image(this.scene, 1025 - 105, 100 - 50, 'x Button');
                    this._btnClose.setInteractive({ cursor: 'pointer' });
                    this._btnClose["defScale"] = this._btnClose.scale;
                    setupButtonTextureBased(this._btnClose, 'x Button', 'x Button HOVER EFFECT');
                    this.add(this._btnClose);
                    this._btnClose.on('pointerup', () => {
                        playBtnClickAnim(this._btnClose);
                        this.onCloseClick();
                    });
                    this._btnSound = new Phaser.GameObjects.Image(this.scene, 160 - 105, 100 - 50, 'Sound');
                    this._btnSound.setInteractive({ cursor: 'pointer' });
                    this._btnSound["defScale"] = this._btnSound.scale;
                    setupButtonTextureBased(this._btnSound, 'Sound', 'Sound HOVER EFFECT');
                    this.add(this._btnSound);
                    this._btnSound.on('pointerup', () => {
                        playBtnClickAnim(this._btnSound);
                        this.onSoundClick();
                    });
                }
                playCorrectAudio() {
                    if (this.correctAudio) {
                        this.correctAudio.stop();
                    }
                    this.correctAudio = this.scene.sound.add(this.gameplay.correctWord);
                    this.correctAudio.play();
                    if (this.areYouSureWindow && this.areYouSureWindow.parentContainer == this) {
                        this.correctAudio.pause();
                    }
                    if (this.correctAudioWord)
                        this.correctAudioWord.stop();
                }
                onSoundClick() {
                    this.playCorrectAudio();
                }
                showGameplay() {
                    setPageBackground("bg-australia");
                    // this.bgMusic = this.scene.sound.add("Winter bg sound");
                    // this.bgMusic.play();
                    // this.bgMusic.loop = true;
                    this.gameplayContainer = new Phaser.GameObjects.Container(this.scene);
                    this.add(this.gameplayContainer);
                    this.gameplay.reset();
                    this.prepareRound();
                    this.gameplay.setupCallbacks(this.showCompleteWindow, this.showLoseWindow, () => {
                        this.onNewRound(true);
                    });
                    this.createTallies();
                }
                prepareRound() {
                    delayedCall(500, () => this.playCorrectAudio());
                    this.gameplayContainer.removeAll();

                    this._RoundedRectangle8 =  new Phaser.GameObjects.Image(this.scene, 60, 323, "Rounded Rectangle 8");
                    this.gameplayContainer.add(this._RoundedRectangle8);
                    this._RoundedRectangle8.scaleY = 1.35;

                    this._DoughTRANSPARANT = new Phaser.GameObjects.Image(this.scene, 495, 222, "Dough TRANSPARANT");
                    this.gameplayContainer.add(this._DoughTRANSPARANT);

                    this._PressButton = new Phaser.GameObjects.Image(this.scene, 495, 360, 'Press button');
                    this._PressButton.setInteractive({ cursor: 'pointer' });
                    this._PressButton.on('pointerup', () => {
                        this.checkTargetBlockLetters();
                    });
                    this._PressButton.on('pointerdown', () => { this._PressButton.setTexture('Press Hover'); });
                    this._PressButton.on('pointerover', () => { game.scene.getAt(0).sound.add("button hover").play(); });
                    this._PressButton.on('pointerout', () => { this._PressButton.setTexture('Press button'); });
                    this._PressButton.on('pointerup', () => {
                        if (this._PressButton.parentContainer) {
                            this._PressButton.setTexture('Press button'); game.scene.getAt(0).sound.add('activity selection - button selection').play();
                        }
                    });
                    this._PressButton["defScale"] = this._PressButton.scale;
                    this.gameplayContainer.add(this._PressButton);

                    this._HandIcon = new Phaser.GameObjects.Image(this.scene, 545, 410, 'Hand Icon');
                    this._HandIcon.setOrigin(0, 1);
                    this._HandIcon.scale = 0.6;
                    this._HandIcon.visible = false;
                    this.gameplayContainer.add(this._HandIcon);

                    this.pressleft = new Phaser.GameObjects.Image(this.scene, 125 - 180, 215, 'pressleft');
                    this.pressleft.setOrigin(0, 0.5);
                    this.gameplayContainer.add(this.pressleft);

                    this.pressRight = new Phaser.GameObjects.Image(this.scene, 545 + 180, 215, 'pressleft');
                    this.pressRight.setOrigin(0, 0.5);
                    this.pressRight.flipX = true;
                    this.gameplayContainer.add(this.pressRight);

                    let shapeL = new Phaser.GameObjects.Graphics(this.scene);
                    shapeL.fillStyle(0xffffff);
                    shapeL.beginPath();
                    shapeL.fillRect(125 + 30, 215 - 120 / 2, 316, 120);
                    shapeL.fillCircle(125 + 30, 215 + 5, 30);
                    shapeL.fillPath();
                    let maskL = shapeL.createGeometryMask();
                    this.pressleft.setMask(maskL);

                    let shapeR = new Phaser.GameObjects.Graphics(this.scene);
                    shapeR.fillStyle(0xffffff);
                    shapeR.beginPath();
                    shapeR.fillRect(545 - 30, 215 - 120 / 2, 316, 120);
                    shapeR.fillCircle(545 + 316 - 30, 215 + 5, 30);
                    shapeR.fillPath();
                    let maskR = shapeR.createGeometryMask();
                    this.pressRight.setMask(maskR);

                    let randomizedLetter = Phaser.Utils.Array.Shuffle(this.gameplay.blockLetters.slice());
                    if (this.gameplay.useImages) {
                        let correctWord = new Phaser.GameObjects.Image(this.scene, 485, 75, this.gameplay.correctWord);
                        this.gameplayContainer.add(correctWord);
                    }
                    else {
                        let correctWord = this.scene.add.text(485, 75, "", {
                            "fontFamily": "QuranErafont",
                            "fontSize": 90,
                            "color": "#000000",
                            "align": 'center'
                        });
                        correctWord.setOrigin(0.5, 0.5);
                        correctWord.style.fixedHeight = 140;
                        correctWord.setText(this.gameplay.correctWord);
                        this.gameplayContainer.add(correctWord);
                    }
                    this.selectableLetters = [];
                    this.targetBlocks = [];
                    let correctWordLettersNumber = this.gameplay.wordsLetters ? this.gameplay.getCorrectWordLettersNumber() : this.gameplay.correctWord.length;
                    for (let i = 0; i < correctWordLettersNumber; i++) {
                        let b = {
                            x: 356 + i * (i == 2 ? 140 : 142), y: 221.5
                        };
                        b['alreadyFilled'] = false;
                        this.targetBlocks.push(b);
                        if (this.gameplay.wordsLetters) {
                            b["-letter-text"] = this.gameplay.getCorrectWordCharAt(correctWordLettersNumber - 1 - i);
                        } else {
                            b["-letter-text"] = this.gameplay.correctWord.charAt(this.gameplay.correctWord.length - 1 - i);
                        }
                        b["-block-"] = null;
                    }
                    for (let i = 0; i < randomizedLetter.length; i++) {
                        let a = new Phaser.GameObjects.Container(this.scene, 196 + i * 152, 487);
                        a.add(a["-image-"] = new Phaser.GameObjects.Image(this.scene, 0, 0, 'DoughNormal'));
                        a["-image-"].setOrigin(0.5, 0.5);
                        this.selectableLetters.push(a);
                        let txt;
                        if (this.gameplay.useImages) {
                            txt = new Phaser.GameObjects.Image(this.scene, 0, 0, randomizedLetter[i]);
                            a.add(txt);
                        }
                        else {
                            txt = this.scene.add.text(0, 0, "", {
                                "fontFamily": "QuranErafont",
                                "fontSize": 55,
                                "color": "#000000",
                                "align": 'center'
                            });
                            txt.setOrigin(0.5, 0.5);
                            txt.style.fixedHeight = 75;
                            txt.setText(randomizedLetter[i]);
                            a.add(txt);
                        }
                        a['startPosition'] = { x: a.x, y: a.y };
                        a["-letter-"] = txt;
                        a["-letter-text"] = randomizedLetter[i];
                        this.gameplayContainer.add(a);
                        a['-draggable-'] = true;
                    }
                    for (let a of this.selectableLetters) {
                        a.setSize(a["-image-"].width, a["-image-"].height);
                        a.setInteractive({ cursor: 'pointer' });
                        this.scene.input.setDraggable(a);
                        a.on('pointerdown', () => {
                            if (a["-placedAtBlock-"]) {
                                a["-placedAtBlock-"]['alreadyFilled'] = false;
                                a["-placedAtBlock-"] = null;
                            }

                            a['-pointerdown-'] = true;
                            if (a['-draggable-'])
                                this.scene.sound.add("drag from its spot").play();
                        });
                        a.on('pointerup', () => {
                            a['-pointerdown-'] = false;
                            if (!a['-draggable-'])
                                return;

                            let targetBlock;
                            for (targetBlock of this.targetBlocks) {
                                if (targetBlock['alreadyFilled'])
                                    continue;
                                if (Phaser.Math.Distance.Between(a.x, a.y, targetBlock.x, targetBlock.y) < 50) {
                                    //as
                                    // a['-draggable-'] = false;
                                    targetBlock['alreadyFilled'] = true;
                                    this.scene.tweens.add({
                                        targets: a,
                                        x: targetBlock.x,
                                        y: targetBlock.y,
                                        duration: 300,
                                        ease: Phaser.Math.Easing.Back.Out
                                    });
                                    targetBlock["-block-"] = a;
                                    a["-placedAtBlock-"] = targetBlock;
                                    this.scene.sound.add("correct drop").play();
                                    this.updateHandIconVisibility();
                                    return;
                                }
                            }
                            this.updateHandIconVisibility();
                            this.moveBridgeBackToStartPosition(a, null, true);
                        });
                        a.on('pointerout', () => {
                            if (!a['-draggable-'])
                                return;
                            if (!a['-pointerdown-'])
                                return;
                            this.moveBridgeBackToStartPosition(a, null, true);
                        });
                    }

                    this.longIce = new Phaser.GameObjects.Image(this.scene, 495, 215, 'BIG DOUGH Normal');
                    this.longIce.setOrigin(0.5, 0.5);
                    this.longIce.alpha = 0;
                    this.gameplayContainer.add(this.longIce);

                    this.createInput();
                    this.setInputEnabled(false);
                    // delayedCall(1200, ()=>{
                    if (this.gameplay.isNewRound()) {
                        if (!this.gameplay.isRoundsComplete()) {
                            // delayedCall(2000, ()=>{
                            this.setInputEnabled(true);
                            // });
                        }
                    }
                    else {
                        this.setInputEnabled(true);
                    }
                    // });
                }

                updateHandIconVisibility() {
                    this.hideHandIcon();
                    if (this.targetBlocks.every(block => !!block['-block-'])) {
                        this.showHandIconAnim();
                    }
                }

                showHandIconAnim() {
                    this._HandIcon.visible = true;
                    this._HandIcon.angle = 0;
                    this._handTween = this.scene.tweens.add({
                        targets: this._HandIcon,
                        "angle": 10,
                        yoyo: true,
                        repeat: -1,
                        duration: 500
                    });
                }

                hideHandIcon() {
                    this._HandIcon.visible = false;
                    if (this._handTween) {
                        this.scene.tweens.remove(this._handTween);
                        this._handTween = null;
                    }
                }

                doCorrectPress() {
                    this.scene.tweens.add({
                        targets: this._DoughTRANSPARANT,
                        alpha: 0,
                        duration: 250,
                        ease: Phaser.Math.Easing.Linear,
                    });

                    this.startPressAnim();
                    // this.scene.sound.add("Placing block above").play();
                    this.longIce.scaleX = 1;
                    this.longIce.alpha = 0;
                    this.scene.tweens.add({
                        targets: this.longIce,
                        alpha: 1,
                        scaleX: 0.4,
                        duration: 160,
                        delay: 20,
                        ease: Phaser.Math.Easing.Circular.Out
                    });
                    this.scene.tweens.add({
                        targets: this.longIce,
                        scaleX: 1,
                        duration: 300,
                        delay: 185,
                        ease: Phaser.Math.Easing.Sine.InOut
                    });
                    let k = 0;
                    for (let targetBlock of this.targetBlocks) {
                        k++;
                        this.scene.tweens.add({
                            targets: targetBlock['-block-']["-image-"],
                            duration: 80,
                            alpha: 0,
                            delay: 30,
                            ease: Phaser.Math.Easing.Sine.Out
                        });
                        if (targetBlock == this.targetBlocks[1])
                            continue;
                        this.scene.tweens.add({
                            targets: targetBlock['-block-'],
                            x: this.targetBlocks[1]['x'],
                            duration: 140,
                            scaleY: 1.15,
                            scaleX: 0.7,
                            ease: Phaser.Math.Easing.Sine.Out,
                            delay: 60
                        });
                        this.scene.tweens.add({
                            targets: targetBlock['-block-'],
                            x: this.targetBlocks[1]['x'],
                            duration: 100,
                            alpha: 0,
                            delay: 50
                        });

                    }
                    delayedCall(400, () => {
                        if (this.gameplay.useImages) {
                            this.targetBlocks[1]['-block-']["-letter-"].setTexture(this.gameplay.correctWord);
                        }
                        else {
                            this.targetBlocks[1]['-block-']["-letter-"].setText(this.gameplay.correctWord);
                        }
                    });
                    //this.scene.sound.add("Letters joining sound").play();
                    delayedCall(900, () => this.scene.sound.add("Correct click").play());
                    //delayedCall(1500, () => this.scene.sound.add("success for corect word").play());
                    this.onCorrectAnswer();
                }

                startPressAnim() {
                    this.scene.tweens.add({
                        targets: this.pressleft,
                        x: 125,
                        duration: 200,
                        ease: Phaser.Math.Easing.Quintic.Out
                    });
                    this.scene.tweens.add({
                        targets: this.pressRight,
                        x: 545,
                        duration: 200,
                        ease: Phaser.Math.Easing.Quintic.Out
                    });

                    delayedCall(250, () => {
                        this.scene.tweens.add({
                            targets: this.pressleft,
                            x: 125 - 180,
                            duration: 300,
                            ease: Phaser.Math.Easing.Sine.Out
                        });
                        this.scene.tweens.add({
                            targets: this.pressRight,
                            x: 545 + 180,
                            duration: 300,
                            ease: Phaser.Math.Easing.Sine.Out
                        });
                    });
                    this.scene.sound.add("Machine squeezes").play();
                }

                startWrongPressAnim() {
                    this.scene.tweens.add({
                        targets: this.pressleft,
                        x: -24,
                        duration: 180,
                        ease: Phaser.Math.Easing.Back.Out
                    });
                    this.scene.tweens.add({
                        targets: this.pressRight,
                        x: 700,
                        duration: 180,
                        ease: Phaser.Math.Easing.Back.Out
                    });

                    delayedCall(200, () => {
                        this.scene.tweens.add({
                            targets: this.pressleft,
                            x: 125 - 180,
                            duration: 300,
                            ease: Phaser.Math.Easing.Sine.Out
                        });
                        this.scene.tweens.add({
                            targets: this.pressRight,
                            x: 545 + 180,
                            duration: 300,
                            ease: Phaser.Math.Easing.Sine.Out
                        });
                    });
                    this.scene.sound.add("Machine getting stuck").play();
                }

                _update() {
                    if (this.selectableLetters) {
                        for (let a of this.selectableLetters) {
                            if (a.x < 0 + a["-image-"].width / 2) {
                                a.x = 0 + a["-image-"].width / 2;
                            }
                            else if (a.x > game.scale.width - a["-image-"].width / 2) {
                                a.x = game.scale.width - a["-image-"].width / 2;
                            }
                            if (a.y < 0 + a["-image-"].height / 2) {
                                a.y = a["-image-"].height / 2;
                            }
                            else if (a.y > game.scale.height - a["-image-"].height / 2) {
                                a.y = game.scale.height - a["-image-"].height / 2;
                            }
                        }
                    }
                }
                placeAppleOverBuckets(a) {
                    if (!a.parentContainer)
                        return;
                    this.gameplayContainer.remove(a);
                    this.gameplayContainer.addAt(a, this.gameplayContainer.length);
                }
                onNewRound(showOut) {
                    this.scene.sound.add("next_round").play();
                    this.setInputEnabled(false);
                    if (showOut) {
                        this.prepareRound();
                    }
                }
                createInput() {
                    this.scene.input.on('drag', (pointer, block, dragX, dragY) => {
                        if (!block['-draggable-'])
                            return;
                        block.x = dragX;
                        block.y = dragY;
                        this.gameplayContainer.bringToTop(block);
                    });
                    this._btnClose.setInteractive({ cursor: 'pointer', pixelPerfect: true });
                }
                checkTargetBlockLetters() {
                    let sameLettersNum = 0;
                    for (let targetBlock of this.targetBlocks) {
                        if (!targetBlock['-block-']) {
                            // this.scene.sound.add("Placing block above").play();
                            return;
                        }
                        if (targetBlock["-letter-text"] == targetBlock['-block-']["-letter-text"]) {
                            sameLettersNum++;
                        }
                    }
                    this.setInputEnabled(false);
                    this.hideHandIcon();
                    if (sameLettersNum == this.targetBlocks.length) {
                        this.doCorrectPress();
                    }
                    else {
                        for (let targetBlock of this.targetBlocks) targetBlock['-block-']["-image-"].setTexture('DoughWrong');

                        this.startWrongPressAnim();
                        delayedCall(500, () => { this.scene.sound.add("wrong drop").play(); });
                        delayedCall(1800, () => {
                            for (let targetBlock of this.targetBlocks) {
                                for (let targetBlock of this.targetBlocks) targetBlock['-block-']["-image-"].setTexture('DoughNormal');
                                this.moveBridgeBackToStartPosition(targetBlock['-block-'], null, true);
                            }
                            // delayedCall(100, ()=>this.scene.sound.add("all three blocks move back after wrong").play());
                        });
                        delayedCall(1900, () => {
                            this.onWrongAnswer();
                            for (let targetBlock of this.targetBlocks) {
                                targetBlock['alreadyFilled'] = false;
                                targetBlock['-block-']['-draggable-'] = true;
                                targetBlock["-block-"] = null;
                            }
                            this.updateHandIconVisibility();
                        });
                        delayedCall(2750, () => {
                            this.setInputEnabled(true);
                        });
                    }
                }
                moveBridgeBackToStartPosition(block, onComplete, playSound) {
                    this.scene.tweens.add({
                        targets: block,
                        x: block['startPosition'].x,
                        y: block['startPosition'].y,
                        duration: 350,
                        ease: Phaser.Math.Easing.Sine.Out,
                        onComplete: () => {
                            if (onComplete)
                                onComplete();
                        }
                    });
                    if (Phaser.Math.Distance.Between(block['startPosition'].x, block['startPosition'].y, block.x, block.y) > 20) {
                        delayedCall(100, () => {
                            if (playSound) {
                                this.scene.sound.add("block goes back when released").play();
                            }
                        });
                    }
                    this.placeAppleOverBuckets(block);
                }
                onCorrectAnswer() {
                    let i = this.gameplay.getCurrentTotalAnswersCount();
                    this.tallyEmptyArray[i].visible = false;
                    this.tally[i].visible = true;
                    let completed = this.gameplay.onCorrectAnswer();
                    return completed;
                }
                onWrongAnswer() {
                    let i = this.gameplay.getCurrentTotalAnswersCount();
                    this.tallyEmptyArray[i].visible = true;
                    this.tally[i].visible = false;
                    let lost = this.gameplay.onWrongAnswer();
                    // this.soundWrongDrop = this.scene.sound.add("wrong drop");
                    // this.soundWrongDrop.play();
                    // this.scene.sound.add("Goose no").play();
                    if (this.idleDelayedCall != null) {
                        destroyDelayedCall(this.idleDelayedCall);
                        this.idleDelayedCall = null;
                    }
                    if (!lost) {
                        delayedCall(650, () => this.playCorrectAudio());
                    }
                    return lost;
                }
                onCloseClick() {
                    this.showAreYouSurePage();
                    this.scene.sound.add('warning page pop up sfx').play();
                }
                createTallies() {
                    if (this.tally) {
                        for (let te of this.tallyEmptyArray) {
                            te.visible = false;
                            this.bringToTop(te);
                        }
                        for (let t of this.tally) {
                            t.visible = false;
                            this.bringToTop(t);
                        }
                        return;
                    }
                    let startX = 37;
                    let startY = 191;
                    let dy = 44;
                    let dx = 45;
                    let tallyEmptyArrayPositions = [];
                    for (let i = 0; i < game.cache.json.get('gameplay')["rounds"].length+this.gameplay.failsNumToLose; i++) {
                        tallyEmptyArrayPositions.push({ x: startX + Math.floor(i / 7) * dx, y: startY + ((i % 7) * dy) });
                    }
                    this.tallyEmptyArray = [];
                    this.tally = [];
                    for (let p of tallyEmptyArrayPositions) {
                        let _BeehiveEmpty = new Phaser.GameObjects.Image(this.scene, p['x'], p['y'], 'tally Empty');
                        this.tallyEmptyArray.push(_BeehiveEmpty);
                        _BeehiveEmpty.visible = false;
                        let _Beehive = new Phaser.GameObjects.Image(this.scene, p['x'], p['y'], 'tally');
                        this.tally.push(_Beehive);
                    }
                    for (let bea of this.tallyEmptyArray) {
                        this.add(bea);
                    }
                    for (let bee of this.tally) {
                        this.add(bee);
                        bee.visible = false;
                    }
                }
                hideAllUnusedTallies() {
                    let i = this.gameplay.getCurrentTotalAnswersCount();
                    for (let k = i + 1; k < this.tallyEmptyArray.length; k++) {
                        this.tallyEmptyArray[k].visible = false;
                        this.tally[k].visible = false;
                    }
                }
                showInstructionPage() {
                    setPageBackground("bg-blue");
                    let playInstructionSound = () => {
                        if (this.wfsnd) {
                            this.wfsnd.stop();
                        }
                        this.wfsnd = this.scene.sound.add("Instruction");
                        this.wfsnd.play();
                    };
                    this.instructionPage = new screen.InstructionPage(this.scene, (target) => {
                        playBtnClickAnim(target);
                        this.instructionPage.destroy(true);
                        this.showGameplay();
                        if (this.wfsnd) {
                            this.wfsnd.stop();
                        }
                    }, (target) => {
                        playBtnClickAnim(target);
                        playInstructionSound();
                    });
                    this.add(this.instructionPage);
                    try {
                        playInstructionSound();
                    }
                    catch (e) {
                        console.error(e);
                    }
                }
                showAreYouSurePage() {
                    pauseAllDelayedCalls();
                    setPageBackground("bg-blue");
                    this.scene.tweens.pauseAll();
                    this.pauseSounds();
                    this.areYouSureWindow = new screen.AreYouSureWindow(this.scene, () => {
                        this.scene.tweens.resumeAll();
                        this.areYouSureWindow.destroy(true);
                        this.destroyGameplay();
                        this.showInstructionPage();
                    }, () => {
                        this.scene.tweens.resumeAll();
                        this.areYouSureWindow.destroy(true);
                        this.unpauseSounds();
                        resumeAllDelayedCalls();
                        setPageBackground("bg-australia");
                    });
                    this.add(this.areYouSureWindow);
                }
                setInputEnabled(enabled) {
                    if (enabled) {
                        for (let a of this.selectableLetters)
                            a.setInteractive({ cursor: 'pointer' });
                        this._PressButton.setInteractive({ cursor: 'pointer' });
                        // this.showHandIconAnim();
                    }
                    else {
                        for (let a of this.selectableLetters)
                            a.disableInteractive();
                        this._PressButton.disableInteractive();
                        this.hideHandIcon();
                    }
                }
                pauseSounds() {
                    this.scene.sound.pauseAll();
                }
                unpauseSounds() {
                    this.scene.sound.resumeAll();
                }
                destroyGameplay() {
                    this.setInputEnabled(false);
                    this.remove(this.gameplayContainer);
                    this.scene.sound.stopAll();
                    destroyAllDelayedCalls();
                }
            }
            screen.GameplayScreen = GameplayScreen;
        })(screen = ctb.screen || (ctb.screen = {}));
    })(ctb || (ctb = {}));

    (function (ctb) {
        var screen;
        (function (screen) {
            class InstructionPage extends Phaser.GameObjects.Container {
                constructor(scene, onPlayClick, onSndClick) {
                    super(scene);
                    this._instructionPage = new Phaser.GameObjects.Image(this.scene, 0 - 105, 0 - 48, 'Instructions page  ALL ACTIVITY  TITLEs');
                    this._instructionPage.setOrigin(0, 0);
                    //this._instructionPage.setInteractive();

                    this._instructionPageTitle = new Phaser.GameObjects.Image(this.scene, 470, 110, 'Logo');
                    this._instructionPageTitle.setScale(0.8);

                    this._btnPlay = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2, 480 - 50, 'btnPLAY1');
                    this._btnPlay.setInteractive({ cursor: 'pointer' });
                    this._btnPlay.once('pointerup', onPlayClick);
                    setupButtonTextureBased(this._btnPlay, 'btnPLAY1', 'btnPLAY2');
                    this.instrTxt = this.scene.add.text(game.scale.width / 2, game.scale.height / 2, "Drag the doughs to make\n\n the right word", {
                        "fontFamily": "Kids Rock DEMO",
                        "fontSize": 30,
                        "lineSpacing": 20,
                        "color": "#43425D",
                        "align": 'center'
                    });
                    this.instrTxt.setOrigin(0.5, 0.5);
                    this.instrTxt.setWordWrapWidth(600);
                    this.instrTxt.setLineSpacing(5);
                    this._btnSoundInstruction = new Phaser.GameObjects.Image(this.scene, 800 - 105, 156 - 50, 'Sound');
                    this._btnSoundInstruction.setInteractive({ cursor: 'pointer' });
                    this._btnSoundInstruction.on('pointerup', onSndClick);
                    this._btnSoundInstruction["defScale"] = this._btnSoundInstruction.scale;
                    setupButtonTextureBased(this._btnSoundInstruction, 'Sound', 'Sound HOVER EFFECT');
                    this.add(this._instructionPage);
                    this.add(this._instructionPageTitle);
                    this.add(this.instrTxt);
                    this.add(this._btnPlay);
                    this.add(this._btnSoundInstruction);
                }
            }
            screen.InstructionPage = InstructionPage;
        })(screen = ctb.screen || (ctb.screen = {}));
    })(ctb || (ctb = {}));

    (function (ctb) {
        var screen;
        (function (screen) {
            class TryAgainWindow extends Phaser.GameObjects.Container {
                constructor(scene, onBack, onReplay) {
                    super(scene);
                    this.music = null;
                    this.setPosition(-106, -48);
                    this._bg = new Phaser.GameObjects.Image(this.scene, 0, 0, 'Try again page');
                    this._bg.setOrigin(0, 0);
                    // this._bg.setInteractive();
                    this._star = new Phaser.GameObjects.Image(this.scene, 400, 415, 'Break Star');
                    this._btnBack = new Phaser.GameObjects.Image(this.scene, 600, 580, 'btnBACK1');
                    this._btnReplay = new Phaser.GameObjects.Image(this.scene, 765, 580, 'btnReplay1');
                    this.totalScoreTxt = this.scene.add.text(830, 355, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 35,
                        "color": "#F49F1C",
                        "align": 'center',
                        'stroke': '#70451A',
                        'strokeThickness': 6
                    });
                    this.totalScoreTxt.setOrigin(0.5, 0.5);
                    let grd = this.totalScoreTxt.context.createLinearGradient(0, 0, 0, this.totalScoreTxt.height);
                    grd.addColorStop(0, '#FFFF00');
                    grd.addColorStop(1, '#C17316');
                    this.totalScoreTxt.setFill(grd);
                    this.starScoreTxt = this.scene.add.text(635, 431, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 24,
                        "color": "#FFFFFF",
                        "align": 'center'
                    });
                    this.starScoreTxt.setOrigin(0.5, 0.5);
                    this.add([
                        this._bg,
                        this._star,
                        this._btnBack,
                        this._btnReplay,
                        this.totalScoreTxt,
                        this.starScoreTxt
                    ]);
                    this._btnBack.setInteractive({ cursor: 'pointer' });
                    this._btnBack.on('pointerup', () => {
                        onBack(this._btnBack);
                        // if (this.music) {
                        //     this.music.stop();
                        // }
                    });
                    setupButtonTextureBased(this._btnBack, 'btnBACK1', 'btnBACK2');
                    this._btnReplay.setInteractive({ cursor: 'pointer' });
                    this._btnReplay.once('pointerup', () => {
                        onReplay(this._btnReplay);
                        if (this.music) {
                            this.music.stop();
                        }
                    });
                    setupButtonTextureBased(this._btnReplay, 'btnReplay1', 'btnReplay2');
                }
                show(score, starScore) {
                    this._star.scale = 1.25;
                    this.scene.tweens.add({
                        targets: this._star,
                        "scale": 1,
                        duration: 500,
                        ease: Phaser.Math.Easing.Back.Out
                    });
                    this.totalScoreTxt.text = String(window.angularComponentRef.component.userInfo.totalScore);
                    this.starScoreTxt.text = String(starScore);
                    this.music = this.scene.sound.add("Fail - close one");
                    this.music.play();
                }
            }
            screen.TryAgainWindow = TryAgainWindow;
        })(screen = ctb.screen || (ctb.screen = {}));
    })(ctb || (ctb = {}));

    game = new ctb.App(json);
};

function destroyDoughPress() {
    if (game) {
        game.destroy();
    }
}

var ctb;
var game;
var popTheBubbles = (json) => {
    (function (ctb) {
        class App extends Phaser.Game {
            constructor() {
                App.json = json;
                let config = {
                    type: Phaser.AUTO,
                    width: App.CANVAS_WIDTH,
                    height: App.CANVAS_HEIGHT,
                    parent: 'game-container',
                    dom: {
                        createContainer: false
                    },
                    scale: {
                        mode: FitScaleManager.detectBestScaleMode(),
                        autoCenter: Phaser.Scale.CENTER_BOTH
                    },
                    transparent: true,
                    scene: {
                        create: () => {
                            this.scene.add('Boot', ctb.scene.Boot, true);
                        }
                    }
                };
                super(config);
            }
        }
        App.CANVAS_WIDTH = 980;
        App.CANVAS_HEIGHT = 600;
        ctb.App = App;
    })(ctb || (ctb = {}));
    var delayedCalls = [];
    function delayedCall(delay, callback, args, callbackScope) {
        let scene = game.scene.getAt(0);
        if (scene) {
            let dc = scene.time.delayedCall(delay, callback, args, callbackScope);
            delayedCalls.push(dc);
            return dc;
        }
        let t = setTimeout(callback, delay);
        delayedCalls.push(t);
        return t;
    }
    function pauseAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.paused = true;
            }
        }
    }
    function resumeAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.paused = false;
            }
        }
    }
    function destroyAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.remove(false);
            }
            else {
                clearTimeout(dc);
            }
        }
        delayedCalls = [];
    }
    function destroyDelayedCall(dc) {
        if (dc instanceof Phaser.Time.TimerEvent) {
            dc.remove(false);
        }
        else {
            clearTimeout(dc);
        }
        let ind = delayedCalls.indexOf(dc);
        if (ind >= 0)
            delayedCalls.splice(ind, 1);
    }
    function setPageBackground(bg) {
    }
    function setupButton(btn, frame) {
        btn.on('pointerdown', () => { btn.setFrame(frame + '_hover' + '0000'); });
        btn.on('pointerover', () => { btn.setFrame(frame + '_hover' + '0000'); game.scene.getAt(0).sound.add("button hover").play(); });
        btn.on('pointerout', () => { btn.setFrame(frame + '0000'); });
        btn.on('pointerup', () => { btn.setFrame(frame + '0000'); game.scene.getAt(0).sound.add('activity selection - button selection').play(); });
    }
    function setupButtonTextureBased(btn, texture, hoverTexture) {
        btn.on('pointerdown', () => { btn.setTexture(hoverTexture); });
        btn.on('pointerover', () => { btn.setTexture(hoverTexture); game.scene.getAt(0).sound.add("button hover").play(); });
        btn.on('pointerout', () => { btn.setTexture(texture); });
        btn.on('pointerup', () => {
            if (btn.parentContainer)
                btn.setTexture(texture); game.scene.getAt(0).sound.add('activity selection - button selection').play();
        });
    }
    function playBtnClickAnim(target) {
        let sc = target.hasOwnProperty("defScale") ? target["defScale"] : 1;
        target.scaleX = target.scaleY = sc;
        let scene = game.scene.getAt(0);
        scene.tweens.add({
            targets: target,
            "scaleX": 0.9 * sc,
            "scaleY": 0.9 * sc,
            duration: 100,
            yoyo: true
        });
    }
    /**
     * @author Roman Parada
     * This class is created to fix overlapping of bottom part of canvas by navigation bar in iOS.
     * It make a delayed resize of the canvas (like Phaser-3 FIT methods does) and it overrides Phaser-3 input window to Phaser-3 core transform methods
     *
     * How to use:
     * Just call the code line below in Boot scene's init() method of your project:
     * new FitScaleManager(this.game).setup();
     */
    class FitScaleManager {
        constructor(game) {
            this.doResize = () => {
                let scale = this.calculateScale();
                let newCanvasWidth = this.phaserScaleManager.width * scale;
                let newCanvasHeight = this.phaserScaleManager.height * scale;
                this.canvasStyle.width = newCanvasWidth + 'px';
                this.canvasStyle.height = newCanvasHeight + 'px';
                this.canvasStyle.marginLeft = (window.innerWidth - newCanvasWidth) / 2 + 'px';
                this.canvasStyle.marginTop = (window.innerHeight - newCanvasHeight) / 2 + 'px';
            };
            this.game = game;
            this.canvasStyle = this.game.canvas.style;
            this.phaserScaleManager = this.game.scale;
        }
        static detectBestScaleMode() {
            let iOS = /iPad|iPhone|iPod/.test(navigator.platform || "");
            let isAndroid = window.navigator.userAgent.toLowerCase().indexOf("android") > -1;
            return iOS || isAndroid ? Phaser.Scale.FIT : Phaser.Scale.NONE;
        }
        ;
        /**
         * Just call this method once in Boot scene's init() method
         */
        setup() {
            this.phaserScaleManager.addListener(Phaser.Scale.Events.RESIZE, this.onResize, this);
            this.overridePhaserTransformMethods();
            this.onResize();
        }
        calculateScale() {
            if (game.scale.scaleMode == Phaser.Scale.NONE)
                return 1;
            return Math.min(window.innerWidth / this.phaserScaleManager.width, window.innerHeight / this.phaserScaleManager.height);
        }
        overridePhaserTransformMethods() {
            this.game.scale.transformX = (pageX) => {
                return (pageX - parseInt(this.canvasStyle.marginLeft.split("px")[0])) / this.calculateScale();
            };
            this.game.scale.transformY = (pageY) => {
                return (pageY - parseInt(this.canvasStyle.marginTop.split("px")[0])) / this.calculateScale();
            };
        }
        onResize() {
            setTimeout(this.doResize, FitScaleManager.RESIZE_DELAY);
        }
    }
    FitScaleManager.RESIZE_DELAY = 500;
    var ctb;
    (function (ctb) {
        var core;
        (function (core) {
            class Gameplay {
                constructor() {
                    this.currentRound = 0;
                    this.correctAnswersCount = 0;
                    this.wrongAnswersCount = 0;
                    this.correctAnswersCountThisRound = 0;
                    this.wrongAnswersCountThisRound = 0;
                    this.onNewRound = null;
                    this.nextLetterDelay = 0;
                    this.failsNumToLose = Number(game.cache.json.get('gameplay')["failsNumToLose"]);
                    this.useImages = Boolean(game.cache.json.get('gameplay')["useImages"]);
                }
                setupCallbacks(onComplete, onLose, onNewRound) {
                    this.onComplete = onComplete;
                    this.onLose = onLose;
                    this.onNewRound = onNewRound;
                }
                calculateScore() {
                    return this.totalRoundsNum - this.wrongAnswersCount;
                }
                onLetterChosen() {
                    if (this.correctAnswersCountThisRound == 1) {
                        this.currentRound++;
                        if (this.currentRound >= this.totalRoundsNum) {
                            let score = this.calculateScore();
                            this.onComplete(score, score);
                            return true;
                        }
                        else {
                            this.nextLetter();
                        }
                    }
                    return false;
                }
                nextLetter() {
                    let fn = () => {
                        this.currentWordData = Phaser.Utils.Array.RemoveRandomElement(this.words);
                        this.correctAnswersCountThisRound = 0;
                        this.wrongAnswersCountThisRound = 0;
                        if (this.onNewRound)
                            this.onNewRound();
                    };
                    if (this.nextLetterDelay == 0) {
                        fn();
                    }
                    else {
                        delayedCall(this.nextLetterDelay, fn);
                    }
                }
                onCorrectAnswer() {
                    this.correctAnswersCount++;
                    this.correctAnswersCountThisRound++;
                    this.nextLetterDelay = 1500;
                    return this.onLetterChosen();
                }
                onWrongAnswer() {
                    this.wrongAnswersCount++;
                    this.wrongAnswersCountThisRound++;
                    this.nextLetterDelay = 0;
                    if (this.wrongAnswersCount >= this.failsNumToLose) {
                        this.onLose(0, 0);
                        return true;
                    }
                    else {
                        this.onLetterChosen();
                    }
                    return false;
                }
                getCurrentTotalAnswersCount() {
                    return this.correctAnswersCount + this.wrongAnswersCount;
                }
                getCurrentTotalAnswersCountThisRound() {
                    return this.correctAnswersCountThisRound + this.wrongAnswersCountThisRound;
                }
                isNewRound() {
                    return this.getCurrentTotalAnswersCountThisRound() == 0;
                }
                isRoundsComplete() {
                    return this.currentRound >= this.totalRoundsNum;
                }
                reset() {
                    this.nextLetterDelay = 0;
                    this.setupCallbacks(null, null, null);
                    let json = game.cache.json.get('gameplay');
                    this.words = json["words"].slice();
                    this.allWorlds = json["words"].slice();
                    this.totalRoundsNum = this.words.length;
                    this.nextLetter();
                    this.currentRound = 0;
                    this.correctAnswersCount = 0;
                    this.wrongAnswersCount = 0;
                    this.correctAnswersCountThisRound = 0;
                    this.wrongAnswersCountThisRound = 0;
                }
            }
            core.Gameplay = Gameplay;
        })(core = ctb.core || (ctb.core = {}));
    })(ctb || (ctb = {}));
    var ctb;
    (function (ctb) {
        var scene;
        (function (scene) {
            class Boot extends Phaser.Scene {
                init() {
                    this.game.scale.transformX = (pageX) => {
                        let offsetLeft = 0;
                        let parentElement = game.canvas.parentElement;
                        while (parentElement) {
                            if (parentElement.offsetLeft) {
                                offsetLeft = parentElement.offsetLeft;
                                break;
                            }
                            parentElement = parentElement.parentElement;
                        }
                        return (pageX - offsetLeft) * this.game.scale.displayScale.x;
                    };
                    this.game.scale.transformY = (pageY) => {
                        let offsetTop = 0;
                        let parentElement = game.canvas.parentElement;
                        while (parentElement) {
                            if (parentElement.offsetTop) {
                                offsetTop = parentElement.offsetTop;
                                break;
                            }
                            parentElement = parentElement.parentElement;
                        }
                        return (pageY - offsetTop) * this.game.scale.displayScale.y;
                    };
                }
                create() {
                    game.scene.remove('Boot');
                    game.scene.add('Preloader', ctb.scene.Preloader, true);
                }
            }
            scene.Boot = Boot;
        })(scene = ctb.scene || (ctb.scene = {}));
    })(ctb || (ctb = {}));
    var ctb;
    (function (ctb) {
        var scene;
        (function (scene) {
            var Gameplay = ctb.core.Gameplay;
            class MainScene extends Phaser.Scene {
                create() {
                    this.gameplay = new Gameplay();
                    this.gameplayScreen = new ctb.screen.GameplayScreen(this, this.gameplay);
                    this.children.add(this.gameplayScreen);
                    this.gameplayScreen.showInstructionPage();
                }
            }
            scene.MainScene = MainScene;
        })(scene = ctb.scene || (ctb.scene = {}));
    })(ctb || (ctb = {}));
    var ctb;
    (function (ctb) {
        var scene;
        (function (scene) {
            class Preloader extends Phaser.Scene {
                preload() {
                    if (typeof ctb.App.json == "string") this.load.json('gameplay', ctb.App.json); else this.game.cache.json.add('gameplay', ctb.App.json);
                }
                create() {
                    let json = game.cache.json.get('gameplay');
                    if (json["useImages"]) {
                        for (let w of json["words"]) {
                            this.load.image(w["word"], w["imageKey"]);
                        }
                    }
                    for (let w of json["words"]) {
                        this.load.audio(w["audioKey"], w["audioKey"]);
                    }
                    let progressTxt = this.add.text(game.scale.width / 2, game.scale.height / 2, "", {
                        "fontFamily": "QuranErafont",
                        "fontSize": 25,
                        "color": "#000000",
                        "align": 'center'
                    });
                    progressTxt.setOrigin(0.5, 0.5);
                    this.load.pack('preloader', 'assets/games/pop-the-bubbles/assets/pack.json');
                    this.load.on('progress', (value) => {
                        progressTxt.text = Math.ceil(value * 100) + "%";
                    }, this);
                    this.load.on('complete', () => {
                        this.nextScene();
                    });
                    this.load.start();
                }
                static playAnim(animKey, sprite, onComplete = null) {
                    let mainScene = game.scene.getScene('ScreenMain');
                    if (!mainScene.anims.exists(animKey)) {
                        let data = Preloader.ANIMS_DATA[animKey];
                        mainScene.anims.create({
                            key: animKey,
                            frames: mainScene.anims.generateFrameNames(data['atlas'], {
                                start: data['start'], end: data['end'], zeroPad: data['padNum'],
                                prefix: data['prefix'], suffix: ''
                            }),
                            frameRate: data['frameRate'],
                            repeat: data['repeat']
                        });
                    }
                    if (sprite.anims.currentAnim) {
                        sprite.off('animationcomplete');
                    }
                    sprite.anims.stop();
                    sprite.play(animKey);
                    sprite.on('animationcomplete', () => {
                        if (onComplete)
                            onComplete();
                    });
                    return sprite;
                }
                nextScene() {
                    game.scene.remove('Preloader');
                    game.scene.add('ScreenMain', ctb.scene.MainScene, true);
                }
            }
            Preloader.ANIMS_DATA = {
                'bubble_poping': {
                    'start': 0,
                    'end': 26,
                    'padNum': 4,
                    'prefix': 'bubble_poping',
                    'repeat': 0,
                    'frameRate': 24,
                    'atlas': 'bubble-atlas'
                },
                'bubble_idle': {
                    'start': 0,
                    'end': 50,
                    'padNum': 4,
                    'prefix': 'idle',
                    'repeat': -1,
                    'frameRate': 24,
                    'atlas': 'bubble-atlas'
                },
                'turtle_idle': {
                    'start': 0,
                    'end': 35,
                    'padNum': 4,
                    'prefix': 'turtle_idle',
                    'repeat': 0,
                    'frameRate': 24,
                    'atlas': 'turtle-idle-atlas'
                },
                'turtle_shock_in': {
                    'start': 0,
                    'end': 16,
                    'padNum': 4,
                    'prefix': 'turtle_shock',
                    'repeat': 0,
                    'frameRate': 24,
                    'atlas': 'turtle_shock-atlas'
                },
                'turtle_shock_out': {
                    'start': 16,
                    'end': 32,
                    'padNum': 4,
                    'prefix': 'turtle_shock',
                    'repeat': 0,
                    'frameRate': 24,
                    'atlas': 'turtle_shock-atlas'
                },
            };
            scene.Preloader = Preloader;
        })(scene = ctb.scene || (ctb.scene = {}));
    })(ctb || (ctb = {}));
    var ctb;
    (function (ctb) {
        var screen;
        (function (screen) {
            class AreYouSureWindow extends Phaser.GameObjects.Container {
                constructor(scene, onYes, onNo) {
                    super(scene);
                    this._areYouSurePage = new Phaser.GameObjects.Image(this.scene, -105, 0 - 48, 'Exit warning');
                    this._areYouSurePage.setOrigin(0, 0);
                    this._areYouSurePage.setInteractive();
                    var modalTextStyle = {
                        backgroundColor: 'transparent',
                        stroke: '#ffffff',
                        strokeThickness: 2,
                        lineSpacing: 15,
                        fontFamily: 'Kids Rock DEMO',
                        fontSize: 27,
                        color: '#43425d',
                        wordWrap: true,
                        align: 'center'
                    };
                    var modalText = this.scene.add.text(game.scale.width / 2 + 12, game.scale.height / 2, "Your progress in this activity will not be saved. \n Are you sure you want to exit? ", modalTextStyle);
                    modalText.setOrigin(0.5, 0.5);
                    this._btnSureYes = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2 - 95, 485 - 50, 'btnYES1');
                    this._btnSureYes.setInteractive({ cursor: 'pointer' });
                    this._btnSureYes.once('pointerup', () => {
                        onYes;
                        window.angularComponentRef.backToMenu();
                    });
                    setupButtonTextureBased(this._btnSureYes, 'btnYES1', 'btnYES2');
                    this._btnSureNo = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2 + 95, 485 - 50, 'btnNO1');
                    this._btnSureNo.setInteractive({ cursor: 'pointer' });
                    this._btnSureNo.once('pointerup', onNo);
                    setupButtonTextureBased(this._btnSureNo, 'btnNO1', 'btnNO2');
                    this.add(this._areYouSurePage);
                    this.add(this._btnSureYes);
                    this.add(this._btnSureNo);
                    this.add(modalText);
                }
            }
            screen.AreYouSureWindow = AreYouSureWindow;
        })(screen = ctb.screen || (ctb.screen = {}));
    })(ctb || (ctb = {}));
    var ctb;
    (function (ctb) {
        var screen;
        (function (screen) {
            class CompleteWindow extends Phaser.GameObjects.Container {
                constructor(scene, onBack, onReplay, onNext) {
                    super(scene);
                    this.music = null;
                    this.setPosition(-104.5, -48);
                    this._bgComplete = new Phaser.GameObjects.Image(this.scene, 0, 0, 'Completion page LATEST UPDATED');
                    this._bgComplete.setOrigin(0, 0);
                    //this._bgComplete.setInteractive();
                    this._cup = new Phaser.GameObjects.Image(this.scene, 400, 410, 'Trophy');
                    this._btnBack = new Phaser.GameObjects.Image(this.scene, 570, 570, 'btnBACK1');
                    this._btnReplay = new Phaser.GameObjects.Image(this.scene, 720, 570, 'btnReplay1');
                    this._btnNext = new Phaser.GameObjects.Image(this.scene, 870, 570, 'btnNEXT1');
                    let _CollectedPoints = new Phaser.GameObjects.Image(this.scene, 620, 440, 'Collected Points');
                    this.totalScoreTxt = this.scene.add.text(845, 352, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 35,
                        "color": "#F49F1C",
                        "align": 'center',
                        'stroke': '#70451A',
                        'strokeThickness': 6
                    });
                    this.totalScoreTxt.setOrigin(0.5, 0.5);
                    let grd = this.totalScoreTxt.context.createLinearGradient(0, 0, 0, this.totalScoreTxt.height);
                    grd.addColorStop(0, '#FFFF00');
                    grd.addColorStop(1, '#C17316');
                    this.totalScoreTxt.setFill(grd);
                    this.starScoreTxt = this.scene.add.text(648, 433, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 24,
                        "color": "#FFFFFF",
                        "align": 'center'
                    });
                    this.starScoreTxt.setOrigin(0.5, 0.5);
                    this.add([
                        this._bgComplete,
                        _CollectedPoints,
                        this._cup,
                        this._btnBack,
                        this._btnReplay,
                        this._btnNext,
                        this.totalScoreTxt,
                        this.starScoreTxt
                    ]);
                    this._btnBack.setInteractive({ cursor: 'pointer' });
                    this._btnBack.on('pointerup', () => {
                        onBack(this._btnBack);
                        window.angularComponentRef.backToMenu();
                        // if (this.music) {
                        //     this.music.stop();
                        // }
                    });
                    setupButtonTextureBased(this._btnBack, 'btnBACK1', 'btnBACK2');
                    this._btnReplay.setInteractive({ cursor: 'pointer' });
                    this._btnReplay.once('pointerup', () => {
                        onReplay(this._btnReplay);
                        if (this.music) {
                            this.music.stop();
                        }
                    });
                    setupButtonTextureBased(this._btnReplay, 'btnReplay1', 'btnReplay2');
                    this._btnNext.setInteractive({ cursor: 'pointer' });
                    this._btnNext.on('pointerup', () => {
                        onNext(this._btnNext);
                        window.angularComponentRef.nextActivity();
                        // if (this.music) {
                        //     this.music.stop();
                        // }
                    });
                    setupButtonTextureBased(this._btnNext, 'btnNEXT1', 'btnNEXT2');
                }
                show(score, starScore) {
                    window.angularComponentRef.gameFinish({ score, starScore })
                    this._cup.scale = 1.25;
                    this.scene.tweens.add({
                        targets: this._cup,
                        "scale": 1,
                        duration: 500,
                        ease: Phaser.Math.Easing.Back.Out
                    });
                    this.totalScoreTxt.text = String(window.angularComponentRef.component.userInfo.totalScore);
                    this.starScoreTxt.text = String(starScore);
                    // let music = this.scene.sound.add("viktory");
                    this.music = this.scene.sound.add("Activity completion fantastic");
                    this.music.play();
                }
            }
            screen.CompleteWindow = CompleteWindow;
        })(screen = ctb.screen || (ctb.screen = {}));
    })(ctb || (ctb = {}));
    var ctb;
    (function (ctb) {
        var screen;
        (function (screen) {
            var Preloader = ctb.scene.Preloader;
            class GameplayScreen extends Phaser.GameObjects.Container {
                constructor(scene, gameplay) {
                    super(scene);
                    this.bgMusic = null;
                    this.correctAudio = null;
                    this.idleDelayedCall = null;
                    this.playIdle = () => {
                        Preloader.playAnim('turtle_idle', this.character, () => {
                            this.idleDelayedCall = delayedCall(Math.floor(Math.random() * 5) * 500, this.playIdle);
                        });
                    };
                    this.sfxBubblePopCounter = 0;
                    this.wfsnd = null;
                    this.showCompleteWindow = (score, starScore) => {
                        let completeWindow = new screen.CompleteWindow(this.scene, (target) => {
                            playBtnClickAnim(target);
                        }, (target) => {
                            playBtnClickAnim(target);
                            this.destroyGameplay();
                            completeWindow.destroy(true);
                            this.showInstructionPage();
                        }, (target) => {
                            playBtnClickAnim(target);
                        });
                        this.setInputEnabled(false);
                        delayedCall(2500, () => {
                            setPageBackground("bg-blue");
                            this.add(completeWindow);
                            completeWindow.show(score, starScore);
                            this.bgMusic.stop();
                        });
                    };
                    this.showLoseWindow = (score, starScore) => {
                        this.timerEvent.destroy();
                        let tryAgainWindow = new screen.TryAgainWindow(this.scene, (target) => {
                            playBtnClickAnim(target);
                        }, (target) => {
                            playBtnClickAnim(target);
                            this.destroyGameplay();
                            tryAgainWindow.destroy(true);
                            this.showInstructionPage();
                        });
                        this.setInputEnabled(false);
                        delayedCall(3000, () => {
                            setPageBackground("bg-blue");
                            this.add(tryAgainWindow);
                            tryAgainWindow.show(score, starScore);
                            this.bgMusic.stop();
                        });
                    };
                    this.gameplay = gameplay;
                    window["gs"] = this;
                    this._gameStage = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2, game.scale.height / 2, 'BG');
                    this._gameStage.setOrigin(0.5, 0.5);
                    this._gameStage.setScale(1.02);
                    //this._gameStage.setInteractive();
                    this.add(this._gameStage);
                    this._btnClose = new Phaser.GameObjects.Image(this.scene, 1025 - 105, 100 - 50, 'x Button');
                    this._btnClose.setInteractive({ cursor: 'pointer' });
                    this._btnClose["defScale"] = this._btnClose.scale;
                    setupButtonTextureBased(this._btnClose, 'x Button', 'x Button HOVER EFFECT');
                    this.add(this._btnClose);
                    this._btnClose.on('pointerup', () => {
                        playBtnClickAnim(this._btnClose);
                        this.onCloseClick();
                    });
                    this._btnSound = new Phaser.GameObjects.Image(this.scene, 160 - 105, 100 - 50, 'Sound');
                    this._btnSound.setInteractive({ cursor: 'pointer' });
                    this._btnSound["defScale"] = this._btnSound.scale;
                    setupButtonTextureBased(this._btnSound, 'Sound', 'Sound HOVER EFFECT');
                    this.add(this._btnSound);
                    this._btnSound.on('pointerup', () => {
                        playBtnClickAnim(this._btnSound);
                        this.onSoundClick();
                    });
                }
                playCorrectAudio() {
                    if (this.correctAudio) {
                        this.correctAudio.stop();
                    }
                    this.correctAudio = this.scene.sound.add(this.gameplay.currentWordData["audioKey"]);
                    this.correctAudio.play();
                    if (this.areYouSureWindow && this.areYouSureWindow.parentContainer == this) {
                        this.correctAudio.pause();
                    }
                }
                onSoundClick() {
                    this.playCorrectAudio();
                }
                destroyIdleDelayedCallIfExists() {
                    if (this.idleDelayedCall != null) {
                        destroyDelayedCall(this.idleDelayedCall);
                        this.idleDelayedCall = null;
                    }
                }
                showGameplay() {
                    setPageBackground("bg-australia");
                    this.bgMusic = this.scene.sound.add("Bachground ambience");
                    this.bgMusic.play();
                    this.bgMusic.loop = true;
                    this.gameplayContainer = new Phaser.GameObjects.Container(this.scene);
                    this.addAt(this.gameplayContainer, this.getIndex(this._btnClose));
                    this.gameplay.reset();
                    this.createRounds();
                    this.prepareRound();
                    this.gameplay.setupCallbacks(this.showCompleteWindow, this.showLoseWindow, () => {
                        this.onNewRound(true);
                    });
                }
                createRounds() {
                    this.gameplayContainer.removeAll();
                    this.character = this.scene.add.sprite(205, 435, null);
                    this.playIdle();
                    this.gameplayContainer.add(this.character);
                    let randomized = this.gameplay.allWorlds.slice(); //Phaser.Utils.Array.Shuffle(this.gameplay.allWorlds.slice());
                    this.words = [];
                    let positions = [
                        { x: 68, y: 174 }, { x: 235, y: 72 }, { x: 461, y: 98 }, { x: 367, y: 253 }, { x: 674, y: 52 }, { x: 605, y: 226 }, { x: 429, y: 416 }, { x: 654, y: 390 }
                    ];
                    for (let i = 0; i < randomized.length; i++) {
                        let w = new Phaser.GameObjects.Container(this.scene, positions[i]['x'] + 20 + 83, positions[i]['y'] + 23 + 65);
                        w.add(w["-image-"] = this.scene.add.sprite(0, 0, null));
                        w["-image-"].setOrigin(0.5, 0.5);
                        this.words.push(w);
                        let txt;
                        if (this.gameplay.useImages) {
                            txt = new Phaser.GameObjects.Image(this.scene, 0, 0, randomized[i]["word"]);
                            w.add(txt);
                        }
                        else {
                            txt = this.scene.add.text(0, 10, "", {
                                "fontFamily": "QuranErafont",
                                "fontSize": 55,
                                "color": "#000000",
                                "align": 'center'
                            });
                            txt.setOrigin(0.5, 0.5);
                            txt.style.fixedHeight = 75;
                            txt.setText(randomized[i]["word"] + ' ');
                            w.add(txt);
                        }
                        w["-letter-"] = txt;
                        w["-word-text-"] = randomized[i]["word"];
                        this.gameplayContainer.add(w);
                        Preloader.playAnim('bubble_idle', w["-image-"]);
                    }
                    for (let word of this.words) {
                        word.setSize(word["-image-"].width, word["-image-"].height);
                        word.setInteractive({ cursor: 'pointer' });
                        word.on('pointerdown', () => {
                            this.setInputEnabled(false);
                            if (word["-word-text-"] == this.gameplay.currentWordData["word"]) {
                                this.onCorrectAnswer();
                                word.destroy(true);
                                this.showPopBubble(word);
                                // this.fadeBubblesOut();
                                this.tfCorrectAnswerCount.setText(String(this.gameplay.correctAnswersCount));
                            }
                            else {
                                let lost = this.onWrongAnswer();
                                this.shakeBubble(word);
                                delayedCall(500, () => {
                                    this.destroyIdleDelayedCallIfExists();
                                    Preloader.playAnim('turtle_shock_in', this.character, () => {
                                        delayedCall(800, () => {
                                            Preloader.playAnim('turtle_shock_out', this.character, this.playIdle);
                                        });
                                    });
                                    this.scene.sound.add("Turtle animation sfx").play();
                                });
                                delayedCall(3200, () => {
                                    if (!lost) {
                                        this.setInputEnabled(true);
                                    }
                                });
                                this.tfWrongAnswerCount.setText(String(this.gameplay.wrongAnswersCount));
                            }
                        });
                    }
                    this._btnClose.setInteractive({ cursor: 'pointer', pixelPerfect: true });
                    this.setInputEnabled(false);
                    this.tfCorrectAnswerCount = this.scene.add.text(game.scale.width / 2 - 118, 29, "0", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 20,
                        "color": "#FFFFFF",
                        "align": 'center'
                    });
                    this.gameplayContainer.add(this.tfCorrectAnswerCount);
                    this.tfWrongAnswerCount = this.scene.add.text(game.scale.width / 2 - 26, 29, "0", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 20,
                        "color": "#FFFFFF",
                        "align": 'center'
                    });
                    this.gameplayContainer.add(this.tfWrongAnswerCount);
                    this.tfTimer = this.scene.add.text(game.scale.width / 2 + 73, 29, "00:00", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 20,
                        "color": "#FFFFFF",
                        "align": 'center'
                    });
                    this.gameplayContainer.add(this.tfTimer);
                    let seconds = 120;
                    this.renderTimer(seconds);
                    this.timerEvent = this.scene.time.addEvent({ delay: 1000, repeat: seconds });
                    this.timerEvent.callback = () => {
                        if (this.timerEvent.repeatCount == 0) {
                            this.showLoseWindow(0, 0);
                        }
                        this.renderTimer(this.timerEvent.repeatCount);
                    };
                }
                renderTimer(seconds) {
                    let sec = seconds % 60;
                    let min = Math.round((seconds - sec) / 60);
                    this.tfTimer.setText((min < 10 ? '0' + min : min)
                        + ":" +
                        (sec < 10 ? '0' + sec : sec));
                }
                showPopBubble(bubble) {
                    let bubble_poping = this.scene.add.sprite(bubble.x, bubble.y, null);
                    this.gameplayContainer.add(bubble_poping);
                    Preloader.playAnim('bubble_poping', bubble_poping, () => {
                        if (bubble_poping.parentContainer)
                            bubble_poping.parentContainer.remove(bubble_poping);
                    });
                }
                shakeBubble(bubble) {
                    this.scene.tweens.add({
                        targets: bubble,
                        x: bubble.x - 5,
                        duration: 100,
                        yoyo: true,
                        repeat: 5
                    });
                    this.scene.tweens.add({
                        targets: bubble,
                        y: bubble.y + 5,
                        duration: 70,
                        yoyo: true,
                        repeat: 5
                    });
                }
                addIdleAnim(bubble) {
                    this.scene.tweens.add({
                        targets: bubble,
                        "scaleX": 0.95,
                        duration: 1000,
                        yoyo: true,
                        repeat: -1
                    });
                    this.scene.tweens.add({
                        targets: bubble,
                        "scaleY": 0.97,
                        duration: 800,
                        yoyo: true,
                        repeat: -1
                    });
                }
                prepareRound() {
                    delayedCall(750, () => {
                        this.playCorrectAudio();
                        delayedCall(750, () => { this.setInputEnabled(true); });
                    });
                }
                onNewRound(showOut) {
                    this.setInputEnabled(false);
                    if (showOut) {
                        this.prepareRound();
                    }
                }
                onCorrectAnswer() {
                    let i = this.gameplay.getCurrentTotalAnswersCount();
                    let completed = this.gameplay.onCorrectAnswer();
                    this.scene.sound.add(this.sfxBubblePopCounter++ % 2 == 0 ? 'Bubble Pop 1' : 'Bubble Pop 2').play();
                    return completed;
                }
                onWrongAnswer() {
                    let i = this.gameplay.getCurrentTotalAnswersCount();
                    let lost = this.gameplay.onWrongAnswer();
                    this.scene.sound.add("Wrong click").play();
                    this.destroyIdleDelayedCallIfExists();
                    if (!lost)
                        delayedCall(2500, () => { this.playCorrectAudio(); });
                    return lost;
                }
                onCloseClick() {
                    this.showAreYouSurePage();
                    this.scene.sound.add('warning page pop up sfx').play();
                }
                showInstructionPage() {
                    setPageBackground("bg-blue");
                    let playInstructionSound = () => {
                        if (this.wfsnd) {
                            this.wfsnd.stop();
                        }
                        this.wfsnd = this.scene.sound.add("Help Salty");
                        this.wfsnd.play();
                    };
                    this.instructionPage = new screen.InstructionPage(this.scene, (target) => {
                        playBtnClickAnim(target);
                        this.instructionPage.destroy(true);
                        this.showGameplay();
                        if (this.wfsnd) {
                            this.wfsnd.stop();
                        }
                    }, (target) => {
                        playBtnClickAnim(target);
                        playInstructionSound();
                    });
                    this.add(this.instructionPage);
                    try {
                        playInstructionSound();
                    }
                    catch (e) {
                        console.error(e);
                    }
                }
                showAreYouSurePage() {
                    pauseAllDelayedCalls();
                    setPageBackground("bg-blue");
                    this.scene.tweens.pauseAll();
                    this.pauseSounds();
                    this.areYouSureWindow = new screen.AreYouSureWindow(this.scene, () => {
                        this.scene.tweens.resumeAll();
                        this.areYouSureWindow.destroy(true);
                        this.destroyGameplay();
                        this.showInstructionPage();
                    }, () => {
                        this.scene.tweens.resumeAll();
                        this.areYouSureWindow.destroy(true);
                        this.unpauseSounds();
                        resumeAllDelayedCalls();
                        setPageBackground("bg-australia");
                    });
                    this.add(this.areYouSureWindow);
                }
                setInputEnabled(enabled) {
                    if (enabled) {
                        for (let a of this.words)
                            if (a.parentContainer)
                                a.setInteractive({ cursor: 'pointer' });
                    }
                    else {
                        for (let a of this.words)
                            a.disableInteractive();
                    }
                }
                pauseSounds() {
                    this.scene.sound.pauseAll();
                }
                unpauseSounds() {
                    this.scene.sound.resumeAll();
                }
                destroyGameplay() {
                    this.setInputEnabled(false);
                    this.remove(this.gameplayContainer);
                    this.scene.sound.stopAll();
                    destroyAllDelayedCalls();
                }
            }
            screen.GameplayScreen = GameplayScreen;
        })(screen = ctb.screen || (ctb.screen = {}));
    })(ctb || (ctb = {}));
    var ctb;
    (function (ctb) {
        var screen;
        (function (screen) {
            class InstructionPage extends Phaser.GameObjects.Container {
                constructor(scene, onPlayClick, onSndClick) {
                    super(scene);
                    this._instructionPage = new Phaser.GameObjects.Image(this.scene, 0 - 105, 0 - 48, 'Instructions page  ALL ACTIVITY  TITLEs');
                    this._instructionPage.setOrigin(0, 0);
                    //this._instructionPage.setInteractive();
                    this._instructionPageTitle = new Phaser.GameObjects.Image(this.scene, 495, 105, 'pop-the-bubbles-title');
                    this._instructionPageTitle.setScale(0.65);
                    this._btnPlay = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2, 480 - 50, 'btnPLAY1');
                    this._btnPlay.setInteractive({ cursor: 'pointer' });
                    this._btnPlay.once('pointerup', onPlayClick);
                    setupButtonTextureBased(this._btnPlay, 'btnPLAY1', 'btnPLAY2');
                    this.instrTxt = this.scene.add.text(game.scale.width / 2, game.scale.height / 2, "Help Salty Turtle pop all the word bubbles.\nListen to the word and tap on the bubble.", {
                        "fontFamily": "Kids Rock DEMO",
                        "fontSize": 30,
                        "color": "#43425D",
                        "align": 'center'
                    });
                    this.instrTxt.setOrigin(0.5, 0.5);
                    this.instrTxt.setWordWrapWidth(710);
                    this.instrTxt.setLineSpacing(10);
                    this._btnSoundInstruction = new Phaser.GameObjects.Image(this.scene, 800 - 105, 156 - 50, 'Sound');
                    this._btnSoundInstruction.setInteractive({ cursor: 'pointer' });
                    this._btnSoundInstruction.on('pointerup', onSndClick);
                    this._btnSoundInstruction["defScale"] = this._btnSoundInstruction.scale;
                    setupButtonTextureBased(this._btnSoundInstruction, 'Sound', 'Sound HOVER EFFECT');
                    this.add(this._instructionPage);
                    this.add(this._instructionPageTitle);
                    this.add(this.instrTxt);
                    this.add(this._btnPlay);
                    this.add(this._btnSoundInstruction);
                }
            }
            screen.InstructionPage = InstructionPage;
        })(screen = ctb.screen || (ctb.screen = {}));
    })(ctb || (ctb = {}));
    var ctb;
    (function (ctb) {
        var screen;
        (function (screen) {
            class TryAgainWindow extends Phaser.GameObjects.Container {
                constructor(scene, onBack, onReplay) {
                    super(scene);
                    this.music = null;
                    this.setPosition(-106, -48);
                    this._bg = new Phaser.GameObjects.Image(this.scene, 0, 0, 'Try again page');
                    this._bg.setOrigin(0, 0);
                    //this._bg.setInteractive();
                    this._star = new Phaser.GameObjects.Image(this.scene, 400, 415, 'Break Star');
                    this._btnBack = new Phaser.GameObjects.Image(this.scene, 600, 580, 'btnBACK1');
                    this._btnReplay = new Phaser.GameObjects.Image(this.scene, 765, 580, 'btnReplay1');
                    this.totalScoreTxt = this.scene.add.text(830, 355, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 35,
                        "color": "#F49F1C",
                        "align": 'center',
                        'stroke': '#70451A',
                        'strokeThickness': 6
                    });
                    this.totalScoreTxt.setOrigin(0.5, 0.5);
                    let grd = this.totalScoreTxt.context.createLinearGradient(0, 0, 0, this.totalScoreTxt.height);
                    grd.addColorStop(0, '#FFFF00');
                    grd.addColorStop(1, '#C17316');
                    this.totalScoreTxt.setFill(grd);
                    this.starScoreTxt = this.scene.add.text(635, 431, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 24,
                        "color": "#FFFFFF",
                        "align": 'center'
                    });
                    this.starScoreTxt.setOrigin(0.5, 0.5);
                    this.add([
                        this._bg,
                        this._star,
                        this._btnBack,
                        this._btnReplay,
                        this.totalScoreTxt,
                        this.starScoreTxt
                    ]);
                    this._btnBack.setInteractive({ cursor: 'pointer' });
                    this._btnBack.on('pointerup', () => {
                        onBack(this._btnBack);
                        window.angularComponentRef.backToMenu();
                        // if (this.music) {
                        //     this.music.stop();
                        // }
                    });
                    setupButtonTextureBased(this._btnBack, 'btnBACK1', 'btnBACK2');
                    this._btnReplay.setInteractive({ cursor: 'pointer' });
                    this._btnReplay.once('pointerup', () => {
                        onReplay(this._btnReplay);
                        if (this.music) {
                            this.music.stop();
                        }
                    });
                    setupButtonTextureBased(this._btnReplay, 'btnReplay1', 'btnReplay2');
                }
                show(score, starScore) {
                    this._star.scale = 1.25;
                    this.scene.tweens.add({
                        targets: this._star,
                        "scale": 1,
                        duration: 500,
                        ease: Phaser.Math.Easing.Back.Out
                    });
                    this.totalScoreTxt.text = String(window.angularComponentRef.component.userInfo.totalScore);
                    this.starScoreTxt.text = String(starScore);
                    this.music = this.scene.sound.add("Fail - close one");
                    this.music.play();
                }
            }
            screen.TryAgainWindow = TryAgainWindow;
        })(screen = ctb.screen || (ctb.screen = {}));
    })(ctb || (ctb = {}));

    game = new ctb.App();
};

var destroyPopTheBubbles = () => {
    if (game) {
        game.destroy();
        game = null;
    }
}

var ctb;
var game;
var demolishTheBuilding = (json) => {
    (function (ctb) {
        class App extends Phaser.Game {
            constructor() {
                console.warn("UNCOMMENT BELOW!");
                App.json = json;

                let config = {
                    type: Phaser.AUTO,
                    width: App.CANVAS_WIDTH,
                    height: App.CANVAS_HEIGHT,
                    parent: 'game-container',
                    dom: {
                        createContainer: false
                    },
                    scale: {
                        mode: FitScaleManager.detectBestScaleMode(),
                        autoCenter: Phaser.Scale.CENTER_BOTH
                    },
                    transparent: true,
                    scene: {
                        create: () => {
                            this.scene.add('Boot', ctb.scene.Boot, true);
                        }
                    }
                };
                super(config);
            }
        }
        App.CANVAS_WIDTH = 980;
        App.CANVAS_HEIGHT = 600;
        ctb.App = App;
    })(ctb || (ctb = {}));
    var delayedCalls = [];
    function delayedCall(delay, callback, args, callbackScope) {
        let scene = game.scene.getAt(0);
        if (scene) {
            let dc = scene.time.delayedCall(delay, callback, args, callbackScope);
            delayedCalls.push(dc);
            return dc;
        }
        let t = setTimeout(callback, delay);
        delayedCalls.push(t);
        return t;
    }
    function pauseAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.paused = true;
            }
        }
    }
    function resumeAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.paused = false;
            }
        }
    }
    function destroyAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.remove(false);
            }
            else {
                clearTimeout(dc);
            }
        }
        delayedCalls = [];
    }
    function destroyDelayedCall(dc) {
        if (dc instanceof Phaser.Time.TimerEvent) {
            dc.remove(false);
        }
        else {
            clearTimeout(dc);
        }
        let ind = delayedCalls.indexOf(dc);
        if (ind >= 0)
            delayedCalls.splice(ind, 1);
    }
    function setPageBackground(bg) {
    }
    function setupButton(btn, frame) {
        btn.on('pointerdown', () => { btn.setFrame(frame + '_hover' + '0000'); });
        btn.on('pointerover', () => { btn.setFrame(frame + '_hover' + '0000'); game.scene.getAt(0).sound.add("button hover").play(); });
        btn.on('pointerout', () => { btn.setFrame(frame + '0000'); });
        btn.on('pointerup', () => { btn.setFrame(frame + '0000'); game.scene.getAt(0).sound.add('activity selection - button selection').play(); });
    }
    function setupButtonTextureBased(btn, texture, hoverTexture) {
        btn.on('pointerdown', () => { btn.setTexture(hoverTexture); });
        btn.on('pointerover', () => { btn.setTexture(hoverTexture); game.scene.getAt(0).sound.add("button hover").play(); });
        btn.on('pointerout', () => { btn.setTexture(texture); });
        btn.on('pointerup', () => {
            if (btn.parentContainer)
                btn.setTexture(texture); game.scene.getAt(0).sound.add('activity selection - button selection').play();
        });
    }
    function playBtnClickAnim(target) {
        let sc = target.hasOwnProperty("defScale") ? target["defScale"] : 1;
        target.scaleX = target.scaleY = sc;
        let scene = game.scene.getAt(0);
        scene.tweens.add({
            targets: target,
            "scaleX": 0.9 * sc,
            "scaleY": 0.9 * sc,
            duration: 100,
            yoyo: true
        });
    }
    /**
     * @author Roman Parada
     * This class is created to fix overlapping of bottom part of canvas by navigation bar in iOS.
     * It make a delayed resize of the canvas (like Phaser-3 FIT methods does) and it overrides Phaser-3 input window to Phaser-3 core transform methods
     *
     * How to use:
     * Just call the code line below in Boot scene's init() method of your project:
     * new FitScaleManager(this.game).setup();
     */
    class FitScaleManager {
        constructor(game) {
            this.doResize = () => {
                let scale = this.calculateScale();
                let newCanvasWidth = this.phaserScaleManager.width * scale;
                let newCanvasHeight = this.phaserScaleManager.height * scale;
                this.canvasStyle.width = newCanvasWidth + 'px';
                this.canvasStyle.height = newCanvasHeight + 'px';
                this.canvasStyle.marginLeft = (window.innerWidth - newCanvasWidth) / 2 + 'px';
                this.canvasStyle.marginTop = (window.innerHeight - newCanvasHeight) / 2 + 'px';
            };
            this.game = game;
            this.canvasStyle = this.game.canvas.style;
            this.phaserScaleManager = this.game.scale;
        }
        static detectBestScaleMode() {
            let iOS = /iPad|iPhone|iPod/.test(navigator.platform || "");
            let isAndroid = window.navigator.userAgent.toLowerCase().indexOf("android") > -1;
            return iOS || isAndroid ? Phaser.Scale.FIT : Phaser.Scale.NONE;
        }
        ;
        /**
         * Just call this method once in Boot scene's init() method
         */
        setup() {
            this.phaserScaleManager.addListener(Phaser.Scale.Events.RESIZE, this.onResize, this);
            this.overridePhaserTransformMethods();
            this.onResize();
        }
        calculateScale() {
            if (game.scale.scaleMode == Phaser.Scale.NONE)
                return 1;
            return Math.min(window.innerWidth / this.phaserScaleManager.width, window.innerHeight / this.phaserScaleManager.height);
        }
        overridePhaserTransformMethods() {
            this.game.scale.transformX = (pageX) => {
                return (pageX - parseInt(this.canvasStyle.marginLeft.split("px")[0])) / this.calculateScale();
            };
            this.game.scale.transformY = (pageY) => {
                return (pageY - parseInt(this.canvasStyle.marginTop.split("px")[0])) / this.calculateScale();
            };
        }
        onResize() {
            setTimeout(this.doResize, FitScaleManager.RESIZE_DELAY);
        }
    }
    FitScaleManager.RESIZE_DELAY = 500;
    var ctb;
    (function (ctb) {
        var core;
        (function (core) {
            class Gameplay {
                constructor() {
                    this.currentRound = 0;
                    this.correctAnswersCount = 0;
                    this.wrongAnswersCount = 0;
                    this.correctAnswersCountThisRound = 0;
                    this.wrongAnswersCountThisRound = 0;
                    this.onNewRound = null;
                    this.nextLetterDelay = 0;
                    this.failsNumToLose = Number(game.cache.json.get('gameplay')["failsNumToLose"]);
                    this.numberOfQuestionsPerRound = 1;
                    this.useImages = Boolean(game.cache.json.get('gameplay')["useImages"]);
                }
                setupCallbacks(onComplete, onLose, onNewRound) {
                    this.onComplete = onComplete;
                    this.onLose = onLose;
                    this.onNewRound = onNewRound;
                }
                calculateScore() {
                    return this.totalRoundsNum - this.wrongAnswersCount;
                }
                onLetterChosen(proceedNextRoundAllowed) {
                    if (this.isNewRound()) {
                        if (this.correctAnswersCount >= this.totalRoundsNum) {
                            this.onComplete(this.correctAnswersCount, this.correctAnswersCount);
                            return true;
                        }
                        else {
                            if (proceedNextRoundAllowed) this.nextLetter();
                        }
                    }
                    return false;
                }
                nextLetter() {
                    let fn = () => {
                        this.currentWordData = Phaser.Utils.Array.RemoveRandomElement(this.words);
                        this.correctAnswersCountThisRound = 0;
                        this.wrongAnswersCountThisRound = 0;
                        if (this.onNewRound)
                            this.onNewRound();
                    };
                    if (this.nextLetterDelay == 0) {
                        fn();
                    }
                    else {
                        delayedCall(this.nextLetterDelay, fn);
                    }
                }
                onCorrectAnswer(delay) {
                    this.correctAnswersCount++;
                    this.correctAnswersCountThisRound++;
                    this.nextLetterDelay = delay || 2800;
                    return this.onLetterChosen(true);
                }
                onWrongAnswer() {
                    this.wrongAnswersCount++;
                    this.wrongAnswersCountThisRound++;
                    this.nextLetterDelay = 0;
                    if (this.wrongAnswersCount >= this.failsNumToLose) {
                        this.onLose(0, 0);
                        return true;
                    }
                    else {
                        this.onLetterChosen(false);
                    }
                    return false;
                }
                getMaxTotalAnswersCount() {
                    return this.failsNumToLose + this.totalRoundsNum - 1;
                }
                getCurrentTotalAnswersCount() {
                    return this.correctAnswersCount + this.wrongAnswersCount;
                }
                getCurrentTotalAnswersCountThisRound() {
                    return this.correctAnswersCountThisRound + this.wrongAnswersCountThisRound;
                }
                isNewRound() {
                    return this.getCurrentTotalAnswersCount() % this.numberOfQuestionsPerRound == 0;
                }
                isRoundsComplete() {
                    return this.wrongAnswersCount >= this.failsNumToLose || this.correctAnswersCount >= this.totalRoundsNum;
                }
                reset() {
                    this.nextLetterDelay = 0;
                    this.setupCallbacks(null, null, null);
                    let json = game.cache.json.get('gameplay');
                    this.words = json["words"].slice();
                    this.allWorlds = json["words"].slice();
                    this.totalRoundsNum = this.words.length;
                    this.nextLetter();
                    this.currentRound = 0;
                    this.correctAnswersCount = 0;
                    this.wrongAnswersCount = 0;
                    this.correctAnswersCountThisRound = 0;
                    this.wrongAnswersCountThisRound = 0;
                }
            }
            core.Gameplay = Gameplay;
        })(core = ctb.core || (ctb.core = {}));
    })(ctb || (ctb = {}));
    var ctb;
    (function (ctb) {
        var scene;
        (function (scene) {
            class Boot extends Phaser.Scene {
                init() {
                    this.game.scale.transformX = (pageX) => {
                        let offsetLeft = 0;
                        let parentElement = game.canvas.parentElement;
                        while (parentElement) {
                            if (parentElement.offsetLeft) {
                                offsetLeft = parentElement.offsetLeft;
                                break;
                            }
                            parentElement = parentElement.parentElement;
                        }
                        return (pageX - offsetLeft) * this.game.scale.displayScale.x;
                    };
                    this.game.scale.transformY = (pageY) => {
                        let offsetTop = 0;
                        let parentElement = game.canvas.parentElement;
                        while (parentElement) {
                            if (parentElement.offsetTop) {
                                offsetTop = parentElement.offsetTop;
                                break;
                            }
                            parentElement = parentElement.parentElement;
                        }
                        return (pageY - offsetTop) * this.game.scale.displayScale.y;
                    };
                }
                create() {
                    game.scene.remove('Boot');
                    game.scene.add('Preloader', ctb.scene.Preloader, true);
                }
            }
            scene.Boot = Boot;
        })(scene = ctb.scene || (ctb.scene = {}));
    })(ctb || (ctb = {}));
    var ctb;
    (function (ctb) {
        var scene;
        (function (scene) {
            var Gameplay = ctb.core.Gameplay;
            class MainScene extends Phaser.Scene {
                create() {
                    this.gameplay = new Gameplay();
                    this.gameplayScreen = new ctb.screen.GameplayScreen(this, this.gameplay);
                    this.children.add(this.gameplayScreen);
                    this.gameplayScreen.showInstructionPage();
                }
            }
            scene.MainScene = MainScene;
        })(scene = ctb.scene || (ctb.scene = {}));
    })(ctb || (ctb = {}));
    var ctb;
    (function (ctb) {
        var scene;
        (function (scene) {
            class Preloader extends Phaser.Scene {
                preload() {
                    if (typeof ctb.App.json == "string") this.load.json('gameplay', ctb.App.json); else this.game.cache.json.add('gameplay', ctb.App.json);
                }
                create() {
                    let json = game.cache.json.get('gameplay');
                    if (json["useImages"]) {
                        for (let w of json["words"]) {
                            if (w["imageKey"].includes('http')) {
                                this.load.image(w["word"], w["imageKey"]);
                            } else {
                                this.load.image(w["word"], "assets/games/demolish-building/imgs/words/" + w["imageKey"] + ".png");
                            }
                        }
                    }
                    for (let w of json["words"]) {
                        if (w["audioKey"].includes('http')) {
                            this.load.audio(w["audioKey"], w["audioKey"]);
                        } else {
                            this.load.audio(w["audioKey"], "assets/games/demolish-building/sound/mp3/words/" + w["audioKey"] + ".mp3");
                        }
                    }
                    let progressTxt = this.add.text(game.scale.width / 2, game.scale.height / 2 + 50, "", {
                        "fontFamily": "QuranErafont",
                        "fontSize": 25,
                        "color": "#000000",
                        "align": 'center'
                    });
                    progressTxt.setOrigin(0.5, 0.5);
                    this.load.pack('preloader', 'assets/games/demolish-building/pack.json');
                    this.load.on('progress', (value) => {
                        progressTxt.text = Math.ceil(value * 100) + "%";
                    }, this);
                    this.load.on('complete', () => {
                        this.nextScene();
                    });
                    this.load.start();
                }
                static playAnim(animKey, sprite, onComplete = null) {
                    let mainScene = game.scene.getScene('ScreenMain');
                    if (!mainScene.anims.exists(animKey)) {
                        let data = Preloader.ANIMS_DATA[animKey];
                        mainScene.anims.create({
                            key: animKey,
                            frames: mainScene.anims.generateFrameNames(data['atlas'], {
                                start: data['start'], end: data['end'], zeroPad: data['padNum'],
                                prefix: data['prefix'], suffix: ''
                            }),
                            frameRate: data['frameRate'],
                            repeat: data['repeat']
                        });
                    }
                    if (sprite.anims.currentAnim) {
                        sprite.off('animationcomplete');
                    }
                    sprite.anims.stop();
                    sprite.play(animKey);
                    sprite.on('animationcomplete', () => {
                        if (onComplete)
                            onComplete();
                    });
                    return sprite;
                }
                nextScene() {
                    game.scene.remove('Preloader');
                    game.scene.add('ScreenMain', ctb.scene.MainScene, true);
                }
            }
            Preloader.ANIMS_DATA = {
                'building_collapse': {
                    'start': 1,
                    'end': 60,
                    'padNum': 4,
                    'prefix': 'Building collapse ',
                    'repeat': 0,
                    'frameRate': 24,
                    'atlas': 'building_collapse'
                },
                'snake_idle': {
                    'start': 1,
                    'end': 72,
                    'padNum': 4,
                    'prefix': 'Iddle',
                    'repeat': 0,
                    'frameRate': 24,
                    'atlas': 'snake_idle'
                },
                'snake_nahh': {
                    'start': 8,
                    'end': 72,
                    'padNum': 4,
                    'prefix': 'Naahh v5 ',
                    'repeat': 0,
                    'frameRate': 24,
                    'atlas': 'snake_idle'
                },
                'window_smash': {
                    'start': 1,
                    'end': 42,
                    'padNum': 4,
                    'prefix': 'windows Smash ',
                    'repeat': 0,
                    'frameRate': 24,
                    'atlas': 'window_smash'
                },


                'bubble_idle': {
                    'start': 0,
                    'end': 50,
                    'padNum': 4,
                    'prefix': 'idle',
                    'repeat': -1,
                    'frameRate': 24,
                    'atlas': 'bubble-atlas'
                },
            };
            scene.Preloader = Preloader;
        })(scene = ctb.scene || (ctb.scene = {}));
    })(ctb || (ctb = {}));
    var ctb;
    (function (ctb) {
        var screen;
        (function (screen) {
            class AreYouSureWindow extends Phaser.GameObjects.Container {
                constructor(scene, onYes, onNo) {
                    super(scene);
                    this._areYouSurePage = new Phaser.GameObjects.Image(this.scene, -105, 0 - 48, 'Exit warning');
                    this._areYouSurePage.setOrigin(0, 0);
                    //this._areYouSurePage.setInteractive();
                    this._btnSureYes = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2 - 95, 485 - 50, 'btnYES1');
                    this._btnSureYes.setInteractive({ cursor: 'pointer' });
                    this._btnSureYes.once('pointerup', () => {
                        onYes;
                        window.angularComponentRef.backToMenu();
                    });
                    var modalTextStyle = {
                        backgroundColor: 'transparent',
                        stroke: '#ffffff',
                        strokeThickness: 2,
                        lineSpacing: 15,
                        fontFamily: 'Kids Rock DEMO',
                        fontSize: 27,
                        color: '#43425d',
                        wordWrap: true,
                        align: 'center'
                    };
                    var modalText = this.scene.add.text(game.scale.width / 2 + 12, game.scale.height / 2, "Your progress in this activity will not be saved. \n Are you sure you want to exit? ", modalTextStyle);
                    modalText.setOrigin(0.5, 0.5);


                    setupButtonTextureBased(this._btnSureYes, 'btnYES1', 'btnYES2');
                    this._btnSureNo = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2 + 95, 485 - 50, 'btnNO1');
                    this._btnSureNo.setInteractive({ cursor: 'pointer' });
                    this._btnSureNo.once('pointerup', onNo);
                    setupButtonTextureBased(this._btnSureNo, 'btnNO1', 'btnNO2');
                    this.add(this._areYouSurePage);
                    this.add(this._btnSureYes);
                    this.add(this._btnSureNo);
                    this.add(modalText);

                }
            }
            screen.AreYouSureWindow = AreYouSureWindow;
        })(screen = ctb.screen || (ctb.screen = {}));
    })(ctb || (ctb = {}));
    var ctb;
    (function (ctb) {
        var screen;
        (function (screen) {
            class CompleteWindow extends Phaser.GameObjects.Container {
                constructor(scene, onBack, onReplay, onNext) {
                    super(scene);
                    this.music = null;
                    this.setPosition(-104.5, -48);
                    this._bgComplete = new Phaser.GameObjects.Image(this.scene, 0, 0, 'Completion page LATEST UPDATED');
                    this._bgComplete.setOrigin(0, 0);
                    //this._bgComplete.setInteractive();
                    this._cup = new Phaser.GameObjects.Image(this.scene, 400, 410, 'Trophy');
                    this._btnBack = new Phaser.GameObjects.Image(this.scene, 570, 570, 'btnBACK1');
                    this._btnReplay = new Phaser.GameObjects.Image(this.scene, 720, 570, 'btnReplay1');
                    this._btnNext = new Phaser.GameObjects.Image(this.scene, 870, 570, 'btnNEXT1');
                    let _CollectedPoints = new Phaser.GameObjects.Image(this.scene, 620, 440, 'Collected Points');
                    this.totalScoreTxt = this.scene.add.text(845, 352, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 35,
                        "color": "#F49F1C",
                        "align": 'center',
                        'stroke': '#70451A',
                        'strokeThickness': 6
                    });
                    this.totalScoreTxt.setOrigin(0.5, 0.5);
                    let grd = this.totalScoreTxt.context.createLinearGradient(0, 0, 0, this.totalScoreTxt.height);
                    grd.addColorStop(0, '#FFFF00');
                    grd.addColorStop(1, '#C17316');
                    this.totalScoreTxt.setFill(grd);
                    this.starScoreTxt = this.scene.add.text(648, 433, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 24,
                        "color": "#FFFFFF",
                        "align": 'center'
                    });
                    this.starScoreTxt.setOrigin(0.5, 0.5);
                    this.add([
                        this._bgComplete,
                        _CollectedPoints,
                        this._cup,
                        this._btnBack,
                        this._btnReplay,
                        this._btnNext,
                        this.totalScoreTxt,
                        this.starScoreTxt
                    ]);
                    this._btnBack.setInteractive({ cursor: 'pointer' });
                    this._btnBack.on('pointerup', () => {
                        onBack(this._btnBack);
                        window.angularComponentRef.backToMenu();
                        // if (this.music) {
                        //     this.music.stop();
                        // }
                    });
                    setupButtonTextureBased(this._btnBack, 'btnBACK1', 'btnBACK2');
                    this._btnReplay.setInteractive({ cursor: 'pointer' });
                    this._btnReplay.once('pointerup', () => {
                        onReplay(this._btnReplay);
                        if (this.music) {
                            this.music.stop();
                        }
                    });
                    setupButtonTextureBased(this._btnReplay, 'btnReplay1', 'btnReplay2');
                    this._btnNext.setInteractive({ cursor: 'pointer' });
                    this._btnNext.on('pointerup', () => {
                        onNext(this._btnNext);
                        window.angularComponentRef.nextActivity();
                        // if (this.music) {
                        //     this.music.stop();
                        // }
                    });
                    setupButtonTextureBased(this._btnNext, 'btnNEXT1', 'btnNEXT2');
                }
                show(score, starScore) {
                    window.angularComponentRef.gameFinish({ score, starScore })
                    this._cup.scale = 1.25;
                    this.scene.tweens.add({
                        targets: this._cup,
                        "scale": 1,
                        duration: 500,
                        ease: Phaser.Math.Easing.Back.Out
                    });
                    this.totalScoreTxt.text = String(window.angularComponentRef.component.userInfo.totalScore);
                    this.starScoreTxt.text = String(starScore);
                    // let music = this.scene.sound.add("viktory");
                    this.music = this.scene.sound.add("Activity completion fantastic");
                    this.music.play();
                }
            }
            screen.CompleteWindow = CompleteWindow;
        })(screen = ctb.screen || (ctb.screen = {}));
    })(ctb || (ctb = {}));
    var ctb;
    (function (ctb) {
        var screen;
        (function (screen) {
            var Preloader = ctb.scene.Preloader;
            class GameplayScreen extends Phaser.GameObjects.Container {
                constructor(scene, gameplay) {
                    super(scene);
                    this.bgMusic = null;
                    this.correctAudio = null;
                    this.idleDelayedCall = null;
                    this.playIdle = () => {
                        Preloader.playAnim('snake_idle', this.character, () => {
                            this.idleDelayedCall = delayedCall(Math.floor(Math.random() * 5) * 500, this.playIdle);
                        });
                    };
                    this.sfxBubblePopCounter = 0;
                    this.wfsnd = null;
                    this.showCompleteWindow = (score, starScore) => {
                        let completeWindow = new screen.CompleteWindow(this.scene, (target) => {
                            playBtnClickAnim(target);
                        }, (target) => {
                            playBtnClickAnim(target);
                            this.destroyGameplay();
                            completeWindow.destroy(true);
                            this.showInstructionPage();
                        }, (target) => {
                            playBtnClickAnim(target);
                        });
                        this.setInputEnabled(false);
                        delayedCall(5500, () => {
                            setPageBackground("bg-blue");
                            this.add(completeWindow);
                            completeWindow.show(score, starScore);
                            this.bgMusic.stop();
                        });
                    };
                    this.showLoseWindow = (score, starScore) => {
                        let tryAgainWindow = new screen.TryAgainWindow(this.scene, (target) => {
                            playBtnClickAnim(target);
                        }, (target) => {
                            playBtnClickAnim(target);
                            this.destroyGameplay();
                            tryAgainWindow.destroy(true);
                            this.showInstructionPage();
                        });
                        this.setInputEnabled(false);
                        delayedCall(3000, () => {
                            setPageBackground("bg-blue");
                            this.add(tryAgainWindow);
                            tryAgainWindow.show(score, starScore);
                            this.bgMusic.stop();
                        });
                    };
                    this.gameplay = gameplay;
                    window["gs"] = this;
                    this._gameStage = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2, game.scale.height / 2, 'BG');
                    this._gameStage.setOrigin(0.5, 0.5);
                    this._gameStage.setScale(1.02);
                    //this._gameStage.setInteractive();
                    this.add(this._gameStage);
                    this._btnClose = new Phaser.GameObjects.Image(this.scene, 1025 - 105, 100 - 50, 'x Button');
                    this._btnClose.setInteractive({ cursor: 'pointer' });
                    this._btnClose["defScale"] = this._btnClose.scale;
                    setupButtonTextureBased(this._btnClose, 'x Button', 'x Button HOVER EFFECT');
                    this.add(this._btnClose);
                    this._btnClose.on('pointerup', () => {
                        playBtnClickAnim(this._btnClose);
                        this.onCloseClick();
                    });
                    this._btnSound = new Phaser.GameObjects.Image(this.scene, 160 - 105, 100 - 50, 'Sound');
                    this._btnSound.setInteractive({ cursor: 'pointer' });
                    this._btnSound["defScale"] = this._btnSound.scale;
                    setupButtonTextureBased(this._btnSound, 'Sound', 'Sound HOVER EFFECT');
                    this.add(this._btnSound);
                    this._btnSound.on('pointerup', () => {
                        playBtnClickAnim(this._btnSound);
                        this.onSoundClick();
                    });
                }
                playCorrectAudio() {
                    if (this.correctAudio) {
                        this.correctAudio.stop();
                    }
                    this.correctAudio = this.scene.sound.add(this.gameplay.currentWordData["audioKey"]);
                    this.correctAudio.play();
                    if (this.areYouSureWindow && this.areYouSureWindow.parentContainer == this) {
                        this.correctAudio.pause();
                    }
                }
                onSoundClick() {
                    this.playCorrectAudio();
                }
                destroyIdleDelayedCallIfExists() {
                    if (this.idleDelayedCall != null) {
                        destroyDelayedCall(this.idleDelayedCall);
                        this.idleDelayedCall = null;
                    }
                }
                showGameplay() {
                    setPageBackground("bg-australia");
                     this.bgMusic = this.scene.sound.add("Bachground ambience");
                     this.bgMusic.play();
                     this.bgMusic.loop = true;
                    this.gameplayContainer = new Phaser.GameObjects.Container(this.scene);
                    this.addAt(this.gameplayContainer, this.getIndex(this._btnClose));
                    this.gameplay.reset();
                    this.createRounds();
                    this.prepareRound();
                    this.gameplay.setupCallbacks(this.showCompleteWindow, this.showLoseWindow, () => {
                        this.onNewRound(true);
                    });
                    this.createTallies();
                }
                createRounds() {
                    this.gameplayContainer.removeAll();

                    window["gs"] = this;

                    this.cranemovingparts = new Phaser.GameObjects.Container(this.scene);
                    this.cranemovingparts.setPosition(975, 440);
                    this.gameplayContainer.add(this.cranemovingparts);
                    window["cranemovingparts"] = this.cranemovingparts;
                    this.cranearrow = new Phaser.GameObjects.Image(this.scene, 0, 0, 'cranearrow');
                    this.cranearrow.setPosition(0, 0);
                    this.cranemovingparts.add(this.cranearrow);
                    this.cranearrow.setOrigin(1, 1);
                    window["cranearrow"] = this.cranearrow;
                    this.chainBall = new Phaser.GameObjects.Container(this.scene);
                    this.chainBall.setPosition(-235, -410);
                    this.cranemovingparts.add(this.chainBall);
                    this.chain = new Phaser.GameObjects.Image(this.scene, 0, 0, 'chain');
                    this.chainBall.add(this.chain);
                    this.chain.setOrigin(0.5, 0);
                    window["this.chainBall"] = this.chainBall;
                    window["chain.png"] = this.chain;
                    this.ball = new Phaser.GameObjects.Image(this.scene, 0, 0, 'ball');
                    this.chainBall.add(this.ball);
                    this.ball.setOrigin(0.5, 0);
                    this.ball.setPosition(0, 265);
                    window["ball"] = this.ball;

                    this.truckCrane = new Phaser.GameObjects.Image(this.scene, 860, 497, 'truck crane');
                    this.gameplayContainer.add(this.truckCrane);
                    this.truckCrane.setPosition(860, 497)
                    window["truck crane.png"] = this.truckCrane;

                    this.character = this.scene.add.sprite(500, 314, null);
                    this.playIdle();
                    this.gameplayContainer.add(this.character);

                    this._Shape835copy = this.scene.add.sprite(783, 469, 'Shape 835 copy');
                    this.gameplayContainer.add(this._Shape835copy);
                    window["this._Shape835copy"] = this._Shape835copy;

                    this.buildingContainer = new Phaser.GameObjects.Container(this.scene);
                    this.buildingContainer.setPosition(0, 0);
                    this.gameplayContainer.add(this.buildingContainer);

                    this.Bldg = new Phaser.GameObjects.Image(this.scene, 495, 311, 'Bldg');
                    this.buildingContainer.add(this.Bldg);
                    window["this.Bldg"] = this.Bldg;

                    this.building_collapse = this.scene.add.sprite(495, 309, null);
                    this.building_collapse.setScale(1.33);
                    this.buildingContainer.add(this.building_collapse);
                    this.building_collapse.visible = false;
                    window["building_collapse"] = this.building_collapse;
                    window["fn"] = () => {
                        Preloader.playAnim('building_collapse', this.building_collapse);
                        this.scene.sound.add("Building collapse").play();
                    }


                    let randomized = this.gameplay.allWorlds.slice(); //Phaser.Utils.Array.Shuffle(this.gameplay.allWorlds.slice());
                    this.words = [];
                    let ballOriginalPosition = { x: 740, y: 375 };
                    let positions = [
                        { x: 152, y: 170 }, { x: 359, y: 170 }, { x: 554, y: 170 },
                        { x: 152, y: 331 }, { x: 359, y: 331 }, { x: 554, y: 331 },
                        { x: 152, y: 486 }, { x: 359, y: 486 }, { x: 554, y: 486 },
                    ];
                    let cranAngles = [
                        { "cranemovingparts": -35, "chainBall": 136 }, { "cranemovingparts": -10, "chainBall": 84 }, { "cranemovingparts": 15, "chainBall": 43 },
                        { "cranemovingparts": -50, "chainBall": 145 }, { "cranemovingparts": -17, "chainBall": 70 }, { "cranemovingparts": -2, "chainBall": 35 },
                        { "cranemovingparts": -55, "chainBall": 131 }, { "cranemovingparts": -31, "chainBall": 68 }, { "cranemovingparts": -20, "chainBall": 30 }
                    ];
                    for (let i = 0; i < randomized.length; i++) {
                        let w = new Phaser.GameObjects.Container(this.scene, positions[i]['x'], positions[i]['y']);
                        w.add(w["-image-"] = this.scene.add.sprite(0, 0, 'Windows Normal'));
                        w["-image-"].setOrigin(0.5, 0.49);
                        this.words.push(w);
                        let txt;
                        if (this.gameplay.useImages) {
                            txt = new Phaser.GameObjects.Image(this.scene, 0, 0, randomized[i]["word"]);
                            w.add(txt);
                        }
                        else {
                            txt = this.scene.add.text(0, 10, "", {
                                "fontFamily": "QuranErafont",
                                "fontSize": 55,
                                "color": "#000000",
                                "align": 'center'
                            });
                            txt.setOrigin(0.5, 0.5);
                            txt.style.fixedHeight = 75;
                            txt.setText(randomized[i]["word"] + ' ');
                            w.add(txt);
                        }
                        w["-letter-"] = txt;
                        w["-word-text-"] = randomized[i]["word"];
                        this.gameplayContainer.add(w);

                        w["-cranAngles-"] = cranAngles[i];
                        // Preloader.playAnim('bubble_idle', w["-image-"]);
                    }

                    /*window["aa"]=(s)=>{
                        this.building_collapse.setScale(s);
                        this.building_collapse.visible = true;
                        Preloader.playAnim('building_collapse', this.building_collapse);
                    };*/

                    for (let word of this.words) {
                        word.setSize(word["-image-"].width, word["-image-"].height);
                        word.setInteractive({ cursor: 'pointer' });
                        word.on('pointerdown', () => {
                            this.setInputEnabled(false);
                            if (word["-word-text-"] == this.gameplay.currentWordData["word"]) {

                                const dx = word.x - ballOriginalPosition.x;
                                const targetDistance = Math.abs(dx);
                                const ballSpeed = 700;
                                const duration = targetDistance / ballSpeed * 1000 + 400;
                                let complete = this.onCorrectAnswer(duration + 1100);
                                word.disableInteractive();
                                this.scene.tweens.add({
                                    targets: this.cranemovingparts,
                                    "angle": word["-cranAngles-"]["cranemovingparts"],
                                    duration: duration,
                                    ease: Phaser.Math.Easing.Back.In,
                                    yoyo: true
                                });
                                this.scene.tweens.add({
                                    targets: this.chainBall,
                                    "angle": word["-cranAngles-"]["chainBall"],
                                    duration: duration,
                                    ease: Phaser.Math.Easing.Back.In,
                                    yoyo: true
                                });

                                this.scene.sound.add("Crane movement").play();

                                delayedCall(Math.max(duration - 50, 50), () => {
                                    word.destroy(true);
                                    this.shakeBuilding();
                                    this.crashWindow(word);
                                    if (complete) {
                                        delayedCall(1000, () => {
                                            this.Bldg.visible = false;
                                            for (let w of this.words) {
                                                w["bubble_poping"].visible = false;
                                                w.visible = false;
                                            }
                                            this.building_collapse.visible = true;
                                            Preloader.playAnim('building_collapse', this.building_collapse);
                                            this.scene.sound.add("Building collapse").play();
                                        })
                                    }
                                });

                                word["-image-"].setTexture('WindowGreen');
                            }
                            else {
                                let lost = this.onWrongAnswer();
                                delayedCall(150, () => {
                                    this.destroyIdleDelayedCallIfExists();
                                    Preloader.playAnim('snake_nahh', this.character, () => {
                                        this.playIdle();
                                    });
                                    this.scene.sound.add("Turtle animation sfx").play();
                                });
                                delayedCall(3200, () => {
                                    if (!lost) {
                                        this.setInputEnabled(true);
                                    }
                                });
                                word["-image-"].setTexture('Windows Red');
                                delayedCall(1000, () => {
                                    if (!lost) {
                                        word["-image-"].setTexture('Windows Normal');
                                    }
                                });
                            }
                        });
                    }
                    this._btnClose.setInteractive({ cursor: 'pointer', pixelPerfect: true });
                    this.setInputEnabled(false);

                    this.rr = new Phaser.GameObjects.Image(this.scene, 153, 45, 'Rounded Rectangle 1143')
                    this.gameplayContainer.add(this.rr);
                    this.rr.setOrigin(0, 0.5);
                    this.rr.setScale(this.gameplay.getMaxTotalAnswersCount() / 8, 1);
                }

                shakeBuilding() {
                    this.scene.tweens.add({
                        targets: this.buildingContainer,
                        x: this.buildingContainer.x - 2,
                        duration: 45,
                        yoyo: true,
                        repeat: 5
                    });
                    this.scene.tweens.add({
                        targets: this.buildingContainer,
                        y: this.buildingContainer.y + 2,
                        duration: 30,
                        yoyo: true,
                        repeat: 5
                    });
                }

                crashWindow(bubble) {
                    let bubble_poping = this.scene.add.sprite(bubble.x + 134, bubble.y + 125, null);
                    this.gameplayContainer.add(bubble_poping);
                    bubble["bubble_poping"] = bubble_poping;
                    Preloader.playAnim('window_smash', bubble_poping);
                    this.scene.sound.add("Windows smash").play();
                }
                 prepareRound() {
                    delayedCall(750, () => {
                        this.playCorrectAudio();
                        delayedCall(750, () => { this.setInputEnabled(true); });

                        /*//HELPER!
                        for (let word of this.words) {
                        //HELPER!
                        /*for (let word of this.words) {
                            if (word["-word-text-"] == this.gameplay.currentWordData["word"]) {
                                word["-image-"].alpha = 0.75;
                            } else {
                                word["-image-"].alpha = 1;
                            }
                        }*/
                    });
                }
                onNewRound(showOut) {
                    this.setInputEnabled(false);
                    if (showOut) {
                        this.prepareRound();
                    }
                }
                onCorrectAnswer(delay) {
                    let i = this.gameplay.getCurrentTotalAnswersCount();
                    this.tallyEmptyArray[i].visible = false;
                    this.tally[i].visible = true;
                    let completed = this.gameplay.onCorrectAnswer(delay);
                    this.scene.sound.add('Correct selection').play();
                    return completed;
                }
                onWrongAnswer() {
                    let i = this.gameplay.getCurrentTotalAnswersCount();
                    this.tallyEmptyArray[i].visible = true;
                    this.tally[i].visible = false;
                    let lost = this.gameplay.onWrongAnswer();
                    this.scene.sound.add("Wrong click").play();
                    this.destroyIdleDelayedCallIfExists();
                    if (!lost)
                        delayedCall(3500, () => { this.playCorrectAudio(); });
                    return lost;
                }
                onCloseClick() {
                    this.showAreYouSurePage();
                    this.scene.sound.add('warning page pop up sfx').play();
                }
                createTallies() {
                    if (this.tally) {
                        for (let te of this.tallyEmptyArray) {
                            te.visible = false;
                            this.bringToTop(te);
                        }
                        for (let t of this.tally) {
                            t.visible = false;
                            this.bringToTop(t);
                        }
                        return;
                    }
                    let startX = 200;
                    let startY = 45;
                    let dx = 43;
                    let tallyEmptyArrayPositions = [];
                    for (let i = 0; i < this.gameplay.getMaxTotalAnswersCount(); i++) {
                        tallyEmptyArrayPositions.push({ x: startX + i * dx, y: startY });
                    }
                    this.tallyEmptyArray = [];
                    this.tally = [];
                    for (let p of tallyEmptyArrayPositions) {
                        let _BeehiveEmpty = new Phaser.GameObjects.Image(this.scene, p['x'], p['y'], 'ballempty');
                        this.tallyEmptyArray.push(_BeehiveEmpty);
                        _BeehiveEmpty.visible = false;
                        let _Beehive = new Phaser.GameObjects.Image(this.scene, p['x'], p['y'], 'ballCorrect');
                        this.tally.push(_Beehive);
                    }
                    for (let bea of this.tallyEmptyArray) {
                        this.add(bea);
                    }
                    for (let bee of this.tally) {
                        this.add(bee);
                        bee.visible = false;
                    }
                }
                hideAllUnusedTallies() {
                    let i = this.gameplay.getCurrentTotalAnswersCount();
                    for (let k = i + 1; k < this.tallyEmptyArray.length; k++) {
                        this.tallyEmptyArray[k].visible = false;
                        this.tally[k].visible = false;
                    }
                }
                showInstructionPage() {
                    setPageBackground("bg-blue");
                    let playInstructionSound = () => {
                        if (this.wfsnd) {
                            this.wfsnd.stop();
                        }
                        this.wfsnd = this.scene.sound.add("Help Salty");
                        this.wfsnd.play();
                    };
                    this.instructionPage = new screen.InstructionPage(this.scene, (target) => {
                        playBtnClickAnim(target);
                        this.instructionPage.destroy(true);
                        this.showGameplay();
                        if (this.wfsnd) {
                            this.wfsnd.stop();
                        }
                    }, (target) => {
                        playBtnClickAnim(target);
                        playInstructionSound();
                    });
                    this.add(this.instructionPage);
                    try {
                        playInstructionSound();
                    }
                    catch (e) {
                        console.error(e);
                    }
                }
                showAreYouSurePage() {
                    pauseAllDelayedCalls();
                    setPageBackground("bg-blue");
                    this.scene.tweens.pauseAll();
                    this.pauseSounds();
                    this.areYouSureWindow = new screen.AreYouSureWindow(this.scene, () => {
                        this.scene.tweens.resumeAll();
                        this.areYouSureWindow.destroy(true);
                        this.destroyGameplay();
                        this.showInstructionPage();
                    }, () => {
                        this.scene.tweens.resumeAll();
                        this.areYouSureWindow.destroy(true);
                        this.unpauseSounds();
                        resumeAllDelayedCalls();
                        setPageBackground("bg-australia");
                    });
                    this.add(this.areYouSureWindow);
                }
                setInputEnabled(enabled) {
                    if (enabled) {
                        for (let a of this.words)
                            if (a.parentContainer)
                                a.setInteractive({ cursor: 'pointer' });
                    }
                    else {
                        for (let a of this.words)
                            a.disableInteractive();
                    }
                }
                pauseSounds() {
                    this.scene.sound.pauseAll();
                }
                unpauseSounds() {
                    this.scene.sound.resumeAll();
                }
                destroyGameplay() {
                    this.setInputEnabled(false);
                    this.remove(this.gameplayContainer);
                    this.scene.sound.stopAll();
                    destroyAllDelayedCalls();
                }
            }
            screen.GameplayScreen = GameplayScreen;
        })(screen = ctb.screen || (ctb.screen = {}));
    })(ctb || (ctb = {}));
    var ctb;
    (function (ctb) {
        var screen;
        (function (screen) {
            class InstructionPage extends Phaser.GameObjects.Container {
                constructor(scene, onPlayClick, onSndClick) {
                    super(scene);
                    this._instructionPage = new Phaser.GameObjects.Image(this.scene, 0 - 105, 0 - 48, 'Instructions page  ALL ACTIVITY  TITLEs');
                    this._instructionPage.setOrigin(0, 0);
                    //this._instructionPage.setInteractive();
                    this._instructionPageTitle = new Phaser.GameObjects.Image(this.scene, 460, 110, 'Logo');
                    this._instructionPageTitle.setScale(0.94);
                    this._btnPlay = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2, 480 - 50, 'btnPLAY1');
                    this._btnPlay.setInteractive({ cursor: 'pointer' });
                    this._btnPlay.once('pointerup', onPlayClick);
                    setupButtonTextureBased(this._btnPlay, 'btnPLAY1', 'btnPLAY2');
                    this.instrTxt = this.scene.add.text(game.scale.width / 2, game.scale.height / 2, "Help Funny Snake smash the windows by\n tapping on the right word.", {
                        "fontFamily": "Kids Rock DEMO",
                        "fontSize": 30,
                        "color": "#43425D",
                        "align": 'center'
                    });
                    this.instrTxt.setOrigin(0.5, 0.5);
                    this.instrTxt.setWordWrapWidth(710);
                    this.instrTxt.setLineSpacing(10);
                    this._btnSoundInstruction = new Phaser.GameObjects.Image(this.scene, 800 - 95, 156 - 50, 'Sound');
                    this._btnSoundInstruction.setInteractive({ cursor: 'pointer' });
                    this._btnSoundInstruction.on('pointerup', onSndClick);
                    this._btnSoundInstruction["defScale"] = this._btnSoundInstruction.scale;
                    setupButtonTextureBased(this._btnSoundInstruction, 'Sound', 'Sound HOVER EFFECT');
                    this.add(this._instructionPage);
                    this.add(this._instructionPageTitle);
                    this.add(this.instrTxt);
                    this.add(this._btnPlay);
                    this.add(this._btnSoundInstruction);
                }
            }
            screen.InstructionPage = InstructionPage;
        })(screen = ctb.screen || (ctb.screen = {}));
    })(ctb || (ctb = {}));
    var ctb;
    (function (ctb) {
        var screen;
        (function (screen) {
            class TryAgainWindow extends Phaser.GameObjects.Container {
                constructor(scene, onBack, onReplay) {
                    super(scene);
                    this.music = null;
                    this.setPosition(-106, -48);
                    this._bg = new Phaser.GameObjects.Image(this.scene, 0, 0, 'Try again page');
                    this._bg.setOrigin(0, 0);
                    //this._bg.setInteractive();
                    this._star = new Phaser.GameObjects.Image(this.scene, 400, 415, 'Break Star');
                    this._btnBack = new Phaser.GameObjects.Image(this.scene, 600, 580, 'btnBACK1');
                    this._btnReplay = new Phaser.GameObjects.Image(this.scene, 765, 580, 'btnReplay1');
                    this.totalScoreTxt = this.scene.add.text(830, 355, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 35,
                        "color": "#F49F1C",
                        "align": 'center',
                        'stroke': '#70451A',
                        'strokeThickness': 6
                    });
                    this.totalScoreTxt.setOrigin(0.5, 0.5);
                    let grd = this.totalScoreTxt.context.createLinearGradient(0, 0, 0, this.totalScoreTxt.height);
                    grd.addColorStop(0, '#FFFF00');
                    grd.addColorStop(1, '#C17316');
                    this.totalScoreTxt.setFill(grd);
                    this.starScoreTxt = this.scene.add.text(635, 431, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 24,
                        "color": "#FFFFFF",
                        "align": 'center'
                    });
                    this.starScoreTxt.setOrigin(0.5, 0.5);
                    this.add([
                        this._bg,
                        this._star,
                        this._btnBack,
                        this._btnReplay,
                        this.totalScoreTxt,
                        this.starScoreTxt
                    ]);
                    this._btnBack.setInteractive({ cursor: 'pointer' });
                    this._btnBack.on('pointerup', () => {
                        onBack(this._btnBack);
                        window.angularComponentRef.backToMenu();
                        // if (this.music) {
                        //     this.music.stop();
                        // }
                    });
                    setupButtonTextureBased(this._btnBack, 'btnBACK1', 'btnBACK2');
                    this._btnReplay.setInteractive({ cursor: 'pointer' });
                    this._btnReplay.once('pointerup', () => {
                        onReplay(this._btnReplay);
                        if (this.music) {
                            this.music.stop();
                        }
                    });
                    setupButtonTextureBased(this._btnReplay, 'btnReplay1', 'btnReplay2');
                }
                show(score, starScore) {
                    this._star.scale = 1.25;
                    this.scene.tweens.add({
                        targets: this._star,
                        "scale": 1,
                        duration: 500,
                        ease: Phaser.Math.Easing.Back.Out
                    });
                    this.totalScoreTxt.text = String(window.angularComponentRef.component.userInfo.totalScore);
                    this.starScoreTxt.text = String(starScore);
                    this.music = this.scene.sound.add("Fail - close one");
                    this.music.play();
                }
            }
            screen.TryAgainWindow = TryAgainWindow;
        })(screen = ctb.screen || (ctb.screen = {}));
    })(ctb || (ctb = {}));

    game = new ctb.App();
};

var destroyDemolishTheBuilding = () => {
    if (game) {
        game.destroy();
        game = null;
    }
}

var gameData = {
    score: 0,
    winSound: null,
};

var game = null;

var dragNDrop = (json) => {
    class Letter extends Phaser.GameObjects.Sprite {
        constructor(config) {
            super(config.scene, config.x, config.y, config.key);

            this.origX = config.x;
            this.origY = config.y;
            this.id = config.id;
            this.letter = config.letter;
            this.setOrigin(0.5, 0.5);
            this.setInteractive();
            this.completed = false;
            config.scene.add.existing(this);

            var textStyle = {
                fontSize: "33px", fontWeight: "bold", align: "center", fontFamily: 'QuranErafont',
                fill: "#000000", stroke: "#ffffff"
            }

            this.letterText = null;
            this.img = null;

            if (config.letter != "") {
                this.letterText = this.scene.add.text(config.x, config.y, this.letter, textStyle);

                this.letterText.setOrigin(0.5, 0.5);
                this.letterText.setSize(this.width, this.height);
            } else {
                this.img = this.scene.add.sprite(config.x, config.y, config.img);
                this.img.setOrigin(0.5, 0.5);
            }

            this.on("pointerdown", function () {
                console.log("letter click");
            });
        }

        update() {
            if (this.letterText != null) {
                this.letterText.x = this.x;
                this.letterText.y = this.y;
            } else if (this.img != null) {
                this.img.x = this.x;
                this.img.y = this.y;
            }
        }

        setPos(x, y) {
            this.x = x;
            this.y = y;
            this.origX = x;
            this.origY = y;

            if (this.letterText != null) {
                this.letterText.x = x;
                this.letterText.y = y;
            } else if (this.img != null) {
                this.img.x = x;
                this.img.y = y;
            }
        }

        setToTop(index) {
            this.setDepth(index);
            if (this.letterText != null)
                this.letterText.setDepth(index);
            else if (this.img != null)
                this.img.setDepth(index);
        }
    }

    class DropZone extends Phaser.GameObjects.Sprite {
        constructor(config) {
            super(config.scene, config.x, config.y, config.key);

            this.id = config.id;
            this.setOrigin(0.5, 0.5);

            config.scene.add.existing(this);

            this.character = config.scene.add.image(this.x, this.y, config.character).setOrigin(0.5, 0.5).setScale(0.8);
            this.dropRect = config.scene.add.image(this.x, this.y + 110, 'dropRect');
            this.dropRect.setOrigin(0.5, 0.5);
        }

        setPos(x, y) {
            this.x = x;
            this.y = y;
            this.character.x = x;
            this.character.y = y;
            this.dropRect.x = x;
            this.dropRect.y = y + 110;
        }
    }

    class Boot extends Phaser.Scene {
        constructor() {
            super({ key: "Boot" });
        }

        init() {
            this.game.scale.transformX = (pageX) => {
                let offsetLeft = 0;
                let parentElement = game.canvas.parentElement;
                while (parentElement) {
                    if (parentElement.offsetLeft) {
                        offsetLeft = parentElement.offsetLeft;
                        break;
                    }
                    parentElement = parentElement.parentElement;
                }
                return (pageX - offsetLeft) * this.game.scale.displayScale.x;
            };
            this.game.scale.transformY = (pageY) => {
                let offsetTop = 0;
                let parentElement = game.canvas.parentElement;
                while (parentElement) {
                    if (parentElement.offsetTop) {
                        offsetTop = parentElement.offsetTop;
                        break;
                    }
                    parentElement = parentElement.parentElement;
                }
                return (pageY - offsetTop) * this.game.scale.displayScale.y;
            };
        }

        preload() {
            var instance = this;
            var progress = this.add.graphics();
            this.load.on('progress', function (value) {
                progress.clear();
            });

            this.load.on('complete', function () {
                progress.destroy();
                this.scene.scene.start('Welcome');
            });

            //this.load.start();

            //load all assets here

            this.load.image("frame", "assets/games/drag_drop/assets/Frame.png")

            /*WELCOME SCENE ASSETS*/
            this.load.image("board", "assets/games/drag_drop/assets/welcome/board.png");
            this.load.image("greyRect", "assets/games/drag_drop/assets/welcome/greyRect.png");
            this.load.image("roundRect", "assets/games/drag_drop/assets/welcome/roundRect.png");
            this.load.image("titleRect", "assets/games/drag_drop/assets/welcome/titlerect.png");
            this.load.image("title", "assets/games/drag_drop/assets/welcome/welcomeText.png");
            this.load.image("leaf", "assets/games/drag_drop/assets/welcome/leaf.png");
            this.load.image("playBtn", "assets/games/drag_drop/assets/welcome/playBtn.png");
            this.load.image("playBtnselected", "assets/games/drag_drop/assets/welcome/playBtnselected.png");
            this.load.image("soundBtn", "assets/games/drag_drop/assets/welcome/soundBtn.png");
            this.load.image("soundBtnHover", "assets/games/drag_drop/assets/welcome/soundBtnHover.png");
            console.log("ASdasdas", json);
            /*GAME SCENE ASSETS*/
            if (json.zone == "ASIA") {
                this.load.image("blueRect", "assets/games/drag_drop/assets/game/boardbg-1.png");
                this.load.image("letterRect", "assets/games/drag_drop/assets/game/letterRect-1.png");
                this.load.image("letterTab", "assets/games/drag_drop/assets/game/letterTab-1.png");
                this.load.image("starBar", "assets/games/drag_drop/assets/game/starBar-1.png");
            } else if ("EUROPE") {
                this.load.image("blueRect", "assets/games/drag_drop/assets/game/boardbg.png");
                this.load.image("letterRect", "assets/games/drag_drop/assets/game/letterRect.png");
                this.load.image("letterTab", "assets/games/drag_drop/assets/game/letterTab.png");
                this.load.image("starBar", "assets/games/drag_drop/assets/game/starBar.png");
            }

            this.load.image("1", "assets/games/drag_drop/assets/game/1.png");
            this.load.image("2", "assets/games/drag_drop/assets/game/2.png");
            this.load.image("3", "assets/games/drag_drop/assets/game/3.png");
            this.load.image("4", "assets/games/drag_drop/assets/game/4.png");
            this.load.image("5", "assets/games/drag_drop/assets/game/5.png");
            this.load.image("6", "assets/games/drag_drop/assets/game/6.png");
            this.load.image("7", "assets/games/drag_drop/assets/game/7.png");
            this.load.image("25", "assets/games/drag_drop/assets/game/25.png");
            this.load.image("28", "assets/games/drag_drop/assets/game/28.png");
            this.load.image("closeBtn", "assets/games/drag_drop/assets/game/closeBtn.png");
            this.load.image("closeBtnHover", "assets/games/drag_drop/assets/game/closeBtnHover.png");
            this.load.image("dropRect", "assets/games/drag_drop/assets/game/dropRect.png");
            this.load.image("incorrectRed", "assets/games/drag_drop/assets/game/incorrectRed.png");
            this.load.image("incorrectYellow", "assets/games/drag_drop/assets/game/incorrectYellow.png");
            this.load.image("stardisable", "assets/games/drag_drop/assets/game/stardisable.png");
            this.load.image("starenable", "assets/games/drag_drop/assets/game/starenable.png");
            this.load.image("frame1", "assets/games/drag_drop/assets/game/f1.png");
            this.load.image("frame2", "assets/games/drag_drop/assets/game/f2.png");
            this.load.image("frame3", "assets/games/drag_drop/assets/game/f3.png");
            this.load.image("frame4", "assets/games/drag_drop/assets/game/f4.png");
            this.load.image("frame5", "assets/games/drag_drop/assets/game/f5.png");
            this.load.image("frame6", "assets/games/drag_drop/assets/game/f6.png");

            /*TRY AGAIN SCENE ASSETS*/
            this.load.image("looseBg", "assets/games/drag_drop/assets/loose/looseBg.png");
            this.load.image("playagainBtn", "assets/games/drag_drop/assets/loose/playagainBtn.png");
            this.load.image("playagainBtnHover", "assets/games/drag_drop/assets/loose/playagainBtnHover.png");
            this.load.image("backtoMenu", "assets/games/drag_drop/assets/loose/backtomenu.png");
            this.load.image("backtoMenuHover", "assets/games/drag_drop/assets/loose/backtomenuHover.png");
            this.load.image("badge", "assets/games/drag_drop/assets/loose/badge.png");
            this.load.image("bigStar", "assets/games/drag_drop/assets/loose/bigstar.png");
            this.load.image("ribbon", "assets/games/drag_drop/assets/loose/ribbon.png");
            this.load.image("totalScoreText", "assets/games/drag_drop/assets/loose/totalScoreText.png");
            this.load.image("tryagainBoard", "assets/games/drag_drop/assets/loose/tryagainBoard.png");

            /*WIN SCREEN ASSETS */
            this.load.image("completionBg", "assets/games/drag_drop/assets/win/completionBg.png");
            this.load.image("completionRibbon", "assets/games/drag_drop/assets/win/ribboncomplete.png");
            this.load.image("trophy", "assets/games/drag_drop/assets/win/trophy.png");
            this.load.image("winstar", "assets/games/drag_drop/assets/win/winstar.png");
            this.load.image("backbtn", "assets/games/drag_drop/assets/win/backbtn.png");
            this.load.image("backbtnHover", "assets/games/drag_drop/assets/win/backbtnHover.png");
            this.load.image("nextBtn", "assets/games/drag_drop/assets/win/nextBtn.png");
            this.load.image("nextBtnHover", "assets/games/drag_drop/assets/win/nextBtnHover.png");

            /* WARNING SCREEN ASSETS*/
            this.load.image("noBtn", "assets/games/drag_drop/assets/warning/noBtn.png");
            this.load.image("noBtnHover", "assets/games/drag_drop/assets/warning/noBtnHover.png");
            this.load.image("yesBtn", "assets/games/drag_drop/assets/warning/yesBtn.png");
            this.load.image("yesBtnHover", "assets/games/drag_drop/assets/warning/yesBtnHover.png");
            this.load.image("sign", "assets/games/drag_drop/assets/warning/sign.png");
            this.load.image("warningBg", "assets/games/drag_drop/assets/warning/warningbg.png");
            this.load.image("warningBoard", "assets/games/drag_drop/assets/warning/warningboard.png");

            this.load.json('jsonData', json);

            /*LOAD SOUNDS*/
            this.load.audio('drag from its spot', 'assets/games/drag_drop/assets/audio/drag from its spot.mp3');
            this.load.audio('When placed wrong', 'assets/games/drag_drop/assets/audio/When placed wrong.mp3');
            this.load.audio('warning page pop up sfx', 'assets/games/drag_drop/assets/audio/warning page pop up sfx.mp3');

            this.load.audio("switchback", 'assets/games/drag_drop/assets/audio/switchback.mp3')
            this.load.audio("warning", 'assets/games/drag_drop/assets/audio/warning.mp3');
            this.load.audio('dragdropInst', 'assets/games/drag_drop/assets/audio/Instruction.mp3');
            this.load.audio('wrongDrop', 'assets/games/drag_drop/assets/audio/wrongdrop.mp3');
            this.load.audio('correctDrop', 'assets/games/drag_drop/assets/audio/correctdrop.mp3');
            this.load.audio('fail', 'assets/games/drag_drop/assets/audio/fail.mp3');

            this.load.audio('buttonclick', 'assets/games/drag_drop/assets/audio/buttonclick.mp3');
            this.load.audio('buttonhover', 'assets/games/drag_drop/assets/audio/buttonhover.mp3');
            this.load.audio('win', 'assets/games/drag_drop/assets/audio/win.mp3');
        }

        create() {
        }

        update() {
        }
    }

    let welcomeInstance = null;
    class Welcome extends Phaser.Scene {
        constructor() {
            super({ key: "Welcome" });

            welcomeInstance = this;
        }

        preload() {
            var jdata = this.cache.json.get('jsonData');
            for (var i = 0; i < jdata.data.length; i++) {
                this.load.image("img_" + i, 'assets/games/drag_drop/assets/game/answerImg/' + jdata.data[i].img);
                this.load.image("character_" + jdata.data[i].referenceImage, 'assets/games/drag_drop/assets/game/' + jdata.data[i].referenceImage + '.png');
                this.load.audio('sound' + jdata.data[i].referenceImage, 'assets/games/drag_drop/assets/audio/voiceover/' + jdata.data[i].referenceImage + '.mp3');
            }
        }

        create() {
            gameData = {
                score: 0,
                winSound: null,
            };

            this.buttonClick = this.sound.add('buttonclick');
            this.buttonHover = this.sound.add('buttonhover');

            var instructionSound = this.sound.add('dragdropInst');

            instructionSound.play();

            var greyRect = this.add.sprite(this.game.config.width / 2, this.game.config.height / 2, 'greyRect');
            greyRect.setOrigin(0.5, 0.5);

            var leaf = this.add.sprite(this.game.config.width / 2 - 380, this.game.config.height / 2 + 130, 'leaf');
            leaf.setOrigin(0.5, 0.5);

            var leaf1 = this.add.sprite(this.game.config.width / 2 + 380, this.game.config.height / 2 - 130, 'leaf');
            leaf1.setOrigin(0.5, 0.5);
            leaf1.setFlipX(-1);

            var roundRect = this.add.sprite(this.game.config.width / 2, this.game.config.height / 2, 'roundRect');
            roundRect.setOrigin(0.5, 0.5);

            var titleRect = this.add.sprite(this.game.config.width / 2, this.game.config.height / 2 - 200, 'titleRect');
            titleRect.setOrigin(0.5, 0.5);

            //var title = this.add.text(this.game.config.width/2,this.game.config.height/2-200, "Drag and Drop", { fontFamily: 'kidsrock', fontSize: 28, color: '#ffde00', align:'center', strokeThickness:2});
            //title.setOrigin(0.5,0.5);

            var title = this.add.sprite(this.game.config.width / 2, this.game.config.height / 2 - 200, 'title');
            title.setOrigin(0.5, 0.5);
            title.setScale(0.8);

            var playBtn = this.add.sprite(this.game.config.width / 2, this.game.config.height / 2 + 160, 'playBtn').setInteractive();
            playBtn.setOrigin(0.5, 0.5);

            var tween = this.tweens.add({
                targets: playBtn,
                scale: 0.8,
                duration: 100,
                ease: 'Power2',
                yoyo: true,
                paused: true
            });

            var tween1 = this.tweens.add({
                targets: playBtn,
                scale: 1.1,
                duration: 100,
                ease: 'Power2',
                paused: true,
            });

            playBtn.on('pointerdown', function () {
                instructionSound.stop();

                this.scene.scene.start("Game");
                this.scene.buttonClick.play();
            });

            playBtn.on('pointerover', function () {
                playBtn.setTexture("playBtnselected");
                this.scene.buttonHover.play();
            });

            playBtn.on('pointerout', function () {
                playBtn.setTexture("playBtn");
            });

            var paragraph = this.add.text(this.game.config.width / 2, this.game.config.height / 2, "Drag the letters to match the\n\n characters.", { fontFamily: 'Kids Rock DEMO', fontSize: 32, color: '#312f2f', align: 'center', strokeThickness: 2 });
            paragraph.setOrigin(0.5, 0.5);

            var soundBtn = this.add.sprite(this.game.config.width / 2 + 230, this.game.config.height / 2 - 200, 'soundBtn').setInteractive();
            soundBtn.setOrigin(0.5, 0.5);

            soundBtn.on("pointerover", function () {
                soundBtn.setTexture('soundBtnHover');
                this.scene.buttonHover.play();
            })

            soundBtn.on("pointerout", function () {
                soundBtn.setTexture('soundBtn');
            })

            soundBtn.on('pointerdown', function () {
                this.scene.buttonClick.play();
                instructionSound.play();
            })
        }

        update(time, delta) {
        }
    }

    let gameInstance = null;
    class Game extends Phaser.Scene {
        constructor() {
            super({ key: "Game" });
            gameInstance = this;
        }
        preload() {
        }

        create() {
            this.incorrect = 0;
            this.correct = 0;
            this.voiceOver = [];

            var jdata = this.cache.json.get('jsonData');
            var btnclickSound = this.sound.add('buttonclick');
            var btnhoverSound = this.sound.add('buttonhover');
            var btnInst = this.sound.add('dragdropInst');

            for (var i = 0; i < 6; i++) {
                var sound = this.sound.add('sound' + (jdata.data[i].referenceImage));
                this.voiceOver.push(sound);
            }

            this.switchBackSound = this.sound.add('switchback');
            this.wrongDropSound = this.sound.add('wrongDrop');
            this.correctDropSound = this.sound.add('correctDrop');

            var blueRect = this.add.sprite(this.game.config.width / 2, this.game.config.height / 2, 'blueRect');
            blueRect.setOrigin(0.5, 0.5);

            this.createStarBar();

            //var board = this.add.sprite(this.game.config.width/2, this.game.config.height/2, 'board');
            //board.setOrigin(0.5, 0.5);

            var letterTab = this.add.sprite(this.game.config.width / 2 - 350, this.game.config.height / 2 + 25, 'letterTab');
            letterTab.setOrigin(0.5, 0.5);

            this.createDropZones();
            this.createLetters();
            this.createIncorectElements();

            var closeBtn = this.add.sprite(this.game.config.width - 50, 40, 'closeBtn').setInteractive();
            closeBtn.setOrigin(0.5, 0.5);

            closeBtn.on("pointerdown", function () {
                btnclickSound.play();
                this.scene.scene.launch('Warning');
                this.scene.scene.pause('Game');

                this.scene.sound.add('warning page pop up sfx').play();
            })

            closeBtn.on("pointerover", function () {
                btnhoverSound.play();
                closeBtn.setTexture('closeBtnHover');
            })

            closeBtn.on("pointerout", function () {
                closeBtn.setTexture('closeBtn');
            })

            this.createWarningMsg();
        }

        update(time, delta) {
            for (var i = 0; i < this.letters.length; i++) {
                this.letters[i].update();
            }
        }

        createLetters() {
            this.letters = [];
            var defaultPos = [];
            var jdata = this.cache.json.get('jsonData');
            for (var i = 0; i < jdata.data.length; i++) {
                var x = 145;
                var y = 130 + (78 * i);

                var letter = new Letter({
                    scene: this,
                    x: x,
                    y: y,
                    key: 'letterRect',
                    id: i + 1,
                    letter: jdata.data[i].letter,
                    img: "img_" + i
                });

                this.input.setDraggable(letter, true);

                defaultPos.push({ x: x, y: y });
                this.letters.push(letter);
            }

            this.input.on('dragstart', function (pointer, gameObject, dragX, dragY) {
                gameObject.setToTop(1);
                this.scene.sound.add('drag from its spot').play();
            });

            this.input.on('drag', function (pointer, gameObject, dragX, dragY) {
                gameObject.x = dragX;
                gameObject.y = dragY;
            });

            this.input.on('dragend', function (pointer, gameObject) {
                if (!this.scene.checkOveralpWithZones(gameObject)) {
                    gameObject.x = gameObject.origX;
                    gameObject.y = gameObject.origY;
                    this.scene.wrongDropSound.play();
                }

                gameObject.setToTop(0);
            });

            defaultPos = this.shuffle(defaultPos);
            for (var i = 0; i < defaultPos.length; i++) {
                var letter = this.letters[i];
                var pos = defaultPos[i];
                letter.setPos(pos.x, pos.y);
                this.letters[i] = letter;
            }
        }

        createDropZones() {
            this.zones = [];
            var defaultPos = [];
            var gap = 0;
            var jdata = this.cache.json.get('jsonData');
            for (var i = 0; i < 6; i++) {
                var y = 150;

                if (i >= 3) {
                    y = 400;
                }

                if (i == 3)
                    gap = 0;

                var x = 370 + (250 * gap);
                var zone = new DropZone({
                    scene: this,
                    x: x,
                    y: y,
                    key: "frame" + (i + 1),
                    id: i + 1,
                    character: 'character_' + jdata.data[i].referenceImage
                });

                this.zones.push(zone);
                defaultPos.push({ x: x, y: y });
                gap++;
            }

            defaultPos = this.shuffle(defaultPos);
            for (var i = 0; i < defaultPos.length; i++) {
                var zone = this.zones[i];
                var pos = defaultPos[i];
                zone.setPos(pos.x, pos.y);
                this.zones[i] = zone;
            }
        }

        checkOveralp(x1, y1, x2, y2, w1, w2, h1, h2) {
            var topleftX1 = x1 - (w1 / 2)
            var topleftY1 = y1 - (h1 / 2);

            var bottomRightX1 = x1 + (w1 / 2);
            var bottomRightY1 = y1 + (h1 / 2);

            var topleftX2 = x2 - (w2 / 2)
            var topleftY2 = y2 - (h2 / 2);

            var bottomRightX2 = x2 + (w2 / 2);
            var bottomRightY2 = y2 + (h2 / 2);

            var rect1 = new Phaser.Geom.Rectangle(topleftX1, topleftY1, w1, h1);
            var rect2 = new Phaser.Geom.Rectangle(topleftX2, topleftY2, w2, h2);

            if (Phaser.Geom.Intersects.RectangleToRectangle(rect1, rect2)) {
                return true;
            }

            return false;
        }

        checkOveralpWithZones(gameObject) {
            for (var i = 0; i < this.zones.length; i++) {
                var zone = this.zones[i];
                if (this.checkOveralp(gameObject.x, gameObject.y, zone.dropRect.x, zone.dropRect.y, gameObject.width, zone.dropRect.width, gameObject.height, zone.dropRect.height)) {
                    if ((gameObject.id == zone.id)) {
                        gameData.score += 2;
                        this.correctDropSound.play();
                        this.voiceOver[gameObject.id - 1].play();
                        gameObject.x = zone.dropRect.x;
                        gameObject.y = zone.dropRect.y;
                        this.input.setDraggable(gameObject, false);

                        this.correct++;
                        this.stars[this.correct - 1].setTexture('starenable');

                        if (this.correct >= 6) {
                            this.time.addEvent({
                                delay: 3000,
                                callback: () => {
                                    this.scene.start("Win");
                                },
                                loop: false
                            });
                        }
                    } else {
                        if (gameData.score > 0)
                            gameData.score -= 2;

                        this.sound.add('When placed wrong').play();

                        var delayEvent = new Phaser.Time.TimerEvent({
                            delay: 1000, callback: () => {
                                gameObject.x = gameObject.origX;
                                gameObject.y = gameObject.origY;
                                this.switchBackSound.play();
                                this.incorrect++;
                                this.incorrectIcons[this.incorrect - 1].setTexture('incorrectRed');

                                if (this.incorrect >= 3)
                                    this.scene.start("Loose");
                            }, loop: false
                        });

                        this.time.addEvent(delayEvent);
                    }

                    return true;
                }
            }

            return false;
        }

        shuffle(arra1) {
            var ctr = arra1.length, temp, index;

            // While there are elements in the array
            while (ctr > 0) {
                // Pick a random index
                index = Math.floor(Math.random() * ctr);
                // Decrease ctr by 1
                ctr--;
                // And swap the last element with it
                temp = arra1[ctr];
                arra1[ctr] = arra1[index];
                arra1[index] = temp;
            }
            return arra1;
        }

        createIncorectElements() {
            this.incorrectIcons = [];
            for (var i = 0; i < 3; i++) {
                var incorrectIcon = this.add.image(80 + (60 * i), 40, 'incorrectYellow');
                incorrectIcon.setOrigin(0.5, 0.5);
                this.incorrectIcons.push(incorrectIcon);
            }
        }

        createStarBar() {
            this.stars = [];
            var bar = this.add.image(this.game.config.width / 2 + 30, 30, 'starBar');
            bar.setOrigin(0.5, 0.5);
            for (var i = 0; i < 6; i++) {
                var star = this.add.image(370 + (60 * i), 35, 'stardisable');
                star.setOrigin(0.5, 0.5);
                this.stars.push(star);
            }
        }

        createWarningMsg() {
        }
    }

    class Loose extends Phaser.Scene {
        constructor() {
            super({ key: "Loose" });
        }

        preload() {
        }

        create() {
            var failsound = this.sound.add('fail');
            failsound.play();

            var btnclickSound = this.sound.add('buttonclick');
            var btnhoverSound = this.sound.add('buttonhover');

            //var board = this.add.sprite(this.game.config.width/2, this.game.config.height/2, 'board');
            //board.setOrigin(0.5, 0.5);

            var blueRect = this.add.sprite(this.game.config.width / 2, this.game.config.height / 2, 'looseBg');
            blueRect.setOrigin(0.5, 0.5);

            var tryAgainBoard = this.add.sprite(this.game.config.width / 2, this.game.config.height / 2, 'tryagainBoard');
            tryAgainBoard.setOrigin(0.5, 0.5);

            var ribbon = this.add.sprite(this.game.config.width / 2, this.game.config.height / 2 - 100, 'ribbon');
            ribbon.setOrigin(0.5, 0.5);

            var bigStar = this.add.sprite(this.game.config.width / 2 - 220, this.game.config.height / 2 + 50, 'bigStar');
            bigStar.setOrigin(0.5, 0.5);
            bigStar.setScale(0);

            var scoreLabel = this.add.sprite(this.game.config.width / 2 + 30, this.game.config.height / 2 - 10, 'totalScoreText');
            scoreLabel.setOrigin(0.5, 0.5);

            var badge = this.add.sprite(this.game.config.width / 2 - 15, this.game.config.height / 2 + 100, 'badge');
            badge.setOrigin(0.5, 0.5);

            var backtomenuBtn = this.add.sprite(this.game.config.width / 2 - 35, this.game.config.height / 2 + 220, 'backtoMenu').setInteractive();
            backtomenuBtn.setOrigin(0.5, 0.5);

            backtomenuBtn.on("pointerdown", function () {
                btnclickSound.play();
                window.angularComponentRef.backToMenu();
                //this.scene.scene.start('Welcome');
            })

            backtomenuBtn.on("pointerover", function () {
                btnhoverSound.play();
                backtomenuBtn.setTexture('backtoMenuHover');
            })

            backtomenuBtn.on("pointerout", function () {
                backtomenuBtn.setTexture('backtoMenu');
            })

            var playagainBtn = this.add.sprite(this.game.config.width / 2 + 120, this.game.config.height / 2 + 220, 'playagainBtn').setInteractive();
            playagainBtn.setOrigin(0.5, 0.5);

            playagainBtn.on("pointerdown", function () {
                btnclickSound.play();
                this.scene.scene.start('Welcome');
            })

            playagainBtn.on("pointerover", function () {
                btnhoverSound.play();
                playagainBtn.setTexture('playagainBtnHover');
            })

            playagainBtn.on("pointerout", function () {
                playagainBtn.setTexture('playagainBtn');
            })

            var textStyle = {
                fontSize: "28px", fontFamily: 'Kids Rock DEMO', align: "center",
                fill: "#fed210", stroke: "#91301a", strokeThickness: 7
            }

            this.scoreText = this.add.text(this.game.config.width / 2 + 170, this.game.config.height / 2 - 5, String(window.angularComponentRef.component.userInfo.totalScore), textStyle);
            this.scoreText.setOrigin(0, 0.5);
            this.scoreText.setScale(0);

            var textStyle1 = {
                fontSize: "22px", fontFamily: 'Kids Rock DEMO', align: "center",
                fill: "#ffffff", stroke: "#ffffff"
            }

            this.badgeText = this.add.text(this.game.config.width / 2, this.game.config.height / 2 + 90, "+0", textStyle1);
            this.badgeText.setOrigin(0.5, 0.5);

            var tween = this.tweens.add({
                targets: bigStar,
                scale: 1,
                ease: 'Power1',
                duration: 500,
            });

            var tween2 = this.tweens.add({
                targets: this.scoreText,
                scale: 1,
                ease: 'Power1',
                duration: 200,
            });
        }

        update(time, delta) {
        }
    }
    class Win extends Phaser.Scene {
        constructor() {
            super({ key: "Win" });
        }

        init() {
            window.angularComponentRef.gameFinish({ score: gameData.score })
        }

        preload() {
        }

        create() {
            var winSound = this.sound.add('win');
            winSound.play();

            var btnclickSound = this.sound.add('buttonclick');
            var btnhoverSound = this.sound.add('buttonhover');

            //var board = this.add.sprite(this.game.config.width/2, this.game.config.height/2, 'board');
            //board.setOrigin(0.5, 0.5);

            var greenRect = this.add.sprite(this.game.config.width / 2, this.game.config.height / 2, 'completionBg');
            greenRect.setOrigin(0.5, 0.5);

            var tryAgainBoard = this.add.sprite(this.game.config.width / 2, this.game.config.height / 2, 'tryagainBoard');
            tryAgainBoard.setOrigin(0.5, 0.5);

            var ribbon = this.add.sprite(this.game.config.width / 2, this.game.config.height / 2 - 110, 'completionRibbon');
            ribbon.setOrigin(0.5, 0.5);

            var stars = this.add.sprite(this.game.config.width / 2, this.game.config.height / 2 - 250, 'winstar');
            stars.setOrigin(0.5, 0.5);

            var trophy = this.add.sprite(this.game.config.width / 2 - 220, this.game.config.height / 2 + 50, 'trophy');
            trophy.setOrigin(0.5, 0.5);
            trophy.setScale(0);

            var scoreLabel = this.add.sprite(this.game.config.width / 2 + 30, this.game.config.height / 2 - 10, 'totalScoreText');
            scoreLabel.setOrigin(0.5, 0.5);

            var badge = this.add.sprite(this.game.config.width / 2 - 15, this.game.config.height / 2 + 100, 'badge');
            badge.setOrigin(0.5, 0.5);

            var backBtn = this.add.sprite(this.game.config.width / 2 - 35, this.game.config.height / 2 + 220, 'backbtn').setInteractive();
            backBtn.setOrigin(0.5, 0.5);

            backBtn.on("pointerdown", function () {
                btnclickSound.play();
                this.scene.scene.start('Welcome');
                window.angularComponentRef.backToMenu();
            })

            backBtn.on("pointerover", function () {
                btnhoverSound.play();
                backBtn.setTexture('backbtnHover');
            })

            backBtn.on("pointerout", function () {
                backBtn.setTexture('backbtn');
            })

            var playagainBtn = this.add.sprite(this.game.config.width / 2 + 120, this.game.config.height / 2 + 220, 'playagainBtn').setInteractive();
            playagainBtn.setOrigin(0.5, 0.5);

            playagainBtn.on("pointerdown", function () {
                btnclickSound.play();
                this.scene.scene.start('Welcome');
            });

            playagainBtn.on("pointerover", function () {
                btnhoverSound.play();
                playagainBtn.setTexture('playagainBtnHover');
            });

            playagainBtn.on("pointerout", function () {
                playagainBtn.setTexture('playagainBtn');
            });

            var nextBtn = this.add.sprite(this.game.config.width / 2 + 280, this.game.config.height / 2 + 220, 'nextBtn').setInteractive();
            nextBtn.setOrigin(0.5, 0.5);

            nextBtn.on("pointerdown", function () {
                btnclickSound.play();
                window.angularComponentRef.nextActivity();
            })

            nextBtn.on("pointerover", function () {
                btnhoverSound.play();
                nextBtn.setTexture('nextBtnHover');
            })

            nextBtn.on("pointerout", function () {
                nextBtn.setTexture('nextBtn');
            })

            var textStyle = {
                fontSize: "28px", fontFamily: "Kids Rock DEMO", align: "center",
                fill: "#fed210", stroke: "#91301a", strokeThickness: 7
            }

            this.scoreText = this.add.text(this.game.config.width / 2 + 170, this.game.config.height / 2 - 5,
                String(window.angularComponentRef.component.userInfo.totalScore), textStyle);
            this.scoreText.setOrigin(0, 0.5);
            this.scoreText.setScale(0);

            var textStyle1 = {
                fontSize: "22px", fontFamily: "Kids Rock DEMO", align: "center",
                fill: "#ffffff", stroke: "#ffffff"
            }

            this.badgeText = this.add.text(this.game.config.width / 2, this.game.config.height / 2 + 90, gameData.score, textStyle1);
            this.badgeText.setOrigin(0.5, 0.5);

            var tween = this.tweens.add({
                targets: trophy,
                scale: 1,
                ease: 'Power1',
                duration: 500,
            });

            var tween2 = this.tweens.add({
                targets: this.scoreText,
                scale: 1,
                ease: 'Power1',
                duration: 200,
            });
        }

        update(time, delta) {
        }
    }
    class Warning extends Phaser.Scene {
        constructor() {
            super({ key: "Warning" });
            gameInstance = this;
        }

        preload() {
        }

        create() {
            var btnclickSound = this.sound.add('buttonclick');
            var btnhoverSound = this.sound.add('buttonhover');

            var bg = this.add.sprite(this.game.config.width / 2, this.game.config.height / 2, 'warningBg');
            bg.setOrigin(0.5);

            var leaf = this.add.sprite(this.game.config.width / 2 - 380, this.game.config.height / 2 + 130, 'leaf');
            leaf.setOrigin(0.5, 0.5);

            var leaf1 = this.add.sprite(this.game.config.width / 2 + 380, this.game.config.height / 2 - 130, 'leaf');
            leaf1.setOrigin(0.5, 0.5);
            leaf1.setFlipX(-1);

            var board = this.add.sprite(this.game.config.width / 2, this.game.config.height / 2, 'warningBoard');
            board.setOrigin(0.5);

            var sign = this.add.sprite(this.game.config.width / 2, this.game.config.height / 2 - 130, 'sign');
            sign.setOrigin(0.5);

            var yesBtn = this.add.sprite(this.game.config.width / 2 - 100, this.game.config.height / 2 + 150, 'yesBtn').setInteractive();
            yesBtn.setOrigin(0.5);

            yesBtn.on("pointerdown", function () {
                btnclickSound.play();
                window.angularComponentRef.backToMenu();
            });

            yesBtn.on("pointerover", function () {
                btnhoverSound.play();
                yesBtn.setTexture('yesBtnHover');
            });

            yesBtn.on("pointerout", function () {
                yesBtn.setTexture('yesBtn');
            });

            var noBtn = this.add.sprite(this.game.config.width / 2 + 100, this.game.config.height / 2 + 150, 'noBtn').setInteractive();
            noBtn.setOrigin(0.5);

            noBtn.on("pointerdown", function () {
                btnclickSound.play();
                this.scene.scene.stop('Warning');
                this.scene.scene.resume('Game');
            });

            noBtn.on("pointerover", function () {
                btnhoverSound.play();
                noBtn.setTexture('noBtnHover');
            });

            noBtn.on("pointerout", function () {
                noBtn.setTexture('noBtn');
            });

            var paragraph = this.add.text(this.game.config.width / 2, this.game.config.height / 2, "Your progress in this activity will not be saved.\nAre you sure you want to exit?", { fontFamily: 'Kids Rock DEMO', fontSize: 26, color: '#43425d', stroke: '#ffffff', align: 'center', strokeThickness: 2 });
            paragraph.setOrigin(0.5, 0.5);
        }
    }

    class FitScaleManager {
        constructor(game) {
            this.doResize = () => {
                let scale = this.calculateScale();
                let newCanvasWidth = this.phaserScaleManager.width * scale;
                let newCanvasHeight = this.phaserScaleManager.height * scale;
                this.canvasStyle.width = newCanvasWidth + 'px';
                this.canvasStyle.height = newCanvasHeight + 'px';
                this.canvasStyle.marginLeft = (window.innerWidth - newCanvasWidth) / 2 + 'px';
                this.canvasStyle.marginTop = (window.innerHeight - newCanvasHeight) / 2 + 'px';
            };
            this.game = game;
            this.canvasStyle = this.game.canvas.style;
            this.phaserScaleManager = this.game.scale;
        }
        static detectBestScaleMode() {
            let iOS = /iPad|iPhone|iPod/.test(navigator.platform || "");
            let isAndroid = window.navigator.userAgent.toLowerCase().indexOf("android") > -1;
            return iOS || isAndroid ? Phaser.Scale.FIT : Phaser.Scale.NONE;
        }
        ;
        /**
         * Just call this method once in Boot scene's init() method
         */
        setup() {
            this.phaserScaleManager.addListener(Phaser.Scale.Events.RESIZE, this.onResize, this);
            this.overridePhaserTransformMethods();
            this.onResize();
        }
        calculateScale() {
            if (game.scale.scaleMode == Phaser.Scale.NONE)
                return 1;
            return Math.min(window.innerWidth / this.phaserScaleManager.width, window.innerHeight / this.phaserScaleManager.height);
        }
        overridePhaserTransformMethods() {
            this.game.scale.transformX = (pageX) => {
                return (pageX - parseInt(this.canvasStyle.marginLeft.split("px")[0])) / this.calculateScale();
            };
            this.game.scale.transformY = (pageY) => {
                return (pageY - parseInt(this.canvasStyle.marginTop.split("px")[0])) / this.calculateScale();
            };
        }
        onResize() {
            setTimeout(this.doResize, FitScaleManager.RESIZE_DELAY);
        }
    }
    FitScaleManager.RESIZE_DELAY = 500;

    var config = {
        type: Phaser.AUTO,
        width: 980,
        height: 600,

        parent: 'game-holder',

        scale: {
            mode: FitScaleManager.detectBestScaleMode(),
            autoCenter: Phaser.Scale.CENTER_BOTH
        },

        physics: {
            default: 'arcade',
            arcade: {
                gravity: { y: 200 }
            }
        },
        dom: {
            createContainer: false
        },
        audio: {
            disableWebAudio: true
        },
        render: {
            imageSmoothingEnabled: false,
            transparent: true,
        },

        scene: [Boot, Welcome, Game, Loose, Win, Warning]
    };
    game = new Phaser.Game(config);
};

var destroyDragNDrop = () => {
    if (game) {
        game.destroy();
        game = null;
    }
}

var game = null;

var bootState = function (game) {
};

bootState.prototype = {

    preload: function () {
        var d = new Date();
        var t = d.getTime();

        this.load.baseURL = "assets/games/shooting-hoops/assets/";
        this.load.image('loadingbar_border', 'ui/loadingbar_border.png?v=' + t);
        this.load.image('loadingbar', 'ui/loadingbar.png?v=' + t);
    },
    create: function () {
        this.scene.start("preload");
    }

};

var preloadState = function (game) {
};

preloadState.prototype = {
    init: function () {
        this.centerX = this.game.config.width * 0.5;
        this.centerY = this.game.config.height * 0.5;
    },
    preload: function () {
        this.progressTxt = this.add.text(game.scale.width / 2, game.scale.height / 2, "", {
            "fontFamily": "QuranEra",
            "fontSize": 25,
            "color": "#000000",
            "align": 'center'
        });
        this.progressTxt.setOrigin(0.5, 0.5);

        this.t = new Date().getTime();
        var t = this.t;
        this.load.baseURL = "assets/games/shooting-hoops/assets/";

        this.load.image("bg0", "bg0.png?v=" + t);

        this.load.image("ball_tally", "ui/ball_tally.png?v=" + t);
        this.load.image("ball_tally_10", "ui/ball_tally_10.png?v=" + t);
        this.load.image("tally_ball", "ui/tally_ball.png?v=" + t);
        this.load.image("tally_circle", "ui/tally_circle.png?v=" + t);

        this.load.json('buttonsData', 'ui/buttons.json?v=' + t);
        this.load.image("ball", "ball.png?v=" + t);

        this.load.image("stand", "stand.png?v=" + t);
        this.load.image("ring", "ring.png?v=" + t);
        this.load.image("ground", "ground.png?v=" + t);

        this.load.image("hit_area", "hit_area.png?v=" + t);
        this.load.image("text_hit_area", "text_hit_area.png?v=" + t);

        this.load.image("shooting_hoops_title", "shooting_hoops_title.png");
        this.load.image("hand", "hand.png");


        //welcome

        this.load.image("greyRect", "greyRect.png?v=" + t);
        this.load.image("roundRect", "roundRect.png?v=" + t);
        this.load.image("titlerect", "titlerect.png?v=" + t);

        this.load.image("snail", "snail.png?v=" + t);
        this.load.image("welcomeText", "welcomeText.png?v=" + t);
        this.load.image("leaf", "leaf.png?v=" + t);
        this.load.image("leaf2", "leaf2.png?v=" + t);

        //loose
        this.load.image("looseBg", "looseBg.png?v=" + t);
        this.load.image("tryagainBoard", "tryagainBoard.png?v=" + t);

        this.load.image("badge", "badge.png?v=" + t);
        this.load.image("bigstar", "bigstar.png?v=" + t);
        this.load.image("ribbon", "ribbon.png?v=" + t);
        this.load.image("totalScoreText", "totalScoreText.png?v=" + t);

        // win

        this.load.image("congratsTitle", "congratsTitle.png?v=" + t);

        this.load.image("winBoard", "tryagainBoard.png?v=" + t);
        this.load.image("completionBg", "completionBg.png?v=" + t);
        this.load.image("ribboncomplete", "ribboncomplete.png?v=" + t);

        this.load.image("trophy", "trophy.png?v=" + t);
        this.load.image("winstar", "winstar.png?v=" + t);
        this.load.image("star1", "star1.png?v=" + t);
        this.load.image("star1", "star1.png?v=" + t);

        //warning

        this.load.image("warningbg", "warningbg.png?v=" + t);
        this.load.image("warningboard", "warningboard.png?v=" + t);
        this.load.image("sign", "sign.png?v=" + t);

        //sprite Sheets

        this.load.atlas('buttons', 'ui/buttons.png?v=' + t, 'ui/buttons.json?v=' + t);
        this.load.atlas('closeButton', 'ui/closeButton.png?v=' + t, 'ui/closeButton.json?v=' + t);

        //audio

        this.load.audio("win_sound", "audio/win.mp3?v=" + t);
        this.load.audio("fail_sound", "audio/fail.mp3?v=" + t);

        this.load.audio("Draganddropinstruction", "audio/Draganddropinstruction.mp3?v=" + t);

        this.load.audio("buttonclick", "audio/buttonclick.mp3?v=" + t);
        this.load.audio("buttonhover", "audio/buttonhover.mp3?v=" + t);

        this.load.audio("bgmusic", "audio/bgmusic.mp3?v=" + t);
        this.load.audio("throwing_ball", "audio/throwing_ball.mp3?v=" + t);
        this.load.audio("warning", "audio/warning.mp3?v=" + t);

        this.load.audio("correct_click_1", "audio/correct_click_1.mp3?v=" + t);
        this.load.audio("correct_click_2", "audio/correct_click_2.mp3?v=" + t);
        this.load.audio("wrong_click", "audio/wrong_click.mp3?v=" + t);

        this.load.audio("activity_completion", "audio/activity_completion.mp3?v=" + t);

        this.load.on('progress', this.updateBar, this);

    },
    updateBar: function (p) {
        this.progressTxt.text = Math.ceil(p * 100) + "%";
    },
    create: function () {
        preloadState.obj = this;
        var t = this.t;
        send(Global.json, this.onResponse);
    },
    onResponse: function () {
        preloadState.obj.scene.start("welcome"); //welcome
    }

};

var welcomeState = function (game) {

};

welcomeState.prototype = {
    preload: function () {
        for (var i = 0; i < Global.questionsArr.length; i++) {
            var question = Global.questionsArr[i];
            if (question.questionImg != "") {
                if (!question.questionImg.startsWith("http")) {
                    this.load.image("Q" + (i + 1), "assets/games/shooting-hoops/assets/imgs/words/" + question.questionImg + ".png");
                }
                else {
                    this.load.image("Q" + (i + 1), question.questionImg);
                }
            }
            for (var j = 0; j < Global.optionsArr[i].length; j++) {
                var option = Global.optionsArr[i][j];

                if (option.img != "") {

                    if (!option.img.startsWith("http")) {
                        this.load.image("Q" + (i + 1) + "_op" + (j + 1), "assets/games/shooting-hoops/assets/imgs/words/" + option.img + ".png");
                    }
                    else {
                        this.load.image("Q" + (i + 1) + "_op" + (j + 1), option.img);
                    }
                }
            }
        }
    },

    init: function () {
        this.instructionSound = this.sound.add("Draganddropinstruction");

        this.clickSound = this.sound.add("buttonclick");
        this.hoverSound = this.sound.add("buttonhover");

    },
    create: function () {

        this.centerX = this.game.config.width * 0.5;
        this.centerY = this.game.config.height * 0.5;

        var greyRect = this.add.sprite(0, 0, "greyRect");
        greyRect.setOrigin(0);

        var leaf = this.add.sprite(111.05, 428.1, "leaf");
        var leaf2 = this.add.sprite(877.25, 174.05, "leaf2");

        var roundRect = this.add.sprite(this.centerX, this.centerY, "roundRect");
        var titlerect = this.add.sprite(this.centerX, 102, "titlerect");
        var welcomeText = this.add.sprite(this.centerX, 102, "shooting_hoops_title");
        welcomeText.setScale(0.8);

        var playBtn = this.add.sprite(this.centerX, 459.1, "buttons", "playBtn");
        playBtn.setInteractive();


        this.soundButton = this.add.sprite(719.15, 97.5, "buttons", "soundBtn");
        this.soundButton.setInteractive();

        playBtn.on('pointerdown', this.onButtonClick, this);

        playBtn.on('pointerover', function () {
            this.onHover(playBtn, "playBtnHover");
        }, this);
        playBtn.on('pointerout', function () {
            this.onHover(playBtn, "playBtn");
        }, this);

        this.soundButton.on('pointerdown', this.onSoundButtonClick, this);
        this.soundButton.on('pointerover', function () {
            this.onHover(this.soundButton, "soundBtnHover")
        }, this);
        this.soundButton.on('pointerout', function () {
            this.onHover(this.soundButton, "soundBtn")
        }, this);

        //var str = "This quiz has 15 questions.\n\nYou need to pass the quiz to \n\nget through to the next zone.\n\nGood Luck!";
        var str = "Shoot the ball into the hoop \n\nby matching the words.";
        var style = {fontFamily: 'Kids Rock DEMO', fontSize: 28, color: '#43425D', align: 'center'/*, strokeThickness: 2*/ };

        var paragraph = this.add.text(this.centerX + 10, this.centerY, str, style);
        paragraph.setOrigin(0.5, 0.5);

        try {
            this.instructionSound.play();
        } catch (e) {
            console.error(e);
        }

        /*var tween = this.tweens.add({
            targets: playBtn,
            scale:0.8,
            duration: 100,
            ease: 'Power2',
            yoyo: true,
            paused: true
        });

           var tween1 = this.tweens.add({
            targets: playBtn,
            scale:1.1,
            duration: 100,
            ease: 'Power2',
            paused: true,
        });*/


    },
    onButtonClick: function () {
        this.instructionSound.stop();

        this.playSound("clickSound");
        this.scene.start("game");
    },
    onHover: function (gameObject, frame) {
        var str = frame.substr(frame.length - 5, frame.length);
        if (str === "Hover") {
            this.playSound("hoverSound");
        }

        gameObject.setFrame(frame);
    },
    onSoundButtonClick: function () {
        this.playSound("clickSound");
        this.instructionSound.play();
        //this.instructionSound.play();

    },

    playSound: function (str) {
        if (Global.soundOnFlag === false) {
            return;
        }
        if (str === "clickSound") {
            this.clickSound.play();
        } else if (str === "hoverSound") {
            this.hoverSound.play();
        }
    }

};

var looseState = function (game) {

};

looseState.prototype = {

    create: function () {
        Global.score = 0;

        var failsound = this.sound.add('fail_sound');
        failsound.play();


        this.centerX = this.game.config.width * 0.5;
        this.centerY = this.game.config.height * 0.5;

        this.clickSound = this.sound.add("buttonclick");
        this.hoverSound = this.sound.add("buttonhover");

        var looseBg = this.add.sprite(0, 0, "looseBg");
        looseBg.setOrigin(0);
        var tryagainBoard = this.add.sprite(this.centerX, this.centerY, "tryagainBoard");

        var ribbon = this.add.sprite(490, 204, "ribbon");

        var bigstar = this.add.sprite(273.05, 354.1, "bigstar");
        bigstar.setScale(0);

        var badge = this.add.sprite(this.game.config.width / 2 - 15, this.game.config.height / 2 + 100, "badge");

        var totalScoreText = this.add.sprite(this.game.config.width / 2 + 30, this.game.config.height / 2 - 10, "totalScoreText");

        var textStyle = { fontSize: "28px", fontFamily: 'Kids Rock DEMO', align: "center", fill: "#fed210", stroke: "#91301a", strokeThickness: 7 }

        var scoreField = this.add.text(this.game.config.width / 2 + 170, this.game.config.height / 2 - 5,
            String(window.angularComponentRef ? window.angularComponentRef.component.userInfo.totalScore : 0),
            textStyle);
        scoreField.setOrigin(0, 0.5);
        scoreField.setScale(0);

        var textStyle1 = { fontSize: "22px", fontFamily: "Kids Rock DEMO", align: "center", fill: "#ffffff", stroke: "#ffffff" }

        var badgeField = this.add.text(this.game.config.width / 2, this.game.config.height / 2 + 90, "+" + Global.score.toString(), textStyle1);
        badgeField.setOrigin(0.5, 0.5);
        badgeField.setLineSpacing(10);
        badgeField.setStroke("#ffffff", 0.2);

        var backtoMenu = this.add.sprite(457, 520, "buttons", "backtomenu");

        backtoMenu.setInteractive();
        backtoMenu.on('pointerdown', this.onBackButtonClick, this);

        backtoMenu.on('pointerover', function () {
            this.onHover(backtoMenu, "backtomenuHover");
        }, this);
        backtoMenu.on('pointerout', function () {
            this.onHover(backtoMenu, "backtomenu");
        }, this);

        var playAgainBtn = this.add.sprite(609, 520, "buttons", "playagainBtn");


        var tween = this.tweens.add({
            targets: bigstar,
            scale: 1,
            ease: 'Power1',
            duration: 500,
        });

        var tween2 = this.tweens.add({
            targets: scoreField,
            scale: 1,
            ease: 'Power1',
            duration: 200,
        });


        /*var tween = this.tweens.add({
            targets: playAgainBtn,
            scale:0.8,
            duration: 100,
            ease: 'Power2',
            yoyo: true,
            paused: true
        });

           var tween1 = this.tweens.add({
            targets: playAgainBtn,
            scale:1.1,
            duration: 100,
            ease: 'Power2',
            paused: true,
        });*/

        playAgainBtn.setInteractive();
        playAgainBtn.on('pointerdown', this.onPlayAgainButtonClick, this);

        playAgainBtn.on('pointerover', function () {
            this.onHover(playAgainBtn, "playagainBtnHover");
        }, this);
        playAgainBtn.on('pointerout', function () {
            this.onHover(playAgainBtn, "playagainBtn");
        }, this);

    },
    onPlayAgainButtonClick: function () {
        this.playSound("clickSound");
        this.scene.start("welcome");
    },
    onBackButtonClick: function () {
        this.playSound("clickSound");
        //this.scene.start("welcome");
        if (window.angularComponentRef) window.angularComponentRef.backToMenu();
    },
    onHover: function (gameObject, frame) {
        var str = frame.substr(frame.length - 5, frame.length);
        if (str === "Hover") {
            this.playSound("hoverSound");
        }
        gameObject.setFrame(frame);
    },
    playSound: function (str) {
        if (Global.soundOnFlag === false) {
            return;
        }
        if (str === "clickSound") {
            this.clickSound.play();
        } else if (str === "hoverSound") {
            this.hoverSound.play();
        }
    }

};

var gameState = function (game) {
};

var winState = function (game) {

};


winState.prototype = {

    init: function () {
        this.activityCompletion = this.sound.add("activity_completion");
        if (window.angularComponentRef) window.angularComponentRef.gameFinish({ score: Global.score });
    },
    create: function () {
        this.activityCompletion.play();

        this.centerX = this.game.config.width * 0.5;
        this.centerY = this.game.config.height * 0.5;

        this.clickSound = this.sound.add("buttonclick");
        this.hoverSound = this.sound.add("buttonhover");

        var winBg = this.add.sprite(0, 0, "completionBg");
        winBg.setOrigin(0);

        var tryagainBoard = this.add.sprite(this.centerX, this.centerY, "winBoard");

        var ribboncomplete = this.add.sprite(this.centerX, 190.05, "ribboncomplete");

        var trophy = this.add.sprite(273.05, 354.1, "trophy");
        trophy.setScale(0);
        var badge = this.add.sprite(this.game.config.width / 2 - 15, this.game.config.height / 2 + 100, "badge");


        var tween = this.tweens.add({
            targets: trophy,
            scale: 1,
            ease: 'Power1',
            duration: 500,
        });



        var winstar = this.add.sprite(485.1, 48, "winstar");

        var totalScoreText = this.add.sprite(this.game.config.width / 2 + 30, this.game.config.height / 2 - 10, "totalScoreText");

        var style = {
            fontSize: "28px",lineSpaceng:25, fontFamily: "Kids Rock DEMO", align: "center",
            fill: "#fed210", stroke: "#91301a", strokeThickness: 7
        }

        var scoreField = this.add.text(650, 298, String(window.angularComponentRef ? window.angularComponentRef.component.userInfo.totalScore : 0), style);
        scoreField.setOrigin(0, 0.5);
        scoreField.setScale(0);

        var tween2 = this.tweens.add({
            targets: scoreField,
            scale: 1,
            ease: 'Power1',
            duration: 200,
        });

        var style2 = { fontFamily: "Kids Rock DEMO", fontSize: 23, color: '#ffffff', align: 'left' };

        var badgeField = this.add.text(489.95, 390.5, "+" + Global.score.toString(), style2);
        badgeField.setOrigin(0.5, 0.5);
        badgeField.setLineSpacing(10);
        badgeField.setStroke("#ffffff", 0.2);


        var backtoMenu = this.add.sprite(this.game.config.width / 2 - 35, this.game.config.height / 2 + 220, "buttons", "backtomenu");
        backtoMenu.setInteractive();

        var playAgainBtn = this.add.sprite(this.game.config.width / 2 + 120, this.game.config.height / 2 + 220, "buttons", "playagainBtn");
        playAgainBtn.setInteractive();

        var nextBtn = this.add.sprite(this.game.config.width / 2 + 280, this.game.config.height / 2 + 220, "buttons", "nextBtn");
        nextBtn.setInteractive();


        playAgainBtn.on('pointerdown', this.onPlayButtonClick, this);
        backtoMenu.on('pointerdown', this.onBackButtonClick, this);
        nextBtn.on('pointerdown', this.onNextButtonClick, this);

        playAgainBtn.on('pointerover', function () { this.onHover(playAgainBtn, "playagainBtnHover"); }, this);
        playAgainBtn.on('pointerout', function () { this.onHover(playAgainBtn, "playagainBtn"); }, this);

        backtoMenu.on('pointerover', function () { this.onHover(backtoMenu, "backtomenuHover"); }, this);
        backtoMenu.on('pointerout', function () { this.onHover(backtoMenu, "backtomenu"); }, this);

        nextBtn.on('pointerover', function () { this.onHover(nextBtn, "nextBtnHover"); }, this);
        nextBtn.on('pointerout', function () { this.onHover(nextBtn, "nextBtn"); }, this);


    },
    onPlayButtonClick: function () {
        this.playSound("clickSound");

        this.scene.start("welcome");
    },
    onBackButtonClick: function () {
        this.playSound("clickSound");
        if (window.angularComponentRef) window.angularComponentRef.backToMenu()
    },
    onNextButtonClick: function () {
        this.playSound("clickSound");
        if (window.angularComponentRef) window.angularComponentRef.nextActivity();
    },
    onHover: function (gameObject, frame) {
        var str = frame.substr(frame.length - 5, frame.length);
        if (str === "Hover") { this.playSound("hoverSound"); }

        gameObject.setFrame(frame);
    },
    playSound: function (str) {
        if (Global.soundOnFlag === false) { return; }
        if (str === "clickSound") { this.clickSound.play(); }
        else if (str === "hoverSound") { this.hoverSound.play(); }
    }

};

var warningState = {

    warningPopup: function (_this, _visibleFlag) {
        _this.warningSound = _this.sound.add("warning");

        _this.warningContainer = _this.add.container(0, 0);
        _this.warningContainer.visible = _visibleFlag;

        this.gameState = _this;

        var warningBg = _this.add.sprite(0, 0, "warningbg");
        warningBg.setOrigin(0);
        _this.warningContainer.add(warningBg);

        var leaf = _this.add.sprite(111.05, 428.1, "leaf");
        _this.warningContainer.add(leaf);

        var leaf2 = _this.add.sprite(877.25, 174.05, "leaf2");
        _this.warningContainer.add(leaf2);

        var warningboard = _this.add.sprite(490, 300, "warningboard");
        _this.warningContainer.add(warningboard);

        var sign = _this.add.sprite(488.15, 174, "sign");
        _this.warningContainer.add(sign);

        var yesBtn = _this.add.sprite(389.1, 452.15, "buttons", "yesBtn");
        _this.warningContainer.add(yesBtn);

        var noBtn = _this.add.sprite(585.15, 452.15, "buttons", "noBtn");
        _this.warningContainer.add(noBtn);

        yesBtn.setInteractive();
        noBtn.setInteractive();

        yesBtn.on('pointerdown', this.onYesButtonClick, this);
        noBtn.on('pointerdown', this.onNoButtonClick, this);

        yesBtn.on('pointerover', function () { _this.onHover(yesBtn, "yesBtnHover"); }, _this);
        yesBtn.on('pointerout', function () { _this.onHover(yesBtn, "yesBtn"); }, _this);

        noBtn.on('pointerover', function () { _this.onHover(noBtn, "noBtnHover"); }, _this);
        noBtn.on('pointerout', function () { _this.onHover(noBtn, "noBtn"); }, _this);

        var str = "Your progress in this activity will not be saved.\n\nAre you sure you want to exit?";
        //var style = { fontFamily: 'kidsrock', fontSize: 26, color: '#a25122',align:'center',stroke:'#ffffff', strokeThickness:2};
        var style2 = { fontFamily: 'Kids Rock DEMO', fontSize: 27, color: '#43425d', align: 'center', stroke: '#ffffff', strokeThickness: 2 };


        var paragraph = _this.add.text(170, 270, str, style2);
        _this.warningContainer.add(paragraph);

    },
    showWarning: function (_this) {

        _this.warningSound.play();

        _this.warningContainer.visible = true;
    },
    hideWarning: function (_this) {
        _this.warningSound.stop();
        _this.warningContainer.visible = false;
    },

    onYesButtonClick: function () {
        this.gameState.playSound("clickSound");
        if (window.angularComponentRef) window.angularComponentRef.backToMenu();
    },
    onNoButtonClick: function () {
        this.gameState.playSound("clickSound");
        this.hideWarning(this.gameState);
    }

};

gameState.prototype = {

    init: function () {
        gameState.obj = this;
        this.cx = this.cameras.main.centerX;
        this.cy = this.cameras.main.centerY;

        this.mouseStartX;
        this.mouseStartY;
        this.mouseEndX;
        this.mouseEndY;

        this.qCount = 0;
        this.totalQuestions = Global.actualQCnt;
        this.gameOverFlag = false;

        this.ballDownwardFlag = false;
        this.ballGroundFlag = false;
        this.shootedFlag = false;

        this.failCount = 0;

        this.selectedOption = "";

        this.scaleTween;

        this.tallyBallsArr = [];

        Global.score = 0;

    },
    create: function () {
        this.setScreen();

        this.updateQuestions();

        this.addUI();

        this.addPlatfoms();

        this.addEvents();


        this.clickSound = this.sound.add("buttonclick");
        this.hoverSound = this.sound.add("buttonhover");

        this.winSound1 = this.sound.add("correct_click_1");
        this.winSound2 = this.sound.add("correct_click_2");
        this.wrongSound = this.sound.add("wrong_click");
        this.throwing_ball = this.sound.add("throwing_ball");
        this.bgmusic = this.sound.add("bgmusic");
        this.bgmusic.setLoop(true);
        this.bgmusic.play();


        warningState.warningPopup(this, false);

    },

    setScreen: function () {
        var bg = this.add.image(0, 0, "bg0");
        bg.setScale(1.02);
        bg.setOrigin(0);

        var stand_1 = this.add.sprite(498 - 262, 260, "stand");
        var stand_2 = this.add.sprite(498, 260, "stand");
        var stand_3 = this.add.sprite(498 + 262, 260, "stand");

        this.ringGroup = this.add.group();

        this.ring_1 = this.ringGroup.create(486.35 - 262, 229, "ring");
        this.ring_2 = this.ringGroup.create(486.35, 229, "ring");
        this.ring_3 = this.ringGroup.create(486.35 + 262, 229, "ring");

        var textStyle = {
            font: "75px QuranEra",
            fill: '#000000',
            fontWeight: 'bold',
            align: 'center',
            stroke: "#ffffff",
            fixedWidth: 180,
            fixedHeight: 170
        };

        var opt_ypos = 158;

        this.optionA = {
            x: this.ring_1.x,
            y: opt_ypos,
            text: this.add.text(this.ring_1.x, opt_ypos, "", textStyle).setOrigin(0.5, 0.5).setLineSpacing(10),
            sprite: this.add.sprite(this.ring_1.x, opt_ypos - 30, "").setOrigin(0.5, 0.5),
            type: "optionA",
            id: 1
        };

        this.optionB = {
            x: this.ring_2.x,
            y: opt_ypos,
            text: this.add.text(this.ring_2.x, opt_ypos, "", textStyle).setOrigin(0.5, 0.5).setLineSpacing(10),
            sprite: this.add.sprite(this.ring_2.x, opt_ypos - 30, "").setOrigin(0.5, 0.5),
            type: "optionB",
            id: 2
        };

        this.optionC = {
            x: this.ring_3.x,
            y: opt_ypos,
            text: this.add.text(this.ring_3.x, opt_ypos, "", textStyle).setOrigin(0.5, 0.5).setLineSpacing(10),
            sprite: this.add.sprite(this.ring_3.x, opt_ypos - 30, "").setOrigin(0.5, 0.5),
            type: "optionC",
            id: 3
        };

        this.ball = this.matter.add.image(500, 480, "ball");
        this.ball.setCircle();
        this.ball.setFriction(0.005);
        this.ball.setBounce(0.3);
        this.ball.setStatic(true);
        this.ball.soundPlayed = false;

        this.ball.scaleX = 0.75;
        this.ball.scaleY = 0.75;
        this.ball.ringFlag = false;

        this.ball.ix = this.ball.x;
        this.ball.iy = this.ball.y;

        var qtextStyle = {
            font: "50px QuranEra",
            fill: '#000000',
            fontWeight: 'bold',
            align: 'center',
            stroke: "#ffffff",
            fixedWidth: 80,
            fixedHeight: 80
        };

        this.qField = {

            text: this.add.text(this.ball.x, this.ball.y, "", qtextStyle).setOrigin(0.5, 0.5),
            sprite: this.add.sprite(this.ball.x, this.ball.y, "").setOrigin(0.5, 0.5),
            answer: 0
        };

        this.ringGroupf = this.add.group();

        this.ring_1f = this.ringGroupf.create(486.35 - 262, 229, "ring");
        this.ring_2f = this.ringGroupf.create(486.35, 229, "ring");
        this.ring_3f = this.ringGroupf.create(486.35 + 262, 229, "ring");

        this.ring_1f.visible = false;
        this.ring_2f.visible = false;
        this.ring_3f.visible = false;

    },
    addPlatfoms: function () {

        this.ground = this.matter.add.image(489, 1500, 'ground', null, { restitution: 0.4, isStatic: true });

        this.platformA1 = this.matter.add.image(162.55, 232 + 2000, 'hit_area', null, {
            restitution: 0.4,
            isStatic: true
        });
        this.platformA2 = this.matter.add.image(290.60, 232 + 2000, 'hit_area', null, {
            restitution: 0.4,
            isStatic: true
        });

        this.platformB1 = this.matter.add.image(424.60, 232 + 2000, 'hit_area', null, {
            restitution: 0.4,
            isStatic: true
        });
        this.platformB2 = this.matter.add.image(552.65, 232 + 2000, 'hit_area', null, {
            restitution: 0.4,
            isStatic: true
        });

        this.platformC1 = this.matter.add.image(690.70, 232 + 2000, 'hit_area', null, {
            restitution: 0.4,
            isStatic: true
        });
        this.platformC2 = this.matter.add.image(817.75, 232 + 2000, 'hit_area', null, {
            restitution: 0.4,
            isStatic: true
        });

        this.ground.alpha = 0;
        this.platformA1.alpha = 0;
        this.platformA2.alpha = 0;
        this.platformB1.alpha = 0;
        this.platformB2.alpha = 0;
        this.platformC1.alpha = 0;
        this.platformC2.alpha = 0;

        this.platformA1.ix = this.platformA1.x;
        this.platformA2.ix = this.platformA2.x;

        this.platformB1.ix = this.platformB1.x;
        this.platformB2.ix = this.platformB2.x;

        this.platformC1.ix = this.platformC1.x;
        this.platformC2.ix = this.platformC2.x;

        this.matter.world.on('collisionstart', this.onCollision, this);
    },

    changePlatfomPos: function () {
        this.ground.y = 508;
        this.platformA1.y = 232;
        this.platformA2.y = 232;

        this.platformB1.y = 232;
        this.platformB2.y = 232;

        this.platformC1.y = 232;
        this.platformC2.y = 232;

        if (this.answer === false) {
            this.platformA1.x = this.ring_1.x - 23;
            this.platformA2.x = this.ring_1.x + 23;

            this.platformB1.x = this.ring_2.x - 23;
            this.platformB2.x = this.ring_2.x + 23;

            this.platformC1.x = this.ring_3.x - 23;
            this.platformC2.x = this.ring_3.x + 23;
        } else {

            this.platformA1.x = this.platformA1.ix;
            this.platformA2.x = this.platformA2.ix;

            this.platformB1.x = this.platformB1.ix;
            this.platformB2.x = this.platformB2.ix;

            this.platformC1.x = this.platformC1.ix;
            this.platformC2.x = this.platformC2.ix;
        }

    },
    resetPlatfoms: function () {
        this.ground.y = 1500;
        this.platformA1.y = 2232;
        this.platformA2.y = 2232;

        this.platformB1.y = 2232;
        this.platformB2.y = 2232;

        this.platformC1.y = 2232;
        this.platformC2.y = 2232;

    },
    onCollision: function (event, bodyA, bodyB) {
        var self = this;

        if (bodyA.gameObject.texture.key === "ball" && bodyB.gameObject.texture.key === "hit_area" && this.ball.soundPlayed === false) {
            this.ball.soundPlayed = true;

            if (this.answer === false) {
                this.playSound("wrong");
            }
        }

        var typeA = bodyA.gameObject.texture.key;
        var typeB = bodyB.gameObject.texture.key;

        if (typeA != "ground" && typeB != "ground") {
            return;
        }


        if (this.ballGroundFlag === false) {
            this.ballGroundFlag = true;

            setTimeout(function () {
                self.onBallFallingComplete();
            }, 1500);

        }

    },
    onBallFallingComplete: function () {
        if (this.qCount === this.totalQuestions - 1) {
            this.onGameOver("finished");
            return;
        }

        if (this.failCount === 3) {
            this.onGameOver("fail");
            return;
        }

        this.resetPlatfoms();

        this.ballGroundFlag = false;
        this.shootedFlag = false;
        this.ball.soundPlayed = false;

        this.ring_1f.visible = false;
        this.ring_2f.visible = false;
        this.ring_3f.visible = false;

        this.ring_1.visible = true;
        this.ring_2.visible = true;
        this.ring_3.visible = true;

        this.ball.setStatic(true);

        this.ball.x = 500;
        this.ball.y = 480;

        this.ball.scaleX = 0.75;
        this.ball.scaleY = 0.75;


        this.nextQuestion();
    },
    addUI: function () {

        var ballTally = {};

        if (Global.actualQCnt == 10) {
            ballTally = this.add.sprite(51, 294, "ball_tally_10");
        } else {
            ballTally = this.add.sprite(51, 246, "ball_tally");
        }

        this.tallyBallGroup = this.add.group();
        this.tallyCircleGroup = this.add.group();

        for (var i = 0; i < Global.actualQCnt; i++) {
            var xpos = 50.5;
            var ypos = 82.05 + i * 46.6;
            var ball = this.tallyBallGroup.create(xpos, ypos, "tally_ball");
            var circle = this.tallyCircleGroup.create(xpos, ypos, "tally_circle");

            ball.visible = false;
            circle.visible = false;
        }

        this.closeButton = this.add.sprite(933.2, 48.05, "closeButton", "closeButton");

        this.soundButton = this.add.sprite(933.2, 130, "buttons", "soundBtn");

        this.soundButton.visible = false;

        var handX = ({
            1: this.optionA,
            2: this.optionB,
            3: this.optionC
        })[this.qField.answer].sprite.x;

        this.hand = this.add.sprite(handX, 0, "hand");
        this.hand.setOrigin(0.5, 0);
        this.hand.scaleX = 0.8;
        this.hand.scaleY = 0.8;

        this.tweens.add({
            targets: this.hand,
            y: this.hand.y + 15,
            duration: 650,
            ease: 'Linear',
            yoyo: true,
            repeat: 1000
        });

    },
    addEvents: function () {
        this.ball.setInteractive();

        this.closeButton.setInteractive();
        this.closeButton.on('pointerdown', this.onCloseButtonClick, this);

        this.closeButton.on('pointerover', function () {
            this.onHover(this.closeButton, "closeButtonHover")
        }, this);
        this.closeButton.on('pointerout', function () {
            this.onHover(this.closeButton, "closeButton")
        }, this);

        this.optionA.type = "optionA";
        this.optionB.type = "optionB";
        this.optionC.type = "optionC";

        this.hitAreaA = this.add.sprite(this.optionA.x, this.optionA.y, "text_hit_area");
        this.hitAreaB = this.add.sprite(this.optionB.x, this.optionB.y, "text_hit_area");
        this.hitAreaC = this.add.sprite(this.optionC.x, this.optionC.y, "text_hit_area");

        this.hitAreaA.setInteractive();
        this.hitAreaB.setInteractive();
        this.hitAreaC.setInteractive();

        this.hitAreaA.on('pointerdown', function () {
            this.onOptionClick(this.optionA);
        }, this);
        this.hitAreaB.on('pointerdown', function () {
            this.onOptionClick(this.optionB);
        }, this);
        this.hitAreaC.on('pointerdown', function () {
            this.onOptionClick(this.optionC);
        }, this);
    },
    onHover: function (gameObject, frame) {
        var str = frame.substr(frame.length - 5, frame.length);
        if (str === "Hover") {
            this.playSound("hoverSound");
        }

        gameObject.setFrame(frame);
    },

    onOptionClick: function (gameObject) {
        if (this.gameOverFlag === true) {
            return;
        }
        if (this.shootedFlag === true) {
            return;
        }

        this.hand.visible = false;

        var optionType = gameObject.type;

        this.shootedFlag = true;
        this.ballDownwardFlag = false;


        var angle = -90;

        this.answer = false;

        var selectedAns = gameObject.id;

        this.selectedOption = gameObject.type;

        if (this.qField.answer === selectedAns) {
            this.answer = true;
        }

        if (gameObject.type === "optionA") {
            angle = -104.68;

            if (this.answer === false) {
                angle = -103.2;
            }
        } else if (gameObject.type === "optionB") {
            angle = -90.5;
            if (this.answer === false) {
                angle = -87.5;
            }

        }
        if (gameObject.type === "optionC") {
            angle = -76;
            if (this.answer === false) {
                angle = -78;
            }
        }


        var angleInRadians = angle * Math.PI / 180;
        this.targetAngle = angleInRadians;

        this.throwing_ball.play();

        this.moveBall(gameObject.type);

    },
    onCloseButtonClick: function () {
        warningState.showWarning(this);
    },

    onBallDown: function (event) {
        this.mouseStartX = event.downX;
        this.mouseStartY = event.downY;

    },
    moveBall: function (type) {
        if (this.gameOverFlag === true) {
            return;
        }

        var scale2 = 0.2;
        var scale3 = 0.28;
        var speed = 18;

        if (type === "optionA" || type === "optionC") {
            scale2 = 0.2;
            scale3 = 0.28;

            if (this.answer === true) {
                speed = 19;
            }
        }

        this.ball.setStatic(false);

        var angleR = this.targetAngle;
        var vx = Math.cos(angleR) * speed;
        var vy = Math.sin(angleR) * speed;

        this.ball.setVelocityX(vx);
        this.ball.setVelocityY(vy);

        if (this.selectedOption === "optionC" && this.answer === false) {
            this.ball.setAngularVelocity(-0.1);
        } else if (this.selectedOption === "optionB" && this.answer === false) {
            this.ball.setAngularVelocity(0.1);
        } else if (this.selectedOption === "optionA") {
            this.ball.setAngularVelocity(-0.1);
        } else {
            this.ball.setAngularVelocity(0.1);
        }

        this.ball.ringFlag = false;

        var tween = this.tweens.add({
            targets: this.ball,
            scaleX: 0.6,
            scaleY: 0.6,
            delay: 0,
            duration: 1000
        });

        this.scaleTween = this.tweens.add({
            targets: this.ball,
            scaleX: scale2,
            scaleY: scale2,
            delay: 1000,
            duration: 200
        });


        this.scaleTween = this.tweens.add({
            targets: this.ball,
            scaleX: scale3,
            scaleY: scale3,
            delay: 300,
            duration: 1000
        });

    },

    update: function () {


        if (this.gameOverFlag === true) {
            return;
        }

        this.qField.text.x = this.ball.x;
        this.qField.text.y = this.ball.y;

        this.qField.text.scaleX = this.ball.scaleX * 2;
        this.qField.text.scaleY = this.ball.scaleY * 2;

        this.qField.sprite.x = this.ball.x;
        this.qField.sprite.y = this.ball.y;

        this.qField.sprite.scaleX = Math.min(1.2, this.ball.scaleX * 2);
        this.qField.sprite.scaleY = Math.min(1.2, this.ball.scaleY * 2);

        if (this.ball.body.velocity.y > 0) {
            this.onDownWard();
        }

    },
    onDownWard: function () {

        /*if(this.ball.soundPlayed === false)
        {
          var dy = Math.abs(this.ball.y-this.ring_1.y);

          console.log("dy: ",dy);

          if(this.answer === true && dy < 150)
          {
            this.ball.soundOnFlag = true;
            this.playSound("win" + Phaser.Math.Between(1, 2));
          }
        }*/

        if (this.ballDownwardFlag === false) {
            this.ballDownwardFlag = true;

            this.ring_1.visible = false;
            this.ring_2.visible = false;
            this.ring_3.visible = false;

            this.ring_1f.visible = true;
            this.ring_2f.visible = true;
            this.ring_3f.visible = true;

            this.changePlatfomPos();

        }

        if (this.ball.y >= 200 && this.ball.ringFlag === false) {
            this.ball.ringFlag = true;

            if (this.answer === true) {
                if (this["prev_win_id"]) {
                    this["prev_win_id"] = this["prev_win_id"] == 1 ? 2 : 1;
                } else {
                    this["prev_win_id"] = 1;
                }
                this.playSound("win" + this["prev_win_id"]);

                this.tallyBallGroup.children.entries[this.qCount].visible = true;

                this.setScore(1);

            } else if (this.answer === false) {
                this.tallyCircleGroup.children.entries[this.qCount].visible = true;

                this.failCount++;
            }
        }

    },
    setScore: function (n) {
        Global.score += n;
    },
    getAngle: function (pointA, pointB) {
        var dx = pointB.x - pointA.x;
        var dy = pointB.y - pointA.y;
        var angle2 = Math.atan2(dy, dx);
        return angle2;
    },
    playSound: function (str) {
        if (this.gameOverFlag === true) {
            return;
        }

        if (Global.soundOnFlag === false) {
            return;
        }

        if (str === "win1") {
            this.winSound1.play();
        } else if (str === "win2") {
            this.winSound2.play();
        } else if (str === "wrong") {
            this.wrongSound.play();
        } else if (str === "clickSound") {
            this.clickSound.play();
        } else if (str === "hoverSound") {
            this.hoverSound.play();
        }

    },

    updateQuestions: function () {
        var options = Global.optionsArr[this.qCount];

        var optionA = options[0];
        var optionB = options[1];
        var optionC = options[2];

        var qfield = Global.questionsArr[this.qCount];

        this.qField.answer = qfield.answer;

        if (qfield.questionImg != "") {
            this.qField.sprite.setTexture("Q" + (this.qCount + 1));
            this.qField.sprite.setVisible(true);
            this.qField.text.setVisible(false);
        } else {
            this.qField.text.setText(qfield.questionTxt);
            this.qField.text.setVisible(true);
            this.qField.sprite.setVisible(false);
        }

        var textStyle = {
            font: "75px QuranEra",
            fill: '#000000',
            fontWeight: 'bold',
            align: 'center',
            stroke: "#ffffff",
            fixedWidth: 180,
            fixedHeight: 170
        };

        if (optionA.img != "") {
            this.optionA.sprite.setTexture("Q" + (this.qCount + 1) + "_op1");
            this.optionA.sprite.setVisible(true);
            this.optionA.text.setVisible(false);
        } else {
            this.optionA.text.setText(optionA.text);
            this.optionA.sprite.setVisible(false);
            this.optionA.text.setVisible(true);
        }

        if (optionB.img != "") {
            this.optionB.sprite.setTexture("Q" + (this.qCount + 1) + "_op2");
            this.optionB.sprite.setVisible(true);
            this.optionB.text.setVisible(false);
        } else {
            this.optionB.text.setText(optionB.text);
            this.optionB.sprite.setVisible(false);
            this.optionB.text.setVisible(true);
        }

        if (optionC.img != "") {
            this.optionC.sprite.setTexture("Q" + (this.qCount + 1) + "_op3");
            this.optionC.sprite.setVisible(true);
            this.optionC.text.setVisible(false);
        } else {
            this.optionC.text.setText(optionC.text);
            this.optionC.sprite.setVisible(false);
            this.optionC.text.setVisible(true);
        }

    },
    nextQuestion: function () {
        if (this.qCount < this.totalQuestions - 1) {
            this.qCount++;
            this.updateQuestions();
        }

    },
    onGameOver: function (str) {
        var self = this;

        this.gameOverFlag = true;

        setTimeout(function () {

            self.bgmusic.stop();

            if (str === "fail") {
                self.scene.start("loose");
            } else if (str === "finished") {
                self.scene.start("win");
            }

        }, 500);
    }
};

var shootingHoops = (json) => {
    Global.json = json;
    Global.actualQCnt = json.data.length;
    let config = {

        type: Phaser.CANVAS,
        transparent: true,
        scale: {
            mode: Phaser.Scale.NONE,
            parent: 'game-holder',
            resolution: 1,
        },
        autoCenter: Phaser.Scale.CENTER_BOTH,

        physics: {
            default: "matter",
            matter: { debug: false },
            audio: { disableWebAudio: true }
        },
        dom: {
            createContainer: true
        }
    };

    if (typeof window.orientation !== 'undefined') {
        config.scale.mode = Phaser.Scale.FIT;
        config.scale.width = 980;
        config.scale.height = 600;
        config.autoCenter = Phaser.Scale.CENTER_BOTH;
        config.scale.resolution = 1;
    } else {
        config.scale.mode = Phaser.Scale.NONE;
        config.scale.width = 980;
        config.scale.height = 600;
        config.autoCenter = Phaser.Scale.CENTER_BOTH;
        config.scale.resolution = 1
    }

    game = new Phaser.Game(config);
    game.scene.add("boot", bootState);
    game.scene.add("preload", preloadState);

    game.scene.add("welcome", welcomeState);
    game.scene.add("win", winState);
    game.scene.add("loose", looseState);
    game.scene.add("warning", warningState);
    game.scene.add("game", gameState);
    game.scene.start("boot");

};

var Global = {};
Global.questionsArr = [];
Global.optionsArr = [];
Global.soundOnFlag = true;
Global.score = 0;

function send(json, callback) {
    onSuccess(json, callback);
}

function onSuccess(res, callback) {
    var arr = res.data;
    Global.questionsArr = [];
    Global.optionsArr = [];

    for (var i = 0; i < arr.length; i++) {
        Global.questionsArr.push(arr[i]);
        Global.optionsArr.push(arr[i].options);
    }

    callback();
}


function resize() {
    var canvas = document.querySelector("canvas");
    var windowWidth = window.innerWidth;
    var windowHeight = window.innerHeight;
    var windowRatio = windowWidth / windowHeight;
    var gameRatio = 980 / 600;

    if (windowRatio < gameRatio) {
        canvas.style.width = windowWidth + "px";
        canvas.style.height = (windowWidth / gameRatio) + "px";
    }
    else {
        canvas.style.width = 980;//(windowHeight * gameRatio) + "px";
        canvas.style.height = 600;//windowHeight + "px";
    }
}


var destroyShootingHoops = () => {
    if (game) {
        game.destroy();
    }

}

var sh;
var game;
function soundPads(json) {
    console.log(json);
    class FitScaleManager {
        constructor(game) {
            this.doResize = () => {
                let scale = this.calculateScale();
                let newCanvasWidth = this.phaserScaleManager.width * scale;
                let newCanvasHeight = this.phaserScaleManager.height * scale;
                this.canvasStyle.width = newCanvasWidth + 'px';
                this.canvasStyle.height = newCanvasHeight + 'px';
                this.canvasStyle.marginLeft = (window.innerWidth - newCanvasWidth) / 2 + 'px';
                this.canvasStyle.marginTop = (window.innerHeight - newCanvasHeight) / 2 + 'px';
            };
            this.game = game;
            this.canvasStyle = this.game.canvas.style;
            this.phaserScaleManager = this.game.scale;
        }
        static detectBestScaleMode() {
            let iOS = /iPad|iPhone|iPod/.test(navigator.platform || "");
            let isAndroid = window.navigator.userAgent.toLowerCase().indexOf("android") > -1;
            return iOS || isAndroid ? Phaser.Scale.FIT : Phaser.Scale.NONE;
        }
        ;
        /**
         * Just call this method once in Boot scene's init() method
         */
        setup() {
            this.phaserScaleManager.addListener(Phaser.Scale.Events.RESIZE, this.onResize, this);
            this.overridePhaserTransformMethods();
            this.onResize();
        }
        calculateScale() {
            if (game.scale.scaleMode ===
                Phaser.Scale.NONE)
                return 1;
            return Math.min(window.innerWidth / this.phaserScaleManager.width, window.innerHeight / this.phaserScaleManager.height);
        }
        overridePhaserTransformMethods() {
            this.game.scale.transformX = (pageX) => {
                return (pageX - parseInt(this.canvasStyle.marginLeft.split("px")[0])) / this.calculateScale();
            };
            this.game.scale.transformY = (pageY) => {
                return (pageY - parseInt(this.canvasStyle.marginTop.split("px")[0])) / this.calculateScale();
            };
        }
        onResize() {
            setTimeout(this.doResize, FitScaleManager.RESIZE_DELAY);
        }
    }
    FitScaleManager.RESIZE_DELAY = 500;



    (function (sh) {
        class App extends Phaser.Game {
            constructor(json) {

                App.json = json;

                let config = {
                    type: Phaser.AUTO,
                    width: App.CANVAS_WIDTH,
                    height: App.CANVAS_HEIGHT,
                    parent: 'game-container',
                    dom: {
                        createContainer: false
                    },
                    scale: {
                        mode: FitScaleManager.detectBestScaleMode(),
                        autoCenter: Phaser.Scale.CENTER_BOTH
                    },
                    transparent: true,
                    scene: {
                        create: () => {
                            this.scene.add('Boot', sh.scene.Boot, true);
                        }
                    }
                };
                super(config);
            }
        }
        App.CANVAS_WIDTH = 980;
        App.CANVAS_HEIGHT = 600;
        sh.App = App;
    })(sh || (sh = {}));

    game = new sh.App(json);

    let delayedCalls = [];
    function delayedCall(delay, callback, args, callbackScope) {
        let scene = game.scene.getAt(0);
        if (scene) {
            let dc = scene.time.delayedCall(delay, callback, args, callbackScope);
            delayedCalls.push(dc);
            return dc;
        }
        let t = setTimeout(callback, delay);
        delayedCalls.push(t);
        return t;
    }
    function pauseAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.paused = true;
            }
        }
    }
    function resumeAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.paused = false;
            }
        }
    }
    function destroyAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.remove(false);
            }
            else {
                clearTimeout(dc);
            }
        }
        delayedCalls = [];
    }
    function setPageBackground(bg) {
        document.querySelector("html").style.backgroundImage = "url(assets/games/sound-pads/imgs/" + bg + ".jpg)";
    }
    function setupButton(btn, frame) {
        btn.on('pointerdown', () => { btn.setFrame(frame + '_hover' + '0000'); });
        btn.on('pointerover', () => { btn.setFrame(frame + '_hover' + '0000'); game.scene.getAt(0).sound.add("button hover").play(); });
        btn.on('pointerout', () => { btn.setFrame(frame + '0000'); });
        btn.on('pointerup', () => { btn.setFrame(frame + '0000'); game.scene.getAt(0).sound.add('activity selection - button selection').play(); });
    }
    function setupButtonTextureBased(btn, texture, hoverTexture) {
        btn.on('pointerdown', () => { btn.setTexture(hoverTexture); });
        btn.on('pointerover', () => { btn.setTexture(hoverTexture); game.scene.getAt(0).sound.add("button hover").play(); });
        btn.on('pointerout', () => { btn.setTexture(texture); });
        btn.on('pointerup', () => { btn.setTexture(texture); game.scene.getAt(0).sound.add('activity selection - button selection').play(); });
    }
    /**
     * @author Roman Parada
     * This class is created to fix overlapping of bottom part of canvas by navigation bar in iOS.
     * It make a delayed resize of the canvas (like Phaser-3 FIT methods does) and it overrides Phaser-3 input window to Phaser-3 core transform methods
     *
     * How to use:
     * Just call the code line below in Boot scene's init() method of your project:
     * new FitScaleManager(this.game).setup();
     */


    (function (sh) {
        var core;
        (function (core) {
            class Gameplay {
                constructor() {
                    this.currentRound = 0;
                    this.correctAnswersCount = 0;
                    this.wrongAnswersCount = 0;
                    this.nextLetterDelay = 0;
                    this.reset();
                    let json = game.cache.json.get('gameplay');
                    this.wrongAnswersToLose = json["wrongAnswersToLose"];
                    this.numberOfQuestionsPerRound = json["numberOfQuestionsPerRound"];
                    this.lettersConfig = JSON.parse(JSON.stringify(json["lettersConfig"]));
                    this.rounds = JSON.parse(JSON.stringify(json["rounds"]));
                    this.numberOfRounds = this.rounds.length;
                }
                setupCallbacks(onComplete, onLose) {
                    this.onComplete = onComplete;
                    this.onLose = onLose;
                }
                onLetterChosen() {
                    if (this.isNewRound()) {
                        if (this.currentRound >= this.numberOfRounds - 1) {
                            this.onComplete(this.correctAnswersCount, this.correctAnswersCount);
                            return true;
                        }
                        else {
                            this.nextRound();
                        }
                    }
                    return false;
                }
                nextRound() {
                    let fn = () => {
                        if (this.currentRound == this.rounds.length) {
                            this.currentRound = 0;
                        }
                        else {
                            this.currentRound++;
                        }
                    };
                    if (this.nextLetterDelay == 0) {
                        fn();
                    }
                    else {
                        delayedCall(this.nextLetterDelay, fn);
                    }
                }
                getCorrectLetterName() {
                    return this.rounds[this.currentRound]['correctLetterName'];
                }
                isCorrectLetterAudioQuestionEnable() {
                    return this.rounds[this.currentRound]['audioQuestionEnable'];
                }
                getCorrectAudioKey() {
                    return this.lettersConfig[this.getCorrectLetterName()]['correctAudioKey'];
                }
                getCorrectAndLetterSoundSfxAudioKey() {
                    return this.lettersConfig[this.getCorrectLetterName()]['Sounds of the letters'];
                }
                onCorrectAnswer() {
                    this.correctAnswersCount++;
                    this.nextLetterDelay = 1500;
                    return this.onLetterChosen();
                }
                onWrongAnswer() {
                    this.wrongAnswersCount++;
                    this.nextLetterDelay = 1500;
                    if (this.wrongAnswersCount >= this.wrongAnswersToLose) {
                        this.onLose(0, 0);
                        return true;
                    }
                    return false;
                }
                getCurrentTotalAnswersCount() {
                    return this.correctAnswersCount + this.wrongAnswersCount;
                }
                isNewRound() {
                    return this.correctAnswersCount % this.numberOfQuestionsPerRound == 0;
                }
                isRoundsComplete() {
                    return this.correctAnswersCount / this.numberOfQuestionsPerRound >= this.numberOfRounds;
                }
                reset() {
                    this.nextLetterDelay = 0;
                    this.currentRound = 0;
                    this.correctAnswersCount = 0;
                    this.wrongAnswersCount = 0;
                }
                getCurrentRoundLetters() {
                    return this.rounds[this.currentRound]["letters"];
                }
            }
            core.Gameplay = Gameplay;
        })(core = sh.core || (sh.core = {}));
    })(sh || (sh = {}));

    (function (sh) {
        var scene;
        (function (scene) {
            class Boot extends Phaser.Scene {
                init() {
                    this.game.scale.transformX = (pageX) => {
                        let offsetLeft = 0;
                        let parentElement = game.canvas.parentElement;
                        while (parentElement) {
                            if (parentElement.offsetLeft) {
                                offsetLeft = parentElement.offsetLeft;
                                break;
                            }
                            parentElement = parentElement.parentElement;
                        }
                        return (pageX - offsetLeft) * this.game.scale.displayScale.x;
                    };
                    this.game.scale.transformY = (pageY) => {
                        let offsetTop = 0;
                        let parentElement = game.canvas.parentElement;
                        while (parentElement) {
                            if (parentElement.offsetTop) {
                                offsetTop = parentElement.offsetTop;
                                break;
                            }
                            parentElement = parentElement.parentElement;
                        }
                        return (pageY - offsetTop) * this.game.scale.displayScale.y;
                    };
                }
                create() {
                    game.scene.remove('Boot');
                    game.scene.add('Preloader', sh.scene.Preloader, true);
                }
            }
            scene.Boot = Boot;
        })(scene = sh.scene || (sh.scene = {}));
    })(sh || (sh = {}));

    (function (sh) {
        var scene;
        (function (scene) {
            var Gameplay = sh.core.Gameplay;
            class MainScene extends Phaser.Scene {
                create() {
                    this.gameplay = new Gameplay();
                    this.gameplayScreen = new sh.screen.GameplayScreen(this, this.gameplay);
                    this.children.add(this.gameplayScreen);
                    this.gameplayScreen.showInstructionPage();
                }
            }
            scene.MainScene = MainScene;
        })(scene = sh.scene || (sh.scene = {}));
    })(sh || (sh = {}));

    (function (sh) {
        var scene;
        (function (scene) {
            class Preloader extends Phaser.Scene {
                preload() {
                    if (typeof sh.App.json == "string") this.load.json('gameplay', sh.App.json); else this.game.cache.json.add('gameplay', sh.App.json);
                }
                create() {
                    let json = game.cache.json.get('gameplay');
                    let lettersConfig = json["lettersConfig"];
                    for (let letterName in lettersConfig) {
                        this.load.image(letterName, "assets/games/sound-pads/imgs/letters/" + letterName + ".png");
                        if (lettersConfig[letterName]["correctAudioKey"] == null) continue;
                        let correctAudioKey = lettersConfig[letterName]["correctAudioKey"];
                        this.load.audio(correctAudioKey, "assets/games/sound-pads/sound/mp3/letters/" + correctAudioKey + ".mp3");
                        this.load.audio(lettersConfig[letterName]["Sounds of the letters"], "assets/games/sound-pads/sound/mp3/letters/" + lettersConfig[letterName]["Sounds of the letters"] + ".mp3");
                    }

                    this.load.pack('preloader', 'assets/games/sound-pads/pack.json');
                    this.load.on('progress', (value) => {
                    }, this);
                    this.load.on('complete', () => {
                        this.nextScene();
                    });
                    this.load.start();
                }
                nextScene() {
                    game.scene.remove('Preloader');
                    game.scene.add('ScreenMain', sh.scene.MainScene, true);
                }
            }
            scene.Preloader = Preloader;
        })(scene = sh.scene || (sh.scene = {}));
    })(sh || (sh = {}));

    (function (sh) {
        var screen;
        (function (screen) {
            class AreYouSureWindow extends Phaser.GameObjects.Container {
                constructor(scene, onYes, onNo) {
                    super(scene);
                    this._areYouSurePage = new Phaser.GameObjects.Image(this.scene, -105, 0 - 48, 'Exit warning');
                    this._areYouSurePage.setOrigin(0, 0);
                    this._areYouSurePage.setInteractive();

                    var modalTextStyle = {
                        backgroundColor: 'transparent',
                        stroke: '#ffffff',
                        strokeThickness: 2,
                        lineSpacing: 15,
                        fontFamily: 'Kids Rock DEMO',
                        fontSize: 27,
                        color: '#43425d',
                        wordWrap: true,
                        align: 'center'
                    };
                    var modalText = this.scene.add.text(game.scale.width / 2 + 12, game.scale.height / 2, "Your progress in this activity will not be saved. \n Are you sure you want to exit? ", modalTextStyle);
                    modalText.setOrigin(0.5, 0.5);


                    this._btnSureYes = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2 - 95, 485 - 50, 'btnYES1');
                    this._btnSureYes.setInteractive({ cursor: 'pointer' });
                    this._btnSureYes.once('pointerup', () => {
                        onYes;
                        angularComponentRef.backToMenu();
                    });


                    setupButtonTextureBased(this._btnSureYes, 'btnYES1', 'btnYES2');
                    this._btnSureNo = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2 + 95, 485 - 50, 'btnNO1');
                    this._btnSureNo.setInteractive({ cursor: 'pointer' });
                    this._btnSureNo.once('pointerup', onNo);
                    setupButtonTextureBased(this._btnSureNo, 'btnNO1', 'btnNO2');
                    this.add(this._areYouSurePage);
                    this.add(this._btnSureYes);
                    this.add(this._btnSureNo);
                    this.add(modalText);
                }
            }
            screen.AreYouSureWindow = AreYouSureWindow;
        })(screen = sh.screen || (sh.screen = {}));
    })(sh || (sh = {}));

    (function (sh) {
        var screen;
        (function (screen) {
            class CompleteWindow extends Phaser.GameObjects.Container {
                constructor(scene, onBack, onReplay, onNext) {
                    super(scene);
                    this.music = null;
                    this.setPosition(-104.5, -48);
                    this._bgComplete = new Phaser.GameObjects.Image(this.scene, 0, 0, 'Completion page LATEST UPDATED');
                    this._bgComplete.setOrigin(0, 0);
                    this._bgComplete.setInteractive();
                    this._cup = new Phaser.GameObjects.Image(this.scene, 400, 410, 'Trophy');
                    this._btnBack = new Phaser.GameObjects.Image(this.scene, 570, 570, 'btnBACK1');
                    this._btnReplay = new Phaser.GameObjects.Image(this.scene, 720, 570, 'btnReplay1');
                    this._btnNext = new Phaser.GameObjects.Image(this.scene, 870, 570, 'btnNEXT1');
                    let _CollectedPoints = new Phaser.GameObjects.Image(this.scene, 620, 440, 'Collected Points');
                    this.totalScoreTxt = this.scene.add.text(845, 352, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 35,
                        "color": "#F49F1C",
                        "align": 'center',
                        'stroke': '#70451A',
                        'strokeThickness': 6
                    });
                    this.totalScoreTxt.setOrigin(0.5, 0.5);
                    let grd = this.totalScoreTxt.context.createLinearGradient(0, 0, 0, this.totalScoreTxt.height);
                    grd.addColorStop(0, '#FFFF00');
                    grd.addColorStop(1, '#C17316');
                    this.totalScoreTxt.setFill(grd);
                    this.starScoreTxt = this.scene.add.text(648, 433, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 24,
                        "color": "#FFFFFF",
                        "align": 'center'
                    });
                    this.starScoreTxt.setOrigin(0.5, 0.5);
                    this.add([
                        this._bgComplete,
                        _CollectedPoints,
                        this._cup,
                        this._btnBack,
                        this._btnReplay,
                        this._btnNext,
                        this.totalScoreTxt,
                        this.starScoreTxt
                    ]);
                    this._btnBack.setInteractive({ cursor: 'pointer' });
                    this._btnBack.on('pointerup', () => {
                        onBack(this._btnBack);
                        angularComponentRef.backToMenu();
                        // if (this.music) {
                        //     this.music.stop();
                        // }
                    });
                    setupButtonTextureBased(this._btnBack, 'btnBACK1', 'btnBACK2');
                    this._btnReplay.setInteractive({ cursor: 'pointer' });
                    this._btnReplay.once('pointerup', () => {
                        onReplay(this._btnReplay);
                        if (this.music) {
                            this.music.stop();
                        }
                    });
                    setupButtonTextureBased(this._btnReplay, 'btnReplay1', 'btnReplay2');
                    this._btnNext.setInteractive({ cursor: 'pointer' });
                    this._btnNext.on('pointerup', () => {
                        onNext(this._btnNext);
                        window.angularComponentRef.nextActivity();
                        // if (this.music) {
                        //     this.music.stop();
                        // }
                    });
                    setupButtonTextureBased(this._btnNext, 'btnNEXT1', 'btnNEXT2');
                }
                show(score, starScore) {
                    window.angularComponentRef.gameFinish({ score, starScore })
                    this._cup.scale = 1.25;
                    this.scene.tweens.add({
                        targets: this._cup,
                        "scale": 1,
                        duration: 500,
                        ease: Phaser.Math.Easing.Back.Out
                    });
                    this.totalScoreTxt.text = String(score);
                    this.starScoreTxt.text = String(starScore);
                    // let music = this.scene.sound.add("viktory");
                    this.music = this.scene.sound.add("Activity completion fantastic");
                    this.music.play();
                }
            }
            screen.CompleteWindow = CompleteWindow;
        })(screen = sh.screen || (sh.screen = {}));
    })(sh || (sh = {}));

    (function (sh) {
        var screen;
        (function (screen) {
            class GameplayScreen extends Phaser.GameObjects.Container {
                constructor(scene, gameplay) {
                    super(scene);
                    this.hexagonPositions = [
                        { x: 275, y: 165 }, { x: 500, y: 165 }, { x: 725, y: 165 },
                        { x: 275, y: 385 }, { x: 500, y: 385 }, { x: 725, y: 385 }
                    ];
                    this.bgMusic = null;
                    this.correctAudio = null;
                    this.wfsnd = null;
                    this.showCompleteWindow = (score, starScore) => {
                        let completeWindow = new screen.CompleteWindow(this.scene, (target) => {
                            this.playBtnClickAnim(target);
                        }, (target) => {
                            this.playBtnClickAnim(target);
                            this.destroyGameplay();
                            this.remove(completeWindow);
                            this.showInstructionPage();
                        }, (target) => {
                            this.playBtnClickAnim(target);
                        });
                        this.setLettersInputEnabled(false);
                        delayedCall(4000, () => {
                            setPageBackground("bg-blue");
                            this.add(completeWindow);
                            completeWindow.show(score, starScore);
                            this.bgMusic.stop();
                        });
                    };
                    this.showLoseWindow = (score, starScore) => {
                        let tryAgainWindow = new screen.TryAgainWindow(this.scene, (target) => {
                            this.playBtnClickAnim(target);
                        }, (target) => {
                            this.playBtnClickAnim(target);
                            this.destroyGameplay();
                            this.remove(tryAgainWindow);
                            this.showInstructionPage();
                        });
                        this.setLettersInputEnabled(false);
                        delayedCall(1750, () => {
                            setPageBackground("bg-blue");
                            this.add(tryAgainWindow);
                            tryAgainWindow.show(score, starScore);
                            this.bgMusic.stop();
                        });
                    };
                    this.gameplay = gameplay;
                    window["t"] = this;
                }
                createHexagons() {
                    this.hexagons = [];
                    for (let p of this.hexagonPositions) {
                        let hc = new Phaser.GameObjects.Container(this.scene, p['x'], -100);
                        var angle = this.hexagons.length * (360 / this.hexagonPositions.length);
                        let h = new Phaser.GameObjects.Image(this.scene, 0, 0, 'hexagon');
                        hc.add(h);
                        h.setAngle(angle);
                        hc["bg"] = h;
                        hc["_hexagon_correct"] = new Phaser.GameObjects.Image(this.scene, 0, 0, '1 Correct Hover Effects');
                        hc.add(hc["_hexagon_correct"]);
                        hc["_hexagon_correct"].setAngle(angle);
                        hc["_hexagon_wrong"] = new Phaser.GameObjects.Image(this.scene, 0, 0, '1 wrong Hover Effects');
                        hc.add(hc["_hexagon_wrong"]);
                        hc["_hexagon_wrong"].setAngle(angle);
                        hc["_hexagon_correct"].visible = hc["_hexagon_wrong"].visible = false;
                        hc["defX"] = p['x'];
                        hc["defY"] = p['y'];
                        this.hexagons.push(hc);
                    }
                    this.gameplayContainer.add(this.hexagons);
                }
                createLetters() {
                    if (this.letters) {
                        for (let l of this.letters) {
                            l.parentContainer["letter"] = null;
                            l["hexagon"] = null;
                            l.parentContainer.remove(l);
                        }
                    }
                    this.letters = [];
                    let _letters = this.gameplay.getCurrentRoundLetters();
                    for (let n of _letters) {
                        let l = new Phaser.GameObjects.Image(this.scene, 0, 0, n);
                        this.letters.push(l);
                    }
                }
                showGameplay() {
                    setPageBackground("bg-australia");
                    this.bgMusic = this.scene.sound.add("bg_sound");
                    this.bgMusic.play();
                    this.bgMusic.loop = true;
                    this.gameplay.reset();
                    this._gameStage = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2, game.scale.height / 2, 'Sound Hive Final');
                    this._gameStage.setOrigin(0.5, 0.5);
                    this._gameStage.setInteractive();
                    this._btnSound = new Phaser.GameObjects.Image(this.scene, 160 - 105, 100 - 50, 'Sound');
                    this._btnSound.setInteractive({ cursor: 'pointer' });
                    this._btnSound["defScale"] = this._btnSound.scale;
                    setupButtonTextureBased(this._btnSound, 'Sound', 'Sound HOVER EFFECT');
                    this._btnClose = new Phaser.GameObjects.Image(this.scene, 1025 - 105, 100 - 50, 'x Button');
                    this._btnClose.setInteractive({ cursor: 'pointer' });
                    this._btnClose["defScale"] = this._btnClose.scale;
                    setupButtonTextureBased(this._btnClose, 'x Button', 'x Button HOVER EFFECT');
                    this.gameplayContainer = new Phaser.GameObjects.Container(this.scene);
                    this.addAt(this.gameplayContainer, 0);
                    this.gameplayContainer.add([
                        this._gameStage,
                        this._btnSound,
                        this._btnClose
                    ]);
                    this.createBeehives();
                    this.createHexagons();
                    this.shuffleOutHexagons();
                    this.createInput();
                    this.gameplay.setupCallbacks(this.showCompleteWindow, this.showLoseWindow);
                }
                createBeehives() {
                    let startX = 510;
                    let startY = 570 - 36;
                    let dx = 40;
                    let dy = 36;
                    let _BeehiveEmptyArrayPositions = [];
                    const numInOneRow = 8;
                    for (let i = 0; i < 16; i++) {
                        _BeehiveEmptyArrayPositions.push({ x: startX + (i % numInOneRow) * dx, y: startY + Math.floor(i / numInOneRow) * dy });
                    }
                    this._BeehiveEmptyArray = [];
                    this._Beehive = [];
                    for (let p of _BeehiveEmptyArrayPositions) {
                        let _BeehiveEmpty = new Phaser.GameObjects.Image(this.scene, p['x'], p['y'], 'Beehive 1 Empty');
                        this._BeehiveEmptyArray.push(_BeehiveEmpty);
                        _BeehiveEmpty.visible = false;
                        _BeehiveEmpty.setScale(0.9);
                        let _Beehive = new Phaser.GameObjects.Image(this.scene, p['x'], p['y'], 'Beehive 1');
                        this._Beehive.push(_Beehive);
                        _Beehive.setScale(0.9);
                    }
                    for (let bea of this._BeehiveEmptyArray) {
                        this.gameplayContainer.add(bea);
                    }
                    for (let bee of this._Beehive) {
                        this.gameplayContainer.add(bee);
                        bee.visible = false;
                    }
                }
                randomizeLettersPosition() {
                    let hx = this.hexagons.slice();
                    for (let l of this.letters) {
                        if (hx.length == 0)
                            return;
                        let hc = Phaser.Utils.Array.RemoveRandomElement(hx);
                        hc.add(l);
                        hc["letter"] = l;
                        l["hexagon"] = hc;
                    }
                }
                updateHexagonsArrange() {
                    for (let hc of this.hexagons) {
                        if (!hc["letter"]) {
                            hc.parentContainer.bringToTop(hc);
                            break;
                        }
                    }
                }
                shuffleOutHexagons() {
                    if (this.gameplay.isNewRound()) {
                        if (!this.gameplay.isRoundsComplete()) {
                            this.createLetters();
                            this.randomizeLettersPosition();
                        }
                    }
                    this.setLettersInputEnabled(false);
                    this.updateHexagonsArrange();
                    let positions = this.hexagonPositions.slice();
                    let i = 0;
                    for (let hc of this.hexagons) {
                        hc.parentContainer.bringToTop(hc);
                        let rndP = Phaser.Utils.Array.RemoveRandomElement(positions);
                        hc.x = rndP['x'];
                        hc.y = -100;
                        hc['posIndex'] = this.hexagonPositions.indexOf(rndP);
                        this.scene.tweens.add({
                            targets: hc,
                            "x": rndP['x'],
                            "y": rndP['y'],
                            duration: 600,
                            delay: (i++) * 100,
                            ease: Phaser.Math.Easing.Back.Out
                        });
                    }
                    delayedCall(450, () => {
                        this.scene.sound.add('spread from centre').play();
                    });
                    delayedCall(1200, () => {
                        let setLettersInputEnabled = () => {
                            if (this.correctAudio && this.correctAudio.isPlaying) {
                                delayedCall((this.correctAudio.duration * 0.75) * 1000, () => {
                                    this.setLettersInputEnabled(true);
                                });
                            }
                            else {
                                this.setLettersInputEnabled(true);
                            }
                        };
                        if (this.gameplay.isNewRound()) {
                            if (!this.gameplay.isRoundsComplete()) {
                                if (this.gameplay.isCorrectLetterAudioQuestionEnable()) {
                                    this.playCorrectAudio();
                                }
                                setLettersInputEnabled();
                            }
                        }
                        else {
                            setLettersInputEnabled();
                        }
                    });
                }
                shuffleInHexagons(doShuffleOutHexagons = true) {
                    this.updateHexagonsArrange();
                    let positions = this.hexagonPositions.slice();
                    this.setLettersInputEnabled(false);
                    let i = 0;
                    for (let hc of this.hexagons) {
                        this.scene.tweens.add({
                            targets: hc,
                            "y": 700,
                            duration: 500,
                            delay: (i++) * 100,
                            onComplete: () => {
                                hc["_hexagon_correct"].visible = hc["_hexagon_wrong"].visible = false;
                            },
                            ease: Phaser.Math.Easing.Back.In
                        });
                    }
                    delayedCall(600, () => {
                        this.scene.sound.add('move to centre').play();
                    });
                    if (doShuffleOutHexagons) {
                        delayedCall(1500, () => {
                            this.shuffleOutHexagons();
                        });
                    }
                }
                createInput() {
                    for (let hc of this.hexagons) {
                        hc["bg"].on('pointerup', () => {
                            let l = hc["letter"];
                            this.setLettersInputEnabled(false);
                            this.playBtnClickAnim(hc);
                            let lost = false;
                            let correctAnswer = l && l.texture.key == this.gameplay.getCorrectLetterName();
                            let d = 1250;
                            if (correctAnswer) {
                                hc["_hexagon_wrong"].visible = false;
                                hc["_hexagon_correct"].visible = true;
                                let completed = this.onCorrectAnswer();
                                delayedCall(1000, () => {
                                    this.scene.sound.add("Spin Sound Effects").play();
                                    this.scene.tweens.add({
                                        targets: hc,
                                        "angle": 720 + 360 + 360 + 360,
                                        duration: 2000,
                                        ease: Phaser.Math.Easing.Sine.Out,
                                        delay: 350
                                    });
                                });
                                delayedCall(1500 + d, () => {
                                    this.shuffleInHexagons(!completed);
                                });
                            }
                            else {
                                hc["_hexagon_wrong"].visible = true;
                                hc["_hexagon_correct"].visible = false;
                                delayedCall(1500, () => {
                                    hc["_hexagon_wrong"].visible = false;
                                });
                                lost = this.onWrongAnswer();
                                if (!lost) {
                                    this.setLettersInputEnabled(true);
                                }
                            }
                            if (!lost) {
                                delayedCall(2500 + d, () => {
                                    if (!this.gameplay.isNewRound()) {
                                        if (this.gameplay.isCorrectLetterAudioQuestionEnable()) {
                                            this.playCorrectAudio();
                                        }
                                    }
                                });
                            }
                        });
                    }
                    this._btnSound.on('pointerup', () => {
                        this.playBtnClickAnim(this._btnSound);
                        this.onSoundClick();
                    });
                    this._btnClose.on('pointerup', () => {
                        this.playBtnClickAnim(this._btnClose);
                        this.onCloseClick();
                    });
                }
                hideAllUnusedBeehives() {
                    let i = this.gameplay.getCurrentTotalAnswersCount();
                    for (let k = i + 1; k < this._BeehiveEmptyArray.length; k++) {
                        this._BeehiveEmptyArray[k].visible = false;
                        this._Beehive[k].visible = false;
                    }
                }
                onCorrectAnswer() {
                    let i = this.gameplay.getCurrentTotalAnswersCount();
                    if (i < this._BeehiveEmptyArray.length) {
                        this._BeehiveEmptyArray[i].visible = false;
                        this._Beehive[i].visible = true;
                    }
                    this.hideAllUnusedBeehives();
                    let completed = this.gameplay.onCorrectAnswer();
                    this.scene.sound.add('correct and letter sound sfx').play();
                    delayedCall(750, () => {
                        this.scene.sound.add(this.gameplay.getCorrectAndLetterSoundSfxAudioKey()).play();
                    });
                    return completed;
                }
                onWrongAnswer() {
                    let i = this.gameplay.getCurrentTotalAnswersCount();
                    if (i < this._BeehiveEmptyArray.length) {
                        this._BeehiveEmptyArray[i].visible = true;
                        this._Beehive[i].visible = false;
                    }
                    this.hideAllUnusedBeehives();
                    let lost = this.gameplay.onWrongAnswer();
                    this.scene.sound.add("wrong sfx").play();
                    return lost;
                }
                playCorrectAudio() {
                    if (this.correctAudio) {
                        this.correctAudio.stop();
                    }
                    this.correctAudio = this.scene.sound.add(this.gameplay.getCorrectAudioKey());
                    this.correctAudio.play();
                    if (this.areYouSureWindow && this.areYouSureWindow.parentContainer == this) {
                        this.correctAudio.pause();
                    }
                }
                onSoundClick() {
                    this.playCorrectAudio();
                }
                onCloseClick() {
                    this.showAreYouSurePage();
                    this.scene.sound.add('warning page pop up sfx').play();
                }
                playBtnClickAnim(target) {
                    let sc = target["defScale"] ? target["defScale"] : 1;
                    target.scaleX = target.scaleY = sc;
                    this.scene.tweens.add({
                        targets: target,
                        "scaleX": 0.9 * sc,
                        "scaleY": 0.9 * sc,
                        duration: 100,
                        yoyo: true
                    });
                }
                showInstructionPage() {
                    setPageBackground("bg-blue");
                    this.instructionPage = new screen.InstructionPage(this.scene, (target) => {
                        this.playBtnClickAnim(target);
                        this.remove(this.instructionPage);
                        this.showGameplay();
                        if (this.wfsnd) {
                            this.wfsnd.stop();
                        }
                    }, (target) => {
                        this.playBtnClickAnim(target);
                        if (this.wfsnd) {
                            this.wfsnd.stop();
                        }
                        this.wfsnd = this.scene.sound.add("Sound pad welcome");
                        this.wfsnd.play();
                    });
                    this.add(this.instructionPage);
                    try {
                        this.wfsnd = this.scene.sound.add("Sound pad welcome");
                        this.wfsnd.play();
                    }
                    catch (e) {
                        console.error(e);
                    }
                }
                showAreYouSurePage() {
                    pauseAllDelayedCalls();
                    setPageBackground("bg-blue");
                    this.pauseSounds();
                    this.areYouSureWindow = new screen.AreYouSureWindow(this.scene, () => {
                        this.remove(this.areYouSureWindow);
                        this.destroyGameplay();
                        this.showInstructionPage();
                    }, () => {
                        this.remove(this.areYouSureWindow);
                        this.unpauseSounds();
                        resumeAllDelayedCalls();
                        setPageBackground("bg-australia");
                    });
                    this.add(this.areYouSureWindow);
                }
                setLettersInputEnabled(enabled) {
                    if (enabled) {
                        for (let hc of this.hexagons) {
                            hc["bg"].setInteractive({ cursor: 'pointer' });
                        }
                    }
                    else {
                        for (let hc of this.hexagons) {
                            hc["bg"].disableInteractive();
                        }
                    }
                }
                pauseSounds() {
                    this.scene.sound.pauseAll();
                }
                unpauseSounds() {
                    this.scene.sound.resumeAll();
                }
                destroyGameplay() {
                    this.setLettersInputEnabled(false);
                    this.remove(this.gameplayContainer);
                    destroyAllDelayedCalls();
                }
            }
            screen.GameplayScreen = GameplayScreen;
        })(screen = sh.screen || (sh.screen = {}));
    })(sh || (sh = {}));

    (function (sh) {
        var screen;
        (function (screen) {
            class InstructionPage extends Phaser.GameObjects.Container {
                constructor(scene, onPlayClick, onSndClick) {
                    super(scene);
                    this._instructionPage = new Phaser.GameObjects.Image(this.scene, 0 - 105, 0 - 48, 'Instructions page  ALL ACTIVITY  TITLEs');
                    this._instructionPage.setOrigin(0, 0);
                    this._instructionPage.setInteractive();
                    this._instructionPageTitle = new Phaser.GameObjects.Image(this.scene, 495, 105, 'title-soundpad');
                    this._instructionPageTitle.setScale(0.8);
                    this._btnPlay = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2, 480 - 50, 'btnPLAY1');
                    this._btnPlay.setInteractive({ cursor: 'pointer' });
                    this._btnPlay.once('pointerup', onPlayClick);
                    setupButtonTextureBased(this._btnPlay, 'btnPLAY1', 'btnPLAY2');
                    this.instrTxt = this.scene.add.text(game.scale.width / 2, game.scale.height / 2, "Help the frog find the sound", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 30,
                        "color": "#43425D",
                        "align": 'center'
                    });
                    this.instrTxt.setOrigin(0.5, 0.5);
                    this._btnSoundInstruction = new Phaser.GameObjects.Image(this.scene, 800 - 105, 156 - 50, 'Sound');
                    this._btnSoundInstruction.setInteractive({ cursor: 'pointer' });
                    this._btnSoundInstruction.on('pointerup', onSndClick);
                    this._btnSoundInstruction["defScale"] = this._btnSoundInstruction.scale;
                    setupButtonTextureBased(this._btnSoundInstruction, 'Sound', 'Sound HOVER EFFECT');
                    this.add(this._instructionPage);
                    this.add(this._instructionPageTitle);
                    this.add(this.instrTxt);
                    this.add(this._btnPlay);
                    this.add(this._btnSoundInstruction);
                }
            }
            screen.InstructionPage = InstructionPage;
        })(screen = sh.screen || (sh.screen = {}));
    })(sh || (sh = {}));

    (function (sh) {
        var screen;
        (function (screen) {
            class TryAgainWindow extends Phaser.GameObjects.Container {
                constructor(scene, onBack, onReplay) {
                    super(scene);
                    this.music = null;
                    this.setPosition(-106, -48);
                    this._bg = new Phaser.GameObjects.Image(this.scene, 0, 0, 'Try again page');
                    this._bg.setOrigin(0, 0);
                    this._bg.setInteractive();
                    this._star = new Phaser.GameObjects.Image(this.scene, 400, 415, 'Break Star');
                    this._btnBack = new Phaser.GameObjects.Image(this.scene, 600, 580, 'btnBACK1');
                    this._btnReplay = new Phaser.GameObjects.Image(this.scene, 765, 580, 'btnReplay1');
                    this.totalScoreTxt = this.scene.add.text(830, 355, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 35,
                        "color": "#F49F1C",
                        "align": 'center',
                        'stroke': '#70451A',
                        'strokeThickness': 6
                    });
                    this.totalScoreTxt.setOrigin(0.5, 0.5);
                    let grd = this.totalScoreTxt.context.createLinearGradient(0, 0, 0, this.totalScoreTxt.height);
                    grd.addColorStop(0, '#FFFF00');
                    grd.addColorStop(1, '#C17316');
                    this.totalScoreTxt.setFill(grd);
                    this.starScoreTxt = this.scene.add.text(635, 431, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 24,
                        "color": "#FFFFFF",
                        "align": 'center'
                    });
                    this.starScoreTxt.setOrigin(0.5, 0.5);
                    this.add([
                        this._bg,
                        this._star,
                        this._btnBack,
                        this._btnReplay,
                        this.totalScoreTxt,
                        this.starScoreTxt
                    ]);
                    this._btnBack.setInteractive({ cursor: 'pointer' });
                    this._btnBack.on('pointerup', () => {
                        onBack(this._btnBack);
                        angularComponentRef.backToMenu();
                        // if (this.music) {
                        //     this.music.stop();
                        // }
                    });
                    setupButtonTextureBased(this._btnBack, 'btnBACK1', 'btnBACK2');
                    this._btnReplay.setInteractive({ cursor: 'pointer' });
                    this._btnReplay.once('pointerup', () => {
                        onReplay(this._btnReplay);
                        if (this.music) {
                            this.music.stop();
                        }
                    });
                    setupButtonTextureBased(this._btnReplay, 'btnReplay1', 'btnReplay2');
                }
                show(score, starScore) {
                    this._star.scale = 1.25;
                    this.scene.tweens.add({
                        targets: this._star,
                        "scale": 1,
                        duration: 500,
                        ease: Phaser.Math.Easing.Back.Out
                    });
                    this.totalScoreTxt.text = String(score);
                    this.starScoreTxt.text = String(starScore);
                    this.music = this.scene.sound.add("Fail - close one");
                    this.music.play();
                }
            }
            screen.TryAgainWindow = TryAgainWindow;
        })(screen = sh.screen || (sh.screen = {}));
    })(sh || (sh = {}));
}



function destroysoundPads() {
    if (game) {
        game.destroy();
    }

}


var rp;
var game;

var readingPractice3 = (json) => {
    (function (rp) {
        class App extends Phaser.Game {
            constructor(json) {
                App.json = json;
                let config = {
                    type: Phaser.AUTO,
                    width: App.CANVAS_WIDTH,
                    height: App.CANVAS_HEIGHT,
                    parent: 'game-container',
                    dom: {
                        createContainer: false
                    },
                    scale: {
                        mode: Phaser.Scale.NONE,
                        // autoCenter: Phaser.Scale.CENTER_BOTH
                    },
                    transparent: true,
                    scene: {
                        create: () => {
                            this.scene.add('Boot', rp.scene.Boot, true);
                        }
                    }
                };
                super(config);
            }
        }

        App.CANVAS_WIDTH = 980;
        App.CANVAS_HEIGHT = 600;
        rp.App = App;
    })(rp || (rp = {}));

    let delayedCalls = [];
    function delayedCall(delay, callback, args, callbackScope) {
        let scene = game.scene.getAt(0);
        if (scene) {
            let dc = scene.time.delayedCall(delay, callback, args, callbackScope);
            delayedCalls.push(dc);
            return dc;
        }
        let t = setTimeout(callback, delay);
        delayedCalls.push(t);
        return t;
    }
    function pauseAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.paused = true;
            }
        }
    }
    function resumeAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.paused = false;
            }
        }
    }
    function destroyAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.remove(false);
            }
            else {
                clearTimeout(dc);
            }
        }
        delayedCalls = [];
    }
    function setPageBackground(bg) {
        document.querySelector("html").style.backgroundImage = "url(assets/imgs/" + bg + ".jpg)";
    }
    function setupButton(btn, frame) {
        btn.on('pointerdown', () => {
            btn.setFrame(frame + '_hover' + '0000');
        });
        btn.on('pointerover', () => {
            btn.setFrame(frame + '_hover' + '0000');
            game.scene.getAt(0).sound.add("button hover").play();
        });
        btn.on('pointerout', () => {
            btn.setFrame(frame + '0000');
        });
        btn.on('pointerup', () => {
            btn.setFrame(frame + '0000');
            game.scene.getAt(0).sound.add('activity selection - button selection').play();
        });
    }
    function setupButtonTextureBased(btn, texture, hoverTexture) {
        btn.on('pointerdown', () => {
            btn.setTexture(hoverTexture);
        });
        btn.on('pointerover', () => {
            btn.setTexture(hoverTexture);
            game.scene.getAt(0).sound.add("button hover").play();
        });
        btn.on('pointerout', () => {
            btn.setTexture(texture);
        });
        btn.on('pointerup', () => {
            btn.setTexture(texture);
            game.scene.getAt(0).sound.add('activity selection - button selection').play();
        });
    }
    function setupButtonFrameBased(btn, texture, defaultFrame, hoverFrame, playClickSound = false, playHoverSound = false) {
        btn.setTexture(texture, defaultFrame);
        btn.on('pointerdown', () => {
            btn.setFrame(hoverFrame);
        });
        btn.on('pointerover', () => {
            btn.setFrame(hoverFrame);
            if (playHoverSound)
                game.scene.getAt(0).sound.add("button hover").play();
        });
        btn.on('pointerout', () => {
            btn.setFrame(defaultFrame);
        });
        btn.on('pointerup', () => {
            btn.setFrame(defaultFrame);
            if (playClickSound)
                game.scene.getAt(0).sound.add('click').play();
        });
    }
    class AbstractPage extends Phaser.GameObjects.Container {
        constructor(scene, pageIndex) {
            super(scene);
            this.pageIndex = pageIndex;
            this.contentContainer = new Phaser.GameObjects.Container(this.scene, pageIndex % 2 === 0 ? -456 : 2, 0);
            this.add(this.contentContainer);
            this.pageBackground = new Phaser.GameObjects.Image(this.scene, 0, 0, pageIndex % 2 === 0 ? 'page-bg' : 'page-bg-front', 0);
            this.pageBackground.setOrigin(0, 0.5);
            this.contentContainer.add(this.pageBackground);
        }
    }
    class EmptyPage extends AbstractPage {
        constructor(scene, pageIndex) {
            super(scene, pageIndex);
        }
        buildContent() {
        }
    }
    class EndPage extends AbstractPage {
        constructor(scene, pageIndex, onCompleteCallback) {
            super(scene, pageIndex);
            this.pageBackground.alpha = 0;
            this.buttonComplete = new Phaser.GameObjects.Image(this.scene, 220, 50, 'complete-button');
            this.buttonComplete.setInteractive({ cursor: 'pointer' });
            setupButtonFrameBased(this.buttonComplete, 'complete-button', 1, 0, true, true);
            this.buttonComplete.on('pointerup', () => onCompleteCallback());
            this.contentContainer.add([this.buttonComplete]);
        }
        buildContent() {
        }
    }
    class IntroductionPage extends AbstractPage {
        constructor(scene, pageIndex) {
            super(scene, pageIndex);
            this.buildContent();
        }
        buildContent() {
            const gameplayConfig = this.scene.game.cache.json.get('gameplay');
            this.headingText = new Phaser.GameObjects.Text(this.scene, 235, 100 - 227, gameplayConfig.introduction.title, {
                "fontFamily": "Kids Rock Demo",
                fontSize: "1.9rem",
                color: "#feb832",
                align: 'center',
                stroke: 'rgba(201, 87, 17, 0.8)',
                strokeThickness: 4,
                shadow: {
                    color: "#8b5a39",
                    offsetX: 2,
                    offsetY: 2,
                    stroke: true,
                    fill: true
                }
            });
            this.headingText.setOrigin(0.5, 0.5);
            this.mainText = new Phaser.GameObjects.Text(this.scene, 235, 250 - 227, gameplayConfig.introduction.text.replaceAll('<br>', '\n'), {
                "fontFamily": "Kids Rock Demo",
                fontSize: "1.175rem",
                color: "#6b3a24",
                align: 'center',
                wordWrap: {
                    width: 410,
                    useAdvancedWrap: false
                }
            });
            this.mainText.setOrigin(0.5, 0.5);
            this.mainText.setLineSpacing(14);
            this.vocalizeBtn = new Phaser.GameObjects.Image(this.scene, 395, 95 - 227, 'reading-sound', 0);
            this.vocalizeBtn.setInteractive({ cursor: 'pointer' });
            setupButtonFrameBased(this.vocalizeBtn, 'reading-sound', 1, 0, false, true);
            this.vocalizeBtn.on('pointerup', () => {
                if (this.sound) {
                    this.sound.stop();
                    this.sound.destroy();
                }
                this.sound = this.scene.sound.add(gameplayConfig.introduction.audio);
                this.sound.play();
            });
            this.sound = this.scene.sound.add(gameplayConfig.introduction.audio);
            this.sound.play();
            this.contentContainer.add([this.headingText, this.mainText, this.vocalizeBtn]);
        }
    }

    class Page extends AbstractPage {
        constructor(scene, pageIndex, dataIndex, displayedNumber) {
            super(scene, pageIndex);
            this.dataIndex = dataIndex;
            this.displayedNumber = displayedNumber;
            this.buildContent();
        }
        buildContent() {
            this.frameBg = new Phaser.GameObjects.Image(this.scene, 225, 0, 'frame-bg');
            const gameplayConfig = this.scene.game.cache.json.get('gameplay');

            const pages = gameplayConfig.data.pages;
            if (pages[this.dataIndex]["useImages"]) {
                this.text = new Phaser.GameObjects.Image(this.scene, 225, 0, pages[this.dataIndex].text);
            } else {
                this.text = new Phaser.GameObjects.Text(this.scene, 225, 180 - 165, "", {
                    "fontFamily": json.data.defaultFontFamily ? json.data.defaultFontFamily : "HafsQuranEra",
                    "fontSize": pages[this.dataIndex].fontSize ? pages[this.dataIndex].fontSize : json.data.defaultFontSize ? json.data.defaultFontSize : 45 * 2,
                    "color": "#010101",
                    "align": 'center'
                });
                this.text.setOrigin(0.5, 0.5);
                this.text.style.fixedHeight = 195;
                this.text.setPadding(0, 32);
                this.text.setText(pages[this.dataIndex].text);
            }

            this.vocalizeBtn = new Phaser.GameObjects.Image(this.scene, 225, 76 - 227, 'reading-sound', 0);
            this.vocalizeBtn.setOrigin(0.5, 0.5);
            this.vocalizeBtn.setInteractive({ cursor: 'pointer' });
            setupButtonFrameBased(this.vocalizeBtn, 'reading-sound', 1, 0, false, true);
            this.pageNumberText = new Phaser.GameObjects.Text(this.scene, 225, 435 - 227, this.displayedNumber, {
                "fontFamily": "Kids Rock Demo",
                "fontSize": "1.1rem",
                "color": "#010101",
                "align": 'center'
            });
            this.pageNumberText.setOrigin(0.5, 1);
            this.contentContainer.add([this.pageBackground, this.frameBg, this.text, this.vocalizeBtn, this.pageNumberText]);
            this.vocalizeBtn.on('pointerup', () => {
                if (this.sound) {
                    this.sound.stop();
                    this.sound.destroy();
                }
                if (gameplayConfig.data.useLocalFiles) {
                    this.sound = this.scene.sound.add(pages[this.dataIndex].text);
                }
                else {
                    this.sound = this.scene.sound.add(pages[this.dataIndex].audio);
                }
                this.sound.play();
            });
        }
    }
    (function (rp) {
        var scene;
        (function (scene) {
            class Boot extends Phaser.Scene {
                init() {
                    this.game.scale.transformX = (pageX) => {
                        let offsetLeft = 0;
                        let parentElement = game.canvas.parentElement;
                        while (parentElement) {
                            if (parentElement.offsetLeft) {
                                offsetLeft = parentElement.offsetLeft;
                                break;
                            }
                            parentElement = parentElement.parentElement;
                        }
                        return (pageX - offsetLeft) * this.game.scale.displayScale.x;
                    };
                    this.game.scale.transformY = (pageY) => {
                        let offsetTop = 0;
                        let parentElement = game.canvas.parentElement;
                        while (parentElement) {
                            if (parentElement.offsetTop) {
                                offsetTop = parentElement.offsetTop;
                                break;
                            }
                            parentElement = parentElement.parentElement;
                        }
                        return (pageY - offsetTop) * this.game.scale.displayScale.y;
                    };
                }

                create() {
                    game.scene.remove('Boot');
                    game.scene.add('Preloader', rp.scene.Preloader, true);
                }
            }
            scene.Boot = Boot;
        })(scene = rp.scene || (rp.scene = {}));
    })(rp || (rp = {}));
    (function (rp) {
        var scene;
        (function (scene) {
            class MainScene extends Phaser.Scene {
                create() {
                    this.gameplayScreen = new rp.screen.GameplayScreen(this);
                    this.children.add(this.gameplayScreen);
                }
            }
            scene.MainScene = MainScene;
        })(scene = rp.scene || (rp.scene = {}));
    })(rp || (rp = {}));
    (function (rp) {
        var scene;
        (function (scene) {
            class Preloader extends Phaser.Scene {
                preload() {
                    if (typeof rp.App.json == "string") this.load.json('gameplay', rp.App.json); else this.game.cache.json.add('gameplay', rp.App.json);
                }
                create() {
                    const gameplayConfig = this.game.cache.json.get('gameplay');
                    const pages = gameplayConfig.data.pages;
                    pages.forEach((page, index) => {
                        if (page["useImages"]) {
                            if (page["text"].includes('http') || page["text"].includes("assets")) {
                                this.load.image(page["text"], page["text"]);
                            }
                            else if (json.data.gameId) {
                                this.load.image(page["text"], "assets/games/reading-practice/assets/imgs/words/" + json.data.gameId + "/" + page["text"] + ".png");
                            }
                            else {
                                this.load.image(page["text"], "assets/games/reading-practice/assets/imgs/words/" + page["text"] + ".png");
                            }
                        }
                        if (gameplayConfig.data.useLocalFiles) {
                            if (json.data.gameId) {
                                if (json.data.indexed) {
                                    this.load.audio(page["text"], "assets/games/reading-practice/assets/sound/mp3/words/" + json.data.gameId + "/" + (index + 1).toString() + ".mp3");
                                } else {
                                    this.load.audio(page["text"], "assets/games/reading-practice/assets/sound/mp3/words/" + json.data.gameId + "/" + page["text"] + ".mp3");
                                }
                            } else {
                                this.load.audio(page["text"], "assets/games/reading-practice/assets/sound/mp3/words/" + page["text"] + ".mp3");
                            }
                        } else {
                            this.load.audio(page["audio"], page["audio"]);
                        }
                    });
                    this.load.audio(gameplayConfig.introduction.audio, gameplayConfig.introduction.audio);
                    this.load.audio("complete-audio", Phaser.Utils.Array.GetRandom(gameplayConfig.completeAudios));
                    this.load.pack('preloader', 'assets/games/reading-practice/assets/pack.json');
                    // font pre-initialization, updating with the loading progress
                    let progress = this.add.text(-100, -100, "0%", { "fontFamily": json.data.defaultFontFamily, "fontSize": 10 });
                    this.load.on('progress', (value) => {
                        progress.setText(Math.floor(value * 100) + "%");
                    }, this);
                    this.load.on('complete', () => {
                        this.nextScene();
                    });
                    this.load.start();
                }
                nextScene() {
                    game.scene.remove('Preloader');
                    game.scene.add('ScreenMain', rp.scene.MainScene, true);
                }
            }
            scene.Preloader = Preloader;
        })(scene = rp.scene || (rp.scene = {}));
    })(rp || (rp = {}));
    (function (rp) {
        var screen;
        (function (screen) {
            class AreYouSureWindow extends Phaser.GameObjects.Container {
                constructor(scene, onYes, onNo) {
                    super(scene);
                    this._areYouSurePage = new Phaser.GameObjects.Image(this.scene, -105, 0 - 48, 'Exit warning');
                    this._areYouSurePage.setOrigin(0, 0);
                    this._areYouSurePage.setInteractive();
                    this._btnSureYes = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2 - 95, 485 - 50, 'btnYES1');
                    this._btnSureYes.setInteractive({ cursor: 'pointer' });
                    setupButtonTextureBased(this._btnSureYes, 'btnYES1', 'btnYES2');
                    this._btnSureYes.once('pointerup', () => {
                        onYes;
                        window.angularComponentRef.backToMenu();
                    });

                    var modalTextStyle = {
                        backgroundColor: 'transparent',
                        stroke: '#ffffff',
                        strokeThickness: 2,
                        lineSpacing: 15,
                        fontFamily: 'Kids Rock DEMO',
                        fontSize: 27,
                        color: '#43425d',
                        wordWrap: true,
                        align: 'center'
                    };
                    var modalText = this.scene.add.text(game.scale.width / 2 + 12, game.scale.height / 2, "Your progress in this activity will not be saved. \n Are you sure you want to exit? ", modalTextStyle);
                    modalText.setOrigin(0.5, 0.5);

                    this._btnSureNo = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2 + 95, 485 - 50, 'btnNO1');
                    this._btnSureNo.setInteractive({ cursor: 'pointer' });
                    setupButtonTextureBased(this._btnSureNo, 'btnNO1', 'btnNO2');
                    this._btnSureNo.once('pointerup', onNo);
                    this.add(this._areYouSurePage);
                    this.add(this._btnSureYes);
                    this.add(this._btnSureNo);
                    this.add(modalText);
                }
            }
            screen.AreYouSureWindow = AreYouSureWindow;
        })(screen = rp.screen || (rp.screen = {}));
    })(rp || (rp = {}));
    (function (rp) {
        var screen;
        (function (screen) {
            class CompleteWindow extends Phaser.GameObjects.Container {
                constructor(scene, onBack, onReplay, onNext) {
                    super(scene);
                    this.music = null;
                    this.setPosition(-104.5, -48);
                    this._bgComplete = new Phaser.GameObjects.Image(this.scene, 0, 0, 'Completion page LATEST UPDATED');
                    this._bgComplete.setOrigin(0, 0);
                    this._bgComplete.setInteractive();
                    this._cup = new Phaser.GameObjects.Image(this.scene, 400, 410, 'Trophy');
                    this._btnBack = new Phaser.GameObjects.Image(this.scene, 570, 570, 'btnBACK1');
                    this._btnReplay = new Phaser.GameObjects.Image(this.scene, 720, 570, 'btnReplay1');
                    this._btnNext = new Phaser.GameObjects.Image(this.scene, 870, 570, 'btnNEXT1');
                    let _CollectedPoints = new Phaser.GameObjects.Image(this.scene, 620, 440, 'Collected Points');
                    this.totalScoreTxt = this.scene.add.text(845, 352, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 35,
                        "color": "#F49F1C",
                        "align": 'center',
                        'stroke': '#70451A',
                        'strokeThickness': 6
                    });
                    this.totalScoreTxt.setOrigin(0.5, 0.5);
                    let grd = this.totalScoreTxt.context.createLinearGradient(0, 0, 0, this.totalScoreTxt.height);
                    grd.addColorStop(0, '#FFFF00');
                    grd.addColorStop(1, '#C17316');
                    this.totalScoreTxt.setFill(grd);
                    this.starScoreTxt = this.scene.add.text(648, 433, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 24,
                        "color": "#FFFFFF",
                        "align": 'center'
                    });
                    this.starScoreTxt.setOrigin(0.5, 0.5);
                    this.add([
                        this._bgComplete,
                        _CollectedPoints,
                        this._cup,
                        this._btnBack,
                        this._btnReplay,
                        this._btnNext,
                        this.totalScoreTxt,
                        this.starScoreTxt
                    ]);
                    this._btnBack.setInteractive({ cursor: 'pointer' });
                    setupButtonTextureBased(this._btnBack, 'btnBACK1', 'btnBACK2');
                    this._btnBack.on('pointerup', () => {
                        onBack(this._btnBack);
                        window.angularComponentRef.backToMenu();
                        // if (this.music) {
                        //     this.music.stop();
                        // }
                    });
                    this._btnReplay.setInteractive({ cursor: 'pointer' });
                    setupButtonTextureBased(this._btnReplay, 'btnReplay1', 'btnReplay2');
                    this._btnReplay.once('pointerup', () => {
                        onReplay(this._btnReplay);
                        if (this.music) {
                            this.music.stop();
                        }
                    });
                    this._btnNext.setInteractive({ cursor: 'pointer' });
                    setupButtonTextureBased(this._btnNext, 'btnNEXT1', 'btnNEXT2');
                    this._btnNext.on('pointerup', () => {
                        onNext(this._btnNext);
                        window.angularComponentRef.nextActivity();
                        // if (this.music) {
                        //     this.music.stop();
                        // }
                    });
                }
                show(score, starScore) {
                    window.angularComponentRef.gameFinish({ score, starScore });
                    this._cup.scale = 1.25;
                    this.scene.tweens.add({
                        targets: this._cup,
                        "scale": 1,
                        duration: 500,
                        ease: Phaser.Math.Easing.Back.Out
                    });
                    this.totalScoreTxt.text = String(window.angularComponentRef.component.userInfo.totalScore);
                    this.starScoreTxt.text = String(starScore);
                    this.music = this.scene.sound.add("complete-audio");
                    this.music.play();
                }
            }
            screen.CompleteWindow = CompleteWindow;
        })(screen = rp.screen || (rp.screen = {}));
    })(rp || (rp = {}));
    (function (rp) {
        var screen;
        (function (screen) {
            class GameplayScreen extends Phaser.GameObjects.Container {
                constructor(scene) {
                    super(scene);
                    this.currentPageIndex = 0;
                    this.flippingActive = false;
                    this.flippingStage = 0;
                    this.flippingDirection = 0;
                    this.leftPage = null;
                    this.rightPage = null;
                    this.flippedPage = null;
                    this.unflippedPage = null;
                    window["gameplay"] = this;
                    this.createBackground();
                    this.buildPages();
                    this.buildButtons();
                }
                buildPages() {
                    this.pages = [];
                    /* introduction page */
                    this.pages.push(new IntroductionPage(this.scene, 0));
                    /* empty page to combine with an introduction page */
                    this.pages.push(new EmptyPage(this.scene, 1));
                    /* pages */
                    const gameplayConfig = this.scene.game.cache.json.get('gameplay');
                    const pages = gameplayConfig.data.pages;
                    for (let i = 0; i < pages.length; i++) {
                        this.pages.push(new Page(this.scene, i + 2, i, `${i + 1}`));
                    }
                    /* empty page */
                    this.pages.push(new EmptyPage(this.scene, this.pages.length));
                    /* the last page */
                    this.pages.push(new EndPage(this.scene, this.pages.length, () => this.onCompleteClicked()));
                    this.pagesContainer = new Phaser.GameObjects.Container(this.scene, 500, 107 + 227);
                    this.add(this.pagesContainer);
                    this.pagesContainer.add(this.pages);
                    this.resetGame();
                }
                buildButtons() {
                    this.buttonPrevPage = new Phaser.GameObjects.Image(this.scene, 15, 286, 'arrows');
                    this.buttonPrevPage.setOrigin(0, 0);
                    this.buttonPrevPage.setInteractive({ cursor: 'pointer' });
                    setupButtonFrameBased(this.buttonPrevPage, 'arrows', 2, 0, true, true);
                    this.buttonPrevPage.on('pointerup', this.switchToPrevPage, this);
                    this.buttonNextPage = new Phaser.GameObjects.Image(this.scene, 910, 286, 'arrows');
                    this.buttonNextPage.setOrigin(0, 0);
                    this.buttonNextPage.setInteractive({ cursor: 'pointer' });
                    setupButtonFrameBased(this.buttonNextPage, 'arrows', 3, 1, true, true);
                    this.buttonNextPage.on('pointerup', this.switchToNextPage, this);
                    this.add([this.buttonPrevPage, this.buttonNextPage]);
                }
                createBackground() {
                    this.backgroundImage = this.scene.add.image(0, 0, 'reading-bg');
                    this.backgroundImage.setOrigin(0, 0);
                    this.buttonClose = new Phaser.GameObjects.Image(this.scene, 930, 50, 'x Button');
                    this.buttonClose.setInteractive({ cursor: 'pointer' });
                    setupButtonTextureBased(this.buttonClose, 'x Button', 'x Button HOVER EFFECT');
                    this.buttonClose.on('pointerup', this.onLeaveClicked, this);
                    this.add(this.buttonClose);
                }
                switchToPrevPage() {
                    if (this.flippingActive)
                        return;
                    if (this.currentPageIndex >= 2) {
                        this.flipToPrevPage();
                    }
                }
                switchToNextPage() {
                    if (this.flippingActive)
                        return;
                    if (this.currentPageIndex < this.pages.length - 2) {
                        this.flipToNextPage();
                    }
                }
                flipToPrevPage() {
                    this.leftPage = this.pages[this.currentPageIndex - 2];
                    this.flippedPage = this.pages[this.currentPageIndex];
                    this.unflippedPage = this.pages[this.currentPageIndex - 1];
                    this.rightPage = this.pages[this.currentPageIndex + 1];
                    this.flippingDirection = -1;
                    this.currentPageIndex -= 2;
                    this.flipPages(this.flippedPage, this.unflippedPage);
                }
                flipToNextPage() {
                    this.leftPage = this.pages[this.currentPageIndex];
                    this.flippedPage = this.pages[this.currentPageIndex + 1];
                    this.unflippedPage = this.pages[this.currentPageIndex + 2];
                    this.rightPage = this.pages[this.currentPageIndex + 3];
                    this.flippingDirection = 1;
                    this.currentPageIndex += 2;
                    this.flipPages(this.flippedPage, this.unflippedPage);
                }
                flipPages(pageToFlip, pageToUnflip) {
                    this.scene.game.sound.stopAll();
                    if (!this.flipSound)
                        this.flipSound = this.scene.sound.add('flip');
                    this.flipSound.play();
                    this.flippingActive = true;
                    this.flippingStage = 1;
                    this.updatePagesVisibility();
                    this.sortPages();
                    pageToFlip.scaleX = 1.0;
                    pageToFlip.scaleY = 1.0;
                    pageToFlip.x = 0;
                    this.scene.tweens.add({
                        targets: pageToFlip,
                        scaleX: 0.0,
                        scaleY: 1.025,
                        x: this.flippingDirection > 0 ? -5 : 5,
                        delay: 50,
                        duration: GameplayScreen.FLIP_DURATION,
                        ease: Phaser.Math.Easing.Quadratic.Out,
                        onComplete: () => {
                            this.flippingStage = 2;
                            this.updatePagesVisibility();
                            this.sortPages();
                            pageToUnflip.scaleX = 0;
                            pageToUnflip.scaleY = 1.025;
                            pageToUnflip.x = this.flippingDirection > 0 ? 5 : -5;
                            this.scene.tweens.add({
                                targets: pageToUnflip,
                                scaleX: 1.0,
                                scaleY: 1.0,
                                x: 0,
                                duration: GameplayScreen.UNFLIP_DURATION,
                                ease: Phaser.Math.Easing.Quadratic.In,
                                onComplete: () => {
                                    this.flippingActive = false;
                                    this.flippingStage = 0;
                                    this.flippingDirection = 0;
                                    this.detectPages();
                                    this.updatePagesVisibility();
                                    this.sortPages();
                                    pageToUnflip.scaleX = 1;
                                    pageToUnflip.scaleY = 1;
                                    pageToFlip.x = pageToUnflip.x = 0;
                                }
                            });
                        }
                    });
                }
                sortPages() {
                    this.pagesContainer.sort("pageIndex", (pageA, pageB) => {
                        if (pageA === this.flippedPage || pageA === this.unflippedPage)
                            return 1;
                        if (pageB === this.flippedPage || pageB === this.unflippedPage)
                            return -1;
                        return this.flippingDirection * (pageA.pageIndex - pageB.pageIndex);
                    });
                }
                detectPages() {
                    this.leftPage = this.pages[this.currentPageIndex];
                    this.rightPage = this.pages[this.currentPageIndex + 1];
                    this.flippedPage = this.unflippedPage = null;
                }
                updatePagesVisibility() {
                    this.pages.forEach(page => page.setVisible(false));
                    if (this.leftPage)
                        this.leftPage.visible = true;
                    if (this.rightPage)
                        this.rightPage.visible = true;
                    if (this.flippedPage)
                        this.flippedPage.visible = this.flippingStage === 1;
                    if (this.unflippedPage)
                        this.unflippedPage.visible = this.flippingStage === 2;
                }
                resetGame() {
                    this.pages.forEach(page => page.setScale(1, 1));
                    this.currentPageIndex = 0;
                    this.flippingActive = false;
                    this.flippingStage = 0;
                    this.detectPages();
                    this.updatePagesVisibility();
                    this.sortPages();
                }
                onCompleteClicked() {
                    const numStars = this.scene.game.cache.json.get('gameplay').maxStars;
                    let completeWindow = new screen.CompleteWindow(this.scene, (target) => {
                    }, (target) => {
                        completeWindow.destroy();
                        this.resetGame();
                        this.remove(completeWindow);
                    }, (target) => {
                    });
                    this.add(completeWindow);
                    completeWindow.show(0, numStars);
                }
                onLeaveClicked() {
                    this.showAreYouSurePage();
                    this.scene.sound.add('warning page pop up sfx').play();
                }
                destroyGameplay() {
                    this.destroy();
                    this.backgroundImage.destroy();
                }
                showAreYouSurePage() {
                    const areYouSureWindow = new screen.AreYouSureWindow(this.scene, () => {
                        areYouSureWindow.destroy();
                        this.resetGame();
                        this.destroyGameplay();
                    }, () => {
                        areYouSureWindow.destroy();
                    });
                    this.add(areYouSureWindow);
                }
            }
            GameplayScreen.FLIP_DURATION = 275;
            GameplayScreen.UNFLIP_DURATION = 275;
            screen.GameplayScreen = GameplayScreen;
        })(screen = rp.screen || (rp.screen = {}));
    })(rp || (rp = {}));

    game = new rp.App(json);
};

function destroyreadingPractice3() {
    if (game) {
        game.destroy();
        game = null;
    }
}

var rp;
var game;

var reciteTheVerse = (json) => {
    (function (rp) {
        class App extends Phaser.Game {
            constructor(json) {
                App.json = json;
                let config = {
                    type: Phaser.AUTO,
                    width: App.CANVAS_WIDTH,
                    height: App.CANVAS_HEIGHT,
                    parent: 'game-container',
                    dom: {
                        createContainer: false
                    },
                    scale: {
                        mode: Phaser.Scale.NONE,
                        // autoCenter: Phaser.Scale.CENTER_BOTH
                    },
                    transparent: true,
                    scene: {
                        create: () => {
                            this.scene.add('Boot', rp.scene.Boot, true);
                        }
                    }
                };
                super(config);
            }
        }

        App.CANVAS_WIDTH = 980;
        App.CANVAS_HEIGHT = 600;
        rp.App = App;
    })(rp || (rp = {}));

    let delayedCalls = [];
    function delayedCall(delay, callback, args, callbackScope) {
        let scene = game.scene.getAt(0);
        if (scene) {
            let dc = scene.time.delayedCall(delay, callback, args, callbackScope);
            delayedCalls.push(dc);
            return dc;
        }
        let t = setTimeout(callback, delay);
        delayedCalls.push(t);
        return t;
    }
    function pauseAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.paused = true;
            }
        }
    }
    function resumeAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.paused = false;
            }
        }
    }
    function destroyAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.remove(false);
            }
            else {
                clearTimeout(dc);
            }
        }
        delayedCalls = [];
    }
    function setPageBackground(bg) {
        document.querySelector("html").style.backgroundImage = "url(assets/imgs/" + bg + ".jpg)";
    }
    function setupButton(btn, frame) {
        btn.on('pointerdown', () => {
            btn.setFrame(frame + '_hover' + '0000');
        });
        btn.on('pointerover', () => {
            btn.setFrame(frame + '_hover' + '0000');
            game.scene.getAt(0).sound.add("button hover").play();
        });
        btn.on('pointerout', () => {
            btn.setFrame(frame + '0000');
        });
        btn.on('pointerup', () => {
            btn.setFrame(frame + '0000');
            game.scene.getAt(0).sound.add('activity selection - button selection').play();
        });
    }
    function setupButtonTextureBased(btn, texture, hoverTexture) {
        btn.on('pointerdown', () => {
            btn.setTexture(hoverTexture);
        });
        btn.on('pointerover', () => {
            btn.setTexture(hoverTexture);
            game.scene.getAt(0).sound.add("button hover").play();
        });
        btn.on('pointerout', () => {
            btn.setTexture(texture);
        });
        btn.on('pointerup', () => {
            btn.setTexture(texture);
            game.scene.getAt(0).sound.add('activity selection - button selection').play();
        });
    }
    function setupButtonFrameBased(btn, texture, defaultFrame, hoverFrame, playClickSound = false, playHoverSound = false) {
        btn.setTexture(texture, defaultFrame);
        btn.on('pointerdown', () => {
            btn.setFrame(hoverFrame);
        });
        btn.on('pointerover', () => {
            btn.setFrame(hoverFrame);
            if (playHoverSound)
                game.scene.getAt(0).sound.add("button hover").play();
        });
        btn.on('pointerout', () => {
            btn.setFrame(defaultFrame);
        });
        btn.on('pointerup', () => {
            btn.setFrame(defaultFrame);
            if (playClickSound)
                game.scene.getAt(0).sound.add('click').play();
        });
    }
    class AbstractPage extends Phaser.GameObjects.Container {
        constructor(scene, pageIndex) {
            super(scene);
            this.pageIndex = pageIndex;
            this.contentContainer = new Phaser.GameObjects.Container(this.scene, pageIndex % 2 === 0 ? -456 : 2, 0);
            this.add(this.contentContainer);
            this.pageBackground = new Phaser.GameObjects.Image(this.scene, 0, 0, pageIndex % 2 === 0 ? 'page-bg' : 'page-bg-front', 0);
            this.pageBackground.setOrigin(0, 0.5);
            this.contentContainer.add(this.pageBackground);

            this.pageBackground.setVisible(false);
        }
    }
    class EmptyPage extends AbstractPage {
        constructor(scene, pageIndex) {
            super(scene, pageIndex);
        }
        buildContent() {
        }
    }
    class EndPage extends AbstractPage {
        constructor(scene, pageIndex, onCompleteCallback) {
            super(scene, pageIndex);
            this.pageBackground.alpha = 0;
            this.buttonComplete = new Phaser.GameObjects.Image(this.scene, 220, 50, 'complete-button');
            this.buttonComplete.setInteractive({ cursor: 'pointer' });
            setupButtonFrameBased(this.buttonComplete, 'complete-button', 1, 0, true, true);
            this.buttonComplete.on('pointerup', () => onCompleteCallback());
            this.contentContainer.add([this.buttonComplete]);
        }
        buildContent() {
        }
    }
    class Page extends AbstractPage {
        constructor(scene, pageIndex, dataIndex, displayedNumber) {
            super(scene, pageIndex);
            this.dataIndex = dataIndex;
            this.displayedNumber = displayedNumber;
            this.buildContent();
        }
        buildContent() {
            // this.frameBg = new Phaser.GameObjects.Image(this.scene, 225, 0, 'frame-bg');
            const gameplayConfig = this.scene.game.cache.json.get('gameplay');

            const pages = gameplayConfig.data.pages;
            if (pages[this.dataIndex]["useImages"]) {
                this.text = new Phaser.GameObjects.Image(this.scene, 225, -45, pages[this.dataIndex].text);
            } else {
                this.text = new Phaser.GameObjects.Text(this.scene, 225, -45, "", {
                    "fontFamily": json.data.defaultFontFamily ? json.data.defaultFontFamily : "HafsQuranEra",
                    "fontSize": pages[this.dataIndex].fontSize ? pages[this.dataIndex].fontSize : json.data.defaultFontSize ? json.data.defaultFontSize : 45 * 2,
                    "color": "#010101",
                    "align": 'center'
                });
                this.text.setOrigin(0.5, 0.5);
                this.text.setText(pages[this.dataIndex].text);
                this.text.setPadding(0, 30);
            }
            let limitHeight = 240;
            let scale = limitHeight / this.text.height;
            if (this.text.height > limitHeight) this.text.setScale(scale);
            let limitWidth = 520;
            if (this.text.width > limitWidth) {
                scale = Math.min(scale, limitWidth / this.text.width);
                this.text.setScale(scale);
            }

            this.vocalizeBtn = new Phaser.GameObjects.Image(this.scene, 225, 108, 'reading-sound', 0);
            this.vocalizeBtn.setOrigin(0.5, 0.5);
            this.vocalizeBtn.setInteractive({ cursor: 'pointer' });
            setupButtonFrameBased(this.vocalizeBtn, 'reading-sound', 1, 0, false, true);
            this.pageNumberText = new Phaser.GameObjects.Text(this.scene, 225, 435 - 227, this.displayedNumber / 2, {
                "fontFamily": "QuranErafont",
                "fontSize": "1.1rem",
                "color": "#010101",
                "align": 'center'
            });
            this.pageNumberText.setOrigin(0.5, 1);
            this.pageNumberText.visible = false;
            this.contentContainer.setPosition(-136, -30);
            this.contentContainer.add([this.pageBackground, /*this.frameBg,*/ this.text, this.vocalizeBtn, this.pageNumberText]);
            this.vocalizeBtn.on('pointerup', () => {
                if (this.sound) {
                    this.sound.stop();
                    this.sound.destroy();
                }
                if (gameplayConfig.data.useLocalFiles) {
                    this.sound = this.scene.sound.add(pages[this.dataIndex].text);
                }
                else {
                    this.sound = this.scene.sound.add(pages[this.dataIndex].audio);
                }
                this.sound.play();
            });
        }
    }
    (function (rp) {
        var scene;
        (function (scene) {
            class Boot extends Phaser.Scene {
                init() {
                    this.game.scale.transformX = (pageX) => {
                        let offsetLeft = 0;
                        let parentElement = game.canvas.parentElement;
                        while (parentElement) {
                            if (parentElement.offsetLeft) {
                                offsetLeft = parentElement.offsetLeft;
                                break;
                            }
                            parentElement = parentElement.parentElement;
                        }
                        return (pageX - offsetLeft) * this.game.scale.displayScale.x;
                    };
                    this.game.scale.transformY = (pageY) => {
                        let offsetTop = 0;
                        let parentElement = game.canvas.parentElement;
                        while (parentElement) {
                            if (parentElement.offsetTop) {
                                offsetTop = parentElement.offsetTop;
                                break;
                            }
                            parentElement = parentElement.parentElement;
                        }
                        return (pageY - offsetTop) * this.game.scale.displayScale.y;
                    };
                }

                create() {
                    game.scene.remove('Boot');
                    game.scene.add('Preloader', rp.scene.Preloader, true);
                }
            }
            scene.Boot = Boot;
        })(scene = rp.scene || (rp.scene = {}));
    })(rp || (rp = {}));
    (function (rp) {
        var scene;
        (function (scene) {
            class MainScene extends Phaser.Scene {
                create() {
                    this.gameplayScreen = new rp.screen.GameplayScreen(this);
                    this.children.add(this.gameplayScreen);
                    this.gameplayScreen.showInstructionPage();
                }
            }
            scene.MainScene = MainScene;
        })(scene = rp.scene || (rp.scene = {}));
    })(rp || (rp = {}));
    (function (rp) {
        var scene;
        (function (scene) {
            class Preloader extends Phaser.Scene {
                preload() {
                    if (typeof rp.App.json == "string") this.load.json('gameplay', rp.App.json); else this.game.cache.json.add('gameplay', rp.App.json);
                }
                create() {
                    const gameplayConfig = this.game.cache.json.get('gameplay');
                    const pages = gameplayConfig.data.pages;
                    pages.forEach((page, index) => {
                        if (page["useImages"]) {
                            if (page["text"].includes('http') || page["text"].includes("assets")) {
                                this.load.image(page["text"], page["text"]);
                            }
                            else if (json.data.gameId) {
                                this.load.image(page["text"], "assets/games/recite-the-verse/assets/imgs/words/" + json.data.gameId + "/" + page["text"] + ".png");
                            }
                            else {
                                this.load.image(page["text"], "assets/games/recite-the-verse/assets/imgs/words/" + page["text"] + ".png");
                            }
                        }
                        if (gameplayConfig.data.useLocalFiles) {
                            if (json.data.gameId) {
                                if (json.data.indexed) {
                                    this.load.audio(page["text"], "assets/games/recite-the-verse/assets/sound/mp3/words/" + json.data.gameId + "/" + (index + 1).toString() + ".mp3");
                                } else {
                                    this.load.audio(page["text"], "assets/games/recite-the-verse/assets/sound/mp3/words/" + json.data.gameId + "/" + page["text"] + ".mp3");
                                }
                            } else {
                                this.load.audio(page["text"], "assets/games/recite-the-verse/assets/sound/mp3/words/" + page["text"] + ".mp3");
                            }
                        } else {
                            this.load.audio(page["audio"], page["audio"]);
                        }
                    });

                    //modify pages array
                    let _pages = gameplayConfig.data.pages;
                    for (let i = _pages.length - 1; i >= 0; i--) {
                        _pages.splice(i, 0, { 'text': '' });
                    }
                    // gameplayConfig.data.pages = [_pages[0],_pages[1],_pages[2],_pages[3],_pages[4],_pages[5]];

                    this.load.audio(gameplayConfig.introduction.audio, gameplayConfig.introduction.audio);
                    this.load.audio("complete-audio", Phaser.Utils.Array.GetRandom(gameplayConfig.completeAudios));
                    this.load.pack('preloader', 'assets/games/recite-the-verse/assets/pack.json');
                    this.load.on('progress', (value) => {
                    }, this);
                    this.load.on('complete', () => {
                        this.nextScene();
                    });
                    this.load.start();
                }
                nextScene() {
                    game.scene.remove('Preloader');
                    game.scene.add('ScreenMain', rp.scene.MainScene, true);
                }
            }
            scene.Preloader = Preloader;
        })(scene = rp.scene || (rp.scene = {}));
    })(rp || (rp = {}));
    (function (rp) {
        var screen;
        (function (screen) {
            class AreYouSureWindow extends Phaser.GameObjects.Container {
                constructor(scene, onYes, onNo) {
                    super(scene);
                    this._areYouSurePage = new Phaser.GameObjects.Image(this.scene, -105, 0 - 48, 'Exit warning');
                    this._areYouSurePage.setOrigin(0, 0);
                    this._areYouSurePage.setInteractive();
                    this._btnSureYes = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2 - 95, 485 - 50, 'btnYES1');
                    this._btnSureYes.setInteractive({ cursor: 'pointer' });
                    setupButtonTextureBased(this._btnSureYes, 'btnYES1', 'btnYES2');
                    this._btnSureYes.once('pointerup', () => {
                        onYes;
                        window.angularComponentRef.backToMenu();
                    });

                    var modalTextStyle = {
                        backgroundColor: 'transparent',
                        stroke: '#ffffff',
                        strokeThickness: 2,
                        lineSpacing: 15,
                        fontFamily: 'Kids Rock DEMO',
                        fontSize: 27,
                        color: '#43425d',
                        wordWrap: true,
                        align: 'center'
                    };
                    var modalText = this.scene.add.text(game.scale.width / 2 + 12, game.scale.height / 2, "Your progress in this activity will not be saved. \n Are you sure you want to exit? ", modalTextStyle);
                    modalText.setOrigin(0.5, 0.5);

                    this._btnSureNo = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2 + 95, 485 - 50, 'btnNO1');
                    this._btnSureNo.setInteractive({ cursor: 'pointer' });
                    setupButtonTextureBased(this._btnSureNo, 'btnNO1', 'btnNO2');
                    this._btnSureNo.once('pointerup', onNo);
                    this.add(this._areYouSurePage);
                    this.add(this._btnSureYes);
                    this.add(this._btnSureNo);
                    this.add(modalText);
                }
            }
            screen.AreYouSureWindow = AreYouSureWindow;
        })(screen = rp.screen || (rp.screen = {}));
    })(rp || (rp = {}));
    (function (rp) {
        var screen;
        (function (screen) {
            class InstructionPage extends Phaser.GameObjects.Container {
                constructor(scene, onPlayClick, onSndClick) {
                    super(scene);
                    this._instructionPage = new Phaser.GameObjects.Image(this.scene, 0 - 105, 0 - 48, 'Instructions page  ALL ACTIVITY  TITLEs');
                    this._instructionPage.setOrigin(0, 0);
                    this._instructionPage.setInteractive();
                    this._instructionPageTitle = new Phaser.GameObjects.Image(this.scene, 495, 105, 'welcome');
                    this._btnPlay = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2, 480 - 20, 'btnPLAY1');
                    this._btnPlay.setInteractive({ cursor: 'pointer' });
                    this._btnPlay.once('pointerup', () => {
                        onPlayClick();
                        // this.parentContainer.remove(this);
                    });
                    setupButtonTextureBased(this._btnPlay, 'btnPLAY1', 'btnPLAY2');
                    const gameplayConfig = this.scene.game.cache.json.get('gameplay');
                    this.instrTxt = this.scene.add.text(game.scale.width / 2, game.scale.height / 2, gameplayConfig.introduction.text ? gameplayConfig.introduction.text.replaceAll('<br>', '\n') : "Read the verse and earn reward for each letter you have read.", {
                        "fontFamily": "Kids Rock DEMO",
                        "fontSize": 27,
                        "color": "#43425D",
                        "align": 'center',
                        stroke: '#ffffff',
                        strokeThickness: 2,
                        lineSpacing: 20,
                    });
                    this.instrTxt.setOrigin(0.5, 0.5);
                    this.instrTxt.setWordWrapWidth(600);
                    this.instrTxt.setLineSpacing(5);
                    this._btnSoundInstruction = new Phaser.GameObjects.Image(this.scene, 800 - 105, 156 - 50, 'Sound');
                    this._btnSoundInstruction.setInteractive({ cursor: 'pointer' });
                    this._btnSoundInstruction.on('pointerup', () => {
                        onSndClick();
                        /* if (this.sound) {
                            this.sound.stop();
                            this.sound.destroy();
                        }
                        this.sound = this.scene.sound.add(gameplayConfig.introduction.audio);
                        this.sound.play(); */
                    });
                    this._btnSoundInstruction["defScale"] = this._btnSoundInstruction.scale;
                    setupButtonTextureBased(this._btnSoundInstruction, 'Sound', 'Sound HOVER EFFECT');
                    this.add(this._instructionPage);
                    this.add(this._instructionPageTitle);
                    this.add(this.instrTxt);
                    this.add(this._btnPlay);
                    this.add(this._btnSoundInstruction);
                }
            }
            screen.InstructionPage = InstructionPage;
        })(screen = rp.screen || (rp.screen = {}));
    })(rp || (rp = {}));
    (function (rp) {
        var screen;
        (function (screen) {
            class CompleteWindow extends Phaser.GameObjects.Container {
                constructor(scene, onBack, onReplay, onNext) {
                    super(scene);
                    this.music = null;
                    this.setPosition(-104.5, -48);
                    this._bgComplete = new Phaser.GameObjects.Image(this.scene, 0, 0, 'Completion page LATEST UPDATED');
                    this._bgComplete.setOrigin(0, 0);
                    this._bgComplete.setInteractive();
                    this._cup = new Phaser.GameObjects.Image(this.scene, 400, 410, 'Trophy');
                    this._btnBack = new Phaser.GameObjects.Image(this.scene, 570, 570, 'btnBACK1');
                    this._btnReplay = new Phaser.GameObjects.Image(this.scene, 720, 570, 'btnReplay1');
                    this._btnNext = new Phaser.GameObjects.Image(this.scene, 870, 570, 'btnNEXT1');
                    let _CollectedPoints = new Phaser.GameObjects.Image(this.scene, 620, 440, 'Collected Points');
                    this.totalScoreTxt = this.scene.add.text(845, 352, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 35,
                        "color": "#F49F1C",
                        "align": 'center',
                        'stroke': '#70451A',
                        'strokeThickness': 6
                    });
                    this.totalScoreTxt.setOrigin(0.5, 0.5);
                    let grd = this.totalScoreTxt.context.createLinearGradient(0, 0, 0, this.totalScoreTxt.height);
                    grd.addColorStop(0, '#FFFF00');
                    grd.addColorStop(1, '#C17316');
                    this.totalScoreTxt.setFill(grd);
                    this.starScoreTxt = this.scene.add.text(648, 433, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 24,
                        "color": "#FFFFFF",
                        "align": 'center'
                    });
                    this.starScoreTxt.setOrigin(0.5, 0.5);
                    this.add([
                        this._bgComplete,
                        _CollectedPoints,
                        this._cup,
                        this._btnBack,
                        this._btnReplay,
                        this._btnNext,
                        this.totalScoreTxt,
                        this.starScoreTxt
                    ]);
                    this._btnBack.setInteractive({ cursor: 'pointer' });
                    setupButtonTextureBased(this._btnBack, 'btnBACK1', 'btnBACK2');
                    this._btnBack.on('pointerup', () => {
                        onBack(this._btnBack);
                        window.angularComponentRef.backToMenu();
                        // if (this.music) {
                        //     this.music.stop();
                        // }
                    });
                    this._btnReplay.setInteractive({ cursor: 'pointer' });
                    setupButtonTextureBased(this._btnReplay, 'btnReplay1', 'btnReplay2');
                    this._btnReplay.once('pointerup', () => {
                        onReplay(this._btnReplay);
                        if (this.music) {
                            this.music.stop();
                        }
                    });
                    this._btnNext.setInteractive({ cursor: 'pointer' });
                    setupButtonTextureBased(this._btnNext, 'btnNEXT1', 'btnNEXT2');
                    this._btnNext.on('pointerup', () => {
                        onNext(this._btnNext);
                        window.angularComponentRef.nextActivity();
                        // if (this.music) {
                        //     this.music.stop();
                        // }
                    });
                }
                show(score, starScore) {
                    window.angularComponentRef.gameFinish({ score, starScore });
                    this._cup.scale = 1.25;
                    this.scene.tweens.add({
                        targets: this._cup,
                        "scale": 1,
                        duration: 500,
                        ease: Phaser.Math.Easing.Back.Out
                    });
                    this.totalScoreTxt.text = String(window.angularComponentRef.component.userInfo.totalScore);
                    this.starScoreTxt.text = String(starScore);
                    this.music = this.scene.sound.add("complete-audio");
                    this.music.play();
                }
            }
            screen.CompleteWindow = CompleteWindow;
        })(screen = rp.screen || (rp.screen = {}));
    })(rp || (rp = {}));
    (function (rp) {
        var screen;
        (function (screen) {
            class GameplayScreen extends Phaser.GameObjects.Container {
                constructor(scene) {
                    super(scene);
                    this.currentPageIndex = 0;
                    this.flippingActive = false;
                    this.flippingStage = 0;
                    this.flippingDirection = 0;
                    this.leftPage = null;
                    this.rightPage = null;
                    this.flippedPage = null;
                    this.unflippedPage = null;
                    window["gameplay"] = this;
                    this.createBackground();
                    this.buildPages();
                    this.buildButtons();
                }
                buildPages() {
                    this.pages = [];
                    /* introduction page */
                    // this.pages.push(new IntroductionPage(this.scene, 0));
                    /* empty page to combine with an introduction page */
                    // this.pages.push(new EmptyPage(this.scene, 1));
                    /* pages */
                    const gameplayConfig = this.scene.game.cache.json.get('gameplay');
                    const pages = gameplayConfig.data.pages;
                    for (let i = 0; i < pages.length; i++) {
                        this.pages.push(new Page(this.scene, i + 2, i, `${i + 1}`));
                    }
                    /* empty page */
                    // this.pages.push(new EmptyPage(this.scene, this.pages.length));
                    /* the last page */
                    // this.pages.push(new EndPage(this.scene, this.pages.length, () => this.onCompleteClicked()));
                    this.pagesContainer = new Phaser.GameObjects.Container(this.scene, 500, 107 + 227);
                    this.add(this.pagesContainer);
                    this.pagesContainer.add(this.pages);
                    this.resetGame();
                }
                buildButtons() {
                    this.buttonPrevPage = new Phaser.GameObjects.Image(this.scene, 450, 380, 'arrows'); window['this.buttonPrevPage'] = this.buttonPrevPage;
                    this.buttonPrevPage.setOrigin(0, 0);
                    this.buttonPrevPage.setInteractive({ cursor: 'pointer' });
                    setupButtonFrameBased(this.buttonPrevPage, 'arrows', 2, 0, true, true);
                    this.buttonPrevPage.on('pointerup', this.switchToPrevPage, this);
                    this.buttonNextPage = new Phaser.GameObjects.Image(this.scene, 660, 380, 'arrows'); window['this.buttonNextPage'] = this.buttonNextPage;
                    this.buttonNextPage.setOrigin(0, 0);
                    this.buttonNextPage.setInteractive({ cursor: 'pointer' });
                    setupButtonFrameBased(this.buttonNextPage, 'arrows', 3, 1, true, true);
                    this.buttonNextPage.on('pointerup', this.switchToNextPage, this);
                    this.add([this.buttonPrevPage, this.buttonNextPage]);
                }
                createBackground() {
                    this.backgroundImage = this.scene.add.image(0, 0, 'reading-bg');
                    this.backgroundImage.setOrigin(0, 0);
                    this.buttonClose = new Phaser.GameObjects.Image(this.scene, 930, 50, 'x Button');
                    this.buttonClose.setInteractive({ cursor: 'pointer' });
                    setupButtonTextureBased(this.buttonClose, 'x Button', 'x Button HOVER EFFECT');
                    this.buttonClose.on('pointerup', this.onLeaveClicked, this);
                    this.add(this.buttonClose);
                }
                showInstructionPage() {
                    setPageBackground("bg-blue");
                    let playInstructionSound = () => {
                        if (this.sound) {
                            this.sound.stop();
                            this.sound.destroy();
                        }
                        const gameplayConfig = this.scene.game.cache.json.get('gameplay');
                        this.sound = this.scene.sound.add(gameplayConfig.introduction.audio ? gameplayConfig.introduction.audio : "Recite the verse - Instruction page audio");
                        this.sound.play();
                    };
                    this.instructionPage = new screen.InstructionPage(this.scene, (target) => {
                        // playBtnClickAnim(target);
                        this.remove(this.instructionPage, true);
                        if (this.sound) {
                            this.sound.stop();
                        }

                        let currPage = this.pages[this.currentPageIndex + 1];
                        this.sound = this.scene.sound.add("Aoothu and basmala");
                        this.sound.play();
                        this.sound.once('complete', () => {
                            this.buttonPrevPage.setInteractive({ cursor: 'pointer' });
                            this.buttonNextPage.setInteractive({ cursor: 'pointer' });
                            currPage.vocalizeBtn.setInteractive({ cursor: 'pointer' });
                            this.buttonPrevPage.alpha = this.buttonNextPage.alpha = currPage.vocalizeBtn.alpha = 1;
                        });
                        this.buttonPrevPage.disableInteractive();
                        this.buttonNextPage.disableInteractive();
                        currPage.vocalizeBtn.disableInteractive();
                        this.buttonPrevPage.alpha = this.buttonNextPage.alpha = currPage.vocalizeBtn.alpha = 0.5;
                    }, (target) => {
                        // playBtnClickAnim(target);
                        playInstructionSound();
                    });
                    this.add(this.instructionPage);
                    try {
                        playInstructionSound();
                    }
                    catch (e) {
                        console.error(e);
                    }
                }
                switchToPrevPage() {
                    if (this.flippingActive)
                        return;
                    if (this.currentPageIndex >= 2) {
                        this.flipToPrevPage();
                    }
                }
                switchToNextPage() {
                    if (this.flippingActive)
                        return;
                    if (this.currentPageIndex < this.pages.length - 2) {
                        this.flipToNextPage();
                    } else {//the last page's next button clicked
                        this.onCompleteClicked();
                    }
                }
                flipToPrevPage() {
                    this.leftPage = this.pages[this.currentPageIndex - 2];
                    this.flippedPage = this.pages[this.currentPageIndex];
                    this.unflippedPage = this.pages[this.currentPageIndex - 1];
                    this.rightPage = this.pages[this.currentPageIndex + 1];
                    this.flippingDirection = -1;
                    this.currentPageIndex -= 2;
                    this.flipPages(this.flippedPage, this.unflippedPage);

                    this.leftPage.setVisible(false);
                    this.rightPage.setVisible(true);
                }
                flipToNextPage() {
                    this.leftPage = this.pages[this.currentPageIndex];
                    this.flippedPage = this.pages[this.currentPageIndex + 1];
                    this.unflippedPage = this.pages[this.currentPageIndex + 2];
                    this.rightPage = this.pages[this.currentPageIndex + 3];
                    this.flippingDirection = 1;
                    this.currentPageIndex += 2;
                    this.flipPages(this.flippedPage, this.unflippedPage);

                    this.leftPage.setVisible(false);
                    this.rightPage.setVisible(true); window['this.rightPage'] = this.rightPage;
                }
                flipPages(pageToFlip, pageToUnflip) {
                    this.scene.game.sound.stopAll();
                    if (!this.flipSound)
                        this.flipSound = this.scene.sound.add('flip');
                    this.flipSound.play();
                    this.flippingActive = true;
                    this.flippingStage = 1;
                    this.updatePagesVisibility();
                    this.sortPages();
                    if (this.flippingDirection < 0) pageToFlip.setVisible(false);
                    this.scene.tweens.add({
                        targets: pageToFlip,
                        alpha: 0.0,
                        duration: GameplayScreen.FLIP_DURATION,
                        onComplete: () => {
                            this.flippingStage = 2;
                            this.updatePagesVisibility();
                            this.sortPages();
                            if (this.flippingDirection > 0) pageToUnflip.setVisible(false);
                            this.scene.tweens.add({
                                targets: pageToUnflip,
                                alpha: 1,
                                duration: GameplayScreen.UNFLIP_DURATION,
                                onComplete: () => {
                                    this.flippingActive = false;
                                    this.flippingStage = 0;
                                    this.flippingDirection = 0;
                                    this.detectPages();
                                    this.updatePagesVisibility();
                                    this.sortPages();
                                }
                            });
                        }
                    });
                }
                sortPages() {
                    this.pagesContainer.sort("pageIndex", (pageA, pageB) => {
                        if (pageA === this.flippedPage || pageA === this.unflippedPage)
                            return 1;
                        if (pageB === this.flippedPage || pageB === this.unflippedPage)
                            return -1;
                        return this.flippingDirection * (pageA.pageIndex - pageB.pageIndex);
                    });
                }
                detectPages() {
                    this.leftPage = this.pages[this.currentPageIndex];
                    this.rightPage = this.pages[this.currentPageIndex + 1];
                    this.flippedPage = this.unflippedPage = null;

                    this.leftPage.setVisible(false);
                    this.rightPage.setVisible(true);
                }
                updatePagesVisibility() {
                    this.pages.forEach(page => page.setVisible(false));
                    if (this.leftPage)
                        this.leftPage.visible = true;
                    if (this.rightPage)
                        this.rightPage.visible = true;
                    if (this.flippedPage)
                        this.flippedPage.visible = this.flippingStage === 1;
                    if (this.unflippedPage)
                        this.unflippedPage.visible = this.flippingStage === 2;

                    this.leftPage.setVisible(false);
                }
                resetGame() {
                    this.pages.forEach(page => page.alpha = 1);
                    this.currentPageIndex = 0;
                    this.flippingActive = false;
                    this.flippingStage = 0;
                    this.detectPages();
                    this.updatePagesVisibility();
                    this.sortPages();
                }
                onCompleteClicked() {
                    const numStars = this.scene.game.cache.json.get('gameplay').maxStars;
                    let completeWindow = new screen.CompleteWindow(this.scene, (target) => {
                    }, (target) => {
                        completeWindow.destroy();
                        this.resetGame();
                        this.remove(completeWindow);
                    }, (target) => {
                    });
                    this.add(completeWindow);
                    completeWindow.show(0, numStars);
                }
                onLeaveClicked() {
                    this.showAreYouSurePage();
                    this.scene.sound.add('warning page pop up sfx').play();
                }
                destroyGameplay() {
                    this.destroy();
                    this.backgroundImage.destroy();
                }
                showAreYouSurePage() {
                    game.sound.pauseAll();
                    const areYouSureWindow = new screen.AreYouSureWindow(this.scene, () => {
                        areYouSureWindow.destroy();
                        this.resetGame();
                        this.destroyGameplay();
                    }, () => {
                        areYouSureWindow.destroy();
                        game.sound.resumeAll();
                    });
                    this.add(areYouSureWindow);
                }
            }
            GameplayScreen.FLIP_DURATION = 275;
            GameplayScreen.UNFLIP_DURATION = 275;
            screen.GameplayScreen = GameplayScreen;
        })(screen = rp.screen || (rp.screen = {}));
    })(rp || (rp = {}));

    game = new rp.App(json);
};

function destroyreadingReciteTheVerse() {
    if (game) {
        game.destroy();
        game = null;
    }
}

var rp;
var game;

var iqraTime = (json) => {
    (function (rp) {
        class App extends Phaser.Game {
            constructor(json) {
                App.json = json;
                let config = {
                    type: Phaser.AUTO,
                    width: App.CANVAS_WIDTH,
                    height: App.CANVAS_HEIGHT,
                    parent: 'game-container',
                    dom: {
                        createContainer: false
                    },
                    scale: {
                        mode: Phaser.Scale.NONE,
                        // autoCenter: Phaser.Scale.CENTER_BOTH
                    },
                    transparent: true,
                    scene: {
                        create: () => {
                            this.scene.add('Boot', rp.scene.Boot, true);
                        }
                    }
                };
                super(config);
            }
        }

        App.CANVAS_WIDTH = 980;
        App.CANVAS_HEIGHT = 600;
        rp.App = App;
    })(rp || (rp = {}));

    let delayedCalls = [];
    function delayedCall(delay, callback, args, callbackScope) {
        let scene = game.scene.getAt(0);
        if (scene) {
            let dc = scene.time.delayedCall(delay, callback, args, callbackScope);
            delayedCalls.push(dc);
            return dc;
        }
        let t = setTimeout(callback, delay);
        delayedCalls.push(t);
        return t;
    }
    function pauseAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.paused = true;
            }
        }
    }
    function resumeAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.paused = false;
            }
        }
    }
    function destroyAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.remove(false);
            }
            else {
                clearTimeout(dc);
            }
        }
        delayedCalls = [];
    }
    function setPageBackground(bg) {
        document.querySelector("html").style.backgroundImage = "url(assets/imgs/" + bg + ".jpg)";
    }
    function setupButton(btn, frame) {
        btn.on('pointerdown', () => {
            btn.setFrame(frame + '_hover' + '0000');
        });
        btn.on('pointerover', () => {
            btn.setFrame(frame + '_hover' + '0000');
            game.scene.getAt(0).sound.add("button hover").play();
        });
        btn.on('pointerout', () => {
            btn.setFrame(frame + '0000');
        });
        btn.on('pointerup', () => {
            btn.setFrame(frame + '0000');
            game.scene.getAt(0).sound.add('activity selection - button selection').play();
        });
    }
    function setupButtonTextureBased(btn, texture, hoverTexture) {
        btn.on('pointerdown', () => {
            btn.setTexture(hoverTexture);
        });
        btn.on('pointerover', () => {
            btn.setTexture(hoverTexture);
            game.scene.getAt(0).sound.add("button hover").play();
        });
        btn.on('pointerout', () => {
            btn.setTexture(texture);
        });
        btn.on('pointerup', () => {
            btn.setTexture(texture);
            game.scene.getAt(0).sound.add('activity selection - button selection').play();
        });
    }
    function setupButtonFrameBased(btn, texture, defaultFrame, hoverFrame, playClickSound = false, playHoverSound = false) {
        btn.setTexture(texture, defaultFrame);
        btn.on('pointerdown', () => {
            btn.setFrame(hoverFrame);
        });
        btn.on('pointerover', () => {
            btn.setFrame(hoverFrame);
            if (playHoverSound)
                game.scene.getAt(0).sound.add("button hover").play();
        });
        btn.on('pointerout', () => {
            btn.setFrame(defaultFrame);
        });
        btn.on('pointerup', () => {
            btn.setFrame(defaultFrame);
            if (playClickSound)
                game.scene.getAt(0).sound.add('click').play();
        });
    }
    class AbstractPage extends Phaser.GameObjects.Container {
        constructor(scene, pageIndex) {
            super(scene);
            this.pageIndex = pageIndex;
            this.contentContainer = new Phaser.GameObjects.Container(this.scene, pageIndex % 2 === 0 ? -456 : 2, 0);
            this.add(this.contentContainer);
            this.pageBackground = new Phaser.GameObjects.Image(this.scene, 0, 0, pageIndex % 2 === 0 ? 'page-bg' : 'page-bg-front', 0);
            this.pageBackground.setOrigin(pageIndex % 2 === 0 ? 0.075 : 0.025, 0.495);
            this.contentContainer.add(this.pageBackground);
        }
    }
    class EmptyPage extends AbstractPage {
        constructor(scene, pageIndex) {
            super(scene, pageIndex);
        }
        buildContent() {
        }
    }
    class EndPage extends AbstractPage {
        constructor(scene, pageIndex, onCompleteCallback) {
            super(scene, pageIndex);
            this.pageBackground.alpha = 0;
            this.buttonComplete = new Phaser.GameObjects.Image(this.scene, 230, 50, 'complete-button');
            this.buttonComplete.setInteractive({ cursor: 'pointer' });
            setupButtonFrameBased(this.buttonComplete, 'complete-button', 1, 0, true, true);
            this.buttonComplete.on('pointerup', () => onCompleteCallback());
            this.contentContainer.add([this.buttonComplete]);
        }
        buildContent() {
        }
    }
    class IntroductionPage extends AbstractPage {
        constructor(scene, pageIndex) {
            super(scene, pageIndex);
            this.buildContent();
        }
        buildContent() {
            const gameplayConfig = this.scene.game.cache.json.get('gameplay');
            this.headingText = new Phaser.GameObjects.Text(this.scene, 235, 100 - 227, gameplayConfig.introduction.title, {
                "fontFamily": "Kids Rock Demo",
                fontSize: "1.9rem",
                color: "#feb832",
                align: 'center',
                stroke: 'rgba(201, 87, 17, 0.8)',
                strokeThickness: 4,
                shadow: {
                    color: "#8b5a39",
                    offsetX: 2,
                    offsetY: 2,
                    stroke: true,
                    fill: true
                }
            });
            this.headingText.setOrigin(0.5, 0.5);
            this.mainText = new Phaser.GameObjects.Text(this.scene, 235, 250 - 227, gameplayConfig.introduction.text.replaceAll('<br>', '\n'), {
                "fontFamily": "Kids Rock Demo",
                fontSize: "1.175rem",
                color: "#6b3a24",
                align: 'center',
                wordWrap: {
                    width: 410,
                    useAdvancedWrap: false
                }
            });
            this.mainText.setOrigin(0.5, 0.5);
            this.mainText.setLineSpacing(14);
            this.vocalizeBtn = new Phaser.GameObjects.Image(this.scene, 395, 95 - 227, 'reading-sound', 0);
            this.vocalizeBtn.setInteractive({ cursor: 'pointer' });
            setupButtonFrameBased(this.vocalizeBtn, 'reading-sound', 1, 0, false, true);
            this.vocalizeBtn.on('pointerup', () => {
                if (this.sound) {
                    this.sound.stop();
                    this.sound.destroy();
                }
                this.sound = this.scene.sound.add("introduction");
                this.sound.play();
            });
            this.sound = this.scene.sound.add("introduction");
            this.sound.play();
            this.contentContainer.add([this.headingText, this.mainText, this.vocalizeBtn]);
        }
    }

    class Page extends AbstractPage {
        constructor(scene, pageIndex, dataIndex, displayedNumber) {
            super(scene, pageIndex);
            this.dataIndex = dataIndex;
            this.displayedNumber = displayedNumber;
            this.buildContent();
        }
        buildContent() {
            this.frameBg = new Phaser.GameObjects.Image(this.scene, 218, 0, 'frame-bg');
            const gameplayConfig = this.scene.game.cache.json.get('gameplay');

            const pages = gameplayConfig.data.pages;
            if (pages[this.dataIndex]["useImages"]) {
                this.text = new Phaser.GameObjects.Image(this.scene, 225, 0, pages[this.dataIndex].text);
            } else {
                this.text = new Phaser.GameObjects.Text(this.scene, 225, 55, "", {
                    "fontFamily": json.data.defaultFontFamily ? json.data.defaultFontFamily : "HafsQuranEra",
                    "fontSize": pages[this.dataIndex].fontSize ? pages[this.dataIndex].fontSize : json.data.defaultFontSize ? json.data.defaultFontSize : 46,
                    "color": "#000000",
                    "align": 'center',
                    "stroke": '#000000',
                    "strokeThickness": 1
                });
                this.text.setOrigin(0.5, 0.5);
                this.text.style.fixedHeight = 195;
                this.text.setPadding(0, 16);
                this.text.setText(pages[this.dataIndex].text);
            }

            this.vocalizeBtn = new Phaser.GameObjects.Image(this.scene, 225, 76 - 227, 'reading-sound', 0);
            this.vocalizeBtn.setOrigin(0.5, 0.5);
            this.vocalizeBtn.setInteractive({ cursor: 'pointer' });
            setupButtonFrameBased(this.vocalizeBtn, 'reading-sound', 1, 0, false, true);
            this.pageNumberText = new Phaser.GameObjects.Text(this.scene, 225, 435 - 227, this.displayedNumber, {
                "fontFamily": "Kids Rock Demo",
                "fontSize": "1.5rem",
                "color": "#454544",
                "align": 'center'
            });
            this.pageNumberText.setOrigin(0.5, 1);
            this.contentContainer.add([this.pageBackground, this.frameBg, this.text, this.vocalizeBtn, this.pageNumberText]);
            this.vocalizeBtn.on('pointerup', () => {
                if (this.sound) {
                    this.sound.stop();
                    this.sound.destroy();
                }
                if (gameplayConfig.data.useLocalFiles) {
                    this.sound = this.scene.sound.add(pages[this.dataIndex].text);
                }
                else {
                    this.sound = this.scene.sound.add(pages[this.dataIndex].audio);
                }
                this.sound.play();
            });
        }
    }
    (function (rp) {
        var scene;
        (function (scene) {
            class Boot extends Phaser.Scene {
                init() {
                    this.game.scale.transformX = (pageX) => {
                        let offsetLeft = 0;
                        let parentElement = game.canvas.parentElement;
                        while (parentElement) {
                            if (parentElement.offsetLeft) {
                                offsetLeft = parentElement.offsetLeft;
                                break;
                            }
                            parentElement = parentElement.parentElement;
                        }
                        return (pageX - offsetLeft) * this.game.scale.displayScale.x;
                    };
                    this.game.scale.transformY = (pageY) => {
                        let offsetTop = 0;
                        let parentElement = game.canvas.parentElement;
                        while (parentElement) {
                            if (parentElement.offsetTop) {
                                offsetTop = parentElement.offsetTop;
                                break;
                            }
                            parentElement = parentElement.parentElement;
                        }
                        return (pageY - offsetTop) * this.game.scale.displayScale.y;
                    };
                }

                create() {
                    game.scene.remove('Boot');
                    game.scene.add('Preloader', rp.scene.Preloader, true);
                }
            }
            scene.Boot = Boot;
        })(scene = rp.scene || (rp.scene = {}));
    })(rp || (rp = {}));
    (function (rp) {
        var scene;
        (function (scene) {
            class MainScene extends Phaser.Scene {
                create() {
                    this.gameplayScreen = new rp.screen.GameplayScreen(this);
                    this.children.add(this.gameplayScreen);
                }
            }
            scene.MainScene = MainScene;
        })(scene = rp.scene || (rp.scene = {}));
    })(rp || (rp = {}));
    (function (rp) {
        var scene;
        (function (scene) {
            class Preloader extends Phaser.Scene {
                preload() {
                    if (typeof rp.App.json == "string") this.load.json('gameplay', rp.App.json); else this.game.cache.json.add('gameplay', rp.App.json);
                }
                create() {
                    const gameplayConfig = this.game.cache.json.get('gameplay');
                    const pages = gameplayConfig.data.pages;
                    pages.forEach((page, index) => {
                        if (page["useImages"]) {
                            if (page["text"].includes('http') || page["text"].includes("assets")) {
                                this.load.image(page["text"], page["text"]);
                            }
                            else if (json.data.gameId) {
                                this.load.image(page["text"], "assets/games/iqra-time/assets/imgs/words/" + json.data.gameId + "/" + page["text"] + ".png");
                            }
                            else {
                                this.load.image(page["text"], "assets/games/iqra-time/assets/imgs/words/" + page["text"] + ".png");
                            }
                        }
                        if (gameplayConfig.data.useLocalFiles) {
                            if (json.data.gameId) {
                                if (json.data.indexed) {
                                    this.load.audio(page["text"], "assets/games/iqra-time/assets/sound/mp3/words/" + json.data.gameId + "/" + (index + 1).toString() + ".mp3");
                                } else {
                                    this.load.audio(page["text"], "assets/games/iqra-time/assets/sound/mp3/words/" + json.data.gameId + "/" + page["text"] + ".mp3");
                                }
                            } else {
                                this.load.audio(page["text"], "assets/games/iqra-time/assets/sound/mp3/words/" + page["text"] + ".mp3");
                            }
                        } else {
                            this.load.audio(page["audio"], page["audio"]);
                        }
                    });

                    this.load.audio("complete-audio", Phaser.Utils.Array.GetRandom(gameplayConfig.completeAudios));
                    this.load.pack('preloader', 'assets/games/iqra-time/assets/pack.json');
                    this.load.on('progress', (value) => {
                    }, this);
                    this.load.on('complete', () => {
                        this.nextScene();
                    });
                    this.load.start();
                }
                nextScene() {
                    game.scene.remove('Preloader');
                    game.scene.add('ScreenMain', rp.scene.MainScene, true);
                }
            }
            scene.Preloader = Preloader;
        })(scene = rp.scene || (rp.scene = {}));
    })(rp || (rp = {}));
    (function (rp) {
        var screen;
        (function (screen) {
            class AreYouSureWindow extends Phaser.GameObjects.Container {
                constructor(scene, onYes, onNo) {
                    super(scene);
                    this._areYouSurePage = new Phaser.GameObjects.Image(this.scene, -105, 0 - 48, 'Exit warning');
                    this._areYouSurePage.setOrigin(0, 0);
                    this._areYouSurePage.setInteractive();
                    this._btnSureYes = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2 - 95, 485 - 50, 'btnYES1');
                    this._btnSureYes.setInteractive({ cursor: 'pointer' });
                    setupButtonTextureBased(this._btnSureYes, 'btnYES1', 'btnYES2');
                    this._btnSureYes.once('pointerup', () => {
                        onYes;
                        window.angularComponentRef.backToMenu();
                    });

                    var modalTextStyle = {
                        backgroundColor: 'transparent',
                        stroke: '#ffffff',
                        strokeThickness: 2,
                        lineSpacing: 15,
                        fontFamily: 'Kids Rock DEMO',
                        fontSize: 27,
                        color: '#43425d',
                        wordWrap: true,
                        align: 'center'
                    };
                    var modalText = this.scene.add.text(game.scale.width / 2 + 12, game.scale.height / 2, "Your progress in this activity will not be saved. \n Are you sure you want to exit? ", modalTextStyle);
                    modalText.setOrigin(0.5, 0.5);

                    this._btnSureNo = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2 + 95, 485 - 50, 'btnNO1');
                    this._btnSureNo.setInteractive({ cursor: 'pointer' });
                    setupButtonTextureBased(this._btnSureNo, 'btnNO1', 'btnNO2');
                    this._btnSureNo.once('pointerup', onNo);
                    this.add(this._areYouSurePage);
                    this.add(this._btnSureYes);
                    this.add(this._btnSureNo);
                    this.add(modalText);
                }
            }
            screen.AreYouSureWindow = AreYouSureWindow;
        })(screen = rp.screen || (rp.screen = {}));
    })(rp || (rp = {}));
    (function (rp) {
        var screen;
        (function (screen) {
            class CompleteWindow extends Phaser.GameObjects.Container {
                constructor(scene, onBack, onReplay, onNext) {
                    super(scene);
                    this.music = null;
                    this.setPosition(-104.5, -48);
                    this._bgComplete = new Phaser.GameObjects.Image(this.scene, 0, 0, 'Completion page LATEST UPDATED');
                    this._bgComplete.setOrigin(0, 0);
                    this._bgComplete.setInteractive();
                    this._cup = new Phaser.GameObjects.Image(this.scene, 400, 410, 'Trophy');
                    this._btnBack = new Phaser.GameObjects.Image(this.scene, 570, 570, 'btnBACK1');
                    this._btnReplay = new Phaser.GameObjects.Image(this.scene, 720, 570, 'btnReplay1');
                    this._btnNext = new Phaser.GameObjects.Image(this.scene, 870, 570, 'btnNEXT1');
                    let _CollectedPoints = new Phaser.GameObjects.Image(this.scene, 620, 440, 'Collected Points');
                    this.totalScoreTxt = this.scene.add.text(845, 352, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 35,
                        "color": "#F49F1C",
                        "align": 'center',
                        'stroke': '#70451A',
                        'strokeThickness': 6
                    });
                    this.totalScoreTxt.setOrigin(0.5, 0.5);
                    let grd = this.totalScoreTxt.context.createLinearGradient(0, 0, 0, this.totalScoreTxt.height);
                    grd.addColorStop(0, '#FFFF00');
                    grd.addColorStop(1, '#C17316');
                    this.totalScoreTxt.setFill(grd);
                    this.starScoreTxt = this.scene.add.text(648, 433, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 24,
                        "color": "#FFFFFF",
                        "align": 'center'
                    });
                    this.starScoreTxt.setOrigin(0.5, 0.5);
                    this.add([
                        this._bgComplete,
                        _CollectedPoints,
                        this._cup,
                        this._btnBack,
                        this._btnReplay,
                        this._btnNext,
                        this.totalScoreTxt,
                        this.starScoreTxt
                    ]);
                    this._btnBack.setInteractive({ cursor: 'pointer' });
                    setupButtonTextureBased(this._btnBack, 'btnBACK1', 'btnBACK2');
                    this._btnBack.on('pointerup', () => {
                        onBack(this._btnBack);
                        window.angularComponentRef.backToMenu();
                        // if (this.music) {
                        //     this.music.stop();
                        // }
                    });
                    this._btnReplay.setInteractive({ cursor: 'pointer' });
                    setupButtonTextureBased(this._btnReplay, 'btnReplay1', 'btnReplay2');
                    this._btnReplay.once('pointerup', () => {
                        onReplay(this._btnReplay);
                        if (this.music) {
                            this.music.stop();
                        }
                    });
                    this._btnNext.setInteractive({ cursor: 'pointer' });
                    setupButtonTextureBased(this._btnNext, 'btnNEXT1', 'btnNEXT2');
                    this._btnNext.on('pointerup', () => {
                        onNext(this._btnNext);
                        window.angularComponentRef.nextActivity();
                        // if (this.music) {
                        //     this.music.stop();
                        // }
                    });
                }
                show(score, starScore) {
                    window.angularComponentRef.gameFinish({ score, starScore });
                    this._cup.scale = 1.25;
                    this.scene.tweens.add({
                        targets: this._cup,
                        "scale": 1,
                        duration: 500,
                        ease: Phaser.Math.Easing.Back.Out
                    });
                    this.totalScoreTxt.text = String(window.angularComponentRef.component.userInfo.totalScore);
                    this.starScoreTxt.text = String(starScore);
                    this.music = this.scene.sound.add("complete-audio");
                    this.music.play();
                }
            }
            screen.CompleteWindow = CompleteWindow;
        })(screen = rp.screen || (rp.screen = {}));
    })(rp || (rp = {}));
    (function (rp) {
        var screen;
        (function (screen) {
            class GameplayScreen extends Phaser.GameObjects.Container {
                constructor(scene) {
                    super(scene);
                    this.currentPageIndex = 0;
                    this.flippingActive = false;
                    this.flippingStage = 0;
                    this.flippingDirection = 0;
                    this.leftPage = null;
                    this.rightPage = null;
                    this.flippedPage = null;
                    this.unflippedPage = null;
                    window["gameplay"] = this;
                    this.createBackground();
                    this.buildPages();
                    this.buildButtons();
                }
                buildPages() {
                    this.pages = [];
                    /* introduction page */
                    this.pages.push(new IntroductionPage(this.scene, 0));
                    /* empty page to combine with an introduction page */
                    this.pages.push(new EmptyPage(this.scene, 1));
                    /* pages */
                    const gameplayConfig = this.scene.game.cache.json.get('gameplay');
                    const pages = gameplayConfig.data.pages;
                    for (let i = 0; i < pages.length; i++) {
                        this.pages.push(new Page(this.scene, i + 2, i, `${i + 1}`));
                    }
                    /* empty page */
                    this.pages.push(new EmptyPage(this.scene, this.pages.length));
                    /* the last page */
                    this.pages.push(new EndPage(this.scene, this.pages.length, () => this.onCompleteClicked()));
                    this.pagesContainer = new Phaser.GameObjects.Container(this.scene, 500, 107 + 227);
                    this.add(this.pagesContainer);
                    this.pagesContainer.add(this.pages);
                    this.resetGame();
                }
                buildButtons() {
                    this.buttonPrevPage = new Phaser.GameObjects.Image(this.scene, 61, 286, 'arrow-right');
                    this.buttonPrevPage.setOrigin(0, 0);
                    this.buttonPrevPage.setScale(-1, 1);
                    this.buttonPrevPage.setInteractive({ cursor: 'pointer' }); window['this.buttonPrevPage'] = this.buttonPrevPage;
                    setupButtonTextureBased(this.buttonPrevPage, 'arrow-right', 'arrow-right-hover');
                    this.buttonPrevPage.on('pointerup', this.switchToPrevPage, this);
                    this.buttonNextPage = new Phaser.GameObjects.Image(this.scene, 919, 286, 'arrow-right');
                    this.buttonNextPage.setOrigin(0, 0);
                    this.buttonNextPage.setInteractive({ cursor: 'pointer' });
                    setupButtonTextureBased(this.buttonNextPage, 'arrow-right', 'arrow-right-hover');
                    this.buttonNextPage.on('pointerup', this.switchToNextPage, this);
                    this.add([this.buttonPrevPage, this.buttonNextPage]);
                }
                createBackground() {
                    this.backgroundImage = this.scene.add.image(0, 0, 'reading-bg');
                    this.backgroundImage.setOrigin(0.01, 0.04);
                    this.buttonClose = new Phaser.GameObjects.Image(this.scene, 930, 50, 'x Button');
                    this.buttonClose.setInteractive({ cursor: 'pointer' });
                    setupButtonTextureBased(this.buttonClose, 'x Button', 'x Button HOVER EFFECT');
                    this.buttonClose.on('pointerup', this.onLeaveClicked, this);
                    this.add(this.buttonClose);
                }
                switchToPrevPage() {
                    if (this.flippingActive)
                        return;
                    if (this.currentPageIndex >= 2) {
                        this.flipToPrevPage();
                    }
                }
                switchToNextPage() {
                    if (this.flippingActive)
                        return;
                    let playIntroSound = this.currentPageIndex == 0;
                    if (this.currentPageIndex < this.pages.length - 2) {
                        this.flipToNextPage();
                    }

                    if (playIntroSound) {
                        let leftPage = this.pages[this.currentPageIndex];
                        let rightPage = this.pages[this.currentPageIndex + 1]
                        this.sound = this.scene.sound.add("Aoothu and basmala");
                        this.sound.play();
                        this.sound.once('complete', () => {
                            this.buttonPrevPage.setInteractive({ cursor: 'pointer' });
                            this.buttonNextPage.setInteractive({ cursor: 'pointer' });
                            leftPage.vocalizeBtn.setInteractive({ cursor: 'pointer' });
                            rightPage.vocalizeBtn.setInteractive({ cursor: 'pointer' });
                            this.buttonPrevPage.alpha = this.buttonNextPage.alpha = 1;
                        });
                        this.buttonPrevPage.disableInteractive();
                        this.buttonNextPage.disableInteractive();
                        leftPage.vocalizeBtn.disableInteractive();
                        rightPage.vocalizeBtn.disableInteractive();
                        this.buttonPrevPage.alpha = this.buttonNextPage.alpha = 0.6;
                    }
                }
                flipToPrevPage() {
                    this.leftPage = this.pages[this.currentPageIndex - 2];
                    this.flippedPage = this.pages[this.currentPageIndex];
                    this.unflippedPage = this.pages[this.currentPageIndex - 1];
                    this.rightPage = this.pages[this.currentPageIndex + 1];
                    this.flippingDirection = -1;
                    this.currentPageIndex -= 2;
                    this.flipPages(this.flippedPage, this.unflippedPage);
                }
                flipToNextPage() {
                    this.leftPage = this.pages[this.currentPageIndex];
                    this.flippedPage = this.pages[this.currentPageIndex + 1];
                    this.unflippedPage = this.pages[this.currentPageIndex + 2];
                    this.rightPage = this.pages[this.currentPageIndex + 3];
                    this.flippingDirection = 1;
                    this.currentPageIndex += 2;
                    this.flipPages(this.flippedPage, this.unflippedPage);
                }
                flipPages(pageToFlip, pageToUnflip) {
                    this.scene.game.sound.stopAll();
                    if (!this.flipSound)
                        this.flipSound = this.scene.sound.add('flip');
                    this.flipSound.play();
                    this.flippingActive = true;
                    this.flippingStage = 1;
                    this.updatePagesVisibility();
                    this.sortPages();
                    pageToFlip.scaleX = 1.0;
                    pageToFlip.scaleY = 1.0;
                    pageToFlip.x = 0;
                    this.scene.tweens.add({
                        targets: pageToFlip,
                        scaleX: 0.0,
                        scaleY: 1.025,
                        x: this.flippingDirection > 0 ? -5 : 5,
                        delay: 50,
                        duration: GameplayScreen.FLIP_DURATION,
                        ease: Phaser.Math.Easing.Quadratic.Out,
                        onComplete: () => {
                            this.flippingStage = 2;
                            this.updatePagesVisibility();
                            this.sortPages();
                            pageToUnflip.scaleX = 0;
                            pageToUnflip.scaleY = 1.025;
                            pageToUnflip.x = this.flippingDirection > 0 ? 5 : -5;
                            this.scene.tweens.add({
                                targets: pageToUnflip,
                                scaleX: 1.0,
                                scaleY: 1.0,
                                x: 0,
                                duration: GameplayScreen.UNFLIP_DURATION,
                                ease: Phaser.Math.Easing.Quadratic.In,
                                onComplete: () => {
                                    this.flippingActive = false;
                                    this.flippingStage = 0;
                                    this.flippingDirection = 0;
                                    this.detectPages();
                                    this.updatePagesVisibility();
                                    this.sortPages();
                                    pageToUnflip.scaleX = 1;
                                    pageToUnflip.scaleY = 1;
                                    pageToFlip.x = pageToUnflip.x = 0;
                                }
                            });
                        }
                    });
                }
                sortPages() {
                    this.pagesContainer.sort("pageIndex", (pageA, pageB) => {
                        if (pageA === this.flippedPage || pageA === this.unflippedPage)
                            return 1;
                        if (pageB === this.flippedPage || pageB === this.unflippedPage)
                            return -1;
                        return this.flippingDirection * (pageA.pageIndex - pageB.pageIndex);
                    });
                }
                detectPages() {
                    this.leftPage = this.pages[this.currentPageIndex];
                    this.rightPage = this.pages[this.currentPageIndex + 1];
                    this.flippedPage = this.unflippedPage = null;
                }
                updatePagesVisibility() {
                    this.pages.forEach(page => page.setVisible(false));
                    if (this.leftPage)
                        this.leftPage.visible = true;
                    if (this.rightPage)
                        this.rightPage.visible = true;
                    if (this.flippedPage)
                        this.flippedPage.visible = this.flippingStage === 1;
                    if (this.unflippedPage)
                        this.unflippedPage.visible = this.flippingStage === 2;
                }
                resetGame() {
                    this.pages.forEach(page => page.setScale(1, 1));
                    this.currentPageIndex = 0;
                    this.flippingActive = false;
                    this.flippingStage = 0;
                    this.detectPages();
                    this.updatePagesVisibility();
                    this.sortPages();
                }
                onCompleteClicked() {
                    const numStars = this.scene.game.cache.json.get('gameplay').maxStars;
                    let completeWindow = new screen.CompleteWindow(this.scene, (target) => {
                    }, (target) => {
                        completeWindow.destroy();
                        this.resetGame();
                        this.remove(completeWindow);
                    }, (target) => {
                    });
                    this.add(completeWindow);
                    completeWindow.show(0, numStars);
                }
                onLeaveClicked() {
                    this.showAreYouSurePage();
                    this.scene.sound.add('warning page pop up sfx').play();
                }
                destroyGameplay() {
                    this.destroy();
                    this.backgroundImage.destroy();
                }
                showAreYouSurePage() {
                    game.sound.pauseAll();
                    const areYouSureWindow = new screen.AreYouSureWindow(this.scene, () => {
                        areYouSureWindow.destroy();
                        this.resetGame();
                        this.destroyGameplay();
                    }, () => {
                        areYouSureWindow.destroy();
                        game.sound.resumeAll();
                    });
                    this.add(areYouSureWindow);
                }
            }
            GameplayScreen.FLIP_DURATION = 275;
            GameplayScreen.UNFLIP_DURATION = 275;
            screen.GameplayScreen = GameplayScreen;
        })(screen = rp.screen || (rp.screen = {}));
    })(rp || (rp = {}));

    game = new rp.App(json);
};

function destroyIqraTime() {
    if (game) {
        game.destroy();
        game = null;
    }
}

var sh;
var game;
function soundBalls(json) {
    class FitScaleManager {
        constructor(game) {
            this.doResize = () => {
                let scale = this.calculateScale();
                let newCanvasWidth = this.phaserScaleManager.width * scale;
                let newCanvasHeight = this.phaserScaleManager.height * scale;
                this.canvasStyle.width = newCanvasWidth + 'px';
                this.canvasStyle.height = newCanvasHeight + 'px';
                this.canvasStyle.marginLeft = (window.innerWidth - newCanvasWidth) / 2 + 'px';
                this.canvasStyle.marginTop = (window.innerHeight - newCanvasHeight) / 2 + 'px';
            };
            this.game = game;
            this.canvasStyle = this.game.canvas.style;
            this.phaserScaleManager = this.game.scale;
        }
        static detectBestScaleMode() {
            let iOS = /iPad|iPhone|iPod/.test(navigator.platform || "");
            let isAndroid = window.navigator.userAgent.toLowerCase().indexOf("android") > -1;
            return iOS || isAndroid ? Phaser.Scale.FIT : Phaser.Scale.NONE;
        }
        ;
        /**
         * Just call this method once in Boot scene's init() method
         */
        setup() {
            this.phaserScaleManager.addListener(Phaser.Scale.Events.RESIZE, this.onResize, this);
            this.overridePhaserTransformMethods();
            this.onResize();
        }
        calculateScale() {
            if (game.scale.scaleMode === Phaser.Scale.NONE)
                return 1;
            return Math.min(window.innerWidth / this.phaserScaleManager.width, window.innerHeight / this.phaserScaleManager.height);
        }
        overridePhaserTransformMethods() {
            this.game.scale.transformX = (pageX) => {
                return (pageX - parseInt(this.canvasStyle.marginLeft.split("px")[0])) / this.calculateScale();
            };
            this.game.scale.transformY = (pageY) => {
                return (pageY - parseInt(this.canvasStyle.marginTop.split("px")[0])) / this.calculateScale();
            };
        }
        onResize() {
            setTimeout(this.doResize, FitScaleManager.RESIZE_DELAY);
        }
    }
    FitScaleManager.RESIZE_DELAY = 500;

    (function (sh) {
        class App extends Phaser.Game {
            constructor(json) {

                App.json = json;

                let config = {
                    type: Phaser.AUTO,
                    width: App.CANVAS_WIDTH,
                    height: App.CANVAS_HEIGHT,
                    parent: 'game-container',
                    dom: {
                        createContainer: false
                    },
                    scale: {
                        mode: FitScaleManager.detectBestScaleMode(),
                        autoCenter: Phaser.Scale.CENTER_BOTH
                    },
                    transparent: true,
                    scene: {
                        create: () => {
                            this.scene.add('Boot', sh.scene.Boot, true);
                        }
                    }
                };
                super(config);
            }
        }
        App.CANVAS_WIDTH = 980;
        App.CANVAS_HEIGHT = 600;
        sh.App = App;
    })(sh || (sh = {}));

    game = new sh.App(json);

    let delayedCalls = [];
    function delayedCall(delay, callback, args, callbackScope) {
        let scene = game.scene.getAt(0);
        if (scene) {
            let dc = scene.time.delayedCall(delay, callback, args, callbackScope);
            delayedCalls.push(dc);
            return dc;
        }
        let t = setTimeout(callback, delay);
        delayedCalls.push(t);
        return t;
    }
    function pauseAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.paused = true;
            }
        }
    }
    function resumeAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.paused = false;
            }
        }
    }
    function destroyAllDelayedCalls() {
        for (let dc of delayedCalls) {
            if (dc instanceof Phaser.Time.TimerEvent) {
                dc.remove(false);
            }
            else {
                clearTimeout(dc);
            }
        }
        delayedCalls = [];
    }
    function setPageBackground(bg) {
        document.querySelector("html").style.backgroundImage = "url(assets/games/sound-balls/imgs/" + bg + ".jpg)";
    }
    function setupButton(btn, frame) {
        btn.on('pointerdown', () => { btn.setFrame(frame + '_hover' + '0000'); });
        btn.on('pointerover', () => { btn.setFrame(frame + '_hover' + '0000'); game.scene.getAt(0).sound.add("button hover").play(); });
        btn.on('pointerout', () => { btn.setFrame(frame + '0000'); });
        btn.on('pointerup', () => { btn.setFrame(frame + '0000'); game.scene.getAt(0).sound.add('activity selection - button selection').play(); });
    }
    function setupButtonTextureBased(btn, texture, hoverTexture) {
        btn.on('pointerdown', () => { btn.setTexture(hoverTexture); });
        btn.on('pointerover', () => { btn.setTexture(hoverTexture); game.scene.getAt(0).sound.add("button hover").play(); });
        btn.on('pointerout', () => { btn.setTexture(texture); });
        btn.on('pointerup', () => { btn.setTexture(texture); game.scene.getAt(0).sound.add('activity selection - button selection').play(); });
    }
    /**
     * @author Roman Parada
     * This class is created to fix overlapping of bottom part of canvas by navigation bar in iOS.
     * It make a delayed resize of the canvas (like Phaser-3 FIT methods does) and it overrides Phaser-3 input window to Phaser-3 core transform methods
     *
     * How to use:
     * Just call the code line below in Boot scene's init() method of your project:
     * new FitScaleManager(this.game).setup();
     */


    (function (sh) {
        var core;
        (function (core) {
            class Gameplay {
                constructor() {
                    this.currentRound = 0;
                    this.correctAnswersCount = 0;
                    this.wrongAnswersCount = 0;
                    this.nextLetterDelay = 0;
                    this.reset();
                    let json = game.cache.json.get('gameplay');
                    this.wrongAnswersToLose = json["wrongAnswersToLose"];
                    this.numberOfQuestionsPerRound = json["numberOfQuestionsPerRound"];
                    this.lettersConfig = JSON.parse(JSON.stringify(json["lettersConfig"]));
                    this.rounds = JSON.parse(JSON.stringify(json["rounds"]));
                    this.numberOfRounds = this.rounds.length;
                }
                setupCallbacks(onComplete, onLose) {
                    this.onComplete = onComplete;
                    this.onLose = onLose;
                }
                onLetterChosen() {
                    if (this.isNewRound()) {
                        if (this.currentRound >= this.numberOfRounds - 1) {
                            this.onComplete(this.correctAnswersCount, this.correctAnswersCount);
                            return true;
                        }
                        else {
                            this.nextRound();
                        }
                    }
                    return false;
                }
                nextRound() {
                    let fn = () => {
                        if (this.currentRound == this.rounds.length) {
                            this.currentRound = 0;
                        }
                        else {
                            this.currentRound++;
                        }
                    };
                    if (this.nextLetterDelay == 0) {
                        fn();
                    }
                    else {
                        delayedCall(this.nextLetterDelay, fn);
                    }
                }
                getCorrectLetterName() {
                    return this.rounds[this.currentRound]['correctLetterName'];
                }
                isCorrectLetterAudioQuestionEnable() {
                    return this.rounds[this.currentRound]['audioQuestionEnable'];
                }
                getCorrectAudioKey() {
                    return this.lettersConfig[this.getCorrectLetterName()]['correctAudioKey'];
                }
                getCorrectAndLetterSoundSfxAudioKey() {
                    return this.lettersConfig[this.getCorrectLetterName()]['Sounds of the letters'];
                }
                onCorrectAnswer() {
                    this.correctAnswersCount++;
                    this.nextLetterDelay = 1500;
                    return this.onLetterChosen();
                }
                onWrongAnswer() {
                    this.wrongAnswersCount++;
                    this.nextLetterDelay = 1500;
                    if (this.wrongAnswersCount >= this.wrongAnswersToLose) {
                        this.onLose(0, 0);
                        return true;
                    }
                    return false;
                }
                getCurrentTotalAnswersCount() {
                    return this.correctAnswersCount + this.wrongAnswersCount;
                }
                isNewRound() {
                    return this.correctAnswersCount % this.numberOfQuestionsPerRound == 0;
                }
                isRoundsComplete() {
                    return this.correctAnswersCount / this.numberOfQuestionsPerRound >= this.numberOfRounds;
                }
                reset() {
                    this.nextLetterDelay = 0;
                    this.currentRound = 0;
                    this.correctAnswersCount = 0;
                    this.wrongAnswersCount = 0;
                }
                getCurrentRoundLetters() {
                    return this.rounds[this.currentRound]["letters"];
                }
            }
            core.Gameplay = Gameplay;
        })(core = sh.core || (sh.core = {}));
    })(sh || (sh = {}));

    (function (sh) {
        var scene;
        (function (scene) {
            class Boot extends Phaser.Scene {
                init() {
                    this.game.scale.transformX = (pageX) => {
                        let offsetLeft = 0;
                        let parentElement = game.canvas.parentElement;
                        while (parentElement) {
                            if (parentElement.offsetLeft) {
                                offsetLeft = parentElement.offsetLeft;
                                break;
                            }
                            parentElement = parentElement.parentElement;
                        }
                        return (pageX - offsetLeft) * this.game.scale.displayScale.x;
                    };
                    this.game.scale.transformY = (pageY) => {
                        let offsetTop = 0;
                        let parentElement = game.canvas.parentElement;
                        while (parentElement) {
                            if (parentElement.offsetTop) {
                                offsetTop = parentElement.offsetTop;
                                break;
                            }
                            parentElement = parentElement.parentElement;
                        }
                        return (pageY - offsetTop) * this.game.scale.displayScale.y;
                    };
                }
                create() {
                    game.scene.remove('Boot');
                    game.scene.add('Preloader', sh.scene.Preloader, true);
                }
            }
            scene.Boot = Boot;
        })(scene = sh.scene || (sh.scene = {}));
    })(sh || (sh = {}));

    (function (sh) {
        var scene;
        (function (scene) {
            var Gameplay = sh.core.Gameplay;
            class MainScene extends Phaser.Scene {
                create() {
                    this.gameplay = new Gameplay();
                    this.gameplayScreen = new sh.screen.GameplayScreen(this, this.gameplay);
                    this.children.add(this.gameplayScreen);
                    this.gameplayScreen.showInstructionPage();
                }
            }
            scene.MainScene = MainScene;
        })(scene = sh.scene || (sh.scene = {}));
    })(sh || (sh = {}));

    (function (sh) {
        var scene;
        (function (scene) {
            class Preloader extends Phaser.Scene {
                preload() {
                    if (typeof sh.App.json == "string") this.load.json('gameplay', sh.App.json); else this.game.cache.json.add('gameplay', sh.App.json);
                }
                create() {
                    let json = game.cache.json.get('gameplay');
                    let lettersConfig = json["lettersConfig"];
                    for (let letterName in lettersConfig) {
                        this.load.image(letterName, "assets/games/sound-balls/imgs/letters/" + letterName + ".png");
                        if (lettersConfig[letterName]["correctAudioKey"] == null) continue;
                        let correctAudioKey = lettersConfig[letterName]["correctAudioKey"];
                        this.load.audio(correctAudioKey, "assets/games/sound-balls/sound/mp3/letters/" + correctAudioKey + ".mp3");
                        this.load.audio(lettersConfig[letterName]["Sounds of the letters"], "assets/games/sound-balls/sound/mp3/letters/" + lettersConfig[letterName]["Sounds of the letters"] + ".mp3");
                    }
                    this.load.pack('preloader', 'assets/games/sound-balls/pack.json');
                    this.load.on('progress', (value) => {
                    }, this);
                    this.load.on('complete', () => {
                        this.nextScene();
                    });
                    this.load.start();
                }
                nextScene() {
                    game.scene.remove('Preloader');
                    game.scene.add('ScreenMain', sh.scene.MainScene, true);
                }
            }
            scene.Preloader = Preloader;
        })(scene = sh.scene || (sh.scene = {}));
    })(sh || (sh = {}));

    (function (sh) {
        var screen;
        (function (screen) {
            class AreYouSureWindow extends Phaser.GameObjects.Container {
                constructor(scene, onYes, onNo) {
                    super(scene);
                    this._areYouSurePage = new Phaser.GameObjects.Image(this.scene, -105, 0 - 48, 'Exit warning');
                    this._areYouSurePage.setOrigin(0, 0);
                    this._areYouSurePage.setInteractive();

                    var modalTextStyle = {
                        backgroundColor: 'transparent',
                        stroke: '#ffffff',
                        strokeThickness: 2,
                        lineSpacing: 15,
                        fontFamily: 'Kids Rock DEMO',
                        fontSize: 27,
                        color: '#43425d',
                        wordWrap: true,
                        align: 'center'
                    };
                    var modalText = this.scene.add.text(game.scale.width / 2 + 12, game.scale.height / 2, "Your progress in this activity will not be saved. \n Are you sure you want to exit? ", modalTextStyle);
                    modalText.setOrigin(0.5, 0.5);

                    this._btnSureYes = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2 - 95, 485 - 50, 'btnYES1');
                    this._btnSureYes.setInteractive({ cursor: 'pointer' });
                    this._btnSureYes.once('pointerup', () => {
                        onYes;
                        window.angularComponentRef.backToMenu();
                    });
                    setupButtonTextureBased(this._btnSureYes, 'btnYES1', 'btnYES2');
                    this._btnSureNo = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2 + 95, 485 - 50, 'btnNO1');
                    this._btnSureNo.setInteractive({ cursor: 'pointer' });
                    this._btnSureNo.once('pointerup', onNo);
                    setupButtonTextureBased(this._btnSureNo, 'btnNO1', 'btnNO2');
                    this.add(this._areYouSurePage);
                    this.add(this._btnSureYes);
                    this.add(this._btnSureNo);
                    this.add(modalText);
                }
            }
            screen.AreYouSureWindow = AreYouSureWindow;
        })(screen = sh.screen || (sh.screen = {}));
    })(sh || (sh = {}));

    (function (sh) {
        var screen;
        (function (screen) {
            class CompleteWindow extends Phaser.GameObjects.Container {
                constructor(scene, onBack, onReplay, onNext) {
                    super(scene);
                    this.music = null;
                    this.setPosition(-104.5, -48);
                    this._bgComplete = new Phaser.GameObjects.Image(this.scene, 0, 0, 'Completion page LATEST UPDATED');
                    this._bgComplete.setOrigin(0, 0);
                    this._bgComplete.setInteractive();
                    this._cup = new Phaser.GameObjects.Image(this.scene, 400, 410, 'Trophy');
                    this._btnBack = new Phaser.GameObjects.Image(this.scene, 570, 570, 'btnBACK1');
                    this._btnReplay = new Phaser.GameObjects.Image(this.scene, 720, 570, 'btnReplay1');
                    this._btnNext = new Phaser.GameObjects.Image(this.scene, 870, 570, 'btnNEXT1');
                    let _CollectedPoints = new Phaser.GameObjects.Image(this.scene, 620, 440, 'Collected Points');
                    this.totalScoreTxt = this.scene.add.text(845, 352, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 35,
                        "color": "#F49F1C",
                        "align": 'center',
                        'stroke': '#70451A',
                        'strokeThickness': 6
                    });
                    this.totalScoreTxt.setOrigin(0.5, 0.5);
                    let grd = this.totalScoreTxt.context.createLinearGradient(0, 0, 0, this.totalScoreTxt.height);
                    grd.addColorStop(0, '#FFFF00');
                    grd.addColorStop(1, '#C17316');
                    this.totalScoreTxt.setFill(grd);
                    this.starScoreTxt = this.scene.add.text(648, 433, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 24,
                        "color": "#FFFFFF",
                        "align": 'center'
                    });
                    this.starScoreTxt.setOrigin(0.5, 0.5);
                    this.add([
                        this._bgComplete,
                        _CollectedPoints,
                        this._cup,
                        this._btnBack,
                        this._btnReplay,
                        this._btnNext,
                        this.totalScoreTxt,
                        this.starScoreTxt
                    ]);
                    this._btnBack.setInteractive({ cursor: 'pointer' });
                    this._btnBack.on('pointerup', () => {
                        onBack(this._btnBack);
                        window.angularComponentRef.backToMenu();
                        // if (this.music) {
                        //     this.music.stop();
                        // }
                    });
                    setupButtonTextureBased(this._btnBack, 'btnBACK1', 'btnBACK2');
                    this._btnReplay.setInteractive({ cursor: 'pointer' });
                    this._btnReplay.once('pointerup', () => {
                        onReplay(this._btnReplay);
                        if (this.music) {
                            this.music.stop();
                        }
                    });
                    setupButtonTextureBased(this._btnReplay, 'btnReplay1', 'btnReplay2');
                    this._btnNext.setInteractive({ cursor: 'pointer' });
                    this._btnNext.on('pointerup', () => {
                        onNext(this._btnNext);
                        window.angularComponentRef.nextActivity();
                        // if (this.music) {
                        //     this.music.stop();
                        // }
                    });
                    setupButtonTextureBased(this._btnNext, 'btnNEXT1', 'btnNEXT2');
                }
                show(score, starScore) {
                    window.angularComponentRef.gameFinish({ score, starScore })
                    this._cup.scale = 1.25;
                    this.scene.tweens.add({
                        targets: this._cup,
                        "scale": 1,
                        duration: 500,
                        ease: Phaser.Math.Easing.Back.Out
                    });
                    this.totalScoreTxt.text = String(window.angularComponentRef.component.userInfo.totalScore);
                    this.starScoreTxt.text = String(starScore);
                    // let music = this.scene.sound.add("viktory");
                    this.music = this.scene.sound.add("Activity completion fantastic");
                    this.music.play();
                }
            }
            screen.CompleteWindow = CompleteWindow;
        })(screen = sh.screen || (sh.screen = {}));
    })(sh || (sh = {}));

    (function (sh) {
        var screen;
        (function (screen) {
            class GameplayScreen extends Phaser.GameObjects.Container {
                constructor(scene, gameplay) {
                    super(scene);
                    this.hexagonPositions = [
                        { x: 502, y: 136 },
                        { x: 405, y: 293 }, { x: 599, y: 292 },
                        { x: 305, y: 450 }, { x: 500, y: 450 }, { x: 692, y: 450 }
                    ];
                    this.bgMusic = null;
                    this.correctAudio = null;
                    this.wfsnd = null;
                    this.showCompleteWindow = (score, starScore) => {
                        let completeWindow = new screen.CompleteWindow(this.scene, (target) => {
                            this.playBtnClickAnim(target);
                        }, (target) => {
                            this.playBtnClickAnim(target);
                            this.destroyGameplay();
                            this.remove(completeWindow);
                            this.showInstructionPage();
                        }, (target) => {
                            this.playBtnClickAnim(target);
                        });
                        this.setLettersInputEnabled(false);
                        delayedCall(1750, () => {
                            setPageBackground("bg-blue");
                            this.add(completeWindow);
                            completeWindow.show(score, starScore);
                            this.bgMusic.stop();
                        });
                    };
                    this.showLoseWindow = (score, starScore) => {
                        let tryAgainWindow = new screen.TryAgainWindow(this.scene, (target) => {
                            this.playBtnClickAnim(target);
                        }, (target) => {
                            this.playBtnClickAnim(target);
                            this.destroyGameplay();
                            this.remove(tryAgainWindow);
                            this.showInstructionPage();
                        });
                        this.setLettersInputEnabled(false);
                        delayedCall(1750, () => {
                            setPageBackground("bg-blue");
                            this.add(tryAgainWindow);
                            tryAgainWindow.show(score, starScore);
                            this.bgMusic.stop();
                        });
                    };
                    this.gameplay = gameplay;
                    window["t"] = this;
                }
                createHexagons() {
                    this.hexagons = [];
                    for (let p of this.hexagonPositions) {
                        let hc = new Phaser.GameObjects.Container(this.scene, this.hexagonPositions[4]['x'], this.hexagonPositions[4]['y']);
                        let h = new Phaser.GameObjects.Image(this.scene, 0, 0, 'hexagon');
                        hc.add(h);
                        hc["bg"] = h;
                        hc["_hexagon_correct"] = new Phaser.GameObjects.Image(this.scene, 0, 0, '1 Correct Hover Effects');
                        hc.add(hc["_hexagon_correct"]);
                        hc["_hexagon_wrong"] = new Phaser.GameObjects.Image(this.scene, 0, 0, '1 wrong Hover Effects');
                        hc.add(hc["_hexagon_wrong"]);
                        hc["_hexagon_correct"].visible = hc["_hexagon_wrong"].visible = false;
                        hc["defX"] = p['x'];
                        hc["defY"] = p['y'];
                        this.hexagons.push(hc);
                    }
                    this.gameplayContainer.add(this.hexagons);
                }
                createLetters() {
                    if (this.letters) {
                        for (let l of this.letters) {
                            l.parentContainer["letter"] = null;
                            l["hexagon"] = null;
                            l.parentContainer.remove(l);
                        }
                    }
                    this.letters = [];
                    let _letters = this.gameplay.getCurrentRoundLetters();
                    for (let n of _letters) {
                        let l = new Phaser.GameObjects.Image(this.scene, 0, 0, n);
                        this.letters.push(l);
                    }
                }
                showGameplay() {
                    setPageBackground("bg-australia");
                    this.bgMusic = this.scene.sound.add("bg_sound");
                    this.bgMusic.play();
                    this.bgMusic.loop = true;
                    this.gameplay.reset();
                    this._gameStage = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2, game.scale.height / 2, 'Sound Hive Final');
                    this._gameStage.setOrigin(0.5, 0.5);
                    this._gameStage.setInteractive();
                    this._btnSound = new Phaser.GameObjects.Image(this.scene, 160 - 105, 100 - 50, 'Sound');
                    this._btnSound.setInteractive({ cursor: 'pointer' });
                    this._btnSound["defScale"] = this._btnSound.scale;
                    setupButtonTextureBased(this._btnSound, 'Sound', 'Sound HOVER EFFECT');
                    this._btnClose = new Phaser.GameObjects.Image(this.scene, 1025 - 105, 100 - 50, 'x Button');
                    this._btnClose.setInteractive({ cursor: 'pointer' });
                    this._btnClose["defScale"] = this._btnClose.scale;
                    setupButtonTextureBased(this._btnClose, 'x Button', 'x Button HOVER EFFECT');
                    this.gameplayContainer = new Phaser.GameObjects.Container(this.scene);
                    this.addAt(this.gameplayContainer, 0);
                    this.gameplayContainer.add([
                        this._gameStage,
                        this._btnSound,
                        this._btnClose
                    ]);
                    this.createBeehives();
                    this.createHexagons();
                    this.shuffleOutHexagons();
                    this.createInput();
                    this.gameplay.setupCallbacks(this.showCompleteWindow, this.showLoseWindow);
                }
                createBeehives() {
                    let startX = 905;
                    let startY = 170;
                    let dx = 30;
                    let dy = 36;
                    let _BeehiveEmptyArrayPositions = [];
                    const numInOneColumn = 8;
                    for (let i = 0; i < 16; i++) {
                        _BeehiveEmptyArrayPositions.push({ x: startX + Math.floor(i / numInOneColumn) * dx, y: startY + (i % numInOneColumn) * dy });
                    }
                    this._BeehiveEmptyArray = [];
                    this._Beehive = [];
                    for (let p of _BeehiveEmptyArrayPositions) {
                        let _BeehiveEmpty = new Phaser.GameObjects.Image(this.scene, p['x'], p['y'], 'Beehive 1 Empty');
                        this._BeehiveEmptyArray.push(_BeehiveEmpty);
                        _BeehiveEmpty.visible = false;
                        _BeehiveEmpty.setScale(0.7);
                        let _Beehive = new Phaser.GameObjects.Image(this.scene, p['x'], p['y'], 'Beehive 1');
                        this._Beehive.push(_Beehive);
                        _Beehive.setScale(0.7);
                    }
                    for (let bea of this._BeehiveEmptyArray) {
                        this.gameplayContainer.add(bea);
                    }
                    for (let bee of this._Beehive) {
                        this.gameplayContainer.add(bee);
                        bee.visible = false;
                    }
                }
                randomizeLettersPosition() {
                    let hx = this.hexagons.slice();
                    for (let l of this.letters) {
                        if (hx.length == 0)
                            return;
                        let hc = Phaser.Utils.Array.RemoveRandomElement(hx);
                        hc.add(l);
                        hc["letter"] = l;
                        l["hexagon"] = hc;
                    }
                }
                updateHexagonsArrange() {
                    for (let hc of this.hexagons) {
                        if (!hc["letter"]) {
                            hc.parentContainer.bringToTop(hc);
                            break;
                        }
                    }
                }
                shuffleOutHexagons() {
                    if (this.gameplay.isNewRound()) {
                        if (!this.gameplay.isRoundsComplete()) {
                            this.createLetters();
                            this.randomizeLettersPosition();
                        }
                    }
                    this.setLettersInputEnabled(false);
                    this.updateHexagonsArrange();
                    let positions = this.hexagonPositions.slice();
                    for (let hc of this.hexagons) {
                        hc.visible = true;
                        let rndP = Phaser.Utils.Array.RemoveRandomElement(positions);
                        this.scene.tweens.add({
                            targets: hc,
                            "x": rndP['x'],
                            "y": rndP['y'],
                            duration: 300,
                            delay: 500
                        });
                    }
                    delayedCall(450, () => {
                        this.scene.sound.add('spread from centre').play();
                    });
                    delayedCall(1200, () => {
                        let setLettersInputEnabled = () => {
                            if (this.correctAudio && this.correctAudio.isPlaying) {
                                delayedCall((this.correctAudio.duration * 0.75) * 1000, () => {
                                    this.setLettersInputEnabled(true);
                                });
                            }
                            else {
                                this.setLettersInputEnabled(true);
                            }
                        };
                        if (this.gameplay.isNewRound()) {
                            if (!this.gameplay.isRoundsComplete()) {
                                if (this.gameplay.isCorrectLetterAudioQuestionEnable()) {
                                    this.playCorrectAudio();
                                }
                                setLettersInputEnabled();
                            }
                        }
                        else {
                            setLettersInputEnabled();
                        }
                    });
                }
                shuffleInHexagons() {
                    this.updateHexagonsArrange();
                    let positions = this.hexagonPositions.slice();
                    this.setLettersInputEnabled(false);
                    for (let hc of this.hexagons) {
                        let posX = hc.x;
                        let posY = hc.y;
                        this.scene.tweens.add({
                            targets: hc,
                            "x": this.hexagonPositions[4]['x'],
                            "y": this.hexagonPositions[4]['y'],
                            duration: 300,
                            delay: 700,
                            onComplete: () => {
                                hc["_hexagon_correct"].visible = hc["_hexagon_wrong"].visible = false;
                            }
                        });
                    }
                    delayedCall(600, () => {
                        this.scene.sound.add('move to centre').play();
                    });
                    delayedCall(1000, () => {
                        this.shuffleOutHexagons();
                    });
                }
                createInput() {
                    for (let hc of this.hexagons) {
                        hc["bg"].on('pointerup', () => {
                            let l = hc["letter"];
                            this.setLettersInputEnabled(false);
                            this.playBtnClickAnim(hc);
                            let lost = false;
                            let correctAnswer = l && l.texture.key == this.gameplay.getCorrectLetterName();
                            if (correctAnswer) {
                                this.scene.sound.add('Burst effect sfx').play();
                                let snowballanim = this.scene.add.sprite(hc.x, hc.y, 'snowwballatlas');
                                hc.parentContainer.add(snowballanim);
                                this.scene.anims.create({
                                    key: 'snowballanim',
                                    frames: this.scene.anims.generateFrameNames('snowwballatlas', {
                                        start: 0, end: 47, zeroPad: 4,
                                        prefix: 'snowballanim', suffix: ''
                                    }),
                                    frameRate: 60
                                });
                                snowballanim.anims.play('snowballanim').once('animationcomplete', () => {
                                    if (snowballanim.parentContainer)
                                        snowballanim.parentContainer.remove(snowballanim);
                                });
                                hc["_hexagon_wrong"].visible = false;
                                hc["_hexagon_correct"].visible = true;
                                hc.visible = false;
                                let completed = this.onCorrectAnswer();
                                if (!completed) {
                                    delayedCall(1000, () => this.shuffleInHexagons());
                                }
                            }
                            else {
                                hc["_hexagon_wrong"].visible = true;
                                hc["_hexagon_correct"].visible = false;
                                delayedCall(1500, () => {
                                    hc["_hexagon_wrong"].visible = false;
                                });
                                lost = this.onWrongAnswer();
                                if (!lost) {
                                    this.setLettersInputEnabled(true);
                                }
                            }
                            if (!lost) {
                                delayedCall(2500, () => {
                                    if (!this.gameplay.isNewRound()) {
                                        if (this.gameplay.isCorrectLetterAudioQuestionEnable()) {
                                            this.playCorrectAudio();
                                        }
                                    }
                                });
                            }
                        });
                    }
                    this._btnSound.on('pointerup', () => {
                        this.playBtnClickAnim(this._btnSound);
                        this.onSoundClick();
                    });
                    this._btnClose.on('pointerup', () => {
                        this.playBtnClickAnim(this._btnClose);
                        this.onCloseClick();
                    });
                }
                hideAllUnusedBeehives() {
                    let i = this.gameplay.getCurrentTotalAnswersCount();
                    for (let k = i + 1; k < this._BeehiveEmptyArray.length; k++) {
                        this._BeehiveEmptyArray[k].visible = false;
                        this._Beehive[k].visible = false;
                    }
                }
                onCorrectAnswer() {
                    let i = this.gameplay.getCurrentTotalAnswersCount();
                    if (i < this._BeehiveEmptyArray.length) {
                        this._BeehiveEmptyArray[i].visible = false;
                        this._Beehive[i].visible = true;
                    }
                    this.hideAllUnusedBeehives();
                    let completed = this.gameplay.onCorrectAnswer();
                    // this.scene.sound.add('correct and letter sound sfx').play();
                    delayedCall(750, () => {
                        this.scene.sound.add(this.gameplay.getCorrectAndLetterSoundSfxAudioKey()).play();
                    });
                    return completed;
                }
                onWrongAnswer() {
                    let i = this.gameplay.getCurrentTotalAnswersCount();
                    if (i < this._BeehiveEmptyArray.length) {
                        this._BeehiveEmptyArray[i].visible = true;
                        this._Beehive[i].visible = false;
                    }
                    this.hideAllUnusedBeehives();
                    let lost = this.gameplay.onWrongAnswer();
                    this.scene.sound.add("wrong sfx").play();
                    return lost;
                }
                playCorrectAudio() {
                    if (this.correctAudio) {
                        this.correctAudio.stop();
                    }
                    this.correctAudio = this.scene.sound.add(this.gameplay.getCorrectAudioKey());
                    this.correctAudio.play();
                    if (this.areYouSureWindow && this.areYouSureWindow.parentContainer == this) {
                        this.correctAudio.pause();
                    }
                }
                onSoundClick() {
                    this.playCorrectAudio();
                }
                onCloseClick() {
                    this.showAreYouSurePage();
                    this.scene.sound.add('warning page pop up sfx').play();
                }
                playBtnClickAnim(target) {
                    let sc = target["defScale"] ? target["defScale"] : 1;
                    target.scaleX = target.scaleY = sc;
                    this.scene.tweens.add({
                        targets: target,
                        "scaleX": 0.9 * sc,
                        "scaleY": 0.9 * sc,
                        duration: 100,
                        yoyo: true
                    });
                }
                showInstructionPage() {
                    setPageBackground("bg-blue");
                    this.instructionPage = new screen.InstructionPage(this.scene, (target) => {
                        this.playBtnClickAnim(target);
                        this.remove(this.instructionPage);
                        this.showGameplay();
                        if (this.wfsnd) {
                            this.wfsnd.stop();
                        }
                    }, (target) => {
                        this.playBtnClickAnim(target);
                        if (this.wfsnd) {
                            this.wfsnd.stop();
                        }
                        this.wfsnd = this.scene.sound.add("Sound Ball welcome");
                        this.wfsnd.play();
                    });
                    this.add(this.instructionPage);
                    try {
                        this.wfsnd = this.scene.sound.add("Sound Ball welcome");
                        this.wfsnd.play();
                    }
                    catch (e) {
                        console.error(e);
                    }
                }
                showAreYouSurePage() {
                    pauseAllDelayedCalls();
                    setPageBackground("bg-blue");
                    this.pauseSounds();
                    this.areYouSureWindow = new screen.AreYouSureWindow(this.scene, () => {
                        this.remove(this.areYouSureWindow);
                        this.destroyGameplay();
                        this.showInstructionPage();
                    }, () => {
                        this.remove(this.areYouSureWindow);
                        this.unpauseSounds();
                        resumeAllDelayedCalls();
                        setPageBackground("bg-australia");
                    });
                    this.add(this.areYouSureWindow);
                }
                setLettersInputEnabled(enabled) {
                    if (enabled) {
                        for (let hc of this.hexagons) {
                            hc["bg"].setInteractive({ cursor: 'pointer' });
                        }
                    }
                    else {
                        for (let hc of this.hexagons) {
                            hc["bg"].disableInteractive();
                        }
                    }
                }
                pauseSounds() {
                    this.scene.sound.pauseAll();
                }
                unpauseSounds() {
                    this.scene.sound.resumeAll();
                }
                destroyGameplay() {
                    this.setLettersInputEnabled(false);
                    this.remove(this.gameplayContainer);
                    destroyAllDelayedCalls();
                }
            }
            screen.GameplayScreen = GameplayScreen;
        })(screen = sh.screen || (sh.screen = {}));
    })(sh || (sh = {}));

    (function (sh) {
        var screen;
        (function (screen) {
            class InstructionPage extends Phaser.GameObjects.Container {
                constructor(scene, onPlayClick, onSndClick) {
                    super(scene);
                    this._instructionPage = new Phaser.GameObjects.Image(this.scene, 0 - 105, 0 - 48, 'Instructions page  ALL ACTIVITY  TITLEs');
                    this._instructionPage.setOrigin(0, 0);
                    this._instructionPage.setInteractive();
                    this._instructionPageTitle = new Phaser.GameObjects.Image(this.scene, 495, 105, 'title-soundball');
                    this._instructionPageTitle.setScale(0.8);
                    this._btnPlay = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2, 480 - 50, 'btnPLAY1');
                    this._btnPlay.setInteractive({ cursor: 'pointer' });
                    this._btnPlay.once('pointerup', onPlayClick);
                    setupButtonTextureBased(this._btnPlay, 'btnPLAY1', 'btnPLAY2');
                    this.instrTxt = this.scene.add.text(game.scale.width / 2, game.scale.height / 2, "Tap the snowball to find the correct sound.", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 30,
                        "stroke": "#ffffff",
                        "color": "#43425d",
                        "align": 'center'
                    });
                    this.instrTxt.setOrigin(0.5, 0.5);
                    this._btnSoundInstruction = new Phaser.GameObjects.Image(this.scene, 800 - 105, 156 - 50, 'Sound');
                    this._btnSoundInstruction.setInteractive({ cursor: 'pointer' });
                    this._btnSoundInstruction.on('pointerup', onSndClick);
                    this._btnSoundInstruction["defScale"] = this._btnSoundInstruction.scale;
                    setupButtonTextureBased(this._btnSoundInstruction, 'Sound', 'Sound HOVER EFFECT');
                    this.add(this._instructionPage);
                    this.add(this._instructionPageTitle);
                    this.add(this.instrTxt);
                    this.add(this._btnPlay);
                    this.add(this._btnSoundInstruction);
                }
            }
            screen.InstructionPage = InstructionPage;
        })(screen = sh.screen || (sh.screen = {}));
    })(sh || (sh = {}));

    (function (sh) {
        var screen;
        (function (screen) {
            class TryAgainWindow extends Phaser.GameObjects.Container {
                constructor(scene, onBack, onReplay) {
                    super(scene);
                    this.music = null;
                    this.setPosition(-106, -48);
                    this._bg = new Phaser.GameObjects.Image(this.scene, 0, 0, 'Try again page');
                    this._bg.setOrigin(0, 0);
                    this._bg.setInteractive();
                    this._star = new Phaser.GameObjects.Image(this.scene, 400, 415, 'Break Star');
                    this._btnBack = new Phaser.GameObjects.Image(this.scene, 600, 580, 'btnBACK1');
                    this._btnReplay = new Phaser.GameObjects.Image(this.scene, 765, 580, 'btnReplay1');
                    this.totalScoreTxt = this.scene.add.text(830, 355, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 35,
                        "color": "#F49F1C",
                        "align": 'center',
                        'stroke': '#70451A',
                        'strokeThickness': 6
                    });
                    this.totalScoreTxt.setOrigin(0.5, 0.5);
                    let grd = this.totalScoreTxt.context.createLinearGradient(0, 0, 0, this.totalScoreTxt.height);
                    grd.addColorStop(0, '#FFFF00');
                    grd.addColorStop(1, '#C17316');
                    this.totalScoreTxt.setFill(grd);
                    this.starScoreTxt = this.scene.add.text(635, 431, "", {
                        "fontFamily": "Kids Rock Demo",
                        "fontSize": 24,
                        "color": "#FFFFFF",
                        "align": 'center'
                    });
                    this.starScoreTxt.setOrigin(0.5, 0.5);
                    this.add([
                        this._bg,
                        this._star,
                        this._btnBack,
                        this._btnReplay,
                        this.totalScoreTxt,
                        this.starScoreTxt
                    ]);
                    this._btnBack.setInteractive({ cursor: 'pointer' });
                    this._btnBack.on('pointerup', () => {
                        onBack(this._btnBack);
                        window.angularComponentRef.backToMenu()
                        // if (this.music) {
                        //     this.music.stop();
                        // }
                    });
                    setupButtonTextureBased(this._btnBack, 'btnBACK1', 'btnBACK2');
                    this._btnReplay.setInteractive({ cursor: 'pointer' });
                    this._btnReplay.once('pointerup', () => {
                        onReplay(this._btnReplay);
                        if (this.music) {
                            this.music.stop();
                        }
                    });
                    setupButtonTextureBased(this._btnReplay, 'btnReplay1', 'btnReplay2');
                }
                show(score, starScore) {
                    this._star.scale = 1.25;
                    this.scene.tweens.add({
                        targets: this._star,
                        "scale": 1,
                        duration: 500,
                        ease: Phaser.Math.Easing.Back.Out
                    });
                    this.totalScoreTxt.text = String(window.angularComponentRef.component.userInfo.totalScore);
                    this.starScoreTxt.text = String(starScore);
                    this.music = this.scene.sound.add("Fail - close one");
                    this.music.play();
                }
            }
            screen.TryAgainWindow = TryAgainWindow;
        })(screen = sh.screen || (sh.screen = {}));
    })(sh || (sh = {}));
}


function destroysoundBalls() {
    if (game) {
        game.destroy();
    }

}

var game;
var apiData;
function questionAndAnswers(json) {

    function setupButton(btn, frame_pointerdown, frame_pointerover, frame_pointerout, frame_pointerup, autoUpdate) {
        if ( typeof frame_pointerout === "undefined" ) frame_pointerout = frame_pointerdown;
        if ( typeof frame_pointerup === "undefined" ) frame_pointerup = frame_pointerdown;

        btn['frame_pointerdown'] = frame_pointerdown;
        btn['frame_pointerover'] = frame_pointerover;
        btn['frame_pointerout'] = frame_pointerout;
        btn['frame_pointerup'] = frame_pointerup;

        if (!btn["alreadySetupEvents"]) {
            btn["alreadySetupEvents"] = true;
            btn.buttonState = 'out';
            btn.on('pointerdown', () => { btn.buttonState = 'down'; btn.setFrame(btn['frame_pointerdown']); });
            btn.on('pointerover', () => { btn.buttonState = 'over'; btn.setFrame(btn['frame_pointerover']); });
            btn.on('pointerout', () => { btn.buttonState = 'out'; btn.setFrame(btn['frame_pointerout']); });
            btn.on('pointerup', () => { btn.buttonState = 'up'; btn.setFrame(btn['frame_pointerup']); });
            btn.setFrame(btn['frame_pointerout']);

            if(autoUpdate) {
                var initTimeout = setTimeout(() => btn.setFrame(btn['frame_pointer' + btn.buttonState]), 0);
                var updateInterval = setInterval(() => btn.setFrame(btn['frame_pointer' + btn.buttonState]), 100);

                btn.on('destroy', function() {
                    clearTimeout(initTimeout);
                    clearInterval(updateInterval);
                })
            }
        }
    }

    //boot
    var boot = function (game) {
        console.log('%cBoot', 'color:white; background:red');
    };

    boot.prototype = {
        init: function () {
            this.apiData = json.data;

            //fix input
            this.game.scale.transformX = (pageX) => {
                let offsetLeft = 0;
                let parentElement = this.game.canvas.parentElement;
                while (parentElement) {
                    if (parentElement.offsetLeft) {
                        offsetLeft = parentElement.offsetLeft;
                        break;
                    }
                    parentElement = parentElement.parentElement;
                }
                return (pageX - offsetLeft) * this.game.scale.displayScale.x;
            };
            this.game.scale.transformY = (pageY) => {
                let offsetTop = 0;
                let parentElement = this.game.canvas.parentElement;
                while (parentElement) {
                    if (parentElement.offsetTop) {
                        offsetTop = parentElement.offsetTop;
                        break;
                    }
                    parentElement = parentElement.parentElement;
                }
                return (pageY - offsetTop) * this.game.scale.displayScale.y;
            };
        },
        preload: function () {
            var modalTextStyle = {
                backgroundColor: 'transparent',
                fontFamily: 'Kids Rock DEMO',
                fontSize: 1
            };
            var modalText = this.add.text(0, 0, ".", modalTextStyle);
            modalText.setPosition(-1000, -1000);
            modalText.alpha = 0;

            this.load.image('red-arrow-image', 'assets/images/red-arrow.png');
            this.load.atlas('answer-buttons', 'assets/qa/animation/picture/answer-buttons.png', 'assets/qa/animation/picture/answer-buttons.json');
            this.load.atlas('assets', 'assets/qa/assets.png', 'assets/qa/assets.json');
            this.load.atlas('assetsGen', 'assets/qa/assetsGen.png', 'assets/qa/assetsGen.json');
            this.load.atlas('soundBtn', 'assets/qa/sound-icon/sound-btn-spritesheet.png', 'assets/qa/sound-icon/sound-btn-spritesheet.json');

            this.load.atlas('idle_atlas', 'assets/qa/animation/picture/Idle_atlas.png', 'assets/qa/animation/picture/Idle_atlas.json');
            this.load.atlas('yes_atlas', 'assets/qa/animation/picture/Yes_atlas.png', 'assets/qa/animation/picture/Yes_atlas.json');
            this.load.atlas('no_atlas', 'assets/qa/animation/picture/No_atlas.png', 'assets/qa/animation/picture/No_atlas.json');
            this.load.atlas('noCorrectAnswerThis_atlas', 'assets/qa/animation/picture/No_its_this_one_atlas.png', 'assets/qa/animation/picture/No_its_this_one_atlas.json');

            this.load.audio('yes1', 'assets/qa/animation/sound/snail_yes_1.mp3');
            this.load.audio('yes2', 'assets/qa/animation/sound/snail_yes_2.mp3');
            this.load.audio('noTryAgain', 'assets/qa/animation/sound/snail_no_short.mp3');
            this.load.audio('noCorrectAnswerThis', 'assets/qa/animation/sound/snail_no_long.mp3');
            this.load.audio('tryAgain', 'assets/qa/animation/sound/Question time - idle_state.mp3');

            this.cache.binary.add('complete', this.apiData.complete);
            this.cache.binary.add('instruction', this.apiData.instruction);
            this.cache.binary.add('questions', this.apiData.content.questions);
            if (this.apiData.content.totalScore) {
                this.cache.binary.add('totalPoints', this.apiData.content.totalScore);
            } else {
                this.cache.binary.add('totalPoints', '0');
            }
            this.cache.binary.add('qAnsPoints', this.apiData.content.qAnsPoints);

            this.load.image('modal-overlay', 'assets/qa/modal-overlay.png'); // API placeholder
            console.warn("LOCAL BG LOADING FORCED!");
            // if (this.apiData.bgImage) {
            //     this.load.image('bg-image', this.apiData.bgImage);
            // } else {
                this.load.image('bg-image', 'assets/qa/new/background question board.jpg');
                this.load.image('bg-image-1', 'assets/qa/new/Group 13 copy.jpg');
            // }
            if (this.apiData.instruction && this.apiData.instruction.b_image) {
                this.load.image('instruction-bg', 'assets/qa/instruction/' + this.apiData.instruction.b_image);
            } else {
                this.load.image('instruction-bg', 'assets/qa/modal-bg-1.png');
            }
            // if (this.apiData.complete && this.apiData.complete.b_image) {
            //   this.load.image('completion-bg', 'assets/qa/completion/' + this.apiData.complete.b_image);
            // } else {
            //   this.load.image('completion-bg', 'assets/qa/modal-bg-1.png');
            // }
            if (this.apiData.complete && this.apiData.complete.award_image) {
                this.load.image('trophy', 'assets/qa/completion/' + this.apiData.complete.award_image);
            }
            this.load.image('completion-bg', 'assets/qa/complete-page-bg.jpg');
            if (this.apiData.complete && this.apiData.complete.audios && this.apiData.complete.audios.length > 0) {
                var index = Math.floor(Math.random() * Math.floor(this.apiData.complete.audios.length));
                this.load.audio('completionSound', this.apiData.complete.audios[index]);
            }
            else {
                this.load.audio('completionSound', 'assets/sounds/viktory.wav');
            }

            this.load.audio('tryAgainSound', 'assets/sounds/fail.wav');

            this.load.audio('bg-music', 'assets/sounds/qa_bg_sound.mp3');

            this.load.audio('selectionSound', 'assets/sounds/selection.mp3');
            this.load.audio('hoverSound', 'assets/sounds/q&a-hover.mp3');
            this.load.audio('tapAnswer', 'assets/sounds/q&a-tap.mp3');
            this.load.audio('exitSound', 'assets/sounds/warning-pop-up.mp3');

            this.fData = this.cache.binary.get('questions');
            for (var j = 0; j < this.fData.length; j++) {
                var questionName = 'questionSound' + j;
                this.load.audio(questionName, this.fData[j].audio);
            }
        },
        create: function () {

            this.isMobile = !this.game.device.desktop;
            //Local storing
            if (window.localStorage.getItem('currentState')) {
                window.localStorage.removeItem('currentState');
            }
            apiData = this.apiData;
            this.scene.start("StartGame", {apiData: this.apiData});
        },

        scaleGame: function () {
            const padding = this.isMobile ? 0 : 0; // include padding around the canvas frame for desktop
            const parentWidth = document.getElementById('game-container').offsetWidth;
            const xScale = (parentWidth - padding) / this.game.width;
            const scalePoint = Math.min(xScale, 1);
        }
    };

    //startGame
    var startgame = function (game) {
        console.log('%cStartGame', 'color:white; background:blue');
    };

    startgame.prototype = {
        init: function () {
            this.goUp = false;
            var storage = {
                questions: [],
                currentPoints: 0
            };
            window.localStorage.setItem('payload', JSON.stringify(storage));
        },
        preload: function () {
            this.fData = this.cache.binary.get('instruction');
            if (this.fData && this.fData.audio) {
                this.load.audio('startSound', this.fData.audio);
            }
        },
        update: function () {
            if (this.redArrowImage) {
              if (this.goUp) {
                this.redArrowImage.y -= 1;
                if (this.redArrowImage.y <= -4) {
                  this.goUp = false
                }
              } else {
                this.redArrowImage.y += 1;
                if (this.redArrowImage.y >= 18) {
                  this.goUp = true;
                }
              }
            }
          },
        create: function () {
            window.angularComponentRef.loadingFinished();
            this.setupState();

            this.addSounds();

            var modalTextStyle = {
                backgroundColor: 'transparent',
                stroke: '#ffffff',
                strokeThickness: 2,
                lineSpacing: 15,
                fontFamily: 'Kids Rock DEMO',
                fontSize: 30,
                color: '#43425d',
                wordWrap: true,
                align: 'center'
            };

            var modalHeaderStyle = {
                backgroundColor: 'transparent',
                stroke: '#ffffff',
                strokeThickness: 16,
                fontFamily: 'Kids Rock DEMO',
                fontSize: 50,
                wordWrap: false,
                align: 'center'
            };

            this.add.sprite(this.game.scale.width/2, this.game.scale.height/2, 'instruction-bg');

            this.modal = this.add.container();

            var modalBox = this.add.sprite(this.game.scale.width/2, this.game.scale.height/2, 'assets', 'activity-Instruction-board.png');
            modalBox.setOrigin(0.5, 0.5);

            this.modalHeaderGroup = this.add.container();
            var modalBoxHeader = this.add.sprite(0, 0, 'assets', 'activity-Instruction-board-header.png');
            modalBoxHeader.setOrigin(0, 0);

            var modalHeaderText = this.add.text(0, 0, this.fData.title, modalHeaderStyle);
            if (!(this.game.device.mobileSafari || this.game.device.safari)) {
                modalHeaderText.setShadow(3, 3, '#43425d', 0, false, true);
            }
            var grd = modalHeaderText.context.createLinearGradient(0, 0, 0, modalHeaderText.height);
            grd.addColorStop(0, '#edee62');
            grd.addColorStop(0.2, '#edee62');
            grd.addColorStop(0.7, '#dd7b33');
            modalHeaderText.setFill(grd);

            var bgSoundButton = this.add.sprite(0, 0, 'soundBtn', 'introduction-sound_02.png');
            bgSoundButton.setOrigin(0, 0);
            bgSoundButton.on('pointerup', function () {
                if (this.redArrowImage) {
                  this.redArrowImage.alpha = 0;
                }
                this.playQuestionSound()
              }, this);

            setupButton(bgSoundButton, 'introduction-sound_02.png', 'introduction-sound_01.png');
            bgSoundButton.setInteractive({ cursor: 'pointer' });
            bgSoundButton.on('pointerover', this.playHoverSound, this);
            bgSoundButton.on('pointerdown', this.playSelectionSound, this );

            this.modalHeaderGroup.add(modalBoxHeader);
            this.modalHeaderGroup.add(modalHeaderText);
            this.modalHeaderGroup.add(bgSoundButton);
            this.modalHeaderGroup.setPosition((modalBox.width - modalBoxHeader.width) / 2 + modalBox.getBounds().left, modalBox.getBounds().top - 21);

            if (this.game.device.os.iOS) {
                this.redArrowImage = this.add.sprite(0, 0, 'red-arrow-image');
                this.redArrowImage.setOrigin(0, 0);
                this.modalHeaderGroup.add(this.redArrowImage);
              }

            modalHeaderText.setPosition(modalBoxHeader.getCenter().x, modalBoxHeader.getCenter().y);
            modalHeaderText.setOrigin(0.5, 0.5);
            modalBoxHeader.setPosition(this.modalHeaderGroup.getBounds().left, this.modalHeaderGroup.getBounds().top);
            bgSoundButton.setPosition(modalBoxHeader.getCenter().x + 30, modalBoxHeader.getCenter().y - 40);

            if (this.game.device.os.iOS) {
                this.redArrowImage.setPosition(modalBoxHeader.getCenter().x + 34, modalBoxHeader.getCenter().y - 110);
            }

            var modalText = this.add.text(this.game.scale.width/2, this.game.scale.height/2, this.fData.content.replaceAll('\\n', '\n'), modalTextStyle);
            console.log(this.fData.content)
            modalText.setWordWrapWidth(modalBox.width - 110);
            modalText.setOrigin(0.5, 0.5);

            var startButton = this.add.sprite(this.game.scale.width/2, modalBox.getBounds().bottom - 103, 'assets', 'activity-Instruction-play-button.png');
            startButton.setOrigin(0, 0)
            startButton.on('pointerup', function () {
                this.fsound.stop();
                currentQuestionIndex = 0;
                this.scene.start("Questions", {currentQuestionIndex: 0});
            }, this);

            setupButton(startButton, 'activity-Instruction-play-button.png', 'activity-Instruction-play-button-hover.png');
            startButton.setInteractive({ cursor: 'pointer' });

            startButton.input.pixelPerfectOver = true;
            startButton.input.pixelPerfectClick = true;
            startButton.setOrigin(0.5, 0.5);

            var leavesRightSprite = this.add.sprite(0, 0, 'assets', 'leaves.png');
            leavesRightSprite.setOrigin(0, 0)
            leavesRightSprite.setPosition(modalBox.getBounds().right - 145, modalBox.getBounds().top + 15);

            var leavesLeftSprite = this.add.sprite(0, 0, 'assets', 'leaves.png');
            leavesLeftSprite.setOrigin(0.5, 0.5);
            leavesLeftSprite.scaleX *= -1;
            leavesLeftSprite.setPosition(modalBox.getBounds().left + 34, modalBox.getBounds().bottom - 140);


            this.modal.add(leavesLeftSprite);
            this.modal.add(leavesRightSprite);
            this.modal.add(modalBox);
            this.modal.add(modalBoxHeader);
            this.modal.add(modalText);
            this.modal.add(startButton);

            this.playQuestionSound();
        },

        setupState: function () {

        },

        addSounds: function () {
            this.fsound = this.sound.add('startSound');
            this.hoverSound = this.sound.add('hoverSound');
            this.selectionSound = this.sound.add('selectionSound');
            this.time.addEvent({ delay: 0, callback: this.playQuestionSound, callbackScope: this, loop: false });
        },

        playHoverSound: function () {
            this.hoverSound.play();
        },
        playSelectionSound: function () {
            this.selectionSound.play();
        },
        playQuestionSound: function () {
            this.fsound.play();
        }
    };
    //endGame
    var endgame = function (game) {
        console.log("%cEndGame", "color:white; background:blue");
    };

    endgame.prototype = {
        init: function () {

        },
        preload: function () {
            this.totalPoints = window.angularComponentRef.getTotalScore();
            this.fData = this.cache.binary.get('complete')
        },
        create: function () {
            if (!this.completionSound) {
                this.completionSound = this.sound.add('completionSound');
            }
            this.completionSound.play()

            window.localStorage.removeItem('currentState');
            window.localStorage.removeItem('wrongButtonKey');

            var storageJson = window.localStorage.getItem('payload');
            var storage = JSON.parse(storageJson);
            var currentPoints = 0;
            if (storage) {
                currentPoints = storage.currentPoints || 0;
            }

            this.add.sprite(0, 0, 'completion-bg').setOrigin(0, 0);

            var totalScoreTextStyle = {
                backgroundColor: 'transparent',
                stroke: '#91301a',
                strokeThickness: 6,
                fontFamily: 'Kids Rock DEMO',
                fontSize: 39,
                wordWrap: false,
                align: 'left'
            };
            var totalScoreTextStyleOutline = {
                backgroundColor: 'transparent',
                stroke: '#fff',
                strokeThickness: 12,
                fontFamily: 'Kids Rock DEMO',
                fontSize: 39,
                wordWrap: false,
                align: 'left'
            };
            var collectedPointsTextStyle = {
                backgroundColor: 'transparent',
                stroke: '#91301a',
                strokeThickness: 2,
                fontFamily: 'Kids Rock DEMO',
                fontSize: 25,
                wordWrap: false,
                align: 'left',
                color: '#ffffff'
            };

            var modalBox = this.add.sprite(this.game.scale.width/2, this.game.scale.height/2, 'assets', 'activity-Instruction-board.png');
            modalBox.setOrigin(0.5, 0.5);
            var completeRibbon = this.add.sprite(modalBox.getCenter().x, modalBox.getBounds().top + 222, 'assets', 'complete-ribbon-full.png');
            completeRibbon.setOrigin(0.5, 0.5);

            var totalScoreOutline = this.add.text(modalBox.getBounds().left + 340, modalBox.getBounds().bottom - 302, "Total Score: " + " " + this.totalPoints, totalScoreTextStyleOutline);
            var totalScore = this.add.text(modalBox.getBounds().left + 342, modalBox.getBounds().bottom - 300, "Total Score: " + " " + this.totalPoints, totalScoreTextStyle);

            var grd = totalScore.context.createLinearGradient(0, 0, 0, totalScore.height);
            grd.addColorStop(0, '#f4fa38');
            grd.addColorStop(0.3, '#edee62');
            grd.addColorStop(0.7, '#dd7b33');
            totalScore.setFill(grd);

            var collectedPointsMedal = this.add.sprite(modalBox.getBounds().left + 324, modalBox.getBounds().bottom - 244, 'assets', 'collected-poins-medal.png');
            collectedPointsMedal.setOrigin(0, 0)
            var collectedPoints = this.add.text(modalBox.getBounds().left + 422, modalBox.getBounds().bottom - 204, "+" + currentPoints, collectedPointsTextStyle);

            var trophy = this.add.sprite(modalBox.getBounds().left + 210, modalBox.getBounds().bottom - 215, 'trophy');
            trophy.setScale(0.5, 0.5);
            trophy.setOrigin(0.5, 0.5);
            trophy.alpha = 0;
            this.tweens.add({
                targets: trophy,
                scaleX: 1,
                scaleY: 1,
                duration: 400,
                ease: Phaser.Math.Easing.Linear
            });
            this.tweens.add({
                targets: trophy,
                alpha: 1,
                duration: 400,
                ease: Phaser.Math.Easing.Linear
            });

            var backToMenuButton = this.add.sprite(modalBox.getBounds().left + 332, modalBox.getBounds().bottom - 89, 'assets', 'back-to-menu-button.png');
            backToMenuButton.setOrigin(0, 0)
            setupButton(backToMenuButton, 'back-to-menu-button.png', 'back-to-menu-button-hover.png');
            backToMenuButton.setInteractive({ cursor: 'pointer' });
            backToMenuButton.on('pointerup', this.backToMenu, this );

            var playAgainButton = this.add.sprite(modalBox.getBounds().left + 479, modalBox.getBounds().bottom - 89, 'assets', 'play-again-button.png');
            playAgainButton.setOrigin(0, 0)
            setupButton(playAgainButton, 'play-again-button.png', 'play-again-button-hover.png');
            playAgainButton.setInteractive({ cursor: 'pointer' });
            playAgainButton.on('pointerup', this.playAgain, this );

            var nextActivityButton = this.add.sprite(modalBox.getBounds().left + 626, modalBox.getBounds().bottom - 89, 'assets', 'next-activity-button.png');
            nextActivityButton.setOrigin(0, 0)
            setupButton(nextActivityButton, 'next-activity-button.png', 'next-activity-button-hover.png');
            nextActivityButton.setInteractive({ cursor: 'pointer' });
            nextActivityButton.on('pointerup', this.nextActivity, this );

            backToMenuButton.on('pointerover', this.playHoverSound, this);
            backToMenuButton.on('pointerdown', this.playSelectionSound, this );

            playAgainButton.on('pointerover', this.playHoverSound, this);
            playAgainButton.on('pointerdown', this.playSelectionSound, this );

            nextActivityButton.on('pointerover', this.playHoverSound, this);
            nextActivityButton.on('pointerdown', this.playSelectionSound, this );

            this.saveActivityAns();

            this.hoverSound = this.sound.add('hoverSound');
            this.selectionSound = this.sound.add('selectionSound');

        },

        backToMenu: function () {
            window.angularComponentRef.backToMenu();
            this.completionSound.stop();
        },
        playAgain: function () {
            this.completionSound.stop();
            this.scene.start("StartGame");
        },
        nextActivity: function () {
            console.log('nextActivity');
            window.angularComponentRef.nextActivity();
        },

        formatTime: function (s) {
            var minutes = "0" + Math.floor(s / 60);
            var seconds = "0" + (s - minutes * 60);
            return minutes.substr(-2) + ":" + seconds.substr(-2);
        },

        saveActivityAns: function () {
            var storageJson = window.localStorage.getItem('payload');
            var storage = JSON.parse(storageJson);
            var _obj = {
                activity_id: 1,
                country_id: 1,
                zone_id: 1,
                continent_id: 1,
                totalScore: 0,
                questions: []
            }
            if (storage) {
                for (var i = 0; i < storage.questions.length; i++) {
                    var questionKey = storage.questions[i].questionKey;
                    var answerKey = storage.questions[i].answerKey;
                    var attempts = storage.questions[i].attempts;
                    var points = storage.questions[i].points;
                    var question = {
                        [questionKey]: {
                            [answerKey]: {
                                try_count: attempts,
                                score: points
                            }
                        }
                    }
                    _obj.questions.push(question);
                    _obj.totalScore += points
                }
                window.angularComponentRef.gameFinish(_obj);
            }
        },

        playHoverSound: function () {
            this.hoverSound.play();
        },
        playSelectionSound: function () {
            this.selectionSound.play();
        }
    };

    //startGame
    var resumegame = function (game) {
        console.log("%cStartGame", "color:white; background:blue");
    };

    resumegame.prototype = {
        init: function (data) {
            this.currentQuestionIndex = data.currentQuestionIndex;
            this.fData = this.cache.binary.get('questions');
        },
        preload: function () {

        },
        create: function () {

            this.add.sprite(0, 0, 'bg-image').setOrigin(0, 0);

            this.hoverSound = this.sound.add('hoverSound');
            this.selectionSound = this.sound.add('selectionSound');

            var startButton = this.add.sprite(this.game.scale.width/2, this.game.scale.height/2, 'assets', 'next-button.png');
            startButton.setOrigin(0, 0)
            setupButton(startButton, 'next-button.png', 'next-button-hover.png');
            startButton.setInteractive({ cursor: 'pointer' });

            startButton.on('pointerup', function () {
                if (currentQuestionIndex < this.fData.questions.length) {
                    this.scene.start("Questions", {currentQuestionIndex: this.currentQuestionIndex});
                } else {
                    this.scene.start("EndGame");
                }
            }, this);

            startButton.on('pointerover', this.playHoverSound, this);
            startButton.on('pointerdown', this.playSelectionSound, this );
            startButton.setOrigin(0.5, 0.5);

            var style = {
                backgroundColor: 'transparent',
                stroke: '#074a83',
                strokeThickness: 6,
                fontFamily: "Kids Rock DEMO",
                fontSize: 40,
                color: "#ffffff",
                wordWrap: false,
                align: "left"
            };
            var startButtonText = this.add.text(this.game.scale.width/2, this.game.scale.height/2 - 100, 'Resume quiz', style);
            startButtonText.setOrigin(0.5, 0.5);
        },
        playHoverSound: function () {
            this.hoverSound.play();
        },
        playSelectionSound: function () {
            this.selectionSound.play();
        }

    };

    //questions
    var questions = function (game) {
        console.log("%cQuestions", "color:white; background:blue");
        // this.bgIndex = 1;
    };

    questions.prototype = {
        init: function (data) {
            var currentQuestionIndex = data.currentQuestionIndex;
            this.currentQuestionIndex = currentQuestionIndex;
            this.wrongAnswersCount = 0;
            this.maxWrongAnswers = 2;
            window.localStorage.setItem('currentState', currentQuestionIndex);
            this.answerTextMaxWidth = 0;
            // this.bgIndex++;
            // this.bgIndex %= 2;
        },
        preload: function () {
            this.fData = this.cache.binary.get('questions');
            this.qAnsPoints = this.cache.binary.get('qAnsPoints');
        },
        create: function () {
            this.defaultLoop = null;

            if (!this.bgMusic) {
                this.bgMusic = this.sound.add('bg-music', {volume: 1, loop: true});
                this.bgMusic.play();
            }
            else {
                if (!this.bgMusic.isPlaying) {
                    this.bgMusic.play();
                }
            }

            this.drawBackground();

            // this.fData = this.game.cache.getJSON('questions');
            this.questionItem = this.fData[this.currentQuestionIndex];
            this.drawQuestionBox(this.questionItem.title);

            this.drawButtonGroup(this.questionItem.answers, this.questionItem.correctAnsKey);

            this.drawPuppet();

            this.addSounds();

            this.addEvents();

            this.exitButton();

            this.exitModal();


        },
        update: function () {

        },
        drawBackground: function () {
            // var key = this.bgIndex == 0 ? 'bg-image' : 'bg-image-1';
            // if (game.textures.get(key).key == "__MISSING") key = 'bg-image';
            this.add.sprite(0, 0, 'bg-image').setOrigin(0, 0);
        },
        drawButtonGroup: function (answers, rightAnswerKey) {
            this.answerTextMaxWidth = 0;
            this.answerNormalImage = 'answer-button-default.png';
            this.answerHoverImage = 'answer-button-default-hover.png';
            this.answerCorrectImage = 'answer-button-correct.png';
            this.answerWrongImage = 'answer-button-wrong.png';

            this.groupButtons = this.add.container();
            var previousGroup;
            for (var index = 0; index < answers.length; index++) {
                var isRightAnswer = (answers[index].key === rightAnswerKey);
                var group = this.drawAnswerButton(answers[index], isRightAnswer);
                if (previousGroup) {
                    group.setPosition(previousGroup.x, previousGroup.getBounds().bottom + 15);
                }
                previousGroup = group;
                this.groupButtons.add(group);
            }
            this.groupButtons.setPosition(66, this.questionBox.getBounds().bottom + 32);

            var groupButtonsChildren = this.groupButtons.getAll();
            for (var i = 0; i < groupButtonsChildren.length; i++) {
                var subChildren = groupButtonsChildren[i].getAll();
                for (var j = 0; j < subChildren.length; j++) {
                    var button = subChildren[j];
                    if (!button.getData("isAnswerButton")) {
                        continue;
                    }
                    setupButton(button, this.answerNormalImage, this.answerHoverImage, undefined, undefined, true);

                    if (button.getData("key") === window.localStorage.getItem('wrongButtonKey')) {
                        setupButton(button, this.answerWrongImage, this.answerWrongImage, undefined, undefined, true);
                        button.disableInteractive();
                        this.wrongAnswersCount++;
                    } else {
                        setupButton(button, this.answerNormalImage, this.answerHoverImage, undefined, undefined, true);
                    }
                }
            }
        },
        drawAnswerButton: function (item, isRightAnswer) {
            var style = {
                backgroundColor: 'transparent',
                stroke: '#681e00',
                strokeThickness: 4,
                fontFamily: "Kids Rock DEMO",
                fontSize: 24,
                color: "#ffffff",
                wordWrap: false,
                align: "left"
            };
            var text = this.add.text(90, 30, item.title, style);
            if (this.answerTextMaxWidth < text.width) {
                this.answerTextMaxWidth = text.width;
            }
            var isClicked = false;
            if (item.key === window.localStorage.getItem('wrongButtonKey')) {
                isClicked = true;
            }

            var button = this.add.sprite(0, 0, 'answer-buttons', this.answerNormalImage);
            button.setOrigin(0, 0);
            setupButton(button, this.answerNormalImage, this.answerHoverImage, undefined, undefined, true);
            button.setInteractive({ cursor: 'pointer' });
            var callbackContext = this;
            button.on('pointerup', function() {
                this.buttonOnClick(button, {
                    context: callbackContext,
                    text: text,
                    clicked: isClicked,
                    isRightAnswer: isRightAnswer,
                    key: item.key
                });
            }.bind(this));
            button.on('pointerover', this.playHoverSound, this);
            button.on('pointerdown', this.playSelectionSound, this );

            button.setData("isRight", isRightAnswer);
            button.setData("key", item.key);
            button.setData("isAnswerButton", true);

            var group = this.add.container();
            group.add(button);
            group.add(text);
            return group;
        },
        drawQuestionBox: function (textContent) {
            var style = {
                backgroundColor: 'transparent',
                stroke: '#681e00', //'#074a83',
                strokeThickness: 5,
                fontFamily: "Kids Rock DEMO",
                fontSize: 32,
                color: "#f5d839",
                wordWrap: true,
                align: "left"
            };
            textContent = 'Question ' + this.questionItem.order + '/' + this.fData.length; //'Q' + this.questionItem.order + '.\xa0' + textContent;

            //question box
            this.questionBox = this.add.container();
            var questionBoxPaddingLeft = 32;
            var questionBoxPaddingRight = 100;
            var questionBoxPaddingY = 15;
            var questionBoxLeft = 0;


            var questionBoxText = this.add.text(questionBoxLeft + questionBoxPaddingLeft, questionBoxPaddingY + 40, textContent, style);
            questionBoxText.setWordWrapWidth(750 - (questionBoxPaddingLeft + questionBoxPaddingRight));
            questionBoxText.setOrigin(0, 0.5);
            questionBoxText.y = 100;

            var questionSoundButton = this.add.sprite(-15, -22, 'assets', 'audio-icon.png');
            questionSoundButton.setScale(1.1, 1.1);
            questionSoundButton.setOrigin(0, 0);
            setupButton(questionSoundButton, 'audio-icon.png', 'audio-icon-hover.png');
            questionSoundButton.setInteractive({ cursor: 'pointer' });
            questionSoundButton.on('pointerup', this.playQuestionSound, this );
            questionSoundButton.on('pointerover', this.playHoverSound, this);
            questionSoundButton.on('pointerdown', this.playSelectionSound, this );

            this.questionBox.add(questionBoxText);
            this.questionBox.add(questionSoundButton);
            this.questionBox.setPosition(55, 34);
        },
        drawPuppet: function () {
            var x = 575;
            var y = 165;

            //puppet
            this.puppetSprite = this.add.sprite(x, y, 'idle_atlas');
            this.puppetSprite.setOrigin(0.0, 0.0);

            var self = this;

            this.anims.create({
                key: 'idleAnimate',
                frames: this.anims.generateFrameNames('idle_atlas', {
                    prefix: 'iddle',
                    suffix: '.png',
                    start: 0,
                    end: 89,
                    zeroPad: 2
                }),
                frameRate: 33,
                repeat: -1
            });


            this.anims.create({
                key: 'noAnimate',
                frames: this.anims.generateFrameNames('no_atlas', {
                    prefix: 'No',
                    suffix: '.png',
                    start: 0,
                    end: 89,
                    zeroPad: 2
                }),
                frameRate: 33,
                repeat: 0
            });

            this.anims.create({
                key: 'yesAnimate',
                frames: this.anims.generateFrameNames('yes_atlas', {
                    prefix: 'YES',
                    suffix: '.png',
                    start: 6,
                    end: 89,
                    zeroPad: 2
                }),
                frameRate: 33,
                repeat: 0
            });

            this.anims.create({
                key: 'noCorrectAnswerThisAnimate',
                frames: this.anims.generateFrameNames('noCorrectAnswerThis_atlas', {
                    prefix: 'No its this one',
                    suffix: '.png',
                    start: 18,
                    end: 89,
                    zeroPad: 2
                }),
                frameRate: 33,
                repeat: 0
            });

            this.puppetSprite.on('animationcomplete', function (animation, frame) {
                if(animation.key !== 'idleAnimate'){
                    self.puppetSprite.anims.play("idleAnimate");
                }
            });
            this.puppetSprite.play('idleAnimate');
        },
        addSounds: function () {
            //sound
            this.fsound = this.sound.add('questionSound' + this.currentQuestionIndex);
            this.trayAgainLoop = null;
            this.fsound.on('complete', function () {
                this.addTrayAgainLoop();
            }, this);

            this.yesSound1 = this.sound.add('yes1');
            this.yesSound2 = this.sound.add('yes2');
            this.noTryAgain = this.sound.add('noTryAgain');
            this.tryAgain = this.sound.add('tryAgain');
            this.noCorrectAnswerThis = this.sound.add('noCorrectAnswerThis');

            this.hoverSound = this.sound.add('hoverSound');
            this.selectionSound = this.sound.add('selectionSound');
            this.iddleDefaultSound = this.sound.add('tapAnswer');
            this.exitSound = this.sound.add('exitSound');
            var self = this;
        },
        addEvents: function () {
            this.questionSoundEvent = this.time.addEvent({ delay: 1000, callback: this.playQuestionSound, callbackScope: this, loop: false });
            this.addNewDefaultLoop();
        },
        addNewDefaultLoop: function () {
            if (this.defaultLoop) {
                this.time.clearPendingEvents();
                this.defaultLoop = this.time.addEvent({ delay: 1000 * 5, callback: this.payPuppet, callbackScope: this, loop: true });
            } else if (!this.defaultLoop) {
                this.defaultLoop = this.time.addEvent({ delay: 1000 * 5, callback: this.payPuppet, callbackScope: this, loop: true });
                // this.puppetSprite.anims.play('idleAnimate');
            }
        },
        buttonOnClick: function (button, data) {
            var context = data.context;
            context.questionSoundEvent.remove(false);

            if (context.fsound && context.fsound.isPlaying) {
                context.fsound.stop();
            }
            var storage = window.localStorage.getItem('payload');
            storage = JSON.parse(storage);

            var questionIdx;
            if (storage) {
                var question;
                for (var i = 0; i < storage.questions.length; i++) {
                    var item = storage.questions[i];
                    if (context.questionItem.key === item.questionKey) {
                        question = item;
                        questionIdx = i;
                        break;
                    }
                }
                if (question) {
                    question.attempts = question.attempts + 1;
                    question.correctAnswer = data.isRightAnswer;
                    storage.questions[questionIdx] = question;
                } else {
                    question = {
                        questionKey: context.questionItem.key,
                        correctAnswer: data.isRightAnswer,
                        attempts: 1
                    };
                    storage.questions.push(question)
                }
            }
            var points = 0;

            var isEndGame = false;
            if (data.isRightAnswer) {
                if (context.wrongAnswersCount === 0) {
                    points = +context.qAnsPoints.correctAnsPoint;

                } else {
                    points = +context.qAnsPoints.secTimeCorrectAnsPoint;
                }
                isEndGame = true;

                context.tryAgain.stop();
                context.noTryAgain.stop();

                data.text.fill = '#6afaff';
                data.text.stroke = '#1a472b';
                context.groupButtons.each(function (item) {
                    item.each(x => x.disableInteractive());
                });
                setupButton(button, context.answerCorrectImage, context.answerCorrectImage, undefined, undefined, true);

                context.puppetSprite.anims.play('yesAnimate');
                context.yesSoundIndex = (context.yesSoundIndex || 0) + 1;
                var yesSound = context['yesSound' + (context.yesSoundIndex % 2 + 1)];
                // yesSound.play();
                setTimeout(function(){yesSound.play()}, 500)
                // context.nextButton.setInteractive({cursor: "pointer"});
                // context.nextButton.alpha = 1;
                setTimeout(context.proceedToTheNextQuestion.bind(context), yesSound.duration * 1000 + 500 + 1500);

                context.addNewDefaultLoop();
                context.addTrayAgainLoop(true);
                window.localStorage.setItem('currentState', +(context.currentQuestionIndex) + 1);
                window.localStorage.removeItem('wrongButtonKey');
            } else {
                points = +context.qAnsPoints.secTimeCorrectAnsPoint;

                button.disableInteractive();

                if (!data.clicked) {
                    data.clicked = true;
                    context.wrongAnswersCount++;
                }
                isEndGame = context.wrongAnswersCount === context.maxWrongAnswers;
                if (isEndGame) {
                    points = +context.qAnsPoints.wrongAnsPoint;
                    context.puppetSprite.anims.play('noCorrectAnswerThisAnimate');
                    context.noCorrectAnswerThis.play();
                } else {
                    context.puppetSprite.anims.play('noAnimate');
                    context.noTryAgain.play();
                }
                if (isEndGame) {
                    context.groupButtons.each(function (item) {
                        item.each(x => x.disableInteractive());
                        if (item.getAt(0).getData("isRight")) {
                            setupButton(item.getAt(0), context.answerCorrectImage, context.answerCorrectImage, undefined, undefined, true);
                        }
                    });
                    setTimeout(context.proceedToTheNextQuestion.bind(context), context.noCorrectAnswerThis.duration * 1000 + 200 + 1500);

                    window.localStorage.setItem('currentState', +(context.currentQuestionIndex) + 1);
                    window.localStorage.removeItem('wrongButtonKey');
                } else {
                    window.localStorage.setItem('wrongButtonKey', data.key);
                }
                setupButton(button, context.answerWrongImage, context.answerWrongImage, undefined, undefined, true);

                context.addNewDefaultLoop();
                context.addTrayAgainLoop(isEndGame);
            }
            if (storage) {
                if (isEndGame) {
                    storage.currentPoints = storage.currentPoints + points;
                    if (questionIdx) {
                        storage.questions[questionIdx].points = points;
                        storage.questions[questionIdx].answerKey = data.key;
                    } else {
                        storage.questions[context.currentQuestionIndex].points = points;
                        storage.questions[context.currentQuestionIndex].answerKey = data.key;
                    }
                }
                window.localStorage.setItem('payload', JSON.stringify(storage));
            }
        },
        addTrayAgainLoop: function (isEndGame) {
            if (this.trayAgainLoop) {
                this.trayAgainLoop.remove(false);
            }

            if (isEndGame) {
                return;
            }

            console.log('Try again loop');
            // this.trayAgainLoop = this.time.addEvent({ delay: 1000 * 10, callback: function() {
            //     this.tryAgain.play();
            // }, callbackScope: this, loop: true });
        },
        playQuestionSound: function () {
            this.tryAgain.stop();
            this.fsound.play();
        },
        payPuppet: function () {
            this.tryAgain.stop();
        },
        proceedToTheNextQuestion: function (delay) {
            if (this.fsound) {
                this.fsound.stop();
            }
            if (this.noTryAgain) {
                this.noTryAgain.stop();
            }
            if (this.iddleDefaultSound) {
                this.iddleDefaultSound.stop();
            }
            if (this.yesSound1) {
                this.yesSound1.stop();
            }
            if (this.yesSound2) {
                this.yesSound2.stop();
            }
            if (this.noCorrectAnswerThis) {
                this.noCorrectAnswerThis.stop();
            }
            this.currentQuestionIndex++;
            if (this.currentQuestionIndex < this.fData.length) {
                this.defaultLoop = null;
                this.scene.start("Questions", {currentQuestionIndex: this.currentQuestionIndex});
            } else {
                if (this.bgMusic) {
                    this.bgMusic.stop();
                }
                this.scene.start("EndGame");
            }
        },

        exitButton: function () {
            this.extiBtn = this.add.sprite(this.game.scale.width - 100, 16, 'assets', 'exit-button.png');
            this.extiBtn.setOrigin(0, 0)
            setupButton(this.extiBtn, 'exit-button.png', 'exit-button-hover.png');
            this.extiBtn.setInteractive({ cursor: 'pointer' });
            this.extiBtn.on('pointerup', this.showExitModal, this);
            this.extiBtn.on('pointerover', this.playHoverSound, this);
            this.extiBtn.on('pointerdown', this.playSelectionSound, this );
        },

        exitModal: function () {
            var modalBg = this.add.sprite(0, 0, 'modal-overlay');
            modalBg.setInteractive();
            modalBg.setOrigin(0, 0)
            this.modal = this.add.container();
            var modalBox = this.add.sprite(this.game.scale.width/2, this.game.scale.height/2, 'assets', 'activity-Instruction-board.png');
            modalBox.setOrigin(0.5, 0.5);

            var leavesRightSprite = this.add.sprite(0, 0, 'assets', 'leaves.png');
            leavesRightSprite.setOrigin(0, 0)
            leavesRightSprite.setPosition(modalBox.getBounds().right - 145, modalBox.getBounds().top + 15);

            var leavesLeftSprite = this.add.sprite(0, 0, 'assets', 'leaves.png');
            leavesLeftSprite.setOrigin(0.5, 0.5);
            leavesLeftSprite.scaleX *= -1;
            leavesLeftSprite.setPosition(modalBox.getBounds().left + 34, modalBox.getBounds().bottom - 140);

            var warningIcon = this.add.sprite(modalBox.getCenter().x, modalBox.getBounds().top + 74, 'assets', 'warning-icon.png');
            warningIcon.setOrigin(0.5, 0);


            var modalTextStyle = {
                backgroundColor: 'transparent',
                stroke: '#ffffff',
                strokeThickness: 2,
                fontFamily: 'Kids Rock DEMO',
                fontSize: 27,
                color: '#43425d',
                wordWrap: true,
                align: 'center'
            };
            var modalText = this.add.text(this.game.scale.width/2, this.game.scale.height/2 + 10, "Your progress in this activity will not be saved. \n \n Are you sure you want to exit? ", modalTextStyle);
            modalText.setWordWrapWidth(modalBox.width - 110);
            modalText.setOrigin(0.5, 0.5);
            var modalYesBtn = this.add.sprite(modalBox.getBounds().left + 217, modalBox.getBounds().bottom - 179, 'assets', 'button-yes.png');
            modalYesBtn.setOrigin(0, 0)
            setupButton(modalYesBtn, 'button-yes.png','button-yes-hover.png');
            modalYesBtn.setInteractive({ cursor: 'pointer' });
            modalYesBtn.on('pointerup', this.exitGame, this);
            var modalNoBtn = this.add.sprite(modalYesBtn.getBounds().right - 43, modalBox.getBounds().bottom - 179, 'assets', 'button-no.png');
            modalNoBtn.setOrigin(0, 0)
            setupButton(modalNoBtn, 'button-no.png','button-no-hover.png');
            modalNoBtn.setInteractive({ cursor: 'pointer' });
            modalNoBtn.on('pointerup', this.exitGameCancel, this);

            modalYesBtn.on('pointerover', this.playHoverSound, this);
            modalYesBtn.on('pointerdown', this.playSelectionSound, this );

            modalNoBtn.on('pointerover', this.playHoverSound, this);
            modalNoBtn.on('pointerdown', this.playSelectionSound, this );

            this.modal.add(modalBg);
            this.modal.add(leavesLeftSprite);
            this.modal.add(leavesRightSprite);
            this.modal.add(modalBox);
            this.modal.add(warningIcon);
            this.modal.add(modalText);
            this.modal.add(modalYesBtn);
            this.modal.add(modalNoBtn);

            this.modal.visible = false;
            this.modal.alpha = 0;
        },

        showExitModal: function () {
            this.extiBtn.visible = false;
            this.modal.visible = true;
            this.modal.alpha = 1;
            this.time.paused = true;
            this.sound.pauseAll();
            this.exitSound.play();
        },

        exitGame: function () {
            this.time.paused = false;
            this.sound.resumeAll();
            window.localStorage.removeItem('currentState');
            window.localStorage.removeItem('wrongButtonKey');
            if (this.bgMusic) {
                this.bgMusic.stop();
            }
            window.angularComponentRef.backToMenu();
        },
        exitGameCancel: function () {
            this.extiBtn.visible = true;
            this.modal.alpha = 0;
            this.modal.visible = false;
            this.time.paused = false;
            this.sound.resumeAll();
            this.bgMusic.resume();
        },
        playHoverSound: function () {
            this.hoverSound.play();
        },
        playIddleDefaultSound: function () {
            this.iddleDefaultSound.play()
        },
        playSelectionSound: function () {
            this.selectionSound.play();
        }
    };

    //main
    game = new Phaser.Game({
        type: Phaser.AUTO,
        width: 980,
        height: 600,
        parent: 'game-container',
        dom: {
            createContainer: false
        },
        scale: {
            mode: Phaser.Scale.NONE,
            // autoCenter: Phaser.Scale.CENTER_BOTH
        },
        transparent: true,
        scene: {
            create: () => {
                game.scene.add("Boot", boot, false);
                game.scene.add("StartGame", startgame);
                game.scene.add("ResumeGame", resumegame);
                game.scene.add("Questions", questions);
                game.scene.add("EndGame", endgame);

                game.scene.start("Boot");
            }
        }
    });


}
function destroyQuestionAndAnswers() {
    if (game)
        game.destroy();
}

/*! xlsx.js (C) 2013-present SheetJS -- http://sheetjs.com */
var DO_NOT_EXPORT_CODEPAGE=true;var DO_NOT_EXPORT_JSZIP=true;var XLSX={};function make_xlsx_lib(e){e.version="0.17.4";var r=1200,t=1252;if(typeof module!=="undefined"&&typeof require!=="undefined"){if(typeof cptable==="undefined"){if(typeof global!=="undefined")global.cptable=undefined;else if(typeof window!=="undefined")window.cptable=undefined}}var a=[874,932,936,949,950];for(var n=0;n<=8;++n)a.push(1250+n);var i={0:1252,1:65001,2:65001,77:1e4,128:932,129:949,130:1361,134:936,136:950,161:1253,162:1254,163:1258,177:1255,178:1256,186:1257,204:1251,222:874,238:1250,255:1252,69:6969};var s=function(e){if(a.indexOf(e)==-1)return;t=i[0]=e};function f(){s(1252)}var l=function(e){r=e;s(e)};function o(){l(1200);f()}function c(e){var r=[];for(var t=0,a=e.length;t<a;++t)r[t]=e.charCodeAt(t);return r}function u(e){var r=[];for(var t=0;t<e.length>>1;++t)r[t]=String.fromCharCode(e.charCodeAt(2*t)+(e.charCodeAt(2*t+1)<<8));return r.join("")}function h(e){var r=[];for(var t=0;t<e.length>>1;++t)r[t]=String.fromCharCode(e.charCodeAt(2*t+1)+(e.charCodeAt(2*t)<<8));return r.join("")}var d=function(e){var r=e.charCodeAt(0),t=e.charCodeAt(1);if(r==255&&t==254)return u(e.slice(2));if(r==254&&t==255)return h(e.slice(2));if(r==65279)return e.slice(1);return e};var v=function Rm(e){return String.fromCharCode(e)};var p=function Fm(e){return String.fromCharCode(e)};if(typeof cptable!=="undefined"){l=function(e){r=e;s(e)};d=function(e){if(e.charCodeAt(0)===255&&e.charCodeAt(1)===254){return cptable.utils.decode(1200,c(e.slice(2)))}return e};v=function Dm(e){if(r===1200)return String.fromCharCode(e);return cptable.utils.decode(r,[e&255,e>>8])[0]};p=function Om(e){return cptable.utils.decode(t,[e])[0]}}var b=null;var m=true;var g=function Pm(){var e="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";return{encode:function(r){var t="";var a=0,n=0,i=0,s=0,f=0,l=0,o=0;for(var c=0;c<r.length;){a=r.charCodeAt(c++);s=a>>2;n=r.charCodeAt(c++);f=(a&3)<<4|n>>4;i=r.charCodeAt(c++);l=(n&15)<<2|i>>6;o=i&63;if(isNaN(n)){l=o=64}else if(isNaN(i)){o=64}t+=e.charAt(s)+e.charAt(f)+e.charAt(l)+e.charAt(o)}return t},decode:function r(t){var a="";var n=0,i=0,s=0,f=0,l=0,o=0,c=0;t=t.replace(/[^\w\+\/\=]/g,"");for(var u=0;u<t.length;){f=e.indexOf(t.charAt(u++));l=e.indexOf(t.charAt(u++));n=f<<2|l>>4;a+=String.fromCharCode(n);o=e.indexOf(t.charAt(u++));i=(l&15)<<4|o>>2;if(o!==64){a+=String.fromCharCode(i)}c=e.indexOf(t.charAt(u++));s=(o&3)<<6|c;if(c!==64){a+=String.fromCharCode(s)}}return a}}}();var E=typeof Buffer!=="undefined"&&typeof process!=="undefined"&&typeof process.versions!=="undefined"&&!!process.versions.node;var w=function(){};if(typeof Buffer!=="undefined"){var k=!Buffer.from;if(!k)try{Buffer.from("foo","utf8")}catch(S){k=true}w=k?function(e,r){return r?new Buffer(e,r):new Buffer(e)}:Buffer.from.bind(Buffer);if(!Buffer.alloc)Buffer.alloc=function(e){return new Buffer(e)};if(!Buffer.allocUnsafe)Buffer.allocUnsafe=function(e){return new Buffer(e)}}function B(e){return E?Buffer.alloc(e):new Array(e)}function C(e){return E?Buffer.allocUnsafe(e):new Array(e)}var T=function Nm(e){if(E)return w(e,"binary");return e.split("").map(function(e){return e.charCodeAt(0)&255})};function _(e){if(typeof ArrayBuffer==="undefined")return T(e);var r=new ArrayBuffer(e.length),t=new Uint8Array(r);for(var a=0;a!=e.length;++a)t[a]=e.charCodeAt(a)&255;return r}function x(e){if(Array.isArray(e))return e.map(function(e){return String.fromCharCode(e)}).join("");var r=[];for(var t=0;t<e.length;++t)r[t]=String.fromCharCode(e[t]);return r.join("")}function A(e){if(typeof Uint8Array==="undefined")throw new Error("Unsupported");return new Uint8Array(e)}function y(e){if(typeof ArrayBuffer=="undefined")throw new Error("Unsupported");if(e instanceof ArrayBuffer)return y(new Uint8Array(e));var r=new Array(e.length);for(var t=0;t<e.length;++t)r[t]=e[t];return r}var I=function(e){return[].concat.apply([],e)};var R=/\u0000/g,F=/[\u0001-\u0006]/g;var D={};var O=function Mm(e){e.version="0.11.2";function r(e){var r="",t=e.length-1;while(t>=0)r+=e.charAt(t--);return r}function t(e,r){var t="";while(t.length<r)t+=e;return t}function a(e,r){var a=""+e;return a.length>=r?a:t("0",r-a.length)+a}function n(e,r){var a=""+e;return a.length>=r?a:t(" ",r-a.length)+a}function i(e,r){var a=""+e;return a.length>=r?a:a+t(" ",r-a.length)}function s(e,r){var a=""+Math.round(e);return a.length>=r?a:t("0",r-a.length)+a}function f(e,r){var a=""+e;return a.length>=r?a:t("0",r-a.length)+a}var l=Math.pow(2,32);function o(e,r){if(e>l||e<-l)return s(e,r);var t=Math.round(e);return f(t,r)}function c(e,r){r=r||0;return e.length>=7+r&&(e.charCodeAt(r)|32)===103&&(e.charCodeAt(r+1)|32)===101&&(e.charCodeAt(r+2)|32)===110&&(e.charCodeAt(r+3)|32)===101&&(e.charCodeAt(r+4)|32)===114&&(e.charCodeAt(r+5)|32)===97&&(e.charCodeAt(r+6)|32)===108}var u=[["Sun","Sunday"],["Mon","Monday"],["Tue","Tuesday"],["Wed","Wednesday"],["Thu","Thursday"],["Fri","Friday"],["Sat","Saturday"]];var h=[["J","Jan","January"],["F","Feb","February"],["M","Mar","March"],["A","Apr","April"],["M","May","May"],["J","Jun","June"],["J","Jul","July"],["A","Aug","August"],["S","Sep","September"],["O","Oct","October"],["N","Nov","November"],["D","Dec","December"]];function d(e){e[0]="General";e[1]="0";e[2]="0.00";e[3]="#,##0";e[4]="#,##0.00";e[9]="0%";e[10]="0.00%";e[11]="0.00E+00";e[12]="# ?/?";e[13]="# ??/??";e[14]="m/d/yy";e[15]="d-mmm-yy";e[16]="d-mmm";e[17]="mmm-yy";e[18]="h:mm AM/PM";e[19]="h:mm:ss AM/PM";e[20]="h:mm";e[21]="h:mm:ss";e[22]="m/d/yy h:mm";e[37]="#,##0 ;(#,##0)";e[38]="#,##0 ;[Red](#,##0)";e[39]="#,##0.00;(#,##0.00)";e[40]="#,##0.00;[Red](#,##0.00)";e[45]="mm:ss";e[46]="[h]:mm:ss";e[47]="mmss.0";e[48]="##0.0E+0";e[49]="@";e[56]='"上午/下午 "hh"時"mm"分"ss"秒 "'}var v={};d(v);var p=[];var b=0;for(b=5;b<=8;++b)p[b]=32+b;for(b=23;b<=26;++b)p[b]=0;for(b=27;b<=31;++b)p[b]=14;for(b=50;b<=58;++b)p[b]=14;for(b=59;b<=62;++b)p[b]=b-58;for(b=67;b<=68;++b)p[b]=b-58;for(b=72;b<=75;++b)p[b]=b-58;for(b=67;b<=68;++b)p[b]=b-57;for(b=76;b<=78;++b)p[b]=b-56;for(b=79;b<=81;++b)p[b]=b-34;var m=[];m[5]=m[63]='"$"#,##0_);\\("$"#,##0\\)';m[6]=m[64]='"$"#,##0_);[Red]\\("$"#,##0\\)';m[7]=m[65]='"$"#,##0.00_);\\("$"#,##0.00\\)';m[8]=m[66]='"$"#,##0.00_);[Red]\\("$"#,##0.00\\)';m[41]='_(* #,##0_);_(* \\(#,##0\\);_(* "-"_);_(@_)';m[42]='_("$"* #,##0_);_("$"* \\(#,##0\\);_("$"* "-"_);_(@_)';m[43]='_(* #,##0.00_);_(* \\(#,##0.00\\);_(* "-"??_);_(@_)';m[44]='_("$"* #,##0.00_);_("$"* \\(#,##0.00\\);_("$"* "-"??_);_(@_)';function g(e,r,t){var a=e<0?-1:1;var n=e*a;var i=0,s=1,f=0;var l=1,o=0,c=0;var u=Math.floor(n);while(o<r){u=Math.floor(n);f=u*s+i;c=u*o+l;if(n-u<5e-8)break;n=1/(n-u);i=s;s=f;l=o;o=c}if(c>r){if(o>r){c=l;f=i}else{c=o;f=s}}if(!t)return[0,a*f,c];var h=Math.floor(a*f/c);return[h,a*f-h*c,c]}function E(e,r,t){if(e>2958465||e<0)return null;var a=e|0,n=Math.floor(86400*(e-a)),i=0;var s=[];var f={D:a,T:n,u:86400*(e-a)-n,y:0,m:0,d:0,H:0,M:0,S:0,q:0};if(Math.abs(f.u)<1e-6)f.u=0;if(r&&r.date1904)a+=1462;if(f.u>.9999){f.u=0;if(++n==86400){f.T=n=0;++a;++f.D}}if(a===60){s=t?[1317,10,29]:[1900,2,29];i=3}else if(a===0){s=t?[1317,8,29]:[1900,1,0];i=6}else{if(a>60)--a;var l=new Date(1900,0,1);l.setDate(l.getDate()+a-1);s=[l.getFullYear(),l.getMonth()+1,l.getDate()];i=l.getDay();if(a<60)i=(i+6)%7;if(t)i=x(l,s)}f.y=s[0];f.m=s[1];f.d=s[2];f.S=n%60;n=Math.floor(n/60);f.M=n%60;n=Math.floor(n/60);f.H=n;f.q=i;return f}e.parse_date_code=E;var w=new Date(1899,11,31,0,0,0);var k=w.getTime();var S=new Date(1900,2,1,0,0,0);function B(e,r){var t=e.getTime();if(r)t-=1461*24*60*60*1e3;else if(e>=S)t+=24*60*60*1e3;return(t-(k+(e.getTimezoneOffset()-w.getTimezoneOffset())*6e4))/(24*60*60*1e3)}function C(e){return e.toString(10)}e._general_int=C;var T=function W(){var e=/(?:\.0*|(\.\d*[1-9])0+)$/;function r(r){return r.indexOf(".")==-1?r:r.replace(e,"$1")}var t=/(?:\.0*|(\.\d*[1-9])0+)[Ee]/;var a=/(E[+-])(\d)$/;function n(e){if(e.indexOf("E")==-1)return e;return e.replace(t,"$1E").replace(a,"$10$2")}function i(e){var t=e<0?12:11;var a=r(e.toFixed(12));if(a.length<=t)return a;a=e.toPrecision(10);if(a.length<=t)return a;return e.toExponential(5)}function s(e){var t=r(e.toFixed(11));return t.length>(e<0?12:11)||t==="0"||t==="-0"?e.toPrecision(6):t}function f(e){var t=Math.floor(Math.log(Math.abs(e))*Math.LOG10E),a;if(t>=-4&&t<=-1)a=e.toPrecision(10+t);else if(Math.abs(t)<=9)a=i(e);else if(t===10)a=e.toFixed(10).substr(0,12);else a=s(e);return r(n(a.toUpperCase()))}return f}();e._general_num=T;function _(e,r){switch(typeof e){case"string":return e;case"boolean":return e?"TRUE":"FALSE";case"number":return(e|0)===e?e.toString(10):T(e);case"undefined":return"";case"object":if(e==null)return"";if(e instanceof Date)return U(14,B(e,r&&r.date1904),r);}throw new Error("unsupported value in General format: "+e)}e._general=_;function x(e,r){r[0]-=581;var t=e.getDay();if(e<60)t=(t+6)%7;return t}function A(e,r,t,n){var i="",s=0,f=0,l=t.y,o,c=0;switch(e){case 98:l=t.y+543;case 121:switch(r.length){case 1:;case 2:o=l%100;c=2;break;default:o=l%1e4;c=4;break;}break;case 109:switch(r.length){case 1:;case 2:o=t.m;c=r.length;break;case 3:return h[t.m-1][1];case 5:return h[t.m-1][0];default:return h[t.m-1][2];}break;case 100:switch(r.length){case 1:;case 2:o=t.d;c=r.length;break;case 3:return u[t.q][0];default:return u[t.q][1];}break;case 104:switch(r.length){case 1:;case 2:o=1+(t.H+11)%12;c=r.length;break;default:throw"bad hour format: "+r;}break;case 72:switch(r.length){case 1:;case 2:o=t.H;c=r.length;break;default:throw"bad hour format: "+r;}break;case 77:switch(r.length){case 1:;case 2:o=t.M;c=r.length;break;default:throw"bad minute format: "+r;}break;case 115:if(r!="s"&&r!="ss"&&r!=".0"&&r!=".00"&&r!=".000")throw"bad second format: "+r;if(t.u===0&&(r=="s"||r=="ss"))return a(t.S,r.length);if(n>=2)f=n===3?1e3:100;else f=n===1?10:1;s=Math.round(f*(t.S+t.u));if(s>=60*f)s=0;if(r==="s")return s===0?"0":""+s/f;i=a(s,2+n);if(r==="ss")return i.substr(0,2);return"."+i.substr(2,r.length-1);case 90:switch(r){case"[h]":;case"[hh]":o=t.D*24+t.H;break;case"[m]":;case"[mm]":o=(t.D*24+t.H)*60+t.M;break;case"[s]":;case"[ss]":o=((t.D*24+t.H)*60+t.M)*60+Math.round(t.S+t.u);break;default:throw"bad abstime format: "+r;}c=r.length===3?1:2;break;case 101:o=l;c=1;break;}var d=c>0?a(o,c):"";return d}function y(e){var r=3;if(e.length<=r)return e;var t=e.length%r,a=e.substr(0,t);for(;t!=e.length;t+=r)a+=(a.length>0?",":"")+e.substr(t,r);return a}var I=function V(){var e=/%/g;function s(r,a,n){var i=a.replace(e,""),s=a.length-i.length;return I(r,i,n*Math.pow(10,2*s))+t("%",s)}function f(e,r,t){var a=r.length-1;while(r.charCodeAt(a-1)===44)--a;return I(e,r.substr(0,a),t/Math.pow(10,3*(r.length-a)))}function l(e,r){var t;var a=e.indexOf("E")-e.indexOf(".")-1;if(e.match(/^#+0.0E\+0$/)){if(r==0)return"0.0E+0";else if(r<0)return"-"+l(e,-r);var n=e.indexOf(".");if(n===-1)n=e.indexOf("E");var i=Math.floor(Math.log(r)*Math.LOG10E)%n;if(i<0)i+=n;t=(r/Math.pow(10,i)).toPrecision(a+1+(n+i)%n);if(t.indexOf("e")===-1){var s=Math.floor(Math.log(r)*Math.LOG10E);if(t.indexOf(".")===-1)t=t.charAt(0)+"."+t.substr(1)+"E+"+(s-t.length+i);else t+="E+"+(s-i);while(t.substr(0,2)==="0."){t=t.charAt(0)+t.substr(2,n)+"."+t.substr(2+n);t=t.replace(/^0+([1-9])/,"$1").replace(/^0+\./,"0.")}t=t.replace(/\+-/,"-")}t=t.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/,function(e,r,t,a){return r+t+a.substr(0,(n+i)%n)+"."+a.substr(i)+"E"})}else t=r.toExponential(a);if(e.match(/E\+00$/)&&t.match(/e[+-]\d$/))t=t.substr(0,t.length-1)+"0"+t.charAt(t.length-1);if(e.match(/E\-/)&&t.match(/e\+/))t=t.replace(/e\+/,"e");return t.replace("e","E")}var c=/# (\?+)( ?)\/( ?)(\d+)/;function u(e,r,i){var s=parseInt(e[4],10),f=Math.round(r*s),l=Math.floor(f/s);var o=f-l*s,c=s;return i+(l===0?"":""+l)+" "+(o===0?t(" ",e[1].length+1+e[4].length):n(o,e[1].length)+e[2]+"/"+e[3]+a(c,e[4].length))}function h(e,r,a){return a+(r===0?"":""+r)+t(" ",e[1].length+2+e[4].length)}var d=/^#*0*\.([0#]+)/;var v=/\).*[0#]/;var p=/\(###\) ###\\?-####/;function b(e){var r="",t;for(var a=0;a!=e.length;++a)switch(t=e.charCodeAt(a)){case 35:break;case 63:r+=" ";break;case 48:r+="0";break;default:r+=String.fromCharCode(t);}return r}function m(e,r){var t=Math.pow(10,r);return""+Math.round(e*t)/t}function E(e,r){var t=e-Math.floor(e),a=Math.pow(10,r);if(r<(""+Math.round(t*a)).length)return 0;return Math.round(t*a)}function w(e,r){if(r<(""+Math.round((e-Math.floor(e))*Math.pow(10,r))).length){return 1}return 0}function k(e){if(e<2147483647&&e>-2147483648)return""+(e>=0?e|0:e-1|0);return""+Math.floor(e)}function S(e,h,B){if(e.charCodeAt(0)===40&&!h.match(v)){var C=h.replace(/\( */,"").replace(/ \)/,"").replace(/\)/,"");if(B>=0)return S("n",C,B);return"("+S("n",C,-B)+")"}if(h.charCodeAt(h.length-1)===44)return f(e,h,B);if(h.indexOf("%")!==-1)return s(e,h,B);if(h.indexOf("E")!==-1)return l(h,B);if(h.charCodeAt(0)===36)return"$"+S(e,h.substr(h.charAt(1)==" "?2:1),B);var T;var _,x,A,R=Math.abs(B),F=B<0?"-":"";if(h.match(/^00+$/))return F+o(R,h.length);if(h.match(/^[#?]+$/)){T=o(B,0);if(T==="0")T="";return T.length>h.length?T:b(h.substr(0,h.length-T.length))+T}if(_=h.match(c))return u(_,R,F);if(h.match(/^#+0+$/))return F+o(R,h.length-h.indexOf("0"));if(_=h.match(d)){T=m(B,_[1].length).replace(/^([^\.]+)$/,"$1."+b(_[1])).replace(/\.$/,"."+b(_[1])).replace(/\.(\d*)$/,function(e,r){return"."+r+t("0",b(_[1]).length-r.length)});return h.indexOf("0.")!==-1?T:T.replace(/^0\./,".")}h=h.replace(/^#+([0.])/,"$1");if(_=h.match(/^(0*)\.(#*)$/)){return F+m(R,_[2].length).replace(/\.(\d*[1-9])0*$/,".$1").replace(/^(-?\d*)$/,"$1.").replace(/^0\./,_[1].length?"0.":".")}if(_=h.match(/^#{1,3},##0(\.?)$/))return F+y(o(R,0));if(_=h.match(/^#,##0\.([#0]*0)$/)){return B<0?"-"+S(e,h,-B):y(""+(Math.floor(B)+w(B,_[1].length)))+"."+a(E(B,_[1].length),_[1].length)}if(_=h.match(/^#,#*,#0/))return S(e,h.replace(/^#,#*,/,""),B);if(_=h.match(/^([0#]+)(\\?-([0#]+))+$/)){T=r(S(e,h.replace(/[\\-]/g,""),B));x=0;return r(r(h.replace(/\\/g,"")).replace(/[0#]/g,function(e){return x<T.length?T.charAt(x++):e==="0"?"0":""}))}if(h.match(p)){T=S(e,"##########",B);return"("+T.substr(0,3)+") "+T.substr(3,3)+"-"+T.substr(6)}var D="";if(_=h.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/)){x=Math.min(_[4].length,7);A=g(R,Math.pow(10,x)-1,false);T=""+F;D=I("n",_[1],A[1]);if(D.charAt(D.length-1)==" ")D=D.substr(0,D.length-1)+"0";T+=D+_[2]+"/"+_[3];D=i(A[2],x);if(D.length<_[4].length)D=b(_[4].substr(_[4].length-D.length))+D;T+=D;return T}if(_=h.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/)){x=Math.min(Math.max(_[1].length,_[4].length),7);A=g(R,Math.pow(10,x)-1,true);return F+(A[0]||(A[1]?"":"0"))+" "+(A[1]?n(A[1],x)+_[2]+"/"+_[3]+i(A[2],x):t(" ",2*x+1+_[2].length+_[3].length))}if(_=h.match(/^[#0?]+$/)){T=o(B,0);if(h.length<=T.length)return T;return b(h.substr(0,h.length-T.length))+T}if(_=h.match(/^([#0?]+)\.([#0]+)$/)){T=""+B.toFixed(Math.min(_[2].length,10)).replace(/([^0])0+$/,"$1");x=T.indexOf(".");var O=h.indexOf(".")-x,P=h.length-T.length-O;return b(h.substr(0,O)+T+h.substr(h.length-P))}if(_=h.match(/^00,000\.([#0]*0)$/)){x=E(B,_[1].length);return B<0?"-"+S(e,h,-B):y(k(B)).replace(/^\d,\d{3}$/,"0$&").replace(/^\d*$/,function(e){return"00,"+(e.length<3?a(0,3-e.length):"")+e})+"."+a(x,_[1].length)}switch(h){case"###,##0.00":return S(e,"#,##0.00",B);case"###,###":;case"##,###":;case"#,###":var N=y(o(R,0));return N!=="0"?F+N:"";case"###,###.00":return S(e,"###,##0.00",B).replace(/^0\./,".");case"#,###.00":return S(e,"#,##0.00",B).replace(/^0\./,".");default:;}throw new Error("unsupported format |"+h+"|")}function B(e,r,t){var a=r.length-1;while(r.charCodeAt(a-1)===44)--a;return I(e,r.substr(0,a),t/Math.pow(10,3*(r.length-a)))}function C(r,a,n){var i=a.replace(e,""),s=a.length-i.length;return I(r,i,n*Math.pow(10,2*s))+t("%",s)}function T(e,r){var t;var a=e.indexOf("E")-e.indexOf(".")-1;if(e.match(/^#+0.0E\+0$/)){if(r==0)return"0.0E+0";else if(r<0)return"-"+T(e,-r);var n=e.indexOf(".");if(n===-1)n=e.indexOf("E");var i=Math.floor(Math.log(r)*Math.LOG10E)%n;if(i<0)i+=n;t=(r/Math.pow(10,i)).toPrecision(a+1+(n+i)%n);if(!t.match(/[Ee]/)){var s=Math.floor(Math.log(r)*Math.LOG10E);if(t.indexOf(".")===-1)t=t.charAt(0)+"."+t.substr(1)+"E+"+(s-t.length+i);else t+="E+"+(s-i);t=t.replace(/\+-/,"-")}t=t.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/,function(e,r,t,a){return r+t+a.substr(0,(n+i)%n)+"."+a.substr(i)+"E"})}else t=r.toExponential(a);if(e.match(/E\+00$/)&&t.match(/e[+-]\d$/))t=t.substr(0,t.length-1)+"0"+t.charAt(t.length-1);if(e.match(/E\-/)&&t.match(/e\+/))t=t.replace(/e\+/,"e");return t.replace("e","E")}function _(e,s,f){if(e.charCodeAt(0)===40&&!s.match(v)){var l=s.replace(/\( */,"").replace(/ \)/,"").replace(/\)/,"");if(f>=0)return _("n",l,f);return"("+_("n",l,-f)+")"}if(s.charCodeAt(s.length-1)===44)return B(e,s,f);if(s.indexOf("%")!==-1)return C(e,s,f);if(s.indexOf("E")!==-1)return T(s,f);if(s.charCodeAt(0)===36)return"$"+_(e,s.substr(s.charAt(1)==" "?2:1),f);var o;var u,m,E,w=Math.abs(f),k=f<0?"-":"";if(s.match(/^00+$/))return k+a(w,s.length);if(s.match(/^[#?]+$/)){o=""+f;if(f===0)o="";return o.length>s.length?o:b(s.substr(0,s.length-o.length))+o}if(u=s.match(c))return h(u,w,k);if(s.match(/^#+0+$/))return k+a(w,s.length-s.indexOf("0"));if(u=s.match(d)){o=(""+f).replace(/^([^\.]+)$/,"$1."+b(u[1])).replace(/\.$/,"."+b(u[1]));o=o.replace(/\.(\d*)$/,function(e,r){return"."+r+t("0",b(u[1]).length-r.length)});return s.indexOf("0.")!==-1?o:o.replace(/^0\./,".")}s=s.replace(/^#+([0.])/,"$1");if(u=s.match(/^(0*)\.(#*)$/)){return k+(""+w).replace(/\.(\d*[1-9])0*$/,".$1").replace(/^(-?\d*)$/,"$1.").replace(/^0\./,u[1].length?"0.":".")}if(u=s.match(/^#{1,3},##0(\.?)$/))return k+y(""+w);if(u=s.match(/^#,##0\.([#0]*0)$/)){return f<0?"-"+_(e,s,-f):y(""+f)+"."+t("0",u[1].length)}if(u=s.match(/^#,#*,#0/))return _(e,s.replace(/^#,#*,/,""),f);if(u=s.match(/^([0#]+)(\\?-([0#]+))+$/)){o=r(_(e,s.replace(/[\\-]/g,""),f));m=0;return r(r(s.replace(/\\/g,"")).replace(/[0#]/g,function(e){return m<o.length?o.charAt(m++):e==="0"?"0":""}))}if(s.match(p)){o=_(e,"##########",f);return"("+o.substr(0,3)+") "+o.substr(3,3)+"-"+o.substr(6)}var S="";if(u=s.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/)){m=Math.min(u[4].length,7);E=g(w,Math.pow(10,m)-1,false);o=""+k;S=I("n",u[1],E[1]);if(S.charAt(S.length-1)==" ")S=S.substr(0,S.length-1)+"0";o+=S+u[2]+"/"+u[3];S=i(E[2],m);if(S.length<u[4].length)S=b(u[4].substr(u[4].length-S.length))+S;o+=S;return o}if(u=s.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/)){m=Math.min(Math.max(u[1].length,u[4].length),7);E=g(w,Math.pow(10,m)-1,true);return k+(E[0]||(E[1]?"":"0"))+" "+(E[1]?n(E[1],m)+u[2]+"/"+u[3]+i(E[2],m):t(" ",2*m+1+u[2].length+u[3].length))}if(u=s.match(/^[#0?]+$/)){o=""+f;if(s.length<=o.length)return o;return b(s.substr(0,s.length-o.length))+o}if(u=s.match(/^([#0]+)\.([#0]+)$/)){o=""+f.toFixed(Math.min(u[2].length,10)).replace(/([^0])0+$/,"$1");m=o.indexOf(".");var x=s.indexOf(".")-m,A=s.length-o.length-x;return b(s.substr(0,x)+o+s.substr(s.length-A))}if(u=s.match(/^00,000\.([#0]*0)$/)){return f<0?"-"+_(e,s,-f):y(""+f).replace(/^\d,\d{3}$/,"0$&").replace(/^\d*$/,function(e){return"00,"+(e.length<3?a(0,3-e.length):"")+e})+"."+a(0,u[1].length)}switch(s){case"###,###":;case"##,###":;case"#,###":var R=y(""+w);return R!=="0"?k+R:"";default:if(s.match(/\.[0#?]*$/))return _(e,s.slice(0,s.lastIndexOf(".")),f)+b(s.slice(s.lastIndexOf(".")));}throw new Error("unsupported format |"+s+"|")}return function x(e,r,t){return(t|0)===t?_(e,r,t):S(e,r,t)}}();function R(e){var r=[];var t=false;for(var a=0,n=0;a<e.length;++a)switch(e.charCodeAt(a)){case 34:t=!t;break;case 95:;case 42:;case 92:++a;break;case 59:r[r.length]=e.substr(n,a-n);n=a+1;}r[r.length]=e.substr(n);if(t===true)throw new Error("Format |"+e+"| unterminated string ");return r}e._split=R;var F=/\[[HhMmSs\u0E0A\u0E19\u0E17]*\]/;function D(e){var r=0,t="",a="";while(r<e.length){switch(t=e.charAt(r)){case"G":if(c(e,r))r+=6;r++;break;case'"':for(;e.charCodeAt(++r)!==34&&r<e.length;){}++r;break;case"\\":r+=2;break;case"_":r+=2;break;case"@":++r;break;case"B":;case"b":if(e.charAt(r+1)==="1"||e.charAt(r+1)==="2")return true;case"M":;case"D":;case"Y":;case"H":;case"S":;case"E":;case"m":;case"d":;case"y":;case"h":;case"s":;case"e":;case"g":return true;case"A":;case"a":;case"上":if(e.substr(r,3).toUpperCase()==="A/P")return true;if(e.substr(r,5).toUpperCase()==="AM/PM")return true;if(e.substr(r,5).toUpperCase()==="上午/下午")return true;++r;break;case"[":a=t;while(e.charAt(r++)!=="]"&&r<e.length)a+=e.charAt(r);if(a.match(F))return true;break;case".":;case"0":;case"#":while(r<e.length&&("0#?.,E+-%".indexOf(t=e.charAt(++r))>-1||t=="\\"&&e.charAt(r+1)=="-"&&"0#".indexOf(e.charAt(r+2))>-1)){}break;case"?":while(e.charAt(++r)===t){}break;case"*":++r;if(e.charAt(r)==" "||e.charAt(r)=="*")++r;break;case"(":;case")":++r;break;case"1":;case"2":;case"3":;case"4":;case"5":;case"6":;case"7":;case"8":;case"9":while(r<e.length&&"0123456789".indexOf(e.charAt(++r))>-1){}break;case" ":++r;break;default:++r;break;}}return false}e.is_date=D;function O(e,r,t,a){var n=[],i="",s=0,f="",l="t",o,u,h;var d="H";while(s<e.length){switch(f=e.charAt(s)){case"G":if(!c(e,s))throw new Error("unrecognized character "+f+" in "+e);n[n.length]={t:"G",v:"General"};s+=7;break;case'"':for(i="";(h=e.charCodeAt(++s))!==34&&s<e.length;)i+=String.fromCharCode(h);n[n.length]={t:"t",v:i};++s;break;case"\\":var v=e.charAt(++s),p=v==="("||v===")"?v:"t";n[n.length]={t:p,v:v};++s;break;case"_":n[n.length]={t:"t",v:" "};s+=2;break;case"@":n[n.length]={t:"T",v:r};++s;break;case"B":;case"b":if(e.charAt(s+1)==="1"||e.charAt(s+1)==="2"){if(o==null){o=E(r,t,e.charAt(s+1)==="2");if(o==null)return""}n[n.length]={t:"X",v:e.substr(s,2)};l=f;s+=2;break};case"M":;case"D":;case"Y":;case"H":;case"S":;case"E":f=f.toLowerCase();case"m":;case"d":;case"y":;case"h":;case"s":;case"e":;case"g":if(r<0)return"";if(o==null){o=E(r,t);if(o==null)return""}i=f;while(++s<e.length&&e.charAt(s).toLowerCase()===f)i+=f;if(f==="m"&&l.toLowerCase()==="h")f="M";if(f==="h")f=d;n[n.length]={t:f,v:i};l=f;break;case"A":;case"a":;case"上":var b={t:f,v:f};if(o==null)o=E(r,t);if(e.substr(s,3).toUpperCase()==="A/P"){if(o!=null)b.v=o.H>=12?"P":"A";b.t="T";d="h";s+=3}else if(e.substr(s,5).toUpperCase()==="AM/PM"){if(o!=null)b.v=o.H>=12?"PM":"AM";b.t="T";s+=5;d="h"}else if(e.substr(s,5).toUpperCase()==="上午/下午"){if(o!=null)b.v=o.H>=12?"下午":"上午";b.t="T";s+=5;d="h"}else{b.t="t";++s}if(o==null&&b.t==="T")return"";n[n.length]=b;l=f;break;case"[":i=f;while(e.charAt(s++)!=="]"&&s<e.length)i+=e.charAt(s);if(i.slice(-1)!=="]")throw'unterminated "[" block: |'+i+"|";if(i.match(F)){if(o==null){o=E(r,t);if(o==null)return""}n[n.length]={t:"Z",v:i.toLowerCase()};l=i.charAt(1)}else if(i.indexOf("$")>-1){i=(i.match(/\$([^-\[\]]*)/)||[])[1]||"$";if(!D(e))n[n.length]={t:"t",v:i}}break;case".":if(o!=null){i=f;while(++s<e.length&&(f=e.charAt(s))==="0")i+=f;n[n.length]={t:"s",v:i};break};case"0":;case"#":i=f;while(++s<e.length&&"0#?.,E+-%".indexOf(f=e.charAt(s))>-1)i+=f;n[n.length]={t:"n",v:i};break;case"?":i=f;while(e.charAt(++s)===f)i+=f;n[n.length]={t:f,v:i};l=f;break;case"*":++s;if(e.charAt(s)==" "||e.charAt(s)=="*")++s;break;case"(":;case")":n[n.length]={t:a===1?"t":f,v:f};++s;break;case"1":;case"2":;case"3":;case"4":;case"5":;case"6":;case"7":;case"8":;case"9":i=f;while(s<e.length&&"0123456789".indexOf(e.charAt(++s))>-1)i+=e.charAt(s);n[n.length]={t:"D",v:i};break;case" ":n[n.length]={t:f,v:f};++s;break;case"$":n[n.length]={t:"t",v:"$"};++s;break;default:if(",$-+/():!^&'~{}<>=€acfijklopqrtuvwxzP".indexOf(f)===-1)throw new Error("unrecognized character "+f+" in "+e);n[n.length]={t:"t",v:f};++s;break;}}var m=0,g=0,w;for(s=n.length-1,l="t";s>=0;--s){switch(n[s].t){case"h":;case"H":n[s].t=d;l="h";if(m<1)m=1;break;case"s":if(w=n[s].v.match(/\.0+$/))g=Math.max(g,w[0].length-1);if(m<3)m=3;case"d":;case"y":;case"M":;case"e":l=n[s].t;break;case"m":if(l==="s"){n[s].t="M";if(m<2)m=2}break;case"X":break;case"Z":if(m<1&&n[s].v.match(/[Hh]/))m=1;if(m<2&&n[s].v.match(/[Mm]/))m=2;if(m<3&&n[s].v.match(/[Ss]/))m=3;}}switch(m){case 0:break;case 1:if(o.u>=.5){o.u=0;++o.S}if(o.S>=60){o.S=0;++o.M}if(o.M>=60){o.M=0;++o.H}break;case 2:if(o.u>=.5){o.u=0;++o.S}if(o.S>=60){o.S=0;++o.M}break;}var k="",S;for(s=0;s<n.length;++s){switch(n[s].t){case"t":;case"T":;case" ":;case"D":break;case"X":n[s].v="";n[s].t=";";break;case"d":;case"m":;case"y":;case"h":;case"H":;case"M":;case"s":;case"e":;case"b":;case"Z":n[s].v=A(n[s].t.charCodeAt(0),n[s].v,o,g);n[s].t="t";break;case"n":;case"?":S=s+1;while(n[S]!=null&&((f=n[S].t)==="?"||f==="D"||(f===" "||f==="t")&&n[S+1]!=null&&(n[S+1].t==="?"||n[S+1].t==="t"&&n[S+1].v==="/")||n[s].t==="("&&(f===" "||f==="n"||f===")")||f==="t"&&(n[S].v==="/"||n[S].v===" "&&n[S+1]!=null&&n[S+1].t=="?"))){n[s].v+=n[S].v;n[S]={v:"",t:";"};++S}k+=n[s].v;s=S-1;break;case"G":n[s].t="t";n[s].v=_(r,t);break;}}var B="",C,T;if(k.length>0){if(k.charCodeAt(0)==40){C=r<0&&k.charCodeAt(0)===45?-r:r;T=I("n",k,C)}else{C=r<0&&a>1?-r:r;T=I("n",k,C);if(C<0&&n[0]&&n[0].t=="t"){T=T.substr(1);n[0].v="-"+n[0].v}}S=T.length-1;var x=n.length;for(s=0;s<n.length;++s)if(n[s]!=null&&n[s].t!="t"&&n[s].v.indexOf(".")>-1){x=s;break}var y=n.length;if(x===n.length&&T.indexOf("E")===-1){for(s=n.length-1;s>=0;--s){if(n[s]==null||"n?".indexOf(n[s].t)===-1)continue;if(S>=n[s].v.length-1){S-=n[s].v.length;n[s].v=T.substr(S+1,n[s].v.length)}else if(S<0)n[s].v="";else{n[s].v=T.substr(0,S+1);S=-1}n[s].t="t";y=s}if(S>=0&&y<n.length)n[y].v=T.substr(0,S+1)+n[y].v}else if(x!==n.length&&T.indexOf("E")===-1){S=T.indexOf(".")-1;for(s=x;s>=0;--s){if(n[s]==null||"n?".indexOf(n[s].t)===-1)continue;u=n[s].v.indexOf(".")>-1&&s===x?n[s].v.indexOf(".")-1:n[s].v.length-1;B=n[s].v.substr(u+1);for(;u>=0;--u){if(S>=0&&(n[s].v.charAt(u)==="0"||n[s].v.charAt(u)==="#"))B=T.charAt(S--)+B}n[s].v=B;n[s].t="t";y=s}if(S>=0&&y<n.length)n[y].v=T.substr(0,S+1)+n[y].v;S=T.indexOf(".")+1;for(s=x;s<n.length;++s){if(n[s]==null||"n?(".indexOf(n[s].t)===-1&&s!==x)continue;u=n[s].v.indexOf(".")>-1&&s===x?n[s].v.indexOf(".")+1:0;B=n[s].v.substr(0,u);for(;u<n[s].v.length;++u){if(S<T.length)B+=T.charAt(S++)}n[s].v=B;n[s].t="t";y=s}}}for(s=0;s<n.length;++s)if(n[s]!=null&&"n?".indexOf(n[s].t)>-1){C=a>1&&r<0&&s>0&&n[s-1].v==="-"?-r:r;n[s].v=I(n[s].t,n[s].v,C);n[s].t="t"}var R="";for(s=0;s!==n.length;++s)if(n[s]!=null)R+=n[s].v;return R}e._eval=O;var P=/\[[=<>]/;var N=/\[(=|>[=]?|<[>=]?)(-?\d+(?:\.\d*)?)\]/;function M(e,r){if(r==null)return false;var t=parseFloat(r[2]);switch(r[1]){case"=":if(e==t)return true;break;case">":if(e>t)return true;break;case"<":if(e<t)return true;break;case"<>":if(e!=t)return true;break;case">=":if(e>=t)return true;break;case"<=":if(e<=t)return true;break;}return false}function L(e,r){var t=R(e);var a=t.length,n=t[a-1].indexOf("@");if(a<4&&n>-1)--a;if(t.length>4)throw new Error("cannot find right format for |"+t.join("|")+"|");if(typeof r!=="number")return[4,t.length===4||n>-1?t[t.length-1]:"@"];switch(t.length){case 1:t=n>-1?["General","General","General",t[0]]:[t[0],t[0],t[0],"@"];break;case 2:t=n>-1?[t[0],t[0],t[0],t[1]]:[t[0],t[1],t[0],"@"];break;case 3:t=n>-1?[t[0],t[1],t[0],t[2]]:[t[0],t[1],t[2],"@"];break;case 4:break;}var i=r>0?t[0]:r<0?t[1]:t[2];if(t[0].indexOf("[")===-1&&t[1].indexOf("[")===-1)return[a,i];if(t[0].match(P)!=null||t[1].match(P)!=null){var s=t[0].match(N);var f=t[1].match(N);return M(r,s)?[a,t[0]]:M(r,f)?[a,t[1]]:[a,t[s!=null&&f!=null?2:1]]}return[a,i]}function U(e,r,t){if(t==null)t={};var a="";switch(typeof e){case"string":if(e=="m/d/yy"&&t.dateNF)a=t.dateNF;else a=e;break;case"number":if(e==14&&t.dateNF)a=t.dateNF;else a=(t.table!=null?t.table:v)[e];if(a==null)a=t.table&&t.table[p[e]]||v[p[e]];if(a==null)a=m[e]||"General";break;}if(c(a,0))return _(r,t);if(r instanceof Date)r=B(r,t.date1904);var n=L(a,r);if(c(n[1]))return _(r,t);if(r===true)r="TRUE";else if(r===false)r="FALSE";else if(r===""||r==null)return"";return O(n[1],r,t,n[0])}function H(e,r){if(typeof r!="number"){r=+r||-1;for(var t=0;t<392;++t){if(v[t]==undefined){if(r<0)r=t;continue}if(v[t]==e){r=t;break}}if(r<0)r=391}v[r]=e;return r}e.load=H;e._table=v;e.get_table=function X(){return v};e.load_table=function G(e){for(var r=0;r!=392;++r)if(e[r]!==undefined)H(e[r],r)};e.init_table=d;e.format=U};O(D);var P={"General Number":"General","General Date":D._table[22],"Long Date":"dddd, mmmm dd, yyyy","Medium Date":D._table[15],"Short Date":D._table[14],"Long Time":D._table[19],"Medium Time":D._table[18],"Short Time":D._table[20],Currency:'"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',Fixed:D._table[2],Standard:D._table[4],Percent:D._table[10],Scientific:D._table[11],"Yes/No":'"Yes";"Yes";"No";@',"True/False":'"True";"True";"False";@',"On/Off":'"Yes";"Yes";"No";@'};var N={5:'"$"#,##0_);\\("$"#,##0\\)',6:'"$"#,##0_);[Red]\\("$"#,##0\\)',7:'"$"#,##0.00_);\\("$"#,##0.00\\)',8:'"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',23:"General",24:"General",25:"General",26:"General",27:"m/d/yy",28:"m/d/yy",29:"m/d/yy",30:"m/d/yy",31:"m/d/yy",32:"h:mm:ss",33:"h:mm:ss",34:"h:mm:ss",35:"h:mm:ss",36:"m/d/yy",41:'_(* #,##0_);_(* (#,##0);_(* "-"_);_(@_)',42:'_("$"* #,##0_);_("$"* (#,##0);_("$"* "-"_);_(@_)',43:'_(* #,##0.00_);_(* (#,##0.00);_(* "-"??_);_(@_)',44:'_("$"* #,##0.00_);_("$"* (#,##0.00);_("$"* "-"??_);_(@_)',50:"m/d/yy",51:"m/d/yy",52:"m/d/yy",53:"m/d/yy",54:"m/d/yy",55:"m/d/yy",56:"m/d/yy",57:"m/d/yy",58:"m/d/yy",59:"0",60:"0.00",61:"#,##0",62:"#,##0.00",63:'"$"#,##0_);\\("$"#,##0\\)',64:'"$"#,##0_);[Red]\\("$"#,##0\\)',65:'"$"#,##0.00_);\\("$"#,##0.00\\)',66:'"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',67:"0%",68:"0.00%",69:"# ?/?",70:"# ??/??",71:"m/d/yy",72:"m/d/yy",73:"d-mmm-yy",74:"d-mmm",75:"mmm-yy",76:"h:mm",77:"h:mm:ss",78:"m/d/yy h:mm",79:"mm:ss",80:"[h]:mm:ss",81:"mmss.0"};var M=/[dD]+|[mM]+|[yYeE]+|[Hh]+|[Ss]+/g;function L(e){var r=typeof e=="number"?D._table[e]:e;r=r.replace(M,"(\\d+)");return new RegExp("^"+r+"$")}function U(e,r,t){var a=-1,n=-1,i=-1,s=-1,f=-1,l=-1;(r.match(M)||[]).forEach(function(e,r){var o=parseInt(t[r+1],10);switch(e.toLowerCase().charAt(0)){case"y":a=o;break;case"d":i=o;break;case"h":s=o;break;case"s":l=o;break;case"m":if(s>=0)f=o;else n=o;break;}});if(l>=0&&f==-1&&n>=0){f=n;n=-1}var o=(""+(a>=0?a:(new Date).getFullYear())).slice(-4)+"-"+("00"+(n>=1?n:1)).slice(-2)+"-"+("00"+(i>=1?i:1)).slice(-2);if(o.length==7)o="0"+o;if(o.length==8)o="20"+o;var c=("00"+(s>=0?s:0)).slice(-2)+":"+("00"+(f>=0?f:0)).slice(-2)+":"+("00"+(l>=0?l:0)).slice(-2);if(s==-1&&f==-1&&l==-1)return o;if(a==-1&&n==-1&&i==-1)return c;return o+"T"+c}var H=true;var W;(function(e){e(W={})})(function(e){e.version="1.2.0";function r(){var e=0,r=new Array(256);for(var t=0;t!=256;++t){e=t;e=e&1?-306674912^e>>>1:e>>>1;e=e&1?-306674912^e>>>1:e>>>1;e=e&1?-306674912^e>>>1:e>>>1;e=e&1?-306674912^e>>>1:e>>>1;e=e&1?-306674912^e>>>1:e>>>1;e=e&1?-306674912^e>>>1:e>>>1;e=e&1?-306674912^e>>>1:e>>>1;e=e&1?-306674912^e>>>1:e>>>1;r[t]=e}return typeof Int32Array!=="undefined"?new Int32Array(r):r}var t=r();function a(e,r){var a=r^-1,n=e.length-1;for(var i=0;i<n;){a=a>>>8^t[(a^e.charCodeAt(i++))&255];a=a>>>8^t[(a^e.charCodeAt(i++))&255]}if(i===n)a=a>>>8^t[(a^e.charCodeAt(i))&255];return a^-1}function n(e,r){if(e.length>1e4)return i(e,r);var a=r^-1,n=e.length-3;for(var s=0;s<n;){a=a>>>8^t[(a^e[s++])&255];a=a>>>8^t[(a^e[s++])&255];a=a>>>8^t[(a^e[s++])&255];a=a>>>8^t[(a^e[s++])&255]}while(s<n+3)a=a>>>8^t[(a^e[s++])&255];return a^-1}function i(e,r){var a=r^-1,n=e.length-7;for(var i=0;i<n;){a=a>>>8^t[(a^e[i++])&255];a=a>>>8^t[(a^e[i++])&255];a=a>>>8^t[(a^e[i++])&255];a=a>>>8^t[(a^e[i++])&255];a=a>>>8^t[(a^e[i++])&255];a=a>>>8^t[(a^e[i++])&255];a=a>>>8^t[(a^e[i++])&255];a=a>>>8^t[(a^e[i++])&255]}while(i<n+7)a=a>>>8^t[(a^e[i++])&255];return a^-1}function s(e,r){var a=r^-1;for(var n=0,i=e.length,s,f;n<i;){s=e.charCodeAt(n++);if(s<128){a=a>>>8^t[(a^s)&255]}else if(s<2048){a=a>>>8^t[(a^(192|s>>6&31))&255];a=a>>>8^t[(a^(128|s&63))&255]}else if(s>=55296&&s<57344){s=(s&1023)+64;f=e.charCodeAt(n++)&1023;a=a>>>8^t[(a^(240|s>>8&7))&255];a=a>>>8^t[(a^(128|s>>2&63))&255];a=a>>>8^t[(a^(128|f>>6&15|(s&3)<<4))&255];
a=a>>>8^t[(a^(128|f&63))&255]}else{a=a>>>8^t[(a^(224|s>>12&15))&255];a=a>>>8^t[(a^(128|s>>6&63))&255];a=a>>>8^t[(a^(128|s&63))&255]}}return a^-1}e.table=t;e.bstr=a;e.buf=n;e.str=s});var V=function Lm(){var e={};e.version="1.1.4";function r(e,r){var t=e.split("/"),a=r.split("/");for(var n=0,i=0,s=Math.min(t.length,a.length);n<s;++n){if(i=t[n].length-a[n].length)return i;if(t[n]!=a[n])return t[n]<a[n]?-1:1}return t.length-a.length}function t(e){if(e.charAt(e.length-1)=="/")return e.slice(0,-1).indexOf("/")===-1?e:t(e.slice(0,-1));var r=e.lastIndexOf("/");return r===-1?e:e.slice(0,r+1)}function a(e){if(e.charAt(e.length-1)=="/")return a(e.slice(0,-1));var r=e.lastIndexOf("/");return r===-1?e:e.slice(r+1)}function n(e,r){if(typeof r==="string")r=new Date(r);var t=r.getHours();t=t<<6|r.getMinutes();t=t<<5|r.getSeconds()>>>1;e._W(2,t);var a=r.getFullYear()-1980;a=a<<4|r.getMonth()+1;a=a<<5|r.getDate();e._W(2,a)}function i(e){var r=e._R(2)&65535;var t=e._R(2)&65535;var a=new Date;var n=t&31;t>>>=5;var i=t&15;t>>>=4;a.setMilliseconds(0);a.setFullYear(t+1980);a.setMonth(i-1);a.setDate(n);var s=r&31;r>>>=5;var f=r&63;r>>>=6;a.setHours(r);a.setMinutes(f);a.setSeconds(s<<1);return a}function s(e){Yr(e,0);var r={};var t=0;while(e.l<=e.length-4){var a=e._R(2);var n=e._R(2),i=e.l+n;var s={};switch(a){case 21589:{t=e._R(1);if(t&1)s.mtime=e._R(4);if(n>5){if(t&2)s.atime=e._R(4);if(t&4)s.ctime=e._R(4)}if(s.mtime)s.mt=new Date(s.mtime*1e3)}break;}e.l=i;r[a]=s}return r}var f;function l(){return f||(f=require("fs"))}function o(e,r){if(e[0]==80&&e[1]==75)return _e(e,r);if(e.length<512)throw new Error("CFB file size "+e.length+" < 512");var t=3;var a=512;var n=0;var i=0;var s=0;var f=0;var l=0;var o=[];var v=e.slice(0,512);Yr(v,0);var b=c(v);t=b[0];switch(t){case 3:a=512;break;case 4:a=4096;break;case 0:if(b[1]==0)return _e(e,r);default:throw new Error("Major Version: Expected 3 or 4 saw "+t);}if(a!==512){v=e.slice(0,a);Yr(v,28)}var g=e.slice(0,a);u(v,t);var E=v._R(4,"i");if(t===3&&E!==0)throw new Error("# Directory Sectors: Expected 0 saw "+E);v.l+=4;s=v._R(4,"i");v.l+=4;v.chk("00100000","Mini Stream Cutoff Size: ");f=v._R(4,"i");n=v._R(4,"i");l=v._R(4,"i");i=v._R(4,"i");for(var k=-1,S=0;S<109;++S){k=v._R(4,"i");if(k<0)break;o[S]=k}var B=h(e,a);p(l,i,B,a,o);var C=m(B,s,o,a);C[s].name="!Directory";if(n>0&&f!==N)C[f].name="!MiniFAT";C[o[0]].name="!FAT";C.fat_addrs=o;C.ssz=a;var T={},_=[],x=[],A=[];w(s,C,B,_,n,T,x,f);d(x,A,_);_.shift();var y={FileIndex:x,FullPaths:A};if(r&&r.raw)y.raw={header:g,sectors:B};return y}function c(e){if(e[e.l]==80&&e[e.l+1]==75)return[0,0];e.chk(M,"Header Signature: ");e.l+=16;var r=e._R(2,"u");return[e._R(2,"u"),r]}function u(e,r){var t=9;e.l+=2;switch(t=e._R(2)){case 9:if(r!=3)throw new Error("Sector Shift: Expected 9 saw "+t);break;case 12:if(r!=4)throw new Error("Sector Shift: Expected 12 saw "+t);break;default:throw new Error("Sector Shift: Expected 9 or 12 saw "+t);}e.chk("0600","Mini Sector Shift: ");e.chk("000000000000","Reserved: ")}function h(e,r){var t=Math.ceil(e.length/r)-1;var a=[];for(var n=1;n<t;++n)a[n-1]=e.slice(n*r,(n+1)*r);a[t-1]=e.slice(t*r);return a}function d(e,r,t){var a=0,n=0,i=0,s=0,f=0,l=t.length;var o=[],c=[];for(;a<l;++a){o[a]=c[a]=a;r[a]=t[a]}for(;f<c.length;++f){a=c[f];n=e[a].L;i=e[a].R;s=e[a].C;if(o[a]===a){if(n!==-1&&o[n]!==n)o[a]=o[n];if(i!==-1&&o[i]!==i)o[a]=o[i]}if(s!==-1)o[s]=a;if(n!==-1&&a!=o[a]){o[n]=o[a];if(c.lastIndexOf(n)<f)c.push(n)}if(i!==-1&&a!=o[a]){o[i]=o[a];if(c.lastIndexOf(i)<f)c.push(i)}}for(a=1;a<l;++a)if(o[a]===a){if(i!==-1&&o[i]!==i)o[a]=o[i];else if(n!==-1&&o[n]!==n)o[a]=o[n]}for(a=1;a<l;++a){if(e[a].type===0)continue;f=a;if(f!=o[f])do{f=o[f];r[a]=r[f]+"/"+r[a]}while(f!==0&&-1!==o[f]&&f!=o[f]);o[a]=-1}r[0]+="/";for(a=1;a<l;++a){if(e[a].type!==2)r[a]+="/"}}function v(e,r,t){var a=e.start,n=e.size;var i=[];var s=a;while(t&&n>0&&s>=0){i.push(r.slice(s*P,s*P+P));n-=P;s=Wr(t,s*4)}if(i.length===0)return Jr(0);return I(i).slice(0,e.size)}function p(e,r,t,a,n){var i=N;if(e===N){if(r!==0)throw new Error("DIFAT chain shorter than expected")}else if(e!==-1){var s=t[e],f=(a>>>2)-1;if(!s)return;for(var l=0;l<f;++l){if((i=Wr(s,l*4))===N)break;n.push(i)}if(r>=1)p(Wr(s,a-4),r-1,t,a,n)}}function b(e,r,t,a,n){var i=[],s=[];if(!n)n=[];var f=a-1,l=0,o=0;for(l=r;l>=0;){n[l]=true;i[i.length]=l;s.push(e[l]);var c=t[Math.floor(l*4/a)];o=l*4&f;if(a<4+o)throw new Error("FAT boundary crossed: "+l+" 4 "+a);if(!e[c])break;l=Wr(e[c],o)}return{nodes:i,data:br([s])}}function m(e,r,t,a){var n=e.length,i=[];var s=[],f=[],l=[];var o=a-1,c=0,u=0,h=0,d=0;for(c=0;c<n;++c){f=[];h=c+r;if(h>=n)h-=n;if(s[h])continue;l=[];var v=[];for(u=h;u>=0;){v[u]=true;s[u]=true;f[f.length]=u;l.push(e[u]);var p=t[Math.floor(u*4/a)];d=u*4&o;if(a<4+d)throw new Error("FAT boundary crossed: "+u+" 4 "+a);if(!e[p])break;u=Wr(e[p],d);if(v[u])break}i[h]={nodes:f,data:br([l])}}return i}function w(e,r,t,a,n,i,s,f){var l=0,o=a.length?2:0;var c=r[e].data;var u=0,h=0,d;for(;u<c.length;u+=128){var p=c.slice(u,u+128);Yr(p,64);h=p._R(2);d=gr(p,0,h-o);a.push(d);var m={name:d,type:p._R(1),color:p._R(1),L:p._R(4,"i"),R:p._R(4,"i"),C:p._R(4,"i"),clsid:p._R(16),state:p._R(4,"i"),start:0,size:0};var g=p._R(2)+p._R(2)+p._R(2)+p._R(2);if(g!==0)m.ct=k(p,p.l-8);var E=p._R(2)+p._R(2)+p._R(2)+p._R(2);if(E!==0)m.mt=k(p,p.l-8);m.start=p._R(4,"i");m.size=p._R(4,"i");if(m.size<0&&m.start<0){m.size=m.type=0;m.start=N;m.name=""}if(m.type===5){l=m.start;if(n>0&&l!==N)r[l].name="!StreamData"}else if(m.size>=4096){m.storage="fat";if(r[m.start]===undefined)r[m.start]=b(t,m.start,r.fat_addrs,r.ssz);r[m.start].name=m.name;m.content=r[m.start].data.slice(0,m.size)}else{m.storage="minifat";if(m.size<0)m.size=0;else if(l!==N&&m.start!==N&&r[l]){m.content=v(m,r[l].data,(r[f]||{}).data)}}if(m.content)Yr(m.content,0);i[d]=m;s.push(m)}}function k(e,r){return new Date((Hr(e,r+4)/1e7*Math.pow(2,32)+Hr(e,r)/1e7-11644473600)*1e3)}function S(e,r){l();return o(f.readFileSync(e),r)}function _(e,r){switch(r&&r.type||"base64"){case"file":return S(e,r);case"base64":return o(T(g.decode(e)),r);case"binary":return o(T(e),r);}return o(e,r)}function x(e,r){var t=r||{},a=t.root||"Root Entry";if(!e.FullPaths)e.FullPaths=[];if(!e.FileIndex)e.FileIndex=[];if(e.FullPaths.length!==e.FileIndex.length)throw new Error("inconsistent CFB structure");if(e.FullPaths.length===0){e.FullPaths[0]=a+"/";e.FileIndex[0]={name:a,type:5}}if(t.CLSID)e.FileIndex[0].clsid=t.CLSID;A(e)}function A(e){var r="Sh33tJ5";if(V.find(e,"/"+r))return;var t=Jr(4);t[0]=55;t[1]=t[3]=50;t[2]=54;e.FileIndex.push({name:r,type:2,content:t,size:4,L:69,R:69,C:69});e.FullPaths.push(e.FullPaths[0]+r);y(e)}function y(e,n){x(e);var i=false,s=false;for(var f=e.FullPaths.length-1;f>=0;--f){var l=e.FileIndex[f];switch(l.type){case 0:if(s)i=true;else{e.FileIndex.pop();e.FullPaths.pop()}break;case 1:;case 2:;case 5:s=true;if(isNaN(l.R*l.L*l.C))i=true;if(l.R>-1&&l.L>-1&&l.R==l.L)i=true;break;default:i=true;break;}}if(!i&&!n)return;var o=new Date(1987,1,19),c=0;var u=[];for(f=0;f<e.FullPaths.length;++f){if(e.FileIndex[f].type===0)continue;u.push([e.FullPaths[f],e.FileIndex[f]])}for(f=0;f<u.length;++f){var h=t(u[f][0]);s=false;for(c=0;c<u.length;++c)if(u[c][0]===h)s=true;if(!s)u.push([h,{name:a(h).replace("/",""),type:1,clsid:U,ct:o,mt:o,content:null}])}u.sort(function(e,t){return r(e[0],t[0])});e.FullPaths=[];e.FileIndex=[];for(f=0;f<u.length;++f){e.FullPaths[f]=u[f][0];e.FileIndex[f]=u[f][1]}for(f=0;f<u.length;++f){var d=e.FileIndex[f];var v=e.FullPaths[f];d.name=a(v).replace("/","");d.L=d.R=d.C=-(d.color=1);d.size=d.content?d.content.length:0;d.start=0;d.clsid=d.clsid||U;if(f===0){d.C=u.length>1?1:-1;d.size=0;d.type=5}else if(v.slice(-1)=="/"){for(c=f+1;c<u.length;++c)if(t(e.FullPaths[c])==v)break;d.C=c>=u.length?-1:c;for(c=f+1;c<u.length;++c)if(t(e.FullPaths[c])==t(v))break;d.R=c>=u.length?-1:c;d.type=1}else{if(t(e.FullPaths[f+1]||"")==t(v))d.R=f+1;d.type=2}}}function D(e,r){var t=r||{};y(e);if(t.fileType=="zip")return Ae(e,t);var a=function(e){var r=0,t=0;for(var a=0;a<e.FileIndex.length;++a){var n=e.FileIndex[a];if(!n.content)continue;var i=n.content.length;if(i>0){if(i<4096)r+=i+63>>6;else t+=i+511>>9}}var s=e.FullPaths.length+3>>2;var f=r+7>>3;var l=r+127>>7;var o=f+t+s+l;var c=o+127>>7;var u=c<=109?0:Math.ceil((c-109)/127);while(o+c+u+127>>7>c)u=++c<=109?0:Math.ceil((c-109)/127);var h=[1,u,c,l,s,t,r,0];e.FileIndex[0].size=r<<6;h[7]=(e.FileIndex[0].start=h[0]+h[1]+h[2]+h[3]+h[4]+h[5])+(h[6]+7>>3);return h}(e);var n=Jr(a[7]<<9);var i=0,s=0;{for(i=0;i<8;++i)n._W(1,L[i]);for(i=0;i<8;++i)n._W(2,0);n._W(2,62);n._W(2,3);n._W(2,65534);n._W(2,9);n._W(2,6);for(i=0;i<3;++i)n._W(2,0);n._W(4,0);n._W(4,a[2]);n._W(4,a[0]+a[1]+a[2]+a[3]-1);n._W(4,0);n._W(4,1<<12);n._W(4,a[3]?a[0]+a[1]+a[2]-1:N);n._W(4,a[3]);n._W(-4,a[1]?a[0]-1:N);n._W(4,a[1]);for(i=0;i<109;++i)n._W(-4,i<a[2]?a[1]+i:-1)}if(a[1]){for(s=0;s<a[1];++s){for(;i<236+s*127;++i)n._W(-4,i<a[2]?a[1]+i:-1);n._W(-4,s===a[1]-1?N:s+1)}}var f=function(e){for(s+=e;i<s-1;++i)n._W(-4,i+1);if(e){++i;n._W(-4,N)}};s=i=0;for(s+=a[1];i<s;++i)n._W(-4,H.DIFSECT);for(s+=a[2];i<s;++i)n._W(-4,H.FATSECT);f(a[3]);f(a[4]);var l=0,o=0;var c=e.FileIndex[0];for(;l<e.FileIndex.length;++l){c=e.FileIndex[l];if(!c.content)continue;o=c.content.length;if(o<4096)continue;c.start=s;f(o+511>>9)}f(a[6]+7>>3);while(n.l&511)n._W(-4,H.ENDOFCHAIN);s=i=0;for(l=0;l<e.FileIndex.length;++l){c=e.FileIndex[l];if(!c.content)continue;o=c.content.length;if(!o||o>=4096)continue;c.start=s;f(o+63>>6)}while(n.l&511)n._W(-4,H.ENDOFCHAIN);for(i=0;i<a[4]<<2;++i){var u=e.FullPaths[i];if(!u||u.length===0){for(l=0;l<17;++l)n._W(4,0);for(l=0;l<3;++l)n._W(4,-1);for(l=0;l<12;++l)n._W(4,0);continue}c=e.FileIndex[i];if(i===0)c.start=c.size?c.start-1:N;var h=i===0&&t.root||c.name;o=2*(h.length+1);n._W(64,h,"utf16le");n._W(2,o);n._W(1,c.type);n._W(1,c.color);n._W(-4,c.L);n._W(-4,c.R);n._W(-4,c.C);if(!c.clsid)for(l=0;l<4;++l)n._W(4,0);else n._W(16,c.clsid,"hex");n._W(4,c.state||0);n._W(4,0);n._W(4,0);n._W(4,0);n._W(4,0);n._W(4,c.start);n._W(4,c.size);n._W(4,0)}for(i=1;i<e.FileIndex.length;++i){c=e.FileIndex[i];if(c.size>=4096){n.l=c.start+1<<9;for(l=0;l<c.size;++l)n._W(1,c.content[l]);for(;l&511;++l)n._W(1,0)}}for(i=1;i<e.FileIndex.length;++i){c=e.FileIndex[i];if(c.size>0&&c.size<4096){for(l=0;l<c.size;++l)n._W(1,c.content[l]);for(;l&63;++l)n._W(1,0)}}while(n.l<n.length)n._W(1,0);return n}function O(e,r){var t=e.FullPaths.map(function(e){return e.toUpperCase()});var a=t.map(function(e){var r=e.split("/");return r[r.length-(e.slice(-1)=="/"?2:1)]});var n=false;if(r.charCodeAt(0)===47){n=true;r=t[0].slice(0,-1)+r}else n=r.indexOf("/")!==-1;var i=r.toUpperCase();var s=n===true?t.indexOf(i):a.indexOf(i);if(s!==-1)return e.FileIndex[s];var f=!i.match(F);i=i.replace(R,"");if(f)i=i.replace(F,"!");for(s=0;s<t.length;++s){if((f?t[s].replace(F,"!"):t[s]).replace(R,"")==i)return e.FileIndex[s];if((f?a[s].replace(F,"!"):a[s]).replace(R,"")==i)return e.FileIndex[s]}return null}var P=64;var N=-2;var M="d0cf11e0a1b11ae1";var L=[208,207,17,224,161,177,26,225];var U="00000000000000000000000000000000";var H={MAXREGSECT:-6,DIFSECT:-4,FATSECT:-3,ENDOFCHAIN:N,FREESECT:-1,HEADER_SIGNATURE:M,HEADER_MINOR_VERSION:"3e00",MAXREGSID:-6,NOSTREAM:-1,HEADER_CLSID:U,EntryTypes:["unknown","storage","stream","lockbytes","property","root"]};function X(e,r,t){l();var a=D(e,t);f.writeFileSync(r,a)}function G(e){var r=new Array(e.length);for(var t=0;t<e.length;++t)r[t]=String.fromCharCode(e[t]);return r.join("")}function z(e,r){var t=D(e,r);switch(r&&r.type){case"file":l();f.writeFileSync(r.filename,t);return t;case"binary":return G(t);case"base64":return g.encode(G(t));}return t}var j;function $(e){try{var r=e.InflateRaw;var t=new r;t._processChunk(new Uint8Array([3,0]),t._finishFlushFlag);if(t.bytesRead)j=e;else throw new Error("zlib does not expose bytesRead")}catch(a){console.error("cannot use native zlib: "+(a.message||a))}}function K(e,r){if(!j)return Ce(e,r);var t=j.InflateRaw;var a=new t;var n=a._processChunk(e.slice(e.l),a._finishFlushFlag);e.l+=a.bytesRead;return n}function Y(e){return j?j.deflateRawSync(e):he(e)}var Q=[16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15];var J=[3,4,5,6,7,8,9,10,11,13,15,17,19,23,27,31,35,43,51,59,67,83,99,115,131,163,195,227,258];var Z=[1,2,3,4,5,7,9,13,17,25,33,49,65,97,129,193,257,385,513,769,1025,1537,2049,3073,4097,6145,8193,12289,16385,24577];function q(e){var r=(e<<1|e<<11)&139536|(e<<5|e<<15)&558144;return(r>>16|r>>8|r)&255}var ee=typeof Uint8Array!=="undefined";var re=ee?new Uint8Array(1<<8):[];for(var te=0;te<1<<8;++te)re[te]=q(te);function ae(e,r){var t=re[e&255];if(r<=8)return t>>>8-r;t=t<<8|re[e>>8&255];if(r<=16)return t>>>16-r;t=t<<8|re[e>>16&255];return t>>>24-r}function ne(e,r){var t=r&7,a=r>>>3;return(e[a]|(t<=6?0:e[a+1]<<8))>>>t&3}function ie(e,r){var t=r&7,a=r>>>3;return(e[a]|(t<=5?0:e[a+1]<<8))>>>t&7}function se(e,r){var t=r&7,a=r>>>3;return(e[a]|(t<=4?0:e[a+1]<<8))>>>t&15}function fe(e,r){var t=r&7,a=r>>>3;return(e[a]|(t<=3?0:e[a+1]<<8))>>>t&31}function le(e,r){var t=r&7,a=r>>>3;return(e[a]|(t<=1?0:e[a+1]<<8))>>>t&127}function oe(e,r,t){var a=r&7,n=r>>>3,i=(1<<t)-1;var s=e[n]>>>a;if(t<8-a)return s&i;s|=e[n+1]<<8-a;if(t<16-a)return s&i;s|=e[n+2]<<16-a;if(t<24-a)return s&i;s|=e[n+3]<<24-a;return s&i}function ce(e,r){var t=e.length,a=2*t>r?2*t:r+5,n=0;if(t>=r)return e;if(E){var i=C(a);if(e.copy)e.copy(i);else for(;n<e.length;++n)i[n]=e[n];return i}else if(ee){var s=new Uint8Array(a);if(s.set)s.set(e);else for(;n<e.length;++n)s[n]=e[n];return s}e.length=a;return e}function ue(e){var r=new Array(e);for(var t=0;t<e;++t)r[t]=0;return r}var he=function(){var e=function(){return function e(r,t){var a=0;while(a<r.length){var n=Math.min(65535,r.length-a);var i=a+n==r.length;t._W(1,+i);t._W(2,n);t._W(2,~n&65535);while(n-- >0)t[t.l++]=r[a++]}return t.l}}();return function(r){var t=Jr(50+Math.floor(r.length*1.1));var a=e(r,t);return t.slice(0,a)}}();function de(e,r,t){var a=1,n=0,i=0,s=0,f=0,l=e.length;var o=ee?new Uint16Array(32):ue(32);for(i=0;i<32;++i)o[i]=0;for(i=l;i<t;++i)e[i]=0;l=e.length;var c=ee?new Uint16Array(l):ue(l);for(i=0;i<l;++i){o[n=e[i]]++;if(a<n)a=n;c[i]=0}o[0]=0;for(i=1;i<=a;++i)o[i+16]=f=f+o[i-1]<<1;for(i=0;i<l;++i){f=e[i];if(f!=0)c[i]=o[f+16]++}var u=0;for(i=0;i<l;++i){u=e[i];if(u!=0){f=ae(c[i],a)>>a-u;for(s=(1<<a+4-u)-1;s>=0;--s)r[f|s<<u]=u&15|i<<4}}return a}var ve=ee?new Uint16Array(512):ue(512);var pe=ee?new Uint16Array(32):ue(32);if(!ee){for(var be=0;be<512;++be)ve[be]=0;for(be=0;be<32;++be)pe[be]=0}(function(){var e=[];var r=0;for(;r<32;r++)e.push(5);de(e,pe,32);var t=[];r=0;for(;r<=143;r++)t.push(8);for(;r<=255;r++)t.push(9);for(;r<=279;r++)t.push(7);for(;r<=287;r++)t.push(8);de(t,ve,288)})();var me=ee?new Uint16Array(32768):ue(32768);var ge=ee?new Uint16Array(32768):ue(32768);var Ee=ee?new Uint16Array(128):ue(128);var we=1,ke=1;function Se(e,r){var t=fe(e,r)+257;r+=5;var a=fe(e,r)+1;r+=5;var n=se(e,r)+4;r+=4;var i=0;var s=ee?new Uint8Array(19):ue(19);var f=[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0];var l=1;var o=ee?new Uint8Array(8):ue(8);var c=ee?new Uint8Array(8):ue(8);var u=s.length;for(var h=0;h<n;++h){s[Q[h]]=i=ie(e,r);if(l<i)l=i;o[i]++;r+=3}var d=0;o[0]=0;for(h=1;h<=l;++h)c[h]=d=d+o[h-1]<<1;for(h=0;h<u;++h)if((d=s[h])!=0)f[h]=c[d]++;var v=0;for(h=0;h<u;++h){v=s[h];if(v!=0){d=re[f[h]]>>8-v;for(var p=(1<<7-v)-1;p>=0;--p)Ee[d|p<<v]=v&7|h<<3}}var b=[];l=1;for(;b.length<t+a;){d=Ee[le(e,r)];r+=d&7;switch(d>>>=3){case 16:i=3+ne(e,r);r+=2;d=b[b.length-1];while(i-- >0)b.push(d);break;case 17:i=3+ie(e,r);r+=3;while(i-- >0)b.push(0);break;case 18:i=11+le(e,r);r+=7;while(i-- >0)b.push(0);break;default:b.push(d);if(l<d)l=d;break;}}var m=b.slice(0,t),g=b.slice(t);for(h=t;h<286;++h)m[h]=0;for(h=a;h<30;++h)g[h]=0;we=de(m,me,286);ke=de(g,ge,30);return r}function Be(e,r){if(e[0]==3&&!(e[1]&3)){return[B(r),2]}var t=0;var a=0;var n=C(r?r:1<<18);var i=0;var s=n.length>>>0;var f=0,l=0;while((a&1)==0){a=ie(e,t);t+=3;if(a>>>1==0){if(t&7)t+=8-(t&7);var o=e[t>>>3]|e[(t>>>3)+1]<<8;t+=32;if(!r&&s<i+o){n=ce(n,i+o);s=n.length}if(typeof e.copy==="function"){e.copy(n,i,t>>>3,(t>>>3)+o);i+=o;t+=8*o}else while(o-- >0){n[i++]=e[t>>>3];t+=8}continue}else if(a>>>1==1){f=9;l=5}else{t=Se(e,t);f=we;l=ke}if(!r&&s<i+32767){n=ce(n,i+32767);s=n.length}for(;;){var c=oe(e,t,f);var u=a>>>1==1?ve[c]:me[c];t+=u&15;u>>>=4;if((u>>>8&255)===0)n[i++]=u;else if(u==256)break;else{u-=257;var h=u<8?0:u-4>>2;if(h>5)h=0;var d=i+J[u];if(h>0){d+=oe(e,t,h);t+=h}c=oe(e,t,l);u=a>>>1==1?pe[c]:ge[c];t+=u&15;u>>>=4;var v=u<4?0:u-2>>1;var p=Z[u];if(v>0){p+=oe(e,t,v);t+=v}if(!r&&s<d){n=ce(n,d);s=n.length}while(i<d){n[i]=n[i-p];++i}}}}return[r?n:n.slice(0,i),t+7>>>3]}function Ce(e,r){var t=e.slice(e.l||0);var a=Be(t,r);e.l+=a[1];return a[0]}function Te(e,r){if(e){if(typeof console!=="undefined")console.error(r)}else throw new Error(r)}function _e(e,r){var t=e;Yr(t,0);var a=[],n=[];var i={FileIndex:a,FullPaths:n};x(i,{root:r.root});var f=t.length-4;while((t[f]!=80||t[f+1]!=75||t[f+2]!=5||t[f+3]!=6)&&f>=0)--f;t.l=f+4;t.l+=4;var l=t._R(2);t.l+=6;var o=t._R(4);t.l=o;for(f=0;f<l;++f){t.l+=20;var c=t._R(4);var u=t._R(4);var h=t._R(2);var d=t._R(2);var v=t._R(2);t.l+=8;var p=t._R(4);var b=s(t.slice(t.l+h,t.l+h+d));t.l+=h+d+v;var m=t.l;t.l=p+4;xe(t,c,u,i,b);t.l=m}return i}function xe(e,r,t,a,n){e.l+=2;var f=e._R(2);var l=e._R(2);var o=i(e);if(f&8257)throw new Error("Unsupported ZIP encryption");var c=e._R(4);var u=e._R(4);var h=e._R(4);var d=e._R(2);var v=e._R(2);var p="";for(var b=0;b<d;++b)p+=String.fromCharCode(e[e.l++]);if(v){var m=s(e.slice(e.l,e.l+v));if((m[21589]||{}).mt)o=m[21589].mt;if(((n||{})[21589]||{}).mt)o=n[21589].mt}e.l+=v;var g=e.slice(e.l,e.l+u);switch(l){case 8:g=K(e,h);break;case 0:break;default:throw new Error("Unsupported ZIP Compression method "+l);}var E=false;if(f&8){c=e._R(4);if(c==134695760){c=e._R(4);E=true}u=e._R(4);h=e._R(4)}if(u!=r)Te(E,"Bad compressed size: "+r+" != "+u);if(h!=t)Te(E,"Bad uncompressed size: "+t+" != "+h);var w=W.buf(g,0);if(c>>0!=w>>0)Te(E,"Bad CRC32 checksum: "+c+" != "+w);Ie(a,p,g,{unsafe:true,mt:o})}function Ae(e,r){var t=r||{};var a=[],i=[];var s=Jr(1);var f=t.compression?8:0,l=0;var o=false;if(o)l|=8;var c=0,u=0;var h=0,d=0;var v=e.FullPaths[0],p=v,b=e.FileIndex[0];var m=[];var g=0;for(c=1;c<e.FullPaths.length;++c){p=e.FullPaths[c].slice(v.length);b=e.FileIndex[c];if(!b.size||!b.content||p=="Sh33tJ5")continue;var E=h;var w=Jr(p.length);for(u=0;u<p.length;++u)w._W(1,p.charCodeAt(u)&127);w=w.slice(0,w.l);m[d]=W.buf(b.content,0);var k=b.content;if(f==8)k=Y(k);s=Jr(30);s._W(4,67324752);s._W(2,20);s._W(2,l);s._W(2,f);if(b.mt)n(s,b.mt);else s._W(4,0);s._W(-4,l&8?0:m[d]);s._W(4,l&8?0:k.length);s._W(4,l&8?0:b.content.length);s._W(2,w.length);s._W(2,0);h+=s.length;a.push(s);h+=w.length;a.push(w);h+=k.length;a.push(k);if(l&8){s=Jr(12);s._W(-4,m[d]);s._W(4,k.length);s._W(4,b.content.length);h+=s.l;a.push(s)}s=Jr(46);s._W(4,33639248);s._W(2,0);s._W(2,20);s._W(2,l);s._W(2,f);s._W(4,0);s._W(-4,m[d]);s._W(4,k.length);s._W(4,b.content.length);s._W(2,w.length);s._W(2,0);s._W(2,0);s._W(2,0);s._W(2,0);s._W(4,0);s._W(4,E);g+=s.l;i.push(s);g+=w.length;i.push(w);++d}s=Jr(22);s._W(4,101010256);s._W(2,0);s._W(2,0);s._W(2,d);s._W(2,d);s._W(4,g);s._W(4,h);s._W(2,0);return I([I(a),I(i),s])}function ye(e){var r={};x(r,e);return r}function Ie(e,r,t,n){var i=n&&n.unsafe;if(!i)x(e);var s=!i&&V.find(e,r);if(!s){var f=e.FullPaths[0];if(r.slice(0,f.length)==f)f=r;else{if(f.slice(-1)!="/")f+="/";f=(f+r).replace("//","/")}s={name:a(r),type:2};e.FileIndex.push(s);e.FullPaths.push(f);if(!i)V.utils.cfb_gc(e)}s.content=t;s.size=t?t.length:0;if(n){if(n.CLSID)s.clsid=n.CLSID;if(n.mt)s.mt=n.mt;if(n.ct)s.ct=n.ct}return s}function Re(e,r){x(e);var t=V.find(e,r);if(t)for(var a=0;a<e.FileIndex.length;++a)if(e.FileIndex[a]==t){e.FileIndex.splice(a,1);e.FullPaths.splice(a,1);return true}return false}function Fe(e,r,t){x(e);var n=V.find(e,r);if(n)for(var i=0;i<e.FileIndex.length;++i)if(e.FileIndex[i]==n){e.FileIndex[i].name=a(t);e.FullPaths[i]=t;return true}return false}function De(e){y(e,true)}e.find=O;e.read=_;e.parse=o;e.write=z;e.writeFile=X;e.utils={cfb_new:ye,cfb_add:Ie,cfb_del:Re,cfb_mov:Fe,cfb_gc:De,ReadShift:Xr,CheckField:Kr,prep_blob:Yr,bconcat:I,use_zlib:$,_deflateRaw:he,_inflateRaw:Ce,consts:H};return e}();if(typeof require!=="undefined"&&typeof module!=="undefined"&&typeof H==="undefined"){module.exports=V}var X;if(typeof require!=="undefined")try{X=require("fs")}catch(S){}function G(e){if(typeof e==="string")return _(e);if(Array.isArray(e))return A(e);return e}function z(e,r,t){if(typeof X!=="undefined"&&X.writeFileSync)return t?X.writeFileSync(e,r,t):X.writeFileSync(e,r);var a=t=="utf8"?Qe(r):r;if(typeof IE_SaveFile!=="undefined")return IE_SaveFile(a,e);if(typeof Blob!=="undefined"){var n=new Blob([G(a)],{type:"application/octet-stream"});if(typeof navigator!=="undefined"&&navigator.msSaveBlob)return navigator.msSaveBlob(n,e);if(typeof saveAs!=="undefined")return saveAs(n,e);if(typeof URL!=="undefined"&&typeof document!=="undefined"&&document.createElement&&URL.createObjectURL){var i=URL.createObjectURL(n);if(typeof chrome==="object"&&typeof(chrome.downloads||{}).download=="function"){if(URL.revokeObjectURL&&typeof setTimeout!=="undefined")setTimeout(function(){URL.revokeObjectURL(i)},6e4);return chrome.downloads.download({url:i,filename:e,saveAs:true})}var s=document.createElement("a");if(s.download!=null){s.download=e;s.href=i;document.body.appendChild(s);s.click();document.body.removeChild(s);if(URL.revokeObjectURL&&typeof setTimeout!=="undefined")setTimeout(function(){URL.revokeObjectURL(i)},6e4);return i}}}if(typeof $!=="undefined"&&typeof File!=="undefined"&&typeof Folder!=="undefined")try{var f=File(e);f.open("w");f.encoding="binary";if(Array.isArray(r))r=x(r);f.write(r);f.close();return r}catch(l){if(!l.message||!l.message.match(/onstruct/))throw l}throw new Error("cannot save file "+e)}function j(e){if(typeof X!=="undefined")return X.readFileSync(e);if(typeof $!=="undefined"&&typeof File!=="undefined"&&typeof Folder!=="undefined")try{var r=File(e);r.open("r");r.encoding="binary";var t=r.read();r.close();return t}catch(a){if(!a.message||!a.message.match(/onstruct/))throw a}throw new Error("Cannot access file "+e)}function K(e){var r=Object.keys(e),t=[];for(var a=0;a<r.length;++a)if(Object.prototype.hasOwnProperty.call(e,r[a]))t.push(r[a]);return t}function Y(e,r){var t=[],a=K(e);for(var n=0;n!==a.length;++n)if(t[e[a[n]][r]]==null)t[e[a[n]][r]]=a[n];return t}function Q(e){var r=[],t=K(e);for(var a=0;a!==t.length;++a)r[e[t[a]]]=t[a];return r}function J(e){var r=[],t=K(e);for(var a=0;a!==t.length;++a)r[e[t[a]]]=parseInt(t[a],10);return r}function Z(e){var r=[],t=K(e);for(var a=0;a!==t.length;++a){if(r[e[t[a]]]==null)r[e[t[a]]]=[];r[e[t[a]]].push(t[a])}return r}var q=new Date(1899,11,30,0,0,0);function ee(e,r){var t=e.getTime();if(r)t-=1462*24*60*60*1e3;var a=q.getTime()+(e.getTimezoneOffset()-q.getTimezoneOffset())*6e4;return(t-a)/(24*60*60*1e3)}var re=new Date;var te=q.getTime()+(re.getTimezoneOffset()-q.getTimezoneOffset())*6e4;var ae=re.getTimezoneOffset();function ne(e){var r=new Date;r.setTime(e*24*60*60*1e3+te);if(r.getTimezoneOffset()!==ae){r.setTime(r.getTime()+(r.getTimezoneOffset()-ae)*6e4)}return r}function ie(e){var r=0,t=0,a=false;var n=e.match(/P([0-9\.]+Y)?([0-9\.]+M)?([0-9\.]+D)?T([0-9\.]+H)?([0-9\.]+M)?([0-9\.]+S)?/);if(!n)throw new Error("|"+e+"| is not an ISO8601 Duration");for(var i=1;i!=n.length;++i){if(!n[i])continue;t=1;if(i>3)a=true;switch(n[i].slice(n[i].length-1)){case"Y":throw new Error("Unsupported ISO Duration Field: "+n[i].slice(n[i].length-1));case"D":t*=24;case"H":t*=60;case"M":if(!a)throw new Error("Unsupported ISO Duration Field: M");else t*=60;case"S":break;}r+=t*parseInt(n[i],10)}return r}var se=new Date("2017-02-19T19:06:09.000Z");if(isNaN(se.getFullYear()))se=new Date("2/19/17");var fe=se.getFullYear()==2017;function le(e,r){var t=new Date(e);if(fe){if(r>0)t.setTime(t.getTime()+t.getTimezoneOffset()*60*1e3);else if(r<0)t.setTime(t.getTime()-t.getTimezoneOffset()*60*1e3);return t}if(e instanceof Date)return e;if(se.getFullYear()==1917&&!isNaN(t.getFullYear())){var a=t.getFullYear();if(e.indexOf(""+a)>-1)return t;t.setFullYear(t.getFullYear()+100);return t}var n=e.match(/\d+/g)||["2017","2","19","0","0","0"];var i=new Date(+n[0],+n[1]-1,+n[2],+n[3]||0,+n[4]||0,+n[5]||0);if(e.indexOf("Z")>-1)i=new Date(i.getTime()-i.getTimezoneOffset()*60*1e3);return i}function oe(e){var r="";for(var t=0;t!=e.length;++t)r+=String.fromCharCode(e[t]);return r}function ce(e){if(typeof JSON!="undefined"&&!Array.isArray(e))return JSON.parse(JSON.stringify(e));if(typeof e!="object"||e==null)return e;if(e instanceof Date)return new Date(e.getTime());var r={};for(var t in e)if(Object.prototype.hasOwnProperty.call(e,t))r[t]=ce(e[t]);return r}function ue(e,r){var t="";while(t.length<r)t+=e;return t}function he(e){var r=Number(e);if(isFinite(r))return r;if(!isNaN(r))return NaN;if(!/\d/.test(e))return r;var t=1;var a=e.replace(/([\d]),([\d])/g,"$1$2").replace(/[$]/g,"").replace(/[%]/g,function(){t*=100;return""});if(!isNaN(r=Number(a)))return r/t;a=a.replace(/[(](.*)[)]/,function(e,r){t=-t;return r});if(!isNaN(r=Number(a)))return r/t;return r}function de(e){var r=new Date(e),t=new Date(NaN);var a=r.getYear(),n=r.getMonth(),i=r.getDate();if(isNaN(i))return t;if(a<0||a>8099)return t;if((n>0||i>1)&&a!=101)return r;if(e.toLowerCase().match(/jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec/))return r;if(e.match(/[^-0-9:,\/\\]/))return t;return r}var ve="abacaba".split(/(:?b)/i).length==5;function pe(e,r,t){if(ve||typeof r=="string")return e.split(r);var a=e.split(r),n=[a[0]];for(var i=1;i<a.length;++i){n.push(t);n.push(a[i])}return n}function be(e){if(!e)return null;if(e.data)return d(e.data);if(e.asNodeBuffer&&E)return d(e.asNodeBuffer().toString("binary"));if(e.asBinary)return d(e.asBinary());if(e._data&&e._data.getContent)return d(oe(Array.prototype.slice.call(e._data.getContent(),0)));if(e.content&&e.type)return d(oe(e.content));return null}function me(e){if(!e)return null;if(e.data)return c(e.data);if(e.asNodeBuffer&&E)return e.asNodeBuffer();if(e._data&&e._data.getContent){var r=e._data.getContent();if(typeof r=="string")return c(r);return Array.prototype.slice.call(r)}if(e.content&&e.type)return e.content;return null}function ge(e){return e&&e.name.slice(-4)===".bin"?me(e):be(e)}function Ee(e,r){var t=e.FullPaths||K(e.files);var a=r.toLowerCase().replace(/[\/]/g,"\\"),n=a.replace(/\\/g,"/");for(var i=0;i<t.length;++i){var s=t[i].replace(/^Root Entry[\/]/,"").toLowerCase();if(a==s||n==s)return e.files?e.files[t[i]]:e.FileIndex[i]}return null}function we(e,r){var t=Ee(e,r);if(t==null)throw new Error("Cannot find file "+r+" in zip");return t}function ke(e,r,t){if(!t)return ge(we(e,r));if(!r)return null;try{return ke(e,r)}catch(a){return null}}function Se(e,r,t){if(!t)return be(we(e,r));if(!r)return null;try{return Se(e,r)}catch(a){return null}}function Be(e){var r=e.FullPaths||K(e.files),t=[];for(var a=0;a<r.length;++a)if(r[a].slice(-1)!="/")t.push(r[a]);return t.sort()}function Ce(e,r,t){if(e.FullPaths)V.utils.cfb_add(e,r,t);else e.file(r,t)}var Te;if(typeof JSZipSync!=="undefined")Te=JSZipSync;if(typeof exports!=="undefined"){if(typeof module!=="undefined"&&module.exports){if(typeof Te==="undefined")Te=undefined}}function _e(){if(!Te)return V.utils.cfb_new();return new Te}function xe(e,r){var t;if(Te)switch(r.type){case"base64":t=new Te(e,{base64:true});break;case"binary":;case"array":t=new Te(e,{base64:false});break;case"buffer":t=new Te(e);break;default:throw new Error("Unrecognized type "+r.type);}else switch(r.type){case"base64":t=V.read(e,{type:"base64"});break;case"binary":t=V.read(e,{type:"binary"});break;case"buffer":;case"array":t=V.read(e,{type:"buffer"});break;default:throw new Error("Unrecognized type "+r.type);}return t}function Ae(e,r){if(e.charAt(0)=="/")return e.slice(1);var t=r.split("/");if(r.slice(-1)!="/")t.pop();var a=e.split("/");while(a.length!==0){var n=a.shift();if(n==="..")t.pop();else if(n!==".")t.push(n)}return t.join("/")}var ye='<?xml version="1.0" encoding="UTF-8" standalone="yes"?>\r\n';var Ie=/([^"\s?>\/]+)\s*=\s*((?:")([^"]*)(?:")|(?:')([^']*)(?:')|([^'">\s]+))/g;var Re=/<[\/\?]?[a-zA-Z0-9:_-]+(?:\s+[^"\s?>\/]+\s*=\s*(?:"[^"]*"|'[^']*'|[^'">\s=]+))*\s*[\/\?]?>/gm;if(!ye.match(Re))Re=/<[^>]*>/g;var Fe=/<\w*:/,De=/<(\/?)\w+:/;function Oe(e,r,t){var a={};var n=0,i=0;for(;n!==e.length;++n)if((i=e.charCodeAt(n))===32||i===10||i===13)break;if(!r)a[0]=e.slice(0,n);if(n===e.length)return a;var s=e.match(Ie),f=0,l="",o=0,c="",u="",h=1;if(s)for(o=0;o!=s.length;++o){u=s[o];for(i=0;i!=u.length;++i)if(u.charCodeAt(i)===61)break;c=u.slice(0,i).trim();while(u.charCodeAt(i+1)==32)++i;h=(n=u.charCodeAt(i+1))==34||n==39?1:0;l=u.slice(i+1+h,u.length-h);for(f=0;f!=c.length;++f)if(c.charCodeAt(f)===58)break;if(f===c.length){if(c.indexOf("_")>0)c=c.slice(0,c.indexOf("_"));a[c]=l;if(!t)a[c.toLowerCase()]=l}else{var d=(f===5&&c.slice(0,5)==="xmlns"?"xmlns":"")+c.slice(f+1);if(a[d]&&c.slice(f-3,f)=="ext")continue;a[d]=l;if(!t)a[d.toLowerCase()]=l}}return a}function Pe(e){return e.replace(De,"<$1")}var Ne={"&quot;":'"',"&apos;":"'","&gt;":">","&lt;":"<","&amp;":"&"};var Me=Q(Ne);var Le=function(){var e=/&(?:quot|apos|gt|lt|amp|#x?([\da-fA-F]+));/gi,r=/_x([\da-fA-F]{4})_/gi;return function t(a){var n=a+"",i=n.indexOf("<![CDATA[");if(i==-1)return n.replace(e,function(e,r){return Ne[e]||String.fromCharCode(parseInt(r,e.indexOf("x")>-1?16:10))||e}).replace(r,function(e,r){return String.fromCharCode(parseInt(r,16))});var s=n.indexOf("]]>");return t(n.slice(0,i))+n.slice(i+9,s)+t(n.slice(s+3))}}();var Ue=/[&<>'"]/g,He=/[\u0000-\u0008\u000b-\u001f]/g;function We(e){var r=e+"";return r.replace(Ue,function(e){return Me[e]}).replace(He,function(e){return"_x"+("000"+e.charCodeAt(0).toString(16)).slice(-4)+"_"})}function Ve(e){return We(e).replace(/ /g,"_x0020_")}var Xe=/[\u0000-\u001f]/g;function Ge(e){var r=e+"";return r.replace(Ue,function(e){return Me[e]}).replace(/\n/g,"<br/>").replace(Xe,function(e){return"&#x"+("000"+e.charCodeAt(0).toString(16)).slice(-4)+";"})}function ze(e){var r=e+"";return r.replace(Ue,function(e){return Me[e]}).replace(Xe,function(e){return"&#x"+e.charCodeAt(0).toString(16).toUpperCase()+";"})}var je=function(){var e=/&#(\d+);/g;function r(e,r){return String.fromCharCode(parseInt(r,10))}return function t(a){return a.replace(e,r)}}();var $e=function(){return function e(r){return r.replace(/(\r\n|[\r\n])/g,"&#10;")}}();function Ke(e){switch(e){case 1:;case true:;case"1":;case"true":;case"TRUE":return true;default:return false;}}var Ye=function Um(e){var r="",t=0,a=0,n=0,i=0,s=0,f=0;while(t<e.length){a=e.charCodeAt(t++);if(a<128){r+=String.fromCharCode(a);
continue}n=e.charCodeAt(t++);if(a>191&&a<224){s=(a&31)<<6;s|=n&63;r+=String.fromCharCode(s);continue}i=e.charCodeAt(t++);if(a<240){r+=String.fromCharCode((a&15)<<12|(n&63)<<6|i&63);continue}s=e.charCodeAt(t++);f=((a&7)<<18|(n&63)<<12|(i&63)<<6|s&63)-65536;r+=String.fromCharCode(55296+(f>>>10&1023));r+=String.fromCharCode(56320+(f&1023))}return r};var Qe=function(e){var r=[],t=0,a=0,n=0;while(t<e.length){a=e.charCodeAt(t++);switch(true){case a<128:r.push(String.fromCharCode(a));break;case a<2048:r.push(String.fromCharCode(192+(a>>6)));r.push(String.fromCharCode(128+(a&63)));break;case a>=55296&&a<57344:a-=55296;n=e.charCodeAt(t++)-56320+(a<<10);r.push(String.fromCharCode(240+(n>>18&7)));r.push(String.fromCharCode(144+(n>>12&63)));r.push(String.fromCharCode(128+(n>>6&63)));r.push(String.fromCharCode(128+(n&63)));break;default:r.push(String.fromCharCode(224+(a>>12)));r.push(String.fromCharCode(128+(a>>6&63)));r.push(String.fromCharCode(128+(a&63)));}}return r.join("")};if(E){var Je=function Hm(e){var r=Buffer.alloc(2*e.length),t,a,n=1,i=0,s=0,f;for(a=0;a<e.length;a+=n){n=1;if((f=e.charCodeAt(a))<128)t=f;else if(f<224){t=(f&31)*64+(e.charCodeAt(a+1)&63);n=2}else if(f<240){t=(f&15)*4096+(e.charCodeAt(a+1)&63)*64+(e.charCodeAt(a+2)&63);n=3}else{n=4;t=(f&7)*262144+(e.charCodeAt(a+1)&63)*4096+(e.charCodeAt(a+2)&63)*64+(e.charCodeAt(a+3)&63);t-=65536;s=55296+(t>>>10&1023);t=56320+(t&1023)}if(s!==0){r[i++]=s&255;r[i++]=s>>>8;s=0}r[i++]=t%256;r[i++]=t>>>8}return r.slice(0,i).toString("ucs2")};var Ze="foo bar bazâð£";if(Ye(Ze)==Je(Ze))Ye=Je;var qe=function Wm(e){return w(e,"binary").toString("utf8")};if(Ye(Ze)==qe(Ze))Ye=qe;Qe=function(e){return w(e,"utf8").toString("binary")}}var er=function(){var e={};return function r(t,a){var n=t+"|"+(a||"");if(e[n])return e[n];return e[n]=new RegExp("<(?:\\w+:)?"+t+'(?: xml:space="preserve")?(?:[^>]*)>([\\s\\S]*?)</(?:\\w+:)?'+t+">",a||"")}}();var rr=function(){var e=[["nbsp"," "],["middot","·"],["quot",'"'],["apos","'"],["gt",">"],["lt","<"],["amp","&"]].map(function(e){return[new RegExp("&"+e[0]+";","ig"),e[1]]});return function r(t){var a=t.replace(/^[\t\n\r ]+/,"").replace(/[\t\n\r ]+$/,"").replace(/>\s+/g,">").replace(/\s+</g,"<").replace(/[\t\n\r ]+/g," ").replace(/<\s*[bB][rR]\s*\/?>/g,"\n").replace(/<[^>]*>/g,"");for(var n=0;n<e.length;++n)a=a.replace(e[n][0],e[n][1]);return a}}();var tr=function(){var e={};return function r(t){if(e[t]!==undefined)return e[t];return e[t]=new RegExp("<(?:vt:)?"+t+">([\\s\\S]*?)</(?:vt:)?"+t+">","g")}}();var ar=/<\/?(?:vt:)?variant>/g,nr=/<(?:vt:)([^>]*)>([\s\S]*)</;function ir(e,r){var t=Oe(e);var a=e.match(tr(t.baseType))||[];var n=[];if(a.length!=t.size){if(r.WTF)throw new Error("unexpected vector length "+a.length+" != "+t.size);return n}a.forEach(function(e){var r=e.replace(ar,"").match(nr);if(r)n.push({v:Ye(r[2]),t:r[1]})});return n}var sr=/(^\s|\s$|\n)/;function fr(e,r){return"<"+e+(r.match(sr)?' xml:space="preserve"':"")+">"+r+"</"+e+">"}function lr(e){return K(e).map(function(r){return" "+r+'="'+e[r]+'"'}).join("")}function or(e,r,t){return"<"+e+(t!=null?lr(t):"")+(r!=null?(r.match(sr)?' xml:space="preserve"':"")+">"+r+"</"+e:"/")+">"}function cr(e,r){try{return e.toISOString().replace(/\.\d*/,"")}catch(t){if(r)throw t}return""}function ur(e,r){switch(typeof e){case"string":var t=or("vt:lpwstr",We(e));if(r)t=t.replace(/&quot;/g,"_x0022_");return t;case"number":return or((e|0)==e?"vt:i4":"vt:r8",We(String(e)));case"boolean":return or("vt:bool",e?"true":"false");}if(e instanceof Date)return or("vt:filetime",cr(e));throw new Error("Unable to serialize "+e)}var hr={dc:"http://purl.org/dc/elements/1.1/",dcterms:"http://purl.org/dc/terms/",dcmitype:"http://purl.org/dc/dcmitype/",mx:"http://schemas.microsoft.com/office/mac/excel/2008/main",r:"http://schemas.openxmlformats.org/officeDocument/2006/relationships",sjs:"http://schemas.openxmlformats.org/package/2006/sheetjs/core-properties",vt:"http://schemas.openxmlformats.org/officeDocument/2006/docPropsVTypes",xsi:"http://www.w3.org/2001/XMLSchema-instance",xsd:"http://www.w3.org/2001/XMLSchema"};hr.main=["http://schemas.openxmlformats.org/spreadsheetml/2006/main","http://purl.oclc.org/ooxml/spreadsheetml/main","http://schemas.microsoft.com/office/excel/2006/main","http://schemas.microsoft.com/office/excel/2006/2"];var dr={o:"urn:schemas-microsoft-com:office:office",x:"urn:schemas-microsoft-com:office:excel",ss:"urn:schemas-microsoft-com:office:spreadsheet",dt:"uuid:C2F41010-65B3-11d1-A29F-00AA00C14882",mv:"http://macVmlSchemaUri",v:"urn:schemas-microsoft-com:vml",html:"http://www.w3.org/TR/REC-html40"};function vr(e,r){var t=1-2*(e[r+7]>>>7);var a=((e[r+7]&127)<<4)+(e[r+6]>>>4&15);var n=e[r+6]&15;for(var i=5;i>=0;--i)n=n*256+e[r+i];if(a==2047)return n==0?t*Infinity:NaN;if(a==0)a=-1022;else{a-=1023;n+=Math.pow(2,52)}return t*Math.pow(2,a-52)*n}function pr(e,r,t){var a=(r<0||1/r==-Infinity?1:0)<<7,n=0,i=0;var s=a?-r:r;if(!isFinite(s)){n=2047;i=isNaN(r)?26985:0}else if(s==0)n=i=0;else{n=Math.floor(Math.log(s)/Math.LN2);i=s*Math.pow(2,52-n);if(n<=-1023&&(!isFinite(i)||i<Math.pow(2,52))){n=-1022}else{i-=Math.pow(2,52);n+=1023}}for(var f=0;f<=5;++f,i/=256)e[t+f]=i&255;e[t+6]=(n&15)<<4|i&15;e[t+7]=n>>4|a}var br=function(e){var r=[],t=10240;for(var a=0;a<e[0].length;++a)if(e[0][a])for(var n=0,i=e[0][a].length;n<i;n+=t)r.push.apply(r,e[0][a].slice(n,n+t));return r};var mr=br;var gr=function(e,r,t){var a=[];for(var n=r;n<t;n+=2)a.push(String.fromCharCode(Lr(e,n)));return a.join("").replace(R,"")};var Er=gr;var wr=function(e,r,t){var a=[];for(var n=r;n<r+t;++n)a.push(("0"+e[n].toString(16)).slice(-2));return a.join("")};var kr=wr;var Sr=function(e,r,t){var a=[];for(var n=r;n<t;n++)a.push(String.fromCharCode(Mr(e,n)));return a.join("")};var Br=Sr;var Cr=function(e,r){var t=Hr(e,r);return t>0?Sr(e,r+4,r+4+t-1):""};var Tr=Cr;var _r=function(e,r){var t=Hr(e,r);return t>0?Sr(e,r+4,r+4+t-1):""};var xr=_r;var Ar=function(e,r){var t=2*Hr(e,r);return t>0?Sr(e,r+4,r+4+t-1):""};var yr=Ar;var Ir,Rr;Ir=Rr=function Vm(e,r){var t=Hr(e,r);return t>0?gr(e,r+4,r+4+t):""};var Fr=function(e,r){var t=Hr(e,r);return t>0?Sr(e,r+4,r+4+t):""};var Dr=Fr;var Or,Pr;Or=Pr=function(e,r){return vr(e,r)};var Nr=function Xm(e){return Array.isArray(e)};if(E){gr=function(e,r,t){if(!Buffer.isBuffer(e))return Er(e,r,t);return e.toString("utf16le",r,t).replace(R,"")};wr=function(e,r,t){return Buffer.isBuffer(e)?e.toString("hex",r,r+t):kr(e,r,t)};Cr=function Gm(e,r){if(!Buffer.isBuffer(e))return Tr(e,r);var t=e.readUInt32LE(r);return t>0?e.toString("utf8",r+4,r+4+t-1):""};_r=function zm(e,r){if(!Buffer.isBuffer(e))return xr(e,r);var t=e.readUInt32LE(r);return t>0?e.toString("utf8",r+4,r+4+t-1):""};Ar=function jm(e,r){if(!Buffer.isBuffer(e))return yr(e,r);var t=2*e.readUInt32LE(r);return e.toString("utf16le",r+4,r+4+t-1)};Ir=function $m(e,r){if(!Buffer.isBuffer(e))return Rr(e,r);var t=e.readUInt32LE(r);return e.toString("utf16le",r+4,r+4+t)};Fr=function Km(e,r){if(!Buffer.isBuffer(e))return Dr(e,r);var t=e.readUInt32LE(r);return e.toString("utf8",r+4,r+4+t)};Sr=function Ym(e,r,t){return Buffer.isBuffer(e)?e.toString("utf8",r,t):Br(e,r,t)};br=function(e){return e[0].length>0&&Buffer.isBuffer(e[0][0])?Buffer.concat(e[0]):mr(e)};I=function(e){return Buffer.isBuffer(e[0])?Buffer.concat(e):[].concat.apply([],e)};Or=function Qm(e,r){if(Buffer.isBuffer(e))return e.readDoubleLE(r);return Pr(e,r)};Nr=function Jm(e){return Buffer.isBuffer(e)||Array.isArray(e)}}if(typeof cptable!=="undefined"){gr=function(e,r,t){return cptable.utils.decode(1200,e.slice(r,t)).replace(R,"")};Sr=function(e,r,t){return cptable.utils.decode(65001,e.slice(r,t))};Cr=function(e,r){var a=Hr(e,r);return a>0?cptable.utils.decode(t,e.slice(r+4,r+4+a-1)):""};_r=function(e,t){var a=Hr(e,t);return a>0?cptable.utils.decode(r,e.slice(t+4,t+4+a-1)):""};Ar=function(e,r){var t=2*Hr(e,r);return t>0?cptable.utils.decode(1200,e.slice(r+4,r+4+t-1)):""};Ir=function(e,r){var t=Hr(e,r);return t>0?cptable.utils.decode(1200,e.slice(r+4,r+4+t)):""};Fr=function(e,r){var t=Hr(e,r);return t>0?cptable.utils.decode(65001,e.slice(r+4,r+4+t)):""}}var Mr=function(e,r){return e[r]};var Lr=function(e,r){return e[r+1]*(1<<8)+e[r]};var Ur=function(e,r){var t=e[r+1]*(1<<8)+e[r];return t<32768?t:(65535-t+1)*-1};var Hr=function(e,r){return e[r+3]*(1<<24)+(e[r+2]<<16)+(e[r+1]<<8)+e[r]};var Wr=function(e,r){return e[r+3]<<24|e[r+2]<<16|e[r+1]<<8|e[r]};var Vr=function(e,r){return e[r]<<24|e[r+1]<<16|e[r+2]<<8|e[r+3]};function Xr(e,t){var a="",n,i,s=[],f,l,o,c;switch(t){case"dbcs":c=this.l;if(E&&Buffer.isBuffer(this))a=this.slice(this.l,this.l+2*e).toString("utf16le");else for(o=0;o<e;++o){a+=String.fromCharCode(Lr(this,c));c+=2}e*=2;break;case"utf8":a=Sr(this,this.l,this.l+e);break;case"utf16le":e*=2;a=gr(this,this.l,this.l+e);break;case"wstr":if(typeof cptable!=="undefined")a=cptable.utils.decode(r,this.slice(this.l,this.l+2*e));else return Xr.call(this,e,"dbcs");e=2*e;break;case"lpstr-ansi":a=Cr(this,this.l);e=4+Hr(this,this.l);break;case"lpstr-cp":a=_r(this,this.l);e=4+Hr(this,this.l);break;case"lpwstr":a=Ar(this,this.l);e=4+2*Hr(this,this.l);break;case"lpp4":e=4+Hr(this,this.l);a=Ir(this,this.l);if(e&2)e+=2;break;case"8lpp4":e=4+Hr(this,this.l);a=Fr(this,this.l);if(e&3)e+=4-(e&3);break;case"cstr":e=0;a="";while((f=Mr(this,this.l+e++))!==0)s.push(v(f));a=s.join("");break;case"_wstr":e=0;a="";while((f=Lr(this,this.l+e))!==0){s.push(v(f));e+=2}e+=2;a=s.join("");break;case"dbcs-cont":a="";c=this.l;for(o=0;o<e;++o){if(this.lens&&this.lens.indexOf(c)!==-1){f=Mr(this,c);this.l=c+1;l=Xr.call(this,e-o,f?"dbcs-cont":"sbcs-cont");return s.join("")+l}s.push(v(Lr(this,c)));c+=2}a=s.join("");e*=2;break;case"cpstr":if(typeof cptable!=="undefined"){a=cptable.utils.decode(r,this.slice(this.l,this.l+e));break};case"sbcs-cont":a="";c=this.l;for(o=0;o!=e;++o){if(this.lens&&this.lens.indexOf(c)!==-1){f=Mr(this,c);this.l=c+1;l=Xr.call(this,e-o,f?"dbcs-cont":"sbcs-cont");return s.join("")+l}s.push(v(Mr(this,c)));c+=1}a=s.join("");break;default:switch(e){case 1:n=Mr(this,this.l);this.l++;return n;case 2:n=(t==="i"?Ur:Lr)(this,this.l);this.l+=2;return n;case 4:;case-4:if(t==="i"||(this[this.l+3]&128)===0){n=(e>0?Wr:Vr)(this,this.l);this.l+=4;return n}else{i=Hr(this,this.l);this.l+=4}return i;case 8:;case-8:if(t==="f"){if(e==8)i=Or(this,this.l);else i=Or([this[this.l+7],this[this.l+6],this[this.l+5],this[this.l+4],this[this.l+3],this[this.l+2],this[this.l+1],this[this.l+0]],0);this.l+=8;return i}else e=8;case 16:a=wr(this,this.l,e);break;};}this.l+=e;return a}var Gr=function(e,r,t){e[t]=r&255;e[t+1]=r>>>8&255;e[t+2]=r>>>16&255;e[t+3]=r>>>24&255};var zr=function(e,r,t){e[t]=r&255;e[t+1]=r>>8&255;e[t+2]=r>>16&255;e[t+3]=r>>24&255};var jr=function(e,r,t){e[t]=r&255;e[t+1]=r>>>8&255};function $r(e,r,a){var n=0,i=0;if(a==="dbcs"){for(i=0;i!=r.length;++i)jr(this,r.charCodeAt(i),this.l+2*i);n=2*r.length}else if(a==="sbcs"){if(typeof cptable!=="undefined"&&t==874){for(i=0;i!=r.length;++i){var s=cptable.utils.encode(t,r.charAt(i));this[this.l+i]=s[0]}}else{r=r.replace(/[^\x00-\x7F]/g,"_");for(i=0;i!=r.length;++i)this[this.l+i]=r.charCodeAt(i)&255}n=r.length}else if(a==="hex"){for(;i<e;++i){this[this.l++]=parseInt(r.slice(2*i,2*i+2),16)||0}return this}else if(a==="utf16le"){var f=Math.min(this.l+e,this.length);for(i=0;i<Math.min(r.length,e);++i){var l=r.charCodeAt(i);this[this.l++]=l&255;this[this.l++]=l>>8}while(this.l<f)this[this.l++]=0;return this}else switch(e){case 1:n=1;this[this.l]=r&255;break;case 2:n=2;this[this.l]=r&255;r>>>=8;this[this.l+1]=r&255;break;case 3:n=3;this[this.l]=r&255;r>>>=8;this[this.l+1]=r&255;r>>>=8;this[this.l+2]=r&255;break;case 4:n=4;Gr(this,r,this.l);break;case 8:n=8;if(a==="f"){pr(this,r,this.l);break};case 16:break;case-4:n=4;zr(this,r,this.l);break;}this.l+=n;return this}function Kr(e,r){var t=wr(this,this.l,e.length>>1);if(t!==e)throw new Error(r+"Expected "+e+" saw "+t);this.l+=e.length>>1}function Yr(e,r){e.l=r;e._R=Xr;e.chk=Kr;e._W=$r}function Qr(e,r){e.l+=r}function Jr(e){var r=B(e);Yr(r,0);return r}function Zr(e,r,t){if(!e)return;var a,n,i;Yr(e,e.l||0);var s=e.length,f=0,l=0;while(e.l<s){f=e._R(1);if(f&128)f=(f&127)+((e._R(1)&127)<<7);var o=Zp[f]||Zp[65535];a=e._R(1);i=a&127;for(n=1;n<4&&a&128;++n)i+=((a=e._R(1))&127)<<7*n;l=e.l+i;var c=o.f&&o.f(e,i,t);e.l=l;if(r(c,o.n,f))return}}function qr(){var e=[],r=E?256:2048;var t=function l(e){var r=Jr(e);Yr(r,0);return r};var a=t(r);var n=function o(){if(!a)return;if(a.length>a.l){a=a.slice(0,a.l);a.l=a.length}if(a.length>0)e.push(a);a=null};var i=function c(e){if(a&&e<a.length-a.l)return a;n();return a=t(Math.max(e+1,r))};var s=function u(){n();return br([e])};var f=function h(e){n();a=e;if(a.l==null)a.l=a.length;i(r)};return{next:i,push:f,end:s,_bufs:e}}function et(e,r,t,a){var n=+qp[r],i;if(isNaN(n))return;if(!a)a=Zp[n].p||(t||[]).length||0;i=1+(n>=128?1:0)+1;if(a>=128)++i;if(a>=16384)++i;if(a>=2097152)++i;var s=e.next(i);if(n<=127)s._W(1,n);else{s._W(1,(n&127)+128);s._W(1,n>>7)}for(var f=0;f!=4;++f){if(a>=128){s._W(1,(a&127)+128);a>>=7}else{s._W(1,a);break}}if(a>0&&Nr(t))e.push(t)}function rt(e,r,t){var a=ce(e);if(r.s){if(a.cRel)a.c+=r.s.c;if(a.rRel)a.r+=r.s.r}else{if(a.cRel)a.c+=r.c;if(a.rRel)a.r+=r.r}if(!t||t.biff<12){while(a.c>=256)a.c-=256;while(a.r>=65536)a.r-=65536}return a}function tt(e,r,t){var a=ce(e);a.s=rt(a.s,r.s,t);a.e=rt(a.e,r.s,t);return a}function at(e,r){if(e.cRel&&e.c<0){e=ce(e);while(e.c<0)e.c+=r>8?16384:256}if(e.rRel&&e.r<0){e=ce(e);while(e.r<0)e.r+=r>8?1048576:r>5?65536:16384}var t=mt(e);if(!e.cRel&&e.cRel!=null)t=dt(t);if(!e.rRel&&e.rRel!=null)t=ot(t);return t}function nt(e,r){if(e.s.r==0&&!e.s.rRel){if(e.e.r==(r.biff>=12?1048575:r.biff>=8?65536:16384)&&!e.e.rRel){return(e.s.cRel?"":"$")+ht(e.s.c)+":"+(e.e.cRel?"":"$")+ht(e.e.c)}}if(e.s.c==0&&!e.s.cRel){if(e.e.c==(r.biff>=12?16383:255)&&!e.e.cRel){return(e.s.rRel?"":"$")+lt(e.s.r)+":"+(e.e.rRel?"":"$")+lt(e.e.r)}}return at(e.s,r.biff)+":"+at(e.e,r.biff)}var it={};var st=function(e,r){var t;if(typeof r!=="undefined")t=r;else if(typeof require!=="undefined"){try{t=undefined}catch(a){t=null}}e.rc4=function(e,r){var t=new Array(256);var a=0,n=0,i=0,s=0;for(n=0;n!=256;++n)t[n]=n;for(n=0;n!=256;++n){i=i+t[n]+e[n%e.length].charCodeAt(0)&255;s=t[n];t[n]=t[i];t[i]=s}n=i=0;var f=B(r.length);for(a=0;a!=r.length;++a){n=n+1&255;i=(i+t[n])%256;s=t[n];t[n]=t[i];t[i]=s;f[a]=r[a]^t[t[n]+t[i]&255]}return f};e.md5=function(e){if(!t)throw new Error("Unsupported crypto");return t.createHash("md5").update(e).digest("hex")}};st(it,typeof crypto!=="undefined"?crypto:undefined);function ft(e){return parseInt(ct(e),10)-1}function lt(e){return""+(e+1)}function ot(e){return e.replace(/([A-Z]|^)(\d+)$/,"$1$$$2")}function ct(e){return e.replace(/\$(\d+)$/,"$1")}function ut(e){var r=vt(e),t=0,a=0;for(;a!==r.length;++a)t=26*t+r.charCodeAt(a)-64;return t-1}function ht(e){if(e<0)throw new Error("invalid column "+e);var r="";for(++e;e;e=Math.floor((e-1)/26))r=String.fromCharCode((e-1)%26+65)+r;return r}function dt(e){return e.replace(/^([A-Z])/,"$$$1")}function vt(e){return e.replace(/^\$([A-Z])/,"$1")}function pt(e){return e.replace(/(\$?[A-Z]*)(\$?\d*)/,"$1,$2").split(",")}function bt(e){var r=0,t=0;for(var a=0;a<e.length;++a){var n=e.charCodeAt(a);if(n>=48&&n<=57)r=10*r+(n-48);else if(n>=65&&n<=90)t=26*t+(n-64)}return{c:t-1,r:r-1}}function mt(e){var r=e.c+1;var t="";for(;r;r=(r-1)/26|0)t=String.fromCharCode((r-1)%26+65)+t;return t+(e.r+1)}function gt(e){var r=e.indexOf(":");if(r==-1)return{s:bt(e),e:bt(e)};return{s:bt(e.slice(0,r)),e:bt(e.slice(r+1))}}function Et(e,r){if(typeof r==="undefined"||typeof r==="number"){return Et(e.s,e.e)}if(typeof e!=="string")e=mt(e);if(typeof r!=="string")r=mt(r);return e==r?e:e+":"+r}function wt(e){var r={s:{c:0,r:0},e:{c:0,r:0}};var t=0,a=0,n=0;var i=e.length;for(t=0;a<i;++a){if((n=e.charCodeAt(a)-64)<1||n>26)break;t=26*t+n}r.s.c=--t;for(t=0;a<i;++a){if((n=e.charCodeAt(a)-48)<0||n>9)break;t=10*t+n}r.s.r=--t;if(a===i||e.charCodeAt(++a)===58){r.e.c=r.s.c;r.e.r=r.s.r;return r}for(t=0;a!=i;++a){if((n=e.charCodeAt(a)-64)<1||n>26)break;t=26*t+n}r.e.c=--t;for(t=0;a!=i;++a){if((n=e.charCodeAt(a)-48)<0||n>9)break;t=10*t+n}r.e.r=--t;return r}function kt(e,r){var t=e.t=="d"&&r instanceof Date;if(e.z!=null)try{return e.w=D.format(e.z,t?ee(r):r)}catch(a){}try{return e.w=D.format((e.XF||{}).numFmtId||(t?14:0),t?ee(r):r)}catch(a){return""+r}}function St(e,r,t){if(e==null||e.t==null||e.t=="z")return"";if(e.w!==undefined)return e.w;if(e.t=="d"&&!e.z&&t&&t.dateNF)e.z=t.dateNF;if(e.t=="e")return ya[e.v]||e.v;if(r==undefined)return kt(e,e.v);return kt(e,r)}function Bt(e,r){var t=r&&r.sheet?r.sheet:"Sheet1";var a={};a[t]=e;return{SheetNames:[t],Sheets:a}}function Ct(e,r,t){var a=t||{};var n=e?Array.isArray(e):a.dense;if(b!=null&&n==null)n=b;var i=e||(n?[]:{});var s=0,f=0;if(i&&a.origin!=null){if(typeof a.origin=="number")s=a.origin;else{var l=typeof a.origin=="string"?bt(a.origin):a.origin;s=l.r;f=l.c}if(!i["!ref"])i["!ref"]="A1:A1"}var o={s:{c:1e7,r:1e7},e:{c:0,r:0}};if(i["!ref"]){var c=wt(i["!ref"]);o.s.c=c.s.c;o.s.r=c.s.r;o.e.c=Math.max(o.e.c,c.e.c);o.e.r=Math.max(o.e.r,c.e.r);if(s==-1)o.e.r=s=c.e.r+1}for(var u=0;u!=r.length;++u){if(!r[u])continue;if(!Array.isArray(r[u]))throw new Error("aoa_to_sheet expects an array of arrays");for(var h=0;h!=r[u].length;++h){if(typeof r[u][h]==="undefined")continue;var d={v:r[u][h]};var v=s+u,p=f+h;if(o.s.r>v)o.s.r=v;if(o.s.c>p)o.s.c=p;if(o.e.r<v)o.e.r=v;if(o.e.c<p)o.e.c=p;if(r[u][h]&&typeof r[u][h]==="object"&&!Array.isArray(r[u][h])&&!(r[u][h]instanceof Date))d=r[u][h];else{if(Array.isArray(d.v)){d.f=r[u][h][1];d.v=d.v[0]}if(d.v===null){if(d.f)d.t="n";else if(a.nullError){d.t="e";d.v=0}else if(!a.sheetStubs)continue;else d.t="z"}else if(typeof d.v==="number")d.t="n";else if(typeof d.v==="boolean")d.t="b";else if(d.v instanceof Date){d.z=a.dateNF||D._table[14];if(a.cellDates){d.t="d";d.w=D.format(d.z,ee(d.v))}else{d.t="n";d.v=ee(d.v);d.w=D.format(d.z,d.v)}}else d.t="s"}if(n){if(!i[v])i[v]=[];if(i[v][p]&&i[v][p].z)d.z=i[v][p].z;i[v][p]=d}else{var m=mt({c:p,r:v});if(i[m]&&i[m].z)d.z=i[m].z;i[m]=d}}}if(o.s.c<1e7)i["!ref"]=Et(o);return i}function Tt(e,r){return Ct(null,e,r)}function _t(e,r){if(!r)r=Jr(4);r._W(4,e);return r}function xt(e){var r=e._R(4);return r===0?"":e._R(r,"dbcs")}function At(e,r){var t=false;if(r==null){t=true;r=Jr(4+2*e.length)}r._W(4,e.length);if(e.length>0)r._W(0,e,"dbcs");return t?r.slice(0,r.l):r}function yt(e){return{ich:e._R(2),ifnt:e._R(2)}}function It(e,r){if(!r)r=Jr(4);r._W(2,e.ich||0);r._W(2,e.ifnt||0);return r}function Rt(e,r){var t=e.l;var a=e._R(1);var n=xt(e);var i=[];var s={t:n,h:n};if((a&1)!==0){var f=e._R(4);for(var l=0;l!=f;++l)i.push(yt(e));s.r=i}else s.r=[{ich:0,ifnt:0}];e.l=t+r;return s}function Ft(e,r){var t=false;if(r==null){t=true;r=Jr(15+4*e.t.length)}r._W(1,0);At(e.t,r);return t?r.slice(0,r.l):r}var Dt=Rt;function Ot(e,r){var t=false;if(r==null){t=true;r=Jr(23+4*e.t.length)}r._W(1,1);At(e.t,r);r._W(4,1);It({ich:0,ifnt:0},r);return t?r.slice(0,r.l):r}function Pt(e){var r=e._R(4);var t=e._R(2);t+=e._R(1)<<16;e.l++;return{c:r,iStyleRef:t}}function Nt(e,r){if(r==null)r=Jr(8);r._W(-4,e.c);r._W(3,e.iStyleRef||e.s);r._W(1,0);return r}function Mt(e){var r=e._R(2);r+=e._R(1)<<16;e.l++;return{c:-1,iStyleRef:r}}function Lt(e,r){if(r==null)r=Jr(4);r._W(3,e.iStyleRef||e.s);r._W(1,0);return r}var Ut=xt;var Ht=At;function Wt(e){var r=e._R(4);return r===0||r===4294967295?"":e._R(r,"dbcs")}function Vt(e,r){var t=false;if(r==null){t=true;r=Jr(127)}r._W(4,e.length>0?e.length:4294967295);if(e.length>0)r._W(0,e,"dbcs");return t?r.slice(0,r.l):r}var Xt=xt;var Gt=Wt;var zt=Vt;function jt(e){var r=e.slice(e.l,e.l+4);var t=r[0]&1,a=r[0]&2;e.l+=4;r[0]&=252;var n=a===0?Or([0,0,0,0,r[0],r[1],r[2],r[3]],0):Wr(r,0)>>2;return t?n/100:n}function $t(e,r){if(r==null)r=Jr(4);var t=0,a=0,n=e*100;if(e==(e|0)&&e>=-(1<<29)&&e<1<<29){a=1}else if(n==(n|0)&&n>=-(1<<29)&&n<1<<29){a=1;t=1}if(a)r._W(-4,((t?n:e)<<2)+(t+2));else throw new Error("unsupported RkNumber "+e)}function Kt(e){var r={s:{},e:{}};r.s.r=e._R(4);r.e.r=e._R(4);r.s.c=e._R(4);r.e.c=e._R(4);return r}function Yt(e,r){if(!r)r=Jr(16);r._W(4,e.s.r);r._W(4,e.e.r);r._W(4,e.s.c);r._W(4,e.e.c);return r}var Qt=Kt;var Jt=Yt;function Zt(e){if(e.length-e.l<8)throw"XLS Xnum Buffer underflow";return e._R(8,"f")}function qt(e,r){return(r||Jr(8))._W(8,e,"f")}function ea(e){var r={};var t=e._R(1);var a=t>>>1;var n=e._R(1);var i=e._R(2,"i");var s=e._R(1);var f=e._R(1);var l=e._R(1);e.l++;switch(a){case 0:r.auto=1;break;case 1:r.index=n;var o=Aa[n];if(o)r.rgb=cl(o);break;case 2:r.rgb=cl([s,f,l]);break;case 3:r.theme=n;break;}if(i!=0)r.tint=i>0?i/32767:i/32768;return r}function ra(e,r){if(!r)r=Jr(8);if(!e||e.auto){r._W(4,0);r._W(4,0);return r}if(e.index!=null){r._W(1,2);r._W(1,e.index)}else if(e.theme!=null){r._W(1,6);r._W(1,e.theme)}else{r._W(1,5);r._W(1,0)}var t=e.tint||0;if(t>0)t*=32767;else if(t<0)t*=32768;r._W(2,t);if(!e.rgb||e.theme!=null){r._W(2,0);r._W(1,0);r._W(1,0)}else{var a=e.rgb||"FFFFFF";if(typeof a=="number")a=("000000"+a.toString(16)).slice(-6);r._W(1,parseInt(a.slice(0,2),16));r._W(1,parseInt(a.slice(2,4),16));r._W(1,parseInt(a.slice(4,6),16));r._W(1,255)}return r}function ta(e){var r=e._R(1);e.l++;var t={fBold:r&1,fItalic:r&2,fUnderline:r&4,fStrikeout:r&8,fOutline:r&16,fShadow:r&32,fCondense:r&64,fExtend:r&128};return t}function aa(e,r){if(!r)r=Jr(2);var t=(e.italic?2:0)|(e.strike?8:0)|(e.outline?16:0)|(e.shadow?32:0)|(e.condense?64:0)|(e.extend?128:0);r._W(1,t);r._W(1,0);return r}function na(e,r){var t={2:"BITMAP",3:"METAFILEPICT",8:"DIB",14:"ENHMETAFILE"};var a=e._R(4);switch(a){case 0:return"";case 4294967295:;case 4294967294:return t[e._R(4)]||"";}if(a>400)throw new Error("Unsupported Clipboard: "+a.toString(16));e.l-=4;return e._R(0,r==1?"lpstr":"lpwstr")}function ia(e){return na(e,1)}function sa(e){return na(e,2)}var fa=2;var la=3;var oa=11;var ca=12;var ua=19;var ha=30;var da=64;var va=65;var pa=71;var ba=4096;var ma=80;var ga=81;var Ea=[ma,ga];var wa={1:{n:"CodePage",t:fa},2:{n:"Category",t:ma},3:{n:"PresentationFormat",t:ma},4:{n:"ByteCount",t:la},5:{n:"LineCount",t:la},6:{n:"ParagraphCount",t:la},7:{n:"SlideCount",t:la},8:{n:"NoteCount",t:la},9:{n:"HiddenCount",t:la},10:{n:"MultimediaClipCount",t:la},11:{n:"ScaleCrop",t:oa},12:{n:"HeadingPairs",t:ba|ca},13:{n:"TitlesOfParts",t:ba|ha},14:{n:"Manager",t:ma},15:{n:"Company",t:ma},16:{n:"LinksUpToDate",t:oa},17:{n:"CharacterCount",t:la},19:{n:"SharedDoc",t:oa},22:{n:"HyperlinksChanged",t:oa},23:{n:"AppVersion",t:la,p:"version"},24:{n:"DigSig",t:va},26:{n:"ContentType",t:ma},27:{n:"ContentStatus",t:ma},28:{n:"Language",t:ma},29:{n:"Version",t:ma},255:{},2147483648:{n:"Locale",t:ua},2147483651:{n:"Behavior",t:ua},1919054434:{}};var ka={1:{n:"CodePage",t:fa},2:{n:"Title",t:ma},3:{n:"Subject",t:ma},4:{n:"Author",t:ma},5:{n:"Keywords",t:ma},6:{n:"Comments",t:ma},7:{n:"Template",t:ma},8:{n:"LastAuthor",t:ma},9:{n:"RevNumber",t:ma},10:{n:"EditTime",t:da},11:{n:"LastPrinted",t:da},12:{n:"CreatedDate",t:da},13:{n:"ModifiedDate",t:da},14:{n:"PageCount",t:la},15:{n:"WordCount",t:la},16:{n:"CharCount",t:la},17:{n:"Thumbnail",t:pa},18:{n:"Application",t:ma},19:{n:"DocSecurity",t:la},255:{},2147483648:{n:"Locale",t:ua},2147483651:{n:"Behavior",t:ua},1919054434:{}};var Sa=Y(wa,"n");var Ba=Y(ka,"n");var Ca={1:"US",2:"CA",3:"",7:"RU",20:"EG",30:"GR",31:"NL",32:"BE",33:"FR",34:"ES",36:"HU",39:"IT",41:"CH",43:"AT",44:"GB",45:"DK",46:"SE",47:"NO",48:"PL",49:"DE",52:"MX",55:"BR",61:"AU",64:"NZ",66:"TH",81:"JP",82:"KR",84:"VN",86:"CN",90:"TR",105:"JS",213:"DZ",216:"MA",218:"LY",351:"PT",354:"IS",358:"FI",420:"CZ",886:"TW",961:"LB",962:"JO",963:"SY",964:"IQ",965:"KW",966:"SA",971:"AE",972:"IL",974:"QA",981:"IR",65535:"US"};var Ta=[null,"solid","mediumGray","darkGray","lightGray","darkHorizontal","darkVertical","darkDown","darkUp","darkGrid","darkTrellis","lightHorizontal","lightVertical","lightDown","lightUp","lightGrid","lightTrellis","gray125","gray0625"];function _a(e){return e.map(function(e){return[e>>16&255,e>>8&255,e&255]})}var xa=_a([0,16777215,16711680,65280,255,16776960,16711935,65535,0,16777215,16711680,65280,255,16776960,16711935,65535,8388608,32768,128,8421376,8388736,32896,12632256,8421504,10066431,10040166,16777164,13434879,6684774,16744576,26316,13421823,128,16711935,16776960,65535,8388736,8388608,32896,255,52479,13434879,13434828,16777113,10079487,16751052,13408767,16764057,3368703,3394764,10079232,16763904,16750848,16737792,6710937,9868950,13158,3381606,13056,3355392,10040064,10040166,3355545,3355443,16777215,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]);var Aa=ce(xa);var ya={0:"#NULL!",7:"#DIV/0!",15:"#VALUE!",23:"#REF!",29:"#NAME?",36:"#NUM!",42:"#N/A",43:"#GETTING_DATA",255:"#WTF?"};var Ia=J(ya);var Ra={"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml":"workbooks","application/vnd.ms-excel.binIndexWs":"TODO","application/vnd.ms-excel.intlmacrosheet":"TODO","application/vnd.ms-excel.binIndexMs":"TODO","application/vnd.openxmlformats-package.core-properties+xml":"coreprops","application/vnd.openxmlformats-officedocument.custom-properties+xml":"custprops","application/vnd.openxmlformats-officedocument.extended-properties+xml":"extprops","application/vnd.openxmlformats-officedocument.customXmlProperties+xml":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.customProperty":"TODO","application/vnd.ms-excel.pivotTable":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.pivotTable+xml":"TODO","application/vnd.openxmlformats-officedocument.drawingml.chart+xml":"TODO","application/vnd.ms-office.chartcolorstyle+xml":"TODO","application/vnd.ms-office.chartstyle+xml":"TODO","application/vnd.ms-office.chartex+xml":"TODO","application/vnd.ms-excel.calcChain":"calcchains","application/vnd.openxmlformats-officedocument.spreadsheetml.calcChain+xml":"calcchains","application/vnd.openxmlformats-officedocument.spreadsheetml.printerSettings":"TODO","application/vnd.ms-office.activeX":"TODO","application/vnd.ms-office.activeX+xml":"TODO","application/vnd.ms-excel.attachedToolbars":"TODO","application/vnd.ms-excel.connections":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.connections+xml":"TODO","application/vnd.ms-excel.externalLink":"links","application/vnd.openxmlformats-officedocument.spreadsheetml.externalLink+xml":"links","application/vnd.ms-excel.sheetMetadata":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.sheetMetadata+xml":"TODO","application/vnd.ms-excel.pivotCacheDefinition":"TODO","application/vnd.ms-excel.pivotCacheRecords":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheDefinition+xml":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheRecords+xml":"TODO","application/vnd.ms-excel.queryTable":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.queryTable+xml":"TODO","application/vnd.ms-excel.userNames":"TODO","application/vnd.ms-excel.revisionHeaders":"TODO","application/vnd.ms-excel.revisionLog":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.revisionHeaders+xml":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.revisionLog+xml":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.userNames+xml":"TODO","application/vnd.ms-excel.tableSingleCells":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.tableSingleCells+xml":"TODO","application/vnd.ms-excel.slicer":"TODO","application/vnd.ms-excel.slicerCache":"TODO","application/vnd.ms-excel.slicer+xml":"TODO","application/vnd.ms-excel.slicerCache+xml":"TODO","application/vnd.ms-excel.wsSortMap":"TODO","application/vnd.ms-excel.table":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.table+xml":"TODO","application/vnd.openxmlformats-officedocument.theme+xml":"themes","application/vnd.openxmlformats-officedocument.themeOverride+xml":"TODO","application/vnd.ms-excel.Timeline+xml":"TODO","application/vnd.ms-excel.TimelineCache+xml":"TODO","application/vnd.ms-office.vbaProject":"vba","application/vnd.ms-office.vbaProjectSignature":"vba","application/vnd.ms-office.volatileDependencies":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.volatileDependencies+xml":"TODO","application/vnd.ms-excel.controlproperties+xml":"TODO","application/vnd.openxmlformats-officedocument.model+data":"TODO","application/vnd.ms-excel.Survey+xml":"TODO","application/vnd.openxmlformats-officedocument.drawing+xml":"drawings","application/vnd.openxmlformats-officedocument.drawingml.chartshapes+xml":"TODO","application/vnd.openxmlformats-officedocument.drawingml.diagramColors+xml":"TODO","application/vnd.openxmlformats-officedocument.drawingml.diagramData+xml":"TODO","application/vnd.openxmlformats-officedocument.drawingml.diagramLayout+xml":"TODO","application/vnd.openxmlformats-officedocument.drawingml.diagramStyle+xml":"TODO","application/vnd.openxmlformats-officedocument.vmlDrawing":"TODO","application/vnd.openxmlformats-package.relationships+xml":"rels","application/vnd.openxmlformats-officedocument.oleObject":"TODO","image/png":"TODO",sheet:"js"};var Fa=function(){var e={workbooks:{xlsx:"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml",xlsm:"application/vnd.ms-excel.sheet.macroEnabled.main+xml",xlsb:"application/vnd.ms-excel.sheet.binary.macroEnabled.main",xlam:"application/vnd.ms-excel.addin.macroEnabled.main+xml",xltx:"application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml"},strs:{xlsx:"application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml",xlsb:"application/vnd.ms-excel.sharedStrings"},comments:{xlsx:"application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml",xlsb:"application/vnd.ms-excel.comments"},sheets:{xlsx:"application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml",xlsb:"application/vnd.ms-excel.worksheet"},charts:{xlsx:"application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml",xlsb:"application/vnd.ms-excel.chartsheet"},dialogs:{xlsx:"application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml",xlsb:"application/vnd.ms-excel.dialogsheet"},macros:{xlsx:"application/vnd.ms-excel.macrosheet+xml",xlsb:"application/vnd.ms-excel.macrosheet"},styles:{xlsx:"application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml",xlsb:"application/vnd.ms-excel.styles"}};K(e).forEach(function(r){["xlsm","xlam"].forEach(function(t){if(!e[r][t])e[r][t]=e[r].xlsx})});K(e).forEach(function(r){K(e[r]).forEach(function(t){Ra[e[r][t]]=r})});return e}();var Da=Z(Ra);hr.CT="http://schemas.openxmlformats.org/package/2006/content-types";function Oa(){return{workbooks:[],sheets:[],charts:[],dialogs:[],macros:[],rels:[],strs:[],comments:[],links:[],coreprops:[],extprops:[],custprops:[],themes:[],styles:[],calcchains:[],vba:[],drawings:[],TODO:[],xmlns:""}}function Pa(e){var r=Oa();if(!e||!e.match)return r;var t={};(e.match(Re)||[]).forEach(function(e){var a=Oe(e);switch(a[0].replace(Fe,"<")){case"<?xml":break;case"<Types":r.xmlns=a["xmlns"+(a[0].match(/<(\w+):/)||["",""])[1]];break;case"<Default":t[a.Extension]=a.ContentType;break;case"<Override":if(r[Ra[a.ContentType]]!==undefined)r[Ra[a.ContentType]].push(a.PartName);break;}});if(r.xmlns!==hr.CT)throw new Error("Unknown Namespace: "+r.xmlns);
r.calcchain=r.calcchains.length>0?r.calcchains[0]:"";r.sst=r.strs.length>0?r.strs[0]:"";r.style=r.styles.length>0?r.styles[0]:"";r.defaults=t;delete r.calcchains;return r}var Na=or("Types",null,{xmlns:hr.CT,"xmlns:xsd":hr.xsd,"xmlns:xsi":hr.xsi});var Ma=[["xml","application/xml"],["bin","application/vnd.ms-excel.sheet.binary.macroEnabled.main"],["vml","application/vnd.openxmlformats-officedocument.vmlDrawing"],["data","application/vnd.openxmlformats-officedocument.model+data"],["bmp","image/bmp"],["png","image/png"],["gif","image/gif"],["emf","image/x-emf"],["wmf","image/x-wmf"],["jpg","image/jpeg"],["jpeg","image/jpeg"],["tif","image/tiff"],["tiff","image/tiff"],["pdf","application/pdf"],["rels",Da.rels[0]]].map(function(e){return or("Default",null,{Extension:e[0],ContentType:e[1]})});function La(e,r){var t=[],a;t[t.length]=ye;t[t.length]=Na;t=t.concat(Ma);var n=function(n){if(e[n]&&e[n].length>0){a=e[n][0];t[t.length]=or("Override",null,{PartName:(a[0]=="/"?"":"/")+a,ContentType:Fa[n][r.bookType||"xlsx"]})}};var i=function(a){(e[a]||[]).forEach(function(e){t[t.length]=or("Override",null,{PartName:(e[0]=="/"?"":"/")+e,ContentType:Fa[a][r.bookType||"xlsx"]})})};var s=function(r){(e[r]||[]).forEach(function(e){t[t.length]=or("Override",null,{PartName:(e[0]=="/"?"":"/")+e,ContentType:Da[r][0]})})};n("workbooks");i("sheets");i("charts");s("themes");["strs","styles"].forEach(n);["coreprops","extprops","custprops"].forEach(s);s("vba");s("comments");s("drawings");if(t.length>2){t[t.length]="</Types>";t[1]=t[1].replace("/>",">")}return t.join("")}var Ua={WB:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument",SHEET:"http://sheetjs.openxmlformats.org/officeDocument/2006/relationships/officeDocument",HLINK:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/hyperlink",VML:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/vmlDrawing",XPATH:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/externalLinkPath",XMISS:"http://schemas.microsoft.com/office/2006/relationships/xlExternalLinkPath/xlPathMissing",XLINK:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/externalLink",CXML:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/customXml",CXMLP:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/customXmlProps",VBA:"http://schemas.microsoft.com/office/2006/relationships/vbaProject"};function Ha(e){var r=e.lastIndexOf("/");return e.slice(0,r+1)+"_rels/"+e.slice(r+1)+".rels"}function Wa(e,r){var t={"!id":{}};if(!e)return t;if(r.charAt(0)!=="/"){r="/"+r}var a={};(e.match(Re)||[]).forEach(function(e){var n=Oe(e);if(n[0]==="<Relationship"){var i={};i.Type=n.Type;i.Target=n.Target;i.Id=n.Id;i.TargetMode=n.TargetMode;var s=n.TargetMode==="External"?n.Target:Ae(n.Target,r);t[s]=i;a[n.Id]=i}});t["!id"]=a;return t}hr.RELS="http://schemas.openxmlformats.org/package/2006/relationships";var Va=or("Relationships",null,{xmlns:hr.RELS});function Xa(e){var r=[ye,Va];K(e["!id"]).forEach(function(t){r[r.length]=or("Relationship",null,e["!id"][t])});if(r.length>2){r[r.length]="</Relationships>";r[1]=r[1].replace("/>",">")}return r.join("")}var Ga=[Ua.HLINK,Ua.XPATH,Ua.XMISS];function za(e,r,t,a,n,i){if(!n)n={};if(!e["!id"])e["!id"]={};if(r<0)for(r=1;e["!id"]["rId"+r];++r){}n.Id="rId"+r;n.Type=a;n.Target=t;if(i)n.TargetMode=i;else if(Ga.indexOf(n.Type)>-1)n.TargetMode="External";if(e["!id"][n.Id])throw new Error("Cannot rewrite rId "+r);e["!id"][n.Id]=n;e[("/"+n.Target).replace("//","/")]=n;return r}var ja="application/vnd.oasis.opendocument.spreadsheet";function $a(e,r){var t=Tp(e);var a;var n;while(a=_p.exec(t))switch(a[3]){case"manifest":break;case"file-entry":n=Oe(a[0],false);if(n.path=="/"&&n.type!==ja)throw new Error("This OpenDocument is not a spreadsheet");break;case"encryption-data":;case"algorithm":;case"start-key-generation":;case"key-derivation":throw new Error("Unsupported ODS Encryption");default:if(r&&r.WTF)throw a;}}function Ka(e){var r=[ye];r.push('<manifest:manifest xmlns:manifest="urn:oasis:names:tc:opendocument:xmlns:manifest:1.0" manifest:version="1.2">\n');r.push('  <manifest:file-entry manifest:full-path="/" manifest:version="1.2" manifest:media-type="application/vnd.oasis.opendocument.spreadsheet"/>\n');for(var t=0;t<e.length;++t)r.push('  <manifest:file-entry manifest:full-path="'+e[t][0]+'" manifest:media-type="'+e[t][1]+'"/>\n');r.push("</manifest:manifest>");return r.join("")}function Ya(e,r,t){return['  <rdf:Description rdf:about="'+e+'">\n','    <rdf:type rdf:resource="http://docs.oasis-open.org/ns/office/1.2/meta/'+(t||"odf")+"#"+r+'"/>\n',"  </rdf:Description>\n"].join("")}function Qa(e,r){return['  <rdf:Description rdf:about="'+e+'">\n','    <ns0:hasPart xmlns:ns0="http://docs.oasis-open.org/ns/office/1.2/meta/pkg#" rdf:resource="'+r+'"/>\n',"  </rdf:Description>\n"].join("")}function Ja(e){var r=[ye];r.push('<rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#">\n');for(var t=0;t!=e.length;++t){r.push(Ya(e[t][0],e[t][1]));r.push(Qa("",e[t][0]))}r.push(Ya("","Document","pkg"));r.push("</rdf:RDF>");return r.join("")}var Za=function(){var r='<office:document-meta xmlns:office="urn:oasis:names:tc:opendocument:xmlns:office:1.0" xmlns:meta="urn:oasis:names:tc:opendocument:xmlns:meta:1.0" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:xlink="http://www.w3.org/1999/xlink" office:version="1.2"><office:meta><meta:generator>Sheet'+"JS "+e.version+"</meta:generator></office:meta></office:document-meta>";return function t(){return r}}();var qa=[["cp:category","Category"],["cp:contentStatus","ContentStatus"],["cp:keywords","Keywords"],["cp:lastModifiedBy","LastAuthor"],["cp:lastPrinted","LastPrinted"],["cp:revision","RevNumber"],["cp:version","Version"],["dc:creator","Author"],["dc:description","Comments"],["dc:identifier","Identifier"],["dc:language","Language"],["dc:subject","Subject"],["dc:title","Title"],["dcterms:created","CreatedDate","date"],["dcterms:modified","ModifiedDate","date"]];hr.CORE_PROPS="http://schemas.openxmlformats.org/package/2006/metadata/core-properties";Ua.CORE_PROPS="http://schemas.openxmlformats.org/package/2006/relationships/metadata/core-properties";var en=function(){var e=new Array(qa.length);for(var r=0;r<qa.length;++r){var t=qa[r];var a="(?:"+t[0].slice(0,t[0].indexOf(":"))+":)"+t[0].slice(t[0].indexOf(":")+1);e[r]=new RegExp("<"+a+"[^>]*>([\\s\\S]*?)</"+a+">")}return e}();function rn(e){var r={};e=Ye(e);for(var t=0;t<qa.length;++t){var a=qa[t],n=e.match(en[t]);if(n!=null&&n.length>0)r[a[1]]=Le(n[1]);if(a[2]==="date"&&r[a[1]])r[a[1]]=le(r[a[1]])}return r}var tn=or("cp:coreProperties",null,{"xmlns:cp":hr.CORE_PROPS,"xmlns:dc":hr.dc,"xmlns:dcterms":hr.dcterms,"xmlns:dcmitype":hr.dcmitype,"xmlns:xsi":hr.xsi});function an(e,r,t,a,n){if(n[e]!=null||r==null||r==="")return;n[e]=r;r=We(r);a[a.length]=t?or(e,r,t):fr(e,r)}function nn(e,r){var t=r||{};var a=[ye,tn],n={};if(!e&&!t.Props)return a.join("");if(e){if(e.CreatedDate!=null)an("dcterms:created",typeof e.CreatedDate==="string"?e.CreatedDate:cr(e.CreatedDate,t.WTF),{"xsi:type":"dcterms:W3CDTF"},a,n);if(e.ModifiedDate!=null)an("dcterms:modified",typeof e.ModifiedDate==="string"?e.ModifiedDate:cr(e.ModifiedDate,t.WTF),{"xsi:type":"dcterms:W3CDTF"},a,n)}for(var i=0;i!=qa.length;++i){var s=qa[i];var f=t.Props&&t.Props[s[1]]!=null?t.Props[s[1]]:e?e[s[1]]:null;if(f===true)f="1";else if(f===false)f="0";else if(typeof f=="number")f=String(f);if(f!=null)an(s[0],f,null,a,n)}if(a.length>2){a[a.length]="</cp:coreProperties>";a[1]=a[1].replace("/>",">")}return a.join("")}var sn=[["Application","Application","string"],["AppVersion","AppVersion","string"],["Company","Company","string"],["DocSecurity","DocSecurity","string"],["Manager","Manager","string"],["HyperlinksChanged","HyperlinksChanged","bool"],["SharedDoc","SharedDoc","bool"],["LinksUpToDate","LinksUpToDate","bool"],["ScaleCrop","ScaleCrop","bool"],["HeadingPairs","HeadingPairs","raw"],["TitlesOfParts","TitlesOfParts","raw"]];hr.EXT_PROPS="http://schemas.openxmlformats.org/officeDocument/2006/extended-properties";Ua.EXT_PROPS="http://schemas.openxmlformats.org/officeDocument/2006/relationships/extended-properties";var fn=["Worksheets","SheetNames","NamedRanges","DefinedNames","Chartsheets","ChartNames"];function ln(e,r,t,a){var n=[];if(typeof e=="string")n=ir(e,a);else for(var i=0;i<e.length;++i)n=n.concat(e[i].map(function(e){return{v:e}}));var s=typeof r=="string"?ir(r,a).map(function(e){return e.v}):r;var f=0,l=0;if(s.length>0)for(var o=0;o!==n.length;o+=2){l=+n[o+1].v;switch(n[o].v){case"Worksheets":;case"工作表":;case"Листы":;case"أوراق العمل":;case"ワークシート":;case"גליונות עבודה":;case"Arbeitsblätter":;case"Çalışma Sayfaları":;case"Feuilles de calcul":;case"Fogli di lavoro":;case"Folhas de cálculo":;case"Planilhas":;case"Regneark":;case"Hojas de cálculo":;case"Werkbladen":t.Worksheets=l;t.SheetNames=s.slice(f,f+l);break;case"Named Ranges":;case"Rangos con nombre":;case"名前付き一覧":;case"Benannte Bereiche":;case"Navngivne områder":t.NamedRanges=l;t.DefinedNames=s.slice(f,f+l);break;case"Charts":;case"Diagramme":t.Chartsheets=l;t.ChartNames=s.slice(f,f+l);break;}f+=l}}function on(e,r,t){var a={};if(!r)r={};e=Ye(e);sn.forEach(function(t){var n=(e.match(er(t[0]))||[])[1];switch(t[2]){case"string":if(n)r[t[1]]=Le(n);break;case"bool":r[t[1]]=n==="true";break;case"raw":var i=e.match(new RegExp("<"+t[0]+"[^>]*>([\\s\\S]*?)</"+t[0]+">"));if(i&&i.length>0)a[t[1]]=i[1];break;}});if(a.HeadingPairs&&a.TitlesOfParts)ln(a.HeadingPairs,a.TitlesOfParts,r,t);return r}var cn=or("Properties",null,{xmlns:hr.EXT_PROPS,"xmlns:vt":hr.vt});function un(e){var r=[],t=or;if(!e)e={};e.Application="SheetJS";r[r.length]=ye;r[r.length]=cn;sn.forEach(function(a){if(e[a[1]]===undefined)return;var n;switch(a[2]){case"string":n=We(String(e[a[1]]));break;case"bool":n=e[a[1]]?"true":"false";break;}if(n!==undefined)r[r.length]=t(a[0],n)});r[r.length]=t("HeadingPairs",t("vt:vector",t("vt:variant","<vt:lpstr>Worksheets</vt:lpstr>")+t("vt:variant",t("vt:i4",String(e.Worksheets))),{size:2,baseType:"variant"}));r[r.length]=t("TitlesOfParts",t("vt:vector",e.SheetNames.map(function(e){return"<vt:lpstr>"+We(e)+"</vt:lpstr>"}).join(""),{size:e.Worksheets,baseType:"lpstr"}));if(r.length>2){r[r.length]="</Properties>";r[1]=r[1].replace("/>",">")}return r.join("")}hr.CUST_PROPS="http://schemas.openxmlformats.org/officeDocument/2006/custom-properties";Ua.CUST_PROPS="http://schemas.openxmlformats.org/officeDocument/2006/relationships/custom-properties";var hn=/<[^>]+>[^<]*/g;function dn(e,r){var t={},a="";var n=e.match(hn);if(n)for(var i=0;i!=n.length;++i){var s=n[i],f=Oe(s);switch(f[0]){case"<?xml":break;case"<Properties":break;case"<property":a=Le(f.name);break;case"</property>":a=null;break;default:if(s.indexOf("<vt:")===0){var l=s.split(">");var o=l[0].slice(4),c=l[1];switch(o){case"lpstr":;case"bstr":;case"lpwstr":t[a]=Le(c);break;case"bool":t[a]=Ke(c);break;case"i1":;case"i2":;case"i4":;case"i8":;case"int":;case"uint":t[a]=parseInt(c,10);break;case"r4":;case"r8":;case"decimal":t[a]=parseFloat(c);break;case"filetime":;case"date":t[a]=le(c);break;case"cy":;case"error":t[a]=Le(c);break;default:if(o.slice(-1)=="/")break;if(r.WTF&&typeof console!=="undefined")console.warn("Unexpected",s,o,l);}}else if(s.slice(0,2)==="</"){}else if(r.WTF)throw new Error(s);}}return t}var vn=or("Properties",null,{xmlns:hr.CUST_PROPS,"xmlns:vt":hr.vt});function pn(e){var r=[ye,vn];if(!e)return r.join("");var t=1;K(e).forEach(function a(n){++t;r[r.length]=or("property",ur(e[n],true),{fmtid:"{D5CDD505-2E9C-101B-9397-08002B2CF9AE}",pid:t,name:We(n)})});if(r.length>2){r[r.length]="</Properties>";r[1]=r[1].replace("/>",">")}return r.join("")}var bn={Title:"Title",Subject:"Subject",Author:"Author",Keywords:"Keywords",Comments:"Description",LastAuthor:"LastAuthor",RevNumber:"Revision",Application:"AppName",LastPrinted:"LastPrinted",CreatedDate:"Created",ModifiedDate:"LastSaved",Category:"Category",Manager:"Manager",Company:"Company",AppVersion:"Version",ContentStatus:"ContentStatus",Identifier:"Identifier",Language:"Language"};var mn=Q(bn);function gn(e,r,t){r=mn[r]||r;e[r]=t}function En(e,r){var t=[];K(bn).map(function(e){for(var r=0;r<qa.length;++r)if(qa[r][1]==e)return qa[r];for(r=0;r<sn.length;++r)if(sn[r][1]==e)return sn[r];throw e}).forEach(function(a){if(e[a[1]]==null)return;var n=r&&r.Props&&r.Props[a[1]]!=null?r.Props[a[1]]:e[a[1]];switch(a[2]){case"date":n=new Date(n).toISOString().replace(/\.\d*Z/,"Z");break;}if(typeof n=="number")n=String(n);else if(n===true||n===false){n=n?"1":"0"}else if(n instanceof Date)n=new Date(n).toISOString().replace(/\.\d*Z/,"");t.push(fr(bn[a[1]]||a[1],n))});return or("DocumentProperties",t.join(""),{xmlns:dr.o})}function wn(e,r){var t=["Worksheets","SheetNames"];var a="CustomDocumentProperties";var n=[];if(e)K(e).forEach(function(r){if(!Object.prototype.hasOwnProperty.call(e,r))return;for(var a=0;a<qa.length;++a)if(r==qa[a][1])return;for(a=0;a<sn.length;++a)if(r==sn[a][1])return;for(a=0;a<t.length;++a)if(r==t[a])return;var i=e[r];var s="string";if(typeof i=="number"){s="float";i=String(i)}else if(i===true||i===false){s="boolean";i=i?"1":"0"}else i=String(i);n.push(or(Ve(r),i,{"dt:dt":s}))});if(r)K(r).forEach(function(t){if(!Object.prototype.hasOwnProperty.call(r,t))return;if(e&&Object.prototype.hasOwnProperty.call(e,t))return;var a=r[t];var i="string";if(typeof a=="number"){i="float";a=String(a)}else if(a===true||a===false){i="boolean";a=a?"1":"0"}else if(a instanceof Date){i="dateTime.tz";a=a.toISOString()}else a=String(a);n.push(or(Ve(t),a,{"dt:dt":i}))});return"<"+a+' xmlns="'+dr.o+'">'+n.join("")+"</"+a+">"}function kn(e){var r=e._R(4),t=e._R(4);return new Date((t/1e7*Math.pow(2,32)+r/1e7-11644473600)*1e3).toISOString().replace(/\.000/,"")}function Sn(e){var r=typeof e=="string"?new Date(Date.parse(e)):e;var t=r.getTime()/1e3+11644473600;var a=t%Math.pow(2,32),n=(t-a)/Math.pow(2,32);a*=1e7;n*=1e7;var i=a/Math.pow(2,32)|0;if(i>0){a=a%Math.pow(2,32);n+=i}var s=Jr(8);s._W(4,a);s._W(4,n);return s}function Bn(e,r,t){var a=e.l;var n=e._R(0,"lpstr-cp");if(t)while(e.l-a&3)++e.l;return n}function Cn(e,r,t){var a=e._R(0,"lpwstr");if(t)e.l+=4-(a.length+1&3)&3;return a}function Tn(e,r,t){if(r===31)return Cn(e);return Bn(e,r,t)}function _n(e,r,t){return Tn(e,r,t===false?0:4)}function xn(e,r){if(!r)throw new Error("VtUnalignedString must have positive length");return Tn(e,r,0)}function An(e){var r=e._R(4);var t=[];for(var a=0;a!=r;++a){var n=e.l;t[a]=e._R(0,"lpwstr").replace(R,"");if(e.l-n&2)e.l+=2}return t}function yn(e){var r=e._R(4);var t=[];for(var a=0;a!=r;++a)t[a]=e._R(0,"lpstr-cp").replace(R,"");return t}function In(e){var r=e.l;var t=Pn(e,ga);if(e[e.l]==0&&e[e.l+1]==0&&e.l-r&2)e.l+=2;var a=Pn(e,la);return[t,a]}function Rn(e){var r=e._R(4);var t=[];for(var a=0;a<r/2;++a)t.push(In(e));return t}function Fn(e,r){var t=e._R(4);var a={};for(var n=0;n!=t;++n){var i=e._R(4);var s=e._R(4);a[i]=e._R(s,r===1200?"utf16le":"utf8").replace(R,"").replace(F,"!");if(r===1200&&s%2)e.l+=2}if(e.l&3)e.l=e.l>>2+1<<2;return a}function Dn(e){var r=e._R(4);var t=e.slice(e.l,e.l+r);e.l+=r;if((r&3)>0)e.l+=4-(r&3)&3;return t}function On(e){var r={};r.Size=e._R(4);e.l+=r.Size+3-(r.Size-1)%4;return r}function Pn(e,r,t){var a=e._R(2),n,i=t||{};e.l+=2;if(r!==ca)if(a!==r&&Ea.indexOf(r)===-1&&!((r&65534)==4126&&(a&65534)==4126))throw new Error("Expected type "+r+" saw "+a);switch(r===ca?a:r){case 2:n=e._R(2,"i");if(!i.raw)e.l+=2;return n;case 3:n=e._R(4,"i");return n;case 11:return e._R(4)!==0;case 19:n=e._R(4);return n;case 30:return Bn(e,a,4).replace(R,"");case 31:return Cn(e);case 64:return kn(e);case 65:return Dn(e);case 71:return On(e);case 80:return _n(e,a,!i.raw).replace(R,"");case 81:return xn(e,a).replace(R,"");case 4108:return Rn(e);case 4126:;case 4127:return a==4127?An(e):yn(e);default:throw new Error("TypedPropertyValue unrecognized type "+r+" "+a);}}function Nn(e,r){var t=Jr(4),a=Jr(4);t._W(4,e==80?31:e);switch(e){case 3:a._W(-4,r);break;case 5:a=Jr(8);a._W(8,r,"f");break;case 11:a._W(4,r?1:0);break;case 64:a=Sn(r);break;case 31:;case 80:a=Jr(4+2*(r.length+1)+(r.length%2?0:2));a._W(4,r.length+1);a._W(0,r,"dbcs");while(a.l!=a.length)a._W(1,0);break;default:throw new Error("TypedPropertyValue unrecognized type "+e+" "+r);}return I([t,a])}function Mn(e,r){var t=e.l;var a=e._R(4);var n=e._R(4);var i=[],s=0;var f=0;var o=-1,c={};for(s=0;s!=n;++s){var u=e._R(4);var h=e._R(4);i[s]=[u,h+t]}i.sort(function(e,r){return e[1]-r[1]});var d={};for(s=0;s!=n;++s){if(e.l!==i[s][1]){var v=true;if(s>0&&r)switch(r[i[s-1][0]].t){case 2:if(e.l+2===i[s][1]){e.l+=2;v=false}break;case 80:if(e.l<=i[s][1]){e.l=i[s][1];v=false}break;case 4108:if(e.l<=i[s][1]){e.l=i[s][1];v=false}break;}if((!r||s==0)&&e.l<=i[s][1]){v=false;e.l=i[s][1]}if(v)throw new Error("Read Error: Expected address "+i[s][1]+" at "+e.l+" :"+s)}if(r){var p=r[i[s][0]];d[p.n]=Pn(e,p.t,{raw:true});if(p.p==="version")d[p.n]=String(d[p.n]>>16)+"."+("0000"+String(d[p.n]&65535)).slice(-4);if(p.n=="CodePage")switch(d[p.n]){case 0:d[p.n]=1252;case 874:;case 932:;case 936:;case 949:;case 950:;case 1250:;case 1251:;case 1253:;case 1254:;case 1255:;case 1256:;case 1257:;case 1258:;case 1e4:;case 1200:;case 1201:;case 1252:;case 65e3:;case-536:;case 65001:;case-535:l(f=d[p.n]>>>0&65535);break;default:throw new Error("Unsupported CodePage: "+d[p.n]);}}else{if(i[s][0]===1){f=d.CodePage=Pn(e,fa);l(f);if(o!==-1){var b=e.l;e.l=i[o][1];c=Fn(e,f);e.l=b}}else if(i[s][0]===0){if(f===0){o=s;e.l=i[s+1][1];continue}c=Fn(e,f)}else{var m=c[i[s][0]];var g;switch(e[e.l]){case 65:e.l+=4;g=Dn(e);break;case 30:e.l+=4;g=_n(e,e[e.l-4]).replace(/\u0000+$/,"");break;case 31:e.l+=4;g=_n(e,e[e.l-4]).replace(/\u0000+$/,"");break;case 3:e.l+=4;g=e._R(4,"i");break;case 19:e.l+=4;g=e._R(4);break;case 5:e.l+=4;g=e._R(8,"f");break;case 11:e.l+=4;g=jn(e,4);break;case 64:e.l+=4;g=le(kn(e));break;default:throw new Error("unparsed value: "+e[e.l]);}d[m]=g}}}e.l=t+a;return d}var Ln=["CodePage","Thumbnail","_PID_LINKBASE","_PID_HLINKS","SystemIdentifier","FMTID"].concat(fn);function Un(e){switch(typeof e){case"boolean":return 11;case"number":return(e|0)==e?3:5;case"string":return 31;case"object":if(e instanceof Date)return 64;break;}return-1}function Hn(e,r,t){var a=Jr(8),n=[],i=[];var s=8,f=0;var l=Jr(8),o=Jr(8);l._W(4,2);l._W(4,1200);o._W(4,1);i.push(l);n.push(o);s+=8+l.length;if(!r){o=Jr(8);o._W(4,0);n.unshift(o);var c=[Jr(4)];c[0]._W(4,e.length);for(f=0;f<e.length;++f){var u=e[f][0];l=Jr(4+4+2*(u.length+1)+(u.length%2?0:2));l._W(4,f+2);l._W(4,u.length+1);l._W(0,u,"dbcs");while(l.l!=l.length)l._W(1,0);c.push(l)}l=I(c);i.unshift(l);s+=8+l.length}for(f=0;f<e.length;++f){if(r&&!r[e[f][0]])continue;if(Ln.indexOf(e[f][0])>-1)continue;if(e[f][1]==null)continue;var h=e[f][1],d=0;if(r){d=+r[e[f][0]];var v=t[d];if(v.p=="version"&&typeof h=="string"){var p=h.split(".");h=(+p[0]<<16)+(+p[1]||0)}l=Nn(v.t,h)}else{var b=Un(h);if(b==-1){b=31;h=String(h)}l=Nn(b,h)}i.push(l);o=Jr(8);o._W(4,!r?2+f:d);n.push(o);s+=8+l.length}var m=8*(i.length+1);for(f=0;f<i.length;++f){n[f]._W(4,m);m+=i[f].length}a._W(4,s);a._W(4,i.length);return I([a].concat(n).concat(i))}function Wn(e,r,t){var a=e.content;if(!a)return{};Yr(a,0);var n,i,s,f,l=0;a.chk("feff","Byte Order: ");a._R(2);var o=a._R(4);var c=a._R(16);if(c!==V.utils.consts.HEADER_CLSID&&c!==t)throw new Error("Bad PropertySet CLSID "+c);n=a._R(4);if(n!==1&&n!==2)throw new Error("Unrecognized #Sets: "+n);i=a._R(16);f=a._R(4);if(n===1&&f!==a.l)throw new Error("Length mismatch: "+f+" !== "+a.l);else if(n===2){s=a._R(16);l=a._R(4)}var u=Mn(a,r);var h={SystemIdentifier:o};for(var d in u)h[d]=u[d];h.FMTID=i;if(n===1)return h;if(l-a.l==2)a.l+=2;if(a.l!==l)throw new Error("Length mismatch 2: "+a.l+" !== "+l);var v;try{v=Mn(a,null)}catch(p){}for(d in v)h[d]=v[d];h.FMTID=[i,s];return h}function Vn(e,r,t,a,n,i){var s=Jr(n?68:48);var f=[s];s._W(2,65534);s._W(2,0);s._W(4,842412599);s._W(16,V.utils.consts.HEADER_CLSID,"hex");s._W(4,n?2:1);s._W(16,r,"hex");s._W(4,n?68:48);var l=Hn(e,t,a);f.push(l);if(n){var o=Hn(n,null,null);s._W(16,i,"hex");s._W(4,68+l.length);f.push(o)}return I(f)}function Xn(e,r){e._R(r);return null}function Gn(e,r){if(!r)r=Jr(e);for(var t=0;t<e;++t)r._W(1,0);return r}function zn(e,r,t){var a=[],n=e.l+r;while(e.l<n)a.push(t(e,n-e.l));if(n!==e.l)throw new Error("Slurp error");return a}function jn(e,r){return e._R(r)===1}function $n(e,r){if(!r)r=Jr(2);r._W(2,+!!e);return r}function Kn(e){return e._R(2,"u")}function Yn(e,r){if(!r)r=Jr(2);r._W(2,e);return r}function Qn(e,r){return zn(e,r,Kn)}function Jn(e){var r=e._R(1),t=e._R(1);return t===1?r:r===1}function Zn(e,r,t){if(!t)t=Jr(2);t._W(1,r=="e"?+e:+!!e);t._W(1,r=="e"?1:0);return t}function qn(e,t,a){var n=e._R(a&&a.biff>=12?2:1);var i="sbcs-cont";var s=r;if(a&&a.biff>=8)r=1200;if(!a||a.biff==8){var f=e._R(1);if(f){i="dbcs-cont"}}else if(a.biff==12){i="wstr"}if(a.biff>=2&&a.biff<=5)i="cpstr";var l=n?e._R(n,i):"";r=s;return l}function ei(e){var t=r;r=1200;var a=e._R(2),n=e._R(1);var i=n&4,s=n&8;var f=1+(n&1);var l=0,o;var c={};if(s)l=e._R(2);if(i)o=e._R(4);var u=f==2?"dbcs-cont":"sbcs-cont";var h=a===0?"":e._R(a,u);if(s)e.l+=4*l;if(i)e.l+=o;c.t=h;if(!s){c.raw="<t>"+c.t+"</t>";c.r=c.t}r=t;return c}function ri(e){var r=e.t||"",t=1;var a=Jr(3+(t>1?2:0));a._W(2,r.length);a._W(1,(t>1?8:0)|1);if(t>1)a._W(2,t);var n=Jr(2*r.length);n._W(2*r.length,r,"utf16le");var i=[a,n];return I(i)}function ti(e,r,t){var a;if(t){if(t.biff>=2&&t.biff<=5)return e._R(r,"cpstr");if(t.biff>=12)return e._R(r,"dbcs-cont")}var n=e._R(1);if(n===0){a=e._R(r,"sbcs-cont")}else{a=e._R(r,"dbcs-cont")}return a}function ai(e,r,t){var a=e._R(t&&t.biff==2?1:2);if(a===0){e.l++;return""}return ti(e,a,t)}function ni(e,r,t){if(t.biff>5)return ai(e,r,t);var a=e._R(1);if(a===0){e.l++;return""}return e._R(a,t.biff<=4||!e.lens?"cpstr":"sbcs-cont")}function ii(e,r,t){if(!t)t=Jr(3+2*e.length);t._W(2,e.length);t._W(1,1);t._W(31,e,"utf16le");return t}function si(e){var r=e._R(1);e.l++;var t=e._R(2);e.l+=2;return[r,t]}function fi(e){var r=e._R(4),t=e.l;var a=false;if(r>24){e.l+=r-24;if(e._R(16)==="795881f43b1d7f48af2c825dc4852763")a=true;e.l=t}var n=e._R((a?r-24:r)>>1,"utf16le").replace(R,"");if(a)e.l+=24;return n}function li(e){var r=e._R(2);var t="";while(r-- >0)t+="../";var a=e._R(0,"lpstr-ansi");e.l+=2;if(e._R(2)!=57005)throw new Error("Bad FileMoniker");var n=e._R(4);if(n===0)return t+a.replace(/\\/g,"/");var i=e._R(4);if(e._R(2)!=3)throw new Error("Bad FileMoniker");var s=e._R(i>>1,"utf16le").replace(R,"");return t+s}function oi(e,r){var t=e._R(16);r-=16;switch(t){case"e0c9ea79f9bace118c8200aa004ba90b":return fi(e,r);case"0303000000000000c000000000000046":return li(e,r);default:throw new Error("Unsupported Moniker "+t);}}function ci(e){var r=e._R(4);var t=r>0?e._R(r,"utf16le").replace(R,""):"";return t}function ui(e,r){if(!r)r=Jr(6+e.length*2);r._W(4,1+e.length);for(var t=0;t<e.length;++t)r._W(2,e.charCodeAt(t));r._W(2,0);return r}function hi(e,r){var t=e.l+r;var a=e._R(4);if(a!==2)throw new Error("Unrecognized streamVersion: "+a);var n=e._R(2);e.l+=2;var i,s,f,l,o="",c,u;if(n&16)i=ci(e,t-e.l);if(n&128)s=ci(e,t-e.l);if((n&257)===257)f=ci(e,t-e.l);if((n&257)===1)l=oi(e,t-e.l);if(n&8)o=ci(e,t-e.l);if(n&32)c=e._R(16);if(n&64)u=kn(e);e.l=t;var h=s||f||l||"";if(h&&o)h+="#"+o;if(!h)h="#"+o;if(n&2&&h.charAt(0)=="/"&&h.charAt(1)!="/")h="file://"+h;var d={Target:h};if(c)d.guid=c;if(u)d.time=u;if(i)d.Tooltip=i;return d}function di(e){var r=Jr(512),t=0;var a=e.Target;if(a.slice(0,7)=="file://")a=a.slice(7);var n=a.indexOf("#");var i=n>-1?31:23;switch(a.charAt(0)){case"#":i=28;break;case".":i&=~2;break;}r._W(4,2);r._W(4,i);var s=[8,6815827,6619237,4849780,83];for(t=0;t<s.length;++t)r._W(4,s[t]);if(i==28){a=a.slice(1);ui(a,r)}else if(i&2){s="e0 c9 ea 79 f9 ba ce 11 8c 82 00 aa 00 4b a9 0b".split(" ");for(t=0;t<s.length;++t)r._W(1,parseInt(s[t],16));var f=n>-1?a.slice(0,n):a;r._W(4,2*(f.length+1));for(t=0;t<f.length;++t)r._W(2,f.charCodeAt(t));r._W(2,0);if(i&8)ui(n>-1?a.slice(n+1):"",r)}else{s="03 03 00 00 00 00 00 00 c0 00 00 00 00 00 00 46".split(" ");for(t=0;t<s.length;++t)r._W(1,parseInt(s[t],16));var l=0;while(a.slice(l*3,l*3+3)=="../"||a.slice(l*3,l*3+3)=="..\\")++l;r._W(2,l);r._W(4,a.length-3*l+1);for(t=0;t<a.length-3*l;++t)r._W(1,a.charCodeAt(t+3*l)&255);r._W(1,0);r._W(2,65535);r._W(2,57005);for(t=0;t<6;++t)r._W(4,0)}return r.slice(0,r.l)}function vi(e){var r=e._R(1),t=e._R(1),a=e._R(1),n=e._R(1);return[r,t,a,n]}function pi(e,r){var t=vi(e,r);t[3]=0;return t}function bi(e){var r=e._R(2);var t=e._R(2);var a=e._R(2);return{r:r,c:t,ixfe:a}}function mi(e,r,t,a){if(!a)a=Jr(6);a._W(2,e);a._W(2,r);a._W(2,t||0);return a}function gi(e){var r=e._R(2);var t=e._R(2);e.l+=8;return{type:r,flags:t}}function Ei(e,r,t){return r===0?"":ni(e,r,t)}function wi(e,r,t){var a=t.biff>8?4:2;var n=e._R(a),i=e._R(a,"i"),s=e._R(a,"i");return[n,i,s]}function ki(e){var r=e._R(2);var t=jt(e);return[r,t]}function Si(e,r,t){e.l+=4;r-=4;var a=e.l+r;var n=qn(e,r,t);var i=e._R(2);a-=e.l;if(i!==a)throw new Error("Malformed AddinUdf: padding = "+a+" != "+i);e.l+=i;return n}function Bi(e){var r=e._R(2);var t=e._R(2);var a=e._R(2);var n=e._R(2);return{s:{c:a,r:r},e:{c:n,r:t}}}function Ci(e,r){if(!r)r=Jr(8);r._W(2,e.s.r);r._W(2,e.e.r);r._W(2,e.s.c);r._W(2,e.e.c);return r}function Ti(e){var r=e._R(2);var t=e._R(2);var a=e._R(1);var n=e._R(1);return{s:{c:a,r:r},e:{c:n,r:t}}}var _i=Ti;function xi(e){e.l+=4;var r=e._R(2);var t=e._R(2);var a=e._R(2);e.l+=12;return[t,r,a]}function Ai(e){var r={};e.l+=4;e.l+=16;r.fSharedNote=e._R(2);e.l+=4;return r}function yi(e){var r={};e.l+=4;e.cf=e._R(2);return r}function Ii(e){e.l+=2;e.l+=e._R(2)}var Ri={0:Ii,4:Ii,5:Ii,6:Ii,7:yi,8:Ii,9:Ii,10:Ii,11:Ii,12:Ii,13:Ai,14:Ii,15:Ii,16:Ii,17:Ii,18:Ii,19:Ii,20:Ii,21:xi};function Fi(e,r){var t=e.l+r;var a=[];while(e.l<t){var n=e._R(2);e.l-=2;try{a.push(Ri[n](e,t-e.l))}catch(i){e.l=t;return a}}if(e.l!=t)e.l=t;return a}function Di(e,r){var t={BIFFVer:0,dt:0};t.BIFFVer=e._R(2);r-=2;if(r>=2){t.dt=e._R(2);e.l-=2}switch(t.BIFFVer){case 1536:;case 1280:;case 1024:;case 768:;case 512:;case 2:;case 7:break;default:if(r>6)throw new Error("Unexpected BIFF Ver "+t.BIFFVer);}e._R(r);return t}function Oi(e,r,t){var a=1536,n=16;switch(t.bookType){case"biff8":break;case"biff5":a=1280;n=8;break;case"biff4":a=4;n=6;break;case"biff3":a=3;n=6;break;case"biff2":a=2;n=4;break;case"xla":break;default:throw new Error("unsupported BIFF version");}var i=Jr(n);i._W(2,a);i._W(2,r);if(n>4)i._W(2,29282);if(n>6)i._W(2,1997);if(n>8){i._W(2,49161);i._W(2,1);i._W(2,1798);i._W(2,0)}return i}function Pi(e,r){if(r===0)return 1200;if(e._R(2)!==1200){}return 1200}function Ni(e,r,t){if(t.enc){e.l+=r;return""}var a=e.l;var n=ni(e,0,t);e._R(r+a-e.l);return n}function Mi(e,r){var t=!r||r.biff==8;var a=Jr(t?112:54);a._W(r.biff==8?2:1,7);if(t)a._W(1,0);a._W(4,859007059);a._W(4,5458548|(t?0:536870912));while(a.l<a.length)a._W(1,t?0:32);return a}function Li(e,r,t){var a=t&&t.biff==8||r==2?e._R(2):(e.l+=r,0);return{fDialog:a&16,fBelow:a&64,fRight:a&128}}function Ui(e,r,t){var a=e._R(4);var n=e._R(1)&3;var i=e._R(1);switch(i){case 0:i="Worksheet";break;case 1:i="Macrosheet";break;case 2:i="Chartsheet";break;case 6:i="VBAModule";break;}var s=qn(e,0,t);if(s.length===0)s="Sheet1";return{pos:a,hs:n,dt:i,name:s}}function Hi(e,r){var t=!r||r.biff>=8?2:1;var a=Jr(8+t*e.name.length);a._W(4,e.pos);a._W(1,e.hs||0);a._W(1,e.dt);a._W(1,e.name.length);if(r.biff>=8)a._W(1,1);a._W(t*e.name.length,e.name,r.biff<8?"sbcs":"utf16le");var n=a.slice(0,a.l);n.l=a.l;return n}function Wi(e,r){var t=e.l+r;var a=e._R(4);var n=e._R(4);var i=[];for(var s=0;s!=n&&e.l<t;++s){i.push(ei(e))}i.Count=a;i.Unique=n;return i}function Vi(e,r){var t=Jr(8);t._W(4,e.Count);t._W(4,e.Unique);var a=[];for(var n=0;n<e.length;++n)a[n]=ri(e[n],r);var i=I([t].concat(a));i.parts=[t.length].concat(a.map(function(e){return e.length}));return i}function Xi(e,r){var t={};t.dsst=e._R(2);e.l+=r-2;return t}function Gi(e){var r={};r.r=e._R(2);r.c=e._R(2);r.cnt=e._R(2)-r.c;var t=e._R(2);e.l+=4;var a=e._R(1);e.l+=3;if(a&7)r.level=a&7;if(a&32)r.hidden=true;if(a&64)r.hpt=t/20;return r}function zi(e){var r=gi(e);if(r.type!=2211)throw new Error("Invalid Future Record "+r.type);var t=e._R(4);return t!==0}function ji(e){e._R(2);return e._R(4)}function $i(e,r,t){var a=0;if(!(t&&t.biff==2)){a=e._R(2)}var n=e._R(2);if(t&&t.biff==2){a=1-(n>>15);n&=32767}var i={Unsynced:a&1,DyZero:(a&2)>>1,ExAsc:(a&4)>>2,ExDsc:(a&8)>>3};return[i,n]}function Ki(e){var r=e._R(2),t=e._R(2),a=e._R(2),n=e._R(2);var i=e._R(2),s=e._R(2),f=e._R(2);var l=e._R(2),o=e._R(2);return{Pos:[r,t],Dim:[a,n],Flags:i,CurTab:s,FirstTab:f,Selected:l,TabRatio:o}}function Yi(){var e=Jr(18);e._W(2,0);e._W(2,0);e._W(2,29280);e._W(2,17600);e._W(2,56);e._W(2,0);e._W(2,0);e._W(2,1);e._W(2,500);return e}function Qi(e,r,t){if(t&&t.biff>=2&&t.biff<5)return{};var a=e._R(2);return{RTL:a&64}}function Ji(e){var r=Jr(18),t=1718;if(e&&e.RTL)t|=64;r._W(2,t);r._W(4,0);r._W(4,64);r._W(4,0);r._W(4,0);return r}function Zi(){}function qi(e,r,t){var a={dyHeight:e._R(2),fl:e._R(2)};switch(t&&t.biff||8){case 2:break;case 3:;case 4:e.l+=2;break;default:e.l+=10;break;}a.name=qn(e,0,t);return a}function es(e,r){var t=e.name||"Arial";var a=r&&r.biff==5,n=a?15+t.length:16+2*t.length;var i=Jr(n);i._W(2,(e.sz||12)*20);i._W(4,0);i._W(2,400);i._W(4,0);i._W(2,0);i._W(1,t.length);if(!a)i._W(1,1);i._W((a?1:2)*t.length,t,a?"sbcs":"utf16le");return i}function rs(e){var r=bi(e);r.isst=e._R(4);return r}function ts(e,r,t,a){var n=Jr(10);mi(e,r,a,n);n._W(4,t);return n}function as(e,r,t){if(t.biffguess&&t.biff==2)t.biff=5;var a=e.l+r;var n=bi(e,6);if(t.biff==2)e.l++;var i=ai(e,a-e.l,t);n.val=i;return n}function ns(e,r,t,a,n){var i=!n||n.biff==8;var s=Jr(6+2+ +i+(1+i)*t.length);mi(e,r,a,s);s._W(2,t.length);if(i)s._W(1,1);s._W((1+i)*t.length,t,i?"utf16le":"sbcs");
return s}function is(e,r,t){var a=e._R(2);var n=ni(e,0,t);return[a,n]}function ss(e,r,t,a){var n=t&&t.biff==5;if(!a)a=Jr(n?3+r.length:5+2*r.length);a._W(2,e);a._W(n?1:2,r.length);if(!n)a._W(1,1);a._W((n?1:2)*r.length,r,n?"sbcs":"utf16le");var i=a.length>a.l?a.slice(0,a.l):a;if(i.l==null)i.l=i.length;return i}var fs=ni;function ls(e,r,t){var a=e.l+r;var n=t.biff==8||!t.biff?4:2;var i=e._R(n),s=e._R(n);var f=e._R(2),l=e._R(2);e.l=a;return{s:{r:i,c:f},e:{r:s,c:l}}}function os(e,r){var t=r.biff==8||!r.biff?4:2;var a=Jr(2*t+6);a._W(t,e.s.r);a._W(t,e.e.r+1);a._W(2,e.s.c);a._W(2,e.e.c+1);a._W(2,0);return a}function cs(e){var r=e._R(2),t=e._R(2);var a=ki(e);return{r:r,c:t,ixfe:a[0],rknum:a[1]}}function us(e,r){var t=e.l+r-2;var a=e._R(2),n=e._R(2);var i=[];while(e.l<t)i.push(ki(e));if(e.l!==t)throw new Error("MulRK read error");var s=e._R(2);if(i.length!=s-n+1)throw new Error("MulRK length mismatch");return{r:a,c:n,C:s,rkrec:i}}function hs(e,r){var t=e.l+r-2;var a=e._R(2),n=e._R(2);var i=[];while(e.l<t)i.push(e._R(2));if(e.l!==t)throw new Error("MulBlank read error");var s=e._R(2);if(i.length!=s-n+1)throw new Error("MulBlank length mismatch");return{r:a,c:n,C:s,ixfe:i}}function ds(e,r,t,a){var n={};var i=e._R(4),s=e._R(4);var f=e._R(4),l=e._R(2);n.patternType=Ta[f>>26];if(!a.cellStyles)return n;n.alc=i&7;n.fWrap=i>>3&1;n.alcV=i>>4&7;n.fJustLast=i>>7&1;n.trot=i>>8&255;n.cIndent=i>>16&15;n.fShrinkToFit=i>>20&1;n.iReadOrder=i>>22&2;n.fAtrNum=i>>26&1;n.fAtrFnt=i>>27&1;n.fAtrAlc=i>>28&1;n.fAtrBdr=i>>29&1;n.fAtrPat=i>>30&1;n.fAtrProt=i>>31&1;n.dgLeft=s&15;n.dgRight=s>>4&15;n.dgTop=s>>8&15;n.dgBottom=s>>12&15;n.icvLeft=s>>16&127;n.icvRight=s>>23&127;n.grbitDiag=s>>30&3;n.icvTop=f&127;n.icvBottom=f>>7&127;n.icvDiag=f>>14&127;n.dgDiag=f>>21&15;n.icvFore=l&127;n.icvBack=l>>7&127;n.fsxButton=l>>14&1;return n}function vs(e,r,t){var a={};a.ifnt=e._R(2);a.numFmtId=e._R(2);a.flags=e._R(2);a.fStyle=a.flags>>2&1;r-=6;a.data=ds(e,r,a.fStyle,t);return a}function ps(e,r,t,a){var n=t&&t.biff==5;if(!a)a=Jr(n?16:20);a._W(2,0);if(e.style){a._W(2,e.numFmtId||0);a._W(2,65524)}else{a._W(2,e.numFmtId||0);a._W(2,r<<4)}var i=0;if(e.numFmtId>0&&n)i|=1024;a._W(4,i);a._W(4,0);if(!n)a._W(4,0);a._W(2,0);return a}function bs(e){e.l+=4;var r=[e._R(2),e._R(2)];if(r[0]!==0)r[0]--;if(r[1]!==0)r[1]--;if(r[0]>7||r[1]>7)throw new Error("Bad Gutters: "+r.join("|"));return r}function ms(e){var r=Jr(8);r._W(4,0);r._W(2,e[0]?e[0]+1:0);r._W(2,e[1]?e[1]+1:0);return r}function gs(e,r,t){var a=bi(e,6);if(t.biff==2||r==9)++e.l;var n=Jn(e,2);a.val=n;a.t=n===true||n===false?"b":"e";return a}function Es(e,r,t,a,n,i){var s=Jr(8);mi(e,r,a,s);Zn(t,i,s);return s}function ws(e,r,t){if(t.biffguess&&t.biff==2)t.biff=5;var a=bi(e,6);var n=Zt(e,8);a.val=n;return a}function ks(e,r,t,a){var n=Jr(14);mi(e,r,a,n);qt(t,n);return n}var Ss=Ei;function Bs(e,r,t){var a=e.l+r;var n=e._R(2);var i=e._R(2);t.sbcch=i;if(i==1025||i==14849)return[i,n];if(i<1||i>255)throw new Error("Unexpected SupBook type: "+i);var s=ti(e,i);var f=[];while(a>e.l)f.push(ai(e));return[i,n,s,f]}function Cs(e,r,t){var a=e._R(2);var n;var i={fBuiltIn:a&1,fWantAdvise:a>>>1&1,fWantPict:a>>>2&1,fOle:a>>>3&1,fOleLink:a>>>4&1,cf:a>>>5&1023,fIcon:a>>>15&1};if(t.sbcch===14849)n=Si(e,r-2,t);i.body=n||e._R(r-2);if(typeof n==="string")i.Name=n;return i}var Ts=["_xlnm.Consolidate_Area","_xlnm.Auto_Open","_xlnm.Auto_Close","_xlnm.Extract","_xlnm.Database","_xlnm.Criteria","_xlnm.Print_Area","_xlnm.Print_Titles","_xlnm.Recorder","_xlnm.Data_Form","_xlnm.Auto_Activate","_xlnm.Auto_Deactivate","_xlnm.Sheet_Title","_xlnm._FilterDatabase"];function _s(e,r,t){var a=e.l+r;var n=e._R(2);var i=e._R(1);var s=e._R(1);var f=e._R(t&&t.biff==2?1:2);var l=0;if(!t||t.biff>=5){if(t.biff!=5)e.l+=2;l=e._R(2);if(t.biff==5)e.l+=2;e.l+=4}var o=ti(e,s,t);if(n&32)o=Ts[o.charCodeAt(0)];var c=a-e.l;if(t&&t.biff==2)--c;var u=a==e.l||f===0||!(c>0)?[]:zu(e,c,t,f);return{chKey:i,Name:o,itab:l,rgce:u}}function xs(e,r,t){if(t.biff<8)return As(e,r,t);var a=[],n=e.l+r,i=e._R(t.biff>8?4:2);while(i--!==0)a.push(wi(e,t.biff>8?12:6,t));if(e.l!=n)throw new Error("Bad ExternSheet: "+e.l+" != "+n);return a}function As(e,r,t){if(e[e.l+1]==3)e[e.l]++;var a=qn(e,r,t);return a.charCodeAt(0)==3?a.slice(1):a}function ys(e,r,t){if(t.biff<8){e.l+=r;return}var a=e._R(2);var n=e._R(2);var i=ti(e,a,t);var s=ti(e,n,t);return[i,s]}function Is(e,r,t){var a=Ti(e,6);e.l++;var n=e._R(1);r-=8;return[ju(e,r,t),n,a]}function Rs(e,r,t){var a=_i(e,6);switch(t.biff){case 2:e.l++;r-=7;break;case 3:;case 4:e.l+=2;r-=8;break;default:e.l+=6;r-=12;}return[a,Xu(e,r,t,a)]}function Fs(e){var r=e._R(4)!==0;var t=e._R(4)!==0;var a=e._R(4);return[r,t,a]}function Ds(e,r,t){if(t.biff<8)return;var a=e._R(2),n=e._R(2);var i=e._R(2),s=e._R(2);var f=ni(e,0,t);if(t.biff<8)e._R(1);return[{r:a,c:n},f,s,i]}function Os(e,r,t){return Ds(e,r,t)}function Ps(e,r){var t=[];var a=e._R(2);while(a--)t.push(Bi(e,r));return t}function Ns(e){var r=Jr(2+e.length*8);r._W(2,e.length);for(var t=0;t<e.length;++t)Ci(e[t],r);return r}function Ms(e,r,t){if(t&&t.biff<8)return Us(e,r,t);var a=xi(e,22);var n=Fi(e,r-22,a[1]);return{cmo:a,ft:n}}var Ls=[];Ls[8]=function(e,r){var t=e.l+r;e.l+=10;var a=e._R(2);e.l+=4;e.l+=2;e.l+=2;e.l+=2;e.l+=4;var n=e._R(1);e.l+=n;e.l=t;return{fmt:a}};function Us(e,r,t){e.l+=4;var a=e._R(2);var n=e._R(2);var i=e._R(2);e.l+=2;e.l+=2;e.l+=2;e.l+=2;e.l+=2;e.l+=2;e.l+=2;e.l+=2;e.l+=2;e.l+=6;r-=36;var s=[];s.push((Ls[a]||Qr)(e,r,t));return{cmo:[n,a,i],ft:s}}function Hs(e,r,t){var a=e.l;var n="";try{e.l+=4;var i=(t.lastobj||{cmo:[0,0]}).cmo[1];var s;if([0,5,7,11,12,14].indexOf(i)==-1)e.l+=6;else s=si(e,6,t);var f=e._R(2);e._R(2);Kn(e,2);var l=e._R(2);e.l+=l;for(var o=1;o<e.lens.length-1;++o){if(e.l-a!=e.lens[o])throw new Error("TxO: bad continue record");var c=e[e.l];var u=ti(e,e.lens[o+1]-e.lens[o]-1);n+=u;if(n.length>=(c?f:2*f))break}if(n.length!==f&&n.length!==f*2){throw new Error("cchText: "+f+" != "+n.length)}e.l=a+r;return{t:n}}catch(h){e.l=a+r;return{t:n}}}function Ws(e,r){var t=Bi(e,8);e.l+=16;var a=hi(e,r-24);return[t,a]}function Vs(e){var r=Jr(24);var t=bt(e[0]);r._W(2,t.r);r._W(2,t.r);r._W(2,t.c);r._W(2,t.c);var a="d0 c9 ea 79 f9 ba ce 11 8c 82 00 aa 00 4b a9 0b".split(" ");for(var n=0;n<16;++n)r._W(1,parseInt(a[n],16));return I([r,di(e[1])])}function Xs(e,r){e._R(2);var t=Bi(e,8);var a=e._R((r-10)/2,"dbcs-cont");a=a.replace(R,"");return[t,a]}function Gs(e){var r=e[1].Tooltip;var t=Jr(10+2*(r.length+1));t._W(2,2048);var a=bt(e[0]);t._W(2,a.r);t._W(2,a.r);t._W(2,a.c);t._W(2,a.c);for(var n=0;n<r.length;++n)t._W(2,r.charCodeAt(n));t._W(2,0);return t}function zs(e){var r=[0,0],t;t=e._R(2);r[0]=Ca[t]||t;t=e._R(2);r[1]=Ca[t]||t;return r}function js(e){if(!e)e=Jr(4);e._W(2,1);e._W(2,1);return e}function $s(e){var r=e._R(2);var t=[];while(r-- >0)t.push(pi(e,8));return t}function Ks(e){var r=e._R(2);var t=[];while(r-- >0)t.push(pi(e,8));return t}function Ys(e){e.l+=2;var r={cxfs:0,crc:0};r.cxfs=e._R(2);r.crc=e._R(4);return r}function Qs(e,r,t){if(!t.cellStyles)return Qr(e,r);var a=t&&t.biff>=12?4:2;var n=e._R(a);var i=e._R(a);var s=e._R(a);var f=e._R(a);var l=e._R(2);if(a==2)e.l+=2;var o={s:n,e:i,w:s,ixfe:f,flags:l};if(t.biff>=5||!t.biff)o.level=l>>8&7;return o}function Js(e,r){var t=Jr(12);t._W(2,r);t._W(2,r);t._W(2,e.width*256);t._W(2,0);var a=0;if(e.hidden)a|=1;t._W(1,a);a=e.level||0;t._W(1,a);t._W(2,0);return t}function Zs(e,r){var t={};if(r<32)return t;e.l+=16;t.header=Zt(e,8);t.footer=Zt(e,8);e.l+=2;return t}function qs(e,r,t){var a={area:false};if(t.biff!=5){e.l+=r;return a}var n=e._R(1);e.l+=3;if(n&16)a.area=true;return a}function ef(e){var r=Jr(2*e);for(var t=0;t<e;++t)r._W(2,t+1);return r}var rf=bi;var tf=Qn;var af=ai;function nf(e){var r=e._R(2);var t=e._R(2);var a=e._R(4);var n={fmt:r,env:t,len:a,data:e.slice(e.l,e.l+a)};e.l+=a;return n}function sf(e,r,t){if(t.biffguess&&t.biff==5)t.biff=2;var a=bi(e,6);++e.l;var n=ni(e,r-7,t);a.t="str";a.val=n;return a}function ff(e){var r=bi(e,6);++e.l;var t=Zt(e,8);r.t="n";r.val=t;return r}function lf(e,r,t){var a=Jr(15);nb(a,e,r);a._W(8,t,"f");return a}function of(e){var r=bi(e,6);++e.l;var t=e._R(2);r.t="n";r.val=t;return r}function cf(e,r,t){var a=Jr(9);nb(a,e,r);a._W(2,t);return a}function uf(e){var r=e._R(1);if(r===0){e.l++;return""}return e._R(r,"sbcs-cont")}function hf(e,r){e.l+=6;e.l+=2;e.l+=1;e.l+=3;e.l+=1;e.l+=r-13}function df(e,r,t){var a=e.l+r;var n=bi(e,6);var i=e._R(2);var s=ti(e,i,t);e.l=a;n.t="str";n.val=s;return n}var vf=function(){var e={1:437,2:850,3:1252,4:1e4,100:852,101:866,102:865,103:861,104:895,105:620,106:737,107:857,120:950,121:949,122:936,123:932,124:874,125:1255,126:1256,150:10007,151:10029,152:10006,200:1250,201:1251,202:1254,203:1253,0:20127,8:865,9:437,10:850,11:437,13:437,14:850,15:437,16:850,17:437,18:850,19:932,20:850,21:437,22:850,23:865,24:437,25:437,26:850,27:437,28:863,29:850,31:852,34:852,35:852,36:860,37:850,38:866,55:850,64:852,77:936,78:949,79:950,80:874,87:1252,88:1252,89:1252,108:863,134:737,135:852,136:857,204:1257,255:16969};var r=Q({1:437,2:850,3:1252,4:1e4,100:852,101:866,102:865,103:861,104:895,105:620,106:737,107:857,120:950,121:949,122:936,123:932,124:874,125:1255,126:1256,150:10007,151:10029,152:10006,200:1250,201:1251,202:1254,203:1253,0:20127});var a=[2,3,48,49,131,139,140,245];function n(r,t){var a=[];var n=B(1);switch(t.type){case"base64":n=T(g.decode(r));break;case"binary":n=T(r);break;case"buffer":;case"array":n=r;break;}Yr(n,0);var i=n._R(1);var s=!!(i&136);var f=false,l=false;switch(i){case 2:break;case 3:break;case 48:f=true;s=true;break;case 49:f=true;s=true;break;case 131:break;case 139:break;case 140:l=true;break;case 245:break;default:throw new Error("DBF Unsupported Version: "+i.toString(16));}var o=0,c=521;if(i==2)o=n._R(2);n.l+=3;if(i!=2)o=n._R(4);if(o>1048576)o=1e6;if(i!=2)c=n._R(2);var u=n._R(2);var h=t.codepage||1252;if(i!=2){n.l+=16;n._R(1);if(n[n.l]!==0)h=e[n[n.l]];n.l+=1;n.l+=2}if(l)n.l+=36;var d=[],v={};var p=Math.min(n.length,i==2?521:c-10-(f?264:0));var b=l?32:11;while(n.l<p&&n[n.l]!=13){v={};v.name=cptable.utils.decode(h,n.slice(n.l,n.l+b)).replace(/[\u0000\r\n].*$/g,"");n.l+=b;v.type=String.fromCharCode(n._R(1));if(i!=2&&!l)v.offset=n._R(4);v.len=n._R(1);if(i==2)v.offset=n._R(2);v.dec=n._R(1);if(v.name.length)d.push(v);if(i!=2)n.l+=l?13:14;switch(v.type){case"B":if((!f||v.len!=8)&&t.WTF)console.log("Skipping "+v.name+":"+v.type);break;case"G":;case"P":if(t.WTF)console.log("Skipping "+v.name+":"+v.type);break;case"+":;case"0":;case"@":;case"C":;case"D":;case"F":;case"I":;case"L":;case"M":;case"N":;case"O":;case"T":;case"Y":break;default:throw new Error("Unknown Field Type: "+v.type);}}if(n[n.l]!==13)n.l=c-1;if(n._R(1)!==13)throw new Error("DBF Terminator not found "+n.l+" "+n[n.l]);n.l=c;var m=0,E=0;a[0]=[];for(E=0;E!=d.length;++E)a[0][E]=d[E].name;while(o-- >0){if(n[n.l]===42){n.l+=u;continue}++n.l;a[++m]=[];E=0;for(E=0;E!=d.length;++E){var w=n.slice(n.l,n.l+d[E].len);n.l+=d[E].len;Yr(w,0);var k=cptable.utils.decode(h,w);switch(d[E].type){case"C":if(k.trim().length)a[m][E]=k.replace(/\s+$/,"");break;case"D":if(k.length===8)a[m][E]=new Date(+k.slice(0,4),+k.slice(4,6)-1,+k.slice(6,8));else a[m][E]=k;break;case"F":a[m][E]=parseFloat(k.trim());break;case"+":;case"I":a[m][E]=l?w._R(-4,"i")^2147483648:w._R(4,"i");break;case"L":switch(k.trim().toUpperCase()){case"Y":;case"T":a[m][E]=true;break;case"N":;case"F":a[m][E]=false;break;case"":;case"?":break;default:throw new Error("DBF Unrecognized L:|"+k+"|");}break;case"M":if(!s)throw new Error("DBF Unexpected MEMO for type "+i.toString(16));a[m][E]="##MEMO##"+(l?parseInt(k.trim(),10):w._R(4));break;case"N":k=k.replace(/\u0000/g,"").trim();if(k&&k!=".")a[m][E]=+k||0;break;case"@":a[m][E]=new Date(w._R(-8,"f")-621356832e5);break;case"T":a[m][E]=new Date((w._R(4)-2440588)*864e5+w._R(4));break;case"Y":a[m][E]=w._R(4,"i")/1e4;break;case"O":a[m][E]=-w._R(-8,"f");break;case"B":if(f&&d[E].len==8){a[m][E]=w._R(8,"f");break};case"G":;case"P":w.l+=d[E].len;break;case"0":if(d[E].name==="_NullFlags")break;default:throw new Error("DBF Unsupported data type "+d[E].type);}}}if(i!=2)if(n.l<n.length&&n[n.l++]!=26)throw new Error("DBF EOF Marker missing "+(n.l-1)+" of "+n.length+" "+n[n.l-1].toString(16));if(t&&t.sheetRows)a=a.slice(0,t.sheetRows);return a}function i(e,r){var t=r||{};if(!t.dateNF)t.dateNF="yyyymmdd";return Tt(n(e,t),t)}function s(e,r){try{return Bt(i(e,r),r)}catch(t){if(r&&r.WTF)throw t}return{SheetNames:[],Sheets:{}}}var f={B:8,C:250,L:1,D:8,"?":0,"":0};function o(e,a){var n=a||{};if(+n.codepage>=0)l(+n.codepage);if(n.type=="string")throw new Error("Cannot write DBF to JS string");var i=qr();var s=Sm(e,{header:1,raw:true,cellDates:true});var o=s[0],c=s.slice(1);var u=0,h=0,d=0,v=1;for(u=0;u<o.length;++u){if(u==null)continue;++d;if(typeof o[u]==="number")o[u]=o[u].toString(10);if(typeof o[u]!=="string")throw new Error("DBF Invalid column name "+o[u]+" |"+typeof o[u]+"|");if(o.indexOf(o[u])!==u)for(h=0;h<1024;++h)if(o.indexOf(o[u]+"_"+h)==-1){o[u]+="_"+h;break}}var p=wt(e["!ref"]);var b=[];for(u=0;u<=p.e.c-p.s.c;++u){var m=[];for(h=0;h<c.length;++h){if(c[h][u]!=null)m.push(c[h][u])}if(m.length==0||o[u]==null){b[u]="?";continue}var g="",E="";for(h=0;h<m.length;++h){switch(typeof m[h]){case"number":E="B";break;case"string":E="C";break;case"boolean":E="L";break;case"object":E=m[h]instanceof Date?"D":"C";break;default:E="C";}g=g&&g!=E?"C":E;if(g=="C")break}v+=f[g]||0;b[u]=g}var w=i.next(32);w._W(4,318902576);w._W(4,c.length);w._W(2,296+32*d);w._W(2,v);for(u=0;u<4;++u)w._W(4,0);w._W(4,0|(+r[t]||3)<<8);for(u=0,h=0;u<o.length;++u){if(o[u]==null)continue;var k=i.next(32);var S=(o[u].slice(-10)+"\0\0\0\0\0\0\0\0\0\0\0").slice(0,11);k._W(1,S,"sbcs");k._W(1,b[u]=="?"?"C":b[u],"sbcs");k._W(4,h);k._W(1,f[b[u]]||0);k._W(1,0);k._W(1,2);k._W(4,0);k._W(1,0);k._W(4,0);k._W(4,0);h+=f[b[u]]||0}var B=i.next(264);B._W(4,13);for(u=0;u<65;++u)B._W(4,0);for(u=0;u<c.length;++u){var C=i.next(v);C._W(1,0);for(h=0;h<o.length;++h){if(o[h]==null)continue;switch(b[h]){case"L":C._W(1,c[u][h]==null?63:c[u][h]?84:70);break;case"B":C._W(8,c[u][h]||0,"f");break;case"D":if(!c[u][h])C._W(8,"00000000","sbcs");else{C._W(4,("0000"+c[u][h].getFullYear()).slice(-4),"sbcs");C._W(2,("00"+(c[u][h].getMonth()+1)).slice(-2),"sbcs");C._W(2,("00"+c[u][h].getDate()).slice(-2),"sbcs")}break;case"C":var T=String(c[u][h]||"");C._W(1,T,"sbcs");for(d=0;d<250-T.length;++d)C._W(1,32);break;}}}i.next(1)._W(1,26);return i.end()}return{versions:a,to_workbook:s,to_sheet:i,from_sheet:o}}();var pf=function(){var e={AA:"À",BA:"Á",CA:"Â",DA:195,HA:"Ä",JA:197,AE:"È",BE:"É",CE:"Ê",HE:"Ë",AI:"Ì",BI:"Í",CI:"Î",HI:"Ï",AO:"Ò",BO:"Ó",CO:"Ô",DO:213,HO:"Ö",AU:"Ù",BU:"Ú",CU:"Û",HU:"Ü",Aa:"à",Ba:"á",Ca:"â",Da:227,Ha:"ä",Ja:229,Ae:"è",Be:"é",Ce:"ê",He:"ë",Ai:"ì",Bi:"í",Ci:"î",Hi:"ï",Ao:"ò",Bo:"ó",Co:"ô",Do:245,Ho:"ö",Au:"ù",Bu:"ú",Cu:"û",Hu:"ü",KC:"Ç",Kc:"ç",q:"æ",z:"œ",a:"Æ",j:"Œ",DN:209,Dn:241,Hy:255,S:169,c:170,R:174,"B ":180,0:176,1:177,2:178,3:179,5:181,6:182,7:183,Q:185,k:186,b:208,i:216,l:222,s:240,y:248,"!":161,'"':162,"#":163,"(":164,"%":165,"'":167,"H ":168,"+":171,";":187,"<":188,"=":189,">":190,"?":191,"{":223};var r=new RegExp("N("+K(e).join("|").replace(/\|\|\|/,"|\\||").replace(/([?()+])/g,"\\$1")+"|\\|)","gm");var t=function(r,t){var a=e[t];return typeof a=="number"?p(a):a};var a=function(e,r,t){var a=r.charCodeAt(0)-32<<4|t.charCodeAt(0)-48;return a==59?e:p(a)};e["|"]=254;function n(e,r){switch(r.type){case"base64":return i(g.decode(e),r);case"binary":return i(e,r);case"buffer":return i(E&&Buffer.isBuffer(e)?e.toString("binary"):x(e),r);case"array":return i(oe(e),r);}throw new Error("Unrecognized type "+r.type)}function i(e,n){var i=e.split(/[\n\r]+/),s=-1,f=-1,o=0,c=0,u=[];var h=[];var d=null;var v={},p=[],b=[],m=[];var g=0,E;if(+n.codepage>=0)l(+n.codepage);for(;o!==i.length;++o){g=0;var w=i[o].trim().replace(/\x1B([\x20-\x2F])([\x30-\x3F])/g,a).replace(r,t);var k=w.replace(/;;/g,"\0").split(";").map(function(e){return e.replace(/\u0000/g,";")});var S=k[0],B;if(w.length>0)switch(S){case"ID":break;case"E":break;case"B":break;case"O":break;case"W":break;case"P":if(k[1].charAt(0)=="P")h.push(w.slice(3).replace(/;;/g,";"));break;case"C":var C=false,T=false,_=false,x=false,A=-1,y=-1;for(c=1;c<k.length;++c)switch(k[c].charAt(0)){case"A":break;case"X":f=parseInt(k[c].slice(1))-1;T=true;break;case"Y":s=parseInt(k[c].slice(1))-1;if(!T)f=0;for(E=u.length;E<=s;++E)u[E]=[];break;case"K":B=k[c].slice(1);if(B.charAt(0)==='"')B=B.slice(1,B.length-1);else if(B==="TRUE")B=true;else if(B==="FALSE")B=false;else if(!isNaN(he(B))){B=he(B);if(d!==null&&D.is_date(d))B=ne(B)}else if(!isNaN(de(B).getDate())){B=le(B)}if(typeof cptable!=="undefined"&&typeof B=="string"&&(n||{}).type!="string"&&(n||{}).codepage)B=cptable.utils.decode(n.codepage,B);C=true;break;case"E":x=true;var I=sc(k[c].slice(1),{r:s,c:f});u[s][f]=[u[s][f],I];break;case"S":_=true;u[s][f]=[u[s][f],"S5S"];break;case"G":break;case"R":A=parseInt(k[c].slice(1))-1;break;case"C":y=parseInt(k[c].slice(1))-1;break;default:if(n&&n.WTF)throw new Error("SYLK bad record "+w);}if(C){if(u[s][f]&&u[s][f].length==2)u[s][f][0]=B;else u[s][f]=B;d=null}if(_){if(x)throw new Error("SYLK shared formula cannot have own formula");var R=A>-1&&u[A][y];if(!R||!R[1])throw new Error("SYLK shared formula cannot find base");u[s][f][1]=oc(R[1],{r:s-A,c:f-y})}break;case"F":var F=0;for(c=1;c<k.length;++c)switch(k[c].charAt(0)){case"X":f=parseInt(k[c].slice(1))-1;++F;break;case"Y":s=parseInt(k[c].slice(1))-1;for(E=u.length;E<=s;++E)u[E]=[];break;case"M":g=parseInt(k[c].slice(1))/20;break;case"F":break;case"G":break;case"P":d=h[parseInt(k[c].slice(1))];break;case"S":break;case"D":break;case"N":break;case"W":m=k[c].slice(1).split(" ");for(E=parseInt(m[0],10);E<=parseInt(m[1],10);++E){g=parseInt(m[2],10);b[E-1]=g===0?{hidden:true}:{wch:g};Bl(b[E-1])}break;case"C":f=parseInt(k[c].slice(1))-1;if(!b[f])b[f]={};break;case"R":s=parseInt(k[c].slice(1))-1;if(!p[s])p[s]={};if(g>0){p[s].hpt=g;p[s].hpx=xl(g)}else if(g===0)p[s].hidden=true;break;default:if(n&&n.WTF)throw new Error("SYLK bad record "+w);}if(F<1)d=null;break;default:if(n&&n.WTF)throw new Error("SYLK bad record "+w);}}if(p.length>0)v["!rows"]=p;if(b.length>0)v["!cols"]=b;if(n&&n.sheetRows)u=u.slice(0,n.sheetRows);return[u,v]}function s(e,r){var t=n(e,r);var a=t[0],i=t[1];var s=Tt(a,r);K(i).forEach(function(e){s[e]=i[e]});return s}function f(e,r){return Bt(s(e,r),r)}function o(e,r,t,a){var n="C;Y"+(t+1)+";X"+(a+1)+";K";switch(e.t){case"n":n+=e.v||0;if(e.f&&!e.F)n+=";E"+lc(e.f,{r:t,c:a});break;case"b":n+=e.v?"TRUE":"FALSE";break;case"e":n+=e.w||e.v;break;case"d":n+='"'+(e.w||e.v)+'"';break;case"s":n+='"'+e.v.replace(/"/g,"")+'"';break;}return n}function c(e,r){r.forEach(function(r,t){var a="F;W"+(t+1)+" "+(t+1)+" ";if(r.hidden)a+="0";else{if(typeof r.width=="number"&&!r.wpx)r.wpx=gl(r.width);if(typeof r.wpx=="number"&&!r.wch)r.wch=El(r.wpx);if(typeof r.wch=="number")a+=Math.round(r.wch)}if(a.charAt(a.length-1)!=" ")e.push(a)})}function u(e,r){r.forEach(function(r,t){var a="F;";if(r.hidden)a+="M0;";else if(r.hpt)a+="M"+20*r.hpt+";";else if(r.hpx)a+="M"+20*_l(r.hpx)+";";if(a.length>2)e.push(a+"R"+(t+1))})}function h(e,r){var t=["ID;PWXL;N;E"],a=[];var n=wt(e["!ref"]),i;var s=Array.isArray(e);var f="\r\n";t.push("P;PGeneral");t.push("F;P0;DG0G8;M255");if(e["!cols"])c(t,e["!cols"]);if(e["!rows"])u(t,e["!rows"]);t.push("B;Y"+(n.e.r-n.s.r+1)+";X"+(n.e.c-n.s.c+1)+";D"+[n.s.c,n.s.r,n.e.c,n.e.r].join(" "));for(var l=n.s.r;l<=n.e.r;++l){for(var h=n.s.c;h<=n.e.c;++h){var d=mt({r:l,c:h});i=s?(e[l]||[])[h]:e[d];if(!i||i.v==null&&(!i.f||i.F))continue;a.push(o(i,e,l,h,r))}}return t.join(f)+f+a.join(f)+f+"E"+f}return{to_workbook:f,to_sheet:s,from_sheet:h}}();var bf=function(){function e(e,t){switch(t.type){case"base64":return r(g.decode(e),t);case"binary":return r(e,t);case"buffer":return r(E&&Buffer.isBuffer(e)?e.toString("binary"):x(e),t);case"array":return r(oe(e),t);}throw new Error("Unrecognized type "+t.type)}function r(e,r){var t=e.split("\n"),a=-1,n=-1,i=0,s=[];for(;i!==t.length;++i){if(t[i].trim()==="BOT"){s[++a]=[];n=0;continue}if(a<0)continue;var f=t[i].trim().split(",");var l=f[0],o=f[1];++i;var c=t[i]||"";while((c.match(/["]/g)||[]).length&1&&i<t.length-1)c+="\n"+t[++i];c=c.trim();switch(+l){case-1:if(c==="BOT"){s[++a]=[];n=0;continue}else if(c!=="EOD")throw new Error("Unrecognized DIF special command "+c);break;case 0:if(c==="TRUE")s[a][n]=true;else if(c==="FALSE")s[a][n]=false;else if(!isNaN(he(o)))s[a][n]=he(o);else if(!isNaN(de(o).getDate()))s[a][n]=le(o);else s[a][n]=o;++n;break;case 1:c=c.slice(1,c.length-1);c=c.replace(/""/g,'"');if(m&&c&&c.match(/^=".*"$/))c=c.slice(2,-1);s[a][n++]=c!==""?c:null;break;}if(c==="EOD")break}if(r&&r.sheetRows)s=s.slice(0,r.sheetRows);return s}function t(r,t){return Tt(e(r,t),t)}function a(e,r){return Bt(t(e,r),r)}var n=function(){var e=function t(e,r,a,n,i){e.push(r);e.push(a+","+n);e.push('"'+i.replace(/"/g,'""')+'"')};var r=function a(e,r,t,n){e.push(r+","+t);e.push(r==1?'"'+n.replace(/"/g,'""')+'"':n)};return function n(t){var a=[];var n=wt(t["!ref"]),i;var s=Array.isArray(t);e(a,"TABLE",0,1,"sheetjs");e(a,"VECTORS",0,n.e.r-n.s.r+1,"");e(a,"TUPLES",0,n.e.c-n.s.c+1,"");e(a,"DATA",0,0,"");for(var f=n.s.r;f<=n.e.r;++f){r(a,-1,0,"BOT");for(var l=n.s.c;l<=n.e.c;++l){var o=mt({r:f,c:l});i=s?(t[f]||[])[l]:t[o];if(!i){r(a,1,0,"");continue}switch(i.t){case"n":var c=m?i.w:i.v;if(!c&&i.v!=null)c=i.v;if(c==null){if(m&&i.f&&!i.F)r(a,1,0,"="+i.f);else r(a,1,0,"")}else r(a,0,c,"V");break;case"b":r(a,0,i.v?1:0,i.v?"TRUE":"FALSE");break;case"s":r(a,1,0,!m||isNaN(i.v)?i.v:'="'+i.v+'"');break;case"d":if(!i.w)i.w=D.format(i.z||D._table[14],ee(le(i.v)));if(m)r(a,0,i.w,"V");else r(a,1,0,i.w);break;default:r(a,1,0,"");}}}r(a,-1,0,"EOD");var u="\r\n";var h=a.join(u);return h}}();return{to_workbook:a,to_sheet:t,from_sheet:n}}();var mf=function(){function e(e){return e.replace(/\\b/g,"\\").replace(/\\c/g,":").replace(/\\n/g,"\n")}function r(e){return e.replace(/\\/g,"\\b").replace(/:/g,"\\c").replace(/\n/g,"\\n")}function t(r,t){var a=r.split("\n"),n=-1,i=-1,s=0,f=[];for(;s!==a.length;++s){var l=a[s].trim().split(":");if(l[0]!=="cell")continue;var o=bt(l[1]);if(f.length<=o.r)for(n=f.length;n<=o.r;++n)if(!f[n])f[n]=[];n=o.r;i=o.c;switch(l[2]){case"t":f[n][i]=e(l[3]);break;case"v":f[n][i]=+l[3];break;case"vtf":var c=l[l.length-1];case"vtc":switch(l[3]){case"nl":f[n][i]=+l[4]?true:false;break;default:f[n][i]=+l[4];break;}if(l[2]=="vtf")f[n][i]=[f[n][i],c];}}if(t&&t.sheetRows)f=f.slice(0,t.sheetRows);return f}function a(e,r){return Tt(t(e,r),r)}function n(e,r){return Bt(a(e,r),r)}var i=["socialcalc:version:1.5","MIME-Version: 1.0","Content-Type: multipart/mixed; boundary=SocialCalcSpreadsheetControlSave"].join("\n");var s=["--SocialCalcSpreadsheetControlSave","Content-type: text/plain; charset=UTF-8"].join("\n")+"\n";var f=["# SocialCalc Spreadsheet Control Save","part:sheet"].join("\n");var l="--SocialCalcSpreadsheetControlSave--";function o(e){if(!e||!e["!ref"])return"";var t=[],a=[],n,i="";var s=gt(e["!ref"]);var f=Array.isArray(e);for(var l=s.s.r;l<=s.e.r;++l){for(var o=s.s.c;o<=s.e.c;++o){i=mt({r:l,c:o});n=f?(e[l]||[])[o]:e[i];if(!n||n.v==null||n.t==="z")continue;a=["cell",i,"t"];switch(n.t){case"s":;case"str":a.push(r(n.v));break;case"n":if(!n.f){a[2]="v";a[3]=n.v}else{a[2]="vtf";a[3]="n";a[4]=n.v;a[5]=r(n.f)}break;case"b":a[2]="vt"+(n.f?"f":"c");a[3]="nl";a[4]=n.v?"1":"0";a[5]=r(n.f||(n.v?"TRUE":"FALSE"));break;case"d":var c=ee(le(n.v));a[2]="vtc";a[3]="nd";a[4]=""+c;a[5]=n.w||D.format(n.z||D._table[14],c);break;case"e":continue;}t.push(a.join(":"))}}t.push("sheet:c:"+(s.e.c-s.s.c+1)+":r:"+(s.e.r-s.s.r+1)+":tvf:1");t.push("valueformat:1:text-wiki");return t.join("\n")}function c(e){return[i,s,f,s,o(e),l].join("\n")}return{to_workbook:n,to_sheet:a,from_sheet:c}}();var gf=function(){function e(e,r,t,a,n){if(n.raw)r[t][a]=e;else if(e===""){}else if(e==="TRUE")r[t][a]=true;else if(e==="FALSE")r[t][a]=false;else if(!isNaN(he(e)))r[t][a]=he(e);else if(!isNaN(de(e).getDate()))r[t][a]=le(e);else r[t][a]=e}function r(r,t){var a=t||{};var n=[];if(!r||r.length===0)return n;var i=r.split(/[\r\n]/);var s=i.length-1;while(s>=0&&i[s].length===0)--s;var f=10,l=0;var o=0;for(;o<=s;++o){l=i[o].indexOf(" ");if(l==-1)l=i[o].length;else l++;f=Math.max(f,l)}for(o=0;o<=s;++o){n[o]=[];var c=0;e(i[o].slice(0,f).trim(),n,o,c,a);for(c=1;c<=(i[o].length-f)/10+1;++c)e(i[o].slice(f+(c-1)*10,f+c*10).trim(),n,o,c,a)}if(a.sheetRows)n=n.slice(0,a.sheetRows);return n}var t={44:",",9:"\t",59:";",124:"|"};var a={44:3,9:2,59:1,124:0};function n(e){var r={},n=false,i=0,s=0;for(;i<e.length;++i){if((s=e.charCodeAt(i))==34)n=!n;else if(!n&&s in t)r[s]=(r[s]||0)+1}s=[];for(i in r)if(Object.prototype.hasOwnProperty.call(r,i)){s.push([r[i],i])}if(!s.length){r=a;for(i in r)if(Object.prototype.hasOwnProperty.call(r,i)){s.push([r[i],i])}}s.sort(function(e,r){return e[0]-r[0]||a[e[1]]-a[r[1]]});return t[s.pop()[1]]||44}function i(e,r){var t=r||{};var a="";if(b!=null&&t.dense==null)t.dense=b;var i=t.dense?[]:{};var s={s:{c:0,r:0},e:{c:0,r:0}};if(e.slice(0,4)=="sep="){if(e.charCodeAt(5)==13&&e.charCodeAt(6)==10){a=e.charAt(4);e=e.slice(7)}else if(e.charCodeAt(5)==13||e.charCodeAt(5)==10){a=e.charAt(4);e=e.slice(6)}else a=n(e.slice(0,1024))}else if(t&&t.FS)a=t.FS;else a=n(e.slice(0,1024));var f=0,l=0,o=0;var c=0,u=0,h=a.charCodeAt(0),d=false,v=0,p=e.charCodeAt(0);e=e.replace(/\r\n/gm,"\n");var m=t.dateNF!=null?L(t.dateNF):null;function g(){var r=e.slice(c,u);var a={};if(r.charAt(0)=='"'&&r.charAt(r.length-1)=='"')r=r.slice(1,-1).replace(/""/g,'"');if(r.length===0)a.t="z";else if(t.raw){a.t="s";a.v=r}else if(r.trim().length===0){a.t="s";a.v=r}else if(r.charCodeAt(0)==61){if(r.charCodeAt(1)==34&&r.charCodeAt(r.length-1)==34){a.t="s";a.v=r.slice(2,-1).replace(/""/g,'"')}else if(uc(r)){a.t="n";a.f=r.slice(1)}else{a.t="s";a.v=r}}else if(r=="TRUE"){a.t="b";a.v=true}else if(r=="FALSE"){a.t="b";a.v=false}else if(!isNaN(o=he(r))){a.t="n";if(t.cellText!==false)a.w=r;a.v=o}else if(!isNaN(de(r).getDate())||m&&r.match(m)){a.z=t.dateNF||D._table[14];var n=0;if(m&&r.match(m)){r=U(r,t.dateNF,r.match(m)||[]);n=1}if(t.cellDates){a.t="d";a.v=le(r,n)}else{a.t="n";a.v=ee(le(r,n))}if(t.cellText!==false)a.w=D.format(a.z,a.v instanceof Date?ee(a.v):a.v);if(!t.cellNF)delete a.z}else{a.t="s";a.v=r}if(a.t=="z"){}else if(t.dense){if(!i[f])i[f]=[];i[f][l]=a}else i[mt({c:l,r:f})]=a;c=u+1;p=e.charCodeAt(c);if(s.e.c<l)s.e.c=l;if(s.e.r<f)s.e.r=f;if(v==h)++l;else{l=0;++f;if(t.sheetRows&&t.sheetRows<=f)return true}}e:for(;u<e.length;++u)switch(v=e.charCodeAt(u)){case 34:if(p===34)d=!d;break;case h:;case 10:;case 13:if(!d&&g())break e;break;default:break;}if(u-c>0)g();i["!ref"]=Et(s);return i}function s(e,t){if(!(t&&t.PRN))return i(e,t);if(t.FS)return i(e,t);if(e.slice(0,4)=="sep=")return i(e,t);if(e.indexOf("\t")>=0||e.indexOf(",")>=0||e.indexOf(";")>=0)return i(e,t);return Tt(r(e,t),t)}function f(e,r){var t="",a=r.type=="string"?[0,0,0,0]:rm(e,r);switch(r.type){case"base64":t=g.decode(e);break;case"binary":t=e;break;case"buffer":if(r.codepage==65001)t=e.toString("utf8");else if(r.codepage&&typeof cptable!=="undefined")t=cptable.utils.decode(r.codepage,e);else t=E&&Buffer.isBuffer(e)?e.toString("binary"):x(e);break;case"array":t=oe(e);break;case"string":t=e;break;default:throw new Error("Unrecognized type "+r.type);}if(a[0]==239&&a[1]==187&&a[2]==191)t=Ye(t.slice(3));else if(r.type!="string"&&r.codepage==65001)t=Ye(t);else if(r.type=="binary"&&typeof cptable!=="undefined"&&r.codepage)t=cptable.utils.decode(r.codepage,cptable.utils.encode(28591,t));if(t.slice(0,19)=="socialcalc:version:")return mf.to_sheet(r.type=="string"?t:Ye(t),r);return s(t,r)}function l(e,r){return Bt(f(e,r),r)}function o(e){var r=[];var t=wt(e["!ref"]),a;var n=Array.isArray(e);for(var i=t.s.r;i<=t.e.r;++i){var s=[];for(var f=t.s.c;f<=t.e.c;++f){var l=mt({r:i,c:f});a=n?(e[i]||[])[f]:e[l];if(!a||a.v==null){s.push("          ");continue}var o=(a.w||(St(a),a.w)||"").slice(0,10);while(o.length<10)o+=" ";s.push(o+(f===0?" ":""))}r.push(s.join(""))}return r.join("\n")}return{to_workbook:l,to_sheet:f,from_sheet:o}}();function Ef(e,r){var t=r||{},a=!!t.WTF;t.WTF=true;try{var n=pf.to_workbook(e,t);t.WTF=a;return n}catch(i){t.WTF=a;if(!i.message.match(/SYLK bad record ID/)&&a)throw i;return gf.to_workbook(e,r)}}var wf=function(){function e(e,r,t){if(!e)return;Yr(e,e.l||0);var a=t.Enum||U;while(e.l<e.length){var n=e._R(2);var i=a[n]||a[65535];var s=e._R(2);var f=e.l+s;var l=i.f&&i.f(e,s,t);e.l=f;if(r(l,i,n))return}}function r(e,r){switch(r.type){case"base64":return t(T(g.decode(e)),r);case"binary":return t(T(e),r);case"buffer":;case"array":return t(e,r);}throw"Unsupported type "+r.type}function t(r,t){if(!r)return r;var a=t||{};if(b!=null&&a.dense==null)a.dense=b;var n=a.dense?[]:{},i="Sheet1",s=0;var f={},l=[i],o=[];var c={s:{r:0,c:0},e:{r:0,c:0}};var u=a.sheetRows||0;if(r[2]==2){a.Enum=U;e(r,function(e,r,t){switch(t){case 0:a.vers=e;if(e>=4096)a.qpro=true;break;case 6:c=e;break;case 15:;case 51:if(!a.qpro)e[1].v=e[1].v.slice(1);case 13:;case 14:;case 16:if(t==14&&(e[2]&112)==112&&(e[2]&15)>1&&(e[2]&15)<15){e[1].z=a.dateNF||D._table[14];if(a.cellDates){e[1].t="d";e[1].v=ne(e[1].v)}}var i=a.dense?(n[e[0].r]||[])[e[0].c]:n[mt(e[0])];if(i){i.t=e[1].t;i.v=e[1].v;if(e[1].z!=null)i.z=e[1].z;if(e[1].f!=null)i.f=e[1].f;break}if(a.dense){if(!n[e[0].r])n[e[0].r]=[];n[e[0].r][e[0].c]=e[1]}else n[mt(e[0])]=e[1];break;default:;}},a)}else if(r[2]==26||r[2]==14){a.Enum=H;if(r[2]==14){a.qpro=true;r.l=0}e(r,function(e,r,t){switch(t){case 22:e[1].v=e[1].v.slice(1);case 23:;case 24:;case 25:;case 37:;case 39:;case 40:if(e[3]>s){n["!ref"]=Et(c);f[i]=n;n=a.dense?[]:{};c={s:{r:0,c:0},e:{r:0,c:0}};s=e[3];i="Sheet"+(s+1);l.push(i)}if(u>0&&e[0].r>=u)break;if(a.dense){if(!n[e[0].r])n[e[0].r]=[];n[e[0].r][e[0].c]=e[1]}else n[mt(e[0])]=e[1];if(c.e.c<e[0].c)c.e.c=e[0].c;if(c.e.r<e[0].r)c.e.r=e[0].r;break;case 27:if(e[14e3])o[e[14e3][0]]=e[14e3][1];break;default:break;}},a)}else throw new Error("Unrecognized LOTUS BOF "+r[2]);n["!ref"]=Et(c);f[i]=n;if(!o.length)return{SheetNames:l,Sheets:f};var h={},d=[];for(var v=0;v<o.length;++v)if(f[l[v]]){d.push(o[v]);h[o[v]]=f[l[v]]}return{SheetNames:d,Sheets:h}}function a(e,r){var t=r||{};if(+t.codepage>=0)l(+t.codepage);if(t.type=="string")throw new Error("Cannot write WK1 to JS string");var a=qr();var n=wt(e["!ref"]);var s=Array.isArray(e);var f=[];tb(a,0,i(1030));tb(a,6,o(n));for(var c=n.s.r;c<=n.e.r;++c){var u=lt(c);for(var d=n.s.c;d<=n.e.c;++d){if(c===n.s.r)f[d]=ht(d);var p=f[d]+u;var b=s?(e[c]||[])[d]:e[p];
if(!b||b.t=="z")continue;if(b.t=="n"){if((b.v|0)==b.v&&b.v>=-32768&&b.v<=32767)tb(a,13,v(c,d,b.v));else tb(a,14,m(c,d,b.v))}else{var g=St(b);tb(a,15,h(c,d,g.slice(0,239)))}}}tb(a,1);return a.end()}function n(e,r){var t=r||{};if(+t.codepage>=0)l(+t.codepage);if(t.type=="string")throw new Error("Cannot write WK3 to JS string");var a=qr();tb(a,0,s(e));for(var n=0,i=0;n<e.SheetNames.length;++n)if((e.Sheets[e.SheetNames[n]]||{})["!ref"])tb(a,27,L(e.SheetNames[n],i++));var f=0;for(n=0;n<e.SheetNames.length;++n){var o=e.Sheets[e.SheetNames[n]];if(!o||!o["!ref"])continue;var c=wt(o["!ref"]);var u=Array.isArray(o);var h=[];for(var d=c.s.r;d<=c.e.r;++d){var v=lt(d);for(var p=c.s.c;p<=c.e.c;++p){if(d===c.s.r)h[p]=ht(p);var b=h[p]+v;var m=u?(o[d]||[])[p]:o[b];if(!m||m.t=="z")continue;if(m.t=="n"){tb(a,23,R(d,p,f,m.v))}else{var g=St(m);tb(a,22,A(d,p,f,g.slice(0,239)))}}}++f}tb(a,1);return a.end()}function i(e){var r=Jr(2);r._W(2,e);return r}function s(e){var r=Jr(26);r._W(2,4096);r._W(2,4);r._W(4,0);var t=0,a=0,n=0;for(var i=0;i<e.SheetNames.length;++i){var s=e.SheetNames[i];var f=e.Sheets[s];if(!f||!f["!ref"])continue;++n;var l=gt(f["!ref"]);if(t<l.e.r)t=l.e.r;if(a<l.e.c)a=l.e.c}r._W(2,t);r._W(1,n);r._W(1,a);r._W(2,0);r._W(2,0);r._W(1,1);r._W(1,2);r._W(4,0);r._W(4,0);return r}function f(e){var r={s:{c:0,r:0},e:{c:0,r:0}};r.s.c=e._R(2);r.s.r=e._R(2);r.e.c=e._R(2);r.e.r=e._R(2);if(r.s.c==65535)r.s.c=r.e.c=r.s.r=r.e.r=0;return r}function o(e){var r=Jr(8);r._W(2,e.s.c);r._W(2,e.s.r);r._W(2,e.e.c);r._W(2,e.e.r);return r}function c(e,r,t){var a=[{c:0,r:0},{t:"n",v:0},0];if(t.qpro&&t.vers!=20768){a[0].c=e._R(1);e.l++;a[0].r=e._R(2);e.l+=2}else{a[2]=e._R(1);a[0].c=e._R(2);a[0].r=e._R(2)}return a}function u(e,r,t){var a=e.l+r;var n=c(e,r,t);n[1].t="s";if(t.vers==20768){e.l++;var i=e._R(1);n[1].v=e._R(i,"utf8");return n}if(t.qpro)e.l++;n[1].v=e._R(a-e.l,"cstr");return n}function h(e,r,t){var a=Jr(7+t.length);a._W(1,255);a._W(2,r);a._W(2,e);a._W(1,39);for(var n=0;n<a.length;++n){var i=t.charCodeAt(n);a._W(1,i>=128?95:i)}a._W(1,0);return a}function d(e,r,t){var a=c(e,r,t);a[1].v=e._R(2,"i");return a}function v(e,r,t){var a=Jr(7);a._W(1,255);a._W(2,r);a._W(2,e);a._W(2,t,"i");return a}function p(e,r,t){var a=c(e,r,t);a[1].v=e._R(8,"f");return a}function m(e,r,t){var a=Jr(13);a._W(1,255);a._W(2,r);a._W(2,e);a._W(8,t,"f");return a}function E(e,r,t){var a=e.l+r;var n=c(e,r,t);n[1].v=e._R(8,"f");if(t.qpro)e.l=a;else{var i=e._R(2);C(e.slice(e.l,e.l+i),n);e.l+=i}return n}function w(e,r,t){var a=r&32768;r&=~32768;r=(a?e:0)+(r>=8192?r-16384:r);return(a?"":"$")+(t?ht(r):lt(r))}var k=[8,8,8,8,8,8,8,8,6,4,4,5,5,7,3,3,3,3,3,3,1,1,2,6,8,8,8,8,8,8,8,8];var S={51:["FALSE",0],52:["TRUE",0],70:["LEN",1],80:["SUM",69],81:["AVERAGEA",69],82:["COUNTA",69],83:["MINA",69],84:["MAXA",69],111:["T",1]};var B=["","","","","","","","","","+","-","*","/","^","=","<>","<=",">=","<",">","","","","","&","","","","","","",""];function C(e,r){Yr(e,0);var t=[],a=0,n="",i="";while(e.l<e.length){var s=e[e.l++];switch(s){case 0:t.push(e._R(8,"f"));break;case 1:{i=w(r[0].c,e._R(2),true);n=w(r[0].r,e._R(2),false);t.push(i+n)}break;case 2:{var f=w(r[0].c,e._R(2),true);var l=w(r[0].r,e._R(2),false);i=w(r[0].c,e._R(2),true);n=w(r[0].r,e._R(2),false);t.push(f+l+":"+i+n)}break;case 3:if(e.l<e.length){console.error("WK1 premature formula end");return}break;case 4:t.push("("+t.pop()+")");break;case 5:t.push(e._R(2));break;case 6:{var o="";while(s=e[e.l++])o+=String.fromCharCode(s);t.push('"'+o.replace(/"/g,'""')+'"');break}break;case 8:t.push("-"+t.pop());break;case 23:t.push("+"+t.pop());break;case 22:t.push("NOT("+t.pop()+")");break;case 20:;case 21:{var c=t.pop(),u=t.pop();t.push(["AND","OR"][s-20]+"("+u+","+c+")")}break;default:if(s<32&&B[s]){c=t.pop();u=t.pop();t.push(u+B[s]+c)}else if(S[s]){a=S[s][1];if(a==69)a=e[e.l++];if(a>t.length){console.error("WK1 bad formula parse 0x"+s.toString(16)+":|"+t.join("|")+"|");return}var h=t.slice(-a);t.length-=a;t.push(S[s][0]+"("+h.join(",")+")")}else if(s<=7)return console.error("WK1 invalid opcode "+s.toString(16));else if(s<=24)return console.error("WK1 unsupported op "+s.toString(16));else if(s<=30)return console.error("WK1 invalid opcode "+s.toString(16));else if(s<=115)return console.error("WK1 unsupported function opcode "+s.toString(16));else return console.error("WK1 unrecognized opcode "+s.toString(16));}}if(t.length==1)r[1].f=""+t[0];else console.error("WK1 bad formula parse |"+t.join("|")+"|")}function _(e){var r=[{c:0,r:0},{t:"n",v:0},0];r[0].r=e._R(2);r[3]=e[e.l++];r[0].c=e[e.l++];return r}function x(e,r){var t=_(e,r);t[1].t="s";t[1].v=e._R(r-4,"cstr");return t}function A(e,r,t,a){var n=Jr(6+a.length);n._W(2,e);n._W(1,t);n._W(1,r);n._W(1,39);for(var i=0;i<a.length;++i){var s=a.charCodeAt(i);n._W(1,s>=128?95:s)}n._W(1,0);return n}function y(e,r){var t=_(e,r);t[1].v=e._R(2);var a=t[1].v>>1;if(t[1].v&1){switch(a&7){case 0:a=(a>>3)*5e3;break;case 1:a=(a>>3)*500;break;case 2:a=(a>>3)/20;break;case 3:a=(a>>3)/200;break;case 4:a=(a>>3)/2e3;break;case 5:a=(a>>3)/2e4;break;case 6:a=(a>>3)/16;break;case 7:a=(a>>3)/64;break;}}t[1].v=a;return t}function I(e,r){var t=_(e,r);var a=e._R(4);var n=e._R(4);var i=e._R(2);if(i==65535){if(a===0&&n===3221225472){t[1].t="e";t[1].v=15}else if(a===0&&n===3489660928){t[1].t="e";t[1].v=42}else t[1].v=0;return t}var s=i&32768;i=(i&32767)-16446;t[1].v=(1-s*2)*(n*Math.pow(2,i+32)+a*Math.pow(2,i));return t}function R(e,r,t,a){var n=Jr(14);n._W(2,e);n._W(1,t);n._W(1,r);if(a==0){n._W(4,0);n._W(4,0);n._W(2,65535);return n}var i=0,s=0,f=0,l=0;if(a<0){i=1;a=-a}s=Math.log2(a)|0;a/=Math.pow(2,s-31);l=a>>>0;if((l&2147483648)==0){a/=2;++s;l=a>>>0}a-=l;l|=2147483648;l>>>=0;a*=Math.pow(2,32);f=a>>>0;n._W(4,f);n._W(4,l);s+=16383+(i?32768:0);n._W(2,s);return n}function F(e,r){var t=I(e,14);e.l+=r-14;return t}function O(e,r){var t=_(e,r);var a=e._R(4);t[1].v=a>>6;return t}function P(e,r){var t=_(e,r);var a=e._R(8,"f");t[1].v=a;return t}function N(e,r){var t=P(e,14);e.l+=r-10;return t}function M(e,r){var t={},a=e.l+r;while(e.l<a){var n=e._R(2);if(n==14e3){t[n]=[0,""];t[n][0]=e._R(2);while(e[e.l]){t[n][1]+=String.fromCharCode(e[e.l]);e.l++}e.l++}}return t}function L(e,r){var t=Jr(5+e.length);t._W(2,14e3);t._W(2,r);for(var a=0;a<e.length;++a){var n=e.charCodeAt(a);t[t.l++]=n>127?95:n}t[t.l++]=0;return t}var U={0:{n:"BOF",f:Kn},1:{n:"EOF"},2:{n:"CALCMODE"},3:{n:"CALCORDER"},4:{n:"SPLIT"},5:{n:"SYNC"},6:{n:"RANGE",f:f},7:{n:"WINDOW1"},8:{n:"COLW1"},9:{n:"WINTWO"},10:{n:"COLW2"},11:{n:"NAME"},12:{n:"BLANK"},13:{n:"INTEGER",f:d},14:{n:"NUMBER",f:p},15:{n:"LABEL",f:u},16:{n:"FORMULA",f:E},24:{n:"TABLE"},25:{n:"ORANGE"},26:{n:"PRANGE"},27:{n:"SRANGE"},28:{n:"FRANGE"},29:{n:"KRANGE1"},32:{n:"HRANGE"},35:{n:"KRANGE2"},36:{n:"PROTEC"},37:{n:"FOOTER"},38:{n:"HEADER"},39:{n:"SETUP"},40:{n:"MARGINS"},41:{n:"LABELFMT"},42:{n:"TITLES"},43:{n:"SHEETJS"},45:{n:"GRAPH"},46:{n:"NGRAPH"},47:{n:"CALCCOUNT"},48:{n:"UNFORMATTED"},49:{n:"CURSORW12"},50:{n:"WINDOW"},51:{n:"STRING",f:u},55:{n:"PASSWORD"},56:{n:"LOCKED"},60:{n:"QUERY"},61:{n:"QUERYNAME"},62:{n:"PRINT"},63:{n:"PRINTNAME"},64:{n:"GRAPH2"},65:{n:"GRAPHNAME"},66:{n:"ZOOM"},67:{n:"SYMSPLIT"},68:{n:"NSROWS"},69:{n:"NSCOLS"},70:{n:"RULER"},71:{n:"NNAME"},72:{n:"ACOMM"},73:{n:"AMACRO"},74:{n:"PARSE"},102:{n:"PRANGES??"},103:{n:"RRANGES??"},104:{n:"FNAME??"},105:{n:"MRANGES??"},65535:{n:""}};var H={0:{n:"BOF"},1:{n:"EOF"},2:{n:"PASSWORD"},3:{n:"CALCSET"},4:{n:"WINDOWSET"},5:{n:"SHEETCELLPTR"},6:{n:"SHEETLAYOUT"},7:{n:"COLUMNWIDTH"},8:{n:"HIDDENCOLUMN"},9:{n:"USERRANGE"},10:{n:"SYSTEMRANGE"},11:{n:"ZEROFORCE"},12:{n:"SORTKEYDIR"},13:{n:"FILESEAL"},14:{n:"DATAFILLNUMS"},15:{n:"PRINTMAIN"},16:{n:"PRINTSTRING"},17:{n:"GRAPHMAIN"},18:{n:"GRAPHSTRING"},19:{n:"??"},20:{n:"ERRCELL"},21:{n:"NACELL"},22:{n:"LABEL16",f:x},23:{n:"NUMBER17",f:I},24:{n:"NUMBER18",f:y},25:{n:"FORMULA19",f:F},26:{n:"FORMULA1A"},27:{n:"XFORMAT",f:M},28:{n:"DTLABELMISC"},29:{n:"DTLABELCELL"},30:{n:"GRAPHWINDOW"},31:{n:"CPA"},32:{n:"LPLAUTO"},33:{n:"QUERY"},34:{n:"HIDDENSHEET"},35:{n:"??"},37:{n:"NUMBER25",f:O},38:{n:"??"},39:{n:"NUMBER27",f:P},40:{n:"FORMULA28",f:N},142:{n:"??"},147:{n:"??"},150:{n:"??"},151:{n:"??"},152:{n:"??"},153:{n:"??"},154:{n:"??"},155:{n:"??"},156:{n:"??"},163:{n:"??"},174:{n:"??"},175:{n:"??"},176:{n:"??"},177:{n:"??"},184:{n:"??"},185:{n:"??"},186:{n:"??"},187:{n:"??"},188:{n:"??"},195:{n:"??"},201:{n:"??"},205:{n:"??"},206:{n:"??"},207:{n:"??"},208:{n:"??"},256:{n:"??"},259:{n:"??"},260:{n:"??"},261:{n:"??"},262:{n:"??"},263:{n:"??"},265:{n:"??"},266:{n:"??"},267:{n:"??"},268:{n:"??"},270:{n:"??"},271:{n:"??"},384:{n:"??"},389:{n:"??"},390:{n:"??"},393:{n:"??"},396:{n:"??"},512:{n:"??"},514:{n:"??"},513:{n:"??"},516:{n:"??"},517:{n:"??"},640:{n:"??"},641:{n:"??"},642:{n:"??"},643:{n:"??"},644:{n:"??"},645:{n:"??"},646:{n:"??"},647:{n:"??"},648:{n:"??"},658:{n:"??"},659:{n:"??"},660:{n:"??"},661:{n:"??"},662:{n:"??"},665:{n:"??"},666:{n:"??"},768:{n:"??"},772:{n:"??"},1600:{n:"??"},1602:{n:"??"},1793:{n:"??"},1794:{n:"??"},1795:{n:"??"},1796:{n:"??"},1920:{n:"??"},2048:{n:"??"},2049:{n:"??"},2052:{n:"??"},2688:{n:"??"},10998:{n:"??"},12849:{n:"??"},28233:{n:"??"},28484:{n:"??"},65535:{n:""}};return{sheet_to_wk1:a,book_to_wk3:n,to_workbook:r}}();function kf(e){var r={},t=e.match(Re),a=0;var n=false;if(t)for(;a!=t.length;++a){var s=Oe(t[a]);switch(s[0].replace(/\w*:/g,"")){case"<condense":break;case"<extend":break;case"<shadow":if(!s.val)break;case"<shadow>":;case"<shadow/>":r.shadow=1;break;case"</shadow>":break;case"<charset":if(s.val=="1")break;r.cp=i[parseInt(s.val,10)];break;case"<outline":if(!s.val)break;case"<outline>":;case"<outline/>":r.outline=1;break;case"</outline>":break;case"<rFont":r.name=s.val;break;case"<sz":r.sz=s.val;break;case"<strike":if(!s.val)break;case"<strike>":;case"<strike/>":r.strike=1;break;case"</strike>":break;case"<u":if(!s.val)break;switch(s.val){case"double":r.uval="double";break;case"singleAccounting":r.uval="single-accounting";break;case"doubleAccounting":r.uval="double-accounting";break;};case"<u>":;case"<u/>":r.u=1;break;case"</u>":break;case"<b":if(s.val=="0")break;case"<b>":;case"<b/>":r.b=1;break;case"</b>":break;case"<i":if(s.val=="0")break;case"<i>":;case"<i/>":r.i=1;break;case"</i>":break;case"<color":if(s.rgb)r.color=s.rgb.slice(2,8);break;case"<family":r.family=s.val;break;case"<vertAlign":r.valign=s.val;break;case"<scheme":break;case"<extLst":;case"<extLst>":;case"</extLst>":break;case"<ext":n=true;break;case"</ext>":n=false;break;default:if(s[0].charCodeAt(1)!==47&&!n)throw new Error("Unrecognized rich format "+s[0]);}}return r}var Sf=function(){var e=er("t"),r=er("rPr");function t(t){var a=t.match(e);if(!a)return{t:"s",v:""};var n={t:"s",v:Le(a[1])};var i=t.match(r);if(i)n.s=kf(i[1]);return n}var a=/<(?:\w+:)?r>/g,n=/<\/(?:\w+:)?r>/;return function i(e){return e.replace(a,"").split(n).map(t).filter(function(e){return e.v})}}();var Bf=function Zm(){var e=/(\r\n|\n)/g;function r(e,r,t){var a=[];if(e.u)a.push("text-decoration: underline;");if(e.uval)a.push("text-underline-style:"+e.uval+";");if(e.sz)a.push("font-size:"+e.sz+"pt;");if(e.outline)a.push("text-effect: outline;");if(e.shadow)a.push("text-shadow: auto;");r.push('<span style="'+a.join("")+'">');if(e.b){r.push("<b>");t.push("</b>")}if(e.i){r.push("<i>");t.push("</i>")}if(e.strike){r.push("<s>");t.push("</s>")}var n=e.valign||"";if(n=="superscript"||n=="super")n="sup";else if(n=="subscript")n="sub";if(n!=""){r.push("<"+n+">");t.push("</"+n+">")}t.push("</span>");return e}function t(t){var a=[[],t.v,[]];if(!t.v)return"";if(t.s)r(t.s,a[0],a[2]);return a[0].join("")+a[1].replace(e,"<br/>")+a[2].join("")}return function a(e){return e.map(t).join("")}}();var Cf=/<(?:\w+:)?t[^>]*>([^<]*)<\/(?:\w+:)?t>/g,Tf=/<(?:\w+:)?r>/;var _f=/<(?:\w+:)?rPh.*?>([\s\S]*?)<\/(?:\w+:)?rPh>/g;function xf(e,r){var t=r?r.cellHTML:true;var a={};if(!e)return{t:""};if(e.match(/^\s*<(?:\w+:)?t[^>]*>/)){a.t=Le(Ye(e.slice(e.indexOf(">")+1).split(/<\/(?:\w+:)?t>/)[0]||""));a.r=Ye(e);if(t)a.h=Ge(a.t)}else if(e.match(Tf)){a.r=Ye(e);a.t=Le(Ye((e.replace(_f,"").match(Cf)||[]).join("").replace(Re,"")));if(t)a.h=Bf(Sf(a.r))}return a}var Af=/<(?:\w+:)?sst([^>]*)>([\s\S]*)<\/(?:\w+:)?sst>/;var yf=/<(?:\w+:)?(?:si|sstItem)>/g;var If=/<\/(?:\w+:)?(?:si|sstItem)>/;function Rf(e,r){var t=[],a="";if(!e)return t;var n=e.match(Af);if(n){a=n[2].replace(yf,"").split(If);for(var i=0;i!=a.length;++i){var s=xf(a[i].trim(),r);if(s!=null)t[t.length]=s}n=Oe(n[1]);t.Count=n.count;t.Unique=n.uniqueCount}return t}Ua.SST="http://schemas.openxmlformats.org/officeDocument/2006/relationships/sharedStrings";var Ff=/^\s|\s$|[\t\n\r]/;function Df(e,r){if(!r.bookSST)return"";var t=[ye];t[t.length]=or("sst",null,{xmlns:hr.main[0],count:e.Count,uniqueCount:e.Unique});for(var a=0;a!=e.length;++a){if(e[a]==null)continue;var n=e[a];var i="<si>";if(n.r)i+=n.r;else{i+="<t";if(!n.t)n.t="";if(n.t.match(Ff))i+=' xml:space="preserve"';i+=">"+We(n.t)+"</t>"}i+="</si>";t[t.length]=i}if(t.length>2){t[t.length]="</sst>";t[1]=t[1].replace("/>",">")}return t.join("")}function Of(e){return[e._R(4),e._R(4)]}function Pf(e,r){var t=[];var a=false;Zr(e,function n(e,i,s){switch(s){case 159:t.Count=e[0];t.Unique=e[1];break;case 19:t.push(e);break;case 160:return true;case 35:a=true;break;case 36:a=false;break;default:if(i.indexOf("Begin")>0){}else if(i.indexOf("End")>0){}if(!a||r.WTF)throw new Error("Unexpected record "+s+" "+i);}});return t}function Nf(e,r){if(!r)r=Jr(8);r._W(4,e.Count);r._W(4,e.Unique);return r}var Mf=Ft;function Lf(e){var r=qr();et(r,"BrtBeginSst",Nf(e));for(var t=0;t<e.length;++t)et(r,"BrtSSTItem",Mf(e[t]));et(r,"BrtEndSst");return r.end()}function Uf(e){if(typeof cptable!=="undefined")return cptable.utils.encode(t,e);var r=[],a=e.split("");for(var n=0;n<a.length;++n)r[n]=a[n].charCodeAt(0);return r}function Hf(e,r){var t={};t.Major=e._R(2);t.Minor=e._R(2);if(r>=4)e.l+=r-4;return t}function Wf(e){var r={};r.id=e._R(0,"lpp4");r.R=Hf(e,4);r.U=Hf(e,4);r.W=Hf(e,4);return r}function Vf(e){var r=e._R(4);var t=e.l+r-4;var a={};var n=e._R(4);var i=[];while(n-- >0)i.push({t:e._R(4),v:e._R(0,"lpp4")});a.name=e._R(0,"lpp4");a.comps=i;if(e.l!=t)throw new Error("Bad DataSpaceMapEntry: "+e.l+" != "+t);return a}function Xf(e){var r=[];e.l+=4;var t=e._R(4);while(t-- >0)r.push(Vf(e));return r}function Gf(e){var r=[];e.l+=4;var t=e._R(4);while(t-- >0)r.push(e._R(0,"lpp4"));return r}function zf(e){var r={};e._R(4);e.l+=4;r.id=e._R(0,"lpp4");r.name=e._R(0,"lpp4");r.R=Hf(e,4);r.U=Hf(e,4);r.W=Hf(e,4);return r}function jf(e){var r=zf(e);r.ename=e._R(0,"8lpp4");r.blksz=e._R(4);r.cmode=e._R(4);if(e._R(4)!=4)throw new Error("Bad !Primary record");return r}function $f(e,r){var t=e.l+r;var a={};a.Flags=e._R(4)&63;e.l+=4;a.AlgID=e._R(4);var n=false;switch(a.AlgID){case 26126:;case 26127:;case 26128:n=a.Flags==36;break;case 26625:n=a.Flags==4;break;case 0:n=a.Flags==16||a.Flags==4||a.Flags==36;break;default:throw"Unrecognized encryption algorithm: "+a.AlgID;}if(!n)throw new Error("Encryption Flags/AlgID mismatch");a.AlgIDHash=e._R(4);a.KeySize=e._R(4);a.ProviderType=e._R(4);e.l+=8;a.CSPName=e._R(t-e.l>>1,"utf16le");e.l=t;return a}function Kf(e,r){var t={},a=e.l+r;e.l+=4;t.Salt=e.slice(e.l,e.l+16);e.l+=16;t.Verifier=e.slice(e.l,e.l+16);e.l+=16;e._R(4);t.VerifierHash=e.slice(e.l,a);e.l=a;return t}function Yf(e){var r=Hf(e);switch(r.Minor){case 2:return[r.Minor,Qf(e,r)];case 3:return[r.Minor,Jf(e,r)];case 4:return[r.Minor,Zf(e,r)];}throw new Error("ECMA-376 Encrypted file unrecognized Version: "+r.Minor)}function Qf(e){var r=e._R(4);if((r&63)!=36)throw new Error("EncryptionInfo mismatch");var t=e._R(4);var a=$f(e,t);var n=Kf(e,e.length-e.l);return{t:"Std",h:a,v:n}}function Jf(){throw new Error("File is password-protected: ECMA-376 Extensible")}function Zf(e){var r=["saltSize","blockSize","keyBits","hashSize","cipherAlgorithm","cipherChaining","hashAlgorithm","saltValue"];e.l+=4;var t=e._R(e.length-e.l,"utf8");var a={};t.replace(Re,function n(e){var t=Oe(e);switch(Pe(t[0])){case"<?xml":break;case"<encryption":;case"</encryption>":break;case"<keyData":r.forEach(function(e){a[e]=t[e]});break;case"<dataIntegrity":a.encryptedHmacKey=t.encryptedHmacKey;a.encryptedHmacValue=t.encryptedHmacValue;break;case"<keyEncryptors>":;case"<keyEncryptors":a.encs=[];break;case"</keyEncryptors>":break;case"<keyEncryptor":a.uri=t.uri;break;case"</keyEncryptor>":break;case"<encryptedKey":a.encs.push(t);break;default:throw t[0];}});return a}function qf(e,r){var t={};var a=t.EncryptionVersionInfo=Hf(e,4);r-=4;if(a.Minor!=2)throw new Error("unrecognized minor version code: "+a.Minor);if(a.Major>4||a.Major<2)throw new Error("unrecognized major version code: "+a.Major);t.Flags=e._R(4);r-=4;var n=e._R(4);r-=4;t.EncryptionHeader=$f(e,n);r-=n;t.EncryptionVerifier=Kf(e,r);return t}function el(e){var r={};var t=r.EncryptionVersionInfo=Hf(e,4);if(t.Major!=1||t.Minor!=1)throw"unrecognized version code "+t.Major+" : "+t.Minor;r.Salt=e._R(16);r.EncryptedVerifier=e._R(16);r.EncryptedVerifierHash=e._R(16);return r}function rl(e){var r=0,t;var a=Uf(e);var n=a.length+1,i,s;var f,l,o;t=B(n);t[0]=a.length;for(i=1;i!=n;++i)t[i]=a[i-1];for(i=n-1;i>=0;--i){s=t[i];f=(r&16384)===0?0:1;l=r<<1&32767;o=f|l;r=o^s}return r^52811}var tl=function(){var e=[187,255,255,186,255,255,185,128,0,190,15,0,191,15,0];var r=[57840,7439,52380,33984,4364,3600,61902,12606,6258,57657,54287,34041,10252,43370,20163];var t=[44796,19929,39858,10053,20106,40212,10761,31585,63170,64933,60267,50935,40399,11199,17763,35526,1453,2906,5812,11624,23248,885,1770,3540,7080,14160,28320,56640,55369,41139,20807,41614,21821,43642,17621,28485,56970,44341,19019,38038,14605,29210,60195,50791,40175,10751,21502,43004,24537,18387,36774,3949,7898,15796,31592,63184,47201,24803,49606,37805,14203,28406,56812,17824,35648,1697,3394,6788,13576,27152,43601,17539,35078,557,1114,2228,4456,30388,60776,51953,34243,7079,14158,28316,14128,28256,56512,43425,17251,34502,7597,13105,26210,52420,35241,883,1766,3532,4129,8258,16516,33032,4657,9314,18628];var a=function(e){return(e/2|e*128)&255};var n=function(e,r){return a(e^r)};var i=function(e){var a=r[e.length-1];var n=104;for(var i=e.length-1;i>=0;--i){var s=e[i];for(var f=0;f!=7;++f){if(s&64)a^=t[n];s*=2;--n}}return a};return function(r){var t=Uf(r);var a=i(t);var s=t.length;var f=B(16);for(var l=0;l!=16;++l)f[l]=0;var o,c,u;if((s&1)===1){o=a>>8;f[s]=n(e[0],o);--s;o=a&255;c=t[t.length-1];f[s]=n(c,o)}while(s>0){--s;o=a>>8;f[s]=n(t[s],o);--s;o=a&255;f[s]=n(t[s],o)}s=15;u=15-t.length;while(u>0){o=a>>8;f[s]=n(e[u],o);--s;--u;o=a&255;f[s]=n(t[s],o);--s;--u}return f}}();var al=function(e,r,t,a,n){if(!n)n=r;if(!a)a=tl(e);var i,s;for(i=0;i!=r.length;++i){s=r[i];s^=a[t];s=(s>>5|s<<3)&255;n[i]=s;++t}return[n,t,a]};var nl=function(e){var r=0,t=tl(e);return function(e){var a=al("",e,r,t);r=a[1];return a[0]}};function il(e,r,t,a){var n={key:Kn(e),verificationBytes:Kn(e)};if(t.password)n.verifier=rl(t.password);a.valid=n.verificationBytes===n.verifier;if(a.valid)a.insitu=nl(t.password);return n}function sl(e,r,t){var a=t||{};a.Info=e._R(2);e.l-=2;if(a.Info===1)a.Data=el(e,r);else a.Data=qf(e,r);return a}function fl(e,r,t){var a={Type:t.biff>=8?e._R(2):0};if(a.Type)sl(e,r-2,a);else il(e,t.biff>=8?r:r-2,t,a);return a}var ll=function(){function e(e,t){switch(t.type){case"base64":return r(g.decode(e),t);case"binary":return r(e,t);case"buffer":return r(E&&Buffer.isBuffer(e)?e.toString("binary"):x(e),t);case"array":return r(oe(e),t);}throw new Error("Unrecognized type "+t.type)}function r(e,r){var t=r||{};var a=t.dense?[]:{};var n=e.match(/\\trowd.*?\\row\b/g);if(!n.length)throw new Error("RTF missing table");var i={s:{c:0,r:0},e:{c:0,r:n.length-1}};n.forEach(function(e,r){if(Array.isArray(a))a[r]=[];var t=/\\\w+\b/g;var n=0;var s;var f=-1;while(s=t.exec(e)){switch(s[0]){case"\\cell":var l=e.slice(n,t.lastIndex-s[0].length);if(l[0]==" ")l=l.slice(1);++f;if(l.length){var o={v:l,t:"s"};if(Array.isArray(a))a[r][f]=o;else a[mt({r:r,c:f})]=o}break;}n=t.lastIndex}if(f>i.e.c)i.e.c=f});a["!ref"]=Et(i);return a}function t(r,t){return Bt(e(r,t),t)}function a(e){var r=["{\\rtf1\\ansi"];var t=wt(e["!ref"]),a;var n=Array.isArray(e);for(var i=t.s.r;i<=t.e.r;++i){r.push("\\trowd\\trautofit1");for(var s=t.s.c;s<=t.e.c;++s)r.push("\\cellx"+(s+1));r.push("\\pard\\intbl");for(s=t.s.c;s<=t.e.c;++s){var f=mt({r:i,c:s});a=n?(e[i]||[])[s]:e[f];if(!a||a.v==null&&(!a.f||a.F))continue;r.push(" "+(a.w||(St(a),a.w)));r.push("\\cell")}r.push("\\pard\\intbl\\row")}return r.join("")+"}"}return{to_workbook:t,to_sheet:e,from_sheet:a}}();function ol(e){var r=e.slice(e[0]==="#"?1:0).slice(0,6);return[parseInt(r.slice(0,2),16),parseInt(r.slice(2,4),16),parseInt(r.slice(4,6),16)]}function cl(e){for(var r=0,t=1;r!=3;++r)t=t*256+(e[r]>255?255:e[r]<0?0:e[r]);return t.toString(16).toUpperCase().slice(1)}function ul(e){var r=e[0]/255,t=e[1]/255,a=e[2]/255;var n=Math.max(r,t,a),i=Math.min(r,t,a),s=n-i;if(s===0)return[0,0,r];var f=0,l=0,o=n+i;l=s/(o>1?2-o:o);switch(n){case r:f=((t-a)/s+6)%6;break;case t:f=(a-r)/s+2;break;case a:f=(r-t)/s+4;break;}return[f/6,l,o/2]}function hl(e){var r=e[0],t=e[1],a=e[2];var n=t*2*(a<.5?a:1-a),i=a-n/2;var s=[i,i,i],f=6*r;var l;if(t!==0)switch(f|0){case 0:;case 6:l=n*f;s[0]+=n;s[1]+=l;break;case 1:l=n*(2-f);s[0]+=l;s[1]+=n;break;case 2:l=n*(f-2);s[1]+=n;s[2]+=l;break;case 3:l=n*(4-f);s[1]+=l;s[2]+=n;break;case 4:l=n*(f-4);s[2]+=n;s[0]+=l;break;case 5:l=n*(6-f);s[2]+=l;s[0]+=n;break;}for(var o=0;o!=3;++o)s[o]=Math.round(s[o]*255);return s}function dl(e,r){if(r===0)return e;var t=ul(ol(e));if(r<0)t[2]=t[2]*(1+r);else t[2]=1-(1-t[2])*(1-r);return cl(hl(t))}var vl=6,pl=15,bl=1,ml=vl;function gl(e){return Math.floor((e+Math.round(128/ml)/256)*ml)}function El(e){return Math.floor((e-5)/ml*100+.5)/100}function wl(e){return Math.round((e*ml+5)/ml*256)/256}function kl(e){return wl(El(gl(e)))}function Sl(e){var r=Math.abs(e-kl(e)),t=ml;if(r>.005)for(ml=bl;ml<pl;++ml)if(Math.abs(e-kl(e))<=r){r=Math.abs(e-kl(e));t=ml}ml=t}function Bl(e){if(e.width){e.wpx=gl(e.width);e.wch=El(e.wpx);e.MDW=ml}else if(e.wpx){e.wch=El(e.wpx);e.width=wl(e.wch);e.MDW=ml}else if(typeof e.wch=="number"){e.width=wl(e.wch);e.wpx=gl(e.width);e.MDW=ml}if(e.customWidth)delete e.customWidth}var Cl=96,Tl=Cl;function _l(e){return e*96/Tl}function xl(e){return e*Tl/96}var Al={None:"none",Solid:"solid",Gray50:"mediumGray",Gray75:"darkGray",Gray25:"lightGray",HorzStripe:"darkHorizontal",VertStripe:"darkVertical",ReverseDiagStripe:"darkDown",DiagStripe:"darkUp",DiagCross:"darkGrid",ThickDiagCross:"darkTrellis",ThinHorzStripe:"lightHorizontal",ThinVertStripe:"lightVertical",ThinReverseDiagStripe:"lightDown",ThinHorzCross:"lightGrid"};function yl(e,r,t,a){r.Borders=[];var n={};var i=false;(e[0].match(Re)||[]).forEach(function(e){var t=Oe(e);switch(Pe(t[0])){case"<borders":;case"<borders>":;case"</borders>":break;case"<border":;case"<border>":;case"<border/>":n={};if(t.diagonalUp)n.diagonalUp=Ke(t.diagonalUp);if(t.diagonalDown)n.diagonalDown=Ke(t.diagonalDown);r.Borders.push(n);break;case"</border>":break;case"<left/>":break;case"<left":;case"<left>":break;case"</left>":break;case"<right/>":break;case"<right":;case"<right>":break;case"</right>":break;case"<top/>":break;case"<top":;case"<top>":break;case"</top>":break;case"<bottom/>":break;case"<bottom":;case"<bottom>":break;case"</bottom>":break;case"<diagonal":;case"<diagonal>":;case"<diagonal/>":break;case"</diagonal>":break;case"<horizontal":;case"<horizontal>":;case"<horizontal/>":break;case"</horizontal>":break;case"<vertical":;case"<vertical>":;case"<vertical/>":break;case"</vertical>":break;case"<start":;case"<start>":;case"<start/>":break;case"</start>":break;case"<end":;case"<end>":;case"<end/>":break;case"</end>":break;case"<color":;case"<color>":break;case"<color/>":;case"</color>":break;case"<extLst":;case"<extLst>":;case"</extLst>":break;case"<ext":i=true;break;case"</ext>":i=false;break;default:if(a&&a.WTF){if(!i)throw new Error("unrecognized "+t[0]+" in borders")};}})}function Il(e,r,t,a){r.Fills=[];var n={};var i=false;(e[0].match(Re)||[]).forEach(function(e){var t=Oe(e);switch(Pe(t[0])){case"<fills":;case"<fills>":;case"</fills>":break;case"<fill>":;case"<fill":;case"<fill/>":n={};r.Fills.push(n);break;case"</fill>":break;case"<gradientFill>":break;case"<gradientFill":;case"</gradientFill>":r.Fills.push(n);n={};break;case"<patternFill":;case"<patternFill>":if(t.patternType)n.patternType=t.patternType;break;case"<patternFill/>":;case"</patternFill>":break;case"<bgColor":if(!n.bgColor)n.bgColor={};if(t.indexed)n.bgColor.indexed=parseInt(t.indexed,10);if(t.theme)n.bgColor.theme=parseInt(t.theme,10);if(t.tint)n.bgColor.tint=parseFloat(t.tint);if(t.rgb)n.bgColor.rgb=t.rgb.slice(-6);break;case"<bgColor/>":;case"</bgColor>":break;case"<fgColor":if(!n.fgColor)n.fgColor={};if(t.theme)n.fgColor.theme=parseInt(t.theme,10);if(t.tint)n.fgColor.tint=parseFloat(t.tint);if(t.rgb!=null)n.fgColor.rgb=t.rgb.slice(-6);break;case"<fgColor/>":;case"</fgColor>":break;case"<stop":;case"<stop/>":break;case"</stop>":break;case"<color":;case"<color/>":break;case"</color>":break;case"<extLst":;case"<extLst>":;case"</extLst>":break;case"<ext":i=true;break;case"</ext>":i=false;break;default:if(a&&a.WTF){if(!i)throw new Error("unrecognized "+t[0]+" in fills")};}})}function Rl(e,r,t,a){r.Fonts=[];var n={};var s=false;(e[0].match(Re)||[]).forEach(function(e){var f=Oe(e);switch(Pe(f[0])){case"<fonts":;case"<fonts>":;case"</fonts>":break;case"<font":;case"<font>":break;case"</font>":;case"<font/>":r.Fonts.push(n);n={};break;case"<name":if(f.val)n.name=Ye(f.val);break;case"<name/>":;case"</name>":break;case"<b":n.bold=f.val?Ke(f.val):1;break;case"<b/>":n.bold=1;break;case"<i":n.italic=f.val?Ke(f.val):1;break;case"<i/>":n.italic=1;break;case"<u":switch(f.val){case"none":n.underline=0;break;case"single":n.underline=1;break;case"double":n.underline=2;break;case"singleAccounting":n.underline=33;break;case"doubleAccounting":n.underline=34;break;}break;case"<u/>":n.underline=1;break;case"<strike":n.strike=f.val?Ke(f.val):1;break;case"<strike/>":n.strike=1;break;case"<outline":n.outline=f.val?Ke(f.val):1;break;case"<outline/>":n.outline=1;break;case"<shadow":n.shadow=f.val?Ke(f.val):1;break;case"<shadow/>":n.shadow=1;break;case"<condense":n.condense=f.val?Ke(f.val):1;break;case"<condense/>":n.condense=1;break;case"<extend":n.extend=f.val?Ke(f.val):1;break;case"<extend/>":n.extend=1;break;case"<sz":if(f.val)n.sz=+f.val;break;case"<sz/>":;case"</sz>":break;case"<vertAlign":if(f.val)n.vertAlign=f.val;break;case"<vertAlign/>":;case"</vertAlign>":break;case"<family":if(f.val)n.family=parseInt(f.val,10);break;case"<family/>":;case"</family>":break;case"<scheme":if(f.val)n.scheme=f.val;break;case"<scheme/>":;case"</scheme>":break;case"<charset":if(f.val=="1")break;f.codepage=i[parseInt(f.val,10)];break;case"<color":if(!n.color)n.color={};if(f.auto)n.color.auto=Ke(f.auto);if(f.rgb)n.color.rgb=f.rgb.slice(-6);else if(f.indexed){n.color.index=parseInt(f.indexed,10);var l=Aa[n.color.index];if(n.color.index==81)l=Aa[1];if(!l)l=Aa[1];n.color.rgb=l[0].toString(16)+l[1].toString(16)+l[2].toString(16)}else if(f.theme){n.color.theme=parseInt(f.theme,10);if(f.tint)n.color.tint=parseFloat(f.tint);if(f.theme&&t.themeElements&&t.themeElements.clrScheme){n.color.rgb=dl(t.themeElements.clrScheme[n.color.theme].rgb,n.color.tint||0)}}break;case"<color/>":;case"</color>":break;case"<AlternateContent":s=true;break;case"</AlternateContent>":s=false;break;case"<extLst":;case"<extLst>":;case"</extLst>":break;case"<ext":s=true;break;case"</ext>":s=false;break;default:if(a&&a.WTF){if(!s)throw new Error("unrecognized "+f[0]+" in fonts")};}})}function Fl(e,r,t){r.NumberFmt=[];var a=K(D._table);for(var n=0;n<a.length;++n)r.NumberFmt[a[n]]=D._table[a[n]];var i=e[0].match(Re);if(!i)return;for(n=0;n<i.length;++n){var s=Oe(i[n]);switch(Pe(s[0])){case"<numFmts":;case"</numFmts>":;case"<numFmts/>":;case"<numFmts>":break;case"<numFmt":{var f=Le(Ye(s.formatCode)),l=parseInt(s.numFmtId,10);r.NumberFmt[l]=f;if(l>0){if(l>392){for(l=392;l>60;--l)if(r.NumberFmt[l]==null)break;r.NumberFmt[l]=f}D.load(f,l)}}break;case"</numFmt>":break;default:if(t.WTF)throw new Error("unrecognized "+s[0]+" in numFmts");}}}function Dl(e){var r=["<numFmts>"];[[5,8],[23,26],[41,44],[50,392]].forEach(function(t){for(var a=t[0];a<=t[1];++a)if(e[a]!=null)r[r.length]=or("numFmt",null,{numFmtId:a,formatCode:We(e[a])})});if(r.length===1)return"";r[r.length]="</numFmts>";r[0]=or("numFmts",null,{count:r.length-2}).replace("/>",">");return r.join("")}var Ol=["numFmtId","fillId","fontId","borderId","xfId"];var Pl=["applyAlignment","applyBorder","applyFill","applyFont","applyNumberFormat","applyProtection","pivotButton","quotePrefix"];function Nl(e,r,t){r.CellXf=[];var a;var n=false;(e[0].match(Re)||[]).forEach(function(e){var i=Oe(e),s=0;switch(Pe(i[0])){case"<cellXfs":;case"<cellXfs>":;case"<cellXfs/>":;case"</cellXfs>":break;case"<xf":;case"<xf/>":a=i;delete a[0];for(s=0;s<Ol.length;++s)if(a[Ol[s]])a[Ol[s]]=parseInt(a[Ol[s]],10);for(s=0;s<Pl.length;++s)if(a[Pl[s]])a[Pl[s]]=Ke(a[Pl[s]]);if(r.NumberFmt&&a.numFmtId>392){for(s=392;s>60;--s)if(r.NumberFmt[a.numFmtId]==r.NumberFmt[s]){a.numFmtId=s;break}}r.CellXf.push(a);break;case"</xf>":break;case"<alignment":;case"<alignment/>":var f={};if(i.vertical)f.vertical=i.vertical;if(i.horizontal)f.horizontal=i.horizontal;if(i.textRotation!=null)f.textRotation=i.textRotation;if(i.indent)f.indent=i.indent;if(i.wrapText)f.wrapText=Ke(i.wrapText);a.alignment=f;break;case"</alignment>":break;case"<protection":break;case"</protection>":;case"<protection/>":break;case"<AlternateContent":n=true;break;case"</AlternateContent>":n=false;break;case"<extLst":;case"<extLst>":;case"</extLst>":break;case"<ext":n=true;break;case"</ext>":n=false;break;default:if(t&&t.WTF){if(!n)throw new Error("unrecognized "+i[0]+" in cellXfs")};}})}function Ml(e){var r=[];r[r.length]=or("cellXfs",null);e.forEach(function(e){r[r.length]=or("xf",null,e)});r[r.length]="</cellXfs>";if(r.length===2)return"";r[0]=or("cellXfs",null,{count:r.length-2}).replace("/>",">");return r.join("")}var Ll=function qm(){var e=/<(?:\w+:)?numFmts([^>]*)>[\S\s]*?<\/(?:\w+:)?numFmts>/;var r=/<(?:\w+:)?cellXfs([^>]*)>[\S\s]*?<\/(?:\w+:)?cellXfs>/;var t=/<(?:\w+:)?fills([^>]*)>[\S\s]*?<\/(?:\w+:)?fills>/;var a=/<(?:\w+:)?fonts([^>]*)>[\S\s]*?<\/(?:\w+:)?fonts>/;var n=/<(?:\w+:)?borders([^>]*)>[\S\s]*?<\/(?:\w+:)?borders>/;return function i(s,f,l){var o={};if(!s)return o;s=s.replace(/<!--([\s\S]*?)-->/gm,"").replace(/<!DOCTYPE[^\[]*\[[^\]]*\]>/gm,"");var c;if(c=s.match(e))Fl(c,o,l);if(c=s.match(a))Rl(c,o,f,l);if(c=s.match(t))Il(c,o,f,l);if(c=s.match(n))yl(c,o,f,l);if(c=s.match(r))Nl(c,o,l);return o}}();var Ul=or("styleSheet",null,{xmlns:hr.main[0],"xmlns:vt":hr.vt});Ua.STY="http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles";function Hl(e,r){var t=[ye,Ul],a;if(e.SSF&&(a=Dl(e.SSF))!=null)t[t.length]=a;t[t.length]='<fonts count="1"><font><sz val="12"/><color theme="1"/><name val="Calibri"/><family val="2"/><scheme val="minor"/></font></fonts>';
t[t.length]='<fills count="2"><fill><patternFill patternType="none"/></fill><fill><patternFill patternType="gray125"/></fill></fills>';t[t.length]='<borders count="1"><border><left/><right/><top/><bottom/><diagonal/></border></borders>';t[t.length]='<cellStyleXfs count="1"><xf numFmtId="0" fontId="0" fillId="0" borderId="0"/></cellStyleXfs>';if(a=Ml(r.cellXfs))t[t.length]=a;t[t.length]='<cellStyles count="1"><cellStyle name="Normal" xfId="0" builtinId="0"/></cellStyles>';t[t.length]='<dxfs count="0"/>';t[t.length]='<tableStyles count="0" defaultTableStyle="TableStyleMedium9" defaultPivotStyle="PivotStyleMedium4"/>';if(t.length>2){t[t.length]="</styleSheet>";t[1]=t[1].replace("/>",">")}return t.join("")}function Wl(e,r){var t=e._R(2);var a=xt(e,r-2);return[t,a]}function Vl(e,r,t){if(!t)t=Jr(6+4*r.length);t._W(2,e);At(r,t);var a=t.length>t.l?t.slice(0,t.l):t;if(t.l==null)t.l=t.length;return a}function Xl(e,r,t){var a={};a.sz=e._R(2)/20;var n=ta(e,2,t);if(n.fItalic)a.italic=1;if(n.fCondense)a.condense=1;if(n.fExtend)a.extend=1;if(n.fShadow)a.shadow=1;if(n.fOutline)a.outline=1;if(n.fStrikeout)a.strike=1;var i=e._R(2);if(i===700)a.bold=1;switch(e._R(2)){case 1:a.vertAlign="superscript";break;case 2:a.vertAlign="subscript";break;}var s=e._R(1);if(s!=0)a.underline=s;var f=e._R(1);if(f>0)a.family=f;var l=e._R(1);if(l>0)a.charset=l;e.l++;a.color=ea(e,8);switch(e._R(1)){case 1:a.scheme="major";break;case 2:a.scheme="minor";break;}a.name=xt(e,r-21);return a}function Gl(e,r){if(!r)r=Jr(25+4*32);r._W(2,e.sz*20);aa(e,r);r._W(2,e.bold?700:400);var t=0;if(e.vertAlign=="superscript")t=1;else if(e.vertAlign=="subscript")t=2;r._W(2,t);r._W(1,e.underline||0);r._W(1,e.family||0);r._W(1,e.charset||0);r._W(1,0);ra(e.color,r);var a=0;if(e.scheme=="major")a=1;if(e.scheme=="minor")a=2;r._W(1,a);At(e.name,r);return r.length>r.l?r.slice(0,r.l):r}var zl=["none","solid","mediumGray","darkGray","lightGray","darkHorizontal","darkVertical","darkDown","darkUp","darkGrid","darkTrellis","lightHorizontal","lightVertical","lightDown","lightUp","lightGrid","lightTrellis","gray125","gray0625"];var jl=Q(zl);var $l=Qr;function Kl(e,r){if(!r)r=Jr(4*3+8*7+16*1);var t=jl[e.patternType];if(t==null)t=40;r._W(4,t);var a=0;if(t!=40){ra({auto:1},r);ra({auto:1},r);for(;a<12;++a)r._W(4,0)}else{for(;a<4;++a)r._W(4,0);for(;a<12;++a)r._W(4,0)}return r.length>r.l?r.slice(0,r.l):r}function Yl(e,r){var t=e.l+r;var a=e._R(2);var n=e._R(2);e.l=t;return{ixfe:a,numFmtId:n}}function Ql(e,r,t){if(!t)t=Jr(16);t._W(2,r||0);t._W(2,e.numFmtId||0);t._W(2,0);t._W(2,0);t._W(2,0);t._W(1,0);t._W(1,0);var a=0;t._W(1,a);t._W(1,0);t._W(1,0);t._W(1,0);return t}function Jl(e,r){if(!r)r=Jr(10);r._W(1,0);r._W(1,0);r._W(4,0);r._W(4,0);return r}var Zl=Qr;function ql(e,r){if(!r)r=Jr(51);r._W(1,0);Jl(null,r);Jl(null,r);Jl(null,r);Jl(null,r);Jl(null,r);return r.length>r.l?r.slice(0,r.l):r}function eo(e,r){if(!r)r=Jr(12+4*10);r._W(4,e.xfId);r._W(2,1);r._W(1,+e.builtinId);r._W(1,0);Vt(e.name||"",r);return r.length>r.l?r.slice(0,r.l):r}function ro(e,r,t){var a=Jr(4+256*2*4);a._W(4,e);Vt(r,a);Vt(t,a);return a.length>a.l?a.slice(0,a.l):a}function to(e,r,t){var a={};a.NumberFmt=[];for(var n in D._table)a.NumberFmt[n]=D._table[n];a.CellXf=[];a.Fonts=[];var i=[];var s=false;Zr(e,function f(e,n,l){switch(l){case 44:a.NumberFmt[e[0]]=e[1];D.load(e[1],e[0]);break;case 43:a.Fonts.push(e);if(e.color.theme!=null&&r&&r.themeElements&&r.themeElements.clrScheme){e.color.rgb=dl(r.themeElements.clrScheme[e.color.theme].rgb,e.color.tint||0)}break;case 1025:break;case 45:break;case 46:break;case 47:if(i[i.length-1]=="BrtBeginCellXFs"){a.CellXf.push(e)}break;case 48:;case 507:;case 572:;case 475:break;case 1171:;case 2102:;case 1130:;case 512:;case 2095:;case 3072:break;case 35:s=true;break;case 36:s=false;break;case 37:i.push(n);s=true;break;case 38:i.pop();s=false;break;default:if((n||"").indexOf("Begin")>0)i.push(n);else if((n||"").indexOf("End")>0)i.pop();else if(!s||t.WTF&&i[i.length-1]!="BrtACBegin")throw new Error("Unexpected record "+l+" "+n);}});return a}function ao(e,r){if(!r)return;var t=0;[[5,8],[23,26],[41,44],[50,392]].forEach(function(e){for(var a=e[0];a<=e[1];++a)if(r[a]!=null)++t});if(t==0)return;et(e,"BrtBeginFmts",_t(t));[[5,8],[23,26],[41,44],[50,392]].forEach(function(t){for(var a=t[0];a<=t[1];++a)if(r[a]!=null)et(e,"BrtFmt",Vl(a,r[a]))});et(e,"BrtEndFmts")}function no(e){var r=1;if(r==0)return;et(e,"BrtBeginFonts",_t(r));et(e,"BrtFont",Gl({sz:12,color:{theme:1},name:"Calibri",family:2,scheme:"minor"}));et(e,"BrtEndFonts")}function io(e){var r=2;if(r==0)return;et(e,"BrtBeginFills",_t(r));et(e,"BrtFill",Kl({patternType:"none"}));et(e,"BrtFill",Kl({patternType:"gray125"}));et(e,"BrtEndFills")}function so(e){var r=1;if(r==0)return;et(e,"BrtBeginBorders",_t(r));et(e,"BrtBorder",ql({}));et(e,"BrtEndBorders")}function fo(e){var r=1;et(e,"BrtBeginCellStyleXFs",_t(r));et(e,"BrtXF",Ql({numFmtId:0,fontId:0,fillId:0,borderId:0},65535));et(e,"BrtEndCellStyleXFs")}function lo(e,r){et(e,"BrtBeginCellXFs",_t(r.length));r.forEach(function(r){et(e,"BrtXF",Ql(r,0))});et(e,"BrtEndCellXFs")}function oo(e){var r=1;et(e,"BrtBeginStyles",_t(r));et(e,"BrtStyle",eo({xfId:0,builtinId:0,name:"Normal"}));et(e,"BrtEndStyles")}function co(e){var r=0;et(e,"BrtBeginDXFs",_t(r));et(e,"BrtEndDXFs")}function uo(e){var r=0;et(e,"BrtBeginTableStyles",ro(r,"TableStyleMedium9","PivotStyleMedium4"));et(e,"BrtEndTableStyles")}function ho(){return}function vo(e,r){var t=qr();et(t,"BrtBeginStyleSheet");ao(t,e.SSF);no(t,e);io(t,e);so(t,e);fo(t,e);lo(t,r.cellXfs);oo(t,e);co(t,e);uo(t,e);ho(t,e);et(t,"BrtEndStyleSheet");return t.end()}Ua.THEME="http://schemas.openxmlformats.org/officeDocument/2006/relationships/theme";var po=["</a:lt1>","</a:dk1>","</a:lt2>","</a:dk2>","</a:accent1>","</a:accent2>","</a:accent3>","</a:accent4>","</a:accent5>","</a:accent6>","</a:hlink>","</a:folHlink>"];function bo(e,r,t){r.themeElements.clrScheme=[];var a={};(e[0].match(Re)||[]).forEach(function(e){var n=Oe(e);switch(n[0]){case"<a:clrScheme":;case"</a:clrScheme>":break;case"<a:srgbClr":a.rgb=n.val;break;case"<a:sysClr":a.rgb=n.lastClr;break;case"<a:dk1>":;case"</a:dk1>":;case"<a:lt1>":;case"</a:lt1>":;case"<a:dk2>":;case"</a:dk2>":;case"<a:lt2>":;case"</a:lt2>":;case"<a:accent1>":;case"</a:accent1>":;case"<a:accent2>":;case"</a:accent2>":;case"<a:accent3>":;case"</a:accent3>":;case"<a:accent4>":;case"</a:accent4>":;case"<a:accent5>":;case"</a:accent5>":;case"<a:accent6>":;case"</a:accent6>":;case"<a:hlink>":;case"</a:hlink>":;case"<a:folHlink>":;case"</a:folHlink>":if(n[0].charAt(1)==="/"){r.themeElements.clrScheme[po.indexOf(n[0])]=a;a={}}else{a.name=n[0].slice(3,n[0].length-1)}break;default:if(t&&t.WTF)throw new Error("Unrecognized "+n[0]+" in clrScheme");}})}function mo(){}function go(){}var Eo=/<a:clrScheme([^>]*)>[\s\S]*<\/a:clrScheme>/;var wo=/<a:fontScheme([^>]*)>[\s\S]*<\/a:fontScheme>/;var ko=/<a:fmtScheme([^>]*)>[\s\S]*<\/a:fmtScheme>/;function So(e,r,t){r.themeElements={};var a;[["clrScheme",Eo,bo],["fontScheme",wo,mo],["fmtScheme",ko,go]].forEach(function(n){if(!(a=e.match(n[1])))throw new Error(n[0]+" not found in themeElements");n[2](a,r,t)})}var Bo=/<a:themeElements([^>]*)>[\s\S]*<\/a:themeElements>/;function Co(e,r){if(!e||e.length===0)return Co(To());var t;var a={};if(!(t=e.match(Bo)))throw new Error("themeElements not found in theme");So(t[0],a,r);a.raw=e;return a}function To(e,r){if(r&&r.themeXLSX)return r.themeXLSX;if(e&&typeof e.raw=="string")return e.raw;var t=[ye];t[t.length]='<a:theme xmlns:a="http://schemas.openxmlformats.org/drawingml/2006/main" name="Office Theme">';t[t.length]="<a:themeElements>";t[t.length]='<a:clrScheme name="Office">';t[t.length]='<a:dk1><a:sysClr val="windowText" lastClr="000000"/></a:dk1>';t[t.length]='<a:lt1><a:sysClr val="window" lastClr="FFFFFF"/></a:lt1>';t[t.length]='<a:dk2><a:srgbClr val="1F497D"/></a:dk2>';t[t.length]='<a:lt2><a:srgbClr val="EEECE1"/></a:lt2>';t[t.length]='<a:accent1><a:srgbClr val="4F81BD"/></a:accent1>';t[t.length]='<a:accent2><a:srgbClr val="C0504D"/></a:accent2>';t[t.length]='<a:accent3><a:srgbClr val="9BBB59"/></a:accent3>';t[t.length]='<a:accent4><a:srgbClr val="8064A2"/></a:accent4>';t[t.length]='<a:accent5><a:srgbClr val="4BACC6"/></a:accent5>';t[t.length]='<a:accent6><a:srgbClr val="F79646"/></a:accent6>';t[t.length]='<a:hlink><a:srgbClr val="0000FF"/></a:hlink>';t[t.length]='<a:folHlink><a:srgbClr val="800080"/></a:folHlink>';t[t.length]="</a:clrScheme>";t[t.length]='<a:fontScheme name="Office">';t[t.length]="<a:majorFont>";t[t.length]='<a:latin typeface="Cambria"/>';t[t.length]='<a:ea typeface=""/>';t[t.length]='<a:cs typeface=""/>';t[t.length]='<a:font script="Jpan" typeface="ＭＳ Ｐゴシック"/>';t[t.length]='<a:font script="Hang" typeface="맑은 고딕"/>';t[t.length]='<a:font script="Hans" typeface="宋体"/>';t[t.length]='<a:font script="Hant" typeface="新細明體"/>';t[t.length]='<a:font script="Arab" typeface="Times New Roman"/>';t[t.length]='<a:font script="Hebr" typeface="Times New Roman"/>';t[t.length]='<a:font script="Thai" typeface="Tahoma"/>';t[t.length]='<a:font script="Ethi" typeface="Nyala"/>';t[t.length]='<a:font script="Beng" typeface="Vrinda"/>';t[t.length]='<a:font script="Gujr" typeface="Shruti"/>';t[t.length]='<a:font script="Khmr" typeface="MoolBoran"/>';t[t.length]='<a:font script="Knda" typeface="Tunga"/>';t[t.length]='<a:font script="Guru" typeface="Raavi"/>';t[t.length]='<a:font script="Cans" typeface="Euphemia"/>';t[t.length]='<a:font script="Cher" typeface="Plantagenet Cherokee"/>';t[t.length]='<a:font script="Yiii" typeface="Microsoft Yi Baiti"/>';t[t.length]='<a:font script="Tibt" typeface="Microsoft Himalaya"/>';t[t.length]='<a:font script="Thaa" typeface="MV Boli"/>';t[t.length]='<a:font script="Deva" typeface="Mangal"/>';t[t.length]='<a:font script="Telu" typeface="Gautami"/>';t[t.length]='<a:font script="Taml" typeface="Latha"/>';t[t.length]='<a:font script="Syrc" typeface="Estrangelo Edessa"/>';t[t.length]='<a:font script="Orya" typeface="Kalinga"/>';t[t.length]='<a:font script="Mlym" typeface="Kartika"/>';t[t.length]='<a:font script="Laoo" typeface="DokChampa"/>';t[t.length]='<a:font script="Sinh" typeface="Iskoola Pota"/>';t[t.length]='<a:font script="Mong" typeface="Mongolian Baiti"/>';t[t.length]='<a:font script="Viet" typeface="Times New Roman"/>';t[t.length]='<a:font script="Uigh" typeface="Microsoft Uighur"/>';t[t.length]='<a:font script="Geor" typeface="Sylfaen"/>';t[t.length]="</a:majorFont>";t[t.length]="<a:minorFont>";t[t.length]='<a:latin typeface="Calibri"/>';t[t.length]='<a:ea typeface=""/>';t[t.length]='<a:cs typeface=""/>';t[t.length]='<a:font script="Jpan" typeface="ＭＳ Ｐゴシック"/>';t[t.length]='<a:font script="Hang" typeface="맑은 고딕"/>';t[t.length]='<a:font script="Hans" typeface="宋体"/>';t[t.length]='<a:font script="Hant" typeface="新細明體"/>';t[t.length]='<a:font script="Arab" typeface="Arial"/>';t[t.length]='<a:font script="Hebr" typeface="Arial"/>';t[t.length]='<a:font script="Thai" typeface="Tahoma"/>';t[t.length]='<a:font script="Ethi" typeface="Nyala"/>';t[t.length]='<a:font script="Beng" typeface="Vrinda"/>';t[t.length]='<a:font script="Gujr" typeface="Shruti"/>';t[t.length]='<a:font script="Khmr" typeface="DaunPenh"/>';t[t.length]='<a:font script="Knda" typeface="Tunga"/>';t[t.length]='<a:font script="Guru" typeface="Raavi"/>';t[t.length]='<a:font script="Cans" typeface="Euphemia"/>';t[t.length]='<a:font script="Cher" typeface="Plantagenet Cherokee"/>';t[t.length]='<a:font script="Yiii" typeface="Microsoft Yi Baiti"/>';t[t.length]='<a:font script="Tibt" typeface="Microsoft Himalaya"/>';t[t.length]='<a:font script="Thaa" typeface="MV Boli"/>';t[t.length]='<a:font script="Deva" typeface="Mangal"/>';t[t.length]='<a:font script="Telu" typeface="Gautami"/>';t[t.length]='<a:font script="Taml" typeface="Latha"/>';t[t.length]='<a:font script="Syrc" typeface="Estrangelo Edessa"/>';t[t.length]='<a:font script="Orya" typeface="Kalinga"/>';t[t.length]='<a:font script="Mlym" typeface="Kartika"/>';t[t.length]='<a:font script="Laoo" typeface="DokChampa"/>';t[t.length]='<a:font script="Sinh" typeface="Iskoola Pota"/>';t[t.length]='<a:font script="Mong" typeface="Mongolian Baiti"/>';t[t.length]='<a:font script="Viet" typeface="Arial"/>';t[t.length]='<a:font script="Uigh" typeface="Microsoft Uighur"/>';t[t.length]='<a:font script="Geor" typeface="Sylfaen"/>';t[t.length]="</a:minorFont>";t[t.length]="</a:fontScheme>";t[t.length]='<a:fmtScheme name="Office">';t[t.length]="<a:fillStyleLst>";t[t.length]='<a:solidFill><a:schemeClr val="phClr"/></a:solidFill>';t[t.length]='<a:gradFill rotWithShape="1">';t[t.length]="<a:gsLst>";t[t.length]='<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="50000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';t[t.length]='<a:gs pos="35000"><a:schemeClr val="phClr"><a:tint val="37000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';t[t.length]='<a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="15000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';t[t.length]="</a:gsLst>";t[t.length]='<a:lin ang="16200000" scaled="1"/>';t[t.length]="</a:gradFill>";t[t.length]='<a:gradFill rotWithShape="1">';t[t.length]="<a:gsLst>";t[t.length]='<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="100000"/><a:shade val="100000"/><a:satMod val="130000"/></a:schemeClr></a:gs>';t[t.length]='<a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="50000"/><a:shade val="100000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';t[t.length]="</a:gsLst>";t[t.length]='<a:lin ang="16200000" scaled="0"/>';t[t.length]="</a:gradFill>";t[t.length]="</a:fillStyleLst>";t[t.length]="<a:lnStyleLst>";t[t.length]='<a:ln w="9525" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"><a:shade val="95000"/><a:satMod val="105000"/></a:schemeClr></a:solidFill><a:prstDash val="solid"/></a:ln>';t[t.length]='<a:ln w="25400" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln>';t[t.length]='<a:ln w="38100" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln>';t[t.length]="</a:lnStyleLst>";t[t.length]="<a:effectStyleLst>";t[t.length]="<a:effectStyle>";t[t.length]="<a:effectLst>";t[t.length]='<a:outerShdw blurRad="40000" dist="20000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="38000"/></a:srgbClr></a:outerShdw>';t[t.length]="</a:effectLst>";t[t.length]="</a:effectStyle>";t[t.length]="<a:effectStyle>";t[t.length]="<a:effectLst>";t[t.length]='<a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw>';t[t.length]="</a:effectLst>";t[t.length]="</a:effectStyle>";t[t.length]="<a:effectStyle>";t[t.length]="<a:effectLst>";t[t.length]='<a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw>';t[t.length]="</a:effectLst>";t[t.length]='<a:scene3d><a:camera prst="orthographicFront"><a:rot lat="0" lon="0" rev="0"/></a:camera><a:lightRig rig="threePt" dir="t"><a:rot lat="0" lon="0" rev="1200000"/></a:lightRig></a:scene3d>';t[t.length]='<a:sp3d><a:bevelT w="63500" h="25400"/></a:sp3d>';t[t.length]="</a:effectStyle>";t[t.length]="</a:effectStyleLst>";t[t.length]="<a:bgFillStyleLst>";t[t.length]='<a:solidFill><a:schemeClr val="phClr"/></a:solidFill>';t[t.length]='<a:gradFill rotWithShape="1">';t[t.length]="<a:gsLst>";t[t.length]='<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="40000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';t[t.length]='<a:gs pos="40000"><a:schemeClr val="phClr"><a:tint val="45000"/><a:shade val="99000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';t[t.length]='<a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="20000"/><a:satMod val="255000"/></a:schemeClr></a:gs>';t[t.length]="</a:gsLst>";t[t.length]='<a:path path="circle"><a:fillToRect l="50000" t="-80000" r="50000" b="180000"/></a:path>';t[t.length]="</a:gradFill>";t[t.length]='<a:gradFill rotWithShape="1">';t[t.length]="<a:gsLst>";t[t.length]='<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="80000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';t[t.length]='<a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="30000"/><a:satMod val="200000"/></a:schemeClr></a:gs>';t[t.length]="</a:gsLst>";t[t.length]='<a:path path="circle"><a:fillToRect l="50000" t="50000" r="50000" b="50000"/></a:path>';t[t.length]="</a:gradFill>";t[t.length]="</a:bgFillStyleLst>";t[t.length]="</a:fmtScheme>";t[t.length]="</a:themeElements>";t[t.length]="<a:objectDefaults>";t[t.length]="<a:spDef>";t[t.length]='<a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="1"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="3"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="2"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="lt1"/></a:fontRef></a:style>';t[t.length]="</a:spDef>";t[t.length]="<a:lnDef>";t[t.length]='<a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="2"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="0"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="1"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="tx1"/></a:fontRef></a:style>';t[t.length]="</a:lnDef>";t[t.length]="</a:objectDefaults>";t[t.length]="<a:extraClrSchemeLst/>";t[t.length]="</a:theme>";return t.join("")}function _o(e,r,t){var a=e.l+r;var n=e._R(4);if(n===124226)return;if(!t.cellStyles){e.l=a;return}var i=e.slice(e.l);e.l=a;var s;try{s=xe(i,{type:"array"})}catch(f){return}var l=Se(s,"theme/theme/theme1.xml",true);if(!l)return;return Co(l,t)}function xo(e){return e._R(4)}function Ao(e){var r={};r.xclrType=e._R(2);r.nTintShade=e._R(2);switch(r.xclrType){case 0:e.l+=4;break;case 1:r.xclrValue=yo(e,4);break;case 2:r.xclrValue=vi(e,4);break;case 3:r.xclrValue=xo(e,4);break;case 4:e.l+=4;break;}e.l+=8;return r}function yo(e,r){return Qr(e,r)}function Io(e,r){return Qr(e,r)}function Ro(e){var r=e._R(2);var t=e._R(2)-4;var a=[r];switch(r){case 4:;case 5:;case 7:;case 8:;case 9:;case 10:;case 11:;case 13:a[1]=Ao(e,t);break;case 6:a[1]=Io(e,t);break;case 14:;case 15:a[1]=e._R(t===1?1:2);break;default:throw new Error("Unrecognized ExtProp type: "+r+" "+t);}return a}function Fo(e,r){var t=e.l+r;e.l+=2;var a=e._R(2);e.l+=2;var n=e._R(2);var i=[];while(n-- >0)i.push(Ro(e,t-e.l));return{ixfe:a,ext:i}}function Do(e,r){r.forEach(function(e){switch(e[0]){case 4:break;case 5:break;case 6:break;case 7:break;case 8:break;case 9:break;case 10:break;case 11:break;case 13:break;case 14:break;case 15:break;}})}function Oo(e){var r=[];if(!e)return r;var t=1;(e.match(Re)||[]).forEach(function(e){var a=Oe(e);switch(a[0]){case"<?xml":break;case"<calcChain":;case"<calcChain>":;case"</calcChain>":break;case"<c":delete a[0];if(a.i)t=a.i;else a.i=t;r.push(a);break;}});return r}function Po(e){var r={};r.i=e._R(4);var t={};t.r=e._R(4);t.c=e._R(4);r.r=mt(t);var a=e._R(1);if(a&2)r.l="1";if(a&8)r.a="1";return r}function No(e,r,t){var a=[];var n=false;Zr(e,function i(e,r,s){switch(s){case 63:a.push(e);break;default:if((r||"").indexOf("Begin")>0){}else if((r||"").indexOf("End")>0){}else if(!n||t.WTF)throw new Error("Unexpected record "+s+" "+r);}});return a}function Mo(){}function Lo(e,r,t,a){if(!e)return e;var n=a||{};var i=false,s=false;Zr(e,function f(e,r,t){if(s)return;switch(t){case 359:;case 363:;case 364:;case 366:;case 367:;case 368:;case 369:;case 370:;case 371:;case 472:;case 577:;case 578:;case 579:;case 580:;case 581:;case 582:;case 583:;case 584:;case 585:;case 586:;case 587:break;case 35:i=true;break;case 36:i=false;break;default:if((r||"").indexOf("Begin")>0){}else if((r||"").indexOf("End")>0){}else if(!i||n.WTF)throw new Error("Unexpected record "+t.toString(16)+" "+r);}},n)}Ua.IMG="http://schemas.openxmlformats.org/officeDocument/2006/relationships/image";Ua.DRAW="http://schemas.openxmlformats.org/officeDocument/2006/relationships/drawing";function Uo(e,r){if(!e)return"??";var t=(e.match(/<c:chart [^>]*r:id="([^"]*)"/)||["",""])[1];return r["!id"][t].Target}var Ho=1024;function Wo(e,r){var t=[21600,21600];var a=["m0,0l0",t[1],t[0],t[1],t[0],"0xe"].join(",");var n=[or("xml",null,{"xmlns:v":dr.v,"xmlns:o":dr.o,"xmlns:x":dr.x,"xmlns:mv":dr.mv}).replace(/\/>/,">"),or("o:shapelayout",or("o:idmap",null,{"v:ext":"edit",data:e}),{"v:ext":"edit"}),or("v:shapetype",[or("v:stroke",null,{joinstyle:"miter"}),or("v:path",null,{gradientshapeok:"t","o:connecttype":"rect"})].join(""),{id:"_x0000_t202","o:spt":202,coordsize:t.join(","),path:a})];while(Ho<e*1e3)Ho+=1e3;r.forEach(function(e){var r=bt(e[0]);var t={color2:"#BEFF82",type:"gradient"};if(t.type=="gradient")t.angle="-180";var a=t.type=="gradient"?or("o:fill",null,{type:"gradientUnscaled","v:ext":"view"}):null;var i=or("v:fill",a,t);var s={on:"t",obscured:"t"};++Ho;n=n.concat(["<v:shape"+lr({id:"_x0000_s"+Ho,type:"#_x0000_t202",style:"position:absolute; margin-left:80pt;margin-top:5pt;width:104pt;height:64pt;z-index:10"+(e[1].hidden?";visibility:hidden":""),fillcolor:"#ECFAD4",strokecolor:"#edeaa1"})+">",i,or("v:shadow",null,s),or("v:path",null,{"o:connecttype":"none"}),'<v:textbox><div style="text-align:left"></div></v:textbox>','<x:ClientData ObjectType="Note">',"<x:MoveWithCells/>","<x:SizeWithCells/>",fr("x:Anchor",[r.c+1,0,r.r+1,0,r.c+3,20,r.r+5,20].join(",")),fr("x:AutoFill","False"),fr("x:Row",String(r.r)),fr("x:Column",String(r.c)),e[1].hidden?"":"<x:Visible/>","</x:ClientData>","</v:shape>"])});n.push("</xml>");return n.join("")}Ua.CMNT="http://schemas.openxmlformats.org/officeDocument/2006/relationships/comments";function Vo(e,r){var t=Array.isArray(e);var a;r.forEach(function(r){var n=bt(r.ref);if(t){if(!e[n.r])e[n.r]=[];a=e[n.r][n.c]}else a=e[r.ref];if(!a){a={t:"z"};if(t)e[n.r][n.c]=a;else e[r.ref]=a;var i=wt(e["!ref"]||"BDWGO1000001:A1");if(i.s.r>n.r)i.s.r=n.r;if(i.e.r<n.r)i.e.r=n.r;if(i.s.c>n.c)i.s.c=n.c;if(i.e.c<n.c)i.e.c=n.c;var s=Et(i);if(s!==e["!ref"])e["!ref"]=s}if(!a.c)a.c=[];var f={a:r.author,t:r.t,r:r.r};if(r.h)f.h=r.h;a.c.push(f)})}function Xo(e,r){if(e.match(/<(?:\w+:)?comments *\/>/))return[];var t=[];var a=[];var n=e.match(/<(?:\w+:)?authors>([\s\S]*)<\/(?:\w+:)?authors>/);if(n&&n[1])n[1].split(/<\/\w*:?author>/).forEach(function(e){if(e===""||e.trim()==="")return;var r=e.match(/<(?:\w+:)?author[^>]*>(.*)/);if(r)t.push(r[1])});var i=e.match(/<(?:\w+:)?commentList>([\s\S]*)<\/(?:\w+:)?commentList>/);if(i&&i[1])i[1].split(/<\/\w*:?comment>/).forEach(function(e){if(e===""||e.trim()==="")return;var n=e.match(/<(?:\w+:)?comment[^>]*>/);if(!n)return;var i=Oe(n[0]);var s={author:i.authorId&&t[i.authorId]||"sheetjsghost",ref:i.ref,guid:i.guid};var f=bt(i.ref);if(r.sheetRows&&r.sheetRows<=f.r)return;var l=e.match(/<(?:\w+:)?text>([\s\S]*)<\/(?:\w+:)?text>/);var o=!!l&&!!l[1]&&xf(l[1])||{r:"",t:"",h:""};s.r=o.r;if(o.r=="<t></t>")o.t=o.h="";s.t=(o.t||"").replace(/\r\n/g,"\n").replace(/\r/g,"\n");if(r.cellHTML)s.h=o.h;a.push(s)});return a}var Go=or("comments",null,{xmlns:hr.main[0]});function zo(e){var r=[ye,Go];var t=[];r.push("<authors>");e.forEach(function(e){e[1].forEach(function(e){var a=We(e.a);if(t.indexOf(a)>-1)return;t.push(a);r.push("<author>"+a+"</author>")})});r.push("</authors>");r.push("<commentList>");e.forEach(function(e){e[1].forEach(function(a){r.push('<comment ref="'+e[0]+'" authorId="'+t.indexOf(We(a.a))+'"><text>');r.push(fr("t",a.t==null?"":We(a.t)));r.push("</text></comment>")})});r.push("</commentList>");if(r.length>2){r[r.length]="</comments>";r[1]=r[1].replace("/>",">")}return r.join("")}function jo(e){var r={};r.iauthor=e._R(4);var t=Qt(e,16);r.rfx=t.s;r.ref=mt(t.s);e.l+=16;return r}function $o(e,r){if(r==null)r=Jr(36);r._W(4,e[1].iauthor);Jt(e[0],r);r._W(4,0);r._W(4,0);r._W(4,0);r._W(4,0);return r}var Ko=xt;function Yo(e){return At(e.slice(0,54))}function Qo(e,r){var t=[];var a=[];var n={};var i=false;Zr(e,function s(e,f,l){switch(l){case 632:a.push(e);break;case 635:n=e;break;case 637:n.t=e.t;n.h=e.h;n.r=e.r;break;case 636:n.author=a[n.iauthor];delete n.iauthor;if(r.sheetRows&&n.rfx&&r.sheetRows<=n.rfx.r)break;if(!n.t)n.t="";delete n.rfx;t.push(n);break;case 3072:break;case 35:i=true;break;case 36:i=false;break;case 37:break;case 38:break;default:if((f||"").indexOf("Begin")>0){}else if((f||"").indexOf("End")>0){}else if(!i||r.WTF)throw new Error("Unexpected record "+l+" "+f);}});return t}function Jo(e){var r=qr();var t=[];et(r,"BrtBeginComments");et(r,"BrtBeginCommentAuthors");e.forEach(function(e){e[1].forEach(function(e){if(t.indexOf(e.a)>-1)return;t.push(e.a.slice(0,54));et(r,"BrtCommentAuthor",Yo(e.a))})});et(r,"BrtEndCommentAuthors");et(r,"BrtBeginCommentList");e.forEach(function(e){e[1].forEach(function(a){a.iauthor=t.indexOf(a.a);var n={s:bt(e[0]),e:bt(e[0])};et(r,"BrtBeginComment",$o([n,a]));if(a.t&&a.t.length>0)et(r,"BrtCommentText",Ot(a));et(r,"BrtEndComment");delete a.iauthor})});et(r,"BrtEndCommentList");et(r,"BrtEndComments");return r.end()}var Zo="application/vnd.ms-office.vbaProject";function qo(e){var r=V.utils.cfb_new({root:"R"});e.FullPaths.forEach(function(t,a){if(t.slice(-1)==="/"||!t.match(/_VBA_PROJECT_CUR/))return;var n=t.replace(/^[^\/]*/,"R").replace(/\/_VBA_PROJECT_CUR\u0000*/,"");V.utils.cfb_add(r,n,e.FileIndex[a].content)});return V.write(r)}function ec(e,r){r.FullPaths.forEach(function(t,a){if(a==0)return;var n=t.replace(/[^\/]*[\/]/,"/_VBA_PROJECT_CUR/");if(n.slice(-1)!=="/")V.utils.cfb_add(e,n,r.FileIndex[a].content)})}var rc=["xlsb","xlsm","xlam","biff8","xla"];Ua.DS="http://schemas.openxmlformats.org/officeDocument/2006/relationships/dialogsheet";Ua.MS="http://schemas.microsoft.com/office/2006/relationships/xlMacrosheet";function tc(){return{"!type":"dialog"}}function ac(){return{"!type":"dialog"}}function nc(){return{"!type":"macro"}}function ic(){return{"!type":"macro"}}var sc=function(){var e=/(^|[^A-Za-z_])R(\[?-?\d+\]|[1-9]\d*|)C(\[?-?\d+\]|[1-9]\d*|)(?![A-Za-z0-9_])/g;var r={r:0,c:0};function t(e,t,a,n){var i=false,s=false;if(a.length==0)s=true;else if(a.charAt(0)=="["){s=true;a=a.slice(1,-1)}if(n.length==0)i=true;else if(n.charAt(0)=="["){i=true;n=n.slice(1,-1)}var f=a.length>0?parseInt(a,10)|0:0,l=n.length>0?parseInt(n,10)|0:0;if(i)l+=r.c;else--l;if(s)f+=r.r;else--f;return t+(i?"":"$")+ht(l)+(s?"":"$")+lt(f)}return function a(n,i){r=i;return n.replace(e,t)}}();var fc=/(^|[^._A-Z0-9])([$]?)([A-Z]{1,2}|[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D])([$]?)(10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})(?![_.\(A-Za-z0-9])/g;var lc=function(){return function e(r,t){return r.replace(fc,function(e,r,a,n,i,s){var f=ut(n)-(a?0:t.c);var l=ft(s)-(i?0:t.r);var o=l==0?"":!i?"["+l+"]":l+1;var c=f==0?"":!a?"["+f+"]":f+1;return r+"R"+o+"C"+c})}}();function oc(e,r){return e.replace(fc,function(e,t,a,n,i,s){return t+(a=="$"?a+n:ht(ut(n)+r.c))+(i=="$"?i+s:lt(ft(s)+r.r))})}function cc(e,r,t){var a=gt(r),n=a.s,i=bt(t);var s={r:i.r-n.r,c:i.c-n.c};return oc(e,s)}function uc(e){if(e.length==1)return false;return true}function hc(e){return e.replace(/_xlfn\./g,"")}function dc(e){e.l+=1;return}function vc(e,r){var t=e._R(r==1?1:2);return[t&16383,t>>14&1,t>>15&1]}function pc(e,r,t){var a=2;if(t){if(t.biff>=2&&t.biff<=5)return bc(e,r,t);else if(t.biff==12)a=4}var n=e._R(a),i=e._R(a);var s=vc(e,2);var f=vc(e,2);return{s:{r:n,c:s[0],cRel:s[1],rRel:s[2]},e:{r:i,c:f[0],cRel:f[1],rRel:f[2]}}}function bc(e){var r=vc(e,2),t=vc(e,2);var a=e._R(1);var n=e._R(1);return{s:{r:r[0],c:a,cRel:r[1],rRel:r[2]},e:{r:t[0],c:n,cRel:t[1],rRel:t[2]}}}function mc(e,r,t){if(t.biff<8)return bc(e,r,t);var a=e._R(t.biff==12?4:2),n=e._R(t.biff==12?4:2);var i=vc(e,2);var s=vc(e,2);return{s:{r:a,c:i[0],cRel:i[1],rRel:i[2]},e:{r:n,c:s[0],cRel:s[1],rRel:s[2]}}}function gc(e,r,t){if(t&&t.biff>=2&&t.biff<=5)return Ec(e,r,t);var a=e._R(t&&t.biff==12?4:2);var n=vc(e,2);return{r:a,c:n[0],cRel:n[1],rRel:n[2]}}function Ec(e){var r=vc(e,2);var t=e._R(1);return{r:r[0],c:t,cRel:r[1],rRel:r[2]}}function wc(e){var r=e._R(2);var t=e._R(2);return{r:r,c:t&255,fQuoted:!!(t&16384),cRel:t>>15,rRel:t>>15}}function kc(e,r,t){var a=t&&t.biff?t.biff:8;if(a>=2&&a<=5)return Sc(e,r,t);var n=e._R(a>=12?4:2);var i=e._R(2);var s=(i&16384)>>14,f=(i&32768)>>15;i&=16383;if(f==1)while(n>524287)n-=1048576;if(s==1)while(i>8191)i=i-16384;return{r:n,c:i,cRel:s,rRel:f}}function Sc(e){var r=e._R(2);var t=e._R(1);var a=(r&32768)>>15,n=(r&16384)>>14;r&=16383;if(a==1&&r>=8192)r=r-16384;if(n==1&&t>=128)t=t-256;return{r:r,c:t,cRel:n,rRel:a}}function Bc(e,r,t){var a=(e[e.l++]&96)>>5;var n=pc(e,t.biff>=2&&t.biff<=5?6:8,t);return[a,n]}function Cc(e,r,t){var a=(e[e.l++]&96)>>5;var n=e._R(2,"i");var i=8;if(t)switch(t.biff){case 5:e.l+=12;i=6;break;case 12:i=12;break;}var s=pc(e,i,t);return[a,n,s]}function Tc(e,r,t){var a=(e[e.l++]&96)>>5;e.l+=t&&t.biff>8?12:t.biff<8?6:8;return[a]}function _c(e,r,t){var a=(e[e.l++]&96)>>5;var n=e._R(2);var i=8;if(t)switch(t.biff){case 5:e.l+=12;i=6;break;case 12:i=12;break;}e.l+=i;return[a,n]}function xc(e,r,t){var a=(e[e.l++]&96)>>5;var n=mc(e,r-1,t);return[a,n]}function Ac(e,r,t){var a=(e[e.l++]&96)>>5;e.l+=t.biff==2?6:t.biff==12?14:7;return[a]}function yc(e){var r=e[e.l+1]&1;var t=1;e.l+=4;return[r,t]}function Ic(e,r,t){e.l+=2;var a=e._R(t&&t.biff==2?1:2);var n=[];for(var i=0;i<=a;++i)n.push(e._R(t&&t.biff==2?1:2));return n}function Rc(e,r,t){var a=e[e.l+1]&255?1:0;e.l+=2;return[a,e._R(t&&t.biff==2?1:2)]}function Fc(e,r,t){var a=e[e.l+1]&255?1:0;e.l+=2;return[a,e._R(t&&t.biff==2?1:2)]}function Dc(e){var r=e[e.l+1]&255?1:0;e.l+=2;return[r,e._R(2)]}function Oc(e,r,t){var a=e[e.l+1]&255?1:0;e.l+=t&&t.biff==2?3:4;return[a]}function Pc(e){var r=e._R(1),t=e._R(1);return[r,t]}function Nc(e){e._R(2);return Pc(e,2)}function Mc(e){e._R(2);return Pc(e,2)}function Lc(e,r,t){var a=(e[e.l]&96)>>5;e.l+=1;var n=gc(e,0,t);return[a,n]}function Uc(e,r,t){var a=(e[e.l]&96)>>5;e.l+=1;var n=kc(e,0,t);return[a,n]}function Hc(e,r,t){var a=(e[e.l]&96)>>5;e.l+=1;var n=e._R(2);if(t&&t.biff==5)e.l+=12;var i=gc(e,0,t);return[a,n,i]}function Wc(e,r,t){var a=(e[e.l]&96)>>5;e.l+=1;var n=e._R(t&&t.biff<=3?1:2);return[nh[n],ah[n],a]}function Vc(e,r,t){var a=e[e.l++];var n=e._R(1),i=t&&t.biff<=3?[a==88?-1:0,e._R(1)]:Xc(e);return[n,(i[0]===0?ah:th)[i[1]]]}function Xc(e){return[e[e.l+1]>>7,e._R(2)&32767]}function Gc(e,r,t){e.l+=t&&t.biff==2?3:4;return}function zc(e,r,t){e.l++;if(t&&t.biff==12)return[e._R(4,"i"),0];var a=e._R(2);var n=e._R(t&&t.biff==2?1:2);return[a,n]}function jc(e){e.l++;return ya[e._R(1)]}function $c(e){e.l++;return e._R(2)}function Kc(e){e.l++;return e._R(1)!==0}function Yc(e){e.l++;return Zt(e,8)}function Qc(e,r,t){e.l++;return qn(e,r-1,t)}function Jc(e,r){var t=[e._R(1)];if(r==12)switch(t[0]){case 2:t[0]=4;break;case 4:t[0]=16;break;case 0:t[0]=1;break;case 1:t[0]=2;break;}switch(t[0]){case 4:t[1]=jn(e,1)?"TRUE":"FALSE";if(r!=12)e.l+=7;break;case 37:;case 16:t[1]=ya[e[e.l]];e.l+=r==12?4:8;break;case 0:e.l+=8;break;case 1:t[1]=Zt(e,8);break;case 2:t[1]=ni(e,0,{biff:r>0&&r<8?2:r});break;default:throw new Error("Bad SerAr: "+t[0]);}return t}function Zc(e,r,t){var a=e._R(t.biff==12?4:2);var n=[];for(var i=0;i!=a;++i)n.push((t.biff==12?Qt:Bi)(e,8));
return n}function qc(e,r,t){var a=0,n=0;if(t.biff==12){a=e._R(4);n=e._R(4)}else{n=1+e._R(1);a=1+e._R(2)}if(t.biff>=2&&t.biff<8){--a;if(--n==0)n=256}for(var i=0,s=[];i!=a&&(s[i]=[]);++i)for(var f=0;f!=n;++f)s[i][f]=Jc(e,t.biff);return s}function eu(e,r,t){var a=e._R(1)>>>5&3;var n=!t||t.biff>=8?4:2;var i=e._R(n);switch(t.biff){case 2:e.l+=5;break;case 3:;case 4:e.l+=8;break;case 5:e.l+=12;break;}return[a,0,i]}function ru(e,r,t){if(t.biff==5)return tu(e,r,t);var a=e._R(1)>>>5&3;var n=e._R(2);var i=e._R(4);return[a,n,i]}function tu(e){var r=e._R(1)>>>5&3;var t=e._R(2,"i");e.l+=8;var a=e._R(2);e.l+=12;return[r,t,a]}function au(e,r,t){var a=e._R(1)>>>5&3;e.l+=t&&t.biff==2?3:4;var n=e._R(t&&t.biff==2?1:2);return[a,n]}function nu(e,r,t){var a=e._R(1)>>>5&3;var n=e._R(t&&t.biff==2?1:2);return[a,n]}function iu(e,r,t){var a=e._R(1)>>>5&3;e.l+=4;if(t.biff<8)e.l--;if(t.biff==12)e.l+=2;return[a]}function su(e,r,t){var a=(e[e.l++]&96)>>5;var n=e._R(2);var i=4;if(t)switch(t.biff){case 5:i=15;break;case 12:i=6;break;}e.l+=i;return[a,n]}var fu=Qr;var lu=Qr;var ou=Qr;function cu(e,r,t){e.l+=2;return[wc(e,4,t)]}function uu(e){e.l+=6;return[]}var hu=cu;var du=uu;var vu=uu;var pu=cu;function bu(e){e.l+=2;return[Kn(e),e._R(2)&1]}var mu=cu;var gu=bu;var Eu=uu;var wu=cu;var ku=cu;var Su=["Data","All","Headers","??","?Data2","??","?DataHeaders","??","Totals","??","??","??","?DataTotals","??","??","??","?Current"];function Bu(e){e.l+=2;var r=e._R(2);var t=e._R(2);var a=e._R(4);var n=e._R(2);var i=e._R(2);var s=Su[t>>2&31];return{ixti:r,coltype:t&3,rt:s,idx:a,c:n,C:i}}function Cu(e){e.l+=2;return[e._R(4)]}function Tu(e,r,t){e.l+=5;e.l+=2;e.l+=t.biff==2?1:4;return["PTGSHEET"]}function _u(e,r,t){e.l+=t.biff==2?4:5;return["PTGENDSHEET"]}function xu(e){var r=e._R(1)>>>5&3;var t=e._R(2);return[r,t]}function Au(e){var r=e._R(1)>>>5&3;var t=e._R(2);return[r,t]}function yu(e){e.l+=4;return[0,0]}var Iu={1:{n:"PtgExp",f:zc},2:{n:"PtgTbl",f:ou},3:{n:"PtgAdd",f:dc},4:{n:"PtgSub",f:dc},5:{n:"PtgMul",f:dc},6:{n:"PtgDiv",f:dc},7:{n:"PtgPower",f:dc},8:{n:"PtgConcat",f:dc},9:{n:"PtgLt",f:dc},10:{n:"PtgLe",f:dc},11:{n:"PtgEq",f:dc},12:{n:"PtgGe",f:dc},13:{n:"PtgGt",f:dc},14:{n:"PtgNe",f:dc},15:{n:"PtgIsect",f:dc},16:{n:"PtgUnion",f:dc},17:{n:"PtgRange",f:dc},18:{n:"PtgUplus",f:dc},19:{n:"PtgUminus",f:dc},20:{n:"PtgPercent",f:dc},21:{n:"PtgParen",f:dc},22:{n:"PtgMissArg",f:dc},23:{n:"PtgStr",f:Qc},26:{n:"PtgSheet",f:Tu},27:{n:"PtgEndSheet",f:_u},28:{n:"PtgErr",f:jc},29:{n:"PtgBool",f:Kc},30:{n:"PtgInt",f:$c},31:{n:"PtgNum",f:Yc},32:{n:"PtgArray",f:Ac},33:{n:"PtgFunc",f:Wc},34:{n:"PtgFuncVar",f:Vc},35:{n:"PtgName",f:eu},36:{n:"PtgRef",f:Lc},37:{n:"PtgArea",f:Bc},38:{n:"PtgMemArea",f:au},39:{n:"PtgMemErr",f:fu},40:{n:"PtgMemNoMem",f:lu},41:{n:"PtgMemFunc",f:nu},42:{n:"PtgRefErr",f:iu},43:{n:"PtgAreaErr",f:Tc},44:{n:"PtgRefN",f:Uc},45:{n:"PtgAreaN",f:xc},46:{n:"PtgMemAreaN",f:xu},47:{n:"PtgMemNoMemN",f:Au},57:{n:"PtgNameX",f:ru},58:{n:"PtgRef3d",f:Hc},59:{n:"PtgArea3d",f:Cc},60:{n:"PtgRefErr3d",f:su},61:{n:"PtgAreaErr3d",f:_c},255:{}};var Ru={64:32,96:32,65:33,97:33,66:34,98:34,67:35,99:35,68:36,100:36,69:37,101:37,70:38,102:38,71:39,103:39,72:40,104:40,73:41,105:41,74:42,106:42,75:43,107:43,76:44,108:44,77:45,109:45,78:46,110:46,79:47,111:47,88:34,120:34,89:57,121:57,90:58,122:58,91:59,123:59,92:60,124:60,93:61,125:61};(function(){for(var e in Ru)Iu[e]=Iu[Ru[e]]})();var Fu={1:{n:"PtgElfLel",f:bu},2:{n:"PtgElfRw",f:wu},3:{n:"PtgElfCol",f:hu},6:{n:"PtgElfRwV",f:ku},7:{n:"PtgElfColV",f:pu},10:{n:"PtgElfRadical",f:mu},11:{n:"PtgElfRadicalS",f:Eu},13:{n:"PtgElfColS",f:du},15:{n:"PtgElfColSV",f:vu},16:{n:"PtgElfRadicalLel",f:gu},25:{n:"PtgList",f:Bu},29:{n:"PtgSxName",f:Cu},255:{}};var Du={0:{n:"PtgAttrNoop",f:yu},1:{n:"PtgAttrSemi",f:Oc},2:{n:"PtgAttrIf",f:Fc},4:{n:"PtgAttrChoose",f:Ic},8:{n:"PtgAttrGoto",f:Rc},16:{n:"PtgAttrSum",f:Gc},32:{n:"PtgAttrBaxcel",f:yc},64:{n:"PtgAttrSpace",f:Nc},65:{n:"PtgAttrSpaceSemi",f:Mc},128:{n:"PtgAttrIfError",f:Dc},255:{}};Du[33]=Du[32];function Ou(e,r,t,a){if(a.biff<8)return Qr(e,r);var n=e.l+r;var i=[];for(var s=0;s!==t.length;++s){switch(t[s][0]){case"PtgArray":t[s][1]=qc(e,0,a);i.push(t[s][1]);break;case"PtgMemArea":t[s][2]=Zc(e,t[s][1],a);i.push(t[s][2]);break;case"PtgExp":if(a&&a.biff==12){t[s][1][1]=e._R(4);i.push(t[s][1])}break;case"PtgList":;case"PtgElfRadicalS":;case"PtgElfColS":;case"PtgElfColSV":throw"Unsupported "+t[s][0];default:break;}}r=n-e.l;if(r!==0)i.push(Qr(e,r));return i}function Pu(e,r,t){var a=e.l+r;var n,i,s=[];while(a!=e.l){r=a-e.l;i=e[e.l];n=Iu[i];if(i===24||i===25)n=(i===24?Fu:Du)[e[e.l+1]];if(!n||!n.f){Qr(e,r)}else{s.push([n.n,n.f(e,r,t)])}}return s}function Nu(e){var r=[];for(var t=0;t<e.length;++t){var a=e[t],n=[];for(var i=0;i<a.length;++i){var s=a[i];if(s)switch(s[0]){case 2:n.push('"'+s[1].replace(/"/g,'""')+'"');break;default:n.push(s[1]);}else n.push("")}r.push(n.join(","))}return r.join(";")}var Mu={PtgAdd:"+",PtgConcat:"&",PtgDiv:"/",PtgEq:"=",PtgGe:">=",PtgGt:">",PtgLe:"<=",PtgLt:"<",PtgMul:"*",PtgNe:"<>",PtgPower:"^",PtgSub:"-"};var Lu=new RegExp(/[^\w\u4E00-\u9FFF\u3040-\u30FF]/);function Uu(e,r){if(!e&&!(r&&r.biff<=5&&r.biff>=2))throw new Error("empty sheet name");if(Lu.test(e))return"'"+e+"'";return e}function Hu(e,r,t){if(!e)return"SH33TJSERR0";if(t.biff>8&&(!e.XTI||!e.XTI[r]))return e.SheetNames[r];if(!e.XTI)return"SH33TJSERR6";var a=e.XTI[r];if(t.biff<8){if(r>1e4)r-=65536;if(r<0)r=-r;return r==0?"":e.XTI[r-1]}if(!a)return"SH33TJSERR1";var n="";if(t.biff>8)switch(e[a[0]][0]){case 357:n=a[1]==-1?"#REF":e.SheetNames[a[1]];return a[1]==a[2]?n:n+":"+e.SheetNames[a[2]];case 358:if(t.SID!=null)return e.SheetNames[t.SID];return"SH33TJSSAME"+e[a[0]][0];case 355:;default:return"SH33TJSSRC"+e[a[0]][0];}switch(e[a[0]][0][0]){case 1025:n=a[1]==-1?"#REF":e.SheetNames[a[1]]||"SH33TJSERR3";return a[1]==a[2]?n:n+":"+e.SheetNames[a[2]];case 14849:return e[a[0]].slice(1).map(function(e){return e.Name}).join(";;");default:if(!e[a[0]][0][3])return"SH33TJSERR2";n=a[1]==-1?"#REF":e[a[0]][0][3][a[1]]||"SH33TJSERR4";return a[1]==a[2]?n:n+":"+e[a[0]][0][3][a[2]];}}function Wu(e,r,t){var a=Hu(e,r,t);return a=="#REF"?a:Uu(a,t)}function Vu(e,r,t,a,n){var i=n&&n.biff||8;var s={s:{c:0,r:0},e:{c:0,r:0}};var f=[],l,o,c,u=0,h=0,d,v="";if(!e[0]||!e[0][0])return"";var p=-1,b="";for(var m=0,g=e[0].length;m<g;++m){var E=e[0][m];switch(E[0]){case"PtgUminus":f.push("-"+f.pop());break;case"PtgUplus":f.push("+"+f.pop());break;case"PtgPercent":f.push(f.pop()+"%");break;case"PtgAdd":;case"PtgConcat":;case"PtgDiv":;case"PtgEq":;case"PtgGe":;case"PtgGt":;case"PtgLe":;case"PtgLt":;case"PtgMul":;case"PtgNe":;case"PtgPower":;case"PtgSub":l=f.pop();o=f.pop();if(p>=0){switch(e[0][p][1][0]){case 0:b=ue(" ",e[0][p][1][1]);break;case 1:b=ue("\r",e[0][p][1][1]);break;default:b="";if(n.WTF)throw new Error("Unexpected PtgAttrSpaceType "+e[0][p][1][0]);}o=o+b;p=-1}f.push(o+Mu[E[0]]+l);break;case"PtgIsect":l=f.pop();o=f.pop();f.push(o+" "+l);break;case"PtgUnion":l=f.pop();o=f.pop();f.push(o+","+l);break;case"PtgRange":l=f.pop();o=f.pop();f.push(o+":"+l);break;case"PtgAttrChoose":break;case"PtgAttrGoto":break;case"PtgAttrIf":break;case"PtgAttrIfError":break;case"PtgRef":c=rt(E[1][1],s,n);f.push(at(c,i));break;case"PtgRefN":c=t?rt(E[1][1],t,n):E[1][1];f.push(at(c,i));break;case"PtgRef3d":u=E[1][1];c=rt(E[1][2],s,n);v=Wu(a,u,n);var w=v;f.push(v+"!"+at(c,i));break;case"PtgFunc":;case"PtgFuncVar":var k=E[1][0],S=E[1][1];if(!k)k=0;k&=127;var B=k==0?[]:f.slice(-k);f.length-=k;if(S==="User")S=B.shift();f.push(S+"("+B.join(",")+")");break;case"PtgBool":f.push(E[1]?"TRUE":"FALSE");break;case"PtgInt":f.push(E[1]);break;case"PtgNum":f.push(String(E[1]));break;case"PtgStr":f.push('"'+E[1].replace(/"/g,'""')+'"');break;case"PtgErr":f.push(E[1]);break;case"PtgAreaN":d=tt(E[1][1],t?{s:t}:s,n);f.push(nt(d,n));break;case"PtgArea":d=tt(E[1][1],s,n);f.push(nt(d,n));break;case"PtgArea3d":u=E[1][1];d=E[1][2];v=Wu(a,u,n);f.push(v+"!"+nt(d,n));break;case"PtgAttrSum":f.push("SUM("+f.pop()+")");break;case"PtgAttrBaxcel":;case"PtgAttrSemi":break;case"PtgName":h=E[1][2];var C=(a.names||[])[h-1]||(a[0]||[])[h];var T=C?C.Name:"SH33TJSNAME"+String(h);if(T in ih)T=ih[T];f.push(T);break;case"PtgNameX":var _=E[1][1];h=E[1][2];var x;if(n.biff<=5){if(_<0)_=-_;if(a[_])x=a[_][h]}else{var A="";if(((a[_]||[])[0]||[])[0]==14849){}else if(((a[_]||[])[0]||[])[0]==1025){if(a[_][h]&&a[_][h].itab>0){A=a.SheetNames[a[_][h].itab-1]+"!"}}else A=a.SheetNames[h-1]+"!";if(a[_]&&a[_][h])A+=a[_][h].Name;else if(a[0]&&a[0][h])A+=a[0][h].Name;else{var y=(Hu(a,_,n)||"").split(";;");if(y[h-1])A=y[h-1];else A+="SH33TJSERRX"}f.push(A);break}if(!x)x={Name:"SH33TJSERRY"};f.push(x.Name);break;case"PtgParen":var I="(",R=")";if(p>=0){b="";switch(e[0][p][1][0]){case 2:I=ue(" ",e[0][p][1][1])+I;break;case 3:I=ue("\r",e[0][p][1][1])+I;break;case 4:R=ue(" ",e[0][p][1][1])+R;break;case 5:R=ue("\r",e[0][p][1][1])+R;break;default:if(n.WTF)throw new Error("Unexpected PtgAttrSpaceType "+e[0][p][1][0]);}p=-1}f.push(I+f.pop()+R);break;case"PtgRefErr":f.push("#REF!");break;case"PtgRefErr3d":f.push("#REF!");break;case"PtgExp":c={c:E[1][1],r:E[1][0]};var F={c:t.c,r:t.r};if(a.sharedf[mt(c)]){var D=a.sharedf[mt(c)];f.push(Vu(D,s,F,a,n))}else{var O=false;for(l=0;l!=a.arrayf.length;++l){o=a.arrayf[l];if(c.c<o[0].s.c||c.c>o[0].e.c)continue;if(c.r<o[0].s.r||c.r>o[0].e.r)continue;f.push(Vu(o[1],s,F,a,n));O=true;break}if(!O)f.push(E[1])}break;case"PtgArray":f.push("{"+Nu(E[1])+"}");break;case"PtgMemArea":break;case"PtgAttrSpace":;case"PtgAttrSpaceSemi":p=m;break;case"PtgTbl":break;case"PtgMemErr":break;case"PtgMissArg":f.push("");break;case"PtgAreaErr":f.push("#REF!");break;case"PtgAreaErr3d":f.push("#REF!");break;case"PtgList":f.push("Table"+E[1].idx+"[#"+E[1].rt+"]");break;case"PtgMemAreaN":;case"PtgMemNoMemN":;case"PtgAttrNoop":;case"PtgSheet":;case"PtgEndSheet":break;case"PtgMemFunc":break;case"PtgMemNoMem":break;case"PtgElfCol":;case"PtgElfColS":;case"PtgElfColSV":;case"PtgElfColV":;case"PtgElfLel":;case"PtgElfRadical":;case"PtgElfRadicalLel":;case"PtgElfRadicalS":;case"PtgElfRw":;case"PtgElfRwV":throw new Error("Unsupported ELFs");case"PtgSxName":throw new Error("Unrecognized Formula Token: "+String(E));default:throw new Error("Unrecognized Formula Token: "+String(E));}var P=["PtgAttrSpace","PtgAttrSpaceSemi","PtgAttrGoto"];if(n.biff!=3)if(p>=0&&P.indexOf(e[0][m][0])==-1){E=e[0][p];var N=true;switch(E[1][0]){case 4:N=false;case 0:b=ue(" ",E[1][1]);break;case 5:N=false;case 1:b=ue("\r",E[1][1]);break;default:b="";if(n.WTF)throw new Error("Unexpected PtgAttrSpaceType "+E[1][0]);}f.push((N?b:"")+f.pop()+(N?"":b));p=-1}}if(f.length>1&&n.WTF)throw new Error("bad formula stack");return f[0]}function Xu(e,r,t){var a=e.l+r,n=t.biff==2?1:2;var i,s=e._R(n);if(s==65535)return[[],Qr(e,r-2)];var f=Pu(e,s,t);if(r!==s+n)i=Ou(e,r-s-n,f,t);e.l=a;return[f,i]}function Gu(e,r,t){var a=e.l+r,n=t.biff==2?1:2;var i,s=e._R(n);if(s==65535)return[[],Qr(e,r-2)];var f=Pu(e,s,t);if(r!==s+n)i=Ou(e,r-s-n,f,t);e.l=a;return[f,i]}function zu(e,r,t,a){var n=e.l+r;var i=Pu(e,a,t);var s;if(n!==e.l)s=Ou(e,n-e.l,i,t);return[i,s]}function ju(e,r,t){var a=e.l+r;var n,i=e._R(2);var s=Pu(e,i,t);if(i==65535)return[[],Qr(e,r-2)];if(r!==i+2)n=Ou(e,a-i-2,s,t);return[s,n]}function $u(e){var r;if(Lr(e,e.l+6)!==65535)return[Zt(e),"n"];switch(e[e.l]){case 0:e.l+=8;return["String","s"];case 1:r=e[e.l+2]===1;e.l+=8;return[r,"b"];case 2:r=e[e.l+2];e.l+=8;return[r,"e"];case 3:e.l+=8;return["","s"];}return[]}function Ku(e){if(e==null){var r=Jr(8);r._W(1,3);r._W(1,0);r._W(2,0);r._W(2,0);r._W(2,65535);return r}else if(typeof e=="number")return qt(e);return qt(0)}function Yu(e,r,t){var a=e.l+r;var n=bi(e,6);if(t.biff==2)++e.l;var i=$u(e,8);var s=e._R(1);if(t.biff!=2){e._R(1);if(t.biff>=5){e._R(4)}}var f=Gu(e,a-e.l,t);return{cell:n,val:i[0],formula:f,shared:s>>3&1,tt:i[1]}}function Qu(e,r,t,a,n){var i=mi(r,t,n);var s=Ku(e.v);var f=Jr(6);var l=1|32;f._W(2,l);f._W(4,0);var o=Jr(e.bf.length);for(var c=0;c<e.bf.length;++c)o[c]=e.bf[c];var u=I([i,s,f,o]);return u}function Ju(e,r,t){var a=e._R(4);var n=Pu(e,a,t);var i=e._R(4);var s=i>0?Ou(e,i,n,t):null;return[n,s]}var Zu=Ju;var qu=Ju;var eh=Ju;var rh=Ju;var th={0:"BEEP",1:"OPEN",2:"OPEN.LINKS",3:"CLOSE.ALL",4:"SAVE",5:"SAVE.AS",6:"FILE.DELETE",7:"PAGE.SETUP",8:"PRINT",9:"PRINTER.SETUP",10:"QUIT",11:"NEW.WINDOW",12:"ARRANGE.ALL",13:"WINDOW.SIZE",14:"WINDOW.MOVE",15:"FULL",16:"CLOSE",17:"RUN",22:"SET.PRINT.AREA",23:"SET.PRINT.TITLES",24:"SET.PAGE.BREAK",25:"REMOVE.PAGE.BREAK",26:"FONT",27:"DISPLAY",28:"PROTECT.DOCUMENT",29:"PRECISION",30:"A1.R1C1",31:"CALCULATE.NOW",32:"CALCULATION",34:"DATA.FIND",35:"EXTRACT",36:"DATA.DELETE",37:"SET.DATABASE",38:"SET.CRITERIA",39:"SORT",40:"DATA.SERIES",41:"TABLE",42:"FORMAT.NUMBER",43:"ALIGNMENT",44:"STYLE",45:"BORDER",46:"CELL.PROTECTION",47:"COLUMN.WIDTH",48:"UNDO",49:"CUT",50:"COPY",51:"PASTE",52:"CLEAR",53:"PASTE.SPECIAL",54:"EDIT.DELETE",55:"INSERT",56:"FILL.RIGHT",57:"FILL.DOWN",61:"DEFINE.NAME",62:"CREATE.NAMES",63:"FORMULA.GOTO",64:"FORMULA.FIND",65:"SELECT.LAST.CELL",66:"SHOW.ACTIVE.CELL",67:"GALLERY.AREA",68:"GALLERY.BAR",69:"GALLERY.COLUMN",70:"GALLERY.LINE",71:"GALLERY.PIE",72:"GALLERY.SCATTER",73:"COMBINATION",74:"PREFERRED",75:"ADD.OVERLAY",76:"GRIDLINES",77:"SET.PREFERRED",78:"AXES",79:"LEGEND",80:"ATTACH.TEXT",81:"ADD.ARROW",82:"SELECT.CHART",83:"SELECT.PLOT.AREA",84:"PATTERNS",85:"MAIN.CHART",86:"OVERLAY",87:"SCALE",88:"FORMAT.LEGEND",89:"FORMAT.TEXT",90:"EDIT.REPEAT",91:"PARSE",92:"JUSTIFY",93:"HIDE",94:"UNHIDE",95:"WORKSPACE",96:"FORMULA",97:"FORMULA.FILL",98:"FORMULA.ARRAY",99:"DATA.FIND.NEXT",100:"DATA.FIND.PREV",101:"FORMULA.FIND.NEXT",102:"FORMULA.FIND.PREV",103:"ACTIVATE",104:"ACTIVATE.NEXT",105:"ACTIVATE.PREV",106:"UNLOCKED.NEXT",107:"UNLOCKED.PREV",108:"COPY.PICTURE",109:"SELECT",110:"DELETE.NAME",111:"DELETE.FORMAT",112:"VLINE",113:"HLINE",114:"VPAGE",115:"HPAGE",116:"VSCROLL",117:"HSCROLL",118:"ALERT",119:"NEW",120:"CANCEL.COPY",121:"SHOW.CLIPBOARD",122:"MESSAGE",124:"PASTE.LINK",125:"APP.ACTIVATE",126:"DELETE.ARROW",127:"ROW.HEIGHT",128:"FORMAT.MOVE",129:"FORMAT.SIZE",130:"FORMULA.REPLACE",131:"SEND.KEYS",132:"SELECT.SPECIAL",133:"APPLY.NAMES",134:"REPLACE.FONT",135:"FREEZE.PANES",136:"SHOW.INFO",137:"SPLIT",138:"ON.WINDOW",139:"ON.DATA",140:"DISABLE.INPUT",142:"OUTLINE",143:"LIST.NAMES",144:"FILE.CLOSE",145:"SAVE.WORKBOOK",146:"DATA.FORM",147:"COPY.CHART",148:"ON.TIME",149:"WAIT",150:"FORMAT.FONT",151:"FILL.UP",152:"FILL.LEFT",153:"DELETE.OVERLAY",155:"SHORT.MENUS",159:"SET.UPDATE.STATUS",161:"COLOR.PALETTE",162:"DELETE.STYLE",163:"WINDOW.RESTORE",164:"WINDOW.MAXIMIZE",166:"CHANGE.LINK",167:"CALCULATE.DOCUMENT",168:"ON.KEY",169:"APP.RESTORE",170:"APP.MOVE",171:"APP.SIZE",172:"APP.MINIMIZE",173:"APP.MAXIMIZE",174:"BRING.TO.FRONT",175:"SEND.TO.BACK",185:"MAIN.CHART.TYPE",186:"OVERLAY.CHART.TYPE",187:"SELECT.END",188:"OPEN.MAIL",189:"SEND.MAIL",190:"STANDARD.FONT",191:"CONSOLIDATE",192:"SORT.SPECIAL",193:"GALLERY.3D.AREA",194:"GALLERY.3D.COLUMN",195:"GALLERY.3D.LINE",196:"GALLERY.3D.PIE",197:"VIEW.3D",198:"GOAL.SEEK",199:"WORKGROUP",200:"FILL.GROUP",201:"UPDATE.LINK",202:"PROMOTE",203:"DEMOTE",204:"SHOW.DETAIL",206:"UNGROUP",207:"OBJECT.PROPERTIES",208:"SAVE.NEW.OBJECT",209:"SHARE",210:"SHARE.NAME",211:"DUPLICATE",212:"APPLY.STYLE",213:"ASSIGN.TO.OBJECT",214:"OBJECT.PROTECTION",215:"HIDE.OBJECT",216:"SET.EXTRACT",217:"CREATE.PUBLISHER",218:"SUBSCRIBE.TO",219:"ATTRIBUTES",220:"SHOW.TOOLBAR",222:"PRINT.PREVIEW",223:"EDIT.COLOR",224:"SHOW.LEVELS",225:"FORMAT.MAIN",226:"FORMAT.OVERLAY",227:"ON.RECALC",228:"EDIT.SERIES",229:"DEFINE.STYLE",240:"LINE.PRINT",243:"ENTER.DATA",249:"GALLERY.RADAR",250:"MERGE.STYLES",251:"EDITION.OPTIONS",252:"PASTE.PICTURE",253:"PASTE.PICTURE.LINK",254:"SPELLING",256:"ZOOM",259:"INSERT.OBJECT",260:"WINDOW.MINIMIZE",265:"SOUND.NOTE",266:"SOUND.PLAY",267:"FORMAT.SHAPE",268:"EXTEND.POLYGON",269:"FORMAT.AUTO",272:"GALLERY.3D.BAR",273:"GALLERY.3D.SURFACE",274:"FILL.AUTO",276:"CUSTOMIZE.TOOLBAR",277:"ADD.TOOL",278:"EDIT.OBJECT",279:"ON.DOUBLECLICK",280:"ON.ENTRY",281:"WORKBOOK.ADD",282:"WORKBOOK.MOVE",283:"WORKBOOK.COPY",284:"WORKBOOK.OPTIONS",285:"SAVE.WORKSPACE",288:"CHART.WIZARD",289:"DELETE.TOOL",290:"MOVE.TOOL",291:"WORKBOOK.SELECT",292:"WORKBOOK.ACTIVATE",293:"ASSIGN.TO.TOOL",295:"COPY.TOOL",296:"RESET.TOOL",297:"CONSTRAIN.NUMERIC",298:"PASTE.TOOL",302:"WORKBOOK.NEW",305:"SCENARIO.CELLS",306:"SCENARIO.DELETE",307:"SCENARIO.ADD",308:"SCENARIO.EDIT",309:"SCENARIO.SHOW",310:"SCENARIO.SHOW.NEXT",311:"SCENARIO.SUMMARY",312:"PIVOT.TABLE.WIZARD",313:"PIVOT.FIELD.PROPERTIES",314:"PIVOT.FIELD",315:"PIVOT.ITEM",316:"PIVOT.ADD.FIELDS",318:"OPTIONS.CALCULATION",319:"OPTIONS.EDIT",320:"OPTIONS.VIEW",321:"ADDIN.MANAGER",322:"MENU.EDITOR",323:"ATTACH.TOOLBARS",324:"VBAActivate",325:"OPTIONS.CHART",328:"VBA.INSERT.FILE",330:"VBA.PROCEDURE.DEFINITION",336:"ROUTING.SLIP",338:"ROUTE.DOCUMENT",339:"MAIL.LOGON",342:"INSERT.PICTURE",343:"EDIT.TOOL",344:"GALLERY.DOUGHNUT",350:"CHART.TREND",352:"PIVOT.ITEM.PROPERTIES",354:"WORKBOOK.INSERT",355:"OPTIONS.TRANSITION",356:"OPTIONS.GENERAL",370:"FILTER.ADVANCED",373:"MAIL.ADD.MAILER",374:"MAIL.DELETE.MAILER",375:"MAIL.REPLY",376:"MAIL.REPLY.ALL",377:"MAIL.FORWARD",378:"MAIL.NEXT.LETTER",379:"DATA.LABEL",380:"INSERT.TITLE",381:"FONT.PROPERTIES",382:"MACRO.OPTIONS",383:"WORKBOOK.HIDE",384:"WORKBOOK.UNHIDE",385:"WORKBOOK.DELETE",386:"WORKBOOK.NAME",388:"GALLERY.CUSTOM",390:"ADD.CHART.AUTOFORMAT",391:"DELETE.CHART.AUTOFORMAT",392:"CHART.ADD.DATA",393:"AUTO.OUTLINE",394:"TAB.ORDER",395:"SHOW.DIALOG",396:"SELECT.ALL",397:"UNGROUP.SHEETS",398:"SUBTOTAL.CREATE",399:"SUBTOTAL.REMOVE",400:"RENAME.OBJECT",412:"WORKBOOK.SCROLL",413:"WORKBOOK.NEXT",414:"WORKBOOK.PREV",415:"WORKBOOK.TAB.SPLIT",416:"FULL.SCREEN",417:"WORKBOOK.PROTECT",420:"SCROLLBAR.PROPERTIES",421:"PIVOT.SHOW.PAGES",422:"TEXT.TO.COLUMNS",423:"FORMAT.CHARTTYPE",424:"LINK.FORMAT",425:"TRACER.DISPLAY",430:"TRACER.NAVIGATE",431:"TRACER.CLEAR",432:"TRACER.ERROR",433:"PIVOT.FIELD.GROUP",434:"PIVOT.FIELD.UNGROUP",435:"CHECKBOX.PROPERTIES",436:"LABEL.PROPERTIES",437:"LISTBOX.PROPERTIES",438:"EDITBOX.PROPERTIES",439:"PIVOT.REFRESH",440:"LINK.COMBO",441:"OPEN.TEXT",442:"HIDE.DIALOG",443:"SET.DIALOG.FOCUS",444:"ENABLE.OBJECT",445:"PUSHBUTTON.PROPERTIES",446:"SET.DIALOG.DEFAULT",447:"FILTER",448:"FILTER.SHOW.ALL",449:"CLEAR.OUTLINE",450:"FUNCTION.WIZARD",451:"ADD.LIST.ITEM",452:"SET.LIST.ITEM",453:"REMOVE.LIST.ITEM",454:"SELECT.LIST.ITEM",455:"SET.CONTROL.VALUE",456:"SAVE.COPY.AS",458:"OPTIONS.LISTS.ADD",459:"OPTIONS.LISTS.DELETE",460:"SERIES.AXES",461:"SERIES.X",462:"SERIES.Y",463:"ERRORBAR.X",464:"ERRORBAR.Y",465:"FORMAT.CHART",466:"SERIES.ORDER",467:"MAIL.LOGOFF",468:"CLEAR.ROUTING.SLIP",469:"APP.ACTIVATE.MICROSOFT",470:"MAIL.EDIT.MAILER",471:"ON.SHEET",472:"STANDARD.WIDTH",473:"SCENARIO.MERGE",474:"SUMMARY.INFO",475:"FIND.FILE",476:"ACTIVE.CELL.FONT",477:"ENABLE.TIPWIZARD",478:"VBA.MAKE.ADDIN",480:"INSERTDATATABLE",481:"WORKGROUP.OPTIONS",482:"MAIL.SEND.MAILER",485:"AUTOCORRECT",489:"POST.DOCUMENT",491:"PICKLIST",493:"VIEW.SHOW",494:"VIEW.DEFINE",495:"VIEW.DELETE",509:"SHEET.BACKGROUND",510:"INSERT.MAP.OBJECT",511:"OPTIONS.MENONO",517:"MSOCHECKS",518:"NORMAL",519:"LAYOUT",520:"RM.PRINT.AREA",521:"CLEAR.PRINT.AREA",522:"ADD.PRINT.AREA",523:"MOVE.BRK",545:"HIDECURR.NOTE",546:"HIDEALL.NOTES",547:"DELETE.NOTE",548:"TRAVERSE.NOTES",549:"ACTIVATE.NOTES",620:"PROTECT.REVISIONS",621:"UNPROTECT.REVISIONS",647:"OPTIONS.ME",653:"WEB.PUBLISH",667:"NEWWEBQUERY",673:"PIVOT.TABLE.CHART",753:"OPTIONS.SAVE",755:"OPTIONS.SPELL",808:"HIDEALL.INKANNOTS"};var ah={0:"COUNT",1:"IF",2:"ISNA",3:"ISERROR",4:"SUM",5:"AVERAGE",6:"MIN",7:"MAX",8:"ROW",9:"COLUMN",10:"NA",11:"NPV",12:"STDEV",13:"DOLLAR",14:"FIXED",15:"SIN",16:"COS",17:"TAN",18:"ATAN",19:"PI",20:"SQRT",21:"EXP",22:"LN",23:"LOG10",24:"ABS",25:"INT",26:"SIGN",27:"ROUND",28:"LOOKUP",29:"INDEX",30:"REPT",31:"MID",32:"LEN",33:"VALUE",34:"TRUE",35:"FALSE",36:"AND",37:"OR",38:"NOT",39:"MOD",40:"DCOUNT",41:"DSUM",42:"DAVERAGE",43:"DMIN",44:"DMAX",45:"DSTDEV",46:"VAR",47:"DVAR",48:"TEXT",49:"LINEST",50:"TREND",51:"LOGEST",52:"GROWTH",53:"GOTO",54:"HALT",55:"RETURN",56:"PV",57:"FV",58:"NPER",59:"PMT",60:"RATE",61:"MIRR",62:"IRR",63:"RAND",64:"MATCH",65:"DATE",66:"TIME",67:"DAY",68:"MONTH",69:"YEAR",70:"WEEKDAY",71:"HOUR",72:"MINUTE",73:"SECOND",74:"NOW",75:"AREAS",76:"ROWS",77:"COLUMNS",78:"OFFSET",79:"ABSREF",80:"RELREF",81:"ARGUMENT",82:"SEARCH",83:"TRANSPOSE",84:"ERROR",85:"STEP",86:"TYPE",87:"ECHO",88:"SET.NAME",89:"CALLER",90:"DEREF",91:"WINDOWS",92:"SERIES",93:"DOCUMENTS",94:"ACTIVE.CELL",95:"SELECTION",96:"RESULT",97:"ATAN2",98:"ASIN",99:"ACOS",100:"CHOOSE",101:"HLOOKUP",102:"VLOOKUP",103:"LINKS",104:"INPUT",105:"ISREF",106:"GET.FORMULA",107:"GET.NAME",108:"SET.VALUE",109:"LOG",110:"EXEC",111:"CHAR",112:"LOWER",113:"UPPER",114:"PROPER",115:"LEFT",116:"RIGHT",117:"EXACT",118:"TRIM",119:"REPLACE",120:"SUBSTITUTE",121:"CODE",122:"NAMES",123:"DIRECTORY",124:"FIND",125:"CELL",126:"ISERR",127:"ISTEXT",128:"ISNUMBER",129:"ISBLANK",130:"T",131:"N",132:"FOPEN",133:"FCLOSE",134:"FSIZE",135:"FREADLN",136:"FREAD",137:"FWRITELN",138:"FWRITE",139:"FPOS",140:"DATEVALUE",141:"TIMEVALUE",142:"SLN",143:"SYD",144:"DDB",145:"GET.DEF",146:"REFTEXT",147:"TEXTREF",148:"INDIRECT",149:"REGISTER",150:"CALL",151:"ADD.BAR",152:"ADD.MENU",153:"ADD.COMMAND",154:"ENABLE.COMMAND",155:"CHECK.COMMAND",156:"RENAME.COMMAND",157:"SHOW.BAR",158:"DELETE.MENU",159:"DELETE.COMMAND",160:"GET.CHART.ITEM",161:"DIALOG.BOX",162:"CLEAN",163:"MDETERM",164:"MINVERSE",165:"MMULT",166:"FILES",167:"IPMT",168:"PPMT",169:"COUNTA",170:"CANCEL.KEY",171:"FOR",172:"WHILE",173:"BREAK",174:"NEXT",175:"INITIATE",176:"REQUEST",177:"POKE",178:"EXECUTE",179:"TERMINATE",180:"RESTART",181:"HELP",182:"GET.BAR",183:"PRODUCT",184:"FACT",185:"GET.CELL",186:"GET.WORKSPACE",187:"GET.WINDOW",188:"GET.DOCUMENT",189:"DPRODUCT",190:"ISNONTEXT",191:"GET.NOTE",192:"NOTE",193:"STDEVP",194:"VARP",195:"DSTDEVP",196:"DVARP",197:"TRUNC",198:"ISLOGICAL",199:"DCOUNTA",200:"DELETE.BAR",201:"UNREGISTER",204:"USDOLLAR",205:"FINDB",206:"SEARCHB",207:"REPLACEB",208:"LEFTB",209:"RIGHTB",210:"MIDB",211:"LENB",212:"ROUNDUP",213:"ROUNDDOWN",214:"ASC",215:"DBCS",216:"RANK",219:"ADDRESS",220:"DAYS360",221:"TODAY",222:"VDB",223:"ELSE",224:"ELSE.IF",225:"END.IF",226:"FOR.CELL",227:"MEDIAN",228:"SUMPRODUCT",229:"SINH",230:"COSH",231:"TANH",232:"ASINH",233:"ACOSH",234:"ATANH",235:"DGET",236:"CREATE.OBJECT",237:"VOLATILE",238:"LAST.ERROR",239:"CUSTOM.UNDO",240:"CUSTOM.REPEAT",241:"FORMULA.CONVERT",242:"GET.LINK.INFO",243:"TEXT.BOX",244:"INFO",245:"GROUP",246:"GET.OBJECT",247:"DB",248:"PAUSE",251:"RESUME",252:"FREQUENCY",253:"ADD.TOOLBAR",254:"DELETE.TOOLBAR",255:"User",256:"RESET.TOOLBAR",257:"EVALUATE",258:"GET.TOOLBAR",259:"GET.TOOL",260:"SPELLING.CHECK",261:"ERROR.TYPE",262:"APP.TITLE",263:"WINDOW.TITLE",264:"SAVE.TOOLBAR",265:"ENABLE.TOOL",266:"PRESS.TOOL",267:"REGISTER.ID",268:"GET.WORKBOOK",269:"AVEDEV",270:"BETADIST",271:"GAMMALN",272:"BETAINV",273:"BINOMDIST",274:"CHIDIST",275:"CHIINV",276:"COMBIN",277:"CONFIDENCE",278:"CRITBINOM",279:"EVEN",280:"EXPONDIST",281:"FDIST",282:"FINV",283:"FISHER",284:"FISHERINV",285:"FLOOR",286:"GAMMADIST",287:"GAMMAINV",288:"CEILING",289:"HYPGEOMDIST",290:"LOGNORMDIST",291:"LOGINV",292:"NEGBINOMDIST",293:"NORMDIST",294:"NORMSDIST",295:"NORMINV",296:"NORMSINV",297:"STANDARDIZE",298:"ODD",299:"PERMUT",300:"POISSON",301:"TDIST",302:"WEIBULL",303:"SUMXMY2",304:"SUMX2MY2",305:"SUMX2PY2",306:"CHITEST",307:"CORREL",308:"COVAR",309:"FORECAST",310:"FTEST",311:"INTERCEPT",312:"PEARSON",313:"RSQ",314:"STEYX",315:"SLOPE",316:"TTEST",317:"PROB",318:"DEVSQ",319:"GEOMEAN",320:"HARMEAN",321:"SUMSQ",322:"KURT",323:"SKEW",324:"ZTEST",325:"LARGE",326:"SMALL",327:"QUARTILE",328:"PERCENTILE",329:"PERCENTRANK",330:"MODE",331:"TRIMMEAN",332:"TINV",334:"MOVIE.COMMAND",335:"GET.MOVIE",336:"CONCATENATE",337:"POWER",338:"PIVOT.ADD.DATA",339:"GET.PIVOT.TABLE",340:"GET.PIVOT.FIELD",341:"GET.PIVOT.ITEM",342:"RADIANS",343:"DEGREES",344:"SUBTOTAL",345:"SUMIF",346:"COUNTIF",347:"COUNTBLANK",348:"SCENARIO.GET",349:"OPTIONS.LISTS.GET",350:"ISPMT",351:"DATEDIF",352:"DATESTRING",353:"NUMBERSTRING",354:"ROMAN",355:"OPEN.DIALOG",356:"SAVE.DIALOG",357:"VIEW.GET",358:"GETPIVOTDATA",359:"HYPERLINK",360:"PHONETIC",361:"AVERAGEA",362:"MAXA",363:"MINA",364:"STDEVPA",365:"VARPA",366:"STDEVA",367:"VARA",368:"BAHTTEXT",369:"THAIDAYOFWEEK",370:"THAIDIGIT",371:"THAIMONTHOFYEAR",372:"THAINUMSOUND",373:"THAINUMSTRING",374:"THAISTRINGLENGTH",375:"ISTHAIDIGIT",376:"ROUNDBAHTDOWN",377:"ROUNDBAHTUP",378:"THAIYEAR",379:"RTD",380:"CUBEVALUE",381:"CUBEMEMBER",382:"CUBEMEMBERPROPERTY",383:"CUBERANKEDMEMBER",384:"HEX2BIN",385:"HEX2DEC",386:"HEX2OCT",387:"DEC2BIN",388:"DEC2HEX",389:"DEC2OCT",390:"OCT2BIN",391:"OCT2HEX",392:"OCT2DEC",393:"BIN2DEC",394:"BIN2OCT",395:"BIN2HEX",396:"IMSUB",397:"IMDIV",398:"IMPOWER",399:"IMABS",400:"IMSQRT",401:"IMLN",402:"IMLOG2",403:"IMLOG10",404:"IMSIN",405:"IMCOS",406:"IMEXP",407:"IMARGUMENT",408:"IMCONJUGATE",409:"IMAGINARY",410:"IMREAL",411:"COMPLEX",412:"IMSUM",413:"IMPRODUCT",414:"SERIESSUM",415:"FACTDOUBLE",416:"SQRTPI",417:"QUOTIENT",418:"DELTA",419:"GESTEP",420:"ISEVEN",421:"ISODD",422:"MROUND",423:"ERF",424:"ERFC",425:"BESSELJ",426:"BESSELK",427:"BESSELY",428:"BESSELI",429:"XIRR",430:"XNPV",431:"PRICEMAT",432:"YIELDMAT",433:"INTRATE",434:"RECEIVED",435:"DISC",436:"PRICEDISC",437:"YIELDDISC",438:"TBILLEQ",439:"TBILLPRICE",440:"TBILLYIELD",441:"PRICE",442:"YIELD",443:"DOLLARDE",444:"DOLLARFR",445:"NOMINAL",446:"EFFECT",447:"CUMPRINC",448:"CUMIPMT",449:"EDATE",450:"EOMONTH",451:"YEARFRAC",452:"COUPDAYBS",453:"COUPDAYS",454:"COUPDAYSNC",455:"COUPNCD",456:"COUPNUM",457:"COUPPCD",458:"DURATION",459:"MDURATION",460:"ODDLPRICE",461:"ODDLYIELD",462:"ODDFPRICE",463:"ODDFYIELD",464:"RANDBETWEEN",465:"WEEKNUM",466:"AMORDEGRC",467:"AMORLINC",468:"CONVERT",724:"SHEETJS",469:"ACCRINT",470:"ACCRINTM",471:"WORKDAY",472:"NETWORKDAYS",473:"GCD",474:"MULTINOMIAL",475:"LCM",476:"FVSCHEDULE",477:"CUBEKPIMEMBER",478:"CUBESET",479:"CUBESETCOUNT",480:"IFERROR",481:"COUNTIFS",482:"SUMIFS",483:"AVERAGEIF",484:"AVERAGEIFS"};var nh={2:1,3:1,10:0,15:1,16:1,17:1,18:1,19:0,20:1,21:1,22:1,23:1,24:1,25:1,26:1,27:2,30:2,31:3,32:1,33:1,34:0,35:0,38:1,39:2,40:3,41:3,42:3,43:3,44:3,45:3,47:3,48:2,53:1,61:3,63:0,65:3,66:3,67:1,68:1,69:1,70:1,71:1,72:1,73:1,74:0,75:1,76:1,77:1,79:2,80:2,83:1,85:0,86:1,89:0,90:1,94:0,95:0,97:2,98:1,99:1,101:3,102:3,105:1,106:1,108:2,111:1,112:1,113:1,114:1,117:2,118:1,119:4,121:1,126:1,127:1,128:1,129:1,130:1,131:1,133:1,134:1,135:1,136:2,137:2,138:2,140:1,141:1,142:3,143:4,144:4,161:1,162:1,163:1,164:1,165:2,172:1,175:2,176:2,177:3,178:2,179:1,184:1,186:1,189:3,190:1,195:3,196:3,197:1,198:1,199:3,201:1,207:4,210:3,211:1,212:2,213:2,214:1,215:1,225:0,229:1,230:1,231:1,232:1,233:1,234:1,235:3,244:1,247:4,252:2,257:1,261:1,271:1,273:4,274:2,275:2,276:2,277:3,278:3,279:1,280:3,281:3,282:3,283:1,284:1,285:2,286:4,287:3,288:2,289:4,290:3,291:3,292:3,293:4,294:1,295:3,296:1,297:3,298:1,299:2,300:3,301:3,302:4,303:2,304:2,305:2,306:2,307:2,308:2,309:3,310:2,311:2,312:2,313:2,314:2,315:2,316:4,325:2,326:2,327:2,328:2,331:2,332:2,337:2,342:1,343:1,346:2,347:1,350:4,351:3,352:1,353:2,360:1,368:1,369:1,370:1,371:1,372:1,373:1,374:1,375:1,376:1,377:1,378:1,382:3,385:1,392:1,393:1,396:2,397:2,398:2,399:1,400:1,401:1,402:1,403:1,404:1,405:1,406:1,407:1,408:1,409:1,410:1,414:4,415:1,416:1,417:2,420:1,421:1,422:2,424:1,425:2,426:2,427:2,428:2,430:3,438:3,439:3,440:3,443:2,444:2,445:2,446:2,447:6,448:6,449:2,450:2,464:2,468:3,476:2,479:1,480:2,65535:0};var ih={"_xlfn.ACOT":"ACOT","_xlfn.ACOTH":"ACOTH","_xlfn.AGGREGATE":"AGGREGATE","_xlfn.ARABIC":"ARABIC","_xlfn.AVERAGEIF":"AVERAGEIF","_xlfn.AVERAGEIFS":"AVERAGEIFS","_xlfn.BASE":"BASE","_xlfn.BETA.DIST":"BETA.DIST","_xlfn.BETA.INV":"BETA.INV","_xlfn.BINOM.DIST":"BINOM.DIST","_xlfn.BINOM.DIST.RANGE":"BINOM.DIST.RANGE","_xlfn.BINOM.INV":"BINOM.INV","_xlfn.BITAND":"BITAND","_xlfn.BITLSHIFT":"BITLSHIFT","_xlfn.BITOR":"BITOR","_xlfn.BITRSHIFT":"BITRSHIFT","_xlfn.BITXOR":"BITXOR","_xlfn.CEILING.MATH":"CEILING.MATH","_xlfn.CEILING.PRECISE":"CEILING.PRECISE","_xlfn.CHISQ.DIST":"CHISQ.DIST","_xlfn.CHISQ.DIST.RT":"CHISQ.DIST.RT","_xlfn.CHISQ.INV":"CHISQ.INV","_xlfn.CHISQ.INV.RT":"CHISQ.INV.RT","_xlfn.CHISQ.TEST":"CHISQ.TEST","_xlfn.COMBINA":"COMBINA","_xlfn.CONCAT":"CONCAT","_xlfn.CONFIDENCE.NORM":"CONFIDENCE.NORM","_xlfn.CONFIDENCE.T":"CONFIDENCE.T","_xlfn.COT":"COT","_xlfn.COTH":"COTH","_xlfn.COUNTIFS":"COUNTIFS","_xlfn.COVARIANCE.P":"COVARIANCE.P","_xlfn.COVARIANCE.S":"COVARIANCE.S","_xlfn.CSC":"CSC","_xlfn.CSCH":"CSCH","_xlfn.DAYS":"DAYS","_xlfn.DECIMAL":"DECIMAL","_xlfn.ECMA.CEILING":"ECMA.CEILING","_xlfn.ERF.PRECISE":"ERF.PRECISE","_xlfn.ERFC.PRECISE":"ERFC.PRECISE","_xlfn.EXPON.DIST":"EXPON.DIST","_xlfn.F.DIST":"F.DIST","_xlfn.F.DIST.RT":"F.DIST.RT","_xlfn.F.INV":"F.INV","_xlfn.F.INV.RT":"F.INV.RT","_xlfn.F.TEST":"F.TEST","_xlfn.FILTERXML":"FILTERXML","_xlfn.FLOOR.MATH":"FLOOR.MATH","_xlfn.FLOOR.PRECISE":"FLOOR.PRECISE","_xlfn.FORECAST.ETS":"FORECAST.ETS","_xlfn.FORECAST.ETS.CONFINT":"FORECAST.ETS.CONFINT","_xlfn.FORECAST.ETS.SEASONALITY":"FORECAST.ETS.SEASONALITY","_xlfn.FORECAST.ETS.STAT":"FORECAST.ETS.STAT","_xlfn.FORECAST.LINEAR":"FORECAST.LINEAR","_xlfn.FORMULATEXT":"FORMULATEXT","_xlfn.GAMMA":"GAMMA","_xlfn.GAMMA.DIST":"GAMMA.DIST","_xlfn.GAMMA.INV":"GAMMA.INV","_xlfn.GAMMALN.PRECISE":"GAMMALN.PRECISE","_xlfn.GAUSS":"GAUSS","_xlfn.HYPGEOM.DIST":"HYPGEOM.DIST","_xlfn.IFERROR":"IFERROR","_xlfn.IFNA":"IFNA","_xlfn.IFS":"IFS","_xlfn.IMCOSH":"IMCOSH","_xlfn.IMCOT":"IMCOT","_xlfn.IMCSC":"IMCSC","_xlfn.IMCSCH":"IMCSCH","_xlfn.IMSEC":"IMSEC","_xlfn.IMSECH":"IMSECH","_xlfn.IMSINH":"IMSINH","_xlfn.IMTAN":"IMTAN","_xlfn.ISFORMULA":"ISFORMULA","_xlfn.ISO.CEILING":"ISO.CEILING","_xlfn.ISOWEEKNUM":"ISOWEEKNUM","_xlfn.LOGNORM.DIST":"LOGNORM.DIST","_xlfn.LOGNORM.INV":"LOGNORM.INV","_xlfn.MAXIFS":"MAXIFS","_xlfn.MINIFS":"MINIFS","_xlfn.MODE.MULT":"MODE.MULT","_xlfn.MODE.SNGL":"MODE.SNGL","_xlfn.MUNIT":"MUNIT","_xlfn.NEGBINOM.DIST":"NEGBINOM.DIST","_xlfn.NETWORKDAYS.INTL":"NETWORKDAYS.INTL","_xlfn.NIGBINOM":"NIGBINOM","_xlfn.NORM.DIST":"NORM.DIST","_xlfn.NORM.INV":"NORM.INV","_xlfn.NORM.S.DIST":"NORM.S.DIST","_xlfn.NORM.S.INV":"NORM.S.INV","_xlfn.NUMBERVALUE":"NUMBERVALUE","_xlfn.PDURATION":"PDURATION","_xlfn.PERCENTILE.EXC":"PERCENTILE.EXC","_xlfn.PERCENTILE.INC":"PERCENTILE.INC","_xlfn.PERCENTRANK.EXC":"PERCENTRANK.EXC","_xlfn.PERCENTRANK.INC":"PERCENTRANK.INC","_xlfn.PERMUTATIONA":"PERMUTATIONA","_xlfn.PHI":"PHI","_xlfn.POISSON.DIST":"POISSON.DIST","_xlfn.QUARTILE.EXC":"QUARTILE.EXC","_xlfn.QUARTILE.INC":"QUARTILE.INC","_xlfn.QUERYSTRING":"QUERYSTRING","_xlfn.RANK.AVG":"RANK.AVG","_xlfn.RANK.EQ":"RANK.EQ","_xlfn.RRI":"RRI","_xlfn.SEC":"SEC","_xlfn.SECH":"SECH","_xlfn.SHEET":"SHEET","_xlfn.SHEETS":"SHEETS","_xlfn.SKEW.P":"SKEW.P","_xlfn.STDEV.P":"STDEV.P","_xlfn.STDEV.S":"STDEV.S","_xlfn.SUMIFS":"SUMIFS","_xlfn.SWITCH":"SWITCH","_xlfn.T.DIST":"T.DIST","_xlfn.T.DIST.2T":"T.DIST.2T","_xlfn.T.DIST.RT":"T.DIST.RT","_xlfn.T.INV":"T.INV","_xlfn.T.INV.2T":"T.INV.2T","_xlfn.T.TEST":"T.TEST","_xlfn.TEXTJOIN":"TEXTJOIN","_xlfn.UNICHAR":"UNICHAR","_xlfn.UNICODE":"UNICODE","_xlfn.VAR.P":"VAR.P","_xlfn.VAR.S":"VAR.S","_xlfn.WEBSERVICE":"WEBSERVICE","_xlfn.WEIBULL.DIST":"WEIBULL.DIST","_xlfn.WORKDAY.INTL":"WORKDAY.INTL","_xlfn.XOR":"XOR","_xlfn.Z.TEST":"Z.TEST"};function sh(e){if(e.slice(0,3)=="of:")e=e.slice(3);if(e.charCodeAt(0)==61){e=e.slice(1);if(e.charCodeAt(0)==61)e=e.slice(1)}e=e.replace(/COM\.MICROSOFT\./g,"");e=e.replace(/\[((?:\.[A-Z]+[0-9]+)(?::\.[A-Z]+[0-9]+)?)\]/g,function(e,r){return r.replace(/\./g,"")});e=e.replace(/\[.(#[A-Z]*[?!])\]/g,"$1");
return e.replace(/[;~]/g,",").replace(/\|/g,";")}function fh(e){var r="of:="+e.replace(fc,"$1[.$2$3$4$5]").replace(/\]:\[/g,":");return r.replace(/;/g,"|").replace(/,/g,";")}function lh(e){var r=e.split(":");var t=r[0].split(".")[0];return[t,r[0].split(".")[1]+(r.length>1?":"+(r[1].split(".")[1]||r[1].split(".")[0]):"")]}function oh(e){return e.replace(/\./,"!")}var ch={};var uh={};Ua.WS=["http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet","http://purl.oclc.org/ooxml/officeDocument/relationships/worksheet"];var hh=typeof Map!=="undefined";function dh(e,r,t){var a=0,n=e.length;if(t){if(hh?t.has(r):Object.prototype.hasOwnProperty.call(t,r)){var i=hh?t.get(r):t[r];for(;a<i.length;++a){if(e[i[a]].t===r){e.Count++;return i[a]}}}}else for(;a<n;++a){if(e[a].t===r){e.Count++;return a}}e[n]={t:r};e.Count++;e.Unique++;if(t){if(hh){if(!t.has(r))t.set(r,[]);t.get(r).push(n)}else{if(!Object.prototype.hasOwnProperty.call(t,r))t[r]=[];t[r].push(n)}}return n}function vh(e,r){var t={min:e+1,max:e+1};var a=-1;if(r.MDW)ml=r.MDW;if(r.width!=null)t.customWidth=1;else if(r.wpx!=null)a=El(r.wpx);else if(r.wch!=null)a=r.wch;if(a>-1){t.width=wl(a);t.customWidth=1}else if(r.width!=null)t.width=r.width;if(r.hidden)t.hidden=true;if(r.level!=null){t.outlineLevel=t.level=r.level}return t}function ph(e,r){if(!e)return;var t=[.7,.7,.75,.75,.3,.3];if(r=="xlml")t=[1,1,1,1,.5,.5];if(e.left==null)e.left=t[0];if(e.right==null)e.right=t[1];if(e.top==null)e.top=t[2];if(e.bottom==null)e.bottom=t[3];if(e.header==null)e.header=t[4];if(e.footer==null)e.footer=t[5]}function bh(e,r,t){var a=t.revssf[r.z!=null?r.z:"General"];var n=60,i=e.length;if(a==null&&t.ssf){for(;n<392;++n)if(t.ssf[n]==null){D.load(r.z,n);t.ssf[n]=r.z;t.revssf[r.z]=a=n;break}}for(n=0;n!=i;++n)if(e[n].numFmtId===a)return n;e[i]={numFmtId:a,fontId:0,fillId:0,borderId:0,xfId:0,applyNumberFormat:1};return i}function mh(e,r,t,a,n,i){try{if(a.cellNF)e.z=D._table[r]}catch(s){if(a.WTF)throw s}if(e.t==="z"&&!a.cellStyles)return;if(e.t==="d"&&typeof e.v==="string")e.v=le(e.v);if((!a||a.cellText!==false)&&e.t!=="z")try{if(D._table[r]==null)D.load(N[r]||"General",r);if(e.t==="e")e.w=e.w||ya[e.v];else if(r===0){if(e.t==="n"){if((e.v|0)===e.v)e.w=D._general_int(e.v);else e.w=D._general_num(e.v)}else if(e.t==="d"){var f=ee(e.v);if((f|0)===f)e.w=D._general_int(f);else e.w=D._general_num(f)}else if(e.v===undefined)return"";else e.w=D._general(e.v,uh)}else if(e.t==="d")e.w=D.format(r,ee(e.v),uh);else e.w=D.format(r,e.v,uh)}catch(s){if(a.WTF)throw s}if(!a.cellStyles)return;if(t!=null)try{e.s=i.Fills[t];if(e.s.fgColor&&e.s.fgColor.theme&&!e.s.fgColor.rgb){e.s.fgColor.rgb=dl(n.themeElements.clrScheme[e.s.fgColor.theme].rgb,e.s.fgColor.tint||0);if(a.WTF)e.s.fgColor.raw_rgb=n.themeElements.clrScheme[e.s.fgColor.theme].rgb}if(e.s.bgColor&&e.s.bgColor.theme){e.s.bgColor.rgb=dl(n.themeElements.clrScheme[e.s.bgColor.theme].rgb,e.s.bgColor.tint||0);if(a.WTF)e.s.bgColor.raw_rgb=n.themeElements.clrScheme[e.s.bgColor.theme].rgb}}catch(s){if(a.WTF&&i.Fills)throw s}}function gh(e,r,t){if(e&&e["!ref"]){var a=wt(e["!ref"]);if(a.e.c<a.s.c||a.e.r<a.s.r)throw new Error("Bad range ("+t+"): "+e["!ref"])}}function Eh(e,r){var t=wt(r);if(t.s.r<=t.e.r&&t.s.c<=t.e.c&&t.s.r>=0&&t.s.c>=0)e["!ref"]=Et(t)}var wh=/<(?:\w:)?mergeCell ref="[A-Z0-9:]+"\s*[\/]?>/g;var kh=/<(?:\w+:)?sheetData[^>]*>([\s\S]*)<\/(?:\w+:)?sheetData>/;var Sh=/<(?:\w:)?hyperlink [^>]*>/gm;var Bh=/"(\w*:\w*)"/;var Ch=/<(?:\w:)?col\b[^>]*[\/]?>/g;var Th=/<(?:\w:)?autoFilter[^>]*([\/]|>([\s\S]*)<\/(?:\w:)?autoFilter)>/g;var _h=/<(?:\w:)?pageMargins[^>]*\/>/g;var xh=/<(?:\w:)?sheetPr\b(?:[^>a-z][^>]*)?\/>/;var Ah=/<(?:\w:)?sheetPr[^>]*(?:[\/]|>([\s\S]*)<\/(?:\w:)?sheetPr)>/;var yh=/<(?:\w:)?sheetViews[^>]*(?:[\/]|>([\s\S]*)<\/(?:\w:)?sheetViews)>/;function Ih(e,r,t,a,n,i,s){if(!e)return e;if(!a)a={"!id":{}};if(b!=null&&r.dense==null)r.dense=b;var f=r.dense?[]:{};var l={s:{r:2e6,c:2e6},e:{r:0,c:0}};var o="",c="";var u=e.match(kh);if(u){o=e.slice(0,u.index);c=e.slice(u.index+u[0].length)}else o=c=e;var h=o.match(xh);if(h)Fh(h[0],f,n,t);else if(h=o.match(Ah))Dh(h[0],h[1]||"",f,n,t,s,i);var d=(o.match(/<(?:\w*:)?dimension/)||{index:-1}).index;if(d>0){var v=o.slice(d,d+50).match(Bh);if(v)Eh(f,v[1])}var p=o.match(yh);if(p&&p[1])jh(p[1],n);var m=[];if(r.cellStyles){var g=o.match(Ch);if(g)Wh(m,g)}if(u)Yh(u[1],f,r,l,i,s);var E=c.match(Th);if(E)f["!autofilter"]=Xh(E[0]);var w=[];var k=c.match(wh);if(k)for(d=0;d!=k.length;++d)w[d]=wt(k[d].slice(k[d].indexOf('"')+1));var S=c.match(Sh);if(S)Lh(f,S,a);var B=c.match(_h);if(B)f["!margins"]=Uh(Oe(B[0]));if(!f["!ref"]&&l.e.c>=l.s.c&&l.e.r>=l.s.r)f["!ref"]=Et(l);if(r.sheetRows>0&&f["!ref"]){var C=wt(f["!ref"]);if(r.sheetRows<=+C.e.r){C.e.r=r.sheetRows-1;if(C.e.r>l.e.r)C.e.r=l.e.r;if(C.e.r<C.s.r)C.s.r=C.e.r;if(C.e.c>l.e.c)C.e.c=l.e.c;if(C.e.c<C.s.c)C.s.c=C.e.c;f["!fullref"]=f["!ref"];f["!ref"]=Et(C)}}if(m.length>0)f["!cols"]=m;if(w.length>0)f["!merges"]=w;return f}function Rh(e){if(e.length===0)return"";var r='<mergeCells count="'+e.length+'">';for(var t=0;t!=e.length;++t)r+='<mergeCell ref="'+Et(e[t])+'"/>';return r+"</mergeCells>"}function Fh(e,r,t,a){var n=Oe(e);if(!t.Sheets[a])t.Sheets[a]={};if(n.codeName)t.Sheets[a].CodeName=Le(Ye(n.codeName))}function Dh(e,r,t,a,n,i,s){Fh(e.slice(0,e.indexOf(">")),t,a,n)}function Oh(e,r,t,a,n){var i=false;var s={},f=null;if(a.bookType!=="xlsx"&&r.vbaraw){var l=r.SheetNames[t];try{if(r.Workbook)l=r.Workbook.Sheets[t].CodeName||l}catch(o){}i=true;s.codeName=Qe(We(l))}if(e&&e["!outline"]){var c={summaryBelow:1,summaryRight:1};if(e["!outline"].above)c.summaryBelow=0;if(e["!outline"].left)c.summaryRight=0;f=(f||"")+or("outlinePr",null,c)}if(!i&&!f)return;n[n.length]=or("sheetPr",f,s)}var Ph=["objects","scenarios","selectLockedCells","selectUnlockedCells"];var Nh=["formatColumns","formatRows","formatCells","insertColumns","insertRows","insertHyperlinks","deleteColumns","deleteRows","sort","autoFilter","pivotTables"];function Mh(e){var r={sheet:1};Ph.forEach(function(t){if(e[t]!=null&&e[t])r[t]="1"});Nh.forEach(function(t){if(e[t]!=null&&!e[t])r[t]="0"});if(e.password)r.password=rl(e.password).toString(16).toUpperCase();return or("sheetProtection",null,r)}function Lh(e,r,t){var a=Array.isArray(e);for(var n=0;n!=r.length;++n){var i=Oe(Ye(r[n]),true);if(!i.ref)return;var s=((t||{})["!id"]||[])[i.id];if(s){i.Target=s.Target;if(i.location)i.Target+="#"+Le(i.location)}else{i.Target="#"+Le(i.location);s={Target:i.Target,TargetMode:"Internal"}}i.Rel=s;if(i.tooltip){i.Tooltip=i.tooltip;delete i.tooltip}var f=wt(i.ref);for(var l=f.s.r;l<=f.e.r;++l)for(var o=f.s.c;o<=f.e.c;++o){var c=mt({c:o,r:l});if(a){if(!e[l])e[l]=[];if(!e[l][o])e[l][o]={t:"z",v:undefined};e[l][o].l=i}else{if(!e[c])e[c]={t:"z",v:undefined};e[c].l=i}}}}function Uh(e){var r={};["left","right","top","bottom","header","footer"].forEach(function(t){if(e[t])r[t]=parseFloat(e[t])});return r}function Hh(e){ph(e);return or("pageMargins",null,e)}function Wh(e,r){var t=false;for(var a=0;a!=r.length;++a){var n=Oe(r[a],true);if(n.hidden)n.hidden=Ke(n.hidden);var i=parseInt(n.min,10)-1,s=parseInt(n.max,10)-1;if(n.outlineLevel)n.level=+n.outlineLevel||0;delete n.min;delete n.max;n.width=+n.width;if(!t&&n.width){t=true;Sl(n.width)}Bl(n);while(i<=s)e[i++]=ce(n)}}function Vh(e,r){var t=["<cols>"],a;for(var n=0;n!=r.length;++n){if(!(a=r[n]))continue;t[t.length]=or("col",null,vh(n,a))}t[t.length]="</cols>";return t.join("")}function Xh(e){var r={ref:(e.match(/ref="([^"]*)"/)||[])[1]};return r}function Gh(e,r,t,a){var n=typeof e.ref=="string"?e.ref:Et(e.ref);if(!t.Workbook)t.Workbook={Sheets:[]};if(!t.Workbook.Names)t.Workbook.Names=[];var i=t.Workbook.Names;var s=gt(n);if(s.s.r==s.e.r){s.e.r=gt(r["!ref"]).e.r;n=Et(s)}for(var f=0;f<i.length;++f){var l=i[f];if(l.Name!="_xlnm._FilterDatabase")continue;if(l.Sheet!=a)continue;l.Ref="'"+t.SheetNames[a]+"'!"+n;break}if(f==i.length)i.push({Name:"_xlnm._FilterDatabase",Sheet:a,Ref:"'"+t.SheetNames[a]+"'!"+n});return or("autoFilter",null,{ref:n})}var zh=/<(?:\w:)?sheetView(?:[^>a-z][^>]*)?\/?>/;function jh(e,r){if(!r.Views)r.Views=[{}];(e.match(zh)||[]).forEach(function(e,t){var a=Oe(e);if(!r.Views[t])r.Views[t]={};if(+a.zoomScale)r.Views[t].zoom=+a.zoomScale;if(Ke(a.rightToLeft))r.Views[t].RTL=true})}function $h(e,r,t,a){var n={workbookViewId:"0"};if((((a||{}).Workbook||{}).Views||[])[0])n.rightToLeft=a.Workbook.Views[0].RTL?"1":"0";return or("sheetViews",or("sheetView",null,n),{})}function Kh(e,r,t,a){if(e.v===undefined&&typeof e.f!=="string"||e.t==="z")return"";var n="";var i=e.t,s=e.v;if(e.t!=="z")switch(e.t){case"b":n=e.v?"1":"0";break;case"n":n=""+e.v;break;case"e":n=ya[e.v];break;case"d":if(a&&a.cellDates)n=le(e.v,-1).toISOString();else{e=ce(e);e.t="n";n=""+(e.v=ee(le(e.v)))}if(typeof e.z==="undefined")e.z=D._table[14];break;default:n=e.v;break;}var f=fr("v",We(n)),l={r:r};var o=bh(a.cellXfs,e,a);if(o!==0)l.s=o;switch(e.t){case"n":break;case"d":l.t="d";break;case"b":l.t="b";break;case"e":l.t="e";break;case"z":break;default:if(e.v==null){delete e.t;break}if(e.v.length>32767)throw new Error("Text length must not exceed 32767 characters");if(a&&a.bookSST){f=fr("v",""+dh(a.Strings,e.v,a.revStrings));l.t="s";break}l.t="str";break;}if(e.t!=i){e.t=i;e.v=s}if(typeof e.f=="string"&&e.f){var c=e.F&&e.F.slice(0,r.length)==r?{t:"array",ref:e.F}:null;f=or("f",We(e.f),c)+(e.v!=null?f:"")}if(e.l)t["!links"].push([r,e.l]);if(e.c)t["!comments"].push([r,e.c]);return or("c",f,l)}var Yh=function(){var e=/<(?:\w+:)?c[ \/>]/,r=/<\/(?:\w+:)?row>/;var t=/r=["']([^"']*)["']/,a=/<(?:\w+:)?is>([\S\s]*?)<\/(?:\w+:)?is>/;var n=/ref=["']([^"']*)["']/;var i=er("v"),s=er("f");return function f(l,o,c,u,h,d){var v=0,p="",b=[],m=[],g=0,E=0,w=0,k="",S;var B,C=0,T=0;var _,x;var A=0,y=0;var I=Array.isArray(d.CellXf),R;var F=[];var O=[];var P=Array.isArray(o);var N=[],M={},L=false;var U=!!c.sheetStubs;for(var H=l.split(r),W=0,V=H.length;W!=V;++W){p=H[W].trim();var X=p.length;if(X===0)continue;var G=0;e:for(v=0;v<X;++v)switch(p[v]){case">":if(p[v-1]!="/"){++v;break e}if(c&&c.cellStyles){B=Oe(p.slice(G,v),true);C=B.r!=null?parseInt(B.r,10):C+1;T=-1;if(c.sheetRows&&c.sheetRows<C)continue;M={};L=false;if(B.ht){L=true;M.hpt=parseFloat(B.ht);M.hpx=xl(M.hpt)}if(B.hidden=="1"){L=true;M.hidden=true}if(B.outlineLevel!=null){L=true;M.level=+B.outlineLevel}if(L)N[C-1]=M}break;case"<":G=v;break;}if(G>=v)break;B=Oe(p.slice(G,v),true);C=B.r!=null?parseInt(B.r,10):C+1;T=-1;if(c.sheetRows&&c.sheetRows<C)continue;if(u.s.r>C-1)u.s.r=C-1;if(u.e.r<C-1)u.e.r=C-1;if(c&&c.cellStyles){M={};L=false;if(B.ht){L=true;M.hpt=parseFloat(B.ht);M.hpx=xl(M.hpt)}if(B.hidden=="1"){L=true;M.hidden=true}if(B.outlineLevel!=null){L=true;M.level=+B.outlineLevel}if(L)N[C-1]=M}b=p.slice(v).split(e);for(var z=0;z!=b.length;++z)if(b[z].trim().charAt(0)!="<")break;b=b.slice(z);for(v=0;v!=b.length;++v){p=b[v].trim();if(p.length===0)continue;m=p.match(t);g=v;E=0;w=0;p="<c "+(p.slice(0,1)=="<"?">":"")+p;if(m!=null&&m.length===2){g=0;k=m[1];for(E=0;E!=k.length;++E){if((w=k.charCodeAt(E)-64)<1||w>26)break;g=26*g+w}--g;T=g}else++T;for(E=0;E!=p.length;++E)if(p.charCodeAt(E)===62)break;++E;B=Oe(p.slice(0,E),true);if(!B.r)B.r=mt({r:C-1,c:T});k=p.slice(E);S={t:""};if((m=k.match(i))!=null&&m[1]!=="")S.v=Le(m[1]);if(c.cellFormula){if((m=k.match(s))!=null&&m[1]!==""){S.f=Le(Ye(m[1])).replace(/\r\n/g,"\n");if(!c.xlfn)S.f=hc(S.f);if(m[0].indexOf('t="array"')>-1){S.F=(k.match(n)||[])[1];if(S.F.indexOf(":")>-1)F.push([wt(S.F),S.F])}else if(m[0].indexOf('t="shared"')>-1){x=Oe(m[0]);var j=Le(Ye(m[1]));if(!c.xlfn)j=hc(j);O[parseInt(x.si,10)]=[x,j,B.r]}}else if(m=k.match(/<f[^>]*\/>/)){x=Oe(m[0]);if(O[x.si])S.f=cc(O[x.si][1],O[x.si][2],B.r)}var $=bt(B.r);for(E=0;E<F.length;++E)if($.r>=F[E][0].s.r&&$.r<=F[E][0].e.r)if($.c>=F[E][0].s.c&&$.c<=F[E][0].e.c)S.F=F[E][1]}if(B.t==null&&S.v===undefined){if(S.f||S.F){S.v=0;S.t="n"}else if(!U)continue;else S.t="z"}else S.t=B.t||"n";if(u.s.c>T)u.s.c=T;if(u.e.c<T)u.e.c=T;switch(S.t){case"n":if(S.v==""||S.v==null){if(!U)continue;S.t="z"}else S.v=parseFloat(S.v);break;case"s":if(typeof S.v=="undefined"){if(!U)continue;S.t="z"}else{_=ch[parseInt(S.v,10)];S.v=_.t;S.r=_.r;if(c.cellHTML)S.h=_.h}break;case"str":S.t="s";S.v=S.v!=null?Ye(S.v):"";if(c.cellHTML)S.h=Ge(S.v);break;case"inlineStr":m=k.match(a);S.t="s";if(m!=null&&(_=xf(m[1]))){S.v=_.t;if(c.cellHTML)S.h=_.h}else S.v="";break;case"b":S.v=Ke(S.v);break;case"d":if(c.cellDates)S.v=le(S.v,1);else{S.v=ee(le(S.v,1));S.t="n"}break;case"e":if(!c||c.cellText!==false)S.w=S.v;S.v=Ia[S.v];break;}A=y=0;R=null;if(I&&B.s!==undefined){R=d.CellXf[B.s];if(R!=null){if(R.numFmtId!=null)A=R.numFmtId;if(c.cellStyles){if(R.fillId!=null)y=R.fillId}}}mh(S,A,y,c,h,d);if(c.cellDates&&I&&S.t=="n"&&D.is_date(D._table[A])){S.t="d";S.v=ne(S.v)}if(P){var K=bt(B.r);if(!o[K.r])o[K.r]=[];o[K.r][K.c]=S}else o[B.r]=S}}if(N.length>0)o["!rows"]=N}}();function Qh(e,r,t,a){var n=[],i=[],s=wt(e["!ref"]),f="",l,o="",c=[],u=0,h=0,d=e["!rows"];var v=Array.isArray(e);var p={r:o},b,m=-1;for(h=s.s.c;h<=s.e.c;++h)c[h]=ht(h);for(u=s.s.r;u<=s.e.r;++u){i=[];o=lt(u);for(h=s.s.c;h<=s.e.c;++h){l=c[h]+o;var g=v?(e[u]||[])[h]:e[l];if(g===undefined)continue;if((f=Kh(g,l,e,r,t,a))!=null)i.push(f)}if(i.length>0||d&&d[u]){p={r:o};if(d&&d[u]){b=d[u];if(b.hidden)p.hidden=1;m=-1;if(b.hpx)m=_l(b.hpx);else if(b.hpt)m=b.hpt;if(m>-1){p.ht=m;p.customHeight=1}if(b.level){p.outlineLevel=b.level}}n[n.length]=or("row",i.join(""),p)}}if(d)for(;u<d.length;++u){if(d&&d[u]){p={r:u+1};b=d[u];if(b.hidden)p.hidden=1;m=-1;if(b.hpx)m=_l(b.hpx);else if(b.hpt)m=b.hpt;if(m>-1){p.ht=m;p.customHeight=1}if(b.level){p.outlineLevel=b.level}n[n.length]=or("row","",p)}}return n.join("")}var Jh=or("worksheet",null,{xmlns:hr.main[0],"xmlns:r":hr.r});function Zh(e,r,t,a){var n=[ye,Jh];var i=t.SheetNames[e],s=0,f="";var l=t.Sheets[i];if(l==null)l={};var o=l["!ref"]||"A1";var c=wt(o);if(c.e.c>16383||c.e.r>1048575){if(r.WTF)throw new Error("Range "+o+" exceeds format limit A1:XFD1048576");c.e.c=Math.min(c.e.c,16383);c.e.r=Math.min(c.e.c,1048575);o=Et(c)}if(!a)a={};l["!comments"]=[];var u=[];Oh(l,t,e,r,n);n[n.length]=or("dimension",null,{ref:o});n[n.length]=$h(l,r,e,t);if(r.sheetFormat)n[n.length]=or("sheetFormatPr",null,{defaultRowHeight:r.sheetFormat.defaultRowHeight||"16",baseColWidth:r.sheetFormat.baseColWidth||"10",outlineLevelRow:r.sheetFormat.outlineLevelRow||"7"});if(l["!cols"]!=null&&l["!cols"].length>0)n[n.length]=Vh(l,l["!cols"]);n[s=n.length]="<sheetData/>";l["!links"]=[];if(l["!ref"]!=null){f=Qh(l,r,e,t,a);if(f.length>0)n[n.length]=f}if(n.length>s+1){n[n.length]="</sheetData>";n[s]=n[s].replace("/>",">")}if(l["!protect"])n[n.length]=Mh(l["!protect"]);if(l["!autofilter"]!=null)n[n.length]=Gh(l["!autofilter"],l,t,e);if(l["!merges"]!=null&&l["!merges"].length>0)n[n.length]=Rh(l["!merges"]);var h=-1,d,v=-1;if(l["!links"].length>0){n[n.length]="<hyperlinks>";l["!links"].forEach(function(e){if(!e[1].Target)return;d={ref:e[0]};if(e[1].Target.charAt(0)!="#"){v=za(a,-1,We(e[1].Target).replace(/#.*$/,""),Ua.HLINK);d["r:id"]="rId"+v}if((h=e[1].Target.indexOf("#"))>-1)d.location=We(e[1].Target.slice(h+1));if(e[1].Tooltip)d.tooltip=We(e[1].Tooltip);n[n.length]=or("hyperlink",null,d)});n[n.length]="</hyperlinks>"}delete l["!links"];if(l["!margins"]!=null)n[n.length]=Hh(l["!margins"]);if(!r||r.ignoreEC||r.ignoreEC==void 0)n[n.length]=fr("ignoredErrors",or("ignoredError",null,{numberStoredAsText:1,sqref:o}));if(u.length>0){v=za(a,-1,"../drawings/drawing"+(e+1)+".xml",Ua.DRAW);n[n.length]=or("drawing",null,{"r:id":"rId"+v});l["!drawing"]=u}if(l["!comments"].length>0){v=za(a,-1,"../drawings/vmlDrawing"+(e+1)+".vml",Ua.VML);n[n.length]=or("legacyDrawing",null,{"r:id":"rId"+v});l["!legacy"]=v}if(n.length>1){n[n.length]="</worksheet>";n[1]=n[1].replace("/>",">")}return n.join("")}function qh(e,r){var t={};var a=e.l+r;t.r=e._R(4);e.l+=4;var n=e._R(2);e.l+=1;var i=e._R(1);e.l=a;if(i&7)t.level=i&7;if(i&16)t.hidden=true;if(i&32)t.hpt=n/20;return t}function ed(e,r,t){var a=Jr(17+8*16);var n=(t["!rows"]||[])[e]||{};a._W(4,e);a._W(4,0);var i=320;if(n.hpx)i=_l(n.hpx)*20;else if(n.hpt)i=n.hpt*20;a._W(2,i);a._W(1,0);var s=0;if(n.level)s|=n.level;if(n.hidden)s|=16;if(n.hpx||n.hpt)s|=32;a._W(1,s);a._W(1,0);var f=0,l=a.l;a.l+=4;var o={r:e,c:0};for(var c=0;c<16;++c){if(r.s.c>c+1<<10||r.e.c<c<<10)continue;var u=-1,h=-1;for(var d=c<<10;d<c+1<<10;++d){o.c=d;var v=Array.isArray(t)?(t[o.r]||[])[o.c]:t[mt(o)];if(v){if(u<0)u=d;h=d}}if(u<0)continue;++f;a._W(4,u);a._W(4,h)}var p=a.l;a.l=l;a._W(4,f);a.l=p;return a.length>a.l?a.slice(0,a.l):a}function rd(e,r,t,a){var n=ed(a,t,r);if(n.length>17||(r["!rows"]||[])[a])et(e,"BrtRowHdr",n)}var td=Qt;var ad=Jt;function nd(){}function id(e,r){var t={};var a=e[e.l];++e.l;t.above=!(a&64);t.left=!(a&128);e.l+=18;t.name=Ut(e,r-19);return t}function sd(e,r,t){if(t==null)t=Jr(84+4*e.length);var a=192;if(r){if(r.above)a&=~64;if(r.left)a&=~128}t._W(1,a);for(var n=1;n<3;++n)t._W(1,0);ra({auto:1},t);t._W(-4,-1);t._W(-4,-1);Ht(e,t);return t.slice(0,t.l)}function fd(e){var r=Pt(e);return[r]}function ld(e,r,t){if(t==null)t=Jr(8);return Nt(r,t)}function od(e){var r=Mt(e);return[r]}function cd(e,r,t){if(t==null)t=Jr(4);return Lt(r,t)}function ud(e){var r=Pt(e);var t=e._R(1);return[r,t,"b"]}function hd(e,r,t){if(t==null)t=Jr(9);Nt(r,t);t._W(1,e.v?1:0);return t}function dd(e){var r=Mt(e);var t=e._R(1);return[r,t,"b"]}function vd(e,r,t){if(t==null)t=Jr(5);Lt(r,t);t._W(1,e.v?1:0);return t}function pd(e){var r=Pt(e);var t=e._R(1);return[r,t,"e"]}function bd(e,r,t){if(t==null)t=Jr(9);Nt(r,t);t._W(1,e.v);return t}function md(e){var r=Mt(e);var t=e._R(1);return[r,t,"e"]}function gd(e,r,t){if(t==null)t=Jr(8);Lt(r,t);t._W(1,e.v);t._W(2,0);t._W(1,0);return t}function Ed(e){var r=Pt(e);var t=e._R(4);return[r,t,"s"]}function wd(e,r,t){if(t==null)t=Jr(12);Nt(r,t);t._W(4,r.v);return t}function kd(e){var r=Mt(e);var t=e._R(4);return[r,t,"s"]}function Sd(e,r,t){if(t==null)t=Jr(8);Lt(r,t);t._W(4,r.v);return t}function Bd(e){var r=Pt(e);var t=Zt(e);return[r,t,"n"]}function Cd(e,r,t){if(t==null)t=Jr(16);Nt(r,t);qt(e.v,t);return t}function Td(e){var r=Mt(e);var t=Zt(e);return[r,t,"n"]}function _d(e,r,t){if(t==null)t=Jr(12);Lt(r,t);qt(e.v,t);return t}function xd(e){var r=Pt(e);var t=jt(e);return[r,t,"n"]}function Ad(e,r,t){if(t==null)t=Jr(12);Nt(r,t);$t(e.v,t);return t}function yd(e){var r=Mt(e);var t=jt(e);return[r,t,"n"]}function Id(e,r,t){if(t==null)t=Jr(8);Lt(r,t);$t(e.v,t);return t}function Rd(e){var r=Pt(e);var t=xt(e);return[r,t,"str"]}function Fd(e,r,t){if(t==null)t=Jr(12+4*e.v.length);Nt(r,t);At(e.v,t);return t.length>t.l?t.slice(0,t.l):t}function Dd(e){var r=Mt(e);var t=xt(e);return[r,t,"str"]}function Od(e,r,t){if(t==null)t=Jr(8+4*e.v.length);Lt(r,t);At(e.v,t);return t.length>t.l?t.slice(0,t.l):t}function Pd(e,r,t){var a=e.l+r;var n=Pt(e);n.r=t["!row"];var i=e._R(1);var s=[n,i,"b"];if(t.cellFormula){e.l+=2;var f=qu(e,a-e.l,t);s[3]=Vu(f,null,n,t.supbooks,t)}else e.l=a;return s}function Nd(e,r,t){var a=e.l+r;var n=Pt(e);n.r=t["!row"];var i=e._R(1);var s=[n,i,"e"];if(t.cellFormula){e.l+=2;var f=qu(e,a-e.l,t);s[3]=Vu(f,null,n,t.supbooks,t)}else e.l=a;return s}function Md(e,r,t){var a=e.l+r;var n=Pt(e);n.r=t["!row"];var i=Zt(e);var s=[n,i,"n"];if(t.cellFormula){e.l+=2;var f=qu(e,a-e.l,t);s[3]=Vu(f,null,n,t.supbooks,t)}else e.l=a;return s}function Ld(e,r,t){var a=e.l+r;var n=Pt(e);n.r=t["!row"];var i=xt(e);var s=[n,i,"str"];if(t.cellFormula){e.l+=2;var f=qu(e,a-e.l,t);s[3]=Vu(f,null,n,t.supbooks,t)}else e.l=a;return s}var Ud=Qt;var Hd=Jt;function Wd(e,r){if(r==null)r=Jr(4);r._W(4,e);return r}function Vd(e,r){var t=e.l+r;var a=Qt(e,16);var n=Wt(e);var i=xt(e);var s=xt(e);var f=xt(e);e.l=t;var l={rfx:a,relId:n,loc:i,display:f};if(s)l.Tooltip=s;return l}function Xd(e,r){var t=Jr(50+4*(e[1].Target.length+(e[1].Tooltip||"").length));Jt({s:bt(e[0]),e:bt(e[0])},t);zt("rId"+r,t);var a=e[1].Target.indexOf("#");var n=a==-1?"":e[1].Target.slice(a+1);At(n||"",t);At(e[1].Tooltip||"",t);At("",t);return t.slice(0,t.l)}function Gd(){}function zd(e,r,t){var a=e.l+r;var n=Kt(e,16);var i=e._R(1);var s=[n];s[2]=i;if(t.cellFormula){var f=Zu(e,a-e.l,t);s[1]=f}else e.l=a;return s}function jd(e,r,t){var a=e.l+r;var n=Qt(e,16);var i=[n];if(t.cellFormula){var s=rh(e,a-e.l,t);i[1]=s;e.l=a}else e.l=a;return i}function $d(e,r,t){if(t==null)t=Jr(18);var a=vh(e,r);t._W(-4,e);t._W(-4,e);t._W(4,(a.width||10)*256);t._W(4,0);var n=0;if(r.hidden)n|=1;if(typeof a.width=="number")n|=2;if(r.level)n|=r.level<<8;t._W(2,n);return t}var Kd=["left","right","top","bottom","header","footer"];function Yd(e){var r={};Kd.forEach(function(t){r[t]=Zt(e,8)});return r}function Qd(e,r){if(r==null)r=Jr(6*8);ph(e);Kd.forEach(function(t){qt(e[t],r)});return r}function Jd(e){var r=e._R(2);e.l+=28;return{RTL:r&32}}function Zd(e,r,t){if(t==null)t=Jr(30);var a=924;if((((r||{}).Views||[])[0]||{}).RTL)a|=32;t._W(2,a);t._W(4,0);t._W(4,0);t._W(4,0);t._W(1,0);t._W(1,0);t._W(2,0);t._W(2,100);t._W(2,0);t._W(2,0);t._W(2,0);t._W(4,0);return t}function qd(e){var r=Jr(24);r._W(4,4);r._W(4,1);Jt(e,r);return r}function ev(e,r){if(r==null)r=Jr(16*4+2);r._W(2,e.password?rl(e.password):0);r._W(4,1);[["objects",false],["scenarios",false],["formatCells",true],["formatColumns",true],["formatRows",true],["insertColumns",true],["insertRows",true],["insertHyperlinks",true],["deleteColumns",true],["deleteRows",true],["selectLockedCells",false],["sort",true],["autoFilter",true],["pivotTables",true],["selectUnlockedCells",false]].forEach(function(t){if(t[1])r._W(4,e[t[0]]!=null&&!e[t[0]]?1:0);else r._W(4,e[t[0]]!=null&&e[t[0]]?0:1)});return r}function rv(){}function tv(){}function av(e,r,t,a,n,i,s){if(!e)return e;var f=r||{};if(!a)a={"!id":{}};if(b!=null&&f.dense==null)f.dense=b;var l=f.dense?[]:{};var o;var c={s:{r:2e6,c:2e6},e:{r:0,c:0}};var u=[];var h=false,d=false;var v,p,m,g,E,w,k,S,B;var C=[];f.biff=12;f["!row"]=0;var T=0,_=false;var x=[];var A={};var y=f.supbooks||n.supbooks||[[]];y.sharedf=A;y.arrayf=x;y.SheetNames=n.SheetNames||n.Sheets.map(function(e){return e.name});if(!f.supbooks){f.supbooks=y;if(n.Names)for(var I=0;I<n.Names.length;++I)y[0][I+1]=n.Names[I]}var R=[],F=[];var O=false;Zp[16]={n:"BrtShortReal",f:Td};Zr(e,function N(e,r,b){if(d)return;switch(b){case 148:o=e;break;case 0:v=e;if(f.sheetRows&&f.sheetRows<=v.r)d=true;S=lt(g=v.r);f["!row"]=v.r;if(e.hidden||e.hpt||e.level!=null){if(e.hpt)e.hpx=xl(e.hpt);F[e.r]=e}break;case 2:;case 3:;case 4:;case 5:;case 6:;case 7:;case 8:;case 9:;case 10:;case 11:;case 13:;case 14:;case 15:;case 16:;case 17:;case 18:p={t:e[2]};switch(e[2]){case"n":p.v=e[1];break;case"s":k=ch[e[1]];p.v=k.t;p.r=k.r;break;case"b":p.v=e[1]?true:false;break;case"e":p.v=e[1];if(f.cellText!==false)p.w=ya[p.v];break;case"str":p.t="s";p.v=e[1];break;}if(m=s.CellXf[e[0].iStyleRef])mh(p,m.numFmtId,null,f,i,s);E=e[0].c==-1?E+1:e[0].c;if(f.dense){if(!l[g])l[g]=[];l[g][E]=p}else l[ht(E)+S]=p;if(f.cellFormula){_=false;for(T=0;T<x.length;++T){var I=x[T];if(v.r>=I[0].s.r&&v.r<=I[0].e.r)if(E>=I[0].s.c&&E<=I[0].e.c){p.F=Et(I[0]);_=true}}if(!_&&e.length>3)p.f=e[3]}if(c.s.r>v.r)c.s.r=v.r;if(c.s.c>E)c.s.c=E;if(c.e.r<v.r)c.e.r=v.r;if(c.e.c<E)c.e.c=E;if(f.cellDates&&m&&p.t=="n"&&D.is_date(D._table[m.numFmtId])){var P=D.parse_date_code(p.v);if(P){p.t="d";p.v=new Date(P.y,P.m-1,P.d,P.H,P.M,P.S,P.u)}}break;case 1:;case 12:if(!f.sheetStubs||h)break;p={t:"z",v:undefined};E=e[0].c==-1?E+1:e[0].c;if(f.dense){if(!l[g])l[g]=[];l[g][E]=p}else l[ht(E)+S]=p;if(c.s.r>v.r)c.s.r=v.r;if(c.s.c>E)c.s.c=E;if(c.e.r<v.r)c.e.r=v.r;if(c.e.c<E)c.e.c=E;break;case 176:C.push(e);break;case 494:var N=a["!id"][e.relId];if(N){e.Target=N.Target;if(e.loc)e.Target+="#"+e.loc;e.Rel=N}else if(e.relId==""){e.Target="#"+e.loc}for(g=e.rfx.s.r;g<=e.rfx.e.r;++g)for(E=e.rfx.s.c;E<=e.rfx.e.c;++E){if(f.dense){if(!l[g])l[g]=[];if(!l[g][E])l[g][E]={t:"z",v:undefined};l[g][E].l=e}else{w=mt({c:E,r:g});if(!l[w])l[w]={t:"z",v:undefined};l[w].l=e}}break;case 426:if(!f.cellFormula)break;x.push(e);B=f.dense?l[g][E]:l[ht(E)+S];B.f=Vu(e[1],c,{r:v.r,c:E},y,f);B.F=Et(e[0]);break;case 427:if(!f.cellFormula)break;A[mt(e[0].s)]=e[1];B=f.dense?l[g][E]:l[ht(E)+S];B.f=Vu(e[1],c,{r:v.r,c:E},y,f);break;case 60:if(!f.cellStyles)break;while(e.e>=e.s){R[e.e--]={width:e.w/256,hidden:!!(e.flags&1),level:e.level};if(!O){O=true;Sl(e.w/256)}Bl(R[e.e+1])}break;case 161:l["!autofilter"]={ref:Et(e)};break;case 476:l["!margins"]=e;break;case 147:if(!n.Sheets[t])n.Sheets[t]={};if(e.name)n.Sheets[t].CodeName=e.name;if(e.above||e.left)l["!outline"]={above:e.above,left:e.left};break;case 137:if(!n.Views)n.Views=[{}];if(!n.Views[0])n.Views[0]={};if(e.RTL)n.Views[0].RTL=true;break;case 485:break;case 64:;case 1053:break;case 151:break;case 152:;case 175:;case 644:;case 625:;case 562:;case 396:;case 1112:;case 1146:;case 471:;case 1050:;case 649:;case 1105:;case 49:;case 589:;case 607:;case 564:;case 1055:;case 168:;case 174:;case 1180:;case 499:;case 507:;case 550:;case 171:;case 167:;case 1177:;case 169:;case 1181:;case 551:;case 552:;case 661:;case 639:;case 478:;case 537:;case 477:;case 536:;case 1103:;case 680:;case 1104:;case 1024:;case 663:;case 535:;case 678:;case 504:;case 1043:;case 428:;case 170:;case 3072:;case 50:;case 2070:;case 1045:break;case 35:h=true;break;case 36:h=false;break;case 37:u.push(r);h=true;break;case 38:u.pop();h=false;break;default:if((r||"").indexOf("Begin")>0){}else if((r||"").indexOf("End")>0){}else if(!h||f.WTF)throw new Error("Unexpected record "+b+" "+r);}},f);delete f.supbooks;delete f["!row"];if(!l["!ref"]&&(c.s.r<2e6||o&&(o.e.r>0||o.e.c>0||o.s.r>0||o.s.c>0)))l["!ref"]=Et(o||c);if(f.sheetRows&&l["!ref"]){var P=wt(l["!ref"]);if(f.sheetRows<=+P.e.r){P.e.r=f.sheetRows-1;if(P.e.r>c.e.r)P.e.r=c.e.r;if(P.e.r<P.s.r)P.s.r=P.e.r;if(P.e.c>c.e.c)P.e.c=c.e.c;if(P.e.c<P.s.c)P.s.c=P.e.c;l["!fullref"]=l["!ref"];l["!ref"]=Et(P)}}if(C.length>0)l["!merges"]=C;if(R.length>0)l["!cols"]=R;if(F.length>0)l["!rows"]=F;return l}function nv(e,r,t,a,n,i,s){if(r.v===undefined)return false;var f="";switch(r.t){case"b":f=r.v?"1":"0";break;case"d":r=ce(r);r.z=r.z||D._table[14];r.v=ee(le(r.v));r.t="n";break;case"n":;case"e":f=""+r.v;break;default:f=r.v;break;}var l={r:t,c:a};l.s=bh(n.cellXfs,r,n);if(r.l)i["!links"].push([mt(l),r.l]);if(r.c)i["!comments"].push([mt(l),r.c]);switch(r.t){case"s":;case"str":if(n.bookSST){f=dh(n.Strings,r.v,n.revStrings);l.t="s";l.v=f;if(s)et(e,"BrtShortIsst",Sd(r,l));else et(e,"BrtCellIsst",wd(r,l))}else{l.t="str";if(s)et(e,"BrtShortSt",Od(r,l));else et(e,"BrtCellSt",Fd(r,l))}return true;case"n":if(r.v==(r.v|0)&&r.v>-1e3&&r.v<1e3){if(s)et(e,"BrtShortRk",Id(r,l));else et(e,"BrtCellRk",Ad(r,l))}else{if(s)et(e,"BrtShortReal",_d(r,l));else et(e,"BrtCellReal",Cd(r,l))}return true;case"b":l.t="b";if(s)et(e,"BrtShortBool",vd(r,l));else et(e,"BrtCellBool",hd(r,l));return true;case"e":l.t="e";if(s)et(e,"BrtShortError",gd(r,l));else et(e,"BrtCellError",bd(r,l));return true;}if(s)et(e,"BrtShortBlank",cd(r,l));else et(e,"BrtCellBlank",ld(r,l));return true}function iv(e,r,t,a){var n=wt(r["!ref"]||"A1"),i,s="",f=[];et(e,"BrtBeginSheetData");var l=Array.isArray(r);var o=n.e.r;if(r["!rows"])o=Math.max(n.e.r,r["!rows"].length-1);for(var c=n.s.r;c<=o;++c){s=lt(c);rd(e,r,n,c);var u=false;if(c<=n.e.r)for(var h=n.s.c;h<=n.e.c;++h){if(c===n.s.r)f[h]=ht(h);i=f[h]+s;var d=l?(r[c]||[])[h]:r[i];if(!d){u=false;continue}u=nv(e,d,c,h,a,r,u)}}et(e,"BrtEndSheetData")}function sv(e,r){if(!r||!r["!merges"])return;et(e,"BrtBeginMergeCells",Wd(r["!merges"].length));r["!merges"].forEach(function(r){et(e,"BrtMergeCell",Hd(r))});et(e,"BrtEndMergeCells")}function fv(e,r){if(!r||!r["!cols"])return;et(e,"BrtBeginColInfos");r["!cols"].forEach(function(r,t){if(r)et(e,"BrtColInfo",$d(t,r))});et(e,"BrtEndColInfos")}function lv(e,r){if(!r||!r["!ref"])return;et(e,"BrtBeginCellIgnoreECs");et(e,"BrtCellIgnoreEC",qd(wt(r["!ref"])));et(e,"BrtEndCellIgnoreECs")}function ov(e,r,t){r["!links"].forEach(function(r){if(!r[1].Target)return;var a=za(t,-1,r[1].Target.replace(/#.*$/,""),Ua.HLINK);et(e,"BrtHLink",Xd(r,a))});delete r["!links"]}function cv(e,r,t,a){if(r["!comments"].length>0){var n=za(a,-1,"../drawings/vmlDrawing"+(t+1)+".vml",Ua.VML);et(e,"BrtLegacyDrawing",zt("rId"+n));r["!legacy"]=n}}function uv(e,r,t,a){if(!r["!autofilter"])return;var n=r["!autofilter"];var i=typeof n.ref==="string"?n.ref:Et(n.ref);if(!t.Workbook)t.Workbook={Sheets:[]};if(!t.Workbook.Names)t.Workbook.Names=[];var s=t.Workbook.Names;var f=gt(i);if(f.s.r==f.e.r){f.e.r=gt(r["!ref"]).e.r;i=Et(f)}for(var l=0;l<s.length;++l){var o=s[l];if(o.Name!="_xlnm._FilterDatabase")continue;if(o.Sheet!=a)continue;o.Ref="'"+t.SheetNames[a]+"'!"+i;break}if(l==s.length)s.push({Name:"_xlnm._FilterDatabase",Sheet:a,Ref:"'"+t.SheetNames[a]+"'!"+i});et(e,"BrtBeginAFilter",Jt(wt(i)));et(e,"BrtEndAFilter")}function hv(e,r,t){et(e,"BrtBeginWsViews");{et(e,"BrtBeginWsView",Zd(r,t));et(e,"BrtEndWsView")}et(e,"BrtEndWsViews")}function dv(){}function vv(e,r){if(!r["!protect"])return;et(e,"BrtSheetProtection",ev(r["!protect"]))}function pv(e,r,t,a){var n=qr();var i=t.SheetNames[e],s=t.Sheets[i]||{};var f=i;try{if(t&&t.Workbook)f=t.Workbook.Sheets[e].CodeName||f}catch(l){}var o=wt(s["!ref"]||"A1");if(o.e.c>16383||o.e.r>1048575){if(r.WTF)throw new Error("Range "+(s["!ref"]||"A1")+" exceeds format limit A1:XFD1048576");o.e.c=Math.min(o.e.c,16383);o.e.r=Math.min(o.e.c,1048575)}s["!links"]=[];s["!comments"]=[];et(n,"BrtBeginSheet");if(t.vbaraw||s["!outline"])et(n,"BrtWsProp",sd(f,s["!outline"]));et(n,"BrtWsDim",ad(o));hv(n,s,t.Workbook);dv(n,s);fv(n,s,e,r,t);iv(n,s,e,r,t);vv(n,s);uv(n,s,t,e);sv(n,s);ov(n,s,a);if(s["!margins"])et(n,"BrtMargins",Qd(s["!margins"]));if(!r||r.ignoreEC||r.ignoreEC==void 0)lv(n,s);cv(n,s,e,a);et(n,"BrtEndSheet");return n.end()}Ua.CHART="http://schemas.openxmlformats.org/officeDocument/2006/relationships/chart";Ua.CHARTEX="http://schemas.microsoft.com/office/2014/relationships/chartEx";function bv(e){var r=[];var t=e.match(/^<c:numCache>/);var a;(e.match(/<c:pt idx="(\d*)">(.*?)<\/c:pt>/gm)||[]).forEach(function(e){var a=e.match(/<c:pt idx="(\d*?)"><c:v>(.*)<\/c:v><\/c:pt>/);if(!a)return;r[+a[1]]=t?+a[2]:a[2]});var n=Le((e.match(/<c:formatCode>([\s\S]*?)<\/c:formatCode>/)||["","General"])[1]);(e.match(/<c:f>(.*?)<\/c:f>/gm)||[]).forEach(function(e){a=e.replace(/<.*?>/g,"")});return[r,n,a]}function mv(e,r,t,a,n,i){var s=i||{"!type":"chart"};if(!e)return i;var f=0,l=0,o="A";var c={s:{r:2e6,c:2e6},e:{r:0,c:0}};(e.match(/<c:numCache>[\s\S]*?<\/c:numCache>/gm)||[]).forEach(function(e){var r=bv(e);c.s.r=c.s.c=0;c.e.c=f;o=ht(f);r[0].forEach(function(e,t){s[o+lt(t)]={t:"n",v:e,z:r[1]};l=t});if(c.e.r<l)c.e.r=l;++f});if(f>0)s["!ref"]=Et(c);return s}Ua.CS="http://schemas.openxmlformats.org/officeDocument/2006/relationships/chartsheet";var gv=or("chartsheet",null,{xmlns:hr.main[0],"xmlns:r":hr.r});function Ev(e,r,t,a,n){if(!e)return e;if(!a)a={"!id":{}};var i={"!type":"chart","!drawel":null,"!rel":""};var s;var f=e.match(xh);if(f)Fh(f[0],i,n,t);if(s=e.match(/drawing r:id="(.*?)"/))i["!rel"]=s[1];if(a["!id"][i["!rel"]])i["!drawel"]=a["!id"][i["!rel"]];return i}function wv(e,r,t,a){var n=[ye,gv];n[n.length]=or("drawing",null,{"r:id":"rId1"});za(a,-1,"../drawings/drawing"+(e+1)+".xml",Ua.DRAW);if(n.length>2){n[n.length]="</chartsheet>";n[1]=n[1].replace("/>",">")}return n.join("")}function kv(e,r){e.l+=10;var t=xt(e,r-10);return{name:t}}function Sv(e,r,t,a,n){if(!e)return e;if(!a)a={"!id":{}};var i={"!type":"chart","!drawel":null,"!rel":""};var s=[];var f=false;Zr(e,function l(e,a,o){switch(o){case 550:i["!rel"]=e;
break;case 651:if(!n.Sheets[t])n.Sheets[t]={};if(e.name)n.Sheets[t].CodeName=e.name;break;case 562:;case 652:;case 669:;case 679:;case 551:;case 552:;case 476:;case 3072:break;case 35:f=true;break;case 36:f=false;break;case 37:s.push(a);break;case 38:s.pop();break;default:if((a||"").indexOf("Begin")>0)s.push(a);else if((a||"").indexOf("End")>0)s.pop();else if(!f||r.WTF)throw new Error("Unexpected record "+o+" "+a);}},r);if(a["!id"][i["!rel"]])i["!drawel"]=a["!id"][i["!rel"]];return i}function Bv(){var e=qr();et(e,"BrtBeginSheet");et(e,"BrtEndSheet");return e.end()}var Cv=[["allowRefreshQuery",false,"bool"],["autoCompressPictures",true,"bool"],["backupFile",false,"bool"],["checkCompatibility",false,"bool"],["CodeName",""],["date1904",false,"bool"],["defaultThemeVersion",0,"int"],["filterPrivacy",false,"bool"],["hidePivotFieldList",false,"bool"],["promptedSolutions",false,"bool"],["publishItems",false,"bool"],["refreshAllConnections",false,"bool"],["saveExternalLinkValues",true,"bool"],["showBorderUnselectedTables",true,"bool"],["showInkAnnotation",true,"bool"],["showObjects","all"],["showPivotChartFilter",false,"bool"],["updateLinks","userSet"]];var Tv=[["activeTab",0,"int"],["autoFilterDateGrouping",true,"bool"],["firstSheet",0,"int"],["minimized",false,"bool"],["showHorizontalScroll",true,"bool"],["showSheetTabs",true,"bool"],["showVerticalScroll",true,"bool"],["tabRatio",600,"int"],["visibility","visible"]];var _v=[];var xv=[["calcCompleted","true"],["calcMode","auto"],["calcOnSave","true"],["concurrentCalc","true"],["fullCalcOnLoad","false"],["fullPrecision","true"],["iterate","false"],["iterateCount","100"],["iterateDelta","0.001"],["refMode","A1"]];function Av(e,r){for(var t=0;t!=e.length;++t){var a=e[t];for(var n=0;n!=r.length;++n){var i=r[n];if(a[i[0]]==null)a[i[0]]=i[1];else switch(i[2]){case"bool":if(typeof a[i[0]]=="string")a[i[0]]=Ke(a[i[0]]);break;case"int":if(typeof a[i[0]]=="string")a[i[0]]=parseInt(a[i[0]],10);break;}}}}function yv(e,r){for(var t=0;t!=r.length;++t){var a=r[t];if(e[a[0]]==null)e[a[0]]=a[1];else switch(a[2]){case"bool":if(typeof e[a[0]]=="string")e[a[0]]=Ke(e[a[0]]);break;case"int":if(typeof e[a[0]]=="string")e[a[0]]=parseInt(e[a[0]],10);break;}}}function Iv(e){yv(e.WBProps,Cv);yv(e.CalcPr,xv);Av(e.WBView,Tv);Av(e.Sheets,_v);uh.date1904=Ke(e.WBProps.date1904)}function Rv(e){if(!e.Workbook)return"false";if(!e.Workbook.WBProps)return"false";return Ke(e.Workbook.WBProps.date1904)?"true":"false"}var Fv="][*?/\\".split("");function Dv(e,r){if(e.length>31){if(r)return false;throw new Error("Sheet names cannot exceed 31 chars")}var t=true;Fv.forEach(function(a){if(e.indexOf(a)==-1)return;if(!r)throw new Error("Sheet name cannot contain : \\ / ? * [ ]");t=false});return t}function Ov(e,r,t){e.forEach(function(a,n){Dv(a);for(var i=0;i<n;++i)if(a==e[i])throw new Error("Duplicate Sheet Name: "+a);if(t){var s=r&&r[n]&&r[n].CodeName||a;if(s.charCodeAt(0)==95&&s.length>22)throw new Error("Bad Code Name: Worksheet"+s)}})}function Pv(e){if(!e||!e.SheetNames||!e.Sheets)throw new Error("Invalid Workbook");if(!e.SheetNames.length)throw new Error("Workbook is empty");var r=e.Workbook&&e.Workbook.Sheets||[];Ov(e.SheetNames,r,!!e.vbaraw);for(var t=0;t<e.SheetNames.length;++t)gh(e.Sheets[e.SheetNames[t]],e.SheetNames[t],t)}var Nv=/<\w+:workbook/;function Mv(e,r){if(!e)throw new Error("Could not find file");var t={AppVersion:{},WBProps:{},WBView:[],Sheets:[],CalcPr:{},Names:[],xmlns:""};var a=false,n="xmlns";var i={},s=0;e.replace(Re,function f(l,o){var c=Oe(l);switch(Pe(c[0])){case"<?xml":break;case"<workbook":if(l.match(Nv))n="xmlns"+l.match(/<(\w+):/)[1];t.xmlns=c[n];break;case"</workbook>":break;case"<fileVersion":delete c[0];t.AppVersion=c;break;case"<fileVersion/>":;case"</fileVersion>":break;case"<fileSharing":break;case"<fileSharing/>":break;case"<workbookPr":;case"<workbookPr/>":Cv.forEach(function(e){if(c[e[0]]==null)return;switch(e[2]){case"bool":t.WBProps[e[0]]=Ke(c[e[0]]);break;case"int":t.WBProps[e[0]]=parseInt(c[e[0]],10);break;default:t.WBProps[e[0]]=c[e[0]];}});if(c.codeName)t.WBProps.CodeName=Ye(c.codeName);break;case"</workbookPr>":break;case"<workbookProtection":break;case"<workbookProtection/>":break;case"<bookViews":;case"<bookViews>":;case"</bookViews>":break;case"<workbookView":;case"<workbookView/>":delete c[0];t.WBView.push(c);break;case"</workbookView>":break;case"<sheets":;case"<sheets>":;case"</sheets>":break;case"<sheet":switch(c.state){case"hidden":c.Hidden=1;break;case"veryHidden":c.Hidden=2;break;default:c.Hidden=0;}delete c.state;c.name=Le(Ye(c.name));delete c[0];t.Sheets.push(c);break;case"</sheet>":break;case"<functionGroups":;case"<functionGroups/>":break;case"<functionGroup":break;case"<externalReferences":;case"</externalReferences>":;case"<externalReferences>":break;case"<externalReference":break;case"<definedNames/>":break;case"<definedNames>":;case"<definedNames":a=true;break;case"</definedNames>":a=false;break;case"<definedName":{i={};i.Name=Ye(c.name);if(c.comment)i.Comment=c.comment;if(c.localSheetId)i.Sheet=+c.localSheetId;if(Ke(c.hidden||"0"))i.Hidden=true;s=o+l.length}break;case"</definedName>":{i.Ref=Le(Ye(e.slice(s,o)));t.Names.push(i)}break;case"<definedName/>":break;case"<calcPr":delete c[0];t.CalcPr=c;break;case"<calcPr/>":delete c[0];t.CalcPr=c;break;case"</calcPr>":break;case"<oleSize":break;case"<customWorkbookViews>":;case"</customWorkbookViews>":;case"<customWorkbookViews":break;case"<customWorkbookView":;case"</customWorkbookView>":break;case"<pivotCaches>":;case"</pivotCaches>":;case"<pivotCaches":break;case"<pivotCache":break;case"<smartTagPr":;case"<smartTagPr/>":break;case"<smartTagTypes":;case"<smartTagTypes>":;case"</smartTagTypes>":break;case"<smartTagType":break;case"<webPublishing":;case"<webPublishing/>":break;case"<fileRecoveryPr":;case"<fileRecoveryPr/>":break;case"<webPublishObjects>":;case"<webPublishObjects":;case"</webPublishObjects>":break;case"<webPublishObject":break;case"<extLst":;case"<extLst>":;case"</extLst>":;case"<extLst/>":break;case"<ext":a=true;break;case"</ext>":a=false;break;case"<ArchID":break;case"<AlternateContent":;case"<AlternateContent>":a=true;break;case"</AlternateContent>":a=false;break;case"<revisionPtr":break;default:if(!a&&r.WTF)throw new Error("unrecognized "+c[0]+" in workbook");}return l});if(hr.main.indexOf(t.xmlns)===-1)throw new Error("Unknown Namespace: "+t.xmlns);Iv(t);return t}var Lv=or("workbook",null,{xmlns:hr.main[0],"xmlns:r":hr.r});function Uv(e){var r=[ye];r[r.length]=Lv;var t=e.Workbook&&(e.Workbook.Names||[]).length>0;var a={codeName:"ThisWorkbook"};if(e.Workbook&&e.Workbook.WBProps){Cv.forEach(function(r){if(e.Workbook.WBProps[r[0]]==null)return;if(e.Workbook.WBProps[r[0]]==r[1])return;a[r[0]]=e.Workbook.WBProps[r[0]]});if(e.Workbook.WBProps.CodeName){a.codeName=e.Workbook.WBProps.CodeName;delete a.CodeName}}r[r.length]=or("workbookPr",null,a);var n=e.Workbook&&e.Workbook.Sheets||[];var i=0;if(n&&n[0]&&!!n[0].Hidden){r[r.length]="<bookViews>";for(i=0;i!=e.SheetNames.length;++i){if(!n[i])break;if(!n[i].Hidden)break}if(i==e.SheetNames.length)i=0;r[r.length]='<workbookView firstSheet="'+i+'" activeTab="'+i+'"/>';r[r.length]="</bookViews>"}r[r.length]="<sheets>";for(i=0;i!=e.SheetNames.length;++i){var s={name:We(e.SheetNames[i].slice(0,31))};s.sheetId=""+(i+1);s["r:id"]="rId"+(i+1);if(n[i])switch(n[i].Hidden){case 1:s.state="hidden";break;case 2:s.state="veryHidden";break;}r[r.length]=or("sheet",null,s)}r[r.length]="</sheets>";if(t){r[r.length]="<definedNames>";if(e.Workbook&&e.Workbook.Names)e.Workbook.Names.forEach(function(e){var t={name:e.Name};if(e.Comment)t.comment=e.Comment;if(e.Sheet!=null)t.localSheetId=""+e.Sheet;if(e.Hidden)t.hidden="1";if(!e.Ref)return;r[r.length]=or("definedName",We(e.Ref),t)});r[r.length]="</definedNames>"}if(r.length>2){r[r.length]="</workbook>";r[1]=r[1].replace("/>",">")}return r.join("")}function Hv(e,r){var t={};t.Hidden=e._R(4);t.iTabID=e._R(4);t.strRelID=Gt(e,r-8);t.name=xt(e);return t}function Wv(e,r){if(!r)r=Jr(127);r._W(4,e.Hidden);r._W(4,e.iTabID);zt(e.strRelID,r);At(e.name.slice(0,31),r);return r.length>r.l?r.slice(0,r.l):r}function Vv(e,r){var t={};var a=e._R(4);t.defaultThemeVersion=e._R(4);var n=r>8?xt(e):"";if(n.length>0)t.CodeName=n;t.autoCompressPictures=!!(a&65536);t.backupFile=!!(a&64);t.checkCompatibility=!!(a&4096);t.date1904=!!(a&1);t.filterPrivacy=!!(a&8);t.hidePivotFieldList=!!(a&1024);t.promptedSolutions=!!(a&16);t.publishItems=!!(a&2048);t.refreshAllConnections=!!(a&262144);t.saveExternalLinkValues=!!(a&128);t.showBorderUnselectedTables=!!(a&4);t.showInkAnnotation=!!(a&32);t.showObjects=["all","placeholders","none"][a>>13&3];t.showPivotChartFilter=!!(a&32768);t.updateLinks=["userSet","never","always"][a>>8&3];return t}function Xv(e,r){if(!r)r=Jr(72);var t=0;if(e){if(e.filterPrivacy)t|=8}r._W(4,t);r._W(4,0);Ht(e&&e.CodeName||"ThisWorkbook",r);return r.slice(0,r.l)}function Gv(e,r){var t={};e._R(4);t.ArchID=e._R(4);e.l+=r-8;return t}function zv(e,r,t){var a=e.l+r;e.l+=4;e.l+=1;var n=e._R(4);var i=Xt(e);var s=eh(e,0,t);var f=Wt(e);e.l=a;var l={Name:i,Ptg:s};if(n<268435455)l.Sheet=n;if(f)l.Comment=f;return l}function jv(e,r){var t={AppVersion:{},WBProps:{},WBView:[],Sheets:[],CalcPr:{},xmlns:""};var a=[];var n=false;if(!r)r={};r.biff=12;var i=[];var s=[[]];s.SheetNames=[];s.XTI=[];Zp[16]={n:"BrtFRTArchID$",f:Gv};Zr(e,function f(e,l,o){switch(o){case 156:s.SheetNames.push(e.name);t.Sheets.push(e);break;case 153:t.WBProps=e;break;case 39:if(e.Sheet!=null)r.SID=e.Sheet;e.Ref=Vu(e.Ptg,null,null,s,r);delete r.SID;delete e.Ptg;i.push(e);break;case 1036:break;case 357:;case 358:;case 355:;case 667:if(!s[0].length)s[0]=[o,e];else s.push([o,e]);s[s.length-1].XTI=[];break;case 362:if(s.length===0){s[0]=[];s[0].XTI=[]}s[s.length-1].XTI=s[s.length-1].XTI.concat(e);s.XTI=s.XTI.concat(e);break;case 361:break;case 2071:;case 158:;case 143:;case 664:;case 353:break;case 3072:;case 3073:;case 534:;case 677:;case 157:;case 610:;case 2050:;case 155:;case 548:;case 676:;case 128:;case 665:;case 2128:;case 2125:;case 549:;case 2053:;case 596:;case 2076:;case 2075:;case 2082:;case 397:;case 154:;case 1117:;case 553:;case 2091:break;case 35:a.push(l);n=true;break;case 36:a.pop();n=false;break;case 37:a.push(l);n=true;break;case 38:a.pop();n=false;break;case 16:break;default:if((l||"").indexOf("Begin")>0){}else if((l||"").indexOf("End")>0){}else if(!n||r.WTF&&a[a.length-1]!="BrtACBegin"&&a[a.length-1]!="BrtFRTBegin")throw new Error("Unexpected record "+o+" "+l);}},r);Iv(t);t.Names=i;t.supbooks=s;return t}function $v(e,r){et(e,"BrtBeginBundleShs");for(var t=0;t!=r.SheetNames.length;++t){var a=r.Workbook&&r.Workbook.Sheets&&r.Workbook.Sheets[t]&&r.Workbook.Sheets[t].Hidden||0;var n={Hidden:a,iTabID:t+1,strRelID:"rId"+(t+1),name:r.SheetNames[t]};et(e,"BrtBundleSh",Wv(n))}et(e,"BrtEndBundleShs")}function Kv(r,t){if(!t)t=Jr(127);for(var a=0;a!=4;++a)t._W(4,0);At("SheetJS",t);At(e.version,t);At(e.version,t);At("7262",t);return t.length>t.l?t.slice(0,t.l):t}function Yv(e,r){if(!r)r=Jr(29);r._W(-4,0);r._W(-4,460);r._W(4,28800);r._W(4,17600);r._W(4,500);r._W(4,e);r._W(4,e);var t=120;r._W(1,t);return r.length>r.l?r.slice(0,r.l):r}function Qv(e,r){if(!r.Workbook||!r.Workbook.Sheets)return;var t=r.Workbook.Sheets;var a=0,n=-1,i=-1;for(;a<t.length;++a){if(!t[a]||!t[a].Hidden&&n==-1)n=a;else if(t[a].Hidden==1&&i==-1)i=a}if(i>n)return;et(e,"BrtBeginBookViews");et(e,"BrtBookView",Yv(n));et(e,"BrtEndBookViews")}function Jv(e,r){var t=qr();et(t,"BrtBeginBook");et(t,"BrtFileVersion",Kv());et(t,"BrtWbProp",Xv(e.Workbook&&e.Workbook.WBProps||null));Qv(t,e,r);$v(t,e,r);et(t,"BrtEndBook");return t.end()}function Zv(e,r,t){if(r.slice(-4)===".bin")return jv(e,t);return Mv(e,t)}function qv(e,r,t,a,n,i,s,f){if(r.slice(-4)===".bin")return av(e,a,t,n,i,s,f);return Ih(e,a,t,n,i,s,f)}function ep(e,r,t,a,n,i,s,f){if(r.slice(-4)===".bin")return Sv(e,a,t,n,i,s,f);return Ev(e,a,t,n,i,s,f)}function rp(e,r,t,a,n,i,s,f){if(r.slice(-4)===".bin")return nc(e,a,t,n,i,s,f);return ic(e,a,t,n,i,s,f)}function tp(e,r,t,a,n,i,s,f){if(r.slice(-4)===".bin")return tc(e,a,t,n,i,s,f);return ac(e,a,t,n,i,s,f)}function ap(e,r,t,a){if(r.slice(-4)===".bin")return to(e,t,a);return Ll(e,t,a)}function np(e,r,t){return Co(e,t)}function ip(e,r,t){if(r.slice(-4)===".bin")return Pf(e,t);return Rf(e,t)}function sp(e,r,t){if(r.slice(-4)===".bin")return Qo(e,t);return Xo(e,t)}function fp(e,r,t){if(r.slice(-4)===".bin")return No(e,r,t);return Oo(e,r,t)}function lp(e,r,t,a){if(t.slice(-4)===".bin")return Lo(e,r,t,a);return Mo(e,r,t,a)}function op(e,r,t){return(r.slice(-4)===".bin"?Jv:Uv)(e,t)}function cp(e,r,t,a,n){return(r.slice(-4)===".bin"?pv:Zh)(e,t,a,n)}function up(e,r,t,a,n){return(r.slice(-4)===".bin"?Bv:wv)(e,t,a,n)}function hp(e,r,t){return(r.slice(-4)===".bin"?vo:Hl)(e,t)}function dp(e,r,t){return(r.slice(-4)===".bin"?Lf:Df)(e,t)}function vp(e,r,t){return(r.slice(-4)===".bin"?Jo:zo)(e,t)}var pp=/([\w:]+)=((?:")([^"]*)(?:")|(?:')([^']*)(?:'))/g;var bp=/([\w:]+)=((?:")(?:[^"]*)(?:")|(?:')(?:[^']*)(?:'))/;function mp(e,r){var t=e.split(/\s+/);var a=[];if(!r)a[0]=t[0];if(t.length===1)return a;var n=e.match(pp),i,s,f,l;if(n)for(l=0;l!=n.length;++l){i=n[l].match(bp);if((s=i[1].indexOf(":"))===-1)a[i[1]]=i[2].slice(1,i[2].length-1);else{if(i[1].slice(0,6)==="xmlns:")f="xmlns"+i[1].slice(6);else f=i[1].slice(s+1);a[f]=i[2].slice(1,i[2].length-1)}}return a}function gp(e){var r=e.split(/\s+/);var t={};if(r.length===1)return t;var a=e.match(pp),n,i,s,f;if(a)for(f=0;f!=a.length;++f){n=a[f].match(bp);if((i=n[1].indexOf(":"))===-1)t[n[1]]=n[2].slice(1,n[2].length-1);else{if(n[1].slice(0,6)==="xmlns:")s="xmlns"+n[1].slice(6);else s=n[1].slice(i+1);t[s]=n[2].slice(1,n[2].length-1)}}return t}function Ep(e,r){var t=P[e]||Le(e);if(t==="General")return D._general(r);return D.format(t,r)}function wp(e,r,t,a){var n=a;switch((t[0].match(/dt:dt="([\w.]+)"/)||["",""])[1]){case"boolean":n=Ke(a);break;case"i2":;case"int":n=parseInt(a,10);break;case"r4":;case"float":n=parseFloat(a);break;case"date":;case"dateTime.tz":n=le(a);break;case"i8":;case"string":;case"fixed":;case"uuid":;case"bin.base64":break;default:throw new Error("bad custprop:"+t[0]);}e[Le(r)]=n}function kp(e,r,t){if(e.t==="z")return;if(!t||t.cellText!==false)try{if(e.t==="e"){e.w=e.w||ya[e.v]}else if(r==="General"){if(e.t==="n"){if((e.v|0)===e.v)e.w=D._general_int(e.v);else e.w=D._general_num(e.v)}else e.w=D._general(e.v)}else e.w=Ep(r||"General",e.v)}catch(a){if(t.WTF)throw a}try{var n=P[r]||r||"General";if(t.cellNF)e.z=n;if(t.cellDates&&e.t=="n"&&D.is_date(n)){var i=D.parse_date_code(e.v);if(i){e.t="d";e.v=new Date(i.y,i.m-1,i.d,i.H,i.M,i.S,i.u)}}}catch(a){if(t.WTF)throw a}}function Sp(e,r,t){if(t.cellStyles){if(r.Interior){var a=r.Interior;if(a.Pattern)a.patternType=Al[a.Pattern]||a.Pattern}}e[r.ID]=r}function Bp(e,r,t,a,n,i,s,f,l,o){var c="General",u=a.StyleID,h={};o=o||{};var d=[];var v=0;if(u===undefined&&f)u=f.StyleID;if(u===undefined&&s)u=s.StyleID;while(i[u]!==undefined){if(i[u].nf)c=i[u].nf;if(i[u].Interior)d.push(i[u].Interior);if(!i[u].Parent)break;u=i[u].Parent}switch(t.Type){case"Boolean":a.t="b";a.v=Ke(e);break;case"String":a.t="s";a.r=je(Le(e));a.v=e.indexOf("<")>-1?Le(r||e).replace(/<.*?>/g,""):a.r;break;case"DateTime":if(e.slice(-1)!="Z")e+="Z";a.v=(le(e)-new Date(Date.UTC(1899,11,30)))/(24*60*60*1e3);if(a.v!==a.v)a.v=Le(e);else if(a.v<60)a.v=a.v-1;if(!c||c=="General")c="yyyy-mm-dd";case"Number":if(a.v===undefined)a.v=+e;if(!a.t)a.t="n";break;case"Error":a.t="e";a.v=Ia[e];if(o.cellText!==false)a.w=e;break;default:if(e==""&&r==""){a.t="z"}else{a.t="s";a.v=je(r||e)}break;}kp(a,c,o);if(o.cellFormula!==false){if(a.Formula){var p=Le(a.Formula);if(p.charCodeAt(0)==61)p=p.slice(1);a.f=sc(p,n);delete a.Formula;if(a.ArrayRange=="RC")a.F=sc("RC:RC",n);else if(a.ArrayRange){a.F=sc(a.ArrayRange,n);l.push([wt(a.F),a.F])}}else{for(v=0;v<l.length;++v)if(n.r>=l[v][0].s.r&&n.r<=l[v][0].e.r)if(n.c>=l[v][0].s.c&&n.c<=l[v][0].e.c)a.F=l[v][1]}}if(o.cellStyles){d.forEach(function(e){if(!h.patternType&&e.patternType)h.patternType=e.patternType});a.s=h}if(a.StyleID!==undefined)a.ixfe=a.StyleID}function Cp(e){e.t=e.v||"";e.t=e.t.replace(/\r\n/g,"\n").replace(/\r/g,"\n");e.v=e.w=e.ixfe=undefined}function Tp(e){if(E&&Buffer.isBuffer(e))return e.toString("utf8");if(typeof e==="string")return e;if(typeof Uint8Array!=="undefined"&&e instanceof Uint8Array)return Ye(x(y(e)));throw new Error("Bad input format: expected Buffer or string")}var _p=/<(\/?)([^\s?><!\/:]*:|)([^\s?<>:\/]+)(?:[\s?:\/][^>]*)?>/gm;function xp(e,r){var t=r||{};O(D);var a=d(Tp(e));if(t.type=="binary"||t.type=="array"||t.type=="base64"){if(typeof cptable!=="undefined")a=cptable.utils.decode(65001,c(a));else a=Ye(a)}var n=a.slice(0,1024).toLowerCase(),i=false;if((n.indexOf(">")&1023)>Math.min(n.indexOf(",")&1023,n.indexOf(";")&1023)){var s=ce(t);s.type="string";return gf.to_workbook(a,s)}if(n.indexOf("<?xml")==-1)["html","table","head","meta","script","style","div"].forEach(function(e){if(n.indexOf("<"+e)>=0)i=true});if(i)return kb.to_workbook(a,t);var f;var l=[],o;if(b!=null&&t.dense==null)t.dense=b;var u={},h=[],v=t.dense?[]:{},p="";var m={},g={},E={};var w=mp('<Data ss:Type="String">'),k=0;var S=0,B=0;var C={s:{r:2e6,c:2e6},e:{r:0,c:0}};var T={},_={};var x="",A=0;var y=[];var I={},R={},F=0,N=[];var M=[],L={};var U=[],H,W=false;var V=[];var X=[],G={},z=0,j=0;var $={Sheets:[],WBProps:{date1904:false}},K={};_p.lastIndex=0;a=a.replace(/<!--([\s\S]*?)-->/gm,"");var Y="";while(f=_p.exec(a))switch(f[3]=(Y=f[3]).toLowerCase()){case"data":if(Y=="data"){if(f[1]==="/"){if((o=l.pop())[0]!==f[3])throw new Error("Bad state: "+o.join("|"))}else if(f[0].charAt(f[0].length-2)!=="/")l.push([f[3],true]);break}if(l[l.length-1][1])break;if(f[1]==="/")Bp(a.slice(k,f.index),x,w,l[l.length-1][0]=="comment"?L:g,{c:S,r:B},T,U[S],E,V,t);else{x="";w=mp(f[0]);k=f.index+f[0].length}break;case"cell":if(f[1]==="/"){if(M.length>0)g.c=M;if((!t.sheetRows||t.sheetRows>B)&&g.v!==undefined){if(t.dense){if(!v[B])v[B]=[];v[B][S]=g}else v[ht(S)+lt(B)]=g}if(g.HRef){g.l={Target:Le(g.HRef)};if(g.HRefScreenTip)g.l.Tooltip=g.HRefScreenTip;delete g.HRef;delete g.HRefScreenTip}if(g.MergeAcross||g.MergeDown){z=S+(parseInt(g.MergeAcross,10)|0);j=B+(parseInt(g.MergeDown,10)|0);y.push({s:{c:S,r:B},e:{c:z,r:j}})}if(!t.sheetStubs){if(g.MergeAcross)S=z+1;else++S}else if(g.MergeAcross||g.MergeDown){for(var Q=S;Q<=z;++Q){for(var J=B;J<=j;++J){if(Q>S||J>B){if(t.dense){if(!v[J])v[J]=[];v[J][Q]={t:"z"}}else v[ht(Q)+lt(J)]={t:"z"}}}}S=z+1}else++S}else{g=gp(f[0]);if(g.Index)S=+g.Index-1;if(S<C.s.c)C.s.c=S;if(S>C.e.c)C.e.c=S;if(f[0].slice(-2)==="/>")++S;M=[]}break;case"row":if(f[1]==="/"||f[0].slice(-2)==="/>"){if(B<C.s.r)C.s.r=B;if(B>C.e.r)C.e.r=B;if(f[0].slice(-2)==="/>"){E=mp(f[0]);if(E.Index)B=+E.Index-1}S=0;++B}else{E=mp(f[0]);if(E.Index)B=+E.Index-1;G={};if(E.AutoFitHeight=="0"||E.Height){G.hpx=parseInt(E.Height,10);G.hpt=_l(G.hpx);X[B]=G}if(E.Hidden=="1"){G.hidden=true;X[B]=G}}break;case"worksheet":if(f[1]==="/"){if((o=l.pop())[0]!==f[3])throw new Error("Bad state: "+o.join("|"));h.push(p);if(C.s.r<=C.e.r&&C.s.c<=C.e.c){v["!ref"]=Et(C);if(t.sheetRows&&t.sheetRows<=C.e.r){v["!fullref"]=v["!ref"];C.e.r=t.sheetRows-1;v["!ref"]=Et(C)}}if(y.length)v["!merges"]=y;if(U.length>0)v["!cols"]=U;if(X.length>0)v["!rows"]=X;u[p]=v}else{C={s:{r:2e6,c:2e6},e:{r:0,c:0}};B=S=0;l.push([f[3],false]);o=mp(f[0]);p=Le(o.Name);v=t.dense?[]:{};y=[];V=[];X=[];K={name:p,Hidden:0};$.Sheets.push(K)}break;case"table":if(f[1]==="/"){if((o=l.pop())[0]!==f[3])throw new Error("Bad state: "+o.join("|"))}else if(f[0].slice(-2)=="/>")break;else{m=mp(f[0]);l.push([f[3],false]);U=[];W=false}break;case"style":if(f[1]==="/")Sp(T,_,t);else _=mp(f[0]);break;case"numberformat":_.nf=Le(mp(f[0]).Format||"General");if(P[_.nf])_.nf=P[_.nf];for(var Z=0;Z!=392;++Z)if(D._table[Z]==_.nf)break;if(Z==392)for(Z=57;Z!=392;++Z)if(D._table[Z]==null){D.load(_.nf,Z);break}break;case"column":if(l[l.length-1][0]!=="table")break;H=mp(f[0]);if(H.Hidden){H.hidden=true;delete H.Hidden}if(H.Width)H.wpx=parseInt(H.Width,10);if(!W&&H.wpx>10){W=true;ml=vl;for(var q=0;q<U.length;++q)if(U[q])Bl(U[q])}if(W)Bl(H);U[H.Index-1||U.length]=H;for(var ee=0;ee<+H.Span;++ee)U[U.length]=ce(H);break;case"namedrange":if(f[1]==="/")break;if(!$.Names)$.Names=[];var re=Oe(f[0]);var te={Name:re.Name,Ref:sc(re.RefersTo.slice(1),{r:0,c:0})};if($.Sheets.length>0)te.Sheet=$.Sheets.length-1;$.Names.push(te);break;case"namedcell":break;case"b":break;case"i":break;case"u":break;case"s":break;case"em":break;case"h2":break;case"h3":break;case"sub":break;case"sup":break;case"span":break;case"alignment":break;case"borders":break;case"border":break;case"font":if(f[0].slice(-2)==="/>")break;else if(f[1]==="/")x+=a.slice(A,f.index);else A=f.index+f[0].length;break;case"interior":if(!t.cellStyles)break;_.Interior=mp(f[0]);break;case"protection":break;case"author":;case"title":;case"description":;case"created":;case"keywords":;case"subject":;case"category":;case"company":;case"lastauthor":;case"lastsaved":;case"lastprinted":;case"version":;case"revision":;case"totaltime":;case"hyperlinkbase":;case"manager":;case"contentstatus":;case"identifier":;case"language":;case"appname":if(f[0].slice(-2)==="/>")break;else if(f[1]==="/")gn(I,Y,a.slice(F,f.index));else F=f.index+f[0].length;break;case"paragraphs":break;case"styles":;case"workbook":if(f[1]==="/"){if((o=l.pop())[0]!==f[3])throw new Error("Bad state: "+o.join("|"))}else l.push([f[3],false]);break;case"comment":if(f[1]==="/"){if((o=l.pop())[0]!==f[3])throw new Error("Bad state: "+o.join("|"));Cp(L);M.push(L)}else{l.push([f[3],false]);o=mp(f[0]);L={a:o.Author}}break;case"autofilter":if(f[1]==="/"){if((o=l.pop())[0]!==f[3])throw new Error("Bad state: "+o.join("|"))}else if(f[0].charAt(f[0].length-2)!=="/"){var ae=mp(f[0]);v["!autofilter"]={ref:sc(ae.Range).replace(/\$/g,"")};l.push([f[3],true])}break;case"name":break;case"datavalidation":if(f[1]==="/"){if((o=l.pop())[0]!==f[3])throw new Error("Bad state: "+o.join("|"))}else{if(f[0].charAt(f[0].length-2)!=="/")l.push([f[3],true])}break;case"pixelsperinch":break;case"componentoptions":;case"documentproperties":;case"customdocumentproperties":;case"officedocumentsettings":;case"pivottable":;case"pivotcache":;case"names":;case"mapinfo":;case"pagebreaks":;case"querytable":;case"sorting":;case"schema":;case"conditionalformatting":;case"smarttagtype":;case"smarttags":;case"excelworkbook":;case"workbookoptions":;case"worksheetoptions":if(f[1]==="/"){if((o=l.pop())[0]!==f[3])throw new Error("Bad state: "+o.join("|"))}else if(f[0].charAt(f[0].length-2)!=="/")l.push([f[3],true]);break;case"null":break;default:if(l.length==0&&f[3]=="document")return yb(a,t);if(l.length==0&&f[3]=="uof")return yb(a,t);var ne=true;switch(l[l.length-1][0]){case"officedocumentsettings":switch(f[3]){case"allowpng":break;case"removepersonalinformation":break;case"downloadcomponents":break;case"locationofcomponents":break;case"colors":break;case"color":break;case"index":break;case"rgb":break;case"targetscreensize":break;case"readonlyrecommended":break;default:ne=false;}break;case"componentoptions":switch(f[3]){case"toolbar":break;case"hideofficelogo":break;case"spreadsheetautofit":break;case"label":break;case"caption":break;case"maxheight":break;case"maxwidth":break;case"nextsheetnumber":break;default:ne=false;}break;case"excelworkbook":switch(f[3]){case"date1904":$.WBProps.date1904=true;break;case"windowheight":break;case"windowwidth":break;case"windowtopx":break;case"windowtopy":break;case"tabratio":break;case"protectstructure":break;case"protectwindow":break;case"protectwindows":break;case"activesheet":break;case"displayinknotes":break;case"firstvisiblesheet":break;case"supbook":break;case"sheetname":break;case"sheetindex":break;case"sheetindexfirst":break;case"sheetindexlast":break;case"dll":break;case"acceptlabelsinformulas":break;case"donotsavelinkvalues":break;case"iteration":break;case"maxiterations":break;case"maxchange":break;case"path":break;case"xct":break;case"count":break;case"selectedsheets":break;case"calculation":break;case"uncalced":break;case"startupprompt":break;case"crn":break;case"externname":break;case"formula":break;case"colfirst":break;case"collast":break;case"wantadvise":break;case"boolean":break;case"error":break;case"text":break;case"ole":break;case"noautorecover":break;case"publishobjects":break;case"donotcalculatebeforesave":break;case"number":break;case"refmoder1c1":break;case"embedsavesmarttags":break;default:ne=false;}break;case"workbookoptions":switch(f[3]){case"owcversion":break;case"height":break;case"width":break;default:ne=false;}break;case"worksheetoptions":switch(f[3]){case"visible":if(f[0].slice(-2)==="/>"){}else if(f[1]==="/")switch(a.slice(F,f.index)){case"SheetHidden":K.Hidden=1;break;case"SheetVeryHidden":K.Hidden=2;break;}else F=f.index+f[0].length;break;case"header":if(!v["!margins"])ph(v["!margins"]={},"xlml");v["!margins"].header=Oe(f[0]).Margin;break;case"footer":if(!v["!margins"])ph(v["!margins"]={},"xlml");v["!margins"].footer=Oe(f[0]).Margin;break;case"pagemargins":var ie=Oe(f[0]);if(!v["!margins"])ph(v["!margins"]={},"xlml");if(ie.Top)v["!margins"].top=ie.Top;if(ie.Left)v["!margins"].left=ie.Left;if(ie.Right)v["!margins"].right=ie.Right;if(ie.Bottom)v["!margins"].bottom=ie.Bottom;break;case"displayrighttoleft":if(!$.Views)$.Views=[];if(!$.Views[0])$.Views[0]={};$.Views[0].RTL=true;break;case"freezepanes":break;case"frozennosplit":break;case"splithorizontal":;case"splitvertical":break;case"donotdisplaygridlines":break;case"activerow":break;case"activecol":break;case"toprowbottompane":break;case"leftcolumnrightpane":break;case"unsynced":break;case"print":break;case"printerrors":break;case"panes":break;case"scale":break;case"pane":break;case"number":break;case"layout":break;case"pagesetup":break;case"selected":break;case"protectobjects":break;case"enableselection":break;case"protectscenarios":break;case"validprinterinfo":break;case"horizontalresolution":break;case"verticalresolution":break;case"numberofcopies":break;case"activepane":break;case"toprowvisible":break;case"leftcolumnvisible":break;case"fittopage":break;case"rangeselection":break;case"papersizeindex":break;case"pagelayoutzoom":break;case"pagebreakzoom":break;case"filteron":break;case"fitwidth":break;case"fitheight":break;case"commentslayout":break;case"zoom":break;case"lefttoright":break;case"gridlines":break;case"allowsort":break;case"allowfilter":break;case"allowinsertrows":break;case"allowdeleterows":break;case"allowinsertcols":break;case"allowdeletecols":break;case"allowinserthyperlinks":break;case"allowformatcells":break;case"allowsizecols":break;case"allowsizerows":break;case"nosummaryrowsbelowdetail":if(!v["!outline"])v["!outline"]={};v["!outline"].above=true;break;case"tabcolorindex":break;case"donotdisplayheadings":break;case"showpagelayoutzoom":break;case"nosummarycolumnsrightdetail":if(!v["!outline"])v["!outline"]={};v["!outline"].left=true;break;case"blackandwhite":break;case"donotdisplayzeros":break;case"displaypagebreak":break;case"rowcolheadings":break;case"donotdisplayoutline":break;case"noorientation":break;case"allowusepivottables":break;case"zeroheight":break;case"viewablerange":break;case"selection":break;case"protectcontents":break;default:ne=false;}break;case"pivottable":;case"pivotcache":switch(f[3]){case"immediateitemsondrop":break;case"showpagemultipleitemlabel":break;case"compactrowindent":break;case"location":break;case"pivotfield":break;case"orientation":break;case"layoutform":break;case"layoutsubtotallocation":break;case"layoutcompactrow":break;case"position":break;case"pivotitem":break;case"datatype":break;case"datafield":break;case"sourcename":break;case"parentfield":break;case"ptlineitems":break;case"ptlineitem":break;case"countofsameitems":break;case"item":break;case"itemtype":break;case"ptsource":break;case"cacheindex":break;case"consolidationreference":break;case"filename":break;case"reference":break;case"nocolumngrand":break;case"norowgrand":break;case"blanklineafteritems":break;case"hidden":break;case"subtotal":break;case"basefield":break;case"mapchilditems":break;case"function":break;case"refreshonfileopen":break;case"printsettitles":break;case"mergelabels":break;case"defaultversion":break;case"refreshname":break;case"refreshdate":break;case"refreshdatecopy":break;case"versionlastrefresh":break;case"versionlastupdate":break;case"versionupdateablemin":break;case"versionrefreshablemin":break;case"calculation":break;default:ne=false;}break;case"pagebreaks":switch(f[3]){case"colbreaks":break;case"colbreak":break;case"rowbreaks":break;case"rowbreak":break;case"colstart":break;case"colend":break;case"rowend":break;default:ne=false;}break;case"autofilter":switch(f[3]){case"autofiltercolumn":break;case"autofiltercondition":break;case"autofilterand":break;case"autofilteror":break;default:ne=false;}break;case"querytable":switch(f[3]){case"id":break;case"autoformatfont":break;case"autoformatpattern":break;case"querysource":break;case"querytype":break;case"enableredirections":break;case"refreshedinxl9":break;case"urlstring":break;case"htmltables":break;case"connection":break;case"commandtext":break;case"refreshinfo":break;case"notitles":break;case"nextid":break;case"columninfo":break;case"overwritecells":break;case"donotpromptforfile":break;case"textwizardsettings":break;case"source":break;case"number":break;case"decimal":break;case"thousandseparator":break;case"trailingminusnumbers":break;case"formatsettings":break;case"fieldtype":break;case"delimiters":break;case"tab":break;case"comma":break;case"autoformatname":break;case"versionlastedit":break;case"versionlastrefresh":break;default:ne=false;}break;case"datavalidation":switch(f[3]){case"range":break;case"type":break;case"min":break;case"max":break;case"sort":break;case"descending":break;case"order":break;case"casesensitive":break;case"value":break;case"errorstyle":break;case"errormessage":break;case"errortitle":break;case"inputmessage":break;case"inputtitle":break;case"combohide":break;case"inputhide":break;case"condition":break;case"qualifier":break;case"useblank":break;case"value1":break;case"value2":break;case"format":break;case"cellrangelist":break;default:ne=false;}break;case"sorting":;case"conditionalformatting":switch(f[3]){case"range":break;case"type":break;case"min":break;case"max":break;case"sort":break;case"descending":break;case"order":break;case"casesensitive":break;case"value":break;case"errorstyle":break;case"errormessage":break;case"errortitle":break;case"cellrangelist":break;case"inputmessage":break;case"inputtitle":break;case"combohide":break;case"inputhide":break;case"condition":break;case"qualifier":break;case"useblank":break;case"value1":break;case"value2":break;case"format":break;default:ne=false;}break;case"mapinfo":;case"schema":;case"data":switch(f[3]){case"map":break;case"entry":break;case"range":break;case"xpath":break;case"field":break;case"xsdtype":break;case"filteron":break;case"aggregate":break;case"elementtype":break;case"attributetype":break;case"schema":;case"element":;case"complextype":;case"datatype":;case"all":;case"attribute":;case"extends":break;case"row":break;default:ne=false;}break;case"smarttags":break;default:ne=false;break;}if(ne)break;if(f[3].match(/!\[CDATA/))break;if(!l[l.length-1][1])throw"Unrecognized tag: "+f[3]+"|"+l.join("|");if(l[l.length-1][0]==="customdocumentproperties"){if(f[0].slice(-2)==="/>")break;else if(f[1]==="/")wp(R,Y,N,a.slice(F,f.index));else{N=f;F=f.index+f[0].length}break}if(t.WTF)throw"Unrecognized tag: "+f[3]+"|"+l.join("|");}var se={};if(!t.bookSheets&&!t.bookProps)se.Sheets=u;se.SheetNames=h;se.Workbook=$;se.SSF=D.get_table();se.Props=I;se.Custprops=R;return se}function Ap(e,r){jb(r=r||{});switch(r.type||"base64"){case"base64":return xp(g.decode(e),r);case"binary":;case"buffer":;case"file":
return xp(e,r);case"array":return xp(x(e),r);}}function yp(e,r){var t=[];if(e.Props)t.push(En(e.Props,r));if(e.Custprops)t.push(wn(e.Props,e.Custprops,r));return t.join("")}function Ip(){return""}function Rp(e,r){var t=['<Style ss:ID="Default" ss:Name="Normal"><NumberFormat/></Style>'];r.cellXfs.forEach(function(e,r){var a=[];a.push(or("NumberFormat",null,{"ss:Format":We(D._table[e.numFmtId])}));var n={"ss:ID":"s"+(21+r)};t.push(or("Style",a.join(""),n))});return or("Styles",t.join(""))}function Fp(e){return or("NamedRange",null,{"ss:Name":e.Name,"ss:RefersTo":"="+lc(e.Ref,{r:0,c:0})})}function Dp(e){if(!((e||{}).Workbook||{}).Names)return"";var r=e.Workbook.Names;var t=[];for(var a=0;a<r.length;++a){var n=r[a];if(n.Sheet!=null)continue;if(n.Name.match(/^_xlfn\./))continue;t.push(Fp(n))}return or("Names",t.join(""))}function Op(e,r,t,a){if(!e)return"";if(!((a||{}).Workbook||{}).Names)return"";var n=a.Workbook.Names;var i=[];for(var s=0;s<n.length;++s){var f=n[s];if(f.Sheet!=t)continue;if(f.Name.match(/^_xlfn\./))continue;i.push(Fp(f))}return i.join("")}function Pp(e,r,t,a){if(!e)return"";var n=[];if(e["!margins"]){n.push("<PageSetup>");if(e["!margins"].header)n.push(or("Header",null,{"x:Margin":e["!margins"].header}));if(e["!margins"].footer)n.push(or("Footer",null,{"x:Margin":e["!margins"].footer}));n.push(or("PageMargins",null,{"x:Bottom":e["!margins"].bottom||"0.75","x:Left":e["!margins"].left||"0.7","x:Right":e["!margins"].right||"0.7","x:Top":e["!margins"].top||"0.75"}));n.push("</PageSetup>")}if(a&&a.Workbook&&a.Workbook.Sheets&&a.Workbook.Sheets[t]){if(a.Workbook.Sheets[t].Hidden)n.push(or("Visible",a.Workbook.Sheets[t].Hidden==1?"SheetHidden":"SheetVeryHidden",{}));else{for(var i=0;i<t;++i)if(a.Workbook.Sheets[i]&&!a.Workbook.Sheets[i].Hidden)break;if(i==t)n.push("<Selected/>")}}if(((((a||{}).Workbook||{}).Views||[])[0]||{}).RTL)n.push("<DisplayRightToLeft/>");if(e["!protect"]){n.push(fr("ProtectContents","True"));if(e["!protect"].objects)n.push(fr("ProtectObjects","True"));if(e["!protect"].scenarios)n.push(fr("ProtectScenarios","True"));if(e["!protect"].selectLockedCells!=null&&!e["!protect"].selectLockedCells)n.push(fr("EnableSelection","NoSelection"));else if(e["!protect"].selectUnlockedCells!=null&&!e["!protect"].selectUnlockedCells)n.push(fr("EnableSelection","UnlockedCells"));[["formatCells","AllowFormatCells"],["formatColumns","AllowSizeCols"],["formatRows","AllowSizeRows"],["insertColumns","AllowInsertCols"],["insertRows","AllowInsertRows"],["insertHyperlinks","AllowInsertHyperlinks"],["deleteColumns","AllowDeleteCols"],["deleteRows","AllowDeleteRows"],["sort","AllowSort"],["autoFilter","AllowFilter"],["pivotTables","AllowUsePivotTables"]].forEach(function(r){if(e["!protect"][r[0]])n.push("<"+r[1]+"/>")})}if(n.length==0)return"";return or("WorksheetOptions",n.join(""),{xmlns:dr.x})}function Np(e){return e.map(function(e){var r=$e(e.t||"");var t=or("ss:Data",r,{xmlns:"http://www.w3.org/TR/REC-html40"});return or("Comment",t,{"ss:Author":e.a})}).join("")}function Mp(e,r,t,a,n,i,s){if(!e||e.v==undefined&&e.f==undefined)return"";var f={};if(e.f)f["ss:Formula"]="="+We(lc(e.f,s));if(e.F&&e.F.slice(0,r.length)==r){var l=bt(e.F.slice(r.length+1));f["ss:ArrayRange"]="RC:R"+(l.r==s.r?"":"["+(l.r-s.r)+"]")+"C"+(l.c==s.c?"":"["+(l.c-s.c)+"]")}if(e.l&&e.l.Target){f["ss:HRef"]=We(e.l.Target);if(e.l.Tooltip)f["x:HRefScreenTip"]=We(e.l.Tooltip)}if(t["!merges"]){var o=t["!merges"];for(var c=0;c!=o.length;++c){if(o[c].s.c!=s.c||o[c].s.r!=s.r)continue;if(o[c].e.c>o[c].s.c)f["ss:MergeAcross"]=o[c].e.c-o[c].s.c;if(o[c].e.r>o[c].s.r)f["ss:MergeDown"]=o[c].e.r-o[c].s.r}}var u="",h="";switch(e.t){case"z":if(!a.sheetStubs)return"";break;case"n":u="Number";h=String(e.v);break;case"b":u="Boolean";h=e.v?"1":"0";break;case"e":u="Error";h=ya[e.v];break;case"d":u="DateTime";h=new Date(e.v).toISOString();if(e.z==null)e.z=e.z||D._table[14];break;case"s":u="String";h=ze(e.v||"");break;}var d=bh(a.cellXfs,e,a);f["ss:StyleID"]="s"+(21+d);f["ss:Index"]=s.c+1;var v=e.v!=null?h:"";var p=e.t=="z"?"":'<Data ss:Type="'+u+'">'+v+"</Data>";if((e.c||[]).length>0)p+=Np(e.c);return or("Cell",p,f)}function Lp(e,r){var t='<Row ss:Index="'+(e+1)+'"';if(r){if(r.hpt&&!r.hpx)r.hpx=xl(r.hpt);if(r.hpx)t+=' ss:AutoFitHeight="0" ss:Height="'+r.hpx+'"';if(r.hidden)t+=' ss:Hidden="1"'}return t+">"}function Up(e,r,t,a){if(!e["!ref"])return"";var n=wt(e["!ref"]);var i=e["!merges"]||[],s=0;var f=[];if(e["!cols"])e["!cols"].forEach(function(e,r){Bl(e);var t=!!e.width;var a=vh(r,e);var n={"ss:Index":r+1};if(t)n["ss:Width"]=gl(a.width);if(e.hidden)n["ss:Hidden"]="1";f.push(or("Column",null,n))});var l=Array.isArray(e);for(var o=n.s.r;o<=n.e.r;++o){var c=[Lp(o,(e["!rows"]||[])[o])];for(var u=n.s.c;u<=n.e.c;++u){var h=false;for(s=0;s!=i.length;++s){if(i[s].s.c>u)continue;if(i[s].s.r>o)continue;if(i[s].e.c<u)continue;if(i[s].e.r<o)continue;if(i[s].s.c!=u||i[s].s.r!=o)h=true;break}if(h)continue;var d={r:o,c:u};var v=mt(d),p=l?(e[o]||[])[u]:e[v];c.push(Mp(p,v,e,r,t,a,d))}c.push("</Row>");if(c.length>2)f.push(c.join(""))}return f.join("")}function Hp(e,r,t){var a=[];var n=t.SheetNames[e];var i=t.Sheets[n];var s=i?Op(i,r,e,t):"";if(s.length>0)a.push("<Names>"+s+"</Names>");s=i?Up(i,r,e,t):"";if(s.length>0)a.push("<Table>"+s+"</Table>");a.push(Pp(i,r,e,t));return a.join("")}function Wp(e,r){if(!r)r={};if(!e.SSF)e.SSF=D.get_table();if(e.SSF){O(D);D.load_table(e.SSF);r.revssf=J(e.SSF);r.revssf[e.SSF[65535]]=0;r.ssf=e.SSF;r.cellXfs=[];bh(r.cellXfs,{},{revssf:{General:0}})}var t=[];t.push(yp(e,r));t.push(Ip(e,r));t.push("");t.push("");for(var a=0;a<e.SheetNames.length;++a)t.push(or("Worksheet",Hp(a,r,e),{"ss:Name":We(e.SheetNames[a])}));t[2]=Rp(e,r);t[3]=Dp(e,r);return ye+or("Workbook",t.join(""),{xmlns:dr.ss,"xmlns:o":dr.o,"xmlns:x":dr.x,"xmlns:ss":dr.ss,"xmlns:dt":dr.dt,"xmlns:html":dr.html})}function Vp(e){var r={};var t=e.content;t.l=28;r.AnsiUserType=t._R(0,"lpstr-ansi");r.AnsiClipboardFormat=ia(t);if(t.length-t.l<=4)return r;var a=t._R(4);if(a==0||a>40)return r;t.l-=4;r.Reserved1=t._R(0,"lpstr-ansi");if(t.length-t.l<=4)return r;a=t._R(4);if(a!==1907505652)return r;r.UnicodeClipboardFormat=sa(t);a=t._R(4);if(a==0||a>40)return r;t.l-=4;r.Reserved2=t._R(0,"lpwstr")}function Xp(e,r,t,a){var n=t;var i=[];var s=r.slice(r.l,r.l+n);if(a&&a.enc&&a.enc.insitu&&s.length>0)switch(e.n){case"BOF":;case"FilePass":;case"FileLock":;case"InterfaceHdr":;case"RRDInfo":;case"RRDHead":;case"UsrExcl":;case"EOF":break;case"BoundSheet8":break;default:a.enc.insitu(s);}i.push(s);r.l+=n;var f=eb[Lr(r,r.l)];var l=0;while(f!=null&&f.n.slice(0,8)==="Continue"){n=Lr(r,r.l+2);l=r.l+4;if(f.n=="ContinueFrt")l+=4;else if(f.n.slice(0,11)=="ContinueFrt"){l+=12}s=r.slice(l,r.l+4+n);i.push(s);r.l+=4+n;f=eb[Lr(r,r.l)]}var o=I(i);Yr(o,0);var c=0;o.lens=[];for(var u=0;u<i.length;++u){o.lens.push(c);c+=i[u].length}if(o.length<t)throw"XLS Record "+(e&&e.n||"??")+" Truncated: "+o.length+" < "+t;return e.f(o,o.length,a)}function Gp(e,r,t){if(e.t==="z")return;if(!e.XF)return;var a=0;try{a=e.z||e.XF.numFmtId||0;if(r.cellNF)e.z=D._table[a]}catch(n){if(r.WTF)throw n}if(!r||r.cellText!==false)try{if(e.t==="e"){e.w=e.w||ya[e.v]}else if(a===0||a=="General"){if(e.t==="n"){if((e.v|0)===e.v)e.w=D._general_int(e.v);else e.w=D._general_num(e.v)}else e.w=D._general(e.v)}else e.w=D.format(a,e.v,{date1904:!!t,dateNF:r&&r.dateNF})}catch(n){if(r.WTF)throw n}if(r.cellDates&&a&&e.t=="n"&&D.is_date(D._table[a]||String(a))){var i=D.parse_date_code(e.v);if(i){e.t="d";e.v=new Date(i.y,i.m-1,i.d,i.H,i.M,i.S,i.u)}}}function zp(e,r,t){return{v:e,ixfe:r,t:t}}function jp(e,r){var t={opts:{}};var a={};if(b!=null&&r.dense==null)r.dense=b;var n=r.dense?[]:{};var i={};var s={};var f=null;var o=[];var c="";var u={};var h,d="",v,p,m,g;var E={};var w=[];var k;var S;var B=[];var C=[];var T={Sheets:[],WBProps:{date1904:false},Views:[{}]},_={};var x=function ge(e){if(e<8)return Aa[e];if(e<64)return C[e-8]||Aa[e];return Aa[e]};var A=function Ee(e,r,t){var a=r.XF.data;if(!a||!a.patternType||!t||!t.cellStyles)return;r.s={};r.s.patternType=a.patternType;var n;if(n=cl(x(a.icvFore))){r.s.fgColor={rgb:n}}if(n=cl(x(a.icvBack))){r.s.bgColor={rgb:n}}};var y=function we(e,r,t){if(V>1)return;if(t.sheetRows&&e.r>=t.sheetRows)return;if(t.cellStyles&&r.XF&&r.XF.data)A(e,r,t);delete r.ixfe;delete r.XF;h=e;d=mt(e);if(!s||!s.s||!s.e)s={s:{r:0,c:0},e:{r:0,c:0}};if(e.r<s.s.r)s.s.r=e.r;if(e.c<s.s.c)s.s.c=e.c;if(e.r+1>s.e.r)s.e.r=e.r+1;if(e.c+1>s.e.c)s.e.c=e.c+1;if(t.cellFormula&&r.f){for(var a=0;a<w.length;++a){if(w[a][0].s.c>e.c||w[a][0].s.r>e.r)continue;if(w[a][0].e.c<e.c||w[a][0].e.r<e.r)continue;r.F=Et(w[a][0]);if(w[a][0].s.c!=e.c||w[a][0].s.r!=e.r)delete r.f;if(r.f)r.f=""+Vu(w[a][1],s,e,H,I);break}}{if(t.dense){if(!n[e.r])n[e.r]=[];n[e.r][e.c]=r}else n[d]=r}};var I={enc:false,sbcch:0,snames:[],sharedf:E,arrayf:w,rrtabid:[],lastuser:"",biff:8,codepage:0,winlocked:0,cellStyles:!!r&&!!r.cellStyles,WTF:!!r&&!!r.wtf};if(r.password)I.password=r.password;var R;var F=[];var O=[];var P=[],N=[];var M=0,L=0;var U=false;var H=[];H.SheetNames=I.snames;H.sharedf=I.sharedf;H.arrayf=I.arrayf;H.names=[];H.XTI=[];var W="";var V=0;var X=0,G=[];var z=[];var j;I.codepage=1200;l(1200);var $=false;while(e.l<e.length-1){var Y=e.l;var Q=e._R(2);if(Q===0&&W==="EOF")break;var J=e.l===e.length?0:e._R(2);var Z=eb[Q];if(Z&&Z.f){if(r.bookSheets){if(W==="BoundSheet8"&&Z.n!=="BoundSheet8")break}W=Z.n;if(Z.r===2||Z.r==12){var q=e._R(2);J-=2;if(!I.enc&&q!==Q&&((q&255)<<8|q>>8)!==Q)throw new Error("rt mismatch: "+q+"!="+Q);if(Z.r==12){e.l+=10;J-=10}}var ee={};if(Z.n==="EOF")ee=Z.f(e,J,I);else ee=Xp(Z,e,J,I);var re=Z.n;if(V==0&&re!="BOF")continue;switch(re){case"Date1904":t.opts.Date1904=T.WBProps.date1904=ee;break;case"WriteProtect":t.opts.WriteProtect=true;break;case"FilePass":if(!I.enc)e.l=0;I.enc=ee;if(!r.password)throw new Error("File is password-protected");if(ee.valid==null)throw new Error("Encryption scheme unsupported");if(!ee.valid)throw new Error("Password is incorrect");break;case"WriteAccess":I.lastuser=ee;break;case"FileSharing":break;case"CodePage":var te=Number(ee);switch(te){case 21010:te=1200;break;case 32768:te=1e4;break;case 32769:te=1252;break;}l(I.codepage=te);$=true;break;case"RRTabId":I.rrtabid=ee;break;case"WinProtect":I.winlocked=ee;break;case"Template":break;case"BookBool":break;case"UsesELFs":break;case"MTRSettings":break;case"RefreshAll":;case"CalcCount":;case"CalcDelta":;case"CalcIter":;case"CalcMode":;case"CalcPrecision":;case"CalcSaveRecalc":t.opts[re]=ee;break;case"CalcRefMode":I.CalcRefMode=ee;break;case"Uncalced":break;case"ForceFullCalculation":t.opts.FullCalc=ee;break;case"WsBool":if(ee.fDialog)n["!type"]="dialog";if(!ee.fBelow)(n["!outline"]||(n["!outline"]={})).above=true;if(!ee.fRight)(n["!outline"]||(n["!outline"]={})).left=true;break;case"XF":B.push(ee);break;case"ExtSST":break;case"BookExt":break;case"RichTextStream":break;case"BkHim":break;case"SupBook":H.push([ee]);H[H.length-1].XTI=[];break;case"ExternName":H[H.length-1].push(ee);break;case"Index":break;case"Lbl":j={Name:ee.Name,Ref:Vu(ee.rgce,s,null,H,I)};if(ee.itab>0)j.Sheet=ee.itab-1;H.names.push(j);if(!H[0]){H[0]=[];H[0].XTI=[]}H[H.length-1].push(ee);if(ee.Name=="_xlnm._FilterDatabase"&&ee.itab>0)if(ee.rgce&&ee.rgce[0]&&ee.rgce[0][0]&&ee.rgce[0][0][0]=="PtgArea3d")z[ee.itab-1]={ref:Et(ee.rgce[0][0][1][2])};break;case"ExternCount":I.ExternCount=ee;break;case"ExternSheet":if(H.length==0){H[0]=[];H[0].XTI=[]}H[H.length-1].XTI=H[H.length-1].XTI.concat(ee);H.XTI=H.XTI.concat(ee);break;case"NameCmt":if(I.biff<8)break;if(j!=null)j.Comment=ee[1];break;case"Protect":n["!protect"]=ee;break;case"Password":if(ee!==0&&I.WTF)console.error("Password verifier: "+ee);break;case"Prot4Rev":;case"Prot4RevPass":break;case"BoundSheet8":{i[ee.pos]=ee;I.snames.push(ee.name)}break;case"EOF":{if(--V)break;if(s.e){if(s.e.r>0&&s.e.c>0){s.e.r--;s.e.c--;n["!ref"]=Et(s);if(r.sheetRows&&r.sheetRows<=s.e.r){var ae=s.e.r;s.e.r=r.sheetRows-1;n["!fullref"]=n["!ref"];n["!ref"]=Et(s);s.e.r=ae}s.e.r++;s.e.c++}if(F.length>0)n["!merges"]=F;if(O.length>0)n["!objects"]=O;if(P.length>0)n["!cols"]=P;if(N.length>0)n["!rows"]=N;T.Sheets.push(_)}if(c==="")u=n;else a[c]=n;n=r.dense?[]:{}}break;case"BOF":{if(I.biff===8)I.biff={9:2,521:3,1033:4}[Q]||{512:2,768:3,1024:4,1280:5,1536:8,2:2,7:2}[ee.BIFFVer]||8;I.biffguess=ee.BIFFVer==0;if(ee.BIFFVer==0&&ee.dt==4096){I.biff=5;$=true;l(I.codepage=28591)}if(I.biff==8&&ee.BIFFVer==0&&ee.dt==16)I.biff=2;if(V++)break;n=r.dense?[]:{};if(I.biff<8&&!$){$=true;l(I.codepage=r.codepage||1252)}if(I.biff<5||ee.BIFFVer==0&&ee.dt==4096){if(c==="")c="Sheet1";s={s:{r:0,c:0},e:{r:0,c:0}};var ne={pos:e.l-J,name:c};i[ne.pos]=ne;I.snames.push(c)}else c=(i[Y]||{name:""}).name;if(ee.dt==32)n["!type"]="chart";if(ee.dt==64)n["!type"]="macro";F=[];O=[];I.arrayf=w=[];P=[];N=[];M=L=0;U=false;_={Hidden:(i[Y]||{hs:0}).hs,name:c}}break;case"Number":;case"BIFF2NUM":;case"BIFF2INT":{if(n["!type"]=="chart")if(r.dense?(n[ee.r]||[])[ee.c]:n[mt({c:ee.c,r:ee.r})])++ee.c;k={ixfe:ee.ixfe,XF:B[ee.ixfe]||{},v:ee.val,t:"n"};if(X>0)k.z=G[k.ixfe>>8&63];Gp(k,r,t.opts.Date1904);y({c:ee.c,r:ee.r},k,r)}break;case"BoolErr":{k={ixfe:ee.ixfe,XF:B[ee.ixfe],v:ee.val,t:ee.t};if(X>0)k.z=G[k.ixfe>>8&63];Gp(k,r,t.opts.Date1904);y({c:ee.c,r:ee.r},k,r)}break;case"RK":{k={ixfe:ee.ixfe,XF:B[ee.ixfe],v:ee.rknum,t:"n"};if(X>0)k.z=G[k.ixfe>>8&63];Gp(k,r,t.opts.Date1904);y({c:ee.c,r:ee.r},k,r)}break;case"MulRk":{for(var ie=ee.c;ie<=ee.C;++ie){var se=ee.rkrec[ie-ee.c][0];k={ixfe:se,XF:B[se],v:ee.rkrec[ie-ee.c][1],t:"n"};if(X>0)k.z=G[k.ixfe>>8&63];Gp(k,r,t.opts.Date1904);y({c:ie,r:ee.r},k,r)}}break;case"Formula":{if(ee.val=="String"){f=ee;break}k=zp(ee.val,ee.cell.ixfe,ee.tt);k.XF=B[k.ixfe];if(r.cellFormula){var fe=ee.formula;if(fe&&fe[0]&&fe[0][0]&&fe[0][0][0]=="PtgExp"){var le=fe[0][0][1][0],oe=fe[0][0][1][1];var ce=mt({r:le,c:oe});if(E[ce])k.f=""+Vu(ee.formula,s,ee.cell,H,I);else k.F=((r.dense?(n[le]||[])[oe]:n[ce])||{}).F}else k.f=""+Vu(ee.formula,s,ee.cell,H,I)}if(X>0)k.z=G[k.ixfe>>8&63];Gp(k,r,t.opts.Date1904);y(ee.cell,k,r);f=ee}break;case"String":{if(f){f.val=ee;k=zp(ee,f.cell.ixfe,"s");k.XF=B[k.ixfe];if(r.cellFormula){k.f=""+Vu(f.formula,s,f.cell,H,I)}if(X>0)k.z=G[k.ixfe>>8&63];Gp(k,r,t.opts.Date1904);y(f.cell,k,r);f=null}else throw new Error("String record expects Formula")}break;case"Array":{w.push(ee);var ue=mt(ee[0].s);v=r.dense?(n[ee[0].s.r]||[])[ee[0].s.c]:n[ue];if(r.cellFormula&&v){if(!f)break;if(!ue||!v)break;v.f=""+Vu(ee[1],s,ee[0],H,I);v.F=Et(ee[0])}}break;case"ShrFmla":{if(!r.cellFormula)break;if(d){if(!f)break;E[mt(f.cell)]=ee[0];v=r.dense?(n[f.cell.r]||[])[f.cell.c]:n[mt(f.cell)];(v||{}).f=""+Vu(ee[0],s,h,H,I)}}break;case"LabelSst":k=zp(o[ee.isst].t,ee.ixfe,"s");if(o[ee.isst].h)k.h=o[ee.isst].h;k.XF=B[k.ixfe];if(X>0)k.z=G[k.ixfe>>8&63];Gp(k,r,t.opts.Date1904);y({c:ee.c,r:ee.r},k,r);break;case"Blank":if(r.sheetStubs){k={ixfe:ee.ixfe,XF:B[ee.ixfe],t:"z"};if(X>0)k.z=G[k.ixfe>>8&63];Gp(k,r,t.opts.Date1904);y({c:ee.c,r:ee.r},k,r)}break;case"MulBlank":if(r.sheetStubs){for(var he=ee.c;he<=ee.C;++he){var de=ee.ixfe[he-ee.c];k={ixfe:de,XF:B[de],t:"z"};if(X>0)k.z=G[k.ixfe>>8&63];Gp(k,r,t.opts.Date1904);y({c:he,r:ee.r},k,r)}}break;case"RString":;case"Label":;case"BIFF2STR":k=zp(ee.val,ee.ixfe,"s");k.XF=B[k.ixfe];if(X>0)k.z=G[k.ixfe>>8&63];Gp(k,r,t.opts.Date1904);y({c:ee.c,r:ee.r},k,r);break;case"Dimensions":{if(V===1)s=ee}break;case"SST":{o=ee}break;case"Format":{if(I.biff==4){G[X++]=ee[1];for(var ve=0;ve<X+163;++ve)if(D._table[ve]==ee[1])break;if(ve>=163)D.load(ee[1],X+163)}else D.load(ee[1],ee[0])}break;case"BIFF2FORMAT":{G[X++]=ee;for(var pe=0;pe<X+163;++pe)if(D._table[pe]==ee)break;if(pe>=163)D.load(ee,X+163)}break;case"MergeCells":F=F.concat(ee);break;case"Obj":O[ee.cmo[0]]=I.lastobj=ee;break;case"TxO":I.lastobj.TxO=ee;break;case"ImData":I.lastobj.ImData=ee;break;case"HLink":{for(g=ee[0].s.r;g<=ee[0].e.r;++g)for(m=ee[0].s.c;m<=ee[0].e.c;++m){v=r.dense?(n[g]||[])[m]:n[mt({c:m,r:g})];if(v)v.l=ee[1]}}break;case"HLinkTooltip":{for(g=ee[0].s.r;g<=ee[0].e.r;++g)for(m=ee[0].s.c;m<=ee[0].e.c;++m){v=r.dense?(n[g]||[])[m]:n[mt({c:m,r:g})];if(v&&v.l)v.l.Tooltip=ee[1]}}break;case"Note":{if(I.biff<=5&&I.biff>=2)break;v=r.dense?(n[ee[0].r]||[])[ee[0].c]:n[mt(ee[0])];var be=O[ee[2]];if(!v){if(r.dense){if(!n[ee[0].r])n[ee[0].r]=[];v=n[ee[0].r][ee[0].c]={t:"z"}}else{v=n[mt(ee[0])]={t:"z"}}s.e.r=Math.max(s.e.r,ee[0].r);s.s.r=Math.min(s.s.r,ee[0].r);s.e.c=Math.max(s.e.c,ee[0].c);s.s.c=Math.min(s.s.c,ee[0].c)}if(!v.c)v.c=[];p={a:ee[1],t:be.TxO.t};v.c.push(p)}break;default:switch(Z.n){case"ClrtClient":break;case"XFExt":Do(B[ee.ixfe],ee.ext);break;case"DefColWidth":M=ee;break;case"DefaultRowHeight":L=ee[1];break;case"ColInfo":{if(!I.cellStyles)break;while(ee.e>=ee.s){P[ee.e--]={width:ee.w/256,level:ee.level||0,hidden:!!(ee.flags&1)};if(!U){U=true;Sl(ee.w/256)}Bl(P[ee.e+1])}}break;case"Row":{var me={};if(ee.level!=null){N[ee.r]=me;me.level=ee.level}if(ee.hidden){N[ee.r]=me;me.hidden=true}if(ee.hpt){N[ee.r]=me;me.hpt=ee.hpt;me.hpx=xl(ee.hpt)}}break;case"LeftMargin":;case"RightMargin":;case"TopMargin":;case"BottomMargin":if(!n["!margins"])ph(n["!margins"]={});n["!margins"][re.slice(0,-6).toLowerCase()]=ee;break;case"Selection":break;case"Setup":if(!n["!margins"])ph(n["!margins"]={});n["!margins"].header=ee.header;n["!margins"].footer=ee.footer;break;case"Window2":if(ee.RTL)T.Views[0].RTL=true;break;case"Header":break;case"Footer":break;case"HCenter":break;case"VCenter":break;case"Pls":break;case"GCW":break;case"LHRecord":break;case"DBCell":break;case"EntExU2":break;case"SxView":break;case"Sxvd":break;case"SXVI":break;case"SXVDEx":break;case"SxIvd":break;case"SXString":break;case"Sync":break;case"Addin":break;case"SXDI":break;case"SXLI":break;case"SXEx":break;case"QsiSXTag":break;case"Feat":break;case"FeatHdr":;case"FeatHdr11":break;case"Feature11":;case"Feature12":;case"List12":break;case"Country":S=ee;break;case"RecalcId":break;case"DxGCol":break;case"Fbi":;case"Fbi2":;case"GelFrame":break;case"Font":break;case"XFCRC":break;case"Style":break;case"StyleExt":break;case"Palette":C=ee;break;case"Theme":R=ee;break;case"ScenarioProtect":break;case"ObjProtect":break;case"CondFmt12":break;case"Table":break;case"TableStyles":break;case"TableStyle":break;case"TableStyleElement":break;case"SXStreamID":break;case"SXVS":break;case"DConRef":break;case"SXAddl":break;case"DConBin":break;case"DConName":break;case"SXPI":break;case"SxFormat":break;case"SxSelect":break;case"SxRule":break;case"SxFilt":break;case"SxItm":break;case"SxDXF":break;case"ScenMan":break;case"DCon":break;case"CellWatch":break;case"PrintRowCol":break;case"PrintGrid":break;case"PrintSize":break;case"XCT":break;case"CRN":break;case"Scl":{}break;case"SheetExt":{}break;case"SheetExtOptional":{}break;case"ObNoMacros":{}break;case"ObProj":{}break;case"CodeName":{if(!c)T.WBProps.CodeName=ee||"ThisWorkbook";else _.CodeName=ee||_.name}break;case"GUIDTypeLib":{}break;case"WOpt":break;case"PhoneticInfo":break;case"OleObjectSize":break;case"DXF":;case"DXFN":;case"DXFN12":;case"DXFN12List":;case"DXFN12NoCB":break;case"Dv":;case"DVal":break;case"BRAI":;case"Series":;case"SeriesText":break;case"DConn":break;case"DbOrParamQry":break;case"DBQueryExt":break;case"OleDbConn":break;case"ExtString":break;case"IFmtRecord":break;case"CondFmt":;case"CF":;case"CF12":;case"CFEx":break;case"Excel9File":break;case"Units":break;case"InterfaceHdr":;case"Mms":;case"InterfaceEnd":;case"DSF":break;case"BuiltInFnGroupCount":break;case"Window1":;case"HideObj":;case"GridSet":;case"Guts":;case"UserBView":;case"UserSViewBegin":;case"UserSViewEnd":break;case"Pane":break;default:switch(Z.n){case"Dat":;case"Begin":;case"End":;case"StartBlock":;case"EndBlock":;case"Frame":;case"Area":;case"Axis":;case"AxisLine":;case"Tick":break;case"AxesUsed":;case"CrtLayout12":;case"CrtLayout12A":;case"CrtLink":;case"CrtLine":;case"CrtMlFrt":;case"CrtMlFrtContinue":break;case"LineFormat":;case"AreaFormat":;case"Chart":;case"Chart3d":;case"Chart3DBarShape":;case"ChartFormat":;case"ChartFrtInfo":break;case"PlotArea":;case"PlotGrowth":break;case"SeriesList":;case"SerParent":;case"SerAuxTrend":break;case"DataFormat":;case"SerToCrt":;case"FontX":break;case"CatSerRange":;case"AxcExt":;case"SerFmt":break;case"ShtProps":break;case"DefaultText":;case"Text":;case"CatLab":break;case"DataLabExtContents":break;case"Legend":;case"LegendException":break;case"Pie":;case"Scatter":break;case"PieFormat":;case"MarkerFormat":break;case"StartObject":;case"EndObject":break;case"AlRuns":;case"ObjectLink":break;case"SIIndex":break;case"AttachedLabel":;case"YMult":break;case"Line":;case"Bar":break;case"Surf":break;case"AxisParent":break;case"Pos":break;case"ValueRange":break;case"SXViewEx9":break;case"SXViewLink":break;case"PivotChartBits":break;case"SBaseRef":break;case"TextPropsStream":break;case"LnExt":break;case"MkrExt":break;case"CrtCoopt":break;case"Qsi":;case"Qsif":;case"Qsir":;case"QsiSXTag":break;case"TxtQry":break;case"FilterMode":break;case"AutoFilter":;case"AutoFilterInfo":break;case"AutoFilter12":break;case"DropDownObjIds":break;case"Sort":break;case"SortData":break;case"ShapePropsStream":break;case"MsoDrawing":;case"MsoDrawingGroup":;case"MsoDrawingSelection":break;case"WebPub":;case"AutoWebPub":break;case"HeaderFooter":;case"HFPicture":;case"PLV":;case"HorizontalPageBreaks":;case"VerticalPageBreaks":break;case"Backup":;case"CompressPictures":;case"Compat12":break;case"Continue":;case"ContinueFrt12":break;case"FrtFontList":;case"FrtWrapper":break;default:switch(Z.n){case"TabIdConf":;case"Radar":;case"RadarArea":;case"DropBar":;case"Intl":;case"CoordList":;case"SerAuxErrBar":break;case"BIFF2FONTCLR":;case"BIFF2FMTCNT":;case"BIFF2FONTXTRA":break;case"BIFF2XF":;case"BIFF3XF":;case"BIFF4XF":break;case"BIFF2XFINDEX":break;case"BIFF4FMTCNT":;case"BIFF2ROW":;case"BIFF2WINDOW2":break;case"SCENARIO":;case"DConBin":;case"PicF":;case"DataLabExt":;case"Lel":;case"BopPop":;case"BopPopCustom":;case"RealTimeData":;case"Name":break;case"LHNGraph":;case"FnGroupName":;case"AddMenu":;case"LPr":break;case"ListObj":;case"ListField":break;case"RRSort":break;case"BigName":break;case"ToolbarHdr":;case"ToolbarEnd":break;case"DDEObjName":break;case"FRTArchId$":break;default:if(r.WTF)throw"Unrecognized Record "+Z.n;};};};}}else e.l+=J}t.SheetNames=K(i).sort(function(e,r){return Number(e)-Number(r)}).map(function(e){return i[e].name});if(!r.bookSheets)t.Sheets=a;if(!t.SheetNames.length&&u["!ref"]){t.SheetNames.push("Sheet1");if(t.Sheets)t.Sheets["Sheet1"]=u}else t.Preamble=u;if(t.Sheets)z.forEach(function(e,r){t.Sheets[t.SheetNames[r]]["!autofilter"]=e});t.Strings=o;t.SSF=D.get_table();if(I.enc)t.Encryption=I.enc;if(R)t.Themes=R;t.Metadata={};if(S!==undefined)t.Metadata.Country=S;if(H.names.length>0)T.Names=H.names;t.Workbook=T;return t}var $p={SI:"e0859ff2f94f6810ab9108002b27b3d9",DSI:"02d5cdd59c2e1b10939708002b2cf9ae",UDI:"05d5cdd59c2e1b10939708002b2cf9ae"};function Kp(e,r,t){var a=V.find(e,"!DocumentSummaryInformation");if(a&&a.size>0)try{var n=Wn(a,wa,$p.DSI);for(var i in n)r[i]=n[i]}catch(s){if(t.WTF)throw s}var f=V.find(e,"!SummaryInformation");if(f&&f.size>0)try{var l=Wn(f,ka,$p.SI);for(var o in l)if(r[o]==null)r[o]=l[o]}catch(s){if(t.WTF)throw s}if(r.HeadingPairs&&r.TitlesOfParts){ln(r.HeadingPairs,r.TitlesOfParts,r,t);delete r.HeadingPairs;delete r.TitlesOfParts}}function Yp(e,r){var t=[],a=[],n=[];var i=0,s;if(e.Props){s=K(e.Props);for(i=0;i<s.length;++i)(Object.prototype.hasOwnProperty.call(Sa,s[i])?t:Object.prototype.hasOwnProperty.call(Ba,s[i])?a:n).push([s[i],e.Props[s[i]]])}if(e.Custprops){s=K(e.Custprops);for(i=0;i<s.length;++i)if(!Object.prototype.hasOwnProperty.call(e.Props||{},s[i]))(Object.prototype.hasOwnProperty.call(Sa,s[i])?t:Object.prototype.hasOwnProperty.call(Ba,s[i])?a:n).push([s[i],e.Custprops[s[i]]])}var f=[];for(i=0;i<n.length;++i){if(Ln.indexOf(n[i][0])>-1)continue;if(n[i][1]==null)continue;f.push(n[i])}if(a.length)V.utils.cfb_add(r,"/SummaryInformation",Vn(a,$p.SI,Ba,ka));if(t.length||f.length)V.utils.cfb_add(r,"/DocumentSummaryInformation",Vn(t,$p.DSI,Sa,wa,f.length?f:null,$p.UDI))}function Qp(e,r){if(!r)r={};jb(r);o();if(r.codepage)s(r.codepage);var t,a;if(e.FullPaths){if(V.find(e,"/encryption"))throw new Error("File is password-protected");t=V.find(e,"!CompObj");a=V.find(e,"/Workbook")||V.find(e,"/Book")}else{switch(r.type){case"base64":e=T(g.decode(e));break;case"binary":e=T(e);break;case"buffer":break;case"array":if(!Array.isArray(e))e=Array.prototype.slice.call(e);break;}Yr(e,0);a={content:e}}var n;var i;if(t)Vp(t);if(r.bookProps&&!r.bookSheets)n={};else{var f=E?"buffer":"array";if(a&&a.content)n=jp(a.content,r);else if((i=V.find(e,"PerfectOffice_MAIN"))&&i.content)n=wf.to_workbook(i.content,(r.type=f,r));else if((i=V.find(e,"NativeContent_MAIN"))&&i.content)n=wf.to_workbook(i.content,(r.type=f,r));else throw new Error("Cannot find Workbook stream");if(r.bookVBA&&e.FullPaths&&V.find(e,"/_VBA_PROJECT_CUR/VBA/dir"))n.vbaraw=qo(e)}var l={};if(e.FullPaths)Kp(e,l,r);n.Props=n.Custprops=l;if(r.bookFiles)n.cfb=e;return n}function Jp(e,r){var t=r||{};var a=V.utils.cfb_new({root:"R"});var n="/Workbook";switch(t.bookType||"xls"){case"xls":t.bookType="biff8";case"xla":if(!t.bookType)t.bookType="xla";case"biff8":n="/Workbook";t.biff=8;break;case"biff5":n="/Book";t.biff=5;break;default:throw new Error("invalid type "+t.bookType+" for XLS CFB");}V.utils.cfb_add(a,n,wb(e,t));if(t.biff==8&&(e.Props||e.Custprops))Yp(e,a);if(t.biff==8&&e.vbaraw)ec(a,V.read(e.vbaraw,{type:typeof e.vbaraw=="string"?"binary":"buffer"}));return a}var Zp={0:{n:"BrtRowHdr",f:qh},1:{n:"BrtCellBlank",f:fd},2:{n:"BrtCellRk",f:xd},3:{n:"BrtCellError",f:pd},4:{n:"BrtCellBool",f:ud},5:{n:"BrtCellReal",f:Bd},6:{n:"BrtCellSt",f:Rd},7:{n:"BrtCellIsst",f:Ed},8:{n:"BrtFmlaString",f:Ld},9:{n:"BrtFmlaNum",f:Md},10:{n:"BrtFmlaBool",f:Pd},11:{n:"BrtFmlaError",f:Nd},12:{n:"BrtShortBlank",f:od},13:{n:"BrtShortRk",f:yd},14:{n:"BrtShortError",f:md},15:{n:"BrtShortBool",f:dd},16:{n:"BrtShortReal",f:Td},17:{n:"BrtShortSt",f:Dd},18:{n:"BrtShortIsst",f:kd},19:{n:"BrtSSTItem",f:Rt},20:{n:"BrtPCDIMissing"},21:{n:"BrtPCDINumber"},22:{n:"BrtPCDIBoolean"},23:{n:"BrtPCDIError"},24:{n:"BrtPCDIString"},25:{n:"BrtPCDIDatetime"},26:{n:"BrtPCDIIndex"},27:{n:"BrtPCDIAMissing"},28:{n:"BrtPCDIANumber"},29:{n:"BrtPCDIABoolean"},30:{n:"BrtPCDIAError"},31:{n:"BrtPCDIAString"},32:{n:"BrtPCDIADatetime"},33:{n:"BrtPCRRecord"},34:{n:"BrtPCRRecordDt"},35:{n:"BrtFRTBegin"},36:{n:"BrtFRTEnd"},37:{n:"BrtACBegin"},38:{n:"BrtACEnd"},39:{n:"BrtName",f:zv},40:{n:"BrtIndexRowBlock"},42:{n:"BrtIndexBlock"},43:{n:"BrtFont",f:Xl},44:{n:"BrtFmt",f:Wl},45:{n:"BrtFill",f:$l},46:{n:"BrtBorder",f:Zl},47:{n:"BrtXF",f:Yl},48:{n:"BrtStyle"},49:{n:"BrtCellMeta"},50:{n:"BrtValueMeta"},51:{n:"BrtMdb"},52:{n:"BrtBeginFmd"},53:{n:"BrtEndFmd"},54:{n:"BrtBeginMdx"},55:{n:"BrtEndMdx"},56:{n:"BrtBeginMdxTuple"},57:{n:"BrtEndMdxTuple"},58:{n:"BrtMdxMbrIstr"},59:{n:"BrtStr"},60:{n:"BrtColInfo",f:Qs},62:{n:"BrtCellRString"},63:{n:"BrtCalcChainItem$",f:Po},64:{n:"BrtDVal",f:rv},65:{n:"BrtSxvcellNum"},66:{n:"BrtSxvcellStr"},67:{n:"BrtSxvcellBool"},68:{n:"BrtSxvcellErr"},69:{n:"BrtSxvcellDate"},70:{n:"BrtSxvcellNil"},128:{n:"BrtFileVersion"},129:{n:"BrtBeginSheet"},130:{n:"BrtEndSheet"},131:{n:"BrtBeginBook",f:Qr,p:0},132:{n:"BrtEndBook"},133:{n:"BrtBeginWsViews"},134:{n:"BrtEndWsViews"},135:{n:"BrtBeginBookViews"},136:{n:"BrtEndBookViews"},137:{n:"BrtBeginWsView",f:Jd},138:{n:"BrtEndWsView"},139:{n:"BrtBeginCsViews"},140:{n:"BrtEndCsViews"},141:{n:"BrtBeginCsView"},142:{n:"BrtEndCsView"},143:{n:"BrtBeginBundleShs"},144:{n:"BrtEndBundleShs"},145:{n:"BrtBeginSheetData"},146:{n:"BrtEndSheetData"},147:{n:"BrtWsProp",f:id},148:{n:"BrtWsDim",f:td,p:16},151:{n:"BrtPane",f:Gd},152:{n:"BrtSel"},153:{n:"BrtWbProp",f:Vv},154:{n:"BrtWbFactoid"},155:{n:"BrtFileRecover"},156:{n:"BrtBundleSh",f:Hv},157:{n:"BrtCalcProp"},158:{n:"BrtBookView"},159:{n:"BrtBeginSst",f:Of},160:{n:"BrtEndSst"},161:{n:"BrtBeginAFilter",f:Qt},162:{n:"BrtEndAFilter"},163:{n:"BrtBeginFilterColumn"},164:{n:"BrtEndFilterColumn"},165:{n:"BrtBeginFilters"},166:{n:"BrtEndFilters"},167:{n:"BrtFilter"},168:{n:"BrtColorFilter"},169:{n:"BrtIconFilter"},170:{n:"BrtTop10Filter"},171:{n:"BrtDynamicFilter"},172:{n:"BrtBeginCustomFilters"},173:{n:"BrtEndCustomFilters"},174:{n:"BrtCustomFilter"},175:{n:"BrtAFilterDateGroupItem"},176:{n:"BrtMergeCell",f:Ud},177:{n:"BrtBeginMergeCells"},178:{n:"BrtEndMergeCells"},179:{n:"BrtBeginPivotCacheDef"},180:{n:"BrtEndPivotCacheDef"},181:{n:"BrtBeginPCDFields"},182:{n:"BrtEndPCDFields"},183:{n:"BrtBeginPCDField"},184:{n:"BrtEndPCDField"},185:{n:"BrtBeginPCDSource"},186:{n:"BrtEndPCDSource"},187:{n:"BrtBeginPCDSRange"},188:{n:"BrtEndPCDSRange"},189:{n:"BrtBeginPCDFAtbl"},190:{n:"BrtEndPCDFAtbl"},191:{n:"BrtBeginPCDIRun"},192:{n:"BrtEndPCDIRun"},193:{n:"BrtBeginPivotCacheRecords"},194:{n:"BrtEndPivotCacheRecords"},195:{n:"BrtBeginPCDHierarchies"},196:{n:"BrtEndPCDHierarchies"},197:{n:"BrtBeginPCDHierarchy"},198:{n:"BrtEndPCDHierarchy"},199:{n:"BrtBeginPCDHFieldsUsage"},200:{n:"BrtEndPCDHFieldsUsage"},201:{n:"BrtBeginExtConnection"},202:{n:"BrtEndExtConnection"},203:{n:"BrtBeginECDbProps"},204:{n:"BrtEndECDbProps"},205:{n:"BrtBeginECOlapProps"},206:{n:"BrtEndECOlapProps"},207:{n:"BrtBeginPCDSConsol"},208:{n:"BrtEndPCDSConsol"},209:{n:"BrtBeginPCDSCPages"},210:{n:"BrtEndPCDSCPages"},211:{n:"BrtBeginPCDSCPage"},212:{n:"BrtEndPCDSCPage"},213:{n:"BrtBeginPCDSCPItem"},214:{n:"BrtEndPCDSCPItem"},215:{n:"BrtBeginPCDSCSets"},216:{n:"BrtEndPCDSCSets"},217:{n:"BrtBeginPCDSCSet"},218:{n:"BrtEndPCDSCSet"},219:{n:"BrtBeginPCDFGroup"},220:{n:"BrtEndPCDFGroup"},221:{n:"BrtBeginPCDFGItems"},222:{n:"BrtEndPCDFGItems"},223:{n:"BrtBeginPCDFGRange"},224:{n:"BrtEndPCDFGRange"},225:{n:"BrtBeginPCDFGDiscrete"},226:{n:"BrtEndPCDFGDiscrete"},227:{n:"BrtBeginPCDSDTupleCache"},228:{n:"BrtEndPCDSDTupleCache"},229:{n:"BrtBeginPCDSDTCEntries"},230:{n:"BrtEndPCDSDTCEntries"},231:{n:"BrtBeginPCDSDTCEMembers"},232:{n:"BrtEndPCDSDTCEMembers"},233:{n:"BrtBeginPCDSDTCEMember"},234:{n:"BrtEndPCDSDTCEMember"},235:{n:"BrtBeginPCDSDTCQueries"},236:{n:"BrtEndPCDSDTCQueries"},237:{n:"BrtBeginPCDSDTCQuery"},238:{n:"BrtEndPCDSDTCQuery"},239:{n:"BrtBeginPCDSDTCSets"},240:{n:"BrtEndPCDSDTCSets"},241:{n:"BrtBeginPCDSDTCSet"},242:{n:"BrtEndPCDSDTCSet"},243:{n:"BrtBeginPCDCalcItems"},244:{n:"BrtEndPCDCalcItems"},245:{n:"BrtBeginPCDCalcItem"},246:{n:"BrtEndPCDCalcItem"},247:{n:"BrtBeginPRule"},248:{n:"BrtEndPRule"},249:{n:"BrtBeginPRFilters"},250:{n:"BrtEndPRFilters"},251:{n:"BrtBeginPRFilter"},252:{n:"BrtEndPRFilter"},253:{n:"BrtBeginPNames"},254:{n:"BrtEndPNames"},255:{n:"BrtBeginPName"},256:{n:"BrtEndPName"},257:{n:"BrtBeginPNPairs"},258:{n:"BrtEndPNPairs"},259:{n:"BrtBeginPNPair"},260:{n:"BrtEndPNPair"},261:{n:"BrtBeginECWebProps"},262:{n:"BrtEndECWebProps"},263:{n:"BrtBeginEcWpTables"},264:{n:"BrtEndECWPTables"},265:{n:"BrtBeginECParams"},266:{n:"BrtEndECParams"},267:{n:"BrtBeginECParam"},268:{n:"BrtEndECParam"},269:{n:"BrtBeginPCDKPIs"},270:{n:"BrtEndPCDKPIs"},271:{n:"BrtBeginPCDKPI"},272:{n:"BrtEndPCDKPI"},273:{n:"BrtBeginDims"},274:{n:"BrtEndDims"},275:{n:"BrtBeginDim"},276:{n:"BrtEndDim"},277:{n:"BrtIndexPartEnd"},278:{n:"BrtBeginStyleSheet"},279:{n:"BrtEndStyleSheet"},280:{n:"BrtBeginSXView"},281:{n:"BrtEndSXVI"},282:{n:"BrtBeginSXVI"},283:{n:"BrtBeginSXVIs"},284:{n:"BrtEndSXVIs"},285:{n:"BrtBeginSXVD"},286:{n:"BrtEndSXVD"},287:{n:"BrtBeginSXVDs"},288:{n:"BrtEndSXVDs"},289:{n:"BrtBeginSXPI"},290:{n:"BrtEndSXPI"},291:{n:"BrtBeginSXPIs"},292:{n:"BrtEndSXPIs"},293:{n:"BrtBeginSXDI"},294:{n:"BrtEndSXDI"},295:{n:"BrtBeginSXDIs"},296:{n:"BrtEndSXDIs"},297:{n:"BrtBeginSXLI"},298:{n:"BrtEndSXLI"},299:{n:"BrtBeginSXLIRws"},300:{n:"BrtEndSXLIRws"},301:{n:"BrtBeginSXLICols"},302:{n:"BrtEndSXLICols"},303:{n:"BrtBeginSXFormat"},304:{n:"BrtEndSXFormat"},305:{n:"BrtBeginSXFormats"},306:{n:"BrtEndSxFormats"},307:{n:"BrtBeginSxSelect"},308:{n:"BrtEndSxSelect"},309:{n:"BrtBeginISXVDRws"
},310:{n:"BrtEndISXVDRws"},311:{n:"BrtBeginISXVDCols"},312:{n:"BrtEndISXVDCols"},313:{n:"BrtEndSXLocation"},314:{n:"BrtBeginSXLocation"},315:{n:"BrtEndSXView"},316:{n:"BrtBeginSXTHs"},317:{n:"BrtEndSXTHs"},318:{n:"BrtBeginSXTH"},319:{n:"BrtEndSXTH"},320:{n:"BrtBeginISXTHRws"},321:{n:"BrtEndISXTHRws"},322:{n:"BrtBeginISXTHCols"},323:{n:"BrtEndISXTHCols"},324:{n:"BrtBeginSXTDMPS"},325:{n:"BrtEndSXTDMPs"},326:{n:"BrtBeginSXTDMP"},327:{n:"BrtEndSXTDMP"},328:{n:"BrtBeginSXTHItems"},329:{n:"BrtEndSXTHItems"},330:{n:"BrtBeginSXTHItem"},331:{n:"BrtEndSXTHItem"},332:{n:"BrtBeginMetadata"},333:{n:"BrtEndMetadata"},334:{n:"BrtBeginEsmdtinfo"},335:{n:"BrtMdtinfo"},336:{n:"BrtEndEsmdtinfo"},337:{n:"BrtBeginEsmdb"},338:{n:"BrtEndEsmdb"},339:{n:"BrtBeginEsfmd"},340:{n:"BrtEndEsfmd"},341:{n:"BrtBeginSingleCells"},342:{n:"BrtEndSingleCells"},343:{n:"BrtBeginList"},344:{n:"BrtEndList"},345:{n:"BrtBeginListCols"},346:{n:"BrtEndListCols"},347:{n:"BrtBeginListCol"},348:{n:"BrtEndListCol"},349:{n:"BrtBeginListXmlCPr"},350:{n:"BrtEndListXmlCPr"},351:{n:"BrtListCCFmla"},352:{n:"BrtListTrFmla"},353:{n:"BrtBeginExternals"},354:{n:"BrtEndExternals"},355:{n:"BrtSupBookSrc",f:Gt},357:{n:"BrtSupSelf"},358:{n:"BrtSupSame"},359:{n:"BrtSupTabs"},360:{n:"BrtBeginSupBook"},361:{n:"BrtPlaceholderName"},362:{n:"BrtExternSheet",f:xs},363:{n:"BrtExternTableStart"},364:{n:"BrtExternTableEnd"},366:{n:"BrtExternRowHdr"},367:{n:"BrtExternCellBlank"},368:{n:"BrtExternCellReal"},369:{n:"BrtExternCellBool"},370:{n:"BrtExternCellError"},371:{n:"BrtExternCellString"},372:{n:"BrtBeginEsmdx"},373:{n:"BrtEndEsmdx"},374:{n:"BrtBeginMdxSet"},375:{n:"BrtEndMdxSet"},376:{n:"BrtBeginMdxMbrProp"},377:{n:"BrtEndMdxMbrProp"},378:{n:"BrtBeginMdxKPI"},379:{n:"BrtEndMdxKPI"},380:{n:"BrtBeginEsstr"},381:{n:"BrtEndEsstr"},382:{n:"BrtBeginPRFItem"},383:{n:"BrtEndPRFItem"},384:{n:"BrtBeginPivotCacheIDs"},385:{n:"BrtEndPivotCacheIDs"},386:{n:"BrtBeginPivotCacheID"},387:{n:"BrtEndPivotCacheID"},388:{n:"BrtBeginISXVIs"},389:{n:"BrtEndISXVIs"},390:{n:"BrtBeginColInfos"},391:{n:"BrtEndColInfos"},392:{n:"BrtBeginRwBrk"},393:{n:"BrtEndRwBrk"},394:{n:"BrtBeginColBrk"},395:{n:"BrtEndColBrk"},396:{n:"BrtBrk"},397:{n:"BrtUserBookView"},398:{n:"BrtInfo"},399:{n:"BrtCUsr"},400:{n:"BrtUsr"},401:{n:"BrtBeginUsers"},403:{n:"BrtEOF"},404:{n:"BrtUCR"},405:{n:"BrtRRInsDel"},406:{n:"BrtRREndInsDel"},407:{n:"BrtRRMove"},408:{n:"BrtRREndMove"},409:{n:"BrtRRChgCell"},410:{n:"BrtRREndChgCell"},411:{n:"BrtRRHeader"},412:{n:"BrtRRUserView"},413:{n:"BrtRRRenSheet"},414:{n:"BrtRRInsertSh"},415:{n:"BrtRRDefName"},416:{n:"BrtRRNote"},417:{n:"BrtRRConflict"},418:{n:"BrtRRTQSIF"},419:{n:"BrtRRFormat"},420:{n:"BrtRREndFormat"},421:{n:"BrtRRAutoFmt"},422:{n:"BrtBeginUserShViews"},423:{n:"BrtBeginUserShView"},424:{n:"BrtEndUserShView"},425:{n:"BrtEndUserShViews"},426:{n:"BrtArrFmla",f:zd},427:{n:"BrtShrFmla",f:jd},428:{n:"BrtTable"},429:{n:"BrtBeginExtConnections"},430:{n:"BrtEndExtConnections"},431:{n:"BrtBeginPCDCalcMems"},432:{n:"BrtEndPCDCalcMems"},433:{n:"BrtBeginPCDCalcMem"},434:{n:"BrtEndPCDCalcMem"},435:{n:"BrtBeginPCDHGLevels"},436:{n:"BrtEndPCDHGLevels"},437:{n:"BrtBeginPCDHGLevel"},438:{n:"BrtEndPCDHGLevel"},439:{n:"BrtBeginPCDHGLGroups"},440:{n:"BrtEndPCDHGLGroups"},441:{n:"BrtBeginPCDHGLGroup"},442:{n:"BrtEndPCDHGLGroup"},443:{n:"BrtBeginPCDHGLGMembers"},444:{n:"BrtEndPCDHGLGMembers"},445:{n:"BrtBeginPCDHGLGMember"},446:{n:"BrtEndPCDHGLGMember"},447:{n:"BrtBeginQSI"},448:{n:"BrtEndQSI"},449:{n:"BrtBeginQSIR"},450:{n:"BrtEndQSIR"},451:{n:"BrtBeginDeletedNames"},452:{n:"BrtEndDeletedNames"},453:{n:"BrtBeginDeletedName"},454:{n:"BrtEndDeletedName"},455:{n:"BrtBeginQSIFs"},456:{n:"BrtEndQSIFs"},457:{n:"BrtBeginQSIF"},458:{n:"BrtEndQSIF"},459:{n:"BrtBeginAutoSortScope"},460:{n:"BrtEndAutoSortScope"},461:{n:"BrtBeginConditionalFormatting"},462:{n:"BrtEndConditionalFormatting"},463:{n:"BrtBeginCFRule"},464:{n:"BrtEndCFRule"},465:{n:"BrtBeginIconSet"},466:{n:"BrtEndIconSet"},467:{n:"BrtBeginDatabar"},468:{n:"BrtEndDatabar"},469:{n:"BrtBeginColorScale"},470:{n:"BrtEndColorScale"},471:{n:"BrtCFVO"},472:{n:"BrtExternValueMeta"},473:{n:"BrtBeginColorPalette"},474:{n:"BrtEndColorPalette"},475:{n:"BrtIndexedColor"},476:{n:"BrtMargins",f:Yd},477:{n:"BrtPrintOptions"},478:{n:"BrtPageSetup"},479:{n:"BrtBeginHeaderFooter"},480:{n:"BrtEndHeaderFooter"},481:{n:"BrtBeginSXCrtFormat"},482:{n:"BrtEndSXCrtFormat"},483:{n:"BrtBeginSXCrtFormats"},484:{n:"BrtEndSXCrtFormats"},485:{n:"BrtWsFmtInfo",f:nd},486:{n:"BrtBeginMgs"},487:{n:"BrtEndMGs"},488:{n:"BrtBeginMGMaps"},489:{n:"BrtEndMGMaps"},490:{n:"BrtBeginMG"},491:{n:"BrtEndMG"},492:{n:"BrtBeginMap"},493:{n:"BrtEndMap"},494:{n:"BrtHLink",f:Vd},495:{n:"BrtBeginDCon"},496:{n:"BrtEndDCon"},497:{n:"BrtBeginDRefs"},498:{n:"BrtEndDRefs"},499:{n:"BrtDRef"},500:{n:"BrtBeginScenMan"},501:{n:"BrtEndScenMan"},502:{n:"BrtBeginSct"},503:{n:"BrtEndSct"},504:{n:"BrtSlc"},505:{n:"BrtBeginDXFs"},506:{n:"BrtEndDXFs"},507:{n:"BrtDXF"},508:{n:"BrtBeginTableStyles"},509:{n:"BrtEndTableStyles"},510:{n:"BrtBeginTableStyle"},511:{n:"BrtEndTableStyle"},512:{n:"BrtTableStyleElement"},513:{n:"BrtTableStyleClient"},514:{n:"BrtBeginVolDeps"},515:{n:"BrtEndVolDeps"},516:{n:"BrtBeginVolType"},517:{n:"BrtEndVolType"},518:{n:"BrtBeginVolMain"},519:{n:"BrtEndVolMain"},520:{n:"BrtBeginVolTopic"},521:{n:"BrtEndVolTopic"},522:{n:"BrtVolSubtopic"},523:{n:"BrtVolRef"},524:{n:"BrtVolNum"},525:{n:"BrtVolErr"},526:{n:"BrtVolStr"},527:{n:"BrtVolBool"},528:{n:"BrtBeginCalcChain$"},529:{n:"BrtEndCalcChain$"},530:{n:"BrtBeginSortState"},531:{n:"BrtEndSortState"},532:{n:"BrtBeginSortCond"},533:{n:"BrtEndSortCond"},534:{n:"BrtBookProtection"},535:{n:"BrtSheetProtection"},536:{n:"BrtRangeProtection"},537:{n:"BrtPhoneticInfo"},538:{n:"BrtBeginECTxtWiz"},539:{n:"BrtEndECTxtWiz"},540:{n:"BrtBeginECTWFldInfoLst"},541:{n:"BrtEndECTWFldInfoLst"},542:{n:"BrtBeginECTwFldInfo"},548:{n:"BrtFileSharing"},549:{n:"BrtOleSize"},550:{n:"BrtDrawing",f:Gt},551:{n:"BrtLegacyDrawing"},552:{n:"BrtLegacyDrawingHF"},553:{n:"BrtWebOpt"},554:{n:"BrtBeginWebPubItems"},555:{n:"BrtEndWebPubItems"},556:{n:"BrtBeginWebPubItem"},557:{n:"BrtEndWebPubItem"},558:{n:"BrtBeginSXCondFmt"},559:{n:"BrtEndSXCondFmt"},560:{n:"BrtBeginSXCondFmts"},561:{n:"BrtEndSXCondFmts"},562:{n:"BrtBkHim"},564:{n:"BrtColor"},565:{n:"BrtBeginIndexedColors"},566:{n:"BrtEndIndexedColors"},569:{n:"BrtBeginMRUColors"},570:{n:"BrtEndMRUColors"},572:{n:"BrtMRUColor"},573:{n:"BrtBeginDVals"},574:{n:"BrtEndDVals"},577:{n:"BrtSupNameStart"},578:{n:"BrtSupNameValueStart"},579:{n:"BrtSupNameValueEnd"},580:{n:"BrtSupNameNum"},581:{n:"BrtSupNameErr"},582:{n:"BrtSupNameSt"},583:{n:"BrtSupNameNil"},584:{n:"BrtSupNameBool"},585:{n:"BrtSupNameFmla"},586:{n:"BrtSupNameBits"},587:{n:"BrtSupNameEnd"},588:{n:"BrtEndSupBook"},589:{n:"BrtCellSmartTagProperty"},590:{n:"BrtBeginCellSmartTag"},591:{n:"BrtEndCellSmartTag"},592:{n:"BrtBeginCellSmartTags"},593:{n:"BrtEndCellSmartTags"},594:{n:"BrtBeginSmartTags"},595:{n:"BrtEndSmartTags"},596:{n:"BrtSmartTagType"},597:{n:"BrtBeginSmartTagTypes"},598:{n:"BrtEndSmartTagTypes"},599:{n:"BrtBeginSXFilters"},600:{n:"BrtEndSXFilters"},601:{n:"BrtBeginSXFILTER"},602:{n:"BrtEndSXFilter"},603:{n:"BrtBeginFills"},604:{n:"BrtEndFills"},605:{n:"BrtBeginCellWatches"},606:{n:"BrtEndCellWatches"},607:{n:"BrtCellWatch"},608:{n:"BrtBeginCRErrs"},609:{n:"BrtEndCRErrs"},610:{n:"BrtCrashRecErr"},611:{n:"BrtBeginFonts"},612:{n:"BrtEndFonts"},613:{n:"BrtBeginBorders"},614:{n:"BrtEndBorders"},615:{n:"BrtBeginFmts"},616:{n:"BrtEndFmts"},617:{n:"BrtBeginCellXFs"},618:{n:"BrtEndCellXFs"},619:{n:"BrtBeginStyles"},620:{n:"BrtEndStyles"},625:{n:"BrtBigName"},626:{n:"BrtBeginCellStyleXFs"},627:{n:"BrtEndCellStyleXFs"},628:{n:"BrtBeginComments"},629:{n:"BrtEndComments"},630:{n:"BrtBeginCommentAuthors"},631:{n:"BrtEndCommentAuthors"},632:{n:"BrtCommentAuthor",f:Ko},633:{n:"BrtBeginCommentList"},634:{n:"BrtEndCommentList"},635:{n:"BrtBeginComment",f:jo},636:{n:"BrtEndComment"},637:{n:"BrtCommentText",f:Dt},638:{n:"BrtBeginOleObjects"},639:{n:"BrtOleObject"},640:{n:"BrtEndOleObjects"},641:{n:"BrtBeginSxrules"},642:{n:"BrtEndSxRules"},643:{n:"BrtBeginActiveXControls"},644:{n:"BrtActiveX"},645:{n:"BrtEndActiveXControls"},646:{n:"BrtBeginPCDSDTCEMembersSortBy"},648:{n:"BrtBeginCellIgnoreECs"},649:{n:"BrtCellIgnoreEC"},650:{n:"BrtEndCellIgnoreECs"},651:{n:"BrtCsProp",f:kv},652:{n:"BrtCsPageSetup"},653:{n:"BrtBeginUserCsViews"},654:{n:"BrtEndUserCsViews"},655:{n:"BrtBeginUserCsView"},656:{n:"BrtEndUserCsView"},657:{n:"BrtBeginPcdSFCIEntries"},658:{n:"BrtEndPCDSFCIEntries"},659:{n:"BrtPCDSFCIEntry"},660:{n:"BrtBeginListParts"},661:{n:"BrtListPart"},662:{n:"BrtEndListParts"},663:{n:"BrtSheetCalcProp"},664:{n:"BrtBeginFnGroup"},665:{n:"BrtFnGroup"},666:{n:"BrtEndFnGroup"},667:{n:"BrtSupAddin"},668:{n:"BrtSXTDMPOrder"},669:{n:"BrtCsProtection"},671:{n:"BrtBeginWsSortMap"},672:{n:"BrtEndWsSortMap"},673:{n:"BrtBeginRRSort"},674:{n:"BrtEndRRSort"},675:{n:"BrtRRSortItem"},676:{n:"BrtFileSharingIso"},677:{n:"BrtBookProtectionIso"},678:{n:"BrtSheetProtectionIso"},679:{n:"BrtCsProtectionIso"},680:{n:"BrtRangeProtectionIso"},681:{n:"BrtDValList"},1024:{n:"BrtRwDescent"},1025:{n:"BrtKnownFonts"},1026:{n:"BrtBeginSXTupleSet"},1027:{n:"BrtEndSXTupleSet"},1028:{n:"BrtBeginSXTupleSetHeader"},1029:{n:"BrtEndSXTupleSetHeader"},1030:{n:"BrtSXTupleSetHeaderItem"},1031:{n:"BrtBeginSXTupleSetData"},1032:{n:"BrtEndSXTupleSetData"},1033:{n:"BrtBeginSXTupleSetRow"},1034:{n:"BrtEndSXTupleSetRow"},1035:{n:"BrtSXTupleSetRowItem"},1036:{n:"BrtNameExt"},1037:{n:"BrtPCDH14"},1038:{n:"BrtBeginPCDCalcMem14"},1039:{n:"BrtEndPCDCalcMem14"},1040:{n:"BrtSXTH14"},1041:{n:"BrtBeginSparklineGroup"},1042:{n:"BrtEndSparklineGroup"},1043:{n:"BrtSparkline"},1044:{n:"BrtSXDI14"},1045:{n:"BrtWsFmtInfoEx14"},1046:{n:"BrtBeginConditionalFormatting14"},1047:{n:"BrtEndConditionalFormatting14"},1048:{n:"BrtBeginCFRule14"},1049:{n:"BrtEndCFRule14"},1050:{n:"BrtCFVO14"},1051:{n:"BrtBeginDatabar14"},1052:{n:"BrtBeginIconSet14"},1053:{n:"BrtDVal14",f:tv},1054:{n:"BrtBeginDVals14"},1055:{n:"BrtColor14"},1056:{n:"BrtBeginSparklines"},1057:{n:"BrtEndSparklines"},1058:{n:"BrtBeginSparklineGroups"},1059:{n:"BrtEndSparklineGroups"},1061:{n:"BrtSXVD14"},1062:{n:"BrtBeginSXView14"},1063:{n:"BrtEndSXView14"},1064:{n:"BrtBeginSXView16"},1065:{n:"BrtEndSXView16"},1066:{n:"BrtBeginPCD14"},1067:{n:"BrtEndPCD14"},1068:{n:"BrtBeginExtConn14"},1069:{n:"BrtEndExtConn14"},1070:{n:"BrtBeginSlicerCacheIDs"},1071:{n:"BrtEndSlicerCacheIDs"},1072:{n:"BrtBeginSlicerCacheID"},1073:{n:"BrtEndSlicerCacheID"},1075:{n:"BrtBeginSlicerCache"},1076:{n:"BrtEndSlicerCache"},1077:{n:"BrtBeginSlicerCacheDef"},1078:{n:"BrtEndSlicerCacheDef"},1079:{n:"BrtBeginSlicersEx"},1080:{n:"BrtEndSlicersEx"},1081:{n:"BrtBeginSlicerEx"},1082:{n:"BrtEndSlicerEx"},1083:{n:"BrtBeginSlicer"},1084:{n:"BrtEndSlicer"},1085:{n:"BrtSlicerCachePivotTables"},1086:{n:"BrtBeginSlicerCacheOlapImpl"},1087:{n:"BrtEndSlicerCacheOlapImpl"},1088:{n:"BrtBeginSlicerCacheLevelsData"},1089:{n:"BrtEndSlicerCacheLevelsData"},1090:{n:"BrtBeginSlicerCacheLevelData"},1091:{n:"BrtEndSlicerCacheLevelData"},1092:{n:"BrtBeginSlicerCacheSiRanges"},1093:{n:"BrtEndSlicerCacheSiRanges"},1094:{n:"BrtBeginSlicerCacheSiRange"},1095:{n:"BrtEndSlicerCacheSiRange"},1096:{n:"BrtSlicerCacheOlapItem"},1097:{n:"BrtBeginSlicerCacheSelections"},1098:{n:"BrtSlicerCacheSelection"},1099:{n:"BrtEndSlicerCacheSelections"},1100:{n:"BrtBeginSlicerCacheNative"},1101:{n:"BrtEndSlicerCacheNative"},1102:{n:"BrtSlicerCacheNativeItem"},1103:{n:"BrtRangeProtection14"},1104:{n:"BrtRangeProtectionIso14"},1105:{n:"BrtCellIgnoreEC14"},1111:{n:"BrtList14"},1112:{n:"BrtCFIcon"},1113:{n:"BrtBeginSlicerCachesPivotCacheIDs"},1114:{n:"BrtEndSlicerCachesPivotCacheIDs"},1115:{n:"BrtBeginSlicers"},1116:{n:"BrtEndSlicers"},1117:{n:"BrtWbProp14"},1118:{n:"BrtBeginSXEdit"},1119:{n:"BrtEndSXEdit"},1120:{n:"BrtBeginSXEdits"},1121:{n:"BrtEndSXEdits"},1122:{n:"BrtBeginSXChange"},1123:{n:"BrtEndSXChange"},1124:{n:"BrtBeginSXChanges"},1125:{n:"BrtEndSXChanges"},1126:{n:"BrtSXTupleItems"},1128:{n:"BrtBeginSlicerStyle"},1129:{n:"BrtEndSlicerStyle"},1130:{n:"BrtSlicerStyleElement"},1131:{n:"BrtBeginStyleSheetExt14"},1132:{n:"BrtEndStyleSheetExt14"},1133:{n:"BrtBeginSlicerCachesPivotCacheID"},1134:{n:"BrtEndSlicerCachesPivotCacheID"},1135:{n:"BrtBeginConditionalFormattings"},1136:{n:"BrtEndConditionalFormattings"},1137:{n:"BrtBeginPCDCalcMemExt"},1138:{n:"BrtEndPCDCalcMemExt"},1139:{n:"BrtBeginPCDCalcMemsExt"},1140:{n:"BrtEndPCDCalcMemsExt"},1141:{n:"BrtPCDField14"},1142:{n:"BrtBeginSlicerStyles"},1143:{n:"BrtEndSlicerStyles"},1144:{n:"BrtBeginSlicerStyleElements"},1145:{n:"BrtEndSlicerStyleElements"},1146:{n:"BrtCFRuleExt"},1147:{n:"BrtBeginSXCondFmt14"},1148:{n:"BrtEndSXCondFmt14"},1149:{n:"BrtBeginSXCondFmts14"},1150:{n:"BrtEndSXCondFmts14"},1152:{n:"BrtBeginSortCond14"},1153:{n:"BrtEndSortCond14"},1154:{n:"BrtEndDVals14"},1155:{n:"BrtEndIconSet14"},1156:{n:"BrtEndDatabar14"},1157:{n:"BrtBeginColorScale14"},1158:{n:"BrtEndColorScale14"},1159:{n:"BrtBeginSxrules14"},1160:{n:"BrtEndSxrules14"},1161:{n:"BrtBeginPRule14"},1162:{n:"BrtEndPRule14"},1163:{n:"BrtBeginPRFilters14"},1164:{n:"BrtEndPRFilters14"},1165:{n:"BrtBeginPRFilter14"},1166:{n:"BrtEndPRFilter14"},1167:{n:"BrtBeginPRFItem14"},1168:{n:"BrtEndPRFItem14"},1169:{n:"BrtBeginCellIgnoreECs14"},1170:{n:"BrtEndCellIgnoreECs14"},1171:{n:"BrtDxf14"},1172:{n:"BrtBeginDxF14s"},1173:{n:"BrtEndDxf14s"},1177:{n:"BrtFilter14"},1178:{n:"BrtBeginCustomFilters14"},1180:{n:"BrtCustomFilter14"},1181:{n:"BrtIconFilter14"},1182:{n:"BrtPivotCacheConnectionName"},2048:{n:"BrtBeginDecoupledPivotCacheIDs"},2049:{n:"BrtEndDecoupledPivotCacheIDs"},2050:{n:"BrtDecoupledPivotCacheID"},2051:{n:"BrtBeginPivotTableRefs"},2052:{n:"BrtEndPivotTableRefs"},2053:{n:"BrtPivotTableRef"},2054:{n:"BrtSlicerCacheBookPivotTables"},2055:{n:"BrtBeginSxvcells"},2056:{n:"BrtEndSxvcells"},2057:{n:"BrtBeginSxRow"},2058:{n:"BrtEndSxRow"},2060:{n:"BrtPcdCalcMem15"},2067:{n:"BrtQsi15"},2068:{n:"BrtBeginWebExtensions"},2069:{n:"BrtEndWebExtensions"},2070:{n:"BrtWebExtension"},2071:{n:"BrtAbsPath15"},2072:{n:"BrtBeginPivotTableUISettings"},2073:{n:"BrtEndPivotTableUISettings"},2075:{n:"BrtTableSlicerCacheIDs"},2076:{n:"BrtTableSlicerCacheID"},2077:{n:"BrtBeginTableSlicerCache"},2078:{n:"BrtEndTableSlicerCache"},2079:{n:"BrtSxFilter15"},2080:{n:"BrtBeginTimelineCachePivotCacheIDs"},2081:{n:"BrtEndTimelineCachePivotCacheIDs"},2082:{n:"BrtTimelineCachePivotCacheID"},2083:{n:"BrtBeginTimelineCacheIDs"},2084:{n:"BrtEndTimelineCacheIDs"},2085:{n:"BrtBeginTimelineCacheID"},2086:{n:"BrtEndTimelineCacheID"},2087:{n:"BrtBeginTimelinesEx"},2088:{n:"BrtEndTimelinesEx"},2089:{n:"BrtBeginTimelineEx"},2090:{n:"BrtEndTimelineEx"},2091:{n:"BrtWorkBookPr15"},2092:{n:"BrtPCDH15"},2093:{n:"BrtBeginTimelineStyle"},2094:{n:"BrtEndTimelineStyle"},2095:{n:"BrtTimelineStyleElement"},2096:{n:"BrtBeginTimelineStylesheetExt15"},2097:{n:"BrtEndTimelineStylesheetExt15"},2098:{n:"BrtBeginTimelineStyles"},2099:{n:"BrtEndTimelineStyles"},2100:{n:"BrtBeginTimelineStyleElements"},2101:{n:"BrtEndTimelineStyleElements"},2102:{n:"BrtDxf15"},2103:{n:"BrtBeginDxfs15"},2104:{n:"brtEndDxfs15"},2105:{n:"BrtSlicerCacheHideItemsWithNoData"},2106:{n:"BrtBeginItemUniqueNames"},2107:{n:"BrtEndItemUniqueNames"},2108:{n:"BrtItemUniqueName"},2109:{n:"BrtBeginExtConn15"},2110:{n:"BrtEndExtConn15"},2111:{n:"BrtBeginOledbPr15"},2112:{n:"BrtEndOledbPr15"},2113:{n:"BrtBeginDataFeedPr15"},2114:{n:"BrtEndDataFeedPr15"},2115:{n:"BrtTextPr15"},2116:{n:"BrtRangePr15"},2117:{n:"BrtDbCommand15"},2118:{n:"BrtBeginDbTables15"},2119:{n:"BrtEndDbTables15"},2120:{n:"BrtDbTable15"},2121:{n:"BrtBeginDataModel"},2122:{n:"BrtEndDataModel"},2123:{n:"BrtBeginModelTables"},2124:{n:"BrtEndModelTables"},2125:{n:"BrtModelTable"},2126:{n:"BrtBeginModelRelationships"},2127:{n:"BrtEndModelRelationships"},2128:{n:"BrtModelRelationship"},2129:{n:"BrtBeginECTxtWiz15"},2130:{n:"BrtEndECTxtWiz15"},2131:{n:"BrtBeginECTWFldInfoLst15"},2132:{n:"BrtEndECTWFldInfoLst15"},2133:{n:"BrtBeginECTWFldInfo15"},2134:{n:"BrtFieldListActiveItem"},2135:{n:"BrtPivotCacheIdVersion"},2136:{n:"BrtSXDI15"},2137:{n:"BrtBeginModelTimeGroupings"},2138:{n:"BrtEndModelTimeGroupings"},2139:{n:"BrtBeginModelTimeGrouping"},2140:{n:"BrtEndModelTimeGrouping"},2141:{n:"BrtModelTimeGroupingCalcCol"},3072:{n:"BrtUid"},3073:{n:"BrtRevisionPtr"},5095:{n:"BrtBeginCalcFeatures"},5096:{n:"BrtEndCalcFeatures"},5097:{n:"BrtCalcFeature"},65535:{n:""}};var qp=Y(Zp,"n");qp["BrtFRTArchID$"]=16;var eb={6:{n:"Formula",f:Yu},10:{n:"EOF",f:Xn},12:{n:"CalcCount",f:Kn},13:{n:"CalcMode",f:Kn},14:{n:"CalcPrecision",f:jn},15:{n:"CalcRefMode",f:jn},16:{n:"CalcDelta",f:Zt},17:{n:"CalcIter",f:jn},18:{n:"Protect",f:jn},19:{n:"Password",f:Kn},20:{n:"Header",f:Ss},21:{n:"Footer",f:Ss},23:{n:"ExternSheet",f:xs},24:{n:"Lbl",f:_s},25:{n:"WinProtect",f:jn},26:{n:"VerticalPageBreaks"},27:{n:"HorizontalPageBreaks"},28:{n:"Note",f:Os},29:{n:"Selection"},34:{n:"Date1904",f:jn},35:{n:"ExternName",f:Cs},38:{n:"LeftMargin",f:Zt},39:{n:"RightMargin",f:Zt},40:{n:"TopMargin",f:Zt},41:{n:"BottomMargin",f:Zt},42:{n:"PrintRowCol",f:jn},43:{n:"PrintGrid",f:jn},47:{n:"FilePass",f:fl},49:{n:"Font",f:qi},51:{n:"PrintSize",f:Kn},60:{n:"Continue"},61:{n:"Window1",f:Ki},64:{n:"Backup",f:jn},65:{n:"Pane",f:Zi},66:{n:"CodePage",f:Kn},77:{n:"Pls"},80:{n:"DCon"},81:{n:"DConRef"},82:{n:"DConName"},85:{n:"DefColWidth",f:Kn},89:{n:"XCT"},90:{n:"CRN"},91:{n:"FileSharing"},92:{n:"WriteAccess",f:Ni},93:{n:"Obj",f:Ms},94:{n:"Uncalced"},95:{n:"CalcSaveRecalc",f:jn},96:{n:"Template"},97:{n:"Intl"},99:{n:"ObjProtect",f:jn},125:{n:"ColInfo",f:Qs},128:{n:"Guts",f:bs},129:{n:"WsBool",f:Li},130:{n:"GridSet",f:Kn},131:{n:"HCenter",f:jn},132:{n:"VCenter",f:jn},133:{n:"BoundSheet8",f:Ui},134:{n:"WriteProtect"},140:{n:"Country",f:zs},141:{n:"HideObj",f:Kn},144:{n:"Sort"},146:{n:"Palette",f:Ks},151:{n:"Sync"},152:{n:"LPr"},153:{n:"DxGCol"},154:{n:"FnGroupName"},155:{n:"FilterMode"},156:{n:"BuiltInFnGroupCount",f:Kn},157:{n:"AutoFilterInfo"},158:{n:"AutoFilter"},160:{n:"Scl",f:tf},161:{n:"Setup",f:Zs},174:{n:"ScenMan"},175:{n:"SCENARIO"},176:{n:"SxView"},177:{n:"Sxvd"},178:{n:"SXVI"},180:{n:"SxIvd"},181:{n:"SXLI"},182:{n:"SXPI"},184:{n:"DocRoute"},185:{n:"RecipName"},189:{n:"MulRk",f:us},190:{n:"MulBlank",f:hs},193:{n:"Mms",f:Xn},197:{n:"SXDI"},198:{n:"SXDB"},199:{n:"SXFDB"},200:{n:"SXDBB"},201:{n:"SXNum"},202:{n:"SxBool",f:jn},203:{n:"SxErr"},204:{n:"SXInt"},205:{n:"SXString"},206:{n:"SXDtr"},207:{n:"SxNil"},208:{n:"SXTbl"},209:{n:"SXTBRGIITM"},210:{n:"SxTbpg"},211:{n:"ObProj"},213:{n:"SXStreamID"},215:{n:"DBCell"},216:{n:"SXRng"},217:{n:"SxIsxoper"},218:{n:"BookBool",f:Kn},220:{n:"DbOrParamQry"},221:{n:"ScenarioProtect",f:jn},222:{n:"OleObjectSize"},224:{n:"XF",f:vs},225:{n:"InterfaceHdr",f:Pi},226:{n:"InterfaceEnd",f:Xn},227:{n:"SXVS"},229:{n:"MergeCells",f:Ps},233:{n:"BkHim"},235:{n:"MsoDrawingGroup"},236:{n:"MsoDrawing"},237:{n:"MsoDrawingSelection"},239:{n:"PhoneticInfo"},240:{n:"SxRule"},241:{n:"SXEx"},242:{n:"SxFilt"},244:{n:"SxDXF"},245:{n:"SxItm"},246:{n:"SxName"},247:{n:"SxSelect"},248:{n:"SXPair"},249:{n:"SxFmla"},251:{n:"SxFormat"},252:{n:"SST",f:Wi},253:{n:"LabelSst",f:rs},255:{n:"ExtSST",f:Xi},256:{n:"SXVDEx"},259:{n:"SXFormula"},290:{n:"SXDBEx"},311:{n:"RRDInsDel"},312:{n:"RRDHead"},315:{n:"RRDChgCell"},317:{n:"RRTabId",f:Qn},318:{n:"RRDRenSheet"},319:{n:"RRSort"},320:{n:"RRDMove"},330:{n:"RRFormat"},331:{n:"RRAutoFmt"},333:{n:"RRInsertSh"},334:{n:"RRDMoveBegin"},335:{n:"RRDMoveEnd"},336:{n:"RRDInsDelBegin"},337:{n:"RRDInsDelEnd"},338:{n:"RRDConflict"},339:{n:"RRDDefName"},340:{n:"RRDRstEtxp"},351:{n:"LRng"},352:{n:"UsesELFs",f:jn},353:{n:"DSF",f:Xn},401:{n:"CUsr"},402:{n:"CbUsr"},403:{n:"UsrInfo"},404:{n:"UsrExcl"},405:{n:"FileLock"},406:{n:"RRDInfo"},407:{n:"BCUsrs"},408:{n:"UsrChk"},425:{n:"UserBView"},426:{n:"UserSViewBegin"},427:{n:"UserSViewEnd"},428:{n:"RRDUserView"},429:{n:"Qsi"},430:{n:"SupBook",f:Bs},431:{n:"Prot4Rev",f:jn},432:{n:"CondFmt"},433:{n:"CF"},434:{n:"DVal"},437:{n:"DConBin"},438:{n:"TxO",f:Hs},439:{n:"RefreshAll",f:jn},440:{n:"HLink",f:Ws},441:{n:"Lel"},442:{n:"CodeName",f:ai},443:{n:"SXFDBType"},444:{n:"Prot4RevPass",f:Kn},445:{n:"ObNoMacros"},446:{n:"Dv"},448:{n:"Excel9File",f:Xn},449:{n:"RecalcId",f:ji,r:2},450:{n:"EntExU2",f:Xn},512:{n:"Dimensions",f:ls},513:{n:"Blank",f:rf},515:{n:"Number",f:ws},516:{n:"Label",f:as},517:{n:"BoolErr",f:gs},519:{n:"String",f:af},520:{n:"Row",f:Gi},523:{n:"Index"},545:{n:"Array",f:Rs},549:{n:"DefaultRowHeight",f:$i},566:{n:"Table"},574:{n:"Window2",f:Qi},638:{n:"RK",f:cs},659:{n:"Style"},1048:{n:"BigName"},1054:{n:"Format",f:is},1084:{n:"ContinueBigName"},1212:{n:"ShrFmla",f:Is},2048:{n:"HLinkTooltip",f:Xs},2049:{n:"WebPub"},2050:{n:"QsiSXTag"},2051:{n:"DBQueryExt"},2052:{n:"ExtString"},2053:{n:"TxtQry"},2054:{n:"Qsir"},2055:{n:"Qsif"},2056:{n:"RRDTQSIF"},2057:{n:"BOF",f:Di},2058:{n:"OleDbConn"},2059:{n:"WOpt"},2060:{n:"SXViewEx"},2061:{n:"SXTH"},2062:{n:"SXPIEx"},2063:{n:"SXVDTEx"},2064:{n:"SXViewEx9"},2066:{n:"ContinueFrt"},2067:{n:"RealTimeData"},2128:{n:"ChartFrtInfo"},2129:{n:"FrtWrapper"},2130:{n:"StartBlock"},2131:{n:"EndBlock"},2132:{n:"StartObject"},2133:{n:"EndObject"},2134:{n:"CatLab"},2135:{n:"YMult"},2136:{n:"SXViewLink"},2137:{n:"PivotChartBits"},2138:{n:"FrtFontList"},2146:{n:"SheetExt"},2147:{n:"BookExt",r:12},2148:{n:"SXAddl"},2149:{n:"CrErr"},2150:{n:"HFPicture"},2151:{n:"FeatHdr",f:Xn},2152:{n:"Feat"},2154:{n:"DataLabExt"},2155:{n:"DataLabExtContents"},2156:{n:"CellWatch"},2161:{n:"FeatHdr11"},2162:{n:"Feature11"},2164:{n:"DropDownObjIds"},2165:{n:"ContinueFrt11"},2166:{n:"DConn"},2167:{n:"List12"},2168:{n:"Feature12"},2169:{n:"CondFmt12"},2170:{n:"CF12"},2171:{n:"CFEx"},2172:{n:"XFCRC",f:Ys,r:12},2173:{n:"XFExt",f:Fo,r:12},2174:{n:"AutoFilter12"},2175:{n:"ContinueFrt12"},2180:{n:"MDTInfo"},2181:{n:"MDXStr"},2182:{n:"MDXTuple"},2183:{n:"MDXSet"},2184:{n:"MDXProp"},2185:{n:"MDXKPI"},2186:{n:"MDB"},2187:{n:"PLV"},2188:{n:"Compat12",f:jn,r:12},2189:{n:"DXF"},2190:{n:"TableStyles",r:12},2191:{n:"TableStyle"},2192:{n:"TableStyleElement"},2194:{n:"StyleExt"},2195:{n:"NamePublish"},2196:{n:"NameCmt",f:ys,r:12},2197:{n:"SortData"},2198:{n:"Theme",f:_o,r:12},2199:{n:"GUIDTypeLib"},2200:{n:"FnGrp12"},2201:{n:"NameFnGrp12"},2202:{n:"MTRSettings",f:Fs,r:12},2203:{n:"CompressPictures",f:Xn},2204:{n:"HeaderFooter"},2205:{n:"CrtLayout12"},2206:{n:"CrtMlFrt"},2207:{n:"CrtMlFrtContinue"},2211:{n:"ForceFullCalculation",f:zi},2212:{n:"ShapePropsStream"},2213:{n:"TextPropsStream"},2214:{n:"RichTextStream"},2215:{n:"CrtLayout12A"},4097:{n:"Units"},4098:{n:"Chart"},4099:{n:"Series"},4102:{n:"DataFormat"},4103:{n:"LineFormat"},4105:{n:"MarkerFormat"},4106:{n:"AreaFormat"},4107:{n:"PieFormat"},4108:{n:"AttachedLabel"},4109:{n:"SeriesText"},4116:{n:"ChartFormat"},4117:{n:"Legend"},4118:{n:"SeriesList"},4119:{n:"Bar"},4120:{n:"Line"},4121:{n:"Pie"},4122:{n:"Area"},4123:{n:"Scatter"},4124:{n:"CrtLine"},4125:{n:"Axis"},4126:{n:"Tick"},4127:{n:"ValueRange"},4128:{n:"CatSerRange"},4129:{n:"AxisLine"},4130:{n:"CrtLink"},4132:{n:"DefaultText"},4133:{n:"Text"},4134:{n:"FontX",f:Kn},4135:{n:"ObjectLink"},4146:{n:"Frame"},4147:{n:"Begin"},4148:{n:"End"},4149:{n:"PlotArea"},4154:{n:"Chart3d"},4156:{n:"PicF"},4157:{n:"DropBar"},4158:{n:"Radar"},4159:{n:"Surf"},4160:{n:"RadarArea"},4161:{n:"AxisParent"},4163:{n:"LegendException"},4164:{n:"ShtProps",f:qs},4165:{n:"SerToCrt"},4166:{n:"AxesUsed"},4168:{n:"SBaseRef"},4170:{n:"SerParent"},4171:{n:"SerAuxTrend"},4174:{n:"IFmtRecord"},4175:{n:"Pos"},4176:{n:"AlRuns"},4177:{n:"BRAI"},4187:{n:"SerAuxErrBar"},4188:{n:"ClrtClient",f:$s},4189:{n:"SerFmt"},4191:{n:"Chart3DBarShape"},4192:{n:"Fbi"},4193:{n:"BopPop"},4194:{n:"AxcExt"},4195:{n:"Dat"},4196:{n:"PlotGrowth"},4197:{n:"SIIndex"},4198:{n:"GelFrame"},4199:{n:"BopPopCustom"},4200:{n:"Fbi2"},0:{n:"Dimensions",f:ls},1:{n:"BIFF2BLANK"},2:{n:"BIFF2INT",f:of},3:{n:"BIFF2NUM",f:ff},4:{n:"BIFF2STR",f:sf},5:{n:"BoolErr",f:gs},7:{n:"String",f:uf},8:{n:"BIFF2ROW"},9:{n:"BOF",f:Di},11:{n:"Index"},22:{n:"ExternCount",f:Kn},30:{n:"BIFF2FORMAT",f:fs},31:{n:"BIFF2FMTCNT"},32:{n:"BIFF2COLINFO"},33:{n:"Array",f:Rs},36:{n:"COLWIDTH"},37:{n:"DefaultRowHeight",f:$i},50:{n:"BIFF2FONTXTRA",f:hf},62:{n:"BIFF2WINDOW2"},52:{n:"DDEObjName"},67:{n:"BIFF2XF"},68:{n:"BIFF2XFINDEX",f:Kn},69:{n:"BIFF2FONTCLR"},86:{n:"BIFF4FMTCNT"},126:{n:"RK"},127:{n:"ImData",f:nf},135:{n:"Addin"},136:{n:"Edg"},137:{n:"Pub"},145:{n:"Sub"},148:{n:"LHRecord"},149:{n:"LHNGraph"},150:{n:"Sound"},169:{n:"CoordList"},171:{n:"GCW"},188:{n:"ShrFmla"},191:{n:"ToolbarHdr"},192:{n:"ToolbarEnd"},194:{n:"AddMenu"},195:{n:"DelMenu"},214:{n:"RString",f:df},223:{n:"UDDesc"},234:{n:"TabIdConf"},354:{n:"XL5Modify"},421:{n:"FileSharing2"},518:{n:"Formula",f:Yu},521:{n:"BOF",f:Di},536:{n:"Lbl",f:_s},547:{n:"ExternName",f:Cs},561:{n:"Font"},579:{n:"BIFF3XF"},1030:{n:"Formula",f:Yu},1033:{n:"BOF",f:Di},1091:{n:"BIFF4XF"},2157:{n:"FeatInfo"},2163:{n:"FeatInfo11"},2177:{n:"SXAddl12"},2240:{n:"AutoWebPub"},2241:{n:"ListObj"},2242:{n:"ListField"},2243:{n:"ListDV"},2244:{n:"ListCondFmt"},2245:{n:"ListCF"},2246:{n:"FMQry"},2247:{n:"FMSQry"},2248:{n:"PLV"},2249:{n:"LnExt"},2250:{n:"MkrExt"},2251:{n:"CrtCoopt"},2262:{n:"FRTArchId$",r:12},29282:{}};var rb=Y(eb,"n");function tb(e,r,t,a){var n=typeof r=="number"?r:+r||+rb[r];if(isNaN(n))return;var i=a||(t||[]).length||0;var s=e.next(4);s._W(2,n);s._W(2,i);if(i>0&&Nr(t))e.push(t)}function ab(e,r,t,a){var n=a||(t||[]).length||0;if(n<=8224)return tb(e,r,t,n);var i=+r||+rb[r];if(isNaN(i))return;var s=t.parts||[],f=0;var l=0,o=0;while(o+(s[f]||8224)<=8224){o+=s[f]||8224;f++}var c=e.next(4);c._W(2,i);c._W(2,o);e.push(t.slice(l,l+o));l+=o;while(l<n){c=e.next(4);c._W(2,60);o=0;while(o+(s[f]||8224)<=8224){o+=s[f]||8224;f++}c._W(2,o);e.push(t.slice(l,l+o));l+=o}}function nb(e,r,t){if(!e)e=Jr(7);e._W(2,r);e._W(2,t);e._W(2,0);e._W(1,0);return e}function ib(e,r,t,a){var n=Jr(9);nb(n,e,r);Zn(t,a||"b",n);return n}function sb(e,r,t){var a=Jr(8+2*t.length);nb(a,e,r);a._W(1,t.length);a._W(t.length,t,"sbcs");return a.l<a.length?a.slice(0,a.l):a}function fb(e,r,t,a){if(r.v!=null)switch(r.t){case"d":;case"n":var n=r.t=="d"?ee(le(r.v)):r.v;if(n==(n|0)&&n>=0&&n<65536)tb(e,2,cf(t,a,n));else tb(e,3,lf(t,a,n));return;case"b":;case"e":tb(e,5,ib(t,a,r.v,r.t));return;case"s":;case"str":tb(e,4,sb(t,a,(r.v||"").slice(0,255)));return;}tb(e,1,nb(null,t,a))}function lb(e,r,t,a){var n=Array.isArray(r);var i=wt(r["!ref"]||"A1"),s,f="",l=[];if(i.e.c>255||i.e.r>16383){if(a.WTF)throw new Error("Range "+(r["!ref"]||"A1")+" exceeds format limit A1:IV16384");i.e.c=Math.min(i.e.c,255);i.e.r=Math.min(i.e.c,16383);s=Et(i)}for(var o=i.s.r;o<=i.e.r;++o){f=lt(o);for(var c=i.s.c;c<=i.e.c;++c){if(o===i.s.r)l[c]=ht(c);s=l[c]+f;var u=n?(r[o]||[])[c]:r[s];if(!u)continue;fb(e,u,o,c,a)}}}function ob(e,r){var t=r||{};if(b!=null&&t.dense==null)t.dense=b;var a=qr();var n=0;for(var i=0;i<e.SheetNames.length;++i)if(e.SheetNames[i]==t.sheet)n=i;if(n==0&&!!t.sheet&&e.SheetNames[0]!=t.sheet)throw new Error("Sheet not found: "+t.sheet);tb(a,t.biff==4?1033:t.biff==3?521:9,Oi(e,16,t));lb(a,e.Sheets[e.SheetNames[n]],n,t,e);tb(a,10);return a.end()}function cb(e,r,t){tb(e,"Font",es({sz:12,color:{theme:1},name:"Arial",family:2,scheme:"minor"},t))}function ub(e,r,t){if(!r)return;[[5,8],[23,26],[41,44],[50,392]].forEach(function(a){for(var n=a[0];n<=a[1];++n)if(r[n]!=null)tb(e,"Format",ss(n,r[n],t))})}function hb(e,r){var t=Jr(19);t._W(4,2151);t._W(4,0);t._W(4,0);t._W(2,3);t._W(1,1);t._W(4,0);tb(e,"FeatHdr",t);t=Jr(39);t._W(4,2152);t._W(4,0);t._W(4,0);t._W(2,3);t._W(1,0);t._W(4,0);t._W(2,1);t._W(4,4);t._W(2,0);Ci(wt(r["!ref"]||"A1"),t);t._W(4,4);tb(e,"Feat",t)}function db(e,r){for(var t=0;t<16;++t)tb(e,"XF",ps({numFmtId:0,style:true},0,r));r.cellXfs.forEach(function(t){tb(e,"XF",ps(t,0,r))})}function vb(e,r){for(var t=0;t<r["!links"].length;++t){var a=r["!links"][t];tb(e,"HLink",Vs(a));if(a[1].Tooltip)tb(e,"HLinkTooltip",Gs(a))}delete r["!links"]}function pb(e,r,t){if(!r)return;var a=0;r.forEach(function(r,t){if(++a<=256&&r){tb(e,"ColInfo",Js(vh(t,r),t))}})}function bb(e,r,t,a,n){var i=16+bh(n.cellXfs,r,n);if(r.v==null&&!r.bf){tb(e,"Blank",mi(t,a,i));return}if(r.bf)tb(e,"Formula",Qu(r,t,a,n,i));else switch(r.t){case"d":;case"n":var s=r.t=="d"?ee(le(r.v)):r.v;tb(e,"Number",ks(t,a,s,i,n));break;case"b":;case"e":tb(e,517,Es(t,a,r.v,i,n,r.t));break;case"s":;case"str":if(n.bookSST){var f=dh(n.Strings,r.v,n.revStrings);tb(e,"LabelSst",ts(t,a,f,i,n))}else tb(e,"Label",ns(t,a,(r.v||"").slice(0,255),i,n));break;default:tb(e,"Blank",mi(t,a,i));}}function mb(e,r,t){var a=qr();var n=t.SheetNames[e],i=t.Sheets[n]||{};var s=(t||{}).Workbook||{};var f=(s.Sheets||[])[e]||{};var l=Array.isArray(i);var o=r.biff==8;var c,u="",h=[];var d=wt(i["!ref"]||"A1");var v=o?65536:16384;if(d.e.c>255||d.e.r>=v){if(r.WTF)throw new Error("Range "+(i["!ref"]||"A1")+" exceeds format limit A1:IV16384");d.e.c=Math.min(d.e.c,255);d.e.r=Math.min(d.e.c,v-1)}tb(a,2057,Oi(t,16,r));tb(a,"CalcMode",Yn(1));tb(a,"CalcCount",Yn(100));tb(a,"CalcRefMode",$n(true));tb(a,"CalcIter",$n(false));tb(a,"CalcDelta",qt(.001));tb(a,"CalcSaveRecalc",$n(true));tb(a,"PrintRowCol",$n(false));tb(a,"PrintGrid",$n(false));tb(a,"GridSet",Yn(1));tb(a,"Guts",ms([0,0]));tb(a,"HCenter",$n(false));tb(a,"VCenter",$n(false));if(o)pb(a,i["!cols"],i);tb(a,512,os(d,r));if(o)i["!links"]=[];for(var p=d.s.r;p<=d.e.r;++p){u=lt(p);for(var b=d.s.c;b<=d.e.c;++b){if(p===d.s.r)h[b]=ht(b);c=h[b]+u;var m=l?(i[p]||[])[b]:i[c];if(!m)continue;bb(a,m,p,b,r);if(o&&m.l)i["!links"].push([c,m.l])}}var g=f.CodeName||f.name||n;if(o)tb(a,"Window2",Ji((s.Views||[])[0]));if(o&&(i["!merges"]||[]).length)tb(a,"MergeCells",Ns(i["!merges"]));if(o)vb(a,i);tb(a,"CodeName",ii(g,r));if(o)hb(a,i);tb(a,"EOF");return a.end()}function gb(e,r,t){var a=qr();var n=(e||{}).Workbook||{};var i=n.Sheets||[];var s=n.WBProps||{};var f=t.biff==8,l=t.biff==5;tb(a,2057,Oi(e,5,t));if(t.bookType=="xla")tb(a,"Addin");tb(a,"InterfaceHdr",f?Yn(1200):null);tb(a,"Mms",Gn(2));if(l)tb(a,"ToolbarHdr");if(l)tb(a,"ToolbarEnd");tb(a,"InterfaceEnd");tb(a,"WriteAccess",Mi("SheetJS",t));tb(a,"CodePage",Yn(f?1200:1252));if(f)tb(a,"DSF",Yn(0));if(f)tb(a,"Excel9File");tb(a,"RRTabId",ef(e.SheetNames.length));if(f&&e.vbaraw)tb(a,"ObProj");if(f&&e.vbaraw){var o=s.CodeName||"ThisWorkbook";tb(a,"CodeName",ii(o,t))}tb(a,"BuiltInFnGroupCount",Yn(17));tb(a,"WinProtect",$n(false));tb(a,"Protect",$n(false));tb(a,"Password",Yn(0));if(f)tb(a,"Prot4Rev",$n(false));if(f)tb(a,"Prot4RevPass",Yn(0));tb(a,"Window1",Yi(t));tb(a,"Backup",$n(false));tb(a,"HideObj",Yn(0));tb(a,"Date1904",$n(Rv(e)=="true"));tb(a,"CalcPrecision",$n(true));if(f)tb(a,"RefreshAll",$n(false));tb(a,"BookBool",Yn(0));cb(a,e,t);ub(a,e.SSF,t);db(a,t);if(f)tb(a,"UsesELFs",$n(false));var c=a.end();var u=qr();if(f)tb(u,"Country",js());if(f&&t.Strings)ab(u,"SST",Vi(t.Strings,t));tb(u,"EOF");var h=u.end();var d=qr();var v=0,p=0;for(p=0;p<e.SheetNames.length;++p)v+=(f?12:11)+(f?2:1)*e.SheetNames[p].length;var b=c.length+v+h.length;for(p=0;p<e.SheetNames.length;++p){var m=i[p]||{};tb(d,"BoundSheet8",Hi({pos:b,hs:m.Hidden||0,dt:0,name:e.SheetNames[p]},t));b+=r[p].length}var g=d.end();if(v!=g.length)throw new Error("BS8 "+v+" != "+g.length);var E=[];if(c.length)E.push(c);if(g.length)E.push(g);if(h.length)E.push(h);return br([E])}function Eb(e,r){var t=r||{};var a=[];if(e&&!e.SSF){e.SSF=D.get_table()}if(e&&e.SSF){O(D);D.load_table(e.SSF);t.revssf=J(e.SSF);t.revssf[e.SSF[65535]]=0;t.ssf=e.SSF}t.Strings=[];t.Strings.Count=0;t.Strings.Unique=0;$b(t);t.cellXfs=[];bh(t.cellXfs,{},{revssf:{General:0}});if(!e.Props)e.Props={};for(var n=0;n<e.SheetNames.length;++n)a[a.length]=mb(n,t,e);a.unshift(gb(e,a,t));return br([a])}function wb(e,r){var t=r||{};
switch(t.biff||2){case 8:;case 5:return Eb(e,r);case 4:;case 3:;case 2:return ob(e,r);}throw new Error("invalid type "+t.bookType+" for BIFF")}var kb=function(){function e(e,r){var t=r||{};if(b!=null&&t.dense==null)t.dense=b;var a=t.dense?[]:{};e=e.replace(/<!--.*?-->/g,"");var n=e.match(/<table/i);if(!n)throw new Error("Invalid HTML: could not find <table>");var i=e.match(/<\/table/i);var s=n.index,f=i&&i.index||e.length;var l=pe(e.slice(s,f),/(:?<tr[^>]*>)/i,"<tr>");var o=-1,c=0,u=0,h=0;var d={s:{r:1e7,c:1e7},e:{r:0,c:0}};var v=[];for(s=0;s<l.length;++s){var p=l[s].trim();var m=p.slice(0,3).toLowerCase();if(m=="<tr"){++o;if(t.sheetRows&&t.sheetRows<=o){--o;break}c=0;continue}if(m!="<td"&&m!="<th")continue;var g=p.split(/<\/t[dh]>/i);for(f=0;f<g.length;++f){var E=g[f].trim();if(!E.match(/<t[dh]/i))continue;var w=E,k=0;while(w.charAt(0)=="<"&&(k=w.indexOf(">"))>-1)w=w.slice(k+1);for(var S=0;S<v.length;++S){var B=v[S];if(B.s.c==c&&B.s.r<o&&o<=B.e.r){c=B.e.c+1;S=-1}}var C=Oe(E.slice(0,E.indexOf(">")));h=C.colspan?+C.colspan:1;if((u=+C.rowspan)>1||h>1)v.push({s:{r:o,c:c},e:{r:o+(u||1)-1,c:c+h-1}});var T=C.t||C["data-t"]||"";if(!w.length){c+=h;continue}w=rr(w);if(d.s.r>o)d.s.r=o;if(d.e.r<o)d.e.r=o;if(d.s.c>c)d.s.c=c;if(d.e.c<c)d.e.c=c;if(!w.length)continue;var _={t:"s",v:w};if(t.raw||!w.trim().length||T=="s"){}else if(w==="TRUE")_={t:"b",v:true};else if(w==="FALSE")_={t:"b",v:false};else if(!isNaN(he(w)))_={t:"n",v:he(w)};else if(!isNaN(de(w).getDate())){_={t:"d",v:le(w)};if(!t.cellDates)_={t:"n",v:ee(_.v)};_.z=t.dateNF||D._table[14]}if(t.dense){if(!a[o])a[o]=[];a[o][c]=_}else a[mt({r:o,c:c})]=_;c+=h}}a["!ref"]=Et(d);if(v.length)a["!merges"]=v;return a}function r(r,t){var a=r.match(/<table.*?>[\s\S]*?<\/table>/gi);if(!a||a.length==0)throw new Error("Invalid HTML: could not find <table>");if(a.length==1)return Bt(e(a[0],t),t);var n=Im.book_new();a.forEach(function(r,a){Im.book_append_sheet(n,e(r,t),"Sheet"+(a+1))});return n}function t(e,r,t,a){var n=e["!merges"]||[];var i=[];for(var s=r.s.c;s<=r.e.c;++s){var f=0,l=0;for(var o=0;o<n.length;++o){if(n[o].s.r>t||n[o].s.c>s)continue;if(n[o].e.r<t||n[o].e.c<s)continue;if(n[o].s.r<t||n[o].s.c<s){f=-1;break}f=n[o].e.r-n[o].s.r+1;l=n[o].e.c-n[o].s.c+1;break}if(f<0)continue;var c=mt({r:t,c:s});var u=a.dense?(e[t]||[])[s]:e[c];var h=u&&u.v!=null&&(u.h||Ge(u.w||(St(u),u.w)||""))||"";var d={};if(f>1)d.rowspan=f;if(l>1)d.colspan=l;if(a.editable)h='<span contenteditable="true">'+h+"</span>";else if(u){d["data-t"]=u&&u.t||"z";if(u.v!=null)d["data-v"]=u.v;if(u.z!=null)d["data-z"]=u.z;if(u.l&&(u.l.Target||"#").charAt(0)!="#")h='<a href="'+u.l.Target+'">'+h+"</a>"}d.id=(a.id||"sjs")+"-"+c;i.push(or("td",h,d))}var v="<tr>";return v+i.join("")+"</tr>"}function a(e,r,t){var a=[];return a.join("")+"<table"+(t&&t.id?' id="'+t.id+'"':"")+">"}var n='<html><head><meta charset="utf-8"/><title>SheetJS Table Export</title></head><body>';var i="</body></html>";function s(e,r){var s=r||{};var f=s.header!=null?s.header:n;var l=s.footer!=null?s.footer:i;var o=[f];var c=gt(e["!ref"]);s.dense=Array.isArray(e);o.push(a(e,c,s));for(var u=c.s.r;u<=c.e.r;++u)o.push(t(e,c,u,s));o.push("</table>"+l);return o.join("")}return{to_workbook:r,to_sheet:e,_row:t,BEGIN:n,END:i,_preamble:a,from_sheet:s}}();function Sb(e,r,t){var a=t||{};if(b!=null)a.dense=b;var n=0,i=0;if(a.origin!=null){if(typeof a.origin=="number")n=a.origin;else{var s=typeof a.origin=="string"?bt(a.origin):a.origin;n=s.r;i=s.c}}var f=r.getElementsByTagName("tr");var l=Math.min(a.sheetRows||1e7,f.length);var o={s:{r:0,c:0},e:{r:n,c:i}};if(e["!ref"]){var c=gt(e["!ref"]);o.s.r=Math.min(o.s.r,c.s.r);o.s.c=Math.min(o.s.c,c.s.c);o.e.r=Math.max(o.e.r,c.e.r);o.e.c=Math.max(o.e.c,c.e.c);if(n==-1)o.e.r=n=c.e.r+1}var u=[],h=0;var d=e["!rows"]||(e["!rows"]=[]);var v=0,p=0,m=0,g=0,E=0,w=0;if(!e["!cols"])e["!cols"]=[];for(;v<f.length&&p<l;++v){var k=f[v];if(Tb(k)){if(a.display)continue;d[p]={hidden:true}}var S=k.children;for(m=g=0;m<S.length;++m){var B=S[m];if(a.display&&Tb(B))continue;var C=B.hasAttribute("data-v")?B.getAttribute("data-v"):B.hasAttribute("v")?B.getAttribute("v"):rr(B.innerHTML);var T=B.getAttribute("data-z")||B.getAttribute("z");for(h=0;h<u.length;++h){var _=u[h];if(_.s.c==g+i&&_.s.r<p+n&&p+n<=_.e.r){g=_.e.c+1-i;h=-1}}w=+B.getAttribute("colspan")||1;if((E=+B.getAttribute("rowspan")||1)>1||w>1)u.push({s:{r:p+n,c:g+i},e:{r:p+n+(E||1)-1,c:g+i+(w||1)-1}});var x={t:"s",v:C};var A=B.getAttribute("data-t")||B.getAttribute("t")||"";if(C!=null){if(C.length==0)x.t=A||"z";else if(a.raw||C.trim().length==0||A=="s"){}else if(C==="TRUE")x={t:"b",v:true};else if(C==="FALSE")x={t:"b",v:false};else if(!isNaN(he(C)))x={t:"n",v:he(C)};else if(!isNaN(de(C).getDate())){x={t:"d",v:le(C)};if(!a.cellDates)x={t:"n",v:ee(x.v)};x.z=a.dateNF||D._table[14]}}if(x.z===undefined&&T!=null)x.z=T;var y="",I=B.getElementsByTagName("A");if(I&&I.length)for(var R=0;R<I.length;++R)if(I[R].hasAttribute("href")){y=I[R].getAttribute("href");if(y.charAt(0)!="#")break}if(y&&y.charAt(0)!="#")x.l={Target:y};if(a.dense){if(!e[p+n])e[p+n]=[];e[p+n][g+i]=x}else e[mt({c:g+i,r:p+n})]=x;if(o.e.c<g+i)o.e.c=g+i;g+=w}++p}if(u.length)e["!merges"]=(e["!merges"]||[]).concat(u);o.e.r=Math.max(o.e.r,p-1+n);e["!ref"]=Et(o);if(p>=l)e["!fullref"]=Et((o.e.r=f.length-v+p-1+n,o));return e}function Bb(e,r){var t=r||{};var a=t.dense?[]:{};return Sb(a,e,r)}function Cb(e,r){return Bt(Bb(e,r),r)}function Tb(e){var r="";var t=_b(e);if(t)r=t(e).getPropertyValue("display");if(!r)r=e.style.display;return r==="none"}function _b(e){if(e.ownerDocument.defaultView&&typeof e.ownerDocument.defaultView.getComputedStyle==="function")return e.ownerDocument.defaultView.getComputedStyle;if(typeof getComputedStyle==="function")return getComputedStyle;return null}var xb=function(){var e=function(e){var r=e.replace(/[\t\r\n]/g," ").trim().replace(/ +/g," ").replace(/<text:s\/>/g," ").replace(/<text:s text:c="(\d+)"\/>/g,function(e,r){return Array(parseInt(r,10)+1).join(" ")}).replace(/<text:tab[^>]*\/>/g,"\t").replace(/<text:line-break\/>/g,"\n");var t=Le(r.replace(/<[^>]*>/g,""));return[t]};var r={day:["d","dd"],month:["m","mm"],year:["y","yy"],hours:["h","hh"],minutes:["m","mm"],seconds:["s","ss"],"am-pm":["A/P","AM/PM"],"day-of-week":["ddd","dddd"],era:["e","ee"],quarter:["\\Qm",'m\\"th quarter"']};return function t(a,n){var i=n||{};if(b!=null&&i.dense==null)i.dense=b;var s=Tp(a);var f=[],l;var o;var c={name:""},u="",h=0;var d;var v;var p={},m=[];var g=i.dense?[]:{};var E,w;var k={value:""};var S="",B=0,C;var T=[];var _=-1,x=-1,A={s:{r:1e6,c:1e7},e:{r:0,c:0}};var y=0;var I={};var R=[],F={},D=0,O=0;var P=[],N=1,M=1;var L=[];var U={Names:[]};var H={};var W=["",""];var V=[],X={};var G="",z=0;var j=false,$=false;var K=0;_p.lastIndex=0;s=s.replace(/<!--([\s\S]*?)-->/gm,"").replace(/<!DOCTYPE[^\[]*\[[^\]]*\]>/gm,"");while(E=_p.exec(s))switch(E[3]=E[3].replace(/_.*$/,"")){case"table":;case"工作表":if(E[1]==="/"){if(A.e.c>=A.s.c&&A.e.r>=A.s.r)g["!ref"]=Et(A);else g["!ref"]="A1:A1";if(i.sheetRows>0&&i.sheetRows<=A.e.r){g["!fullref"]=g["!ref"];A.e.r=i.sheetRows-1;g["!ref"]=Et(A)}if(R.length)g["!merges"]=R;if(P.length)g["!rows"]=P;d.name=d["名称"]||d.name;if(typeof JSON!=="undefined")JSON.stringify(d);m.push(d.name);p[d.name]=g;$=false}else if(E[0].charAt(E[0].length-2)!=="/"){d=Oe(E[0],false);_=x=-1;A.s.r=A.s.c=1e7;A.e.r=A.e.c=0;g=i.dense?[]:{};R=[];P=[];$=true}break;case"table-row-group":if(E[1]==="/")--y;else++y;break;case"table-row":;case"行":if(E[1]==="/"){_+=N;N=1;break}v=Oe(E[0],false);if(v["行号"])_=v["行号"]-1;else if(_==-1)_=0;N=+v["number-rows-repeated"]||1;if(N<10)for(K=0;K<N;++K)if(y>0)P[_+K]={level:y};x=-1;break;case"covered-table-cell":if(E[1]!=="/")++x;if(i.sheetStubs){if(i.dense){if(!g[_])g[_]=[];g[_][x]={t:"z"}}else g[mt({r:_,c:x})]={t:"z"}}S="";T=[];break;case"table-cell":;case"数据":if(E[0].charAt(E[0].length-2)==="/"){++x;k=Oe(E[0],false);M=parseInt(k["number-columns-repeated"]||"1",10);w={t:"z",v:null};if(k.formula&&i.cellFormula!=false)w.f=sh(Le(k.formula));if((k["数据类型"]||k["value-type"])=="string"){w.t="s";w.v=Le(k["string-value"]||"");if(i.dense){if(!g[_])g[_]=[];g[_][x]=w}else{g[mt({r:_,c:x})]=w}}x+=M-1}else if(E[1]!=="/"){++x;S="";B=0;T=[];M=1;var Y=N?_+N-1:_;if(x>A.e.c)A.e.c=x;if(x<A.s.c)A.s.c=x;if(_<A.s.r)A.s.r=_;if(Y>A.e.r)A.e.r=Y;k=Oe(E[0],false);V=[];X={};w={t:k["数据类型"]||k["value-type"],v:null};if(i.cellFormula){if(k.formula)k.formula=Le(k.formula);if(k["number-matrix-columns-spanned"]&&k["number-matrix-rows-spanned"]){D=parseInt(k["number-matrix-rows-spanned"],10)||0;O=parseInt(k["number-matrix-columns-spanned"],10)||0;F={s:{r:_,c:x},e:{r:_+D-1,c:x+O-1}};w.F=Et(F);L.push([F,w.F])}if(k.formula)w.f=sh(k.formula);else for(K=0;K<L.length;++K)if(_>=L[K][0].s.r&&_<=L[K][0].e.r)if(x>=L[K][0].s.c&&x<=L[K][0].e.c)w.F=L[K][1]}if(k["number-columns-spanned"]||k["number-rows-spanned"]){D=parseInt(k["number-rows-spanned"],10)||0;O=parseInt(k["number-columns-spanned"],10)||0;F={s:{r:_,c:x},e:{r:_+D-1,c:x+O-1}};R.push(F)}if(k["number-columns-repeated"])M=parseInt(k["number-columns-repeated"],10);switch(w.t){case"boolean":w.t="b";w.v=Ke(k["boolean-value"]);break;case"float":w.t="n";w.v=parseFloat(k.value);break;case"percentage":w.t="n";w.v=parseFloat(k.value);break;case"currency":w.t="n";w.v=parseFloat(k.value);break;case"date":w.t="d";w.v=le(k["date-value"]);if(!i.cellDates){w.t="n";w.v=ee(w.v)}w.z="m/d/yy";break;case"time":w.t="n";w.v=ie(k["time-value"])/86400;if(i.cellDates){w.t="d";w.v=ne(w.v)}w.z="HH:MM:SS";break;case"number":w.t="n";w.v=parseFloat(k["数据数值"]);break;default:if(w.t==="string"||w.t==="text"||!w.t){w.t="s";if(k["string-value"]!=null){S=Le(k["string-value"]);T=[]}}else throw new Error("Unsupported value type "+w.t);}}else{j=false;if(w.t==="s"){w.v=S||"";if(T.length)w.R=T;j=B==0}if(H.Target)w.l=H;if(V.length>0){w.c=V;V=[]}if(S&&i.cellText!==false)w.w=S;if(j){w.t="z";delete w.v}if(!j||i.sheetStubs){if(!(i.sheetRows&&i.sheetRows<=_)){for(var Q=0;Q<N;++Q){M=parseInt(k["number-columns-repeated"]||"1",10);if(i.dense){if(!g[_+Q])g[_+Q]=[];g[_+Q][x]=Q==0?w:ce(w);while(--M>0)g[_+Q][x+M]=ce(w)}else{g[mt({r:_+Q,c:x})]=w;while(--M>0)g[mt({r:_+Q,c:x+M})]=ce(w)}if(A.e.c<=x)A.e.c=x}}}M=parseInt(k["number-columns-repeated"]||"1",10);x+=M-1;M=0;w={};S="";T=[]}H={};break;case"document":;case"document-content":;case"电子表格文档":;case"spreadsheet":;case"主体":;case"scripts":;case"styles":;case"font-face-decls":;case"master-styles":if(E[1]==="/"){if((l=f.pop())[0]!==E[3])throw"Bad state: "+l}else if(E[0].charAt(E[0].length-2)!=="/")f.push([E[3],true]);break;case"annotation":if(E[1]==="/"){if((l=f.pop())[0]!==E[3])throw"Bad state: "+l;X.t=S;if(T.length)X.R=T;X.a=G;V.push(X)}else if(E[0].charAt(E[0].length-2)!=="/"){f.push([E[3],false])}G="";z=0;S="";B=0;T=[];break;case"creator":if(E[1]==="/"){G=s.slice(z,E.index)}else z=E.index+E[0].length;break;case"meta":;case"元数据":;case"settings":;case"config-item-set":;case"config-item-map-indexed":;case"config-item-map-entry":;case"config-item-map-named":;case"shapes":;case"frame":;case"text-box":;case"image":;case"data-pilot-tables":;case"list-style":;case"form":;case"dde-links":;case"event-listeners":;case"chart":if(E[1]==="/"){if((l=f.pop())[0]!==E[3])throw"Bad state: "+l}else if(E[0].charAt(E[0].length-2)!=="/")f.push([E[3],false]);S="";B=0;T=[];break;case"scientific-number":break;case"currency-symbol":break;case"currency-style":break;case"number-style":;case"percentage-style":;case"date-style":;case"time-style":if(E[1]==="/"){I[c.name]=u;if((l=f.pop())[0]!==E[3])throw"Bad state: "+l}else if(E[0].charAt(E[0].length-2)!=="/"){u="";c=Oe(E[0],false);f.push([E[3],true])}break;case"script":break;case"libraries":break;case"automatic-styles":break;case"default-style":;case"page-layout":break;case"style":break;case"map":break;case"font-face":break;case"paragraph-properties":break;case"table-properties":break;case"table-column-properties":break;case"table-row-properties":break;case"table-cell-properties":break;case"number":switch(f[f.length-1][0]){case"time-style":;case"date-style":o=Oe(E[0],false);u+=r[E[3]][o.style==="long"?1:0];break;}break;case"fraction":break;case"day":;case"month":;case"year":;case"era":;case"day-of-week":;case"week-of-year":;case"quarter":;case"hours":;case"minutes":;case"seconds":;case"am-pm":switch(f[f.length-1][0]){case"time-style":;case"date-style":o=Oe(E[0],false);u+=r[E[3]][o.style==="long"?1:0];break;}break;case"boolean-style":break;case"boolean":break;case"text-style":break;case"text":if(E[0].slice(-2)==="/>")break;else if(E[1]==="/")switch(f[f.length-1][0]){case"number-style":;case"date-style":;case"time-style":u+=s.slice(h,E.index);break;}else h=E.index+E[0].length;break;case"named-range":o=Oe(E[0],false);W=lh(o["cell-range-address"]);var J={Name:o.name,Ref:W[0]+"!"+W[1]};if($)J.Sheet=m.length;U.Names.push(J);break;case"text-content":break;case"text-properties":break;case"embedded-text":break;case"body":;case"电子表格":break;case"forms":break;case"table-column":break;case"table-header-rows":break;case"table-rows":break;case"table-column-group":break;case"table-header-columns":break;case"table-columns":break;case"null-date":break;case"graphic-properties":break;case"calculation-settings":break;case"named-expressions":break;case"label-range":break;case"label-ranges":break;case"named-expression":break;case"sort":break;case"sort-by":break;case"sort-groups":break;case"tab":break;case"line-break":break;case"span":break;case"p":;case"文本串":if(["master-styles"].indexOf(f[f.length-1][0])>-1)break;if(E[1]==="/"&&(!k||!k["string-value"])){var Z=e(s.slice(B,E.index),C);S=(S.length>0?S+"\n":"")+Z[0]}else{C=Oe(E[0],false);B=E.index+E[0].length}break;case"s":break;case"database-range":if(E[1]==="/")break;try{W=lh(Oe(E[0])["target-range-address"]);p[W[0]]["!autofilter"]={ref:W[1]}}catch(q){}break;case"date":break;case"object":break;case"title":;case"标题":break;case"desc":break;case"binary-data":break;case"table-source":break;case"scenario":break;case"iteration":break;case"content-validations":break;case"content-validation":break;case"help-message":break;case"error-message":break;case"database-ranges":break;case"filter":break;case"filter-and":break;case"filter-or":break;case"filter-condition":break;case"list-level-style-bullet":break;case"list-level-style-number":break;case"list-level-properties":break;case"sender-firstname":;case"sender-lastname":;case"sender-initials":;case"sender-title":;case"sender-position":;case"sender-email":;case"sender-phone-private":;case"sender-fax":;case"sender-company":;case"sender-phone-work":;case"sender-street":;case"sender-city":;case"sender-postal-code":;case"sender-country":;case"sender-state-or-province":;case"author-name":;case"author-initials":;case"chapter":;case"file-name":;case"template-name":;case"sheet-name":break;case"event-listener":break;case"initial-creator":;case"creation-date":;case"print-date":;case"generator":;case"document-statistic":;case"user-defined":;case"editing-duration":;case"editing-cycles":break;case"config-item":break;case"page-number":break;case"page-count":break;case"time":break;case"cell-range-source":break;case"detective":break;case"operation":break;case"highlighted-range":break;case"data-pilot-table":;case"source-cell-range":;case"source-service":;case"data-pilot-field":;case"data-pilot-level":;case"data-pilot-subtotals":;case"data-pilot-subtotal":;case"data-pilot-members":;case"data-pilot-member":;case"data-pilot-display-info":;case"data-pilot-sort-info":;case"data-pilot-layout-info":;case"data-pilot-field-reference":;case"data-pilot-groups":;case"data-pilot-group":;case"data-pilot-group-member":break;case"rect":break;case"dde-connection-decls":;case"dde-connection-decl":;case"dde-link":;case"dde-source":break;case"properties":break;case"property":break;case"a":if(E[1]!=="/"){H=Oe(E[0],false);if(!H.href)break;H.Target=Le(H.href);delete H.href;if(H.Target.charAt(0)=="#"&&H.Target.indexOf(".")>-1){W=lh(H.Target.slice(1));H.Target="#"+W[0]+"!"+W[1]}else if(H.Target.match(/^\.\.[\\\/]/))H.Target=H.Target.slice(3)}break;case"table-protection":break;case"data-pilot-grand-total":break;case"office-document-common-attrs":break;default:switch(E[2]){case"dc:":;case"calcext:":;case"loext:":;case"ooo:":;case"chartooo:":;case"draw:":;case"style:":;case"chart:":;case"form:":;case"uof:":;case"表:":;case"字:":break;default:if(i.WTF)throw new Error(E);};}var re={Sheets:p,SheetNames:m,Workbook:U};if(i.bookSheets)delete re.Sheets;return re}}();function Ab(e,r){r=r||{};if(Ee(e,"META-INF/manifest.xml"))$a(ke(e,"META-INF/manifest.xml"),r);var t=Se(e,"content.xml");if(!t)throw new Error("Missing content.xml in ODS / UOF file");var a=xb(Ye(t),r);if(Ee(e,"meta.xml"))a.Props=rn(ke(e,"meta.xml"));return a}function yb(e,r){return xb(e,r)}var Ib=function(){var e="<office:master-styles>"+'<style:master-page style:name="mp1" style:page-layout-name="mp1">'+"<style:header/>"+'<style:header-left style:display="false"/>'+"<style:footer/>"+'<style:footer-left style:display="false"/>'+"</style:master-page>"+"</office:master-styles>";var r="<office:document-styles "+lr({"xmlns:office":"urn:oasis:names:tc:opendocument:xmlns:office:1.0","xmlns:table":"urn:oasis:names:tc:opendocument:xmlns:table:1.0","xmlns:style":"urn:oasis:names:tc:opendocument:xmlns:style:1.0","xmlns:text":"urn:oasis:names:tc:opendocument:xmlns:text:1.0","xmlns:draw":"urn:oasis:names:tc:opendocument:xmlns:drawing:1.0","xmlns:fo":"urn:oasis:names:tc:opendocument:xmlns:xsl-fo-compatible:1.0","xmlns:xlink":"http://www.w3.org/1999/xlink","xmlns:dc":"http://purl.org/dc/elements/1.1/","xmlns:number":"urn:oasis:names:tc:opendocument:xmlns:datastyle:1.0","xmlns:svg":"urn:oasis:names:tc:opendocument:xmlns:svg-compatible:1.0","xmlns:of":"urn:oasis:names:tc:opendocument:xmlns:of:1.2","office:version":"1.2"})+">"+e+"</office:document-styles>";return function t(){return ye+r}}();var Rb=function(){var e=function(e){return We(e).replace(/  +/g,function(e){return'<text:s text:c="'+e.length+'"/>'}).replace(/\t/g,"<text:tab/>").replace(/\n/g,"</text:p><text:p>").replace(/^ /,"<text:s/>").replace(/ $/,"<text:s/>")};var r="          <table:table-cell />\n";var t="          <table:covered-table-cell/>\n";var a=function(a,n,i){var s=[];s.push('      <table:table table:name="'+We(n.SheetNames[i])+'" table:style-name="ta1">\n');var f=0,l=0,o=gt(a["!ref"]||"A1");var c=a["!merges"]||[],u=0;var h=Array.isArray(a);if(a["!cols"]){for(l=0;l<=o.e.c;++l)s.push("        <table:table-column"+(a["!cols"][l]?' table:style-name="co'+a["!cols"][l].ods+'"':"")+"></table:table-column>\n")}var d="",v=a["!rows"]||[];for(f=0;f<o.s.r;++f){d=v[f]?' table:style-name="ro'+v[f].ods+'"':"";s.push("        <table:table-row"+d+"></table:table-row>\n")}for(;f<=o.e.r;++f){d=v[f]?' table:style-name="ro'+v[f].ods+'"':"";s.push("        <table:table-row"+d+">\n");for(l=0;l<o.s.c;++l)s.push(r);for(;l<=o.e.c;++l){var p=false,b={},m="";for(u=0;u!=c.length;++u){if(c[u].s.c>l)continue;if(c[u].s.r>f)continue;if(c[u].e.c<l)continue;if(c[u].e.r<f)continue;if(c[u].s.c!=l||c[u].s.r!=f)p=true;b["table:number-columns-spanned"]=c[u].e.c-c[u].s.c+1;b["table:number-rows-spanned"]=c[u].e.r-c[u].s.r+1;break}if(p){s.push(t);continue}var g=mt({r:f,c:l}),E=h?(a[f]||[])[l]:a[g];if(E&&E.f){b["table:formula"]=We(fh(E.f));if(E.F){if(E.F.slice(0,g.length)==g){var w=gt(E.F);b["table:number-matrix-columns-spanned"]=w.e.c-w.s.c+1;b["table:number-matrix-rows-spanned"]=w.e.r-w.s.r+1}}}if(!E){s.push(r);continue}switch(E.t){case"b":m=E.v?"TRUE":"FALSE";b["office:value-type"]="boolean";b["office:boolean-value"]=E.v?"true":"false";break;case"n":m=E.w||String(E.v||0);b["office:value-type"]="float";b["office:value"]=E.v||0;break;case"s":;case"str":m=E.v==null?"":E.v;b["office:value-type"]="string";break;case"d":m=E.w||le(E.v).toISOString();b["office:value-type"]="date";b["office:date-value"]=le(E.v).toISOString();b["table:style-name"]="ce1";break;default:s.push(r);continue;}var k=e(m);if(E.l&&E.l.Target){var S=E.l.Target;S=S.charAt(0)=="#"?"#"+oh(S.slice(1)):S;if(S.charAt(0)!="#"&&!S.match(/^\w+:/))S="../"+S;k=or("text:a",k,{"xlink:href":S.replace(/&/g,"&amp;")})}s.push("          "+or("table:table-cell",or("text:p",k,{}),b)+"\n")}s.push("        </table:table-row>\n")}s.push("      </table:table>\n");return s.join("")};var n=function(e,r){e.push(" <office:automatic-styles>\n");e.push('  <number:date-style style:name="N37" number:automatic-order="true">\n');e.push('   <number:month number:style="long"/>\n');e.push("   <number:text>/</number:text>\n");e.push('   <number:day number:style="long"/>\n');e.push("   <number:text>/</number:text>\n");e.push("   <number:year/>\n");e.push("  </number:date-style>\n");var t=0;r.SheetNames.map(function(e){return r.Sheets[e]}).forEach(function(r){if(!r)return;if(r["!cols"]){for(var a=0;a<r["!cols"].length;++a)if(r["!cols"][a]){var n=r["!cols"][a];if(n.width==null&&n.wpx==null&&n.wch==null)continue;Bl(n);n.ods=t;var i=r["!cols"][a].wpx+"px";e.push('  <style:style style:name="co'+t+'" style:family="table-column">\n');e.push('   <style:table-column-properties fo:break-before="auto" style:column-width="'+i+'"/>\n');e.push("  </style:style>\n");++t}}});var a=0;r.SheetNames.map(function(e){return r.Sheets[e]}).forEach(function(r){if(!r)return;if(r["!rows"]){for(var t=0;t<r["!rows"].length;++t)if(r["!rows"][t]){r["!rows"][t].ods=a;var n=r["!rows"][t].hpx+"px";e.push('  <style:style style:name="ro'+a+'" style:family="table-row">\n');e.push('   <style:table-row-properties fo:break-before="auto" style:row-height="'+n+'"/>\n');e.push("  </style:style>\n");++a}}});e.push('  <style:style style:name="ta1" style:family="table" style:master-page-name="mp1">\n');e.push('   <style:table-properties table:display="true" style:writing-mode="lr-tb"/>\n');e.push("  </style:style>\n");e.push('  <style:style style:name="ce1" style:family="table-cell" style:parent-style-name="Default" style:data-style-name="N37"/>\n');e.push(" </office:automatic-styles>\n")};return function i(e,r){var t=[ye];var i=lr({"xmlns:office":"urn:oasis:names:tc:opendocument:xmlns:office:1.0","xmlns:table":"urn:oasis:names:tc:opendocument:xmlns:table:1.0","xmlns:style":"urn:oasis:names:tc:opendocument:xmlns:style:1.0","xmlns:text":"urn:oasis:names:tc:opendocument:xmlns:text:1.0","xmlns:draw":"urn:oasis:names:tc:opendocument:xmlns:drawing:1.0","xmlns:fo":"urn:oasis:names:tc:opendocument:xmlns:xsl-fo-compatible:1.0","xmlns:xlink":"http://www.w3.org/1999/xlink","xmlns:dc":"http://purl.org/dc/elements/1.1/","xmlns:meta":"urn:oasis:names:tc:opendocument:xmlns:meta:1.0","xmlns:number":"urn:oasis:names:tc:opendocument:xmlns:datastyle:1.0","xmlns:presentation":"urn:oasis:names:tc:opendocument:xmlns:presentation:1.0","xmlns:svg":"urn:oasis:names:tc:opendocument:xmlns:svg-compatible:1.0","xmlns:chart":"urn:oasis:names:tc:opendocument:xmlns:chart:1.0","xmlns:dr3d":"urn:oasis:names:tc:opendocument:xmlns:dr3d:1.0","xmlns:math":"http://www.w3.org/1998/Math/MathML","xmlns:form":"urn:oasis:names:tc:opendocument:xmlns:form:1.0","xmlns:script":"urn:oasis:names:tc:opendocument:xmlns:script:1.0","xmlns:ooo":"http://openoffice.org/2004/office","xmlns:ooow":"http://openoffice.org/2004/writer","xmlns:oooc":"http://openoffice.org/2004/calc","xmlns:dom":"http://www.w3.org/2001/xml-events","xmlns:xforms":"http://www.w3.org/2002/xforms","xmlns:xsd":"http://www.w3.org/2001/XMLSchema","xmlns:xsi":"http://www.w3.org/2001/XMLSchema-instance","xmlns:sheet":"urn:oasis:names:tc:opendocument:sh33tjs:1.0","xmlns:rpt":"http://openoffice.org/2005/report","xmlns:of":"urn:oasis:names:tc:opendocument:xmlns:of:1.2","xmlns:xhtml":"http://www.w3.org/1999/xhtml","xmlns:grddl":"http://www.w3.org/2003/g/data-view#","xmlns:tableooo":"http://openoffice.org/2009/table","xmlns:drawooo":"http://openoffice.org/2010/draw","xmlns:calcext":"urn:org:documentfoundation:names:experimental:calc:xmlns:calcext:1.0","xmlns:loext":"urn:org:documentfoundation:names:experimental:office:xmlns:loext:1.0","xmlns:field":"urn:openoffice:names:experimental:ooo-ms-interop:xmlns:field:1.0","xmlns:formx":"urn:openoffice:names:experimental:ooxml-odf-interop:xmlns:form:1.0","xmlns:css3t":"http://www.w3.org/TR/css3-text/","office:version":"1.2"});var s=lr({"xmlns:config":"urn:oasis:names:tc:opendocument:xmlns:config:1.0","office:mimetype":"application/vnd.oasis.opendocument.spreadsheet"});if(r.bookType=="fods"){t.push("<office:document"+i+s+">\n");t.push(Za().replace(/office:document-meta/g,"office:meta"))}else t.push("<office:document-content"+i+">\n");n(t,e);t.push("  <office:body>\n");t.push("    <office:spreadsheet>\n");for(var f=0;f!=e.SheetNames.length;++f)t.push(a(e.Sheets[e.SheetNames[f]],e,f,r));t.push("    </office:spreadsheet>\n");t.push("  </office:body>\n");if(r.bookType=="fods")t.push("</office:document>");else t.push("</office:document-content>");return t.join("")}}();function Fb(e,r){if(r.bookType=="fods")return Rb(e,r);var t=_e();var a="";var n=[];var i=[];a="mimetype";Ce(t,a,"application/vnd.oasis.opendocument.spreadsheet");a="content.xml";Ce(t,a,Rb(e,r));n.push([a,"text/xml"]);i.push([a,"ContentFile"]);a="styles.xml";Ce(t,a,Ib(e,r));n.push([a,"text/xml"]);i.push([a,"StylesFile"]);a="meta.xml";Ce(t,a,ye+Za());n.push([a,"text/xml"]);i.push([a,"MetadataFile"]);a="manifest.rdf";Ce(t,a,Ja(i));n.push([a,"application/rdf+xml"]);a="META-INF/manifest.xml";Ce(t,a,Ka(n));return t}function Db(e,r){if(!r)return 0;var t=e.SheetNames.indexOf(r);if(t==-1)throw new Error("Sheet not found: "+r);return t}function Ob(e){return function r(t,a){var n=Db(t,a.sheet);return e.from_sheet(t.Sheets[t.SheetNames[n]],a,t)}}var Pb=Ob(kb);var Nb=Ob({from_sheet:Tm});var Mb=Ob(typeof pf!=="undefined"?pf:{});var Lb=Ob(typeof bf!=="undefined"?bf:{});var Ub=Ob(typeof gf!=="undefined"?gf:{});var Hb=Ob(typeof ll!=="undefined"?ll:{});var Wb=Ob({from_sheet:_m});var Vb=Ob(typeof vf!=="undefined"?vf:{});var Xb=Ob(typeof mf!=="undefined"?mf:{});var Gb=Ob(typeof wf!=="undefined"?{from_sheet:wf.sheet_to_wk1}:{});function zb(e){return function r(t){for(var a=0;a!=e.length;++a){var n=e[a];if(t[n[0]]===undefined)t[n[0]]=n[1];if(n[2]==="n")t[n[0]]=Number(t[n[0]])}}}var jb=function(e){zb([["cellNF",false],["cellHTML",true],["cellFormula",true],["cellStyles",false],["cellText",true],["cellDates",false],["sheetStubs",false],["sheetRows",0,"n"],["bookDeps",false],["bookSheets",false],["bookProps",false],["bookFiles",false],["bookVBA",false],["password",""],["WTF",false]])(e)};var $b=zb([["cellDates",false],["bookSST",false],["bookType","xlsx"],["compression",false],["WTF",false]]);function Kb(e){if(Ua.WS.indexOf(e)>-1)return"sheet";if(Ua.CS&&e==Ua.CS)return"chart";if(Ua.DS&&e==Ua.DS)return"dialog";if(Ua.MS&&e==Ua.MS)return"macro";return e&&e.length?e:"sheet"}function Yb(e,r){if(!e)return 0;try{e=r.map(function a(r){if(!r.id)r.id=r.strRelID;return[r.name,e["!id"][r.id].Target,Kb(e["!id"][r.id].Type)]})}catch(t){return null}return!e||e.length===0?null:e}function Qb(e,r,t,a,n,i,s,f,l,o,c,u){try{i[a]=Wa(Se(e,t,true),r);var h=ke(e,r);var d;switch(f){case"sheet":d=qv(h,r,n,l,i[a],o,c,u);break;case"chart":d=ep(h,r,n,l,i[a],o,c,u);if(!d||!d["!drawel"])break;var v=Ae(d["!drawel"].Target,r);var p=Ha(v);var b=Uo(Se(e,v,true),Wa(Se(e,p,true),v));var m=Ae(b,v);var g=Ha(m);d=mv(Se(e,m,true),m,l,Wa(Se(e,g,true),m),o,d);break;case"macro":d=rp(h,r,n,l,i[a],o,c,u);break;case"dialog":d=tp(h,r,n,l,i[a],o,c,u);break;default:throw new Error("Unrecognized sheet type "+f);}s[a]=d;var E=[];if(i&&i[a])K(i[a]).forEach(function(t){if(i[a][t].Type==Ua.CMNT){var n=Ae(i[a][t].Target,r);E=sp(ke(e,n,true),n,l);if(!E||!E.length)return;Vo(d,E)}})}catch(w){if(l.WTF)throw w}}function Jb(e){return e.charAt(0)=="/"?e.slice(1):e}function Zb(e,r){O(D);r=r||{};jb(r);if(Ee(e,"META-INF/manifest.xml"))return Ab(e,r);if(Ee(e,"objectdata.xml"))return Ab(e,r);if(Ee(e,"Index/Document.iwa"))throw new Error("Unsupported NUMBERS file");var t=Be(e);var a=Pa(Se(e,"[Content_Types].xml"));var n=false;var i,s;if(a.workbooks.length===0){s="xl/workbook.xml";if(ke(e,s,true))a.workbooks.push(s)}if(a.workbooks.length===0){s="xl/workbook.bin";if(!ke(e,s,true))throw new Error("Could not find workbook");a.workbooks.push(s);n=true}if(a.workbooks[0].slice(-3)=="bin")n=true;var f={};var l={};if(!r.bookSheets&&!r.bookProps){ch=[];if(a.sst)try{ch=ip(ke(e,Jb(a.sst)),a.sst,r)}catch(o){if(r.WTF)throw o}if(r.cellStyles&&a.themes.length)f=np(Se(e,a.themes[0].replace(/^\//,""),true)||"",a.themes[0],r);if(a.style)l=ap(ke(e,Jb(a.style)),a.style,f,r)}a.links.map(function(t){try{var a=Wa(Se(e,Ha(Jb(t))),t);return lp(ke(e,Jb(t)),a,t,r)}catch(n){}});var c=Zv(ke(e,Jb(a.workbooks[0])),a.workbooks[0],r);var u={},h="";if(a.coreprops.length){h=ke(e,Jb(a.coreprops[0]),true);if(h)u=rn(h);if(a.extprops.length!==0){h=ke(e,Jb(a.extprops[0]),true);if(h)on(h,u,r)}}var d={};if(!r.bookSheets||r.bookProps){if(a.custprops.length!==0){h=Se(e,Jb(a.custprops[0]),true);if(h)d=dn(h,r)}}var v={};if(r.bookSheets||r.bookProps){if(c.Sheets)i=c.Sheets.map(function I(e){return e.name});else if(u.Worksheets&&u.SheetNames.length>0)i=u.SheetNames;if(r.bookProps){v.Props=u;v.Custprops=d}if(r.bookSheets&&typeof i!=="undefined")v.SheetNames=i;if(r.bookSheets?v.SheetNames:r.bookProps)return v}i={};var p={};if(r.bookDeps&&a.calcchain)p=fp(ke(e,Jb(a.calcchain)),a.calcchain,r);var b=0;var m={};var g,E;{var w=c.Sheets;u.Worksheets=w.length;u.SheetNames=[];for(var k=0;k!=w.length;++k){u.SheetNames[k]=w[k].name}}var S=n?"bin":"xml";var B=a.workbooks[0].lastIndexOf("/");var C=(a.workbooks[0].slice(0,B+1)+"_rels/"+a.workbooks[0].slice(B+1)+".rels").replace(/^\//,"");if(!Ee(e,C))C="xl/_rels/workbook."+S+".rels";var T=Wa(Se(e,C,true),C);if(T)T=Yb(T,c.Sheets);var _=ke(e,"xl/worksheets/sheet.xml",true)?1:0;e:for(b=0;b!=u.Worksheets;++b){var x="sheet";if(T&&T[b]){g="xl/"+T[b][1].replace(/[\/]?xl\//,"");if(!Ee(e,g))g=T[b][1];if(!Ee(e,g))g=C.replace(/_rels\/.*$/,"")+T[b][1];x=T[b][2]}else{g="xl/worksheets/sheet"+(b+1-_)+"."+S;g=g.replace(/sheet0\./,"sheet.")}E=g.replace(/^(.*)(\/)([^\/]*)$/,"$1/_rels/$3.rels");if(r&&r.sheets!=null)switch(typeof r.sheets){case"number":if(b!=r.sheets)continue e;break;case"string":if(u.SheetNames[b].toLowerCase()!=r.sheets.toLowerCase())continue e;break;default:if(Array.isArray&&Array.isArray(r.sheets)){var A=false;for(var y=0;y!=r.sheets.length;++y){if(typeof r.sheets[y]=="number"&&r.sheets[y]==b)A=1;if(typeof r.sheets[y]=="string"&&r.sheets[y].toLowerCase()==u.SheetNames[b].toLowerCase())A=1}if(!A)continue e};}Qb(e,g,E,u.SheetNames[b],b,m,i,x,r,c,f,l)}v={Directory:a,Workbook:c,Props:u,Custprops:d,Deps:p,Sheets:i,SheetNames:u.SheetNames,Strings:ch,Styles:l,Themes:f,SSF:D.get_table()};if(r&&r.bookFiles){if(e.files){v.keys=t;v.files=e.files}else{v.keys=[];v.files={};e.FullPaths.forEach(function(r,t){r=r.replace(/^Root Entry[\/]/,"");v.keys.push(r);v.files[r]=e.FileIndex[t]})}}if(r&&r.bookVBA){if(a.vba.length>0)v.vbaraw=ke(e,Jb(a.vba[0]),true);else if(a.defaults&&a.defaults.bin===Zo)v.vbaraw=ke(e,"xl/vbaProject.bin",true)}return v}function qb(e,r){var t=r||{};var a="Workbook",n=V.find(e,a);try{a="/!DataSpaces/Version";n=V.find(e,a);if(!n||!n.content)throw new Error("ECMA-376 Encrypted file missing "+a);Wf(n.content);a="/!DataSpaces/DataSpaceMap";n=V.find(e,a);if(!n||!n.content)throw new Error("ECMA-376 Encrypted file missing "+a);var i=Xf(n.content);if(i.length!==1||i[0].comps.length!==1||i[0].comps[0].t!==0||i[0].name!=="StrongEncryptionDataSpace"||i[0].comps[0].v!=="EncryptedPackage")throw new Error("ECMA-376 Encrypted file bad "+a);a="/!DataSpaces/DataSpaceInfo/StrongEncryptionDataSpace";n=V.find(e,a);if(!n||!n.content)throw new Error("ECMA-376 Encrypted file missing "+a);var s=Gf(n.content);if(s.length!=1||s[0]!="StrongEncryptionTransform")throw new Error("ECMA-376 Encrypted file bad "+a);a="/!DataSpaces/TransformInfo/StrongEncryptionTransform/!Primary";n=V.find(e,a);if(!n||!n.content)throw new Error("ECMA-376 Encrypted file missing "+a);jf(n.content)}catch(f){}a="/EncryptionInfo";n=V.find(e,a);if(!n||!n.content)throw new Error("ECMA-376 Encrypted file missing "+a);var l=Yf(n.content);a="/EncryptedPackage";
n=V.find(e,a);if(!n||!n.content)throw new Error("ECMA-376 Encrypted file missing "+a);if(l[0]==4&&typeof decrypt_agile!=="undefined")return decrypt_agile(l[1],n.content,t.password||"",t);if(l[0]==2&&typeof decrypt_std76!=="undefined")return decrypt_std76(l[1],n.content,t.password||"",t);throw new Error("File is password-protected")}function em(e,r){Ho=1024;if(r.bookType=="ods")return Fb(e,r);if(e&&!e.SSF){e.SSF=D.get_table()}if(e&&e.SSF){O(D);D.load_table(e.SSF);r.revssf=J(e.SSF);r.revssf[e.SSF[65535]]=0;r.ssf=e.SSF}r.rels={};r.wbrels={};r.Strings=[];r.Strings.Count=0;r.Strings.Unique=0;if(hh)r.revStrings=new Map;else{r.revStrings={};r.revStrings.foo=[];delete r.revStrings.foo}var t=r.bookType=="xlsb"?"bin":"xml";var a=rc.indexOf(r.bookType)>-1;var n=Oa();$b(r=r||{});var i=_e();var s="",f=0;r.cellXfs=[];bh(r.cellXfs,{},{revssf:{General:0}});if(!e.Props)e.Props={};s="docProps/core.xml";Ce(i,s,nn(e.Props,r));n.coreprops.push(s);za(r.rels,2,s,Ua.CORE_PROPS);s="docProps/app.xml";if(e.Props&&e.Props.SheetNames){}else if(!e.Workbook||!e.Workbook.Sheets)e.Props.SheetNames=e.SheetNames;else{var l=[];for(var o=0;o<e.SheetNames.length;++o)if((e.Workbook.Sheets[o]||{}).Hidden!=2)l.push(e.SheetNames[o]);e.Props.SheetNames=l}e.Props.Worksheets=e.Props.SheetNames.length;Ce(i,s,un(e.Props,r));n.extprops.push(s);za(r.rels,3,s,Ua.EXT_PROPS);if(e.Custprops!==e.Props&&K(e.Custprops||{}).length>0){s="docProps/custom.xml";Ce(i,s,pn(e.Custprops,r));n.custprops.push(s);za(r.rels,4,s,Ua.CUST_PROPS)}for(f=1;f<=e.SheetNames.length;++f){var c={"!id":{}};var u=e.Sheets[e.SheetNames[f-1]];var h=(u||{})["!type"]||"sheet";switch(h){case"chart":;default:s="xl/worksheets/sheet"+f+"."+t;Ce(i,s,cp(f-1,s,r,e,c));n.sheets.push(s);za(r.wbrels,-1,"worksheets/sheet"+f+"."+t,Ua.WS[0]);}if(u){var d=u["!comments"];var v=false;if(d&&d.length>0){var p="xl/comments"+f+"."+t;Ce(i,p,vp(d,p,r));n.comments.push(p);za(c,-1,"../comments"+f+"."+t,Ua.CMNT);v=true}if(u["!legacy"]){if(v)Ce(i,"xl/drawings/vmlDrawing"+f+".vml",Wo(f,u["!comments"]))}delete u["!comments"];delete u["!legacy"]}if(c["!id"].rId1)Ce(i,Ha(s),Xa(c))}if(r.Strings!=null&&r.Strings.length>0){s="xl/sharedStrings."+t;Ce(i,s,dp(r.Strings,s,r));n.strs.push(s);za(r.wbrels,-1,"sharedStrings."+t,Ua.SST)}s="xl/workbook."+t;Ce(i,s,op(e,s,r));n.workbooks.push(s);za(r.rels,1,s,Ua.WB);s="xl/theme/theme1.xml";Ce(i,s,To(e.Themes,r));n.themes.push(s);za(r.wbrels,-1,"theme/theme1.xml",Ua.THEME);s="xl/styles."+t;Ce(i,s,hp(e,s,r));n.styles.push(s);za(r.wbrels,-1,"styles."+t,Ua.STY);if(e.vbaraw&&a){s="xl/vbaProject.bin";Ce(i,s,e.vbaraw);n.vba.push(s);za(r.wbrels,-1,"vbaProject.bin",Ua.VBA)}Ce(i,"[Content_Types].xml",La(n,r));Ce(i,"_rels/.rels",Xa(r.rels));Ce(i,"xl/_rels/workbook."+t+".rels",Xa(r.wbrels));delete r.revssf;delete r.ssf;return i}function rm(e,r){var t="";switch((r||{}).type||"base64"){case"buffer":return[e[0],e[1],e[2],e[3],e[4],e[5],e[6],e[7]];case"base64":t=g.decode(e.slice(0,12));break;case"binary":t=e;break;case"array":return[e[0],e[1],e[2],e[3],e[4],e[5],e[6],e[7]];default:throw new Error("Unrecognized type "+(r&&r.type||"undefined"));}return[t.charCodeAt(0),t.charCodeAt(1),t.charCodeAt(2),t.charCodeAt(3),t.charCodeAt(4),t.charCodeAt(5),t.charCodeAt(6),t.charCodeAt(7)]}function tm(e,r){if(V.find(e,"EncryptedPackage"))return qb(e,r);return Qp(e,r)}function am(e,r){var t,a=e;var n=r||{};if(!n.type)n.type=E&&Buffer.isBuffer(e)?"buffer":"base64";t=xe(a,n);return Zb(t,n)}function nm(e,r){var t=0;e:while(t<e.length)switch(e.charCodeAt(t)){case 10:;case 13:;case 32:++t;break;case 60:return Ap(e.slice(t),r);default:break e;}return gf.to_workbook(e,r)}function im(e,r){var t="",a=rm(e,r);switch(r.type){case"base64":t=g.decode(e);break;case"binary":t=e;break;case"buffer":t=e.toString("binary");break;case"array":t=oe(e);break;default:throw new Error("Unrecognized type "+r.type);}if(a[0]==239&&a[1]==187&&a[2]==191)t=Ye(t);return nm(t,r)}function sm(e,r){var t=e;if(r.type=="base64")t=g.decode(t);t=cptable.utils.decode(1200,t.slice(2),"str");r.type="binary";return nm(t,r)}function fm(e){return!e.match(/[^\x00-\x7F]/)?e:Qe(e)}function lm(e,r,t,a){if(a){t.type="string";return gf.to_workbook(e,t)}return gf.to_workbook(r,t)}function om(e,r){o();var t=r||{};if(typeof ArrayBuffer!=="undefined"&&e instanceof ArrayBuffer)return om(new Uint8Array(e),(t=ce(t),t.type="array",t));var a=e,n=[0,0,0,0],i=false;if(t.cellStyles){t.cellNF=true;t.sheetStubs=true}uh={};if(t.dateNF)uh.dateNF=t.dateNF;if(!t.type)t.type=E&&Buffer.isBuffer(e)?"buffer":"base64";if(t.type=="file"){t.type=E?"buffer":"binary";a=j(e)}if(t.type=="string"){i=true;t.type="binary";t.codepage=65001;a=fm(e)}if(t.type=="array"&&typeof Uint8Array!=="undefined"&&e instanceof Uint8Array&&typeof ArrayBuffer!=="undefined"){var s=new ArrayBuffer(3),f=new Uint8Array(s);f.foo="bar";if(!f.foo){t=ce(t);t.type="array";return om(y(a),t)}}switch((n=rm(a,t))[0]){case 208:if(n[1]===207&&n[2]===17&&n[3]===224&&n[4]===161&&n[5]===177&&n[6]===26&&n[7]===225)return tm(V.read(a,t),t);break;case 9:if(n[1]<=8)return Qp(a,t);break;case 60:return Ap(a,t);case 73:if(n[1]===73&&n[2]===42&&n[3]===0)throw new Error("TIFF Image File is not a spreadsheet");if(n[1]===68)return Ef(a,t);break;case 84:if(n[1]===65&&n[2]===66&&n[3]===76)return bf.to_workbook(a,t);break;case 80:return n[1]===75&&n[2]<9&&n[3]<9?am(a,t):lm(e,a,t,i);case 239:return n[3]===60?Ap(a,t):lm(e,a,t,i);case 255:if(n[1]===254){return sm(a,t)}break;case 0:if(n[1]===0&&n[2]>=2&&n[3]===0)return wf.to_workbook(a,t);break;case 3:;case 131:;case 139:;case 140:return vf.to_workbook(a,t);case 123:if(n[1]===92&&n[2]===114&&n[3]===116)return ll.to_workbook(a,t);break;case 10:;case 13:;case 32:return im(a,t);case 137:if(n[1]===80&&n[2]===78&&n[3]===71)throw new Error("PNG Image File is not a spreadsheet");break;}if(vf.versions.indexOf(n[0])>-1&&n[2]<=12&&n[3]<=31)return vf.to_workbook(a,t);return lm(e,a,t,i)}function cm(e,r){var t=r||{};t.type="file";return om(e,t)}function um(e,r){switch(r.type){case"base64":;case"binary":break;case"buffer":;case"array":r.type="";break;case"file":return z(r.file,V.write(e,{type:E?"buffer":""}));case"string":throw new Error("'string' output type invalid for '"+r.bookType+"' files");default:throw new Error("Unrecognized type "+r.type);}return V.write(e,r)}function hm(e,r){var t=ce(r||{});var a=em(e,t);var n={};if(t.compression)n.compression="DEFLATE";if(t.password)n.type=E?"nodebuffer":"string";else switch(t.type){case"base64":n.type="base64";break;case"binary":n.type="string";break;case"string":throw new Error("'string' output type invalid for '"+t.bookType+"' files");case"buffer":;case"file":n.type=E?"nodebuffer":"string";break;default:throw new Error("Unrecognized type "+t.type);}var i=a.FullPaths?V.write(a,{fileType:"zip",type:{nodebuffer:"buffer",string:"binary"}[n.type]||n.type}):a.generate(n);if(t.password&&typeof encrypt_agile!=="undefined")return um(encrypt_agile(i,t.password),t);if(t.type==="file")return z(t.file,i);return t.type=="string"?Ye(i):i}function dm(e,r){var t=r||{};var a=Jp(e,t);return um(a,t)}function vm(e,r,t){if(!t)t="";var a=t+e;switch(r.type){case"base64":return g.encode(Qe(a));case"binary":return Qe(a);case"string":return e;case"file":return z(r.file,a,"utf8");case"buffer":{if(E)return w(a,"utf8");else return vm(a,{type:"binary"}).split("").map(function(e){return e.charCodeAt(0)})};}throw new Error("Unrecognized type "+r.type)}function pm(e,r){switch(r.type){case"base64":return g.encode(e);case"binary":return e;case"string":return e;case"file":return z(r.file,e,"binary");case"buffer":{if(E)return w(e,"binary");else return e.split("").map(function(e){return e.charCodeAt(0)})};}throw new Error("Unrecognized type "+r.type)}function bm(e,r){switch(r.type){case"string":;case"base64":;case"binary":var t="";for(var a=0;a<e.length;++a)t+=String.fromCharCode(e[a]);return r.type=="base64"?g.encode(t):r.type=="string"?Ye(t):t;case"file":return z(r.file,e);case"buffer":return e;default:throw new Error("Unrecognized type "+r.type);}}function mm(e,r){o();Pv(e);var t=ce(r||{});if(t.cellStyles){t.cellNF=true;t.sheetStubs=true}if(t.type=="array"){t.type="binary";var a=mm(e,t);t.type="array";return _(a)}switch(t.bookType||"xlsb"){case"xml":;case"xlml":return vm(Wp(e,t),t);case"slk":;case"sylk":return vm(Mb(e,t),t);case"htm":;case"html":return vm(Pb(e,t),t);case"txt":return pm(Wb(e,t),t);case"csv":return vm(Nb(e,t),t,"\ufeff");case"dif":return vm(Lb(e,t),t);case"dbf":return bm(Vb(e,t),t);case"prn":return vm(Ub(e,t),t);case"rtf":return vm(Hb(e,t),t);case"eth":return vm(Xb(e,t),t);case"fods":return vm(Fb(e,t),t);case"wk1":return bm(Gb(e,t),t);case"wk3":return bm(wf.book_to_wk3(e,t),t);case"biff2":if(!t.biff)t.biff=2;case"biff3":if(!t.biff)t.biff=3;case"biff4":if(!t.biff)t.biff=4;return bm(wb(e,t),t);case"biff5":if(!t.biff)t.biff=5;case"biff8":;case"xla":;case"xls":if(!t.biff)t.biff=8;return dm(e,t);case"xlsx":;case"xlsm":;case"xlam":;case"xlsb":;case"ods":return hm(e,t);default:throw new Error("Unrecognized bookType |"+t.bookType+"|");}}function gm(e){if(e.bookType)return;var r={xls:"biff8",htm:"html",slk:"sylk",socialcalc:"eth",Sh33tJS:"WTF"};var t=e.file.slice(e.file.lastIndexOf(".")).toLowerCase();if(t.match(/^\.[a-z]+$/))e.bookType=t.slice(1);e.bookType=r[e.bookType]||e.bookType}function Em(e,r,t){var a=t||{};a.type="file";a.file=r;gm(a);return mm(e,a)}function wm(e,r,t,a){var n=t||{};n.type="file";n.file=e;gm(n);n.type="buffer";var i=a;if(!(i instanceof Function))i=t;return X.writeFile(e,mm(r,n),i)}function km(e,r,t,a,n,i,s,f){var l=lt(t);var o=f.defval,c=f.raw||!Object.prototype.hasOwnProperty.call(f,"raw");var u=true;var h=n===1?[]:{};if(n!==1){if(Object.defineProperty)try{Object.defineProperty(h,"__rowNum__",{value:t,enumerable:false})}catch(d){h.__rowNum__=t}else h.__rowNum__=t}if(!s||e[t])for(var v=r.s.c;v<=r.e.c;++v){var p=s?e[t][v]:e[a[v]+l];if(p===undefined||p.t===undefined){if(o===undefined)continue;if(i[v]!=null){h[i[v]]=o}continue}var b=p.v;switch(p.t){case"z":if(b==null)break;continue;case"e":b=b==0?null:void 0;break;case"s":;case"d":;case"b":;case"n":break;default:throw new Error("unrecognized type "+p.t);}if(i[v]!=null){if(b==null){if(p.t=="e"&&b===null)h[i[v]]=null;else if(o!==undefined)h[i[v]]=o;else if(c&&b===null)h[i[v]]=null;else continue}else{h[i[v]]=c||f.rawNumbers&&p.t=="n"?b:St(p,b,f)}if(b!=null)u=false}}return{row:h,isempty:u}}function Sm(e,r){if(e==null||e["!ref"]==null)return[];var t={t:"n",v:0},a=0,n=1,i=[],s=0,f="";var l={s:{r:0,c:0},e:{r:0,c:0}};var o=r||{};var c=o.range!=null?o.range:e["!ref"];if(o.header===1)a=1;else if(o.header==="A")a=2;else if(Array.isArray(o.header))a=3;else if(o.header==null)a=0;switch(typeof c){case"string":l=wt(c);break;case"number":l=wt(e["!ref"]);l.s.r=c;break;default:l=c;}if(a>0)n=0;var u=lt(l.s.r);var h=[];var d=[];var v=0,p=0;var b=Array.isArray(e);var m=l.s.r,g=0,E=0;if(b&&!e[m])e[m]=[];for(g=l.s.c;g<=l.e.c;++g){h[g]=ht(g);t=b?e[m][g]:e[h[g]+u];switch(a){case 1:i[g]=g-l.s.c;break;case 2:i[g]=h[g];break;case 3:i[g]=o.header[g-l.s.c];break;default:if(t==null)t={w:"__EMPTY",t:"s"};f=s=St(t,null,o);p=0;for(E=0;E<i.length;++E)if(i[E]==f)f=s+"_"+ ++p;i[g]=f;}}for(m=l.s.r+n;m<=l.e.r;++m){var w=km(e,l,m,h,a,i,b,o);if(w.isempty===false||(a===1?o.blankrows!==false:!!o.blankrows))d[v++]=w.row}d.length=v;return d}var Bm=/"/g;function Cm(e,r,t,a,n,i,s,f){var l=true;var o=[],c="",u=lt(t);for(var h=r.s.c;h<=r.e.c;++h){if(!a[h])continue;var d=f.dense?(e[t]||[])[h]:e[a[h]+u];if(d==null)c="";else if(d.v!=null){l=false;c=""+(f.rawNumbers&&d.t=="n"?d.v:St(d,null,f));for(var v=0,p=0;v!==c.length;++v)if((p=c.charCodeAt(v))===n||p===i||p===34||f.forceQuotes){c='"'+c.replace(Bm,'""')+'"';break}if(c=="ID")c='"ID"'}else if(d.f!=null&&!d.F){l=false;c="="+d.f;if(c.indexOf(",")>=0)c='"'+c.replace(Bm,'""')+'"'}else c="";o.push(c)}if(f.blankrows===false&&l)return null;return o.join(s)}function Tm(e,r){var t=[];var a=r==null?{}:r;if(e==null||e["!ref"]==null)return"";var n=wt(e["!ref"]);var i=a.FS!==undefined?a.FS:",",s=i.charCodeAt(0);var f=a.RS!==undefined?a.RS:"\n",l=f.charCodeAt(0);var o=new RegExp((i=="|"?"\\|":i)+"+$");var c="",u=[];a.dense=Array.isArray(e);var h=a.skipHidden&&e["!cols"]||[];var d=a.skipHidden&&e["!rows"]||[];for(var v=n.s.c;v<=n.e.c;++v)if(!(h[v]||{}).hidden)u[v]=ht(v);for(var p=n.s.r;p<=n.e.r;++p){if((d[p]||{}).hidden)continue;c=Cm(e,n,p,u,s,l,i,a);if(c==null){continue}if(a.strip)c=c.replace(o,"");t.push(c+f)}delete a.dense;return t.join("")}function _m(e,r){if(!r)r={};r.FS="\t";r.RS="\n";var t=Tm(e,r);if(typeof cptable=="undefined"||r.type=="string")return t;var a=cptable.utils.encode(1200,t,"str");return String.fromCharCode(255)+String.fromCharCode(254)+a}function xm(e){var r="",t,a="";if(e==null||e["!ref"]==null)return[];var n=wt(e["!ref"]),i="",s=[],f;var l=[];var o=Array.isArray(e);for(f=n.s.c;f<=n.e.c;++f)s[f]=ht(f);for(var c=n.s.r;c<=n.e.r;++c){i=lt(c);for(f=n.s.c;f<=n.e.c;++f){r=s[f]+i;t=o?(e[c]||[])[f]:e[r];a="";if(t===undefined)continue;else if(t.F!=null){r=t.F;if(!t.f)continue;a=t.f;if(r.indexOf(":")==-1)r=r+":"+r}if(t.f!=null)a=t.f;else if(t.t=="z")continue;else if(t.t=="n"&&t.v!=null)a=""+t.v;else if(t.t=="b")a=t.v?"TRUE":"FALSE";else if(t.w!==undefined)a="'"+t.w;else if(t.v===undefined)continue;else if(t.t=="s")a="'"+t.v;else a=""+t.v;l[l.length]=r+"="+a}}return l}function Am(e,r,t){var a=t||{};var n=+!a.skipHeader;var i=e||{};var s=0,f=0;if(i&&a.origin!=null){if(typeof a.origin=="number")s=a.origin;else{var l=typeof a.origin=="string"?bt(a.origin):a.origin;s=l.r;f=l.c}}var o;var c={s:{c:0,r:0},e:{c:f,r:s+r.length-1+n}};if(i["!ref"]){var u=wt(i["!ref"]);c.e.c=Math.max(c.e.c,u.e.c);c.e.r=Math.max(c.e.r,u.e.r);if(s==-1){s=u.e.r+1;c.e.r=s+r.length-1+n}}else{if(s==-1){s=0;c.e.r=r.length-1+n}}var h=a.header||[],d=0;r.forEach(function(e,r){K(e).forEach(function(t){if((d=h.indexOf(t))==-1)h[d=h.length]=t;var l=e[t];var c="z";var u="";var v=mt({c:f+d,r:s+r+n});o=Im.sheet_get_cell(i,v);if(l&&typeof l==="object"&&!(l instanceof Date)){i[v]=l}else{if(typeof l=="number")c="n";else if(typeof l=="boolean")c="b";else if(typeof l=="string")c="s";else if(l instanceof Date){c="d";if(!a.cellDates){c="n";l=ee(l)}u=a.dateNF||D._table[14]}else if(l===null&&a.nullError){c="e";l=0}if(!o)i[v]=o={t:c,v:l};else{o.t=c;o.v=l;delete o.w;delete o.R;if(u)o.z=u}if(u)o.z=u}})});c.e.c=Math.max(c.e.c,f+h.length-1);var v=lt(s);if(n)for(d=0;d<h.length;++d)i[ht(d+f)+v]={t:"s",v:h[d]};i["!ref"]=Et(c);return i}function ym(e,r){return Am(null,e,r)}var Im={encode_col:ht,encode_row:lt,encode_cell:mt,encode_range:Et,decode_col:ut,decode_row:ft,split_cell:pt,decode_cell:bt,decode_range:gt,format_cell:St,get_formulae:xm,make_csv:Tm,make_json:Sm,make_formulae:xm,sheet_add_aoa:Ct,sheet_add_json:Am,sheet_add_dom:Sb,aoa_to_sheet:Tt,json_to_sheet:ym,table_to_sheet:Bb,table_to_book:Cb,sheet_to_csv:Tm,sheet_to_txt:_m,sheet_to_json:Sm,sheet_to_html:kb.from_sheet,sheet_to_formulae:xm,sheet_to_row_object_array:Sm};(function(e){e.consts=e.consts||{};function r(r){r.forEach(function(r){e.consts[r[0]]=r[1]})}function t(e,r,t){return e[r]!=null?e[r]:e[r]=t}function a(e,r,t){if(typeof r=="string"){if(Array.isArray(e)){var n=bt(r);if(!e[n.r])e[n.r]=[];return e[n.r][n.c]||(e[n.r][n.c]={t:"z"})}return e[r]||(e[r]={t:"z"})}if(typeof r!="number")return a(e,mt(r));return a(e,mt({r:r,c:t||0}))}e.sheet_get_cell=a;function n(e,r){if(typeof r=="number"){if(r>=0&&e.SheetNames.length>r)return r;throw new Error("Cannot find sheet # "+r)}else if(typeof r=="string"){var t=e.SheetNames.indexOf(r);if(t>-1)return t;throw new Error("Cannot find sheet name |"+r+"|")}else throw new Error("Cannot find sheet |"+r+"|")}e.book_new=function(){return{SheetNames:[],Sheets:{}}};e.book_append_sheet=function(e,r,t){if(!t)for(var a=1;a<=65535;++a,t=undefined)if(e.SheetNames.indexOf(t="Sheet"+a)==-1)break;if(!t||e.SheetNames.length>=65535)throw new Error("Too many worksheets");Dv(t);if(e.SheetNames.indexOf(t)>=0)throw new Error("Worksheet with name |"+t+"| already exists!");e.SheetNames.push(t);e.Sheets[t]=r};e.book_set_sheet_visibility=function(e,r,a){t(e,"Workbook",{});t(e.Workbook,"Sheets",[]);var i=n(e,r);t(e.Workbook.Sheets,i,{});switch(a){case 0:;case 1:;case 2:break;default:throw new Error("Bad sheet visibility setting "+a);}e.Workbook.Sheets[i].Hidden=a};r([["SHEET_VISIBLE",0],["SHEET_HIDDEN",1],["SHEET_VERY_HIDDEN",2]]);e.cell_set_number_format=function(e,r){e.z=r;return e};e.cell_set_hyperlink=function(e,r,t){if(!r){delete e.l}else{e.l={Target:r};if(t)e.l.Tooltip=t}return e};e.cell_set_internal_link=function(r,t,a){return e.cell_set_hyperlink(r,"#"+t,a)};e.cell_add_comment=function(e,r,t){if(!e.c)e.c=[];e.c.push({t:r,a:t||"SheetJS"})};e.sheet_set_array_formula=function(e,r,t){var n=typeof r!="string"?r:wt(r);var i=typeof r=="string"?r:Et(r);for(var s=n.s.r;s<=n.e.r;++s)for(var f=n.s.c;f<=n.e.c;++f){var l=a(e,s,f);l.t="n";l.F=i;delete l.v;if(s==n.s.r&&f==n.s.c)l.f=t}return e};return e})(Im);if(E&&typeof require!="undefined")(function(){var r={}.Readable;var t=function(e,t){var a=r();var n=t==null?{}:t;if(e==null||e["!ref"]==null){a.push(null);return a}var i=wt(e["!ref"]);var s=n.FS!==undefined?n.FS:",",f=s.charCodeAt(0);var l=n.RS!==undefined?n.RS:"\n",o=l.charCodeAt(0);var c=new RegExp((s=="|"?"\\|":s)+"+$");var u="",h=[];n.dense=Array.isArray(e);var d=n.skipHidden&&e["!cols"]||[];var v=n.skipHidden&&e["!rows"]||[];for(var p=i.s.c;p<=i.e.c;++p)if(!(d[p]||{}).hidden)h[p]=ht(p);var b=i.s.r;var m=false;a._read=function(){if(!m){m=true;return a.push("\ufeff")}while(b<=i.e.r){++b;if((v[b-1]||{}).hidden)continue;u=Cm(e,i,b-1,h,f,o,s,n);if(u!=null){if(n.strip)u=u.replace(c,"");a.push(u+l);break}}if(b>i.e.r)return a.push(null)};return a};var a=function(e,t){var a=r();var n=t||{};var i=n.header!=null?n.header:kb.BEGIN;var s=n.footer!=null?n.footer:kb.END;a.push(i);var f=gt(e["!ref"]);n.dense=Array.isArray(e);a.push(kb._preamble(e,f,n));var l=f.s.r;var o=false;a._read=function(){if(l>f.e.r){if(!o){o=true;a.push("</table>"+s)}return a.push(null)}while(l<=f.e.r){a.push(kb._row(e,f,l,n));++l;break}};return a};var n=function(e,t){var a=r({objectMode:true});if(e==null||e["!ref"]==null){a.push(null);return a}var n={t:"n",v:0},i=0,s=1,f=[],l=0,o="";var c={s:{r:0,c:0},e:{r:0,c:0}};var u=t||{};var h=u.range!=null?u.range:e["!ref"];if(u.header===1)i=1;else if(u.header==="A")i=2;else if(Array.isArray(u.header))i=3;switch(typeof h){case"string":c=wt(h);break;case"number":c=wt(e["!ref"]);c.s.r=h;break;default:c=h;}if(i>0)s=0;var d=lt(c.s.r);var v=[];var p=0;var b=Array.isArray(e);var m=c.s.r,g=0,E=0;if(b&&!e[m])e[m]=[];for(g=c.s.c;g<=c.e.c;++g){v[g]=ht(g);n=b?e[m][g]:e[v[g]+d];switch(i){case 1:f[g]=g-c.s.c;break;case 2:f[g]=v[g];break;case 3:f[g]=u.header[g-c.s.c];break;default:if(n==null)n={w:"__EMPTY",t:"s"};o=l=St(n,null,u);p=0;for(E=0;E<f.length;++E)if(f[E]==o)o=l+"_"+ ++p;f[g]=o;}}m=c.s.r+s;a._read=function(){if(m>c.e.r)return a.push(null);while(m<=c.e.r){var r=km(e,c,m,v,i,f,b,u);++m;if(r.isempty===false||(i===1?u.blankrows!==false:!!u.blankrows)){a.push(r.row);break}}};return a};e.stream={to_json:n,to_html:a,to_csv:t}})();if(typeof Qp!=="undefined")e.parse_xlscfb=Qp;e.parse_zip=Zb;e.read=om;e.readFile=cm;e.readFileSync=cm;e.write=mm;e.writeFile=Em;e.writeFileSync=Em;e.writeFileAsync=wm;e.utils=Im;e.SSF=D;if(typeof V!=="undefined")e.CFB=V}if(typeof exports!=="undefined")make_xlsx_lib(exports);else if(typeof module!=="undefined"&&module.exports)make_xlsx_lib(module.exports);else if(typeof define==="function"&&define.amd)define("xlsx",function(){if(!XLSX.version)make_xlsx_lib(XLSX);return XLSX});else make_xlsx_lib(XLSX);if(typeof window!=="undefined"&&!window.XLSX)window.XLSX=XLSX;var XLS=XLSX,ODS=XLSX;
